(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "../../node_modules/@agentx/quill/dist/quill.js":
/*!******************************************************!*\
  !*** ../../node_modules/@agentx/quill/dist/quill.js ***!
  \******************************************************/
/***/ ((module) => {

/*!
 * Quill Editor v2.0.0-dev.5
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_668__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_668__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_668__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_668__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_668__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_668__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_668__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_668__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_668__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_668__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_668__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_668__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_668__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_668__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_668__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_668__(__nested_webpack_require_668__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./assets/icons/align-center.svg":
/*!***************************************!*\
  !*** ./assets/icons/align-center.svg ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/align-center.svg?");

/***/ }),

/***/ "./assets/icons/align-justify.svg":
/*!****************************************!*\
  !*** ./assets/icons/align-justify.svg ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/align-justify.svg?");

/***/ }),

/***/ "./assets/icons/align-left.svg":
/*!*************************************!*\
  !*** ./assets/icons/align-left.svg ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/align-left.svg?");

/***/ }),

/***/ "./assets/icons/align-right.svg":
/*!**************************************!*\
  !*** ./assets/icons/align-right.svg ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/align-right.svg?");

/***/ }),

/***/ "./assets/icons/background.svg":
/*!*************************************!*\
  !*** ./assets/icons/background.svg ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <g class=\\\"ql-fill ql-color-label\\\"> <polygon points=\\\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\\\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\\\"6.817 5 6 5 6 6 6.38 6 6.817 5\\\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\\\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\\\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\\\"4.63 10 4 10 4 11 4.192 11 4.63 10\\\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\\\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\\\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\\\"12 6.868 12 6 11.62 6 12 6.868\\\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\\\"12.933 9 13 9 13 8 12.495 8 12.933 9\\\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\\\"5.5 13 9 5 12.5 13\\\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/background.svg?");

/***/ }),

/***/ "./assets/icons/blockquote.svg":
/*!*************************************!*\
  !*** ./assets/icons/blockquote.svg ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <rect class=\\\"ql-fill ql-stroke\\\" height=3 width=3 x=4 y=5></rect> <rect class=\\\"ql-fill ql-stroke\\\" height=3 width=3 x=11 y=5></rect> <path class=\\\"ql-even ql-fill ql-stroke\\\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\\\"ql-even ql-fill ql-stroke\\\" d=M14,8c0,4.031-3,5-3,5></path> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/blockquote.svg?");

/***/ }),

/***/ "./assets/icons/bold.svg":
/*!*******************************!*\
  !*** ./assets/icons/bold.svg ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/bold.svg?");

/***/ }),

/***/ "./assets/icons/clean.svg":
/*!********************************!*\
  !*** ./assets/icons/clean.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg class=\\\"\\\" viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/clean.svg?");

/***/ }),

/***/ "./assets/icons/code.svg":
/*!*******************************!*\
  !*** ./assets/icons/code.svg ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <polyline class=\\\"ql-even ql-stroke\\\" points=\\\"5 7 3 9 5 11\\\"></polyline> <polyline class=\\\"ql-even ql-stroke\\\" points=\\\"13 7 15 9 13 11\\\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/code.svg?");

/***/ }),

/***/ "./assets/icons/color.svg":
/*!********************************!*\
  !*** ./assets/icons/color.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=\\\"ql-color-label ql-stroke ql-transparent\\\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\\\"5.5 11 9 3 12.5 11\\\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/color.svg?");

/***/ }),

/***/ "./assets/icons/direction-ltr.svg":
/*!****************************************!*\
  !*** ./assets/icons/direction-ltr.svg ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <polygon class=\\\"ql-stroke ql-fill\\\" points=\\\"3 11 5 9 3 7 3 11\\\"></polygon> <line class=\\\"ql-stroke ql-fill\\\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/direction-ltr.svg?");

/***/ }),

/***/ "./assets/icons/direction-rtl.svg":
/*!****************************************!*\
  !*** ./assets/icons/direction-rtl.svg ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <polygon class=\\\"ql-stroke ql-fill\\\" points=\\\"15 12 13 10 15 8 15 12\\\"></polygon> <line class=\\\"ql-stroke ql-fill\\\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/direction-rtl.svg?");

/***/ }),

/***/ "./assets/icons/dropdown.svg":
/*!***********************************!*\
  !*** ./assets/icons/dropdown.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <polygon class=ql-stroke points=\\\"7 11 9 13 11 11 7 11\\\"></polygon> <polygon class=ql-stroke points=\\\"7 7 9 5 11 7 7 7\\\"></polygon> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/dropdown.svg?");

/***/ }),

/***/ "./assets/icons/formula.svg":
/*!**********************************!*\
  !*** ./assets/icons/formula.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/formula.svg?");

/***/ }),

/***/ "./assets/icons/header-2.svg":
/*!***********************************!*\
  !*** ./assets/icons/header-2.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewBox=\\\"0 0 18 18\\\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/header-2.svg?");

/***/ }),

/***/ "./assets/icons/header.svg":
/*!*********************************!*\
  !*** ./assets/icons/header.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewBox=\\\"0 0 18 18\\\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/header.svg?");

/***/ }),

/***/ "./assets/icons/image.svg":
/*!********************************!*\
  !*** ./assets/icons/image.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\\\"ql-even ql-fill\\\" points=\\\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\\\"></polyline> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/image.svg?");

/***/ }),

/***/ "./assets/icons/indent.svg":
/*!*********************************!*\
  !*** ./assets/icons/indent.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\\\"ql-fill ql-stroke\\\" points=\\\"3 7 3 11 5 9 3 7\\\"></polyline> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/indent.svg?");

/***/ }),

/***/ "./assets/icons/italic.svg":
/*!*********************************!*\
  !*** ./assets/icons/italic.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/italic.svg?");

/***/ }),

/***/ "./assets/icons/link.svg":
/*!*******************************!*\
  !*** ./assets/icons/link.svg ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\\\"ql-even ql-stroke\\\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\\\"ql-even ql-stroke\\\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/link.svg?");

/***/ }),

/***/ "./assets/icons/list-bullet.svg":
/*!**************************************!*\
  !*** ./assets/icons/list-bullet.svg ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/list-bullet.svg?");

/***/ }),

/***/ "./assets/icons/list-check.svg":
/*!*************************************!*\
  !*** ./assets/icons/list-check.svg ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg class=\\\"\\\" viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\\\"3 4 4 5 6 3\\\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\\\"3 14 4 15 6 13\\\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\\\"3 9 4 10 6 8\\\"></polyline> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/list-check.svg?");

/***/ }),

/***/ "./assets/icons/list-ordered.svg":
/*!***************************************!*\
  !*** ./assets/icons/list-ordered.svg ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\\\"ql-stroke ql-thin\\\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\\\"ql-stroke ql-thin\\\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\\\"ql-stroke ql-thin\\\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/list-ordered.svg?");

/***/ }),

/***/ "./assets/icons/outdent.svg":
/*!**********************************!*\
  !*** ./assets/icons/outdent.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\\\"5 7 5 11 3 9 5 7\\\"></polyline> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/outdent.svg?");

/***/ }),

/***/ "./assets/icons/strike.svg":
/*!*********************************!*\
  !*** ./assets/icons/strike.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <line class=\\\"ql-stroke ql-thin\\\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/strike.svg?");

/***/ }),

/***/ "./assets/icons/subscript.svg":
/*!************************************!*\
  !*** ./assets/icons/subscript.svg ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/subscript.svg?");

/***/ }),

/***/ "./assets/icons/superscript.svg":
/*!**************************************!*\
  !*** ./assets/icons/superscript.svg ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/superscript.svg?");

/***/ }),

/***/ "./assets/icons/table.svg":
/*!********************************!*\
  !*** ./assets/icons/table.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=2 width=3 x=5 y=5></rect> <rect class=ql-fill height=2 width=4 x=9 y=5></rect> <g class=\\\"ql-fill ql-transparent\\\"> <rect height=2 width=3 x=5 y=8></rect> <rect height=2 width=4 x=9 y=8></rect> <rect height=2 width=3 x=5 y=11></rect> <rect height=2 width=4 x=9 y=11></rect> </g> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/table.svg?");

/***/ }),

/***/ "./assets/icons/underline.svg":
/*!************************************!*\
  !*** ./assets/icons/underline.svg ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/underline.svg?");

/***/ }),

/***/ "./assets/icons/video.svg":
/*!********************************!*\
  !*** ./assets/icons/video.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = \"<svg viewbox=\\\"0 0 18 18\\\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>\";\n\n//# sourceURL=webpack://Quill/./assets/icons/video.svg?");

/***/ }),

/***/ "./blots/block.js":
/*!************************!*\
  !*** ./blots/block.js ***!
  \************************/
/*! exports provided: blockDelta, bubbleFormats, BlockEmbed, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"blockDelta\", function() { return blockDelta; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"bubbleFormats\", function() { return bubbleFormats; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"BlockEmbed\", function() { return BlockEmbed; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Block; });\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! extend */ \"./node_modules/extend/index.js\");\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(extend__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! quill-delta */ \"./node_modules/quill-delta/dist/Delta.js\");\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(quill_delta__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _break__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./break */ \"./blots/break.js\");\n/* harmony import */ var _inline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./inline */ \"./blots/inline.js\");\n/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./text */ \"./blots/text.js\");\n\n\n\n\n\n\nconst NEWLINE_LENGTH = 1;\n\nclass Block extends parchment__WEBPACK_IMPORTED_MODULE_2__[\"BlockBlot\"] {\n  constructor(scroll, domNode) {\n    super(scroll, domNode);\n    this.cache = {};\n  }\n\n  delta() {\n    if (this.cache.delta == null) {\n      this.cache.delta = blockDelta(this);\n    }\n\n    return this.cache.delta;\n  }\n\n  deleteAt(index, length) {\n    super.deleteAt(index, length);\n    this.cache = {};\n  }\n\n  formatAt(index, length, name, value) {\n    if (length <= 0) return;\n\n    if (this.scroll.query(name, parchment__WEBPACK_IMPORTED_MODULE_2__[\"Scope\"].BLOCK)) {\n      if (index + length === this.length()) {\n        this.format(name, value);\n      }\n    } else {\n      super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);\n    }\n\n    this.cache = {};\n  }\n\n  insertAt(index, value, def) {\n    if (def != null) {\n      super.insertAt(index, value, def);\n      this.cache = {};\n      return;\n    }\n\n    if (value.length === 0) return;\n    const lines = value.split('\\n');\n    const text = lines.shift();\n\n    if (text.length > 0) {\n      if (index < this.length() - 1 || this.children.tail == null) {\n        super.insertAt(Math.min(index, this.length() - 1), text);\n      } else {\n        this.children.tail.insertAt(this.children.tail.length(), text);\n      }\n\n      this.cache = {};\n    }\n\n    let block = this;\n    lines.reduce((lineIndex, line) => {\n      block = block.split(lineIndex, true);\n      block.insertAt(0, line);\n      return line.length;\n    }, index + text.length);\n  }\n\n  insertBefore(blot, ref) {\n    const head = this.children.head;\n    super.insertBefore(blot, ref);\n\n    if (head instanceof _break__WEBPACK_IMPORTED_MODULE_3__[\"default\"]) {\n      head.remove();\n    }\n\n    this.cache = {};\n  }\n\n  length() {\n    if (this.cache.length == null) {\n      this.cache.length = super.length() + NEWLINE_LENGTH;\n    }\n\n    return this.cache.length;\n  }\n\n  moveChildren(target, ref) {\n    super.moveChildren(target, ref);\n    this.cache = {};\n  }\n\n  optimize(context) {\n    super.optimize(context);\n    this.cache = {};\n  }\n\n  path(index) {\n    return super.path(index, true);\n  }\n\n  removeChild(child) {\n    super.removeChild(child);\n    this.cache = {};\n  }\n\n  split(index) {\n    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n\n    if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {\n      const clone = this.clone();\n\n      if (index === 0) {\n        this.parent.insertBefore(clone, this);\n        return this;\n      }\n\n      this.parent.insertBefore(clone, this.next);\n      return clone;\n    }\n\n    const next = super.split(index, force);\n    this.cache = {};\n    return next;\n  }\n\n}\n\nBlock.blotName = 'block';\nBlock.tagName = 'P';\nBlock.defaultChild = _break__WEBPACK_IMPORTED_MODULE_3__[\"default\"];\nBlock.allowedChildren = [_break__WEBPACK_IMPORTED_MODULE_3__[\"default\"], _inline__WEBPACK_IMPORTED_MODULE_4__[\"default\"], parchment__WEBPACK_IMPORTED_MODULE_2__[\"EmbedBlot\"], _text__WEBPACK_IMPORTED_MODULE_5__[\"default\"]];\n\nclass BlockEmbed extends parchment__WEBPACK_IMPORTED_MODULE_2__[\"EmbedBlot\"] {\n  attach() {\n    super.attach();\n    this.attributes = new parchment__WEBPACK_IMPORTED_MODULE_2__[\"AttributorStore\"](this.domNode);\n  }\n\n  delta() {\n    return new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a().insert(this.value(), extend__WEBPACK_IMPORTED_MODULE_0___default()(this.formats(), this.attributes.values()));\n  }\n\n  format(name, value) {\n    const attribute = this.scroll.query(name, parchment__WEBPACK_IMPORTED_MODULE_2__[\"Scope\"].BLOCK_ATTRIBUTE);\n\n    if (attribute != null) {\n      this.attributes.attribute(attribute, value);\n    }\n  }\n\n  formatAt(index, length, name, value) {\n    this.format(name, value);\n  }\n\n  insertAt(index, value, def) {\n    if (typeof value === 'string' && value.endsWith('\\n')) {\n      const block = this.scroll.create(Block.blotName);\n      this.parent.insertBefore(block, index === 0 ? this : this.next);\n      block.insertAt(0, value.slice(0, -1));\n    } else {\n      super.insertAt(index, value, def);\n    }\n  }\n\n}\n\nBlockEmbed.scope = parchment__WEBPACK_IMPORTED_MODULE_2__[\"Scope\"].BLOCK_BLOT; // It is important for cursor behavior BlockEmbeds use tags that are block level elements\n\nfunction blockDelta(blot) {\n  let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;\n  return blot.descendants(parchment__WEBPACK_IMPORTED_MODULE_2__[\"LeafBlot\"]).reduce((delta, leaf) => {\n    if (leaf.length() === 0) {\n      return delta;\n    }\n\n    return delta.insert(leaf.value(), bubbleFormats(leaf, {}, filter));\n  }, new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a()).insert('\\n', bubbleFormats(blot));\n}\n\nfunction bubbleFormats(blot) {\n  let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n  let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;\n  if (blot == null) return formats;\n\n  if (typeof blot.formats === 'function') {\n    formats = extend__WEBPACK_IMPORTED_MODULE_0___default()(formats, blot.formats());\n\n    if (filter) {\n      // exclude syntax highlighting from deltas and getFormat()\n      delete formats['code-token'];\n    }\n  }\n\n  if (blot.parent == null || blot.parent.statics.blotName === 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {\n    return formats;\n  }\n\n  return bubbleFormats(blot.parent, formats, filter);\n}\n\n\n\n//# sourceURL=webpack://Quill/./blots/block.js?");

/***/ }),

/***/ "./blots/break.js":
/*!************************!*\
  !*** ./blots/break.js ***!
  \************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n\n\nclass Break extends parchment__WEBPACK_IMPORTED_MODULE_0__[\"EmbedBlot\"] {\n  static value() {\n    return undefined;\n  }\n\n  optimize() {\n    if (this.prev || this.next) {\n      this.remove();\n    }\n  }\n\n  length() {\n    return 0;\n  }\n\n  value() {\n    return '';\n  }\n\n}\n\nBreak.blotName = 'break';\nBreak.tagName = 'BR';\n/* harmony default export */ __webpack_exports__[\"default\"] = (Break);\n\n//# sourceURL=webpack://Quill/./blots/break.js?");

/***/ }),

/***/ "./blots/container.js":
/*!****************************!*\
  !*** ./blots/container.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n\n\nclass Container extends parchment__WEBPACK_IMPORTED_MODULE_0__[\"ContainerBlot\"] {}\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (Container);\n\n//# sourceURL=webpack://Quill/./blots/container.js?");

/***/ }),

/***/ "./blots/cursor.js":
/*!*************************!*\
  !*** ./blots/cursor.js ***!
  \*************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./text */ \"./blots/text.js\");\n\n\n\nclass Cursor extends parchment__WEBPACK_IMPORTED_MODULE_0__[\"EmbedBlot\"] {\n  static value() {\n    return undefined;\n  }\n\n  constructor(scroll, domNode, selection) {\n    super(scroll, domNode);\n    this.selection = selection;\n    this.textNode = document.createTextNode(Cursor.CONTENTS);\n    this.domNode.appendChild(this.textNode);\n    this.savedLength = 0;\n  }\n\n  detach() {\n    // super.detach() will also clear domNode.__blot\n    if (this.parent != null) this.parent.removeChild(this);\n  }\n\n  format(name, value) {\n    if (this.savedLength !== 0) {\n      super.format(name, value);\n      return;\n    }\n\n    let target = this;\n    let index = 0;\n\n    while (target != null && target.statics.scope !== parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].BLOCK_BLOT) {\n      index += target.offset(target.parent);\n      target = target.parent;\n    }\n\n    if (target != null) {\n      this.savedLength = Cursor.CONTENTS.length;\n      target.optimize();\n      target.formatAt(index, Cursor.CONTENTS.length, name, value);\n      this.savedLength = 0;\n    }\n  }\n\n  index(node, offset) {\n    if (node === this.textNode) return 0;\n    return super.index(node, offset);\n  }\n\n  length() {\n    return this.savedLength;\n  }\n\n  position() {\n    return [this.textNode, this.textNode.data.length];\n  }\n\n  remove() {\n    super.remove();\n    this.parent = null;\n  }\n\n  restore() {\n    if (this.selection.composing || this.parent == null) return null;\n    const range = this.selection.getNativeRange(); // Link format will insert text outside of anchor tag\n\n    while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {\n      this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);\n    }\n\n    const prevTextBlot = this.prev instanceof _text__WEBPACK_IMPORTED_MODULE_1__[\"default\"] ? this.prev : null;\n    const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;\n    const nextTextBlot = this.next instanceof _text__WEBPACK_IMPORTED_MODULE_1__[\"default\"] ? this.next : null;\n    const nextText = nextTextBlot ? nextTextBlot.text : '';\n    const textNode = this.textNode; // take text from inside this blot and reset it\n\n    const newText = textNode.data.split(Cursor.CONTENTS).join('');\n    textNode.data = Cursor.CONTENTS; // proactively merge TextBlots around cursor so that optimization\n    // doesn't lose the cursor.  the reason we are here in cursor.restore\n    // could be that the user clicked in prevTextBlot or nextTextBlot, or\n    // the user typed something.\n\n    let mergedTextBlot;\n\n    if (prevTextBlot) {\n      mergedTextBlot = prevTextBlot;\n\n      if (newText || nextTextBlot) {\n        prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);\n\n        if (nextTextBlot) {\n          nextTextBlot.remove();\n        }\n      }\n    } else if (nextTextBlot) {\n      mergedTextBlot = nextTextBlot;\n      nextTextBlot.insertAt(0, newText);\n    } else {\n      const newTextNode = document.createTextNode(newText);\n      mergedTextBlot = this.scroll.create(newTextNode);\n      this.parent.insertBefore(mergedTextBlot, this);\n    }\n\n    this.remove();\n\n    if (range) {\n      // calculate selection to restore\n      const remapOffset = (node, offset) => {\n        if (prevTextBlot && node === prevTextBlot.domNode) {\n          return offset;\n        }\n\n        if (node === textNode) {\n          return prevTextLength + offset - 1;\n        }\n\n        if (nextTextBlot && node === nextTextBlot.domNode) {\n          return prevTextLength + newText.length + offset;\n        }\n\n        return null;\n      };\n\n      const start = remapOffset(range.start.node, range.start.offset);\n      const end = remapOffset(range.end.node, range.end.offset);\n\n      if (start !== null && end !== null) {\n        return {\n          startNode: mergedTextBlot.domNode,\n          startOffset: start,\n          endNode: mergedTextBlot.domNode,\n          endOffset: end\n        };\n      }\n    }\n\n    return null;\n  }\n\n  update(mutations, context) {\n    if (mutations.some(mutation => {\n      return mutation.type === 'characterData' && mutation.target === this.textNode;\n    })) {\n      const range = this.restore();\n      if (range) context.range = range;\n    }\n  }\n\n  value() {\n    return '';\n  }\n\n}\n\nCursor.blotName = 'cursor';\nCursor.className = 'ql-cursor';\nCursor.tagName = 'span';\nCursor.CONTENTS = '\\uFEFF'; // Zero width no break space\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (Cursor);\n\n//# sourceURL=webpack://Quill/./blots/cursor.js?");

/***/ }),

/***/ "./blots/embed.js":
/*!************************!*\
  !*** ./blots/embed.js ***!
  \************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./text */ \"./blots/text.js\");\n\n\nconst GUARD_TEXT = '\\uFEFF';\n\nclass Embed extends parchment__WEBPACK_IMPORTED_MODULE_0__[\"EmbedBlot\"] {\n  constructor(scroll, node) {\n    super(scroll, node);\n    this.contentNode = document.createElement('span');\n    this.contentNode.setAttribute('contenteditable', false);\n    Array.from(this.domNode.childNodes).forEach(childNode => {\n      this.contentNode.appendChild(childNode);\n    });\n    this.leftGuard = document.createTextNode(GUARD_TEXT);\n    this.rightGuard = document.createTextNode(GUARD_TEXT);\n    this.domNode.appendChild(this.leftGuard);\n    this.domNode.appendChild(this.contentNode);\n    this.domNode.appendChild(this.rightGuard);\n  }\n\n  index(node, offset) {\n    if (node === this.leftGuard) return 0;\n    if (node === this.rightGuard) return 1;\n    return super.index(node, offset);\n  }\n\n  restore(node) {\n    let range;\n    let textNode;\n    const text = node.data.split(GUARD_TEXT).join('');\n\n    if (node === this.leftGuard) {\n      if (this.prev instanceof _text__WEBPACK_IMPORTED_MODULE_1__[\"default\"]) {\n        const prevLength = this.prev.length();\n        this.prev.insertAt(prevLength, text);\n        range = {\n          startNode: this.prev.domNode,\n          startOffset: prevLength + text.length\n        };\n      } else {\n        textNode = document.createTextNode(text);\n        this.parent.insertBefore(this.scroll.create(textNode), this);\n        range = {\n          startNode: textNode,\n          startOffset: text.length\n        };\n      }\n    } else if (node === this.rightGuard) {\n      if (this.next instanceof _text__WEBPACK_IMPORTED_MODULE_1__[\"default\"]) {\n        this.next.insertAt(0, text);\n        range = {\n          startNode: this.next.domNode,\n          startOffset: text.length\n        };\n      } else {\n        textNode = document.createTextNode(text);\n        this.parent.insertBefore(this.scroll.create(textNode), this.next);\n        range = {\n          startNode: textNode,\n          startOffset: text.length\n        };\n      }\n    }\n\n    node.data = GUARD_TEXT;\n    return range;\n  }\n\n  update(mutations, context) {\n    mutations.forEach(mutation => {\n      if (mutation.type === 'characterData' && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {\n        const range = this.restore(mutation.target);\n        if (range) context.range = range;\n      }\n    });\n  }\n\n}\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (Embed);\n\n//# sourceURL=webpack://Quill/./blots/embed.js?");

/***/ }),

/***/ "./blots/inline.js":
/*!*************************!*\
  !*** ./blots/inline.js ***!
  \*************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _break__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./break */ \"./blots/break.js\");\n/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./text */ \"./blots/text.js\");\n\n\n\n\nclass Inline extends parchment__WEBPACK_IMPORTED_MODULE_0__[\"InlineBlot\"] {\n  static compare(self, other) {\n    const selfIndex = Inline.order.indexOf(self);\n    const otherIndex = Inline.order.indexOf(other);\n\n    if (selfIndex >= 0 || otherIndex >= 0) {\n      return selfIndex - otherIndex;\n    }\n\n    if (self === other) {\n      return 0;\n    }\n\n    if (self < other) {\n      return -1;\n    }\n\n    return 1;\n  }\n\n  formatAt(index, length, name, value) {\n    if (Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].BLOT)) {\n      const blot = this.isolate(index, length);\n\n      if (value) {\n        blot.wrap(name, value);\n      }\n    } else {\n      super.formatAt(index, length, name, value);\n    }\n  }\n\n  optimize(context) {\n    super.optimize(context);\n\n    if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {\n      const parent = this.parent.isolate(this.offset(), this.length());\n      this.moveChildren(parent);\n      parent.wrap(this);\n    }\n  }\n\n}\n\nInline.allowedChildren = [Inline, _break__WEBPACK_IMPORTED_MODULE_1__[\"default\"], parchment__WEBPACK_IMPORTED_MODULE_0__[\"EmbedBlot\"], _text__WEBPACK_IMPORTED_MODULE_2__[\"default\"]]; // Lower index means deeper in the DOM tree, since not found (-1) is for embeds\n\nInline.order = ['cursor', 'inline', // Must be lower\n'link', // Chrome wants <a> to be lower\n'underline', 'strike', 'italic', 'bold', 'script', 'code'];\n/* harmony default export */ __webpack_exports__[\"default\"] = (Inline);\n\n//# sourceURL=webpack://Quill/./blots/inline.js?");

/***/ }),

/***/ "./blots/scroll.js":
/*!*************************!*\
  !*** ./blots/scroll.js ***!
  \*************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _core_emitter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/emitter */ \"./core/emitter.js\");\n/* harmony import */ var _block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./block */ \"./blots/block.js\");\n/* harmony import */ var _break__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./break */ \"./blots/break.js\");\n/* harmony import */ var _container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./container */ \"./blots/container.js\");\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\n\n\n\n\nfunction isLine(blot) {\n  return blot instanceof _block__WEBPACK_IMPORTED_MODULE_2__[\"default\"] || blot instanceof _block__WEBPACK_IMPORTED_MODULE_2__[\"BlockEmbed\"];\n}\n\nclass Scroll extends parchment__WEBPACK_IMPORTED_MODULE_0__[\"ScrollBlot\"] {\n  constructor(registry, domNode, _ref) {\n    let emitter = _ref.emitter;\n    super(registry, domNode);\n    this.emitter = emitter;\n    this.batch = false;\n    this.optimize();\n    this.enable();\n    this.domNode.addEventListener('dragstart', e => this.handleDragStart(e));\n  }\n\n  batchStart() {\n    if (!Array.isArray(this.batch)) {\n      this.batch = [];\n    }\n  }\n\n  batchEnd() {\n    const mutations = this.batch;\n    this.batch = false;\n    this.update(mutations);\n  }\n\n  emitMount(blot) {\n    this.emitter.emit(_core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.SCROLL_BLOT_MOUNT, blot);\n  }\n\n  emitUnmount(blot) {\n    this.emitter.emit(_core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.SCROLL_BLOT_UNMOUNT, blot);\n  }\n\n  deleteAt(index, length) {\n    const _this$line = this.line(index),\n          _this$line2 = _slicedToArray(_this$line, 2),\n          first = _this$line2[0],\n          offset = _this$line2[1];\n\n    const _this$line3 = this.line(index + length),\n          _this$line4 = _slicedToArray(_this$line3, 1),\n          last = _this$line4[0];\n\n    super.deleteAt(index, length);\n\n    if (last != null && first !== last && offset > 0) {\n      if (first instanceof _block__WEBPACK_IMPORTED_MODULE_2__[\"BlockEmbed\"] || last instanceof _block__WEBPACK_IMPORTED_MODULE_2__[\"BlockEmbed\"]) {\n        this.optimize();\n        return;\n      }\n\n      const ref = last.children.head instanceof _break__WEBPACK_IMPORTED_MODULE_3__[\"default\"] ? null : last.children.head;\n      first.moveChildren(last, ref);\n      first.remove();\n    }\n\n    this.optimize();\n  }\n\n  enable() {\n    let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;\n    this.domNode.setAttribute('contenteditable', enabled);\n  }\n\n  formatAt(index, length, format, value) {\n    super.formatAt(index, length, format, value);\n    this.optimize();\n  }\n\n  handleDragStart(event) {\n    event.preventDefault();\n  }\n\n  insertAt(index, value, def) {\n    if (index >= this.length()) {\n      if (def == null || this.scroll.query(value, parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].BLOCK) == null) {\n        const blot = this.scroll.create(this.statics.defaultChild.blotName);\n        this.appendChild(blot);\n\n        if (def == null && value.endsWith('\\n')) {\n          blot.insertAt(0, value.slice(0, -1), def);\n        } else {\n          blot.insertAt(0, value, def);\n        }\n      } else {\n        const embed = this.scroll.create(value, def);\n        this.appendChild(embed);\n      }\n    } else {\n      super.insertAt(index, value, def);\n    }\n\n    this.optimize();\n  }\n\n  insertBefore(blot, ref) {\n    if (blot.statics.scope === parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].INLINE_BLOT) {\n      const wrapper = this.scroll.create(this.statics.defaultChild.blotName);\n      wrapper.appendChild(blot);\n      super.insertBefore(wrapper, ref);\n    } else {\n      super.insertBefore(blot, ref);\n    }\n  }\n\n  isEnabled() {\n    return this.domNode.getAttribute('contenteditable') === 'true';\n  }\n\n  leaf(index) {\n    return this.path(index).pop() || [null, -1];\n  }\n\n  line(index) {\n    if (index === this.length()) {\n      return this.line(index - 1);\n    }\n\n    return this.descendant(isLine, index);\n  }\n\n  lines() {\n    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;\n\n    const getLines = (blot, blotIndex, blotLength) => {\n      let lines = [];\n      let lengthLeft = blotLength;\n      blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength) => {\n        if (isLine(child)) {\n          lines.push(child);\n        } else if (child instanceof parchment__WEBPACK_IMPORTED_MODULE_0__[\"ContainerBlot\"]) {\n          lines = lines.concat(getLines(child, childIndex, lengthLeft));\n        }\n\n        lengthLeft -= childLength;\n      });\n      return lines;\n    };\n\n    return getLines(this, index, length);\n  }\n\n  optimize() {\n    let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];\n    let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n    if (this.batch) return;\n    super.optimize(mutations, context);\n\n    if (mutations.length > 0) {\n      this.emitter.emit(_core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.SCROLL_OPTIMIZE, mutations, context);\n    }\n  }\n\n  path(index) {\n    return super.path(index).slice(1); // Exclude self\n  }\n\n  remove() {// Never remove self\n  }\n\n  update(mutations) {\n    if (this.batch) {\n      if (Array.isArray(mutations)) {\n        this.batch = this.batch.concat(mutations);\n      }\n\n      return;\n    }\n\n    let source = _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER;\n\n    if (typeof mutations === 'string') {\n      source = mutations;\n    }\n\n    if (!Array.isArray(mutations)) {\n      mutations = this.observer.takeRecords();\n    }\n\n    if (mutations.length > 0) {\n      this.emitter.emit(_core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.SCROLL_BEFORE_UPDATE, source, mutations);\n    }\n\n    super.update(mutations.concat([])); // pass copy\n\n    if (mutations.length > 0) {\n      this.emitter.emit(_core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.SCROLL_UPDATE, source, mutations);\n    }\n  }\n\n}\n\nScroll.blotName = 'scroll';\nScroll.className = 'ql-editor';\nScroll.tagName = 'DIV';\nScroll.defaultChild = _block__WEBPACK_IMPORTED_MODULE_2__[\"default\"];\nScroll.allowedChildren = [_block__WEBPACK_IMPORTED_MODULE_2__[\"default\"], _block__WEBPACK_IMPORTED_MODULE_2__[\"BlockEmbed\"], _container__WEBPACK_IMPORTED_MODULE_4__[\"default\"]];\n/* harmony default export */ __webpack_exports__[\"default\"] = (Scroll);\n\n//# sourceURL=webpack://Quill/./blots/scroll.js?");

/***/ }),

/***/ "./blots/text.js":
/*!***********************!*\
  !*** ./blots/text.js ***!
  \***********************/
/*! exports provided: default, escapeText */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Text; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"escapeText\", function() { return escapeText; });\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n\n\nclass Text extends parchment__WEBPACK_IMPORTED_MODULE_0__[\"TextBlot\"] {}\n\nfunction escapeText(text) {\n  return text.replace(/[&<>\"']/g, s => {\n    // https://lodash.com/docs#escape\n    const entityMap = {\n      '&': '&amp;',\n      '<': '&lt;',\n      '>': '&gt;',\n      '\"': '&quot;',\n      \"'\": '&#39;'\n    };\n    return entityMap[s];\n  });\n}\n\n\n\n//# sourceURL=webpack://Quill/./blots/text.js?");

/***/ }),

/***/ "./core.js":
/*!*****************!*\
  !*** ./core.js ***!
  \*****************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _core_quill__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./core/quill */ \"./core/quill.js\");\n/* harmony import */ var _blots_block__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./blots/block */ \"./blots/block.js\");\n/* harmony import */ var _blots_break__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./blots/break */ \"./blots/break.js\");\n/* harmony import */ var _blots_container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./blots/container */ \"./blots/container.js\");\n/* harmony import */ var _blots_cursor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./blots/cursor */ \"./blots/cursor.js\");\n/* harmony import */ var _blots_embed__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./blots/embed */ \"./blots/embed.js\");\n/* harmony import */ var _blots_inline__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./blots/inline */ \"./blots/inline.js\");\n/* harmony import */ var _blots_scroll__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./blots/scroll */ \"./blots/scroll.js\");\n/* harmony import */ var _blots_text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./blots/text */ \"./blots/text.js\");\n/* harmony import */ var _modules_clipboard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/clipboard */ \"./modules/clipboard.js\");\n/* harmony import */ var _modules_history__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/history */ \"./modules/history.js\");\n/* harmony import */ var _modules_keyboard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/keyboard */ \"./modules/keyboard.js\");\n/* harmony import */ var _modules_uploader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./modules/uploader */ \"./modules/uploader.js\");\n\n\n\n\n\n\n\n\n\n\n\n\n\n_core_quill__WEBPACK_IMPORTED_MODULE_0__[\"default\"].register({\n  'blots/block': _blots_block__WEBPACK_IMPORTED_MODULE_1__[\"default\"],\n  'blots/block/embed': _blots_block__WEBPACK_IMPORTED_MODULE_1__[\"BlockEmbed\"],\n  'blots/break': _blots_break__WEBPACK_IMPORTED_MODULE_2__[\"default\"],\n  'blots/container': _blots_container__WEBPACK_IMPORTED_MODULE_3__[\"default\"],\n  'blots/cursor': _blots_cursor__WEBPACK_IMPORTED_MODULE_4__[\"default\"],\n  'blots/embed': _blots_embed__WEBPACK_IMPORTED_MODULE_5__[\"default\"],\n  'blots/inline': _blots_inline__WEBPACK_IMPORTED_MODULE_6__[\"default\"],\n  'blots/scroll': _blots_scroll__WEBPACK_IMPORTED_MODULE_7__[\"default\"],\n  'blots/text': _blots_text__WEBPACK_IMPORTED_MODULE_8__[\"default\"],\n  'modules/clipboard': _modules_clipboard__WEBPACK_IMPORTED_MODULE_9__[\"default\"],\n  'modules/history': _modules_history__WEBPACK_IMPORTED_MODULE_10__[\"default\"],\n  'modules/keyboard': _modules_keyboard__WEBPACK_IMPORTED_MODULE_11__[\"default\"],\n  'modules/uploader': _modules_uploader__WEBPACK_IMPORTED_MODULE_12__[\"default\"]\n});\n/* harmony default export */ __webpack_exports__[\"default\"] = (_core_quill__WEBPACK_IMPORTED_MODULE_0__[\"default\"]);\n\n//# sourceURL=webpack://Quill/./core.js?");

/***/ }),

/***/ "./core/editor.js":
/*!************************!*\
  !*** ./core/editor.js ***!
  \************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var clone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! clone */ \"./node_modules/clone/clone.js\");\n/* harmony import */ var clone__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(clone__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var deep_equal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! deep-equal */ \"./node_modules/deep-equal/index.js\");\n/* harmony import */ var deep_equal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(deep_equal__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! extend */ \"./node_modules/extend/index.js\");\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(extend__WEBPACK_IMPORTED_MODULE_2__);\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! quill-delta */ \"./node_modules/quill-delta/dist/Delta.js\");\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(quill_delta__WEBPACK_IMPORTED_MODULE_3__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _selection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./selection */ \"./core/selection.js\");\n/* harmony import */ var _blots_cursor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../blots/cursor */ \"./blots/cursor.js\");\n/* harmony import */ var _blots_block__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../blots/block */ \"./blots/block.js\");\n/* harmony import */ var _blots_break__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../blots/break */ \"./blots/break.js\");\n/* harmony import */ var _blots_text__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../blots/text */ \"./blots/text.js\");\nfunction _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }\n\nfunction _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === \"[object Arguments]\") return Array.from(iter); }\n\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\n\n\n\n\n\n\n\n\nconst ASCII = /^[ -~]*$/;\n\nclass Editor {\n  constructor(scroll) {\n    this.scroll = scroll;\n    this.delta = this.getDelta();\n  }\n\n  applyDelta(delta) {\n    let consumeNextNewline = false;\n    this.scroll.update();\n    let scrollLength = this.scroll.length();\n    this.scroll.batchStart();\n    const normalizedDelta = normalizeDelta(delta);\n    normalizedDelta.reduce((index, op) => {\n      const length = op.retain || op.delete || op.insert.length || 1;\n      let attributes = op.attributes || {};\n\n      if (op.insert != null) {\n        if (typeof op.insert === 'string') {\n          let text = op.insert;\n\n          if (text.endsWith('\\n') && consumeNextNewline) {\n            consumeNextNewline = false;\n            text = text.slice(0, -1);\n          }\n\n          if ((index >= scrollLength || this.scroll.descendant(_blots_block__WEBPACK_IMPORTED_MODULE_7__[\"BlockEmbed\"], index)[0]) && !text.endsWith('\\n')) {\n            consumeNextNewline = true;\n          }\n\n          this.scroll.insertAt(index, text);\n\n          const _this$scroll$line = this.scroll.line(index),\n                _this$scroll$line2 = _slicedToArray(_this$scroll$line, 2),\n                line = _this$scroll$line2[0],\n                offset = _this$scroll$line2[1];\n\n          let formats = extend__WEBPACK_IMPORTED_MODULE_2___default()({}, Object(_blots_block__WEBPACK_IMPORTED_MODULE_7__[\"bubbleFormats\"])(line));\n\n          if (line instanceof _blots_block__WEBPACK_IMPORTED_MODULE_7__[\"default\"]) {\n            const _line$descendant = line.descendant(parchment__WEBPACK_IMPORTED_MODULE_4__[\"LeafBlot\"], offset),\n                  _line$descendant2 = _slicedToArray(_line$descendant, 1),\n                  leaf = _line$descendant2[0];\n\n            formats = extend__WEBPACK_IMPORTED_MODULE_2___default()(formats, Object(_blots_block__WEBPACK_IMPORTED_MODULE_7__[\"bubbleFormats\"])(leaf));\n          }\n\n          attributes = quill_delta__WEBPACK_IMPORTED_MODULE_3__[\"AttributeMap\"].diff(formats, attributes) || {};\n        } else if (typeof op.insert === 'object') {\n          const key = Object.keys(op.insert)[0]; // There should only be one key\n\n          if (key == null) return index;\n          this.scroll.insertAt(index, key, op.insert[key]);\n        }\n\n        scrollLength += length;\n      }\n\n      Object.keys(attributes).forEach(name => {\n        this.scroll.formatAt(index, length, name, attributes[name]);\n      });\n      return index + length;\n    }, 0);\n    normalizedDelta.reduce((index, op) => {\n      if (typeof op.delete === 'number') {\n        this.scroll.deleteAt(index, op.delete);\n        return index;\n      }\n\n      return index + (op.retain || op.insert.length || 1);\n    }, 0);\n    this.scroll.batchEnd();\n    this.scroll.optimize();\n    return this.update(normalizedDelta);\n  }\n\n  deleteText(index, length) {\n    this.scroll.deleteAt(index, length);\n    return this.update(new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(index).delete(length));\n  }\n\n  formatLine(index, length) {\n    let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};\n    this.scroll.update();\n    Object.keys(formats).forEach(format => {\n      this.scroll.lines(index, Math.max(length, 1)).forEach(line => {\n        line.format(format, formats[format]);\n      });\n    });\n    this.scroll.optimize();\n    const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(index).retain(length, clone__WEBPACK_IMPORTED_MODULE_0___default()(formats));\n    return this.update(delta);\n  }\n\n  formatText(index, length) {\n    let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};\n    Object.keys(formats).forEach(format => {\n      this.scroll.formatAt(index, length, format, formats[format]);\n    });\n    const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(index).retain(length, clone__WEBPACK_IMPORTED_MODULE_0___default()(formats));\n    return this.update(delta);\n  }\n\n  getContents(index, length) {\n    return this.delta.slice(index, index + length);\n  }\n\n  getDelta() {\n    return this.scroll.lines().reduce((delta, line) => {\n      return delta.concat(line.delta());\n    }, new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a());\n  }\n\n  getFormat(index) {\n    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;\n    let lines = [];\n    let leaves = [];\n\n    if (length === 0) {\n      this.scroll.path(index).forEach(path => {\n        const _path = _slicedToArray(path, 1),\n              blot = _path[0];\n\n        if (blot instanceof _blots_block__WEBPACK_IMPORTED_MODULE_7__[\"default\"]) {\n          lines.push(blot);\n        } else if (blot instanceof parchment__WEBPACK_IMPORTED_MODULE_4__[\"LeafBlot\"]) {\n          leaves.push(blot);\n        }\n      });\n    } else {\n      lines = this.scroll.lines(index, length);\n      leaves = this.scroll.descendants(parchment__WEBPACK_IMPORTED_MODULE_4__[\"LeafBlot\"], index, length);\n    }\n\n    const formatsArr = [lines, leaves].map(blots => {\n      if (blots.length === 0) return {};\n      let formats = Object(_blots_block__WEBPACK_IMPORTED_MODULE_7__[\"bubbleFormats\"])(blots.shift());\n\n      while (Object.keys(formats).length > 0) {\n        const blot = blots.shift();\n        if (blot == null) return formats;\n        formats = combineFormats(Object(_blots_block__WEBPACK_IMPORTED_MODULE_7__[\"bubbleFormats\"])(blot), formats);\n      }\n\n      return formats;\n    });\n    return extend__WEBPACK_IMPORTED_MODULE_2___default.a.apply(extend__WEBPACK_IMPORTED_MODULE_2___default.a, formatsArr);\n  }\n\n  getHTML(index, length) {\n    const _this$scroll$line3 = this.scroll.line(index),\n          _this$scroll$line4 = _slicedToArray(_this$scroll$line3, 2),\n          line = _this$scroll$line4[0],\n          lineOffset = _this$scroll$line4[1];\n\n    if (line.length() >= lineOffset + length) {\n      return convertHTML(line, lineOffset, length, true);\n    }\n\n    return convertHTML(this.scroll, index, length, true);\n  }\n\n  getText(index, length) {\n    return this.getContents(index, length).filter(op => typeof op.insert === 'string').map(op => op.insert).join('');\n  }\n\n  insertEmbed(index, embed, value) {\n    this.scroll.insertAt(index, embed, value);\n    return this.update(new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(index).insert({\n      [embed]: value\n    }));\n  }\n\n  insertText(index, text) {\n    let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};\n    text = text.replace(/\\r\\n/g, '\\n').replace(/\\r/g, '\\n');\n    this.scroll.insertAt(index, text);\n    Object.keys(formats).forEach(format => {\n      this.scroll.formatAt(index, text.length, format, formats[format]);\n    });\n    return this.update(new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(index).insert(text, clone__WEBPACK_IMPORTED_MODULE_0___default()(formats)));\n  }\n\n  isBlank() {\n    if (this.scroll.children.length === 0) return true;\n    if (this.scroll.children.length > 1) return false;\n    const block = this.scroll.children.head;\n    if (block.statics.blotName !== _blots_block__WEBPACK_IMPORTED_MODULE_7__[\"default\"].blotName) return false;\n    if (block.children.length > 1) return false;\n    return block.children.head instanceof _blots_break__WEBPACK_IMPORTED_MODULE_8__[\"default\"];\n  }\n\n  removeFormat(index, length) {\n    const text = this.getText(index, length);\n\n    const _this$scroll$line5 = this.scroll.line(index + length),\n          _this$scroll$line6 = _slicedToArray(_this$scroll$line5, 2),\n          line = _this$scroll$line6[0],\n          offset = _this$scroll$line6[1];\n\n    let suffixLength = 0;\n    let suffix = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a();\n\n    if (line != null) {\n      suffixLength = line.length() - offset;\n      suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\\n');\n    }\n\n    const contents = this.getContents(index, length + suffixLength);\n    const diff = contents.diff(new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().insert(text).concat(suffix));\n    const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(index).concat(diff);\n    return this.applyDelta(delta);\n  }\n\n  update(change) {\n    let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];\n    let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;\n    const oldDelta = this.delta;\n\n    if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && this.scroll.find(mutations[0].target)) {\n      // Optimization for character changes\n      const textBlot = this.scroll.find(mutations[0].target);\n      const formats = Object(_blots_block__WEBPACK_IMPORTED_MODULE_7__[\"bubbleFormats\"])(textBlot);\n      const index = textBlot.offset(this.scroll);\n      const oldValue = mutations[0].oldValue.replace(_blots_cursor__WEBPACK_IMPORTED_MODULE_6__[\"default\"].CONTENTS, '');\n      const oldText = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().insert(oldValue);\n      const newText = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().insert(textBlot.value());\n      const relativeSelectionInfo = selectionInfo && {\n        oldRange: shiftRange(selectionInfo.oldRange, -index),\n        newRange: shiftRange(selectionInfo.newRange, -index)\n      };\n      const diffDelta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));\n      change = diffDelta.reduce((delta, op) => {\n        if (op.insert) {\n          return delta.insert(op.insert, formats);\n        }\n\n        return delta.push(op);\n      }, new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a());\n      this.delta = oldDelta.compose(change);\n    } else {\n      this.delta = this.getDelta();\n\n      if (!change || !deep_equal__WEBPACK_IMPORTED_MODULE_1___default()(oldDelta.compose(change), this.delta)) {\n        change = oldDelta.diff(this.delta, selectionInfo);\n      }\n    }\n\n    return change;\n  }\n\n}\n\nfunction convertListHTML(items, lastIndent, types) {\n  if (items.length === 0) {\n    const _getListType = getListType(types.pop()),\n          _getListType2 = _slicedToArray(_getListType, 1),\n          endTag = _getListType2[0];\n\n    if (lastIndent <= 0) {\n      return \"</li></\".concat(endTag, \">\");\n    }\n\n    return \"</li></\".concat(endTag, \">\").concat(convertListHTML([], lastIndent - 1, types));\n  }\n\n  const _items = _toArray(items),\n        _items$ = _items[0],\n        child = _items$.child,\n        offset = _items$.offset,\n        length = _items$.length,\n        indent = _items$.indent,\n        type = _items$.type,\n        rest = _items.slice(1);\n\n  const _getListType3 = getListType(type),\n        _getListType4 = _slicedToArray(_getListType3, 2),\n        tag = _getListType4[0],\n        attribute = _getListType4[1];\n\n  if (indent > lastIndent) {\n    types.push(type);\n\n    if (indent === lastIndent + 1) {\n      return \"<\".concat(tag, \"><li\").concat(attribute, \">\").concat(convertHTML(child, offset, length)).concat(convertListHTML(rest, indent, types));\n    }\n\n    return \"<\".concat(tag, \"><li>\").concat(convertListHTML(items, lastIndent + 1, types));\n  }\n\n  const previousType = types[types.length - 1];\n\n  if (indent === lastIndent && type === previousType) {\n    return \"</li><li\".concat(attribute, \">\").concat(convertHTML(child, offset, length)).concat(convertListHTML(rest, indent, types));\n  }\n\n  const _getListType5 = getListType(types.pop()),\n        _getListType6 = _slicedToArray(_getListType5, 1),\n        endTag = _getListType6[0];\n\n  return \"</li></\".concat(endTag, \">\").concat(convertListHTML(items, lastIndent - 1, types));\n}\n\nfunction convertHTML(blot, index, length) {\n  let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;\n\n  if (typeof blot.html === 'function') {\n    return blot.html(index, length);\n  }\n\n  if (blot instanceof _blots_text__WEBPACK_IMPORTED_MODULE_9__[\"default\"]) {\n    return Object(_blots_text__WEBPACK_IMPORTED_MODULE_9__[\"escapeText\"])(blot.value().slice(index, index + length));\n  }\n\n  if (blot.children) {\n    // TODO fix API\n    if (blot.statics.blotName === 'list-container') {\n      const items = [];\n      blot.children.forEachAt(index, length, (child, offset, childLength) => {\n        const formats = child.formats();\n        items.push({\n          child,\n          offset,\n          length: childLength,\n          indent: formats.indent || 0,\n          type: formats.list\n        });\n      });\n      return convertListHTML(items, -1, []);\n    }\n\n    const parts = [];\n    blot.children.forEachAt(index, length, (child, offset, childLength) => {\n      parts.push(convertHTML(child, offset, childLength));\n    });\n\n    if (isRoot || blot.statics.blotName === 'list') {\n      return parts.join('');\n    }\n\n    const _blot$domNode = blot.domNode,\n          outerHTML = _blot$domNode.outerHTML,\n          innerHTML = _blot$domNode.innerHTML;\n\n    const _outerHTML$split = outerHTML.split(\">\".concat(innerHTML, \"<\")),\n          _outerHTML$split2 = _slicedToArray(_outerHTML$split, 2),\n          start = _outerHTML$split2[0],\n          end = _outerHTML$split2[1]; // TODO cleanup\n\n\n    if (start === '<table') {\n      return \"<table style=\\\"border: 1px solid #000;\\\">\".concat(parts.join(''), \"<\").concat(end);\n    }\n\n    return \"\".concat(start, \">\").concat(parts.join(''), \"<\").concat(end);\n  }\n\n  return blot.domNode.outerHTML;\n}\n\nfunction combineFormats(formats, combined) {\n  return Object.keys(combined).reduce((merged, name) => {\n    if (formats[name] == null) return merged;\n\n    if (combined[name] === formats[name]) {\n      merged[name] = combined[name];\n    } else if (Array.isArray(combined[name])) {\n      if (combined[name].indexOf(formats[name]) < 0) {\n        merged[name] = combined[name].concat([formats[name]]);\n      }\n    } else {\n      merged[name] = [combined[name], formats[name]];\n    }\n\n    return merged;\n  }, {});\n}\n\nfunction getListType(type) {\n  const tag = type === 'ordered' ? 'ol' : 'ul';\n\n  switch (type) {\n    case 'checked':\n      return [tag, ' data-list=\"checked\"'];\n\n    case 'unchecked':\n      return [tag, ' data-list=\"unchecked\"'];\n\n    default:\n      return [tag, ''];\n  }\n}\n\nfunction normalizeDelta(delta) {\n  return delta.reduce((normalizedDelta, op) => {\n    if (typeof op.insert === 'string') {\n      const text = op.insert.replace(/\\r\\n/g, '\\n').replace(/\\r/g, '\\n');\n      return normalizedDelta.insert(text, op.attributes);\n    }\n\n    return normalizedDelta.push(op);\n  }, new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a());\n}\n\nfunction shiftRange(_ref, amount) {\n  let index = _ref.index,\n      length = _ref.length;\n  return new _selection__WEBPACK_IMPORTED_MODULE_5__[\"Range\"](index + amount, length);\n}\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (Editor);\n\n//# sourceURL=webpack://Quill/./core/editor.js?");

/***/ }),

/***/ "./core/emitter.js":
/*!*************************!*\
  !*** ./core/emitter.js ***!
  \*************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! eventemitter3 */ \"./node_modules/eventemitter3/index.js\");\n/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(eventemitter3__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./logger */ \"./core/logger.js\");\n/* harmony import */ var _shadow_selection_polyfill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./shadow-selection-polyfill */ \"./core/shadow-selection-polyfill.js\");\n\n\n\nconst debug = Object(_logger__WEBPACK_IMPORTED_MODULE_1__[\"default\"])('quill:events');\nconst EVENTS = [_shadow_selection_polyfill__WEBPACK_IMPORTED_MODULE_2__[\"SHADOW_SELECTIONCHANGE\"], 'mousedown', 'mouseup', 'click'];\nconst EMITTERS = [];\nconst supportsRootNode = 'getRootNode' in document;\nEVENTS.forEach(eventName => {\n  document.addEventListener(eventName, function () {\n    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {\n      args[_key] = arguments[_key];\n    }\n\n    EMITTERS.forEach(em => {\n      em.handleDOM(...args);\n    });\n  });\n});\n\nclass Emitter extends eventemitter3__WEBPACK_IMPORTED_MODULE_0___default.a {\n  constructor() {\n    super();\n    this.listeners = {};\n    EMITTERS.push(this);\n    this.on('error', debug.error);\n  }\n\n  emit() {\n    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {\n      args[_key2] = arguments[_key2];\n    }\n\n    debug.log.call(debug, ...args);\n    super.emit(...args);\n  }\n\n  handleDOM(event) {\n    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {\n      args[_key3 - 1] = arguments[_key3];\n    }\n\n    const target = event.composedPath ? event.composedPath()[0] : event.target;\n\n    const containsNode = (node, srcTarget) => {\n      if (!supportsRootNode || srcTarget.getRootNode() === document) {\n        return node.contains(srcTarget);\n      }\n\n      while (!node.contains(srcTarget)) {\n        const root = srcTarget.getRootNode();\n\n        if (!root || !root.host) {\n          return false;\n        }\n\n        srcTarget = root.host;\n      }\n\n      return true;\n    };\n\n    (this.listeners[event.type] || []).forEach((_ref) => {\n      let node = _ref.node,\n          handler = _ref.handler;\n\n      if (target === node || containsNode(node, target)) {\n        handler(event, ...args);\n      }\n    });\n  }\n\n  listenDOM(eventName, node, handler) {\n    if (!this.listeners[eventName]) {\n      this.listeners[eventName] = [];\n    }\n\n    this.listeners[eventName].push({\n      node,\n      handler\n    });\n  }\n\n}\n\nEmitter.events = {\n  EDITOR_CHANGE: 'editor-change',\n  SCROLL_BEFORE_UPDATE: 'scroll-before-update',\n  SCROLL_BLOT_MOUNT: 'scroll-blot-mount',\n  SCROLL_BLOT_UNMOUNT: 'scroll-blot-unmount',\n  SCROLL_OPTIMIZE: 'scroll-optimize',\n  SCROLL_UPDATE: 'scroll-update',\n  SELECTION_CHANGE: 'selection-change',\n  TEXT_CHANGE: 'text-change'\n};\nEmitter.sources = {\n  API: 'api',\n  SILENT: 'silent',\n  USER: 'user'\n};\n/* harmony default export */ __webpack_exports__[\"default\"] = (Emitter);\n\n//# sourceURL=webpack://Quill/./core/emitter.js?");

/***/ }),

/***/ "./core/instances.js":
/*!***************************!*\
  !*** ./core/instances.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony default export */ __webpack_exports__[\"default\"] = (new WeakMap());\n\n//# sourceURL=webpack://Quill/./core/instances.js?");

/***/ }),

/***/ "./core/logger.js":
/*!************************!*\
  !*** ./core/logger.js ***!
  \************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\nconst levels = ['error', 'warn', 'log', 'info'];\nlet level = 'warn';\n\nfunction debug(method) {\n  if (levels.indexOf(method) <= levels.indexOf(level)) {\n    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {\n      args[_key - 1] = arguments[_key];\n    }\n\n    console[method](...args); // eslint-disable-line no-console\n  }\n}\n\nfunction namespace(ns) {\n  return levels.reduce((logger, method) => {\n    logger[method] = debug.bind(console, method, ns);\n    return logger;\n  }, {});\n}\n\nnamespace.level = newLevel => {\n  level = newLevel;\n};\n\ndebug.level = namespace.level;\n/* harmony default export */ __webpack_exports__[\"default\"] = (namespace);\n\n//# sourceURL=webpack://Quill/./core/logger.js?");

/***/ }),

/***/ "./core/module.js":
/*!************************!*\
  !*** ./core/module.js ***!
  \************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\nclass Module {\n  constructor(quill) {\n    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n    this.quill = quill;\n    this.options = options;\n  }\n\n}\n\nModule.DEFAULTS = {};\n/* harmony default export */ __webpack_exports__[\"default\"] = (Module);\n\n//# sourceURL=webpack://Quill/./core/module.js?");

/***/ }),

/***/ "./core/quill.js":
/*!***********************!*\
  !*** ./core/quill.js ***!
  \***********************/
/*! exports provided: globalRegistry, expandConfig, overload, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"globalRegistry\", function() { return globalRegistry; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"expandConfig\", function() { return expandConfig; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"overload\", function() { return overload; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Quill; });\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta */ \"./node_modules/quill-delta/dist/Delta.js\");\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! extend */ \"./node_modules/extend/index.js\");\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(extend__WEBPACK_IMPORTED_MODULE_2__);\n/* harmony import */ var _editor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./editor */ \"./core/editor.js\");\n/* harmony import */ var _emitter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./emitter */ \"./core/emitter.js\");\n/* harmony import */ var _module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./module */ \"./core/module.js\");\n/* harmony import */ var _selection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./selection */ \"./core/selection.js\");\n/* harmony import */ var _instances__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./instances */ \"./core/instances.js\");\n/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./logger */ \"./core/logger.js\");\n/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./theme */ \"./core/theme.js\");\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\n\n\n\n\n\n\n\n\nconst debug = Object(_logger__WEBPACK_IMPORTED_MODULE_8__[\"default\"])('quill');\nconst globalRegistry = new parchment__WEBPACK_IMPORTED_MODULE_1__[\"Registry\"]();\nparchment__WEBPACK_IMPORTED_MODULE_1__[\"ParentBlot\"].uiClass = 'ql-ui';\n\nclass Quill {\n  static debug(limit) {\n    if (limit === true) {\n      limit = 'log';\n    }\n\n    _logger__WEBPACK_IMPORTED_MODULE_8__[\"default\"].level(limit);\n  }\n\n  static find(node) {\n    return _instances__WEBPACK_IMPORTED_MODULE_7__[\"default\"].get(node) || globalRegistry.find(node);\n  }\n\n  static import(name) {\n    if (this.imports[name] == null) {\n      debug.error(\"Cannot import \".concat(name, \". Are you sure it was registered?\"));\n    }\n\n    return this.imports[name];\n  }\n\n  static register(path, target) {\n    let overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;\n\n    if (typeof path !== 'string') {\n      const name = path.attrName || path.blotName;\n\n      if (typeof name === 'string') {\n        // register(Blot | Attributor, overwrite)\n        this.register(\"formats/\".concat(name), path, target);\n      } else {\n        Object.keys(path).forEach(key => {\n          this.register(key, path[key], target);\n        });\n      }\n    } else {\n      if (this.imports[path] != null && !overwrite) {\n        debug.warn(\"Overwriting \".concat(path, \" with\"), target);\n      }\n\n      this.imports[path] = target;\n\n      if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {\n        globalRegistry.register(target);\n      }\n\n      if (typeof target.register === 'function') {\n        target.register(globalRegistry);\n      }\n    }\n  }\n\n  constructor(container) {\n    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n    this.options = expandConfig(container, options);\n    this.container = this.options.container;\n\n    if (this.container == null) {\n      return debug.error('Invalid Quill container', container);\n    }\n\n    if (this.options.debug) {\n      Quill.debug(this.options.debug);\n    }\n\n    const html = this.container.innerHTML.trim();\n    this.container.classList.add('ql-container');\n    this.container.innerHTML = '';\n    _instances__WEBPACK_IMPORTED_MODULE_7__[\"default\"].set(this.container, this);\n    this.root = this.addContainer('ql-editor');\n    this.root.classList.add('ql-blank');\n    this.root.setAttribute('data-gramm', false);\n    this.scrollingContainer = this.options.scrollingContainer || this.root;\n    this.emitter = new _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"]();\n    const ScrollBlot = this.options.registry.query(parchment__WEBPACK_IMPORTED_MODULE_1__[\"ScrollBlot\"].blotName);\n    this.scroll = new ScrollBlot(this.options.registry, this.root, {\n      emitter: this.emitter\n    });\n    this.editor = new _editor__WEBPACK_IMPORTED_MODULE_3__[\"default\"](this.scroll);\n    this.selection = new _selection__WEBPACK_IMPORTED_MODULE_6__[\"default\"](this.scroll, this.emitter);\n    this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap\n\n    this.keyboard = this.theme.addModule('keyboard');\n    this.clipboard = this.theme.addModule('clipboard');\n    this.history = this.theme.addModule('history');\n    this.uploader = this.theme.addModule('uploader');\n    this.theme.init();\n    this.emitter.on(_emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].events.EDITOR_CHANGE, type => {\n      if (type === _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].events.TEXT_CHANGE) {\n        this.root.classList.toggle('ql-blank', this.editor.isBlank());\n      }\n    });\n    this.emitter.on(_emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].events.SCROLL_UPDATE, (source, mutations) => {\n      const oldRange = this.selection.lastRange;\n\n      const _this$selection$getRa = this.selection.getRange(),\n            _this$selection$getRa2 = _slicedToArray(_this$selection$getRa, 1),\n            newRange = _this$selection$getRa2[0];\n\n      const selectionInfo = oldRange && newRange ? {\n        oldRange,\n        newRange\n      } : undefined;\n      modify.call(this, () => this.editor.update(null, mutations, selectionInfo), source);\n    });\n    const contents = this.clipboard.convert({\n      html: \"\".concat(html, \"<p><br></p>\"),\n      text: '\\n'\n    });\n    this.setContents(contents);\n    this.history.clear();\n\n    if (this.options.placeholder) {\n      this.root.setAttribute('data-placeholder', this.options.placeholder);\n    }\n\n    if (this.options.readOnly) {\n      this.disable();\n    }\n\n    this.allowReadOnlyEdits = false;\n  }\n\n  addContainer(container) {\n    let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;\n\n    if (typeof container === 'string') {\n      const className = container;\n      container = document.createElement('div');\n      container.classList.add(className);\n    }\n\n    this.container.insertBefore(container, refNode);\n    return container;\n  }\n\n  blur() {\n    this.selection.setRange(null);\n  }\n\n  deleteText(index, length, source) {\n    var _overload = overload(index, length, source);\n\n    var _overload2 = _slicedToArray(_overload, 4);\n\n    index = _overload2[0];\n    length = _overload2[1];\n    source = _overload2[3];\n    return modify.call(this, () => {\n      return this.editor.deleteText(index, length);\n    }, source, index, -1 * length);\n  }\n\n  disable() {\n    this.enable(false);\n  }\n\n  editReadOnly(modifier) {\n    this.allowReadOnlyEdits = true;\n    const value = modifier();\n    this.allowReadOnlyEdits = false;\n    return value;\n  }\n\n  enable() {\n    let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;\n    this.scroll.enable(enabled);\n    this.container.classList.toggle('ql-disabled', !enabled);\n  }\n\n  focus() {\n    const scrollTop = this.scrollingContainer.scrollTop;\n    this.selection.focus();\n    this.scrollingContainer.scrollTop = scrollTop;\n    this.scrollIntoView();\n  }\n\n  format(name, value) {\n    let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.API;\n    return modify.call(this, () => {\n      const range = this.getSelection(true);\n      let change = new quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a();\n      if (range == null) return change;\n\n      if (this.scroll.query(name, parchment__WEBPACK_IMPORTED_MODULE_1__[\"Scope\"].BLOCK)) {\n        change = this.editor.formatLine(range.index, range.length, {\n          [name]: value\n        });\n      } else if (range.length === 0) {\n        this.selection.format(name, value);\n        return change;\n      } else {\n        change = this.editor.formatText(range.index, range.length, {\n          [name]: value\n        });\n      }\n\n      this.setSelection(range, _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.SILENT);\n      return change;\n    }, source);\n  }\n\n  formatLine(index, length, name, value, source) {\n    let formats; // eslint-disable-next-line prefer-const\n\n    var _overload3 = overload(index, length, name, value, source);\n\n    var _overload4 = _slicedToArray(_overload3, 4);\n\n    index = _overload4[0];\n    length = _overload4[1];\n    formats = _overload4[2];\n    source = _overload4[3];\n    return modify.call(this, () => {\n      return this.editor.formatLine(index, length, formats);\n    }, source, index, 0);\n  }\n\n  formatText(index, length, name, value, source) {\n    let formats; // eslint-disable-next-line prefer-const\n\n    var _overload5 = overload(index, length, name, value, source);\n\n    var _overload6 = _slicedToArray(_overload5, 4);\n\n    index = _overload6[0];\n    length = _overload6[1];\n    formats = _overload6[2];\n    source = _overload6[3];\n    return modify.call(this, () => {\n      return this.editor.formatText(index, length, formats);\n    }, source, index, 0);\n  }\n\n  getBounds(index) {\n    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;\n    let bounds;\n\n    if (typeof index === 'number') {\n      bounds = this.selection.getBounds(index, length);\n    } else {\n      bounds = this.selection.getBounds(index.index, index.length);\n    }\n\n    const containerBounds = this.container.getBoundingClientRect();\n    return {\n      bottom: bounds.bottom - containerBounds.top,\n      height: bounds.height,\n      left: bounds.left - containerBounds.left,\n      right: bounds.right - containerBounds.left,\n      top: bounds.top - containerBounds.top,\n      width: bounds.width\n    };\n  }\n\n  getContents() {\n    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;\n\n    var _overload7 = overload(index, length);\n\n    var _overload8 = _slicedToArray(_overload7, 2);\n\n    index = _overload8[0];\n    length = _overload8[1];\n    return this.editor.getContents(index, length);\n  }\n\n  getFormat() {\n    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);\n    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;\n\n    if (typeof index === 'number') {\n      return this.editor.getFormat(index, length);\n    }\n\n    return this.editor.getFormat(index.index, index.length);\n  }\n\n  getIndex(blot) {\n    return blot.offset(this.scroll);\n  }\n\n  getLength() {\n    return this.scroll.length();\n  }\n\n  getLeaf(index) {\n    return this.scroll.leaf(index);\n  }\n\n  getLine(index) {\n    return this.scroll.line(index);\n  }\n\n  getLines() {\n    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;\n\n    if (typeof index !== 'number') {\n      return this.scroll.lines(index.index, index.length);\n    }\n\n    return this.scroll.lines(index, length);\n  }\n\n  getModule(name) {\n    return this.theme.modules[name];\n  }\n\n  getSelection() {\n    let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;\n    if (focus) this.focus();\n    this.update(); // Make sure we access getRange with editor in consistent state\n\n    return this.selection.getRange()[0];\n  }\n\n  getSemanticHTML() {\n    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;\n\n    var _overload9 = overload(index, length);\n\n    var _overload10 = _slicedToArray(_overload9, 2);\n\n    index = _overload10[0];\n    length = _overload10[1];\n    return this.editor.getHTML(index, length);\n  }\n\n  getText() {\n    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;\n\n    var _overload11 = overload(index, length);\n\n    var _overload12 = _slicedToArray(_overload11, 2);\n\n    index = _overload12[0];\n    length = _overload12[1];\n    return this.editor.getText(index, length);\n  }\n\n  hasFocus() {\n    return this.selection.hasFocus();\n  }\n\n  insertEmbed(index, embed, value) {\n    let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;\n    return modify.call(this, () => {\n      return this.editor.insertEmbed(index, embed, value);\n    }, source, index);\n  }\n\n  insertText(index, text, name, value, source) {\n    let formats; // eslint-disable-next-line prefer-const\n\n    var _overload13 = overload(index, 0, name, value, source);\n\n    var _overload14 = _slicedToArray(_overload13, 4);\n\n    index = _overload14[0];\n    formats = _overload14[2];\n    source = _overload14[3];\n    return modify.call(this, () => {\n      return this.editor.insertText(index, text, formats);\n    }, source, index, text.length);\n  }\n\n  isEnabled() {\n    return this.scroll.isEnabled();\n  }\n\n  off() {\n    return this.emitter.off(...arguments);\n  }\n\n  on() {\n    return this.emitter.on(...arguments);\n  }\n\n  once() {\n    return this.emitter.once(...arguments);\n  }\n\n  removeFormat(index, length, source) {\n    var _overload15 = overload(index, length, source);\n\n    var _overload16 = _slicedToArray(_overload15, 4);\n\n    index = _overload16[0];\n    length = _overload16[1];\n    source = _overload16[3];\n    return modify.call(this, () => {\n      return this.editor.removeFormat(index, length);\n    }, source, index);\n  }\n\n  scrollIntoView() {\n    this.selection.scrollIntoView(this.scrollingContainer);\n  }\n\n  setContents(delta) {\n    let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.API;\n    return modify.call(this, () => {\n      delta = new quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a(delta);\n      const length = this.getLength();\n      const deleted = this.editor.deleteText(0, length);\n      const applied = this.editor.applyDelta(delta);\n      const lastOp = applied.ops[applied.ops.length - 1];\n\n      if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\\n') {\n        this.editor.deleteText(this.getLength() - 1, 1);\n        applied.delete(1);\n      }\n\n      return deleted.compose(applied);\n    }, source);\n  }\n\n  setSelection(index, length, source) {\n    if (index == null) {\n      this.selection.setRange(null, length || Quill.sources.API);\n    } else {\n      var _overload17 = overload(index, length, source);\n\n      var _overload18 = _slicedToArray(_overload17, 4);\n\n      index = _overload18[0];\n      length = _overload18[1];\n      source = _overload18[3];\n      this.selection.setRange(new _selection__WEBPACK_IMPORTED_MODULE_6__[\"Range\"](Math.max(0, index), length), source);\n\n      if (source !== _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.SILENT) {\n        this.selection.scrollIntoView(this.scrollingContainer);\n      }\n    }\n  }\n\n  setText(text) {\n    let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.API;\n    const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a().insert(text);\n    return this.setContents(delta, source);\n  }\n\n  update() {\n    let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.USER;\n    const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes\n\n    this.selection.update(source); // TODO this is usually undefined\n\n    return change;\n  }\n\n  updateContents(delta) {\n    let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.API;\n    return modify.call(this, () => {\n      delta = new quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a(delta);\n      return this.editor.applyDelta(delta, source);\n    }, source, true);\n  }\n\n}\n\nQuill.DEFAULTS = {\n  bounds: null,\n  modules: {},\n  placeholder: '',\n  readOnly: false,\n  registry: globalRegistry,\n  scrollingContainer: null,\n  theme: 'default'\n};\nQuill.events = _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].events;\nQuill.sources = _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources; // eslint-disable-next-line no-undef\n\nQuill.version =  false ? undefined : \"2.0.0-dev.5\";\nQuill.imports = {\n  delta: quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a,\n  parchment: parchment__WEBPACK_IMPORTED_MODULE_1__,\n  'core/module': _module__WEBPACK_IMPORTED_MODULE_5__[\"default\"],\n  'core/theme': _theme__WEBPACK_IMPORTED_MODULE_9__[\"default\"]\n};\n\nfunction expandConfig(container, userConfig) {\n  userConfig = extend__WEBPACK_IMPORTED_MODULE_2___default()(true, {\n    container,\n    modules: {\n      clipboard: true,\n      keyboard: true,\n      history: true,\n      uploader: true\n    }\n  }, userConfig);\n\n  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {\n    userConfig.theme = _theme__WEBPACK_IMPORTED_MODULE_9__[\"default\"];\n  } else {\n    userConfig.theme = Quill.import(\"themes/\".concat(userConfig.theme));\n\n    if (userConfig.theme == null) {\n      throw new Error(\"Invalid theme \".concat(userConfig.theme, \". Did you register it?\"));\n    }\n  }\n\n  const themeConfig = extend__WEBPACK_IMPORTED_MODULE_2___default()(true, {}, userConfig.theme.DEFAULTS);\n  [themeConfig, userConfig].forEach(config => {\n    config.modules = config.modules || {};\n    Object.keys(config.modules).forEach(module => {\n      if (config.modules[module] === true) {\n        config.modules[module] = {};\n      }\n    });\n  });\n  const moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));\n  const moduleConfig = moduleNames.reduce((config, name) => {\n    const moduleClass = Quill.import(\"modules/\".concat(name));\n\n    if (moduleClass == null) {\n      debug.error(\"Cannot load \".concat(name, \" module. Are you sure you registered it?\"));\n    } else {\n      config[name] = moduleClass.DEFAULTS || {};\n    }\n\n    return config;\n  }, {}); // Special case toolbar shorthand\n\n  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {\n    userConfig.modules.toolbar = {\n      container: userConfig.modules.toolbar\n    };\n  }\n\n  userConfig = extend__WEBPACK_IMPORTED_MODULE_2___default()(true, {}, Quill.DEFAULTS, {\n    modules: moduleConfig\n  }, themeConfig, userConfig);\n  ['bounds', 'container', 'scrollingContainer'].forEach(key => {\n    if (typeof userConfig[key] === 'string') {\n      userConfig[key] = document.querySelector(userConfig[key]);\n    }\n  });\n  userConfig.modules = Object.keys(userConfig.modules).reduce((config, name) => {\n    if (userConfig.modules[name]) {\n      config[name] = userConfig.modules[name];\n    }\n\n    return config;\n  }, {});\n  return userConfig;\n} // Handle selection preservation and TEXT_CHANGE emission\n// common to modification APIs\n\n\nfunction modify(modifier, source, index, shift) {\n  if (!this.isEnabled() && source === _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.USER && !this.allowReadOnlyEdits) {\n    return new quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a();\n  }\n\n  let range = index == null ? null : this.getSelection();\n  const oldDelta = this.editor.delta;\n  const change = modifier();\n\n  if (range != null) {\n    if (index === true) {\n      index = range.index; // eslint-disable-line prefer-destructuring\n    }\n\n    if (shift == null) {\n      range = shiftRange(range, change, source);\n    } else if (shift !== 0) {\n      range = shiftRange(range, index, shift, source);\n    }\n\n    this.setSelection(range, _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.SILENT);\n  }\n\n  if (change.length() > 0) {\n    const args = [_emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].events.TEXT_CHANGE, change, oldDelta, source];\n    this.emitter.emit(_emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].events.EDITOR_CHANGE, ...args);\n\n    if (source !== _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.SILENT) {\n      this.emitter.emit(...args);\n    }\n  }\n\n  return change;\n}\n\nfunction overload(index, length, name, value, source) {\n  let formats = {};\n\n  if (typeof index.index === 'number' && typeof index.length === 'number') {\n    // Allow for throwaway end (used by insertText/insertEmbed)\n    if (typeof length !== 'number') {\n      source = value;\n      value = name;\n      name = length;\n      length = index.length; // eslint-disable-line prefer-destructuring\n\n      index = index.index; // eslint-disable-line prefer-destructuring\n    } else {\n      length = index.length; // eslint-disable-line prefer-destructuring\n\n      index = index.index; // eslint-disable-line prefer-destructuring\n    }\n  } else if (typeof length !== 'number') {\n    source = value;\n    value = name;\n    name = length;\n    length = 0;\n  } // Handle format being object, two format name/value strings or excluded\n\n\n  if (typeof name === 'object') {\n    formats = name;\n    source = value;\n  } else if (typeof name === 'string') {\n    if (value != null) {\n      formats[name] = value;\n    } else {\n      source = name;\n    }\n  } // Handle optional source\n\n\n  source = source || _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.API;\n  return [index, length, formats, source];\n}\n\nfunction shiftRange(range, index, length, source) {\n  if (range == null) return null;\n  let start;\n  let end;\n\n  if (index instanceof quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a) {\n    var _map = [range.index, range.index + range.length].map(pos => index.transformPosition(pos, source !== _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.USER));\n\n    var _map2 = _slicedToArray(_map, 2);\n\n    start = _map2[0];\n    end = _map2[1];\n  } else {\n    var _map3 = [range.index, range.index + range.length].map(pos => {\n      if (pos < index || pos === index && source === _emitter__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.USER) return pos;\n\n      if (length >= 0) {\n        return pos + length;\n      }\n\n      return Math.max(index, pos + length);\n    });\n\n    var _map4 = _slicedToArray(_map3, 2);\n\n    start = _map4[0];\n    end = _map4[1];\n  }\n\n  return new _selection__WEBPACK_IMPORTED_MODULE_6__[\"Range\"](start, end - start);\n}\n\n\n\n//# sourceURL=webpack://Quill/./core/quill.js?");

/***/ }),

/***/ "./core/selection.js":
/*!***************************!*\
  !*** ./core/selection.js ***!
  \***************************/
/*! exports provided: Range, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"Range\", function() { return Range; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Selection; });\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var clone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! clone */ \"./node_modules/clone/clone.js\");\n/* harmony import */ var clone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(clone__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var deep_equal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! deep-equal */ \"./node_modules/deep-equal/index.js\");\n/* harmony import */ var deep_equal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(deep_equal__WEBPACK_IMPORTED_MODULE_2__);\n/* harmony import */ var _emitter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./emitter */ \"./core/emitter.js\");\n/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./logger */ \"./core/logger.js\");\n/* harmony import */ var _shadow_selection_polyfill__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./shadow-selection-polyfill */ \"./core/shadow-selection-polyfill.js\");\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\n\n\n\n\nconst debug = Object(_logger__WEBPACK_IMPORTED_MODULE_4__[\"default\"])('quill:selection');\n\nclass Range {\n  constructor(index) {\n    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;\n    this.index = index;\n    this.length = length;\n  }\n\n}\n\nclass Selection {\n  constructor(scroll, emitter) {\n    this.emitter = emitter;\n    this.scroll = scroll;\n    this.composing = false;\n    this.mouseDown = false;\n    this.root = this.scroll.domNode;\n    this.rootDocument = this.root.getRootNode ? this.root.getRootNode() : document;\n    this.cursor = this.scroll.create('cursor', this); // savedRange is last non-null range\n\n    this.savedRange = new Range(0, 0);\n    this.lastRange = this.savedRange;\n    this.handleComposition();\n    this.handleDragging();\n    this.emitter.listenDOM(_shadow_selection_polyfill__WEBPACK_IMPORTED_MODULE_5__[\"SHADOW_SELECTIONCHANGE\"], document, () => {\n      if (!this.mouseDown && !this.composing) {\n        setTimeout(this.update.bind(this, _emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].sources.USER), 1);\n      }\n    });\n    this.emitter.on(_emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].events.SCROLL_BEFORE_UPDATE, () => {\n      if (!this.hasFocus()) return;\n      const native = this.getNativeRange();\n      if (native == null) return;\n      if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle\n\n      this.emitter.once(_emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].events.SCROLL_UPDATE, () => {\n        try {\n          if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) {\n            this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);\n          }\n\n          this.update(_emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].sources.SILENT);\n        } catch (ignored) {// ignore\n        }\n      });\n    });\n    this.emitter.on(_emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].events.SCROLL_OPTIMIZE, (mutations, context) => {\n      if (context.range) {\n        const _context$range = context.range,\n              startNode = _context$range.startNode,\n              startOffset = _context$range.startOffset,\n              endNode = _context$range.endNode,\n              endOffset = _context$range.endOffset;\n        this.setNativeRange(startNode, startOffset, endNode, endOffset);\n        this.update(_emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].sources.SILENT);\n      }\n    });\n    this.update(_emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].sources.SILENT);\n  }\n\n  handleComposition() {\n    this.root.addEventListener('compositionstart', () => {\n      this.composing = true;\n      this.scroll.batchStart();\n    });\n    this.root.addEventListener('compositionend', () => {\n      this.scroll.batchEnd();\n      this.composing = false;\n\n      if (this.cursor.parent) {\n        const range = this.cursor.restore();\n        if (!range) return;\n        setTimeout(() => {\n          this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);\n        }, 1);\n      }\n    });\n  }\n\n  handleDragging() {\n    this.emitter.listenDOM('mousedown', document.body, () => {\n      this.mouseDown = true;\n    });\n    this.emitter.listenDOM('mouseup', document.body, () => {\n      this.mouseDown = false;\n      this.update(_emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].sources.USER);\n    });\n  }\n\n  focus() {\n    if (this.hasFocus()) return;\n    this.root.focus();\n    this.setRange(this.savedRange);\n  }\n\n  format(format, value) {\n    this.scroll.update();\n    const nativeRange = this.getNativeRange();\n    if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].BLOCK)) return;\n\n    if (nativeRange.start.node !== this.cursor.textNode) {\n      const blot = this.scroll.find(nativeRange.start.node, false);\n      if (blot == null) return; // TODO Give blot ability to not split\n\n      if (blot instanceof parchment__WEBPACK_IMPORTED_MODULE_0__[\"LeafBlot\"]) {\n        const after = blot.split(nativeRange.start.offset);\n        blot.parent.insertBefore(this.cursor, after);\n      } else {\n        blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen\n      }\n\n      this.cursor.attach();\n    }\n\n    this.cursor.format(format, value);\n    this.scroll.optimize();\n    this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);\n    this.update();\n  }\n\n  getBounds(index) {\n    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;\n    const scrollLength = this.scroll.length();\n    index = Math.min(index, scrollLength - 1);\n    length = Math.min(index + length, scrollLength - 1) - index;\n    let node;\n\n    let _this$scroll$leaf = this.scroll.leaf(index),\n        _this$scroll$leaf2 = _slicedToArray(_this$scroll$leaf, 2),\n        leaf = _this$scroll$leaf2[0],\n        offset = _this$scroll$leaf2[1];\n\n    if (leaf == null) return null;\n\n    var _leaf$position = leaf.position(offset, true);\n\n    var _leaf$position2 = _slicedToArray(_leaf$position, 2);\n\n    node = _leaf$position2[0];\n    offset = _leaf$position2[1];\n    const range = document.createRange();\n\n    if (length > 0) {\n      range.setStart(node, offset);\n\n      var _this$scroll$leaf3 = this.scroll.leaf(index + length);\n\n      var _this$scroll$leaf4 = _slicedToArray(_this$scroll$leaf3, 2);\n\n      leaf = _this$scroll$leaf4[0];\n      offset = _this$scroll$leaf4[1];\n      if (leaf == null) return null;\n\n      var _leaf$position3 = leaf.position(offset, true);\n\n      var _leaf$position4 = _slicedToArray(_leaf$position3, 2);\n\n      node = _leaf$position4[0];\n      offset = _leaf$position4[1];\n      range.setEnd(node, offset);\n      return range.getBoundingClientRect();\n    }\n\n    let side = 'left';\n    let rect;\n\n    if (node instanceof Text) {\n      if (offset < node.data.length) {\n        range.setStart(node, offset);\n        range.setEnd(node, offset + 1);\n      } else {\n        range.setStart(node, offset - 1);\n        range.setEnd(node, offset);\n        side = 'right';\n      }\n\n      rect = range.getBoundingClientRect();\n    } else {\n      rect = leaf.domNode.getBoundingClientRect();\n      if (offset > 0) side = 'right';\n    }\n\n    return {\n      bottom: rect.top + rect.height,\n      height: rect.height,\n      left: rect[side],\n      right: rect[side],\n      top: rect.top,\n      width: 0\n    };\n  }\n\n  getNativeRange() {\n    const nativeRange = Object(_shadow_selection_polyfill__WEBPACK_IMPORTED_MODULE_5__[\"getRange\"])(this.rootDocument);\n    if (nativeRange == null) return null;\n    const range = this.normalizeNative(nativeRange);\n    debug.info('getNativeRange', range);\n    return range;\n  }\n\n  getRange() {\n    const normalized = this.getNativeRange();\n    if (normalized == null) return [null, null];\n    const range = this.normalizedToRange(normalized);\n    return [range, normalized];\n  }\n\n  hasFocus() {\n    return this.rootDocument.activeElement === this.root;\n  }\n\n  normalizedToRange(range) {\n    const positions = [[range.start.node, range.start.offset]];\n\n    if (!range.native.collapsed) {\n      positions.push([range.end.node, range.end.offset]);\n    }\n\n    const indexes = positions.map(position => {\n      const _position = _slicedToArray(position, 2),\n            node = _position[0],\n            offset = _position[1];\n\n      const blot = this.scroll.find(node, true);\n      const index = blot.offset(this.scroll);\n\n      if (offset === 0) {\n        return index;\n      }\n\n      if (blot instanceof parchment__WEBPACK_IMPORTED_MODULE_0__[\"LeafBlot\"]) {\n        return index + blot.index(node, offset);\n      }\n\n      return index + blot.length();\n    });\n    const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);\n    const start = Math.min(end, ...indexes);\n    return new Range(start, end - start);\n  }\n\n  normalizeNative(nativeRange) {\n    if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {\n      return null;\n    }\n\n    const range = {\n      start: {\n        node: nativeRange.startContainer,\n        offset: nativeRange.startOffset\n      },\n      end: {\n        node: nativeRange.endContainer,\n        offset: nativeRange.endOffset\n      },\n      native: nativeRange\n    };\n    [range.start, range.end].forEach(position => {\n      let node = position.node,\n          offset = position.offset;\n\n      while (!(node instanceof Text) && node.childNodes.length > 0) {\n        if (node.childNodes.length > offset) {\n          node = node.childNodes[offset];\n          offset = 0;\n        } else if (node.childNodes.length === offset) {\n          node = node.lastChild;\n\n          if (node instanceof Text) {\n            offset = node.data.length;\n          } else if (node.childNodes.length > 0) {\n            // Container case\n            offset = node.childNodes.length;\n          } else {\n            // Embed case\n            offset = node.childNodes.length + 1;\n          }\n        } else {\n          break;\n        }\n      }\n\n      position.node = node;\n      position.offset = offset;\n    });\n    return range;\n  }\n\n  rangeToNative(range) {\n    const indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];\n    const args = [];\n    const scrollLength = this.scroll.length();\n    indexes.forEach((index, i) => {\n      index = Math.min(scrollLength - 1, index);\n\n      const _this$scroll$leaf5 = this.scroll.leaf(index),\n            _this$scroll$leaf6 = _slicedToArray(_this$scroll$leaf5, 2),\n            leaf = _this$scroll$leaf6[0],\n            leafOffset = _this$scroll$leaf6[1];\n\n      const _leaf$position5 = leaf.position(leafOffset, i !== 0),\n            _leaf$position6 = _slicedToArray(_leaf$position5, 2),\n            node = _leaf$position6[0],\n            offset = _leaf$position6[1];\n\n      args.push(node, offset);\n    });\n\n    if (args.length < 2) {\n      return args.concat(args);\n    }\n\n    return args;\n  }\n\n  scrollIntoView(scrollingContainer) {\n    const range = this.lastRange;\n    if (range == null) return;\n    const bounds = this.getBounds(range.index, range.length);\n    if (bounds == null) return;\n    const limit = this.scroll.length() - 1;\n\n    const _this$scroll$line = this.scroll.line(Math.min(range.index, limit)),\n          _this$scroll$line2 = _slicedToArray(_this$scroll$line, 1),\n          first = _this$scroll$line2[0];\n\n    let last = first;\n\n    if (range.length > 0) {\n      var _this$scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));\n\n      var _this$scroll$line4 = _slicedToArray(_this$scroll$line3, 1);\n\n      last = _this$scroll$line4[0];\n    }\n\n    if (first == null || last == null) return;\n    const scrollBounds = scrollingContainer.getBoundingClientRect();\n\n    if (bounds.top < scrollBounds.top) {\n      scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;\n    } else if (bounds.bottom > scrollBounds.bottom) {\n      scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;\n    }\n  }\n\n  setNativeRange(startNode, startOffset) {\n    let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;\n    let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;\n    let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;\n    debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);\n\n    if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {\n      return;\n    }\n\n    const selection = typeof this.rootDocument.getSelection === 'function' ? this.rootDocument.getSelection() : document.getSelection();\n    if (selection == null) return;\n\n    if (startNode != null) {\n      if (!this.hasFocus()) this.root.focus();\n\n      const _ref = this.getNativeRange() || {},\n            native = _ref.native;\n\n      if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {\n        if (startNode.tagName === 'BR') {\n          startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);\n          startNode = startNode.parentNode;\n        }\n\n        if (endNode.tagName === 'BR') {\n          endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);\n          endNode = endNode.parentNode;\n        }\n\n        const range = document.createRange();\n        range.setStart(startNode, startOffset);\n        range.setEnd(endNode, endOffset);\n        selection.removeAllRanges();\n        selection.addRange(range);\n      }\n    } else {\n      selection.removeAllRanges();\n      this.root.blur();\n    }\n  }\n\n  setRange(range) {\n    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n    let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].sources.API;\n\n    if (typeof force === 'string') {\n      source = force;\n      force = false;\n    }\n\n    debug.info('setRange', range);\n\n    if (range != null) {\n      const args = this.rangeToNative(range);\n      this.setNativeRange(...args, force);\n    } else {\n      this.setNativeRange(null);\n    }\n\n    this.update(source);\n  }\n\n  update() {\n    let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].sources.USER;\n    const oldRange = this.lastRange;\n\n    const _this$getRange = this.getRange(),\n          _this$getRange2 = _slicedToArray(_this$getRange, 2),\n          lastRange = _this$getRange2[0],\n          nativeRange = _this$getRange2[1];\n\n    this.lastRange = lastRange;\n\n    if (this.lastRange != null) {\n      this.savedRange = this.lastRange;\n    }\n\n    if (!deep_equal__WEBPACK_IMPORTED_MODULE_2___default()(oldRange, this.lastRange)) {\n      if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {\n        const range = this.cursor.restore();\n\n        if (range) {\n          this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);\n        }\n      }\n\n      const args = [_emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].events.SELECTION_CHANGE, clone__WEBPACK_IMPORTED_MODULE_1___default()(this.lastRange), clone__WEBPACK_IMPORTED_MODULE_1___default()(oldRange), source];\n      this.emitter.emit(_emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].events.EDITOR_CHANGE, ...args);\n\n      if (source !== _emitter__WEBPACK_IMPORTED_MODULE_3__[\"default\"].sources.SILENT) {\n        this.emitter.emit(...args);\n      }\n    }\n  }\n\n}\n\nfunction contains(parent, descendant) {\n  try {\n    // Firefox inserts inaccessible nodes around video elements\n    descendant.parentNode; // eslint-disable-line no-unused-expressions\n  } catch (e) {\n    return false;\n  }\n\n  return parent.contains(descendant);\n}\n\n\n\n//# sourceURL=webpack://Quill/./core/selection.js?");

/***/ }),

/***/ "./core/shadow-selection-polyfill.js":
/*!*******************************************!*\
  !*** ./core/shadow-selection-polyfill.js ***!
  \*******************************************/
/*! exports provided: SHADOW_SELECTIONCHANGE, getRange, internalGetShadowSelection */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"SHADOW_SELECTIONCHANGE\", function() { return SHADOW_SELECTIONCHANGE; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"getRange\", function() { return getRange; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"internalGetShadowSelection\", function() { return internalGetShadowSelection; });\n/* eslint-disable no-cond-assign */\n\n/* eslint-disable no-plusplus */\n\n/**\n * Copyright 2018 Google LLC\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\"); you may not\n * use this file except in compliance with the License. You may obtain a copy of\n * the License at\n *\n *     http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS, WITHOUT\n * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the\n * License for the specific language governing permissions and limitations under\n * the License.\n */\n// NOTE: copied from https://github.com/GoogleChromeLabs/shadow-selection-polyfill\nconst SHADOW_SELECTIONCHANGE = '-shadow-selectionchange';\nconst hasShadow = 'attachShadow' in Element.prototype && 'getRootNode' in Element.prototype;\nconst hasSelection = !!(hasShadow && document.createElement('div').attachShadow({\n  mode: 'open'\n}).getSelection);\nconst hasShady = window.ShadyDOM && window.ShadyDOM.inUse;\nconst isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;\nconst useDocument = !hasShadow || hasShady || !hasSelection && !isSafari;\nconst validNodeTypes = [Node.ELEMENT_NODE, Node.TEXT_NODE, Node.DOCUMENT_FRAGMENT_NODE];\n\nfunction isValidNode(node) {\n  return validNodeTypes.includes(node.nodeType);\n}\n\nfunction findNode(s, parentNode, isLeft) {\n  const nodes = parentNode.childNodes || parentNode.children;\n\n  if (!nodes) {\n    return parentNode; // found it, probably text\n  }\n\n  for (let i = 0; i < nodes.length; ++i) {\n    const j = isLeft ? i : nodes.length - 1 - i;\n    const childNode = nodes[j];\n\n    if (!isValidNode(childNode)) {\n      continue; // eslint-disable-line no-continue\n    }\n\n    if (s.containsNode(childNode, true)) {\n      if (s.containsNode(childNode, false)) {\n        return childNode;\n      }\n\n      return findNode(s, childNode, isLeft);\n    }\n  }\n\n  return parentNode;\n}\n/**\n * @param {function(!Event)} fn to add to selectionchange internals\n */\n\n\nconst addInternalListener = (() => {\n  if (hasSelection || useDocument) {\n    // getSelection exists or document API can be used\n    document.addEventListener('selectionchange', () => {\n      document.dispatchEvent(new CustomEvent(SHADOW_SELECTIONCHANGE));\n    });\n    return () => {};\n  }\n\n  let withinInternals = false;\n  const handlers = [];\n  document.addEventListener('selectionchange', ev => {\n    if (withinInternals) {\n      return;\n    }\n\n    document.dispatchEvent(new CustomEvent(SHADOW_SELECTIONCHANGE));\n    withinInternals = true;\n    window.setTimeout(() => {\n      withinInternals = false;\n    }, 2); // FIXME: should be > 1 to prevent infinite Selection.update() loop\n\n    handlers.forEach(fn => fn(ev));\n  });\n  return fn => handlers.push(fn);\n})();\n\nlet wasCaret = false;\nlet resolveTask = null;\naddInternalListener(() => {\n  const s = window.getSelection();\n\n  if (s.type === 'Caret') {\n    wasCaret = true;\n  } else if (wasCaret && !resolveTask) {\n    resolveTask = Promise.resolve(true).then(() => {\n      wasCaret = false;\n      resolveTask = null;\n    });\n  }\n});\n/**\n * @param {!Selection} s the window selection to use\n * @param {!Node} node the node to walk from\n * @param {boolean} walkForward should this walk in natural direction\n * @return {boolean} whether the selection contains the following node (even partially)\n */\n\nfunction containsNextElement(s, node, walkForward) {\n  const start = node;\n\n  while (node = walkFromNode(node, walkForward)) {\n    // eslint-disable-line no-cond-assign\n    // walking (left) can contain our own parent, which we don't want\n    if (!node.contains(start)) {\n      break;\n    }\n  }\n\n  if (!node) {\n    return false;\n  } // we look for Element as .containsNode says true for _every_ text node, and we only care about\n  // elements themselves\n\n\n  return node instanceof Element && s.containsNode(node, true);\n}\n/**\n * @param {!Selection} s the window selection to use\n * @param {!Node} leftNode the left node\n * @param {!Node} rightNode the right node\n * @return {boolean|undefined} whether this has natural direction\n */\n\n\nfunction getSelectionDirection(s, leftNode, rightNode) {\n  if (s.type !== 'Range') {\n    return undefined; // no direction\n  }\n\n  const measure = () => s.toString().length;\n\n  const initialSize = measure();\n\n  if (initialSize === 1 && wasCaret && leftNode === rightNode) {\n    // nb. We need to reset a single selection as Safari _always_ tells us the cursor was dragged\n    // left to right (maybe RTL on those devices).\n    // To be fair, Chrome has the same bug.\n    s.extend(leftNode, 0);\n    s.collapseToEnd();\n    return undefined;\n  }\n\n  let updatedSize; // Try extending forward and seeing what happens.\n\n  s.modify('extend', 'forward', 'character');\n  updatedSize = measure();\n\n  if (updatedSize > initialSize || containsNextElement(s, rightNode, true)) {\n    s.modify('extend', 'backward', 'character');\n    return true;\n  }\n\n  if (updatedSize < initialSize || !s.containsNode(leftNode)) {\n    s.modify('extend', 'backward', 'character');\n    return false;\n  } // Maybe we were at the end of something. Extend backwards.\n  // TODO(samthor): We seem to be able to get away without the 'backwards' case.\n\n\n  s.modify('extend', 'backward', 'character');\n  updatedSize = measure();\n\n  if (updatedSize > initialSize || containsNextElement(s, leftNode, false)) {\n    s.modify('extend', 'forward', 'character');\n    return false;\n  }\n\n  if (updatedSize < initialSize || !s.containsNode(rightNode)) {\n    s.modify('extend', 'forward', 'character');\n    return true;\n  } // This is likely a select-all.\n\n\n  return undefined;\n}\n/**\n * Returns the next valid node (element or text). This is needed as Safari doesn't support\n * TreeWalker inside Shadow DOM. Don't escape shadow roots.\n *\n * @param {!Node} node to start from\n * @param {boolean} walkForward should this walk in natural direction\n * @return {Node} node found, if any\n */\n\n\nfunction walkFromNode(node, walkForward) {\n  if (!walkForward) {\n    return node.previousSibling || node.parentNode || null;\n  }\n\n  while (node) {\n    if (node.nextSibling) {\n      return node.nextSibling;\n    }\n\n    node = node.parentNode;\n  }\n\n  return null;\n}\n/**\n * @param {!Node} node to check for initial space\n * @return {number} count of initial space\n */\n\n\nfunction initialSpace(node) {\n  if (node.nodeType !== Node.TEXT_NODE) {\n    return 0;\n  }\n\n  return /^\\s*/.exec(node.textContent)[0].length;\n}\n/**\n * @param {!Node} node to check for trailing space\n * @return {number} count of ignored trailing space\n */\n\n\nfunction ignoredTrailingSpace(node) {\n  if (node.nodeType !== Node.TEXT_NODE) {\n    return 0;\n  }\n\n  const trailingSpaceCount = /\\s*$/.exec(node.textContent)[0].length;\n\n  if (!trailingSpaceCount) {\n    return 0;\n  }\n\n  return trailingSpaceCount - 1; // always allow single last\n}\n\nconst cachedRange = new Map();\nfunction getRange(root) {\n  if (hasSelection || useDocument) {\n    const s = (useDocument ? document : root).getSelection();\n    return s.rangeCount ? s.getRangeAt(0) : null;\n  }\n\n  const thisFrame = cachedRange.get(root);\n\n  if (thisFrame) {\n    return thisFrame;\n  }\n\n  const result = internalGetShadowSelection(root);\n  cachedRange.set(root, result.range);\n  window.setTimeout(() => {\n    cachedRange.delete(root);\n  }, 0);\n  return result.range;\n}\nconst fakeSelectionNode = document.createTextNode('');\nfunction internalGetShadowSelection(root) {\n  const range = document.createRange();\n  const s = window.getSelection();\n\n  if (!s.containsNode(root.host, true)) {\n    return {\n      range: null,\n      mode: 'none'\n    };\n  } // TODO: inserting fake nodes isn't ideal, but containsNode doesn't work on nearby adjacent\n  // text nodes (in fact it returns true for all text nodes on the page?!).\n  // insert a fake 'before' node to see if it's selected\n\n\n  root.insertBefore(fakeSelectionNode, root.childNodes[0]);\n  const includesBeforeRoot = s.containsNode(fakeSelectionNode);\n  fakeSelectionNode.remove();\n\n  if (includesBeforeRoot) {\n    return {\n      range: null,\n      mode: 'outside-before'\n    };\n  } // insert a fake 'after' node to see if it's selected\n\n\n  root.appendChild(fakeSelectionNode);\n  const includesAfterRoot = s.containsNode(fakeSelectionNode);\n  fakeSelectionNode.remove();\n\n  if (includesAfterRoot) {\n    return {\n      range: null,\n      mode: 'outside-after'\n    };\n  }\n\n  const measure = () => s.toString().length;\n\n  if (!(s.type === 'Caret' || s.type === 'Range')) {\n    throw new TypeError(\"unexpected type: \".concat(s.type));\n  }\n\n  const leftNode = findNode(s, root, true);\n  let rightNode;\n  let isNaturalDirection;\n\n  if (s.type === 'Range') {\n    rightNode = findNode(s, root, false); // get right node here _before_ getSelectionDirection\n\n    isNaturalDirection = getSelectionDirection(s, leftNode, rightNode); // isNaturalDirection means \"going right\"\n  }\n\n  if (s.type === 'Caret') {\n    // we might transition to being a caret, so don't check initial value\n    s.extend(leftNode, 0);\n    const at = measure();\n    s.collapseToEnd();\n    range.setStart(leftNode, at);\n    range.setEnd(leftNode, at);\n    return {\n      range,\n      mode: 'caret'\n    };\n  }\n\n  if (isNaturalDirection === undefined) {\n    if (s.type !== 'Range') {\n      throw new TypeError(\"unexpected type: \".concat(s.type));\n    } // This occurs when we can't move because we can't extend left or right to measure the\n    // direction we're moving in. Good news though: we don't need to _change_ the selection\n    // to measure it, so just return immediately.\n\n\n    range.setStart(leftNode, 0);\n    range.setEnd(rightNode, rightNode.length);\n    return {\n      range,\n      mode: 'all'\n    };\n  }\n\n  const size = measure();\n  let offsetLeft;\n  let offsetRight; // only one newline/space char is cared about\n\n  const validRightLength = rightNode.length - ignoredTrailingSpace(rightNode);\n\n  if (isNaturalDirection) {\n    // walk in the opposite direction first\n    s.extend(leftNode, 0);\n    offsetLeft = measure() + initialSpace(leftNode); // measure doesn't include initial space\n    // then in our actual direction\n\n    s.extend(rightNode, validRightLength);\n    offsetRight = validRightLength - (measure() - size); // then revert to the original position\n\n    s.extend(rightNode, offsetRight);\n  } else {\n    // walk in the opposite direction first\n    s.extend(rightNode, validRightLength);\n    offsetRight = validRightLength - measure(); // then in our actual direction\n\n    s.extend(leftNode, 0);\n    offsetLeft = measure() - size + initialSpace(leftNode); // doesn't include initial space\n    // then revert to the original position\n\n    s.extend(leftNode, offsetLeft);\n  }\n\n  range.setStart(leftNode, offsetLeft);\n  range.setEnd(rightNode, offsetRight);\n  return {\n    mode: isNaturalDirection ? 'right' : 'left',\n    range\n  };\n}\n\n//# sourceURL=webpack://Quill/./core/shadow-selection-polyfill.js?");

/***/ }),

/***/ "./core/theme.js":
/*!***********************!*\
  !*** ./core/theme.js ***!
  \***********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\nclass Theme {\n  constructor(quill, options) {\n    this.quill = quill;\n    this.options = options;\n    this.modules = {};\n  }\n\n  init() {\n    Object.keys(this.options.modules).forEach(name => {\n      if (this.modules[name] == null) {\n        this.addModule(name);\n      }\n    });\n  }\n\n  addModule(name) {\n    const ModuleClass = this.quill.constructor.import(\"modules/\".concat(name));\n    this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});\n    return this.modules[name];\n  }\n\n}\n\nTheme.DEFAULTS = {\n  modules: {}\n};\nTheme.themes = {\n  default: Theme\n};\n/* harmony default export */ __webpack_exports__[\"default\"] = (Theme);\n\n//# sourceURL=webpack://Quill/./core/theme.js?");

/***/ }),

/***/ "./formats/align.js":
/*!**************************!*\
  !*** ./formats/align.js ***!
  \**************************/
/*! exports provided: AlignAttribute, AlignClass, AlignStyle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"AlignAttribute\", function() { return AlignAttribute; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"AlignClass\", function() { return AlignClass; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"AlignStyle\", function() { return AlignStyle; });\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n\nconst config = {\n  scope: parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].BLOCK,\n  whitelist: ['right', 'center', 'justify']\n};\nconst AlignAttribute = new parchment__WEBPACK_IMPORTED_MODULE_0__[\"Attributor\"]('align', 'align', config);\nconst AlignClass = new parchment__WEBPACK_IMPORTED_MODULE_0__[\"ClassAttributor\"]('align', 'ql-align', config);\nconst AlignStyle = new parchment__WEBPACK_IMPORTED_MODULE_0__[\"StyleAttributor\"]('align', 'text-align', config);\n\n\n//# sourceURL=webpack://Quill/./formats/align.js?");

/***/ }),

/***/ "./formats/background.js":
/*!*******************************!*\
  !*** ./formats/background.js ***!
  \*******************************/
/*! exports provided: BackgroundClass, BackgroundStyle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"BackgroundClass\", function() { return BackgroundClass; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"BackgroundStyle\", function() { return BackgroundStyle; });\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./color */ \"./formats/color.js\");\n\n\nconst BackgroundClass = new parchment__WEBPACK_IMPORTED_MODULE_0__[\"ClassAttributor\"]('background', 'ql-bg', {\n  scope: parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].INLINE\n});\nconst BackgroundStyle = new _color__WEBPACK_IMPORTED_MODULE_1__[\"ColorAttributor\"]('background', 'background-color', {\n  scope: parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].INLINE\n});\n\n\n//# sourceURL=webpack://Quill/./formats/background.js?");

/***/ }),

/***/ "./formats/blockquote.js":
/*!*******************************!*\
  !*** ./formats/blockquote.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _blots_block__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../blots/block */ \"./blots/block.js\");\n\n\nclass Blockquote extends _blots_block__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {}\n\nBlockquote.blotName = 'blockquote';\nBlockquote.tagName = 'blockquote';\n/* harmony default export */ __webpack_exports__[\"default\"] = (Blockquote);\n\n//# sourceURL=webpack://Quill/./formats/blockquote.js?");

/***/ }),

/***/ "./formats/bold.js":
/*!*************************!*\
  !*** ./formats/bold.js ***!
  \*************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _blots_inline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../blots/inline */ \"./blots/inline.js\");\n\n\nclass Bold extends _blots_inline__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n  static create() {\n    return super.create();\n  }\n\n  static formats() {\n    return true;\n  }\n\n  optimize(context) {\n    super.optimize(context);\n\n    if (this.domNode.tagName !== this.statics.tagName[0]) {\n      this.replaceWith(this.statics.blotName);\n    }\n  }\n\n}\n\nBold.blotName = 'bold';\nBold.tagName = ['STRONG', 'B'];\n/* harmony default export */ __webpack_exports__[\"default\"] = (Bold);\n\n//# sourceURL=webpack://Quill/./formats/bold.js?");

/***/ }),

/***/ "./formats/code.js":
/*!*************************!*\
  !*** ./formats/code.js ***!
  \*************************/
/*! exports provided: Code, CodeBlockContainer, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"Code\", function() { return Code; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"CodeBlockContainer\", function() { return CodeBlockContainer; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return CodeBlock; });\n/* harmony import */ var _blots_block__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../blots/block */ \"./blots/block.js\");\n/* harmony import */ var _blots_break__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../blots/break */ \"./blots/break.js\");\n/* harmony import */ var _blots_cursor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../blots/cursor */ \"./blots/cursor.js\");\n/* harmony import */ var _blots_inline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../blots/inline */ \"./blots/inline.js\");\n/* harmony import */ var _blots_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../blots/text */ \"./blots/text.js\");\n/* harmony import */ var _blots_container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../blots/container */ \"./blots/container.js\");\n/* harmony import */ var _core_quill__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../core/quill */ \"./core/quill.js\");\n\n\n\n\n\n\n\n\nclass CodeBlockContainer extends _blots_container__WEBPACK_IMPORTED_MODULE_5__[\"default\"] {\n  static create(value) {\n    const domNode = super.create(value);\n    domNode.setAttribute('spellcheck', false);\n    return domNode;\n  }\n\n  html(index, length) {\n    const text = this.children.map(child => child.domNode.innerText).join('\\n').slice(index, index + length);\n    return \"<pre>\".concat(Object(_blots_text__WEBPACK_IMPORTED_MODULE_4__[\"escapeText\"])(text), \"</pre>\");\n  }\n\n}\n\nclass CodeBlock extends _blots_block__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n  static register() {\n    _core_quill__WEBPACK_IMPORTED_MODULE_6__[\"default\"].register(CodeBlockContainer);\n  }\n\n}\n\nclass Code extends _blots_inline__WEBPACK_IMPORTED_MODULE_3__[\"default\"] {}\n\nCode.blotName = 'code';\nCode.tagName = 'CODE';\nCodeBlock.blotName = 'code-block';\nCodeBlock.className = 'ql-code-block';\nCodeBlock.tagName = 'DIV';\nCodeBlockContainer.blotName = 'code-block-container';\nCodeBlockContainer.className = 'ql-code-block-container';\nCodeBlockContainer.tagName = 'DIV';\nCodeBlockContainer.allowedChildren = [CodeBlock];\nCodeBlock.allowedChildren = [_blots_text__WEBPACK_IMPORTED_MODULE_4__[\"default\"], _blots_break__WEBPACK_IMPORTED_MODULE_1__[\"default\"], _blots_cursor__WEBPACK_IMPORTED_MODULE_2__[\"default\"]];\nCodeBlock.requiredContainer = CodeBlockContainer;\nCodeBlock.TAB = '  ';\n\n\n//# sourceURL=webpack://Quill/./formats/code.js?");

/***/ }),

/***/ "./formats/color.js":
/*!**************************!*\
  !*** ./formats/color.js ***!
  \**************************/
/*! exports provided: ColorAttributor, ColorClass, ColorStyle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"ColorAttributor\", function() { return ColorAttributor; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"ColorClass\", function() { return ColorClass; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"ColorStyle\", function() { return ColorStyle; });\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n\n\nclass ColorAttributor extends parchment__WEBPACK_IMPORTED_MODULE_0__[\"StyleAttributor\"] {\n  value(domNode) {\n    let value = super.value(domNode);\n    if (!value.startsWith('rgb(')) return value;\n    value = value.replace(/^[^\\d]+/, '').replace(/[^\\d]+$/, '');\n    const hex = value.split(',').map(component => \"00\".concat(parseInt(component, 10).toString(16)).slice(-2)).join('');\n    return \"#\".concat(hex);\n  }\n\n}\n\nconst ColorClass = new parchment__WEBPACK_IMPORTED_MODULE_0__[\"ClassAttributor\"]('color', 'ql-color', {\n  scope: parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].INLINE\n});\nconst ColorStyle = new ColorAttributor('color', 'color', {\n  scope: parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].INLINE\n});\n\n\n//# sourceURL=webpack://Quill/./formats/color.js?");

/***/ }),

/***/ "./formats/direction.js":
/*!******************************!*\
  !*** ./formats/direction.js ***!
  \******************************/
/*! exports provided: DirectionAttribute, DirectionClass, DirectionStyle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"DirectionAttribute\", function() { return DirectionAttribute; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"DirectionClass\", function() { return DirectionClass; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"DirectionStyle\", function() { return DirectionStyle; });\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n\nconst config = {\n  scope: parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].BLOCK,\n  whitelist: ['rtl']\n};\nconst DirectionAttribute = new parchment__WEBPACK_IMPORTED_MODULE_0__[\"Attributor\"]('direction', 'dir', config);\nconst DirectionClass = new parchment__WEBPACK_IMPORTED_MODULE_0__[\"ClassAttributor\"]('direction', 'ql-direction', config);\nconst DirectionStyle = new parchment__WEBPACK_IMPORTED_MODULE_0__[\"StyleAttributor\"]('direction', 'direction', config);\n\n\n//# sourceURL=webpack://Quill/./formats/direction.js?");

/***/ }),

/***/ "./formats/font.js":
/*!*************************!*\
  !*** ./formats/font.js ***!
  \*************************/
/*! exports provided: FontStyle, FontClass */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"FontStyle\", function() { return FontStyle; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"FontClass\", function() { return FontClass; });\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n\nconst config = {\n  scope: parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].INLINE,\n  whitelist: ['serif', 'monospace']\n};\nconst FontClass = new parchment__WEBPACK_IMPORTED_MODULE_0__[\"ClassAttributor\"]('font', 'ql-font', config);\n\nclass FontStyleAttributor extends parchment__WEBPACK_IMPORTED_MODULE_0__[\"StyleAttributor\"] {\n  value(node) {\n    return super.value(node).replace(/[\"']/g, '');\n  }\n\n}\n\nconst FontStyle = new FontStyleAttributor('font', 'font-family', config);\n\n\n//# sourceURL=webpack://Quill/./formats/font.js?");

/***/ }),

/***/ "./formats/formula.js":
/*!****************************!*\
  !*** ./formats/formula.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _blots_embed__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../blots/embed */ \"./blots/embed.js\");\n\n\nclass Formula extends _blots_embed__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n  static create(value) {\n    if (window.katex == null) {\n      throw new Error('Formula module requires KaTeX.');\n    }\n\n    const node = super.create(value);\n\n    if (typeof value === 'string') {\n      window.katex.render(value, node, {\n        throwOnError: false,\n        errorColor: '#f00'\n      });\n      node.setAttribute('data-value', value);\n    }\n\n    return node;\n  }\n\n  static value(domNode) {\n    return domNode.getAttribute('data-value');\n  }\n\n  html() {\n    const _this$value = this.value(),\n          formula = _this$value.formula;\n\n    return \"<span>\".concat(formula, \"</span>\");\n  }\n\n}\n\nFormula.blotName = 'formula';\nFormula.className = 'ql-formula';\nFormula.tagName = 'SPAN';\n/* harmony default export */ __webpack_exports__[\"default\"] = (Formula);\n\n//# sourceURL=webpack://Quill/./formats/formula.js?");

/***/ }),

/***/ "./formats/header.js":
/*!***************************!*\
  !*** ./formats/header.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _blots_block__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../blots/block */ \"./blots/block.js\");\n\n\nclass Header extends _blots_block__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n  static formats(domNode) {\n    return this.tagName.indexOf(domNode.tagName) + 1;\n  }\n\n}\n\nHeader.blotName = 'header';\nHeader.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];\n/* harmony default export */ __webpack_exports__[\"default\"] = (Header);\n\n//# sourceURL=webpack://Quill/./formats/header.js?");

/***/ }),

/***/ "./formats/image.js":
/*!**************************!*\
  !*** ./formats/image.js ***!
  \**************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./link */ \"./formats/link.js\");\n\n\nconst ATTRIBUTES = ['alt', 'height', 'width'];\n\nclass Image extends parchment__WEBPACK_IMPORTED_MODULE_0__[\"EmbedBlot\"] {\n  static create(value) {\n    const node = super.create(value);\n\n    if (typeof value === 'string') {\n      node.setAttribute('src', this.sanitize(value));\n    }\n\n    return node;\n  }\n\n  static formats(domNode) {\n    return ATTRIBUTES.reduce((formats, attribute) => {\n      if (domNode.hasAttribute(attribute)) {\n        formats[attribute] = domNode.getAttribute(attribute);\n      }\n\n      return formats;\n    }, {});\n  }\n\n  static match(url) {\n    return /\\.(jpe?g|gif|png)$/.test(url) || /^data:image\\/.+;base64/.test(url);\n  }\n\n  static register() {\n    if (/Firefox/i.test(navigator.userAgent)) {\n      setTimeout(() => {\n        // Disable image resizing in Firefox\n        document.execCommand('enableObjectResizing', false, false);\n      }, 1);\n    }\n  }\n\n  static sanitize(url) {\n    return Object(_link__WEBPACK_IMPORTED_MODULE_1__[\"sanitize\"])(url, ['http', 'https', 'data']) ? url : '//:0';\n  }\n\n  static value(domNode) {\n    return domNode.getAttribute('src');\n  }\n\n  format(name, value) {\n    if (ATTRIBUTES.indexOf(name) > -1) {\n      if (value) {\n        this.domNode.setAttribute(name, value);\n      } else {\n        this.domNode.removeAttribute(name);\n      }\n    } else {\n      super.format(name, value);\n    }\n  }\n\n}\n\nImage.blotName = 'image';\nImage.tagName = 'IMG';\n/* harmony default export */ __webpack_exports__[\"default\"] = (Image);\n\n//# sourceURL=webpack://Quill/./formats/image.js?");

/***/ }),

/***/ "./formats/indent.js":
/*!***************************!*\
  !*** ./formats/indent.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n\n\nclass IndentAttributor extends parchment__WEBPACK_IMPORTED_MODULE_0__[\"ClassAttributor\"] {\n  add(node, value) {\n    if (value === '+1' || value === '-1') {\n      const indent = this.value(node) || 0;\n      value = value === '+1' ? indent + 1 : indent - 1;\n    }\n\n    if (value === 0) {\n      this.remove(node);\n      return true;\n    }\n\n    return super.add(node, value);\n  }\n\n  canAdd(node, value) {\n    return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));\n  }\n\n  value(node) {\n    return parseInt(super.value(node), 10) || undefined; // Don't return NaN\n  }\n\n}\n\nconst IndentClass = new IndentAttributor('indent', 'ql-indent', {\n  scope: parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].BLOCK,\n  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]\n});\n/* harmony default export */ __webpack_exports__[\"default\"] = (IndentClass);\n\n//# sourceURL=webpack://Quill/./formats/indent.js?");

/***/ }),

/***/ "./formats/italic.js":
/*!***************************!*\
  !*** ./formats/italic.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _bold__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bold */ \"./formats/bold.js\");\n\n\nclass Italic extends _bold__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {}\n\nItalic.blotName = 'italic';\nItalic.tagName = ['EM', 'I'];\n/* harmony default export */ __webpack_exports__[\"default\"] = (Italic);\n\n//# sourceURL=webpack://Quill/./formats/italic.js?");

/***/ }),

/***/ "./formats/link.js":
/*!*************************!*\
  !*** ./formats/link.js ***!
  \*************************/
/*! exports provided: default, sanitize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Link; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"sanitize\", function() { return sanitize; });\n/* harmony import */ var _blots_inline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../blots/inline */ \"./blots/inline.js\");\n\n\nclass Link extends _blots_inline__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n  static create(value) {\n    const node = super.create(value);\n    node.setAttribute('href', this.sanitize(value));\n    node.setAttribute('rel', 'noopener noreferrer');\n    node.setAttribute('target', '_blank');\n    return node;\n  }\n\n  static formats(domNode) {\n    return domNode.getAttribute('href');\n  }\n\n  static sanitize(url) {\n    return sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;\n  }\n\n  format(name, value) {\n    if (name !== this.statics.blotName || !value) {\n      super.format(name, value);\n    } else {\n      this.domNode.setAttribute('href', this.constructor.sanitize(value));\n    }\n  }\n\n}\n\nLink.blotName = 'link';\nLink.tagName = 'A';\nLink.SANITIZED_URL = 'about:blank';\nLink.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];\n\nfunction sanitize(url, protocols) {\n  const anchor = document.createElement('a');\n  anchor.href = url;\n  const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));\n  return protocols.indexOf(protocol) > -1;\n}\n\n\n\n//# sourceURL=webpack://Quill/./formats/link.js?");

/***/ }),

/***/ "./formats/list.js":
/*!*************************!*\
  !*** ./formats/list.js ***!
  \*************************/
/*! exports provided: ListContainer, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"ListContainer\", function() { return ListContainer; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return ListItem; });\n/* harmony import */ var _blots_block__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../blots/block */ \"./blots/block.js\");\n/* harmony import */ var _blots_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../blots/container */ \"./blots/container.js\");\n/* harmony import */ var _core_quill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/quill */ \"./core/quill.js\");\n\n\n\n\nclass ListContainer extends _blots_container__WEBPACK_IMPORTED_MODULE_1__[\"default\"] {}\n\nListContainer.blotName = 'list-container';\nListContainer.tagName = 'OL';\n\nclass ListItem extends _blots_block__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n  static create(value) {\n    const node = super.create();\n    node.setAttribute('data-list', value);\n    return node;\n  }\n\n  static formats(domNode) {\n    return domNode.getAttribute('data-list') || undefined;\n  }\n\n  static register() {\n    _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].register(ListContainer);\n  }\n\n  constructor(scroll, domNode) {\n    super(scroll, domNode);\n    const ui = domNode.ownerDocument.createElement('span');\n\n    const listEventHandler = e => {\n      if (!scroll.isEnabled()) return;\n      const format = this.statics.formats(domNode, scroll);\n\n      if (format === 'checked') {\n        this.format('list', 'unchecked');\n        e.preventDefault();\n      } else if (format === 'unchecked') {\n        this.format('list', 'checked');\n        e.preventDefault();\n      }\n    };\n\n    ui.addEventListener('mousedown', listEventHandler);\n    ui.addEventListener('touchstart', listEventHandler);\n    this.attachUI(ui);\n  }\n\n  format(name, value) {\n    if (name === this.statics.blotName && value) {\n      this.domNode.setAttribute('data-list', value);\n    } else {\n      super.format(name, value);\n    }\n  }\n\n}\n\nListItem.blotName = 'list';\nListItem.tagName = 'LI';\nListContainer.allowedChildren = [ListItem];\nListItem.requiredContainer = ListContainer;\n\n\n//# sourceURL=webpack://Quill/./formats/list.js?");

/***/ }),

/***/ "./formats/script.js":
/*!***************************!*\
  !*** ./formats/script.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _blots_inline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../blots/inline */ \"./blots/inline.js\");\n\n\nclass Script extends _blots_inline__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n  static create(value) {\n    if (value === 'super') {\n      return document.createElement('sup');\n    }\n\n    if (value === 'sub') {\n      return document.createElement('sub');\n    }\n\n    return super.create(value);\n  }\n\n  static formats(domNode) {\n    if (domNode.tagName === 'SUB') return 'sub';\n    if (domNode.tagName === 'SUP') return 'super';\n    return undefined;\n  }\n\n}\n\nScript.blotName = 'script';\nScript.tagName = ['SUB', 'SUP'];\n/* harmony default export */ __webpack_exports__[\"default\"] = (Script);\n\n//# sourceURL=webpack://Quill/./formats/script.js?");

/***/ }),

/***/ "./formats/size.js":
/*!*************************!*\
  !*** ./formats/size.js ***!
  \*************************/
/*! exports provided: SizeClass, SizeStyle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"SizeClass\", function() { return SizeClass; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"SizeStyle\", function() { return SizeStyle; });\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n\nconst SizeClass = new parchment__WEBPACK_IMPORTED_MODULE_0__[\"ClassAttributor\"]('size', 'ql-size', {\n  scope: parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].INLINE,\n  whitelist: ['small', 'large', 'huge']\n});\nconst SizeStyle = new parchment__WEBPACK_IMPORTED_MODULE_0__[\"StyleAttributor\"]('size', 'font-size', {\n  scope: parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].INLINE,\n  whitelist: ['10px', '18px', '32px']\n});\n\n\n//# sourceURL=webpack://Quill/./formats/size.js?");

/***/ }),

/***/ "./formats/strike.js":
/*!***************************!*\
  !*** ./formats/strike.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _bold__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bold */ \"./formats/bold.js\");\n\n\nclass Strike extends _bold__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {}\n\nStrike.blotName = 'strike';\nStrike.tagName = ['S', 'STRIKE'];\n/* harmony default export */ __webpack_exports__[\"default\"] = (Strike);\n\n//# sourceURL=webpack://Quill/./formats/strike.js?");

/***/ }),

/***/ "./formats/table.js":
/*!**************************!*\
  !*** ./formats/table.js ***!
  \**************************/
/*! exports provided: TableCell, TableRow, TableBody, TableContainer, tableId */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"TableCell\", function() { return TableCell; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"TableRow\", function() { return TableRow; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"TableBody\", function() { return TableBody; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"TableContainer\", function() { return TableContainer; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"tableId\", function() { return tableId; });\n/* harmony import */ var _blots_block__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../blots/block */ \"./blots/block.js\");\n/* harmony import */ var _blots_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../blots/container */ \"./blots/container.js\");\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\n\nclass TableCell extends _blots_block__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n  static create(value) {\n    const node = super.create();\n\n    if (value) {\n      node.setAttribute('data-row', value);\n    } else {\n      node.setAttribute('data-row', tableId());\n    }\n\n    return node;\n  }\n\n  static formats(domNode) {\n    if (domNode.hasAttribute('data-row')) {\n      return domNode.getAttribute('data-row');\n    }\n\n    return undefined;\n  }\n\n  cellOffset() {\n    if (this.parent) {\n      return this.parent.children.indexOf(this);\n    }\n\n    return -1;\n  }\n\n  format(name, value) {\n    if (name === TableCell.blotName && value) {\n      this.domNode.setAttribute('data-row', value);\n    } else {\n      super.format(name, value);\n    }\n  }\n\n  row() {\n    return this.parent;\n  }\n\n  rowOffset() {\n    if (this.row()) {\n      return this.row().rowOffset();\n    }\n\n    return -1;\n  }\n\n  table() {\n    return this.row() && this.row().table();\n  }\n\n}\n\nTableCell.blotName = 'table';\nTableCell.tagName = 'TD';\n\nclass TableRow extends _blots_container__WEBPACK_IMPORTED_MODULE_1__[\"default\"] {\n  checkMerge() {\n    if (super.checkMerge() && this.next.children.head != null) {\n      const thisHead = this.children.head.formats();\n      const thisTail = this.children.tail.formats();\n      const nextHead = this.next.children.head.formats();\n      const nextTail = this.next.children.tail.formats();\n      return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;\n    }\n\n    return false;\n  }\n\n  optimize() {\n    super.optimize(...arguments);\n    this.children.forEach(child => {\n      if (child.next == null) return;\n      const childFormats = child.formats();\n      const nextFormats = child.next.formats();\n\n      if (childFormats.table !== nextFormats.table) {\n        const next = this.splitAfter(child);\n\n        if (next) {\n          next.optimize();\n        } // We might be able to merge with prev now\n\n\n        if (this.prev) {\n          this.prev.optimize();\n        }\n      }\n    });\n  }\n\n  rowOffset() {\n    if (this.parent) {\n      return this.parent.children.indexOf(this);\n    }\n\n    return -1;\n  }\n\n  table() {\n    return this.parent && this.parent.parent;\n  }\n\n}\n\nTableRow.blotName = 'table-row';\nTableRow.tagName = 'TR';\n\nclass TableBody extends _blots_container__WEBPACK_IMPORTED_MODULE_1__[\"default\"] {}\n\nTableBody.blotName = 'table-body';\nTableBody.tagName = 'TBODY';\n\nclass TableContainer extends _blots_container__WEBPACK_IMPORTED_MODULE_1__[\"default\"] {\n  balanceCells() {\n    const rows = this.descendants(TableRow);\n    const maxColumns = rows.reduce((max, row) => {\n      return Math.max(row.children.length, max);\n    }, 0);\n    rows.forEach(row => {\n      new Array(maxColumns - row.children.length).fill(0).forEach(() => {\n        let value;\n\n        if (row.children.head != null) {\n          value = TableCell.formats(row.children.head.domNode);\n        }\n\n        const blot = this.scroll.create(TableCell.blotName, value);\n        row.appendChild(blot);\n        blot.optimize(); // Add break blot\n      });\n    });\n  }\n\n  cells(column) {\n    return this.rows().map(row => row.children.at(column));\n  }\n\n  deleteColumn(index) {\n    const _this$descendant = this.descendant(TableBody),\n          _this$descendant2 = _slicedToArray(_this$descendant, 1),\n          body = _this$descendant2[0];\n\n    if (body == null || body.children.head == null) return;\n    body.children.forEach(row => {\n      const cell = row.children.at(index);\n\n      if (cell != null) {\n        cell.remove();\n      }\n    });\n  }\n\n  insertColumn(index) {\n    const _this$descendant3 = this.descendant(TableBody),\n          _this$descendant4 = _slicedToArray(_this$descendant3, 1),\n          body = _this$descendant4[0];\n\n    if (body == null || body.children.head == null) return;\n    body.children.forEach(row => {\n      const ref = row.children.at(index);\n      const value = TableCell.formats(row.children.head.domNode);\n      const cell = this.scroll.create(TableCell.blotName, value);\n      row.insertBefore(cell, ref);\n    });\n  }\n\n  insertRow(index) {\n    const _this$descendant5 = this.descendant(TableBody),\n          _this$descendant6 = _slicedToArray(_this$descendant5, 1),\n          body = _this$descendant6[0];\n\n    if (body == null || body.children.head == null) return;\n    const id = tableId();\n    const row = this.scroll.create(TableRow.blotName);\n    body.children.head.children.forEach(() => {\n      const cell = this.scroll.create(TableCell.blotName, id);\n      row.appendChild(cell);\n    });\n    const ref = body.children.at(index);\n    body.insertBefore(row, ref);\n  }\n\n  rows() {\n    const body = this.children.head;\n    if (body == null) return [];\n    return body.children.map(row => row);\n  }\n\n}\n\nTableContainer.blotName = 'table-container';\nTableContainer.tagName = 'TABLE';\nTableContainer.allowedChildren = [TableBody];\nTableBody.requiredContainer = TableContainer;\nTableBody.allowedChildren = [TableRow];\nTableRow.requiredContainer = TableBody;\nTableRow.allowedChildren = [TableCell];\nTableCell.requiredContainer = TableRow;\n\nfunction tableId() {\n  const id = Math.random().toString(36).slice(2, 6);\n  return \"row-\".concat(id);\n}\n\n\n\n//# sourceURL=webpack://Quill/./formats/table.js?");

/***/ }),

/***/ "./formats/underline.js":
/*!******************************!*\
  !*** ./formats/underline.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _blots_inline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../blots/inline */ \"./blots/inline.js\");\n\n\nclass Underline extends _blots_inline__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {}\n\nUnderline.blotName = 'underline';\nUnderline.tagName = 'U';\n/* harmony default export */ __webpack_exports__[\"default\"] = (Underline);\n\n//# sourceURL=webpack://Quill/./formats/underline.js?");

/***/ }),

/***/ "./formats/video.js":
/*!**************************!*\
  !*** ./formats/video.js ***!
  \**************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _blots_block__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../blots/block */ \"./blots/block.js\");\n/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./link */ \"./formats/link.js\");\n\n\nconst ATTRIBUTES = ['height', 'width'];\n\nclass Video extends _blots_block__WEBPACK_IMPORTED_MODULE_0__[\"BlockEmbed\"] {\n  static create(value) {\n    const node = super.create(value);\n    node.setAttribute('frameborder', '0');\n    node.setAttribute('allowfullscreen', true);\n    node.setAttribute('src', this.sanitize(value));\n    return node;\n  }\n\n  static formats(domNode) {\n    return ATTRIBUTES.reduce((formats, attribute) => {\n      if (domNode.hasAttribute(attribute)) {\n        formats[attribute] = domNode.getAttribute(attribute);\n      }\n\n      return formats;\n    }, {});\n  }\n\n  static sanitize(url) {\n    return _link__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sanitize(url); // eslint-disable-line import/no-named-as-default-member\n  }\n\n  static value(domNode) {\n    return domNode.getAttribute('src');\n  }\n\n  format(name, value) {\n    if (ATTRIBUTES.indexOf(name) > -1) {\n      if (value) {\n        this.domNode.setAttribute(name, value);\n      } else {\n        this.domNode.removeAttribute(name);\n      }\n    } else {\n      super.format(name, value);\n    }\n  }\n\n  html() {\n    const _this$value = this.value(),\n          video = _this$value.video;\n\n    return \"<a href=\\\"\".concat(video, \"\\\">\").concat(video, \"</a>\");\n  }\n\n}\n\nVideo.blotName = 'video';\nVideo.className = 'ql-video';\nVideo.tagName = 'IFRAME';\n/* harmony default export */ __webpack_exports__[\"default\"] = (Video);\n\n//# sourceURL=webpack://Quill/./formats/video.js?");

/***/ }),

/***/ "./modules/clipboard.js":
/*!******************************!*\
  !*** ./modules/clipboard.js ***!
  \******************************/
/*! exports provided: default, matchAttributor, matchBlot, matchNewline, matchText, traverse */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Clipboard; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"matchAttributor\", function() { return matchAttributor; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"matchBlot\", function() { return matchBlot; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"matchNewline\", function() { return matchNewline; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"matchText\", function() { return matchText; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"traverse\", function() { return traverse; });\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! extend */ \"./node_modules/extend/index.js\");\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(extend__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! quill-delta */ \"./node_modules/quill-delta/dist/Delta.js\");\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(quill_delta__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _blots_block__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../blots/block */ \"./blots/block.js\");\n/* harmony import */ var _core_quill__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../core/quill */ \"./core/quill.js\");\n/* harmony import */ var _core_logger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../core/logger */ \"./core/logger.js\");\n/* harmony import */ var _core_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../core/module */ \"./core/module.js\");\n/* harmony import */ var _formats_align__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../formats/align */ \"./formats/align.js\");\n/* harmony import */ var _formats_background__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../formats/background */ \"./formats/background.js\");\n/* harmony import */ var _formats_code__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../formats/code */ \"./formats/code.js\");\n/* harmony import */ var _formats_color__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../formats/color */ \"./formats/color.js\");\n/* harmony import */ var _formats_direction__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../formats/direction */ \"./formats/direction.js\");\n/* harmony import */ var _formats_font__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../formats/font */ \"./formats/font.js\");\n/* harmony import */ var _formats_size__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../formats/size */ \"./formats/size.js\");\nfunction _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }\n\nfunction _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }\n\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nconst debug = Object(_core_logger__WEBPACK_IMPORTED_MODULE_5__[\"default\"])('quill:clipboard');\nconst CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['ol, ul', matchList], ['pre', matchCodeBlock], ['tr', matchTable], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['strike', matchAlias.bind(matchAlias, 'strike')], ['style', matchIgnore]];\nconst ATTRIBUTE_ATTRIBUTORS = [_formats_align__WEBPACK_IMPORTED_MODULE_7__[\"AlignAttribute\"], _formats_direction__WEBPACK_IMPORTED_MODULE_11__[\"DirectionAttribute\"]].reduce((memo, attr) => {\n  memo[attr.keyName] = attr;\n  return memo;\n}, {});\nconst STYLE_ATTRIBUTORS = [_formats_align__WEBPACK_IMPORTED_MODULE_7__[\"AlignStyle\"], _formats_background__WEBPACK_IMPORTED_MODULE_8__[\"BackgroundStyle\"], _formats_color__WEBPACK_IMPORTED_MODULE_10__[\"ColorStyle\"], _formats_direction__WEBPACK_IMPORTED_MODULE_11__[\"DirectionStyle\"], _formats_font__WEBPACK_IMPORTED_MODULE_12__[\"FontStyle\"], _formats_size__WEBPACK_IMPORTED_MODULE_13__[\"SizeStyle\"]].reduce((memo, attr) => {\n  memo[attr.keyName] = attr;\n  return memo;\n}, {});\n\nclass Clipboard extends _core_module__WEBPACK_IMPORTED_MODULE_6__[\"default\"] {\n  constructor(quill, options) {\n    super(quill, options);\n    this.quill.root.addEventListener('copy', e => this.onCaptureCopy(e, false));\n    this.quill.root.addEventListener('cut', e => this.onCaptureCopy(e, true));\n    this.quill.root.addEventListener('paste', this.onCapturePaste.bind(this));\n    this.matchers = [];\n    CLIPBOARD_CONFIG.concat(this.options.matchers).forEach((_ref) => {\n      let _ref2 = _slicedToArray(_ref, 2),\n          selector = _ref2[0],\n          matcher = _ref2[1];\n\n      this.addMatcher(selector, matcher);\n    });\n  }\n\n  addMatcher(selector, matcher) {\n    this.matchers.push([selector, matcher]);\n  }\n\n  convert(_ref3) {\n    let html = _ref3.html,\n        text = _ref3.text;\n    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n\n    if (formats[_formats_code__WEBPACK_IMPORTED_MODULE_9__[\"default\"].blotName]) {\n      return new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a().insert(text, {\n        [_formats_code__WEBPACK_IMPORTED_MODULE_9__[\"default\"].blotName]: formats[_formats_code__WEBPACK_IMPORTED_MODULE_9__[\"default\"].blotName]\n      });\n    }\n\n    if (!html) {\n      return new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a().insert(text || '');\n    }\n\n    const doc = new DOMParser().parseFromString(html, 'text/html');\n    const container = doc.body;\n    const nodeMatches = new WeakMap();\n\n    const _this$prepareMatching = this.prepareMatching(container, nodeMatches),\n          _this$prepareMatching2 = _slicedToArray(_this$prepareMatching, 2),\n          elementMatchers = _this$prepareMatching2[0],\n          textMatchers = _this$prepareMatching2[1];\n\n    const delta = traverse(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches); // Remove trailing newline\n\n    if (deltaEndsWith(delta, '\\n') && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) {\n      return delta.compose(new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a().retain(delta.length() - 1).delete(1));\n    }\n\n    return delta;\n  }\n\n  dangerouslyPasteHTML(index, html) {\n    let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _core_quill__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.API;\n\n    if (typeof index === 'string') {\n      const delta = this.convert({\n        html: index,\n        text: ''\n      });\n      this.quill.setContents(delta, html);\n      this.quill.setSelection(0, _core_quill__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.SILENT);\n    } else {\n      const paste = this.convert({\n        html,\n        text: ''\n      });\n      this.quill.updateContents(new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a().retain(index).concat(paste), source);\n      this.quill.setSelection(index + paste.length(), _core_quill__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.SILENT);\n    }\n  }\n\n  onCaptureCopy(e) {\n    let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n    if (e.defaultPrevented) return;\n    e.preventDefault();\n\n    const _this$quill$selection = this.quill.selection.getRange(),\n          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),\n          range = _this$quill$selection2[0];\n\n    if (range == null) return;\n\n    const _this$onCopy = this.onCopy(range, isCut),\n          html = _this$onCopy.html,\n          text = _this$onCopy.text;\n\n    e.clipboardData.setData('text/plain', text);\n    e.clipboardData.setData('text/html', html);\n\n    if (isCut) {\n      this.quill.deleteText(range, _core_quill__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.USER);\n    }\n  }\n\n  onCapturePaste(e) {\n    if (e.defaultPrevented || !this.quill.isEnabled()) return;\n    e.preventDefault();\n    const range = this.quill.getSelection(true);\n    if (range == null) return;\n    const html = e.clipboardData.getData('text/html');\n    const text = e.clipboardData.getData('text/plain');\n    const files = Array.from(e.clipboardData.files || []);\n\n    if (!html && files.length > 0) {\n      this.quill.uploader.upload(range, files);\n    } else {\n      this.onPaste(range, {\n        html,\n        text\n      });\n    }\n  }\n\n  onCopy(range) {\n    const text = this.quill.getText(range);\n    const html = this.quill.getSemanticHTML(range);\n    return {\n      html,\n      text\n    };\n  }\n\n  onPaste(range, _ref4) {\n    let text = _ref4.text,\n        html = _ref4.html;\n    const formats = this.quill.getFormat(range.index);\n    const pastedDelta = this.convert({\n      text,\n      html\n    }, formats);\n    debug.log('onPaste', pastedDelta, {\n      text,\n      html\n    });\n    const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a().retain(range.index).delete(range.length).concat(pastedDelta);\n    this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.USER); // range.length contributes to delta.length()\n\n    this.quill.setSelection(delta.length() - range.length, _core_quill__WEBPACK_IMPORTED_MODULE_4__[\"default\"].sources.SILENT);\n    this.quill.scrollIntoView();\n  }\n\n  prepareMatching(container, nodeMatches) {\n    const elementMatchers = [];\n    const textMatchers = [];\n    this.matchers.forEach(pair => {\n      const _pair = _slicedToArray(pair, 2),\n            selector = _pair[0],\n            matcher = _pair[1];\n\n      switch (selector) {\n        case Node.TEXT_NODE:\n          textMatchers.push(matcher);\n          break;\n\n        case Node.ELEMENT_NODE:\n          elementMatchers.push(matcher);\n          break;\n\n        default:\n          Array.from(container.querySelectorAll(selector)).forEach(node => {\n            if (nodeMatches.has(node)) {\n              const matches = nodeMatches.get(node);\n              matches.push(matcher);\n            } else {\n              nodeMatches.set(node, [matcher]);\n            }\n          });\n          break;\n      }\n    });\n    return [elementMatchers, textMatchers];\n  }\n\n}\n\nClipboard.DEFAULTS = {\n  matchers: []\n};\n\nfunction applyFormat(delta, format, value) {\n  if (typeof format === 'object') {\n    return Object.keys(format).reduce((newDelta, key) => {\n      return applyFormat(newDelta, key, format[key]);\n    }, delta);\n  }\n\n  return delta.reduce((newDelta, op) => {\n    if (op.attributes && op.attributes[format]) {\n      return newDelta.push(op);\n    }\n\n    return newDelta.insert(op.insert, extend__WEBPACK_IMPORTED_MODULE_0___default()({}, {\n      [format]: value\n    }, op.attributes));\n  }, new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a());\n}\n\nfunction deltaEndsWith(delta, text) {\n  let endText = '';\n\n  for (let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus\n  ) {\n    const op = delta.ops[i];\n    if (typeof op.insert !== 'string') break;\n    endText = op.insert + endText;\n  }\n\n  return endText.slice(-1 * text.length) === text;\n}\n\nfunction isLine(node) {\n  if (node.childNodes.length === 0) return false; // Exclude embed blocks\n\n  return ['address', 'article', 'blockquote', 'canvas', 'dd', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'iframe', 'li', 'main', 'nav', 'ol', 'output', 'p', 'pre', 'section', 'table', 'td', 'tr', 'ul', 'video'].includes(node.tagName.toLowerCase());\n}\n\nconst preNodes = new WeakMap();\n\nfunction isPre(node) {\n  if (node == null) return false;\n\n  if (!preNodes.has(node)) {\n    if (node.tagName === 'PRE') {\n      preNodes.set(node, true);\n    } else {\n      preNodes.set(node, isPre(node.parentNode));\n    }\n  }\n\n  return preNodes.get(node);\n}\n\nfunction traverse(scroll, node, elementMatchers, textMatchers, nodeMatches) {\n  // Post-order\n  if (node.nodeType === node.TEXT_NODE) {\n    return textMatchers.reduce((delta, matcher) => {\n      return matcher(node, delta, scroll);\n    }, new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a());\n  }\n\n  if (node.nodeType === node.ELEMENT_NODE) {\n    return Array.from(node.childNodes || []).reduce((delta, childNode) => {\n      let childrenDelta = traverse(scroll, childNode, elementMatchers, textMatchers, nodeMatches);\n\n      if (childNode.nodeType === node.ELEMENT_NODE) {\n        childrenDelta = elementMatchers.reduce((reducedDelta, matcher) => {\n          return matcher(childNode, reducedDelta, scroll);\n        }, childrenDelta);\n        childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher) => {\n          return matcher(childNode, reducedDelta, scroll);\n        }, childrenDelta);\n      }\n\n      return delta.concat(childrenDelta);\n    }, new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a());\n  }\n\n  return new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a();\n}\n\nfunction matchAlias(format, node, delta) {\n  return applyFormat(delta, format, true);\n}\n\nfunction matchAttributor(node, delta, scroll) {\n  const attributes = parchment__WEBPACK_IMPORTED_MODULE_2__[\"Attributor\"].keys(node);\n  const classes = parchment__WEBPACK_IMPORTED_MODULE_2__[\"ClassAttributor\"].keys(node);\n  const styles = parchment__WEBPACK_IMPORTED_MODULE_2__[\"StyleAttributor\"].keys(node);\n  const formats = {};\n  attributes.concat(classes).concat(styles).forEach(name => {\n    let attr = scroll.query(name, parchment__WEBPACK_IMPORTED_MODULE_2__[\"Scope\"].ATTRIBUTE);\n\n    if (attr != null) {\n      formats[attr.attrName] = attr.value(node);\n      if (formats[attr.attrName]) return;\n    }\n\n    attr = ATTRIBUTE_ATTRIBUTORS[name];\n\n    if (attr != null && (attr.attrName === name || attr.keyName === name)) {\n      formats[attr.attrName] = attr.value(node) || undefined;\n    }\n\n    attr = STYLE_ATTRIBUTORS[name];\n\n    if (attr != null && (attr.attrName === name || attr.keyName === name)) {\n      attr = STYLE_ATTRIBUTORS[name];\n      formats[attr.attrName] = attr.value(node) || undefined;\n    }\n  });\n\n  if (Object.keys(formats).length > 0) {\n    return applyFormat(delta, formats);\n  }\n\n  return delta;\n}\n\nfunction matchBlot(node, delta, scroll) {\n  const match = scroll.query(node);\n  if (match == null) return delta;\n\n  if (match.prototype instanceof parchment__WEBPACK_IMPORTED_MODULE_2__[\"EmbedBlot\"]) {\n    const embed = {};\n    const value = match.value(node);\n\n    if (value != null) {\n      embed[match.blotName] = value;\n      return new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a().insert(embed, match.formats(node, scroll));\n    }\n  } else {\n    if (match.prototype instanceof parchment__WEBPACK_IMPORTED_MODULE_2__[\"BlockBlot\"] && !deltaEndsWith(delta, '\\n')) {\n      delta.insert('\\n');\n    }\n\n    if (typeof match.formats === 'function') {\n      return applyFormat(delta, match.blotName, match.formats(node, scroll));\n    }\n  }\n\n  return delta;\n}\n\nfunction matchBreak(node, delta) {\n  if (!deltaEndsWith(delta, '\\n')) {\n    delta.insert('\\n');\n  }\n\n  return delta;\n}\n\nfunction matchCodeBlock(node, delta, scroll) {\n  const match = scroll.query('code-block');\n  const language = match ? match.formats(node, scroll) : true;\n  return applyFormat(delta, 'code-block', language);\n}\n\nfunction matchIgnore() {\n  return new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a();\n}\n\nfunction matchIndent(node, delta, scroll) {\n  const match = scroll.query(node);\n\n  if (match == null || match.blotName !== 'list' || !deltaEndsWith(delta, '\\n')) {\n    return delta;\n  }\n\n  let indent = -1;\n  let parent = node.parentNode;\n\n  while (parent != null) {\n    if (['OL', 'UL'].includes(parent.tagName)) {\n      indent += 1;\n    }\n\n    parent = parent.parentNode;\n  }\n\n  if (indent <= 0) return delta;\n  return delta.reduce((composed, op) => {\n    if (op.attributes && op.attributes.list) {\n      return composed.push(op);\n    }\n\n    return composed.insert(op.insert, _objectSpread({\n      indent\n    }, op.attributes || {}));\n  }, new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a());\n}\n\nfunction matchList(node, delta) {\n  const list = node.tagName === 'OL' ? 'ordered' : 'bullet';\n  return applyFormat(delta, 'list', list);\n}\n\nfunction matchNewline(node, delta, scroll) {\n  if (!deltaEndsWith(delta, '\\n')) {\n    if (isLine(node)) {\n      return delta.insert('\\n');\n    }\n\n    if (delta.length() > 0 && node.nextSibling) {\n      let nextSibling = node.nextSibling;\n\n      while (nextSibling != null) {\n        if (isLine(nextSibling)) {\n          return delta.insert('\\n');\n        }\n\n        const match = scroll.query(nextSibling);\n\n        if (match && match.prototype instanceof _blots_block__WEBPACK_IMPORTED_MODULE_3__[\"BlockEmbed\"]) {\n          return delta.insert('\\n');\n        }\n\n        nextSibling = nextSibling.firstChild;\n      }\n    }\n  }\n\n  return delta;\n}\n\nfunction matchStyles(node, delta) {\n  const formats = {};\n  const style = node.style || {};\n\n  if (style.fontStyle === 'italic') {\n    formats.italic = true;\n  }\n\n  if (style.textDecoration === 'underline') {\n    formats.underline = true;\n  }\n\n  if (style.textDecoration === 'line-through') {\n    formats.strike = true;\n  }\n\n  if (style.fontWeight.startsWith('bold') || parseInt(style.fontWeight, 10) >= 700) {\n    formats.bold = true;\n  }\n\n  if (Object.keys(formats).length > 0) {\n    delta = applyFormat(delta, formats);\n  }\n\n  if (parseFloat(style.textIndent || 0) > 0) {\n    // Could be 0.5in\n    return new quill_delta__WEBPACK_IMPORTED_MODULE_1___default.a().insert('\\t').concat(delta);\n  }\n\n  return delta;\n}\n\nfunction matchTable(node, delta) {\n  const table = node.parentNode.tagName === 'TABLE' ? node.parentNode : node.parentNode.parentNode;\n  const rows = Array.from(table.querySelectorAll('tr'));\n  const row = rows.indexOf(node) + 1;\n  return applyFormat(delta, 'table', row);\n}\n\nfunction matchText(node, delta) {\n  let text = node.data; // Word represents empty line with <o:p>&nbsp;</o:p>\n\n  if (node.parentNode.tagName === 'O:P') {\n    return delta.insert(text.trim());\n  }\n\n  if (text.trim().length === 0 && text.includes('\\n')) {\n    return delta;\n  }\n\n  if (!isPre(node)) {\n    const replacer = (collapse, match) => {\n      const replaced = match.replace(/[^\\u00a0]/g, ''); // \\u00a0 is nbsp;\n\n      return replaced.length < 1 && collapse ? ' ' : replaced;\n    };\n\n    text = text.replace(/\\r\\n/g, ' ').replace(/\\n/g, ' ');\n    text = text.replace(/\\s\\s+/g, replacer.bind(replacer, true)); // collapse whitespace\n\n    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {\n      text = text.replace(/^\\s+/, replacer.bind(replacer, false));\n    }\n\n    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {\n      text = text.replace(/\\s+$/, replacer.bind(replacer, false));\n    }\n  }\n\n  return delta.insert(text);\n}\n\n\n\n//# sourceURL=webpack://Quill/./modules/clipboard.js?");

/***/ }),

/***/ "./modules/history.js":
/*!****************************!*\
  !*** ./modules/history.js ***!
  \****************************/
/*! exports provided: default, getLastChangeIndex */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return History; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"getLastChangeIndex\", function() { return getLastChangeIndex; });\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _core_quill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/quill */ \"./core/quill.js\");\n/* harmony import */ var _core_module__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/module */ \"./core/module.js\");\n\n\n\n\nclass History extends _core_module__WEBPACK_IMPORTED_MODULE_2__[\"default\"] {\n  constructor(quill, options) {\n    super(quill, options);\n    this.lastRecorded = 0;\n    this.ignoreChange = false;\n    this.clear();\n    this.quill.on(_core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.EDITOR_CHANGE, (eventName, delta, oldDelta, source) => {\n      if (eventName !== _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.TEXT_CHANGE || this.ignoreChange) return;\n\n      if (!this.options.userOnly || source === _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER) {\n        this.record(delta, oldDelta);\n      } else {\n        this.transform(delta);\n      }\n    });\n    this.quill.keyboard.addBinding({\n      key: 'z',\n      shortKey: true\n    }, this.undo.bind(this));\n    this.quill.keyboard.addBinding({\n      key: 'z',\n      shortKey: true,\n      shiftKey: true\n    }, this.redo.bind(this));\n\n    if (/Win/i.test(navigator.platform)) {\n      this.quill.keyboard.addBinding({\n        key: 'y',\n        shortKey: true\n      }, this.redo.bind(this));\n    }\n  }\n\n  change(source, dest) {\n    if (this.stack[source].length === 0) return;\n    const delta = this.stack[source].pop();\n    const base = this.quill.getContents();\n    const inverseDelta = delta.invert(base);\n    this.stack[dest].push(inverseDelta);\n    this.lastRecorded = 0;\n    this.ignoreChange = true;\n    this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n    this.ignoreChange = false;\n    const index = getLastChangeIndex(this.quill.scroll, delta);\n    this.quill.setSelection(index);\n  }\n\n  clear() {\n    this.stack = {\n      undo: [],\n      redo: []\n    };\n  }\n\n  cutoff() {\n    this.lastRecorded = 0;\n  }\n\n  record(changeDelta, oldDelta) {\n    if (changeDelta.ops.length === 0) return;\n    this.stack.redo = [];\n    let undoDelta = changeDelta.invert(oldDelta);\n    const timestamp = Date.now();\n\n    if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {\n      const delta = this.stack.undo.pop();\n      undoDelta = undoDelta.compose(delta);\n    } else {\n      this.lastRecorded = timestamp;\n    }\n\n    if (undoDelta.length() === 0) return;\n    this.stack.undo.push(undoDelta);\n\n    if (this.stack.undo.length > this.options.maxStack) {\n      this.stack.undo.shift();\n    }\n  }\n\n  redo() {\n    this.change('redo', 'undo');\n  }\n\n  transform(delta) {\n    transformStack(this.stack.undo, delta);\n    transformStack(this.stack.redo, delta);\n  }\n\n  undo() {\n    this.change('undo', 'redo');\n  }\n\n}\n\nHistory.DEFAULTS = {\n  delay: 1000,\n  maxStack: 100,\n  userOnly: false\n};\n\nfunction transformStack(stack, delta) {\n  let remoteDelta = delta;\n\n  for (let i = stack.length - 1; i >= 0; i -= 1) {\n    const oldDelta = stack[i];\n    stack[i] = remoteDelta.transform(oldDelta, true);\n    remoteDelta = oldDelta.transform(remoteDelta);\n\n    if (stack[i].length() === 0) {\n      stack.splice(i, 1);\n    }\n  }\n}\n\nfunction endsWithNewlineChange(scroll, delta) {\n  const lastOp = delta.ops[delta.ops.length - 1];\n  if (lastOp == null) return false;\n\n  if (lastOp.insert != null) {\n    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\\n');\n  }\n\n  if (lastOp.attributes != null) {\n    return Object.keys(lastOp.attributes).some(attr => {\n      return scroll.query(attr, parchment__WEBPACK_IMPORTED_MODULE_0__[\"Scope\"].BLOCK) != null;\n    });\n  }\n\n  return false;\n}\n\nfunction getLastChangeIndex(scroll, delta) {\n  const deleteLength = delta.reduce((length, op) => {\n    return length + (op.delete || 0);\n  }, 0);\n  let changeIndex = delta.length() - deleteLength;\n\n  if (endsWithNewlineChange(scroll, delta)) {\n    changeIndex -= 1;\n  }\n\n  return changeIndex;\n}\n\n\n\n//# sourceURL=webpack://Quill/./modules/history.js?");

/***/ }),

/***/ "./modules/keyboard.js":
/*!*****************************!*\
  !*** ./modules/keyboard.js ***!
  \*****************************/
/*! exports provided: default, SHORTKEY, normalize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Keyboard; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"SHORTKEY\", function() { return SHORTKEY; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"normalize\", function() { return normalize; });\n/* harmony import */ var clone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! clone */ \"./node_modules/clone/clone.js\");\n/* harmony import */ var clone__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(clone__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var deep_equal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! deep-equal */ \"./node_modules/deep-equal/index.js\");\n/* harmony import */ var deep_equal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(deep_equal__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! extend */ \"./node_modules/extend/index.js\");\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(extend__WEBPACK_IMPORTED_MODULE_2__);\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! quill-delta */ \"./node_modules/quill-delta/dist/Delta.js\");\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(quill_delta__WEBPACK_IMPORTED_MODULE_3__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _core_quill__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../core/quill */ \"./core/quill.js\");\n/* harmony import */ var _core_logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../core/logger */ \"./core/logger.js\");\n/* harmony import */ var _core_module__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../core/module */ \"./core/module.js\");\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\n\n\n\n\n\n\nconst debug = Object(_core_logger__WEBPACK_IMPORTED_MODULE_6__[\"default\"])('quill:keyboard');\nconst SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';\n\nclass Keyboard extends _core_module__WEBPACK_IMPORTED_MODULE_7__[\"default\"] {\n  static match(evt, binding) {\n    if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(key => {\n      return !!binding[key] !== evt[key] && binding[key] !== null;\n    })) {\n      return false;\n    }\n\n    return binding.key === evt.key || binding.key === evt.which;\n  }\n\n  constructor(quill, options) {\n    super(quill, options);\n    this.bindings = {};\n    Object.keys(this.options.bindings).forEach(name => {\n      if (this.options.bindings[name]) {\n        this.addBinding(this.options.bindings[name]);\n      }\n    });\n    this.addBinding({\n      key: 'Enter',\n      shiftKey: null\n    }, this.handleEnter);\n    this.addBinding({\n      key: 'Enter',\n      metaKey: null,\n      ctrlKey: null,\n      altKey: null\n    }, () => {});\n\n    if (/Firefox/i.test(navigator.userAgent)) {\n      // Need to handle delete and backspace for Firefox in the general case #1171\n      this.addBinding({\n        key: 'Backspace'\n      }, {\n        collapsed: true\n      }, this.handleBackspace);\n      this.addBinding({\n        key: 'Delete'\n      }, {\n        collapsed: true\n      }, this.handleDelete);\n    } else {\n      this.addBinding({\n        key: 'Backspace'\n      }, {\n        collapsed: true,\n        prefix: /^.?$/\n      }, this.handleBackspace);\n      this.addBinding({\n        key: 'Delete'\n      }, {\n        collapsed: true,\n        suffix: /^.?$/\n      }, this.handleDelete);\n    }\n\n    this.addBinding({\n      key: 'Backspace'\n    }, {\n      collapsed: false\n    }, this.handleDeleteRange);\n    this.addBinding({\n      key: 'Delete'\n    }, {\n      collapsed: false\n    }, this.handleDeleteRange);\n    this.addBinding({\n      key: 'Backspace',\n      altKey: null,\n      ctrlKey: null,\n      metaKey: null,\n      shiftKey: null\n    }, {\n      collapsed: true,\n      offset: 0\n    }, this.handleBackspace);\n    this.listen();\n  }\n\n  addBinding(keyBinding) {\n    let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n    let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};\n    const binding = normalize(keyBinding);\n\n    if (binding == null) {\n      debug.warn('Attempted to add invalid keyboard binding', binding);\n      return;\n    }\n\n    if (typeof context === 'function') {\n      context = {\n        handler: context\n      };\n    }\n\n    if (typeof handler === 'function') {\n      handler = {\n        handler\n      };\n    }\n\n    const keys = Array.isArray(binding.key) ? binding.key : [binding.key];\n    keys.forEach(key => {\n      const singleBinding = extend__WEBPACK_IMPORTED_MODULE_2___default()({}, binding, {\n        key\n      }, context, handler);\n      this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];\n      this.bindings[singleBinding.key].push(singleBinding);\n    });\n  }\n\n  listen() {\n    this.quill.root.addEventListener('keydown', evt => {\n      if (evt.defaultPrevented || evt.isComposing) return;\n      const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);\n      const matches = bindings.filter(binding => Keyboard.match(evt, binding));\n      if (matches.length === 0) return;\n      const range = this.quill.getSelection();\n      if (range == null || !this.quill.hasFocus()) return;\n\n      const _this$quill$getLine = this.quill.getLine(range.index),\n            _this$quill$getLine2 = _slicedToArray(_this$quill$getLine, 2),\n            line = _this$quill$getLine2[0],\n            offset = _this$quill$getLine2[1];\n\n      const _this$quill$getLeaf = this.quill.getLeaf(range.index),\n            _this$quill$getLeaf2 = _slicedToArray(_this$quill$getLeaf, 2),\n            leafStart = _this$quill$getLeaf2[0],\n            offsetStart = _this$quill$getLeaf2[1];\n\n      const _ref = range.length === 0 ? [leafStart, offsetStart] : this.quill.getLeaf(range.index + range.length),\n            _ref2 = _slicedToArray(_ref, 2),\n            leafEnd = _ref2[0],\n            offsetEnd = _ref2[1];\n\n      const prefixText = leafStart instanceof parchment__WEBPACK_IMPORTED_MODULE_4__[\"TextBlot\"] ? leafStart.value().slice(0, offsetStart) : '';\n      const suffixText = leafEnd instanceof parchment__WEBPACK_IMPORTED_MODULE_4__[\"TextBlot\"] ? leafEnd.value().slice(offsetEnd) : '';\n      const curContext = {\n        collapsed: range.length === 0,\n        empty: range.length === 0 && line.length() <= 1,\n        format: this.quill.getFormat(range),\n        line,\n        offset,\n        prefix: prefixText,\n        suffix: suffixText,\n        event: evt\n      };\n      const prevented = matches.some(binding => {\n        if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) {\n          return false;\n        }\n\n        if (binding.empty != null && binding.empty !== curContext.empty) {\n          return false;\n        }\n\n        if (binding.offset != null && binding.offset !== curContext.offset) {\n          return false;\n        }\n\n        if (Array.isArray(binding.format)) {\n          // any format is present\n          if (binding.format.every(name => curContext.format[name] == null)) {\n            return false;\n          }\n        } else if (typeof binding.format === 'object') {\n          // all formats must match\n          if (!Object.keys(binding.format).every(name => {\n            if (binding.format[name] === true) return curContext.format[name] != null;\n            if (binding.format[name] === false) return curContext.format[name] == null;\n            return deep_equal__WEBPACK_IMPORTED_MODULE_1___default()(binding.format[name], curContext.format[name]);\n          })) {\n            return false;\n          }\n        }\n\n        if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) {\n          return false;\n        }\n\n        if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) {\n          return false;\n        }\n\n        return binding.handler.call(this, range, curContext, binding) !== true;\n      });\n\n      if (prevented) {\n        evt.preventDefault();\n      }\n    });\n  }\n\n  handleBackspace(range, context) {\n    // Check for astral symbols\n    const length = /[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]$/.test(context.prefix) ? 2 : 1;\n    if (range.index === 0 || this.quill.getLength() <= 1) return;\n    let formats = {};\n\n    const _this$quill$getLine3 = this.quill.getLine(range.index),\n          _this$quill$getLine4 = _slicedToArray(_this$quill$getLine3, 1),\n          line = _this$quill$getLine4[0];\n\n    let delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(range.index - length).delete(length);\n\n    if (context.offset === 0) {\n      // Always deleting newline here, length always 1\n      const _this$quill$getLine5 = this.quill.getLine(range.index - 1),\n            _this$quill$getLine6 = _slicedToArray(_this$quill$getLine5, 1),\n            prev = _this$quill$getLine6[0];\n\n      if (prev) {\n        const curFormats = line.formats();\n        const prevFormats = this.quill.getFormat(range.index - 1, 1);\n        formats = quill_delta__WEBPACK_IMPORTED_MODULE_3__[\"AttributeMap\"].diff(curFormats, prevFormats) || {};\n\n        if (Object.keys(formats).length > 0) {\n          // line.length() - 1 targets \\n in line, another -1 for newline being deleted\n          const formatDelta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(range.index + line.length() - 2).retain(1, formats);\n          delta = delta.compose(formatDelta);\n        }\n      }\n    }\n\n    this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n    this.quill.focus();\n  }\n\n  handleDelete(range, context) {\n    // Check for astral symbols\n    const length = /^[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]/.test(context.suffix) ? 2 : 1;\n    if (range.index >= this.quill.getLength() - length) return;\n    let formats = {};\n\n    const _this$quill$getLine7 = this.quill.getLine(range.index),\n          _this$quill$getLine8 = _slicedToArray(_this$quill$getLine7, 1),\n          line = _this$quill$getLine8[0];\n\n    let delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(range.index).delete(length);\n\n    if (context.offset >= line.length() - 1) {\n      const _this$quill$getLine9 = this.quill.getLine(range.index + 1),\n            _this$quill$getLine10 = _slicedToArray(_this$quill$getLine9, 1),\n            next = _this$quill$getLine10[0];\n\n      if (next) {\n        const curFormats = line.formats();\n        const nextFormats = this.quill.getFormat(range.index, 1);\n        formats = quill_delta__WEBPACK_IMPORTED_MODULE_3__[\"AttributeMap\"].diff(curFormats, nextFormats) || {};\n\n        if (Object.keys(formats).length > 0) {\n          delta = delta.retain(next.length() - 1).retain(1, formats);\n        }\n      }\n    }\n\n    this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n    this.quill.focus();\n  }\n\n  handleDeleteRange(range) {\n    const lines = this.quill.getLines(range);\n    let formats = {};\n\n    if (lines.length > 1) {\n      const firstFormats = lines[0].formats();\n      const lastFormats = lines[lines.length - 1].formats();\n      formats = quill_delta__WEBPACK_IMPORTED_MODULE_3__[\"AttributeMap\"].diff(lastFormats, firstFormats) || {};\n    }\n\n    this.quill.deleteText(range, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n\n    if (Object.keys(formats).length > 0) {\n      this.quill.formatLine(range.index, 1, formats, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n    }\n\n    this.quill.setSelection(range.index, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.SILENT);\n    this.quill.focus();\n  }\n\n  handleEnter(range, context) {\n    const lineFormats = Object.keys(context.format).reduce((formats, format) => {\n      if (this.quill.scroll.query(format, parchment__WEBPACK_IMPORTED_MODULE_4__[\"Scope\"].BLOCK) && !Array.isArray(context.format[format])) {\n        formats[format] = context.format[format];\n      }\n\n      return formats;\n    }, {});\n    const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(range.index).delete(range.length).insert('\\n', lineFormats);\n    this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n    this.quill.setSelection(range.index + 1, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.SILENT);\n    this.quill.focus();\n    Object.keys(context.format).forEach(name => {\n      if (lineFormats[name] != null) return;\n      if (Array.isArray(context.format[name])) return;\n      if (name === 'code' || name === 'link') return;\n      this.quill.format(name, context.format[name], _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n    });\n  }\n\n}\n\nKeyboard.DEFAULTS = {\n  bindings: {\n    bold: makeFormatHandler('bold'),\n    italic: makeFormatHandler('italic'),\n    underline: makeFormatHandler('underline'),\n    indent: {\n      // highlight tab or tab at beginning of list, indent or blockquote\n      key: 'Tab',\n      format: ['blockquote', 'indent', 'list'],\n\n      handler(range, context) {\n        if (context.collapsed && context.offset !== 0) return true;\n        this.quill.format('indent', '+1', _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        return false;\n      }\n\n    },\n    outdent: {\n      key: 'Tab',\n      shiftKey: true,\n      format: ['blockquote', 'indent', 'list'],\n\n      // highlight tab or tab at beginning of list, indent or blockquote\n      handler(range, context) {\n        if (context.collapsed && context.offset !== 0) return true;\n        this.quill.format('indent', '-1', _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        return false;\n      }\n\n    },\n    'outdent backspace': {\n      key: 'Backspace',\n      collapsed: true,\n      shiftKey: null,\n      metaKey: null,\n      ctrlKey: null,\n      altKey: null,\n      format: ['indent', 'list'],\n      offset: 0,\n\n      handler(range, context) {\n        if (context.format.indent != null) {\n          this.quill.format('indent', '-1', _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        } else if (context.format.list != null) {\n          this.quill.format('list', false, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        }\n      }\n\n    },\n    'indent code-block': makeCodeBlockHandler(true),\n    'outdent code-block': makeCodeBlockHandler(false),\n    'remove tab': {\n      key: 'Tab',\n      shiftKey: true,\n      collapsed: true,\n      prefix: /\\t$/,\n\n      handler(range) {\n        this.quill.deleteText(range.index - 1, 1, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n      }\n\n    },\n    tab: {\n      key: 'Tab',\n\n      handler(range, context) {\n        if (context.format.table) return true;\n        this.quill.history.cutoff();\n        const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(range.index).delete(range.length).insert('\\t');\n        this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        this.quill.history.cutoff();\n        this.quill.setSelection(range.index + 1, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.SILENT);\n        return false;\n      }\n\n    },\n    'blockquote empty enter': {\n      key: 'Enter',\n      collapsed: true,\n      format: ['blockquote'],\n      empty: true,\n\n      handler() {\n        this.quill.format('blockquote', false, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n      }\n\n    },\n    'list empty enter': {\n      key: 'Enter',\n      collapsed: true,\n      format: ['list'],\n      empty: true,\n\n      handler(range, context) {\n        const formats = {\n          list: false\n        };\n\n        if (context.format.indent) {\n          formats.indent = false;\n        }\n\n        this.quill.formatLine(range.index, range.length, formats, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n      }\n\n    },\n    'checklist enter': {\n      key: 'Enter',\n      collapsed: true,\n      format: {\n        list: 'checked'\n      },\n\n      handler(range) {\n        const _this$quill$getLine11 = this.quill.getLine(range.index),\n              _this$quill$getLine12 = _slicedToArray(_this$quill$getLine11, 2),\n              line = _this$quill$getLine12[0],\n              offset = _this$quill$getLine12[1];\n\n        const formats = extend__WEBPACK_IMPORTED_MODULE_2___default()({}, line.formats(), {\n          list: 'checked'\n        });\n        const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(range.index).insert('\\n', formats).retain(line.length() - offset - 1).retain(1, {\n          list: 'unchecked'\n        });\n        this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        this.quill.setSelection(range.index + 1, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.SILENT);\n        this.quill.scrollIntoView();\n      }\n\n    },\n    'header enter': {\n      key: 'Enter',\n      collapsed: true,\n      format: ['header'],\n      suffix: /^$/,\n\n      handler(range, context) {\n        const _this$quill$getLine13 = this.quill.getLine(range.index),\n              _this$quill$getLine14 = _slicedToArray(_this$quill$getLine13, 2),\n              line = _this$quill$getLine14[0],\n              offset = _this$quill$getLine14[1];\n\n        const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(range.index).insert('\\n', context.format).retain(line.length() - offset - 1).retain(1, {\n          header: null\n        });\n        this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        this.quill.setSelection(range.index + 1, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.SILENT);\n        this.quill.scrollIntoView();\n      }\n\n    },\n    'table backspace': {\n      key: 'Backspace',\n      format: ['table'],\n      collapsed: true,\n      offset: 0,\n\n      handler() {}\n\n    },\n    'table delete': {\n      key: 'Delete',\n      format: ['table'],\n      collapsed: true,\n      suffix: /^$/,\n\n      handler() {}\n\n    },\n    'table enter': {\n      key: 'Enter',\n      shiftKey: null,\n      format: ['table'],\n\n      handler(range) {\n        const module = this.quill.getModule('table');\n\n        if (module) {\n          const _module$getTable = module.getTable(range),\n                _module$getTable2 = _slicedToArray(_module$getTable, 4),\n                table = _module$getTable2[0],\n                row = _module$getTable2[1],\n                cell = _module$getTable2[2],\n                offset = _module$getTable2[3];\n\n          const shift = tableSide(table, row, cell, offset);\n          if (shift == null) return;\n          let index = table.offset();\n\n          if (shift < 0) {\n            const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(index).insert('\\n');\n            this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n            this.quill.setSelection(range.index + 1, range.length, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.SILENT);\n          } else if (shift > 0) {\n            index += table.length();\n            const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(index).insert('\\n');\n            this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n            this.quill.setSelection(index, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n          }\n        }\n      }\n\n    },\n    'table tab': {\n      key: 'Tab',\n      shiftKey: null,\n      format: ['table'],\n\n      handler(range, context) {\n        const event = context.event,\n              cell = context.line;\n        const offset = cell.offset(this.quill.scroll);\n\n        if (event.shiftKey) {\n          this.quill.setSelection(offset - 1, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        } else {\n          this.quill.setSelection(offset + cell.length(), _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        }\n      }\n\n    },\n    'list autofill': {\n      key: ' ',\n      shiftKey: null,\n      collapsed: true,\n      format: {\n        list: false,\n        'code-block': false,\n        blockquote: false,\n        header: false,\n        table: false\n      },\n      prefix: /^\\s*?(\\d+\\.|-|\\*|\\[ ?\\]|\\[x\\])$/,\n\n      handler(range, context) {\n        if (this.quill.scroll.query('list') == null) return true;\n        const length = context.prefix.length;\n\n        const _this$quill$getLine15 = this.quill.getLine(range.index),\n              _this$quill$getLine16 = _slicedToArray(_this$quill$getLine15, 2),\n              line = _this$quill$getLine16[0],\n              offset = _this$quill$getLine16[1];\n\n        if (offset > length) return true;\n        let value;\n\n        switch (context.prefix.trim()) {\n          case '[]':\n          case '[ ]':\n            value = 'unchecked';\n            break;\n\n          case '[x]':\n            value = 'checked';\n            break;\n\n          case '-':\n          case '*':\n            value = 'bullet';\n            break;\n\n          default:\n            value = 'ordered';\n        }\n\n        this.quill.insertText(range.index, ' ', _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        this.quill.history.cutoff();\n        const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, {\n          list: value\n        });\n        this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        this.quill.history.cutoff();\n        this.quill.setSelection(range.index - length, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.SILENT);\n        return false;\n      }\n\n    },\n    'code exit': {\n      key: 'Enter',\n      collapsed: true,\n      format: ['code-block'],\n      prefix: /^$/,\n      suffix: /^\\s*$/,\n\n      handler(range) {\n        const _this$quill$getLine17 = this.quill.getLine(range.index),\n              _this$quill$getLine18 = _slicedToArray(_this$quill$getLine17, 2),\n              line = _this$quill$getLine18[0],\n              offset = _this$quill$getLine18[1];\n\n        let numLines = 2;\n        let cur = line;\n\n        while (cur != null && cur.length() <= 1 && cur.formats()['code-block']) {\n          cur = cur.prev;\n          numLines -= 1; // Requisite prev lines are empty\n\n          if (numLines <= 0) {\n            const delta = new quill_delta__WEBPACK_IMPORTED_MODULE_3___default.a().retain(range.index + line.length() - offset - 2).retain(1, {\n              'code-block': null\n            }).delete(1);\n            this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n            this.quill.setSelection(range.index - 1, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.SILENT);\n            return false;\n          }\n        }\n\n        return true;\n      }\n\n    },\n    'embed left': makeEmbedArrowHandler('ArrowLeft', false),\n    'embed left shift': makeEmbedArrowHandler('ArrowLeft', true),\n    'embed right': makeEmbedArrowHandler('ArrowRight', false),\n    'embed right shift': makeEmbedArrowHandler('ArrowRight', true),\n    'table down': makeTableArrowHandler(false),\n    'table up': makeTableArrowHandler(true)\n  }\n};\n\nfunction makeCodeBlockHandler(indent) {\n  return {\n    key: 'Tab',\n    shiftKey: !indent,\n    format: {\n      'code-block': true\n    },\n\n    handler(range) {\n      const CodeBlock = this.quill.scroll.query('code-block');\n      const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);\n      let index = range.index,\n          length = range.length;\n      lines.forEach((line, i) => {\n        if (indent) {\n          line.insertAt(0, CodeBlock.TAB);\n\n          if (i === 0) {\n            index += CodeBlock.TAB.length;\n          } else {\n            length += CodeBlock.TAB.length;\n          }\n        } else if (line.domNode.textContent.startsWith(CodeBlock.TAB)) {\n          line.deleteAt(0, CodeBlock.TAB.length);\n\n          if (i === 0) {\n            index -= CodeBlock.TAB.length;\n          } else {\n            length -= CodeBlock.TAB.length;\n          }\n        }\n      });\n      this.quill.update(_core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n      this.quill.setSelection(index, length, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.SILENT);\n    }\n\n  };\n}\n\nfunction makeEmbedArrowHandler(key, shiftKey) {\n  const where = key === 'ArrowLeft' ? 'prefix' : 'suffix';\n  return {\n    key,\n    shiftKey,\n    altKey: null,\n    [where]: /^$/,\n\n    handler(range) {\n      let index = range.index;\n\n      if (key === 'ArrowRight') {\n        index += range.length + 1;\n      }\n\n      const _this$quill$getLeaf3 = this.quill.getLeaf(index),\n            _this$quill$getLeaf4 = _slicedToArray(_this$quill$getLeaf3, 1),\n            leaf = _this$quill$getLeaf4[0];\n\n      if (!(leaf instanceof parchment__WEBPACK_IMPORTED_MODULE_4__[\"EmbedBlot\"])) return true;\n\n      if (key === 'ArrowLeft') {\n        if (shiftKey) {\n          this.quill.setSelection(range.index - 1, range.length + 1, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        } else {\n          this.quill.setSelection(range.index - 1, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        }\n      } else if (shiftKey) {\n        this.quill.setSelection(range.index, range.length + 1, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n      } else {\n        this.quill.setSelection(range.index + range.length + 1, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n      }\n\n      return false;\n    }\n\n  };\n}\n\nfunction makeFormatHandler(format) {\n  return {\n    key: format[0],\n    shortKey: true,\n\n    handler(range, context) {\n      this.quill.format(format, !context.format[format], _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n    }\n\n  };\n}\n\nfunction makeTableArrowHandler(up) {\n  return {\n    key: up ? 'ArrowUp' : 'ArrowDown',\n    collapsed: true,\n    format: ['table'],\n\n    handler(range, context) {\n      // TODO move to table module\n      const key = up ? 'prev' : 'next';\n      const cell = context.line;\n      const targetRow = cell.parent[key];\n\n      if (targetRow != null) {\n        if (targetRow.statics.blotName === 'table-row') {\n          let targetCell = targetRow.children.head;\n          let cur = cell;\n\n          while (cur.prev != null) {\n            cur = cur.prev;\n            targetCell = targetCell.next;\n          }\n\n          const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);\n          this.quill.setSelection(index, 0, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n        }\n      } else {\n        const targetLine = cell.table()[key];\n\n        if (targetLine != null) {\n          if (up) {\n            this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n          } else {\n            this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, _core_quill__WEBPACK_IMPORTED_MODULE_5__[\"default\"].sources.USER);\n          }\n        }\n      }\n\n      return false;\n    }\n\n  };\n}\n\nfunction normalize(binding) {\n  if (typeof binding === 'string' || typeof binding === 'number') {\n    binding = {\n      key: binding\n    };\n  } else if (typeof binding === 'object') {\n    binding = clone__WEBPACK_IMPORTED_MODULE_0___default()(binding, false);\n  } else {\n    return null;\n  }\n\n  if (binding.shortKey) {\n    binding[SHORTKEY] = binding.shortKey;\n    delete binding.shortKey;\n  }\n\n  return binding;\n}\n\nfunction tableSide(table, row, cell, offset) {\n  if (row.prev == null && row.next == null) {\n    if (cell.prev == null && cell.next == null) {\n      return offset === 0 ? -1 : 1;\n    }\n\n    return cell.prev == null ? -1 : 1;\n  }\n\n  if (row.prev == null) {\n    return -1;\n  }\n\n  if (row.next == null) {\n    return 1;\n  }\n\n  return null;\n}\n\n\n\n//# sourceURL=webpack://Quill/./modules/keyboard.js?");

/***/ }),

/***/ "./modules/syntax.js":
/*!***************************!*\
  !*** ./modules/syntax.js ***!
  \***************************/
/*! exports provided: CodeBlock, CodeToken, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"CodeBlock\", function() { return SyntaxCodeBlock; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"CodeToken\", function() { return CodeToken; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Syntax; });\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta */ \"./node_modules/quill-delta/dist/Delta.js\");\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _blots_inline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../blots/inline */ \"./blots/inline.js\");\n/* harmony import */ var _core_quill__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/quill */ \"./core/quill.js\");\n/* harmony import */ var _core_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../core/module */ \"./core/module.js\");\n/* harmony import */ var _blots_block__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../blots/block */ \"./blots/block.js\");\n/* harmony import */ var _blots_break__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../blots/break */ \"./blots/break.js\");\n/* harmony import */ var _blots_cursor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../blots/cursor */ \"./blots/cursor.js\");\n/* harmony import */ var _blots_text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../blots/text */ \"./blots/text.js\");\n/* harmony import */ var _formats_code__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../formats/code */ \"./formats/code.js\");\n/* harmony import */ var _clipboard__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./clipboard */ \"./modules/clipboard.js\");\n\n\n\n\n\n\n\n\n\n\n\nconst TokenAttributor = new parchment__WEBPACK_IMPORTED_MODULE_1__[\"ClassAttributor\"]('code-token', 'hljs', {\n  scope: parchment__WEBPACK_IMPORTED_MODULE_1__[\"Scope\"].INLINE\n});\n\nclass CodeToken extends _blots_inline__WEBPACK_IMPORTED_MODULE_2__[\"default\"] {\n  static formats(node, scroll) {\n    while (node != null && node !== scroll.domNode) {\n      if (node.classList && node.classList.contains(_formats_code__WEBPACK_IMPORTED_MODULE_9__[\"default\"].className)) {\n        return super.formats(node, scroll);\n      }\n\n      node = node.parentNode;\n    }\n\n    return undefined;\n  }\n\n  constructor(scroll, domNode, value) {\n    super(scroll, domNode, value);\n    TokenAttributor.add(this.domNode, value);\n  }\n\n  format(format, value) {\n    if (format !== CodeToken.blotName) {\n      super.format(format, value);\n    } else if (value) {\n      TokenAttributor.add(this.domNode, value);\n    } else {\n      TokenAttributor.remove(this.domNode);\n      this.domNode.classList.remove(this.statics.className);\n    }\n  }\n\n  optimize() {\n    super.optimize(...arguments);\n\n    if (!TokenAttributor.value(this.domNode)) {\n      this.unwrap();\n    }\n  }\n\n}\n\nCodeToken.blotName = 'code-token';\nCodeToken.className = 'ql-token';\n\nclass SyntaxCodeBlock extends _formats_code__WEBPACK_IMPORTED_MODULE_9__[\"default\"] {\n  static create(value) {\n    const domNode = super.create(value);\n\n    if (typeof value === 'string') {\n      domNode.setAttribute('data-language', value);\n    }\n\n    return domNode;\n  }\n\n  static formats(domNode) {\n    return domNode.getAttribute('data-language') || 'plain';\n  }\n\n  static register() {} // Syntax module will register\n\n\n  format(name, value) {\n    if (name === this.statics.blotName && value) {\n      this.domNode.setAttribute('data-language', value);\n    } else {\n      super.format(name, value);\n    }\n  }\n\n  replaceWith(name, value) {\n    this.formatAt(0, this.length(), CodeToken.blotName, false);\n    return super.replaceWith(name, value);\n  }\n\n}\n\nclass SyntaxCodeBlockContainer extends _formats_code__WEBPACK_IMPORTED_MODULE_9__[\"CodeBlockContainer\"] {\n  attach() {\n    super.attach();\n    this.forceNext = false;\n    this.scroll.emitMount(this);\n  }\n\n  format(name, value) {\n    if (name === SyntaxCodeBlock.blotName) {\n      this.forceNext = true;\n      this.children.forEach(child => {\n        child.format(name, value);\n      });\n    }\n  }\n\n  formatAt(index, length, name, value) {\n    if (name === SyntaxCodeBlock.blotName) {\n      this.forceNext = true;\n    }\n\n    super.formatAt(index, length, name, value);\n  }\n\n  highlight(highlight) {\n    let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n    if (this.children.head == null) return;\n    const nodes = Array.from(this.domNode.childNodes).filter(node => node !== this.uiNode);\n    const text = \"\".concat(nodes.map(node => node.textContent).join('\\n'), \"\\n\");\n    const language = SyntaxCodeBlock.formats(this.children.head.domNode);\n\n    if (forced || this.forceNext || this.cachedText !== text) {\n      if (text.trim().length > 0 || this.cachedText == null) {\n        const oldDelta = this.children.reduce((delta, child) => {\n          return delta.concat(Object(_blots_block__WEBPACK_IMPORTED_MODULE_5__[\"blockDelta\"])(child, false));\n        }, new quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a());\n        const delta = highlight(text, language);\n        oldDelta.diff(delta).reduce((index, _ref) => {\n          let retain = _ref.retain,\n              attributes = _ref.attributes;\n          // Should be all retains\n          if (!retain) return index;\n\n          if (attributes) {\n            Object.keys(attributes).forEach(format => {\n              if ([SyntaxCodeBlock.blotName, CodeToken.blotName].includes(format)) {\n                this.formatAt(index, retain, format, attributes[format]);\n              }\n            });\n          }\n\n          return index + retain;\n        }, 0);\n      }\n\n      this.cachedText = text;\n      this.forceNext = false;\n    }\n  }\n\n  optimize(context) {\n    super.optimize(context);\n\n    if (this.parent != null && this.children.head != null && this.uiNode != null) {\n      const language = SyntaxCodeBlock.formats(this.children.head.domNode);\n\n      if (language !== this.uiNode.value) {\n        this.uiNode.value = language;\n      }\n    }\n  }\n\n}\n\nSyntaxCodeBlockContainer.allowedChildren = [SyntaxCodeBlock];\nSyntaxCodeBlock.requiredContainer = SyntaxCodeBlockContainer;\nSyntaxCodeBlock.allowedChildren = [CodeToken, _blots_cursor__WEBPACK_IMPORTED_MODULE_7__[\"default\"], _blots_text__WEBPACK_IMPORTED_MODULE_8__[\"default\"], _blots_break__WEBPACK_IMPORTED_MODULE_6__[\"default\"]];\n\nclass Syntax extends _core_module__WEBPACK_IMPORTED_MODULE_4__[\"default\"] {\n  static register() {\n    _core_quill__WEBPACK_IMPORTED_MODULE_3__[\"default\"].register(CodeToken, true);\n    _core_quill__WEBPACK_IMPORTED_MODULE_3__[\"default\"].register(SyntaxCodeBlock, true);\n    _core_quill__WEBPACK_IMPORTED_MODULE_3__[\"default\"].register(SyntaxCodeBlockContainer, true);\n  }\n\n  constructor(quill, options) {\n    super(quill, options);\n\n    if (this.options.hljs == null) {\n      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');\n    }\n\n    this.languages = this.options.languages.reduce((memo, _ref2) => {\n      let key = _ref2.key;\n      memo[key] = true;\n      return memo;\n    }, {});\n    this.highlightBlot = this.highlightBlot.bind(this);\n    this.initListener();\n    this.initTimer();\n  }\n\n  initListener() {\n    this.quill.on(_core_quill__WEBPACK_IMPORTED_MODULE_3__[\"default\"].events.SCROLL_BLOT_MOUNT, blot => {\n      if (!(blot instanceof SyntaxCodeBlockContainer)) return;\n      const select = this.quill.root.ownerDocument.createElement('select');\n      this.options.languages.forEach((_ref3) => {\n        let key = _ref3.key,\n            label = _ref3.label;\n        const option = select.ownerDocument.createElement('option');\n        option.textContent = label;\n        option.setAttribute('value', key);\n        select.appendChild(option);\n      });\n      select.addEventListener('change', () => {\n        blot.format(SyntaxCodeBlock.blotName, select.value);\n        this.quill.root.focus(); // Prevent scrolling\n\n        this.highlight(blot, true);\n      });\n\n      if (blot.uiNode == null) {\n        blot.attachUI(select);\n\n        if (blot.children.head) {\n          select.value = SyntaxCodeBlock.formats(blot.children.head.domNode);\n        }\n      }\n    });\n  }\n\n  initTimer() {\n    let timer = null;\n    this.quill.on(_core_quill__WEBPACK_IMPORTED_MODULE_3__[\"default\"].events.SCROLL_OPTIMIZE, () => {\n      clearTimeout(timer);\n      timer = setTimeout(() => {\n        this.highlight();\n        timer = null;\n      }, this.options.interval);\n    });\n  }\n\n  highlight() {\n    let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;\n    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n    if (this.quill.selection.composing) return;\n    this.quill.update(_core_quill__WEBPACK_IMPORTED_MODULE_3__[\"default\"].sources.USER);\n    const range = this.quill.getSelection();\n    const blots = blot == null ? this.quill.scroll.descendants(SyntaxCodeBlockContainer) : [blot];\n    blots.forEach(container => {\n      container.highlight(this.highlightBlot, force);\n    });\n    this.quill.update(_core_quill__WEBPACK_IMPORTED_MODULE_3__[\"default\"].sources.SILENT);\n\n    if (range != null) {\n      this.quill.setSelection(range, _core_quill__WEBPACK_IMPORTED_MODULE_3__[\"default\"].sources.SILENT);\n    }\n  }\n\n  highlightBlot(text) {\n    let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'plain';\n    language = this.languages[language] ? language : 'plain';\n\n    if (language === 'plain') {\n      return Object(_blots_text__WEBPACK_IMPORTED_MODULE_8__[\"escapeText\"])(text).split('\\n').reduce((delta, line, i) => {\n        if (i !== 0) {\n          delta.insert('\\n', {\n            [_formats_code__WEBPACK_IMPORTED_MODULE_9__[\"default\"].blotName]: language\n          });\n        }\n\n        return delta.insert(line);\n      }, new quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a());\n    }\n\n    const container = this.quill.root.ownerDocument.createElement('div');\n    container.classList.add(_formats_code__WEBPACK_IMPORTED_MODULE_9__[\"default\"].className);\n    container.innerHTML = this.options.hljs.highlight(language, text).value;\n    return Object(_clipboard__WEBPACK_IMPORTED_MODULE_10__[\"traverse\"])(this.quill.scroll, container, [(node, delta) => {\n      const value = TokenAttributor.value(node);\n\n      if (value) {\n        return delta.compose(new quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a().retain(delta.length(), {\n          [CodeToken.blotName]: value\n        }));\n      }\n\n      return delta;\n    }], [(node, delta) => {\n      return node.data.split('\\n').reduce((memo, nodeText, i) => {\n        if (i !== 0) memo.insert('\\n', {\n          [_formats_code__WEBPACK_IMPORTED_MODULE_9__[\"default\"].blotName]: language\n        });\n        return memo.insert(nodeText);\n      }, delta);\n    }], new WeakMap());\n  }\n\n}\n\nSyntax.DEFAULTS = {\n  hljs: (() => {\n    return window.hljs;\n  })(),\n  interval: 1000,\n  languages: [{\n    key: 'plain',\n    label: 'Plain'\n  }, {\n    key: 'bash',\n    label: 'Bash'\n  }, {\n    key: 'cpp',\n    label: 'C++'\n  }, {\n    key: 'cs',\n    label: 'C#'\n  }, {\n    key: 'css',\n    label: 'CSS'\n  }, {\n    key: 'diff',\n    label: 'Diff'\n  }, {\n    key: 'xml',\n    label: 'HTML/XML'\n  }, {\n    key: 'java',\n    label: 'Java'\n  }, {\n    key: 'javascript',\n    label: 'Javascript'\n  }, {\n    key: 'markdown',\n    label: 'Markdown'\n  }, {\n    key: 'php',\n    label: 'PHP'\n  }, {\n    key: 'python',\n    label: 'Python'\n  }, {\n    key: 'ruby',\n    label: 'Ruby'\n  }, {\n    key: 'sql',\n    label: 'SQL'\n  }]\n};\n\n\n//# sourceURL=webpack://Quill/./modules/syntax.js?");

/***/ }),

/***/ "./modules/table.js":
/*!**************************!*\
  !*** ./modules/table.js ***!
  \**************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta */ \"./node_modules/quill-delta/dist/Delta.js\");\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _core_quill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/quill */ \"./core/quill.js\");\n/* harmony import */ var _core_module__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/module */ \"./core/module.js\");\n/* harmony import */ var _formats_table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../formats/table */ \"./formats/table.js\");\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\n\n\n\nclass Table extends _core_module__WEBPACK_IMPORTED_MODULE_2__[\"default\"] {\n  static register() {\n    _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].register(_formats_table__WEBPACK_IMPORTED_MODULE_3__[\"TableCell\"]);\n    _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].register(_formats_table__WEBPACK_IMPORTED_MODULE_3__[\"TableRow\"]);\n    _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].register(_formats_table__WEBPACK_IMPORTED_MODULE_3__[\"TableBody\"]);\n    _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].register(_formats_table__WEBPACK_IMPORTED_MODULE_3__[\"TableContainer\"]);\n  }\n\n  constructor() {\n    super(...arguments);\n    this.listenBalanceCells();\n  }\n\n  balanceTables() {\n    this.quill.scroll.descendants(_formats_table__WEBPACK_IMPORTED_MODULE_3__[\"TableContainer\"]).forEach(table => {\n      table.balanceCells();\n    });\n  }\n\n  deleteColumn() {\n    const _this$getTable = this.getTable(),\n          _this$getTable2 = _slicedToArray(_this$getTable, 3),\n          table = _this$getTable2[0],\n          cell = _this$getTable2[2];\n\n    if (cell == null) return;\n    table.deleteColumn(cell.cellOffset());\n    this.quill.update(_core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n  }\n\n  deleteRow() {\n    const _this$getTable3 = this.getTable(),\n          _this$getTable4 = _slicedToArray(_this$getTable3, 2),\n          row = _this$getTable4[1];\n\n    if (row == null) return;\n    row.remove();\n    this.quill.update(_core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n  }\n\n  deleteTable() {\n    const _this$getTable5 = this.getTable(),\n          _this$getTable6 = _slicedToArray(_this$getTable5, 1),\n          table = _this$getTable6[0];\n\n    if (table == null) return;\n    const offset = table.offset();\n    table.remove();\n    this.quill.update(_core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n    this.quill.setSelection(offset, _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.SILENT);\n  }\n\n  getTable() {\n    let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();\n    if (range == null) return [null, null, null, -1];\n\n    const _this$quill$getLine = this.quill.getLine(range.index),\n          _this$quill$getLine2 = _slicedToArray(_this$quill$getLine, 2),\n          cell = _this$quill$getLine2[0],\n          offset = _this$quill$getLine2[1];\n\n    if (cell == null || cell.statics.blotName !== _formats_table__WEBPACK_IMPORTED_MODULE_3__[\"TableCell\"].blotName) {\n      return [null, null, null, -1];\n    }\n\n    const row = cell.parent;\n    const table = row.parent.parent;\n    return [table, row, cell, offset];\n  }\n\n  insertColumn(offset) {\n    const range = this.quill.getSelection();\n\n    const _this$getTable7 = this.getTable(range),\n          _this$getTable8 = _slicedToArray(_this$getTable7, 3),\n          table = _this$getTable8[0],\n          row = _this$getTable8[1],\n          cell = _this$getTable8[2];\n\n    if (cell == null) return;\n    const column = cell.cellOffset();\n    table.insertColumn(column + offset);\n    this.quill.update(_core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n    let shift = row.rowOffset();\n\n    if (offset === 0) {\n      shift += 1;\n    }\n\n    this.quill.setSelection(range.index + shift, range.length, _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.SILENT);\n  }\n\n  insertColumnLeft() {\n    this.insertColumn(0);\n  }\n\n  insertColumnRight() {\n    this.insertColumn(1);\n  }\n\n  insertRow(offset) {\n    const range = this.quill.getSelection();\n\n    const _this$getTable9 = this.getTable(range),\n          _this$getTable10 = _slicedToArray(_this$getTable9, 3),\n          table = _this$getTable10[0],\n          row = _this$getTable10[1],\n          cell = _this$getTable10[2];\n\n    if (cell == null) return;\n    const index = row.rowOffset();\n    table.insertRow(index + offset);\n    this.quill.update(_core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n\n    if (offset > 0) {\n      this.quill.setSelection(range, _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.SILENT);\n    } else {\n      this.quill.setSelection(range.index + row.children.length, range.length, _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.SILENT);\n    }\n  }\n\n  insertRowAbove() {\n    this.insertRow(0);\n  }\n\n  insertRowBelow() {\n    this.insertRow(1);\n  }\n\n  insertTable(rows, columns) {\n    const range = this.quill.getSelection();\n    if (range == null) return;\n    const delta = new Array(rows).fill(0).reduce(memo => {\n      const text = new Array(columns).fill('\\n').join('');\n      return memo.insert(text, {\n        table: Object(_formats_table__WEBPACK_IMPORTED_MODULE_3__[\"tableId\"])()\n      });\n    }, new quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a().retain(range.index));\n    this.quill.updateContents(delta, _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n    this.quill.setSelection(range.index, _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.SILENT);\n    this.balanceTables();\n  }\n\n  listenBalanceCells() {\n    this.quill.on(_core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.SCROLL_OPTIMIZE, mutations => {\n      mutations.some(mutation => {\n        if (['TD', 'TR', 'TBODY', 'TABLE'].includes(mutation.target.tagName)) {\n          this.quill.once(_core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.TEXT_CHANGE, (delta, old, source) => {\n            if (source !== _core_quill__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER) return;\n            this.balanceTables();\n          });\n          return true;\n        }\n\n        return false;\n      });\n    });\n  }\n\n}\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (Table);\n\n//# sourceURL=webpack://Quill/./modules/table.js?");

/***/ }),

/***/ "./modules/toolbar.js":
/*!****************************!*\
  !*** ./modules/toolbar.js ***!
  \****************************/
/*! exports provided: default, addControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Toolbar; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"addControls\", function() { return addControls; });\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta */ \"./node_modules/quill-delta/dist/Delta.js\");\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var parchment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! parchment */ \"./node_modules/parchment/src/parchment.ts\");\n/* harmony import */ var _core_quill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/quill */ \"./core/quill.js\");\n/* harmony import */ var _core_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/logger */ \"./core/logger.js\");\n/* harmony import */ var _core_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../core/module */ \"./core/module.js\");\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\n\n\n\nconst supportsRootNode = 'getRootNode' in document;\nconst debug = Object(_core_logger__WEBPACK_IMPORTED_MODULE_3__[\"default\"])('quill:toolbar');\n\nclass Toolbar extends _core_module__WEBPACK_IMPORTED_MODULE_4__[\"default\"] {\n  constructor(quill, options) {\n    super(quill, options);\n\n    if (Array.isArray(this.options.container)) {\n      const container = document.createElement('div');\n      addControls(container, this.options.container);\n      quill.container.parentNode.insertBefore(container, quill.container);\n      this.container = container;\n    } else if (typeof this.options.container === 'string') {\n      const rootDocument = supportsRootNode ? quill.container.getRootNode() : document;\n      this.container = rootDocument.querySelector(this.options.container);\n    } else {\n      this.container = this.options.container;\n    }\n\n    if (!(this.container instanceof HTMLElement)) {\n      return debug.error('Container required for toolbar', this.options);\n    }\n\n    this.container.classList.add('ql-toolbar');\n    this.controls = [];\n    this.handlers = {};\n    Object.keys(this.options.handlers).forEach(format => {\n      this.addHandler(format, this.options.handlers[format]);\n    });\n    Array.from(this.container.querySelectorAll('button, select')).forEach(input => {\n      this.attach(input);\n    });\n    this.quill.on(_core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].events.EDITOR_CHANGE, (type, range) => {\n      if (type === _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].events.SELECTION_CHANGE) {\n        this.update(range);\n      }\n    });\n    this.quill.on(_core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].events.SCROLL_OPTIMIZE, () => {\n      const _this$quill$selection = this.quill.selection.getRange(),\n            _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),\n            range = _this$quill$selection2[0]; // quill.getSelection triggers update\n\n\n      this.update(range);\n    });\n  }\n\n  addHandler(format, handler) {\n    this.handlers[format] = handler;\n  }\n\n  attach(input) {\n    let format = Array.from(input.classList).find(className => {\n      return className.indexOf('ql-') === 0;\n    });\n    if (!format) return;\n    format = format.slice('ql-'.length);\n\n    if (input.tagName === 'BUTTON') {\n      input.setAttribute('type', 'button');\n    }\n\n    if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {\n      debug.warn('ignoring attaching to nonexistent format', format, input);\n      return;\n    }\n\n    const eventName = input.tagName === 'SELECT' ? 'change' : 'click';\n    input.addEventListener(eventName, e => {\n      let value;\n\n      if (input.tagName === 'SELECT') {\n        if (input.selectedIndex < 0) return;\n        const selected = input.options[input.selectedIndex];\n\n        if (selected.hasAttribute('selected')) {\n          value = false;\n        } else {\n          value = selected.value || false;\n        }\n      } else {\n        if (input.classList.contains('ql-active')) {\n          value = false;\n        } else {\n          value = input.value || !input.hasAttribute('value');\n        }\n\n        e.preventDefault();\n      }\n\n      this.quill.focus();\n\n      const _this$quill$selection3 = this.quill.selection.getRange(),\n            _this$quill$selection4 = _slicedToArray(_this$quill$selection3, 1),\n            range = _this$quill$selection4[0];\n\n      if (this.handlers[format] != null) {\n        this.handlers[format].call(this, value);\n      } else if (this.quill.scroll.query(format).prototype instanceof parchment__WEBPACK_IMPORTED_MODULE_1__[\"EmbedBlot\"]) {\n        value = prompt(\"Enter \".concat(format)); // eslint-disable-line no-alert\n\n        if (!value) return;\n        this.quill.updateContents(new quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a().retain(range.index).delete(range.length).insert({\n          [format]: value\n        }), _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n      } else {\n        this.quill.format(format, value, _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n      }\n\n      this.update(range);\n    });\n    this.controls.push([format, input]);\n  }\n\n  update(range) {\n    const formats = range == null ? {} : this.quill.getFormat(range);\n    this.controls.forEach(pair => {\n      const _pair = _slicedToArray(pair, 2),\n            format = _pair[0],\n            input = _pair[1];\n\n      if (input.tagName === 'SELECT') {\n        let option;\n\n        if (range == null) {\n          option = null;\n        } else if (formats[format] == null) {\n          option = input.querySelector('option[selected]');\n        } else if (!Array.isArray(formats[format])) {\n          let value = formats[format];\n\n          if (typeof value === 'string') {\n            value = value.replace(/\"/g, '\\\\\"');\n          }\n\n          option = input.querySelector(\"option[value=\\\"\".concat(value, \"\\\"]\"));\n        }\n\n        if (option == null) {\n          input.value = ''; // TODO make configurable?\n\n          input.selectedIndex = -1;\n        } else {\n          option.selected = true;\n        }\n      } else if (range == null) {\n        input.classList.remove('ql-active');\n      } else if (input.hasAttribute('value')) {\n        // both being null should match (default values)\n        // '1' should match with 1 (headers)\n        const isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');\n        input.classList.toggle('ql-active', isActive);\n      } else {\n        input.classList.toggle('ql-active', formats[format] != null);\n      }\n    });\n  }\n\n}\n\nToolbar.DEFAULTS = {};\n\nfunction addButton(container, format, value) {\n  const input = document.createElement('button');\n  input.setAttribute('type', 'button');\n  input.classList.add(\"ql-\".concat(format));\n\n  if (value != null) {\n    input.value = value;\n  }\n\n  container.appendChild(input);\n}\n\nfunction addControls(container, groups) {\n  if (!Array.isArray(groups[0])) {\n    groups = [groups];\n  }\n\n  groups.forEach(controls => {\n    const group = document.createElement('span');\n    group.classList.add('ql-formats');\n    controls.forEach(control => {\n      if (typeof control === 'string') {\n        addButton(group, control);\n      } else {\n        const format = Object.keys(control)[0];\n        const value = control[format];\n\n        if (Array.isArray(value)) {\n          addSelect(group, format, value);\n        } else {\n          addButton(group, format, value);\n        }\n      }\n    });\n    container.appendChild(group);\n  });\n}\n\nfunction addSelect(container, format, values) {\n  const input = document.createElement('select');\n  input.classList.add(\"ql-\".concat(format));\n  values.forEach(value => {\n    const option = document.createElement('option');\n\n    if (value !== false) {\n      option.setAttribute('value', value);\n    } else {\n      option.setAttribute('selected', 'selected');\n    }\n\n    input.appendChild(option);\n  });\n  container.appendChild(input);\n}\n\nToolbar.DEFAULTS = {\n  container: null,\n  handlers: {\n    clean() {\n      const range = this.quill.getSelection();\n      if (range == null) return;\n\n      if (range.length === 0) {\n        const formats = this.quill.getFormat();\n        Object.keys(formats).forEach(name => {\n          // Clean functionality in existing apps only clean inline formats\n          if (this.quill.scroll.query(name, parchment__WEBPACK_IMPORTED_MODULE_1__[\"Scope\"].INLINE) != null) {\n            this.quill.format(name, false, _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n          }\n        });\n      } else {\n        this.quill.removeFormat(range, _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n      }\n    },\n\n    direction(value) {\n      const _this$quill$getFormat = this.quill.getFormat(),\n            align = _this$quill$getFormat.align;\n\n      if (value === 'rtl' && align == null) {\n        this.quill.format('align', 'right', _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n      } else if (!value && align === 'right') {\n        this.quill.format('align', false, _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n      }\n\n      this.quill.format('direction', value, _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n    },\n\n    indent(value) {\n      const range = this.quill.getSelection();\n      const formats = this.quill.getFormat(range);\n      const indent = parseInt(formats.indent || 0, 10);\n\n      if (value === '+1' || value === '-1') {\n        let modifier = value === '+1' ? 1 : -1;\n        if (formats.direction === 'rtl') modifier *= -1;\n        this.quill.format('indent', indent + modifier, _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n      }\n    },\n\n    link(value) {\n      if (value === true) {\n        value = prompt('Enter link URL:'); // eslint-disable-line no-alert\n      }\n\n      this.quill.format('link', value, _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n    },\n\n    list(value) {\n      const range = this.quill.getSelection();\n      const formats = this.quill.getFormat(range);\n\n      if (value === 'check') {\n        if (formats.list === 'checked' || formats.list === 'unchecked') {\n          this.quill.format('list', false, _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n        } else {\n          this.quill.format('list', 'unchecked', _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n        }\n      } else {\n        this.quill.format('list', value, _core_quill__WEBPACK_IMPORTED_MODULE_2__[\"default\"].sources.USER);\n      }\n    }\n\n  }\n};\n\n\n//# sourceURL=webpack://Quill/./modules/toolbar.js?");

/***/ }),

/***/ "./modules/uploader.js":
/*!*****************************!*\
  !*** ./modules/uploader.js ***!
  \*****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta */ \"./node_modules/quill-delta/dist/Delta.js\");\n/* harmony import */ var quill_delta__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _core_emitter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/emitter */ \"./core/emitter.js\");\n/* harmony import */ var _core_module__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/module */ \"./core/module.js\");\n\n\n\n\nclass Uploader extends _core_module__WEBPACK_IMPORTED_MODULE_2__[\"default\"] {\n  constructor(quill, options) {\n    super(quill, options);\n    quill.root.addEventListener('drop', e => {\n      e.preventDefault();\n      let native;\n\n      if (document.caretRangeFromPoint) {\n        native = document.caretRangeFromPoint(e.clientX, e.clientY);\n      } else if (document.caretPositionFromPoint) {\n        const position = document.caretPositionFromPoint(e.clientX, e.clientY);\n        native = document.createRange();\n        native.setStart(position.offsetNode, position.offset);\n        native.setEnd(position.offsetNode, position.offset);\n      } else {\n        return;\n      }\n\n      const normalized = quill.selection.normalizeNative(native);\n      const range = quill.selection.normalizedToRange(normalized);\n      this.upload(range, e.dataTransfer.files);\n    });\n  }\n\n  upload(range, files) {\n    const uploads = [];\n    Array.from(files).forEach(file => {\n      if (file && this.options.mimetypes.includes(file.type)) {\n        uploads.push(file);\n      }\n    });\n\n    if (uploads.length > 0) {\n      this.options.handler.call(this, range, uploads);\n    }\n  }\n\n}\n\nUploader.DEFAULTS = {\n  mimetypes: ['image/png', 'image/jpeg'],\n\n  handler(range, files) {\n    const promises = files.map(file => {\n      return new Promise(resolve => {\n        const reader = new FileReader();\n\n        reader.onload = e => {\n          resolve(e.target.result);\n        };\n\n        reader.readAsDataURL(file);\n      });\n    });\n    Promise.all(promises).then(images => {\n      const update = images.reduce((delta, image) => {\n        return delta.insert({\n          image\n        });\n      }, new quill_delta__WEBPACK_IMPORTED_MODULE_0___default.a().retain(range.index).delete(range.length));\n      this.quill.updateContents(update, _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n      this.quill.setSelection(range.index + images.length, _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.SILENT);\n    });\n  }\n\n};\n/* harmony default export */ __webpack_exports__[\"default\"] = (Uploader);\n\n//# sourceURL=webpack://Quill/./modules/uploader.js?");

/***/ }),

/***/ "./node_modules/clone/clone.js":
/*!*************************************!*\
  !*** ./node_modules/clone/clone.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("var clone = (function() {\n'use strict';\n\nfunction _instanceof(obj, type) {\n  return type != null && obj instanceof type;\n}\n\nvar nativeMap;\ntry {\n  nativeMap = Map;\n} catch(_) {\n  // maybe a reference error because no `Map`. Give it a dummy value that no\n  // value will ever be an instanceof.\n  nativeMap = function() {};\n}\n\nvar nativeSet;\ntry {\n  nativeSet = Set;\n} catch(_) {\n  nativeSet = function() {};\n}\n\nvar nativePromise;\ntry {\n  nativePromise = Promise;\n} catch(_) {\n  nativePromise = function() {};\n}\n\n/**\n * Clones (copies) an Object using deep copying.\n *\n * This function supports circular references by default, but if you are certain\n * there are no circular references in your object, you can save some CPU time\n * by calling clone(obj, false).\n *\n * Caution: if `circular` is false and `parent` contains circular references,\n * your program may enter an infinite loop and crash.\n *\n * @param `parent` - the object to be cloned\n * @param `circular` - set to true if the object to be cloned may contain\n *    circular references. (optional - true by default)\n * @param `depth` - set to a number if the object is only to be cloned to\n *    a particular depth. (optional - defaults to Infinity)\n * @param `prototype` - sets the prototype to be used when cloning an object.\n *    (optional - defaults to parent prototype).\n * @param `includeNonEnumerable` - set to true if the non-enumerable properties\n *    should be cloned as well. Non-enumerable properties on the prototype\n *    chain will be ignored. (optional - false by default)\n*/\nfunction clone(parent, circular, depth, prototype, includeNonEnumerable) {\n  if (typeof circular === 'object') {\n    depth = circular.depth;\n    prototype = circular.prototype;\n    includeNonEnumerable = circular.includeNonEnumerable;\n    circular = circular.circular;\n  }\n  // maintain two arrays for circular references, where corresponding parents\n  // and children have the same index\n  var allParents = [];\n  var allChildren = [];\n\n  var useBuffer = typeof Buffer != 'undefined';\n\n  if (typeof circular == 'undefined')\n    circular = true;\n\n  if (typeof depth == 'undefined')\n    depth = Infinity;\n\n  // recurse this function so we don't reset allParents and allChildren\n  function _clone(parent, depth) {\n    // cloning null always returns null\n    if (parent === null)\n      return null;\n\n    if (depth === 0)\n      return parent;\n\n    var child;\n    var proto;\n    if (typeof parent != 'object') {\n      return parent;\n    }\n\n    if (_instanceof(parent, nativeMap)) {\n      child = new nativeMap();\n    } else if (_instanceof(parent, nativeSet)) {\n      child = new nativeSet();\n    } else if (_instanceof(parent, nativePromise)) {\n      child = new nativePromise(function (resolve, reject) {\n        parent.then(function(value) {\n          resolve(_clone(value, depth - 1));\n        }, function(err) {\n          reject(_clone(err, depth - 1));\n        });\n      });\n    } else if (clone.__isArray(parent)) {\n      child = [];\n    } else if (clone.__isRegExp(parent)) {\n      child = new RegExp(parent.source, __getRegExpFlags(parent));\n      if (parent.lastIndex) child.lastIndex = parent.lastIndex;\n    } else if (clone.__isDate(parent)) {\n      child = new Date(parent.getTime());\n    } else if (useBuffer && Buffer.isBuffer(parent)) {\n      if (Buffer.allocUnsafe) {\n        // Node.js >= 4.5.0\n        child = Buffer.allocUnsafe(parent.length);\n      } else {\n        // Older Node.js versions\n        child = new Buffer(parent.length);\n      }\n      parent.copy(child);\n      return child;\n    } else if (_instanceof(parent, Error)) {\n      child = Object.create(parent);\n    } else {\n      if (typeof prototype == 'undefined') {\n        proto = Object.getPrototypeOf(parent);\n        child = Object.create(proto);\n      }\n      else {\n        child = Object.create(prototype);\n        proto = prototype;\n      }\n    }\n\n    if (circular) {\n      var index = allParents.indexOf(parent);\n\n      if (index != -1) {\n        return allChildren[index];\n      }\n      allParents.push(parent);\n      allChildren.push(child);\n    }\n\n    if (_instanceof(parent, nativeMap)) {\n      parent.forEach(function(value, key) {\n        var keyChild = _clone(key, depth - 1);\n        var valueChild = _clone(value, depth - 1);\n        child.set(keyChild, valueChild);\n      });\n    }\n    if (_instanceof(parent, nativeSet)) {\n      parent.forEach(function(value) {\n        var entryChild = _clone(value, depth - 1);\n        child.add(entryChild);\n      });\n    }\n\n    for (var i in parent) {\n      var attrs;\n      if (proto) {\n        attrs = Object.getOwnPropertyDescriptor(proto, i);\n      }\n\n      if (attrs && attrs.set == null) {\n        continue;\n      }\n      child[i] = _clone(parent[i], depth - 1);\n    }\n\n    if (Object.getOwnPropertySymbols) {\n      var symbols = Object.getOwnPropertySymbols(parent);\n      for (var i = 0; i < symbols.length; i++) {\n        // Don't need to worry about cloning a symbol because it is a primitive,\n        // like a number or string.\n        var symbol = symbols[i];\n        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);\n        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {\n          continue;\n        }\n        child[symbol] = _clone(parent[symbol], depth - 1);\n        if (!descriptor.enumerable) {\n          Object.defineProperty(child, symbol, {\n            enumerable: false\n          });\n        }\n      }\n    }\n\n    if (includeNonEnumerable) {\n      var allPropertyNames = Object.getOwnPropertyNames(parent);\n      for (var i = 0; i < allPropertyNames.length; i++) {\n        var propertyName = allPropertyNames[i];\n        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);\n        if (descriptor && descriptor.enumerable) {\n          continue;\n        }\n        child[propertyName] = _clone(parent[propertyName], depth - 1);\n        Object.defineProperty(child, propertyName, {\n          enumerable: false\n        });\n      }\n    }\n\n    return child;\n  }\n\n  return _clone(parent, depth);\n}\n\n/**\n * Simple flat clone using prototype, accepts only objects, usefull for property\n * override on FLAT configuration object (no nested props).\n *\n * USE WITH CAUTION! This may not behave as you wish if you do not know how this\n * works.\n */\nclone.clonePrototype = function clonePrototype(parent) {\n  if (parent === null)\n    return null;\n\n  var c = function () {};\n  c.prototype = parent;\n  return new c();\n};\n\n// private utility functions\n\nfunction __objToStr(o) {\n  return Object.prototype.toString.call(o);\n}\nclone.__objToStr = __objToStr;\n\nfunction __isDate(o) {\n  return typeof o === 'object' && __objToStr(o) === '[object Date]';\n}\nclone.__isDate = __isDate;\n\nfunction __isArray(o) {\n  return typeof o === 'object' && __objToStr(o) === '[object Array]';\n}\nclone.__isArray = __isArray;\n\nfunction __isRegExp(o) {\n  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';\n}\nclone.__isRegExp = __isRegExp;\n\nfunction __getRegExpFlags(re) {\n  var flags = '';\n  if (re.global) flags += 'g';\n  if (re.ignoreCase) flags += 'i';\n  if (re.multiline) flags += 'm';\n  return flags;\n}\nclone.__getRegExpFlags = __getRegExpFlags;\n\nreturn clone;\n})();\n\nif (typeof module === 'object' && module.exports) {\n  module.exports = clone;\n}\n\n\n//# sourceURL=webpack://Quill/./node_modules/clone/clone.js?");

/***/ }),

/***/ "./node_modules/deep-equal/index.js":
/*!******************************************!*\
  !*** ./node_modules/deep-equal/index.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

eval("var pSlice = Array.prototype.slice;\nvar objectKeys = __webpack_require__(/*! ./lib/keys.js */ \"./node_modules/deep-equal/lib/keys.js\");\nvar isArguments = __webpack_require__(/*! ./lib/is_arguments.js */ \"./node_modules/deep-equal/lib/is_arguments.js\");\n\nvar deepEqual = module.exports = function (actual, expected, opts) {\n  if (!opts) opts = {};\n  // 7.1. All identical values are equivalent, as determined by ===.\n  if (actual === expected) {\n    return true;\n\n  } else if (actual instanceof Date && expected instanceof Date) {\n    return actual.getTime() === expected.getTime();\n\n  // 7.3. Other pairs that do not both pass typeof value == 'object',\n  // equivalence is determined by ==.\n  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {\n    return opts.strict ? actual === expected : actual == expected;\n\n  // 7.4. For all other Object pairs, including Array objects, equivalence is\n  // determined by having the same number of owned properties (as verified\n  // with Object.prototype.hasOwnProperty.call), the same set of keys\n  // (although not necessarily the same order), equivalent values for every\n  // corresponding key, and an identical 'prototype' property. Note: this\n  // accounts for both named and indexed properties on Arrays.\n  } else {\n    return objEquiv(actual, expected, opts);\n  }\n}\n\nfunction isUndefinedOrNull(value) {\n  return value === null || value === undefined;\n}\n\nfunction isBuffer (x) {\n  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;\n  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {\n    return false;\n  }\n  if (x.length > 0 && typeof x[0] !== 'number') return false;\n  return true;\n}\n\nfunction objEquiv(a, b, opts) {\n  var i, key;\n  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))\n    return false;\n  // an identical 'prototype' property.\n  if (a.prototype !== b.prototype) return false;\n  //~~~I've managed to break Object.keys through screwy arguments passing.\n  //   Converting to array solves the problem.\n  if (isArguments(a)) {\n    if (!isArguments(b)) {\n      return false;\n    }\n    a = pSlice.call(a);\n    b = pSlice.call(b);\n    return deepEqual(a, b, opts);\n  }\n  if (isBuffer(a)) {\n    if (!isBuffer(b)) {\n      return false;\n    }\n    if (a.length !== b.length) return false;\n    for (i = 0; i < a.length; i++) {\n      if (a[i] !== b[i]) return false;\n    }\n    return true;\n  }\n  try {\n    var ka = objectKeys(a),\n        kb = objectKeys(b);\n  } catch (e) {//happens when one is a string literal and the other isn't\n    return false;\n  }\n  // having the same number of owned properties (keys incorporates\n  // hasOwnProperty)\n  if (ka.length != kb.length)\n    return false;\n  //the same set of keys (although not necessarily the same order),\n  ka.sort();\n  kb.sort();\n  //~~~cheap key test\n  for (i = ka.length - 1; i >= 0; i--) {\n    if (ka[i] != kb[i])\n      return false;\n  }\n  //equivalent values for every corresponding key, and\n  //~~~possibly expensive deep test\n  for (i = ka.length - 1; i >= 0; i--) {\n    key = ka[i];\n    if (!deepEqual(a[key], b[key], opts)) return false;\n  }\n  return typeof a === typeof b;\n}\n\n\n//# sourceURL=webpack://Quill/./node_modules/deep-equal/index.js?");

/***/ }),

/***/ "./node_modules/deep-equal/lib/is_arguments.js":
/*!*****************************************************!*\
  !*** ./node_modules/deep-equal/lib/is_arguments.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("var supportsArgumentsClass = (function(){\n  return Object.prototype.toString.call(arguments)\n})() == '[object Arguments]';\n\nexports = module.exports = supportsArgumentsClass ? supported : unsupported;\n\nexports.supported = supported;\nfunction supported(object) {\n  return Object.prototype.toString.call(object) == '[object Arguments]';\n};\n\nexports.unsupported = unsupported;\nfunction unsupported(object){\n  return object &&\n    typeof object == 'object' &&\n    typeof object.length == 'number' &&\n    Object.prototype.hasOwnProperty.call(object, 'callee') &&\n    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||\n    false;\n};\n\n\n//# sourceURL=webpack://Quill/./node_modules/deep-equal/lib/is_arguments.js?");

/***/ }),

/***/ "./node_modules/deep-equal/lib/keys.js":
/*!*********************************************!*\
  !*** ./node_modules/deep-equal/lib/keys.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("exports = module.exports = typeof Object.keys === 'function'\n  ? Object.keys : shim;\n\nexports.shim = shim;\nfunction shim (obj) {\n  var keys = [];\n  for (var key in obj) keys.push(key);\n  return keys;\n}\n\n\n//# sourceURL=webpack://Quill/./node_modules/deep-equal/lib/keys.js?");

/***/ }),

/***/ "./node_modules/eventemitter3/index.js":
/*!*********************************************!*\
  !*** ./node_modules/eventemitter3/index.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("'use strict';\n\nvar has = Object.prototype.hasOwnProperty\n  , prefix = '~';\n\n/**\n * Constructor to create a storage for our `EE` objects.\n * An `Events` instance is a plain object whose properties are event names.\n *\n * @constructor\n * @private\n */\nfunction Events() {}\n\n//\n// We try to not inherit from `Object.prototype`. In some engines creating an\n// instance in this way is faster than calling `Object.create(null)` directly.\n// If `Object.create(null)` is not supported we prefix the event names with a\n// character to make sure that the built-in object properties are not\n// overridden or used as an attack vector.\n//\nif (Object.create) {\n  Events.prototype = Object.create(null);\n\n  //\n  // This hack is needed because the `__proto__` property is still inherited in\n  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.\n  //\n  if (!new Events().__proto__) prefix = false;\n}\n\n/**\n * Representation of a single event listener.\n *\n * @param {Function} fn The listener function.\n * @param {*} context The context to invoke the listener with.\n * @param {Boolean} [once=false] Specify if the listener is a one-time listener.\n * @constructor\n * @private\n */\nfunction EE(fn, context, once) {\n  this.fn = fn;\n  this.context = context;\n  this.once = once || false;\n}\n\n/**\n * Add a listener for a given event.\n *\n * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.\n * @param {(String|Symbol)} event The event name.\n * @param {Function} fn The listener function.\n * @param {*} context The context to invoke the listener with.\n * @param {Boolean} once Specify if the listener is a one-time listener.\n * @returns {EventEmitter}\n * @private\n */\nfunction addListener(emitter, event, fn, context, once) {\n  if (typeof fn !== 'function') {\n    throw new TypeError('The listener must be a function');\n  }\n\n  var listener = new EE(fn, context || emitter, once)\n    , evt = prefix ? prefix + event : event;\n\n  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;\n  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);\n  else emitter._events[evt] = [emitter._events[evt], listener];\n\n  return emitter;\n}\n\n/**\n * Clear event by name.\n *\n * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.\n * @param {(String|Symbol)} evt The Event name.\n * @private\n */\nfunction clearEvent(emitter, evt) {\n  if (--emitter._eventsCount === 0) emitter._events = new Events();\n  else delete emitter._events[evt];\n}\n\n/**\n * Minimal `EventEmitter` interface that is molded against the Node.js\n * `EventEmitter` interface.\n *\n * @constructor\n * @public\n */\nfunction EventEmitter() {\n  this._events = new Events();\n  this._eventsCount = 0;\n}\n\n/**\n * Return an array listing the events for which the emitter has registered\n * listeners.\n *\n * @returns {Array}\n * @public\n */\nEventEmitter.prototype.eventNames = function eventNames() {\n  var names = []\n    , events\n    , name;\n\n  if (this._eventsCount === 0) return names;\n\n  for (name in (events = this._events)) {\n    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);\n  }\n\n  if (Object.getOwnPropertySymbols) {\n    return names.concat(Object.getOwnPropertySymbols(events));\n  }\n\n  return names;\n};\n\n/**\n * Return the listeners registered for a given event.\n *\n * @param {(String|Symbol)} event The event name.\n * @returns {Array} The registered listeners.\n * @public\n */\nEventEmitter.prototype.listeners = function listeners(event) {\n  var evt = prefix ? prefix + event : event\n    , handlers = this._events[evt];\n\n  if (!handlers) return [];\n  if (handlers.fn) return [handlers.fn];\n\n  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {\n    ee[i] = handlers[i].fn;\n  }\n\n  return ee;\n};\n\n/**\n * Return the number of listeners listening to a given event.\n *\n * @param {(String|Symbol)} event The event name.\n * @returns {Number} The number of listeners.\n * @public\n */\nEventEmitter.prototype.listenerCount = function listenerCount(event) {\n  var evt = prefix ? prefix + event : event\n    , listeners = this._events[evt];\n\n  if (!listeners) return 0;\n  if (listeners.fn) return 1;\n  return listeners.length;\n};\n\n/**\n * Calls each of the listeners registered for a given event.\n *\n * @param {(String|Symbol)} event The event name.\n * @returns {Boolean} `true` if the event had listeners, else `false`.\n * @public\n */\nEventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {\n  var evt = prefix ? prefix + event : event;\n\n  if (!this._events[evt]) return false;\n\n  var listeners = this._events[evt]\n    , len = arguments.length\n    , args\n    , i;\n\n  if (listeners.fn) {\n    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);\n\n    switch (len) {\n      case 1: return listeners.fn.call(listeners.context), true;\n      case 2: return listeners.fn.call(listeners.context, a1), true;\n      case 3: return listeners.fn.call(listeners.context, a1, a2), true;\n      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;\n      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;\n      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;\n    }\n\n    for (i = 1, args = new Array(len -1); i < len; i++) {\n      args[i - 1] = arguments[i];\n    }\n\n    listeners.fn.apply(listeners.context, args);\n  } else {\n    var length = listeners.length\n      , j;\n\n    for (i = 0; i < length; i++) {\n      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);\n\n      switch (len) {\n        case 1: listeners[i].fn.call(listeners[i].context); break;\n        case 2: listeners[i].fn.call(listeners[i].context, a1); break;\n        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;\n        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;\n        default:\n          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {\n            args[j - 1] = arguments[j];\n          }\n\n          listeners[i].fn.apply(listeners[i].context, args);\n      }\n    }\n  }\n\n  return true;\n};\n\n/**\n * Add a listener for a given event.\n *\n * @param {(String|Symbol)} event The event name.\n * @param {Function} fn The listener function.\n * @param {*} [context=this] The context to invoke the listener with.\n * @returns {EventEmitter} `this`.\n * @public\n */\nEventEmitter.prototype.on = function on(event, fn, context) {\n  return addListener(this, event, fn, context, false);\n};\n\n/**\n * Add a one-time listener for a given event.\n *\n * @param {(String|Symbol)} event The event name.\n * @param {Function} fn The listener function.\n * @param {*} [context=this] The context to invoke the listener with.\n * @returns {EventEmitter} `this`.\n * @public\n */\nEventEmitter.prototype.once = function once(event, fn, context) {\n  return addListener(this, event, fn, context, true);\n};\n\n/**\n * Remove the listeners of a given event.\n *\n * @param {(String|Symbol)} event The event name.\n * @param {Function} fn Only remove the listeners that match this function.\n * @param {*} context Only remove the listeners that have this context.\n * @param {Boolean} once Only remove one-time listeners.\n * @returns {EventEmitter} `this`.\n * @public\n */\nEventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {\n  var evt = prefix ? prefix + event : event;\n\n  if (!this._events[evt]) return this;\n  if (!fn) {\n    clearEvent(this, evt);\n    return this;\n  }\n\n  var listeners = this._events[evt];\n\n  if (listeners.fn) {\n    if (\n      listeners.fn === fn &&\n      (!once || listeners.once) &&\n      (!context || listeners.context === context)\n    ) {\n      clearEvent(this, evt);\n    }\n  } else {\n    for (var i = 0, events = [], length = listeners.length; i < length; i++) {\n      if (\n        listeners[i].fn !== fn ||\n        (once && !listeners[i].once) ||\n        (context && listeners[i].context !== context)\n      ) {\n        events.push(listeners[i]);\n      }\n    }\n\n    //\n    // Reset the array, or remove it completely if we have no more listeners.\n    //\n    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;\n    else clearEvent(this, evt);\n  }\n\n  return this;\n};\n\n/**\n * Remove all listeners, or those of the specified event.\n *\n * @param {(String|Symbol)} [event] The event name.\n * @returns {EventEmitter} `this`.\n * @public\n */\nEventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {\n  var evt;\n\n  if (event) {\n    evt = prefix ? prefix + event : event;\n    if (this._events[evt]) clearEvent(this, evt);\n  } else {\n    this._events = new Events();\n    this._eventsCount = 0;\n  }\n\n  return this;\n};\n\n//\n// Alias methods names because people roll like that.\n//\nEventEmitter.prototype.off = EventEmitter.prototype.removeListener;\nEventEmitter.prototype.addListener = EventEmitter.prototype.on;\n\n//\n// Expose the prefix.\n//\nEventEmitter.prefixed = prefix;\n\n//\n// Allow `EventEmitter` to be imported as module namespace.\n//\nEventEmitter.EventEmitter = EventEmitter;\n\n//\n// Expose the module.\n//\nif ('undefined' !== typeof module) {\n  module.exports = EventEmitter;\n}\n\n\n//# sourceURL=webpack://Quill/./node_modules/eventemitter3/index.js?");

/***/ }),

/***/ "./node_modules/extend/index.js":
/*!**************************************!*\
  !*** ./node_modules/extend/index.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("'use strict';\n\nvar hasOwn = Object.prototype.hasOwnProperty;\nvar toStr = Object.prototype.toString;\nvar defineProperty = Object.defineProperty;\nvar gOPD = Object.getOwnPropertyDescriptor;\n\nvar isArray = function isArray(arr) {\n\tif (typeof Array.isArray === 'function') {\n\t\treturn Array.isArray(arr);\n\t}\n\n\treturn toStr.call(arr) === '[object Array]';\n};\n\nvar isPlainObject = function isPlainObject(obj) {\n\tif (!obj || toStr.call(obj) !== '[object Object]') {\n\t\treturn false;\n\t}\n\n\tvar hasOwnConstructor = hasOwn.call(obj, 'constructor');\n\tvar hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');\n\t// Not own constructor property must be Object\n\tif (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {\n\t\treturn false;\n\t}\n\n\t// Own properties are enumerated firstly, so to speed up,\n\t// if last one is own, then all properties are own.\n\tvar key;\n\tfor (key in obj) { /**/ }\n\n\treturn typeof key === 'undefined' || hasOwn.call(obj, key);\n};\n\n// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target\nvar setProperty = function setProperty(target, options) {\n\tif (defineProperty && options.name === '__proto__') {\n\t\tdefineProperty(target, options.name, {\n\t\t\tenumerable: true,\n\t\t\tconfigurable: true,\n\t\t\tvalue: options.newValue,\n\t\t\twritable: true\n\t\t});\n\t} else {\n\t\ttarget[options.name] = options.newValue;\n\t}\n};\n\n// Return undefined instead of __proto__ if '__proto__' is not an own property\nvar getProperty = function getProperty(obj, name) {\n\tif (name === '__proto__') {\n\t\tif (!hasOwn.call(obj, name)) {\n\t\t\treturn void 0;\n\t\t} else if (gOPD) {\n\t\t\t// In early versions of node, obj['__proto__'] is buggy when obj has\n\t\t\t// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.\n\t\t\treturn gOPD(obj, name).value;\n\t\t}\n\t}\n\n\treturn obj[name];\n};\n\nmodule.exports = function extend() {\n\tvar options, name, src, copy, copyIsArray, clone;\n\tvar target = arguments[0];\n\tvar i = 1;\n\tvar length = arguments.length;\n\tvar deep = false;\n\n\t// Handle a deep copy situation\n\tif (typeof target === 'boolean') {\n\t\tdeep = target;\n\t\ttarget = arguments[1] || {};\n\t\t// skip the boolean and the target\n\t\ti = 2;\n\t}\n\tif (target == null || (typeof target !== 'object' && typeof target !== 'function')) {\n\t\ttarget = {};\n\t}\n\n\tfor (; i < length; ++i) {\n\t\toptions = arguments[i];\n\t\t// Only deal with non-null/undefined values\n\t\tif (options != null) {\n\t\t\t// Extend the base object\n\t\t\tfor (name in options) {\n\t\t\t\tsrc = getProperty(target, name);\n\t\t\t\tcopy = getProperty(options, name);\n\n\t\t\t\t// Prevent never-ending loop\n\t\t\t\tif (target !== copy) {\n\t\t\t\t\t// Recurse if we're merging plain objects or arrays\n\t\t\t\t\tif (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {\n\t\t\t\t\t\tif (copyIsArray) {\n\t\t\t\t\t\t\tcopyIsArray = false;\n\t\t\t\t\t\t\tclone = src && isArray(src) ? src : [];\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\tclone = src && isPlainObject(src) ? src : {};\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t// Never move original objects, clone them\n\t\t\t\t\t\tsetProperty(target, { name: name, newValue: extend(deep, clone, copy) });\n\n\t\t\t\t\t// Don't bring in undefined values\n\t\t\t\t\t} else if (typeof copy !== 'undefined') {\n\t\t\t\t\t\tsetProperty(target, { name: name, newValue: copy });\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// Return the modified object\n\treturn target;\n};\n\n\n//# sourceURL=webpack://Quill/./node_modules/extend/index.js?");

/***/ }),

/***/ "./node_modules/fast-diff/diff.js":
/*!****************************************!*\
  !*** ./node_modules/fast-diff/diff.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("/**\n * This library modifies the diff-patch-match library by Neil Fraser\n * by removing the patch and match functionality and certain advanced\n * options in the diff function. The original license is as follows:\n *\n * ===\n *\n * Diff Match and Patch\n *\n * Copyright 2006 Google Inc.\n * http://code.google.com/p/google-diff-match-patch/\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *   http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n\n/**\n * The data structure representing a diff is an array of tuples:\n * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]\n * which means: delete 'Hello', add 'Goodbye' and keep ' world.'\n */\nvar DIFF_DELETE = -1;\nvar DIFF_INSERT = 1;\nvar DIFF_EQUAL = 0;\n\n\n/**\n * Find the differences between two texts.  Simplifies the problem by stripping\n * any common prefix or suffix off the texts before diffing.\n * @param {string} text1 Old string to be diffed.\n * @param {string} text2 New string to be diffed.\n * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info\n * @return {Array} Array of diff tuples.\n */\nfunction diff_main(text1, text2, cursor_pos, _fix_unicode) {\n  // Check for equality\n  if (text1 === text2) {\n    if (text1) {\n      return [[DIFF_EQUAL, text1]];\n    }\n    return [];\n  }\n\n  if (cursor_pos != null) {\n    var editdiff = find_cursor_edit_diff(text1, text2, cursor_pos);\n    if (editdiff) {\n      return editdiff;\n    }\n  }\n\n  // Trim off common prefix (speedup).\n  var commonlength = diff_commonPrefix(text1, text2);\n  var commonprefix = text1.substring(0, commonlength);\n  text1 = text1.substring(commonlength);\n  text2 = text2.substring(commonlength);\n\n  // Trim off common suffix (speedup).\n  commonlength = diff_commonSuffix(text1, text2);\n  var commonsuffix = text1.substring(text1.length - commonlength);\n  text1 = text1.substring(0, text1.length - commonlength);\n  text2 = text2.substring(0, text2.length - commonlength);\n\n  // Compute the diff on the middle block.\n  var diffs = diff_compute_(text1, text2);\n\n  // Restore the prefix and suffix.\n  if (commonprefix) {\n    diffs.unshift([DIFF_EQUAL, commonprefix]);\n  }\n  if (commonsuffix) {\n    diffs.push([DIFF_EQUAL, commonsuffix]);\n  }\n  diff_cleanupMerge(diffs, _fix_unicode);\n  return diffs;\n};\n\n\n/**\n * Find the differences between two texts.  Assumes that the texts do not\n * have any common prefix or suffix.\n * @param {string} text1 Old string to be diffed.\n * @param {string} text2 New string to be diffed.\n * @return {Array} Array of diff tuples.\n */\nfunction diff_compute_(text1, text2) {\n  var diffs;\n\n  if (!text1) {\n    // Just add some text (speedup).\n    return [[DIFF_INSERT, text2]];\n  }\n\n  if (!text2) {\n    // Just delete some text (speedup).\n    return [[DIFF_DELETE, text1]];\n  }\n\n  var longtext = text1.length > text2.length ? text1 : text2;\n  var shorttext = text1.length > text2.length ? text2 : text1;\n  var i = longtext.indexOf(shorttext);\n  if (i !== -1) {\n    // Shorter text is inside the longer text (speedup).\n    diffs = [\n      [DIFF_INSERT, longtext.substring(0, i)],\n      [DIFF_EQUAL, shorttext],\n      [DIFF_INSERT, longtext.substring(i + shorttext.length)]\n    ];\n    // Swap insertions for deletions if diff is reversed.\n    if (text1.length > text2.length) {\n      diffs[0][0] = diffs[2][0] = DIFF_DELETE;\n    }\n    return diffs;\n  }\n\n  if (shorttext.length === 1) {\n    // Single character string.\n    // After the previous speedup, the character can't be an equality.\n    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];\n  }\n\n  // Check to see if the problem can be split in two.\n  var hm = diff_halfMatch_(text1, text2);\n  if (hm) {\n    // A half-match was found, sort out the return data.\n    var text1_a = hm[0];\n    var text1_b = hm[1];\n    var text2_a = hm[2];\n    var text2_b = hm[3];\n    var mid_common = hm[4];\n    // Send both pairs off for separate processing.\n    var diffs_a = diff_main(text1_a, text2_a);\n    var diffs_b = diff_main(text1_b, text2_b);\n    // Merge the results.\n    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);\n  }\n\n  return diff_bisect_(text1, text2);\n};\n\n\n/**\n * Find the 'middle snake' of a diff, split the problem in two\n * and return the recursively constructed diff.\n * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.\n * @param {string} text1 Old string to be diffed.\n * @param {string} text2 New string to be diffed.\n * @return {Array} Array of diff tuples.\n * @private\n */\nfunction diff_bisect_(text1, text2) {\n  // Cache the text lengths to prevent multiple calls.\n  var text1_length = text1.length;\n  var text2_length = text2.length;\n  var max_d = Math.ceil((text1_length + text2_length) / 2);\n  var v_offset = max_d;\n  var v_length = 2 * max_d;\n  var v1 = new Array(v_length);\n  var v2 = new Array(v_length);\n  // Setting all elements to -1 is faster in Chrome & Firefox than mixing\n  // integers and undefined.\n  for (var x = 0; x < v_length; x++) {\n    v1[x] = -1;\n    v2[x] = -1;\n  }\n  v1[v_offset + 1] = 0;\n  v2[v_offset + 1] = 0;\n  var delta = text1_length - text2_length;\n  // If the total number of characters is odd, then the front path will collide\n  // with the reverse path.\n  var front = (delta % 2 !== 0);\n  // Offsets for start and end of k loop.\n  // Prevents mapping of space beyond the grid.\n  var k1start = 0;\n  var k1end = 0;\n  var k2start = 0;\n  var k2end = 0;\n  for (var d = 0; d < max_d; d++) {\n    // Walk the front path one step.\n    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {\n      var k1_offset = v_offset + k1;\n      var x1;\n      if (k1 === -d || (k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1])) {\n        x1 = v1[k1_offset + 1];\n      } else {\n        x1 = v1[k1_offset - 1] + 1;\n      }\n      var y1 = x1 - k1;\n      while (\n        x1 < text1_length && y1 < text2_length &&\n        text1.charAt(x1) === text2.charAt(y1)\n      ) {\n        x1++;\n        y1++;\n      }\n      v1[k1_offset] = x1;\n      if (x1 > text1_length) {\n        // Ran off the right of the graph.\n        k1end += 2;\n      } else if (y1 > text2_length) {\n        // Ran off the bottom of the graph.\n        k1start += 2;\n      } else if (front) {\n        var k2_offset = v_offset + delta - k1;\n        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {\n          // Mirror x2 onto top-left coordinate system.\n          var x2 = text1_length - v2[k2_offset];\n          if (x1 >= x2) {\n            // Overlap detected.\n            return diff_bisectSplit_(text1, text2, x1, y1);\n          }\n        }\n      }\n    }\n\n    // Walk the reverse path one step.\n    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {\n      var k2_offset = v_offset + k2;\n      var x2;\n      if (k2 === -d || (k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1])) {\n        x2 = v2[k2_offset + 1];\n      } else {\n        x2 = v2[k2_offset - 1] + 1;\n      }\n      var y2 = x2 - k2;\n      while (\n        x2 < text1_length && y2 < text2_length &&\n        text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)\n      ) {\n        x2++;\n        y2++;\n      }\n      v2[k2_offset] = x2;\n      if (x2 > text1_length) {\n        // Ran off the left of the graph.\n        k2end += 2;\n      } else if (y2 > text2_length) {\n        // Ran off the top of the graph.\n        k2start += 2;\n      } else if (!front) {\n        var k1_offset = v_offset + delta - k2;\n        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {\n          var x1 = v1[k1_offset];\n          var y1 = v_offset + x1 - k1_offset;\n          // Mirror x2 onto top-left coordinate system.\n          x2 = text1_length - x2;\n          if (x1 >= x2) {\n            // Overlap detected.\n            return diff_bisectSplit_(text1, text2, x1, y1);\n          }\n        }\n      }\n    }\n  }\n  // Diff took too long and hit the deadline or\n  // number of diffs equals number of characters, no commonality at all.\n  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];\n};\n\n\n/**\n * Given the location of the 'middle snake', split the diff in two parts\n * and recurse.\n * @param {string} text1 Old string to be diffed.\n * @param {string} text2 New string to be diffed.\n * @param {number} x Index of split point in text1.\n * @param {number} y Index of split point in text2.\n * @return {Array} Array of diff tuples.\n */\nfunction diff_bisectSplit_(text1, text2, x, y) {\n  var text1a = text1.substring(0, x);\n  var text2a = text2.substring(0, y);\n  var text1b = text1.substring(x);\n  var text2b = text2.substring(y);\n\n  // Compute both diffs serially.\n  var diffs = diff_main(text1a, text2a);\n  var diffsb = diff_main(text1b, text2b);\n\n  return diffs.concat(diffsb);\n};\n\n\n/**\n * Determine the common prefix of two strings.\n * @param {string} text1 First string.\n * @param {string} text2 Second string.\n * @return {number} The number of characters common to the start of each\n *     string.\n */\nfunction diff_commonPrefix(text1, text2) {\n  // Quick check for common null cases.\n  if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) {\n    return 0;\n  }\n  // Binary search.\n  // Performance analysis: http://neil.fraser.name/news/2007/10/09/\n  var pointermin = 0;\n  var pointermax = Math.min(text1.length, text2.length);\n  var pointermid = pointermax;\n  var pointerstart = 0;\n  while (pointermin < pointermid) {\n    if (\n      text1.substring(pointerstart, pointermid) ==\n      text2.substring(pointerstart, pointermid)\n    ) {\n      pointermin = pointermid;\n      pointerstart = pointermin;\n    } else {\n      pointermax = pointermid;\n    }\n    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);\n  }\n\n  if (is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) {\n    pointermid--;\n  }\n\n  return pointermid;\n};\n\n\n/**\n * Determine the common suffix of two strings.\n * @param {string} text1 First string.\n * @param {string} text2 Second string.\n * @return {number} The number of characters common to the end of each string.\n */\nfunction diff_commonSuffix(text1, text2) {\n  // Quick check for common null cases.\n  if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) {\n    return 0;\n  }\n  // Binary search.\n  // Performance analysis: http://neil.fraser.name/news/2007/10/09/\n  var pointermin = 0;\n  var pointermax = Math.min(text1.length, text2.length);\n  var pointermid = pointermax;\n  var pointerend = 0;\n  while (pointermin < pointermid) {\n    if (\n      text1.substring(text1.length - pointermid, text1.length - pointerend) ==\n      text2.substring(text2.length - pointermid, text2.length - pointerend)\n    ) {\n      pointermin = pointermid;\n      pointerend = pointermin;\n    } else {\n      pointermax = pointermid;\n    }\n    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);\n  }\n\n  if (is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) {\n    pointermid--;\n  }\n\n  return pointermid;\n};\n\n\n/**\n * Do the two texts share a substring which is at least half the length of the\n * longer text?\n * This speedup can produce non-minimal diffs.\n * @param {string} text1 First string.\n * @param {string} text2 Second string.\n * @return {Array.<string>} Five element Array, containing the prefix of\n *     text1, the suffix of text1, the prefix of text2, the suffix of\n *     text2 and the common middle.  Or null if there was no match.\n */\nfunction diff_halfMatch_(text1, text2) {\n  var longtext = text1.length > text2.length ? text1 : text2;\n  var shorttext = text1.length > text2.length ? text2 : text1;\n  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {\n    return null;  // Pointless.\n  }\n\n  /**\n   * Does a substring of shorttext exist within longtext such that the substring\n   * is at least half the length of longtext?\n   * Closure, but does not reference any external variables.\n   * @param {string} longtext Longer string.\n   * @param {string} shorttext Shorter string.\n   * @param {number} i Start index of quarter length substring within longtext.\n   * @return {Array.<string>} Five element Array, containing the prefix of\n   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix\n   *     of shorttext and the common middle.  Or null if there was no match.\n   * @private\n   */\n  function diff_halfMatchI_(longtext, shorttext, i) {\n    // Start with a 1/4 length substring at position i as a seed.\n    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));\n    var j = -1;\n    var best_common = '';\n    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;\n    while ((j = shorttext.indexOf(seed, j + 1)) !== -1) {\n      var prefixLength = diff_commonPrefix(\n        longtext.substring(i), shorttext.substring(j));\n      var suffixLength = diff_commonSuffix(\n        longtext.substring(0, i), shorttext.substring(0, j));\n      if (best_common.length < suffixLength + prefixLength) {\n        best_common = shorttext.substring(\n          j - suffixLength, j) + shorttext.substring(j, j + prefixLength);\n        best_longtext_a = longtext.substring(0, i - suffixLength);\n        best_longtext_b = longtext.substring(i + prefixLength);\n        best_shorttext_a = shorttext.substring(0, j - suffixLength);\n        best_shorttext_b = shorttext.substring(j + prefixLength);\n      }\n    }\n    if (best_common.length * 2 >= longtext.length) {\n      return [\n        best_longtext_a, best_longtext_b,\n        best_shorttext_a, best_shorttext_b, best_common\n      ];\n    } else {\n      return null;\n    }\n  }\n\n  // First check if the second quarter is the seed for a half-match.\n  var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));\n  // Check again based on the third quarter.\n  var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));\n  var hm;\n  if (!hm1 && !hm2) {\n    return null;\n  } else if (!hm2) {\n    hm = hm1;\n  } else if (!hm1) {\n    hm = hm2;\n  } else {\n    // Both matched.  Select the longest.\n    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;\n  }\n\n  // A half-match was found, sort out the return data.\n  var text1_a, text1_b, text2_a, text2_b;\n  if (text1.length > text2.length) {\n    text1_a = hm[0];\n    text1_b = hm[1];\n    text2_a = hm[2];\n    text2_b = hm[3];\n  } else {\n    text2_a = hm[0];\n    text2_b = hm[1];\n    text1_a = hm[2];\n    text1_b = hm[3];\n  }\n  var mid_common = hm[4];\n  return [text1_a, text1_b, text2_a, text2_b, mid_common];\n};\n\n\n/**\n * Reorder and merge like edit sections.  Merge equalities.\n * Any edit section can move as long as it doesn't cross an equality.\n * @param {Array} diffs Array of diff tuples.\n * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff\n */\nfunction diff_cleanupMerge(diffs, fix_unicode) {\n  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.\n  var pointer = 0;\n  var count_delete = 0;\n  var count_insert = 0;\n  var text_delete = '';\n  var text_insert = '';\n  var commonlength;\n  while (pointer < diffs.length) {\n    if (pointer < diffs.length - 1 && !diffs[pointer][1]) {\n      diffs.splice(pointer, 1);\n      continue;\n    }\n    switch (diffs[pointer][0]) {\n      case DIFF_INSERT:\n\n        count_insert++;\n        text_insert += diffs[pointer][1];\n        pointer++;\n        break;\n      case DIFF_DELETE:\n        count_delete++;\n        text_delete += diffs[pointer][1];\n        pointer++;\n        break;\n      case DIFF_EQUAL:\n        var previous_equality = pointer - count_insert - count_delete - 1;\n        if (fix_unicode) {\n          // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,\n          // we assume that the old and new text in the diff are complete and correct\n          // unicode-encoded JS strings, but the tuple boundaries may fall between\n          // surrogate pairs.  we fix this by shaving off stray surrogates from the end\n          // of the previous equality and the beginning of this equality.  this may create\n          // empty equalities or a common prefix or suffix.  for example, if AB and AC are\n          // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and\n          // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this\n          // particular case, both equalities go away, we absorb any previous inequalities,\n          // and we keep scanning for the next equality before rewriting the tuples.\n          if (previous_equality >= 0 && ends_with_pair_start(diffs[previous_equality][1])) {\n            var stray = diffs[previous_equality][1].slice(-1);\n            diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);\n            text_delete = stray + text_delete;\n            text_insert = stray + text_insert;\n            if (!diffs[previous_equality][1]) {\n              // emptied out previous equality, so delete it and include previous delete/insert\n              diffs.splice(previous_equality, 1);\n              pointer--;\n              var k = previous_equality - 1;\n              if (diffs[k] && diffs[k][0] === DIFF_INSERT) {\n                count_insert++;\n                text_insert = diffs[k][1] + text_insert;\n                k--;\n              }\n              if (diffs[k] && diffs[k][0] === DIFF_DELETE) {\n                count_delete++;\n                text_delete = diffs[k][1] + text_delete;\n                k--;\n              }\n              previous_equality = k;\n            }\n          }\n          if (starts_with_pair_end(diffs[pointer][1])) {\n            var stray = diffs[pointer][1].charAt(0);\n            diffs[pointer][1] = diffs[pointer][1].slice(1);\n            text_delete += stray;\n            text_insert += stray;\n          }\n        }\n        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {\n          // for empty equality not at end, wait for next equality\n          diffs.splice(pointer, 1);\n          break;\n        }\n        if (text_delete.length > 0 || text_insert.length > 0) {\n          // note that diff_commonPrefix and diff_commonSuffix are unicode-aware\n          if (text_delete.length > 0 && text_insert.length > 0) {\n            // Factor out any common prefixes.\n            commonlength = diff_commonPrefix(text_insert, text_delete);\n            if (commonlength !== 0) {\n              if (previous_equality >= 0) {\n                diffs[previous_equality][1] += text_insert.substring(0, commonlength);\n              } else {\n                diffs.splice(0, 0, [DIFF_EQUAL, text_insert.substring(0, commonlength)]);\n                pointer++;\n              }\n              text_insert = text_insert.substring(commonlength);\n              text_delete = text_delete.substring(commonlength);\n            }\n            // Factor out any common suffixes.\n            commonlength = diff_commonSuffix(text_insert, text_delete);\n            if (commonlength !== 0) {\n              diffs[pointer][1] =\n                text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];\n              text_insert = text_insert.substring(0, text_insert.length - commonlength);\n              text_delete = text_delete.substring(0, text_delete.length - commonlength);\n            }\n          }\n          // Delete the offending records and add the merged ones.\n          var n = count_insert + count_delete;\n          if (text_delete.length === 0 && text_insert.length === 0) {\n            diffs.splice(pointer - n, n);\n            pointer = pointer - n;\n          } else if (text_delete.length === 0) {\n            diffs.splice(pointer - n, n, [DIFF_INSERT, text_insert]);\n            pointer = pointer - n + 1;\n          } else if (text_insert.length === 0) {\n            diffs.splice(pointer - n, n, [DIFF_DELETE, text_delete]);\n            pointer = pointer - n + 1;\n          } else {\n            diffs.splice(pointer - n, n, [DIFF_DELETE, text_delete], [DIFF_INSERT, text_insert]);\n            pointer = pointer - n + 2;\n          }\n        }\n        if (pointer !== 0 && diffs[pointer - 1][0] === DIFF_EQUAL) {\n          // Merge this equality with the previous one.\n          diffs[pointer - 1][1] += diffs[pointer][1];\n          diffs.splice(pointer, 1);\n        } else {\n          pointer++;\n        }\n        count_insert = 0;\n        count_delete = 0;\n        text_delete = '';\n        text_insert = '';\n        break;\n    }\n  }\n  if (diffs[diffs.length - 1][1] === '') {\n    diffs.pop();  // Remove the dummy entry at the end.\n  }\n\n  // Second pass: look for single edits surrounded on both sides by equalities\n  // which can be shifted sideways to eliminate an equality.\n  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC\n  var changes = false;\n  pointer = 1;\n  // Intentionally ignore the first and last element (don't need checking).\n  while (pointer < diffs.length - 1) {\n    if (diffs[pointer - 1][0] === DIFF_EQUAL &&\n      diffs[pointer + 1][0] === DIFF_EQUAL) {\n      // This is a single edit surrounded by equalities.\n      if (diffs[pointer][1].substring(diffs[pointer][1].length -\n        diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {\n        // Shift the edit over the previous equality.\n        diffs[pointer][1] = diffs[pointer - 1][1] +\n          diffs[pointer][1].substring(0, diffs[pointer][1].length -\n            diffs[pointer - 1][1].length);\n        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];\n        diffs.splice(pointer - 1, 1);\n        changes = true;\n      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==\n        diffs[pointer + 1][1]) {\n        // Shift the edit over the next equality.\n        diffs[pointer - 1][1] += diffs[pointer + 1][1];\n        diffs[pointer][1] =\n          diffs[pointer][1].substring(diffs[pointer + 1][1].length) +\n          diffs[pointer + 1][1];\n        diffs.splice(pointer + 1, 1);\n        changes = true;\n      }\n    }\n    pointer++;\n  }\n  // If shifts were made, the diff needs reordering and another shift sweep.\n  if (changes) {\n    diff_cleanupMerge(diffs, fix_unicode);\n  }\n};\n\nfunction is_surrogate_pair_start(charCode) {\n  return charCode >= 0xD800 && charCode <= 0xDBFF;\n}\n\nfunction is_surrogate_pair_end(charCode) {\n  return charCode >= 0xDC00 && charCode <= 0xDFFF;\n}\n\nfunction starts_with_pair_end(str) {\n  return is_surrogate_pair_end(str.charCodeAt(0));\n}\n\nfunction ends_with_pair_start(str) {\n  return is_surrogate_pair_start(str.charCodeAt(str.length - 1));\n}\n\nfunction remove_empty_tuples(tuples) {\n  var ret = [];\n  for (var i = 0; i < tuples.length; i++) {\n    if (tuples[i][1].length > 0) {\n      ret.push(tuples[i]);\n    }\n  }\n  return ret;\n}\n\nfunction make_edit_splice(before, oldMiddle, newMiddle, after) {\n  if (ends_with_pair_start(before) || starts_with_pair_end(after)) {\n    return null;\n  }\n  return remove_empty_tuples([\n    [DIFF_EQUAL, before],\n    [DIFF_DELETE, oldMiddle],\n    [DIFF_INSERT, newMiddle],\n    [DIFF_EQUAL, after]\n  ]);\n}\n\nfunction find_cursor_edit_diff(oldText, newText, cursor_pos) {\n  // note: this runs after equality check has ruled out exact equality\n  var oldRange = typeof cursor_pos === 'number' ?\n    { index: cursor_pos, length: 0 } : cursor_pos.oldRange;\n  var newRange = typeof cursor_pos === 'number' ?\n    null : cursor_pos.newRange;\n  // take into account the old and new selection to generate the best diff\n  // possible for a text edit.  for example, a text change from \"xxx\" to \"xx\"\n  // could be a delete or forwards-delete of any one of the x's, or the\n  // result of selecting two of the x's and typing \"x\".\n  var oldLength = oldText.length;\n  var newLength = newText.length;\n  if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {\n    // see if we have an insert or delete before or after cursor\n    var oldCursor = oldRange.index;\n    var oldBefore = oldText.slice(0, oldCursor);\n    var oldAfter = oldText.slice(oldCursor);\n    var maybeNewCursor = newRange ? newRange.index : null;\n    editBefore: {\n      // is this an insert or delete right before oldCursor?\n      var newCursor = oldCursor + newLength - oldLength;\n      if (maybeNewCursor !== null && maybeNewCursor !== newCursor) {\n        break editBefore;\n      }\n      if (newCursor < 0 || newCursor > newLength) {\n        break editBefore;\n      }\n      var newBefore = newText.slice(0, newCursor);\n      var newAfter = newText.slice(newCursor);\n      if (newAfter !== oldAfter) {\n        break editBefore;\n      }\n      var prefixLength = Math.min(oldCursor, newCursor);\n      var oldPrefix = oldBefore.slice(0, prefixLength);\n      var newPrefix = newBefore.slice(0, prefixLength);\n      if (oldPrefix !== newPrefix) {\n        break editBefore;\n      }\n      var oldMiddle = oldBefore.slice(prefixLength);\n      var newMiddle = newBefore.slice(prefixLength);\n      return make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);\n    }\n    editAfter: {\n      // is this an insert or delete right after oldCursor?\n      if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) {\n        break editAfter;\n      }\n      var cursor = oldCursor;\n      var newBefore = newText.slice(0, cursor);\n      var newAfter = newText.slice(cursor);\n      if (newBefore !== oldBefore) {\n        break editAfter;\n      }\n      var suffixLength = Math.min(oldLength - cursor, newLength - cursor);\n      var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);\n      var newSuffix = newAfter.slice(newAfter.length - suffixLength);\n      if (oldSuffix !== newSuffix) {\n        break editAfter;\n      }\n      var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);\n      var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);\n      return make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);\n    }\n  }\n  if (oldRange.length > 0 && newRange && newRange.length === 0) {\n    replaceRange: {\n      // see if diff could be a splice of the old selection range\n      var oldPrefix = oldText.slice(0, oldRange.index);\n      var oldSuffix = oldText.slice(oldRange.index + oldRange.length);\n      var prefixLength = oldPrefix.length;\n      var suffixLength = oldSuffix.length;\n      if (newLength < prefixLength + suffixLength) {\n        break replaceRange;\n      }\n      var newPrefix = newText.slice(0, prefixLength);\n      var newSuffix = newText.slice(newLength - suffixLength);\n      if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) {\n        break replaceRange;\n      }\n      var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);\n      var newMiddle = newText.slice(prefixLength, newLength - suffixLength);\n      return make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);\n    }\n  }\n\n  return null;\n}\n\nfunction diff(text1, text2, cursor_pos) {\n  // only pass fix_unicode=true at the top level, not when diff_main is\n  // recursively invoked\n  return diff_main(text1, text2, cursor_pos, true);\n}\n\ndiff.INSERT = DIFF_INSERT;\ndiff.DELETE = DIFF_DELETE;\ndiff.EQUAL = DIFF_EQUAL;\n\nmodule.exports = diff;\n\n\n//# sourceURL=webpack://Quill/./node_modules/fast-diff/diff.js?");

/***/ }),

/***/ "./node_modules/parchment/src/attributor/attributor.ts":
/*!*************************************************************!*\
  !*** ./node_modules/parchment/src/attributor/attributor.ts ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Attributor; });\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scope */ \"./node_modules/parchment/src/scope.ts\");\n\nclass Attributor {\n    constructor(attrName, keyName, options = {}) {\n        this.attrName = attrName;\n        this.keyName = keyName;\n        const attributeBit = _scope__WEBPACK_IMPORTED_MODULE_0__[\"default\"].TYPE & _scope__WEBPACK_IMPORTED_MODULE_0__[\"default\"].ATTRIBUTE;\n        this.scope =\n            options.scope != null\n                ? // Ignore type bits, force attribute bit\n                    (options.scope & _scope__WEBPACK_IMPORTED_MODULE_0__[\"default\"].LEVEL) | attributeBit\n                : _scope__WEBPACK_IMPORTED_MODULE_0__[\"default\"].ATTRIBUTE;\n        if (options.whitelist != null) {\n            this.whitelist = options.whitelist;\n        }\n    }\n    static keys(node) {\n        return Array.from(node.attributes).map((item) => item.name);\n    }\n    add(node, value) {\n        if (!this.canAdd(node, value)) {\n            return false;\n        }\n        node.setAttribute(this.keyName, value);\n        return true;\n    }\n    canAdd(_node, value) {\n        if (this.whitelist == null) {\n            return true;\n        }\n        if (typeof value === 'string') {\n            return this.whitelist.indexOf(value.replace(/[\"']/g, '')) > -1;\n        }\n        else {\n            return this.whitelist.indexOf(value) > -1;\n        }\n    }\n    remove(node) {\n        node.removeAttribute(this.keyName);\n    }\n    value(node) {\n        const value = node.getAttribute(this.keyName);\n        if (this.canAdd(node, value) && value) {\n            return value;\n        }\n        return '';\n    }\n}\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/attributor/attributor.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/attributor/class.ts":
/*!********************************************************!*\
  !*** ./node_modules/parchment/src/attributor/class.ts ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _attributor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./attributor */ \"./node_modules/parchment/src/attributor/attributor.ts\");\n\nfunction match(node, prefix) {\n    const className = node.getAttribute('class') || '';\n    return className\n        .split(/\\s+/)\n        .filter(name => name.indexOf(`${prefix}-`) === 0);\n}\nclass ClassAttributor extends _attributor__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n    static keys(node) {\n        return (node.getAttribute('class') || '').split(/\\s+/).map(name => name\n            .split('-')\n            .slice(0, -1)\n            .join('-'));\n    }\n    add(node, value) {\n        if (!this.canAdd(node, value)) {\n            return false;\n        }\n        this.remove(node);\n        node.classList.add(`${this.keyName}-${value}`);\n        return true;\n    }\n    remove(node) {\n        const matches = match(node, this.keyName);\n        matches.forEach(name => {\n            node.classList.remove(name);\n        });\n        if (node.classList.length === 0) {\n            node.removeAttribute('class');\n        }\n    }\n    value(node) {\n        const result = match(node, this.keyName)[0] || '';\n        const value = result.slice(this.keyName.length + 1); // +1 for hyphen\n        return this.canAdd(node, value) ? value : '';\n    }\n}\n/* harmony default export */ __webpack_exports__[\"default\"] = (ClassAttributor);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/attributor/class.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/attributor/store.ts":
/*!********************************************************!*\
  !*** ./node_modules/parchment/src/attributor/store.ts ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _registry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../registry */ \"./node_modules/parchment/src/registry.ts\");\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scope */ \"./node_modules/parchment/src/scope.ts\");\n/* harmony import */ var _attributor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./attributor */ \"./node_modules/parchment/src/attributor/attributor.ts\");\n/* harmony import */ var _class__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./class */ \"./node_modules/parchment/src/attributor/class.ts\");\n/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./style */ \"./node_modules/parchment/src/attributor/style.ts\");\n\n\n\n\n\nclass AttributorStore {\n    constructor(domNode) {\n        this.attributes = {};\n        this.domNode = domNode;\n        this.build();\n    }\n    attribute(attribute, value) {\n        // verb\n        if (value) {\n            if (attribute.add(this.domNode, value)) {\n                if (attribute.value(this.domNode) != null) {\n                    this.attributes[attribute.attrName] = attribute;\n                }\n                else {\n                    delete this.attributes[attribute.attrName];\n                }\n            }\n        }\n        else {\n            attribute.remove(this.domNode);\n            delete this.attributes[attribute.attrName];\n        }\n    }\n    build() {\n        this.attributes = {};\n        const blot = _registry__WEBPACK_IMPORTED_MODULE_0__[\"default\"].find(this.domNode);\n        if (blot == null) {\n            return;\n        }\n        const attributes = _attributor__WEBPACK_IMPORTED_MODULE_2__[\"default\"].keys(this.domNode);\n        const classes = _class__WEBPACK_IMPORTED_MODULE_3__[\"default\"].keys(this.domNode);\n        const styles = _style__WEBPACK_IMPORTED_MODULE_4__[\"default\"].keys(this.domNode);\n        attributes\n            .concat(classes)\n            .concat(styles)\n            .forEach(name => {\n            const attr = blot.scroll.query(name, _scope__WEBPACK_IMPORTED_MODULE_1__[\"default\"].ATTRIBUTE);\n            if (attr instanceof _attributor__WEBPACK_IMPORTED_MODULE_2__[\"default\"]) {\n                this.attributes[attr.attrName] = attr;\n            }\n        });\n    }\n    copy(target) {\n        Object.keys(this.attributes).forEach(key => {\n            const value = this.attributes[key].value(this.domNode);\n            target.format(key, value);\n        });\n    }\n    move(target) {\n        this.copy(target);\n        Object.keys(this.attributes).forEach(key => {\n            this.attributes[key].remove(this.domNode);\n        });\n        this.attributes = {};\n    }\n    values() {\n        return Object.keys(this.attributes).reduce((attributes, name) => {\n            attributes[name] = this.attributes[name].value(this.domNode);\n            return attributes;\n        }, {});\n    }\n}\n/* harmony default export */ __webpack_exports__[\"default\"] = (AttributorStore);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/attributor/store.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/attributor/style.ts":
/*!********************************************************!*\
  !*** ./node_modules/parchment/src/attributor/style.ts ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _attributor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./attributor */ \"./node_modules/parchment/src/attributor/attributor.ts\");\n\nfunction camelize(name) {\n    const parts = name.split('-');\n    const rest = parts\n        .slice(1)\n        .map((part) => part[0].toUpperCase() + part.slice(1))\n        .join('');\n    return parts[0] + rest;\n}\nclass StyleAttributor extends _attributor__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n    static keys(node) {\n        return (node.getAttribute('style') || '').split(';').map(value => {\n            const arr = value.split(':');\n            return arr[0].trim();\n        });\n    }\n    add(node, value) {\n        if (!this.canAdd(node, value)) {\n            return false;\n        }\n        // @ts-ignore\n        node.style[camelize(this.keyName)] = value;\n        return true;\n    }\n    remove(node) {\n        // @ts-ignore\n        node.style[camelize(this.keyName)] = '';\n        if (!node.getAttribute('style')) {\n            node.removeAttribute('style');\n        }\n    }\n    value(node) {\n        // @ts-ignore\n        const value = node.style[camelize(this.keyName)];\n        return this.canAdd(node, value) ? value : '';\n    }\n}\n/* harmony default export */ __webpack_exports__[\"default\"] = (StyleAttributor);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/attributor/style.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/blot/abstract/container.ts":
/*!***************************************************************!*\
  !*** ./node_modules/parchment/src/blot/abstract/container.ts ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../scope */ \"./node_modules/parchment/src/scope.ts\");\n/* harmony import */ var _parent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./parent */ \"./node_modules/parchment/src/blot/abstract/parent.ts\");\n\n\nclass ContainerBlot extends _parent__WEBPACK_IMPORTED_MODULE_1__[\"default\"] {\n    checkMerge() {\n        return (this.next !== null && this.next.statics.blotName === this.statics.blotName);\n    }\n    deleteAt(index, length) {\n        super.deleteAt(index, length);\n        this.enforceAllowedChildren();\n    }\n    formatAt(index, length, name, value) {\n        super.formatAt(index, length, name, value);\n        this.enforceAllowedChildren();\n    }\n    insertAt(index, value, def) {\n        super.insertAt(index, value, def);\n        this.enforceAllowedChildren();\n    }\n    optimize(context) {\n        super.optimize(context);\n        if (this.children.length > 0 && this.next != null && this.checkMerge()) {\n            this.next.moveChildren(this);\n            this.next.remove();\n        }\n    }\n}\nContainerBlot.blotName = 'container';\nContainerBlot.scope = _scope__WEBPACK_IMPORTED_MODULE_0__[\"default\"].BLOCK_BLOT;\n/* harmony default export */ __webpack_exports__[\"default\"] = (ContainerBlot);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/blot/abstract/container.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/blot/abstract/leaf.ts":
/*!**********************************************************!*\
  !*** ./node_modules/parchment/src/blot/abstract/leaf.ts ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../scope */ \"./node_modules/parchment/src/scope.ts\");\n/* harmony import */ var _shadow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./shadow */ \"./node_modules/parchment/src/blot/abstract/shadow.ts\");\n\n\nclass LeafBlot extends _shadow__WEBPACK_IMPORTED_MODULE_1__[\"default\"] {\n    static value(_domNode) {\n        return true;\n    }\n    index(node, offset) {\n        if (this.domNode === node ||\n            this.domNode.compareDocumentPosition(node) &\n                Node.DOCUMENT_POSITION_CONTAINED_BY) {\n            return Math.min(offset, 1);\n        }\n        return -1;\n    }\n    position(index, _inclusive) {\n        const childNodes = Array.from(this.parent.domNode.childNodes);\n        let offset = childNodes.indexOf(this.domNode);\n        if (index > 0) {\n            offset += 1;\n        }\n        return [this.parent.domNode, offset];\n    }\n    value() {\n        return {\n            [this.statics.blotName]: this.statics.value(this.domNode) || true,\n        };\n    }\n}\nLeafBlot.scope = _scope__WEBPACK_IMPORTED_MODULE_0__[\"default\"].INLINE_BLOT;\n/* harmony default export */ __webpack_exports__[\"default\"] = (LeafBlot);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/blot/abstract/leaf.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/blot/abstract/parent.ts":
/*!************************************************************!*\
  !*** ./node_modules/parchment/src/blot/abstract/parent.ts ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _collection_linked_list__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../collection/linked-list */ \"./node_modules/parchment/src/collection/linked-list.ts\");\n/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../error */ \"./node_modules/parchment/src/error.ts\");\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../scope */ \"./node_modules/parchment/src/scope.ts\");\n/* harmony import */ var _shadow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./shadow */ \"./node_modules/parchment/src/blot/abstract/shadow.ts\");\n\n\n\n\nclass ParentBlot extends _shadow__WEBPACK_IMPORTED_MODULE_3__[\"default\"] {\n    constructor(scroll, domNode) {\n        super(scroll, domNode);\n        this.uiNode = null;\n        this.build();\n    }\n    appendChild(other) {\n        this.insertBefore(other);\n    }\n    attach() {\n        super.attach();\n        this.children.forEach(child => {\n            child.attach();\n        });\n    }\n    attachUI(node) {\n        if (this.uiNode != null) {\n            this.uiNode.remove();\n        }\n        this.uiNode = node;\n        if (ParentBlot.uiClass) {\n            this.uiNode.classList.add(ParentBlot.uiClass);\n        }\n        this.uiNode.setAttribute('contenteditable', 'false');\n        this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);\n    }\n    build() {\n        this.children = new _collection_linked_list__WEBPACK_IMPORTED_MODULE_0__[\"default\"]();\n        // Need to be reversed for if DOM nodes already in order\n        Array.from(this.domNode.childNodes)\n            .filter((node) => node !== this.uiNode)\n            .reverse()\n            .forEach((node) => {\n            try {\n                const child = makeAttachedBlot(node, this.scroll);\n                this.insertBefore(child, this.children.head || undefined);\n            }\n            catch (err) {\n                if (err instanceof _error__WEBPACK_IMPORTED_MODULE_1__[\"default\"]) {\n                    return;\n                }\n                else {\n                    throw err;\n                }\n            }\n        });\n    }\n    deleteAt(index, length) {\n        if (index === 0 && length === this.length()) {\n            return this.remove();\n        }\n        this.children.forEachAt(index, length, (child, offset, childLength) => {\n            child.deleteAt(offset, childLength);\n        });\n    }\n    descendant(criteria, index = 0) {\n        const [child, offset] = this.children.find(index);\n        if ((criteria.blotName == null && criteria(child)) ||\n            (criteria.blotName != null && child instanceof criteria)) {\n            return [child, offset];\n        }\n        else if (child instanceof ParentBlot) {\n            return child.descendant(criteria, offset);\n        }\n        else {\n            return [null, -1];\n        }\n    }\n    descendants(criteria, index = 0, length = Number.MAX_VALUE) {\n        let descendants = [];\n        let lengthLeft = length;\n        this.children.forEachAt(index, length, (child, childIndex, childLength) => {\n            if ((criteria.blotName == null && criteria(child)) ||\n                (criteria.blotName != null && child instanceof criteria)) {\n                descendants.push(child);\n            }\n            if (child instanceof ParentBlot) {\n                descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft));\n            }\n            lengthLeft -= childLength;\n        });\n        return descendants;\n    }\n    detach() {\n        this.children.forEach(child => {\n            child.detach();\n        });\n        super.detach();\n    }\n    enforceAllowedChildren() {\n        let done = false;\n        this.children.forEach((child) => {\n            if (done) {\n                return;\n            }\n            const allowed = this.statics.allowedChildren.some((def) => child instanceof def);\n            if (allowed) {\n                return;\n            }\n            if (child.statics.scope === _scope__WEBPACK_IMPORTED_MODULE_2__[\"default\"].BLOCK_BLOT) {\n                if (child.next != null) {\n                    this.splitAfter(child);\n                }\n                if (child.prev != null) {\n                    this.splitAfter(child.prev);\n                }\n                child.parent.unwrap();\n                done = true;\n            }\n            else if (child instanceof ParentBlot) {\n                child.unwrap();\n            }\n            else {\n                child.remove();\n            }\n        });\n    }\n    formatAt(index, length, name, value) {\n        this.children.forEachAt(index, length, (child, offset, childLength) => {\n            child.formatAt(offset, childLength, name, value);\n        });\n    }\n    insertAt(index, value, def) {\n        const [child, offset] = this.children.find(index);\n        if (child) {\n            child.insertAt(offset, value, def);\n        }\n        else {\n            const blot = def == null\n                ? this.scroll.create('text', value)\n                : this.scroll.create(value, def);\n            this.appendChild(blot);\n        }\n    }\n    insertBefore(childBlot, refBlot) {\n        if (childBlot.parent != null) {\n            childBlot.parent.children.remove(childBlot);\n        }\n        let refDomNode = null;\n        this.children.insertBefore(childBlot, refBlot || null);\n        if (refBlot != null) {\n            refDomNode = refBlot.domNode;\n        }\n        if (this.domNode.parentNode !== childBlot.domNode ||\n            this.domNode.nextSibling !== refDomNode) {\n            this.domNode.insertBefore(childBlot.domNode, refDomNode);\n        }\n        childBlot.parent = this;\n        childBlot.attach();\n    }\n    length() {\n        return this.children.reduce((memo, child) => {\n            return memo + child.length();\n        }, 0);\n    }\n    moveChildren(targetParent, refNode) {\n        this.children.forEach(child => {\n            targetParent.insertBefore(child, refNode);\n        });\n    }\n    optimize(context) {\n        super.optimize(context);\n        this.enforceAllowedChildren();\n        if (this.uiNode != null && this.uiNode !== this.domNode.firstChild) {\n            this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);\n        }\n        if (this.children.length === 0) {\n            if (this.statics.defaultChild != null) {\n                const child = this.scroll.create(this.statics.defaultChild.blotName);\n                this.appendChild(child);\n                // TODO double check if necessary\n                // child.optimize(context);\n            }\n            else {\n                this.remove();\n            }\n        }\n    }\n    path(index, inclusive = false) {\n        const [child, offset] = this.children.find(index, inclusive);\n        const position = [[this, index]];\n        if (child instanceof ParentBlot) {\n            return position.concat(child.path(offset, inclusive));\n        }\n        else if (child != null) {\n            position.push([child, offset]);\n        }\n        return position;\n    }\n    removeChild(child) {\n        this.children.remove(child);\n    }\n    replaceWith(name, value) {\n        const replacement = typeof name === 'string' ? this.scroll.create(name, value) : name;\n        if (replacement instanceof ParentBlot) {\n            this.moveChildren(replacement);\n        }\n        return super.replaceWith(replacement);\n    }\n    split(index, force = false) {\n        if (!force) {\n            if (index === 0) {\n                return this;\n            }\n            if (index === this.length()) {\n                return this.next;\n            }\n        }\n        const after = this.clone();\n        if (this.parent) {\n            this.parent.insertBefore(after, this.next || undefined);\n        }\n        this.children.forEachAt(index, this.length(), (child, offset, _length) => {\n            const split = child.split(offset, force);\n            if (split != null) {\n                after.appendChild(split);\n            }\n        });\n        return after;\n    }\n    splitAfter(child) {\n        const after = this.clone();\n        while (child.next != null) {\n            after.appendChild(child.next);\n        }\n        if (this.parent) {\n            this.parent.insertBefore(after, this.next || undefined);\n        }\n        return after;\n    }\n    unwrap() {\n        if (this.parent) {\n            this.moveChildren(this.parent, this.next || undefined);\n        }\n        this.remove();\n    }\n    update(mutations, _context) {\n        const addedNodes = [];\n        const removedNodes = [];\n        mutations.forEach(mutation => {\n            if (mutation.target === this.domNode && mutation.type === 'childList') {\n                addedNodes.push.apply(addedNodes, mutation.addedNodes);\n                removedNodes.push.apply(removedNodes, mutation.removedNodes);\n            }\n        });\n        removedNodes.forEach((node) => {\n            // Check node has actually been removed\n            // One exception is Chrome does not immediately remove IFRAMEs\n            // from DOM but MutationRecord is correct in its reported removal\n            if (node.parentNode != null &&\n                // @ts-ignore\n                node.tagName !== 'IFRAME' &&\n                document.body.compareDocumentPosition(node) &\n                    Node.DOCUMENT_POSITION_CONTAINED_BY) {\n                return;\n            }\n            const blot = this.scroll.find(node);\n            if (blot == null) {\n                return;\n            }\n            if (blot.domNode.parentNode == null ||\n                blot.domNode.parentNode === this.domNode) {\n                blot.detach();\n            }\n        });\n        addedNodes\n            .filter(node => {\n            return node.parentNode === this.domNode || node === this.uiNode;\n        })\n            .sort((a, b) => {\n            if (a === b) {\n                return 0;\n            }\n            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {\n                return 1;\n            }\n            return -1;\n        })\n            .forEach(node => {\n            let refBlot = null;\n            if (node.nextSibling != null) {\n                refBlot = this.scroll.find(node.nextSibling);\n            }\n            const blot = makeAttachedBlot(node, this.scroll);\n            if (blot.next !== refBlot || blot.next == null) {\n                if (blot.parent != null) {\n                    blot.parent.removeChild(this);\n                }\n                this.insertBefore(blot, refBlot || undefined);\n            }\n        });\n        this.enforceAllowedChildren();\n    }\n}\nParentBlot.uiClass = '';\nfunction makeAttachedBlot(node, scroll) {\n    let blot = scroll.find(node);\n    if (blot == null) {\n        try {\n            blot = scroll.create(node);\n        }\n        catch (e) {\n            blot = scroll.create(_scope__WEBPACK_IMPORTED_MODULE_2__[\"default\"].INLINE);\n            Array.from(node.childNodes).forEach((child) => {\n                // @ts-ignore\n                blot.domNode.appendChild(child);\n            });\n            if (node.parentNode) {\n                node.parentNode.replaceChild(blot.domNode, node);\n            }\n            blot.attach();\n        }\n    }\n    return blot;\n}\n/* harmony default export */ __webpack_exports__[\"default\"] = (ParentBlot);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/blot/abstract/parent.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/blot/abstract/shadow.ts":
/*!************************************************************!*\
  !*** ./node_modules/parchment/src/blot/abstract/shadow.ts ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../error */ \"./node_modules/parchment/src/error.ts\");\n/* harmony import */ var _registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../registry */ \"./node_modules/parchment/src/registry.ts\");\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../scope */ \"./node_modules/parchment/src/scope.ts\");\n\n\n\nclass ShadowBlot {\n    constructor(scroll, domNode) {\n        this.scroll = scroll;\n        this.domNode = domNode;\n        _registry__WEBPACK_IMPORTED_MODULE_1__[\"default\"].blots.set(domNode, this);\n        this.prev = null;\n        this.next = null;\n    }\n    static create(value) {\n        if (this.tagName == null) {\n            throw new _error__WEBPACK_IMPORTED_MODULE_0__[\"default\"]('Blot definition missing tagName');\n        }\n        let node;\n        if (Array.isArray(this.tagName)) {\n            if (typeof value === 'string') {\n                value = value.toUpperCase();\n                if (parseInt(value, 10).toString() === value) {\n                    value = parseInt(value, 10);\n                }\n            }\n            if (typeof value === 'number') {\n                node = document.createElement(this.tagName[value - 1]);\n            }\n            else if (this.tagName.indexOf(value) > -1) {\n                node = document.createElement(value);\n            }\n            else {\n                node = document.createElement(this.tagName[0]);\n            }\n        }\n        else {\n            node = document.createElement(this.tagName);\n        }\n        if (this.className) {\n            node.classList.add(this.className);\n        }\n        return node;\n    }\n    // Hack for accessing inherited static methods\n    get statics() {\n        return this.constructor;\n    }\n    attach() {\n        // Nothing to do\n    }\n    clone() {\n        const domNode = this.domNode.cloneNode(false);\n        return this.scroll.create(domNode);\n    }\n    detach() {\n        if (this.parent != null) {\n            this.parent.removeChild(this);\n        }\n        _registry__WEBPACK_IMPORTED_MODULE_1__[\"default\"].blots.delete(this.domNode);\n    }\n    deleteAt(index, length) {\n        const blot = this.isolate(index, length);\n        blot.remove();\n    }\n    formatAt(index, length, name, value) {\n        const blot = this.isolate(index, length);\n        if (this.scroll.query(name, _scope__WEBPACK_IMPORTED_MODULE_2__[\"default\"].BLOT) != null && value) {\n            blot.wrap(name, value);\n        }\n        else if (this.scroll.query(name, _scope__WEBPACK_IMPORTED_MODULE_2__[\"default\"].ATTRIBUTE) != null) {\n            const parent = this.scroll.create(this.statics.scope);\n            blot.wrap(parent);\n            parent.format(name, value);\n        }\n    }\n    insertAt(index, value, def) {\n        const blot = def == null\n            ? this.scroll.create('text', value)\n            : this.scroll.create(value, def);\n        const ref = this.split(index);\n        this.parent.insertBefore(blot, ref || undefined);\n    }\n    isolate(index, length) {\n        const target = this.split(index);\n        if (target == null) {\n            throw new Error('Attempt to isolate at end');\n        }\n        target.split(length);\n        return target;\n    }\n    length() {\n        return 1;\n    }\n    offset(root = this.parent) {\n        if (this.parent == null || this === root) {\n            return 0;\n        }\n        return this.parent.children.offset(this) + this.parent.offset(root);\n    }\n    optimize(_context) {\n        if (this.statics.requiredContainer &&\n            !(this.parent instanceof this.statics.requiredContainer)) {\n            this.wrap(this.statics.requiredContainer.blotName);\n        }\n    }\n    remove() {\n        if (this.domNode.parentNode != null) {\n            this.domNode.parentNode.removeChild(this.domNode);\n        }\n        this.detach();\n    }\n    replaceWith(name, value) {\n        const replacement = typeof name === 'string' ? this.scroll.create(name, value) : name;\n        if (this.parent != null) {\n            this.parent.insertBefore(replacement, this.next || undefined);\n            this.remove();\n        }\n        return replacement;\n    }\n    split(index, _force) {\n        return index === 0 ? this : this.next;\n    }\n    update(_mutations, _context) {\n        // Nothing to do by default\n    }\n    wrap(name, value) {\n        const wrapper = typeof name === 'string'\n            ? this.scroll.create(name, value)\n            : name;\n        if (this.parent != null) {\n            this.parent.insertBefore(wrapper, this.next || undefined);\n        }\n        if (typeof wrapper.appendChild !== 'function') {\n            throw new _error__WEBPACK_IMPORTED_MODULE_0__[\"default\"](`Cannot wrap ${name}`);\n        }\n        wrapper.appendChild(this);\n        return wrapper;\n    }\n}\nShadowBlot.blotName = 'abstract';\n/* harmony default export */ __webpack_exports__[\"default\"] = (ShadowBlot);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/blot/abstract/shadow.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/blot/block.ts":
/*!**************************************************!*\
  !*** ./node_modules/parchment/src/blot/block.ts ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _attributor_attributor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../attributor/attributor */ \"./node_modules/parchment/src/attributor/attributor.ts\");\n/* harmony import */ var _attributor_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../attributor/store */ \"./node_modules/parchment/src/attributor/store.ts\");\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scope */ \"./node_modules/parchment/src/scope.ts\");\n/* harmony import */ var _abstract_leaf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./abstract/leaf */ \"./node_modules/parchment/src/blot/abstract/leaf.ts\");\n/* harmony import */ var _abstract_parent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./abstract/parent */ \"./node_modules/parchment/src/blot/abstract/parent.ts\");\n/* harmony import */ var _inline__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./inline */ \"./node_modules/parchment/src/blot/inline.ts\");\n\n\n\n\n\n\nclass BlockBlot extends _abstract_parent__WEBPACK_IMPORTED_MODULE_4__[\"default\"] {\n    constructor(scroll, domNode) {\n        super(scroll, domNode);\n        this.attributes = new _attributor_store__WEBPACK_IMPORTED_MODULE_1__[\"default\"](this.domNode);\n    }\n    static formats(domNode, scroll) {\n        const match = scroll.query(BlockBlot.blotName);\n        if (match != null &&\n            domNode.tagName === match.tagName) {\n            return undefined;\n        }\n        else if (typeof this.tagName === 'string') {\n            return true;\n        }\n        else if (Array.isArray(this.tagName)) {\n            return domNode.tagName.toLowerCase();\n        }\n    }\n    format(name, value) {\n        const format = this.scroll.query(name, _scope__WEBPACK_IMPORTED_MODULE_2__[\"default\"].BLOCK);\n        if (format == null) {\n            return;\n        }\n        else if (format instanceof _attributor_attributor__WEBPACK_IMPORTED_MODULE_0__[\"default\"]) {\n            this.attributes.attribute(format, value);\n        }\n        else if (name === this.statics.blotName && !value) {\n            this.replaceWith(BlockBlot.blotName);\n        }\n        else if (value &&\n            (name !== this.statics.blotName || this.formats()[name] !== value)) {\n            this.replaceWith(name, value);\n        }\n    }\n    formats() {\n        const formats = this.attributes.values();\n        const format = this.statics.formats(this.domNode, this.scroll);\n        if (format != null) {\n            formats[this.statics.blotName] = format;\n        }\n        return formats;\n    }\n    formatAt(index, length, name, value) {\n        if (this.scroll.query(name, _scope__WEBPACK_IMPORTED_MODULE_2__[\"default\"].BLOCK) != null) {\n            this.format(name, value);\n        }\n        else {\n            super.formatAt(index, length, name, value);\n        }\n    }\n    insertAt(index, value, def) {\n        if (def == null || this.scroll.query(value, _scope__WEBPACK_IMPORTED_MODULE_2__[\"default\"].INLINE) != null) {\n            // Insert text or inline\n            super.insertAt(index, value, def);\n        }\n        else {\n            const after = this.split(index);\n            if (after != null) {\n                const blot = this.scroll.create(value, def);\n                after.parent.insertBefore(blot, after);\n            }\n            else {\n                throw new Error('Attempt to insertAt after block boundaries');\n            }\n        }\n    }\n    replaceWith(name, value) {\n        const replacement = super.replaceWith(name, value);\n        this.attributes.copy(replacement);\n        return replacement;\n    }\n    update(mutations, context) {\n        super.update(mutations, context);\n        const attributeChanged = mutations.some(mutation => mutation.target === this.domNode && mutation.type === 'attributes');\n        if (attributeChanged) {\n            this.attributes.build();\n        }\n    }\n}\nBlockBlot.blotName = 'block';\nBlockBlot.scope = _scope__WEBPACK_IMPORTED_MODULE_2__[\"default\"].BLOCK_BLOT;\nBlockBlot.tagName = 'P';\nBlockBlot.allowedChildren = [\n    _inline__WEBPACK_IMPORTED_MODULE_5__[\"default\"],\n    BlockBlot,\n    _abstract_leaf__WEBPACK_IMPORTED_MODULE_3__[\"default\"],\n];\n/* harmony default export */ __webpack_exports__[\"default\"] = (BlockBlot);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/blot/block.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/blot/embed.ts":
/*!**************************************************!*\
  !*** ./node_modules/parchment/src/blot/embed.ts ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _abstract_leaf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./abstract/leaf */ \"./node_modules/parchment/src/blot/abstract/leaf.ts\");\n\nclass EmbedBlot extends _abstract_leaf__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n    static formats(_domNode, _scroll) {\n        return undefined;\n    }\n    format(name, value) {\n        // super.formatAt wraps, which is what we want in general,\n        // but this allows subclasses to overwrite for formats\n        // that just apply to particular embeds\n        super.formatAt(0, this.length(), name, value);\n    }\n    formatAt(index, length, name, value) {\n        if (index === 0 && length === this.length()) {\n            this.format(name, value);\n        }\n        else {\n            super.formatAt(index, length, name, value);\n        }\n    }\n    formats() {\n        return this.statics.formats(this.domNode, this.scroll);\n    }\n}\n/* harmony default export */ __webpack_exports__[\"default\"] = (EmbedBlot);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/blot/embed.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/blot/inline.ts":
/*!***************************************************!*\
  !*** ./node_modules/parchment/src/blot/inline.ts ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _attributor_attributor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../attributor/attributor */ \"./node_modules/parchment/src/attributor/attributor.ts\");\n/* harmony import */ var _attributor_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../attributor/store */ \"./node_modules/parchment/src/attributor/store.ts\");\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scope */ \"./node_modules/parchment/src/scope.ts\");\n/* harmony import */ var _abstract_leaf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./abstract/leaf */ \"./node_modules/parchment/src/blot/abstract/leaf.ts\");\n/* harmony import */ var _abstract_parent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./abstract/parent */ \"./node_modules/parchment/src/blot/abstract/parent.ts\");\n\n\n\n\n\n// Shallow object comparison\nfunction isEqual(obj1, obj2) {\n    if (Object.keys(obj1).length !== Object.keys(obj2).length) {\n        return false;\n    }\n    // @ts-ignore\n    for (const prop in obj1) {\n        // @ts-ignore\n        if (obj1[prop] !== obj2[prop]) {\n            return false;\n        }\n    }\n    return true;\n}\nclass InlineBlot extends _abstract_parent__WEBPACK_IMPORTED_MODULE_4__[\"default\"] {\n    constructor(scroll, domNode) {\n        super(scroll, domNode);\n        this.attributes = new _attributor_store__WEBPACK_IMPORTED_MODULE_1__[\"default\"](this.domNode);\n    }\n    static formats(domNode, scroll) {\n        const match = scroll.query(InlineBlot.blotName);\n        if (match != null &&\n            domNode.tagName === match.tagName) {\n            return undefined;\n        }\n        else if (typeof this.tagName === 'string') {\n            return true;\n        }\n        else if (Array.isArray(this.tagName)) {\n            return domNode.tagName.toLowerCase();\n        }\n        return undefined;\n    }\n    format(name, value) {\n        if (name === this.statics.blotName && !value) {\n            this.children.forEach(child => {\n                if (!(child instanceof InlineBlot)) {\n                    child = child.wrap(InlineBlot.blotName, true);\n                }\n                this.attributes.copy(child);\n            });\n            this.unwrap();\n        }\n        else {\n            const format = this.scroll.query(name, _scope__WEBPACK_IMPORTED_MODULE_2__[\"default\"].INLINE);\n            if (format == null) {\n                return;\n            }\n            if (format instanceof _attributor_attributor__WEBPACK_IMPORTED_MODULE_0__[\"default\"]) {\n                this.attributes.attribute(format, value);\n            }\n            else if (value &&\n                (name !== this.statics.blotName || this.formats()[name] !== value)) {\n                this.replaceWith(name, value);\n            }\n        }\n    }\n    formats() {\n        const formats = this.attributes.values();\n        const format = this.statics.formats(this.domNode, this.scroll);\n        if (format != null) {\n            formats[this.statics.blotName] = format;\n        }\n        return formats;\n    }\n    formatAt(index, length, name, value) {\n        if (this.formats()[name] != null ||\n            this.scroll.query(name, _scope__WEBPACK_IMPORTED_MODULE_2__[\"default\"].ATTRIBUTE)) {\n            const blot = this.isolate(index, length);\n            blot.format(name, value);\n        }\n        else {\n            super.formatAt(index, length, name, value);\n        }\n    }\n    optimize(context) {\n        super.optimize(context);\n        const formats = this.formats();\n        if (Object.keys(formats).length === 0) {\n            return this.unwrap(); // unformatted span\n        }\n        const next = this.next;\n        if (next instanceof InlineBlot &&\n            next.prev === this &&\n            isEqual(formats, next.formats())) {\n            next.moveChildren(this);\n            next.remove();\n        }\n    }\n    replaceWith(name, value) {\n        const replacement = super.replaceWith(name, value);\n        this.attributes.copy(replacement);\n        return replacement;\n    }\n    update(mutations, context) {\n        super.update(mutations, context);\n        const attributeChanged = mutations.some(mutation => mutation.target === this.domNode && mutation.type === 'attributes');\n        if (attributeChanged) {\n            this.attributes.build();\n        }\n    }\n    wrap(name, value) {\n        const wrapper = super.wrap(name, value);\n        if (wrapper instanceof InlineBlot) {\n            this.attributes.move(wrapper);\n        }\n        return wrapper;\n    }\n}\nInlineBlot.allowedChildren = [InlineBlot, _abstract_leaf__WEBPACK_IMPORTED_MODULE_3__[\"default\"]];\nInlineBlot.blotName = 'inline';\nInlineBlot.scope = _scope__WEBPACK_IMPORTED_MODULE_2__[\"default\"].INLINE_BLOT;\nInlineBlot.tagName = 'SPAN';\n/* harmony default export */ __webpack_exports__[\"default\"] = (InlineBlot);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/blot/inline.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/blot/scroll.ts":
/*!***************************************************!*\
  !*** ./node_modules/parchment/src/blot/scroll.ts ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _registry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../registry */ \"./node_modules/parchment/src/registry.ts\");\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scope */ \"./node_modules/parchment/src/scope.ts\");\n/* harmony import */ var _abstract_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./abstract/container */ \"./node_modules/parchment/src/blot/abstract/container.ts\");\n/* harmony import */ var _abstract_parent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./abstract/parent */ \"./node_modules/parchment/src/blot/abstract/parent.ts\");\n/* harmony import */ var _block__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./block */ \"./node_modules/parchment/src/blot/block.ts\");\n\n\n\n\n\nconst OBSERVER_CONFIG = {\n    attributes: true,\n    characterData: true,\n    characterDataOldValue: true,\n    childList: true,\n    subtree: true,\n};\nconst MAX_OPTIMIZE_ITERATIONS = 100;\nclass ScrollBlot extends _abstract_parent__WEBPACK_IMPORTED_MODULE_3__[\"default\"] {\n    constructor(registry, node) {\n        // @ts-ignore\n        super(null, node);\n        this.registry = registry;\n        this.scroll = this;\n        this.build();\n        this.observer = new MutationObserver((mutations) => {\n            this.update(mutations);\n        });\n        this.observer.observe(this.domNode, OBSERVER_CONFIG);\n        this.attach();\n    }\n    create(input, value) {\n        return this.registry.create(this, input, value);\n    }\n    find(node, bubble = false) {\n        return this.registry.find(node, bubble);\n    }\n    query(query, scope = _scope__WEBPACK_IMPORTED_MODULE_1__[\"default\"].ANY) {\n        return this.registry.query(query, scope);\n    }\n    register(...definitions) {\n        return this.registry.register(...definitions);\n    }\n    build() {\n        if (this.scroll == null) {\n            return;\n        }\n        super.build();\n    }\n    detach() {\n        super.detach();\n        this.observer.disconnect();\n    }\n    deleteAt(index, length) {\n        this.update();\n        if (index === 0 && length === this.length()) {\n            this.children.forEach(child => {\n                child.remove();\n            });\n        }\n        else {\n            super.deleteAt(index, length);\n        }\n    }\n    formatAt(index, length, name, value) {\n        this.update();\n        super.formatAt(index, length, name, value);\n    }\n    insertAt(index, value, def) {\n        this.update();\n        super.insertAt(index, value, def);\n    }\n    optimize(mutations = [], context = {}) {\n        super.optimize(context);\n        const mutationsMap = context.mutationsMap || new WeakMap();\n        // We must modify mutations directly, cannot make copy and then modify\n        let records = Array.from(this.observer.takeRecords());\n        // Array.push currently seems to be implemented by a non-tail recursive function\n        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());\n        while (records.length > 0) {\n            mutations.push(records.pop());\n        }\n        const mark = (blot, markParent = true) => {\n            if (blot == null || blot === this) {\n                return;\n            }\n            if (blot.domNode.parentNode == null) {\n                return;\n            }\n            if (!mutationsMap.has(blot.domNode)) {\n                mutationsMap.set(blot.domNode, []);\n            }\n            if (markParent) {\n                mark(blot.parent);\n            }\n        };\n        const optimize = (blot) => {\n            // Post-order traversal\n            if (!mutationsMap.has(blot.domNode)) {\n                return;\n            }\n            if (blot instanceof _abstract_parent__WEBPACK_IMPORTED_MODULE_3__[\"default\"]) {\n                blot.children.forEach(optimize);\n            }\n            mutationsMap.delete(blot.domNode);\n            blot.optimize(context);\n        };\n        let remaining = mutations;\n        for (let i = 0; remaining.length > 0; i += 1) {\n            if (i >= MAX_OPTIMIZE_ITERATIONS) {\n                throw new Error('[Parchment] Maximum optimize iterations reached');\n            }\n            remaining.forEach((mutation) => {\n                const blot = this.find(mutation.target, true);\n                if (blot == null) {\n                    return;\n                }\n                if (blot.domNode === mutation.target) {\n                    if (mutation.type === 'childList') {\n                        mark(this.find(mutation.previousSibling, false));\n                        Array.from(mutation.addedNodes).forEach((node) => {\n                            const child = this.find(node, false);\n                            mark(child, false);\n                            if (child instanceof _abstract_parent__WEBPACK_IMPORTED_MODULE_3__[\"default\"]) {\n                                child.children.forEach((grandChild) => {\n                                    mark(grandChild, false);\n                                });\n                            }\n                        });\n                    }\n                    else if (mutation.type === 'attributes') {\n                        mark(blot.prev);\n                    }\n                }\n                mark(blot);\n            });\n            this.children.forEach(optimize);\n            remaining = Array.from(this.observer.takeRecords());\n            records = remaining.slice();\n            while (records.length > 0) {\n                mutations.push(records.pop());\n            }\n        }\n    }\n    update(mutations, context = {}) {\n        mutations = mutations || this.observer.takeRecords();\n        const mutationsMap = new WeakMap();\n        mutations\n            .map((mutation) => {\n            const blot = _registry__WEBPACK_IMPORTED_MODULE_0__[\"default\"].find(mutation.target, true);\n            if (blot == null) {\n                return null;\n            }\n            if (mutationsMap.has(blot.domNode)) {\n                mutationsMap.get(blot.domNode).push(mutation);\n                return null;\n            }\n            else {\n                mutationsMap.set(blot.domNode, [mutation]);\n                return blot;\n            }\n        })\n            .forEach((blot) => {\n            if (blot != null && blot !== this && mutationsMap.has(blot.domNode)) {\n                blot.update(mutationsMap.get(blot.domNode) || [], context);\n            }\n        });\n        context.mutationsMap = mutationsMap;\n        if (mutationsMap.has(this.domNode)) {\n            super.update(mutationsMap.get(this.domNode), context);\n        }\n        this.optimize(mutations, context);\n    }\n}\nScrollBlot.blotName = 'scroll';\nScrollBlot.defaultChild = _block__WEBPACK_IMPORTED_MODULE_4__[\"default\"];\nScrollBlot.allowedChildren = [_block__WEBPACK_IMPORTED_MODULE_4__[\"default\"], _abstract_container__WEBPACK_IMPORTED_MODULE_2__[\"default\"]];\nScrollBlot.scope = _scope__WEBPACK_IMPORTED_MODULE_1__[\"default\"].BLOCK_BLOT;\nScrollBlot.tagName = 'DIV';\n/* harmony default export */ __webpack_exports__[\"default\"] = (ScrollBlot);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/blot/scroll.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/blot/text.ts":
/*!*************************************************!*\
  !*** ./node_modules/parchment/src/blot/text.ts ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scope */ \"./node_modules/parchment/src/scope.ts\");\n/* harmony import */ var _abstract_leaf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./abstract/leaf */ \"./node_modules/parchment/src/blot/abstract/leaf.ts\");\n\n\nclass TextBlot extends _abstract_leaf__WEBPACK_IMPORTED_MODULE_1__[\"default\"] {\n    constructor(scroll, node) {\n        super(scroll, node);\n        this.text = this.statics.value(this.domNode);\n    }\n    static create(value) {\n        return document.createTextNode(value);\n    }\n    static value(domNode) {\n        return domNode.data;\n    }\n    deleteAt(index, length) {\n        this.domNode.data = this.text =\n            this.text.slice(0, index) + this.text.slice(index + length);\n    }\n    index(node, offset) {\n        if (this.domNode === node) {\n            return offset;\n        }\n        return -1;\n    }\n    insertAt(index, value, def) {\n        if (def == null) {\n            this.text = this.text.slice(0, index) + value + this.text.slice(index);\n            this.domNode.data = this.text;\n        }\n        else {\n            super.insertAt(index, value, def);\n        }\n    }\n    length() {\n        return this.text.length;\n    }\n    optimize(context) {\n        super.optimize(context);\n        this.text = this.statics.value(this.domNode);\n        if (this.text.length === 0) {\n            this.remove();\n        }\n        else if (this.next instanceof TextBlot && this.next.prev === this) {\n            this.insertAt(this.length(), this.next.value());\n            this.next.remove();\n        }\n    }\n    position(index, _inclusive = false) {\n        return [this.domNode, index];\n    }\n    split(index, force = false) {\n        if (!force) {\n            if (index === 0) {\n                return this;\n            }\n            if (index === this.length()) {\n                return this.next;\n            }\n        }\n        const after = this.scroll.create(this.domNode.splitText(index));\n        this.parent.insertBefore(after, this.next || undefined);\n        this.text = this.statics.value(this.domNode);\n        return after;\n    }\n    update(mutations, _context) {\n        if (mutations.some(mutation => {\n            return (mutation.type === 'characterData' && mutation.target === this.domNode);\n        })) {\n            this.text = this.statics.value(this.domNode);\n        }\n    }\n    value() {\n        return this.text;\n    }\n}\nTextBlot.blotName = 'text';\nTextBlot.scope = _scope__WEBPACK_IMPORTED_MODULE_0__[\"default\"].INLINE_BLOT;\n/* harmony default export */ __webpack_exports__[\"default\"] = (TextBlot);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/blot/text.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/collection/linked-list.ts":
/*!**************************************************************!*\
  !*** ./node_modules/parchment/src/collection/linked-list.ts ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\nclass LinkedList {\n    constructor() {\n        this.head = null;\n        this.tail = null;\n        this.length = 0;\n    }\n    append(...nodes) {\n        this.insertBefore(nodes[0], null);\n        if (nodes.length > 1) {\n            this.append.apply(this, nodes.slice(1));\n        }\n    }\n    at(index) {\n        const next = this.iterator();\n        let cur = next();\n        while (cur && index > 0) {\n            index -= 1;\n            cur = next();\n        }\n        return cur;\n    }\n    contains(node) {\n        const next = this.iterator();\n        let cur = next();\n        while (cur) {\n            if (cur === node) {\n                return true;\n            }\n            cur = next();\n        }\n        return false;\n    }\n    indexOf(node) {\n        const next = this.iterator();\n        let cur = next();\n        let index = 0;\n        while (cur) {\n            if (cur === node) {\n                return index;\n            }\n            index += 1;\n            cur = next();\n        }\n        return -1;\n    }\n    insertBefore(node, refNode) {\n        if (node == null) {\n            return;\n        }\n        this.remove(node);\n        node.next = refNode;\n        if (refNode != null) {\n            node.prev = refNode.prev;\n            if (refNode.prev != null) {\n                refNode.prev.next = node;\n            }\n            refNode.prev = node;\n            if (refNode === this.head) {\n                this.head = node;\n            }\n        }\n        else if (this.tail != null) {\n            this.tail.next = node;\n            node.prev = this.tail;\n            this.tail = node;\n        }\n        else {\n            node.prev = null;\n            this.head = this.tail = node;\n        }\n        this.length += 1;\n    }\n    offset(target) {\n        let index = 0;\n        let cur = this.head;\n        while (cur != null) {\n            if (cur === target) {\n                return index;\n            }\n            index += cur.length();\n            cur = cur.next;\n        }\n        return -1;\n    }\n    remove(node) {\n        if (!this.contains(node)) {\n            return;\n        }\n        if (node.prev != null) {\n            node.prev.next = node.next;\n        }\n        if (node.next != null) {\n            node.next.prev = node.prev;\n        }\n        if (node === this.head) {\n            this.head = node.next;\n        }\n        if (node === this.tail) {\n            this.tail = node.prev;\n        }\n        this.length -= 1;\n    }\n    iterator(curNode = this.head) {\n        // TODO use yield when we can\n        return () => {\n            const ret = curNode;\n            if (curNode != null) {\n                curNode = curNode.next;\n            }\n            return ret;\n        };\n    }\n    find(index, inclusive = false) {\n        const next = this.iterator();\n        let cur = next();\n        while (cur) {\n            const length = cur.length();\n            if (index < length ||\n                (inclusive &&\n                    index === length &&\n                    (cur.next == null || cur.next.length() !== 0))) {\n                return [cur, index];\n            }\n            index -= length;\n            cur = next();\n        }\n        return [null, 0];\n    }\n    forEach(callback) {\n        const next = this.iterator();\n        let cur = next();\n        while (cur) {\n            callback(cur);\n            cur = next();\n        }\n    }\n    forEachAt(index, length, callback) {\n        if (length <= 0) {\n            return;\n        }\n        const [startNode, offset] = this.find(index);\n        let curIndex = index - offset;\n        const next = this.iterator(startNode);\n        let cur = next();\n        while (cur && curIndex < index + length) {\n            const curLength = cur.length();\n            if (index > curIndex) {\n                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));\n            }\n            else {\n                callback(cur, 0, Math.min(curLength, index + length - curIndex));\n            }\n            curIndex += curLength;\n            cur = next();\n        }\n    }\n    map(callback) {\n        return this.reduce((memo, cur) => {\n            memo.push(callback(cur));\n            return memo;\n        }, []);\n    }\n    reduce(callback, memo) {\n        const next = this.iterator();\n        let cur = next();\n        while (cur) {\n            memo = callback(memo, cur);\n            cur = next();\n        }\n        return memo;\n    }\n}\n/* harmony default export */ __webpack_exports__[\"default\"] = (LinkedList);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/collection/linked-list.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/error.ts":
/*!*********************************************!*\
  !*** ./node_modules/parchment/src/error.ts ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return ParchmentError; });\nclass ParchmentError extends Error {\n    constructor(message) {\n        message = '[Parchment] ' + message;\n        super(message);\n        this.message = message;\n        this.name = this.constructor.name;\n    }\n}\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/error.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/parchment.ts":
/*!*************************************************!*\
  !*** ./node_modules/parchment/src/parchment.ts ***!
  \*************************************************/
/*! exports provided: ParentBlot, ContainerBlot, LeafBlot, EmbedBlot, ScrollBlot, BlockBlot, InlineBlot, TextBlot, Attributor, ClassAttributor, StyleAttributor, AttributorStore, Registry, Scope */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _blot_abstract_container__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./blot/abstract/container */ \"./node_modules/parchment/src/blot/abstract/container.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"ContainerBlot\", function() { return _blot_abstract_container__WEBPACK_IMPORTED_MODULE_0__[\"default\"]; });\n\n/* harmony import */ var _blot_abstract_leaf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./blot/abstract/leaf */ \"./node_modules/parchment/src/blot/abstract/leaf.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"LeafBlot\", function() { return _blot_abstract_leaf__WEBPACK_IMPORTED_MODULE_1__[\"default\"]; });\n\n/* harmony import */ var _blot_abstract_parent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./blot/abstract/parent */ \"./node_modules/parchment/src/blot/abstract/parent.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"ParentBlot\", function() { return _blot_abstract_parent__WEBPACK_IMPORTED_MODULE_2__[\"default\"]; });\n\n/* harmony import */ var _blot_block__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./blot/block */ \"./node_modules/parchment/src/blot/block.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"BlockBlot\", function() { return _blot_block__WEBPACK_IMPORTED_MODULE_3__[\"default\"]; });\n\n/* harmony import */ var _blot_embed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./blot/embed */ \"./node_modules/parchment/src/blot/embed.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"EmbedBlot\", function() { return _blot_embed__WEBPACK_IMPORTED_MODULE_4__[\"default\"]; });\n\n/* harmony import */ var _blot_inline__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./blot/inline */ \"./node_modules/parchment/src/blot/inline.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"InlineBlot\", function() { return _blot_inline__WEBPACK_IMPORTED_MODULE_5__[\"default\"]; });\n\n/* harmony import */ var _blot_scroll__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./blot/scroll */ \"./node_modules/parchment/src/blot/scroll.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"ScrollBlot\", function() { return _blot_scroll__WEBPACK_IMPORTED_MODULE_6__[\"default\"]; });\n\n/* harmony import */ var _blot_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./blot/text */ \"./node_modules/parchment/src/blot/text.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"TextBlot\", function() { return _blot_text__WEBPACK_IMPORTED_MODULE_7__[\"default\"]; });\n\n/* harmony import */ var _attributor_attributor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./attributor/attributor */ \"./node_modules/parchment/src/attributor/attributor.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"Attributor\", function() { return _attributor_attributor__WEBPACK_IMPORTED_MODULE_8__[\"default\"]; });\n\n/* harmony import */ var _attributor_class__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./attributor/class */ \"./node_modules/parchment/src/attributor/class.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"ClassAttributor\", function() { return _attributor_class__WEBPACK_IMPORTED_MODULE_9__[\"default\"]; });\n\n/* harmony import */ var _attributor_store__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./attributor/store */ \"./node_modules/parchment/src/attributor/store.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"AttributorStore\", function() { return _attributor_store__WEBPACK_IMPORTED_MODULE_10__[\"default\"]; });\n\n/* harmony import */ var _attributor_style__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./attributor/style */ \"./node_modules/parchment/src/attributor/style.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"StyleAttributor\", function() { return _attributor_style__WEBPACK_IMPORTED_MODULE_11__[\"default\"]; });\n\n/* harmony import */ var _registry__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./registry */ \"./node_modules/parchment/src/registry.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"Registry\", function() { return _registry__WEBPACK_IMPORTED_MODULE_12__[\"default\"]; });\n\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./scope */ \"./node_modules/parchment/src/scope.ts\");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, \"Scope\", function() { return _scope__WEBPACK_IMPORTED_MODULE_13__[\"default\"]; });\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/parchment.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/registry.ts":
/*!************************************************!*\
  !*** ./node_modules/parchment/src/registry.ts ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Registry; });\n/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./error */ \"./node_modules/parchment/src/error.ts\");\n/* harmony import */ var _scope__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scope */ \"./node_modules/parchment/src/scope.ts\");\n\n\nclass Registry {\n    constructor() {\n        this.attributes = {};\n        this.classes = {};\n        this.tags = {};\n        this.types = {};\n    }\n    static find(node, bubble = false) {\n        if (node == null) {\n            return null;\n        }\n        if (this.blots.has(node)) {\n            return this.blots.get(node) || null;\n        }\n        if (bubble) {\n            return this.find(node.parentNode, bubble);\n        }\n        return null;\n    }\n    create(scroll, input, value) {\n        const match = this.query(input);\n        if (match == null) {\n            throw new _error__WEBPACK_IMPORTED_MODULE_0__[\"default\"](`Unable to create ${input} blot`);\n        }\n        const blotClass = match;\n        const node = \n        // @ts-ignore\n        input instanceof Node || input.nodeType === Node.TEXT_NODE\n            ? input\n            : blotClass.create(value);\n        const blot = new blotClass(scroll, node, value);\n        Registry.blots.set(blot.domNode, blot);\n        return blot;\n    }\n    find(node, bubble = false) {\n        return Registry.find(node, bubble);\n    }\n    query(query, scope = _scope__WEBPACK_IMPORTED_MODULE_1__[\"default\"].ANY) {\n        let match;\n        if (typeof query === 'string') {\n            match = this.types[query] || this.attributes[query];\n            // @ts-ignore\n        }\n        else if (query instanceof Text || query.nodeType === Node.TEXT_NODE) {\n            match = this.types.text;\n        }\n        else if (typeof query === 'number') {\n            if (query & _scope__WEBPACK_IMPORTED_MODULE_1__[\"default\"].LEVEL & _scope__WEBPACK_IMPORTED_MODULE_1__[\"default\"].BLOCK) {\n                match = this.types.block;\n            }\n            else if (query & _scope__WEBPACK_IMPORTED_MODULE_1__[\"default\"].LEVEL & _scope__WEBPACK_IMPORTED_MODULE_1__[\"default\"].INLINE) {\n                match = this.types.inline;\n            }\n        }\n        else if (query instanceof HTMLElement) {\n            const names = (query.getAttribute('class') || '').split(/\\s+/);\n            names.some(name => {\n                match = this.classes[name];\n                if (match) {\n                    return true;\n                }\n                return false;\n            });\n            match = match || this.tags[query.tagName];\n        }\n        if (match == null) {\n            return null;\n        }\n        // @ts-ignore\n        if (scope & _scope__WEBPACK_IMPORTED_MODULE_1__[\"default\"].LEVEL & match.scope && scope & _scope__WEBPACK_IMPORTED_MODULE_1__[\"default\"].TYPE & match.scope) {\n            return match;\n        }\n        return null;\n    }\n    register(...definitions) {\n        if (definitions.length > 1) {\n            return definitions.map(d => {\n                return this.register(d);\n            });\n        }\n        const definition = definitions[0];\n        if (typeof definition.blotName !== 'string' &&\n            typeof definition.attrName !== 'string') {\n            throw new _error__WEBPACK_IMPORTED_MODULE_0__[\"default\"]('Invalid definition');\n        }\n        else if (definition.blotName === 'abstract') {\n            throw new _error__WEBPACK_IMPORTED_MODULE_0__[\"default\"]('Cannot register abstract class');\n        }\n        this.types[definition.blotName || definition.attrName] = definition;\n        if (typeof definition.keyName === 'string') {\n            this.attributes[definition.keyName] = definition;\n        }\n        else {\n            if (definition.className != null) {\n                this.classes[definition.className] = definition;\n            }\n            if (definition.tagName != null) {\n                if (Array.isArray(definition.tagName)) {\n                    definition.tagName = definition.tagName.map((tagName) => {\n                        return tagName.toUpperCase();\n                    });\n                }\n                else {\n                    definition.tagName = definition.tagName.toUpperCase();\n                }\n                const tagNames = Array.isArray(definition.tagName)\n                    ? definition.tagName\n                    : [definition.tagName];\n                tagNames.forEach((tag) => {\n                    if (this.tags[tag] == null || definition.className == null) {\n                        this.tags[tag] = definition;\n                    }\n                });\n            }\n        }\n        return definition;\n    }\n}\nRegistry.blots = new WeakMap();\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/registry.ts?");

/***/ }),

/***/ "./node_modules/parchment/src/scope.ts":
/*!*********************************************!*\
  !*** ./node_modules/parchment/src/scope.ts ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\nvar Scope;\n(function (Scope) {\n    Scope[Scope[\"TYPE\"] = 3] = \"TYPE\";\n    Scope[Scope[\"LEVEL\"] = 12] = \"LEVEL\";\n    Scope[Scope[\"ATTRIBUTE\"] = 13] = \"ATTRIBUTE\";\n    Scope[Scope[\"BLOT\"] = 14] = \"BLOT\";\n    Scope[Scope[\"INLINE\"] = 7] = \"INLINE\";\n    Scope[Scope[\"BLOCK\"] = 11] = \"BLOCK\";\n    Scope[Scope[\"BLOCK_BLOT\"] = 10] = \"BLOCK_BLOT\";\n    Scope[Scope[\"INLINE_BLOT\"] = 6] = \"INLINE_BLOT\";\n    Scope[Scope[\"BLOCK_ATTRIBUTE\"] = 9] = \"BLOCK_ATTRIBUTE\";\n    Scope[Scope[\"INLINE_ATTRIBUTE\"] = 5] = \"INLINE_ATTRIBUTE\";\n    Scope[Scope[\"ANY\"] = 15] = \"ANY\";\n})(Scope || (Scope = {}));\n/* harmony default export */ __webpack_exports__[\"default\"] = (Scope);\n\n\n//# sourceURL=webpack://Quill/./node_modules/parchment/src/scope.ts?");

/***/ }),

/***/ "./node_modules/quill-delta/dist/AttributeMap.js":
/*!*******************************************************!*\
  !*** ./node_modules/quill-delta/dist/AttributeMap.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\nvar __importDefault = (this && this.__importDefault) || function (mod) {\n    return (mod && mod.__esModule) ? mod : { \"default\": mod };\n};\nObject.defineProperty(exports, \"__esModule\", { value: true });\nvar deep_equal_1 = __importDefault(__webpack_require__(/*! deep-equal */ \"./node_modules/deep-equal/index.js\"));\nvar extend_1 = __importDefault(__webpack_require__(/*! extend */ \"./node_modules/extend/index.js\"));\nvar AttributeMap;\n(function (AttributeMap) {\n    function compose(a, b, keepNull) {\n        if (a === void 0) { a = {}; }\n        if (b === void 0) { b = {}; }\n        if (typeof a !== 'object') {\n            a = {};\n        }\n        if (typeof b !== 'object') {\n            b = {};\n        }\n        var attributes = extend_1.default(true, {}, b);\n        if (!keepNull) {\n            attributes = Object.keys(attributes).reduce(function (copy, key) {\n                if (attributes[key] != null) {\n                    copy[key] = attributes[key];\n                }\n                return copy;\n            }, {});\n        }\n        for (var key in a) {\n            if (a[key] !== undefined && b[key] === undefined) {\n                attributes[key] = a[key];\n            }\n        }\n        return Object.keys(attributes).length > 0 ? attributes : undefined;\n    }\n    AttributeMap.compose = compose;\n    function diff(a, b) {\n        if (a === void 0) { a = {}; }\n        if (b === void 0) { b = {}; }\n        if (typeof a !== 'object') {\n            a = {};\n        }\n        if (typeof b !== 'object') {\n            b = {};\n        }\n        var attributes = Object.keys(a)\n            .concat(Object.keys(b))\n            .reduce(function (attrs, key) {\n            if (!deep_equal_1.default(a[key], b[key])) {\n                attrs[key] = b[key] === undefined ? null : b[key];\n            }\n            return attrs;\n        }, {});\n        return Object.keys(attributes).length > 0 ? attributes : undefined;\n    }\n    AttributeMap.diff = diff;\n    function invert(attr, base) {\n        if (attr === void 0) { attr = {}; }\n        if (base === void 0) { base = {}; }\n        attr = attr || {};\n        var baseInverted = Object.keys(base).reduce(function (memo, key) {\n            if (base[key] !== attr[key] && attr[key] !== undefined) {\n                memo[key] = base[key];\n            }\n            return memo;\n        }, {});\n        return Object.keys(attr).reduce(function (memo, key) {\n            if (attr[key] !== base[key] && base[key] === undefined) {\n                memo[key] = null;\n            }\n            return memo;\n        }, baseInverted);\n    }\n    AttributeMap.invert = invert;\n    function transform(a, b, priority) {\n        if (priority === void 0) { priority = false; }\n        if (typeof a !== 'object') {\n            return b;\n        }\n        if (typeof b !== 'object') {\n            return undefined;\n        }\n        if (!priority) {\n            return b; // b simply overwrites us without priority\n        }\n        var attributes = Object.keys(b).reduce(function (attrs, key) {\n            if (a[key] === undefined) {\n                attrs[key] = b[key]; // null is a valid value\n            }\n            return attrs;\n        }, {});\n        return Object.keys(attributes).length > 0 ? attributes : undefined;\n    }\n    AttributeMap.transform = transform;\n})(AttributeMap || (AttributeMap = {}));\nexports.default = AttributeMap;\n//# sourceMappingURL=AttributeMap.js.map\n\n//# sourceURL=webpack://Quill/./node_modules/quill-delta/dist/AttributeMap.js?");

/***/ }),

/***/ "./node_modules/quill-delta/dist/Delta.js":
/*!************************************************!*\
  !*** ./node_modules/quill-delta/dist/Delta.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\nvar __importDefault = (this && this.__importDefault) || function (mod) {\n    return (mod && mod.__esModule) ? mod : { \"default\": mod };\n};\nvar deep_equal_1 = __importDefault(__webpack_require__(/*! deep-equal */ \"./node_modules/deep-equal/index.js\"));\nvar extend_1 = __importDefault(__webpack_require__(/*! extend */ \"./node_modules/extend/index.js\"));\nvar fast_diff_1 = __importDefault(__webpack_require__(/*! fast-diff */ \"./node_modules/fast-diff/diff.js\"));\nvar AttributeMap_1 = __importDefault(__webpack_require__(/*! ./AttributeMap */ \"./node_modules/quill-delta/dist/AttributeMap.js\"));\nvar Op_1 = __importDefault(__webpack_require__(/*! ./Op */ \"./node_modules/quill-delta/dist/Op.js\"));\nvar NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()\nvar Delta = /** @class */ (function () {\n    function Delta(ops) {\n        // Assume we are given a well formed ops\n        if (Array.isArray(ops)) {\n            this.ops = ops;\n        }\n        else if (ops != null && Array.isArray(ops.ops)) {\n            this.ops = ops.ops;\n        }\n        else {\n            this.ops = [];\n        }\n    }\n    Delta.prototype.insert = function (arg, attributes) {\n        var newOp = {};\n        if (typeof arg === 'string' && arg.length === 0) {\n            return this;\n        }\n        newOp.insert = arg;\n        if (attributes != null &&\n            typeof attributes === 'object' &&\n            Object.keys(attributes).length > 0) {\n            newOp.attributes = attributes;\n        }\n        return this.push(newOp);\n    };\n    Delta.prototype.delete = function (length) {\n        if (length <= 0) {\n            return this;\n        }\n        return this.push({ delete: length });\n    };\n    Delta.prototype.retain = function (length, attributes) {\n        if (length <= 0) {\n            return this;\n        }\n        var newOp = { retain: length };\n        if (attributes != null &&\n            typeof attributes === 'object' &&\n            Object.keys(attributes).length > 0) {\n            newOp.attributes = attributes;\n        }\n        return this.push(newOp);\n    };\n    Delta.prototype.push = function (newOp) {\n        var index = this.ops.length;\n        var lastOp = this.ops[index - 1];\n        newOp = extend_1.default(true, {}, newOp);\n        if (typeof lastOp === 'object') {\n            if (typeof newOp.delete === 'number' &&\n                typeof lastOp.delete === 'number') {\n                this.ops[index - 1] = { delete: lastOp.delete + newOp.delete };\n                return this;\n            }\n            // Since it does not matter if we insert before or after deleting at the same index,\n            // always prefer to insert first\n            if (typeof lastOp.delete === 'number' && newOp.insert != null) {\n                index -= 1;\n                lastOp = this.ops[index - 1];\n                if (typeof lastOp !== 'object') {\n                    this.ops.unshift(newOp);\n                    return this;\n                }\n            }\n            if (deep_equal_1.default(newOp.attributes, lastOp.attributes)) {\n                if (typeof newOp.insert === 'string' &&\n                    typeof lastOp.insert === 'string') {\n                    this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };\n                    if (typeof newOp.attributes === 'object') {\n                        this.ops[index - 1].attributes = newOp.attributes;\n                    }\n                    return this;\n                }\n                else if (typeof newOp.retain === 'number' &&\n                    typeof lastOp.retain === 'number') {\n                    this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };\n                    if (typeof newOp.attributes === 'object') {\n                        this.ops[index - 1].attributes = newOp.attributes;\n                    }\n                    return this;\n                }\n            }\n        }\n        if (index === this.ops.length) {\n            this.ops.push(newOp);\n        }\n        else {\n            this.ops.splice(index, 0, newOp);\n        }\n        return this;\n    };\n    Delta.prototype.chop = function () {\n        var lastOp = this.ops[this.ops.length - 1];\n        if (lastOp && lastOp.retain && !lastOp.attributes) {\n            this.ops.pop();\n        }\n        return this;\n    };\n    Delta.prototype.filter = function (predicate) {\n        return this.ops.filter(predicate);\n    };\n    Delta.prototype.forEach = function (predicate) {\n        this.ops.forEach(predicate);\n    };\n    Delta.prototype.map = function (predicate) {\n        return this.ops.map(predicate);\n    };\n    Delta.prototype.partition = function (predicate) {\n        var passed = [];\n        var failed = [];\n        this.forEach(function (op) {\n            var target = predicate(op) ? passed : failed;\n            target.push(op);\n        });\n        return [passed, failed];\n    };\n    Delta.prototype.reduce = function (predicate, initialValue) {\n        return this.ops.reduce(predicate, initialValue);\n    };\n    Delta.prototype.changeLength = function () {\n        return this.reduce(function (length, elem) {\n            if (elem.insert) {\n                return length + Op_1.default.length(elem);\n            }\n            else if (elem.delete) {\n                return length - elem.delete;\n            }\n            return length;\n        }, 0);\n    };\n    Delta.prototype.length = function () {\n        return this.reduce(function (length, elem) {\n            return length + Op_1.default.length(elem);\n        }, 0);\n    };\n    Delta.prototype.slice = function (start, end) {\n        if (start === void 0) { start = 0; }\n        if (end === void 0) { end = Infinity; }\n        var ops = [];\n        var iter = Op_1.default.iterator(this.ops);\n        var index = 0;\n        while (index < end && iter.hasNext()) {\n            var nextOp = void 0;\n            if (index < start) {\n                nextOp = iter.next(start - index);\n            }\n            else {\n                nextOp = iter.next(end - index);\n                ops.push(nextOp);\n            }\n            index += Op_1.default.length(nextOp);\n        }\n        return new Delta(ops);\n    };\n    Delta.prototype.compose = function (other) {\n        var thisIter = Op_1.default.iterator(this.ops);\n        var otherIter = Op_1.default.iterator(other.ops);\n        var ops = [];\n        var firstOther = otherIter.peek();\n        if (firstOther != null &&\n            typeof firstOther.retain === 'number' &&\n            firstOther.attributes == null) {\n            var firstLeft = firstOther.retain;\n            while (thisIter.peekType() === 'insert' &&\n                thisIter.peekLength() <= firstLeft) {\n                firstLeft -= thisIter.peekLength();\n                ops.push(thisIter.next());\n            }\n            if (firstOther.retain - firstLeft > 0) {\n                otherIter.next(firstOther.retain - firstLeft);\n            }\n        }\n        var delta = new Delta(ops);\n        while (thisIter.hasNext() || otherIter.hasNext()) {\n            if (otherIter.peekType() === 'insert') {\n                delta.push(otherIter.next());\n            }\n            else if (thisIter.peekType() === 'delete') {\n                delta.push(thisIter.next());\n            }\n            else {\n                var length_1 = Math.min(thisIter.peekLength(), otherIter.peekLength());\n                var thisOp = thisIter.next(length_1);\n                var otherOp = otherIter.next(length_1);\n                if (typeof otherOp.retain === 'number') {\n                    var newOp = {};\n                    if (typeof thisOp.retain === 'number') {\n                        newOp.retain = length_1;\n                    }\n                    else {\n                        newOp.insert = thisOp.insert;\n                    }\n                    // Preserve null when composing with a retain, otherwise remove it for inserts\n                    var attributes = AttributeMap_1.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');\n                    if (attributes) {\n                        newOp.attributes = attributes;\n                    }\n                    delta.push(newOp);\n                    // Optimization if rest of other is just retain\n                    if (!otherIter.hasNext() &&\n                        deep_equal_1.default(delta.ops[delta.ops.length - 1], newOp)) {\n                        var rest = new Delta(thisIter.rest());\n                        return delta.concat(rest).chop();\n                    }\n                    // Other op should be delete, we could be an insert or retain\n                    // Insert + delete cancels out\n                }\n                else if (typeof otherOp.delete === 'number' &&\n                    typeof thisOp.retain === 'number') {\n                    delta.push(otherOp);\n                }\n            }\n        }\n        return delta.chop();\n    };\n    Delta.prototype.concat = function (other) {\n        var delta = new Delta(this.ops.slice());\n        if (other.ops.length > 0) {\n            delta.push(other.ops[0]);\n            delta.ops = delta.ops.concat(other.ops.slice(1));\n        }\n        return delta;\n    };\n    Delta.prototype.diff = function (other, cursor) {\n        if (this.ops === other.ops) {\n            return new Delta();\n        }\n        var strings = [this, other].map(function (delta) {\n            return delta\n                .map(function (op) {\n                if (op.insert != null) {\n                    return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;\n                }\n                var prep = delta === other ? 'on' : 'with';\n                throw new Error('diff() called ' + prep + ' non-document');\n            })\n                .join('');\n        });\n        var retDelta = new Delta();\n        var diffResult = fast_diff_1.default(strings[0], strings[1], cursor);\n        var thisIter = Op_1.default.iterator(this.ops);\n        var otherIter = Op_1.default.iterator(other.ops);\n        diffResult.forEach(function (component) {\n            var length = component[1].length;\n            while (length > 0) {\n                var opLength = 0;\n                switch (component[0]) {\n                    case fast_diff_1.default.INSERT:\n                        opLength = Math.min(otherIter.peekLength(), length);\n                        retDelta.push(otherIter.next(opLength));\n                        break;\n                    case fast_diff_1.default.DELETE:\n                        opLength = Math.min(length, thisIter.peekLength());\n                        thisIter.next(opLength);\n                        retDelta.delete(opLength);\n                        break;\n                    case fast_diff_1.default.EQUAL:\n                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);\n                        var thisOp = thisIter.next(opLength);\n                        var otherOp = otherIter.next(opLength);\n                        if (deep_equal_1.default(thisOp.insert, otherOp.insert)) {\n                            retDelta.retain(opLength, AttributeMap_1.default.diff(thisOp.attributes, otherOp.attributes));\n                        }\n                        else {\n                            retDelta.push(otherOp).delete(opLength);\n                        }\n                        break;\n                }\n                length -= opLength;\n            }\n        });\n        return retDelta.chop();\n    };\n    Delta.prototype.eachLine = function (predicate, newline) {\n        if (newline === void 0) { newline = '\\n'; }\n        var iter = Op_1.default.iterator(this.ops);\n        var line = new Delta();\n        var i = 0;\n        while (iter.hasNext()) {\n            if (iter.peekType() !== 'insert') {\n                return;\n            }\n            var thisOp = iter.peek();\n            var start = Op_1.default.length(thisOp) - iter.peekLength();\n            var index = typeof thisOp.insert === 'string'\n                ? thisOp.insert.indexOf(newline, start) - start\n                : -1;\n            if (index < 0) {\n                line.push(iter.next());\n            }\n            else if (index > 0) {\n                line.push(iter.next(index));\n            }\n            else {\n                if (predicate(line, iter.next(1).attributes || {}, i) === false) {\n                    return;\n                }\n                i += 1;\n                line = new Delta();\n            }\n        }\n        if (line.length() > 0) {\n            predicate(line, {}, i);\n        }\n    };\n    Delta.prototype.invert = function (base) {\n        var inverted = new Delta();\n        this.reduce(function (baseIndex, op) {\n            if (op.insert) {\n                inverted.delete(Op_1.default.length(op));\n            }\n            else if (op.retain && op.attributes == null) {\n                inverted.retain(op.retain);\n                return baseIndex + op.retain;\n            }\n            else if (op.delete || (op.retain && op.attributes)) {\n                var length_2 = (op.delete || op.retain);\n                var slice = base.slice(baseIndex, baseIndex + length_2);\n                slice.forEach(function (baseOp) {\n                    if (op.delete) {\n                        inverted.push(baseOp);\n                    }\n                    else if (op.retain && op.attributes) {\n                        inverted.retain(Op_1.default.length(baseOp), AttributeMap_1.default.invert(op.attributes, baseOp.attributes));\n                    }\n                });\n                return baseIndex + length_2;\n            }\n            return baseIndex;\n        }, 0);\n        return inverted.chop();\n    };\n    Delta.prototype.transform = function (arg, priority) {\n        if (priority === void 0) { priority = false; }\n        priority = !!priority;\n        if (typeof arg === 'number') {\n            return this.transformPosition(arg, priority);\n        }\n        var other = arg;\n        var thisIter = Op_1.default.iterator(this.ops);\n        var otherIter = Op_1.default.iterator(other.ops);\n        var delta = new Delta();\n        while (thisIter.hasNext() || otherIter.hasNext()) {\n            if (thisIter.peekType() === 'insert' &&\n                (priority || otherIter.peekType() !== 'insert')) {\n                delta.retain(Op_1.default.length(thisIter.next()));\n            }\n            else if (otherIter.peekType() === 'insert') {\n                delta.push(otherIter.next());\n            }\n            else {\n                var length_3 = Math.min(thisIter.peekLength(), otherIter.peekLength());\n                var thisOp = thisIter.next(length_3);\n                var otherOp = otherIter.next(length_3);\n                if (thisOp.delete) {\n                    // Our delete either makes their delete redundant or removes their retain\n                    continue;\n                }\n                else if (otherOp.delete) {\n                    delta.push(otherOp);\n                }\n                else {\n                    // We retain either their retain or insert\n                    delta.retain(length_3, AttributeMap_1.default.transform(thisOp.attributes, otherOp.attributes, priority));\n                }\n            }\n        }\n        return delta.chop();\n    };\n    Delta.prototype.transformPosition = function (index, priority) {\n        if (priority === void 0) { priority = false; }\n        priority = !!priority;\n        var thisIter = Op_1.default.iterator(this.ops);\n        var offset = 0;\n        while (thisIter.hasNext() && offset <= index) {\n            var length_4 = thisIter.peekLength();\n            var nextType = thisIter.peekType();\n            thisIter.next();\n            if (nextType === 'delete') {\n                index -= Math.min(length_4, index - offset);\n                continue;\n            }\n            else if (nextType === 'insert' && (offset < index || !priority)) {\n                index += length_4;\n            }\n            offset += length_4;\n        }\n        return index;\n    };\n    Delta.Op = Op_1.default;\n    Delta.AttributeMap = AttributeMap_1.default;\n    return Delta;\n}());\nmodule.exports = Delta;\n//# sourceMappingURL=Delta.js.map\n\n//# sourceURL=webpack://Quill/./node_modules/quill-delta/dist/Delta.js?");

/***/ }),

/***/ "./node_modules/quill-delta/dist/Iterator.js":
/*!***************************************************!*\
  !*** ./node_modules/quill-delta/dist/Iterator.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\nvar __importDefault = (this && this.__importDefault) || function (mod) {\n    return (mod && mod.__esModule) ? mod : { \"default\": mod };\n};\nObject.defineProperty(exports, \"__esModule\", { value: true });\nvar Op_1 = __importDefault(__webpack_require__(/*! ./Op */ \"./node_modules/quill-delta/dist/Op.js\"));\nvar Iterator = /** @class */ (function () {\n    function Iterator(ops) {\n        this.ops = ops;\n        this.index = 0;\n        this.offset = 0;\n    }\n    Iterator.prototype.hasNext = function () {\n        return this.peekLength() < Infinity;\n    };\n    Iterator.prototype.next = function (length) {\n        if (!length) {\n            length = Infinity;\n        }\n        var nextOp = this.ops[this.index];\n        if (nextOp) {\n            var offset = this.offset;\n            var opLength = Op_1.default.length(nextOp);\n            if (length >= opLength - offset) {\n                length = opLength - offset;\n                this.index += 1;\n                this.offset = 0;\n            }\n            else {\n                this.offset += length;\n            }\n            if (typeof nextOp.delete === 'number') {\n                return { delete: length };\n            }\n            else {\n                var retOp = {};\n                if (nextOp.attributes) {\n                    retOp.attributes = nextOp.attributes;\n                }\n                if (typeof nextOp.retain === 'number') {\n                    retOp.retain = length;\n                }\n                else if (typeof nextOp.insert === 'string') {\n                    retOp.insert = nextOp.insert.substr(offset, length);\n                }\n                else {\n                    // offset should === 0, length should === 1\n                    retOp.insert = nextOp.insert;\n                }\n                return retOp;\n            }\n        }\n        else {\n            return { retain: Infinity };\n        }\n    };\n    Iterator.prototype.peek = function () {\n        return this.ops[this.index];\n    };\n    Iterator.prototype.peekLength = function () {\n        if (this.ops[this.index]) {\n            // Should never return 0 if our index is being managed correctly\n            return Op_1.default.length(this.ops[this.index]) - this.offset;\n        }\n        else {\n            return Infinity;\n        }\n    };\n    Iterator.prototype.peekType = function () {\n        if (this.ops[this.index]) {\n            if (typeof this.ops[this.index].delete === 'number') {\n                return 'delete';\n            }\n            else if (typeof this.ops[this.index].retain === 'number') {\n                return 'retain';\n            }\n            else {\n                return 'insert';\n            }\n        }\n        return 'retain';\n    };\n    Iterator.prototype.rest = function () {\n        if (!this.hasNext()) {\n            return [];\n        }\n        else if (this.offset === 0) {\n            return this.ops.slice(this.index);\n        }\n        else {\n            var offset = this.offset;\n            var index = this.index;\n            var next = this.next();\n            var rest = this.ops.slice(this.index);\n            this.offset = offset;\n            this.index = index;\n            return [next].concat(rest);\n        }\n    };\n    return Iterator;\n}());\nexports.default = Iterator;\n//# sourceMappingURL=Iterator.js.map\n\n//# sourceURL=webpack://Quill/./node_modules/quill-delta/dist/Iterator.js?");

/***/ }),

/***/ "./node_modules/quill-delta/dist/Op.js":
/*!*********************************************!*\
  !*** ./node_modules/quill-delta/dist/Op.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\nvar __importDefault = (this && this.__importDefault) || function (mod) {\n    return (mod && mod.__esModule) ? mod : { \"default\": mod };\n};\nObject.defineProperty(exports, \"__esModule\", { value: true });\nvar Iterator_1 = __importDefault(__webpack_require__(/*! ./Iterator */ \"./node_modules/quill-delta/dist/Iterator.js\"));\nvar Op;\n(function (Op) {\n    function iterator(ops) {\n        return new Iterator_1.default(ops);\n    }\n    Op.iterator = iterator;\n    function length(op) {\n        if (typeof op.delete === 'number') {\n            return op.delete;\n        }\n        else if (typeof op.retain === 'number') {\n            return op.retain;\n        }\n        else {\n            return typeof op.insert === 'string' ? op.insert.length : 1;\n        }\n    }\n    Op.length = length;\n})(Op || (Op = {}));\nexports.default = Op;\n//# sourceMappingURL=Op.js.map\n\n//# sourceURL=webpack://Quill/./node_modules/quill-delta/dist/Op.js?");

/***/ }),

/***/ "./quill.js":
/*!******************!*\
  !*** ./quill.js ***!
  \******************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./core */ \"./core.js\");\n/* harmony import */ var _formats_align__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./formats/align */ \"./formats/align.js\");\n/* harmony import */ var _formats_direction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./formats/direction */ \"./formats/direction.js\");\n/* harmony import */ var _formats_indent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./formats/indent */ \"./formats/indent.js\");\n/* harmony import */ var _formats_blockquote__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./formats/blockquote */ \"./formats/blockquote.js\");\n/* harmony import */ var _formats_header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./formats/header */ \"./formats/header.js\");\n/* harmony import */ var _formats_list__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./formats/list */ \"./formats/list.js\");\n/* harmony import */ var _formats_background__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./formats/background */ \"./formats/background.js\");\n/* harmony import */ var _formats_color__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./formats/color */ \"./formats/color.js\");\n/* harmony import */ var _formats_font__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./formats/font */ \"./formats/font.js\");\n/* harmony import */ var _formats_size__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./formats/size */ \"./formats/size.js\");\n/* harmony import */ var _formats_bold__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./formats/bold */ \"./formats/bold.js\");\n/* harmony import */ var _formats_italic__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./formats/italic */ \"./formats/italic.js\");\n/* harmony import */ var _formats_link__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./formats/link */ \"./formats/link.js\");\n/* harmony import */ var _formats_script__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./formats/script */ \"./formats/script.js\");\n/* harmony import */ var _formats_strike__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./formats/strike */ \"./formats/strike.js\");\n/* harmony import */ var _formats_underline__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./formats/underline */ \"./formats/underline.js\");\n/* harmony import */ var _formats_formula__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./formats/formula */ \"./formats/formula.js\");\n/* harmony import */ var _formats_image__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./formats/image */ \"./formats/image.js\");\n/* harmony import */ var _formats_video__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./formats/video */ \"./formats/video.js\");\n/* harmony import */ var _formats_code__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./formats/code */ \"./formats/code.js\");\n/* harmony import */ var _modules_syntax__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./modules/syntax */ \"./modules/syntax.js\");\n/* harmony import */ var _modules_table__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./modules/table */ \"./modules/table.js\");\n/* harmony import */ var _modules_toolbar__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./modules/toolbar */ \"./modules/toolbar.js\");\n/* harmony import */ var _ui_icons__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./ui/icons */ \"./ui/icons.js\");\n/* harmony import */ var _ui_picker__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./ui/picker */ \"./ui/picker.js\");\n/* harmony import */ var _ui_color_picker__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./ui/color-picker */ \"./ui/color-picker.js\");\n/* harmony import */ var _ui_icon_picker__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./ui/icon-picker */ \"./ui/icon-picker.js\");\n/* harmony import */ var _ui_tooltip__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./ui/tooltip */ \"./ui/tooltip.js\");\n/* harmony import */ var _themes_bubble__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./themes/bubble */ \"./themes/bubble.js\");\n/* harmony import */ var _themes_snow__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./themes/snow */ \"./themes/snow.js\");\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n_core__WEBPACK_IMPORTED_MODULE_0__[\"default\"].register({\n  'attributors/attribute/direction': _formats_direction__WEBPACK_IMPORTED_MODULE_2__[\"DirectionAttribute\"],\n  'attributors/class/align': _formats_align__WEBPACK_IMPORTED_MODULE_1__[\"AlignClass\"],\n  'attributors/class/background': _formats_background__WEBPACK_IMPORTED_MODULE_7__[\"BackgroundClass\"],\n  'attributors/class/color': _formats_color__WEBPACK_IMPORTED_MODULE_8__[\"ColorClass\"],\n  'attributors/class/direction': _formats_direction__WEBPACK_IMPORTED_MODULE_2__[\"DirectionClass\"],\n  'attributors/class/font': _formats_font__WEBPACK_IMPORTED_MODULE_9__[\"FontClass\"],\n  'attributors/class/size': _formats_size__WEBPACK_IMPORTED_MODULE_10__[\"SizeClass\"],\n  'attributors/style/align': _formats_align__WEBPACK_IMPORTED_MODULE_1__[\"AlignStyle\"],\n  'attributors/style/background': _formats_background__WEBPACK_IMPORTED_MODULE_7__[\"BackgroundStyle\"],\n  'attributors/style/color': _formats_color__WEBPACK_IMPORTED_MODULE_8__[\"ColorStyle\"],\n  'attributors/style/direction': _formats_direction__WEBPACK_IMPORTED_MODULE_2__[\"DirectionStyle\"],\n  'attributors/style/font': _formats_font__WEBPACK_IMPORTED_MODULE_9__[\"FontStyle\"],\n  'attributors/style/size': _formats_size__WEBPACK_IMPORTED_MODULE_10__[\"SizeStyle\"]\n}, true);\n_core__WEBPACK_IMPORTED_MODULE_0__[\"default\"].register({\n  'formats/align': _formats_align__WEBPACK_IMPORTED_MODULE_1__[\"AlignClass\"],\n  'formats/direction': _formats_direction__WEBPACK_IMPORTED_MODULE_2__[\"DirectionClass\"],\n  'formats/indent': _formats_indent__WEBPACK_IMPORTED_MODULE_3__[\"default\"],\n  'formats/background': _formats_background__WEBPACK_IMPORTED_MODULE_7__[\"BackgroundStyle\"],\n  'formats/color': _formats_color__WEBPACK_IMPORTED_MODULE_8__[\"ColorStyle\"],\n  'formats/font': _formats_font__WEBPACK_IMPORTED_MODULE_9__[\"FontClass\"],\n  'formats/size': _formats_size__WEBPACK_IMPORTED_MODULE_10__[\"SizeClass\"],\n  'formats/blockquote': _formats_blockquote__WEBPACK_IMPORTED_MODULE_4__[\"default\"],\n  'formats/code-block': _formats_code__WEBPACK_IMPORTED_MODULE_20__[\"default\"],\n  'formats/header': _formats_header__WEBPACK_IMPORTED_MODULE_5__[\"default\"],\n  'formats/list': _formats_list__WEBPACK_IMPORTED_MODULE_6__[\"default\"],\n  'formats/bold': _formats_bold__WEBPACK_IMPORTED_MODULE_11__[\"default\"],\n  'formats/code': _formats_code__WEBPACK_IMPORTED_MODULE_20__[\"Code\"],\n  'formats/italic': _formats_italic__WEBPACK_IMPORTED_MODULE_12__[\"default\"],\n  'formats/link': _formats_link__WEBPACK_IMPORTED_MODULE_13__[\"default\"],\n  'formats/script': _formats_script__WEBPACK_IMPORTED_MODULE_14__[\"default\"],\n  'formats/strike': _formats_strike__WEBPACK_IMPORTED_MODULE_15__[\"default\"],\n  'formats/underline': _formats_underline__WEBPACK_IMPORTED_MODULE_16__[\"default\"],\n  'formats/formula': _formats_formula__WEBPACK_IMPORTED_MODULE_17__[\"default\"],\n  'formats/image': _formats_image__WEBPACK_IMPORTED_MODULE_18__[\"default\"],\n  'formats/video': _formats_video__WEBPACK_IMPORTED_MODULE_19__[\"default\"],\n  'modules/syntax': _modules_syntax__WEBPACK_IMPORTED_MODULE_21__[\"default\"],\n  'modules/table': _modules_table__WEBPACK_IMPORTED_MODULE_22__[\"default\"],\n  'modules/toolbar': _modules_toolbar__WEBPACK_IMPORTED_MODULE_23__[\"default\"],\n  'themes/bubble': _themes_bubble__WEBPACK_IMPORTED_MODULE_29__[\"default\"],\n  'themes/snow': _themes_snow__WEBPACK_IMPORTED_MODULE_30__[\"default\"],\n  'ui/icons': _ui_icons__WEBPACK_IMPORTED_MODULE_24__[\"default\"],\n  'ui/picker': _ui_picker__WEBPACK_IMPORTED_MODULE_25__[\"default\"],\n  'ui/icon-picker': _ui_icon_picker__WEBPACK_IMPORTED_MODULE_27__[\"default\"],\n  'ui/color-picker': _ui_color_picker__WEBPACK_IMPORTED_MODULE_26__[\"default\"],\n  'ui/tooltip': _ui_tooltip__WEBPACK_IMPORTED_MODULE_28__[\"default\"]\n}, true);\n/* harmony default export */ __webpack_exports__[\"default\"] = (_core__WEBPACK_IMPORTED_MODULE_0__[\"default\"]);\n\n//# sourceURL=webpack://Quill/./quill.js?");

/***/ }),

/***/ "./themes/base.js":
/*!************************!*\
  !*** ./themes/base.js ***!
  \************************/
/*! exports provided: BaseTooltip, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"BaseTooltip\", function() { return BaseTooltip; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return BaseTheme; });\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! extend */ \"./node_modules/extend/index.js\");\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(extend__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _core_emitter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/emitter */ \"./core/emitter.js\");\n/* harmony import */ var _core_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/theme */ \"./core/theme.js\");\n/* harmony import */ var _ui_color_picker__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../ui/color-picker */ \"./ui/color-picker.js\");\n/* harmony import */ var _ui_icon_picker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../ui/icon-picker */ \"./ui/icon-picker.js\");\n/* harmony import */ var _ui_picker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../ui/picker */ \"./ui/picker.js\");\n/* harmony import */ var _ui_tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../ui/tooltip */ \"./ui/tooltip.js\");\n\n\n\n\n\n\n\nconst ALIGNS = [false, 'center', 'right', 'justify'];\nconst COLORS = ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466'];\nconst FONTS = [false, 'serif', 'monospace'];\nconst HEADERS = ['1', '2', '3', false];\nconst SIZES = ['small', false, 'large', 'huge'];\n\nclass BaseTheme extends _core_theme__WEBPACK_IMPORTED_MODULE_2__[\"default\"] {\n  constructor(quill, options) {\n    super(quill, options);\n\n    const listener = e => {\n      if (!document.body.contains(quill.root)) {\n        document.body.removeEventListener('click', listener);\n        return;\n      }\n\n      if (this.tooltip != null && !this.tooltip.root.contains(e.target) && document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) {\n        this.tooltip.hide();\n      }\n\n      if (this.pickers != null) {\n        this.pickers.forEach(picker => {\n          if (!picker.container.contains(e.target)) {\n            picker.close();\n          }\n        });\n      }\n    };\n\n    quill.emitter.listenDOM('click', document.body, listener);\n  }\n\n  addModule(name) {\n    const module = super.addModule(name);\n\n    if (name === 'toolbar') {\n      this.extendToolbar(module);\n    }\n\n    return module;\n  }\n\n  buildButtons(buttons, icons) {\n    Array.from(buttons).forEach(button => {\n      const className = button.getAttribute('class') || '';\n      className.split(/\\s+/).forEach(name => {\n        if (!name.startsWith('ql-')) return;\n        name = name.slice('ql-'.length);\n        if (icons[name] == null) return;\n\n        if (name === 'direction') {\n          button.innerHTML = icons[name][''] + icons[name].rtl;\n        } else if (typeof icons[name] === 'string') {\n          button.innerHTML = icons[name];\n        } else {\n          const value = button.value || '';\n\n          if (value != null && icons[name][value]) {\n            button.innerHTML = icons[name][value];\n          }\n        }\n      });\n    });\n  }\n\n  buildPickers(selects, icons) {\n    this.pickers = Array.from(selects).map(select => {\n      if (select.classList.contains('ql-align')) {\n        if (select.querySelector('option') == null) {\n          fillSelect(select, ALIGNS);\n        }\n\n        return new _ui_icon_picker__WEBPACK_IMPORTED_MODULE_4__[\"default\"](select, icons.align);\n      }\n\n      if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {\n        const format = select.classList.contains('ql-background') ? 'background' : 'color';\n\n        if (select.querySelector('option') == null) {\n          fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');\n        }\n\n        return new _ui_color_picker__WEBPACK_IMPORTED_MODULE_3__[\"default\"](select, icons[format]);\n      }\n\n      if (select.querySelector('option') == null) {\n        if (select.classList.contains('ql-font')) {\n          fillSelect(select, FONTS);\n        } else if (select.classList.contains('ql-header')) {\n          fillSelect(select, HEADERS);\n        } else if (select.classList.contains('ql-size')) {\n          fillSelect(select, SIZES);\n        }\n      }\n\n      return new _ui_picker__WEBPACK_IMPORTED_MODULE_5__[\"default\"](select);\n    });\n\n    const update = () => {\n      this.pickers.forEach(picker => {\n        picker.update();\n      });\n    };\n\n    this.quill.on(_core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.EDITOR_CHANGE, update);\n  }\n\n}\n\nBaseTheme.DEFAULTS = extend__WEBPACK_IMPORTED_MODULE_0___default()(true, {}, _core_theme__WEBPACK_IMPORTED_MODULE_2__[\"default\"].DEFAULTS, {\n  modules: {\n    toolbar: {\n      handlers: {\n        formula() {\n          this.quill.theme.tooltip.edit('formula');\n        },\n\n        image() {\n          let fileInput = this.container.querySelector('input.ql-image[type=file]');\n\n          if (fileInput == null) {\n            fileInput = document.createElement('input');\n            fileInput.setAttribute('type', 'file');\n            fileInput.setAttribute('accept', this.quill.uploader.options.mimetypes.join(', '));\n            fileInput.classList.add('ql-image');\n            fileInput.addEventListener('change', () => {\n              const range = this.quill.getSelection(true);\n              this.quill.uploader.upload(range, fileInput.files);\n              fileInput.value = '';\n            });\n            this.container.appendChild(fileInput);\n          }\n\n          fileInput.click();\n        },\n\n        video() {\n          this.quill.theme.tooltip.edit('video');\n        }\n\n      }\n    }\n  }\n});\n\nclass BaseTooltip extends _ui_tooltip__WEBPACK_IMPORTED_MODULE_6__[\"default\"] {\n  constructor(quill, boundsContainer) {\n    super(quill, boundsContainer);\n    this.textbox = this.root.querySelector('input[type=\"text\"]');\n    this.listen();\n  }\n\n  listen() {\n    this.textbox.addEventListener('keydown', event => {\n      if (event.key === 'Enter') {\n        this.save();\n        event.preventDefault();\n      } else if (event.key === 'Escape') {\n        this.cancel();\n        event.preventDefault();\n      }\n    });\n  }\n\n  cancel() {\n    this.hide();\n  }\n\n  edit() {\n    let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';\n    let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;\n    this.root.classList.remove('ql-hidden');\n    this.root.classList.add('ql-editing');\n\n    if (preview != null) {\n      this.textbox.value = preview;\n    } else if (mode !== this.root.getAttribute('data-mode')) {\n      this.textbox.value = '';\n    }\n\n    this.position(this.quill.getBounds(this.quill.selection.savedRange));\n    this.textbox.select();\n    this.textbox.setAttribute('placeholder', this.textbox.getAttribute(\"data-\".concat(mode)) || '');\n    this.root.setAttribute('data-mode', mode);\n  }\n\n  restoreFocus() {\n    const scrollTop = this.quill.scrollingContainer.scrollTop;\n    this.quill.focus();\n    this.quill.scrollingContainer.scrollTop = scrollTop;\n  }\n\n  save() {\n    let value = this.textbox.value;\n\n    switch (this.root.getAttribute('data-mode')) {\n      case 'link':\n        {\n          const scrollTop = this.quill.root.scrollTop;\n\n          if (this.linkRange) {\n            this.quill.formatText(this.linkRange, 'link', value, _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n            delete this.linkRange;\n          } else {\n            this.restoreFocus();\n            this.quill.format('link', value, _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n          }\n\n          this.quill.root.scrollTop = scrollTop;\n          break;\n        }\n\n      case 'video':\n        {\n          value = extractVideoUrl(value);\n        }\n      // eslint-disable-next-line no-fallthrough\n\n      case 'formula':\n        {\n          if (!value) break;\n          const range = this.quill.getSelection(true);\n\n          if (range != null) {\n            const index = range.index + range.length;\n            this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n\n            if (this.root.getAttribute('data-mode') === 'formula') {\n              this.quill.insertText(index + 1, ' ', _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n            }\n\n            this.quill.setSelection(index + 2, _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n          }\n\n          break;\n        }\n\n      default:\n    }\n\n    this.textbox.value = '';\n    this.hide();\n  }\n\n}\n\nfunction extractVideoUrl(url) {\n  let match = url.match(/^(?:(https?):\\/\\/)?(?:(?:www|m)\\.)?youtube\\.com\\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\\/\\/)?(?:(?:www|m)\\.)?youtu\\.be\\/([a-zA-Z0-9_-]+)/);\n\n  if (match) {\n    return \"\".concat(match[1] || 'https', \"://www.youtube.com/embed/\").concat(match[2], \"?showinfo=0\");\n  } // eslint-disable-next-line no-cond-assign\n\n\n  if (match = url.match(/^(?:(https?):\\/\\/)?(?:www\\.)?vimeo\\.com\\/(\\d+)/)) {\n    return \"\".concat(match[1] || 'https', \"://player.vimeo.com/video/\").concat(match[2], \"/\");\n  }\n\n  return url;\n}\n\nfunction fillSelect(select, values) {\n  let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;\n  values.forEach(value => {\n    const option = document.createElement('option');\n\n    if (value === defaultValue) {\n      option.setAttribute('selected', 'selected');\n    } else {\n      option.setAttribute('value', value);\n    }\n\n    select.appendChild(option);\n  });\n}\n\n\n\n//# sourceURL=webpack://Quill/./themes/base.js?");

/***/ }),

/***/ "./themes/bubble.js":
/*!**************************!*\
  !*** ./themes/bubble.js ***!
  \**************************/
/*! exports provided: BubbleTooltip, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"BubbleTooltip\", function() { return BubbleTooltip; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return BubbleTheme; });\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! extend */ \"./node_modules/extend/index.js\");\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(extend__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _core_emitter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/emitter */ \"./core/emitter.js\");\n/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./base */ \"./themes/base.js\");\n/* harmony import */ var _core_selection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/selection */ \"./core/selection.js\");\n/* harmony import */ var _ui_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../ui/icons */ \"./ui/icons.js\");\n\n\n\n\n\nconst TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{\n  header: 1\n}, {\n  header: 2\n}, 'blockquote']];\n\nclass BubbleTooltip extends _base__WEBPACK_IMPORTED_MODULE_2__[\"BaseTooltip\"] {\n  constructor(quill, bounds) {\n    super(quill, bounds);\n    this.quill.on(_core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.EDITOR_CHANGE, (type, range, oldRange, source) => {\n      if (type !== _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.SELECTION_CHANGE) return;\n\n      if (range != null && range.length > 0 && source === _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER) {\n        this.show(); // Lock our width so we will expand beyond our offsetParent boundaries\n\n        this.root.style.left = '0px';\n        this.root.style.width = '';\n        this.root.style.width = \"\".concat(this.root.offsetWidth, \"px\");\n        const lines = this.quill.getLines(range.index, range.length);\n\n        if (lines.length === 1) {\n          this.position(this.quill.getBounds(range));\n        } else {\n          const lastLine = lines[lines.length - 1];\n          const index = this.quill.getIndex(lastLine);\n          const length = Math.min(lastLine.length() - 1, range.index + range.length - index);\n          const indexBounds = this.quill.getBounds(new _core_selection__WEBPACK_IMPORTED_MODULE_3__[\"Range\"](index, length));\n          this.position(indexBounds);\n        }\n      } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) {\n        this.hide();\n      }\n    });\n  }\n\n  listen() {\n    super.listen();\n    this.root.querySelector('.ql-close').addEventListener('click', () => {\n      this.root.classList.remove('ql-editing');\n    });\n    this.quill.on(_core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.SCROLL_OPTIMIZE, () => {\n      // Let selection be restored by toolbar handlers before repositioning\n      setTimeout(() => {\n        if (this.root.classList.contains('ql-hidden')) return;\n        const range = this.quill.getSelection();\n\n        if (range != null) {\n          this.position(this.quill.getBounds(range));\n        }\n      }, 1);\n    });\n  }\n\n  cancel() {\n    this.show();\n  }\n\n  position(reference) {\n    const shift = super.position(reference);\n    const arrow = this.root.querySelector('.ql-tooltip-arrow');\n    arrow.style.marginLeft = '';\n\n    if (shift !== 0) {\n      arrow.style.marginLeft = \"\".concat(-1 * shift - arrow.offsetWidth / 2, \"px\");\n    }\n\n    return shift;\n  }\n\n}\n\nBubbleTooltip.TEMPLATE = ['<span class=\"ql-tooltip-arrow\"></span>', '<div class=\"ql-tooltip-editor\">', '<input type=\"text\" data-formula=\"e=mc^2\" data-link=\"https://quilljs.com\" data-video=\"Embed URL\">', '<a class=\"ql-close\"></a>', '</div>'].join('');\n\nclass BubbleTheme extends _base__WEBPACK_IMPORTED_MODULE_2__[\"default\"] {\n  constructor(quill, options) {\n    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {\n      options.modules.toolbar.container = TOOLBAR_CONFIG;\n    }\n\n    super(quill, options);\n    this.quill.container.classList.add('ql-bubble');\n  }\n\n  extendToolbar(toolbar) {\n    this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);\n    this.tooltip.root.appendChild(toolbar.container);\n    this.buildButtons(toolbar.container.querySelectorAll('button'), _ui_icons__WEBPACK_IMPORTED_MODULE_4__[\"default\"]);\n    this.buildPickers(toolbar.container.querySelectorAll('select'), _ui_icons__WEBPACK_IMPORTED_MODULE_4__[\"default\"]);\n  }\n\n}\n\nBubbleTheme.DEFAULTS = extend__WEBPACK_IMPORTED_MODULE_0___default()(true, {}, _base__WEBPACK_IMPORTED_MODULE_2__[\"default\"].DEFAULTS, {\n  modules: {\n    toolbar: {\n      handlers: {\n        link(value) {\n          if (!value) {\n            this.quill.format('link', false);\n          } else {\n            this.quill.theme.tooltip.edit();\n          }\n        }\n\n      }\n    }\n  }\n});\n\n\n//# sourceURL=webpack://Quill/./themes/bubble.js?");

/***/ }),

/***/ "./themes/snow.js":
/*!************************!*\
  !*** ./themes/snow.js ***!
  \************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! extend */ \"./node_modules/extend/index.js\");\n/* harmony import */ var extend__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(extend__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _core_emitter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/emitter */ \"./core/emitter.js\");\n/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./base */ \"./themes/base.js\");\n/* harmony import */ var _formats_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../formats/link */ \"./formats/link.js\");\n/* harmony import */ var _core_selection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../core/selection */ \"./core/selection.js\");\n/* harmony import */ var _ui_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../ui/icons */ \"./ui/icons.js\");\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\n\n\n\n\nconst TOOLBAR_CONFIG = [[{\n  header: ['1', '2', '3', false]\n}], ['bold', 'italic', 'underline', 'link'], [{\n  list: 'ordered'\n}, {\n  list: 'bullet'\n}], ['clean']];\n\nclass SnowTooltip extends _base__WEBPACK_IMPORTED_MODULE_2__[\"BaseTooltip\"] {\n  constructor(quill, bounds) {\n    super(quill, bounds);\n    this.preview = this.root.querySelector('a.ql-preview');\n  }\n\n  listen() {\n    super.listen();\n    this.root.querySelector('a.ql-action').addEventListener('click', event => {\n      if (this.root.classList.contains('ql-editing')) {\n        this.save();\n      } else {\n        this.edit('link', this.preview.textContent);\n      }\n\n      event.preventDefault();\n    });\n    this.root.querySelector('a.ql-remove').addEventListener('click', event => {\n      if (this.linkRange != null) {\n        const range = this.linkRange;\n        this.restoreFocus();\n        this.quill.formatText(range, 'link', false, _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER);\n        delete this.linkRange;\n      }\n\n      event.preventDefault();\n      this.hide();\n    });\n    this.quill.on(_core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].events.SELECTION_CHANGE, (range, oldRange, source) => {\n      if (range == null) return;\n\n      if (range.length === 0 && source === _core_emitter__WEBPACK_IMPORTED_MODULE_1__[\"default\"].sources.USER) {\n        const _this$quill$scroll$de = this.quill.scroll.descendant(_formats_link__WEBPACK_IMPORTED_MODULE_3__[\"default\"], range.index),\n              _this$quill$scroll$de2 = _slicedToArray(_this$quill$scroll$de, 2),\n              link = _this$quill$scroll$de2[0],\n              offset = _this$quill$scroll$de2[1];\n\n        if (link != null) {\n          this.linkRange = new _core_selection__WEBPACK_IMPORTED_MODULE_4__[\"Range\"](range.index - offset, link.length());\n          const preview = _formats_link__WEBPACK_IMPORTED_MODULE_3__[\"default\"].formats(link.domNode);\n          this.preview.textContent = preview;\n          this.preview.setAttribute('href', preview);\n          this.show();\n          this.position(this.quill.getBounds(this.linkRange));\n          return;\n        }\n      } else {\n        delete this.linkRange;\n      }\n\n      this.hide();\n    });\n  }\n\n  show() {\n    super.show();\n    this.root.removeAttribute('data-mode');\n  }\n\n}\n\nSnowTooltip.TEMPLATE = ['<a class=\"ql-preview\" rel=\"noopener noreferrer\" target=\"_blank\" href=\"about:blank\"></a>', '<input type=\"text\" data-formula=\"e=mc^2\" data-link=\"https://quilljs.com\" data-video=\"Embed URL\">', '<a class=\"ql-action\"></a>', '<a class=\"ql-remove\"></a>'].join('');\n\nclass SnowTheme extends _base__WEBPACK_IMPORTED_MODULE_2__[\"default\"] {\n  constructor(quill, options) {\n    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {\n      options.modules.toolbar.container = TOOLBAR_CONFIG;\n    }\n\n    super(quill, options);\n    this.quill.container.classList.add('ql-snow');\n  }\n\n  extendToolbar(toolbar) {\n    toolbar.container.classList.add('ql-snow');\n    this.buildButtons(toolbar.container.querySelectorAll('button'), _ui_icons__WEBPACK_IMPORTED_MODULE_5__[\"default\"]);\n    this.buildPickers(toolbar.container.querySelectorAll('select'), _ui_icons__WEBPACK_IMPORTED_MODULE_5__[\"default\"]);\n    this.tooltip = new SnowTooltip(this.quill, this.options.bounds);\n\n    if (toolbar.container.querySelector('.ql-link')) {\n      this.quill.keyboard.addBinding({\n        key: 'k',\n        shortKey: true\n      }, (range, context) => {\n        toolbar.handlers.link.call(toolbar, !context.format.link);\n      });\n    }\n  }\n\n}\n\nSnowTheme.DEFAULTS = extend__WEBPACK_IMPORTED_MODULE_0___default()(true, {}, _base__WEBPACK_IMPORTED_MODULE_2__[\"default\"].DEFAULTS, {\n  modules: {\n    toolbar: {\n      handlers: {\n        link(value) {\n          if (value) {\n            const range = this.quill.getSelection();\n            if (range == null || range.length === 0) return;\n            let preview = this.quill.getText(range);\n\n            if (/^\\S+@\\S+\\.\\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {\n              preview = \"mailto:\".concat(preview);\n            }\n\n            const tooltip = this.quill.theme.tooltip;\n            tooltip.edit('link', preview);\n          } else {\n            this.quill.format('link', false);\n          }\n        }\n\n      }\n    }\n  }\n});\n/* harmony default export */ __webpack_exports__[\"default\"] = (SnowTheme);\n\n//# sourceURL=webpack://Quill/./themes/snow.js?");

/***/ }),

/***/ "./ui/color-picker.js":
/*!****************************!*\
  !*** ./ui/color-picker.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _picker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./picker */ \"./ui/picker.js\");\n\n\nclass ColorPicker extends _picker__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n  constructor(select, label) {\n    super(select);\n    this.label.innerHTML = label;\n    this.container.classList.add('ql-color-picker');\n    Array.from(this.container.querySelectorAll('.ql-picker-item')).slice(0, 7).forEach(item => {\n      item.classList.add('ql-primary');\n    });\n  }\n\n  buildItem(option) {\n    const item = super.buildItem(option);\n    item.style.backgroundColor = option.getAttribute('value') || '';\n    return item;\n  }\n\n  selectItem(item, trigger) {\n    super.selectItem(item, trigger);\n    const colorLabel = this.label.querySelector('.ql-color-label');\n    const value = item ? item.getAttribute('data-value') || '' : '';\n\n    if (colorLabel) {\n      if (colorLabel.tagName === 'line') {\n        colorLabel.style.stroke = value;\n      } else {\n        colorLabel.style.fill = value;\n      }\n    }\n  }\n\n}\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (ColorPicker);\n\n//# sourceURL=webpack://Quill/./ui/color-picker.js?");

/***/ }),

/***/ "./ui/icon-picker.js":
/*!***************************!*\
  !*** ./ui/icon-picker.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _picker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./picker */ \"./ui/picker.js\");\n\n\nclass IconPicker extends _picker__WEBPACK_IMPORTED_MODULE_0__[\"default\"] {\n  constructor(select, icons) {\n    super(select);\n    this.container.classList.add('ql-icon-picker');\n    Array.from(this.container.querySelectorAll('.ql-picker-item')).forEach(item => {\n      item.innerHTML = icons[item.getAttribute('data-value') || ''];\n    });\n    this.defaultItem = this.container.querySelector('.ql-selected');\n    this.selectItem(this.defaultItem);\n  }\n\n  selectItem(target, trigger) {\n    super.selectItem(target, trigger);\n    const item = target || this.defaultItem;\n    if (this.label.innerHTML === item.innerHTML) return;\n    this.label.innerHTML = item.innerHTML;\n  }\n\n}\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (IconPicker);\n\n//# sourceURL=webpack://Quill/./ui/icon-picker.js?");

/***/ }),

/***/ "./ui/icons.js":
/*!*********************!*\
  !*** ./ui/icons.js ***!
  \*********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _assets_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../assets/icons/align-left.svg */ \"./assets/icons/align-left.svg\");\n/* harmony import */ var _assets_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _assets_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../assets/icons/align-center.svg */ \"./assets/icons/align-center.svg\");\n/* harmony import */ var _assets_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var _assets_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../assets/icons/align-right.svg */ \"./assets/icons/align-right.svg\");\n/* harmony import */ var _assets_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_2__);\n/* harmony import */ var _assets_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../assets/icons/align-justify.svg */ \"./assets/icons/align-justify.svg\");\n/* harmony import */ var _assets_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_3__);\n/* harmony import */ var _assets_icons_background_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../assets/icons/background.svg */ \"./assets/icons/background.svg\");\n/* harmony import */ var _assets_icons_background_svg__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_background_svg__WEBPACK_IMPORTED_MODULE_4__);\n/* harmony import */ var _assets_icons_blockquote_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../assets/icons/blockquote.svg */ \"./assets/icons/blockquote.svg\");\n/* harmony import */ var _assets_icons_blockquote_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_blockquote_svg__WEBPACK_IMPORTED_MODULE_5__);\n/* harmony import */ var _assets_icons_bold_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../assets/icons/bold.svg */ \"./assets/icons/bold.svg\");\n/* harmony import */ var _assets_icons_bold_svg__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_bold_svg__WEBPACK_IMPORTED_MODULE_6__);\n/* harmony import */ var _assets_icons_clean_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../assets/icons/clean.svg */ \"./assets/icons/clean.svg\");\n/* harmony import */ var _assets_icons_clean_svg__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_clean_svg__WEBPACK_IMPORTED_MODULE_7__);\n/* harmony import */ var _assets_icons_code_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../assets/icons/code.svg */ \"./assets/icons/code.svg\");\n/* harmony import */ var _assets_icons_code_svg__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_code_svg__WEBPACK_IMPORTED_MODULE_8__);\n/* harmony import */ var _assets_icons_color_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../assets/icons/color.svg */ \"./assets/icons/color.svg\");\n/* harmony import */ var _assets_icons_color_svg__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_color_svg__WEBPACK_IMPORTED_MODULE_9__);\n/* harmony import */ var _assets_icons_direction_ltr_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../assets/icons/direction-ltr.svg */ \"./assets/icons/direction-ltr.svg\");\n/* harmony import */ var _assets_icons_direction_ltr_svg__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_direction_ltr_svg__WEBPACK_IMPORTED_MODULE_10__);\n/* harmony import */ var _assets_icons_direction_rtl_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../assets/icons/direction-rtl.svg */ \"./assets/icons/direction-rtl.svg\");\n/* harmony import */ var _assets_icons_direction_rtl_svg__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_direction_rtl_svg__WEBPACK_IMPORTED_MODULE_11__);\n/* harmony import */ var _assets_icons_formula_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../assets/icons/formula.svg */ \"./assets/icons/formula.svg\");\n/* harmony import */ var _assets_icons_formula_svg__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_formula_svg__WEBPACK_IMPORTED_MODULE_12__);\n/* harmony import */ var _assets_icons_header_svg__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../assets/icons/header.svg */ \"./assets/icons/header.svg\");\n/* harmony import */ var _assets_icons_header_svg__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_header_svg__WEBPACK_IMPORTED_MODULE_13__);\n/* harmony import */ var _assets_icons_header_2_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../assets/icons/header-2.svg */ \"./assets/icons/header-2.svg\");\n/* harmony import */ var _assets_icons_header_2_svg__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_header_2_svg__WEBPACK_IMPORTED_MODULE_14__);\n/* harmony import */ var _assets_icons_italic_svg__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../assets/icons/italic.svg */ \"./assets/icons/italic.svg\");\n/* harmony import */ var _assets_icons_italic_svg__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_italic_svg__WEBPACK_IMPORTED_MODULE_15__);\n/* harmony import */ var _assets_icons_image_svg__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../assets/icons/image.svg */ \"./assets/icons/image.svg\");\n/* harmony import */ var _assets_icons_image_svg__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_image_svg__WEBPACK_IMPORTED_MODULE_16__);\n/* harmony import */ var _assets_icons_indent_svg__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../assets/icons/indent.svg */ \"./assets/icons/indent.svg\");\n/* harmony import */ var _assets_icons_indent_svg__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_indent_svg__WEBPACK_IMPORTED_MODULE_17__);\n/* harmony import */ var _assets_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../assets/icons/outdent.svg */ \"./assets/icons/outdent.svg\");\n/* harmony import */ var _assets_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_18__);\n/* harmony import */ var _assets_icons_link_svg__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../assets/icons/link.svg */ \"./assets/icons/link.svg\");\n/* harmony import */ var _assets_icons_link_svg__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_link_svg__WEBPACK_IMPORTED_MODULE_19__);\n/* harmony import */ var _assets_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../assets/icons/list-bullet.svg */ \"./assets/icons/list-bullet.svg\");\n/* harmony import */ var _assets_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_20__);\n/* harmony import */ var _assets_icons_list_check_svg__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../assets/icons/list-check.svg */ \"./assets/icons/list-check.svg\");\n/* harmony import */ var _assets_icons_list_check_svg__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_list_check_svg__WEBPACK_IMPORTED_MODULE_21__);\n/* harmony import */ var _assets_icons_list_ordered_svg__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../assets/icons/list-ordered.svg */ \"./assets/icons/list-ordered.svg\");\n/* harmony import */ var _assets_icons_list_ordered_svg__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_list_ordered_svg__WEBPACK_IMPORTED_MODULE_22__);\n/* harmony import */ var _assets_icons_subscript_svg__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../assets/icons/subscript.svg */ \"./assets/icons/subscript.svg\");\n/* harmony import */ var _assets_icons_subscript_svg__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_subscript_svg__WEBPACK_IMPORTED_MODULE_23__);\n/* harmony import */ var _assets_icons_superscript_svg__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../assets/icons/superscript.svg */ \"./assets/icons/superscript.svg\");\n/* harmony import */ var _assets_icons_superscript_svg__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_superscript_svg__WEBPACK_IMPORTED_MODULE_24__);\n/* harmony import */ var _assets_icons_strike_svg__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../assets/icons/strike.svg */ \"./assets/icons/strike.svg\");\n/* harmony import */ var _assets_icons_strike_svg__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_strike_svg__WEBPACK_IMPORTED_MODULE_25__);\n/* harmony import */ var _assets_icons_table_svg__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../assets/icons/table.svg */ \"./assets/icons/table.svg\");\n/* harmony import */ var _assets_icons_table_svg__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_table_svg__WEBPACK_IMPORTED_MODULE_26__);\n/* harmony import */ var _assets_icons_underline_svg__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../assets/icons/underline.svg */ \"./assets/icons/underline.svg\");\n/* harmony import */ var _assets_icons_underline_svg__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_underline_svg__WEBPACK_IMPORTED_MODULE_27__);\n/* harmony import */ var _assets_icons_video_svg__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../assets/icons/video.svg */ \"./assets/icons/video.svg\");\n/* harmony import */ var _assets_icons_video_svg__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_video_svg__WEBPACK_IMPORTED_MODULE_28__);\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* harmony default export */ __webpack_exports__[\"default\"] = ({\n  align: {\n    '': _assets_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_0___default.a,\n    center: _assets_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_1___default.a,\n    right: _assets_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_2___default.a,\n    justify: _assets_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_3___default.a\n  },\n  background: _assets_icons_background_svg__WEBPACK_IMPORTED_MODULE_4___default.a,\n  blockquote: _assets_icons_blockquote_svg__WEBPACK_IMPORTED_MODULE_5___default.a,\n  bold: _assets_icons_bold_svg__WEBPACK_IMPORTED_MODULE_6___default.a,\n  clean: _assets_icons_clean_svg__WEBPACK_IMPORTED_MODULE_7___default.a,\n  code: _assets_icons_code_svg__WEBPACK_IMPORTED_MODULE_8___default.a,\n  'code-block': _assets_icons_code_svg__WEBPACK_IMPORTED_MODULE_8___default.a,\n  color: _assets_icons_color_svg__WEBPACK_IMPORTED_MODULE_9___default.a,\n  direction: {\n    '': _assets_icons_direction_ltr_svg__WEBPACK_IMPORTED_MODULE_10___default.a,\n    rtl: _assets_icons_direction_rtl_svg__WEBPACK_IMPORTED_MODULE_11___default.a\n  },\n  formula: _assets_icons_formula_svg__WEBPACK_IMPORTED_MODULE_12___default.a,\n  header: {\n    '1': _assets_icons_header_svg__WEBPACK_IMPORTED_MODULE_13___default.a,\n    '2': _assets_icons_header_2_svg__WEBPACK_IMPORTED_MODULE_14___default.a\n  },\n  italic: _assets_icons_italic_svg__WEBPACK_IMPORTED_MODULE_15___default.a,\n  image: _assets_icons_image_svg__WEBPACK_IMPORTED_MODULE_16___default.a,\n  indent: {\n    '+1': _assets_icons_indent_svg__WEBPACK_IMPORTED_MODULE_17___default.a,\n    '-1': _assets_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_18___default.a\n  },\n  link: _assets_icons_link_svg__WEBPACK_IMPORTED_MODULE_19___default.a,\n  list: {\n    bullet: _assets_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_20___default.a,\n    check: _assets_icons_list_check_svg__WEBPACK_IMPORTED_MODULE_21___default.a,\n    ordered: _assets_icons_list_ordered_svg__WEBPACK_IMPORTED_MODULE_22___default.a\n  },\n  script: {\n    sub: _assets_icons_subscript_svg__WEBPACK_IMPORTED_MODULE_23___default.a,\n    super: _assets_icons_superscript_svg__WEBPACK_IMPORTED_MODULE_24___default.a\n  },\n  strike: _assets_icons_strike_svg__WEBPACK_IMPORTED_MODULE_25___default.a,\n  table: _assets_icons_table_svg__WEBPACK_IMPORTED_MODULE_26___default.a,\n  underline: _assets_icons_underline_svg__WEBPACK_IMPORTED_MODULE_27___default.a,\n  video: _assets_icons_video_svg__WEBPACK_IMPORTED_MODULE_28___default.a\n});\n\n//# sourceURL=webpack://Quill/./ui/icons.js?");

/***/ }),

/***/ "./ui/picker.js":
/*!**********************!*\
  !*** ./ui/picker.js ***!
  \**********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _assets_icons_dropdown_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../assets/icons/dropdown.svg */ \"./assets/icons/dropdown.svg\");\n/* harmony import */ var _assets_icons_dropdown_svg__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_dropdown_svg__WEBPACK_IMPORTED_MODULE_0__);\n\nlet optionsCounter = 0;\n\nfunction toggleAriaAttribute(element, attribute) {\n  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));\n}\n\nclass Picker {\n  constructor(select) {\n    this.select = select;\n    this.container = document.createElement('span');\n    this.buildPicker();\n    this.select.style.display = 'none';\n    this.select.parentNode.insertBefore(this.container, this.select);\n    this.label.addEventListener('mousedown', () => {\n      this.togglePicker();\n    });\n    this.label.addEventListener('keydown', event => {\n      switch (event.key) {\n        case 'Enter':\n          this.togglePicker();\n          break;\n\n        case 'Escape':\n          this.escape();\n          event.preventDefault();\n          break;\n\n        default:\n      }\n    });\n    this.select.addEventListener('change', this.update.bind(this));\n  }\n\n  togglePicker() {\n    this.container.classList.toggle('ql-expanded'); // Toggle aria-expanded and aria-hidden to make the picker accessible\n\n    toggleAriaAttribute(this.label, 'aria-expanded');\n    toggleAriaAttribute(this.options, 'aria-hidden');\n  }\n\n  buildItem(option) {\n    const item = document.createElement('span');\n    item.tabIndex = '0';\n    item.setAttribute('role', 'button');\n    item.classList.add('ql-picker-item');\n\n    if (option.hasAttribute('value')) {\n      item.setAttribute('data-value', option.getAttribute('value'));\n    }\n\n    if (option.textContent) {\n      item.setAttribute('data-label', option.textContent);\n    }\n\n    item.addEventListener('click', () => {\n      this.selectItem(item, true);\n    });\n    item.addEventListener('keydown', event => {\n      switch (event.key) {\n        case 'Enter':\n          this.selectItem(item, true);\n          event.preventDefault();\n          break;\n\n        case 'Escape':\n          this.escape();\n          event.preventDefault();\n          break;\n\n        default:\n      }\n    });\n    return item;\n  }\n\n  buildLabel() {\n    const label = document.createElement('span');\n    label.classList.add('ql-picker-label');\n    label.innerHTML = _assets_icons_dropdown_svg__WEBPACK_IMPORTED_MODULE_0___default.a;\n    label.tabIndex = '0';\n    label.setAttribute('role', 'button');\n    label.setAttribute('aria-expanded', 'false');\n    this.container.appendChild(label);\n    return label;\n  }\n\n  buildOptions() {\n    const options = document.createElement('span');\n    options.classList.add('ql-picker-options'); // Don't want screen readers to read this until options are visible\n\n    options.setAttribute('aria-hidden', 'true');\n    options.tabIndex = '-1'; // Need a unique id for aria-controls\n\n    options.id = \"ql-picker-options-\".concat(optionsCounter);\n    optionsCounter += 1;\n    this.label.setAttribute('aria-controls', options.id);\n    this.options = options;\n    Array.from(this.select.options).forEach(option => {\n      const item = this.buildItem(option);\n      options.appendChild(item);\n\n      if (option.selected === true) {\n        this.selectItem(item);\n      }\n    });\n    this.container.appendChild(options);\n  }\n\n  buildPicker() {\n    Array.from(this.select.attributes).forEach(item => {\n      this.container.setAttribute(item.name, item.value);\n    });\n    this.container.classList.add('ql-picker');\n    this.label = this.buildLabel();\n    this.buildOptions();\n  }\n\n  escape() {\n    // Close menu and return focus to trigger label\n    this.close(); // Need setTimeout for accessibility to ensure that the browser executes\n    // focus on the next process thread and after any DOM content changes\n\n    setTimeout(() => this.label.focus(), 1);\n  }\n\n  close() {\n    this.container.classList.remove('ql-expanded');\n    this.label.setAttribute('aria-expanded', 'false');\n    this.options.setAttribute('aria-hidden', 'true');\n  }\n\n  selectItem(item) {\n    let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n    const selected = this.container.querySelector('.ql-selected');\n    if (item === selected) return;\n\n    if (selected != null) {\n      selected.classList.remove('ql-selected');\n    }\n\n    if (item == null) return;\n    item.classList.add('ql-selected');\n    this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);\n\n    if (item.hasAttribute('data-value')) {\n      this.label.setAttribute('data-value', item.getAttribute('data-value'));\n    } else {\n      this.label.removeAttribute('data-value');\n    }\n\n    if (item.hasAttribute('data-label')) {\n      this.label.setAttribute('data-label', item.getAttribute('data-label'));\n    } else {\n      this.label.removeAttribute('data-label');\n    }\n\n    if (trigger) {\n      this.select.dispatchEvent(new Event('change'));\n      this.close();\n    }\n  }\n\n  update() {\n    let option;\n\n    if (this.select.selectedIndex > -1) {\n      const item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];\n      option = this.select.options[this.select.selectedIndex];\n      this.selectItem(item);\n    } else {\n      this.selectItem(null);\n    }\n\n    const isActive = option != null && option !== this.select.querySelector('option[selected]');\n    this.label.classList.toggle('ql-active', isActive);\n  }\n\n}\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (Picker);\n\n//# sourceURL=webpack://Quill/./ui/picker.js?");

/***/ }),

/***/ "./ui/tooltip.js":
/*!***********************!*\
  !*** ./ui/tooltip.js ***!
  \***********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\nclass Tooltip {\n  constructor(quill, boundsContainer) {\n    this.quill = quill;\n    this.boundsContainer = boundsContainer || document.body;\n    this.root = quill.addContainer('ql-tooltip');\n    this.root.innerHTML = this.constructor.TEMPLATE;\n\n    if (this.quill.root === this.quill.scrollingContainer) {\n      this.quill.root.addEventListener('scroll', () => {\n        this.root.style.marginTop = \"\".concat(-1 * this.quill.root.scrollTop, \"px\");\n      });\n    }\n\n    this.hide();\n  }\n\n  hide() {\n    this.root.classList.add('ql-hidden');\n  }\n\n  position(reference) {\n    const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2; // root.scrollTop should be 0 if scrollContainer !== root\n\n    const top = reference.bottom + this.quill.root.scrollTop;\n    this.root.style.left = \"\".concat(left, \"px\");\n    this.root.style.top = \"\".concat(top, \"px\");\n    this.root.classList.remove('ql-flip');\n    const containerBounds = this.boundsContainer.getBoundingClientRect();\n    const rootBounds = this.root.getBoundingClientRect();\n    let shift = 0;\n\n    if (rootBounds.right > containerBounds.right) {\n      shift = containerBounds.right - rootBounds.right;\n      this.root.style.left = \"\".concat(left + shift, \"px\");\n    }\n\n    if (rootBounds.left < containerBounds.left) {\n      shift = containerBounds.left - rootBounds.left;\n      this.root.style.left = \"\".concat(left + shift, \"px\");\n    }\n\n    if (rootBounds.bottom > containerBounds.bottom) {\n      const height = rootBounds.bottom - rootBounds.top;\n      const verticalShift = reference.bottom - reference.top + height;\n      this.root.style.top = \"\".concat(top - verticalShift, \"px\");\n      this.root.classList.add('ql-flip');\n    }\n\n    return shift;\n  }\n\n  show() {\n    this.root.classList.remove('ql-editing');\n    this.root.classList.remove('ql-hidden');\n  }\n\n}\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (Tooltip);\n\n//# sourceURL=webpack://Quill/./ui/tooltip.js?");

/***/ }),

/***/ 0:
/*!************************!*\
  !*** multi ./quill.js ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

eval("module.exports = __webpack_require__(/*! ./quill.js */\"./quill.js\");\n\n\n//# sourceURL=webpack://Quill/multi_./quill.js?");

/***/ })

/******/ })["default"];
});

/***/ }),

/***/ "../../node_modules/@agentx/quill/dist/quill.snow.css":
/*!************************************************************!*\
  !*** ../../node_modules/@agentx/quill/dist/quill.snow.css ***!
  \************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../css-loader/dist/cjs.js!./quill.snow.css */ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/@agentx/quill/dist/quill.snow.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!******************************************************************************!*\
  !*** ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \******************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _assertThisInitialized)
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ "../../node_modules/@babel/runtime/helpers/esm/extends.js":
/*!****************************************************************!*\
  !*** ../../node_modules/@babel/runtime/helpers/esm/extends.js ***!
  \****************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _extends)
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ "../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js":
/*!**********************************************************************!*\
  !*** ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _inheritsLoose)
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(t, o);
}


/***/ }),

/***/ "../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js":
/*!*************************************************************************************!*\
  !*** ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js ***!
  \*************************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _objectWithoutPropertiesLoose)
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ "../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***********************************************************************!*\
  !*** ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _setPrototypeOf)
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/DOMRectReadOnly.js":
/*!*************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/DOMRectReadOnly.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DOMRectReadOnly: () => (/* binding */ DOMRectReadOnly)
/* harmony export */ });
/* harmony import */ var _utils_freeze__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils/freeze */ "../../node_modules/@juggle/resize-observer/lib/utils/freeze.js");

var DOMRectReadOnly = (function () {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0,_utils_freeze__WEBPACK_IMPORTED_MODULE_0__.freeze)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function () {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return { x: x, y: y, top: top, right: right, bottom: bottom, left: left, width: width, height: height };
    };
    DOMRectReadOnly.fromRect = function (rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}());



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/ResizeObservation.js":
/*!***************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/ResizeObservation.js ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ResizeObservation: () => (/* binding */ ResizeObservation)
/* harmony export */ });
/* harmony import */ var _ResizeObserverBoxOptions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ResizeObserverBoxOptions */ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverBoxOptions.js");
/* harmony import */ var _algorithms_calculateBoxSize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./algorithms/calculateBoxSize */ "../../node_modules/@juggle/resize-observer/lib/algorithms/calculateBoxSize.js");
/* harmony import */ var _utils_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils/element */ "../../node_modules/@juggle/resize-observer/lib/utils/element.js");



var skipNotifyOnElement = function (target) {
    return !(0,_utils_element__WEBPACK_IMPORTED_MODULE_2__.isSVG)(target)
        && !(0,_utils_element__WEBPACK_IMPORTED_MODULE_2__.isReplacedElement)(target)
        && getComputedStyle(target).display === 'inline';
};
var ResizeObservation = (function () {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || _ResizeObserverBoxOptions__WEBPACK_IMPORTED_MODULE_0__.ResizeObserverBoxOptions.CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function () {
        var size = (0,_algorithms_calculateBoxSize__WEBPACK_IMPORTED_MODULE_1__.calculateBoxSize)(this.target, this.observedBox, true);
        if (skipNotifyOnElement(this.target)) {
            this.lastReportedSize = size;
        }
        if (this.lastReportedSize.inlineSize !== size.inlineSize
            || this.lastReportedSize.blockSize !== size.blockSize) {
            return true;
        }
        return false;
    };
    return ResizeObservation;
}());



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/ResizeObserver.js":
/*!************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/ResizeObserver.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ResizeObserver: () => (/* binding */ ResizeObserver)
/* harmony export */ });
/* harmony import */ var _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ResizeObserverController */ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverController.js");
/* harmony import */ var _utils_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils/element */ "../../node_modules/@juggle/resize-observer/lib/utils/element.js");


var ResizeObserver = (function () {
    function ResizeObserver(callback) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (typeof callback !== 'function') {
            throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        }
        _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__.ResizeObserverController.connect(this, callback);
    }
    ResizeObserver.prototype.observe = function (target, options) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (!(0,_utils_element__WEBPACK_IMPORTED_MODULE_1__.isElement)(target)) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__.ResizeObserverController.observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function (target) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (!(0,_utils_element__WEBPACK_IMPORTED_MODULE_1__.isElement)(target)) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__.ResizeObserverController.unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function () {
        _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__.ResizeObserverController.disconnect(this);
    };
    ResizeObserver.toString = function () {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}());



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverBoxOptions.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/ResizeObserverBoxOptions.js ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ResizeObserverBoxOptions: () => (/* binding */ ResizeObserverBoxOptions)
/* harmony export */ });
var ResizeObserverBoxOptions;
(function (ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverController.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/ResizeObserverController.js ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ResizeObserverController: () => (/* binding */ ResizeObserverController)
/* harmony export */ });
/* harmony import */ var _utils_scheduler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils/scheduler */ "../../node_modules/@juggle/resize-observer/lib/utils/scheduler.js");
/* harmony import */ var _ResizeObservation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ResizeObservation */ "../../node_modules/@juggle/resize-observer/lib/ResizeObservation.js");
/* harmony import */ var _ResizeObserverDetail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ResizeObserverDetail */ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverDetail.js");
/* harmony import */ var _utils_resizeObservers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/resizeObservers */ "../../node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js");




var observerMap = new WeakMap();
var getObservationIndex = function (observationTargets, target) {
    for (var i = 0; i < observationTargets.length; i += 1) {
        if (observationTargets[i].target === target) {
            return i;
        }
    }
    return -1;
};
var ResizeObserverController = (function () {
    function ResizeObserverController() {
    }
    ResizeObserverController.connect = function (resizeObserver, callback) {
        var detail = new _ResizeObserverDetail__WEBPACK_IMPORTED_MODULE_2__.ResizeObserverDetail(resizeObserver, callback);
        observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function (resizeObserver, target, options) {
        var detail = observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if (getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && _utils_resizeObservers__WEBPACK_IMPORTED_MODULE_3__.resizeObservers.push(detail);
            detail.observationTargets.push(new _ResizeObservation__WEBPACK_IMPORTED_MODULE_1__.ResizeObservation(target, options && options.box));
            (0,_utils_scheduler__WEBPACK_IMPORTED_MODULE_0__.updateCount)(1);
            _utils_scheduler__WEBPACK_IMPORTED_MODULE_0__.scheduler.schedule();
        }
    };
    ResizeObserverController.unobserve = function (resizeObserver, target) {
        var detail = observerMap.get(resizeObserver);
        var index = getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && _utils_resizeObservers__WEBPACK_IMPORTED_MODULE_3__.resizeObservers.splice(_utils_resizeObservers__WEBPACK_IMPORTED_MODULE_3__.resizeObservers.indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0,_utils_scheduler__WEBPACK_IMPORTED_MODULE_0__.updateCount)(-1);
        }
    };
    ResizeObserverController.disconnect = function (resizeObserver) {
        var _this = this;
        var detail = observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function (ot) { return _this.unobserve(resizeObserver, ot.target); });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}());



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverDetail.js":
/*!******************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/ResizeObserverDetail.js ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ResizeObserverDetail: () => (/* binding */ ResizeObserverDetail)
/* harmony export */ });
var ResizeObserverDetail = (function () {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}());



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverEntry.js":
/*!*****************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/ResizeObserverEntry.js ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ResizeObserverEntry: () => (/* binding */ ResizeObserverEntry)
/* harmony export */ });
/* harmony import */ var _algorithms_calculateBoxSize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./algorithms/calculateBoxSize */ "../../node_modules/@juggle/resize-observer/lib/algorithms/calculateBoxSize.js");
/* harmony import */ var _utils_freeze__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils/freeze */ "../../node_modules/@juggle/resize-observer/lib/utils/freeze.js");


var ResizeObserverEntry = (function () {
    function ResizeObserverEntry(target) {
        var boxes = (0,_algorithms_calculateBoxSize__WEBPACK_IMPORTED_MODULE_0__.calculateBoxSizes)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0,_utils_freeze__WEBPACK_IMPORTED_MODULE_1__.freeze)([boxes.borderBoxSize]);
        this.contentBoxSize = (0,_utils_freeze__WEBPACK_IMPORTED_MODULE_1__.freeze)([boxes.contentBoxSize]);
        this.devicePixelContentBoxSize = (0,_utils_freeze__WEBPACK_IMPORTED_MODULE_1__.freeze)([boxes.devicePixelContentBoxSize]);
    }
    return ResizeObserverEntry;
}());



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverSize.js":
/*!****************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/ResizeObserverSize.js ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ResizeObserverSize: () => (/* binding */ ResizeObserverSize)
/* harmony export */ });
/* harmony import */ var _utils_freeze__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils/freeze */ "../../node_modules/@juggle/resize-observer/lib/utils/freeze.js");

var ResizeObserverSize = (function () {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0,_utils_freeze__WEBPACK_IMPORTED_MODULE_0__.freeze)(this);
    }
    return ResizeObserverSize;
}());



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/algorithms/broadcastActiveObservations.js":
/*!************************************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/algorithms/broadcastActiveObservations.js ***!
  \************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   broadcastActiveObservations: () => (/* binding */ broadcastActiveObservations)
/* harmony export */ });
/* harmony import */ var _utils_resizeObservers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/resizeObservers */ "../../node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js");
/* harmony import */ var _ResizeObserverEntry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ResizeObserverEntry */ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverEntry.js");
/* harmony import */ var _calculateDepthForNode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./calculateDepthForNode */ "../../node_modules/@juggle/resize-observer/lib/algorithms/calculateDepthForNode.js");
/* harmony import */ var _calculateBoxSize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./calculateBoxSize */ "../../node_modules/@juggle/resize-observer/lib/algorithms/calculateBoxSize.js");




var broadcastActiveObservations = function () {
    var shallowestDepth = Infinity;
    var callbacks = [];
    _utils_resizeObservers__WEBPACK_IMPORTED_MODULE_0__.resizeObservers.forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) {
            return;
        }
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new _ResizeObserverEntry__WEBPACK_IMPORTED_MODULE_1__.ResizeObserverEntry(ot.target);
            var targetDepth = (0,_calculateDepthForNode__WEBPACK_IMPORTED_MODULE_2__.calculateDepthForNode)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0,_calculateBoxSize__WEBPACK_IMPORTED_MODULE_3__.calculateBoxSize)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) {
                shallowestDepth = targetDepth;
            }
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/algorithms/calculateBoxSize.js":
/*!*************************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/algorithms/calculateBoxSize.js ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   calculateBoxSize: () => (/* binding */ calculateBoxSize),
/* harmony export */   calculateBoxSizes: () => (/* binding */ calculateBoxSizes)
/* harmony export */ });
/* harmony import */ var _ResizeObserverBoxOptions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ResizeObserverBoxOptions */ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverBoxOptions.js");
/* harmony import */ var _ResizeObserverSize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ResizeObserverSize */ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverSize.js");
/* harmony import */ var _DOMRectReadOnly__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../DOMRectReadOnly */ "../../node_modules/@juggle/resize-observer/lib/DOMRectReadOnly.js");
/* harmony import */ var _utils_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/element */ "../../node_modules/@juggle/resize-observer/lib/utils/element.js");
/* harmony import */ var _utils_freeze__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/freeze */ "../../node_modules/@juggle/resize-observer/lib/utils/freeze.js");
/* harmony import */ var _utils_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/global */ "../../node_modules/@juggle/resize-observer/lib/utils/global.js");






var cache = new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = (/msie|trident/i).test(_utils_global__WEBPACK_IMPORTED_MODULE_5__.global.navigator && _utils_global__WEBPACK_IMPORTED_MODULE_5__.global.navigator.userAgent);
var parseDimension = function (pixel) { return parseFloat(pixel || '0'); };
var size = function (inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) { inlineSize = 0; }
    if (blockSize === void 0) { blockSize = 0; }
    if (switchSizes === void 0) { switchSizes = false; }
    return new _ResizeObserverSize__WEBPACK_IMPORTED_MODULE_1__.ResizeObserverSize((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var zeroBoxes = (0,_utils_freeze__WEBPACK_IMPORTED_MODULE_4__.freeze)({
    devicePixelContentBoxSize: size(),
    borderBoxSize: size(),
    contentBoxSize: size(),
    contentRect: new _DOMRectReadOnly__WEBPACK_IMPORTED_MODULE_2__.DOMRectReadOnly(0, 0, 0, 0)
});
var calculateBoxSizes = function (target, forceRecalculation) {
    if (forceRecalculation === void 0) { forceRecalculation = false; }
    if (cache.has(target) && !forceRecalculation) {
        return cache.get(target);
    }
    if ((0,_utils_element__WEBPACK_IMPORTED_MODULE_3__.isHidden)(target)) {
        cache.set(target, zeroBoxes);
        return zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0,_utils_element__WEBPACK_IMPORTED_MODULE_3__.isSVG)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !IE && cs.boxSizing === 'border-box';
    var switchSizes = verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0,_utils_freeze__WEBPACK_IMPORTED_MODULE_4__.freeze)({
        devicePixelContentBoxSize: size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: size(contentWidth, contentHeight, switchSizes),
        contentRect: new _DOMRectReadOnly__WEBPACK_IMPORTED_MODULE_2__.DOMRectReadOnly(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    cache.set(target, boxes);
    return boxes;
};
var calculateBoxSize = function (target, observedBox, forceRecalculation) {
    var _a = calculateBoxSizes(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch (observedBox) {
        case _ResizeObserverBoxOptions__WEBPACK_IMPORTED_MODULE_0__.ResizeObserverBoxOptions.DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case _ResizeObserverBoxOptions__WEBPACK_IMPORTED_MODULE_0__.ResizeObserverBoxOptions.BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/algorithms/calculateDepthForNode.js":
/*!******************************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/algorithms/calculateDepthForNode.js ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   calculateDepthForNode: () => (/* binding */ calculateDepthForNode)
/* harmony export */ });
/* harmony import */ var _utils_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/element */ "../../node_modules/@juggle/resize-observer/lib/utils/element.js");

var calculateDepthForNode = function (node) {
    if ((0,_utils_element__WEBPACK_IMPORTED_MODULE_0__.isHidden)(node)) {
        return Infinity;
    }
    var depth = 0;
    var parent = node.parentNode;
    while (parent) {
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/algorithms/deliverResizeLoopError.js":
/*!*******************************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/algorithms/deliverResizeLoopError.js ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   deliverResizeLoopError: () => (/* binding */ deliverResizeLoopError)
/* harmony export */ });
var msg = 'ResizeObserver loop completed with undelivered notifications.';
var deliverResizeLoopError = function () {
    var event;
    if (typeof ErrorEvent === 'function') {
        event = new ErrorEvent('error', {
            message: msg
        });
    }
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = msg;
    }
    window.dispatchEvent(event);
};



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/algorithms/gatherActiveObservationsAtDepth.js":
/*!****************************************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/algorithms/gatherActiveObservationsAtDepth.js ***!
  \****************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   gatherActiveObservationsAtDepth: () => (/* binding */ gatherActiveObservationsAtDepth)
/* harmony export */ });
/* harmony import */ var _utils_resizeObservers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/resizeObservers */ "../../node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js");
/* harmony import */ var _calculateDepthForNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./calculateDepthForNode */ "../../node_modules/@juggle/resize-observer/lib/algorithms/calculateDepthForNode.js");


var gatherActiveObservationsAtDepth = function (depth) {
    _utils_resizeObservers__WEBPACK_IMPORTED_MODULE_0__.resizeObservers.forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0,_calculateDepthForNode__WEBPACK_IMPORTED_MODULE_1__.calculateDepthForNode)(ot.target) > depth) {
                    ro.activeTargets.push(ot);
                }
                else {
                    ro.skippedTargets.push(ot);
                }
            }
        });
    });
};



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/algorithms/hasActiveObservations.js":
/*!******************************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/algorithms/hasActiveObservations.js ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   hasActiveObservations: () => (/* binding */ hasActiveObservations)
/* harmony export */ });
/* harmony import */ var _utils_resizeObservers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/resizeObservers */ "../../node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js");

var hasActiveObservations = function () {
    return _utils_resizeObservers__WEBPACK_IMPORTED_MODULE_0__.resizeObservers.some(function (ro) { return ro.activeTargets.length > 0; });
};



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/algorithms/hasSkippedObservations.js":
/*!*******************************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/algorithms/hasSkippedObservations.js ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   hasSkippedObservations: () => (/* binding */ hasSkippedObservations)
/* harmony export */ });
/* harmony import */ var _utils_resizeObservers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/resizeObservers */ "../../node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js");

var hasSkippedObservations = function () {
    return _utils_resizeObservers__WEBPACK_IMPORTED_MODULE_0__.resizeObservers.some(function (ro) { return ro.skippedTargets.length > 0; });
};



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/exports/resize-observer.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/exports/resize-observer.js ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ResizeObserver: () => (/* reexport safe */ _ResizeObserver__WEBPACK_IMPORTED_MODULE_0__.ResizeObserver),
/* harmony export */   ResizeObserverEntry: () => (/* reexport safe */ _ResizeObserverEntry__WEBPACK_IMPORTED_MODULE_1__.ResizeObserverEntry),
/* harmony export */   ResizeObserverSize: () => (/* reexport safe */ _ResizeObserverSize__WEBPACK_IMPORTED_MODULE_2__.ResizeObserverSize)
/* harmony export */ });
/* harmony import */ var _ResizeObserver__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ResizeObserver */ "../../node_modules/@juggle/resize-observer/lib/ResizeObserver.js");
/* harmony import */ var _ResizeObserverEntry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ResizeObserverEntry */ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverEntry.js");
/* harmony import */ var _ResizeObserverSize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ResizeObserverSize */ "../../node_modules/@juggle/resize-observer/lib/ResizeObserverSize.js");





/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/utils/element.js":
/*!***********************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/utils/element.js ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   isElement: () => (/* binding */ isElement),
/* harmony export */   isHidden: () => (/* binding */ isHidden),
/* harmony export */   isReplacedElement: () => (/* binding */ isReplacedElement),
/* harmony export */   isSVG: () => (/* binding */ isSVG)
/* harmony export */ });
var isSVG = function (target) { return target instanceof SVGElement && 'getBBox' in target; };
var isHidden = function (target) {
    if (isSVG(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isElement = function (obj) {
    var _a;
    if (obj instanceof Element) {
        return true;
    }
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var isReplacedElement = function (target) {
    switch (target.tagName) {
        case 'INPUT':
            if (target.type !== 'image') {
                break;
            }
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/utils/freeze.js":
/*!**********************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/utils/freeze.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   freeze: () => (/* binding */ freeze)
/* harmony export */ });
var freeze = function (obj) { return Object.freeze(obj); };


/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/utils/global.js":
/*!**********************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/utils/global.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   global: () => (/* binding */ global)
/* harmony export */ });
var global = typeof window !== 'undefined' ? window : {};


/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/utils/process.js":
/*!***********************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/utils/process.js ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   process: () => (/* binding */ process)
/* harmony export */ });
/* harmony import */ var _algorithms_hasActiveObservations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../algorithms/hasActiveObservations */ "../../node_modules/@juggle/resize-observer/lib/algorithms/hasActiveObservations.js");
/* harmony import */ var _algorithms_hasSkippedObservations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../algorithms/hasSkippedObservations */ "../../node_modules/@juggle/resize-observer/lib/algorithms/hasSkippedObservations.js");
/* harmony import */ var _algorithms_deliverResizeLoopError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../algorithms/deliverResizeLoopError */ "../../node_modules/@juggle/resize-observer/lib/algorithms/deliverResizeLoopError.js");
/* harmony import */ var _algorithms_broadcastActiveObservations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../algorithms/broadcastActiveObservations */ "../../node_modules/@juggle/resize-observer/lib/algorithms/broadcastActiveObservations.js");
/* harmony import */ var _algorithms_gatherActiveObservationsAtDepth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../algorithms/gatherActiveObservationsAtDepth */ "../../node_modules/@juggle/resize-observer/lib/algorithms/gatherActiveObservationsAtDepth.js");





var process = function () {
    var depth = 0;
    (0,_algorithms_gatherActiveObservationsAtDepth__WEBPACK_IMPORTED_MODULE_4__.gatherActiveObservationsAtDepth)(depth);
    while ((0,_algorithms_hasActiveObservations__WEBPACK_IMPORTED_MODULE_0__.hasActiveObservations)()) {
        depth = (0,_algorithms_broadcastActiveObservations__WEBPACK_IMPORTED_MODULE_3__.broadcastActiveObservations)();
        (0,_algorithms_gatherActiveObservationsAtDepth__WEBPACK_IMPORTED_MODULE_4__.gatherActiveObservationsAtDepth)(depth);
    }
    if ((0,_algorithms_hasSkippedObservations__WEBPACK_IMPORTED_MODULE_1__.hasSkippedObservations)()) {
        (0,_algorithms_deliverResizeLoopError__WEBPACK_IMPORTED_MODULE_2__.deliverResizeLoopError)();
    }
    return depth > 0;
};



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/utils/queueMicroTask.js":
/*!******************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/utils/queueMicroTask.js ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   queueMicroTask: () => (/* binding */ queueMicroTask)
/* harmony export */ });
var trigger;
var callbacks = [];
var notify = function () { return callbacks.splice(0).forEach(function (cb) { return cb(); }); };
var queueMicroTask = function (callback) {
    if (!trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = { characterData: true };
        new MutationObserver(function () { return notify(); }).observe(el_1, config);
        trigger = function () { el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++); };
    }
    callbacks.push(callback);
    trigger();
};



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/utils/queueResizeObserver.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/utils/queueResizeObserver.js ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   queueResizeObserver: () => (/* binding */ queueResizeObserver)
/* harmony export */ });
/* harmony import */ var _queueMicroTask__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./queueMicroTask */ "../../node_modules/@juggle/resize-observer/lib/utils/queueMicroTask.js");

var queueResizeObserver = function (cb) {
    (0,_queueMicroTask__WEBPACK_IMPORTED_MODULE_0__.queueMicroTask)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   resizeObservers: () => (/* binding */ resizeObservers)
/* harmony export */ });
var resizeObservers = [];



/***/ }),

/***/ "../../node_modules/@juggle/resize-observer/lib/utils/scheduler.js":
/*!*************************************************************************!*\
  !*** ../../node_modules/@juggle/resize-observer/lib/utils/scheduler.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   scheduler: () => (/* binding */ scheduler),
/* harmony export */   updateCount: () => (/* binding */ updateCount)
/* harmony export */ });
/* harmony import */ var _process__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./process */ "../../node_modules/@juggle/resize-observer/lib/utils/process.js");
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./global */ "../../node_modules/@juggle/resize-observer/lib/utils/global.js");
/* harmony import */ var _queueResizeObserver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./queueResizeObserver */ "../../node_modules/@juggle/resize-observer/lib/utils/queueResizeObserver.js");



var watching = 0;
var isWatching = function () { return !!watching; };
var CATCH_PERIOD = 250;
var observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
var events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var time = function (timeout) {
    if (timeout === void 0) { timeout = 0; }
    return Date.now() + timeout;
};
var scheduled = false;
var Scheduler = (function () {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function () { return _this.schedule(); };
    }
    Scheduler.prototype.run = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = CATCH_PERIOD; }
        if (scheduled) {
            return;
        }
        scheduled = true;
        var until = time(timeout);
        (0,_queueResizeObserver__WEBPACK_IMPORTED_MODULE_2__.queueResizeObserver)(function () {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0,_process__WEBPACK_IMPORTED_MODULE_0__.process)();
            }
            finally {
                scheduled = false;
                timeout = until - time();
                if (!isWatching()) {
                    return;
                }
                if (elementsHaveResized) {
                    _this.run(1000);
                }
                else if (timeout > 0) {
                    _this.run(timeout);
                }
                else {
                    _this.start();
                }
            }
        });
    };
    Scheduler.prototype.schedule = function () {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function () {
        var _this = this;
        var cb = function () { return _this.observer && _this.observer.observe(document.body, observerConfig); };
        document.body ? cb() : _global__WEBPACK_IMPORTED_MODULE_1__.global.addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function () {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            events.forEach(function (name) { return _global__WEBPACK_IMPORTED_MODULE_1__.global.addEventListener(name, _this.listener, true); });
        }
    };
    Scheduler.prototype.stop = function () {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(function (name) { return _global__WEBPACK_IMPORTED_MODULE_1__.global.removeEventListener(name, _this.listener, true); });
            this.stopped = true;
        }
    };
    return Scheduler;
}());
var scheduler = new Scheduler();
var updateCount = function (n) {
    !watching && n > 0 && scheduler.start();
    watching += n;
    !watching && scheduler.stop();
};



/***/ }),

/***/ "../../node_modules/classnames/index.js":
/*!**********************************************!*\
  !*** ../../node_modules/classnames/index.js ***!
  \**********************************************/
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/@agentx/quill/dist/quill.snow.css":
/*!******************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../../node_modules/@agentx/quill/dist/quill.snow.css ***!
  \******************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Quill Editor v2.0.0-dev.5
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
.ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
}
.ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}
.ql-container:not(.ql-disabled) li[data-list=checked] > .ql-ui,
.ql-container:not(.ql-disabled) li[data-list=unchecked] > .ql-ui {
  cursor: pointer;
}
.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
.ql-clipboard p {
  margin: 0;
  padding: 0;
}
.ql-editor {
  box-sizing: border-box;
  counter-reset: list-0;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.ql-editor > * {
  cursor: text;
}
.ql-editor p,
.ql-editor ol,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0;
  padding: 0;
}
.ql-editor p,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor table {
  border-collapse: collapse;
}
.ql-editor td {
  border: 1px solid #000;
  padding: 2px 5px;
}
.ql-editor ol {
  padding-left: 1.5em;
}
.ql-editor li {
  list-style-type: none;
  padding-left: 1.5em;
  position: relative;
}
.ql-editor li > .ql-ui:before {
  display: inline-block;
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
  white-space: nowrap;
  width: 1.2em;
}
.ql-editor li[data-list=checked] > .ql-ui,
.ql-editor li[data-list=unchecked] > .ql-ui {
  color: #777;
}
.ql-editor li[data-list=bullet] > .ql-ui:before {
  content: '\\2022';
}
.ql-editor li[data-list=checked] > .ql-ui:before {
  content: '\\2611';
}
.ql-editor li[data-list=unchecked] > .ql-ui:before {
  content: '\\2610';
}
.ql-editor li[data-list=ordered] {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
.ql-editor li[data-list=ordered] > .ql-ui:before {
  content: counter(list-0, decimal) '. ';
}
.ql-editor li[data-list=ordered].ql-indent-1 {
  counter-increment: list-1;
}
.ql-editor li[data-list=ordered].ql-indent-1 > .ql-ui:before {
  content: counter(list-1, lower-alpha) '. ';
}
.ql-editor li[data-list=ordered].ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor li[data-list=ordered].ql-indent-2 {
  counter-increment: list-2;
}
.ql-editor li[data-list=ordered].ql-indent-2 > .ql-ui:before {
  content: counter(list-2, lower-roman) '. ';
}
.ql-editor li[data-list=ordered].ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor li[data-list=ordered].ql-indent-3 {
  counter-increment: list-3;
}
.ql-editor li[data-list=ordered].ql-indent-3 > .ql-ui:before {
  content: counter(list-3, decimal) '. ';
}
.ql-editor li[data-list=ordered].ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor li[data-list=ordered].ql-indent-4 {
  counter-increment: list-4;
}
.ql-editor li[data-list=ordered].ql-indent-4 > .ql-ui:before {
  content: counter(list-4, lower-alpha) '. ';
}
.ql-editor li[data-list=ordered].ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
.ql-editor li[data-list=ordered].ql-indent-5 {
  counter-increment: list-5;
}
.ql-editor li[data-list=ordered].ql-indent-5 > .ql-ui:before {
  content: counter(list-5, lower-roman) '. ';
}
.ql-editor li[data-list=ordered].ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
.ql-editor li[data-list=ordered].ql-indent-6 {
  counter-increment: list-6;
}
.ql-editor li[data-list=ordered].ql-indent-6 > .ql-ui:before {
  content: counter(list-6, decimal) '. ';
}
.ql-editor li[data-list=ordered].ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
.ql-editor li[data-list=ordered].ql-indent-7 {
  counter-increment: list-7;
}
.ql-editor li[data-list=ordered].ql-indent-7 > .ql-ui:before {
  content: counter(list-7, lower-alpha) '. ';
}
.ql-editor li[data-list=ordered].ql-indent-7 {
  counter-reset: list-8 list-9;
}
.ql-editor li[data-list=ordered].ql-indent-8 {
  counter-increment: list-8;
}
.ql-editor li[data-list=ordered].ql-indent-8 > .ql-ui:before {
  content: counter(list-8, lower-roman) '. ';
}
.ql-editor li[data-list=ordered].ql-indent-8 {
  counter-reset: list-9;
}
.ql-editor li[data-list=ordered].ql-indent-9 {
  counter-increment: list-9;
}
.ql-editor li[data-list=ordered].ql-indent-9 > .ql-ui:before {
  content: counter(list-9, decimal) '. ';
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
.ql-editor li.ql-direction-rtl {
  padding-right: 1.5em;
}
.ql-editor li.ql-direction-rtl > .ql-ui:before {
  margin-left: 0.3em;
  margin-right: -1.5em;
  text-align: left;
}
.ql-editor table {
  table-layout: fixed;
  width: 100%;
}
.ql-editor table td {
  outline: none;
}
.ql-editor .ql-code-block-container {
  font-family: monospace;
}
.ql-editor .ql-video {
  display: block;
  max-width: 100%;
}
.ql-editor .ql-video.ql-align-center {
  margin: 0 auto;
}
.ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
.ql-editor .ql-bg-black {
  background-color: #000;
}
.ql-editor .ql-bg-red {
  background-color: #e60000;
}
.ql-editor .ql-bg-orange {
  background-color: #f90;
}
.ql-editor .ql-bg-yellow {
  background-color: #ff0;
}
.ql-editor .ql-bg-green {
  background-color: #008a00;
}
.ql-editor .ql-bg-blue {
  background-color: #06c;
}
.ql-editor .ql-bg-purple {
  background-color: #93f;
}
.ql-editor .ql-color-white {
  color: #fff;
}
.ql-editor .ql-color-red {
  color: #e60000;
}
.ql-editor .ql-color-orange {
  color: #f90;
}
.ql-editor .ql-color-yellow {
  color: #ff0;
}
.ql-editor .ql-color-green {
  color: #008a00;
}
.ql-editor .ql-color-blue {
  color: #06c;
}
.ql-editor .ql-color-purple {
  color: #93f;
}
.ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
.ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
.ql-editor .ql-size-small {
  font-size: 0.75em;
}
.ql-editor .ql-size-large {
  font-size: 1.5em;
}
.ql-editor .ql-size-huge {
  font-size: 2.5em;
}
.ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.ql-editor .ql-align-center {
  text-align: center;
}
.ql-editor .ql-align-justify {
  text-align: justify;
}
.ql-editor .ql-align-right {
  text-align: right;
}
.ql-editor .ql-ui {
  position: absolute;
}
.ql-editor.ql-blank::before {
  color: rgba(0,0,0,0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}
.ql-snow.ql-toolbar:after,
.ql-snow .ql-toolbar:after {
  clear: both;
  content: '';
  display: table;
}
.ql-snow.ql-toolbar button,
.ql-snow .ql-toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  float: left;
  height: 24px;
  padding: 3px 5px;
  width: 28px;
}
.ql-snow.ql-toolbar button svg,
.ql-snow .ql-toolbar button svg {
  float: left;
  height: 100%;
}
.ql-snow.ql-toolbar button:active:hover,
.ql-snow .ql-toolbar button:active:hover {
  outline: none;
}
.ql-snow.ql-toolbar input.ql-image[type=file],
.ql-snow .ql-toolbar input.ql-image[type=file] {
  display: none;
}
.ql-snow.ql-toolbar button:hover,
.ql-snow .ql-toolbar button:hover,
.ql-snow.ql-toolbar button:focus,
.ql-snow .ql-toolbar button:focus,
.ql-snow.ql-toolbar button.ql-active,
.ql-snow .ql-toolbar button.ql-active,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow .ql-toolbar .ql-picker-label:hover,
.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow .ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-item:hover,
.ql-snow .ql-toolbar .ql-picker-item:hover,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected {
  color: #06c;
}
.ql-snow.ql-toolbar button:hover .ql-fill,
.ql-snow .ql-toolbar button:hover .ql-fill,
.ql-snow.ql-toolbar button:focus .ql-fill,
.ql-snow .ql-toolbar button:focus .ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
  fill: #06c;
}
.ql-snow.ql-toolbar button:hover .ql-stroke,
.ql-snow .ql-toolbar button:hover .ql-stroke,
.ql-snow.ql-toolbar button:focus .ql-stroke,
.ql-snow .ql-toolbar button:focus .ql-stroke,
.ql-snow.ql-toolbar button.ql-active .ql-stroke,
.ql-snow .ql-toolbar button.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow.ql-toolbar button:hover .ql-stroke-miter,
.ql-snow .ql-toolbar button:hover .ql-stroke-miter,
.ql-snow.ql-toolbar button:focus .ql-stroke-miter,
.ql-snow .ql-toolbar button:focus .ql-stroke-miter,
.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
  stroke: #06c;
}
@media (pointer: coarse) {
  .ql-snow.ql-toolbar button:hover:not(.ql-active),
  .ql-snow .ql-toolbar button:hover:not(.ql-active) {
    color: #444;
  }
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
    fill: #444;
  }
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
    stroke: #444;
  }
}
.ql-snow {
  box-sizing: border-box;
}
.ql-snow * {
  box-sizing: border-box;
}
.ql-snow .ql-hidden {
  display: none;
}
.ql-snow .ql-out-bottom,
.ql-snow .ql-out-top {
  visibility: hidden;
}
.ql-snow .ql-tooltip {
  position: absolute;
  transform: translateY(10px);
}
.ql-snow .ql-tooltip a {
  cursor: pointer;
  text-decoration: none;
}
.ql-snow .ql-tooltip.ql-flip {
  transform: translateY(-10px);
}
.ql-snow .ql-formats {
  display: inline-block;
  vertical-align: middle;
}
.ql-snow .ql-formats:after {
  clear: both;
  content: '';
  display: table;
}
.ql-snow .ql-stroke {
  fill: none;
  stroke: #444;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}
.ql-snow .ql-stroke-miter {
  fill: none;
  stroke: #444;
  stroke-miterlimit: 10;
  stroke-width: 2;
}
.ql-snow .ql-fill,
.ql-snow .ql-stroke.ql-fill {
  fill: #444;
}
.ql-snow .ql-empty {
  fill: none;
}
.ql-snow .ql-even {
  fill-rule: evenodd;
}
.ql-snow .ql-thin,
.ql-snow .ql-stroke.ql-thin {
  stroke-width: 1;
}
.ql-snow .ql-transparent {
  opacity: 0.4;
}
.ql-snow .ql-direction svg:last-child {
  display: none;
}
.ql-snow .ql-direction.ql-active svg:last-child {
  display: inline;
}
.ql-snow .ql-direction.ql-active svg:first-child {
  display: none;
}
.ql-snow .ql-editor h1 {
  font-size: 2em;
}
.ql-snow .ql-editor h2 {
  font-size: 1.5em;
}
.ql-snow .ql-editor h3 {
  font-size: 1.17em;
}
.ql-snow .ql-editor h4 {
  font-size: 1em;
}
.ql-snow .ql-editor h5 {
  font-size: 0.83em;
}
.ql-snow .ql-editor h6 {
  font-size: 0.67em;
}
.ql-snow .ql-editor a {
  text-decoration: underline;
}
.ql-snow .ql-editor blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px;
}
.ql-snow .ql-editor code,
.ql-snow .ql-editor .ql-code-block-container {
  background-color: #f0f0f0;
  border-radius: 3px;
}
.ql-snow .ql-editor .ql-code-block-container {
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 5px 10px;
}
.ql-snow .ql-editor code {
  font-size: 85%;
  padding: 2px 4px;
}
.ql-snow .ql-editor .ql-code-block-container {
  background-color: #23241f;
  color: #f8f8f2;
  overflow: visible;
}
.ql-snow .ql-editor img {
  max-width: 100%;
}
.ql-snow .ql-picker {
  color: #444;
  display: inline-block;
  float: left;
  font-size: 14px;
  font-weight: 500;
  height: 24px;
  position: relative;
  vertical-align: middle;
}
.ql-snow .ql-picker-label {
  cursor: pointer;
  display: inline-block;
  height: 100%;
  padding-left: 8px;
  padding-right: 2px;
  position: relative;
  width: 100%;
}
.ql-snow .ql-picker-label::before {
  display: inline-block;
  line-height: 22px;
}
.ql-snow .ql-picker-options {
  background-color: #fff;
  display: none;
  min-width: 100%;
  padding: 4px 8px;
  position: absolute;
  white-space: nowrap;
}
.ql-snow .ql-picker-options .ql-picker-item {
  cursor: pointer;
  display: block;
  padding-bottom: 5px;
  padding-top: 5px;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: #ccc;
  z-index: 2;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
  fill: #ccc;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
  stroke: #ccc;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  display: block;
  margin-top: -1px;
  top: 100%;
  z-index: 1;
}
.ql-snow .ql-color-picker,
.ql-snow .ql-icon-picker {
  width: 28px;
}
.ql-snow .ql-color-picker .ql-picker-label,
.ql-snow .ql-icon-picker .ql-picker-label {
  padding: 2px 4px;
}
.ql-snow .ql-color-picker .ql-picker-label svg,
.ql-snow .ql-icon-picker .ql-picker-label svg {
  right: 4px;
}
.ql-snow .ql-icon-picker .ql-picker-options {
  padding: 4px 0px;
}
.ql-snow .ql-icon-picker .ql-picker-item {
  height: 24px;
  width: 24px;
  padding: 2px 4px;
}
.ql-snow .ql-color-picker .ql-picker-options {
  padding: 3px 5px;
  width: 152px;
}
.ql-snow .ql-color-picker .ql-picker-item {
  border: 1px solid transparent;
  float: left;
  height: 16px;
  margin: 2px;
  padding: 0px;
  width: 16px;
}
.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  position: absolute;
  margin-top: -9px;
  right: 0;
  top: 50%;
  width: 18px;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {
  content: attr(data-label);
}
.ql-snow .ql-picker.ql-header {
  width: 98px;
}
.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: 'Normal';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: 'Heading 1';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: 'Heading 2';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: 'Heading 3';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: 'Heading 4';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: 'Heading 5';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: 'Heading 6';
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  font-size: 2em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  font-size: 1.5em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  font-size: 1.17em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  font-size: 1em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  font-size: 0.83em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  font-size: 0.67em;
}
.ql-snow .ql-picker.ql-font {
  width: 108px;
}
.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: 'Sans Serif';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: 'Serif';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: 'Monospace';
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  font-family: Georgia, Times New Roman, serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  font-family: Monaco, Courier New, monospace;
}
.ql-snow .ql-picker.ql-size {
  width: 98px;
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: 'Normal';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: 'Small';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: 'Large';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: 'Huge';
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  font-size: 10px;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  font-size: 18px;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  font-size: 32px;
}
.ql-snow .ql-color-picker.ql-background .ql-picker-item {
  background-color: #fff;
}
.ql-snow .ql-color-picker.ql-color .ql-picker-item {
  background-color: #000;
}
.ql-code-block-container {
  position: relative;
}
.ql-code-block-container .ql-ui {
  right: 5px;
  top: 5px;
}
.ql-toolbar.ql-snow {
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
  padding: 8px;
}
.ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px;
}
.ql-toolbar.ql-snow .ql-picker-label {
  border: 1px solid transparent;
}
.ql-toolbar.ql-snow .ql-picker-options {
  border: 1px solid transparent;
  box-shadow: rgba(0,0,0,0.2) 0 2px 8px;
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: #ccc;
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  border-color: #ccc;
}
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
  border-color: #000;
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
}
.ql-snow .ql-tooltip {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 5px #ddd;
  color: #444;
  padding: 5px 12px;
  white-space: nowrap;
}
.ql-snow .ql-tooltip::before {
  content: "Visit URL:";
  line-height: 26px;
  margin-right: 8px;
}
.ql-snow .ql-tooltip input[type=text] {
  display: none;
  border: 1px solid #ccc;
  font-size: 13px;
  height: 26px;
  margin: 0px;
  padding: 3px 5px;
  width: 170px;
}
.ql-snow .ql-tooltip a.ql-preview {
  display: inline-block;
  max-width: 200px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}
.ql-snow .ql-tooltip a.ql-action::after {
  border-right: 1px solid #ccc;
  content: 'Edit';
  margin-left: 16px;
  padding-right: 8px;
}
.ql-snow .ql-tooltip a.ql-remove::before {
  content: 'Remove';
  margin-left: 8px;
}
.ql-snow .ql-tooltip a {
  line-height: 26px;
}
.ql-snow .ql-tooltip.ql-editing a.ql-preview,
.ql-snow .ql-tooltip.ql-editing a.ql-remove {
  display: none;
}
.ql-snow .ql-tooltip.ql-editing input[type=text] {
  display: inline-block;
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: 'Save';
  padding-right: 0px;
}
.ql-snow .ql-tooltip[data-mode=link]::before {
  content: "Enter link:";
}
.ql-snow .ql-tooltip[data-mode=formula]::before {
  content: "Enter formula:";
}
.ql-snow .ql-tooltip[data-mode=video]::before {
  content: "Enter video:";
}
.ql-snow a {
  color: #06c;
}
.ql-container.ql-snow {
  border: 1px solid #ccc;
}

`, "",{"version":3,"sources":["webpack://./../../node_modules/@agentx/quill/dist/quill.snow.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;EACE,sBAAsB;EACtB,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;;;;;;;;;;EAUE,SAAS;EACT,UAAU;AACZ;AACA;;;;;;;EAOE,oFAAoF;AACtF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6EAA6E;EAC7E,yBAAyB;AAC3B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,sEAAsE;AACxE;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,+DAA+D;AACjE;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iDAAiD;AACnD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,aAAa;AACf;AACA;;;;;;;;;;;;;;EAcE,WAAW;AACb;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,YAAY;AACd;AACA;EACE;;IAEE,WAAW;EACb;EACA;;;;IAIE,UAAU;EACZ;EACA;;;;IAIE,YAAY;EACd;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;AACA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,QAAQ;EACR,WAAW;AACb;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,WAAW;AACb;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,+DAA+D;EAC/D,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB","sourcesContent":["/*!\n * Quill Editor v2.0.0-dev.5\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n.ql-container {\n  box-sizing: border-box;\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container:not(.ql-disabled) li[data-list=checked] > .ql-ui,\n.ql-container:not(.ql-disabled) li[data-list=unchecked] > .ql-ui {\n  cursor: pointer;\n}\n.ql-clipboard {\n  left: -100000px;\n  height: 1px;\n  overflow-y: hidden;\n  position: absolute;\n  top: 50%;\n}\n.ql-clipboard p {\n  margin: 0;\n  padding: 0;\n}\n.ql-editor {\n  box-sizing: border-box;\n  counter-reset: list-0;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  padding: 12px 15px;\n  tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor > * {\n  cursor: text;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n}\n.ql-editor p,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor table {\n  border-collapse: collapse;\n}\n.ql-editor td {\n  border: 1px solid #000;\n  padding: 2px 5px;\n}\n.ql-editor ol {\n  padding-left: 1.5em;\n}\n.ql-editor li {\n  list-style-type: none;\n  padding-left: 1.5em;\n  position: relative;\n}\n.ql-editor li > .ql-ui:before {\n  display: inline-block;\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li[data-list=checked] > .ql-ui,\n.ql-editor li[data-list=unchecked] > .ql-ui {\n  color: #777;\n}\n.ql-editor li[data-list=bullet] > .ql-ui:before {\n  content: '\\2022';\n}\n.ql-editor li[data-list=checked] > .ql-ui:before {\n  content: '\\2611';\n}\n.ql-editor li[data-list=unchecked] > .ql-ui:before {\n  content: '\\2610';\n}\n.ql-editor li[data-list=ordered] {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-0;\n}\n.ql-editor li[data-list=ordered] > .ql-ui:before {\n  content: counter(list-0, decimal) '. ';\n}\n.ql-editor li[data-list=ordered].ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor li[data-list=ordered].ql-indent-1 > .ql-ui:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor li[data-list=ordered].ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor li[data-list=ordered].ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor li[data-list=ordered].ql-indent-2 > .ql-ui:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor li[data-list=ordered].ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor li[data-list=ordered].ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor li[data-list=ordered].ql-indent-3 > .ql-ui:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor li[data-list=ordered].ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor li[data-list=ordered].ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor li[data-list=ordered].ql-indent-4 > .ql-ui:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor li[data-list=ordered].ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor li[data-list=ordered].ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor li[data-list=ordered].ql-indent-5 > .ql-ui:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor li[data-list=ordered].ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor li[data-list=ordered].ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor li[data-list=ordered].ql-indent-6 > .ql-ui:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor li[data-list=ordered].ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor li[data-list=ordered].ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor li[data-list=ordered].ql-indent-7 > .ql-ui:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor li[data-list=ordered].ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor li[data-list=ordered].ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor li[data-list=ordered].ql-indent-8 > .ql-ui:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor li[data-list=ordered].ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor li[data-list=ordered].ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor li[data-list=ordered].ql-indent-9 > .ql-ui:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor li.ql-direction-rtl {\n  padding-right: 1.5em;\n}\n.ql-editor li.ql-direction-rtl > .ql-ui:before {\n  margin-left: 0.3em;\n  margin-right: -1.5em;\n  text-align: left;\n}\n.ql-editor table {\n  table-layout: fixed;\n  width: 100%;\n}\n.ql-editor table td {\n  outline: none;\n}\n.ql-editor .ql-code-block-container {\n  font-family: monospace;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n.ql-editor .ql-ui {\n  position: absolute;\n}\n.ql-editor.ql-blank::before {\n  color: rgba(0,0,0,0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  left: 15px;\n  pointer-events: none;\n  position: absolute;\n  right: 15px;\n}\n.ql-snow.ql-toolbar:after,\n.ql-snow .ql-toolbar:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow.ql-toolbar button,\n.ql-snow .ql-toolbar button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  float: left;\n  height: 24px;\n  padding: 3px 5px;\n  width: 28px;\n}\n.ql-snow.ql-toolbar button svg,\n.ql-snow .ql-toolbar button svg {\n  float: left;\n  height: 100%;\n}\n.ql-snow.ql-toolbar button:active:hover,\n.ql-snow .ql-toolbar button:active:hover {\n  outline: none;\n}\n.ql-snow.ql-toolbar input.ql-image[type=file],\n.ql-snow .ql-toolbar input.ql-image[type=file] {\n  display: none;\n}\n.ql-snow.ql-toolbar button:hover,\n.ql-snow .ql-toolbar button:hover,\n.ql-snow.ql-toolbar button:focus,\n.ql-snow .ql-toolbar button:focus,\n.ql-snow.ql-toolbar button.ql-active,\n.ql-snow .ql-toolbar button.ql-active,\n.ql-snow.ql-toolbar .ql-picker-label:hover,\n.ql-snow .ql-toolbar .ql-picker-label:hover,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active,\n.ql-snow.ql-toolbar .ql-picker-item:hover,\n.ql-snow .ql-toolbar .ql-picker-item:hover,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n  color: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n  fill: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-stroke,\n.ql-snow .ql-toolbar button:hover .ql-stroke,\n.ql-snow.ql-toolbar button:focus .ql-stroke,\n.ql-snow .ql-toolbar button:focus .ql-stroke,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow.ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow .ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n  stroke: #06c;\n}\n@media (pointer: coarse) {\n  .ql-snow.ql-toolbar button:hover:not(.ql-active),\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) {\n    color: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n    fill: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n    stroke: #444;\n  }\n}\n.ql-snow {\n  box-sizing: border-box;\n}\n.ql-snow * {\n  box-sizing: border-box;\n}\n.ql-snow .ql-hidden {\n  display: none;\n}\n.ql-snow .ql-out-bottom,\n.ql-snow .ql-out-top {\n  visibility: hidden;\n}\n.ql-snow .ql-tooltip {\n  position: absolute;\n  transform: translateY(10px);\n}\n.ql-snow .ql-tooltip a {\n  cursor: pointer;\n  text-decoration: none;\n}\n.ql-snow .ql-tooltip.ql-flip {\n  transform: translateY(-10px);\n}\n.ql-snow .ql-formats {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ql-snow .ql-formats:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow .ql-stroke {\n  fill: none;\n  stroke: #444;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n.ql-snow .ql-stroke-miter {\n  fill: none;\n  stroke: #444;\n  stroke-miterlimit: 10;\n  stroke-width: 2;\n}\n.ql-snow .ql-fill,\n.ql-snow .ql-stroke.ql-fill {\n  fill: #444;\n}\n.ql-snow .ql-empty {\n  fill: none;\n}\n.ql-snow .ql-even {\n  fill-rule: evenodd;\n}\n.ql-snow .ql-thin,\n.ql-snow .ql-stroke.ql-thin {\n  stroke-width: 1;\n}\n.ql-snow .ql-transparent {\n  opacity: 0.4;\n}\n.ql-snow .ql-direction svg:last-child {\n  display: none;\n}\n.ql-snow .ql-direction.ql-active svg:last-child {\n  display: inline;\n}\n.ql-snow .ql-direction.ql-active svg:first-child {\n  display: none;\n}\n.ql-snow .ql-editor h1 {\n  font-size: 2em;\n}\n.ql-snow .ql-editor h2 {\n  font-size: 1.5em;\n}\n.ql-snow .ql-editor h3 {\n  font-size: 1.17em;\n}\n.ql-snow .ql-editor h4 {\n  font-size: 1em;\n}\n.ql-snow .ql-editor h5 {\n  font-size: 0.83em;\n}\n.ql-snow .ql-editor h6 {\n  font-size: 0.67em;\n}\n.ql-snow .ql-editor a {\n  text-decoration: underline;\n}\n.ql-snow .ql-editor blockquote {\n  border-left: 4px solid #ccc;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding-left: 16px;\n}\n.ql-snow .ql-editor code,\n.ql-snow .ql-editor .ql-code-block-container {\n  background-color: #f0f0f0;\n  border-radius: 3px;\n}\n.ql-snow .ql-editor .ql-code-block-container {\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding: 5px 10px;\n}\n.ql-snow .ql-editor code {\n  font-size: 85%;\n  padding: 2px 4px;\n}\n.ql-snow .ql-editor .ql-code-block-container {\n  background-color: #23241f;\n  color: #f8f8f2;\n  overflow: visible;\n}\n.ql-snow .ql-editor img {\n  max-width: 100%;\n}\n.ql-snow .ql-picker {\n  color: #444;\n  display: inline-block;\n  float: left;\n  font-size: 14px;\n  font-weight: 500;\n  height: 24px;\n  position: relative;\n  vertical-align: middle;\n}\n.ql-snow .ql-picker-label {\n  cursor: pointer;\n  display: inline-block;\n  height: 100%;\n  padding-left: 8px;\n  padding-right: 2px;\n  position: relative;\n  width: 100%;\n}\n.ql-snow .ql-picker-label::before {\n  display: inline-block;\n  line-height: 22px;\n}\n.ql-snow .ql-picker-options {\n  background-color: #fff;\n  display: none;\n  min-width: 100%;\n  padding: 4px 8px;\n  position: absolute;\n  white-space: nowrap;\n}\n.ql-snow .ql-picker-options .ql-picker-item {\n  cursor: pointer;\n  display: block;\n  padding-bottom: 5px;\n  padding-top: 5px;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  color: #ccc;\n  z-index: 2;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n  fill: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n  stroke: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  display: block;\n  margin-top: -1px;\n  top: 100%;\n  z-index: 1;\n}\n.ql-snow .ql-color-picker,\n.ql-snow .ql-icon-picker {\n  width: 28px;\n}\n.ql-snow .ql-color-picker .ql-picker-label,\n.ql-snow .ql-icon-picker .ql-picker-label {\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-label svg,\n.ql-snow .ql-icon-picker .ql-picker-label svg {\n  right: 4px;\n}\n.ql-snow .ql-icon-picker .ql-picker-options {\n  padding: 4px 0px;\n}\n.ql-snow .ql-icon-picker .ql-picker-item {\n  height: 24px;\n  width: 24px;\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-options {\n  padding: 3px 5px;\n  width: 152px;\n}\n.ql-snow .ql-color-picker .ql-picker-item {\n  border: 1px solid transparent;\n  float: left;\n  height: 16px;\n  margin: 2px;\n  padding: 0px;\n  width: 16px;\n}\n.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n  position: absolute;\n  margin-top: -9px;\n  right: 0;\n  top: 50%;\n  width: 18px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n  content: attr(data-label);\n}\n.ql-snow .ql-picker.ql-header {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  content: 'Heading 1';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  content: 'Heading 2';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  content: 'Heading 3';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  content: 'Heading 4';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  content: 'Heading 5';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  content: 'Heading 6';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  font-size: 2em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  font-size: 1.5em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  font-size: 1.17em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  font-size: 1em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  font-size: 0.83em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  font-size: 0.67em;\n}\n.ql-snow .ql-picker.ql-font {\n  width: 108px;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item::before {\n  content: 'Sans Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  content: 'Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  content: 'Monospace';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-snow .ql-picker.ql-size {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  content: 'Small';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  content: 'Large';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  content: 'Huge';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  font-size: 10px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  font-size: 18px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  font-size: 32px;\n}\n.ql-snow .ql-color-picker.ql-background .ql-picker-item {\n  background-color: #fff;\n}\n.ql-snow .ql-color-picker.ql-color .ql-picker-item {\n  background-color: #000;\n}\n.ql-code-block-container {\n  position: relative;\n}\n.ql-code-block-container .ql-ui {\n  right: 5px;\n  top: 5px;\n}\n.ql-toolbar.ql-snow {\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  padding: 8px;\n}\n.ql-toolbar.ql-snow .ql-formats {\n  margin-right: 15px;\n}\n.ql-toolbar.ql-snow .ql-picker-label {\n  border: 1px solid transparent;\n}\n.ql-toolbar.ql-snow .ql-picker-options {\n  border: 1px solid transparent;\n  box-shadow: rgba(0,0,0,0.2) 0 2px 8px;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n  border-color: #000;\n}\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n  border-top: 0px;\n}\n.ql-snow .ql-tooltip {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  box-shadow: 0px 0px 5px #ddd;\n  color: #444;\n  padding: 5px 12px;\n  white-space: nowrap;\n}\n.ql-snow .ql-tooltip::before {\n  content: \"Visit URL:\";\n  line-height: 26px;\n  margin-right: 8px;\n}\n.ql-snow .ql-tooltip input[type=text] {\n  display: none;\n  border: 1px solid #ccc;\n  font-size: 13px;\n  height: 26px;\n  margin: 0px;\n  padding: 3px 5px;\n  width: 170px;\n}\n.ql-snow .ql-tooltip a.ql-preview {\n  display: inline-block;\n  max-width: 200px;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  vertical-align: top;\n}\n.ql-snow .ql-tooltip a.ql-action::after {\n  border-right: 1px solid #ccc;\n  content: 'Edit';\n  margin-left: 16px;\n  padding-right: 8px;\n}\n.ql-snow .ql-tooltip a.ql-remove::before {\n  content: 'Remove';\n  margin-left: 8px;\n}\n.ql-snow .ql-tooltip a {\n  line-height: 26px;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-preview,\n.ql-snow .ql-tooltip.ql-editing a.ql-remove {\n  display: none;\n}\n.ql-snow .ql-tooltip.ql-editing input[type=text] {\n  display: inline-block;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-action::after {\n  border-right: 0px;\n  content: 'Save';\n  padding-right: 0px;\n}\n.ql-snow .ql-tooltip[data-mode=link]::before {\n  content: \"Enter link:\";\n}\n.ql-snow .ql-tooltip[data-mode=formula]::before {\n  content: \"Enter formula:\";\n}\n.ql-snow .ql-tooltip[data-mode=video]::before {\n  content: \"Enter video:\";\n}\n.ql-snow a {\n  color: #06c;\n}\n.ql-container.ql-snow {\n  border: 1px solid #ccc;\n}\n\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/AvatarStatus/styles.scss":
/*!*****************************************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/AvatarStatus/styles.scss ***!
  \*****************************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar-status {
  position: relative;
  width: max-content;
  margin-right: calc(var(--space-token-even) * 2);
  display: block;
}
.avatar-status .status {
  position: absolute;
  bottom: -2px;
  right: -4px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background-color: var(--md-secondary-white-bg-color);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}
.avatar-status .status svg {
  font-size: var(--font-size-small);
}`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/AvatarStatus/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kBAAA;EACA,+CAAA;EACA,cAAA;AACF;AAAE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oDAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAEJ;AADI;EACE,iCAAA;AAGN","sourcesContent":[".avatar-status {\n  position: relative;\n  width: max-content;\n  margin-right: calc(var(--space-token-even) * 2);\n  display: block;\n  .status {\n    position: absolute;\n    bottom: -2px;\n    right: -4px;\n    width: 16px;\n    height: 16px;\n    border-radius: 100%;\n    background-color: var(--md-secondary-white-bg-color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    svg {\n      font-size: var(--font-size-small);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/EmergencyNotificationModal/styles.scss":
/*!*******************************************************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/EmergencyNotificationModal/styles.scss ***!
  \*******************************************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.read-the-notification-wrapper {
  padding: 16px 8px 0px;
}

.read-the-notification::part(checkbox-label) {
  z-index: 0;
}

md-modal::part(modal-body) {
  margin-bottom: 16px;
  overflow: hidden;
}

md-checkbox {
  right: 5px;
}

md-button {
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/EmergencyNotificationModal/styles.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".read-the-notification-wrapper {\n  padding: 16px 8px 0px;\n}\n\n.read-the-notification::part(checkbox-label) {\n  z-index: 0;\n}\n\nmd-modal::part(modal-body) {\n  margin-bottom: 16px;\n  overflow: hidden;\n}\n\nmd-checkbox {\n  right: 5px;\n}\n\nmd-button {\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/ErrorDetail/styles.scss":
/*!****************************************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/ErrorDetail/styles.scss ***!
  \****************************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-details * {
  --trackingid-detail-max-width: 405px;
  --details-hidden-height: 1px;
  --default-details-show-height: 120px;
  --color-gray-border: #ccc;
}

.error-details summary::-webkit-details-marker {
  display: none;
}

.error-details summary {
  list-style-type: none !important;
  cursor: pointer;
}

.trackingid-container {
  font-size: var(--font-size-small);
  color: var(--md-secondary-text-color);
}

.trackingid-description {
  margin-top: calc(var(--space-token-cardinal) * 2);
}

.failed-error-link {
  color: var(--md-primary-text-color);
  text-decoration: underline;
  cursor: pointer;
}

.error-details {
  width: 100%;
}
.error-details.centered {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.error-details.centered .trackingid-summary {
  text-align: center;
  padding: 0 var(--space-token-cardinal);
}
.error-details.centered .trackingid-description {
  text-align: center;
  margin: 16px 0;
  font-size: 12px;
  color: var(--md-primary-text-color);
}
.error-details.centered .tracking-input-wrap {
  text-align: center;
  color: var(--md-primary-text-color);
}

.copy-trackingid-icon {
  cursor: pointer;
  padding-top: calc(var(--space-token-even) * 2);
}

.trackingid-error-details-wrap {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: calc(var(--space-token-cardinal) * 2);
  position: relative;
}
.trackingid-error-details-wrap .tracking-input-wrap {
  display: flex;
  min-width: 0px;
}
.trackingid-error-details-wrap .tracking-input-wrap .trackingid-label {
  flex: 1 0 auto;
  padding-right: var(--space-token-cardinal);
  align-self: center;
  display: inline;
}
.trackingid-error-details-wrap .tracking-input-wrap .trackingid-input {
  display: inline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 1 auto;
}
.trackingid-error-details-wrap.modal .tracking-input-wrap .trackingid-input {
  display: inline-block;
  padding: calc(var(--space-token-even) * 2) calc(var(--space-token-even) * 4);
  border: 1px solid var(--color-gray-border);
  box-sizing: border-box;
  border-radius: var(--border-radius-small);
}
.trackingid-error-details-wrap.default .copied-trackingid-icon,
.trackingid-error-details-wrap.default .copy-trackingid-icon {
  padding-top: 0;
}
.trackingid-error-details-wrap.default #copy-trackingid-icon::part(button) {
  width: 24px;
  height: 24px;
}

.error-details[open] .trackingid-container {
  animation: show 0.5s;
  height: var(--default-details-show-height);
}
.error-details[open] .trackingid-container.default .error-details[open] .trackingid-container.modal {
  display: block;
  animation: show 1s;
}

.error-details:not([open]) .trackingid-container {
  animation: hide 0.5s;
  height: var(--details-hidden-height);
}
.error-details:not([open]) .trackingid-container.modal {
  display: block;
  animation: hide 1s;
}

.error-details-link {
  width: fit-content;
  color: var(--md-alert-info-text-color, --color-blue-70);
  text-decoration: underline;
}

@keyframes show {
  0% {
    opacity: 0;
    height: var(--details-hidden-height);
  }
  100% {
    opacity: 1;
  }
}
@keyframes hide {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    height: var(--details-hidden-height);
  }
}
.copy-button-container {
  margin-left: calc(var(--space-token-cardinal) * 2);
  align-self: center;
  transition: opacity 250ms linear;
}`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/ErrorDetail/styles.scss"],"names":[],"mappings":"AACA;EACE,oCAAA;EACA,4BAAA;EACA,oCAAA;EACA,yBAAA;AACF;;AACA;EAEE,aAAA;AACF;;AACA;EACE,gCAAA;EACA,eAAA;AAEF;;AAAA;EACE,iCAAA;EACA,qCAAA;AAGF;;AAAA;EACE,iDAAA;AAGF;;AADA;EACE,mCAAA;EACA,0BAAA;EACA,eAAA;AAIF;;AADA;EACE,WAAA;AAIF;AAFE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AAIJ;AAFI;EACE,kBAAA;EACA,sCAAA;AAIN;AADI;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mCAAA;AAGN;AADI;EACE,kBAAA;EACA,mCAAA;AAGN;;AAEA;EACE,eAAA;EACA,8CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,cAAA;AACJ;AAAI;EACE,cAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;AAEN;AACI;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AACN;AAKM;EACE,qBAAA;EACA,4EAAA;EACA,0CAAA;EACA,sBAAA;EACA,yCAAA;AAHR;AASI;;EAEE,cAAA;AAPN;AASI;EACE,WAAA;EACA,YAAA;AAPN;;AAWA;EACE,oBAAA;EACA,0CAAA;AARF;AAUE;EACE,cAAA;EACA,kBAAA;AARJ;;AAWA;EACE,oBAAA;EACA,oCAAA;AARF;AAUE;EACE,cAAA;EACA,kBAAA;AARJ;;AAYA;EACE,kBAAA;EACA,uDAAA;EACA,0BAAA;AATF;;AAYA;EACE;IACE,UAAA;IACA,oCAAA;EATF;EAYA;IACE,UAAA;EAVF;AACF;AAYA;EACE;IACE,UAAA;EAVF;EAaA;IACE,UAAA;IACA,oCAAA;EAXF;AACF;AAcA;EACE,kDAAA;EACA,kBAAA;EACA,gCAAA;AAZF","sourcesContent":["@import \"../../../../css/variables.css\";\n.error-details * {\n  --trackingid-detail-max-width: 405px;\n  --details-hidden-height: 1px;\n  --default-details-show-height: 120px;\n  --color-gray-border: #ccc;\n}\n.error-details summary::-webkit-details-marker {\n  // remove default arrow of details html tag\n  display: none;\n}\n.error-details summary {\n  list-style-type: none !important;\n  cursor: pointer;\n}\n.trackingid-container {\n  font-size: var(--font-size-small);\n  color: var(--md-secondary-text-color);\n}\n\n.trackingid-description {\n  margin-top: calc(var(--space-token-cardinal) * 2);\n}\n.failed-error-link {\n  color: var(--md-primary-text-color);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.error-details {\n  width: 100%;\n\n  &.centered {\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    align-items: center;\n    justify-content: center;\n\n    .trackingid-summary {\n      text-align: center;\n      padding: 0 var(--space-token-cardinal);\n    }\n\n    .trackingid-description {\n      text-align: center;\n      margin: 16px 0;\n      font-size: 12px;\n      color: var(--md-primary-text-color);\n    }\n    .tracking-input-wrap {\n      text-align: center;\n      color: var(--md-primary-text-color);\n    }\n  }\n}\n\n.copy-trackingid-icon {\n  cursor: pointer;\n  padding-top: calc(var(--space-token-even) * 2);\n}\n\n.trackingid-error-details-wrap {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-top: calc(var(--space-token-cardinal) * 2);\n  position: relative;\n\n  .tracking-input-wrap {\n    display: flex;\n    min-width: 0px;\n    .trackingid-label {\n      flex: 1 0 auto;\n      padding-right: var(--space-token-cardinal);\n      align-self: center;\n      display: inline;\n    }\n\n    .trackingid-input {\n      display: inline;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      flex: 0 1 auto;\n    }\n  }\n\n  &.modal {\n    .tracking-input-wrap {\n      .trackingid-input {\n        display: inline-block;\n        padding: calc(var(--space-token-even) * 2) calc(var(--space-token-even) * 4);\n        border: 1px solid var(--color-gray-border);\n        box-sizing: border-box;\n        border-radius: var(--border-radius-small);\n      }\n    }\n  }\n\n  &.default {\n    .copied-trackingid-icon,\n    .copy-trackingid-icon {\n      padding-top: 0;\n    }\n    #copy-trackingid-icon::part(button) {\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n.error-details[open] .trackingid-container {\n  animation: show 0.5s;\n  height: var(--default-details-show-height);\n\n  &.default &.modal {\n    display: block;\n    animation: show 1s;\n  }\n}\n.error-details:not([open]) .trackingid-container {\n  animation: hide 0.5s;\n  height: var(--details-hidden-height);\n\n  &.modal {\n    display: block;\n    animation: hide 1s;\n  }\n}\n\n.error-details-link {\n  width: fit-content;\n  color: var(--md-alert-info-text-color, --color-blue-70);\n  text-decoration: underline;\n}\n\n@keyframes show {\n  0% {\n    opacity: 0;\n    height: var(--details-hidden-height);\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes hide {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n    height: var(--details-hidden-height);\n  }\n}\n\n.copy-button-container {\n  margin-left: calc(var(--space-token-cardinal) * 2);\n  align-self: center;\n  transition: opacity 250ms linear;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/HighlightText/styles.scss":
/*!******************************************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/HighlightText/styles.scss ***!
  \******************************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.md-combobox-option .select-label span.highlight-span {
  margin-right: auto;
}
.md-combobox-option .select-label span.highlight-span span {
  margin-right: auto;
}`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/HighlightText/styles.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AAAF;AACE;EACE,kBAAA;AACJ","sourcesContent":["@import \"../../../../css/variables.css\";\n\n.md-combobox-option .select-label span.highlight-span {\n  margin-right: auto;\n  span {\n    margin-right: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/List/FetchError/styles.scss":
/*!********************************************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/List/FetchError/styles.scss ***!
  \********************************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infinite-scroll-error {
  display: flex;
  padding-left: 15px;
  font-size: var(--font-size-small);
  color: var(--md-alert-error-text-color, --red-70-color);
  flex-direction: column;
}
.infinite-scroll-error .error-block {
  display: flex;
  flex-direction: column;
}
.infinite-scroll-error .error-block .error-span-padding {
  padding-right: 8px;
}
.infinite-scroll-error .error-block .tracking-error-block {
  display: inline-flex;
}
.infinite-scroll-error .error-block .infinite-scroll-retry-link::part(link) {
  font-size: var(--font-size-small);
  color: var(--md-alert-error-text-color, --red-70-color);
}`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/List/FetchError/styles.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kBAAA;EACA,iCAAA;EACA,uDAAA;EACA,sBAAA;AAAF;AACE;EACE,aAAA;EACA,sBAAA;AACJ;AAAI;EACE,kBAAA;AAEN;AAAI;EACE,oBAAA;AAEN;AAAI;EACE,iCAAA;EACA,uDAAA;AAEN","sourcesContent":["@import \"../../../../../css/variables.css\";\n\n.infinite-scroll-error {\n  display: flex;\n  padding-left: 15px;\n  font-size: var(--font-size-small);\n  color: var(--md-alert-error-text-color, --red-70-color);\n  flex-direction: column;\n  .error-block {\n    display: flex;\n    flex-direction: column;\n    .error-span-padding {\n      padding-right: 8px;\n    }\n    .tracking-error-block {\n      display: inline-flex;\n    }\n    .infinite-scroll-retry-link::part(link) {\n      font-size: var(--font-size-small);\n      color: var(--md-alert-error-text-color, --red-70-color);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/List/ListError/styles.scss":
/*!*******************************************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/List/ListError/styles.scss ***!
  \*******************************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-error {
  text-align: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
}

.list-error__illustrations {
  width: 84px;
  margin: auto;
}

.list-error .list-error__header {
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  margin-top: 24px;
  margin-bottom: 0;
}

.list-error .list-error__sub-header {
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 0;
  margin-top: 0;
}

.list-error .list-error__button {
  margin-top: 24px;
}`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/List/ListError/styles.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AAAF;;AAGA;EACE,gBAAA;AAAF","sourcesContent":["@import \"../../../../../css/variables.css\";\n\n.list-error {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 10px;\n}\n\n.list-error__illustrations {\n  width: 84px;\n  margin: auto;\n}\n\n.list-error .list-error__header {\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 19px;\n  margin-top: 24px;\n  margin-bottom: 0;\n}\n\n.list-error .list-error__sub-header {\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 19px;\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.list-error .list-error__button {\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/List/ListItem/styles.scss":
/*!******************************************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/List/ListItem/styles.scss ***!
  \******************************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infinite-scroll-spinner {
  display: flex;
  justify-content: center;
  padding: var(--padding-12);
}`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/List/ListItem/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,0BAAA;AACF","sourcesContent":[".infinite-scroll-spinner {\n  display: flex;\n  justify-content: center;\n  padding: var(--padding-12);\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/MSTAvatar/styles.scss":
/*!**************************************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/MSTAvatar/styles.scss ***!
  \**************************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mst-avatar.type-available .status svg {
  color: var(--md-green-60);
}
.mst-avatar.type-busy .status svg {
  color: var(--md-yellow-60);
}
.mst-avatar.type-oncall .status {
  border-radius: 4px;
}
.mst-avatar.type-oncall .status svg {
  color: var(--md-yellow-60);
}
.mst-avatar.type-meeting .status {
  border-radius: 4px;
}
.mst-avatar.type-meeting .status svg {
  color: var(--md-yellow-60);
}
.mst-avatar.type-dnd .status svg {
  color: var(--md-red-60);
}
.mst-avatar.type-presenting .status {
  border-radius: 4px;
}
.mst-avatar.type-presenting .status svg {
  color: var(--md-yellow-60);
}
.mst-avatar.type-occupied .status svg {
  color: var(--md-gray-60);
}
.mst-avatar.type-unknown .status svg {
  color: var(--md-gray-60);
}
.mst-avatar.type-outofoffice .status svg {
  color: var(--md-gray-60);
}`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/MSTAvatar/styles.scss"],"names":[],"mappings":"AAGM;EACE,yBAAA;AAFR;AAQM;EACE,0BAAA;AANR;AAWI;EACE,kBAAA;AATN;AAUM;EACE,0BAAA;AARR;AAaI;EACE,kBAAA;AAXN;AAYM;EACE,0BAAA;AAVR;AAgBM;EACE,uBAAA;AAdR;AAmBI;EACE,kBAAA;AAjBN;AAkBM;EACE,0BAAA;AAhBR;AAsBM;EACE,wBAAA;AApBR;AA0BM;EACE,wBAAA;AAxBR;AA8BM;EACE,wBAAA;AA5BR","sourcesContent":[".mst-avatar {\n  &.type-available {\n    .status {\n      svg {\n        color: var(--md-green-60);\n      }\n    }\n  }\n  &.type-busy {\n    .status {\n      svg {\n        color: var(--md-yellow-60);\n      }\n    }\n  }\n  &.type-oncall {\n    .status {\n      border-radius: 4px;\n      svg {\n        color: var(--md-yellow-60);\n      }\n    }\n  }\n  &.type-meeting {\n    .status {\n      border-radius: 4px;\n      svg {\n        color: var(--md-yellow-60);\n      }\n    }\n  }\n  &.type-dnd {\n    .status {\n      svg {\n        color: var(--md-red-60);\n      }\n    }\n  }\n  &.type-presenting {\n    .status {\n      border-radius: 4px;\n      svg {\n        color: var(--md-yellow-60);\n      }\n    }\n  }\n  &.type-occupied {\n    .status {\n      svg {\n        color: var(--md-gray-60);\n      }\n    }\n  }\n  &.type-unknown {\n    .status {\n      svg {\n        color: var(--md-gray-60);\n      }\n    }\n  }\n  &.type-outofoffice {\n    .status {\n      svg {\n        color: var(--md-gray-60);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/WebexAvatar/styles.scss":
/*!****************************************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/WebexAvatar/styles.scss ***!
  \****************************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webex-avatar-presence-icon.type-active .status svg {
  color: var(--md-green-60);
}
.webex-avatar-presence-icon.type-meeting .status svg {
  color: var(--md-orange-60);
}
.webex-avatar-presence-icon.type-call .status svg {
  color: var(--md-orange-60);
}
.webex-avatar-presence-icon.type-dnd .status svg {
  color: var(--md-red-60);
}
.webex-avatar-presence-icon.type-presenting .status svg {
  color: var(--md-red-60);
}
.webex-avatar-presence-icon.type-quiet .status svg {
  color: var(--md-gray-60);
}
.webex-avatar-presence-icon.type-inactive .status svg {
  color: var(--md-gray-60);
}
.webex-avatar-presence-icon.type-ooo .status svg {
  color: var(--md-gray-60);
}
.webex-avatar-presence-icon.type-calendaritem .status svg {
  color: var(--md-orange-60);
}
.webex-avatar-presence-icon.type-busy .status svg {
  color: var(--md-orange-60);
}
.webex-avatar-presence-icon.type- .status svg {
  color: var(--md-gray-60);
}`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/WebexAvatar/styles.scss"],"names":[],"mappings":"AAGM;EACE,yBAAA;AAFR;AAQM;EACE,0BAAA;AANR;AAYM;EACE,0BAAA;AAVR;AAgBM;EACE,uBAAA;AAdR;AAoBM;EACE,uBAAA;AAlBR;AAwBM;EACE,wBAAA;AAtBR;AA4BM;EACE,wBAAA;AA1BR;AAgCM;EACE,wBAAA;AA9BR;AAoCM;EACE,0BAAA;AAlCR;AAwCM;EACE,0BAAA;AAtCR;AA4CM;EACE,wBAAA;AA1CR","sourcesContent":[".webex-avatar-presence-icon {\n  &.type-active {\n    .status {\n      svg {\n        color: var(--md-green-60);\n      }\n    }\n  }\n  &.type-meeting {\n    .status {\n      svg {\n        color: var(--md-orange-60);\n      }\n    }\n  }\n  &.type-call {\n    .status {\n      svg {\n        color: var(--md-orange-60);\n      }\n    }\n  }\n  &.type-dnd {\n    .status {\n      svg {\n        color: var(--md-red-60);\n      }\n    }\n  }\n  &.type-presenting {\n    .status {\n      svg {\n        color: var(--md-red-60);\n      }\n    }\n  }\n  &.type-quiet {\n    .status {\n      svg {\n        color: var(--md-gray-60);\n      }\n    }\n  }\n  &.type-inactive {\n    .status {\n      svg {\n        color: var(--md-gray-60);\n      }\n    }\n  }\n  &.type-ooo {\n    .status {\n      svg {\n        color: var(--md-gray-60);\n      }\n    }\n  }\n  &.type-calendaritem {\n    .status {\n      svg {\n        color: var(--md-orange-60);\n      }\n    }\n  }\n  &.type-busy {\n    .status {\n      svg {\n        color: var(--md-orange-60);\n      }\n    }\n  }\n  &.type- {\n    .status {\n      svg {\n        color: var(--md-gray-60);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/ContactHistory/HandledByAgent/styles.scss":
/*!****************************************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/ContactHistory/HandledByAgent/styles.scss ***!
  \****************************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  /* Light & Dark Defaults */
  --sandbox-bg-color-default: #e5e5e5;
  --border-width: 1px;
  --md-primary-bg-color-default: #ffffff;
  --md-secondary-bg-color-default: #f7f7f7;
  --md-secondary-white-bg-color-default: #ffffff;
  --md-tertiary-bg-color-default: #ededed;
  --md-quaternary-bg-color-default: #dedede;
  --defult-button-size: 36px;
  --md-primary-text-color-default: #121212;
  --md-secondary-text-color-default: #545454;
  --md-primary-seperator-color-default: #cccccc;
  --md-alert-warning-bg-color: #ffecc2;
  /* Border */
  --border: 1px solid var(--md-primary-seperator-color, --md-primary-seperator-color-default);
  --blue-border: var(--border-width) solid var(--link-color);
  --red-border: var(--border-width) solid var(--red-color);
  --interaction-border-bottom: 8px solid var(--gray-30-color);
  --email-chat-min-width: 600px;
  --interaction-control-height: 67px;
  --top-header-height: 65px;
  /* Font size */
  --font-size-xlarge: 20px;
  --font-size-large: 16px;
  --font-size-medium: 14px;
  --font-size-small: 12px;
  --font-size-xsmall: 10px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  /* Padding */
  --padding-16: 16px;
  --padding-14: 14px;
  --padding-12: 12px;
  --padding-10: 10px;
  --padding-8: 8px;
  --padding-3: 3px;
  --padding-2: 2px;
  --conference-button-padding: 4px 8px 4px 4px;
  /* Cardinal variables */
  --left-spacing-16: 16px;
  --left-spacing-40: 40px;
  --margin-8: 8px;
  --margin-375rem: 0.375rem;
  /* Flexbox */
  --flex-only-two-columns: 50%;
  /* Font Weight */
  --font-weight-normal: var(--brand-font-weight-regular, 400);
  --font-weight-bold: 600;
  /* Font family */
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light:
    var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-bold:
    var(--brand-font-bold, "CiscoSansTT Bold"), "CiscoSansTT Bold", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-icons: "momentum-ui-icons", sans-serif;
  /* Colors */
  --red-color: #ff5c4a;
  --orange-color: #d67f04;
  --red-60-color: #d93829;
  --red-70-color: #a12512;
  --red-20-color: #ffe1d9;
  --white-color: #fff;
  --black-color: #000;
  --blue-20-color: #b8f2ff;
  --blue-40-color: #07c1f5;
  --link-color: #00a0d1;
  --grey-border: #f2f2f2;
  --grey-color: #d2d5d6;
  --green-color: #24ab31;
  --green-05-color: #edfaf4;
  --green-10-color: #befade;
  --green-20-color: #bcf7bf;
  --green-30-color: #31e88c;
  --gray-100-color: #171b1f;
  --gray-80-color: #3b3b3b;
  --gray-70-color: #535759;
  --gray-30-color: #d2d5d6;
  --gray-20-color: #f7f7f7;
  --gray-10-color: #f2f4f5;
  --background-color: transparent;
  --slate-60-color: #6f739e;
  --sub-header: #535759;
  --blue-05-color: #e6fbff;
  --blue-70-color: #005e7d;
  --brand-60-color: #007ea8;
  --disabled-lightui-color: #ededed;
  --disabled-text-color: #b2b2b2;
  --highlight-color: #737678;
  --violet-20-color: #f0e3fc;
  --yellow-20-color: #ffe6b3;
  --light-green-color: #44cf50;
  --dark-green-color: #03612c;
  --disabled-color: #e6e7e7;
  --red-30-color: #ffc7ba;
  --gold-color: #7d4705;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 10px;
  --border-radius-medium-top: 8px 8px 0 0;
  --border-radius-medium-bottom: 0 0 8px 8px;
  /* Box shadow*/
  --common-box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.18), 0px 2px 4px rgba(0, 0, 0, 0.16);
  --simple-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
  --focused-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --focused-momentum-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3);
  --focused-list-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3) inset;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  --animation-slideIn: slideIn var(--default-animation-duration) var(--ease-in-out-quint) forwards;
  --animation-slideOut: slideOut var(--default-animation-duration) var(--ease-in-out-quint) forwards;
  --animation-fadeIn: fadeIn var(--quick-animation-duration) linear forwards;
  box-sizing: border-box;
}

/* Animation */
@keyframes slideIn {
  from {
    transform: translatex(0);
  }
  to {
    transform: translatex(-100%);
  }
}
@keyframes slideOut {
  from {
    transform: translatex(-100%);
  }
  to {
    transform: translatex(0);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.agent-history * {
  --item-social-icon-dimension: 2rem;
  --item-social-icon-left: 1.1rem;
  --item-social-icon-top: 0.9375rem;
  --item-social-pad-bot: 0.625rem;
  --error-icon-mar-bot: 1.563rem;
  --selected-tab-bottom-border: 3px solid var(--link-color);
  --media-icon-height: 32px;
  --time-width: 70px;
  --badge-width: 40px;
  --tab-height: 40px;
  --tab-header-height: 48px;
  --tab-title-margin: 1rem 0.75rem;
  --tab-title-height: calc(1rem / 0.6);
  --color-blue-60: #007aa3;
  --dragger-border-radius: 16px;
  --history-illustration-height: 151px;
  --agent-history-resizer-height: var(--history-divider-height, 2px);
  --history-dragger-height: var(--grabber-width, 12px);
  --history-dragger-width: 42px;
  --wrapup-reason-max-width: 88px;
  --wrapup-reason-min-width: 36px;
}

.disable-element {
  pointer-events: none;
}

.agent-history {
  overflow: visible;
  height: 100%;
  position: relative;
  min-height: 52px;
  max-height: 75vh;
  background-color: var(--md-agent-history-bg-color);
}

.agent-history md-tabs::part(tabs-list),
.agent-history.new-momentum md-tabs::part(tabs-list) {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-shrink: 0;
}

.agent-history.new-momentum md-tabs::part(tabs-list) {
  margin-top: 12px;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 8px;
}

.agent-history md-tabs::part(tabs-content) {
  max-height: calc(100% - (var(--tab-header-height) + 1px));
}

.agent-history-title {
  margin: var(--tab-title-margin);
  font-size: var(--font-size-large);
  color: var(--md-primary-text-color);
}

.agent-history-main {
  margin: 0;
  padding: 0;
  color: var(--md-secondary-text-color);
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  scrollbar-width: thin;
  background-color: var(--md-agent-history-bg-color, var(--gray-20-color));
}
.agent-history-main::-webkit-scrollbar {
  width: calc(var(--space-token-even) * 4);
}
.agent-history-main::-webkit-scrollbar-thumb {
  border-radius: var(--border-radius-large);
  background-color: var(--md-presence-away-bg-color);
}

.agent-history-main > div {
  scrollbar-width: thin;
}
.agent-history-main > div::-webkit-scrollbar {
  width: calc(var(--space-token-even) * 4);
}
.agent-history-main > div::-webkit-scrollbar-thumb {
  border-radius: var(--border-radius-large);
  background-color: var(--md-presence-away-bg-color);
}

.agent-history-main .item {
  width: 99% !important;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  list-style: none;
  font-size: var(--font-size-medium);
  overflow: hidden;
  margin: 4px 2px 2px 2px;
  padding-left: calc(var(--space-token-cardinal) * 2);
}

.agent-history-main .item:focus {
  outline: none;
  box-shadow: var(--focused-momentum-shadow);
}

.aih-list-container:focus {
  outline: none;
  box-shadow: var(--focused-list-shadow);
}

.agent-history-main .item > .icon {
  width: var(--item-social-icon-dimension);
  height: var(--item-social-icon-dimension);
  background: var(--md-primary-bg-color, white);
  color: var(--black-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 2px;
}

.agent-history-main .item .details {
  padding: calc(var(--space-token-cardinal) * 2);
  flex: 1;
  width: calc(100% - var(--time-width) - var(--space-token-cardinal) * 2 - var(--badge-width));
  display: flex;
  flex-direction: column;
}

.agent-history-main .item .details div:first-of-type {
  color: var(--md-primary-text-color);
}

.agent-history-main .item .details div {
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
}

.agent-history-main .item .time {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.agent-history-main .item .time-data {
  margin-right: calc(var(--space-token-cardinal) * 3);
  width: var(--time-width);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.agent-history-main .item .time-data.with-margin {
  margin-top: calc(var(--space-token-cardinal) * 5);
}

.agent-history-main .item .details .wrapup-reason-container {
  display: flex;
  align-items: center;
  width: 100%;
  font-size: var(--font-size-small);
}

.agent-history-main .item .details .wrapup-reason {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: var(--wrapup-reason-max-width);
  min-width: var(--wrapup-reason-min-width);
}

.agent-history-main .item .details .wrapup-reason-container .recent-icon {
  margin: 0px 8px;
}

.agent-history-main .item .details .wrapup-reason-container .wrapup-separater {
  margin-left: calc(var(--space-token-even) * 4);
}

.agent-history-main .item .time > md-icon {
  padding-right: 0.5rem;
}

.agent-history-main-no-scroll {
  overflow-y: hidden;
}

.loading-error {
  width: 100%;
  height: 100%;
  padding: calc(var(--space-token-cardinal) * 2);
  background-color: var(--md-secondary-bg-color);
  overflow-y: auto;
}

.loading-error .error-main {
  height: unset;
  top: unset;
}

.no-history {
  padding: calc(var(--space-token-cardinal) * 2);
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.no-history img {
  display: block;
  margin: auto;
}

.no-history p {
  color: var(--md-primary-text-color);
  text-align: center;
}

.agent-history-resizer {
  background: var(--md-nav-h-divider-primary);
  width: 100%;
  height: var(--agent-history-resizer-height);
  cursor: ns-resize;
}

.agent-history-resizer.active {
  background: var(--md-nav-h-divider-primary-hover);
}

.history-resizer-container {
  width: 100%;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: calc((var(--agent-history-resizer-height) + var(--history-dragger-height) - 2px) * -1);
}
.history-resizer-container md-grabber {
  height: var(--history-dragger-height);
  width: var(--history-dragger-width);
}

.history-resizer-container:hover .history-dragger,
.history-resizer-container:hover .agent-history-resizer {
  background: var(--md-nav-h-divider-primary-hover);
}

.history-loader {
  left: 50%;
  position: absolute;
  text-align: center;
  top: 45%;
  transform: var(--translate-50);
  color: var(--md-primary-text-color);
  background-color: var(--md-agent-history-bg-color);
}

.loading-text {
  font-family: var(--font-family);
  font-size: var(--font-size-medium);
  font-weight: var(--font-weight-bold);
  margin-top: calc(var(--space-token-even) * 3);
}

.agent-history-main .item .time-data .edit-button:hover {
  color: var(--color-blue-60);
}

.spinner-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.8;
  background-color: var(--md-secondary-white-bg-color);
}

.spinner-container md-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

@media (forced-colors: active) {
  .agent-history-main .item:focus {
    outline: 1px solid Highlight;
  }
  .agent-history-resizer {
    border-bottom: 1px solid CanvasText;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/variables.css","webpack://./src/direflow-components/ContactHistory/HandledByAgent/styles.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,mCAAA;EACA,mBAAA;EACA,sCAAA;EACA,wCAAA;EACA,8CAAA;EACA,uCAAA;EACA,yCAAA;EAEA,0BAAA;EAEA,wCAAA;EACA,0CAAA;EACA,6CAAA;EAEA,oCAAA;EAEA,WAAA;EACA,2FAAA;EACA,0DAAA;EACA,wDAAA;EACA,2DAAA;EACA,6BAAA;EACA,kCAAA;EAEA,yBAAA;EAEA,cAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;EAEA,mBAAA;EACA,2BAAA;EACA,uBAAA;EAEA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4CAAA;EAEA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EAEA,YAAA;EACA,4BAAA;EAEA,gBAAA;EACA,2DAAA;EACA,uBAAA;EAEA,gBAAA;EACA;;cAAA;EAGA;qHAAA;EAEA;kHAAA;EAGA,oDAAA;EAEA,WAAA;EACA,oBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,wBAAA;EAEA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,+BAAA;EACA,yBAAA;EACA,qBAAA;EACA,wBAAA;EACA,wBAAA;EACA,yBAAA;EACA,iCAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,qBAAA;EAEA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,uCAAA;EACA,0CAAA;EAEA,cAAA;EACA,qFAAA;EACA,oDAAA;EACA,qDAAA;EACA,iFAAA;EACA,mFAAA;EAEA,cAAA;EACA,mDAAA;EACA,mCAAA;EACA,iCAAA;EACA,gGAAA;EACA,kGAAA;EACA,0EAAA;EACA,sBAAA;ACjBF;;ADoBA,cAAA;AAEA;EACE;IACE,wBAAA;EClBF;EDoBA;IACE,4BAAA;EClBF;AACF;ADqBA;EACE;IACE,4BAAA;ECnBF;EDqBA;IACE,wBAAA;ECnBF;AACF;ADsBA;EACE;IACE,UAAA;ECpBF;EDsBA;IACE,UAAA;ECpBF;AACF;AA/IA;EACE,kCAAA;EACA,+BAAA;EACA,iCAAA;EACA,+BAAA;EACA,8BAAA;EACA,yDAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gCAAA;EACA,oCAAA;EACA,wBAAA;EACA,6BAAA;EACA,oCAAA;EACA,kEAAA;EACA,oDAAA;EACA,6BAAA;EACA,+BAAA;EACA,+BAAA;AAiJF;;AA9IA;EACE,oBAAA;AAiJF;;AA9IA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kDAAA;AAiJF;;AA9IA;;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAiJF;;AA9IA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAiJF;;AA9IA;EACE,yDAAA;AAiJF;;AA9IA;EACE,+BAAA;EACA,iCAAA;EACA,mCAAA;AAiJF;;AA9IA;EACE,SAAA;EACA,UAAA;EACA,qCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,wEAAA;AAiJF;AA/IE;EACE,wCAAA;AAiJJ;AA9IE;EACE,yCAAA;EACA,kDAAA;AAgJJ;;AA5IA;EACE,qBAAA;AA+IF;AA7IE;EACE,wCAAA;AA+IJ;AA5IE;EACE,yCAAA;EACA,kDAAA;AA8IJ;;AA1IA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mDAAA;AA6IF;;AA3IA;EACE,aAAA;EACA,0CAAA;AA8IF;;AA3IA;EACE,aAAA;EACA,sCAAA;AA8IF;;AA3IA;EACE,wCAAA;EACA,yCAAA;EACA,6CAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA8IF;;AA3IA;EACE,8CAAA;EACA,OAAA;EACA,4FAAA;EACA,aAAA;EACA,sBAAA;AA8IF;;AA5IA;EACE,mCAAA;AA+IF;;AA5IA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;AA+IF;;AA5IA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AA+IF;;AA5IA;EACE,mDAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AA+IF;;AA5IA;EACE,iDAAA;AA+IF;;AA5IA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iCAAA;AA+IF;;AA5IA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yCAAA;EACA,yCAAA;AA+IF;;AA5IA;EACE,eAAA;AA+IF;;AA7IA;EACE,8CAAA;AAgJF;;AA7IA;EACE,qBAAA;AAgJF;;AA7IA;EACE,kBAAA;AAgJF;;AA7IA;EACE,WAAA;EACA,YAAA;EACA,8CAAA;EACA,8CAAA;EACA,gBAAA;AAgJF;;AA7IA;EACE,aAAA;EACA,UAAA;AAgJF;;AA7IA;EACE,8CAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AAgJF;;AA7IA;EACE,cAAA;EACA,YAAA;AAgJF;;AA7IA;EACE,mCAAA;EACA,kBAAA;AAgJF;;AA7IA;EACE,2CAAA;EACA,WAAA;EACA,2CAAA;EACA,iBAAA;AAgJF;;AA7IA;EACE,iDAAA;AAgJF;;AA7IA;EACE,WAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2FAAA;AAgJF;AA9IE;EACE,qCAAA;EACA,mCAAA;AAgJJ;;AA5IA;;EAEE,iDAAA;AA+IF;;AA5IA;EACE,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,8BAAA;EACA,mCAAA;EACA,kDAAA;AA+IF;;AA5IA;EACE,+BAAA;EACA,kCAAA;EACA,oCAAA;EACA,6CAAA;AA+IF;;AA5IA;EACE,2BAAA;AA+IF;;AA5IA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,oDAAA;AA+IF;;AA5IA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA+IF;;AA5IA;EACE;IACE,4BAAA;EA+IF;EA7IA;IAEE,mCAAA;EA8IF;AACF","sourcesContent":["* {\n  /* Light & Dark Defaults */\n  --sandbox-bg-color-default: #e5e5e5;\n  --border-width: 1px;\n  --md-primary-bg-color-default: #ffffff;\n  --md-secondary-bg-color-default: #f7f7f7;\n  --md-secondary-white-bg-color-default: #ffffff;\n  --md-tertiary-bg-color-default: #ededed;\n  --md-quaternary-bg-color-default: #dedede;\n\n  --defult-button-size: 36px;\n\n  --md-primary-text-color-default: #121212;\n  --md-secondary-text-color-default: #545454;\n  --md-primary-seperator-color-default: #cccccc;\n\n  --md-alert-warning-bg-color: #ffecc2;\n\n  /* Border */\n  --border: 1px solid var(--md-primary-seperator-color, --md-primary-seperator-color-default);\n  --blue-border: var(--border-width) solid var(--link-color);\n  --red-border: var(--border-width) solid var(--red-color);\n  --interaction-border-bottom: 8px solid var(--gray-30-color);\n  --email-chat-min-width: 600px;\n  --interaction-control-height: 67px;\n\n  --top-header-height: 65px;\n\n  /* Font size */\n  --font-size-xlarge: 20px;\n  --font-size-large: 16px;\n  --font-size-medium: 14px;\n  --font-size-small: 12px;\n  --font-size-xsmall: 10px;\n\n  /* Spacing tokens */\n  --space-token-cardinal: 5px;\n  --space-token-even: 2px;\n\n  /* Padding */\n  --padding-16: 16px;\n  --padding-14: 14px;\n  --padding-12: 12px;\n  --padding-10: 10px;\n  --padding-8: 8px;\n  --padding-3: 3px;\n  --padding-2: 2px;\n  --conference-button-padding: 4px 8px 4px 4px;\n\n  /* Cardinal variables */\n  --left-spacing-16: 16px;\n  --left-spacing-40: 40px;\n  --margin-8: 8px;\n  --margin-375rem: 0.375rem;\n\n  /* Flexbox */\n  --flex-only-two-columns: 50%;\n\n  /* Font Weight */\n  --font-weight-normal: var(--brand-font-weight-regular, 400);\n  --font-weight-bold: 600;\n\n  /* Font family */\n  --font-family:\n    var(--brand-font-regular, \"CiscoSansTT Regular\"), \"CiscoSansTT Regular\", \"Helvetica Neue\", Helvetica, Arial,\n    sans-serif;\n  --font-family-light:\n    var(--brand-font-light, \"CiscoSansTT Light\"), \"CiscoSansTT Light\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  --font-family-bold:\n    var(--brand-font-bold, \"CiscoSansTT Bold\"), \"CiscoSansTT Bold\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n  --font-family-icons: \"momentum-ui-icons\", sans-serif;\n\n  /* Colors */\n  --red-color: #ff5c4a;\n  --orange-color: #d67f04;\n  --red-60-color: #d93829;\n  --red-70-color: #a12512;\n  --red-20-color: #ffe1d9;\n  --white-color: #fff;\n  --black-color: #000;\n  --blue-20-color: #b8f2ff;\n  --blue-40-color: #07c1f5;\n  --link-color: #00a0d1;\n  --grey-border: #f2f2f2;\n  --grey-color: #d2d5d6;\n  --green-color: #24ab31;\n  --green-05-color: #edfaf4;\n  --green-10-color: #befade;\n  --green-20-color: #bcf7bf;\n  --green-30-color: #31e88c;\n  --gray-100-color: #171b1f;\n  --gray-80-color: #3b3b3b;\n\n  --gray-70-color: #535759;\n  --gray-30-color: #d2d5d6;\n  --gray-20-color: #f7f7f7;\n  --gray-10-color: #f2f4f5;\n  --background-color: transparent;\n  --slate-60-color: #6f739e;\n  --sub-header: #535759;\n  --blue-05-color: #e6fbff;\n  --blue-70-color: #005e7d;\n  --brand-60-color: #007ea8;\n  --disabled-lightui-color: #ededed;\n  --disabled-text-color: #b2b2b2;\n  --highlight-color: #737678;\n  --violet-20-color: #f0e3fc;\n  --yellow-20-color: #ffe6b3;\n  --light-green-color: #44cf50;\n  --dark-green-color: #03612c;\n  --disabled-color: #e6e7e7;\n  --red-30-color: #ffc7ba;\n  --gold-color: #7d4705;\n\n  /* Border radius */\n  --border-radius-small: 4px;\n  --border-radius-medium: 8px;\n  --border-radius-large: 10px;\n  --border-radius-medium-top: 8px 8px 0 0;\n  --border-radius-medium-bottom: 0 0 8px 8px;\n\n  /* Box shadow*/\n  --common-box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.18), 0px 2px 4px rgba(0, 0, 0, 0.16);\n  --simple-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);\n  --focused-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);\n  --focused-momentum-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3);\n  --focused-list-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3) inset;\n\n  /* Animation */\n  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);\n  --default-animation-duration: 300ms;\n  --quick-animation-duration: 150ms;\n  --animation-slideIn: slideIn var(--default-animation-duration) var(--ease-in-out-quint) forwards;\n  --animation-slideOut: slideOut var(--default-animation-duration) var(--ease-in-out-quint) forwards;\n  --animation-fadeIn: fadeIn var(--quick-animation-duration) linear forwards;\n  box-sizing: border-box;\n}\n\n/* Animation */\n\n@keyframes slideIn {\n  from {\n    transform: translatex(0);\n  }\n  to {\n    transform: translatex(-100%);\n  }\n}\n\n@keyframes slideOut {\n  from {\n    transform: translatex(-100%);\n  }\n  to {\n    transform: translatex(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n","@use \"../../../css/variables.css\" as *;\n\n.agent-history * {\n  --item-social-icon-dimension: 2rem;\n  --item-social-icon-left: 1.1rem;\n  --item-social-icon-top: 0.9375rem;\n  --item-social-pad-bot: 0.625rem;\n  --error-icon-mar-bot: 1.563rem;\n  --selected-tab-bottom-border: 3px solid var(--link-color);\n  --media-icon-height: 32px;\n  --time-width: 70px;\n  --badge-width: 40px;\n  --tab-height: 40px;\n  --tab-header-height: 48px;\n  --tab-title-margin: 1rem 0.75rem;\n  --tab-title-height: calc(1rem / 0.6);\n  --color-blue-60: #007aa3;\n  --dragger-border-radius: 16px;\n  --history-illustration-height: 151px;\n  --agent-history-resizer-height: var(--history-divider-height, 2px);\n  --history-dragger-height: var(--grabber-width, 12px);\n  --history-dragger-width: 42px;\n  --wrapup-reason-max-width: 88px;\n  --wrapup-reason-min-width: 36px;\n}\n\n.disable-element {\n  pointer-events: none;\n}\n\n.agent-history {\n  overflow: visible;\n  height: 100%;\n  position: relative;\n  min-height: 52px;\n  max-height: 75vh;\n  background-color: var(--md-agent-history-bg-color);\n}\n\n.agent-history md-tabs::part(tabs-list),\n.agent-history.new-momentum md-tabs::part(tabs-list) {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n\n.agent-history.new-momentum md-tabs::part(tabs-list) {\n  margin-top: 12px;\n  padding-left: 16px;\n  padding-right: 16px;\n  margin-bottom: 8px;\n}\n\n.agent-history md-tabs::part(tabs-content) {\n  max-height: calc(100% - calc(var(--tab-header-height) + 1px));\n}\n\n.agent-history-title {\n  margin: var(--tab-title-margin);\n  font-size: var(--font-size-large);\n  color: var(--md-primary-text-color);\n}\n\n.agent-history-main {\n  margin: 0;\n  padding: 0;\n  color: var(--md-secondary-text-color);\n  height: 100%;\n  overflow: hidden;\n  overflow-y: scroll;\n  scrollbar-width: thin;\n  background-color: var(--md-agent-history-bg-color, var(--gray-20-color));\n\n  &::-webkit-scrollbar {\n    width: calc(var(--space-token-even) * 4);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: var(--border-radius-large);\n    background-color: var(--md-presence-away-bg-color);\n  }\n}\n\n.agent-history-main > div {\n  scrollbar-width: thin;\n\n  &::-webkit-scrollbar {\n    width: calc(var(--space-token-even) * 4);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: var(--border-radius-large);\n    background-color: var(--md-presence-away-bg-color);\n  }\n}\n\n.agent-history-main .item {\n  width: 99% !important;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  list-style: none;\n  font-size: var(--font-size-medium);\n  overflow: hidden;\n  margin: 4px 2px 2px 2px;\n  padding-left: calc(var(--space-token-cardinal) * 2);\n}\n.agent-history-main .item:focus {\n  outline: none;\n  box-shadow: var(--focused-momentum-shadow);\n}\n\n.aih-list-container:focus {\n  outline: none;\n  box-shadow: var(--focused-list-shadow);\n}\n\n.agent-history-main .item > .icon {\n  width: var(--item-social-icon-dimension);\n  height: var(--item-social-icon-dimension);\n  background: var(--md-primary-bg-color, white);\n  color: var(--black-color);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 2px;\n}\n\n.agent-history-main .item .details {\n  padding: calc(var(--space-token-cardinal) * 2);\n  flex: 1;\n  width: calc(100% - var(--time-width) - calc(var(--space-token-cardinal) * 2) - var(--badge-width));\n  display: flex;\n  flex-direction: column;\n}\n.agent-history-main .item .details div:first-of-type {\n  color: var(--md-primary-text-color);\n}\n\n.agent-history-main .item .details div {\n  white-space: nowrap;\n  overflow: hidden;\n  width: calc(100%);\n  text-overflow: ellipsis;\n}\n\n.agent-history-main .item .time {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.agent-history-main .item .time-data {\n  margin-right: calc(var(--space-token-cardinal) * 3);\n  width: var(--time-width);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.agent-history-main .item .time-data.with-margin {\n  margin-top: calc(var(--space-token-cardinal) * 5);\n}\n\n.agent-history-main .item .details .wrapup-reason-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  font-size: var(--font-size-small);\n}\n\n.agent-history-main .item .details .wrapup-reason {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: var(--wrapup-reason-max-width);\n  min-width: var(--wrapup-reason-min-width);\n}\n\n.agent-history-main .item .details .wrapup-reason-container .recent-icon {\n  margin: 0px 8px;\n}\n.agent-history-main .item .details .wrapup-reason-container .wrapup-separater {\n  margin-left: calc(var(--space-token-even) * 4);\n}\n\n.agent-history-main .item .time > md-icon {\n  padding-right: 0.5rem;\n}\n\n.agent-history-main-no-scroll {\n  overflow-y: hidden;\n}\n\n.loading-error {\n  width: 100%;\n  height: 100%;\n  padding: calc(var(--space-token-cardinal) * 2);\n  background-color: var(--md-secondary-bg-color);\n  overflow-y: auto;\n}\n\n.loading-error .error-main {\n  height: unset;\n  top: unset;\n}\n\n.no-history {\n  padding: calc(var(--space-token-cardinal) * 2);\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.no-history img {\n  display: block;\n  margin: auto;\n}\n\n.no-history p {\n  color: var(--md-primary-text-color);\n  text-align: center;\n}\n\n.agent-history-resizer {\n  background: var(--md-nav-h-divider-primary);\n  width: 100%;\n  height: var(--agent-history-resizer-height);\n  cursor: ns-resize;\n}\n\n.agent-history-resizer.active {\n  background: var(--md-nav-h-divider-primary-hover);\n}\n\n.history-resizer-container {\n  width: 100%;\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  top: calc((var(--agent-history-resizer-height) + var(--history-dragger-height) - 2px) * -1);\n\n  md-grabber {\n    height: var(--history-dragger-height);\n    width: var(--history-dragger-width);\n  }\n}\n\n.history-resizer-container:hover .history-dragger,\n.history-resizer-container:hover .agent-history-resizer {\n  background: var(--md-nav-h-divider-primary-hover);\n}\n\n.history-loader {\n  left: 50%;\n  position: absolute;\n  text-align: center;\n  top: 45%;\n  transform: var(--translate-50);\n  color: var(--md-primary-text-color);\n  background-color: var(--md-agent-history-bg-color);\n}\n\n.loading-text {\n  font-family: var(--font-family);\n  font-size: var(--font-size-medium);\n  font-weight: var(--font-weight-bold);\n  margin-top: calc(var(--space-token-even) * 3);\n}\n\n.agent-history-main .item .time-data .edit-button:hover {\n  color: var(--color-blue-60);\n}\n\n.spinner-container {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0.8;\n  background-color: var(--md-secondary-white-bg-color);\n}\n\n.spinner-container md-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n@media (forced-colors: active) {\n  .agent-history-main .item:focus {\n    outline: 1px solid Highlight;\n  }\n  .agent-history-resizer {\n    // horizontal divider line in agent history resizer\n    border-bottom: 1px solid CanvasText;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../agentx-services/dist/styles/z-index.css":
/*!********************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!../agentx-services/dist/styles/z-index.css ***!
  \********************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;

  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;

  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;

  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;

  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;

  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}
`, "",{"version":3,"sources":["webpack://./../agentx-services/dist/styles/z-index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;;EAE3B,+BAA+B;EAC/B,yBAAyB;EACzB,kCAAkC;;EAElC,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,+BAA+B;;EAE/B,oCAAoC;EACpC,2BAA2B;;EAE3B,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;;EAEvB;gHAC8G;EAC9G,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;AACjC","sourcesContent":["* {\n  /* BASE LEVEL < 100 */\n  --z-index-negative: -1;\n  --z-index-base: 0;\n  --z-overflow-scroll-button: 1;\n  --z-index-expand-collapse: 2;\n  --z-index-maximize-block: 3;\n\n  --z-index-task-collapse-area: 7;\n  --z-index-menu-overlay: 8;\n  --z-index-dynamic-area-overflow: 9;\n\n  --z-navigation-bar: 12;\n  --z-index-task-list: 12;\n  --z-index-wrap-up: 13;\n  --z-index-sticky-header: 14;\n  --z-index-shortcutkey-modal: 15;\n\n  /* MID LEVEL FLOATING > 100 < 1000 */\n  --z-index-notification: 150;\n\n  /* SUPER LEVEL > 1000 */\n  --z-index-modal: 1040;\n  --z-index-popover: 1041;\n\n  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,\n         followed by error modal since error can occur during app load such as teams failure/register failure. */\n  --z-index-app-full-overlay: 1050;\n  --z-index-modal-error: 1100;\n  --z-index-connection-lost: 1200;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/css/common.css":
/*!**********************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/css/common.css ***!
  \**********************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../node_modules/css-loader/dist/cjs.js!./variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.hidden-overflow {
  overflow: hidden;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/css/common.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["@import \"variables.css\";\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.hidden-overflow {\n  overflow: hidden;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css":
/*!*************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css ***!
  \*************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  /* Light & Dark Defaults */
  --sandbox-bg-color-default: #e5e5e5;
  --border-width: 1px;
  --md-primary-bg-color-default: #ffffff;
  --md-secondary-bg-color-default: #f7f7f7;
  --md-secondary-white-bg-color-default: #ffffff;
  --md-tertiary-bg-color-default: #ededed;
  --md-quaternary-bg-color-default: #dedede;

  --defult-button-size: 36px;

  --md-primary-text-color-default: #121212;
  --md-secondary-text-color-default: #545454;
  --md-primary-seperator-color-default: #cccccc;

  --md-alert-warning-bg-color: #ffecc2;

  /* Border */
  --border: 1px solid var(--md-primary-seperator-color, --md-primary-seperator-color-default);
  --blue-border: var(--border-width) solid var(--link-color);
  --red-border: var(--border-width) solid var(--red-color);
  --interaction-border-bottom: 8px solid var(--gray-30-color);
  --email-chat-min-width: 600px;
  --interaction-control-height: 67px;

  --top-header-height: 65px;

  /* Font size */
  --font-size-xlarge: 20px;
  --font-size-large: 16px;
  --font-size-medium: 14px;
  --font-size-small: 12px;
  --font-size-xsmall: 10px;

  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;

  /* Padding */
  --padding-16: 16px;
  --padding-14: 14px;
  --padding-12: 12px;
  --padding-10: 10px;
  --padding-8: 8px;
  --padding-3: 3px;
  --padding-2: 2px;
  --conference-button-padding: 4px 8px 4px 4px;

  /* Cardinal variables */
  --left-spacing-16: 16px;
  --left-spacing-40: 40px;
  --margin-8: 8px;
  --margin-375rem: 0.375rem;

  /* Flexbox */
  --flex-only-two-columns: 50%;

  /* Font Weight */
  --font-weight-normal: var(--brand-font-weight-regular, 400);
  --font-weight-bold: 600;

  /* Font family */
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light:
    var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-bold:
    var(--brand-font-bold, "CiscoSansTT Bold"), "CiscoSansTT Bold", "Helvetica Neue", Helvetica, Arial, sans-serif;

  --font-family-icons: "momentum-ui-icons", sans-serif;

  /* Colors */
  --red-color: #ff5c4a;
  --orange-color: #d67f04;
  --red-60-color: #d93829;
  --red-70-color: #a12512;
  --red-20-color: #ffe1d9;
  --white-color: #fff;
  --black-color: #000;
  --blue-20-color: #b8f2ff;
  --blue-40-color: #07c1f5;
  --link-color: #00a0d1;
  --grey-border: #f2f2f2;
  --grey-color: #d2d5d6;
  --green-color: #24ab31;
  --green-05-color: #edfaf4;
  --green-10-color: #befade;
  --green-20-color: #bcf7bf;
  --green-30-color: #31e88c;
  --gray-100-color: #171b1f;
  --gray-80-color: #3b3b3b;

  --gray-70-color: #535759;
  --gray-30-color: #d2d5d6;
  --gray-20-color: #f7f7f7;
  --gray-10-color: #f2f4f5;
  --background-color: transparent;
  --slate-60-color: #6f739e;
  --sub-header: #535759;
  --blue-05-color: #e6fbff;
  --blue-70-color: #005e7d;
  --brand-60-color: #007ea8;
  --disabled-lightui-color: #ededed;
  --disabled-text-color: #b2b2b2;
  --highlight-color: #737678;
  --violet-20-color: #f0e3fc;
  --yellow-20-color: #ffe6b3;
  --light-green-color: #44cf50;
  --dark-green-color: #03612c;
  --disabled-color: #e6e7e7;
  --red-30-color: #ffc7ba;
  --gold-color: #7d4705;

  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 10px;
  --border-radius-medium-top: 8px 8px 0 0;
  --border-radius-medium-bottom: 0 0 8px 8px;

  /* Box shadow*/
  --common-box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.18), 0px 2px 4px rgba(0, 0, 0, 0.16);
  --simple-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
  --focused-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --focused-momentum-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3);
  --focused-list-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3) inset;

  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  --animation-slideIn: slideIn var(--default-animation-duration) var(--ease-in-out-quint) forwards;
  --animation-slideOut: slideOut var(--default-animation-duration) var(--ease-in-out-quint) forwards;
  --animation-fadeIn: fadeIn var(--quick-animation-duration) linear forwards;
  box-sizing: border-box;
}

/* Animation */

@keyframes slideIn {
  from {
    transform: translatex(0);
  }
  to {
    transform: translatex(-100%);
  }
}

@keyframes slideOut {
  from {
    transform: translatex(-100%);
  }
  to {
    transform: translatex(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/variables.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,mBAAmB;EACnB,sCAAsC;EACtC,wCAAwC;EACxC,8CAA8C;EAC9C,uCAAuC;EACvC,yCAAyC;;EAEzC,0BAA0B;;EAE1B,wCAAwC;EACxC,0CAA0C;EAC1C,6CAA6C;;EAE7C,oCAAoC;;EAEpC,WAAW;EACX,2FAA2F;EAC3F,0DAA0D;EAC1D,wDAAwD;EACxD,2DAA2D;EAC3D,6BAA6B;EAC7B,kCAAkC;;EAElC,yBAAyB;;EAEzB,cAAc;EACd,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;;EAExB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;;EAEvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;;EAE5C,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;;EAEzB,YAAY;EACZ,4BAA4B;;EAE5B,gBAAgB;EAChB,2DAA2D;EAC3D,uBAAuB;;EAEvB,gBAAgB;EAChB;;cAEY;EACZ;qHACmH;EACnH;kHACgH;;EAEhH,oDAAoD;;EAEpD,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;;EAExB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;;EAErB,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,uCAAuC;EACvC,0CAA0C;;EAE1C,cAAc;EACd,qFAAqF;EACrF,oDAAoD;EACpD,qDAAqD;EACrD,iFAAiF;EACjF,mFAAmF;;EAEnF,cAAc;EACd,mDAAmD;EACnD,mCAAmC;EACnC,iCAAiC;EACjC,gGAAgG;EAChG,kGAAkG;EAClG,0EAA0E;EAC1E,sBAAsB;AACxB;;AAEA,cAAc;;AAEd;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["* {\n  /* Light & Dark Defaults */\n  --sandbox-bg-color-default: #e5e5e5;\n  --border-width: 1px;\n  --md-primary-bg-color-default: #ffffff;\n  --md-secondary-bg-color-default: #f7f7f7;\n  --md-secondary-white-bg-color-default: #ffffff;\n  --md-tertiary-bg-color-default: #ededed;\n  --md-quaternary-bg-color-default: #dedede;\n\n  --defult-button-size: 36px;\n\n  --md-primary-text-color-default: #121212;\n  --md-secondary-text-color-default: #545454;\n  --md-primary-seperator-color-default: #cccccc;\n\n  --md-alert-warning-bg-color: #ffecc2;\n\n  /* Border */\n  --border: 1px solid var(--md-primary-seperator-color, --md-primary-seperator-color-default);\n  --blue-border: var(--border-width) solid var(--link-color);\n  --red-border: var(--border-width) solid var(--red-color);\n  --interaction-border-bottom: 8px solid var(--gray-30-color);\n  --email-chat-min-width: 600px;\n  --interaction-control-height: 67px;\n\n  --top-header-height: 65px;\n\n  /* Font size */\n  --font-size-xlarge: 20px;\n  --font-size-large: 16px;\n  --font-size-medium: 14px;\n  --font-size-small: 12px;\n  --font-size-xsmall: 10px;\n\n  /* Spacing tokens */\n  --space-token-cardinal: 5px;\n  --space-token-even: 2px;\n\n  /* Padding */\n  --padding-16: 16px;\n  --padding-14: 14px;\n  --padding-12: 12px;\n  --padding-10: 10px;\n  --padding-8: 8px;\n  --padding-3: 3px;\n  --padding-2: 2px;\n  --conference-button-padding: 4px 8px 4px 4px;\n\n  /* Cardinal variables */\n  --left-spacing-16: 16px;\n  --left-spacing-40: 40px;\n  --margin-8: 8px;\n  --margin-375rem: 0.375rem;\n\n  /* Flexbox */\n  --flex-only-two-columns: 50%;\n\n  /* Font Weight */\n  --font-weight-normal: var(--brand-font-weight-regular, 400);\n  --font-weight-bold: 600;\n\n  /* Font family */\n  --font-family:\n    var(--brand-font-regular, \"CiscoSansTT Regular\"), \"CiscoSansTT Regular\", \"Helvetica Neue\", Helvetica, Arial,\n    sans-serif;\n  --font-family-light:\n    var(--brand-font-light, \"CiscoSansTT Light\"), \"CiscoSansTT Light\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  --font-family-bold:\n    var(--brand-font-bold, \"CiscoSansTT Bold\"), \"CiscoSansTT Bold\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n  --font-family-icons: \"momentum-ui-icons\", sans-serif;\n\n  /* Colors */\n  --red-color: #ff5c4a;\n  --orange-color: #d67f04;\n  --red-60-color: #d93829;\n  --red-70-color: #a12512;\n  --red-20-color: #ffe1d9;\n  --white-color: #fff;\n  --black-color: #000;\n  --blue-20-color: #b8f2ff;\n  --blue-40-color: #07c1f5;\n  --link-color: #00a0d1;\n  --grey-border: #f2f2f2;\n  --grey-color: #d2d5d6;\n  --green-color: #24ab31;\n  --green-05-color: #edfaf4;\n  --green-10-color: #befade;\n  --green-20-color: #bcf7bf;\n  --green-30-color: #31e88c;\n  --gray-100-color: #171b1f;\n  --gray-80-color: #3b3b3b;\n\n  --gray-70-color: #535759;\n  --gray-30-color: #d2d5d6;\n  --gray-20-color: #f7f7f7;\n  --gray-10-color: #f2f4f5;\n  --background-color: transparent;\n  --slate-60-color: #6f739e;\n  --sub-header: #535759;\n  --blue-05-color: #e6fbff;\n  --blue-70-color: #005e7d;\n  --brand-60-color: #007ea8;\n  --disabled-lightui-color: #ededed;\n  --disabled-text-color: #b2b2b2;\n  --highlight-color: #737678;\n  --violet-20-color: #f0e3fc;\n  --yellow-20-color: #ffe6b3;\n  --light-green-color: #44cf50;\n  --dark-green-color: #03612c;\n  --disabled-color: #e6e7e7;\n  --red-30-color: #ffc7ba;\n  --gold-color: #7d4705;\n\n  /* Border radius */\n  --border-radius-small: 4px;\n  --border-radius-medium: 8px;\n  --border-radius-large: 10px;\n  --border-radius-medium-top: 8px 8px 0 0;\n  --border-radius-medium-bottom: 0 0 8px 8px;\n\n  /* Box shadow*/\n  --common-box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.18), 0px 2px 4px rgba(0, 0, 0, 0.16);\n  --simple-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);\n  --focused-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);\n  --focused-momentum-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3);\n  --focused-list-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3) inset;\n\n  /* Animation */\n  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);\n  --default-animation-duration: 300ms;\n  --quick-animation-duration: 150ms;\n  --animation-slideIn: slideIn var(--default-animation-duration) var(--ease-in-out-quint) forwards;\n  --animation-slideOut: slideOut var(--default-animation-duration) var(--ease-in-out-quint) forwards;\n  --animation-fadeIn: fadeIn var(--quick-animation-duration) linear forwards;\n  box-sizing: border-box;\n}\n\n/* Animation */\n\n@keyframes slideIn {\n  from {\n    transform: translatex(0);\n  }\n  to {\n    transform: translatex(-100%);\n  }\n}\n\n@keyframes slideOut {\n  from {\n    transform: translatex(-100%);\n  }\n  to {\n    transform: translatex(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AddressBookIncreasedLimit/components/OrgDetails/OrgDetails.css":
/*!******************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AddressBookIncreasedLimit/components/OrgDetails/OrgDetails.css ***!
  \******************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_agentx_services_dist_styles_z_index_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! -!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../agentx-services/dist/styles/z-index.css */ "../../node_modules/css-loader/dist/cjs.js!../agentx-services/dist/styles/z-index.css");
// Imports




var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_agentx_services_dist_styles_z_index_css__WEBPACK_IMPORTED_MODULE_3__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  width: 306px;
  border-radius: var(--border-radius-small);
  display: block;
}

.card-header {
  border-bottom: var(--border-width) solid var(--md-quaternary-bg-color);
  display: flex;
  width: 100%;
  height: 56px;
}

.card-header-avatar {
  padding: var(--padding-10) 0 var(--padding-14) var(--padding-10);
}

.card-header-title {
  padding: 0 0 var(--padding-10) var(--padding-14);
}

.card-name {
  font-weight: var(--font-weight-bold);
  margin: var(--space-token-cardinal) 0 0 0;
}

.card-status {
  margin: 0;
  color: var(--md-secondary-text-color);
}

.details {
  padding: var(--space-token-cardinal) 10px;
}

.field {
  display: flex;
  width: 286px;
}

.field-key,
.field-value {
  font-size: var(--font-size-small);
  flex: 1;
}

.field-key {
  color: var(--md-secondary-text-color);
}

.field-value {
  float: right;
}

.span-ellipses {
  display: block;
  width: 175px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/AddressBookIncreasedLimit/components/OrgDetails/OrgDetails.css"],"names":[],"mappings":"AAGA;EACE,YAAY;EACZ,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,sEAAsE;EACtE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,iCAAiC;EACjC,OAAO;AACT;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["@import \"../../../../css/variables.css\";\n@import \"~@agentx/agentx-services/dist/styles/z-index.css\";\n\n.card {\n  width: 306px;\n  border-radius: var(--border-radius-small);\n  display: block;\n}\n\n.card-header {\n  border-bottom: var(--border-width) solid var(--md-quaternary-bg-color);\n  display: flex;\n  width: 100%;\n  height: 56px;\n}\n\n.card-header-avatar {\n  padding: var(--padding-10) 0 var(--padding-14) var(--padding-10);\n}\n\n.card-header-title {\n  padding: 0 0 var(--padding-10) var(--padding-14);\n}\n\n.card-name {\n  font-weight: var(--font-weight-bold);\n  margin: var(--space-token-cardinal) 0 0 0;\n}\n\n.card-status {\n  margin: 0;\n  color: var(--md-secondary-text-color);\n}\n\n.details {\n  padding: var(--space-token-cardinal) 10px;\n}\n\n.field {\n  display: flex;\n  width: 286px;\n}\n\n.field-key,\n.field-value {\n  font-size: var(--font-size-small);\n  flex: 1;\n}\n\n.field-key {\n  color: var(--md-secondary-text-color);\n}\n\n.field-value {\n  float: right;\n}\n\n.span-ellipses {\n  display: block;\n  width: 175px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/WebexContactCard.css":
/*!******************************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/WebexContactCard.css ***!
  \******************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_agentx_services_dist_styles_z_index_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! -!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../agentx-services/dist/styles/z-index.css */ "../../node_modules/css-loader/dist/cjs.js!../agentx-services/dist/styles/z-index.css");
// Imports




var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_agentx_services_dist_styles_z_index_css__WEBPACK_IMPORTED_MODULE_3__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  width: 306px;
  border-radius: var(--border-radius-small);
  display: block;
}

.card-header {
  border-bottom: var(--border-width) solid var(--md-quaternary-bg-color);
  font-family: var(--font-family);
  padding-top: 4px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 82px;
}

.card-header-avatar {
  padding: var(--padding-10) 0 var(--padding-14) var(--padding-10);
}

.card-header-title {
  padding: 0 0 var(--padding-10) var(--padding-14);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.card-name {
  font-weight: var(--font-weight-bold);
  margin: var(--space-token-cardinal) 0 0 0;
}

.card-status,
.card-custom-status {
  margin: 0;
  color: var(--md-secondary-text-color);
}

.details {
  padding: var(--space-token-cardinal) 10px;
  font-family: var(--font-family);
}

.field {
  display: flex;
  width: 286px;
  padding-top: 3px;
  padding-bottom: 3px;
}

.field-key,
.field-value {
  font-size: var(--font-size-small);
  flex: 1;
}

.field-key {
  color: var(--md-secondary-text-color);
}

.field-value {
  float: right;
}

.ellipses {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.span-ellipses {
  width: 175px;
}

.header-ellipses {
  width: 230px;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/WebexContactCard.css"],"names":[],"mappings":"AAGA;EACE,YAAY;EACZ,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,sEAAsE;EACtE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;;EAEE,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,OAAO;AACT;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["@import \"../../../../css/variables.css\";\n@import \"~@agentx/agentx-services/dist/styles/z-index.css\";\n\n.card {\n  width: 306px;\n  border-radius: var(--border-radius-small);\n  display: block;\n}\n\n.card-header {\n  border-bottom: var(--border-width) solid var(--md-quaternary-bg-color);\n  font-family: var(--font-family);\n  padding-top: 4px;\n  padding-left: 10px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 82px;\n}\n\n.card-header-avatar {\n  padding: var(--padding-10) 0 var(--padding-14) var(--padding-10);\n}\n\n.card-header-title {\n  padding: 0 0 var(--padding-10) var(--padding-14);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.card-name {\n  font-weight: var(--font-weight-bold);\n  margin: var(--space-token-cardinal) 0 0 0;\n}\n\n.card-status,\n.card-custom-status {\n  margin: 0;\n  color: var(--md-secondary-text-color);\n}\n\n.details {\n  padding: var(--space-token-cardinal) 10px;\n  font-family: var(--font-family);\n}\n\n.field {\n  display: flex;\n  width: 286px;\n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n\n.field-key,\n.field-value {\n  font-size: var(--font-size-small);\n  flex: 1;\n}\n\n.field-key {\n  color: var(--md-secondary-text-color);\n}\n\n.field-value {\n  float: right;\n}\n\n.ellipses {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.span-ellipses {\n  width: 175px;\n}\n\n.header-ellipses {\n  width: 230px;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AddressBookIncreasedLimit/styles.css":
/*!****************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AddressBookIncreasedLimit/styles.css ***!
  \****************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../node_modules/css-loader/dist/cjs.js!../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.address-book-increased-limit-list:not(.set-focus-visible):focus {
  border: none;
  outline: none;
}
.address-book-increased-limit-list:not(.set-focus-visible):focus-visible {
  border: none;
  outline: none;
}

.address-book-increased-limit-list .address-book-increased-limit-list-item {
  padding-left: 15px !important;
}
.address-book-increased-limit-list .address-book-increased-limit-list-item:hover {
  background-color: var(--list-hover-background, #c9f4ff);
}
.address-book-increased-limit-list .address-book-increased-limit-list-item.hovered {
  outline: none;
  box-shadow: var(--focused-list-shadow);
}

.address-book-increased-limit .address-book-increased-limit-list-item.selected {
  background-color: var(--list-active-background, #c9f4ff);
}

.address-book-increased-limit .address-book-increased-limit-list-item.selected.hovered {
  outline: none;
}

.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-name {
  color: var(--list-active-text-color);
}

.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-dn {
  color: var(--list-active-text-color);
}

.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-name {
  color: var(--list-hover-text-color);
}

.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-dn {
  color: var(--list-hover-text-color);
}

.address-book-increased-limit .address-list-error {
  text-align: center;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.address-book-increased-limit .address-list-error .address-list-error__illustrations {
  width: 84px;
  margin: auto;
}

.address-book-increased-limit .address-list-error .address-list-error__header {
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  margin-top: 24px;
  margin-bottom: 0;
}

.address-book-increased-limit .address-list-error .address-list-error__sub-header {
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 0;
  margin-top: 0;
}

.address-book-increased-limit .address-list-error .address-list-error__button {
  margin-top: 24px;
}

.address-book-increased-limit .address-book-increased-limit__loading {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  margin: auto;
}

.address-book-increased-limit {
  width: 100%;
  height: 100%;
}

.address-book-increased-limit.address-book-loading-error {
  display: flex;
  align-items: center;
}

.address-book-increased-limit > div.no-record {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(var(--space-token-cardinal) * 2);
  position: relative;
  text-align: center;
}

.no-record-found {
  position: relative;
  top: 11px;
}
.address-book-increased-limit .search-error {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-small);
}
.address-book-increased-limit .search-block-error {
  display: flex;
  align-items: center;
  padding: var(--padding-16);
  justify-content: center;
}

@media (forced-colors: active) {
  /* //outdial contact list */
  .address-book-increased-limit-list .address-book-increased-limit-list-item {
    forced-color-adjust: none;
    background-color: Canvas !important;
    color: CanvasText !important;
    box-shadow: none;
    outline-offset: -1px;
  }

  .address-book-increased-limit-list .address-book-increased-limit-list-item > .address-list-item-detail > .address-dn {
    forced-color-adjust: none;
    background-color: Canvas !important;
    color: CanvasText !important;
    box-shadow: none;
  }
  .address-book-increased-limit .address-book-increased-limit-list-item.selected {
    forced-color-adjust: none;
    background-color: Highlight !important;
    color: Canvas !important;
    box-shadow: none;
  }

  .address-book-increased-limit
    .address-book-increased-limit-list-item.selected
    > .address-list-item-detail
    > .address-dn {
    forced-color-adjust: none;
    background-color: Highlight !important;
    color: Canvas !important;
    box-shadow: none;
  }

  .address-book-increased-limit-list .address-book-increased-limit-list-item.hovered {
    forced-color-adjust: none;
    outline: 1px solid Highlight !important;
    outline-offset: -1px;
    box-shadow: none;
  }

  .address-book-increased-limit-list
    .address-book-increased-limit-list-item:hover
    > .address-list-item-detail
    > .address-dn,
  .address-book-increased-limit-list .address-book-increased-limit-list-item:hover {
    forced-color-adjust: none;
    background-color: Highlight !important;
    color: Canvas !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/AddressBookIncreasedLimit/styles.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,uDAAuD;AACzD;AACA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B;IACE,yBAAyB;IACzB,mCAAmC;IACnC,4BAA4B;IAC5B,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,mCAAmC;IACnC,4BAA4B;IAC5B,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,sCAAsC;IACtC,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;;;;IAIE,yBAAyB;IACzB,sCAAsC;IACtC,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,uCAAuC;IACvC,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;;;;;IAKE,yBAAyB;IACzB,sCAAsC;IACtC,wBAAwB;EAC1B;AACF","sourcesContent":["@import \"../../css/variables.css\";\n\n.address-book-increased-limit-list:not(.set-focus-visible):focus {\n  border: none;\n  outline: none;\n}\n.address-book-increased-limit-list:not(.set-focus-visible):focus-visible {\n  border: none;\n  outline: none;\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item {\n  padding-left: 15px !important;\n}\n.address-book-increased-limit-list .address-book-increased-limit-list-item:hover {\n  background-color: var(--list-hover-background, #c9f4ff);\n}\n.address-book-increased-limit-list .address-book-increased-limit-list-item.hovered {\n  outline: none;\n  box-shadow: var(--focused-list-shadow);\n}\n\n.address-book-increased-limit .address-book-increased-limit-list-item.selected {\n  background-color: var(--list-active-background, #c9f4ff);\n}\n\n.address-book-increased-limit .address-book-increased-limit-list-item.selected.hovered {\n  outline: none;\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-name {\n  color: var(--list-active-text-color);\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-dn {\n  color: var(--list-active-text-color);\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-name {\n  color: var(--list-hover-text-color);\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-dn {\n  color: var(--list-hover-text-color);\n}\n\n.address-book-increased-limit .address-list-error {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.address-book-increased-limit .address-list-error .address-list-error__illustrations {\n  width: 84px;\n  margin: auto;\n}\n\n.address-book-increased-limit .address-list-error .address-list-error__header {\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 19px;\n  margin-top: 24px;\n  margin-bottom: 0;\n}\n\n.address-book-increased-limit .address-list-error .address-list-error__sub-header {\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 19px;\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.address-book-increased-limit .address-list-error .address-list-error__button {\n  margin-top: 24px;\n}\n\n.address-book-increased-limit .address-book-increased-limit__loading {\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  align-items: center;\n  margin: auto;\n}\n\n.address-book-increased-limit {\n  width: 100%;\n  height: 100%;\n}\n\n.address-book-increased-limit.address-book-loading-error {\n  display: flex;\n  align-items: center;\n}\n\n.address-book-increased-limit > div.no-record {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: calc(var(--space-token-cardinal) * 2);\n  position: relative;\n  text-align: center;\n}\n\n.no-record-found {\n  position: relative;\n  top: 11px;\n}\n.address-book-increased-limit .search-error {\n  display: flex;\n  flex-direction: row;\n  column-gap: 8px;\n  align-items: center;\n  font-size: var(--font-size-small);\n}\n.address-book-increased-limit .search-block-error {\n  display: flex;\n  align-items: center;\n  padding: var(--padding-16);\n  justify-content: center;\n}\n\n@media (forced-colors: active) {\n  /* //outdial contact list */\n  .address-book-increased-limit-list .address-book-increased-limit-list-item {\n    forced-color-adjust: none;\n    background-color: Canvas !important;\n    color: CanvasText !important;\n    box-shadow: none;\n    outline-offset: -1px;\n  }\n\n  .address-book-increased-limit-list .address-book-increased-limit-list-item > .address-list-item-detail > .address-dn {\n    forced-color-adjust: none;\n    background-color: Canvas !important;\n    color: CanvasText !important;\n    box-shadow: none;\n  }\n  .address-book-increased-limit .address-book-increased-limit-list-item.selected {\n    forced-color-adjust: none;\n    background-color: Highlight !important;\n    color: Canvas !important;\n    box-shadow: none;\n  }\n\n  .address-book-increased-limit\n    .address-book-increased-limit-list-item.selected\n    > .address-list-item-detail\n    > .address-dn {\n    forced-color-adjust: none;\n    background-color: Highlight !important;\n    color: Canvas !important;\n    box-shadow: none;\n  }\n\n  .address-book-increased-limit-list .address-book-increased-limit-list-item.hovered {\n    forced-color-adjust: none;\n    outline: 1px solid Highlight !important;\n    outline-offset: -1px;\n    box-shadow: none;\n  }\n\n  .address-book-increased-limit-list\n    .address-book-increased-limit-list-item:hover\n    > .address-list-item-detail\n    > .address-dn,\n  .address-book-increased-limit-list .address-book-increased-limit-list-item:hover {\n    forced-color-adjust: none;\n    background-color: Highlight !important;\n    color: Canvas !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AgentProfile/styles.css":
/*!***************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AgentProfile/styles.css ***!
  \***************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../node_modules/css-loader/dist/cjs.js!../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent-profile {
  --menu-item-height-channel-menu-item: 120px;
  --header-button-size: 64px;
  --badge-width: 92px;
  --menu-item-height: 30px;
  --menu-width: 400px;
  --menu-value-maxwidth: calc(var(--menu-width) - 1.75rem * 2);
  --slider-margin-top: 24px;
  --slider-margin-right: 10px;
  --button-sound-padding: 5px;
  --slider-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.32);
  --slider-focus-shadow: 0 0 0 8px rgba(0, 160, 209, 0.4);
  --error-main-padding: 0 2rem 0 2.875rem;
  --managed-teams-section-height: 86px;
}

@keyframes slideIn {
  from {
    transform: translatex(0);
  }
  to {
    transform: translatex(100%);
  }
}

@keyframes slideOut {
  from {
    transform: translatex(50%);
  }
  to {
    transform: translatex(0);
  }
}

.profile-button {
  width: var(--header-button-size);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.webrtc-warning-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
  fill: var(--md-yellow-70);
  background-color: var(--md-secondary-white-bg-color);
  border-radius: 50%;
  overflow: visible;
}

.webrtc-warning-icon.dark {
  fill: var(--md-yellow-40);
}

.md-event-overlay__children {
  padding: 0px;
  width: var(--menu-width);
  margin-left: calc(calc(calc(var(--space-token-cardinal) * 2) * 3.5) - (var(--menu-width)));
}

.menu-content {
  display: flex;
  flex-direction: column;
  align-content: center;
  padding: 1rem 0.75rem;
  box-sizing: border-box;
  text-align: center;
}

.menu-user-settings-container {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.menu-help-container {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.menu-channel-capacity-container {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.menu-header {
  display: flex;
  justify-content: flex-end;
  padding: 0.75rem;
  padding-bottom: 0.25rem;
}

.menu-footer {
  display: flex;
  justify-content: center;
  padding: 0.5rem;
  border-top: 1px solid var(--md-quaternary-bg-color);
  align-content: flex-end;
  margin-top: auto;
}

.menu-footer-profile.disabled {
  cursor: not-allowed;
  pointer-events: none !important;
}
.menu-footer-profile.disabled md-link::part(link) {
  cursor: not-allowed;
  pointer-events: none !important;
  color: var(--link-disabled, #b2b2b2);
}

.menu-footer-profile.disabled md-link {
  cursor: not-allowed;
  pointer-events: none !important;
}

.menu-footer-profile {
  cursor: pointer;
  padding: 0;
}
.menu-footer-profile md-link {
  width: calc(100% - 4px);
  height: calc(100% - 2px);
  text-align: center;
}
.menu-footer-profile md-link::part(link) {
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 0.7rem;
  justify-content: center;
}

.menu-header-left {
  display: flex;
  justify-content: left;
  padding: 0.5rem;
  border-bottom: 1px solid var(--md-quaternary-bg-color);
  align-items: center;
}

.md-list-item > .md-list-item__left {
  justify-content: space-between;
}

.menu-item {
  display: flex;
  box-sizing: border-box;
  text-align: left;
  flex-direction: column;
  margin-left: 12px;
}
.menu-align {
  margin-top: calc(var(--space-token-cardinal) * 2);
}

.value-align {
  margin-top: -0.25rem;
}

.menu-item md-icon {
  margin-right: 0.5rem;
}

.menu-value {
  font-size: var(--font-size-small);
  color: var(--md-secondary-text-color);
}

.menu-telephony-status {
  font-size: var(--font-size-small);
  line-height: 16px;
  display: flex;
}

.menu-telephony-status-light {
  color: var(--md-yellow-70);
}

.menu-telephony-status-dark {
  color: var(--md-yellow-40);
}

.menu-spinner {
  padding: 6px;
}

.ms-retry-spinner {
  padding: 4px 6px 6px 6px;
}

.menu-reconnect {
  display: inline-flex;
}

.menu-warning-icon {
  margin-top: -2px;
}

.ms-config-label {
  float: left;
}

.ms-info-tooltip {
  float: right;
}

.ms-info-tooltip md-icon {
  display: flex;
  margin-right: unset;
  color: var(--md-secondary-text-color);
}

.ms-info-tooltip md-icon::part(icon) {
  margin-left: calc(var(--space-token-even) * 2);
  margin-right: calc(var(--space-token-even) * 2);
}

.ms-retry-wrapper,
.ms-retry-failed-wrapper {
  display: inline-flex;
  align-items: center;
  font-size: var(--font-size-small);
  color: var(--link-inline);
  position: relative;
}
.ms-retry-wrapper md-icon {
  position: absolute;
}
.ms-retry-failed-wrapper md-icon {
  position: absolute;
  padding-left: calc(var(--space-token-even) * 3);
}

.ms-authenticated-failed {
  margin-left: calc(var(--space-token-even) * 10);
}
.ms-sync-failed {
  margin-left: calc(var(--space-token-even) * 10);
  padding-left: calc(var(--space-token-even) * 3);
}

.ms-auth-failed {
  display: flex;
  align-items: center;
}
.ms-authenticated {
  display: flex;
  font-size: var(--font-size-small);
  color: var(--md-secondary-text-color);
  margin-top: 4px;
}
.ms-auth-failed-info {
  font-size: var(--font-size-small);
  color: var(--md-secondary-text-color);
}
.ms-retry-wrapper md-link::part(link) {
  font-size: var(--font-size-small);
}
.ms-sync-failed-info {
  font-size: var(--font-size-small);
  color: var(--link-inline);
}
.ms-retry-failed-wrapper md-link::part(link) {
  font-size: var(--font-size-small);
}

.ms-retry-auth-link {
  cursor: pointer;
  font-size: var(--font-size-small);
}

.profile-signout {
  display: flex;
  align-items: center;
}

.profile-signout md-icon {
  margin-right: 0.5rem;
}

.value-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: var(--menu-value-maxwidth);
}

.value-ellipsis .md-event-overlay__arrow {
  margin-left: calc(calc(calc(var(--space-token-cardinal) * 8) * 3.5) - (var(--menu-width)));
}

.value-ellipsis .md-event-overlay__children {
  margin-left: calc(calc(calc(var(--space-token-cardinal) * 3.5) * 3.5) - (var(--menu-width)));
}

.menu-item-label {
  font-size: var(--font-size-medium);
  color: var(--md-primary-text-color);
}

.menu-label {
  font-size: var(--font-size-small);
  color: var(--md-primary-text-color);
}

.menu-agent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 1rem;
  padding-left: 0.75rem;
  padding-right: 1.5rem;
  gap: 0.5rem;
}

.agentName {
  padding: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--font-size-heading-small, 1.25rem);
  line-height: var(--font-lineheight-heading-small, 1.75rem);
  font-family: var(--font-family-bold);
  font-weight: 700;
  margin: 0;
}

.settings,
.channelCapacity {
  border-top: var(--border);
}

.badge-wrapper .badge-content {
  width: calc(var(--menu-width) / 2 - 1.75rem - 40px);
  display: flex;
  justify-content: space-between;
}

.badge-wrapper .badge-content span {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.badge-wrapper .badge-content span md-icon {
  margin-right: 0.5rem;
}

.md-menu-item .md-list-item {
  box-sizing: border-box;
  box-shadow: none;
}

.badge-wrapper {
  display: grid;
  grid-template-areas: "badge badge" "badge badge";
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
}

.badge-wrapper .badge {
  padding: calc(var(--space-token-even) * 2);
}

.capacity {
  font-weight: var(--font-weight-bold);
  padding: 0 0.5rem;
}

.sub-header {
  margin-top: calc(var(--space-token-even) * 10);
  margin-bottom: 0.5rem;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-bold);
  text-align: left;
  justify-content: space-between;
  display: flex;
  align-items: center;
}

.sub-header > h2.heading {
  font-size: inherit;
  font-weight: inherit;
  margin: 0;
}

.iconInfo {
  padding-left: calc(var(--space-token-cardinal) + var(--space-token-even));
  vertical-align: middle;
}

.tooltip-padding {
  padding: calc(var(--space-token-even) * 5);
}

.routing-type {
  display: inline-flex;
  align-items: center;
  font-size: var(--font-size-medium);
  text-align: left;
  font-weight: normal;
  color: var(--md-secondary-text-color);
}

.menu-quicklink {
  font-size: var(--font-size-large);
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  gap: 0.75rem;
  height: 40px;
}

.menu-quicklink::part(link) {
  gap: 0.75rem;
  color: var(--md-primary-text-color);
  align-items: center;
}

.menu-quicklink md-link[disabled],
.menu-quicklink md-button[disabled],
.menu-item md-link[disabled],
.menu-item md-button[disabled],
.team-name-container md-button[disabled],
.team-name-container md-link[disabled],
.menu-footer md-link[disabled] {
  pointer-events: none;
}

md-link.team-name-container[disabled],
md-link.managed-teams[disabled],
md-link.profile-setting-wrapper[disabled] {
  cursor: not-allowed;
}

.conflict-warning,
.shortcut-arrow {
  vertical-align: middle;
  padding-left: var(--space-token-cardinal);
}

.shortcut-arrow,
.notification-settings-arrow {
  margin-left: auto;
}

.agent-profile-link::part(link) {
  color: var(--md-primary-text-color);
  gap: 0.5rem;
  align-items: center;
}

.agent-profile-link {
  color: var(--md-primary-text-color);
}

.agent-profile-link[disabled],
.agent-profile-link.disabled,
.team-change-settings-text.disabled,
.managed-teams-text.disabled,
.agent-profile-link[disabled]::part(link) {
  color: var(--disabled-text-color);
}

.error-report-badge {
  padding-right: calc(var(--space-token-cardinal) * 4);
}

.speaker-mic-settings-container,
.notification-settings-container {
  padding-top: calc(var(--space-token-even) * 12);
  padding-left: calc(var(--space-token-even) * 12);
  padding-right: calc(var(--space-token-even) * 12);
  padding-bottom: none;
}

.settings-container {
  padding-bottom: calc(var(--space-token-even) * 12);
  border-bottom: var(--border-width) solid var(--md-quaternary-bg-color);
}

.notification-sound-slider {
  display: flex;
  align-items: center;
  margin-top: 15px;
}

.notification-sound-slider .slider {
  flex: 1;
  margin-right: var(--slider-margin-right);
}

.notification-sound-slider .play,
.notification-sound-slider .speaker {
  padding: var(--button-sound-padding);
}

.arrow-icon-back {
  transform: rotate(90deg);
  margin-left: calc(var(--space-token-even) * 7);
  margin-right: calc(var(--space-token-cardinal) + calc(var(--space-token-even) * 4));
  cursor: pointer;
}

.play-message,
.record-message,
.settings-description {
  color: var(--md-secondary-text-color);
  font-size: var(--font-size-small);
}

.settings-description.volume-title {
  margin-top: var(--slider-margin-top);
}

.settings-description.mic-speaker {
  margin-bottom: 16px;
}

.label-container,
.toggle-switch-container {
  display: flex;
  justify-content: space-between;
}

.slideIn {
  animation: slideIn var(--default-animation-duration) var(--ease-in-out-quint) backwards;
}

.slideOut {
  animation: slideOut var(--default-animation-duration) var(--ease-in-out-quint) backwards;
}

.menu-overlay-container {
  height: calc(100vh - var(--top-header-height) - var(--space-token-cardinal));
  overflow: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
}
md-menu-overlay::part(overlay) {
  transform: translate3d(-335px, 50px, 0);
  visibility: hidden;
  transition: all var(--default-animation-duration) ease-in-out;
}

md-menu-overlay.modal-open::part(overlay) {
  visibility: visible;
  transform: translate3d(-335px, 50px, 0);
}
md-menu-overlay.modal-close::part(overlay) {
  transform: translate3d(335px, 50px, 0);
  top: 0px;
  display: none;
}

.notification-sound-slider .sliderInput {
  -webkit-appearance: none;
  width: 100%;
  height: 2px;
  background: var(--link-color);
  outline: none;
  border-radius: 50px;
}

.notification-sound-slider .sliderInput:disabled {
  background: var(--md-primary-seperator-color-default);
}

.notification-sound-slider .sliderInput::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  cursor: pointer;
  background-color: var(--md-primary-bg-color-default);
  border: 1px solid var(--md-secondary-text-color);
  border-radius: 50%;
  box-shadow: var(--slider-shadow);
}

.notification-sound-slider .sliderInput:focus::-webkit-slider-thumb {
  box-shadow: var(--slider-focus-shadow);
}
.notification-sound-slider .sliderInput:focus {
  box-shadow: var(--slider-focus-shadow);
}

md-icon[name="info-badge-filled"]:focus {
  outline: none;
  box-shadow: var(--focused-momentum-shadow);
}

.wc-menu-team_list {
  md-list-item::part(list-item) {
    padding: 0;
    border-radius: 5px;
    background: none;
  }
}

.wc-menu-team-item {
  margin: var(--space-token-cardinal);
  cursor: default;
}

.team-list-search {
  padding-top: 16px;
  display: flex;
  justify-content: center;
}

.teams-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}

.menu-overlay-container md-input {
  width: 369px;
}

.menu-overlay-container md-list {
  padding-left: 15px;
  width: 380px;
}

.save-team-btn,
.save-profile-btn {
  padding-left: 9px;
}

.team-name-option-text {
  padding: 0 0 0 calc(var(--space-token-cardinal) * 2);
  display: block;
  font-size: var(--font-size-medium);
}

.team-menu-item {
  border: 0;
  border-radius: 0;
}

.team-name-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.team-name-container::part(link) {
  width: 100%;
}

.shortcut-arrow-container {
  margin-left: auto;
  align-items: center;
}
.notification-settings-btn {
  width: 100%;
  border: 0;
  background: transparent;
  padding: 0.25rem 0;
  cursor: pointer;
}

.notification-settings-text {
  color: var(--md-primary-text-color);
}

.notification-settings-btn::part(link) {
  width: 100%;
}

.team-name-value {
  color: var(--button-disabled-text-color, --disabled-text-color);
}

.teams-failed {
  margin: auto;
}

.routing-type md-icon::part(icon) {
  margin-left: calc(var(--space-token-even) * 2);
  margin-right: calc(var(--space-token-even) * 2);
}

.routing-type md-icon {
  display: flex;
}

.user-profile-section .menu-quicklink {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 10px;
  padding: 0;
  padding-left: 0.5rem;
}

.navigation-arrow::part(button) {
  right: -10px; /** adding -10 to right for alignment with rest arrow icons as button has some default spacings in it **/
  background-color: transparent;
}

.navigation-arrow::part(button):hover {
  background-color: transparent;
}

.user-profile-section .managed-teams,
.user-profile-section .menu-quicklink {
  font-weight: var(--font-weight-normal);
}

.user-profile-section .profile-settings {
  cursor: pointer;
}

.profile-settings-text {
  padding: 8px 5px 3px 5px;
}

.profile-menu-separator {
  height: 1px;
  margin-top: 20px;
  margin-left: 0.75rem;
  margin-right: 1rem;
  background-color: var(--md-secondary-seperator-color);
}

.user-profile-section .managed-teams::part(link) {
  width: 100%;
  padding-right: 0.5rem;
}

.managed-teams-text {
  padding: 8px 5px 3px 5px;
}

.user-profile-section .profile-settings:hover {
  background-color: var(--button-white-hover-bg-color);
  border-radius: 8px;
}

.user-profile-section .profile-setting-wrapper::part(link) {
  width: 100%;
  padding-right: 8px;
  align-items: center;
}

.view-all-link {
  color: var(--md-hyperlink-text-color);
}

.profile-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}

.profile-container agentx-wc-user-profile {
  padding: 12px;
}

.manged-teams-list {
  list-style-type: none;
}

.inf-scroll {
  padding-left: 40px;
}

md-toggle-switch[data-testid="toggle-dark-mode"],
md-toggle-switch[data-testid="toggle-new-look"] {
  margin-left: auto;
  margin-top: 0.5rem;

  &::part(toggle-label) {
    margin-right: 0;
  }
}

.managed-team-view {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  word-wrap: break-word;
  text-align: left;
  margin-top: -10px;
  margin-bottom: 10px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.managed-team-loading,
.managed-team-error {
  min-height: var(--managed-teams-section-height);
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.managed-team-error span,
.managed-team-error md-icon {
  color: var(--md-input-chat-error-color);
  margin-right: 5px;
}

.managed-team-error .managed-teams-retry-link::part(link) {
  color: var(--md-input-chat-error-color);
}

.profile-loader {
  left: 50%;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: var(--translate-50);
  color: var(--md-primary-text-color);
}

.loading-text {
  font-family: var(--font-family);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-bold);
  margin-top: calc(var(--space-token-even) * 3);
}

md-dropdown.speakerMic-dropdown::part(dropdown-header) {
  border-radius: 30px;
}

.mic-error-message {
  font-size: var(--font-size-small);
  color: var(--red-70-color);
  position: relative;
}

.error-text {
  padding: 0px;
  text-align: left;
  width: 330px;
  display: inline-block;
  margin: 0px 20px;
}

.speaker-error-text {
  padding: 0px;
  text-align: left;
  width: 330px;
  display: inline-block;
  margin: 0px;
  color: var(--md-secondary-text-color-default);
}

.error-icon {
  position: absolute;
  bottom: 18px;
  left: 0;
}

.microphone-test-button {
  margin-left: auto;
  padding-bottom: 6px;
}

.speaker-test-button md-button::part(button),
.microphone-test-button md-button::part(button) {
  width: 100px;
}
.ms-user-auth {
  margin-right: calc(var(--space-token-even) * 4);
}
.ms-sync-success {
  margin-left: calc(var(--space-token-even) * 4);
}

@media (forced-colors: active) {
  /* //firefox fix   */
  .badge-wrapper:focus,
  .badge-wrapper:focus-visible {
    outline: 2px solid Highlight;
  }
  .webrtc-warning-icon,
  .webrtc-warning-icon.dark {
    fill: Canvas;
    background-color: CanvasText;
  }

  /* volume slider fix in HC mode  */
  .notification-sound-slider .sliderInput {
    background-color: Highlight;
  }
  .notification-sound-slider .sliderInput:focus::-webkit-slider-thumb {
    outline: 3px solid Highlight;
    background-color: HighlightText;
  }
  .notification-sound-slider .sliderInput::-webkit-slider-thumb {
    background-color: CanvasText;
  }
}

.profile-settings {
  display: flex;
  flex-direction: column;
  margin: 16px;
}

.save-profile-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-right: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/AgentProfile/styles.css"],"names":[],"mappings":"AAEA;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,4DAA4D;EAC5D,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,gDAAgD;EAChD,uDAAuD;EACvD,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,oDAAoD;EACpD,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,0FAA0F;AAC5F;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mDAAmD;EACnD,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;EAC/C,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,iCAAiC;EACjC,qCAAqC;AACvC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,0FAA0F;AAC5F;;AAEA;EACE,4FAA4F;AAC9F;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kDAAkD;EAClD,0DAA0D;EAC1D,oCAAoC;EACpC,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;EACrB,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,yEAAyE;EACzE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,oBAAoB;AACtB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;;EAKE,iCAAiC;AACnC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;EAEE,+CAA+C;EAC/C,gDAAgD;EAChD,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,kDAAkD;EAClD,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,wCAAwC;AAC1C;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;EAC9C,mFAAmF;EACnF,eAAe;AACjB;;AAEA;;;EAGE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,wFAAwF;AAC1F;;AAEA;EACE,4EAA4E;EAC5E,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,sCAAsC;EACtC,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oDAAoD;EACpD,gDAAgD;EAChD,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,oDAAoD;EACpD,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY,EAAE,wGAAwG;EACtH,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;;EAElB;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA,kCAAkC;EAClC;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["@import \"../../css/variables.css\";\n\n.agent-profile {\n  --menu-item-height-channel-menu-item: 120px;\n  --header-button-size: 64px;\n  --badge-width: 92px;\n  --menu-item-height: 30px;\n  --menu-width: 400px;\n  --menu-value-maxwidth: calc(var(--menu-width) - 1.75rem * 2);\n  --slider-margin-top: 24px;\n  --slider-margin-right: 10px;\n  --button-sound-padding: 5px;\n  --slider-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.32);\n  --slider-focus-shadow: 0 0 0 8px rgba(0, 160, 209, 0.4);\n  --error-main-padding: 0 2rem 0 2.875rem;\n  --managed-teams-section-height: 86px;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translatex(0);\n  }\n  to {\n    transform: translatex(100%);\n  }\n}\n\n@keyframes slideOut {\n  from {\n    transform: translatex(50%);\n  }\n  to {\n    transform: translatex(0);\n  }\n}\n\n.profile-button {\n  width: var(--header-button-size);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n.webrtc-warning-icon {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: 1;\n  fill: var(--md-yellow-70);\n  background-color: var(--md-secondary-white-bg-color);\n  border-radius: 50%;\n  overflow: visible;\n}\n\n.webrtc-warning-icon.dark {\n  fill: var(--md-yellow-40);\n}\n\n.md-event-overlay__children {\n  padding: 0px;\n  width: var(--menu-width);\n  margin-left: calc(calc(calc(var(--space-token-cardinal) * 2) * 3.5) - (var(--menu-width)));\n}\n\n.menu-content {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  padding: 1rem 0.75rem;\n  box-sizing: border-box;\n  text-align: center;\n}\n\n.menu-user-settings-container {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.menu-help-container {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.menu-channel-capacity-container {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.menu-header {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0.75rem;\n  padding-bottom: 0.25rem;\n}\n\n.menu-footer {\n  display: flex;\n  justify-content: center;\n  padding: 0.5rem;\n  border-top: 1px solid var(--md-quaternary-bg-color);\n  align-content: flex-end;\n  margin-top: auto;\n}\n\n.menu-footer-profile.disabled {\n  cursor: not-allowed;\n  pointer-events: none !important;\n}\n.menu-footer-profile.disabled md-link::part(link) {\n  cursor: not-allowed;\n  pointer-events: none !important;\n  color: var(--link-disabled, #b2b2b2);\n}\n\n.menu-footer-profile.disabled md-link {\n  cursor: not-allowed;\n  pointer-events: none !important;\n}\n\n.menu-footer-profile {\n  cursor: pointer;\n  padding: 0;\n}\n.menu-footer-profile md-link {\n  width: calc(100% - 4px);\n  height: calc(100% - 2px);\n  text-align: center;\n}\n.menu-footer-profile md-link::part(link) {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  padding: 0.7rem;\n  justify-content: center;\n}\n\n.menu-header-left {\n  display: flex;\n  justify-content: left;\n  padding: 0.5rem;\n  border-bottom: 1px solid var(--md-quaternary-bg-color);\n  align-items: center;\n}\n\n.md-list-item > .md-list-item__left {\n  justify-content: space-between;\n}\n\n.menu-item {\n  display: flex;\n  box-sizing: border-box;\n  text-align: left;\n  flex-direction: column;\n  margin-left: 12px;\n}\n.menu-align {\n  margin-top: calc(var(--space-token-cardinal) * 2);\n}\n\n.value-align {\n  margin-top: -0.25rem;\n}\n\n.menu-item md-icon {\n  margin-right: 0.5rem;\n}\n\n.menu-value {\n  font-size: var(--font-size-small);\n  color: var(--md-secondary-text-color);\n}\n\n.menu-telephony-status {\n  font-size: var(--font-size-small);\n  line-height: 16px;\n  display: flex;\n}\n\n.menu-telephony-status-light {\n  color: var(--md-yellow-70);\n}\n\n.menu-telephony-status-dark {\n  color: var(--md-yellow-40);\n}\n\n.menu-spinner {\n  padding: 6px;\n}\n\n.ms-retry-spinner {\n  padding: 4px 6px 6px 6px;\n}\n\n.menu-reconnect {\n  display: inline-flex;\n}\n\n.menu-warning-icon {\n  margin-top: -2px;\n}\n\n.ms-config-label {\n  float: left;\n}\n\n.ms-info-tooltip {\n  float: right;\n}\n\n.ms-info-tooltip md-icon {\n  display: flex;\n  margin-right: unset;\n  color: var(--md-secondary-text-color);\n}\n\n.ms-info-tooltip md-icon::part(icon) {\n  margin-left: calc(var(--space-token-even) * 2);\n  margin-right: calc(var(--space-token-even) * 2);\n}\n\n.ms-retry-wrapper,\n.ms-retry-failed-wrapper {\n  display: inline-flex;\n  align-items: center;\n  font-size: var(--font-size-small);\n  color: var(--link-inline);\n  position: relative;\n}\n.ms-retry-wrapper md-icon {\n  position: absolute;\n}\n.ms-retry-failed-wrapper md-icon {\n  position: absolute;\n  padding-left: calc(var(--space-token-even) * 3);\n}\n\n.ms-authenticated-failed {\n  margin-left: calc(var(--space-token-even) * 10);\n}\n.ms-sync-failed {\n  margin-left: calc(var(--space-token-even) * 10);\n  padding-left: calc(var(--space-token-even) * 3);\n}\n\n.ms-auth-failed {\n  display: flex;\n  align-items: center;\n}\n.ms-authenticated {\n  display: flex;\n  font-size: var(--font-size-small);\n  color: var(--md-secondary-text-color);\n  margin-top: 4px;\n}\n.ms-auth-failed-info {\n  font-size: var(--font-size-small);\n  color: var(--md-secondary-text-color);\n}\n.ms-retry-wrapper md-link::part(link) {\n  font-size: var(--font-size-small);\n}\n.ms-sync-failed-info {\n  font-size: var(--font-size-small);\n  color: var(--link-inline);\n}\n.ms-retry-failed-wrapper md-link::part(link) {\n  font-size: var(--font-size-small);\n}\n\n.ms-retry-auth-link {\n  cursor: pointer;\n  font-size: var(--font-size-small);\n}\n\n.profile-signout {\n  display: flex;\n  align-items: center;\n}\n\n.profile-signout md-icon {\n  margin-right: 0.5rem;\n}\n\n.value-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: var(--menu-value-maxwidth);\n}\n\n.value-ellipsis .md-event-overlay__arrow {\n  margin-left: calc(calc(calc(var(--space-token-cardinal) * 8) * 3.5) - (var(--menu-width)));\n}\n\n.value-ellipsis .md-event-overlay__children {\n  margin-left: calc(calc(calc(var(--space-token-cardinal) * 3.5) * 3.5) - (var(--menu-width)));\n}\n\n.menu-item-label {\n  font-size: var(--font-size-medium);\n  color: var(--md-primary-text-color);\n}\n\n.menu-label {\n  font-size: var(--font-size-small);\n  color: var(--md-primary-text-color);\n}\n\n.menu-agent {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding-bottom: 1rem;\n  padding-left: 0.75rem;\n  padding-right: 1.5rem;\n  gap: 0.5rem;\n}\n\n.agentName {\n  padding: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: var(--font-size-heading-small, 1.25rem);\n  line-height: var(--font-lineheight-heading-small, 1.75rem);\n  font-family: var(--font-family-bold);\n  font-weight: 700;\n  margin: 0;\n}\n\n.settings,\n.channelCapacity {\n  border-top: var(--border);\n}\n\n.badge-wrapper .badge-content {\n  width: calc(var(--menu-width) / 2 - 1.75rem - 40px);\n  display: flex;\n  justify-content: space-between;\n}\n\n.badge-wrapper .badge-content span {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.badge-wrapper .badge-content span md-icon {\n  margin-right: 0.5rem;\n}\n\n.md-menu-item .md-list-item {\n  box-sizing: border-box;\n  box-shadow: none;\n}\n\n.badge-wrapper {\n  display: grid;\n  grid-template-areas: \"badge badge\" \"badge badge\";\n  grid-template-rows: 1fr 1fr;\n  grid-template-columns: 1fr 1fr;\n}\n\n.badge-wrapper .badge {\n  padding: calc(var(--space-token-even) * 2);\n}\n\n.capacity {\n  font-weight: var(--font-weight-bold);\n  padding: 0 0.5rem;\n}\n\n.sub-header {\n  margin-top: calc(var(--space-token-even) * 10);\n  margin-bottom: 0.5rem;\n  font-size: var(--font-size-small);\n  font-weight: var(--font-weight-bold);\n  text-align: left;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n}\n\n.sub-header > h2.heading {\n  font-size: inherit;\n  font-weight: inherit;\n  margin: 0;\n}\n\n.iconInfo {\n  padding-left: calc(var(--space-token-cardinal) + var(--space-token-even));\n  vertical-align: middle;\n}\n\n.tooltip-padding {\n  padding: calc(var(--space-token-even) * 5);\n}\n\n.routing-type {\n  display: inline-flex;\n  align-items: center;\n  font-size: var(--font-size-medium);\n  text-align: left;\n  font-weight: normal;\n  color: var(--md-secondary-text-color);\n}\n\n.menu-quicklink {\n  font-size: var(--font-size-large);\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0;\n  gap: 0.75rem;\n  height: 40px;\n}\n\n.menu-quicklink::part(link) {\n  gap: 0.75rem;\n  color: var(--md-primary-text-color);\n  align-items: center;\n}\n\n.menu-quicklink md-link[disabled],\n.menu-quicklink md-button[disabled],\n.menu-item md-link[disabled],\n.menu-item md-button[disabled],\n.team-name-container md-button[disabled],\n.team-name-container md-link[disabled],\n.menu-footer md-link[disabled] {\n  pointer-events: none;\n}\n\nmd-link.team-name-container[disabled],\nmd-link.managed-teams[disabled],\nmd-link.profile-setting-wrapper[disabled] {\n  cursor: not-allowed;\n}\n\n.conflict-warning,\n.shortcut-arrow {\n  vertical-align: middle;\n  padding-left: var(--space-token-cardinal);\n}\n\n.shortcut-arrow,\n.notification-settings-arrow {\n  margin-left: auto;\n}\n\n.agent-profile-link::part(link) {\n  color: var(--md-primary-text-color);\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.agent-profile-link {\n  color: var(--md-primary-text-color);\n}\n\n.agent-profile-link[disabled],\n.agent-profile-link.disabled,\n.team-change-settings-text.disabled,\n.managed-teams-text.disabled,\n.agent-profile-link[disabled]::part(link) {\n  color: var(--disabled-text-color);\n}\n\n.error-report-badge {\n  padding-right: calc(var(--space-token-cardinal) * 4);\n}\n\n.speaker-mic-settings-container,\n.notification-settings-container {\n  padding-top: calc(var(--space-token-even) * 12);\n  padding-left: calc(var(--space-token-even) * 12);\n  padding-right: calc(var(--space-token-even) * 12);\n  padding-bottom: none;\n}\n\n.settings-container {\n  padding-bottom: calc(var(--space-token-even) * 12);\n  border-bottom: var(--border-width) solid var(--md-quaternary-bg-color);\n}\n\n.notification-sound-slider {\n  display: flex;\n  align-items: center;\n  margin-top: 15px;\n}\n\n.notification-sound-slider .slider {\n  flex: 1;\n  margin-right: var(--slider-margin-right);\n}\n\n.notification-sound-slider .play,\n.notification-sound-slider .speaker {\n  padding: var(--button-sound-padding);\n}\n\n.arrow-icon-back {\n  transform: rotate(90deg);\n  margin-left: calc(var(--space-token-even) * 7);\n  margin-right: calc(var(--space-token-cardinal) + calc(var(--space-token-even) * 4));\n  cursor: pointer;\n}\n\n.play-message,\n.record-message,\n.settings-description {\n  color: var(--md-secondary-text-color);\n  font-size: var(--font-size-small);\n}\n\n.settings-description.volume-title {\n  margin-top: var(--slider-margin-top);\n}\n\n.settings-description.mic-speaker {\n  margin-bottom: 16px;\n}\n\n.label-container,\n.toggle-switch-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.slideIn {\n  animation: slideIn var(--default-animation-duration) var(--ease-in-out-quint) backwards;\n}\n\n.slideOut {\n  animation: slideOut var(--default-animation-duration) var(--ease-in-out-quint) backwards;\n}\n\n.menu-overlay-container {\n  height: calc(100vh - var(--top-header-height) - var(--space-token-cardinal));\n  overflow: auto;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\nmd-menu-overlay::part(overlay) {\n  transform: translate3d(-335px, 50px, 0);\n  visibility: hidden;\n  transition: all var(--default-animation-duration) ease-in-out;\n}\n\nmd-menu-overlay.modal-open::part(overlay) {\n  visibility: visible;\n  transform: translate3d(-335px, 50px, 0);\n}\nmd-menu-overlay.modal-close::part(overlay) {\n  transform: translate3d(335px, 50px, 0);\n  top: 0px;\n  display: none;\n}\n\n.notification-sound-slider .sliderInput {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 2px;\n  background: var(--link-color);\n  outline: none;\n  border-radius: 50px;\n}\n\n.notification-sound-slider .sliderInput:disabled {\n  background: var(--md-primary-seperator-color-default);\n}\n\n.notification-sound-slider .sliderInput::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  background-color: var(--md-primary-bg-color-default);\n  border: 1px solid var(--md-secondary-text-color);\n  border-radius: 50%;\n  box-shadow: var(--slider-shadow);\n}\n\n.notification-sound-slider .sliderInput:focus::-webkit-slider-thumb {\n  box-shadow: var(--slider-focus-shadow);\n}\n.notification-sound-slider .sliderInput:focus {\n  box-shadow: var(--slider-focus-shadow);\n}\n\nmd-icon[name=\"info-badge-filled\"]:focus {\n  outline: none;\n  box-shadow: var(--focused-momentum-shadow);\n}\n\n.wc-menu-team_list {\n  md-list-item::part(list-item) {\n    padding: 0;\n    border-radius: 5px;\n    background: none;\n  }\n}\n\n.wc-menu-team-item {\n  margin: var(--space-token-cardinal);\n  cursor: default;\n}\n\n.team-list-search {\n  padding-top: 16px;\n  display: flex;\n  justify-content: center;\n}\n\n.teams-container {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  height: 100%;\n}\n\n.menu-overlay-container md-input {\n  width: 369px;\n}\n\n.menu-overlay-container md-list {\n  padding-left: 15px;\n  width: 380px;\n}\n\n.save-team-btn,\n.save-profile-btn {\n  padding-left: 9px;\n}\n\n.team-name-option-text {\n  padding: 0 0 0 calc(var(--space-token-cardinal) * 2);\n  display: block;\n  font-size: var(--font-size-medium);\n}\n\n.team-menu-item {\n  border: 0;\n  border-radius: 0;\n}\n\n.team-name-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n}\n\n.team-name-container::part(link) {\n  width: 100%;\n}\n\n.shortcut-arrow-container {\n  margin-left: auto;\n  align-items: center;\n}\n.notification-settings-btn {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  padding: 0.25rem 0;\n  cursor: pointer;\n}\n\n.notification-settings-text {\n  color: var(--md-primary-text-color);\n}\n\n.notification-settings-btn::part(link) {\n  width: 100%;\n}\n\n.team-name-value {\n  color: var(--button-disabled-text-color, --disabled-text-color);\n}\n\n.teams-failed {\n  margin: auto;\n}\n\n.routing-type md-icon::part(icon) {\n  margin-left: calc(var(--space-token-even) * 2);\n  margin-right: calc(var(--space-token-even) * 2);\n}\n\n.routing-type md-icon {\n  display: flex;\n}\n\n.user-profile-section .menu-quicklink {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  margin-bottom: 10px;\n  padding: 0;\n  padding-left: 0.5rem;\n}\n\n.navigation-arrow::part(button) {\n  right: -10px; /** adding -10 to right for alignment with rest arrow icons as button has some default spacings in it **/\n  background-color: transparent;\n}\n\n.navigation-arrow::part(button):hover {\n  background-color: transparent;\n}\n\n.user-profile-section .managed-teams,\n.user-profile-section .menu-quicklink {\n  font-weight: var(--font-weight-normal);\n}\n\n.user-profile-section .profile-settings {\n  cursor: pointer;\n}\n\n.profile-settings-text {\n  padding: 8px 5px 3px 5px;\n}\n\n.profile-menu-separator {\n  height: 1px;\n  margin-top: 20px;\n  margin-left: 0.75rem;\n  margin-right: 1rem;\n  background-color: var(--md-secondary-seperator-color);\n}\n\n.user-profile-section .managed-teams::part(link) {\n  width: 100%;\n  padding-right: 0.5rem;\n}\n\n.managed-teams-text {\n  padding: 8px 5px 3px 5px;\n}\n\n.user-profile-section .profile-settings:hover {\n  background-color: var(--button-white-hover-bg-color);\n  border-radius: 8px;\n}\n\n.user-profile-section .profile-setting-wrapper::part(link) {\n  width: 100%;\n  padding-right: 8px;\n  align-items: center;\n}\n\n.view-all-link {\n  color: var(--md-hyperlink-text-color);\n}\n\n.profile-container {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  height: 100%;\n}\n\n.profile-container agentx-wc-user-profile {\n  padding: 12px;\n}\n\n.manged-teams-list {\n  list-style-type: none;\n}\n\n.inf-scroll {\n  padding-left: 40px;\n}\n\nmd-toggle-switch[data-testid=\"toggle-dark-mode\"],\nmd-toggle-switch[data-testid=\"toggle-new-look\"] {\n  margin-left: auto;\n  margin-top: 0.5rem;\n\n  &::part(toggle-label) {\n    margin-right: 0;\n  }\n}\n\n.managed-team-view {\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  word-wrap: break-word;\n  text-align: left;\n  margin-top: -10px;\n  margin-bottom: 10px;\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.managed-team-loading,\n.managed-team-error {\n  min-height: var(--managed-teams-section-height);\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.managed-team-error span,\n.managed-team-error md-icon {\n  color: var(--md-input-chat-error-color);\n  margin-right: 5px;\n}\n\n.managed-team-error .managed-teams-retry-link::part(link) {\n  color: var(--md-input-chat-error-color);\n}\n\n.profile-loader {\n  left: 50%;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  transform: var(--translate-50);\n  color: var(--md-primary-text-color);\n}\n\n.loading-text {\n  font-family: var(--font-family);\n  font-size: var(--font-size-large);\n  font-weight: var(--font-weight-bold);\n  margin-top: calc(var(--space-token-even) * 3);\n}\n\nmd-dropdown.speakerMic-dropdown::part(dropdown-header) {\n  border-radius: 30px;\n}\n\n.mic-error-message {\n  font-size: var(--font-size-small);\n  color: var(--red-70-color);\n  position: relative;\n}\n\n.error-text {\n  padding: 0px;\n  text-align: left;\n  width: 330px;\n  display: inline-block;\n  margin: 0px 20px;\n}\n\n.speaker-error-text {\n  padding: 0px;\n  text-align: left;\n  width: 330px;\n  display: inline-block;\n  margin: 0px;\n  color: var(--md-secondary-text-color-default);\n}\n\n.error-icon {\n  position: absolute;\n  bottom: 18px;\n  left: 0;\n}\n\n.microphone-test-button {\n  margin-left: auto;\n  padding-bottom: 6px;\n}\n\n.speaker-test-button md-button::part(button),\n.microphone-test-button md-button::part(button) {\n  width: 100px;\n}\n.ms-user-auth {\n  margin-right: calc(var(--space-token-even) * 4);\n}\n.ms-sync-success {\n  margin-left: calc(var(--space-token-even) * 4);\n}\n\n@media (forced-colors: active) {\n  /* //firefox fix   */\n  .badge-wrapper:focus,\n  .badge-wrapper:focus-visible {\n    outline: 2px solid Highlight;\n  }\n  .webrtc-warning-icon,\n  .webrtc-warning-icon.dark {\n    fill: Canvas;\n    background-color: CanvasText;\n  }\n\n  /* volume slider fix in HC mode  */\n  .notification-sound-slider .sliderInput {\n    background-color: Highlight;\n  }\n  .notification-sound-slider .sliderInput:focus::-webkit-slider-thumb {\n    outline: 3px solid Highlight;\n    background-color: HighlightText;\n  }\n  .notification-sound-slider .sliderInput::-webkit-slider-thumb {\n    background-color: CanvasText;\n  }\n}\n\n.profile-settings {\n  display: flex;\n  flex-direction: column;\n  margin: 16px;\n}\n\n.save-profile-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AgentStateSelector/index.css":
/*!********************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AgentStateSelector/index.css ***!
  \********************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../node_modules/css-loader/dist/cjs.js!../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent-status {
  --full-menu-item-width: calc(218px);
  --full-status-width: calc(260px);
  --full-half-width: calc(99px);
  --compact-status-width: calc(184px);
  --compact-menu-item-width: calc(150px);
  --compact-half-width: calc(61px);
  --state-input-height: calc(42px);
  --state-selector-height: calc(344px);
  --state-selector-min-height: calc(164px);
  --current-status-max-width: calc(1px);
  --agent-state-selector-padding: calc(10px);
}

.menu-list {
  height: 100%;
  margin: 0;
  overflow-y: hidden;
  width: 100%;
}

.md-menu-item-container {
  width: 100%;
}
/* Adding padding top to make the focus border on the first state selector visible */
md-list-item:first-child {
  padding-top: 0.125rem;
}

.agent-status .status-menu-item {
  border: 0;
  border-radius: var(--advance-list-border-radius-rounded, 0);
}

.agent-status-select-option-badge {
  display: inline-flex;
  align-items: center;
}

.agent-status-select-option-badge svg {
  width: 13.5px;
  height: 13.5px;
  position: absolute;
}

.agent-status-select-option-badge .available-raw-icon {
  width: 13.5px;
  height: 13.5px;
  background-color: var(--md-primary-one-bg-color, --md-primary-bg-color);
  border-radius: 50%;
  color: var(--avatar-presence-active);
}

.agent-status-select-option-badge .idle-raw-icon {
  width: 13.5px;
  height: 13.5px;
  background-color: var(--md-primary-one-bg-color, --md-primary-bg-color);
  border-radius: 50%;
  color: var(--avatar-presence-inactive);
}

.status-button__children {
  color: var(--md-button-secondary-text-color);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.status-button__children .status-indicator-container {
  width: 16px;
  height: 16px;
  border-radius: 50%;

  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.status-button__children svg {
  width: 13.5px;
  height: 13.5px;
  background-color: var(--md-primary-one-bg-color, --md-primary-bg-color);
  border-radius: 50%;
  display: inline-flex;
}

.available-icon-color {
  color: var(--avatar-presence-active);
}

.idle-icon-color {
  color: var(--avatar-presence-inactive);
}

.rona-icon-color {
  color: var(--avatar-presence-busy);
}

.engaged-icon-color {
  color: var(--avatar-presence-engaged);
}

.agent-status .status-indicator {
  box-sizing: border-box;
  color: var(--md-presence-away-bg-color);
  margin: 0;
}

.agent-status .status-indicator.green-status {
  color: var(--md-green-60);
}

.agent-status .status-indicator.yellow-status {
  color: var(--md-yellow-60);
}

.agent-status .status-indicator.red-status {
  color: var(--md-presence-do-not-disturb-bg-color);
}

.agent-status .ax-current-status-label {
  flex-grow: 1;
  text-align: left;
  width: 1%;
  padding: 0.5px 0 0 calc(var(--space-token-cardinal) * 2);
}

.agent-status .ax-current-status-label.half-width {
  width: var(--full-half-width);
}

.agent-status-option-text {
  display: block;
  font-size: var(--font-size-medium);
  padding: 0 0 0 calc(var(--space-token-cardinal) * 2);
  width: var(--full-menu-item-width);
}

.agent-status-option-list {
  display: block;
  font-size: var(--font-size-medium);
  padding: 0 0 0 calc(var(--space-token-cardinal) * 2);
  width: calc(var(--full-menu-item-width) - var(--space-token-cardinal));
}

.ellipsis-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-status .agent-current-status-timer {
  color: var(--md-primary-text-color);
  display: inline-flex;
  align-items: center;
  flex-grow: 0;
  font-size: var(--font-size-small);
  height: calc(var(--space-token-cardinal) * 2);
  padding: 0 calc(var(--space-token-cardinal) * 2) 0 calc(var(--space-token-cardinal) * 2);

  &.medium-font {
    font-size: var(--font-size-medium);
  }
}

.agent-status .agent-current-status-timer.tooltip-text-color {
  color: var(--tooltip-font-color, --gray-20-color);
  padding: 0;
}

.agent-status .tooltip-timer .cumulativeStateTimer,
.agent-status .tooltip-timer .cumulativeStateTimer.ellipsis-timer {
  display: inline;

  max-width: unset;
  overflow: unset;
  text-overflow: unset;
  white-space: unset;
  width: unset;
}

.agent-status .cumulativeStateTimer {
  margin-right: var(--space-token-cardinal);
}

.agent-status .cumulativeStateTimer.ellipsis-timer {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: var(--full-half-width);
}

.agent-status .cumulativeStateTimer .agent-current-status-timer {
  display: inline;
  margin: 0;
  padding: 0 var(--space-token-cardinal);
}

.agent-state-button::part(button) {
  width: var(--full-status-width);
  align-items: center;
}

.state-menu-overlay::part(overlay-content) {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-height: var(--state-selector-height);
  padding-top: var(--padding-10);
  padding-left: var(--padding-8);
  padding-right: var(--padding-8);
  padding-bottom: var(--padding-8);
}

.state-selector-list {
  align-content: flex-start;
  display: block;
  overflow: auto;
  overflow-x: hidden;
  padding-left: var(--padding-2);
  padding-right: var(--padding-2);
  padding-bottom: var(--padding-2);
}

.engagedStatus {
  position: relative;
  bottom: var(--current-status-max-width);
}
.engagedStatus .engagedTooltip {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  left: calc(8px);
  top: calc(1.5px);
}
.state-list-hide {
  display: none;
}

.state-input-wrapper {
  height: var(--state-input-height);
  padding-left: var(--padding-2);
  padding-right: var(--padding-2);
  padding-top: var(--padding-2);
}

div.no-record {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(var(--space-token-cardinal) * 2);
  position: relative;
  text-align: center;
  min-height: 200px;
}

.no-record-found {
  position: relative;
  top: 11px;
}
.search-error {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-small);
}
.search-block-error {
  display: flex;
  align-items: center;
  padding: var(--padding-16);
  min-height: 200px;
}

.state-no-match-span {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
}

.state-no-match {
  padding: calc(var(--space-token-cardinal) * 2);
  position: relative;
  top: 50%;
  text-align: center;
}

.state-no-match img {
  display: block;
  margin: auto;
}

.state-no-match span {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
}

.state-item-highlight {
  background-color: var(--md-alert-info-bg-color, --md-alert-info-bg-color-default);
}

.state-list__loading {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  margin: auto;
  min-height: 180px;
}

.infinite-menu-list {
  display: flex;
  place-content: center flex-start;
  align-items: center;
  flex-flow: row;
  box-sizing: border-box;
  color: var(--list-text-color, #121212);
  flex: 1 1 auto;
  font-size: 0.875rem;
  line-height: 1.125rem;
  min-height: 2.25rem;
  padding: 0.5rem 1rem !important;
  position: relative;
  cursor: pointer;
  overflow-x: hidden;
}

.infinite-menu-list:hover {
  background-color: var(--list-hover-background, #c9f4ff);
}
.infinite-menu-list.selected {
  background-color: var(--list-active-background, #91ebff);
}
.infinite-menu-list.hovered {
  outline: none;
  box-shadow: var(--focused-list-shadow);
}
.infinite-scroll-error {
  height: auto !important;
}

.fixed-size-list {
  overflow-x: hidden;

  ul {
    margin: 0;
  }
}

@media (max-width: 736px) {
  .agent-status .ax-current-status-label.half-width,
  .agent-status .cumulativeStateTimer.ellipsis-timer {
    width: var(--compact-half-width);
  }

  .state-menu-overlay::part(overlay-content) {
    width: var(--compact-status-width);
  }

  .agent-state-button::part(button) {
    width: var(--compact-status-width);
  }

  .agent-status-option-text {
    width: var(--compact-menu-item-width);
  }
}

@media (forced-colors: active) {
  .agent-state-button::part(button) {
    border: 1px solid CanvasText;
  }

  .status-indicator-container svg,
  .agent-status-select-option-badge .available-raw-icon svg {
    background-color: CanvasText;
  }
  .status-indicator-container path,
  .agent-status-select-option-badge .available-raw-icon path {
    fill: Canvas;
  }
}

.infinite-menu-list svg {
  position: relative;
}
/* .infinite-menu-list .ellipsis-text {
  width: 210px;
} */
`, "",{"version":3,"sources":["webpack://./src/direflow-components/AgentStateSelector/index.css"],"names":[],"mappings":"AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,6BAA6B;EAC7B,mCAAmC;EACnC,sCAAsC;EACtC,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA,oFAAoF;AACpF;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uEAAuE;EACvE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uEAAuE;EACvE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uEAAuE;EACvE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,oDAAoD;EACpD,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,oDAAoD;EACpD,sEAAsE;AACxE;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,6CAA6C;EAC7C,wFAAwF;;EAExF;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,iDAAiD;EACjD,UAAU;AACZ;;AAEA;;EAEE,eAAe;;EAEf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,wCAAwC;EACxC,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uDAAuD;AACzD;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;;EAElB;IACE,SAAS;EACX;AACF;;AAEA;EACE;;IAEE,gCAAgC;EAClC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;;GAEG","sourcesContent":["@import \"../../css/variables.css\";\n\n.agent-status {\n  --full-menu-item-width: calc(218px);\n  --full-status-width: calc(260px);\n  --full-half-width: calc(99px);\n  --compact-status-width: calc(184px);\n  --compact-menu-item-width: calc(150px);\n  --compact-half-width: calc(61px);\n  --state-input-height: calc(42px);\n  --state-selector-height: calc(344px);\n  --state-selector-min-height: calc(164px);\n  --current-status-max-width: calc(1px);\n  --agent-state-selector-padding: calc(10px);\n}\n\n.menu-list {\n  height: 100%;\n  margin: 0;\n  overflow-y: hidden;\n  width: 100%;\n}\n\n.md-menu-item-container {\n  width: 100%;\n}\n/* Adding padding top to make the focus border on the first state selector visible */\nmd-list-item:first-child {\n  padding-top: 0.125rem;\n}\n\n.agent-status .status-menu-item {\n  border: 0;\n  border-radius: var(--advance-list-border-radius-rounded, 0);\n}\n\n.agent-status-select-option-badge {\n  display: inline-flex;\n  align-items: center;\n}\n\n.agent-status-select-option-badge svg {\n  width: 13.5px;\n  height: 13.5px;\n  position: absolute;\n}\n\n.agent-status-select-option-badge .available-raw-icon {\n  width: 13.5px;\n  height: 13.5px;\n  background-color: var(--md-primary-one-bg-color, --md-primary-bg-color);\n  border-radius: 50%;\n  color: var(--avatar-presence-active);\n}\n\n.agent-status-select-option-badge .idle-raw-icon {\n  width: 13.5px;\n  height: 13.5px;\n  background-color: var(--md-primary-one-bg-color, --md-primary-bg-color);\n  border-radius: 50%;\n  color: var(--avatar-presence-inactive);\n}\n\n.status-button__children {\n  color: var(--md-button-secondary-text-color);\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.status-button__children .status-indicator-container {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.status-button__children svg {\n  width: 13.5px;\n  height: 13.5px;\n  background-color: var(--md-primary-one-bg-color, --md-primary-bg-color);\n  border-radius: 50%;\n  display: inline-flex;\n}\n\n.available-icon-color {\n  color: var(--avatar-presence-active);\n}\n\n.idle-icon-color {\n  color: var(--avatar-presence-inactive);\n}\n\n.rona-icon-color {\n  color: var(--avatar-presence-busy);\n}\n\n.engaged-icon-color {\n  color: var(--avatar-presence-engaged);\n}\n\n.agent-status .status-indicator {\n  box-sizing: border-box;\n  color: var(--md-presence-away-bg-color);\n  margin: 0;\n}\n\n.agent-status .status-indicator.green-status {\n  color: var(--md-green-60);\n}\n\n.agent-status .status-indicator.yellow-status {\n  color: var(--md-yellow-60);\n}\n\n.agent-status .status-indicator.red-status {\n  color: var(--md-presence-do-not-disturb-bg-color);\n}\n\n.agent-status .ax-current-status-label {\n  flex-grow: 1;\n  text-align: left;\n  width: 1%;\n  padding: 0.5px 0 0 calc(var(--space-token-cardinal) * 2);\n}\n\n.agent-status .ax-current-status-label.half-width {\n  width: var(--full-half-width);\n}\n\n.agent-status-option-text {\n  display: block;\n  font-size: var(--font-size-medium);\n  padding: 0 0 0 calc(var(--space-token-cardinal) * 2);\n  width: var(--full-menu-item-width);\n}\n\n.agent-status-option-list {\n  display: block;\n  font-size: var(--font-size-medium);\n  padding: 0 0 0 calc(var(--space-token-cardinal) * 2);\n  width: calc(var(--full-menu-item-width) - var(--space-token-cardinal));\n}\n\n.ellipsis-text {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agent-status .agent-current-status-timer {\n  color: var(--md-primary-text-color);\n  display: inline-flex;\n  align-items: center;\n  flex-grow: 0;\n  font-size: var(--font-size-small);\n  height: calc(var(--space-token-cardinal) * 2);\n  padding: 0 calc(var(--space-token-cardinal) * 2) 0 calc(var(--space-token-cardinal) * 2);\n\n  &.medium-font {\n    font-size: var(--font-size-medium);\n  }\n}\n\n.agent-status .agent-current-status-timer.tooltip-text-color {\n  color: var(--tooltip-font-color, --gray-20-color);\n  padding: 0;\n}\n\n.agent-status .tooltip-timer .cumulativeStateTimer,\n.agent-status .tooltip-timer .cumulativeStateTimer.ellipsis-timer {\n  display: inline;\n\n  max-width: unset;\n  overflow: unset;\n  text-overflow: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.agent-status .cumulativeStateTimer {\n  margin-right: var(--space-token-cardinal);\n}\n\n.agent-status .cumulativeStateTimer.ellipsis-timer {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: var(--full-half-width);\n}\n\n.agent-status .cumulativeStateTimer .agent-current-status-timer {\n  display: inline;\n  margin: 0;\n  padding: 0 var(--space-token-cardinal);\n}\n\n.agent-state-button::part(button) {\n  width: var(--full-status-width);\n  align-items: center;\n}\n\n.state-menu-overlay::part(overlay-content) {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  max-height: var(--state-selector-height);\n  padding-top: var(--padding-10);\n  padding-left: var(--padding-8);\n  padding-right: var(--padding-8);\n  padding-bottom: var(--padding-8);\n}\n\n.state-selector-list {\n  align-content: flex-start;\n  display: block;\n  overflow: auto;\n  overflow-x: hidden;\n  padding-left: var(--padding-2);\n  padding-right: var(--padding-2);\n  padding-bottom: var(--padding-2);\n}\n\n.engagedStatus {\n  position: relative;\n  bottom: var(--current-status-max-width);\n}\n.engagedStatus .engagedTooltip {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  left: calc(8px);\n  top: calc(1.5px);\n}\n.state-list-hide {\n  display: none;\n}\n\n.state-input-wrapper {\n  height: var(--state-input-height);\n  padding-left: var(--padding-2);\n  padding-right: var(--padding-2);\n  padding-top: var(--padding-2);\n}\n\ndiv.no-record {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: calc(var(--space-token-cardinal) * 2);\n  position: relative;\n  text-align: center;\n  min-height: 200px;\n}\n\n.no-record-found {\n  position: relative;\n  top: 11px;\n}\n.search-error {\n  display: flex;\n  flex-direction: row;\n  column-gap: 8px;\n  align-items: center;\n  font-size: var(--font-size-small);\n}\n.search-block-error {\n  display: flex;\n  align-items: center;\n  padding: var(--padding-16);\n  min-height: 200px;\n}\n\n.state-no-match-span {\n  font-size: var(--font-size-medium);\n  margin: 0 calc(var(--space-token-even) * 8);\n  margin-bottom: auto;\n}\n\n.state-no-match {\n  padding: calc(var(--space-token-cardinal) * 2);\n  position: relative;\n  top: 50%;\n  text-align: center;\n}\n\n.state-no-match img {\n  display: block;\n  margin: auto;\n}\n\n.state-no-match span {\n  font-size: var(--font-size-medium);\n  margin: 0 calc(var(--space-token-even) * 8);\n  margin-bottom: auto;\n}\n\n.state-item-highlight {\n  background-color: var(--md-alert-info-bg-color, --md-alert-info-bg-color-default);\n}\n\n.state-list__loading {\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  align-items: center;\n  margin: auto;\n  min-height: 180px;\n}\n\n.infinite-menu-list {\n  display: flex;\n  place-content: center flex-start;\n  align-items: center;\n  flex-flow: row;\n  box-sizing: border-box;\n  color: var(--list-text-color, #121212);\n  flex: 1 1 auto;\n  font-size: 0.875rem;\n  line-height: 1.125rem;\n  min-height: 2.25rem;\n  padding: 0.5rem 1rem !important;\n  position: relative;\n  cursor: pointer;\n  overflow-x: hidden;\n}\n\n.infinite-menu-list:hover {\n  background-color: var(--list-hover-background, #c9f4ff);\n}\n.infinite-menu-list.selected {\n  background-color: var(--list-active-background, #91ebff);\n}\n.infinite-menu-list.hovered {\n  outline: none;\n  box-shadow: var(--focused-list-shadow);\n}\n.infinite-scroll-error {\n  height: auto !important;\n}\n\n.fixed-size-list {\n  overflow-x: hidden;\n\n  ul {\n    margin: 0;\n  }\n}\n\n@media (max-width: 736px) {\n  .agent-status .ax-current-status-label.half-width,\n  .agent-status .cumulativeStateTimer.ellipsis-timer {\n    width: var(--compact-half-width);\n  }\n\n  .state-menu-overlay::part(overlay-content) {\n    width: var(--compact-status-width);\n  }\n\n  .agent-state-button::part(button) {\n    width: var(--compact-status-width);\n  }\n\n  .agent-status-option-text {\n    width: var(--compact-menu-item-width);\n  }\n}\n\n@media (forced-colors: active) {\n  .agent-state-button::part(button) {\n    border: 1px solid CanvasText;\n  }\n\n  .status-indicator-container svg,\n  .agent-status-select-option-badge .available-raw-icon svg {\n    background-color: CanvasText;\n  }\n  .status-indicator-container path,\n  .agent-status-select-option-badge .available-raw-icon path {\n    fill: Canvas;\n  }\n}\n\n.infinite-menu-list svg {\n  position: relative;\n}\n/* .infinite-menu-list .ellipsis-text {\n  width: 210px;\n} */\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AppTitle/index.css":
/*!**********************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AppTitle/index.css ***!
  \**********************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../node_modules/css-loader/dist/cjs.js!../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-title-container {
  --padding-logo: 24px;
  --logo-width: calc(96px + var(--padding-logo));
  --content-height: 32px;
  --padding: 0.75rem;
  max-width: 304px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  height: var(--content-height);
  padding: var(--padding) 0px var(--padding) 0;
}

.app-title-container.momentum-style {
  padding-left: 0.25rem;
}

.app-title-container.is-visual-rebrand {
  padding-left: 0.75rem;
}

.app-title-container .logo {
  height: inherit;
  align-items: center;
  display: flex;
  justify-content: center;
  max-width: calc(var(--logo-width));
}

.app-title-container .logo--img {
  width: inherit;
  height: inherit;
  max-width: calc(var(--logo-width));
  padding: 0 var(--padding);
}

.app-title-container .title {
  font-size: var(--font-size-large);
  color: var(--md-primary-text-color);
  padding: 0 4px 0 var(--padding);
  display: flex;
  align-items: center;
}
.app-title-container .title-img {
  font-size: var(--font-size-large);
  color: var(--md-primary-text-color);
  padding: 0 4px 0 var(--padding);
  height: var(--content-height);
  display: flex;
  align-items: center;
}
.app-title-container .temp-title {
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  font-size: var(--font-size-large);
  white-space: nowrap;
}

.app-title-container .dynamic-title-width {
  white-space: unset;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/AppTitle/index.css"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,8CAA8C;EAC9C,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,+BAA+B;EAC/B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B","sourcesContent":["@import \"../../css/variables.css\";\n\n.app-title-container {\n  --padding-logo: 24px;\n  --logo-width: calc(96px + var(--padding-logo));\n  --content-height: 32px;\n  --padding: 0.75rem;\n  max-width: 304px;\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  height: var(--content-height);\n  padding: var(--padding) 0px var(--padding) 0;\n}\n\n.app-title-container.momentum-style {\n  padding-left: 0.25rem;\n}\n\n.app-title-container.is-visual-rebrand {\n  padding-left: 0.75rem;\n}\n\n.app-title-container .logo {\n  height: inherit;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  max-width: calc(var(--logo-width));\n}\n\n.app-title-container .logo--img {\n  width: inherit;\n  height: inherit;\n  max-width: calc(var(--logo-width));\n  padding: 0 var(--padding);\n}\n\n.app-title-container .title {\n  font-size: var(--font-size-large);\n  color: var(--md-primary-text-color);\n  padding: 0 4px 0 var(--padding);\n  display: flex;\n  align-items: center;\n}\n.app-title-container .title-img {\n  font-size: var(--font-size-large);\n  color: var(--md-primary-text-color);\n  padding: 0 4px 0 var(--padding);\n  height: var(--content-height);\n  display: flex;\n  align-items: center;\n}\n.app-title-container .temp-title {\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  font-size: var(--font-size-large);\n  white-space: nowrap;\n}\n\n.app-title-container .dynamic-title-width {\n  white-space: unset;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/EnterpriseSearch/styles.css":
/*!*************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/EnterpriseSearch/styles.css ***!
  \*************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.org-search-container {
  display: flex;
  height: var(--tab-height);
}

.org-search-container md-input {
  width: 100%;
}

.org-search-container.max-width {
  flex-direction: column;
}

.org-search-spinner {
  display: flex;
  justify-content: center;
  height: var(--content-height-with-ani);
  align-items: center;
  margin: auto;
}

.organization-users-list {
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  height: var(--content-height-with-ani);
}

.organization-auth-error,
.organization-auth-error md-icon,
.organization-auth-error md-link::part(link) {
  font-size: var(--font-size-small);
  color: var(--link-inline);
  display: flex;
  align-items: center;
}

.organization-auth-error .auth-error-message {
  margin: 0 calc(var(--space-token-even) * 4);
}

.organization-users-list .address-book-increased-limit-list .address-book-increased-limit-list-item,
.organization-users-list .address-book-increased-limit-list .infinite-scroll-error {
  padding-left: 0.25rem !important;
}

.refresh-spinner {
  margin: auto calc(var(--space-token-even) * 3) auto calc(var(--space-token-even) * 7);
  width: calc(var(--space-token-even) * 14);
}
.address-book-increased-limit-list:not(.set-focus-visible):focus {
  border: none;
  outline: none;
}
.address-book-increased-limit-list:not(.set-focus-visible):focus-visible {
  border: none;
  outline: none;
}

.address-book-increased-limit-list .address-book-increased-limit-list-item {
  padding-left: 15px !important;
}
.address-book-increased-limit-list .address-book-increased-limit-list-item:hover {
  background-color: var(--list-hover-background, #c9f4ff);
}
.address-book-increased-limit-list .address-book-increased-limit-list-item.hovered {
  outline: none;
  box-shadow: var(--focused-list-shadow);
}

.address-book-increased-limit .address-book-increased-limit-list-item.selected {
  background-color: var(--list-active-background, #c9f4ff);
}

.address-book-increased-limit .address-book-increased-limit-list-item.selected.hovered {
  outline: none;
}

.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-name {
  color: var(--list-active-text-color);
}

.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-dn {
  color: var(--list-active-text-color);
}

.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-name {
  color: var(--list-hover-text-color);
}

.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-dn {
  color: var(--list-hover-text-color);
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/EnterpriseSearch/styles.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;;;EAGE,iCAAiC;EACjC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,qFAAqF;EACrF,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,uDAAuD;AACzD;AACA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["@import \"../../../../css/variables.css\";\n\n.org-search-container {\n  display: flex;\n  height: var(--tab-height);\n}\n\n.org-search-container md-input {\n  width: 100%;\n}\n\n.org-search-container.max-width {\n  flex-direction: column;\n}\n\n.org-search-spinner {\n  display: flex;\n  justify-content: center;\n  height: var(--content-height-with-ani);\n  align-items: center;\n  margin: auto;\n}\n\n.organization-users-list {\n  margin-top: 0.25rem;\n  margin-bottom: 0.5rem;\n  height: var(--content-height-with-ani);\n}\n\n.organization-auth-error,\n.organization-auth-error md-icon,\n.organization-auth-error md-link::part(link) {\n  font-size: var(--font-size-small);\n  color: var(--link-inline);\n  display: flex;\n  align-items: center;\n}\n\n.organization-auth-error .auth-error-message {\n  margin: 0 calc(var(--space-token-even) * 4);\n}\n\n.organization-users-list .address-book-increased-limit-list .address-book-increased-limit-list-item,\n.organization-users-list .address-book-increased-limit-list .infinite-scroll-error {\n  padding-left: 0.25rem !important;\n}\n\n.refresh-spinner {\n  margin: auto calc(var(--space-token-even) * 3) auto calc(var(--space-token-even) * 7);\n  width: calc(var(--space-token-even) * 14);\n}\n.address-book-increased-limit-list:not(.set-focus-visible):focus {\n  border: none;\n  outline: none;\n}\n.address-book-increased-limit-list:not(.set-focus-visible):focus-visible {\n  border: none;\n  outline: none;\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item {\n  padding-left: 15px !important;\n}\n.address-book-increased-limit-list .address-book-increased-limit-list-item:hover {\n  background-color: var(--list-hover-background, #c9f4ff);\n}\n.address-book-increased-limit-list .address-book-increased-limit-list-item.hovered {\n  outline: none;\n  box-shadow: var(--focused-list-shadow);\n}\n\n.address-book-increased-limit .address-book-increased-limit-list-item.selected {\n  background-color: var(--list-active-background, #c9f4ff);\n}\n\n.address-book-increased-limit .address-book-increased-limit-list-item.selected.hovered {\n  outline: none;\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-name {\n  color: var(--list-active-text-color);\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-dn {\n  color: var(--list-active-text-color);\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-name {\n  color: var(--list-hover-text-color);\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-dn {\n  color: var(--list-hover-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/ErrorModal/styles.css":
/*!*******************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/ErrorModal/styles.css ***!
  \*******************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal .error-modal-body {
  margin: 0 var(--space-token-cardinal);
  color: var(--md-secondary-text-color);
}

.error-modal .error-message {
  margin-bottom: calc(var(--space-token-cardinal) * 3);
}

.md-modal__footer {
  display: flex;
}

.error-modal-btn {
  margin-left: 0.5rem;
}
md-modal::part(modal-body) {
  overflow: hidden;
}

@media screen and (max-height: 550px) {
  md-modal::part(modal-container) {
    max-height: calc(100vh - 5%);
  }

  md-modal::part(modal-content) {
    max-height: calc(100vh);
    overflow-y: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/ErrorModal/styles.css"],"names":[],"mappings":"AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;AACF","sourcesContent":["@import \"../../../../css/variables.css\";\n\n.error-modal .error-modal-body {\n  margin: 0 var(--space-token-cardinal);\n  color: var(--md-secondary-text-color);\n}\n\n.error-modal .error-message {\n  margin-bottom: calc(var(--space-token-cardinal) * 3);\n}\n\n.md-modal__footer {\n  display: flex;\n}\n\n.error-modal-btn {\n  margin-left: 0.5rem;\n}\nmd-modal::part(modal-body) {\n  overflow: hidden;\n}\n\n@media screen and (max-height: 550px) {\n  md-modal::part(modal-container) {\n    max-height: calc(100vh - 5%);\n  }\n\n  md-modal::part(modal-content) {\n    max-height: calc(100vh);\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/SearchBar/styles.css":
/*!******************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/SearchBar/styles.css ***!
  \******************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar {
  padding: 11px 14px;
}
.search-input::part(md-input-container) {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/SearchBar/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".search-bar {\n  padding: 11px 14px;\n}\n.search-input::part(md-input-container) {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/styles.css":
/*!********************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/styles.css ***!
  \********************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../node_modules/css-loader/dist/cjs.js!../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-main {
  /* CSS variables for inline errors */
  --common-margin-spacing: 16px;
  --error-main-padding: 0 2rem;

  /* styling for error main */
  position: relative;
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: var(--font-family);
  padding: var(--error-main-padding);
  top: 30%;
}

.error-main .error-header {
  font-size: var(--font-size-medium);
  margin-bottom: 0;
  color: var(--md-primary-text-color-default);
  font-weight: 500;
  text-align: center;
  line-height: 19px;
}

.error-main .error-sub-message {
  font-size: var(--font-size-medium);
  color: var(--md-secondary-text-color, --gray-70-color);
  line-height: 19px;
}

.error-main .try-again-button {
  margin: calc(var(--space-token-even) * 12) 0 calc(var(--space-token-even) * 12) 0;
}

.error-main .tech-error__illustration {
  margin-bottom: calc(var(--space-token-even) * 8);
}

.error-main .learn-more-details-wrapper {
  font-size: var(--font-size-small);
  line-height: 125%;
  color: var(--md-primary-text-color);
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/Common/components/styles.css"],"names":[],"mappings":"AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;;EAE5B,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,kCAAkC;EAClC,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,sDAAsD;EACtD,iBAAiB;AACnB;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mCAAmC;AACrC","sourcesContent":["@import \"../../../css/variables.css\";\n\n.error-main {\n  /* CSS variables for inline errors */\n  --common-margin-spacing: 16px;\n  --error-main-padding: 0 2rem;\n\n  /* styling for error main */\n  position: relative;\n  width: 100%;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  font-family: var(--font-family);\n  padding: var(--error-main-padding);\n  top: 30%;\n}\n\n.error-main .error-header {\n  font-size: var(--font-size-medium);\n  margin-bottom: 0;\n  color: var(--md-primary-text-color-default);\n  font-weight: 500;\n  text-align: center;\n  line-height: 19px;\n}\n\n.error-main .error-sub-message {\n  font-size: var(--font-size-medium);\n  color: var(--md-secondary-text-color, --gray-70-color);\n  line-height: 19px;\n}\n\n.error-main .try-again-button {\n  margin: calc(var(--space-token-even) * 12) 0 calc(var(--space-token-even) * 12) 0;\n}\n\n.error-main .tech-error__illustration {\n  margin-bottom: calc(var(--space-token-even) * 8);\n}\n\n.error-main .learn-more-details-wrapper {\n  font-size: var(--font-size-small);\n  line-height: 125%;\n  color: var(--md-primary-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/ContactHistory/styles/styles.css":
/*!************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/ContactHistory/styles/styles.css ***!
  \************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../node_modules/css-loader/dist/cjs.js!../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-history * {
  --main-container-padding: 1rem;
  --main-header-padding: 0.625rem 1rem;
  --header-font-color: var(--md-primary-text-color);

  --date-badge-pad: 0.25rem 0.625rem;
  --line-height-14: 0.875rem;
  --line-height-16: 1rem;

  --timeline-line-width: 0.0625rem;
  --timeline-line-padd-left: 20px;
  --timeline-header-pad: 0.125rem 0;
  --timeline-item-padding: 0.625rem 0.875rem;
  --timeline-item-mar-left: 3.75rem;
  --talk-duration-pad-left: 0.25rem;
  --timeline-icon-dimention: 2rem;
  --timeline-icon-left: 1.1rem;
  --timeline-icon-top: 0.9375rem;
  --timeline-pad-bot: 0.625rem;
  --error-icon-mar-bot: 1.563rem;
  --error-head-mar-bot: 0.5rem;
  --error-code-mar-bot: 2.5rem;
  --inline-error-height: 24px;
  --inline-error-padding: calc(calc(var(--space-token-cardinal) * 2) * 2) calc(var(--space-token-cardinal) * 2);
  --contact-history-info-height: 160px;
}

.contact-history {
  position: relative;
  background: var(--md-primary-bg-color);
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.timeline {
  position: relative;
  font-family: var(--font-family);
  margin-bottom: -10px; /** this is needed to join the timeline line for each group/date*/
  padding-bottom: var(--timeline-pad-bot);
  list-style: none;
}

.timeline-main-container {
  padding: var(--main-container-padding);
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  margin: 0;
}

/* timeline straight line*/
.timeline:before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: var(--timeline-line-width);
  background: var(--grey-color);
  left: var(--timeline-line-padd-left);
  margin: 0;
}
/* remove extra tail line from last node*/
.timeline-main-container .timeline:last-child:before {
  bottom: 32px;
}

.timeline-spinner {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-record-found-prev {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--md-primary-text-color);
}

.no-record-found {
  padding: calc(var(--space-token-cardinal) * 2);
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}

.no-record-found img {
  display: block;
  margin: auto;
}
.no-record-found span {
  color: var(--md-primary-text-color);
  text-align: center;
}

.timeline .timeline-item--entry {
  list-style: none;
  display: flex;
  flex-direction: row;
  margin: 1rem 0;
}

.timeline .timeline-item {
  margin-left: 0.75rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.timeline .timeline-item:focus {
  outline: none;
  box-shadow: var(--focused-momentum-shadow);
}

.timeline .timeline-item > .timeline-body {
  padding-top: 0.2rem;
  display: flex;
  font-size: var(--font-size-small);
  color: var(--md-secondary-text-color);
  line-height: 1.5;
}

.timeline .timeline-body md-link {
  display: block;
}

.timeline .timeline-sublist {
  margin: 0;
  padding-left: 2px;
}

.timeline > md-badge::part(badge) {
  border-color: var(--grey-color);
  padding: 4px 12px;
  height: 26px;
  color: var(--md-secondary-text-color, --md-secondary-text-color-default);
}

.transcript-available {
  cursor: pointer;
}

.timeline .timeline-item > .timeline-header {
  color: var(--header-font-color);
  line-height: var(--line-height-16);
  padding: var(--timeline-header-pad);
  display: flex;
}

.flex-1 {
  flex: 1;
}

ul.timeline > li {
  margin-bottom: 10px;
  padding-top: 0;
  display: flex;
}

ul.timeline > li > .icon {
  width: var(--timeline-icon-dimention);
  height: var(--timeline-icon-dimention);
  background: var(--gray-10-color);
  color: var(--black-color);
  border-radius: 50%;
  left: var(--timeline-icon-left);
  top: var(--timeline-icon-top);
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeline-item .accepting-time {
  color: var(--md-secondary-text-color);
  font-size: var(--font-size-small);
  display: flex;
}

.timeline-item .accepting-time i {
  padding-right: 0.3em;
}

.timeline-item .accepting-time > span {
  padding-left: var(--talk-duration-pad-left);
}

/** Error loading*/
.error-main {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: var(--font-family);
  height: 100%;
}

.transcript-info {
  --info-padding-top: calc(var(--space-token-cardinal) + var(--space-token-even));
  --info-padding-right: calc(var(--space-token-cardinal) * 4);
  --info-padding-left: calc(var(--space-token-cardinal) * 3);
  border-bottom: var(--border);
  font-size: var(--font-size-small);
  padding: var(--info-padding-top) var(--info-padding-right) calc(var(--space-token-cardinal) * 2)
    var(--info-padding-left);
}

.transcript-info dt {
  font-weight: 400; /* Overriding momemtum css on dt element*/
  font-family: var(--font-family-light);
  width: 15%;
}

.transcript-info dd {
  margin-bottom: 0;
}

.transcript-info dt::after {
  content: ":";
  padding-right: calc(var(--space-token-cardinal) * 2);
}

.transcript-info > div {
  display: flex;
}

.email-transcript {
  height: 100%;
  width: calc(100% - var(--border-width));
  border: var(--border-0);
  position: absolute;
  left: 100%;
  top: 10px;
  background-color: var(--md-primary-bg-color);
  box-shadow: var(--common-box-shadow);
  color: var(--md-primary-text-color);
}

#backTranscipt .icon-padding {
  margin-right: calc(var(--space-token-cardinal) * 2);
}

.transcript-sender-type {
  margin-left: calc(1em * 0.5);
}

.transcript-sender-date {
  color: var(--md-secondary-text-color);
}

.slideIn {
  animation: var(--animation-slideIn);
}

.slideOut {
  animation: var(--animation-slideOut);
}

.transcript-content {
  animation: var(--animation-fadeIn);
  height: 100%;
}

.email-transcript .link-button {
  font-size: var(--font-size-medium);
  color: var(--link-color);
  padding-left: 0.625rem;
  padding-top: 0.625rem;
  display: block;
}

.email-transcript-content {
  height: calc(100% - var(--contact-history-info-height));
  overflow-y: scroll;
  padding: calc(var(--space-token-cardinal) * 2) calc(calc(var(--space-token-cardinal) * 2) * 2)
    calc(var(--space-token-cardinal) * 2) calc(calc(var(--space-token-cardinal) * 2) * 1.5);
}

.email-transcript-content pre {
  word-wrap: break-word;
  white-space: normal;
  font-family: var(--font-family) !important; /* need to override font family of email */
  font-size: var(--font-size-medium) !important;
}

.email-transcript-content pre * {
  font-family: var(--font-family) !important; /* need to override font family of email */
}

.email-transcript-content .sender-detail {
  display: flex;
  justify-content: space-between;
  font-size: var(--font-size-small);
  padding-bottom: calc(var(--space-token-cardinal) * 2);
}

.email-transcript-content .sender-detail > span:first-child {
  font-family: var(--font-family-bold);
}

.email-transcript-content .sender-detail > span:first-child > span {
  font-family: var(--font-family-light);
}

.inline-error {
  display: flex;
  align-items: center;
  font-size: var(--font-size-small);
  border: var(--border);
  justify-content: space-around;
  padding: var(--inline-error-padding);
  border-radius: var(--border-radius-large);
}

.inline-error .md-button {
  font-size: var(--font-size-small);
  height: var(--inline-error-height);
}

.inline-error dt {
  font-weight: 400; /* Overriding momemtum css on dt element*/
}

@media (forced-colors: active) {
  /* contact history  */
  .timeline .timeline-item:focus {
    outline: 1px solid Highlight;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/ContactHistory/styles/styles.css"],"names":[],"mappings":"AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,iDAAiD;;EAEjD,kCAAkC;EAClC,0BAA0B;EAC1B,sBAAsB;;EAEtB,gCAAgC;EAChC,+BAA+B;EAC/B,iCAAiC;EACjC,0CAA0C;EAC1C,iCAAiC;EACjC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,6GAA6G;EAC7G,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB,EAAE,iEAAiE;EACvF,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,SAAS;AACX;AACA,yCAAyC;AACzC;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,YAAY;EACZ,wEAAwE;AAC1E;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,+EAA+E;EAC/E,2DAA2D;EAC3D,0DAA0D;EAC1D,4BAA4B;EAC5B,iCAAiC;EACjC;4BAC0B;AAC5B;;AAEA;EACE,gBAAgB,EAAE,yCAAyC;EAC3D,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,4CAA4C;EAC5C,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;EAClB;2FACyF;AAC3F;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C,EAAE,0CAA0C;EACtF,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C,EAAE,0CAA0C;AACxF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iCAAiC;EACjC,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA;EACE,qBAAqB;EACrB;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;AACF","sourcesContent":["@import \"../../../css/variables.css\";\n\n.contact-history * {\n  --main-container-padding: 1rem;\n  --main-header-padding: 0.625rem 1rem;\n  --header-font-color: var(--md-primary-text-color);\n\n  --date-badge-pad: 0.25rem 0.625rem;\n  --line-height-14: 0.875rem;\n  --line-height-16: 1rem;\n\n  --timeline-line-width: 0.0625rem;\n  --timeline-line-padd-left: 20px;\n  --timeline-header-pad: 0.125rem 0;\n  --timeline-item-padding: 0.625rem 0.875rem;\n  --timeline-item-mar-left: 3.75rem;\n  --talk-duration-pad-left: 0.25rem;\n  --timeline-icon-dimention: 2rem;\n  --timeline-icon-left: 1.1rem;\n  --timeline-icon-top: 0.9375rem;\n  --timeline-pad-bot: 0.625rem;\n  --error-icon-mar-bot: 1.563rem;\n  --error-head-mar-bot: 0.5rem;\n  --error-code-mar-bot: 2.5rem;\n  --inline-error-height: 24px;\n  --inline-error-padding: calc(calc(var(--space-token-cardinal) * 2) * 2) calc(var(--space-token-cardinal) * 2);\n  --contact-history-info-height: 160px;\n}\n\n.contact-history {\n  position: relative;\n  background: var(--md-primary-bg-color);\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.timeline {\n  position: relative;\n  font-family: var(--font-family);\n  margin-bottom: -10px; /** this is needed to join the timeline line for each group/date*/\n  padding-bottom: var(--timeline-pad-bot);\n  list-style: none;\n}\n\n.timeline-main-container {\n  padding: var(--main-container-padding);\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n  margin: 0;\n}\n\n/* timeline straight line*/\n.timeline:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: var(--timeline-line-width);\n  background: var(--grey-color);\n  left: var(--timeline-line-padd-left);\n  margin: 0;\n}\n/* remove extra tail line from last node*/\n.timeline-main-container .timeline:last-child:before {\n  bottom: 32px;\n}\n\n.timeline-spinner {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.no-record-found-prev {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--md-primary-text-color);\n}\n\n.no-record-found {\n  padding: calc(var(--space-token-cardinal) * 2);\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  text-align: center;\n}\n\n.no-record-found img {\n  display: block;\n  margin: auto;\n}\n.no-record-found span {\n  color: var(--md-primary-text-color);\n  text-align: center;\n}\n\n.timeline .timeline-item--entry {\n  list-style: none;\n  display: flex;\n  flex-direction: row;\n  margin: 1rem 0;\n}\n\n.timeline .timeline-item {\n  margin-left: 0.75rem;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.timeline .timeline-item:focus {\n  outline: none;\n  box-shadow: var(--focused-momentum-shadow);\n}\n\n.timeline .timeline-item > .timeline-body {\n  padding-top: 0.2rem;\n  display: flex;\n  font-size: var(--font-size-small);\n  color: var(--md-secondary-text-color);\n  line-height: 1.5;\n}\n\n.timeline .timeline-body md-link {\n  display: block;\n}\n\n.timeline .timeline-sublist {\n  margin: 0;\n  padding-left: 2px;\n}\n\n.timeline > md-badge::part(badge) {\n  border-color: var(--grey-color);\n  padding: 4px 12px;\n  height: 26px;\n  color: var(--md-secondary-text-color, --md-secondary-text-color-default);\n}\n\n.transcript-available {\n  cursor: pointer;\n}\n\n.timeline .timeline-item > .timeline-header {\n  color: var(--header-font-color);\n  line-height: var(--line-height-16);\n  padding: var(--timeline-header-pad);\n  display: flex;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\nul.timeline > li {\n  margin-bottom: 10px;\n  padding-top: 0;\n  display: flex;\n}\n\nul.timeline > li > .icon {\n  width: var(--timeline-icon-dimention);\n  height: var(--timeline-icon-dimention);\n  background: var(--gray-10-color);\n  color: var(--black-color);\n  border-radius: 50%;\n  left: var(--timeline-icon-left);\n  top: var(--timeline-icon-top);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.timeline-item .accepting-time {\n  color: var(--md-secondary-text-color);\n  font-size: var(--font-size-small);\n  display: flex;\n}\n\n.timeline-item .accepting-time i {\n  padding-right: 0.3em;\n}\n\n.timeline-item .accepting-time > span {\n  padding-left: var(--talk-duration-pad-left);\n}\n\n/** Error loading*/\n.error-main {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  font-family: var(--font-family);\n  height: 100%;\n}\n\n.transcript-info {\n  --info-padding-top: calc(var(--space-token-cardinal) + var(--space-token-even));\n  --info-padding-right: calc(var(--space-token-cardinal) * 4);\n  --info-padding-left: calc(var(--space-token-cardinal) * 3);\n  border-bottom: var(--border);\n  font-size: var(--font-size-small);\n  padding: var(--info-padding-top) var(--info-padding-right) calc(var(--space-token-cardinal) * 2)\n    var(--info-padding-left);\n}\n\n.transcript-info dt {\n  font-weight: 400; /* Overriding momemtum css on dt element*/\n  font-family: var(--font-family-light);\n  width: 15%;\n}\n\n.transcript-info dd {\n  margin-bottom: 0;\n}\n\n.transcript-info dt::after {\n  content: \":\";\n  padding-right: calc(var(--space-token-cardinal) * 2);\n}\n\n.transcript-info > div {\n  display: flex;\n}\n\n.email-transcript {\n  height: 100%;\n  width: calc(100% - var(--border-width));\n  border: var(--border-0);\n  position: absolute;\n  left: 100%;\n  top: 10px;\n  background-color: var(--md-primary-bg-color);\n  box-shadow: var(--common-box-shadow);\n  color: var(--md-primary-text-color);\n}\n\n#backTranscipt .icon-padding {\n  margin-right: calc(var(--space-token-cardinal) * 2);\n}\n\n.transcript-sender-type {\n  margin-left: calc(1em * 0.5);\n}\n\n.transcript-sender-date {\n  color: var(--md-secondary-text-color);\n}\n\n.slideIn {\n  animation: var(--animation-slideIn);\n}\n\n.slideOut {\n  animation: var(--animation-slideOut);\n}\n\n.transcript-content {\n  animation: var(--animation-fadeIn);\n  height: 100%;\n}\n\n.email-transcript .link-button {\n  font-size: var(--font-size-medium);\n  color: var(--link-color);\n  padding-left: 0.625rem;\n  padding-top: 0.625rem;\n  display: block;\n}\n\n.email-transcript-content {\n  height: calc(100% - var(--contact-history-info-height));\n  overflow-y: scroll;\n  padding: calc(var(--space-token-cardinal) * 2) calc(calc(var(--space-token-cardinal) * 2) * 2)\n    calc(var(--space-token-cardinal) * 2) calc(calc(var(--space-token-cardinal) * 2) * 1.5);\n}\n\n.email-transcript-content pre {\n  word-wrap: break-word;\n  white-space: normal;\n  font-family: var(--font-family) !important; /* need to override font family of email */\n  font-size: var(--font-size-medium) !important;\n}\n\n.email-transcript-content pre * {\n  font-family: var(--font-family) !important; /* need to override font family of email */\n}\n\n.email-transcript-content .sender-detail {\n  display: flex;\n  justify-content: space-between;\n  font-size: var(--font-size-small);\n  padding-bottom: calc(var(--space-token-cardinal) * 2);\n}\n\n.email-transcript-content .sender-detail > span:first-child {\n  font-family: var(--font-family-bold);\n}\n\n.email-transcript-content .sender-detail > span:first-child > span {\n  font-family: var(--font-family-light);\n}\n\n.inline-error {\n  display: flex;\n  align-items: center;\n  font-size: var(--font-size-small);\n  border: var(--border);\n  justify-content: space-around;\n  padding: var(--inline-error-padding);\n  border-radius: var(--border-radius-large);\n}\n\n.inline-error .md-button {\n  font-size: var(--font-size-small);\n  height: var(--inline-error-height);\n}\n\n.inline-error dt {\n  font-weight: 400; /* Overriding momemtum css on dt element*/\n}\n\n@media (forced-colors: active) {\n  /* contact history  */\n  .timeline .timeline-item:focus {\n    outline: 1px solid Highlight;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Dialer/style.css":
/*!********************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Dialer/style.css ***!
  \********************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../node_modules/css-loader/dist/cjs.js!../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialpad-buttons {
  display: flex;
  justify-content: center;
  height: var(--content-height-with-ani);
  align-items: center;
  width: var(--dialer-width);
  flex-wrap: wrap;
  box-sizing: border-box;
}

.dialpad-button {
  padding: 6px 12px;
}

.dialpad-button-text-wrapper {
  display: flex;
  flex-direction: column;
}

.dialpad-char-btn {
  font-size: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/Dialer/style.css"],"names":[],"mappings":"AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["@import \"../../css/variables.css\";\n.dialpad-buttons {\n  display: flex;\n  justify-content: center;\n  height: var(--content-height-with-ani);\n  align-items: center;\n  width: var(--dialer-width);\n  flex-wrap: wrap;\n  box-sizing: border-box;\n}\n\n.dialpad-button {\n  padding: 6px 12px;\n}\n\n.dialpad-button-text-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.dialpad-char-btn {\n  font-size: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/EmailComposer/styles/email.css":
/*!**********************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/EmailComposer/styles/email.css ***!
  \**********************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../node_modules/css-loader/dist/cjs.js!../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-template {
  /**
  Variables defined
  */
  --text-padding: 0 1rem;
  --mini-spacing: 2px;
  --xsmall-spacing: 4px;
  --small-spacing: 8px;
  --medium-spacing: 16px;
  --large-spacing: 24px;
  --xlarge-spacing: 32px;
  --border-radius: 8px;
  --prev-thread-dim: 32px;
  --attch-fname-width: 129px;
  --attch-max-height: 48px;
  --email-readonly-subject-fontsize: 16px;
  --thread-toggle-font-size: 9px;
  --thread-toggle-height: 30px;
  --email-line-height: 1.2rem;
  --email-min-height: 300px;
  --editor-max-height: 400px;
  --email-chat-min-width: 600px;
  --reply-message-warning-margin: 54px;
  --quick-reply-send-height: 64px;
  --error-code-mar-bot: 2.5rem;
  --label-width: 64px;
  --reply-header-height: 48px;
  --read-header-height: 40px;
  --height-100-pc: 100%;
  --reply-link-icon-padding: 0 0 0 14px;
  --padding-reset: 0;
  --ccfield-height: 32px;
  --toolbar-attach-icon-padding: 3px 5px;
  --toolbar-info-icon-padding: 7px;
  --thread-bar: #643abd;
  /**
    css applied on the element
  */
  box-sizing: border-box;
  font-style: normal;
  font-weight: normal;
  background: var(--md-email-composer-bg-color);
  color: var(--md-primary-text-color);
  height: 100%;
  width: 100%;
  line-height: var(--email-line-height);
  position: relative;
  min-height: var(--email-min-height);
  overflow: hidden;
  border-bottom-left-radius: var(--border-radius-medium);
  border-bottom-right-radius: var(--border-radius-medium);
}

/** style for responsive height of editor in read  mode.*/
.email-template .email-template-read {
  min-height: calc(var(--email-line-height) * 4);
}

.email-template .composeEmailForm {
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.email-template .email-header {
  /* background: var(--md-email-composer-bg-color); */
  border-bottom: var(--border);
  border-top: var(--border);
  color: var(--md-primary-text-color);
  padding: var(--large-spacing) var(--large-spacing) var(--padding-reset) var(--large-spacing);
}

.email-header.readonly {
  padding-bottom: var(--large-spacing);
}

.email-template .email-row {
  display: flex;
  align-items: center;
  font-size: var(--font-size-medium);
  color: var(--md-primary-text-color);
  height: var(--read-header-height);
  padding-bottom: var(--space-token-cardinal);
}

.subject-col1 {
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: row;
  max-width: 100%;
  height: var(--large-spacing);
}

.subject-col2 {
  white-space: nowrap;
}

.email-template .email-row .subject {
  padding-left: var(--padding-reset);
  font-size: var(--email-readonly-subject-fontsize);
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link-button {
  font-size: var(--font-size-medium);
  color: var(--md-hyperlink-text-color);
  margin: 0 calc(var(--space-token-cardinal) * 2);
  padding: var(--reply-link-icon-padding);
}
.link-button::part(button) {
  font-size: var(--font-size-medium);
}

.reply-icon {
  margin-right: var(--small-spacing);
}

.email-template .md-input-container {
  margin: 0;
  flex-grow: 1;
}

.email-template .email-row .email-label {
  color: var(--md-secondary-text-color);
  padding-left: var(--padding-reset);
  width: var(--email-label-area-width);
}

.email-value {
  padding-left: calc(var(--space-token-cardinal) * 3);
  color: var(--md-primary-text-color);
  flex: 1;
}

.replyClass.writeMailClass .email-value {
  padding-left: var(--padding-reset);
}

.email-template .email-row.email-input-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: stretch;
}

.email-template .email-row.email-input-row .md-input {
  height: calc(var(--input-heigh) - var(--border-width));
}

.email-template .email-row.email-input-row.hide-cc-field {
  display: none;
}

.email-template .email-row.email-input-row input,
.email-template .email-row.email-input-row .md .input,
.md .email-template .email-row.email-input-row .input,
.email-template .email-row.email-input-row .md .md-input,
.md .email-template .email-row.email-input-row .md-input {
  border: none;
}

.error-input {
  border-bottom: var(--red-border) !important;
  height: calc(var(--reply-header-height) - var(--border-width));
}

/**
 * Overwriting ql-editor styling
 */

.quill {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.ql-container .ql-editor {
  box-shadow: none;
  padding-left: var(--padding-reset);
  padding-top: var(--padding-reset);
}
.ql-formats {
  margin-right: var(--padding-reset) !important;
}

.ql-formats .tb-separator {
  border-right: 0.06rem solid var(--grey-color);
  height: calc(var(--space-token-cardinal) * 3);
  margin: var(--padding-reset) var(--space-token-cardinal) var(--padding-reset) var(--space-token-cardinal);
}

.ql-formats .ql-stroke {
  stroke-width: 1 !important /*overriding default quill toolbar button's style */;
}
.ql-formats svg .ql-fill {
  fill: var(--md-primary-text-color);
}
.ql-formats svg .ql-stroke {
  stroke: var(--md-primary-text-color);
}
.ql-snow .ql-formats .ql-picker {
  color: var(--md-primary-text-color);
}

.ql-bold .ql-stroke {
  stroke-width: 2 !important /*overriding default quill toolbar button's style */;
}

.text-editor {
  display: flex;
  flex-grow: 1;
}

.email-editor-container {
  color: var(--md-primary-text-color-default);
  background-color: var(--md-primary-bg-color-default);
  overflow: auto;
  padding: var(--medium-spacing) var(--medium-spacing) var(--small-spacing) var(--large-spacing);
}
.email-editor-height-read {
  height: calc(100% - (var(--quick-reply-send-height) - var(--small-spacing)));
}
.email-editor-height-reply {
  height: calc(100% - var(--small-spacing));
}

.email-container-write-height {
  height: auto;
}

.display-space-between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.withAttachment {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.email-editor-container-readonly {
  padding-left: calc(var(--space-token-cardinal) * 3);
}

.label-width {
  width: var(--label-width);
  min-width: var(--label-width);
}

.ql-container {
  font-family: var(--font-family) !important;
  max-width: 100%;
}

.ql-container.ql-snow {
  border: none !important;
}
.ql-container.ql-snow :focus {
  box-shadow: none;
}

.email-editor-container-editable .ql-container .ql-editor {
  max-height: var(--editor-max-height);
  padding-left: var(--padding-reset);
}

.ql-toolbar.ql-snow {
  border: none !important;
  border-bottom: var(--border) !important;
  padding: 11px 13px !important;
}

.email-footer {
  padding: var(--medium-spacing) var(--large-spacing);
  display: flex;
  justify-content: space-between;
  background: var(--md-email-composer-bg-color);
  align-items: center;
  border-top: var(--md-hyperlink-text-color);
  position: absolute;
  bottom: 0;
  width: 100%;
}

.attachment-section {
  align-self: flex-start;
  padding: var(--medium-spacing) var(--large-spacing) var(--medium-spacing) var(--large-spacing);
  margin: 0;
  display: flex;
}

.attachment-section.editing {
  padding: var(--padding-reset) var(--large-spacing) var(--medium-spacing) var(--padding-reset);
}

.more-attachments {
  margin-right: calc(var(--space-token-cardinal) * 2);
  max-height: var(--defult-button-size);
  margin-top: calc(var(--space-token-cardinal) * 2);
  font-size: var(--font-size-xlarge);
}

.attachment-section .form-group {
  margin-bottom: 0;
}
.attachment-section .form-group .attachment-items {
  padding: 0;
  overflow: hidden;
  margin: calc(var(--space-token-caridinal) * 2) 0 var(--space-token-cardinal);
  display: flex;
  flex-wrap: wrap;
  max-height: var(--attch-max-height);
}

.hide-attachments {
  height: 100%;
}

.attachment-container {
  height: 100%;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  border-radius: var(--border-radius-small);
  display: flex;
  padding: 0;
  cursor: pointer;
  height: var(--defult-button-size);
}
.download-inprogress {
  margin-top: -10px;
}

.showall-attachments {
  max-height: none !important;
}

.attachment-item {
  display: flex;
  border-radius: var(--border-radius-small);
  margin: var(--padding-reset) var(--small-spacing) var(--medium-spacing) var(--padding-reset);
  flex-direction: column;
  box-shadow: none;
}
.attachment-padding-left {
  margin-left: calc(var(--space-token-cardinal) * 3);
}
.attachment-padding-right {
  margin-right: calc(var(--space-token-cardinal) * 3);
}

#toggleThreadButton {
  margin: var(--large-spacing) var(--large-spacing) var(--large-spacing) var(--padding-reset);
  display: flex;
  justify-content: center;
  align-content: center;
  min-width: var(--prev-thread-dim);
  background: var(--md-quaternary-bg-color);
  border: none;
  border-radius: var(--medium-spacing);
  box-sizing: content-box;
  line-height: var(--small-spacing);
  font-family: monospace;
  font-size: var(--thread-toggle-font-size);
  width: var(--thread-toggle-height);
  height: var(--thread-toggle-font-size);
  cursor: pointer;
  padding: var(--padding-reset);
}

#toggleThreadButton:focus {
  outline: none;
  box-shadow: none;
}

.email-editor-container-readonly blockquote:first-of-type {
  font-size: var(--font-size-medium);
}

.email-editor-container-readonly-pre {
  font-family: var(--font-family) !important; /* need to override font family of email in read only mode*/
  white-space: pre-wrap;
  font-size: var(--font-size-medium) !important;
}

.email-transcript-content pre * {
  font-family: var(--font-family) !important;
}

.email-editor-blockquote {
  border-left: var(--thread-bar) !important;
  border-left-style: solid !important;
  border-left-width: var(--mini-spacing) !important;
  padding-left: var(--small-spacing);
}

.email-editor-container-readonly-pre * {
  font-family: var(--font-family) !important; /* need to override font family of email in read only mode*/
}

/* Start: quill overridden css, added important force these styles*/

.ql-picker-options .ql-picker-item {
  font-family: var(--font-family) !important;
}

.ql-picker.ql-tablemodule [data-value=""]::before {
  content: "\\fbfa";
  font-family: var(--font-family-icons);
}

.ql-picker.ql-tablemodule [class="ql-picker-item"]:first-of-type {
  display: none;
}

.ql-picker-item.ql-selected {
  display: none !important; /* hiding forcefully first element of insert Table icon*/
}

.ql-tablemodule .ql-picker-label svg {
  display: none;
}
.ql-picker.ql-tablemodule {
  width: 30px !important;
}

.ql-tablemodule .ql-picker-item:before {
  content: attr(data-label);
}

#quickReplyInp:empty:before {
  content: attr(placeholder);
  color: var(--gray-70-color);
  pointer-events: none;
}

#quickReplyInp {
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  overflow-wrap: break-word;
  box-shadow: none;
  font-size: var(--font-size-medium);
  line-height: var(--email-line-height);
  padding: var(--medium-spacing) var(--large-spacing);
}

.quick-reply-container {
  border-top: var(--md-alert-info-text-color);
  border-top-width: var(--border-width);
  background: var(--md-email-composer-bg-color);
  border-top-style: solid;
  box-sizing: border-box;
  overflow-x: hidden;
  max-height: calc(var(--email-line-height) * 4);
  position: absolute;
  height: var(--quick-reply-send-height);
  bottom: var(--quick-reply-send-height);
  width: 100%;
}

.quick-reply-send {
  padding: var(--small-spacing) var(--large-spacing);
  display: flex;
  background: var(--md-email-composer-bg-color);
  justify-content: space-between;
  height: var(--quick-reply-send-height);
  align-items: center;
  border-top: var(--md-hyperlink-text-color);
  position: absolute;
  bottom: 0;
  width: 100%;
}

.send-button {
  white-space: nowrap;
}

.send-button[disabled="true"]::part(button) {
  background: var(--md-tertiary-bg-color);
  color: var(--md-disabled-text-color);
}

.reply-warning {
  background: var(--md-tertiary-bg-color);
  color: var(--md-secondary-text-color);
  border-radius: var(--border-radius);
  height: var(--reply-header-height);
  padding: var(--small-spacing);
  font-family: var(--font-family-light);
  font-size: var(--font-size-small);
  line-height: 1.25em;
  margin-right: var(--large-spacing);
  width: 100%;
}

.ql-attach {
  width: auto !important;
  text-align: center;
  display: flex !important;
  align-items: center;
  height: auto !important;
  padding: var(--toolbar-attach-icon-padding);
}

.ql-icon {
  color: var(--md-secondary-text-color);
  top: var(--mini-spacing);
  position: relative;
}
.ql-icon.disable {
  color: inherit;
}

.ql-info {
  position: relative;
  bottom: var(--border-width);
}

/* End: quill overridden css*/

.attachContent {
  padding-left: var(--toolbar-info-icon-padding);
  color: var(--md-primary-text-color);
}
.attachContent.disable {
  color: inherit;
}

.email-row .md-input-container .md-input:not(.md-select__filter--input):hover {
}

#ccAddress {
  box-shadow: none;
  padding-left: var(--padding-reset);
}

#ccAddressReadOnly {
  padding-left: calc(var(--space-token-cardinal) * 3);
}

.attachment-cancel {
  padding: var(--space-token-cardinal) calc(var(--space-token-cardinal) * 2);
  display: flex;
}

.fontSizeReadMail {
  font-size: var(--email-readonly-subject-fontsize);
}

.align-item-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.subject-col2-cc {
  align-items: flex-start;
  flex: 1;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.subject-col1-cc,
.subject-col3-cc {
  white-space: nowrap;
}

.email-value-cc-input {
  background: transparent;
  color: var(--md-primary-text-color);
  position: inherit;
  flex: 1;
  height: var(--ccfield-height);
}
#ccAddress:focus {
  outline: none;
  box-shadow: var(--focused-momentum-shadow);
}

.cc-row-height {
  height: unset !important;
}

.removeCcAddress,
#attachmentCancel {
  display: flex;
  cursor: pointer;
}

.send-icon {
  margin-right: var(--small-spacing);
}

.badge-wrapper {
  margin: 0 var(--small-spacing) var(--medium-spacing) 0;
}

.ql-snow .ql-picker-options {
  background-color: var(--md-primary-bg-color) !important;
  color: var(--md-primary-text-color) !important;
}

.ql-snow .ql-picker-item:hover {
  color: var(--md-hyperlink-text-color) !important;
}

.ql-snow .ql-tooltip {
  left: 0 !important;
  transform: translate(50%, 10px) !important;
  background-color: var(--md-primary-bg-color) !important;
  color: var(--md-primary-text-color) !important;
}

.ql-snow .ql-tooltip.ql-editing input[type="text"] {
  background: var(--input-default-bg-color) !important;
  color: var(--input-default-text-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/EmailComposer/styles/email.css"],"names":[],"mappings":"AAEA;EACE;;GAEC;EACD,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,uCAAuC;EACvC,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;EACtB,sCAAsC;EACtC,gCAAgC;EAChC,qBAAqB;EACrB;;GAEC;EACD,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,sDAAsD;EACtD,uDAAuD;AACzD;;AAEA,yDAAyD;AACzD;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;EACnD,4BAA4B;EAC5B,yBAAyB;EACzB,mCAAmC;EACnC,4FAA4F;AAC9F;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,mCAAmC;EACnC,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,iDAAiD;EACjD,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,+CAA+C;EAC/C,uCAAuC;AACzC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mDAAmD;EACnD,mCAAmC;EACnC,OAAO;AACT;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,8DAA8D;AAChE;;AAEA;;EAEE;;AAEF;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;EAC7C,yGAAyG;AAC3G;;AAEA;EACE,+EAA+E;AACjF;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,oDAAoD;EACpD,cAAc;EACd,8FAA8F;AAChG;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,mDAAmD;EACnD,aAAa;EACb,8BAA8B;EAC9B,6CAA6C;EAC7C,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,8FAA8F;EAC9F,SAAS;EACT,aAAa;AACf;;AAEA;EACE,6FAA6F;AAC/F;;AAEA;EACE,mDAAmD;EACnD,qCAAqC;EACrC,iDAAiD;EACjD,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,4EAA4E;EAC5E,aAAa;EACb,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,UAAU;EACV,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,4FAA4F;EAC5F,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,mDAAmD;AACrD;;AAEA;EACE,2FAA2F;EAC3F,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,iCAAiC;EACjC,yCAAyC;EACzC,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;EACtB,yCAAyC;EACzC,kCAAkC;EAClC,sCAAsC;EACtC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0CAA0C,EAAE,2DAA2D;EACvG,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,iDAAiD;EACjD,kCAAkC;AACpC;;AAEA;EACE,0CAA0C,EAAE,2DAA2D;AACzG;;AAEA,mEAAmE;;AAEnE;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB,EAAE,wDAAwD;AACpF;;AAEA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;EACrC,mDAAmD;AACrD;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,6CAA6C;EAC7C,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,kDAAkD;EAClD,aAAa;EACb,6CAA6C;EAC7C,8BAA8B;EAC9B,sCAAsC;EACtC,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mCAAmC;EACnC,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;EACrC,iCAAiC;EACjC,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,6BAA6B;;AAE7B;EACE,8CAA8C;EAC9C,mCAAmC;AACrC;AACA;EACE,cAAc;AAChB;;AAEA;AACA;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,0EAA0E;EAC1E,aAAa;AACf;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,OAAO;EACP,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,iBAAiB;EACjB,OAAO;EACP,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,uDAAuD;EACvD,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,uDAAuD;EACvD,8CAA8C;AAChD;;AAEA;EACE,oDAAoD;EACpD,iDAAiD;AACnD","sourcesContent":["@import \"../../../css/variables.css\";\n\n.email-template {\n  /**\n  Variables defined\n  */\n  --text-padding: 0 1rem;\n  --mini-spacing: 2px;\n  --xsmall-spacing: 4px;\n  --small-spacing: 8px;\n  --medium-spacing: 16px;\n  --large-spacing: 24px;\n  --xlarge-spacing: 32px;\n  --border-radius: 8px;\n  --prev-thread-dim: 32px;\n  --attch-fname-width: 129px;\n  --attch-max-height: 48px;\n  --email-readonly-subject-fontsize: 16px;\n  --thread-toggle-font-size: 9px;\n  --thread-toggle-height: 30px;\n  --email-line-height: 1.2rem;\n  --email-min-height: 300px;\n  --editor-max-height: 400px;\n  --email-chat-min-width: 600px;\n  --reply-message-warning-margin: 54px;\n  --quick-reply-send-height: 64px;\n  --error-code-mar-bot: 2.5rem;\n  --label-width: 64px;\n  --reply-header-height: 48px;\n  --read-header-height: 40px;\n  --height-100-pc: 100%;\n  --reply-link-icon-padding: 0 0 0 14px;\n  --padding-reset: 0;\n  --ccfield-height: 32px;\n  --toolbar-attach-icon-padding: 3px 5px;\n  --toolbar-info-icon-padding: 7px;\n  --thread-bar: #643abd;\n  /**\n    css applied on the element\n  */\n  box-sizing: border-box;\n  font-style: normal;\n  font-weight: normal;\n  background: var(--md-email-composer-bg-color);\n  color: var(--md-primary-text-color);\n  height: 100%;\n  width: 100%;\n  line-height: var(--email-line-height);\n  position: relative;\n  min-height: var(--email-min-height);\n  overflow: hidden;\n  border-bottom-left-radius: var(--border-radius-medium);\n  border-bottom-right-radius: var(--border-radius-medium);\n}\n\n/** style for responsive height of editor in read  mode.*/\n.email-template .email-template-read {\n  min-height: calc(var(--email-line-height) * 4);\n}\n\n.email-template .composeEmailForm {\n  height: 100%;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.email-template .email-header {\n  /* background: var(--md-email-composer-bg-color); */\n  border-bottom: var(--border);\n  border-top: var(--border);\n  color: var(--md-primary-text-color);\n  padding: var(--large-spacing) var(--large-spacing) var(--padding-reset) var(--large-spacing);\n}\n\n.email-header.readonly {\n  padding-bottom: var(--large-spacing);\n}\n\n.email-template .email-row {\n  display: flex;\n  align-items: center;\n  font-size: var(--font-size-medium);\n  color: var(--md-primary-text-color);\n  height: var(--read-header-height);\n  padding-bottom: var(--space-token-cardinal);\n}\n\n.subject-col1 {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  flex-direction: row;\n  max-width: 100%;\n  height: var(--large-spacing);\n}\n\n.subject-col2 {\n  white-space: nowrap;\n}\n\n.email-template .email-row .subject {\n  padding-left: var(--padding-reset);\n  font-size: var(--email-readonly-subject-fontsize);\n  font-weight: bold;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.link-button {\n  font-size: var(--font-size-medium);\n  color: var(--md-hyperlink-text-color);\n  margin: 0 calc(var(--space-token-cardinal) * 2);\n  padding: var(--reply-link-icon-padding);\n}\n.link-button::part(button) {\n  font-size: var(--font-size-medium);\n}\n\n.reply-icon {\n  margin-right: var(--small-spacing);\n}\n\n.email-template .md-input-container {\n  margin: 0;\n  flex-grow: 1;\n}\n\n.email-template .email-row .email-label {\n  color: var(--md-secondary-text-color);\n  padding-left: var(--padding-reset);\n  width: var(--email-label-area-width);\n}\n\n.email-value {\n  padding-left: calc(var(--space-token-cardinal) * 3);\n  color: var(--md-primary-text-color);\n  flex: 1;\n}\n\n.replyClass.writeMailClass .email-value {\n  padding-left: var(--padding-reset);\n}\n\n.email-template .email-row.email-input-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: stretch;\n}\n\n.email-template .email-row.email-input-row .md-input {\n  height: calc(var(--input-heigh) - var(--border-width));\n}\n\n.email-template .email-row.email-input-row.hide-cc-field {\n  display: none;\n}\n\n.email-template .email-row.email-input-row input,\n.email-template .email-row.email-input-row .md .input,\n.md .email-template .email-row.email-input-row .input,\n.email-template .email-row.email-input-row .md .md-input,\n.md .email-template .email-row.email-input-row .md-input {\n  border: none;\n}\n\n.error-input {\n  border-bottom: var(--red-border) !important;\n  height: calc(var(--reply-header-height) - var(--border-width));\n}\n\n/**\n * Overwriting ql-editor styling\n */\n\n.quill {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.ql-container .ql-editor {\n  box-shadow: none;\n  padding-left: var(--padding-reset);\n  padding-top: var(--padding-reset);\n}\n.ql-formats {\n  margin-right: var(--padding-reset) !important;\n}\n\n.ql-formats .tb-separator {\n  border-right: 0.06rem solid var(--grey-color);\n  height: calc(var(--space-token-cardinal) * 3);\n  margin: var(--padding-reset) var(--space-token-cardinal) var(--padding-reset) var(--space-token-cardinal);\n}\n\n.ql-formats .ql-stroke {\n  stroke-width: 1 !important /*overriding default quill toolbar button's style */;\n}\n.ql-formats svg .ql-fill {\n  fill: var(--md-primary-text-color);\n}\n.ql-formats svg .ql-stroke {\n  stroke: var(--md-primary-text-color);\n}\n.ql-snow .ql-formats .ql-picker {\n  color: var(--md-primary-text-color);\n}\n\n.ql-bold .ql-stroke {\n  stroke-width: 2 !important /*overriding default quill toolbar button's style */;\n}\n\n.text-editor {\n  display: flex;\n  flex-grow: 1;\n}\n\n.email-editor-container {\n  color: var(--md-primary-text-color-default);\n  background-color: var(--md-primary-bg-color-default);\n  overflow: auto;\n  padding: var(--medium-spacing) var(--medium-spacing) var(--small-spacing) var(--large-spacing);\n}\n.email-editor-height-read {\n  height: calc(100% - (var(--quick-reply-send-height) - var(--small-spacing)));\n}\n.email-editor-height-reply {\n  height: calc(100% - var(--small-spacing));\n}\n\n.email-container-write-height {\n  height: auto;\n}\n\n.display-space-between {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.withAttachment {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.email-editor-container-readonly {\n  padding-left: calc(var(--space-token-cardinal) * 3);\n}\n\n.label-width {\n  width: var(--label-width);\n  min-width: var(--label-width);\n}\n\n.ql-container {\n  font-family: var(--font-family) !important;\n  max-width: 100%;\n}\n\n.ql-container.ql-snow {\n  border: none !important;\n}\n.ql-container.ql-snow :focus {\n  box-shadow: none;\n}\n\n.email-editor-container-editable .ql-container .ql-editor {\n  max-height: var(--editor-max-height);\n  padding-left: var(--padding-reset);\n}\n\n.ql-toolbar.ql-snow {\n  border: none !important;\n  border-bottom: var(--border) !important;\n  padding: 11px 13px !important;\n}\n\n.email-footer {\n  padding: var(--medium-spacing) var(--large-spacing);\n  display: flex;\n  justify-content: space-between;\n  background: var(--md-email-composer-bg-color);\n  align-items: center;\n  border-top: var(--md-hyperlink-text-color);\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n\n.attachment-section {\n  align-self: flex-start;\n  padding: var(--medium-spacing) var(--large-spacing) var(--medium-spacing) var(--large-spacing);\n  margin: 0;\n  display: flex;\n}\n\n.attachment-section.editing {\n  padding: var(--padding-reset) var(--large-spacing) var(--medium-spacing) var(--padding-reset);\n}\n\n.more-attachments {\n  margin-right: calc(var(--space-token-cardinal) * 2);\n  max-height: var(--defult-button-size);\n  margin-top: calc(var(--space-token-cardinal) * 2);\n  font-size: var(--font-size-xlarge);\n}\n\n.attachment-section .form-group {\n  margin-bottom: 0;\n}\n.attachment-section .form-group .attachment-items {\n  padding: 0;\n  overflow: hidden;\n  margin: calc(var(--space-token-caridinal) * 2) 0 var(--space-token-cardinal);\n  display: flex;\n  flex-wrap: wrap;\n  max-height: var(--attch-max-height);\n}\n\n.hide-attachments {\n  height: 100%;\n}\n\n.attachment-container {\n  height: 100%;\n  white-space: nowrap;\n  justify-content: center;\n  align-items: center;\n  border-radius: var(--border-radius-small);\n  display: flex;\n  padding: 0;\n  cursor: pointer;\n  height: var(--defult-button-size);\n}\n.download-inprogress {\n  margin-top: -10px;\n}\n\n.showall-attachments {\n  max-height: none !important;\n}\n\n.attachment-item {\n  display: flex;\n  border-radius: var(--border-radius-small);\n  margin: var(--padding-reset) var(--small-spacing) var(--medium-spacing) var(--padding-reset);\n  flex-direction: column;\n  box-shadow: none;\n}\n.attachment-padding-left {\n  margin-left: calc(var(--space-token-cardinal) * 3);\n}\n.attachment-padding-right {\n  margin-right: calc(var(--space-token-cardinal) * 3);\n}\n\n#toggleThreadButton {\n  margin: var(--large-spacing) var(--large-spacing) var(--large-spacing) var(--padding-reset);\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  min-width: var(--prev-thread-dim);\n  background: var(--md-quaternary-bg-color);\n  border: none;\n  border-radius: var(--medium-spacing);\n  box-sizing: content-box;\n  line-height: var(--small-spacing);\n  font-family: monospace;\n  font-size: var(--thread-toggle-font-size);\n  width: var(--thread-toggle-height);\n  height: var(--thread-toggle-font-size);\n  cursor: pointer;\n  padding: var(--padding-reset);\n}\n\n#toggleThreadButton:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.email-editor-container-readonly blockquote:first-of-type {\n  font-size: var(--font-size-medium);\n}\n\n.email-editor-container-readonly-pre {\n  font-family: var(--font-family) !important; /* need to override font family of email in read only mode*/\n  white-space: pre-wrap;\n  font-size: var(--font-size-medium) !important;\n}\n\n.email-transcript-content pre * {\n  font-family: var(--font-family) !important;\n}\n\n.email-editor-blockquote {\n  border-left: var(--thread-bar) !important;\n  border-left-style: solid !important;\n  border-left-width: var(--mini-spacing) !important;\n  padding-left: var(--small-spacing);\n}\n\n.email-editor-container-readonly-pre * {\n  font-family: var(--font-family) !important; /* need to override font family of email in read only mode*/\n}\n\n/* Start: quill overridden css, added important force these styles*/\n\n.ql-picker-options .ql-picker-item {\n  font-family: var(--font-family) !important;\n}\n\n.ql-picker.ql-tablemodule [data-value=\"\"]::before {\n  content: \"\\fbfa\";\n  font-family: var(--font-family-icons);\n}\n\n.ql-picker.ql-tablemodule [class=\"ql-picker-item\"]:first-of-type {\n  display: none;\n}\n\n.ql-picker-item.ql-selected {\n  display: none !important; /* hiding forcefully first element of insert Table icon*/\n}\n\n.ql-tablemodule .ql-picker-label svg {\n  display: none;\n}\n.ql-picker.ql-tablemodule {\n  width: 30px !important;\n}\n\n.ql-tablemodule .ql-picker-item:before {\n  content: attr(data-label);\n}\n\n#quickReplyInp:empty:before {\n  content: attr(placeholder);\n  color: var(--gray-70-color);\n  pointer-events: none;\n}\n\n#quickReplyInp {\n  width: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overflow-wrap: break-word;\n  box-shadow: none;\n  font-size: var(--font-size-medium);\n  line-height: var(--email-line-height);\n  padding: var(--medium-spacing) var(--large-spacing);\n}\n\n.quick-reply-container {\n  border-top: var(--md-alert-info-text-color);\n  border-top-width: var(--border-width);\n  background: var(--md-email-composer-bg-color);\n  border-top-style: solid;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  max-height: calc(var(--email-line-height) * 4);\n  position: absolute;\n  height: var(--quick-reply-send-height);\n  bottom: var(--quick-reply-send-height);\n  width: 100%;\n}\n\n.quick-reply-send {\n  padding: var(--small-spacing) var(--large-spacing);\n  display: flex;\n  background: var(--md-email-composer-bg-color);\n  justify-content: space-between;\n  height: var(--quick-reply-send-height);\n  align-items: center;\n  border-top: var(--md-hyperlink-text-color);\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n\n.send-button {\n  white-space: nowrap;\n}\n\n.send-button[disabled=\"true\"]::part(button) {\n  background: var(--md-tertiary-bg-color);\n  color: var(--md-disabled-text-color);\n}\n\n.reply-warning {\n  background: var(--md-tertiary-bg-color);\n  color: var(--md-secondary-text-color);\n  border-radius: var(--border-radius);\n  height: var(--reply-header-height);\n  padding: var(--small-spacing);\n  font-family: var(--font-family-light);\n  font-size: var(--font-size-small);\n  line-height: 1.25em;\n  margin-right: var(--large-spacing);\n  width: 100%;\n}\n\n.ql-attach {\n  width: auto !important;\n  text-align: center;\n  display: flex !important;\n  align-items: center;\n  height: auto !important;\n  padding: var(--toolbar-attach-icon-padding);\n}\n\n.ql-icon {\n  color: var(--md-secondary-text-color);\n  top: var(--mini-spacing);\n  position: relative;\n}\n.ql-icon.disable {\n  color: inherit;\n}\n\n.ql-info {\n  position: relative;\n  bottom: var(--border-width);\n}\n\n/* End: quill overridden css*/\n\n.attachContent {\n  padding-left: var(--toolbar-info-icon-padding);\n  color: var(--md-primary-text-color);\n}\n.attachContent.disable {\n  color: inherit;\n}\n\n.email-row .md-input-container .md-input:not(.md-select__filter--input):hover {\n}\n\n#ccAddress {\n  box-shadow: none;\n  padding-left: var(--padding-reset);\n}\n\n#ccAddressReadOnly {\n  padding-left: calc(var(--space-token-cardinal) * 3);\n}\n\n.attachment-cancel {\n  padding: var(--space-token-cardinal) calc(var(--space-token-cardinal) * 2);\n  display: flex;\n}\n\n.fontSizeReadMail {\n  font-size: var(--email-readonly-subject-fontsize);\n}\n\n.align-item-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.subject-col2-cc {\n  align-items: flex-start;\n  flex: 1;\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.subject-col1-cc,\n.subject-col3-cc {\n  white-space: nowrap;\n}\n\n.email-value-cc-input {\n  background: transparent;\n  color: var(--md-primary-text-color);\n  position: inherit;\n  flex: 1;\n  height: var(--ccfield-height);\n}\n#ccAddress:focus {\n  outline: none;\n  box-shadow: var(--focused-momentum-shadow);\n}\n\n.cc-row-height {\n  height: unset !important;\n}\n\n.removeCcAddress,\n#attachmentCancel {\n  display: flex;\n  cursor: pointer;\n}\n\n.send-icon {\n  margin-right: var(--small-spacing);\n}\n\n.badge-wrapper {\n  margin: 0 var(--small-spacing) var(--medium-spacing) 0;\n}\n\n.ql-snow .ql-picker-options {\n  background-color: var(--md-primary-bg-color) !important;\n  color: var(--md-primary-text-color) !important;\n}\n\n.ql-snow .ql-picker-item:hover {\n  color: var(--md-hyperlink-text-color) !important;\n}\n\n.ql-snow .ql-tooltip {\n  left: 0 !important;\n  transform: translate(50%, 10px) !important;\n  background-color: var(--md-primary-bg-color) !important;\n  color: var(--md-primary-text-color) !important;\n}\n\n.ql-snow .ql-tooltip.ql-editing input[type=\"text\"] {\n  background: var(--input-default-bg-color) !important;\n  color: var(--input-default-text-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/ConfirmationDialog/style.css":
/*!**************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/ConfirmationDialog/style.css ***!
  \**************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.confirmation-dialog__title {
  font-size: var(--font-size-medium);
  font-family: var(--font-family-bold);
  height: 28px;
  padding: 12px 16px 12px 16px;
}

.confirmation-dialog__message {
  font-size: var(--font-size-medium);
  height: 56px;
  max-width: 100%;
  padding: 8px 16px 8px 16px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.confirmation-dialog__buttons-container {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  width: 100%;
  padding: 6px 10px 12px 10px;
  justify-content: end;
  margin-left: auto;
}

.confirmation-dialog__button {
  margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/InteractionControl/components/ConfirmationDialog/style.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["@import \"../../../../css/variables.css\";\n\n.confirmation-dialog {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.confirmation-dialog__title {\n  font-size: var(--font-size-medium);\n  font-family: var(--font-family-bold);\n  height: 28px;\n  padding: 12px 16px 12px 16px;\n}\n\n.confirmation-dialog__message {\n  font-size: var(--font-size-medium);\n  height: 56px;\n  max-width: 100%;\n  padding: 8px 16px 8px 16px;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.confirmation-dialog__buttons-container {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  width: 100%;\n  padding: 6px 10px 12px 10px;\n  justify-content: end;\n  margin-left: auto;\n}\n\n.confirmation-dialog__button {\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.css":
/*!*******************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.css ***!
  \*******************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infinite-menu-list {
  align-content: center;
  list-style-type: none;
}

.infinite-menu-list:hover {
  background-color: var(--list-hover-background, #c9f4ff);
  cursor: pointer;
}
.selected-list-item-focused {
  outline: none;
  cursor: pointer;
  box-shadow: var(--focused-list-shadow);
}

.selected-list-item {
  background-color: var(--list-active-background, #c9f4ff);
  box-shadow: var(--focused-list-shadow);
}

.list-item {
  display: flex;
  align-items: center;
  padding-left: 10px;
  &.type-Available {
    .status {
      svg {
        color: var(--md-green-60);
      }
    }
  }
  &.type-Idle {
    .status {
      svg {
        color: var(--md-gray-60);
      }
    }
  }
}

.list-text {
  font-size: var(--font-size-medium);
  padding: 1px calc(var(--space-token-even) * 5) 0 calc(var(--space-token-cardinal) * 2);
  width: calc(var(--full-menu-item-width) - var(--space-token-cardinal));
  padding-left: 10px;
}

.ellipsis-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-item-detail {
  padding: 1px calc(var(--space-token-even) * 5);
}

.list-item-detail .list-item-name {
  font-size: var(--font-size-medium);
  max-width: var(--adr-name-width);
  font-family: var(--font-family);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-item-detail .list-item-subtitle {
  color: var(--md-secondary-text-color);
  font-size: var(--font-size-small);
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,uDAAuD;EACvD,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,wDAAwD;EACxD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB;IACE;MACE;QACE,yBAAyB;MAC3B;IACF;EACF;EACA;IACE;MACE;QACE,wBAAwB;MAC1B;IACF;EACF;AACF;;AAEA;EACE,kCAAkC;EAClC,sFAAsF;EACtF,sEAAsE;EACtE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC","sourcesContent":[".infinite-menu-list {\n  align-content: center;\n  list-style-type: none;\n}\n\n.infinite-menu-list:hover {\n  background-color: var(--list-hover-background, #c9f4ff);\n  cursor: pointer;\n}\n.selected-list-item-focused {\n  outline: none;\n  cursor: pointer;\n  box-shadow: var(--focused-list-shadow);\n}\n\n.selected-list-item {\n  background-color: var(--list-active-background, #c9f4ff);\n  box-shadow: var(--focused-list-shadow);\n}\n\n.list-item {\n  display: flex;\n  align-items: center;\n  padding-left: 10px;\n  &.type-Available {\n    .status {\n      svg {\n        color: var(--md-green-60);\n      }\n    }\n  }\n  &.type-Idle {\n    .status {\n      svg {\n        color: var(--md-gray-60);\n      }\n    }\n  }\n}\n\n.list-text {\n  font-size: var(--font-size-medium);\n  padding: 1px calc(var(--space-token-even) * 5) 0 calc(var(--space-token-cardinal) * 2);\n  width: calc(var(--full-menu-item-width) - var(--space-token-cardinal));\n  padding-left: 10px;\n}\n\n.ellipsis-text {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.list-item-detail {\n  padding: 1px calc(var(--space-token-even) * 5);\n}\n\n.list-item-detail .list-item-name {\n  font-size: var(--font-size-medium);\n  max-width: var(--adr-name-width);\n  font-family: var(--font-family);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.list-item-detail .list-item-subtitle {\n  color: var(--md-secondary-text-color);\n  font-size: var(--font-size-small);\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.css":
/*!********************************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.css ***!
  \********************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search {
  display: flex;
  width: 100%;
}

.search .search-bar-input {
  width: 100%;
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,OAAO;AACT","sourcesContent":[".search {\n  display: flex;\n  width: 100%;\n}\n\n.search .search-bar-input {\n  width: 100%;\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/TransferModal/styles.css":
/*!**********************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/TransferModal/styles.css ***!
  \**********************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  --dropdown-width: 510px;
  --dropdown-max-height: 220px;
  --dropdown-max-height-connector-view: 255px;
  --addressbook-max-height-connector-view: 238px;
  --addressbook-two-row-max-height-connector-view: 204px;
  --queue-dropdown-max-height: 290px;
  --queue-dropdown-min-height: 110px;
  --modal-height: 420px;
  --modal-radio-height: 24px;
  --cancel-ctq-container-maxwidth: 500px;
  --padding-icon-right: 0.5rem;
  --transfer-modal-content-height: 240px;
  --queue-dropdown-item: 36px;
  --dropdown-height: 48px;
  --menu-overlay-max-height: 325px;
  --modal-size: 490px;
  --modal-size-large: 530px;
  --organization-list-item-max-width: 375px;
  --modal-content-height: 290px;
  --min-height-value: 332px;
}

.queueDropdown {
  width: var(--dropdown-width);
}

.queueDropdown-tabbed {
  height: 35px;
}

.queueDropdown::part(overlay) {
  width: 100%;
  transform: none;
  top: calc(100% + 0.2rem);
}

.queueDropdown::part(overlay-content) {
  width: 100%;
}

.epdn-addressbook {
  width: 100%;
}

.entry-point-tab {
  border-bottom: 2px solid var(--md-separator-primary);
  width: 100%;
  display: inline-flex;
  height: 3rem;
  min-height: 3rem;
  align-items: center;
  padding: 0.3rem 1rem;
  color: var(--md-textColor-secondary);
}

.entry-point-tab > span {
  margin-top: 5px;
}

.queue-option.string {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.no-options {
  width: 100%;
  display: inline-flex;
  height: 3rem;
  min-height: 3rem;
  align-items: center;
  padding: 0.3rem 1rem;
  color: var(--md-textColor-secondary);
}

.queueDropdown::part(combobox-options) {
  line-height: 21px;
  max-height: var(--queue-dropdown-max-height);
}

.queueDropdown::part(combobox-option) {
  max-height: var(--dropdown-height);
}

.queueDropdown::part(combobox-option) .select-label span {
  margin-left: 0;
  margin-right: 0;
}

.highlighted-part {
  margin-left: 4px !important;
}

.modal-container .md-event-overlay__children {
  height: auto;
  max-height: var(--dropdown-max-height);
  width: var(--dropdown-width);
}

.md-modal__header {
  padding-bottom: 0.75rem;
}

.my-radio-group md-radiogroup .radioClass {
  box-sizing: border-box;
}

.modal-body-class.list-queue.list-organization #dailNumberId,
.modal-body-class.list-queue.list-organization #organizationUsers {
  margin-top: 9px;
}

.my-radio-group md-radiogroup::part(radio-group-container) {
  width: 100%;
  justify-content: space-between;
}

.modal-body-class.list-queue:not(.list-organization):not(.radio-two-row):not(.list-dialnumber):not(
    .isConsultTransferInfiniteScrollEnabled-class
  )
  .my-radio-group
  md-radiogroup::part(radio-group-container),
.modal-body-class:not(.list-organization):not(.list-queue):not(.isConsultTransferInfiniteScrollEnabled-class)
  .my-radio-group
  md-radiogroup::part(radio-group-container),
.modal-body-class.radio-two-row .my-radio-group md-radiogroup::part(radio-group-container) {
  flex-flow: wrap;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.modal-body-class.radio-three-column .my-radio-group md-radiogroup::part(radio-group-container) {
  flex-flow: wrap;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.org-search-input::part(md-input-container) {
  margin-bottom: 0;
}

md-modal.modal-container-large::part(modal-header) {
  padding-bottom: 0px;
}

.modal-container > .md-modal__content {
  min-height: var(--modal-size);
}

.my-radio-group .md-radio-group,
.my-radio-group .md-radio {
  display: flex;
}

.my-radio-group {
  /* padding-top: calc(var(--space-token-even) * 6); */
}

.agentAction-container {
  margin-top: 0.75rem;
}

md-modal::part(modal-body) {
  overflow: visible;
}

.modal-container .md-label.md-radio__label > span {
  height: var(--modal-radio-height);
  margin-right: calc(var(--space-token-even) * 36);
}

.modal-container .md-input-container .input-error-class {
  border-color: var(--red-color);
  border-radius: 0;
  box-shadow: var(--focused-shadow);
  display: inline-block;
}

.actionMessage {
  display: flex;
  font-size: var(--font-size-small);
  margin-top: 0.5rem;
}

.agentAction-error-container {
  color: var(--md-alert-error-text-color, --red-70-color);
}

.agentAction-warning-container {
  color: var(--md-alert-warning-text-color, --yellow-70-color);
}

.cancelCtq-info-container {
  color: var(--md-secondary-text-color-default);
  display: flex;
  flex-direction: row;
  font-size: var(--font-size-small);
  margin-top: 0.5rem;
  max-width: var(--cancel-ctq-container-maxwidth);
}

.agentAction-error-icon {
  color: var(--red-70-color);
  padding-right: 0.5rem;
}

.cancelCtq-info-icon {
  padding-right: var(--padding-icon-right);
}

md-radio {
  margin-top: 12px;
}

.cancelCtq-spinner {
  padding-right: calc(var(--space-token-even) * 4);
  padding-top: calc(var(--space-token-even) * 2);
}

.cancelCtq-link {
  text-decoration: underline;
}

.transfer-modal-btn {
  margin-left: 0.75rem;
}

#dailNumberId {
  margin-right: 0;
}

#entryPointId {
  /* margin-top: 10px; */
}

.modal-body-class {
  min-height: var(--transfer-modal-content-height);
}

.multiparty-consult-check-box {
  display: flex;
  justify-content: flex-start;
  padding-bottom: calc(var(--space-token-even) * 4);
  margin-left: -0.25rem;
}

.transfer-modal-md-button {
  display: flex;
  justify-content: flex-end;
}

.direction-column {
  flex-direction: column !important;
}

.transfer-modal-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
}

.available {
  color: var(--md-presence-active-bg-color);
}

.un-available {
  color: var(--md-presence-away-bg-color);
}

.align {
  vertical-align: middle;
}

.transfer-modal-search-container {
  display: flex;
}

.transfer-modal-search-container.organization {
  flex-direction: column;
}

.search-row {
  display: flex;
}

.epdn-addressbook-search {
  flex: 1;
}

.org-search-container {
  display: flex;
  margin-bottom: 8px;
}

.org-search-container md-input {
  width: 100%;
}

.refresh-spinner {
  margin: auto calc(var(--space-token-even) * 3) auto calc(var(--space-token-even) * 7);
  width: calc(var(--space-token-even) * 14);
}

.refresh-list-tooltip {
  margin-left: calc(var(--space-token-even) * 4);
}

.refresh-list-button {
  height: calc(var(--space-token-even) * 14);
  width: calc(var(--space-token-even) * 14);
}

.address-list-item {
  align-items: center;
  display: grid;
  grid-template-columns: 0fr 1fr 0fr;
  width: 100%;
}

.address-list-item-detail {
  padding: 1px calc(var(--space-token-even) * 5);
}

.address-list-item-detail .address-name,
.address-dn {
  font-size: var(--font-size-medium);
  max-width: var(--adr-name-width);
  font-family: var(--font-family);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.address-list-item-detail .address-dn {
  color: var(--md-secondary-text-color);
  font-size: var(--font-size-small);
}

.organization-users-list .address-list-item-detail .address-dn {
  max-width: var(--organization-list-item-max-width);
}

.dnDropdown::part(combobox-option) {
  padding-bottom: var(--space-token-even);
  padding-top: var(--space-token-even);
}

.radioLabel {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 88px;
}

.my-radio-group .radioClass {
  margin-right: 0;
  width: fit-content;
}

.organization-users-list {
  margin-top: 0.25rem;
}

.organization-users-list.disabled {
  opacity: 0.8;
  pointer-events: none;
}

.organization-auth-error,
.organization-auth-error md-icon,
.organization-auth-error md-link::part(link) {
  font-size: var(--font-size-small);
  color: var(--link-inline);
  display: flex;
  align-items: center;
}

.organization-auth-error .auth-error-message {
  margin: 0 calc(var(--space-token-even) * 4);
}

.organization-users-list .address-book-increased-limit-list .address-book-increased-limit-list-item,
.organization-users-list .address-book-increased-limit-list .infinite-scroll-error {
  padding-left: 0.25rem !important;
}

.no-record {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(var(--space-token-cardinal) * 2);
  gap: 4px;
  text-align: center;
}

.no-record-found {
  position: relative;
  top: 11px;
}

.org-search-error {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-small);
}

.org-search-block-error {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--padding-16);
}

.agentAction-container .org-search-spinner {
  display: flex;
  justify-content: center;
  height: var(--transfer-modal-content-height);
  align-items: center;
  margin: auto;
}

.modal-container-height {
  min-height: var(--min-height-value);
}

.all-radio-buttons-hidden {
  display: flex;
  height: 390px;
  padding: 20px;
  align-items: center;
}

.all-radio-buttons-hidden-icon {
  display: flex;
  align-self: baseline;
}
.all-radio-buttons-hidden-text-wrapper {
  display: flex;
  gap: 10px;
}
.address-book-increased-limit-list:not(.set-focus-visible):focus {
  border: none;
  outline: none;
}
.address-book-increased-limit-list:not(.set-focus-visible):focus-visible {
  border: none;
  outline: none;
}

.address-book-increased-limit-list .address-book-increased-limit-list-item {
  padding-left: 15px !important;
}
.address-book-increased-limit-list .address-book-increased-limit-list-item:hover {
  background-color: var(--list-hover-background, #c9f4ff);
}
.address-book-increased-limit-list .address-book-increased-limit-list-item.hovered {
  outline: none;
  box-shadow: var(--focused-list-shadow);
}

.address-book-increased-limit .address-book-increased-limit-list-item.selected {
  background-color: var(--list-active-background, #c9f4ff);
}

.address-book-increased-limit .address-book-increased-limit-list-item.selected.hovered {
  outline: none;
}

.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-name {
  color: var(--list-active-text-color);
}

.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-dn {
  color: var(--list-active-text-color);
}

.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-name {
  color: var(--list-hover-text-color);
}

.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-dn {
  color: var(--list-hover-text-color);
}

@media only screen and (min-width: 41em) {
  md-modal.modal-container-large::part(modal-content) {
    height: auto;
  }

  md-modal::part(modal-container) {
    width: var(--modal-size);
  }

  md-modal::part(modal-content) {
    height: var(--modal-size);
  }
}

@media screen and (max-width: 640px) and (max-height: 575px) {
  .radio-two-row .queueDropdown::part(combobox-options) {
    max-height: var(--dropdown-max-height-connector-view) !important;
  }

  .epdn-addressbook .address-book-increased-limit-list .fixed-size-list {
    max-height: var(--addressbook-max-height-connector-view) !important;
  }

  .radio-two-row .epdn-addressbook .address-book-increased-limit-list .fixed-size-list {
    max-height: var(--addressbook-two-row-max-height-connector-view) !important;
  }

  /* // for connector view  */
  .transfer-modal-footer-connector-view {
    bottom: 20px;
    position: absolute;
  }

  .consult-checkbox-connector {
    margin-left: 50px;
  }
}
@media screen and (max-height: 575px) {
  .transfer-to-div .fixed-size-list,
  .transfer-to-div .no-record,
  .addressbook-consult-transfer-infinite-scrolling .entry-point-content .fixed-size-list,
  .infinite-scroll-spinner-modal,
  .addressbook-consult-transfer-infinite-scrolling .address-book-increased-limit__loading,
  .addressbook-consult-transfer-infinite-scrolling .no-record {
    max-height: var(--addressbook-max-height-connector-view) !important;
  }

  .addressbook-consult-transfer-infinite-scrolling .entry-point-content .fixed-size-list {
    max-height: var(--addressbook-two-row-max-height-connector-view) !important;
  }
}
.transfer-to-div {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.epdn-addressbook-search md-input::part(md-input-container),
.transfer-to-div md-input::part(md-input-container) {
  margin-bottom: 0.5rem;
}

.infinite-list-container {
  width: 100%;
}

.ellipsis-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.infinite-scroll-spinner-modal {
  display: flex;
  justify-content: center;
  height: var(--modal-content-height);
  align-items: center;
  margin-top: auto;
}

.infinite-menu-list.selected-list-item:hover {
  background-color: var(--list-active-background, #c9f4ff);
}

.transfer-to-div .search-error {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-small);
}

.transfer-to-div .search-block-error {
  display: flex;
  align-items: center;
  padding: var(--padding-16);
  justify-content: center;
}

.modal-content-height {
  height: var(--modal-content-height);
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/InteractionControl/components/TransferModal/styles.css"],"names":[],"mappings":"AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,2CAA2C;EAC3C,8CAA8C;EAC9C,sDAAsD;EACtD,kCAAkC;EAClC,kCAAkC;EAClC,qBAAqB;EACrB,0BAA0B;EAC1B,sCAAsC;EACtC,4BAA4B;EAC5B,sCAAsC;EACtC,2BAA2B;EAC3B,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oDAAoD;EACpD,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;;;;;;;;;EASE,eAAe;EACf,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qFAAqF;EACrF,yCAAyC;AAC3C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,kCAAkC;EAClC,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;EAGE,iCAAiC;EACjC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,uDAAuD;AACzD;AACA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,gEAAgE;EAClE;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,2EAA2E;EAC7E;;EAEA,2BAA2B;EAC3B;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;;;;;;IAME,mEAAmE;EACrE;;EAEA;IACE,2EAA2E;EAC7E;AACF;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["@import \"../../../../css/variables.css\";\n\n* {\n  --dropdown-width: 510px;\n  --dropdown-max-height: 220px;\n  --dropdown-max-height-connector-view: 255px;\n  --addressbook-max-height-connector-view: 238px;\n  --addressbook-two-row-max-height-connector-view: 204px;\n  --queue-dropdown-max-height: 290px;\n  --queue-dropdown-min-height: 110px;\n  --modal-height: 420px;\n  --modal-radio-height: 24px;\n  --cancel-ctq-container-maxwidth: 500px;\n  --padding-icon-right: 0.5rem;\n  --transfer-modal-content-height: 240px;\n  --queue-dropdown-item: 36px;\n  --dropdown-height: 48px;\n  --menu-overlay-max-height: 325px;\n  --modal-size: 490px;\n  --modal-size-large: 530px;\n  --organization-list-item-max-width: 375px;\n  --modal-content-height: 290px;\n  --min-height-value: 332px;\n}\n\n.queueDropdown {\n  width: var(--dropdown-width);\n}\n\n.queueDropdown-tabbed {\n  height: 35px;\n}\n\n.queueDropdown::part(overlay) {\n  width: 100%;\n  transform: none;\n  top: calc(100% + 0.2rem);\n}\n\n.queueDropdown::part(overlay-content) {\n  width: 100%;\n}\n\n.epdn-addressbook {\n  width: 100%;\n}\n\n.entry-point-tab {\n  border-bottom: 2px solid var(--md-separator-primary);\n  width: 100%;\n  display: inline-flex;\n  height: 3rem;\n  min-height: 3rem;\n  align-items: center;\n  padding: 0.3rem 1rem;\n  color: var(--md-textColor-secondary);\n}\n\n.entry-point-tab > span {\n  margin-top: 5px;\n}\n\n.queue-option.string {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.no-options {\n  width: 100%;\n  display: inline-flex;\n  height: 3rem;\n  min-height: 3rem;\n  align-items: center;\n  padding: 0.3rem 1rem;\n  color: var(--md-textColor-secondary);\n}\n\n.queueDropdown::part(combobox-options) {\n  line-height: 21px;\n  max-height: var(--queue-dropdown-max-height);\n}\n\n.queueDropdown::part(combobox-option) {\n  max-height: var(--dropdown-height);\n}\n\n.queueDropdown::part(combobox-option) .select-label span {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.highlighted-part {\n  margin-left: 4px !important;\n}\n\n.modal-container .md-event-overlay__children {\n  height: auto;\n  max-height: var(--dropdown-max-height);\n  width: var(--dropdown-width);\n}\n\n.md-modal__header {\n  padding-bottom: 0.75rem;\n}\n\n.my-radio-group md-radiogroup .radioClass {\n  box-sizing: border-box;\n}\n\n.modal-body-class.list-queue.list-organization #dailNumberId,\n.modal-body-class.list-queue.list-organization #organizationUsers {\n  margin-top: 9px;\n}\n\n.my-radio-group md-radiogroup::part(radio-group-container) {\n  width: 100%;\n  justify-content: space-between;\n}\n\n.modal-body-class.list-queue:not(.list-organization):not(.radio-two-row):not(.list-dialnumber):not(\n    .isConsultTransferInfiniteScrollEnabled-class\n  )\n  .my-radio-group\n  md-radiogroup::part(radio-group-container),\n.modal-body-class:not(.list-organization):not(.list-queue):not(.isConsultTransferInfiniteScrollEnabled-class)\n  .my-radio-group\n  md-radiogroup::part(radio-group-container),\n.modal-body-class.radio-two-row .my-radio-group md-radiogroup::part(radio-group-container) {\n  flex-flow: wrap;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.modal-body-class.radio-three-column .my-radio-group md-radiogroup::part(radio-group-container) {\n  flex-flow: wrap;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.org-search-input::part(md-input-container) {\n  margin-bottom: 0;\n}\n\nmd-modal.modal-container-large::part(modal-header) {\n  padding-bottom: 0px;\n}\n\n.modal-container > .md-modal__content {\n  min-height: var(--modal-size);\n}\n\n.my-radio-group .md-radio-group,\n.my-radio-group .md-radio {\n  display: flex;\n}\n\n.my-radio-group {\n  /* padding-top: calc(var(--space-token-even) * 6); */\n}\n\n.agentAction-container {\n  margin-top: 0.75rem;\n}\n\nmd-modal::part(modal-body) {\n  overflow: visible;\n}\n\n.modal-container .md-label.md-radio__label > span {\n  height: var(--modal-radio-height);\n  margin-right: calc(var(--space-token-even) * 36);\n}\n\n.modal-container .md-input-container .input-error-class {\n  border-color: var(--red-color);\n  border-radius: 0;\n  box-shadow: var(--focused-shadow);\n  display: inline-block;\n}\n\n.actionMessage {\n  display: flex;\n  font-size: var(--font-size-small);\n  margin-top: 0.5rem;\n}\n\n.agentAction-error-container {\n  color: var(--md-alert-error-text-color, --red-70-color);\n}\n\n.agentAction-warning-container {\n  color: var(--md-alert-warning-text-color, --yellow-70-color);\n}\n\n.cancelCtq-info-container {\n  color: var(--md-secondary-text-color-default);\n  display: flex;\n  flex-direction: row;\n  font-size: var(--font-size-small);\n  margin-top: 0.5rem;\n  max-width: var(--cancel-ctq-container-maxwidth);\n}\n\n.agentAction-error-icon {\n  color: var(--red-70-color);\n  padding-right: 0.5rem;\n}\n\n.cancelCtq-info-icon {\n  padding-right: var(--padding-icon-right);\n}\n\nmd-radio {\n  margin-top: 12px;\n}\n\n.cancelCtq-spinner {\n  padding-right: calc(var(--space-token-even) * 4);\n  padding-top: calc(var(--space-token-even) * 2);\n}\n\n.cancelCtq-link {\n  text-decoration: underline;\n}\n\n.transfer-modal-btn {\n  margin-left: 0.75rem;\n}\n\n#dailNumberId {\n  margin-right: 0;\n}\n\n#entryPointId {\n  /* margin-top: 10px; */\n}\n\n.modal-body-class {\n  min-height: var(--transfer-modal-content-height);\n}\n\n.multiparty-consult-check-box {\n  display: flex;\n  justify-content: flex-start;\n  padding-bottom: calc(var(--space-token-even) * 4);\n  margin-left: -0.25rem;\n}\n\n.transfer-modal-md-button {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.direction-column {\n  flex-direction: column !important;\n}\n\n.transfer-modal-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.available {\n  color: var(--md-presence-active-bg-color);\n}\n\n.un-available {\n  color: var(--md-presence-away-bg-color);\n}\n\n.align {\n  vertical-align: middle;\n}\n\n.transfer-modal-search-container {\n  display: flex;\n}\n\n.transfer-modal-search-container.organization {\n  flex-direction: column;\n}\n\n.search-row {\n  display: flex;\n}\n\n.epdn-addressbook-search {\n  flex: 1;\n}\n\n.org-search-container {\n  display: flex;\n  margin-bottom: 8px;\n}\n\n.org-search-container md-input {\n  width: 100%;\n}\n\n.refresh-spinner {\n  margin: auto calc(var(--space-token-even) * 3) auto calc(var(--space-token-even) * 7);\n  width: calc(var(--space-token-even) * 14);\n}\n\n.refresh-list-tooltip {\n  margin-left: calc(var(--space-token-even) * 4);\n}\n\n.refresh-list-button {\n  height: calc(var(--space-token-even) * 14);\n  width: calc(var(--space-token-even) * 14);\n}\n\n.address-list-item {\n  align-items: center;\n  display: grid;\n  grid-template-columns: 0fr 1fr 0fr;\n  width: 100%;\n}\n\n.address-list-item-detail {\n  padding: 1px calc(var(--space-token-even) * 5);\n}\n\n.address-list-item-detail .address-name,\n.address-dn {\n  font-size: var(--font-size-medium);\n  max-width: var(--adr-name-width);\n  font-family: var(--font-family);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.address-list-item-detail .address-dn {\n  color: var(--md-secondary-text-color);\n  font-size: var(--font-size-small);\n}\n\n.organization-users-list .address-list-item-detail .address-dn {\n  max-width: var(--organization-list-item-max-width);\n}\n\n.dnDropdown::part(combobox-option) {\n  padding-bottom: var(--space-token-even);\n  padding-top: var(--space-token-even);\n}\n\n.radioLabel {\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 88px;\n}\n\n.my-radio-group .radioClass {\n  margin-right: 0;\n  width: fit-content;\n}\n\n.organization-users-list {\n  margin-top: 0.25rem;\n}\n\n.organization-users-list.disabled {\n  opacity: 0.8;\n  pointer-events: none;\n}\n\n.organization-auth-error,\n.organization-auth-error md-icon,\n.organization-auth-error md-link::part(link) {\n  font-size: var(--font-size-small);\n  color: var(--link-inline);\n  display: flex;\n  align-items: center;\n}\n\n.organization-auth-error .auth-error-message {\n  margin: 0 calc(var(--space-token-even) * 4);\n}\n\n.organization-users-list .address-book-increased-limit-list .address-book-increased-limit-list-item,\n.organization-users-list .address-book-increased-limit-list .infinite-scroll-error {\n  padding-left: 0.25rem !important;\n}\n\n.no-record {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: calc(var(--space-token-cardinal) * 2);\n  gap: 4px;\n  text-align: center;\n}\n\n.no-record-found {\n  position: relative;\n  top: 11px;\n}\n\n.org-search-error {\n  display: flex;\n  flex-direction: row;\n  column-gap: 8px;\n  align-items: center;\n  font-size: var(--font-size-small);\n}\n\n.org-search-block-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--padding-16);\n}\n\n.agentAction-container .org-search-spinner {\n  display: flex;\n  justify-content: center;\n  height: var(--transfer-modal-content-height);\n  align-items: center;\n  margin: auto;\n}\n\n.modal-container-height {\n  min-height: var(--min-height-value);\n}\n\n.all-radio-buttons-hidden {\n  display: flex;\n  height: 390px;\n  padding: 20px;\n  align-items: center;\n}\n\n.all-radio-buttons-hidden-icon {\n  display: flex;\n  align-self: baseline;\n}\n.all-radio-buttons-hidden-text-wrapper {\n  display: flex;\n  gap: 10px;\n}\n.address-book-increased-limit-list:not(.set-focus-visible):focus {\n  border: none;\n  outline: none;\n}\n.address-book-increased-limit-list:not(.set-focus-visible):focus-visible {\n  border: none;\n  outline: none;\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item {\n  padding-left: 15px !important;\n}\n.address-book-increased-limit-list .address-book-increased-limit-list-item:hover {\n  background-color: var(--list-hover-background, #c9f4ff);\n}\n.address-book-increased-limit-list .address-book-increased-limit-list-item.hovered {\n  outline: none;\n  box-shadow: var(--focused-list-shadow);\n}\n\n.address-book-increased-limit .address-book-increased-limit-list-item.selected {\n  background-color: var(--list-active-background, #c9f4ff);\n}\n\n.address-book-increased-limit .address-book-increased-limit-list-item.selected.hovered {\n  outline: none;\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-name {\n  color: var(--list-active-text-color);\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item.selected .address-dn {\n  color: var(--list-active-text-color);\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-name {\n  color: var(--list-hover-text-color);\n}\n\n.address-book-increased-limit-list .address-book-increased-limit-list-item:hover .address-dn {\n  color: var(--list-hover-text-color);\n}\n\n@media only screen and (min-width: 41em) {\n  md-modal.modal-container-large::part(modal-content) {\n    height: auto;\n  }\n\n  md-modal::part(modal-container) {\n    width: var(--modal-size);\n  }\n\n  md-modal::part(modal-content) {\n    height: var(--modal-size);\n  }\n}\n\n@media screen and (max-width: 640px) and (max-height: 575px) {\n  .radio-two-row .queueDropdown::part(combobox-options) {\n    max-height: var(--dropdown-max-height-connector-view) !important;\n  }\n\n  .epdn-addressbook .address-book-increased-limit-list .fixed-size-list {\n    max-height: var(--addressbook-max-height-connector-view) !important;\n  }\n\n  .radio-two-row .epdn-addressbook .address-book-increased-limit-list .fixed-size-list {\n    max-height: var(--addressbook-two-row-max-height-connector-view) !important;\n  }\n\n  /* // for connector view  */\n  .transfer-modal-footer-connector-view {\n    bottom: 20px;\n    position: absolute;\n  }\n\n  .consult-checkbox-connector {\n    margin-left: 50px;\n  }\n}\n@media screen and (max-height: 575px) {\n  .transfer-to-div .fixed-size-list,\n  .transfer-to-div .no-record,\n  .addressbook-consult-transfer-infinite-scrolling .entry-point-content .fixed-size-list,\n  .infinite-scroll-spinner-modal,\n  .addressbook-consult-transfer-infinite-scrolling .address-book-increased-limit__loading,\n  .addressbook-consult-transfer-infinite-scrolling .no-record {\n    max-height: var(--addressbook-max-height-connector-view) !important;\n  }\n\n  .addressbook-consult-transfer-infinite-scrolling .entry-point-content .fixed-size-list {\n    max-height: var(--addressbook-two-row-max-height-connector-view) !important;\n  }\n}\n.transfer-to-div {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n}\n\n.epdn-addressbook-search md-input::part(md-input-container),\n.transfer-to-div md-input::part(md-input-container) {\n  margin-bottom: 0.5rem;\n}\n\n.infinite-list-container {\n  width: 100%;\n}\n\n.ellipsis-text {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.infinite-scroll-spinner-modal {\n  display: flex;\n  justify-content: center;\n  height: var(--modal-content-height);\n  align-items: center;\n  margin-top: auto;\n}\n\n.infinite-menu-list.selected-list-item:hover {\n  background-color: var(--list-active-background, #c9f4ff);\n}\n\n.transfer-to-div .search-error {\n  display: flex;\n  flex-direction: row;\n  column-gap: 8px;\n  align-items: center;\n  font-size: var(--font-size-small);\n}\n\n.transfer-to-div .search-block-error {\n  display: flex;\n  align-items: center;\n  padding: var(--padding-16);\n  justify-content: center;\n}\n\n.modal-content-height {\n  height: var(--modal-content-height);\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/styles/Accordion.css":
/*!*******************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/styles/Accordion.css ***!
  \*******************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../node_modules/css-loader/dist/cjs.js!../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_agentx_services_dist_styles_z_index_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! -!../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../agentx-services/dist/styles/z-index.css */ "../../node_modules/css-loader/dist/cjs.js!../agentx-services/dist/styles/z-index.css");
// Imports




var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_agentx_services_dist_styles_z_index_css__WEBPACK_IMPORTED_MODULE_3__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --accordion-max-width: 5px;
}

* {
  --interaction-button-collapse-left: calc(50% - (calc(var(--grabber-width) / 2)));
  --interaction-button-collapse-height: var(--grabber-width, 12px);
}

.interaction-control-wrapper {
  max-width: 100%;
  padding: 0;
  position: relative;
  width: 100%;

  background-color: var(--interaction-container-bg-color, var(--md-secondary-white-bg-color));
  border-radius: var(--border-radius-medium);
}

.interaction-control {
  --avatar-width: 32px;
  display: flex;
  width: 100%;
  flex-direction: column;
  box-sizing: border-box;
}

.interaction-control-title {
  display: flex;
  border: none;
  outline: none;
  font-family: var(--font-family);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-normal);
  justify-content: space-between;
  align-items: center;
  padding: calc(var(--space-token-even) * 8) calc(var(--space-token-cardinal) * 5);
  border-bottom: var(--interaction-control-title-bottom-border);
  border-radius: var(--border-radius-medium);
}

.inner-container {
  margin-top: calc(var(--space-token-even) * -6);
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
}

.interaction-control-title.interaction-expanded {
  border-radius: 0;
}

.interaction_detail_container {
  display: flex;
  align-items: center;
  flex: 1;
}

.interaction_detail_container .interaction-section {
  max-width: var(--accordion-max-width);
  padding-right: calc(var(--space-token-even) * 6);
  display: flex;
  flex-direction: column;
}

.interaction-section .interaction-control-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  max-width: 17rem;
}

/**  
* changing  be default margin  of hr
*/
hr {
  margin: 0;
}

.interaction-control-content {
  display: none;
  width: 100%;
}

.interaction-control-display {
  display: block;
  border-radius: var(--border-radius-medium-bottom);
  padding: calc(var(--space-token-even) * 8) 0px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.interaction-control.handset-active_12 .interaction-control-display {
  border-radius: var(--border-radius-medium-bottom);
}

.interaction-control.email-active_16 .interaction-control-title {
  border-radius: var(--border-radius-medium-top);
}

.interaction-control-avatar {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  text-align: start;
  align-items: center;
}

#interaction-control-id {
  padding: 0;
  display: flex;
  box-sizing: border-box;
  flex: 1;
  box-shadow: var(--common-box-shadow-elevation2);
  border-radius: var(--border-radius-medium);
}

#interaction-control-id:not(:first-child) {
  margin-top: 8px;
}

.updateStatusColor {
  color: var(--md-alert-warning-bg-color, --md-alert-warning-bg-color-default);
  font-size: var(--font-size-small);
}

.interaction-control-name {
  color: var(--md-primary-text-color, --md-primary-text-color-default);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-bold);
  line-height: 1.5rem;
  margin-top: 0;
  margin-bottom: 4px;
}

.accordion-toggle-button-icon {
  line-height: 10px;
  margin: 0 15px;
}

.interaction-control .collapse-button {
  opacity: 0;
  position: absolute;
  left: var(--interaction-button-collapse-left);
  top: 100%;
  bottom: 6.12%;
}

.interaction-control .collapse-button:focus-within {
  opacity: 1;
  width: 40px;
  left: var(--interaction-button-collapse-left);
  height: var(--interaction-button-collapse-height);
  z-index: var(--z-index-expand-collapse, 3);
}
.interaction-control:hover .collapse-button,
.interaction-control-title .expand-button {
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 100%;
  bottom: 6.12%;
  width: 40px;
  left: var(--interaction-button-collapse-left);
  height: var(--interaction-button-collapse-height);
  z-index: var(--z-index-expand-collapse, 3);
}

.md-button--icon:focus {
  box-shadow: none;
}

.align-center-flex {
  display: inline-flex;
  align-items: flex-start;
}

.interaction-content {
  justify-content: space-between;
  flex-flow: row wrap;
  width: 100%;
  max-height: 180px;
  overflow-y: auto;
  margin: 0;
}

.interaction-info-section {
  padding: var(--space-token-even);
  flex-basis: var(--flex-only-two-columns);
  min-width: 0;
  line-height: 2rem;
  width: 100%;
  box-sizing: border-box;
}

.interaction-content.single-column {
  flex-flow: column;
  max-height: 153px;
}

.interaction-info-section .md-input-container {
  margin-bottom: 0;
}

.interaction-info-key {
  display: flex;
  font-size: var(--font-size-medium);
  color: var(--md-secondary-text-color, --md-secondary-text-color-default);
  margin-left: calc(var(--space-token-even) * 12);
  margin-right: calc(var(--space-token-even) * 4);
  min-width: 7.2rem;
  width: 30%;
}
.interaction-info-key .interaction-label {
  float: left;
  word-break: break-word;

  font-weight: var(--brand-font-weight-bold, regular);
  font-family: var(--font-family-bold);
  color: var(--md-primary-text-color);
}
.interaction-secure-cad {
  margin-left: 9px;
}

.interaction-info-value {
  font-size: var(--font-size-medium);
  color: var(--md-primary-text-color, --md-primary-text-color-default);
  width: 70%;
  margin-right: calc(var(--space-token-even) * 12);
  margin-left: 0;
}
.interaction-mask-value {
  border-radius: 0.25rem;
  min-height: 2rem;
  overflow-y: auto;
  padding: 0px 0.375rem;
}
.interaction-info-value:hover .copy-button-container {
  opacity: 1;
}

.copy-button-container:focus-within {
  opacity: 1;
}

.cad-value-width {
  width: calc(100% - 40px);
}
.cad-timer {
  padding: 0 6px;
}
.non-editable-field {
  color: var(--md-secondary-text-color, --md-secondary-text-color-default);
}

.btn-group {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.word-break {
  word-break: break-word;
}

.interactionButtonHolder md-menu-overlay::part(overlay) {
  top: -8px !important;
}

.interactionButtonText {
  font-size: var(--font-size-medium);
}

.ellipses {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.interaction_detail_container,
.interaction-button-container {
  margin-top: calc(var(--space-token-even) * 6);
}

.monitoring-split {
  display: flex;
}

.monitoring-split img {
  width: 13px;
  margin-right: 6px;
}

.split-icon {
  margin-right: 0.375rem;
  height: 1rem;
}

.timer-dash {
  margin: 0 0.3rem;
}

.recording-indicator {
  position: absolute;
  top: 5px;
  right: 5px;
  line-height: 14px;
  color: var(--button-red-bg-color, #d4371c);
}

.recording-indicator.recording-paused {
  color: var(--button-disabled-text-color, #b2b2b2);
}

.cad-button-container {
  float: right;
  display: flex;
  margin-right: calc(var(--space-token-even) * 8);
}

.cad-buttons {
  margin-left: calc(var(--space-token-even) * 6);

  span {
    font-size: var(--font-size-medium);
  }
}

.cad-retry {
  font: var(--font-size-small);
  background-color: transparent;
  border: none;
  color: inherit;
  padding: 0;
  cursor: pointer;
  margin-left: 12px;
}
.cad-retry-disable {
  color: var(--disabled-text-color);
}

.cad-retry-text {
  text-decoration: underline;
}
.cad-retry-spinner {
  display: inline-block;
  margin: 0 0 -1px 8px;
}
.agentAction-error-icon {
  padding-right: calc(var(--space-token-even) * 2);
  vertical-align: middle;
}

.agentAction-retry-icon {
  vertical-align: middle;
}

.agentAction-success-icon {
  padding-right: calc(var(--space-token-even) * 2);
  vertical-align: middle;
}

.agentAction-warning-icon {
  padding-right: calc(var(--space-token-even) * 2);
  vertical-align: middle;
}

.agentAction-success-container {
  font: var(--font-size-small);
  color: var(--md-alert-success-text-color);
}

.agentAction-error-container {
  font: var(--font-size-small);
  color: var(--md-alert-error-text-color);
}

.agentAction-warning-container {
  font: var(--font-size-small);
  color: var(--md-alert-warning-text-color);
}
.securecad-error {
  display: block;
}
.cad-container {
  padding-top: calc(var(--space-token-even) * 13);
  float: left;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  height: 68px;
}
.decrypt-error.single-column {
  position: absolute;
  bottom: 0;
}
.cad-container.single-column {
  padding-top: calc(var(--space-token-even) * 1);
  height: 92px;
}
.cad-alert-container.single-column {
  margin-bottom: 8px;
  position: relative;
  height: 51px;
  width: 100%;
}

.cad-alert-container {
  float: left;
  padding-left: calc(var(--space-token-even) * 12);
  position: absolute;
  bottom: 0;
}

.copy-button-container {
  margin-left: calc(var(--space-token-cardinal) * 2);
  align-self: center;
  opacity: 0;
  transition: opacity 250ms linear;
}

@media (min-width: 737px) and (max-width: 1023px) {
  #interaction-control-id {
    /* Accordion width to be full minus Nav bar width minus padding above Connector view */
    width: calc(100vw - var(--nav-bar-width) - (var(--panel-padding-width) * 2));
  }
}

@media (min-width: 737px) {
  #interaction-accordion .higher-z-index {
    z-index: var(--z-index-task-collapse-area, 7);
  }
}

@media (max-width: 736px) {
  #interaction-control-id {
    /* Accordion width to be full minus padding in Connector view */
    width: calc(100vw - (var(--panel-padding-width) * 2));
  }
}

div.interaction-control-status > md-badge::part(badge) {
  background-color: var(--md-secondary-two-bg-color);
}

div.interaction-control-status .monitoring-hold::part(badge) {
  background-color: var(--button-engaged-bg-color, #fff7e3);
}

.md-list-conference {
  width: 100%;
  justify-content: flex-start;
}

.md-list-conference .conference-timer {
  position: absolute;
  left: 211px;
}

.md-list-conference .conference-span-icon {
  left: var(--left-spacing-16);
  margin-top: 0;
}

.md-list-conference .conferenceBargeIN-span-name {
  left: var(--left-spacing-40);
  display: block;
  width: 162px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.split-separator {
  margin: 0 var(--margin-8);
  opacity: 0.4;
}

md-menu-overlay md-button.md-button-conference::part(button) {
  background-color: var(--md-secondary-two-bg-color);
  font-size: var(--font-size-small);
  padding: var(--conference-button-padding);
  color: var(--button-secondary-text-color);
}

.split-right-participants {
  margin-left: 0;
  display: flex;
  align-items: center;
}

.split-right-conference {
  margin-left: 0;
}

.md-button-conference md-badge {
  margin-right: var(--margin-375rem);
}

md-icon.arrow-icon.arrow-up {
  padding-top: var(--space-token-even);
}

md-menu-overlay md-button.md-button-conference .agent-current-status-timer {
  margin-left: 0;
}

.interaction-control-title .timer-label {
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
}

.md-list-conference .conference-timer .agent-current-status-timer {
  font-size: var(--font-size-small);
}

.md-list-item-conference {
  padding: var(--padding-3);
  background-color: var(--md-secondary-two-bg-color);
}

.conference-span-name-tooltip {
  overflow: hidden;
}

.wd-100 {
  width: 100% !important;
}

.conferenceBargeIN-span {
  display: flex;
  left: 0;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/InteractionControl/styles/Accordion.css"],"names":[],"mappings":"AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gFAAgF;EAChF,gEAAgE;AAClE;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,WAAW;;EAEX,2FAA2F;EAC3F,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,iCAAiC;EACjC,sCAAsC;EACtC,8BAA8B;EAC9B,mBAAmB;EACnB,gFAAgF;EAChF,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;EAC9C,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,qCAAqC;EACrC,gDAAgD;EAChD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;CAEC;AACD;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iDAAiD;EACjD,8CAA8C;EAC9C,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,+CAA+C;EAC/C,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4EAA4E;EAC5E,iCAAiC;AACnC;;AAEA;EACE,oEAAoE;EACpE,iCAAiC;EACjC,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,6CAA6C;EAC7C,SAAS;EACT,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6CAA6C;EAC7C,iDAAiD;EACjD,0CAA0C;AAC5C;AACA;;EAEE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,WAAW;EACX,6CAA6C;EAC7C,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,wEAAwE;EACxE,+CAA+C;EAC/C,+CAA+C;EAC/C,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,WAAW;EACX,sBAAsB;;EAEtB,mDAAmD;EACnD,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oEAAoE;EACpE,UAAU;EACV,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;;EAE9C;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;AACA;EACE,+CAA+C;EAC/C,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gDAAgD;EAChD,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE;IACE,sFAAsF;IACtF,4EAA4E;EAC9E;AACF;;AAEA;EACE;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,+DAA+D;IAC/D,qDAAqD;EACvD;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,iCAAiC;EACjC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,WAAW;AACb","sourcesContent":["@import \"../../../css/variables.css\";\n@import \"~@agentx/agentx-services/dist/styles/z-index.css\";\n\n:host {\n  --accordion-max-width: 5px;\n}\n\n* {\n  --interaction-button-collapse-left: calc(50% - (calc(var(--grabber-width) / 2)));\n  --interaction-button-collapse-height: var(--grabber-width, 12px);\n}\n\n.interaction-control-wrapper {\n  max-width: 100%;\n  padding: 0;\n  position: relative;\n  width: 100%;\n\n  background-color: var(--interaction-container-bg-color, var(--md-secondary-white-bg-color));\n  border-radius: var(--border-radius-medium);\n}\n\n.interaction-control {\n  --avatar-width: 32px;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.interaction-control-title {\n  display: flex;\n  border: none;\n  outline: none;\n  font-family: var(--font-family);\n  font-size: var(--font-size-large);\n  font-weight: var(--font-weight-normal);\n  justify-content: space-between;\n  align-items: center;\n  padding: calc(var(--space-token-even) * 8) calc(var(--space-token-cardinal) * 5);\n  border-bottom: var(--interaction-control-title-bottom-border);\n  border-radius: var(--border-radius-medium);\n}\n\n.inner-container {\n  margin-top: calc(var(--space-token-even) * -6);\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  align-items: center;\n}\n\n.interaction-control-title.interaction-expanded {\n  border-radius: 0;\n}\n\n.interaction_detail_container {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n\n.interaction_detail_container .interaction-section {\n  max-width: var(--accordion-max-width);\n  padding-right: calc(var(--space-token-even) * 6);\n  display: flex;\n  flex-direction: column;\n}\n\n.interaction-section .interaction-control-name {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  display: block;\n  max-width: 17rem;\n}\n\n/**  \n* changing  be default margin  of hr\n*/\nhr {\n  margin: 0;\n}\n\n.interaction-control-content {\n  display: none;\n  width: 100%;\n}\n\n.interaction-control-display {\n  display: block;\n  border-radius: var(--border-radius-medium-bottom);\n  padding: calc(var(--space-token-even) * 8) 0px;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.interaction-control.handset-active_12 .interaction-control-display {\n  border-radius: var(--border-radius-medium-bottom);\n}\n\n.interaction-control.email-active_16 .interaction-control-title {\n  border-radius: var(--border-radius-medium-top);\n}\n\n.interaction-control-avatar {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: row;\n  text-align: start;\n  align-items: center;\n}\n\n#interaction-control-id {\n  padding: 0;\n  display: flex;\n  box-sizing: border-box;\n  flex: 1;\n  box-shadow: var(--common-box-shadow-elevation2);\n  border-radius: var(--border-radius-medium);\n}\n\n#interaction-control-id:not(:first-child) {\n  margin-top: 8px;\n}\n\n.updateStatusColor {\n  color: var(--md-alert-warning-bg-color, --md-alert-warning-bg-color-default);\n  font-size: var(--font-size-small);\n}\n\n.interaction-control-name {\n  color: var(--md-primary-text-color, --md-primary-text-color-default);\n  font-size: var(--font-size-large);\n  font-weight: var(--font-weight-bold);\n  line-height: 1.5rem;\n  margin-top: 0;\n  margin-bottom: 4px;\n}\n\n.accordion-toggle-button-icon {\n  line-height: 10px;\n  margin: 0 15px;\n}\n\n.interaction-control .collapse-button {\n  opacity: 0;\n  position: absolute;\n  left: var(--interaction-button-collapse-left);\n  top: 100%;\n  bottom: 6.12%;\n}\n\n.interaction-control .collapse-button:focus-within {\n  opacity: 1;\n  width: 40px;\n  left: var(--interaction-button-collapse-left);\n  height: var(--interaction-button-collapse-height);\n  z-index: var(--z-index-expand-collapse, 3);\n}\n.interaction-control:hover .collapse-button,\n.interaction-control-title .expand-button {\n  opacity: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 100%;\n  bottom: 6.12%;\n  width: 40px;\n  left: var(--interaction-button-collapse-left);\n  height: var(--interaction-button-collapse-height);\n  z-index: var(--z-index-expand-collapse, 3);\n}\n\n.md-button--icon:focus {\n  box-shadow: none;\n}\n\n.align-center-flex {\n  display: inline-flex;\n  align-items: flex-start;\n}\n\n.interaction-content {\n  justify-content: space-between;\n  flex-flow: row wrap;\n  width: 100%;\n  max-height: 180px;\n  overflow-y: auto;\n  margin: 0;\n}\n\n.interaction-info-section {\n  padding: var(--space-token-even);\n  flex-basis: var(--flex-only-two-columns);\n  min-width: 0;\n  line-height: 2rem;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.interaction-content.single-column {\n  flex-flow: column;\n  max-height: 153px;\n}\n\n.interaction-info-section .md-input-container {\n  margin-bottom: 0;\n}\n\n.interaction-info-key {\n  display: flex;\n  font-size: var(--font-size-medium);\n  color: var(--md-secondary-text-color, --md-secondary-text-color-default);\n  margin-left: calc(var(--space-token-even) * 12);\n  margin-right: calc(var(--space-token-even) * 4);\n  min-width: 7.2rem;\n  width: 30%;\n}\n.interaction-info-key .interaction-label {\n  float: left;\n  word-break: break-word;\n\n  font-weight: var(--brand-font-weight-bold, regular);\n  font-family: var(--font-family-bold);\n  color: var(--md-primary-text-color);\n}\n.interaction-secure-cad {\n  margin-left: 9px;\n}\n\n.interaction-info-value {\n  font-size: var(--font-size-medium);\n  color: var(--md-primary-text-color, --md-primary-text-color-default);\n  width: 70%;\n  margin-right: calc(var(--space-token-even) * 12);\n  margin-left: 0;\n}\n.interaction-mask-value {\n  border-radius: 0.25rem;\n  min-height: 2rem;\n  overflow-y: auto;\n  padding: 0px 0.375rem;\n}\n.interaction-info-value:hover .copy-button-container {\n  opacity: 1;\n}\n\n.copy-button-container:focus-within {\n  opacity: 1;\n}\n\n.cad-value-width {\n  width: calc(100% - 40px);\n}\n.cad-timer {\n  padding: 0 6px;\n}\n.non-editable-field {\n  color: var(--md-secondary-text-color, --md-secondary-text-color-default);\n}\n\n.btn-group {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.word-break {\n  word-break: break-word;\n}\n\n.interactionButtonHolder md-menu-overlay::part(overlay) {\n  top: -8px !important;\n}\n\n.interactionButtonText {\n  font-size: var(--font-size-medium);\n}\n\n.ellipses {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.interaction_detail_container,\n.interaction-button-container {\n  margin-top: calc(var(--space-token-even) * 6);\n}\n\n.monitoring-split {\n  display: flex;\n}\n\n.monitoring-split img {\n  width: 13px;\n  margin-right: 6px;\n}\n\n.split-icon {\n  margin-right: 0.375rem;\n  height: 1rem;\n}\n\n.timer-dash {\n  margin: 0 0.3rem;\n}\n\n.recording-indicator {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  line-height: 14px;\n  color: var(--button-red-bg-color, #d4371c);\n}\n\n.recording-indicator.recording-paused {\n  color: var(--button-disabled-text-color, #b2b2b2);\n}\n\n.cad-button-container {\n  float: right;\n  display: flex;\n  margin-right: calc(var(--space-token-even) * 8);\n}\n\n.cad-buttons {\n  margin-left: calc(var(--space-token-even) * 6);\n\n  span {\n    font-size: var(--font-size-medium);\n  }\n}\n\n.cad-retry {\n  font: var(--font-size-small);\n  background-color: transparent;\n  border: none;\n  color: inherit;\n  padding: 0;\n  cursor: pointer;\n  margin-left: 12px;\n}\n.cad-retry-disable {\n  color: var(--disabled-text-color);\n}\n\n.cad-retry-text {\n  text-decoration: underline;\n}\n.cad-retry-spinner {\n  display: inline-block;\n  margin: 0 0 -1px 8px;\n}\n.agentAction-error-icon {\n  padding-right: calc(var(--space-token-even) * 2);\n  vertical-align: middle;\n}\n\n.agentAction-retry-icon {\n  vertical-align: middle;\n}\n\n.agentAction-success-icon {\n  padding-right: calc(var(--space-token-even) * 2);\n  vertical-align: middle;\n}\n\n.agentAction-warning-icon {\n  padding-right: calc(var(--space-token-even) * 2);\n  vertical-align: middle;\n}\n\n.agentAction-success-container {\n  font: var(--font-size-small);\n  color: var(--md-alert-success-text-color);\n}\n\n.agentAction-error-container {\n  font: var(--font-size-small);\n  color: var(--md-alert-error-text-color);\n}\n\n.agentAction-warning-container {\n  font: var(--font-size-small);\n  color: var(--md-alert-warning-text-color);\n}\n.securecad-error {\n  display: block;\n}\n.cad-container {\n  padding-top: calc(var(--space-token-even) * 13);\n  float: left;\n  width: 100%;\n  box-sizing: border-box;\n  position: relative;\n  height: 68px;\n}\n.decrypt-error.single-column {\n  position: absolute;\n  bottom: 0;\n}\n.cad-container.single-column {\n  padding-top: calc(var(--space-token-even) * 1);\n  height: 92px;\n}\n.cad-alert-container.single-column {\n  margin-bottom: 8px;\n  position: relative;\n  height: 51px;\n  width: 100%;\n}\n\n.cad-alert-container {\n  float: left;\n  padding-left: calc(var(--space-token-even) * 12);\n  position: absolute;\n  bottom: 0;\n}\n\n.copy-button-container {\n  margin-left: calc(var(--space-token-cardinal) * 2);\n  align-self: center;\n  opacity: 0;\n  transition: opacity 250ms linear;\n}\n\n@media (min-width: 737px) and (max-width: 1023px) {\n  #interaction-control-id {\n    /* Accordion width to be full minus Nav bar width minus padding above Connector view */\n    width: calc(100vw - var(--nav-bar-width) - (var(--panel-padding-width) * 2));\n  }\n}\n\n@media (min-width: 737px) {\n  #interaction-accordion .higher-z-index {\n    z-index: var(--z-index-task-collapse-area, 7);\n  }\n}\n\n@media (max-width: 736px) {\n  #interaction-control-id {\n    /* Accordion width to be full minus padding in Connector view */\n    width: calc(100vw - (var(--panel-padding-width) * 2));\n  }\n}\n\ndiv.interaction-control-status > md-badge::part(badge) {\n  background-color: var(--md-secondary-two-bg-color);\n}\n\ndiv.interaction-control-status .monitoring-hold::part(badge) {\n  background-color: var(--button-engaged-bg-color, #fff7e3);\n}\n\n.md-list-conference {\n  width: 100%;\n  justify-content: flex-start;\n}\n\n.md-list-conference .conference-timer {\n  position: absolute;\n  left: 211px;\n}\n\n.md-list-conference .conference-span-icon {\n  left: var(--left-spacing-16);\n  margin-top: 0;\n}\n\n.md-list-conference .conferenceBargeIN-span-name {\n  left: var(--left-spacing-40);\n  display: block;\n  width: 162px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.split-separator {\n  margin: 0 var(--margin-8);\n  opacity: 0.4;\n}\n\nmd-menu-overlay md-button.md-button-conference::part(button) {\n  background-color: var(--md-secondary-two-bg-color);\n  font-size: var(--font-size-small);\n  padding: var(--conference-button-padding);\n  color: var(--button-secondary-text-color);\n}\n\n.split-right-participants {\n  margin-left: 0;\n  display: flex;\n  align-items: center;\n}\n\n.split-right-conference {\n  margin-left: 0;\n}\n\n.md-button-conference md-badge {\n  margin-right: var(--margin-375rem);\n}\n\nmd-icon.arrow-icon.arrow-up {\n  padding-top: var(--space-token-even);\n}\n\nmd-menu-overlay md-button.md-button-conference .agent-current-status-timer {\n  margin-left: 0;\n}\n\n.interaction-control-title .timer-label {\n  clip: rect(1px, 1px, 1px, 1px);\n  clip-path: inset(50%);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n}\n\n.md-list-conference .conference-timer .agent-current-status-timer {\n  font-size: var(--font-size-small);\n}\n\n.md-list-item-conference {\n  padding: var(--padding-3);\n  background-color: var(--md-secondary-two-bg-color);\n}\n\n.conference-span-name-tooltip {\n  overflow: hidden;\n}\n\n.wd-100 {\n  width: 100% !important;\n}\n\n.conferenceBargeIN-span {\n  display: flex;\n  left: 0;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionPopoverManager/components/index.css":
/*!**************************************************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionPopoverManager/components/index.css ***!
  \**************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../../node_modules/css-loader/dist/cjs.js!../../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_agentx_services_dist_styles_z_index_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! -!../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../agentx-services/dist/styles/z-index.css */ "../../node_modules/css-loader/dist/cjs.js!../agentx-services/dist/styles/z-index.css");
// Imports




var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_agentx_services_dist_styles_z_index_css__WEBPACK_IMPORTED_MODULE_3__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  --popover-width: 328px;
  --popover-header-height: 60px;
  --popover-header-error-height: 100px;
  --popover-margin: 16px;
  --popover-padding: 12px;
  --popover-error-width: 265px;
  --icon-badge-widht: 40px;
  --icon-badge-height: 12px;
  --error-detail-input-width: 225px;
  --popover-contact-title: 175px;
  --popover-contact-width: 372.5px;
  --popover-contact-max-height: 75px;
  --popover-icon-badge-margin: 0 12px 0 15.5px;
  --popover-error-margin: 0px 40px 0px 67.5px;
  --animation-slideIn-pop: slideInPop var(--default-animation-duration) var(--ease-in-out-quint) forwards;
  --animation-slideOut-pop: slideOutPop var(--default-animation-duration) var(--ease-in-out-quint) forwards;
  --queue-max-width: 100px;
  --popover-tasklist-icon-margin: 6px;
  --popover-tasklist-contact-title-header-width: 250px;
  --popover-tasklist-contact-title-width: 160px;
  --popover-tasklist-title-line-height: 14px;
  --popover-tasklist-title-info-line-height: 22px;
  --popover-tasklist-margin: 4px 6px;
  --popover-tasklist-border-radius: 0.75rem;
  --popover-tasklist-contact-header: 48px;
  --popover-tasklist-contact-padding: 4px;
  --green-60: #00853c;
  --green-50: #00ab50;
  --green-70: #03612c;
  --popover-dot-width: 4px;
  --pagination-accept-max-width: 130px;
  --popover-button-max-width: 85px;
}

.popover-light {
  width: var(--popover-width);
  margin-top: var(--popover-margin);
  background-color: var(--md-primary-bg-color);
  border: 1px solid var(--gray-30-color);
  border-radius: var(--border-radius-medium);
  font-size: var(--font-size-small);
  font-family: var(--font-family);
  color: var(--md-secondary-text-color);
}

.popover-dark {
  width: var(--popover-width);
  margin-top: var(--popover-margin);
  background-color: var(--md-primary-bg-color);
  border: 1px solid var(--gray-80-color);
  border-radius: var(--border-radius-medium);
  font-size: var(--font-size-small);
  font-family: var(--font-family);
  color: var(--md-secondary-text-color);
}

.header {
  min-height: var(--popover-header-height);
  display: flex;
  align-items: center;
  position: relative;
  flex-direction: column;
}

.header md-task-item::part(task-item-container) {
  box-shadow: none;
  background-color: transparent;
  max-width: var(--popover-width);
  width: 100%;
}

.header-error {
  min-height: var(--popover-header-error-height);
  padding: var(--popover-padding) var(--space-token-cardinal) var(--popover-padding) 0;
}

.channel-icon {
  position: relative;
  top: 0.1rem;
}

.queue-name {
  max-width: var(--queue-max-width);
  display: inline-block;
  margin-right: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.loader {
  font-size: 3px;
  margin-top: 3px;
  margin-left: 2px;
}

.connecting-loader {
  max-width: var(--queue-max-width);
  display: flex;
  margin-right: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.popover-error-icon {
  vertical-align: middle;
  padding-right: var(--space-token-cardinal);
}

.trackingid-input {
  border: none;
  font-size: var(--font-size-xsmall);
  font-weight: var(--font-weight-normal);
  width: var(--error-detail-input-width);
  color: var(--md-secondary-text-color);
  background-color: var(--white-color);
}

.trackingid-input-call-green {
  background: var(--green-05-color);
}

.trackingId-label {
  font-size: var(--font-size-xsmall);
  font-weight: var(--font-weight-normal);
  color: var(--md-secondary-text-color);
  padding-right: var(--space-token-cardinal);
}

.popover-contact-title {
  width: var(--popover-contact-title);
}

.popover-trackingId,
.popover-contact-title-header {
  display: flex;
  justify-content: space-between;
}

.popover-contact-title-header {
  width: var(--popover-error-width);
}

.popover-toggle-button {
  position: absolute;
  bottom: calc(var(--icon-badge-height) / 2 * -2);
  left: calc(50% - var(--icon-badge-widht) / 2);
  width: var(--icon-badge-widht);
  height: var(--icon-badge-height);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1px;
}

.popover-toggle-button md-button {
  width: 100%;
  opacity: 0;
  transition: opacity 150ms linear;
}

.popover-toggle-button md-button:focus {
  opacity: 1;
  background: var(--md-primary-seperator-color, --md-primary-seperator-color-default);
}

.popover-toggle-button md-button:focus-within {
  opacity: 1;
}

.popover-toggle-button md-button::part(button) {
  width: 100%;
  height: 100%;
  background: var(--md-input-disabled);
  border-bottom-right-radius: calc(var(--icon-badge-height) / 2);
  border-bottom-left-radius: calc(var(--icon-badge-height) / 2);
  padding: 2px;
  box-shadow: 0px 2px 4px rgb(0 0 0 / 25%);
}

.popover:hover .popover-toggle-button md-button,
.popover.popover-expanded .popover-toggle-button md-button {
  opacity: 1;
}

.popover-contact-header {
  display: flex;
}

.copy-trackingId-btn {
  background: none;
  border: none;
  vertical-align: middle;
}

.error-details .trackingId-summary {
  cursor: pointer;
  text-decoration: underline;
  color: var(--link-color);
  width: fit-content;
}

.error-details .trackingId-summary::-webkit-details-marker {
  display: none;
}

.header button {
  margin-left: 4px;
}

.icon-badge {
  width: var(--icon-badge-widht);
  height: var(--icon-badge-widht);
  background-color: var(--gray-10-color);
  margin: var(--popover-icon-badge-margin);
}

.icon-badge-call {
  width: var(--icon-badge-widht);
  height: var(--icon-badge-widht);
  background-color: var(--white-color);
  margin: var(--popover-icon-badge-margin);
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

.cancelling-text-container {
  display: inline-flex;
  width: 54px;
}
.cancelling-text-container md-spinner {
  margin-right: 4px;
}

.cancelling-text-container .cancelling-text {
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  white-space: nowrap;
}

.popover-contact {
  width: var(--popover-contact-width);
}

.contact-title {
  font-size: var(--font-size-large);
  color: var(--gray-100-color);
}

.popover-timer {
  color: var(--taskitem-timer-text-color);
}

.header .interaction-btn {
  padding: 0 !important;
  height: var(--defult-button-size) !important;
}

.accept-btn-call::part(button) {
  background-color: var(--md-primary-success-bg-color);
  color: var(--md-primary-success-text-color);
  cursor: default;
}

.accept-btn-call {
  cursor: default;
  height: auto;
  display: inline-block;
}

.details-toggle-btn {
  background: none;
}

.popover-details-light {
  padding: var(--popover-padding);
  border-top: 1px solid var(--gray-30-color);
  display: none;
}

.popover-details-dark {
  padding: var(--popover-padding);
  border-top: 1px solid var(--gray-80-color);
  display: none;
}

.popover-details.popover-details-show {
  display: block;
}

.popover-details-row {
  margin: 0;
  display: flex;
  width: 100%;
  padding-bottom: 4px;
  font-size: var(--font-size-small);
}

.popover-details-row dt md-tooltip,
.popover-details-row dd md-tooltip {
  width: 100%;
}

.popover-details-row dd {
  height: 20px;
  margin-inline-start: 0px;
}

.popover-details-row dd:focus-visible {
  outline-color: var(--md-button-primary-hover-bg-color, #005e7d);
}

.popover-details-row dt {
  font-weight: var(--font-weight-normal); /* Overriding momemtum css on dt element*/
  width: 40%;
}

.popover-details-row dd {
  width: 60%;
}

.popover-details-row dd .popover-details-row-value {
  margin-bottom: 0; /* Overriding momemtum css on dd element*/
  margin-left: 0;
}

.popover-details-row:last-child {
  padding-bottom: 0;
}

dl.popover-details-row > dt ::after {
  content: ":";
}

.popover-details-row-label {
  /* flex: 0.7; */
  width: 100%;
}

.popover-details-row-value {
  flex: 1;
  width: 100%;
  color: var(--md-primary-text-color);
  margin-left: calc(var(--space-token-cardinal) * 2);
  padding-left: 2px;
}

.popover-title-info {
  display: flex;
}

.popover-title-info > div:first-child::after {
  content: "-";
  padding-left: var(--space-token-cardinal);
  padding-right: var(--space-token-cardinal);
}

.popover-error {
  width: var(--popover-error-width);
  color: var(--red-70-color);
  font-size: var(--font-size-small);
  margin: var(--popover-error-margin);
  margin-bottom: calc(var(--space-token-cardinal) * 2);
}

.popover-slide-in {
  animation: var(--animation-slideIn-pop);
}

.popover-slide-out {
  animation: var(--animation-slideOut-pop);
}

.popover_container {
  z-index: var(--z-index-popover, 1041);
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.interaction-btn--glow {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.5rem 1rem 0.5625rem; /** same as for md-button component */
  width: 100%;
  height: 100%;
  border-radius: 36px; /** same as for md-button component */
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  transition: box-shadow 250ms linear;
  margin-left: 0;
}

.interaction-btn.glowing .interaction-btn--glow {
  animation: glowing 1000ms infinite;
  box-shadow:
    0 0 0 2px var(--green-30-color),
    0 0 0 4px var(--green-10-color);
}

.interaction-btn.accept-btn-call.glowing .interaction-btn--glow {
  animation: glowingCall 1000ms infinite;
  box-shadow:
    0 0 0 2px var(--green-30-color),
    0 0 0 4px var(--green-10-color);
}

/* Animation */
@keyframes slideInPop {
  from {
    transform: translatex(100%);
  }
  to {
    transform: translatex(0);
  }
}

@keyframes slideOutPop {
  from {
    transform: translatex(0);
  }
  to {
    transform: translatex(100%);
  }
}
@media (max-width: 677px) {
  .popover-details-row {
    padding-bottom: calc(var(--space-token-cardinal) - var(--space-token-even));
  }
}

@keyframes glowing {
  0% {
    box-shadow:
      0 0 0 0px var(--md-primary-success-bg-color),
      0 0 0 2px var(--blue-40-color);
  }
  25% {
    box-shadow:
      0 0 0 2px var(--md-primary-success-bg-color),
      0 0 0 2px var(--blue-40-color);
  }
  100% {
    box-shadow:
      0 0 0 0px var(--md-primary-success-bg-color),
      0 0 0 2px var(--blue-40-color);
  }
}

@keyframes glowingCall {
  0% {
    box-shadow:
      0 0 0 0px var(--md-primary-success-bg-color),
      0 0 0 2px var(--blue-40-color);
  }
  25% {
    box-shadow:
      0 0 0 2px var(--md-primary-success-bg-color),
      0 0 0 2px var(--blue-40-color);
  }
  100% {
    box-shadow:
      0 0 0 0px var(--md-primary-success-bg-color),
      0 0 0 2px var(--blue-40-color);
  }
}
/* CSS for popover in task list.*/
.popover-task-list {
  margin: var(--popover-tasklist-margin);
  border-radius: var(--popover-tasklist-border-radius);
  width: auto;
}
.collapsed {
  background: none;
  box-shadow: none;
  border-style: none;
}

.popover-pagination {
  width: var(--popover-width);
  margin-top: calc(var(--popover-margin) / 2);
  background-color: var(--md-primary-bg-color);
  border: 1px solid var(--gray-30-color);
  border-radius: var(--border-radius-medium);
  font-size: var(--font-size-small);
  font-family: var(--font-family);
  color: var(--md-secondary-text-color);
  height: var(--popover-header-height);
  display: flex;
  justify-content: space-around;
}

.pagination-detail {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--font-size-medium);
  justify-content: center;
  padding: calc(var(--popover-padding) / 2);
  color: var(--md-secondary-text-color);
}

.pagination-info {
  display: flex;
  padding-left: calc(var(--popover-padding) / 2);
}

.pagination-accept-all {
  display: flex;
  align-items: center;
  padding-right: var(--popover-padding);
}

.ellipses-popover {
  display: flex;
}

.popover-dot {
  height: var(--popover-dot-width);
  width: var(--popover-dot-width);
  background-color: var(--md-quaternary-bg-color);
  border-radius: 50%;
  display: inline-block;
  margin-right: var(--popover-dot-width);
}

.popover-dot-selected {
  background-color: var(--md-primary-text-color);
}

.pagination-button {
  display: flex;
}

.text-ellipsis .popover-button {
  max-width: var(--popover-button-max-width);
}

.acceptAll {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.web-call-answer-button {
  margin: 8px 0px 8px 0px;
}

.hidden-aria-live-region {
  position: absolute;
  /* 
  Move the element far off the visible area of the page.
  This hides the element visually but not from screen readers.
  */
  left: -9999px;
}

@media (forced-colors: active) {
  /* //incoming calls and emails  */
  .header md-task-item::part(task-item-container) {
    forced-color-adjust: auto;
    box-shadow: none;
    background-color: none !important;
    outline: 1px solid CanvasText !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/InteractionPopoverManager/components/index.css"],"names":[],"mappings":"AAGA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,gCAAgC;EAChC,kCAAkC;EAClC,4CAA4C;EAC5C,2CAA2C;EAC3C,uGAAuG;EACvG,yGAAyG;EACzG,wBAAwB;EACxB,mCAAmC;EACnC,oDAAoD;EACpD,6CAA6C;EAC7C,0CAA0C;EAC1C,+CAA+C;EAC/C,kCAAkC;EAClC,yCAAyC;EACzC,uCAAuC;EACvC,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,4CAA4C;EAC5C,sCAAsC;EACtC,0CAA0C;EAC1C,iCAAiC;EACjC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,4CAA4C;EAC5C,sCAAsC;EACtC,0CAA0C;EAC1C,iCAAiC;EACjC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,oFAAoF;AACtF;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,sCAAsC;EACtC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,6CAA6C;EAC7C,8BAA8B;EAC9B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,mFAAmF;AACrF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,8DAA8D;EAC9D,6DAA6D;EAC7D,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;EACpD,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,sCAAsC,EAAE,yCAAyC;EACjF,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB,EAAE,yCAAyC;EAC3D,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,OAAO;EACP,WAAW;EACX,mCAAmC;EACnC,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,iCAAiC;EACjC,mCAAmC;EACnC,oDAAoD;AACtD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,8BAA8B,EAAE,qCAAqC;EACrE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,qCAAqC;EAC1D,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC;;mCAEiC;AACnC;;AAEA;EACE,sCAAsC;EACtC;;mCAEiC;AACnC;;AAEA,cAAc;AACd;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2EAA2E;EAC7E;AACF;;AAEA;EACE;IACE;;oCAEgC;EAClC;EACA;IACE;;oCAEgC;EAClC;EACA;IACE;;oCAEgC;EAClC;AACF;;AAEA;EACE;IACE;;oCAEgC;EAClC;EACA;IACE;;oCAEgC;EAClC;EACA;IACE;;oCAEgC;EAClC;AACF;AACA,iCAAiC;AACjC;EACE,sCAAsC;EACtC,oDAAoD;EACpD,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,4CAA4C;EAC5C,sCAAsC;EACtC,0CAA0C;EAC1C,iCAAiC;EACjC,+BAA+B;EAC/B,qCAAqC;EACrC,oCAAoC;EACpC,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;EAClC,uBAAuB;EACvB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,+CAA+C;EAC/C,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB;;;GAGC;EACD,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC;IACE,yBAAyB;IACzB,gBAAgB;IAChB,iCAAiC;IACjC,wCAAwC;EAC1C;AACF","sourcesContent":["@import \"../../../css/variables.css\";\n@import \"~@agentx/agentx-services/dist/styles/z-index.css\";\n\n* {\n  box-sizing: border-box;\n  --popover-width: 328px;\n  --popover-header-height: 60px;\n  --popover-header-error-height: 100px;\n  --popover-margin: 16px;\n  --popover-padding: 12px;\n  --popover-error-width: 265px;\n  --icon-badge-widht: 40px;\n  --icon-badge-height: 12px;\n  --error-detail-input-width: 225px;\n  --popover-contact-title: 175px;\n  --popover-contact-width: 372.5px;\n  --popover-contact-max-height: 75px;\n  --popover-icon-badge-margin: 0 12px 0 15.5px;\n  --popover-error-margin: 0px 40px 0px 67.5px;\n  --animation-slideIn-pop: slideInPop var(--default-animation-duration) var(--ease-in-out-quint) forwards;\n  --animation-slideOut-pop: slideOutPop var(--default-animation-duration) var(--ease-in-out-quint) forwards;\n  --queue-max-width: 100px;\n  --popover-tasklist-icon-margin: 6px;\n  --popover-tasklist-contact-title-header-width: 250px;\n  --popover-tasklist-contact-title-width: 160px;\n  --popover-tasklist-title-line-height: 14px;\n  --popover-tasklist-title-info-line-height: 22px;\n  --popover-tasklist-margin: 4px 6px;\n  --popover-tasklist-border-radius: 0.75rem;\n  --popover-tasklist-contact-header: 48px;\n  --popover-tasklist-contact-padding: 4px;\n  --green-60: #00853c;\n  --green-50: #00ab50;\n  --green-70: #03612c;\n  --popover-dot-width: 4px;\n  --pagination-accept-max-width: 130px;\n  --popover-button-max-width: 85px;\n}\n\n.popover-light {\n  width: var(--popover-width);\n  margin-top: var(--popover-margin);\n  background-color: var(--md-primary-bg-color);\n  border: 1px solid var(--gray-30-color);\n  border-radius: var(--border-radius-medium);\n  font-size: var(--font-size-small);\n  font-family: var(--font-family);\n  color: var(--md-secondary-text-color);\n}\n\n.popover-dark {\n  width: var(--popover-width);\n  margin-top: var(--popover-margin);\n  background-color: var(--md-primary-bg-color);\n  border: 1px solid var(--gray-80-color);\n  border-radius: var(--border-radius-medium);\n  font-size: var(--font-size-small);\n  font-family: var(--font-family);\n  color: var(--md-secondary-text-color);\n}\n\n.header {\n  min-height: var(--popover-header-height);\n  display: flex;\n  align-items: center;\n  position: relative;\n  flex-direction: column;\n}\n\n.header md-task-item::part(task-item-container) {\n  box-shadow: none;\n  background-color: transparent;\n  max-width: var(--popover-width);\n  width: 100%;\n}\n\n.header-error {\n  min-height: var(--popover-header-error-height);\n  padding: var(--popover-padding) var(--space-token-cardinal) var(--popover-padding) 0;\n}\n\n.channel-icon {\n  position: relative;\n  top: 0.1rem;\n}\n\n.queue-name {\n  max-width: var(--queue-max-width);\n  display: inline-block;\n  margin-right: 0.5rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: bottom;\n}\n\n.loader {\n  font-size: 3px;\n  margin-top: 3px;\n  margin-left: 2px;\n}\n\n.connecting-loader {\n  max-width: var(--queue-max-width);\n  display: flex;\n  margin-right: 0.5rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: bottom;\n}\n\n.popover-error-icon {\n  vertical-align: middle;\n  padding-right: var(--space-token-cardinal);\n}\n\n.trackingid-input {\n  border: none;\n  font-size: var(--font-size-xsmall);\n  font-weight: var(--font-weight-normal);\n  width: var(--error-detail-input-width);\n  color: var(--md-secondary-text-color);\n  background-color: var(--white-color);\n}\n\n.trackingid-input-call-green {\n  background: var(--green-05-color);\n}\n\n.trackingId-label {\n  font-size: var(--font-size-xsmall);\n  font-weight: var(--font-weight-normal);\n  color: var(--md-secondary-text-color);\n  padding-right: var(--space-token-cardinal);\n}\n\n.popover-contact-title {\n  width: var(--popover-contact-title);\n}\n\n.popover-trackingId,\n.popover-contact-title-header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.popover-contact-title-header {\n  width: var(--popover-error-width);\n}\n\n.popover-toggle-button {\n  position: absolute;\n  bottom: calc(var(--icon-badge-height) / 2 * -2);\n  left: calc(50% - var(--icon-badge-widht) / 2);\n  width: var(--icon-badge-widht);\n  height: var(--icon-badge-height);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 1px;\n}\n\n.popover-toggle-button md-button {\n  width: 100%;\n  opacity: 0;\n  transition: opacity 150ms linear;\n}\n\n.popover-toggle-button md-button:focus {\n  opacity: 1;\n  background: var(--md-primary-seperator-color, --md-primary-seperator-color-default);\n}\n\n.popover-toggle-button md-button:focus-within {\n  opacity: 1;\n}\n\n.popover-toggle-button md-button::part(button) {\n  width: 100%;\n  height: 100%;\n  background: var(--md-input-disabled);\n  border-bottom-right-radius: calc(var(--icon-badge-height) / 2);\n  border-bottom-left-radius: calc(var(--icon-badge-height) / 2);\n  padding: 2px;\n  box-shadow: 0px 2px 4px rgb(0 0 0 / 25%);\n}\n\n.popover:hover .popover-toggle-button md-button,\n.popover.popover-expanded .popover-toggle-button md-button {\n  opacity: 1;\n}\n\n.popover-contact-header {\n  display: flex;\n}\n\n.copy-trackingId-btn {\n  background: none;\n  border: none;\n  vertical-align: middle;\n}\n\n.error-details .trackingId-summary {\n  cursor: pointer;\n  text-decoration: underline;\n  color: var(--link-color);\n  width: fit-content;\n}\n\n.error-details .trackingId-summary::-webkit-details-marker {\n  display: none;\n}\n\n.header button {\n  margin-left: 4px;\n}\n\n.icon-badge {\n  width: var(--icon-badge-widht);\n  height: var(--icon-badge-widht);\n  background-color: var(--gray-10-color);\n  margin: var(--popover-icon-badge-margin);\n}\n\n.icon-badge-call {\n  width: var(--icon-badge-widht);\n  height: var(--icon-badge-widht);\n  background-color: var(--white-color);\n  margin: var(--popover-icon-badge-margin);\n}\n\n.text-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n}\n\n.cancelling-text-container {\n  display: inline-flex;\n  width: 54px;\n}\n.cancelling-text-container md-spinner {\n  margin-right: 4px;\n}\n\n.cancelling-text-container .cancelling-text {\n  text-overflow: ellipsis;\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.popover-contact {\n  width: var(--popover-contact-width);\n}\n\n.contact-title {\n  font-size: var(--font-size-large);\n  color: var(--gray-100-color);\n}\n\n.popover-timer {\n  color: var(--taskitem-timer-text-color);\n}\n\n.header .interaction-btn {\n  padding: 0 !important;\n  height: var(--defult-button-size) !important;\n}\n\n.accept-btn-call::part(button) {\n  background-color: var(--md-primary-success-bg-color);\n  color: var(--md-primary-success-text-color);\n  cursor: default;\n}\n\n.accept-btn-call {\n  cursor: default;\n  height: auto;\n  display: inline-block;\n}\n\n.details-toggle-btn {\n  background: none;\n}\n\n.popover-details-light {\n  padding: var(--popover-padding);\n  border-top: 1px solid var(--gray-30-color);\n  display: none;\n}\n\n.popover-details-dark {\n  padding: var(--popover-padding);\n  border-top: 1px solid var(--gray-80-color);\n  display: none;\n}\n\n.popover-details.popover-details-show {\n  display: block;\n}\n\n.popover-details-row {\n  margin: 0;\n  display: flex;\n  width: 100%;\n  padding-bottom: 4px;\n  font-size: var(--font-size-small);\n}\n\n.popover-details-row dt md-tooltip,\n.popover-details-row dd md-tooltip {\n  width: 100%;\n}\n\n.popover-details-row dd {\n  height: 20px;\n  margin-inline-start: 0px;\n}\n\n.popover-details-row dd:focus-visible {\n  outline-color: var(--md-button-primary-hover-bg-color, #005e7d);\n}\n\n.popover-details-row dt {\n  font-weight: var(--font-weight-normal); /* Overriding momemtum css on dt element*/\n  width: 40%;\n}\n\n.popover-details-row dd {\n  width: 60%;\n}\n\n.popover-details-row dd .popover-details-row-value {\n  margin-bottom: 0; /* Overriding momemtum css on dd element*/\n  margin-left: 0;\n}\n\n.popover-details-row:last-child {\n  padding-bottom: 0;\n}\n\ndl.popover-details-row > dt ::after {\n  content: \":\";\n}\n\n.popover-details-row-label {\n  /* flex: 0.7; */\n  width: 100%;\n}\n\n.popover-details-row-value {\n  flex: 1;\n  width: 100%;\n  color: var(--md-primary-text-color);\n  margin-left: calc(var(--space-token-cardinal) * 2);\n  padding-left: 2px;\n}\n\n.popover-title-info {\n  display: flex;\n}\n\n.popover-title-info > div:first-child::after {\n  content: \"-\";\n  padding-left: var(--space-token-cardinal);\n  padding-right: var(--space-token-cardinal);\n}\n\n.popover-error {\n  width: var(--popover-error-width);\n  color: var(--red-70-color);\n  font-size: var(--font-size-small);\n  margin: var(--popover-error-margin);\n  margin-bottom: calc(var(--space-token-cardinal) * 2);\n}\n\n.popover-slide-in {\n  animation: var(--animation-slideIn-pop);\n}\n\n.popover-slide-out {\n  animation: var(--animation-slideOut-pop);\n}\n\n.popover_container {\n  z-index: var(--z-index-popover, 1041);\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n}\n\n.interaction-btn--glow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: 0.5rem 1rem 0.5625rem; /** same as for md-button component */\n  width: 100%;\n  height: 100%;\n  border-radius: 36px; /** same as for md-button component */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: none;\n  transition: box-shadow 250ms linear;\n  margin-left: 0;\n}\n\n.interaction-btn.glowing .interaction-btn--glow {\n  animation: glowing 1000ms infinite;\n  box-shadow:\n    0 0 0 2px var(--green-30-color),\n    0 0 0 4px var(--green-10-color);\n}\n\n.interaction-btn.accept-btn-call.glowing .interaction-btn--glow {\n  animation: glowingCall 1000ms infinite;\n  box-shadow:\n    0 0 0 2px var(--green-30-color),\n    0 0 0 4px var(--green-10-color);\n}\n\n/* Animation */\n@keyframes slideInPop {\n  from {\n    transform: translatex(100%);\n  }\n  to {\n    transform: translatex(0);\n  }\n}\n\n@keyframes slideOutPop {\n  from {\n    transform: translatex(0);\n  }\n  to {\n    transform: translatex(100%);\n  }\n}\n@media (max-width: 677px) {\n  .popover-details-row {\n    padding-bottom: calc(var(--space-token-cardinal) - var(--space-token-even));\n  }\n}\n\n@keyframes glowing {\n  0% {\n    box-shadow:\n      0 0 0 0px var(--md-primary-success-bg-color),\n      0 0 0 2px var(--blue-40-color);\n  }\n  25% {\n    box-shadow:\n      0 0 0 2px var(--md-primary-success-bg-color),\n      0 0 0 2px var(--blue-40-color);\n  }\n  100% {\n    box-shadow:\n      0 0 0 0px var(--md-primary-success-bg-color),\n      0 0 0 2px var(--blue-40-color);\n  }\n}\n\n@keyframes glowingCall {\n  0% {\n    box-shadow:\n      0 0 0 0px var(--md-primary-success-bg-color),\n      0 0 0 2px var(--blue-40-color);\n  }\n  25% {\n    box-shadow:\n      0 0 0 2px var(--md-primary-success-bg-color),\n      0 0 0 2px var(--blue-40-color);\n  }\n  100% {\n    box-shadow:\n      0 0 0 0px var(--md-primary-success-bg-color),\n      0 0 0 2px var(--blue-40-color);\n  }\n}\n/* CSS for popover in task list.*/\n.popover-task-list {\n  margin: var(--popover-tasklist-margin);\n  border-radius: var(--popover-tasklist-border-radius);\n  width: auto;\n}\n.collapsed {\n  background: none;\n  box-shadow: none;\n  border-style: none;\n}\n\n.popover-pagination {\n  width: var(--popover-width);\n  margin-top: calc(var(--popover-margin) / 2);\n  background-color: var(--md-primary-bg-color);\n  border: 1px solid var(--gray-30-color);\n  border-radius: var(--border-radius-medium);\n  font-size: var(--font-size-small);\n  font-family: var(--font-family);\n  color: var(--md-secondary-text-color);\n  height: var(--popover-header-height);\n  display: flex;\n  justify-content: space-around;\n}\n\n.pagination-detail {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: var(--font-size-medium);\n  justify-content: center;\n  padding: calc(var(--popover-padding) / 2);\n  color: var(--md-secondary-text-color);\n}\n\n.pagination-info {\n  display: flex;\n  padding-left: calc(var(--popover-padding) / 2);\n}\n\n.pagination-accept-all {\n  display: flex;\n  align-items: center;\n  padding-right: var(--popover-padding);\n}\n\n.ellipses-popover {\n  display: flex;\n}\n\n.popover-dot {\n  height: var(--popover-dot-width);\n  width: var(--popover-dot-width);\n  background-color: var(--md-quaternary-bg-color);\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: var(--popover-dot-width);\n}\n\n.popover-dot-selected {\n  background-color: var(--md-primary-text-color);\n}\n\n.pagination-button {\n  display: flex;\n}\n\n.text-ellipsis .popover-button {\n  max-width: var(--popover-button-max-width);\n}\n\n.acceptAll {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n\n.web-call-answer-button {\n  margin: 8px 0px 8px 0px;\n}\n\n.hidden-aria-live-region {\n  position: absolute;\n  /* \n  Move the element far off the visible area of the page.\n  This hides the element visually but not from screen readers.\n  */\n  left: -9999px;\n}\n\n@media (forced-colors: active) {\n  /* //incoming calls and emails  */\n  .header md-task-item::part(task-item-container) {\n    forced-color-adjust: auto;\n    box-shadow: none;\n    background-color: none !important;\n    outline: 1px solid CanvasText !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Keypad/style.css":
/*!********************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Keypad/style.css ***!
  \********************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../node_modules/css-loader/dist/cjs.js!../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.keypad-container {
  padding: 25px 16px 25px 17px;
}

.validation-msg {
  width: 100%;
  padding-top: calc(var(--space-token-even) * 4);
  font-size: calc(var(--space-token-even) * 6);
  color: rgb(247, 100, 74);
  display: flex;
  align-items: center;
}

.validation-msg p {
  padding-left: calc(var(--space-token-even) * 4);
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/Keypad/style.css"],"names":[],"mappings":"AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,4CAA4C;EAC5C,wBAAwB;EACxB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,SAAS;AACX","sourcesContent":["@import \"../../css/variables.css\";\n\n.keypad-container {\n  padding: 25px 16px 25px 17px;\n}\n\n.validation-msg {\n  width: 100%;\n  padding-top: calc(var(--space-token-even) * 4);\n  font-size: calc(var(--space-token-even) * 6);\n  color: rgb(247, 100, 74);\n  display: flex;\n  align-items: center;\n}\n\n.validation-msg p {\n  padding-left: calc(var(--space-token-even) * 4);\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Outdial/styles.css":
/*!**********************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Outdial/styles.css ***!
  \**********************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../node_modules/css-loader/dist/cjs.js!../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outdial-main * {
  --dialer-width: 245px;
  --search-height: 55px;
  --tab-height: 37px;
  --adr-name-width: 130px;
  --address-list-padding: 1px;
  --line-height: 1.25rem;
  --content-height-with-ani: 217px;
  --max-popover-height-with-ani: 446px;
  --menu-list-min-height: 144px;
  --dialpad-dropdown-max-height: 314px;
  --dialpad-dropdown-min-height: 119px;
  --outdialani-selector-height: calc(346px);
  --column-gap: 8px;
  --outdial-status-height: 285px;
  --padding-outdialani-11: 11px;
}

.enterprise-search * {
  --adr-name-width: 300px;
}

.outdial-main {
  box-sizing: border-box;
  overflow: visible;
  overflow-x: unset;
  width: fit-content;
  width: 100%;
}
.height-with-ani {
  height: calc(var(--tab-height) + var(--search-height) + var(--content-height-with-ani) + 60px + 52px);
}

.outdial-opener {
  pointer-events: auto !important; /* overriding pointer-events, because in case of disabled button, tooltip is not showing  */
}

.address-book {
  display: flex;
  flex-direction: column;
  position: sticky;
}

.address-book-height-with-ani {
  height: calc(var(--max-popover-height-with-ani) - 50px);
}

.address-book,
.dialpad-main,
.enterprise-search {
  padding: calc(var(--space-token-even) * 4) calc(var(--space-token-even) * 4) 0;
}

.tooltip-text {
  font-size: var(--font-size-small);
}
.address-search .search-input {
  margin-bottom: calc(var(--space-token-even) * 5);
}
.address-list {
  width: 100%;
}

.adr-list-ht-outdial-ani {
  height: calc(var(--content-height-with-ani) + var(--tab-height));
}

.adr-list-ht-od-dis-outdial-ani {
  height: var(--content-height-with-ani);
}

.address-list-dynamic > div {
  padding: var(--address-list-padding);
}

.address-list-item {
  display: grid;
  grid-template-columns: 0fr 1fr 0fr;
  align-items: center;
  width: 100%;
  cursor: pointer;
}
.address-list-item-detail {
  padding: 1px calc(var(--space-token-even) * 5);
}

.address-list-item-detail .address-name,
.address-dn {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: var(--font-size-medium);
  max-width: var(--adr-name-width);
}

.address-list-item-detail .address-dn {
  font-size: var(--font-size-small);
  color: var(--md-secondary-text-color);
}

.address-list > div.no-record {
  padding: calc(var(--space-token-cardinal) * 2);
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}

.no-record {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(var(--space-token-cardinal) * 2);
  gap: 4px;
  text-align: center;
}

.no-record-found {
  position: relative;
  top: 21px;
}

.no-contacts {
  width: 100%;
  padding: calc(var(--space-token-cardinal) * 2);
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}

.no-contacts img {
  display: block;
  margin: auto;
}

.no-contacts-found {
  position: relative;
  top: 21px;
}

.no-contacts-found-prev {
  font-size: var(--font-size-small);
  text-align: center;
}

.outdial-main .md-input-container .md-input {
  font-size: var(--font-size-small);
}

.hidden-btn {
  visibility: hidden;
}
md-list-item:hover .hidden-btn,
md-list-item:focus .hidden-btn,
md-list-item[aria-selected="true"] .hidden-bt {
  visibility: visible;
}

/* overriding momentum disabled back ground color of input*/
.md-input-container .md-input:not(.md-select__filter--input).md-disabled,
.md-input-container .md-input:not(.md-select__filter--input):disabled {
  border-color: var(--grey-color);
  color: var(--grey-color);
  background-color: var(--white-color);
}

.dialpad-search .md-input-container {
  margin-bottom: 0px;
}

.dialpad-main {
  width: 100%;
}

.dialpad-search {
  margin-bottom: calc(var(--space-token-even) * 5);
}

.dialpad-dropdown::part(combobox-options) {
  max-height: var(--dialpad-dropdown-max-height);
  min-height: var(--dialpad-dropdown-min-height);
}

.dialpad-height-with-ani {
  height: var(--content-height-with-ani);
}
.dialpad-height-without-ani {
  height: var(--content-height-with-ani);
}
.dialpad-button {
  padding: 6px calc(var(--space-token-even) * 6);
}

.dialpad-button > button > span {
  font-size: var(--font-size-small);
}

.md-combo-box__options .md-list-item {
  font-size: var(--font-size-small);
  height: var(--tab-height);
}
.md-combo-box input {
  border-radius: 1rem;
}
/* overriding momentum tab css to align with UX*/
.outdial-main .md-tab__list {
  display: flex;
  width: 100%;
}

.outdial-main .md-type--tabs {
  flex: 1;
  padding-left: 0;
  margin-top: 1px;
  margin-left: 2px;
}

.outdial-main .md-type--tabs a {
  width: 100%;
  display: flex;
  text-align: center;
  padding-bottom: 0;
  justify-content: center;
  height: var(--tab-height);
  box-sizing: border-box;
  padding-top: calc(var(--space-token-even) * 5);
  padding-right: 0px;
}

.outdial-main .md-type--tabs a:focus {
  box-shadow: var(--focused-shadow);
  background-color: var(--white-color);
}

.validation-msg {
  width: 100%;
  padding-top: calc(var(--space-token-even) * 4);
  font-size: calc(var(--space-token-even) * 6);
  color: var(--md-alert-error-text-color);
  display: flex;
  align-items: center;
}

.validation-msg p {
  padding-left: calc(var(--space-token-even) * 4);
  margin: 0;
}

.md-input-container.red-shadow .md-active {
  box-shadow: 0 0 4px 2px rgba(209, 0, 0, 0.75);
}
.dialer {
  display: flex;
  justify-content: center;
}

md-tab-panel.address-panel {
  overflow: visible;
  overflow-x: unset;
}

.outdial-ani-tooltip {
  width: 100%;
  padding-top: 2px;
  display: block;
  padding-bottom: 6px;
  margin: 0 auto;
}

.outdial-ani-label {
  margin: 0px;
  padding: 2px 0px 0px 8px;
}

.outdial-ani-container {
  padding: 2px 8px 0px 8px;
}

.button-internal-element {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.arrow-icon {
  padding-left: calc(var(--space-token-even) * 5);
  text-align: center;
}

.outdial-button {
  display: flex;
  justify-content: center;
  padding: 8px 0px 8px;
}

.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 142px;
  text-align: left;
}

.outdial-menu::part(overlay-content) {
  overflow: visible;
}

.status-menu-item {
  border: 0;
  border-radius: 0;
}

.agent-status-option-text.ellipsis-text {
  width: 165px;
}

/* css for outdial ani combobox --> */

.outdial-combobox::part(group) {
  border-radius: 18px;
}

.outdial-combobox::part(combobox) {
  width: 100%;
}

.outdial-main md-tabs::part(tabs-content) {
  overflow: visible;
}
.menu-list {
  width: 100%;
  height: 100%;
  min-height: var(--menu-list-min-height);
  place-content: start;
  padding: var(--wc-menu-padding);
}
#outdial-overlay::part(overlay) {
  margin-bottom: -1.2rem;
  margin-top: -0.9rem;
}

.outdial-ani-btn::part(button) {
  box-shadow: none;
  width: 100%;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.outdial-ani-search {
  padding: var(--padding-outdialani-11) var(--padding-14);
}

.search-outdialani-input::part(md-input-container) {
  margin-bottom: 0;
}

.outdial-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
}

.outdial-ani-menu::part(overlay-content) {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: var(--outdialani-selector-height);
  max-height: var(--outdialani-selector-height);
}
.fixed-size-list ul {
  margin: 0;
}
.outdial-list__loading {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  margin: auto;
  min-height: var(--outdial-status-height);
}

.infinite-menu-list-item {
  align-content: center;
  list-style-type: none;
  padding: 0 var(--padding-14);
}

.infinite-menu-list-item:hover {
  background-color: var(--list-hover-background, #c9f4ff);
  cursor: pointer;
}

.selected-list-item-focused {
  outline: none;
  cursor: pointer;
  box-shadow: var(--focused-list-shadow);
}

.selected-list-item {
  background-color: var(--list-active-background, #c9f4ff);
  box-shadow: var(--focused-list-shadow);
}

div.no-record {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(var(--space-token-cardinal) * 2);
  position: relative;
  text-align: center;
  min-height: var(--outdial-status-height);
}

.search-error {
  display: flex;
  flex-direction: row;
  column-gap: var(--column-gap);
  align-items: center;
  font-size: var(--font-size-small);
}
.search-block-error {
  display: flex;
  align-items: center;
  padding: var(--padding-16);
  min-height: var(--outdial-status-height);
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/Outdial/styles.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,gCAAgC;EAChC,oCAAoC;EACpC,6BAA6B;EAC7B,oCAAoC;EACpC,oCAAoC;EACpC,yCAAyC;EACzC,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qGAAqG;AACvG;;AAEA;EACE,+BAA+B,EAAE,2FAA2F;AAC9H;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;;;EAGE,8EAA8E;AAChF;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,gDAAgD;AAClD;AACA;EACE,WAAW;AACb;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;AACA;;;EAGE,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;;EAEE,+BAA+B;EAC/B,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA,gDAAgD;AAChD;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,OAAO;EACP,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,4CAA4C;EAC5C,uCAAuC;EACvC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,SAAS;AACX;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,qCAAqC;;AAErC;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yCAAyC;EACzC,6CAA6C;AAC/C;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,uDAAuD;EACvD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,wDAAwD;EACxD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,wCAAwC;AAC1C","sourcesContent":["@import \"../../css/variables.css\";\n\n.outdial-main * {\n  --dialer-width: 245px;\n  --search-height: 55px;\n  --tab-height: 37px;\n  --adr-name-width: 130px;\n  --address-list-padding: 1px;\n  --line-height: 1.25rem;\n  --content-height-with-ani: 217px;\n  --max-popover-height-with-ani: 446px;\n  --menu-list-min-height: 144px;\n  --dialpad-dropdown-max-height: 314px;\n  --dialpad-dropdown-min-height: 119px;\n  --outdialani-selector-height: calc(346px);\n  --column-gap: 8px;\n  --outdial-status-height: 285px;\n  --padding-outdialani-11: 11px;\n}\n\n.enterprise-search * {\n  --adr-name-width: 300px;\n}\n\n.outdial-main {\n  box-sizing: border-box;\n  overflow: visible;\n  overflow-x: unset;\n  width: fit-content;\n  width: 100%;\n}\n.height-with-ani {\n  height: calc(var(--tab-height) + var(--search-height) + var(--content-height-with-ani) + 60px + 52px);\n}\n\n.outdial-opener {\n  pointer-events: auto !important; /* overriding pointer-events, because in case of disabled button, tooltip is not showing  */\n}\n\n.address-book {\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n}\n\n.address-book-height-with-ani {\n  height: calc(var(--max-popover-height-with-ani) - 50px);\n}\n\n.address-book,\n.dialpad-main,\n.enterprise-search {\n  padding: calc(var(--space-token-even) * 4) calc(var(--space-token-even) * 4) 0;\n}\n\n.tooltip-text {\n  font-size: var(--font-size-small);\n}\n.address-search .search-input {\n  margin-bottom: calc(var(--space-token-even) * 5);\n}\n.address-list {\n  width: 100%;\n}\n\n.adr-list-ht-outdial-ani {\n  height: calc(var(--content-height-with-ani) + var(--tab-height));\n}\n\n.adr-list-ht-od-dis-outdial-ani {\n  height: var(--content-height-with-ani);\n}\n\n.address-list-dynamic > div {\n  padding: var(--address-list-padding);\n}\n\n.address-list-item {\n  display: grid;\n  grid-template-columns: 0fr 1fr 0fr;\n  align-items: center;\n  width: 100%;\n  cursor: pointer;\n}\n.address-list-item-detail {\n  padding: 1px calc(var(--space-token-even) * 5);\n}\n\n.address-list-item-detail .address-name,\n.address-dn {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  font-size: var(--font-size-medium);\n  max-width: var(--adr-name-width);\n}\n\n.address-list-item-detail .address-dn {\n  font-size: var(--font-size-small);\n  color: var(--md-secondary-text-color);\n}\n\n.address-list > div.no-record {\n  padding: calc(var(--space-token-cardinal) * 2);\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  text-align: center;\n}\n\n.no-record {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: calc(var(--space-token-cardinal) * 2);\n  gap: 4px;\n  text-align: center;\n}\n\n.no-record-found {\n  position: relative;\n  top: 21px;\n}\n\n.no-contacts {\n  width: 100%;\n  padding: calc(var(--space-token-cardinal) * 2);\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  text-align: center;\n}\n\n.no-contacts img {\n  display: block;\n  margin: auto;\n}\n\n.no-contacts-found {\n  position: relative;\n  top: 21px;\n}\n\n.no-contacts-found-prev {\n  font-size: var(--font-size-small);\n  text-align: center;\n}\n\n.outdial-main .md-input-container .md-input {\n  font-size: var(--font-size-small);\n}\n\n.hidden-btn {\n  visibility: hidden;\n}\nmd-list-item:hover .hidden-btn,\nmd-list-item:focus .hidden-btn,\nmd-list-item[aria-selected=\"true\"] .hidden-bt {\n  visibility: visible;\n}\n\n/* overriding momentum disabled back ground color of input*/\n.md-input-container .md-input:not(.md-select__filter--input).md-disabled,\n.md-input-container .md-input:not(.md-select__filter--input):disabled {\n  border-color: var(--grey-color);\n  color: var(--grey-color);\n  background-color: var(--white-color);\n}\n\n.dialpad-search .md-input-container {\n  margin-bottom: 0px;\n}\n\n.dialpad-main {\n  width: 100%;\n}\n\n.dialpad-search {\n  margin-bottom: calc(var(--space-token-even) * 5);\n}\n\n.dialpad-dropdown::part(combobox-options) {\n  max-height: var(--dialpad-dropdown-max-height);\n  min-height: var(--dialpad-dropdown-min-height);\n}\n\n.dialpad-height-with-ani {\n  height: var(--content-height-with-ani);\n}\n.dialpad-height-without-ani {\n  height: var(--content-height-with-ani);\n}\n.dialpad-button {\n  padding: 6px calc(var(--space-token-even) * 6);\n}\n\n.dialpad-button > button > span {\n  font-size: var(--font-size-small);\n}\n\n.md-combo-box__options .md-list-item {\n  font-size: var(--font-size-small);\n  height: var(--tab-height);\n}\n.md-combo-box input {\n  border-radius: 1rem;\n}\n/* overriding momentum tab css to align with UX*/\n.outdial-main .md-tab__list {\n  display: flex;\n  width: 100%;\n}\n\n.outdial-main .md-type--tabs {\n  flex: 1;\n  padding-left: 0;\n  margin-top: 1px;\n  margin-left: 2px;\n}\n\n.outdial-main .md-type--tabs a {\n  width: 100%;\n  display: flex;\n  text-align: center;\n  padding-bottom: 0;\n  justify-content: center;\n  height: var(--tab-height);\n  box-sizing: border-box;\n  padding-top: calc(var(--space-token-even) * 5);\n  padding-right: 0px;\n}\n\n.outdial-main .md-type--tabs a:focus {\n  box-shadow: var(--focused-shadow);\n  background-color: var(--white-color);\n}\n\n.validation-msg {\n  width: 100%;\n  padding-top: calc(var(--space-token-even) * 4);\n  font-size: calc(var(--space-token-even) * 6);\n  color: var(--md-alert-error-text-color);\n  display: flex;\n  align-items: center;\n}\n\n.validation-msg p {\n  padding-left: calc(var(--space-token-even) * 4);\n  margin: 0;\n}\n\n.md-input-container.red-shadow .md-active {\n  box-shadow: 0 0 4px 2px rgba(209, 0, 0, 0.75);\n}\n.dialer {\n  display: flex;\n  justify-content: center;\n}\n\nmd-tab-panel.address-panel {\n  overflow: visible;\n  overflow-x: unset;\n}\n\n.outdial-ani-tooltip {\n  width: 100%;\n  padding-top: 2px;\n  display: block;\n  padding-bottom: 6px;\n  margin: 0 auto;\n}\n\n.outdial-ani-label {\n  margin: 0px;\n  padding: 2px 0px 0px 8px;\n}\n\n.outdial-ani-container {\n  padding: 2px 8px 0px 8px;\n}\n\n.button-internal-element {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.arrow-icon {\n  padding-left: calc(var(--space-token-even) * 5);\n  text-align: center;\n}\n\n.outdial-button {\n  display: flex;\n  justify-content: center;\n  padding: 8px 0px 8px;\n}\n\n.ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 142px;\n  text-align: left;\n}\n\n.outdial-menu::part(overlay-content) {\n  overflow: visible;\n}\n\n.status-menu-item {\n  border: 0;\n  border-radius: 0;\n}\n\n.agent-status-option-text.ellipsis-text {\n  width: 165px;\n}\n\n/* css for outdial ani combobox --> */\n\n.outdial-combobox::part(group) {\n  border-radius: 18px;\n}\n\n.outdial-combobox::part(combobox) {\n  width: 100%;\n}\n\n.outdial-main md-tabs::part(tabs-content) {\n  overflow: visible;\n}\n.menu-list {\n  width: 100%;\n  height: 100%;\n  min-height: var(--menu-list-min-height);\n  place-content: start;\n  padding: var(--wc-menu-padding);\n}\n#outdial-overlay::part(overlay) {\n  margin-bottom: -1.2rem;\n  margin-top: -0.9rem;\n}\n\n.outdial-ani-btn::part(button) {\n  box-shadow: none;\n  width: 100%;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.outdial-ani-search {\n  padding: var(--padding-outdialani-11) var(--padding-14);\n}\n\n.search-outdialani-input::part(md-input-container) {\n  margin-bottom: 0;\n}\n\n.outdial-container {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.outdial-ani-menu::part(overlay-content) {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  height: var(--outdialani-selector-height);\n  max-height: var(--outdialani-selector-height);\n}\n.fixed-size-list ul {\n  margin: 0;\n}\n.outdial-list__loading {\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  align-items: center;\n  margin: auto;\n  min-height: var(--outdial-status-height);\n}\n\n.infinite-menu-list-item {\n  align-content: center;\n  list-style-type: none;\n  padding: 0 var(--padding-14);\n}\n\n.infinite-menu-list-item:hover {\n  background-color: var(--list-hover-background, #c9f4ff);\n  cursor: pointer;\n}\n\n.selected-list-item-focused {\n  outline: none;\n  cursor: pointer;\n  box-shadow: var(--focused-list-shadow);\n}\n\n.selected-list-item {\n  background-color: var(--list-active-background, #c9f4ff);\n  box-shadow: var(--focused-list-shadow);\n}\n\ndiv.no-record {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: calc(var(--space-token-cardinal) * 2);\n  position: relative;\n  text-align: center;\n  min-height: var(--outdial-status-height);\n}\n\n.search-error {\n  display: flex;\n  flex-direction: row;\n  column-gap: var(--column-gap);\n  align-items: center;\n  font-size: var(--font-size-small);\n}\n.search-block-error {\n  display: flex;\n  align-items: center;\n  padding: var(--padding-16);\n  min-height: var(--outdial-status-height);\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/WrapUp/styles.css":
/*!*********************************************************************************************!*\
  !*** ../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/WrapUp/styles.css ***!
  \*********************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../node_modules/css-loader/dist/runtime/api.js */ "../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! -!../../../../../node_modules/css-loader/dist/cjs.js!../../css/variables.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/variables.css");
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_agentx_services_dist_styles_z_index_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! -!../../../../../node_modules/css-loader/dist/cjs.js!../../../../agentx-services/dist/styles/z-index.css */ "../../node_modules/css-loader/dist/cjs.js!../agentx-services/dist/styles/z-index.css");
// Imports




var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_css_variables_css__WEBPACK_IMPORTED_MODULE_2__["default"]);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_agentx_services_dist_styles_z_index_css__WEBPACK_IMPORTED_MODULE_3__["default"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  /* Wrapup Container */
  --wrapup-overlay-height: 568px;
  --wrapup-space-above-overlay: 216px;
  --wrapup-overlay-connector-height: calc(100vh - var(--wrapup-space-above-overlay));
  --wrapup-body-margin: 24px;

  --auto-wrapup-container-width: 205px;
  --wrap-up-list-container-width: 100%;
  --wrap-up-radio-option-padding: 3px;
  --wrapup-error-icon-right-margin: 8px;
  --wrapup-text-max-width: 130px;
  --wrap-up-list-container-max-height: 304px; /* 288px 8 * 36 + 16px padding */

  --full-wrapup-button-width: calc(260px);
  --wrapup-overlay-min-height: calc(369px);
}

.wrapup-container {
  display: flex;
  flex-direction: column;
  max-height: var(--wrapup-overlay-height);
  min-height: var(--wrapup-overlay-min-height);
}

#wrap-up-menu-overlay::part(overlay) {
  z-index: var(--z-index-wrap-up, 13);
}

.wrap-up-popover-wrapper {
  width: 100%;
}
.wrap-up-menu-selector {
  position: relative;
}

.monitoring-split {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.monitoring-split img {
  width: 13px;
}

.timer-dash {
  margin: 0 calc(var(--space-token-even) * 2);
}

.wrapup-button__children {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.auto-wrapup-wrapper {
  background-color: var(--md-auto-wrapup-bg-color, --blue-05-color);
  text-align: center;
}
.auto-wrapup-wrapper md-button::part(button) {
  margin-top: calc(var(--space-token-even) * 4);
  margin-bottom: calc(var(--space-token-even) * 6);
}
.auto-wrapup-label {
  font-size: var(--font-size-medium);
  line-height: 14px;
  color: var(--md-alert-info-text-color, --blue-70-color);
  padding-top: calc(var(--space-token-even) * 7);
  padding-bottom: calc(var(--space-token-even) * 7);
}
.auto-wrapup-button {
  font-size: var(--font-size-large);
  margin: calc(var(--space-token-cardinal) * 2);
}
.wrap-up-reason-header {
  font-size: var(--font-size-medium);
  padding: calc(var(--space-token-even) * 8) var(--wrapup-body-margin);
  line-height: 150%;
  font-weight: bold;
}
.wrap-up-reason-header.follow-up {
  padding: calc(var(--space-token-even) * 8) var(--wrapup-body-margin) calc(var(--space-token-even) * 4);
}
.wrap-up-input-wrapper {
  margin: 0 var(--wrapup-body-margin);
}
.wrapup-button::part(button) {
  background-color: var(--md-quaternary-bg-color);
}

.wrap-up-list-container,
.wrap-up-virtual-list-container {
  border-bottom: 1px solid var(--md-primary-seperator-color, --md-primary-seperator-color-default);
  width: var(--wrap-up-list-container-width);
  flex: 1 1 auto;
  max-height: var(--wrap-up-list-container-max-height);
  height: 100%;
  padding: var(--space-token-even) var(--wrapup-body-margin);
}
.wrapup-list__loading {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  margin: auto;
  min-height: 304px;
}

div.no-record {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(var(--space-token-cardinal) * 2);
  position: relative;
  text-align: center;
  min-height: 304px;
}

.no-record-found {
  position: relative;
  top: 11px;
}
.search-error {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-small);
}
.search-block-error {
  display: flex;
  align-items: center;
  padding: var(--padding-16);
  min-height: 304px;
}

.wrap-up-list-container {
  overflow-x: hidden;
  overflow-y: auto;
}

.wrap-up-virtual-list-container {
  overflow: hidden;
}

.wrap-up-list-container md-radiogroup::part(radio-group-container),
.wrap-up-virtual-list-container md-radiogroup::part(radio-group-container) {
  max-width: 100%;
}

.wrap-up-list-container md-radio::part(radio-wrapper),
.wrap-up-virtual-list-container md-radio::part(radio-wrapper) {
  max-width: 100%;
}

.wrap-up-list-container md-radio::part(radio-label),
.wrap-up-virtual-list-container md-radio::part(radio-label) {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}

.wrap-up-virtual-list-container .wrap-up-radio-option {
  padding: var(--wrap-up-radio-option-padding, 3px);
}

.wrap-up-list-container img,
.wrap-up-virtual-list-container img {
  display: block;
  margin: auto;
}
.wrap-up-list-container p,
.wrap-up-virtual-list-container p {
  text-align: center;
  position: relative;
  top: 21px;
}

.last-agent-route,
.wrap-up-no-match {
  margin: 0 calc(var(--space-token-even) * 8);
  font-size: var(--font-size-medium);
}
.wrap-up-submit-button {
  text-align: center;
  padding: calc(var(--space-token-even) * 8) 0px;
}
.md-radio__label span {
  overflow: hidden;
  text-overflow: ellipsis;
}
.wrap-up-toggle-icon {
  margin-left: calc(var(--space-token-cardinal) * 2);
  color: var(--md-primary-text-color, --gray-100-color);
}
.hide-content {
  display: none;
}
.auto-wrapup-container {
  width: var(--auto-wrapup-container-width);
  text-align: left;
  font-size: var(--font-size-medium);
  color: var(--md-primary-text-color, --gray-100-color);
  display: flex;
}
.font-blue {
  color: var(--md-alert-info-text-color, --blue-70-color);
}
.font-red {
  color: var(--md-alert-error-text-color, --red-70-color);
}
.wrapup-error-container {
  font-size: var(--font-size-small);
  color: var(--md-alert-error-text-color, --red-70-color);
  padding: calc(var(--space-token-even) * 6) var(--wrapup-body-margin) 0;
  line-height: 100%;
}
.wrapup-error-icon-container md-icon::part(icon) {
  margin-right: var(--wrapup-error-icon-right-margin);
  vertical-align: middle;
}

.wrapup-error-icon-container {
  float: left;
}

.wrapup-error-message {
  margin-bottom: var(--space-token-cardinal);
}

.wrapup-text {
  max-width: var(--wrapup-text-max-width);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

.wrapup-text-notimer {
  max-width: var(--auto-wrapup-container-width);
}

@media (max-width: 677px), (max-height: 677px) {
  .with-auto-wrapup-height,
  .wrap-up-list-container {
    overflow-x: hidden;
    overflow-y: auto;
  }
  .wrapup-container {
    z-index: var(--z-index-wrap-up, 13);
    display: flex;
    flex-direction: column;
    max-height: var(--wrapup-overlay-connector-height);
    min-height: var(--wrapup-overlay-connector-height);
  }
  .wrap-up-reason-header {
    display: none;
  }
  .wrap-up-input-wrapper {
    margin-top: calc(var(--space-token-even) * 8);
  }
  .wrap-up-followup-checkbox-wrapper {
    margin-top: calc(var(--space-token-even) * 2);
  }

  .wrap-up-submit-button {
    padding: calc(var(--space-token-cardinal) * 2) 0;
  }
  .wrap-up-setting {
    border-top: var(--border);
  }
  .auto-wrapup-label {
    padding-top: calc(var(--space-token-even) * 4);
    padding-bottom: calc(var(--space-token-even) * 4);
  }
  .last-agent-route {
    margin-bottom: 0;
  }
}

@media (max-width: 475px) {
  .wrapup-container {
    left: 0;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.radio-wrapper {
  width: 97% !important;
}
`, "",{"version":3,"sources":["webpack://./src/direflow-components/WrapUp/styles.css"],"names":[],"mappings":"AAGA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,mCAAmC;EACnC,kFAAkF;EAClF,0BAA0B;;EAE1B,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;EAC9B,0CAA0C,EAAE,gCAAgC;;EAE5E,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,kBAAkB;AACpB;AACA;EACE,6CAA6C;EAC7C,gDAAgD;AAClD;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,uDAAuD;EACvD,8CAA8C;EAC9C,iDAAiD;AACnD;AACA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;AACA;EACE,kCAAkC;EAClC,oEAAoE;EACpE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,sGAAsG;AACxG;AACA;EACE,mCAAmC;AACrC;AACA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,gGAAgG;EAChG,0CAA0C;EAC1C,cAAc;EACd,oDAAoD;EACpD,YAAY;EACZ,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,2CAA2C;EAC3C,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kDAAkD;EAClD,qDAAqD;AACvD;AACA;EACE,aAAa;AACf;AACA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,kCAAkC;EAClC,qDAAqD;EACrD,aAAa;AACf;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,iCAAiC;EACjC,uDAAuD;EACvD,sEAAsE;EACtE,iBAAiB;AACnB;AACA;EACE,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,mCAAmC;IACnC,aAAa;IACb,sBAAsB;IACtB,kDAAkD;IAClD,kDAAkD;EACpD;EACA;IACE,aAAa;EACf;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;;EAEA;IACE,gDAAgD;EAClD;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,8CAA8C;IAC9C,iDAAiD;EACnD;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["@import \"../../css/variables.css\";\n@import \"~@agentx/agentx-services/dist/styles/z-index.css\";\n\n* {\n  /* Wrapup Container */\n  --wrapup-overlay-height: 568px;\n  --wrapup-space-above-overlay: 216px;\n  --wrapup-overlay-connector-height: calc(100vh - var(--wrapup-space-above-overlay));\n  --wrapup-body-margin: 24px;\n\n  --auto-wrapup-container-width: 205px;\n  --wrap-up-list-container-width: 100%;\n  --wrap-up-radio-option-padding: 3px;\n  --wrapup-error-icon-right-margin: 8px;\n  --wrapup-text-max-width: 130px;\n  --wrap-up-list-container-max-height: 304px; /* 288px 8 * 36 + 16px padding */\n\n  --full-wrapup-button-width: calc(260px);\n  --wrapup-overlay-min-height: calc(369px);\n}\n\n.wrapup-container {\n  display: flex;\n  flex-direction: column;\n  max-height: var(--wrapup-overlay-height);\n  min-height: var(--wrapup-overlay-min-height);\n}\n\n#wrap-up-menu-overlay::part(overlay) {\n  z-index: var(--z-index-wrap-up, 13);\n}\n\n.wrap-up-popover-wrapper {\n  width: 100%;\n}\n.wrap-up-menu-selector {\n  position: relative;\n}\n\n.monitoring-split {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.monitoring-split img {\n  width: 13px;\n}\n\n.timer-dash {\n  margin: 0 calc(var(--space-token-even) * 2);\n}\n\n.wrapup-button__children {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.auto-wrapup-wrapper {\n  background-color: var(--md-auto-wrapup-bg-color, --blue-05-color);\n  text-align: center;\n}\n.auto-wrapup-wrapper md-button::part(button) {\n  margin-top: calc(var(--space-token-even) * 4);\n  margin-bottom: calc(var(--space-token-even) * 6);\n}\n.auto-wrapup-label {\n  font-size: var(--font-size-medium);\n  line-height: 14px;\n  color: var(--md-alert-info-text-color, --blue-70-color);\n  padding-top: calc(var(--space-token-even) * 7);\n  padding-bottom: calc(var(--space-token-even) * 7);\n}\n.auto-wrapup-button {\n  font-size: var(--font-size-large);\n  margin: calc(var(--space-token-cardinal) * 2);\n}\n.wrap-up-reason-header {\n  font-size: var(--font-size-medium);\n  padding: calc(var(--space-token-even) * 8) var(--wrapup-body-margin);\n  line-height: 150%;\n  font-weight: bold;\n}\n.wrap-up-reason-header.follow-up {\n  padding: calc(var(--space-token-even) * 8) var(--wrapup-body-margin) calc(var(--space-token-even) * 4);\n}\n.wrap-up-input-wrapper {\n  margin: 0 var(--wrapup-body-margin);\n}\n.wrapup-button::part(button) {\n  background-color: var(--md-quaternary-bg-color);\n}\n\n.wrap-up-list-container,\n.wrap-up-virtual-list-container {\n  border-bottom: 1px solid var(--md-primary-seperator-color, --md-primary-seperator-color-default);\n  width: var(--wrap-up-list-container-width);\n  flex: 1 1 auto;\n  max-height: var(--wrap-up-list-container-max-height);\n  height: 100%;\n  padding: var(--space-token-even) var(--wrapup-body-margin);\n}\n.wrapup-list__loading {\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  align-items: center;\n  margin: auto;\n  min-height: 304px;\n}\n\ndiv.no-record {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: calc(var(--space-token-cardinal) * 2);\n  position: relative;\n  text-align: center;\n  min-height: 304px;\n}\n\n.no-record-found {\n  position: relative;\n  top: 11px;\n}\n.search-error {\n  display: flex;\n  flex-direction: row;\n  column-gap: 8px;\n  align-items: center;\n  font-size: var(--font-size-small);\n}\n.search-block-error {\n  display: flex;\n  align-items: center;\n  padding: var(--padding-16);\n  min-height: 304px;\n}\n\n.wrap-up-list-container {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.wrap-up-virtual-list-container {\n  overflow: hidden;\n}\n\n.wrap-up-list-container md-radiogroup::part(radio-group-container),\n.wrap-up-virtual-list-container md-radiogroup::part(radio-group-container) {\n  max-width: 100%;\n}\n\n.wrap-up-list-container md-radio::part(radio-wrapper),\n.wrap-up-virtual-list-container md-radio::part(radio-wrapper) {\n  max-width: 100%;\n}\n\n.wrap-up-list-container md-radio::part(radio-label),\n.wrap-up-virtual-list-container md-radio::part(radio-label) {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.wrap-up-virtual-list-container .wrap-up-radio-option {\n  padding: var(--wrap-up-radio-option-padding, 3px);\n}\n\n.wrap-up-list-container img,\n.wrap-up-virtual-list-container img {\n  display: block;\n  margin: auto;\n}\n.wrap-up-list-container p,\n.wrap-up-virtual-list-container p {\n  text-align: center;\n  position: relative;\n  top: 21px;\n}\n\n.last-agent-route,\n.wrap-up-no-match {\n  margin: 0 calc(var(--space-token-even) * 8);\n  font-size: var(--font-size-medium);\n}\n.wrap-up-submit-button {\n  text-align: center;\n  padding: calc(var(--space-token-even) * 8) 0px;\n}\n.md-radio__label span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.wrap-up-toggle-icon {\n  margin-left: calc(var(--space-token-cardinal) * 2);\n  color: var(--md-primary-text-color, --gray-100-color);\n}\n.hide-content {\n  display: none;\n}\n.auto-wrapup-container {\n  width: var(--auto-wrapup-container-width);\n  text-align: left;\n  font-size: var(--font-size-medium);\n  color: var(--md-primary-text-color, --gray-100-color);\n  display: flex;\n}\n.font-blue {\n  color: var(--md-alert-info-text-color, --blue-70-color);\n}\n.font-red {\n  color: var(--md-alert-error-text-color, --red-70-color);\n}\n.wrapup-error-container {\n  font-size: var(--font-size-small);\n  color: var(--md-alert-error-text-color, --red-70-color);\n  padding: calc(var(--space-token-even) * 6) var(--wrapup-body-margin) 0;\n  line-height: 100%;\n}\n.wrapup-error-icon-container md-icon::part(icon) {\n  margin-right: var(--wrapup-error-icon-right-margin);\n  vertical-align: middle;\n}\n\n.wrapup-error-icon-container {\n  float: left;\n}\n\n.wrapup-error-message {\n  margin-bottom: var(--space-token-cardinal);\n}\n\n.wrapup-text {\n  max-width: var(--wrapup-text-max-width);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n}\n\n.wrapup-text-notimer {\n  max-width: var(--auto-wrapup-container-width);\n}\n\n@media (max-width: 677px), (max-height: 677px) {\n  .with-auto-wrapup-height,\n  .wrap-up-list-container {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n  .wrapup-container {\n    z-index: var(--z-index-wrap-up, 13);\n    display: flex;\n    flex-direction: column;\n    max-height: var(--wrapup-overlay-connector-height);\n    min-height: var(--wrapup-overlay-connector-height);\n  }\n  .wrap-up-reason-header {\n    display: none;\n  }\n  .wrap-up-input-wrapper {\n    margin-top: calc(var(--space-token-even) * 8);\n  }\n  .wrap-up-followup-checkbox-wrapper {\n    margin-top: calc(var(--space-token-even) * 2);\n  }\n\n  .wrap-up-submit-button {\n    padding: calc(var(--space-token-cardinal) * 2) 0;\n  }\n  .wrap-up-setting {\n    border-top: var(--border);\n  }\n  .auto-wrapup-label {\n    padding-top: calc(var(--space-token-even) * 4);\n    padding-bottom: calc(var(--space-token-even) * 4);\n  }\n  .last-agent-route {\n    margin-bottom: 0;\n  }\n}\n\n@media (max-width: 475px) {\n  .wrapup-container {\n    left: 0;\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.radio-wrapper {\n  width: 97% !important;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/runtime/api.js":
/*!*********************************************************!*\
  !*** ../../node_modules/css-loader/dist/runtime/api.js ***!
  \*********************************************************/
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ "../../node_modules/css-loader/dist/runtime/sourceMaps.js":
/*!****************************************************************!*\
  !*** ../../node_modules/css-loader/dist/runtime/sourceMaps.js ***!
  \****************************************************************/
/***/ ((module) => {

"use strict";


module.exports = function (item) {
  var content = item[1];
  var cssMapping = item[3];
  if (!cssMapping) {
    return content;
  }
  if (typeof btoa === "function") {
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    return [content].concat([sourceMapping]).join("\n");
  }
  return [content].join("\n");
};

/***/ }),

/***/ "../../node_modules/dompurify/dist/purify.es.mjs":
/*!*******************************************************!*\
  !*** ../../node_modules/dompurify/dist/purify.es.mjs ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ purify)
/* harmony export */ });
/*! @license DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE */

const {
  entries,
  setPrototypeOf,
  isFrozen,
  getPrototypeOf,
  getOwnPropertyDescriptor
} = Object;
let {
  freeze,
  seal,
  create
} = Object; // eslint-disable-line import/no-mutable-exports
let {
  apply,
  construct
} = typeof Reflect !== 'undefined' && Reflect;
if (!freeze) {
  freeze = function freeze(x) {
    return x;
  };
}
if (!seal) {
  seal = function seal(x) {
    return x;
  };
}
if (!apply) {
  apply = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}
if (!construct) {
  construct = function construct(Func, args) {
    return new Func(...args);
  };
}
const arrayForEach = unapply(Array.prototype.forEach);
const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
const arrayPop = unapply(Array.prototype.pop);
const arrayPush = unapply(Array.prototype.push);
const arraySplice = unapply(Array.prototype.splice);
const stringToLowerCase = unapply(String.prototype.toLowerCase);
const stringToString = unapply(String.prototype.toString);
const stringMatch = unapply(String.prototype.match);
const stringReplace = unapply(String.prototype.replace);
const stringIndexOf = unapply(String.prototype.indexOf);
const stringTrim = unapply(String.prototype.trim);
const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
const regExpTest = unapply(RegExp.prototype.test);
const typeErrorCreate = unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */
function unapply(func) {
  return function (thisArg) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return apply(func, thisArg, args);
  };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */
function unconstruct(func) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return construct(func, args);
  };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */
function addToSet(set, array) {
  let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
  if (setPrototypeOf) {
    // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
  }
  let l = array.length;
  while (l--) {
    let element = array[l];
    if (typeof element === 'string') {
      const lcElement = transformCaseFunc(element);
      if (lcElement !== element) {
        // Config presets (e.g. tags.js, attrs.js) are immutable.
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }
        element = lcElement;
      }
    }
    set[element] = true;
  }
  return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */
function cleanArray(array) {
  for (let index = 0; index < array.length; index++) {
    const isPropertyExist = objectHasOwnProperty(array, index);
    if (!isPropertyExist) {
      array[index] = null;
    }
  }
  return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */
function clone(object) {
  const newObject = create(null);
  for (const [property, value] of entries(object)) {
    const isPropertyExist = objectHasOwnProperty(object, property);
    if (isPropertyExist) {
      if (Array.isArray(value)) {
        newObject[property] = cleanArray(value);
      } else if (value && typeof value === 'object' && value.constructor === Object) {
        newObject[property] = clone(value);
      } else {
        newObject[property] = value;
      }
    }
  }
  return newObject;
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */
function lookupGetter(object, prop) {
  while (object !== null) {
    const desc = getOwnPropertyDescriptor(object, prop);
    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }
      if (typeof desc.value === 'function') {
        return unapply(desc.value);
      }
    }
    object = getPrototypeOf(object);
  }
  function fallbackValue() {
    return null;
  }
  return fallbackValue;
}

const html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);
const svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
const svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
const mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover', 'mprescripts']);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
const text = freeze(['#text']);

const html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'popover', 'popovertarget', 'popovertargetaction', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'wrap', 'xmlns', 'slot']);
const svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'amplitude', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'exponent', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'slope', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'tablevalues', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
const mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
const xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

// eslint-disable-next-line unicorn/better-regex
const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const DOCTYPE_NAME = seal(/^html$/i);
const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

var EXPRESSIONS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ARIA_ATTR: ARIA_ATTR,
  ATTR_WHITESPACE: ATTR_WHITESPACE,
  CUSTOM_ELEMENT: CUSTOM_ELEMENT,
  DATA_ATTR: DATA_ATTR,
  DOCTYPE_NAME: DOCTYPE_NAME,
  ERB_EXPR: ERB_EXPR,
  IS_ALLOWED_URI: IS_ALLOWED_URI,
  IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
  MUSTACHE_EXPR: MUSTACHE_EXPR,
  TMPLIT_EXPR: TMPLIT_EXPR
});

/* eslint-disable @typescript-eslint/indent */
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const NODE_TYPE = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12 // Deprecated
};
const getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */
const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
  if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
    return null;
  }
  // Allow the callers to control the unique policy name
  // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
  // Policy creation with duplicate names throws in Trusted Types.
  let suffix = null;
  const ATTR_NAME = 'data-tt-policy-suffix';
  if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
    suffix = purifyHostElement.getAttribute(ATTR_NAME);
  }
  const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML(html) {
        return html;
      },
      createScriptURL(scriptUrl) {
        return scriptUrl;
      }
    });
  } catch (_) {
    // Policy creation failed (most likely another DOMPurify script has
    // already run). Skip creating the policy, as this will only cause errors
    // if TT are enforced.
    console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
    return null;
  }
};
const _createHooksMap = function _createHooksMap() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function createDOMPurify() {
  let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
  const DOMPurify = root => createDOMPurify(root);
  DOMPurify.version = '3.2.4';
  DOMPurify.removed = [];
  if (!window || !window.document || window.document.nodeType !== NODE_TYPE.document || !window.Element) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;
    return DOMPurify;
  }
  let {
    document
  } = window;
  const originalDocument = document;
  const currentScript = originalDocument.currentScript;
  const {
    DocumentFragment,
    HTMLTemplateElement,
    Node,
    Element,
    NodeFilter,
    NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap,
    HTMLFormElement,
    DOMParser,
    trustedTypes
  } = window;
  const ElementPrototype = Element.prototype;
  const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
  const remove = lookupGetter(ElementPrototype, 'remove');
  const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
  const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
  const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
  // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.
  if (typeof HTMLTemplateElement === 'function') {
    const template = document.createElement('template');
    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }
  let trustedTypesPolicy;
  let emptyHTML = '';
  const {
    implementation,
    createNodeIterator,
    createDocumentFragment,
    getElementsByTagName
  } = document;
  const {
    importNode
  } = originalDocument;
  let hooks = _createHooksMap();
  /**
   * Expose whether this browser supports running the full DOMPurify.
   */
  DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
  const {
    MUSTACHE_EXPR,
    ERB_EXPR,
    TMPLIT_EXPR,
    DATA_ATTR,
    ARIA_ATTR,
    IS_SCRIPT_OR_DATA,
    ATTR_WHITESPACE,
    CUSTOM_ELEMENT
  } = EXPRESSIONS;
  let {
    IS_ALLOWED_URI: IS_ALLOWED_URI$1
  } = EXPRESSIONS;
  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */
  /* allowed element names */
  let ALLOWED_TAGS = null;
  const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
  /* Allowed attribute names */
  let ALLOWED_ATTR = null;
  const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg, ...mathMl, ...xml]);
  /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */
  let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));
  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
  let FORBID_TAGS = null;
  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
  let FORBID_ATTR = null;
  /* Decide if ARIA attributes are okay */
  let ALLOW_ARIA_ATTR = true;
  /* Decide if custom data attributes are okay */
  let ALLOW_DATA_ATTR = true;
  /* Decide if unknown protocols are okay */
  let ALLOW_UNKNOWN_PROTOCOLS = false;
  /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */
  let ALLOW_SELF_CLOSE_IN_ATTR = true;
  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */
  let SAFE_FOR_TEMPLATES = false;
  /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */
  let SAFE_FOR_XML = true;
  /* Decide if document with <html>... should be returned */
  let WHOLE_DOCUMENT = false;
  /* Track whether config is already set on this instance of DOMPurify. */
  let SET_CONFIG = false;
  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */
  let FORCE_BODY = false;
  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */
  let RETURN_DOM = false;
  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */
  let RETURN_DOM_FRAGMENT = false;
  /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */
  let RETURN_TRUSTED_TYPE = false;
  /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */
  let SANITIZE_DOM = true;
  /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */
  let SANITIZE_NAMED_PROPS = false;
  const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
  /* Keep element content when removing element? */
  let KEEP_CONTENT = true;
  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */
  let IN_PLACE = false;
  /* Allow usage of profiles like html, svg and mathMl */
  let USE_PROFILES = {};
  /* Tags to ignore content of when KEEP_CONTENT is true */
  let FORBID_CONTENTS = null;
  const DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
  /* Tags that are safe for data: URIs */
  let DATA_URI_TAGS = null;
  const DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
  /* Attributes safe for values like "javascript:" */
  let URI_SAFE_ATTRIBUTES = null;
  const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
  const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
  const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
  /* Document namespace */
  let NAMESPACE = HTML_NAMESPACE;
  let IS_EMPTY_INPUT = false;
  /* Allowed XHTML+XML namespaces */
  let ALLOWED_NAMESPACES = null;
  const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
  let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
  let HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']);
  // Certain elements are allowed in both SVG and HTML
  // namespace. We need to specify them explicitly
  // so that they don't get erroneously deleted from
  // HTML namespace.
  const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
  /* Parsing of strict XHTML documents */
  let PARSER_MEDIA_TYPE = null;
  const SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
  const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
  let transformCaseFunc = null;
  /* Keep a reference to config to pass to hooks */
  let CONFIG = null;
  /* Ideally, do not touch anything below this line */
  /* ______________________________________________ */
  const formElement = document.createElement('form');
  const isRegexOrFunction = function isRegexOrFunction(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };
  /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */
  // eslint-disable-next-line complexity
  const _parseConfig = function _parseConfig() {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (CONFIG && CONFIG === cfg) {
      return;
    }
    /* Shield configuration object from tampering */
    if (!cfg || typeof cfg !== 'object') {
      cfg = {};
    }
    /* Shield configuration object from prototype pollution */
    cfg = clone(cfg);
    PARSER_MEDIA_TYPE =
    // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
    // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
    transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
    /* Set configuration parameters */
    ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
    ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
    URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
    DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
    FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
    FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
    FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
    USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
    RETURN_DOM = cfg.RETURN_DOM || false; // Default false
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
    FORCE_BODY = cfg.FORCE_BODY || false; // Default false
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
    IN_PLACE = cfg.IN_PLACE || false; // Default false
    IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
    NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
    MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
    HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
    CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
    }
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }
    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    /* Parse profile info */
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, text);
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, html);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, xml);
      }
    }
    /* Merge configuration parameters */
    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone(ALLOWED_TAGS);
      }
      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
    }
    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone(ALLOWED_ATTR);
      }
      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
    }
    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
    }
    if (cfg.FORBID_CONTENTS) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
    }
    /* Add #text in case KEEP_CONTENT is set to true */
    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }
    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }
    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
      delete FORBID_TAGS.tbody;
    }
    if (cfg.TRUSTED_TYPES_POLICY) {
      if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      }
      if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      }
      // Overwrite existing TrustedTypes policy.
      trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
      // Sign local variables required by `sanitize`.
      emptyHTML = trustedTypesPolicy.createHTML('');
    } else {
      // Uninitialized policy, attempt to initialize the internal dompurify policy.
      if (trustedTypesPolicy === undefined) {
        trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
      }
      // If creating the internal policy succeeded sign internal variables.
      if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') {
        emptyHTML = trustedTypesPolicy.createHTML('');
      }
    }
    // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.
    if (freeze) {
      freeze(cfg);
    }
    CONFIG = cfg;
  };
  /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */
  const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
  const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
  /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */
  const _checkValidNamespace = function _checkValidNamespace(element) {
    let parent = getParentNode(element);
    // In JSDOM, if we're inside shadow DOM, then parentNode
    // can be null. We just simulate parent in this case.
    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: 'template'
      };
    }
    const tagName = stringToLowerCase(element.tagName);
    const parentTagName = stringToLowerCase(parent.tagName);
    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }
    if (element.namespaceURI === SVG_NAMESPACE) {
      // The only way to switch from HTML namespace to SVG
      // is via <svg>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'svg';
      }
      // The only way to switch from MathML to SVG is via`
      // svg if parent is either <annotation-xml> or MathML
      // text integration points.
      if (parent.namespaceURI === MATHML_NAMESPACE) {
        return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
      }
      // We only allow elements that are defined in SVG
      // spec. All others are disallowed in SVG namespace.
      return Boolean(ALL_SVG_TAGS[tagName]);
    }
    if (element.namespaceURI === MATHML_NAMESPACE) {
      // The only way to switch from HTML namespace to MathML
      // is via <math>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'math';
      }
      // The only way to switch from SVG to MathML is via
      // <math> and HTML integration points
      if (parent.namespaceURI === SVG_NAMESPACE) {
        return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
      }
      // We only allow elements that are defined in MathML
      // spec. All others are disallowed in MathML namespace.
      return Boolean(ALL_MATHML_TAGS[tagName]);
    }
    if (element.namespaceURI === HTML_NAMESPACE) {
      // The only way to switch from SVG to HTML is via
      // HTML integration points, and from MathML to HTML
      // is via MathML text integration points
      if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      // We disallow tags that are specific for MathML
      // or SVG and should never appear in HTML namespace
      return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    }
    // For XHTML and XML documents that support custom namespaces
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    }
    // The code should never reach this place (this means
    // that the element somehow got namespace that is not
    // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
    // Return false just in case.
    return false;
  };
  /**
   * _forceRemove
   *
   * @param node a DOM node
   */
  const _forceRemove = function _forceRemove(node) {
    arrayPush(DOMPurify.removed, {
      element: node
    });
    try {
      // eslint-disable-next-line unicorn/prefer-dom-node-remove
      getParentNode(node).removeChild(node);
    } catch (_) {
      remove(node);
    }
  };
  /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */
  const _removeAttribute = function _removeAttribute(name, element) {
    try {
      arrayPush(DOMPurify.removed, {
        attribute: element.getAttributeNode(name),
        from: element
      });
    } catch (_) {
      arrayPush(DOMPurify.removed, {
        attribute: null,
        from: element
      });
    }
    element.removeAttribute(name);
    // We void attribute values for unremovable "is" attributes
    if (name === 'is') {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(element);
        } catch (_) {}
      } else {
        try {
          element.setAttribute(name, '');
        } catch (_) {}
      }
    }
  };
  /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */
  const _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    let doc = null;
    let leadingWhitespace = null;
    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    } else {
      /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
      const matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
      // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
    }
    const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */
    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {}
    }
    /* Use createHTMLDocument in case DOMParser is not available */
    if (!doc || !doc.documentElement) {
      doc = implementation.createDocument(NAMESPACE, 'template', null);
      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_) {
        // Syntax error if dirtyPayload is invalid xml
      }
    }
    const body = doc.body || doc.documentElement;
    if (dirty && leadingWhitespace) {
      body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }
    /* Work on whole document or just its body */
    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
    }
    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };
  /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */
  const _createNodeIterator = function _createNodeIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root,
    // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
  };
  /**
   * _isClobbered
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */
  const _isClobbered = function _isClobbered(element) {
    return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
  };
  /**
   * Checks whether the given object is a DOM node.
   *
   * @param value object to check whether it's a DOM node
   * @return true is object is a DOM node
   */
  const _isNode = function _isNode(value) {
    return typeof Node === 'function' && value instanceof Node;
  };
  function _executeHooks(hooks, currentNode, data) {
    arrayForEach(hooks, hook => {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  }
  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */
  const _sanitizeElements = function _sanitizeElements(currentNode) {
    let content = null;
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
    /* Check if element is clobbered or can clobber */
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Now let's check the element's type and name */
    const tagName = transformCaseFunc(currentNode.nodeName);
    /* Execute a hook if present */
    _executeHooks(hooks.uponSanitizeElement, currentNode, {
      tagName,
      allowedTags: ALLOWED_TAGS
    });
    /* Detect mXSS attempts abusing namespace confusion */
    if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove any occurrence of processing instructions */
    if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove any kind of possibly harmful comments */
    if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove element if anything forbids its presence */
    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      /* Check if we have a custom element to handle */
      if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
          return false;
        }
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
          return false;
        }
      }
      /* Keep content except for bad-listed elements */
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
        const parentNode = getParentNode(currentNode) || currentNode.parentNode;
        const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
        if (childNodes && parentNode) {
          const childCount = childNodes.length;
          for (let i = childCount - 1; i >= 0; --i) {
            const childClone = cloneNode(childNodes[i], true);
            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
            parentNode.insertBefore(childClone, getNextSibling(currentNode));
          }
        }
      }
      _forceRemove(currentNode);
      return true;
    }
    /* Check whether element has a valid namespace */
    if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Make sure that older browsers don't get fallback-tag mXSS */
    if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Sanitize element content to be template-safe */
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
      /* Get the element's text content */
      content = currentNode.textContent;
      arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
        content = stringReplace(content, expr, ' ');
      });
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeElements, currentNode, null);
    return false;
  };
  /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */
  // eslint-disable-next-line complexity
  const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }
    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */
    if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      if (
      // First condition does a very basic check if a) it's basically a valid custom element tagname AND
      // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
      _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
      // Alternative, second condition checks if it's an `is`-attribute, AND
      // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
        return false;
      }
      /* Check value is safe. First, is attr inert? If so, is safe */
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if (value) {
      return false;
    } else ;
    return true;
  };
  /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */
  const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
    return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
  };
  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */
  const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
    const {
      attributes
    } = currentNode;
    /* Check if we have attributes; if not we might have a text node */
    if (!attributes || _isClobbered(currentNode)) {
      return;
    }
    const hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR,
      forceKeepAttr: undefined
    };
    let l = attributes.length;
    /* Go backwards over all attributes; safely remove bad ones */
    while (l--) {
      const attr = attributes[l];
      const {
        name,
        namespaceURI,
        value: attrValue
      } = attr;
      const lcName = transformCaseFunc(name);
      let value = name === 'value' ? attrValue : stringTrim(attrValue);
      /* Execute a hook if present */
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
      _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
      value = hookEvent.attrValue;
      /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */
      if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
        // Remove the attribute with this value
        _removeAttribute(name, currentNode);
        // Prefix the value and later re-create the attribute with the sanitized value
        value = SANITIZE_NAMED_PROPS_PREFIX + value;
      }
      /* Work around a security issue with comments inside attributes */
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Did the hooks approve of the attribute? */
      if (hookEvent.forceKeepAttr) {
        continue;
      }
      /* Remove attribute */
      _removeAttribute(name, currentNode);
      /* Did the hooks approve of the attribute? */
      if (!hookEvent.keepAttr) {
        continue;
      }
      /* Work around a security issue in jQuery 3.0 */
      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Sanitize attribute content to be template-safe */
      if (SAFE_FOR_TEMPLATES) {
        arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
          value = stringReplace(value, expr, ' ');
        });
      }
      /* Is `value` valid for this attribute? */
      const lcTag = transformCaseFunc(currentNode.nodeName);
      if (!_isValidAttribute(lcTag, lcName, value)) {
        continue;
      }
      /* Handle attributes that require Trusted Types */
      if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
        if (namespaceURI) ; else {
          switch (trustedTypes.getAttributeType(lcTag, lcName)) {
            case 'TrustedHTML':
              {
                value = trustedTypesPolicy.createHTML(value);
                break;
              }
            case 'TrustedScriptURL':
              {
                value = trustedTypesPolicy.createScriptURL(value);
                break;
              }
          }
        }
      }
      /* Handle invalid data-* attribute set by try-catching it */
      try {
        if (namespaceURI) {
          currentNode.setAttributeNS(namespaceURI, name, value);
        } else {
          /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
          currentNode.setAttribute(name, value);
        }
        if (_isClobbered(currentNode)) {
          _forceRemove(currentNode);
        } else {
          arrayPop(DOMPurify.removed);
        }
      } catch (_) {}
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
  };
  /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */
  const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
    let shadowNode = null;
    const shadowIterator = _createNodeIterator(fragment);
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
      /* Sanitize tags and elements */
      _sanitizeElements(shadowNode);
      /* Check attributes next */
      _sanitizeAttributes(shadowNode);
      /* Deep shadow DOM detected */
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(shadowNode.content);
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
  };
  // eslint-disable-next-line complexity
  DOMPurify.sanitize = function (dirty) {
    let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let body = null;
    let importedNode = null;
    let currentNode = null;
    let returnNode = null;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */
    IS_EMPTY_INPUT = !dirty;
    if (IS_EMPTY_INPUT) {
      dirty = '<!-->';
    }
    /* Stringify, in case dirty is an object */
    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      if (typeof dirty.toString === 'function') {
        dirty = dirty.toString();
        if (typeof dirty !== 'string') {
          throw typeErrorCreate('dirty is not a string, aborting');
        }
      } else {
        throw typeErrorCreate('toString is not a function');
      }
    }
    /* Return dirty HTML if DOMPurify cannot run */
    if (!DOMPurify.isSupported) {
      return dirty;
    }
    /* Assign config vars */
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }
    /* Clean up removed elements */
    DOMPurify.removed = [];
    /* Check if dirty is correctly typed for IN_PLACE */
    if (typeof dirty === 'string') {
      IN_PLACE = false;
    }
    if (IN_PLACE) {
      /* Do some early pre-sanitization to avoid unsafe root nodes */
      if (dirty.nodeName) {
        const tagName = transformCaseFunc(dirty.nodeName);
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
        }
      }
    } else if (dirty instanceof Node) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!---->');
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else if (importedNode.nodeName === 'HTML') {
        body = importedNode;
      } else {
        // eslint-disable-next-line unicorn/prefer-dom-node-append
        body.appendChild(importedNode);
      }
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
      // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf('<') === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }
      /* Initialize the document to work on */
      body = _initDocument(dirty);
      /* Check we have a DOM node from the data */
      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
      }
    }
    /* Remove first element node (ours) if FORCE_BODY is set */
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    /* Get node iterator */
    const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
    /* Now start iterating over the created document */
    while (currentNode = nodeIterator.nextNode()) {
      /* Sanitize tags and elements */
      _sanitizeElements(currentNode);
      /* Check attributes next */
      _sanitizeAttributes(currentNode);
      /* Shadow DOM detected, sanitize it */
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }
    }
    /* If we sanitized `dirty` in-place, return it. */
    if (IN_PLACE) {
      return dirty;
    }
    /* Return sanitized string or DOM */
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);
        while (body.firstChild) {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }
      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
        /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }
      return returnNode;
    }
    let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    /* Serialize doctype if allowed */
    if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
    }
    /* Sanitize final string template-safe */
    if (SAFE_FOR_TEMPLATES) {
      arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
        serializedHTML = stringReplace(serializedHTML, expr, ' ');
      });
    }
    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };
  DOMPurify.setConfig = function () {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _parseConfig(cfg);
    SET_CONFIG = true;
  };
  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };
  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }
    const lcTag = transformCaseFunc(tag);
    const lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };
  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }
    arrayPush(hooks[entryPoint], hookFunction);
  };
  DOMPurify.removeHook = function (entryPoint, hookFunction) {
    if (hookFunction !== undefined) {
      const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
      return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
    }
    return arrayPop(hooks[entryPoint]);
  };
  DOMPurify.removeHooks = function (entryPoint) {
    hooks[entryPoint] = [];
  };
  DOMPurify.removeAllHooks = function () {
    hooks = _createHooksMap();
  };
  return DOMPurify;
}
var purify = createDOMPurify();


//# sourceMappingURL=purify.es.mjs.map


/***/ }),

/***/ "../../node_modules/iso-639-1/src/data.js":
/*!************************************************!*\
  !*** ../../node_modules/iso-639-1/src/data.js ***!
  \************************************************/
/***/ ((module) => {

const LANGUAGES_LIST = {
  aa: {
    name: 'Afar',
    nativeName: 'Afaraf',
  },
  ab: {
    name: 'Abkhaz',
    nativeName: 'аҧсуа бызшәа',
  },
  ae: {
    name: 'Avestan',
    nativeName: 'avesta',
  },
  af: {
    name: 'Afrikaans',
    nativeName: 'Afrikaans',
  },
  ak: {
    name: 'Akan',
    nativeName: 'Akan',
  },
  am: {
    name: 'Amharic',
    nativeName: 'አማርኛ',
  },
  an: {
    name: 'Aragonese',
    nativeName: 'aragonés',
  },
  ar: {
    name: 'Arabic',
    nativeName: 'العربية',
  },
  as: {
    name: 'Assamese',
    nativeName: 'অসমীয়া',
  },
  av: {
    name: 'Avaric',
    nativeName: 'авар мацӀ',
  },
  ay: {
    name: 'Aymara',
    nativeName: 'aymar aru',
  },
  az: {
    name: 'Azerbaijani',
    nativeName: 'azərbaycan dili',
  },
  ba: {
    name: 'Bashkir',
    nativeName: 'башҡорт теле',
  },
  be: {
    name: 'Belarusian',
    nativeName: 'беларуская мова',
  },
  bg: {
    name: 'Bulgarian',
    nativeName: 'български език',
  },
  bi: {
    name: 'Bislama',
    nativeName: 'Bislama',
  },
  bm: {
    name: 'Bambara',
    nativeName: 'bamanankan',
  },
  bn: {
    name: 'Bengali',
    nativeName: 'বাংলা',
  },
  bo: {
    name: 'Tibetan',
    nativeName: 'བོད་ཡིག',
  },
  br: {
    name: 'Breton',
    nativeName: 'brezhoneg',
  },
  bs: {
    name: 'Bosnian',
    nativeName: 'bosanski jezik',
  },
  ca: {
    name: 'Catalan',
    nativeName: 'Català',
  },
  ce: {
    name: 'Chechen',
    nativeName: 'нохчийн мотт',
  },
  ch: {
    name: 'Chamorro',
    nativeName: 'Chamoru',
  },
  co: {
    name: 'Corsican',
    nativeName: 'corsu',
  },
  cr: {
    name: 'Cree',
    nativeName: 'ᓀᐦᐃᔭᐍᐏᐣ',
  },
  cs: {
    name: 'Czech',
    nativeName: 'Čeština',
  },
  cu: {
    name: 'Old Church Slavonic',
    nativeName: 'ѩзыкъ словѣньскъ',
  },
  cv: {
    name: 'Chuvash',
    nativeName: 'чӑваш чӗлхи',
  },
  cy: {
    name: 'Welsh',
    nativeName: 'Cymraeg',
  },
  da: {
    name: 'Danish',
    nativeName: 'Dansk',
  },
  de: {
    name: 'German',
    nativeName: 'Deutsch',
  },
  dv: {
    name: 'Divehi',
    nativeName: 'ދިވެހި',
  },
  dz: {
    name: 'Dzongkha',
    nativeName: 'རྫོང་ཁ',
  },
  ee: {
    name: 'Ewe',
    nativeName: 'Eʋegbe',
  },
  el: {
    name: 'Greek',
    nativeName: 'Ελληνικά',
  },
  en: {
    name: 'English',
    nativeName: 'English',
  },
  eo: {
    name: 'Esperanto',
    nativeName: 'Esperanto',
  },
  es: {
    name: 'Spanish',
    nativeName: 'Español',
  },
  et: {
    name: 'Estonian',
    nativeName: 'eesti',
  },
  eu: {
    name: 'Basque',
    nativeName: 'euskara',
  },
  fa: {
    name: 'Persian',
    nativeName: 'فارسی',
  },
  ff: {
    name: 'Fula',
    nativeName: 'Fulfulde',
  },
  fi: {
    name: 'Finnish',
    nativeName: 'suomi',
  },
  fj: {
    name: 'Fijian',
    nativeName: 'vosa Vakaviti',
  },
  fo: {
    name: 'Faroese',
    nativeName: 'Føroyskt',
  },
  fr: {
    name: 'French',
    nativeName: 'Français',
  },
  fy: {
    name: 'Western Frisian',
    nativeName: 'Frysk',
  },
  ga: {
    name: 'Irish',
    nativeName: 'Gaeilge',
  },
  gd: {
    name: 'Scottish Gaelic',
    nativeName: 'Gàidhlig',
  },
  gl: {
    name: 'Galician',
    nativeName: 'galego',
  },
  gn: {
    name: 'Guaraní',
    nativeName: "Avañe'ẽ",
  },
  gu: {
    name: 'Gujarati',
    nativeName: 'ગુજરાતી',
  },
  gv: {
    name: 'Manx',
    nativeName: 'Gaelg',
  },
  ha: {
    name: 'Hausa',
    nativeName: 'هَوُسَ',
  },
  he: {
    name: 'Hebrew',
    nativeName: 'עברית',
  },
  hi: {
    name: 'Hindi',
    nativeName: 'हिन्दी',
  },
  ho: {
    name: 'Hiri Motu',
    nativeName: 'Hiri Motu',
  },
  hr: {
    name: 'Croatian',
    nativeName: 'Hrvatski',
  },
  ht: {
    name: 'Haitian',
    nativeName: 'Kreyòl ayisyen',
  },
  hu: {
    name: 'Hungarian',
    nativeName: 'magyar',
  },
  hy: {
    name: 'Armenian',
    nativeName: 'Հայերեն',
  },
  hz: {
    name: 'Herero',
    nativeName: 'Otjiherero',
  },
  ia: {
    name: 'Interlingua',
    nativeName: 'Interlingua',
  },
  id: {
    name: 'Indonesian',
    nativeName: 'Bahasa Indonesia',
  },
  ie: {
    name: 'Interlingue',
    nativeName: 'Interlingue',
  },
  ig: {
    name: 'Igbo',
    nativeName: 'Asụsụ Igbo',
  },
  ii: {
    name: 'Nuosu',
    nativeName: 'ꆈꌠ꒿ Nuosuhxop',
  },
  ik: {
    name: 'Inupiaq',
    nativeName: 'Iñupiaq',
  },
  io: {
    name: 'Ido',
    nativeName: 'Ido',
  },
  is: {
    name: 'Icelandic',
    nativeName: 'Íslenska',
  },
  it: {
    name: 'Italian',
    nativeName: 'Italiano',
  },
  iu: {
    name: 'Inuktitut',
    nativeName: 'ᐃᓄᒃᑎᑐᑦ',
  },
  ja: {
    name: 'Japanese',
    nativeName: '日本語',
  },
  jv: {
    name: 'Javanese',
    nativeName: 'basa Jawa',
  },
  ka: {
    name: 'Georgian',
    nativeName: 'ქართული',
  },
  kg: {
    name: 'Kongo',
    nativeName: 'Kikongo',
  },
  ki: {
    name: 'Kikuyu',
    nativeName: 'Gĩkũyũ',
  },
  kj: {
    name: 'Kwanyama',
    nativeName: 'Kuanyama',
  },
  kk: {
    name: 'Kazakh',
    nativeName: 'қазақ тілі',
  },
  kl: {
    name: 'Kalaallisut',
    nativeName: 'kalaallisut',
  },
  km: {
    name: 'Khmer',
    nativeName: 'ខេមរភាសា',
  },
  kn: {
    name: 'Kannada',
    nativeName: 'ಕನ್ನಡ',
  },
  ko: {
    name: 'Korean',
    nativeName: '한국어',
  },
  kr: {
    name: 'Kanuri',
    nativeName: 'Kanuri',
  },
  ks: {
    name: 'Kashmiri',
    nativeName: 'कश्मीरी',
  },
  ku: {
    name: 'Kurdish',
    nativeName: 'Kurdî',
  },
  kv: {
    name: 'Komi',
    nativeName: 'коми кыв',
  },
  kw: {
    name: 'Cornish',
    nativeName: 'Kernewek',
  },
  ky: {
    name: 'Kyrgyz',
    nativeName: 'Кыргызча',
  },
  la: {
    name: 'Latin',
    nativeName: 'latine',
  },
  lb: {
    name: 'Luxembourgish',
    nativeName: 'Lëtzebuergesch',
  },
  lg: {
    name: 'Ganda',
    nativeName: 'Luganda',
  },
  li: {
    name: 'Limburgish',
    nativeName: 'Limburgs',
  },
  ln: {
    name: 'Lingala',
    nativeName: 'Lingála',
  },
  lo: {
    name: 'Lao',
    nativeName: 'ພາສາລາວ',
  },
  lt: {
    name: 'Lithuanian',
    nativeName: 'lietuvių kalba',
  },
  lu: {
    name: 'Luba-Katanga',
    nativeName: 'Kiluba',
  },
  lv: {
    name: 'Latvian',
    nativeName: 'latviešu valoda',
  },
  mg: {
    name: 'Malagasy',
    nativeName: 'fiteny malagasy',
  },
  mh: {
    name: 'Marshallese',
    nativeName: 'Kajin M̧ajeļ',
  },
  mi: {
    name: 'Māori',
    nativeName: 'te reo Māori',
  },
  mk: {
    name: 'Macedonian',
    nativeName: 'македонски јазик',
  },
  ml: {
    name: 'Malayalam',
    nativeName: 'മലയാളം',
  },
  mn: {
    name: 'Mongolian',
    nativeName: 'Монгол хэл',
  },
  mr: {
    name: 'Marathi',
    nativeName: 'मराठी',
  },
  ms: {
    name: 'Malay',
    nativeName: 'Bahasa Melayu',
  },
  mt: {
    name: 'Maltese',
    nativeName: 'Malti',
  },
  my: {
    name: 'Burmese',
    nativeName: 'ဗမာစာ',
  },
  na: {
    name: 'Nauru',
    nativeName: 'Dorerin Naoero',
  },
  nb: {
    name: 'Norwegian Bokmål',
    nativeName: 'Norsk bokmål',
  },
  nd: {
    name: 'Northern Ndebele',
    nativeName: 'isiNdebele',
  },
  ne: {
    name: 'Nepali',
    nativeName: 'नेपाली',
  },
  ng: {
    name: 'Ndonga',
    nativeName: 'Owambo',
  },
  nl: {
    name: 'Dutch',
    nativeName: 'Nederlands',
  },
  nn: {
    name: 'Norwegian Nynorsk',
    nativeName: 'Norsk nynorsk',
  },
  no: {
    name: 'Norwegian',
    nativeName: 'Norsk',
  },
  nr: {
    name: 'Southern Ndebele',
    nativeName: 'isiNdebele',
  },
  nv: {
    name: 'Navajo',
    nativeName: 'Diné bizaad',
  },
  ny: {
    name: 'Chichewa',
    nativeName: 'chiCheŵa',
  },
  oc: {
    name: 'Occitan',
    nativeName: 'occitan',
  },
  oj: {
    name: 'Ojibwe',
    nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ',
  },
  om: {
    name: 'Oromo',
    nativeName: 'Afaan Oromoo',
  },
  or: {
    name: 'Oriya',
    nativeName: 'ଓଡ଼ିଆ',
  },
  os: {
    name: 'Ossetian',
    nativeName: 'ирон æвзаг',
  },
  pa: {
    name: 'Panjabi',
    nativeName: 'ਪੰਜਾਬੀ',
  },
  pi: {
    name: 'Pāli',
    nativeName: 'पाऴि',
  },
  pl: {
    name: 'Polish',
    nativeName: 'Polski',
  },
  ps: {
    name: 'Pashto',
    nativeName: 'پښتو',
  },
  pt: {
    name: 'Portuguese',
    nativeName: 'Português',
  },
  qu: {
    name: 'Quechua',
    nativeName: 'Runa Simi',
  },
  rm: {
    name: 'Romansh',
    nativeName: 'rumantsch grischun',
  },
  rn: {
    name: 'Kirundi',
    nativeName: 'Ikirundi',
  },
  ro: {
    name: 'Romanian',
    nativeName: 'Română',
  },
  ru: {
    name: 'Russian',
    nativeName: 'Русский',
  },
  rw: {
    name: 'Kinyarwanda',
    nativeName: 'Ikinyarwanda',
  },
  sa: {
    name: 'Sanskrit',
    nativeName: 'संस्कृतम्',
  },
  sc: {
    name: 'Sardinian',
    nativeName: 'sardu',
  },
  sd: {
    name: 'Sindhi',
    nativeName: 'सिन्धी',
  },
  se: {
    name: 'Northern Sami',
    nativeName: 'Davvisámegiella',
  },
  sg: {
    name: 'Sango',
    nativeName: 'yângâ tî sängö',
  },
  si: {
    name: 'Sinhala',
    nativeName: 'සිංහල',
  },
  sk: {
    name: 'Slovak',
    nativeName: 'Slovenčina',
  },
  sl: {
    name: 'Slovenian',
    nativeName: 'slovenščina',
  },
  sm: {
    name: 'Samoan',
    nativeName: "gagana fa'a Samoa",
  },
  sn: {
    name: 'Shona',
    nativeName: 'chiShona',
  },
  so: {
    name: 'Somali',
    nativeName: 'Soomaaliga',
  },
  sq: {
    name: 'Albanian',
    nativeName: 'Shqip',
  },
  sr: {
    name: 'Serbian',
    nativeName: 'српски језик',
  },
  ss: {
    name: 'Swati',
    nativeName: 'SiSwati',
  },
  st: {
    name: 'Southern Sotho',
    nativeName: 'Sesotho',
  },
  su: {
    name: 'Sundanese',
    nativeName: 'Basa Sunda',
  },
  sv: {
    name: 'Swedish',
    nativeName: 'Svenska',
  },
  sw: {
    name: 'Swahili',
    nativeName: 'Kiswahili',
  },
  ta: {
    name: 'Tamil',
    nativeName: 'தமிழ்',
  },
  te: {
    name: 'Telugu',
    nativeName: 'తెలుగు',
  },
  tg: {
    name: 'Tajik',
    nativeName: 'тоҷикӣ',
  },
  th: {
    name: 'Thai',
    nativeName: 'ไทย',
  },
  ti: {
    name: 'Tigrinya',
    nativeName: 'ትግርኛ',
  },
  tk: {
    name: 'Turkmen',
    nativeName: 'Türkmençe',
  },
  tl: {
    name: 'Tagalog',
    nativeName: 'Wikang Tagalog',
  },
  tn: {
    name: 'Tswana',
    nativeName: 'Setswana',
  },
  to: {
    name: 'Tonga',
    nativeName: 'faka Tonga',
  },
  tr: {
    name: 'Turkish',
    nativeName: 'Türkçe',
  },
  ts: {
    name: 'Tsonga',
    nativeName: 'Xitsonga',
  },
  tt: {
    name: 'Tatar',
    nativeName: 'татар теле',
  },
  tw: {
    name: 'Twi',
    nativeName: 'Twi',
  },
  ty: {
    name: 'Tahitian',
    nativeName: 'Reo Tahiti',
  },
  ug: {
    name: 'Uyghur',
    nativeName: 'ئۇيغۇرچە‎',
  },
  uk: {
    name: 'Ukrainian',
    nativeName: 'Українська',
  },
  ur: {
    name: 'Urdu',
    nativeName: 'اردو',
  },
  uz: {
    name: 'Uzbek',
    nativeName: 'Ўзбек',
  },
  ve: {
    name: 'Venda',
    nativeName: 'Tshivenḓa',
  },
  vi: {
    name: 'Vietnamese',
    nativeName: 'Tiếng Việt',
  },
  vo: {
    name: 'Volapük',
    nativeName: 'Volapük',
  },
  wa: {
    name: 'Walloon',
    nativeName: 'walon',
  },
  wo: {
    name: 'Wolof',
    nativeName: 'Wollof',
  },
  xh: {
    name: 'Xhosa',
    nativeName: 'isiXhosa',
  },
  yi: {
    name: 'Yiddish',
    nativeName: 'ייִדיש',
  },
  yo: {
    name: 'Yoruba',
    nativeName: 'Yorùbá',
  },
  za: {
    name: 'Zhuang',
    nativeName: 'Saɯ cueŋƅ',
  },
  zh: {
    name: 'Chinese',
    nativeName: '中文',
  },
  zu: {
    name: 'Zulu',
    nativeName: 'isiZulu',
  },
};

module.exports = LANGUAGES_LIST;


/***/ }),

/***/ "../../node_modules/iso-639-1/src/index.js":
/*!*************************************************!*\
  !*** ../../node_modules/iso-639-1/src/index.js ***!
  \*************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const LANGUAGES_LIST = __webpack_require__(/*! ./data.js */ "../../node_modules/iso-639-1/src/data.js");

const LANGUAGES = {};
const LANGUAGES_BY_NAME = {};
const LANGUAGE_CODES = [];
const LANGUAGE_NAMES = [];
const LANGUAGE_NATIVE_NAMES = [];

for (const code in LANGUAGES_LIST) {
  const { name, nativeName } = LANGUAGES_LIST[code];
  LANGUAGES[code] =
    LANGUAGES_BY_NAME[name.toLowerCase()] =
    LANGUAGES_BY_NAME[nativeName.toLowerCase()] =
      { code, name, nativeName };
  LANGUAGE_CODES.push(code);
  LANGUAGE_NAMES.push(name);
  LANGUAGE_NATIVE_NAMES.push(nativeName);
}

module.exports = class ISO6391 {
  static getLanguages(codes = []) {
    return codes.map(code =>
      ISO6391.validate(code)
        ? Object.assign({}, LANGUAGES[code])
        : { code, name: '', nativeName: '' }
    );
  }

  static getName(code) {
    return ISO6391.validate(code) ? LANGUAGES_LIST[code].name : '';
  }

  static getAllNames() {
    return LANGUAGE_NAMES.slice();
  }

  static getNativeName(code) {
    return ISO6391.validate(code) ? LANGUAGES_LIST[code].nativeName : '';
  }

  static getAllNativeNames() {
    return LANGUAGE_NATIVE_NAMES.slice();
  }

  static getCode(name) {
    name = name.toLowerCase();
    return LANGUAGES_BY_NAME.hasOwnProperty(name)
      ? LANGUAGES_BY_NAME[name].code
      : '';
  }

  static getAllCodes() {
    return LANGUAGE_CODES.slice();
  }

  static validate(code) {
    return LANGUAGES_LIST.hasOwnProperty(code);
  }
}


/***/ }),

/***/ "../../node_modules/js-cookie/dist/js.cookie.mjs":
/*!*******************************************************!*\
  !*** ../../node_modules/js-cookie/dist/js.cookie.mjs ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ api)
/* harmony export */ });
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */




/***/ }),

/***/ "../../node_modules/lit-element/lib/css-tag.js":
/*!*****************************************************!*\
  !*** ../../node_modules/lit-element/lib/css-tag.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CSSResult: () => (/* binding */ CSSResult),
/* harmony export */   css: () => (/* binding */ css),
/* harmony export */   supportsAdoptingStyleSheets: () => (/* binding */ supportsAdoptingStyleSheets),
/* harmony export */   unsafeCSS: () => (/* binding */ unsafeCSS)
/* harmony export */ });
/**
@license
Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
const supportsAdoptingStyleSheets = ('adoptedStyleSheets' in Document.prototype) &&
    ('replace' in CSSStyleSheet.prototype);
const constructionToken = Symbol();
class CSSResult {
    constructor(cssText, safeToken) {
        if (safeToken !== constructionToken) {
            throw new Error('CSSResult is not constructable. Use `unsafeCSS` or `css` instead.');
        }
        this.cssText = cssText;
    }
    // Note, this is a getter so that it's lazy. In practice, this means
    // stylesheets are not created until the first element instance is made.
    get styleSheet() {
        if (this._styleSheet === undefined) {
            // Note, if `adoptedStyleSheets` is supported then we assume CSSStyleSheet
            // is constructable.
            if (supportsAdoptingStyleSheets) {
                this._styleSheet = new CSSStyleSheet();
                this._styleSheet.replaceSync(this.cssText);
            }
            else {
                this._styleSheet = null;
            }
        }
        return this._styleSheet;
    }
    toString() {
        return this.cssText;
    }
}
/**
 * Wrap a value for interpolation in a css tagged template literal.
 *
 * This is unsafe because untrusted CSS text can be used to phone home
 * or exfiltrate data to an attacker controlled site. Take care to only use
 * this with trusted input.
 */
const unsafeCSS = (value) => {
    return new CSSResult(String(value), constructionToken);
};
const textFromCSSResult = (value) => {
    if (value instanceof CSSResult) {
        return value.cssText;
    }
    else if (typeof value === 'number') {
        return value;
    }
    else {
        throw new Error(`Value passed to 'css' function must be a 'css' function result: ${value}. Use 'unsafeCSS' to pass non-literal values, but
            take care to ensure page security.`);
    }
};
/**
 * Template tag which which can be used with LitElement's `style` property to
 * set element styles. For security reasons, only literal string values may be
 * used. To incorporate non-literal values `unsafeCSS` may be used inside a
 * template string part.
 */
const css = (strings, ...values) => {
    const cssText = values.reduce((acc, v, idx) => acc + textFromCSSResult(v) + strings[idx + 1], strings[0]);
    return new CSSResult(cssText, constructionToken);
};
//# sourceMappingURL=css-tag.js.map

/***/ }),

/***/ "../../node_modules/lit-element/lib/decorators.js":
/*!********************************************************!*\
  !*** ../../node_modules/lit-element/lib/decorators.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   customElement: () => (/* binding */ customElement),
/* harmony export */   eventOptions: () => (/* binding */ eventOptions),
/* harmony export */   internalProperty: () => (/* binding */ internalProperty),
/* harmony export */   property: () => (/* binding */ property),
/* harmony export */   query: () => (/* binding */ query),
/* harmony export */   queryAll: () => (/* binding */ queryAll),
/* harmony export */   queryAssignedNodes: () => (/* binding */ queryAssignedNodes),
/* harmony export */   queryAsync: () => (/* binding */ queryAsync)
/* harmony export */ });
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const legacyCustomElement = (tagName, clazz) => {
    window.customElements.define(tagName, clazz);
    // Cast as any because TS doesn't recognize the return type as being a
    // subtype of the decorated class when clazz is typed as
    // `Constructor<HTMLElement>` for some reason.
    // `Constructor<HTMLElement>` is helpful to make sure the decorator is
    // applied to elements however.
    // tslint:disable-next-line:no-any
    return clazz;
};
const standardCustomElement = (tagName, descriptor) => {
    const { kind, elements } = descriptor;
    return {
        kind,
        elements,
        // This callback is called once the class is otherwise fully defined
        finisher(clazz) {
            window.customElements.define(tagName, clazz);
        }
    };
};
/**
 * Class decorator factory that defines the decorated class as a custom element.
 *
 * ```
 * @customElement('my-element')
 * class MyElement {
 *   render() {
 *     return html``;
 *   }
 * }
 * ```
 *
 * @param tagName The name of the custom element to define.
 */
const customElement = (tagName) => (classOrDescriptor) => (typeof classOrDescriptor === 'function') ?
    legacyCustomElement(tagName, classOrDescriptor) :
    standardCustomElement(tagName, classOrDescriptor);
const standardProperty = (options, element) => {
    // When decorating an accessor, pass it through and add property metadata.
    // Note, the `hasOwnProperty` check in `createProperty` ensures we don't
    // stomp over the user's accessor.
    if (element.kind === 'method' && element.descriptor &&
        !('value' in element.descriptor)) {
        return Object.assign(Object.assign({}, element), { finisher(clazz) {
                clazz.createProperty(element.key, options);
            } });
    }
    else {
        // createProperty() takes care of defining the property, but we still
        // must return some kind of descriptor, so return a descriptor for an
        // unused prototype field. The finisher calls createProperty().
        return {
            kind: 'field',
            key: Symbol(),
            placement: 'own',
            descriptor: {},
            // When @babel/plugin-proposal-decorators implements initializers,
            // do this instead of the initializer below. See:
            // https://github.com/babel/babel/issues/9260 extras: [
            //   {
            //     kind: 'initializer',
            //     placement: 'own',
            //     initializer: descriptor.initializer,
            //   }
            // ],
            initializer() {
                if (typeof element.initializer === 'function') {
                    this[element.key] = element.initializer.call(this);
                }
            },
            finisher(clazz) {
                clazz.createProperty(element.key, options);
            }
        };
    }
};
const legacyProperty = (options, proto, name) => {
    proto.constructor
        .createProperty(name, options);
};
/**
 * A property decorator which creates a LitElement property which reflects a
 * corresponding attribute value. A `PropertyDeclaration` may optionally be
 * supplied to configure property features.
 *
 * This decorator should only be used for public fields. Private or protected
 * fields should use the internalProperty decorator.
 *
 * @example
 *
 *     class MyElement {
 *       @property({ type: Boolean })
 *       clicked = false;
 *     }
 *
 * @ExportDecoratedItems
 */
function property(options) {
    // tslint:disable-next-line:no-any decorator
    return (protoOrDescriptor, name) => (name !== undefined) ?
        legacyProperty(options, protoOrDescriptor, name) :
        standardProperty(options, protoOrDescriptor);
}
/**
 * Declares a private or protected property that still triggers updates to the
 * element when it changes.
 *
 * Properties declared this way must not be used from HTML or HTML templating
 * systems, they're solely for properties internal to the element. These
 * properties may be renamed by optimization tools like closure compiler.
 */
function internalProperty(options) {
    return property({ attribute: false, hasChanged: options === null || options === void 0 ? void 0 : options.hasChanged });
}
/**
 * A property decorator that converts a class property into a getter that
 * executes a querySelector on the element's renderRoot.
 *
 * @param selector A DOMString containing one or more selectors to match.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector
 *
 * @example
 *
 *     class MyElement {
 *       @query('#first')
 *       first;
 *
 *       render() {
 *         return html`
 *           <div id="first"></div>
 *           <div id="second"></div>
 *         `;
 *       }
 *     }
 *
 */
function query(selector) {
    return (protoOrDescriptor, 
    // tslint:disable-next-line:no-any decorator
    name) => {
        const descriptor = {
            get() {
                return this.renderRoot.querySelector(selector);
            },
            enumerable: true,
            configurable: true,
        };
        return (name !== undefined) ?
            legacyQuery(descriptor, protoOrDescriptor, name) :
            standardQuery(descriptor, protoOrDescriptor);
    };
}
// Note, in the future, we may extend this decorator to support the use case
// where the queried element may need to do work to become ready to interact
// with (e.g. load some implementation code). If so, we might elect to
// add a second argument defining a function that can be run to make the
// queried element loaded/updated/ready.
/**
 * A property decorator that converts a class property into a getter that
 * returns a promise that resolves to the result of a querySelector on the
 * element's renderRoot done after the element's `updateComplete` promise
 * resolves. When the queried property may change with element state, this
 * decorator can be used instead of requiring users to await the
 * `updateComplete` before accessing the property.
 *
 * @param selector A DOMString containing one or more selectors to match.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector
 *
 * @example
 *
 *     class MyElement {
 *       @queryAsync('#first')
 *       first;
 *
 *       render() {
 *         return html`
 *           <div id="first"></div>
 *           <div id="second"></div>
 *         `;
 *       }
 *     }
 *
 *     // external usage
 *     async doSomethingWithFirst() {
 *      (await aMyElement.first).doSomething();
 *     }
 */
function queryAsync(selector) {
    return (protoOrDescriptor, 
    // tslint:disable-next-line:no-any decorator
    name) => {
        const descriptor = {
            async get() {
                await this.updateComplete;
                return this.renderRoot.querySelector(selector);
            },
            enumerable: true,
            configurable: true,
        };
        return (name !== undefined) ?
            legacyQuery(descriptor, protoOrDescriptor, name) :
            standardQuery(descriptor, protoOrDescriptor);
    };
}
/**
 * A property decorator that converts a class property into a getter
 * that executes a querySelectorAll on the element's renderRoot.
 *
 * @param selector A DOMString containing one or more selectors to match.
 *
 * See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelectorAll
 *
 * @example
 *
 *     class MyElement {
 *       @queryAll('div')
 *       divs;
 *
 *       render() {
 *         return html`
 *           <div id="first"></div>
 *           <div id="second"></div>
 *         `;
 *       }
 *     }
 */
function queryAll(selector) {
    return (protoOrDescriptor, 
    // tslint:disable-next-line:no-any decorator
    name) => {
        const descriptor = {
            get() {
                return this.renderRoot.querySelectorAll(selector);
            },
            enumerable: true,
            configurable: true,
        };
        return (name !== undefined) ?
            legacyQuery(descriptor, protoOrDescriptor, name) :
            standardQuery(descriptor, protoOrDescriptor);
    };
}
const legacyQuery = (descriptor, proto, name) => {
    Object.defineProperty(proto, name, descriptor);
};
const standardQuery = (descriptor, element) => ({
    kind: 'method',
    placement: 'prototype',
    key: element.key,
    descriptor,
});
const standardEventOptions = (options, element) => {
    return Object.assign(Object.assign({}, element), { finisher(clazz) {
            Object.assign(clazz.prototype[element.key], options);
        } });
};
const legacyEventOptions = 
// tslint:disable-next-line:no-any legacy decorator
(options, proto, name) => {
    Object.assign(proto[name], options);
};
/**
 * Adds event listener options to a method used as an event listener in a
 * lit-html template.
 *
 * @param options An object that specifies event listener options as accepted by
 * `EventTarget#addEventListener` and `EventTarget#removeEventListener`.
 *
 * Current browsers support the `capture`, `passive`, and `once` options. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Parameters
 *
 * @example
 *
 *     class MyElement {
 *       clicked = false;
 *
 *       render() {
 *         return html`
 *           <div @click=${this._onClick}`>
 *             <button></button>
 *           </div>
 *         `;
 *       }
 *
 *       @eventOptions({capture: true})
 *       _onClick(e) {
 *         this.clicked = true;
 *       }
 *     }
 */
function eventOptions(options) {
    // Return value typed as any to prevent TypeScript from complaining that
    // standard decorator function signature does not match TypeScript decorator
    // signature
    // TODO(kschaaf): unclear why it was only failing on this decorator and not
    // the others
    return ((protoOrDescriptor, name) => (name !== undefined) ?
        legacyEventOptions(options, protoOrDescriptor, name) :
        standardEventOptions(options, protoOrDescriptor));
}
/**
 * A property decorator that converts a class property into a getter that
 * returns the `assignedNodes` of the given named `slot`. Note, the type of
 * this property should be annotated as `NodeListOf<HTMLElement>`.
 *
 */
function queryAssignedNodes(slotName = '', flatten = false) {
    return (protoOrDescriptor, 
    // tslint:disable-next-line:no-any decorator
    name) => {
        const descriptor = {
            get() {
                const selector = `slot${slotName ? `[name=${slotName}]` : ''}`;
                const slot = this.renderRoot.querySelector(selector);
                return slot && slot.assignedNodes({ flatten });
            },
            enumerable: true,
            configurable: true,
        };
        return (name !== undefined) ?
            legacyQuery(descriptor, protoOrDescriptor, name) :
            standardQuery(descriptor, protoOrDescriptor);
    };
}
//# sourceMappingURL=decorators.js.map

/***/ }),

/***/ "../../node_modules/lit-element/lib/updating-element.js":
/*!**************************************************************!*\
  !*** ../../node_modules/lit-element/lib/updating-element.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UpdatingElement: () => (/* binding */ UpdatingElement),
/* harmony export */   defaultConverter: () => (/* binding */ defaultConverter),
/* harmony export */   notEqual: () => (/* binding */ notEqual)
/* harmony export */ });
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
var _a;
/**
 * When using Closure Compiler, JSCompiler_renameProperty(property, object) is
 * replaced at compile time by the munged name for object[property]. We cannot
 * alias this function, so we have to use a small shim that has the same
 * behavior when not compiling.
 */
window.JSCompiler_renameProperty =
    (prop, _obj) => prop;
const defaultConverter = {
    toAttribute(value, type) {
        switch (type) {
            case Boolean:
                return value ? '' : null;
            case Object:
            case Array:
                // if the value is `null` or `undefined` pass this through
                // to allow removing/no change behavior.
                return value == null ? value : JSON.stringify(value);
        }
        return value;
    },
    fromAttribute(value, type) {
        switch (type) {
            case Boolean:
                return value !== null;
            case Number:
                return value === null ? null : Number(value);
            case Object:
            case Array:
                return JSON.parse(value);
        }
        return value;
    }
};
/**
 * Change function that returns true if `value` is different from `oldValue`.
 * This method is used as the default for a property's `hasChanged` function.
 */
const notEqual = (value, old) => {
    // This ensures (old==NaN, value==NaN) always returns false
    return old !== value && (old === old || value === value);
};
const defaultPropertyDeclaration = {
    attribute: true,
    type: String,
    converter: defaultConverter,
    reflect: false,
    hasChanged: notEqual
};
const STATE_HAS_UPDATED = 1;
const STATE_UPDATE_REQUESTED = 1 << 2;
const STATE_IS_REFLECTING_TO_ATTRIBUTE = 1 << 3;
const STATE_IS_REFLECTING_TO_PROPERTY = 1 << 4;
/**
 * The Closure JS Compiler doesn't currently have good support for static
 * property semantics where "this" is dynamic (e.g.
 * https://github.com/google/closure-compiler/issues/3177 and others) so we use
 * this hack to bypass any rewriting by the compiler.
 */
const finalized = 'finalized';
/**
 * Base element class which manages element properties and attributes. When
 * properties change, the `update` method is asynchronously called. This method
 * should be supplied by subclassers to render updates as desired.
 */
class UpdatingElement extends HTMLElement {
    constructor() {
        super();
        this._updateState = 0;
        this._instanceProperties = undefined;
        // Initialize to an unresolved Promise so we can make sure the element has
        // connected before first update.
        this._updatePromise = new Promise((res) => this._enableUpdatingResolver = res);
        /**
         * Map with keys for any properties that have changed since the last
         * update cycle with previous values.
         */
        this._changedProperties = new Map();
        /**
         * Map with keys of properties that should be reflected when updated.
         */
        this._reflectingProperties = undefined;
        this.initialize();
    }
    /**
     * Returns a list of attributes corresponding to the registered properties.
     * @nocollapse
     */
    static get observedAttributes() {
        // note: piggy backing on this to ensure we're finalized.
        this.finalize();
        const attributes = [];
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        this._classProperties.forEach((v, p) => {
            const attr = this._attributeNameForProperty(p, v);
            if (attr !== undefined) {
                this._attributeToPropertyMap.set(attr, p);
                attributes.push(attr);
            }
        });
        return attributes;
    }
    /**
     * Ensures the private `_classProperties` property metadata is created.
     * In addition to `finalize` this is also called in `createProperty` to
     * ensure the `@property` decorator can add property metadata.
     */
    /** @nocollapse */
    static _ensureClassProperties() {
        // ensure private storage for property declarations.
        if (!this.hasOwnProperty(JSCompiler_renameProperty('_classProperties', this))) {
            this._classProperties = new Map();
            // NOTE: Workaround IE11 not supporting Map constructor argument.
            const superProperties = Object.getPrototypeOf(this)._classProperties;
            if (superProperties !== undefined) {
                superProperties.forEach((v, k) => this._classProperties.set(k, v));
            }
        }
    }
    /**
     * Creates a property accessor on the element prototype if one does not exist
     * and stores a PropertyDeclaration for the property with the given options.
     * The property setter calls the property's `hasChanged` property option
     * or uses a strict identity check to determine whether or not to request
     * an update.
     *
     * This method may be overridden to customize properties; however,
     * when doing so, it's important to call `super.createProperty` to ensure
     * the property is setup correctly. This method calls
     * `getPropertyDescriptor` internally to get a descriptor to install.
     * To customize what properties do when they are get or set, override
     * `getPropertyDescriptor`. To customize the options for a property,
     * implement `createProperty` like this:
     *
     * static createProperty(name, options) {
     *   options = Object.assign(options, {myOption: true});
     *   super.createProperty(name, options);
     * }
     *
     * @nocollapse
     */
    static createProperty(name, options = defaultPropertyDeclaration) {
        // Note, since this can be called by the `@property` decorator which
        // is called before `finalize`, we ensure storage exists for property
        // metadata.
        this._ensureClassProperties();
        this._classProperties.set(name, options);
        // Do not generate an accessor if the prototype already has one, since
        // it would be lost otherwise and that would never be the user's intention;
        // Instead, we expect users to call `requestUpdate` themselves from
        // user-defined accessors. Note that if the super has an accessor we will
        // still overwrite it
        if (options.noAccessor || this.prototype.hasOwnProperty(name)) {
            return;
        }
        const key = typeof name === 'symbol' ? Symbol() : `__${name}`;
        const descriptor = this.getPropertyDescriptor(name, key, options);
        if (descriptor !== undefined) {
            Object.defineProperty(this.prototype, name, descriptor);
        }
    }
    /**
     * Returns a property descriptor to be defined on the given named property.
     * If no descriptor is returned, the property will not become an accessor.
     * For example,
     *
     *   class MyElement extends LitElement {
     *     static getPropertyDescriptor(name, key, options) {
     *       const defaultDescriptor =
     *           super.getPropertyDescriptor(name, key, options);
     *       const setter = defaultDescriptor.set;
     *       return {
     *         get: defaultDescriptor.get,
     *         set(value) {
     *           setter.call(this, value);
     *           // custom action.
     *         },
     *         configurable: true,
     *         enumerable: true
     *       }
     *     }
     *   }
     *
     * @nocollapse
     */
    static getPropertyDescriptor(name, key, _options) {
        return {
            // tslint:disable-next-line:no-any no symbol in index
            get() {
                return this[key];
            },
            set(value) {
                const oldValue = this[name];
                this[key] = value;
                this._requestUpdate(name, oldValue);
            },
            configurable: true,
            enumerable: true
        };
    }
    /**
     * Returns the property options associated with the given property.
     * These options are defined with a PropertyDeclaration via the `properties`
     * object or the `@property` decorator and are registered in
     * `createProperty(...)`.
     *
     * Note, this method should be considered "final" and not overridden. To
     * customize the options for a given property, override `createProperty`.
     *
     * @nocollapse
     * @final
     */
    static getPropertyOptions(name) {
        return this._classProperties && this._classProperties.get(name) ||
            defaultPropertyDeclaration;
    }
    /**
     * Creates property accessors for registered properties and ensures
     * any superclasses are also finalized.
     * @nocollapse
     */
    static finalize() {
        // finalize any superclasses
        const superCtor = Object.getPrototypeOf(this);
        if (!superCtor.hasOwnProperty(finalized)) {
            superCtor.finalize();
        }
        this[finalized] = true;
        this._ensureClassProperties();
        // initialize Map populated in observedAttributes
        this._attributeToPropertyMap = new Map();
        // make any properties
        // Note, only process "own" properties since this element will inherit
        // any properties defined on the superClass, and finalization ensures
        // the entire prototype chain is finalized.
        if (this.hasOwnProperty(JSCompiler_renameProperty('properties', this))) {
            const props = this.properties;
            // support symbols in properties (IE11 does not support this)
            const propKeys = [
                ...Object.getOwnPropertyNames(props),
                ...(typeof Object.getOwnPropertySymbols === 'function') ?
                    Object.getOwnPropertySymbols(props) :
                    []
            ];
            // This for/of is ok because propKeys is an array
            for (const p of propKeys) {
                // note, use of `any` is due to TypeSript lack of support for symbol in
                // index types
                // tslint:disable-next-line:no-any no symbol in index
                this.createProperty(p, props[p]);
            }
        }
    }
    /**
     * Returns the property name for the given attribute `name`.
     * @nocollapse
     */
    static _attributeNameForProperty(name, options) {
        const attribute = options.attribute;
        return attribute === false ?
            undefined :
            (typeof attribute === 'string' ?
                attribute :
                (typeof name === 'string' ? name.toLowerCase() : undefined));
    }
    /**
     * Returns true if a property should request an update.
     * Called when a property value is set and uses the `hasChanged`
     * option for the property if present or a strict identity check.
     * @nocollapse
     */
    static _valueHasChanged(value, old, hasChanged = notEqual) {
        return hasChanged(value, old);
    }
    /**
     * Returns the property value for the given attribute value.
     * Called via the `attributeChangedCallback` and uses the property's
     * `converter` or `converter.fromAttribute` property option.
     * @nocollapse
     */
    static _propertyValueFromAttribute(value, options) {
        const type = options.type;
        const converter = options.converter || defaultConverter;
        const fromAttribute = (typeof converter === 'function' ? converter : converter.fromAttribute);
        return fromAttribute ? fromAttribute(value, type) : value;
    }
    /**
     * Returns the attribute value for the given property value. If this
     * returns undefined, the property will *not* be reflected to an attribute.
     * If this returns null, the attribute will be removed, otherwise the
     * attribute will be set to the value.
     * This uses the property's `reflect` and `type.toAttribute` property options.
     * @nocollapse
     */
    static _propertyValueToAttribute(value, options) {
        if (options.reflect === undefined) {
            return;
        }
        const type = options.type;
        const converter = options.converter;
        const toAttribute = converter && converter.toAttribute ||
            defaultConverter.toAttribute;
        return toAttribute(value, type);
    }
    /**
     * Performs element initialization. By default captures any pre-set values for
     * registered properties.
     */
    initialize() {
        this._saveInstanceProperties();
        // ensures first update will be caught by an early access of
        // `updateComplete`
        this._requestUpdate();
    }
    /**
     * Fixes any properties set on the instance before upgrade time.
     * Otherwise these would shadow the accessor and break these properties.
     * The properties are stored in a Map which is played back after the
     * constructor runs. Note, on very old versions of Safari (<=9) or Chrome
     * (<=41), properties created for native platform properties like (`id` or
     * `name`) may not have default values set in the element constructor. On
     * these browsers native properties appear on instances and therefore their
     * default value will overwrite any element default (e.g. if the element sets
     * this.id = 'id' in the constructor, the 'id' will become '' since this is
     * the native platform default).
     */
    _saveInstanceProperties() {
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        this.constructor
            ._classProperties.forEach((_v, p) => {
            if (this.hasOwnProperty(p)) {
                const value = this[p];
                delete this[p];
                if (!this._instanceProperties) {
                    this._instanceProperties = new Map();
                }
                this._instanceProperties.set(p, value);
            }
        });
    }
    /**
     * Applies previously saved instance properties.
     */
    _applyInstanceProperties() {
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        // tslint:disable-next-line:no-any
        this._instanceProperties.forEach((v, p) => this[p] = v);
        this._instanceProperties = undefined;
    }
    connectedCallback() {
        // Ensure first connection completes an update. Updates cannot complete
        // before connection.
        this.enableUpdating();
    }
    enableUpdating() {
        if (this._enableUpdatingResolver !== undefined) {
            this._enableUpdatingResolver();
            this._enableUpdatingResolver = undefined;
        }
    }
    /**
     * Allows for `super.disconnectedCallback()` in extensions while
     * reserving the possibility of making non-breaking feature additions
     * when disconnecting at some point in the future.
     */
    disconnectedCallback() {
    }
    /**
     * Synchronizes property values when attributes change.
     */
    attributeChangedCallback(name, old, value) {
        if (old !== value) {
            this._attributeToProperty(name, value);
        }
    }
    _propertyToAttribute(name, value, options = defaultPropertyDeclaration) {
        const ctor = this.constructor;
        const attr = ctor._attributeNameForProperty(name, options);
        if (attr !== undefined) {
            const attrValue = ctor._propertyValueToAttribute(value, options);
            // an undefined value does not change the attribute.
            if (attrValue === undefined) {
                return;
            }
            // Track if the property is being reflected to avoid
            // setting the property again via `attributeChangedCallback`. Note:
            // 1. this takes advantage of the fact that the callback is synchronous.
            // 2. will behave incorrectly if multiple attributes are in the reaction
            // stack at time of calling. However, since we process attributes
            // in `update` this should not be possible (or an extreme corner case
            // that we'd like to discover).
            // mark state reflecting
            this._updateState = this._updateState | STATE_IS_REFLECTING_TO_ATTRIBUTE;
            if (attrValue == null) {
                this.removeAttribute(attr);
            }
            else {
                this.setAttribute(attr, attrValue);
            }
            // mark state not reflecting
            this._updateState = this._updateState & ~STATE_IS_REFLECTING_TO_ATTRIBUTE;
        }
    }
    _attributeToProperty(name, value) {
        // Use tracking info to avoid deserializing attribute value if it was
        // just set from a property setter.
        if (this._updateState & STATE_IS_REFLECTING_TO_ATTRIBUTE) {
            return;
        }
        const ctor = this.constructor;
        // Note, hint this as an `AttributeMap` so closure clearly understands
        // the type; it has issues with tracking types through statics
        // tslint:disable-next-line:no-unnecessary-type-assertion
        const propName = ctor._attributeToPropertyMap.get(name);
        if (propName !== undefined) {
            const options = ctor.getPropertyOptions(propName);
            // mark state reflecting
            this._updateState = this._updateState | STATE_IS_REFLECTING_TO_PROPERTY;
            this[propName] =
                // tslint:disable-next-line:no-any
                ctor._propertyValueFromAttribute(value, options);
            // mark state not reflecting
            this._updateState = this._updateState & ~STATE_IS_REFLECTING_TO_PROPERTY;
        }
    }
    /**
     * This private version of `requestUpdate` does not access or return the
     * `updateComplete` promise. This promise can be overridden and is therefore
     * not free to access.
     */
    _requestUpdate(name, oldValue) {
        let shouldRequestUpdate = true;
        // If we have a property key, perform property update steps.
        if (name !== undefined) {
            const ctor = this.constructor;
            const options = ctor.getPropertyOptions(name);
            if (ctor._valueHasChanged(this[name], oldValue, options.hasChanged)) {
                if (!this._changedProperties.has(name)) {
                    this._changedProperties.set(name, oldValue);
                }
                // Add to reflecting properties set.
                // Note, it's important that every change has a chance to add the
                // property to `_reflectingProperties`. This ensures setting
                // attribute + property reflects correctly.
                if (options.reflect === true &&
                    !(this._updateState & STATE_IS_REFLECTING_TO_PROPERTY)) {
                    if (this._reflectingProperties === undefined) {
                        this._reflectingProperties = new Map();
                    }
                    this._reflectingProperties.set(name, options);
                }
            }
            else {
                // Abort the request if the property should not be considered changed.
                shouldRequestUpdate = false;
            }
        }
        if (!this._hasRequestedUpdate && shouldRequestUpdate) {
            this._updatePromise = this._enqueueUpdate();
        }
    }
    /**
     * Requests an update which is processed asynchronously. This should
     * be called when an element should update based on some state not triggered
     * by setting a property. In this case, pass no arguments. It should also be
     * called when manually implementing a property setter. In this case, pass the
     * property `name` and `oldValue` to ensure that any configured property
     * options are honored. Returns the `updateComplete` Promise which is resolved
     * when the update completes.
     *
     * @param name {PropertyKey} (optional) name of requesting property
     * @param oldValue {any} (optional) old value of requesting property
     * @returns {Promise} A Promise that is resolved when the update completes.
     */
    requestUpdate(name, oldValue) {
        this._requestUpdate(name, oldValue);
        return this.updateComplete;
    }
    /**
     * Sets up the element to asynchronously update.
     */
    async _enqueueUpdate() {
        this._updateState = this._updateState | STATE_UPDATE_REQUESTED;
        try {
            // Ensure any previous update has resolved before updating.
            // This `await` also ensures that property changes are batched.
            await this._updatePromise;
        }
        catch (e) {
            // Ignore any previous errors. We only care that the previous cycle is
            // done. Any error should have been handled in the previous update.
        }
        const result = this.performUpdate();
        // If `performUpdate` returns a Promise, we await it. This is done to
        // enable coordinating updates with a scheduler. Note, the result is
        // checked to avoid delaying an additional microtask unless we need to.
        if (result != null) {
            await result;
        }
        return !this._hasRequestedUpdate;
    }
    get _hasRequestedUpdate() {
        return (this._updateState & STATE_UPDATE_REQUESTED);
    }
    get hasUpdated() {
        return (this._updateState & STATE_HAS_UPDATED);
    }
    /**
     * Performs an element update. Note, if an exception is thrown during the
     * update, `firstUpdated` and `updated` will not be called.
     *
     * You can override this method to change the timing of updates. If this
     * method is overridden, `super.performUpdate()` must be called.
     *
     * For instance, to schedule updates to occur just before the next frame:
     *
     * ```
     * protected async performUpdate(): Promise<unknown> {
     *   await new Promise((resolve) => requestAnimationFrame(() => resolve()));
     *   super.performUpdate();
     * }
     * ```
     */
    performUpdate() {
        // Mixin instance properties once, if they exist.
        if (this._instanceProperties) {
            this._applyInstanceProperties();
        }
        let shouldUpdate = false;
        const changedProperties = this._changedProperties;
        try {
            shouldUpdate = this.shouldUpdate(changedProperties);
            if (shouldUpdate) {
                this.update(changedProperties);
            }
            else {
                this._markUpdated();
            }
        }
        catch (e) {
            // Prevent `firstUpdated` and `updated` from running when there's an
            // update exception.
            shouldUpdate = false;
            // Ensure element can accept additional updates after an exception.
            this._markUpdated();
            throw e;
        }
        if (shouldUpdate) {
            if (!(this._updateState & STATE_HAS_UPDATED)) {
                this._updateState = this._updateState | STATE_HAS_UPDATED;
                this.firstUpdated(changedProperties);
            }
            this.updated(changedProperties);
        }
    }
    _markUpdated() {
        this._changedProperties = new Map();
        this._updateState = this._updateState & ~STATE_UPDATE_REQUESTED;
    }
    /**
     * Returns a Promise that resolves when the element has completed updating.
     * The Promise value is a boolean that is `true` if the element completed the
     * update without triggering another update. The Promise result is `false` if
     * a property was set inside `updated()`. If the Promise is rejected, an
     * exception was thrown during the update.
     *
     * To await additional asynchronous work, override the `_getUpdateComplete`
     * method. For example, it is sometimes useful to await a rendered element
     * before fulfilling this Promise. To do this, first await
     * `super._getUpdateComplete()`, then any subsequent state.
     *
     * @returns {Promise} The Promise returns a boolean that indicates if the
     * update resolved without triggering another update.
     */
    get updateComplete() {
        return this._getUpdateComplete();
    }
    /**
     * Override point for the `updateComplete` promise.
     *
     * It is not safe to override the `updateComplete` getter directly due to a
     * limitation in TypeScript which means it is not possible to call a
     * superclass getter (e.g. `super.updateComplete.then(...)`) when the target
     * language is ES5 (https://github.com/microsoft/TypeScript/issues/338).
     * This method should be overridden instead. For example:
     *
     *   class MyElement extends LitElement {
     *     async _getUpdateComplete() {
     *       await super._getUpdateComplete();
     *       await this._myChild.updateComplete;
     *     }
     *   }
     */
    _getUpdateComplete() {
        return this._updatePromise;
    }
    /**
     * Controls whether or not `update` should be called when the element requests
     * an update. By default, this method always returns `true`, but this can be
     * customized to control when to update.
     *
     * @param _changedProperties Map of changed properties with old values
     */
    shouldUpdate(_changedProperties) {
        return true;
    }
    /**
     * Updates the element. This method reflects property values to attributes.
     * It can be overridden to render and keep updated element DOM.
     * Setting properties inside this method will *not* trigger
     * another update.
     *
     * @param _changedProperties Map of changed properties with old values
     */
    update(_changedProperties) {
        if (this._reflectingProperties !== undefined &&
            this._reflectingProperties.size > 0) {
            // Use forEach so this works even if for/of loops are compiled to for
            // loops expecting arrays
            this._reflectingProperties.forEach((v, k) => this._propertyToAttribute(k, this[k], v));
            this._reflectingProperties = undefined;
        }
        this._markUpdated();
    }
    /**
     * Invoked whenever the element is updated. Implement to perform
     * post-updating tasks via DOM APIs, for example, focusing an element.
     *
     * Setting properties inside this method will trigger the element to update
     * again after this update cycle completes.
     *
     * @param _changedProperties Map of changed properties with old values
     */
    updated(_changedProperties) {
    }
    /**
     * Invoked when the element is first updated. Implement to perform one time
     * work on the element after update.
     *
     * Setting properties inside this method will trigger the element to update
     * again after this update cycle completes.
     *
     * @param _changedProperties Map of changed properties with old values
     */
    firstUpdated(_changedProperties) {
    }
}
_a = finalized;
/**
 * Marks class as having finished creating properties.
 */
UpdatingElement[_a] = true;
//# sourceMappingURL=updating-element.js.map

/***/ }),

/***/ "../../node_modules/lit-element/lit-element.js":
/*!*****************************************************!*\
  !*** ../../node_modules/lit-element/lit-element.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CSSResult: () => (/* reexport safe */ _lib_css_tag_js__WEBPACK_IMPORTED_MODULE_4__.CSSResult),
/* harmony export */   LitElement: () => (/* binding */ LitElement),
/* harmony export */   SVGTemplateResult: () => (/* reexport safe */ lit_html_lit_html_js__WEBPACK_IMPORTED_MODULE_3__.SVGTemplateResult),
/* harmony export */   TemplateResult: () => (/* reexport safe */ lit_html_lit_html_js__WEBPACK_IMPORTED_MODULE_3__.TemplateResult),
/* harmony export */   UpdatingElement: () => (/* reexport safe */ _lib_updating_element_js__WEBPACK_IMPORTED_MODULE_1__.UpdatingElement),
/* harmony export */   css: () => (/* reexport safe */ _lib_css_tag_js__WEBPACK_IMPORTED_MODULE_4__.css),
/* harmony export */   customElement: () => (/* reexport safe */ _lib_decorators_js__WEBPACK_IMPORTED_MODULE_2__.customElement),
/* harmony export */   defaultConverter: () => (/* reexport safe */ _lib_updating_element_js__WEBPACK_IMPORTED_MODULE_1__.defaultConverter),
/* harmony export */   eventOptions: () => (/* reexport safe */ _lib_decorators_js__WEBPACK_IMPORTED_MODULE_2__.eventOptions),
/* harmony export */   html: () => (/* reexport safe */ lit_html_lit_html_js__WEBPACK_IMPORTED_MODULE_3__.html),
/* harmony export */   internalProperty: () => (/* reexport safe */ _lib_decorators_js__WEBPACK_IMPORTED_MODULE_2__.internalProperty),
/* harmony export */   notEqual: () => (/* reexport safe */ _lib_updating_element_js__WEBPACK_IMPORTED_MODULE_1__.notEqual),
/* harmony export */   property: () => (/* reexport safe */ _lib_decorators_js__WEBPACK_IMPORTED_MODULE_2__.property),
/* harmony export */   query: () => (/* reexport safe */ _lib_decorators_js__WEBPACK_IMPORTED_MODULE_2__.query),
/* harmony export */   queryAll: () => (/* reexport safe */ _lib_decorators_js__WEBPACK_IMPORTED_MODULE_2__.queryAll),
/* harmony export */   queryAssignedNodes: () => (/* reexport safe */ _lib_decorators_js__WEBPACK_IMPORTED_MODULE_2__.queryAssignedNodes),
/* harmony export */   queryAsync: () => (/* reexport safe */ _lib_decorators_js__WEBPACK_IMPORTED_MODULE_2__.queryAsync),
/* harmony export */   supportsAdoptingStyleSheets: () => (/* reexport safe */ _lib_css_tag_js__WEBPACK_IMPORTED_MODULE_4__.supportsAdoptingStyleSheets),
/* harmony export */   svg: () => (/* reexport safe */ lit_html_lit_html_js__WEBPACK_IMPORTED_MODULE_3__.svg),
/* harmony export */   unsafeCSS: () => (/* reexport safe */ _lib_css_tag_js__WEBPACK_IMPORTED_MODULE_4__.unsafeCSS)
/* harmony export */ });
/* harmony import */ var lit_html_lib_shady_render_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-html/lib/shady-render.js */ "../../node_modules/lit-html/lib/shady-render.js");
/* harmony import */ var _lib_updating_element_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./lib/updating-element.js */ "../../node_modules/lit-element/lib/updating-element.js");
/* harmony import */ var _lib_decorators_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./lib/decorators.js */ "../../node_modules/lit-element/lib/decorators.js");
/* harmony import */ var lit_html_lit_html_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/lit-html.js */ "../../node_modules/lit-html/lit-html.js");
/* harmony import */ var _lib_css_tag_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./lib/css-tag.js */ "../../node_modules/lit-element/lib/css-tag.js");
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */







// IMPORTANT: do not change the property name or the assignment expression.
// This line will be used in regexes to search for LitElement usage.
// TODO(justinfagnani): inject version number at build time
(window['litElementVersions'] || (window['litElementVersions'] = []))
    .push('2.3.1');
/**
 * Sentinal value used to avoid calling lit-html's render function when
 * subclasses do not implement `render`
 */
const renderNotImplemented = {};
class LitElement extends _lib_updating_element_js__WEBPACK_IMPORTED_MODULE_1__.UpdatingElement {
    /**
     * Return the array of styles to apply to the element.
     * Override this method to integrate into a style management system.
     *
     * @nocollapse
     */
    static getStyles() {
        return this.styles;
    }
    /** @nocollapse */
    static _getUniqueStyles() {
        // Only gather styles once per class
        if (this.hasOwnProperty(JSCompiler_renameProperty('_styles', this))) {
            return;
        }
        // Take care not to call `this.getStyles()` multiple times since this
        // generates new CSSResults each time.
        // TODO(sorvell): Since we do not cache CSSResults by input, any
        // shared styles will generate new stylesheet objects, which is wasteful.
        // This should be addressed when a browser ships constructable
        // stylesheets.
        const userStyles = this.getStyles();
        if (userStyles === undefined) {
            this._styles = [];
        }
        else if (Array.isArray(userStyles)) {
            // De-duplicate styles preserving the _last_ instance in the set.
            // This is a performance optimization to avoid duplicated styles that can
            // occur especially when composing via subclassing.
            // The last item is kept to try to preserve the cascade order with the
            // assumption that it's most important that last added styles override
            // previous styles.
            const addStyles = (styles, set) => styles.reduceRight((set, s) => 
            // Note: On IE set.add() does not return the set
            Array.isArray(s) ? addStyles(s, set) : (set.add(s), set), set);
            // Array.from does not work on Set in IE, otherwise return
            // Array.from(addStyles(userStyles, new Set<CSSResult>())).reverse()
            const set = addStyles(userStyles, new Set());
            const styles = [];
            set.forEach((v) => styles.unshift(v));
            this._styles = styles;
        }
        else {
            this._styles = [userStyles];
        }
    }
    /**
     * Performs element initialization. By default this calls `createRenderRoot`
     * to create the element `renderRoot` node and captures any pre-set values for
     * registered properties.
     */
    initialize() {
        super.initialize();
        this.constructor._getUniqueStyles();
        this.renderRoot =
            this.createRenderRoot();
        // Note, if renderRoot is not a shadowRoot, styles would/could apply to the
        // element's getRootNode(). While this could be done, we're choosing not to
        // support this now since it would require different logic around de-duping.
        if (window.ShadowRoot && this.renderRoot instanceof window.ShadowRoot) {
            this.adoptStyles();
        }
    }
    /**
     * Returns the node into which the element should render and by default
     * creates and returns an open shadowRoot. Implement to customize where the
     * element's DOM is rendered. For example, to render into the element's
     * childNodes, return `this`.
     * @returns {Element|DocumentFragment} Returns a node into which to render.
     */
    createRenderRoot() {
        return this.attachShadow({ mode: 'open' });
    }
    /**
     * Applies styling to the element shadowRoot using the `static get styles`
     * property. Styling will apply using `shadowRoot.adoptedStyleSheets` where
     * available and will fallback otherwise. When Shadow DOM is polyfilled,
     * ShadyCSS scopes styles and adds them to the document. When Shadow DOM
     * is available but `adoptedStyleSheets` is not, styles are appended to the
     * end of the `shadowRoot` to [mimic spec
     * behavior](https://wicg.github.io/construct-stylesheets/#using-constructed-stylesheets).
     */
    adoptStyles() {
        const styles = this.constructor._styles;
        if (styles.length === 0) {
            return;
        }
        // There are three separate cases here based on Shadow DOM support.
        // (1) shadowRoot polyfilled: use ShadyCSS
        // (2) shadowRoot.adoptedStyleSheets available: use it.
        // (3) shadowRoot.adoptedStyleSheets polyfilled: append styles after
        // rendering
        if (window.ShadyCSS !== undefined && !window.ShadyCSS.nativeShadow) {
            window.ShadyCSS.ScopingShim.prepareAdoptedCssText(styles.map((s) => s.cssText), this.localName);
        }
        else if (_lib_css_tag_js__WEBPACK_IMPORTED_MODULE_4__.supportsAdoptingStyleSheets) {
            this.renderRoot.adoptedStyleSheets =
                styles.map((s) => s.styleSheet);
        }
        else {
            // This must be done after rendering so the actual style insertion is done
            // in `update`.
            this._needsShimAdoptedStyleSheets = true;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        // Note, first update/render handles styleElement so we only call this if
        // connected after first update.
        if (this.hasUpdated && window.ShadyCSS !== undefined) {
            window.ShadyCSS.styleElement(this);
        }
    }
    /**
     * Updates the element. This method reflects property values to attributes
     * and calls `render` to render DOM via lit-html. Setting properties inside
     * this method will *not* trigger another update.
     * @param _changedProperties Map of changed properties with old values
     */
    update(changedProperties) {
        // Setting properties in `render` should not trigger an update. Since
        // updates are allowed after super.update, it's important to call `render`
        // before that.
        const templateResult = this.render();
        super.update(changedProperties);
        // If render is not implemented by the component, don't call lit-html render
        if (templateResult !== renderNotImplemented) {
            this.constructor
                .render(templateResult, this.renderRoot, { scopeName: this.localName, eventContext: this });
        }
        // When native Shadow DOM is used but adoptedStyles are not supported,
        // insert styling after rendering to ensure adoptedStyles have highest
        // priority.
        if (this._needsShimAdoptedStyleSheets) {
            this._needsShimAdoptedStyleSheets = false;
            this.constructor._styles.forEach((s) => {
                const style = document.createElement('style');
                style.textContent = s.cssText;
                this.renderRoot.appendChild(style);
            });
        }
    }
    /**
     * Invoked on each update to perform rendering tasks. This method may return
     * any value renderable by lit-html's NodePart - typically a TemplateResult.
     * Setting properties inside this method will *not* trigger the element to
     * update.
     */
    render() {
        return renderNotImplemented;
    }
}
/**
 * Ensure this class is marked as `finalized` as an optimization ensuring
 * it will not needlessly try to `finalize`.
 *
 * Note this property name is a string to prevent breaking Closure JS Compiler
 * optimizations. See updating-element.ts for more information.
 */
LitElement['finalized'] = true;
/**
 * Render method used to render the value to the element's DOM.
 * @param result The value to render.
 * @param container Node into which to render.
 * @param options Element name.
 * @nocollapse
 */
LitElement.render = lit_html_lib_shady_render_js__WEBPACK_IMPORTED_MODULE_0__.render;
//# sourceMappingURL=lit-element.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/default-template-processor.js":
/*!*********************************************************************!*\
  !*** ../../node_modules/lit-html/lib/default-template-processor.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DefaultTemplateProcessor: () => (/* binding */ DefaultTemplateProcessor),
/* harmony export */   defaultTemplateProcessor: () => (/* binding */ defaultTemplateProcessor)
/* harmony export */ });
/* harmony import */ var _parts_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./parts.js */ "../../node_modules/lit-html/lib/parts.js");
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

/**
 * Creates Parts when a template is instantiated.
 */
class DefaultTemplateProcessor {
    /**
     * Create parts for an attribute-position binding, given the event, attribute
     * name, and string literals.
     *
     * @param element The element containing the binding
     * @param name  The attribute name
     * @param strings The string literals. There are always at least two strings,
     *   event for fully-controlled bindings with a single expression.
     */
    handleAttributeExpressions(element, name, strings, options) {
        const prefix = name[0];
        if (prefix === '.') {
            const committer = new _parts_js__WEBPACK_IMPORTED_MODULE_0__.PropertyCommitter(element, name.slice(1), strings);
            return committer.parts;
        }
        if (prefix === '@') {
            return [new _parts_js__WEBPACK_IMPORTED_MODULE_0__.EventPart(element, name.slice(1), options.eventContext)];
        }
        if (prefix === '?') {
            return [new _parts_js__WEBPACK_IMPORTED_MODULE_0__.BooleanAttributePart(element, name.slice(1), strings)];
        }
        const committer = new _parts_js__WEBPACK_IMPORTED_MODULE_0__.AttributeCommitter(element, name, strings);
        return committer.parts;
    }
    /**
     * Create parts for a text-position binding.
     * @param templateFactory
     */
    handleTextExpression(options) {
        return new _parts_js__WEBPACK_IMPORTED_MODULE_0__.NodePart(options);
    }
}
const defaultTemplateProcessor = new DefaultTemplateProcessor();
//# sourceMappingURL=default-template-processor.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/directive.js":
/*!****************************************************!*\
  !*** ../../node_modules/lit-html/lib/directive.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   directive: () => (/* binding */ directive),
/* harmony export */   isDirective: () => (/* binding */ isDirective)
/* harmony export */ });
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const directives = new WeakMap();
/**
 * Brands a function as a directive factory function so that lit-html will call
 * the function during template rendering, rather than passing as a value.
 *
 * A _directive_ is a function that takes a Part as an argument. It has the
 * signature: `(part: Part) => void`.
 *
 * A directive _factory_ is a function that takes arguments for data and
 * configuration and returns a directive. Users of directive usually refer to
 * the directive factory as the directive. For example, "The repeat directive".
 *
 * Usually a template author will invoke a directive factory in their template
 * with relevant arguments, which will then return a directive function.
 *
 * Here's an example of using the `repeat()` directive factory that takes an
 * array and a function to render an item:
 *
 * ```js
 * html`<ul><${repeat(items, (item) => html`<li>${item}</li>`)}</ul>`
 * ```
 *
 * When `repeat` is invoked, it returns a directive function that closes over
 * `items` and the template function. When the outer template is rendered, the
 * return directive function is called with the Part for the expression.
 * `repeat` then performs it's custom logic to render multiple items.
 *
 * @param f The directive factory function. Must be a function that returns a
 * function of the signature `(part: Part) => void`. The returned function will
 * be called with the part object.
 *
 * @example
 *
 * import {directive, html} from 'lit-html';
 *
 * const immutable = directive((v) => (part) => {
 *   if (part.value !== v) {
 *     part.setValue(v)
 *   }
 * });
 */
const directive = (f) => ((...args) => {
    const d = f(...args);
    directives.set(d, true);
    return d;
});
const isDirective = (o) => {
    return typeof o === 'function' && directives.has(o);
};
//# sourceMappingURL=directive.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/dom.js":
/*!**********************************************!*\
  !*** ../../node_modules/lit-html/lib/dom.js ***!
  \**********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   isCEPolyfill: () => (/* binding */ isCEPolyfill),
/* harmony export */   removeNodes: () => (/* binding */ removeNodes),
/* harmony export */   reparentNodes: () => (/* binding */ reparentNodes)
/* harmony export */ });
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * True if the custom elements polyfill is in use.
 */
const isCEPolyfill = typeof window !== 'undefined' &&
    window.customElements != null &&
    window.customElements.polyfillWrapFlushCallback !==
        undefined;
/**
 * Reparents nodes, starting from `start` (inclusive) to `end` (exclusive),
 * into another container (could be the same container), before `before`. If
 * `before` is null, it appends the nodes to the container.
 */
const reparentNodes = (container, start, end = null, before = null) => {
    while (start !== end) {
        const n = start.nextSibling;
        container.insertBefore(start, before);
        start = n;
    }
};
/**
 * Removes nodes, starting from `start` (inclusive) to `end` (exclusive), from
 * `container`.
 */
const removeNodes = (container, start, end = null) => {
    while (start !== end) {
        const n = start.nextSibling;
        container.removeChild(start);
        start = n;
    }
};
//# sourceMappingURL=dom.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/modify-template.js":
/*!**********************************************************!*\
  !*** ../../node_modules/lit-html/lib/modify-template.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   insertNodeIntoTemplate: () => (/* binding */ insertNodeIntoTemplate),
/* harmony export */   removeNodesFromTemplate: () => (/* binding */ removeNodesFromTemplate)
/* harmony export */ });
/* harmony import */ var _template_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./template.js */ "../../node_modules/lit-html/lib/template.js");
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

const walkerNodeFilter = 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */;
/**
 * Removes the list of nodes from a Template safely. In addition to removing
 * nodes from the Template, the Template part indices are updated to match
 * the mutated Template DOM.
 *
 * As the template is walked the removal state is tracked and
 * part indices are adjusted as needed.
 *
 * div
 *   div#1 (remove) <-- start removing (removing node is div#1)
 *     div
 *       div#2 (remove)  <-- continue removing (removing node is still div#1)
 *         div
 * div <-- stop removing since previous sibling is the removing node (div#1,
 * removed 4 nodes)
 */
function removeNodesFromTemplate(template, nodesToRemove) {
    const { element: { content }, parts } = template;
    const walker = document.createTreeWalker(content, walkerNodeFilter, null, false);
    let partIndex = nextActiveIndexInTemplateParts(parts);
    let part = parts[partIndex];
    let nodeIndex = -1;
    let removeCount = 0;
    const nodesToRemoveInTemplate = [];
    let currentRemovingNode = null;
    while (walker.nextNode()) {
        nodeIndex++;
        const node = walker.currentNode;
        // End removal if stepped past the removing node
        if (node.previousSibling === currentRemovingNode) {
            currentRemovingNode = null;
        }
        // A node to remove was found in the template
        if (nodesToRemove.has(node)) {
            nodesToRemoveInTemplate.push(node);
            // Track node we're removing
            if (currentRemovingNode === null) {
                currentRemovingNode = node;
            }
        }
        // When removing, increment count by which to adjust subsequent part indices
        if (currentRemovingNode !== null) {
            removeCount++;
        }
        while (part !== undefined && part.index === nodeIndex) {
            // If part is in a removed node deactivate it by setting index to -1 or
            // adjust the index as needed.
            part.index = currentRemovingNode !== null ? -1 : part.index - removeCount;
            // go to the next active part.
            partIndex = nextActiveIndexInTemplateParts(parts, partIndex);
            part = parts[partIndex];
        }
    }
    nodesToRemoveInTemplate.forEach((n) => n.parentNode.removeChild(n));
}
const countNodes = (node) => {
    let count = (node.nodeType === 11 /* Node.DOCUMENT_FRAGMENT_NODE */) ? 0 : 1;
    const walker = document.createTreeWalker(node, walkerNodeFilter, null, false);
    while (walker.nextNode()) {
        count++;
    }
    return count;
};
const nextActiveIndexInTemplateParts = (parts, startIndex = -1) => {
    for (let i = startIndex + 1; i < parts.length; i++) {
        const part = parts[i];
        if ((0,_template_js__WEBPACK_IMPORTED_MODULE_0__.isTemplatePartActive)(part)) {
            return i;
        }
    }
    return -1;
};
/**
 * Inserts the given node into the Template, optionally before the given
 * refNode. In addition to inserting the node into the Template, the Template
 * part indices are updated to match the mutated Template DOM.
 */
function insertNodeIntoTemplate(template, node, refNode = null) {
    const { element: { content }, parts } = template;
    // If there's no refNode, then put node at end of template.
    // No part indices need to be shifted in this case.
    if (refNode === null || refNode === undefined) {
        content.appendChild(node);
        return;
    }
    const walker = document.createTreeWalker(content, walkerNodeFilter, null, false);
    let partIndex = nextActiveIndexInTemplateParts(parts);
    let insertCount = 0;
    let walkerIndex = -1;
    while (walker.nextNode()) {
        walkerIndex++;
        const walkerNode = walker.currentNode;
        if (walkerNode === refNode) {
            insertCount = countNodes(node);
            refNode.parentNode.insertBefore(node, refNode);
        }
        while (partIndex !== -1 && parts[partIndex].index === walkerIndex) {
            // If we've inserted the node, simply adjust all subsequent parts
            if (insertCount > 0) {
                while (partIndex !== -1) {
                    parts[partIndex].index += insertCount;
                    partIndex = nextActiveIndexInTemplateParts(parts, partIndex);
                }
                return;
            }
            partIndex = nextActiveIndexInTemplateParts(parts, partIndex);
        }
    }
}
//# sourceMappingURL=modify-template.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/part.js":
/*!***********************************************!*\
  !*** ../../node_modules/lit-html/lib/part.js ***!
  \***********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   noChange: () => (/* binding */ noChange),
/* harmony export */   nothing: () => (/* binding */ nothing)
/* harmony export */ });
/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * A sentinel value that signals that a value was handled by a directive and
 * should not be written to the DOM.
 */
const noChange = {};
/**
 * A sentinel value that signals a NodePart to fully clear its content.
 */
const nothing = {};
//# sourceMappingURL=part.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/parts.js":
/*!************************************************!*\
  !*** ../../node_modules/lit-html/lib/parts.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AttributeCommitter: () => (/* binding */ AttributeCommitter),
/* harmony export */   AttributePart: () => (/* binding */ AttributePart),
/* harmony export */   BooleanAttributePart: () => (/* binding */ BooleanAttributePart),
/* harmony export */   EventPart: () => (/* binding */ EventPart),
/* harmony export */   NodePart: () => (/* binding */ NodePart),
/* harmony export */   PropertyCommitter: () => (/* binding */ PropertyCommitter),
/* harmony export */   PropertyPart: () => (/* binding */ PropertyPart),
/* harmony export */   isIterable: () => (/* binding */ isIterable),
/* harmony export */   isPrimitive: () => (/* binding */ isPrimitive)
/* harmony export */ });
/* harmony import */ var _directive_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./directive.js */ "../../node_modules/lit-html/lib/directive.js");
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./dom.js */ "../../node_modules/lit-html/lib/dom.js");
/* harmony import */ var _part_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./part.js */ "../../node_modules/lit-html/lib/part.js");
/* harmony import */ var _template_instance_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./template-instance.js */ "../../node_modules/lit-html/lib/template-instance.js");
/* harmony import */ var _template_result_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./template-result.js */ "../../node_modules/lit-html/lib/template-result.js");
/* harmony import */ var _template_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./template.js */ "../../node_modules/lit-html/lib/template.js");
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */






const isPrimitive = (value) => {
    return (value === null ||
        !(typeof value === 'object' || typeof value === 'function'));
};
const isIterable = (value) => {
    return Array.isArray(value) ||
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        !!(value && value[Symbol.iterator]);
};
/**
 * Writes attribute values to the DOM for a group of AttributeParts bound to a
 * single attribute. The value is only set once even if there are multiple parts
 * for an attribute.
 */
class AttributeCommitter {
    constructor(element, name, strings) {
        this.dirty = true;
        this.element = element;
        this.name = name;
        this.strings = strings;
        this.parts = [];
        for (let i = 0; i < strings.length - 1; i++) {
            this.parts[i] = this._createPart();
        }
    }
    /**
     * Creates a single part. Override this to create a differnt type of part.
     */
    _createPart() {
        return new AttributePart(this);
    }
    _getValue() {
        const strings = this.strings;
        const l = strings.length - 1;
        const parts = this.parts;
        // If we're assigning an attribute via syntax like:
        //    attr="${foo}"  or  attr=${foo}
        // but not
        //    attr="${foo} ${bar}" or attr="${foo} baz"
        // then we don't want to coerce the attribute value into one long
        // string. Instead we want to just return the value itself directly,
        // so that sanitizeDOMValue can get the actual value rather than
        // String(value)
        // The exception is if v is an array, in which case we do want to smash
        // it together into a string without calling String() on the array.
        //
        // This also allows trusted values (when using TrustedTypes) being
        // assigned to DOM sinks without being stringified in the process.
        if (l === 1 && strings[0] === '' && strings[1] === '') {
            const v = parts[0].value;
            if (typeof v === 'symbol') {
                return String(v);
            }
            if (typeof v === 'string' || !isIterable(v)) {
                return v;
            }
        }
        let text = '';
        for (let i = 0; i < l; i++) {
            text += strings[i];
            const part = parts[i];
            if (part !== undefined) {
                const v = part.value;
                if (isPrimitive(v) || !isIterable(v)) {
                    text += typeof v === 'string' ? v : String(v);
                }
                else {
                    for (const t of v) {
                        text += typeof t === 'string' ? t : String(t);
                    }
                }
            }
        }
        text += strings[l];
        return text;
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            this.element.setAttribute(this.name, this._getValue());
        }
    }
}
/**
 * A Part that controls all or part of an attribute value.
 */
class AttributePart {
    constructor(committer) {
        this.value = undefined;
        this.committer = committer;
    }
    setValue(value) {
        if (value !== _part_js__WEBPACK_IMPORTED_MODULE_2__.noChange && (!isPrimitive(value) || value !== this.value)) {
            this.value = value;
            // If the value is a not a directive, dirty the committer so that it'll
            // call setAttribute. If the value is a directive, it'll dirty the
            // committer if it calls setValue().
            if (!(0,_directive_js__WEBPACK_IMPORTED_MODULE_0__.isDirective)(value)) {
                this.committer.dirty = true;
            }
        }
    }
    commit() {
        while ((0,_directive_js__WEBPACK_IMPORTED_MODULE_0__.isDirective)(this.value)) {
            const directive = this.value;
            this.value = _part_js__WEBPACK_IMPORTED_MODULE_2__.noChange;
            directive(this);
        }
        if (this.value === _part_js__WEBPACK_IMPORTED_MODULE_2__.noChange) {
            return;
        }
        this.committer.commit();
    }
}
/**
 * A Part that controls a location within a Node tree. Like a Range, NodePart
 * has start and end locations and can set and update the Nodes between those
 * locations.
 *
 * NodeParts support several value types: primitives, Nodes, TemplateResults,
 * as well as arrays and iterables of those types.
 */
class NodePart {
    constructor(options) {
        this.value = undefined;
        this.__pendingValue = undefined;
        this.options = options;
    }
    /**
     * Appends this part into a container.
     *
     * This part must be empty, as its contents are not automatically moved.
     */
    appendInto(container) {
        this.startNode = container.appendChild((0,_template_js__WEBPACK_IMPORTED_MODULE_5__.createMarker)());
        this.endNode = container.appendChild((0,_template_js__WEBPACK_IMPORTED_MODULE_5__.createMarker)());
    }
    /**
     * Inserts this part after the `ref` node (between `ref` and `ref`'s next
     * sibling). Both `ref` and its next sibling must be static, unchanging nodes
     * such as those that appear in a literal section of a template.
     *
     * This part must be empty, as its contents are not automatically moved.
     */
    insertAfterNode(ref) {
        this.startNode = ref;
        this.endNode = ref.nextSibling;
    }
    /**
     * Appends this part into a parent part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */
    appendIntoPart(part) {
        part.__insert(this.startNode = (0,_template_js__WEBPACK_IMPORTED_MODULE_5__.createMarker)());
        part.__insert(this.endNode = (0,_template_js__WEBPACK_IMPORTED_MODULE_5__.createMarker)());
    }
    /**
     * Inserts this part after the `ref` part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */
    insertAfterPart(ref) {
        ref.__insert(this.startNode = (0,_template_js__WEBPACK_IMPORTED_MODULE_5__.createMarker)());
        this.endNode = ref.endNode;
        ref.endNode = this.startNode;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        if (this.startNode.parentNode === null) {
            return;
        }
        while ((0,_directive_js__WEBPACK_IMPORTED_MODULE_0__.isDirective)(this.__pendingValue)) {
            const directive = this.__pendingValue;
            this.__pendingValue = _part_js__WEBPACK_IMPORTED_MODULE_2__.noChange;
            directive(this);
        }
        const value = this.__pendingValue;
        if (value === _part_js__WEBPACK_IMPORTED_MODULE_2__.noChange) {
            return;
        }
        if (isPrimitive(value)) {
            if (value !== this.value) {
                this.__commitText(value);
            }
        }
        else if (value instanceof _template_result_js__WEBPACK_IMPORTED_MODULE_4__.TemplateResult) {
            this.__commitTemplateResult(value);
        }
        else if (value instanceof Node) {
            this.__commitNode(value);
        }
        else if (isIterable(value)) {
            this.__commitIterable(value);
        }
        else if (value === _part_js__WEBPACK_IMPORTED_MODULE_2__.nothing) {
            this.value = _part_js__WEBPACK_IMPORTED_MODULE_2__.nothing;
            this.clear();
        }
        else {
            // Fallback, will render the string representation
            this.__commitText(value);
        }
    }
    __insert(node) {
        this.endNode.parentNode.insertBefore(node, this.endNode);
    }
    __commitNode(value) {
        if (this.value === value) {
            return;
        }
        this.clear();
        this.__insert(value);
        this.value = value;
    }
    __commitText(value) {
        const node = this.startNode.nextSibling;
        value = value == null ? '' : value;
        // If `value` isn't already a string, we explicitly convert it here in case
        // it can't be implicitly converted - i.e. it's a symbol.
        const valueAsString = typeof value === 'string' ? value : String(value);
        if (node === this.endNode.previousSibling &&
            node.nodeType === 3 /* Node.TEXT_NODE */) {
            // If we only have a single text node between the markers, we can just
            // set its value, rather than replacing it.
            // TODO(justinfagnani): Can we just check if this.value is primitive?
            node.data = valueAsString;
        }
        else {
            this.__commitNode(document.createTextNode(valueAsString));
        }
        this.value = value;
    }
    __commitTemplateResult(value) {
        const template = this.options.templateFactory(value);
        if (this.value instanceof _template_instance_js__WEBPACK_IMPORTED_MODULE_3__.TemplateInstance &&
            this.value.template === template) {
            this.value.update(value.values);
        }
        else {
            // Make sure we propagate the template processor from the TemplateResult
            // so that we use its syntax extension, etc. The template factory comes
            // from the render function options so that it can control template
            // caching and preprocessing.
            const instance = new _template_instance_js__WEBPACK_IMPORTED_MODULE_3__.TemplateInstance(template, value.processor, this.options);
            const fragment = instance._clone();
            instance.update(value.values);
            this.__commitNode(fragment);
            this.value = instance;
        }
    }
    __commitIterable(value) {
        // For an Iterable, we create a new InstancePart per item, then set its
        // value to the item. This is a little bit of overhead for every item in
        // an Iterable, but it lets us recurse easily and efficiently update Arrays
        // of TemplateResults that will be commonly returned from expressions like:
        // array.map((i) => html`${i}`), by reusing existing TemplateInstances.
        // If _value is an array, then the previous render was of an
        // iterable and _value will contain the NodeParts from the previous
        // render. If _value is not an array, clear this part and make a new
        // array for NodeParts.
        if (!Array.isArray(this.value)) {
            this.value = [];
            this.clear();
        }
        // Lets us keep track of how many items we stamped so we can clear leftover
        // items from a previous render
        const itemParts = this.value;
        let partIndex = 0;
        let itemPart;
        for (const item of value) {
            // Try to reuse an existing part
            itemPart = itemParts[partIndex];
            // If no existing part, create a new one
            if (itemPart === undefined) {
                itemPart = new NodePart(this.options);
                itemParts.push(itemPart);
                if (partIndex === 0) {
                    itemPart.appendIntoPart(this);
                }
                else {
                    itemPart.insertAfterPart(itemParts[partIndex - 1]);
                }
            }
            itemPart.setValue(item);
            itemPart.commit();
            partIndex++;
        }
        if (partIndex < itemParts.length) {
            // Truncate the parts array so _value reflects the current state
            itemParts.length = partIndex;
            this.clear(itemPart && itemPart.endNode);
        }
    }
    clear(startNode = this.startNode) {
        (0,_dom_js__WEBPACK_IMPORTED_MODULE_1__.removeNodes)(this.startNode.parentNode, startNode.nextSibling, this.endNode);
    }
}
/**
 * Implements a boolean attribute, roughly as defined in the HTML
 * specification.
 *
 * If the value is truthy, then the attribute is present with a value of
 * ''. If the value is falsey, the attribute is removed.
 */
class BooleanAttributePart {
    constructor(element, name, strings) {
        this.value = undefined;
        this.__pendingValue = undefined;
        if (strings.length !== 2 || strings[0] !== '' || strings[1] !== '') {
            throw new Error('Boolean attributes can only contain a single expression');
        }
        this.element = element;
        this.name = name;
        this.strings = strings;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while ((0,_directive_js__WEBPACK_IMPORTED_MODULE_0__.isDirective)(this.__pendingValue)) {
            const directive = this.__pendingValue;
            this.__pendingValue = _part_js__WEBPACK_IMPORTED_MODULE_2__.noChange;
            directive(this);
        }
        if (this.__pendingValue === _part_js__WEBPACK_IMPORTED_MODULE_2__.noChange) {
            return;
        }
        const value = !!this.__pendingValue;
        if (this.value !== value) {
            if (value) {
                this.element.setAttribute(this.name, '');
            }
            else {
                this.element.removeAttribute(this.name);
            }
            this.value = value;
        }
        this.__pendingValue = _part_js__WEBPACK_IMPORTED_MODULE_2__.noChange;
    }
}
/**
 * Sets attribute values for PropertyParts, so that the value is only set once
 * even if there are multiple parts for a property.
 *
 * If an expression controls the whole property value, then the value is simply
 * assigned to the property under control. If there are string literals or
 * multiple expressions, then the strings are expressions are interpolated into
 * a string first.
 */
class PropertyCommitter extends AttributeCommitter {
    constructor(element, name, strings) {
        super(element, name, strings);
        this.single =
            (strings.length === 2 && strings[0] === '' && strings[1] === '');
    }
    _createPart() {
        return new PropertyPart(this);
    }
    _getValue() {
        if (this.single) {
            return this.parts[0].value;
        }
        return super._getValue();
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.element[this.name] = this._getValue();
        }
    }
}
class PropertyPart extends AttributePart {
}
// Detect event listener options support. If the `capture` property is read
// from the options object, then options are supported. If not, then the third
// argument to add/removeEventListener is interpreted as the boolean capture
// value so we should only pass the `capture` property.
let eventOptionsSupported = false;
// Wrap into an IIFE because MS Edge <= v41 does not support having try/catch
// blocks right into the body of a module
(() => {
    try {
        const options = {
            get capture() {
                eventOptionsSupported = true;
                return false;
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.addEventListener('test', options, options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.removeEventListener('test', options, options);
    }
    catch (_e) {
        // event options not supported
    }
})();
class EventPart {
    constructor(element, eventName, eventContext) {
        this.value = undefined;
        this.__pendingValue = undefined;
        this.element = element;
        this.eventName = eventName;
        this.eventContext = eventContext;
        this.__boundHandleEvent = (e) => this.handleEvent(e);
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while ((0,_directive_js__WEBPACK_IMPORTED_MODULE_0__.isDirective)(this.__pendingValue)) {
            const directive = this.__pendingValue;
            this.__pendingValue = _part_js__WEBPACK_IMPORTED_MODULE_2__.noChange;
            directive(this);
        }
        if (this.__pendingValue === _part_js__WEBPACK_IMPORTED_MODULE_2__.noChange) {
            return;
        }
        const newListener = this.__pendingValue;
        const oldListener = this.value;
        const shouldRemoveListener = newListener == null ||
            oldListener != null &&
                (newListener.capture !== oldListener.capture ||
                    newListener.once !== oldListener.once ||
                    newListener.passive !== oldListener.passive);
        const shouldAddListener = newListener != null && (oldListener == null || shouldRemoveListener);
        if (shouldRemoveListener) {
            this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        }
        if (shouldAddListener) {
            this.__options = getOptions(newListener);
            this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        }
        this.value = newListener;
        this.__pendingValue = _part_js__WEBPACK_IMPORTED_MODULE_2__.noChange;
    }
    handleEvent(event) {
        if (typeof this.value === 'function') {
            this.value.call(this.eventContext || this.element, event);
        }
        else {
            this.value.handleEvent(event);
        }
    }
}
// We copy options because of the inconsistent behavior of browsers when reading
// the third argument of add/removeEventListener. IE11 doesn't support options
// at all. Chrome 41 only reads `capture` if the argument is an object.
const getOptions = (o) => o &&
    (eventOptionsSupported ?
        { capture: o.capture, passive: o.passive, once: o.once } :
        o.capture);
//# sourceMappingURL=parts.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/render.js":
/*!*************************************************!*\
  !*** ../../node_modules/lit-html/lib/render.js ***!
  \*************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   parts: () => (/* binding */ parts),
/* harmony export */   render: () => (/* binding */ render)
/* harmony export */ });
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dom.js */ "../../node_modules/lit-html/lib/dom.js");
/* harmony import */ var _parts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./parts.js */ "../../node_modules/lit-html/lib/parts.js");
/* harmony import */ var _template_factory_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./template-factory.js */ "../../node_modules/lit-html/lib/template-factory.js");
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */



const parts = new WeakMap();
/**
 * Renders a template result or other value to a container.
 *
 * To update a container with new values, reevaluate the template literal and
 * call `render` with the new result.
 *
 * @param result Any value renderable by NodePart - typically a TemplateResult
 *     created by evaluating a template tag like `html` or `svg`.
 * @param container A DOM parent to render to. The entire contents are either
 *     replaced, or efficiently updated if the same result type was previous
 *     rendered there.
 * @param options RenderOptions for the entire render tree rendered to this
 *     container. Render options must *not* change between renders to the same
 *     container, as those changes will not effect previously rendered DOM.
 */
const render = (result, container, options) => {
    let part = parts.get(container);
    if (part === undefined) {
        (0,_dom_js__WEBPACK_IMPORTED_MODULE_0__.removeNodes)(container, container.firstChild);
        parts.set(container, part = new _parts_js__WEBPACK_IMPORTED_MODULE_1__.NodePart(Object.assign({ templateFactory: _template_factory_js__WEBPACK_IMPORTED_MODULE_2__.templateFactory }, options)));
        part.appendInto(container);
    }
    part.setValue(result);
    part.commit();
};
//# sourceMappingURL=render.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/shady-render.js":
/*!*******************************************************!*\
  !*** ../../node_modules/lit-html/lib/shady-render.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TemplateResult: () => (/* reexport safe */ _lit_html_js__WEBPACK_IMPORTED_MODULE_6__.TemplateResult),
/* harmony export */   html: () => (/* reexport safe */ _lit_html_js__WEBPACK_IMPORTED_MODULE_6__.html),
/* harmony export */   render: () => (/* binding */ render),
/* harmony export */   shadyTemplateFactory: () => (/* binding */ shadyTemplateFactory),
/* harmony export */   svg: () => (/* reexport safe */ _lit_html_js__WEBPACK_IMPORTED_MODULE_6__.svg)
/* harmony export */ });
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dom.js */ "../../node_modules/lit-html/lib/dom.js");
/* harmony import */ var _modify_template_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modify-template.js */ "../../node_modules/lit-html/lib/modify-template.js");
/* harmony import */ var _render_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./render.js */ "../../node_modules/lit-html/lib/render.js");
/* harmony import */ var _template_factory_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./template-factory.js */ "../../node_modules/lit-html/lib/template-factory.js");
/* harmony import */ var _template_instance_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./template-instance.js */ "../../node_modules/lit-html/lib/template-instance.js");
/* harmony import */ var _template_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./template.js */ "../../node_modules/lit-html/lib/template.js");
/* harmony import */ var _lit_html_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../lit-html.js */ "../../node_modules/lit-html/lit-html.js");
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * Module to add shady DOM/shady CSS polyfill support to lit-html template
 * rendering. See the [[render]] method for details.
 *
 * @packageDocumentation
 */
/**
 * Do not remove this comment; it keeps typedoc from misplacing the module
 * docs.
 */







// Get a key to lookup in `templateCaches`.
const getTemplateCacheKey = (type, scopeName) => `${type}--${scopeName}`;
let compatibleShadyCSSVersion = true;
if (typeof window.ShadyCSS === 'undefined') {
    compatibleShadyCSSVersion = false;
}
else if (typeof window.ShadyCSS.prepareTemplateDom === 'undefined') {
    console.warn(`Incompatible ShadyCSS version detected. ` +
        `Please update to at least @webcomponents/webcomponentsjs@2.0.2 and ` +
        `@webcomponents/shadycss@1.3.1.`);
    compatibleShadyCSSVersion = false;
}
/**
 * Template factory which scopes template DOM using ShadyCSS.
 * @param scopeName {string}
 */
const shadyTemplateFactory = (scopeName) => (result) => {
    const cacheKey = getTemplateCacheKey(result.type, scopeName);
    let templateCache = _template_factory_js__WEBPACK_IMPORTED_MODULE_3__.templateCaches.get(cacheKey);
    if (templateCache === undefined) {
        templateCache = {
            stringsArray: new WeakMap(),
            keyString: new Map()
        };
        _template_factory_js__WEBPACK_IMPORTED_MODULE_3__.templateCaches.set(cacheKey, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) {
        return template;
    }
    const key = result.strings.join(_template_js__WEBPACK_IMPORTED_MODULE_5__.marker);
    template = templateCache.keyString.get(key);
    if (template === undefined) {
        const element = result.getTemplateElement();
        if (compatibleShadyCSSVersion) {
            window.ShadyCSS.prepareTemplateDom(element, scopeName);
        }
        template = new _template_js__WEBPACK_IMPORTED_MODULE_5__.Template(result, element);
        templateCache.keyString.set(key, template);
    }
    templateCache.stringsArray.set(result.strings, template);
    return template;
};
const TEMPLATE_TYPES = ['html', 'svg'];
/**
 * Removes all style elements from Templates for the given scopeName.
 */
const removeStylesFromLitTemplates = (scopeName) => {
    TEMPLATE_TYPES.forEach((type) => {
        const templates = _template_factory_js__WEBPACK_IMPORTED_MODULE_3__.templateCaches.get(getTemplateCacheKey(type, scopeName));
        if (templates !== undefined) {
            templates.keyString.forEach((template) => {
                const { element: { content } } = template;
                // IE 11 doesn't support the iterable param Set constructor
                const styles = new Set();
                Array.from(content.querySelectorAll('style')).forEach((s) => {
                    styles.add(s);
                });
                (0,_modify_template_js__WEBPACK_IMPORTED_MODULE_1__.removeNodesFromTemplate)(template, styles);
            });
        }
    });
};
const shadyRenderSet = new Set();
/**
 * For the given scope name, ensures that ShadyCSS style scoping is performed.
 * This is done just once per scope name so the fragment and template cannot
 * be modified.
 * (1) extracts styles from the rendered fragment and hands them to ShadyCSS
 * to be scoped and appended to the document
 * (2) removes style elements from all lit-html Templates for this scope name.
 *
 * Note, <style> elements can only be placed into templates for the
 * initial rendering of the scope. If <style> elements are included in templates
 * dynamically rendered to the scope (after the first scope render), they will
 * not be scoped and the <style> will be left in the template and rendered
 * output.
 */
const prepareTemplateStyles = (scopeName, renderedDOM, template) => {
    shadyRenderSet.add(scopeName);
    // If `renderedDOM` is stamped from a Template, then we need to edit that
    // Template's underlying template element. Otherwise, we create one here
    // to give to ShadyCSS, which still requires one while scoping.
    const templateElement = !!template ? template.element : document.createElement('template');
    // Move styles out of rendered DOM and store.
    const styles = renderedDOM.querySelectorAll('style');
    const { length } = styles;
    // If there are no styles, skip unnecessary work
    if (length === 0) {
        // Ensure prepareTemplateStyles is called to support adding
        // styles via `prepareAdoptedCssText` since that requires that
        // `prepareTemplateStyles` is called.
        //
        // ShadyCSS will only update styles containing @apply in the template
        // given to `prepareTemplateStyles`. If no lit Template was given,
        // ShadyCSS will not be able to update uses of @apply in any relevant
        // template. However, this is not a problem because we only create the
        // template for the purpose of supporting `prepareAdoptedCssText`,
        // which doesn't support @apply at all.
        window.ShadyCSS.prepareTemplateStyles(templateElement, scopeName);
        return;
    }
    const condensedStyle = document.createElement('style');
    // Collect styles into a single style. This helps us make sure ShadyCSS
    // manipulations will not prevent us from being able to fix up template
    // part indices.
    // NOTE: collecting styles is inefficient for browsers but ShadyCSS
    // currently does this anyway. When it does not, this should be changed.
    for (let i = 0; i < length; i++) {
        const style = styles[i];
        style.parentNode.removeChild(style);
        condensedStyle.textContent += style.textContent;
    }
    // Remove styles from nested templates in this scope.
    removeStylesFromLitTemplates(scopeName);
    // And then put the condensed style into the "root" template passed in as
    // `template`.
    const content = templateElement.content;
    if (!!template) {
        (0,_modify_template_js__WEBPACK_IMPORTED_MODULE_1__.insertNodeIntoTemplate)(template, condensedStyle, content.firstChild);
    }
    else {
        content.insertBefore(condensedStyle, content.firstChild);
    }
    // Note, it's important that ShadyCSS gets the template that `lit-html`
    // will actually render so that it can update the style inside when
    // needed (e.g. @apply native Shadow DOM case).
    window.ShadyCSS.prepareTemplateStyles(templateElement, scopeName);
    const style = content.querySelector('style');
    if (window.ShadyCSS.nativeShadow && style !== null) {
        // When in native Shadow DOM, ensure the style created by ShadyCSS is
        // included in initially rendered output (`renderedDOM`).
        renderedDOM.insertBefore(style.cloneNode(true), renderedDOM.firstChild);
    }
    else if (!!template) {
        // When no style is left in the template, parts will be broken as a
        // result. To fix this, we put back the style node ShadyCSS removed
        // and then tell lit to remove that node from the template.
        // There can be no style in the template in 2 cases (1) when Shady DOM
        // is in use, ShadyCSS removes all styles, (2) when native Shadow DOM
        // is in use ShadyCSS removes the style if it contains no content.
        // NOTE, ShadyCSS creates its own style so we can safely add/remove
        // `condensedStyle` here.
        content.insertBefore(condensedStyle, content.firstChild);
        const removes = new Set();
        removes.add(condensedStyle);
        (0,_modify_template_js__WEBPACK_IMPORTED_MODULE_1__.removeNodesFromTemplate)(template, removes);
    }
};
/**
 * Extension to the standard `render` method which supports rendering
 * to ShadowRoots when the ShadyDOM (https://github.com/webcomponents/shadydom)
 * and ShadyCSS (https://github.com/webcomponents/shadycss) polyfills are used
 * or when the webcomponentsjs
 * (https://github.com/webcomponents/webcomponentsjs) polyfill is used.
 *
 * Adds a `scopeName` option which is used to scope element DOM and stylesheets
 * when native ShadowDOM is unavailable. The `scopeName` will be added to
 * the class attribute of all rendered DOM. In addition, any style elements will
 * be automatically re-written with this `scopeName` selector and moved out
 * of the rendered DOM and into the document `<head>`.
 *
 * It is common to use this render method in conjunction with a custom element
 * which renders a shadowRoot. When this is done, typically the element's
 * `localName` should be used as the `scopeName`.
 *
 * In addition to DOM scoping, ShadyCSS also supports a basic shim for css
 * custom properties (needed only on older browsers like IE11) and a shim for
 * a deprecated feature called `@apply` that supports applying a set of css
 * custom properties to a given location.
 *
 * Usage considerations:
 *
 * * Part values in `<style>` elements are only applied the first time a given
 * `scopeName` renders. Subsequent changes to parts in style elements will have
 * no effect. Because of this, parts in style elements should only be used for
 * values that will never change, for example parts that set scope-wide theme
 * values or parts which render shared style elements.
 *
 * * Note, due to a limitation of the ShadyDOM polyfill, rendering in a
 * custom element's `constructor` is not supported. Instead rendering should
 * either done asynchronously, for example at microtask timing (for example
 * `Promise.resolve()`), or be deferred until the first time the element's
 * `connectedCallback` runs.
 *
 * Usage considerations when using shimmed custom properties or `@apply`:
 *
 * * Whenever any dynamic changes are made which affect
 * css custom properties, `ShadyCSS.styleElement(element)` must be called
 * to update the element. There are two cases when this is needed:
 * (1) the element is connected to a new parent, (2) a class is added to the
 * element that causes it to match different custom properties.
 * To address the first case when rendering a custom element, `styleElement`
 * should be called in the element's `connectedCallback`.
 *
 * * Shimmed custom properties may only be defined either for an entire
 * shadowRoot (for example, in a `:host` rule) or via a rule that directly
 * matches an element with a shadowRoot. In other words, instead of flowing from
 * parent to child as do native css custom properties, shimmed custom properties
 * flow only from shadowRoots to nested shadowRoots.
 *
 * * When using `@apply` mixing css shorthand property names with
 * non-shorthand names (for example `border` and `border-width`) is not
 * supported.
 */
const render = (result, container, options) => {
    if (!options || typeof options !== 'object' || !options.scopeName) {
        throw new Error('The `scopeName` option is required.');
    }
    const scopeName = options.scopeName;
    const hasRendered = _render_js__WEBPACK_IMPORTED_MODULE_2__.parts.has(container);
    const needsScoping = compatibleShadyCSSVersion &&
        container.nodeType === 11 /* Node.DOCUMENT_FRAGMENT_NODE */ &&
        !!container.host;
    // Handle first render to a scope specially...
    const firstScopeRender = needsScoping && !shadyRenderSet.has(scopeName);
    // On first scope render, render into a fragment; this cannot be a single
    // fragment that is reused since nested renders can occur synchronously.
    const renderContainer = firstScopeRender ? document.createDocumentFragment() : container;
    (0,_render_js__WEBPACK_IMPORTED_MODULE_2__.render)(result, renderContainer, Object.assign({ templateFactory: shadyTemplateFactory(scopeName) }, options));
    // When performing first scope render,
    // (1) We've rendered into a fragment so that there's a chance to
    // `prepareTemplateStyles` before sub-elements hit the DOM
    // (which might cause them to render based on a common pattern of
    // rendering in a custom element's `connectedCallback`);
    // (2) Scope the template with ShadyCSS one time only for this scope.
    // (3) Render the fragment into the container and make sure the
    // container knows its `part` is the one we just rendered. This ensures
    // DOM will be re-used on subsequent renders.
    if (firstScopeRender) {
        const part = _render_js__WEBPACK_IMPORTED_MODULE_2__.parts.get(renderContainer);
        _render_js__WEBPACK_IMPORTED_MODULE_2__.parts.delete(renderContainer);
        // ShadyCSS might have style sheets (e.g. from `prepareAdoptedCssText`)
        // that should apply to `renderContainer` even if the rendered value is
        // not a TemplateInstance. However, it will only insert scoped styles
        // into the document if `prepareTemplateStyles` has already been called
        // for the given scope name.
        const template = part.value instanceof _template_instance_js__WEBPACK_IMPORTED_MODULE_4__.TemplateInstance ?
            part.value.template :
            undefined;
        prepareTemplateStyles(scopeName, renderContainer, template);
        (0,_dom_js__WEBPACK_IMPORTED_MODULE_0__.removeNodes)(container, container.firstChild);
        container.appendChild(renderContainer);
        _render_js__WEBPACK_IMPORTED_MODULE_2__.parts.set(container, part);
    }
    // After elements have hit the DOM, update styling if this is the
    // initial render to this container.
    // This is needed whenever dynamic changes are made so it would be
    // safest to do every render; however, this would regress performance
    // so we leave it up to the user to call `ShadyCSS.styleElement`
    // for dynamic changes.
    if (!hasRendered && needsScoping) {
        window.ShadyCSS.styleElement(container.host);
    }
};
//# sourceMappingURL=shady-render.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/template-factory.js":
/*!***********************************************************!*\
  !*** ../../node_modules/lit-html/lib/template-factory.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   templateCaches: () => (/* binding */ templateCaches),
/* harmony export */   templateFactory: () => (/* binding */ templateFactory)
/* harmony export */ });
/* harmony import */ var _template_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./template.js */ "../../node_modules/lit-html/lib/template.js");
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

/**
 * The default TemplateFactory which caches Templates keyed on
 * result.type and result.strings.
 */
function templateFactory(result) {
    let templateCache = templateCaches.get(result.type);
    if (templateCache === undefined) {
        templateCache = {
            stringsArray: new WeakMap(),
            keyString: new Map()
        };
        templateCaches.set(result.type, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) {
        return template;
    }
    // If the TemplateStringsArray is new, generate a key from the strings
    // This key is shared between all templates with identical content
    const key = result.strings.join(_template_js__WEBPACK_IMPORTED_MODULE_0__.marker);
    // Check if we already have a Template for this key
    template = templateCache.keyString.get(key);
    if (template === undefined) {
        // If we have not seen this key before, create a new Template
        template = new _template_js__WEBPACK_IMPORTED_MODULE_0__.Template(result, result.getTemplateElement());
        // Cache the Template for this key
        templateCache.keyString.set(key, template);
    }
    // Cache all future queries for this TemplateStringsArray
    templateCache.stringsArray.set(result.strings, template);
    return template;
}
const templateCaches = new Map();
//# sourceMappingURL=template-factory.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/template-instance.js":
/*!************************************************************!*\
  !*** ../../node_modules/lit-html/lib/template-instance.js ***!
  \************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TemplateInstance: () => (/* binding */ TemplateInstance)
/* harmony export */ });
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dom.js */ "../../node_modules/lit-html/lib/dom.js");
/* harmony import */ var _template_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./template.js */ "../../node_modules/lit-html/lib/template.js");
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


/**
 * An instance of a `Template` that can be attached to the DOM and updated
 * with new values.
 */
class TemplateInstance {
    constructor(template, processor, options) {
        this.__parts = [];
        this.template = template;
        this.processor = processor;
        this.options = options;
    }
    update(values) {
        let i = 0;
        for (const part of this.__parts) {
            if (part !== undefined) {
                part.setValue(values[i]);
            }
            i++;
        }
        for (const part of this.__parts) {
            if (part !== undefined) {
                part.commit();
            }
        }
    }
    _clone() {
        // There are a number of steps in the lifecycle of a template instance's
        // DOM fragment:
        //  1. Clone - create the instance fragment
        //  2. Adopt - adopt into the main document
        //  3. Process - find part markers and create parts
        //  4. Upgrade - upgrade custom elements
        //  5. Update - set node, attribute, property, etc., values
        //  6. Connect - connect to the document. Optional and outside of this
        //     method.
        //
        // We have a few constraints on the ordering of these steps:
        //  * We need to upgrade before updating, so that property values will pass
        //    through any property setters.
        //  * We would like to process before upgrading so that we're sure that the
        //    cloned fragment is inert and not disturbed by self-modifying DOM.
        //  * We want custom elements to upgrade even in disconnected fragments.
        //
        // Given these constraints, with full custom elements support we would
        // prefer the order: Clone, Process, Adopt, Upgrade, Update, Connect
        //
        // But Safari does not implement CustomElementRegistry#upgrade, so we
        // can not implement that order and still have upgrade-before-update and
        // upgrade disconnected fragments. So we instead sacrifice the
        // process-before-upgrade constraint, since in Custom Elements v1 elements
        // must not modify their light DOM in the constructor. We still have issues
        // when co-existing with CEv0 elements like Polymer 1, and with polyfills
        // that don't strictly adhere to the no-modification rule because shadow
        // DOM, which may be created in the constructor, is emulated by being placed
        // in the light DOM.
        //
        // The resulting order is on native is: Clone, Adopt, Upgrade, Process,
        // Update, Connect. document.importNode() performs Clone, Adopt, and Upgrade
        // in one step.
        //
        // The Custom Elements v1 polyfill supports upgrade(), so the order when
        // polyfilled is the more ideal: Clone, Process, Adopt, Upgrade, Update,
        // Connect.
        const fragment = _dom_js__WEBPACK_IMPORTED_MODULE_0__.isCEPolyfill ?
            this.template.element.content.cloneNode(true) :
            document.importNode(this.template.element.content, true);
        const stack = [];
        const parts = this.template.parts;
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(fragment, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */, null, false);
        let partIndex = 0;
        let nodeIndex = 0;
        let part;
        let node = walker.nextNode();
        // Loop through all the nodes and parts of a template
        while (partIndex < parts.length) {
            part = parts[partIndex];
            if (!(0,_template_js__WEBPACK_IMPORTED_MODULE_1__.isTemplatePartActive)(part)) {
                this.__parts.push(undefined);
                partIndex++;
                continue;
            }
            // Progress the tree walker until we find our next part's node.
            // Note that multiple parts may share the same node (attribute parts
            // on a single element), so this loop may not run at all.
            while (nodeIndex < part.index) {
                nodeIndex++;
                if (node.nodeName === 'TEMPLATE') {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
                if ((node = walker.nextNode()) === null) {
                    // We've exhausted the content inside a nested template element.
                    // Because we still have parts (the outer for-loop), we know:
                    // - There is a template in the stack
                    // - The walker will find a nextNode outside the template
                    walker.currentNode = stack.pop();
                    node = walker.nextNode();
                }
            }
            // We've arrived at our part's node.
            if (part.type === 'node') {
                const part = this.processor.handleTextExpression(this.options);
                part.insertAfterNode(node.previousSibling);
                this.__parts.push(part);
            }
            else {
                this.__parts.push(...this.processor.handleAttributeExpressions(node, part.name, part.strings, this.options));
            }
            partIndex++;
        }
        if (_dom_js__WEBPACK_IMPORTED_MODULE_0__.isCEPolyfill) {
            document.adoptNode(fragment);
            customElements.upgrade(fragment);
        }
        return fragment;
    }
}
//# sourceMappingURL=template-instance.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/template-result.js":
/*!**********************************************************!*\
  !*** ../../node_modules/lit-html/lib/template-result.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SVGTemplateResult: () => (/* binding */ SVGTemplateResult),
/* harmony export */   TemplateResult: () => (/* binding */ TemplateResult)
/* harmony export */ });
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dom.js */ "../../node_modules/lit-html/lib/dom.js");
/* harmony import */ var _template_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./template.js */ "../../node_modules/lit-html/lib/template.js");
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * @module lit-html
 */


/**
 * Our TrustedTypePolicy for HTML which is declared using the html template
 * tag function.
 *
 * That HTML is a developer-authored constant, and is parsed with innerHTML
 * before any untrusted expressions have been mixed in. Therefor it is
 * considered safe by construction.
 */
const policy = window.trustedTypes &&
    trustedTypes.createPolicy('lit-html', { createHTML: (s) => s });
const commentMarker = ` ${_template_js__WEBPACK_IMPORTED_MODULE_1__.marker} `;
/**
 * The return type of `html`, which holds a Template and the values from
 * interpolated expressions.
 */
class TemplateResult {
    constructor(strings, values, type, processor) {
        this.strings = strings;
        this.values = values;
        this.type = type;
        this.processor = processor;
    }
    /**
     * Returns a string of HTML used to create a `<template>` element.
     */
    getHTML() {
        const l = this.strings.length - 1;
        let html = '';
        let isCommentBinding = false;
        for (let i = 0; i < l; i++) {
            const s = this.strings[i];
            // For each binding we want to determine the kind of marker to insert
            // into the template source before it's parsed by the browser's HTML
            // parser. The marker type is based on whether the expression is in an
            // attribute, text, or comment position.
            //   * For node-position bindings we insert a comment with the marker
            //     sentinel as its text content, like <!--{{lit-guid}}-->.
            //   * For attribute bindings we insert just the marker sentinel for the
            //     first binding, so that we support unquoted attribute bindings.
            //     Subsequent bindings can use a comment marker because multi-binding
            //     attributes must be quoted.
            //   * For comment bindings we insert just the marker sentinel so we don't
            //     close the comment.
            //
            // The following code scans the template source, but is *not* an HTML
            // parser. We don't need to track the tree structure of the HTML, only
            // whether a binding is inside a comment, and if not, if it appears to be
            // the first binding in an attribute.
            const commentOpen = s.lastIndexOf('<!--');
            // We're in comment position if we have a comment open with no following
            // comment close. Because <-- can appear in an attribute value there can
            // be false positives.
            isCommentBinding = (commentOpen > -1 || isCommentBinding) &&
                s.indexOf('-->', commentOpen + 1) === -1;
            // Check to see if we have an attribute-like sequence preceding the
            // expression. This can match "name=value" like structures in text,
            // comments, and attribute values, so there can be false-positives.
            const attributeMatch = _template_js__WEBPACK_IMPORTED_MODULE_1__.lastAttributeNameRegex.exec(s);
            if (attributeMatch === null) {
                // We're only in this branch if we don't have a attribute-like
                // preceding sequence. For comments, this guards against unusual
                // attribute values like <div foo="<!--${'bar'}">. Cases like
                // <!-- foo=${'bar'}--> are handled correctly in the attribute branch
                // below.
                html += s + (isCommentBinding ? commentMarker : _template_js__WEBPACK_IMPORTED_MODULE_1__.nodeMarker);
            }
            else {
                // For attributes we use just a marker sentinel, and also append a
                // $lit$ suffix to the name to opt-out of attribute-specific parsing
                // that IE and Edge do for style and certain SVG attributes.
                html += s.substr(0, attributeMatch.index) + attributeMatch[1] +
                    attributeMatch[2] + _template_js__WEBPACK_IMPORTED_MODULE_1__.boundAttributeSuffix + attributeMatch[3] +
                    _template_js__WEBPACK_IMPORTED_MODULE_1__.marker;
            }
        }
        html += this.strings[l];
        return html;
    }
    getTemplateElement() {
        const template = document.createElement('template');
        let value = this.getHTML();
        if (policy !== undefined) {
            // this is secure because `this.strings` is a TemplateStringsArray.
            // TODO: validate this when
            // https://github.com/tc39/proposal-array-is-template-object is
            // implemented.
            value = policy.createHTML(value);
        }
        template.innerHTML = value;
        return template;
    }
}
/**
 * A TemplateResult for SVG fragments.
 *
 * This class wraps HTML in an `<svg>` tag in order to parse its contents in the
 * SVG namespace, then modifies the template to remove the `<svg>` tag so that
 * clones only container the original fragment.
 */
class SVGTemplateResult extends TemplateResult {
    getHTML() {
        return `<svg>${super.getHTML()}</svg>`;
    }
    getTemplateElement() {
        const template = super.getTemplateElement();
        const content = template.content;
        const svgElement = content.firstChild;
        content.removeChild(svgElement);
        (0,_dom_js__WEBPACK_IMPORTED_MODULE_0__.reparentNodes)(content, svgElement.firstChild);
        return template;
    }
}
//# sourceMappingURL=template-result.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lib/template.js":
/*!***************************************************!*\
  !*** ../../node_modules/lit-html/lib/template.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Template: () => (/* binding */ Template),
/* harmony export */   boundAttributeSuffix: () => (/* binding */ boundAttributeSuffix),
/* harmony export */   createMarker: () => (/* binding */ createMarker),
/* harmony export */   isTemplatePartActive: () => (/* binding */ isTemplatePartActive),
/* harmony export */   lastAttributeNameRegex: () => (/* binding */ lastAttributeNameRegex),
/* harmony export */   marker: () => (/* binding */ marker),
/* harmony export */   markerRegex: () => (/* binding */ markerRegex),
/* harmony export */   nodeMarker: () => (/* binding */ nodeMarker)
/* harmony export */ });
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * An expression marker with embedded unique key to avoid collision with
 * possible text in templates.
 */
const marker = `{{lit-${String(Math.random()).slice(2)}}}`;
/**
 * An expression marker used text-positions, multi-binding attributes, and
 * attributes with markup-like text values.
 */
const nodeMarker = `<!--${marker}-->`;
const markerRegex = new RegExp(`${marker}|${nodeMarker}`);
/**
 * Suffix appended to all bound attribute names.
 */
const boundAttributeSuffix = '$lit$';
/**
 * An updatable Template that tracks the location of dynamic parts.
 */
class Template {
    constructor(result, element) {
        this.parts = [];
        this.element = element;
        const nodesToRemove = [];
        const stack = [];
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(element.content, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */, null, false);
        // Keeps track of the last index associated with a part. We try to delete
        // unnecessary nodes, but we never want to associate two different parts
        // to the same index. They must have a constant node between.
        let lastPartIndex = 0;
        let index = -1;
        let partIndex = 0;
        const { strings, values: { length } } = result;
        while (partIndex < length) {
            const node = walker.nextNode();
            if (node === null) {
                // We've exhausted the content inside a nested template element.
                // Because we still have parts (the outer for-loop), we know:
                // - There is a template in the stack
                // - The walker will find a nextNode outside the template
                walker.currentNode = stack.pop();
                continue;
            }
            index++;
            if (node.nodeType === 1 /* Node.ELEMENT_NODE */) {
                if (node.hasAttributes()) {
                    const attributes = node.attributes;
                    const { length } = attributes;
                    // Per
                    // https://developer.mozilla.org/en-US/docs/Web/API/NamedNodeMap,
                    // attributes are not guaranteed to be returned in document order.
                    // In particular, Edge/IE can return them out of order, so we cannot
                    // assume a correspondence between part index and attribute index.
                    let count = 0;
                    for (let i = 0; i < length; i++) {
                        if (endsWith(attributes[i].name, boundAttributeSuffix)) {
                            count++;
                        }
                    }
                    while (count-- > 0) {
                        // Get the template literal section leading up to the first
                        // expression in this attribute
                        const stringForPart = strings[partIndex];
                        // Find the attribute name
                        const name = lastAttributeNameRegex.exec(stringForPart)[2];
                        // Find the corresponding attribute
                        // All bound attributes have had a suffix added in
                        // TemplateResult#getHTML to opt out of special attribute
                        // handling. To look up the attribute value we also need to add
                        // the suffix.
                        const attributeLookupName = name.toLowerCase() + boundAttributeSuffix;
                        const attributeValue = node.getAttribute(attributeLookupName);
                        node.removeAttribute(attributeLookupName);
                        const statics = attributeValue.split(markerRegex);
                        this.parts.push({ type: 'attribute', index, name, strings: statics });
                        partIndex += statics.length - 1;
                    }
                }
                if (node.tagName === 'TEMPLATE') {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
            }
            else if (node.nodeType === 3 /* Node.TEXT_NODE */) {
                const data = node.data;
                if (data.indexOf(marker) >= 0) {
                    const parent = node.parentNode;
                    const strings = data.split(markerRegex);
                    const lastIndex = strings.length - 1;
                    // Generate a new text node for each literal section
                    // These nodes are also used as the markers for node parts
                    for (let i = 0; i < lastIndex; i++) {
                        let insert;
                        let s = strings[i];
                        if (s === '') {
                            insert = createMarker();
                        }
                        else {
                            const match = lastAttributeNameRegex.exec(s);
                            if (match !== null && endsWith(match[2], boundAttributeSuffix)) {
                                s = s.slice(0, match.index) + match[1] +
                                    match[2].slice(0, -boundAttributeSuffix.length) + match[3];
                            }
                            insert = document.createTextNode(s);
                        }
                        parent.insertBefore(insert, node);
                        this.parts.push({ type: 'node', index: ++index });
                    }
                    // If there's no text, we must insert a comment to mark our place.
                    // Else, we can trust it will stick around after cloning.
                    if (strings[lastIndex] === '') {
                        parent.insertBefore(createMarker(), node);
                        nodesToRemove.push(node);
                    }
                    else {
                        node.data = strings[lastIndex];
                    }
                    // We have a part for each match found
                    partIndex += lastIndex;
                }
            }
            else if (node.nodeType === 8 /* Node.COMMENT_NODE */) {
                if (node.data === marker) {
                    const parent = node.parentNode;
                    // Add a new marker node to be the startNode of the Part if any of
                    // the following are true:
                    //  * We don't have a previousSibling
                    //  * The previousSibling is already the start of a previous part
                    if (node.previousSibling === null || index === lastPartIndex) {
                        index++;
                        parent.insertBefore(createMarker(), node);
                    }
                    lastPartIndex = index;
                    this.parts.push({ type: 'node', index });
                    // If we don't have a nextSibling, keep this node so we have an end.
                    // Else, we can remove it to save future costs.
                    if (node.nextSibling === null) {
                        node.data = '';
                    }
                    else {
                        nodesToRemove.push(node);
                        index--;
                    }
                    partIndex++;
                }
                else {
                    let i = -1;
                    while ((i = node.data.indexOf(marker, i + 1)) !== -1) {
                        // Comment node has a binding marker inside, make an inactive part
                        // The binding won't work, but subsequent bindings will
                        // TODO (justinfagnani): consider whether it's even worth it to
                        // make bindings in comments work
                        this.parts.push({ type: 'node', index: -1 });
                        partIndex++;
                    }
                }
            }
        }
        // Remove text binding nodes after the walk to not disturb the TreeWalker
        for (const n of nodesToRemove) {
            n.parentNode.removeChild(n);
        }
    }
}
const endsWith = (str, suffix) => {
    const index = str.length - suffix.length;
    return index >= 0 && str.slice(index) === suffix;
};
const isTemplatePartActive = (part) => part.index !== -1;
// Allows `document.createComment('')` to be renamed for a
// small manual size-savings.
const createMarker = () => document.createComment('');
/**
 * This regex extracts the attribute name preceding an attribute-position
 * expression. It does this by matching the syntax allowed for attributes
 * against the string literal directly preceding the expression, assuming that
 * the expression is in an attribute-value position.
 *
 * See attributes in the HTML spec:
 * https://www.w3.org/TR/html5/syntax.html#elements-attributes
 *
 * " \x09\x0a\x0c\x0d" are HTML space characters:
 * https://www.w3.org/TR/html5/infrastructure.html#space-characters
 *
 * "\0-\x1F\x7F-\x9F" are Unicode control characters, which includes every
 * space character except " ".
 *
 * So an attribute is:
 *  * The name: any character except a control character, space character, ('),
 *    ("), ">", "=", or "/"
 *  * Followed by zero or more space characters
 *  * Followed by "="
 *  * Followed by zero or more space characters
 *  * Followed by:
 *    * Any character except space, ('), ("), "<", ">", "=", (`), or
 *    * (") then any non-("), or
 *    * (') then any non-(')
 */
const lastAttributeNameRegex = 
// eslint-disable-next-line no-control-regex
/([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;
//# sourceMappingURL=template.js.map

/***/ }),

/***/ "../../node_modules/lit-html/lit-html.js":
/*!***********************************************!*\
  !*** ../../node_modules/lit-html/lit-html.js ***!
  \***********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AttributeCommitter: () => (/* reexport safe */ _lib_parts_js__WEBPACK_IMPORTED_MODULE_5__.AttributeCommitter),
/* harmony export */   AttributePart: () => (/* reexport safe */ _lib_parts_js__WEBPACK_IMPORTED_MODULE_5__.AttributePart),
/* harmony export */   BooleanAttributePart: () => (/* reexport safe */ _lib_parts_js__WEBPACK_IMPORTED_MODULE_5__.BooleanAttributePart),
/* harmony export */   DefaultTemplateProcessor: () => (/* reexport safe */ _lib_default_template_processor_js__WEBPACK_IMPORTED_MODULE_0__.DefaultTemplateProcessor),
/* harmony export */   EventPart: () => (/* reexport safe */ _lib_parts_js__WEBPACK_IMPORTED_MODULE_5__.EventPart),
/* harmony export */   NodePart: () => (/* reexport safe */ _lib_parts_js__WEBPACK_IMPORTED_MODULE_5__.NodePart),
/* harmony export */   PropertyCommitter: () => (/* reexport safe */ _lib_parts_js__WEBPACK_IMPORTED_MODULE_5__.PropertyCommitter),
/* harmony export */   PropertyPart: () => (/* reexport safe */ _lib_parts_js__WEBPACK_IMPORTED_MODULE_5__.PropertyPart),
/* harmony export */   SVGTemplateResult: () => (/* reexport safe */ _lib_template_result_js__WEBPACK_IMPORTED_MODULE_1__.SVGTemplateResult),
/* harmony export */   Template: () => (/* reexport safe */ _lib_template_js__WEBPACK_IMPORTED_MODULE_9__.Template),
/* harmony export */   TemplateInstance: () => (/* reexport safe */ _lib_template_instance_js__WEBPACK_IMPORTED_MODULE_8__.TemplateInstance),
/* harmony export */   TemplateResult: () => (/* reexport safe */ _lib_template_result_js__WEBPACK_IMPORTED_MODULE_1__.TemplateResult),
/* harmony export */   createMarker: () => (/* reexport safe */ _lib_template_js__WEBPACK_IMPORTED_MODULE_9__.createMarker),
/* harmony export */   defaultTemplateProcessor: () => (/* reexport safe */ _lib_default_template_processor_js__WEBPACK_IMPORTED_MODULE_0__.defaultTemplateProcessor),
/* harmony export */   directive: () => (/* reexport safe */ _lib_directive_js__WEBPACK_IMPORTED_MODULE_2__.directive),
/* harmony export */   html: () => (/* binding */ html),
/* harmony export */   isDirective: () => (/* reexport safe */ _lib_directive_js__WEBPACK_IMPORTED_MODULE_2__.isDirective),
/* harmony export */   isIterable: () => (/* reexport safe */ _lib_parts_js__WEBPACK_IMPORTED_MODULE_5__.isIterable),
/* harmony export */   isPrimitive: () => (/* reexport safe */ _lib_parts_js__WEBPACK_IMPORTED_MODULE_5__.isPrimitive),
/* harmony export */   isTemplatePartActive: () => (/* reexport safe */ _lib_template_js__WEBPACK_IMPORTED_MODULE_9__.isTemplatePartActive),
/* harmony export */   noChange: () => (/* reexport safe */ _lib_part_js__WEBPACK_IMPORTED_MODULE_4__.noChange),
/* harmony export */   nothing: () => (/* reexport safe */ _lib_part_js__WEBPACK_IMPORTED_MODULE_4__.nothing),
/* harmony export */   parts: () => (/* reexport safe */ _lib_render_js__WEBPACK_IMPORTED_MODULE_6__.parts),
/* harmony export */   removeNodes: () => (/* reexport safe */ _lib_dom_js__WEBPACK_IMPORTED_MODULE_3__.removeNodes),
/* harmony export */   render: () => (/* reexport safe */ _lib_render_js__WEBPACK_IMPORTED_MODULE_6__.render),
/* harmony export */   reparentNodes: () => (/* reexport safe */ _lib_dom_js__WEBPACK_IMPORTED_MODULE_3__.reparentNodes),
/* harmony export */   svg: () => (/* binding */ svg),
/* harmony export */   templateCaches: () => (/* reexport safe */ _lib_template_factory_js__WEBPACK_IMPORTED_MODULE_7__.templateCaches),
/* harmony export */   templateFactory: () => (/* reexport safe */ _lib_template_factory_js__WEBPACK_IMPORTED_MODULE_7__.templateFactory)
/* harmony export */ });
/* harmony import */ var _lib_default_template_processor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./lib/default-template-processor.js */ "../../node_modules/lit-html/lib/default-template-processor.js");
/* harmony import */ var _lib_template_result_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./lib/template-result.js */ "../../node_modules/lit-html/lib/template-result.js");
/* harmony import */ var _lib_directive_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./lib/directive.js */ "../../node_modules/lit-html/lib/directive.js");
/* harmony import */ var _lib_dom_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./lib/dom.js */ "../../node_modules/lit-html/lib/dom.js");
/* harmony import */ var _lib_part_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./lib/part.js */ "../../node_modules/lit-html/lib/part.js");
/* harmony import */ var _lib_parts_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./lib/parts.js */ "../../node_modules/lit-html/lib/parts.js");
/* harmony import */ var _lib_render_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./lib/render.js */ "../../node_modules/lit-html/lib/render.js");
/* harmony import */ var _lib_template_factory_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./lib/template-factory.js */ "../../node_modules/lit-html/lib/template-factory.js");
/* harmony import */ var _lib_template_instance_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./lib/template-instance.js */ "../../node_modules/lit-html/lib/template-instance.js");
/* harmony import */ var _lib_template_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./lib/template.js */ "../../node_modules/lit-html/lib/template.js");
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 *
 * Main lit-html module.
 *
 * Main exports:
 *
 * -  [[html]]
 * -  [[svg]]
 * -  [[render]]
 *
 * @packageDocumentation
 */
/**
 * Do not remove this comment; it keeps typedoc from misplacing the module
 * docs.
 */




// TODO(justinfagnani): remove line when we get NodePart moving methods








// IMPORTANT: do not change the property name or the assignment expression.
// This line will be used in regexes to search for lit-html usage.
// TODO(justinfagnani): inject version number at build time
if (typeof window !== 'undefined') {
    (window['litHtmlVersions'] || (window['litHtmlVersions'] = [])).push('1.4.1');
}
/**
 * Interprets a template literal as an HTML template that can efficiently
 * render to and update a container.
 */
const html = (strings, ...values) => new _lib_template_result_js__WEBPACK_IMPORTED_MODULE_1__.TemplateResult(strings, values, 'html', _lib_default_template_processor_js__WEBPACK_IMPORTED_MODULE_0__.defaultTemplateProcessor);
/**
 * Interprets a template literal as an SVG template that can efficiently
 * render to and update a container.
 */
const svg = (strings, ...values) => new _lib_template_result_js__WEBPACK_IMPORTED_MODULE_1__.SVGTemplateResult(strings, values, 'svg', _lib_default_template_processor_js__WEBPACK_IMPORTED_MODULE_0__.defaultTemplateProcessor);
//# sourceMappingURL=lit-html.js.map

/***/ }),

/***/ "../../node_modules/lodash/lodash.js":
/*!*******************************************!*\
  !*** ../../node_modules/lodash/lodash.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ "../../node_modules/luxon/src/datetime.js":
/*!************************************************!*\
  !*** ../../node_modules/luxon/src/datetime.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ DateTime),
/* harmony export */   friendlyDateTime: () => (/* binding */ friendlyDateTime)
/* harmony export */ });
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./duration.js */ "../../node_modules/luxon/src/duration.js");
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./interval.js */ "../../node_modules/luxon/src/interval.js");
/* harmony import */ var _settings_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./settings.js */ "../../node_modules/luxon/src/settings.js");
/* harmony import */ var _info_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./info.js */ "../../node_modules/luxon/src/info.js");
/* harmony import */ var _impl_formatter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./impl/formatter.js */ "../../node_modules/luxon/src/impl/formatter.js");
/* harmony import */ var _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./zones/fixedOffsetZone.js */ "../../node_modules/luxon/src/zones/fixedOffsetZone.js");
/* harmony import */ var _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./impl/locale.js */ "../../node_modules/luxon/src/impl/locale.js");
/* harmony import */ var _impl_util_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./impl/util.js */ "../../node_modules/luxon/src/impl/util.js");
/* harmony import */ var _impl_zoneUtil_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./impl/zoneUtil.js */ "../../node_modules/luxon/src/impl/zoneUtil.js");
/* harmony import */ var _impl_diff_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./impl/diff.js */ "../../node_modules/luxon/src/impl/diff.js");
/* harmony import */ var _impl_regexParser_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./impl/regexParser.js */ "../../node_modules/luxon/src/impl/regexParser.js");
/* harmony import */ var _impl_tokenParser_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./impl/tokenParser.js */ "../../node_modules/luxon/src/impl/tokenParser.js");
/* harmony import */ var _impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./impl/conversions.js */ "../../node_modules/luxon/src/impl/conversions.js");
/* harmony import */ var _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./impl/formats.js */ "../../node_modules/luxon/src/impl/formats.js");
/* harmony import */ var _errors_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./errors.js */ "../../node_modules/luxon/src/errors.js");
/* harmony import */ var _impl_invalid_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./impl/invalid.js */ "../../node_modules/luxon/src/impl/invalid.js");

















const INVALID = "Invalid DateTime";
const MAX_DATE = 8.64e15;

function unsupportedZone(zone) {
  return new _impl_invalid_js__WEBPACK_IMPORTED_MODULE_15__["default"]("unsupported zone", `the zone "${zone.name}" is not supported`);
}

// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.gregorianToWeek)(dt.c);
  }
  return dt.weekData;
}

/**
 * @param {DateTime} dt
 */
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.gregorianToWeek)(
      dt.c,
      dt.loc.getMinDaysInFirstWeek(),
      dt.loc.getStartOfWeek()
    );
  }
  return dt.localWeekData;
}

// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid,
  };
  return new DateTime({ ...current, ...alts, old: current });
}

// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  let utcGuess = localTS - o * 60 * 1000;

  // Test whether the zone matches the offset for this ts
  const o2 = tz.offset(utcGuess);

  // If so, offset didn't change and we're done
  if (o === o2) {
    return [utcGuess, o];
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= (o2 - o) * 60 * 1000;

  // If that gives us the local time we want, we're done
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }

  // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
}

// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;

  const d = new Date(ts);

  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds(),
  };
}

// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
  return fixOffset((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.objToLocalTS)(obj), offset, zone);
}

// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
  const oPre = inst.o,
    year = inst.c.year + Math.trunc(dur.years),
    month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
    c = {
      ...inst.c,
      year,
      month,
      day:
        Math.min(inst.c.day, (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.daysInMonth)(year, month)) +
        Math.trunc(dur.days) +
        Math.trunc(dur.weeks) * 7,
    },
    millisToAdd = _duration_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromObject({
      years: dur.years - Math.trunc(dur.years),
      quarters: dur.quarters - Math.trunc(dur.quarters),
      months: dur.months - Math.trunc(dur.months),
      weeks: dur.weeks - Math.trunc(dur.weeks),
      days: dur.days - Math.trunc(dur.days),
      hours: dur.hours,
      minutes: dur.minutes,
      seconds: dur.seconds,
      milliseconds: dur.milliseconds,
    }).as("milliseconds"),
    localTS = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.objToLocalTS)(c);

  let [ts, o] = fixOffset(localTS, oPre, inst.zone);

  if (millisToAdd !== 0) {
    ts += millisToAdd;
    // that could have changed the offset by going over a DST, but we want to keep the ts the same
    o = inst.zone.offset(ts);
  }

  return { ts, o };
}

// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if ((parsed && Object.keys(parsed).length !== 0) || parsedZone) {
    const interpretationZone = parsedZone || zone,
      inst = DateTime.fromObject(parsed, {
        ...opts,
        zone: interpretationZone,
        specificOffset,
      });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new _impl_invalid_js__WEBPACK_IMPORTED_MODULE_15__["default"]("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}

// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid
    ? _impl_formatter_js__WEBPACK_IMPORTED_MODULE_4__["default"].create(_impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].create("en-US"), {
        allowZ,
        forceSimple: true,
      }).formatDateTimeFromString(dt, format)
    : null;
}

function toISODate(o, extended) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(o.c.year, longFormat ? 6 : 4);

  if (extended) {
    c += "-";
    c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(o.c.month);
    c += "-";
    c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(o.c.day);
  } else {
    c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(o.c.month);
    c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(o.c.day);
  }
  return c;
}

function toISOTime(
  o,
  extended,
  suppressSeconds,
  suppressMilliseconds,
  includeOffset,
  extendedZone
) {
  let c = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(o.c.hour);
  if (extended) {
    c += ":";
    c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(o.c.minute);
  }

  if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
    c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(o.c.second);

    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(o.c.millisecond, 3);
    }
  }

  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(Math.trunc(-o.o / 60));
      c += ":";
      c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(Math.trunc(o.o / 60));
      c += ":";
      c += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.padStart)(Math.trunc(o.o % 60));
    }
  }

  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}

// defaults for unspecified units in the supported calendars
const defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  };

// Units in the supported calendars, sorted by bigness
const orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
  orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond",
  ],
  orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];

// standardize case and plurality in units
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal",
  }[unit.toLowerCase()];

  if (!normalized) throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.InvalidUnitError(unit);

  return normalized;
}

function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}

// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
function guessOffsetForZone(zone) {
  if (!zoneOffsetGuessCache[zone]) {
    if (zoneOffsetTs === undefined) {
      zoneOffsetTs = _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].now();
    }

    zoneOffsetGuessCache[zone] = zone.offset(zoneOffsetTs);
  }
  return zoneOffsetGuessCache[zone];
}

// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
  const zone = (0,_impl_zoneUtil_js__WEBPACK_IMPORTED_MODULE_8__.normalizeZone)(opts.zone, _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }

  const loc = _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromObject(opts);

  let ts, o;

  // assume we have the higher-order units
  if (!(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(obj.year)) {
    for (const u of orderedUnits) {
      if ((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }

    const invalid = (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.hasInvalidGregorianData)(obj) || (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.hasInvalidTimeData)(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }

    const offsetProvis = guessOffsetForZone(zone);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].now();
  }

  return new DateTime({ ts, zone, loc, o });
}

function diffRelative(start, end, opts) {
  const round = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(opts.round) ? true : opts.round,
    format = (c, unit) => {
      c = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.roundTo)(c, round || opts.calendary ? 0 : 2, true);
      const formatter = end.loc.clone(opts).relFormatter(opts);
      return formatter.format(c, unit);
    },
    differ = (unit) => {
      if (opts.calendary) {
        if (!end.hasSame(start, unit)) {
          return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
        } else return 0;
      } else {
        return end.diff(start, unit).get(unit);
      }
    };

  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }

  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}

function lastOpts(argList) {
  let opts = {},
    args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}

/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */
let zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */
let zoneOffsetGuessCache = {};

/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */
class DateTime {
  /**
   * @access private
   */
  constructor(config) {
    const zone = config.zone || _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultZone;

    let invalid =
      config.invalid ||
      (Number.isNaN(config.ts) ? new _impl_invalid_js__WEBPACK_IMPORTED_MODULE_15__["default"]("invalid input") : null) ||
      (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */
    this.ts = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(config.ts) ? _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].now() : config.ts;

    let c = null,
      o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);

      if (unchanged) {
        [c, o] = [config.old.c, config.old.o];
      } else {
        // If an offset has been passed and we have not been called from
        // clone(), we can trust it and avoid the offset calculation.
        const ot = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isNumber)(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new _impl_invalid_js__WEBPACK_IMPORTED_MODULE_15__["default"]("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }

    /**
     * @access private
     */
    this._zone = zone;
    /**
     * @access private
     */
    this.loc = config.loc || _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].create();
    /**
     * @access private
     */
    this.invalid = invalid;
    /**
     * @access private
     */
    this.weekData = null;
    /**
     * @access private
     */
    this.localWeekData = null;
    /**
     * @access private
     */
    this.c = c;
    /**
     * @access private
     */
    this.o = o;
    /**
     * @access private
     */
    this.isLuxonDateTime = true;
  }

  // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }

  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }

  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;

    opts.zone = _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_5__["default"].utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }

  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isDate)(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }

    const zoneToUse = (0,_impl_zoneUtil_js__WEBPACK_IMPORTED_MODULE_8__.normalizeZone)(options.zone, _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromObject(options),
    });
  }

  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isNumber)(milliseconds)) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: (0,_impl_zoneUtil_js__WEBPACK_IMPORTED_MODULE_8__.normalizeZone)(options.zone, _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultZone),
        loc: _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromObject(options),
      });
    }
  }

  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isNumber)(seconds)) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: (0,_impl_zoneUtil_js__WEBPACK_IMPORTED_MODULE_8__.normalizeZone)(options.zone, _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultZone),
        loc: _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromObject(options),
      });
    }
  }

  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = (0,_impl_zoneUtil_js__WEBPACK_IMPORTED_MODULE_8__.normalizeZone)(opts.zone, _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    const loc = _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromObject(opts);
    const normalized = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.normalizeObject)(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.usesLocalWeekValues)(normalized, loc);

    const tsNow = _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].now(),
      offsetProvis = !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(opts.specificOffset)
        ? opts.specificOffset
        : zoneToUse.offset(tsNow),
      containsOrdinal = !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.ordinal),
      containsGregorYear = !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.year),
      containsGregorMD = !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.month) || !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }

    if (containsGregorMD && containsOrdinal) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    const useWeekData = definiteWeekDef || (normalized.weekday && !containsGregor);

    // configure ourselves to deal with gregorian dates or week stuff
    let units,
      defaultValues,
      objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.gregorianToWeek)(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.gregorianToOrdinal)(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }

    // set default values for missing stuff
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }

    // make sure the values we have are in range
    const higherOrderInvalid = useWeekData
        ? (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.hasInvalidWeekData)(normalized, minDaysInFirstWeek, startOfWeek)
        : containsOrdinal
        ? (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.hasInvalidOrdinalData)(normalized)
        : (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.hasInvalidGregorianData)(normalized),
      invalid = higherOrderInvalid || (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.hasInvalidTimeData)(normalized);

    if (invalid) {
      return DateTime.invalid(invalid);
    }

    // compute the actual time
    const gregorian = useWeekData
        ? (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.weekToGregorian)(normalized, minDaysInFirstWeek, startOfWeek)
        : containsOrdinal
        ? (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.ordinalToGregorian)(normalized)
        : normalized,
      [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse),
      inst = new DateTime({
        ts: tsFinal,
        zone: zoneToUse,
        o: offsetFinal,
        loc,
      });

    // gregorian data + weekday serves only to validate
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }

    if (!inst.isValid) {
      return DateTime.invalid(inst.invalid);
    }

    return inst;
  }

  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = (0,_impl_regexParser_js__WEBPACK_IMPORTED_MODULE_10__.parseISODate)(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }

  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = (0,_impl_regexParser_js__WEBPACK_IMPORTED_MODULE_10__.parseRFC2822Date)(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }

  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = (0,_impl_regexParser_js__WEBPACK_IMPORTED_MODULE_10__.parseHTTPDate)(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }

  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if ((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(text) || (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(fmt)) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.InvalidArgumentError("fromFormat requires an input string and a format");
    }

    const { locale = null, numberingSystem = null } = opts,
      localeToUse = _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      }),
      [vals, parsedZone, specificOffset, invalid] = (0,_impl_tokenParser_js__WEBPACK_IMPORTED_MODULE_11__.parseFromTokens)(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }

  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }

  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = (0,_impl_regexParser_js__WEBPACK_IMPORTED_MODULE_10__.parseSQL)(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }

  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }

    const invalid = reason instanceof _impl_invalid_js__WEBPACK_IMPORTED_MODULE_15__["default"] ? reason : new _impl_invalid_js__WEBPACK_IMPORTED_MODULE_15__["default"](reason, explanation);

    if (_settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].throwOnInvalid) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.InvalidDateTimeError(invalid);
    } else {
      return new DateTime({ invalid });
    }
  }

  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return (o && o.isLuxonDateTime) || false;
  }

  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = (0,_impl_tokenParser_js__WEBPACK_IMPORTED_MODULE_11__.formatOptsToTokens)(formatOpts, _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => (t ? t.val : null)).join("");
  }

  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = (0,_impl_tokenParser_js__WEBPACK_IMPORTED_MODULE_11__.expandMacroTokens)(_impl_formatter_js__WEBPACK_IMPORTED_MODULE_4__["default"].parseFormat(fmt), _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }

  static resetCache() {
    zoneOffsetTs = undefined;
    zoneOffsetGuessCache = {};
  }

  // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }

  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }

  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }

  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }

  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }

  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }

  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }

  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }

  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }

  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }

  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }

  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }

  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }

  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }

  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }

  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }

  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }

  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }

  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }

  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.gregorianToOrdinal)(this.c).ordinal : NaN;
  }

  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? _info_js__WEBPACK_IMPORTED_MODULE_3__["default"].months("short", { locObj: this.loc })[this.month - 1] : null;
  }

  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? _info_js__WEBPACK_IMPORTED_MODULE_3__["default"].months("long", { locObj: this.loc })[this.month - 1] : null;
  }

  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? _info_js__WEBPACK_IMPORTED_MODULE_3__["default"].weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }

  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? _info_js__WEBPACK_IMPORTED_MODULE_3__["default"].weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }

  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }

  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }

  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }

  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }

  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return (
        this.offset > this.set({ month: 1, day: 1 }).offset ||
        this.offset > this.set({ month: 5 }).offset
      );
    }
  }

  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 86400000;
    const minuteMs = 60000;
    const localTS = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.objToLocalTS)(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);

    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (
      c1.hour === c2.hour &&
      c1.minute === c2.minute &&
      c1.second === c2.second &&
      c1.millisecond === c2.millisecond
    ) {
      return [clone(this, { ts: ts1 }), clone(this, { ts: ts2 })];
    }
    return [this];
  }

  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isLeapYear)(this.year);
  }

  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.daysInMonth)(this.year, this.month);
  }

  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.daysInYear)(this.year) : NaN;
  }

  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.weeksInWeekYear)(this.weekYear) : NaN;
  }

  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid
      ? (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.weeksInWeekYear)(
          this.localWeekYear,
          this.loc.getMinDaysInFirstWeek(),
          this.loc.getStartOfWeek()
        )
      : NaN;
  }

  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = _impl_formatter_js__WEBPACK_IMPORTED_MODULE_4__["default"].create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }

  // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset = 0, opts = {}) {
    return this.setZone(_zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_5__["default"].instance(offset), opts);
  }

  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(_settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultZone);
  }

  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = (0,_impl_zoneUtil_js__WEBPACK_IMPORTED_MODULE_8__.normalizeZone)(zone, _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone(this, { ts: newTS, zone });
    }
  }

  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone(this, { loc });
  }

  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }

  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values) {
    if (!this.isValid) return this;

    const normalized = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.normalizeObject)(values, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.usesLocalWeekValues)(normalized, this.loc);

    const settingWeekStuff =
        !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.weekYear) ||
        !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.weekNumber) ||
        !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.weekday),
      containsOrdinal = !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.ordinal),
      containsGregorYear = !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.year),
      containsGregorMD = !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.month) || !(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }

    if (containsGregorMD && containsOrdinal) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    let mixed;
    if (settingWeekStuff) {
      mixed = (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.weekToGregorian)(
        { ...(0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.gregorianToWeek)(this.c, minDaysInFirstWeek, startOfWeek), ...normalized },
        minDaysInFirstWeek,
        startOfWeek
      );
    } else if (!(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.ordinal)) {
      mixed = (0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.ordinalToGregorian)({ ...(0,_impl_conversions_js__WEBPACK_IMPORTED_MODULE_12__.gregorianToOrdinal)(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };

      // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month
      if ((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(normalized.day)) {
        mixed.day = Math.min((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.daysInMonth)(mixed.year, mixed.month), mixed.day);
      }
    }

    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone(this, { ts, o });
  }

  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = _duration_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }

  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = _duration_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }

  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;

    const o = {},
      normalizedUnit = _duration_js__WEBPACK_IMPORTED_MODULE_0__["default"].normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
      case "milliseconds":
        break;
      // no default, invalid units throw in normalizeUnit()
    }

    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }

    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }

    return this.set(o);
  }

  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid
      ? this.plus({ [unit]: 1 })
          .startOf(unit, opts)
          .minus(1)
      : this;
  }

  // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid
      ? _impl_formatter_js__WEBPACK_IMPORTED_MODULE_4__["default"].create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt)
      : INVALID;
  }

  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATE_SHORT, opts = {}) {
    return this.isValid
      ? _impl_formatter_js__WEBPACK_IMPORTED_MODULE_4__["default"].create(this.loc.clone(opts), formatOpts).formatDateTime(this)
      : INVALID;
  }

  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid
      ? _impl_formatter_js__WEBPACK_IMPORTED_MODULE_4__["default"].create(this.loc.clone(opts), opts).formatDateTimeParts(this)
      : [];
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false,
  } = {}) {
    if (!this.isValid) {
      return null;
    }

    const ext = format === "extended";

    let c = toISODate(this, ext);
    c += "T";
    c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }

    return toISODate(this, format === "extended");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended",
  } = {}) {
    if (!this.isValid) {
      return null;
    }

    let c = includePrefix ? "T" : "";
    return (
      c +
      toISOTime(
        this,
        format === "extended",
        suppressSeconds,
        suppressMilliseconds,
        includeOffset,
        extendedZone
      )
    );
  }

  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";

    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }

    return toTechFormat(this, fmt, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }

    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }

  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }

  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }

  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }

  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1000) : NaN;
  }

  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }

  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid) return {};

    const base = { ...this.c };

    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }

  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }

  // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return _duration_js__WEBPACK_IMPORTED_MODULE_0__["default"].invalid("created by diffing an invalid DateTime");
    }

    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };

    const units = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.maybeArray)(unit).map(_duration_js__WEBPACK_IMPORTED_MODULE_0__["default"].normalizeUnit),
      otherIsLater = otherDateTime.valueOf() > this.valueOf(),
      earlier = otherIsLater ? this : otherDateTime,
      later = otherIsLater ? otherDateTime : this,
      diffed = (0,_impl_diff_js__WEBPACK_IMPORTED_MODULE_9__["default"])(earlier, later, units, durOpts);

    return otherIsLater ? diffed.negate() : diffed;
  }

  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }

  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(otherDateTime) {
    return this.isValid ? _interval_js__WEBPACK_IMPORTED_MODULE_1__["default"].fromDateTimes(this, otherDateTime) : this;
  }

  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;

    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return (
      adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts)
    );
  }

  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return (
      this.isValid &&
      other.isValid &&
      this.valueOf() === other.valueOf() &&
      this.zone.equals(other.zone) &&
      this.loc.equals(other.loc)
    );
  }

  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || DateTime.fromObject({}, { zone: this.zone }),
      padding = options.padding ? (this < base ? -options.padding : options.padding) : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit,
    });
  }

  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;

    return diffRelative(options.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true,
    });
  }

  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.bestBy)(dateTimes, (i) => i.valueOf(), Math.min);
  }

  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.bestBy)(dateTimes, (i) => i.valueOf(), Math.max);
  }

  // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options,
      localeToUse = _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });
    return (0,_impl_tokenParser_js__WEBPACK_IMPORTED_MODULE_11__.explainFromTokens)(localeToUse, text, fmt);
  }

  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime.fromFormatExplain(text, fmt, options);
  }

  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options,
      localeToUse = _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });
    return new _impl_tokenParser_js__WEBPACK_IMPORTED_MODULE_11__.TokenParser(localeToUse, fmt);
  }

  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(text, formatParser, opts = {}) {
    if ((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(text) || (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isUndefined)(formatParser)) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.InvalidArgumentError(
        "fromFormatParser requires an input string and a format parser"
      );
    }
    const { locale = null, numberingSystem = null } = opts,
      localeToUse = _impl_locale_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });

    if (!localeToUse.equals(formatParser.locale)) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.InvalidArgumentError(
        `fromFormatParser called with a locale of ${localeToUse}, ` +
          `but the format parser was created for ${formatParser.locale}`
      );
    }

    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);

    if (invalidReason) {
      return DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(
        result,
        zone,
        opts,
        `format ${formatParser.format}`,
        text,
        specificOffset
      );
    }
  }

  // FORMAT PRESETS

  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATE_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATE_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATE_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATE_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATE_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.TIME_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.TIME_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.TIME_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.TIME_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.TIME_24_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.TIME_24_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.TIME_24_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.TIME_24_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATETIME_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATETIME_SHORT_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATETIME_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATETIME_MED_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATETIME_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATETIME_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATETIME_FULL_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATETIME_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return _impl_formats_js__WEBPACK_IMPORTED_MODULE_13__.DATETIME_HUGE_WITH_SECONDS;
  }
}

/**
 * @private
 */
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_7__.isNumber)(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new _errors_js__WEBPACK_IMPORTED_MODULE_14__.InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/duration.js":
/*!************************************************!*\
  !*** ../../node_modules/luxon/src/duration.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   accurateMatrix: () => (/* binding */ accurateMatrix),
/* harmony export */   casualMatrix: () => (/* binding */ casualMatrix),
/* harmony export */   daysInMonthAccurate: () => (/* binding */ daysInMonthAccurate),
/* harmony export */   daysInYearAccurate: () => (/* binding */ daysInYearAccurate),
/* harmony export */   "default": () => (/* binding */ Duration),
/* harmony export */   lowOrderMatrix: () => (/* binding */ lowOrderMatrix)
/* harmony export */ });
/* harmony import */ var _errors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./errors.js */ "../../node_modules/luxon/src/errors.js");
/* harmony import */ var _impl_formatter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./impl/formatter.js */ "../../node_modules/luxon/src/impl/formatter.js");
/* harmony import */ var _impl_invalid_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./impl/invalid.js */ "../../node_modules/luxon/src/impl/invalid.js");
/* harmony import */ var _impl_locale_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./impl/locale.js */ "../../node_modules/luxon/src/impl/locale.js");
/* harmony import */ var _impl_regexParser_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./impl/regexParser.js */ "../../node_modules/luxon/src/impl/regexParser.js");
/* harmony import */ var _impl_util_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./impl/util.js */ "../../node_modules/luxon/src/impl/util.js");
/* harmony import */ var _settings_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./settings.js */ "../../node_modules/luxon/src/settings.js");
/* harmony import */ var _datetime_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./datetime.js */ "../../node_modules/luxon/src/datetime.js");









const INVALID = "Invalid Duration";

// unit conversion constants
const lowOrderMatrix = {
    weeks: {
      days: 7,
      hours: 7 * 24,
      minutes: 7 * 24 * 60,
      seconds: 7 * 24 * 60 * 60,
      milliseconds: 7 * 24 * 60 * 60 * 1000,
    },
    days: {
      hours: 24,
      minutes: 24 * 60,
      seconds: 24 * 60 * 60,
      milliseconds: 24 * 60 * 60 * 1000,
    },
    hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1000 },
    minutes: { seconds: 60, milliseconds: 60 * 1000 },
    seconds: { milliseconds: 1000 },
  },
  casualMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: 52,
      days: 365,
      hours: 365 * 24,
      minutes: 365 * 24 * 60,
      seconds: 365 * 24 * 60 * 60,
      milliseconds: 365 * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: 13,
      days: 91,
      hours: 91 * 24,
      minutes: 91 * 24 * 60,
      seconds: 91 * 24 * 60 * 60,
      milliseconds: 91 * 24 * 60 * 60 * 1000,
    },
    months: {
      weeks: 4,
      days: 30,
      hours: 30 * 24,
      minutes: 30 * 24 * 60,
      seconds: 30 * 24 * 60 * 60,
      milliseconds: 30 * 24 * 60 * 60 * 1000,
    },

    ...lowOrderMatrix,
  },
  daysInYearAccurate = 146097.0 / 400,
  daysInMonthAccurate = 146097.0 / 4800,
  accurateMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: daysInYearAccurate / 7,
      days: daysInYearAccurate,
      hours: daysInYearAccurate * 24,
      minutes: daysInYearAccurate * 24 * 60,
      seconds: daysInYearAccurate * 24 * 60 * 60,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: daysInYearAccurate / 28,
      days: daysInYearAccurate / 4,
      hours: (daysInYearAccurate * 24) / 4,
      minutes: (daysInYearAccurate * 24 * 60) / 4,
      seconds: (daysInYearAccurate * 24 * 60 * 60) / 4,
      milliseconds: (daysInYearAccurate * 24 * 60 * 60 * 1000) / 4,
    },
    months: {
      weeks: daysInMonthAccurate / 7,
      days: daysInMonthAccurate,
      hours: daysInMonthAccurate * 24,
      minutes: daysInMonthAccurate * 24 * 60,
      seconds: daysInMonthAccurate * 24 * 60 * 60,
      milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000,
    },
    ...lowOrderMatrix,
  };

// units ordered by size
const orderedUnits = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds",
];

const reverseUnits = orderedUnits.slice(0).reverse();

// clone really means "create another instance just like this one, but with these changes"
function clone(dur, alts, clear = false) {
  // deep merge for vals
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...(alts.values || {}) },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix,
  };
  return new Duration(conf);
}

function durationToMillis(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}

// NB: mutates parameters
function normalizeValues(matrix, vals) {
  // the logic below assumes the overall value of the duration is positive
  // if this is not the case, factor is used to make it so
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;

  orderedUnits.reduceRight((previous, current) => {
    if (!(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.isUndefined)(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];

        // if (previousVal < 0):
        // lower order unit is negative (e.g. { years: 2, days: -2 })
        // normalize this by reducing the higher order unit by the appropriate amount
        // and increasing the lower order unit
        // this can never make the higher order unit negative, because this function only operates
        // on positive durations, so the amount of time represented by the lower order unit cannot
        // be larger than the higher order unit
        // else:
        // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
        // in this case we attempt to convert as much as possible from the lower order unit into
        // the higher order one
        //
        // Math.floor takes care of both of these cases, rounding away from 0
        // if previousVal < 0 it makes the absolute value larger
        // if previousVal >= it makes the absolute value smaller
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);

  // try to convert any decimals into smaller units if possible
  // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
  orderedUnits.reduce((previous, current) => {
    if (!(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.isUndefined)(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}

// Remove all properties with a value of 0 from an object
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}

/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */
class Duration {
  /**
   * @private
   */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;

    if (config.matrix) {
      matrix = config.matrix;
    }

    /**
     * @access private
     */
    this.values = config.values;
    /**
     * @access private
     */
    this.loc = config.loc || _impl_locale_js__WEBPACK_IMPORTED_MODULE_3__["default"].create();
    /**
     * @access private
     */
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.matrix = matrix;
    /**
     * @access private
     */
    this.isLuxonDuration = true;
  }

  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return Duration.fromObject({ milliseconds: count }, opts);
  }

  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${
          obj === null ? "null" : typeof obj
        }`
      );
    }

    return new Duration({
      values: (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.normalizeObject)(obj, Duration.normalizeUnit),
      loc: _impl_locale_js__WEBPACK_IMPORTED_MODULE_3__["default"].fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix,
    });
  }

  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if ((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.isNumber)(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }

  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = (0,_impl_regexParser_js__WEBPACK_IMPORTED_MODULE_4__.parseISODuration)(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = (0,_impl_regexParser_js__WEBPACK_IMPORTED_MODULE_4__.parseISOTimeOnly)(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.InvalidArgumentError("need to specify a reason the Duration is invalid");
    }

    const invalid = reason instanceof _impl_invalid_js__WEBPACK_IMPORTED_MODULE_2__["default"] ? reason : new _impl_invalid_js__WEBPACK_IMPORTED_MODULE_2__["default"](reason, explanation);

    if (_settings_js__WEBPACK_IMPORTED_MODULE_6__["default"].throwOnInvalid) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.InvalidDurationError(invalid);
    } else {
      return new Duration({ invalid });
    }
  }

  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds",
    }[unit ? unit.toLowerCase() : unit];

    if (!normalized) throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.InvalidUnitError(unit);

    return normalized;
  }

  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return (o && o.isLuxonDuration) || false;
  }

  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false,
    };
    return this.isValid
      ? _impl_formatter_js__WEBPACK_IMPORTED_MODULE_1__["default"].create(this.loc, fmtOpts).formatDurationFromString(this, fmt)
      : INVALID;
  }

  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID;

    const l = orderedUnits
      .map((unit) => {
        const val = this.values[unit];
        if ((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.isUndefined)(val)) {
          return null;
        }
        return this.loc
          .numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) })
          .format(val);
      })
      .filter((n) => n);

    return this.loc
      .listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts })
      .format(l);
  }

  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid) return {};
    return { ...this.values };
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;

    let s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      // this will handle "floating point madness" by removing extra decimal places
      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      s += (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.roundTo)(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;

    const millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;

    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false,
    };

    const dateTime = _datetime_js__WEBPACK_IMPORTED_MODULE_7__["default"].fromMillis(millis, { zone: "UTC" });
    return dateTime.toISOTime(opts);
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }

  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid) return NaN;

    return durationToMillis(this.matrix, this.values);
  }

  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid) return this;

    const dur = Duration.fromDurationLike(duration),
      result = {};

    for (const k of orderedUnits) {
      if ((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.hasOwnProperty)(dur.values, k) || (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.hasOwnProperty)(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }

    return clone(this, { values: result }, true);
  }

  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid) return this;

    const dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }

  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.asNumber)(fn(this.values[k], k));
    }
    return clone(this, { values: result }, true);
  }

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }

  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values) {
    if (!this.isValid) return this;

    const mixed = { ...this.values, ...(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.normalizeObject)(values, Duration.normalizeUnit) };
    return clone(this, { values: mixed });
  }

  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone(this, opts);
  }

  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }

  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone(this, { values: vals }, true);
  }

  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone(this, { values: vals }, true);
  }

  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid) return this;

    if (units.length === 0) {
      return this;
    }

    units = units.map((u) => Duration.normalizeUnit(u));

    const built = {},
      accumulated = {},
      vals = this.toObject();
    let lastUnit;

    for (const k of orderedUnits) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;

        let own = 0;

        // anything we haven't boiled down yet should get boiled to this unit
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }

        // plus anything that's already in this unit
        if ((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.isNumber)(vals[k])) {
          own += vals[k];
        }

        // only keep the integer part for now in the hopes of putting any decimal part
        // into a smaller unit later
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1000 - i * 1000) / 1000;

        // otherwise, keep it in the wings to boil it later
      } else if ((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.isNumber)(vals[k])) {
        accumulated[k] = vals[k];
      }
    }

    // anything leftover becomes the decimal for the last unit
    // lastUnit must be defined since units is not empty
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] +=
          key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }

    normalizeValues(this.matrix, built);
    return clone(this, { values: built }, true);
  }

  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }

  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone(this, { values: negated }, true);
  }

  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }

  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }

  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }

  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }

  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }

  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }

  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }

  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }

  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }

  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    if (!this.loc.equals(other.loc)) {
      return false;
    }

    function eq(v1, v2) {
      // Consider 0 and undefined as equal
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }

    for (const u of orderedUnits) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/errors.js":
/*!**********************************************!*\
  !*** ../../node_modules/luxon/src/errors.js ***!
  \**********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ConflictingSpecificationError: () => (/* binding */ ConflictingSpecificationError),
/* harmony export */   InvalidArgumentError: () => (/* binding */ InvalidArgumentError),
/* harmony export */   InvalidDateTimeError: () => (/* binding */ InvalidDateTimeError),
/* harmony export */   InvalidDurationError: () => (/* binding */ InvalidDurationError),
/* harmony export */   InvalidIntervalError: () => (/* binding */ InvalidIntervalError),
/* harmony export */   InvalidUnitError: () => (/* binding */ InvalidUnitError),
/* harmony export */   ZoneIsAbstractError: () => (/* binding */ ZoneIsAbstractError)
/* harmony export */ });
// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
class LuxonError extends Error {}

/**
 * @private
 */
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class ConflictingSpecificationError extends LuxonError {}

/**
 * @private
 */
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}

/**
 * @private
 */
class InvalidArgumentError extends LuxonError {}

/**
 * @private
 */
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/impl/conversions.js":
/*!********************************************************!*\
  !*** ../../node_modules/luxon/src/impl/conversions.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   dayOfWeek: () => (/* binding */ dayOfWeek),
/* harmony export */   gregorianToOrdinal: () => (/* binding */ gregorianToOrdinal),
/* harmony export */   gregorianToWeek: () => (/* binding */ gregorianToWeek),
/* harmony export */   hasInvalidGregorianData: () => (/* binding */ hasInvalidGregorianData),
/* harmony export */   hasInvalidOrdinalData: () => (/* binding */ hasInvalidOrdinalData),
/* harmony export */   hasInvalidTimeData: () => (/* binding */ hasInvalidTimeData),
/* harmony export */   hasInvalidWeekData: () => (/* binding */ hasInvalidWeekData),
/* harmony export */   isoWeekdayToLocal: () => (/* binding */ isoWeekdayToLocal),
/* harmony export */   ordinalToGregorian: () => (/* binding */ ordinalToGregorian),
/* harmony export */   usesLocalWeekValues: () => (/* binding */ usesLocalWeekValues),
/* harmony export */   weekToGregorian: () => (/* binding */ weekToGregorian)
/* harmony export */ });
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util.js */ "../../node_modules/luxon/src/impl/util.js");
/* harmony import */ var _invalid_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./invalid.js */ "../../node_modules/luxon/src/impl/invalid.js");
/* harmony import */ var _errors_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../errors.js */ "../../node_modules/luxon/src/errors.js");




const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
  leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];

function unitOutOfRange(unit, value) {
  return new _invalid_js__WEBPACK_IMPORTED_MODULE_1__["default"](
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}

function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));

  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }

  const js = d.getUTCDay();

  return js === 0 ? 7 : js;
}

function computeOrdinal(year, month, day) {
  return day + ((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isLeapYear)(year) ? leapLadder : nonLeapLadder)[month - 1];
}

function uncomputeOrdinal(year, ordinal) {
  const table = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isLeapYear)(year) ? leapLadder : nonLeapLadder,
    month0 = table.findIndex((i) => i < ordinal),
    day = ordinal - table[month0];
  return { month: month0 + 1, day };
}

function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return ((isoWeekday - startOfWeek + 7) % 7) + 1;
}

/**
 * @private
 */

function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj,
    ordinal = computeOrdinal(year, month, day),
    weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);

  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7),
    weekYear;

  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.weeksInWeekYear)(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.weeksInWeekYear)(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }

  return { weekYear, weekNumber, weekday, ...(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.timeObject)(gregObj) };
}

function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData,
    weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek),
    yearInDays = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.daysInYear)(weekYear);

  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek,
    year;

  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.daysInYear)(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.daysInYear)(weekYear);
  } else {
    year = weekYear;
  }

  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.timeObject)(weekData) };
}

function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.timeObject)(gregData) };
}

function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.timeObject)(ordinalData) };
}

/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData =
    !(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(obj.localWeekday) ||
    !(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(obj.localWeekNumber) ||
    !(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData =
      !(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(obj.weekday) || !(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(obj.weekNumber) || !(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(obj.weekYear);

    if (hasIsoWeekData) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_2__.ConflictingSpecificationError(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    }
    if (!(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek(),
    };
  } else {
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
  }
}

function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isInteger)(obj.weekYear),
    validWeek = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.integerBetween)(
      obj.weekNumber,
      1,
      (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.weeksInWeekYear)(obj.weekYear, minDaysInFirstWeek, startOfWeek)
    ),
    validWeekday = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.integerBetween)(obj.weekday, 1, 7);

  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}

function hasInvalidOrdinalData(obj) {
  const validYear = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isInteger)(obj.year),
    validOrdinal = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.integerBetween)(obj.ordinal, 1, (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.daysInYear)(obj.year));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}

function hasInvalidGregorianData(obj) {
  const validYear = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isInteger)(obj.year),
    validMonth = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.integerBetween)(obj.month, 1, 12),
    validDay = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.integerBetween)(obj.day, 1, (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.daysInMonth)(obj.year, obj.month));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}

function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour =
      (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.integerBetween)(hour, 0, 23) ||
      (hour === 24 && minute === 0 && second === 0 && millisecond === 0),
    validMinute = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.integerBetween)(minute, 0, 59),
    validSecond = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.integerBetween)(second, 0, 59),
    validMillisecond = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.integerBetween)(millisecond, 0, 999);

  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}


/***/ }),

/***/ "../../node_modules/luxon/src/impl/diff.js":
/*!*************************************************!*\
  !*** ../../node_modules/luxon/src/impl/diff.js ***!
  \*************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* export default binding */ __WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../duration.js */ "../../node_modules/luxon/src/duration.js");


function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(),
    ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(_duration_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromMillis(ms).as("days"));
}

function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - (days % 7)) / 7;
      },
    ],
    ["days", dayDiff],
  ];

  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;

  /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;

      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);

      if (highWater > later) {
        // we overshot the end point, backtrack cursor by 1
        results[unit]--;
        cursor = earlier.plus(results);

        // if we are still overshooting now, we need to backtrack again
        // this happens in certain situations when diffing times in different zones,
        // because this calculation ignores time zones
        if (cursor > later) {
          // keep the "overshot by 1" around as highWater
          highWater = cursor;
          // backtrack cursor by 1
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }

  return [cursor, results, highWater, lowestOrder];
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);

  const remainingMillis = later - cursor;

  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );

  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }

    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }

  const duration = _duration_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromObject(results, opts);

  if (lowerOrderUnits.length > 0) {
    return _duration_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromMillis(remainingMillis, opts)
      .shiftTo(...lowerOrderUnits)
      .plus(duration);
  } else {
    return duration;
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/impl/digits.js":
/*!***************************************************!*\
  !*** ../../node_modules/luxon/src/impl/digits.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   digitRegex: () => (/* binding */ digitRegex),
/* harmony export */   parseDigits: () => (/* binding */ parseDigits),
/* harmony export */   resetDigitRegexCache: () => (/* binding */ resetDigitRegexCache)
/* harmony export */ });
const numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d",
};

const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881],
};

const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");

function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);

      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}

// cache of {numberingSystem: {append: regex}}
let digitRegexCache = {};
function resetDigitRegexCache() {
  digitRegexCache = {};
}

function digitRegex({ numberingSystem }, append = "") {
  const ns = numberingSystem || "latn";

  if (!digitRegexCache[ns]) {
    digitRegexCache[ns] = {};
  }
  if (!digitRegexCache[ns][append]) {
    digitRegexCache[ns][append] = new RegExp(`${numberingSystems[ns]}${append}`);
  }

  return digitRegexCache[ns][append];
}


/***/ }),

/***/ "../../node_modules/luxon/src/impl/english.js":
/*!****************************************************!*\
  !*** ../../node_modules/luxon/src/impl/english.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   eraForDateTime: () => (/* binding */ eraForDateTime),
/* harmony export */   eras: () => (/* binding */ eras),
/* harmony export */   erasLong: () => (/* binding */ erasLong),
/* harmony export */   erasNarrow: () => (/* binding */ erasNarrow),
/* harmony export */   erasShort: () => (/* binding */ erasShort),
/* harmony export */   formatRelativeTime: () => (/* binding */ formatRelativeTime),
/* harmony export */   formatString: () => (/* binding */ formatString),
/* harmony export */   meridiemForDateTime: () => (/* binding */ meridiemForDateTime),
/* harmony export */   meridiems: () => (/* binding */ meridiems),
/* harmony export */   monthForDateTime: () => (/* binding */ monthForDateTime),
/* harmony export */   months: () => (/* binding */ months),
/* harmony export */   monthsLong: () => (/* binding */ monthsLong),
/* harmony export */   monthsNarrow: () => (/* binding */ monthsNarrow),
/* harmony export */   monthsShort: () => (/* binding */ monthsShort),
/* harmony export */   weekdayForDateTime: () => (/* binding */ weekdayForDateTime),
/* harmony export */   weekdays: () => (/* binding */ weekdays),
/* harmony export */   weekdaysLong: () => (/* binding */ weekdaysLong),
/* harmony export */   weekdaysNarrow: () => (/* binding */ weekdaysNarrow),
/* harmony export */   weekdaysShort: () => (/* binding */ weekdaysShort)
/* harmony export */ });
/* harmony import */ var _formats_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./formats.js */ "../../node_modules/luxon/src/impl/formats.js");
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util.js */ "../../node_modules/luxon/src/impl/util.js");



function stringify(obj) {
  return JSON.stringify(obj, Object.keys(obj).sort());
}

/**
 * @private
 */

const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];

function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}

const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];

function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}

const meridiems = ["AM", "PM"];

const erasLong = ["Before Christ", "Anno Domini"];

const erasShort = ["BC", "AD"];

const erasNarrow = ["B", "A"];

function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}

function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}

function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}

function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}

function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}

function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."],
  };

  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;

  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
      default: // fall through
    }
  }

  const isInPast = Object.is(count, -0) || count < 0,
    fmtValue = Math.abs(count),
    singular = fmtValue === 1,
    lilUnits = units[unit],
    fmtUnit = narrow
      ? singular
        ? lilUnits[1]
        : lilUnits[2] || lilUnits[1]
      : singular
      ? units[unit][0]
      : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}

function formatString(knownFormat) {
  // these all have the offsets removed because we don't have access to them
  // without all the intl stuff this is backfilling
  const filtered = (0,_util_js__WEBPACK_IMPORTED_MODULE_1__.pick)(knownFormat, [
      "weekday",
      "era",
      "year",
      "month",
      "day",
      "hour",
      "minute",
      "second",
      "timeZoneName",
      "hourCycle",
    ]),
    key = stringify(filtered),
    dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";
  switch (key) {
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATE_SHORT):
      return "M/d/yyyy";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATE_MED):
      return "LLL d, yyyy";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATE_MED_WITH_WEEKDAY):
      return "EEE, LLL d, yyyy";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATE_FULL):
      return "LLLL d, yyyy";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATE_HUGE):
      return "EEEE, LLLL d, yyyy";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.TIME_SIMPLE):
      return "h:mm a";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.TIME_WITH_SECONDS):
      return "h:mm:ss a";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.TIME_WITH_SHORT_OFFSET):
      return "h:mm a";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.TIME_WITH_LONG_OFFSET):
      return "h:mm a";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.TIME_24_SIMPLE):
      return "HH:mm";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.TIME_24_WITH_SECONDS):
      return "HH:mm:ss";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.TIME_24_WITH_SHORT_OFFSET):
      return "HH:mm";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.TIME_24_WITH_LONG_OFFSET):
      return "HH:mm";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATETIME_SHORT):
      return "M/d/yyyy, h:mm a";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATETIME_MED):
      return "LLL d, yyyy, h:mm a";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATETIME_FULL):
      return "LLLL d, yyyy, h:mm a";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATETIME_HUGE):
      return dateTimeHuge;
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATETIME_SHORT_WITH_SECONDS):
      return "M/d/yyyy, h:mm:ss a";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATETIME_MED_WITH_SECONDS):
      return "LLL d, yyyy, h:mm:ss a";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATETIME_MED_WITH_WEEKDAY):
      return "EEE, d LLL yyyy, h:mm a";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATETIME_FULL_WITH_SECONDS):
      return "LLLL d, yyyy, h:mm:ss a";
    case stringify(_formats_js__WEBPACK_IMPORTED_MODULE_0__.DATETIME_HUGE_WITH_SECONDS):
      return "EEEE, LLLL d, yyyy, h:mm:ss a";
    default:
      return dateTimeHuge;
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/impl/formats.js":
/*!****************************************************!*\
  !*** ../../node_modules/luxon/src/impl/formats.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DATETIME_FULL: () => (/* binding */ DATETIME_FULL),
/* harmony export */   DATETIME_FULL_WITH_SECONDS: () => (/* binding */ DATETIME_FULL_WITH_SECONDS),
/* harmony export */   DATETIME_HUGE: () => (/* binding */ DATETIME_HUGE),
/* harmony export */   DATETIME_HUGE_WITH_SECONDS: () => (/* binding */ DATETIME_HUGE_WITH_SECONDS),
/* harmony export */   DATETIME_MED: () => (/* binding */ DATETIME_MED),
/* harmony export */   DATETIME_MED_WITH_SECONDS: () => (/* binding */ DATETIME_MED_WITH_SECONDS),
/* harmony export */   DATETIME_MED_WITH_WEEKDAY: () => (/* binding */ DATETIME_MED_WITH_WEEKDAY),
/* harmony export */   DATETIME_SHORT: () => (/* binding */ DATETIME_SHORT),
/* harmony export */   DATETIME_SHORT_WITH_SECONDS: () => (/* binding */ DATETIME_SHORT_WITH_SECONDS),
/* harmony export */   DATE_FULL: () => (/* binding */ DATE_FULL),
/* harmony export */   DATE_HUGE: () => (/* binding */ DATE_HUGE),
/* harmony export */   DATE_MED: () => (/* binding */ DATE_MED),
/* harmony export */   DATE_MED_WITH_WEEKDAY: () => (/* binding */ DATE_MED_WITH_WEEKDAY),
/* harmony export */   DATE_SHORT: () => (/* binding */ DATE_SHORT),
/* harmony export */   TIME_24_SIMPLE: () => (/* binding */ TIME_24_SIMPLE),
/* harmony export */   TIME_24_WITH_LONG_OFFSET: () => (/* binding */ TIME_24_WITH_LONG_OFFSET),
/* harmony export */   TIME_24_WITH_SECONDS: () => (/* binding */ TIME_24_WITH_SECONDS),
/* harmony export */   TIME_24_WITH_SHORT_OFFSET: () => (/* binding */ TIME_24_WITH_SHORT_OFFSET),
/* harmony export */   TIME_SIMPLE: () => (/* binding */ TIME_SIMPLE),
/* harmony export */   TIME_WITH_LONG_OFFSET: () => (/* binding */ TIME_WITH_LONG_OFFSET),
/* harmony export */   TIME_WITH_SECONDS: () => (/* binding */ TIME_WITH_SECONDS),
/* harmony export */   TIME_WITH_SHORT_OFFSET: () => (/* binding */ TIME_WITH_SHORT_OFFSET)
/* harmony export */ });
/**
 * @private
 */

const n = "numeric",
  s = "short",
  l = "long";

const DATE_SHORT = {
  year: n,
  month: n,
  day: n,
};

const DATE_MED = {
  year: n,
  month: s,
  day: n,
};

const DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
};

const DATE_FULL = {
  year: n,
  month: l,
  day: n,
};

const DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
};

const TIME_SIMPLE = {
  hour: n,
  minute: n,
};

const TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
};

const TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s,
};

const TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l,
};

const TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23",
};

const TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
};

const TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s,
};

const TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l,
};

const DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
};

const DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n,
};

const DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
};

const DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n,
};

const DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n,
};

const DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s,
};

const DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s,
};

const DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l,
};

const DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l,
};


/***/ }),

/***/ "../../node_modules/luxon/src/impl/formatter.js":
/*!******************************************************!*\
  !*** ../../node_modules/luxon/src/impl/formatter.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Formatter)
/* harmony export */ });
/* harmony import */ var _english_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./english.js */ "../../node_modules/luxon/src/impl/english.js");
/* harmony import */ var _formats_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./formats.js */ "../../node_modules/luxon/src/impl/formats.js");
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util.js */ "../../node_modules/luxon/src/impl/util.js");




function stringifyTokens(splits, tokenToString) {
  let s = "";
  for (const token of splits) {
    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }
  return s;
}

const macroTokenToFormatOpts = {
  D: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATE_SHORT,
  DD: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATE_MED,
  DDD: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATE_FULL,
  DDDD: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATE_HUGE,
  t: _formats_js__WEBPACK_IMPORTED_MODULE_1__.TIME_SIMPLE,
  tt: _formats_js__WEBPACK_IMPORTED_MODULE_1__.TIME_WITH_SECONDS,
  ttt: _formats_js__WEBPACK_IMPORTED_MODULE_1__.TIME_WITH_SHORT_OFFSET,
  tttt: _formats_js__WEBPACK_IMPORTED_MODULE_1__.TIME_WITH_LONG_OFFSET,
  T: _formats_js__WEBPACK_IMPORTED_MODULE_1__.TIME_24_SIMPLE,
  TT: _formats_js__WEBPACK_IMPORTED_MODULE_1__.TIME_24_WITH_SECONDS,
  TTT: _formats_js__WEBPACK_IMPORTED_MODULE_1__.TIME_24_WITH_SHORT_OFFSET,
  TTTT: _formats_js__WEBPACK_IMPORTED_MODULE_1__.TIME_24_WITH_LONG_OFFSET,
  f: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATETIME_SHORT,
  ff: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATETIME_MED,
  fff: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATETIME_FULL,
  ffff: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATETIME_HUGE,
  F: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATETIME_SHORT_WITH_SECONDS,
  FF: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATETIME_MED_WITH_SECONDS,
  FFF: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATETIME_FULL_WITH_SECONDS,
  FFFF: _formats_js__WEBPACK_IMPORTED_MODULE_1__.DATETIME_HUGE_WITH_SECONDS,
};

/**
 * @private
 */

class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }

  static parseFormat(fmt) {
    // white-space is always considered a literal in user-provided formats
    // the " " token has a special meaning (see unitForToken)

    let current = null,
      currentFull = "",
      bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }

    if (currentFull.length > 0) {
      splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
    }

    return splits;
  }

  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }

  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }

  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }

  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, { ...this.opts, ...opts });
  }

  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }

  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }

  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }

  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }

  num(n, p = 0) {
    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return (0,_util_js__WEBPACK_IMPORTED_MODULE_2__.padStart)(n, p);
    }

    const opts = { ...this.opts };

    if (p > 0) {
      opts.padTo = p;
    }

    return this.loc.numberFormatter(opts).format(n);
  }

  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en",
      useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory",
      string = (opts, extract) => this.loc.extract(dt, opts, extract),
      formatOffset = (opts) => {
        if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
          return "Z";
        }

        return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
      },
      meridiem = () =>
        knownEnglish
          ? _english_js__WEBPACK_IMPORTED_MODULE_0__.meridiemForDateTime(dt)
          : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"),
      month = (length, standalone) =>
        knownEnglish
          ? _english_js__WEBPACK_IMPORTED_MODULE_0__.monthForDateTime(dt, length)
          : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"),
      weekday = (length, standalone) =>
        knownEnglish
          ? _english_js__WEBPACK_IMPORTED_MODULE_0__.weekdayForDateTime(dt, length)
          : string(
              standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
              "weekday"
            ),
      maybeMacro = (token) => {
        const formatOpts = Formatter.macroTokenToFormatOpts(token);
        if (formatOpts) {
          return this.formatWithSystemDefault(dt, formatOpts);
        } else {
          return token;
        }
      },
      era = (length) =>
        knownEnglish ? _english_js__WEBPACK_IMPORTED_MODULE_0__.eraForDateTime(dt, length) : string({ era: length }, "era"),
      tokenToString = (token) => {
        // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
        switch (token) {
          // ms
          case "S":
            return this.num(dt.millisecond);
          case "u":
          // falls through
          case "SSS":
            return this.num(dt.millisecond, 3);
          // seconds
          case "s":
            return this.num(dt.second);
          case "ss":
            return this.num(dt.second, 2);
          // fractional seconds
          case "uu":
            return this.num(Math.floor(dt.millisecond / 10), 2);
          case "uuu":
            return this.num(Math.floor(dt.millisecond / 100));
          // minutes
          case "m":
            return this.num(dt.minute);
          case "mm":
            return this.num(dt.minute, 2);
          // hours
          case "h":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
          case "hh":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
          case "H":
            return this.num(dt.hour);
          case "HH":
            return this.num(dt.hour, 2);
          // offset
          case "Z":
            // like +6
            return formatOffset({ format: "narrow", allowZ: this.opts.allowZ });
          case "ZZ":
            // like +06:00
            return formatOffset({ format: "short", allowZ: this.opts.allowZ });
          case "ZZZ":
            // like +0600
            return formatOffset({ format: "techie", allowZ: this.opts.allowZ });
          case "ZZZZ":
            // like EST
            return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
          case "ZZZZZ":
            // like Eastern Standard Time
            return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
          // zone
          case "z":
            // like America/New_York
            return dt.zoneName;
          // meridiems
          case "a":
            return meridiem();
          // dates
          case "d":
            return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
          case "dd":
            return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
          // weekdays - standalone
          case "c":
            // like 1
            return this.num(dt.weekday);
          case "ccc":
            // like 'Tues'
            return weekday("short", true);
          case "cccc":
            // like 'Tuesday'
            return weekday("long", true);
          case "ccccc":
            // like 'T'
            return weekday("narrow", true);
          // weekdays - format
          case "E":
            // like 1
            return this.num(dt.weekday);
          case "EEE":
            // like 'Tues'
            return weekday("short", false);
          case "EEEE":
            // like 'Tuesday'
            return weekday("long", false);
          case "EEEEE":
            // like 'T'
            return weekday("narrow", false);
          // months - standalone
          case "L":
            // like 1
            return useDateTimeFormatter
              ? string({ month: "numeric", day: "numeric" }, "month")
              : this.num(dt.month);
          case "LL":
            // like 01, doesn't seem to work
            return useDateTimeFormatter
              ? string({ month: "2-digit", day: "numeric" }, "month")
              : this.num(dt.month, 2);
          case "LLL":
            // like Jan
            return month("short", true);
          case "LLLL":
            // like January
            return month("long", true);
          case "LLLLL":
            // like J
            return month("narrow", true);
          // months - format
          case "M":
            // like 1
            return useDateTimeFormatter
              ? string({ month: "numeric" }, "month")
              : this.num(dt.month);
          case "MM":
            // like 01
            return useDateTimeFormatter
              ? string({ month: "2-digit" }, "month")
              : this.num(dt.month, 2);
          case "MMM":
            // like Jan
            return month("short", false);
          case "MMMM":
            // like January
            return month("long", false);
          case "MMMMM":
            // like J
            return month("narrow", false);
          // years
          case "y":
            // like 2014
            return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
          case "yy":
            // like 14
            return useDateTimeFormatter
              ? string({ year: "2-digit" }, "year")
              : this.num(dt.year.toString().slice(-2), 2);
          case "yyyy":
            // like 0012
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 4);
          case "yyyyyy":
            // like 000012
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 6);
          // eras
          case "G":
            // like AD
            return era("short");
          case "GG":
            // like Anno Domini
            return era("long");
          case "GGGGG":
            return era("narrow");
          case "kk":
            return this.num(dt.weekYear.toString().slice(-2), 2);
          case "kkkk":
            return this.num(dt.weekYear, 4);
          case "W":
            return this.num(dt.weekNumber);
          case "WW":
            return this.num(dt.weekNumber, 2);
          case "n":
            return this.num(dt.localWeekNumber);
          case "nn":
            return this.num(dt.localWeekNumber, 2);
          case "ii":
            return this.num(dt.localWeekYear.toString().slice(-2), 2);
          case "iiii":
            return this.num(dt.localWeekYear, 4);
          case "o":
            return this.num(dt.ordinal);
          case "ooo":
            return this.num(dt.ordinal, 3);
          case "q":
            // like 1
            return this.num(dt.quarter);
          case "qq":
            // like 01
            return this.num(dt.quarter, 2);
          case "X":
            return this.num(Math.floor(dt.ts / 1000));
          case "x":
            return this.num(dt.ts);
          default:
            return maybeMacro(token);
        }
      };

    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }

  formatDurationFromString(dur, fmt) {
    const tokenToField = (token) => {
        switch (token[0]) {
          case "S":
            return "millisecond";
          case "s":
            return "second";
          case "m":
            return "minute";
          case "h":
            return "hour";
          case "d":
            return "day";
          case "w":
            return "week";
          case "M":
            return "month";
          case "y":
            return "year";
          default:
            return null;
        }
      },
      tokenToString = (lildur) => (token) => {
        const mapped = tokenToField(token);
        if (mapped) {
          return this.num(lildur.get(mapped), token.length);
        } else {
          return token;
        }
      },
      tokens = Formatter.parseFormat(fmt),
      realTokens = tokens.reduce(
        (found, { literal, val }) => (literal ? found : found.concat(val)),
        []
      ),
      collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/impl/invalid.js":
/*!****************************************************!*\
  !*** ../../node_modules/luxon/src/impl/invalid.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Invalid)
/* harmony export */ });
class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }

  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/impl/locale.js":
/*!***************************************************!*\
  !*** ../../node_modules/luxon/src/impl/locale.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Locale)
/* harmony export */ });
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util.js */ "../../node_modules/luxon/src/impl/util.js");
/* harmony import */ var _english_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./english.js */ "../../node_modules/luxon/src/impl/english.js");
/* harmony import */ var _settings_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../settings.js */ "../../node_modules/luxon/src/settings.js");
/* harmony import */ var _datetime_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../datetime.js */ "../../node_modules/luxon/src/datetime.js");
/* harmony import */ var _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../zones/IANAZone.js */ "../../node_modules/luxon/src/zones/IANAZone.js");






// todo - remap caching

let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}

let intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}

let intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}

let intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts; // exclude `base` from the options
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}

let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}

let weekInfoCache = {};
function getCachedWeekInfo(locString) {
  let data = weekInfoCache[locString];
  if (!data) {
    const locale = new Intl.Locale(locString);
    // browsers currently implement this as a property, but spec says it should be a getter function
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data;
  }
  return data;
}

function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:

  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u

  // private subtags and unicode subtags have ordering requirements,
  // and we're not properly parsing this, so just strip out the
  // private ones if they exist.
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }

  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }

    const { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}

function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }

    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }

    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}

function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = _datetime_js__WEBPACK_IMPORTED_MODULE_3__["default"].utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}

function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = _datetime_js__WEBPACK_IMPORTED_MODULE_3__["default"].utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}

function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();

  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}

function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return (
      loc.numberingSystem === "latn" ||
      !loc.locale ||
      loc.locale.startsWith("en") ||
      new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn"
    );
  }
}

/**
 * @private
 */

class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;

    const { padTo, floor, ...otherOpts } = opts;

    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }

  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      // to match the browser's numberformatter defaults
      const fixed = this.floor ? Math.floor(i) : (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.roundTo)(i, 3);
      return (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.padStart)(fixed, this.padTo);
    }
  }
}

/**
 * @private
 */

class PolyDateFormatter {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = undefined;

    let z = undefined;
    if (this.opts.timeZone) {
      // Don't apply any workarounds if a timeZone is explicitly provided in opts
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_4__["default"].create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
        // we manually apply the offset and substitute the zone as needed.
        z = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({ minutes: dt.offset });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z = dt.zone.name;
    } else {
      // Custom zones can have any offset / offsetName so we just manually
      // apply the offset and substitute the zone as needed.
      z = "UTC";
      this.dt = dt.setZone("UTC").plus({ minutes: dt.offset });
      this.originalZone = dt.zone;
    }

    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }

  format() {
    if (this.originalZone) {
      // If we have to substitute in the actual zone name, we have to use
      // formatToParts so that the timezone can be replaced.
      return this.formatToParts()
        .map(({ value }) => value)
        .join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }

  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName,
          });
          return {
            ...part,
            value: offsetName,
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }

  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}

/**
 * @private
 */
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.hasRelative)()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }

  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return _english_js__WEBPACK_IMPORTED_MODULE_1__.formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }

  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}

const fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7],
};

/**
 * @private
 */

class Locale {
  static fromOpts(opts) {
    return Locale.create(
      opts.locale,
      opts.numberingSystem,
      opts.outputCalendar,
      opts.weekSettings,
      opts.defaultToEN
    );
  }

  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultLocale;
    // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultNumberingSystem;
    const outputCalendarR = outputCalendar || _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultOutputCalendar;
    const weekSettingsR = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.validateWeekSettings)(weekSettings) || _settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultWeekSettings;
    return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }

  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }

  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }

  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);

    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);

    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};

    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }

  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }

    return this.fastNumbersCached;
  }

  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness =
      (this.numberingSystem === null || this.numberingSystem === "latn") &&
      (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }

  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.validateWeekSettings)(alts.weekSettings) || this.weekSettings,
        alts.defaultToEN || false
      );
    }
  }

  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }

  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }

  months(length, format = false) {
    return listStuff(this, length, _english_js__WEBPACK_IMPORTED_MODULE_1__.months, () => {
      const intl = format ? { month: length, day: "numeric" } : { month: length },
        formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }

  weekdays(length, format = false) {
    return listStuff(this, length, _english_js__WEBPACK_IMPORTED_MODULE_1__.weekdays, () => {
      const intl = format
          ? { weekday: length, year: "numeric", month: "long", day: "numeric" }
          : { weekday: length },
        formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays((dt) =>
          this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }

  meridiems() {
    return listStuff(
      this,
      undefined,
      () => _english_js__WEBPACK_IMPORTED_MODULE_1__.meridiems,
      () => {
        // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
        // for AM and PM. This is probably wrong, but it's makes parsing way easier.
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [_datetime_js__WEBPACK_IMPORTED_MODULE_3__["default"].utc(2016, 11, 13, 9), _datetime_js__WEBPACK_IMPORTED_MODULE_3__["default"].utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }

        return this.meridiemCache;
      }
    );
  }

  eras(length) {
    return listStuff(this, length, _english_js__WEBPACK_IMPORTED_MODULE_1__.eras, () => {
      const intl = { era: length };

      // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.
      if (!this.eraCache[length]) {
        this.eraCache[length] = [_datetime_js__WEBPACK_IMPORTED_MODULE_3__["default"].utc(-40, 1, 1), _datetime_js__WEBPACK_IMPORTED_MODULE_3__["default"].utc(2017, 1, 1)].map((dt) =>
          this.extract(dt, intl, "era")
        );
      }

      return this.eraCache[length];
    });
  }

  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts),
      results = df.formatToParts(),
      matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }

  numberFormatter(opts = {}) {
    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the rest of the condition is used heavily)
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }

  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }

  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }

  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }

  isEnglish() {
    return (
      this.locale === "en" ||
      this.locale.toLowerCase() === "en-us" ||
      new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us")
    );
  }

  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.hasLocaleWeekInfo)()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }

  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }

  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }

  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }

  equals(other) {
    return (
      this.locale === other.locale &&
      this.numberingSystem === other.numberingSystem &&
      this.outputCalendar === other.outputCalendar
    );
  }

  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/impl/regexParser.js":
/*!********************************************************!*\
  !*** ../../node_modules/luxon/src/impl/regexParser.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   parseHTTPDate: () => (/* binding */ parseHTTPDate),
/* harmony export */   parseISODate: () => (/* binding */ parseISODate),
/* harmony export */   parseISODuration: () => (/* binding */ parseISODuration),
/* harmony export */   parseISOTimeOnly: () => (/* binding */ parseISOTimeOnly),
/* harmony export */   parseRFC2822Date: () => (/* binding */ parseRFC2822Date),
/* harmony export */   parseSQL: () => (/* binding */ parseSQL)
/* harmony export */ });
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util.js */ "../../node_modules/luxon/src/impl/util.js");
/* harmony import */ var _english_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./english.js */ "../../node_modules/luxon/src/impl/english.js");
/* harmony import */ var _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../zones/fixedOffsetZone.js */ "../../node_modules/luxon/src/zones/fixedOffsetZone.js");
/* harmony import */ var _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../zones/IANAZone.js */ "../../node_modules/luxon/src/zones/IANAZone.js");





/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;

function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}

function combineExtractors(...extractors) {
  return (m) =>
    extractors
      .reduce(
        ([mergedVals, mergedZone, cursor], ex) => {
          const [val, zone, next] = ex(m, cursor);
          return [{ ...mergedVals, ...val }, zone || mergedZone, next];
        },
        [{}, null, 1]
      )
      .slice(0, 2);
}

function parse(s, ...patterns) {
  if (s == null) {
    return [null, null];
  }

  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}

function simpleParse(...keys) {
  return (match, cursor) => {
    const ret = {};
    let i;

    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseInteger)(match[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}

// ISO and SQL parsing
const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);

function int(match, pos, fallback) {
  const m = match[pos];
  return (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(m) ? fallback : (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseInteger)(m);
}

function extractISOYmd(match, cursor) {
  const item = {
    year: int(match, cursor),
    month: int(match, cursor + 1, 1),
    day: int(match, cursor + 2, 1),
  };

  return [item, null, cursor + 3];
}

function extractISOTime(match, cursor) {
  const item = {
    hours: int(match, cursor, 0),
    minutes: int(match, cursor + 1, 0),
    seconds: int(match, cursor + 2, 0),
    milliseconds: (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseMillis)(match[cursor + 3]),
  };

  return [item, null, cursor + 4];
}

function extractISOOffset(match, cursor) {
  const local = !match[cursor] && !match[cursor + 1],
    fullOffset = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.signedOffset)(match[cursor + 1], match[cursor + 2]),
    zone = local ? null : _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_2__["default"].instance(fullOffset);
  return [{}, zone, cursor + 3];
}

function extractIANAZone(match, cursor) {
  const zone = match[cursor] ? _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_3__["default"].create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
}

// ISO time parsing

const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);

// ISO duration parsing

const isoDuration =
  /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;

function extractISODuration(match) {
  const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] =
    match;

  const hasNegativePrefix = s[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";

  const maybeNegate = (num, force = false) =>
    num !== undefined && (force || (num && hasNegativePrefix)) ? -num : num;

  return [
    {
      years: maybeNegate((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseFloating)(yearStr)),
      months: maybeNegate((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseFloating)(monthStr)),
      weeks: maybeNegate((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseFloating)(weekStr)),
      days: maybeNegate((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseFloating)(dayStr)),
      hours: maybeNegate((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseFloating)(hourStr)),
      minutes: maybeNegate((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseFloating)(minuteStr)),
      seconds: maybeNegate((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseFloating)(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseMillis)(millisecondsStr), negativeSeconds),
    },
  ];
}

// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60,
};

function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.untruncateYear)((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseInteger)(yearStr)) : (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseInteger)(yearStr),
    month: _english_js__WEBPACK_IMPORTED_MODULE_1__.monthsShort.indexOf(monthStr) + 1,
    day: (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseInteger)(dayStr),
    hour: (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseInteger)(hourStr),
    minute: (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseInteger)(minuteStr),
  };

  if (secondStr) result.second = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseInteger)(secondStr);
  if (weekdayStr) {
    result.weekday =
      weekdayStr.length > 3
        ? _english_js__WEBPACK_IMPORTED_MODULE_1__.weekdaysLong.indexOf(weekdayStr) + 1
        : _english_js__WEBPACK_IMPORTED_MODULE_1__.weekdaysShort.indexOf(weekdayStr) + 1;
  }

  return result;
}

// RFC 2822/5322
const rfc2822 =
  /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;

function extractRFC2822(match) {
  const [
      ,
      weekdayStr,
      dayStr,
      monthStr,
      yearStr,
      hourStr,
      minuteStr,
      secondStr,
      obsOffset,
      milOffset,
      offHourStr,
      offMinuteStr,
    ] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);

  let offset;
  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.signedOffset)(offHourStr, offMinuteStr);
  }

  return [result, new _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_2__["default"](offset)];
}

function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s
    .replace(/\([^()]*\)|[\n\t]/g, " ")
    .replace(/(\s\s+)/g, " ")
    .trim();
}

// http date

const rfc1123 =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
  rfc850 =
    /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
  ascii =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;

function extractRFC1123Or850(match) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_2__["default"].utcInstance];
}

function extractASCII(match) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_2__["default"].utcInstance];
}

const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);

const extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);

/*
 * @private
 */

function parseISODate(s) {
  return parse(
    s,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}

function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}

function parseHTTPDate(s) {
  return parse(
    s,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}

function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}

const extractISOTimeOnly = combineExtractors(extractISOTime);

function parseISOTimeOnly(s) {
  return parse(s, [isoTimeOnly, extractISOTimeOnly]);
}

const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);

const extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);

function parseSQL(s) {
  return parse(
    s,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}


/***/ }),

/***/ "../../node_modules/luxon/src/impl/tokenParser.js":
/*!********************************************************!*\
  !*** ../../node_modules/luxon/src/impl/tokenParser.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TokenParser: () => (/* binding */ TokenParser),
/* harmony export */   expandMacroTokens: () => (/* binding */ expandMacroTokens),
/* harmony export */   explainFromTokens: () => (/* binding */ explainFromTokens),
/* harmony export */   formatOptsToTokens: () => (/* binding */ formatOptsToTokens),
/* harmony export */   parseFromTokens: () => (/* binding */ parseFromTokens)
/* harmony export */ });
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util.js */ "../../node_modules/luxon/src/impl/util.js");
/* harmony import */ var _formatter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./formatter.js */ "../../node_modules/luxon/src/impl/formatter.js");
/* harmony import */ var _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../zones/fixedOffsetZone.js */ "../../node_modules/luxon/src/zones/fixedOffsetZone.js");
/* harmony import */ var _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../zones/IANAZone.js */ "../../node_modules/luxon/src/zones/IANAZone.js");
/* harmony import */ var _datetime_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../datetime.js */ "../../node_modules/luxon/src/datetime.js");
/* harmony import */ var _digits_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./digits.js */ "../../node_modules/luxon/src/impl/digits.js");
/* harmony import */ var _errors_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../errors.js */ "../../node_modules/luxon/src/errors.js");








const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";

function intUnit(regex, post = (i) => i) {
  return { regex, deser: ([s]) => post((0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.parseDigits)(s)) };
}

const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");

function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}

function stripInsensitivities(s) {
  return s
    .replace(/\./g, "") // ignore dots that were made optional
    .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}

function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s]) =>
        strings.findIndex((i) => stripInsensitivities(s) === stripInsensitivities(i)) + startIndex,
    };
  }
}

function offset(regex, groups) {
  return { regex, deser: ([, h, m]) => (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.signedOffset)(h, m), groups };
}

function simple(regex) {
  return { regex, deser: ([s]) => s };
}

function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

/**
 * @param token
 * @param {Locale} loc
 */
function unitForToken(token, loc) {
  const one = (0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.digitRegex)(loc),
    two = (0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.digitRegex)(loc, "{2}"),
    three = (0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.digitRegex)(loc, "{3}"),
    four = (0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.digitRegex)(loc, "{4}"),
    six = (0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.digitRegex)(loc, "{6}"),
    oneOrTwo = (0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.digitRegex)(loc, "{1,2}"),
    oneToThree = (0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.digitRegex)(loc, "{1,3}"),
    oneToSix = (0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.digitRegex)(loc, "{1,6}"),
    oneToNine = (0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.digitRegex)(loc, "{1,9}"),
    twoToFour = (0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.digitRegex)(loc, "{2,4}"),
    fourToSix = (0,_digits_js__WEBPACK_IMPORTED_MODULE_5__.digitRegex)(loc, "{4,6}"),
    literal = (t) => ({ regex: RegExp(escapeToken(t.val)), deser: ([s]) => s, literal: true }),
    unitate = (t) => {
      if (token.literal) {
        return literal(t);
      }
      switch (t.val) {
        // era
        case "G":
          return oneOf(loc.eras("short"), 0);
        case "GG":
          return oneOf(loc.eras("long"), 0);
        // years
        case "y":
          return intUnit(oneToSix);
        case "yy":
          return intUnit(twoToFour, _util_js__WEBPACK_IMPORTED_MODULE_0__.untruncateYear);
        case "yyyy":
          return intUnit(four);
        case "yyyyy":
          return intUnit(fourToSix);
        case "yyyyyy":
          return intUnit(six);
        // months
        case "M":
          return intUnit(oneOrTwo);
        case "MM":
          return intUnit(two);
        case "MMM":
          return oneOf(loc.months("short", true), 1);
        case "MMMM":
          return oneOf(loc.months("long", true), 1);
        case "L":
          return intUnit(oneOrTwo);
        case "LL":
          return intUnit(two);
        case "LLL":
          return oneOf(loc.months("short", false), 1);
        case "LLLL":
          return oneOf(loc.months("long", false), 1);
        // dates
        case "d":
          return intUnit(oneOrTwo);
        case "dd":
          return intUnit(two);
        // ordinals
        case "o":
          return intUnit(oneToThree);
        case "ooo":
          return intUnit(three);
        // time
        case "HH":
          return intUnit(two);
        case "H":
          return intUnit(oneOrTwo);
        case "hh":
          return intUnit(two);
        case "h":
          return intUnit(oneOrTwo);
        case "mm":
          return intUnit(two);
        case "m":
          return intUnit(oneOrTwo);
        case "q":
          return intUnit(oneOrTwo);
        case "qq":
          return intUnit(two);
        case "s":
          return intUnit(oneOrTwo);
        case "ss":
          return intUnit(two);
        case "S":
          return intUnit(oneToThree);
        case "SSS":
          return intUnit(three);
        case "u":
          return simple(oneToNine);
        case "uu":
          return simple(oneOrTwo);
        case "uuu":
          return intUnit(one);
        // meridiem
        case "a":
          return oneOf(loc.meridiems(), 0);
        // weekYear (k)
        case "kkkk":
          return intUnit(four);
        case "kk":
          return intUnit(twoToFour, _util_js__WEBPACK_IMPORTED_MODULE_0__.untruncateYear);
        // weekNumber (W)
        case "W":
          return intUnit(oneOrTwo);
        case "WW":
          return intUnit(two);
        // weekdays
        case "E":
        case "c":
          return intUnit(one);
        case "EEE":
          return oneOf(loc.weekdays("short", false), 1);
        case "EEEE":
          return oneOf(loc.weekdays("long", false), 1);
        case "ccc":
          return oneOf(loc.weekdays("short", true), 1);
        case "cccc":
          return oneOf(loc.weekdays("long", true), 1);
        // offset/zone
        case "Z":
        case "ZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
        case "ZZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
        // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
        // because we don't have any way to figure out what they are
        case "z":
          return simple(/[a-z_+-/]{1,256}?/i);
        // this special-case "token" represents a place where a macro-token expanded into a white-space literal
        // in this case we accept any non-newline white-space
        case " ":
          return simple(/[^\S\n\r]/);
        default:
          return literal(t);
      }
    };

  const unit = unitate(token) || {
    invalidReason: MISSING_FTP,
  };

  unit.token = token;

  return unit;
}

const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy",
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM",
  },
  day: {
    numeric: "d",
    "2-digit": "dd",
  },
  weekday: {
    short: "EEE",
    long: "EEEE",
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh",
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH",
  },
  minute: {
    numeric: "m",
    "2-digit": "mm",
  },
  second: {
    numeric: "s",
    "2-digit": "ss",
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ",
  },
};

function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;

  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value,
    };
  }

  const style = formatOpts[type];

  // The user might have explicitly specified hour12 or hourCycle
  // if so, respect their decision
  // if not, refer back to the resolvedOpts, which are based on the locale
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      // tokens only differentiate between 24 hours or not,
      // so we do not need to check hourCycle here, which is less supported anyways
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }

  if (val) {
    return {
      literal: false,
      val,
    };
  }

  return undefined;
}

function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [`^${re}$`, units];
}

function match(input, regex, handlers) {
  const matches = input.match(regex);

  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if ((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.hasOwnProperty)(handlers, i)) {
        const h = handlers[i],
          groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}

function dateTimeFromMatches(matches) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };

  let zone = null;
  let specificOffset;
  if (!(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(matches.z)) {
    zone = _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_3__["default"].create(matches.z);
  }

  if (!(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(matches.Z)) {
    if (!zone) {
      zone = new _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_2__["default"](matches.Z);
    }
    specificOffset = matches.Z;
  }

  if (!(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }

  if (!(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }

  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }

  if (!(0,_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(matches.u)) {
    matches.S = (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.parseMillis)(matches.u);
  }

  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }

    return r;
  }, {});

  return [vals, zone, specificOffset];
}

let dummyDateTimeCache = null;

function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = _datetime_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromMillis(1555555555555);
  }

  return dummyDateTimeCache;
}

function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }

  const formatOpts = _formatter_js__WEBPACK_IMPORTED_MODULE_1__["default"].macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);

  if (tokens == null || tokens.includes(undefined)) {
    return token;
  }

  return tokens;
}

function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}

/**
 * @private
 */

class TokenParser {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(_formatter_js__WEBPACK_IMPORTED_MODULE_1__["default"].parseFormat(format), locale);
    this.units = this.tokens.map((t) => unitForToken(t, locale));
    this.disqualifyingUnit = this.units.find((t) => t.invalidReason);

    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }

  explainFromTokens(input) {
    if (!this.isValid) {
      return { input, tokens: this.tokens, invalidReason: this.invalidReason };
    } else {
      const [rawMatches, matches] = match(input, this.regex, this.handlers),
        [result, zone, specificOffset] = matches
          ? dateTimeFromMatches(matches)
          : [null, null, undefined];
      if ((0,_util_js__WEBPACK_IMPORTED_MODULE_0__.hasOwnProperty)(matches, "a") && (0,_util_js__WEBPACK_IMPORTED_MODULE_0__.hasOwnProperty)(matches, "H")) {
        throw new _errors_js__WEBPACK_IMPORTED_MODULE_6__.ConflictingSpecificationError(
          "Can't include meridiem when specifying 24-hour format"
        );
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset,
      };
    }
  }

  get isValid() {
    return !this.disqualifyingUnit;
  }

  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}

function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}

function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}

function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }

  const formatter = _formatter_js__WEBPACK_IMPORTED_MODULE_1__["default"].create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}


/***/ }),

/***/ "../../node_modules/luxon/src/impl/util.js":
/*!*************************************************!*\
  !*** ../../node_modules/luxon/src/impl/util.js ***!
  \*************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   asNumber: () => (/* binding */ asNumber),
/* harmony export */   bestBy: () => (/* binding */ bestBy),
/* harmony export */   daysInMonth: () => (/* binding */ daysInMonth),
/* harmony export */   daysInYear: () => (/* binding */ daysInYear),
/* harmony export */   floorMod: () => (/* binding */ floorMod),
/* harmony export */   formatOffset: () => (/* binding */ formatOffset),
/* harmony export */   hasLocaleWeekInfo: () => (/* binding */ hasLocaleWeekInfo),
/* harmony export */   hasOwnProperty: () => (/* binding */ hasOwnProperty),
/* harmony export */   hasRelative: () => (/* binding */ hasRelative),
/* harmony export */   integerBetween: () => (/* binding */ integerBetween),
/* harmony export */   isDate: () => (/* binding */ isDate),
/* harmony export */   isInteger: () => (/* binding */ isInteger),
/* harmony export */   isLeapYear: () => (/* binding */ isLeapYear),
/* harmony export */   isNumber: () => (/* binding */ isNumber),
/* harmony export */   isString: () => (/* binding */ isString),
/* harmony export */   isUndefined: () => (/* binding */ isUndefined),
/* harmony export */   maybeArray: () => (/* binding */ maybeArray),
/* harmony export */   normalizeObject: () => (/* binding */ normalizeObject),
/* harmony export */   objToLocalTS: () => (/* binding */ objToLocalTS),
/* harmony export */   padStart: () => (/* binding */ padStart),
/* harmony export */   parseFloating: () => (/* binding */ parseFloating),
/* harmony export */   parseInteger: () => (/* binding */ parseInteger),
/* harmony export */   parseMillis: () => (/* binding */ parseMillis),
/* harmony export */   parseZoneInfo: () => (/* binding */ parseZoneInfo),
/* harmony export */   pick: () => (/* binding */ pick),
/* harmony export */   roundTo: () => (/* binding */ roundTo),
/* harmony export */   signedOffset: () => (/* binding */ signedOffset),
/* harmony export */   timeObject: () => (/* binding */ timeObject),
/* harmony export */   untruncateYear: () => (/* binding */ untruncateYear),
/* harmony export */   validateWeekSettings: () => (/* binding */ validateWeekSettings),
/* harmony export */   weeksInWeekYear: () => (/* binding */ weeksInWeekYear)
/* harmony export */ });
/* harmony import */ var _errors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../errors.js */ "../../node_modules/luxon/src/errors.js");
/* harmony import */ var _settings_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../settings.js */ "../../node_modules/luxon/src/settings.js");
/* harmony import */ var _conversions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./conversions.js */ "../../node_modules/luxon/src/impl/conversions.js");
/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/





/**
 * @private
 */

// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}

function isNumber(o) {
  return typeof o === "number";
}

function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}

function isString(o) {
  return typeof o === "string";
}

function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}

// CAPABILITIES

function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}

function hasLocaleWeekInfo() {
  try {
    return (
      typeof Intl !== "undefined" &&
      !!Intl.Locale &&
      ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype)
    );
  } catch (e) {
    return false;
  }
}

// OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}

function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}

function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.InvalidArgumentError("Week settings must be an object");
  } else {
    if (
      !integerBetween(settings.firstDay, 1, 7) ||
      !integerBetween(settings.minimalDays, 1, 7) ||
      !Array.isArray(settings.weekend) ||
      settings.weekend.some((v) => !integerBetween(v, 1, 7))
    ) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend),
    };
  }
}

// NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}

// x % n but takes the sign of n instead of x
function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}

function padStart(input, n = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n, "0");
  } else {
    padded = ("" + input).padStart(n, "0");
  }
  return padded;
}

function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}

function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseFloat(string);
  }
}

function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    const f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}

function roundTo(number, digits, towardZero = false) {
  const factor = 10 ** digits,
    rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}

// DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}

function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1,
    modYear = year + (month - modMonth) / 12;

  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}

// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
  let d = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );

  // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
    // so if obj.year is in 99, but obj.day makes it roll over into year 100,
    // the calculations done by Date.UTC are using year 2000 - which is incorrect
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}

// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = (0,_conversions_js__WEBPACK_IMPORTED_MODULE_2__.isoWeekdayToLocal)((0,_conversions_js__WEBPACK_IMPORTED_MODULE_2__.dayOfWeek)(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}

function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}

function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > _settings_js__WEBPACK_IMPORTED_MODULE_1__["default"].twoDigitCutoffYear ? 1900 + year : 2000 + year;
}

// PARSING

function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts),
    intlOpts = {
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };

  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }

  const modified = { timeZoneName: offsetFormat, ...intlOpts };

  const parsed = new Intl.DateTimeFormat(locale, modified)
    .formatToParts(date)
    .find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}

// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);

  // don't || this because we want to preserve -0
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }

  const offMin = parseInt(offMinuteStr, 10) || 0,
    offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}

// COERCION

function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue))
    throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}

function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}

/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */
function formatOffset(offset, format) {
  const hours = Math.trunc(Math.abs(offset / 60)),
    minutes = Math.trunc(Math.abs(offset % 60)),
    sign = offset >= 0 ? "+" : "-";

  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}

function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}


/***/ }),

/***/ "../../node_modules/luxon/src/impl/zoneUtil.js":
/*!*****************************************************!*\
  !*** ../../node_modules/luxon/src/impl/zoneUtil.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   normalizeZone: () => (/* binding */ normalizeZone)
/* harmony export */ });
/* harmony import */ var _zone_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../zone.js */ "../../node_modules/luxon/src/zone.js");
/* harmony import */ var _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../zones/IANAZone.js */ "../../node_modules/luxon/src/zones/IANAZone.js");
/* harmony import */ var _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../zones/fixedOffsetZone.js */ "../../node_modules/luxon/src/zones/fixedOffsetZone.js");
/* harmony import */ var _zones_invalidZone_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../zones/invalidZone.js */ "../../node_modules/luxon/src/zones/invalidZone.js");
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util.js */ "../../node_modules/luxon/src/impl/util.js");
/* harmony import */ var _zones_systemZone_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../zones/systemZone.js */ "../../node_modules/luxon/src/zones/systemZone.js");
/**
 * @private
 */









function normalizeZone(input, defaultZone) {
  let offset;
  if ((0,_util_js__WEBPACK_IMPORTED_MODULE_4__.isUndefined)(input) || input === null) {
    return defaultZone;
  } else if (input instanceof _zone_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    return input;
  } else if ((0,_util_js__WEBPACK_IMPORTED_MODULE_4__.isString)(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone;
    else if (lowered === "local" || lowered === "system") return _zones_systemZone_js__WEBPACK_IMPORTED_MODULE_5__["default"].instance;
    else if (lowered === "utc" || lowered === "gmt") return _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_2__["default"].utcInstance;
    else return _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseSpecifier(lowered) || _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_1__["default"].create(input);
  } else if ((0,_util_js__WEBPACK_IMPORTED_MODULE_4__.isNumber)(input)) {
    return _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_2__["default"].instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new _zones_invalidZone_js__WEBPACK_IMPORTED_MODULE_3__["default"](input);
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/info.js":
/*!********************************************!*\
  !*** ../../node_modules/luxon/src/info.js ***!
  \********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Info)
/* harmony export */ });
/* harmony import */ var _datetime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./datetime.js */ "../../node_modules/luxon/src/datetime.js");
/* harmony import */ var _settings_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./settings.js */ "../../node_modules/luxon/src/settings.js");
/* harmony import */ var _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./impl/locale.js */ "../../node_modules/luxon/src/impl/locale.js");
/* harmony import */ var _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./zones/IANAZone.js */ "../../node_modules/luxon/src/zones/IANAZone.js");
/* harmony import */ var _impl_zoneUtil_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./impl/zoneUtil.js */ "../../node_modules/luxon/src/impl/zoneUtil.js");
/* harmony import */ var _impl_util_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./impl/util.js */ "../../node_modules/luxon/src/impl/util.js");








/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */
class Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = _settings_js__WEBPACK_IMPORTED_MODULE_1__["default"].defaultZone) {
    const proto = _datetime_js__WEBPACK_IMPORTED_MODULE_0__["default"].now().setZone(zone).set({ month: 12 });

    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }

  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_3__["default"].isValidZone(zone);
  }

  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return (0,_impl_zoneUtil_js__WEBPACK_IMPORTED_MODULE_4__.normalizeZone)(input, _settings_js__WEBPACK_IMPORTED_MODULE_1__["default"].defaultZone);
  }

  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__["default"].create(locale)).getStartOfWeek();
  }

  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__["default"].create(locale)).getMinDaysInFirstWeek();
  }

  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    // copy the array, because we cache it internally
    return (locObj || _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__["default"].create(locale)).getWeekendDays().slice();
  }

  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__["default"].create(locale, numberingSystem, outputCalendar)).months(length);
  }

  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__["default"].create(locale, numberingSystem, outputCalendar)).months(length, true);
  }

  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__["default"].create(locale, numberingSystem, null)).weekdays(length);
  }

  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null } = {}
  ) {
    return (locObj || _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__["default"].create(locale, numberingSystem, null)).weekdays(length, true);
  }

  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__["default"].create(locale).meridiems();
  }

  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", { locale = null } = {}) {
    return _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__["default"].create(locale, null, "gregory").eras(length);
  }

  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.hasRelative)(), localeWeek: (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.hasLocaleWeekInfo)() };
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/interval.js":
/*!************************************************!*\
  !*** ../../node_modules/luxon/src/interval.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Interval)
/* harmony export */ });
/* harmony import */ var _datetime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./datetime.js */ "../../node_modules/luxon/src/datetime.js");
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./duration.js */ "../../node_modules/luxon/src/duration.js");
/* harmony import */ var _settings_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./settings.js */ "../../node_modules/luxon/src/settings.js");
/* harmony import */ var _errors_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./errors.js */ "../../node_modules/luxon/src/errors.js");
/* harmony import */ var _impl_invalid_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./impl/invalid.js */ "../../node_modules/luxon/src/impl/invalid.js");
/* harmony import */ var _impl_formatter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./impl/formatter.js */ "../../node_modules/luxon/src/impl/formatter.js");
/* harmony import */ var _impl_formats_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./impl/formats.js */ "../../node_modules/luxon/src/impl/formats.js");








const INVALID = "Invalid Interval";

// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}

/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */
class Interval {
  /**
   * @private
   */
  constructor(config) {
    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */
    this.e = config.end;
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.isLuxonInterval = true;
  }

  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_3__.InvalidArgumentError("need to specify a reason the Interval is invalid");
    }

    const invalid = reason instanceof _impl_invalid_js__WEBPACK_IMPORTED_MODULE_4__["default"] ? reason : new _impl_invalid_js__WEBPACK_IMPORTED_MODULE_4__["default"](reason, explanation);

    if (_settings_js__WEBPACK_IMPORTED_MODULE_2__["default"].throwOnInvalid) {
      throw new _errors_js__WEBPACK_IMPORTED_MODULE_3__.InvalidIntervalError(invalid);
    } else {
      return new Interval({ invalid });
    }
  }

  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = (0,_datetime_js__WEBPACK_IMPORTED_MODULE_0__.friendlyDateTime)(start),
      builtEnd = (0,_datetime_js__WEBPACK_IMPORTED_MODULE_0__.friendlyDateTime)(end);

    const validateError = validateStartEnd(builtStart, builtEnd);

    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd,
      });
    } else {
      return validateError;
    }
  }

  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = _duration_js__WEBPACK_IMPORTED_MODULE_1__["default"].fromDurationLike(duration),
      dt = (0,_datetime_js__WEBPACK_IMPORTED_MODULE_0__.friendlyDateTime)(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }

  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = _duration_js__WEBPACK_IMPORTED_MODULE_1__["default"].fromDurationLike(duration),
      dt = (0,_datetime_js__WEBPACK_IMPORTED_MODULE_0__.friendlyDateTime)(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }

  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s, e] = (text || "").split("/", 2);
    if (s && e) {
      let start, startIsValid;
      try {
        start = _datetime_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }

      let end, endIsValid;
      try {
        end = _datetime_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }

      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }

      if (startIsValid) {
        const dur = _duration_js__WEBPACK_IMPORTED_MODULE_1__["default"].fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = _duration_js__WEBPACK_IMPORTED_MODULE_1__["default"].fromISO(s, opts);
        if (dur.isValid) {
          return Interval.before(end, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }

  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return (o && o.isLuxonInterval) || false;
  }

  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }

  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }

  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }

  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }

  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts?.useLocaleWeeks) {
      end = this.end.reconfigure({ locale: start.locale });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }

  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }

  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }

  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }

  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }

  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }

  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }

  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes
        .map(_datetime_js__WEBPACK_IMPORTED_MODULE_0__.friendlyDateTime)
        .filter((d) => this.contains(d))
        .sort((a, b) => a.toMillis() - b.toMillis()),
      results = [];
    let { s } = this,
      i = 0;

    while (s < this.e) {
      const added = sorted[i] || this.e,
        next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }

    return results;
  }

  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = _duration_js__WEBPACK_IMPORTED_MODULE_1__["default"].fromDurationLike(duration);

    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }

    let { s } = this,
      idx = 1,
      next;

    const results = [];
    while (s < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }

    return results;
  }

  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }

  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }

  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }

  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }

  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }

  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    return this.s.equals(other.s) && this.e.equals(other.e);
  }

  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid) return this;
    const s = this.s > other.s ? this.s : other.s,
      e = this.e < other.e ? this.e : other.e;

    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }

  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid) return this;
    const s = this.s < other.s ? this.s : other.s,
      e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }

  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals
      .sort((a, b) => a.s - b.s)
      .reduce(
        ([sofar, current], item) => {
          if (!current) {
            return [sofar, item];
          } else if (current.overlaps(item) || current.abutsStart(item)) {
            return [sofar, current.union(item)];
          } else {
            return [sofar.concat([current]), item];
          }
        },
        [[], null]
      );
    if (final) {
      found.push(final);
    }
    return found;
  }

  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null,
      currentCount = 0;
    const results = [],
      ends = intervals.map((i) => [
        { time: i.s, type: "s" },
        { time: i.e, type: "e" },
      ]),
      flattened = Array.prototype.concat(...ends),
      arr = flattened.sort((a, b) => a.time - b.time);

    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;

      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }

        start = null;
      }
    }

    return Interval.merge(results);
  }

  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval.xor([this].concat(intervals))
      .map((i) => this.intersection(i))
      .filter((i) => i && !i.isEmpty());
  }

  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid) return INVALID;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }

  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = _impl_formats_js__WEBPACK_IMPORTED_MODULE_6__.DATE_SHORT, opts = {}) {
    return this.isValid
      ? _impl_formatter_js__WEBPACK_IMPORTED_MODULE_5__["default"].create(this.s.loc.clone(opts), formatOpts).formatInterval(this)
      : INVALID;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid) return INVALID;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid) return INVALID;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid) return INVALID;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }

  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator = " – " } = {}) {
    if (!this.isValid) return INVALID;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }

  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return _duration_js__WEBPACK_IMPORTED_MODULE_1__["default"].invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }

  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/luxon.js":
/*!*********************************************!*\
  !*** ../../node_modules/luxon/src/luxon.js ***!
  \*********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DateTime: () => (/* reexport safe */ _datetime_js__WEBPACK_IMPORTED_MODULE_0__["default"]),
/* harmony export */   Duration: () => (/* reexport safe */ _duration_js__WEBPACK_IMPORTED_MODULE_1__["default"]),
/* harmony export */   FixedOffsetZone: () => (/* reexport safe */ _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_5__["default"]),
/* harmony export */   IANAZone: () => (/* reexport safe */ _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_6__["default"]),
/* harmony export */   Info: () => (/* reexport safe */ _info_js__WEBPACK_IMPORTED_MODULE_3__["default"]),
/* harmony export */   Interval: () => (/* reexport safe */ _interval_js__WEBPACK_IMPORTED_MODULE_2__["default"]),
/* harmony export */   InvalidZone: () => (/* reexport safe */ _zones_invalidZone_js__WEBPACK_IMPORTED_MODULE_7__["default"]),
/* harmony export */   Settings: () => (/* reexport safe */ _settings_js__WEBPACK_IMPORTED_MODULE_9__["default"]),
/* harmony export */   SystemZone: () => (/* reexport safe */ _zones_systemZone_js__WEBPACK_IMPORTED_MODULE_8__["default"]),
/* harmony export */   VERSION: () => (/* binding */ VERSION),
/* harmony export */   Zone: () => (/* reexport safe */ _zone_js__WEBPACK_IMPORTED_MODULE_4__["default"])
/* harmony export */ });
/* harmony import */ var _datetime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./datetime.js */ "../../node_modules/luxon/src/datetime.js");
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./duration.js */ "../../node_modules/luxon/src/duration.js");
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./interval.js */ "../../node_modules/luxon/src/interval.js");
/* harmony import */ var _info_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./info.js */ "../../node_modules/luxon/src/info.js");
/* harmony import */ var _zone_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./zone.js */ "../../node_modules/luxon/src/zone.js");
/* harmony import */ var _zones_fixedOffsetZone_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./zones/fixedOffsetZone.js */ "../../node_modules/luxon/src/zones/fixedOffsetZone.js");
/* harmony import */ var _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./zones/IANAZone.js */ "../../node_modules/luxon/src/zones/IANAZone.js");
/* harmony import */ var _zones_invalidZone_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./zones/invalidZone.js */ "../../node_modules/luxon/src/zones/invalidZone.js");
/* harmony import */ var _zones_systemZone_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./zones/systemZone.js */ "../../node_modules/luxon/src/zones/systemZone.js");
/* harmony import */ var _settings_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./settings.js */ "../../node_modules/luxon/src/settings.js");











const VERSION = "3.5.0";




/***/ }),

/***/ "../../node_modules/luxon/src/settings.js":
/*!************************************************!*\
  !*** ../../node_modules/luxon/src/settings.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Settings)
/* harmony export */ });
/* harmony import */ var _zones_systemZone_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./zones/systemZone.js */ "../../node_modules/luxon/src/zones/systemZone.js");
/* harmony import */ var _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./zones/IANAZone.js */ "../../node_modules/luxon/src/zones/IANAZone.js");
/* harmony import */ var _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./impl/locale.js */ "../../node_modules/luxon/src/impl/locale.js");
/* harmony import */ var _datetime_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./datetime.js */ "../../node_modules/luxon/src/datetime.js");
/* harmony import */ var _impl_zoneUtil_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./impl/zoneUtil.js */ "../../node_modules/luxon/src/impl/zoneUtil.js");
/* harmony import */ var _impl_util_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./impl/util.js */ "../../node_modules/luxon/src/impl/util.js");
/* harmony import */ var _impl_digits_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./impl/digits.js */ "../../node_modules/luxon/src/impl/digits.js");









let now = () => Date.now(),
  defaultZone = "system",
  defaultLocale = null,
  defaultNumberingSystem = null,
  defaultOutputCalendar = null,
  twoDigitCutoffYear = 60,
  throwOnInvalid,
  defaultWeekSettings = null;

/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now;
  }

  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    now = n;
  }

  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }

  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return (0,_impl_zoneUtil_js__WEBPACK_IMPORTED_MODULE_4__.normalizeZone)(defaultZone, _zones_systemZone_js__WEBPACK_IMPORTED_MODULE_0__["default"].instance);
  }

  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }

  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }

  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }

  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }

  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }

  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }

  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */

  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }

  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_5__.validateWeekSettings)(weekSettings);
  }

  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }

  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }

  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }

  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }

  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    _impl_locale_js__WEBPACK_IMPORTED_MODULE_2__["default"].resetCache();
    _zones_IANAZone_js__WEBPACK_IMPORTED_MODULE_1__["default"].resetCache();
    _datetime_js__WEBPACK_IMPORTED_MODULE_3__["default"].resetCache();
    (0,_impl_digits_js__WEBPACK_IMPORTED_MODULE_6__.resetDigitRegexCache)();
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/zone.js":
/*!********************************************!*\
  !*** ../../node_modules/luxon/src/zone.js ***!
  \********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Zone)
/* harmony export */ });
/* harmony import */ var _errors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./errors.js */ "../../node_modules/luxon/src/errors.js");


/**
 * @interface
 */
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.ZoneIsAbstractError();
  }

  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.ZoneIsAbstractError();
  }

  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.ZoneIsAbstractError();
  }

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.ZoneIsAbstractError();
  }

  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.ZoneIsAbstractError();
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new _errors_js__WEBPACK_IMPORTED_MODULE_0__.ZoneIsAbstractError();
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/zones/IANAZone.js":
/*!******************************************************!*\
  !*** ../../node_modules/luxon/src/zones/IANAZone.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ IANAZone)
/* harmony export */ });
/* harmony import */ var _impl_util_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../impl/util.js */ "../../node_modules/luxon/src/impl/util.js");
/* harmony import */ var _zone_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../zone.js */ "../../node_modules/luxon/src/zone.js");



let dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short",
    });
  }
  return dtfCache[zone];
}

const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6,
};

function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""),
    parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted),
    [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}

function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];

    if (type === "era") {
      filled[pos] = value;
    } else if (!(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}

let ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */
class IANAZone extends _zone_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }
    return ianaZoneCache[name];
  }

  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }

  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(s) {
    return this.isValidZone(s);
  }

  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  }

  constructor(name) {
    super();
    /** @private **/
    this.zoneName = name;
    /** @private **/
    this.valid = IANAZone.isValidZone(name);
  }

  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }

  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return false;
  }

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, { format, locale }) {
    return (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_0__.parseZoneInfo)(ts, format, locale, this.name);
  }

  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_0__.formatOffset)(this.offset(ts), format);
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    const date = new Date(ts);

    if (isNaN(date)) return NaN;

    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts
      ? partsOffset(dtf, date)
      : hackyOffset(dtf, date);

    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }

    // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
    const adjustedHour = hour === 24 ? 0 : hour;

    const asUTC = (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_0__.objToLocalTS)({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0,
    });

    let asTS = +date;
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }

  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }

  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/zones/fixedOffsetZone.js":
/*!*************************************************************!*\
  !*** ../../node_modules/luxon/src/zones/fixedOffsetZone.js ***!
  \*************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ FixedOffsetZone)
/* harmony export */ });
/* harmony import */ var _impl_util_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../impl/util.js */ "../../node_modules/luxon/src/impl/util.js");
/* harmony import */ var _zone_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../zone.js */ "../../node_modules/luxon/src/zone.js");



let singleton = null;

/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */
class FixedOffsetZone extends _zone_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new FixedOffsetZone(0);
    }
    return singleton;
  }

  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }

  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s) {
    if (s) {
      const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone((0,_impl_util_js__WEBPACK_IMPORTED_MODULE_0__.signedOffset)(r[1], r[2]));
      }
    }
    return null;
  }

  constructor(offset) {
    super();
    /** @private **/
    this.fixed = offset;
  }

  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }

  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_0__.formatOffset)(this.fixed, "narrow")}`;
  }

  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${(0,_impl_util_js__WEBPACK_IMPORTED_MODULE_0__.formatOffset)(-this.fixed, "narrow")}`;
    }
  }

  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }

  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_0__.formatOffset)(this.fixed, format);
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return true;
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }

  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }

  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return true;
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/zones/invalidZone.js":
/*!*********************************************************!*\
  !*** ../../node_modules/luxon/src/zones/invalidZone.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ InvalidZone)
/* harmony export */ });
/* harmony import */ var _zone_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../zone.js */ "../../node_modules/luxon/src/zone.js");


/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */
class InvalidZone extends _zone_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  constructor(zoneName) {
    super();
    /**  @private */
    this.zoneName = zoneName;
  }

  /** @override **/
  get type() {
    return "invalid";
  }

  /** @override **/
  get name() {
    return this.zoneName;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName() {
    return null;
  }

  /** @override **/
  formatOffset() {
    return "";
  }

  /** @override **/
  offset() {
    return NaN;
  }

  /** @override **/
  equals() {
    return false;
  }

  /** @override **/
  get isValid() {
    return false;
  }
}


/***/ }),

/***/ "../../node_modules/luxon/src/zones/systemZone.js":
/*!********************************************************!*\
  !*** ../../node_modules/luxon/src/zones/systemZone.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SystemZone)
/* harmony export */ });
/* harmony import */ var _impl_util_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../impl/util.js */ "../../node_modules/luxon/src/impl/util.js");
/* harmony import */ var _zone_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../zone.js */ "../../node_modules/luxon/src/zone.js");



let singleton = null;

/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */
class SystemZone extends _zone_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton === null) {
      singleton = new SystemZone();
    }
    return singleton;
  }

  /** @override **/
  get type() {
    return "system";
  }

  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName(ts, { format, locale }) {
    return (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_0__.parseZoneInfo)(ts, format, locale);
  }

  /** @override **/
  formatOffset(ts, format) {
    return (0,_impl_util_js__WEBPACK_IMPORTED_MODULE_0__.formatOffset)(this.offset(ts), format);
  }

  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }

  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }

  /** @override **/
  get isValid() {
    return true;
  }
}


/***/ }),

/***/ "../../node_modules/memoize-one/dist/memoize-one.esm.js":
/*!**************************************************************!*\
  !*** ../../node_modules/memoize-one/dist/memoize-one.esm.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (memoizeOne);


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/ObserverComponent.js":
/*!******************************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/ObserverComponent.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Observer: () => (/* binding */ ObserverComponent)
/* harmony export */ });
/* harmony import */ var _useObserver__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./useObserver */ "../../node_modules/mobx-react-lite/es/useObserver.js");

function ObserverComponent(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") {
        return null;
    }
    return (0,_useObserver__WEBPACK_IMPORTED_MODULE_0__.useObserver)(component);
}
ObserverComponent.propTypes = {
    children: ObserverPropsCheck,
    render: ObserverPropsCheck
};
ObserverComponent.displayName = "Observer";

function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) {
        return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    }
    if (hasProp || hasExtraProp) {
        return null;
    }
    return new Error("Invalid prop `" +
        propFullName +
        "` of type `" +
        typeof props[key] +
        "` supplied to" +
        " `" +
        componentName +
        "`, expected `function`.");
}


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/assertEnvironment.js":
/*!******************************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/assertEnvironment.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mobx */ "../../node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");


if (!react__WEBPACK_IMPORTED_MODULE_1__.useState) {
    throw new Error("mobx-react-lite requires React with Hooks support");
}
if (!mobx__WEBPACK_IMPORTED_MODULE_0__.spy) {
    throw new Error("mobx-react-lite requires mobx at least version 4 to be available");
}


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/index.js":
/*!******************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/index.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Observer: () => (/* reexport safe */ _ObserverComponent__WEBPACK_IMPORTED_MODULE_6__.Observer),
/* harmony export */   isObserverBatched: () => (/* reexport safe */ _observerBatching__WEBPACK_IMPORTED_MODULE_2__.isObserverBatched),
/* harmony export */   isUsingStaticRendering: () => (/* reexport safe */ _staticRendering__WEBPACK_IMPORTED_MODULE_3__.isUsingStaticRendering),
/* harmony export */   observer: () => (/* reexport safe */ _observer__WEBPACK_IMPORTED_MODULE_4__.observer),
/* harmony export */   observerBatching: () => (/* reexport safe */ _observerBatching__WEBPACK_IMPORTED_MODULE_2__.observerBatching),
/* harmony export */   useAsObservableSource: () => (/* reexport safe */ _useAsObservableSource__WEBPACK_IMPORTED_MODULE_8__.useAsObservableSource),
/* harmony export */   useForceUpdate: () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_7__.useForceUpdate),
/* harmony export */   useLocalStore: () => (/* reexport safe */ _useLocalStore__WEBPACK_IMPORTED_MODULE_9__.useLocalStore),
/* harmony export */   useObserver: () => (/* reexport safe */ _useObserver__WEBPACK_IMPORTED_MODULE_5__.useObserver),
/* harmony export */   useQueuedForceUpdate: () => (/* reexport safe */ _useQueuedForceUpdate__WEBPACK_IMPORTED_MODULE_10__.useQueuedForceUpdate),
/* harmony export */   useQueuedForceUpdateBlock: () => (/* reexport safe */ _useQueuedForceUpdate__WEBPACK_IMPORTED_MODULE_10__.useQueuedForceUpdateBlock),
/* harmony export */   useStaticRendering: () => (/* reexport safe */ _staticRendering__WEBPACK_IMPORTED_MODULE_3__.useStaticRendering)
/* harmony export */ });
/* harmony import */ var _assertEnvironment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./assertEnvironment */ "../../node_modules/mobx-react-lite/es/assertEnvironment.js");
/* harmony import */ var _utils_reactBatchedUpdates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils/reactBatchedUpdates */ "../../node_modules/mobx-react-lite/es/utils/reactBatchedUpdates.js");
/* harmony import */ var _observerBatching__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./observerBatching */ "../../node_modules/mobx-react-lite/es/observerBatching.js");
/* harmony import */ var _staticRendering__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./staticRendering */ "../../node_modules/mobx-react-lite/es/staticRendering.js");
/* harmony import */ var _observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./observer */ "../../node_modules/mobx-react-lite/es/observer.js");
/* harmony import */ var _useObserver__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./useObserver */ "../../node_modules/mobx-react-lite/es/useObserver.js");
/* harmony import */ var _ObserverComponent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ObserverComponent */ "../../node_modules/mobx-react-lite/es/ObserverComponent.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./utils */ "../../node_modules/mobx-react-lite/es/utils.js");
/* harmony import */ var _useAsObservableSource__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./useAsObservableSource */ "../../node_modules/mobx-react-lite/es/useAsObservableSource.js");
/* harmony import */ var _useLocalStore__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./useLocalStore */ "../../node_modules/mobx-react-lite/es/useLocalStore.js");
/* harmony import */ var _useQueuedForceUpdate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./useQueuedForceUpdate */ "../../node_modules/mobx-react-lite/es/useQueuedForceUpdate.js");



(0,_observerBatching__WEBPACK_IMPORTED_MODULE_2__.observerBatching)(_utils_reactBatchedUpdates__WEBPACK_IMPORTED_MODULE_1__.unstable_batchedUpdates);











/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/observer.js":
/*!*********************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/observer.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   observer: () => (/* binding */ observer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _staticRendering__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./staticRendering */ "../../node_modules/mobx-react-lite/es/staticRendering.js");
/* harmony import */ var _useObserver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./useObserver */ "../../node_modules/mobx-react-lite/es/useObserver.js");
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



// n.b. base case is not used for actual typings or exported in the typing files
function observer(baseComponent, options) {
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0,_staticRendering__WEBPACK_IMPORTED_MODULE_1__.isUsingStaticRendering)()) {
        return baseComponent;
    }
    var realOptions = __assign({ forwardRef: false }, options);
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    var wrappedComponent = function (props, ref) {
        return (0,_useObserver__WEBPACK_IMPORTED_MODULE_2__.useObserver)(function () { return baseComponent(props, ref); }, baseComponentName);
    };
    wrappedComponent.displayName = baseComponentName;
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    var memoComponent;
    if (realOptions.forwardRef) {
        // we have to use forwardRef here because:
        // 1. it cannot go before memo, only after it
        // 2. forwardRef converts the function into an actual component, so we can't let the baseComponent do it
        //    since it wouldn't be a callable function anymore
        memoComponent = (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)((0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(wrappedComponent));
    }
    else {
        memoComponent = (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(wrappedComponent);
    }
    copyStaticProperties(baseComponent, memoComponent);
    memoComponent.displayName = baseComponentName;
    return memoComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true
};
function copyStaticProperties(base, target) {
    Object.keys(base).forEach(function (key) {
        if (!hoistBlackList[key]) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
        }
    });
}


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/observerBatching.js":
/*!*****************************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/observerBatching.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   defaultNoopBatch: () => (/* binding */ defaultNoopBatch),
/* harmony export */   isObserverBatched: () => (/* binding */ isObserverBatched),
/* harmony export */   observerBatching: () => (/* binding */ observerBatching)
/* harmony export */ });
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mobx */ "../../node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils */ "../../node_modules/mobx-react-lite/es/utils.js");


var observerBatchingConfiguredSymbol = (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getSymbol)("observerBatching");
function defaultNoopBatch(callback) {
    callback();
}
function observerBatching(reactionScheduler) {
    if (!reactionScheduler) {
        reactionScheduler = defaultNoopBatch;
        if (true) {
            console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native");
        }
    }
    (0,mobx__WEBPACK_IMPORTED_MODULE_0__.configure)({ reactionScheduler: reactionScheduler });
    (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getGlobal)()[observerBatchingConfiguredSymbol] = true;
}
var isObserverBatched = function () { return !!(0,_utils__WEBPACK_IMPORTED_MODULE_1__.getGlobal)()[observerBatchingConfiguredSymbol]; };


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/printDebugValue.js":
/*!****************************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/printDebugValue.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   printDebugValue: () => (/* binding */ printDebugValue)
/* harmony export */ });
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mobx */ "../../node_modules/mobx/lib/mobx.module.js");

function printDebugValue(v) {
    return (0,mobx__WEBPACK_IMPORTED_MODULE_0__.getDependencyTree)(v);
}


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/reactionCleanupTracking.js":
/*!************************************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/reactionCleanupTracking.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS: () => (/* binding */ CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS),
/* harmony export */   CLEANUP_TIMER_LOOP_MILLIS: () => (/* binding */ CLEANUP_TIMER_LOOP_MILLIS),
/* harmony export */   createTrackingData: () => (/* binding */ createTrackingData),
/* harmony export */   forceCleanupTimerToRunNowForTests: () => (/* binding */ forceCleanupTimerToRunNowForTests),
/* harmony export */   recordReactionAsCommitted: () => (/* binding */ recordReactionAsCommitted),
/* harmony export */   resetCleanupScheduleForTests: () => (/* binding */ resetCleanupScheduleForTests),
/* harmony export */   scheduleCleanupOfReactionIfLeaked: () => (/* binding */ scheduleCleanupOfReactionIfLeaked)
/* harmony export */ });
function createTrackingData(reaction) {
    var trackingData = {
        cleanAt: Date.now() + CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS,
        reaction: reaction
    };
    return trackingData;
}
/**
 * The minimum time before we'll clean up a Reaction created in a render
 * for a component that hasn't managed to run its effects. This needs to
 * be big enough to ensure that a component won't turn up and have its
 * effects run without being re-rendered.
 */
var CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS = 10000;
/**
 * The frequency with which we'll check for leaked reactions.
 */
var CLEANUP_TIMER_LOOP_MILLIS = 10000;
/**
 * Reactions created by components that have yet to be fully mounted.
 */
var uncommittedReactionRefs = new Set();
/**
 * Latest 'uncommitted reactions' cleanup timer handle.
 */
var reactionCleanupHandle;
function ensureCleanupTimerRunning() {
    if (reactionCleanupHandle === undefined) {
        reactionCleanupHandle = setTimeout(cleanUncommittedReactions, CLEANUP_TIMER_LOOP_MILLIS);
    }
}
function scheduleCleanupOfReactionIfLeaked(ref) {
    uncommittedReactionRefs.add(ref);
    ensureCleanupTimerRunning();
}
function recordReactionAsCommitted(reactionRef) {
    uncommittedReactionRefs.delete(reactionRef);
}
/**
 * Run by the cleanup timer to dispose any outstanding reactions
 */
function cleanUncommittedReactions() {
    reactionCleanupHandle = undefined;
    // Loop through all the candidate leaked reactions; those older
    // than CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS get tidied.
    var now = Date.now();
    uncommittedReactionRefs.forEach(function (ref) {
        var tracking = ref.current;
        if (tracking) {
            if (now >= tracking.cleanAt) {
                // It's time to tidy up this leaked reaction.
                tracking.reaction.dispose();
                ref.current = null;
                uncommittedReactionRefs.delete(ref);
            }
        }
    });
    if (uncommittedReactionRefs.size > 0) {
        // We've just finished a round of cleanups but there are still
        // some leak candidates outstanding.
        ensureCleanupTimerRunning();
    }
}
/* istanbul ignore next */
/**
 * Only to be used by test functions; do not export outside of mobx-react-lite
 */
function forceCleanupTimerToRunNowForTests() {
    // This allows us to control the execution of the cleanup timer
    // to force it to run at awkward times in unit tests.
    if (reactionCleanupHandle) {
        clearTimeout(reactionCleanupHandle);
        cleanUncommittedReactions();
    }
}
/* istanbul ignore next */
function resetCleanupScheduleForTests() {
    if (reactionCleanupHandle) {
        clearTimeout(reactionCleanupHandle);
        reactionCleanupHandle = undefined;
    }
    uncommittedReactionRefs.clear();
}


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/staticRendering.js":
/*!****************************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/staticRendering.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   isUsingStaticRendering: () => (/* binding */ isUsingStaticRendering),
/* harmony export */   useStaticRendering: () => (/* binding */ useStaticRendering)
/* harmony export */ });
var globalIsUsingStaticRendering = false;
function useStaticRendering(enable) {
    globalIsUsingStaticRendering = enable;
}
function isUsingStaticRendering() {
    return globalIsUsingStaticRendering;
}


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/useAsObservableSource.js":
/*!**********************************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/useAsObservableSource.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   useAsObservableSource: () => (/* binding */ useAsObservableSource),
/* harmony export */   useAsObservableSourceInternal: () => (/* binding */ useAsObservableSourceInternal)
/* harmony export */ });
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mobx */ "../../node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils */ "../../node_modules/mobx-react-lite/es/utils.js");
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};



function useAsObservableSourceInternal(current, usedByLocalStore) {
    var culprit = usedByLocalStore ? "useLocalStore" : "useAsObservableSource";
    if ( true && usedByLocalStore) {
        var _a = __read(react__WEBPACK_IMPORTED_MODULE_1__.useState(current), 1), initialSource = _a[0];
        if ((initialSource !== undefined && current === undefined) ||
            (initialSource === undefined && current !== undefined)) {
            throw new Error("make sure you never pass `undefined` to " + culprit);
        }
    }
    if (usedByLocalStore && current === undefined) {
        return undefined;
    }
    if ( true && !(0,_utils__WEBPACK_IMPORTED_MODULE_2__.isPlainObject)(current)) {
        throw new Error(culprit + " expects a plain object as " + (usedByLocalStore ? "second" : "first") + " argument");
    }
    var _b = __read(react__WEBPACK_IMPORTED_MODULE_1__.useState(function () { return (0,mobx__WEBPACK_IMPORTED_MODULE_0__.observable)(current, {}, { deep: false }); }), 1), res = _b[0];
    if ( true &&
        Object.keys(res).length !== Object.keys(current).length) {
        throw new Error("the shape of objects passed to " + culprit + " should be stable");
    }
    (0,mobx__WEBPACK_IMPORTED_MODULE_0__.runInAction)(function () {
        Object.assign(res, current);
    });
    return res;
}
function useAsObservableSource(current) {
    return useAsObservableSourceInternal(current, false);
}


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/useLocalStore.js":
/*!**************************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/useLocalStore.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   useLocalStore: () => (/* binding */ useLocalStore)
/* harmony export */ });
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mobx */ "../../node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _useAsObservableSource__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./useAsObservableSource */ "../../node_modules/mobx-react-lite/es/useAsObservableSource.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils */ "../../node_modules/mobx-react-lite/es/utils.js");




function useLocalStore(initializer, current) {
    var source = (0,_useAsObservableSource__WEBPACK_IMPORTED_MODULE_2__.useAsObservableSourceInternal)(current, true);
    return react__WEBPACK_IMPORTED_MODULE_1__.useState(function () {
        var local = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.observable)(initializer(source));
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_3__.isPlainObject)(local)) {
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__.runInAction)(function () {
                Object.keys(local).forEach(function (key) {
                    var value = local[key];
                    if (typeof value === "function") {
                        // @ts-ignore No idea why ts2536 is popping out here
                        local[key] = wrapInTransaction(value, local);
                    }
                });
            });
        }
        return local;
    })[0];
}
// tslint:disable-next-line: ban-types
function wrapInTransaction(fn, context) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,mobx__WEBPACK_IMPORTED_MODULE_0__.transaction)(function () { return fn.apply(context, args); });
    };
}


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/useObserver.js":
/*!************************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/useObserver.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   useObserver: () => (/* binding */ useObserver)
/* harmony export */ });
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mobx */ "../../node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _printDebugValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./printDebugValue */ "../../node_modules/mobx-react-lite/es/printDebugValue.js");
/* harmony import */ var _reactionCleanupTracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactionCleanupTracking */ "../../node_modules/mobx-react-lite/es/reactionCleanupTracking.js");
/* harmony import */ var _staticRendering__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./staticRendering */ "../../node_modules/mobx-react-lite/es/staticRendering.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils */ "../../node_modules/mobx-react-lite/es/utils.js");
/* harmony import */ var _useQueuedForceUpdate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./useQueuedForceUpdate */ "../../node_modules/mobx-react-lite/es/useQueuedForceUpdate.js");







var EMPTY_OBJECT = {};
function observerComponentNameFor(baseComponentName) {
    return "observer" + baseComponentName;
}
function useObserver(fn, baseComponentName, options) {
    if (baseComponentName === void 0) { baseComponentName = "observed"; }
    if (options === void 0) { options = EMPTY_OBJECT; }
    if ((0,_staticRendering__WEBPACK_IMPORTED_MODULE_4__.isUsingStaticRendering)()) {
        return fn();
    }
    var wantedForceUpdateHook = options.useForceUpdate || _utils__WEBPACK_IMPORTED_MODULE_5__.useForceUpdate;
    var forceUpdate = wantedForceUpdateHook();
    var queuedForceUpdate = (0,_useQueuedForceUpdate__WEBPACK_IMPORTED_MODULE_6__.useQueuedForceUpdate)(forceUpdate);
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var reactionTrackingRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    if (!reactionTrackingRef.current) {
        // First render for this component (or first time since a previous
        // reaction from an abandoned render was disposed).
        var newReaction_1 = new mobx__WEBPACK_IMPORTED_MODULE_0__.Reaction(observerComponentNameFor(baseComponentName), function () {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (trackingData_1.mounted) {
                // We have reached useEffect(), so we're mounted, and can trigger an update
                queuedForceUpdate();
            }
            else {
                // We haven't yet reached useEffect(), so we'll need to trigger a re-render
                // when (and if) useEffect() arrives.  The easiest way to do that is just to
                // drop our current reaction and allow useEffect() to recreate it.
                newReaction_1.dispose();
                reactionTrackingRef.current = null;
            }
        });
        var trackingData_1 = (0,_reactionCleanupTracking__WEBPACK_IMPORTED_MODULE_3__.createTrackingData)(newReaction_1);
        reactionTrackingRef.current = trackingData_1;
        (0,_reactionCleanupTracking__WEBPACK_IMPORTED_MODULE_3__.scheduleCleanupOfReactionIfLeaked)(reactionTrackingRef);
    }
    var reaction = reactionTrackingRef.current.reaction;
    react__WEBPACK_IMPORTED_MODULE_1__.useDebugValue(reaction, _printDebugValue__WEBPACK_IMPORTED_MODULE_2__.printDebugValue);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function () {
        // Called on first mount only
        (0,_reactionCleanupTracking__WEBPACK_IMPORTED_MODULE_3__.recordReactionAsCommitted)(reactionTrackingRef);
        if (reactionTrackingRef.current) {
            // Great. We've already got our reaction from our render;
            // all we need to do is to record that it's now mounted,
            // to allow future observable changes to trigger re-renders
            reactionTrackingRef.current.mounted = true;
        }
        else {
            // The reaction we set up in our render has been disposed.
            // This is either due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up, or we got a observable change
            // between render and useEffect
            // Re-create the reaction
            reactionTrackingRef.current = {
                reaction: new mobx__WEBPACK_IMPORTED_MODULE_0__.Reaction(observerComponentNameFor(baseComponentName), function () {
                    // We've definitely already been mounted at this point
                    queuedForceUpdate();
                }),
                cleanAt: Infinity
            };
            queuedForceUpdate();
        }
        return function () {
            reactionTrackingRef.current.reaction.dispose();
            reactionTrackingRef.current = null;
        };
    }, []);
    // delay all force-update calls after rendering of this component
    return (0,_useQueuedForceUpdate__WEBPACK_IMPORTED_MODULE_6__.useQueuedForceUpdateBlock)(function () {
        // render the original component, but have the
        // reaction track the observables, so that rendering
        // can be invalidated (see above) once a dependency changes
        var rendering;
        var exception;
        reaction.track(function () {
            try {
                rendering = fn();
            }
            catch (e) {
                exception = e;
            }
        });
        if (exception) {
            throw exception; // re-throw any exceptions caught during rendering
        }
        return rendering;
    });
}


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/useQueuedForceUpdate.js":
/*!*********************************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/useQueuedForceUpdate.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   useQueuedForceUpdate: () => (/* binding */ useQueuedForceUpdate),
/* harmony export */   useQueuedForceUpdateBlock: () => (/* binding */ useQueuedForceUpdateBlock)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");

var insideRender = false;
var forceUpdateQueue = [];
function useQueuedForceUpdate(forceUpdate) {
    return function () {
        if (insideRender) {
            forceUpdateQueue.push(forceUpdate);
        }
        else {
            forceUpdate();
        }
    };
}
function useQueuedForceUpdateBlock(callback) {
    // start intercepting force-update calls
    insideRender = true;
    forceUpdateQueue = [];
    try {
        var result = callback();
        // stop intercepting force-update
        insideRender = false;
        // store queue or nothing if it was empty to execute useLayoutEffect only when necessary
        var queue_1 = forceUpdateQueue.length > 0 ? forceUpdateQueue : undefined;
        // run force-update queue in useLayoutEffect
        react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect(function () {
            if (queue_1) {
                queue_1.forEach(function (x) { return x(); });
            }
        }, [queue_1]);
        return result;
    }
    finally {
        insideRender = false;
    }
}


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/utils.js":
/*!******************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/utils.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getGlobal: () => (/* binding */ getGlobal),
/* harmony export */   getSymbol: () => (/* binding */ getSymbol),
/* harmony export */   isPlainObject: () => (/* binding */ isPlainObject),
/* harmony export */   useForceUpdate: () => (/* binding */ useForceUpdate),
/* harmony export */   useUnmount: () => (/* binding */ useUnmount)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

var EMPTY_ARRAY = [];
function useUnmount(fn) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return fn; }, EMPTY_ARRAY);
}
function useForceUpdate() {
    var _a = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), 2), setTick = _a[1];
    var update = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        setTick(function (tick) { return tick + 1; });
    }, []);
    return update;
}
function isPlainObject(value) {
    if (!value || typeof value !== "object") {
        return false;
    }
    var proto = Object.getPrototypeOf(value);
    return !proto || proto === Object.prototype;
}
function getSymbol(name) {
    if (typeof Symbol === "function") {
        return Symbol.for(name);
    }
    return "__$mobx-react " + name + "__";
}
var mockGlobal = {};
function getGlobal() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    return mockGlobal;
}


/***/ }),

/***/ "../../node_modules/mobx-react-lite/es/utils/reactBatchedUpdates.js":
/*!**************************************************************************!*\
  !*** ../../node_modules/mobx-react-lite/es/utils/reactBatchedUpdates.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   unstable_batchedUpdates: () => (/* reexport safe */ react_dom__WEBPACK_IMPORTED_MODULE_0__.unstable_batchedUpdates)
/* harmony export */ });
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react-dom */ "../../node_modules/react-dom/index.js");



/***/ }),

/***/ "../../node_modules/mobx/lib/mobx.module.js":
/*!**************************************************!*\
  !*** ../../node_modules/mobx/lib/mobx.module.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $mobx: () => (/* binding */ $mobx),
/* harmony export */   FlowCancellationError: () => (/* binding */ FlowCancellationError),
/* harmony export */   IDerivationState: () => (/* binding */ IDerivationState),
/* harmony export */   ObservableMap: () => (/* binding */ ObservableMap),
/* harmony export */   ObservableSet: () => (/* binding */ ObservableSet),
/* harmony export */   Reaction: () => (/* binding */ Reaction),
/* harmony export */   _allowStateChanges: () => (/* binding */ allowStateChanges),
/* harmony export */   _allowStateChangesInsideComputed: () => (/* binding */ allowStateChangesInsideComputed),
/* harmony export */   _allowStateReadsEnd: () => (/* binding */ allowStateReadsEnd),
/* harmony export */   _allowStateReadsStart: () => (/* binding */ allowStateReadsStart),
/* harmony export */   _endAction: () => (/* binding */ _endAction),
/* harmony export */   _getAdministration: () => (/* binding */ getAdministration),
/* harmony export */   _getGlobalState: () => (/* binding */ getGlobalState),
/* harmony export */   _interceptReads: () => (/* binding */ interceptReads),
/* harmony export */   _isComputingDerivation: () => (/* binding */ isComputingDerivation),
/* harmony export */   _resetGlobalState: () => (/* binding */ resetGlobalState),
/* harmony export */   _startAction: () => (/* binding */ _startAction),
/* harmony export */   action: () => (/* binding */ action),
/* harmony export */   autorun: () => (/* binding */ autorun),
/* harmony export */   comparer: () => (/* binding */ comparer),
/* harmony export */   computed: () => (/* binding */ computed),
/* harmony export */   configure: () => (/* binding */ configure),
/* harmony export */   createAtom: () => (/* binding */ createAtom),
/* harmony export */   decorate: () => (/* binding */ decorate),
/* harmony export */   entries: () => (/* binding */ entries),
/* harmony export */   extendObservable: () => (/* binding */ extendObservable),
/* harmony export */   flow: () => (/* binding */ flow),
/* harmony export */   get: () => (/* binding */ get),
/* harmony export */   getAtom: () => (/* binding */ getAtom),
/* harmony export */   getDebugName: () => (/* binding */ getDebugName),
/* harmony export */   getDependencyTree: () => (/* binding */ getDependencyTree),
/* harmony export */   getObserverTree: () => (/* binding */ getObserverTree),
/* harmony export */   has: () => (/* binding */ has),
/* harmony export */   intercept: () => (/* binding */ intercept),
/* harmony export */   isAction: () => (/* binding */ isAction),
/* harmony export */   isArrayLike: () => (/* binding */ isArrayLike),
/* harmony export */   isBoxedObservable: () => (/* binding */ isObservableValue),
/* harmony export */   isComputed: () => (/* binding */ isComputed),
/* harmony export */   isComputedProp: () => (/* binding */ isComputedProp),
/* harmony export */   isFlowCancellationError: () => (/* binding */ isFlowCancellationError),
/* harmony export */   isObservable: () => (/* binding */ isObservable),
/* harmony export */   isObservableArray: () => (/* binding */ isObservableArray),
/* harmony export */   isObservableMap: () => (/* binding */ isObservableMap),
/* harmony export */   isObservableObject: () => (/* binding */ isObservableObject),
/* harmony export */   isObservableProp: () => (/* binding */ isObservableProp),
/* harmony export */   isObservableSet: () => (/* binding */ isObservableSet),
/* harmony export */   keys: () => (/* binding */ keys),
/* harmony export */   observable: () => (/* binding */ observable),
/* harmony export */   observe: () => (/* binding */ observe),
/* harmony export */   onBecomeObserved: () => (/* binding */ onBecomeObserved),
/* harmony export */   onBecomeUnobserved: () => (/* binding */ onBecomeUnobserved),
/* harmony export */   onReactionError: () => (/* binding */ onReactionError),
/* harmony export */   reaction: () => (/* binding */ reaction),
/* harmony export */   remove: () => (/* binding */ remove),
/* harmony export */   runInAction: () => (/* binding */ runInAction),
/* harmony export */   set: () => (/* binding */ set),
/* harmony export */   spy: () => (/* binding */ spy),
/* harmony export */   toJS: () => (/* binding */ toJS),
/* harmony export */   trace: () => (/* binding */ trace),
/* harmony export */   transaction: () => (/* binding */ transaction),
/* harmony export */   untracked: () => (/* binding */ untracked),
/* harmony export */   values: () => (/* binding */ values),
/* harmony export */   when: () => (/* binding */ when)
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(/*! process/browser.js */ "../../node_modules/process/browser.js");
/** MobX - (c) Michel Weststrate 2015 - 2020 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is a production build.";
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message) {
    invariant(false, message);
    throw "X"; // unreachable
}
function invariant(check, message) {
    if (!check)
        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg, thing) {
    if (false)
        {}
    if (thing) {
        return deprecated("'" + msg + "', use '" + thing + "' instead.");
    }
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    if ( true && !isPropertyConfigurable(object, prop))
        fail("Cannot make property '" + prop.toString() + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
/**
 * Returns the following: own keys, prototype keys & own symbol keys, if they are enumerable.
 */
function getPlainObjectKeys(object) {
    var enumerables = new Set();
    for (var key in object)
        enumerables.add(key); // *all* enumerables
    Object.getOwnPropertySymbols(object).forEach(function (k) {
        if (Object.getOwnPropertyDescriptor(object, k).enumerable)
            enumerables.add(k);
    }); // *own* symbols
    // Note: this implementation is missing enumerable, inherited, symbolic property names! That would however pretty expensive to add,
    // as there is no efficient iterator that returns *all* properties
    return Array.from(enumerables);
}
function stringifyKey(key) {
    if (key && key.toString)
        return key.toString();
    else
        return new String(key).toString();
}
function getMapLikeKeys(map) {
    if (isPlainObject(map))
        return Object.keys(map);
    if (Array.isArray(map))
        return map.map(function (_a) {
            var _b = __read(_a, 1), key = _b[0];
            return key;
        });
    if (isES6Map(map) || isObservableMap(map))
        return Array.from(map.keys());
    return fail("Cannot get keys from '" + map + "'");
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

var $mobx = Symbol("mobx administration");
var Atom = /** @class */ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        this.name = name;
        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.isBeingObserved = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    Atom.prototype.onBecomeObserved = function () {
        if (this.onBecomeObservedListeners) {
            this.onBecomeObservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    Atom.prototype.onBecomeUnobserved = function () {
        if (this.onBecomeUnobservedListeners) {
            this.onBecomeUnobservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */
    Atom.prototype.reportObserved = function () {
        return reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    Atom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    Atom.prototype.toString = function () {
        return this.name;
    };
    return Atom;
}());
var isAtom = createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) {
        onBecomeObserved(atom, onBecomeObservedHandler);
    }
    if (onBecomeUnobservedHandler !== noop) {
        onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    }
    return atom;
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    return Object.is(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer,
    shallow: shallowComparer
};

var mobxDidRunLazyInitializersSymbol = Symbol("mobx did run lazy initializers");
var mobxPendingDecorators = Symbol("mobx pending decorators");
var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return (cache[prop] ||
        (cache[prop] = {
            configurable: true,
            enumerable: enumerable,
            get: function () {
                initializeInstance(this);
                return this[prop];
            },
            set: function (value) {
                initializeInstance(this);
                this[prop] = value;
            }
        }));
}
function initializeInstance(target) {
    var e_1, _a;
    if (target[mobxDidRunLazyInitializersSymbol] === true)
        return;
    var decorators = target[mobxPendingDecorators];
    if (decorators) {
        addHiddenProp(target, mobxDidRunLazyInitializersSymbol, true);
        // Build property key array from both strings and symbols
        var keys = __spread(Object.getOwnPropertySymbols(decorators), Object.keys(decorators));
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                var d = decorators[key];
                d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
}
function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate(target, prop, descriptor, applyImmediately
        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
        // as the instance to apply the decorator to equals the target
        ) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if ( true && !quacksLikeADecorator(arguments))
                fail("This function is a decorator, but it wasn't invoked like a decorator");
            if (!Object.prototype.hasOwnProperty.call(target, mobxPendingDecorators)) {
                var inheritedDecorators = target[mobxPendingDecorators];
                addHiddenProp(target, mobxPendingDecorators, __assign({}, inheritedDecorators));
            }
            target[mobxPendingDecorators][prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY;
            return decorator.apply(null, arguments);
        }
        else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator(args) {
    return (((args.length === 2 || args.length === 3) &&
        (typeof args[1] === "string" || typeof args[1] === "symbol")) ||
        (args.length === 4 && args[3] === true));
}

function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, { name: name });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name });
    if (isES6Map(v))
        return observable.map(v, { name: name });
    if (isES6Set(v))
        return observable.set(v, { name: name });
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v))
        return v;
    if (Array.isArray(v))
        return observable.array(v, { name: name, deep: false });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name, deep: false });
    if (isES6Map(v))
        return observable.map(v, { name: name, deep: false });
    if (isES6Set(v))
        return observable.set(v, { name: name, deep: false });
    return fail( true &&
        "The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue, name) {
    if ( true && isObservable(v))
        throw "observable.struct should not be used with observable values";
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

function createDecoratorForEnhancer(enhancer) {
    invariant(enhancer);
    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        if (true) {
            invariant(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + stringifyKey(propertyName) + "\"), use @computed instead.");
        }
        var initialValue = descriptor
            ? descriptor.initializer
                ? descriptor.initializer.call(target)
                : descriptor.value
            : undefined;
        asObservableObject(target).addObservableProp(propertyName, initialValue, enhancer);
    });
    var res = 
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && process.env && "development" !== "production"
        ? function observableDecorator() {
            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
            // and simply return the created prop decorator
            if (arguments.length < 2)
                return fail("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
            return decorator.apply(null, arguments);
        }
        : decorator;
    res.enhancer = enhancer;
    return res;
}

// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function assertValidOption(key) {
    if (!/^(deep|name|equals|defaultDecorator|proxy)$/.test(key))
        fail("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions(thing) {
    if (thing === null || thing === undefined)
        return defaultCreateObservableOptions;
    if (typeof thing === "string")
        return { name: thing, deep: true, proxy: true };
    if (true) {
        if (typeof thing !== "object")
            return fail("expected options object");
        Object.keys(thing).forEach(assertValidOption);
    }
    return thing;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
function getEnhancerFromOptions(options) {
    return options.defaultDecorator
        ? options.defaultDecorator.enhancer
        : options.deep === false
            ? referenceEnhancer
            : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string" || typeof arguments[1] === "symbol") {
        return deepDecorator.apply(null, arguments);
    }
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = isPlainObject(v)
        ? observable.object(v, arg2, arg3)
        : Array.isArray(v)
            ? observable.array(v, arg2)
            : isES6Map(v)
                ? observable.map(v, arg2)
                : isES6Set(v)
                    ? observable.set(v, arg2)
                    : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    fail( true &&
        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
}
var observableFactories = {
    box: function (value, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions(options);
        return createObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("set");
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function (props, decorators, options) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions(options);
        if (o.proxy === false) {
            return extendObservable({}, props, decorators, o);
        }
        else {
            var defaultDecorator = getDefaultDecoratorFromObjectOptions(o);
            var base = extendObservable({}, undefined, undefined, o);
            var proxy = createDynamicObservableObject(base);
            extendObservableObjectWithProperties(proxy, props, decorators, defaultDecorator);
            return proxy;
        }
    },
    ref: refDecorator,
    shallow: shallowDecorator,
    deep: deepDecorator,
    struct: refStructDecorator
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
function incorrectlyUsedAsDecorator(methodName) {
    fail(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    // Forcing instance now, fixes hot reloadig issues on React Native:
    var options = decoratorArgs[0] || {};
    asObservableObject(instance).addComputedProp(instance, propertyName, __assign({ get: get,
        set: set, context: instance }, options));
});
var computedStructDecorator = computedDecorator({ equals: comparer.structural });
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        // @computed
        return computedDecorator.apply(null, arguments);
    }
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
        // @computed({ options })
        return computedDecorator.apply(null, arguments);
    }
    // computed(expr, options?)
    if (true) {
        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
    }
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */
    return new ComputedValue(opts);
};
computed.struct = computedStructDecorator;

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) {
                        obj.get();
                    }
                    else {
                        try {
                            obj.get();
                        }
                        catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            untrackedEnd(prevUntracked);
                            allowStateReadsEnd(prevAllowStateReads);
                            return true;
                        }
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
        }
    }
}
// function invariantShouldCompute(derivation: IDerivation) {
//     const newDepState = (derivation as any).dependenciesState
//     if (
//         process.env.NODE_ENV === "production" &&
//         (newDepState === IDerivationState.POSSIBLY_STALE ||
//             newDepState === IDerivationState.NOT_TRACKING)
//     )
//         fail("Illegal dependency state")
// }
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers = atom.observers.size > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers)
        fail( true &&
            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "strict"))
        fail( true &&
            (globalState.enforceActions
                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
                atom.name);
}
function checkIfStateReadsAreAllowed(observable) {
    if ( true &&
        !globalState.allowStateReads &&
        globalState.observableRequiresReaction) {
        console.warn("[mobx] Observable " + observable.name + " being read outside a reactive context");
    }
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    if (globalState.disableErrorBoundaries === true) {
        result = f.call(context);
    }
    else {
        try {
            result = f.call(context);
        }
        catch (e) {
            result = new CaughtException(e);
        }
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    if (false)
        {}
    if (derivation.observing.length !== 0)
        return;
    if (globalState.reactionRequiresObservable || derivation.requiresObservable) {
        console.warn("[mobx] Derivation " + derivation.name + " is created/updated without reading any observable value");
    }
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    }
    finally {
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var functionNameDescriptor = Object.getOwnPropertyDescriptor(function () { }, "name");
var isFunctionNameConfigurable = functionNameDescriptor && functionNameDescriptor.configurable;
function createAction(actionName, fn, ref) {
    if (true) {
        invariant(typeof fn === "function", "`action` can only be invoked on functions");
        if (typeof actionName !== "string" || !actionName)
            fail("actions should have valid names, got: '" + actionName + "'");
    }
    var res = function () {
        return executeAction(actionName, fn, ref || this, arguments);
    };
    res.isMobxAction = true;
    if (true) {
        if (isFunctionNameConfigurable) {
            Object.defineProperty(res, "name", { value: actionName });
        }
    }
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = _startAction(actionName, scope, args);
    try {
        return fn.apply(scope, args);
    }
    catch (err) {
        runInfo.error = err;
        throw err;
    }
    finally {
        _endAction(runInfo);
    }
}
function _startAction(actionName, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy && "development" !== "production") {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    var prevAllowStateReads = allowStateReadsStart(true);
    var runInfo = {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        prevAllowStateReads: prevAllowStateReads,
        notifySpy: notifySpy,
        startTime: startTime,
        actionId: nextActionId++,
        parentActionId: currentActionId
    };
    currentActionId = runInfo.actionId;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId) {
        fail("invalid action stack. did you forget to finish an action?");
    }
    currentActionId = runInfo.parentActionId;
    if (runInfo.error !== undefined) {
        globalState.suppressReactionErrors = true;
    }
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    allowStateReadsEnd(runInfo.prevAllowStateReads);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy && "development" !== "production") {
        spyReportEnd({ time: Date.now() - runInfo.startTime });
    }
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
function allowStateChangesInsideComputed(func) {
    var prev = globalState.computationDepth;
    globalState.computationDepth = 0;
    var res;
    try {
        res = func();
    }
    finally {
        globalState.computationDepth = prev;
    }
    return res;
}

var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy, equals) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        if (equals === void 0) { equals = comparer.default; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.name = name;
        _this.equals = equals;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled() && "development" !== "production") {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy && "development" !== "production") {
                spyReportStart({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy && "development" !== "production")
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.equals(this.value, newValue) ? globalState.UNCHANGED : newValue;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ObservableValue.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom));
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce a new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(options) {
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        invariant(options.get, "missing option for computed: get");
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId();
        if (options.set)
            this.setter = createAction(this.name + "-setter", options.set);
        this.equals =
            options.equals ||
                (options.compareStructural || options.struct
                    ? comparer.structural
                    : comparer.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        this.keepAlive = !!options.keepAlive;
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeObserved = function () {
        if (this.onBecomeObservedListeners) {
            this.onBecomeObservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        if (this.onBecomeUnobservedListeners) {
            this.onBecomeUnobservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        if (this.isComputing)
            fail("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState.inBatch === 0 && this.observers.size === 0 && !this.keepAlive) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead();
                startBatch(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch();
            }
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false,  true &&
                "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled() && "development" !== "production") {
            spyReport({
                object: this.scope,
                type: "compute",
                name: this.name
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue);
        if (changed) {
            this.value = newValue;
        }
        return changed;
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            if (globalState.disableErrorBoundaries === true) {
                res = this.derivation.call(this.scope);
            }
            else {
                try {
                    res = this.derivation.call(this.scope);
                }
                catch (e) {
                    res = new CaughtException(e);
                }
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.suspend = function () {
        if (!this.keepAlive) {
            clearObserving(this);
            this.value = undefined; // don't hold on to computed value!
        }
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.warnAboutUntrackedRead = function () {
        if (false)
            {}
        if (this.requiresReaction === true) {
            fail("[mobx] Computed value " + this.name + " is read outside a reactive context");
        }
        if (this.isTracing !== TraceMode.NONE) {
            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
        }
        if (globalState.computedRequiresReaction) {
            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
        }
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ComputedValue;
}());
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

/**
 * These values will persist if global state is reset
 */
var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED"
];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         *
         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
         * internal state storage of MobX, and can be the same across many different package versions
         */
        this.version = 5;
        /**
         * globally unique token to signal unchanged
         */
        this.UNCHANGED = {};
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * Is it allowed to read observables at this point?
         * Used to hold the state needed for `observableRequiresReaction`
         */
        this.allowStateReads = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.enforceActions = false;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */
        this.computedRequiresReaction = false;
        /**
         * (Experimental)
         * Warn if you try to create to derivation / reactive context without accessing any observable.
         */
        this.reactionRequiresObservable = false;
        /**
         * (Experimental)
         * Warn if observables are accessed outside a reactive context
         */
        this.observableRequiresReaction = false;
        /**
         * Allows overwriting of computed properties, useful in tests but not prod as it can cause
         * memory leaks. See https://github.com/mobxjs/mobx/issues/1867
         */
        this.computedConfigurable = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */
        this.disableErrorBoundaries = false;
        /*
         * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
         * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
         */
        this.suppressReactionErrors = false;
    }
    return MobXGlobals;
}());
var mockGlobal = {};
function getGlobal() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    return mockGlobal;
}
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = (function () {
    var global = getGlobal();
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals)
        canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version)
        canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        setTimeout(function () {
            if (!isolateCalled) {
                fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
            }
        }, 1);
        return new MobXGlobals();
    }
    else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        if (!global.__mobxGlobals.UNCHANGED)
            global.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
        return global.__mobxGlobals;
    }
    else {
        global.__mobxInstanceCount = 1;
        return (global.__mobxGlobals = new MobXGlobals());
    }
})();
function isolateGlobalState() {
    if (globalState.pendingReactions.length ||
        globalState.inBatch ||
        globalState.isRunningReactions)
        fail("isolateGlobalState should be called before MobX is running any reactions");
    isolateCalled = true;
    if (canMergeGlobalState) {
        if (--getGlobal().__mobxInstanceCount === 0)
            getGlobal().__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.size > 0;
}
function getObservers(observable) {
    return observable.observers;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers.add(node);
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers.delete(node);
    if (observable.observers.size === 0) {
        // deleting last observer
        queueForUnobservation(observable);
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBecomeUnobserved();
                }
                if (observable instanceof ComputedValue) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observabe of another, etc..
                    observable.suspend();
                }
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
            if (!observable.isBeingObserved) {
                observable.isBeingObserved = true;
                observable.onBecomeObserved();
            }
        }
        return true;
    }
    else if (observable.observers.size === 0 && globalState.inBatch > 0) {
        queueForUnobservation(observable);
    }
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    });
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    });
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    });
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate, errorHandler, requiresObservable) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        if (requiresObservable === void 0) { requiresObservable = false; }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.requiresObservable = requiresObservable;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending &&
                        isSpyEnabled() &&
                        "development" !== "production") {
                        // onInvalidate didn't trigger track right away..
                        spyReport({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    }
                }
                catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        if (this.isDisposed) {
            return;
            // console.warn("Reaction already disposed") // Note: Not a warning / error in mobx 4 either
        }
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify && "development" !== "production") {
            startTime = Date.now();
            spyReportStart({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify && "development" !== "production") {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries)
            throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
        if (globalState.suppressReactionErrors) {
            console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
        }
        else {
            console.error(message, error);
            /** If debugging brought you here, please, read the above message :-). Tnx! */
        }
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r[$mobx] = this;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function isSpyEnabled() {
    return  true && !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (false)
        {} // dead code elimination can do the rest
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    if (false)
        {}
    var change = __assign(__assign({}, event), { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (false)
        {}
    if (change)
        spyReport(__assign(__assign({}, change), { spyReportEnd: true }));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    if (false) {}
    else {
        globalState.spyListeners.push(listener);
        return once(function () {
            globalState.spyListeners = globalState.spyListeners.filter(function (l) { return l !== listener; });
        });
    }
}

function dontReassignFields() {
    fail( true && "@action fields are not reassignable");
}
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor) {
            if ( true && descriptor.get !== undefined) {
                return fail("@action cannot be used with getters");
            }
            // babel / typescript
            // @action method() { }
            if (descriptor.value) {
                // typescript
                return {
                    value: createAction(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
                };
            }
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function () {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function actionFieldDecorator(name) {
    // Simple property that writes on first invocation to the current instance
    return function (target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function () {
                return undefined;
            },
            set: function (value) {
                addHiddenProp(this, prop, action(name, value));
            }
        });
    };
}
function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) {
        // if (descriptor.value)
        // Typescript / Babel: @action.bound method() { }
        // also: babel @action.bound method = () => {}
        return {
            configurable: true,
            enumerable: false,
            get: function () {
                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
    }
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function (v) {
            defineBoundAction(this, propertyName, v);
        },
        get: function () {
            return undefined;
        }
    };
}

var action = function action(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    // @action fn() {}
    if (arg4 === true) {
        // apply to instance immediately
        addHiddenProp(arg1, arg2, createAction(arg1.name || arg2, arg3.value, this));
    }
    else {
        return namedActionDecorator(arg2).apply(null, arguments);
    }
};
action.bound = boundActionDecorator;
function runInAction(arg1, arg2) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    if (true) {
        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
        if (typeof actionName !== "string" || !actionName)
            fail("actions should have valid names, got: '" + actionName + "'");
    }
    return executeAction(actionName, fn, this, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
}

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun(view, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (true) {
        invariant(typeof view === "function", "Autorun expects a function as first argument");
        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
    }
    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) {
        // normal autorun
        reaction = new Reaction(name, function () {
            this.track(reactionRunner);
        }, opts.onError, opts.requiresObservable);
    }
    else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction = new Reaction(name, function () {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction.isDisposed)
                        reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
var run = function (f) { return f(); };
function createSchedulerFromOptions(opts) {
    return opts.scheduler
        ? opts.scheduler
        : opts.delay
            ? function (f) { return setTimeout(f, opts.delay); }
            : run;
}
function reaction(expression, effect, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (true) {
        invariant(typeof expression === "function", "First argument to reaction should be a function");
        invariant(typeof opts === "object", "Third argument of reactions should be an object");
    }
    var name = opts.name || "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural
        ? comparer.structural
        : opts.equals || comparer.default;
    var r = new Reaction(name, function () {
        if (firstTime || runSync) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false; // Q: move into reaction runner?
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effectAction(value, r);
        if (!firstTime && changed === true)
            effectAction(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function () {
        try {
            return baseFn.apply(this, arguments);
        }
        catch (e) {
            errorHandler.call(this, e);
        }
    };
}

function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = typeof arg3 === "function" ? arg3 : arg2;
    var listenersKey = hook + "Listeners";
    if (atom[listenersKey]) {
        atom[listenersKey].add(cb);
    }
    else {
        atom[listenersKey] = new Set([cb]);
    }
    var orig = atom[hook];
    if (typeof orig !== "function")
        return fail( true && "Not an atom that can be (un)observed");
    return function () {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners.delete(cb);
            if (hookListeners.size === 0) {
                delete atom[listenersKey];
            }
        }
    };
}

function configure(options) {
    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, computedConfigurable = options.computedConfigurable, disableErrorBoundaries = options.disableErrorBoundaries, reactionScheduler = options.reactionScheduler, reactionRequiresObservable = options.reactionRequiresObservable, observableRequiresReaction = options.observableRequiresReaction;
    if (options.isolateGlobalState === true) {
        isolateGlobalState();
    }
    if (enforceActions !== undefined) {
        if (typeof enforceActions === "boolean" || enforceActions === "strict")
            deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
        var ea = void 0;
        switch (enforceActions) {
            case true:
            case "observed":
                ea = true;
                break;
            case false:
            case "never":
                ea = false;
                break;
            case "strict":
            case "always":
                ea = "strict";
                break;
            default:
                fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
        }
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) {
        globalState.computedRequiresReaction = !!computedRequiresReaction;
    }
    if (reactionRequiresObservable !== undefined) {
        globalState.reactionRequiresObservable = !!reactionRequiresObservable;
    }
    if (observableRequiresReaction !== undefined) {
        globalState.observableRequiresReaction = !!observableRequiresReaction;
        globalState.allowStateReads = !globalState.observableRequiresReaction;
    }
    if (computedConfigurable !== undefined) {
        globalState.computedConfigurable = !!computedConfigurable;
    }
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true)
            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (reactionScheduler) {
        setReactionScheduler(reactionScheduler);
    }
}

function decorate(thing, decorators) {
     true &&
        invariant(isPlainObject(decorators), "Decorators should be a key value map");
    var target = typeof thing === "function" ? thing.prototype : thing;
    var _loop_1 = function (prop) {
        var propertyDecorators = decorators[prop];
        if (!Array.isArray(propertyDecorators)) {
            propertyDecorators = [propertyDecorators];
        }
         true &&
            invariant(propertyDecorators.every(function (decorator) { return typeof decorator === "function"; }), "Decorate: expected a decorator function or array of decorator functions for '" + prop + "'");
        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
        var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) { return decorator(target, prop, accDescriptor); }, descriptor);
        if (newDescriptor)
            Object.defineProperty(target, prop, newDescriptor);
    };
    for (var prop in decorators) {
        _loop_1(prop);
    }
    return thing;
}

function extendObservable(target, properties, decorators, options) {
    if (true) {
        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
        invariant(typeof target === "object", "'extendObservable' expects an object as first argument");
        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
    }
    options = asCreateObservableOptions(options);
    var defaultDecorator = getDefaultDecoratorFromObjectOptions(options);
    initializeInstance(target); // Fixes #1740
    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    if (properties)
        extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator);
    return target;
}
function getDefaultDecoratorFromObjectOptions(options) {
    return options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
}
function extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator) {
    var e_1, _a, e_2, _b;
    if (true) {
        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
        if (decorators) {
            var keys = getPlainObjectKeys(decorators);
            try {
                for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                    var key = keys_1_1.value;
                    if (!(key in properties))
                        fail("Trying to declare a decorator for unspecified property '" + stringifyKey(key) + "'");
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    }
    startBatch();
    try {
        var keys = getPlainObjectKeys(properties);
        try {
            for (var keys_2 = __values(keys), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
                var key = keys_2_1.value;
                var descriptor = Object.getOwnPropertyDescriptor(properties, key);
                if (true) {
                    if (!isPlainObject(properties))
                        fail("'extendObservabe' only accepts plain objects as second argument");
                    if (isComputed(descriptor.value))
                        fail("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
                }
                var decorator = decorators && key in decorators
                    ? decorators[key]
                    : descriptor.get
                        ? computedDecorator
                        : defaultDecorator;
                if ( true && typeof decorator !== "function")
                    fail("Not a valid decorator for '" + stringifyKey(key) + "', got: " + decorator);
                var resultDescriptor = decorator(target, key, descriptor, true);
                if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
                )
                    Object.defineProperty(target, key, resultDescriptor);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (keys_2_1 && !keys_2_1.done && (_b = keys_2.return)) _b.call(keys_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    finally {
        endBatch();
    }
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}

var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
function flow(generator) {
    if (arguments.length !== 1)
        fail( true && "Flow expects 1 argument and cannot be used as decorator");
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    return function () {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function (resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done)
                    return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function () {
            try {
                if (pendingPromise)
                    cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var res = gen.return(undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            }
            catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
}
function cancelPromise(promise) {
    if (typeof promise.cancel === "function")
        promise.cancel();
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail( true &&
                "InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail( true &&
            "Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail( true && "An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

function _isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value[$mobx].values.has(property))
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function isComputed(value) {
    if (arguments.length > 1)
        return fail( true &&
            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (typeof propName !== "string")
        return fail( true &&
            "isComputed expected a property name as second argument");
    return _isComputed(value, propName);
}

function _isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if ( true &&
            (isObservableMap(value) || isObservableArray(value)))
            return fail("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if (isObservableObject(value)) {
            return value[$mobx].values.has(property);
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value[$mobx] ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}
function isObservable(value) {
    if (arguments.length !== 1)
        fail( true &&
            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (typeof propName !== "string")
        return fail( true && "expected a property name as second argument");
    return _isObservable(value, propName);
}

function keys(obj) {
    if (isObservableObject(obj)) {
        return obj[$mobx].getKeys();
    }
    if (isObservableMap(obj)) {
        return Array.from(obj.keys());
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.keys());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (_, index) { return index; });
    }
    return fail( true &&
        "'keys()' can only be used on observable objects, arrays, sets and maps");
}
function values(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return obj[key]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return obj.get(key); });
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.values());
    }
    if (isObservableArray(obj)) {
        return obj.slice();
    }
    return fail( true &&
        "'values()' can only be used on observable objects, arrays, sets and maps");
}
function entries(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return [key, obj[key]]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return [key, obj.get(key)]; });
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.entries());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (key, index) { return [index, key]; });
    }
    return fail( true &&
        "'entries()' can only be used on observable objects, arrays and maps");
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var values_1 = key;
        try {
            for (var key_1 in values_1)
                set(obj, key_1, values_1[key_1]);
        }
        finally {
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) {
        var adm = obj[$mobx];
        var existingObservable = adm.values.get(key);
        if (existingObservable) {
            adm.write(key, value);
        }
        else {
            adm.addObservableProp(key, value, adm.defaultEnhancer);
        }
    }
    else if (isObservableMap(obj)) {
        obj.set(key, value);
    }
    else if (isObservableSet(obj)) {
        obj.add(key);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        startBatch();
        if (key >= obj.length)
            obj.length = key + 1;
        obj[key] = value;
        endBatch();
    }
    else {
        return fail( true &&
            "'set()' can only be used on observable objects, arrays and maps");
    }
}
function remove(obj, key) {
    if (isObservableObject(obj)) {
        obj[$mobx].remove(key);
    }
    else if (isObservableMap(obj)) {
        obj.delete(key);
    }
    else if (isObservableSet(obj)) {
        obj.delete(key);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        obj.splice(key, 1);
    }
    else {
        return fail( true &&
            "'remove()' can only be used on observable objects, arrays and maps");
    }
}
function has(obj, key) {
    if (isObservableObject(obj)) {
        // return keys(obj).indexOf(key) >= 0
        var adm = getAdministration(obj);
        return adm.has(key);
    }
    else if (isObservableMap(obj)) {
        return obj.has(key);
    }
    else if (isObservableSet(obj)) {
        return obj.has(key);
    }
    else if (isObservableArray(obj)) {
        return key >= 0 && key < obj.length;
    }
    else {
        return fail( true &&
            "'has()' can only be used on observable objects, arrays and maps");
    }
}
function get(obj, key) {
    if (!has(obj, key))
        return undefined;
    if (isObservableObject(obj)) {
        return obj[key];
    }
    else if (isObservableMap(obj)) {
        return obj.get(key);
    }
    else if (isObservableArray(obj)) {
        return obj[key];
    }
    else {
        return fail( true &&
            "'get()' can only be used on observable objects, arrays and maps");
    }
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

var defaultOptions = {
    detectCycles: true,
    exportMapsAsObjects: true,
    recurseEverything: false
};
function cache(map, key, value, options) {
    if (options.detectCycles)
        map.set(key, value);
    return value;
}
function toJSHelper(source, options, __alreadySeen) {
    if (!options.recurseEverything && !isObservable(source))
        return source;
    if (typeof source !== "object")
        return source;
    // Directly return null if source is null
    if (source === null)
        return null;
    // Directly return the Date object itself if contained in the observable
    if (source instanceof Date)
        return source;
    if (isObservableValue(source))
        return toJSHelper(source.get(), options, __alreadySeen);
    // make sure we track the keys of the object
    if (isObservable(source))
        keys(source);
    var detectCycles = options.detectCycles === true;
    if (detectCycles && source !== null && __alreadySeen.has(source)) {
        return __alreadySeen.get(source);
    }
    if (isObservableArray(source) || Array.isArray(source)) {
        var res_1 = cache(__alreadySeen, source, [], options);
        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
        res_1.length = toAdd.length;
        for (var i = 0, l = toAdd.length; i < l; i++)
            res_1[i] = toAdd[i];
        return res_1;
    }
    if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_2 = cache(__alreadySeen, source, new Set(), options);
            source.forEach(function (value) {
                res_2.add(toJSHelper(value, options, __alreadySeen));
            });
            return res_2;
        }
        else {
            var res_3 = cache(__alreadySeen, source, [], options);
            source.forEach(function (value) {
                res_3.push(toJSHelper(value, options, __alreadySeen));
            });
            return res_3;
        }
    }
    if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_4 = cache(__alreadySeen, source, new Map(), options);
            source.forEach(function (value, key) {
                res_4.set(key, toJSHelper(value, options, __alreadySeen));
            });
            return res_4;
        }
        else {
            var res_5 = cache(__alreadySeen, source, {}, options);
            source.forEach(function (value, key) {
                res_5[key] = toJSHelper(value, options, __alreadySeen);
            });
            return res_5;
        }
    }
    // Fallback to the situation that source is an ObservableObject or a plain object
    var res = cache(__alreadySeen, source, {}, options);
    getPlainObjectKeys(source).forEach(function (key) {
        res[key] = toJSHelper(source[key], options, __alreadySeen);
    });
    return res;
}
function toJS(source, options) {
    // backward compatibility
    if (typeof options === "boolean")
        options = { detectCycles: options };
    if (!options)
        options = defaultOptions;
    options.detectCycles =
        options.detectCycles === undefined
            ? options.recurseEverything === true
            : options.detectCycles === true;
    var __alreadySeen;
    if (options.detectCycles)
        __alreadySeen = new Map();
    return toJSHelper(source, options, __alreadySeen);
}

function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail( true &&
            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
        return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        timeoutHandle = setTimeout(function () {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                var error = new Error("WHEN_TIMEOUT");
                if (opts.onError)
                    opts.onError(error);
                else
                    throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    var disposer = autorun(function (r) {
        if (predicate()) {
            r.dispose();
            if (timeoutHandle)
                clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    if ( true && opts && opts.onError)
        return fail("the options 'onError' and 'promise' cannot be combined");
    var cancel;
    var res = new Promise(function (resolve, reject) {
        var disposer = _when(predicate, resolve, __assign(__assign({}, opts), { onError: reject }));
        cancel = function () {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}

function getAdm(target) {
    return target[$mobx];
}
function isPropertyKey(val) {
    return typeof val === "string" || typeof val === "number" || typeof val === "symbol";
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function (target, name) {
        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol)
            return true;
        var adm = getAdm(target);
        // MWE: should `in` operator be reactive? If not, below code path will be faster / more memory efficient
        // TODO: check performance stats!
        // if (adm.values.get(name as string)) return true
        if (isPropertyKey(name))
            return adm.has(name);
        return name in target;
    },
    get: function (target, name) {
        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol)
            return target[name];
        var adm = getAdm(target);
        var observable = adm.values.get(name);
        if (observable instanceof Atom) {
            var result = observable.get();
            if (result === undefined) {
                // This fixes #1796, because deleting a prop that has an
                // undefined value won't retrigger a observer (no visible effect),
                // the autorun wouldn't subscribe to future key changes (see also next comment)
                adm.has(name);
            }
            return result;
        }
        // make sure we start listening to future keys
        // note that we only do this here for optimization
        if (isPropertyKey(name))
            adm.has(name);
        return target[name];
    },
    set: function (target, name, value) {
        if (!isPropertyKey(name))
            return false;
        set(target, name, value);
        return true;
    },
    deleteProperty: function (target, name) {
        if (!isPropertyKey(name))
            return false;
        var adm = getAdm(target);
        adm.remove(name);
        return true;
    },
    ownKeys: function (target) {
        var adm = getAdm(target);
        adm.keysAtom.reportObserved();
        return Reflect.ownKeys(target);
    },
    preventExtensions: function (target) {
        fail("Dynamic observable objects cannot be frozen");
        return false;
    }
};
function createDynamicObservableObject(base) {
    var proxy = new Proxy(base, objectProxyTraps);
    base[$mobx].proxy = proxy;
    return proxy;
}

function hasInterceptors(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = __spread((interceptable.interceptors || []));
        for (var i = 0, l = interceptors.length; i < l; i++) {
            change = interceptors[i](change);
            invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
            if (!change)
                break;
        }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function (target, name) {
        if (name === $mobx)
            return target[$mobx];
        if (name === "length")
            return target[$mobx].getArrayLength();
        if (typeof name === "number") {
            return arrayExtensions.get.call(target, name);
        }
        if (typeof name === "string" && !isNaN(name)) {
            return arrayExtensions.get.call(target, parseInt(name));
        }
        if (arrayExtensions.hasOwnProperty(name)) {
            return arrayExtensions[name];
        }
        return target[name];
    },
    set: function (target, name, value) {
        if (name === "length") {
            target[$mobx].setArrayLength(value);
        }
        if (typeof name === "number") {
            arrayExtensions.set.call(target, name, value);
        }
        if (typeof name === "symbol" || isNaN(name)) {
            target[name] = value;
        }
        else {
            // numeric string
            arrayExtensions.set.call(target, parseInt(name), value);
        }
        return true;
    },
    preventExtensions: function (target) {
        fail("Observable arrays cannot be frozen");
        return false;
    }
};
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) { name = "ObservableArray@" + getNextId(); }
    if (owned === void 0) { owned = false; }
    var adm = new ObservableArrayAdministration(name, enhancer, owned);
    addHiddenFinalProp(adm.values, $mobx, adm);
    var proxy = new Proxy(adm.values, arrayTraps);
    adm.proxy = proxy;
    if (initialValues && initialValues.length) {
        var prev = allowStateChangesStart(true);
        adm.spliceWithArray(0, 0, initialValues);
        allowStateChangesEnd(prev);
    }
    return proxy;
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, owned) {
        this.owned = owned;
        this.values = [];
        this.proxy = undefined;
        this.lastKnownLength = 0;
        this.atom = new Atom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined && values.length > 0)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.proxy,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed.");
        this.lastKnownLength += delta;
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
        if (true) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        var _a;
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.proxy,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
        if (notifySpy && "development" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "development" !== "production")
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.proxy,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy && "development" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "development" !== "production")
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var arrayExtensions = {
    intercept: function (handler) {
        return this[$mobx].intercept(handler);
    },
    observe: function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        var adm = this[$mobx];
        return adm.observe(listener, fireImmediately);
    },
    clear: function () {
        return this.splice(0);
    },
    replace: function (newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray(0, adm.values.length, newItems);
    },
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    toJS: function () {
        return this.slice();
    },
    toJSON: function () {
        // Used by JSON.stringify
        return this.toJS();
    },
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    splice: function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        var adm = this[$mobx];
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray(index);
            case 2:
                return adm.spliceWithArray(index, deleteCount);
        }
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    spliceWithArray: function (index, deleteCount, newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    push: function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx];
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    },
    pop: function () {
        return this.splice(Math.max(this[$mobx].values.length - 1, 0), 1)[0];
    },
    shift: function () {
        return this.splice(0, 1)[0];
    },
    unshift: function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx];
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    },
    reverse: function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        if (true) {
            console.warn("[mobx] `observableArray.reverse()` will not update the array in place. Use `observableArray.slice().reverse()` to suppress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().reverse())` to reverse & update in place");
        }
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    },
    sort: function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (true) {
            console.warn("[mobx] `observableArray.sort()` will not update the array in place. Use `observableArray.slice().sort()` to suppress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().sort())` to sort & update in place");
        }
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    },
    remove: function (value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues(adm.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    },
    get: function (index) {
        var adm = this[$mobx];
        if (adm) {
            if (index < adm.values.length) {
                adm.atom.reportObserved();
                return adm.dehanceValue(adm.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + adm.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    },
    set: function (index, newValue) {
        var adm = this[$mobx];
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: adm.proxy,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    }
};
[
    "concat",
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    arrayExtensions[funcName] = function () {
        var adm = this[$mobx];
        adm.atom.reportObserved();
        var res = adm.dehanceValues(adm.values);
        return res[funcName].apply(res, arguments);
    };
});
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}

var _a;
var ObservableMapMarker = {};
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this[_a] = ObservableMapMarker;
        this._keysAtom = createAtom(this.name + ".keys()");
        this[Symbol.toStringTag] = "Map";
        if (typeof Map !== "function") {
            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        }
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return this._data.has(key);
    };
    ObservableMap.prototype.has = function (key) {
        var _this = this;
        if (!globalState.trackingDerivation)
            return this._has(key);
        var entry = this._hasMap.get(key);
        if (!entry) {
            // todo: replace with atom (breaking change)
            var newEntry = (entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false));
            this._hasMap.set(key, newEntry);
            onBecomeUnobserved(newEntry, function () { return _this._hasMap.delete(key); });
        }
        return entry.get();
    };
    ObservableMap.prototype.set = function (key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data.get(key).value,
                    name: key
                }
                : null;
            if (notifySpy && "development" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            transaction(function () {
                _this._keysAtom.reportChanged();
                _this._updateHasMapEntry(key, false);
                var observable = _this._data.get(key);
                observable.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "development" !== "production")
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        var entry = this._hasMap.get(key);
        if (entry) {
            entry.setNewValue(value);
        }
    };
    ObservableMap.prototype._updateValue = function (key, newValue) {
        var observable = this._data.get(key);
        newValue = observable.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy && "development" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "development" !== "production")
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (key, newValue) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        transaction(function () {
            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);
            _this._data.set(key, observable);
            newValue = observable.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keysAtom.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy && "development" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "development" !== "production")
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        if (this.has(key))
            return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        this._keysAtom.reportObserved();
        return this._data.keys();
    };
    ObservableMap.prototype.values = function () {
        var self = this;
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        return makeIterable({
            next: function () {
                return nextIndex < keys.length
                    ? { value: self.get(keys[nextIndex++]), done: false }
                    : { done: true };
            }
        });
    };
    ObservableMap.prototype.entries = function () {
        var self = this;
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        return makeIterable({
            next: function () {
                if (nextIndex < keys.length) {
                    var key = keys[nextIndex++];
                    return {
                        value: [key, self.get(key)],
                        done: false
                    };
                }
                return { done: true };
            }
        });
    };
    ObservableMap.prototype[(_a = $mobx, Symbol.iterator)] = function () {
        return this.entries();
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var e_1, _b;
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                callback.call(thisArg, value, key, this);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other))
                getPlainObjectKeys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_b) {
                    var _c = __read(_b, 2), key = _c[0], value = _c[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other)) {
                if (other.constructor !== Map)
                    fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
                other.forEach(function (value, key) { return _this.set(key, value); });
            }
            else if (other !== null && other !== undefined)
                fail("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                var e_2, _b;
                try {
                    for (var _c = __values(_this.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var key = _d.value;
                        _this.delete(key);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = Array.from(_this.keys());
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            this._keysAtom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */
    ObservableMap.prototype.toPOJO = function () {
        var e_3, _b;
        var res = {};
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                // We lie about symbol key types due to https://github.com/Microsoft/TypeScript/issues/1863
                res[typeof key === "symbol" ? key : stringifyKey(key)] = value;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        return new Map(this);
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            Array.from(this.keys())
                .map(function (key) { return stringifyKey(key) + ": " + ("" + _this.get(key)); })
                .join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
         true &&
            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var _a$1;
var ObservableSetMarker = {};
var ObservableSet = /** @class */ (function () {
    function ObservableSet(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableSet@" + getNextId(); }
        this.name = name;
        this[_a$1] = ObservableSetMarker;
        this._data = new Set();
        this._atom = createAtom(this.name);
        this[Symbol.toStringTag] = "Set";
        if (typeof Set !== "function") {
            throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
        }
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name); };
        if (initialData) {
            this.replace(initialData);
        }
    }
    ObservableSet.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableSet.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                var e_1, _b;
                try {
                    for (var _c = __values(_this._data.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var value = _d.value;
                        _this.delete(value);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
        });
    };
    ObservableSet.prototype.forEach = function (callbackFn, thisArg) {
        var e_2, _b;
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var value = _d.value;
                callbackFn.call(thisArg, value, value, this);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Object.defineProperty(ObservableSet.prototype, "size", {
        get: function () {
            this._atom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    ObservableSet.prototype.add = function (value) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._atom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "add",
                object: this,
                newValue: value
            });
            if (!change)
                return this;
            // TODO: ideally, value = change.value would be done here, so that values can be
            // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function () {
                _this._data.add(_this.enhancer(value, undefined));
                _this._atom.reportChanged();
            });
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "add",
                    object: this,
                    newValue: value
                }
                : null;
            if (notifySpy && "development" !== "production")
                spyReportStart(change);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "development" !== "production")
                spyReportEnd();
        }
        return this;
    };
    ObservableSet.prototype.delete = function (value) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                oldValue: value
            });
            if (!change)
                return false;
        }
        if (this.has(value)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: value
                }
                : null;
            if (notifySpy && "development" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name }));
            transaction(function () {
                _this._atom.reportChanged();
                _this._data.delete(value);
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "development" !== "production")
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableSet.prototype.has = function (value) {
        this._atom.reportObserved();
        return this._data.has(this.dehanceValue(value));
    };
    ObservableSet.prototype.entries = function () {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function () {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length
                    ? { value: [keys[index], values[index]], done: false }
                    : { done: true };
            }
        });
    };
    ObservableSet.prototype.keys = function () {
        return this.values();
    };
    ObservableSet.prototype.values = function () {
        this._atom.reportObserved();
        var self = this;
        var nextIndex = 0;
        var observableValues = Array.from(this._data.values());
        return makeIterable({
            next: function () {
                return nextIndex < observableValues.length
                    ? { value: self.dehanceValue(observableValues[nextIndex++]), done: false }
                    : { done: true };
            }
        });
    };
    ObservableSet.prototype.replace = function (other) {
        var _this = this;
        if (isObservableSet(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (Array.isArray(other)) {
                _this.clear();
                other.forEach(function (value) { return _this.add(value); });
            }
            else if (isES6Set(other)) {
                _this.clear();
                other.forEach(function (value) { return _this.add(value); });
            }
            else if (other !== null && other !== undefined) {
                fail("Cannot initialize set from " + other);
            }
        });
        return this;
    };
    ObservableSet.prototype.observe = function (listener, fireImmediately) {
        // TODO 'fireImmediately' can be true?
         true &&
            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with sets.");
        return registerListener(this, listener);
    };
    ObservableSet.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableSet.prototype.toJS = function () {
        return new Set(this);
    };
    ObservableSet.prototype.toString = function () {
        return this.name + "[ " + Array.from(this).join(", ") + " ]";
    };
    ObservableSet.prototype[(_a$1 = $mobx, Symbol.iterator)] = function () {
        return this.values();
    };
    return ObservableSet;
}());
var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, values, name, defaultEnhancer) {
        if (values === void 0) { values = new Map(); }
        this.target = target;
        this.values = values;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.keysAtom = new Atom(name + ".keys");
    }
    ObservableObjectAdministration.prototype.read = function (key) {
        return this.values.get(key).get();
    };
    ObservableObjectAdministration.prototype.write = function (key, newValue) {
        var instance = this.target;
        var observable = this.values.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "update",
                object: this.proxy || instance,
                name: key,
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this.proxy || instance,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy && "development" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "development" !== "production")
                spyReportEnd();
        }
    };
    ObservableObjectAdministration.prototype.has = function (key) {
        var map = this.pendingKeys || (this.pendingKeys = new Map());
        var entry = map.get(key);
        if (entry)
            return entry.get();
        else {
            var exists = !!this.values.get(key);
            // Possible optimization: Don't have a separate map for non existing keys,
            // but store them in the values map instead, using a special symbol to denote "not existing"
            entry = new ObservableValue(exists, referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
            map.set(key, entry);
            return entry.get(); // read to subscribe
        }
    };
    ObservableObjectAdministration.prototype.addObservableProp = function (propName, newValue, enhancer) {
        if (enhancer === void 0) { enhancer = this.defaultEnhancer; }
        var target = this.target;
        assertPropertyConfigurable(target, propName);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy || target,
                name: propName,
                type: "add",
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        var observable = new ObservableValue(newValue, enhancer, this.name + "." + stringifyKey(propName), false);
        this.values.set(propName, observable);
        newValue = observable.value; // observableValue might have changed it
        Object.defineProperty(target, propName, generateObservablePropConfig(propName));
        this.notifyPropertyAddition(propName, newValue);
    };
    ObservableObjectAdministration.prototype.addComputedProp = function (propertyOwner, // where is the property declared?
    propName, options) {
        var target = this.target;
        options.name = options.name || this.name + "." + stringifyKey(propName);
        this.values.set(propName, new ComputedValue(options));
        if (propertyOwner === target || isPropertyConfigurable(propertyOwner, propName))
            Object.defineProperty(propertyOwner, propName, generateComputedPropConfig(propName));
    };
    ObservableObjectAdministration.prototype.remove = function (key) {
        if (!this.values.has(key))
            return;
        var target = this.target;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy || target,
                name: key,
                type: "remove"
            });
            if (!change)
                return;
        }
        try {
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var oldObservable = this.values.get(key);
            var oldValue = oldObservable && oldObservable.get();
            oldObservable && oldObservable.set(undefined);
            // notify key and keyset listeners
            this.keysAtom.reportChanged();
            this.values.delete(key);
            if (this.pendingKeys) {
                var entry = this.pendingKeys.get(key);
                if (entry)
                    entry.set(false);
            }
            // delete the prop
            delete this.target[key];
            var change = notify || notifySpy
                ? {
                    type: "remove",
                    object: this.proxy || target,
                    oldValue: oldValue,
                    name: key
                }
                : null;
            if (notifySpy && "development" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "development" !== "production")
                spyReportEnd();
        }
        finally {
            endBatch();
        }
    };
    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */
        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
         true &&
            invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableObjectAdministration.prototype.notifyPropertyAddition = function (key, newValue) {
        var notify = hasListeners(this);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this.proxy || this.target,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy && "development" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "development" !== "production")
            spyReportEnd();
        if (this.pendingKeys) {
            var entry = this.pendingKeys.get(key);
            if (entry)
                entry.set(true);
        }
        this.keysAtom.reportChanged();
    };
    ObservableObjectAdministration.prototype.getKeys = function () {
        var e_1, _a;
        this.keysAtom.reportObserved();
        // return Reflect.ownKeys(this.values) as any
        var res = [];
        try {
            for (var _b = __values(this.values), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                if (value instanceof ObservableValue)
                    res.push(key);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return res;
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name, defaultEnhancer) {
    if (name === void 0) { name = ""; }
    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer; }
    if (Object.prototype.hasOwnProperty.call(target, $mobx))
        return target[$mobx];
     true &&
        invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, new Map(), stringifyKey(name), defaultEnhancer);
    addHiddenProp(target, $mobx, adm);
    return adm;
}
var observablePropertyConfigs = Object.create(null);
var computedPropertyConfigs = Object.create(null);
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this[$mobx].read(propName);
            },
            set: function (v) {
                this[$mobx].write(propName, v);
            }
        }));
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner[$mobx];
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance(owner);
        return owner[$mobx];
    }
    return adm;
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: globalState.computedConfigurable,
            enumerable: false,
            get: function () {
                return getAdministrationForComputedPropOwner(this).read(propName);
            },
            set: function (v) {
                getAdministrationForComputedPropOwner(this).write(propName, v);
            }
        }));
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        return isObservableObjectAdministration(thing[$mobx]);
    }
    return false;
}

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined)
                fail( true &&
                    "It is not possible to get index atoms from arrays");
            return thing[$mobx].atom;
        }
        if (isObservableSet(thing)) {
            return thing[$mobx];
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return anyThing._keysAtom;
            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable)
                fail( true &&
                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        if (property && !thing[$mobx])
            thing[property]; // See #1072
        if (isObservableObject(thing)) {
            if (!property)
                return fail( true && "please specify a property");
            var observable = thing[$mobx].values.get(property);
            if (!observable)
                fail( true &&
                    "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing[$mobx])) {
            // disposer function
            return thing[$mobx];
        }
    }
    return fail( true && "Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    if (!thing)
        fail("Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing) || isObservableSet(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance(thing);
    if (thing[$mobx])
        return thing[$mobx];
    fail( true && "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

var toString = Object.prototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) { depth = -1; }
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) {
                depth++;
            }
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    if (depth === 0) {
        return false;
    }
    else if (depth < 0) {
        depth = -1;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], depth - 1, aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key = void 0;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.slice();
    if (isES6Map(a) || isObservableMap(a))
        return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a))
        return Array.from(a.entries());
    return a;
}
function has$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}

/*
The only reason for this file to exist is pure horror:
Without it rollup can make the bundling fail at any point in time; when it rolls up the files in the wrong order
it will cause undefined errors (for example because super classes or local variables not being hoisted).
With this file that will still happen,
but at least in this file we can magically reorder the imports with trial and error until the build succeeds again.
*/

/**
 * (c) Michel Weststrate 2015 - 2018
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
if (typeof Proxy === "undefined" || typeof Symbol === "undefined") {
    throw new Error("[mobx] MobX 5+ requires Proxy and Symbol objects. If your environment doesn't support Symbol or Proxy objects, please downgrade to MobX 4. For React Native Android, consider upgrading JSCore.");
}
try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    "development";
}
catch (e) {
    var g = getGlobal();
    if (typeof process === "undefined")
        g.process = {};
    g.process.env = {};
}
(function () {
    function testCodeMinification() { }
    if (testCodeMinification.name !== "testCodeMinification" &&
        "development" !== "production" &&
        typeof process !== 'undefined' && process.env.IGNORE_MOBX_MINIFY_WARNING !== "true") {
        // trick so it doesn't get replaced
        var varName = ["process", "env", "NODE_ENV"].join(".");
        console.warn("[mobx] you are running a minified build, but '" + varName + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
    }
})();
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    // See: https://github.com/andykog/mobx-devtools/
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy,
        extras: {
            getDebugName: getDebugName
        },
        $mobx: $mobx
    });
}




/***/ }),

/***/ "../../node_modules/object-assign/index.js":
/*!*************************************************!*\
  !*** ../../node_modules/object-assign/index.js ***!
  \*************************************************/
/***/ ((module) => {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "../../node_modules/process/browser.js":
/*!*********************************************!*\
  !*** ../../node_modules/process/browser.js ***!
  \*********************************************/
/***/ ((module) => {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../../node_modules/react-dom/cjs/react-dom.development.js":
/*!*****************************************************************!*\
  !*** ../../node_modules/react-dom/cjs/react-dom.development.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @license React v17.0.2
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  (function() {
'use strict';

var React = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _assign = __webpack_require__(/*! object-assign */ "../../node_modules/object-assign/index.js");
var Scheduler = __webpack_require__(/*! scheduler */ "../../node_modules/scheduler/index.js");
var tracing = __webpack_require__(/*! scheduler/tracing */ "../../node_modules/scheduler/tracing.js");

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

// by calls to these methods by a Babel plugin.
//
// In PROD (or in packages without access to React internals),
// they are left as they are instead.

function warn(format) {
  {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    printWarning('warn', format, args);
  }
}
function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

if (!React) {
  {
    throw Error( "ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM." );
  }
}

var FunctionComponent = 0;
var ClassComponent = 1;
var IndeterminateComponent = 2; // Before we know whether it is function or class

var HostRoot = 3; // Root of a host tree. Could be nested inside another node.

var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.

var HostComponent = 5;
var HostText = 6;
var Fragment = 7;
var Mode = 8;
var ContextConsumer = 9;
var ContextProvider = 10;
var ForwardRef = 11;
var Profiler = 12;
var SuspenseComponent = 13;
var MemoComponent = 14;
var SimpleMemoComponent = 15;
var LazyComponent = 16;
var IncompleteClassComponent = 17;
var DehydratedFragment = 18;
var SuspenseListComponent = 19;
var FundamentalComponent = 20;
var ScopeComponent = 21;
var Block = 22;
var OffscreenComponent = 23;
var LegacyHiddenComponent = 24;

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableProfilerTimer = true; // Record durations for commit and passive effects phases.

var enableFundamentalAPI = false; // Experimental Scope support.
var enableNewReconciler = false; // Errors that are thrown while unmounting (or after in the case of passive effects)
var warnAboutStringRefs = false;

var allNativeEvents = new Set();
/**
 * Mapping from registration name to event name
 */


var registrationNameDependencies = {};
/**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */

var possibleRegistrationNames =  {} ; // Trust the developer to only use possibleRegistrationNames in true

function registerTwoPhaseEvent(registrationName, dependencies) {
  registerDirectEvent(registrationName, dependencies);
  registerDirectEvent(registrationName + 'Capture', dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
  {
    if (registrationNameDependencies[registrationName]) {
      error('EventRegistry: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName);
    }
  }

  registrationNameDependencies[registrationName] = dependencies;

  {
    var lowerCasedName = registrationName.toLowerCase();
    possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      possibleRegistrationNames.ondblclick = registrationName;
    }
  }

  for (var i = 0; i < dependencies.length; i++) {
    allNativeEvents.add(dependencies[i]);
  }
}

var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');

// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.

var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.

var BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.

var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.

var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.

var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.

var POSITIVE_NUMERIC = 6;

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
/* eslint-enable max-len */

var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
var hasOwnProperty = Object.prototype.hasOwnProperty;
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
  if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
    return true;
  }

  if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
    return false;
  }

  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }

  illegalAttributeNameCache[attributeName] = true;

  {
    error('Invalid attribute name: `%s`', attributeName);
  }

  return false;
}
function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
  if (propertyInfo !== null) {
    return propertyInfo.type === RESERVED;
  }

  if (isCustomComponentTag) {
    return false;
  }

  if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
    return true;
  }

  return false;
}
function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
  if (propertyInfo !== null && propertyInfo.type === RESERVED) {
    return false;
  }

  switch (typeof value) {
    case 'function': // $FlowIssue symbol is perfectly valid here

    case 'symbol':
      // eslint-disable-line
      return true;

    case 'boolean':
      {
        if (isCustomComponentTag) {
          return false;
        }

        if (propertyInfo !== null) {
          return !propertyInfo.acceptsBooleans;
        } else {
          var prefix = name.toLowerCase().slice(0, 5);
          return prefix !== 'data-' && prefix !== 'aria-';
        }
      }

    default:
      return false;
  }
}
function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
  if (value === null || typeof value === 'undefined') {
    return true;
  }

  if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
    return true;
  }

  if (isCustomComponentTag) {
    return false;
  }

  if (propertyInfo !== null) {

    switch (propertyInfo.type) {
      case BOOLEAN:
        return !value;

      case OVERLOADED_BOOLEAN:
        return value === false;

      case NUMERIC:
        return isNaN(value);

      case POSITIVE_NUMERIC:
        return isNaN(value) || value < 1;
    }
  }

  return false;
}
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}

function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.


var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
// elements (not just inputs). Now that ReactDOMInput assigns to the
// defaultValue property -- do we need this?
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.

[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var name = _ref[0],
      attributeName = _ref[1];
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).

['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.

['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML boolean attributes.

['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
// on the client side because the browsers are inconsistent. Instead we call focus().
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.

['checked', // Note: `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`. We have special logic for handling this.
'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.

['capture', 'download' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be positive numbers.

['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be numbers.

['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;

var capitalize = function (token) {
  return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.


['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // String SVG attributes with the xlink namespace.

['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
  false);
}); // String SVG attributes with the xml namespace.

['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
  false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.

['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.

var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
false);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  true, // sanitizeURL
  true);
});

// and any newline or tab are filtered out as if they're not part of the URL.
// https://url.spec.whatwg.org/#url-parsing
// Tab or newline are defined as \r\n\t:
// https://infra.spec.whatwg.org/#ascii-tab-or-newline
// A C0 control is a code point in the range \u0000 NULL to \u001F
// INFORMATION SEPARATOR ONE, inclusive:
// https://infra.spec.whatwg.org/#c0-control-or-space

/* eslint-disable max-len */

var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
var didWarn = false;

function sanitizeURL(url) {
  {
    if (!didWarn && isJavaScriptProtocol.test(url)) {
      didWarn = true;

      error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
    }
  }
}

/**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */
function getValueForProperty(node, name, expected, propertyInfo) {
  {
    if (propertyInfo.mustUseProperty) {
      var propertyName = propertyInfo.propertyName;
      return node[propertyName];
    } else {
      if ( propertyInfo.sanitizeURL) {
        // If we haven't fully disabled javascript: URLs, and if
        // the hydration is successful of a javascript: URL, we
        // still want to warn on the client.
        sanitizeURL('' + expected);
      }

      var attributeName = propertyInfo.attributeName;
      var stringValue = null;

      if (propertyInfo.type === OVERLOADED_BOOLEAN) {
        if (node.hasAttribute(attributeName)) {
          var value = node.getAttribute(attributeName);

          if (value === '') {
            return true;
          }

          if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
            return value;
          }

          if (value === '' + expected) {
            return expected;
          }

          return value;
        }
      } else if (node.hasAttribute(attributeName)) {
        if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
          // We had an attribute but shouldn't have had one, so read it
          // for the error message.
          return node.getAttribute(attributeName);
        }

        if (propertyInfo.type === BOOLEAN) {
          // If this was a boolean, it doesn't matter what the value is
          // the fact that we have it is the same as the expected.
          return expected;
        } // Even if this property uses a namespace we use getAttribute
        // because we assume its namespaced name is the same as our config.
        // To use getAttributeNS we need the local name which we don't have
        // in our config atm.


        stringValue = node.getAttribute(attributeName);
      }

      if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
        return stringValue === null ? expected : stringValue;
      } else if (stringValue === '' + expected) {
        return expected;
      } else {
        return stringValue;
      }
    }
  }
}
/**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */

function getValueForAttribute(node, name, expected) {
  {
    if (!isAttributeNameSafe(name)) {
      return;
    } // If the object is an opaque reference ID, it's expected that
    // the next prop is different than the server value, so just return
    // expected


    if (isOpaqueHydratingObject(expected)) {
      return expected;
    }

    if (!node.hasAttribute(name)) {
      return expected === undefined ? undefined : null;
    }

    var value = node.getAttribute(name);

    if (value === '' + expected) {
      return expected;
    }

    return value;
  }
}
/**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */

function setValueForProperty(node, name, value, isCustomComponentTag) {
  var propertyInfo = getPropertyInfo(name);

  if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
    return;
  }

  if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
    value = null;
  } // If the prop isn't in the special list, treat it as a simple attribute.


  if (isCustomComponentTag || propertyInfo === null) {
    if (isAttributeNameSafe(name)) {
      var _attributeName = name;

      if (value === null) {
        node.removeAttribute(_attributeName);
      } else {
        node.setAttribute(_attributeName,  '' + value);
      }
    }

    return;
  }

  var mustUseProperty = propertyInfo.mustUseProperty;

  if (mustUseProperty) {
    var propertyName = propertyInfo.propertyName;

    if (value === null) {
      var type = propertyInfo.type;
      node[propertyName] = type === BOOLEAN ? false : '';
    } else {
      // Contrary to `setAttribute`, object properties are properly
      // `toString`ed by IE8/9.
      node[propertyName] = value;
    }

    return;
  } // The rest are treated as attributes with special cases.


  var attributeName = propertyInfo.attributeName,
      attributeNamespace = propertyInfo.attributeNamespace;

  if (value === null) {
    node.removeAttribute(attributeName);
  } else {
    var _type = propertyInfo.type;
    var attributeValue;

    if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
      // If attribute type is boolean, we know for sure it won't be an execution sink
      // and we won't require Trusted Type here.
      attributeValue = '';
    } else {
      // `setAttribute` with objects becomes only `[object]` in IE8/9,
      // ('' + value) makes it output the correct toString()-value.
      {
        attributeValue = '' + value;
      }

      if (propertyInfo.sanitizeURL) {
        sanitizeURL(attributeValue.toString());
      }
    }

    if (attributeNamespace) {
      node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
    } else {
      node.setAttribute(attributeName, attributeValue);
    }
  }
}

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}

function describeClassComponentFrame(ctor, source, ownerFn) {
  {
    return describeNativeComponentFrame(ctor, true);
  }
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

function describeFiber(fiber) {
  var owner =  fiber._debugOwner ? fiber._debugOwner.type : null ;
  var source =  fiber._debugSource ;

  switch (fiber.tag) {
    case HostComponent:
      return describeBuiltInComponentFrame(fiber.type);

    case LazyComponent:
      return describeBuiltInComponentFrame('Lazy');

    case SuspenseComponent:
      return describeBuiltInComponentFrame('Suspense');

    case SuspenseListComponent:
      return describeBuiltInComponentFrame('SuspenseList');

    case FunctionComponent:
    case IndeterminateComponent:
    case SimpleMemoComponent:
      return describeFunctionComponentFrame(fiber.type);

    case ForwardRef:
      return describeFunctionComponentFrame(fiber.type.render);

    case Block:
      return describeFunctionComponentFrame(fiber.type._render);

    case ClassComponent:
      return describeClassComponentFrame(fiber.type);

    default:
      return '';
  }
}

function getStackByFiberInDevAndProd(workInProgress) {
  try {
    var info = '';
    var node = workInProgress;

    do {
      info += describeFiber(node);
      node = node.return;
    } while (node);

    return info;
  } catch (x) {
    return '\nError generating stack: ' + x.message + '\n' + x.stack;
  }
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case REACT_FRAGMENT_TYPE:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
var current = null;
var isRendering = false;
function getCurrentFiberOwnerNameInDevOrNull() {
  {
    if (current === null) {
      return null;
    }

    var owner = current._debugOwner;

    if (owner !== null && typeof owner !== 'undefined') {
      return getComponentName(owner.type);
    }
  }

  return null;
}

function getCurrentFiberStackInDev() {
  {
    if (current === null) {
      return '';
    } // Safe because if current fiber exists, we are reconciling,
    // and it is guaranteed to be the work-in-progress version.


    return getStackByFiberInDevAndProd(current);
  }
}

function resetCurrentFiber() {
  {
    ReactDebugCurrentFrame.getCurrentStack = null;
    current = null;
    isRendering = false;
  }
}
function setCurrentFiber(fiber) {
  {
    ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
    current = fiber;
    isRendering = false;
  }
}
function setIsRendering(rendering) {
  {
    isRendering = rendering;
  }
}
function getIsRendering() {
  {
    return isRendering;
  }
}

// Flow does not allow string concatenation of most non-string types. To work
// around this limitation, we use an opaque type that can only be obtained by
// passing the value through getToStringValue first.
function toString(value) {
  return '' + value;
}
function getToStringValue(value) {
  switch (typeof value) {
    case 'boolean':
    case 'number':
    case 'object':
    case 'string':
    case 'undefined':
      return value;

    default:
      // function, symbol are assigned as empty strings
      return '';
  }
}

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};
function checkControlledValueProps(tagName, props) {
  {
    if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
      error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
    }

    if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
      error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
    }
  }
}

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(node) {
  return node._valueTracker;
}

function detachTracker(node) {
  node._valueTracker = null;
}

function getValueFromNode(node) {
  var value = '';

  if (!node) {
    return value;
  }

  if (isCheckable(node)) {
    value = node.checked ? 'true' : 'false';
  } else {
    value = node.value;
  }

  return value;
}

function trackValueOnNode(node) {
  var valueField = isCheckable(node) ? 'checked' : 'value';
  var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
  var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
  // and don't track value will cause over reporting of changes,
  // but it's better then a hard failure
  // (needed for certain tests that spyOn input values and Safari)

  if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
    return;
  }

  var get = descriptor.get,
      set = descriptor.set;
  Object.defineProperty(node, valueField, {
    configurable: true,
    get: function () {
      return get.call(this);
    },
    set: function (value) {
      currentValue = '' + value;
      set.call(this, value);
    }
  }); // We could've passed this the first time
  // but it triggers a bug in IE11 and Edge 14/15.
  // Calling defineProperty() again should be equivalent.
  // https://github.com/facebook/react/issues/11768

  Object.defineProperty(node, valueField, {
    enumerable: descriptor.enumerable
  });
  var tracker = {
    getValue: function () {
      return currentValue;
    },
    setValue: function (value) {
      currentValue = '' + value;
    },
    stopTracking: function () {
      detachTracker(node);
      delete node[valueField];
    }
  };
  return tracker;
}

function track(node) {
  if (getTracker(node)) {
    return;
  } // TODO: Once it's just Fiber we can move this to node._wrapperState


  node._valueTracker = trackValueOnNode(node);
}
function updateValueIfChanged(node) {
  if (!node) {
    return false;
  }

  var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
  // that trying again will succeed

  if (!tracker) {
    return true;
  }

  var lastValue = tracker.getValue();
  var nextValue = getValueFromNode(node);

  if (nextValue !== lastValue) {
    tracker.setValue(nextValue);
    return true;
  }

  return false;
}

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}
/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */


function getHostProps(element, props) {
  var node = element;
  var checked = props.checked;

  var hostProps = _assign({}, props, {
    defaultChecked: undefined,
    defaultValue: undefined,
    value: undefined,
    checked: checked != null ? checked : node._wrapperState.initialChecked
  });

  return hostProps;
}
function initWrapperState(element, props) {
  {
    checkControlledValueProps('input', props);

    if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
      error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);

      didWarnCheckedDefaultChecked = true;
    }

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
      error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);

      didWarnValueDefaultValue = true;
    }
  }

  var node = element;
  var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
  node._wrapperState = {
    initialChecked: props.checked != null ? props.checked : props.defaultChecked,
    initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
    controlled: isControlled(props)
  };
}
function updateChecked(element, props) {
  var node = element;
  var checked = props.checked;

  if (checked != null) {
    setValueForProperty(node, 'checked', checked, false);
  }
}
function updateWrapper(element, props) {
  var node = element;

  {
    var controlled = isControlled(props);

    if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
      error('A component is changing an uncontrolled input to be controlled. ' + 'This is likely caused by the value changing from undefined to ' + 'a defined value, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');

      didWarnUncontrolledToControlled = true;
    }

    if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
      error('A component is changing a controlled input to be uncontrolled. ' + 'This is likely caused by the value changing from a defined to ' + 'undefined, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');

      didWarnControlledToUncontrolled = true;
    }
  }

  updateChecked(element, props);
  var value = getToStringValue(props.value);
  var type = props.type;

  if (value != null) {
    if (type === 'number') {
      if (value === 0 && node.value === '' || // We explicitly want to coerce to number here if possible.
      // eslint-disable-next-line
      node.value != value) {
        node.value = toString(value);
      }
    } else if (node.value !== toString(value)) {
      node.value = toString(value);
    }
  } else if (type === 'submit' || type === 'reset') {
    // Submit/reset inputs need the attribute removed completely to avoid
    // blank-text buttons.
    node.removeAttribute('value');
    return;
  }

  {
    // When syncing the value attribute, the value comes from a cascade of
    // properties:
    //  1. The value React property
    //  2. The defaultValue React property
    //  3. Otherwise there should be no change
    if (props.hasOwnProperty('value')) {
      setDefaultValue(node, props.type, value);
    } else if (props.hasOwnProperty('defaultValue')) {
      setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
    }
  }

  {
    // When syncing the checked attribute, it only changes when it needs
    // to be removed, such as transitioning from a checkbox into a text input
    if (props.checked == null && props.defaultChecked != null) {
      node.defaultChecked = !!props.defaultChecked;
    }
  }
}
function postMountWrapper(element, props, isHydrating) {
  var node = element; // Do not assign value if it is already set. This prevents user text input
  // from being lost during SSR hydration.

  if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
    var type = props.type;
    var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
    // default value provided by the browser. See: #12872

    if (isButton && (props.value === undefined || props.value === null)) {
      return;
    }

    var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
    // from being lost during SSR hydration.

    if (!isHydrating) {
      {
        // When syncing the value attribute, the value property should use
        // the wrapperState._initialValue property. This uses:
        //
        //   1. The value React property when present
        //   2. The defaultValue React property when present
        //   3. An empty string
        if (initialValue !== node.value) {
          node.value = initialValue;
        }
      }
    }

    {
      // Otherwise, the value attribute is synchronized to the property,
      // so we assign defaultValue to the same thing as the value property
      // assignment step above.
      node.defaultValue = initialValue;
    }
  } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
  // this is needed to work around a chrome bug where setting defaultChecked
  // will sometimes influence the value of checked (even after detachment).
  // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
  // We need to temporarily unset name to avoid disrupting radio button groups.


  var name = node.name;

  if (name !== '') {
    node.name = '';
  }

  {
    // When syncing the checked attribute, both the checked property and
    // attribute are assigned at the same time using defaultChecked. This uses:
    //
    //   1. The checked React property when present
    //   2. The defaultChecked React property when present
    //   3. Otherwise, false
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !!node._wrapperState.initialChecked;
  }

  if (name !== '') {
    node.name = name;
  }
}
function restoreControlledState(element, props) {
  var node = element;
  updateWrapper(node, props);
  updateNamedCousins(node, props);
}

function updateNamedCousins(rootNode, props) {
  var name = props.name;

  if (props.type === 'radio' && name != null) {
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    } // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form. It might not even be in the
    // document. Let's just use the local `querySelectorAll` to ensure we don't
    // miss anything.


    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];

      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      } // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.


      var otherProps = getFiberCurrentPropsFromNode(otherNode);

      if (!otherProps) {
        {
          throw Error( "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported." );
        }
      } // We need update the tracked value on the named cousin since the value
      // was changed but the input saw no event or value set


      updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.

      updateWrapper(otherNode, otherProps);
    }
  }
} // In Chrome, assigning defaultValue to certain input types triggers input validation.
// For number inputs, the display value loses trailing decimal points. For email inputs,
// Chrome raises "The specified value <x> is not a valid email address".
//
// Here we check to see if the defaultValue has actually changed, avoiding these problems
// when the user is inputting text
//
// https://github.com/facebook/react/issues/7253


function setDefaultValue(node, type, value) {
  if ( // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
  type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
    if (value == null) {
      node.defaultValue = toString(node._wrapperState.initialValue);
    } else if (node.defaultValue !== toString(value)) {
      node.defaultValue = toString(value);
    }
  }
}

var didWarnSelectedSetOnOption = false;
var didWarnInvalidChild = false;

function flattenChildren(children) {
  var content = ''; // Flatten children. We'll warn if they are invalid
  // during validateProps() which runs for hydration too.
  // Note that this would throw on non-element objects.
  // Elements are stringified (which is normally irrelevant
  // but matters for <fbt>).

  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }

    content += child; // Note: we don't warn about invalid children here.
    // Instead, this is done separately below so that
    // it happens during the hydration code path too.
  });
  return content;
}
/**
 * Implements an <option> host component that warns when `selected` is set.
 */


function validateProps(element, props) {
  {
    // This mirrors the code path above, but runs for hydration too.
    // Warn about invalid children here so that client and hydration are consistent.
    // TODO: this seems like it could cause a DEV-only throw for hydration
    // if children contains a non-element object. We should try to avoid that.
    if (typeof props.children === 'object' && props.children !== null) {
      React.Children.forEach(props.children, function (child) {
        if (child == null) {
          return;
        }

        if (typeof child === 'string' || typeof child === 'number') {
          return;
        }

        if (typeof child.type !== 'string') {
          return;
        }

        if (!didWarnInvalidChild) {
          didWarnInvalidChild = true;

          error('Only strings and numbers are supported as <option> children.');
        }
      });
    } // TODO: Remove support for `selected` in <option>.


    if (props.selected != null && !didWarnSelectedSetOnOption) {
      error('Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');

      didWarnSelectedSetOnOption = true;
    }
  }
}
function postMountWrapper$1(element, props) {
  // value="" should make a value attribute (#6219)
  if (props.value != null) {
    element.setAttribute('value', toString(getToStringValue(props.value)));
  }
}
function getHostProps$1(element, props) {
  var hostProps = _assign({
    children: undefined
  }, props);

  var content = flattenChildren(props.children);

  if (content) {
    hostProps.children = content;
  }

  return hostProps;
}

var didWarnValueDefaultValue$1;

{
  didWarnValueDefaultValue$1 = false;
}

function getDeclarationErrorAddendum() {
  var ownerName = getCurrentFiberOwnerNameInDevOrNull();

  if (ownerName) {
    return '\n\nCheck the render method of `' + ownerName + '`.';
  }

  return '';
}

var valuePropNames = ['value', 'defaultValue'];
/**
 * Validation function for `value` and `defaultValue`.
 */

function checkSelectPropTypes(props) {
  {
    checkControlledValueProps('select', props);

    for (var i = 0; i < valuePropNames.length; i++) {
      var propName = valuePropNames[i];

      if (props[propName] == null) {
        continue;
      }

      var isArray = Array.isArray(props[propName]);

      if (props.multiple && !isArray) {
        error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum());
      } else if (!props.multiple && isArray) {
        error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum());
      }
    }
  }
}

function updateOptions(node, multiple, propValue, setDefaultSelected) {
  var options = node.options;

  if (multiple) {
    var selectedValues = propValue;
    var selectedValue = {};

    for (var i = 0; i < selectedValues.length; i++) {
      // Prefix to avoid chaos with special keys.
      selectedValue['$' + selectedValues[i]] = true;
    }

    for (var _i = 0; _i < options.length; _i++) {
      var selected = selectedValue.hasOwnProperty('$' + options[_i].value);

      if (options[_i].selected !== selected) {
        options[_i].selected = selected;
      }

      if (selected && setDefaultSelected) {
        options[_i].defaultSelected = true;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    var _selectedValue = toString(getToStringValue(propValue));

    var defaultSelected = null;

    for (var _i2 = 0; _i2 < options.length; _i2++) {
      if (options[_i2].value === _selectedValue) {
        options[_i2].selected = true;

        if (setDefaultSelected) {
          options[_i2].defaultSelected = true;
        }

        return;
      }

      if (defaultSelected === null && !options[_i2].disabled) {
        defaultSelected = options[_i2];
      }
    }

    if (defaultSelected !== null) {
      defaultSelected.selected = true;
    }
  }
}
/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */


function getHostProps$2(element, props) {
  return _assign({}, props, {
    value: undefined
  });
}
function initWrapperState$1(element, props) {
  var node = element;

  {
    checkSelectPropTypes(props);
  }

  node._wrapperState = {
    wasMultiple: !!props.multiple
  };

  {
    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
      error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');

      didWarnValueDefaultValue$1 = true;
    }
  }
}
function postMountWrapper$2(element, props) {
  var node = element;
  node.multiple = !!props.multiple;
  var value = props.value;

  if (value != null) {
    updateOptions(node, !!props.multiple, value, false);
  } else if (props.defaultValue != null) {
    updateOptions(node, !!props.multiple, props.defaultValue, true);
  }
}
function postUpdateWrapper(element, props) {
  var node = element;
  var wasMultiple = node._wrapperState.wasMultiple;
  node._wrapperState.wasMultiple = !!props.multiple;
  var value = props.value;

  if (value != null) {
    updateOptions(node, !!props.multiple, value, false);
  } else if (wasMultiple !== !!props.multiple) {
    // For simplicity, reapply `defaultValue` if `multiple` is toggled.
    if (props.defaultValue != null) {
      updateOptions(node, !!props.multiple, props.defaultValue, true);
    } else {
      // Revert the select back to its default unselected state.
      updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
    }
  }
}
function restoreControlledState$1(element, props) {
  var node = element;
  var value = props.value;

  if (value != null) {
    updateOptions(node, !!props.multiple, value, false);
  }
}

var didWarnValDefaultVal = false;

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
function getHostProps$3(element, props) {
  var node = element;

  if (!(props.dangerouslySetInnerHTML == null)) {
    {
      throw Error( "`dangerouslySetInnerHTML` does not make sense on <textarea>." );
    }
  } // Always set children to the same thing. In IE9, the selection range will
  // get reset if `textContent` is mutated.  We could add a check in setTextContent
  // to only set the value if/when the value differs from the node value (which would
  // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
  // solution. The value can be a boolean or object so that's why it's forced
  // to be a string.


  var hostProps = _assign({}, props, {
    value: undefined,
    defaultValue: undefined,
    children: toString(node._wrapperState.initialValue)
  });

  return hostProps;
}
function initWrapperState$2(element, props) {
  var node = element;

  {
    checkControlledValueProps('textarea', props);

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
      error('%s contains a textarea with both value and defaultValue props. ' + 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component');

      didWarnValDefaultVal = true;
    }
  }

  var initialValue = props.value; // Only bother fetching default value if we're going to use it

  if (initialValue == null) {
    var children = props.children,
        defaultValue = props.defaultValue;

    if (children != null) {
      {
        error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
      }

      {
        if (!(defaultValue == null)) {
          {
            throw Error( "If you supply `defaultValue` on a <textarea>, do not pass children." );
          }
        }

        if (Array.isArray(children)) {
          if (!(children.length <= 1)) {
            {
              throw Error( "<textarea> can only have at most one child." );
            }
          }

          children = children[0];
        }

        defaultValue = children;
      }
    }

    if (defaultValue == null) {
      defaultValue = '';
    }

    initialValue = defaultValue;
  }

  node._wrapperState = {
    initialValue: getToStringValue(initialValue)
  };
}
function updateWrapper$1(element, props) {
  var node = element;
  var value = getToStringValue(props.value);
  var defaultValue = getToStringValue(props.defaultValue);

  if (value != null) {
    // Cast `value` to a string to ensure the value is set correctly. While
    // browsers typically do this as necessary, jsdom doesn't.
    var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed

    if (newValue !== node.value) {
      node.value = newValue;
    }

    if (props.defaultValue == null && node.defaultValue !== newValue) {
      node.defaultValue = newValue;
    }
  }

  if (defaultValue != null) {
    node.defaultValue = toString(defaultValue);
  }
}
function postMountWrapper$3(element, props) {
  var node = element; // This is in postMount because we need access to the DOM node, which is not
  // available until after the component has mounted.

  var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
  // initial value. In IE10/IE11 there is a bug where the placeholder attribute
  // will populate textContent as well.
  // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/

  if (textContent === node._wrapperState.initialValue) {
    if (textContent !== '' && textContent !== null) {
      node.value = textContent;
    }
  }
}
function restoreControlledState$2(element, props) {
  // DOM component is still mounted; update
  updateWrapper$1(element, props);
}

var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
var Namespaces = {
  html: HTML_NAMESPACE,
  mathml: MATH_NAMESPACE,
  svg: SVG_NAMESPACE
}; // Assumes there is no parent namespace.

function getIntrinsicNamespace(type) {
  switch (type) {
    case 'svg':
      return SVG_NAMESPACE;

    case 'math':
      return MATH_NAMESPACE;

    default:
      return HTML_NAMESPACE;
  }
}
function getChildNamespace(parentNamespace, type) {
  if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
    // No (or default) parent namespace: potential entry point.
    return getIntrinsicNamespace(type);
  }

  if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
    // We're leaving SVG.
    return HTML_NAMESPACE;
  } // By default, pass namespace below.


  return parentNamespace;
}

/* globals MSApp */

/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */
var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

var reusableSVGContainer;
/**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */

var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  if (node.namespaceURI === Namespaces.svg) {

    if (!('innerHTML' in node)) {
      // IE does not have innerHTML for SVG nodes, so instead we inject the
      // new markup in a temp node and then move the child nodes across into
      // the target node
      reusableSVGContainer = reusableSVGContainer || document.createElement('div');
      reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
      var svgNode = reusableSVGContainer.firstChild;

      while (node.firstChild) {
        node.removeChild(node.firstChild);
      }

      while (svgNode.firstChild) {
        node.appendChild(svgNode.firstChild);
      }

      return;
    }
  }

  node.innerHTML = html;
});

/**
 * HTML nodeType values that represent the type of the node
 */
var ELEMENT_NODE = 1;
var TEXT_NODE = 3;
var COMMENT_NODE = 8;
var DOCUMENT_NODE = 9;
var DOCUMENT_FRAGMENT_NODE = 11;

/**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */

var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
      firstChild.nodeValue = text;
      return;
    }
  }

  node.textContent = text;
};

// List derived from Gecko source code:
// https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
var shorthandToLonghand = {
  animation: ['animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction'],
  background: ['backgroundAttachment', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundSize'],
  backgroundPosition: ['backgroundPositionX', 'backgroundPositionY'],
  border: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderTopColor', 'borderTopStyle', 'borderTopWidth'],
  borderBlockEnd: ['borderBlockEndColor', 'borderBlockEndStyle', 'borderBlockEndWidth'],
  borderBlockStart: ['borderBlockStartColor', 'borderBlockStartStyle', 'borderBlockStartWidth'],
  borderBottom: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth'],
  borderColor: ['borderBottomColor', 'borderLeftColor', 'borderRightColor', 'borderTopColor'],
  borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
  borderInlineEnd: ['borderInlineEndColor', 'borderInlineEndStyle', 'borderInlineEndWidth'],
  borderInlineStart: ['borderInlineStartColor', 'borderInlineStartStyle', 'borderInlineStartWidth'],
  borderLeft: ['borderLeftColor', 'borderLeftStyle', 'borderLeftWidth'],
  borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
  borderRight: ['borderRightColor', 'borderRightStyle', 'borderRightWidth'],
  borderStyle: ['borderBottomStyle', 'borderLeftStyle', 'borderRightStyle', 'borderTopStyle'],
  borderTop: ['borderTopColor', 'borderTopStyle', 'borderTopWidth'],
  borderWidth: ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth'],
  columnRule: ['columnRuleColor', 'columnRuleStyle', 'columnRuleWidth'],
  columns: ['columnCount', 'columnWidth'],
  flex: ['flexBasis', 'flexGrow', 'flexShrink'],
  flexFlow: ['flexDirection', 'flexWrap'],
  font: ['fontFamily', 'fontFeatureSettings', 'fontKerning', 'fontLanguageOverride', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition', 'fontWeight', 'lineHeight'],
  fontVariant: ['fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition'],
  gap: ['columnGap', 'rowGap'],
  grid: ['gridAutoColumns', 'gridAutoFlow', 'gridAutoRows', 'gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
  gridArea: ['gridColumnEnd', 'gridColumnStart', 'gridRowEnd', 'gridRowStart'],
  gridColumn: ['gridColumnEnd', 'gridColumnStart'],
  gridColumnGap: ['columnGap'],
  gridGap: ['columnGap', 'rowGap'],
  gridRow: ['gridRowEnd', 'gridRowStart'],
  gridRowGap: ['rowGap'],
  gridTemplate: ['gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
  listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
  margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
  marker: ['markerEnd', 'markerMid', 'markerStart'],
  mask: ['maskClip', 'maskComposite', 'maskImage', 'maskMode', 'maskOrigin', 'maskPositionX', 'maskPositionY', 'maskRepeat', 'maskSize'],
  maskPosition: ['maskPositionX', 'maskPositionY'],
  outline: ['outlineColor', 'outlineStyle', 'outlineWidth'],
  overflow: ['overflowX', 'overflowY'],
  padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
  placeContent: ['alignContent', 'justifyContent'],
  placeItems: ['alignItems', 'justifyItems'],
  placeSelf: ['alignSelf', 'justifySelf'],
  textDecoration: ['textDecorationColor', 'textDecorationLine', 'textDecorationStyle'],
  textEmphasis: ['textEmphasisColor', 'textEmphasisStyle'],
  transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction'],
  wordWrap: ['overflowWrap']
};

/**
 * CSS properties which accept numbers but are not in units of "px".
 */
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */

function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */


var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.

Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */

function dangerousStyleValue(name, value, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901
  var isEmpty = value == null || typeof value === 'boolean' || value === '';

  if (isEmpty) {
    return '';
  }

  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return ('' + value).trim();
}

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */

function hyphenateStyleName(name) {
  return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

var warnValidStyle = function () {};

{
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
  var msPattern$1 = /^-ms-/;
  var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon

  var badStyleValueWithSemicolonPattern = /;\s*$/;
  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;
  var warnedForInfinityValue = false;

  var camelize = function (string) {
    return string.replace(hyphenPattern, function (_, character) {
      return character.toUpperCase();
    });
  };

  var warnHyphenatedStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;

    error('Unsupported style property %s. Did you mean %s?', name, // As Andi Smith suggests
    // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
    // is converted to lowercase `ms`.
    camelize(name.replace(msPattern$1, 'ms-')));
  };

  var warnBadVendoredStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;

    error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
  };

  var warnStyleValueWithSemicolon = function (name, value) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;

    error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
  };

  var warnStyleValueIsNaN = function (name, value) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;

    error('`NaN` is an invalid value for the `%s` css style property.', name);
  };

  var warnStyleValueIsInfinity = function (name, value) {
    if (warnedForInfinityValue) {
      return;
    }

    warnedForInfinityValue = true;

    error('`Infinity` is an invalid value for the `%s` css style property.', name);
  };

  warnValidStyle = function (name, value) {
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value);
    }

    if (typeof value === 'number') {
      if (isNaN(value)) {
        warnStyleValueIsNaN(name, value);
      } else if (!isFinite(value)) {
        warnStyleValueIsInfinity(name, value);
      }
    }
  };
}

var warnValidStyle$1 = warnValidStyle;

/**
 * Operations for dealing with CSS properties.
 */

/**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */

function createDangerousStringForStyles(styles) {
  {
    var serialized = '';
    var delimiter = '';

    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }

      var styleValue = styles[styleName];

      if (styleValue != null) {
        var isCustomProperty = styleName.indexOf('--') === 0;
        serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
        delimiter = ';';
      }
    }

    return serialized || null;
  }
}
/**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */

function setValueForStyles(node, styles) {
  var style = node.style;

  for (var styleName in styles) {
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }

    var isCustomProperty = styleName.indexOf('--') === 0;

    {
      if (!isCustomProperty) {
        warnValidStyle$1(styleName, styles[styleName]);
      }
    }

    var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);

    if (styleName === 'float') {
      styleName = 'cssFloat';
    }

    if (isCustomProperty) {
      style.setProperty(styleName, styleValue);
    } else {
      style[styleName] = styleValue;
    }
  }
}

function isValueEmpty(value) {
  return value == null || typeof value === 'boolean' || value === '';
}
/**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */


function expandShorthandMap(styles) {
  var expanded = {};

  for (var key in styles) {
    var longhands = shorthandToLonghand[key] || [key];

    for (var i = 0; i < longhands.length; i++) {
      expanded[longhands[i]] = key;
    }
  }

  return expanded;
}
/**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */


function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
  {
    if (!nextStyles) {
      return;
    }

    var expandedUpdates = expandShorthandMap(styleUpdates);
    var expandedStyles = expandShorthandMap(nextStyles);
    var warnedAbout = {};

    for (var key in expandedUpdates) {
      var originalKey = expandedUpdates[key];
      var correctOriginalKey = expandedStyles[key];

      if (correctOriginalKey && originalKey !== correctOriginalKey) {
        var warningKey = originalKey + ',' + correctOriginalKey;

        if (warnedAbout[warningKey]) {
          continue;
        }

        warnedAbout[warningKey] = true;

        error('%s a style property during rerender (%s) when a ' + 'conflicting property is set (%s) can lead to styling bugs. To ' + "avoid this, don't mix shorthand and non-shorthand properties " + 'for the same value; instead, replace the shorthand with ' + 'separate values.', isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
      }
    }
  }
}

// For HTML, certain tags should omit their close tag. We keep a list for
// those special-case tags.
var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.

};

// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

var HTML = '__html';

function assertValidProps(tag, props) {
  if (!props) {
    return;
  } // Note the use of `==` which checks for null or undefined.


  if (voidElementTags[tag]) {
    if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
      {
        throw Error( tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." );
      }
    }
  }

  if (props.dangerouslySetInnerHTML != null) {
    if (!(props.children == null)) {
      {
        throw Error( "Can only set one of `children` or `props.dangerouslySetInnerHTML`." );
      }
    }

    if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) {
      {
        throw Error( "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information." );
      }
    }
  }

  {
    if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
      error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
    }
  }

  if (!(props.style == null || typeof props.style === 'object')) {
    {
      throw Error( "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." );
    }
  }
}

function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this list too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;

    default:
      return true;
  }
}

// When adding attributes to the HTML or SVG allowed attribute list, be sure to
// also add them to this module to ensure casing and incorrect name
// warnings.
var possibleStandardNames = {
  // HTML
  accept: 'accept',
  acceptcharset: 'acceptCharset',
  'accept-charset': 'acceptCharset',
  accesskey: 'accessKey',
  action: 'action',
  allowfullscreen: 'allowFullScreen',
  alt: 'alt',
  as: 'as',
  async: 'async',
  autocapitalize: 'autoCapitalize',
  autocomplete: 'autoComplete',
  autocorrect: 'autoCorrect',
  autofocus: 'autoFocus',
  autoplay: 'autoPlay',
  autosave: 'autoSave',
  capture: 'capture',
  cellpadding: 'cellPadding',
  cellspacing: 'cellSpacing',
  challenge: 'challenge',
  charset: 'charSet',
  checked: 'checked',
  children: 'children',
  cite: 'cite',
  class: 'className',
  classid: 'classID',
  classname: 'className',
  cols: 'cols',
  colspan: 'colSpan',
  content: 'content',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  controls: 'controls',
  controlslist: 'controlsList',
  coords: 'coords',
  crossorigin: 'crossOrigin',
  dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
  data: 'data',
  datetime: 'dateTime',
  default: 'default',
  defaultchecked: 'defaultChecked',
  defaultvalue: 'defaultValue',
  defer: 'defer',
  dir: 'dir',
  disabled: 'disabled',
  disablepictureinpicture: 'disablePictureInPicture',
  disableremoteplayback: 'disableRemotePlayback',
  download: 'download',
  draggable: 'draggable',
  enctype: 'encType',
  enterkeyhint: 'enterKeyHint',
  for: 'htmlFor',
  form: 'form',
  formmethod: 'formMethod',
  formaction: 'formAction',
  formenctype: 'formEncType',
  formnovalidate: 'formNoValidate',
  formtarget: 'formTarget',
  frameborder: 'frameBorder',
  headers: 'headers',
  height: 'height',
  hidden: 'hidden',
  high: 'high',
  href: 'href',
  hreflang: 'hrefLang',
  htmlfor: 'htmlFor',
  httpequiv: 'httpEquiv',
  'http-equiv': 'httpEquiv',
  icon: 'icon',
  id: 'id',
  innerhtml: 'innerHTML',
  inputmode: 'inputMode',
  integrity: 'integrity',
  is: 'is',
  itemid: 'itemID',
  itemprop: 'itemProp',
  itemref: 'itemRef',
  itemscope: 'itemScope',
  itemtype: 'itemType',
  keyparams: 'keyParams',
  keytype: 'keyType',
  kind: 'kind',
  label: 'label',
  lang: 'lang',
  list: 'list',
  loop: 'loop',
  low: 'low',
  manifest: 'manifest',
  marginwidth: 'marginWidth',
  marginheight: 'marginHeight',
  max: 'max',
  maxlength: 'maxLength',
  media: 'media',
  mediagroup: 'mediaGroup',
  method: 'method',
  min: 'min',
  minlength: 'minLength',
  multiple: 'multiple',
  muted: 'muted',
  name: 'name',
  nomodule: 'noModule',
  nonce: 'nonce',
  novalidate: 'noValidate',
  open: 'open',
  optimum: 'optimum',
  pattern: 'pattern',
  placeholder: 'placeholder',
  playsinline: 'playsInline',
  poster: 'poster',
  preload: 'preload',
  profile: 'profile',
  radiogroup: 'radioGroup',
  readonly: 'readOnly',
  referrerpolicy: 'referrerPolicy',
  rel: 'rel',
  required: 'required',
  reversed: 'reversed',
  role: 'role',
  rows: 'rows',
  rowspan: 'rowSpan',
  sandbox: 'sandbox',
  scope: 'scope',
  scoped: 'scoped',
  scrolling: 'scrolling',
  seamless: 'seamless',
  selected: 'selected',
  shape: 'shape',
  size: 'size',
  sizes: 'sizes',
  span: 'span',
  spellcheck: 'spellCheck',
  src: 'src',
  srcdoc: 'srcDoc',
  srclang: 'srcLang',
  srcset: 'srcSet',
  start: 'start',
  step: 'step',
  style: 'style',
  summary: 'summary',
  tabindex: 'tabIndex',
  target: 'target',
  title: 'title',
  type: 'type',
  usemap: 'useMap',
  value: 'value',
  width: 'width',
  wmode: 'wmode',
  wrap: 'wrap',
  // SVG
  about: 'about',
  accentheight: 'accentHeight',
  'accent-height': 'accentHeight',
  accumulate: 'accumulate',
  additive: 'additive',
  alignmentbaseline: 'alignmentBaseline',
  'alignment-baseline': 'alignmentBaseline',
  allowreorder: 'allowReorder',
  alphabetic: 'alphabetic',
  amplitude: 'amplitude',
  arabicform: 'arabicForm',
  'arabic-form': 'arabicForm',
  ascent: 'ascent',
  attributename: 'attributeName',
  attributetype: 'attributeType',
  autoreverse: 'autoReverse',
  azimuth: 'azimuth',
  basefrequency: 'baseFrequency',
  baselineshift: 'baselineShift',
  'baseline-shift': 'baselineShift',
  baseprofile: 'baseProfile',
  bbox: 'bbox',
  begin: 'begin',
  bias: 'bias',
  by: 'by',
  calcmode: 'calcMode',
  capheight: 'capHeight',
  'cap-height': 'capHeight',
  clip: 'clip',
  clippath: 'clipPath',
  'clip-path': 'clipPath',
  clippathunits: 'clipPathUnits',
  cliprule: 'clipRule',
  'clip-rule': 'clipRule',
  color: 'color',
  colorinterpolation: 'colorInterpolation',
  'color-interpolation': 'colorInterpolation',
  colorinterpolationfilters: 'colorInterpolationFilters',
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorprofile: 'colorProfile',
  'color-profile': 'colorProfile',
  colorrendering: 'colorRendering',
  'color-rendering': 'colorRendering',
  contentscripttype: 'contentScriptType',
  contentstyletype: 'contentStyleType',
  cursor: 'cursor',
  cx: 'cx',
  cy: 'cy',
  d: 'd',
  datatype: 'datatype',
  decelerate: 'decelerate',
  descent: 'descent',
  diffuseconstant: 'diffuseConstant',
  direction: 'direction',
  display: 'display',
  divisor: 'divisor',
  dominantbaseline: 'dominantBaseline',
  'dominant-baseline': 'dominantBaseline',
  dur: 'dur',
  dx: 'dx',
  dy: 'dy',
  edgemode: 'edgeMode',
  elevation: 'elevation',
  enablebackground: 'enableBackground',
  'enable-background': 'enableBackground',
  end: 'end',
  exponent: 'exponent',
  externalresourcesrequired: 'externalResourcesRequired',
  fill: 'fill',
  fillopacity: 'fillOpacity',
  'fill-opacity': 'fillOpacity',
  fillrule: 'fillRule',
  'fill-rule': 'fillRule',
  filter: 'filter',
  filterres: 'filterRes',
  filterunits: 'filterUnits',
  floodopacity: 'floodOpacity',
  'flood-opacity': 'floodOpacity',
  floodcolor: 'floodColor',
  'flood-color': 'floodColor',
  focusable: 'focusable',
  fontfamily: 'fontFamily',
  'font-family': 'fontFamily',
  fontsize: 'fontSize',
  'font-size': 'fontSize',
  fontsizeadjust: 'fontSizeAdjust',
  'font-size-adjust': 'fontSizeAdjust',
  fontstretch: 'fontStretch',
  'font-stretch': 'fontStretch',
  fontstyle: 'fontStyle',
  'font-style': 'fontStyle',
  fontvariant: 'fontVariant',
  'font-variant': 'fontVariant',
  fontweight: 'fontWeight',
  'font-weight': 'fontWeight',
  format: 'format',
  from: 'from',
  fx: 'fx',
  fy: 'fy',
  g1: 'g1',
  g2: 'g2',
  glyphname: 'glyphName',
  'glyph-name': 'glyphName',
  glyphorientationhorizontal: 'glyphOrientationHorizontal',
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphorientationvertical: 'glyphOrientationVertical',
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphref: 'glyphRef',
  gradienttransform: 'gradientTransform',
  gradientunits: 'gradientUnits',
  hanging: 'hanging',
  horizadvx: 'horizAdvX',
  'horiz-adv-x': 'horizAdvX',
  horizoriginx: 'horizOriginX',
  'horiz-origin-x': 'horizOriginX',
  ideographic: 'ideographic',
  imagerendering: 'imageRendering',
  'image-rendering': 'imageRendering',
  in2: 'in2',
  in: 'in',
  inlist: 'inlist',
  intercept: 'intercept',
  k1: 'k1',
  k2: 'k2',
  k3: 'k3',
  k4: 'k4',
  k: 'k',
  kernelmatrix: 'kernelMatrix',
  kernelunitlength: 'kernelUnitLength',
  kerning: 'kerning',
  keypoints: 'keyPoints',
  keysplines: 'keySplines',
  keytimes: 'keyTimes',
  lengthadjust: 'lengthAdjust',
  letterspacing: 'letterSpacing',
  'letter-spacing': 'letterSpacing',
  lightingcolor: 'lightingColor',
  'lighting-color': 'lightingColor',
  limitingconeangle: 'limitingConeAngle',
  local: 'local',
  markerend: 'markerEnd',
  'marker-end': 'markerEnd',
  markerheight: 'markerHeight',
  markermid: 'markerMid',
  'marker-mid': 'markerMid',
  markerstart: 'markerStart',
  'marker-start': 'markerStart',
  markerunits: 'markerUnits',
  markerwidth: 'markerWidth',
  mask: 'mask',
  maskcontentunits: 'maskContentUnits',
  maskunits: 'maskUnits',
  mathematical: 'mathematical',
  mode: 'mode',
  numoctaves: 'numOctaves',
  offset: 'offset',
  opacity: 'opacity',
  operator: 'operator',
  order: 'order',
  orient: 'orient',
  orientation: 'orientation',
  origin: 'origin',
  overflow: 'overflow',
  overlineposition: 'overlinePosition',
  'overline-position': 'overlinePosition',
  overlinethickness: 'overlineThickness',
  'overline-thickness': 'overlineThickness',
  paintorder: 'paintOrder',
  'paint-order': 'paintOrder',
  panose1: 'panose1',
  'panose-1': 'panose1',
  pathlength: 'pathLength',
  patterncontentunits: 'patternContentUnits',
  patterntransform: 'patternTransform',
  patternunits: 'patternUnits',
  pointerevents: 'pointerEvents',
  'pointer-events': 'pointerEvents',
  points: 'points',
  pointsatx: 'pointsAtX',
  pointsaty: 'pointsAtY',
  pointsatz: 'pointsAtZ',
  prefix: 'prefix',
  preservealpha: 'preserveAlpha',
  preserveaspectratio: 'preserveAspectRatio',
  primitiveunits: 'primitiveUnits',
  property: 'property',
  r: 'r',
  radius: 'radius',
  refx: 'refX',
  refy: 'refY',
  renderingintent: 'renderingIntent',
  'rendering-intent': 'renderingIntent',
  repeatcount: 'repeatCount',
  repeatdur: 'repeatDur',
  requiredextensions: 'requiredExtensions',
  requiredfeatures: 'requiredFeatures',
  resource: 'resource',
  restart: 'restart',
  result: 'result',
  results: 'results',
  rotate: 'rotate',
  rx: 'rx',
  ry: 'ry',
  scale: 'scale',
  security: 'security',
  seed: 'seed',
  shaperendering: 'shapeRendering',
  'shape-rendering': 'shapeRendering',
  slope: 'slope',
  spacing: 'spacing',
  specularconstant: 'specularConstant',
  specularexponent: 'specularExponent',
  speed: 'speed',
  spreadmethod: 'spreadMethod',
  startoffset: 'startOffset',
  stddeviation: 'stdDeviation',
  stemh: 'stemh',
  stemv: 'stemv',
  stitchtiles: 'stitchTiles',
  stopcolor: 'stopColor',
  'stop-color': 'stopColor',
  stopopacity: 'stopOpacity',
  'stop-opacity': 'stopOpacity',
  strikethroughposition: 'strikethroughPosition',
  'strikethrough-position': 'strikethroughPosition',
  strikethroughthickness: 'strikethroughThickness',
  'strikethrough-thickness': 'strikethroughThickness',
  string: 'string',
  stroke: 'stroke',
  strokedasharray: 'strokeDasharray',
  'stroke-dasharray': 'strokeDasharray',
  strokedashoffset: 'strokeDashoffset',
  'stroke-dashoffset': 'strokeDashoffset',
  strokelinecap: 'strokeLinecap',
  'stroke-linecap': 'strokeLinecap',
  strokelinejoin: 'strokeLinejoin',
  'stroke-linejoin': 'strokeLinejoin',
  strokemiterlimit: 'strokeMiterlimit',
  'stroke-miterlimit': 'strokeMiterlimit',
  strokewidth: 'strokeWidth',
  'stroke-width': 'strokeWidth',
  strokeopacity: 'strokeOpacity',
  'stroke-opacity': 'strokeOpacity',
  suppresscontenteditablewarning: 'suppressContentEditableWarning',
  suppresshydrationwarning: 'suppressHydrationWarning',
  surfacescale: 'surfaceScale',
  systemlanguage: 'systemLanguage',
  tablevalues: 'tableValues',
  targetx: 'targetX',
  targety: 'targetY',
  textanchor: 'textAnchor',
  'text-anchor': 'textAnchor',
  textdecoration: 'textDecoration',
  'text-decoration': 'textDecoration',
  textlength: 'textLength',
  textrendering: 'textRendering',
  'text-rendering': 'textRendering',
  to: 'to',
  transform: 'transform',
  typeof: 'typeof',
  u1: 'u1',
  u2: 'u2',
  underlineposition: 'underlinePosition',
  'underline-position': 'underlinePosition',
  underlinethickness: 'underlineThickness',
  'underline-thickness': 'underlineThickness',
  unicode: 'unicode',
  unicodebidi: 'unicodeBidi',
  'unicode-bidi': 'unicodeBidi',
  unicoderange: 'unicodeRange',
  'unicode-range': 'unicodeRange',
  unitsperem: 'unitsPerEm',
  'units-per-em': 'unitsPerEm',
  unselectable: 'unselectable',
  valphabetic: 'vAlphabetic',
  'v-alphabetic': 'vAlphabetic',
  values: 'values',
  vectoreffect: 'vectorEffect',
  'vector-effect': 'vectorEffect',
  version: 'version',
  vertadvy: 'vertAdvY',
  'vert-adv-y': 'vertAdvY',
  vertoriginx: 'vertOriginX',
  'vert-origin-x': 'vertOriginX',
  vertoriginy: 'vertOriginY',
  'vert-origin-y': 'vertOriginY',
  vhanging: 'vHanging',
  'v-hanging': 'vHanging',
  videographic: 'vIdeographic',
  'v-ideographic': 'vIdeographic',
  viewbox: 'viewBox',
  viewtarget: 'viewTarget',
  visibility: 'visibility',
  vmathematical: 'vMathematical',
  'v-mathematical': 'vMathematical',
  vocab: 'vocab',
  widths: 'widths',
  wordspacing: 'wordSpacing',
  'word-spacing': 'wordSpacing',
  writingmode: 'writingMode',
  'writing-mode': 'writingMode',
  x1: 'x1',
  x2: 'x2',
  x: 'x',
  xchannelselector: 'xChannelSelector',
  xheight: 'xHeight',
  'x-height': 'xHeight',
  xlinkactuate: 'xlinkActuate',
  'xlink:actuate': 'xlinkActuate',
  xlinkarcrole: 'xlinkArcrole',
  'xlink:arcrole': 'xlinkArcrole',
  xlinkhref: 'xlinkHref',
  'xlink:href': 'xlinkHref',
  xlinkrole: 'xlinkRole',
  'xlink:role': 'xlinkRole',
  xlinkshow: 'xlinkShow',
  'xlink:show': 'xlinkShow',
  xlinktitle: 'xlinkTitle',
  'xlink:title': 'xlinkTitle',
  xlinktype: 'xlinkType',
  'xlink:type': 'xlinkType',
  xmlbase: 'xmlBase',
  'xml:base': 'xmlBase',
  xmllang: 'xmlLang',
  'xml:lang': 'xmlLang',
  xmlns: 'xmlns',
  'xml:space': 'xmlSpace',
  xmlnsxlink: 'xmlnsXlink',
  'xmlns:xlink': 'xmlnsXlink',
  xmlspace: 'xmlSpace',
  y1: 'y1',
  y2: 'y2',
  y: 'y',
  ychannelselector: 'yChannelSelector',
  z: 'z',
  zoomandpan: 'zoomAndPan'
};

var ariaProperties = {
  'aria-current': 0,
  // state
  'aria-details': 0,
  'aria-disabled': 0,
  // state
  'aria-hidden': 0,
  // state
  'aria-invalid': 0,
  // state
  'aria-keyshortcuts': 0,
  'aria-label': 0,
  'aria-roledescription': 0,
  // Widget Attributes
  'aria-autocomplete': 0,
  'aria-checked': 0,
  'aria-expanded': 0,
  'aria-haspopup': 0,
  'aria-level': 0,
  'aria-modal': 0,
  'aria-multiline': 0,
  'aria-multiselectable': 0,
  'aria-orientation': 0,
  'aria-placeholder': 0,
  'aria-pressed': 0,
  'aria-readonly': 0,
  'aria-required': 0,
  'aria-selected': 0,
  'aria-sort': 0,
  'aria-valuemax': 0,
  'aria-valuemin': 0,
  'aria-valuenow': 0,
  'aria-valuetext': 0,
  // Live Region Attributes
  'aria-atomic': 0,
  'aria-busy': 0,
  'aria-live': 0,
  'aria-relevant': 0,
  // Drag-and-Drop Attributes
  'aria-dropeffect': 0,
  'aria-grabbed': 0,
  // Relationship Attributes
  'aria-activedescendant': 0,
  'aria-colcount': 0,
  'aria-colindex': 0,
  'aria-colspan': 0,
  'aria-controls': 0,
  'aria-describedby': 0,
  'aria-errormessage': 0,
  'aria-flowto': 0,
  'aria-labelledby': 0,
  'aria-owns': 0,
  'aria-posinset': 0,
  'aria-rowcount': 0,
  'aria-rowindex': 0,
  'aria-rowspan': 0,
  'aria-setsize': 0
};

var warnedProperties = {};
var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

function validateProperty(tagName, name) {
  {
    if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) {
      return true;
    }

    if (rARIACamel.test(name)) {
      var ariaName = 'aria-' + name.slice(4).toLowerCase();
      var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
      // DOM properties, then it is an invalid aria-* attribute.

      if (correctName == null) {
        error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);

        warnedProperties[name] = true;
        return true;
      } // aria-* attributes should be lowercase; suggest the lowercase version.


      if (name !== correctName) {
        error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);

        warnedProperties[name] = true;
        return true;
      }
    }

    if (rARIA.test(name)) {
      var lowerCasedName = name.toLowerCase();
      var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
      // DOM properties, then it is an invalid aria-* attribute.

      if (standardName == null) {
        warnedProperties[name] = true;
        return false;
      } // aria-* attributes should be lowercase; suggest the lowercase version.


      if (name !== standardName) {
        error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);

        warnedProperties[name] = true;
        return true;
      }
    }
  }

  return true;
}

function warnInvalidARIAProps(type, props) {
  {
    var invalidProps = [];

    for (var key in props) {
      var isValid = validateProperty(type, key);

      if (!isValid) {
        invalidProps.push(key);
      }
    }

    var unknownPropString = invalidProps.map(function (prop) {
      return '`' + prop + '`';
    }).join(', ');

    if (invalidProps.length === 1) {
      error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
    } else if (invalidProps.length > 1) {
      error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
    }
  }
}

function validateProperties(type, props) {
  if (isCustomComponent(type, props)) {
    return;
  }

  warnInvalidARIAProps(type, props);
}

var didWarnValueNull = false;
function validateProperties$1(type, props) {
  {
    if (type !== 'input' && type !== 'textarea' && type !== 'select') {
      return;
    }

    if (props != null && props.value === null && !didWarnValueNull) {
      didWarnValueNull = true;

      if (type === 'select' && props.multiple) {
        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
      } else {
        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
      }
    }
  }
}

var validateProperty$1 = function () {};

{
  var warnedProperties$1 = {};
  var _hasOwnProperty = Object.prototype.hasOwnProperty;
  var EVENT_NAME_REGEX = /^on./;
  var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
  var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
  var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

  validateProperty$1 = function (tagName, name, value, eventRegistry) {
    if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
      return true;
    }

    var lowerCasedName = name.toLowerCase();

    if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
      error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');

      warnedProperties$1[name] = true;
      return true;
    } // We can't rely on the event system being injected on the server.


    if (eventRegistry != null) {
      var registrationNameDependencies = eventRegistry.registrationNameDependencies,
          possibleRegistrationNames = eventRegistry.possibleRegistrationNames;

      if (registrationNameDependencies.hasOwnProperty(name)) {
        return true;
      }

      var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

      if (registrationName != null) {
        error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);

        warnedProperties$1[name] = true;
        return true;
      }

      if (EVENT_NAME_REGEX.test(name)) {
        error('Unknown event handler property `%s`. It will be ignored.', name);

        warnedProperties$1[name] = true;
        return true;
      }
    } else if (EVENT_NAME_REGEX.test(name)) {
      // If no event plugins have been injected, we are in a server environment.
      // So we can't tell if the event name is correct for sure, but we can filter
      // out known bad ones like `onclick`. We can't suggest a specific replacement though.
      if (INVALID_EVENT_NAME_REGEX.test(name)) {
        error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
      }

      warnedProperties$1[name] = true;
      return true;
    } // Let the ARIA attribute hook validate ARIA attributes


    if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
      return true;
    }

    if (lowerCasedName === 'innerhtml') {
      error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');

      warnedProperties$1[name] = true;
      return true;
    }

    if (lowerCasedName === 'aria') {
      error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');

      warnedProperties$1[name] = true;
      return true;
    }

    if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
      error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);

      warnedProperties$1[name] = true;
      return true;
    }

    if (typeof value === 'number' && isNaN(value)) {
      error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);

      warnedProperties$1[name] = true;
      return true;
    }

    var propertyInfo = getPropertyInfo(name);
    var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

    if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
      var standardName = possibleStandardNames[lowerCasedName];

      if (standardName !== name) {
        error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);

        warnedProperties$1[name] = true;
        return true;
      }
    } else if (!isReserved && name !== lowerCasedName) {
      // Unknown attributes should have lowercase casing since that's how they
      // will be cased anyway with server rendering.
      error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);

      warnedProperties$1[name] = true;
      return true;
    }

    if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
      if (value) {
        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
      } else {
        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
      }

      warnedProperties$1[name] = true;
      return true;
    } // Now that we've validated casing, do not validate
    // data types for reserved props


    if (isReserved) {
      return true;
    } // Warn when a known attribute is a bad type


    if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
      warnedProperties$1[name] = true;
      return false;
    } // Warn when passing the strings 'false' or 'true' into a boolean prop


    if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
      error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);

      warnedProperties$1[name] = true;
      return true;
    }

    return true;
  };
}

var warnUnknownProperties = function (type, props, eventRegistry) {
  {
    var unknownProps = [];

    for (var key in props) {
      var isValid = validateProperty$1(type, key, props[key], eventRegistry);

      if (!isValid) {
        unknownProps.push(key);
      }
    }

    var unknownPropString = unknownProps.map(function (prop) {
      return '`' + prop + '`';
    }).join(', ');

    if (unknownProps.length === 1) {
      error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
    } else if (unknownProps.length > 1) {
      error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
    }
  }
};

function validateProperties$2(type, props, eventRegistry) {
  if (isCustomComponent(type, props)) {
    return;
  }

  warnUnknownProperties(type, props, eventRegistry);
}

var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
var IS_NON_DELEGATED = 1 << 1;
var IS_CAPTURE_PHASE = 1 << 2;
var IS_REPLAYED = 1 << 4;
// set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
// we call willDeferLaterForLegacyFBSupport, thus not bailing out
// will result in endless cycles like an infinite loop.
// We also don't want to defer during event replaying.

var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;

/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  // Fallback to nativeEvent.srcElement for IE9
  // https://github.com/facebook/react/issues/12506
  var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963

  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  } // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html


  return target.nodeType === TEXT_NODE ? target.parentNode : target;
}

var restoreImpl = null;
var restoreTarget = null;
var restoreQueue = null;

function restoreStateOfTarget(target) {
  // We perform this translation at the end of the event loop so that we
  // always receive the correct fiber here
  var internalInstance = getInstanceFromNode(target);

  if (!internalInstance) {
    // Unmounted
    return;
  }

  if (!(typeof restoreImpl === 'function')) {
    {
      throw Error( "setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.

  if (stateNode) {
    var _props = getFiberCurrentPropsFromNode(stateNode);

    restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
  }
}

function setRestoreImplementation(impl) {
  restoreImpl = impl;
}
function enqueueStateRestore(target) {
  if (restoreTarget) {
    if (restoreQueue) {
      restoreQueue.push(target);
    } else {
      restoreQueue = [target];
    }
  } else {
    restoreTarget = target;
  }
}
function needsStateRestore() {
  return restoreTarget !== null || restoreQueue !== null;
}
function restoreStateIfNeeded() {
  if (!restoreTarget) {
    return;
  }

  var target = restoreTarget;
  var queuedTargets = restoreQueue;
  restoreTarget = null;
  restoreQueue = null;
  restoreStateOfTarget(target);

  if (queuedTargets) {
    for (var i = 0; i < queuedTargets.length; i++) {
      restoreStateOfTarget(queuedTargets[i]);
    }
  }
}

// the renderer. Such as when we're dispatching events or if third party
// libraries need to call batchedUpdates. Eventually, this API will go away when
// everything is batched by default. We'll then have a similar API to opt-out of
// scheduled work and instead do synchronous work.
// Defaults

var batchedUpdatesImpl = function (fn, bookkeeping) {
  return fn(bookkeeping);
};

var discreteUpdatesImpl = function (fn, a, b, c, d) {
  return fn(a, b, c, d);
};

var flushDiscreteUpdatesImpl = function () {};

var batchedEventUpdatesImpl = batchedUpdatesImpl;
var isInsideEventHandler = false;
var isBatchingEventUpdates = false;

function finishEventHandler() {
  // Here we wait until all updates have propagated, which is important
  // when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  // Then we restore state of any controlled component.
  var controlledComponentsHavePendingUpdates = needsStateRestore();

  if (controlledComponentsHavePendingUpdates) {
    // If a controlled event was fired, we may need to restore the state of
    // the DOM node back to the controlled value. This is necessary when React
    // bails out of the update without touching the DOM.
    flushDiscreteUpdatesImpl();
    restoreStateIfNeeded();
  }
}

function batchedUpdates(fn, bookkeeping) {
  if (isInsideEventHandler) {
    // If we are currently inside another batch, we need to wait until it
    // fully completes before restoring state.
    return fn(bookkeeping);
  }

  isInsideEventHandler = true;

  try {
    return batchedUpdatesImpl(fn, bookkeeping);
  } finally {
    isInsideEventHandler = false;
    finishEventHandler();
  }
}
function batchedEventUpdates(fn, a, b) {
  if (isBatchingEventUpdates) {
    // If we are currently inside another batch, we need to wait until it
    // fully completes before restoring state.
    return fn(a, b);
  }

  isBatchingEventUpdates = true;

  try {
    return batchedEventUpdatesImpl(fn, a, b);
  } finally {
    isBatchingEventUpdates = false;
    finishEventHandler();
  }
}
function discreteUpdates(fn, a, b, c, d) {
  var prevIsInsideEventHandler = isInsideEventHandler;
  isInsideEventHandler = true;

  try {
    return discreteUpdatesImpl(fn, a, b, c, d);
  } finally {
    isInsideEventHandler = prevIsInsideEventHandler;

    if (!isInsideEventHandler) {
      finishEventHandler();
    }
  }
}
function flushDiscreteUpdatesIfNeeded(timeStamp) {
  {
    if (!isInsideEventHandler) {
      flushDiscreteUpdatesImpl();
    }
  }
}
function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
  batchedUpdatesImpl = _batchedUpdatesImpl;
  discreteUpdatesImpl = _discreteUpdatesImpl;
  flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
  batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
    case 'onMouseEnter':
      return !!(props.disabled && isInteractive(type));

    default:
      return false;
  }
}
/**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */


function getListener(inst, registrationName) {
  var stateNode = inst.stateNode;

  if (stateNode === null) {
    // Work in progress (ex: onload events in incremental mode).
    return null;
  }

  var props = getFiberCurrentPropsFromNode(stateNode);

  if (props === null) {
    // Work in progress.
    return null;
  }

  var listener = props[registrationName];

  if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
    return null;
  }

  if (!(!listener || typeof listener === 'function')) {
    {
      throw Error( "Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type." );
    }
  }

  return listener;
}

var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support

if (canUseDOM) {
  try {
    var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value

    Object.defineProperty(options, 'passive', {
      get: function () {
        passiveBrowserEventsSupported = true;
      }
    });
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, options);
  } catch (e) {
    passiveBrowserEventsSupported = false;
  }
}

function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
  var funcArgs = Array.prototype.slice.call(arguments, 3);

  try {
    func.apply(context, funcArgs);
  } catch (error) {
    this.onError(error);
  }
}

var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;

{
  // In DEV mode, we swap out invokeGuardedCallback for a special version
  // that plays more nicely with the browser's DevTools. The idea is to preserve
  // "Pause on exceptions" behavior. Because React wraps all user-provided
  // functions in invokeGuardedCallback, and the production version of
  // invokeGuardedCallback uses a try-catch, all user exceptions are treated
  // like caught exceptions, and the DevTools won't pause unless the developer
  // takes the extra step of enabling pause on caught exceptions. This is
  // unintuitive, though, because even though React has caught the error, from
  // the developer's perspective, the error is uncaught.
  //
  // To preserve the expected "Pause on exceptions" behavior, we don't use a
  // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
  // DOM node, and call the user-provided callback from inside an event handler
  // for that fake event. If the callback throws, the error is "captured" using
  // a global event handler. But because the error happens in a different
  // event loop context, it does not interrupt the normal program flow.
  // Effectively, this gives us try-catch behavior without actually using
  // try-catch. Neat!
  // Check that the browser supports the APIs we need to implement our special
  // DEV version of invokeGuardedCallback
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');

    invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
      // If document doesn't exist we know for sure we will crash in this method
      // when we call document.createEvent(). However this can cause confusing
      // errors: https://github.com/facebookincubator/create-react-app/issues/3482
      // So we preemptively throw with a better message instead.
      if (!(typeof document !== 'undefined')) {
        {
          throw Error( "The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous." );
        }
      }

      var evt = document.createEvent('Event');
      var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
      // set this to true at the beginning, then set it to false right after
      // calling the function. If the function errors, `didError` will never be
      // set to false. This strategy works even if the browser is flaky and
      // fails to call our global error handler, because it doesn't rely on
      // the error event at all.

      var didError = true; // Keeps track of the value of window.event so that we can reset it
      // during the callback to let user code access window.event in the
      // browsers that support it.

      var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
      // dispatching: https://github.com/facebook/react/issues/13688

      var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');

      function restoreAfterDispatch() {
        // We immediately remove the callback from event listeners so that
        // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
        // nested call would trigger the fake event handlers of any call higher
        // in the stack.
        fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
        // window.event assignment in both IE <= 10 as they throw an error
        // "Member not found" in strict mode, and in Firefox which does not
        // support window.event.

        if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
          window.event = windowEvent;
        }
      } // Create an event handler for our fake event. We will synchronously
      // dispatch our fake event using `dispatchEvent`. Inside the handler, we
      // call the user-provided callback.


      var funcArgs = Array.prototype.slice.call(arguments, 3);

      function callCallback() {
        didCall = true;
        restoreAfterDispatch();
        func.apply(context, funcArgs);
        didError = false;
      } // Create a global error event handler. We use this to capture the value
      // that was thrown. It's possible that this error handler will fire more
      // than once; for example, if non-React code also calls `dispatchEvent`
      // and a handler for that event throws. We should be resilient to most of
      // those cases. Even if our error event handler fires more than once, the
      // last error event is always used. If the callback actually does error,
      // we know that the last error event is the correct one, because it's not
      // possible for anything else to have happened in between our callback
      // erroring and the code that follows the `dispatchEvent` call below. If
      // the callback doesn't error, but the error event was fired, we know to
      // ignore it because `didError` will be false, as described above.


      var error; // Use this to track whether the error event is ever called.

      var didSetError = false;
      var isCrossOriginError = false;

      function handleWindowError(event) {
        error = event.error;
        didSetError = true;

        if (error === null && event.colno === 0 && event.lineno === 0) {
          isCrossOriginError = true;
        }

        if (event.defaultPrevented) {
          // Some other error handler has prevented default.
          // Browsers silence the error report if this happens.
          // We'll remember this to later decide whether to log it or not.
          if (error != null && typeof error === 'object') {
            try {
              error._suppressLogging = true;
            } catch (inner) {// Ignore.
            }
          }
        }
      } // Create a fake event type.


      var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers

      window.addEventListener('error', handleWindowError);
      fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
      // errors, it will trigger our global error handler.

      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);

      if (windowEventDescriptor) {
        Object.defineProperty(window, 'event', windowEventDescriptor);
      }

      if (didCall && didError) {
        if (!didSetError) {
          // The callback errored, but the error event never fired.
          error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
        } else if (isCrossOriginError) {
          error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://reactjs.org/link/crossorigin-error for more information.');
        }

        this.onError(error);
      } // Remove our event listeners


      window.removeEventListener('error', handleWindowError);

      if (!didCall) {
        // Something went really wrong, and our event was not dispatched.
        // https://github.com/facebook/react/issues/16734
        // https://github.com/facebook/react/issues/16585
        // Fall back to the production implementation.
        restoreAfterDispatch();
        return invokeGuardedCallbackProd.apply(this, arguments);
      }
    };
  }
}

var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;

var hasError = false;
var caughtError = null; // Used by event system to capture/rethrow the first error.

var hasRethrowError = false;
var rethrowError = null;
var reporter = {
  onError: function (error) {
    hasError = true;
    caughtError = error;
  }
};
/**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */

function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
  hasError = false;
  caughtError = null;
  invokeGuardedCallbackImpl$1.apply(reporter, arguments);
}
/**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */

function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
  invokeGuardedCallback.apply(this, arguments);

  if (hasError) {
    var error = clearCaughtError();

    if (!hasRethrowError) {
      hasRethrowError = true;
      rethrowError = error;
    }
  }
}
/**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */

function rethrowCaughtError() {
  if (hasRethrowError) {
    var error = rethrowError;
    hasRethrowError = false;
    rethrowError = null;
    throw error;
  }
}
function hasCaughtError() {
  return hasError;
}
function clearCaughtError() {
  if (hasError) {
    var error = caughtError;
    hasError = false;
    caughtError = null;
    return error;
  } else {
    {
      {
        throw Error( "clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  }
}

/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */
function get(key) {
  return key._reactInternals;
}
function has(key) {
  return key._reactInternals !== undefined;
}
function set(key, value) {
  key._reactInternals = value;
}

// Don't change these two values. They're used by React Dev Tools.
var NoFlags =
/*                      */
0;
var PerformedWork =
/*                */
1; // You can change the rest (and add more).

var Placement =
/*                    */
2;
var Update =
/*                       */
4;
var PlacementAndUpdate =
/*           */
6;
var Deletion =
/*                     */
8;
var ContentReset =
/*                 */
16;
var Callback =
/*                     */
32;
var DidCapture =
/*                   */
64;
var Ref =
/*                          */
128;
var Snapshot =
/*                     */
256;
var Passive =
/*                      */
512; // TODO (effects) Remove this bit once the new reconciler is synced to the old.

var PassiveUnmountPendingDev =
/*     */
8192;
var Hydrating =
/*                    */
1024;
var HydratingAndUpdate =
/*           */
1028; // Passive & Update & Callback & Ref & Snapshot

var LifecycleEffectMask =
/*          */
932; // Union of all host effects

var HostEffectMask =
/*               */
2047; // These are not really side effects, but we still reuse this field.

var Incomplete =
/*                   */
2048;
var ShouldCapture =
/*                */
4096;
var ForceUpdateForLegacySuspense =
/* */
16384; // Static tags describe aspects of a fiber that are not specific to a render,

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
function getNearestMountedFiber(fiber) {
  var node = fiber;
  var nearestMounted = fiber;

  if (!fiber.alternate) {
    // If there is no alternate, this might be a new tree that isn't inserted
    // yet. If it is, then it will have a pending insertion effect on it.
    var nextNode = node;

    do {
      node = nextNode;

      if ((node.flags & (Placement | Hydrating)) !== NoFlags) {
        // This is an insertion or in-progress hydration. The nearest possible
        // mounted fiber is the parent but we need to continue to figure out
        // if that one is still mounted.
        nearestMounted = node.return;
      }

      nextNode = node.return;
    } while (nextNode);
  } else {
    while (node.return) {
      node = node.return;
    }
  }

  if (node.tag === HostRoot) {
    // TODO: Check if this was a nested HostRoot when used with
    // renderContainerIntoSubtree.
    return nearestMounted;
  } // If we didn't hit the root, that means that we're in an disconnected tree
  // that has been unmounted.


  return null;
}
function getSuspenseInstanceFromFiber(fiber) {
  if (fiber.tag === SuspenseComponent) {
    var suspenseState = fiber.memoizedState;

    if (suspenseState === null) {
      var current = fiber.alternate;

      if (current !== null) {
        suspenseState = current.memoizedState;
      }
    }

    if (suspenseState !== null) {
      return suspenseState.dehydrated;
    }
  }

  return null;
}
function getContainerFromFiber(fiber) {
  return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
}
function isFiberMounted(fiber) {
  return getNearestMountedFiber(fiber) === fiber;
}
function isMounted(component) {
  {
    var owner = ReactCurrentOwner.current;

    if (owner !== null && owner.tag === ClassComponent) {
      var ownerFiber = owner;
      var instance = ownerFiber.stateNode;

      if (!instance._warnedAboutRefsInRender) {
        error('%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(ownerFiber.type) || 'A component');
      }

      instance._warnedAboutRefsInRender = true;
    }
  }

  var fiber = get(component);

  if (!fiber) {
    return false;
  }

  return getNearestMountedFiber(fiber) === fiber;
}

function assertIsMounted(fiber) {
  if (!(getNearestMountedFiber(fiber) === fiber)) {
    {
      throw Error( "Unable to find node on an unmounted component." );
    }
  }
}

function findCurrentFiberUsingSlowPath(fiber) {
  var alternate = fiber.alternate;

  if (!alternate) {
    // If there is no alternate, then we only need to check if it is mounted.
    var nearestMounted = getNearestMountedFiber(fiber);

    if (!(nearestMounted !== null)) {
      {
        throw Error( "Unable to find node on an unmounted component." );
      }
    }

    if (nearestMounted !== fiber) {
      return null;
    }

    return fiber;
  } // If we have two possible branches, we'll walk backwards up to the root
  // to see what path the root points to. On the way we may hit one of the
  // special cases and we'll deal with them.


  var a = fiber;
  var b = alternate;

  while (true) {
    var parentA = a.return;

    if (parentA === null) {
      // We're at the root.
      break;
    }

    var parentB = parentA.alternate;

    if (parentB === null) {
      // There is no alternate. This is an unusual case. Currently, it only
      // happens when a Suspense component is hidden. An extra fragment fiber
      // is inserted in between the Suspense fiber and its children. Skip
      // over this extra fragment fiber and proceed to the next parent.
      var nextParent = parentA.return;

      if (nextParent !== null) {
        a = b = nextParent;
        continue;
      } // If there's no parent, we're at the root.


      break;
    } // If both copies of the parent fiber point to the same child, we can
    // assume that the child is current. This happens when we bailout on low
    // priority: the bailed out fiber's child reuses the current child.


    if (parentA.child === parentB.child) {
      var child = parentA.child;

      while (child) {
        if (child === a) {
          // We've determined that A is the current branch.
          assertIsMounted(parentA);
          return fiber;
        }

        if (child === b) {
          // We've determined that B is the current branch.
          assertIsMounted(parentA);
          return alternate;
        }

        child = child.sibling;
      } // We should never have an alternate for any mounting node. So the only
      // way this could possibly happen is if this was unmounted, if at all.


      {
        {
          throw Error( "Unable to find node on an unmounted component." );
        }
      }
    }

    if (a.return !== b.return) {
      // The return pointer of A and the return pointer of B point to different
      // fibers. We assume that return pointers never criss-cross, so A must
      // belong to the child set of A.return, and B must belong to the child
      // set of B.return.
      a = parentA;
      b = parentB;
    } else {
      // The return pointers point to the same fiber. We'll have to use the
      // default, slow path: scan the child sets of each parent alternate to see
      // which child belongs to which set.
      //
      // Search parent A's child set
      var didFindChild = false;
      var _child = parentA.child;

      while (_child) {
        if (_child === a) {
          didFindChild = true;
          a = parentA;
          b = parentB;
          break;
        }

        if (_child === b) {
          didFindChild = true;
          b = parentA;
          a = parentB;
          break;
        }

        _child = _child.sibling;
      }

      if (!didFindChild) {
        // Search parent B's child set
        _child = parentB.child;

        while (_child) {
          if (_child === a) {
            didFindChild = true;
            a = parentB;
            b = parentA;
            break;
          }

          if (_child === b) {
            didFindChild = true;
            b = parentB;
            a = parentA;
            break;
          }

          _child = _child.sibling;
        }

        if (!didFindChild) {
          {
            throw Error( "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue." );
          }
        }
      }
    }

    if (!(a.alternate === b)) {
      {
        throw Error( "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  } // If the root is not a host container, we're in a disconnected tree. I.e.
  // unmounted.


  if (!(a.tag === HostRoot)) {
    {
      throw Error( "Unable to find node on an unmounted component." );
    }
  }

  if (a.stateNode.current === a) {
    // We've determined that A is the current branch.
    return fiber;
  } // Otherwise B has to be current branch.


  return alternate;
}
function findCurrentHostFiber(parent) {
  var currentParent = findCurrentFiberUsingSlowPath(parent);

  if (!currentParent) {
    return null;
  } // Next we'll drill down this component to find the first HostComponent/Text.


  var node = currentParent;

  while (true) {
    if (node.tag === HostComponent || node.tag === HostText) {
      return node;
    } else if (node.child) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === currentParent) {
      return null;
    }

    while (!node.sibling) {
      if (!node.return || node.return === currentParent) {
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  } // Flow needs the return null here, but ESLint complains about it.
  // eslint-disable-next-line no-unreachable


  return null;
}
function findCurrentHostFiberWithNoPortals(parent) {
  var currentParent = findCurrentFiberUsingSlowPath(parent);

  if (!currentParent) {
    return null;
  } // Next we'll drill down this component to find the first HostComponent/Text.


  var node = currentParent;

  while (true) {
    if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI ) {
      return node;
    } else if (node.child && node.tag !== HostPortal) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === currentParent) {
      return null;
    }

    while (!node.sibling) {
      if (!node.return || node.return === currentParent) {
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  } // Flow needs the return null here, but ESLint complains about it.
  // eslint-disable-next-line no-unreachable


  return null;
}
function doesFiberContain(parentFiber, childFiber) {
  var node = childFiber;
  var parentFiberAlternate = parentFiber.alternate;

  while (node !== null) {
    if (node === parentFiber || node === parentFiberAlternate) {
      return true;
    }

    node = node.return;
  }

  return false;
}

var attemptUserBlockingHydration;
function setAttemptUserBlockingHydration(fn) {
  attemptUserBlockingHydration = fn;
}
var attemptContinuousHydration;
function setAttemptContinuousHydration(fn) {
  attemptContinuousHydration = fn;
}
var attemptHydrationAtCurrentPriority;
function setAttemptHydrationAtCurrentPriority(fn) {
  attemptHydrationAtCurrentPriority = fn;
}
var attemptHydrationAtPriority;
function setAttemptHydrationAtPriority(fn) {
  attemptHydrationAtPriority = fn;
} // TODO: Upgrade this definition once we're on a newer version of Flow that
var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.

var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
// if the last target was dehydrated.

var queuedFocus = null;
var queuedDrag = null;
var queuedMouse = null; // For pointer events there can be one latest event per pointerId.

var queuedPointers = new Map();
var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.

var queuedExplicitHydrationTargets = [];
function hasQueuedDiscreteEvents() {
  return queuedDiscreteEvents.length > 0;
}
var discreteReplayableEvents = ['mousedown', 'mouseup', 'touchcancel', 'touchend', 'touchstart', 'auxclick', 'dblclick', 'pointercancel', 'pointerdown', 'pointerup', 'dragend', 'dragstart', 'drop', 'compositionend', 'compositionstart', 'keydown', 'keypress', 'keyup', 'input', 'textInput', // Intentionally camelCase
'copy', 'cut', 'paste', 'click', 'change', 'contextmenu', 'reset', 'submit'];
function isReplayableDiscreteEvent(eventType) {
  return discreteReplayableEvents.indexOf(eventType) > -1;
}

function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  return {
    blockedOn: blockedOn,
    domEventName: domEventName,
    eventSystemFlags: eventSystemFlags | IS_REPLAYED,
    nativeEvent: nativeEvent,
    targetContainers: [targetContainer]
  };
}

function queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
  queuedDiscreteEvents.push(queuedEvent);
} // Resets the replaying for this type of continuous event to no event.

function clearIfContinuousEvent(domEventName, nativeEvent) {
  switch (domEventName) {
    case 'focusin':
    case 'focusout':
      queuedFocus = null;
      break;

    case 'dragenter':
    case 'dragleave':
      queuedDrag = null;
      break;

    case 'mouseover':
    case 'mouseout':
      queuedMouse = null;
      break;

    case 'pointerover':
    case 'pointerout':
      {
        var pointerId = nativeEvent.pointerId;
        queuedPointers.delete(pointerId);
        break;
      }

    case 'gotpointercapture':
    case 'lostpointercapture':
      {
        var _pointerId = nativeEvent.pointerId;
        queuedPointerCaptures.delete(_pointerId);
        break;
      }
  }
}

function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
    var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);

    if (blockedOn !== null) {
      var _fiber2 = getInstanceFromNode(blockedOn);

      if (_fiber2 !== null) {
        // Attempt to increase the priority of this target.
        attemptContinuousHydration(_fiber2);
      }
    }

    return queuedEvent;
  } // If we have already queued this exact event, then it's because
  // the different event systems have different DOM event listeners.
  // We can accumulate the flags, and the targetContainers, and
  // store a single event to be replayed.


  existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
  var targetContainers = existingQueuedEvent.targetContainers;

  if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) {
    targetContainers.push(targetContainer);
  }

  return existingQueuedEvent;
}

function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  // These set relatedTarget to null because the replayed event will be treated as if we
  // moved from outside the window (no target) onto the target once it hydrates.
  // Instead of mutating we could clone the event.
  switch (domEventName) {
    case 'focusin':
      {
        var focusEvent = nativeEvent;
        queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
        return true;
      }

    case 'dragenter':
      {
        var dragEvent = nativeEvent;
        queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
        return true;
      }

    case 'mouseover':
      {
        var mouseEvent = nativeEvent;
        queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
        return true;
      }

    case 'pointerover':
      {
        var pointerEvent = nativeEvent;
        var pointerId = pointerEvent.pointerId;
        queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
        return true;
      }

    case 'gotpointercapture':
      {
        var _pointerEvent = nativeEvent;
        var _pointerId2 = _pointerEvent.pointerId;
        queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
        return true;
      }
  }

  return false;
} // Check if this target is unblocked. Returns true if it's unblocked.

function attemptExplicitHydrationTarget(queuedTarget) {
  // TODO: This function shares a lot of logic with attemptToDispatchEvent.
  // Try to unify them. It's a bit tricky since it would require two return
  // values.
  var targetInst = getClosestInstanceFromNode(queuedTarget.target);

  if (targetInst !== null) {
    var nearestMounted = getNearestMountedFiber(targetInst);

    if (nearestMounted !== null) {
      var tag = nearestMounted.tag;

      if (tag === SuspenseComponent) {
        var instance = getSuspenseInstanceFromFiber(nearestMounted);

        if (instance !== null) {
          // We're blocked on hydrating this boundary.
          // Increase its priority.
          queuedTarget.blockedOn = instance;
          attemptHydrationAtPriority(queuedTarget.lanePriority, function () {
            Scheduler.unstable_runWithPriority(queuedTarget.priority, function () {
              attemptHydrationAtCurrentPriority(nearestMounted);
            });
          });
          return;
        }
      } else if (tag === HostRoot) {
        var root = nearestMounted.stateNode;

        if (root.hydrate) {
          queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
          // a root other than sync.

          return;
        }
      }
    }
  }

  queuedTarget.blockedOn = null;
}

function attemptReplayContinuousQueuedEvent(queuedEvent) {
  if (queuedEvent.blockedOn !== null) {
    return false;
  }

  var targetContainers = queuedEvent.targetContainers;

  while (targetContainers.length > 0) {
    var targetContainer = targetContainers[0];
    var nextBlockedOn = attemptToDispatchEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);

    if (nextBlockedOn !== null) {
      // We're still blocked. Try again later.
      var _fiber3 = getInstanceFromNode(nextBlockedOn);

      if (_fiber3 !== null) {
        attemptContinuousHydration(_fiber3);
      }

      queuedEvent.blockedOn = nextBlockedOn;
      return false;
    } // This target container was successfully dispatched. Try the next.


    targetContainers.shift();
  }

  return true;
}

function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
  if (attemptReplayContinuousQueuedEvent(queuedEvent)) {
    map.delete(key);
  }
}

function replayUnblockedEvents() {
  hasScheduledReplayAttempt = false; // First replay discrete events.

  while (queuedDiscreteEvents.length > 0) {
    var nextDiscreteEvent = queuedDiscreteEvents[0];

    if (nextDiscreteEvent.blockedOn !== null) {
      // We're still blocked.
      // Increase the priority of this boundary to unblock
      // the next discrete event.
      var _fiber4 = getInstanceFromNode(nextDiscreteEvent.blockedOn);

      if (_fiber4 !== null) {
        attemptUserBlockingHydration(_fiber4);
      }

      break;
    }

    var targetContainers = nextDiscreteEvent.targetContainers;

    while (targetContainers.length > 0) {
      var targetContainer = targetContainers[0];
      var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.domEventName, nextDiscreteEvent.eventSystemFlags, targetContainer, nextDiscreteEvent.nativeEvent);

      if (nextBlockedOn !== null) {
        // We're still blocked. Try again later.
        nextDiscreteEvent.blockedOn = nextBlockedOn;
        break;
      } // This target container was successfully dispatched. Try the next.


      targetContainers.shift();
    }

    if (nextDiscreteEvent.blockedOn === null) {
      // We've successfully replayed the first event. Let's try the next one.
      queuedDiscreteEvents.shift();
    }
  } // Next replay any continuous events.


  if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) {
    queuedFocus = null;
  }

  if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) {
    queuedDrag = null;
  }

  if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) {
    queuedMouse = null;
  }

  queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
  queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}

function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
  if (queuedEvent.blockedOn === unblocked) {
    queuedEvent.blockedOn = null;

    if (!hasScheduledReplayAttempt) {
      hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
      // now unblocked. This first might not actually be unblocked yet.
      // We could check it early to avoid scheduling an unnecessary callback.

      Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
    }
  }
}

function retryIfBlockedOn(unblocked) {
  // Mark anything that was blocked on this as no longer blocked
  // and eligible for a replay.
  if (queuedDiscreteEvents.length > 0) {
    scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
    // worth it because we expect very few discrete events to queue up and once
    // we are actually fully unblocked it will be fast to replay them.

    for (var i = 1; i < queuedDiscreteEvents.length; i++) {
      var queuedEvent = queuedDiscreteEvents[i];

      if (queuedEvent.blockedOn === unblocked) {
        queuedEvent.blockedOn = null;
      }
    }
  }

  if (queuedFocus !== null) {
    scheduleCallbackIfUnblocked(queuedFocus, unblocked);
  }

  if (queuedDrag !== null) {
    scheduleCallbackIfUnblocked(queuedDrag, unblocked);
  }

  if (queuedMouse !== null) {
    scheduleCallbackIfUnblocked(queuedMouse, unblocked);
  }

  var unblock = function (queuedEvent) {
    return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
  };

  queuedPointers.forEach(unblock);
  queuedPointerCaptures.forEach(unblock);

  for (var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++) {
    var queuedTarget = queuedExplicitHydrationTargets[_i];

    if (queuedTarget.blockedOn === unblocked) {
      queuedTarget.blockedOn = null;
    }
  }

  while (queuedExplicitHydrationTargets.length > 0) {
    var nextExplicitTarget = queuedExplicitHydrationTargets[0];

    if (nextExplicitTarget.blockedOn !== null) {
      // We're still blocked.
      break;
    } else {
      attemptExplicitHydrationTarget(nextExplicitTarget);

      if (nextExplicitTarget.blockedOn === null) {
        // We're unblocked.
        queuedExplicitHydrationTargets.shift();
      }
    }
  }
}

var DiscreteEvent = 0;
var UserBlockingEvent = 1;
var ContinuousEvent = 2;

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */

function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  return prefixes;
}
/**
 * A list of event names to a configurable list of vendor prefixes.
 */


var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};
/**
 * Event names that have already been detected and prefixed (if applicable).
 */

var prefixedEventNames = {};
/**
 * Element to check for prefixes on.
 */

var style = {};
/**
 * Bootstrap if a DOM exists.
 */

if (canUseDOM) {
  style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.

  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  } // Same as above


  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}
/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */


function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return eventName;
}

var ANIMATION_END = getVendorPrefixedEventName('animationend');
var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
var ANIMATION_START = getVendorPrefixedEventName('animationstart');
var TRANSITION_END = getVendorPrefixedEventName('transitionend');

var topLevelEventsToReactNames = new Map();
var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
// the code required to apply the same logic for event prioritization and that of the
// SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
// duplication (for which there would be quite a bit). For the events that are not needed
// for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
// array of top level events.
// Lastly, we ignore prettier so we can keep the formatting sane.
// prettier-ignore

var discreteEventPairsForSimpleEventPlugin = ['cancel', 'cancel', 'click', 'click', 'close', 'close', 'contextmenu', 'contextMenu', 'copy', 'copy', 'cut', 'cut', 'auxclick', 'auxClick', 'dblclick', 'doubleClick', // Careful!
'dragend', 'dragEnd', 'dragstart', 'dragStart', 'drop', 'drop', 'focusin', 'focus', // Careful!
'focusout', 'blur', // Careful!
'input', 'input', 'invalid', 'invalid', 'keydown', 'keyDown', 'keypress', 'keyPress', 'keyup', 'keyUp', 'mousedown', 'mouseDown', 'mouseup', 'mouseUp', 'paste', 'paste', 'pause', 'pause', 'play', 'play', 'pointercancel', 'pointerCancel', 'pointerdown', 'pointerDown', 'pointerup', 'pointerUp', 'ratechange', 'rateChange', 'reset', 'reset', 'seeked', 'seeked', 'submit', 'submit', 'touchcancel', 'touchCancel', 'touchend', 'touchEnd', 'touchstart', 'touchStart', 'volumechange', 'volumeChange'];
var otherDiscreteEvents = ['change', 'selectionchange', 'textInput', 'compositionstart', 'compositionend', 'compositionupdate'];


var userBlockingPairsForSimpleEventPlugin = ['drag', 'drag', 'dragenter', 'dragEnter', 'dragexit', 'dragExit', 'dragleave', 'dragLeave', 'dragover', 'dragOver', 'mousemove', 'mouseMove', 'mouseout', 'mouseOut', 'mouseover', 'mouseOver', 'pointermove', 'pointerMove', 'pointerout', 'pointerOut', 'pointerover', 'pointerOver', 'scroll', 'scroll', 'toggle', 'toggle', 'touchmove', 'touchMove', 'wheel', 'wheel']; // prettier-ignore

var continuousPairsForSimpleEventPlugin = ['abort', 'abort', ANIMATION_END, 'animationEnd', ANIMATION_ITERATION, 'animationIteration', ANIMATION_START, 'animationStart', 'canplay', 'canPlay', 'canplaythrough', 'canPlayThrough', 'durationchange', 'durationChange', 'emptied', 'emptied', 'encrypted', 'encrypted', 'ended', 'ended', 'error', 'error', 'gotpointercapture', 'gotPointerCapture', 'load', 'load', 'loadeddata', 'loadedData', 'loadedmetadata', 'loadedMetadata', 'loadstart', 'loadStart', 'lostpointercapture', 'lostPointerCapture', 'playing', 'playing', 'progress', 'progress', 'seeking', 'seeking', 'stalled', 'stalled', 'suspend', 'suspend', 'timeupdate', 'timeUpdate', TRANSITION_END, 'transitionEnd', 'waiting', 'waiting'];
/**
 * Turns
 * ['abort', ...]
 *
 * into
 *
 * topLevelEventsToReactNames = new Map([
 *   ['abort', 'onAbort'],
 * ]);
 *
 * and registers them.
 */

function registerSimplePluginEventsAndSetTheirPriorities(eventTypes, priority) {
  // As the event types are in pairs of two, we need to iterate
  // through in twos. The events are in pairs of two to save code
  // and improve init perf of processing this array, as it will
  // result in far fewer object allocations and property accesses
  // if we only use three arrays to process all the categories of
  // instead of tuples.
  for (var i = 0; i < eventTypes.length; i += 2) {
    var topEvent = eventTypes[i];
    var event = eventTypes[i + 1];
    var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
    var reactName = 'on' + capitalizedEvent;
    eventPriorities.set(topEvent, priority);
    topLevelEventsToReactNames.set(topEvent, reactName);
    registerTwoPhaseEvent(reactName, [topEvent]);
  }
}

function setEventPriorities(eventTypes, priority) {
  for (var i = 0; i < eventTypes.length; i++) {
    eventPriorities.set(eventTypes[i], priority);
  }
}

function getEventPriorityForPluginSystem(domEventName) {
  var priority = eventPriorities.get(domEventName); // Default to a ContinuousEvent. Note: we might
  // want to warn if we can't detect the priority
  // for the event.

  return priority === undefined ? ContinuousEvent : priority;
}
function registerSimpleEvents() {
  registerSimplePluginEventsAndSetTheirPriorities(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
  registerSimplePluginEventsAndSetTheirPriorities(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
  registerSimplePluginEventsAndSetTheirPriorities(continuousPairsForSimpleEventPlugin, ContinuousEvent);
  setEventPriorities(otherDiscreteEvents, DiscreteEvent);
}

var Scheduler_now = Scheduler.unstable_now;

{
  // Provide explicit error message when production+profiling bundle of e.g.
  // react-dom is used with production (non-profiling) bundle of
  // scheduler/tracing
  if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) {
    {
      throw Error( "It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling" );
    }
  }
}
// ascending numbers so we can compare them like numbers. They start at 90 to
// avoid clashing with Scheduler's priorities.

var ImmediatePriority = 99;
var UserBlockingPriority = 98;
var NormalPriority = 97;
var LowPriority = 96;
var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.

var NoPriority = 90;
var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.

var SyncLanePriority = 15;
var SyncBatchedLanePriority = 14;
var InputDiscreteHydrationLanePriority = 13;
var InputDiscreteLanePriority = 12;
var InputContinuousHydrationLanePriority = 11;
var InputContinuousLanePriority = 10;
var DefaultHydrationLanePriority = 9;
var DefaultLanePriority = 8;
var TransitionHydrationPriority = 7;
var TransitionPriority = 6;
var RetryLanePriority = 5;
var SelectiveHydrationLanePriority = 4;
var IdleHydrationLanePriority = 3;
var IdleLanePriority = 2;
var OffscreenLanePriority = 1;
var NoLanePriority = 0;
var TotalLanes = 31;
var NoLanes =
/*                        */
0;
var NoLane =
/*                          */
0;
var SyncLane =
/*                        */
1;
var SyncBatchedLane =
/*                 */
2;
var InputDiscreteHydrationLane =
/*      */
4;
var InputDiscreteLanes =
/*                    */
24;
var InputContinuousHydrationLane =
/*           */
32;
var InputContinuousLanes =
/*                  */
192;
var DefaultHydrationLane =
/*            */
256;
var DefaultLanes =
/*                   */
3584;
var TransitionHydrationLane =
/*                */
4096;
var TransitionLanes =
/*                       */
4186112;
var RetryLanes =
/*                            */
62914560;
var SomeRetryLane =
/*                  */
33554432;
var SelectiveHydrationLane =
/*          */
67108864;
var NonIdleLanes =
/*                                 */
134217727;
var IdleHydrationLane =
/*               */
134217728;
var IdleLanes =
/*                             */
805306368;
var OffscreenLane =
/*                   */
1073741824;
var NoTimestamp = -1;
function setCurrentUpdateLanePriority(newLanePriority) {
} // "Registers" used to "return" multiple values
// Used by getHighestPriorityLanes and getNextLanes:

var return_highestLanePriority = DefaultLanePriority;

function getHighestPriorityLanes(lanes) {
  if ((SyncLane & lanes) !== NoLanes) {
    return_highestLanePriority = SyncLanePriority;
    return SyncLane;
  }

  if ((SyncBatchedLane & lanes) !== NoLanes) {
    return_highestLanePriority = SyncBatchedLanePriority;
    return SyncBatchedLane;
  }

  if ((InputDiscreteHydrationLane & lanes) !== NoLanes) {
    return_highestLanePriority = InputDiscreteHydrationLanePriority;
    return InputDiscreteHydrationLane;
  }

  var inputDiscreteLanes = InputDiscreteLanes & lanes;

  if (inputDiscreteLanes !== NoLanes) {
    return_highestLanePriority = InputDiscreteLanePriority;
    return inputDiscreteLanes;
  }

  if ((lanes & InputContinuousHydrationLane) !== NoLanes) {
    return_highestLanePriority = InputContinuousHydrationLanePriority;
    return InputContinuousHydrationLane;
  }

  var inputContinuousLanes = InputContinuousLanes & lanes;

  if (inputContinuousLanes !== NoLanes) {
    return_highestLanePriority = InputContinuousLanePriority;
    return inputContinuousLanes;
  }

  if ((lanes & DefaultHydrationLane) !== NoLanes) {
    return_highestLanePriority = DefaultHydrationLanePriority;
    return DefaultHydrationLane;
  }

  var defaultLanes = DefaultLanes & lanes;

  if (defaultLanes !== NoLanes) {
    return_highestLanePriority = DefaultLanePriority;
    return defaultLanes;
  }

  if ((lanes & TransitionHydrationLane) !== NoLanes) {
    return_highestLanePriority = TransitionHydrationPriority;
    return TransitionHydrationLane;
  }

  var transitionLanes = TransitionLanes & lanes;

  if (transitionLanes !== NoLanes) {
    return_highestLanePriority = TransitionPriority;
    return transitionLanes;
  }

  var retryLanes = RetryLanes & lanes;

  if (retryLanes !== NoLanes) {
    return_highestLanePriority = RetryLanePriority;
    return retryLanes;
  }

  if (lanes & SelectiveHydrationLane) {
    return_highestLanePriority = SelectiveHydrationLanePriority;
    return SelectiveHydrationLane;
  }

  if ((lanes & IdleHydrationLane) !== NoLanes) {
    return_highestLanePriority = IdleHydrationLanePriority;
    return IdleHydrationLane;
  }

  var idleLanes = IdleLanes & lanes;

  if (idleLanes !== NoLanes) {
    return_highestLanePriority = IdleLanePriority;
    return idleLanes;
  }

  if ((OffscreenLane & lanes) !== NoLanes) {
    return_highestLanePriority = OffscreenLanePriority;
    return OffscreenLane;
  }

  {
    error('Should have found matching lanes. This is a bug in React.');
  } // This shouldn't be reachable, but as a fallback, return the entire bitmask.


  return_highestLanePriority = DefaultLanePriority;
  return lanes;
}

function schedulerPriorityToLanePriority(schedulerPriorityLevel) {
  switch (schedulerPriorityLevel) {
    case ImmediatePriority:
      return SyncLanePriority;

    case UserBlockingPriority:
      return InputContinuousLanePriority;

    case NormalPriority:
    case LowPriority:
      // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
      return DefaultLanePriority;

    case IdlePriority:
      return IdleLanePriority;

    default:
      return NoLanePriority;
  }
}
function lanePriorityToSchedulerPriority(lanePriority) {
  switch (lanePriority) {
    case SyncLanePriority:
    case SyncBatchedLanePriority:
      return ImmediatePriority;

    case InputDiscreteHydrationLanePriority:
    case InputDiscreteLanePriority:
    case InputContinuousHydrationLanePriority:
    case InputContinuousLanePriority:
      return UserBlockingPriority;

    case DefaultHydrationLanePriority:
    case DefaultLanePriority:
    case TransitionHydrationPriority:
    case TransitionPriority:
    case SelectiveHydrationLanePriority:
    case RetryLanePriority:
      return NormalPriority;

    case IdleHydrationLanePriority:
    case IdleLanePriority:
    case OffscreenLanePriority:
      return IdlePriority;

    case NoLanePriority:
      return NoPriority;

    default:
      {
        {
          throw Error( "Invalid update priority: " + lanePriority + ". This is a bug in React." );
        }
      }

  }
}
function getNextLanes(root, wipLanes) {
  // Early bailout if there's no pending work left.
  var pendingLanes = root.pendingLanes;

  if (pendingLanes === NoLanes) {
    return_highestLanePriority = NoLanePriority;
    return NoLanes;
  }

  var nextLanes = NoLanes;
  var nextLanePriority = NoLanePriority;
  var expiredLanes = root.expiredLanes;
  var suspendedLanes = root.suspendedLanes;
  var pingedLanes = root.pingedLanes; // Check if any work has expired.

  if (expiredLanes !== NoLanes) {
    nextLanes = expiredLanes;
    nextLanePriority = return_highestLanePriority = SyncLanePriority;
  } else {
    // Do not work on any idle work until all the non-idle work has finished,
    // even if the work is suspended.
    var nonIdlePendingLanes = pendingLanes & NonIdleLanes;

    if (nonIdlePendingLanes !== NoLanes) {
      var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;

      if (nonIdleUnblockedLanes !== NoLanes) {
        nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
        nextLanePriority = return_highestLanePriority;
      } else {
        var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;

        if (nonIdlePingedLanes !== NoLanes) {
          nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
          nextLanePriority = return_highestLanePriority;
        }
      }
    } else {
      // The only remaining work is Idle.
      var unblockedLanes = pendingLanes & ~suspendedLanes;

      if (unblockedLanes !== NoLanes) {
        nextLanes = getHighestPriorityLanes(unblockedLanes);
        nextLanePriority = return_highestLanePriority;
      } else {
        if (pingedLanes !== NoLanes) {
          nextLanes = getHighestPriorityLanes(pingedLanes);
          nextLanePriority = return_highestLanePriority;
        }
      }
    }
  }

  if (nextLanes === NoLanes) {
    // This should only be reachable if we're suspended
    // TODO: Consider warning in this path if a fallback timer is not scheduled.
    return NoLanes;
  } // If there are higher priority lanes, we'll include them even if they
  // are suspended.


  nextLanes = pendingLanes & getEqualOrHigherPriorityLanes(nextLanes); // If we're already in the middle of a render, switching lanes will interrupt
  // it and we'll lose our progress. We should only do this if the new lanes are
  // higher priority.

  if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
  // bother waiting until the root is complete.
  (wipLanes & suspendedLanes) === NoLanes) {
    getHighestPriorityLanes(wipLanes);
    var wipLanePriority = return_highestLanePriority;

    if (nextLanePriority <= wipLanePriority) {
      return wipLanes;
    } else {
      return_highestLanePriority = nextLanePriority;
    }
  } // Check for entangled lanes and add them to the batch.
  //
  // A lane is said to be entangled with another when it's not allowed to render
  // in a batch that does not also include the other lane. Typically we do this
  // when multiple updates have the same source, and we only want to respond to
  // the most recent event from that source.
  //
  // Note that we apply entanglements *after* checking for partial work above.
  // This means that if a lane is entangled during an interleaved event while
  // it's already rendering, we won't interrupt it. This is intentional, since
  // entanglement is usually "best effort": we'll try our best to render the
  // lanes in the same batch, but it's not worth throwing out partially
  // completed work in order to do it.
  //
  // For those exceptions where entanglement is semantically important, like
  // useMutableSource, we should ensure that there is no partial work at the
  // time we apply the entanglement.


  var entangledLanes = root.entangledLanes;

  if (entangledLanes !== NoLanes) {
    var entanglements = root.entanglements;
    var lanes = nextLanes & entangledLanes;

    while (lanes > 0) {
      var index = pickArbitraryLaneIndex(lanes);
      var lane = 1 << index;
      nextLanes |= entanglements[index];
      lanes &= ~lane;
    }
  }

  return nextLanes;
}
function getMostRecentEventTime(root, lanes) {
  var eventTimes = root.eventTimes;
  var mostRecentEventTime = NoTimestamp;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    var eventTime = eventTimes[index];

    if (eventTime > mostRecentEventTime) {
      mostRecentEventTime = eventTime;
    }

    lanes &= ~lane;
  }

  return mostRecentEventTime;
}

function computeExpirationTime(lane, currentTime) {
  // TODO: Expiration heuristic is constant per lane, so could use a map.
  getHighestPriorityLanes(lane);
  var priority = return_highestLanePriority;

  if (priority >= InputContinuousLanePriority) {
    // User interactions should expire slightly more quickly.
    //
    // NOTE: This is set to the corresponding constant as in Scheduler.js. When
    // we made it larger, a product metric in www regressed, suggesting there's
    // a user interaction that's being starved by a series of synchronous
    // updates. If that theory is correct, the proper solution is to fix the
    // starvation. However, this scenario supports the idea that expiration
    // times are an important safeguard when starvation does happen.
    //
    // Also note that, in the case of user input specifically, this will soon no
    // longer be an issue because we plan to make user input synchronous by
    // default (until you enter `startTransition`, of course.)
    //
    // If weren't planning to make these updates synchronous soon anyway, I
    // would probably make this number a configurable parameter.
    return currentTime + 250;
  } else if (priority >= TransitionPriority) {
    return currentTime + 5000;
  } else {
    // Anything idle priority or lower should never expire.
    return NoTimestamp;
  }
}

function markStarvedLanesAsExpired(root, currentTime) {
  // TODO: This gets called every time we yield. We can optimize by storing
  // the earliest expiration time on the root. Then use that to quickly bail out
  // of this function.
  var pendingLanes = root.pendingLanes;
  var suspendedLanes = root.suspendedLanes;
  var pingedLanes = root.pingedLanes;
  var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
  // expiration time. If so, we'll assume the update is being starved and mark
  // it as expired to force it to finish.

  var lanes = pendingLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    var expirationTime = expirationTimes[index];

    if (expirationTime === NoTimestamp) {
      // Found a pending lane with no expiration time. If it's not suspended, or
      // if it's pinged, assume it's CPU-bound. Compute a new expiration time
      // using the current time.
      if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) {
        // Assumes timestamps are monotonically increasing.
        expirationTimes[index] = computeExpirationTime(lane, currentTime);
      }
    } else if (expirationTime <= currentTime) {
      // This lane expired
      root.expiredLanes |= lane;
    }

    lanes &= ~lane;
  }
} // This returns the highest priority pending lanes regardless of whether they
function getLanesToRetrySynchronouslyOnError(root) {
  var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;

  if (everythingButOffscreen !== NoLanes) {
    return everythingButOffscreen;
  }

  if (everythingButOffscreen & OffscreenLane) {
    return OffscreenLane;
  }

  return NoLanes;
}
function returnNextLanesPriority() {
  return return_highestLanePriority;
}
function includesNonIdleWork(lanes) {
  return (lanes & NonIdleLanes) !== NoLanes;
}
function includesOnlyRetries(lanes) {
  return (lanes & RetryLanes) === lanes;
}
function includesOnlyTransitions(lanes) {
  return (lanes & TransitionLanes) === lanes;
} // To ensure consistency across multiple updates in the same event, this should
// be a pure function, so that it always returns the same lane for given inputs.

function findUpdateLane(lanePriority, wipLanes) {
  switch (lanePriority) {
    case NoLanePriority:
      break;

    case SyncLanePriority:
      return SyncLane;

    case SyncBatchedLanePriority:
      return SyncBatchedLane;

    case InputDiscreteLanePriority:
      {
        var _lane = pickArbitraryLane(InputDiscreteLanes & ~wipLanes);

        if (_lane === NoLane) {
          // Shift to the next priority level
          return findUpdateLane(InputContinuousLanePriority, wipLanes);
        }

        return _lane;
      }

    case InputContinuousLanePriority:
      {
        var _lane2 = pickArbitraryLane(InputContinuousLanes & ~wipLanes);

        if (_lane2 === NoLane) {
          // Shift to the next priority level
          return findUpdateLane(DefaultLanePriority, wipLanes);
        }

        return _lane2;
      }

    case DefaultLanePriority:
      {
        var _lane3 = pickArbitraryLane(DefaultLanes & ~wipLanes);

        if (_lane3 === NoLane) {
          // If all the default lanes are already being worked on, look for a
          // lane in the transition range.
          _lane3 = pickArbitraryLane(TransitionLanes & ~wipLanes);

          if (_lane3 === NoLane) {
            // All the transition lanes are taken, too. This should be very
            // rare, but as a last resort, pick a default lane. This will have
            // the effect of interrupting the current work-in-progress render.
            _lane3 = pickArbitraryLane(DefaultLanes);
          }
        }

        return _lane3;
      }

    case TransitionPriority: // Should be handled by findTransitionLane instead

    case RetryLanePriority:
      // Should be handled by findRetryLane instead
      break;

    case IdleLanePriority:
      var lane = pickArbitraryLane(IdleLanes & ~wipLanes);

      if (lane === NoLane) {
        lane = pickArbitraryLane(IdleLanes);
      }

      return lane;
  }

  {
    {
      throw Error( "Invalid update priority: " + lanePriority + ". This is a bug in React." );
    }
  }
} // To ensure consistency across multiple updates in the same event, this should
// be pure function, so that it always returns the same lane for given inputs.

function findTransitionLane(wipLanes, pendingLanes) {
  // First look for lanes that are completely unclaimed, i.e. have no
  // pending work.
  var lane = pickArbitraryLane(TransitionLanes & ~pendingLanes);

  if (lane === NoLane) {
    // If all lanes have pending work, look for a lane that isn't currently
    // being worked on.
    lane = pickArbitraryLane(TransitionLanes & ~wipLanes);

    if (lane === NoLane) {
      // If everything is being worked on, pick any lane. This has the
      // effect of interrupting the current work-in-progress.
      lane = pickArbitraryLane(TransitionLanes);
    }
  }

  return lane;
} // To ensure consistency across multiple updates in the same event, this should
// be pure function, so that it always returns the same lane for given inputs.

function findRetryLane(wipLanes) {
  // This is a fork of `findUpdateLane` designed specifically for Suspense
  // "retries" — a special update that attempts to flip a Suspense boundary
  // from its placeholder state to its primary/resolved state.
  var lane = pickArbitraryLane(RetryLanes & ~wipLanes);

  if (lane === NoLane) {
    lane = pickArbitraryLane(RetryLanes);
  }

  return lane;
}

function getHighestPriorityLane(lanes) {
  return lanes & -lanes;
}

function getLowestPriorityLane(lanes) {
  // This finds the most significant non-zero bit.
  var index = 31 - clz32(lanes);
  return index < 0 ? NoLanes : 1 << index;
}

function getEqualOrHigherPriorityLanes(lanes) {
  return (getLowestPriorityLane(lanes) << 1) - 1;
}

function pickArbitraryLane(lanes) {
  // This wrapper function gets inlined. Only exists so to communicate that it
  // doesn't matter which bit is selected; you can pick any bit without
  // affecting the algorithms where its used. Here I'm using
  // getHighestPriorityLane because it requires the fewest operations.
  return getHighestPriorityLane(lanes);
}

function pickArbitraryLaneIndex(lanes) {
  return 31 - clz32(lanes);
}

function laneToIndex(lane) {
  return pickArbitraryLaneIndex(lane);
}

function includesSomeLane(a, b) {
  return (a & b) !== NoLanes;
}
function isSubsetOfLanes(set, subset) {
  return (set & subset) === subset;
}
function mergeLanes(a, b) {
  return a | b;
}
function removeLanes(set, subset) {
  return set & ~subset;
} // Seems redundant, but it changes the type from a single lane (used for
// updates) to a group of lanes (used for flushing work).

function laneToLanes(lane) {
  return lane;
}
function higherPriorityLane(a, b) {
  // This works because the bit ranges decrease in priority as you go left.
  return a !== NoLane && a < b ? a : b;
}
function createLaneMap(initial) {
  // Intentionally pushing one by one.
  // https://v8.dev/blog/elements-kinds#avoid-creating-holes
  var laneMap = [];

  for (var i = 0; i < TotalLanes; i++) {
    laneMap.push(initial);
  }

  return laneMap;
}
function markRootUpdated(root, updateLane, eventTime) {
  root.pendingLanes |= updateLane; // TODO: Theoretically, any update to any lane can unblock any other lane. But
  // it's not practical to try every single possible combination. We need a
  // heuristic to decide which lanes to attempt to render, and in which batches.
  // For now, we use the same heuristic as in the old ExpirationTimes model:
  // retry any lane at equal or lower priority, but don't try updates at higher
  // priority without also including the lower priority updates. This works well
  // when considering updates across different priority levels, but isn't
  // sufficient for updates within the same priority, since we want to treat
  // those updates as parallel.
  // Unsuspend any update at equal or lower priority.

  var higherPriorityLanes = updateLane - 1; // Turns 0b1000 into 0b0111

  root.suspendedLanes &= higherPriorityLanes;
  root.pingedLanes &= higherPriorityLanes;
  var eventTimes = root.eventTimes;
  var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
  // recent event, and we assume time is monotonically increasing.

  eventTimes[index] = eventTime;
}
function markRootSuspended(root, suspendedLanes) {
  root.suspendedLanes |= suspendedLanes;
  root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.

  var expirationTimes = root.expirationTimes;
  var lanes = suspendedLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    expirationTimes[index] = NoTimestamp;
    lanes &= ~lane;
  }
}
function markRootPinged(root, pingedLanes, eventTime) {
  root.pingedLanes |= root.suspendedLanes & pingedLanes;
}
function markDiscreteUpdatesExpired(root) {
  root.expiredLanes |= InputDiscreteLanes & root.pendingLanes;
}
function hasDiscreteLanes(lanes) {
  return (lanes & InputDiscreteLanes) !== NoLanes;
}
function markRootMutableRead(root, updateLane) {
  root.mutableReadLanes |= updateLane & root.pendingLanes;
}
function markRootFinished(root, remainingLanes) {
  var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
  root.pendingLanes = remainingLanes; // Let's try everything again

  root.suspendedLanes = 0;
  root.pingedLanes = 0;
  root.expiredLanes &= remainingLanes;
  root.mutableReadLanes &= remainingLanes;
  root.entangledLanes &= remainingLanes;
  var entanglements = root.entanglements;
  var eventTimes = root.eventTimes;
  var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work

  var lanes = noLongerPendingLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    entanglements[index] = NoLanes;
    eventTimes[index] = NoTimestamp;
    expirationTimes[index] = NoTimestamp;
    lanes &= ~lane;
  }
}
function markRootEntangled(root, entangledLanes) {
  root.entangledLanes |= entangledLanes;
  var entanglements = root.entanglements;
  var lanes = entangledLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    entanglements[index] |= entangledLanes;
    lanes &= ~lane;
  }
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros. Only used on lanes, so assume input is an integer.
// Based on:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32

var log = Math.log;
var LN2 = Math.LN2;

function clz32Fallback(lanes) {
  if (lanes === 0) {
    return 32;
  }

  return 31 - (log(lanes) / LN2 | 0) | 0;
}

// Intentionally not named imports because Rollup would use dynamic dispatch for
var UserBlockingPriority$1 = Scheduler.unstable_UserBlockingPriority,
    runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?

var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
// We'd like to remove this but it's not clear if this is safe.

function setEnabled(enabled) {
  _enabled = !!enabled;
}
function isEnabled() {
  return _enabled;
}
function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
  var eventPriority = getEventPriorityForPluginSystem(domEventName);
  var listenerWrapper;

  switch (eventPriority) {
    case DiscreteEvent:
      listenerWrapper = dispatchDiscreteEvent;
      break;

    case UserBlockingEvent:
      listenerWrapper = dispatchUserBlockingUpdate;
      break;

    case ContinuousEvent:
    default:
      listenerWrapper = dispatchEvent;
      break;
  }

  return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
}

function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
  {
    flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
  }

  discreteUpdates(dispatchEvent, domEventName, eventSystemFlags, container, nativeEvent);
}

function dispatchUserBlockingUpdate(domEventName, eventSystemFlags, container, nativeEvent) {
  {
    runWithPriority(UserBlockingPriority$1, dispatchEvent.bind(null, domEventName, eventSystemFlags, container, nativeEvent));
  }
}

function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  if (!_enabled) {
    return;
  }

  var allowReplay = true;

  {
    // TODO: replaying capture phase events is currently broken
    // because we used to do it during top-level native bubble handlers
    // but now we use different bubble and capture handlers.
    // In eager mode, we attach capture listeners early, so we need
    // to filter them out until we fix the logic to handle them correctly.
    // This could've been outside the flag but I put it inside to reduce risk.
    allowReplay = (eventSystemFlags & IS_CAPTURE_PHASE) === 0;
  }

  if (allowReplay && hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(domEventName)) {
    // If we already have a queue of discrete events, and this is another discrete
    // event, then we can't dispatch it regardless of its target, since they
    // need to dispatch in order.
    queueDiscreteEvent(null, // Flags that we're not actually blocked on anything as far as we know.
    domEventName, eventSystemFlags, targetContainer, nativeEvent);
    return;
  }

  var blockedOn = attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);

  if (blockedOn === null) {
    // We successfully dispatched this event.
    if (allowReplay) {
      clearIfContinuousEvent(domEventName, nativeEvent);
    }

    return;
  }

  if (allowReplay) {
    if (isReplayableDiscreteEvent(domEventName)) {
      // This this to be replayed later once the target is available.
      queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
      return;
    }

    if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
      return;
    } // We need to clear only if we didn't queue because
    // queueing is accummulative.


    clearIfContinuousEvent(domEventName, nativeEvent);
  } // This is not replayable so we'll invoke it but without a target,
  // in case the event system needs to trace it.


  dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
} // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.

function attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  // TODO: Warn if _enabled is false.
  var nativeEventTarget = getEventTarget(nativeEvent);
  var targetInst = getClosestInstanceFromNode(nativeEventTarget);

  if (targetInst !== null) {
    var nearestMounted = getNearestMountedFiber(targetInst);

    if (nearestMounted === null) {
      // This tree has been unmounted already. Dispatch without a target.
      targetInst = null;
    } else {
      var tag = nearestMounted.tag;

      if (tag === SuspenseComponent) {
        var instance = getSuspenseInstanceFromFiber(nearestMounted);

        if (instance !== null) {
          // Queue the event to be replayed later. Abort dispatching since we
          // don't want this event dispatched twice through the event system.
          // TODO: If this is the first discrete event in the queue. Schedule an increased
          // priority for this boundary.
          return instance;
        } // This shouldn't happen, something went wrong but to avoid blocking
        // the whole system, dispatch the event without a target.
        // TODO: Warn.


        targetInst = null;
      } else if (tag === HostRoot) {
        var root = nearestMounted.stateNode;

        if (root.hydrate) {
          // If this happens during a replay something went wrong and it might block
          // the whole system.
          return getContainerFromFiber(nearestMounted);
        }

        targetInst = null;
      } else if (nearestMounted !== targetInst) {
        // If we get an event (ex: img onload) before committing that
        // component's mount, ignore it for now (that is, treat it as if it was an
        // event on a non-React tree). We might also consider queueing events and
        // dispatching them after the mount.
        targetInst = null;
      }
    }
  }

  dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer); // We're not blocked on anything.

  return null;
}

function addEventBubbleListener(target, eventType, listener) {
  target.addEventListener(eventType, listener, false);
  return listener;
}
function addEventCaptureListener(target, eventType, listener) {
  target.addEventListener(eventType, listener, true);
  return listener;
}
function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
  target.addEventListener(eventType, listener, {
    capture: true,
    passive: passive
  });
  return listener;
}
function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
  target.addEventListener(eventType, listener, {
    passive: passive
  });
  return listener;
}

/**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */
var root = null;
var startText = null;
var fallbackText = null;
function initialize(nativeEventTarget) {
  root = nativeEventTarget;
  startText = getText();
  return true;
}
function reset() {
  root = null;
  startText = null;
  fallbackText = null;
}
function getData() {
  if (fallbackText) {
    return fallbackText;
  }

  var start;
  var startValue = startText;
  var startLength = startValue.length;
  var end;
  var endValue = getText();
  var endLength = endValue.length;

  for (start = 0; start < startLength; start++) {
    if (startValue[start] !== endValue[start]) {
      break;
    }
  }

  var minEnd = startLength - start;

  for (end = 1; end <= minEnd; end++) {
    if (startValue[startLength - end] !== endValue[endLength - end]) {
      break;
    }
  }

  var sliceTail = end > 1 ? 1 - end : undefined;
  fallbackText = endValue.slice(start, sliceTail);
  return fallbackText;
}
function getText() {
  if ('value' in root) {
    return root.value;
  }

  return root.textContent;
}

/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */
function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.

    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  } // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
  // report Enter as charCode 10 when ctrl is pressed.


  if (charCode === 10) {
    charCode = 13;
  } // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.


  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

function functionThatReturnsTrue() {
  return true;
}

function functionThatReturnsFalse() {
  return false;
} // This is intentionally a factory so that we have different returned constructors.
// If we had a single constructor, it would be megamorphic and engines would deopt.


function createSyntheticEvent(Interface) {
  /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */
  function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
    this._reactName = reactName;
    this._targetInst = targetInst;
    this.type = reactEventType;
    this.nativeEvent = nativeEvent;
    this.target = nativeEventTarget;
    this.currentTarget = null;

    for (var _propName in Interface) {
      if (!Interface.hasOwnProperty(_propName)) {
        continue;
      }

      var normalize = Interface[_propName];

      if (normalize) {
        this[_propName] = normalize(nativeEvent);
      } else {
        this[_propName] = nativeEvent[_propName];
      }
    }

    var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;

    if (defaultPrevented) {
      this.isDefaultPrevented = functionThatReturnsTrue;
    } else {
      this.isDefaultPrevented = functionThatReturnsFalse;
    }

    this.isPropagationStopped = functionThatReturnsFalse;
    return this;
  }

  _assign(SyntheticBaseEvent.prototype, {
    preventDefault: function () {
      this.defaultPrevented = true;
      var event = this.nativeEvent;

      if (!event) {
        return;
      }

      if (event.preventDefault) {
        event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
      } else if (typeof event.returnValue !== 'unknown') {
        event.returnValue = false;
      }

      this.isDefaultPrevented = functionThatReturnsTrue;
    },
    stopPropagation: function () {
      var event = this.nativeEvent;

      if (!event) {
        return;
      }

      if (event.stopPropagation) {
        event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
      } else if (typeof event.cancelBubble !== 'unknown') {
        // The ChangeEventPlugin registers a "propertychange" event for
        // IE. This event does not support bubbling or cancelling, and
        // any references to cancelBubble throw "Member not found".  A
        // typeof check of "unknown" circumvents this issue (and is also
        // IE specific).
        event.cancelBubble = true;
      }

      this.isPropagationStopped = functionThatReturnsTrue;
    },

    /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */
    persist: function () {// Modern event system doesn't use pooling.
    },

    /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */
    isPersistent: functionThatReturnsTrue
  });

  return SyntheticBaseEvent;
}
/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */


var EventInterface = {
  eventPhase: 0,
  bubbles: 0,
  cancelable: 0,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: 0,
  isTrusted: 0
};
var SyntheticEvent = createSyntheticEvent(EventInterface);

var UIEventInterface = _assign({}, EventInterface, {
  view: 0,
  detail: 0
});

var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
var lastMovementX;
var lastMovementY;
var lastMouseEvent;

function updateMouseMovementPolyfillState(event) {
  if (event !== lastMouseEvent) {
    if (lastMouseEvent && event.type === 'mousemove') {
      lastMovementX = event.screenX - lastMouseEvent.screenX;
      lastMovementY = event.screenY - lastMouseEvent.screenY;
    } else {
      lastMovementX = 0;
      lastMovementY = 0;
    }

    lastMouseEvent = event;
  }
}
/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */


var MouseEventInterface = _assign({}, UIEventInterface, {
  screenX: 0,
  screenY: 0,
  clientX: 0,
  clientY: 0,
  pageX: 0,
  pageY: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  getModifierState: getEventModifierState,
  button: 0,
  buttons: 0,
  relatedTarget: function (event) {
    if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
    return event.relatedTarget;
  },
  movementX: function (event) {
    if ('movementX' in event) {
      return event.movementX;
    }

    updateMouseMovementPolyfillState(event);
    return lastMovementX;
  },
  movementY: function (event) {
    if ('movementY' in event) {
      return event.movementY;
    } // Don't need to call updateMouseMovementPolyfillState() here
    // because it's guaranteed to have already run when movementX
    // was copied.


    return lastMovementY;
  }
});

var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */

var DragEventInterface = _assign({}, MouseEventInterface, {
  dataTransfer: 0
});

var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */

var FocusEventInterface = _assign({}, UIEventInterface, {
  relatedTarget: 0
});

var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */

var AnimationEventInterface = _assign({}, EventInterface, {
  animationName: 0,
  elapsedTime: 0,
  pseudoElement: 0
});

var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */

var ClipboardEventInterface = _assign({}, EventInterface, {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
});

var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */

var CompositionEventInterface = _assign({}, EventInterface, {
  data: 0
});

var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
// Happens to share the same list for now.

var SyntheticInputEvent = SyntheticCompositionEvent;
/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */

var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};
/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */

var translateToKey = {
  '8': 'Backspace',
  '9': 'Tab',
  '12': 'Clear',
  '13': 'Enter',
  '16': 'Shift',
  '17': 'Control',
  '18': 'Alt',
  '19': 'Pause',
  '20': 'CapsLock',
  '27': 'Escape',
  '32': ' ',
  '33': 'PageUp',
  '34': 'PageDown',
  '35': 'End',
  '36': 'Home',
  '37': 'ArrowLeft',
  '38': 'ArrowUp',
  '39': 'ArrowRight',
  '40': 'ArrowDown',
  '45': 'Insert',
  '46': 'Delete',
  '112': 'F1',
  '113': 'F2',
  '114': 'F3',
  '115': 'F4',
  '116': 'F5',
  '117': 'F6',
  '118': 'F7',
  '119': 'F8',
  '120': 'F9',
  '121': 'F10',
  '122': 'F11',
  '123': 'F12',
  '144': 'NumLock',
  '145': 'ScrollLock',
  '224': 'Meta'
};
/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */

function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.
    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;

    if (key !== 'Unidentified') {
      return key;
    }
  } // Browser does not implement `key`, polyfill as much of it as we can.


  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.

    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }

  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }

  return '';
}
/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */


var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
}; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
// getModifierState. If getModifierState is not supported, we map it to a set of
// modifier keys exposed by the event. In this case, Lock-keys are not supported.

function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;

  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }

  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}
/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */


var KeyboardEventInterface = _assign({}, UIEventInterface, {
  key: getEventKey,
  code: 0,
  location: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  repeat: 0,
  locale: 0,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.
    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }

    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.
    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }

    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }

    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }

    return 0;
  }
});

var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
/**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */

var PointerEventInterface = _assign({}, MouseEventInterface, {
  pointerId: 0,
  width: 0,
  height: 0,
  pressure: 0,
  tangentialPressure: 0,
  tiltX: 0,
  tiltY: 0,
  twist: 0,
  pointerType: 0,
  isPrimary: 0
});

var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */

var TouchEventInterface = _assign({}, UIEventInterface, {
  touches: 0,
  targetTouches: 0,
  changedTouches: 0,
  altKey: 0,
  metaKey: 0,
  ctrlKey: 0,
  shiftKey: 0,
  getModifierState: getEventModifierState
});

var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */

var TransitionEventInterface = _assign({}, EventInterface, {
  propertyName: 0,
  elapsedTime: 0,
  pseudoElement: 0
});

var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */

var WheelEventInterface = _assign({}, MouseEventInterface, {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: 0,
  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: 0
});

var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space

var START_KEYCODE = 229;
var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
var documentMode = null;

if (canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
} // Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.


var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.

var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

function registerEvents() {
  registerTwoPhaseEvent('onBeforeInput', ['compositionend', 'keypress', 'textInput', 'paste']);
  registerTwoPhaseEvent('onCompositionEnd', ['compositionend', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
  registerTwoPhaseEvent('onCompositionStart', ['compositionstart', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
  registerTwoPhaseEvent('onCompositionUpdate', ['compositionupdate', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
} // Track whether we've ever handled a keypress on the space key.


var hasSpaceKeypress = false;
/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */

function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}
/**
 * Translate native top level events into event types.
 */


function getCompositionEventType(domEventName) {
  switch (domEventName) {
    case 'compositionstart':
      return 'onCompositionStart';

    case 'compositionend':
      return 'onCompositionEnd';

    case 'compositionupdate':
      return 'onCompositionUpdate';
  }
}
/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */


function isFallbackCompositionStart(domEventName, nativeEvent) {
  return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
}
/**
 * Does our fallback mode think that this event is the end of composition?
 */


function isFallbackCompositionEnd(domEventName, nativeEvent) {
  switch (domEventName) {
    case 'keyup':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;

    case 'keydown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;

    case 'keypress':
    case 'mousedown':
    case 'focusout':
      // Events are not possible without cancelling IME.
      return true;

    default:
      return false;
  }
}
/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */


function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;

  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }

  return null;
}
/**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */


function isUsingKoreanIME(nativeEvent) {
  return nativeEvent.locale === 'ko';
} // Track the current IME composition status, if any.


var isComposing = false;
/**
 * @return {?object} A SyntheticCompositionEvent.
 */

function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(domEventName);
  } else if (!isComposing) {
    if (isFallbackCompositionStart(domEventName, nativeEvent)) {
      eventType = 'onCompositionStart';
    }
  } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) {
    eventType = 'onCompositionEnd';
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!isComposing && eventType === 'onCompositionStart') {
      isComposing = initialize(nativeEventTarget);
    } else if (eventType === 'onCompositionEnd') {
      if (isComposing) {
        fallbackData = getData();
      }
    }
  }

  var listeners = accumulateTwoPhaseListeners(targetInst, eventType);

  if (listeners.length > 0) {
    var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });

    if (fallbackData) {
      // Inject data generated from fallback path into the synthetic event.
      // This matches the property of native CompositionEventInterface.
      event.data = fallbackData;
    } else {
      var customData = getDataFromCustomEvent(nativeEvent);

      if (customData !== null) {
        event.data = customData;
      }
    }
  }
}

function getNativeBeforeInputChars(domEventName, nativeEvent) {
  switch (domEventName) {
    case 'compositionend':
      return getDataFromCustomEvent(nativeEvent);

    case 'keypress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;

      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'textInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to ignore it.

      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}
/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */


function getFallbackBeforeInputChars(domEventName, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (isComposing) {
    if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
      var chars = getData();
      reset();
      isComposing = false;
      return chars;
    }

    return null;
  }

  switch (domEventName) {
    case 'paste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;

    case 'keypress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (!isKeypressCommand(nativeEvent)) {
        // IE fires the `keypress` event when a user types an emoji via
        // Touch keyboard of Windows.  In such a case, the `char` property
        // holds an emoji character like `\uD83D\uDE0A`.  Because its length
        // is 2, the property `which` does not represent an emoji correctly.
        // In such a case, we directly return the `char` property instead of
        // using `which`.
        if (nativeEvent.char && nativeEvent.char.length > 1) {
          return nativeEvent.char;
        } else if (nativeEvent.which) {
          return String.fromCharCode(nativeEvent.which);
        }
      }

      return null;

    case 'compositionend':
      return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;

    default:
      return null;
  }
}
/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */


function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(domEventName, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
  } // If no characters are being inserted, no BeforeInput event should
  // be fired.


  if (!chars) {
    return null;
  }

  var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');

  if (listeners.length > 0) {
    var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });
    event.data = chars;
  }
}
/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */


function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
  extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
}

/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */
var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */

function isEventSupported(eventNameSuffix) {
  if (!canUseDOM) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = (eventName in document);

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  return isSupported;
}

function registerEvents$1() {
  registerTwoPhaseEvent('onChange', ['change', 'click', 'focusin', 'focusout', 'input', 'keydown', 'keyup', 'selectionchange']);
}

function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
  // Flag this event loop as needing state restore.
  enqueueStateRestore(target);
  var listeners = accumulateTwoPhaseListeners(inst, 'onChange');

  if (listeners.length > 0) {
    var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });
  }
}
/**
 * For IE shims
 */


var activeElement = null;
var activeElementInst = null;
/**
 * SECTION: handle `change` event
 */

function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

function manualDispatchChangeEvent(nativeEvent) {
  var dispatchQueue = [];
  createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.

  batchedUpdates(runEventInBatch, dispatchQueue);
}

function runEventInBatch(dispatchQueue) {
  processDispatchQueue(dispatchQueue, 0);
}

function getInstIfValueChanged(targetInst) {
  var targetNode = getNodeFromInstance(targetInst);

  if (updateValueIfChanged(targetNode)) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(domEventName, targetInst) {
  if (domEventName === 'change') {
    return targetInst;
  }
}
/**
 * SECTION: handle `input` event
 */


var isInputEventSupported = false;

if (canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.
  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}
/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */


function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}
/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */


function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  activeElement.detachEvent('onpropertychange', handlePropertyChange);
  activeElement = null;
  activeElementInst = null;
}
/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */


function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }

  if (getInstIfValueChanged(activeElementInst)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
  if (domEventName === 'focusin') {
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (domEventName === 'focusout') {
    stopWatchingForValueChange();
  }
} // For IE8 and IE9.


function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
  if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst);
  }
}
/**
 * SECTION: handle `click` event
 */


function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(domEventName, targetInst) {
  if (domEventName === 'click') {
    return getInstIfValueChanged(targetInst);
  }
}

function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
  if (domEventName === 'input' || domEventName === 'change') {
    return getInstIfValueChanged(targetInst);
  }
}

function handleControlledInputBlur(node) {
  var state = node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  {
    // If controlled, assign the value attribute to the current value on blur
    setDefaultValue(node, 'number', node.value);
  }
}
/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */


function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
  var getTargetInstFunc, handleEventFunc;

  if (shouldUseChangeEvent(targetNode)) {
    getTargetInstFunc = getTargetInstForChangeEvent;
  } else if (isTextInputElement(targetNode)) {
    if (isInputEventSupported) {
      getTargetInstFunc = getTargetInstForInputOrChangeEvent;
    } else {
      getTargetInstFunc = getTargetInstForInputEventPolyfill;
      handleEventFunc = handleEventsForInputEventPolyfill;
    }
  } else if (shouldUseClickEvent(targetNode)) {
    getTargetInstFunc = getTargetInstForClickEvent;
  }

  if (getTargetInstFunc) {
    var inst = getTargetInstFunc(domEventName, targetInst);

    if (inst) {
      createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
      return;
    }
  }

  if (handleEventFunc) {
    handleEventFunc(domEventName, targetNode, targetInst);
  } // When blurring, set the value attribute for number inputs


  if (domEventName === 'focusout') {
    handleControlledInputBlur(targetNode);
  }
}

function registerEvents$2() {
  registerDirectEvent('onMouseEnter', ['mouseout', 'mouseover']);
  registerDirectEvent('onMouseLeave', ['mouseout', 'mouseover']);
  registerDirectEvent('onPointerEnter', ['pointerout', 'pointerover']);
  registerDirectEvent('onPointerLeave', ['pointerout', 'pointerover']);
}
/**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */


function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
  var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';

  if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0) {
    // If this is an over event with a target, we might have already dispatched
    // the event in the out event of the other target. If this is replayed,
    // then it's because we couldn't dispatch against this target previously
    // so we have to do it now instead.
    var related = nativeEvent.relatedTarget || nativeEvent.fromElement;

    if (related) {
      // If the related node is managed by React, we can assume that we have
      // already dispatched the corresponding events during its mouseout.
      if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) {
        return;
      }
    }
  }

  if (!isOutEvent && !isOverEvent) {
    // Must not be a mouse or pointer in or out - ignoring.
    return;
  }

  var win; // TODO: why is this nullable in the types but we read from it?

  if (nativeEventTarget.window === nativeEventTarget) {
    // `nativeEventTarget` is probably a window object.
    win = nativeEventTarget;
  } else {
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    var doc = nativeEventTarget.ownerDocument;

    if (doc) {
      win = doc.defaultView || doc.parentWindow;
    } else {
      win = window;
    }
  }

  var from;
  var to;

  if (isOutEvent) {
    var _related = nativeEvent.relatedTarget || nativeEvent.toElement;

    from = targetInst;
    to = _related ? getClosestInstanceFromNode(_related) : null;

    if (to !== null) {
      var nearestMounted = getNearestMountedFiber(to);

      if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) {
        to = null;
      }
    }
  } else {
    // Moving to a node from outside the window.
    from = null;
    to = targetInst;
  }

  if (from === to) {
    // Nothing pertains to our managed components.
    return;
  }

  var SyntheticEventCtor = SyntheticMouseEvent;
  var leaveEventType = 'onMouseLeave';
  var enterEventType = 'onMouseEnter';
  var eventTypePrefix = 'mouse';

  if (domEventName === 'pointerout' || domEventName === 'pointerover') {
    SyntheticEventCtor = SyntheticPointerEvent;
    leaveEventType = 'onPointerLeave';
    enterEventType = 'onPointerEnter';
    eventTypePrefix = 'pointer';
  }

  var fromNode = from == null ? win : getNodeFromInstance(from);
  var toNode = to == null ? win : getNodeFromInstance(to);
  var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
  leave.target = fromNode;
  leave.relatedTarget = toNode;
  var enter = null; // We should only process this nativeEvent if we are processing
  // the first ancestor. Next time, we will ignore the event.

  var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);

  if (nativeTargetInst === targetInst) {
    var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
    enterEvent.target = toNode;
    enterEvent.relatedTarget = fromNode;
    enter = enterEvent;
  }

  accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
}

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
  ;
}

var objectIs = typeof Object.is === 'function' ? Object.is : is;

var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */

function shallowEqual(objA, objB) {
  if (objectIs(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  } // Test for A's keys different from B.


  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }

  return node;
}
/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */


function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }

    node = node.parentNode;
  }
}
/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */


function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === TEXT_NODE) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

/**
 * @param {DOMElement} outerNode
 * @return {?object}
 */

function getOffsets(outerNode) {
  var ownerDocument = outerNode.ownerDocument;
  var win = ownerDocument && ownerDocument.defaultView || window;
  var selection = win.getSelection && win.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset,
      focusNode = selection.focusNode,
      focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
  // up/down buttons on an <input type="number">. Anonymous divs do not seem to
  // expose properties, triggering a "Permission denied error" if any of its
  // properties are accessed. The only seemingly possible way to avoid erroring
  // is to access a property that typically works for non-anonymous divs and
  // catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427

  try {
    /* eslint-disable no-unused-expressions */
    anchorNode.nodeType;
    focusNode.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
}
/**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */

function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
  var length = 0;
  var start = -1;
  var end = -1;
  var indexWithinAnchor = 0;
  var indexWithinFocus = 0;
  var node = outerNode;
  var parentNode = null;

  outer: while (true) {
    var next = null;

    while (true) {
      if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) {
        start = length + anchorOffset;
      }

      if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) {
        end = length + focusOffset;
      }

      if (node.nodeType === TEXT_NODE) {
        length += node.nodeValue.length;
      }

      if ((next = node.firstChild) === null) {
        break;
      } // Moving from `node` to its first child `next`.


      parentNode = node;
      node = next;
    }

    while (true) {
      if (node === outerNode) {
        // If `outerNode` has children, this is always the second time visiting
        // it. If it has no children, this is still the first loop, and the only
        // valid selection is anchorNode and focusNode both equal to this node
        // and both offsets 0, in which case we will have handled above.
        break outer;
      }

      if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
        start = length;
      }

      if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
        end = length;
      }

      if ((next = node.nextSibling) !== null) {
        break;
      }

      node = parentNode;
      parentNode = node.parentNode;
    } // Moving from `node` to its next sibling `next`.


    node = next;
  }

  if (start === -1 || end === -1) {
    // This should never happen. (Would happen if the anchor/focus nodes aren't
    // actually inside the passed-in node.)
    return null;
  }

  return {
    start: start,
    end: end
  };
}
/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */

function setOffsets(node, offsets) {
  var doc = node.ownerDocument || document;
  var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
  // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
  // fails when pasting 100+ items)

  if (!win.getSelection) {
    return;
  }

  var selection = win.getSelection();
  var length = node.textContent.length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.

  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
      return;
    }

    var range = doc.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

function isTextNode(node) {
  return node && node.nodeType === TEXT_NODE;
}

function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

function isInDocument(node) {
  return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
}

function isSameOriginFrame(iframe) {
  try {
    // Accessing the contentDocument of a HTMLIframeElement can cause the browser
    // to throw, e.g. if it has a cross-origin src attribute.
    // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
    // iframe.contentDocument.defaultView;
    // A safety way is to access one of the cross origin properties: Window or Location
    // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
    // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
    return typeof iframe.contentWindow.location.href === 'string';
  } catch (err) {
    return false;
  }
}

function getActiveElementDeep() {
  var win = window;
  var element = getActiveElement();

  while (element instanceof win.HTMLIFrameElement) {
    if (isSameOriginFrame(element)) {
      win = element.contentWindow;
    } else {
      return element;
    }

    element = getActiveElement(win.document);
  }

  return element;
}
/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */

/**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */


function hasSelectionCapabilities(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
}
function getSelectionInformation() {
  var focusedElem = getActiveElementDeep();
  return {
    focusedElem: focusedElem,
    selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
  };
}
/**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */

function restoreSelection(priorSelectionInformation) {
  var curFocusedElem = getActiveElementDeep();
  var priorFocusedElem = priorSelectionInformation.focusedElem;
  var priorSelectionRange = priorSelectionInformation.selectionRange;

  if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
    if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) {
      setSelection(priorFocusedElem, priorSelectionRange);
    } // Focusing a node can change the scroll position, which is undesirable


    var ancestors = [];
    var ancestor = priorFocusedElem;

    while (ancestor = ancestor.parentNode) {
      if (ancestor.nodeType === ELEMENT_NODE) {
        ancestors.push({
          element: ancestor,
          left: ancestor.scrollLeft,
          top: ancestor.scrollTop
        });
      }
    }

    if (typeof priorFocusedElem.focus === 'function') {
      priorFocusedElem.focus();
    }

    for (var i = 0; i < ancestors.length; i++) {
      var info = ancestors[i];
      info.element.scrollLeft = info.left;
      info.element.scrollTop = info.top;
    }
  }
}
/**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */

function getSelection(input) {
  var selection;

  if ('selectionStart' in input) {
    // Modern browser with input or textarea.
    selection = {
      start: input.selectionStart,
      end: input.selectionEnd
    };
  } else {
    // Content editable or old IE textarea.
    selection = getOffsets(input);
  }

  return selection || {
    start: 0,
    end: 0
  };
}
/**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */

function setSelection(input, offsets) {
  var start = offsets.start;
  var end = offsets.end;

  if (end === undefined) {
    end = start;
  }

  if ('selectionStart' in input) {
    input.selectionStart = start;
    input.selectionEnd = Math.min(end, input.value.length);
  } else {
    setOffsets(input, offsets);
  }
}

var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;

function registerEvents$3() {
  registerTwoPhaseEvent('onSelect', ['focusout', 'contextmenu', 'dragend', 'focusin', 'keydown', 'keyup', 'mousedown', 'mouseup', 'selectionchange']);
}

var activeElement$1 = null;
var activeElementInst$1 = null;
var lastSelection = null;
var mouseDown = false;
/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */

function getSelection$1(node) {
  if ('selectionStart' in node && hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else {
    var win = node.ownerDocument && node.ownerDocument.defaultView || window;
    var selection = win.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  }
}
/**
 * Get document associated with the event target.
 */


function getEventTargetDocument(eventTarget) {
  return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
}
/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */


function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  var doc = getEventTargetDocument(nativeEventTarget);

  if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) {
    return;
  } // Only fire when selection has actually changed.


  var currentSelection = getSelection$1(activeElement$1);

  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;
    var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');

    if (listeners.length > 0) {
      var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
      dispatchQueue.push({
        event: event,
        listeners: listeners
      });
      event.target = activeElement$1;
    }
  }
}
/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */


function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {

  var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;

  switch (domEventName) {
    // Track the input node that has focus.
    case 'focusin':
      if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
        activeElement$1 = targetNode;
        activeElementInst$1 = targetInst;
        lastSelection = null;
      }

      break;

    case 'focusout':
      activeElement$1 = null;
      activeElementInst$1 = null;
      lastSelection = null;
      break;
    // Don't fire the event while the user is dragging. This matches the
    // semantics of the native select event.

    case 'mousedown':
      mouseDown = true;
      break;

    case 'contextmenu':
    case 'mouseup':
    case 'dragend':
      mouseDown = false;
      constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
      break;
    // Chrome and IE fire non-standard event when selection is changed (and
    // sometimes when it hasn't). IE's event fires out of order with respect
    // to key and input events on deletion, so we discard it.
    //
    // Firefox doesn't support selectionchange, so check selection status
    // after each key entry. The selection changes after keydown and before
    // keyup, but we check on keydown as well in the case of holding down a
    // key, when multiple keydown events are fired but only one keyup is.
    // This is also our approach for IE handling, for the reason above.

    case 'selectionchange':
      if (skipSelectionChangeEvent) {
        break;
      }

    // falls through

    case 'keydown':
    case 'keyup':
      constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
  }
}

function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  var reactName = topLevelEventsToReactNames.get(domEventName);

  if (reactName === undefined) {
    return;
  }

  var SyntheticEventCtor = SyntheticEvent;
  var reactEventType = domEventName;

  switch (domEventName) {
    case 'keypress':
      // Firefox creates a keypress event for function keys too. This removes
      // the unwanted keypress events. Enter is however both printable and
      // non-printable. One would expect Tab to be as well (but it isn't).
      if (getEventCharCode(nativeEvent) === 0) {
        return;
      }

    /* falls through */

    case 'keydown':
    case 'keyup':
      SyntheticEventCtor = SyntheticKeyboardEvent;
      break;

    case 'focusin':
      reactEventType = 'focus';
      SyntheticEventCtor = SyntheticFocusEvent;
      break;

    case 'focusout':
      reactEventType = 'blur';
      SyntheticEventCtor = SyntheticFocusEvent;
      break;

    case 'beforeblur':
    case 'afterblur':
      SyntheticEventCtor = SyntheticFocusEvent;
      break;

    case 'click':
      // Firefox creates a click event on right mouse clicks. This removes the
      // unwanted click events.
      if (nativeEvent.button === 2) {
        return;
      }

    /* falls through */

    case 'auxclick':
    case 'dblclick':
    case 'mousedown':
    case 'mousemove':
    case 'mouseup': // TODO: Disabled elements should not respond to mouse events

    /* falls through */

    case 'mouseout':
    case 'mouseover':
    case 'contextmenu':
      SyntheticEventCtor = SyntheticMouseEvent;
      break;

    case 'drag':
    case 'dragend':
    case 'dragenter':
    case 'dragexit':
    case 'dragleave':
    case 'dragover':
    case 'dragstart':
    case 'drop':
      SyntheticEventCtor = SyntheticDragEvent;
      break;

    case 'touchcancel':
    case 'touchend':
    case 'touchmove':
    case 'touchstart':
      SyntheticEventCtor = SyntheticTouchEvent;
      break;

    case ANIMATION_END:
    case ANIMATION_ITERATION:
    case ANIMATION_START:
      SyntheticEventCtor = SyntheticAnimationEvent;
      break;

    case TRANSITION_END:
      SyntheticEventCtor = SyntheticTransitionEvent;
      break;

    case 'scroll':
      SyntheticEventCtor = SyntheticUIEvent;
      break;

    case 'wheel':
      SyntheticEventCtor = SyntheticWheelEvent;
      break;

    case 'copy':
    case 'cut':
    case 'paste':
      SyntheticEventCtor = SyntheticClipboardEvent;
      break;

    case 'gotpointercapture':
    case 'lostpointercapture':
    case 'pointercancel':
    case 'pointerdown':
    case 'pointermove':
    case 'pointerout':
    case 'pointerover':
    case 'pointerup':
      SyntheticEventCtor = SyntheticPointerEvent;
      break;
  }

  var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;

  {
    // Some events don't bubble in the browser.
    // In the past, React has always bubbled them, but this can be surprising.
    // We're going to try aligning closer to the browser behavior by not bubbling
    // them in React either. We'll start by not bubbling onScroll, and then expand.
    var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
    // nonDelegatedEvents list in DOMPluginEventSystem.
    // Then we can remove this special list.
    // This is a breaking change that can wait until React 18.
    domEventName === 'scroll';

    var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);

    if (_listeners.length > 0) {
      // Intentionally create event lazily.
      var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);

      dispatchQueue.push({
        event: _event,
        listeners: _listeners
      });
    }
  }
}

// TODO: remove top-level side effect.
registerSimpleEvents();
registerEvents$2();
registerEvents$1();
registerEvents$3();
registerEvents();

function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  // TODO: we should remove the concept of a "SimpleEventPlugin".
  // This is the basic functionality of the event system. All
  // the other plugins are essentially polyfills. So the plugin
  // should probably be inlined somewhere and have its logic
  // be core the to event system. This would potentially allow
  // us to ship builds of React without the polyfilled plugins below.
  extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
  var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
  // event's native "bubble" phase, which means that we're
  // not in the capture phase. That's because we emulate
  // the capture phase here still. This is a trade-off,
  // because in an ideal world we would not emulate and use
  // the phases properly, like we do with the SimpleEvent
  // plugin. However, the plugins below either expect
  // emulation (EnterLeave) or use state localized to that
  // plugin (BeforeInput, Change, Select). The state in
  // these modules complicates things, as you'll essentially
  // get the case where the capture phase event might change
  // state, only for the following bubble event to come in
  // later and not trigger anything as the state now
  // invalidates the heuristics of the event plugin. We
  // could alter all these plugins to work in such ways, but
  // that might cause other unknown side-effects that we
  // can't forsee right now.

  if (shouldProcessPolyfillPlugins) {
    extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
    extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
  }
} // List of events that need to be individually attached to media elements.


var mediaEventTypes = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'encrypted', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'pause', 'play', 'playing', 'progress', 'ratechange', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting']; // We should not delegate these events to the container, but rather
// set them on the actual target element itself. This is primarily
// because these events do not consistently bubble in the DOM.

var nonDelegatedEvents = new Set(['cancel', 'close', 'invalid', 'load', 'scroll', 'toggle'].concat(mediaEventTypes));

function executeDispatch(event, listener, currentTarget) {
  var type = event.type || 'unknown-event';
  event.currentTarget = currentTarget;
  invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
  event.currentTarget = null;
}

function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
  var previousInstance;

  if (inCapturePhase) {
    for (var i = dispatchListeners.length - 1; i >= 0; i--) {
      var _dispatchListeners$i = dispatchListeners[i],
          instance = _dispatchListeners$i.instance,
          currentTarget = _dispatchListeners$i.currentTarget,
          listener = _dispatchListeners$i.listener;

      if (instance !== previousInstance && event.isPropagationStopped()) {
        return;
      }

      executeDispatch(event, listener, currentTarget);
      previousInstance = instance;
    }
  } else {
    for (var _i = 0; _i < dispatchListeners.length; _i++) {
      var _dispatchListeners$_i = dispatchListeners[_i],
          _instance = _dispatchListeners$_i.instance,
          _currentTarget = _dispatchListeners$_i.currentTarget,
          _listener = _dispatchListeners$_i.listener;

      if (_instance !== previousInstance && event.isPropagationStopped()) {
        return;
      }

      executeDispatch(event, _listener, _currentTarget);
      previousInstance = _instance;
    }
  }
}

function processDispatchQueue(dispatchQueue, eventSystemFlags) {
  var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;

  for (var i = 0; i < dispatchQueue.length; i++) {
    var _dispatchQueue$i = dispatchQueue[i],
        event = _dispatchQueue$i.event,
        listeners = _dispatchQueue$i.listeners;
    processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
  } // This would be a good time to rethrow if any of the event handlers threw.


  rethrowCaughtError();
}

function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
  var nativeEventTarget = getEventTarget(nativeEvent);
  var dispatchQueue = [];
  extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
  processDispatchQueue(dispatchQueue, eventSystemFlags);
}

function listenToNonDelegatedEvent(domEventName, targetElement) {
  var isCapturePhaseListener = false;
  var listenerSet = getEventListenerSet(targetElement);
  var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);

  if (!listenerSet.has(listenerSetKey)) {
    addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
    listenerSet.add(listenerSetKey);
  }
}
var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
  {
    if (rootContainerElement[listeningMarker]) {
      // Performance optimization: don't iterate through events
      // for the same portal container or root node more than once.
      // TODO: once we remove the flag, we may be able to also
      // remove some of the bookkeeping maps used for laziness.
      return;
    }

    rootContainerElement[listeningMarker] = true;
    allNativeEvents.forEach(function (domEventName) {
      if (!nonDelegatedEvents.has(domEventName)) {
        listenToNativeEvent(domEventName, false, rootContainerElement, null);
      }

      listenToNativeEvent(domEventName, true, rootContainerElement, null);
    });
  }
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, rootContainerElement, targetElement) {
  var eventSystemFlags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var target = rootContainerElement; // selectionchange needs to be attached to the document
  // otherwise it won't capture incoming events that are only
  // triggered on the document directly.

  if (domEventName === 'selectionchange' && rootContainerElement.nodeType !== DOCUMENT_NODE) {
    target = rootContainerElement.ownerDocument;
  } // If the event can be delegated (or is capture phase), we can
  // register it to the root container. Otherwise, we should
  // register the event to the target element and mark it as
  // a non-delegated event.


  if (targetElement !== null && !isCapturePhaseListener && nonDelegatedEvents.has(domEventName)) {
    // For all non-delegated events, apart from scroll, we attach
    // their event listeners to the respective elements that their
    // events fire on. That means we can skip this step, as event
    // listener has already been added previously. However, we
    // special case the scroll event because the reality is that any
    // element can scroll.
    // TODO: ideally, we'd eventually apply the same logic to all
    // events from the nonDelegatedEvents list. Then we can remove
    // this special case and use the same logic for all events.
    if (domEventName !== 'scroll') {
      return;
    }

    eventSystemFlags |= IS_NON_DELEGATED;
    target = targetElement;
  }

  var listenerSet = getEventListenerSet(target);
  var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener); // If the listener entry is empty or we should upgrade, then
  // we need to trap an event listener onto the target.

  if (!listenerSet.has(listenerSetKey)) {
    if (isCapturePhaseListener) {
      eventSystemFlags |= IS_CAPTURE_PHASE;
    }

    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    listenerSet.add(listenerSetKey);
  }
}

function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
  var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
  // active and not passive.

  var isPassiveListener = undefined;

  if (passiveBrowserEventsSupported) {
    // Browsers introduced an intervention, making these events
    // passive by default on document. React doesn't bind them
    // to document anymore, but changing this now would undo
    // the performance wins from the change. So we emulate
    // the existing behavior manually on the roots now.
    // https://github.com/facebook/react/issues/19651
    if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') {
      isPassiveListener = true;
    }
  }

  targetContainer =  targetContainer;
  var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we


  if (isCapturePhaseListener) {
    if (isPassiveListener !== undefined) {
      unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
    } else {
      unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
    }
  } else {
    if (isPassiveListener !== undefined) {
      unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
    } else {
      unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
  }
}

function isMatchingRootContainer(grandContainer, targetContainer) {
  return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
}

function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
  var ancestorInst = targetInst;

  if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
    var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we

    if (targetInst !== null) {
      // The below logic attempts to work out if we need to change
      // the target fiber to a different ancestor. We had similar logic
      // in the legacy event system, except the big difference between
      // systems is that the modern event system now has an event listener
      // attached to each React Root and React Portal Root. Together,
      // the DOM nodes representing these roots are the "rootContainer".
      // To figure out which ancestor instance we should use, we traverse
      // up the fiber tree from the target instance and attempt to find
      // root boundaries that match that of our current "rootContainer".
      // If we find that "rootContainer", we find the parent fiber
      // sub-tree for that root and make that our ancestor instance.
      var node = targetInst;

      mainLoop: while (true) {
        if (node === null) {
          return;
        }

        var nodeTag = node.tag;

        if (nodeTag === HostRoot || nodeTag === HostPortal) {
          var container = node.stateNode.containerInfo;

          if (isMatchingRootContainer(container, targetContainerNode)) {
            break;
          }

          if (nodeTag === HostPortal) {
            // The target is a portal, but it's not the rootContainer we're looking for.
            // Normally portals handle their own events all the way down to the root.
            // So we should be able to stop now. However, we don't know if this portal
            // was part of *our* root.
            var grandNode = node.return;

            while (grandNode !== null) {
              var grandTag = grandNode.tag;

              if (grandTag === HostRoot || grandTag === HostPortal) {
                var grandContainer = grandNode.stateNode.containerInfo;

                if (isMatchingRootContainer(grandContainer, targetContainerNode)) {
                  // This is the rootContainer we're looking for and we found it as
                  // a parent of the Portal. That means we can ignore it because the
                  // Portal will bubble through to us.
                  return;
                }
              }

              grandNode = grandNode.return;
            }
          } // Now we need to find it's corresponding host fiber in the other
          // tree. To do this we can use getClosestInstanceFromNode, but we
          // need to validate that the fiber is a host instance, otherwise
          // we need to traverse up through the DOM till we find the correct
          // node that is from the other tree.


          while (container !== null) {
            var parentNode = getClosestInstanceFromNode(container);

            if (parentNode === null) {
              return;
            }

            var parentTag = parentNode.tag;

            if (parentTag === HostComponent || parentTag === HostText) {
              node = ancestorInst = parentNode;
              continue mainLoop;
            }

            container = container.parentNode;
          }
        }

        node = node.return;
      }
    }
  }

  batchedEventUpdates(function () {
    return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
  });
}

function createDispatchListener(instance, listener, currentTarget) {
  return {
    instance: instance,
    listener: listener,
    currentTarget: currentTarget
  };
}

function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly) {
  var captureName = reactName !== null ? reactName + 'Capture' : null;
  var reactEventName = inCapturePhase ? captureName : reactName;
  var listeners = [];
  var instance = targetFiber;
  var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.

  while (instance !== null) {
    var _instance2 = instance,
        stateNode = _instance2.stateNode,
        tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)

    if (tag === HostComponent && stateNode !== null) {
      lastHostComponent = stateNode; // createEventHandle listeners


      if (reactEventName !== null) {
        var listener = getListener(instance, reactEventName);

        if (listener != null) {
          listeners.push(createDispatchListener(instance, listener, lastHostComponent));
        }
      }
    } // If we are only accumulating events for the target, then we don't
    // continue to propagate through the React fiber tree to find other
    // listeners.


    if (accumulateTargetOnly) {
      break;
    }

    instance = instance.return;
  }

  return listeners;
} // We should only use this function for:
// - BeforeInputEventPlugin
// - ChangeEventPlugin
// - SelectEventPlugin
// This is because we only process these plugins
// in the bubble phase, so we need to accumulate two
// phase event listeners (via emulation).

function accumulateTwoPhaseListeners(targetFiber, reactName) {
  var captureName = reactName + 'Capture';
  var listeners = [];
  var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.

  while (instance !== null) {
    var _instance3 = instance,
        stateNode = _instance3.stateNode,
        tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)

    if (tag === HostComponent && stateNode !== null) {
      var currentTarget = stateNode;
      var captureListener = getListener(instance, captureName);

      if (captureListener != null) {
        listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
      }

      var bubbleListener = getListener(instance, reactName);

      if (bubbleListener != null) {
        listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
      }
    }

    instance = instance.return;
  }

  return listeners;
}

function getParent(inst) {
  if (inst === null) {
    return null;
  }

  do {
    inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
    // That is depending on if we want nested subtrees (layers) to bubble
    // events to their parent. We could also go through parentNode on the
    // host node but that wouldn't work for React Native and doesn't let us
    // do the portal feature.
  } while (inst && inst.tag !== HostComponent);

  if (inst) {
    return inst;
  }

  return null;
}
/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */


function getLowestCommonAncestor(instA, instB) {
  var nodeA = instA;
  var nodeB = instB;
  var depthA = 0;

  for (var tempA = nodeA; tempA; tempA = getParent(tempA)) {
    depthA++;
  }

  var depthB = 0;

  for (var tempB = nodeB; tempB; tempB = getParent(tempB)) {
    depthB++;
  } // If A is deeper, crawl up.


  while (depthA - depthB > 0) {
    nodeA = getParent(nodeA);
    depthA--;
  } // If B is deeper, crawl up.


  while (depthB - depthA > 0) {
    nodeB = getParent(nodeB);
    depthB--;
  } // Walk in lockstep until we find a match.


  var depth = depthA;

  while (depth--) {
    if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) {
      return nodeA;
    }

    nodeA = getParent(nodeA);
    nodeB = getParent(nodeB);
  }

  return null;
}

function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
  var registrationName = event._reactName;
  var listeners = [];
  var instance = target;

  while (instance !== null) {
    if (instance === common) {
      break;
    }

    var _instance4 = instance,
        alternate = _instance4.alternate,
        stateNode = _instance4.stateNode,
        tag = _instance4.tag;

    if (alternate !== null && alternate === common) {
      break;
    }

    if (tag === HostComponent && stateNode !== null) {
      var currentTarget = stateNode;

      if (inCapturePhase) {
        var captureListener = getListener(instance, registrationName);

        if (captureListener != null) {
          listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
        }
      } else if (!inCapturePhase) {
        var bubbleListener = getListener(instance, registrationName);

        if (bubbleListener != null) {
          listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
        }
      }
    }

    instance = instance.return;
  }

  if (listeners.length !== 0) {
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });
  }
} // We should only use this function for:
// - EnterLeaveEventPlugin
// This is because we only process this plugin
// in the bubble phase, so we need to accumulate two
// phase event listeners.


function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;

  if (from !== null) {
    accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
  }

  if (to !== null && enterEvent !== null) {
    accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
  }
}
function getListenerSetKey(domEventName, capture) {
  return domEventName + "__" + (capture ? 'capture' : 'bubble');
}

var didWarnInvalidHydration = false;
var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
var AUTOFOCUS = 'autoFocus';
var CHILDREN = 'children';
var STYLE = 'style';
var HTML$1 = '__html';
var HTML_NAMESPACE$1 = Namespaces.html;
var warnedUnknownTags;
var suppressHydrationWarning;
var validatePropertiesInDevelopment;
var warnForTextDifference;
var warnForPropDifference;
var warnForExtraAttributes;
var warnForInvalidEventListener;
var canDiffStyleForHydrationWarning;
var normalizeMarkupForTextOrAttribute;
var normalizeHTML;

{
  warnedUnknownTags = {
    // There are working polyfills for <dialog>. Let people use it.
    dialog: true,
    // Electron ships a custom <webview> tag to display external web content in
    // an isolated frame and process.
    // This tag is not present in non Electron environments such as JSDom which
    // is often used for testing purposes.
    // @see https://electronjs.org/docs/api/webview-tag
    webview: true
  };

  validatePropertiesInDevelopment = function (type, props) {
    validateProperties(type, props);
    validateProperties$1(type, props);
    validateProperties$2(type, props, {
      registrationNameDependencies: registrationNameDependencies,
      possibleRegistrationNames: possibleRegistrationNames
    });
  }; // IE 11 parses & normalizes the style attribute as opposed to other
  // browsers. It adds spaces and sorts the properties in some
  // non-alphabetical order. Handling that would require sorting CSS
  // properties in the client & server versions or applying
  // `expectedStyle` to a temporary DOM node to read its `style` attribute
  // normalized. Since it only affects IE, we're skipping style warnings
  // in that browser completely in favor of doing all that work.
  // See https://github.com/facebook/react/issues/11807


  canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
  // It also can turn \u0000 into \uFFFD inside attributes.
  // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
  // If we have a mismatch, it might be caused by that.
  // We will still patch up in this case but not fire the warning.

  var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
  var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;

  normalizeMarkupForTextOrAttribute = function (markup) {
    var markupString = typeof markup === 'string' ? markup : '' + markup;
    return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
  };

  warnForTextDifference = function (serverText, clientText) {
    if (didWarnInvalidHydration) {
      return;
    }

    var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
    var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);

    if (normalizedServerText === normalizedClientText) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
  };

  warnForPropDifference = function (propName, serverValue, clientValue) {
    if (didWarnInvalidHydration) {
      return;
    }

    var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
    var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);

    if (normalizedServerValue === normalizedClientValue) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
  };

  warnForExtraAttributes = function (attributeNames) {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;
    var names = [];
    attributeNames.forEach(function (name) {
      names.push(name);
    });

    error('Extra attributes from the server: %s', names);
  };

  warnForInvalidEventListener = function (registrationName, listener) {
    if (listener === false) {
      error('Expected `%s` listener to be a function, instead got `false`.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', registrationName, registrationName, registrationName);
    } else {
      error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
    }
  }; // Parse the HTML and read it back to normalize the HTML string so that it
  // can be used for comparison.


  normalizeHTML = function (parent, html) {
    // We could have created a separate document here to avoid
    // re-initializing custom elements if they exist. But this breaks
    // how <noscript> is being handled. So we use the same document.
    // See the discussion in https://github.com/facebook/react/pull/11157.
    var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
    testElement.innerHTML = html;
    return testElement.innerHTML;
  };
}

function getOwnerDocumentFromRootContainer(rootContainerElement) {
  return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
}

function noop() {}

function trapClickOnNonInteractiveElement(node) {
  // Mobile Safari does not fire properly bubble click events on
  // non-interactive elements, which means delegated click listeners do not
  // fire. The workaround for this bug involves attaching an empty click
  // listener on the target node.
  // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
  // Just set it using the onclick property so that we don't have to manage any
  // bookkeeping for it. Not sure if we need to clear it when the listener is
  // removed.
  // TODO: Only do this for the relevant Safaris maybe?
  node.onclick = noop;
}

function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
  for (var propKey in nextProps) {
    if (!nextProps.hasOwnProperty(propKey)) {
      continue;
    }

    var nextProp = nextProps[propKey];

    if (propKey === STYLE) {
      {
        if (nextProp) {
          // Freeze the next style object so that we can assume it won't be
          // mutated. We have already warned for this in the past.
          Object.freeze(nextProp);
        }
      } // Relies on `updateStylesByID` not mutating `styleUpdates`.


      setValueForStyles(domElement, nextProp);
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
      var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

      if (nextHtml != null) {
        setInnerHTML(domElement, nextHtml);
      }
    } else if (propKey === CHILDREN) {
      if (typeof nextProp === 'string') {
        // Avoid setting initial textContent when the text is empty. In IE11 setting
        // textContent on a <textarea> will cause the placeholder to not
        // show within the <textarea> until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        var canSetTextContent = tag !== 'textarea' || nextProp !== '';

        if (canSetTextContent) {
          setTextContent(domElement, nextProp);
        }
      } else if (typeof nextProp === 'number') {
        setTextContent(domElement, '' + nextProp);
      }
    } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ; else if (propKey === AUTOFOCUS) ; else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      if (nextProp != null) {
        if ( typeof nextProp !== 'function') {
          warnForInvalidEventListener(propKey, nextProp);
        }

        if (propKey === 'onScroll') {
          listenToNonDelegatedEvent('scroll', domElement);
        }
      }
    } else if (nextProp != null) {
      setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
    }
  }
}

function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
  // TODO: Handle wasCustomComponentTag
  for (var i = 0; i < updatePayload.length; i += 2) {
    var propKey = updatePayload[i];
    var propValue = updatePayload[i + 1];

    if (propKey === STYLE) {
      setValueForStyles(domElement, propValue);
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
      setInnerHTML(domElement, propValue);
    } else if (propKey === CHILDREN) {
      setTextContent(domElement, propValue);
    } else {
      setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
    }
  }
}

function createElement(type, props, rootContainerElement, parentNamespace) {
  var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
  // tags get no namespace.

  var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
  var domElement;
  var namespaceURI = parentNamespace;

  if (namespaceURI === HTML_NAMESPACE$1) {
    namespaceURI = getIntrinsicNamespace(type);
  }

  if (namespaceURI === HTML_NAMESPACE$1) {
    {
      isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
      // allow <SVG> or <mATH>.

      if (!isCustomComponentTag && type !== type.toLowerCase()) {
        error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type);
      }
    }

    if (type === 'script') {
      // Create the script via .innerHTML so its "parser-inserted" flag is
      // set to true and it does not execute
      var div = ownerDocument.createElement('div');

      div.innerHTML = '<script><' + '/script>'; // eslint-disable-line
      // This is guaranteed to yield a script element.

      var firstChild = div.firstChild;
      domElement = div.removeChild(firstChild);
    } else if (typeof props.is === 'string') {
      // $FlowIssue `createElement` should be updated for Web Components
      domElement = ownerDocument.createElement(type, {
        is: props.is
      });
    } else {
      // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
      // See discussion in https://github.com/facebook/react/pull/6896
      // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
      domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
      // attributes on `select`s needs to be added before `option`s are inserted.
      // This prevents:
      // - a bug where the `select` does not scroll to the correct option because singular
      //  `select` elements automatically pick the first item #13222
      // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
      // See https://github.com/facebook/react/issues/13222
      // and https://github.com/facebook/react/issues/14239

      if (type === 'select') {
        var node = domElement;

        if (props.multiple) {
          node.multiple = true;
        } else if (props.size) {
          // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
          // it is possible that no option is selected.
          //
          // This is only necessary when a select in "single selection mode".
          node.size = props.size;
        }
      }
    }
  } else {
    domElement = ownerDocument.createElementNS(namespaceURI, type);
  }

  {
    if (namespaceURI === HTML_NAMESPACE$1) {
      if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
        warnedUnknownTags[type] = true;

        error('The tag <%s> is unrecognized in this browser. ' + 'If you meant to render a React component, start its name with ' + 'an uppercase letter.', type);
      }
    }
  }

  return domElement;
}
function createTextNode(text, rootContainerElement) {
  return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
}
function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
  var isCustomComponentTag = isCustomComponent(tag, rawProps);

  {
    validatePropertiesInDevelopment(tag, rawProps);
  } // TODO: Make sure that we check isMounted before firing any of these events.


  var props;

  switch (tag) {
    case 'dialog':
      listenToNonDelegatedEvent('cancel', domElement);
      listenToNonDelegatedEvent('close', domElement);
      props = rawProps;
      break;

    case 'iframe':
    case 'object':
    case 'embed':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the load event.
      listenToNonDelegatedEvent('load', domElement);
      props = rawProps;
      break;

    case 'video':
    case 'audio':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for all the media events.
      for (var i = 0; i < mediaEventTypes.length; i++) {
        listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
      }

      props = rawProps;
      break;

    case 'source':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the error event.
      listenToNonDelegatedEvent('error', domElement);
      props = rawProps;
      break;

    case 'img':
    case 'image':
    case 'link':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for error and load events.
      listenToNonDelegatedEvent('error', domElement);
      listenToNonDelegatedEvent('load', domElement);
      props = rawProps;
      break;

    case 'details':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the toggle event.
      listenToNonDelegatedEvent('toggle', domElement);
      props = rawProps;
      break;

    case 'input':
      initWrapperState(domElement, rawProps);
      props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'option':
      validateProps(domElement, rawProps);
      props = getHostProps$1(domElement, rawProps);
      break;

    case 'select':
      initWrapperState$1(domElement, rawProps);
      props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'textarea':
      initWrapperState$2(domElement, rawProps);
      props = getHostProps$3(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    default:
      props = rawProps;
  }

  assertValidProps(tag, props);
  setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);

  switch (tag) {
    case 'input':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper(domElement, rawProps, false);
      break;

    case 'textarea':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper$3(domElement);
      break;

    case 'option':
      postMountWrapper$1(domElement, rawProps);
      break;

    case 'select':
      postMountWrapper$2(domElement, rawProps);
      break;

    default:
      if (typeof props.onClick === 'function') {
        // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(domElement);
      }

      break;
  }
} // Calculate the diff between the two objects.

function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
  {
    validatePropertiesInDevelopment(tag, nextRawProps);
  }

  var updatePayload = null;
  var lastProps;
  var nextProps;

  switch (tag) {
    case 'input':
      lastProps = getHostProps(domElement, lastRawProps);
      nextProps = getHostProps(domElement, nextRawProps);
      updatePayload = [];
      break;

    case 'option':
      lastProps = getHostProps$1(domElement, lastRawProps);
      nextProps = getHostProps$1(domElement, nextRawProps);
      updatePayload = [];
      break;

    case 'select':
      lastProps = getHostProps$2(domElement, lastRawProps);
      nextProps = getHostProps$2(domElement, nextRawProps);
      updatePayload = [];
      break;

    case 'textarea':
      lastProps = getHostProps$3(domElement, lastRawProps);
      nextProps = getHostProps$3(domElement, nextRawProps);
      updatePayload = [];
      break;

    default:
      lastProps = lastRawProps;
      nextProps = nextRawProps;

      if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') {
        // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(domElement);
      }

      break;
  }

  assertValidProps(tag, nextProps);
  var propKey;
  var styleName;
  var styleUpdates = null;

  for (propKey in lastProps) {
    if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
      continue;
    }

    if (propKey === STYLE) {
      var lastStyle = lastProps[propKey];

      for (styleName in lastStyle) {
        if (lastStyle.hasOwnProperty(styleName)) {
          if (!styleUpdates) {
            styleUpdates = {};
          }

          styleUpdates[styleName] = '';
        }
      }
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ; else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ; else if (propKey === AUTOFOCUS) ; else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      // This is a special case. If any listener updates we need to ensure
      // that the "current" fiber pointer gets updated so we need a commit
      // to update this element.
      if (!updatePayload) {
        updatePayload = [];
      }
    } else {
      // For all other deleted properties we add it to the queue. We use
      // the allowed property list in the commit phase instead.
      (updatePayload = updatePayload || []).push(propKey, null);
    }
  }

  for (propKey in nextProps) {
    var nextProp = nextProps[propKey];
    var lastProp = lastProps != null ? lastProps[propKey] : undefined;

    if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
      continue;
    }

    if (propKey === STYLE) {
      {
        if (nextProp) {
          // Freeze the next style object so that we can assume it won't be
          // mutated. We have already warned for this in the past.
          Object.freeze(nextProp);
        }
      }

      if (lastProp) {
        // Unset styles on `lastProp` but not on `nextProp`.
        for (styleName in lastProp) {
          if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
            if (!styleUpdates) {
              styleUpdates = {};
            }

            styleUpdates[styleName] = '';
          }
        } // Update styles that changed since `lastProp`.


        for (styleName in nextProp) {
          if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
            if (!styleUpdates) {
              styleUpdates = {};
            }

            styleUpdates[styleName] = nextProp[styleName];
          }
        }
      } else {
        // Relies on `updateStylesByID` not mutating `styleUpdates`.
        if (!styleUpdates) {
          if (!updatePayload) {
            updatePayload = [];
          }

          updatePayload.push(propKey, styleUpdates);
        }

        styleUpdates = nextProp;
      }
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
      var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
      var lastHtml = lastProp ? lastProp[HTML$1] : undefined;

      if (nextHtml != null) {
        if (lastHtml !== nextHtml) {
          (updatePayload = updatePayload || []).push(propKey, nextHtml);
        }
      }
    } else if (propKey === CHILDREN) {
      if (typeof nextProp === 'string' || typeof nextProp === 'number') {
        (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
      }
    } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ; else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      if (nextProp != null) {
        // We eagerly listen to this even though we haven't committed yet.
        if ( typeof nextProp !== 'function') {
          warnForInvalidEventListener(propKey, nextProp);
        }

        if (propKey === 'onScroll') {
          listenToNonDelegatedEvent('scroll', domElement);
        }
      }

      if (!updatePayload && lastProp !== nextProp) {
        // This is a special case. If any listener updates we need to ensure
        // that the "current" props pointer gets updated so we need a commit
        // to update this element.
        updatePayload = [];
      }
    } else if (typeof nextProp === 'object' && nextProp !== null && nextProp.$$typeof === REACT_OPAQUE_ID_TYPE) {
      // If we encounter useOpaqueReference's opaque object, this means we are hydrating.
      // In this case, call the opaque object's toString function which generates a new client
      // ID so client and server IDs match and throws to rerender.
      nextProp.toString();
    } else {
      // For any other property we always add it to the queue and then we
      // filter it out using the allowed property list during the commit.
      (updatePayload = updatePayload || []).push(propKey, nextProp);
    }
  }

  if (styleUpdates) {
    {
      validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
    }

    (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
  }

  return updatePayload;
} // Apply the diff.

function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
  // Update checked *before* name.
  // In the middle of an update, it is possible to have multiple checked.
  // When a checked radio tries to change name, browser makes another radio's checked false.
  if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) {
    updateChecked(domElement, nextRawProps);
  }

  var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
  var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.

  updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
  // changed.

  switch (tag) {
    case 'input':
      // Update the wrapper around inputs *after* updating props. This has to
      // happen after `updateDOMProperties`. Otherwise HTML5 input validations
      // raise warnings and prevent the new value from being assigned.
      updateWrapper(domElement, nextRawProps);
      break;

    case 'textarea':
      updateWrapper$1(domElement, nextRawProps);
      break;

    case 'select':
      // <select> value update needs to occur after <option> children
      // reconciliation
      postUpdateWrapper(domElement, nextRawProps);
      break;
  }
}

function getPossibleStandardName(propName) {
  {
    var lowerCasedName = propName.toLowerCase();

    if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
      return null;
    }

    return possibleStandardNames[lowerCasedName] || null;
  }
}

function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
  var isCustomComponentTag;
  var extraAttributeNames;

  {
    suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
    isCustomComponentTag = isCustomComponent(tag, rawProps);
    validatePropertiesInDevelopment(tag, rawProps);
  } // TODO: Make sure that we check isMounted before firing any of these events.


  switch (tag) {
    case 'dialog':
      listenToNonDelegatedEvent('cancel', domElement);
      listenToNonDelegatedEvent('close', domElement);
      break;

    case 'iframe':
    case 'object':
    case 'embed':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the load event.
      listenToNonDelegatedEvent('load', domElement);
      break;

    case 'video':
    case 'audio':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for all the media events.
      for (var i = 0; i < mediaEventTypes.length; i++) {
        listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
      }

      break;

    case 'source':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the error event.
      listenToNonDelegatedEvent('error', domElement);
      break;

    case 'img':
    case 'image':
    case 'link':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for error and load events.
      listenToNonDelegatedEvent('error', domElement);
      listenToNonDelegatedEvent('load', domElement);
      break;

    case 'details':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the toggle event.
      listenToNonDelegatedEvent('toggle', domElement);
      break;

    case 'input':
      initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'option':
      validateProps(domElement, rawProps);
      break;

    case 'select':
      initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'textarea':
      initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;
  }

  assertValidProps(tag, rawProps);

  {
    extraAttributeNames = new Set();
    var attributes = domElement.attributes;

    for (var _i = 0; _i < attributes.length; _i++) {
      var name = attributes[_i].name.toLowerCase();

      switch (name) {
        // Built-in SSR attribute is allowed
        case 'data-reactroot':
          break;
        // Controlled attributes are not validated
        // TODO: Only ignore them on controlled tags.

        case 'value':
          break;

        case 'checked':
          break;

        case 'selected':
          break;

        default:
          // Intentionally use the original name.
          // See discussion in https://github.com/facebook/react/pull/10676.
          extraAttributeNames.add(attributes[_i].name);
      }
    }
  }

  var updatePayload = null;

  for (var propKey in rawProps) {
    if (!rawProps.hasOwnProperty(propKey)) {
      continue;
    }

    var nextProp = rawProps[propKey];

    if (propKey === CHILDREN) {
      // For text content children we compare against textContent. This
      // might match additional HTML that is hidden when we read it using
      // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
      // satisfies our requirement. Our requirement is not to produce perfect
      // HTML and attributes. Ideally we should preserve structure but it's
      // ok not to if the visible content is still enough to indicate what
      // even listeners these nodes might be wired up to.
      // TODO: Warn if there is more than a single textNode as a child.
      // TODO: Should we use domElement.firstChild.nodeValue to compare?
      if (typeof nextProp === 'string') {
        if (domElement.textContent !== nextProp) {
          if ( !suppressHydrationWarning) {
            warnForTextDifference(domElement.textContent, nextProp);
          }

          updatePayload = [CHILDREN, nextProp];
        }
      } else if (typeof nextProp === 'number') {
        if (domElement.textContent !== '' + nextProp) {
          if ( !suppressHydrationWarning) {
            warnForTextDifference(domElement.textContent, nextProp);
          }

          updatePayload = [CHILDREN, '' + nextProp];
        }
      }
    } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      if (nextProp != null) {
        if ( typeof nextProp !== 'function') {
          warnForInvalidEventListener(propKey, nextProp);
        }

        if (propKey === 'onScroll') {
          listenToNonDelegatedEvent('scroll', domElement);
        }
      }
    } else if ( // Convince Flow we've calculated it (it's DEV-only in this method.)
    typeof isCustomComponentTag === 'boolean') {
      // Validate that the properties correspond to their expected values.
      var serverValue = void 0;
      var propertyInfo = getPropertyInfo(propKey);

      if (suppressHydrationWarning) ; else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
      // TODO: Only ignore them on controlled tags.
      propKey === 'value' || propKey === 'checked' || propKey === 'selected') ; else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
        var serverHTML = domElement.innerHTML;
        var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

        if (nextHtml != null) {
          var expectedHTML = normalizeHTML(domElement, nextHtml);

          if (expectedHTML !== serverHTML) {
            warnForPropDifference(propKey, serverHTML, expectedHTML);
          }
        }
      } else if (propKey === STYLE) {
        // $FlowFixMe - Should be inferred as not undefined.
        extraAttributeNames.delete(propKey);

        if (canDiffStyleForHydrationWarning) {
          var expectedStyle = createDangerousStringForStyles(nextProp);
          serverValue = domElement.getAttribute('style');

          if (expectedStyle !== serverValue) {
            warnForPropDifference(propKey, serverValue, expectedStyle);
          }
        }
      } else if (isCustomComponentTag) {
        // $FlowFixMe - Should be inferred as not undefined.
        extraAttributeNames.delete(propKey.toLowerCase());
        serverValue = getValueForAttribute(domElement, propKey, nextProp);

        if (nextProp !== serverValue) {
          warnForPropDifference(propKey, serverValue, nextProp);
        }
      } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
        var isMismatchDueToBadCasing = false;

        if (propertyInfo !== null) {
          // $FlowFixMe - Should be inferred as not undefined.
          extraAttributeNames.delete(propertyInfo.attributeName);
          serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
        } else {
          var ownNamespace = parentNamespace;

          if (ownNamespace === HTML_NAMESPACE$1) {
            ownNamespace = getIntrinsicNamespace(tag);
          }

          if (ownNamespace === HTML_NAMESPACE$1) {
            // $FlowFixMe - Should be inferred as not undefined.
            extraAttributeNames.delete(propKey.toLowerCase());
          } else {
            var standardName = getPossibleStandardName(propKey);

            if (standardName !== null && standardName !== propKey) {
              // If an SVG prop is supplied with bad casing, it will
              // be successfully parsed from HTML, but will produce a mismatch
              // (and would be incorrectly rendered on the client).
              // However, we already warn about bad casing elsewhere.
              // So we'll skip the misleading extra mismatch warning in this case.
              isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.

              extraAttributeNames.delete(standardName);
            } // $FlowFixMe - Should be inferred as not undefined.


            extraAttributeNames.delete(propKey);
          }

          serverValue = getValueForAttribute(domElement, propKey, nextProp);
        }

        if (nextProp !== serverValue && !isMismatchDueToBadCasing) {
          warnForPropDifference(propKey, serverValue, nextProp);
        }
      }
    }
  }

  {
    // $FlowFixMe - Should be inferred as not undefined.
    if (extraAttributeNames.size > 0 && !suppressHydrationWarning) {
      // $FlowFixMe - Should be inferred as not undefined.
      warnForExtraAttributes(extraAttributeNames);
    }
  }

  switch (tag) {
    case 'input':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper(domElement, rawProps, true);
      break;

    case 'textarea':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper$3(domElement);
      break;

    case 'select':
    case 'option':
      // For input and textarea we current always set the value property at
      // post mount to force it to diverge from attributes. However, for
      // option and select we don't quite do the same thing and select
      // is not resilient to the DOM state changing so we don't do that here.
      // TODO: Consider not doing this for input and textarea.
      break;

    default:
      if (typeof rawProps.onClick === 'function') {
        // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(domElement);
      }

      break;
  }

  return updatePayload;
}
function diffHydratedText(textNode, text) {
  var isDifferent = textNode.nodeValue !== text;
  return isDifferent;
}
function warnForUnmatchedText(textNode, text) {
  {
    warnForTextDifference(textNode.nodeValue, text);
  }
}
function warnForDeletedHydratableElement(parentNode, child) {
  {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
  }
}
function warnForDeletedHydratableText(parentNode, child) {
  {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
  }
}
function warnForInsertedHydratedElement(parentNode, tag, props) {
  {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
  }
}
function warnForInsertedHydratedText(parentNode, text) {
  {
    if (text === '') {
      // We expect to insert empty text nodes since they're not represented in
      // the HTML.
      // TODO: Remove this special case if we can just avoid inserting empty
      // text nodes.
      return;
    }

    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
  }
}
function restoreControlledState$3(domElement, tag, props) {
  switch (tag) {
    case 'input':
      restoreControlledState(domElement, props);
      return;

    case 'textarea':
      restoreControlledState$2(domElement, props);
      return;

    case 'select':
      restoreControlledState$1(domElement, props);
      return;
  }
}

var validateDOMNesting = function () {};

var updatedAncestorInfo = function () {};

{
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.
  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope

  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template', // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope

  var buttonScopeTags = inScopeTags.concat(['button']); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags

  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
  var emptyAncestorInfo = {
    current: null,
    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,
    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  updatedAncestorInfo = function (oldInfo, tag) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);

    var info = {
      tag: tag
    };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }

    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    } // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody


    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }

    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }

    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }

    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }

    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }

    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }

    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };
  /**
   * Returns whether
   */


  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';

      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but

      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr

      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody

      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup

      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable

      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead

      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element

      case 'html':
        return tag === 'head' || tag === 'body' || tag === 'frameset';

      case 'frameset':
        return tag === 'frame';

      case '#document':
        return tag === 'html';
    } // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody


    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frameset':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };
  /**
   * Returns whether
   */


  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  var didWarn$1 = {};

  validateDOMNesting = function (childTag, childText, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      if (childTag != null) {
        error('validateDOMNesting: when childText is passed, childTag should be null');
      }

      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var invalidParentOrAncestor = invalidParent || invalidAncestor;

    if (!invalidParentOrAncestor) {
      return;
    }

    var ancestorTag = invalidParentOrAncestor.tag;
    var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;

    if (didWarn$1[warnKey]) {
      return;
    }

    didWarn$1[warnKey] = true;
    var tagDisplayName = childTag;
    var whitespaceInfo = '';

    if (childTag === '#text') {
      if (/\S/.test(childText)) {
        tagDisplayName = 'Text nodes';
      } else {
        tagDisplayName = 'Whitespace text nodes';
        whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
      }
    } else {
      tagDisplayName = '<' + childTag + '>';
    }

    if (invalidParent) {
      var info = '';

      if (ancestorTag === 'table' && childTag === 'tr') {
        info += ' Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by ' + 'the browser.';
      }

      error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
    } else {
      error('validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>.', tagDisplayName, ancestorTag);
    }
  };
}

var SUPPRESS_HYDRATION_WARNING$1;

{
  SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
}

var SUSPENSE_START_DATA = '$';
var SUSPENSE_END_DATA = '/$';
var SUSPENSE_PENDING_START_DATA = '$?';
var SUSPENSE_FALLBACK_START_DATA = '$!';
var STYLE$1 = 'style';
var eventsEnabled = null;
var selectionInformation = null;

function shouldAutoFocusHostComponent(type, props) {
  switch (type) {
    case 'button':
    case 'input':
    case 'select':
    case 'textarea':
      return !!props.autoFocus;
  }

  return false;
}
function getRootHostContext(rootContainerInstance) {
  var type;
  var namespace;
  var nodeType = rootContainerInstance.nodeType;

  switch (nodeType) {
    case DOCUMENT_NODE:
    case DOCUMENT_FRAGMENT_NODE:
      {
        type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
        var root = rootContainerInstance.documentElement;
        namespace = root ? root.namespaceURI : getChildNamespace(null, '');
        break;
      }

    default:
      {
        var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
        var ownNamespace = container.namespaceURI || null;
        type = container.tagName;
        namespace = getChildNamespace(ownNamespace, type);
        break;
      }
  }

  {
    var validatedTag = type.toLowerCase();
    var ancestorInfo = updatedAncestorInfo(null, validatedTag);
    return {
      namespace: namespace,
      ancestorInfo: ancestorInfo
    };
  }
}
function getChildHostContext(parentHostContext, type, rootContainerInstance) {
  {
    var parentHostContextDev = parentHostContext;
    var namespace = getChildNamespace(parentHostContextDev.namespace, type);
    var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
    return {
      namespace: namespace,
      ancestorInfo: ancestorInfo
    };
  }
}
function getPublicInstance(instance) {
  return instance;
}
function prepareForCommit(containerInfo) {
  eventsEnabled = isEnabled();
  selectionInformation = getSelectionInformation();
  var activeInstance = null;

  setEnabled(false);
  return activeInstance;
}
function resetAfterCommit(containerInfo) {
  restoreSelection(selectionInformation);
  setEnabled(eventsEnabled);
  eventsEnabled = null;
  selectionInformation = null;
}
function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
  var parentNamespace;

  {
    // TODO: take namespace into account when validating.
    var hostContextDev = hostContext;
    validateDOMNesting(type, null, hostContextDev.ancestorInfo);

    if (typeof props.children === 'string' || typeof props.children === 'number') {
      var string = '' + props.children;
      var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
      validateDOMNesting(null, string, ownAncestorInfo);
    }

    parentNamespace = hostContextDev.namespace;
  }

  var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
  precacheFiberNode(internalInstanceHandle, domElement);
  updateFiberProps(domElement, props);
  return domElement;
}
function appendInitialChild(parentInstance, child) {
  parentInstance.appendChild(child);
}
function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
  setInitialProperties(domElement, type, props, rootContainerInstance);
  return shouldAutoFocusHostComponent(type, props);
}
function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
  {
    var hostContextDev = hostContext;

    if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
      var string = '' + newProps.children;
      var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
      validateDOMNesting(null, string, ownAncestorInfo);
    }
  }

  return diffProperties(domElement, type, oldProps, newProps);
}
function shouldSetTextContent(type, props) {
  return type === 'textarea' || type === 'option' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
}
function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
  {
    var hostContextDev = hostContext;
    validateDOMNesting(null, text, hostContextDev.ancestorInfo);
  }

  var textNode = createTextNode(text, rootContainerInstance);
  precacheFiberNode(internalInstanceHandle, textNode);
  return textNode;
}
// if a component just imports ReactDOM (e.g. for findDOMNode).
// Some environments might not have setTimeout or clearTimeout.

var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
var noTimeout = -1; // -------------------
function commitMount(domElement, type, newProps, internalInstanceHandle) {
  // Despite the naming that might imply otherwise, this method only
  // fires if there is an `Update` effect scheduled during mounting.
  // This happens if `finalizeInitialChildren` returns `true` (which it
  // does to implement the `autoFocus` attribute on the client). But
  // there are also other cases when this might happen (such as patching
  // up text content during hydration mismatch). So we'll check this again.
  if (shouldAutoFocusHostComponent(type, newProps)) {
    domElement.focus();
  }
}
function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
  // Update the props handle so that we know which props are the ones with
  // with current event handlers.
  updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.

  updateProperties(domElement, updatePayload, type, oldProps, newProps);
}
function resetTextContent(domElement) {
  setTextContent(domElement, '');
}
function commitTextUpdate(textInstance, oldText, newText) {
  textInstance.nodeValue = newText;
}
function appendChild(parentInstance, child) {
  parentInstance.appendChild(child);
}
function appendChildToContainer(container, child) {
  var parentNode;

  if (container.nodeType === COMMENT_NODE) {
    parentNode = container.parentNode;
    parentNode.insertBefore(child, container);
  } else {
    parentNode = container;
    parentNode.appendChild(child);
  } // This container might be used for a portal.
  // If something inside a portal is clicked, that click should bubble
  // through the React tree. However, on Mobile Safari the click would
  // never bubble through the *DOM* tree unless an ancestor with onclick
  // event exists. So we wouldn't see it and dispatch it.
  // This is why we ensure that non React root containers have inline onclick
  // defined.
  // https://github.com/facebook/react/issues/11918


  var reactRootContainer = container._reactRootContainer;

  if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) {
    // TODO: This cast may not be sound for SVG, MathML or custom elements.
    trapClickOnNonInteractiveElement(parentNode);
  }
}
function insertBefore(parentInstance, child, beforeChild) {
  parentInstance.insertBefore(child, beforeChild);
}
function insertInContainerBefore(container, child, beforeChild) {
  if (container.nodeType === COMMENT_NODE) {
    container.parentNode.insertBefore(child, beforeChild);
  } else {
    container.insertBefore(child, beforeChild);
  }
}

function removeChild(parentInstance, child) {
  parentInstance.removeChild(child);
}
function removeChildFromContainer(container, child) {
  if (container.nodeType === COMMENT_NODE) {
    container.parentNode.removeChild(child);
  } else {
    container.removeChild(child);
  }
}
function hideInstance(instance) {
  // TODO: Does this work for all element types? What about MathML? Should we
  // pass host context to this method?
  instance = instance;
  var style = instance.style;

  if (typeof style.setProperty === 'function') {
    style.setProperty('display', 'none', 'important');
  } else {
    style.display = 'none';
  }
}
function hideTextInstance(textInstance) {
  textInstance.nodeValue = '';
}
function unhideInstance(instance, props) {
  instance = instance;
  var styleProp = props[STYLE$1];
  var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
  instance.style.display = dangerousStyleValue('display', display);
}
function unhideTextInstance(textInstance, text) {
  textInstance.nodeValue = text;
}
function clearContainer(container) {
  if (container.nodeType === ELEMENT_NODE) {
    container.textContent = '';
  } else if (container.nodeType === DOCUMENT_NODE) {
    var body = container.body;

    if (body != null) {
      body.textContent = '';
    }
  }
} // -------------------
function canHydrateInstance(instance, type, props) {
  if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) {
    return null;
  } // This has now been refined to an element node.


  return instance;
}
function canHydrateTextInstance(instance, text) {
  if (text === '' || instance.nodeType !== TEXT_NODE) {
    // Empty strings are not parsed by HTML so there won't be a correct match here.
    return null;
  } // This has now been refined to a text node.


  return instance;
}
function isSuspenseInstancePending(instance) {
  return instance.data === SUSPENSE_PENDING_START_DATA;
}
function isSuspenseInstanceFallback(instance) {
  return instance.data === SUSPENSE_FALLBACK_START_DATA;
}

function getNextHydratable(node) {
  // Skip non-hydratable nodes.
  for (; node != null; node = node.nextSibling) {
    var nodeType = node.nodeType;

    if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) {
      break;
    }
  }

  return node;
}

function getNextHydratableSibling(instance) {
  return getNextHydratable(instance.nextSibling);
}
function getFirstHydratableChild(parentInstance) {
  return getNextHydratable(parentInstance.firstChild);
}
function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
  precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
  // get attached.

  updateFiberProps(instance, props);
  var parentNamespace;

  {
    var hostContextDev = hostContext;
    parentNamespace = hostContextDev.namespace;
  }

  return diffHydratedProperties(instance, type, props, parentNamespace);
}
function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
  precacheFiberNode(internalInstanceHandle, textInstance);
  return diffHydratedText(textInstance, text);
}
function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
  var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
  // There might be nested nodes so we need to keep track of how
  // deep we are and only break out when we're back on top.

  var depth = 0;

  while (node) {
    if (node.nodeType === COMMENT_NODE) {
      var data = node.data;

      if (data === SUSPENSE_END_DATA) {
        if (depth === 0) {
          return getNextHydratableSibling(node);
        } else {
          depth--;
        }
      } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
        depth++;
      }
    }

    node = node.nextSibling;
  } // TODO: Warn, we didn't find the end comment boundary.


  return null;
} // Returns the SuspenseInstance if this node is a direct child of a
// SuspenseInstance. I.e. if its previous sibling is a Comment with
// SUSPENSE_x_START_DATA. Otherwise, null.

function getParentSuspenseInstance(targetInstance) {
  var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
  // There might be nested nodes so we need to keep track of how
  // deep we are and only break out when we're back on top.

  var depth = 0;

  while (node) {
    if (node.nodeType === COMMENT_NODE) {
      var data = node.data;

      if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
        if (depth === 0) {
          return node;
        } else {
          depth--;
        }
      } else if (data === SUSPENSE_END_DATA) {
        depth++;
      }
    }

    node = node.previousSibling;
  }

  return null;
}
function commitHydratedContainer(container) {
  // Retry if any event replaying was blocked on this.
  retryIfBlockedOn(container);
}
function commitHydratedSuspenseInstance(suspenseInstance) {
  // Retry if any event replaying was blocked on this.
  retryIfBlockedOn(suspenseInstance);
}
function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
  {
    warnForUnmatchedText(textInstance, text);
  }
}
function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    warnForUnmatchedText(textInstance, text);
  }
}
function didNotHydrateContainerInstance(parentContainer, instance) {
  {
    if (instance.nodeType === ELEMENT_NODE) {
      warnForDeletedHydratableElement(parentContainer, instance);
    } else if (instance.nodeType === COMMENT_NODE) ; else {
      warnForDeletedHydratableText(parentContainer, instance);
    }
  }
}
function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    if (instance.nodeType === ELEMENT_NODE) {
      warnForDeletedHydratableElement(parentInstance, instance);
    } else if (instance.nodeType === COMMENT_NODE) ; else {
      warnForDeletedHydratableText(parentInstance, instance);
    }
  }
}
function didNotFindHydratableContainerInstance(parentContainer, type, props) {
  {
    warnForInsertedHydratedElement(parentContainer, type);
  }
}
function didNotFindHydratableContainerTextInstance(parentContainer, text) {
  {
    warnForInsertedHydratedText(parentContainer, text);
  }
}
function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    warnForInsertedHydratedElement(parentInstance, type);
  }
}
function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    warnForInsertedHydratedText(parentInstance, text);
  }
}
function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) ;
}
var clientId = 0;
function makeClientIdInDEV(warnOnAccessInDEV) {
  var id = 'r:' + (clientId++).toString(36);
  return {
    toString: function () {
      warnOnAccessInDEV();
      return id;
    },
    valueOf: function () {
      warnOnAccessInDEV();
      return id;
    }
  };
}
function isOpaqueHydratingObject(value) {
  return value !== null && typeof value === 'object' && value.$$typeof === REACT_OPAQUE_ID_TYPE;
}
function makeOpaqueHydratingObject(attemptToReadValue) {
  return {
    $$typeof: REACT_OPAQUE_ID_TYPE,
    toString: attemptToReadValue,
    valueOf: attemptToReadValue
  };
}
function preparePortalMount(portalInstance) {
  {
    listenToAllSupportedEvents(portalInstance);
  }
}

var randomKey = Math.random().toString(36).slice(2);
var internalInstanceKey = '__reactFiber$' + randomKey;
var internalPropsKey = '__reactProps$' + randomKey;
var internalContainerInstanceKey = '__reactContainer$' + randomKey;
var internalEventHandlersKey = '__reactEvents$' + randomKey;
function precacheFiberNode(hostInst, node) {
  node[internalInstanceKey] = hostInst;
}
function markContainerAsRoot(hostRoot, node) {
  node[internalContainerInstanceKey] = hostRoot;
}
function unmarkContainerAsRoot(node) {
  node[internalContainerInstanceKey] = null;
}
function isContainerMarkedAsRoot(node) {
  return !!node[internalContainerInstanceKey];
} // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
// If the target node is part of a hydrated or not yet rendered subtree, then
// this may also return a SuspenseComponent or HostRoot to indicate that.
// Conceptually the HostRoot fiber is a child of the Container node. So if you
// pass the Container node as the targetNode, you will not actually get the
// HostRoot back. To get to the HostRoot, you need to pass a child of it.
// The same thing applies to Suspense boundaries.

function getClosestInstanceFromNode(targetNode) {
  var targetInst = targetNode[internalInstanceKey];

  if (targetInst) {
    // Don't return HostRoot or SuspenseComponent here.
    return targetInst;
  } // If the direct event target isn't a React owned DOM node, we need to look
  // to see if one of its parents is a React owned DOM node.


  var parentNode = targetNode.parentNode;

  while (parentNode) {
    // We'll check if this is a container root that could include
    // React nodes in the future. We need to check this first because
    // if we're a child of a dehydrated container, we need to first
    // find that inner container before moving on to finding the parent
    // instance. Note that we don't check this field on  the targetNode
    // itself because the fibers are conceptually between the container
    // node and the first child. It isn't surrounding the container node.
    // If it's not a container, we check if it's an instance.
    targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];

    if (targetInst) {
      // Since this wasn't the direct target of the event, we might have
      // stepped past dehydrated DOM nodes to get here. However they could
      // also have been non-React nodes. We need to answer which one.
      // If we the instance doesn't have any children, then there can't be
      // a nested suspense boundary within it. So we can use this as a fast
      // bailout. Most of the time, when people add non-React children to
      // the tree, it is using a ref to a child-less DOM node.
      // Normally we'd only need to check one of the fibers because if it
      // has ever gone from having children to deleting them or vice versa
      // it would have deleted the dehydrated boundary nested inside already.
      // However, since the HostRoot starts out with an alternate it might
      // have one on the alternate so we need to check in case this was a
      // root.
      var alternate = targetInst.alternate;

      if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
        // Next we need to figure out if the node that skipped past is
        // nested within a dehydrated boundary and if so, which one.
        var suspenseInstance = getParentSuspenseInstance(targetNode);

        while (suspenseInstance !== null) {
          // We found a suspense instance. That means that we haven't
          // hydrated it yet. Even though we leave the comments in the
          // DOM after hydrating, and there are boundaries in the DOM
          // that could already be hydrated, we wouldn't have found them
          // through this pass since if the target is hydrated it would
          // have had an internalInstanceKey on it.
          // Let's get the fiber associated with the SuspenseComponent
          // as the deepest instance.
          var targetSuspenseInst = suspenseInstance[internalInstanceKey];

          if (targetSuspenseInst) {
            return targetSuspenseInst;
          } // If we don't find a Fiber on the comment, it might be because
          // we haven't gotten to hydrate it yet. There might still be a
          // parent boundary that hasn't above this one so we need to find
          // the outer most that is known.


          suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
          // host component also hasn't hydrated yet. We can return it
          // below since it will bail out on the isMounted check later.
        }
      }

      return targetInst;
    }

    targetNode = parentNode;
    parentNode = targetNode.parentNode;
  }

  return null;
}
/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */

function getInstanceFromNode(node) {
  var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];

  if (inst) {
    if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) {
      return inst;
    } else {
      return null;
    }
  }

  return null;
}
/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */

function getNodeFromInstance(inst) {
  if (inst.tag === HostComponent || inst.tag === HostText) {
    // In Fiber this, is just the state node right now. We assume it will be
    // a host component or host text.
    return inst.stateNode;
  } // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.


  {
    {
      throw Error( "getNodeFromInstance: Invalid argument." );
    }
  }
}
function getFiberCurrentPropsFromNode(node) {
  return node[internalPropsKey] || null;
}
function updateFiberProps(node, props) {
  node[internalPropsKey] = props;
}
function getEventListenerSet(node) {
  var elementListenerSet = node[internalEventHandlersKey];

  if (elementListenerSet === undefined) {
    elementListenerSet = node[internalEventHandlersKey] = new Set();
  }

  return elementListenerSet;
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var valueStack = [];
var fiberStack;

{
  fiberStack = [];
}

var index = -1;

function createCursor(defaultValue) {
  return {
    current: defaultValue
  };
}

function pop(cursor, fiber) {
  if (index < 0) {
    {
      error('Unexpected pop.');
    }

    return;
  }

  {
    if (fiber !== fiberStack[index]) {
      error('Unexpected Fiber popped.');
    }
  }

  cursor.current = valueStack[index];
  valueStack[index] = null;

  {
    fiberStack[index] = null;
  }

  index--;
}

function push(cursor, value, fiber) {
  index++;
  valueStack[index] = cursor.current;

  {
    fiberStack[index] = fiber;
  }

  cursor.current = value;
}

var warnedAboutMissingGetChildContext;

{
  warnedAboutMissingGetChildContext = {};
}

var emptyContextObject = {};

{
  Object.freeze(emptyContextObject);
} // A cursor to the current merged context object on the stack.


var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.

var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
// We use this to get access to the parent context after we have already
// pushed the next context provider, and now need to merge their contexts.

var previousContext = emptyContextObject;

function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
  {
    if (didPushOwnContextIfProvider && isContextProvider(Component)) {
      // If the fiber is a context provider itself, when we read its context
      // we may have already pushed its own child context on the stack. A context
      // provider should not "see" its own child context. Therefore we read the
      // previous (parent) context instead for a context provider.
      return previousContext;
    }

    return contextStackCursor.current;
  }
}

function cacheContext(workInProgress, unmaskedContext, maskedContext) {
  {
    var instance = workInProgress.stateNode;
    instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
    instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
  }
}

function getMaskedContext(workInProgress, unmaskedContext) {
  {
    var type = workInProgress.type;
    var contextTypes = type.contextTypes;

    if (!contextTypes) {
      return emptyContextObject;
    } // Avoid recreating masked context unless unmasked context has changed.
    // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
    // This may trigger infinite loops if componentWillReceiveProps calls setState.


    var instance = workInProgress.stateNode;

    if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
      return instance.__reactInternalMemoizedMaskedChildContext;
    }

    var context = {};

    for (var key in contextTypes) {
      context[key] = unmaskedContext[key];
    }

    {
      var name = getComponentName(type) || 'Unknown';
      checkPropTypes(contextTypes, context, 'context', name);
    } // Cache unmasked context so we can avoid recreating masked context unless necessary.
    // Context is created before the class component is instantiated so check for instance.


    if (instance) {
      cacheContext(workInProgress, unmaskedContext, context);
    }

    return context;
  }
}

function hasContextChanged() {
  {
    return didPerformWorkStackCursor.current;
  }
}

function isContextProvider(type) {
  {
    var childContextTypes = type.childContextTypes;
    return childContextTypes !== null && childContextTypes !== undefined;
  }
}

function popContext(fiber) {
  {
    pop(didPerformWorkStackCursor, fiber);
    pop(contextStackCursor, fiber);
  }
}

function popTopLevelContextObject(fiber) {
  {
    pop(didPerformWorkStackCursor, fiber);
    pop(contextStackCursor, fiber);
  }
}

function pushTopLevelContextObject(fiber, context, didChange) {
  {
    if (!(contextStackCursor.current === emptyContextObject)) {
      {
        throw Error( "Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    push(contextStackCursor, context, fiber);
    push(didPerformWorkStackCursor, didChange, fiber);
  }
}

function processChildContext(fiber, type, parentContext) {
  {
    var instance = fiber.stateNode;
    var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
    // It has only been added in Fiber to match the (unintentional) behavior in Stack.

    if (typeof instance.getChildContext !== 'function') {
      {
        var componentName = getComponentName(type) || 'Unknown';

        if (!warnedAboutMissingGetChildContext[componentName]) {
          warnedAboutMissingGetChildContext[componentName] = true;

          error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
        }
      }

      return parentContext;
    }

    var childContext = instance.getChildContext();

    for (var contextKey in childContext) {
      if (!(contextKey in childContextTypes)) {
        {
          throw Error( (getComponentName(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes." );
        }
      }
    }

    {
      var name = getComponentName(type) || 'Unknown';
      checkPropTypes(childContextTypes, childContext, 'child context', name);
    }

    return _assign({}, parentContext, childContext);
  }
}

function pushContextProvider(workInProgress) {
  {
    var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
    // If the instance does not exist yet, we will push null at first,
    // and replace it on the stack later when invalidating the context.

    var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
    // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.

    previousContext = contextStackCursor.current;
    push(contextStackCursor, memoizedMergedChildContext, workInProgress);
    push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
    return true;
  }
}

function invalidateContextProvider(workInProgress, type, didChange) {
  {
    var instance = workInProgress.stateNode;

    if (!instance) {
      {
        throw Error( "Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    if (didChange) {
      // Merge parent and own context.
      // Skip this if we're not updating due to sCU.
      // This avoids unnecessarily recomputing memoized values.
      var mergedContext = processChildContext(workInProgress, type, previousContext);
      instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
      // It is important to unwind the context in the reverse order.

      pop(didPerformWorkStackCursor, workInProgress);
      pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.

      push(contextStackCursor, mergedContext, workInProgress);
      push(didPerformWorkStackCursor, didChange, workInProgress);
    } else {
      pop(didPerformWorkStackCursor, workInProgress);
      push(didPerformWorkStackCursor, didChange, workInProgress);
    }
  }
}

function findCurrentUnmaskedContext(fiber) {
  {
    // Currently this is only used with renderSubtreeIntoContainer; not sure if it
    // makes sense elsewhere
    if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) {
      {
        throw Error( "Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    var node = fiber;

    do {
      switch (node.tag) {
        case HostRoot:
          return node.stateNode.context;

        case ClassComponent:
          {
            var Component = node.type;

            if (isContextProvider(Component)) {
              return node.stateNode.__reactInternalMemoizedMergedChildContext;
            }

            break;
          }
      }

      node = node.return;
    } while (node !== null);

    {
      {
        throw Error( "Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  }
}

var LegacyRoot = 0;
var BlockingRoot = 1;
var ConcurrentRoot = 2;

var rendererID = null;
var injectedHook = null;
var hasLoggedError = false;
var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
function injectInternals(internals) {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
    // No DevTools
    return false;
  }

  var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;

  if (hook.isDisabled) {
    // This isn't a real property on the hook, but it can be set to opt out
    // of DevTools integration and associated warnings and logs.
    // https://github.com/facebook/react/issues/3877
    return true;
  }

  if (!hook.supportsFiber) {
    {
      error('The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://reactjs.org/link/react-devtools');
    } // DevTools exists, even though it doesn't support Fiber.


    return true;
  }

  try {
    rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.

    injectedHook = hook;
  } catch (err) {
    // Catch all errors because it is unsafe to throw during initialization.
    {
      error('React instrumentation encountered an error: %s.', err);
    }
  } // DevTools exists


  return true;
}
function onScheduleRoot(root, children) {
  {
    if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') {
      try {
        injectedHook.onScheduleFiberRoot(rendererID, root, children);
      } catch (err) {
        if ( !hasLoggedError) {
          hasLoggedError = true;

          error('React instrumentation encountered an error: %s', err);
        }
      }
    }
  }
}
function onCommitRoot(root, priorityLevel) {
  if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') {
    try {
      var didError = (root.current.flags & DidCapture) === DidCapture;

      if (enableProfilerTimer) {
        injectedHook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
      } else {
        injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
      }
    } catch (err) {
      {
        if (!hasLoggedError) {
          hasLoggedError = true;

          error('React instrumentation encountered an error: %s', err);
        }
      }
    }
  }
}
function onCommitUnmount(fiber) {
  if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') {
    try {
      injectedHook.onCommitFiberUnmount(rendererID, fiber);
    } catch (err) {
      {
        if (!hasLoggedError) {
          hasLoggedError = true;

          error('React instrumentation encountered an error: %s', err);
        }
      }
    }
  }
}

var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority,
    Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback,
    Scheduler_cancelCallback = Scheduler.unstable_cancelCallback,
    Scheduler_shouldYield = Scheduler.unstable_shouldYield,
    Scheduler_requestPaint = Scheduler.unstable_requestPaint,
    Scheduler_now$1 = Scheduler.unstable_now,
    Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel,
    Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority,
    Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority,
    Scheduler_NormalPriority = Scheduler.unstable_NormalPriority,
    Scheduler_LowPriority = Scheduler.unstable_LowPriority,
    Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;

{
  // Provide explicit error message when production+profiling bundle of e.g.
  // react-dom is used with production (non-profiling) bundle of
  // scheduler/tracing
  if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) {
    {
      throw Error( "It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling" );
    }
  }
}

var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
// ascending numbers so we can compare them like numbers. They start at 90 to
// avoid clashing with Scheduler's priorities.

var ImmediatePriority$1 = 99;
var UserBlockingPriority$2 = 98;
var NormalPriority$1 = 97;
var LowPriority$1 = 96;
var IdlePriority$1 = 95; // NoPriority is the absence of priority. Also React-only.

var NoPriority$1 = 90;
var shouldYield = Scheduler_shouldYield;
var requestPaint = // Fall back gracefully if we're running an older version of Scheduler.
Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function () {};
var syncQueue = null;
var immediateQueueCallbackNode = null;
var isFlushingSyncQueue = false;
var initialTimeMs$1 = Scheduler_now$1(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
// This will be the case for modern browsers that support `performance.now`. In
// older browsers, Scheduler falls back to `Date.now`, which returns a Unix
// timestamp. In that case, subtract the module initialization time to simulate
// the behavior of performance.now and keep our times small enough to fit
// within 32 bits.
// TODO: Consider lifting this into Scheduler.

var now = initialTimeMs$1 < 10000 ? Scheduler_now$1 : function () {
  return Scheduler_now$1() - initialTimeMs$1;
};
function getCurrentPriorityLevel() {
  switch (Scheduler_getCurrentPriorityLevel()) {
    case Scheduler_ImmediatePriority:
      return ImmediatePriority$1;

    case Scheduler_UserBlockingPriority:
      return UserBlockingPriority$2;

    case Scheduler_NormalPriority:
      return NormalPriority$1;

    case Scheduler_LowPriority:
      return LowPriority$1;

    case Scheduler_IdlePriority:
      return IdlePriority$1;

    default:
      {
        {
          throw Error( "Unknown priority level." );
        }
      }

  }
}

function reactPriorityToSchedulerPriority(reactPriorityLevel) {
  switch (reactPriorityLevel) {
    case ImmediatePriority$1:
      return Scheduler_ImmediatePriority;

    case UserBlockingPriority$2:
      return Scheduler_UserBlockingPriority;

    case NormalPriority$1:
      return Scheduler_NormalPriority;

    case LowPriority$1:
      return Scheduler_LowPriority;

    case IdlePriority$1:
      return Scheduler_IdlePriority;

    default:
      {
        {
          throw Error( "Unknown priority level." );
        }
      }

  }
}

function runWithPriority$1(reactPriorityLevel, fn) {
  var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
  return Scheduler_runWithPriority(priorityLevel, fn);
}
function scheduleCallback(reactPriorityLevel, callback, options) {
  var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
  return Scheduler_scheduleCallback(priorityLevel, callback, options);
}
function scheduleSyncCallback(callback) {
  // Push this callback into an internal queue. We'll flush these either in
  // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
  if (syncQueue === null) {
    syncQueue = [callback]; // Flush the queue in the next tick, at the earliest.

    immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
  } else {
    // Push onto existing queue. Don't need to schedule a callback because
    // we already scheduled one when we created the queue.
    syncQueue.push(callback);
  }

  return fakeCallbackNode;
}
function cancelCallback(callbackNode) {
  if (callbackNode !== fakeCallbackNode) {
    Scheduler_cancelCallback(callbackNode);
  }
}
function flushSyncCallbackQueue() {
  if (immediateQueueCallbackNode !== null) {
    var node = immediateQueueCallbackNode;
    immediateQueueCallbackNode = null;
    Scheduler_cancelCallback(node);
  }

  flushSyncCallbackQueueImpl();
}

function flushSyncCallbackQueueImpl() {
  if (!isFlushingSyncQueue && syncQueue !== null) {
    // Prevent re-entrancy.
    isFlushingSyncQueue = true;
    var i = 0;

    {
      try {
        var _isSync2 = true;
        var _queue = syncQueue;
        runWithPriority$1(ImmediatePriority$1, function () {
          for (; i < _queue.length; i++) {
            var callback = _queue[i];

            do {
              callback = callback(_isSync2);
            } while (callback !== null);
          }
        });
        syncQueue = null;
      } catch (error) {
        // If something throws, leave the remaining callbacks on the queue.
        if (syncQueue !== null) {
          syncQueue = syncQueue.slice(i + 1);
        } // Resume flushing in the next tick


        Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
        throw error;
      } finally {
        isFlushingSyncQueue = false;
      }
    }
  }
}

// TODO: this is special because it gets imported during build.
var ReactVersion = '17.0.2';

var NoMode = 0;
var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
// tag instead

var BlockingMode = 2;
var ConcurrentMode = 4;
var ProfileMode = 8;
var DebugTracingMode = 16;

var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
var NoTransition = 0;
function requestCurrentTransition() {
  return ReactCurrentBatchConfig.transition;
}

var ReactStrictModeWarnings = {
  recordUnsafeLifecycleWarnings: function (fiber, instance) {},
  flushPendingUnsafeLifecycleWarnings: function () {},
  recordLegacyContextWarning: function (fiber, instance) {},
  flushLegacyContextWarning: function () {},
  discardPendingWarnings: function () {}
};

{
  var findStrictRoot = function (fiber) {
    var maybeStrictRoot = null;
    var node = fiber;

    while (node !== null) {
      if (node.mode & StrictMode) {
        maybeStrictRoot = node;
      }

      node = node.return;
    }

    return maybeStrictRoot;
  };

  var setToSortedString = function (set) {
    var array = [];
    set.forEach(function (value) {
      array.push(value);
    });
    return array.sort().join(', ');
  };

  var pendingComponentWillMountWarnings = [];
  var pendingUNSAFE_ComponentWillMountWarnings = [];
  var pendingComponentWillReceivePropsWarnings = [];
  var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
  var pendingComponentWillUpdateWarnings = [];
  var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.

  var didWarnAboutUnsafeLifecycles = new Set();

  ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
    // Dedup strategy: Warn once per component.
    if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
      return;
    }

    if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
    instance.componentWillMount.__suppressDeprecationWarning !== true) {
      pendingComponentWillMountWarnings.push(fiber);
    }

    if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') {
      pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
    }

    if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
      pendingComponentWillReceivePropsWarnings.push(fiber);
    }

    if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
      pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
    }

    if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
      pendingComponentWillUpdateWarnings.push(fiber);
    }

    if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') {
      pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    }
  };

  ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
    // We do an initial pass to gather component names
    var componentWillMountUniqueNames = new Set();

    if (pendingComponentWillMountWarnings.length > 0) {
      pendingComponentWillMountWarnings.forEach(function (fiber) {
        componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingComponentWillMountWarnings = [];
    }

    var UNSAFE_componentWillMountUniqueNames = new Set();

    if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
      pendingUNSAFE_ComponentWillMountWarnings.forEach(function (fiber) {
        UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingUNSAFE_ComponentWillMountWarnings = [];
    }

    var componentWillReceivePropsUniqueNames = new Set();

    if (pendingComponentWillReceivePropsWarnings.length > 0) {
      pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
        componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingComponentWillReceivePropsWarnings = [];
    }

    var UNSAFE_componentWillReceivePropsUniqueNames = new Set();

    if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
      pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function (fiber) {
        UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    }

    var componentWillUpdateUniqueNames = new Set();

    if (pendingComponentWillUpdateWarnings.length > 0) {
      pendingComponentWillUpdateWarnings.forEach(function (fiber) {
        componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingComponentWillUpdateWarnings = [];
    }

    var UNSAFE_componentWillUpdateUniqueNames = new Set();

    if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
      pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function (fiber) {
        UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingUNSAFE_ComponentWillUpdateWarnings = [];
    } // Finally, we flush all the warnings
    // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'


    if (UNSAFE_componentWillMountUniqueNames.size > 0) {
      var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);

      error('Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '\nPlease update the following components: %s', sortedNames);
    }

    if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
      var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);

      error('Using UNSAFE_componentWillReceiveProps in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, " + 'refactor your code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '\nPlease update the following components: %s', _sortedNames);
    }

    if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
      var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);

      error('Using UNSAFE_componentWillUpdate in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '\nPlease update the following components: %s', _sortedNames2);
    }

    if (componentWillMountUniqueNames.size > 0) {
      var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);

      warn('componentWillMount has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '* Rename componentWillMount to UNSAFE_componentWillMount to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames3);
    }

    if (componentWillReceivePropsUniqueNames.size > 0) {
      var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);

      warn('componentWillReceiveProps has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, refactor your " + 'code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames4);
    }

    if (componentWillUpdateUniqueNames.size > 0) {
      var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);

      warn('componentWillUpdate has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames5);
    }
  };

  var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.

  var didWarnAboutLegacyContext = new Set();

  ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
    var strictRoot = findStrictRoot(fiber);

    if (strictRoot === null) {
      error('Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');

      return;
    } // Dedup strategy: Warn once per component.


    if (didWarnAboutLegacyContext.has(fiber.type)) {
      return;
    }

    var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);

    if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
      if (warningsForRoot === undefined) {
        warningsForRoot = [];
        pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
      }

      warningsForRoot.push(fiber);
    }
  };

  ReactStrictModeWarnings.flushLegacyContextWarning = function () {
    pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
      if (fiberArray.length === 0) {
        return;
      }

      var firstFiber = fiberArray[0];
      var uniqueNames = new Set();
      fiberArray.forEach(function (fiber) {
        uniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutLegacyContext.add(fiber.type);
      });
      var sortedNames = setToSortedString(uniqueNames);

      try {
        setCurrentFiber(firstFiber);

        error('Legacy context API has been detected within a strict-mode tree.' + '\n\nThe old API will be supported in all 16.x releases, but applications ' + 'using it should migrate to the new version.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context', sortedNames);
      } finally {
        resetCurrentFiber();
      }
    });
  };

  ReactStrictModeWarnings.discardPendingWarnings = function () {
    pendingComponentWillMountWarnings = [];
    pendingUNSAFE_ComponentWillMountWarnings = [];
    pendingComponentWillReceivePropsWarnings = [];
    pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    pendingComponentWillUpdateWarnings = [];
    pendingUNSAFE_ComponentWillUpdateWarnings = [];
    pendingLegacyContextWarning = new Map();
  };
}

function resolveDefaultProps(Component, baseProps) {
  if (Component && Component.defaultProps) {
    // Resolve default props. Taken from ReactElement
    var props = _assign({}, baseProps);

    var defaultProps = Component.defaultProps;

    for (var propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }

    return props;
  }

  return baseProps;
}

// Max 31 bit integer. The max integer size in V8 for 32-bit systems.
// Math.pow(2, 30) - 1
// 0b111111111111111111111111111111
var MAX_SIGNED_31_BIT_INT = 1073741823;

var valueCursor = createCursor(null);
var rendererSigil;

{
  // Use this to detect multiple renderers using the same context
  rendererSigil = {};
}

var currentlyRenderingFiber = null;
var lastContextDependency = null;
var lastContextWithAllBitsObserved = null;
var isDisallowedContextReadInDEV = false;
function resetContextDependencies() {
  // This is called right before React yields execution, to ensure `readContext`
  // cannot be called outside the render phase.
  currentlyRenderingFiber = null;
  lastContextDependency = null;
  lastContextWithAllBitsObserved = null;

  {
    isDisallowedContextReadInDEV = false;
  }
}
function enterDisallowedContextReadInDEV() {
  {
    isDisallowedContextReadInDEV = true;
  }
}
function exitDisallowedContextReadInDEV() {
  {
    isDisallowedContextReadInDEV = false;
  }
}
function pushProvider(providerFiber, nextValue) {
  var context = providerFiber.type._context;

  {
    push(valueCursor, context._currentValue, providerFiber);
    context._currentValue = nextValue;

    {
      if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
        error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
      }

      context._currentRenderer = rendererSigil;
    }
  }
}
function popProvider(providerFiber) {
  var currentValue = valueCursor.current;
  pop(valueCursor, providerFiber);
  var context = providerFiber.type._context;

  {
    context._currentValue = currentValue;
  }
}
function calculateChangedBits(context, newValue, oldValue) {
  if (objectIs(oldValue, newValue)) {
    // No change
    return 0;
  } else {
    var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

    {
      if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) {
        error('calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
      }
    }

    return changedBits | 0;
  }
}
function scheduleWorkOnParentPath(parent, renderLanes) {
  // Update the child lanes of all the ancestors, including the alternates.
  var node = parent;

  while (node !== null) {
    var alternate = node.alternate;

    if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
      node.childLanes = mergeLanes(node.childLanes, renderLanes);

      if (alternate !== null) {
        alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
      }
    } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) {
      alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
    } else {
      // Neither alternate was updated, which means the rest of the
      // ancestor path already has sufficient priority.
      break;
    }

    node = node.return;
  }
}
function propagateContextChange(workInProgress, context, changedBits, renderLanes) {
  var fiber = workInProgress.child;

  if (fiber !== null) {
    // Set the return pointer of the child to the work-in-progress fiber.
    fiber.return = workInProgress;
  }

  while (fiber !== null) {
    var nextFiber = void 0; // Visit this fiber.

    var list = fiber.dependencies;

    if (list !== null) {
      nextFiber = fiber.child;
      var dependency = list.firstContext;

      while (dependency !== null) {
        // Check if the context matches.
        if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
          // Match! Schedule an update on this fiber.
          if (fiber.tag === ClassComponent) {
            // Schedule a force update on the work-in-progress.
            var update = createUpdate(NoTimestamp, pickArbitraryLane(renderLanes));
            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
            // update to the current fiber, too, which means it will persist even if
            // this render is thrown away. Since it's a race condition, not sure it's
            // worth fixing.

            enqueueUpdate(fiber, update);
          }

          fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
          var alternate = fiber.alternate;

          if (alternate !== null) {
            alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
          }

          scheduleWorkOnParentPath(fiber.return, renderLanes); // Mark the updated lanes on the list, too.

          list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
          // dependency list.

          break;
        }

        dependency = dependency.next;
      }
    } else if (fiber.tag === ContextProvider) {
      // Don't scan deeper if this is a matching provider
      nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
    } else {
      // Traverse down.
      nextFiber = fiber.child;
    }

    if (nextFiber !== null) {
      // Set the return pointer of the child to the work-in-progress fiber.
      nextFiber.return = fiber;
    } else {
      // No child. Traverse to next sibling.
      nextFiber = fiber;

      while (nextFiber !== null) {
        if (nextFiber === workInProgress) {
          // We're back to the root of this subtree. Exit.
          nextFiber = null;
          break;
        }

        var sibling = nextFiber.sibling;

        if (sibling !== null) {
          // Set the return pointer of the sibling to the work-in-progress fiber.
          sibling.return = nextFiber.return;
          nextFiber = sibling;
          break;
        } // No more siblings. Traverse up.


        nextFiber = nextFiber.return;
      }
    }

    fiber = nextFiber;
  }
}
function prepareToReadContext(workInProgress, renderLanes) {
  currentlyRenderingFiber = workInProgress;
  lastContextDependency = null;
  lastContextWithAllBitsObserved = null;
  var dependencies = workInProgress.dependencies;

  if (dependencies !== null) {
    var firstContext = dependencies.firstContext;

    if (firstContext !== null) {
      if (includesSomeLane(dependencies.lanes, renderLanes)) {
        // Context list has a pending update. Mark that this fiber performed work.
        markWorkInProgressReceivedUpdate();
      } // Reset the work-in-progress list


      dependencies.firstContext = null;
    }
  }
}
function readContext(context, observedBits) {
  {
    // This warning would fire if you read context inside a Hook like useMemo.
    // Unlike the class check below, it's not enforced in production for perf.
    if (isDisallowedContextReadInDEV) {
      error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
    }
  }

  if (lastContextWithAllBitsObserved === context) ; else if (observedBits === false || observedBits === 0) ; else {
    var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.

    if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
      // Observe all updates.
      lastContextWithAllBitsObserved = context;
      resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
    } else {
      resolvedObservedBits = observedBits;
    }

    var contextItem = {
      context: context,
      observedBits: resolvedObservedBits,
      next: null
    };

    if (lastContextDependency === null) {
      if (!(currentlyRenderingFiber !== null)) {
        {
          throw Error( "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()." );
        }
      } // This is the first dependency for this component. Create a new list.


      lastContextDependency = contextItem;
      currentlyRenderingFiber.dependencies = {
        lanes: NoLanes,
        firstContext: contextItem,
        responders: null
      };
    } else {
      // Append a new context item.
      lastContextDependency = lastContextDependency.next = contextItem;
    }
  }

  return  context._currentValue ;
}

var UpdateState = 0;
var ReplaceState = 1;
var ForceUpdate = 2;
var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
// It should only be read right after calling `processUpdateQueue`, via
// `checkHasForceUpdateAfterProcessing`.

var hasForceUpdate = false;
var didWarnUpdateInsideUpdate;
var currentlyProcessingQueue;

{
  didWarnUpdateInsideUpdate = false;
  currentlyProcessingQueue = null;
}

function initializeUpdateQueue(fiber) {
  var queue = {
    baseState: fiber.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: {
      pending: null
    },
    effects: null
  };
  fiber.updateQueue = queue;
}
function cloneUpdateQueue(current, workInProgress) {
  // Clone the update queue from current. Unless it's already a clone.
  var queue = workInProgress.updateQueue;
  var currentQueue = current.updateQueue;

  if (queue === currentQueue) {
    var clone = {
      baseState: currentQueue.baseState,
      firstBaseUpdate: currentQueue.firstBaseUpdate,
      lastBaseUpdate: currentQueue.lastBaseUpdate,
      shared: currentQueue.shared,
      effects: currentQueue.effects
    };
    workInProgress.updateQueue = clone;
  }
}
function createUpdate(eventTime, lane) {
  var update = {
    eventTime: eventTime,
    lane: lane,
    tag: UpdateState,
    payload: null,
    callback: null,
    next: null
  };
  return update;
}
function enqueueUpdate(fiber, update) {
  var updateQueue = fiber.updateQueue;

  if (updateQueue === null) {
    // Only occurs if the fiber has been unmounted.
    return;
  }

  var sharedQueue = updateQueue.shared;
  var pending = sharedQueue.pending;

  if (pending === null) {
    // This is the first update. Create a circular list.
    update.next = update;
  } else {
    update.next = pending.next;
    pending.next = update;
  }

  sharedQueue.pending = update;

  {
    if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
      error('An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');

      didWarnUpdateInsideUpdate = true;
    }
  }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
  // Captured updates are updates that are thrown by a child during the render
  // phase. They should be discarded if the render is aborted. Therefore,
  // we should only put them on the work-in-progress queue, not the current one.
  var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.

  var current = workInProgress.alternate;

  if (current !== null) {
    var currentQueue = current.updateQueue;

    if (queue === currentQueue) {
      // The work-in-progress queue is the same as current. This happens when
      // we bail out on a parent fiber that then captures an error thrown by
      // a child. Since we want to append the update only to the work-in
      // -progress queue, we need to clone the updates. We usually clone during
      // processUpdateQueue, but that didn't happen in this case because we
      // skipped over the parent when we bailed out.
      var newFirst = null;
      var newLast = null;
      var firstBaseUpdate = queue.firstBaseUpdate;

      if (firstBaseUpdate !== null) {
        // Loop through the updates and clone them.
        var update = firstBaseUpdate;

        do {
          var clone = {
            eventTime: update.eventTime,
            lane: update.lane,
            tag: update.tag,
            payload: update.payload,
            callback: update.callback,
            next: null
          };

          if (newLast === null) {
            newFirst = newLast = clone;
          } else {
            newLast.next = clone;
            newLast = clone;
          }

          update = update.next;
        } while (update !== null); // Append the captured update the end of the cloned list.


        if (newLast === null) {
          newFirst = newLast = capturedUpdate;
        } else {
          newLast.next = capturedUpdate;
          newLast = capturedUpdate;
        }
      } else {
        // There are no base updates.
        newFirst = newLast = capturedUpdate;
      }

      queue = {
        baseState: currentQueue.baseState,
        firstBaseUpdate: newFirst,
        lastBaseUpdate: newLast,
        shared: currentQueue.shared,
        effects: currentQueue.effects
      };
      workInProgress.updateQueue = queue;
      return;
    }
  } // Append the update to the end of the list.


  var lastBaseUpdate = queue.lastBaseUpdate;

  if (lastBaseUpdate === null) {
    queue.firstBaseUpdate = capturedUpdate;
  } else {
    lastBaseUpdate.next = capturedUpdate;
  }

  queue.lastBaseUpdate = capturedUpdate;
}

function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
  switch (update.tag) {
    case ReplaceState:
      {
        var payload = update.payload;

        if (typeof payload === 'function') {
          // Updater function
          {
            enterDisallowedContextReadInDEV();
          }

          var nextState = payload.call(instance, prevState, nextProps);

          {
            if ( workInProgress.mode & StrictMode) {
              disableLogs();

              try {
                payload.call(instance, prevState, nextProps);
              } finally {
                reenableLogs();
              }
            }

            exitDisallowedContextReadInDEV();
          }

          return nextState;
        } // State object


        return payload;
      }

    case CaptureUpdate:
      {
        workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
      }
    // Intentional fallthrough

    case UpdateState:
      {
        var _payload = update.payload;
        var partialState;

        if (typeof _payload === 'function') {
          // Updater function
          {
            enterDisallowedContextReadInDEV();
          }

          partialState = _payload.call(instance, prevState, nextProps);

          {
            if ( workInProgress.mode & StrictMode) {
              disableLogs();

              try {
                _payload.call(instance, prevState, nextProps);
              } finally {
                reenableLogs();
              }
            }

            exitDisallowedContextReadInDEV();
          }
        } else {
          // Partial state object
          partialState = _payload;
        }

        if (partialState === null || partialState === undefined) {
          // Null and undefined are treated as no-ops.
          return prevState;
        } // Merge the partial state and the previous state.


        return _assign({}, prevState, partialState);
      }

    case ForceUpdate:
      {
        hasForceUpdate = true;
        return prevState;
      }
  }

  return prevState;
}

function processUpdateQueue(workInProgress, props, instance, renderLanes) {
  // This is always non-null on a ClassComponent or HostRoot
  var queue = workInProgress.updateQueue;
  hasForceUpdate = false;

  {
    currentlyProcessingQueue = queue.shared;
  }

  var firstBaseUpdate = queue.firstBaseUpdate;
  var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.

  var pendingQueue = queue.shared.pending;

  if (pendingQueue !== null) {
    queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
    // and last so that it's non-circular.

    var lastPendingUpdate = pendingQueue;
    var firstPendingUpdate = lastPendingUpdate.next;
    lastPendingUpdate.next = null; // Append pending updates to base queue

    if (lastBaseUpdate === null) {
      firstBaseUpdate = firstPendingUpdate;
    } else {
      lastBaseUpdate.next = firstPendingUpdate;
    }

    lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
    // we need to transfer the updates to that queue, too. Because the base
    // queue is a singly-linked list with no cycles, we can append to both
    // lists and take advantage of structural sharing.
    // TODO: Pass `current` as argument

    var current = workInProgress.alternate;

    if (current !== null) {
      // This is always non-null on a ClassComponent or HostRoot
      var currentQueue = current.updateQueue;
      var currentLastBaseUpdate = currentQueue.lastBaseUpdate;

      if (currentLastBaseUpdate !== lastBaseUpdate) {
        if (currentLastBaseUpdate === null) {
          currentQueue.firstBaseUpdate = firstPendingUpdate;
        } else {
          currentLastBaseUpdate.next = firstPendingUpdate;
        }

        currentQueue.lastBaseUpdate = lastPendingUpdate;
      }
    }
  } // These values may change as we process the queue.


  if (firstBaseUpdate !== null) {
    // Iterate through the list of updates to compute the result.
    var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
    // from the original lanes.

    var newLanes = NoLanes;
    var newBaseState = null;
    var newFirstBaseUpdate = null;
    var newLastBaseUpdate = null;
    var update = firstBaseUpdate;

    do {
      var updateLane = update.lane;
      var updateEventTime = update.eventTime;

      if (!isSubsetOfLanes(renderLanes, updateLane)) {
        // Priority is insufficient. Skip this update. If this is the first
        // skipped update, the previous update/state is the new base
        // update/state.
        var clone = {
          eventTime: updateEventTime,
          lane: updateLane,
          tag: update.tag,
          payload: update.payload,
          callback: update.callback,
          next: null
        };

        if (newLastBaseUpdate === null) {
          newFirstBaseUpdate = newLastBaseUpdate = clone;
          newBaseState = newState;
        } else {
          newLastBaseUpdate = newLastBaseUpdate.next = clone;
        } // Update the remaining priority in the queue.


        newLanes = mergeLanes(newLanes, updateLane);
      } else {
        // This update does have sufficient priority.
        if (newLastBaseUpdate !== null) {
          var _clone = {
            eventTime: updateEventTime,
            // This update is going to be committed so we never want uncommit
            // it. Using NoLane works because 0 is a subset of all bitmasks, so
            // this will never be skipped by the check above.
            lane: NoLane,
            tag: update.tag,
            payload: update.payload,
            callback: update.callback,
            next: null
          };
          newLastBaseUpdate = newLastBaseUpdate.next = _clone;
        } // Process this update.


        newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
        var callback = update.callback;

        if (callback !== null) {
          workInProgress.flags |= Callback;
          var effects = queue.effects;

          if (effects === null) {
            queue.effects = [update];
          } else {
            effects.push(update);
          }
        }
      }

      update = update.next;

      if (update === null) {
        pendingQueue = queue.shared.pending;

        if (pendingQueue === null) {
          break;
        } else {
          // An update was scheduled from inside a reducer. Add the new
          // pending updates to the end of the list and keep processing.
          var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
          // unravel them when transferring them to the base queue.

          var _firstPendingUpdate = _lastPendingUpdate.next;
          _lastPendingUpdate.next = null;
          update = _firstPendingUpdate;
          queue.lastBaseUpdate = _lastPendingUpdate;
          queue.shared.pending = null;
        }
      }
    } while (true);

    if (newLastBaseUpdate === null) {
      newBaseState = newState;
    }

    queue.baseState = newBaseState;
    queue.firstBaseUpdate = newFirstBaseUpdate;
    queue.lastBaseUpdate = newLastBaseUpdate; // Set the remaining expiration time to be whatever is remaining in the queue.
    // This should be fine because the only two other things that contribute to
    // expiration time are props and context. We're already in the middle of the
    // begin phase by the time we start processing the queue, so we've already
    // dealt with the props. Context in components that specify
    // shouldComponentUpdate is tricky; but we'll have to account for
    // that regardless.

    markSkippedUpdateLanes(newLanes);
    workInProgress.lanes = newLanes;
    workInProgress.memoizedState = newState;
  }

  {
    currentlyProcessingQueue = null;
  }
}

function callCallback(callback, context) {
  if (!(typeof callback === 'function')) {
    {
      throw Error( "Invalid argument passed as callback. Expected a function. Instead received: " + callback );
    }
  }

  callback.call(context);
}

function resetHasForceUpdateBeforeProcessing() {
  hasForceUpdate = false;
}
function checkHasForceUpdateAfterProcessing() {
  return hasForceUpdate;
}
function commitUpdateQueue(finishedWork, finishedQueue, instance) {
  // Commit the effects
  var effects = finishedQueue.effects;
  finishedQueue.effects = null;

  if (effects !== null) {
    for (var i = 0; i < effects.length; i++) {
      var effect = effects[i];
      var callback = effect.callback;

      if (callback !== null) {
        effect.callback = null;
        callCallback(callback, instance);
      }
    }
  }
}

var fakeInternalInstance = {};
var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
// We'll use it to determine whether we need to initialize legacy refs.

var emptyRefsObject = new React.Component().refs;
var didWarnAboutStateAssignmentForComponent;
var didWarnAboutUninitializedState;
var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
var didWarnAboutLegacyLifecyclesAndDerivedState;
var didWarnAboutUndefinedDerivedState;
var warnOnUndefinedDerivedState;
var warnOnInvalidCallback;
var didWarnAboutDirectlyAssigningPropsToState;
var didWarnAboutContextTypeAndContextTypes;
var didWarnAboutInvalidateContextType;

{
  didWarnAboutStateAssignmentForComponent = new Set();
  didWarnAboutUninitializedState = new Set();
  didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
  didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
  didWarnAboutDirectlyAssigningPropsToState = new Set();
  didWarnAboutUndefinedDerivedState = new Set();
  didWarnAboutContextTypeAndContextTypes = new Set();
  didWarnAboutInvalidateContextType = new Set();
  var didWarnOnInvalidCallback = new Set();

  warnOnInvalidCallback = function (callback, callerName) {
    if (callback === null || typeof callback === 'function') {
      return;
    }

    var key = callerName + '_' + callback;

    if (!didWarnOnInvalidCallback.has(key)) {
      didWarnOnInvalidCallback.add(key);

      error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
    }
  };

  warnOnUndefinedDerivedState = function (type, partialState) {
    if (partialState === undefined) {
      var componentName = getComponentName(type) || 'Component';

      if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
        didWarnAboutUndefinedDerivedState.add(componentName);

        error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
      }
    }
  }; // This is so gross but it's at least non-critical and can be removed if
  // it causes problems. This is meant to give a nicer error message for
  // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
  // ...)) which otherwise throws a "_processChildContext is not a function"
  // exception.


  Object.defineProperty(fakeInternalInstance, '_processChildContext', {
    enumerable: false,
    value: function () {
      {
        {
          throw Error( "_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal)." );
        }
      }
    }
  });
  Object.freeze(fakeInternalInstance);
}

function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
  var prevState = workInProgress.memoizedState;

  {
    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        // Invoke the function an extra time to help detect side-effects.
        getDerivedStateFromProps(nextProps, prevState);
      } finally {
        reenableLogs();
      }
    }
  }

  var partialState = getDerivedStateFromProps(nextProps, prevState);

  {
    warnOnUndefinedDerivedState(ctor, partialState);
  } // Merge the partial state and the previous state.


  var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
  workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
  // base state.

  if (workInProgress.lanes === NoLanes) {
    // Queue is always non-null for classes
    var updateQueue = workInProgress.updateQueue;
    updateQueue.baseState = memoizedState;
  }
}
var classComponentUpdater = {
  isMounted: isMounted,
  enqueueSetState: function (inst, payload, callback) {
    var fiber = get(inst);
    var eventTime = requestEventTime();
    var lane = requestUpdateLane(fiber);
    var update = createUpdate(eventTime, lane);
    update.payload = payload;

    if (callback !== undefined && callback !== null) {
      {
        warnOnInvalidCallback(callback, 'setState');
      }

      update.callback = callback;
    }

    enqueueUpdate(fiber, update);
    scheduleUpdateOnFiber(fiber, lane, eventTime);
  },
  enqueueReplaceState: function (inst, payload, callback) {
    var fiber = get(inst);
    var eventTime = requestEventTime();
    var lane = requestUpdateLane(fiber);
    var update = createUpdate(eventTime, lane);
    update.tag = ReplaceState;
    update.payload = payload;

    if (callback !== undefined && callback !== null) {
      {
        warnOnInvalidCallback(callback, 'replaceState');
      }

      update.callback = callback;
    }

    enqueueUpdate(fiber, update);
    scheduleUpdateOnFiber(fiber, lane, eventTime);
  },
  enqueueForceUpdate: function (inst, callback) {
    var fiber = get(inst);
    var eventTime = requestEventTime();
    var lane = requestUpdateLane(fiber);
    var update = createUpdate(eventTime, lane);
    update.tag = ForceUpdate;

    if (callback !== undefined && callback !== null) {
      {
        warnOnInvalidCallback(callback, 'forceUpdate');
      }

      update.callback = callback;
    }

    enqueueUpdate(fiber, update);
    scheduleUpdateOnFiber(fiber, lane, eventTime);
  }
};

function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
  var instance = workInProgress.stateNode;

  if (typeof instance.shouldComponentUpdate === 'function') {
    {
      if ( workInProgress.mode & StrictMode) {
        disableLogs();

        try {
          // Invoke the function an extra time to help detect side-effects.
          instance.shouldComponentUpdate(newProps, newState, nextContext);
        } finally {
          reenableLogs();
        }
      }
    }

    var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);

    {
      if (shouldUpdate === undefined) {
        error('%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentName(ctor) || 'Component');
      }
    }

    return shouldUpdate;
  }

  if (ctor.prototype && ctor.prototype.isPureReactComponent) {
    return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
  }

  return true;
}

function checkClassInstance(workInProgress, ctor, newProps) {
  var instance = workInProgress.stateNode;

  {
    var name = getComponentName(ctor) || 'Component';
    var renderPresent = instance.render;

    if (!renderPresent) {
      if (ctor.prototype && typeof ctor.prototype.render === 'function') {
        error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
      } else {
        error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
      }
    }

    if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
      error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
    }

    if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
    }

    if (instance.propTypes) {
      error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
    }

    if (instance.contextType) {
      error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
    }

    {
      if (instance.contextTypes) {
        error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
      }

      if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
        didWarnAboutContextTypeAndContextTypes.add(ctor);

        error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
      }
    }

    if (typeof instance.componentShouldUpdate === 'function') {
      error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
    }

    if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
      error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentName(ctor) || 'A pure component');
    }

    if (typeof instance.componentDidUnmount === 'function') {
      error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
    }

    if (typeof instance.componentDidReceiveProps === 'function') {
      error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
    }

    if (typeof instance.componentWillRecieveProps === 'function') {
      error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
    }

    if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
      error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
    }

    var hasMutatedProps = instance.props !== newProps;

    if (instance.props !== undefined && hasMutatedProps) {
      error('%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name);
    }

    if (instance.defaultProps) {
      error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
      didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);

      error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentName(ctor));
    }

    if (typeof instance.getDerivedStateFromProps === 'function') {
      error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
    }

    if (typeof instance.getDerivedStateFromError === 'function') {
      error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
    }

    if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
      error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
    }

    var _state = instance.state;

    if (_state && (typeof _state !== 'object' || isArray(_state))) {
      error('%s.state: must be set to an object or null', name);
    }

    if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
      error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
    }
  }
}

function adoptClassInstance(workInProgress, instance) {
  instance.updater = classComponentUpdater;
  workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates

  set(instance, workInProgress);

  {
    instance._reactInternalInstance = fakeInternalInstance;
  }
}

function constructClassInstance(workInProgress, ctor, props) {
  var isLegacyContextConsumer = false;
  var unmaskedContext = emptyContextObject;
  var context = emptyContextObject;
  var contextType = ctor.contextType;

  {
    if ('contextType' in ctor) {
      var isValid = // Allow null for conditional declaration
      contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>

      if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
        didWarnAboutInvalidateContextType.add(ctor);
        var addendum = '';

        if (contextType === undefined) {
          addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
        } else if (typeof contextType !== 'object') {
          addendum = ' However, it is set to a ' + typeof contextType + '.';
        } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
          addendum = ' Did you accidentally pass the Context.Provider instead?';
        } else if (contextType._context !== undefined) {
          // <Context.Consumer>
          addendum = ' Did you accidentally pass the Context.Consumer instead?';
        } else {
          addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
        }

        error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentName(ctor) || 'Component', addendum);
      }
    }
  }

  if (typeof contextType === 'object' && contextType !== null) {
    context = readContext(contextType);
  } else {
    unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    var contextTypes = ctor.contextTypes;
    isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
    context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
  } // Instantiate twice to help detect side-effects.


  {
    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        new ctor(props, context); // eslint-disable-line no-new
      } finally {
        reenableLogs();
      }
    }
  }

  var instance = new ctor(props, context);
  var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
  adoptClassInstance(workInProgress, instance);

  {
    if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
      var componentName = getComponentName(ctor) || 'Component';

      if (!didWarnAboutUninitializedState.has(componentName)) {
        didWarnAboutUninitializedState.add(componentName);

        error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
      }
    } // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Warn about these lifecycles if they are present.
    // Don't warn about react-lifecycles-compat polyfilled methods though.


    if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
      var foundWillMountName = null;
      var foundWillReceivePropsName = null;
      var foundWillUpdateName = null;

      if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
        foundWillMountName = 'componentWillMount';
      } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
        foundWillMountName = 'UNSAFE_componentWillMount';
      }

      if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
        foundWillReceivePropsName = 'componentWillReceiveProps';
      } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
        foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
      }

      if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
        foundWillUpdateName = 'componentWillUpdate';
      } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
        foundWillUpdateName = 'UNSAFE_componentWillUpdate';
      }

      if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var _componentName = getComponentName(ctor) || 'Component';

        var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

        if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
          didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);

          error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://reactjs.org/link/unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
        }
      }
    }
  } // Cache unmasked context so we can avoid recreating masked context unless necessary.
  // ReactFiberContext usually updates this cache but can't for newly-created instances.


  if (isLegacyContextConsumer) {
    cacheContext(workInProgress, unmaskedContext, context);
  }

  return instance;
}

function callComponentWillMount(workInProgress, instance) {
  var oldState = instance.state;

  if (typeof instance.componentWillMount === 'function') {
    instance.componentWillMount();
  }

  if (typeof instance.UNSAFE_componentWillMount === 'function') {
    instance.UNSAFE_componentWillMount();
  }

  if (oldState !== instance.state) {
    {
      error('%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentName(workInProgress.type) || 'Component');
    }

    classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
  }
}

function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
  var oldState = instance.state;

  if (typeof instance.componentWillReceiveProps === 'function') {
    instance.componentWillReceiveProps(newProps, nextContext);
  }

  if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
    instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
  }

  if (instance.state !== oldState) {
    {
      var componentName = getComponentName(workInProgress.type) || 'Component';

      if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
        didWarnAboutStateAssignmentForComponent.add(componentName);

        error('%s.componentWillReceiveProps(): Assigning directly to ' + "this.state is deprecated (except inside a component's " + 'constructor). Use setState instead.', componentName);
      }
    }

    classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
  }
} // Invokes the mount life-cycles on a previously never rendered instance.


function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
  {
    checkClassInstance(workInProgress, ctor, newProps);
  }

  var instance = workInProgress.stateNode;
  instance.props = newProps;
  instance.state = workInProgress.memoizedState;
  instance.refs = emptyRefsObject;
  initializeUpdateQueue(workInProgress);
  var contextType = ctor.contextType;

  if (typeof contextType === 'object' && contextType !== null) {
    instance.context = readContext(contextType);
  } else {
    var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    instance.context = getMaskedContext(workInProgress, unmaskedContext);
  }

  {
    if (instance.state === newProps) {
      var componentName = getComponentName(ctor) || 'Component';

      if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
        didWarnAboutDirectlyAssigningPropsToState.add(componentName);

        error('%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
      }
    }

    if (workInProgress.mode & StrictMode) {
      ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
    }

    {
      ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
    }
  }

  processUpdateQueue(workInProgress, newProps, instance, renderLanes);
  instance.state = workInProgress.memoizedState;
  var getDerivedStateFromProps = ctor.getDerivedStateFromProps;

  if (typeof getDerivedStateFromProps === 'function') {
    applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
    instance.state = workInProgress.memoizedState;
  } // In order to support react-lifecycles-compat polyfilled components,
  // Unsafe lifecycles should not be invoked for components using the new APIs.


  if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
    callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
    // process them now.

    processUpdateQueue(workInProgress, newProps, instance, renderLanes);
    instance.state = workInProgress.memoizedState;
  }

  if (typeof instance.componentDidMount === 'function') {
    workInProgress.flags |= Update;
  }
}

function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
  var instance = workInProgress.stateNode;
  var oldProps = workInProgress.memoizedProps;
  instance.props = oldProps;
  var oldContext = instance.context;
  var contextType = ctor.contextType;
  var nextContext = emptyContextObject;

  if (typeof contextType === 'object' && contextType !== null) {
    nextContext = readContext(contextType);
  } else {
    var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
  }

  var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
  var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
  // ever the previously attempted to render - not the "current". However,
  // during componentDidUpdate we pass the "current" props.
  // In order to support react-lifecycles-compat polyfilled components,
  // Unsafe lifecycles should not be invoked for components using the new APIs.

  if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
    if (oldProps !== newProps || oldContext !== nextContext) {
      callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
    }
  }

  resetHasForceUpdateBeforeProcessing();
  var oldState = workInProgress.memoizedState;
  var newState = instance.state = oldState;
  processUpdateQueue(workInProgress, newProps, instance, renderLanes);
  newState = workInProgress.memoizedState;

  if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidMount === 'function') {
      workInProgress.flags |= Update;
    }

    return false;
  }

  if (typeof getDerivedStateFromProps === 'function') {
    applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
    newState = workInProgress.memoizedState;
  }

  var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

  if (shouldUpdate) {
    // In order to support react-lifecycles-compat polyfilled components,
    // Unsafe lifecycles should not be invoked for components using the new APIs.
    if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
      if (typeof instance.componentWillMount === 'function') {
        instance.componentWillMount();
      }

      if (typeof instance.UNSAFE_componentWillMount === 'function') {
        instance.UNSAFE_componentWillMount();
      }
    }

    if (typeof instance.componentDidMount === 'function') {
      workInProgress.flags |= Update;
    }
  } else {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidMount === 'function') {
      workInProgress.flags |= Update;
    } // If shouldComponentUpdate returned false, we should still update the
    // memoized state to indicate that this work can be reused.


    workInProgress.memoizedProps = newProps;
    workInProgress.memoizedState = newState;
  } // Update the existing instance's state, props, and context pointers even
  // if shouldComponentUpdate returns false.


  instance.props = newProps;
  instance.state = newState;
  instance.context = nextContext;
  return shouldUpdate;
} // Invokes the update life-cycles and returns false if it shouldn't rerender.


function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
  var instance = workInProgress.stateNode;
  cloneUpdateQueue(current, workInProgress);
  var unresolvedOldProps = workInProgress.memoizedProps;
  var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
  instance.props = oldProps;
  var unresolvedNewProps = workInProgress.pendingProps;
  var oldContext = instance.context;
  var contextType = ctor.contextType;
  var nextContext = emptyContextObject;

  if (typeof contextType === 'object' && contextType !== null) {
    nextContext = readContext(contextType);
  } else {
    var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
  }

  var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
  var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
  // ever the previously attempted to render - not the "current". However,
  // during componentDidUpdate we pass the "current" props.
  // In order to support react-lifecycles-compat polyfilled components,
  // Unsafe lifecycles should not be invoked for components using the new APIs.

  if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
    if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) {
      callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
    }
  }

  resetHasForceUpdateBeforeProcessing();
  var oldState = workInProgress.memoizedState;
  var newState = instance.state = oldState;
  processUpdateQueue(workInProgress, newProps, instance, renderLanes);
  newState = workInProgress.memoizedState;

  if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Update;
      }
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Snapshot;
      }
    }

    return false;
  }

  if (typeof getDerivedStateFromProps === 'function') {
    applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
    newState = workInProgress.memoizedState;
  }

  var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

  if (shouldUpdate) {
    // In order to support react-lifecycles-compat polyfilled components,
    // Unsafe lifecycles should not be invoked for components using the new APIs.
    if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
      if (typeof instance.componentWillUpdate === 'function') {
        instance.componentWillUpdate(newProps, newState, nextContext);
      }

      if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
        instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
      }
    }

    if (typeof instance.componentDidUpdate === 'function') {
      workInProgress.flags |= Update;
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function') {
      workInProgress.flags |= Snapshot;
    }
  } else {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Update;
      }
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Snapshot;
      }
    } // If shouldComponentUpdate returned false, we should still update the
    // memoized props/state to indicate that this work can be reused.


    workInProgress.memoizedProps = newProps;
    workInProgress.memoizedState = newState;
  } // Update the existing instance's state, props, and context pointers even
  // if shouldComponentUpdate returns false.


  instance.props = newProps;
  instance.state = newState;
  instance.context = nextContext;
  return shouldUpdate;
}

var didWarnAboutMaps;
var didWarnAboutGenerators;
var didWarnAboutStringRefs;
var ownerHasKeyUseWarning;
var ownerHasFunctionTypeWarning;

var warnForMissingKey = function (child, returnFiber) {};

{
  didWarnAboutMaps = false;
  didWarnAboutGenerators = false;
  didWarnAboutStringRefs = {};
  /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */

  ownerHasKeyUseWarning = {};
  ownerHasFunctionTypeWarning = {};

  warnForMissingKey = function (child, returnFiber) {
    if (child === null || typeof child !== 'object') {
      return;
    }

    if (!child._store || child._store.validated || child.key != null) {
      return;
    }

    if (!(typeof child._store === 'object')) {
      {
        throw Error( "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    child._store.validated = true;
    var componentName = getComponentName(returnFiber.type) || 'Component';

    if (ownerHasKeyUseWarning[componentName]) {
      return;
    }

    ownerHasKeyUseWarning[componentName] = true;

    error('Each child in a list should have a unique ' + '"key" prop. See https://reactjs.org/link/warning-keys for ' + 'more information.');
  };
}

var isArray$1 = Array.isArray;

function coerceRef(returnFiber, current, element) {
  var mixedRef = element.ref;

  if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
    {
      // TODO: Clean this up once we turn on the string ref warning for
      // everyone, because the strict mode case will no longer be relevant
      if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
      // because these cannot be automatically converted to an arrow function
      // using a codemod. Therefore, we don't have to warn about string refs again.
      !(element._owner && element._self && element._owner.stateNode !== element._self)) {
        var componentName = getComponentName(returnFiber.type) || 'Component';

        if (!didWarnAboutStringRefs[componentName]) {
          {
            error('A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', mixedRef);
          }

          didWarnAboutStringRefs[componentName] = true;
        }
      }
    }

    if (element._owner) {
      var owner = element._owner;
      var inst;

      if (owner) {
        var ownerFiber = owner;

        if (!(ownerFiber.tag === ClassComponent)) {
          {
            throw Error( "Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref" );
          }
        }

        inst = ownerFiber.stateNode;
      }

      if (!inst) {
        {
          throw Error( "Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue." );
        }
      }

      var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref

      if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) {
        return current.ref;
      }

      var ref = function (value) {
        var refs = inst.refs;

        if (refs === emptyRefsObject) {
          // This is a lazy pooled frozen object, so we need to initialize.
          refs = inst.refs = {};
        }

        if (value === null) {
          delete refs[stringRef];
        } else {
          refs[stringRef] = value;
        }
      };

      ref._stringRef = stringRef;
      return ref;
    } else {
      if (!(typeof mixedRef === 'string')) {
        {
          throw Error( "Expected ref to be a function, a string, an object returned by React.createRef(), or null." );
        }
      }

      if (!element._owner) {
        {
          throw Error( "Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information." );
        }
      }
    }
  }

  return mixedRef;
}

function throwOnInvalidObjectType(returnFiber, newChild) {
  if (returnFiber.type !== 'textarea') {
    {
      {
        throw Error( "Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + "). If you meant to render a collection of children, use an array instead." );
      }
    }
  }
}

function warnOnFunctionType(returnFiber) {
  {
    var componentName = getComponentName(returnFiber.type) || 'Component';

    if (ownerHasFunctionTypeWarning[componentName]) {
      return;
    }

    ownerHasFunctionTypeWarning[componentName] = true;

    error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
  }
} // We avoid inlining this to avoid potential deopts from using try/catch.
// to be able to optimize each path individually by branching early. This needs
// a compiler or we can do it manually. Helpers that don't need this branching
// live outside of this function.


function ChildReconciler(shouldTrackSideEffects) {
  function deleteChild(returnFiber, childToDelete) {
    if (!shouldTrackSideEffects) {
      // Noop.
      return;
    } // Deletions are added in reversed order so we add it to the front.
    // At this point, the return fiber's effect list is empty except for
    // deletions, so we can just append the deletion to the list. The remaining
    // effects aren't added until the complete phase. Once we implement
    // resuming, this may not be true.


    var last = returnFiber.lastEffect;

    if (last !== null) {
      last.nextEffect = childToDelete;
      returnFiber.lastEffect = childToDelete;
    } else {
      returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
    }

    childToDelete.nextEffect = null;
    childToDelete.flags = Deletion;
  }

  function deleteRemainingChildren(returnFiber, currentFirstChild) {
    if (!shouldTrackSideEffects) {
      // Noop.
      return null;
    } // TODO: For the shouldClone case, this could be micro-optimized a bit by
    // assuming that after the first child we've already added everything.


    var childToDelete = currentFirstChild;

    while (childToDelete !== null) {
      deleteChild(returnFiber, childToDelete);
      childToDelete = childToDelete.sibling;
    }

    return null;
  }

  function mapRemainingChildren(returnFiber, currentFirstChild) {
    // Add the remaining children to a temporary map so that we can find them by
    // keys quickly. Implicit (null) keys get added to this set with their index
    // instead.
    var existingChildren = new Map();
    var existingChild = currentFirstChild;

    while (existingChild !== null) {
      if (existingChild.key !== null) {
        existingChildren.set(existingChild.key, existingChild);
      } else {
        existingChildren.set(existingChild.index, existingChild);
      }

      existingChild = existingChild.sibling;
    }

    return existingChildren;
  }

  function useFiber(fiber, pendingProps) {
    // We currently set sibling to null and index to 0 here because it is easy
    // to forget to do before returning it. E.g. for the single child case.
    var clone = createWorkInProgress(fiber, pendingProps);
    clone.index = 0;
    clone.sibling = null;
    return clone;
  }

  function placeChild(newFiber, lastPlacedIndex, newIndex) {
    newFiber.index = newIndex;

    if (!shouldTrackSideEffects) {
      // Noop.
      return lastPlacedIndex;
    }

    var current = newFiber.alternate;

    if (current !== null) {
      var oldIndex = current.index;

      if (oldIndex < lastPlacedIndex) {
        // This is a move.
        newFiber.flags = Placement;
        return lastPlacedIndex;
      } else {
        // This item can stay in place.
        return oldIndex;
      }
    } else {
      // This is an insertion.
      newFiber.flags = Placement;
      return lastPlacedIndex;
    }
  }

  function placeSingleChild(newFiber) {
    // This is simpler for the single child case. We only need to do a
    // placement for inserting new children.
    if (shouldTrackSideEffects && newFiber.alternate === null) {
      newFiber.flags = Placement;
    }

    return newFiber;
  }

  function updateTextNode(returnFiber, current, textContent, lanes) {
    if (current === null || current.tag !== HostText) {
      // Insert
      var created = createFiberFromText(textContent, returnFiber.mode, lanes);
      created.return = returnFiber;
      return created;
    } else {
      // Update
      var existing = useFiber(current, textContent);
      existing.return = returnFiber;
      return existing;
    }
  }

  function updateElement(returnFiber, current, element, lanes) {
    if (current !== null) {
      if (current.elementType === element.type || ( // Keep this check inline so it only runs on the false path:
       isCompatibleFamilyForHotReloading(current, element) )) {
        // Move based on index
        var existing = useFiber(current, element.props);
        existing.ref = coerceRef(returnFiber, current, element);
        existing.return = returnFiber;

        {
          existing._debugSource = element._source;
          existing._debugOwner = element._owner;
        }

        return existing;
      }
    } // Insert


    var created = createFiberFromElement(element, returnFiber.mode, lanes);
    created.ref = coerceRef(returnFiber, current, element);
    created.return = returnFiber;
    return created;
  }

  function updatePortal(returnFiber, current, portal, lanes) {
    if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
      // Insert
      var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
      created.return = returnFiber;
      return created;
    } else {
      // Update
      var existing = useFiber(current, portal.children || []);
      existing.return = returnFiber;
      return existing;
    }
  }

  function updateFragment(returnFiber, current, fragment, lanes, key) {
    if (current === null || current.tag !== Fragment) {
      // Insert
      var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
      created.return = returnFiber;
      return created;
    } else {
      // Update
      var existing = useFiber(current, fragment);
      existing.return = returnFiber;
      return existing;
    }
  }

  function createChild(returnFiber, newChild, lanes) {
    if (typeof newChild === 'string' || typeof newChild === 'number') {
      // Text nodes don't have keys. If the previous node is implicitly keyed
      // we can continue to replace it without aborting even if it is not a text
      // node.
      var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
      created.return = returnFiber;
      return created;
    }

    if (typeof newChild === 'object' && newChild !== null) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          {
            var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);

            _created.ref = coerceRef(returnFiber, null, newChild);
            _created.return = returnFiber;
            return _created;
          }

        case REACT_PORTAL_TYPE:
          {
            var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);

            _created2.return = returnFiber;
            return _created2;
          }
      }

      if (isArray$1(newChild) || getIteratorFn(newChild)) {
        var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);

        _created3.return = returnFiber;
        return _created3;
      }

      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    return null;
  }

  function updateSlot(returnFiber, oldFiber, newChild, lanes) {
    // Update the fiber if the keys match, otherwise return null.
    var key = oldFiber !== null ? oldFiber.key : null;

    if (typeof newChild === 'string' || typeof newChild === 'number') {
      // Text nodes don't have keys. If the previous node is implicitly keyed
      // we can continue to replace it without aborting even if it is not a text
      // node.
      if (key !== null) {
        return null;
      }

      return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
    }

    if (typeof newChild === 'object' && newChild !== null) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          {
            if (newChild.key === key) {
              if (newChild.type === REACT_FRAGMENT_TYPE) {
                return updateFragment(returnFiber, oldFiber, newChild.props.children, lanes, key);
              }

              return updateElement(returnFiber, oldFiber, newChild, lanes);
            } else {
              return null;
            }
          }

        case REACT_PORTAL_TYPE:
          {
            if (newChild.key === key) {
              return updatePortal(returnFiber, oldFiber, newChild, lanes);
            } else {
              return null;
            }
          }
      }

      if (isArray$1(newChild) || getIteratorFn(newChild)) {
        if (key !== null) {
          return null;
        }

        return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
      }

      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    return null;
  }

  function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
    if (typeof newChild === 'string' || typeof newChild === 'number') {
      // Text nodes don't have keys, so we neither have to check the old nor
      // new node for the key. If both are text nodes, they match.
      var matchedFiber = existingChildren.get(newIdx) || null;
      return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
    }

    if (typeof newChild === 'object' && newChild !== null) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          {
            var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

            if (newChild.type === REACT_FRAGMENT_TYPE) {
              return updateFragment(returnFiber, _matchedFiber, newChild.props.children, lanes, newChild.key);
            }

            return updateElement(returnFiber, _matchedFiber, newChild, lanes);
          }

        case REACT_PORTAL_TYPE:
          {
            var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

            return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
          }

      }

      if (isArray$1(newChild) || getIteratorFn(newChild)) {
        var _matchedFiber3 = existingChildren.get(newIdx) || null;

        return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
      }

      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    return null;
  }
  /**
   * Warns if there is a duplicate or missing key
   */


  function warnOnInvalidKey(child, knownKeys, returnFiber) {
    {
      if (typeof child !== 'object' || child === null) {
        return knownKeys;
      }

      switch (child.$$typeof) {
        case REACT_ELEMENT_TYPE:
        case REACT_PORTAL_TYPE:
          warnForMissingKey(child, returnFiber);
          var key = child.key;

          if (typeof key !== 'string') {
            break;
          }

          if (knownKeys === null) {
            knownKeys = new Set();
            knownKeys.add(key);
            break;
          }

          if (!knownKeys.has(key)) {
            knownKeys.add(key);
            break;
          }

          error('Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted — the behavior is unsupported and ' + 'could change in a future version.', key);

          break;
      }
    }

    return knownKeys;
  }

  function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
    // This algorithm can't optimize by searching from both ends since we
    // don't have backpointers on fibers. I'm trying to see how far we can get
    // with that model. If it ends up not being worth the tradeoffs, we can
    // add it later.
    // Even with a two ended optimization, we'd want to optimize for the case
    // where there are few changes and brute force the comparison instead of
    // going for the Map. It'd like to explore hitting that path first in
    // forward-only mode and only go for the Map once we notice that we need
    // lots of look ahead. This doesn't handle reversal as well as two ended
    // search but that's unusual. Besides, for the two ended optimization to
    // work on Iterables, we'd need to copy the whole set.
    // In this first iteration, we'll just live with hitting the bad case
    // (adding everything to a Map) in for every insert/move.
    // If you change this code, also update reconcileChildrenIterator() which
    // uses the same algorithm.
    {
      // First, validate keys.
      var knownKeys = null;

      for (var i = 0; i < newChildren.length; i++) {
        var child = newChildren[i];
        knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
      }
    }

    var resultingFirstChild = null;
    var previousNewFiber = null;
    var oldFiber = currentFirstChild;
    var lastPlacedIndex = 0;
    var newIdx = 0;
    var nextOldFiber = null;

    for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
      if (oldFiber.index > newIdx) {
        nextOldFiber = oldFiber;
        oldFiber = null;
      } else {
        nextOldFiber = oldFiber.sibling;
      }

      var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);

      if (newFiber === null) {
        // TODO: This breaks on empty slots like null children. That's
        // unfortunate because it triggers the slow path all the time. We need
        // a better way to communicate whether this was a miss or null,
        // boolean, undefined, etc.
        if (oldFiber === null) {
          oldFiber = nextOldFiber;
        }

        break;
      }

      if (shouldTrackSideEffects) {
        if (oldFiber && newFiber.alternate === null) {
          // We matched the slot, but we didn't reuse the existing fiber, so we
          // need to delete the existing child.
          deleteChild(returnFiber, oldFiber);
        }
      }

      lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

      if (previousNewFiber === null) {
        // TODO: Move out of the loop. This only happens for the first run.
        resultingFirstChild = newFiber;
      } else {
        // TODO: Defer siblings if we're not at the right index for this slot.
        // I.e. if we had null values before, then we want to defer this
        // for each null value. However, we also don't want to call updateSlot
        // with the previous one.
        previousNewFiber.sibling = newFiber;
      }

      previousNewFiber = newFiber;
      oldFiber = nextOldFiber;
    }

    if (newIdx === newChildren.length) {
      // We've reached the end of the new children. We can delete the rest.
      deleteRemainingChildren(returnFiber, oldFiber);
      return resultingFirstChild;
    }

    if (oldFiber === null) {
      // If we don't have any more existing children we can choose a fast path
      // since the rest will all be insertions.
      for (; newIdx < newChildren.length; newIdx++) {
        var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);

        if (_newFiber === null) {
          continue;
        }

        lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          // TODO: Move out of the loop. This only happens for the first run.
          resultingFirstChild = _newFiber;
        } else {
          previousNewFiber.sibling = _newFiber;
        }

        previousNewFiber = _newFiber;
      }

      return resultingFirstChild;
    } // Add all children to a key map for quick lookups.


    var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

    for (; newIdx < newChildren.length; newIdx++) {
      var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);

      if (_newFiber2 !== null) {
        if (shouldTrackSideEffects) {
          if (_newFiber2.alternate !== null) {
            // The new fiber is a work in progress, but if there exists a
            // current, that means that we reused the fiber. We need to delete
            // it from the child list so that we don't add it to the deletion
            // list.
            existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
          }
        }

        lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          resultingFirstChild = _newFiber2;
        } else {
          previousNewFiber.sibling = _newFiber2;
        }

        previousNewFiber = _newFiber2;
      }
    }

    if (shouldTrackSideEffects) {
      // Any existing children that weren't consumed above were deleted. We need
      // to add them to the deletion list.
      existingChildren.forEach(function (child) {
        return deleteChild(returnFiber, child);
      });
    }

    return resultingFirstChild;
  }

  function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
    // This is the same implementation as reconcileChildrenArray(),
    // but using the iterator instead.
    var iteratorFn = getIteratorFn(newChildrenIterable);

    if (!(typeof iteratorFn === 'function')) {
      {
        throw Error( "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    {
      // We don't support rendering Generators because it's a mutation.
      // See https://github.com/facebook/react/issues/12995
      if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
      newChildrenIterable[Symbol.toStringTag] === 'Generator') {
        if (!didWarnAboutGenerators) {
          error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
        }

        didWarnAboutGenerators = true;
      } // Warn about using Maps as children


      if (newChildrenIterable.entries === iteratorFn) {
        if (!didWarnAboutMaps) {
          error('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
        }

        didWarnAboutMaps = true;
      } // First, validate keys.
      // We'll get a different iterator later for the main pass.


      var _newChildren = iteratorFn.call(newChildrenIterable);

      if (_newChildren) {
        var knownKeys = null;

        var _step = _newChildren.next();

        for (; !_step.done; _step = _newChildren.next()) {
          var child = _step.value;
          knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
        }
      }
    }

    var newChildren = iteratorFn.call(newChildrenIterable);

    if (!(newChildren != null)) {
      {
        throw Error( "An iterable object provided no iterator." );
      }
    }

    var resultingFirstChild = null;
    var previousNewFiber = null;
    var oldFiber = currentFirstChild;
    var lastPlacedIndex = 0;
    var newIdx = 0;
    var nextOldFiber = null;
    var step = newChildren.next();

    for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
      if (oldFiber.index > newIdx) {
        nextOldFiber = oldFiber;
        oldFiber = null;
      } else {
        nextOldFiber = oldFiber.sibling;
      }

      var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);

      if (newFiber === null) {
        // TODO: This breaks on empty slots like null children. That's
        // unfortunate because it triggers the slow path all the time. We need
        // a better way to communicate whether this was a miss or null,
        // boolean, undefined, etc.
        if (oldFiber === null) {
          oldFiber = nextOldFiber;
        }

        break;
      }

      if (shouldTrackSideEffects) {
        if (oldFiber && newFiber.alternate === null) {
          // We matched the slot, but we didn't reuse the existing fiber, so we
          // need to delete the existing child.
          deleteChild(returnFiber, oldFiber);
        }
      }

      lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

      if (previousNewFiber === null) {
        // TODO: Move out of the loop. This only happens for the first run.
        resultingFirstChild = newFiber;
      } else {
        // TODO: Defer siblings if we're not at the right index for this slot.
        // I.e. if we had null values before, then we want to defer this
        // for each null value. However, we also don't want to call updateSlot
        // with the previous one.
        previousNewFiber.sibling = newFiber;
      }

      previousNewFiber = newFiber;
      oldFiber = nextOldFiber;
    }

    if (step.done) {
      // We've reached the end of the new children. We can delete the rest.
      deleteRemainingChildren(returnFiber, oldFiber);
      return resultingFirstChild;
    }

    if (oldFiber === null) {
      // If we don't have any more existing children we can choose a fast path
      // since the rest will all be insertions.
      for (; !step.done; newIdx++, step = newChildren.next()) {
        var _newFiber3 = createChild(returnFiber, step.value, lanes);

        if (_newFiber3 === null) {
          continue;
        }

        lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          // TODO: Move out of the loop. This only happens for the first run.
          resultingFirstChild = _newFiber3;
        } else {
          previousNewFiber.sibling = _newFiber3;
        }

        previousNewFiber = _newFiber3;
      }

      return resultingFirstChild;
    } // Add all children to a key map for quick lookups.


    var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

    for (; !step.done; newIdx++, step = newChildren.next()) {
      var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);

      if (_newFiber4 !== null) {
        if (shouldTrackSideEffects) {
          if (_newFiber4.alternate !== null) {
            // The new fiber is a work in progress, but if there exists a
            // current, that means that we reused the fiber. We need to delete
            // it from the child list so that we don't add it to the deletion
            // list.
            existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
          }
        }

        lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          resultingFirstChild = _newFiber4;
        } else {
          previousNewFiber.sibling = _newFiber4;
        }

        previousNewFiber = _newFiber4;
      }
    }

    if (shouldTrackSideEffects) {
      // Any existing children that weren't consumed above were deleted. We need
      // to add them to the deletion list.
      existingChildren.forEach(function (child) {
        return deleteChild(returnFiber, child);
      });
    }

    return resultingFirstChild;
  }

  function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
    // There's no need to check for keys on text nodes since we don't have a
    // way to define them.
    if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
      // We already have an existing node so let's just update it and delete
      // the rest.
      deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
      var existing = useFiber(currentFirstChild, textContent);
      existing.return = returnFiber;
      return existing;
    } // The existing first child is not a text node so we need to create one
    // and delete the existing ones.


    deleteRemainingChildren(returnFiber, currentFirstChild);
    var created = createFiberFromText(textContent, returnFiber.mode, lanes);
    created.return = returnFiber;
    return created;
  }

  function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
    var key = element.key;
    var child = currentFirstChild;

    while (child !== null) {
      // TODO: If key === null and child.key === null, then this only applies to
      // the first item in the list.
      if (child.key === key) {
        switch (child.tag) {
          case Fragment:
            {
              if (element.type === REACT_FRAGMENT_TYPE) {
                deleteRemainingChildren(returnFiber, child.sibling);
                var existing = useFiber(child, element.props.children);
                existing.return = returnFiber;

                {
                  existing._debugSource = element._source;
                  existing._debugOwner = element._owner;
                }

                return existing;
              }

              break;
            }

          case Block:

          // We intentionally fallthrough here if enableBlocksAPI is not on.
          // eslint-disable-next-lined no-fallthrough

          default:
            {
              if (child.elementType === element.type || ( // Keep this check inline so it only runs on the false path:
               isCompatibleFamilyForHotReloading(child, element) )) {
                deleteRemainingChildren(returnFiber, child.sibling);

                var _existing3 = useFiber(child, element.props);

                _existing3.ref = coerceRef(returnFiber, child, element);
                _existing3.return = returnFiber;

                {
                  _existing3._debugSource = element._source;
                  _existing3._debugOwner = element._owner;
                }

                return _existing3;
              }

              break;
            }
        } // Didn't match.


        deleteRemainingChildren(returnFiber, child);
        break;
      } else {
        deleteChild(returnFiber, child);
      }

      child = child.sibling;
    }

    if (element.type === REACT_FRAGMENT_TYPE) {
      var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
      created.return = returnFiber;
      return created;
    } else {
      var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);

      _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
      _created4.return = returnFiber;
      return _created4;
    }
  }

  function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
    var key = portal.key;
    var child = currentFirstChild;

    while (child !== null) {
      // TODO: If key === null and child.key === null, then this only applies to
      // the first item in the list.
      if (child.key === key) {
        if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
          deleteRemainingChildren(returnFiber, child.sibling);
          var existing = useFiber(child, portal.children || []);
          existing.return = returnFiber;
          return existing;
        } else {
          deleteRemainingChildren(returnFiber, child);
          break;
        }
      } else {
        deleteChild(returnFiber, child);
      }

      child = child.sibling;
    }

    var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
    created.return = returnFiber;
    return created;
  } // This API will tag the children with the side-effect of the reconciliation
  // itself. They will be added to the side-effect list as we pass through the
  // children and the parent.


  function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
    // This function is not recursive.
    // If the top level item is an array, we treat it as a set of children,
    // not as a fragment. Nested arrays on the other hand will be treated as
    // fragment nodes. Recursion happens at the normal flow.
    // Handle top level unkeyed fragments as if they were arrays.
    // This leads to an ambiguity between <>{[...]}</> and <>...</>.
    // We treat the ambiguous cases above the same.
    var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;

    if (isUnkeyedTopLevelFragment) {
      newChild = newChild.props.children;
    } // Handle object types


    var isObject = typeof newChild === 'object' && newChild !== null;

    if (isObject) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));

        case REACT_PORTAL_TYPE:
          return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));

      }
    }

    if (typeof newChild === 'string' || typeof newChild === 'number') {
      return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
    }

    if (isArray$1(newChild)) {
      return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
    }

    if (getIteratorFn(newChild)) {
      return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
    }

    if (isObject) {
      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) {
      // If the new child is undefined, and the return fiber is a composite
      // component, throw an error. If Fiber return types are disabled,
      // we already threw above.
      switch (returnFiber.tag) {
        case ClassComponent:
          {
            {
              var instance = returnFiber.stateNode;

              if (instance.render._isMockFunction) {
                // We allow auto-mocks to proceed as if they're returning null.
                break;
              }
            }
          }
        // Intentionally fall through to the next case, which handles both
        // functions and classes
        // eslint-disable-next-lined no-fallthrough

        case Block:
        case FunctionComponent:
        case ForwardRef:
        case SimpleMemoComponent:
          {
            {
              {
                throw Error( (getComponentName(returnFiber.type) || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null." );
              }
            }
          }
      }
    } // Remaining cases are all treated as empty.


    return deleteRemainingChildren(returnFiber, currentFirstChild);
  }

  return reconcileChildFibers;
}

var reconcileChildFibers = ChildReconciler(true);
var mountChildFibers = ChildReconciler(false);
function cloneChildFibers(current, workInProgress) {
  if (!(current === null || workInProgress.child === current.child)) {
    {
      throw Error( "Resuming work not yet implemented." );
    }
  }

  if (workInProgress.child === null) {
    return;
  }

  var currentChild = workInProgress.child;
  var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
  workInProgress.child = newChild;
  newChild.return = workInProgress;

  while (currentChild.sibling !== null) {
    currentChild = currentChild.sibling;
    newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
    newChild.return = workInProgress;
  }

  newChild.sibling = null;
} // Reset a workInProgress child set to prepare it for a second pass.

function resetChildFibers(workInProgress, lanes) {
  var child = workInProgress.child;

  while (child !== null) {
    resetWorkInProgress(child, lanes);
    child = child.sibling;
  }
}

var NO_CONTEXT = {};
var contextStackCursor$1 = createCursor(NO_CONTEXT);
var contextFiberStackCursor = createCursor(NO_CONTEXT);
var rootInstanceStackCursor = createCursor(NO_CONTEXT);

function requiredContext(c) {
  if (!(c !== NO_CONTEXT)) {
    {
      throw Error( "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  return c;
}

function getRootHostContainer() {
  var rootInstance = requiredContext(rootInstanceStackCursor.current);
  return rootInstance;
}

function pushHostContainer(fiber, nextRootInstance) {
  // Push current root instance onto the stack;
  // This allows us to reset root when portals are popped.
  push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
  // This enables us to pop only Fibers that provide unique contexts.

  push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
  // However, we can't just call getRootHostContext() and push it because
  // we'd have a different number of entries on the stack depending on
  // whether getRootHostContext() throws somewhere in renderer code or not.
  // So we push an empty value first. This lets us safely unwind on errors.

  push(contextStackCursor$1, NO_CONTEXT, fiber);
  var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.

  pop(contextStackCursor$1, fiber);
  push(contextStackCursor$1, nextRootContext, fiber);
}

function popHostContainer(fiber) {
  pop(contextStackCursor$1, fiber);
  pop(contextFiberStackCursor, fiber);
  pop(rootInstanceStackCursor, fiber);
}

function getHostContext() {
  var context = requiredContext(contextStackCursor$1.current);
  return context;
}

function pushHostContext(fiber) {
  var rootInstance = requiredContext(rootInstanceStackCursor.current);
  var context = requiredContext(contextStackCursor$1.current);
  var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.

  if (context === nextContext) {
    return;
  } // Track the context and the Fiber that provided it.
  // This enables us to pop only Fibers that provide unique contexts.


  push(contextFiberStackCursor, fiber, fiber);
  push(contextStackCursor$1, nextContext, fiber);
}

function popHostContext(fiber) {
  // Do not pop unless this Fiber provided the current context.
  // pushHostContext() only pushes Fibers that provide unique contexts.
  if (contextFiberStackCursor.current !== fiber) {
    return;
  }

  pop(contextStackCursor$1, fiber);
  pop(contextFiberStackCursor, fiber);
}

var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
// inherited deeply down the subtree. The upper bits only affect
// this immediate suspense boundary and gets reset each new
// boundary or suspense list.

var SubtreeSuspenseContextMask = 1; // Subtree Flags:
// InvisibleParentSuspenseContext indicates that one of our parent Suspense
// boundaries is not currently showing visible main content.
// Either because it is already showing a fallback or is not mounted at all.
// We can use this to determine if it is desirable to trigger a fallback at
// the parent. If not, then we might need to trigger undesirable boundaries
// and/or suspend the commit to avoid hiding the parent content.

var InvisibleParentSuspenseContext = 1; // Shallow Flags:
// ForceSuspenseFallback can be used by SuspenseList to force newly added
// items into their fallback state during one of the render passes.

var ForceSuspenseFallback = 2;
var suspenseStackCursor = createCursor(DefaultSuspenseContext);
function hasSuspenseContext(parentContext, flag) {
  return (parentContext & flag) !== 0;
}
function setDefaultShallowSuspenseContext(parentContext) {
  return parentContext & SubtreeSuspenseContextMask;
}
function setShallowSuspenseContext(parentContext, shallowContext) {
  return parentContext & SubtreeSuspenseContextMask | shallowContext;
}
function addSubtreeSuspenseContext(parentContext, subtreeContext) {
  return parentContext | subtreeContext;
}
function pushSuspenseContext(fiber, newContext) {
  push(suspenseStackCursor, newContext, fiber);
}
function popSuspenseContext(fiber) {
  pop(suspenseStackCursor, fiber);
}

function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
  // If it was the primary children that just suspended, capture and render the
  // fallback. Otherwise, don't capture and bubble to the next boundary.
  var nextState = workInProgress.memoizedState;

  if (nextState !== null) {
    if (nextState.dehydrated !== null) {
      // A dehydrated boundary always captures.
      return true;
    }

    return false;
  }

  var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.

  if (props.fallback === undefined) {
    return false;
  } // Regular boundaries always capture.


  if (props.unstable_avoidThisFallback !== true) {
    return true;
  } // If it's a boundary we should avoid, then we prefer to bubble up to the
  // parent boundary if it is currently invisible.


  if (hasInvisibleParent) {
    return false;
  } // If the parent is not able to handle it, we must handle it.


  return true;
}
function findFirstSuspended(row) {
  var node = row;

  while (node !== null) {
    if (node.tag === SuspenseComponent) {
      var state = node.memoizedState;

      if (state !== null) {
        var dehydrated = state.dehydrated;

        if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
          return node;
        }
      }
    } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
    // keep track of whether it suspended or not.
    node.memoizedProps.revealOrder !== undefined) {
      var didSuspend = (node.flags & DidCapture) !== NoFlags;

      if (didSuspend) {
        return node;
      }
    } else if (node.child !== null) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === row) {
      return null;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === row) {
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }

  return null;
}

var NoFlags$1 =
/*  */
0; // Represents whether effect should fire.

var HasEffect =
/* */
1; // Represents the phase in which the effect (not the clean-up) fires.

var Layout =
/*    */
2;
var Passive$1 =
/*   */
4;

// This may have been an insertion or a hydration.

var hydrationParentFiber = null;
var nextHydratableInstance = null;
var isHydrating = false;

function enterHydrationState(fiber) {

  var parentInstance = fiber.stateNode.containerInfo;
  nextHydratableInstance = getFirstHydratableChild(parentInstance);
  hydrationParentFiber = fiber;
  isHydrating = true;
  return true;
}

function deleteHydratableInstance(returnFiber, instance) {
  {
    switch (returnFiber.tag) {
      case HostRoot:
        didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
        break;

      case HostComponent:
        didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
        break;
    }
  }

  var childToDelete = createFiberFromHostInstanceForDeletion();
  childToDelete.stateNode = instance;
  childToDelete.return = returnFiber;
  childToDelete.flags = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
  // these children are not part of the reconciliation list of children.
  // Even if we abort and rereconcile the children, that will try to hydrate
  // again and the nodes are still in the host tree so these will be
  // recreated.

  if (returnFiber.lastEffect !== null) {
    returnFiber.lastEffect.nextEffect = childToDelete;
    returnFiber.lastEffect = childToDelete;
  } else {
    returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
  }
}

function insertNonHydratedInstance(returnFiber, fiber) {
  fiber.flags = fiber.flags & ~Hydrating | Placement;

  {
    switch (returnFiber.tag) {
      case HostRoot:
        {
          var parentContainer = returnFiber.stateNode.containerInfo;

          switch (fiber.tag) {
            case HostComponent:
              var type = fiber.type;
              var props = fiber.pendingProps;
              didNotFindHydratableContainerInstance(parentContainer, type);
              break;

            case HostText:
              var text = fiber.pendingProps;
              didNotFindHydratableContainerTextInstance(parentContainer, text);
              break;
          }

          break;
        }

      case HostComponent:
        {
          var parentType = returnFiber.type;
          var parentProps = returnFiber.memoizedProps;
          var parentInstance = returnFiber.stateNode;

          switch (fiber.tag) {
            case HostComponent:
              var _type = fiber.type;
              var _props = fiber.pendingProps;
              didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
              break;

            case HostText:
              var _text = fiber.pendingProps;
              didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
              break;

            case SuspenseComponent:
              didNotFindHydratableSuspenseInstance(parentType, parentProps);
              break;
          }

          break;
        }

      default:
        return;
    }
  }
}

function tryHydrate(fiber, nextInstance) {
  switch (fiber.tag) {
    case HostComponent:
      {
        var type = fiber.type;
        var props = fiber.pendingProps;
        var instance = canHydrateInstance(nextInstance, type);

        if (instance !== null) {
          fiber.stateNode = instance;
          return true;
        }

        return false;
      }

    case HostText:
      {
        var text = fiber.pendingProps;
        var textInstance = canHydrateTextInstance(nextInstance, text);

        if (textInstance !== null) {
          fiber.stateNode = textInstance;
          return true;
        }

        return false;
      }

    case SuspenseComponent:
      {

        return false;
      }

    default:
      return false;
  }
}

function tryToClaimNextHydratableInstance(fiber) {
  if (!isHydrating) {
    return;
  }

  var nextInstance = nextHydratableInstance;

  if (!nextInstance) {
    // Nothing to hydrate. Make it an insertion.
    insertNonHydratedInstance(hydrationParentFiber, fiber);
    isHydrating = false;
    hydrationParentFiber = fiber;
    return;
  }

  var firstAttemptedInstance = nextInstance;

  if (!tryHydrate(fiber, nextInstance)) {
    // If we can't hydrate this instance let's try the next one.
    // We use this as a heuristic. It's based on intuition and not data so it
    // might be flawed or unnecessary.
    nextInstance = getNextHydratableSibling(firstAttemptedInstance);

    if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
      // Nothing to hydrate. Make it an insertion.
      insertNonHydratedInstance(hydrationParentFiber, fiber);
      isHydrating = false;
      hydrationParentFiber = fiber;
      return;
    } // We matched the next one, we'll now assume that the first one was
    // superfluous and we'll delete it. Since we can't eagerly delete it
    // we'll have to schedule a deletion. To do that, this node needs a dummy
    // fiber associated with it.


    deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
  }

  hydrationParentFiber = fiber;
  nextHydratableInstance = getFirstHydratableChild(nextInstance);
}

function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {

  var instance = fiber.stateNode;
  var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.

  fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
  // is a new ref we mark this as an update.

  if (updatePayload !== null) {
    return true;
  }

  return false;
}

function prepareToHydrateHostTextInstance(fiber) {

  var textInstance = fiber.stateNode;
  var textContent = fiber.memoizedProps;
  var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);

  {
    if (shouldUpdate) {
      // We assume that prepareToHydrateHostTextInstance is called in a context where the
      // hydration parent is the parent host component of this host text.
      var returnFiber = hydrationParentFiber;

      if (returnFiber !== null) {
        switch (returnFiber.tag) {
          case HostRoot:
            {
              var parentContainer = returnFiber.stateNode.containerInfo;
              didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
              break;
            }

          case HostComponent:
            {
              var parentType = returnFiber.type;
              var parentProps = returnFiber.memoizedProps;
              var parentInstance = returnFiber.stateNode;
              didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
              break;
            }
        }
      }
    }
  }

  return shouldUpdate;
}

function skipPastDehydratedSuspenseInstance(fiber) {

  var suspenseState = fiber.memoizedState;
  var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;

  if (!suspenseInstance) {
    {
      throw Error( "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
}

function popToNextHostParent(fiber) {
  var parent = fiber.return;

  while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent) {
    parent = parent.return;
  }

  hydrationParentFiber = parent;
}

function popHydrationState(fiber) {

  if (fiber !== hydrationParentFiber) {
    // We're deeper than the current hydration context, inside an inserted
    // tree.
    return false;
  }

  if (!isHydrating) {
    // If we're not currently hydrating but we're in a hydration context, then
    // we were an insertion and now need to pop up reenter hydration of our
    // siblings.
    popToNextHostParent(fiber);
    isHydrating = true;
    return false;
  }

  var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
  // We only do this deeper than head and body since they tend to have random
  // other nodes in them. We also ignore components with pure text content in
  // side of them.
  // TODO: Better heuristic.

  if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
    var nextInstance = nextHydratableInstance;

    while (nextInstance) {
      deleteHydratableInstance(fiber, nextInstance);
      nextInstance = getNextHydratableSibling(nextInstance);
    }
  }

  popToNextHostParent(fiber);

  if (fiber.tag === SuspenseComponent) {
    nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
  } else {
    nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
  }

  return true;
}

function resetHydrationState() {

  hydrationParentFiber = null;
  nextHydratableInstance = null;
  isHydrating = false;
}

function getIsHydrating() {
  return isHydrating;
}

// and should be reset before starting a new render.
// This tracks which mutable sources need to be reset after a render.

var workInProgressSources = [];
var rendererSigil$1;

{
  // Used to detect multiple renderers using the same mutable source.
  rendererSigil$1 = {};
}

function markSourceAsDirty(mutableSource) {
  workInProgressSources.push(mutableSource);
}
function resetWorkInProgressVersions() {
  for (var i = 0; i < workInProgressSources.length; i++) {
    var mutableSource = workInProgressSources[i];

    {
      mutableSource._workInProgressVersionPrimary = null;
    }
  }

  workInProgressSources.length = 0;
}
function getWorkInProgressVersion(mutableSource) {
  {
    return mutableSource._workInProgressVersionPrimary;
  }
}
function setWorkInProgressVersion(mutableSource, version) {
  {
    mutableSource._workInProgressVersionPrimary = version;
  }

  workInProgressSources.push(mutableSource);
}
function warnAboutMultipleRenderersDEV(mutableSource) {
  {
    {
      if (mutableSource._currentPrimaryRenderer == null) {
        mutableSource._currentPrimaryRenderer = rendererSigil$1;
      } else if (mutableSource._currentPrimaryRenderer !== rendererSigil$1) {
        error('Detected multiple renderers concurrently rendering the ' + 'same mutable source. This is currently unsupported.');
      }
    }
  }
} // Eager reads the version of a mutable source and stores it on the root.

var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher,
    ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
var didWarnAboutMismatchedHooksForComponent;
var didWarnAboutUseOpaqueIdentifier;

{
  didWarnAboutUseOpaqueIdentifier = {};
  didWarnAboutMismatchedHooksForComponent = new Set();
}

// These are set right before calling the component.
var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
// the work-in-progress hook.

var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
// current hook list is the list that belongs to the current fiber. The
// work-in-progress hook list is a new list that will be added to the
// work-in-progress fiber.

var currentHook = null;
var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
// does not get reset if we do another render pass; only when we're completely
// finished evaluating this component. This is an optimization so we know
// whether we need to clear render phase updates after a throw.

var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
// gets reset after each attempt.
// TODO: Maybe there's some way to consolidate this with
// `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.

var didScheduleRenderPhaseUpdateDuringThisPass = false;
var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook

var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
// The list stores the order of hooks used during the initial render (mount).
// Subsequent renders (updates) reference this list.

var hookTypesDev = null;
var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
// the dependencies for Hooks that need them (e.g. useEffect or useMemo).
// When true, such Hooks will always be "remounted". Only used during hot reload.

var ignorePreviousDependencies = false;

function mountHookTypesDev() {
  {
    var hookName = currentHookNameInDev;

    if (hookTypesDev === null) {
      hookTypesDev = [hookName];
    } else {
      hookTypesDev.push(hookName);
    }
  }
}

function updateHookTypesDev() {
  {
    var hookName = currentHookNameInDev;

    if (hookTypesDev !== null) {
      hookTypesUpdateIndexDev++;

      if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
        warnOnHookMismatchInDev(hookName);
      }
    }
  }
}

function checkDepsAreArrayDev(deps) {
  {
    if (deps !== undefined && deps !== null && !Array.isArray(deps)) {
      // Verify deps, but only on mount to avoid extra checks.
      // It's unlikely their type would change as usually you define them inline.
      error('%s received a final argument that is not an array (instead, received `%s`). When ' + 'specified, the final argument must be an array.', currentHookNameInDev, typeof deps);
    }
  }
}

function warnOnHookMismatchInDev(currentHookName) {
  {
    var componentName = getComponentName(currentlyRenderingFiber$1.type);

    if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
      didWarnAboutMismatchedHooksForComponent.add(componentName);

      if (hookTypesDev !== null) {
        var table = '';
        var secondColumnStart = 30;

        for (var i = 0; i <= hookTypesUpdateIndexDev; i++) {
          var oldHookName = hookTypesDev[i];
          var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
          var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
          // lol @ IE not supporting String#repeat

          while (row.length < secondColumnStart) {
            row += ' ';
          }

          row += newHookName + '\n';
          table += row;
        }

        error('React has detected a change in the order of Hooks called by %s. ' + 'This will lead to bugs and errors if not fixed. ' + 'For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n' + '   Previous render            Next render\n' + '   ------------------------------------------------------\n' + '%s' + '   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n', componentName, table);
      }
    }
  }
}

function throwInvalidHookError() {
  {
    {
      throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem." );
    }
  }
}

function areHookInputsEqual(nextDeps, prevDeps) {
  {
    if (ignorePreviousDependencies) {
      // Only true when this component is being hot reloaded.
      return false;
    }
  }

  if (prevDeps === null) {
    {
      error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
    }

    return false;
  }

  {
    // Don't bother comparing lengths in prod because these arrays should be
    // passed inline.
    if (nextDeps.length !== prevDeps.length) {
      error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
    }
  }

  for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
    if (objectIs(nextDeps[i], prevDeps[i])) {
      continue;
    }

    return false;
  }

  return true;
}

function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
  renderLanes = nextRenderLanes;
  currentlyRenderingFiber$1 = workInProgress;

  {
    hookTypesDev = current !== null ? current._debugHookTypes : null;
    hookTypesUpdateIndexDev = -1; // Used for hot reloading:

    ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
  }

  workInProgress.memoizedState = null;
  workInProgress.updateQueue = null;
  workInProgress.lanes = NoLanes; // The following should have already been reset
  // currentHook = null;
  // workInProgressHook = null;
  // didScheduleRenderPhaseUpdate = false;
  // TODO Warn if no hooks are used at all during mount, then some are used during update.
  // Currently we will identify the update render as a mount because memoizedState === null.
  // This is tricky because it's valid for certain types of components (e.g. React.lazy)
  // Using memoizedState to differentiate between mount/update only works if at least one stateful hook is used.
  // Non-stateful hooks (e.g. context) don't get added to memoizedState,
  // so memoizedState would be null during updates and mounts.

  {
    if (current !== null && current.memoizedState !== null) {
      ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
    } else if (hookTypesDev !== null) {
      // This dispatcher handles an edge case where a component is updating,
      // but no stateful hooks have been used.
      // We want to match the production code behavior (which will use HooksDispatcherOnMount),
      // but with the extra DEV validation to ensure hooks ordering hasn't changed.
      // This dispatcher does that.
      ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
    } else {
      ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
    }
  }

  var children = Component(props, secondArg); // Check if there was a render phase update

  if (didScheduleRenderPhaseUpdateDuringThisPass) {
    // Keep rendering in a loop for as long as render phase updates continue to
    // be scheduled. Use a counter to prevent infinite loops.
    var numberOfReRenders = 0;

    do {
      didScheduleRenderPhaseUpdateDuringThisPass = false;

      if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
        {
          throw Error( "Too many re-renders. React limits the number of renders to prevent an infinite loop." );
        }
      }

      numberOfReRenders += 1;

      {
        // Even when hot reloading, allow dependencies to stabilize
        // after first render to prevent infinite render phase updates.
        ignorePreviousDependencies = false;
      } // Start over from the beginning of the list


      currentHook = null;
      workInProgressHook = null;
      workInProgress.updateQueue = null;

      {
        // Also validate hook order for cascading updates.
        hookTypesUpdateIndexDev = -1;
      }

      ReactCurrentDispatcher$1.current =  HooksDispatcherOnRerenderInDEV ;
      children = Component(props, secondArg);
    } while (didScheduleRenderPhaseUpdateDuringThisPass);
  } // We can assume the previous dispatcher is always this one, since we set it
  // at the beginning of the render phase and there's no re-entrancy.


  ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;

  {
    workInProgress._debugHookTypes = hookTypesDev;
  } // This check uses currentHook so that it works the same in DEV and prod bundles.
  // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.


  var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
  renderLanes = NoLanes;
  currentlyRenderingFiber$1 = null;
  currentHook = null;
  workInProgressHook = null;

  {
    currentHookNameInDev = null;
    hookTypesDev = null;
    hookTypesUpdateIndexDev = -1;
  }

  didScheduleRenderPhaseUpdate = false;

  if (!!didRenderTooFewHooks) {
    {
      throw Error( "Rendered fewer hooks than expected. This may be caused by an accidental early return statement." );
    }
  }

  return children;
}
function bailoutHooks(current, workInProgress, lanes) {
  workInProgress.updateQueue = current.updateQueue;
  workInProgress.flags &= ~(Passive | Update);
  current.lanes = removeLanes(current.lanes, lanes);
}
function resetHooksAfterThrow() {
  // We can assume the previous dispatcher is always this one, since we set it
  // at the beginning of the render phase and there's no re-entrancy.
  ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;

  if (didScheduleRenderPhaseUpdate) {
    // There were render phase updates. These are only valid for this render
    // phase, which we are now aborting. Remove the updates from the queues so
    // they do not persist to the next render. Do not remove updates from hooks
    // that weren't processed.
    //
    // Only reset the updates from the queue if it has a clone. If it does
    // not have a clone, that means it wasn't processed, and the updates were
    // scheduled before we entered the render phase.
    var hook = currentlyRenderingFiber$1.memoizedState;

    while (hook !== null) {
      var queue = hook.queue;

      if (queue !== null) {
        queue.pending = null;
      }

      hook = hook.next;
    }

    didScheduleRenderPhaseUpdate = false;
  }

  renderLanes = NoLanes;
  currentlyRenderingFiber$1 = null;
  currentHook = null;
  workInProgressHook = null;

  {
    hookTypesDev = null;
    hookTypesUpdateIndexDev = -1;
    currentHookNameInDev = null;
    isUpdatingOpaqueValueInRenderPhase = false;
  }

  didScheduleRenderPhaseUpdateDuringThisPass = false;
}

function mountWorkInProgressHook() {
  var hook = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };

  if (workInProgressHook === null) {
    // This is the first hook in the list
    currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
  } else {
    // Append to the end of the list
    workInProgressHook = workInProgressHook.next = hook;
  }

  return workInProgressHook;
}

function updateWorkInProgressHook() {
  // This function is used both for updates and for re-renders triggered by a
  // render phase update. It assumes there is either a current hook we can
  // clone, or a work-in-progress hook from a previous render pass that we can
  // use as a base. When we reach the end of the base list, we must switch to
  // the dispatcher used for mounts.
  var nextCurrentHook;

  if (currentHook === null) {
    var current = currentlyRenderingFiber$1.alternate;

    if (current !== null) {
      nextCurrentHook = current.memoizedState;
    } else {
      nextCurrentHook = null;
    }
  } else {
    nextCurrentHook = currentHook.next;
  }

  var nextWorkInProgressHook;

  if (workInProgressHook === null) {
    nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
  } else {
    nextWorkInProgressHook = workInProgressHook.next;
  }

  if (nextWorkInProgressHook !== null) {
    // There's already a work-in-progress. Reuse it.
    workInProgressHook = nextWorkInProgressHook;
    nextWorkInProgressHook = workInProgressHook.next;
    currentHook = nextCurrentHook;
  } else {
    // Clone from the current hook.
    if (!(nextCurrentHook !== null)) {
      {
        throw Error( "Rendered more hooks than during the previous render." );
      }
    }

    currentHook = nextCurrentHook;
    var newHook = {
      memoizedState: currentHook.memoizedState,
      baseState: currentHook.baseState,
      baseQueue: currentHook.baseQueue,
      queue: currentHook.queue,
      next: null
    };

    if (workInProgressHook === null) {
      // This is the first hook in the list.
      currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
    } else {
      // Append to the end of the list.
      workInProgressHook = workInProgressHook.next = newHook;
    }
  }

  return workInProgressHook;
}

function createFunctionComponentUpdateQueue() {
  return {
    lastEffect: null
  };
}

function basicStateReducer(state, action) {
  // $FlowFixMe: Flow doesn't like mixed types
  return typeof action === 'function' ? action(state) : action;
}

function mountReducer(reducer, initialArg, init) {
  var hook = mountWorkInProgressHook();
  var initialState;

  if (init !== undefined) {
    initialState = init(initialArg);
  } else {
    initialState = initialArg;
  }

  hook.memoizedState = hook.baseState = initialState;
  var queue = hook.queue = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: reducer,
    lastRenderedState: initialState
  };
  var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
  return [hook.memoizedState, dispatch];
}

function updateReducer(reducer, initialArg, init) {
  var hook = updateWorkInProgressHook();
  var queue = hook.queue;

  if (!(queue !== null)) {
    {
      throw Error( "Should have a queue. This is likely a bug in React. Please file an issue." );
    }
  }

  queue.lastRenderedReducer = reducer;
  var current = currentHook; // The last rebase update that is NOT part of the base state.

  var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.

  var pendingQueue = queue.pending;

  if (pendingQueue !== null) {
    // We have new updates that haven't been processed yet.
    // We'll add them to the base queue.
    if (baseQueue !== null) {
      // Merge the pending queue and the base queue.
      var baseFirst = baseQueue.next;
      var pendingFirst = pendingQueue.next;
      baseQueue.next = pendingFirst;
      pendingQueue.next = baseFirst;
    }

    {
      if (current.baseQueue !== baseQueue) {
        // Internal invariant that should never happen, but feasibly could in
        // the future if we implement resuming, or some form of that.
        error('Internal error: Expected work-in-progress queue to be a clone. ' + 'This is a bug in React.');
      }
    }

    current.baseQueue = baseQueue = pendingQueue;
    queue.pending = null;
  }

  if (baseQueue !== null) {
    // We have a queue to process.
    var first = baseQueue.next;
    var newState = current.baseState;
    var newBaseState = null;
    var newBaseQueueFirst = null;
    var newBaseQueueLast = null;
    var update = first;

    do {
      var updateLane = update.lane;

      if (!isSubsetOfLanes(renderLanes, updateLane)) {
        // Priority is insufficient. Skip this update. If this is the first
        // skipped update, the previous update/state is the new base
        // update/state.
        var clone = {
          lane: updateLane,
          action: update.action,
          eagerReducer: update.eagerReducer,
          eagerState: update.eagerState,
          next: null
        };

        if (newBaseQueueLast === null) {
          newBaseQueueFirst = newBaseQueueLast = clone;
          newBaseState = newState;
        } else {
          newBaseQueueLast = newBaseQueueLast.next = clone;
        } // Update the remaining priority in the queue.
        // TODO: Don't need to accumulate this. Instead, we can remove
        // renderLanes from the original lanes.


        currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
        markSkippedUpdateLanes(updateLane);
      } else {
        // This update does have sufficient priority.
        if (newBaseQueueLast !== null) {
          var _clone = {
            // This update is going to be committed so we never want uncommit
            // it. Using NoLane works because 0 is a subset of all bitmasks, so
            // this will never be skipped by the check above.
            lane: NoLane,
            action: update.action,
            eagerReducer: update.eagerReducer,
            eagerState: update.eagerState,
            next: null
          };
          newBaseQueueLast = newBaseQueueLast.next = _clone;
        } // Process this update.


        if (update.eagerReducer === reducer) {
          // If this update was processed eagerly, and its reducer matches the
          // current reducer, we can use the eagerly computed state.
          newState = update.eagerState;
        } else {
          var action = update.action;
          newState = reducer(newState, action);
        }
      }

      update = update.next;
    } while (update !== null && update !== first);

    if (newBaseQueueLast === null) {
      newBaseState = newState;
    } else {
      newBaseQueueLast.next = newBaseQueueFirst;
    } // Mark that the fiber performed work, but only if the new state is
    // different from the current state.


    if (!objectIs(newState, hook.memoizedState)) {
      markWorkInProgressReceivedUpdate();
    }

    hook.memoizedState = newState;
    hook.baseState = newBaseState;
    hook.baseQueue = newBaseQueueLast;
    queue.lastRenderedState = newState;
  }

  var dispatch = queue.dispatch;
  return [hook.memoizedState, dispatch];
}

function rerenderReducer(reducer, initialArg, init) {
  var hook = updateWorkInProgressHook();
  var queue = hook.queue;

  if (!(queue !== null)) {
    {
      throw Error( "Should have a queue. This is likely a bug in React. Please file an issue." );
    }
  }

  queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
  // work-in-progress hook.

  var dispatch = queue.dispatch;
  var lastRenderPhaseUpdate = queue.pending;
  var newState = hook.memoizedState;

  if (lastRenderPhaseUpdate !== null) {
    // The queue doesn't persist past this render pass.
    queue.pending = null;
    var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
    var update = firstRenderPhaseUpdate;

    do {
      // Process this render phase update. We don't have to check the
      // priority because it will always be the same as the current
      // render's.
      var action = update.action;
      newState = reducer(newState, action);
      update = update.next;
    } while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
    // different from the current state.


    if (!objectIs(newState, hook.memoizedState)) {
      markWorkInProgressReceivedUpdate();
    }

    hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
    // the base state unless the queue is empty.
    // TODO: Not sure if this is the desired semantics, but it's what we
    // do for gDSFP. I can't remember why.

    if (hook.baseQueue === null) {
      hook.baseState = newState;
    }

    queue.lastRenderedState = newState;
  }

  return [newState, dispatch];
}

function readFromUnsubcribedMutableSource(root, source, getSnapshot) {
  {
    warnAboutMultipleRenderersDEV(source);
  }

  var getVersion = source._getVersion;
  var version = getVersion(source._source); // Is it safe for this component to read from this source during the current render?

  var isSafeToReadFromSource = false; // Check the version first.
  // If this render has already been started with a specific version,
  // we can use it alone to determine if we can safely read from the source.

  var currentRenderVersion = getWorkInProgressVersion(source);

  if (currentRenderVersion !== null) {
    // It's safe to read if the store hasn't been mutated since the last time
    // we read something.
    isSafeToReadFromSource = currentRenderVersion === version;
  } else {
    // If there's no version, then this is the first time we've read from the
    // source during the current render pass, so we need to do a bit more work.
    // What we need to determine is if there are any hooks that already
    // subscribed to the source, and if so, whether there are any pending
    // mutations that haven't been synchronized yet.
    //
    // If there are no pending mutations, then `root.mutableReadLanes` will be
    // empty, and we know we can safely read.
    //
    // If there *are* pending mutations, we may still be able to safely read
    // if the currently rendering lanes are inclusive of the pending mutation
    // lanes, since that guarantees that the value we're about to read from
    // the source is consistent with the values that we read during the most
    // recent mutation.
    isSafeToReadFromSource = isSubsetOfLanes(renderLanes, root.mutableReadLanes);

    if (isSafeToReadFromSource) {
      // If it's safe to read from this source during the current render,
      // store the version in case other components read from it.
      // A changed version number will let those components know to throw and restart the render.
      setWorkInProgressVersion(source, version);
    }
  }

  if (isSafeToReadFromSource) {
    var snapshot = getSnapshot(source._source);

    {
      if (typeof snapshot === 'function') {
        error('Mutable source should not return a function as the snapshot value. ' + 'Functions may close over mutable values and cause tearing.');
      }
    }

    return snapshot;
  } else {
    // This handles the special case of a mutable source being shared between renderers.
    // In that case, if the source is mutated between the first and second renderer,
    // The second renderer don't know that it needs to reset the WIP version during unwind,
    // (because the hook only marks sources as dirty if it's written to their WIP version).
    // That would cause this tear check to throw again and eventually be visible to the user.
    // We can avoid this infinite loop by explicitly marking the source as dirty.
    //
    // This can lead to tearing in the first renderer when it resumes,
    // but there's nothing we can do about that (short of throwing here and refusing to continue the render).
    markSourceAsDirty(source);

    {
      {
        throw Error( "Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue." );
      }
    }
  }
}

function useMutableSource(hook, source, getSnapshot, subscribe) {
  var root = getWorkInProgressRoot();

  if (!(root !== null)) {
    {
      throw Error( "Expected a work-in-progress root. This is a bug in React. Please file an issue." );
    }
  }

  var getVersion = source._getVersion;
  var version = getVersion(source._source);
  var dispatcher = ReactCurrentDispatcher$1.current; // eslint-disable-next-line prefer-const

  var _dispatcher$useState = dispatcher.useState(function () {
    return readFromUnsubcribedMutableSource(root, source, getSnapshot);
  }),
      currentSnapshot = _dispatcher$useState[0],
      setSnapshot = _dispatcher$useState[1];

  var snapshot = currentSnapshot; // Grab a handle to the state hook as well.
  // We use it to clear the pending update queue if we have a new source.

  var stateHook = workInProgressHook;
  var memoizedState = hook.memoizedState;
  var refs = memoizedState.refs;
  var prevGetSnapshot = refs.getSnapshot;
  var prevSource = memoizedState.source;
  var prevSubscribe = memoizedState.subscribe;
  var fiber = currentlyRenderingFiber$1;
  hook.memoizedState = {
    refs: refs,
    source: source,
    subscribe: subscribe
  }; // Sync the values needed by our subscription handler after each commit.

  dispatcher.useEffect(function () {
    refs.getSnapshot = getSnapshot; // Normally the dispatch function for a state hook never changes,
    // but this hook recreates the queue in certain cases  to avoid updates from stale sources.
    // handleChange() below needs to reference the dispatch function without re-subscribing,
    // so we use a ref to ensure that it always has the latest version.

    refs.setSnapshot = setSnapshot; // Check for a possible change between when we last rendered now.

    var maybeNewVersion = getVersion(source._source);

    if (!objectIs(version, maybeNewVersion)) {
      var maybeNewSnapshot = getSnapshot(source._source);

      {
        if (typeof maybeNewSnapshot === 'function') {
          error('Mutable source should not return a function as the snapshot value. ' + 'Functions may close over mutable values and cause tearing.');
        }
      }

      if (!objectIs(snapshot, maybeNewSnapshot)) {
        setSnapshot(maybeNewSnapshot);
        var lane = requestUpdateLane(fiber);
        markRootMutableRead(root, lane);
      } // If the source mutated between render and now,
      // there may be state updates already scheduled from the old source.
      // Entangle the updates so that they render in the same batch.


      markRootEntangled(root, root.mutableReadLanes);
    }
  }, [getSnapshot, source, subscribe]); // If we got a new source or subscribe function, re-subscribe in a passive effect.

  dispatcher.useEffect(function () {
    var handleChange = function () {
      var latestGetSnapshot = refs.getSnapshot;
      var latestSetSnapshot = refs.setSnapshot;

      try {
        latestSetSnapshot(latestGetSnapshot(source._source)); // Record a pending mutable source update with the same expiration time.

        var lane = requestUpdateLane(fiber);
        markRootMutableRead(root, lane);
      } catch (error) {
        // A selector might throw after a source mutation.
        // e.g. it might try to read from a part of the store that no longer exists.
        // In this case we should still schedule an update with React.
        // Worst case the selector will throw again and then an error boundary will handle it.
        latestSetSnapshot(function () {
          throw error;
        });
      }
    };

    var unsubscribe = subscribe(source._source, handleChange);

    {
      if (typeof unsubscribe !== 'function') {
        error('Mutable source subscribe function must return an unsubscribe function.');
      }
    }

    return unsubscribe;
  }, [source, subscribe]); // If any of the inputs to useMutableSource change, reading is potentially unsafe.
  //
  // If either the source or the subscription have changed we can't can't trust the update queue.
  // Maybe the source changed in a way that the old subscription ignored but the new one depends on.
  //
  // If the getSnapshot function changed, we also shouldn't rely on the update queue.
  // It's possible that the underlying source was mutated between the when the last "change" event fired,
  // and when the current render (with the new getSnapshot function) is processed.
  //
  // In both cases, we need to throw away pending updates (since they are no longer relevant)
  // and treat reading from the source as we do in the mount case.

  if (!objectIs(prevGetSnapshot, getSnapshot) || !objectIs(prevSource, source) || !objectIs(prevSubscribe, subscribe)) {
    // Create a new queue and setState method,
    // So if there are interleaved updates, they get pushed to the older queue.
    // When this becomes current, the previous queue and dispatch method will be discarded,
    // including any interleaving updates that occur.
    var newQueue = {
      pending: null,
      dispatch: null,
      lastRenderedReducer: basicStateReducer,
      lastRenderedState: snapshot
    };
    newQueue.dispatch = setSnapshot = dispatchAction.bind(null, currentlyRenderingFiber$1, newQueue);
    stateHook.queue = newQueue;
    stateHook.baseQueue = null;
    snapshot = readFromUnsubcribedMutableSource(root, source, getSnapshot);
    stateHook.memoizedState = stateHook.baseState = snapshot;
  }

  return snapshot;
}

function mountMutableSource(source, getSnapshot, subscribe) {
  var hook = mountWorkInProgressHook();
  hook.memoizedState = {
    refs: {
      getSnapshot: getSnapshot,
      setSnapshot: null
    },
    source: source,
    subscribe: subscribe
  };
  return useMutableSource(hook, source, getSnapshot, subscribe);
}

function updateMutableSource(source, getSnapshot, subscribe) {
  var hook = updateWorkInProgressHook();
  return useMutableSource(hook, source, getSnapshot, subscribe);
}

function mountState(initialState) {
  var hook = mountWorkInProgressHook();

  if (typeof initialState === 'function') {
    // $FlowFixMe: Flow doesn't like mixed types
    initialState = initialState();
  }

  hook.memoizedState = hook.baseState = initialState;
  var queue = hook.queue = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: basicStateReducer,
    lastRenderedState: initialState
  };
  var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
  return [hook.memoizedState, dispatch];
}

function updateState(initialState) {
  return updateReducer(basicStateReducer);
}

function rerenderState(initialState) {
  return rerenderReducer(basicStateReducer);
}

function pushEffect(tag, create, destroy, deps) {
  var effect = {
    tag: tag,
    create: create,
    destroy: destroy,
    deps: deps,
    // Circular
    next: null
  };
  var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;

  if (componentUpdateQueue === null) {
    componentUpdateQueue = createFunctionComponentUpdateQueue();
    currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
    componentUpdateQueue.lastEffect = effect.next = effect;
  } else {
    var lastEffect = componentUpdateQueue.lastEffect;

    if (lastEffect === null) {
      componentUpdateQueue.lastEffect = effect.next = effect;
    } else {
      var firstEffect = lastEffect.next;
      lastEffect.next = effect;
      effect.next = firstEffect;
      componentUpdateQueue.lastEffect = effect;
    }
  }

  return effect;
}

function mountRef(initialValue) {
  var hook = mountWorkInProgressHook();
  var ref = {
    current: initialValue
  };

  {
    Object.seal(ref);
  }

  hook.memoizedState = ref;
  return ref;
}

function updateRef(initialValue) {
  var hook = updateWorkInProgressHook();
  return hook.memoizedState;
}

function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
  var hook = mountWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  currentlyRenderingFiber$1.flags |= fiberFlags;
  hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
}

function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
  var hook = updateWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var destroy = undefined;

  if (currentHook !== null) {
    var prevEffect = currentHook.memoizedState;
    destroy = prevEffect.destroy;

    if (nextDeps !== null) {
      var prevDeps = prevEffect.deps;

      if (areHookInputsEqual(nextDeps, prevDeps)) {
        pushEffect(hookFlags, create, destroy, nextDeps);
        return;
      }
    }
  }

  currentlyRenderingFiber$1.flags |= fiberFlags;
  hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
}

function mountEffect(create, deps) {
  {
    // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
    if ('undefined' !== typeof jest) {
      warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
    }
  }

  return mountEffectImpl(Update | Passive, Passive$1, create, deps);
}

function updateEffect(create, deps) {
  {
    // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
    if ('undefined' !== typeof jest) {
      warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
    }
  }

  return updateEffectImpl(Update | Passive, Passive$1, create, deps);
}

function mountLayoutEffect(create, deps) {
  return mountEffectImpl(Update, Layout, create, deps);
}

function updateLayoutEffect(create, deps) {
  return updateEffectImpl(Update, Layout, create, deps);
}

function imperativeHandleEffect(create, ref) {
  if (typeof ref === 'function') {
    var refCallback = ref;

    var _inst = create();

    refCallback(_inst);
    return function () {
      refCallback(null);
    };
  } else if (ref !== null && ref !== undefined) {
    var refObject = ref;

    {
      if (!refObject.hasOwnProperty('current')) {
        error('Expected useImperativeHandle() first argument to either be a ' + 'ref callback or React.createRef() object. Instead received: %s.', 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
      }
    }

    var _inst2 = create();

    refObject.current = _inst2;
    return function () {
      refObject.current = null;
    };
  }
}

function mountImperativeHandle(ref, create, deps) {
  {
    if (typeof create !== 'function') {
      error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
    }
  } // TODO: If deps are provided, should we skip comparing the ref itself?


  var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
  return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
}

function updateImperativeHandle(ref, create, deps) {
  {
    if (typeof create !== 'function') {
      error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
    }
  } // TODO: If deps are provided, should we skip comparing the ref itself?


  var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
  return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
}

function mountDebugValue(value, formatterFn) {// This hook is normally a no-op.
  // The react-debug-hooks package injects its own implementation
  // so that e.g. DevTools can display custom hook values.
}

var updateDebugValue = mountDebugValue;

function mountCallback(callback, deps) {
  var hook = mountWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  hook.memoizedState = [callback, nextDeps];
  return callback;
}

function updateCallback(callback, deps) {
  var hook = updateWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var prevState = hook.memoizedState;

  if (prevState !== null) {
    if (nextDeps !== null) {
      var prevDeps = prevState[1];

      if (areHookInputsEqual(nextDeps, prevDeps)) {
        return prevState[0];
      }
    }
  }

  hook.memoizedState = [callback, nextDeps];
  return callback;
}

function mountMemo(nextCreate, deps) {
  var hook = mountWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var nextValue = nextCreate();
  hook.memoizedState = [nextValue, nextDeps];
  return nextValue;
}

function updateMemo(nextCreate, deps) {
  var hook = updateWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var prevState = hook.memoizedState;

  if (prevState !== null) {
    // Assume these are defined. If they're not, areHookInputsEqual will warn.
    if (nextDeps !== null) {
      var prevDeps = prevState[1];

      if (areHookInputsEqual(nextDeps, prevDeps)) {
        return prevState[0];
      }
    }
  }

  var nextValue = nextCreate();
  hook.memoizedState = [nextValue, nextDeps];
  return nextValue;
}

function mountDeferredValue(value) {
  var _mountState = mountState(value),
      prevValue = _mountState[0],
      setValue = _mountState[1];

  mountEffect(function () {
    var prevTransition = ReactCurrentBatchConfig$1.transition;
    ReactCurrentBatchConfig$1.transition = 1;

    try {
      setValue(value);
    } finally {
      ReactCurrentBatchConfig$1.transition = prevTransition;
    }
  }, [value]);
  return prevValue;
}

function updateDeferredValue(value) {
  var _updateState = updateState(),
      prevValue = _updateState[0],
      setValue = _updateState[1];

  updateEffect(function () {
    var prevTransition = ReactCurrentBatchConfig$1.transition;
    ReactCurrentBatchConfig$1.transition = 1;

    try {
      setValue(value);
    } finally {
      ReactCurrentBatchConfig$1.transition = prevTransition;
    }
  }, [value]);
  return prevValue;
}

function rerenderDeferredValue(value) {
  var _rerenderState = rerenderState(),
      prevValue = _rerenderState[0],
      setValue = _rerenderState[1];

  updateEffect(function () {
    var prevTransition = ReactCurrentBatchConfig$1.transition;
    ReactCurrentBatchConfig$1.transition = 1;

    try {
      setValue(value);
    } finally {
      ReactCurrentBatchConfig$1.transition = prevTransition;
    }
  }, [value]);
  return prevValue;
}

function startTransition(setPending, callback) {
  var priorityLevel = getCurrentPriorityLevel();

  {
    runWithPriority$1(priorityLevel < UserBlockingPriority$2 ? UserBlockingPriority$2 : priorityLevel, function () {
      setPending(true);
    });
    runWithPriority$1(priorityLevel > NormalPriority$1 ? NormalPriority$1 : priorityLevel, function () {
      var prevTransition = ReactCurrentBatchConfig$1.transition;
      ReactCurrentBatchConfig$1.transition = 1;

      try {
        setPending(false);
        callback();
      } finally {
        ReactCurrentBatchConfig$1.transition = prevTransition;
      }
    });
  }
}

function mountTransition() {
  var _mountState2 = mountState(false),
      isPending = _mountState2[0],
      setPending = _mountState2[1]; // The `start` method can be stored on a ref, since `setPending`
  // never changes.


  var start = startTransition.bind(null, setPending);
  mountRef(start);
  return [start, isPending];
}

function updateTransition() {
  var _updateState2 = updateState(),
      isPending = _updateState2[0];

  var startRef = updateRef();
  var start = startRef.current;
  return [start, isPending];
}

function rerenderTransition() {
  var _rerenderState2 = rerenderState(),
      isPending = _rerenderState2[0];

  var startRef = updateRef();
  var start = startRef.current;
  return [start, isPending];
}

var isUpdatingOpaqueValueInRenderPhase = false;
function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
  {
    return isUpdatingOpaqueValueInRenderPhase;
  }
}

function warnOnOpaqueIdentifierAccessInDEV(fiber) {
  {
    // TODO: Should warn in effects and callbacks, too
    var name = getComponentName(fiber.type) || 'Unknown';

    if (getIsRendering() && !didWarnAboutUseOpaqueIdentifier[name]) {
      error('The object passed back from useOpaqueIdentifier is meant to be ' + 'passed through to attributes only. Do not read the ' + 'value directly.');

      didWarnAboutUseOpaqueIdentifier[name] = true;
    }
  }
}

function mountOpaqueIdentifier() {
  var makeId =  makeClientIdInDEV.bind(null, warnOnOpaqueIdentifierAccessInDEV.bind(null, currentlyRenderingFiber$1)) ;

  if (getIsHydrating()) {
    var didUpgrade = false;
    var fiber = currentlyRenderingFiber$1;

    var readValue = function () {
      if (!didUpgrade) {
        // Only upgrade once. This works even inside the render phase because
        // the update is added to a shared queue, which outlasts the
        // in-progress render.
        didUpgrade = true;

        {
          isUpdatingOpaqueValueInRenderPhase = true;
          setId(makeId());
          isUpdatingOpaqueValueInRenderPhase = false;
          warnOnOpaqueIdentifierAccessInDEV(fiber);
        }
      }

      {
        {
          throw Error( "The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly." );
        }
      }
    };

    var id = makeOpaqueHydratingObject(readValue);
    var setId = mountState(id)[1];

    if ((currentlyRenderingFiber$1.mode & BlockingMode) === NoMode) {
      currentlyRenderingFiber$1.flags |= Update | Passive;
      pushEffect(HasEffect | Passive$1, function () {
        setId(makeId());
      }, undefined, null);
    }

    return id;
  } else {
    var _id = makeId();

    mountState(_id);
    return _id;
  }
}

function updateOpaqueIdentifier() {
  var id = updateState()[0];
  return id;
}

function rerenderOpaqueIdentifier() {
  var id = rerenderState()[0];
  return id;
}

function dispatchAction(fiber, queue, action) {
  {
    if (typeof arguments[3] === 'function') {
      error("State updates from the useState() and useReducer() Hooks don't support the " + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
    }
  }

  var eventTime = requestEventTime();
  var lane = requestUpdateLane(fiber);
  var update = {
    lane: lane,
    action: action,
    eagerReducer: null,
    eagerState: null,
    next: null
  }; // Append the update to the end of the list.

  var pending = queue.pending;

  if (pending === null) {
    // This is the first update. Create a circular list.
    update.next = update;
  } else {
    update.next = pending.next;
    pending.next = update;
  }

  queue.pending = update;
  var alternate = fiber.alternate;

  if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
    // This is a render phase update. Stash it in a lazily-created map of
    // queue -> linked list of updates. After this render pass, we'll restart
    // and apply the stashed updates on top of the work-in-progress hook.
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
  } else {
    if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
      // The queue is currently empty, which means we can eagerly compute the
      // next state before entering the render phase. If the new state is the
      // same as the current state, we may be able to bail out entirely.
      var lastRenderedReducer = queue.lastRenderedReducer;

      if (lastRenderedReducer !== null) {
        var prevDispatcher;

        {
          prevDispatcher = ReactCurrentDispatcher$1.current;
          ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
        }

        try {
          var currentState = queue.lastRenderedState;
          var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
          // it, on the update object. If the reducer hasn't changed by the
          // time we enter the render phase, then the eager state can be used
          // without calling the reducer again.

          update.eagerReducer = lastRenderedReducer;
          update.eagerState = eagerState;

          if (objectIs(eagerState, currentState)) {
            // Fast path. We can bail out without scheduling React to re-render.
            // It's still possible that we'll need to rebase this update later,
            // if the component re-renders for a different reason and by that
            // time the reducer has changed.
            return;
          }
        } catch (error) {// Suppress the error. It will throw again in the render phase.
        } finally {
          {
            ReactCurrentDispatcher$1.current = prevDispatcher;
          }
        }
      }
    }

    {
      // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
      if ('undefined' !== typeof jest) {
        warnIfNotScopedWithMatchingAct(fiber);
        warnIfNotCurrentlyActingUpdatesInDev(fiber);
      }
    }

    scheduleUpdateOnFiber(fiber, lane, eventTime);
  }
}

var ContextOnlyDispatcher = {
  readContext: readContext,
  useCallback: throwInvalidHookError,
  useContext: throwInvalidHookError,
  useEffect: throwInvalidHookError,
  useImperativeHandle: throwInvalidHookError,
  useLayoutEffect: throwInvalidHookError,
  useMemo: throwInvalidHookError,
  useReducer: throwInvalidHookError,
  useRef: throwInvalidHookError,
  useState: throwInvalidHookError,
  useDebugValue: throwInvalidHookError,
  useDeferredValue: throwInvalidHookError,
  useTransition: throwInvalidHookError,
  useMutableSource: throwInvalidHookError,
  useOpaqueIdentifier: throwInvalidHookError,
  unstable_isNewReconciler: enableNewReconciler
};
var HooksDispatcherOnMountInDEV = null;
var HooksDispatcherOnMountWithHookTypesInDEV = null;
var HooksDispatcherOnUpdateInDEV = null;
var HooksDispatcherOnRerenderInDEV = null;
var InvalidNestedHooksDispatcherOnMountInDEV = null;
var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
var InvalidNestedHooksDispatcherOnRerenderInDEV = null;

{
  var warnInvalidContextAccess = function () {
    error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
  };

  var warnInvalidHookAccess = function () {
    error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://reactjs.org/link/rules-of-hooks');
  };

  HooksDispatcherOnMountInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      mountHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      mountHookTypesDev();
      return mountRef(initialValue);
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      mountHookTypesDev();
      return mountDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      mountHookTypesDev();
      return mountDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      mountHookTypesDev();
      return mountTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      mountHookTypesDev();
      return mountMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      mountHookTypesDev();
      return mountOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  HooksDispatcherOnMountWithHookTypesInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      updateHookTypesDev();
      return mountCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      updateHookTypesDev();
      return mountEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      updateHookTypesDev();
      return mountImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      updateHookTypesDev();
      return mountLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      updateHookTypesDev();
      return mountRef(initialValue);
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      updateHookTypesDev();
      return mountDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      updateHookTypesDev();
      return mountDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      updateHookTypesDev();
      return mountTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      updateHookTypesDev();
      return mountMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      updateHookTypesDev();
      return mountOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  HooksDispatcherOnUpdateInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      updateHookTypesDev();
      return updateDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      updateHookTypesDev();
      return updateTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      updateHookTypesDev();
      return updateOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  HooksDispatcherOnRerenderInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

      try {
        return rerenderReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

      try {
        return rerenderState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      updateHookTypesDev();
      return rerenderDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      updateHookTypesDev();
      return rerenderTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      updateHookTypesDev();
      return rerenderOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  InvalidNestedHooksDispatcherOnMountInDEV = {
    readContext: function (context, observedBits) {
      warnInvalidContextAccess();
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      warnInvalidHookAccess();
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      warnInvalidHookAccess();
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountRef(initialValue);
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      warnInvalidHookAccess();
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  InvalidNestedHooksDispatcherOnUpdateInDEV = {
    readContext: function (context, observedBits) {
      warnInvalidContextAccess();
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  InvalidNestedHooksDispatcherOnRerenderInDEV = {
    readContext: function (context, observedBits) {
      warnInvalidContextAccess();
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return rerenderReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return rerenderState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return rerenderDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return rerenderTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return rerenderOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
}

var now$1 = Scheduler.unstable_now;
var commitTime = 0;
var profilerStartTime = -1;

function getCommitTime() {
  return commitTime;
}

function recordCommitTime() {

  commitTime = now$1();
}

function startProfilerTimer(fiber) {

  profilerStartTime = now$1();

  if (fiber.actualStartTime < 0) {
    fiber.actualStartTime = now$1();
  }
}

function stopProfilerTimerIfRunning(fiber) {

  profilerStartTime = -1;
}

function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {

  if (profilerStartTime >= 0) {
    var elapsedTime = now$1() - profilerStartTime;
    fiber.actualDuration += elapsedTime;

    if (overrideBaseTime) {
      fiber.selfBaseDuration = elapsedTime;
    }

    profilerStartTime = -1;
  }
}

function transferActualDuration(fiber) {
  // Transfer time spent rendering these children so we don't lose it
  // after we rerender. This is used as a helper in special cases
  // where we should count the work of multiple passes.
  var child = fiber.child;

  while (child) {
    fiber.actualDuration += child.actualDuration;
    child = child.sibling;
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var didReceiveUpdate = false;
var didWarnAboutBadClass;
var didWarnAboutModulePatternComponent;
var didWarnAboutContextTypeOnFunctionComponent;
var didWarnAboutGetDerivedStateOnFunctionComponent;
var didWarnAboutFunctionRefs;
var didWarnAboutReassigningProps;
var didWarnAboutRevealOrder;
var didWarnAboutTailOptions;

{
  didWarnAboutBadClass = {};
  didWarnAboutModulePatternComponent = {};
  didWarnAboutContextTypeOnFunctionComponent = {};
  didWarnAboutGetDerivedStateOnFunctionComponent = {};
  didWarnAboutFunctionRefs = {};
  didWarnAboutReassigningProps = false;
  didWarnAboutRevealOrder = {};
  didWarnAboutTailOptions = {};
}

function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
  if (current === null) {
    // If this is a fresh new component that hasn't been rendered yet, we
    // won't update its child set by applying minimal side-effects. Instead,
    // we will add them all to the child before it gets rendered. That means
    // we can optimize this reconciliation pass by not tracking side-effects.
    workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
  } else {
    // If the current child is the same as the work in progress, it means that
    // we haven't yet started any work on these children. Therefore, we use
    // the clone algorithm to create a copy of all the current children.
    // If we had any progressed work already, that is invalid at this point so
    // let's throw it out.
    workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
  }
}

function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
  // This function is fork of reconcileChildren. It's used in cases where we
  // want to reconcile without matching against the existing set. This has the
  // effect of all current children being unmounted; even if the type and key
  // are the same, the old child is unmounted and a new child is created.
  //
  // To do this, we're going to go through the reconcile algorithm twice. In
  // the first pass, we schedule a deletion for all the current children by
  // passing null.
  workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
  // pass null in place of where we usually pass the current child set. This has
  // the effect of remounting all children regardless of whether their
  // identities match.

  workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
}

function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
  // TODO: current can be non-null here even if the component
  // hasn't yet mounted. This happens after the first render suspends.
  // We'll need to figure out if this is fine or can cause issues.
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var innerPropTypes = Component.propTypes;

      if (innerPropTypes) {
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(Component));
      }
    }
  }

  var render = Component.render;
  var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent

  var nextChildren;
  prepareToReadContext(workInProgress, renderLanes);

  {
    ReactCurrentOwner$1.current = workInProgress;
    setIsRendering(true);
    nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);

    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
      } finally {
        reenableLogs();
      }
    }

    setIsRendering(false);
  }

  if (current !== null && !didReceiveUpdate) {
    bailoutHooks(current, workInProgress, renderLanes);
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
  if (current === null) {
    var type = Component.type;

    if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
    Component.defaultProps === undefined) {
      var resolvedType = type;

      {
        resolvedType = resolveFunctionForHotReloading(type);
      } // If this is a plain function component without default props,
      // and with only the default shallow comparison, we upgrade it
      // to a SimpleMemoComponent to allow fast path updates.


      workInProgress.tag = SimpleMemoComponent;
      workInProgress.type = resolvedType;

      {
        validateFunctionComponentInDev(workInProgress, type);
      }

      return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateLanes, renderLanes);
    }

    {
      var innerPropTypes = type.propTypes;

      if (innerPropTypes) {
        // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(type));
      }
    }

    var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
    child.ref = workInProgress.ref;
    child.return = workInProgress;
    workInProgress.child = child;
    return child;
  }

  {
    var _type = Component.type;
    var _innerPropTypes = _type.propTypes;

    if (_innerPropTypes) {
      // Inner memo component props aren't currently validated in createElement.
      // We could move it there, but we'd still need this for lazy code path.
      checkPropTypes(_innerPropTypes, nextProps, // Resolved props
      'prop', getComponentName(_type));
    }
  }

  var currentChild = current.child; // This is always exactly one child

  if (!includesSomeLane(updateLanes, renderLanes)) {
    // This will be the props with resolved defaultProps,
    // unlike current.memoizedProps which will be the unresolved ones.
    var prevProps = currentChild.memoizedProps; // Default to shallow comparison

    var compare = Component.compare;
    compare = compare !== null ? compare : shallowEqual;

    if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) {
      return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  var newChild = createWorkInProgress(currentChild, nextProps);
  newChild.ref = workInProgress.ref;
  newChild.return = workInProgress;
  workInProgress.child = newChild;
  return newChild;
}

function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
  // TODO: current can be non-null here even if the component
  // hasn't yet mounted. This happens when the inner render suspends.
  // We'll need to figure out if this is fine or can cause issues.
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var outerMemoType = workInProgress.elementType;

      if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
        // We warn when you define propTypes on lazy()
        // so let's just skip over it to find memo() outer wrapper.
        // Inner props for memo are validated later.
        var lazyComponent = outerMemoType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;

        try {
          outerMemoType = init(payload);
        } catch (x) {
          outerMemoType = null;
        } // Inner propTypes will be validated in the function component path.


        var outerPropTypes = outerMemoType && outerMemoType.propTypes;

        if (outerPropTypes) {
          checkPropTypes(outerPropTypes, nextProps, // Resolved (SimpleMemoComponent has no defaultProps)
          'prop', getComponentName(outerMemoType));
        }
      }
    }
  }

  if (current !== null) {
    var prevProps = current.memoizedProps;

    if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && ( // Prevent bailout if the implementation changed due to hot reload.
     workInProgress.type === current.type )) {
      didReceiveUpdate = false;

      if (!includesSomeLane(renderLanes, updateLanes)) {
        // The pending lanes were cleared at the beginning of beginWork. We're
        // about to bail out, but there might be other lanes that weren't
        // included in the current render. Usually, the priority level of the
        // remaining updates is accumlated during the evaluation of the
        // component (i.e. when processing the update queue). But since since
        // we're bailing out early *without* evaluating the component, we need
        // to account for it here, too. Reset to the value of the current fiber.
        // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
        // because a MemoComponent fiber does not have hooks or an update queue;
        // rather, it wraps around an inner component, which may or may not
        // contains hooks.
        // TODO: Move the reset at in beginWork out of the common path so that
        // this is no longer necessary.
        workInProgress.lanes = current.lanes;
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
      } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
        // This is a special case that only exists for legacy mode.
        // See https://github.com/facebook/react/pull/19216.
        didReceiveUpdate = true;
      }
    }
  }

  return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}

function updateOffscreenComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps;
  var nextChildren = nextProps.children;
  var prevState = current !== null ? current.memoizedState : null;

  if (nextProps.mode === 'hidden' || nextProps.mode === 'unstable-defer-without-hiding') {
    if ((workInProgress.mode & ConcurrentMode) === NoMode) {
      // In legacy sync mode, don't defer the subtree. Render it now.
      // TODO: Figure out what we should do in Blocking mode.
      var nextState = {
        baseLanes: NoLanes
      };
      workInProgress.memoizedState = nextState;
      pushRenderLanes(workInProgress, renderLanes);
    } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
      var nextBaseLanes;

      if (prevState !== null) {
        var prevBaseLanes = prevState.baseLanes;
        nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
      } else {
        nextBaseLanes = renderLanes;
      } // Schedule this fiber to re-render at offscreen priority. Then bailout.


      {
        markSpawnedWork(OffscreenLane);
      }

      workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
      var _nextState = {
        baseLanes: nextBaseLanes
      };
      workInProgress.memoizedState = _nextState; // We're about to bail out, but we need to push this to the stack anyway
      // to avoid a push/pop misalignment.

      pushRenderLanes(workInProgress, nextBaseLanes);
      return null;
    } else {
      // Rendering at offscreen, so we can clear the base lanes.
      var _nextState2 = {
        baseLanes: NoLanes
      };
      workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.

      var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
      pushRenderLanes(workInProgress, subtreeRenderLanes);
    }
  } else {
    var _subtreeRenderLanes;

    if (prevState !== null) {
      _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes); // Since we're not hidden anymore, reset the state

      workInProgress.memoizedState = null;
    } else {
      // We weren't previously hidden, and we still aren't, so there's nothing
      // special to do. Need to push to the stack regardless, though, to avoid
      // a push/pop misalignment.
      _subtreeRenderLanes = renderLanes;
    }

    pushRenderLanes(workInProgress, _subtreeRenderLanes);
  }

  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
} // Note: These happen to have identical begin phases, for now. We shouldn't hold
// ourselves to this constraint, though. If the behavior diverges, we should
// fork the function.


var updateLegacyHiddenComponent = updateOffscreenComponent;

function updateFragment(current, workInProgress, renderLanes) {
  var nextChildren = workInProgress.pendingProps;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateMode(current, workInProgress, renderLanes) {
  var nextChildren = workInProgress.pendingProps.children;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateProfiler(current, workInProgress, renderLanes) {
  {
    workInProgress.flags |= Update; // Reset effect durations for the next eventual effect phase.
    // These are reset during render to allow the DevTools commit hook a chance to read them,

    var stateNode = workInProgress.stateNode;
    stateNode.effectDuration = 0;
    stateNode.passiveEffectDuration = 0;
  }

  var nextProps = workInProgress.pendingProps;
  var nextChildren = nextProps.children;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function markRef(current, workInProgress) {
  var ref = workInProgress.ref;

  if (current === null && ref !== null || current !== null && current.ref !== ref) {
    // Schedule a Ref effect
    workInProgress.flags |= Ref;
  }
}

function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var innerPropTypes = Component.propTypes;

      if (innerPropTypes) {
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(Component));
      }
    }
  }

  var context;

  {
    var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
    context = getMaskedContext(workInProgress, unmaskedContext);
  }

  var nextChildren;
  prepareToReadContext(workInProgress, renderLanes);

  {
    ReactCurrentOwner$1.current = workInProgress;
    setIsRendering(true);
    nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);

    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
      } finally {
        reenableLogs();
      }
    }

    setIsRendering(false);
  }

  if (current !== null && !didReceiveUpdate) {
    bailoutHooks(current, workInProgress, renderLanes);
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var innerPropTypes = Component.propTypes;

      if (innerPropTypes) {
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(Component));
      }
    }
  } // Push context providers early to prevent context stack mismatches.
  // During mounting we don't know the child context yet as the instance doesn't exist.
  // We will invalidate the child context in finishClassComponent() right after rendering.


  var hasContext;

  if (isContextProvider(Component)) {
    hasContext = true;
    pushContextProvider(workInProgress);
  } else {
    hasContext = false;
  }

  prepareToReadContext(workInProgress, renderLanes);
  var instance = workInProgress.stateNode;
  var shouldUpdate;

  if (instance === null) {
    if (current !== null) {
      // A class component without an instance only mounts if it suspended
      // inside a non-concurrent tree, in an inconsistent state. We want to
      // treat it like a new mount, even though an empty version of it already
      // committed. Disconnect the alternate pointers.
      current.alternate = null;
      workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

      workInProgress.flags |= Placement;
    } // In the initial pass we might need to construct the instance.


    constructClassInstance(workInProgress, Component, nextProps);
    mountClassInstance(workInProgress, Component, nextProps, renderLanes);
    shouldUpdate = true;
  } else if (current === null) {
    // In a resume, we'll already have an instance we can reuse.
    shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
  } else {
    shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
  }

  var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);

  {
    var inst = workInProgress.stateNode;

    if (shouldUpdate && inst.props !== nextProps) {
      if (!didWarnAboutReassigningProps) {
        error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentName(workInProgress.type) || 'a component');
      }

      didWarnAboutReassigningProps = true;
    }
  }

  return nextUnitOfWork;
}

function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
  // Refs should update even if shouldComponentUpdate returns false
  markRef(current, workInProgress);
  var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;

  if (!shouldUpdate && !didCaptureError) {
    // Context providers should defer to sCU for rendering
    if (hasContext) {
      invalidateContextProvider(workInProgress, Component, false);
    }

    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  }

  var instance = workInProgress.stateNode; // Rerender

  ReactCurrentOwner$1.current = workInProgress;
  var nextChildren;

  if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
    // If we captured an error, but getDerivedStateFromError is not defined,
    // unmount all the children. componentDidCatch will schedule an update to
    // re-render a fallback. This is temporary until we migrate everyone to
    // the new API.
    // TODO: Warn in a future release.
    nextChildren = null;

    {
      stopProfilerTimerIfRunning();
    }
  } else {
    {
      setIsRendering(true);
      nextChildren = instance.render();

      if ( workInProgress.mode & StrictMode) {
        disableLogs();

        try {
          instance.render();
        } finally {
          reenableLogs();
        }
      }

      setIsRendering(false);
    }
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;

  if (current !== null && didCaptureError) {
    // If we're recovering from an error, reconcile without reusing any of
    // the existing children. Conceptually, the normal children and the children
    // that are shown on error are two different sets, so we shouldn't reuse
    // normal children even if their identities match.
    forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
  } else {
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  } // Memoize state using the values we just used to render.
  // TODO: Restructure so we never read values from the instance.


  workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.

  if (hasContext) {
    invalidateContextProvider(workInProgress, Component, true);
  }

  return workInProgress.child;
}

function pushHostRootContext(workInProgress) {
  var root = workInProgress.stateNode;

  if (root.pendingContext) {
    pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
  } else if (root.context) {
    // Should always be set
    pushTopLevelContextObject(workInProgress, root.context, false);
  }

  pushHostContainer(workInProgress, root.containerInfo);
}

function updateHostRoot(current, workInProgress, renderLanes) {
  pushHostRootContext(workInProgress);
  var updateQueue = workInProgress.updateQueue;

  if (!(current !== null && updateQueue !== null)) {
    {
      throw Error( "If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  var nextProps = workInProgress.pendingProps;
  var prevState = workInProgress.memoizedState;
  var prevChildren = prevState !== null ? prevState.element : null;
  cloneUpdateQueue(current, workInProgress);
  processUpdateQueue(workInProgress, nextProps, null, renderLanes);
  var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
  // being called "element".

  var nextChildren = nextState.element;

  if (nextChildren === prevChildren) {
    resetHydrationState();
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  }

  var root = workInProgress.stateNode;

  if (root.hydrate && enterHydrationState(workInProgress)) {
    // If we don't have any current children this might be the first pass.
    // We always try to hydrate. If this isn't a hydration pass there won't
    // be any children to hydrate which is effectively the same thing as
    // not hydrating.
    {
      var mutableSourceEagerHydrationData = root.mutableSourceEagerHydrationData;

      if (mutableSourceEagerHydrationData != null) {
        for (var i = 0; i < mutableSourceEagerHydrationData.length; i += 2) {
          var mutableSource = mutableSourceEagerHydrationData[i];
          var version = mutableSourceEagerHydrationData[i + 1];
          setWorkInProgressVersion(mutableSource, version);
        }
      }
    }

    var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
    workInProgress.child = child;
    var node = child;

    while (node) {
      // Mark each child as hydrating. This is a fast path to know whether this
      // tree is part of a hydrating tree. This is used to determine if a child
      // node has fully mounted yet, and for scheduling event replaying.
      // Conceptually this is similar to Placement in that a new subtree is
      // inserted into the React tree here. It just happens to not need DOM
      // mutations because it already exists.
      node.flags = node.flags & ~Placement | Hydrating;
      node = node.sibling;
    }
  } else {
    // Otherwise reset hydration state in case we aborted and resumed another
    // root.
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    resetHydrationState();
  }

  return workInProgress.child;
}

function updateHostComponent(current, workInProgress, renderLanes) {
  pushHostContext(workInProgress);

  if (current === null) {
    tryToClaimNextHydratableInstance(workInProgress);
  }

  var type = workInProgress.type;
  var nextProps = workInProgress.pendingProps;
  var prevProps = current !== null ? current.memoizedProps : null;
  var nextChildren = nextProps.children;
  var isDirectTextChild = shouldSetTextContent(type, nextProps);

  if (isDirectTextChild) {
    // We special case a direct text child of a host node. This is a common
    // case. We won't handle it as a reified child. We will instead handle
    // this in the host environment that also has access to this prop. That
    // avoids allocating another HostText fiber and traversing it.
    nextChildren = null;
  } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
    // If we're switching from a direct text child to a normal child, or to
    // empty, we need to schedule the text content to be reset.
    workInProgress.flags |= ContentReset;
  }

  markRef(current, workInProgress);
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateHostText(current, workInProgress) {
  if (current === null) {
    tryToClaimNextHydratableInstance(workInProgress);
  } // Nothing to do here. This is terminal. We'll do the completion step
  // immediately after.


  return null;
}

function mountLazyComponent(_current, workInProgress, elementType, updateLanes, renderLanes) {
  if (_current !== null) {
    // A lazy component only mounts if it suspended inside a non-
    // concurrent tree, in an inconsistent state. We want to treat it like
    // a new mount, even though an empty version of it already committed.
    // Disconnect the alternate pointers.
    _current.alternate = null;
    workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

    workInProgress.flags |= Placement;
  }

  var props = workInProgress.pendingProps;
  var lazyComponent = elementType;
  var payload = lazyComponent._payload;
  var init = lazyComponent._init;
  var Component = init(payload); // Store the unwrapped component in the type.

  workInProgress.type = Component;
  var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
  var resolvedProps = resolveDefaultProps(Component, props);
  var child;

  switch (resolvedTag) {
    case FunctionComponent:
      {
        {
          validateFunctionComponentInDev(workInProgress, Component);
          workInProgress.type = Component = resolveFunctionForHotReloading(Component);
        }

        child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
        return child;
      }

    case ClassComponent:
      {
        {
          workInProgress.type = Component = resolveClassForHotReloading(Component);
        }

        child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
        return child;
      }

    case ForwardRef:
      {
        {
          workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
        }

        child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
        return child;
      }

    case MemoComponent:
      {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            var outerPropTypes = Component.propTypes;

            if (outerPropTypes) {
              checkPropTypes(outerPropTypes, resolvedProps, // Resolved for outer only
              'prop', getComponentName(Component));
            }
          }
        }

        child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), // The inner type can have defaults too
        updateLanes, renderLanes);
        return child;
      }
  }

  var hint = '';

  {
    if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) {
      hint = ' Did you wrap a component in React.lazy() more than once?';
    }
  } // This message intentionally doesn't mention ForwardRef or MemoComponent
  // because the fact that it's a separate type of work is an
  // implementation detail.


  {
    {
      throw Error( "Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint );
    }
  }
}

function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
  if (_current !== null) {
    // An incomplete component only mounts if it suspended inside a non-
    // concurrent tree, in an inconsistent state. We want to treat it like
    // a new mount, even though an empty version of it already committed.
    // Disconnect the alternate pointers.
    _current.alternate = null;
    workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

    workInProgress.flags |= Placement;
  } // Promote the fiber to a class and try rendering again.


  workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
  // Push context providers early to prevent context stack mismatches.
  // During mounting we don't know the child context yet as the instance doesn't exist.
  // We will invalidate the child context in finishClassComponent() right after rendering.

  var hasContext;

  if (isContextProvider(Component)) {
    hasContext = true;
    pushContextProvider(workInProgress);
  } else {
    hasContext = false;
  }

  prepareToReadContext(workInProgress, renderLanes);
  constructClassInstance(workInProgress, Component, nextProps);
  mountClassInstance(workInProgress, Component, nextProps, renderLanes);
  return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
}

function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
  if (_current !== null) {
    // An indeterminate component only mounts if it suspended inside a non-
    // concurrent tree, in an inconsistent state. We want to treat it like
    // a new mount, even though an empty version of it already committed.
    // Disconnect the alternate pointers.
    _current.alternate = null;
    workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

    workInProgress.flags |= Placement;
  }

  var props = workInProgress.pendingProps;
  var context;

  {
    var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
    context = getMaskedContext(workInProgress, unmaskedContext);
  }

  prepareToReadContext(workInProgress, renderLanes);
  var value;

  {
    if (Component.prototype && typeof Component.prototype.render === 'function') {
      var componentName = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutBadClass[componentName]) {
        error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);

        didWarnAboutBadClass[componentName] = true;
      }
    }

    if (workInProgress.mode & StrictMode) {
      ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
    }

    setIsRendering(true);
    ReactCurrentOwner$1.current = workInProgress;
    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
    setIsRendering(false);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;

  {
    // Support for module components is deprecated and is removed behind a flag.
    // Whether or not it would crash later, we want to show a good message in DEV first.
    if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
      var _componentName = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutModulePatternComponent[_componentName]) {
        error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);

        didWarnAboutModulePatternComponent[_componentName] = true;
      }
    }
  }

  if ( // Run these checks in production only if the flag is off.
  // Eventually we'll delete this branch altogether.
   typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
    {
      var _componentName2 = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutModulePatternComponent[_componentName2]) {
        error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName2, _componentName2, _componentName2);

        didWarnAboutModulePatternComponent[_componentName2] = true;
      }
    } // Proceed under the assumption that this is a class instance


    workInProgress.tag = ClassComponent; // Throw out any hooks that were used.

    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
    // During mounting we don't know the child context yet as the instance doesn't exist.
    // We will invalidate the child context in finishClassComponent() right after rendering.

    var hasContext = false;

    if (isContextProvider(Component)) {
      hasContext = true;
      pushContextProvider(workInProgress);
    } else {
      hasContext = false;
    }

    workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
    initializeUpdateQueue(workInProgress);
    var getDerivedStateFromProps = Component.getDerivedStateFromProps;

    if (typeof getDerivedStateFromProps === 'function') {
      applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
    }

    adoptClassInstance(workInProgress, value);
    mountClassInstance(workInProgress, Component, props, renderLanes);
    return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
  } else {
    // Proceed under the assumption that this is a function component
    workInProgress.tag = FunctionComponent;

    {

      if ( workInProgress.mode & StrictMode) {
        disableLogs();

        try {
          value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        } finally {
          reenableLogs();
        }
      }
    }

    reconcileChildren(null, workInProgress, value, renderLanes);

    {
      validateFunctionComponentInDev(workInProgress, Component);
    }

    return workInProgress.child;
  }
}

function validateFunctionComponentInDev(workInProgress, Component) {
  {
    if (Component) {
      if (Component.childContextTypes) {
        error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
      }
    }

    if (workInProgress.ref !== null) {
      var info = '';
      var ownerName = getCurrentFiberOwnerNameInDevOrNull();

      if (ownerName) {
        info += '\n\nCheck the render method of `' + ownerName + '`.';
      }

      var warningKey = ownerName || workInProgress._debugID || '';
      var debugSource = workInProgress._debugSource;

      if (debugSource) {
        warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
      }

      if (!didWarnAboutFunctionRefs[warningKey]) {
        didWarnAboutFunctionRefs[warningKey] = true;

        error('Function components cannot be given refs. ' + 'Attempts to access this ref will fail. ' + 'Did you mean to use React.forwardRef()?%s', info);
      }
    }

    if (typeof Component.getDerivedStateFromProps === 'function') {
      var _componentName3 = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
        error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);

        didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
      }
    }

    if (typeof Component.contextType === 'object' && Component.contextType !== null) {
      var _componentName4 = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
        error('%s: Function components do not support contextType.', _componentName4);

        didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
      }
    }
  }
}

var SUSPENDED_MARKER = {
  dehydrated: null,
  retryLane: NoLane
};

function mountSuspenseOffscreenState(renderLanes) {
  return {
    baseLanes: renderLanes
  };
}

function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
  return {
    baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes)
  };
} // TODO: Probably should inline this back


function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
  // If we're already showing a fallback, there are cases where we need to
  // remain on that fallback regardless of whether the content has resolved.
  // For example, SuspenseList coordinates when nested content appears.
  if (current !== null) {
    var suspenseState = current.memoizedState;

    if (suspenseState === null) {
      // Currently showing content. Don't hide it, even if ForceSuspenseFallack
      // is true. More precise name might be "ForceRemainSuspenseFallback".
      // Note: This is a factoring smell. Can't remain on a fallback if there's
      // no fallback to remain on.
      return false;
    }
  } // Not currently showing content. Consult the Suspense context.


  return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
}

function getRemainingWorkInPrimaryTree(current, renderLanes) {
  // TODO: Should not remove render lanes that were pinged during this render
  return removeLanes(current.childLanes, renderLanes);
}

function updateSuspenseComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.

  {
    if (shouldSuspend(workInProgress)) {
      workInProgress.flags |= DidCapture;
    }
  }

  var suspenseContext = suspenseStackCursor.current;
  var showFallback = false;
  var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;

  if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
    // Something in this boundary's subtree already suspended. Switch to
    // rendering the fallback children.
    showFallback = true;
    workInProgress.flags &= ~DidCapture;
  } else {
    // Attempting the main content
    if (current === null || current.memoizedState !== null) {
      // This is a new mount or this boundary is already showing a fallback state.
      // Mark this subtree context as having at least one invisible parent that could
      // handle the fallback state.
      // Boundaries without fallbacks or should be avoided are not considered since
      // they cannot handle preferred fallback states.
      if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) {
        suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
      }
    }
  }

  suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
  pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
  // boundary's children. This involves some custom reconcilation logic. Two
  // main reasons this is so complicated.
  //
  // First, Legacy Mode has different semantics for backwards compatibility. The
  // primary tree will commit in an inconsistent state, so when we do the
  // second pass to render the fallback, we do some exceedingly, uh, clever
  // hacks to make that not totally break. Like transferring effects and
  // deletions from hidden tree. In Concurrent Mode, it's much simpler,
  // because we bailout on the primary tree completely and leave it in its old
  // state, no effects. Same as what we do for Offscreen (except that
  // Offscreen doesn't have the first render pass).
  //
  // Second is hydration. During hydration, the Suspense fiber has a slightly
  // different layout, where the child points to a dehydrated fragment, which
  // contains the DOM rendered by the server.
  //
  // Third, even if you set all that aside, Suspense is like error boundaries in
  // that we first we try to render one tree, and if that fails, we render again
  // and switch to a different tree. Like a try/catch block. So we have to track
  // which branch we're currently rendering. Ideally we would model this using
  // a stack.

  if (current === null) {
    // Initial mount
    // If we're currently hydrating, try to hydrate this boundary.
    // But only if this has a fallback.
    if (nextProps.fallback !== undefined) {
      tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
    }

    var nextPrimaryChildren = nextProps.children;
    var nextFallbackChildren = nextProps.fallback;

    if (showFallback) {
      var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
      var primaryChildFragment = workInProgress.child;
      primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
      workInProgress.memoizedState = SUSPENDED_MARKER;
      return fallbackFragment;
    } else if (typeof nextProps.unstable_expectedLoadTime === 'number') {
      // This is a CPU-bound tree. Skip this tree and show a placeholder to
      // unblock the surrounding content. Then immediately retry after the
      // initial commit.
      var _fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);

      var _primaryChildFragment = workInProgress.child;
      _primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
      workInProgress.memoizedState = SUSPENDED_MARKER; // Since nothing actually suspended, there will nothing to ping this to
      // get it started back up to attempt the next item. While in terms of
      // priority this work has the same priority as this current render, it's
      // not part of the same transition once the transition has committed. If
      // it's sync, we still want to yield so that it can be painted.
      // Conceptually, this is really the same as pinging. We can use any
      // RetryLane even if it's the one currently rendering since we're leaving
      // it behind on this node.

      workInProgress.lanes = SomeRetryLane;

      {
        markSpawnedWork(SomeRetryLane);
      }

      return _fallbackFragment;
    } else {
      return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren, renderLanes);
    }
  } else {
    // This is an update.
    // If the current fiber has a SuspenseState, that means it's already showing
    // a fallback.
    var prevState = current.memoizedState;

    if (prevState !== null) {

      if (showFallback) {
        var _nextFallbackChildren2 = nextProps.fallback;
        var _nextPrimaryChildren2 = nextProps.children;

        var _fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes);

        var _primaryChildFragment3 = workInProgress.child;
        var prevOffscreenState = current.child.memoizedState;
        _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
        _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
        workInProgress.memoizedState = SUSPENDED_MARKER;
        return _fallbackChildFragment;
      } else {
        var _nextPrimaryChildren3 = nextProps.children;

        var _primaryChildFragment4 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren3, renderLanes);

        workInProgress.memoizedState = null;
        return _primaryChildFragment4;
      }
    } else {
      // The current tree is not already showing a fallback.
      if (showFallback) {
        // Timed out.
        var _nextFallbackChildren3 = nextProps.fallback;
        var _nextPrimaryChildren4 = nextProps.children;

        var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes);

        var _primaryChildFragment5 = workInProgress.child;
        var _prevOffscreenState = current.child.memoizedState;
        _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes);
        _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes); // Skip the primary children, and continue working on the
        // fallback children.

        workInProgress.memoizedState = SUSPENDED_MARKER;
        return _fallbackChildFragment2;
      } else {
        // Still haven't timed out. Continue rendering the children, like we
        // normally do.
        var _nextPrimaryChildren5 = nextProps.children;

        var _primaryChildFragment6 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren5, renderLanes);

        workInProgress.memoizedState = null;
        return _primaryChildFragment6;
      }
    }
  }
}

function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
  var mode = workInProgress.mode;
  var primaryChildProps = {
    mode: 'visible',
    children: primaryChildren
  };
  var primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, renderLanes, null);
  primaryChildFragment.return = workInProgress;
  workInProgress.child = primaryChildFragment;
  return primaryChildFragment;
}

function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
  var mode = workInProgress.mode;
  var progressedPrimaryFragment = workInProgress.child;
  var primaryChildProps = {
    mode: 'hidden',
    children: primaryChildren
  };
  var primaryChildFragment;
  var fallbackChildFragment;

  if ((mode & BlockingMode) === NoMode && progressedPrimaryFragment !== null) {
    // In legacy mode, we commit the primary tree as if it successfully
    // completed, even though it's in an inconsistent state.
    primaryChildFragment = progressedPrimaryFragment;
    primaryChildFragment.childLanes = NoLanes;
    primaryChildFragment.pendingProps = primaryChildProps;

    if ( workInProgress.mode & ProfileMode) {
      // Reset the durations from the first pass so they aren't included in the
      // final amounts. This seems counterintuitive, since we're intentionally
      // not measuring part of the render phase, but this makes it match what we
      // do in Concurrent Mode.
      primaryChildFragment.actualDuration = 0;
      primaryChildFragment.actualStartTime = -1;
      primaryChildFragment.selfBaseDuration = 0;
      primaryChildFragment.treeBaseDuration = 0;
    }

    fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
  } else {
    primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, NoLanes, null);
    fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
  }

  primaryChildFragment.return = workInProgress;
  fallbackChildFragment.return = workInProgress;
  primaryChildFragment.sibling = fallbackChildFragment;
  workInProgress.child = primaryChildFragment;
  return fallbackChildFragment;
}

function createWorkInProgressOffscreenFiber(current, offscreenProps) {
  // The props argument to `createWorkInProgress` is `any` typed, so we use this
  // wrapper function to constrain it.
  return createWorkInProgress(current, offscreenProps);
}

function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
  var currentPrimaryChildFragment = current.child;
  var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
  var primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
    mode: 'visible',
    children: primaryChildren
  });

  if ((workInProgress.mode & BlockingMode) === NoMode) {
    primaryChildFragment.lanes = renderLanes;
  }

  primaryChildFragment.return = workInProgress;
  primaryChildFragment.sibling = null;

  if (currentFallbackChildFragment !== null) {
    // Delete the fallback child fragment
    currentFallbackChildFragment.nextEffect = null;
    currentFallbackChildFragment.flags = Deletion;
    workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChildFragment;
  }

  workInProgress.child = primaryChildFragment;
  return primaryChildFragment;
}

function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
  var mode = workInProgress.mode;
  var currentPrimaryChildFragment = current.child;
  var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
  var primaryChildProps = {
    mode: 'hidden',
    children: primaryChildren
  };
  var primaryChildFragment;

  if ( // In legacy mode, we commit the primary tree as if it successfully
  // completed, even though it's in an inconsistent state.
  (mode & BlockingMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
  // already cloned. In legacy mode, the only case where this isn't true is
  // when DevTools forces us to display a fallback; we skip the first render
  // pass entirely and go straight to rendering the fallback. (In Concurrent
  // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
  // only codepath.)
  workInProgress.child !== currentPrimaryChildFragment) {
    var progressedPrimaryFragment = workInProgress.child;
    primaryChildFragment = progressedPrimaryFragment;
    primaryChildFragment.childLanes = NoLanes;
    primaryChildFragment.pendingProps = primaryChildProps;

    if ( workInProgress.mode & ProfileMode) {
      // Reset the durations from the first pass so they aren't included in the
      // final amounts. This seems counterintuitive, since we're intentionally
      // not measuring part of the render phase, but this makes it match what we
      // do in Concurrent Mode.
      primaryChildFragment.actualDuration = 0;
      primaryChildFragment.actualStartTime = -1;
      primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
      primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
    } // The fallback fiber was added as a deletion effect during the first pass.
    // However, since we're going to remain on the fallback, we no longer want
    // to delete it. So we need to remove it from the list. Deletions are stored
    // on the same list as effects. We want to keep the effects from the primary
    // tree. So we copy the primary child fragment's effect list, which does not
    // include the fallback deletion effect.


    var progressedLastEffect = primaryChildFragment.lastEffect;

    if (progressedLastEffect !== null) {
      workInProgress.firstEffect = primaryChildFragment.firstEffect;
      workInProgress.lastEffect = progressedLastEffect;
      progressedLastEffect.nextEffect = null;
    } else {
      // TODO: Reset this somewhere else? Lol legacy mode is so weird.
      workInProgress.firstEffect = workInProgress.lastEffect = null;
    }
  } else {
    primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
  }

  var fallbackChildFragment;

  if (currentFallbackChildFragment !== null) {
    fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
  } else {
    fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
    // mounted but this is a new fiber.

    fallbackChildFragment.flags |= Placement;
  }

  fallbackChildFragment.return = workInProgress;
  primaryChildFragment.return = workInProgress;
  primaryChildFragment.sibling = fallbackChildFragment;
  workInProgress.child = primaryChildFragment;
  return fallbackChildFragment;
}

function scheduleWorkOnFiber(fiber, renderLanes) {
  fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
  var alternate = fiber.alternate;

  if (alternate !== null) {
    alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
  }

  scheduleWorkOnParentPath(fiber.return, renderLanes);
}

function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
  // Mark any Suspense boundaries with fallbacks as having work to do.
  // If they were previously forced into fallbacks, they may now be able
  // to unblock.
  var node = firstChild;

  while (node !== null) {
    if (node.tag === SuspenseComponent) {
      var state = node.memoizedState;

      if (state !== null) {
        scheduleWorkOnFiber(node, renderLanes);
      }
    } else if (node.tag === SuspenseListComponent) {
      // If the tail is hidden there might not be an Suspense boundaries
      // to schedule work on. In this case we have to schedule it on the
      // list itself.
      // We don't have to traverse to the children of the list since
      // the list will propagate the change when it rerenders.
      scheduleWorkOnFiber(node, renderLanes);
    } else if (node.child !== null) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === workInProgress) {
      return;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === workInProgress) {
        return;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }
}

function findLastContentRow(firstChild) {
  // This is going to find the last row among these children that is already
  // showing content on the screen, as opposed to being in fallback state or
  // new. If a row has multiple Suspense boundaries, any of them being in the
  // fallback state, counts as the whole row being in a fallback state.
  // Note that the "rows" will be workInProgress, but any nested children
  // will still be current since we haven't rendered them yet. The mounted
  // order may not be the same as the new order. We use the new order.
  var row = firstChild;
  var lastContentRow = null;

  while (row !== null) {
    var currentRow = row.alternate; // New rows can't be content rows.

    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
      lastContentRow = row;
    }

    row = row.sibling;
  }

  return lastContentRow;
}

function validateRevealOrder(revealOrder) {
  {
    if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
      didWarnAboutRevealOrder[revealOrder] = true;

      if (typeof revealOrder === 'string') {
        switch (revealOrder.toLowerCase()) {
          case 'together':
          case 'forwards':
          case 'backwards':
            {
              error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());

              break;
            }

          case 'forward':
          case 'backward':
            {
              error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());

              break;
            }

          default:
            error('"%s" is not a supported revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);

            break;
        }
      } else {
        error('%s is not a supported value for revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
      }
    }
  }
}

function validateTailOptions(tailMode, revealOrder) {
  {
    if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
      if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
        didWarnAboutTailOptions[tailMode] = true;

        error('"%s" is not a supported value for tail on <SuspenseList />. ' + 'Did you mean "collapsed" or "hidden"?', tailMode);
      } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
        didWarnAboutTailOptions[tailMode] = true;

        error('<SuspenseList tail="%s" /> is only valid if revealOrder is ' + '"forwards" or "backwards". ' + 'Did you mean to specify revealOrder="forwards"?', tailMode);
      }
    }
  }
}

function validateSuspenseListNestedChild(childSlot, index) {
  {
    var isArray = Array.isArray(childSlot);
    var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';

    if (isArray || isIterable) {
      var type = isArray ? 'array' : 'iterable';

      error('A nested %s was passed to row #%s in <SuspenseList />. Wrap it in ' + 'an additional SuspenseList to configure its revealOrder: ' + '<SuspenseList revealOrder=...> ... ' + '<SuspenseList revealOrder=...>{%s}</SuspenseList> ... ' + '</SuspenseList>', type, index, type);

      return false;
    }
  }

  return true;
}

function validateSuspenseListChildren(children, revealOrder) {
  {
    if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
      if (Array.isArray(children)) {
        for (var i = 0; i < children.length; i++) {
          if (!validateSuspenseListNestedChild(children[i], i)) {
            return;
          }
        }
      } else {
        var iteratorFn = getIteratorFn(children);

        if (typeof iteratorFn === 'function') {
          var childrenIterator = iteratorFn.call(children);

          if (childrenIterator) {
            var step = childrenIterator.next();
            var _i = 0;

            for (; !step.done; step = childrenIterator.next()) {
              if (!validateSuspenseListNestedChild(step.value, _i)) {
                return;
              }

              _i++;
            }
          }
        } else {
          error('A single row was passed to a <SuspenseList revealOrder="%s" />. ' + 'This is not useful since it needs multiple rows. ' + 'Did you mean to pass multiple children or an array?', revealOrder);
        }
      }
    }
  }
}

function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
  var renderState = workInProgress.memoizedState;

  if (renderState === null) {
    workInProgress.memoizedState = {
      isBackwards: isBackwards,
      rendering: null,
      renderingStartTime: 0,
      last: lastContentRow,
      tail: tail,
      tailMode: tailMode,
      lastEffect: lastEffectBeforeRendering
    };
  } else {
    // We can reuse the existing object from previous renders.
    renderState.isBackwards = isBackwards;
    renderState.rendering = null;
    renderState.renderingStartTime = 0;
    renderState.last = lastContentRow;
    renderState.tail = tail;
    renderState.tailMode = tailMode;
    renderState.lastEffect = lastEffectBeforeRendering;
  }
} // This can end up rendering this component multiple passes.
// The first pass splits the children fibers into two sets. A head and tail.
// We first render the head. If anything is in fallback state, we do another
// pass through beginWork to rerender all children (including the tail) with
// the force suspend context. If the first render didn't have anything in
// in fallback state. Then we render each row in the tail one-by-one.
// That happens in the completeWork phase without going back to beginWork.


function updateSuspenseListComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps;
  var revealOrder = nextProps.revealOrder;
  var tailMode = nextProps.tail;
  var newChildren = nextProps.children;
  validateRevealOrder(revealOrder);
  validateTailOptions(tailMode, revealOrder);
  validateSuspenseListChildren(newChildren, revealOrder);
  reconcileChildren(current, workInProgress, newChildren, renderLanes);
  var suspenseContext = suspenseStackCursor.current;
  var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);

  if (shouldForceFallback) {
    suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
    workInProgress.flags |= DidCapture;
  } else {
    var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;

    if (didSuspendBefore) {
      // If we previously forced a fallback, we need to schedule work
      // on any nested boundaries to let them know to try to render
      // again. This is the same as context updating.
      propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
    }

    suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
  }

  pushSuspenseContext(workInProgress, suspenseContext);

  if ((workInProgress.mode & BlockingMode) === NoMode) {
    // In legacy mode, SuspenseList doesn't work so we just
    // use make it a noop by treating it as the default revealOrder.
    workInProgress.memoizedState = null;
  } else {
    switch (revealOrder) {
      case 'forwards':
        {
          var lastContentRow = findLastContentRow(workInProgress.child);
          var tail;

          if (lastContentRow === null) {
            // The whole list is part of the tail.
            // TODO: We could fast path by just rendering the tail now.
            tail = workInProgress.child;
            workInProgress.child = null;
          } else {
            // Disconnect the tail rows after the content row.
            // We're going to render them separately later.
            tail = lastContentRow.sibling;
            lastContentRow.sibling = null;
          }

          initSuspenseListRenderState(workInProgress, false, // isBackwards
          tail, lastContentRow, tailMode, workInProgress.lastEffect);
          break;
        }

      case 'backwards':
        {
          // We're going to find the first row that has existing content.
          // At the same time we're going to reverse the list of everything
          // we pass in the meantime. That's going to be our tail in reverse
          // order.
          var _tail = null;
          var row = workInProgress.child;
          workInProgress.child = null;

          while (row !== null) {
            var currentRow = row.alternate; // New rows can't be content rows.

            if (currentRow !== null && findFirstSuspended(currentRow) === null) {
              // This is the beginning of the main content.
              workInProgress.child = row;
              break;
            }

            var nextRow = row.sibling;
            row.sibling = _tail;
            _tail = row;
            row = nextRow;
          } // TODO: If workInProgress.child is null, we can continue on the tail immediately.


          initSuspenseListRenderState(workInProgress, true, // isBackwards
          _tail, null, // last
          tailMode, workInProgress.lastEffect);
          break;
        }

      case 'together':
        {
          initSuspenseListRenderState(workInProgress, false, // isBackwards
          null, // tail
          null, // last
          undefined, workInProgress.lastEffect);
          break;
        }

      default:
        {
          // The default reveal order is the same as not having
          // a boundary.
          workInProgress.memoizedState = null;
        }
    }
  }

  return workInProgress.child;
}

function updatePortalComponent(current, workInProgress, renderLanes) {
  pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
  var nextChildren = workInProgress.pendingProps;

  if (current === null) {
    // Portals are special because we don't append the children during mount
    // but at commit. Therefore we need to track insertions which the normal
    // flow doesn't do during mount. This doesn't happen at the root because
    // the root always starts with a "current" with a null child.
    // TODO: Consider unifying this with how the root works.
    workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
  } else {
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  }

  return workInProgress.child;
}

var hasWarnedAboutUsingNoValuePropOnContextProvider = false;

function updateContextProvider(current, workInProgress, renderLanes) {
  var providerType = workInProgress.type;
  var context = providerType._context;
  var newProps = workInProgress.pendingProps;
  var oldProps = workInProgress.memoizedProps;
  var newValue = newProps.value;

  {
    if (!('value' in newProps)) {
      if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
        hasWarnedAboutUsingNoValuePropOnContextProvider = true;

        error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
      }
    }

    var providerPropTypes = workInProgress.type.propTypes;

    if (providerPropTypes) {
      checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
    }
  }

  pushProvider(workInProgress, newValue);

  if (oldProps !== null) {
    var oldValue = oldProps.value;
    var changedBits = calculateChangedBits(context, newValue, oldValue);

    if (changedBits === 0) {
      // No change. Bailout early if children are the same.
      if (oldProps.children === newProps.children && !hasContextChanged()) {
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
      }
    } else {
      // The context value changed. Search for matching consumers and schedule
      // them to update.
      propagateContextChange(workInProgress, context, changedBits, renderLanes);
    }
  }

  var newChildren = newProps.children;
  reconcileChildren(current, workInProgress, newChildren, renderLanes);
  return workInProgress.child;
}

var hasWarnedAboutUsingContextAsConsumer = false;

function updateContextConsumer(current, workInProgress, renderLanes) {
  var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
  // DEV mode, we create a separate object for Context.Consumer that acts
  // like a proxy to Context. This proxy object adds unnecessary code in PROD
  // so we use the old behaviour (Context.Consumer references Context) to
  // reduce size and overhead. The separate object references context via
  // a property called "_context", which also gives us the ability to check
  // in DEV mode if this property exists or not and warn if it does not.

  {
    if (context._context === undefined) {
      // This may be because it's a Context (rather than a Consumer).
      // Or it may be because it's older React where they're the same thing.
      // We only want to warn if we're sure it's a new React.
      if (context !== context.Consumer) {
        if (!hasWarnedAboutUsingContextAsConsumer) {
          hasWarnedAboutUsingContextAsConsumer = true;

          error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
        }
      }
    } else {
      context = context._context;
    }
  }

  var newProps = workInProgress.pendingProps;
  var render = newProps.children;

  {
    if (typeof render !== 'function') {
      error('A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
    }
  }

  prepareToReadContext(workInProgress, renderLanes);
  var newValue = readContext(context, newProps.unstable_observedBits);
  var newChildren;

  {
    ReactCurrentOwner$1.current = workInProgress;
    setIsRendering(true);
    newChildren = render(newValue);
    setIsRendering(false);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  reconcileChildren(current, workInProgress, newChildren, renderLanes);
  return workInProgress.child;
}

function markWorkInProgressReceivedUpdate() {
  didReceiveUpdate = true;
}

function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
  if (current !== null) {
    // Reuse previous dependencies
    workInProgress.dependencies = current.dependencies;
  }

  {
    // Don't update "base" render times for bailouts.
    stopProfilerTimerIfRunning();
  }

  markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.

  if (!includesSomeLane(renderLanes, workInProgress.childLanes)) {
    // The children don't have any work either. We can skip them.
    // TODO: Once we add back resuming, we should check if the children are
    // a work-in-progress set. If so, we need to transfer their effects.
    return null;
  } else {
    // This fiber doesn't have work, but its subtree does. Clone the child
    // fibers and continue.
    cloneChildFibers(current, workInProgress);
    return workInProgress.child;
  }
}

function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
  {
    var returnFiber = oldWorkInProgress.return;

    if (returnFiber === null) {
      throw new Error('Cannot swap the root fiber.');
    } // Disconnect from the old current.
    // It will get deleted.


    current.alternate = null;
    oldWorkInProgress.alternate = null; // Connect to the new tree.

    newWorkInProgress.index = oldWorkInProgress.index;
    newWorkInProgress.sibling = oldWorkInProgress.sibling;
    newWorkInProgress.return = oldWorkInProgress.return;
    newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.

    if (oldWorkInProgress === returnFiber.child) {
      returnFiber.child = newWorkInProgress;
    } else {
      var prevSibling = returnFiber.child;

      if (prevSibling === null) {
        throw new Error('Expected parent to have a child.');
      }

      while (prevSibling.sibling !== oldWorkInProgress) {
        prevSibling = prevSibling.sibling;

        if (prevSibling === null) {
          throw new Error('Expected to find the previous sibling.');
        }
      }

      prevSibling.sibling = newWorkInProgress;
    } // Delete the old fiber and place the new one.
    // Since the old fiber is disconnected, we have to schedule it manually.


    var last = returnFiber.lastEffect;

    if (last !== null) {
      last.nextEffect = current;
      returnFiber.lastEffect = current;
    } else {
      returnFiber.firstEffect = returnFiber.lastEffect = current;
    }

    current.nextEffect = null;
    current.flags = Deletion;
    newWorkInProgress.flags |= Placement; // Restart work from the new fiber.

    return newWorkInProgress;
  }
}

function beginWork(current, workInProgress, renderLanes) {
  var updateLanes = workInProgress.lanes;

  {
    if (workInProgress._debugNeedsRemount && current !== null) {
      // This will restart the begin phase with a new fiber.
      return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
    }
  }

  if (current !== null) {
    var oldProps = current.memoizedProps;
    var newProps = workInProgress.pendingProps;

    if (oldProps !== newProps || hasContextChanged() || ( // Force a re-render if the implementation changed due to hot reload:
     workInProgress.type !== current.type )) {
      // If props or context changed, mark the fiber as having performed work.
      // This may be unset if the props are determined to be equal later (memo).
      didReceiveUpdate = true;
    } else if (!includesSomeLane(renderLanes, updateLanes)) {
      didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
      // the begin phase. There's still some bookkeeping we that needs to be done
      // in this optimized path, mostly pushing stuff onto the stack.

      switch (workInProgress.tag) {
        case HostRoot:
          pushHostRootContext(workInProgress);
          resetHydrationState();
          break;

        case HostComponent:
          pushHostContext(workInProgress);
          break;

        case ClassComponent:
          {
            var Component = workInProgress.type;

            if (isContextProvider(Component)) {
              pushContextProvider(workInProgress);
            }

            break;
          }

        case HostPortal:
          pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
          break;

        case ContextProvider:
          {
            var newValue = workInProgress.memoizedProps.value;
            pushProvider(workInProgress, newValue);
            break;
          }

        case Profiler:
          {
            // Profiler should only call onRender when one of its descendants actually rendered.
            var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

            if (hasChildWork) {
              workInProgress.flags |= Update;
            } // Reset effect durations for the next eventual effect phase.
            // These are reset during render to allow the DevTools commit hook a chance to read them,


            var stateNode = workInProgress.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
          }

          break;

        case SuspenseComponent:
          {
            var state = workInProgress.memoizedState;

            if (state !== null) {
              // whether to retry the primary children, or to skip over it and
              // go straight to the fallback. Check the priority of the primary
              // child fragment.


              var primaryChildFragment = workInProgress.child;
              var primaryChildLanes = primaryChildFragment.childLanes;

              if (includesSomeLane(renderLanes, primaryChildLanes)) {
                // The primary children have pending work. Use the normal path
                // to attempt to render the primary children again.
                return updateSuspenseComponent(current, workInProgress, renderLanes);
              } else {
                // The primary child fragment does not have pending work marked
                // on it
                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                // priority. Bailout.

                var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);

                if (child !== null) {
                  // The fallback children have pending work. Skip over the
                  // primary children and work on the fallback.
                  return child.sibling;
                } else {
                  return null;
                }
              }
            } else {
              pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
            }

            break;
          }

        case SuspenseListComponent:
          {
            var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;

            var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

            if (didSuspendBefore) {
              if (_hasChildWork) {
                // If something was in fallback state last time, and we have all the
                // same children then we're still in progressive loading state.
                // Something might get unblocked by state updates or retries in the
                // tree which will affect the tail. So we need to use the normal
                // path to compute the correct tail.
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
              } // If none of the children had any work, that means that none of
              // them got retried so they'll still be blocked in the same way
              // as before. We can fast bail out.


              workInProgress.flags |= DidCapture;
            } // If nothing suspended before and we're rendering the same children,
            // then the tail doesn't matter. Anything new that suspends will work
            // in the "together" mode, so we can continue from the state we had.


            var renderState = workInProgress.memoizedState;

            if (renderState !== null) {
              // Reset to the "together" mode in case we've started a different
              // update in the past but didn't complete it.
              renderState.rendering = null;
              renderState.tail = null;
              renderState.lastEffect = null;
            }

            pushSuspenseContext(workInProgress, suspenseStackCursor.current);

            if (_hasChildWork) {
              break;
            } else {
              // If none of the children had any work, that means that none of
              // them got retried so they'll still be blocked in the same way
              // as before. We can fast bail out.
              return null;
            }
          }

        case OffscreenComponent:
        case LegacyHiddenComponent:
          {
            // Need to check if the tree still needs to be deferred. This is
            // almost identical to the logic used in the normal update path,
            // so we'll just enter that. The only difference is we'll bail out
            // at the next level instead of this one, because the child props
            // have not changed. Which is fine.
            // TODO: Probably should refactor `beginWork` to split the bailout
            // path from the normal path. I'm tempted to do a labeled break here
            // but I won't :)
            workInProgress.lanes = NoLanes;
            return updateOffscreenComponent(current, workInProgress, renderLanes);
          }
      }

      return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    } else {
      if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
        // This is a special case that only exists for legacy mode.
        // See https://github.com/facebook/react/pull/19216.
        didReceiveUpdate = true;
      } else {
        // An update was scheduled on this fiber, but there are no new props
        // nor legacy context. Set this to false. If an update queue or context
        // consumer produces a changed value, it will set this to true. Otherwise,
        // the component will assume the children have not changed and bail out.
        didReceiveUpdate = false;
      }
    }
  } else {
    didReceiveUpdate = false;
  } // Before entering the begin phase, clear pending update priority.
  // TODO: This assumes that we're about to evaluate the component and process
  // the update queue. However, there's an exception: SimpleMemoComponent
  // sometimes bails out later in the begin phase. This indicates that we should
  // move this assignment out of the common path and into each branch.


  workInProgress.lanes = NoLanes;

  switch (workInProgress.tag) {
    case IndeterminateComponent:
      {
        return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
      }

    case LazyComponent:
      {
        var elementType = workInProgress.elementType;
        return mountLazyComponent(current, workInProgress, elementType, updateLanes, renderLanes);
      }

    case FunctionComponent:
      {
        var _Component = workInProgress.type;
        var unresolvedProps = workInProgress.pendingProps;
        var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
        return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderLanes);
      }

    case ClassComponent:
      {
        var _Component2 = workInProgress.type;
        var _unresolvedProps = workInProgress.pendingProps;

        var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);

        return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderLanes);
      }

    case HostRoot:
      return updateHostRoot(current, workInProgress, renderLanes);

    case HostComponent:
      return updateHostComponent(current, workInProgress, renderLanes);

    case HostText:
      return updateHostText(current, workInProgress);

    case SuspenseComponent:
      return updateSuspenseComponent(current, workInProgress, renderLanes);

    case HostPortal:
      return updatePortalComponent(current, workInProgress, renderLanes);

    case ForwardRef:
      {
        var type = workInProgress.type;
        var _unresolvedProps2 = workInProgress.pendingProps;

        var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);

        return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
      }

    case Fragment:
      return updateFragment(current, workInProgress, renderLanes);

    case Mode:
      return updateMode(current, workInProgress, renderLanes);

    case Profiler:
      return updateProfiler(current, workInProgress, renderLanes);

    case ContextProvider:
      return updateContextProvider(current, workInProgress, renderLanes);

    case ContextConsumer:
      return updateContextConsumer(current, workInProgress, renderLanes);

    case MemoComponent:
      {
        var _type2 = workInProgress.type;
        var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.

        var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);

        {
          if (workInProgress.type !== workInProgress.elementType) {
            var outerPropTypes = _type2.propTypes;

            if (outerPropTypes) {
              checkPropTypes(outerPropTypes, _resolvedProps3, // Resolved for outer only
              'prop', getComponentName(_type2));
            }
          }
        }

        _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
        return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateLanes, renderLanes);
      }

    case SimpleMemoComponent:
      {
        return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateLanes, renderLanes);
      }

    case IncompleteClassComponent:
      {
        var _Component3 = workInProgress.type;
        var _unresolvedProps4 = workInProgress.pendingProps;

        var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);

        return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderLanes);
      }

    case SuspenseListComponent:
      {
        return updateSuspenseListComponent(current, workInProgress, renderLanes);
      }

    case FundamentalComponent:
      {

        break;
      }

    case ScopeComponent:
      {

        break;
      }

    case Block:
      {

        break;
      }

    case OffscreenComponent:
      {
        return updateOffscreenComponent(current, workInProgress, renderLanes);
      }

    case LegacyHiddenComponent:
      {
        return updateLegacyHiddenComponent(current, workInProgress, renderLanes);
      }
  }

  {
    {
      throw Error( "Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function markUpdate(workInProgress) {
  // Tag the fiber with an update effect. This turns a Placement into
  // a PlacementAndUpdate.
  workInProgress.flags |= Update;
}

function markRef$1(workInProgress) {
  workInProgress.flags |= Ref;
}

var appendAllChildren;
var updateHostContainer;
var updateHostComponent$1;
var updateHostText$1;

{
  // Mutation mode
  appendAllChildren = function (parent, workInProgress, needsVisibilityToggle, isHidden) {
    // We only have the top Fiber that was created but we need recurse down its
    // children to find all the terminal nodes.
    var node = workInProgress.child;

    while (node !== null) {
      if (node.tag === HostComponent || node.tag === HostText) {
        appendInitialChild(parent, node.stateNode);
      } else if (node.tag === HostPortal) ; else if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }

      if (node === workInProgress) {
        return;
      }

      while (node.sibling === null) {
        if (node.return === null || node.return === workInProgress) {
          return;
        }

        node = node.return;
      }

      node.sibling.return = node.return;
      node = node.sibling;
    }
  };

  updateHostContainer = function (workInProgress) {// Noop
  };

  updateHostComponent$1 = function (current, workInProgress, type, newProps, rootContainerInstance) {
    // If we have an alternate, that means this is an update and we need to
    // schedule a side-effect to do the updates.
    var oldProps = current.memoizedProps;

    if (oldProps === newProps) {
      // In mutation mode, this is sufficient for a bailout because
      // we won't touch this node even if children changed.
      return;
    } // If we get updated because one of our children updated, we don't
    // have newProps so we'll have to reuse them.
    // TODO: Split the update API as separate for the props vs. children.
    // Even better would be if children weren't special cased at all tho.


    var instance = workInProgress.stateNode;
    var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
    // component is hitting the resume path. Figure out why. Possibly
    // related to `hidden`.

    var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.

    workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
    // is a new ref we mark this as an update. All the work is done in commitWork.

    if (updatePayload) {
      markUpdate(workInProgress);
    }
  };

  updateHostText$1 = function (current, workInProgress, oldText, newText) {
    // If the text differs, mark it as an update. All the work in done in commitWork.
    if (oldText !== newText) {
      markUpdate(workInProgress);
    }
  };
}

function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
  if (getIsHydrating()) {
    // If we're hydrating, we should consume as many items as we can
    // so we don't leave any behind.
    return;
  }

  switch (renderState.tailMode) {
    case 'hidden':
      {
        // Any insertions at the end of the tail list after this point
        // should be invisible. If there are already mounted boundaries
        // anything before them are not considered for collapsing.
        // Therefore we need to go through the whole tail to find if
        // there are any.
        var tailNode = renderState.tail;
        var lastTailNode = null;

        while (tailNode !== null) {
          if (tailNode.alternate !== null) {
            lastTailNode = tailNode;
          }

          tailNode = tailNode.sibling;
        } // Next we're simply going to delete all insertions after the
        // last rendered item.


        if (lastTailNode === null) {
          // All remaining items in the tail are insertions.
          renderState.tail = null;
        } else {
          // Detach the insertion after the last node that was already
          // inserted.
          lastTailNode.sibling = null;
        }

        break;
      }

    case 'collapsed':
      {
        // Any insertions at the end of the tail list after this point
        // should be invisible. If there are already mounted boundaries
        // anything before them are not considered for collapsing.
        // Therefore we need to go through the whole tail to find if
        // there are any.
        var _tailNode = renderState.tail;
        var _lastTailNode = null;

        while (_tailNode !== null) {
          if (_tailNode.alternate !== null) {
            _lastTailNode = _tailNode;
          }

          _tailNode = _tailNode.sibling;
        } // Next we're simply going to delete all insertions after the
        // last rendered item.


        if (_lastTailNode === null) {
          // All remaining items in the tail are insertions.
          if (!hasRenderedATailFallback && renderState.tail !== null) {
            // We suspended during the head. We want to show at least one
            // row at the tail. So we'll keep on and cut off the rest.
            renderState.tail.sibling = null;
          } else {
            renderState.tail = null;
          }
        } else {
          // Detach the insertion after the last node that was already
          // inserted.
          _lastTailNode.sibling = null;
        }

        break;
      }
  }
}

function completeWork(current, workInProgress, renderLanes) {
  var newProps = workInProgress.pendingProps;

  switch (workInProgress.tag) {
    case IndeterminateComponent:
    case LazyComponent:
    case SimpleMemoComponent:
    case FunctionComponent:
    case ForwardRef:
    case Fragment:
    case Mode:
    case Profiler:
    case ContextConsumer:
    case MemoComponent:
      return null;

    case ClassComponent:
      {
        var Component = workInProgress.type;

        if (isContextProvider(Component)) {
          popContext(workInProgress);
        }

        return null;
      }

    case HostRoot:
      {
        popHostContainer(workInProgress);
        popTopLevelContextObject(workInProgress);
        resetWorkInProgressVersions();
        var fiberRoot = workInProgress.stateNode;

        if (fiberRoot.pendingContext) {
          fiberRoot.context = fiberRoot.pendingContext;
          fiberRoot.pendingContext = null;
        }

        if (current === null || current.child === null) {
          // If we hydrated, pop so that we can delete any remaining children
          // that weren't hydrated.
          var wasHydrated = popHydrationState(workInProgress);

          if (wasHydrated) {
            // If we hydrated, then we'll need to schedule an update for
            // the commit side-effects on the root.
            markUpdate(workInProgress);
          } else if (!fiberRoot.hydrate) {
            // Schedule an effect to clear this container at the start of the next commit.
            // This handles the case of React rendering into a container with previous children.
            // It's also safe to do for updates too, because current.child would only be null
            // if the previous render was null (so the the container would already be empty).
            workInProgress.flags |= Snapshot;
          }
        }

        updateHostContainer(workInProgress);
        return null;
      }

    case HostComponent:
      {
        popHostContext(workInProgress);
        var rootContainerInstance = getRootHostContainer();
        var type = workInProgress.type;

        if (current !== null && workInProgress.stateNode != null) {
          updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);

          if (current.ref !== workInProgress.ref) {
            markRef$1(workInProgress);
          }
        } else {
          if (!newProps) {
            if (!(workInProgress.stateNode !== null)) {
              {
                throw Error( "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue." );
              }
            } // This can happen when we abort work.


            return null;
          }

          var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
          // "stack" as the parent. Then append children as we go in beginWork
          // or completeWork depending on whether we want to add them top->down or
          // bottom->up. Top->down is faster in IE11.

          var _wasHydrated = popHydrationState(workInProgress);

          if (_wasHydrated) {
            // TODO: Move this and createInstance step into the beginPhase
            // to consolidate.
            if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) {
              // If changes to the hydrated node need to be applied at the
              // commit-phase we mark this as such.
              markUpdate(workInProgress);
            }
          } else {
            var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
            appendAllChildren(instance, workInProgress, false, false);
            workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
            // (eg DOM renderer supports auto-focus for certain elements).
            // Make sure such renderers get scheduled for later work.

            if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) {
              markUpdate(workInProgress);
            }
          }

          if (workInProgress.ref !== null) {
            // If there is a ref on a host node we need to schedule a callback
            markRef$1(workInProgress);
          }
        }

        return null;
      }

    case HostText:
      {
        var newText = newProps;

        if (current && workInProgress.stateNode != null) {
          var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
          // to schedule a side-effect to do the updates.

          updateHostText$1(current, workInProgress, oldText, newText);
        } else {
          if (typeof newText !== 'string') {
            if (!(workInProgress.stateNode !== null)) {
              {
                throw Error( "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue." );
              }
            } // This can happen when we abort work.

          }

          var _rootContainerInstance = getRootHostContainer();

          var _currentHostContext = getHostContext();

          var _wasHydrated2 = popHydrationState(workInProgress);

          if (_wasHydrated2) {
            if (prepareToHydrateHostTextInstance(workInProgress)) {
              markUpdate(workInProgress);
            }
          } else {
            workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
          }
        }

        return null;
      }

    case SuspenseComponent:
      {
        popSuspenseContext(workInProgress);
        var nextState = workInProgress.memoizedState;

        if ((workInProgress.flags & DidCapture) !== NoFlags) {
          // Something suspended. Re-render with the fallback children.
          workInProgress.lanes = renderLanes; // Do not reset the effect list.

          if ( (workInProgress.mode & ProfileMode) !== NoMode) {
            transferActualDuration(workInProgress);
          }

          return workInProgress;
        }

        var nextDidTimeout = nextState !== null;
        var prevDidTimeout = false;

        if (current === null) {
          if (workInProgress.memoizedProps.fallback !== undefined) {
            popHydrationState(workInProgress);
          }
        } else {
          var prevState = current.memoizedState;
          prevDidTimeout = prevState !== null;
        }

        if (nextDidTimeout && !prevDidTimeout) {
          // If this subtreee is running in blocking mode we can suspend,
          // otherwise we won't suspend.
          // TODO: This will still suspend a synchronous tree if anything
          // in the concurrent tree already suspended during this render.
          // This is a known bug.
          if ((workInProgress.mode & BlockingMode) !== NoMode) {
            // TODO: Move this back to throwException because this is too late
            // if this is a large tree which is common for initial loads. We
            // don't know if we should restart a render or not until we get
            // this marker, and this is too late.
            // If this render already had a ping or lower pri updates,
            // and this is the first time we know we're going to suspend we
            // should be able to immediately restart from within throwException.
            var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;

            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
              // If this was in an invisible tree or a new render, then showing
              // this boundary is ok.
              renderDidSuspend();
            } else {
              // Otherwise, we're going to have to hide content so we should
              // suspend for longer if possible.
              renderDidSuspendDelayIfPossible();
            }
          }
        }

        {
          // TODO: Only schedule updates if these values are non equal, i.e. it changed.
          if (nextDidTimeout || prevDidTimeout) {
            // If this boundary just timed out, schedule an effect to attach a
            // retry listener to the promise. This flag is also used to hide the
            // primary children. In mutation mode, we also need the flag to
            // *unhide* children that were previously hidden, so check if this
            // is currently timed out, too.
            workInProgress.flags |= Update;
          }
        }

        return null;
      }

    case HostPortal:
      popHostContainer(workInProgress);
      updateHostContainer(workInProgress);

      if (current === null) {
        preparePortalMount(workInProgress.stateNode.containerInfo);
      }

      return null;

    case ContextProvider:
      // Pop provider fiber
      popProvider(workInProgress);
      return null;

    case IncompleteClassComponent:
      {
        // Same as class component case. I put it down here so that the tags are
        // sequential to ensure this switch is compiled to a jump table.
        var _Component = workInProgress.type;

        if (isContextProvider(_Component)) {
          popContext(workInProgress);
        }

        return null;
      }

    case SuspenseListComponent:
      {
        popSuspenseContext(workInProgress);
        var renderState = workInProgress.memoizedState;

        if (renderState === null) {
          // We're running in the default, "independent" mode.
          // We don't do anything in this mode.
          return null;
        }

        var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
        var renderedTail = renderState.rendering;

        if (renderedTail === null) {
          // We just rendered the head.
          if (!didSuspendAlready) {
            // This is the first pass. We need to figure out if anything is still
            // suspended in the rendered set.
            // If new content unsuspended, but there's still some content that
            // didn't. Then we need to do a second pass that forces everything
            // to keep showing their fallbacks.
            // We might be suspended if something in this render pass suspended, or
            // something in the previous committed pass suspended. Otherwise,
            // there's no chance so we can skip the expensive call to
            // findFirstSuspended.
            var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);

            if (!cannotBeSuspended) {
              var row = workInProgress.child;

              while (row !== null) {
                var suspended = findFirstSuspended(row);

                if (suspended !== null) {
                  didSuspendAlready = true;
                  workInProgress.flags |= DidCapture;
                  cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                  // part of the second pass. In that case nothing will subscribe to
                  // its thennables. Instead, we'll transfer its thennables to the
                  // SuspenseList so that it can retry if they resolve.
                  // There might be multiple of these in the list but since we're
                  // going to wait for all of them anyway, it doesn't really matter
                  // which ones gets to ping. In theory we could get clever and keep
                  // track of how many dependencies remain but it gets tricky because
                  // in the meantime, we can add/remove/change items and dependencies.
                  // We might bail out of the loop before finding any but that
                  // doesn't matter since that means that the other boundaries that
                  // we did find already has their listeners attached.

                  var newThennables = suspended.updateQueue;

                  if (newThennables !== null) {
                    workInProgress.updateQueue = newThennables;
                    workInProgress.flags |= Update;
                  } // Rerender the whole list, but this time, we'll force fallbacks
                  // to stay in place.
                  // Reset the effect list before doing the second pass since that's now invalid.


                  if (renderState.lastEffect === null) {
                    workInProgress.firstEffect = null;
                  }

                  workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.

                  resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                  // rerender the children.

                  pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                  return workInProgress.child;
                }

                row = row.sibling;
              }
            }

            if (renderState.tail !== null && now() > getRenderTargetTime()) {
              // We have already passed our CPU deadline but we still have rows
              // left in the tail. We'll just give up further attempts to render
              // the main content and only render fallbacks.
              workInProgress.flags |= DidCapture;
              didSuspendAlready = true;
              cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
              // to get it started back up to attempt the next item. While in terms
              // of priority this work has the same priority as this current render,
              // it's not part of the same transition once the transition has
              // committed. If it's sync, we still want to yield so that it can be
              // painted. Conceptually, this is really the same as pinging.
              // We can use any RetryLane even if it's the one currently rendering
              // since we're leaving it behind on this node.

              workInProgress.lanes = SomeRetryLane;

              {
                markSpawnedWork(SomeRetryLane);
              }
            }
          } else {
            cutOffTailIfNeeded(renderState, false);
          } // Next we're going to render the tail.

        } else {
          // Append the rendered row to the child list.
          if (!didSuspendAlready) {
            var _suspended = findFirstSuspended(renderedTail);

            if (_suspended !== null) {
              workInProgress.flags |= DidCapture;
              didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
              // get lost if this row ends up dropped during a second pass.

              var _newThennables = _suspended.updateQueue;

              if (_newThennables !== null) {
                workInProgress.updateQueue = _newThennables;
                workInProgress.flags |= Update;
              }

              cutOffTailIfNeeded(renderState, true); // This might have been modified.

              if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
              ) {
                  // We need to delete the row we just rendered.
                  // Reset the effect list to what it was before we rendered this
                  // child. The nested children have already appended themselves.
                  var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.

                  if (lastEffect !== null) {
                    lastEffect.nextEffect = null;
                  } // We're done.


                  return null;
                }
            } else if ( // The time it took to render last row is greater than the remaining
            // time we have to render. So rendering one more row would likely
            // exceed it.
            now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
              // We have now passed our CPU deadline and we'll just give up further
              // attempts to render the main content and only render fallbacks.
              // The assumption is that this is usually faster.
              workInProgress.flags |= DidCapture;
              didSuspendAlready = true;
              cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
              // to get it started back up to attempt the next item. While in terms
              // of priority this work has the same priority as this current render,
              // it's not part of the same transition once the transition has
              // committed. If it's sync, we still want to yield so that it can be
              // painted. Conceptually, this is really the same as pinging.
              // We can use any RetryLane even if it's the one currently rendering
              // since we're leaving it behind on this node.

              workInProgress.lanes = SomeRetryLane;

              {
                markSpawnedWork(SomeRetryLane);
              }
            }
          }

          if (renderState.isBackwards) {
            // The effect list of the backwards tail will have been added
            // to the end. This breaks the guarantee that life-cycles fire in
            // sibling order but that isn't a strong guarantee promised by React.
            // Especially since these might also just pop in during future commits.
            // Append to the beginning of the list.
            renderedTail.sibling = workInProgress.child;
            workInProgress.child = renderedTail;
          } else {
            var previousSibling = renderState.last;

            if (previousSibling !== null) {
              previousSibling.sibling = renderedTail;
            } else {
              workInProgress.child = renderedTail;
            }

            renderState.last = renderedTail;
          }
        }

        if (renderState.tail !== null) {
          // We still have tail rows to render.
          // Pop a row.
          var next = renderState.tail;
          renderState.rendering = next;
          renderState.tail = next.sibling;
          renderState.lastEffect = workInProgress.lastEffect;
          renderState.renderingStartTime = now();
          next.sibling = null; // Restore the context.
          // TODO: We can probably just avoid popping it instead and only
          // setting it the first time we go from not suspended to suspended.

          var suspenseContext = suspenseStackCursor.current;

          if (didSuspendAlready) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
          } else {
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
          }

          pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.

          return next;
        }

        return null;
      }

    case FundamentalComponent:
      {

        break;
      }

    case ScopeComponent:
      {

        break;
      }

    case Block:

      break;

    case OffscreenComponent:
    case LegacyHiddenComponent:
      {
        popRenderLanes(workInProgress);

        if (current !== null) {
          var _nextState = workInProgress.memoizedState;
          var _prevState = current.memoizedState;
          var prevIsHidden = _prevState !== null;
          var nextIsHidden = _nextState !== null;

          if (prevIsHidden !== nextIsHidden && newProps.mode !== 'unstable-defer-without-hiding') {
            workInProgress.flags |= Update;
          }
        }

        return null;
      }
  }

  {
    {
      throw Error( "Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function unwindWork(workInProgress, renderLanes) {
  switch (workInProgress.tag) {
    case ClassComponent:
      {
        var Component = workInProgress.type;

        if (isContextProvider(Component)) {
          popContext(workInProgress);
        }

        var flags = workInProgress.flags;

        if (flags & ShouldCapture) {
          workInProgress.flags = flags & ~ShouldCapture | DidCapture;

          if ( (workInProgress.mode & ProfileMode) !== NoMode) {
            transferActualDuration(workInProgress);
          }

          return workInProgress;
        }

        return null;
      }

    case HostRoot:
      {
        popHostContainer(workInProgress);
        popTopLevelContextObject(workInProgress);
        resetWorkInProgressVersions();
        var _flags = workInProgress.flags;

        if (!((_flags & DidCapture) === NoFlags)) {
          {
            throw Error( "The root failed to unmount after an error. This is likely a bug in React. Please file an issue." );
          }
        }

        workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
        return workInProgress;
      }

    case HostComponent:
      {
        // TODO: popHydrationState
        popHostContext(workInProgress);
        return null;
      }

    case SuspenseComponent:
      {
        popSuspenseContext(workInProgress);

        var _flags2 = workInProgress.flags;

        if (_flags2 & ShouldCapture) {
          workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.

          if ( (workInProgress.mode & ProfileMode) !== NoMode) {
            transferActualDuration(workInProgress);
          }

          return workInProgress;
        }

        return null;
      }

    case SuspenseListComponent:
      {
        popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
        // caught by a nested boundary. If not, it should bubble through.

        return null;
      }

    case HostPortal:
      popHostContainer(workInProgress);
      return null;

    case ContextProvider:
      popProvider(workInProgress);
      return null;

    case OffscreenComponent:
    case LegacyHiddenComponent:
      popRenderLanes(workInProgress);
      return null;

    default:
      return null;
  }
}

function unwindInterruptedWork(interruptedWork) {
  switch (interruptedWork.tag) {
    case ClassComponent:
      {
        var childContextTypes = interruptedWork.type.childContextTypes;

        if (childContextTypes !== null && childContextTypes !== undefined) {
          popContext(interruptedWork);
        }

        break;
      }

    case HostRoot:
      {
        popHostContainer(interruptedWork);
        popTopLevelContextObject(interruptedWork);
        resetWorkInProgressVersions();
        break;
      }

    case HostComponent:
      {
        popHostContext(interruptedWork);
        break;
      }

    case HostPortal:
      popHostContainer(interruptedWork);
      break;

    case SuspenseComponent:
      popSuspenseContext(interruptedWork);
      break;

    case SuspenseListComponent:
      popSuspenseContext(interruptedWork);
      break;

    case ContextProvider:
      popProvider(interruptedWork);
      break;

    case OffscreenComponent:
    case LegacyHiddenComponent:
      popRenderLanes(interruptedWork);
      break;
  }
}

function createCapturedValue(value, source) {
  // If the value is an error, call this function immediately after it is thrown
  // so the stack is accurate.
  return {
    value: value,
    source: source,
    stack: getStackByFiberInDevAndProd(source)
  };
}

// This module is forked in different environments.
// By default, return `true` to log errors to the console.
// Forks can return `false` if this isn't desirable.
function showErrorDialog(boundary, errorInfo) {
  return true;
}

function logCapturedError(boundary, errorInfo) {
  try {
    var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
    // This enables renderers like ReactNative to better manage redbox behavior.

    if (logError === false) {
      return;
    }

    var error = errorInfo.value;

    if (true) {
      var source = errorInfo.source;
      var stack = errorInfo.stack;
      var componentStack = stack !== null ? stack : ''; // Browsers support silencing uncaught errors by calling
      // `preventDefault()` in window `error` handler.
      // We record this information as an expando on the error.

      if (error != null && error._suppressLogging) {
        if (boundary.tag === ClassComponent) {
          // The error is recoverable and was silenced.
          // Ignore it and don't print the stack addendum.
          // This is handy for testing error boundaries without noise.
          return;
        } // The error is fatal. Since the silencing might have
        // been accidental, we'll surface it anyway.
        // However, the browser would have silenced the original error
        // so we'll print it first, and then print the stack addendum.


        console['error'](error); // Don't transform to our wrapper
        // For a more detailed description of this block, see:
        // https://github.com/facebook/react/pull/13384
      }

      var componentName = source ? getComponentName(source.type) : null;
      var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
      var errorBoundaryMessage;
      var errorBoundaryName = getComponentName(boundary.type);

      if (errorBoundaryName) {
        errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
      } else {
        errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.';
      }

      var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
      // We don't include the original error message and JS stack because the browser
      // has already printed it. Even if the application swallows the error, it is still
      // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.

      console['error'](combinedMessage); // Don't transform to our wrapper
    } else {}
  } catch (e) {
    // This method must not throw, or React internal state will get messed up.
    // If console.error is overridden, or logCapturedError() shows a dialog that throws,
    // we want to report this error outside of the normal stack as a last resort.
    // https://github.com/facebook/react/issues/13188
    setTimeout(function () {
      throw e;
    });
  }
}

var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;

function createRootErrorUpdate(fiber, errorInfo, lane) {
  var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.

  update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
  // being called "element".

  update.payload = {
    element: null
  };
  var error = errorInfo.value;

  update.callback = function () {
    onUncaughtError(error);
    logCapturedError(fiber, errorInfo);
  };

  return update;
}

function createClassErrorUpdate(fiber, errorInfo, lane) {
  var update = createUpdate(NoTimestamp, lane);
  update.tag = CaptureUpdate;
  var getDerivedStateFromError = fiber.type.getDerivedStateFromError;

  if (typeof getDerivedStateFromError === 'function') {
    var error$1 = errorInfo.value;

    update.payload = function () {
      logCapturedError(fiber, errorInfo);
      return getDerivedStateFromError(error$1);
    };
  }

  var inst = fiber.stateNode;

  if (inst !== null && typeof inst.componentDidCatch === 'function') {
    update.callback = function callback() {
      {
        markFailedErrorBoundaryForHotReloading(fiber);
      }

      if (typeof getDerivedStateFromError !== 'function') {
        // To preserve the preexisting retry behavior of error boundaries,
        // we keep track of which ones already failed during this batch.
        // This gets reset before we yield back to the browser.
        // TODO: Warn in strict mode if getDerivedStateFromError is
        // not defined.
        markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined

        logCapturedError(fiber, errorInfo);
      }

      var error$1 = errorInfo.value;
      var stack = errorInfo.stack;
      this.componentDidCatch(error$1, {
        componentStack: stack !== null ? stack : ''
      });

      {
        if (typeof getDerivedStateFromError !== 'function') {
          // If componentDidCatch is the only error boundary method defined,
          // then it needs to call setState to recover from errors.
          // If no state update is scheduled then the boundary will swallow the error.
          if (!includesSomeLane(fiber.lanes, SyncLane)) {
            error('%s: Error boundaries should implement getDerivedStateFromError(). ' + 'In that method, return a state update to display an error message or fallback UI.', getComponentName(fiber.type) || 'Unknown');
          }
        }
      }
    };
  } else {
    update.callback = function () {
      markFailedErrorBoundaryForHotReloading(fiber);
    };
  }

  return update;
}

function attachPingListener(root, wakeable, lanes) {
  // Attach a listener to the promise to "ping" the root and retry. But only if
  // one does not already exist for the lanes we're currently rendering (which
  // acts like a "thread ID" here).
  var pingCache = root.pingCache;
  var threadIDs;

  if (pingCache === null) {
    pingCache = root.pingCache = new PossiblyWeakMap$1();
    threadIDs = new Set();
    pingCache.set(wakeable, threadIDs);
  } else {
    threadIDs = pingCache.get(wakeable);

    if (threadIDs === undefined) {
      threadIDs = new Set();
      pingCache.set(wakeable, threadIDs);
    }
  }

  if (!threadIDs.has(lanes)) {
    // Memoize using the thread ID to prevent redundant listeners.
    threadIDs.add(lanes);
    var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
    wakeable.then(ping, ping);
  }
}

function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
  // The source fiber did not complete.
  sourceFiber.flags |= Incomplete; // Its effect list is no longer valid.

  sourceFiber.firstEffect = sourceFiber.lastEffect = null;

  if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
    // This is a wakeable.
    var wakeable = value;

    if ((sourceFiber.mode & BlockingMode) === NoMode) {
      // Reset the memoizedState to what it was before we attempted
      // to render it.
      var currentSource = sourceFiber.alternate;

      if (currentSource) {
        sourceFiber.updateQueue = currentSource.updateQueue;
        sourceFiber.memoizedState = currentSource.memoizedState;
        sourceFiber.lanes = currentSource.lanes;
      } else {
        sourceFiber.updateQueue = null;
        sourceFiber.memoizedState = null;
      }
    }

    var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.

    var _workInProgress = returnFiber;

    do {
      if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
        // Found the nearest boundary.
        // Stash the promise on the boundary fiber. If the boundary times out, we'll
        // attach another listener to flip the boundary back to its normal state.
        var wakeables = _workInProgress.updateQueue;

        if (wakeables === null) {
          var updateQueue = new Set();
          updateQueue.add(wakeable);
          _workInProgress.updateQueue = updateQueue;
        } else {
          wakeables.add(wakeable);
        } // If the boundary is outside of blocking mode, we should *not*
        // suspend the commit. Pretend as if the suspended component rendered
        // null and keep rendering. In the commit phase, we'll schedule a
        // subsequent synchronous update to re-render the Suspense.
        //
        // Note: It doesn't matter whether the component that suspended was
        // inside a blocking mode tree. If the Suspense is outside of it, we
        // should *not* suspend the commit.


        if ((_workInProgress.mode & BlockingMode) === NoMode) {
          _workInProgress.flags |= DidCapture;
          sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
          // But we shouldn't call any lifecycle methods or callbacks. Remove
          // all lifecycle effect tags.

          sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);

          if (sourceFiber.tag === ClassComponent) {
            var currentSourceFiber = sourceFiber.alternate;

            if (currentSourceFiber === null) {
              // This is a new mount. Change the tag so it's not mistaken for a
              // completed class component. For example, we should not call
              // componentWillUnmount if it is deleted.
              sourceFiber.tag = IncompleteClassComponent;
            } else {
              // When we try rendering again, we should not reuse the current fiber,
              // since it's known to be in an inconsistent state. Use a force update to
              // prevent a bail out.
              var update = createUpdate(NoTimestamp, SyncLane);
              update.tag = ForceUpdate;
              enqueueUpdate(sourceFiber, update);
            }
          } // The source fiber did not complete. Mark it with Sync priority to
          // indicate that it still has pending work.


          sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane); // Exit without suspending.

          return;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.


        attachPingListener(root, wakeable, rootRenderLanes);
        _workInProgress.flags |= ShouldCapture;
        _workInProgress.lanes = rootRenderLanes;
        return;
      } // This boundary already captured during this render. Continue to the next
      // boundary.


      _workInProgress = _workInProgress.return;
    } while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
    // TODO: Use invariant so the message is stripped in prod?


    value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.');
  } // We didn't find a boundary that could handle this type of exception. Start
  // over and traverse parent path again, this time treating the exception
  // as an error.


  renderDidError();
  value = createCapturedValue(value, sourceFiber);
  var workInProgress = returnFiber;

  do {
    switch (workInProgress.tag) {
      case HostRoot:
        {
          var _errorInfo = value;
          workInProgress.flags |= ShouldCapture;
          var lane = pickArbitraryLane(rootRenderLanes);
          workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);

          var _update = createRootErrorUpdate(workInProgress, _errorInfo, lane);

          enqueueCapturedUpdate(workInProgress, _update);
          return;
        }

      case ClassComponent:
        // Capture and retry
        var errorInfo = value;
        var ctor = workInProgress.type;
        var instance = workInProgress.stateNode;

        if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
          workInProgress.flags |= ShouldCapture;

          var _lane = pickArbitraryLane(rootRenderLanes);

          workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state

          var _update2 = createClassErrorUpdate(workInProgress, errorInfo, _lane);

          enqueueCapturedUpdate(workInProgress, _update2);
          return;
        }

        break;
    }

    workInProgress = workInProgress.return;
  } while (workInProgress !== null);
}

var didWarnAboutUndefinedSnapshotBeforeUpdate = null;

{
  didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
}

var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;

var callComponentWillUnmountWithTimer = function (current, instance) {
  instance.props = current.memoizedProps;
  instance.state = current.memoizedState;

  {
    instance.componentWillUnmount();
  }
}; // Capture errors so they don't interrupt unmounting.


function safelyCallComponentWillUnmount(current, instance) {
  {
    invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);

    if (hasCaughtError()) {
      var unmountError = clearCaughtError();
      captureCommitPhaseError(current, unmountError);
    }
  }
}

function safelyDetachRef(current) {
  var ref = current.ref;

  if (ref !== null) {
    if (typeof ref === 'function') {
      {
        invokeGuardedCallback(null, ref, null, null);

        if (hasCaughtError()) {
          var refError = clearCaughtError();
          captureCommitPhaseError(current, refError);
        }
      }
    } else {
      ref.current = null;
    }
  }
}

function safelyCallDestroy(current, destroy) {
  {
    invokeGuardedCallback(null, destroy, null);

    if (hasCaughtError()) {
      var error = clearCaughtError();
      captureCommitPhaseError(current, error);
    }
  }
}

function commitBeforeMutationLifeCycles(current, finishedWork) {
  switch (finishedWork.tag) {
    case FunctionComponent:
    case ForwardRef:
    case SimpleMemoComponent:
    case Block:
      {
        return;
      }

    case ClassComponent:
      {
        if (finishedWork.flags & Snapshot) {
          if (current !== null) {
            var prevProps = current.memoizedProps;
            var prevState = current.memoizedState;
            var instance = finishedWork.stateNode; // We could update instance props and state here,
            // but instead we rely on them being set during last render.
            // TODO: revisit this when we implement resuming.

            {
              if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                if (instance.props !== finishedWork.memoizedProps) {
                  error('Expected %s props to match memoized props before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }

                if (instance.state !== finishedWork.memoizedState) {
                  error('Expected %s state to match memoized state before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }
              }
            }

            var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);

            {
              var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;

              if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                didWarnSet.add(finishedWork.type);

                error('%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentName(finishedWork.type));
              }
            }

            instance.__reactInternalSnapshotBeforeUpdate = snapshot;
          }
        }

        return;
      }

    case HostRoot:
      {
        {
          if (finishedWork.flags & Snapshot) {
            var root = finishedWork.stateNode;
            clearContainer(root.containerInfo);
          }
        }

        return;
      }

    case HostComponent:
    case HostText:
    case HostPortal:
    case IncompleteClassComponent:
      // Nothing to do for these component types
      return;
  }

  {
    {
      throw Error( "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function commitHookEffectListUnmount(tag, finishedWork) {
  var updateQueue = finishedWork.updateQueue;
  var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

  if (lastEffect !== null) {
    var firstEffect = lastEffect.next;
    var effect = firstEffect;

    do {
      if ((effect.tag & tag) === tag) {
        // Unmount
        var destroy = effect.destroy;
        effect.destroy = undefined;

        if (destroy !== undefined) {
          destroy();
        }
      }

      effect = effect.next;
    } while (effect !== firstEffect);
  }
}

function commitHookEffectListMount(tag, finishedWork) {
  var updateQueue = finishedWork.updateQueue;
  var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

  if (lastEffect !== null) {
    var firstEffect = lastEffect.next;
    var effect = firstEffect;

    do {
      if ((effect.tag & tag) === tag) {
        // Mount
        var create = effect.create;
        effect.destroy = create();

        {
          var destroy = effect.destroy;

          if (destroy !== undefined && typeof destroy !== 'function') {
            var addendum = void 0;

            if (destroy === null) {
              addendum = ' You returned null. If your effect does not require clean ' + 'up, return undefined (or nothing).';
            } else if (typeof destroy.then === 'function') {
              addendum = '\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + 'useEffect(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching';
            } else {
              addendum = ' You returned: ' + destroy;
            }

            error('An effect function must not return anything besides a function, ' + 'which is used for clean-up.%s', addendum);
          }
        }
      }

      effect = effect.next;
    } while (effect !== firstEffect);
  }
}

function schedulePassiveEffects(finishedWork) {
  var updateQueue = finishedWork.updateQueue;
  var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

  if (lastEffect !== null) {
    var firstEffect = lastEffect.next;
    var effect = firstEffect;

    do {
      var _effect = effect,
          next = _effect.next,
          tag = _effect.tag;

      if ((tag & Passive$1) !== NoFlags$1 && (tag & HasEffect) !== NoFlags$1) {
        enqueuePendingPassiveHookEffectUnmount(finishedWork, effect);
        enqueuePendingPassiveHookEffectMount(finishedWork, effect);
      }

      effect = next;
    } while (effect !== firstEffect);
  }
}

function commitLifeCycles(finishedRoot, current, finishedWork, committedLanes) {
  switch (finishedWork.tag) {
    case FunctionComponent:
    case ForwardRef:
    case SimpleMemoComponent:
    case Block:
      {
        // At this point layout effects have already been destroyed (during mutation phase).
        // This is done to prevent sibling component effects from interfering with each other,
        // e.g. a destroy function in one component should never override a ref set
        // by a create function in another component during the same commit.
        {
          commitHookEffectListMount(Layout | HasEffect, finishedWork);
        }

        schedulePassiveEffects(finishedWork);
        return;
      }

    case ClassComponent:
      {
        var instance = finishedWork.stateNode;

        if (finishedWork.flags & Update) {
          if (current === null) {
            // We could update instance props and state here,
            // but instead we rely on them being set during last render.
            // TODO: revisit this when we implement resuming.
            {
              if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                if (instance.props !== finishedWork.memoizedProps) {
                  error('Expected %s props to match memoized props before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }

                if (instance.state !== finishedWork.memoizedState) {
                  error('Expected %s state to match memoized state before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }
              }
            }

            {
              instance.componentDidMount();
            }
          } else {
            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
            var prevState = current.memoizedState; // We could update instance props and state here,
            // but instead we rely on them being set during last render.
            // TODO: revisit this when we implement resuming.

            {
              if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                if (instance.props !== finishedWork.memoizedProps) {
                  error('Expected %s props to match memoized props before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }

                if (instance.state !== finishedWork.memoizedState) {
                  error('Expected %s state to match memoized state before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }
              }
            }

            {
              instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
            }
          }
        } // TODO: I think this is now always non-null by the time it reaches the
        // commit phase. Consider removing the type check.


        var updateQueue = finishedWork.updateQueue;

        if (updateQueue !== null) {
          {
            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
              if (instance.props !== finishedWork.memoizedProps) {
                error('Expected %s props to match memoized props before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
              }

              if (instance.state !== finishedWork.memoizedState) {
                error('Expected %s state to match memoized state before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
              }
            }
          } // We could update instance props and state here,
          // but instead we rely on them being set during last render.
          // TODO: revisit this when we implement resuming.


          commitUpdateQueue(finishedWork, updateQueue, instance);
        }

        return;
      }

    case HostRoot:
      {
        // TODO: I think this is now always non-null by the time it reaches the
        // commit phase. Consider removing the type check.
        var _updateQueue = finishedWork.updateQueue;

        if (_updateQueue !== null) {
          var _instance = null;

          if (finishedWork.child !== null) {
            switch (finishedWork.child.tag) {
              case HostComponent:
                _instance = getPublicInstance(finishedWork.child.stateNode);
                break;

              case ClassComponent:
                _instance = finishedWork.child.stateNode;
                break;
            }
          }

          commitUpdateQueue(finishedWork, _updateQueue, _instance);
        }

        return;
      }

    case HostComponent:
      {
        var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
        // (eg DOM renderer may schedule auto-focus for inputs and form controls).
        // These effects should only be committed when components are first mounted,
        // aka when there is no current/alternate.

        if (current === null && finishedWork.flags & Update) {
          var type = finishedWork.type;
          var props = finishedWork.memoizedProps;
          commitMount(_instance2, type, props);
        }

        return;
      }

    case HostText:
      {
        // We have no life-cycles associated with text.
        return;
      }

    case HostPortal:
      {
        // We have no life-cycles associated with portals.
        return;
      }

    case Profiler:
      {
        {
          var _finishedWork$memoize2 = finishedWork.memoizedProps,
              onCommit = _finishedWork$memoize2.onCommit,
              onRender = _finishedWork$memoize2.onRender;
          var effectDuration = finishedWork.stateNode.effectDuration;
          var commitTime = getCommitTime();

          if (typeof onRender === 'function') {
            {
              onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime, finishedRoot.memoizedInteractions);
            }
          }
        }

        return;
      }

    case SuspenseComponent:
      {
        commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
        return;
      }

    case SuspenseListComponent:
    case IncompleteClassComponent:
    case FundamentalComponent:
    case ScopeComponent:
    case OffscreenComponent:
    case LegacyHiddenComponent:
      return;
  }

  {
    {
      throw Error( "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function hideOrUnhideAllChildren(finishedWork, isHidden) {
  {
    // We only have the top Fiber that was inserted but we need to recurse down its
    // children to find all the terminal nodes.
    var node = finishedWork;

    while (true) {
      if (node.tag === HostComponent) {
        var instance = node.stateNode;

        if (isHidden) {
          hideInstance(instance);
        } else {
          unhideInstance(node.stateNode, node.memoizedProps);
        }
      } else if (node.tag === HostText) {
        var _instance3 = node.stateNode;

        if (isHidden) {
          hideTextInstance(_instance3);
        } else {
          unhideTextInstance(_instance3, node.memoizedProps);
        }
      } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ; else if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }

      if (node === finishedWork) {
        return;
      }

      while (node.sibling === null) {
        if (node.return === null || node.return === finishedWork) {
          return;
        }

        node = node.return;
      }

      node.sibling.return = node.return;
      node = node.sibling;
    }
  }
}

function commitAttachRef(finishedWork) {
  var ref = finishedWork.ref;

  if (ref !== null) {
    var instance = finishedWork.stateNode;
    var instanceToUse;

    switch (finishedWork.tag) {
      case HostComponent:
        instanceToUse = getPublicInstance(instance);
        break;

      default:
        instanceToUse = instance;
    } // Moved outside to ensure DCE works with this flag

    if (typeof ref === 'function') {
      ref(instanceToUse);
    } else {
      {
        if (!ref.hasOwnProperty('current')) {
          error('Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().', getComponentName(finishedWork.type));
        }
      }

      ref.current = instanceToUse;
    }
  }
}

function commitDetachRef(current) {
  var currentRef = current.ref;

  if (currentRef !== null) {
    if (typeof currentRef === 'function') {
      currentRef(null);
    } else {
      currentRef.current = null;
    }
  }
} // User-originating errors (lifecycles and refs) should not interrupt
// deletion, so don't let them throw. Host-originating errors should
// interrupt deletion, so it's okay


function commitUnmount(finishedRoot, current, renderPriorityLevel) {
  onCommitUnmount(current);

  switch (current.tag) {
    case FunctionComponent:
    case ForwardRef:
    case MemoComponent:
    case SimpleMemoComponent:
    case Block:
      {
        var updateQueue = current.updateQueue;

        if (updateQueue !== null) {
          var lastEffect = updateQueue.lastEffect;

          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;

            do {
              var _effect2 = effect,
                  destroy = _effect2.destroy,
                  tag = _effect2.tag;

              if (destroy !== undefined) {
                if ((tag & Passive$1) !== NoFlags$1) {
                  enqueuePendingPassiveHookEffectUnmount(current, effect);
                } else {
                  {
                    safelyCallDestroy(current, destroy);
                  }
                }
              }

              effect = effect.next;
            } while (effect !== firstEffect);
          }
        }

        return;
      }

    case ClassComponent:
      {
        safelyDetachRef(current);
        var instance = current.stateNode;

        if (typeof instance.componentWillUnmount === 'function') {
          safelyCallComponentWillUnmount(current, instance);
        }

        return;
      }

    case HostComponent:
      {
        safelyDetachRef(current);
        return;
      }

    case HostPortal:
      {
        // TODO: this is recursive.
        // We are also not using this parent because
        // the portal will get pushed immediately.
        {
          unmountHostComponents(finishedRoot, current);
        }

        return;
      }

    case FundamentalComponent:
      {

        return;
      }

    case DehydratedFragment:
      {

        return;
      }

    case ScopeComponent:
      {

        return;
      }
  }
}

function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
  // While we're inside a removed host node we don't want to call
  // removeChild on the inner nodes because they're removed by the top
  // call anyway. We also want to call componentWillUnmount on all
  // composites before this host node is removed from the tree. Therefore
  // we do an inner loop while we're still inside the host node.
  var node = root;

  while (true) {
    commitUnmount(finishedRoot, node); // Visit children because they may contain more composite or host nodes.
    // Skip portals because commitUnmount() currently visits them recursively.

    if (node.child !== null && ( // If we use mutation we drill down into portals using commitUnmount above.
    // If we don't use mutation we drill down into portals here instead.
     node.tag !== HostPortal)) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === root) {
      return;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === root) {
        return;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }
}

function detachFiberMutation(fiber) {
  // Cut off the return pointers to disconnect it from the tree. Ideally, we
  // should clear the child pointer of the parent alternate to let this
  // get GC:ed but we don't know which for sure which parent is the current
  // one so we'll settle for GC:ing the subtree of this child. This child
  // itself will be GC:ed when the parent updates the next time.
  // Note: we cannot null out sibling here, otherwise it can cause issues
  // with findDOMNode and how it requires the sibling field to carry out
  // traversal in a later effect. See PR #16820. We now clear the sibling
  // field after effects, see: detachFiberAfterEffects.
  //
  // Don't disconnect stateNode now; it will be detached in detachFiberAfterEffects.
  // It may be required if the current component is an error boundary,
  // and one of its descendants throws while unmounting a passive effect.
  fiber.alternate = null;
  fiber.child = null;
  fiber.dependencies = null;
  fiber.firstEffect = null;
  fiber.lastEffect = null;
  fiber.memoizedProps = null;
  fiber.memoizedState = null;
  fiber.pendingProps = null;
  fiber.return = null;
  fiber.updateQueue = null;

  {
    fiber._debugOwner = null;
  }
}

function getHostParentFiber(fiber) {
  var parent = fiber.return;

  while (parent !== null) {
    if (isHostParent(parent)) {
      return parent;
    }

    parent = parent.return;
  }

  {
    {
      throw Error( "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function isHostParent(fiber) {
  return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
}

function getHostSibling(fiber) {
  // We're going to search forward into the tree until we find a sibling host
  // node. Unfortunately, if multiple insertions are done in a row we have to
  // search past them. This leads to exponential search for the next sibling.
  // TODO: Find a more efficient way to do this.
  var node = fiber;

  siblings: while (true) {
    // If we didn't find anything, let's try the next sibling.
    while (node.sibling === null) {
      if (node.return === null || isHostParent(node.return)) {
        // If we pop out of the root or hit the parent the fiber we are the
        // last sibling.
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;

    while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
      // If it is not host node and, we might have a host node inside it.
      // Try to search down until we find one.
      if (node.flags & Placement) {
        // If we don't have a child, try the siblings instead.
        continue siblings;
      } // If we don't have a child, try the siblings instead.
      // We also skip portals because they are not part of this host tree.


      if (node.child === null || node.tag === HostPortal) {
        continue siblings;
      } else {
        node.child.return = node;
        node = node.child;
      }
    } // Check if this host node is stable or about to be placed.


    if (!(node.flags & Placement)) {
      // Found it!
      return node.stateNode;
    }
  }
}

function commitPlacement(finishedWork) {


  var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.

  var parent;
  var isContainer;
  var parentStateNode = parentFiber.stateNode;

  switch (parentFiber.tag) {
    case HostComponent:
      parent = parentStateNode;
      isContainer = false;
      break;

    case HostRoot:
      parent = parentStateNode.containerInfo;
      isContainer = true;
      break;

    case HostPortal:
      parent = parentStateNode.containerInfo;
      isContainer = true;
      break;

    case FundamentalComponent:

    // eslint-disable-next-line-no-fallthrough

    default:
      {
        {
          throw Error( "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue." );
        }
      }

  }

  if (parentFiber.flags & ContentReset) {
    // Reset the text content of the parent before doing any insertions
    resetTextContent(parent); // Clear ContentReset from the effect tag

    parentFiber.flags &= ~ContentReset;
  }

  var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
  // children to find all the terminal nodes.

  if (isContainer) {
    insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
  } else {
    insertOrAppendPlacementNode(finishedWork, before, parent);
  }
}

function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
  var tag = node.tag;
  var isHost = tag === HostComponent || tag === HostText;

  if (isHost || enableFundamentalAPI ) {
    var stateNode = isHost ? node.stateNode : node.stateNode.instance;

    if (before) {
      insertInContainerBefore(parent, stateNode, before);
    } else {
      appendChildToContainer(parent, stateNode);
    }
  } else if (tag === HostPortal) ; else {
    var child = node.child;

    if (child !== null) {
      insertOrAppendPlacementNodeIntoContainer(child, before, parent);
      var sibling = child.sibling;

      while (sibling !== null) {
        insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
        sibling = sibling.sibling;
      }
    }
  }
}

function insertOrAppendPlacementNode(node, before, parent) {
  var tag = node.tag;
  var isHost = tag === HostComponent || tag === HostText;

  if (isHost || enableFundamentalAPI ) {
    var stateNode = isHost ? node.stateNode : node.stateNode.instance;

    if (before) {
      insertBefore(parent, stateNode, before);
    } else {
      appendChild(parent, stateNode);
    }
  } else if (tag === HostPortal) ; else {
    var child = node.child;

    if (child !== null) {
      insertOrAppendPlacementNode(child, before, parent);
      var sibling = child.sibling;

      while (sibling !== null) {
        insertOrAppendPlacementNode(sibling, before, parent);
        sibling = sibling.sibling;
      }
    }
  }
}

function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
  // We only have the top Fiber that was deleted but we need to recurse down its
  // children to find all the terminal nodes.
  var node = current; // Each iteration, currentParent is populated with node's host parent if not
  // currentParentIsValid.

  var currentParentIsValid = false; // Note: these two variables *must* always be updated together.

  var currentParent;
  var currentParentIsContainer;

  while (true) {
    if (!currentParentIsValid) {
      var parent = node.return;

      findParent: while (true) {
        if (!(parent !== null)) {
          {
            throw Error( "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue." );
          }
        }

        var parentStateNode = parent.stateNode;

        switch (parent.tag) {
          case HostComponent:
            currentParent = parentStateNode;
            currentParentIsContainer = false;
            break findParent;

          case HostRoot:
            currentParent = parentStateNode.containerInfo;
            currentParentIsContainer = true;
            break findParent;

          case HostPortal:
            currentParent = parentStateNode.containerInfo;
            currentParentIsContainer = true;
            break findParent;

        }

        parent = parent.return;
      }

      currentParentIsValid = true;
    }

    if (node.tag === HostComponent || node.tag === HostText) {
      commitNestedUnmounts(finishedRoot, node); // After all the children have unmounted, it is now safe to remove the
      // node from the tree.

      if (currentParentIsContainer) {
        removeChildFromContainer(currentParent, node.stateNode);
      } else {
        removeChild(currentParent, node.stateNode);
      } // Don't visit children because we already visited them.

    } else if (node.tag === HostPortal) {
      if (node.child !== null) {
        // When we go into a portal, it becomes the parent to remove from.
        // We will reassign it back when we pop the portal on the way up.
        currentParent = node.stateNode.containerInfo;
        currentParentIsContainer = true; // Visit children because portals might contain host components.

        node.child.return = node;
        node = node.child;
        continue;
      }
    } else {
      commitUnmount(finishedRoot, node); // Visit children because we may find more host components below.

      if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }
    }

    if (node === current) {
      return;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === current) {
        return;
      }

      node = node.return;

      if (node.tag === HostPortal) {
        // When we go out of the portal, we need to restore the parent.
        // Since we don't keep a stack of them, we will search for it.
        currentParentIsValid = false;
      }
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }
}

function commitDeletion(finishedRoot, current, renderPriorityLevel) {
  {
    // Recursively delete all host nodes from the parent.
    // Detach refs and call componentWillUnmount() on the whole subtree.
    unmountHostComponents(finishedRoot, current);
  }

  var alternate = current.alternate;
  detachFiberMutation(current);

  if (alternate !== null) {
    detachFiberMutation(alternate);
  }
}

function commitWork(current, finishedWork) {

  switch (finishedWork.tag) {
    case FunctionComponent:
    case ForwardRef:
    case MemoComponent:
    case SimpleMemoComponent:
    case Block:
      {
        // Layout effects are destroyed during the mutation phase so that all
        // destroy functions for all fibers are called before any create functions.
        // This prevents sibling component effects from interfering with each other,
        // e.g. a destroy function in one component should never override a ref set
        // by a create function in another component during the same commit.
        {
          commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
        }

        return;
      }

    case ClassComponent:
      {
        return;
      }

    case HostComponent:
      {
        var instance = finishedWork.stateNode;

        if (instance != null) {
          // Commit the work prepared earlier.
          var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
          // as the newProps. The updatePayload will contain the real change in
          // this case.

          var oldProps = current !== null ? current.memoizedProps : newProps;
          var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.

          var updatePayload = finishedWork.updateQueue;
          finishedWork.updateQueue = null;

          if (updatePayload !== null) {
            commitUpdate(instance, updatePayload, type, oldProps, newProps);
          }
        }

        return;
      }

    case HostText:
      {
        if (!(finishedWork.stateNode !== null)) {
          {
            throw Error( "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue." );
          }
        }

        var textInstance = finishedWork.stateNode;
        var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
        // as the newProps. The updatePayload will contain the real change in
        // this case.

        var oldText = current !== null ? current.memoizedProps : newText;
        commitTextUpdate(textInstance, oldText, newText);
        return;
      }

    case HostRoot:
      {
        {
          var _root = finishedWork.stateNode;

          if (_root.hydrate) {
            // We've just hydrated. No need to hydrate again.
            _root.hydrate = false;
            commitHydratedContainer(_root.containerInfo);
          }
        }

        return;
      }

    case Profiler:
      {
        return;
      }

    case SuspenseComponent:
      {
        commitSuspenseComponent(finishedWork);
        attachSuspenseRetryListeners(finishedWork);
        return;
      }

    case SuspenseListComponent:
      {
        attachSuspenseRetryListeners(finishedWork);
        return;
      }

    case IncompleteClassComponent:
      {
        return;
      }

    case FundamentalComponent:
      {

        break;
      }

    case ScopeComponent:
      {

        break;
      }

    case OffscreenComponent:
    case LegacyHiddenComponent:
      {
        var newState = finishedWork.memoizedState;
        var isHidden = newState !== null;
        hideOrUnhideAllChildren(finishedWork, isHidden);
        return;
      }
  }

  {
    {
      throw Error( "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function commitSuspenseComponent(finishedWork) {
  var newState = finishedWork.memoizedState;

  if (newState !== null) {
    markCommitTimeOfFallback();

    {
      // Hide the Offscreen component that contains the primary children. TODO:
      // Ideally, this effect would have been scheduled on the Offscreen fiber
      // itself. That's how unhiding works: the Offscreen component schedules an
      // effect on itself. However, in this case, the component didn't complete,
      // so the fiber was never added to the effect list in the normal path. We
      // could have appended it to the effect list in the Suspense component's
      // second pass, but doing it this way is less complicated. This would be
      // simpler if we got rid of the effect list and traversed the tree, like
      // we're planning to do.
      var primaryChildParent = finishedWork.child;
      hideOrUnhideAllChildren(primaryChildParent, true);
    }
  }
}

function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {

  var newState = finishedWork.memoizedState;

  if (newState === null) {
    var current = finishedWork.alternate;

    if (current !== null) {
      var prevState = current.memoizedState;

      if (prevState !== null) {
        var suspenseInstance = prevState.dehydrated;

        if (suspenseInstance !== null) {
          commitHydratedSuspenseInstance(suspenseInstance);
        }
      }
    }
  }
}

function attachSuspenseRetryListeners(finishedWork) {
  // If this boundary just timed out, then it will have a set of wakeables.
  // For each wakeable, attach a listener so that when it resolves, React
  // attempts to re-render the boundary in the primary (pre-timeout) state.
  var wakeables = finishedWork.updateQueue;

  if (wakeables !== null) {
    finishedWork.updateQueue = null;
    var retryCache = finishedWork.stateNode;

    if (retryCache === null) {
      retryCache = finishedWork.stateNode = new PossiblyWeakSet();
    }

    wakeables.forEach(function (wakeable) {
      // Memoize using the boundary fiber to prevent redundant listeners.
      var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);

      if (!retryCache.has(wakeable)) {
        {
          if (wakeable.__reactDoNotTraceInteractions !== true) {
            retry = tracing.unstable_wrap(retry);
          }
        }

        retryCache.add(wakeable);
        wakeable.then(retry, retry);
      }
    });
  }
} // This function detects when a Suspense boundary goes from visible to hidden.
// It returns false if the boundary is already hidden.
// TODO: Use an effect tag.


function isSuspenseBoundaryBeingHidden(current, finishedWork) {
  if (current !== null) {
    var oldState = current.memoizedState;

    if (oldState === null || oldState.dehydrated !== null) {
      var newState = finishedWork.memoizedState;
      return newState !== null && newState.dehydrated === null;
    }
  }

  return false;
}

function commitResetTextContent(current) {

  resetTextContent(current.stateNode);
}

var COMPONENT_TYPE = 0;
var HAS_PSEUDO_CLASS_TYPE = 1;
var ROLE_TYPE = 2;
var TEST_NAME_TYPE = 3;
var TEXT_TYPE = 4;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor$1 = Symbol.for;
  COMPONENT_TYPE = symbolFor$1('selector.component');
  HAS_PSEUDO_CLASS_TYPE = symbolFor$1('selector.has_pseudo_class');
  ROLE_TYPE = symbolFor$1('selector.role');
  TEST_NAME_TYPE = symbolFor$1('selector.test_id');
  TEXT_TYPE = symbolFor$1('selector.text');
}
var commitHooks = [];
function onCommitRoot$1() {
  {
    commitHooks.forEach(function (commitHook) {
      return commitHook();
    });
  }
}

var ceil = Math.ceil;
var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher,
    ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner,
    IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
var NoContext =
/*             */
0;
var BatchedContext =
/*               */
1;
var EventContext =
/*                 */
2;
var DiscreteEventContext =
/*         */
4;
var LegacyUnbatchedContext =
/*       */
8;
var RenderContext =
/*                */
16;
var CommitContext =
/*                */
32;
var RetryAfterError =
/*       */
64;
var RootIncomplete = 0;
var RootFatalErrored = 1;
var RootErrored = 2;
var RootSuspended = 3;
var RootSuspendedWithDelay = 4;
var RootCompleted = 5; // Describes where we are in the React execution stack

var executionContext = NoContext; // The root we're working on

var workInProgressRoot = null; // The fiber we're working on

var workInProgress = null; // The lanes we're rendering

var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
// This is a superset of the lanes we started working on at the root. The only
// case where it's different from `workInProgressRootRenderLanes` is when we
// enter a subtree that is hidden and needs to be unhidden: Suspense and
// Offscreen component.
//
// Most things in the work loop should deal with workInProgressRootRenderLanes.
// Most things in begin/complete phases should deal with subtreeRenderLanes.

var subtreeRenderLanes = NoLanes;
var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.

var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown

var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
// slightly different than `renderLanes` because `renderLanes` can change as you
// enter and exit an Offscreen tree. This value is the combination of all render
// lanes for the entire render phase.

var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
// includes unprocessed updates, not work in bailed out children.

var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.

var workInProgressRootUpdatedLanes = NoLanes; // Lanes that were pinged (in an interleaved event) during this render.

var workInProgressRootPingedLanes = NoLanes;
var mostRecentlyUpdatedRoot = null; // The most recent time we committed a fallback. This lets us ensure a train
// model where we don't commit new loading states in too quick succession.

var globalMostRecentFallbackTime = 0;
var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
// more and prefer CPU suspense heuristics instead.

var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
// suspense heuristics and opt out of rendering more content.

var RENDER_TIMEOUT_MS = 500;

function resetRenderTimer() {
  workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
}

function getRenderTargetTime() {
  return workInProgressRootRenderTargetTime;
}
var nextEffect = null;
var hasUncaughtError = false;
var firstUncaughtError = null;
var legacyErrorBoundariesThatAlreadyFailed = null;
var rootDoesHavePassiveEffects = false;
var rootWithPendingPassiveEffects = null;
var pendingPassiveEffectsRenderPriority = NoPriority$1;
var pendingPassiveEffectsLanes = NoLanes;
var pendingPassiveHookEffectsMount = [];
var pendingPassiveHookEffectsUnmount = [];
var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates

var NESTED_UPDATE_LIMIT = 50;
var nestedUpdateCount = 0;
var rootWithNestedUpdates = null;
var NESTED_PASSIVE_UPDATE_LIMIT = 50;
var nestedPassiveUpdateCount = 0; // Marks the need to reschedule pending interactions at these lanes
// during the commit phase. This enables them to be traced across components
// that spawn new work during render. E.g. hidden boundaries, suspended SSR
// hydration or SuspenseList.
// TODO: Can use a bitmask instead of an array

var spawnedWorkDuringRender = null; // If two updates are scheduled within the same event, we should treat their
// event times as simultaneous, even if the actual clock time has advanced
// between the first and second call.

var currentEventTime = NoTimestamp;
var currentEventWipLanes = NoLanes;
var currentEventPendingLanes = NoLanes; // Dev only flag that tracks if passive effects are currently being flushed.
// We warn about state updates for unmounted components differently in this case.

var isFlushingPassiveEffects = false;
var focusedInstanceHandle = null;
var shouldFireAfterActiveInstanceBlur = false;
function getWorkInProgressRoot() {
  return workInProgressRoot;
}
function requestEventTime() {
  if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
    // We're inside React, so it's fine to read the actual time.
    return now();
  } // We're not inside React, so we may be in the middle of a browser event.


  if (currentEventTime !== NoTimestamp) {
    // Use the same start time for all updates until we enter React again.
    return currentEventTime;
  } // This is the first update since React yielded. Compute a new start time.


  currentEventTime = now();
  return currentEventTime;
}
function requestUpdateLane(fiber) {
  // Special cases
  var mode = fiber.mode;

  if ((mode & BlockingMode) === NoMode) {
    return SyncLane;
  } else if ((mode & ConcurrentMode) === NoMode) {
    return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
  } // The algorithm for assigning an update to a lane should be stable for all
  // updates at the same priority within the same event. To do this, the inputs
  // to the algorithm must be the same. For example, we use the `renderLanes`
  // to avoid choosing a lane that is already in the middle of rendering.
  //
  // However, the "included" lanes could be mutated in between updates in the
  // same event, like if you perform an update inside `flushSync`. Or any other
  // code path that might call `prepareFreshStack`.
  //
  // The trick we use is to cache the first of each of these inputs within an
  // event. Then reset the cached values once we can be sure the event is over.
  // Our heuristic for that is whenever we enter a concurrent work loop.
  //
  // We'll do the same for `currentEventPendingLanes` below.


  if (currentEventWipLanes === NoLanes) {
    currentEventWipLanes = workInProgressRootIncludedLanes;
  }

  var isTransition = requestCurrentTransition() !== NoTransition;

  if (isTransition) {
    if (currentEventPendingLanes !== NoLanes) {
      currentEventPendingLanes = mostRecentlyUpdatedRoot !== null ? mostRecentlyUpdatedRoot.pendingLanes : NoLanes;
    }

    return findTransitionLane(currentEventWipLanes, currentEventPendingLanes);
  } // TODO: Remove this dependency on the Scheduler priority.
  // To do that, we're replacing it with an update lane priority.


  var schedulerPriority = getCurrentPriorityLevel(); // The old behavior was using the priority level of the Scheduler.
  // This couples React to the Scheduler internals, so we're replacing it
  // with the currentUpdateLanePriority above. As an example of how this
  // could be problematic, if we're not inside `Scheduler.runWithPriority`,
  // then we'll get the priority of the current running Scheduler task,
  // which is probably not what we want.

  var lane;

  if ( // TODO: Temporary. We're removing the concept of discrete updates.
  (executionContext & DiscreteEventContext) !== NoContext && schedulerPriority === UserBlockingPriority$2) {
    lane = findUpdateLane(InputDiscreteLanePriority, currentEventWipLanes);
  } else {
    var schedulerLanePriority = schedulerPriorityToLanePriority(schedulerPriority);

    lane = findUpdateLane(schedulerLanePriority, currentEventWipLanes);
  }

  return lane;
}

function requestRetryLane(fiber) {
  // This is a fork of `requestUpdateLane` designed specifically for Suspense
  // "retries" — a special update that attempts to flip a Suspense boundary
  // from its placeholder state to its primary/resolved state.
  // Special cases
  var mode = fiber.mode;

  if ((mode & BlockingMode) === NoMode) {
    return SyncLane;
  } else if ((mode & ConcurrentMode) === NoMode) {
    return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
  } // See `requestUpdateLane` for explanation of `currentEventWipLanes`


  if (currentEventWipLanes === NoLanes) {
    currentEventWipLanes = workInProgressRootIncludedLanes;
  }

  return findRetryLane(currentEventWipLanes);
}

function scheduleUpdateOnFiber(fiber, lane, eventTime) {
  checkForNestedUpdates();
  warnAboutRenderPhaseUpdatesInDEV(fiber);
  var root = markUpdateLaneFromFiberToRoot(fiber, lane);

  if (root === null) {
    warnAboutUpdateOnUnmountedFiberInDEV(fiber);
    return null;
  } // Mark that the root has a pending update.


  markRootUpdated(root, lane, eventTime);

  if (root === workInProgressRoot) {
    // Received an update to a tree that's in the middle of rendering. Mark
    // that there was an interleaved update work on this root. Unless the
    // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
    // phase update. In that case, we don't treat render phase updates as if
    // they were interleaved, for backwards compat reasons.
    {
      workInProgressRootUpdatedLanes = mergeLanes(workInProgressRootUpdatedLanes, lane);
    }

    if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
      // The root already suspended with a delay, which means this render
      // definitely won't finish. Since we have a new update, let's mark it as
      // suspended now, right before marking the incoming update. This has the
      // effect of interrupting the current render and switching to the update.
      // TODO: Make sure this doesn't override pings that happen while we've
      // already started rendering.
      markRootSuspended$1(root, workInProgressRootRenderLanes);
    }
  } // TODO: requestUpdateLanePriority also reads the priority. Pass the
  // priority as an argument to that function and this one.


  var priorityLevel = getCurrentPriorityLevel();

  if (lane === SyncLane) {
    if ( // Check if we're inside unbatchedUpdates
    (executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
    (executionContext & (RenderContext | CommitContext)) === NoContext) {
      // Register pending interactions on the root to avoid losing traced interaction data.
      schedulePendingInteractions(root, lane); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
      // root inside of batchedUpdates should be synchronous, but layout updates
      // should be deferred until the end of the batch.

      performSyncWorkOnRoot(root);
    } else {
      ensureRootIsScheduled(root, eventTime);
      schedulePendingInteractions(root, lane);

      if (executionContext === NoContext) {
        // Flush the synchronous work now, unless we're already working or inside
        // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
        // scheduleCallbackForFiber to preserve the ability to schedule a callback
        // without immediately flushing it. We only do this for user-initiated
        // updates, to preserve historical behavior of legacy mode.
        resetRenderTimer();
        flushSyncCallbackQueue();
      }
    }
  } else {
    // Schedule a discrete update but only if it's not Sync.
    if ((executionContext & DiscreteEventContext) !== NoContext && ( // Only updates at user-blocking priority or greater are considered
    // discrete, even inside a discrete event.
    priorityLevel === UserBlockingPriority$2 || priorityLevel === ImmediatePriority$1)) {
      // This is the result of a discrete event. Track the lowest priority
      // discrete update per root so we can flush them early, if needed.
      if (rootsWithPendingDiscreteUpdates === null) {
        rootsWithPendingDiscreteUpdates = new Set([root]);
      } else {
        rootsWithPendingDiscreteUpdates.add(root);
      }
    } // Schedule other updates after in case the callback is sync.


    ensureRootIsScheduled(root, eventTime);
    schedulePendingInteractions(root, lane);
  } // We use this when assigning a lane for a transition inside
  // `requestUpdateLane`. We assume it's the same as the root being updated,
  // since in the common case of a single root app it probably is. If it's not
  // the same root, then it's not a huge deal, we just might batch more stuff
  // together more than necessary.


  mostRecentlyUpdatedRoot = root;
} // This is split into a separate function so we can mark a fiber with pending
// work without treating it as a typical update that originates from an event;
// e.g. retrying a Suspense boundary isn't an update, but it does schedule work
// on a fiber.

function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
  // Update the source fiber's lanes
  sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
  var alternate = sourceFiber.alternate;

  if (alternate !== null) {
    alternate.lanes = mergeLanes(alternate.lanes, lane);
  }

  {
    if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) {
      warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
    }
  } // Walk the parent path to the root and update the child expiration time.


  var node = sourceFiber;
  var parent = sourceFiber.return;

  while (parent !== null) {
    parent.childLanes = mergeLanes(parent.childLanes, lane);
    alternate = parent.alternate;

    if (alternate !== null) {
      alternate.childLanes = mergeLanes(alternate.childLanes, lane);
    } else {
      {
        if ((parent.flags & (Placement | Hydrating)) !== NoFlags) {
          warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        }
      }
    }

    node = parent;
    parent = parent.return;
  }

  if (node.tag === HostRoot) {
    var root = node.stateNode;
    return root;
  } else {
    return null;
  }
} // Use this function to schedule a task for a root. There's only one task per
// root; if a task was already scheduled, we'll check to make sure the priority
// of the existing task is the same as the priority of the next level that the
// root has work on. This function is called on every update, and right before
// exiting a task.


function ensureRootIsScheduled(root, currentTime) {
  var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
  // expired so we know to work on those next.

  markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.

  var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes); // This returns the priority level computed during the `getNextLanes` call.

  var newCallbackPriority = returnNextLanesPriority();

  if (nextLanes === NoLanes) {
    // Special case: There's nothing to work on.
    if (existingCallbackNode !== null) {
      cancelCallback(existingCallbackNode);
      root.callbackNode = null;
      root.callbackPriority = NoLanePriority;
    }

    return;
  } // Check if there's an existing task. We may be able to reuse it.


  if (existingCallbackNode !== null) {
    var existingCallbackPriority = root.callbackPriority;

    if (existingCallbackPriority === newCallbackPriority) {
      // The priority hasn't changed. We can reuse the existing task. Exit.
      return;
    } // The priority changed. Cancel the existing callback. We'll schedule a new
    // one below.


    cancelCallback(existingCallbackNode);
  } // Schedule a new callback.


  var newCallbackNode;

  if (newCallbackPriority === SyncLanePriority) {
    // Special case: Sync React callbacks are scheduled on a special
    // internal queue
    newCallbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
  } else if (newCallbackPriority === SyncBatchedLanePriority) {
    newCallbackNode = scheduleCallback(ImmediatePriority$1, performSyncWorkOnRoot.bind(null, root));
  } else {
    var schedulerPriorityLevel = lanePriorityToSchedulerPriority(newCallbackPriority);
    newCallbackNode = scheduleCallback(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
  }

  root.callbackPriority = newCallbackPriority;
  root.callbackNode = newCallbackNode;
} // This is the entry point for every concurrent task, i.e. anything that
// goes through Scheduler.


function performConcurrentWorkOnRoot(root) {
  // Since we know we're in a React event, we can clear the current
  // event time. The next update will compute a new event time.
  currentEventTime = NoTimestamp;
  currentEventWipLanes = NoLanes;
  currentEventPendingLanes = NoLanes;

  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Should not already be working." );
    }
  } // Flush any pending passive effects before deciding which lanes to work on,
  // in case they schedule additional work.


  var originalCallbackNode = root.callbackNode;
  var didFlushPassiveEffects = flushPassiveEffects();

  if (didFlushPassiveEffects) {
    // Something in the passive effect phase may have canceled the current task.
    // Check if the task node for this root was changed.
    if (root.callbackNode !== originalCallbackNode) {
      // The current task was canceled. Exit. We don't need to call
      // `ensureRootIsScheduled` because the check above implies either that
      // there's a new task, or that there's no remaining work on this root.
      return null;
    }
  } // Determine the next expiration time to work on, using the fields stored
  // on the root.


  var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);

  if (lanes === NoLanes) {
    // Defensive coding. This is never expected to happen.
    return null;
  }

  var exitStatus = renderRootConcurrent(root, lanes);

  if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
    // The render included lanes that were updated during the render phase.
    // For example, when unhiding a hidden tree, we include all the lanes
    // that were previously skipped when the tree was hidden. That set of
    // lanes is a superset of the lanes we started rendering with.
    //
    // So we'll throw out the current work and restart.
    prepareFreshStack(root, NoLanes);
  } else if (exitStatus !== RootIncomplete) {
    if (exitStatus === RootErrored) {
      executionContext |= RetryAfterError; // If an error occurred during hydration,
      // discard server response and fall back to client side render.

      if (root.hydrate) {
        root.hydrate = false;
        clearContainer(root.containerInfo);
      } // If something threw an error, try rendering one more time. We'll render
      // synchronously to block concurrent data mutations, and we'll includes
      // all pending updates are included. If it still fails after the second
      // attempt, we'll give up and commit the resulting tree.


      lanes = getLanesToRetrySynchronouslyOnError(root);

      if (lanes !== NoLanes) {
        exitStatus = renderRootSync(root, lanes);
      }
    }

    if (exitStatus === RootFatalErrored) {
      var fatalError = workInProgressRootFatalError;
      prepareFreshStack(root, NoLanes);
      markRootSuspended$1(root, lanes);
      ensureRootIsScheduled(root, now());
      throw fatalError;
    } // We now have a consistent tree. The next step is either to commit it,
    // or, if something suspended, wait to commit it after a timeout.


    var finishedWork = root.current.alternate;
    root.finishedWork = finishedWork;
    root.finishedLanes = lanes;
    finishConcurrentRender(root, exitStatus, lanes);
  }

  ensureRootIsScheduled(root, now());

  if (root.callbackNode === originalCallbackNode) {
    // The task node scheduled for this root is the same one that's
    // currently executed. Need to return a continuation.
    return performConcurrentWorkOnRoot.bind(null, root);
  }

  return null;
}

function finishConcurrentRender(root, exitStatus, lanes) {
  switch (exitStatus) {
    case RootIncomplete:
    case RootFatalErrored:
      {
        {
          {
            throw Error( "Root did not complete. This is a bug in React." );
          }
        }
      }
    // Flow knows about invariant, so it complains if I add a break
    // statement, but eslint doesn't know about invariant, so it complains
    // if I do. eslint-disable-next-line no-fallthrough

    case RootErrored:
      {
        // We should have already attempted to retry this tree. If we reached
        // this point, it errored again. Commit it.
        commitRoot(root);
        break;
      }

    case RootSuspended:
      {
        markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
        // should immediately commit it or wait a bit.

        if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
        !shouldForceFlushFallbacksInDEV()) {
          // This render only included retries, no updates. Throttle committing
          // retries so that we don't show too many loading states too quickly.
          var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.

          if (msUntilTimeout > 10) {
            var nextLanes = getNextLanes(root, NoLanes);

            if (nextLanes !== NoLanes) {
              // There's additional work on this root.
              break;
            }

            var suspendedLanes = root.suspendedLanes;

            if (!isSubsetOfLanes(suspendedLanes, lanes)) {
              // We should prefer to render the fallback of at the last
              // suspended level. Ping the last suspended level to try
              // rendering it again.
              // FIXME: What if the suspended lanes are Idle? Should not restart.
              var eventTime = requestEventTime();
              markRootPinged(root, suspendedLanes);
              break;
            } // The render is suspended, it hasn't timed out, and there's no
            // lower priority work to do. Instead of committing the fallback
            // immediately, wait for more data to arrive.


            root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
            break;
          }
        } // The work expired. Commit immediately.


        commitRoot(root);
        break;
      }

    case RootSuspendedWithDelay:
      {
        markRootSuspended$1(root, lanes);

        if (includesOnlyTransitions(lanes)) {
          // This is a transition, so we should exit without committing a
          // placeholder and without scheduling a timeout. Delay indefinitely
          // until we receive more data.
          break;
        }

        if (!shouldForceFlushFallbacksInDEV()) {
          // This is not a transition, but we did trigger an avoided state.
          // Schedule a placeholder to display after a short delay, using the Just
          // Noticeable Difference.
          // TODO: Is the JND optimization worth the added complexity? If this is
          // the only reason we track the event time, then probably not.
          // Consider removing.
          var mostRecentEventTime = getMostRecentEventTime(root, lanes);
          var eventTimeMs = mostRecentEventTime;
          var timeElapsedMs = now() - eventTimeMs;

          var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.


          if (_msUntilTimeout > 10) {
            // Instead of committing the fallback immediately, wait for more data
            // to arrive.
            root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
            break;
          }
        } // Commit the placeholder.


        commitRoot(root);
        break;
      }

    case RootCompleted:
      {
        // The work completed. Ready to commit.
        commitRoot(root);
        break;
      }

    default:
      {
        {
          {
            throw Error( "Unknown root exit status." );
          }
        }
      }
  }
}

function markRootSuspended$1(root, suspendedLanes) {
  // When suspending, we should always exclude lanes that were pinged or (more
  // rarely, since we try to avoid it) updated during the render phase.
  // TODO: Lol maybe there's a better way to factor this besides this
  // obnoxiously named function :)
  suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
  suspendedLanes = removeLanes(suspendedLanes, workInProgressRootUpdatedLanes);
  markRootSuspended(root, suspendedLanes);
} // This is the entry point for synchronous tasks that don't go
// through Scheduler


function performSyncWorkOnRoot(root) {
  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Should not already be working." );
    }
  }

  flushPassiveEffects();
  var lanes;
  var exitStatus;

  if (root === workInProgressRoot && includesSomeLane(root.expiredLanes, workInProgressRootRenderLanes)) {
    // There's a partial tree, and at least one of its lanes has expired. Finish
    // rendering it before rendering the rest of the expired work.
    lanes = workInProgressRootRenderLanes;
    exitStatus = renderRootSync(root, lanes);

    if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
      // The render included lanes that were updated during the render phase.
      // For example, when unhiding a hidden tree, we include all the lanes
      // that were previously skipped when the tree was hidden. That set of
      // lanes is a superset of the lanes we started rendering with.
      //
      // Note that this only happens when part of the tree is rendered
      // concurrently. If the whole tree is rendered synchronously, then there
      // are no interleaved events.
      lanes = getNextLanes(root, lanes);
      exitStatus = renderRootSync(root, lanes);
    }
  } else {
    lanes = getNextLanes(root, NoLanes);
    exitStatus = renderRootSync(root, lanes);
  }

  if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
    executionContext |= RetryAfterError; // If an error occurred during hydration,
    // discard server response and fall back to client side render.

    if (root.hydrate) {
      root.hydrate = false;
      clearContainer(root.containerInfo);
    } // If something threw an error, try rendering one more time. We'll render
    // synchronously to block concurrent data mutations, and we'll includes
    // all pending updates are included. If it still fails after the second
    // attempt, we'll give up and commit the resulting tree.


    lanes = getLanesToRetrySynchronouslyOnError(root);

    if (lanes !== NoLanes) {
      exitStatus = renderRootSync(root, lanes);
    }
  }

  if (exitStatus === RootFatalErrored) {
    var fatalError = workInProgressRootFatalError;
    prepareFreshStack(root, NoLanes);
    markRootSuspended$1(root, lanes);
    ensureRootIsScheduled(root, now());
    throw fatalError;
  } // We now have a consistent tree. Because this is a sync render, we
  // will commit it even if something suspended.


  var finishedWork = root.current.alternate;
  root.finishedWork = finishedWork;
  root.finishedLanes = lanes;
  commitRoot(root); // Before exiting, make sure there's a callback scheduled for the next
  // pending level.

  ensureRootIsScheduled(root, now());
  return null;
}
function flushDiscreteUpdates() {
  // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
  // However, `act` uses `batchedUpdates`, so there's no way to distinguish
  // those two cases. Need to fix this before exposing flushDiscreteUpdates
  // as a public API.
  if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
    {
      if ((executionContext & RenderContext) !== NoContext) {
        error('unstable_flushDiscreteUpdates: Cannot flush updates when React is ' + 'already rendering.');
      }
    } // We're already rendering, so we can't synchronously flush pending work.
    // This is probably a nested event dispatch triggered by a lifecycle/effect,
    // like `el.focus()`. Exit.


    return;
  }

  flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
  // they fire before the next serial event.

  flushPassiveEffects();
}

function flushPendingDiscreteUpdates() {
  if (rootsWithPendingDiscreteUpdates !== null) {
    // For each root with pending discrete updates, schedule a callback to
    // immediately flush them.
    var roots = rootsWithPendingDiscreteUpdates;
    rootsWithPendingDiscreteUpdates = null;
    roots.forEach(function (root) {
      markDiscreteUpdatesExpired(root);
      ensureRootIsScheduled(root, now());
    });
  } // Now flush the immediate queue.


  flushSyncCallbackQueue();
}

function batchedUpdates$1(fn, a) {
  var prevExecutionContext = executionContext;
  executionContext |= BatchedContext;

  try {
    return fn(a);
  } finally {
    executionContext = prevExecutionContext;

    if (executionContext === NoContext) {
      // Flush the immediate callbacks that were scheduled during this batch
      resetRenderTimer();
      flushSyncCallbackQueue();
    }
  }
}
function batchedEventUpdates$1(fn, a) {
  var prevExecutionContext = executionContext;
  executionContext |= EventContext;

  try {
    return fn(a);
  } finally {
    executionContext = prevExecutionContext;

    if (executionContext === NoContext) {
      // Flush the immediate callbacks that were scheduled during this batch
      resetRenderTimer();
      flushSyncCallbackQueue();
    }
  }
}
function discreteUpdates$1(fn, a, b, c, d) {
  var prevExecutionContext = executionContext;
  executionContext |= DiscreteEventContext;

  {
    try {
      return runWithPriority$1(UserBlockingPriority$2, fn.bind(null, a, b, c, d));
    } finally {
      executionContext = prevExecutionContext;

      if (executionContext === NoContext) {
        // Flush the immediate callbacks that were scheduled during this batch
        resetRenderTimer();
        flushSyncCallbackQueue();
      }
    }
  }
}
function unbatchedUpdates(fn, a) {
  var prevExecutionContext = executionContext;
  executionContext &= ~BatchedContext;
  executionContext |= LegacyUnbatchedContext;

  try {
    return fn(a);
  } finally {
    executionContext = prevExecutionContext;

    if (executionContext === NoContext) {
      // Flush the immediate callbacks that were scheduled during this batch
      resetRenderTimer();
      flushSyncCallbackQueue();
    }
  }
}
function flushSync(fn, a) {
  var prevExecutionContext = executionContext;

  if ((prevExecutionContext & (RenderContext | CommitContext)) !== NoContext) {
    {
      error('flushSync was called from inside a lifecycle method. React cannot ' + 'flush when React is already rendering. Consider moving this call to ' + 'a scheduler task or micro task.');
    }

    return fn(a);
  }

  executionContext |= BatchedContext;

  {
    try {
      if (fn) {
        return runWithPriority$1(ImmediatePriority$1, fn.bind(null, a));
      } else {
        return undefined;
      }
    } finally {
      executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
      // Note that this will happen even if batchedUpdates is higher up
      // the stack.

      flushSyncCallbackQueue();
    }
  }
}
function pushRenderLanes(fiber, lanes) {
  push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
  subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
  workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
}
function popRenderLanes(fiber) {
  subtreeRenderLanes = subtreeRenderLanesCursor.current;
  pop(subtreeRenderLanesCursor, fiber);
}

function prepareFreshStack(root, lanes) {
  root.finishedWork = null;
  root.finishedLanes = NoLanes;
  var timeoutHandle = root.timeoutHandle;

  if (timeoutHandle !== noTimeout) {
    // The root previous suspended and scheduled a timeout to commit a fallback
    // state. Now that we have additional work, cancel the timeout.
    root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above

    cancelTimeout(timeoutHandle);
  }

  if (workInProgress !== null) {
    var interruptedWork = workInProgress.return;

    while (interruptedWork !== null) {
      unwindInterruptedWork(interruptedWork);
      interruptedWork = interruptedWork.return;
    }
  }

  workInProgressRoot = root;
  workInProgress = createWorkInProgress(root.current, null);
  workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
  workInProgressRootExitStatus = RootIncomplete;
  workInProgressRootFatalError = null;
  workInProgressRootSkippedLanes = NoLanes;
  workInProgressRootUpdatedLanes = NoLanes;
  workInProgressRootPingedLanes = NoLanes;

  {
    spawnedWorkDuringRender = null;
  }

  {
    ReactStrictModeWarnings.discardPendingWarnings();
  }
}

function handleError(root, thrownValue) {
  do {
    var erroredWork = workInProgress;

    try {
      // Reset module-level state that was set during the render phase.
      resetContextDependencies();
      resetHooksAfterThrow();
      resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
      // separate issue. Write a regression test using string refs.

      ReactCurrentOwner$2.current = null;

      if (erroredWork === null || erroredWork.return === null) {
        // Expected to be working on a non-root fiber. This is a fatal error
        // because there's no ancestor that can handle it; the root is
        // supposed to capture all errors that weren't caught by an error
        // boundary.
        workInProgressRootExitStatus = RootFatalErrored;
        workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
        // sibling, or the parent if there are no siblings. But since the root
        // has no siblings nor a parent, we set it to null. Usually this is
        // handled by `completeUnitOfWork` or `unwindWork`, but since we're
        // intentionally not calling those, we need set it here.
        // TODO: Consider calling `unwindWork` to pop the contexts.

        workInProgress = null;
        return;
      }

      if (enableProfilerTimer && erroredWork.mode & ProfileMode) {
        // Record the time spent rendering before an error was thrown. This
        // avoids inaccurate Profiler durations in the case of a
        // suspended render.
        stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
      }

      throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
      completeUnitOfWork(erroredWork);
    } catch (yetAnotherThrownValue) {
      // Something in the return path also threw.
      thrownValue = yetAnotherThrownValue;

      if (workInProgress === erroredWork && erroredWork !== null) {
        // If this boundary has already errored, then we had trouble processing
        // the error. Bubble it to the next boundary.
        erroredWork = erroredWork.return;
        workInProgress = erroredWork;
      } else {
        erroredWork = workInProgress;
      }

      continue;
    } // Return to the normal work loop.


    return;
  } while (true);
}

function pushDispatcher() {
  var prevDispatcher = ReactCurrentDispatcher$2.current;
  ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;

  if (prevDispatcher === null) {
    // The React isomorphic package does not include a default dispatcher.
    // Instead the first renderer will lazily attach one, in order to give
    // nicer error messages.
    return ContextOnlyDispatcher;
  } else {
    return prevDispatcher;
  }
}

function popDispatcher(prevDispatcher) {
  ReactCurrentDispatcher$2.current = prevDispatcher;
}

function pushInteractions(root) {
  {
    var prevInteractions = tracing.__interactionsRef.current;
    tracing.__interactionsRef.current = root.memoizedInteractions;
    return prevInteractions;
  }
}

function popInteractions(prevInteractions) {
  {
    tracing.__interactionsRef.current = prevInteractions;
  }
}

function markCommitTimeOfFallback() {
  globalMostRecentFallbackTime = now();
}
function markSkippedUpdateLanes(lane) {
  workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
}
function renderDidSuspend() {
  if (workInProgressRootExitStatus === RootIncomplete) {
    workInProgressRootExitStatus = RootSuspended;
  }
}
function renderDidSuspendDelayIfPossible() {
  if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) {
    workInProgressRootExitStatus = RootSuspendedWithDelay;
  } // Check if there are updates that we skipped tree that might have unblocked
  // this render.


  if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootUpdatedLanes))) {
    // Mark the current render as suspended so that we switch to working on
    // the updates that were skipped. Usually we only suspend at the end of
    // the render phase.
    // TODO: We should probably always mark the root as suspended immediately
    // (inside this function), since by suspending at the end of the render
    // phase introduces a potential mistake where we suspend lanes that were
    // pinged or updated while we were rendering.
    markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
  }
}
function renderDidError() {
  if (workInProgressRootExitStatus !== RootCompleted) {
    workInProgressRootExitStatus = RootErrored;
  }
} // Called during render to determine if anything has suspended.
// Returns false if we're not sure.

function renderHasNotSuspendedYet() {
  // If something errored or completed, we can't really be sure,
  // so those are false.
  return workInProgressRootExitStatus === RootIncomplete;
}

function renderRootSync(root, lanes) {
  var prevExecutionContext = executionContext;
  executionContext |= RenderContext;
  var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
  // and prepare a fresh one. Otherwise we'll continue where we left off.

  if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
    prepareFreshStack(root, lanes);
    startWorkOnPendingInteractions(root, lanes);
  }

  var prevInteractions = pushInteractions(root);

  do {
    try {
      workLoopSync();
      break;
    } catch (thrownValue) {
      handleError(root, thrownValue);
    }
  } while (true);

  resetContextDependencies();

  {
    popInteractions(prevInteractions);
  }

  executionContext = prevExecutionContext;
  popDispatcher(prevDispatcher);

  if (workInProgress !== null) {
    // This is a sync render, so we should have finished the whole tree.
    {
      {
        throw Error( "Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  }


  workInProgressRoot = null;
  workInProgressRootRenderLanes = NoLanes;
  return workInProgressRootExitStatus;
} // The work loop is an extremely hot path. Tell Closure not to inline it.

/** @noinline */


function workLoopSync() {
  // Already timed out, so perform work without checking if we need to yield.
  while (workInProgress !== null) {
    performUnitOfWork(workInProgress);
  }
}

function renderRootConcurrent(root, lanes) {
  var prevExecutionContext = executionContext;
  executionContext |= RenderContext;
  var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
  // and prepare a fresh one. Otherwise we'll continue where we left off.

  if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
    resetRenderTimer();
    prepareFreshStack(root, lanes);
    startWorkOnPendingInteractions(root, lanes);
  }

  var prevInteractions = pushInteractions(root);

  do {
    try {
      workLoopConcurrent();
      break;
    } catch (thrownValue) {
      handleError(root, thrownValue);
    }
  } while (true);

  resetContextDependencies();

  {
    popInteractions(prevInteractions);
  }

  popDispatcher(prevDispatcher);
  executionContext = prevExecutionContext;


  if (workInProgress !== null) {

    return RootIncomplete;
  } else {


    workInProgressRoot = null;
    workInProgressRootRenderLanes = NoLanes; // Return the final exit status.

    return workInProgressRootExitStatus;
  }
}
/** @noinline */


function workLoopConcurrent() {
  // Perform work until Scheduler asks us to yield
  while (workInProgress !== null && !shouldYield()) {
    performUnitOfWork(workInProgress);
  }
}

function performUnitOfWork(unitOfWork) {
  // The current, flushed, state of this fiber is the alternate. Ideally
  // nothing should rely on this, but relying on it here means that we don't
  // need an additional field on the work in progress.
  var current = unitOfWork.alternate;
  setCurrentFiber(unitOfWork);
  var next;

  if ( (unitOfWork.mode & ProfileMode) !== NoMode) {
    startProfilerTimer(unitOfWork);
    next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
    stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
  } else {
    next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
  }

  resetCurrentFiber();
  unitOfWork.memoizedProps = unitOfWork.pendingProps;

  if (next === null) {
    // If this doesn't spawn new work, complete the current work.
    completeUnitOfWork(unitOfWork);
  } else {
    workInProgress = next;
  }

  ReactCurrentOwner$2.current = null;
}

function completeUnitOfWork(unitOfWork) {
  // Attempt to complete the current unit of work, then move to the next
  // sibling. If there are no more siblings, return to the parent fiber.
  var completedWork = unitOfWork;

  do {
    // The current, flushed, state of this fiber is the alternate. Ideally
    // nothing should rely on this, but relying on it here means that we don't
    // need an additional field on the work in progress.
    var current = completedWork.alternate;
    var returnFiber = completedWork.return; // Check if the work completed or if something threw.

    if ((completedWork.flags & Incomplete) === NoFlags) {
      setCurrentFiber(completedWork);
      var next = void 0;

      if ( (completedWork.mode & ProfileMode) === NoMode) {
        next = completeWork(current, completedWork, subtreeRenderLanes);
      } else {
        startProfilerTimer(completedWork);
        next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.

        stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
      }

      resetCurrentFiber();

      if (next !== null) {
        // Completing this fiber spawned new work. Work on that next.
        workInProgress = next;
        return;
      }

      resetChildLanes(completedWork);

      if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
      (returnFiber.flags & Incomplete) === NoFlags) {
        // Append all the effects of the subtree and this fiber onto the effect
        // list of the parent. The completion order of the children affects the
        // side-effect order.
        if (returnFiber.firstEffect === null) {
          returnFiber.firstEffect = completedWork.firstEffect;
        }

        if (completedWork.lastEffect !== null) {
          if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = completedWork.firstEffect;
          }

          returnFiber.lastEffect = completedWork.lastEffect;
        } // If this fiber had side-effects, we append it AFTER the children's
        // side-effects. We can perform certain side-effects earlier if needed,
        // by doing multiple passes over the effect list. We don't want to
        // schedule our own side-effect on our own list because if end up
        // reusing children we'll schedule this effect onto itself since we're
        // at the end.


        var flags = completedWork.flags; // Skip both NoWork and PerformedWork tags when creating the effect
        // list. PerformedWork effect is read by React DevTools but shouldn't be
        // committed.

        if (flags > PerformedWork) {
          if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = completedWork;
          } else {
            returnFiber.firstEffect = completedWork;
          }

          returnFiber.lastEffect = completedWork;
        }
      }
    } else {
      // This fiber did not complete because something threw. Pop values off
      // the stack without entering the complete phase. If this is a boundary,
      // capture values if possible.
      var _next = unwindWork(completedWork); // Because this fiber did not complete, don't reset its expiration time.


      if (_next !== null) {
        // If completing this work spawned new work, do that next. We'll come
        // back here again.
        // Since we're restarting, remove anything that is not a host effect
        // from the effect tag.
        _next.flags &= HostEffectMask;
        workInProgress = _next;
        return;
      }

      if ( (completedWork.mode & ProfileMode) !== NoMode) {
        // Record the render duration for the fiber that errored.
        stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.

        var actualDuration = completedWork.actualDuration;
        var child = completedWork.child;

        while (child !== null) {
          actualDuration += child.actualDuration;
          child = child.sibling;
        }

        completedWork.actualDuration = actualDuration;
      }

      if (returnFiber !== null) {
        // Mark the parent fiber as incomplete and clear its effect list.
        returnFiber.firstEffect = returnFiber.lastEffect = null;
        returnFiber.flags |= Incomplete;
      }
    }

    var siblingFiber = completedWork.sibling;

    if (siblingFiber !== null) {
      // If there is more work to do in this returnFiber, do that next.
      workInProgress = siblingFiber;
      return;
    } // Otherwise, return to the parent


    completedWork = returnFiber; // Update the next thing we're working on in case something throws.

    workInProgress = completedWork;
  } while (completedWork !== null); // We've reached the root.


  if (workInProgressRootExitStatus === RootIncomplete) {
    workInProgressRootExitStatus = RootCompleted;
  }
}

function resetChildLanes(completedWork) {
  if ( // TODO: Move this check out of the hot path by moving `resetChildLanes`
  // to switch statement in `completeWork`.
  (completedWork.tag === LegacyHiddenComponent || completedWork.tag === OffscreenComponent) && completedWork.memoizedState !== null && !includesSomeLane(subtreeRenderLanes, OffscreenLane) && (completedWork.mode & ConcurrentMode) !== NoLanes) {
    // The children of this component are hidden. Don't bubble their
    // expiration times.
    return;
  }

  var newChildLanes = NoLanes; // Bubble up the earliest expiration time.

  if ( (completedWork.mode & ProfileMode) !== NoMode) {
    // In profiling mode, resetChildExpirationTime is also used to reset
    // profiler durations.
    var actualDuration = completedWork.actualDuration;
    var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
    // When work is done, it should bubble to the parent's actualDuration. If
    // the fiber has not been cloned though, (meaning no work was done), then
    // this value will reflect the amount of time spent working on a previous
    // render. In that case it should not bubble. We determine whether it was
    // cloned by comparing the child pointer.

    var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
    var child = completedWork.child;

    while (child !== null) {
      newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));

      if (shouldBubbleActualDurations) {
        actualDuration += child.actualDuration;
      }

      treeBaseDuration += child.treeBaseDuration;
      child = child.sibling;
    }

    var isTimedOutSuspense = completedWork.tag === SuspenseComponent && completedWork.memoizedState !== null;

    if (isTimedOutSuspense) {
      // Don't count time spent in a timed out Suspense subtree as part of the base duration.
      var primaryChildFragment = completedWork.child;

      if (primaryChildFragment !== null) {
        treeBaseDuration -= primaryChildFragment.treeBaseDuration;
      }
    }

    completedWork.actualDuration = actualDuration;
    completedWork.treeBaseDuration = treeBaseDuration;
  } else {
    var _child = completedWork.child;

    while (_child !== null) {
      newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
      _child = _child.sibling;
    }
  }

  completedWork.childLanes = newChildLanes;
}

function commitRoot(root) {
  var renderPriorityLevel = getCurrentPriorityLevel();
  runWithPriority$1(ImmediatePriority$1, commitRootImpl.bind(null, root, renderPriorityLevel));
  return null;
}

function commitRootImpl(root, renderPriorityLevel) {
  do {
    // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
    // means `flushPassiveEffects` will sometimes result in additional
    // passive effects. So we need to keep flushing in a loop until there are
    // no more pending effects.
    // TODO: Might be better if `flushPassiveEffects` did not automatically
    // flush synchronous work at the end, to avoid factoring hazards like this.
    flushPassiveEffects();
  } while (rootWithPendingPassiveEffects !== null);

  flushRenderPhaseStrictModeWarningsInDEV();

  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Should not already be working." );
    }
  }

  var finishedWork = root.finishedWork;
  var lanes = root.finishedLanes;

  if (finishedWork === null) {

    return null;
  }

  root.finishedWork = null;
  root.finishedLanes = NoLanes;

  if (!(finishedWork !== root.current)) {
    {
      throw Error( "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue." );
    }
  } // commitRoot never returns a continuation; it always finishes synchronously.
  // So we can clear these now to allow a new callback to be scheduled.


  root.callbackNode = null; // Update the first and last pending times on this root. The new first
  // pending time is whatever is left on the root fiber.

  var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
  markRootFinished(root, remainingLanes); // Clear already finished discrete updates in case that a later call of
  // `flushDiscreteUpdates` starts a useless render pass which may cancels
  // a scheduled timeout.

  if (rootsWithPendingDiscreteUpdates !== null) {
    if (!hasDiscreteLanes(remainingLanes) && rootsWithPendingDiscreteUpdates.has(root)) {
      rootsWithPendingDiscreteUpdates.delete(root);
    }
  }

  if (root === workInProgressRoot) {
    // We can reset these now that they are finished.
    workInProgressRoot = null;
    workInProgress = null;
    workInProgressRootRenderLanes = NoLanes;
  } // Get the list of effects.


  var firstEffect;

  if (finishedWork.flags > PerformedWork) {
    // A fiber's effect list consists only of its children, not itself. So if
    // the root has an effect, we need to add it to the end of the list. The
    // resulting list is the set that would belong to the root's parent, if it
    // had one; that is, all the effects in the tree including the root.
    if (finishedWork.lastEffect !== null) {
      finishedWork.lastEffect.nextEffect = finishedWork;
      firstEffect = finishedWork.firstEffect;
    } else {
      firstEffect = finishedWork;
    }
  } else {
    // There is no effect on the root.
    firstEffect = finishedWork.firstEffect;
  }

  if (firstEffect !== null) {

    var prevExecutionContext = executionContext;
    executionContext |= CommitContext;
    var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles

    ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
    // of the effect list for each phase: all mutation effects come before all
    // layout effects, and so on.
    // The first phase a "before mutation" phase. We use this phase to read the
    // state of the host tree right before we mutate it. This is where
    // getSnapshotBeforeUpdate is called.

    focusedInstanceHandle = prepareForCommit(root.containerInfo);
    shouldFireAfterActiveInstanceBlur = false;
    nextEffect = firstEffect;

    do {
      {
        invokeGuardedCallback(null, commitBeforeMutationEffects, null);

        if (hasCaughtError()) {
          if (!(nextEffect !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var error = clearCaughtError();
          captureCommitPhaseError(nextEffect, error);
          nextEffect = nextEffect.nextEffect;
        }
      }
    } while (nextEffect !== null); // We no longer need to track the active instance fiber


    focusedInstanceHandle = null;

    {
      // Mark the current commit time to be shared by all Profilers in this
      // batch. This enables them to be grouped later.
      recordCommitTime();
    } // The next phase is the mutation phase, where we mutate the host tree.


    nextEffect = firstEffect;

    do {
      {
        invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);

        if (hasCaughtError()) {
          if (!(nextEffect !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var _error = clearCaughtError();

          captureCommitPhaseError(nextEffect, _error);
          nextEffect = nextEffect.nextEffect;
        }
      }
    } while (nextEffect !== null);

    resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
    // the mutation phase, so that the previous tree is still current during
    // componentWillUnmount, but before the layout phase, so that the finished
    // work is current during componentDidMount/Update.

    root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
    // the host tree after it's been mutated. The idiomatic use case for this is
    // layout, but class component lifecycles also fire here for legacy reasons.

    nextEffect = firstEffect;

    do {
      {
        invokeGuardedCallback(null, commitLayoutEffects, null, root, lanes);

        if (hasCaughtError()) {
          if (!(nextEffect !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var _error2 = clearCaughtError();

          captureCommitPhaseError(nextEffect, _error2);
          nextEffect = nextEffect.nextEffect;
        }
      }
    } while (nextEffect !== null);

    nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
    // opportunity to paint.

    requestPaint();

    {
      popInteractions(prevInteractions);
    }

    executionContext = prevExecutionContext;
  } else {
    // No effects.
    root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
    // no effects.
    // TODO: Maybe there's a better way to report this.

    {
      recordCommitTime();
    }
  }

  var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;

  if (rootDoesHavePassiveEffects) {
    // This commit has passive effects. Stash a reference to them. But don't
    // schedule a callback until after flushing layout work.
    rootDoesHavePassiveEffects = false;
    rootWithPendingPassiveEffects = root;
    pendingPassiveEffectsLanes = lanes;
    pendingPassiveEffectsRenderPriority = renderPriorityLevel;
  } else {
    // We are done with the effect chain at this point so let's clear the
    // nextEffect pointers to assist with GC. If we have passive effects, we'll
    // clear this in flushPassiveEffects.
    nextEffect = firstEffect;

    while (nextEffect !== null) {
      var nextNextEffect = nextEffect.nextEffect;
      nextEffect.nextEffect = null;

      if (nextEffect.flags & Deletion) {
        detachFiberAfterEffects(nextEffect);
      }

      nextEffect = nextNextEffect;
    }
  } // Read this again, since an effect might have updated it


  remainingLanes = root.pendingLanes; // Check if there's remaining work on this root

  if (remainingLanes !== NoLanes) {
    {
      if (spawnedWorkDuringRender !== null) {
        var expirationTimes = spawnedWorkDuringRender;
        spawnedWorkDuringRender = null;

        for (var i = 0; i < expirationTimes.length; i++) {
          scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
        }
      }

      schedulePendingInteractions(root, remainingLanes);
    }
  } else {
    // If there's no remaining work, we can clear the set of already failed
    // error boundaries.
    legacyErrorBoundariesThatAlreadyFailed = null;
  }

  {
    if (!rootDidHavePassiveEffects) {
      // If there are no passive effects, then we can complete the pending interactions.
      // Otherwise, we'll wait until after the passive effects are flushed.
      // Wait to do this until after remaining work has been scheduled,
      // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
      finishPendingInteractions(root, lanes);
    }
  }

  if (remainingLanes === SyncLane) {
    // Count the number of times the root synchronously re-renders without
    // finishing. If there are too many, it indicates an infinite update loop.
    if (root === rootWithNestedUpdates) {
      nestedUpdateCount++;
    } else {
      nestedUpdateCount = 0;
      rootWithNestedUpdates = root;
    }
  } else {
    nestedUpdateCount = 0;
  }

  onCommitRoot(finishedWork.stateNode, renderPriorityLevel);

  {
    onCommitRoot$1();
  } // Always call this before exiting `commitRoot`, to ensure that any
  // additional work on this root is scheduled.


  ensureRootIsScheduled(root, now());

  if (hasUncaughtError) {
    hasUncaughtError = false;
    var _error3 = firstUncaughtError;
    firstUncaughtError = null;
    throw _error3;
  }

  if ((executionContext & LegacyUnbatchedContext) !== NoContext) {
    // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
    // synchronously, but layout updates should be deferred until the end
    // of the batch.


    return null;
  } // If layout work was scheduled, flush it now.


  flushSyncCallbackQueue();

  return null;
}

function commitBeforeMutationEffects() {
  while (nextEffect !== null) {
    var current = nextEffect.alternate;

    if (!shouldFireAfterActiveInstanceBlur && focusedInstanceHandle !== null) {
      if ((nextEffect.flags & Deletion) !== NoFlags) {
        if (doesFiberContain(nextEffect, focusedInstanceHandle)) {
          shouldFireAfterActiveInstanceBlur = true;
        }
      } else {
        // TODO: Move this out of the hot path using a dedicated effect tag.
        if (nextEffect.tag === SuspenseComponent && isSuspenseBoundaryBeingHidden(current, nextEffect) && doesFiberContain(nextEffect, focusedInstanceHandle)) {
          shouldFireAfterActiveInstanceBlur = true;
        }
      }
    }

    var flags = nextEffect.flags;

    if ((flags & Snapshot) !== NoFlags) {
      setCurrentFiber(nextEffect);
      commitBeforeMutationLifeCycles(current, nextEffect);
      resetCurrentFiber();
    }

    if ((flags & Passive) !== NoFlags) {
      // If there are passive effects, schedule a callback to flush at
      // the earliest opportunity.
      if (!rootDoesHavePassiveEffects) {
        rootDoesHavePassiveEffects = true;
        scheduleCallback(NormalPriority$1, function () {
          flushPassiveEffects();
          return null;
        });
      }
    }

    nextEffect = nextEffect.nextEffect;
  }
}

function commitMutationEffects(root, renderPriorityLevel) {
  // TODO: Should probably move the bulk of this function to commitWork.
  while (nextEffect !== null) {
    setCurrentFiber(nextEffect);
    var flags = nextEffect.flags;

    if (flags & ContentReset) {
      commitResetTextContent(nextEffect);
    }

    if (flags & Ref) {
      var current = nextEffect.alternate;

      if (current !== null) {
        commitDetachRef(current);
      }
    } // The following switch statement is only concerned about placement,
    // updates, and deletions. To avoid needing to add a case for every possible
    // bitmap value, we remove the secondary effects from the effect tag and
    // switch on that value.


    var primaryFlags = flags & (Placement | Update | Deletion | Hydrating);

    switch (primaryFlags) {
      case Placement:
        {
          commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
          // inserted, before any life-cycles like componentDidMount gets called.
          // TODO: findDOMNode doesn't rely on this any more but isMounted does
          // and isMounted is deprecated anyway so we should be able to kill this.

          nextEffect.flags &= ~Placement;
          break;
        }

      case PlacementAndUpdate:
        {
          // Placement
          commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
          // inserted, before any life-cycles like componentDidMount gets called.

          nextEffect.flags &= ~Placement; // Update

          var _current = nextEffect.alternate;
          commitWork(_current, nextEffect);
          break;
        }

      case Hydrating:
        {
          nextEffect.flags &= ~Hydrating;
          break;
        }

      case HydratingAndUpdate:
        {
          nextEffect.flags &= ~Hydrating; // Update

          var _current2 = nextEffect.alternate;
          commitWork(_current2, nextEffect);
          break;
        }

      case Update:
        {
          var _current3 = nextEffect.alternate;
          commitWork(_current3, nextEffect);
          break;
        }

      case Deletion:
        {
          commitDeletion(root, nextEffect);
          break;
        }
    }

    resetCurrentFiber();
    nextEffect = nextEffect.nextEffect;
  }
}

function commitLayoutEffects(root, committedLanes) {


  while (nextEffect !== null) {
    setCurrentFiber(nextEffect);
    var flags = nextEffect.flags;

    if (flags & (Update | Callback)) {
      var current = nextEffect.alternate;
      commitLifeCycles(root, current, nextEffect);
    }

    {
      if (flags & Ref) {
        commitAttachRef(nextEffect);
      }
    }

    resetCurrentFiber();
    nextEffect = nextEffect.nextEffect;
  }
}

function flushPassiveEffects() {
  // Returns whether passive effects were flushed.
  if (pendingPassiveEffectsRenderPriority !== NoPriority$1) {
    var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority$1 ? NormalPriority$1 : pendingPassiveEffectsRenderPriority;
    pendingPassiveEffectsRenderPriority = NoPriority$1;

    {
      return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
    }
  }

  return false;
}
function enqueuePendingPassiveHookEffectMount(fiber, effect) {
  pendingPassiveHookEffectsMount.push(effect, fiber);

  if (!rootDoesHavePassiveEffects) {
    rootDoesHavePassiveEffects = true;
    scheduleCallback(NormalPriority$1, function () {
      flushPassiveEffects();
      return null;
    });
  }
}
function enqueuePendingPassiveHookEffectUnmount(fiber, effect) {
  pendingPassiveHookEffectsUnmount.push(effect, fiber);

  {
    fiber.flags |= PassiveUnmountPendingDev;
    var alternate = fiber.alternate;

    if (alternate !== null) {
      alternate.flags |= PassiveUnmountPendingDev;
    }
  }

  if (!rootDoesHavePassiveEffects) {
    rootDoesHavePassiveEffects = true;
    scheduleCallback(NormalPriority$1, function () {
      flushPassiveEffects();
      return null;
    });
  }
}

function invokePassiveEffectCreate(effect) {
  var create = effect.create;
  effect.destroy = create();
}

function flushPassiveEffectsImpl() {
  if (rootWithPendingPassiveEffects === null) {
    return false;
  }

  var root = rootWithPendingPassiveEffects;
  var lanes = pendingPassiveEffectsLanes;
  rootWithPendingPassiveEffects = null;
  pendingPassiveEffectsLanes = NoLanes;

  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Cannot flush passive effects while already rendering." );
    }
  }

  {
    isFlushingPassiveEffects = true;
  }

  var prevExecutionContext = executionContext;
  executionContext |= CommitContext;
  var prevInteractions = pushInteractions(root); // It's important that ALL pending passive effect destroy functions are called
  // before ANY passive effect create functions are called.
  // Otherwise effects in sibling components might interfere with each other.
  // e.g. a destroy function in one component may unintentionally override a ref
  // value set by a create function in another component.
  // Layout effects have the same constraint.
  // First pass: Destroy stale passive effects.

  var unmountEffects = pendingPassiveHookEffectsUnmount;
  pendingPassiveHookEffectsUnmount = [];

  for (var i = 0; i < unmountEffects.length; i += 2) {
    var _effect = unmountEffects[i];
    var fiber = unmountEffects[i + 1];
    var destroy = _effect.destroy;
    _effect.destroy = undefined;

    {
      fiber.flags &= ~PassiveUnmountPendingDev;
      var alternate = fiber.alternate;

      if (alternate !== null) {
        alternate.flags &= ~PassiveUnmountPendingDev;
      }
    }

    if (typeof destroy === 'function') {
      {
        setCurrentFiber(fiber);

        {
          invokeGuardedCallback(null, destroy, null);
        }

        if (hasCaughtError()) {
          if (!(fiber !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var error = clearCaughtError();
          captureCommitPhaseError(fiber, error);
        }

        resetCurrentFiber();
      }
    }
  } // Second pass: Create new passive effects.


  var mountEffects = pendingPassiveHookEffectsMount;
  pendingPassiveHookEffectsMount = [];

  for (var _i = 0; _i < mountEffects.length; _i += 2) {
    var _effect2 = mountEffects[_i];
    var _fiber = mountEffects[_i + 1];

    {
      setCurrentFiber(_fiber);

      {
        invokeGuardedCallback(null, invokePassiveEffectCreate, null, _effect2);
      }

      if (hasCaughtError()) {
        if (!(_fiber !== null)) {
          {
            throw Error( "Should be working on an effect." );
          }
        }

        var _error4 = clearCaughtError();

        captureCommitPhaseError(_fiber, _error4);
      }

      resetCurrentFiber();
    }
  } // Note: This currently assumes there are no passive effects on the root fiber
  // because the root is not part of its own effect list.
  // This could change in the future.


  var effect = root.current.firstEffect;

  while (effect !== null) {
    var nextNextEffect = effect.nextEffect; // Remove nextEffect pointer to assist GC

    effect.nextEffect = null;

    if (effect.flags & Deletion) {
      detachFiberAfterEffects(effect);
    }

    effect = nextNextEffect;
  }

  {
    popInteractions(prevInteractions);
    finishPendingInteractions(root, lanes);
  }

  {
    isFlushingPassiveEffects = false;
  }

  executionContext = prevExecutionContext;
  flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
  // exceeds the limit, we'll fire a warning.

  nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
  return true;
}

function isAlreadyFailedLegacyErrorBoundary(instance) {
  return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
}
function markLegacyErrorBoundaryAsFailed(instance) {
  if (legacyErrorBoundariesThatAlreadyFailed === null) {
    legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
  } else {
    legacyErrorBoundariesThatAlreadyFailed.add(instance);
  }
}

function prepareToThrowUncaughtError(error) {
  if (!hasUncaughtError) {
    hasUncaughtError = true;
    firstUncaughtError = error;
  }
}

var onUncaughtError = prepareToThrowUncaughtError;

function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
  var errorInfo = createCapturedValue(error, sourceFiber);
  var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
  enqueueUpdate(rootFiber, update);
  var eventTime = requestEventTime();
  var root = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);

  if (root !== null) {
    markRootUpdated(root, SyncLane, eventTime);
    ensureRootIsScheduled(root, eventTime);
    schedulePendingInteractions(root, SyncLane);
  }
}

function captureCommitPhaseError(sourceFiber, error) {
  if (sourceFiber.tag === HostRoot) {
    // Error was thrown at the root. There is no parent, so the root
    // itself should capture it.
    captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    return;
  }

  var fiber = sourceFiber.return;

  while (fiber !== null) {
    if (fiber.tag === HostRoot) {
      captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
      return;
    } else if (fiber.tag === ClassComponent) {
      var ctor = fiber.type;
      var instance = fiber.stateNode;

      if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
        enqueueUpdate(fiber, update);
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(fiber, SyncLane);

        if (root !== null) {
          markRootUpdated(root, SyncLane, eventTime);
          ensureRootIsScheduled(root, eventTime);
          schedulePendingInteractions(root, SyncLane);
        } else {
          // This component has already been unmounted.
          // We can't schedule any follow up work for the root because the fiber is already unmounted,
          // but we can still call the log-only boundary so the error isn't swallowed.
          //
          // TODO This is only a temporary bandaid for the old reconciler fork.
          // We can delete this special case once the new fork is merged.
          if (typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
            try {
              instance.componentDidCatch(error, errorInfo);
            } catch (errorToIgnore) {// TODO Ignore this error? Rethrow it?
              // This is kind of an edge case.
            }
          }
        }

        return;
      }
    }

    fiber = fiber.return;
  }
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
  var pingCache = root.pingCache;

  if (pingCache !== null) {
    // The wakeable resolved, so we no longer need to memoize, because it will
    // never be thrown again.
    pingCache.delete(wakeable);
  }

  var eventTime = requestEventTime();
  markRootPinged(root, pingedLanes);

  if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
    // Received a ping at the same priority level at which we're currently
    // rendering. We might want to restart this render. This should mirror
    // the logic of whether or not a root suspends once it completes.
    // TODO: If we're rendering sync either due to Sync, Batched or expired,
    // we should probably never restart.
    // If we're suspended with delay, or if it's a retry, we'll always suspend
    // so we can always restart.
    if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
      // Restart from the root.
      prepareFreshStack(root, NoLanes);
    } else {
      // Even though we can't restart right now, we might get an
      // opportunity later. So we mark this render as having a ping.
      workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
    }
  }

  ensureRootIsScheduled(root, eventTime);
  schedulePendingInteractions(root, pingedLanes);
}

function retryTimedOutBoundary(boundaryFiber, retryLane) {
  // The boundary fiber (a Suspense component or SuspenseList component)
  // previously was rendered in its fallback state. One of the promises that
  // suspended it has resolved, which means at least part of the tree was
  // likely unblocked. Try rendering again, at a new expiration time.
  if (retryLane === NoLane) {
    retryLane = requestRetryLane(boundaryFiber);
  } // TODO: Special case idle priority?


  var eventTime = requestEventTime();
  var root = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);

  if (root !== null) {
    markRootUpdated(root, retryLane, eventTime);
    ensureRootIsScheduled(root, eventTime);
    schedulePendingInteractions(root, retryLane);
  }
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
  var retryLane = NoLane; // Default

  var retryCache;

  {
    retryCache = boundaryFiber.stateNode;
  }

  if (retryCache !== null) {
    // The wakeable resolved, so we no longer need to memoize, because it will
    // never be thrown again.
    retryCache.delete(wakeable);
  }

  retryTimedOutBoundary(boundaryFiber, retryLane);
} // Computes the next Just Noticeable Difference (JND) boundary.
// The theory is that a person can't tell the difference between small differences in time.
// Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
// difference in the experience. However, waiting for longer might mean that we can avoid
// showing an intermediate loading state. The longer we have already waited, the harder it
// is to tell small differences in time. Therefore, the longer we've already waited,
// the longer we can wait additionally. At some point we have to give up though.
// We pick a train model where the next boundary commits at a consistent schedule.
// These particular numbers are vague estimates. We expect to adjust them based on research.

function jnd(timeElapsed) {
  return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
}

function checkForNestedUpdates() {
  if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
    nestedUpdateCount = 0;
    rootWithNestedUpdates = null;

    {
      {
        throw Error( "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops." );
      }
    }
  }

  {
    if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
      nestedPassiveUpdateCount = 0;

      error('Maximum update depth exceeded. This can happen when a component ' + "calls setState inside useEffect, but useEffect either doesn't " + 'have a dependency array, or one of the dependencies changes on ' + 'every render.');
    }
  }
}

function flushRenderPhaseStrictModeWarningsInDEV() {
  {
    ReactStrictModeWarnings.flushLegacyContextWarning();

    {
      ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
  }
}

var didWarnStateUpdateForNotYetMountedComponent = null;

function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
  {
    if ((executionContext & RenderContext) !== NoContext) {
      // We let the other warning about render phase updates deal with this one.
      return;
    }

    if (!(fiber.mode & (BlockingMode | ConcurrentMode))) {
      return;
    }

    var tag = fiber.tag;

    if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
      // Only warn for user-defined components, not internal ones like Suspense.
      return;
    } // We show the whole stack but dedupe on the top component's name because
    // the problematic code almost always lies inside that component.


    var componentName = getComponentName(fiber.type) || 'ReactComponent';

    if (didWarnStateUpdateForNotYetMountedComponent !== null) {
      if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) {
        return;
      }

      didWarnStateUpdateForNotYetMountedComponent.add(componentName);
    } else {
      didWarnStateUpdateForNotYetMountedComponent = new Set([componentName]);
    }

    var previousFiber = current;

    try {
      setCurrentFiber(fiber);

      error("Can't perform a React state update on a component that hasn't mounted yet. " + 'This indicates that you have a side-effect in your render function that ' + 'asynchronously later calls tries to update the component. Move this work to ' + 'useEffect instead.');
    } finally {
      if (previousFiber) {
        setCurrentFiber(fiber);
      } else {
        resetCurrentFiber();
      }
    }
  }
}

var didWarnStateUpdateForUnmountedComponent = null;

function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
  {
    var tag = fiber.tag;

    if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
      // Only warn for user-defined components, not internal ones like Suspense.
      return;
    } // If there are pending passive effects unmounts for this Fiber,
    // we can assume that they would have prevented this update.


    if ((fiber.flags & PassiveUnmountPendingDev) !== NoFlags) {
      return;
    } // We show the whole stack but dedupe on the top component's name because
    // the problematic code almost always lies inside that component.


    var componentName = getComponentName(fiber.type) || 'ReactComponent';

    if (didWarnStateUpdateForUnmountedComponent !== null) {
      if (didWarnStateUpdateForUnmountedComponent.has(componentName)) {
        return;
      }

      didWarnStateUpdateForUnmountedComponent.add(componentName);
    } else {
      didWarnStateUpdateForUnmountedComponent = new Set([componentName]);
    }

    if (isFlushingPassiveEffects) ; else {
      var previousFiber = current;

      try {
        setCurrentFiber(fiber);

        error("Can't perform a React state update on an unmounted component. This " + 'is a no-op, but it indicates a memory leak in your application. To ' + 'fix, cancel all subscriptions and asynchronous tasks in %s.', tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function');
      } finally {
        if (previousFiber) {
          setCurrentFiber(fiber);
        } else {
          resetCurrentFiber();
        }
      }
    }
  }
}

var beginWork$1;

{
  var dummyFiber = null;

  beginWork$1 = function (current, unitOfWork, lanes) {
    // If a component throws an error, we replay it again in a synchronously
    // dispatched event, so that the debugger will treat it as an uncaught
    // error See ReactErrorUtils for more information.
    // Before entering the begin phase, copy the work-in-progress onto a dummy
    // fiber. If beginWork throws, we'll use this to reset the state.
    var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);

    try {
      return beginWork(current, unitOfWork, lanes);
    } catch (originalError) {
      if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') {
        // Don't replay promises. Treat everything else like an error.
        throw originalError;
      } // Keep this code in sync with handleError; any changes here must have
      // corresponding changes there.


      resetContextDependencies();
      resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
      // same fiber again.
      // Unwind the failed stack frame

      unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.

      assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);

      if ( unitOfWork.mode & ProfileMode) {
        // Reset the profiler timer.
        startProfilerTimer(unitOfWork);
      } // Run beginWork again.


      invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);

      if (hasCaughtError()) {
        var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
        // Rethrow this error instead of the original one.

        throw replayError;
      } else {
        // This branch is reachable if the render phase is impure.
        throw originalError;
      }
    }
  };
}

var didWarnAboutUpdateInRender = false;
var didWarnAboutUpdateInRenderForAnotherComponent;

{
  didWarnAboutUpdateInRenderForAnotherComponent = new Set();
}

function warnAboutRenderPhaseUpdatesInDEV(fiber) {
  {
    if (isRendering && (executionContext & RenderContext) !== NoContext && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) {
      switch (fiber.tag) {
        case FunctionComponent:
        case ForwardRef:
        case SimpleMemoComponent:
          {
            var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.

            var dedupeKey = renderingComponentName;

            if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
              didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
              var setStateComponentName = getComponentName(fiber.type) || 'Unknown';

              error('Cannot update a component (`%s`) while rendering a ' + 'different component (`%s`). To locate the bad setState() call inside `%s`, ' + 'follow the stack trace as described in https://reactjs.org/link/setstate-in-render', setStateComponentName, renderingComponentName, renderingComponentName);
            }

            break;
          }

        case ClassComponent:
          {
            if (!didWarnAboutUpdateInRender) {
              error('Cannot update during an existing state transition (such as ' + 'within `render`). Render methods should be a pure ' + 'function of props and state.');

              didWarnAboutUpdateInRender = true;
            }

            break;
          }
      }
    }
  }
} // a 'shared' variable that changes when act() opens/closes in tests.


var IsThisRendererActing = {
  current: false
};
function warnIfNotScopedWithMatchingAct(fiber) {
  {
    if ( IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
      var previousFiber = current;

      try {
        setCurrentFiber(fiber);

        error("It looks like you're using the wrong act() around your test interactions.\n" + 'Be sure to use the matching version of act() corresponding to your renderer:\n\n' + '// for react-dom:\n' + // Break up imports to avoid accidentally parsing them as dependencies.
        'import {act} fr' + "om 'react-dom/test-utils';\n" + '// ...\n' + 'act(() => ...);\n\n' + '// for react-test-renderer:\n' + // Break up imports to avoid accidentally parsing them as dependencies.
        'import TestRenderer fr' + "om react-test-renderer';\n" + 'const {act} = TestRenderer;\n' + '// ...\n' + 'act(() => ...);');
      } finally {
        if (previousFiber) {
          setCurrentFiber(fiber);
        } else {
          resetCurrentFiber();
        }
      }
    }
  }
}
function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
  {
    if ( (fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
      error('An update to %s ran an effect, but was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentName(fiber.type));
    }
  }
}

function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
  {
    if ( executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
      var previousFiber = current;

      try {
        setCurrentFiber(fiber);

        error('An update to %s inside a test was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentName(fiber.type));
      } finally {
        if (previousFiber) {
          setCurrentFiber(fiber);
        } else {
          resetCurrentFiber();
        }
      }
    }
  }
}

var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.

var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
// scheduler is the actual recommendation. The alternative could be a testing build,
// a new lib, or whatever; we dunno just yet. This message is for early adopters
// to get their tests right.

function warnIfUnmockedScheduler(fiber) {
  {
    if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
      if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
        didWarnAboutUnmockedScheduler = true;

        error('In Concurrent or Sync modes, the "scheduler" module needs to be mocked ' + 'to guarantee consistent behaviour across tests and browsers. ' + 'For example, with jest: \n' + // Break up requires to avoid accidentally parsing them as dependencies.
        "jest.mock('scheduler', () => require" + "('scheduler/unstable_mock'));\n\n" + 'For more info, visit https://reactjs.org/link/mock-scheduler');
      }
    }
  }
}

function computeThreadID(root, lane) {
  // Interaction threads are unique per root and expiration time.
  // NOTE: Intentionally unsound cast. All that matters is that it's a number
  // and it represents a batch of work. Could make a helper function instead,
  // but meh this is fine for now.
  return lane * 1000 + root.interactionThreadID;
}

function markSpawnedWork(lane) {

  if (spawnedWorkDuringRender === null) {
    spawnedWorkDuringRender = [lane];
  } else {
    spawnedWorkDuringRender.push(lane);
  }
}

function scheduleInteractions(root, lane, interactions) {

  if (interactions.size > 0) {
    var pendingInteractionMap = root.pendingInteractionMap;
    var pendingInteractions = pendingInteractionMap.get(lane);

    if (pendingInteractions != null) {
      interactions.forEach(function (interaction) {
        if (!pendingInteractions.has(interaction)) {
          // Update the pending async work count for previously unscheduled interaction.
          interaction.__count++;
        }

        pendingInteractions.add(interaction);
      });
    } else {
      pendingInteractionMap.set(lane, new Set(interactions)); // Update the pending async work count for the current interactions.

      interactions.forEach(function (interaction) {
        interaction.__count++;
      });
    }

    var subscriber = tracing.__subscriberRef.current;

    if (subscriber !== null) {
      var threadID = computeThreadID(root, lane);
      subscriber.onWorkScheduled(interactions, threadID);
    }
  }
}

function schedulePendingInteractions(root, lane) {

  scheduleInteractions(root, lane, tracing.__interactionsRef.current);
}

function startWorkOnPendingInteractions(root, lanes) {
  // we can accurately attribute time spent working on it, And so that cascading
  // work triggered during the render phase will be associated with it.


  var interactions = new Set();
  root.pendingInteractionMap.forEach(function (scheduledInteractions, scheduledLane) {
    if (includesSomeLane(lanes, scheduledLane)) {
      scheduledInteractions.forEach(function (interaction) {
        return interactions.add(interaction);
      });
    }
  }); // Store the current set of interactions on the FiberRoot for a few reasons:
  // We can re-use it in hot functions like performConcurrentWorkOnRoot()
  // without having to recalculate it. We will also use it in commitWork() to
  // pass to any Profiler onRender() hooks. This also provides DevTools with a
  // way to access it when the onCommitRoot() hook is called.

  root.memoizedInteractions = interactions;

  if (interactions.size > 0) {
    var subscriber = tracing.__subscriberRef.current;

    if (subscriber !== null) {
      var threadID = computeThreadID(root, lanes);

      try {
        subscriber.onWorkStarted(interactions, threadID);
      } catch (error) {
        // If the subscriber throws, rethrow it in a separate task
        scheduleCallback(ImmediatePriority$1, function () {
          throw error;
        });
      }
    }
  }
}

function finishPendingInteractions(root, committedLanes) {

  var remainingLanesAfterCommit = root.pendingLanes;
  var subscriber;

  try {
    subscriber = tracing.__subscriberRef.current;

    if (subscriber !== null && root.memoizedInteractions.size > 0) {
      // FIXME: More than one lane can finish in a single commit.
      var threadID = computeThreadID(root, committedLanes);
      subscriber.onWorkStopped(root.memoizedInteractions, threadID);
    }
  } catch (error) {
    // If the subscriber throws, rethrow it in a separate task
    scheduleCallback(ImmediatePriority$1, function () {
      throw error;
    });
  } finally {
    // Clear completed interactions from the pending Map.
    // Unless the render was suspended or cascading work was scheduled,
    // In which case– leave pending interactions until the subsequent render.
    var pendingInteractionMap = root.pendingInteractionMap;
    pendingInteractionMap.forEach(function (scheduledInteractions, lane) {
      // Only decrement the pending interaction count if we're done.
      // If there's still work at the current priority,
      // That indicates that we are waiting for suspense data.
      if (!includesSomeLane(remainingLanesAfterCommit, lane)) {
        pendingInteractionMap.delete(lane);
        scheduledInteractions.forEach(function (interaction) {
          interaction.__count--;

          if (subscriber !== null && interaction.__count === 0) {
            try {
              subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
              // If the subscriber throws, rethrow it in a separate task
              scheduleCallback(ImmediatePriority$1, function () {
                throw error;
              });
            }
          }
        });
      }
    });
  }
} // `act` testing API

function shouldForceFlushFallbacksInDEV() {
  // Never force flush in production. This function should get stripped out.
  return  actingUpdatesScopeDepth > 0;
}
// so we can tell if any async act() calls try to run in parallel.


var actingUpdatesScopeDepth = 0;

function detachFiberAfterEffects(fiber) {
  fiber.sibling = null;
  fiber.stateNode = null;
}

var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.

var failedBoundaries = null;
var setRefreshHandler = function (handler) {
  {
    resolveFamily = handler;
  }
};
function resolveFunctionForHotReloading(type) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return type;
    }

    var family = resolveFamily(type);

    if (family === undefined) {
      return type;
    } // Use the latest known implementation.


    return family.current;
  }
}
function resolveClassForHotReloading(type) {
  // No implementation differences.
  return resolveFunctionForHotReloading(type);
}
function resolveForwardRefForHotReloading(type) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return type;
    }

    var family = resolveFamily(type);

    if (family === undefined) {
      // Check if we're dealing with a real forwardRef. Don't want to crash early.
      if (type !== null && type !== undefined && typeof type.render === 'function') {
        // ForwardRef is special because its resolved .type is an object,
        // but it's possible that we only have its inner render function in the map.
        // If that inner render function is different, we'll build a new forwardRef type.
        var currentRender = resolveFunctionForHotReloading(type.render);

        if (type.render !== currentRender) {
          var syntheticType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: currentRender
          };

          if (type.displayName !== undefined) {
            syntheticType.displayName = type.displayName;
          }

          return syntheticType;
        }
      }

      return type;
    } // Use the latest known implementation.


    return family.current;
  }
}
function isCompatibleFamilyForHotReloading(fiber, element) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return false;
    }

    var prevType = fiber.elementType;
    var nextType = element.type; // If we got here, we know types aren't === equal.

    var needsCompareFamilies = false;
    var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;

    switch (fiber.tag) {
      case ClassComponent:
        {
          if (typeof nextType === 'function') {
            needsCompareFamilies = true;
          }

          break;
        }

      case FunctionComponent:
        {
          if (typeof nextType === 'function') {
            needsCompareFamilies = true;
          } else if ($$typeofNextType === REACT_LAZY_TYPE) {
            // We don't know the inner type yet.
            // We're going to assume that the lazy inner type is stable,
            // and so it is sufficient to avoid reconciling it away.
            // We're not going to unwrap or actually use the new lazy type.
            needsCompareFamilies = true;
          }

          break;
        }

      case ForwardRef:
        {
          if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
            needsCompareFamilies = true;
          } else if ($$typeofNextType === REACT_LAZY_TYPE) {
            needsCompareFamilies = true;
          }

          break;
        }

      case MemoComponent:
      case SimpleMemoComponent:
        {
          if ($$typeofNextType === REACT_MEMO_TYPE) {
            // TODO: if it was but can no longer be simple,
            // we shouldn't set this.
            needsCompareFamilies = true;
          } else if ($$typeofNextType === REACT_LAZY_TYPE) {
            needsCompareFamilies = true;
          }

          break;
        }

      default:
        return false;
    } // Check if both types have a family and it's the same one.


    if (needsCompareFamilies) {
      // Note: memo() and forwardRef() we'll compare outer rather than inner type.
      // This means both of them need to be registered to preserve state.
      // If we unwrapped and compared the inner types for wrappers instead,
      // then we would risk falsely saying two separate memo(Foo)
      // calls are equivalent because they wrap the same Foo function.
      var prevFamily = resolveFamily(prevType);

      if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) {
        return true;
      }
    }

    return false;
  }
}
function markFailedErrorBoundaryForHotReloading(fiber) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return;
    }

    if (typeof WeakSet !== 'function') {
      return;
    }

    if (failedBoundaries === null) {
      failedBoundaries = new WeakSet();
    }

    failedBoundaries.add(fiber);
  }
}
var scheduleRefresh = function (root, update) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return;
    }

    var staleFamilies = update.staleFamilies,
        updatedFamilies = update.updatedFamilies;
    flushPassiveEffects();
    flushSync(function () {
      scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
    });
  }
};
var scheduleRoot = function (root, element) {
  {
    if (root.context !== emptyContextObject) {
      // Super edge case: root has a legacy _renderSubtree context
      // but we don't know the parentComponent so we can't pass it.
      // Just ignore. We'll delete this with _renderSubtree code path later.
      return;
    }

    flushPassiveEffects();
    flushSync(function () {
      updateContainer(element, root, null, null);
    });
  }
};

function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
  {
    var alternate = fiber.alternate,
        child = fiber.child,
        sibling = fiber.sibling,
        tag = fiber.tag,
        type = fiber.type;
    var candidateType = null;

    switch (tag) {
      case FunctionComponent:
      case SimpleMemoComponent:
      case ClassComponent:
        candidateType = type;
        break;

      case ForwardRef:
        candidateType = type.render;
        break;
    }

    if (resolveFamily === null) {
      throw new Error('Expected resolveFamily to be set during hot reload.');
    }

    var needsRender = false;
    var needsRemount = false;

    if (candidateType !== null) {
      var family = resolveFamily(candidateType);

      if (family !== undefined) {
        if (staleFamilies.has(family)) {
          needsRemount = true;
        } else if (updatedFamilies.has(family)) {
          if (tag === ClassComponent) {
            needsRemount = true;
          } else {
            needsRender = true;
          }
        }
      }
    }

    if (failedBoundaries !== null) {
      if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
        needsRemount = true;
      }
    }

    if (needsRemount) {
      fiber._debugNeedsRemount = true;
    }

    if (needsRemount || needsRender) {
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }

    if (child !== null && !needsRemount) {
      scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
    }

    if (sibling !== null) {
      scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
  }
}

var findHostInstancesForRefresh = function (root, families) {
  {
    var hostInstances = new Set();
    var types = new Set(families.map(function (family) {
      return family.current;
    }));
    findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
    return hostInstances;
  }
};

function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
  {
    var child = fiber.child,
        sibling = fiber.sibling,
        tag = fiber.tag,
        type = fiber.type;
    var candidateType = null;

    switch (tag) {
      case FunctionComponent:
      case SimpleMemoComponent:
      case ClassComponent:
        candidateType = type;
        break;

      case ForwardRef:
        candidateType = type.render;
        break;
    }

    var didMatch = false;

    if (candidateType !== null) {
      if (types.has(candidateType)) {
        didMatch = true;
      }
    }

    if (didMatch) {
      // We have a match. This only drills down to the closest host components.
      // There's no need to search deeper because for the purpose of giving
      // visual feedback, "flashing" outermost parent rectangles is sufficient.
      findHostInstancesForFiberShallowly(fiber, hostInstances);
    } else {
      // If there's no match, maybe there will be one further down in the child tree.
      if (child !== null) {
        findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
      }
    }

    if (sibling !== null) {
      findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
  }
}

function findHostInstancesForFiberShallowly(fiber, hostInstances) {
  {
    var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);

    if (foundHostInstances) {
      return;
    } // If we didn't find any host children, fallback to closest host parent.


    var node = fiber;

    while (true) {
      switch (node.tag) {
        case HostComponent:
          hostInstances.add(node.stateNode);
          return;

        case HostPortal:
          hostInstances.add(node.stateNode.containerInfo);
          return;

        case HostRoot:
          hostInstances.add(node.stateNode.containerInfo);
          return;
      }

      if (node.return === null) {
        throw new Error('Expected to reach root first.');
      }

      node = node.return;
    }
  }
}

function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
  {
    var node = fiber;
    var foundHostInstances = false;

    while (true) {
      if (node.tag === HostComponent) {
        // We got a match.
        foundHostInstances = true;
        hostInstances.add(node.stateNode); // There may still be more, so keep searching.
      } else if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }

      if (node === fiber) {
        return foundHostInstances;
      }

      while (node.sibling === null) {
        if (node.return === null || node.return === fiber) {
          return foundHostInstances;
        }

        node = node.return;
      }

      node.sibling.return = node.return;
      node = node.sibling;
    }
  }

  return false;
}

var hasBadMapPolyfill;

{
  hasBadMapPolyfill = false;

  try {
    var nonExtensibleObject = Object.preventExtensions({});
    /* eslint-disable no-new */

    new Map([[nonExtensibleObject, null]]);
    new Set([nonExtensibleObject]);
    /* eslint-enable no-new */
  } catch (e) {
    // TODO: Consider warning about bad polyfills
    hasBadMapPolyfill = true;
  }
}

var debugCounter = 1;

function FiberNode(tag, pendingProps, key, mode) {
  // Instance
  this.tag = tag;
  this.key = key;
  this.elementType = null;
  this.type = null;
  this.stateNode = null; // Fiber

  this.return = null;
  this.child = null;
  this.sibling = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = pendingProps;
  this.memoizedProps = null;
  this.updateQueue = null;
  this.memoizedState = null;
  this.dependencies = null;
  this.mode = mode; // Effects

  this.flags = NoFlags;
  this.nextEffect = null;
  this.firstEffect = null;
  this.lastEffect = null;
  this.lanes = NoLanes;
  this.childLanes = NoLanes;
  this.alternate = null;

  {
    // Note: The following is done to avoid a v8 performance cliff.
    //
    // Initializing the fields below to smis and later updating them with
    // double values will cause Fibers to end up having separate shapes.
    // This behavior/bug has something to do with Object.preventExtension().
    // Fortunately this only impacts DEV builds.
    // Unfortunately it makes React unusably slow for some applications.
    // To work around this, initialize the fields below with doubles.
    //
    // Learn more about this here:
    // https://github.com/facebook/react/issues/14365
    // https://bugs.chromium.org/p/v8/issues/detail?id=8538
    this.actualDuration = Number.NaN;
    this.actualStartTime = Number.NaN;
    this.selfBaseDuration = Number.NaN;
    this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
    // This won't trigger the performance cliff mentioned above,
    // and it simplifies other profiler code (including DevTools).

    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.selfBaseDuration = 0;
    this.treeBaseDuration = 0;
  }

  {
    // This isn't directly used but is handy for debugging internals:
    this._debugID = debugCounter++;
    this._debugSource = null;
    this._debugOwner = null;
    this._debugNeedsRemount = false;
    this._debugHookTypes = null;

    if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
      Object.preventExtensions(this);
    }
  }
} // This is a constructor function, rather than a POJO constructor, still
// please ensure we do the following:
// 1) Nobody should add any instance methods on this. Instance methods can be
//    more difficult to predict when they get optimized and they are almost
//    never inlined properly in static compilers.
// 2) Nobody should rely on `instanceof Fiber` for type testing. We should
//    always know when it is a fiber.
// 3) We might want to experiment with using numeric keys since they are easier
//    to optimize in a non-JIT environment.
// 4) We can easily go from a constructor to a createFiber object literal if that
//    is faster.
// 5) It should be easy to port this to a C struct and keep a C implementation
//    compatible.


var createFiber = function (tag, pendingProps, key, mode) {
  // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
  return new FiberNode(tag, pendingProps, key, mode);
};

function shouldConstruct$1(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function isSimpleFunctionComponent(type) {
  return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
}
function resolveLazyComponentTag(Component) {
  if (typeof Component === 'function') {
    return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
  } else if (Component !== undefined && Component !== null) {
    var $$typeof = Component.$$typeof;

    if ($$typeof === REACT_FORWARD_REF_TYPE) {
      return ForwardRef;
    }

    if ($$typeof === REACT_MEMO_TYPE) {
      return MemoComponent;
    }
  }

  return IndeterminateComponent;
} // This is used to create an alternate fiber to do work on.

function createWorkInProgress(current, pendingProps) {
  var workInProgress = current.alternate;

  if (workInProgress === null) {
    // We use a double buffering pooling technique because we know that we'll
    // only ever need at most two versions of a tree. We pool the "other" unused
    // node that we're free to reuse. This is lazily created to avoid allocating
    // extra objects for things that are never updated. It also allow us to
    // reclaim the extra memory if needed.
    workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
    workInProgress.elementType = current.elementType;
    workInProgress.type = current.type;
    workInProgress.stateNode = current.stateNode;

    {
      // DEV-only fields
      workInProgress._debugID = current._debugID;
      workInProgress._debugSource = current._debugSource;
      workInProgress._debugOwner = current._debugOwner;
      workInProgress._debugHookTypes = current._debugHookTypes;
    }

    workInProgress.alternate = current;
    current.alternate = workInProgress;
  } else {
    workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.

    workInProgress.type = current.type; // We already have an alternate.
    // Reset the effect tag.

    workInProgress.flags = NoFlags; // The effect list is no longer valid.

    workInProgress.nextEffect = null;
    workInProgress.firstEffect = null;
    workInProgress.lastEffect = null;

    {
      // We intentionally reset, rather than copy, actualDuration & actualStartTime.
      // This prevents time from endlessly accumulating in new commits.
      // This has the downside of resetting values for different priority renders,
      // But works for yielding (the common case) and should support resuming.
      workInProgress.actualDuration = 0;
      workInProgress.actualStartTime = -1;
    }
  }

  workInProgress.childLanes = current.childLanes;
  workInProgress.lanes = current.lanes;
  workInProgress.child = current.child;
  workInProgress.memoizedProps = current.memoizedProps;
  workInProgress.memoizedState = current.memoizedState;
  workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
  // it cannot be shared with the current fiber.

  var currentDependencies = current.dependencies;
  workInProgress.dependencies = currentDependencies === null ? null : {
    lanes: currentDependencies.lanes,
    firstContext: currentDependencies.firstContext
  }; // These will be overridden during the parent's reconciliation

  workInProgress.sibling = current.sibling;
  workInProgress.index = current.index;
  workInProgress.ref = current.ref;

  {
    workInProgress.selfBaseDuration = current.selfBaseDuration;
    workInProgress.treeBaseDuration = current.treeBaseDuration;
  }

  {
    workInProgress._debugNeedsRemount = current._debugNeedsRemount;

    switch (workInProgress.tag) {
      case IndeterminateComponent:
      case FunctionComponent:
      case SimpleMemoComponent:
        workInProgress.type = resolveFunctionForHotReloading(current.type);
        break;

      case ClassComponent:
        workInProgress.type = resolveClassForHotReloading(current.type);
        break;

      case ForwardRef:
        workInProgress.type = resolveForwardRefForHotReloading(current.type);
        break;
    }
  }

  return workInProgress;
} // Used to reuse a Fiber for a second pass.

function resetWorkInProgress(workInProgress, renderLanes) {
  // This resets the Fiber to what createFiber or createWorkInProgress would
  // have set the values to before during the first pass. Ideally this wouldn't
  // be necessary but unfortunately many code paths reads from the workInProgress
  // when they should be reading from current and writing to workInProgress.
  // We assume pendingProps, index, key, ref, return are still untouched to
  // avoid doing another reconciliation.
  // Reset the effect tag but keep any Placement tags, since that's something
  // that child fiber is setting, not the reconciliation.
  workInProgress.flags &= Placement; // The effect list is no longer valid.

  workInProgress.nextEffect = null;
  workInProgress.firstEffect = null;
  workInProgress.lastEffect = null;
  var current = workInProgress.alternate;

  if (current === null) {
    // Reset to createFiber's initial values.
    workInProgress.childLanes = NoLanes;
    workInProgress.lanes = renderLanes;
    workInProgress.child = null;
    workInProgress.memoizedProps = null;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.dependencies = null;
    workInProgress.stateNode = null;

    {
      // Note: We don't reset the actualTime counts. It's useful to accumulate
      // actual time across multiple render passes.
      workInProgress.selfBaseDuration = 0;
      workInProgress.treeBaseDuration = 0;
    }
  } else {
    // Reset to the cloned values that createWorkInProgress would've.
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.

    workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
    // it cannot be shared with the current fiber.

    var currentDependencies = current.dependencies;
    workInProgress.dependencies = currentDependencies === null ? null : {
      lanes: currentDependencies.lanes,
      firstContext: currentDependencies.firstContext
    };

    {
      // Note: We don't reset the actualTime counts. It's useful to accumulate
      // actual time across multiple render passes.
      workInProgress.selfBaseDuration = current.selfBaseDuration;
      workInProgress.treeBaseDuration = current.treeBaseDuration;
    }
  }

  return workInProgress;
}
function createHostRootFiber(tag) {
  var mode;

  if (tag === ConcurrentRoot) {
    mode = ConcurrentMode | BlockingMode | StrictMode;
  } else if (tag === BlockingRoot) {
    mode = BlockingMode | StrictMode;
  } else {
    mode = NoMode;
  }

  if ( isDevToolsPresent) {
    // Always collect profile timings when DevTools are present.
    // This enables DevTools to start capturing timing at any point–
    // Without some nodes in the tree having empty base times.
    mode |= ProfileMode;
  }

  return createFiber(HostRoot, null, null, mode);
}
function createFiberFromTypeAndProps(type, // React$ElementType
key, pendingProps, owner, mode, lanes) {
  var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.

  var resolvedType = type;

  if (typeof type === 'function') {
    if (shouldConstruct$1(type)) {
      fiberTag = ClassComponent;

      {
        resolvedType = resolveClassForHotReloading(resolvedType);
      }
    } else {
      {
        resolvedType = resolveFunctionForHotReloading(resolvedType);
      }
    }
  } else if (typeof type === 'string') {
    fiberTag = HostComponent;
  } else {
    getTag: switch (type) {
      case REACT_FRAGMENT_TYPE:
        return createFiberFromFragment(pendingProps.children, mode, lanes, key);

      case REACT_DEBUG_TRACING_MODE_TYPE:
        fiberTag = Mode;
        mode |= DebugTracingMode;
        break;

      case REACT_STRICT_MODE_TYPE:
        fiberTag = Mode;
        mode |= StrictMode;
        break;

      case REACT_PROFILER_TYPE:
        return createFiberFromProfiler(pendingProps, mode, lanes, key);

      case REACT_SUSPENSE_TYPE:
        return createFiberFromSuspense(pendingProps, mode, lanes, key);

      case REACT_SUSPENSE_LIST_TYPE:
        return createFiberFromSuspenseList(pendingProps, mode, lanes, key);

      case REACT_OFFSCREEN_TYPE:
        return createFiberFromOffscreen(pendingProps, mode, lanes, key);

      case REACT_LEGACY_HIDDEN_TYPE:
        return createFiberFromLegacyHidden(pendingProps, mode, lanes, key);

      case REACT_SCOPE_TYPE:

      // eslint-disable-next-line no-fallthrough

      default:
        {
          if (typeof type === 'object' && type !== null) {
            switch (type.$$typeof) {
              case REACT_PROVIDER_TYPE:
                fiberTag = ContextProvider;
                break getTag;

              case REACT_CONTEXT_TYPE:
                // This is a consumer
                fiberTag = ContextConsumer;
                break getTag;

              case REACT_FORWARD_REF_TYPE:
                fiberTag = ForwardRef;

                {
                  resolvedType = resolveForwardRefForHotReloading(resolvedType);
                }

                break getTag;

              case REACT_MEMO_TYPE:
                fiberTag = MemoComponent;
                break getTag;

              case REACT_LAZY_TYPE:
                fiberTag = LazyComponent;
                resolvedType = null;
                break getTag;

              case REACT_BLOCK_TYPE:
                fiberTag = Block;
                break getTag;
            }
          }

          var info = '';

          {
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
            }

            var ownerName = owner ? getComponentName(owner.type) : null;

            if (ownerName) {
              info += '\n\nCheck the render method of `' + ownerName + '`.';
            }
          }

          {
            {
              throw Error( "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info );
            }
          }
        }
    }
  }

  var fiber = createFiber(fiberTag, pendingProps, key, mode);
  fiber.elementType = type;
  fiber.type = resolvedType;
  fiber.lanes = lanes;

  {
    fiber._debugOwner = owner;
  }

  return fiber;
}
function createFiberFromElement(element, mode, lanes) {
  var owner = null;

  {
    owner = element._owner;
  }

  var type = element.type;
  var key = element.key;
  var pendingProps = element.props;
  var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);

  {
    fiber._debugSource = element._source;
    fiber._debugOwner = element._owner;
  }

  return fiber;
}
function createFiberFromFragment(elements, mode, lanes, key) {
  var fiber = createFiber(Fragment, elements, key, mode);
  fiber.lanes = lanes;
  return fiber;
}

function createFiberFromProfiler(pendingProps, mode, lanes, key) {
  {
    if (typeof pendingProps.id !== 'string') {
      error('Profiler must specify an "id" as a prop');
    }
  }

  var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.

  fiber.elementType = REACT_PROFILER_TYPE;
  fiber.type = REACT_PROFILER_TYPE;
  fiber.lanes = lanes;

  {
    fiber.stateNode = {
      effectDuration: 0,
      passiveEffectDuration: 0
    };
  }

  return fiber;
}

function createFiberFromSuspense(pendingProps, mode, lanes, key) {
  var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
  // This needs to be fixed in getComponentName so that it relies on the tag
  // instead.

  fiber.type = REACT_SUSPENSE_TYPE;
  fiber.elementType = REACT_SUSPENSE_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
  var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);

  {
    // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
    // This needs to be fixed in getComponentName so that it relies on the tag
    // instead.
    fiber.type = REACT_SUSPENSE_LIST_TYPE;
  }

  fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
  var fiber = createFiber(OffscreenComponent, pendingProps, key, mode); // TODO: The OffscreenComponent fiber shouldn't have a type. It has a tag.
  // This needs to be fixed in getComponentName so that it relies on the tag
  // instead.

  {
    fiber.type = REACT_OFFSCREEN_TYPE;
  }

  fiber.elementType = REACT_OFFSCREEN_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromLegacyHidden(pendingProps, mode, lanes, key) {
  var fiber = createFiber(LegacyHiddenComponent, pendingProps, key, mode); // TODO: The LegacyHidden fiber shouldn't have a type. It has a tag.
  // This needs to be fixed in getComponentName so that it relies on the tag
  // instead.

  {
    fiber.type = REACT_LEGACY_HIDDEN_TYPE;
  }

  fiber.elementType = REACT_LEGACY_HIDDEN_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromText(content, mode, lanes) {
  var fiber = createFiber(HostText, content, null, mode);
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromHostInstanceForDeletion() {
  var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.

  fiber.elementType = 'DELETED';
  fiber.type = 'DELETED';
  return fiber;
}
function createFiberFromPortal(portal, mode, lanes) {
  var pendingProps = portal.children !== null ? portal.children : [];
  var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
  fiber.lanes = lanes;
  fiber.stateNode = {
    containerInfo: portal.containerInfo,
    pendingChildren: null,
    // Used by persistent updates
    implementation: portal.implementation
  };
  return fiber;
} // Used for stashing WIP properties to replay failed work in DEV.

function assignFiberPropertiesInDEV(target, source) {
  if (target === null) {
    // This Fiber's initial properties will always be overwritten.
    // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
    target = createFiber(IndeterminateComponent, null, null, NoMode);
  } // This is intentionally written as a list of all properties.
  // We tried to use Object.assign() instead but this is called in
  // the hottest path, and Object.assign() was too slow:
  // https://github.com/facebook/react/issues/12502
  // This code is DEV-only so size is not a concern.


  target.tag = source.tag;
  target.key = source.key;
  target.elementType = source.elementType;
  target.type = source.type;
  target.stateNode = source.stateNode;
  target.return = source.return;
  target.child = source.child;
  target.sibling = source.sibling;
  target.index = source.index;
  target.ref = source.ref;
  target.pendingProps = source.pendingProps;
  target.memoizedProps = source.memoizedProps;
  target.updateQueue = source.updateQueue;
  target.memoizedState = source.memoizedState;
  target.dependencies = source.dependencies;
  target.mode = source.mode;
  target.flags = source.flags;
  target.nextEffect = source.nextEffect;
  target.firstEffect = source.firstEffect;
  target.lastEffect = source.lastEffect;
  target.lanes = source.lanes;
  target.childLanes = source.childLanes;
  target.alternate = source.alternate;

  {
    target.actualDuration = source.actualDuration;
    target.actualStartTime = source.actualStartTime;
    target.selfBaseDuration = source.selfBaseDuration;
    target.treeBaseDuration = source.treeBaseDuration;
  }

  target._debugID = source._debugID;
  target._debugSource = source._debugSource;
  target._debugOwner = source._debugOwner;
  target._debugNeedsRemount = source._debugNeedsRemount;
  target._debugHookTypes = source._debugHookTypes;
  return target;
}

function FiberRootNode(containerInfo, tag, hydrate) {
  this.tag = tag;
  this.containerInfo = containerInfo;
  this.pendingChildren = null;
  this.current = null;
  this.pingCache = null;
  this.finishedWork = null;
  this.timeoutHandle = noTimeout;
  this.context = null;
  this.pendingContext = null;
  this.hydrate = hydrate;
  this.callbackNode = null;
  this.callbackPriority = NoLanePriority;
  this.eventTimes = createLaneMap(NoLanes);
  this.expirationTimes = createLaneMap(NoTimestamp);
  this.pendingLanes = NoLanes;
  this.suspendedLanes = NoLanes;
  this.pingedLanes = NoLanes;
  this.expiredLanes = NoLanes;
  this.mutableReadLanes = NoLanes;
  this.finishedLanes = NoLanes;
  this.entangledLanes = NoLanes;
  this.entanglements = createLaneMap(NoLanes);

  {
    this.mutableSourceEagerHydrationData = null;
  }

  {
    this.interactionThreadID = tracing.unstable_getThreadID();
    this.memoizedInteractions = new Set();
    this.pendingInteractionMap = new Map();
  }

  {
    switch (tag) {
      case BlockingRoot:
        this._debugRootType = 'createBlockingRoot()';
        break;

      case ConcurrentRoot:
        this._debugRootType = 'createRoot()';
        break;

      case LegacyRoot:
        this._debugRootType = 'createLegacyRoot()';
        break;
    }
  }
}

function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
  var root = new FiberRootNode(containerInfo, tag, hydrate);
  // stateNode is any.


  var uninitializedFiber = createHostRootFiber(tag);
  root.current = uninitializedFiber;
  uninitializedFiber.stateNode = root;
  initializeUpdateQueue(uninitializedFiber);
  return root;
}

// This ensures that the version used for server rendering matches the one
// that is eventually read during hydration.
// If they don't match there's a potential tear and a full deopt render is required.

function registerMutableSourceForHydration(root, mutableSource) {
  var getVersion = mutableSource._getVersion;
  var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
  // Retaining it forever may interfere with GC.

  if (root.mutableSourceEagerHydrationData == null) {
    root.mutableSourceEagerHydrationData = [mutableSource, version];
  } else {
    root.mutableSourceEagerHydrationData.push(mutableSource, version);
  }
}

function createPortal(children, containerInfo, // TODO: figure out the API for cross-renderer implementation.
implementation) {
  var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return {
    // This tag allow us to uniquely identify this as a React Portal
    $$typeof: REACT_PORTAL_TYPE,
    key: key == null ? null : '' + key,
    children: children,
    containerInfo: containerInfo,
    implementation: implementation
  };
}

var didWarnAboutNestedUpdates;
var didWarnAboutFindNodeInStrictMode;

{
  didWarnAboutNestedUpdates = false;
  didWarnAboutFindNodeInStrictMode = {};
}

function getContextForSubtree(parentComponent) {
  if (!parentComponent) {
    return emptyContextObject;
  }

  var fiber = get(parentComponent);
  var parentContext = findCurrentUnmaskedContext(fiber);

  if (fiber.tag === ClassComponent) {
    var Component = fiber.type;

    if (isContextProvider(Component)) {
      return processChildContext(fiber, Component, parentContext);
    }
  }

  return parentContext;
}

function findHostInstanceWithWarning(component, methodName) {
  {
    var fiber = get(component);

    if (fiber === undefined) {
      if (typeof component.render === 'function') {
        {
          {
            throw Error( "Unable to find node on an unmounted component." );
          }
        }
      } else {
        {
          {
            throw Error( "Argument appears to not be a ReactComponent. Keys: " + Object.keys(component) );
          }
        }
      }
    }

    var hostFiber = findCurrentHostFiber(fiber);

    if (hostFiber === null) {
      return null;
    }

    if (hostFiber.mode & StrictMode) {
      var componentName = getComponentName(fiber.type) || 'Component';

      if (!didWarnAboutFindNodeInStrictMode[componentName]) {
        didWarnAboutFindNodeInStrictMode[componentName] = true;
        var previousFiber = current;

        try {
          setCurrentFiber(hostFiber);

          if (fiber.mode & StrictMode) {
            error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which is inside StrictMode. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
          } else {
            error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which renders StrictMode children. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
          }
        } finally {
          // Ideally this should reset to previous but this shouldn't be called in
          // render and there's another warning for that anyway.
          if (previousFiber) {
            setCurrentFiber(previousFiber);
          } else {
            resetCurrentFiber();
          }
        }
      }
    }

    return hostFiber.stateNode;
  }
}

function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
  return createFiberRoot(containerInfo, tag, hydrate);
}
function updateContainer(element, container, parentComponent, callback) {
  {
    onScheduleRoot(container, element);
  }

  var current$1 = container.current;
  var eventTime = requestEventTime();

  {
    // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
    if ('undefined' !== typeof jest) {
      warnIfUnmockedScheduler(current$1);
      warnIfNotScopedWithMatchingAct(current$1);
    }
  }

  var lane = requestUpdateLane(current$1);

  var context = getContextForSubtree(parentComponent);

  if (container.context === null) {
    container.context = context;
  } else {
    container.pendingContext = context;
  }

  {
    if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
      didWarnAboutNestedUpdates = true;

      error('Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentName(current.type) || 'Unknown');
    }
  }

  var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
  // being called "element".

  update.payload = {
    element: element
  };
  callback = callback === undefined ? null : callback;

  if (callback !== null) {
    {
      if (typeof callback !== 'function') {
        error('render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback);
      }
    }

    update.callback = callback;
  }

  enqueueUpdate(current$1, update);
  scheduleUpdateOnFiber(current$1, lane, eventTime);
  return lane;
}
function getPublicRootInstance(container) {
  var containerFiber = container.current;

  if (!containerFiber.child) {
    return null;
  }

  switch (containerFiber.child.tag) {
    case HostComponent:
      return getPublicInstance(containerFiber.child.stateNode);

    default:
      return containerFiber.child.stateNode;
  }
}

function markRetryLaneImpl(fiber, retryLane) {
  var suspenseState = fiber.memoizedState;

  if (suspenseState !== null && suspenseState.dehydrated !== null) {
    suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
  }
} // Increases the priority of thennables when they resolve within this boundary.


function markRetryLaneIfNotHydrated(fiber, retryLane) {
  markRetryLaneImpl(fiber, retryLane);
  var alternate = fiber.alternate;

  if (alternate) {
    markRetryLaneImpl(alternate, retryLane);
  }
}

function attemptUserBlockingHydration$1(fiber) {
  if (fiber.tag !== SuspenseComponent) {
    // We ignore HostRoots here because we can't increase
    // their priority and they should not suspend on I/O,
    // since you have to wrap anything that might suspend in
    // Suspense.
    return;
  }

  var eventTime = requestEventTime();
  var lane = InputDiscreteHydrationLane;
  scheduleUpdateOnFiber(fiber, lane, eventTime);
  markRetryLaneIfNotHydrated(fiber, lane);
}
function attemptContinuousHydration$1(fiber) {
  if (fiber.tag !== SuspenseComponent) {
    // We ignore HostRoots here because we can't increase
    // their priority and they should not suspend on I/O,
    // since you have to wrap anything that might suspend in
    // Suspense.
    return;
  }

  var eventTime = requestEventTime();
  var lane = SelectiveHydrationLane;
  scheduleUpdateOnFiber(fiber, lane, eventTime);
  markRetryLaneIfNotHydrated(fiber, lane);
}
function attemptHydrationAtCurrentPriority$1(fiber) {
  if (fiber.tag !== SuspenseComponent) {
    // We ignore HostRoots here because we can't increase
    // their priority other than synchronously flush it.
    return;
  }

  var eventTime = requestEventTime();
  var lane = requestUpdateLane(fiber);
  scheduleUpdateOnFiber(fiber, lane, eventTime);
  markRetryLaneIfNotHydrated(fiber, lane);
}
function runWithPriority$2(priority, fn) {

  try {
    setCurrentUpdateLanePriority(priority);
    return fn();
  } finally {
  }
}
function findHostInstanceWithNoPortals(fiber) {
  var hostFiber = findCurrentHostFiberWithNoPortals(fiber);

  if (hostFiber === null) {
    return null;
  }

  if (hostFiber.tag === FundamentalComponent) {
    return hostFiber.stateNode.instance;
  }

  return hostFiber.stateNode;
}

var shouldSuspendImpl = function (fiber) {
  return false;
};

function shouldSuspend(fiber) {
  return shouldSuspendImpl(fiber);
}
var overrideHookState = null;
var overrideHookStateDeletePath = null;
var overrideHookStateRenamePath = null;
var overrideProps = null;
var overridePropsDeletePath = null;
var overridePropsRenamePath = null;
var scheduleUpdate = null;
var setSuspenseHandler = null;

{
  var copyWithDeleteImpl = function (obj, path, index) {
    var key = path[index];
    var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);

    if (index + 1 === path.length) {
      if (Array.isArray(updated)) {
        updated.splice(key, 1);
      } else {
        delete updated[key];
      }

      return updated;
    } // $FlowFixMe number or string is fine here


    updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
    return updated;
  };

  var copyWithDelete = function (obj, path) {
    return copyWithDeleteImpl(obj, path, 0);
  };

  var copyWithRenameImpl = function (obj, oldPath, newPath, index) {
    var oldKey = oldPath[index];
    var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);

    if (index + 1 === oldPath.length) {
      var newKey = newPath[index]; // $FlowFixMe number or string is fine here

      updated[newKey] = updated[oldKey];

      if (Array.isArray(updated)) {
        updated.splice(oldKey, 1);
      } else {
        delete updated[oldKey];
      }
    } else {
      // $FlowFixMe number or string is fine here
      updated[oldKey] = copyWithRenameImpl( // $FlowFixMe number or string is fine here
      obj[oldKey], oldPath, newPath, index + 1);
    }

    return updated;
  };

  var copyWithRename = function (obj, oldPath, newPath) {
    if (oldPath.length !== newPath.length) {
      warn('copyWithRename() expects paths of the same length');

      return;
    } else {
      for (var i = 0; i < newPath.length - 1; i++) {
        if (oldPath[i] !== newPath[i]) {
          warn('copyWithRename() expects paths to be the same except for the deepest key');

          return;
        }
      }
    }

    return copyWithRenameImpl(obj, oldPath, newPath, 0);
  };

  var copyWithSetImpl = function (obj, path, index, value) {
    if (index >= path.length) {
      return value;
    }

    var key = path[index];
    var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here

    updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
    return updated;
  };

  var copyWithSet = function (obj, path, value) {
    return copyWithSetImpl(obj, path, 0, value);
  };

  var findHook = function (fiber, id) {
    // For now, the "id" of stateful hooks is just the stateful hook index.
    // This may change in the future with e.g. nested hooks.
    var currentHook = fiber.memoizedState;

    while (currentHook !== null && id > 0) {
      currentHook = currentHook.next;
      id--;
    }

    return currentHook;
  }; // Support DevTools editable values for useState and useReducer.


  overrideHookState = function (fiber, id, path, value) {
    var hook = findHook(fiber, id);

    if (hook !== null) {
      var newState = copyWithSet(hook.memoizedState, path, value);
      hook.memoizedState = newState;
      hook.baseState = newState; // We aren't actually adding an update to the queue,
      // because there is no update we can add for useReducer hooks that won't trigger an error.
      // (There's no appropriate action type for DevTools overrides.)
      // As a result though, React will see the scheduled update as a noop and bailout.
      // Shallow cloning props works as a workaround for now to bypass the bailout check.

      fiber.memoizedProps = _assign({}, fiber.memoizedProps);
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }
  };

  overrideHookStateDeletePath = function (fiber, id, path) {
    var hook = findHook(fiber, id);

    if (hook !== null) {
      var newState = copyWithDelete(hook.memoizedState, path);
      hook.memoizedState = newState;
      hook.baseState = newState; // We aren't actually adding an update to the queue,
      // because there is no update we can add for useReducer hooks that won't trigger an error.
      // (There's no appropriate action type for DevTools overrides.)
      // As a result though, React will see the scheduled update as a noop and bailout.
      // Shallow cloning props works as a workaround for now to bypass the bailout check.

      fiber.memoizedProps = _assign({}, fiber.memoizedProps);
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }
  };

  overrideHookStateRenamePath = function (fiber, id, oldPath, newPath) {
    var hook = findHook(fiber, id);

    if (hook !== null) {
      var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
      hook.memoizedState = newState;
      hook.baseState = newState; // We aren't actually adding an update to the queue,
      // because there is no update we can add for useReducer hooks that won't trigger an error.
      // (There's no appropriate action type for DevTools overrides.)
      // As a result though, React will see the scheduled update as a noop and bailout.
      // Shallow cloning props works as a workaround for now to bypass the bailout check.

      fiber.memoizedProps = _assign({}, fiber.memoizedProps);
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }
  }; // Support DevTools props for function components, forwardRef, memo, host components, etc.


  overrideProps = function (fiber, path, value) {
    fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);

    if (fiber.alternate) {
      fiber.alternate.pendingProps = fiber.pendingProps;
    }

    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  overridePropsDeletePath = function (fiber, path) {
    fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);

    if (fiber.alternate) {
      fiber.alternate.pendingProps = fiber.pendingProps;
    }

    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  overridePropsRenamePath = function (fiber, oldPath, newPath) {
    fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);

    if (fiber.alternate) {
      fiber.alternate.pendingProps = fiber.pendingProps;
    }

    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  scheduleUpdate = function (fiber) {
    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  setSuspenseHandler = function (newShouldSuspendImpl) {
    shouldSuspendImpl = newShouldSuspendImpl;
  };
}

function findHostInstanceByFiber(fiber) {
  var hostFiber = findCurrentHostFiber(fiber);

  if (hostFiber === null) {
    return null;
  }

  return hostFiber.stateNode;
}

function emptyFindFiberByHostInstance(instance) {
  return null;
}

function getCurrentFiberForDevTools() {
  return current;
}

function injectIntoDevTools(devToolsConfig) {
  var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
  var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
  return injectInternals({
    bundleType: devToolsConfig.bundleType,
    version: devToolsConfig.version,
    rendererPackageName: devToolsConfig.rendererPackageName,
    rendererConfig: devToolsConfig.rendererConfig,
    overrideHookState: overrideHookState,
    overrideHookStateDeletePath: overrideHookStateDeletePath,
    overrideHookStateRenamePath: overrideHookStateRenamePath,
    overrideProps: overrideProps,
    overridePropsDeletePath: overridePropsDeletePath,
    overridePropsRenamePath: overridePropsRenamePath,
    setSuspenseHandler: setSuspenseHandler,
    scheduleUpdate: scheduleUpdate,
    currentDispatcherRef: ReactCurrentDispatcher,
    findHostInstanceByFiber: findHostInstanceByFiber,
    findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
    // React Refresh
    findHostInstancesForRefresh:  findHostInstancesForRefresh ,
    scheduleRefresh:  scheduleRefresh ,
    scheduleRoot:  scheduleRoot ,
    setRefreshHandler:  setRefreshHandler ,
    // Enables DevTools to append owner stacks to error messages in DEV mode.
    getCurrentFiber:  getCurrentFiberForDevTools 
  });
}

function ReactDOMRoot(container, options) {
  this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
}

function ReactDOMBlockingRoot(container, tag, options) {
  this._internalRoot = createRootImpl(container, tag, options);
}

ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function (children) {
  var root = this._internalRoot;

  {
    if (typeof arguments[1] === 'function') {
      error('render(...): does not support the second callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
    }

    var container = root.containerInfo;

    if (container.nodeType !== COMMENT_NODE) {
      var hostInstance = findHostInstanceWithNoPortals(root.current);

      if (hostInstance) {
        if (hostInstance.parentNode !== container) {
          error('render(...): It looks like the React-rendered content of the ' + 'root container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + "root.unmount() to empty a root's container.");
        }
      }
    }
  }

  updateContainer(children, root, null, null);
};

ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function () {
  {
    if (typeof arguments[0] === 'function') {
      error('unmount(...): does not support a callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
    }
  }

  var root = this._internalRoot;
  var container = root.containerInfo;
  updateContainer(null, root, null, function () {
    unmarkContainerAsRoot(container);
  });
};

function createRootImpl(container, tag, options) {
  // Tag is either LegacyRoot or Concurrent Root
  var hydrate = options != null && options.hydrate === true;
  var hydrationCallbacks = options != null && options.hydrationOptions || null;
  var mutableSources = options != null && options.hydrationOptions != null && options.hydrationOptions.mutableSources || null;
  var root = createContainer(container, tag, hydrate);
  markContainerAsRoot(root.current, container);
  var containerNodeType = container.nodeType;

  {
    var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
    listenToAllSupportedEvents(rootContainerElement);
  }

  if (mutableSources) {
    for (var i = 0; i < mutableSources.length; i++) {
      var mutableSource = mutableSources[i];
      registerMutableSourceForHydration(root, mutableSource);
    }
  }

  return root;
}
function createLegacyRoot(container, options) {
  return new ReactDOMBlockingRoot(container, LegacyRoot, options);
}
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
}

var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
var topLevelUpdateWarnings;
var warnedAboutHydrateAPI = false;

{
  topLevelUpdateWarnings = function (container) {
    if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
      var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);

      if (hostInstance) {
        if (hostInstance.parentNode !== container) {
          error('render(...): It looks like the React-rendered content of this ' + 'container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + 'ReactDOM.unmountComponentAtNode to empty a container.');
        }
      }
    }

    var isRootRenderedBySomeReact = !!container._reactRootContainer;
    var rootEl = getReactRootElementInContainer(container);
    var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));

    if (hasNonRootReactChild && !isRootRenderedBySomeReact) {
      error('render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.');
    }

    if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') {
      error('render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.');
    }
  };
}

function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOCUMENT_NODE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function shouldHydrateDueToLegacyHeuristic(container) {
  var rootElement = getReactRootElementInContainer(container);
  return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
}

function legacyCreateRootFromDOMContainer(container, forceHydrate) {
  var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.

  if (!shouldHydrate) {
    var warned = false;
    var rootSibling;

    while (rootSibling = container.lastChild) {
      {
        if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
          warned = true;

          error('render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.');
        }
      }

      container.removeChild(rootSibling);
    }
  }

  {
    if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
      warnedAboutHydrateAPI = true;

      warn('render(): Calling ReactDOM.render() to hydrate server-rendered markup ' + 'will stop working in React v18. Replace the ReactDOM.render() call ' + 'with ReactDOM.hydrate() if you want React to attach to the server HTML.');
    }
  }

  return createLegacyRoot(container, shouldHydrate ? {
    hydrate: true
  } : undefined);
}

function warnOnInvalidCallback$1(callback, callerName) {
  {
    if (callback !== null && typeof callback !== 'function') {
      error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
    }
  }
}

function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
  {
    topLevelUpdateWarnings(container);
    warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
  } // TODO: Without `any` type, Flow says "Property cannot be accessed on any
  // member of intersection type." Whyyyyyy.


  var root = container._reactRootContainer;
  var fiberRoot;

  if (!root) {
    // Initial mount
    root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
    fiberRoot = root._internalRoot;

    if (typeof callback === 'function') {
      var originalCallback = callback;

      callback = function () {
        var instance = getPublicRootInstance(fiberRoot);
        originalCallback.call(instance);
      };
    } // Initial mount should not be batched.


    unbatchedUpdates(function () {
      updateContainer(children, fiberRoot, parentComponent, callback);
    });
  } else {
    fiberRoot = root._internalRoot;

    if (typeof callback === 'function') {
      var _originalCallback = callback;

      callback = function () {
        var instance = getPublicRootInstance(fiberRoot);

        _originalCallback.call(instance);
      };
    } // Update


    updateContainer(children, fiberRoot, parentComponent, callback);
  }

  return getPublicRootInstance(fiberRoot);
}

function findDOMNode(componentOrElement) {
  {
    var owner = ReactCurrentOwner$3.current;

    if (owner !== null && owner.stateNode !== null) {
      var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;

      if (!warnedAboutRefsInRender) {
        error('%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(owner.type) || 'A component');
      }

      owner.stateNode._warnedAboutRefsInRender = true;
    }
  }

  if (componentOrElement == null) {
    return null;
  }

  if (componentOrElement.nodeType === ELEMENT_NODE) {
    return componentOrElement;
  }

  {
    return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
  }
}
function hydrate(element, container, callback) {
  if (!isValidContainer(container)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  }

  {
    var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

    if (isModernRoot) {
      error('You are calling ReactDOM.hydrate() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call createRoot(container, {hydrate: true}).render(element)?');
    }
  } // TODO: throw or warn if we couldn't hydrate?


  return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
}
function render(element, container, callback) {
  if (!isValidContainer(container)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  }

  {
    var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

    if (isModernRoot) {
      error('You are calling ReactDOM.render() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call root.render(element)?');
    }
  }

  return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
}
function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
  if (!isValidContainer(containerNode)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  }

  if (!(parentComponent != null && has(parentComponent))) {
    {
      throw Error( "parentComponent must be a valid React Component" );
    }
  }

  return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
}
function unmountComponentAtNode(container) {
  if (!isValidContainer(container)) {
    {
      throw Error( "unmountComponentAtNode(...): Target container is not a DOM element." );
    }
  }

  {
    var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

    if (isModernRoot) {
      error('You are calling ReactDOM.unmountComponentAtNode() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?');
    }
  }

  if (container._reactRootContainer) {
    {
      var rootEl = getReactRootElementInContainer(container);
      var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);

      if (renderedByDifferentReact) {
        error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.');
      }
    } // Unmount should not be batched.


    unbatchedUpdates(function () {
      legacyRenderSubtreeIntoContainer(null, null, container, false, function () {
        // $FlowFixMe This should probably use `delete container._reactRootContainer`
        container._reactRootContainer = null;
        unmarkContainerAsRoot(container);
      });
    }); // If you call unmountComponentAtNode twice in quick succession, you'll
    // get `true` twice. That's probably fine?

    return true;
  } else {
    {
      var _rootEl = getReactRootElementInContainer(container);

      var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.

      var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;

      if (hasNonRootReactChild) {
        error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.');
      }
    }

    return false;
  }
}

setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
setAttemptContinuousHydration(attemptContinuousHydration$1);
setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
setAttemptHydrationAtPriority(runWithPriority$2);
var didWarnAboutUnstableCreatePortal = false;

{
  if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
  Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
  Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') {
    error('React depends on Map and Set built-in types. Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
  }
}

setRestoreImplementation(restoreControlledState$3);
setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);

function createPortal$1(children, container) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!isValidContainer(container)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  } // TODO: pass ReactDOM portal implementation as third argument
  // $FlowFixMe The Flow type is opaque but there's no way to actually create it.


  return createPortal(children, container, null, key);
}

function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {

  return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
}

function unstable_createPortal(children, container) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  {
    if (!didWarnAboutUnstableCreatePortal) {
      didWarnAboutUnstableCreatePortal = true;

      warn('The ReactDOM.unstable_createPortal() alias has been deprecated, ' + 'and will be removed in React 18+. Update your code to use ' + 'ReactDOM.createPortal() instead. It has the exact same API, ' + 'but without the "unstable_" prefix.');
    }
  }

  return createPortal$1(children, container, key);
}

var Internals = {
  // Keep in sync with ReactTestUtils.js, and ReactTestUtilsAct.js.
  // This is an array for better minification.
  Events: [getInstanceFromNode, getNodeFromInstance, getFiberCurrentPropsFromNode, enqueueStateRestore, restoreStateIfNeeded, flushPassiveEffects, // TODO: This is related to `act`, not events. Move to separate key?
  IsThisRendererActing]
};
var foundDevTools = injectIntoDevTools({
  findFiberByHostInstance: getClosestInstanceFromNode,
  bundleType:  1 ,
  version: ReactVersion,
  rendererPackageName: 'react-dom'
});

{
  if (!foundDevTools && canUseDOM && window.top === window.self) {
    // If we're in Chrome or Firefox, provide a download link if not installed.
    if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
      var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.

      if (/^(https?|file):$/.test(protocol)) {
        // eslint-disable-next-line react-internal/no-production-logging
        console.info('%cDownload the React DevTools ' + 'for a better development experience: ' + 'https://reactjs.org/link/react-devtools' + (protocol === 'file:' ? '\nYou might need to use a local HTTP server (instead of file://): ' + 'https://reactjs.org/link/react-devtools-faq' : ''), 'font-weight:bold');
      }
    }
  }
}

exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
exports.createPortal = createPortal$1;
exports.findDOMNode = findDOMNode;
exports.flushSync = flushSync;
exports.hydrate = hydrate;
exports.render = render;
exports.unmountComponentAtNode = unmountComponentAtNode;
exports.unstable_batchedUpdates = batchedUpdates$1;
exports.unstable_createPortal = unstable_createPortal;
exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
exports.version = ReactVersion;
  })();
}


/***/ }),

/***/ "../../node_modules/react-dom/index.js":
/*!*********************************************!*\
  !*** ../../node_modules/react-dom/index.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (true) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/react-dom.development.js */ "../../node_modules/react-dom/cjs/react-dom.development.js");
}


/***/ }),

/***/ "../../node_modules/react-lib-adler32/adler32.js":
/*!*******************************************************!*\
  !*** ../../node_modules/react-lib-adler32/adler32.js ***!
  \*******************************************************/
/***/ ((module) => {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adler32
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),

/***/ "../../node_modules/react-window-infinite-loader/dist/index.esm.js":
/*!*************************************************************************!*\
  !*** ../../node_modules/react-window-infinite-loader/dist/index.esm.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");


function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function isRangeVisible(_ref) {
  var lastRenderedStartIndex = _ref.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref.lastRenderedStopIndex,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}

function scanForUnloadedRanges(_ref) {
  var isItemLoaded = _ref.isItemLoaded,
      itemCount = _ref.itemCount,
      minimumBatchSize = _ref.minimumBatchSize,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  var unloadedRanges = [];

  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var _index = startIndex; _index <= stopIndex; _index++) {
    var loaded = isItemLoaded(_index);

    if (!loaded) {
      rangeStopIndex = _index;
      if (rangeStartIndex === null) {
        rangeStartIndex = _index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push(rangeStartIndex, rangeStopIndex);

      rangeStartIndex = rangeStopIndex = null;
    }
  }

  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), itemCount - 1);

    for (var _index2 = rangeStopIndex + 1; _index2 <= potentialStopIndex; _index2++) {
      if (!isItemLoaded(_index2)) {
        rangeStopIndex = _index2;
      } else {
        break;
      }
    }

    unloadedRanges.push(rangeStartIndex, rangeStopIndex);
  }

  // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.
  if (unloadedRanges.length) {
    while (unloadedRanges[1] - unloadedRanges[0] + 1 < minimumBatchSize && unloadedRanges[0] > 0) {
      var _index3 = unloadedRanges[0] - 1;

      if (!isItemLoaded(_index3)) {
        unloadedRanges[0] = _index3;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var InfiniteLoader = function (_PureComponent) {
  inherits(InfiniteLoader, _PureComponent);

  function InfiniteLoader() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, InfiniteLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = InfiniteLoader.__proto__ || Object.getPrototypeOf(InfiniteLoader)).call.apply(_ref, [this].concat(args))), _this), _this._lastRenderedStartIndex = -1, _this._lastRenderedStopIndex = -1, _this._memoizedUnloadedRanges = [], _this._onItemsRendered = function (_ref2) {
      var visibleStartIndex = _ref2.visibleStartIndex,
          visibleStopIndex = _ref2.visibleStopIndex;

      if (true) {
        if (!isInteger(visibleStartIndex) || !isInteger(visibleStopIndex)) {
          console.warn('Invalid onItemsRendered signature; please refer to InfiniteLoader documentation.');
        }

        if (typeof _this.props.loadMoreRows === 'function') {
          console.warn('InfiniteLoader "loadMoreRows" prop has been renamed to "loadMoreItems".');
        }
      }

      _this._lastRenderedStartIndex = visibleStartIndex;
      _this._lastRenderedStopIndex = visibleStopIndex;

      _this._ensureRowsLoaded(visibleStartIndex, visibleStopIndex);
    }, _this._setRef = function (listRef) {
      _this._listRef = listRef;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(InfiniteLoader, [{
    key: 'resetloadMoreItemsCache',
    value: function resetloadMoreItemsCache() {
      var autoReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this._memoizedUnloadedRanges = [];

      if (autoReload) {
        this._ensureRowsLoaded(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (true) {
        if (this._listRef == null) {
          console.warn('Invalid list ref; please refer to InfiniteLoader documentation.');
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        onItemsRendered: this._onItemsRendered,
        ref: this._setRef
      });
    }
  }, {
    key: '_ensureRowsLoaded',
    value: function _ensureRowsLoaded(startIndex, stopIndex) {
      var _props = this.props,
          isItemLoaded = _props.isItemLoaded,
          itemCount = _props.itemCount,
          _props$minimumBatchSi = _props.minimumBatchSize,
          minimumBatchSize = _props$minimumBatchSi === undefined ? 10 : _props$minimumBatchSi,
          _props$threshold = _props.threshold,
          threshold = _props$threshold === undefined ? 15 : _props$threshold;


      var unloadedRanges = scanForUnloadedRanges({
        isItemLoaded: isItemLoaded,
        itemCount: itemCount,
        minimumBatchSize: minimumBatchSize,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(itemCount - 1, stopIndex + threshold)
      });

      // Avoid calling load-rows unless range has changed.
      // This shouldn't be strictly necessary, but is maybe nice to do.
      if (this._memoizedUnloadedRanges.length !== unloadedRanges.length || this._memoizedUnloadedRanges.some(function (startOrStop, index) {
        return unloadedRanges[index] !== startOrStop;
      })) {
        this._memoizedUnloadedRanges = unloadedRanges;
        this._loadUnloadedRanges(unloadedRanges);
      }
    }
  }, {
    key: '_loadUnloadedRanges',
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      // loadMoreRows was renamed to loadMoreItems in v1.0.3; will be removed in v2.0
      var loadMoreItems = this.props.loadMoreItems || this.props.loadMoreRows;

      var _loop = function _loop(i) {
        var startIndex = unloadedRanges[i];
        var stopIndex = unloadedRanges[i + 1];
        var promise = loadMoreItems(startIndex, stopIndex);
        if (promise != null) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: startIndex,
              stopIndex: stopIndex
            })) {
              // Handle an unmount while promises are still in flight.
              if (_this2._listRef == null) {
                return;
              }

              // Resize cached row sizes for VariableSizeList,
              // otherwise just re-render the list.
              if (typeof _this2._listRef.resetAfterIndex === 'function') {
                _this2._listRef.resetAfterIndex(startIndex, true);
              } else {
                // HACK reset temporarily cached item styles to force PureComponent to re-render.
                // This is pretty gross, but I'm okay with it for now.
                // Don't judge me.
                if (typeof _this2._listRef._getItemStyleCache === 'function') {
                  _this2._listRef._getItemStyleCache(-1);
                }
                _this2._listRef.forceUpdate();
              }
            }
          });
        }
      };

      for (var i = 0; i < unloadedRanges.length; i += 2) {
        _loop(i);
      }
    }
  }]);
  return InfiniteLoader;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InfiniteLoader);


/***/ }),

/***/ "../../node_modules/react-window/dist/index.esm.js":
/*!*********************************************************!*\
  !*** ../../node_modules/react-window/dist/index.esm.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FixedSizeGrid: () => (/* binding */ FixedSizeGrid),
/* harmony export */   FixedSizeList: () => (/* binding */ FixedSizeList),
/* harmony export */   VariableSizeGrid: () => (/* binding */ VariableSizeGrid),
/* harmony export */   VariableSizeList: () => (/* binding */ VariableSizeList),
/* harmony export */   areEqual: () => (/* binding */ areEqual),
/* harmony export */   shouldComponentUpdate: () => (/* binding */ shouldComponentUpdate)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/esm/extends */ "../../node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/esm/assertThisInitialized */ "../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/esm/inheritsLoose */ "../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js");
/* harmony import */ var memoize_one__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! memoize-one */ "../../node_modules/memoize-one/dist/memoize-one.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/esm/objectWithoutPropertiesLoose */ "../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js");







// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var now = hasNativePerformanceNow ? function () {
  return performance.now();
} : function () {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();

  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }

  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}

var size = -1; // This utility copied from "dom-helpers" package.

function getScrollbarSize(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (size === -1 || recalculate) {
    var div = document.createElement('div');
    var style = div.style;
    style.width = '50px';
    style.height = '50px';
    style.overflow = 'scroll';
    document.body.appendChild(div);
    size = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }

  return size;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.

function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement('div');
    var outerStyle = outerDiv.style;
    outerStyle.width = '50px';
    outerStyle.height = '50px';
    outerStyle.overflow = 'scroll';
    outerStyle.direction = 'rtl';
    var innerDiv = document.createElement('div');
    var innerStyle = innerDiv.style;
    innerStyle.width = '100px';
    innerStyle.height = '100px';
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);

    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = 'positive-descending';
    } else {
      outerDiv.scrollLeft = 1;

      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = 'negative';
      } else {
        cachedRTLResult = 'positive-ascending';
      }
    }

    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }

  return cachedRTLResult;
}

var IS_SCROLLING_DEBOUNCE_INTERVAL = 150;

var defaultItemKey = function defaultItemKey(_ref) {
  var columnIndex = _ref.columnIndex,
      data = _ref.data,
      rowIndex = _ref.rowIndex;
  return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsOverscanCount = null;
var devWarningsOverscanRowsColumnsCount = null;
var devWarningsTagName = null;

if (true) {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsOverscanCount = /*#__PURE__*/new WeakSet();
    devWarningsOverscanRowsColumnsCount = /*#__PURE__*/new WeakSet();
    devWarningsTagName = /*#__PURE__*/new WeakSet();
  }
}

function createGridComponent(_ref2) {
  var _class;

  var getColumnOffset = _ref2.getColumnOffset,
      getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset,
      getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex,
      getColumnWidth = _ref2.getColumnWidth,
      getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight,
      getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth,
      getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment,
      getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment,
      getRowHeight = _ref2.getRowHeight,
      getRowOffset = _ref2.getRowOffset,
      getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset,
      getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex,
      initInstanceProps = _ref2.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref2.validateProps;
  return _class = /*#__PURE__*/function (_PureComponent) {
    (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_2__["default"])(Grid, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function Grid(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, (0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_1__["default"])(_this));
      _this._resetIsScrollingTimeoutId = null;
      _this._outerRef = void 0;
      _this.state = {
        instance: (0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_1__["default"])(_this),
        isScrolling: false,
        horizontalScrollDirection: 'forward',
        scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
        scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
        scrollUpdateWasRequested: false,
        verticalScrollDirection: 'forward'
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = (0,memoize_one__WEBPACK_IMPORTED_MODULE_5__["default"])(function (overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
        return _this.props.onItemsRendered({
          overscanColumnStartIndex: overscanColumnStartIndex,
          overscanColumnStopIndex: overscanColumnStopIndex,
          overscanRowStartIndex: overscanRowStartIndex,
          overscanRowStopIndex: overscanRowStopIndex,
          visibleColumnStartIndex: visibleColumnStartIndex,
          visibleColumnStopIndex: visibleColumnStopIndex,
          visibleRowStartIndex: visibleRowStartIndex,
          visibleRowStopIndex: visibleRowStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = (0,memoize_one__WEBPACK_IMPORTED_MODULE_5__["default"])(function (scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          horizontalScrollDirection: horizontalScrollDirection,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          verticalScrollDirection: verticalScrollDirection,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (rowIndex, columnIndex) {
        var _this$props = _this.props,
            columnWidth = _this$props.columnWidth,
            direction = _this$props.direction,
            rowHeight = _this$props.rowHeight;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);

        var key = rowIndex + ":" + columnIndex;
        var style;

        if (itemStyleCache.hasOwnProperty(key)) {
          style = itemStyleCache[key];
        } else {
          var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);

          var isRtl = direction === 'rtl';
          itemStyleCache[key] = style = {
            position: 'absolute',
            left: isRtl ? undefined : _offset,
            right: isRtl ? _offset : undefined,
            top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
            height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
            width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
          };
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = (0,memoize_one__WEBPACK_IMPORTED_MODULE_5__["default"])(function (_, __, ___) {
        return {};
      });

      _this._onScroll = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientHeight = _event$currentTarget.clientHeight,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollTop = _event$currentTarget.scrollTop,
            scrollHeight = _event$currentTarget.scrollHeight,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
          // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
          // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
          // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.

          var calculatedScrollLeft = scrollLeft;

          if (direction === 'rtl') {
            switch (getRTLOffsetType()) {
              case 'negative':
                calculatedScrollLeft = -scrollLeft;
                break;

              case 'positive-descending':
                calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
          var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
            scrollLeft: calculatedScrollLeft,
            scrollTop: calculatedScrollTop,
            verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1);
        });
      };

      return _this;
    }

    Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = Grid.prototype;

    _proto.scrollTo = function scrollTo(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;

      if (scrollLeft !== undefined) {
        scrollLeft = Math.max(0, scrollLeft);
      }

      if (scrollTop !== undefined) {
        scrollTop = Math.max(0, scrollTop);
      }

      this.setState(function (prevState) {
        if (scrollLeft === undefined) {
          scrollLeft = prevState.scrollLeft;
        }

        if (scrollTop === undefined) {
          scrollTop = prevState.scrollTop;
        }

        if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
          return null;
        }

        return {
          horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          scrollUpdateWasRequested: true,
          verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(_ref4) {
      var _ref4$align = _ref4.align,
          align = _ref4$align === void 0 ? 'auto' : _ref4$align,
          columnIndex = _ref4.columnIndex,
          rowIndex = _ref4.rowIndex;
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          height = _this$props2.height,
          rowCount = _this$props2.rowCount,
          width = _this$props2.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;
      var scrollbarSize = getScrollbarSize();

      if (columnIndex !== undefined) {
        columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
      }

      if (rowIndex !== undefined) {
        rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
      }

      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
      // to ensure it's fully visible.
      // But we only need to account for its size when it's actually visible.

      var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
      var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
      this.scrollTo({
        scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
        scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
      });
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props,
          initialScrollLeft = _this$props3.initialScrollLeft,
          initialScrollTop = _this$props3.initialScrollTop;

      if (this._outerRef != null) {
        var outerRef = this._outerRef;

        if (typeof initialScrollLeft === 'number') {
          outerRef.scrollLeft = initialScrollLeft;
        }

        if (typeof initialScrollTop === 'number') {
          outerRef.scrollTop = initialScrollTop;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var direction = this.props.direction;
      var _this$state2 = this.state,
          scrollLeft = _this$state2.scrollLeft,
          scrollTop = _this$state2.scrollTop,
          scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
        // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
        // So we need to determine which browser behavior we're dealing with, and mimic it.
        var outerRef = this._outerRef;

        if (direction === 'rtl') {
          switch (getRTLOffsetType()) {
            case 'negative':
              outerRef.scrollLeft = -scrollLeft;
              break;

            case 'positive-ascending':
              outerRef.scrollLeft = scrollLeft;
              break;

            default:
              var clientWidth = outerRef.clientWidth,
                  scrollWidth = outerRef.scrollWidth;
              outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
              break;
          }
        } else {
          outerRef.scrollLeft = Math.max(0, scrollLeft);
        }

        outerRef.scrollTop = Math.max(0, scrollTop);
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          columnCount = _this$props4.columnCount,
          direction = _this$props4.direction,
          height = _this$props4.height,
          innerRef = _this$props4.innerRef,
          innerElementType = _this$props4.innerElementType,
          innerTagName = _this$props4.innerTagName,
          itemData = _this$props4.itemData,
          _this$props4$itemKey = _this$props4.itemKey,
          itemKey = _this$props4$itemKey === void 0 ? defaultItemKey : _this$props4$itemKey,
          outerElementType = _this$props4.outerElementType,
          outerTagName = _this$props4.outerTagName,
          rowCount = _this$props4.rowCount,
          style = _this$props4.style,
          useIsScrolling = _this$props4.useIsScrolling,
          width = _this$props4.width;
      var isScrolling = this.state.isScrolling;

      var _this$_getHorizontalR = this._getHorizontalRangeToRender(),
          columnStartIndex = _this$_getHorizontalR[0],
          columnStopIndex = _this$_getHorizontalR[1];

      var _this$_getVerticalRan = this._getVerticalRangeToRender(),
          rowStartIndex = _this$_getVerticalRan[0],
          rowStopIndex = _this$_getVerticalRan[1];

      var items = [];

      if (columnCount > 0 && rowCount) {
        for (var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++) {
          for (var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++) {
            items.push((0,react__WEBPACK_IMPORTED_MODULE_3__.createElement)(children, {
              columnIndex: _columnIndex,
              data: itemData,
              isScrolling: useIsScrolling ? isScrolling : undefined,
              key: itemKey({
                columnIndex: _columnIndex,
                data: itemData,
                rowIndex: _rowIndex
              }),
              rowIndex: _rowIndex,
              style: this._getItemStyle(_rowIndex, _columnIndex)
            }));
          }
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
      return (0,react__WEBPACK_IMPORTED_MODULE_3__.createElement)(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: this._onScroll,
        ref: this._outerRefSetter,
        style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, (0,react__WEBPACK_IMPORTED_MODULE_3__.createElement)(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: estimatedTotalHeight,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: estimatedTotalWidth
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      var _this$props5 = this.props,
          columnCount = _this$props5.columnCount,
          onItemsRendered = _this$props5.onItemsRendered,
          onScroll = _this$props5.onScroll,
          rowCount = _this$props5.rowCount;

      if (typeof onItemsRendered === 'function') {
        if (columnCount > 0 && rowCount > 0) {
          var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(),
              _overscanColumnStartIndex = _this$_getHorizontalR2[0],
              _overscanColumnStopIndex = _this$_getHorizontalR2[1],
              _visibleColumnStartIndex = _this$_getHorizontalR2[2],
              _visibleColumnStopIndex = _this$_getHorizontalR2[3];

          var _this$_getVerticalRan2 = this._getVerticalRangeToRender(),
              _overscanRowStartIndex = _this$_getVerticalRan2[0],
              _overscanRowStopIndex = _this$_getVerticalRan2[1],
              _visibleRowStartIndex = _this$_getVerticalRan2[2],
              _visibleRowStopIndex = _this$_getVerticalRan2[3];

          this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
        }
      }

      if (typeof onScroll === 'function') {
        var _this$state3 = this.state,
            _horizontalScrollDirection = _this$state3.horizontalScrollDirection,
            _scrollLeft = _this$state3.scrollLeft,
            _scrollTop = _this$state3.scrollTop,
            _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested,
            _verticalScrollDirection = _this$state3.verticalScrollDirection;

        this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
      }
    } // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.
    ;

    _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
      var _this$props6 = this.props,
          columnCount = _this$props6.columnCount,
          overscanColumnCount = _this$props6.overscanColumnCount,
          overscanColumnsCount = _this$props6.overscanColumnsCount,
          overscanCount = _this$props6.overscanCount,
          rowCount = _this$props6.rowCount;
      var _this$state4 = this.state,
          horizontalScrollDirection = _this$state4.horizontalScrollDirection,
          isScrolling = _this$state4.isScrolling,
          scrollLeft = _this$state4.scrollLeft;
      var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
      var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
      var _this$props7 = this.props,
          columnCount = _this$props7.columnCount,
          overscanCount = _this$props7.overscanCount,
          overscanRowCount = _this$props7.overscanRowCount,
          overscanRowsCount = _this$props7.overscanRowsCount,
          rowCount = _this$props7.rowCount;
      var _this$state5 = this.state,
          isScrolling = _this$state5.isScrolling,
          verticalScrollDirection = _this$state5.verticalScrollDirection,
          scrollTop = _this$state5.scrollTop;
      var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
      var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return Grid;
  }(react__WEBPACK_IMPORTED_MODULE_3__.PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    useIsScrolling: false
  }, _class;
}

var validateSharedProps = function validateSharedProps(_ref5, _ref6) {
  var children = _ref5.children,
      direction = _ref5.direction,
      height = _ref5.height,
      innerTagName = _ref5.innerTagName,
      outerTagName = _ref5.outerTagName,
      overscanColumnsCount = _ref5.overscanColumnsCount,
      overscanCount = _ref5.overscanCount,
      overscanRowsCount = _ref5.overscanRowsCount,
      width = _ref5.width;
  var instance = _ref6.instance;

  if (true) {
    if (typeof overscanCount === 'number') {
      if (devWarningsOverscanCount && !devWarningsOverscanCount.has(instance)) {
        devWarningsOverscanCount.add(instance);
        console.warn('The overscanCount prop has been deprecated. ' + 'Please use the overscanColumnCount and overscanRowCount props instead.');
      }
    }

    if (typeof overscanColumnsCount === 'number' || typeof overscanRowsCount === 'number') {
      if (devWarningsOverscanRowsColumnsCount && !devWarningsOverscanRowsColumnsCount.has(instance)) {
        devWarningsOverscanRowsColumnsCount.add(instance);
        console.warn('The overscanColumnsCount and overscanRowsCount props have been deprecated. ' + 'Please use the overscanColumnCount and overscanRowCount props instead.');
      }
    }

    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName && !devWarningsTagName.has(instance)) {
        devWarningsTagName.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    }

    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children) + "\" was specified."));
    }

    switch (direction) {
      case 'ltr':
      case 'rtl':
        // Valid values
        break;

      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }

    if (typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Grids must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width) + "\" was specified."));
    }

    if (typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Grids must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height) + "\" was specified."));
    }
  }
};

var DEFAULT_ESTIMATED_ITEM_SIZE = 50;

var getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
  var rowCount = _ref.rowCount;
  var rowMetadataMap = _ref2.rowMetadataMap,
      estimatedRowHeight = _ref2.estimatedRowHeight,
      lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredRowIndex >= rowCount) {
    lastMeasuredRowIndex = rowCount - 1;
  }

  if (lastMeasuredRowIndex >= 0) {
    var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
  var columnCount = _ref3.columnCount;
  var columnMetadataMap = _ref4.columnMetadataMap,
      estimatedColumnWidth = _ref4.estimatedColumnWidth,
      lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredColumnIndex >= columnCount) {
    lastMeasuredColumnIndex = columnCount - 1;
  }

  if (lastMeasuredColumnIndex >= 0) {
    var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
  var itemMetadataMap, itemSize, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    itemSize = props.columnWidth;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    itemSize = props.rowHeight;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    if (itemType === 'column') {
      instanceProps.lastMeasuredColumnIndex = index;
    } else {
      instanceProps.lastMeasuredRowIndex = index;
    }
  }

  return itemMetadataMap[index];
};

var findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
  var itemMetadataMap, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata(itemType, props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
  var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata(itemType, props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
  var size = itemType === 'column' ? props.width : props.height;
  var itemMetadata = getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
  // To ensure it reflects actual measurements instead of just estimates.

  var estimatedTotalSize = itemType === 'column' ? getEstimatedTotalWidth(props, instanceProps) : getEstimatedTotalHeight(props, instanceProps);
  var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
  var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);

  if (align === 'smart') {
    if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
      align = 'auto';
    } else {
      align = 'center';
    }
  }

  switch (align) {
    case 'start':
      return maxOffset;

    case 'end':
      return minOffset;

    case 'center':
      return Math.round(minOffset + (maxOffset - minOffset) / 2);

    case 'auto':
    default:
      if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
        return scrollOffset;
      } else if (minOffset > maxOffset) {
        // Because we only take into account the scrollbar size when calculating minOffset
        // this value can be larger than maxOffset when at the end of the list
        return minOffset;
      } else if (scrollOffset < minOffset) {
        return minOffset;
      } else {
        return maxOffset;
      }

  }
};

var VariableSizeGrid = /*#__PURE__*/createGridComponent({
  getColumnOffset: function getColumnOffset(props, index, instanceProps) {
    return getItemMetadata('column', props, index, instanceProps).offset;
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
    return findNearestItem('column', props, instanceProps, scrollLeft);
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
    var columnCount = props.columnCount,
        width = props.width;
    var itemMetadata = getItemMetadata('column', props, startIndex, instanceProps);
    var maxOffset = scrollLeft + width;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < columnCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('column', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  getColumnWidth: function getColumnWidth(props, index, instanceProps) {
    return instanceProps.columnMetadataMap[index].size;
  },
  getEstimatedTotalHeight: getEstimatedTotalHeight,
  getEstimatedTotalWidth: getEstimatedTotalWidth,
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getRowOffset: function getRowOffset(props, index, instanceProps) {
    return getItemMetadata('row', props, index, instanceProps).offset;
  },
  getRowHeight: function getRowHeight(props, index, instanceProps) {
    return instanceProps.rowMetadataMap[index].size;
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
    return findNearestItem('row', props, instanceProps, scrollTop);
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
    var rowCount = props.rowCount,
        height = props.height;
    var itemMetadata = getItemMetadata('row', props, startIndex, instanceProps);
    var maxOffset = scrollTop + height;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < rowCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('row', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref5 = props,
        estimatedColumnWidth = _ref5.estimatedColumnWidth,
        estimatedRowHeight = _ref5.estimatedRowHeight;
    var instanceProps = {
      columnMetadataMap: {},
      estimatedColumnWidth: estimatedColumnWidth || DEFAULT_ESTIMATED_ITEM_SIZE,
      estimatedRowHeight: estimatedRowHeight || DEFAULT_ESTIMATED_ITEM_SIZE,
      lastMeasuredColumnIndex: -1,
      lastMeasuredRowIndex: -1,
      rowMetadataMap: {}
    };

    instance.resetAfterColumnIndex = function (columnIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        columnIndex: columnIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterRowIndex = function (rowIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        rowIndex: rowIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterIndices = function (_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex,
          _ref6$shouldForceUpda = _ref6.shouldForceUpdate,
          shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;

      if (typeof columnIndex === 'number') {
        instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
      }

      if (typeof rowIndex === 'number') {
        instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
      } // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.


      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref7) {
    var columnWidth = _ref7.columnWidth,
        rowHeight = _ref7.rowHeight;

    if (true) {
      if (typeof columnWidth !== 'function') {
        throw Error('An invalid "columnWidth" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (columnWidth === null ? 'null' : typeof columnWidth) + "\" was specified."));
      } else if (typeof rowHeight !== 'function') {
        throw Error('An invalid "rowHeight" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (rowHeight === null ? 'null' : typeof rowHeight) + "\" was specified."));
      }
    }
  }
});

var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;

var defaultItemKey$1 = function defaultItemKey(index, data) {
  return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsDirection = null;
var devWarningsTagName$1 = null;

if (true) {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsDirection = /*#__PURE__*/new WeakSet();
    devWarningsTagName$1 = /*#__PURE__*/new WeakSet();
  }
}

function createListComponent(_ref) {
  var _class;

  var getItemOffset = _ref.getItemOffset,
      getEstimatedTotalSize = _ref.getEstimatedTotalSize,
      getItemSize = _ref.getItemSize,
      getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment,
      getStartIndexForOffset = _ref.getStartIndexForOffset,
      getStopIndexForStartIndex = _ref.getStopIndexForStartIndex,
      initInstanceProps = _ref.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref.validateProps;
  return _class = /*#__PURE__*/function (_PureComponent) {
    (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_2__["default"])(List, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function List(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, (0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_1__["default"])(_this));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: (0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_1__["default"])(_this),
        isScrolling: false,
        scrollDirection: 'forward',
        scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = (0,memoize_one__WEBPACK_IMPORTED_MODULE_5__["default"])(function (overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex: overscanStartIndex,
          overscanStopIndex: overscanStopIndex,
          visibleStartIndex: visibleStartIndex,
          visibleStopIndex: visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = (0,memoize_one__WEBPACK_IMPORTED_MODULE_5__["default"])(function (scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection: scrollDirection,
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (index) {
        var _this$props = _this.props,
            direction = _this$props.direction,
            itemSize = _this$props.itemSize,
            layout = _this$props.layout;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);

        var style;

        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _offset = getItemOffset(_this.props, index, _this._instanceProps);

          var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"

          var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
          var isRtl = direction === 'rtl';
          var offsetHorizontal = isHorizontal ? _offset : 0;
          itemStyleCache[index] = style = {
            position: 'absolute',
            left: isRtl ? undefined : offsetHorizontal,
            right: isRtl ? offsetHorizontal : undefined,
            top: !isHorizontal ? _offset : 0,
            height: !isHorizontal ? size : '100%',
            width: isHorizontal ? size : '100%'
          };
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = (0,memoize_one__WEBPACK_IMPORTED_MODULE_5__["default"])(function (_, __, ___) {
        return {};
      });

      _this._onScrollHorizontal = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;

          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
            // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
            switch (getRTLOffsetType()) {
              case 'negative':
                scrollOffset = -scrollLeft;
                break;

              case 'positive-descending':
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._onScrollVertical = function (event) {
        var _event$currentTarget2 = event.currentTarget,
            clientHeight = _event$currentTarget2.clientHeight,
            scrollHeight = _event$currentTarget2.scrollHeight,
            scrollTop = _event$currentTarget2.scrollTop;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1, null);
        });
      };

      return _this;
    }

    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = List.prototype;

    _proto.scrollTo = function scrollTo(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function (prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }

        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = 'auto';
      }

      var _this$props2 = this.props,
          itemCount = _this$props2.itemCount,
          layout = _this$props2.layout;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
      // But we only need to account for its size when it's actually visible.
      // This is an edge case for lists; normally they only scroll in the dominant direction.

      var scrollbarSize = 0;

      if (this._outerRef) {
        var outerRef = this._outerRef;

        if (layout === 'vertical') {
          scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? getScrollbarSize() : 0;
        } else {
          scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? getScrollbarSize() : 0;
        }
      }

      this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props,
          direction = _this$props3.direction,
          initialScrollOffset = _this$props3.initialScrollOffset,
          layout = _this$props3.layout;

      if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props4 = this.props,
          direction = _this$props4.direction,
          layout = _this$props4.layout;
      var _this$state = this.state,
          scrollOffset = _this$state.scrollOffset,
          scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // So we need to determine which browser behavior we're dealing with, and mimic it.
            switch (getRTLOffsetType()) {
              case 'negative':
                outerRef.scrollLeft = -scrollOffset;
                break;

              case 'positive-ascending':
                outerRef.scrollLeft = scrollOffset;
                break;

              default:
                var clientWidth = outerRef.clientWidth,
                    scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          className = _this$props5.className,
          direction = _this$props5.direction,
          height = _this$props5.height,
          innerRef = _this$props5.innerRef,
          innerElementType = _this$props5.innerElementType,
          innerTagName = _this$props5.innerTagName,
          itemCount = _this$props5.itemCount,
          itemData = _this$props5.itemData,
          _this$props5$itemKey = _this$props5.itemKey,
          itemKey = _this$props5$itemKey === void 0 ? defaultItemKey$1 : _this$props5$itemKey,
          layout = _this$props5.layout,
          outerElementType = _this$props5.outerElementType,
          outerTagName = _this$props5.outerTagName,
          style = _this$props5.style,
          useIsScrolling = _this$props5.useIsScrolling,
          width = _this$props5.width;
      var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"

      var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;

      var _this$_getRangeToRend = this._getRangeToRender(),
          startIndex = _this$_getRangeToRend[0],
          stopIndex = _this$_getRangeToRend[1];

      var items = [];

      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push((0,react__WEBPACK_IMPORTED_MODULE_3__.createElement)(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : undefined,
            style: this._getItemStyle(_index)
          }));
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
      return (0,react__WEBPACK_IMPORTED_MODULE_3__.createElement)(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: onScroll,
        ref: this._outerRefSetter,
        style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, (0,react__WEBPACK_IMPORTED_MODULE_3__.createElement)(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? '100%' : estimatedTotalSize,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: isHorizontal ? estimatedTotalSize : '100%'
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === 'function') {
        var itemCount = this.props.itemCount;

        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(),
              _overscanStartIndex = _this$_getRangeToRend2[0],
              _overscanStopIndex = _this$_getRangeToRend2[1],
              _visibleStartIndex = _this$_getRangeToRend2[2],
              _visibleStopIndex = _this$_getRangeToRend2[3];

          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }

      if (typeof this.props.onScroll === 'function') {
        var _this$state2 = this.state,
            _scrollDirection = _this$state2.scrollDirection,
            _scrollOffset = _this$state2.scrollOffset,
            _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    } // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.
    ;

    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props6 = this.props,
          itemCount = _this$props6.itemCount,
          overscanCount = _this$props6.overscanCount;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollDirection = _this$state3.scrollDirection,
          scrollOffset = _this$state3.scrollOffset;

      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return List;
  }(react__WEBPACK_IMPORTED_MODULE_3__.PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    layout: 'vertical',
    overscanCount: 2,
    useIsScrolling: false
  }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.

var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children,
      direction = _ref2.direction,
      height = _ref2.height,
      layout = _ref2.layout,
      innerTagName = _ref2.innerTagName,
      outerTagName = _ref2.outerTagName,
      width = _ref2.width;
  var instance = _ref3.instance;

  if (true) {
    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName$1 && !devWarningsTagName$1.has(instance)) {
        devWarningsTagName$1.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    } // TODO Deprecate direction "horizontal"


    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';

    switch (direction) {
      case 'horizontal':
      case 'vertical':
        if (devWarningsDirection && !devWarningsDirection.has(instance)) {
          devWarningsDirection.add(instance);
          console.warn('The direction prop should be either "ltr" (default) or "rtl". ' + 'Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.');
        }

        break;

      case 'ltr':
      case 'rtl':
        // Valid values
        break;

      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }

    switch (layout) {
      case 'horizontal':
      case 'vertical':
        // Valid values
        break;

      default:
        throw Error('An invalid "layout" prop has been specified. ' + 'Value should be either "horizontal" or "vertical". ' + ("\"" + layout + "\" was specified."));
    }

    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children) + "\" was specified."));
    }

    if (isHorizontal && typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Horizontal lists must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width) + "\" was specified."));
    } else if (!isHorizontal && typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Vertical lists must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height) + "\" was specified."));
    }
  }
};

var DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;

var getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
  var _ref = props,
      itemSize = _ref.itemSize;
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    instanceProps.lastMeasuredIndex = index;
  }

  return itemMetadataMap[index];
};

var findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata$1(props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
  var itemCount = props.itemCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata$1(props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
  var itemCount = _ref2.itemCount;
  var itemMetadataMap = _ref3.itemMetadataMap,
      estimatedItemSize = _ref3.estimatedItemSize,
      lastMeasuredIndex = _ref3.lastMeasuredIndex;
  var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredIndex >= itemCount) {
    lastMeasuredIndex = itemCount - 1;
  }

  if (lastMeasuredIndex >= 0) {
    var itemMetadata = itemMetadataMap[lastMeasuredIndex];
    totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
  return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};

var VariableSizeList = /*#__PURE__*/createListComponent({
  getItemOffset: function getItemOffset(props, index, instanceProps) {
    return getItemMetadata$1(props, index, instanceProps).offset;
  },
  getItemSize: function getItemSize(props, index, instanceProps) {
    return instanceProps.itemMetadataMap[index].size;
  },
  getEstimatedTotalSize: getEstimatedTotalSize,
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var direction = props.direction,
        height = props.height,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.

    var estimatedTotalSize = getEstimatedTotalSize(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        return Math.round(minOffset + (maxOffset - minOffset) / 2);

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
    return findNearestItem$1(props, instanceProps, offset);
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
    var direction = props.direction,
        height = props.height,
        itemCount = props.itemCount,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, startIndex, instanceProps);
    var maxOffset = scrollOffset + size;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < itemCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata$1(props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref4 = props,
        estimatedItemSize = _ref4.estimatedItemSize;
    var instanceProps = {
      itemMetadataMap: {},
      estimatedItemSize: estimatedItemSize || DEFAULT_ESTIMATED_ITEM_SIZE$1,
      lastMeasuredIndex: -1
    };

    instance.resetAfterIndex = function (index, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.

      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref5) {
    var itemSize = _ref5.itemSize;

    if (true) {
      if (typeof itemSize !== 'function') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize) + "\" was specified."));
      }
    }
  }
});

var FixedSizeGrid = /*#__PURE__*/createGridComponent({
  getColumnOffset: function getColumnOffset(_ref, index) {
    var columnWidth = _ref.columnWidth;
    return index * columnWidth;
  },
  getColumnWidth: function getColumnWidth(_ref2, index) {
    var columnWidth = _ref2.columnWidth;
    return columnWidth;
  },
  getRowOffset: function getRowOffset(_ref3, index) {
    var rowHeight = _ref3.rowHeight;
    return index * rowHeight;
  },
  getRowHeight: function getRowHeight(_ref4, index) {
    var rowHeight = _ref4.rowHeight;
    return rowHeight;
  },
  getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
    var rowCount = _ref5.rowCount,
        rowHeight = _ref5.rowHeight;
    return rowHeight * rowCount;
  },
  getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
    var columnCount = _ref6.columnCount,
        columnWidth = _ref6.columnWidth;
    return columnWidth * columnCount;
  },
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
    var columnCount = _ref7.columnCount,
        columnWidth = _ref7.columnWidth,
        width = _ref7.width;
    var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
    var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
    var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);

    if (align === 'smart') {
      if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        // "Centered" offset is usually the average of the min and max.
        // But near the edges of the list, this doesn't hold true.
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

        if (middleOffset < Math.ceil(width / 2)) {
          return 0; // near the beginning
        } else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) {
          return lastColumnOffset; // near the end
        } else {
          return middleOffset;
        }

      case 'auto':
      default:
        if (scrollLeft >= minOffset && scrollLeft <= maxOffset) {
          return scrollLeft;
        } else if (minOffset > maxOffset) {
          // Because we only take into account the scrollbar size when calculating minOffset
          // this value can be larger than maxOffset when at the end of the list
          return minOffset;
        } else if (scrollLeft < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
    var rowHeight = _ref8.rowHeight,
        height = _ref8.height,
        rowCount = _ref8.rowCount;
    var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
    var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
    var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);

    if (align === 'smart') {
      if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        // "Centered" offset is usually the average of the min and max.
        // But near the edges of the list, this doesn't hold true.
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

        if (middleOffset < Math.ceil(height / 2)) {
          return 0; // near the beginning
        } else if (middleOffset > lastRowOffset + Math.floor(height / 2)) {
          return lastRowOffset; // near the end
        } else {
          return middleOffset;
        }

      case 'auto':
      default:
        if (scrollTop >= minOffset && scrollTop <= maxOffset) {
          return scrollTop;
        } else if (minOffset > maxOffset) {
          // Because we only take into account the scrollbar size when calculating minOffset
          // this value can be larger than maxOffset when at the end of the list
          return minOffset;
        } else if (scrollTop < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
    var columnWidth = _ref9.columnWidth,
        columnCount = _ref9.columnCount;
    return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
    var columnWidth = _ref10.columnWidth,
        columnCount = _ref10.columnCount,
        width = _ref10.width;
    var left = startIndex * columnWidth;
    var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
    return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
    ));
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
    var rowHeight = _ref11.rowHeight,
        rowCount = _ref11.rowCount;
    return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
    var rowHeight = _ref12.rowHeight,
        rowCount = _ref12.rowCount,
        height = _ref12.height;
    var top = startIndex * rowHeight;
    var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
    return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref13) {
    var columnWidth = _ref13.columnWidth,
        rowHeight = _ref13.rowHeight;

    if (true) {
      if (typeof columnWidth !== 'number') {
        throw Error('An invalid "columnWidth" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (columnWidth === null ? 'null' : typeof columnWidth) + "\" was specified."));
      }

      if (typeof rowHeight !== 'number') {
        throw Error('An invalid "rowHeight" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (rowHeight === null ? 'null' : typeof rowHeight) + "\" was specified."));
      }
    }
  }
});

var FixedSizeList = /*#__PURE__*/createListComponent({
  getItemOffset: function getItemOffset(_ref, index) {
    var itemSize = _ref.itemSize;
    return index * itemSize;
  },
  getItemSize: function getItemSize(_ref2, index) {
    var itemSize = _ref2.itemSize;
    return itemSize;
  },
  getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
    var itemCount = _ref3.itemCount,
        itemSize = _ref3.itemSize;
    return itemSize * itemCount;
  },
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var direction = _ref4.direction,
        height = _ref4.height,
        itemCount = _ref4.itemCount,
        itemSize = _ref4.itemSize,
        layout = _ref4.layout,
        width = _ref4.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var lastItemOffset = Math.max(0, itemCount * itemSize - size);
    var maxOffset = Math.min(lastItemOffset, index * itemSize);
    var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        {
          // "Centered" offset is usually the average of the min and max.
          // But near the edges of the list, this doesn't hold true.
          var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

          if (middleOffset < Math.ceil(size / 2)) {
            return 0; // near the beginning
          } else if (middleOffset > lastItemOffset + Math.floor(size / 2)) {
            return lastItemOffset; // near the end
          } else {
            return middleOffset;
          }
        }

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
    var itemCount = _ref5.itemCount,
        itemSize = _ref5.itemSize;
    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
    var direction = _ref6.direction,
        height = _ref6.height,
        itemCount = _ref6.itemCount,
        itemSize = _ref6.itemSize,
        layout = _ref6.layout,
        width = _ref6.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var offset = startIndex * itemSize;
    var size = isHorizontal ? width : height;
    var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
    return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref7) {
    var itemSize = _ref7.itemSize;

    if (true) {
      if (typeof itemSize !== 'number') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize) + "\" was specified."));
      }
    }
  }
});

// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function shallowDiffers(prev, next) {
  for (var attribute in prev) {
    if (!(attribute in next)) {
      return true;
    }
  }

  for (var _attribute in next) {
    if (prev[_attribute] !== next[_attribute]) {
      return true;
    }
  }

  return false;
}

var _excluded = ["style"],
    _excluded2 = ["style"];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo

function areEqual(prevProps, nextProps) {
  var prevStyle = prevProps.style,
      prevRest = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__["default"])(prevProps, _excluded);

  var nextStyle = nextProps.style,
      nextRest = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__["default"])(nextProps, _excluded2);

  return !shallowDiffers(prevStyle, nextStyle) && !shallowDiffers(prevRest, nextRest);
}

// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate

function shouldComponentUpdate(nextProps, nextState) {
  return !areEqual(this.props, nextProps) || shallowDiffers(this.state, nextState);
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ "../../node_modules/react/cjs/react-jsx-runtime.development.js":
/*!*********************************************************************!*\
  !*** ../../node_modules/react/cjs/react-jsx-runtime.development.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  (function() {
'use strict';

var React = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _assign = __webpack_require__(/*! object-assign */ "../../node_modules/object-assign/index.js");

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
exports.Fragment = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  exports.Fragment = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case exports.Fragment:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown;
var specialPropRefWarningShown;
var didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function warnIfStringRefCannotBeAutoConverted(config, self) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}

function defineKeyPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingKey = function () {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingKey.isReactWarning = true;
    Object.defineProperty(props, 'key', {
      get: warnAboutAccessingKey,
      configurable: true
    });
  }
}

function defineRefPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingRef = function () {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingRef.isReactWarning = true;
    Object.defineProperty(props, 'ref', {
      get: warnAboutAccessingRef,
      configurable: true
    });
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */

function jsxDEV(type, config, maybeKey, source, self) {
  {
    var propName; // Reserved names are extracted

    var props = {};
    var key = null;
    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
    // but as an intermediary step, we will use jsxDEV for everything except
    // <div {...props} key="Hi" />, because we aren't currently able to tell if
    // key is explicitly declared to be undefined or not.

    if (maybeKey !== undefined) {
      key = '' + maybeKey;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    if (hasValidRef(config)) {
      ref = config.ref;
      warnIfStringRefCannotBeAutoConverted(config, self);
    } // Remaining properties are added to a new props object


    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    } // Resolve default props


    if (type && type.defaultProps) {
      var defaultProps = type.defaultProps;

      for (propName in defaultProps) {
        if (props[propName] === undefined) {
          props[propName] = defaultProps[propName];
        }
      }
    }

    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }

    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
}

function getDeclarationErrorAddendum() {
  {
    if (ReactCurrentOwner$1.current) {
      var name = getComponentName(ReactCurrentOwner$1.current.type);

      if (name) {
        return '\n\nCheck the render method of `' + name + '`.';
      }
    }

    return '';
  }
}

function getSourceInfoErrorAddendum(source) {
  {
    if (source !== undefined) {
      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
      var lineNumber = source.lineNumber;
      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
    }

    return '';
  }
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  {
    var info = getDeclarationErrorAddendum();

    if (!info) {
      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

      if (parentName) {
        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
      }
    }

    return info;
  }
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  {
    if (!element._store || element._store.validated || element.key != null) {
      return;
    }

    element._store.validated = true;
    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
      return;
    }

    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
    // property, it may be the creator of the child that's responsible for
    // assigning it a key.

    var childOwner = '';

    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
      // Give the component that originally created this child.
      childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
    }

    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  {
    if (typeof node !== 'object') {
      return;
    }

    if (Array.isArray(node)) {
      for (var i = 0; i < node.length; i++) {
        var child = node[i];

        if (isValidElement(child)) {
          validateExplicitKey(child, parentType);
        }
      }
    } else if (isValidElement(node)) {
      // This element was passed in a valid location.
      if (node._store) {
        node._store.validated = true;
      }
    } else if (node) {
      var iteratorFn = getIteratorFn(node);

      if (typeof iteratorFn === 'function') {
        // Entry iterators used to provide implicit keys,
        // but now we print a separate warning for them later.
        if (iteratorFn !== node.entries) {
          var iterator = iteratorFn.call(node);
          var step;

          while (!(step = iterator.next()).done) {
            if (isValidElement(step.value)) {
              validateExplicitKey(step.value, parentType);
            }
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentName(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentName(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}

function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
  {
    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.

    if (!validType) {
      var info = '';

      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
      }

      var sourceInfo = getSourceInfoErrorAddendum(source);

      if (sourceInfo) {
        info += sourceInfo;
      } else {
        info += getDeclarationErrorAddendum();
      }

      var typeString;

      if (type === null) {
        typeString = 'null';
      } else if (Array.isArray(type)) {
        typeString = 'array';
      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
        typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
        info = ' Did you accidentally export a JSX literal instead of a component?';
      } else {
        typeString = typeof type;
      }

      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }

    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.

    if (element == null) {
      return element;
    } // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)


    if (validType) {
      var children = props.children;

      if (children !== undefined) {
        if (isStaticChildren) {
          if (Array.isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              validateChildKeys(children[i], type);
            }

            if (Object.freeze) {
              Object.freeze(children);
            }
          } else {
            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
          }
        } else {
          validateChildKeys(children, type);
        }
      }
    }

    if (type === exports.Fragment) {
      validateFragmentProps(element);
    } else {
      validatePropTypes(element);
    }

    return element;
  }
} // These two functions exist to still get child warnings in dev
// even with the prod transform. This means that jsxDEV is purely
// opt-in behavior for better messages but that we won't stop
// giving you warnings if you use production apis.

function jsxWithValidationStatic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, true);
  }
}
function jsxWithValidationDynamic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, false);
  }
}

var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
// for now we can ship identical prod functions

var jsxs =  jsxWithValidationStatic ;

exports.jsx = jsx;
exports.jsxs = jsxs;
  })();
}


/***/ }),

/***/ "../../node_modules/react/cjs/react.development.js":
/*!*********************************************************!*\
  !*** ../../node_modules/react/cjs/react.development.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  (function() {
'use strict';

var _assign = __webpack_require__(/*! object-assign */ "../../node_modules/object-assign/index.js");

// TODO: this is special because it gets imported during build.
var ReactVersion = '17.0.2';

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
exports.Fragment = 0xeacb;
exports.StrictMode = 0xeacc;
exports.Profiler = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
exports.Suspense = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  exports.Fragment = symbolFor('react.fragment');
  exports.StrictMode = symbolFor('react.strict_mode');
  exports.Profiler = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  exports.Suspense = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

/**
 * Keeps track of the current dispatcher.
 */
var ReactCurrentDispatcher = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

/**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */
var ReactCurrentBatchConfig = {
  transition: 0
};

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

var ReactDebugCurrentFrame = {};
var currentExtraStackFrame = null;
function setExtraStackFrame(stack) {
  {
    currentExtraStackFrame = stack;
  }
}

{
  ReactDebugCurrentFrame.setExtraStackFrame = function (stack) {
    {
      currentExtraStackFrame = stack;
    }
  }; // Stack implementation injected by the current renderer.


  ReactDebugCurrentFrame.getCurrentStack = null;

  ReactDebugCurrentFrame.getStackAddendum = function () {
    var stack = ''; // Add an extra top frame while an element is being validated

    if (currentExtraStackFrame) {
      stack += currentExtraStackFrame;
    } // Delegate to the injected renderer-specific implementation


    var impl = ReactDebugCurrentFrame.getCurrentStack;

    if (impl) {
      stack += impl() || '';
    }

    return stack;
  };
}

/**
 * Used by act() to track whether you're inside an act() scope.
 */
var IsSomeRendererActing = {
  current: false
};

var ReactSharedInternals = {
  ReactCurrentDispatcher: ReactCurrentDispatcher,
  ReactCurrentBatchConfig: ReactCurrentBatchConfig,
  ReactCurrentOwner: ReactCurrentOwner,
  IsSomeRendererActing: IsSomeRendererActing,
  // Used by renderers to avoid bundling object-assign twice in UMD bundles:
  assign: _assign
};

{
  ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
}

// by calls to these methods by a Babel plugin.
//
// In PROD (or in packages without access to React internals),
// they are left as they are instead.

function warn(format) {
  {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    printWarning('warn', format, args);
  }
}
function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

var didWarnStateUpdateForUnmountedComponent = {};

function warnNoop(publicInstance, callerName) {
  {
    var _constructor = publicInstance.constructor;
    var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
    var warningKey = componentName + "." + callerName;

    if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
      return;
    }

    error("Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);

    didWarnStateUpdateForUnmountedComponent[warningKey] = true;
  }
}
/**
 * This is the abstract API for an update queue.
 */


var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance, callback, callerName) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState, callback, callerName) {
    warnNoop(publicInstance, 'setState');
  }
};

var emptyObject = {};

{
  Object.freeze(emptyObject);
}
/**
 * Base class helpers for the updating state of a component.
 */


function Component(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
  // renderer.

  this.updater = updater || ReactNoopUpdateQueue;
}

Component.prototype.isReactComponent = {};
/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */

Component.prototype.setState = function (partialState, callback) {
  if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) {
    {
      throw Error( "setState(...): takes an object of state variables to update or a function which returns an object of state variables." );
    }
  }

  this.updater.enqueueSetState(this, partialState, callback, 'setState');
};
/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */


Component.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
};
/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */


{
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };

  var defineDeprecationWarning = function (methodName, info) {
    Object.defineProperty(Component.prototype, methodName, {
      get: function () {
        warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);

        return undefined;
      }
    });
  };

  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

function ComponentDummy() {}

ComponentDummy.prototype = Component.prototype;
/**
 * Convenience component with default shallow equality check for sCU.
 */

function PureComponent(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject;
  this.updater = updater || ReactNoopUpdateQueue;
}

var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.

_assign(pureComponentPrototype, Component.prototype);

pureComponentPrototype.isPureReactComponent = true;

// an immutable object with a single mutable value
function createRef() {
  var refObject = {
    current: null
  };

  {
    Object.seal(refObject);
  }

  return refObject;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case exports.Fragment:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case exports.Profiler:
      return 'Profiler';

    case exports.StrictMode:
      return 'StrictMode';

    case exports.Suspense:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    }
  };

  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    }
  };

  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

function warnIfStringRefCannotBeAutoConverted(config) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */

function createElement(type, config, children) {
  var propName; // Reserved names are extracted

  var props = {};
  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;

      {
        warnIfStringRefCannotBeAutoConverted(config);
      }
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }

    props.children = childArray;
  } // Resolve default props


  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;

    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }

  {
    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }
  }

  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
}
function cloneAndReplaceKey(oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
  return newElement;
}
/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */

function cloneElement(element, config, children) {
  if (!!(element === null || element === undefined)) {
    {
      throw Error( "React.cloneElement(...): The argument must be a React element, but you passed " + element + "." );
    }
  }

  var propName; // Original props are copied

  var props = _assign({}, element.props); // Reserved names are extracted


  var key = element.key;
  var ref = element.ref; // Self is preserved since the owner is preserved.

  var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.

  var source = element._source; // Owner will be preserved, unless ref is overridden

  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    } // Remaining properties override existing props


    var defaultProps;

    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}

var SEPARATOR = '.';
var SUBSEPARATOR = ':';
/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = key.replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });
  return '$' + escapedString;
}
/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */


var didWarnAboutMaps = false;
var userProvidedKeyEscapeRegex = /\/+/g;

function escapeUserProvidedKey(text) {
  return text.replace(userProvidedKeyEscapeRegex, '$&/');
}
/**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */


function getElementKey(element, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (typeof element === 'object' && element !== null && element.key != null) {
    // Explicit key
    return escape('' + element.key);
  } // Implicit key determined by the index in the set


  return index.toString(36);
}

function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  var invokeCallback = false;

  if (children === null) {
    invokeCallback = true;
  } else {
    switch (type) {
      case 'string':
      case 'number':
        invokeCallback = true;
        break;

      case 'object':
        switch (children.$$typeof) {
          case REACT_ELEMENT_TYPE:
          case REACT_PORTAL_TYPE:
            invokeCallback = true;
        }

    }
  }

  if (invokeCallback) {
    var _child = children;
    var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows:

    var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;

    if (Array.isArray(mappedChild)) {
      var escapedChildKey = '';

      if (childKey != null) {
        escapedChildKey = escapeUserProvidedKey(childKey) + '/';
      }

      mapIntoArray(mappedChild, array, escapedChildKey, '', function (c) {
        return c;
      });
    } else if (mappedChild != null) {
      if (isValidElement(mappedChild)) {
        mappedChild = cloneAndReplaceKey(mappedChild, // Keep both the (mapped) and old keys if they differ, just as
        // traverseAllChildren used to do for objects as children
        escapedPrefix + ( // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
        mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
        escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
      }

      array.push(mappedChild);
    }

    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.

  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getElementKey(child, i);
      subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
    }
  } else {
    var iteratorFn = getIteratorFn(children);

    if (typeof iteratorFn === 'function') {
      var iterableChildren = children;

      {
        // Warn about using Maps as children
        if (iteratorFn === iterableChildren.entries) {
          if (!didWarnAboutMaps) {
            warn('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
          }

          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(iterableChildren);
      var step;
      var ii = 0;

      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getElementKey(child, ii++);
        subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
      }
    } else if (type === 'object') {
      var childrenString = '' + children;

      {
        {
          throw Error( "Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). If you meant to render a collection of children, use an array instead." );
        }
      }
    }
  }

  return subtreeCount;
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }

  var result = [];
  var count = 0;
  mapIntoArray(children, result, '', '', function (child) {
    return func.call(context, child, count++);
  });
  return result;
}
/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */


function countChildren(children) {
  var n = 0;
  mapChildren(children, function () {
    n++; // Don't return anything
  });
  return n;
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  mapChildren(children, function () {
    forEachFunc.apply(this, arguments); // Don't return anything.
  }, forEachContext);
}
/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */


function toArray(children) {
  return mapChildren(children, function (child) {
    return child;
  }) || [];
}
/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */


function onlyChild(children) {
  if (!isValidElement(children)) {
    {
      throw Error( "React.Children.only expected to receive a single React element child." );
    }
  }

  return children;
}

function createContext(defaultValue, calculateChangedBits) {
  if (calculateChangedBits === undefined) {
    calculateChangedBits = null;
  } else {
    {
      if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') {
        error('createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits);
      }
    }
  }

  var context = {
    $$typeof: REACT_CONTEXT_TYPE,
    _calculateChangedBits: calculateChangedBits,
    // As a workaround to support multiple concurrent renderers, we categorize
    // some renderers as primary and others as secondary. We only expect
    // there to be two concurrent renderers at most: React Native (primary) and
    // Fabric (secondary); React DOM (primary) and React ART (secondary).
    // Secondary renderers store their context values on separate fields.
    _currentValue: defaultValue,
    _currentValue2: defaultValue,
    // Used to track how many concurrent renderers this context currently
    // supports within in a single renderer. Such as parallel server rendering.
    _threadCount: 0,
    // These are circular
    Provider: null,
    Consumer: null
  };
  context.Provider = {
    $$typeof: REACT_PROVIDER_TYPE,
    _context: context
  };
  var hasWarnedAboutUsingNestedContextConsumers = false;
  var hasWarnedAboutUsingConsumerProvider = false;
  var hasWarnedAboutDisplayNameOnConsumer = false;

  {
    // A separate object, but proxies back to the original context object for
    // backwards compatibility. It has a different $$typeof, so we can properly
    // warn for the incorrect usage of Context as a Consumer.
    var Consumer = {
      $$typeof: REACT_CONTEXT_TYPE,
      _context: context,
      _calculateChangedBits: context._calculateChangedBits
    }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here

    Object.defineProperties(Consumer, {
      Provider: {
        get: function () {
          if (!hasWarnedAboutUsingConsumerProvider) {
            hasWarnedAboutUsingConsumerProvider = true;

            error('Rendering <Context.Consumer.Provider> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Provider> instead?');
          }

          return context.Provider;
        },
        set: function (_Provider) {
          context.Provider = _Provider;
        }
      },
      _currentValue: {
        get: function () {
          return context._currentValue;
        },
        set: function (_currentValue) {
          context._currentValue = _currentValue;
        }
      },
      _currentValue2: {
        get: function () {
          return context._currentValue2;
        },
        set: function (_currentValue2) {
          context._currentValue2 = _currentValue2;
        }
      },
      _threadCount: {
        get: function () {
          return context._threadCount;
        },
        set: function (_threadCount) {
          context._threadCount = _threadCount;
        }
      },
      Consumer: {
        get: function () {
          if (!hasWarnedAboutUsingNestedContextConsumers) {
            hasWarnedAboutUsingNestedContextConsumers = true;

            error('Rendering <Context.Consumer.Consumer> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
          }

          return context.Consumer;
        }
      },
      displayName: {
        get: function () {
          return context.displayName;
        },
        set: function (displayName) {
          if (!hasWarnedAboutDisplayNameOnConsumer) {
            warn('Setting `displayName` on Context.Consumer has no effect. ' + "You should set it directly on the context with Context.displayName = '%s'.", displayName);

            hasWarnedAboutDisplayNameOnConsumer = true;
          }
        }
      }
    }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty

    context.Consumer = Consumer;
  }

  {
    context._currentRenderer = null;
    context._currentRenderer2 = null;
  }

  return context;
}

var Uninitialized = -1;
var Pending = 0;
var Resolved = 1;
var Rejected = 2;

function lazyInitializer(payload) {
  if (payload._status === Uninitialized) {
    var ctor = payload._result;
    var thenable = ctor(); // Transition to the next state.

    var pending = payload;
    pending._status = Pending;
    pending._result = thenable;
    thenable.then(function (moduleObject) {
      if (payload._status === Pending) {
        var defaultExport = moduleObject.default;

        {
          if (defaultExport === undefined) {
            error('lazy: Expected the result of a dynamic import() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + // Break up imports to avoid accidentally parsing them as dependencies.
            'const MyComponent = lazy(() => imp' + "ort('./MyComponent'))", moduleObject);
          }
        } // Transition to the next state.


        var resolved = payload;
        resolved._status = Resolved;
        resolved._result = defaultExport;
      }
    }, function (error) {
      if (payload._status === Pending) {
        // Transition to the next state.
        var rejected = payload;
        rejected._status = Rejected;
        rejected._result = error;
      }
    });
  }

  if (payload._status === Resolved) {
    return payload._result;
  } else {
    throw payload._result;
  }
}

function lazy(ctor) {
  var payload = {
    // We use these fields to store the result.
    _status: -1,
    _result: ctor
  };
  var lazyType = {
    $$typeof: REACT_LAZY_TYPE,
    _payload: payload,
    _init: lazyInitializer
  };

  {
    // In production, this would just set it on the object.
    var defaultProps;
    var propTypes; // $FlowFixMe

    Object.defineProperties(lazyType, {
      defaultProps: {
        configurable: true,
        get: function () {
          return defaultProps;
        },
        set: function (newDefaultProps) {
          error('React.lazy(...): It is not supported to assign `defaultProps` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          defaultProps = newDefaultProps; // Match production behavior more closely:
          // $FlowFixMe

          Object.defineProperty(lazyType, 'defaultProps', {
            enumerable: true
          });
        }
      },
      propTypes: {
        configurable: true,
        get: function () {
          return propTypes;
        },
        set: function (newPropTypes) {
          error('React.lazy(...): It is not supported to assign `propTypes` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          propTypes = newPropTypes; // Match production behavior more closely:
          // $FlowFixMe

          Object.defineProperty(lazyType, 'propTypes', {
            enumerable: true
          });
        }
      }
    });
  }

  return lazyType;
}

function forwardRef(render) {
  {
    if (render != null && render.$$typeof === REACT_MEMO_TYPE) {
      error('forwardRef requires a render function but received a `memo` ' + 'component. Instead of forwardRef(memo(...)), use ' + 'memo(forwardRef(...)).');
    } else if (typeof render !== 'function') {
      error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
    } else {
      if (render.length !== 0 && render.length !== 2) {
        error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
      }
    }

    if (render != null) {
      if (render.defaultProps != null || render.propTypes != null) {
        error('forwardRef render functions do not support propTypes or defaultProps. ' + 'Did you accidentally pass a React component?');
      }
    }
  }

  var elementType = {
    $$typeof: REACT_FORWARD_REF_TYPE,
    render: render
  };

  {
    var ownName;
    Object.defineProperty(elementType, 'displayName', {
      enumerable: false,
      configurable: true,
      get: function () {
        return ownName;
      },
      set: function (name) {
        ownName = name;

        if (render.displayName == null) {
          render.displayName = name;
        }
      }
    });
  }

  return elementType;
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === exports.Fragment || type === exports.Profiler || type === REACT_DEBUG_TRACING_MODE_TYPE || type === exports.StrictMode || type === exports.Suspense || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function memo(type, compare) {
  {
    if (!isValidElementType(type)) {
      error('memo: The first argument must be a component. Instead ' + 'received: %s', type === null ? 'null' : typeof type);
    }
  }

  var elementType = {
    $$typeof: REACT_MEMO_TYPE,
    type: type,
    compare: compare === undefined ? null : compare
  };

  {
    var ownName;
    Object.defineProperty(elementType, 'displayName', {
      enumerable: false,
      configurable: true,
      get: function () {
        return ownName;
      },
      set: function (name) {
        ownName = name;

        if (type.displayName == null) {
          type.displayName = name;
        }
      }
    });
  }

  return elementType;
}

function resolveDispatcher() {
  var dispatcher = ReactCurrentDispatcher.current;

  if (!(dispatcher !== null)) {
    {
      throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem." );
    }
  }

  return dispatcher;
}

function useContext(Context, unstable_observedBits) {
  var dispatcher = resolveDispatcher();

  {
    if (unstable_observedBits !== undefined) {
      error('useContext() second argument is reserved for future ' + 'use in React. Passing it is not supported. ' + 'You passed: %s.%s', unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? '\n\nDid you call array.map(useContext)? ' + 'Calling Hooks inside a loop is not supported. ' + 'Learn more at https://reactjs.org/link/rules-of-hooks' : '');
    } // TODO: add a more generic warning for invalid values.


    if (Context._context !== undefined) {
      var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
      // and nobody should be using this in existing code.

      if (realContext.Consumer === Context) {
        error('Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be ' + 'removed in a future major release. Did you mean to call useContext(Context) instead?');
      } else if (realContext.Provider === Context) {
        error('Calling useContext(Context.Provider) is not supported. ' + 'Did you mean to call useContext(Context) instead?');
      }
    }
  }

  return dispatcher.useContext(Context, unstable_observedBits);
}
function useState(initialState) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useState(initialState);
}
function useReducer(reducer, initialArg, init) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useReducer(reducer, initialArg, init);
}
function useRef(initialValue) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useRef(initialValue);
}
function useEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useEffect(create, deps);
}
function useLayoutEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useLayoutEffect(create, deps);
}
function useCallback(callback, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useCallback(callback, deps);
}
function useMemo(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useMemo(create, deps);
}
function useImperativeHandle(ref, create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useImperativeHandle(ref, create, deps);
}
function useDebugValue(value, formatterFn) {
  {
    var dispatcher = resolveDispatcher();
    return dispatcher.useDebugValue(value, formatterFn);
  }
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher$1.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher$1.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case exports.Suspense:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      setExtraStackFrame(stack);
    } else {
      setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = getComponentName(ReactCurrentOwner.current.type);

    if (name) {
      return '\n\nCheck the render method of `' + name + '`.';
    }
  }

  return '';
}

function getSourceInfoErrorAddendum(source) {
  if (source !== undefined) {
    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
    var lineNumber = source.lineNumber;
    return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
  }

  return '';
}

function getSourceInfoErrorAddendumForProps(elementProps) {
  if (elementProps !== null && elementProps !== undefined) {
    return getSourceInfoErrorAddendum(elementProps.__source);
  }

  return '';
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  var info = getDeclarationErrorAddendum();

  if (!info) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

    if (parentName) {
      info = "\n\nCheck the top-level render call using <" + parentName + ">.";
    }
  }

  return info;
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }

  element._store.validated = true;
  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

  if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
    return;
  }

  ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.

  var childOwner = '';

  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
  }

  {
    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }

  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];

      if (isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);

    if (typeof iteratorFn === 'function') {
      // Entry iterators used to provide implicit keys,
      // but now we print a separate warning for them later.
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step;

        while (!(step = iterator.next()).done) {
          if (isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentName(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentName(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}
function createElementWithValidation(type, props, children) {
  var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
  // succeed and there will likely be errors in render.

  if (!validType) {
    var info = '';

    if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
      info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
    }

    var sourceInfo = getSourceInfoErrorAddendumForProps(props);

    if (sourceInfo) {
      info += sourceInfo;
    } else {
      info += getDeclarationErrorAddendum();
    }

    var typeString;

    if (type === null) {
      typeString = 'null';
    } else if (Array.isArray(type)) {
      typeString = 'array';
    } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
      typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
      info = ' Did you accidentally export a JSX literal instead of a component?';
    } else {
      typeString = typeof type;
    }

    {
      error('React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }
  }

  var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
  // TODO: Drop this when these are no longer allowed as the type argument.

  if (element == null) {
    return element;
  } // Skip key warning if the type isn't valid since our key validation logic
  // doesn't expect a non-string/function type and can throw confusing errors.
  // We don't want exception behavior to differ between dev and prod.
  // (Rendering will throw with a helpful message and as soon as the type is
  // fixed, the key warnings will appear.)


  if (validType) {
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], type);
    }
  }

  if (type === exports.Fragment) {
    validateFragmentProps(element);
  } else {
    validatePropTypes(element);
  }

  return element;
}
var didWarnAboutDeprecatedCreateFactory = false;
function createFactoryWithValidation(type) {
  var validatedFactory = createElementWithValidation.bind(null, type);
  validatedFactory.type = type;

  {
    if (!didWarnAboutDeprecatedCreateFactory) {
      didWarnAboutDeprecatedCreateFactory = true;

      warn('React.createFactory() is deprecated and will be removed in ' + 'a future major release. Consider using JSX ' + 'or use React.createElement() directly instead.');
    } // Legacy hook: remove it


    Object.defineProperty(validatedFactory, 'type', {
      enumerable: false,
      get: function () {
        warn('Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');

        Object.defineProperty(this, 'type', {
          value: type
        });
        return type;
      }
    });
  }

  return validatedFactory;
}
function cloneElementWithValidation(element, props, children) {
  var newElement = cloneElement.apply(this, arguments);

  for (var i = 2; i < arguments.length; i++) {
    validateChildKeys(arguments[i], newElement.type);
  }

  validatePropTypes(newElement);
  return newElement;
}

{

  try {
    var frozenObject = Object.freeze({});
    /* eslint-disable no-new */

    new Map([[frozenObject, null]]);
    new Set([frozenObject]);
    /* eslint-enable no-new */
  } catch (e) {
  }
}

var createElement$1 =  createElementWithValidation ;
var cloneElement$1 =  cloneElementWithValidation ;
var createFactory =  createFactoryWithValidation ;
var Children = {
  map: mapChildren,
  forEach: forEachChildren,
  count: countChildren,
  toArray: toArray,
  only: onlyChild
};

exports.Children = Children;
exports.Component = Component;
exports.PureComponent = PureComponent;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
exports.cloneElement = cloneElement$1;
exports.createContext = createContext;
exports.createElement = createElement$1;
exports.createFactory = createFactory;
exports.createRef = createRef;
exports.forwardRef = forwardRef;
exports.isValidElement = isValidElement;
exports.lazy = lazy;
exports.memo = memo;
exports.useCallback = useCallback;
exports.useContext = useContext;
exports.useDebugValue = useDebugValue;
exports.useEffect = useEffect;
exports.useImperativeHandle = useImperativeHandle;
exports.useLayoutEffect = useLayoutEffect;
exports.useMemo = useMemo;
exports.useReducer = useReducer;
exports.useRef = useRef;
exports.useState = useState;
exports.version = ReactVersion;
  })();
}


/***/ }),

/***/ "../../node_modules/react/index.js":
/*!*****************************************!*\
  !*** ../../node_modules/react/index.js ***!
  \*****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/react.development.js */ "../../node_modules/react/cjs/react.development.js");
}


/***/ }),

/***/ "../../node_modules/react/jsx-runtime.js":
/*!***********************************************!*\
  !*** ../../node_modules/react/jsx-runtime.js ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/react-jsx-runtime.development.js */ "../../node_modules/react/cjs/react-jsx-runtime.development.js");
}


/***/ }),

/***/ "../../node_modules/scheduler/cjs/scheduler-tracing.development.js":
/*!*************************************************************************!*\
  !*** ../../node_modules/scheduler/cjs/scheduler-tracing.development.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v0.20.2
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  (function() {
'use strict';

var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.

var interactionIDCounter = 0;
var threadIDCounter = 0; // Set of currently traced interactions.
// Interactions "stack"–
// Meaning that newly traced interactions are appended to the previously active set.
// When an interaction goes out of scope, the previous set (if any) is restored.

exports.__interactionsRef = null; // Listener(s) to notify when interactions begin and end.

exports.__subscriberRef = null;

{
  exports.__interactionsRef = {
    current: new Set()
  };
  exports.__subscriberRef = {
    current: null
  };
}
function unstable_clear(callback) {

  var prevInteractions = exports.__interactionsRef.current;
  exports.__interactionsRef.current = new Set();

  try {
    return callback();
  } finally {
    exports.__interactionsRef.current = prevInteractions;
  }
}
function unstable_getCurrent() {
  {
    return exports.__interactionsRef.current;
  }
}
function unstable_getThreadID() {
  return ++threadIDCounter;
}
function unstable_trace(name, timestamp, callback) {
  var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;

  var interaction = {
    __count: 1,
    id: interactionIDCounter++,
    name: name,
    timestamp: timestamp
  };
  var prevInteractions = exports.__interactionsRef.current; // Traced interactions should stack/accumulate.
  // To do that, clone the current interactions.
  // The previous set will be restored upon completion.

  var interactions = new Set(prevInteractions);
  interactions.add(interaction);
  exports.__interactionsRef.current = interactions;
  var subscriber = exports.__subscriberRef.current;
  var returnValue;

  try {
    if (subscriber !== null) {
      subscriber.onInteractionTraced(interaction);
    }
  } finally {
    try {
      if (subscriber !== null) {
        subscriber.onWorkStarted(interactions, threadID);
      }
    } finally {
      try {
        returnValue = callback();
      } finally {
        exports.__interactionsRef.current = prevInteractions;

        try {
          if (subscriber !== null) {
            subscriber.onWorkStopped(interactions, threadID);
          }
        } finally {
          interaction.__count--; // If no async work was scheduled for this interaction,
          // Notify subscribers that it's completed.

          if (subscriber !== null && interaction.__count === 0) {
            subscriber.onInteractionScheduledWorkCompleted(interaction);
          }
        }
      }
    }
  }

  return returnValue;
}
function unstable_wrap(callback) {
  var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;

  var wrappedInteractions = exports.__interactionsRef.current;
  var subscriber = exports.__subscriberRef.current;

  if (subscriber !== null) {
    subscriber.onWorkScheduled(wrappedInteractions, threadID);
  } // Update the pending async work count for the current interactions.
  // Update after calling subscribers in case of error.


  wrappedInteractions.forEach(function (interaction) {
    interaction.__count++;
  });
  var hasRun = false;

  function wrapped() {
    var prevInteractions = exports.__interactionsRef.current;
    exports.__interactionsRef.current = wrappedInteractions;
    subscriber = exports.__subscriberRef.current;

    try {
      var returnValue;

      try {
        if (subscriber !== null) {
          subscriber.onWorkStarted(wrappedInteractions, threadID);
        }
      } finally {
        try {
          returnValue = callback.apply(undefined, arguments);
        } finally {
          exports.__interactionsRef.current = prevInteractions;

          if (subscriber !== null) {
            subscriber.onWorkStopped(wrappedInteractions, threadID);
          }
        }
      }

      return returnValue;
    } finally {
      if (!hasRun) {
        // We only expect a wrapped function to be executed once,
        // But in the event that it's executed more than once–
        // Only decrement the outstanding interaction counts once.
        hasRun = true; // Update pending async counts for all wrapped interactions.
        // If this was the last scheduled async work for any of them,
        // Mark them as completed.

        wrappedInteractions.forEach(function (interaction) {
          interaction.__count--;

          if (subscriber !== null && interaction.__count === 0) {
            subscriber.onInteractionScheduledWorkCompleted(interaction);
          }
        });
      }
    }
  }

  wrapped.cancel = function cancel() {
    subscriber = exports.__subscriberRef.current;

    try {
      if (subscriber !== null) {
        subscriber.onWorkCanceled(wrappedInteractions, threadID);
      }
    } finally {
      // Update pending async counts for all wrapped interactions.
      // If this was the last scheduled async work for any of them,
      // Mark them as completed.
      wrappedInteractions.forEach(function (interaction) {
        interaction.__count--;

        if (subscriber && interaction.__count === 0) {
          subscriber.onInteractionScheduledWorkCompleted(interaction);
        }
      });
    }
  };

  return wrapped;
}

var subscribers = null;

{
  subscribers = new Set();
}

function unstable_subscribe(subscriber) {
  {
    subscribers.add(subscriber);

    if (subscribers.size === 1) {
      exports.__subscriberRef.current = {
        onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
        onInteractionTraced: onInteractionTraced,
        onWorkCanceled: onWorkCanceled,
        onWorkScheduled: onWorkScheduled,
        onWorkStarted: onWorkStarted,
        onWorkStopped: onWorkStopped
      };
    }
  }
}
function unstable_unsubscribe(subscriber) {
  {
    subscribers.delete(subscriber);

    if (subscribers.size === 0) {
      exports.__subscriberRef.current = null;
    }
  }
}

function onInteractionTraced(interaction) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onInteractionTraced(interaction);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onInteractionScheduledWorkCompleted(interaction) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onInteractionScheduledWorkCompleted(interaction);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkScheduled(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkScheduled(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkStarted(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkStarted(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkStopped(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkStopped(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkCanceled(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkCanceled(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

exports.unstable_clear = unstable_clear;
exports.unstable_getCurrent = unstable_getCurrent;
exports.unstable_getThreadID = unstable_getThreadID;
exports.unstable_subscribe = unstable_subscribe;
exports.unstable_trace = unstable_trace;
exports.unstable_unsubscribe = unstable_unsubscribe;
exports.unstable_wrap = unstable_wrap;
  })();
}


/***/ }),

/***/ "../../node_modules/scheduler/cjs/scheduler.development.js":
/*!*****************************************************************!*\
  !*** ../../node_modules/scheduler/cjs/scheduler.development.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v0.20.2
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  (function() {
'use strict';

var enableSchedulerDebugging = false;
var enableProfiling = false;

var requestHostCallback;
var requestHostTimeout;
var cancelHostTimeout;
var requestPaint;
var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';

if (hasPerformanceNow) {
  var localPerformance = performance;

  exports.unstable_now = function () {
    return localPerformance.now();
  };
} else {
  var localDate = Date;
  var initialTime = localDate.now();

  exports.unstable_now = function () {
    return localDate.now() - initialTime;
  };
}

if ( // If Scheduler runs in a non-DOM environment, it falls back to a naive
// implementation using setTimeout.
typeof window === 'undefined' || // Check if MessageChannel is supported, too.
typeof MessageChannel !== 'function') {
  // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
  // fallback to a naive implementation.
  var _callback = null;
  var _timeoutID = null;

  var _flushCallback = function () {
    if (_callback !== null) {
      try {
        var currentTime = exports.unstable_now();
        var hasRemainingTime = true;

        _callback(hasRemainingTime, currentTime);

        _callback = null;
      } catch (e) {
        setTimeout(_flushCallback, 0);
        throw e;
      }
    }
  };

  requestHostCallback = function (cb) {
    if (_callback !== null) {
      // Protect against re-entrancy.
      setTimeout(requestHostCallback, 0, cb);
    } else {
      _callback = cb;
      setTimeout(_flushCallback, 0);
    }
  };

  requestHostTimeout = function (cb, ms) {
    _timeoutID = setTimeout(cb, ms);
  };

  cancelHostTimeout = function () {
    clearTimeout(_timeoutID);
  };

  exports.unstable_shouldYield = function () {
    return false;
  };

  requestPaint = exports.unstable_forceFrameRate = function () {};
} else {
  // Capture local references to native APIs, in case a polyfill overrides them.
  var _setTimeout = window.setTimeout;
  var _clearTimeout = window.clearTimeout;

  if (typeof console !== 'undefined') {
    // TODO: Scheduler no longer requires these methods to be polyfilled. But
    // maybe we want to continue warning if they don't exist, to preserve the
    // option to rely on it in the future?
    var requestAnimationFrame = window.requestAnimationFrame;
    var cancelAnimationFrame = window.cancelAnimationFrame;

    if (typeof requestAnimationFrame !== 'function') {
      // Using console['error'] to evade Babel and ESLint
      console['error']("This browser doesn't support requestAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
    }

    if (typeof cancelAnimationFrame !== 'function') {
      // Using console['error'] to evade Babel and ESLint
      console['error']("This browser doesn't support cancelAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
    }
  }

  var isMessageLoopRunning = false;
  var scheduledHostCallback = null;
  var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
  // thread, like user events. By default, it yields multiple times per frame.
  // It does not attempt to align with frame boundaries, since most tasks don't
  // need to be frame aligned; for those that do, use requestAnimationFrame.

  var yieldInterval = 5;
  var deadline = 0; // TODO: Make this configurable

  {
    // `isInputPending` is not available. Since we have no way of knowing if
    // there's pending input, always yield at the end of the frame.
    exports.unstable_shouldYield = function () {
      return exports.unstable_now() >= deadline;
    }; // Since we yield every frame regardless, `requestPaint` has no effect.


    requestPaint = function () {};
  }

  exports.unstable_forceFrameRate = function (fps) {
    if (fps < 0 || fps > 125) {
      // Using console['error'] to evade Babel and ESLint
      console['error']('forceFrameRate takes a positive int between 0 and 125, ' + 'forcing frame rates higher than 125 fps is not supported');
      return;
    }

    if (fps > 0) {
      yieldInterval = Math.floor(1000 / fps);
    } else {
      // reset the framerate
      yieldInterval = 5;
    }
  };

  var performWorkUntilDeadline = function () {
    if (scheduledHostCallback !== null) {
      var currentTime = exports.unstable_now(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
      // cycle. This means there's always time remaining at the beginning of
      // the message event.

      deadline = currentTime + yieldInterval;
      var hasTimeRemaining = true;

      try {
        var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);

        if (!hasMoreWork) {
          isMessageLoopRunning = false;
          scheduledHostCallback = null;
        } else {
          // If there's more work, schedule the next message event at the end
          // of the preceding one.
          port.postMessage(null);
        }
      } catch (error) {
        // If a scheduler task throws, exit the current browser task so the
        // error can be observed.
        port.postMessage(null);
        throw error;
      }
    } else {
      isMessageLoopRunning = false;
    } // Yielding to the browser will give it a chance to paint, so we can
  };

  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = performWorkUntilDeadline;

  requestHostCallback = function (callback) {
    scheduledHostCallback = callback;

    if (!isMessageLoopRunning) {
      isMessageLoopRunning = true;
      port.postMessage(null);
    }
  };

  requestHostTimeout = function (callback, ms) {
    taskTimeoutID = _setTimeout(function () {
      callback(exports.unstable_now());
    }, ms);
  };

  cancelHostTimeout = function () {
    _clearTimeout(taskTimeoutID);

    taskTimeoutID = -1;
  };
}

function push(heap, node) {
  var index = heap.length;
  heap.push(node);
  siftUp(heap, node, index);
}
function peek(heap) {
  var first = heap[0];
  return first === undefined ? null : first;
}
function pop(heap) {
  var first = heap[0];

  if (first !== undefined) {
    var last = heap.pop();

    if (last !== first) {
      heap[0] = last;
      siftDown(heap, last, 0);
    }

    return first;
  } else {
    return null;
  }
}

function siftUp(heap, node, i) {
  var index = i;

  while (true) {
    var parentIndex = index - 1 >>> 1;
    var parent = heap[parentIndex];

    if (parent !== undefined && compare(parent, node) > 0) {
      // The parent is larger. Swap positions.
      heap[parentIndex] = node;
      heap[index] = parent;
      index = parentIndex;
    } else {
      // The parent is smaller. Exit.
      return;
    }
  }
}

function siftDown(heap, node, i) {
  var index = i;
  var length = heap.length;

  while (index < length) {
    var leftIndex = (index + 1) * 2 - 1;
    var left = heap[leftIndex];
    var rightIndex = leftIndex + 1;
    var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.

    if (left !== undefined && compare(left, node) < 0) {
      if (right !== undefined && compare(right, left) < 0) {
        heap[index] = right;
        heap[rightIndex] = node;
        index = rightIndex;
      } else {
        heap[index] = left;
        heap[leftIndex] = node;
        index = leftIndex;
      }
    } else if (right !== undefined && compare(right, node) < 0) {
      heap[index] = right;
      heap[rightIndex] = node;
      index = rightIndex;
    } else {
      // Neither child is smaller. Exit.
      return;
    }
  }
}

function compare(a, b) {
  // Compare sort index first, then task id.
  var diff = a.sortIndex - b.sortIndex;
  return diff !== 0 ? diff : a.id - b.id;
}

// TODO: Use symbols?
var ImmediatePriority = 1;
var UserBlockingPriority = 2;
var NormalPriority = 3;
var LowPriority = 4;
var IdlePriority = 5;

function markTaskErrored(task, ms) {
}

/* eslint-disable no-var */
// Math.pow(2, 30) - 1
// 0b111111111111111111111111111111

var maxSigned31BitInt = 1073741823; // Times out immediately

var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out

var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
var NORMAL_PRIORITY_TIMEOUT = 5000;
var LOW_PRIORITY_TIMEOUT = 10000; // Never times out

var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap

var taskQueue = [];
var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.

var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
var currentTask = null;
var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.

var isPerformingWork = false;
var isHostCallbackScheduled = false;
var isHostTimeoutScheduled = false;

function advanceTimers(currentTime) {
  // Check for tasks that are no longer delayed and add them to the queue.
  var timer = peek(timerQueue);

  while (timer !== null) {
    if (timer.callback === null) {
      // Timer was cancelled.
      pop(timerQueue);
    } else if (timer.startTime <= currentTime) {
      // Timer fired. Transfer to the task queue.
      pop(timerQueue);
      timer.sortIndex = timer.expirationTime;
      push(taskQueue, timer);
    } else {
      // Remaining timers are pending.
      return;
    }

    timer = peek(timerQueue);
  }
}

function handleTimeout(currentTime) {
  isHostTimeoutScheduled = false;
  advanceTimers(currentTime);

  if (!isHostCallbackScheduled) {
    if (peek(taskQueue) !== null) {
      isHostCallbackScheduled = true;
      requestHostCallback(flushWork);
    } else {
      var firstTimer = peek(timerQueue);

      if (firstTimer !== null) {
        requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
      }
    }
  }
}

function flushWork(hasTimeRemaining, initialTime) {


  isHostCallbackScheduled = false;

  if (isHostTimeoutScheduled) {
    // We scheduled a timeout but it's no longer needed. Cancel it.
    isHostTimeoutScheduled = false;
    cancelHostTimeout();
  }

  isPerformingWork = true;
  var previousPriorityLevel = currentPriorityLevel;

  try {
    if (enableProfiling) {
      try {
        return workLoop(hasTimeRemaining, initialTime);
      } catch (error) {
        if (currentTask !== null) {
          var currentTime = exports.unstable_now();
          markTaskErrored(currentTask, currentTime);
          currentTask.isQueued = false;
        }

        throw error;
      }
    } else {
      // No catch in prod code path.
      return workLoop(hasTimeRemaining, initialTime);
    }
  } finally {
    currentTask = null;
    currentPriorityLevel = previousPriorityLevel;
    isPerformingWork = false;
  }
}

function workLoop(hasTimeRemaining, initialTime) {
  var currentTime = initialTime;
  advanceTimers(currentTime);
  currentTask = peek(taskQueue);

  while (currentTask !== null && !(enableSchedulerDebugging )) {
    if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || exports.unstable_shouldYield())) {
      // This currentTask hasn't expired, and we've reached the deadline.
      break;
    }

    var callback = currentTask.callback;

    if (typeof callback === 'function') {
      currentTask.callback = null;
      currentPriorityLevel = currentTask.priorityLevel;
      var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;

      var continuationCallback = callback(didUserCallbackTimeout);
      currentTime = exports.unstable_now();

      if (typeof continuationCallback === 'function') {
        currentTask.callback = continuationCallback;
      } else {

        if (currentTask === peek(taskQueue)) {
          pop(taskQueue);
        }
      }

      advanceTimers(currentTime);
    } else {
      pop(taskQueue);
    }

    currentTask = peek(taskQueue);
  } // Return whether there's additional work


  if (currentTask !== null) {
    return true;
  } else {
    var firstTimer = peek(timerQueue);

    if (firstTimer !== null) {
      requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
    }

    return false;
  }
}

function unstable_runWithPriority(priorityLevel, eventHandler) {
  switch (priorityLevel) {
    case ImmediatePriority:
    case UserBlockingPriority:
    case NormalPriority:
    case LowPriority:
    case IdlePriority:
      break;

    default:
      priorityLevel = NormalPriority;
  }

  var previousPriorityLevel = currentPriorityLevel;
  currentPriorityLevel = priorityLevel;

  try {
    return eventHandler();
  } finally {
    currentPriorityLevel = previousPriorityLevel;
  }
}

function unstable_next(eventHandler) {
  var priorityLevel;

  switch (currentPriorityLevel) {
    case ImmediatePriority:
    case UserBlockingPriority:
    case NormalPriority:
      // Shift down to normal priority
      priorityLevel = NormalPriority;
      break;

    default:
      // Anything lower than normal priority should remain at the current level.
      priorityLevel = currentPriorityLevel;
      break;
  }

  var previousPriorityLevel = currentPriorityLevel;
  currentPriorityLevel = priorityLevel;

  try {
    return eventHandler();
  } finally {
    currentPriorityLevel = previousPriorityLevel;
  }
}

function unstable_wrapCallback(callback) {
  var parentPriorityLevel = currentPriorityLevel;
  return function () {
    // This is a fork of runWithPriority, inlined for performance.
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = parentPriorityLevel;

    try {
      return callback.apply(this, arguments);
    } finally {
      currentPriorityLevel = previousPriorityLevel;
    }
  };
}

function unstable_scheduleCallback(priorityLevel, callback, options) {
  var currentTime = exports.unstable_now();
  var startTime;

  if (typeof options === 'object' && options !== null) {
    var delay = options.delay;

    if (typeof delay === 'number' && delay > 0) {
      startTime = currentTime + delay;
    } else {
      startTime = currentTime;
    }
  } else {
    startTime = currentTime;
  }

  var timeout;

  switch (priorityLevel) {
    case ImmediatePriority:
      timeout = IMMEDIATE_PRIORITY_TIMEOUT;
      break;

    case UserBlockingPriority:
      timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
      break;

    case IdlePriority:
      timeout = IDLE_PRIORITY_TIMEOUT;
      break;

    case LowPriority:
      timeout = LOW_PRIORITY_TIMEOUT;
      break;

    case NormalPriority:
    default:
      timeout = NORMAL_PRIORITY_TIMEOUT;
      break;
  }

  var expirationTime = startTime + timeout;
  var newTask = {
    id: taskIdCounter++,
    callback: callback,
    priorityLevel: priorityLevel,
    startTime: startTime,
    expirationTime: expirationTime,
    sortIndex: -1
  };

  if (startTime > currentTime) {
    // This is a delayed task.
    newTask.sortIndex = startTime;
    push(timerQueue, newTask);

    if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
      // All tasks are delayed, and this is the task with the earliest delay.
      if (isHostTimeoutScheduled) {
        // Cancel an existing timeout.
        cancelHostTimeout();
      } else {
        isHostTimeoutScheduled = true;
      } // Schedule a timeout.


      requestHostTimeout(handleTimeout, startTime - currentTime);
    }
  } else {
    newTask.sortIndex = expirationTime;
    push(taskQueue, newTask);
    // wait until the next time we yield.


    if (!isHostCallbackScheduled && !isPerformingWork) {
      isHostCallbackScheduled = true;
      requestHostCallback(flushWork);
    }
  }

  return newTask;
}

function unstable_pauseExecution() {
}

function unstable_continueExecution() {

  if (!isHostCallbackScheduled && !isPerformingWork) {
    isHostCallbackScheduled = true;
    requestHostCallback(flushWork);
  }
}

function unstable_getFirstCallbackNode() {
  return peek(taskQueue);
}

function unstable_cancelCallback(task) {
  // remove from the queue because you can't remove arbitrary nodes from an
  // array based heap, only the first one.)


  task.callback = null;
}

function unstable_getCurrentPriorityLevel() {
  return currentPriorityLevel;
}

var unstable_requestPaint = requestPaint;
var unstable_Profiling =  null;

exports.unstable_IdlePriority = IdlePriority;
exports.unstable_ImmediatePriority = ImmediatePriority;
exports.unstable_LowPriority = LowPriority;
exports.unstable_NormalPriority = NormalPriority;
exports.unstable_Profiling = unstable_Profiling;
exports.unstable_UserBlockingPriority = UserBlockingPriority;
exports.unstable_cancelCallback = unstable_cancelCallback;
exports.unstable_continueExecution = unstable_continueExecution;
exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
exports.unstable_next = unstable_next;
exports.unstable_pauseExecution = unstable_pauseExecution;
exports.unstable_requestPaint = unstable_requestPaint;
exports.unstable_runWithPriority = unstable_runWithPriority;
exports.unstable_scheduleCallback = unstable_scheduleCallback;
exports.unstable_wrapCallback = unstable_wrapCallback;
  })();
}


/***/ }),

/***/ "../../node_modules/scheduler/index.js":
/*!*********************************************!*\
  !*** ../../node_modules/scheduler/index.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/scheduler.development.js */ "../../node_modules/scheduler/cjs/scheduler.development.js");
}


/***/ }),

/***/ "../../node_modules/scheduler/tracing.js":
/*!***********************************************!*\
  !*** ../../node_modules/scheduler/tracing.js ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/scheduler-tracing.development.js */ "../../node_modules/scheduler/cjs/scheduler-tracing.development.js");
}


/***/ }),

/***/ "../../node_modules/setimmediate/setImmediate.js":
/*!*******************************************************!*\
  !*** ../../node_modules/setimmediate/setImmediate.js ***!
  \*******************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(/*! process/browser.js */ "../../node_modules/process/browser.js");
(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof __webpack_require__.g === "undefined" ? this : __webpack_require__.g : self));


/***/ }),

/***/ "../../node_modules/timers-browserify/main.js":
/*!****************************************************!*\
  !*** ../../node_modules/timers-browserify/main.js ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var scope = (typeof __webpack_require__.g !== "undefined" && __webpack_require__.g) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(/*! setimmediate */ "../../node_modules/setimmediate/setImmediate.js");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof __webpack_require__.g !== "undefined" && __webpack_require__.g.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof __webpack_require__.g !== "undefined" && __webpack_require__.g.clearImmediate) ||
                         (this && this.clearImmediate);


/***/ }),

/***/ "../../node_modules/use-resize-observer/polyfilled.js":
/*!************************************************************!*\
  !*** ../../node_modules/use-resize-observer/polyfilled.js ***!
  \************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var resizeObserver = __webpack_require__(/*! @juggle/resize-observer */ "../../node_modules/@juggle/resize-observer/lib/exports/resize-observer.js");
var react = __webpack_require__(/*! react */ "../../node_modules/react/index.js");

// This could've been more streamlined with internal state instead of abusing
// refs to such extent, but then composing hooks and components could not opt out of unnecessary renders.
function useResolvedElement(subscriber, refOrElement) {
  var lastReportRef = react.useRef(null);
  var refOrElementRef = react.useRef(null);
  refOrElementRef.current = refOrElement;
  var cbElementRef = react.useRef(null); // Calling re-evaluation after each render without using a dep array,
  // as the ref object's current value could've changed since the last render.

  react.useEffect(function () {
    evaluateSubscription();
  });
  var evaluateSubscription = react.useCallback(function () {
    var cbElement = cbElementRef.current;
    var refOrElement = refOrElementRef.current; // Ugly ternary. But smaller than an if-else block.

    var element = cbElement ? cbElement : refOrElement ? refOrElement instanceof Element ? refOrElement : refOrElement.current : null;

    if (lastReportRef.current && lastReportRef.current.element === element && lastReportRef.current.subscriber === subscriber) {
      return;
    }

    if (lastReportRef.current && lastReportRef.current.cleanup) {
      lastReportRef.current.cleanup();
    }

    lastReportRef.current = {
      element: element,
      subscriber: subscriber,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: element ? subscriber(element) : undefined
    };
  }, [subscriber]); // making sure we call the cleanup function on unmount

  react.useEffect(function () {
    return function () {
      if (lastReportRef.current && lastReportRef.current.cleanup) {
        lastReportRef.current.cleanup();
        lastReportRef.current = null;
      }
    };
  }, []);
  return react.useCallback(function (element) {
    cbElementRef.current = element;
    evaluateSubscription();
  }, [evaluateSubscription]);
}

// We're only using the first element of the size sequences, until future versions of the spec solidify on how
// exactly it'll be used for fragments in multi-column scenarios:
// From the spec:
// > The box size properties are exposed as FrozenArray in order to support elements that have multiple fragments,
// > which occur in multi-column scenarios. However the current definitions of content rect and border box do not
// > mention how those boxes are affected by multi-column layout. In this spec, there will only be a single
// > ResizeObserverSize returned in the FrozenArray, which will correspond to the dimensions of the first column.
// > A future version of this spec will extend the returned FrozenArray to contain the per-fragment size information.
// (https://drafts.csswg.org/resize-observer/#resize-observer-entry-interface)
//
// Also, testing these new box options revealed that in both Chrome and FF everything is returned in the callback,
// regardless of the "box" option.
// The spec states the following on this:
// > This does not have any impact on which box dimensions are returned to the defined callback when the event
// > is fired, it solely defines which box the author wishes to observe layout changes on.
// (https://drafts.csswg.org/resize-observer/#resize-observer-interface)
// I'm not exactly clear on what this means, especially when you consider a later section stating the following:
// > This section is non-normative. An author may desire to observe more than one CSS box.
// > In this case, author will need to use multiple ResizeObservers.
// (https://drafts.csswg.org/resize-observer/#resize-observer-interface)
// Which is clearly not how current browser implementations behave, and seems to contradict the previous quote.
// For this reason I decided to only return the requested size,
// even though it seems we have access to results for all box types.
// This also means that we get to keep the current api, being able to return a simple { width, height } pair,
// regardless of box option.
function extractSize(entry, boxProp, sizeType) {
  if (!entry[boxProp]) {
    if (boxProp === "contentBoxSize") {
      // The dimensions in `contentBoxSize` and `contentRect` are equivalent according to the spec.
      // See the 6th step in the description for the RO algorithm:
      // https://drafts.csswg.org/resize-observer/#create-and-populate-resizeobserverentry-h
      // > Set this.contentRect to logical this.contentBoxSize given target and observedBox of "content-box".
      // In real browser implementations of course these objects differ, but the width/height values should be equivalent.
      return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
    }

    return undefined;
  } // A couple bytes smaller than calling Array.isArray() and just as effective here.


  return entry[boxProp][0] ? entry[boxProp][0][sizeType] : // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
  // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
  // @ts-ignore
  entry[boxProp][sizeType];
}

function useResizeObserver(opts) {
  if (opts === void 0) {
    opts = {};
  }

  // Saving the callback as a ref. With this, I don't need to put onResize in the
  // effect dep array, and just passing in an anonymous function without memoising
  // will not reinstantiate the hook's ResizeObserver.
  var onResize = opts.onResize;
  var onResizeRef = react.useRef(undefined);
  onResizeRef.current = onResize;
  var round = opts.round || Math.round; // Using a single instance throughout the hook's lifetime

  var resizeObserverRef = react.useRef();

  var _useState = react.useState({
    width: undefined,
    height: undefined
  }),
      size = _useState[0],
      setSize = _useState[1]; // In certain edge cases the RO might want to report a size change just after
  // the component unmounted.


  var didUnmount = react.useRef(false);
  react.useEffect(function () {
    didUnmount.current = false;
    return function () {
      didUnmount.current = true;
    };
  }, []); // Using a ref to track the previous width / height to avoid unnecessary renders.

  var previous = react.useRef({
    width: undefined,
    height: undefined
  }); // This block is kinda like a useEffect, only it's called whenever a new
  // element could be resolved based on the ref option. It also has a cleanup
  // function.

  var refCallback = useResolvedElement(react.useCallback(function (element) {
    // We only use a single Resize Observer instance, and we're instantiating it on demand, only once there's something to observe.
    // This instance is also recreated when the `box` option changes, so that a new observation is fired if there was a previously observed element with a different box option.
    if (!resizeObserverRef.current || resizeObserverRef.current.box !== opts.box || resizeObserverRef.current.round !== round) {
      resizeObserverRef.current = {
        box: opts.box,
        round: round,
        instance: new resizeObserver.ResizeObserver(function (entries) {
          var entry = entries[0];
          var boxProp = opts.box === "border-box" ? "borderBoxSize" : opts.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
          var reportedWidth = extractSize(entry, boxProp, "inlineSize");
          var reportedHeight = extractSize(entry, boxProp, "blockSize");
          var newWidth = reportedWidth ? round(reportedWidth) : undefined;
          var newHeight = reportedHeight ? round(reportedHeight) : undefined;

          if (previous.current.width !== newWidth || previous.current.height !== newHeight) {
            var newSize = {
              width: newWidth,
              height: newHeight
            };
            previous.current.width = newWidth;
            previous.current.height = newHeight;

            if (onResizeRef.current) {
              onResizeRef.current(newSize);
            } else {
              if (!didUnmount.current) {
                setSize(newSize);
              }
            }
          }
        })
      };
    }

    resizeObserverRef.current.instance.observe(element, {
      box: opts.box
    });
    return function () {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.instance.unobserve(element);
      }
    };
  }, [opts.box, round]), opts.ref);
  return react.useMemo(function () {
    return {
      ref: refCallback,
      width: size.width,
      height: size.height
    };
  }, [refCallback, size.width, size.height]);
}

module.exports = useResizeObserver;


/***/ }),

/***/ "../../node_modules/validator/lib/isByteLength.js":
/*!********************************************************!*\
  !*** ../../node_modules/validator/lib/isByteLength.js ***!
  \********************************************************/
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isByteLength;
var _assertString = _interopRequireDefault(__webpack_require__(/*! ./util/assertString */ "../../node_modules/validator/lib/util/assertString.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;
  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ "../../node_modules/validator/lib/isEmail.js":
/*!***************************************************!*\
  !*** ../../node_modules/validator/lib/isEmail.js ***!
  \***************************************************/
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isEmail;
var _assertString = _interopRequireDefault(__webpack_require__(/*! ./util/assertString */ "../../node_modules/validator/lib/util/assertString.js"));
var _isByteLength = _interopRequireDefault(__webpack_require__(/*! ./isByteLength */ "../../node_modules/validator/lib/isByteLength.js"));
var _isFQDN = _interopRequireDefault(__webpack_require__(/*! ./isFQDN */ "../../node_modules/validator/lib/isFQDN.js"));
var _isIP = _interopRequireDefault(__webpack_require__(/*! ./isIP */ "../../node_modules/validator/lib/isIP.js"));
var _merge = _interopRequireDefault(__webpack_require__(/*! ./util/merge */ "../../node_modules/validator/lib/util/merge.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var default_email_options = {
  allow_display_name: false,
  allow_underscores: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true,
  blacklisted_chars: '',
  ignore_max_length: false,
  host_blacklist: [],
  host_whitelist: []
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var defaultMaxEmailLength = 254;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

/**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */
function validateDisplayName(display_name) {
  var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1');
  // display name with only spaces is not valid
  if (!display_name_without_quotes.trim()) {
    return false;
  }

  // check whether display name contains illegal character
  var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
  if (contains_illegal) {
    // if contains illegal characters,
    // must to be enclosed in double-quotes, otherwise it's not a valid display name
    if (display_name_without_quotes === display_name) {
      return false;
    }

    // the quotes in display name must start with character symbol \
    var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
    if (!all_start_with_back_slash) {
      return false;
    }
  }
  return true;
}
function isEmail(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_email_options);
  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(splitNameAddress);
    if (display_email) {
      var display_name = display_email[1];

      // Remove display name and angle brackets to get email address
      // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
      str = str.replace(display_name, '').replace(/(^<|>$)/g, '');

      // sometimes need to trim the last space to get the display name
      // because there may be a space between display name and email address
      // eg. myname <address@gmail.com>
      // the display name is `myname` instead of `myname `, so need to trim the last space
      if (display_name.endsWith(' ')) {
        display_name = display_name.slice(0, -1);
      }
      if (!validateDisplayName(display_name)) {
        return false;
      }
    } else if (options.require_display_name) {
      return false;
    }
  }
  if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
    return false;
  }
  var parts = str.split('@');
  var domain = parts.pop();
  var lower_domain = domain.toLowerCase();
  if (options.host_blacklist.includes(lower_domain)) {
    return false;
  }
  if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) {
    return false;
  }
  var user = parts.join('@');
  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase();

    // Removing sub-address from username before gmail validation
    var username = user.split('+')[0];

    // Dots are not included in gmail length restriction
    if (!(0, _isByteLength.default)(username.replace(/\./g, ''), {
      min: 6,
      max: 30
    })) {
      return false;
    }
    var _user_parts = username.split('.');
    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }
  if (options.ignore_max_length === false && (!(0, _isByteLength.default)(user, {
    max: 64
  }) || !(0, _isByteLength.default)(domain, {
    max: 254
  }))) {
    return false;
  }
  if (!(0, _isFQDN.default)(domain, {
    require_tld: options.require_tld,
    ignore_max_length: options.ignore_max_length,
    allow_underscores: options.allow_underscores
  })) {
    if (!options.allow_ip_domain) {
      return false;
    }
    if (!(0, _isIP.default)(domain)) {
      if (!domain.startsWith('[') || !domain.endsWith(']')) {
        return false;
      }
      var noBracketdomain = domain.slice(1, -1);
      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
        return false;
      }
    }
  }
  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }
  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
  var user_parts = user.split('.');
  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }
  if (options.blacklisted_chars) {
    if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
  }
  return true;
}
module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ "../../node_modules/validator/lib/isFQDN.js":
/*!**************************************************!*\
  !*** ../../node_modules/validator/lib/isFQDN.js ***!
  \**************************************************/
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isFQDN;
var _assertString = _interopRequireDefault(__webpack_require__(/*! ./util/assertString */ "../../node_modules/validator/lib/util/assertString.js"));
var _merge = _interopRequireDefault(__webpack_require__(/*! ./util/merge */ "../../node_modules/validator/lib/util/merge.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_numeric_tld: false,
  allow_wildcard: false,
  ignore_max_length: false
};
function isFQDN(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }

  /* Remove the optional wildcard before checking validity */
  if (options.allow_wildcard === true && str.indexOf('*.') === 0) {
    str = str.substring(2);
  }
  var parts = str.split('.');
  var tld = parts[parts.length - 1];
  if (options.require_tld) {
    // disallow fqdns without tld
    if (parts.length < 2) {
      return false;
    }
    if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }

    // disallow spaces
    if (/\s/.test(tld)) {
      return false;
    }
  }

  // reject numeric TLDs
  if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
    return false;
  }
  return parts.every(function (part) {
    if (part.length > 63 && !options.ignore_max_length) {
      return false;
    }
    if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }

    // disallow full-width chars
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }

    // disallow parts starting or ending with hyphen
    if (/^-|-$/.test(part)) {
      return false;
    }
    if (!options.allow_underscores && /_/.test(part)) {
      return false;
    }
    return true;
  });
}
module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ "../../node_modules/validator/lib/isIP.js":
/*!************************************************!*\
  !*** ../../node_modules/validator/lib/isIP.js ***!
  \************************************************/
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIP;
var _assertString = _interopRequireDefault(__webpack_require__(/*! ./util/assertString */ "../../node_modules/validator/lib/util/assertString.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */
var IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
var IPv4AddressFormat = "(".concat(IPv4SegmentFormat, "[.]){3}").concat(IPv4SegmentFormat);
var IPv4AddressRegExp = new RegExp("^".concat(IPv4AddressFormat, "$"));
var IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
var IPv6AddressRegExp = new RegExp('^(' + "(?:".concat(IPv6SegmentFormat, ":){7}(?:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){6}(?:").concat(IPv4AddressFormat, "|:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){5}(?::").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){4}(?:(:").concat(IPv6SegmentFormat, "){0,1}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){3}(?:(:").concat(IPv6SegmentFormat, "){0,2}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){2}(?:(:").concat(IPv6SegmentFormat, "){0,3}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){1}(?:(:").concat(IPv6SegmentFormat, "){0,4}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat(IPv6SegmentFormat, "){0,5}:").concat(IPv4AddressFormat, "|(?::").concat(IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z-.:]{1,})?$');
function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);
  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  }
  if (version === '4') {
    return IPv4AddressRegExp.test(str);
  }
  if (version === '6') {
    return IPv6AddressRegExp.test(str);
  }
  return false;
}
module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ "../../node_modules/validator/lib/util/assertString.js":
/*!*************************************************************!*\
  !*** ../../node_modules/validator/lib/util/assertString.js ***!
  \*************************************************************/
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = assertString;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;
  if (!isString) {
    var invalidType = _typeof(input);
    if (input === null) invalidType = 'null';else if (invalidType === 'object') invalidType = input.constructor.name;
    throw new TypeError("Expected a string but received a ".concat(invalidType));
  }
}
module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ "../../node_modules/validator/lib/util/merge.js":
/*!******************************************************!*\
  !*** ../../node_modules/validator/lib/util/merge.js ***!
  \******************************************************/
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 ? arguments[1] : undefined;
  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ "./src/assets/AgentStateIcons/RONA_16.svg":
/*!************************************************!*\
  !*** ./src/assets/AgentStateIcons/RONA_16.svg ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgRona16 = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "#D4371C",
  d: "M6.75 13.5a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5M2.813 5.625h7.874a1.125 1.125 0 0 1 0 2.25H2.814a1.125 1.125 0 0 1 0-2.25"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgRona16);

/***/ }),

/***/ "./src/assets/AgentStateIcons/available_16.svg":
/*!*****************************************************!*\
  !*** ./src/assets/AgentStateIcons/available_16.svg ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgAvailable16 = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "#1D805F",
  d: "M13.5 6.75a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0m-3.392-3.094L5.5 8.265 3.375 6.14A1.143 1.143 0 1 0 1.76 7.757l2.424 2.424.035.033.474.474c.447.447 1.17.447 1.617 0l5.416-5.416a1.143 1.143 0 0 0-1.617-1.616"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgAvailable16);

/***/ }),

/***/ "./src/assets/AgentStateIcons/available_raw.svg":
/*!******************************************************!*\
  !*** ./src/assets/AgentStateIcons/available_raw.svg ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgAvailableRaw = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M13.5 6.75a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0m-3.392-3.094L5.5 8.265 3.375 6.14A1.143 1.143 0 1 0 1.76 7.757l2.424 2.424.035.033.474.474c.447.447 1.17.447 1.617 0l5.416-5.416a1.143 1.143 0 0 0-1.617-1.616"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgAvailableRaw);

/***/ }),

/***/ "./src/assets/AgentStateIcons/engaged_available_16.svg":
/*!*************************************************************!*\
  !*** ./src/assets/AgentStateIcons/engaged_available_16.svg ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgEngagedAvailable16 = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "#A85F00",
  d: "M13.5 6.75a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0m-3.392-3.094L5.5 8.265 3.375 6.14A1.143 1.143 0 1 0 1.76 7.757l2.424 2.424.035.033.474.474c.447.447 1.17.447 1.617 0l5.416-5.416a1.143 1.143 0 0 0-1.617-1.616"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgEngagedAvailable16);

/***/ }),

/***/ "./src/assets/AgentStateIcons/engaged_idle_16.svg":
/*!********************************************************!*\
  !*** ./src/assets/AgentStateIcons/engaged_idle_16.svg ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgEngagedIdle16 = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "#A85F00",
  d: "M6.75 13.5a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5M2.813 5.625h7.874a1.125 1.125 0 0 1 0 2.25H2.814a1.125 1.125 0 0 1 0-2.25"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgEngagedIdle16);

/***/ }),

/***/ "./src/assets/AgentStateIcons/idle_16.svg":
/*!************************************************!*\
  !*** ./src/assets/AgentStateIcons/idle_16.svg ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgIdle16 = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "#707070",
  d: "M6.75 13.5a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5M2.813 5.625h7.874a1.125 1.125 0 0 1 0 2.25H2.814a1.125 1.125 0 0 1 0-2.25"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgIdle16);

/***/ }),

/***/ "./src/assets/AgentStateIcons/idle_raw.svg":
/*!*************************************************!*\
  !*** ./src/assets/AgentStateIcons/idle_raw.svg ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgIdleRaw = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M6.75 13.5a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5M2.813 5.625h7.874a1.125 1.125 0 0 1 0 2.25H2.814a1.125 1.125 0 0 1 0-2.25"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgIdleRaw);

/***/ }),

/***/ "./src/assets/AvatarStatus/active-presence-small-filled.svg":
/*!******************************************************************!*\
  !*** ./src/assets/AvatarStatus/active-presence-small-filled.svg ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgActivePresenceSmallFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M13 7A6 6 0 1 1 1 7a6 6 0 0 1 12 0"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgActivePresenceSmallFilled);

/***/ }),

/***/ "./src/assets/AvatarStatus/busy-presence_bold.svg":
/*!********************************************************!*\
  !*** ./src/assets/AvatarStatus/busy-presence_bold.svg ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgBusyPresenceBold = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M30 16c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2s14 6.268 14 14m-14 7a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgBusyPresenceBold);

/***/ }),

/***/ "./src/assets/AvatarStatus/calendar-empty-filled.svg":
/*!***********************************************************!*\
  !*** ./src/assets/AvatarStatus/calendar-empty-filled.svg ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgCalendarEmptyFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M23 5.5V3a1 1 0 0 0-2 0v2.5H11V3a1 1 0 0 0-2 0v2.5A4.505 4.505 0 0 0 4.5 10v14A4.505 4.505 0 0 0 9 28.5h14a4.504 4.504 0 0 0 4.5-4.5V10A4.505 4.505 0 0 0 23 5.5"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCalendarEmptyFilled);

/***/ }),

/***/ "./src/assets/AvatarStatus/camera-presence_filled.svg":
/*!************************************************************!*\
  !*** ./src/assets/AvatarStatus/camera-presence_filled.svg ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgCameraPresenceFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 33 33"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M28.789 9.724a1.5 1.5 0 0 0-1.505-.04l-3.782 2.404v-2.087a4.505 4.505 0 0 0-4.5-4.5h-12a4.505 4.505 0 0 0-4.5 4.5v12a4.505 4.505 0 0 0 4.5 4.5h12a4.505 4.505 0 0 0 4.5-4.5v-2.09l3.827 2.43c.208.105.438.16.672.16A1.504 1.504 0 0 0 29.5 21V11a1.49 1.49 0 0 0-.711-1.276"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCameraPresenceFilled);

/***/ }),

/***/ "./src/assets/AvatarStatus/check-circle-badge-filled_filled.svg":
/*!**********************************************************************!*\
  !*** ./src/assets/AvatarStatus/check-circle-badge-filled_filled.svg ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgCheckCircleBadgeFilledFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12.906 7A5.906 5.906 0 1 1 1.094 7a5.906 5.906 0 0 1 11.812 0M9.94 4.293 5.906 8.325 4.047 6.467A1 1 0 0 0 2.633 7.88l2.121 2.121.03.029.416.415a1 1 0 0 0 1.414 0l4.739-4.739a1 1 0 1 0-1.414-1.414"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCheckCircleBadgeFilledFilled);

/***/ }),

/***/ "./src/assets/AvatarStatus/dnd-presence-badge_filled.svg":
/*!***************************************************************!*\
  !*** ./src/assets/AvatarStatus/dnd-presence-badge_filled.svg ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgDndPresenceBadgeFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12M3.5 6h7a1 1 0 1 1 0 2h-7a1 1 0 0 1 0-2"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgDndPresenceBadgeFilled);

/***/ }),

/***/ "./src/assets/AvatarStatus/headset_filled.svg":
/*!****************************************************!*\
  !*** ./src/assets/AvatarStatus/headset_filled.svg ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgHeadsetFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M27.806 21.744 25 18.938a3.035 3.035 0 0 0-4.286.003s-1.502 1.527-1.808 1.85a7.57 7.57 0 0 1-5.492-2.23 7.86 7.86 0 0 1-2.276-5.43c.37-.37 1.895-1.87 1.898-1.873a3.027 3.027 0 0 0 0-4.284L10.23 4.17a3.115 3.115 0 0 0-4.301 0l-1.5 1.5c-1.116 1.114-1.438 3.536-.824 6.17.548 2.355 2.085 6.043 6.286 10.245s7.89 5.738 10.244 6.287a11.3 11.3 0 0 0 2.544.306 5.16 5.16 0 0 0 3.627-1.13l1.5-1.5a3.04 3.04 0 0 0 0-4.303"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgHeadsetFilled);

/***/ }),

/***/ "./src/assets/AvatarStatus/priority-badge_filled.svg":
/*!***********************************************************!*\
  !*** ./src/assets/AvatarStatus/priority-badge_filled.svg ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgPriorityBadgeFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12.906 7A5.906 5.906 0 1 1 1.094 7a5.906 5.906 0 0 1 11.812 0M6 3v5a1 1 0 0 0 2 0V3a1 1 0 0 0-2 0m1 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgPriorityBadgeFilled);

/***/ }),

/***/ "./src/assets/AvatarStatus/pto-presence_filled.svg":
/*!*********************************************************!*\
  !*** ./src/assets/AvatarStatus/pto-presence_filled.svg ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgPtoPresenceFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M28.965 6.894a3.375 3.375 0 0 0-4.646-1.018l-6.478 4.137-6.348-4.112a1.998 1.998 0 0 0-2.47 3.072l3.405 4.497-2.901 1.853a10.3 10.3 0 0 0-3.793-1.756 3.35 3.35 0 0 0-2.309.383c-.982.63-1.047 1.33-.801 1.743l2.761 4.5 1.135 1.952a2.5 2.5 0 0 0 3.507.85l6.539-4.177.46 6.144a1.95 1.95 0 0 0 1.96 1.673H19a1.955 1.955 0 0 0 1.971-1.66l1.49-9.92 5.482-3.5a3.37 3.37 0 0 0 1.021-4.661"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgPtoPresenceFilled);

/***/ }),

/***/ "./src/assets/AvatarStatus/quiet-hours-presence-filled.svg":
/*!*****************************************************************!*\
  !*** ./src/assets/AvatarStatus/quiet-hours-presence-filled.svg ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgQuietHoursPresenceFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12.793 9.566a.65.65 0 0 0-.309-.25.65.65 0 0 0-.394-.02c-.86.231-1.758.274-2.633.134A6.02 6.02 0 0 1 4.57 4.543a6.3 6.3 0 0 1 .137-2.637.62.62 0 0 0-.023-.394.63.63 0 0 0-.247-.305.658.658 0 0 0-.777.027 6.6 6.6 0 0 0-2.125 2.868 6.7 6.7 0 0 0-.332 3.554 6.492 6.492 0 0 0 5.465 5.191 6.6 6.6 0 0 0 6.102-2.511.64.64 0 0 0 .136-.379.66.66 0 0 0-.113-.39m0 0"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgQuietHoursPresenceFilled);

/***/ }),

/***/ "./src/assets/AvatarStatus/recents-presence-badge_filled.svg":
/*!*******************************************************************!*\
  !*** ./src/assets/AvatarStatus/recents-presence-badge_filled.svg ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgRecentsPresenceBadgeFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M3.667 2.011A6 6 0 0 1 7 1a6.007 6.007 0 0 1 6 6 6 6 0 1 1-9.333-4.989M6 3.5v3.283a1 1 0 0 0 .232.363l.041.04q.02.022.04.041l2.04 2.04a1 1 0 0 0 1.415-1.414L8 6.086V3.5a1 1 0 0 0-2 0"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgRecentsPresenceBadgeFilled);

/***/ }),

/***/ "./src/assets/AvatarStatus/share-screen_filled.svg":
/*!*********************************************************!*\
  !*** ./src/assets/AvatarStatus/share-screen_filled.svg ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgShareScreenFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M25 5.5H7A4.505 4.505 0 0 0 2.5 10v11.784A4.72 4.72 0 0 0 7.216 26.5h17.568a4.72 4.72 0 0 0 4.716-4.716V10A4.505 4.505 0 0 0 25 5.5m-4.293 11.207a1 1 0 0 1-1.414 0L17 14.414V20a1 1 0 0 1-2 0v-5.587l-2.293 2.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgShareScreenFilled);

/***/ }),

/***/ "./src/assets/warning-badge-filled.svg":
/*!*********************************************!*\
  !*** ./src/assets/warning-badge-filled.svg ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgWarningBadgeFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M14.58 11.875 9.083 2.374a1.25 1.25 0 0 0-2.164 0l-5.5 9.501A1.25 1.25 0 0 0 2.5 13.75h11a1.25 1.25 0 0 0 1.082-1.875ZM7 4a1 1 0 0 1 2 0v5a1 1 0 0 1-2 0zm1 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
})));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgWarningBadgeFilled);

/***/ }),

/***/ "./src/constants.ts":
/*!**************************!*\
  !*** ./src/constants.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AGENT: () => (/* binding */ AGENT),
/* harmony export */   AGENT_AND_SUPERVISOR: () => (/* binding */ AGENT_AND_SUPERVISOR),
/* harmony export */   AGENT_SUPERVISOR: () => (/* binding */ AGENT_SUPERVISOR),
/* harmony export */   AX_OUTDIAL_EDIT: () => (/* binding */ AX_OUTDIAL_EDIT),
/* harmony export */   CHECKBOX_HEIGHT: () => (/* binding */ CHECKBOX_HEIGHT),
/* harmony export */   COLLAB_TOOL: () => (/* binding */ COLLAB_TOOL),
/* harmony export */   CONNECTOR_VIEW: () => (/* binding */ CONNECTOR_VIEW),
/* harmony export */   COPY_TIMEOUT: () => (/* binding */ COPY_TIMEOUT),
/* harmony export */   DESKTOP: () => (/* binding */ DESKTOP),
/* harmony export */   DIALER_BUTTON_CLICK_EVENT: () => (/* binding */ DIALER_BUTTON_CLICK_EVENT),
/* harmony export */   DIALPAD_BUTTONS_ARRAY: () => (/* binding */ DIALPAD_BUTTONS_ARRAY),
/* harmony export */   DURATION_DIALER_BUTTON_PRESS: () => (/* binding */ DURATION_DIALER_BUTTON_PRESS),
/* harmony export */   INITIATE_MS_AUTH_LOGIN: () => (/* binding */ INITIATE_MS_AUTH_LOGIN),
/* harmony export */   Key: () => (/* binding */ Key),
/* harmony export */   LIST_CLICK: () => (/* binding */ LIST_CLICK),
/* harmony export */   LOADER_DISPLAY_DURATION: () => (/* binding */ LOADER_DISPLAY_DURATION),
/* harmony export */   MIN_NUMBER_OF_CONSULT_AGENTS_FOR_INTERACTING: () => (/* binding */ MIN_NUMBER_OF_CONSULT_AGENTS_FOR_INTERACTING),
/* harmony export */   MONITORING_REGULAR_DARK: () => (/* binding */ MONITORING_REGULAR_DARK),
/* harmony export */   MONITORING_REGULAR_LIGHT: () => (/* binding */ MONITORING_REGULAR_LIGHT),
/* harmony export */   NO_CHECKBOX_HEIGHT: () => (/* binding */ NO_CHECKBOX_HEIGHT),
/* harmony export */   OUTDIAL: () => (/* binding */ OUTDIAL),
/* harmony export */   OUTDIAL_MENU_CLOSE: () => (/* binding */ OUTDIAL_MENU_CLOSE),
/* harmony export */   OUTDIAL_TYPE: () => (/* binding */ OUTDIAL_TYPE),
/* harmony export */   RETRY_PRESENCE_SYNC_REGISTER: () => (/* binding */ RETRY_PRESENCE_SYNC_REGISTER),
/* harmony export */   SERVICE_STATUS: () => (/* binding */ SERVICE_STATUS),
/* harmony export */   SUPERVISOR: () => (/* binding */ SUPERVISOR),
/* harmony export */   SUPERVISOR_ALT: () => (/* binding */ SUPERVISOR_ALT),
/* harmony export */   SUPERVISOR_AND_AGENT: () => (/* binding */ SUPERVISOR_AND_AGENT),
/* harmony export */   WEB_RTC_PREFIX: () => (/* binding */ WEB_RTC_PREFIX),
/* harmony export */   WEB_RTC_STATUS: () => (/* binding */ WEB_RTC_STATUS),
/* harmony export */   keyCode: () => (/* binding */ keyCode)
/* harmony export */ });
const CONNECTOR_VIEW = "677px";
var Key;
(function (Key) {
    Key["End"] = "End";
    Key["Home"] = "Home";
    Key["Enter"] = "Enter";
    Key["Tab"] = "Tab";
    Key["ArrowDown"] = "ArrowDown";
    Key["ArrowLeft"] = "ArrowLeft";
    Key["ArrowRight"] = "ArrowRight";
    Key["ArrowUp"] = "ArrowUp";
    Key["Delete"] = "Delete";
    Key["Space"] = "Space";
})(Key || (Key = {}));
const COPY_TIMEOUT = 1000;
const AGENT_SUPERVISOR = "AgentSupervisor";
const SUPERVISOR_AND_AGENT = "Supervisor and Agent";
const SUPERVISOR = "supervisor";
const SUPERVISOR_ALT = "Supervisor";
const AGENT = "agent";
const AGENT_AND_SUPERVISOR = "agent_supervisor";
const OUTDIAL = "OUTDIAL";
const INITIATE_MS_AUTH_LOGIN = "initiate-microsoft-auth-flow";
const OUTDIAL_TYPE = {
    WEBEX_SEARCH: "Webex",
    MICROSOFT_SEARCH: "Microsoft_Teams",
    ADDRESS_BOOK: "Address_Book",
    CUSTOM: "Custom"
};
const WEB_RTC_STATUS = {
    WEB_RTC_CONNECTED: "webRtcConnected",
    WEB_RTC_REGISTERING: "webRtcRegistering",
    WEB_RTC_DISCONNECTED: "webRtcDisconnected"
};
const DIALER_BUTTON_CLICK_EVENT = "dialer-button-press-event";
const LOADER_DISPLAY_DURATION = 300;
const DURATION_DIALER_BUTTON_PRESS = 10;
const DIALPAD_BUTTONS_ARRAY = [
    { id: 0, val: "1", str: "" },
    { id: 1, val: "2", str: "ABC" },
    { id: 2, val: "3", str: "DEF" },
    { id: 3, val: "4", str: "GHI" },
    { id: 4, val: "5", str: "JKL" },
    { id: 5, val: "6", str: "MNO" },
    { id: 6, val: "7", str: "PQRS" },
    { id: 7, val: "8", str: "TUV" },
    { id: 8, val: "9", str: "WXYZ" },
    { id: 9, val: "*", str: "" },
    { id: 10, val: "0", str: "+" },
    { id: 11, val: "#", str: "" }
];
const keyCode = {
    backspace: 8,
    delete: 46
};
const WEB_RTC_PREFIX = "webrtc-";
const DESKTOP = "Desktop";
const MONITORING_REGULAR_DARK = "/images/illustrations/Monitoring-regular-dark.svg";
const MONITORING_REGULAR_LIGHT = "/images/illustrations/Monitoring-regular-light.svg";
const COLLAB_TOOL = {
    NONE: "",
    WEBEX: "Webex",
    TEAMS: "Microsoft Teams"
};
const RETRY_PRESENCE_SYNC_REGISTER = "retry-presence-sync-register";
const SERVICE_STATUS = {
    SYNC_FAILURE: "sync_failure",
    MERCURY_FAILURE: "mercury_failure",
    MERCURY_SUCCESSFUL: "mercury_successful"
};
// MultiPartyConference in Consult Request Modal
const MIN_NUMBER_OF_CONSULT_AGENTS_FOR_INTERACTING = 2;
const CHECKBOX_HEIGHT = 33;
const NO_CHECKBOX_HEIGHT = 0;
const OUTDIAL_MENU_CLOSE = "outdial-menu-close";
const AX_OUTDIAL_EDIT = "ax-outdail-edit";
const LIST_CLICK = "list-click";


/***/ }),

/***/ "./src/css/common.css":
/*!****************************!*\
  !*** ./src/css/common.css ***!
  \****************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../node_modules/css-loader/dist/cjs.js!./common.css */ "../../node_modules/css-loader/dist/cjs.js!./src/css/common.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/AddressBookIncreasedLimit/AddressBookIncreasedLimit.tsx":
/*!*****************************************************************************************!*\
  !*** ./src/direflow-components/AddressBookIncreasedLimit/AddressBookIncreasedLimit.tsx ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/components/HighlightText */ "./src/direflow-components/Common/components/HighlightText/index.tsx");
/* harmony import */ var _Common_components_List__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/components/List */ "./src/direflow-components/Common/components/List/index.tsx");
/* harmony import */ var _Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/components/List/ListError */ "./src/direflow-components/Common/components/List/ListError/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./styles.css */ "./src/direflow-components/AddressBookIncreasedLimit/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_11__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};












const AddressBookIncreasedLimit = ({ data, searchQuery, handleListClick, isAdhocDialingEnabled = false, height, retryLoadingAddressBook, loadingError, loadingTrackingId, loading = false, resetTab, isAddressBookInfiniteScrollEnabled, initiateDataFetch, isConsultTransferInfiniteScrollEnabled = false }) => {
    const [filteredAddress, setFilteredAddress] = react__WEBPACK_IMPORTED_MODULE_3__.useState(data);
    const { outdial: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.useI18nContext)();
    const [hasNextPage, setHasNextPage] = react__WEBPACK_IMPORTED_MODULE_3__.useState(false);
    const [isNextPageLoading, setIsNextPageLoading] = react__WEBPACK_IMPORTED_MODULE_3__.useState(false);
    const [page, setPage] = react__WEBPACK_IMPORTED_MODULE_3__.useState(-1);
    const [pageFetchError, setPageFetchError] = react__WEBPACK_IMPORTED_MODULE_3__.useState({
        error: false,
        trackingId: ""
    });
    const [addressBookItems, setAddressBookItems] = react__WEBPACK_IMPORTED_MODULE_3__.useState([]);
    const [loadingFirstPage, setLoadingFirstPage] = react__WEBPACK_IMPORTED_MODULE_3__.useState(false);
    const [loadingFirstPageError, setLoadingFirstPageError] = react__WEBPACK_IMPORTED_MODULE_3__.useState({
        error: false,
        trackingId: ""
    });
    const [searchError, setSearchError] = react__WEBPACK_IMPORTED_MODULE_3__.useState(false);
    const loadFirstPage = () => {
        setAddressBookItems([]);
        setLoadingFirstPage(true);
        loadPage(0, searchQuery, true);
    };
    react__WEBPACK_IMPORTED_MODULE_3__.useEffect(() => {
        if (!isAddressBookInfiniteScrollEnabled) {
            const filteredList = data.filter((address) => {
                var _a;
                const FULL_STRING = `${address.desc}-${address.dn}`;
                return FULL_STRING.toLowerCase().includes((_a = searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.toLowerCase()) !== null && _a !== void 0 ? _a : "");
            });
            setFilteredAddress(filteredList);
        }
    }, [data, searchQuery, isAddressBookInfiniteScrollEnabled]);
    react__WEBPACK_IMPORTED_MODULE_3__.useEffect(() => {
        if (isAddressBookInfiniteScrollEnabled && initiateDataFetch !== 0 && searchQuery !== undefined) {
            if (searchQuery.length >= _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MINIMUM_CHARACTERS_FOR_SEARCH || searchQuery === "") {
                setSearchError(false);
                loadFirstPage();
            }
            else {
                setSearchError(true);
            }
        }
    }, [initiateDataFetch, searchQuery]);
    const loadPage = (page, searchQuery, reset = false) => {
        (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.fetchAddressBookList)(page, searchQuery, _Common_constants__WEBPACK_IMPORTED_MODULE_10__.PAGE_SIZE)
            .then((response) => {
            const { speedDials, page: responsePage, totalPages } = response || {};
            setPageFetchError({ error: false, trackingId: "" });
            setLoadingFirstPageError({ error: false, trackingId: "" });
            document.dispatchEvent(new CustomEvent("on-widget-update"));
            // eslint-disable-next-line no-unsafe-optional-chaining -- Tech debt/Potential bug.
            setAddressBookItems((prevItems) => (reset ? speedDials : [...prevItems, ...response === null || response === void 0 ? void 0 : response.speedDials]));
            if (responsePage !== undefined && totalPages !== undefined) {
                setHasNextPage(responsePage < totalPages - 1);
                setPage(responsePage);
            }
            else {
                setHasNextPage(false);
            }
            setIsNextPageLoading(false);
            if (page === 0) {
                setLoadingFirstPage(false);
            }
        })
            .catch((error) => {
            const trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error);
            if (page === 0) {
                setLoadingFirstPage(false);
                setLoadingFirstPageError({ error: true, trackingId });
            }
            else {
                setPageFetchError({ error: true, trackingId });
                setHasNextPage(true);
                setIsNextPageLoading(false);
            }
        });
    };
    const loadNextPage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isNextPageLoading) {
            return;
        }
        setIsNextPageLoading(true);
        loadPage(page + 1, searchQuery);
    });
    const isNoRecordFound = () => {
        return ((isAddressBookInfiniteScrollEnabled && addressBookItems.length === 0 && !loadingFirstPage) ||
            (!isAddressBookInfiniteScrollEnabled && filteredAddress.length === 0 && !loading));
    };
    const getLoadingError = () => {
        if (searchError && isAddressBookInfiniteScrollEnabled) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "search-block-error", style: { height } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "search-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "info-badge-filled", iconSet: "momentumDesign", size: "16", class: "search-error-info" }), i18n.searchError] })) })));
        }
        if (!loading && loadingError) {
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_9__["default"], { onRetry: retryLoadingAddressBook, trackingId: loadingTrackingId });
        }
        else if (!loadingFirstPage && loadingFirstPageError.error) {
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_9__["default"], { onRetry: () => loadPage(0, searchQuery), trackingId: loadingFirstPageError.trackingId });
        }
        else if (isNoRecordFound()) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", Object.assign({ className: "no-record", style: { height } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_6__["default"], { illustrationType: "empty-result" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", { children: i18n.noAdrFound })] }) })));
        }
        return null;
    };
    const ListItemContent = ({ data, index, style, isSelected, isFocused, onSelectValue }) => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `address-list-item address-book-increased-limit-list-item ${isSelected ? "selected" : ""} ${isFocused ? "hovered" : ""}`, style: style, onClick: () => onSelectValue(data, index) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-avatar", { size: "32", title: data.desc, class: "address-list-item-avatar" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "address-list-item-detail" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: data.desc, disabled: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-name" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_7__["default"], { text: data.desc, highlight: searchQuery }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-dn" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_7__["default"], { text: data.dn, highlight: searchQuery }) }))] }))] }), index));
    };
    const getAddressBookListComponent = () => {
        if (isNoRecordFound() || searchError) {
            return null;
        }
        if (!loading && !loadingError && !isAddressBookInfiniteScrollEnabled) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_8__["default"], Object.assign({ data: filteredAddress, customClassName: `address-book-increased-limit-list ${isConsultTransferInfiniteScrollEnabled ? "set-focus-visible" : ""}`, height: height, itemHeight: 48, onSelectValue: handleListClick, resetFocus: resetTab, infiniteScrollEnabled: isAddressBookInfiniteScrollEnabled }, { children: (props) => {
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItemContent, Object.assign({}, props));
                } })));
        }
        else if (!loadingFirstPage && !loadingFirstPageError.error && isAddressBookInfiniteScrollEnabled) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_8__["default"], Object.assign({ data: addressBookItems, customClassName: `address-book-increased-limit-list ${isConsultTransferInfiniteScrollEnabled ? "set-focus-visible" : ""}`, height: height, itemHeight: 48, resetFocus: resetTab, onSelectValue: handleListClick, hasNextPage: hasNextPage, isNextPageLoading: isNextPageLoading, loadNextPage: loadNextPage, pageFetchError: pageFetchError, infiniteScrollEnabled: isAddressBookInfiniteScrollEnabled }, { children: (props) => {
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItemContent, Object.assign({}, props));
                } })));
        }
        return null;
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: (_styles_css__WEBPACK_IMPORTED_MODULE_11___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `address-list address-book-increased-limit ${isAdhocDialingEnabled ? "adr-list-ht-od-dis-outdial-ani" : "adr-list-ht-outdial-ani"} ${(!isAddressBookInfiniteScrollEnabled && loadingError) ||
                    (isAddressBookInfiniteScrollEnabled && (loadingFirstPageError === null || loadingFirstPageError === void 0 ? void 0 : loadingFirstPageError.error))
                    ? "address-book-loading-error"
                    : ""}` }, { children: [((!isAddressBookInfiniteScrollEnabled && loading) ||
                        (isAddressBookInfiniteScrollEnabled && loadingFirstPage)) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-book-increased-limit__loading", style: { height } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "56" }) }))), getAddressBookListComponent(), getLoadingError()] })) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AddressBookIncreasedLimit);


/***/ }),

/***/ "./src/direflow-components/AddressBookIncreasedLimit/components/OrgDetails/OrgDetails.css":
/*!************************************************************************************************!*\
  !*** ./src/direflow-components/AddressBookIncreasedLimit/components/OrgDetails/OrgDetails.css ***!
  \************************************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!./OrgDetails.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AddressBookIncreasedLimit/components/OrgDetails/OrgDetails.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/AddressBookIncreasedLimit/components/OrgDetails/OrgDetails.tsx":
/*!************************************************************************************************!*\
  !*** ./src/direflow-components/AddressBookIncreasedLimit/components/OrgDetails/OrgDetails.tsx ***!
  \************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _Common_components_MSTAvatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Common/components/MSTAvatar */ "./src/direflow-components/Common/components/MSTAvatar/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Utility_Utils_MSFTavatarUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Utility/Utils/MSFTavatarUtils */ "./src/direflow-components/Utility/Utils/MSFTavatarUtils.ts");
/* harmony import */ var _OrgDetails_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./OrgDetails.css */ "./src/direflow-components/AddressBookIncreasedLimit/components/OrgDetails/OrgDetails.css");
/* harmony import */ var _OrgDetails_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_OrgDetails_css__WEBPACK_IMPORTED_MODULE_6__);







const OrgDetails = ({ name, details, avatarImageURL, userAvailability, userActivity }) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_OrgDetails_css__WEBPACK_IMPORTED_MODULE_6___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "card" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "card-header" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "card-header-avatar" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_MSTAvatar__WEBPACK_IMPORTED_MODULE_3__["default"], { alt: name, title: name, availability: userAvailability, activity: userActivity, avatarClass: "list-item-avatar", src: avatarImageURL || "" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "card-header-title" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "card-name" }, { children: name })), userActivity && userAvailability ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "card-status" }, { children: (0,_Utility_Utils_MSFTavatarUtils__WEBPACK_IMPORTED_MODULE_5__.getUserSynchStatus)(userAvailability, userActivity) }))) : null] }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "details" }, { children: Object.keys(details).map((key) => ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "field" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "field-key" }, { children: [details[key].label, ":"] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ class: "field-value", placement: "right", message: details[key].value }, (!(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_2__.isTextOverflow)(_Common_constants__WEBPACK_IMPORTED_MODULE_4__.MAX_FIELD_VALUE_LENGTH, details[key].value) ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "span-ellipses" }, { children: details[key].value })) }))] }), key))) }))] })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrgDetails);


/***/ }),

/***/ "./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/StatusMessageTimeUtils.ts":
/*!*****************************************************************************************************************!*\
  !*** ./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/StatusMessageTimeUtils.ts ***!
  \*****************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getDateTimeString: () => (/* binding */ getDateTimeString),
/* harmony export */   is24HrFormat: () => (/* binding */ is24HrFormat)
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");

const is24HrFormat = () => {
    const currentDate = new Date().toLocaleString();
    return !currentDate.match(/am|pm/i);
};
const getDateTimeString = (timestamp) => {
    const time = luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.fromISO(timestamp);
    if (is24HrFormat()) {
        const time24hrFormat = time.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.TIME_24_SIMPLE);
        return time.hasSame(luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.now(), "day")
            ? time24hrFormat
            : `${time.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.DATE_SHORT)}, ${time24hrFormat}`;
    }
    return time.hasSame(luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.now(), "day")
        ? time.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.TIME_SIMPLE)
        : time.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.DATETIME_SHORT);
};


/***/ }),

/***/ "./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/WebexContactCard.css":
/*!************************************************************************************************************!*\
  !*** ./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/WebexContactCard.css ***!
  \************************************************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!./WebexContactCard.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/WebexContactCard.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/WebexContactCard.tsx":
/*!************************************************************************************************************!*\
  !*** ./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/WebexContactCard.tsx ***!
  \************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _Common_components_WebexAvatar_WebexAvatar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Common/components/WebexAvatar/WebexAvatar */ "./src/direflow-components/Common/components/WebexAvatar/WebexAvatar.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _StatusMessageTimeUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./StatusMessageTimeUtils */ "./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/StatusMessageTimeUtils.ts");
/* harmony import */ var _WebexContactCard_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./WebexContactCard.css */ "./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/WebexContactCard.css");
/* harmony import */ var _WebexContactCard_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_WebexContactCard_css__WEBPACK_IMPORTED_MODULE_9__);










const WebexContactCard = ({ name, details, src, presenceStatus, lastActiveTime, expiresTime, customStatusMessage }) => {
    const { webexPresenceStatus } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.useI18nContext)();
    const [presenceStatusMessage, setPresenceStatusMessage] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const getLastActiveString = (timestamp) => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!timestamp) {
            return "";
        }
        const now = luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.now();
        const selectedTime = luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.fromISO(timestamp);
        const diffInMins = Math.round((_b = (_a = now.diff(selectedTime, ["minutes"]).toObject()) === null || _a === void 0 ? void 0 : _a.minutes) !== null && _b !== void 0 ? _b : 0);
        const diffInHrs = Math.round((_d = (_c = now.diff(selectedTime, ["hours"]).toObject()) === null || _c === void 0 ? void 0 : _c.hours) !== null && _d !== void 0 ? _d : 0);
        if (diffInMins < 5) {
            return webexPresenceStatus.lastActiveFewMinutesAgo;
        }
        if (diffInMins <= 59) {
            return (_e = webexPresenceStatus.lastActiveMinutesAgo) === null || _e === void 0 ? void 0 : _e.replace("{min}", diffInMins);
        }
        if (diffInHrs === 1) {
            return webexPresenceStatus.lastActive1HourAgo;
        }
        if (diffInHrs < 24) {
            return (_f = webexPresenceStatus.lastActiveHoursAgo) === null || _f === void 0 ? void 0 : _f.replace("{hour}", diffInHrs);
        }
        if (diffInHrs > 24 && diffInHrs < 48) {
            return webexPresenceStatus.lastActiveYesterday;
        }
        return (_g = webexPresenceStatus.lastActiveOnDate) === null || _g === void 0 ? void 0 : _g.replace("{date}", selectedTime.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.DATE_SHORT));
    };
    function buildMessage(prop, expiresTime, presenceStatus) {
        return expiresTime
            ? prop === null || prop === void 0 ? void 0 : prop.replace("{date}", (0,_StatusMessageTimeUtils__WEBPACK_IMPORTED_MODULE_8__.getDateTimeString)(expiresTime))
            : webexPresenceStatus[`${presenceStatus}`];
    }
    const getPresenceStatusMessage = () => {
        if (presenceStatus === "active" ||
            presenceStatus === "call" ||
            presenceStatus === "meeting" ||
            presenceStatus === "calendarItem" ||
            presenceStatus === "presenting") {
            return webexPresenceStatus[`${presenceStatus}`];
        }
        if (presenceStatus === "inactive" && lastActiveTime) {
            return getLastActiveString(lastActiveTime);
        }
        if (presenceStatus === "dnd") {
            return buildMessage(webexPresenceStatus.dndUntil, expiresTime, presenceStatus);
        }
        if (presenceStatus === "quiet") {
            return buildMessage(webexPresenceStatus.quietUntil, expiresTime, presenceStatus);
        }
        if (presenceStatus === "busy") {
            return buildMessage(webexPresenceStatus.busyUntil, expiresTime, presenceStatus);
        }
        if (presenceStatus === "ooo") {
            return buildMessage(webexPresenceStatus.outOfOfficeUntil, expiresTime, presenceStatus);
        }
        return "";
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        setPresenceStatusMessage(getPresenceStatusMessage());
    }, [presenceStatus]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_WebexContactCard_css__WEBPACK_IMPORTED_MODULE_9___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "card" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "card-header" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "card-header-avatar" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_WebexAvatar_WebexAvatar__WEBPACK_IMPORTED_MODULE_6__["default"], { name: name, src: src, presence: presenceStatus }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "card-header-title" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "card-name" }, { children: name })), presenceStatus && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ class: "card-status", placement: "right", message: presenceStatusMessage }, (!(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.isTextOverflow)(_Common_constants__WEBPACK_IMPORTED_MODULE_7__.MAX_FIELD_VALUE_LENGTH, presenceStatusMessage) ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ellipses header-ellipses" }, { children: presenceStatusMessage })) }))), customStatusMessage && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ class: "card-custom-status", placement: "right", message: customStatusMessage }, (!(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.isTextOverflow)(_Common_constants__WEBPACK_IMPORTED_MODULE_7__.MAX_FIELD_VALUE_LENGTH, customStatusMessage) ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ellipses header-ellipses" }, { children: customStatusMessage })) })))] }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "details" }, { children: Object.keys(details).map((key) => ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "field" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "field-key" }, { children: [details[key].label, ":"] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ class: "field-value", placement: "right", message: details[key].value }, (!(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.isTextOverflow)(_Common_constants__WEBPACK_IMPORTED_MODULE_7__.MAX_FIELD_VALUE_LENGTH, details[key].value) ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ellipses span-ellipses" }, { children: details[key].value })) }))] }), key))) }))] })) })));
};
WebexContactCard.defaultProps = {
    presenceStatus: undefined,
    lastActiveTime: undefined,
    expiresTime: undefined,
    customStatusMessage: undefined
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WebexContactCard);


/***/ }),

/***/ "./src/direflow-components/AddressBookIncreasedLimit/styles.css":
/*!**********************************************************************!*\
  !*** ./src/direflow-components/AddressBookIncreasedLimit/styles.css ***!
  \**********************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../node_modules/css-loader/dist/cjs.js!./styles.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AddressBookIncreasedLimit/styles.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/AgentProfile/DefaultAgentProfileProps.ts":
/*!**************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/DefaultAgentProfileProps.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const AgentProfileProperties = {
    agentname: "",
    agentid: "",
    agentphoto: undefined,
    teamname: "",
    teamid: "",
    dnnumber: "",
    channels: {
        emailcount: 0,
        voicecount: 0,
        chatcount: 0,
        socialcount: 0
    },
    agentstatus: "Available",
    tasklistlength: 0,
    profileType: "BLENDED",
    themeswitchenabled: false,
    darktheme: false,
    keyboardShortcutKeyConflict: false,
    isWebRTCEnabled: false,
    selectedRoleName: "",
    isExtension: false,
    usesOtherDN: false,
    userRole: [],
    monitoringEnabled: false,
    agentDbId: "",
    engagedState: false,
    dialNumberValueForNonUS: "",
    defaultDn: "",
    isDefaultDnSet: false,
    isManagedTeamsEnabled: false,
    managedTeams: [],
    isManagedTeamsError: false,
    isManagedTeamLoading: false,
    isMicAccessDenied: false,
    deviceType: undefined,
    selectedInputDeviceId: "",
    selectedOutputDeviceId: "",
    loginVoiceOptions: [],
    microsoftAuthConfig: {
        isEnabled: false,
        isAuthenticated: false
    },
    presenceServiceStatus: {
        serviceStatus: "",
        trackingId: ""
    },
    collabDetails: {
        collabToolInSync: "",
        displayUserDetails: false,
        stateSynchronization: false
    },
    isDesktopEmergencyNotificationEnabled: false,
    isDesktopEnhancedSignInEnabled: false,
    isDesktopManagedFilterInfScrollingEnabled: false,
    isUploadLogsToWebexEnabled: false,
    isPersonalGreetingsEnabled: false
};
const AgentProfilePropertiesWrapper = {
    profileProps: AgentProfileProperties
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AgentProfilePropertiesWrapper);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/ChannelCapacity/index.tsx":
/*!***********************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/ChannelCapacity/index.tsx ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");

/* eslint-disable default-case */



const ChannelCapacity = ({ channels, profileType }) => {
    const { agentProfile } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.useI18nContext)();
    const [routingProfile, setRoutingProfile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(agentProfile.blendedRouting);
    const [routingProfileTooltip, setRoutingProfileTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(agentProfile.blendedRoutingTooltip);
    const badgeDisablededBg = "var(--md-button-disabled-bg-color)";
    const badgeDisabledText = "var(--md-button-disabled-text-color)";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        switch (profileType) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_3__.PROFILE_ROUTING_MODES.BLENDED:
                setRoutingProfile(agentProfile.blendedRouting);
                setRoutingProfileTooltip(agentProfile.blendedRoutingTooltip);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_3__.PROFILE_ROUTING_MODES.EXCLUSIVE:
                setRoutingProfile(agentProfile.exclusiveRouting);
                setRoutingProfileTooltip(agentProfile.exclusiveRoutingTooltip);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_3__.PROFILE_ROUTING_MODES.REALTIME:
                setRoutingProfile(agentProfile.realtimeRouting);
                setRoutingProfileTooltip(agentProfile.realtimeRoutingTooltip);
                break;
        }
    }, [profileType, agentProfile]);
    const getBadgeWrapperAriaLabel = () => {
        return `${agentProfile.voice} ${channels.voicecount} ${agentProfile.chat} 
    ${channels.chatcount} ${agentProfile.email} ${channels.emailcount} 
    ${agentProfile.social} ${channels.socialcount} `;
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-channel-capacity-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-label sub-header" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", Object.assign({ className: "heading" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: agentProfile.ChannelCapacity }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "routing-type" }, { children: [routingProfile, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: routingProfileTooltip }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { tabIndex: 0, ariaLabel: routingProfileTooltip, name: "info-badge-filled", size: "16", iconSet: "momentumDesign" }) }))] }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "badge-wrapper", tabIndex: 0, "aria-label": getBadgeWrapperAriaLabel() }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ class: "badge", rounded: true, color: channels.voicecount ? "green" : "", bgColor: channels.voicecount ? undefined : badgeDisablededBg, textColor: channels.voicecount ? undefined : badgeDisabledText }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "badge-content" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { ariaHidden: "true", name: "handset-filled", size: "16", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: agentProfile.voice })] }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "capacity" }, { children: channels.voicecount }))] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ class: "badge", rounded: true, color: channels.chatcount ? "blue" : "", bgColor: channels.chatcount ? undefined : badgeDisablededBg, textColor: channels.chatcount ? undefined : badgeDisabledText }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "badge-content" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { ariaHidden: "true", name: "chat-filled", size: "16", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: agentProfile.chat })] }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "capacity" }, { children: channels.chatcount }))] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ class: "badge", rounded: true, color: channels.emailcount ? "purple" : "", bgColor: channels.emailcount ? undefined : badgeDisablededBg, textColor: channels.emailcount ? undefined : badgeDisabledText }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "badge-content" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { ariaHidden: "true", name: "email-filled", size: "16", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: agentProfile.email })] }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "capacity" }, { children: channels.emailcount }))] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ class: "badge", rounded: true, color: channels.socialcount ? "cyan" : "", bgColor: channels.socialcount ? undefined : badgeDisablededBg, textColor: channels.socialcount ? undefined : badgeDisabledText }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "badge-content" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { ariaHidden: "true", name: "share-c-native-adr-filled", size: "16", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: agentProfile.social })] }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "capacity" }, { children: channels.socialcount }))] })) }))] }))] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ChannelCapacity);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/Menu/index.tsx":
/*!************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/Menu/index.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _assets_warning_badge_filled_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../assets/warning-badge-filled.svg */ "./src/assets/warning-badge-filled.svg");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_components_EmergencyNotificationModal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Common/components/EmergencyNotificationModal */ "./src/direflow-components/Common/components/EmergencyNotificationModal/index.tsx");
/* harmony import */ var _Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Common/components/ErrorModal */ "./src/direflow-components/Common/components/ErrorModal/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../styles.css */ "./src/direflow-components/AgentProfile/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _MenuContent__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../MenuContent */ "./src/direflow-components/AgentProfile/components/MenuContent/index.tsx");
/* harmony import */ var _MenuContent_PaginatedManagedTeams_PaginatedManagedTeams__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../MenuContent/PaginatedManagedTeams/PaginatedManagedTeams */ "./src/direflow-components/AgentProfile/components/MenuContent/PaginatedManagedTeams/PaginatedManagedTeams.tsx");
/* harmony import */ var _NotificationSettingsBar_NotificationSettingsBar__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../NotificationSettingsBar/NotificationSettingsBar */ "./src/direflow-components/AgentProfile/components/NotificationSettingsBar/NotificationSettingsBar.tsx");
/* harmony import */ var _NotificationSettingsBar_NotificationSettingsBarSound__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../NotificationSettingsBar/NotificationSettingsBarSound */ "./src/direflow-components/AgentProfile/components/NotificationSettingsBar/NotificationSettingsBarSound.tsx");
/* harmony import */ var _ProfileSettings_ProfileSettings__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../ProfileSettings/ProfileSettings */ "./src/direflow-components/AgentProfile/components/ProfileSettings/ProfileSettings.tsx");
/* harmony import */ var _SpeakerMicSettings_speakerMicrophoneComponent__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../SpeakerMicSettings/speakerMicrophoneComponent */ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/speakerMicrophoneComponent.tsx");
/* harmony import */ var _TeamsList_TeamMenuItem__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../TeamsList/TeamMenuItem */ "./src/direflow-components/AgentProfile/components/TeamsList/TeamMenuItem.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

/* eslint-disable no-nested-ternary */






















const defaultCountryCodeValue = "+1"; // initial country code of US.
const defaultCountryCallingCode = "+1, United States of America, US";
const MenuComponent = ({ agentname, agentid, agentphoto, teamname, teamid, dnnumber, channels, agentstatus, tasklistlength, profileType, themeswitchenabled, darktheme, visualRebrandNewLookToggleEnabled, keyboardShortcutKeyConflict, isWebRTCEnabled, isMicAccessDenied, deviceType, selectedInputDeviceId, selectedOutputDeviceId, selectedRoleName, isExtension, availableExtensions, dialPlan, usesOtherDN, userRole, monitoringEnabled, engagedState, dialNumberValueForNonUS, defaultDn, isDefaultDnSet, managedTeams, isManagedTeamLoading, isManagedTeamsError, loginVoiceOptions, webRtcStatus, microsoftAuthConfig, presenceServiceStatus, collabDetails, isDesktopEmergencyNotificationEnabled, isEmergencyModalAlreadyDisplayed, isSuppressWebexCallingNotificationEnabled, isConsultTransferInfiniteScrollEnabled, agentDbId, isDesktopEnhancedSignInEnabled, isDesktopManagedFilterInfScrollingEnabled, isUploadLogsToWebexEnabled, isPersonalGreetingsEnabled }) => {
    var _a, _b, _c;
    const DEFAULT_AVATAR_SIZE = 36;
    const MANAGED_TEAMS_CLASS = ".user-profile-section .managed-teams md-link";
    const PROFILE_SETTINGS_CLASS = ".user-profile-section .profile-settings-container md-link";
    const NAVIGATION_SETTINGS_CLASS = "md-link.notification-settings-btn";
    const WARNING_BADGE_SVG = _assets_warning_badge_filled_svg__WEBPACK_IMPORTED_MODULE_7__["default"];
    const { agentProfile, notificationLables, common, emergencyServiceNotification } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_9__.useI18nContext)();
    const dispatch = (0,react__WEBPACK_IMPORTED_MODULE_6__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.EventContext);
    const [errorModalState, setErrorModalState] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [notificationModalState, setNotificationModalState] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [signoutModalState, setSignoutModalState] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const menuElm = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const profileSettingsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const notificationSettingsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const personalGreetingsSettingsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const teamChangeSettingsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const profileChangeSettingsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const manageProfileChangeRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const notificationTitleRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const personalGreetingsTitleRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const speakerMicTitleRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const speakerMicSettingsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const [isSpeakerMic, setIsSpeakerMic] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [isSettingsPage, setIsSettingsPage] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [isPersonalGreetingsSettingsPage, setIsPersonalGreetingsSettingsPage] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [isTeamChangePage, setIsTeamChangePage] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [slide, setSlide] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const [isLayoutErrorModal, setIsLayoutErrorModal] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [isChangeTeamModal, setIsChangeTeamModal] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [isAgentProfileModelOpen, setIsAgentProfileModelOpen] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [notificationTitleOverflow, setNotificationTitleOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [personalGreetingsTitleOverflow, setPersonalGreetingsTitleOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [selectedIndex, setSelectedIndex] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0);
    const [selectedTeamDetails, setSelectedTeamDetails] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({
        teamName: teamname,
        teamId: teamid
    });
    const searchInputRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const teamListRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const menuTriggerRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const homeMenuRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const [isFetchPreferencesInProgress, setIsFetchPreferencesInProgress] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const slideAnimationTime = 300;
    const [isProfileUpdatePage, setIsProfileUpdatePage] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [isManagedTeamsView, setIsManagedTeamsView] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [isChangeProfileModal, setIsChangeProfileModal] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [isSaveClicked, setIsSaveClicked] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [userPreferences, setUserPreferences] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null);
    const [shouldFocusStateSelectorFlag, setShouldFocusStateSelectorFlag] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(true);
    const phoneFormats = {
        international: "International",
        other: "Other"
    };
    const userProfileComponentRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const profileInitialObject = {
        roles: selectedRoleName ? selectedRoleName.split("_") : [],
        teamName: teamname || null,
        teamId: teamid || null,
        dnNumber: dnnumber,
        isExtension: false,
        usesOtherDN,
        dialNumberValueForNonUS,
        extensionNumber: "",
        defaultDn,
        isDefaultDnSet: false,
        isInternational: false,
        phoneNumber: "",
        countryCallingCode: "",
        countryCodeValue: "",
        deviceType,
        isEmergencyModalAlreadyDisplayed,
        isConsultTransferInfiniteScrollEnabled
    };
    const [selectedProfileSettings, setSelectedProfileSettings] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(profileInitialObject);
    const [selectedProfileSettingsCopy, setSelectedProfileSettingsCopy] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(profileInitialObject);
    const [profileSettingsFieldsEmptyCheck, setProfileSettingsFieldsEmptyCheck] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(true);
    const [filteredTeamList, setFilteredTeamList] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([{ teamName: "", teamId: "" }]);
    const [searchQuery, setSearchQuery] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const userRoleString = userRole && userRole.length > 0 ? userRole.join("_") : "";
    const userRoleRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(userRoleString);
    const focusOnElemTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const buttonFocusTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const teamChangeSettingTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const navigateTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const linkFocusTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const handleBackTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const focusOnBackButtonTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const focusOnModalCloseTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    userRoleRef.current = userRoleString;
    // Paginated Managed Teams
    const [paginatedManagedTeamsList, setPaginatedManagedTeamsList] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]);
    const [paginatedManagedTeamsMeta, setPaginatedManagedTeamsMeta] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({
        page: 0,
        totalPages: 0,
        orgid: "",
        pageSize: 0,
        totalRecords: 0
    });
    const [isPaginatedManagedTeamsLoading, setIsPaginatedManagedTeamsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [isPaginatedManagedTeamsError, setIsPaginatedManagedTeamsError] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const errorModalCallback = () => {
        setSignoutModalState(false);
        setErrorModalState(false);
        handleFocusOnModalClose();
    };
    const profileHandler = (event, option) => {
        if (option && option.value && option.value === "signout") {
            if (tasklistlength === 0) {
                setSignoutModalState(true);
            }
            else {
                setErrorModalState(true);
            }
        }
        else {
            // create modal for settings option
        }
    };
    const isHomeMenu = () => {
        return (!isSettingsPage &&
            !isPersonalGreetingsSettingsPage &&
            !isTeamChangePage &&
            !isFetchPreferencesInProgress &&
            !isProfileUpdatePage &&
            !isManagedTeamsView &&
            !isSpeakerMic);
    };
    const updateSignOutByUi = (isSignedOut) => {
        const event = new CustomEvent("ax-aqm-signout-by-ui", {
            detail: { isSignedOut },
            bubbles: true,
            composed: true
        });
        if (dispatch) {
            dispatch(event);
        }
    };
    const signOut = () => {
        var _a, _b, _c, _d;
        updateSignOutByUi(true);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.SIGN_OUT, [
            (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral,
            (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus
        ]);
        const logoutResponse = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.agent.logout({
            data: { logoutReason: "User requested logout" }
        });
        logoutResponse.catch((err) => {
            var _a, _b, _c, _d;
            updateSignOutByUi(false);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.SIGN_OUT, {
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.SIGN_OUT_METHOD]: "Agent",
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                Reason: "RoutingLogoutFailure"
            }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus]);
            _sdk__WEBPACK_IMPORTED_MODULE_10__.logger.error(`event=AQMLogoutFailure | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err)}] [AgentProfile:Menu] Routing logout Failed - Posted an event for CILogout ${err}`, err);
        });
    };
    const executeSignOutShortcut = (key) => {
        if (key.data &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.SIGNOUT_KEY &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
            if (tasklistlength === 0) {
                setSignoutModalState(true);
            }
            else {
                setErrorModalState(true);
            }
        }
    };
    const executeMenuShortcuts = (key) => {
        if (key.data &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_USER_PROFILE_KEY &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
            menuElm.current.firstChild.click();
        }
        if (key.data &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.ENABLE_SILENT_NOTIFICATION_KEY &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
            const notificationSettings = localStorage.getItem("desktop-notification-settings");
            const notificationSettingsForUpdate = { settings: true, silent: false };
            if (notificationSettings) {
                const notification = JSON.parse(notificationSettings);
                notificationSettingsForUpdate.settings = notification.settings;
                notificationSettingsForUpdate.silent = notification.settings; // enable silentNotification only when settings enabled
            }
            const event = new CustomEvent("ax-toast-notification-settings", {
                detail: {
                    notificationEnabled: notificationSettingsForUpdate.settings,
                    silentNotificationEnabled: notificationSettingsForUpdate.silent
                }
            });
            if (dispatch) {
                dispatch(event);
            }
            localStorage.setItem("desktop-notification-settings", JSON.stringify(notificationSettingsForUpdate));
            setIsSettingsPage(true);
        }
    };
    const inputKeydownHandler = (event) => {
        const { srcEvent } = event.detail;
        if (teamListRef && teamListRef.current) {
            if (srcEvent.code === "Tab") {
                teamListRef.current.rovingPreventFocus = false;
            }
            else {
                teamListRef.current.rovingPreventFocus = true;
            }
        }
    };
    const resetTeamsFlags = () => {
        setIsTeamChangePage(false);
        setIsFetchPreferencesInProgress(false);
        setIsProfileUpdatePage(false);
        setIsManagedTeamsView(false);
    };
    const filterTeamList = (e) => {
        const searchText = e.target.value || "";
        setSearchQuery(searchText);
        if (filteredTeamList.length > 0) {
            const filteredList = filteredTeamList.filter((team) => team.teamName.toLowerCase().includes(searchText.toLowerCase()));
            setFilteredTeamList((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_14__.orderBy)(filteredList, "teamName"));
        }
    };
    const getCurrentTeam = () => {
        if (filteredTeamList.length > 0) {
            const index = filteredTeamList.findIndex((teamOption) => teamOption.teamName === teamname);
            setSelectedIndex(index);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const event = new CustomEvent("focus-visible", {
            bubbles: true,
            composed: true
        });
        if (teamListRef && teamListRef.current) {
            teamListRef.current.rovingPreventFocus = true;
            teamListRef.current.dispatchEvent(event);
        }
        if (searchInputRef && searchInputRef.current) {
            const input = searchInputRef.current;
            input.addEventListener("input-keydown", inputKeydownHandler);
            input.addEventListener("input-change", filterTeamList);
            return () => {
                input.removeEventListener("input-keydown", inputKeydownHandler);
                input.removeEventListener("input-change", filterTeamList);
            };
        }
        return () => { };
    }, [isTeamChangePage, isFetchPreferencesInProgress]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((key) => executeMenuShortcuts(key));
        return () => {
            if (stopListen) {
                stopListen();
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((key) => executeSignOutShortcut(key));
        return () => {
            if (stopListen) {
                stopListen();
            }
        };
    }, [tasklistlength]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const textContainer = notificationTitleRef === null || notificationTitleRef === void 0 ? void 0 : notificationTitleRef.current;
        let isTextOverflowing;
        if (textContainer && isSettingsPage) {
            isTextOverflowing = textContainer.offsetWidth < textContainer.scrollWidth;
        }
        setNotificationTitleOverflow(isTextOverflowing);
    }, [isSettingsPage]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const textContainer = personalGreetingsTitleRef === null || personalGreetingsTitleRef === void 0 ? void 0 : personalGreetingsTitleRef.current;
        let isTextOverflowing;
        if (textContainer && isPersonalGreetingsSettingsPage) {
            isTextOverflowing = textContainer.offsetWidth < textContainer.scrollWidth;
        }
        setPersonalGreetingsTitleOverflow(isTextOverflowing);
    }, [isPersonalGreetingsSettingsPage]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const textContainer = speakerMicTitleRef === null || speakerMicTitleRef === void 0 ? void 0 : speakerMicTitleRef.current;
        let isTextOverflowing;
        if (textContainer && isSpeakerMic) {
            isTextOverflowing = textContainer.offsetWidth < textContainer.scrollWidth;
        }
        setNotificationTitleOverflow(isTextOverflowing);
    }, [isSpeakerMic]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        setSelectedTeamDetails({ teamName: teamname, teamId: teamid });
    }, [isTeamChangePage]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const isInternationalValue = JSON.stringify(userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.isInternational)
            ? userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.isInternational
            : true; // isInternational should be true by default if there are no preferences saved
        const profileDetails = {
            // Defaulting to agent role in order to keep the Save Selection link disabled
            // as during comparison of roles in isProfileSettingNotUpdated function,
            // this.userRole is by default agent as soon as we complete Station Login.
            // Hence here if preferences are not there OR selectedrolename is null
            // (as we would have logged in with agent earlier, where selectedRoleName is not saved in Preferences),
            // we are setting roles to ['agent']
            roles: (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.selectedRoleName) ? userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.selectedRoleName.split("_") : [_constants__WEBPACK_IMPORTED_MODULE_8__.AGENT],
            teamName: teamname,
            teamId: teamid,
            dnNumber: dnnumber,
            isExtension,
            usesOtherDN,
            dialNumberValueForNonUS: defaultDn,
            extensionNumber: (isExtension && dnnumber) || defaultDn,
            defaultDn,
            isDefaultDnSet,
            isInternational: isDefaultDnSet ? false : isInternationalValue,
            phoneNumber: defaultDn,
            countryCallingCode: defaultCountryCallingCode,
            countryCodeValue: defaultCountryCodeValue,
            isRememberMyCredentials: false,
            deviceType,
            isEmergencyModalAlreadyDisplayed,
            isConsultTransferInfiniteScrollEnabled
        };
        setSelectedProfileSettingsCopy(profileDetails);
        setSelectedProfileSettings(profileDetails);
        setIsSaveClicked(false);
    }, [isProfileUpdatePage, userPreferences, filteredTeamList]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        getCurrentTeam();
    }, [filteredTeamList]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        putInitialLoadFocus();
    }, [selectedRoleName]);
    const putInitialLoadFocus = () => {
        var _a, _b, _c;
        if (shouldFocusStateSelectorFlag && selectedRoleName === _constants__WEBPACK_IMPORTED_MODULE_8__.SUPERVISOR) {
            ((_c = (_b = (_a = menuTriggerRef === null || menuTriggerRef === void 0 ? void 0 : menuTriggerRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button")) === null || _c === void 0 ? void 0 : _c.focus()) && setShouldFocusStateSelectorFlag(false);
        }
    };
    const isSupervisor = () => { var _a; return ((_a = userRoleRef.current) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_8__.SUPERVISOR; };
    const isSupervisorAndAgent = () => { var _a; return ((_a = userRoleRef.current) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_8__.AGENT_AND_SUPERVISOR; };
    const fetchManagedTeams = () => {
        if (isDesktopManagedFilterInfScrollingEnabled) {
            updatePaginatedManagedTeamsList([]);
            setIsPaginatedManagedTeamsLoading(true);
            // fetch the first page so that the preview is seen.
            fetchFirstPageManagedTeams();
        }
        else {
            const event = new CustomEvent("fetch-managed-team", {
                detail: {},
                bubbles: true,
                composed: true
            });
            if (dispatch) {
                dispatch(event);
            }
        }
    };
    const fetchFirstPageManagedTeams = () => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        const orgId = (_d = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _d === void 0 ? void 0 : _d.orgId;
        try {
            const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedTeamsList({
                orgId,
                page: 0,
                pageSize: _Common_constants__WEBPACK_IMPORTED_MODULE_13__.PAGE_SIZE,
                customFilter: "",
                supervisorView: true
            });
            updatePaginatedManagedTeamsList(response.data);
            setPaginatedManagedTeamsMeta(response.meta);
            setIsPaginatedManagedTeamsLoading(false);
            setIsPaginatedManagedTeamsError(false);
        }
        catch (error) {
            setIsPaginatedManagedTeamsLoading(false);
            setIsPaginatedManagedTeamsError(true);
            _sdk__WEBPACK_IMPORTED_MODULE_10__.logger.error(`event=FetchManagedTeamsFailure | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error)}]`, error);
        }
    });
    const openAgentProfileModel = () => {
        if (isSupervisor() || isSupervisorAndAgent()) {
            fetchManagedTeams();
        }
        setIsAgentProfileModelOpen(true);
        setIsSettingsPage(false);
        setIsPersonalGreetingsSettingsPage(false);
        resetTeamsFlags();
        setSearchQuery("");
        setFilteredTeamList(filteredTeamList);
        setIsSpeakerMic(false);
        setFocusOnElements();
    };
    const closeAgentProfileModel = () => {
        setIsAgentProfileModelOpen(false);
    };
    const clearAllTimeouts = () => {
        [
            focusOnElemTimeoutIdRef,
            buttonFocusTimeoutIdRef,
            teamChangeSettingTimeoutIdRef,
            linkFocusTimeoutIdRef,
            handleBackTimeoutIdRef,
            focusOnBackButtonTimeoutIdRef,
            focusOnModalCloseTimeoutIdRef
        ].forEach((ref) => {
            if (ref.current) {
                window.clearTimeout(ref.current);
            }
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const profileMenu = menuElm === null || menuElm === void 0 ? void 0 : menuElm.current;
        if (profileMenu) {
            profileMenu.addEventListener("menu-overlay-open", openAgentProfileModel);
            profileMenu.addEventListener("menu-overlay-close", closeAgentProfileModel);
        }
        return () => {
            if (profileMenu) {
                profileMenu.removeEventListener("menu-overlay-open", openAgentProfileModel);
                profileMenu.removeEventListener("menu-overlay-close", closeAgentProfileModel);
            }
            // Cleanup all timeouts
            clearAllTimeouts();
        };
    }, []);
    const resetFocusableElements = () => {
        var _a;
        if ((_a = menuElm === null || menuElm === void 0 ? void 0 : menuElm.current) === null || _a === void 0 ? void 0 : _a.setFocusableElements) {
            menuElm.current.setFocusableElements();
        }
    };
    const setFocusOnElements = () => {
        focusOnElemTimeoutIdRef.current = window.setTimeout(() => {
            resetFocusableElements();
            if (profileSettingsRef === null || profileSettingsRef === void 0 ? void 0 : profileSettingsRef.current) {
                const button = profileSettingsRef.current.shadowRoot.querySelector("button");
                button.focus();
            }
        }, _Common_constants__WEBPACK_IMPORTED_MODULE_13__.TIMEOUT_TEN_MS);
    };
    const setFocusIfButtonPresent = (usedVariableRef) => {
        buttonFocusTimeoutIdRef.current = window.setTimeout(() => {
            var _a;
            resetFocusableElements();
            if (usedVariableRef === null || usedVariableRef === void 0 ? void 0 : usedVariableRef.current) {
                const button = (_a = usedVariableRef.current.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("button");
                if (button) {
                    button.focus();
                }
            }
        }, _Common_constants__WEBPACK_IMPORTED_MODULE_13__.TIMEOUT_HUNDRED_FIFTY_MS);
    };
    const navigateToSettingsPage = (isSettings) => {
        setIsSettingsPage(isSettings);
        setSlide("slideOut");
        isSettings ? setFocusIfButtonPresent(notificationSettingsRef) : setFocusIfButtonPresent(profileSettingsRef);
    };
    const navigateToPersonalGreetingsSettingsPage = (isPersonalGreetingsSettings) => {
        setIsPersonalGreetingsSettingsPage(isPersonalGreetingsSettings);
        setSlide("slideOut");
        isPersonalGreetingsSettings
            ? setFocusIfButtonPresent(personalGreetingsSettingsRef)
            : setFocusIfButtonPresent(profileSettingsRef);
    };
    const navigateToSpeakerMicSettingsPage = (isSpMic) => {
        setIsSpeakerMic(isSpMic);
        setSlide("slideOut");
        isSpMic ? setFocusIfButtonPresent(speakerMicSettingsRef) : setFocusIfButtonPresent(profileSettingsRef);
    };
    const navigateToTeamChangePage = (isChangeTeam) => {
        var _a;
        setIsTeamChangePage(isChangeTeam);
        setFilteredTeamList(((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.teams) || []);
        getCurrentTeam();
        if (isChangeTeam) {
            teamChangeSettingTimeoutIdRef.current = window.setTimeout(() => {
                var _a;
                if (teamChangeSettingsRef === null || teamChangeSettingsRef === void 0 ? void 0 : teamChangeSettingsRef.current) {
                    const button = (_a = teamChangeSettingsRef.current.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("button");
                    if (button) {
                        button.focus();
                    }
                }
            }, _Common_constants__WEBPACK_IMPORTED_MODULE_13__.TIMEOUT_THOUSAND_MS);
        }
        else {
            setFocusOnElements();
        }
    };
    const resetLayout = () => {
        const event = new CustomEvent("ax-reset-layout", {
            detail: {},
            bubbles: true,
            composed: true
        });
        if (dispatch) {
            dispatch(event);
        }
        // eslint-disable-next-line @wxcc-desktop/no-blocked-words-plugin/no-blocked-words -- tech debt to rename
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.LAYOUT_SETTINGS_MASTER_RESET);
        setIsLayoutErrorModal(false);
    };
    const changeTeamHandler = () => {
        _sdk__WEBPACK_IMPORTED_MODULE_10__.logger.info("[ChangeTeam] Change Team Confirm Clicked");
        if (tasklistlength > 0) {
            const event = new CustomEvent("ax-change-team-cancelled", {
                detail: {
                    message: agentProfile.errorChangeTeams
                },
                bubbles: true,
                composed: true
            });
            if (dispatch) {
                dispatch(event);
                _sdk__WEBPACK_IMPORTED_MODULE_10__.logger.info("[ChangeTeam] ax-change-team-cancelled event dispatched");
            }
        }
        else {
            const event = new CustomEvent("ax-change-team", {
                detail: { selectedTeamDetails },
                bubbles: true,
                composed: true
            });
            if (dispatch) {
                dispatch(event);
                _sdk__WEBPACK_IMPORTED_MODULE_10__.logger.info("[ChangeTeam] ax-change-team event dispatched");
            }
        }
        setIsChangeTeamModal(false);
    };
    const showEmergencyModal = (deviceType) => {
        return (isDesktopEmergencyNotificationEnabled &&
            deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.LoginVoiceOptions.BROWSER &&
            !isEmergencyModalAlreadyDisplayed);
    };
    const changeProfileHandler = () => {
        var _a, _b, _c;
        _sdk__WEBPACK_IMPORTED_MODULE_10__.logger.info("[UpdateProfile] Update Profile Confirm Clicked");
        if (tasklistlength > 0) {
            const event = new CustomEvent("ax-update-profile-cancelled", {
                detail: {
                    message: agentProfile.errorProfileUpdate
                },
                bubbles: true,
                composed: true
            });
            if (dispatch) {
                dispatch(event);
                _sdk__WEBPACK_IMPORTED_MODULE_10__.logger.info("[UpdateProfile] ax-update-profile-cancelled event dispatched");
            }
        }
        else {
            const profileDetails = Object.assign({}, selectedProfileSettings);
            // since to the API the key sent for number is always dn
            profileDetails.dnNumber = profileDetails.isExtension
                ? (_a = profileDetails.extensionNumber) === null || _a === void 0 ? void 0 : _a.replace(/ /g, "")
                : (_b = profileDetails.dnNumber) === null || _b === void 0 ? void 0 : _b.replace(/ /g, "");
            profileDetails.dialNumberValueForNonUS = (_c = profileDetails.dialNumberValueForNonUS) === null || _c === void 0 ? void 0 : _c.replace(/ /g, "");
            if (showEmergencyModal(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.deviceType)) {
                profileDetails.isEmergencyModalAlreadyDisplayed = true;
            }
            const event = new CustomEvent("ax-update-profile", {
                detail: { profileDetails },
                bubbles: true,
                composed: true
            });
            if (dispatch) {
                dispatch(event);
                _sdk__WEBPACK_IMPORTED_MODULE_10__.logger.info("[UpdateProfile] ax-update-profile event dispatched");
            }
        }
        setIsChangeProfileModal(false);
    };
    const confirmResetLayout = (event) => {
        event.preventDefault();
        setIsLayoutErrorModal(true);
    };
    const handleClickBackToMain = (profileItem) => {
        navigateTimeoutIdRef.current = window.setTimeout(() => {
            navigateToSettingsPage(false);
            navigateToSpeakerMicSettingsPage(false);
            navigateToPersonalGreetingsSettingsPage(false);
            resetTeamsFlags();
            if (profileItem) {
                setFocusIfLinkPresent(profileItem);
            }
        }, slideAnimationTime);
        setSlide("slideIn");
    };
    const keydownBackToMain = (event, profileItem) => {
        const { key, code } = event;
        if (key === _constants__WEBPACK_IMPORTED_MODULE_8__.Key.Enter || code === _constants__WEBPACK_IMPORTED_MODULE_8__.Key.Enter || key === _constants__WEBPACK_IMPORTED_MODULE_8__.Key.Space || code === _constants__WEBPACK_IMPORTED_MODULE_8__.Key.Space) {
            handleClickBackToMain(profileItem);
        }
    };
    const handleSelectTeam = (team) => {
        setSelectedTeamDetails(team);
    };
    const setFocusIfLinkPresent = (profileItem) => {
        linkFocusTimeoutIdRef.current = window.setTimeout(() => {
            var _a, _b, _c;
            resetFocusableElements();
            const profileItemLink = (_c = (_b = (_a = homeMenuRef === null || homeMenuRef === void 0 ? void 0 : homeMenuRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(profileItem)) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("a");
            profileItemLink === null || profileItemLink === void 0 ? void 0 : profileItemLink.focus();
        }, _Common_constants__WEBPACK_IMPORTED_MODULE_13__.TIMEOUT_HUNDRED_FIFTY_MS);
    };
    const handleClickBackToProfileView = (profileItem) => {
        handleBackTimeoutIdRef.current = window.setTimeout(() => {
            navigateToSettingsPage(false);
            navigateToSpeakerMicSettingsPage(false);
            setIsProfileUpdatePage(false);
            setIsManagedTeamsView(false);
            navigateToPersonalGreetingsSettingsPage(false);
            if (profileItem) {
                setFocusIfLinkPresent(profileItem);
            }
        }, slideAnimationTime);
        setSlide("slideIn");
    };
    /**
     * Method to set focus on buttons while navigating back and forth from profile settings
     * @param isChanged
     * @param refElem
     */
    const setFocusOnBackButton = (isChanged, refElem) => {
        if (isChanged) {
            focusOnBackButtonTimeoutIdRef.current = window.setTimeout(() => {
                var _a;
                if (refElem === null || refElem === void 0 ? void 0 : refElem.current) {
                    const button = (_a = refElem.current.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("button");
                    if (button) {
                        button.focus();
                    }
                }
            }, _Common_constants__WEBPACK_IMPORTED_MODULE_13__.TIMEOUT_THOUSAND_MS);
        }
        else {
            setFocusOnElements();
        }
    };
    const navigateToProfileSettingsUpdate = (isProfileUpdate) => __awaiter(void 0, void 0, void 0, function* () {
        var _e;
        setIsProfileUpdatePage(isProfileUpdate);
        setFilteredTeamList(((_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _e === void 0 ? void 0 : _e.teams) || []);
        yield fetchSavedPreferences();
    });
    const navigateToManagedTeamsView = (view) => {
        setSlide("slideOut");
        setIsManagedTeamsView(view);
        setFocusOnBackButton(view, manageProfileChangeRef);
    };
    const onProfileSettingsUpdate = (event) => {
        setProfileSettingsFieldsEmptyCheck(event.detail.submitProperty);
        setSelectedProfileSettings(event.detail.profileDetail);
    };
    const updateAndSaveDetails = (data) => {
        const isExtension = data.loginOption === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.LoginVoiceOptions.EXTENSION;
        const isAgentDn = data.loginOption === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.LoginVoiceOptions.AGENT_DN;
        const newProfileDetails = Object.assign(Object.assign({}, selectedProfileSettings), { roles: data.role.split("_"), dnNumber: isAgentDn ? data.dialNumber : "", teamName: data.team.teamName, teamId: data.team.teamId, extensionNumber: data.extensionNumber || (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.extensionNumber) || defaultDn || "", deviceType: data.loginOption, isRememberMyCredentials: data.isRememberMeChecked, usesOtherDN,
            isExtension, phoneNumber: data.dialNumber || (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.dialNumberValueForNonUS) || defaultDn || "", dialNumberValueForNonUS: data.dialNumber || (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.dialNumberValueForNonUS) || defaultDn || "", isEmergencyModalAlreadyDisplayed });
        setSelectedProfileSettings(newProfileDetails);
        setIsChangeProfileModal(true);
    };
    const isProfileSettingNotUpdated = () => {
        const { roles = [], teamName = "", dnNumber = "", isExtension, extensionNumber = "", deviceType = "" } = selectedProfileSettings;
        const checkIfExtensionNumMatches = isExtension
            ? extensionNumber === selectedProfileSettingsCopy.extensionNumber
            : true;
        const deviceCheck = isWebRTCEnabled ? selectedProfileSettingsCopy.deviceType === deviceType : true;
        return ((selectedProfileSettingsCopy.dnNumber === dnNumber ||
            deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.LoginVoiceOptions.BROWSER) &&
            checkIfExtensionNumMatches &&
            selectedProfileSettingsCopy.isExtension === isExtension &&
            JSON.stringify(selectedProfileSettingsCopy.roles) === JSON.stringify(roles) &&
            selectedProfileSettingsCopy.teamName === teamName &&
            deviceCheck);
    };
    const isSaveProfileDisabled = isProfileSettingNotUpdated() || profileSettingsFieldsEmptyCheck;
    const isSaveTeamDisabled = selectedTeamDetails.teamName === teamname;
    const saveTeamSelected = (event) => {
        event.preventDefault();
        if (!isSaveTeamDisabled) {
            setIsChangeTeamModal(true);
        }
    };
    const saveProfileUpdates = (event) => {
        event.preventDefault();
        if (!isSaveProfileDisabled) {
            setIsSaveClicked(true);
        }
    };
    const getUserStoredPreferences = () => {
        return sessionStorage.getItem(_Common_constants__WEBPACK_IMPORTED_MODULE_13__.USER_PREFERENCE);
    };
    const fetchSavedPreferences = () => __awaiter(void 0, void 0, void 0, function* () {
        var _f;
        let isPreferenceSaved;
        setIsFetchPreferencesInProgress(true);
        try {
            const userStoredPreferences = getUserStoredPreferences();
            const userPreferences = userStoredPreferences
                ? JSON.parse(userStoredPreferences)
                : yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.userPrefs.fetchUserPreferences({
                    orgId: ((_f = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _f === void 0 ? void 0 : _f.orgId) || "",
                    userId: agentid
                });
            if (!getUserStoredPreferences()) {
                const event = new CustomEvent("update-user-preference-storage", {
                    detail: userPreferences,
                    bubbles: true,
                    composed: true
                });
                if (dispatch) {
                    dispatch(event);
                }
            }
            _sdk__WEBPACK_IMPORTED_MODULE_10__.logger.info("event=userPreferencesFetchSuccess | fetching User Preferences Success : ", userPreferences);
            if (userPreferences) {
                isPreferenceSaved = true;
                const desktopPreference = JSON.parse(userPreferences.desktopPreference);
                if (desktopPreference) {
                    selectedRoleName = desktopPreference.selectedRoleName || "";
                    setUserPreferences(desktopPreference);
                }
            }
            else {
                isPreferenceSaved = false;
            }
        }
        catch (error) {
            isPreferenceSaved = false;
            setUserPreferences(null);
            _sdk__WEBPACK_IMPORTED_MODULE_10__.logger.error("event=userPreferencesFetchFailed | fetching User Preferences Error : ", error);
            const event = new CustomEvent("save-update-user-prefs-failed", {
                detail: { isPrefSaved: isPreferenceSaved },
                bubbles: true,
                composed: true
            });
            if (dispatch) {
                dispatch(event);
            }
        }
        // Updating this flag here to know if preferences are already saved or not.
        // Using this flag to perform save/update action when called from user station login & user profile settings
        const event = new CustomEvent("update-flag-user-prefs-saved", {
            detail: { isPrefSaved: isPreferenceSaved },
            bubbles: true,
            composed: true
        });
        if (dispatch) {
            dispatch(event);
        }
        setIsFetchPreferencesInProgress(false);
    });
    const onProfileSettingsValidationsCheck = (event) => {
        if (event.detail.isValid) {
            setIsChangeProfileModal(true);
        }
        setIsSaveClicked(false);
    };
    const getAvatarVariant = (engagedState, agentstatus) => {
        return engagedState && agentstatus !== _Common_constants__WEBPACK_IMPORTED_MODULE_13__.RONA
            ? "engaged"
            : agentstatus === _Common_constants__WEBPACK_IMPORTED_MODULE_13__.AVAILABLE
                ? "active"
                : agentstatus === _Common_constants__WEBPACK_IMPORTED_MODULE_13__.RONA
                    ? "rona"
                    : "idle";
    };
    const isWebRTCDisconnected = () => {
        return webRtcStatus === _Common_constants__WEBPACK_IMPORTED_MODULE_13__.WEB_RTC_STATUS.WEB_RTC_DISCONNECTED;
    };
    const isWebRTCRegistering = () => {
        return webRtcStatus === _Common_constants__WEBPACK_IMPORTED_MODULE_13__.WEB_RTC_STATUS.WEB_RTC_REGISTERING;
    };
    const isWebRTCBrowser = () => {
        return isWebRTCEnabled && deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.LoginVoiceOptions.BROWSER;
    };
    // eslint-disable-next-line consistent-return
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        if (userProfileComponentRef && userProfileComponentRef.current) {
            const userProfile = userProfileComponentRef.current;
            userProfile.addEventListener("on-component-update", onProfileSettingsUpdate);
            userProfile.addEventListener("profile-settings-invalid-data", onProfileSettingsValidationsCheck);
            window.addEventListener("alert-close", handleFocusOnAlertClose);
            return () => {
                userProfile.removeEventListener("on-component-update", onProfileSettingsUpdate);
                userProfile.removeEventListener("profile-settings-invalid-data", onProfileSettingsValidationsCheck);
                window.removeEventListener("alert-close", handleFocusOnAlertClose);
            };
        }
        // Return a no-op function if there are no event listeners to clean up
        return () => { };
    }, [isProfileUpdatePage, isFetchPreferencesInProgress]);
    const getPhoneFormat = () => {
        /** International checkbox should be unchecked if
         * 1. If isInternational is false in preferences
         * 2. If Force Default DN is set
         * 3. If no preference and defaultDn is set
         * International checkbox should be checked
         * 1. By default if there are no preferences
         * 2. If isInternational is true in preferences
         * */
        if ((!userPreferences && (defaultDn === null || defaultDn === void 0 ? void 0 : defaultDn.length) > 0) ||
            (userPreferences && !(userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.isInternational)) ||
            isDefaultDnSet) {
            return phoneFormats.other;
        }
        return phoneFormats.international;
    };
    const handleFocusOnAlertClose = () => {
        var _a, _b, _c;
        // this is in the case when the StateSelector is not presant.
        if (selectedRoleName === _constants__WEBPACK_IMPORTED_MODULE_8__.SUPERVISOR) {
            (_c = (_b = (_a = menuTriggerRef === null || menuTriggerRef === void 0 ? void 0 : menuTriggerRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.children[0]) === null || _c === void 0 ? void 0 : _c.focus();
        }
    };
    const getDeviceType = () => {
        if (deviceType) {
            return deviceType === null || deviceType === void 0 ? void 0 : deviceType.toUpperCase();
        }
        return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.LoginVoiceOptions.AGENT_DN;
    };
    const getDefaultExtension = () => {
        if (isDefaultDnSet) {
            return defaultDn;
        }
        if (isExtension) {
            return dnnumber;
        }
        return (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.extensionNumber) || defaultDn;
    };
    const getDefaultDialNumber = () => {
        if (isDefaultDnSet) {
            return defaultDn;
        }
        if (deviceType === "AGENT_DN") {
            return dnnumber;
        }
        return (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.dialNumberValueForNonUS) || defaultDn;
    };
    const getHasNextPage = () => {
        if (!paginatedManagedTeamsMeta) {
            return false;
        }
        const { page, totalPages } = paginatedManagedTeamsMeta;
        return page < totalPages - 1;
    };
    const updatePaginatedManagedTeamsList = (updatedList) => {
        setPaginatedManagedTeamsList(updatedList);
    };
    const editUserProfileSection = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `menu-overlay-container ${slide}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-header-left" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ref: profileChangeSettingsRef, class: "arrow-icon-back profile-back-arrow", ariaLabel: agentProfile.arrowLabel, hasRemoveStyle: true, onClick: () => handleClickBackToProfileView(PROFILE_SETTINGS_CLASS), onKeyDown: (e) => keydownBackToMain(e, PROFILE_SETTINGS_CLASS), "data-testid": "profile-back-button" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: "icon-arrow-tail-down_14" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: agentProfile.profileSettings }, (!notificationTitleOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "value-ellipsis", id: "profile-settings-header", ref: notificationTitleRef }, { children: agentProfile.profileSettings })) }))] })), isFetchPreferencesInProgress && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "profile-loader" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "60" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "loading-text" }, { children: common.loadingMsg }))] }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "profile-container" }, { children: [!isFetchPreferencesInProgress &&
                        (!isDesktopEnhancedSignInEnabled ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("agentx-wc-user-profile", Object.assign({ ref: userProfileComponentRef, selectedRoleName: userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.selectedRoleName, teamName: userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.teamName, teamId: userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.teamId }, ((userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.isExtension) ? { isExtensionUsedFromProfile: true } : ""), (usesOtherDN ? { usesOtherDNFromProfile: true } : ""), (monitoringEnabled ? { isMonitoringEnabledFromProfile: true } : ""), (isDefaultDnSet ? { isDefaultDnSetFromProfile: true } : ""), (isSaveClicked ? { isSubmitProfile: true } : ""), { userRole: userRole && userRole.length > 0 ? userRole.join("_") : "", filteredTeamList: JSON.stringify(filteredTeamList), teamsMeta: JSON.stringify(((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.teamsMeta) || {}), extensionNumber: isDefaultDnSet ? defaultDn : (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.extensionNumber) || defaultDn, dialNumberValueForNonUS: isDefaultDnSet ? defaultDn : (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.dialNumberValueForNonUS) || defaultDn, defaultDn: defaultDn, isInternationalFromProfile: isDefaultDnSet
                                ? JSON.stringify(false)
                                : (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.isInternational)
                                    ? JSON.stringify(userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.isInternational)
                                    : JSON.stringify(true), phoneNumber: (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.isInternational) ? userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.internationalPhoneNumber : defaultDn, phoneFormat: getPhoneFormat(), countryCallingCode: userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.countryCallingCode, countryCodeValue: userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.countryCodeValue, isRememberMyCredentials: userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.isRememberMyCredentials }, (isWebRTCEnabled ? { isWebRTCEnabled: true } : ""), { loginVoiceOptions: JSON.stringify(loginVoiceOptions), deviceType: deviceType, agentDbId: agentDbId, orgId: (_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _b === void 0 ? void 0 : _b.orgId }, (isEmergencyModalAlreadyDisplayed ? { isEmergencyModalAlreadyDisplayed: true } : ""), (isConsultTransferInfiniteScrollEnabled ? { isConsultTransferInfiniteScrollEnabled: true } : "")))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProfileSettings_ProfileSettings__WEBPACK_IMPORTED_MODULE_20__["default"], { userRole: userRole, selectedRoleName: selectedRoleName, teamName: teamname || (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.teamName), teamId: teamid || (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.teamId), teams: filteredTeamList, voiceOptions: loginVoiceOptions !== null && loginVoiceOptions !== void 0 ? loginVoiceOptions : [], initialLoginOption: getDeviceType(), isRememberMyCredentials: (_c = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.isRememberMyCredentials) !== null && _c !== void 0 ? _c : false, isMonitoringEnabled: monitoringEnabled, isDefaultDnSet: isDefaultDnSet, defaultExtension: getDefaultExtension(), defaultNumber: getDefaultDialNumber(), availableExtensions: availableExtensions, dialPlan: dialPlan, sendAllUpdates: updateAndSaveDetails }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: `menu-footer menu-footer-profile ${isSaveProfileDisabled ? "disabled" : ""}` }, { children: !isDesktopEnhancedSignInEnabled && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-link", Object.assign({ "data-testid": "save-profile-updated-link", ariaLabel: agentProfile.saveSelection, onClick: saveProfileUpdates, "aria-disabled": isSaveProfileDisabled ? "true" : "", ariaRole: "button" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "check_16" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "save-profile-btn" }, { children: agentProfile.saveSelection }))] }))) }))] }))] })));
    const renderManagedTeamsContainer = () => {
        return isDesktopManagedFilterInfScrollingEnabled ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MenuContent_PaginatedManagedTeams_PaginatedManagedTeams__WEBPACK_IMPORTED_MODULE_17__["default"], { managedTeams: paginatedManagedTeamsList, hasNextPage: getHasNextPage() })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "managed-teams-container", id: "managed-teams-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", Object.assign({ className: "manged-teams-list" }, { children: managedTeams && managedTeams.map((team) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", { children: team.teamName })) })) })));
    };
    const viewManagedTeams = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `menu-overlay-container ${slide}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-header-left" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ "data-testid": "managed-teams-back-button", ref: manageProfileChangeRef, class: "arrow-icon-back", ariaLabel: agentProfile.arrowLabel, hasRemoveStyle: true, onClick: () => handleClickBackToProfileView(MANAGED_TEAMS_CLASS), onKeyDown: (e) => keydownBackToMain(e, MANAGED_TEAMS_CLASS) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: "icon-arrow-tail-down_14" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ role: "heading", message: agentProfile.managedTeams }, (!notificationTitleOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "value-ellipsis", id: "managed-teams-header", ref: notificationTitleRef }, { children: agentProfile.managedTeams })) }))] })), renderManagedTeamsContainer()] })));
    const getManagedTeamsArray = () => isDesktopManagedFilterInfScrollingEnabled ? paginatedManagedTeamsList : managedTeams;
    const getManagedTeamsLoading = () => isDesktopManagedFilterInfScrollingEnabled ? isPaginatedManagedTeamsLoading : isManagedTeamLoading;
    const getManagedTeamsError = () => isDesktopManagedFilterInfScrollingEnabled ? isPaginatedManagedTeamsError : isManagedTeamsError;
    const renderHomeMenu = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ ref: homeMenuRef, className: "menu-overlay-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "menu-header" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ref: profileSettingsRef, onClick: (e) => profileHandler(e, { value: "signout" }), onKeydown: (e) => profileHandler(e, { value: "signout" }), ariaLabel: agentProfile.signOut, "data-testid": "signoutButton", variant: "secondary", size: "28" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "profile-signout" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { iconSet: "momentumDesign", name: "sign-out-bold" }), agentProfile.signOut] })) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MenuContent__WEBPACK_IMPORTED_MODULE_16__["default"], { agentName: agentname, agentStatus: agentstatus, agentPhoto: agentphoto, teamName: teamname, dnNumber: dnnumber, channels: channels, profileType: profileType, themeSwitchEnabled: themeswitchenabled, darkTheme: darktheme, navigateToSettingsPage: navigateToSettingsPage, navigateToPersonalGreetingsSettingsPage: navigateToPersonalGreetingsSettingsPage, navigateToSpeakerMicSettingsPage: navigateToSpeakerMicSettingsPage, navigateToTeamChangePage: navigateToTeamChangePage, keyboardShortcutKeyConflict: keyboardShortcutKeyConflict, confirmResetLayout: confirmResetLayout, isVisible: isAgentProfileModelOpen, tasklistlength: tasklistlength, selectedRoleName: selectedRoleName, monitoringEnabled: monitoringEnabled, managedTeamsArray: getManagedTeamsArray(), isManagedTeamLoading: getManagedTeamsLoading(), isManagedTeamsError: getManagedTeamsError(), paginatedManagedTeamsMetaData: paginatedManagedTeamsMeta, isDesktopManagedFilterInfScrollingEnabled: isDesktopManagedFilterInfScrollingEnabled, isExtension: isExtension, userRole: userRole, navigateToProfileSettingsUpdate: navigateToProfileSettingsUpdate, navigateToManagedTeamsView: navigateToManagedTeamsView, isBrowserNetworkTest: isWebRTCEnabled && deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.LoginVoiceOptions.BROWSER, engagedState: engagedState, getAvatarVariant: getAvatarVariant, reloadManagedTeams: fetchManagedTeams, deviceType: deviceType || _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.LoginVoiceOptions.AGENT_DN, isWebRTCFFEnabled: isWebRTCEnabled, webRtcStatus: webRtcStatus, loginVoiceOptions: loginVoiceOptions, microsoftAuthConfig: microsoftAuthConfig, presenceServiceStatus: presenceServiceStatus, collabDetails: collabDetails, visualRebrandNewLookToggleEnabled: visualRebrandNewLookToggleEnabled, isUploadLogsToWebexEnabled: isUploadLogsToWebexEnabled, isPersonalGreetingsEnabled: isPersonalGreetingsEnabled })] })));
    const checkPresenceMercurySuccess = () => {
        return presenceServiceStatus.serviceStatus === "mercury_successful";
    };
    const checkPresenceFailure = () => {
        return (presenceServiceStatus.serviceStatus === "mercury_failure" ||
            presenceServiceStatus.serviceStatus === "sync_failure");
    };
    const shouldDisplayWarning = () => {
        const isWebRTCDisconnectedOrRegistering = isWebRTCBrowser() && (isWebRTCDisconnected() || isWebRTCRegistering());
        return (((microsoftAuthConfig === null || microsoftAuthConfig === void 0 ? void 0 : microsoftAuthConfig.isEnabled) && !(microsoftAuthConfig === null || microsoftAuthConfig === void 0 ? void 0 : microsoftAuthConfig.isAuthenticated)) ||
            isWebRTCDisconnectedOrRegistering ||
            (!checkPresenceMercurySuccess() && collabDetails.stateSynchronization));
    };
    const warningAria = () => {
        if (isWebRTCDisconnected() && (microsoftAuthConfig === null || microsoftAuthConfig === void 0 ? void 0 : microsoftAuthConfig.isEnabled) && !(microsoftAuthConfig === null || microsoftAuthConfig === void 0 ? void 0 : microsoftAuthConfig.isAuthenticated)) {
            return ` ${agentProfile.webRTCDisconnected} and ${agentProfile.msAuthFailed} and ${agentProfile.stateSyncFailed}`;
        }
        else if (isWebRTCDisconnected() && checkPresenceFailure()) {
            return ` ${agentProfile.webRTCDisconnected} and ${agentProfile.stateSyncFailed}`;
        }
        else if (checkPresenceFailure()) {
            return ` ${agentProfile.stateSyncFailed}`;
        }
        else if (isWebRTCDisconnected()) {
            return ` ${agentProfile.webRTCDisconnected}`;
        }
        else if ((microsoftAuthConfig === null || microsoftAuthConfig === void 0 ? void 0 : microsoftAuthConfig.isEnabled) && !(microsoftAuthConfig === null || microsoftAuthConfig === void 0 ? void 0 : microsoftAuthConfig.isAuthenticated)) {
            return ` ${agentProfile.msAuthFailed} and ${agentProfile.stateSyncFailed}`;
        }
        else {
            return "";
        }
    };
    const handleConfirm = () => {
        if (showEmergencyModal(selectedProfileSettings === null || selectedProfileSettings === void 0 ? void 0 : selectedProfileSettings.deviceType)) {
            setNotificationModalState(true);
            setIsChangeProfileModal(false);
        }
        else {
            changeProfileHandler();
        }
    };
    const handleFocusOnModalClose = () => {
        // setTimeout is added to take into consideration a scenario where, when you click outside the modal and navigate using keyboard
        focusOnModalCloseTimeoutIdRef.current = window.setTimeout(() => {
            var _a, _b, _c;
            (_c = (_b = (_a = menuTriggerRef === null || menuTriggerRef === void 0 ? void 0 : menuTriggerRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.children[0]) === null || _c === void 0 ? void 0 : _c.focus();
        }, 10);
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_12__["default"], { isOpen: errorModalState, message: agentProfile.errorActiveContacts, buttons: [{ label: common.okButton, onClick: errorModalCallback }], modalHeader: common.Error, showCloseButton: false }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_12__["default"], { isOpen: signoutModalState && !errorModalState, message: agentProfile.signoutConfirm, buttons: [
                    {
                        label: common.Cancel,
                        onClick: errorModalCallback,
                        variant: "secondary",
                        ariaLabel: common.Cancel
                    },
                    {
                        label: agentProfile.signOut,
                        onClick: signOut,
                        ariaLabel: agentProfile.signOut
                    }
                ], modalHeader: agentProfile.signoutConfirmHeader, showCloseButton: false, noExitOnEsc: true }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_12__["default"], { isOpen: isLayoutErrorModal, message: agentProfile.resetConfirmMessage, buttons: [
                    {
                        label: common.Cancel,
                        onClick: () => {
                            setIsLayoutErrorModal(false);
                        },
                        variant: "secondary",
                        ariaLabel: common.Cancel
                    },
                    {
                        label: common.okButton,
                        onClick: resetLayout,
                        ariaLabel: common.okButton
                    }
                ], modalHeader: agentProfile.resetConfirmHeader, showCloseButton: false, setErrorModal: setIsLayoutErrorModal, noExitOnEsc: false }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_12__["default"], { isOpen: isChangeTeamModal, message: agentProfile.changeTeamsConfirmMessage, buttons: [
                    {
                        label: common.Cancel,
                        onClick: () => {
                            setIsChangeTeamModal(false);
                        },
                        variant: "secondary",
                        ariaLabel: common.Cancel
                    },
                    {
                        label: agentProfile.changeTeamLabel,
                        onClick: changeTeamHandler,
                        ariaLabel: agentProfile.changeTeamLabel
                    }
                ], modalHeader: agentProfile.changeTeamsConfirmHeader, showCloseButton: false, setErrorModal: setIsChangeTeamModal, noExitOnEsc: false }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_12__["default"], { isOpen: isChangeProfileModal, message: agentProfile.changeProfileConfirmMessage, buttons: [
                    {
                        label: common.Cancel,
                        onClick: () => {
                            setIsChangeProfileModal(false);
                            setIsSaveClicked(false);
                        },
                        variant: "secondary",
                        ariaLabel: common.Cancel
                    },
                    {
                        label: agentProfile.confirm,
                        onClick: handleConfirm,
                        ariaLabel: agentProfile.confirm
                    }
                ], modalHeader: agentProfile.changeProfileConfirmHeader, showCloseButton: false, setErrorModal: setIsChangeProfileModal, noExitOnEsc: false }), showEmergencyModal(selectedProfileSettings === null || selectedProfileSettings === void 0 ? void 0 : selectedProfileSettings.deviceType) ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmergencyNotificationModal__WEBPACK_IMPORTED_MODULE_11__["default"], { isOpen: notificationModalState, buttons: [
                    {
                        label: common.Cancel,
                        onClick: () => {
                            setNotificationModalState(false);
                            setIsChangeProfileModal(false);
                        },
                        variant: "secondary",
                        ariaLabel: common.Cancel
                    },
                    {
                        label: common.Continue,
                        onClick: () => {
                            changeProfileHandler();
                            setNotificationModalState(false);
                        },
                        ariaLabel: common.Continue
                    }
                ], modalHeader: emergencyServiceNotification === null || emergencyServiceNotification === void 0 ? void 0 : emergencyServiceNotification.emergencyServiceNotification, showCloseButton: false, setModalState: setNotificationModalState, noExitOnEsc: true, checkBoxLabel: emergencyServiceNotification === null || emergencyServiceNotification === void 0 ? void 0 : emergencyServiceNotification.readNotification })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_15___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ ref: menuElm, "custom-width": "400px", ariaRole: "dialog", ariaLabel: agentProfile.ariaAgentprofile, class: isAgentProfileModelOpen ? "modal-open" : "modal-close" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ slot: "menu-trigger", placement: "bottom", message: agentname }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ class: "profile-button", ariaLabel: `${agentProfile.ariaAgentprofile}${warningAria()}`, ref: menuTriggerRef, hasRemoveStyle: true, slot: "menu-trigger" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-avatar", Object.assign({ alt: agentname, title: agentname, type: getAvatarVariant(engagedState, agentstatus), src: agentphoto, hideDefaultTooltip: false }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumAvatarEnabled
                                            ? { newMomentum: true, size: 32 }
                                            : { size: DEFAULT_AVATAR_SIZE }))), shouldDisplayWarning() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WARNING_BADGE_SVG, { className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("webrtc-warning-icon", {
                                                dark: darktheme
                                            }) }))] })) }) })), isHomeMenu() ? (renderHomeMenu) : isSpeakerMic ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `menu-overlay-container ${slide}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-header-left" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ref: speakerMicSettingsRef, class: "arrow-icon-back", ariaLabel: agentProfile.arrowLabel, hasRemoveStyle: true, onClick: handleClickBackToMain, onKeyDown: keydownBackToMain }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: "icon-arrow-tail-down_14" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: agentProfile.speakerAndMic }, (!notificationTitleOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "value-ellipsis", id: "speaker-mic-settings-header", ref: speakerMicTitleRef }, { children: agentProfile.speakerAndMic })) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpeakerMicSettings_speakerMicrophoneComponent__WEBPACK_IMPORTED_MODULE_21__["default"], { logger: _sdk__WEBPACK_IMPORTED_MODULE_10__.logger, agentProfileProps: agentProfile, isMicAccessDenied: isMicAccessDenied, selectedInputDeviceId: selectedInputDeviceId, selectedOutputDeviceId: selectedOutputDeviceId })] }))) : isSettingsPage ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `menu-overlay-container ${slide}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-header-left" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ "data-testid": "notification-settings-back-btn", ref: notificationSettingsRef, class: "arrow-icon-back", ariaLabel: agentProfile.arrowLabel, hasRemoveStyle: true, onClick: () => handleClickBackToMain(NAVIGATION_SETTINGS_CLASS), onKeyDown: (e) => keydownBackToMain(e, NAVIGATION_SETTINGS_CLASS) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: "icon-arrow-tail-down_14" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: agentProfile.notificationSettings }, (!notificationTitleOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", Object.assign({ className: "value-ellipsis", id: "notification-settings-header", ref: notificationTitleRef }, { children: agentProfile.notificationSettings })) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NotificationSettingsBar_NotificationSettingsBar__WEBPACK_IMPORTED_MODULE_18__["default"], { notificationLabel: agentProfile.enableNotificationSettings, notificationDescription: agentProfile.notificationSettingDescription, isSilentSetting: false, isSuppressWebexCallingNotificationsSetting: false }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NotificationSettingsBar_NotificationSettingsBar__WEBPACK_IMPORTED_MODULE_18__["default"], { notificationLabel: agentProfile.enableSilentNotificationSettings, notificationDescription: agentProfile.silentNotificationDescription, isSilentSetting: true, isSuppressWebexCallingNotificationsSetting: false }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NotificationSettingsBar_NotificationSettingsBarSound__WEBPACK_IMPORTED_MODULE_19__["default"], { notificationLabel: notificationLables, desktopSoundSetting: _Common_constants__WEBPACK_IMPORTED_MODULE_13__.DESKTOP_NOTIFICATION_SOUND_SETTINGS, agentId: agentid }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: isSuppressWebexCallingNotificationEnabled && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NotificationSettingsBar_NotificationSettingsBar__WEBPACK_IMPORTED_MODULE_18__["default"], { notificationLabel: agentProfile.suppressWebexCallingNotificationSettings, notificationDescription: agentProfile.suppressWebexCallingNotificationDescription, isSilentSetting: false, isSuppressWebexCallingNotificationsSetting: true })) })] }))) : isPersonalGreetingsSettingsPage ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: `menu-overlay-container ${slide}` }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-header-left" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ "data-testid": "personal-greeting-settings-back-btn", ref: personalGreetingsSettingsRef, class: "arrow-icon-back", ariaLabel: agentProfile.arrowLabel, hasRemoveStyle: true, onClick: () => handleClickBackToMain(NAVIGATION_SETTINGS_CLASS), onKeyDown: (e) => keydownBackToMain(e, NAVIGATION_SETTINGS_CLASS) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: "icon-arrow-tail-down_14" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: agentProfile.personalGreetings }, (!personalGreetingsTitleOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", Object.assign({ className: "value-ellipsis", id: "personal-greeting-settings-header", ref: personalGreetingsTitleRef }, { children: agentProfile.personalGreetings })) }))] })) }))) : isTeamChangePage ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `menu-overlay-container ${slide}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-header-left" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ref: teamChangeSettingsRef, class: "arrow-icon-back", ariaLabel: agentProfile.arrowLabel, hasRemoveStyle: true, onClick: handleClickBackToMain, onKeyDown: keydownBackToMain }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: "icon-arrow-tail-down_14" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: agentProfile.teamName }, (!notificationTitleOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", Object.assign({ className: "value-ellipsis", id: "team-settings-header", ref: notificationTitleRef }, { children: agentProfile.teamName })) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "teams-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "team-list-search" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-input", Object.assign({ "data-testid": "search-input", clear: true, ref: searchInputRef, htmlId: "pillSearchInput", name: "pillSearchInput", ariaLabel: agentProfile.searchTeams, placeholder: agentProfile.searchTeams, onInput: filterTeamList, class: "search-input", value: searchQuery, searchable: true, clearAriaLabel: agentProfile.clear }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }))) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-list", Object.assign({ class: "menu-list", role: "listbox", label: "Teams", ref: teamListRef, selected: selectedIndex, activated: selectedIndex }, { children: Object.keys(filteredTeamList).length > 0 ? ((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_14__.orderBy)(filteredTeamList, "teamName").map((option) => {
                                                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TeamsList_TeamMenuItem__WEBPACK_IMPORTED_MODULE_22__["default"], { teamName: option.teamName, teamId: option.teamId, onSelectTeam: () => {
                                                        handleSelectTeam(option);
                                                    } }, option.teamName));
                                            })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "no-record-found" }, { children: agentProfile.noTeam }))) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: `menu-footer menu-footer-profile ${isSaveTeamDisabled ? "disabled" : ""}` }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-link", Object.assign({ "data-testid": "save-team-selected-link", ariaLabel: agentProfile.saveTeamSelection, onClick: saveTeamSelected, ariaRole: "button" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "check_16" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "save-team-btn" }, { children: agentProfile.saveTeamSelection }))] })) }))] }))] }))) : isProfileUpdatePage ? (editUserProfileSection) : (isManagedTeamsView && viewManagedTeams)] })) }))] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_5__.observer)(MenuComponent));


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/MenuContent/PaginatedManagedTeams/ListItem.tsx":
/*!********************************************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/MenuContent/PaginatedManagedTeams/ListItem.tsx ***!
  \********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");

const ListItem = ({ data, index, style }) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", Object.assign({ "data-testid": "team-name", style: style }, { children: data.teamName }), index));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ListItem);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/MenuContent/PaginatedManagedTeams/PaginatedManagedTeams.tsx":
/*!*********************************************************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/MenuContent/PaginatedManagedTeams/PaginatedManagedTeams.tsx ***!
  \*********************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _Common_components_List__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../Common/components/List */ "./src/direflow-components/Common/components/List/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ListItem */ "./src/direflow-components/AgentProfile/components/MenuContent/PaginatedManagedTeams/ListItem.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






const PaginatedManagedTeams = (data) => {
    const [updatedList, setUpdatedList] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(data === null || data === void 0 ? void 0 : data.managedTeams);
    // pagination
    const [hasNextPage, setHasNextPage] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(data === null || data === void 0 ? void 0 : data.hasNextPage);
    const [pageNum, setPageNum] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((data === null || data === void 0 ? void 0 : data.hasNextPage) ? 0 : -1);
    // loading
    const [isNextPageLoading, setIsNextPageLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    //errors
    const [pageFetchError, setPageFetchError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        error: false,
        trackingId: ""
    });
    const ListContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const fetchManagedTeams = (pageNumber, reset) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const orgId = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId;
            const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedTeamsList({
                orgId,
                page: pageNumber,
                pageSize: _Common_constants__WEBPACK_IMPORTED_MODULE_4__.PAGE_SIZE,
                customFilter: "",
                supervisorView: true
            });
            handleLoadPageSuccess(response, reset);
        }
        catch (error) {
            handleLoadPageError(error, pageNumber);
        }
    });
    const handleLoadPageSuccess = (response, reset) => {
        const { page, totalPages } = response.meta || {};
        const currentManagedTeams = response.data || [];
        setUpdatedList((prevManagedTeamList) => reset ? currentManagedTeams : [...prevManagedTeamList, ...currentManagedTeams]);
        setPageFetchError({ error: false, trackingId: "" });
        if (page !== undefined && totalPages !== undefined) {
            setHasNextPage(page < totalPages - 1);
        }
        else {
            setHasNextPage(false);
        }
        setIsNextPageLoading(false);
        setPageNum(page);
    };
    const handleLoadPageError = (err, pageNumber) => {
        const trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err);
        setPageFetchError({ error: true, trackingId });
        setHasNextPage(true);
        setIsNextPageLoading(false);
    };
    const loadPage = (pageNumber, reset = false) => __awaiter(void 0, void 0, void 0, function* () {
        fetchManagedTeams(pageNumber, reset);
    });
    const loadNextPage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isNextPageLoading) {
            return;
        }
        setIsNextPageLoading(true);
        loadPage(pageNum + 1, false);
    });
    const getHeight = () => {
        return window.innerHeight - 64 - 42 - 5; // window - app header - menu header - cardinal token.
    };
    // UI renders
    const renderManagedTeamsList = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "managed-teams-container inf-scroll manged-teams-list", id: "managed-teams-container", ref: ListContainerRef }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_3__["default"], Object.assign({ data: updatedList, height: getHeight(), itemHeight: 24, retainLastFocusedItem: true, ariaLabel: "", innerElementType: "ul", infiniteScrollEnabled: true, hasNextPage: hasNextPage, isNextPageLoading: isNextPageLoading, loadNextPage: loadNextPage, pageFetchError: pageFetchError, onSelectValue: (selected) => { } }, { children: (props) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ListItem__WEBPACK_IMPORTED_MODULE_5__["default"], Object.assign({}, props)) })) })) }));
    };
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: renderManagedTeamsList() });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PaginatedManagedTeams);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/MenuContent/index.tsx":
/*!*******************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/MenuContent/index.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _ChannelCapacity__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../ChannelCapacity */ "./src/direflow-components/AgentProfile/components/ChannelCapacity/index.tsx");












const MenuContentComponent = ({ agentName, agentStatus, agentPhoto, teamName, dnNumber, channels, profileType, darkTheme, themeSwitchEnabled, keyboardShortcutKeyConflict, navigateToSettingsPage, navigateToPersonalGreetingsSettingsPage, navigateToTeamChangePage, navigateToSpeakerMicSettingsPage, confirmResetLayout, isVisible, tasklistlength, selectedRoleName, navigateToProfileSettingsUpdate, navigateToManagedTeamsView, isExtension, userRole, monitoringEnabled, managedTeamsArray, isManagedTeamLoading, isManagedTeamsError, paginatedManagedTeamsMetaData, isDesktopManagedFilterInfScrollingEnabled, reloadManagedTeams, engagedState, isWebRTCFFEnabled, getAvatarVariant, deviceType, isBrowserNetworkTest, webRtcStatus, loginVoiceOptions, microsoftAuthConfig, presenceServiceStatus, collabDetails, visualRebrandNewLookToggleEnabled, isUploadLogsToWebexEnabled, isPersonalGreetingsEnabled }) => {
    const { agentProfile, common, microsoft, webex, collabTool } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_8__.useI18nContext)();
    const dispatch = (0,react__WEBPACK_IMPORTED_MODULE_6__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.EventContext);
    const teamNameTextRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const [teamNameOverflow, setTeamNameOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const dnNumberTextRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const userRoleTextRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const [dnNumberOverflow, setDnNumberOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [darkThemeEnabled, setDarkThemeEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(darkTheme);
    const [newLookEnabled, setNewLookEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isVisualRebrandEnabled);
    const [userRoleOverflow, setUserRoleOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [showKeyboardShortcuts, setShowKeyboardShortcuts] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(true);
    const userRoleString = userRole && userRole.length > 0 ? userRole.join("_") : "";
    const menuValue = "menu-value";
    const keyPress = {
        NOTIFICATION: "notification",
        MANAGE_TEAMS: "manageteams",
        TEAM_CHANGE: "changeteams",
        PROFILE: "profile",
        PERSONAL_GREETINGS: "personalgreetings"
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const regis = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.getRegisteredKeys();
        setShowKeyboardShortcuts(regis.size > 0);
        const nameTextContainer = teamNameTextRef === null || teamNameTextRef === void 0 ? void 0 : teamNameTextRef.current;
        let isNameTextOverflowing;
        if (nameTextContainer && isVisible) {
            isNameTextOverflowing = nameTextContainer.offsetWidth < nameTextContainer.scrollWidth;
        }
        setTeamNameOverflow(isNameTextOverflowing);
        const numberTextContainer = dnNumberTextRef === null || dnNumberTextRef === void 0 ? void 0 : dnNumberTextRef.current;
        let isNumberTextOverflowing;
        if (numberTextContainer && isVisible) {
            isNumberTextOverflowing = numberTextContainer.offsetWidth < numberTextContainer.scrollWidth;
        }
        setDnNumberOverflow(isNumberTextOverflowing);
        const roleTextContainer = userRoleTextRef === null || userRoleTextRef === void 0 ? void 0 : userRoleTextRef.current;
        let isRoleTextOverflowing;
        if (roleTextContainer && isVisible) {
            isRoleTextOverflowing = roleTextContainer.offsetWidth < roleTextContainer.scrollWidth;
        }
        setUserRoleOverflow(isRoleTextOverflowing);
    }, [isVisible]);
    const downloadLogs = (event) => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.ERROR_DETAILS_DOWNLOADED);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.ERROR_DETAILS_DOWNLOADED, {
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.ERROR_DETAILS_DOWNLOADED]: true,
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
        });
        if (isUploadLogsToWebexEnabled) {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.webex.uploadLogs();
        }
        event.preventDefault();
        _sdk__WEBPACK_IMPORTED_MODULE_9__.loggerPool.browserDownloadAllLogsText();
    };
    const callbackSettings = (event) => {
        event.preventDefault();
        navigateToSettingsPage(true);
    };
    const callbackPersonalGreetingsSettings = (event) => {
        event.preventDefault();
        navigateToPersonalGreetingsSettingsPage(true);
    };
    const speakerMicCallbackSettings = (event) => {
        event.preventDefault();
        navigateToSpeakerMicSettingsPage(true);
    };
    const callbackTeamChange = (event) => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CHANGE_TEAM);
        event.preventDefault();
        if (tasklistlength > 0) {
            const changeTeamEvent = new CustomEvent("ax-change-team-cancelled", {
                detail: {
                    message: agentProfile.errorChangeTeams
                },
                bubbles: true,
                composed: true
            });
            dispatch(changeTeamEvent);
        }
        navigateToTeamChangePage(true);
    };
    const toggleDarkMode = () => {
        const event = new CustomEvent("ax-dark-theme", {
            detail: {
                darkTheme: !darkThemeEnabled
            },
            bubbles: true,
            composed: true
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.DARK_MODE_TOGGLE, {
            DarkModeEnabled: !darkThemeEnabled
        });
        setDarkThemeEnabled(!darkThemeEnabled);
        dispatch(event);
    };
    const toggleNewLook = () => {
        const event = new CustomEvent("ax-visual-rebrand-new-look", {
            detail: {
                newLook: !newLookEnabled
            },
            bubbles: true,
            composed: true
        });
        //Add telemetry for new look toggle if needed
        setNewLookEnabled(!newLookEnabled);
        dispatch(event);
    };
    const handleKeyboardShortcutsEvent = () => {
        const event = new CustomEvent("ax-keyboard-shortcuts", {
            detail: true,
            bubbles: true,
            composed: true
        });
        if (dispatch) {
            dispatch(event);
        }
    };
    const handleKeyboardShortcuts = (event) => {
        event.preventDefault();
        handleKeyboardShortcutsEvent();
    };
    const handleKeyPressEvent = (keyword) => (e) => {
        if (e.key === _constants__WEBPACK_IMPORTED_MODULE_7__.Key.Enter) {
            e.preventDefault();
            switch (keyword) {
                case keyPress.MANAGE_TEAMS:
                    callbackViewManagedTeams(e);
                    break;
                case keyPress.PROFILE:
                    callbackProfileSettingsUpdate(e);
                    break;
                case keyPress.TEAM_CHANGE:
                    callbackTeamChange(e);
                    break;
                case keyPress.NOTIFICATION:
                    callbackSettings(e);
                    break;
                case keyPress.PERSONAL_GREETINGS:
                    callbackPersonalGreetingsSettings(e);
                    break;
                default:
                    break;
            }
        }
    };
    const executeMenuContentShortcuts = (key) => {
        if (key.data &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_SHORTCUT_KEY_MODAL_KEY &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
            handleKeyboardShortcutsEvent();
        }
        if (key.data &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.DOWNLOAD_ERROR_REPORT_KEY &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_SHIFT) {
            _sdk__WEBPACK_IMPORTED_MODULE_9__.loggerPool.browserDownloadAllLogsText();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((key) => executeMenuContentShortcuts(key));
        return () => {
            if (stopListen) {
                stopListen();
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        setDarkThemeEnabled(darkTheme);
    }, [darkTheme]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        setNewLookEnabled(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isVisualRebrandEnabled);
    }, [_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isVisualRebrandEnabled]);
    const callbackProfileSettingsUpdate = (event) => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CHANGE_PROFILE_SETTINGS);
        event.preventDefault();
        if (tasklistlength > 0) {
            return;
        }
        else {
            navigateToProfileSettingsUpdate(true);
        }
    };
    const disableManagedTeams = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(() => {
        return isManagedTeamLoading || isManagedTeamsError;
    }, [isManagedTeamLoading, isManagedTeamsError]);
    const totalManagedTeams = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(() => (managedTeamsArray ? managedTeamsArray.length : 0), [managedTeamsArray]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        document.dispatchEvent(new CustomEvent("on-widget-update"));
    }, [disableManagedTeams, totalManagedTeams]);
    const callbackViewManagedTeams = (event) => {
        event.preventDefault();
        if (!disableManagedTeams && totalManagedTeams !== 0) {
            navigateToManagedTeamsView(true);
        }
    };
    const isSupervisor = () => (userRoleString === null || userRoleString === void 0 ? void 0 : userRoleString.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_7__.SUPERVISOR;
    const isAgent = () => (userRoleString === null || userRoleString === void 0 ? void 0 : userRoleString.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT;
    const isSupervisorAndAgent = () => (userRoleString === null || userRoleString === void 0 ? void 0 : userRoleString.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT_AND_SUPERVISOR;
    const isSelectedRoleSupervisorAndAgent = () => (userRoleString === null || userRoleString === void 0 ? void 0 : userRoleString.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT_AND_SUPERVISOR &&
        (selectedRoleName === null || selectedRoleName === void 0 ? void 0 : selectedRoleName.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT_AND_SUPERVISOR;
    const isSelectedRoleSupervisor = () => (userRoleString === null || userRoleString === void 0 ? void 0 : userRoleString.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT_AND_SUPERVISOR &&
        (selectedRoleName === null || selectedRoleName === void 0 ? void 0 : selectedRoleName.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_7__.SUPERVISOR;
    const shouldDisplayProfile = () => {
        // if Supervisor has logged in then display as per monitoring enabled/disabled
        if (isSupervisor()) {
            return monitoringEnabled;
        }
        return true;
    };
    const shouldDisplayDN = () => {
        // if Supervisor has logged in OR if Supervisor+Agent has logged in check if selected role is Supervisor
        // then display as per monitoring enabled/disabled
        if (isSelectedRoleSupervisor() || isSupervisor()) {
            return monitoringEnabled;
        }
        return true;
    };
    const shouldDisplayRole = () => {
        // Display Role only if Supervisor+Agent has logged in
        if (isSupervisorAndAgent()) {
            return true;
        }
        return false;
    };
    const shouldDisplayManagedTeams = () => {
        if (isSupervisorAndAgent() || isSupervisor()) {
            return true;
        }
        return false;
    };
    const shouldDisplayTeamsORChannelCapacity = () => {
        // Display only if logged in user role is Agent OR Agent+Supervisor and selected role is Agent+Supervisor
        if (isAgent() || isSelectedRoleSupervisorAndAgent()) {
            return true;
        }
        return false;
    };
    const displayChannelCapacity = () => {
        return shouldDisplayTeamsORChannelCapacity();
    };
    const checkWebRTCBrowser = () => {
        return isWebRTCFFEnabled && deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.LoginVoiceOptions.BROWSER;
    };
    const getRoleDisplayString = () => {
        let roleStr;
        if ((userRoleString === null || userRoleString === void 0 ? void 0 : userRoleString.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT_AND_SUPERVISOR) {
            if ((selectedRoleName === null || selectedRoleName === void 0 ? void 0 : selectedRoleName.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT_AND_SUPERVISOR) {
                roleStr = agentProfile.roleAgentSupervisor;
            }
            else if ((selectedRoleName === null || selectedRoleName === void 0 ? void 0 : selectedRoleName.toLocaleLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_7__.SUPERVISOR) {
                roleStr = agentProfile.roleSupervisor;
            }
        }
        return roleStr;
    };
    const retryManagedTeams = (event) => {
        event.preventDefault();
        reloadManagedTeams();
    };
    const ManageTeamError = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "managed-team-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "error-legacy-badge-filled", iconSet: "momentumDesign", size: "16" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-label": agentProfile.managedTeamsError }, { children: agentProfile.managedTeamsError })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-link", Object.assign({ inline: true, class: "managed-teams-retry-link", "aria-label": common.tryAgain, onClick: retryManagedTeams, "data-testid": "retry-managed-teams" }, { children: common.tryAgain }))] })));
    };
    const extensionDNProfileSettings = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [shouldDisplayRole() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-item menu-align", "aria-label": `${agentProfile.userRole} ${getRoleDisplayString()}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-label", Object.assign({ htmlFor: "user-role" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "menu-item-label" }, { children: agentProfile.userRole })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: getRoleDisplayString() }, (!userRoleOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "value-ellipsis value-align", id: "user-role", ref: userRoleTextRef }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "data-testid": "role-name", "data-title": "role-name", className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(menuValue) }, { children: getRoleDisplayString() })) })) }))] }))), shouldDisplayDN() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-item menu-align", "aria-label": `${agentProfile.dialNumber} ${dnNumber}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-label", Object.assign({ htmlFor: "dial-number", "aria-hidden": "true" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "menu-item-label" }, { children: isExtension ? agentProfile.extension : agentProfile.dialNumber })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: dnNumber }, (!dnNumberOverflow ? { disabled: true } : ""), { "aria-hidden": "true" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "value-ellipsis value-align", id: "dial-number", ref: dnNumberTextRef }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "data-testid": "dnNumber", className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(menuValue) }, { children: dnNumber })) })) }))] })))] }));
    const shouldDisplayWebRTCDisconnected = () => {
        return webRtcStatus === _constants__WEBPACK_IMPORTED_MODULE_7__.WEB_RTC_STATUS.WEB_RTC_DISCONNECTED;
    };
    const shouldDisplayWebRTCReconnect = () => {
        return webRtcStatus === _constants__WEBPACK_IMPORTED_MODULE_7__.WEB_RTC_STATUS.WEB_RTC_REGISTERING;
    };
    const getDisconnectErrorMessage = () => {
        return loginVoiceOptions && loginVoiceOptions.length > 1
            ? agentProfile.disconnectMessage
            : agentProfile.singleTelephonyDisconnectMessage;
    };
    const getWebrtcDisconnectClassName = () => {
        const className = darkThemeEnabled ? "menu-telephony-status-dark" : "menu-telephony-status-light";
        return `menu-telephony-status ${className}`;
    };
    const telephonyDesktopProfileSettings = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-item menu-align", "aria-label": agentProfile.telephony }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-label", Object.assign({ htmlFor: "telephony" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "menu-item-label" }, { children: agentProfile.telephony })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: agentProfile.desktop }, (!userRoleOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "value-ellipsis value-align", id: "telephony", ref: userRoleTextRef }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "data-testid": "name", "data-title": "name", className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(menuValue) }, { children: agentProfile.desktop })) })) })), shouldDisplayWebRTCDisconnected() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-reconnect" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-warning_12", class: "menu-warning-icon", color: darkThemeEnabled ? "var(--md-yellow-40)" : "var(--md-yellow-70)" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: getDisconnectErrorMessage() }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(getWebrtcDisconnectClassName()) }, { children: getDisconnectErrorMessage() })) }) }))] }))), shouldDisplayWebRTCReconnect() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-reconnect" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "menu-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "12" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: agentProfile.reconnecting }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(menuValue) }, { children: [agentProfile.reconnecting, "..."] })) }) }))] })))] })) }));
    const retryMicrosoftAuthentication = (event) => {
        event.preventDefault();
        (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_10__.evt)(_constants__WEBPACK_IMPORTED_MODULE_7__.INITIATE_MS_AUTH_LOGIN, true, dispatch);
    };
    const retryPresenceSynchronization = (event) => {
        event.preventDefault();
        (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_10__.evt)(_constants__WEBPACK_IMPORTED_MODULE_7__.RETRY_PRESENCE_SYNC_REGISTER, true, dispatch);
    };
    const getPresenceSyncContent = () => {
        let content;
        switch (presenceServiceStatus.serviceStatus) {
            case _constants__WEBPACK_IMPORTED_MODULE_7__.SERVICE_STATUS.MERCURY_SUCCESSFUL:
                content = (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "ms-sync-success" }, { children: collabTool === null || collabTool === void 0 ? void 0 : collabTool.successful }));
                break;
            case _constants__WEBPACK_IMPORTED_MODULE_7__.SERVICE_STATUS.SYNC_FAILURE:
                content = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "ms-retry-failed-wrapper" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "error-legacy-badge-filled", size: "12", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ms-sync-failed", "data-testid": "ms-sync-failed" }, { children: collabTool === null || collabTool === void 0 ? void 0 : collabTool.failed })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-link", Object.assign({ inline: true, className: "ms-retry-auth-link", "data-testid": "retry-ms-sync", ariaRole: "link", "aria-label": collabTool === null || collabTool === void 0 ? void 0 : collabTool.tryAgain, onClick: retryPresenceSynchronization }, { children: collabTool === null || collabTool === void 0 ? void 0 : collabTool.tryAgain }))] })));
                break;
            case _constants__WEBPACK_IMPORTED_MODULE_7__.SERVICE_STATUS.MERCURY_FAILURE:
                content = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "ms-retry-failed-wrapper" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "error-legacy-badge-filled", size: "12", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "ms-sync-failed", "data-testid": "ms-mercury-failed" }, { children: [collabTool === null || collabTool === void 0 ? void 0 : collabTool.failed, collabTool === null || collabTool === void 0 ? void 0 : collabTool.mercuryFailedInfo] }))] })));
                break;
            case "":
                // initial case
                content = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "menu-reconnect" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "ms-retry-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "12" }) })) })));
                break;
            default:
                // retry cases
                content = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-reconnect" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "ms-retry-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "12" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: collabTool === null || collabTool === void 0 ? void 0 : collabTool.retrying })] })));
        }
        return content;
    };
    const presenceSyncProfile = () => {
        return (microsoftAuthConfig.isAuthenticated || collabDetails.collabToolInSync === _constants__WEBPACK_IMPORTED_MODULE_7__.COLLAB_TOOL.WEBEX) &&
            collabDetails.stateSynchronization ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "value-align", id: "presence-sync" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ "data-testid": "ms-presence-sync", className: "ms-authenticated" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: collabTool === null || collabTool === void 0 ? void 0 : collabTool.stateSync }), getPresenceSyncContent()] })), presenceServiceStatus.trackingId !== "" &&
                    (presenceServiceStatus.serviceStatus === _constants__WEBPACK_IMPORTED_MODULE_7__.SERVICE_STATUS.SYNC_FAILURE ||
                        presenceServiceStatus.serviceStatus === _constants__WEBPACK_IMPORTED_MODULE_7__.SERVICE_STATUS.MERCURY_FAILURE) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "ms-sync-failed-info" }, { children: [collabTool === null || collabTool === void 0 ? void 0 : collabTool.trackingIdLabel, presenceServiceStatus.trackingId] })))] }))) : null;
    };
    const getCollabToolLabel = () => {
        switch (collabDetails.collabToolInSync) {
            case _constants__WEBPACK_IMPORTED_MODULE_7__.COLLAB_TOOL.TEAMS:
                return microsoft.teams;
            case _constants__WEBPACK_IMPORTED_MODULE_7__.COLLAB_TOOL.WEBEX:
                return webex.webex;
            default:
                return "";
        }
    };
    const getCollabToolInfo = () => {
        switch (collabDetails.collabToolInSync) {
            case _constants__WEBPACK_IMPORTED_MODULE_7__.COLLAB_TOOL.TEAMS:
                return microsoft.info;
            case _constants__WEBPACK_IMPORTED_MODULE_7__.COLLAB_TOOL.WEBEX:
                return webex.info;
            default:
                return "";
        }
    };
    const collabToolProfile = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ "data-testid": "ms-profile-wrapper", className: "menu-item menu-align" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-label", Object.assign({ class: "ms-config-label", htmlFor: "microsoft-auth" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: [common.collaborationTool, " - ", getCollabToolLabel()] }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "top", class: "ms-info-tooltip", message: getCollabToolInfo() }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { tabindex: "0", ariaLabel: getCollabToolInfo(), name: "info-badge-filled", size: "16", iconSet: "momentumDesign" }) }))] }), (microsoftAuthConfig === null || microsoftAuthConfig === void 0 ? void 0 : microsoftAuthConfig.isEnabled) ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "value-align", id: "microsoft-auth" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ "data-testid": "ms-authenticated", className: "ms-authenticated" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "ms-user-auth" }, { children: collabTool === null || collabTool === void 0 ? void 0 : collabTool.userAuthenticated })), microsoftAuthConfig.isAuthenticated ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: collabTool === null || collabTool === void 0 ? void 0 : collabTool.successful })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "ms-retry-wrapper" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "error-legacy-badge-filled", size: "12", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ms-authenticated-failed", "data-testid": "ms-authenticated-failed" }, { children: collabTool === null || collabTool === void 0 ? void 0 : collabTool.failed })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-link", Object.assign({ inline: true, class: "ms-retry-auth-link", "data-testid": "retry-ms-auth", ariaRole: "link", "aria-label": collabTool === null || collabTool === void 0 ? void 0 : collabTool.tryAgain, onClick: retryMicrosoftAuthentication }, { children: collabTool === null || collabTool === void 0 ? void 0 : collabTool.tryAgain }))] })))] })), !microsoftAuthConfig.isAuthenticated && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "ms-auth-failed-info" }, { children: microsoft.authenticationFailedInfo })))] }))) : null, presenceSyncProfile()] })));
    };
    // This gets the actual number of the managedTeams from the paginatedMeta. Eventho not all the recortds are loaded.
    const getManagedTeamsLength = () => isDesktopManagedFilterInfScrollingEnabled ? paginatedManagedTeamsMetaData === null || paginatedManagedTeamsMetaData === void 0 ? void 0 : paginatedManagedTeamsMetaData.totalRecords : totalManagedTeams;
    const userProfileSection = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "user-profile-section" }, { children: [shouldDisplayManagedTeams() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "managed-teams-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-link", Object.assign({ ariaRole: "link", tag: "span", type: "button", ariaLabel: !isManagedTeamsError && !isManagedTeamLoading
                                ? `${agentProfile.managedTeams} ${!disableManagedTeams ? `(${totalManagedTeams})` : ""} ${managedTeamsArray.map((team) => team.teamName).join(", ")}`
                                : `${agentProfile.managedTeams}`, class: "menu-quicklink managed-teams" }, (disableManagedTeams || totalManagedTeams === 0 ? { disabled: true } : ""), (disableManagedTeams || totalManagedTeams === 0
                            ? {}
                            : {
                                onClick: callbackViewManagedTeams,
                                onKeyPress: handleKeyPressEvent(keyPress.MANAGE_TEAMS)
                            }), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ "aria-hidden": "true", className: `agent-profile-link managed-teams-text ${disableManagedTeams || totalManagedTeams === 0 ? "disabled" : ""}`, "data-testid": "change-managed-teams" }, { children: [agentProfile.managedTeams, " ", !disableManagedTeams ? `(${getManagedTeamsLength()})` : null] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "shortcut-arrow-container", "aria-hidden": "true" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ "aria-label": agentProfile.managedTeams, class: "navigation-arrow", circle: true, variant: "ghost" }, (disableManagedTeams || totalManagedTeams === 0 ? { disabled: true } : ""), { role: "button", "tab-index": "-1" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "arrow-right-bold", size: "16", iconSet: "momentumDesign" }) })) }))] })), isManagedTeamLoading ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "managed-team-loading" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "32" }) }))) : isManagedTeamsError ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ManageTeamError, {})) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "managed-team-view" }, { children: managedTeamsArray.map((team) => team.teamName).join(", ") })))] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "profile-settings-container" }, { children: [shouldDisplayProfile() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-link", Object.assign({ "data-testid": "change-profile-settings-btn", ariaRole: "link", tag: "span", type: "button" }, (tasklistlength !== 0 ? { disabled: true } : ""), (tasklistlength !== 0
                        ? {}
                        : {
                            onClick: callbackProfileSettingsUpdate,
                            onKeyPress: handleKeyPressEvent(keyPress.PROFILE)
                        }), { ariaLabel: agentProfile.profileSettings, title: agentProfile.profileSettings, class: classnames__WEBPACK_IMPORTED_MODULE_4___default()("menu-quicklink profile-setting-wrapper", {
                            "profile-settings": tasklistlength === 0
                        }) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true", className: `agent-profile-link profile-settings-text ${tasklistlength !== 0 ? "disabled" : ""}`, "data-testid": "change-profile-settings" }, { children: agentProfile.profileSettings })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "shortcut-arrow-container", "aria-hidden": "true" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ class: "navigation-arrow", circle: true, variant: "ghost", role: "button", "tab-index": "-1" }, (tasklistlength !== 0 ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "arrow-right-bold", size: "16", iconSet: "momentumDesign" }) })) }))] }))), checkWebRTCBrowser() ? telephonyDesktopProfileSettings : extensionDNProfileSettings] })), shouldDisplayTeamsORChannelCapacity() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-item menu-align", "aria-label": `${agentProfile.teamName} ${teamName}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-label", Object.assign({ htmlFor: "team-name", "aria-hidden": "true" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "menu-item-label" }, { children: agentProfile.teamName })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: teamName }, (!teamNameOverflow ? { disabled: true } : ""), { "aria-hidden": "true" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "value-ellipsis value-align", id: "team-name", ref: teamNameTextRef }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(menuValue), "data-testid": "team-name" }, { children: teamName })) })) }))] }))), collabDetails.collabToolInSync !== "" ? collabToolProfile() : null] })));
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-content" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-agent" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-avatar", Object.assign({ "aria-hidden": "true", alt: agentName, title: agentName, type: getAvatarVariant(engagedState, agentStatus), src: agentPhoto, size: 88, "aria-label": agentName, hideDefaultTooltip: false, tabindex: -1 }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumAvatarEnabled ? { newMomentum: true } : {}))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", Object.assign({ className: "agentName" }, { children: agentName }))] })), userProfileSection, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "profile-menu-separator" }), displayChannelCapacity() && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ChannelCapacity__WEBPACK_IMPORTED_MODULE_11__["default"], { channels: channels, profileType: profileType }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-user-settings-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", Object.assign({ className: "menu-label sub-header  user-settings" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: agentProfile.userSettings }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-link", Object.assign({ ariaRole: "link", tag: "span", "data-testid": "notification-settings-btn", onClick: callbackSettings, onKeyPress: handleKeyPressEvent(keyPress.NOTIFICATION), class: "menu-quicklink notification-settings-btn", type: "button", ariaLabel: agentProfile.notificationSettings }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "alert-bold", size: "16", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "agent-profile-link notification-settings-text", "data-testid": "notification-settings" }, { children: agentProfile.notificationSettings })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "notification-settings-arrow", name: "arrow-right-bold", size: "16", iconSet: "momentumDesign" })] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-link", Object.assign({ class: "menu-quicklink agent-profile-link", onClick: confirmResetLayout, tag: "a", ariaRole: "button", "data-testid": "reset-layout" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "reset-bold", size: "16", iconSet: "momentumDesign" }), agentProfile.resetLayout] })), themeSwitchEnabled && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "menu-quicklink" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "appearance-bold", size: "16", iconSet: "momentumDesign" }), agentProfile.darkTheme, " ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-toggle-switch", Object.assign({ "data-testid": "toggle-dark-mode", onClick: toggleDarkMode, label: agentProfile.darkTheme }, (darkThemeEnabled ? { checked: true } : "")))] }))), visualRebrandNewLookToggleEnabled && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "menu-quicklink" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "sparkle-bold", size: "16", iconSet: "momentumDesign" }), agentProfile.newLook, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-toggle-switch", Object.assign({ "data-testid": "toggle-new-look", onClick: toggleNewLook, label: agentProfile.newLook }, (newLookEnabled ? { checked: true } : "")))] }))), checkWebRTCBrowser() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "menu-quicklink" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "adjust-bold", size: "16", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-link", Object.assign({ class: "agent-profile-link speaker-mic-link", "aria-label": agentProfile.speakerAndMic, onClick: speakerMicCallbackSettings, tag: "a", ariaRole: "button", "data-testid": "speaker-mic-settings" }, { children: agentProfile.speakerAndMic })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "notification-settings-arrow", name: "arrow-right-bold", size: "16", iconSet: "momentumDesign", onClick: speakerMicCallbackSettings })] }))), isPersonalGreetingsEnabled && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-link", Object.assign({ ariaRole: "link", tag: "span", "data-testid": "personal-greetings-btn", onClick: callbackPersonalGreetingsSettings, onKeyPress: handleKeyPressEvent(keyPress.PERSONAL_GREETINGS), class: "menu-quicklink notification-settings-btn", type: "button", ariaLabel: agentProfile.personalGreetings }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "active-speaker-bold", size: "16", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "agent-profile-link personal-greetings-text", "data-testid": "personal-greetings" }, { children: agentProfile.personalGreetings })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "notification-settings-arrow", name: "arrow-right-bold", size: "16", iconSet: "momentumDesign" })] })))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "menu-help-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", Object.assign({ className: "menu-label sub-header" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: agentProfile.help }) })), showKeyboardShortcuts && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "menu-quicklink" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-link", Object.assign({ class: "agent-profile-link", ariaLabel: `${agentProfile.keyboardShortcuts} ${agentProfile.keyboardShortcutCombination}`, onClick: handleKeyboardShortcuts, ariaRole: "button", "data-testid": "keyboard-shortcut" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "keyboard-bold", size: "16", iconSet: "momentumDesign" }), agentProfile.keyboardShortcuts, keyboardShortcutKeyConflict && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "conflict-warning", name: "icon-warning_14", color: "red" })] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ textColor: "var(--md-primary-text-color)", outlined: true, small: true }, { children: agentProfile.keyboardShortcutCombination })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "shortcut-arrow", name: "arrow-right-bold", size: "16", iconSet: "momentumDesign", onClick: handleKeyboardShortcuts })] })] }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "menu-quicklink" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-link", Object.assign({ class: "menu-quicklink agent-profile-link", ariaLabel: `${agentProfile.downloadLogs} ${agentProfile.errorReportCombination}`, onClick: downloadLogs, tag: "a", ariaRole: "button", "data-testid": "download-logs" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "note-bold", size: "16", iconSet: "momentumDesign" }), agentProfile.downloadLogs] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ textColor: "var(--md-primary-text-color)", class: "error-report-badge", outlined: true, small: true }, { children: agentProfile.errorReportCombination }))] })), isBrowserNetworkTest && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "menu-quicklink" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-link", Object.assign({ class: "menu-quicklink agent-profile-link", href: "https://cscan.webex.com", target: "_blank", ariaRole: "button", "data-testid": "test-network" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "tools-bold", size: "16", iconSet: "momentumDesign" }), agentProfile.testYourNetwork] })) })))] }))] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_5__.observer)(MenuContentComponent));


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/NotificationSettingsBar/NotificationSettingsBar.tsx":
/*!*************************************************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/NotificationSettingsBar/NotificationSettingsBar.tsx ***!
  \*************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/AgentProfile/constants.ts");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../styles.css */ "./src/direflow-components/AgentProfile/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_5__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






const NotificationSettingsBar = (props) => {
    const dispatch = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.EventContext);
    const { notificationLabel, notificationDescription, isSilentSetting, isSuppressWebexCallingNotificationsSetting } = props;
    const NOTIFICATION_SETTINGS = "desktop-notification-settings";
    const notificationSettings = localStorage.getItem(NOTIFICATION_SETTINGS);
    const webexSuppressCallingNotificationSetting = localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_4__.DESKTOP_HIDE_WEBEX_CALLING_NOTIFICATIONS_SETTING);
    const notificationDefault = { settings: true, silent: false };
    let suppressWebexCallingNotificationDefault = false;
    if (notificationSettings) {
        const notification = JSON.parse(notificationSettings);
        notificationDefault.settings = notification.settings;
        notificationDefault.silent = notification.silent;
    }
    else {
        localStorage.setItem(NOTIFICATION_SETTINGS, JSON.stringify(notificationDefault));
    }
    if (webexSuppressCallingNotificationSetting) {
        suppressWebexCallingNotificationDefault = JSON.parse(webexSuppressCallingNotificationSetting);
    }
    else {
        localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_4__.DESKTOP_HIDE_WEBEX_CALLING_NOTIFICATIONS_SETTING, JSON.stringify(suppressWebexCallingNotificationDefault));
    }
    const notificationSettingsHandler = (data) => {
        notificationDefault.settings = data.target.checked;
        notificationDefault.silent = !data.target.checked ? false : notificationDefault.silent;
        postNotificationSettingsChanged();
    };
    const silentNotificationHandler = (data) => {
        notificationDefault.silent = data;
        postNotificationSettingsChanged();
    };
    const suppressWebexNotificationSettingsHandler = (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g;
        suppressWebexCallingNotificationDefault = (_a = data.target.checked) !== null && _a !== void 0 ? _a : false;
        try {
            if (suppressWebexCallingNotificationDefault === true) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.webex.registerWebexCallingEvents((_d = (_c = (_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.agentId) !== null && _d !== void 0 ? _d : "");
            }
            yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.webex
                .updateAnswerCallsSetting((_g = (_f = (_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf) === null || _e === void 0 ? void 0 : _e.profile) === null || _f === void 0 ? void 0 : _f.agentId) !== null && _g !== void 0 ? _g : "", suppressWebexCallingNotificationDefault)
                .then(() => {
                localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_4__.DESKTOP_HIDE_WEBEX_CALLING_NOTIFICATIONS_SETTING, JSON.stringify(suppressWebexCallingNotificationDefault));
            });
        }
        catch (error) {
            const event = new CustomEvent("ax-suppress-webex-notifications-failed", {
                detail: {
                    message: error
                },
                bubbles: true,
                composed: true
            });
            if (dispatch) {
                dispatch(event);
            }
        }
    });
    const postNotificationSettingsChanged = () => {
        localStorage.setItem(NOTIFICATION_SETTINGS, JSON.stringify(notificationDefault));
        const event = new CustomEvent("ax-toast-notification-settings", {
            detail: {
                notificationEnabled: notificationDefault.settings,
                silentNotificationEnabled: notificationDefault.silent
            }
        });
        if (dispatch) {
            dispatch(event);
        }
        notificationTelemetryTracker();
    };
    //Mix  Panel tracker for  notification settings changes
    const notificationTelemetryTracker = () => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.NOTIFICATION_SETTINGS_UPDATE, {
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.ENABLE_SILENT_NOTIFICATION]: notificationDefault.silent,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.ENABLE_NOTIFICATION]: notificationDefault.settings
        });
    };
    const shouldDisable = () => {
        return isSilentSetting ? !notificationDefault.settings : false;
    };
    const shouldBeChecked = () => {
        if (isSilentSetting) {
            return !notificationDefault.settings ? false : notificationDefault.silent;
        }
        else if (isSuppressWebexCallingNotificationsSetting) {
            return suppressWebexCallingNotificationDefault;
        }
        return notificationDefault.settings;
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_5___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "notification-settings-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "toggle-switch-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ "aria-label": notificationLabel }, { children: notificationLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-toggle-switch", Object.assign({ label: notificationLabel, description: notificationDescription, onClick: (e) => isSilentSetting
                                ? silentNotificationHandler(e.target.checked)
                                : isSuppressWebexCallingNotificationsSetting
                                    ? suppressWebexNotificationSettingsHandler(e)
                                    : notificationSettingsHandler(e) }, (shouldDisable() ? { disabled: true } : ""), (shouldBeChecked() ? { checked: true } : "")))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "settings-description" }, { children: notificationDescription }))] })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NotificationSettingsBar);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/NotificationSettingsBar/NotificationSettingsBarSound.tsx":
/*!******************************************************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/NotificationSettingsBar/NotificationSettingsBarSound.tsx ***!
  \******************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../InteractionPopoverManager/Utils/InteractionPopoversUtils */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../styles.css */ "./src/direflow-components/AgentProfile/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_5__);






const NotificationSettingsBarSound = (props) => {
    const { notificationLabel, desktopSoundSetting, agentId } = props;
    const notificationSettings = localStorage.getItem(desktopSoundSetting);
    const notification = notificationSettings ? JSON.parse(notificationSettings) : {};
    const defaultSettings = notification && notification[agentId] ? notification[agentId] : { sound: true, volume: 0.8, mute: false };
    const [mute, setMute] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultSettings.mute);
    const [sound, setSound] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultSettings.sound);
    const [volume, setVolume] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultSettings.volume);
    const soundHandler = (data) => {
        defaultSettings.sound = data.target.checked;
        notification[agentId] = defaultSettings;
        setSound(data.target.checked);
        localStorage.setItem(desktopSoundSetting, JSON.stringify(notification));
        soundNotificationTelemetryTracker();
    };
    const volumeHandler = (event) => {
        defaultSettings.volume = event.target.value / 100;
        setVolume(defaultSettings.volume);
        notification[agentId] = defaultSettings;
        if (defaultSettings.volume === 0) {
            defaultSettings.mute = true;
            setMute(true);
        }
        else {
            defaultSettings.mute = false;
            setMute(false);
        }
        localStorage.setItem(desktopSoundSetting, JSON.stringify(notification));
    };
    const muteHandler = () => {
        if (defaultSettings.volume === 0 && mute) {
            defaultSettings.volume = 0.8;
            setVolume(defaultSettings.volume);
        }
        defaultSettings.mute = !mute;
        notification[agentId] = defaultSettings;
        setMute(!mute);
        localStorage.setItem(desktopSoundSetting, JSON.stringify(notification));
        soundNotificationTelemetryTracker();
    };
    const soundNotificationTelemetryTracker = () => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.NOTIFICATION_SOUND_SETTINGS_UPDATE, {
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.NOTIFICATION_SOUND_SETTINGS_VOLUME]: defaultSettings.volume,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.ENABLE_SOUND_NOTIFICATION]: defaultSettings.sound,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.ENABLE_SOUND_NOTIFICATION_MUTE]: defaultSettings.mute
        });
    };
    const playHandler = () => {
        (0,_InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__.playSound)();
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_5___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "notification-settings-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "toggle-switch-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: notificationLabel.enableSoundNotificationSettings }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-toggle-switch", Object.assign({ label: notificationLabel.enableSoundNotificationSettings, description: notificationLabel.enableSoundNotificationSettingsDescription, onClick: soundHandler }, (defaultSettings.sound ? { checked: true } : "")))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "settings-description" }, { children: notificationLabel.enableSoundNotificationSettingsDescription })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "settings-description volume-title" }, { children: notificationLabel.volumeTitle })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "notification-sound-slider" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "slider" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "range", min: "0", max: "100", className: "sliderInput", value: !mute ? volume * 100 : 0, onChange: volumeHandler, onMouseUp: soundNotificationTelemetryTracker, disabled: !sound, "aria-label": notificationLabel.notificationVolume, tabIndex: 0 }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "speaker" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ color: "color-none" }, (!sound ? { disabled: true } : ""), { ariaLabel: !mute ? notificationLabel.muteVolume : notificationLabel.unmuteVolume, onClick: sound && muteHandler, circle: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: mute ? "speaker-muted_16" : "speaker_16" }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "play" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ color: "color-none" }, (!sound ? { disabled: true } : ""), { ariaLabel: notificationLabel.playSound, onClick: sound && playHandler, circle: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: "play_16" }) })) }))] }))] })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NotificationSettingsBarSound);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/ProfileSettings/ProfileSettings.tsx":
/*!*********************************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/ProfileSettings/ProfileSettings.tsx ***!
  \*********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-mfe-wc-based */ "@agentx/agentx-mfe-wc-based");
/* harmony import */ var _agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../sdk */ "./src/sdk.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





const ProfileSettings = ({ userRole, selectedRoleName, teamName, teamId, teams, voiceOptions, initialLoginOption, isRememberMyCredentials, isMonitoringEnabled, isDefaultDnSet, availableExtensions, defaultExtension, defaultNumber, dialPlan, sendAllUpdates }) => {
    var _a;
    const { agentProfile } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const settingsRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const [isSaveClicked, setIsSaveClicked] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
    const [errorType, setErrorType] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("none");
    const [errorMessage, setErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const initialProfileConfig = {
        role: userRole.join("_"),
        dialNumber: defaultNumber,
        team: {
            teamName,
            teamId
        },
        extensionNumber: defaultExtension,
        loginOption: initialLoginOption,
        isRememberMeChecked: isRememberMyCredentials
    };
    const hasProfileChanged = (newProfileDetails) => {
        const loginOptionChanged = initialProfileConfig.loginOption !== newProfileDetails.loginOption;
        const rolesChanged = initialProfileConfig.role !== newProfileDetails.role && initialProfileConfig.role !== "agent";
        const dialNumberChanged = newProfileDetails.loginOption === "AGENT_DN" && initialProfileConfig.dialNumber !== newProfileDetails.dialNumber;
        const teamChanged = initialProfileConfig.team.teamName !== newProfileDetails.team.teamName ||
            initialProfileConfig.team.teamId !== newProfileDetails.team.teamId;
        const extensionNumberChanged = newProfileDetails.loginOption === "EXTENSION" &&
            initialProfileConfig.extensionNumber !== newProfileDetails.extensionNumber;
        const checkboxChanged = initialProfileConfig.isRememberMeChecked !== newProfileDetails.isRememberMeChecked;
        const result = loginOptionChanged ||
            rolesChanged ||
            dialNumberChanged ||
            teamChanged ||
            extensionNumberChanged ||
            checkboxChanged;
        _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[ProfileSettings] profile details have changed: ", result);
        return result;
    };
    const handleUserProfileDataAvailable = (event) => __awaiter(void 0, void 0, void 0, function* () {
        _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[ProfileSettings] Receiving complete data from component. Saving...");
        const newProfileConfig = Object.assign({}, event.detail.data);
        setIsSaveClicked(!isSaveClicked);
        if (hasProfileChanged(newProfileConfig)) {
            // when user has role 'agent', the event will not contain a populated role as it's not a selection in UI
            if (newProfileConfig.role === "" && initialProfileConfig.role === "agent") {
                newProfileConfig.role = initialProfileConfig.role;
            }
            if (!(yield hasBrowserError(newProfileConfig.loginOption))) {
                sendAllUpdates(newProfileConfig);
            }
        }
    });
    const handleComponentUpdated = (event) => {
        _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[ProfileSettings] Updating profile settings. Profile is complete: ", event.detail.isComplete);
        const newProfileConfig = Object.assign({}, event.detail.data);
        const profileHasChanged = hasProfileChanged(newProfileConfig);
        if (newProfileConfig.loginOption !== "BROWSER") {
            setErrorType("none");
            setErrorMessage("");
        }
        setIsSaveButtonDisabled(!profileHasChanged || !event.detail.isComplete);
    };
    const hasBrowserError = (loginOption) => __awaiter(void 0, void 0, void 0, function* () {
        if (loginOption !== "BROWSER") {
            return false;
        }
        let errorType = "none";
        let errorMessage = "";
        if (!(0,_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__.isWebRtcSupportedBrowser)()) {
            errorType = "unknown";
            errorMessage = agentProfile.browserUnsupportedError;
        }
        if (yield (0,_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__.isMicrophoneAccessDenied)()) {
            errorType = "unknown";
            errorMessage = agentProfile.microphoneAccessDeniedError;
        }
        setErrorType(errorType);
        setErrorMessage(errorMessage);
        return errorType !== "none";
    });
    const handleSaveClicked = () => {
        if (!isSaveButtonDisabled) {
            setIsSaveClicked(!isSaveClicked);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (settingsRef && settingsRef.current) {
            const userProfile = settingsRef.current;
            userProfile.addEventListener("data-available", handleUserProfileDataAvailable);
            userProfile.addEventListener("component-updated", handleComponentUpdated);
            return () => {
                userProfile.removeEventListener("data-available", handleUserProfileDataAvailable);
                userProfile.removeEventListener("component-updated", handleComponentUpdated);
            };
        }
        return () => { };
    }, []);
    const getDialPlanRegexes = () => {
        var _a;
        return (_a = dialPlan === null || dialPlan === void 0 ? void 0 : dialPlan.dialPlanEntity) === null || _a === void 0 ? void 0 : _a.map((plan) => {
            return plan.regex;
        });
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "profile-settings" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "user-profile-wrapper" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("uuip-wc-user-profile", Object.assign({ ref: settingsRef, userRole: userRole.join("_"), preferenceRoleName: selectedRoleName, isCallMonitoringEnabled: isMonitoringEnabled, teams: JSON.stringify(teams), defaultTeam: JSON.stringify({ teamName, teamId }), loginVoiceOptions: JSON.stringify(voiceOptions) }, (isDefaultDnSet ? { isReadonlyNumber: true } : ""), (isSaveClicked ? { getProfileDataTriggered: true } : ""), (initialLoginOption ? { defaultVoiceOption: initialLoginOption } : ""), { defaultDialNumber: defaultNumber, defaultExtension: defaultExtension }, ((availableExtensions === null || availableExtensions === void 0 ? void 0 : availableExtensions.length) > 0 ? { extensions: JSON.stringify(availableExtensions) } : ""), (isRememberMyCredentials ? { isRememberMeChecked: true } : ""), (((_a = dialPlan === null || dialPlan === void 0 ? void 0 : dialPlan.dialPlanEntity) === null || _a === void 0 ? void 0 : _a.length) > 0
                    ? { dialPlanRegexStrings: JSON.stringify(getDialPlanRegexes()) }
                    : ""), { errorType: errorType, errorMessage: errorMessage })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "save-profile-wrapper" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ "data-testid": "save-profile-button", className: "save-profile-button", onClick: handleSaveClicked, variant: "primary", ariaLabel: agentProfile.saveLabel }, (isSaveButtonDisabled ? { disabled: true } : ""), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "check_16", size: "20" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "save-profile-btn" }, { children: agentProfile.saveLabel }))] })) }))] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProfileSettings);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/MicroPhoneComponent.tsx":
/*!****************************************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/SpeakerMicSettings/MicroPhoneComponent.tsx ***!
  \****************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/AgentProfile/constants.ts");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../styles.css */ "./src/direflow-components/AgentProfile/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _SpeakerMicSettingsBar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./SpeakerMicSettingsBar */ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/SpeakerMicSettingsBar.tsx");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils */ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/utils.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







const MicrophoneComponent = (props) => {
    const { agentProfileProps, logger, isMicAccessDenied, microphonesArray, microphoneOption, selectedSpeakerId, onDeviceChange } = props;
    const [testButtonLabelMic, setTestButtonMicLabel] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(agentProfileProps.test);
    const [isMicRecording, setIsMicRecording] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isMicPlaying, setIsMicPlaying] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [inputDeviceId, setInputDeviceId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const timerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(-1);
    const audio = document.createElement("audio");
    audio.onended = () => {
        logger.info("[WebRtc]: Playing the recording has ended...");
        setTestButtonMicLabel(agentProfileProps.test);
        setIsMicPlaying(false);
    };
    const startAudioRecording = () => {
        logger.info("[WebRtc]: Recording Audio...");
        // If a previous audio recording is playing, pause it
        const recorderAudioIsPlaying = !audio.paused; // the paused property tells whether the media element is paused or not
        logger.info("[WebRtc]: paused?", !recorderAudioIsPlaying);
        if (recorderAudioIsPlaying) {
            audio.pause();
        }
        // start recording using the audio recording API
        _utils__WEBPACK_IMPORTED_MODULE_6__.audioRecorder.start(inputDeviceId).catch((error) => {
            // on error
            logger.error(`[WebRtc]: An error occurred with the error name ${error.name}, error message: ${error.message}`);
        });
    };
    /** Plays recorded audio using the audio element in the HTML document
     * @param {Blob} recorderAudioAsBlob - recorded audio as a Blob Object
     */
    function playAudio(recorderAudioAsBlob) {
        // read content of files (Blobs) asynchronously
        const reader = new FileReader();
        // once content has been read
        reader.onload = (e) => {
            var _a;
            // store the base64 URL that represents the URL of the recording audio
            const base64URL = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.result;
            const ac = new AudioContext();
            const o = ac.createOscillator();
            o.start();
            const dest = ac.createMediaStreamDestination();
            o.connect(dest);
            // set the audio element's source using the base64 URL
            audio.src = base64URL;
            // call the load method as it is used to update the audio element after changing the source or other settings
            audio.load();
            // play the audio after successfully setting new src and type that corresponds to the recorded audio
            logger.info("[WebRtc]: Playing audio...");
            audio.play();
            // The oscillator will play through the audio element
            // calling the audio.setSinkId() with the deviceId of a connected output device.
            if (audio.setSinkId) {
                audio.setSinkId(selectedSpeakerId);
            }
        };
        // read content and convert it to a URL (base64)
        reader.readAsDataURL(recorderAudioAsBlob);
    }
    /** Stop the currently started audio recording & sends it
     */
    function stopAudioRecording() {
        logger.info("[WebRtc]: Stopping Audio Recording...");
        // stop the recording using the audio recording API
        _utils__WEBPACK_IMPORTED_MODULE_6__.audioRecorder
            .stop()
            .then((audioAsblob) => {
            // Play recorder audio
            playAudio(audioAsblob);
        })
            .catch((error) => {
            // Error handling structure
            logger.error(`[WebRtc]: An error occurred with the error name ${error.name}`);
        });
    }
    const stopRecording = () => {
        setTestButtonMicLabel(agentProfileProps.playing);
        setIsMicRecording(false);
        setIsMicPlaying(true);
        stopAudioRecording();
    };
    const testMicroPhoneAudioFn = () => {
        // call the test function only when access is allowed
        if (!isMicAccessDenied) {
            if (testButtonLabelMic === agentProfileProps.test) {
                setTestButtonMicLabel(agentProfileProps.recording);
                setIsMicRecording(true);
                startAudioRecording();
                const stopRecordingFn = window.setTimeout(() => {
                    stopRecording();
                }, _constants__WEBPACK_IMPORTED_MODULE_3__.VOICE_RECORDING_DURATION);
                timerRef.current = stopRecordingFn;
            }
            else if (testButtonLabelMic === agentProfileProps.recording) {
                stopRecording();
                if (timerRef) {
                    window.clearTimeout(timerRef.current);
                }
            }
        }
    };
    const onMicroPhoneDropdownChange = (label) => __awaiter(void 0, void 0, void 0, function* () {
        if (label) {
            const deviceId = yield (0,_utils__WEBPACK_IMPORTED_MODULE_6__.getInputDeviceId)(label);
            if (deviceId) {
                setInputDeviceId(deviceId);
                onDeviceChange(deviceId);
            }
        }
    });
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_4___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpeakerMicSettingsBar__WEBPACK_IMPORTED_MODULE_5__["default"], { label: agentProfileProps.mic, description: agentProfileProps.micDescription, dropDownOptions: microphonesArray, testFunction: testMicroPhoneAudioFn, selectedOption: microphoneOption, testButtonLabel: testButtonLabelMic, onDropdownChange: onMicroPhoneDropdownChange, isPlaying: isMicPlaying, isRecording: isMicRecording, onPlayMessage: agentProfileProps.onMicPlay, onRecordMessage: agentProfileProps.onMicRecord, isAccessDenied: isMicAccessDenied, errorMsg: agentProfileProps.micError }) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MicrophoneComponent);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/SpeakerComponent.tsx":
/*!*************************************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/SpeakerMicSettings/SpeakerComponent.tsx ***!
  \*************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/AgentProfile/constants.ts");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../styles.css */ "./src/direflow-components/AgentProfile/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _SpeakerMicSettingsBar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./SpeakerMicSettingsBar */ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/SpeakerMicSettingsBar.tsx");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils */ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/utils.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







const SpeakerComponent = (props) => {
    const { agentProfileProps, speakerAccessDenied, speakersArray, speakerOption, saveSpeakerSettings, speakerSettings, muteButtonClickHandler, onDeviceChange } = props;
    const [speakerIcon, setSpeakerIcon] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_constants__WEBPACK_IMPORTED_MODULE_3__.speakerMicIconSettings.speaker);
    const [muteSpeaker, setMuteSpeaker] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(speakerSettings.speaker.mute);
    const [testButtonLabelSpeaker, setTestButtonSpeakerLabel] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(agentProfileProps.test);
    const [speakerVolume, setSpeakerVolume] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(speakerSettings.speaker.volume);
    const [selectedSpeakersDeviceId, setSelectedSpeakersDeviceId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [isSpeakerPlaying, setIsSpeakerPlaying] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const speakerAudio = document.createElement("audio");
    speakerAudio.onended = () => {
        setTestButtonSpeakerLabel(agentProfileProps.test);
        setIsSpeakerPlaying(false);
    };
    const testSpeakerAudioFn = () => {
        if (!speakerAccessDenied) {
            setTestButtonSpeakerLabel(agentProfileProps.playing);
            setIsSpeakerPlaying(true);
            const ac = new AudioContext();
            const o = ac.createOscillator();
            o.start();
            const dest = ac.createMediaStreamDestination();
            o.connect(dest);
            speakerAudio.src = _constants__WEBPACK_IMPORTED_MODULE_3__.AUDIO_FILE;
            speakerAudio.load();
            speakerAudio.volume = speakerSettings.speaker.volume;
            speakerAudio.muted = speakerSettings.speaker.mute;
            speakerAudio.play();
            if (speakerAudio.setSinkId) {
                speakerAudio.setSinkId(selectedSpeakersDeviceId);
            }
        }
    };
    const toggleSpeaker = () => {
        setMuteSpeaker(!muteSpeaker);
        muteButtonClickHandler(_constants__WEBPACK_IMPORTED_MODULE_3__.SPEAKER, muteSpeaker);
    };
    const handleSpeakerSliderChange = (value) => {
        speakerSettings.speaker.volume = value / _constants__WEBPACK_IMPORTED_MODULE_3__.SLIDER_MAX_RANGE;
        setSpeakerVolume(speakerSettings.speaker.volume);
        if (speakerSettings.speaker.volume === 0) {
            speakerSettings.speaker.mute = true;
            setMuteSpeaker(true);
        }
        else {
            speakerSettings.speaker.mute = false;
            setMuteSpeaker(false);
        }
        saveSpeakerSettings();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        setSpeakerIcon(muteSpeaker ? _constants__WEBPACK_IMPORTED_MODULE_3__.speakerMicIconSettings.mutedSpeaker : _constants__WEBPACK_IMPORTED_MODULE_3__.speakerMicIconSettings.speaker);
    }, [muteSpeaker]);
    const onSpeakerPhoneDropdownChange = (label) => __awaiter(void 0, void 0, void 0, function* () {
        if (label) {
            const deviceId = yield (0,_utils__WEBPACK_IMPORTED_MODULE_6__.getOutputDeviceId)(label);
            if (deviceId) {
                setSelectedSpeakersDeviceId(deviceId);
                onDeviceChange(deviceId);
            }
        }
    });
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_4___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpeakerMicSettingsBar__WEBPACK_IMPORTED_MODULE_5__["default"], { label: agentProfileProps.speaker, description: agentProfileProps.speakerDescription, dropDownOptions: speakersArray, testFunction: testSpeakerAudioFn, selectedOption: speakerOption, onSliderChange: handleSpeakerSliderChange, sliderValue: !muteSpeaker ? speakerVolume * 100 : 0, iconName: speakerIcon, iconPress: toggleSpeaker, testButtonLabel: testButtonLabelSpeaker, onDropdownChange: onSpeakerPhoneDropdownChange, isPlaying: isSpeakerPlaying, onPlayMessage: agentProfileProps.onSpeakerPlay, isAccessDenied: speakerAccessDenied, errorMsg: agentProfileProps.speakerError, isRecording: undefined, onRecordMessage: undefined, isSpeaker: true }) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SpeakerComponent);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/SpeakerMicSettingsBar.tsx":
/*!******************************************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/SpeakerMicSettings/SpeakerMicSettingsBar.tsx ***!
  \******************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../styles.css */ "./src/direflow-components/AgentProfile/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_5__);






const SpeakerMicSettingsBar = (props) => {
    const { label, description, dropDownOptions, testFunction, selectedOption, iconName, iconPress, testButtonLabel, onSliderChange, sliderValue, onDropdownChange, isPlaying, isRecording, onPlayMessage, onRecordMessage, isAccessDenied, errorMsg, isSpeaker } = props;
    const comboBoxRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const updateOnInputChange = (e) => {
        var _a, _b;
        if ((_a = e.detail) === null || _a === void 0 ? void 0 : _a.option) {
            onDropdownChange((_b = e.detail.option) === null || _b === void 0 ? void 0 : _b.label);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const element = comboBoxRef.current;
        if (element) {
            element.addEventListener("dropdown-selected", updateOnInputChange);
        }
        return () => {
            if (element) {
                element.removeEventListener("dropdown-selected", updateOnInputChange);
            }
        };
    }, []);
    const sliderChangeHandler = (value) => {
        if (onSliderChange) {
            onSliderChange(value);
        }
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_5___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "settings-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "label-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ "aria-label": label }, { children: label })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "settings-description mic-speaker", "aria-label": description }, { children: description })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-dropdown", Object.assign({ class: "speakerMic-dropdown", options: JSON.stringify(dropDownOptions), "option-id": "ID", "option-value": "label", defaultOption: JSON.stringify(selectedOption), ref: comboBoxRef, "aria-label": selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label, title: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || "", "custom-tab-index": "0", "data-testid": `${label}_dropdown` }, (isAccessDenied ? { disabled: true } : ""), (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "notification-sound-slider" }, { children: [isSpeaker && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "slider" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "range", min: "0", max: "100", className: "sliderInput", value: sliderValue, onChange: (e) => sliderChangeHandler(e.target.value), disabled: false, "aria-label": `${label}_slider`, tabIndex: 0, "data-testid": `${label}_slider` }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "speaker" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ color: "color-none", ariaLabel: `${label}_mute_button`, onClick: iconPress, circle: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", ariaLabel: `${label}_mute_button`, name: iconName, "data-testid": `${label}_${iconName}` }) })) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: `${label.toLowerCase()}-test-button` }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ id: `${label}_${testButtonLabel}`, "data-testid": `${label}_${testButtonLabel}`, ariaLabel: testButtonLabel, onClick: testFunction }, (isAccessDenied ? { disabled: true } : ""), { children: testButtonLabel })) }))] })), isAccessDenied && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "mic-error-message" }, { children: !isSpeaker ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "error-icon" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "error-legacy-badge-filled", size: "12", iconSet: "momentumDesign" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "error-text" }, { children: errorMsg }))] })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "speaker-error-text" }, { children: errorMsg }))) }))), isPlaying && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "play-message" }, { children: onPlayMessage })), isRecording && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "record-message" }, { children: onRecordMessage }))] })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__.observer)(SpeakerMicSettingsBar));


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/speakerMicrophoneComponent.tsx":
/*!***********************************************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/SpeakerMicSettings/speakerMicrophoneComponent.tsx ***!
  \***********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/AgentProfile/constants.ts");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../styles.css */ "./src/direflow-components/AgentProfile/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _MicroPhoneComponent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./MicroPhoneComponent */ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/MicroPhoneComponent.tsx");
/* harmony import */ var _SpeakerComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./SpeakerComponent */ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/SpeakerComponent.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};








const SpeakerMicrophoneComponent = (props) => {
    var _a, _b;
    const { agentProfileProps, logger, isMicAccessDenied, selectedInputDeviceId, selectedOutputDeviceId } = props;
    const soundMicSettingsString = localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_4__.SPEAKER_MIC_SOUND_SETTINGS) || _constants__WEBPACK_IMPORTED_MODULE_4__.SPEAKER_MIC_SOUND_DEFAULT_SETTINGS;
    const speakerMicSettings = soundMicSettingsString && JSON.parse(soundMicSettingsString);
    const [microphonesArray, setMicrophones] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [speakersArray, setSpeakers] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [microphoneOption, setMicrophoneSelectedOption] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({});
    const [speakerOption, setSpeakersSelectedOption] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({});
    const [micAccessDenied, setMicAccessDenied] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(isMicAccessDenied);
    const [speakerAccessDenied, setSpeakerAccessDenied] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [selectedSpeakerId, setSelectedSpeakerId] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [isInputDeviceChanged, setInputDeviceChanged] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [isOutputDeviceChanged, setOutputDeviceChanged] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const dispatch = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.EventContext);
    const Media = (_b = (_a = window === null || window === void 0 ? void 0 : window.callingClient) === null || _a === void 0 ? void 0 : _a.mediaEngine) === null || _b === void 0 ? void 0 : _b.Media;
    const eventDispatchHandler = (eventName, deviceObj) => {
        const event = new CustomEvent(eventName, deviceObj);
        if (dispatch) {
            dispatch(event);
            logger.info(`[WebRtc]: ${eventName} event dispatched`);
        }
    };
    /**
     * Save Settings to local storage
     */
    const saveSpeakerMicSettings = lodash__WEBPACK_IMPORTED_MODULE_2___default().debounce(() => {
        eventDispatchHandler("ax-speaker-mic-setting-update", {
            detail: { speakerMicSettings },
            bubbles: true,
            composed: true
        });
        localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_4__.SPEAKER_MIC_SOUND_SETTINGS, JSON.stringify(speakerMicSettings));
    }, 300);
    const muteButtonClickHandler = (settingName, muteFlag) => {
        speakerMicSettings[settingName].mute = muteFlag;
        if (speakerMicSettings[settingName].volume === 0 && muteFlag) {
            speakerMicSettings[settingName].volume = _constants__WEBPACK_IMPORTED_MODULE_4__.DEFAULT_VOLUME;
        }
        speakerMicSettings[settingName].mute = !muteFlag;
        saveSpeakerMicSettings();
    };
    const checkMicError = (micArray) => {
        return micArray.length === 1 && micArray[0].ID === "" ? setMicAccessDenied(true) : setMicAccessDenied(false);
    };
    /**
     * Get Microphones
     */
    const getMicroPhones = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const microphones = yield (Media === null || Media === void 0 ? void 0 : Media.getMicrophones());
            const microphonesArrayObj = microphones === null || microphones === void 0 ? void 0 : microphones.map((obj) => {
                return { ID: obj.ID, label: obj.label };
            });
            setMicrophones(microphonesArrayObj.length === 1 && microphonesArrayObj[0].ID === "" ? [] : microphonesArrayObj);
            checkMicError(microphonesArrayObj);
            //Selecting first microphone as default as Firefox doesn't return default microphone
            //https://tinyurl.com/45sdeejt
            const defaultMicId = navigator.userAgent.includes("Firefox") ? microphonesArrayObj[0].ID : _constants__WEBPACK_IMPORTED_MODULE_4__.DEFAULT_DEVICE_ID;
            // If there's a change in input device set to default else set to user's selection
            const selectedOptionID = isInputDeviceChanged ? defaultMicId : (selectedInputDeviceId === null || selectedInputDeviceId === void 0 ? void 0 : selectedInputDeviceId.toString()) || defaultMicId;
            const defaultMic = microphonesArrayObj === null || microphonesArrayObj === void 0 ? void 0 : microphonesArrayObj.find((deviceObject) => deviceObject.ID === selectedOptionID);
            setMicrophoneSelectedOption(defaultMic);
            setInputDeviceChanged(false);
            logger.info(`[WebRtc]: Default Microphone, ${defaultMic}`);
            logger.info(`[WebRtc]: Loaded Microphones , ${microphonesArray}`);
        }
        catch (error) {
            logger.error(`[WebRtc]: Failed to Load Microphones ,${error}`);
            setMicrophoneSelectedOption({});
        }
    });
    const checkSpeakerError = (spArray) => {
        return spArray.length === 1 && spArray[0].ID === "" ? setSpeakerAccessDenied(true) : setSpeakerAccessDenied(false);
    };
    /**
     * Get Speakers
     */
    const getSpeakers = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const speakers = yield (Media === null || Media === void 0 ? void 0 : Media.getSpeakers());
            const speakersArrayObj = speakers === null || speakers === void 0 ? void 0 : speakers.map((obj) => {
                return { ID: obj.ID, label: obj.label };
            });
            setSpeakers(speakersArrayObj.length === 1 && speakersArrayObj[0].ID === "" ? [] : speakersArrayObj);
            checkSpeakerError(speakersArrayObj);
            //Selecting first speaker as default as Firefox doesn't return default speaker
            //https://tinyurl.com/45sdeejt
            const defaultSpeakerId = navigator.userAgent.includes("Firefox") ? speakersArrayObj[0].ID : _constants__WEBPACK_IMPORTED_MODULE_4__.DEFAULT_DEVICE_ID;
            // If there's a change in output device set to default else set to user's selection
            const selectedOption = isOutputDeviceChanged
                ? defaultSpeakerId
                : selectedOutputDeviceId.toString() || defaultSpeakerId;
            const defaultSpeaker = speakersArrayObj === null || speakersArrayObj === void 0 ? void 0 : speakersArrayObj.find((deviceObject) => deviceObject.ID === selectedOption);
            setSpeakersSelectedOption(defaultSpeaker);
            setOutputDeviceChanged(false);
            logger.info(`[WebRtc]: Default Speaker, ${defaultSpeaker}`);
            logger.info(`[WebRtc]: Loaded Speakers , ${speakersArray}`);
        }
        catch (error) {
            logger.error(`[WebRtc]: Failed to Load Speakers , ${error}`);
            setSpeakerAccessDenied(true);
            setSpeakersSelectedOption({});
        }
    });
    /**
     * Get the Media devices used in system
     */
    const getMediaDevices = () => {
        getMicroPhones();
        getSpeakers();
    };
    /**
     * Change input device so input devices are fetched again
     */
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if (isOutputDeviceChanged) {
            getSpeakers();
        }
    }, [isOutputDeviceChanged]);
    /**
     * Change in output device so output devices are fetched again
     */
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if (isInputDeviceChanged) {
            getMicroPhones();
        }
    }, [isInputDeviceChanged]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        getMediaDevices();
        Media === null || Media === void 0 ? void 0 : Media.on("device:changed", () => {
            // When a new device is added/removed device change is fired so as to fetch new set of devices
            setInputDeviceChanged(true);
            setOutputDeviceChanged(true);
        });
    }, []);
    /**
     * On every input device change store that to a store variable so as to retain it back
     * @param deviceId
     */
    const inputDeviceChangeHandler = (deviceId) => {
        setInputDeviceChanged(false);
        eventDispatchHandler("ax-input-device-change", {
            detail: { selectedInputDeviceId: deviceId },
            bubbles: true,
            composed: true
        });
    };
    /**
     * On every output device change store that to a store variable so as to retain it back
     * @param deviceId
     */
    const outputDeviceChangeHandler = (deviceId) => {
        setSelectedSpeakerId(deviceId);
        setOutputDeviceChanged(false);
        eventDispatchHandler("ax-output-device-change", {
            detail: { selectedOutputDeviceId: deviceId },
            bubbles: true,
            composed: true
        });
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_5___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "speaker-mic-settings-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpeakerComponent__WEBPACK_IMPORTED_MODULE_7__["default"], { agentProfileProps: agentProfileProps, speakerAccessDenied: speakerAccessDenied, speakersArray: speakersArray, speakerOption: speakerOption, saveSpeakerSettings: saveSpeakerMicSettings, speakerSettings: speakerMicSettings, muteButtonClickHandler: muteButtonClickHandler, onDeviceChange: outputDeviceChangeHandler }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "speaker-mic-settings-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MicroPhoneComponent__WEBPACK_IMPORTED_MODULE_6__["default"], { agentProfileProps: agentProfileProps, logger: logger, isMicAccessDenied: micAccessDenied, microphonesArray: microphonesArray, microphoneOption: microphoneOption, selectedSpeakerId: selectedSpeakerId, onDeviceChange: inputDeviceChangeHandler }) }))] }) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SpeakerMicrophoneComponent);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/SpeakerMicSettings/utils.ts":
/*!*************************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/SpeakerMicSettings/utils.ts ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   audioRecorder: () => (/* binding */ audioRecorder),
/* harmony export */   getInputDeviceId: () => (/* binding */ getInputDeviceId),
/* harmony export */   getOutputDeviceId: () => (/* binding */ getOutputDeviceId)
/* harmony export */ });
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const getOutputDeviceId = (selectedDeviceLabel) => __awaiter(void 0, void 0, void 0, function* () {
    const devices = yield navigator.mediaDevices.enumerateDevices();
    const audioDevices = devices.filter((device) => {
        return device.kind === "audiooutput";
    });
    const mediaDeviceInfo = audioDevices.find((deviceObject) => deviceObject.label === selectedDeviceLabel);
    return mediaDeviceInfo === null || mediaDeviceInfo === void 0 ? void 0 : mediaDeviceInfo.deviceId;
});
const getInputDeviceId = (selectedDeviceLabel) => __awaiter(void 0, void 0, void 0, function* () {
    const devices = yield navigator.mediaDevices.enumerateDevices();
    const audioDevices = devices.filter((device) => {
        return device.kind === "audioinput";
    });
    const mediaDeviceInfo = audioDevices.find((deviceObject) => deviceObject.label === selectedDeviceLabel);
    return mediaDeviceInfo === null || mediaDeviceInfo === void 0 ? void 0 : mediaDeviceInfo.deviceId;
});
const getBlobObject = (audioRecorder, mimeType, resolve) => {
    // create a single blob object, as we might have gathered a few Blob objects that needs to be joined as one
    const audioBlob = new Blob(audioRecorder.audioBlobs, { type: mimeType });
    // resolve promise with the single audio blob representing the recorded audio
    resolve(audioBlob);
};
const storeBlobs = (audioRecorder, data) => {
    // store audio Blob object
    return audioRecorder.audioBlobs.push(data);
};
const audioRecorder = {
    /** Stores the recorded audio as Blob objects of audio data as the recording continues */
    audioBlobs: [] /* of type Blob[] */,
    /** Stores the reference of the MediaRecorder instance that handles the MediaStream when recording starts */
    mediaRecorder: null /* of type MediaRecorder */,
    /** Stores the reference to the stream currently capturing the audio */
    streamBeingCaptured: null /* of type MediaStream */,
    /** Start recording the audio
     * @returns {Promise} - returns a promise that resolves if audio recording successfully started
     */
    start: (inputDeviceID) => {
        // Feature Detection
        if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
            // Feature is not supported in browser
            // return a custom error
            return Promise.reject(new Error("mediaDevices API or getUserMedia method is not supported in this browser."));
        }
        // Feature is supported in browser
        const constraints = {
            audio: {
                // passing the selected input device in constraints
                deviceId: inputDeviceID
            }
        };
        // create an audio stream
        return (navigator.mediaDevices
            .getUserMedia(constraints /* of type MediaStreamConstraints */)
            // returns a promise that resolves to the audio stream
            .then((stream) => {
            // save the reference of the stream to be able to stop it when necessary
            audioRecorder.streamBeingCaptured = stream;
            // create a media recorder instance by passing that stream into the MediaRecorder constructor
            audioRecorder.mediaRecorder = new MediaRecorder(stream); /* the MediaRecorder interface of the MediaStream Recording
                        API provides functionality to easily record media */
            // clear previously saved audio Blobs, if any
            audioRecorder.audioBlobs = [];
            // add a dataavailable event listener in order to store the audio data Blobs when recording
            audioRecorder.mediaRecorder.addEventListener("dataavailable", (event) => storeBlobs(audioRecorder, event.data));
            // start the recording by calling the start method on the media recorder
            audioRecorder.mediaRecorder.start();
        }));
        /* errors are not handled in the API because if its handled and the promise is chained, the .then after the catch will be executed */
    },
    /** Stop the started audio recording
     * @returns {Promise} - returns a promise that resolves to the audio as a blob file
     */
    stop() {
        // return a promise that would return the blob or URL of the recording
        return new Promise((resolve) => {
            if (audioRecorder.mediaRecorder) {
                // save audio type to pass to set the Blob type
                const { mimeType } = audioRecorder.mediaRecorder;
                // listen to the stop event in order to create & return a single Blob object
                audioRecorder.mediaRecorder.addEventListener("stop", () => getBlobObject(audioRecorder, mimeType, resolve));
                audioRecorder.cancel();
            }
        });
    },
    /** Cancel audio recording */
    cancel() {
        // stop the recording feature
        if (audioRecorder.mediaRecorder) {
            audioRecorder.mediaRecorder.stop();
            if (audioRecorder) {
                // stop all the tracks on the active stream in order to stop the stream
                audioRecorder.stopStream();
                // reset API properties for next recording
                audioRecorder.resetRecordingProperties();
            }
        }
    },
    /** Stop all the tracks on the active stream in order to stop the stream and remove
     * the red flashing dot showing in the tab
     */
    stopStream() {
        // stopping the capturing request by stopping all the tracks on the active stream
        if (audioRecorder.streamBeingCaptured) {
            audioRecorder.streamBeingCaptured
                .getTracks() // get all tracks from the stream
                .forEach((track) => track.stop()); // stop each one
        }
    },
    /** Reset all the recording properties including the media recorder and stream being captured */
    resetRecordingProperties() {
        if (audioRecorder.mediaRecorder) {
            audioRecorder.mediaRecorder.removeEventListener("dataavailable", (event) => storeBlobs(audioRecorder, event.data));
            const { mimeType } = audioRecorder.mediaRecorder;
            const resolve = () => {
                /* To remove the lister callback */
            };
            audioRecorder.mediaRecorder.removeEventListener("stop", () => getBlobObject(audioRecorder, mimeType, resolve));
            audioRecorder.mediaRecorder = null;
            audioRecorder.streamBeingCaptured = null;
        }
        /* No need to remove event listeners attached to mediaRecorder as
              If a DOM element which is removed is reference-free (no references pointing to it), the element itself is picked
              up by the garbage collector as well as any event handlers/listeners associated with it.
              getEventListeners(audioRecorder.mediaRecorder) will return an empty array of events. */
    }
};


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/TeamsList/TeamMenuItem.tsx":
/*!************************************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/TeamsList/TeamMenuItem.tsx ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../styles.css */ "./src/direflow-components/AgentProfile/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_4__);





const TeamMenuItem = ({ teamName, teamId, onSelectTeam }) => {
    const [isTextOverflow, setTextOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const teamOptionTextRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        const textContainer = teamOptionTextRef.current;
        let isTextOverflowing;
        if (textContainer) {
            isTextOverflowing = textContainer.offsetWidth < textContainer.scrollWidth;
        }
        setTextOverflow(isTextOverflowing);
    }, []);
    const handleKeyDown = (e) => {
        e.preventDefault();
        if (e.key === "Enter" || e.key === " ") {
            onSelectTeam({ name: teamName, id: teamId });
        }
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_4___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-list-item", Object.assign({ slot: "list-item", class: "team-menu-item", id: `id-${teamName}`, "aria-label": teamName, onClick: () => {
                onSelectTeam({ name: teamName, id: teamId });
            }, onKeyDown: handleKeyDown }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: teamName }, (!isTextOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ ref: teamOptionTextRef, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("team-name-option-text", "value-ellipsis") }, { children: teamName })) })) }), `status-${teamName}`) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TeamMenuItem);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/components/index.tsx":
/*!*******************************************************************!*\
  !*** ./src/direflow-components/AgentProfile/components/index.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../styles.css */ "./src/direflow-components/AgentProfile/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Menu */ "./src/direflow-components/AgentProfile/components/Menu/index.tsx");





/**
 * AgentStateSelector MFE
 * This Micro Front End provides the interface for selecting among the application provided agent state options
 * @param props
 */
const AgentProfile = (props) => {
    const { profileProps } = props;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: (_styles_css__WEBPACK_IMPORTED_MODULE_3___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "agent-profile" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Menu__WEBPACK_IMPORTED_MODULE_4__["default"], Object.assign({}, profileProps)) })) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AgentProfile);


/***/ }),

/***/ "./src/direflow-components/AgentProfile/constants.ts":
/*!***********************************************************!*\
  !*** ./src/direflow-components/AgentProfile/constants.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AUDIO_FILE: () => (/* binding */ AUDIO_FILE),
/* harmony export */   BROWSER: () => (/* binding */ BROWSER),
/* harmony export */   DEFAULT_DEVICE_ID: () => (/* binding */ DEFAULT_DEVICE_ID),
/* harmony export */   DEFAULT_VOLUME: () => (/* binding */ DEFAULT_VOLUME),
/* harmony export */   DESKTOP_HIDE_WEBEX_CALLING_NOTIFICATIONS_SETTING: () => (/* binding */ DESKTOP_HIDE_WEBEX_CALLING_NOTIFICATIONS_SETTING),
/* harmony export */   MICROPHONE: () => (/* binding */ MICROPHONE),
/* harmony export */   MICROPHONE_LABEL: () => (/* binding */ MICROPHONE_LABEL),
/* harmony export */   SLIDER_MAX_RANGE: () => (/* binding */ SLIDER_MAX_RANGE),
/* harmony export */   SPEAKER: () => (/* binding */ SPEAKER),
/* harmony export */   SPEAKERS_LABEL: () => (/* binding */ SPEAKERS_LABEL),
/* harmony export */   SPEAKER_MIC_SOUND_DEFAULT_SETTINGS: () => (/* binding */ SPEAKER_MIC_SOUND_DEFAULT_SETTINGS),
/* harmony export */   SPEAKER_MIC_SOUND_SETTINGS: () => (/* binding */ SPEAKER_MIC_SOUND_SETTINGS),
/* harmony export */   VOICE_RECORDING_DURATION: () => (/* binding */ VOICE_RECORDING_DURATION),
/* harmony export */   speakerMicIconSettings: () => (/* binding */ speakerMicIconSettings)
/* harmony export */ });
const speakerMicIconSettings = {
    mic: "microphone_16",
    speaker: "speaker_16",
    mutedMic: "microphone-muted_16",
    mutedSpeaker: "speaker-muted_16"
};
const SPEAKER_MIC_SOUND_DEFAULT_SETTINGS = '{"mic":{"sound":true,"volume":0.8,"mute":false},"speaker":{"sound":true,"volume":0.8,"mute":false}}';
const SPEAKER_MIC_SOUND_SETTINGS = "desktop-speaker-mic-sound-settings";
const AUDIO_FILE = "/sounds/Logo_Full.wav";
const DEFAULT_VOLUME = 0.8;
const VOICE_RECORDING_DURATION = 4000;
const MICROPHONE = "mic";
const SPEAKER = "speaker";
const SLIDER_MAX_RANGE = 100;
const DEFAULT_DEVICE_ID = "default";
const BROWSER = "BROWSER";
const MICROPHONE_LABEL = "Microphone";
const SPEAKERS_LABEL = "Speakers";
const DESKTOP_HIDE_WEBEX_CALLING_NOTIFICATIONS_SETTING = "desktop-hide-webex-calling-notifications-setting";


/***/ }),

/***/ "./src/direflow-components/AgentProfile/styles.css":
/*!*********************************************************!*\
  !*** ./src/direflow-components/AgentProfile/styles.css ***!
  \*********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../node_modules/css-loader/dist/cjs.js!./styles.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AgentProfile/styles.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/AgentStateSelector.tsx":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/AgentStateSelector.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! js-cookie */ "../../node_modules/js-cookie/dist/js.cookie.mjs");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/components/ErrorModal */ "./src/direflow-components/Common/components/ErrorModal/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../InteractionControl/constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./index.css */ "./src/direflow-components/AgentStateSelector/index.css");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _StateSelector__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./StateSelector */ "./src/direflow-components/AgentStateSelector/StateSelector.tsx");
/* harmony import */ var _StateSelectorUtils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./StateSelectorUtils */ "./src/direflow-components/AgentStateSelector/StateSelectorUtils.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};














/**
 * AgentStateSelector MFE
 * This Micro Front End provides the interface for selecting among the application provided agent state options
 * @param props
 */
const AgentStateSelector = ({ agentStateProps }) => {
    const { idleTimeStamp, timerTimeStamp, agentStateOptions, agentStateIdleCodes, systemIdleCodes, defaultState, engagedState, isStateChangedByPresenceSync, stateChangedByName, currentUserId, isDesktopAuxCodesInfiniteScrollEnabled, isWxccCoreDisallowPendingLogoutStateChangeEnabled, isWxccRonaEnhancementsEnabled, idleCodesAccess, webRtcStatus, deviceType } = agentStateProps;
    const dispatch = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.EventContext);
    const [idleCodes, setIdleCodes] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const [selectedState, setSelectedState] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [statedisable, setStateDisable] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [agentChangedState, setAgentChangedState] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [resetStateSelector, setResetStateSelector] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [errorModalState, setErrorModalState] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const idleCodeRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(idleCodes);
    const selectedStateOption = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const [idleCodeMeta, setIdleCodeMeta] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({
        orgid: "",
        links: { first: "", last: "", next: "", self: "" },
        page: 0,
        pageSize: 0,
        totalPages: 0,
        totalRecords: 0
    });
    idleCodeRef.current = idleCodes;
    const agentStatePropsRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(agentStateProps);
    agentStatePropsRef.current = agentStateProps;
    const selectedStateRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(selectedState);
    selectedStateRef.current = selectedState;
    const isDesktopAuxCodesInfiniteScrollEnabledRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(isDesktopAuxCodesInfiniteScrollEnabled);
    const idleCodeMetaRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(idleCodeMeta);
    function dispatchSuccessEvent(status, lastStateChangeTimestamp, lastIdleCodeChangeTimestamp, changedByName, triggersErrorModal = false) {
        const event = new CustomEvent("ax-state-selected", {
            detail: {
                agentStatus: status,
                lastStateChangeTimestamp,
                lastIdleCodeChangeTimestamp,
                changedByName,
                triggersErrorModal
            },
            bubbles: true,
            composed: true
        });
        if (dispatch) {
            dispatch(event);
        }
    }
    // this function is used to dispatch the error event for the state selector in the
    // in the agent self
    function dispatchFailureEvent(trackingId, reason, reasonCode) {
        let message = "";
        if (isWxccCoreDisallowPendingLogoutStateChangeEnabled &&
            reason === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON &&
            reasonCode === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE) {
            message = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().stateSelector.errorStateChangeInPendingLogout;
        }
        else {
            message = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().stateSelector.errorstatechange;
        }
        const event = new CustomEvent("ax-state-selected-failed", {
            detail: {
                message,
                trackingId
            },
            bubbles: true,
            composed: true
        });
        if (dispatch) {
            dispatch(event);
        }
    }
    const errorModalCallback = () => {
        setErrorModalState(false);
    };
    const getPreviousStateTime = () => {
        const now = luxon__WEBPACK_IMPORTED_MODULE_4__.DateTime.fromMillis(new Date().getTime());
        const start = luxon__WEBPACK_IMPORTED_MODULE_4__.DateTime.fromMillis(agentStatePropsRef.current.timerTimeStamp.getTime());
        const differenceInMS = now.diff(start).milliseconds;
        return Math.round(differenceInMS / 1000);
    };
    const dispatchEvent = (detail) => {
        const event = new CustomEvent(_InteractionControl_constants__WEBPACK_IMPORTED_MODULE_10__.ANNOUNCEMENT_UPDATE, {
            detail,
            bubbles: true,
            composed: true
        });
        if (dispatch) {
            dispatch(event);
        }
    };
    const handleStateChange = (option) => {
        var _a, _b, _c, _d;
        selectedStateOption.current = option.name;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, [
            (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral,
            (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus
        ]);
        setAgentChangedState(true);
        setStateDisable(true);
        const agentState = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.agent.stateChange({
            data: {
                state: option.name === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AVAILABLE ? _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AVAILABLE : _Common_constants__WEBPACK_IMPORTED_MODULE_9__.IDLE,
                auxCodeIdArray: option.id.toString()
            }
        });
        agentState
            .then((data) => {
            _sdk__WEBPACK_IMPORTED_MODULE_7__.logger.info(`[AgentStateSelector] Agent state change success request: ${JSON.stringify(data)}`);
            setAgentChangedState(true);
            setStateDisable(false);
            dispatchEvent({
                message: `${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().stateSelector.agentStateChangeSuccessful.replace("{selectedState}", option.name)}`
            });
            setSelectedState(option.name);
        })
            .catch((err) => {
            var _a, _b, _c, _d;
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, {
                CurrentState: option.name,
                PreviousState: selectedStateRef.current,
                TimeInPreviousState: getPreviousStateTime(),
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                Reason: "AgentStateChangeFailure"
            }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus]);
            dispatchEvent({
                message: `${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().stateSelector.agentStateChangeFail.replace("{selectedState}", option.name)}`
            });
            _sdk__WEBPACK_IMPORTED_MODULE_7__.logger.error(`event=AgentStateChangeFailure | [AgentStateSelector] Agent state change failed request: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err)}`, err);
            const [reason, reasonCode] = getReasonAndReasonCodeFromErrorObject(err);
            dispatchFailureEvent((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err), reason, reasonCode);
            setAgentChangedState(false);
            setStateDisable(false);
            setResetStateSelector((prevState) => !prevState);
        });
    };
    function dispatchInteractionDeliveryFailureEvent(errorConfig) {
        const buttonConfig = errorConfig.buttonLayout === _StateSelectorUtils__WEBPACK_IMPORTED_MODULE_13__.IdleCodeErrorButtonLayout.SINGLE_OK_BUTTON
            ? [{ type: "button", variant: "primary", label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().common.okButton }]
            : [
                {
                    type: "button",
                    variant: "secondary",
                    label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().idleCodeErrors.cancelButton,
                    onClick: () => { }
                },
                {
                    type: "button",
                    variant: "primary",
                    label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().idleCodeErrors.setAvailableButton,
                    onClick: () => {
                        handleStateChange({ name: _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AVAILABLE, id: "0", isDefault: false, isSystem: false });
                    }
                }
            ];
        const event = new CustomEvent("ax-interaction-delivery-failure", {
            detail: {
                header: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().idleCodeErrors.errorHeader,
                message: errorConfig.message,
                buttons: buttonConfig
            },
            bubbles: true,
            composed: true
        });
        if (dispatch) {
            dispatch(event);
        }
    }
    const isAvailableOptionAdded = (data) => {
        const isAvailableOption = data.filter((item) => item.name === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.availableOption.name);
        return isAvailableOption.length > 0;
    };
    const getReasonAndReasonCodeFromErrorObject = (errorObj) => {
        var _a, _b, _c, _d;
        const reason = ((_b = (_a = errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reason) || "";
        const reasonCode = ((_d = (_c = errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || "";
        return [reason, reasonCode];
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        var _a;
        if (isDesktopAuxCodesInfiniteScrollEnabled) {
            if (agentStateIdleCodes && ((_a = agentStateIdleCodes === null || agentStateIdleCodes === void 0 ? void 0 : agentStateIdleCodes.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const oldOptions = agentStateIdleCodes === null || agentStateIdleCodes === void 0 ? void 0 : agentStateIdleCodes.data.map((a) => (Object.assign({}, a)));
                const newOptions = oldOptions.filter((option) => !option.isSystem);
                // do not append available option if it is not the first page
                if (agentStateIdleCodes.meta.page === 0 && !isAvailableOptionAdded(agentStateIdleCodes.data)) {
                    newOptions.splice(0, 0, _Common_constants__WEBPACK_IMPORTED_MODULE_9__.availableOption);
                }
                setIdleCodes(newOptions);
                setIdleCodeMeta(Object.assign({}, agentStateIdleCodes === null || agentStateIdleCodes === void 0 ? void 0 : agentStateIdleCodes.meta));
            }
        }
        else {
            // when isDesktopAuxCodesInfiniteScrollEnabled if off,
            // we will fetch idleCodes from store and render in state dropdown
            if (agentStateOptions.length > 0) {
                const oldOptions = agentStateOptions.map((a) => (Object.assign({}, a)));
                const newOptions = oldOptions.filter((option) => !option.isSystem);
                newOptions.splice(0, 0, _Common_constants__WEBPACK_IMPORTED_MODULE_9__.availableOption);
                setIdleCodes(newOptions);
            }
        }
    }, [agentStateOptions, agentStateIdleCodes]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        setSelectedState(defaultState);
    }, [defaultState]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        _sdk__WEBPACK_IMPORTED_MODULE_7__.logger.info(`[AgentStateSelector] Agent engaged status is: ${engagedState}`);
    }, [engagedState]);
    const executeAvailableShortcut = (key) => {
        if (key.data &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.GO_TO_AVAILABLE_KEY &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT &&
            selectedState !== _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AVAILABLE) {
            handleStateChange({ name: _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AVAILABLE, id: "0", isDefault: false, isSystem: false });
        }
    };
    const triggerBannerHideEvent = () => {
        const sessionBannerDetails = sessionStorage.getItem(_Common_constants__WEBPACK_IMPORTED_MODULE_9__.ALERT_BANNER_DETAILS);
        const currentBannerDetails = sessionBannerDetails ? JSON.parse(sessionBannerDetails) : undefined;
        if (currentBannerDetails &&
            (currentBannerDetails.reason === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AGENT_STATE_CHANGEDBY_NAME ||
                currentBannerDetails.reason === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AX_PRESENCE_STATE_UPDATE)) {
            sessionStorage.removeItem(_Common_constants__WEBPACK_IMPORTED_MODULE_9__.ALERT_BANNER_DETAILS);
            const event = new CustomEvent("ax-banner-hide", {
                bubbles: true,
                composed: true
            });
            if (dispatch) {
                dispatch(event);
            }
        }
    };
    const triggerBannerShowEvent = (detail) => {
        const event = new CustomEvent("ax-banner-show", {
            detail,
            bubbles: true,
            composed: true
        });
        if (dispatch) {
            dispatch(event);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        setAgentChangedState(false);
        if (selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.RONA) {
            selectedStateOption.current = null;
            triggerBannerHideEvent();
        }
        else {
            const agentStateChangedByName = sessionStorage.getItem(_Common_constants__WEBPACK_IMPORTED_MODULE_9__.ALERT_BANNER_DETAILS);
            if (agentStateChangedByName) {
                const parsedAgentStatechangedByName = JSON.parse(agentStateChangedByName);
                if (parsedAgentStatechangedByName.reason === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AGENT_STATE_CHANGEDBY_NAME) {
                    triggerBannerShowEvent({
                        bannerText: `${parsedAgentStatechangedByName.details} ${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().stateSelector.engagedSupervisorStateChange} <b>${selectedState}.</b>`,
                        bannerType: _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AGENT_STATE_CHANGEDBY_NAME,
                        supervisorName: parsedAgentStatechangedByName.details
                    });
                }
                else if (selectedState && parsedAgentStatechangedByName.reason === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AX_PRESENCE_STATE_UPDATE) {
                    triggerBannerShowEvent({
                        bannerText: `${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().stateSelector.axAgentStateChanged} <b>${selectedState}</b> ${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().stateSelector.axAgentSync}`,
                        bannerType: _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AX_PRESENCE_STATE_UPDATE
                    });
                }
            }
        }
    }, [selectedState]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        isDesktopAuxCodesInfiniteScrollEnabledRef.current = isDesktopAuxCodesInfiniteScrollEnabled;
        idleCodeMetaRef.current = idleCodeMeta;
    }, [isDesktopAuxCodesInfiniteScrollEnabled, idleCodeMeta]);
    const triggerStateChange = (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        let selectedStateName;
        let triggersErrorModal = false;
        const isDesktopAuxCodesInfiniteScrollEnabledCurrent = isDesktopAuxCodesInfiniteScrollEnabledRef.current;
        const idleCodeMetaCurrent = idleCodeMetaRef.current;
        if (data.data.subStatus === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AVAILABLE) {
            selectedStateName = _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AVAILABLE;
        }
        else {
            // NOTE: Special case for system idle codes, which are being filtered out in the idleCodes list
            const systemCode = systemIdleCodes === null || systemIdleCodes === void 0 ? void 0 : systemIdleCodes.data.find((idleCode) => idleCode.id.toString() === data.data.auxCodeId);
            if (systemCode) {
                _sdk__WEBPACK_IMPORTED_MODULE_7__.logger.info("[AgentStateSelector] Changing state to system code: ", systemCode.name);
                selectedStateName = systemCode.name;
                if (isWxccRonaEnhancementsEnabled) {
                    const errorConfig = (0,_StateSelectorUtils__WEBPACK_IMPORTED_MODULE_13__.getErrorModalConfigForIdleCode)(systemCode);
                    if (errorConfig === null || errorConfig === void 0 ? void 0 : errorConfig.message) {
                        triggersErrorModal = true;
                        dispatchInteractionDeliveryFailureEvent(errorConfig);
                    }
                }
                else if (systemCode.name === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.RONA) {
                    triggersErrorModal = true;
                }
            }
            else {
                selectedStateName = yield (0,_StateSelectorUtils__WEBPACK_IMPORTED_MODULE_13__.findAndSetSelectedStateName)(idleCodeRef.current, data.data.auxCodeId, isDesktopAuxCodesInfiniteScrollEnabledCurrent, idleCodeMetaCurrent.orgid);
            }
        }
        const stateName = (!selectedStateName || selectedStateName === "") && selectedStateOption.current
            ? selectedStateOption.current
            : selectedStateName;
        if (stateName) {
            js_cookie__WEBPACK_IMPORTED_MODULE_3__["default"].set("agentState", `${stateName}`);
            const telemetryData = {
                CurrentState: stateName,
                PreviousState: selectedStateRef.current,
                TimeInPreviousState: getPreviousStateTime(),
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
            };
            if (data.data.lastStateChangeReason === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.PRESENCE_SYNC) {
                telemetryData.Reason = _Common_constants__WEBPACK_IMPORTED_MODULE_9__.PRESENCE_SYNC;
            }
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, telemetryData, [
                (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral,
                (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus
            ]);
            setSelectedState(stateName);
            dispatchSuccessEvent(stateName, data.data.lastStateChangeTimestamp, data.data.lastIdleCodeChangeTimestamp, ((_e = data.data.changedBy) === null || _e === void 0 ? void 0 : _e.toLowerCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.SUPERVISOR ? data.data.changedByName : null, triggersErrorModal);
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        const stateChangeListener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.agent.eAgentStateChangeSuccess.listen((data) => {
            const { changedByName, changedBy, agentId } = data.data;
            const loggedInAgentId = currentUserId !== "" ? currentUserId : sessionStorage.getItem("agentId");
            if (loggedInAgentId && agentId === loggedInAgentId) {
                if (changedByName !== null && (changedBy === null || changedBy === void 0 ? void 0 : changedBy.toLowerCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_9__.SUPERVISOR) {
                    sessionStorage.setItem(_Common_constants__WEBPACK_IMPORTED_MODULE_9__.ALERT_BANNER_DETAILS, JSON.stringify({ reason: _Common_constants__WEBPACK_IMPORTED_MODULE_9__.AGENT_STATE_CHANGEDBY_NAME, details: changedByName }));
                }
                triggerStateChange(data);
            }
        });
        return () => {
            if (stateChangeListener) {
                stateChangeListener.stopListen();
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if (agentChangedState) {
            triggerBannerHideEvent();
        }
    }, [agentChangedState]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((key) => executeAvailableShortcut(key));
        return () => {
            if (stopListen) {
                stopListen();
            }
        };
    }, []);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: [(_index_css__WEBPACK_IMPORTED_MODULE_11___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "agent-status" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_8__["default"], { isOpen: errorModalState, message: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().stateSelector.errorstatechange, buttons: [{ label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().common.okButton, onClick: errorModalCallback }], modalHeader: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().common.Error, showCloseButton: false, noExitOnEsc: false, setErrorModal: setErrorModalState }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StateSelector__WEBPACK_IMPORTED_MODULE_12__["default"], { statedisable: statedisable, agentStateOptions: idleCodes, infiniteIdleCodeMeta: idleCodeMeta, handleStateChange: handleStateChange, idleTimeStamp: idleTimeStamp, timerTimeStamp: timerTimeStamp, selectedState: selectedState, isStateChangedByPresenceSync: isStateChangedByPresenceSync, engagedState: engagedState, stateChangedByName: stateChangedByName, resetStateSelector: resetStateSelector, isDesktopAuxCodesInfiniteScrollEnabled: isDesktopAuxCodesInfiniteScrollEnabled, idleCodesAccess: idleCodesAccess, webRtcProps: { webRtcStatus, deviceType }, isWxccRonaEnhancementsEnabled: isWxccRonaEnhancementsEnabled })] })) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AgentStateSelector);


/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/DefaultStateSelectorProps.ts":
/*!*********************************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/DefaultStateSelectorProps.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const stateSelectorProperties = {
    agentStateProps: {
        agentStateOptions: [
            {
                name: "",
                id: "1",
                isDefault: true,
                isSystem: false
            }
        ],
        agentStateIdleCodes: null,
        systemIdleCodes: null,
        defaultState: "",
        idleTimeStamp: new Date(),
        timerTimeStamp: new Date(),
        engagedState: false,
        stateChangedByName: null,
        currentUserId: "",
        isDesktopAuxCodesInfiniteScrollEnabled: false,
        isWxccCoreDisallowPendingLogoutStateChangeEnabled: false,
        isWxccRonaEnhancementsEnabled: false,
        isStateChangedByPresenceSync: false,
        idleCodesAccess: "ALL",
        webRtcStatus: "",
        deviceType: null
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (stateSelectorProperties);


/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/StateIndicator.tsx":
/*!***********************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/StateIndicator.tsx ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _assets_AgentStateIcons_RONA_16_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../assets/AgentStateIcons/RONA_16.svg */ "./src/assets/AgentStateIcons/RONA_16.svg");
/* harmony import */ var _assets_AgentStateIcons_available_16_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../assets/AgentStateIcons/available_16.svg */ "./src/assets/AgentStateIcons/available_16.svg");
/* harmony import */ var _assets_AgentStateIcons_available_raw_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../assets/AgentStateIcons/available_raw.svg */ "./src/assets/AgentStateIcons/available_raw.svg");
/* harmony import */ var _assets_AgentStateIcons_engaged_available_16_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../assets/AgentStateIcons/engaged_available_16.svg */ "./src/assets/AgentStateIcons/engaged_available_16.svg");
/* harmony import */ var _assets_AgentStateIcons_engaged_idle_16_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../assets/AgentStateIcons/engaged_idle_16.svg */ "./src/assets/AgentStateIcons/engaged_idle_16.svg");
/* harmony import */ var _assets_AgentStateIcons_idle_16_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../assets/AgentStateIcons/idle_16.svg */ "./src/assets/AgentStateIcons/idle_16.svg");
/* harmony import */ var _assets_AgentStateIcons_idle_raw_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../assets/AgentStateIcons/idle_raw.svg */ "./src/assets/AgentStateIcons/idle_raw.svg");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_9__);










const StateIndicator = ({ state, engagedState, isSelector }) => {
    const getIcon = (iconClass) => {
        const iconName = getIconNameForState();
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: iconName, size: "16", iconSet: "momentumDesign", class: iconClass });
    };
    const getMdv2IconNameForState = () => {
        if (engagedState) {
            return "busy-presence-bold";
        }
        else if (state === _Common_constants__WEBPACK_IMPORTED_MODULE_8__.AVAILABLE) {
            return "active-presence-small-filled";
        }
        else if (state === _Common_constants__WEBPACK_IMPORTED_MODULE_8__.RONA) {
            return "dnd-presence-badge-filled";
        }
        return "recents-presence-badge-filled";
    };
    const getIconNameForState = () => {
        return getMdv2IconNameForState();
    };
    const getMdv2IndicatorForSelector = () => {
        //class is responsible for the color of the icon
        if (state === _Common_constants__WEBPACK_IMPORTED_MODULE_8__.AVAILABLE) {
            return getIcon("available-icon-color");
        }
        return getIcon("idle-icon-color");
    };
    const getIdleIndicator = () => {
        const className = engagedState ? "engaged-icon-color" : "idle-icon-color";
        return getIcon(className);
    };
    const getAvailableIndicator = () => {
        const className = engagedState ? "engaged-icon-color" : "available-icon-color";
        return getIcon(className);
    };
    const getRonaIndicator = () => {
        const className = "rona-icon-color";
        return getIcon(className);
    };
    const getMdv2IndicatorForState = () => {
        switch (state) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_8__.AVAILABLE:
                return getAvailableIndicator();
            case _Common_constants__WEBPACK_IMPORTED_MODULE_8__.RONA:
                return getRonaIndicator();
            default:
                return getIdleIndicator();
        }
    };
    const getIndicatorForSelector = () => {
        if (state === _Common_constants__WEBPACK_IMPORTED_MODULE_8__.AVAILABLE) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "available-raw-icon" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AgentStateIcons_available_raw_svg__WEBPACK_IMPORTED_MODULE_3__["default"], {}) })));
        }
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "idle-raw-icon" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AgentStateIcons_idle_raw_svg__WEBPACK_IMPORTED_MODULE_7__["default"], {}) })));
    };
    const getIndicatorForState = () => {
        switch (state) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_8__.AVAILABLE:
                return !engagedState ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AgentStateIcons_available_16_svg__WEBPACK_IMPORTED_MODULE_2__["default"], {}) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AgentStateIcons_engaged_available_16_svg__WEBPACK_IMPORTED_MODULE_4__["default"], {});
            case _Common_constants__WEBPACK_IMPORTED_MODULE_8__.RONA:
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AgentStateIcons_RONA_16_svg__WEBPACK_IMPORTED_MODULE_1__["default"], {});
            default:
                return !engagedState ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AgentStateIcons_idle_16_svg__WEBPACK_IMPORTED_MODULE_6__["default"], {}) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AgentStateIcons_engaged_idle_16_svg__WEBPACK_IMPORTED_MODULE_5__["default"], {});
        }
    };
    const getIndicator = () => {
        if (isSelector) {
            return _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_9__.themeManager.isMomentumAvatarEnabled ? getMdv2IndicatorForSelector() : getIndicatorForSelector();
        }
        return _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_9__.themeManager.isMomentumAvatarEnabled ? getMdv2IndicatorForState() : getIndicatorForState();
    };
    if (isSelector) {
        return getIndicator();
    }
    return state ? getIndicator() : null;
};
StateIndicator.defaultProps = {
    engagedState: false,
    isSelector: false
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (StateIndicator);


/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/StateMenuItem.tsx":
/*!**********************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/StateMenuItem.tsx ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/components/HighlightText */ "./src/direflow-components/Common/components/HighlightText/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _StateIndicator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./StateIndicator */ "./src/direflow-components/AgentStateSelector/StateIndicator.tsx");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./index.css */ "./src/direflow-components/AgentStateSelector/index.css");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_7__);








const StateMenuItem = ({ agentStateOption, handleStateChange, selectedState, setIsOpen, menuIsOpen, searchTerm, isHighlightedItem }) => {
    const [isTextOverflow, setTextOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const { stateSelector } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const stateOptionTextRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        const textContainer = stateOptionTextRef.current;
        let isTextOverflowing;
        if (textContainer && menuIsOpen) {
            isTextOverflowing = textContainer.offsetWidth < textContainer.scrollWidth;
        }
        setTextOverflow(isTextOverflowing);
    }, [menuIsOpen]);
    const handleSelection = () => {
        if (selectedState !== agentStateOption.name) {
            setIsOpen(false);
            handleStateChange(agentStateOption, new Date());
        }
        else {
            setIsOpen(false);
        }
    };
    const handleClick = () => {
        handleSelection();
    };
    const handleKeyDown = (e) => {
        e.preventDefault();
        if (e.key === "Enter" || e.key === " ") {
            handleSelection();
        }
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-list-item", Object.assign({ slot: "list-item", class: classnames__WEBPACK_IMPORTED_MODULE_1___default()("status-menu-item", {
            "state-item-highlight": isHighlightedItem
        }), id: `id-${agentStateOption.name}`, "aria-label": agentStateOption.name === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.AVAILABLE ? stateSelector.Available : agentStateOption.name, onClick: handleClick, onKeyDown: handleKeyDown, "aria-selected": selectedState === agentStateOption.name, role: "option" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "agent-status-select-option-badge" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StateIndicator__WEBPACK_IMPORTED_MODULE_6__["default"], { state: agentStateOption.name, isSelector: true }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: agentStateOption.name === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.AVAILABLE ? stateSelector.Available : agentStateOption.name }, (!isTextOverflow ? { disabled: true } : ""), (isTextOverflow && !menuIsOpen ? { opened: false } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ ref: stateOptionTextRef, className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("agent-status-option-text", "ellipsis-text") }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_4__["default"], { text: agentStateOption.name === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.AVAILABLE ? stateSelector.Available : agentStateOption.name, highlight: searchTerm }) })) }))] }), `status-${agentStateOption.name}`));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (StateMenuItem);


/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/StateSelector.tsx":
/*!**********************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/StateSelector.tsx ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! use-resize-observer/polyfilled */ "../../node_modules/use-resize-observer/polyfilled.js");
/* harmony import */ var use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./index.css */ "./src/direflow-components/AgentStateSelector/index.css");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _StateIndicator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./StateIndicator */ "./src/direflow-components/AgentStateSelector/StateIndicator.tsx");
/* harmony import */ var _StateMenuItem__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./StateMenuItem */ "./src/direflow-components/AgentStateSelector/StateMenuItem.tsx");
/* harmony import */ var _StateSelectorIncreasedLimit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./StateSelectorIncreasedLimit */ "./src/direflow-components/AgentStateSelector/StateSelectorIncreasedLimit.tsx");
/* harmony import */ var _StateSelectorUtils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./StateSelectorUtils */ "./src/direflow-components/AgentStateSelector/StateSelectorUtils.tsx");
/* harmony import */ var _StateTimer__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./StateTimer */ "./src/direflow-components/AgentStateSelector/StateTimer.tsx");
















const StateSelector = react__WEBPACK_IMPORTED_MODULE_4__.memo(({ agentStateOptions, idleTimeStamp, timerTimeStamp, selectedState, statedisable, handleStateChange, isStateChangedByPresenceSync, engagedState, stateChangedByName, infiniteIdleCodeMeta, resetStateSelector, isDesktopAuxCodesInfiniteScrollEnabled, idleCodesAccess, webRtcProps, isWxccRonaEnhancementsEnabled }) => {
    const [statusChildrenWidth, setStatusChildrenWidth] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0);
    const [resetFocus, setResetFocus] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [timerWidth, setTimerWidth] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0);
    const [stateTextWidth, setStateTextWidth] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0);
    const { stateSelector, common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__.useI18nContext)();
    const menuElm = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const menuTriggerRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [selectedIndex, setSelectedIndex] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0);
    const [isHighlightedItem, setIsHighlightedItem] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(-1);
    const [selectedTimeValue, setSelectedTimeValue] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const [isTimerOverflow, setTimerOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [isTooltipDisabled, setTooltipDisabled] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true);
    const [contentFits, setContentFits] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true);
    const [isTextWidthHalf, setTextWidthHalf] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [stateTimerWidth, setStateTimerWidth] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0);
    const [shouldFocusStateSelectorFlag, setShouldFocusStateSelectorFlag] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true);
    const [stateButtonAriaLabelVal, setStateButtonAriaLabelVal] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(stateSelector.agentStateLabel);
    const statusChildrenRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const timerRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const searchInputRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const stateOptionsListRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const stateOptionTextRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const [isTextOverflow, setTextOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const { deviceType, webRtcStatus } = webRtcProps;
    /**
     * On Modal open check if text is overflowing so as to display Tooltip accordingly
     */
    const checkIfTextIsOverflowing = () => {
        const textContainer = stateOptionTextRef.current;
        let isTextOverflowing;
        if (textContainer && isOpen) {
            isTextOverflowing = textContainer.offsetWidth < textContainer.scrollWidth;
        }
        setTextOverflow(isTextOverflowing);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        checkIfTextIsOverflowing();
    }, [isOpen]);
    const unsetTextandtimer = () => {
        setTimerOverflow(false);
        setTextWidthHalf(false);
    };
    const handleTextandtimer = (timerOverflow, textOverflow) => {
        if (timerOverflow && textOverflow) {
            setTimerOverflow(true);
            setTextWidthHalf(true);
        }
        else if (timerOverflow) {
            setTimerOverflow(true);
            setTextWidthHalf(false);
        }
        else {
            unsetTextandtimer();
        }
    };
    const setOverallfit = (overallFits) => {
        setContentFits(overallFits);
    };
    const updateTimerWidth = (width) => {
        setStateTimerWidth(width);
    };
    use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_15___default()({
        ref: statusChildrenRef,
        onResize: ({ width }) => {
            if (width) {
                setStatusChildrenWidth(width);
                (0,_StateSelectorUtils__WEBPACK_IMPORTED_MODULE_13__.handleStatusChildrenRef)(width, timerWidth, stateTextWidth, setOverallfit, handleTextandtimer, unsetTextandtimer);
            }
        }
    });
    use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_15___default()({
        ref: timerRef,
        onResize: ({ width }) => {
            if (width) {
                setTimerWidth(width);
                const widthDetails = {
                    width,
                    stateTimerWidth,
                    statusChildrenWidth,
                    stateTextWidth
                };
                (0,_StateSelectorUtils__WEBPACK_IMPORTED_MODULE_13__.handleTimerRef)(widthDetails, updateTimerWidth, setOverallfit, handleTextandtimer, unsetTextandtimer, selectedState);
            }
        }
    });
    const [searchTerm, setSearchTerm] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const [filteredStateList, setFilteredStateList] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(agentStateOptions);
    const [localizedAgentState, setLocalizedAgentState] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(agentStateOptions);
    const executeOpenStateSelector = (keyInfo) => {
        if (keyInfo.data &&
            keyInfo.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_STATE_SELECTOR_KEY &&
            keyInfo.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
            menuTriggerRef.current.click();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        putInitialLoadFocus();
    }, [selectedState]);
    const isStateSelectionDisabled = (webRtcCondition) => {
        return (isWxccRonaEnhancementsEnabled && deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.LoginVoiceOptions.BROWSER && webRtcCondition);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        if (isStateSelectionDisabled(webRtcStatus === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.WEB_RTC_STATUS.WEB_RTC_DISCONNECTED)) {
            const idleCode = agentStateOptions.find((code) => code.isDefault === true);
            handleStateChange(idleCode, new Date());
            //TODO add a popup to inform the user that the agent is forced to idle state due to webRTC connection
        }
    }, [webRtcStatus]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress(executeOpenStateSelector);
        return () => {
            if (stopListen) {
                stopListen();
            }
        };
    }, []);
    const handleStateSelectorFocus = () => {
        var _a, _b;
        if ((_b = (_a = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("input")) {
            searchInputRef.current.shadowRoot.querySelector("input").focus();
        }
    };
    // this method is for enabling focus on state selector on initial loadPage
    const putInitialLoadFocus = () => {
        var _a, _b, _c;
        if (selectedState && shouldFocusStateSelectorFlag) {
            ((_c = (_b = (_a = menuTriggerRef === null || menuTriggerRef === void 0 ? void 0 : menuTriggerRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button")) === null || _c === void 0 ? void 0 : _c.focus()) && setShouldFocusStateSelectorFlag(false);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        if (menuElm === null || menuElm === void 0 ? void 0 : menuElm.current) {
            menuElm.current.isOpen = isOpen;
        }
        handleStateSelectorFocus();
        if (!isOpen && searchTerm !== "") {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_SEARCHED);
        }
    }, [isOpen]);
    const openMenu = () => {
        setIsOpen(true);
    };
    const closeMenu = () => {
        setIsOpen(false);
    };
    const putDefaultFocus = () => {
        var _a, _b;
        (_b = (_a = menuTriggerRef === null || menuTriggerRef === void 0 ? void 0 : menuTriggerRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button").focus();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const localizedState = agentStateOptions.map((agentState) => {
            return Object.assign(Object.assign({}, agentState), { localizedName: agentState.name === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE ? stateSelector.Available : agentState.name });
        });
        setLocalizedAgentState(localizedState);
        setFilteredStateList(localizedState);
    }, [agentStateOptions]);
    const selectedStateTimeValueRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)({
        selectedState,
        selectedTimeValue
    });
    const getLocalizeAgentStateLabel = () => {
        var _a, _b, _c;
        const currentStateValue = selectedStateTimeValueRef.current;
        const stateLabel = currentStateValue.selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE ? stateSelector.Available : currentStateValue.selectedState;
        let buttonLabel = `${stateSelector.label}, `;
        if (currentStateValue.selectedTimeValue === "") {
            buttonLabel += ((_a = stateSelector.agentStateLabelOnStateChange) === null || _a === void 0 ? void 0 : _a.replace("{selectedState}", stateLabel)) || "";
        }
        else {
            buttonLabel += (_c = (_b = stateSelector.agentStateLabel) === null || _b === void 0 ? void 0 : _b.replace("{selectedState}", stateLabel)) === null || _c === void 0 ? void 0 : _c.replace("{selectedTimeValue}", currentStateValue.selectedTimeValue);
        }
        return buttonLabel;
    };
    const setStateButtonAriaLabel = () => {
        setStateButtonAriaLabelVal(getLocalizeAgentStateLabel());
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        selectedStateTimeValueRef.current.selectedState = selectedState;
        selectedStateTimeValueRef.current.selectedTimeValue = "";
        setStateButtonAriaLabel();
    }, [selectedState]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        selectedStateTimeValueRef.current.selectedTimeValue = selectedTimeValue;
    }, [selectedTimeValue]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const stateMenu = menuElm === null || menuElm === void 0 ? void 0 : menuElm.current;
        const menuTriggerElement = menuTriggerRef === null || menuTriggerRef === void 0 ? void 0 : menuTriggerRef.current;
        if (stateMenu) {
            stateMenu.addEventListener("menu-overlay-open", openMenu);
            stateMenu.addEventListener("menu-overlay-close", closeMenu);
            window.addEventListener("alert-close", putDefaultFocus);
            document.addEventListener(_Common_constants__WEBPACK_IMPORTED_MODULE_7__.AGENTX_DEFAULT_FOCUS, putDefaultFocus);
        }
        menuTriggerElement === null || menuTriggerElement === void 0 ? void 0 : menuTriggerElement.addEventListener("focus", setStateButtonAriaLabel);
        return () => {
            if (stateMenu) {
                stateMenu.removeEventListener("menu-overlay-open", openMenu);
                stateMenu.removeEventListener("menu-overlay-close", closeMenu);
                window.removeEventListener("alert-close", putDefaultFocus);
                document.removeEventListener(_Common_constants__WEBPACK_IMPORTED_MODULE_7__.AGENTX_DEFAULT_FOCUS, putDefaultFocus);
            }
            menuTriggerElement === null || menuTriggerElement === void 0 ? void 0 : menuTriggerElement.removeEventListener("focus", setStateButtonAriaLabel);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        if (searchTerm === "") {
            if (!isDesktopAuxCodesInfiniteScrollEnabled) {
                setFilteredStateList(agentStateOptions);
            }
            // No item should be highlighted when it shows all states
            setIsHighlightedItem(-1);
        }
        else {
            if (!isDesktopAuxCodesInfiniteScrollEnabled) {
                const filterStateList = localizedAgentState.filter((status) => { var _a; return (_a = status.localizedName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchTerm.toLowerCase()); });
                const isSelectedReasonPresent = filterStateList === null || filterStateList === void 0 ? void 0 : filterStateList.filter((status) => selectedState === status.name);
                if ((isSelectedReasonPresent === null || isSelectedReasonPresent === void 0 ? void 0 : isSelectedReasonPresent.length) < 1) {
                    setSelectedIndex(-1);
                }
                setFilteredStateList(filterStateList);
            }
            // As soon as list is filtered, first item should be highlighted
            setIsHighlightedItem(0);
        }
    }, [searchTerm, selectedState]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        if ((filteredStateList.length > 0, selectedState)) {
            const index = filteredStateList.findIndex((stateOption) => stateOption.name === selectedState);
            if (index > -1) {
                setSelectedIndex(index);
            }
        }
    }, [filteredStateList, selectedState]);
    const statusColor = (selected, engaged) => {
        if (engaged && selected !== _Common_constants__WEBPACK_IMPORTED_MODULE_7__.RONA) {
            return "engaged";
        }
        else {
            if (selected === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE) {
                return "available";
            }
            if (selected === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.RONA) {
                return "unavailable";
            }
        }
        return "idle";
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const textWidth = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_8__.getTextWidth)(selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE ? stateSelector.Available : selectedState);
        setStateTextWidth(textWidth);
        handleStateSelectorFocus();
    }, [selectedState, stateSelector.Available]);
    const stateSelectorDebouncedFunc = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_8__.debouncedFunc)((value) => setSearchTerm(value));
    const onInputChange = (event) => {
        const searchParam = event.target.value;
        if (isDesktopAuxCodesInfiniteScrollEnabled) {
            stateSelectorDebouncedFunc(searchParam);
        }
        else {
            if (stateOptionsListRef) {
                stateOptionsListRef.current.rovingPreventFocus = true;
            }
            setSearchTerm(searchParam);
        }
    };
    const inputKeydownHandler = (event) => {
        const { srcEvent } = event.detail;
        if (stateOptionsListRef && stateOptionsListRef.current) {
            if (srcEvent.code === "Tab") {
                stateOptionsListRef.current.rovingPreventFocus = false;
            }
            else if (srcEvent.code === "ArrowDown") {
                stateOptionsListRef.current.querySelectorAll("md-list-item")[selectedIndex].focus();
                stateOptionsListRef.current.rovingPreventFocus = false;
            }
            else if (srcEvent.code === "Enter" && searchTerm !== "") {
                handleStateChangeInterceptor(filteredStateList[0], new Date());
                stateOptionsListRef.current.rovingPreventFocus = true;
            }
            else {
                stateOptionsListRef.current.rovingPreventFocus = true;
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const stateOptionsList = stateOptionsListRef.current;
        if (stateOptionsList) {
            stateOptionsList.rovingPreventFocus = true;
        }
        if (searchInputRef && searchInputRef.current) {
            const input = searchInputRef.current;
            input.addEventListener("input-change", onInputChange);
            input.addEventListener("input-keydown", inputKeydownHandler);
            return () => {
                input.removeEventListener("input-change", onInputChange);
                input.removeEventListener("input-keydown", inputKeydownHandler);
            };
        }
        return () => { };
    }, [filteredStateList, selectedIndex]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useLayoutEffect)(() => {
        const extraSpace = 35;
        const halved = 2;
        let originalTimerWidth = stateTimerWidth;
        if (statusChildrenWidth && timerWidth && stateTextWidth) {
            const availableSpace = statusChildrenWidth - extraSpace;
            const middleBreakpoint = availableSpace / halved;
            if (timerWidth > stateTimerWidth) {
                setStateTimerWidth(timerWidth);
                originalTimerWidth = timerWidth;
            }
            const overallFits = availableSpace - stateTextWidth - originalTimerWidth > 0;
            setContentFits(overallFits);
            if (!overallFits) {
                const textOverflow = middleBreakpoint - stateTextWidth < 0;
                const timerOverflow = middleBreakpoint - originalTimerWidth < 0;
                handleTextandtimer(timerOverflow, textOverflow);
            }
            else {
                unsetTextandtimer();
            }
        }
    }, [stateTextWidth]);
    const Timer = (color) => {
        const aColor = color || "none";
        if (selectedState !== _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE &&
            selectedState !== _Common_constants__WEBPACK_IMPORTED_MODULE_7__.RONA &&
            idleTimeStamp.getTime() !== timerTimeStamp.getTime()) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("cumulativeStateTimer", {
                    "ellipsis-timer": isTimerOverflow
                }) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StateTimer__WEBPACK_IMPORTED_MODULE_14__["default"], { color: aColor, timerTimeStamp: idleTimeStamp.getTime(), setSelectedTimeValue: setSelectedTimeValue, isMediumFont: _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: "/" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StateTimer__WEBPACK_IMPORTED_MODULE_14__["default"], { color: aColor, timerTimeStamp: timerTimeStamp.getTime(), isMediumFont: _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled })] })));
        }
        if (selectedState) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StateTimer__WEBPACK_IMPORTED_MODULE_14__["default"], { color: aColor, timerTimeStamp: timerTimeStamp.getTime(), setSelectedTimeValue: setSelectedTimeValue, isMediumFont: _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled }) }));
        }
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    };
    const handleStateChangeInterceptor = (agentStateOption, date) => {
        menuElm.current.isOpen = false;
        setIsOpen(false);
        if (!isOpen && searchTerm !== "") {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_SEARCHED);
        }
        handleStateChange(agentStateOption, date);
    };
    const renderTooltip = () => {
        return engagedState
            ? stateChangedByName
                ? generateEngagedTooltipByName()
                : generateEngagedTooltip()
            : isStateSelectionDisabled(webRtcStatus !== _Common_constants__WEBPACK_IMPORTED_MODULE_7__.WEB_RTC_STATUS.WEB_RTC_CONNECTED)
                ? stateSelector.stateChangeDisabled
                : stateSelector.label;
    };
    const generateEngagedTooltipByName = () => {
        return `${stateSelector.engagedInfo} \n \n${stateChangedByName} ${stateSelector.engagedSupervisorStateChange} ${selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE ? `${stateSelector.Available} ` : `${selectedState}. `}`;
    };
    const generateEngagedTooltip = () => {
        if (isStateChangedByPresenceSync) {
            return `${stateSelector.engagedPresenceInfo} ${selectedState} ${stateSelector.engagedPresenceSync}`;
        }
        else if (selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE) {
            return stateSelector.engagedAvailableInfo;
        }
        else {
            return `${stateSelector.engagedIdleInfo} ${selectedState}.`;
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const disabledStatus = !selectedState || contentFits;
        setTooltipDisabled(disabledStatus);
    }, [contentFits, selectedState]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        //remove selection outline when menu is closed
        if (!isOpen) {
            setResetFocus(!resetFocus);
        }
    }, [isOpen]);
    const renderAriaText = () => {
        if (stateChangedByName) {
            return `${stateSelector.engagedInfo} ${stateChangedByName} ${stateSelector.engagedSupervisorStateChange} ${selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE ? `${stateSelector.Available} ` : `${selectedState}.`}`;
        }
        else if (isStateChangedByPresenceSync) {
            return `${stateSelector.engagedPresenceInfo} ${selectedState} ${stateSelector.engagedPresenceSync}`;
        }
        else {
            return selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE
                ? stateSelector.engagedAvailableInfo
                : `${stateSelector.engagedIdleInfo} ${selectedState}.`;
        }
    };
    const checkIfSearchMatchesAvailable = (searchQuery, prevItems = []) => {
        if (prevItems.length > 0) {
            const isAvailableOption = prevItems.filter((item) => item.name === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.availableOption.name);
            if (isAvailableOption.length > 0) {
                return false;
            }
        }
        return _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase());
    };
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((state) => {
        setIsOpen(false);
        if (selectedStateTimeValueRef.current.selectedState !== state.name) {
            handleStateChange(state, new Date());
        }
    }, [handleStateChange, selectedState, setIsOpen]);
    // useEffect is added to fix the issue of selected state not getting highlighted correctly when state is changed, in case of api failure.
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        (0,_StateSelectorUtils__WEBPACK_IMPORTED_MODULE_13__.handleSelectedInFailure)(stateOptionsListRef, selectedIndex);
    }, [resetStateSelector]);
    const getLoadingError = () => {
        if (!isDesktopAuxCodesInfiniteScrollEnabled && (!filteredStateList || filteredStateList.length === 0)) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "state-no-match" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_6__["default"], { illustrationType: "empty-result" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-label": common.nomatchfound }, { children: common.nomatchfound }))] })));
        }
        return null;
    };
    const handleClientSearch = (searchParam) => {
        const localizedAgentStateArr = [...localizedAgentState];
        const filteredList = localizedAgentStateArr.filter((status) => { var _a; return (_a = status.localizedName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchParam.toLowerCase()); });
        setFilteredStateList(filteredList);
    };
    const updateFilterList = (data, pageUpdate = false, reset = false) => {
        if (!pageUpdate) {
            setFilteredStateList(data);
        }
        else {
            setFilteredStateList((prevItems) => reset
                ? [...data, ...(checkIfSearchMatchesAvailable(searchTerm) ? [_Common_constants__WEBPACK_IMPORTED_MODULE_7__.availableOption] : [])]
                : [
                    ...prevItems,
                    ...data,
                    ...(checkIfSearchMatchesAvailable(searchTerm, prevItems) ? [_Common_constants__WEBPACK_IMPORTED_MODULE_7__.availableOption] : [])
                ]);
        }
    };
    const getStateSelectorWithInfiniteScroll = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StateSelectorIncreasedLimit__WEBPACK_IMPORTED_MODULE_12__["default"], { selectedIndex: selectedIndex, filteredStateList: filteredStateList, searchTerm: searchTerm, isDesktopAuxCodesInfiniteScrollEnabled: isDesktopAuxCodesInfiniteScrollEnabled, idleCodesAccess: idleCodesAccess, infiniteIdleCodeMeta: infiniteIdleCodeMeta, localizedAgentState: localizedAgentState, lisItemClick: handleClick, isTextOverflow: isTextOverflow, onSelectValue: handleStateChangeInterceptor, isOpen: isOpen, stateOptionTextRef: stateOptionTextRef, resetFocus: resetFocus ? 1 : 0, updateFilterListCallBack: updateFilterList, clientSearch: handleClientSearch }));
    };
    const renderArrowIcon = (isOpen) => {
        if (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled) {
            return isOpen ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { className: "arrow-icon arrow-up", name: "arrow-up-bold", iconSet: "momentumDesign", size: "16" })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { className: "arrow-icon arrow-down", name: "arrow-down-bold", iconSet: "momentumDesign", size: "16" }));
        }
        return isOpen ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { className: "arrow-icon arrow-up", name: "icon-arrow-up-optical_8" })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { className: "arrow-icon arrow-down", name: "icon-arrow-down-optical_8" }));
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ ref: menuElm, size: "small", position: "bottom", id: "menu-overlay", "max-height": "180px", class: "state-menu-overlay" }, (isStateSelectionDisabled(webRtcStatus !== _Common_constants__WEBPACK_IMPORTED_MODULE_7__.WEB_RTC_STATUS.WEB_RTC_CONNECTED) ? { disabled: true } : ""), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-tooltip", Object.assign({ slot: "menu-trigger", placement: "bottom" }, (isTooltipDisabled
                ? {
                    message: renderTooltip()
                }
                : ""), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ slot: "tooltip-content" }, { children: stateChangedByName && engagedState ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", { children: [stateSelector.engagedInfo, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}), stateChangedByName, " ", stateSelector.engagedSupervisorStateChange, " ", selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE ? `${stateSelector.Available} ` : `${selectedState}. `] })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "status-tooltip-text" }, { children: selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE ? `${stateSelector.Available} ` : `${selectedState}` })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "tooltip-timer" }, { children: Timer("tooltip-text-color") }))] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ref: menuTriggerRef, size: "32", class: "agent-state-button", ariaLabel: stateButtonAriaLabelVal, ariaHaspopup: true, ariaExpanded: !!isOpen, variant: statusColor(selectedState, engagedState) }, (statedisable ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "status-button__children", ref: statusChildrenRef }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "status-indicator-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StateIndicator__WEBPACK_IMPORTED_MODULE_10__["default"], { state: selectedState, engagedState: engagedState }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("ax-current-status-label", "ellipsis-text", {
                                        "half-width": isTextWidthHalf
                                    }) }, { children: engagedState && selectedState !== _Common_constants__WEBPACK_IMPORTED_MODULE_7__.RONA ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "engagedStatus" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "sr-only", "aria-label": renderAriaText() }), stateSelector.Engaged] }))) : selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.AVAILABLE ? (stateSelector.Available) : (selectedState) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ ref: timerRef }, { children: !engagedState || selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.RONA ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Timer, {}) : "" })), renderArrowIcon(isOpen)] })) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "state-input-wrapper" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-input", { ref: searchInputRef, id: "pillSearchInput", searchable: true, newMomentum: true, placeholder: common.search, clear: true, containerSize: "medium-10", htmlId: "pillSearchInput", name: "pillSearchInput", value: searchTerm, type: "text", autoFocus: true, ariaLabel: stateSelector.searchState, clearAriaLabel: stateSelector.clear }) })), isDesktopAuxCodesInfiniteScrollEnabled ? (getStateSelectorWithInfiniteScroll()) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-list", Object.assign({ class: classnames__WEBPACK_IMPORTED_MODULE_3___default()("menu-list", {
                    "state-selector-list": filteredStateList.length > 0,
                    "state-list-hide": !filteredStateList || filteredStateList.length === 0
                }), role: "listbox", ref: stateOptionsListRef, selected: selectedIndex, label: stateSelector.agentStateSelector, activated: selectedIndex }, { children: filteredStateList &&
                    filteredStateList.length > 0 &&
                    filteredStateList.map((option, idx) => {
                        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StateMenuItem__WEBPACK_IMPORTED_MODULE_11__["default"], { agentStateOption: option, handleStateChange: handleStateChangeInterceptor, selectedState: selectedState, setIsOpen: setIsOpen, menuIsOpen: isOpen, searchTerm: searchTerm, isHighlightedItem: isHighlightedItem === idx }, option.id));
                    }) }))), getLoadingError()] })));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (StateSelector);


/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/StateSelectorIncreasedLimit.tsx":
/*!************************************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/StateSelectorIncreasedLimit.tsx ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FIRST_PAGE_NUMBER: () => (/* binding */ FIRST_PAGE_NUMBER),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/components/HighlightText */ "./src/direflow-components/Common/components/HighlightText/index.tsx");
/* harmony import */ var _Common_components_List__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/components/List */ "./src/direflow-components/Common/components/List/index.tsx");
/* harmony import */ var _Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/components/List/ListError */ "./src/direflow-components/Common/components/List/ListError/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _StateIndicator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./StateIndicator */ "./src/direflow-components/AgentStateSelector/StateIndicator.tsx");
/* harmony import */ var _StateSelectorUtils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./StateSelectorUtils */ "./src/direflow-components/AgentStateSelector/StateSelectorUtils.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};















const FIRST_PAGE_NUMBER = 0;
const ItemHeight = 36;
const ListItemContent = ({ data, index, style, isSelected, isFocused, onSelectValue, customData }) => {
    const state = data.name;
    const stateSelector = customData.stateSelector;
    const searchTerm = (customData === null || customData === void 0 ? void 0 : customData.searchQuery) || "";
    const stateOptionTextRef = customData.stateOptionTextRef;
    const isTextOverflow = customData.isTextOverflow;
    const isOpen = customData.isOpen;
    return ((0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)("li", Object.assign({ className: `infinite-menu-list status-menu-item ${customData.selectedIndex === index ? "selected" : ""} ${isFocused ? "hovered focused-item" : ""}` }, (isFocused ? { tabIndex: 0 } : { tabIndex: -1 }), { "aria-posinset": index, "data-state": index, id: `id-${state}`, key: `status-${state}`, "aria-label": state === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.AVAILABLE ? stateSelector.Available : state, style: style, onClick: () => onSelectValue(data, index) }),
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "agent-status-select-option-badge", "aria-hidden": true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StateIndicator__WEBPACK_IMPORTED_MODULE_12__["default"], { state: state }) })),
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ "aria-hidden": true, message: state === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.AVAILABLE ? stateSelector.Available : state }, (!isTextOverflow ? { disabled: true } : ""), (isTextOverflow && !isOpen ? { opened: false } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ ref: stateOptionTextRef, className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("agent-status-option-list", "ellipsis-text") }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_7__["default"], { text: state === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.AVAILABLE ? stateSelector.Available : state, highlight: searchTerm }) })) }))));
};
const StateSelectorIncreasedLimit = ({ selectedIndex, filteredStateList, searchTerm, isDesktopAuxCodesInfiniteScrollEnabled, idleCodesAccess, infiniteIdleCodeMeta, localizedAgentState, lisItemClick, isTextOverflow, onSelectValue, isOpen, stateOptionTextRef, resetFocus, updateFilterListCallBack, clientSearch }) => {
    const { stateSelector, common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__.useI18nContext)();
    const [hasNextPage, setHasNextPage] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
    const [isNextPageLoading, setIsNextPageLoading] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
    const [pageFetchError, setPageFetchError] = react__WEBPACK_IMPORTED_MODULE_1__.useState({
        error: false,
        trackingId: ""
    });
    const [currentPage, setCurrentPage] = react__WEBPACK_IMPORTED_MODULE_1__.useState(infiniteIdleCodeMeta === null || infiniteIdleCodeMeta === void 0 ? void 0 : infiniteIdleCodeMeta.page);
    const [searchError, setSearchError] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
    const [loadingFirstPage, setLoadingFirstPage] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
    const [loadingFirstPageError, setLoadingFirstPageError] = react__WEBPACK_IMPORTED_MODULE_1__.useState({
        error: false,
        trackingId: ""
    });
    const filteredInfiniteIdleCodeMeta = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({ totalPages: 0 });
    const dispatch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.EventContext);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        var _a;
        // if isDesktopAuxCodesInfiniteScrollEnabled is true(and on opening dropdown)
        // if currentPage is lesser than total page only then set hasNextPage to true
        // else call to next page will be made on initial load if hasNextPage is set to true initially
        // if we have filtered data , take the total pages from filtered record (as this is not stored to the STORE)
        if (isDesktopAuxCodesInfiniteScrollEnabled && isOpen) {
            const filteredTotalPages = (_a = filteredInfiniteIdleCodeMeta === null || filteredInfiniteIdleCodeMeta === void 0 ? void 0 : filteredInfiniteIdleCodeMeta.current) === null || _a === void 0 ? void 0 : _a.totalPages;
            const totalPages = filteredTotalPages || (infiniteIdleCodeMeta === null || infiniteIdleCodeMeta === void 0 ? void 0 : infiniteIdleCodeMeta.totalPages);
            if (currentPage !== undefined && totalPages) {
                setHasNextPage(currentPage < totalPages - 1);
            }
            else {
                setHasNextPage(false);
            }
        }
    }, [isOpen]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        setCurrentPage(infiniteIdleCodeMeta === null || infiniteIdleCodeMeta === void 0 ? void 0 : infiniteIdleCodeMeta.page);
    }, [infiniteIdleCodeMeta]);
    const loadFirstPage = () => {
        updateFilterListCallBack([]);
        setLoadingFirstPage(true);
        loadPage(0, searchTerm, true);
    };
    const handleSearch = (searchParam) => {
        // handle client side search
        if (infiniteIdleCodeMeta && currentPage === infiniteIdleCodeMeta.totalPages - 1) {
            clientSearch(searchParam);
        }
        else {
            // handle server side search
            loadFirstPage();
        }
    };
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
        if (isDesktopAuxCodesInfiniteScrollEnabled && isOpen && searchTerm !== undefined) {
            if (searchTerm.length >= _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MINIMUM_CHARACTERS_FOR_SEARCH || searchTerm === "") {
                setSearchError(false);
                handleSearch(searchTerm);
            }
            else {
                setSearchError(true);
            }
        }
    }, [searchTerm]);
    const dispatchAgentStateIdleCodesUpdate = (agentStateIdleCodes) => {
        const updatedIdleCodes = {
            meta: agentStateIdleCodes.meta,
            data: [...localizedAgentState, ...agentStateIdleCodes.data]
        };
        (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_11__.evt)(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.AX_IDLE_CODE_UPDATE, updatedIdleCodes, dispatch);
    };
    const handleError = (error, page) => {
        const trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(error);
        if (page === FIRST_PAGE_NUMBER) {
            setLoadingFirstPage(false);
            setLoadingFirstPageError({ error: true, trackingId });
        }
        else {
            setPageFetchError({ error: true, trackingId });
            setHasNextPage(true);
            setIsNextPageLoading(false);
        }
    };
    const handlePageUpdate = (agentStateIdleCodes, reset) => {
        setPageFetchError({ error: false, trackingId: "" });
        setLoadingFirstPageError({ error: false, trackingId: "" });
        // eslint-disable-next-line no-unsafe-optional-chaining -- Tech debt/Potential bug.
        const { page, totalPages } = agentStateIdleCodes === null || agentStateIdleCodes === void 0 ? void 0 : agentStateIdleCodes.meta;
        if (page !== undefined && totalPages !== undefined) {
            setHasNextPage(page < totalPages - 1);
            setCurrentPage(page);
            filteredInfiniteIdleCodeMeta.current = agentStateIdleCodes === null || agentStateIdleCodes === void 0 ? void 0 : agentStateIdleCodes.meta;
            // update the filtered list, append the available option if the search query matches it
            updateFilterListCallBack(agentStateIdleCodes === null || agentStateIdleCodes === void 0 ? void 0 : agentStateIdleCodes.data, true, reset);
        }
        else {
            setHasNextPage(false);
        }
        setIsNextPageLoading(false);
        if (page === FIRST_PAGE_NUMBER) {
            setLoadingFirstPage(false);
        }
    };
    const loadPage = (currentPage, searchQuery, reset = false) => {
        (0,_StateSelectorUtils__WEBPACK_IMPORTED_MODULE_13__.fetchIdleCodes)(infiniteIdleCodeMeta === null || infiniteIdleCodeMeta === void 0 ? void 0 : infiniteIdleCodeMeta.orgid, currentPage, searchQuery, _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.DEFAULT_PAGE_SIZE)
            .then((response) => {
            const agentStateIdleCodes = response;
            if (searchQuery === "") {
                dispatchAgentStateIdleCodesUpdate(agentStateIdleCodes);
            }
            handlePageUpdate(agentStateIdleCodes, reset);
        })
            .catch((error) => {
            handleError(error, currentPage);
        });
    };
    const loadNextPage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isNextPageLoading) {
            return;
        }
        setIsNextPageLoading(true);
        setPageFetchError({ error: false, trackingId: "" });
        loadPage((currentPage ? currentPage : 0) + 1, searchTerm); // added ?? 0 to avoid undefined
    });
    const handleSelectValue = (selectedValue) => {
        lisItemClick(selectedValue);
    };
    const isNoRecordFound = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {
        return isDesktopAuxCodesInfiniteScrollEnabled && filteredStateList.length === 0 && !loadingFirstPage;
    }, [isDesktopAuxCodesInfiniteScrollEnabled, filteredStateList, loadingFirstPage]);
    const getLoadingError = () => {
        if (isDesktopAuxCodesInfiniteScrollEnabled) {
            if (searchError) {
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "search-block-error" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "search-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "info-badge-filled", iconSet: "momentumDesign", size: "16", class: "search-error-info" }), stateSelector.searchError] })) })));
            }
            else if (!loadingFirstPage && loadingFirstPageError.error) {
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_9__["default"], { onRetry: () => loadPage(0, searchTerm), trackingId: loadingFirstPageError.trackingId });
            }
            else if (filteredStateList.length === 0 && !loadingFirstPage) {
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "no-record" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_6__["default"], { illustrationType: "empty-result" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-label": common.nomatchfound, className: "no-record-found" }, { children: common.nomatchfound }))] })));
            }
        }
        return null;
    };
    const getStateSelectorList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
        if (!searchError && !isNoRecordFound() && !loadingFirstPage && !loadingFirstPageError.error) {
            const customData = {
                selectedIndex,
                searchQuery: searchTerm,
                stateSelector,
                isTextOverflow,
                isOpen,
                stateOptionTextRef
            };
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_8__["default"], Object.assign({ innerElementType: "ul", data: filteredStateList, height: filteredStateList.length > 8 ? ItemHeight * 8 : ItemHeight * filteredStateList.length, itemHeight: ItemHeight, resetFocus: resetFocus ? 1 : 0, hasNextPage: hasNextPage, isNextPageLoading: isNextPageLoading, loadNextPage: loadNextPage, pageFetchError: pageFetchError, infiniteScrollEnabled: isDesktopAuxCodesInfiniteScrollEnabled, customData: customData, onSelectValue: handleSelectValue }, { children: (props) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItemContent, Object.assign({}, props)) })) }));
        }
        return null;
    }, [
        searchError,
        isNoRecordFound,
        loadingFirstPage,
        loadingFirstPageError.error,
        filteredStateList,
        resetFocus,
        hasNextPage,
        isNextPageLoading,
        pageFetchError,
        isDesktopAuxCodesInfiniteScrollEnabled,
        ItemHeight,
        stateOptionTextRef,
        stateSelector,
        isOpen,
        isTextOverflow,
        searchTerm
    ]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `state-selector-increased-limit ${isDesktopAuxCodesInfiniteScrollEnabled && (loadingFirstPageError === null || loadingFirstPageError === void 0 ? void 0 : loadingFirstPageError.error) ? "state-list-loading-error" : ""}` }, { children: [isDesktopAuxCodesInfiniteScrollEnabled && loadingFirstPage && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "state-list__loading" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "56" }) }))), getStateSelectorList, getLoadingError()] })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (StateSelectorIncreasedLimit);


/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/StateSelectorUtils.tsx":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/StateSelectorUtils.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IdleCodeErrorButtonLayout: () => (/* binding */ IdleCodeErrorButtonLayout),
/* harmony export */   fetchIdleCodes: () => (/* binding */ fetchIdleCodes),
/* harmony export */   findAndSetSelectedStateName: () => (/* binding */ findAndSetSelectedStateName),
/* harmony export */   getErrorModalConfigForIdleCode: () => (/* binding */ getErrorModalConfigForIdleCode),
/* harmony export */   getSpecificIdleCodeForExternalTrigger: () => (/* binding */ getSpecificIdleCodeForExternalTrigger),
/* harmony export */   handleSelectedInFailure: () => (/* binding */ handleSelectedInFailure),
/* harmony export */   handleStatusChildrenRef: () => (/* binding */ handleStatusChildrenRef),
/* harmony export */   handleTimerRef: () => (/* binding */ handleTimerRef)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




const handleStatusChildrenRef = (width, timerWidth, stateTextWidth, setOverallfit, handleTextandtimer, unsetTextandtimer) => {
    const extraSpace = 30;
    const halved = 2;
    if (width && timerWidth && stateTextWidth) {
        const availableSpace = width - extraSpace;
        const middleBreakpoint = availableSpace / halved;
        const overallFits = availableSpace - stateTextWidth - timerWidth > 0;
        setOverallfit(overallFits);
        if (!overallFits) {
            const textOverflow = middleBreakpoint - stateTextWidth < 0;
            const timerOverflow = middleBreakpoint - timerWidth < 0;
            handleTextandtimer(timerOverflow, textOverflow);
        }
        else {
            unsetTextandtimer();
        }
    }
};
const handleTimerRef = (widthDetails, updateTimerWidth, setOverallfit, handleTextandtimer, unsetTextandtimer, selectedState) => {
    const extraSpace = 35;
    const halved = 2;
    const { width, stateTimerWidth, statusChildrenWidth, stateTextWidth } = widthDetails;
    let originalTimerWidth = stateTimerWidth;
    if (statusChildrenWidth && width && stateTextWidth) {
        const availableSpace = statusChildrenWidth - extraSpace;
        const middleBreakpoint = availableSpace / halved;
        if (width > stateTimerWidth) {
            updateTimerWidth(width);
            originalTimerWidth = width;
            const overallFits = availableSpace - stateTextWidth - originalTimerWidth > 0;
            setOverallfit(overallFits);
            if (!overallFits) {
                const textOverflow = middleBreakpoint - stateTextWidth < 0;
                const timerOverflow = middleBreakpoint - originalTimerWidth < 0;
                handleTextandtimer(timerOverflow, textOverflow);
            }
            else {
                unsetTextandtimer();
            }
        }
        else if (selectedState === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.AVAILABLE && width < stateTimerWidth) {
            updateTimerWidth(width);
            const overallFits = availableSpace - stateTextWidth - width > 0;
            setOverallfit(overallFits);
            if (!overallFits) {
                const textOverflow = middleBreakpoint - stateTextWidth < 0;
                const timerOverflow = middleBreakpoint - width < 0;
                handleTextandtimer(timerOverflow, textOverflow);
            }
            else {
                unsetTextandtimer();
            }
        }
    }
};
const fetchIdleCodes = (orgId, page, search, PAGE_SIZE) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = {
            orgId,
            page,
            search,
            pageSize: PAGE_SIZE
        };
        const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.abs.fetchPaginatedIdleCodes(params);
        return response ? response : {};
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`event=fetchIdleCodes | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error) : ""} | Fetching idle codes from aux code is failed : ${error}`, error);
        throw error;
    }
});
const handleSelectedInFailure = (stateOptionsListRef, selectedIndex) => {
    if (stateOptionsListRef && stateOptionsListRef.current) {
        stateOptionsListRef.current.selected = selectedIndex;
        stateOptionsListRef.current.activated = selectedIndex;
    }
};
const getSpecificIdleCodeForExternalTrigger = (auxCodeId, orgId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.abs.fetchPaginatedIdleCodes({
            orgId,
            customFilter: `id==${auxCodeId}`
        });
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("event=fetchIdleCodes | Successfully fetched singular idle code by external state change");
        return response;
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("event=fetchIdleCodes | Error on fetching singular idle code for subStatus", error);
        throw error;
    }
});
const findAndSetSelectedStateName = (idleCodesArray, auxCodeId, isDesktopAuxCodesInfiniteScrollEnabled, orgId) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const idleCode = idleCodesArray.find((idleCode) => idleCode.id.toString() === auxCodeId);
    if (idleCode) {
        return idleCode.name;
    }
    else if (isDesktopAuxCodesInfiniteScrollEnabled) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[AgentStateSelector]: Idle code not present, fetching from backend");
        const fetchedIdleCode = yield getSpecificIdleCodeForExternalTrigger(auxCodeId, orgId);
        return ((_a = fetchedIdleCode === null || fetchedIdleCode === void 0 ? void 0 : fetchedIdleCode.data) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (_b = fetchedIdleCode === null || fetchedIdleCode === void 0 ? void 0 : fetchedIdleCode.data[0]) === null || _b === void 0 ? void 0 : _b.name : null;
    }
    return null;
});
var IdleCodeErrorButtonLayout;
(function (IdleCodeErrorButtonLayout) {
    IdleCodeErrorButtonLayout[IdleCodeErrorButtonLayout["SINGLE_OK_BUTTON"] = 0] = "SINGLE_OK_BUTTON";
    IdleCodeErrorButtonLayout[IdleCodeErrorButtonLayout["CANCEL_AND_SET_AVAILABLE_BUTTONS"] = 1] = "CANCEL_AND_SET_AVAILABLE_BUTTONS";
})(IdleCodeErrorButtonLayout || (IdleCodeErrorButtonLayout = {}));
const getErrorModalConfigForIdleCode = (idleCode) => {
    const errorConfigs = {
        [_Common_constants__WEBPACK_IMPORTED_MODULE_2__.ERROR_TRIGGERING_IDLE_CODES.INVALID_NUMBER]: {
            message: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getLocalizedMessages)().idleCodeErrors.invalidNumber,
            buttonLayout: IdleCodeErrorButtonLayout.SINGLE_OK_BUTTON
        },
        [_Common_constants__WEBPACK_IMPORTED_MODULE_2__.ERROR_TRIGGERING_IDLE_CODES.UNREACHABLE]: {
            message: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getLocalizedMessages)().idleCodeErrors.unreachable,
            buttonLayout: IdleCodeErrorButtonLayout.CANCEL_AND_SET_AVAILABLE_BUTTONS
        },
        [_Common_constants__WEBPACK_IMPORTED_MODULE_2__.ERROR_TRIGGERING_IDLE_CODES.DECLINED]: {
            message: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getLocalizedMessages)().idleCodeErrors.declined,
            buttonLayout: IdleCodeErrorButtonLayout.CANCEL_AND_SET_AVAILABLE_BUTTONS
        },
        [_Common_constants__WEBPACK_IMPORTED_MODULE_2__.ERROR_TRIGGERING_IDLE_CODES.RONA]: {
            message: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getLocalizedMessages)().idleCodeErrors.rona,
            buttonLayout: IdleCodeErrorButtonLayout.CANCEL_AND_SET_AVAILABLE_BUTTONS
        },
        [_Common_constants__WEBPACK_IMPORTED_MODULE_2__.ERROR_TRIGGERING_IDLE_CODES.BUSY]: {
            message: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getLocalizedMessages)().idleCodeErrors.busy,
            buttonLayout: IdleCodeErrorButtonLayout.CANCEL_AND_SET_AVAILABLE_BUTTONS
        },
        [_Common_constants__WEBPACK_IMPORTED_MODULE_2__.ERROR_TRIGGERING_IDLE_CODES.CHANNEL_FAILURE]: {
            message: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getLocalizedMessages)().idleCodeErrors.channelFailure,
            buttonLayout: IdleCodeErrorButtonLayout.CANCEL_AND_SET_AVAILABLE_BUTTONS
        }
    };
    return errorConfigs[idleCode.name] || null;
};


/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/StateTimer.tsx":
/*!*******************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/StateTimer.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _useTime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./useTime */ "./src/direflow-components/AgentStateSelector/useTime/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);







/**
 * StateTimer Component
 * This component controls and renders the active agent state clock that appear in the selector.
 * When available, the timer will begin calculating time from a provided timestamp prop.
 * It uses hooks and custom functions to continually update the clock view, calculate accurate increments,
 * and reset when a new state is chosen
 */
const StateTimer = ({ timerTimeStamp, color, setSelectedTimeValue = null, timerLabel, isMediumFont }) => {
    const start = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromMillis(timerTimeStamp);
    const now = (0,_useTime__WEBPACK_IMPORTED_MODULE_5__["default"])();
    const { common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const { seconds = "sec", minutes = "min", hours = "hour" } = (common === null || common === void 0 ? void 0 : common.time) || {};
    const timeUnitsList = [seconds, minutes, hours];
    const selectedTime = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_4__.formatDuration)(now.diff(start));
    const formattedSelectedTime = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_4__.formatSelectedTime)(selectedTime, timeUnitsList);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (setSelectedTimeValue) {
            setSelectedTimeValue(formattedSelectedTime);
        }
    }, [formattedSelectedTime, setSelectedTimeValue]);
    const dateTime = () => {
        return selectedTime;
    };
    const getFormattedTime = () => {
        return formattedSelectedTime;
    };
    const timerClassNames = classnames__WEBPACK_IMPORTED_MODULE_6___default()("agent-current-status-timer", color, {
        "medium-font": isMediumFont
    });
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: start <= now && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("time", Object.assign({ role: "timer", dateTime: dateTime(), className: timerClassNames }, { children: [timerLabel && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "timer-label" }, { children: `${timerLabel} ${getFormattedTime()}` })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true" }, { children: dateTime() }))] }))) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (StateTimer);


/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/index.css":
/*!**************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/index.css ***!
  \**************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../node_modules/css-loader/dist/cjs.js!./index.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AgentStateSelector/index.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/useTime/getTime.ts":
/*!***********************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/useTime/getTime.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
    var _a;
    return ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.webex) === null || _a === void 0 ? void 0 : _a.getServerTime) ? luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromJSDate(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.webex.getServerTime()) : luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.utc();
});


/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/useTime/index.ts":
/*!*********************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/useTime/index.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _useTime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./useTime */ "./src/direflow-components/AgentStateSelector/useTime/useTime.ts");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_useTime__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ "./src/direflow-components/AgentStateSelector/useTime/useTime.ts":
/*!***********************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/useTime/useTime.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _getTime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getTime */ "./src/direflow-components/AgentStateSelector/useTime/getTime.ts");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((refreshCycle = 100) => {
    // Returns the current time
    // and queues re-renders every `refreshCycle` milliseconds (default: 100ms)
    const [now, setNow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_getTime__WEBPACK_IMPORTED_MODULE_1__["default"])());
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        // Regularly set time in state
        // (this will cause your component to re-render frequently)
        const intervalId = setInterval(() => setNow((0,_getTime__WEBPACK_IMPORTED_MODULE_1__["default"])()), refreshCycle);
        // Cleanup interval
        return () => clearInterval(intervalId);
        // Specify dependencies for useEffect
    }, [refreshCycle, setNow]);
    return now;
});


/***/ }),

/***/ "./src/direflow-components/AppTitle/AppTitle.tsx":
/*!*******************************************************!*\
  !*** ./src/direflow-components/AppTitle/AppTitle.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./index.css */ "./src/direflow-components/AppTitle/index.css");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_6__);







/**
 * App Title MFE
 * A Micro Front End component for rendering an option Application Title within the Header MFE
 *
 * @param props
 */
const TOTAL_APP_TITLE_LOG_WIDTH = 304;
const AppTitle = (props) => {
    const { apptitle, logo } = props;
    const [title, setTitle] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(apptitle);
    const logoElm = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)();
    const titleElm = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)();
    const tempTitleElm = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)();
    const [titleDynamicStyle, setTitleDynamicStyle] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [dynamicWidth, setDynamicWidth] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({});
    const [isAppTitleIsImage, setAppTitleIsImage] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const dispatch = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.EventContext);
    const dynamicWidthTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const calculateDynamicTitleWidth = () => {
        dynamicWidthTimeoutIdRef.current = window.setTimeout(() => {
            const logoWidth = logoElm && logoElm.current ? logoElm.current.getBoundingClientRect().width : 0;
            const titleWidth = tempTitleElm.current.getBoundingClientRect().width;
            const availableSpaceForTitle = TOTAL_APP_TITLE_LOG_WIDTH - logoWidth;
            if (logoWidth + titleWidth > TOTAL_APP_TITLE_LOG_WIDTH) {
                setTitleDynamicStyle("dynamic-title-width");
                if (!isAppTitleIsImage) {
                    setDynamicWidth({ width: availableSpaceForTitle });
                }
                else {
                    setDynamicWidth({ maxWidth: availableSpaceForTitle });
                }
            }
            else {
                setTitleDynamicStyle("");
                setDynamicWidth({
                    maxWidth: availableSpaceForTitle,
                    whiteSpace: "nowrap"
                });
            }
        }, 0);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        setTitle(apptitle);
        calculateDynamicTitleWidth();
        return () => {
            if (dynamicWidthTimeoutIdRef.current) {
                window.clearTimeout(dynamicWidthTimeoutIdRef.current);
            }
        };
    }, [apptitle, logo, titleDynamicStyle, isAppTitleIsImage]);
    const containerClassName = classnames__WEBPACK_IMPORTED_MODULE_3___default()("app-title-container", {
        "momentum-style": _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__.themeManager.isMomentumV2Enabled,
        "is-visual-rebrand": _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__.themeManager.isVisualRebrandEnabled
    });
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: [(_index_css__WEBPACK_IMPORTED_MODULE_6___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: containerClassName }, { children: [logo.toLowerCase() !== "no-logo" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("picture", Object.assign({ className: "logo", ref: logoElm }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { className: "logo--img", alt: title, src: logo, onLoad: () => {
                            calculateDynamicTitleWidth();
                        } }) }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", Object.assign({ className: "temp-title", ref: tempTitleElm }, { children: title })), title.length > 0 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: title, className: `title-img ${titleDynamicStyle}`, ref: titleElm, style: Object.assign({}, dynamicWidth), alt: "", onError: (e) => {
                                e.target.style.display = "none";
                                setAppTitleIsImage(false);
                            }, onLoad: (e) => {
                                setAppTitleIsImage(true);
                                if (dispatch) {
                                    dispatch(new CustomEvent("ax-app-title-as-image", {
                                        bubbles: true,
                                        composed: true,
                                        detail: { appTitleAsImage: true }
                                    }));
                                }
                                e.target.style.display = "";
                            } }), !isAppTitleIsImage && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: title, placement: "bottom" }, (!titleDynamicStyle ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", Object.assign({ className: `title ${titleDynamicStyle}`, ref: titleElm, style: Object.assign({}, dynamicWidth) }, { children: title })) })))] }))] })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_4__.observer)(AppTitle));


/***/ }),

/***/ "./src/direflow-components/AppTitle/__mocks__/DefaultApplicationTitleProps.js":
/*!************************************************************************************!*\
  !*** ./src/direflow-components/AppTitle/__mocks__/DefaultApplicationTitleProps.js ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const applicationTitleProperties = {
  apptitle: "Agent Desktop",
  logo: "",
  appTitleAsImage: false
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (applicationTitleProperties);


/***/ }),

/***/ "./src/direflow-components/AppTitle/index.css":
/*!****************************************************!*\
  !*** ./src/direflow-components/AppTitle/index.css ***!
  \****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../node_modules/css-loader/dist/cjs.js!./index.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/AppTitle/index.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/Utils.ts":
/*!*************************************************!*\
  !*** ./src/direflow-components/Common/Utils.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   debouncedFunc: () => (/* binding */ debouncedFunc),
/* harmony export */   dispatchAnnouncement: () => (/* binding */ dispatchAnnouncement),
/* harmony export */   escapeRegExp: () => (/* binding */ escapeRegExp),
/* harmony export */   escapeSpecialChars: () => (/* binding */ escapeSpecialChars),
/* harmony export */   evt: () => (/* binding */ evt),
/* harmony export */   fetchAddressBookList: () => (/* binding */ fetchAddressBookList),
/* harmony export */   formatDuration: () => (/* binding */ formatDuration),
/* harmony export */   formatSelectedTime: () => (/* binding */ formatSelectedTime),
/* harmony export */   getDateCommonFormat: () => (/* binding */ getDateCommonFormat),
/* harmony export */   getDateForBrowserLang: () => (/* binding */ getDateForBrowserLang),
/* harmony export */   getDerivedMediaChannel: () => (/* binding */ getDerivedMediaChannel),
/* harmony export */   getDerivedMediaChannelForDirection: () => (/* binding */ getDerivedMediaChannelForDirection),
/* harmony export */   getDestAgentTypeForEporEPDN: () => (/* binding */ getDestAgentTypeForEporEPDN),
/* harmony export */   getImageCH: () => (/* binding */ getImageCH),
/* harmony export */   getImageSrcGeneric: () => (/* binding */ getImageSrcGeneric),
/* harmony export */   getTextWidth: () => (/* binding */ getTextWidth),
/* harmony export */   isIconSrc: () => (/* binding */ isIconSrc),
/* harmony export */   isMultipartyFeatureFlagOn: () => (/* binding */ isMultipartyFeatureFlagOn),
/* harmony export */   isOutboundContact: () => (/* binding */ isOutboundContact),
/* harmony export */   isTextOverflow: () => (/* binding */ isTextOverflow),
/* harmony export */   orderBy: () => (/* binding */ orderBy)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../sdk */ "./src/sdk.ts");
/* harmony import */ var _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../InteractionControl/constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../InteractionPopoverManager/Utils/InteractionPopoversUtils */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! mobx */ "../../node_modules/mobx/lib/mobx.module.js");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};









/**
 * method to format the duration (timestamp) in hh:mm:ss format
 * @param duration
 */
const formatDuration = (duration) => {
    if (duration.shiftTo("hours", "minute").get("hours") < 1) {
        return duration.toFormat("mm:ss");
    }
    return duration.toFormat("hh:mm:ss");
};
/**
 * @param {string} selectedTime - The time string to format, in the format 'HH:MM:SS'.
 * @returns {string} A string representing the duration, in the format 'H hour M min S sec'.
 */
const formatSelectedTime = (selectedTime, timeUnits = ["sec", "min", "hour"]) => {
    const timeParts = selectedTime.split(":").reverse().map(Number);
    let formattedTime = "";
    timeParts.forEach((part, i) => {
        if (part > 0) {
            formattedTime = `${part} ${timeUnits[i]} ${formattedTime}`;
        }
    });
    return formattedTime.trim();
};
const escapeSpecialChars = (input) => {
    return input.replace(/[^+?\d]/gi, "");
};
/**
 * Order/Sort list of objects based on provided field
 * @param list
 * @param field
 */
const orderBy = (list, field) => {
    const sortedList = list.slice().sort((a, b) => {
        const nameA = a[field].toLowerCase();
        const nameB = b[field].toLowerCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });
    if ((0,mobx__WEBPACK_IMPORTED_MODULE_8__.isObservableArray)(list)) {
        list.replace(sortedList);
    }
    else {
        list = sortedList;
    }
    return list;
};
const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
const reHasRegExpChar = RegExp(reRegExpChar.source);
const escapeRegExp = (string) => {
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string || "";
};
const getDateCommonFormat = (timestamp) => {
    const date = new Date(timestamp);
    return `${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getLocalizedMessages)().common.months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
};
/**
 * Returns date with browser language format
 */
const getDateForBrowserLang = (timestamp) => {
    const date = new Date(timestamp);
    const lang = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getBrowserLanguage)();
    const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };
    return `${date.toLocaleDateString(lang, options)}`;
};
/**
 * Returns width of text
 * @param text The text you want to measure the width of
 */
const getTextWidth = (text, fontSize = "14px") => {
    const tag = document.createElement("div");
    tag.style.position = "absolute";
    tag.style.visibility = "hidden";
    tag.style.whiteSpace = "nowrap";
    tag.style.fontSize = fontSize;
    tag.innerHTML = text;
    document.body.appendChild(tag);
    const textWidth = tag.clientWidth;
    document.body.removeChild(tag);
    return textWidth;
};
/**
 * Returns true if text cannot fit in max-width
 * @param maxWidthOverflow Max width after which ellipses will come
 * @param text Text for which tooltip is shown.
 */
const isTextOverflow = (maxWidthOverflow, text) => {
    const textWidth = getTextWidth(text);
    return textWidth > maxWidthOverflow;
};
const fetchAddressBookList = (page, search, pageSize) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    if ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.addressBookId) {
        try {
            const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.abs.fetchAddressBooksCMS({
                orgId: ((_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.conf.profile) === null || _b === void 0 ? void 0 : _b.orgId) || "",
                addressBookId: ((_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.conf.profile) === null || _c === void 0 ? void 0 : _c.addressBookId) || "",
                page: page || 0,
                search,
                pageSize: pageSize || 50
            });
            _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("Successfully fetched Address Book Contacts :", response);
            return response;
        }
        catch (error) {
            _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=FetchAddressBookError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)}] Failed to fetch AddressBook: `, error);
            throw error;
        }
    }
    else {
        return { speedDials: [] };
    }
});
const evt = (eventName, dataToBeSend, dispatchCustom) => {
    const event = new CustomEvent(eventName, {
        detail: dataToBeSend,
        bubbles: true,
        composed: true
    });
    if (dispatchCustom) {
        dispatchCustom(event);
    }
};
const debouncedFunc = (func, delay) => {
    return lodash__WEBPACK_IMPORTED_MODULE_1___default().debounce(func, delay || _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_5__.THREE_HUNDRED_MS);
};
/**
 * This method checks of contact is of outbound direction
 * Certain components use contact.callDirection === OUTDIAL hence checking both here
 * @param direction - Direction of the contact
 */
const isOutboundContact = (direction) => {
    const lowerCaseDirection = direction ? direction.toLowerCase() : "";
    return lowerCaseDirection === _constants__WEBPACK_IMPORTED_MODULE_6__.OUTBOUND.toLowerCase() || lowerCaseDirection === _constants__WEBPACK_IMPORTED_MODULE_6__.OUT_DIAL.toLowerCase();
};
/**
 * For icons, this method returns the derived media channel to be searched in icon json
 * @param mediaChannel - The original media channel
 * @param direction - Direction of the contact
 */
const getDerivedMediaChannelForDirection = (mediaChannel, direction) => {
    if (isOutboundContact(direction)) {
        if (mediaChannel && mediaChannel === _constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.EMAIL) {
            return _constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_EMAIL;
        }
        if (mediaChannel && mediaChannel === _constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.SMS) {
            return _constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_SMS;
        }
        return mediaChannel;
    }
    return mediaChannel;
};
/**
 * For icons, this method provides the derived media channel if its digital outbound, else the original media channel.
 * @param mediaType - The media type
 * @param mediaChannel - The media channel
 */
const getDerivedMediaChannel = (mediaType, mediaChannel) => {
    if ((0,_InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_7__.isMediaTypeDigitalOutbound)(mediaType)) {
        return mediaType;
    }
    return mediaChannel;
};
/**
 * Returns imgSrc for various scenarios
 * @param mediaType - The media type
 * @param mediaChannel - The media channel
 * @returns imgSrc from MEDIA_SUBCHANNEL_TYPES json
 */
const getImageSrcGeneric = (mediaType, mediaChannel, isDarkMode, showDetails = false) => {
    let imgSrc;
    const derivedMediaChannel = getDerivedMediaChannel(mediaType, mediaChannel);
    if (mediaType === _constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.MIDCALL_MONITORING) {
        imgSrc = isDarkMode ? _constants__WEBPACK_IMPORTED_MODULE_2__.MONITORING_REGULAR_DARK : _constants__WEBPACK_IMPORTED_MODULE_2__.MONITORING_REGULAR_LIGHT;
    }
    else if (derivedMediaChannel && _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]) {
        if (showDetails) {
            imgSrc = isDarkMode
                ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel].normal.dark
                : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel].normal.light;
        }
        else {
            imgSrc = isDarkMode
                ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel].unselected.dark
                : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel].unselected.light;
        }
    }
    return imgSrc;
};
/**
 * @param mediaType - The media type
 * @param mediaChannel - The media channel
 * @returns a boolean indicating if imgSrc is present or not
 */
const isIconSrc = (mediaType, mediaChannel) => {
    const derivedMediaChannel = getDerivedMediaChannel(mediaType, mediaChannel);
    return (mediaType === _constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.MIDCALL_MONITORING ||
        !!(derivedMediaChannel &&
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]));
};
const getImageCH = (mediaType, derivedMediaChannel, isDarkMode) => {
    if (mediaType === _constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.MIDCALL_MONITORING) {
        return isDarkMode ? _constants__WEBPACK_IMPORTED_MODULE_2__.MONITORING_REGULAR_DARK : _constants__WEBPACK_IMPORTED_MODULE_2__.MONITORING_REGULAR_LIGHT;
    }
    if (derivedMediaChannel && _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]) {
        return isDarkMode
            ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel].normal.dark
            : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel].normal.light;
    }
    return undefined;
};
const dispatchAnnouncement = (message) => {
    window.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_6__.AX_ANNOUNCEMENT_UPDATE, {
        detail: {
            thisEvent: {
                message
            }
        }
    }));
};
const isMultipartyFeatureFlagOn = () => {
    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.featureflag.isWxccPersistCallEnabled() || _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.featureflag.isWxccMultiPartyConfEnabled();
};
const getDestAgentTypeForEporEPDN = () => {
    if (isMultipartyFeatureFlagOn()) {
        return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.DESTINATION_TYPE.ENTRY_POINT;
    }
    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.DESTINATION_TYPE.EPDN;
};


/***/ }),

/***/ "./src/direflow-components/Common/components/AvatarStatus/AvatarStatus.tsx":
/*!*********************************************************************************!*\
  !*** ./src/direflow-components/Common/components/AvatarStatus/AvatarStatus.tsx ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./styles.scss */ "./src/direflow-components/Common/components/AvatarStatus/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_2__);



const AvatarStatus = ({ title, alt, avatarClass, size, src, statusIcon, presenceType, newMomentum }) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: (_styles_scss__WEBPACK_IMPORTED_MODULE_2___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "avatar-status" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-avatar", Object.assign({ "aria-hidden": "true", size: size, alt: alt, title: title, src: src, type: presenceType !== null && presenceType !== void 0 ? presenceType : "", className: `${avatarClass} avatar` }, (newMomentum ? { newMomentum: true } : {}))), !presenceType && statusIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "status" }, { children: statusIcon }))] })) })));
};
AvatarStatus.defaultProps = {
    size: 32,
    src: null,
    avatarClass: null,
    statusIcon: null
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AvatarStatus);


/***/ }),

/***/ "./src/direflow-components/Common/components/AvatarStatus/styles.scss":
/*!****************************************************************************!*\
  !*** ./src/direflow-components/Common/components/AvatarStatus/styles.scss ***!
  \****************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./styles.scss */ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/AvatarStatus/styles.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/EmergencyNotificationModal/index.tsx":
/*!****************************************************************************************!*\
  !*** ./src/direflow-components/Common/components/EmergencyNotificationModal/index.tsx ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./styles.scss */ "./src/direflow-components/Common/components/EmergencyNotificationModal/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_4__);





const EmergencyNotificationModal = ({ modalHeader, isOpen, buttons, showCloseButton, noExitOnEsc, setModalState, checkBoxLabel }) => {
    const [showModal, setShowModal] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(isOpen);
    const modalRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const modalCheckboxRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const cancelButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const continueButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    if (buttons === undefined) {
        // eslint-disable-next-line no-param-reassign
        buttons = [{ label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getLocalizedMessages)().common.okButton }];
    }
    const btnClickHandler = () => {
        setShowModal(false);
        if (setModalState) {
            setModalState(false);
        }
        resetFocusableElements();
    };
    const buttonsGroup = buttons.map((btn) => {
        const isCancelButton = btn.label === "Cancel";
        const ref = isCancelButton ? cancelButtonRef : continueButtonRef;
        const buttonVariant = btn.color
            ? { color: btn.color }
            : btn.variant
                ? { variant: btn.variant }
                : { variant: "primary" };
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ref: ref, class: "error-modal-btn", onClick: (e) => (btn.onClick ? btn.onClick(e) : false), ariaLabel: btn.ariaLabel ? btn.ariaLabel : (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getLocalizedMessages)().common.submitForm }, buttonVariant, { children: btn.label }), btn.label));
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        var _a, _b, _c;
        const button = (_b = (_a = continueButtonRef === null || continueButtonRef === void 0 ? void 0 : continueButtonRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button");
        if (button && (modalCheckboxRef === null || modalCheckboxRef === void 0 ? void 0 : modalCheckboxRef.current)) {
            button.disabled = !((_c = modalCheckboxRef === null || modalCheckboxRef === void 0 ? void 0 : modalCheckboxRef.current) === null || _c === void 0 ? void 0 : _c.checked);
        }
    }, [isOpen]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        setShowModal(isOpen);
        if (setModalState) {
            setModalState(isOpen);
        }
    }, [isOpen, setModalState]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        const modalElem = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current;
        if (modalElem) {
            modalElem.addEventListener("close-modal", btnClickHandler);
        }
        return () => {
            if (modalElem) {
                modalElem.removeEventListener("close-modal", btnClickHandler);
            }
        };
    }, []);
    const updateCheckboxState = (checked) => {
        var _a, _b;
        const button = (_b = (_a = continueButtonRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button");
        if (button) {
            button.disabled = !checked;
        }
        resetFocusableElements();
    };
    const handleOnCheckboxChange = (e) => {
        updateCheckboxState(e.target.checked);
    };
    const handleOnKeyboardPress = (event) => {
        if (event.keyCode === 32 || event.keyCode === 13) {
            const checkbox = modalCheckboxRef.current;
            if (checkbox) {
                updateCheckboxState(checkbox.checked);
            }
        }
    };
    const resetFocusableElements = () => {
        if (modalRef.current) {
            modalRef.current.setFocusableElements();
        }
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_styles_scss__WEBPACK_IMPORTED_MODULE_4___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-modal", Object.assign({ ref: modalRef, headerLabel: modalHeader }, (showModal ? { show: true } : ""), { hideFooter: true, size: "dialog", htmlId: "modal" }, (noExitOnEsc === false ? "" : { noExitOnEsc: true }), (showCloseButton === false ? "" : { showCloseButton: true }), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "emergency-notification-body" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("agentx-wc-emergency-notification-content", {}), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "read-the-notification-wrapper" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-checkbox", Object.assign({ ref: modalCheckboxRef, id: "readNotificationCheckbox", slot: "checkbox", class: "read-the-notification", onClick: handleOnCheckboxChange, onKeyDown: handleOnKeyboardPress }, { children: checkBoxLabel })) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ slot: "footer" }, { children: buttonsGroup }))] })) }) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EmergencyNotificationModal);


/***/ }),

/***/ "./src/direflow-components/Common/components/EmergencyNotificationModal/styles.scss":
/*!******************************************************************************************!*\
  !*** ./src/direflow-components/Common/components/EmergencyNotificationModal/styles.scss ***!
  \******************************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./styles.scss */ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/EmergencyNotificationModal/styles.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx":
/*!*******************************************************************************!*\
  !*** ./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");

const EmptyStateWrapper = ({ illustrationType, theme }) => {
    const imagePath = () => {
        switch (illustrationType) {
            case "empty-state":
                return "/images/illustrations/box-open-120.svg";
            case "empty-result":
                return "/images/illustrations/desert-open-results-192.svg";
            case "empty-organization-search":
                return `/images/illustrations/flashlight-search-192-${theme}.svg`;
            default:
                return "/images/illustrations/box-open-120.svg";
        }
    };
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: imagePath(), alt: "", className: "tech-error__illustration", "aria-hidden": "true" });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EmptyStateWrapper);


/***/ }),

/***/ "./src/direflow-components/Common/components/EnterpriseSearch/EnterpriseSearch.tsx":
/*!*****************************************************************************************!*\
  !*** ./src/direflow-components/Common/components/EnterpriseSearch/EnterpriseSearch.tsx ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _InteractionControl_components_TransferModal_integration_microsoft__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../InteractionControl/components/TransferModal/integration/microsoft */ "./src/direflow-components/InteractionControl/components/TransferModal/integration/microsoft/index.tsx");
/* harmony import */ var _InteractionControl_components_TransferModal_integration_microsoft_AuthError__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../InteractionControl/components/TransferModal/integration/microsoft/AuthError */ "./src/direflow-components/InteractionControl/components/TransferModal/integration/microsoft/AuthError.tsx");
/* harmony import */ var _InteractionControl_components_TransferModal_integration_webex_WebexOrganizationUserList__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../InteractionControl/components/TransferModal/integration/webex/WebexOrganizationUserList */ "./src/direflow-components/InteractionControl/components/TransferModal/integration/webex/WebexOrganizationUserList.tsx");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./styles.css */ "./src/direflow-components/Common/components/EnterpriseSearch/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_12__);













function EnterpriseSearch({ displayMicrosoftUserDetails, displayWebexUserDetails, microsoftAuthenticated, height, isDarkMode, resetTab, handleSelectedNumber }) {
    const { common, enterpriseSearch } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.useI18nContext)();
    const [initiateOrgDataFetch, setInitiateOrgDataFetch] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0);
    const [orgSearchValue, setOrgSearchValue] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const [isLoadingListItem, setIsLoadingListItem] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [placeholderString, setPlaceholderString] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(enterpriseSearch.orgPlaceholder);
    const [maxWidth, setMaxWidth] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const dispatchCustomEvent = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.EventContext);
    const orgSearchInputRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const INPUT_CHANGE_EVENT = "input-change";
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        var _a;
        (_a = orgSearchInputRef === null || orgSearchInputRef === void 0 ? void 0 : orgSearchInputRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener(INPUT_CHANGE_EVENT, orgSearchInputValueChangeHandler);
        return () => {
            var _a;
            (_a = orgSearchInputRef === null || orgSearchInputRef === void 0 ? void 0 : orgSearchInputRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(INPUT_CHANGE_EVENT, orgSearchInputValueChangeHandler);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        if (displayWebexUserDetails) {
            setMaxWidth("max-width");
            setPlaceholderString(enterpriseSearch.webexPlaceholder);
        }
        else if (displayMicrosoftUserDetails) {
            setMaxWidth("");
            setPlaceholderString(enterpriseSearch.orgPlaceholder);
        }
    }, [displayMicrosoftUserDetails, displayWebexUserDetails]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        document.dispatchEvent(new CustomEvent("on-widget-update"));
    }, [isLoadingListItem]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        setOrgSearchValue("");
        setIsLoadingListItem(false);
        if (resetTab === 1 && displayMicrosoftUserDetails && microsoftAuthenticated) {
            getListValues();
        }
    }, [resetTab]);
    const orgSearchInputValueChangeHandler = (0,_Utils__WEBPACK_IMPORTED_MODULE_11__.debouncedFunc)((e) => {
        var _a;
        const value = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.value;
        setOrgSearchValue(value);
        if (initiateOrgDataFetch === 0) {
            setInitiateOrgDataFetch(1);
        }
        // When entering new values, reset the selected value.
        handleSelectedNumber("");
    }, 500);
    const handleUserSelection = (value) => {
        if ((value === null || value === void 0 ? void 0 : value.businessPhones) && (value === null || value === void 0 ? void 0 : value.businessPhones.length) > 0) {
            setInitiateOrgDataFetch(0);
            handleSelectedNumber(value === null || value === void 0 ? void 0 : value.businessPhones[0]);
            orgSearchInputRef.current.value = value.businessPhones[0];
            setOrgSearchValue(value.businessPhones[0]);
        }
        else {
            handleSelectedNumber("");
        }
    };
    const handleMsAuthenticationRetry = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((event) => {
        event.preventDefault();
        (0,_Utils__WEBPACK_IMPORTED_MODULE_11__.evt)(_constants__WEBPACK_IMPORTED_MODULE_5__.INITIATE_MS_AUTH_LOGIN, true, dispatchCustomEvent);
    }, []);
    const renderWebexOrgSearchComp = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InteractionControl_components_TransferModal_integration_webex_WebexOrganizationUserList__WEBPACK_IMPORTED_MODULE_10__["default"], { searchQuery: orgSearchValue, height: height, isDarkMode: isDarkMode, onItemClicked: handleUserSelection }));
    };
    const refreshSpinner = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "refresh-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "16" }) })));
    };
    const getListValues = () => {
        if (microsoftAuthenticated) {
            setIsLoadingListItem(true);
            handleSelectedNumber("");
            setInitiateOrgDataFetch((prevValue) => {
                return prevValue + 1;
            });
        }
    };
    const refreshButton = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ class: "refresh-list-tooltip", message: enterpriseSearch.refreshTheList }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ class: "refresh-list-button", type: "button", arialabel: enterpriseSearch.refreshAddressBook, circle: true, variant: "ghost", onClick: (e) => getListValues(), onKeyDown: (e) => getListValues() }, (!microsoftAuthenticated && { disabled: true }), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: "icon-refresh_16" }) })) })));
    };
    const renderMicrosoftOrgSearchComp = () => {
        return microsoftAuthenticated ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InteractionControl_components_TransferModal_integration_microsoft__WEBPACK_IMPORTED_MODULE_8__["default"], { height: height, searchQuery: orgSearchValue, handleListClick: handleUserSelection, initiateDataFetch: initiateOrgDataFetch, updateFetchingStatus: setIsLoadingListItem, resetFocus: resetTab })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InteractionControl_components_TransferModal_integration_microsoft_AuthError__WEBPACK_IMPORTED_MODULE_9__["default"], { handleRetry: handleMsAuthenticationRetry, errorMessageLabel: enterpriseSearch.microsoftAuthError, tryAgainLabel: common.tryAgain }));
    };
    const renderOrgSearchComp = () => {
        let userListComponent;
        let enableRefresh = false;
        if (displayMicrosoftUserDetails) {
            enableRefresh = true;
            userListComponent = renderMicrosoftOrgSearchComp();
        }
        else if (displayWebexUserDetails) {
            userListComponent = renderWebexOrgSearchComp();
        }
        else {
            _sdk__WEBPACK_IMPORTED_MODULE_7__.logger.error(`displayUserDetails enabled but no MSFT or Webex user details enabled`);
        }
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_12___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `org-search-container ${maxWidth}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-input", Object.assign({ class: "org-search-input", ref: orgSearchInputRef, placeholder: placeholderString, value: orgSearchValue, variant: "primary", clear: true, autoFocus: true, clearAriaLabel: common.clear }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }))), enableRefresh && (isLoadingListItem ? refreshSpinner() : refreshButton())] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "organization-users-list" }, { children: userListComponent }))] }) })));
    };
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "modal-search-container organization" }, { children: renderOrgSearchComp() }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__.observer)(EnterpriseSearch));


/***/ }),

/***/ "./src/direflow-components/Common/components/EnterpriseSearch/styles.css":
/*!*******************************************************************************!*\
  !*** ./src/direflow-components/Common/components/EnterpriseSearch/styles.css ***!
  \*******************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!./styles.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/EnterpriseSearch/styles.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/ErrorDetail/index.tsx":
/*!*************************************************************************!*\
  !*** ./src/direflow-components/Common/components/ErrorDetail/index.tsx ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./styles.scss */ "./src/direflow-components/Common/components/ErrorDetail/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_5__);






const ErrorDetail = ({ trackingId, format }) => {
    const [showDetails, setDetailsVisibility] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isCopied, setIsCopied] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const trackingIdInput = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const trackingIdCpyBtn = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const detailsRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const setCopyTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const copyTrackingID = () => {
        const text = trackingIdInput.current ? trackingIdInput.current.innerText : "";
        const inputTemp = document.createElement("input");
        inputTemp.value = text;
        document.body.appendChild(inputTemp);
        inputTemp.select();
        document.execCommand("copy");
        document.body.removeChild(inputTemp);
        setIsCopied(true);
        if (setCopyTimeoutIdRef.current) {
            window.clearTimeout(setCopyTimeoutIdRef.current);
        }
        setCopyTimeoutIdRef.current = window.setTimeout(() => {
            setIsCopied(false);
        }, _constants__WEBPACK_IMPORTED_MODULE_3__.COPY_TIMEOUT);
    };
    const handleDetailToggle = () => {
        if (detailsRef && detailsRef.current) {
            setDetailsVisibility(detailsRef.current.open);
        }
        setIsCopied(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        const details = detailsRef === null || detailsRef === void 0 ? void 0 : detailsRef.current;
        if (details) {
            details.addEventListener("toggle", handleDetailToggle);
            details.open = showDetails;
        }
        return () => {
            if (details) {
                details.removeEventListener("toggle", handleDetailToggle);
            }
            if (setCopyTimeoutIdRef.current) {
                window.clearTimeout(setCopyTimeoutIdRef.current);
            }
        };
    }, []);
    const localizedMessages = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.getLocalizedMessages)().common;
    const { interaction_control } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.getLocalizedMessages)();
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_styles_scss__WEBPACK_IMPORTED_MODULE_5___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("details", Object.assign({ ref: detailsRef, className: `error-details ${format === "default" || format === undefined ? "centered" : ""}` }, { children: [!format || format === "default" ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("summary", Object.assign({ className: "trackingid-summary failed-error-link" }, { children: showDetails ? localizedMessages.showLess : localizedMessages.learnMore }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("summary", Object.assign({ className: "trackingid-summary error-details-link" }, { children: localizedMessages.errorDetails }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `trackingid-container ${format}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "trackingid-description" }, { children: localizedMessages.trackingIdDescription })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `trackingid-error-details-wrap ${format}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "tracking-input-wrap" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "trackingid-label" }, { children: localizedMessages.trackingIdInputLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ id: "trackingid-input", className: "trackingid-input", ref: trackingIdInput }, { children: trackingId }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "copy-button-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "top", message: !isCopied ? interaction_control.copy : interaction_control.copied }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ id: "copy-trackingid-icon", class: "copy-tracking-icon", circle: true, onClick: copyTrackingID, variant: isCopied ? "green" : "white", size: 14, ref: trackingIdCpyBtn }, { children: format === "modal" ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: isCopied ? "icon-check_14" : "icon-copy_14" })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: isCopied ? "icon-check_12" : "icon-copy_12" })) })) })) }))] }))] }))] })) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ErrorDetail);


/***/ }),

/***/ "./src/direflow-components/Common/components/ErrorDetail/styles.scss":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/Common/components/ErrorDetail/styles.scss ***!
  \***************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./styles.scss */ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/ErrorDetail/styles.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/ErrorModal/index.tsx":
/*!************************************************************************!*\
  !*** ./src/direflow-components/Common/components/ErrorModal/index.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dompurify */ "../../node_modules/dompurify/dist/purify.es.mjs");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./styles.css */ "./src/direflow-components/Common/components/ErrorModal/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _ErrorDetail__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../ErrorDetail */ "./src/direflow-components/Common/components/ErrorDetail/index.tsx");







const ErrorModal = ({ modalHeader, message, isOpen, buttons, trackingId, showCloseButton, noExitOnEsc, setErrorModal }) => {
    const [showErrorModal, setShowErrorModal] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(isOpen);
    const modalRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const modalButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    if (buttons === undefined || buttons.length === 0) {
        // eslint-disable-next-line no-param-reassign
        buttons = [{ label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.getLocalizedMessages)().common.okButton }];
    }
    const btnClickHandler = () => {
        setShowErrorModal(false);
        if (setErrorModal) {
            setErrorModal(false);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        var _a, _b;
        if ((_b = (_a = modalButtonRef === null || modalButtonRef === void 0 ? void 0 : modalButtonRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button")) {
            modalButtonRef.current.shadowRoot.querySelector("button").autofocus = true;
        }
    }, [isOpen]);
    const buttonsGroup = buttons.map((btn) => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ref: modalButtonRef, class: "error-modal-btn", onClick: (e) => (btn.onClick ? btn.onClick(e) : false), ariaLabel: btn.ariaLabel ? btn.ariaLabel : (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.getLocalizedMessages)().common.submitForm }, (btn.color ? { color: btn.color } : btn.variant ? { variant: btn.variant } : { variant: "primary" }), { children: btn.label }), btn.label));
    });
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        setShowErrorModal(isOpen);
        if (setErrorModal) {
            setErrorModal(isOpen);
        }
    }, [isOpen, setErrorModal]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        const modalElem = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current;
        if (modalElem) {
            modalElem.addEventListener("close-modal", btnClickHandler);
        }
        return () => {
            if (modalElem) {
                modalElem.removeEventListener("close-modal", btnClickHandler);
            }
        };
    }, []);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_5___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-modal", Object.assign({ ref: modalRef, applicationId: "app", headerLabel: modalHeader }, (showErrorModal ? { show: true } : ""), { hideFooter: true, size: "dialog", htmlId: "modal", class: "error-modal" }, (noExitOnEsc === false ? "" : { noExitOnEsc: true }), (showCloseButton === false ? "" : { showCloseButton: true }), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "error-modal-body" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "error-message", dangerouslySetInnerHTML: {
                                        __html: dompurify__WEBPACK_IMPORTED_MODULE_2__["default"].sanitize(message)
                                    } }), trackingId ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrorDetail__WEBPACK_IMPORTED_MODULE_6__["default"], { trackingId: trackingId, format: "modal" }) : null] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "md-modal__footer", slot: "footer" }, { children: buttonsGroup }))] })) }) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ErrorModal);


/***/ }),

/***/ "./src/direflow-components/Common/components/ErrorModal/styles.css":
/*!*************************************************************************!*\
  !*** ./src/direflow-components/Common/components/ErrorModal/styles.css ***!
  \*************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!./styles.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/ErrorModal/styles.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/HighlightText/index.tsx":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/Common/components/HighlightText/index.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./styles.scss */ "./src/direflow-components/Common/components/HighlightText/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_3__);




const HighlightText = ({ text = "", highlight = "" }) => {
    if (!(highlight === null || highlight === void 0 ? void 0 : highlight.trim())) {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: text });
    }
    const regex = new RegExp(`(${(0,_Utils__WEBPACK_IMPORTED_MODULE_2__.escapeRegExp)(highlight)})`, "gi");
    const parts = text.split(regex);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_styles_scss__WEBPACK_IMPORTED_MODULE_3___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "highlight-span" }, { children: parts
                .filter((part) => part)
                .map((part, i) => regex.test(part) ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", { children: part }, `row-text-${i}`) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: part }, `row-text-${i}`)) })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HighlightText);


/***/ }),

/***/ "./src/direflow-components/Common/components/HighlightText/styles.scss":
/*!*****************************************************************************!*\
  !*** ./src/direflow-components/Common/components/HighlightText/styles.scss ***!
  \*****************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./styles.scss */ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/HighlightText/styles.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/InlineError.tsx":
/*!*******************************************************************!*\
  !*** ./src/direflow-components/Common/components/InlineError.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _ErrorDetail__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ErrorDetail */ "./src/direflow-components/Common/components/ErrorDetail/index.tsx");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./styles.css */ "./src/direflow-components/Common/components/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_4__);





/**
 * Inline Error message component.
 * @param props
 */
const InlineError = ({ errorHeaderMsg, errorSubMsg, retry, trackingId, top }) => {
    const localizedMessages = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.getLocalizedMessages)().common;
    const validErrorSubMsg = errorSubMsg && errorSubMsg !== "{err.details}" && typeof errorSubMsg === "string";
    const errorImage = "/images/illustrations/cloud-failure-192-red-pink.svg";
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_4___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "error-main", style: top || top === 0 ? { top: `${top}%` } : {} }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: errorImage, alt: localizedMessages.tryAgain, className: "tech-error__illustration" }), errorHeaderMsg && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-label", Object.assign({ className: "error-header" }, { children: errorHeaderMsg })), validErrorSubMsg && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-label", Object.assign({ className: "error-sub-message" }, { children: [localizedMessages.errorID, ": ", errorSubMsg] }))), retry && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ariaLabel: localizedMessages.tryAgain, class: "try-again-button", variant: "primary", onClick: retry }, { children: localizedMessages.tryAgain }))), trackingId && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrorDetail__WEBPACK_IMPORTED_MODULE_3__["default"], { trackingId: trackingId, format: "default" })] })) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InlineError);


/***/ }),

/***/ "./src/direflow-components/Common/components/List/FetchError/index.tsx":
/*!*****************************************************************************!*\
  !*** ./src/direflow-components/Common/components/List/FetchError/index.tsx ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FetchError: () => (/* binding */ FetchError)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./styles.scss */ "./src/direflow-components/Common/components/List/FetchError/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_3__);




const FetchError = ({ trackingId, onRetry, style }) => {
    const { common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.useI18nContext)();
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: (_styles_scss__WEBPACK_IMPORTED_MODULE_3___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-help-text", Object.assign({ messageType: "error", class: "infinite-scroll-error", style: style, "aria-live": "polite" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "error-block" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "error-span-padding" }, { children: [" ", common.errorMsg, "."] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-link", Object.assign({ inline: true, class: "infinite-scroll-retry-link", "aria-label": common.tryAgain, onClick: onRetry, onKeyDown: onRetry, tag: "span", "data-testid": "retry-page" }, { children: common.tryAgain }))] }), trackingId && trackingId !== "" ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "tracking-error-block" }, { children: [common.trackingIdInputLabel, trackingId] }))) : null] })) })) }) })));
};


/***/ }),

/***/ "./src/direflow-components/Common/components/List/FetchError/styles.scss":
/*!*******************************************************************************!*\
  !*** ./src/direflow-components/Common/components/List/FetchError/styles.scss ***!
  \*******************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./styles.scss */ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/List/FetchError/styles.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/List/ListError/index.tsx":
/*!****************************************************************************!*\
  !*** ./src/direflow-components/Common/components/List/ListError/index.tsx ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./styles.scss */ "./src/direflow-components/Common/components/List/ListError/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_3__);




const ListError = ({ onRetry, trackingId }) => {
    const { addressListError, common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.useI18nContext)();
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: (_styles_scss__WEBPACK_IMPORTED_MODULE_3___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "list-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: "/images/illustrations/cloud-failure-192-red-pink.svg", alt: addressListError.title, className: "list-error__illustrations" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "list-error__header" }, { children: addressListError.title })), trackingId && trackingId !== "" ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", Object.assign({ className: "list-error__sub-header" }, { children: ["(", addressListError.errorId, " ", trackingId, ")"] }))) : null, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ariaLabel: addressListError.title, class: "list-error__button", variant: "primary", onClick: onRetry }, { children: common.tryAgain }))] })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ListError);


/***/ }),

/***/ "./src/direflow-components/Common/components/List/ListError/styles.scss":
/*!******************************************************************************!*\
  !*** ./src/direflow-components/Common/components/List/ListError/styles.scss ***!
  \******************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./styles.scss */ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/List/ListError/styles.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/List/ListItem/index.tsx":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/Common/components/List/ListItem/index.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ListItem: () => (/* binding */ ListItem)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var react_window__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react-window */ "../../node_modules/react-window/dist/index.esm.js");
/* harmony import */ var _FetchError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../FetchError */ "./src/direflow-components/Common/components/List/FetchError/index.tsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./styles.scss */ "./src/direflow-components/Common/components/List/ListItem/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_4__);






const ListItem = (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(({ data, index, style }) => {
    var _a, _b, _c, _d;
    const { children, info, onRetry, isItemLoaded, onSelectValue, resetFocusedItemIndex, customData } = data;
    const props = {
        data: info.data[index],
        index,
        style,
        isFocused: info.focusedItem === index,
        isSelected: (_a = (info.data && info.selectedItem === index)) !== null && _a !== void 0 ? _a : false,
        onSelectValue,
        resetFocusedItemIndex,
        customData
    };
    if (!isItemLoaded(index) && info.infiniteScrollEnabled) {
        if ((_b = info.pageFetchError) === null || _b === void 0 ? void 0 : _b.error) {
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FetchError__WEBPACK_IMPORTED_MODULE_3__.FetchError, { trackingId: (_d = (_c = info.pageFetchError) === null || _c === void 0 ? void 0 : _c.trackingId) !== null && _d !== void 0 ? _d : false, onRetry: onRetry, style: style });
        }
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: (_styles_scss__WEBPACK_IMPORTED_MODULE_4___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "infinite-scroll-spinner", style: style }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "24" }) })) })));
    }
    // /* Refer this link, - https://www.developerway.com/posts/react-component-as-prop-the-right-way */
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: children(props) });
}, react_window__WEBPACK_IMPORTED_MODULE_5__.areEqual);



/***/ }),

/***/ "./src/direflow-components/Common/components/List/ListItem/styles.scss":
/*!*****************************************************************************!*\
  !*** ./src/direflow-components/Common/components/List/ListItem/styles.scss ***!
  \*****************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./styles.scss */ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/List/ListItem/styles.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/List/index.tsx":
/*!******************************************************************!*\
  !*** ./src/direflow-components/Common/components/List/index.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var react_window__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! react-window */ "../../node_modules/react-window/dist/index.esm.js");
/* harmony import */ var react_window_infinite_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react-window-infinite-loader */ "../../node_modules/react-window-infinite-loader/dist/index.esm.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ListItem */ "./src/direflow-components/Common/components/List/ListItem/index.tsx");







const List = ({ children, innerElementType = "div", data, customData, customClassName = "", onSelectValue: handleListClick, width = "100%", height = 288, // Pre-Defined Height of the List (To list the 8 items in the list)
itemHeight = 36, // Pre-Defined Item Height of the List Item
resetFocus, resetFocusedAndSelected, hasNextPage, isNextPageLoading, loadNextPage, pageFetchError, infiniteScrollEnabled, hasChildElements, retainLastFocusedItem, ariaLabel, itemKey }) => {
    const [selectedItem, setSelectedItem] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(-1);
    const [focusedItem, setFocusedItem] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(-1);
    const listContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const isItemLoaded = (index) => {
        return !hasNextPage || index < data.length;
    };
    const itemCount = infiniteScrollEnabled && hasNextPage ? data.length + 1 : data.length;
    const InfiniteLoaderProps = {
        isItemLoaded,
        itemCount,
        loadMoreItems: isNextPageLoading ? () => { } : loadNextPage
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        setFocusedItem(-1);
    }, [resetFocus !== null && resetFocus !== void 0 ? resetFocus : 0]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        setFocusedItem(-1);
        setSelectedItem(-1);
    }, [resetFocusedAndSelected !== null && resetFocusedAndSelected !== void 0 ? resetFocusedAndSelected : 0]);
    const updateFocusedItemIndex = (itemIndex) => {
        if (retainLastFocusedItem) {
            setFocusedItem(itemIndex);
            setSelectedItem(itemIndex);
            handleListClick(data[itemIndex]);
        }
        else {
            setFocusedItem(itemIndex);
        }
    };
    const getNewIndex = (currentFocusedIndex, currentSelectedIndex) => {
        if (retainLastFocusedItem && currentFocusedIndex === -1) {
            return currentSelectedIndex;
        }
        return currentFocusedIndex;
    };
    const navigateToNext = (currentIndex, direction) => {
        let newIndex = currentIndex;
        if (direction === _constants__WEBPACK_IMPORTED_MODULE_4__.UP) {
            newIndex = Math.max(0, currentIndex - 1);
        }
        else if (direction === _constants__WEBPACK_IMPORTED_MODULE_4__.DOWN) {
            newIndex = (currentIndex + 1) % data.length;
        }
        updateFocusedItemIndex(newIndex);
        scrollToItem(newIndex);
    };
    const handleArrows = (keyCode) => {
        const newIndex = getNewIndex(focusedItem, selectedItem);
        switch (keyCode) {
            case _constants__WEBPACK_IMPORTED_MODULE_4__.ARROW_UP: {
                navigateToNext(newIndex, _constants__WEBPACK_IMPORTED_MODULE_4__.UP);
                break;
            }
            case _constants__WEBPACK_IMPORTED_MODULE_4__.ARROW_DOWN: {
                navigateToNext(newIndex, _constants__WEBPACK_IMPORTED_MODULE_4__.DOWN);
                break;
            }
            case _constants__WEBPACK_IMPORTED_MODULE_4__.ENTER_KEY_CODE: {
                if (focusedItem > -1) {
                    setSelectedItem(focusedItem);
                    handleListClick(data[focusedItem]); // Sending the selected item object to the parent component.
                }
                break;
            }
            default: {
                // clear the focused item if the list doesn't have child elements
                if (!hasChildElements && !retainLastFocusedItem) {
                    setFocusedItem(-1);
                }
                break;
            }
        }
    };
    const scrollToItem = (index) => {
        if (listContainerRef.current && listContainerRef.current.scrollToItem) {
            listContainerRef.current.scrollToItem(index, "center");
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        return () => {
            setSelectedItem(-1);
        };
    }, []);
    const onListKeyDown = (event) => {
        handleArrows(event.keyCode);
    };
    const onRetry = (event) => {
        event.preventDefault();
        // eslint-disable-next-line no-unused-expressions
        loadNextPage === null || loadNextPage === void 0 ? void 0 : loadNextPage();
    };
    const info = {
        data,
        infiniteScrollEnabled,
        selectedItem,
        focusedItem,
        pageFetchError
    };
    const onSelectValue = (data, index) => {
        setSelectedItem(index);
        handleListClick(data); // Sending the selected item object to the parent component.
        setFocusedItem(index);
    };
    const resetFocusedItemIndex = (index) => {
        const i = index !== undefined && index !== null ? index : -1;
        updateFocusedItemIndex(i);
    };
    const itemData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
        // This helper function memoizes incoming props.
        // To avoid causing unnecessary re-renders pure Row components.
        return {
            children,
            info,
            customData,
            onRetry,
            onSelectValue,
            isItemLoaded,
            resetFocusedItemIndex
        };
    }, [info, onRetry, isItemLoaded, onSelectValue, resetFocusedItemIndex, customData]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(`infinite-list-container`, customClassName), tabIndex: 0 }, (ariaLabel ? { "aria-label": ariaLabel } : {}), { onKeyDown: onListKeyDown }, { children: infiniteScrollEnabled ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_window_infinite_loader__WEBPACK_IMPORTED_MODULE_3__["default"], Object.assign({}, InfiniteLoaderProps, { children: ({ onItemsRendered, ref }) => (
            // This link would be helpful for future Enhancement - https://blog.logrocket.com/how-to-virtualize-large-lists-using-react-window/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_window__WEBPACK_IMPORTED_MODULE_6__.FixedSizeList, Object.assign({ className: "fixed-size-list", innerElementType: innerElementType, height: height, width: width, itemSize: itemHeight, itemData: itemData, ref: (node) => {
                    ref(node);
                    listContainerRef.current = node;
                }, itemCount: itemCount, onItemsRendered: onItemsRendered, itemKey: itemKey }, { children: _ListItem__WEBPACK_IMPORTED_MODULE_5__.ListItem }))) }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_window__WEBPACK_IMPORTED_MODULE_6__.FixedSizeList, Object.assign({ className: "fixed-size-list", innerElementType: innerElementType, height: height, width: width, itemSize: itemHeight, itemData: itemData, ref: listContainerRef, itemCount: itemCount, itemKey: itemKey }, { children: _ListItem__WEBPACK_IMPORTED_MODULE_5__.ListItem }))) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (List);


/***/ }),

/***/ "./src/direflow-components/Common/components/MSTAvatar/index.tsx":
/*!***********************************************************************!*\
  !*** ./src/direflow-components/Common/components/MSTAvatar/index.tsx ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   StatusType: () => (/* binding */ StatusType),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./styles.scss */ "./src/direflow-components/Common/components/MSTAvatar/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Utility_Utils_MSFTavatarUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Utility/Utils/MSFTavatarUtils */ "./src/direflow-components/Utility/Utils/MSFTavatarUtils.ts");
/* harmony import */ var _AvatarStatus_AvatarStatus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../AvatarStatus/AvatarStatus */ "./src/direflow-components/Common/components/AvatarStatus/AvatarStatus.tsx");
/* harmony import */ var _assets_AvatarStatus_busy_presence_bold_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/busy-presence_bold.svg */ "./src/assets/AvatarStatus/busy-presence_bold.svg");
/* harmony import */ var _assets_AvatarStatus_camera_presence_filled_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/camera-presence_filled.svg */ "./src/assets/AvatarStatus/camera-presence_filled.svg");
/* harmony import */ var _assets_AvatarStatus_check_circle_badge_filled_filled_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/check-circle-badge-filled_filled.svg */ "./src/assets/AvatarStatus/check-circle-badge-filled_filled.svg");
/* harmony import */ var _assets_AvatarStatus_dnd_presence_badge_filled_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/dnd-presence-badge_filled.svg */ "./src/assets/AvatarStatus/dnd-presence-badge_filled.svg");
/* harmony import */ var _assets_AvatarStatus_headset_filled_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/headset_filled.svg */ "./src/assets/AvatarStatus/headset_filled.svg");
/* harmony import */ var _assets_AvatarStatus_priority_badge_filled_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/priority-badge_filled.svg */ "./src/assets/AvatarStatus/priority-badge_filled.svg");
/* harmony import */ var _assets_AvatarStatus_pto_presence_filled_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/pto-presence_filled.svg */ "./src/assets/AvatarStatus/pto-presence_filled.svg");
/* harmony import */ var _assets_AvatarStatus_recents_presence_badge_filled_svg__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/recents-presence-badge_filled.svg */ "./src/assets/AvatarStatus/recents-presence-badge_filled.svg");
/* harmony import */ var _assets_AvatarStatus_share_screen_filled_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/share-screen_filled.svg */ "./src/assets/AvatarStatus/share-screen_filled.svg");















const StatusType = {
    Available: "available",
    Busy: "busy",
    OnCall: "oncall",
    Meeting: "meeting",
    DnD: "dnd",
    Presenting: "presenting",
    Occupied: "occupied",
    UnKnown: "unknown",
    OutOfOffice: "outofoffice"
};
const StatusTypeIcon = {
    [StatusType.Available]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_check_circle_badge_filled_filled_svg__WEBPACK_IMPORTED_MODULE_8__["default"], {}),
    [StatusType.Busy]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_busy_presence_bold_svg__WEBPACK_IMPORTED_MODULE_6__["default"], {}),
    [StatusType.OnCall]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_headset_filled_svg__WEBPACK_IMPORTED_MODULE_10__["default"], {}),
    [StatusType.Meeting]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_camera_presence_filled_svg__WEBPACK_IMPORTED_MODULE_7__["default"], {}),
    [StatusType.DnD]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_dnd_presence_badge_filled_svg__WEBPACK_IMPORTED_MODULE_9__["default"], {}),
    [StatusType.Presenting]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_share_screen_filled_svg__WEBPACK_IMPORTED_MODULE_14__["default"], {}),
    [StatusType.Occupied]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_recents_presence_badge_filled_svg__WEBPACK_IMPORTED_MODULE_13__["default"], {}),
    [StatusType.UnKnown]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_priority_badge_filled_svg__WEBPACK_IMPORTED_MODULE_11__["default"], {}),
    [StatusType.OutOfOffice]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_pto_presence_filled_svg__WEBPACK_IMPORTED_MODULE_12__["default"], {})
};
const MSTAvatar = ({ title, alt, size, src, availability, activity, avatarClass }) => {
    const [type, setType] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (availability && activity) {
            setType((0,_Utility_Utils_MSFTavatarUtils__WEBPACK_IMPORTED_MODULE_4__.getAvatarStatus)(availability, activity, StatusType));
        }
        else {
            setType(null);
        }
    }, [availability, activity]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: (_styles_scss__WEBPACK_IMPORTED_MODULE_3___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: `mst-avatar type-${type}` }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AvatarStatus_AvatarStatus__WEBPACK_IMPORTED_MODULE_5__["default"], { size: size, alt: alt, title: title, src: src, statusIcon: type ? StatusTypeIcon[type] : null, avatarClass: avatarClass }) })) })));
};
MSTAvatar.defaultProps = {
    size: 32,
    avatarClass: null,
    src: null
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MSTAvatar);


/***/ }),

/***/ "./src/direflow-components/Common/components/MSTAvatar/styles.scss":
/*!*************************************************************************!*\
  !*** ./src/direflow-components/Common/components/MSTAvatar/styles.scss ***!
  \*************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./styles.scss */ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/MSTAvatar/styles.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/SearchBar/SearchBar.tsx":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/Common/components/SearchBar/SearchBar.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./styles.css */ "./src/direflow-components/Common/components/SearchBar/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_7__);








const SearchBar = (props) => {
    const { searchQuery, setSearchQuery, placeHolderText } = props;
    const { common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.useI18nContext)();
    const searchInp = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const onSearchInputChange = (e) => {
        var _a, _b;
        const searchText = ((_b = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim()) || "";
        setSearchQuery(searchText);
    };
    const debouncedInputChangeHandler = (0,_Utils__WEBPACK_IMPORTED_MODULE_6__.debouncedFunc)((e) => {
        onSearchInputChange(e);
    }, _constants__WEBPACK_IMPORTED_MODULE_5__.TIME_DELAY);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        const searchInput = searchInp === null || searchInp === void 0 ? void 0 : searchInp.current;
        searchInput.addEventListener("input-change", debouncedInputChangeHandler);
        return () => {
            searchInput.removeEventListener("input-change", debouncedInputChangeHandler);
        };
    }, []);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_7___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "search-bar" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-input", Object.assign({ clear: true, ref: searchInp, htmlId: "pillSearchInput", name: "pillSearchInput", ariaLabel: placeHolderText, placeholder: placeHolderText, class: "search-input", value: searchQuery, autoFocus: true, searchable: true, clearAriaLabel: common.clear }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }))) })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SearchBar);


/***/ }),

/***/ "./src/direflow-components/Common/components/SearchBar/styles.css":
/*!************************************************************************!*\
  !*** ./src/direflow-components/Common/components/SearchBar/styles.css ***!
  \************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!./styles.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/SearchBar/styles.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/TooltipEllipsis/index.tsx":
/*!*****************************************************************************!*\
  !*** ./src/direflow-components/Common/components/TooltipEllipsis/index.tsx ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");


const TooltipEllipsis = ({ children, value, placement }) => {
    const tooltipChildRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [isOverflown, setIsOverflown] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const timeOutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        timeOutIdRef.current = window.setTimeout(() => {
            const element = tooltipChildRef === null || tooltipChildRef === void 0 ? void 0 : tooltipChildRef.current;
            if (element) {
                setIsOverflown(element.scrollWidth > element.clientWidth);
            }
        }, 50);
        return () => {
            if (timeOutIdRef.current) {
                window.clearTimeout(timeOutIdRef.current);
            }
        };
    }, [children]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: value, placement: placement }, (!isOverflown ? { disabled: true } : ""), { children: react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(children, { ref: tooltipChildRef }) })));
};
TooltipEllipsis.defaultProps = {
    value: "",
    placement: "top"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TooltipEllipsis);


/***/ }),

/***/ "./src/direflow-components/Common/components/WebexAvatar/WebexAvatar.tsx":
/*!*******************************************************************************!*\
  !*** ./src/direflow-components/Common/components/WebexAvatar/WebexAvatar.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _WebexAvatarPresenceIcon_WebexAvatarPresenceIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../WebexAvatarPresenceIcon/WebexAvatarPresenceIcon */ "./src/direflow-components/Common/components/WebexAvatarPresenceIcon/WebexAvatarPresenceIcon.tsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./styles.scss */ "./src/direflow-components/Common/components/WebexAvatar/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_3__);




const WebexAvatar = ({ name, src, presence }) => {
    const shouldShowPresenceIcon = () => {
        return (presence === "active" ||
            presence === "meeting" ||
            presence === "calendarItem" ||
            presence === "call" ||
            presence === "dnd" ||
            presence === "presenting" ||
            presence === "quiet" ||
            presence === "ooo" ||
            presence === "busy" ||
            presence === "inactive");
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: (_styles_scss__WEBPACK_IMPORTED_MODULE_3___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: `webex-avatar-presence-icon type-${presence ? presence.toLowerCase() : ""}` }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "avatar-status" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-avatar", { size: 32, alt: name, title: name, src: src, className: "list-item-avatar" }), presence && shouldShowPresenceIcon() && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WebexAvatarPresenceIcon_WebexAvatarPresenceIcon__WEBPACK_IMPORTED_MODULE_2__["default"], { presence: presence })] })) })) })));
};
WebexAvatar.defaultProps = {
    presence: undefined,
    children: null
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WebexAvatar);


/***/ }),

/***/ "./src/direflow-components/Common/components/WebexAvatar/styles.scss":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/Common/components/WebexAvatar/styles.scss ***!
  \***************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./styles.scss */ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/Common/components/WebexAvatar/styles.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/components/WebexAvatarPresenceIcon/WebexAvatarPresenceIcon.tsx":
/*!*******************************************************************************************************!*\
  !*** ./src/direflow-components/Common/components/WebexAvatarPresenceIcon/WebexAvatarPresenceIcon.tsx ***!
  \*******************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   getStatusIcon: () => (/* binding */ getStatusIcon)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _assets_AvatarStatus_active_presence_small_filled_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/active-presence-small-filled.svg */ "./src/assets/AvatarStatus/active-presence-small-filled.svg");
/* harmony import */ var _assets_AvatarStatus_camera_presence_filled_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/camera-presence_filled.svg */ "./src/assets/AvatarStatus/camera-presence_filled.svg");
/* harmony import */ var _assets_AvatarStatus_calendar_empty_filled_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/calendar-empty-filled.svg */ "./src/assets/AvatarStatus/calendar-empty-filled.svg");
/* harmony import */ var _assets_AvatarStatus_headset_filled_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/headset_filled.svg */ "./src/assets/AvatarStatus/headset_filled.svg");
/* harmony import */ var _assets_AvatarStatus_dnd_presence_badge_filled_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/dnd-presence-badge_filled.svg */ "./src/assets/AvatarStatus/dnd-presence-badge_filled.svg");
/* harmony import */ var _assets_AvatarStatus_share_screen_filled_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/share-screen_filled.svg */ "./src/assets/AvatarStatus/share-screen_filled.svg");
/* harmony import */ var _assets_AvatarStatus_quiet_hours_presence_filled_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/quiet-hours-presence-filled.svg */ "./src/assets/AvatarStatus/quiet-hours-presence-filled.svg");
/* harmony import */ var _assets_AvatarStatus_pto_presence_filled_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/pto-presence_filled.svg */ "./src/assets/AvatarStatus/pto-presence_filled.svg");
/* harmony import */ var _assets_AvatarStatus_busy_presence_bold_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/busy-presence_bold.svg */ "./src/assets/AvatarStatus/busy-presence_bold.svg");
/* harmony import */ var _assets_AvatarStatus_recents_presence_badge_filled_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../assets/AvatarStatus/recents-presence-badge_filled.svg */ "./src/assets/AvatarStatus/recents-presence-badge_filled.svg");
/* harmony import */ var _Utility_Utils_WebexAvatarUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Utility/Utils/WebexAvatarUtils */ "./src/direflow-components/Utility/Utils/WebexAvatarUtils.ts");












const getStatusIcon = (statusIcon) => {
    const icons = {
        [_Utility_Utils_WebexAvatarUtils__WEBPACK_IMPORTED_MODULE_11__.WebexStatus.Active]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_active_presence_small_filled_svg__WEBPACK_IMPORTED_MODULE_1__["default"], {}),
        [_Utility_Utils_WebexAvatarUtils__WEBPACK_IMPORTED_MODULE_11__.WebexStatus.Meeting]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_camera_presence_filled_svg__WEBPACK_IMPORTED_MODULE_2__["default"], {}),
        [_Utility_Utils_WebexAvatarUtils__WEBPACK_IMPORTED_MODULE_11__.WebexStatus.CalendarItem]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_calendar_empty_filled_svg__WEBPACK_IMPORTED_MODULE_3__["default"], {}),
        [_Utility_Utils_WebexAvatarUtils__WEBPACK_IMPORTED_MODULE_11__.WebexStatus.Call]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_headset_filled_svg__WEBPACK_IMPORTED_MODULE_4__["default"], {}),
        [_Utility_Utils_WebexAvatarUtils__WEBPACK_IMPORTED_MODULE_11__.WebexStatus.Dnd]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_dnd_presence_badge_filled_svg__WEBPACK_IMPORTED_MODULE_5__["default"], {}),
        [_Utility_Utils_WebexAvatarUtils__WEBPACK_IMPORTED_MODULE_11__.WebexStatus.Presenting]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_share_screen_filled_svg__WEBPACK_IMPORTED_MODULE_6__["default"], {}),
        [_Utility_Utils_WebexAvatarUtils__WEBPACK_IMPORTED_MODULE_11__.WebexStatus.Quiet]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_quiet_hours_presence_filled_svg__WEBPACK_IMPORTED_MODULE_7__["default"], {}),
        [_Utility_Utils_WebexAvatarUtils__WEBPACK_IMPORTED_MODULE_11__.WebexStatus.OOO]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_pto_presence_filled_svg__WEBPACK_IMPORTED_MODULE_8__["default"], {}),
        [_Utility_Utils_WebexAvatarUtils__WEBPACK_IMPORTED_MODULE_11__.WebexStatus.Busy]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_busy_presence_bold_svg__WEBPACK_IMPORTED_MODULE_9__["default"], {}),
        [_Utility_Utils_WebexAvatarUtils__WEBPACK_IMPORTED_MODULE_11__.WebexStatus.Inactive]: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_AvatarStatus_recents_presence_badge_filled_svg__WEBPACK_IMPORTED_MODULE_10__["default"], {})
    };
    return icons[`${statusIcon ? statusIcon.toLowerCase() : "unknown"}`] || null;
};
const WebexAvatarPresenceIcon = ({ presence }) => {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "status" }, { children: getStatusIcon(presence) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WebexAvatarPresenceIcon);


/***/ }),

/***/ "./src/direflow-components/Common/components/styles.css":
/*!**************************************************************!*\
  !*** ./src/direflow-components/Common/components/styles.css ***!
  \**************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../node_modules/css-loader/dist/cjs.js!./styles.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Common/components/styles.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Common/constants.ts":
/*!*****************************************************!*\
  !*** ./src/direflow-components/Common/constants.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ADDRESS_BOOK: () => (/* binding */ ADDRESS_BOOK),
/* harmony export */   AGENTS: () => (/* binding */ AGENTS),
/* harmony export */   AGENTX_DEFAULT_FOCUS: () => (/* binding */ AGENTX_DEFAULT_FOCUS),
/* harmony export */   AGENT_STATE_CHANGEDBY_NAME: () => (/* binding */ AGENT_STATE_CHANGEDBY_NAME),
/* harmony export */   ALERT_BANNER_DETAILS: () => (/* binding */ ALERT_BANNER_DETAILS),
/* harmony export */   ALL: () => (/* binding */ ALL),
/* harmony export */   ARROW_DOWN: () => (/* binding */ ARROW_DOWN),
/* harmony export */   ARROW_UP: () => (/* binding */ ARROW_UP),
/* harmony export */   AVAILABLE: () => (/* binding */ AVAILABLE),
/* harmony export */   AX_ANNOUNCEMENT_UPDATE: () => (/* binding */ AX_ANNOUNCEMENT_UPDATE),
/* harmony export */   AX_END_MONITORING: () => (/* binding */ AX_END_MONITORING),
/* harmony export */   AX_IDLE_CODE_UPDATE: () => (/* binding */ AX_IDLE_CODE_UPDATE),
/* harmony export */   AX_PRESENCE_STATE_UPDATE: () => (/* binding */ AX_PRESENCE_STATE_UPDATE),
/* harmony export */   AX_WEBEX_CALL_HOLD_RESUME: () => (/* binding */ AX_WEBEX_CALL_HOLD_RESUME),
/* harmony export */   AX_WEBEX_CALL_MUTE_UNMUTE: () => (/* binding */ AX_WEBEX_CALL_MUTE_UNMUTE),
/* harmony export */   AX_WEBEX_CALL_SEND_DTMF: () => (/* binding */ AX_WEBEX_CALL_SEND_DTMF),
/* harmony export */   AX_WEB_CALL_MUTE_UNMUTE: () => (/* binding */ AX_WEB_CALL_MUTE_UNMUTE),
/* harmony export */   ApiResponseState: () => (/* binding */ ApiResponseState),
/* harmony export */   BARGEIN: () => (/* binding */ BARGEIN),
/* harmony export */   BARGEIN_BUTTON: () => (/* binding */ BARGEIN_BUTTON),
/* harmony export */   BARGE_IN_MONITORING_STATE: () => (/* binding */ BARGE_IN_MONITORING_STATE),
/* harmony export */   CAD_VAR_MAX: () => (/* binding */ CAD_VAR_MAX),
/* harmony export */   CALLBACK: () => (/* binding */ CALLBACK),
/* harmony export */   CAMPAIGN: () => (/* binding */ CAMPAIGN),
/* harmony export */   CAMPAIGN_OUTDIAL_CUSTOMER: () => (/* binding */ CAMPAIGN_OUTDIAL_CUSTOMER),
/* harmony export */   CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER: () => (/* binding */ CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER),
/* harmony export */   CANCELCTQ: () => (/* binding */ CANCELCTQ),
/* harmony export */   CONFERENCE: () => (/* binding */ CONFERENCE),
/* harmony export */   CONFERENCE_BUTTON: () => (/* binding */ CONFERENCE_BUTTON),
/* harmony export */   CONFERENCE_COMPLETED: () => (/* binding */ CONFERENCE_COMPLETED),
/* harmony export */   CONFERENCING: () => (/* binding */ CONFERENCING),
/* harmony export */   CONNECTED: () => (/* binding */ CONNECTED),
/* harmony export */   CONNECTOR_VIEW_WIDTH: () => (/* binding */ CONNECTOR_VIEW_WIDTH),
/* harmony export */   CONSULT: () => (/* binding */ CONSULT),
/* harmony export */   CONSULTED_AGENT_HELD: () => (/* binding */ CONSULTED_AGENT_HELD),
/* harmony export */   CONSULTED_AGENT_UNHELD: () => (/* binding */ CONSULTED_AGENT_UNHELD),
/* harmony export */   CONSULTING: () => (/* binding */ CONSULTING),
/* harmony export */   CONSULT_BUTTON: () => (/* binding */ CONSULT_BUTTON),
/* harmony export */   CONSULT_COMPLETED: () => (/* binding */ CONSULT_COMPLETED),
/* harmony export */   CONSULT_HOLD: () => (/* binding */ CONSULT_HOLD),
/* harmony export */   CONSULT_REQUESTED: () => (/* binding */ CONSULT_REQUESTED),
/* harmony export */   CONSULT_UNHELD: () => (/* binding */ CONSULT_UNHELD),
/* harmony export */   COURTESY_CALLBACK: () => (/* binding */ COURTESY_CALLBACK),
/* harmony export */   DESKTOP_NOTIFICATION_SOUND_SETTINGS: () => (/* binding */ DESKTOP_NOTIFICATION_SOUND_SETTINGS),
/* harmony export */   DIALNUMBER: () => (/* binding */ DIALNUMBER),
/* harmony export */   DIAL_NUMBER: () => (/* binding */ DIAL_NUMBER),
/* harmony export */   DN: () => (/* binding */ DN),
/* harmony export */   DOWN: () => (/* binding */ DOWN),
/* harmony export */   EMPTY_COLUMN_VALUE: () => (/* binding */ EMPTY_COLUMN_VALUE),
/* harmony export */   EMPTY_DETAIL_VALUE: () => (/* binding */ EMPTY_DETAIL_VALUE),
/* harmony export */   END: () => (/* binding */ END),
/* harmony export */   ENDCONFERENCE: () => (/* binding */ ENDCONFERENCE),
/* harmony export */   ENDCONSULT: () => (/* binding */ ENDCONSULT),
/* harmony export */   ENDCONSULT_BUTTON: () => (/* binding */ ENDCONSULT_BUTTON),
/* harmony export */   ENDMONITORING: () => (/* binding */ ENDMONITORING),
/* harmony export */   ENDMONITORING_BUTTON: () => (/* binding */ ENDMONITORING_BUTTON),
/* harmony export */   END_BUTTON: () => (/* binding */ END_BUTTON),
/* harmony export */   END_CONFERENCE_BUTTON: () => (/* binding */ END_CONFERENCE_BUTTON),
/* harmony export */   ENGAGED: () => (/* binding */ ENGAGED),
/* harmony export */   ENTER_KEY: () => (/* binding */ ENTER_KEY),
/* harmony export */   ENTER_KEY_CODE: () => (/* binding */ ENTER_KEY_CODE),
/* harmony export */   ENTRYPOINT: () => (/* binding */ ENTRYPOINT),
/* harmony export */   ENTRY_POINT: () => (/* binding */ ENTRY_POINT),
/* harmony export */   EPDN: () => (/* binding */ EPDN),
/* harmony export */   EPDN_CONSULTING: () => (/* binding */ EPDN_CONSULTING),
/* harmony export */   EPDN_HOLD: () => (/* binding */ EPDN_HOLD),
/* harmony export */   EP_DN: () => (/* binding */ EP_DN),
/* harmony export */   ERROR_TRIGGERING_IDLE_CODES: () => (/* binding */ ERROR_TRIGGERING_IDLE_CODES),
/* harmony export */   ESCAPE_KEY_CODE: () => (/* binding */ ESCAPE_KEY_CODE),
/* harmony export */   EVENT_TYPES: () => (/* binding */ EVENT_TYPES),
/* harmony export */   EXITCONFERENCE: () => (/* binding */ EXITCONFERENCE),
/* harmony export */   EXIT_CONFERENCE: () => (/* binding */ EXIT_CONFERENCE),
/* harmony export */   EXIT_CONSULT: () => (/* binding */ EXIT_CONSULT),
/* harmony export */   FC_DESKTOP_VIEW: () => (/* binding */ FC_DESKTOP_VIEW),
/* harmony export */   FLOW_ACTIVITY_EVENT: () => (/* binding */ FLOW_ACTIVITY_EVENT),
/* harmony export */   HOLD: () => (/* binding */ HOLD),
/* harmony export */   HOLD_BUTTON: () => (/* binding */ HOLD_BUTTON),
/* harmony export */   IDLE: () => (/* binding */ IDLE),
/* harmony export */   INBOUND: () => (/* binding */ INBOUND),
/* harmony export */   INBOUNDQUEUE: () => (/* binding */ INBOUNDQUEUE),
/* harmony export */   INTERACTION_PANEL: () => (/* binding */ INTERACTION_PANEL),
/* harmony export */   KEYPAD: () => (/* binding */ KEYPAD),
/* harmony export */   KEYPAD_BUTTON: () => (/* binding */ KEYPAD_BUTTON),
/* harmony export */   MAX_FIELD_VALUE_LENGTH: () => (/* binding */ MAX_FIELD_VALUE_LENGTH),
/* harmony export */   MEDIA_TYPES: () => (/* binding */ MEDIA_TYPES),
/* harmony export */   MERGE_BUTTON: () => (/* binding */ MERGE_BUTTON),
/* harmony export */   MINIMUM_CHARACTERS_FOR_SEARCH: () => (/* binding */ MINIMUM_CHARACTERS_FOR_SEARCH),
/* harmony export */   MONITORINGHELD: () => (/* binding */ MONITORINGHELD),
/* harmony export */   MONITORINGHELD_BUTTON: () => (/* binding */ MONITORINGHELD_BUTTON),
/* harmony export */   MONITORINGUNHELD: () => (/* binding */ MONITORINGUNHELD),
/* harmony export */   MONITORINGUNHELD_BUTTON: () => (/* binding */ MONITORINGUNHELD_BUTTON),
/* harmony export */   MONITORING_TYPE: () => (/* binding */ MONITORING_TYPE),
/* harmony export */   MUTE: () => (/* binding */ MUTE),
/* harmony export */   MUTE_BUTTON: () => (/* binding */ MUTE_BUTTON),
/* harmony export */   NONE: () => (/* binding */ NONE),
/* harmony export */   ORGANIZATION: () => (/* binding */ ORGANIZATION),
/* harmony export */   ORG_CONTAINER_HEIGHT: () => (/* binding */ ORG_CONTAINER_HEIGHT),
/* harmony export */   ORG_CONTAINER_HEIGHT_INFINITE_SCROLL: () => (/* binding */ ORG_CONTAINER_HEIGHT_INFINITE_SCROLL),
/* harmony export */   OUTBOUND: () => (/* binding */ OUTBOUND),
/* harmony export */   OUTBOUND_TYPE: () => (/* binding */ OUTBOUND_TYPE),
/* harmony export */   OUTDIAL_RESERVATION: () => (/* binding */ OUTDIAL_RESERVATION),
/* harmony export */   OUT_DIAL: () => (/* binding */ OUT_DIAL),
/* harmony export */   PAGE_SIZE: () => (/* binding */ PAGE_SIZE),
/* harmony export */   PAUSE: () => (/* binding */ PAUSE),
/* harmony export */   POST_CALL: () => (/* binding */ POST_CALL),
/* harmony export */   POST_CALL_CONSULT_TYPE: () => (/* binding */ POST_CALL_CONSULT_TYPE),
/* harmony export */   PRESENCE_SYNC: () => (/* binding */ PRESENCE_SYNC),
/* harmony export */   PROFILE_ROUTING_MODES: () => (/* binding */ PROFILE_ROUTING_MODES),
/* harmony export */   PROGRESSIVE_CAMPAIGN: () => (/* binding */ PROGRESSIVE_CAMPAIGN),
/* harmony export */   PROGRESSIVE_CAMPAIGN_ICON: () => (/* binding */ PROGRESSIVE_CAMPAIGN_ICON),
/* harmony export */   QUEUES: () => (/* binding */ QUEUES),
/* harmony export */   RECORDING: () => (/* binding */ RECORDING),
/* harmony export */   RECORDINGPAUSE: () => (/* binding */ RECORDINGPAUSE),
/* harmony export */   RECORDINGPAUSE_BUTTON: () => (/* binding */ RECORDINGPAUSE_BUTTON),
/* harmony export */   RECORDINGRESUME: () => (/* binding */ RECORDINGRESUME),
/* harmony export */   RECORDINGRESUME_BUTTON: () => (/* binding */ RECORDINGRESUME_BUTTON),
/* harmony export */   RECORDING_BUTTON: () => (/* binding */ RECORDING_BUTTON),
/* harmony export */   RESUME: () => (/* binding */ RESUME),
/* harmony export */   RESUME_BUTTON: () => (/* binding */ RESUME_BUTTON),
/* harmony export */   RINGING: () => (/* binding */ RINGING),
/* harmony export */   RONA: () => (/* binding */ RONA),
/* harmony export */   RONA_TIMEOUT: () => (/* binding */ RONA_TIMEOUT),
/* harmony export */   SILENTMONITORING: () => (/* binding */ SILENTMONITORING),
/* harmony export */   SOUND_DEFAULT_SETTINGS: () => (/* binding */ SOUND_DEFAULT_SETTINGS),
/* harmony export */   SPACE_KEY: () => (/* binding */ SPACE_KEY),
/* harmony export */   STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON: () => (/* binding */ STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON),
/* harmony export */   STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE: () => (/* binding */ STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE),
/* harmony export */   STATE_POST_CALL: () => (/* binding */ STATE_POST_CALL),
/* harmony export */   SUPERVISOR: () => (/* binding */ SUPERVISOR),
/* harmony export */   SWITCH_BUTTON: () => (/* binding */ SWITCH_BUTTON),
/* harmony export */   TIMEOUT_HUNDRED_FIFTY_MS: () => (/* binding */ TIMEOUT_HUNDRED_FIFTY_MS),
/* harmony export */   TIMEOUT_TEN_MS: () => (/* binding */ TIMEOUT_TEN_MS),
/* harmony export */   TIMEOUT_THOUSAND_MS: () => (/* binding */ TIMEOUT_THOUSAND_MS),
/* harmony export */   TIMER_FIELDS: () => (/* binding */ TIMER_FIELDS),
/* harmony export */   TIME_DELAY: () => (/* binding */ TIME_DELAY),
/* harmony export */   TRANSFER: () => (/* binding */ TRANSFER),
/* harmony export */   TRANSFER_BUTTON: () => (/* binding */ TRANSFER_BUTTON),
/* harmony export */   TRANSFER_COMPLETED: () => (/* binding */ TRANSFER_COMPLETED),
/* harmony export */   UNMUTE: () => (/* binding */ UNMUTE),
/* harmony export */   UNMUTE_BUTTON: () => (/* binding */ UNMUTE_BUTTON),
/* harmony export */   UP: () => (/* binding */ UP),
/* harmony export */   UPDATE_RTD_DATA: () => (/* binding */ UPDATE_RTD_DATA),
/* harmony export */   USER_PREFERENCE: () => (/* binding */ USER_PREFERENCE),
/* harmony export */   WEBEX_EXPERTS: () => (/* binding */ WEBEX_EXPERTS),
/* harmony export */   WEB_RTC_STATUS: () => (/* binding */ WEB_RTC_STATUS),
/* harmony export */   WELLBEING_BREAK: () => (/* binding */ WELLBEING_BREAK),
/* harmony export */   WHISPER: () => (/* binding */ WHISPER),
/* harmony export */   WHISPER_COACH_BUTTON: () => (/* binding */ WHISPER_COACH_BUTTON),
/* harmony export */   WRAPUP_ASSIST: () => (/* binding */ WRAPUP_ASSIST),
/* harmony export */   WRAP_UP: () => (/* binding */ WRAP_UP),
/* harmony export */   availableOption: () => (/* binding */ availableOption),
/* harmony export */   nonToggleButtons: () => (/* binding */ nonToggleButtons),
/* harmony export */   retryAttemptContactHistory: () => (/* binding */ retryAttemptContactHistory)
/* harmony export */ });
/**
 * Interaction Control component events
 */
const RINGING = "RINGING";
const END = "END";
const PAUSE = "PAUSE";
const RESUME = "RESUME";
const CONNECTED = "CONNECTED";
const CONSULT = "CONSULT";
const CONSULT_COMPLETED = "consultCompleted";
const CONFERENCE = "CONFERENCE";
const CONSULTING = "CONSULTING";
const CONFERENCING = "CONFERENCING";
const CONSULT_REQUESTED = "CONSULT REQUESTED";
const CONFERENCE_COMPLETED = "conference-completed";
const EPDN_CONSULTING = "EPDN_CONSULTING";
const EPDN_HOLD = "EPDN_HOLD";
const RECORDING = "RECORDING";
const RECORDINGPAUSE = "RECORDINGPAUSE";
const RECORDINGRESUME = "RECORDINGRESUME";
const CONSULT_UNHELD = "CONSULT UNHELD";
const TRANSFER = "TRANSFER";
const ENDCONSULT = "ENDCONSULT";
const CANCELCTQ = "CANCELCTQ";
const HOLD = "HOLD";
const CONSULT_HOLD = "CONSULT HOLD";
const WRAP_UP = "WRAP UP";
const USER_PREFERENCE = "user_preference";
const WHISPER = "WHISPER";
const BARGEIN = "BARGEIN";
const SILENTMONITORING = "SILENTMONITORING";
const ENDMONITORING = "ENDMONITORING";
const MONITORINGHELD = "MONITORINGHELD";
const MONITORINGUNHELD = "MONITORINGUNHELD";
const UPDATE_RTD_DATA = "UPDATE_RTD_DATA";
const KEYPAD = "KEYPAD";
const MUTE = "MUTE";
const UNMUTE = "UNMUTE";
const WRAPUP_ASSIST = "WRAPUP-ASSIST";
const POST_CALL = "POST-CALL";
const FLOW_ACTIVITY_EVENT = "flow-activity";
const AGENTX_DEFAULT_FOCUS = "agentx-default-focus";
const QUEUES = "Queues";
const AGENTS = "Agents";
const DIAL_NUMBER = "Dial Number";
const ADDRESS_BOOK = "Address Book";
const ORGANIZATION = "Organization";
const WEBEX_EXPERTS = "WebexExperts";
const ENTRY_POINT = "Entry Point";
const INBOUNDQUEUE = "inboundqueue";
const AVAILABLE = "Available";
const DIALNUMBER = "DialNumber";
const ALL = "all";
const DN = "DN";
const ENDCONFERENCE = "ENDCONFERENCE";
const EXITCONFERENCE = "EXITCONFERENCE";
const EPDN = "EpDn";
const ENTRYPOINT = "entryPoint";
const EP_DN = "EP-DN";
const TRANSFER_COMPLETED = "transfer-completed";
const WELLBEING_BREAK = "WellbeingBreak";
const STATE_POST_CALL = "post_call";
/**
 * Interaction Control buttons label
 */
const CONSULT_BUTTON = "CONSULT_BUTTON";
const ENDCONSULT_BUTTON = "ENDCONSULT_BUTTON";
const CONSULTED_AGENT_HELD = "CONSULTED_AGENT_HELD";
const CONSULTED_AGENT_UNHELD = "CONSULTED_AGENT_UNHELD";
const CONFERENCE_BUTTON = "CONFERENCE_BUTTON";
const TRANSFER_BUTTON = "TRANSFER_BUTTON";
const END_BUTTON = "END_BUTTON";
const HOLD_BUTTON = "HOLD_BUTTON";
const EXIT_CONSULT = "EXIT_CONSULT";
const RESUME_BUTTON = "RESUME_BUTTON";
const RECORDING_BUTTON = "RECORDING_BUTTON";
const END_CONFERENCE_BUTTON = "ENDCONFERENCE_BUTTON";
const EXIT_CONFERENCE = "EXITCONFERENCE_BUTTON";
const RECORDINGPAUSE_BUTTON = "RECORDINGPAUSE_BUTTON";
const RECORDINGRESUME_BUTTON = "RECORDINGRESUME_BUTTON";
const WHISPER_COACH_BUTTON = "WHISPER_COACH_BUTTON";
const BARGEIN_BUTTON = "BARGEIN_BUTTON";
const MONITORINGHELD_BUTTON = "MONITORINGHELD_BUTTON";
const MONITORINGUNHELD_BUTTON = "MONITORINGUNHELD_BUTTON";
const ENDMONITORING_BUTTON = "ENDMONITORING_BUTTON";
const KEYPAD_BUTTON = "KEYPAD_BUTTON";
const MUTE_BUTTON = "MUTE_BUTTON";
const UNMUTE_BUTTON = "UNMUTE_BUTTON";
const AX_ANNOUNCEMENT_UPDATE = "ax-announcement-update";
const nonToggleButtons = [
    TRANSFER_BUTTON,
    CONSULT_BUTTON,
    ENDCONSULT_BUTTON,
    CONFERENCE_BUTTON,
    END_BUTTON,
    ENDMONITORING_BUTTON,
    BARGEIN_BUTTON,
    RECORDINGPAUSE_BUTTON,
    RECORDINGRESUME_BUTTON,
    HOLD_BUTTON,
    RESUME_BUTTON,
    END_CONFERENCE_BUTTON,
    MONITORINGHELD_BUTTON,
    MONITORINGUNHELD_BUTTON,
    MUTE_BUTTON,
    UNMUTE_BUTTON,
    EXITCONFERENCE
];
/**
 * interaction mediaTypes
 */
const MEDIA_TYPES = {
    CHAT: "chat",
    EMAIL: "email",
    VOICE: "telephony",
    OUTBOUND_VOICE: "outbound telephony",
    OUTBOUND_AGENT_INITIATED_EMAIL: "outboundEmail",
    OUTBOUND_AGENT_INITIATED_SMS: "outboundSms",
    SOCIAL: "social",
    SMS: "sms",
    FACEBOOK: "facebook",
    WHATSAPP: "whatsapp",
    MIDCALL_MONITORING: "midcall telephony",
    APPLE_BUSINESS_CHAT: "appleMessages",
    GOOGLE_BUSINESS_CHAT: "googleMessages"
};
var MONITORING_TYPE;
(function (MONITORING_TYPE) {
    MONITORING_TYPE["MIDCALL"] = "midcall";
    MONITORING_TYPE["ADHOC"] = "adhoc";
    MONITORING_TYPE["CONTINUOUS"] = "continuous";
})(MONITORING_TYPE || (MONITORING_TYPE = {}));
const OUTBOUND_TYPE = {
    OUTDIAL: "OUTDIAL",
    CALLBACK: "CALLBACK",
    IVR_PREDICTIVE: "IVR_PREDICTIVE",
    IVR_PROGRESSIVE: "IVR_PROGRESSIVE",
    CAMPAIGN: "CAMPAIGN",
    OUTDIAL_RESERVATION: "OUTDIAL_RESERVATION"
};
/**
 * Common
 */
const ENTER_KEY_CODE = 13;
const ESCAPE_KEY_CODE = 27;
const OUTBOUND = "OUTBOUND";
const OUT_DIAL = "OUTDIAL";
const INBOUND = "INBOUND";
const ENGAGED = "Engaged";
const IDLE = "Idle";
const RONA = "RONA";
const ENTER_KEY = "Enter";
const SPACE_KEY = " ";
const COURTESY_CALLBACK = "COURTESY_CALLBACK";
const PROGRESSIVE_CAMPAIGN = "PROGRESSIVE_CAMPAIGN";
const CAMPAIGN_OUTDIAL_CUSTOMER = "CAMPAIGN_OUTDIAL_CUSTOMER";
const CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER = "CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER";
const OUTDIAL_RESERVATION = "OUTDIAL_RESERVATION";
const CAMPAIGN = "CAMPAIGN";
const CALLBACK = "CALLBACK";
const DESKTOP_NOTIFICATION_SOUND_SETTINGS = "desktop-notification-sound-settings";
const CAD_VAR_MAX = 256;
const FC_DESKTOP_VIEW = "FC-DESKTOP-VIEW";
const INTERACTION_PANEL = "interaction-panel";
const RONA_TIMEOUT = "ronaTimeout";
const SUPERVISOR = "supervisor";
const SOUND_DEFAULT_SETTINGS = '{"default":{"sound":true,"volume":0.8,"mute":false}}';
const AGENT_STATE_CHANGEDBY_NAME = "agentStateChangedByName";
const BARGE_IN_MONITORING_STATE = "BargeIn";
const PROGRESSIVE_CAMPAIGN_ICON = "progressive_campaign";
const STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON = "STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT";
const STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE = 1087;
const ALERT_BANNER_DETAILS = "alertBannerDetails";
const ERROR_TRIGGERING_IDLE_CODES = {
    INVALID_NUMBER: "INVALID_NUMBER",
    UNREACHABLE: "UNREACHABLE",
    DECLINED: "DECLINED",
    BUSY: "BUSY",
    CHANNEL_FAILURE: "CHANNEL_FAILURE",
    RONA: "RONA"
};
const EVENT_TYPES = {
    AGENT_OFFER_CONTACT: "AgentOfferContact",
    AGENT_OFFER_CONSULT: "AgentOfferConsult",
    AGENT_CONTACT: "AgentContact",
    AGENT_CONSULTING: "AgentConsulting",
    AGENT_CONTACT_ASSIGNED: "AgentContactAssigned",
    AGENT_CONTACT_RESERVED: "AgentContactReserved",
    MONITORING_OFFERED: "MonitoringOffered",
    MONITORING_STARTED: "MonitoringStarted",
    AGENT_OFFER_CAMPAIGN_RESERVED: "AgentOfferCampaignReservation",
    AGENT_ADD_CAMPAIGN_RESERVED: "AgentAddCampaignReservation"
};
const PROFILE_ROUTING_MODES = {
    BLENDED: "BLENDED",
    EXCLUSIVE: "EXCLUSIVE",
    REALTIME: "BLENDED_REALTIME"
};
const EMPTY_COLUMN_VALUE = "-";
const TIMER_FIELDS = ["totalcontactduration", "timeincontactstatus", "agentinteractiontime"];
const AX_WEB_CALL_MUTE_UNMUTE = "ax-web-call-mute-unmute";
const AX_WEBEX_CALL_MUTE_UNMUTE = "ax-webex-call-mute-unmute";
const AX_WEBEX_CALL_HOLD_RESUME = "ax-webex-call-hold-resume";
const AX_WEBEX_CALL_SEND_DTMF = "ax-webex-call-send-dtmf";
const AX_END_MONITORING = "ax-end-monitoring";
const WEB_RTC_STATUS = {
    WEB_RTC_CONNECTED: "webRtcConnected",
    WEB_RTC_REGISTERING: "webRtcRegistering",
    WEB_RTC_DISCONNECTED: "webRtcDisconnected"
};
const PAGE_SIZE = 50;
const MINIMUM_CHARACTERS_FOR_SEARCH = 3;
const TIMEOUT_TEN_MS = 10;
const TIMEOUT_HUNDRED_FIFTY_MS = 200;
const TIMEOUT_THOUSAND_MS = 1000;
const EMPTY_DETAIL_VALUE = "-";
// Consult/Transfer Organization Container Height
const ORG_CONTAINER_HEIGHT = 240;
const CONNECTOR_VIEW_WIDTH = 640;
const ORG_CONTAINER_HEIGHT_INFINITE_SCROLL = 290;
const MAX_FIELD_VALUE_LENGTH = 180;
const PRESENCE_SYNC = "PRESENCE_SYNC";
const AX_PRESENCE_STATE_UPDATE = "ax-presence-state-update";
const AX_IDLE_CODE_UPDATE = "ax-idle-codes-update";
const retryAttemptContactHistory = 1;
const availableOption = {
    name: AVAILABLE,
    id: "0",
    isDefault: false,
    isSystem: false
};
const ARROW_UP = 38;
const ARROW_DOWN = 40;
const UP = "UP";
const DOWN = "DOWN";
const NONE = "none";
const TIME_DELAY = 500;
var ApiResponseState;
(function (ApiResponseState) {
    ApiResponseState["FAIL"] = "FAIL";
    ApiResponseState["PASS"] = "PASS"; // The API call succeeded
})(ApiResponseState || (ApiResponseState = {}));
const MERGE_BUTTON = {
    icon: "call-merge-bold",
    ariaLabel: "mergeCall"
};
const SWITCH_BUTTON = {
    icon: "call-swap-bold",
    ariaLabel: "switchCall"
};
var POST_CALL_CONSULT_TYPE;
(function (POST_CALL_CONSULT_TYPE) {
    POST_CALL_CONSULT_TYPE["ACTIVE"] = "consulting";
    POST_CALL_CONSULT_TYPE["COMPLETED"] = "consultCompleted";
    POST_CALL_CONSULT_TYPE["INITIATED"] = "consultInitiated";
})(POST_CALL_CONSULT_TYPE || (POST_CALL_CONSULT_TYPE = {}));


/***/ }),

/***/ "./src/direflow-components/ContactHistory/ContactHistoryHelper.ts":
/*!************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/ContactHistoryHelper.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DATE_FORMAT: () => (/* binding */ DATE_FORMAT),
/* harmony export */   DATE_TIME_FORMAT: () => (/* binding */ DATE_TIME_FORMAT),
/* harmony export */   DURATION_FORMAT: () => (/* binding */ DURATION_FORMAT),
/* harmony export */   DURATION_FORMAT_POSTFIX: () => (/* binding */ DURATION_FORMAT_POSTFIX),
/* harmony export */   MERIDIEM_TIME_FORMAT: () => (/* binding */ MERIDIEM_TIME_FORMAT),
/* harmony export */   convertToTime: () => (/* binding */ convertToTime),
/* harmony export */   fetchHistoryByANI: () => (/* binding */ fetchHistoryByANI),
/* harmony export */   fetchHistoryByAgent: () => (/* binding */ fetchHistoryByAgent),
/* harmony export */   fetchTranscript: () => (/* binding */ fetchTranscript),
/* harmony export */   getContactsSorted: () => (/* binding */ getContactsSorted),
/* harmony export */   getIconName: () => (/* binding */ getIconName),
/* harmony export */   getTimerLabel: () => (/* binding */ getTimerLabel),
/* harmony export */   groupContactsByStartDate: () => (/* binding */ groupContactsByStartDate),
/* harmony export */   isOutdialTypeProgressive: () => (/* binding */ isOutdialTypeProgressive),
/* harmony export */   logger: () => (/* binding */ logger)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _HandledByAgent_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./HandledByAgent/types */ "./src/direflow-components/ContactHistory/HandledByAgent/types.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-restricted-syntax */
/**
 * Utilities methods
 */
/* eslint-disable no-await-in-loop */






const DATE_TIME_FORMAT = "LL/dd/yy hh:mm a";
const DATE_FORMAT = "LL/dd/yy";
const DURATION_FORMAT = "hh-mm-ss";
const DURATION_FORMAT_POSTFIX = ["h", "m", "s"];
const MERIDIEM_TIME_FORMAT = "hh:mm a";
// Concat history durations can be 1 day, 1 week, 1 month, 2 month until it reaches to 100 records
const DURATIONS_FOR_CONTACT_HISTORY_BY_ANI = [1, 6, 23, 60];
// maximum number of records to be displayed in the report
const CONTACT_HISTORY_RECORD_LIMIT = 100;
const TWENTY_FOUR_HOURS = 1;
const logger = (0,_sdk__WEBPACK_IMPORTED_MODULE_3__.createLogger)("[ContactHistory]");
const PROGRESSIVE = "PROGRESSIVE";
const PREDICTIVE = "PREDICTIVE";
const PREVIEW_CAMPAIGN = "PREVIEW_CAMPAIGN";
const PROGRESSIVE_CAMPAIGN = "PROGRESSIVE_CAMPAIGN";
const ANONYMOUS = "anonymous";
const getEndTime = (previousStartTime) => previousStartTime - 1;
const getStartTime = (endTime, days) => luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.fromMillis(endTime).minus({ days }).valueOf();
function limit(contacts, remainingRecords) {
    let newContacts = [];
    newContacts = contacts.slice(0, remainingRecords);
    return newContacts;
}
function fetchHistoryByANIAqm(ani) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        let previousStartTime = 0;
        let loadedContacts = [];
        const startDate = luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.local();
        let remainingRecords = CONTACT_HISTORY_RECORD_LIMIT;
        /** Iterate through all the report durations */
        for (const days of DURATIONS_FOR_CONTACT_HISTORY_BY_ANI) {
            const endTime = days === 1 ? startDate.toMillis() : getEndTime(previousStartTime);
            const startTime = getStartTime(endTime, days);
            previousStartTime = startTime;
            const res = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.fetchHistoryByANI({
                ani,
                endTime,
                startTime
            });
            const { contacts } = res;
            logger.info(`[ContactHistoryHelper:fetchHistoryByANI : AqmAPI]=> Total contact history record found for ${days} days [${(_a = contacts === null || contacts === void 0 ? void 0 : contacts.length) !== null && _a !== void 0 ? _a : 0}]`);
            /** merge currently fetched records with previously fetched records */
            if ((contacts === null || contacts === void 0 ? void 0 : contacts.length) > 0) {
                if (contacts.length >= remainingRecords) {
                    loadedContacts = loadedContacts.concat(limit(contacts, remainingRecords));
                    remainingRecords = 0;
                }
                else {
                    loadedContacts = loadedContacts.concat(contacts);
                    remainingRecords -= contacts.length;
                }
            }
            /** If number of records reaches the limit, then stop fetching data from server */
            if (remainingRecords === 0) {
                break;
            }
        }
        logger.info(`[ContactHistoryHelper:fetchHistoryByANI : AqmAPI]=> Total contact history record found [${loadedContacts.length}]`);
        return loadedContacts;
    });
}
function fetchHistoryByANITahoe(ani, agentId, interactionId) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const endTime = new Date().getTime();
        const startTime = getStartTime(endTime, 60);
        const res = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.tahoe.fetchInteractionHistory({
            ani,
            endTime,
            startTime,
            agentId,
            interactionId
        });
        const { contacts } = res;
        logger.info(`[ContactHistoryHelper:fetchHistoryByANI : TahoeAPI]=> Total contact history record found for 60 days [${(_a = contacts === null || contacts === void 0 ? void 0 : contacts.length) !== null && _a !== void 0 ? _a : 0}]`);
        return contacts;
    });
}
/**
 * Load contact history data by ANI
 */
function fetchHistoryByANI(ani, tahoeEnabled, agentId, interactionId) {
    return __awaiter(this, void 0, void 0, function* () {
        if (ani === ANONYMOUS) {
            return [];
        }
        if (tahoeEnabled) {
            return fetchHistoryByANITahoe(ani, agentId, interactionId);
        }
        return fetchHistoryByANIAqm(ani);
    });
}
/**
 * Load contact history data by ANI
 */
function fetchHistoryByAgent(agentId, tahoeEnabled, isMaskSensitiveDataEnabled) {
    return __awaiter(this, void 0, void 0, function* () {
        const endTime = luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.local().toMillis();
        const startTime = getStartTime(endTime, TWENTY_FOUR_HOURS);
        let resp;
        if (tahoeEnabled) {
            resp = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.tahoe.fetchAgentHistory({
                agentId
            });
        }
        else {
            resp = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.fetchHistoryByAgent({
                endTime,
                startTime
            });
        }
        let contacts;
        if (!isMaskSensitiveDataEnabled) {
            contacts = resp.contacts.map((entry) => {
                return Object.assign(Object.assign({}, entry), { displayAni: entry.ani });
            });
        }
        else {
            contacts = resp.contacts.map((entry) => {
                return Object.assign(Object.assign({}, entry), { displayAni: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.maskSensitiveData)(entry.ani), entrypointName: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.maskSensitiveData)(entry.entrypointName), customerName: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.maskSensitiveData)(entry.customerName), dnis: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.maskSensitiveData)(entry.dnis) });
            });
        }
        logger.info(`[ContactHistoryHelper:fetchHistoryByAgent: ${tahoeEnabled ? "TahoeAPI" : "AqmAPI"}]=> Total contact history by agent found [${contacts ? contacts.length : 0}]`);
        return contacts || [];
    });
}
/**
 * Group by contact history by date
 * @param contacts
 */
const groupContactsByStartDate = (contacts) => {
    return lodash__WEBPACK_IMPORTED_MODULE_1___default().chain(lodash__WEBPACK_IMPORTED_MODULE_1___default().map(contacts, (contact) => lodash__WEBPACK_IMPORTED_MODULE_1___default().extend({
        contactStartDate: luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.fromMillis(Number(contact.cstts)).toFormat(DATE_FORMAT)
    }, contact)))
        .groupBy("contactStartDate")
        .map((value, key) => ({
        contactStartDate: key,
        contacts: value
    })) // sort record on descending order. i.e. latest on top
        .value();
};
/**
   * Call to fetch transcript inbound and outbound from Contact having field as
   * transcript:
        'INTERACTION:inboundTranscript__s:b4652927-5ec8-11ea-8819-a3467503704c',
      outboundTranscript:
        'INTERACTION:outboundTranscript__s:b4652927-5ec8-11ea-8819-a3467503704c',
   */
const fetchTranscript = (transcriptTypeWithId) => {
    logger.info(`[ContactHistoryHelper:fetchTranscriptsForContact]=> transcripts request : ${transcriptTypeWithId}`);
    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.fetchTranscript({
        transcriptId: transcriptTypeWithId
    });
};
const convertToTime = (cstts) => {
    return luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.fromMillis(Number(cstts)).toFormat(MERIDIEM_TIME_FORMAT);
};
const getContactsSorted = (contacts) => {
    return contacts.sort((a, b) => {
        if (a.cstts > b.cstts) {
            return -1;
        }
        if (a.cstts < b.cstts) {
            return 1;
        }
        return 0;
    });
};
const isOutdialTypeProgressive = (outdialType) => {
    return (outdialType === PROGRESSIVE ||
        outdialType === PROGRESSIVE_CAMPAIGN ||
        outdialType === PREDICTIVE ||
        outdialType === PREVIEW_CAMPAIGN);
};
const getTimerLabel = (timer) => {
    const timeUnits = ["hour", "minute", "second"];
    let formattedTimer = timer;
    if (formattedTimer.length === 5) {
        formattedTimer = `00:${formattedTimer}`;
    }
    const parts = formattedTimer
        .split(":")
        .map(Number)
        .map((value, i) => (value > 0 ? `${value} ${timeUnits[i]}${value !== 1 ? "s" : ""}` : ""))
        .filter(Boolean);
    return `${parts.join(", ")}`;
};
const getIconName = (channelType, isCallback = false, subChannelType = "", outdialType = "") => {
    if (channelType !== _HandledByAgent_types__WEBPACK_IMPORTED_MODULE_5__.ChannelTypes.social) {
        if (channelType === _HandledByAgent_types__WEBPACK_IMPORTED_MODULE_5__.ChannelTypes.telephony) {
            if (isOutdialTypeProgressive(outdialType)) {
                return "icon-campaign";
            }
            return isCallback || (outdialType && outdialType.includes("CALLBACK")) ? "icon-callback" : "handset";
        }
        return channelType;
    }
    if (subChannelType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.FACEBOOK) {
        return "messenger";
    }
    if ((subChannelType === null || subChannelType === void 0 ? void 0 : subChannelType.toLowerCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.WHATSAPP) {
        return "whatsApp";
    }
    if (!subChannelType) {
        return "share-c-native-adr";
    }
    return subChannelType;
};


/***/ }),

/***/ "./src/direflow-components/ContactHistory/HandledByAgent/components/HistoryList.tsx":
/*!******************************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/HandledByAgent/components/HistoryList.tsx ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_components_List__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Common/components/List */ "./src/direflow-components/Common/components/List/index.tsx");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../types */ "./src/direflow-components/ContactHistory/HandledByAgent/types.ts");
/* harmony import */ var _HistoryListItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./HistoryListItem */ "./src/direflow-components/ContactHistory/HandledByAgent/components/HistoryListItem.tsx");






/** Get Icon name based on chanelType and subChannelType */
/** derive the contact history header label */
const HistoryList = ({ contacts, channelType, allowOutdial, isActiveCall, updateOutdailRequest, listContainerHeight, webRtcStatus, isWebRTCEnabled, deviceType, isDarkMode }) => {
    const { contactHistory } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.useI18nContext)();
    const contactsByChannel = channelType === _types__WEBPACK_IMPORTED_MODULE_4__.ChannelTypes.All ? contacts : contacts.filter((c) => c.channelType === channelType);
    /* AIH list with virtual scrol */
    const ListToRender = ({ _data, index, style, _isSelected, isFocused, _onSelectValue, resetFocusedItemIndex }) => {
        const contact = contactsByChannel[index];
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HistoryListItem__WEBPACK_IMPORTED_MODULE_5__["default"], { isFocused: isFocused, contact: contact, index: index, allowOutdial: allowOutdial, isActiveCall: isActiveCall, updateOutdailRequest: updateOutdailRequest, webRtcStatus: webRtcStatus, isWebRTCEnabled: isWebRTCEnabled, deviceType: deviceType, isDarkMode: isDarkMode, style: style, resetFocusedItemIndex: resetFocusedItemIndex }));
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: contactsByChannel.length === 0 ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "no-history" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_2__["default"], { illustrationType: "empty-state" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ tabIndex: 0, "aria-label": contactHistory.noHistory }, { children: contactHistory.noHistoryNew }))] }) }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "agent-history-main agent-history-main-no-scroll" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_3__["default"], Object.assign({ data: contactsByChannel, height: listContainerHeight ? listContainerHeight - 45 : 400, onSelectValue: () => { }, hasChildElements: true, customClassName: "aih-list-container", itemHeight: 70, ariaLabel: contactHistory.listContainer, innerElementType: "ul", infiniteScrollEnabled: false }, { children: (props) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListToRender, Object.assign({}, props)) })) }))) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HistoryList);


/***/ }),

/***/ "./src/direflow-components/ContactHistory/HandledByAgent/components/HistoryListItem.tsx":
/*!**********************************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/HandledByAgent/components/HistoryListItem.tsx ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-mfe-wc-based */ "@agentx/agentx-mfe-wc-based");
/* harmony import */ var _agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../InteractionPopoverManager/Utils/InteractionPopoversUtils */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts");
/* harmony import */ var _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../ContactHistoryHelper */ "./src/direflow-components/ContactHistory/ContactHistoryHelper.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../types */ "./src/direflow-components/ContactHistory/HandledByAgent/types.ts");














const OUTBOUND = "outbound";
const OUTDIAL = "outdial";
const getCustomerName = (contact) => {
    if (contact.callDirection === OUTDIAL || contact.callDirection === OUTBOUND) {
        return contact.dnis;
    }
    if (contact.customerName && contact.customerName !== "N/A") {
        return contact.customerName;
    }
    return contact.displayAni;
};
const getHistoryHeaderLabel = (contact) => {
    switch (contact.channelType) {
        case _types__WEBPACK_IMPORTED_MODULE_12__.ChannelTypes.telephony:
        case _types__WEBPACK_IMPORTED_MODULE_12__.ChannelTypes.email:
            return contact.callDirection === OUTDIAL || contact.callDirection === OUTBOUND
                ? contact.dnis
                : contact.displayAni;
        case _types__WEBPACK_IMPORTED_MODULE_12__.ChannelTypes.chat:
        case _types__WEBPACK_IMPORTED_MODULE_12__.ChannelTypes.social:
            return getCustomerName(contact);
        default:
            return "";
    }
};
const HistoryListItem = ({ contact, index, allowOutdial, isActiveCall, updateOutdailRequest, webRtcStatus, isWebRTCEnabled, deviceType, isDarkMode, style = {}, isFocused, resetFocusedItemIndex }) => {
    var _a, _b, _c, _d;
    const { contactHistory, common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_7__.useI18nContext)();
    const agentHistoryItemButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const dispatchEvent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_4__.EventContext);
    const limitWrapUpReasonLength = 14;
    const agentHistoryItemList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const headerLabelRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const [isHeaderLabelTruncated, setIsHeaderLabelTruncated] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const handleOutdialMenuClose = (e) => {
            const itemIndex = e.detail.value;
            if (agentHistoryItemButtonRef.current && itemIndex === index) {
                agentHistoryItemButtonRef.current.shadowRoot.querySelector("button").focus();
            }
        };
        document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_6__.OUTDIAL_MENU_CLOSE, handleOutdialMenuClose);
        return () => {
            document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_6__.OUTDIAL_MENU_CLOSE, handleOutdialMenuClose);
        };
    }, []);
    const iconName = (0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_11__.getIconName)(contact.channelType, contact.isCallback, contact.subChannelType, contact.outdialType);
    const iconSize = contact.isCallback || (0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_11__.isOutdialTypeProgressive)(contact.outdialType) ? "18" : "16";
    const headerLabel = getHistoryHeaderLabel(contact);
    const formattedDuration = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_9__.formatDuration)(luxon__WEBPACK_IMPORTED_MODULE_5__.Duration.fromMillis(contact.talkDuration));
    const interactionStartTime = (0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_11__.convertToTime)(contact.cstts);
    const isAllowOutdialForCall = allowOutdial && contact.channelType === _Common_constants__WEBPACK_IMPORTED_MODULE_8__.MEDIA_TYPES.VOICE;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const element = headerLabelRef.current;
        if (element) {
            setIsHeaderLabelTruncated(element.scrollWidth > element.clientWidth);
        }
    }, [headerLabel, headerLabelRef]);
    const ariaLabelForContent = `${contact.callDirection === OUTDIAL || contact.callDirection === OUTBOUND
        ? contactHistory.initiatedTo
        : contactHistory.receivedFrom}, ${(0,_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_2__.makeAlphaNumericReadable)(headerLabel)}, ${contactHistory.wrapUpReason} ${(_a = contact.wrapUpCode) !== null && _a !== void 0 ? _a : "N/A"}, ${common.historyItemTime} ${interactionStartTime}`;
    const ariaLabelForTelephony = `${contactHistory.startCallTelephony}`;
    const getMediaTypeIcon = () => {
        const { MEDIA_SUBCHANNEL_TYPES } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants;
        const derivedMediaChannel = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_9__.getDerivedMediaChannelForDirection)(contact.subChannelType, contact.callDirection);
        if ((contact.channelType === _Common_constants__WEBPACK_IMPORTED_MODULE_8__.MEDIA_TYPES.SOCIAL || (0,_InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_10__.isMediaTypeDigitalOutbound)(derivedMediaChannel !== null && derivedMediaChannel !== void 0 ? derivedMediaChannel : "")) &&
            derivedMediaChannel &&
            MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]) {
            const imgSrc = isDarkMode
                ? MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel].aih.dark
                : MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel].aih.light;
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", { alt: imgSrc, src: imgSrc });
        }
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("md-icon", { "aria-hidden": "true", name: `icon-${iconName}_${iconSize}`, size: `${iconSize}`, iconSet: "preferMomentumDesign" }));
    };
    const dispatchOutDialConfirmModal = () => {
        const event = new CustomEvent("ax-active-call-error", {
            detail: {
                message: contactHistory.onAnActiveCallErrorMessage,
                htmlHeadingElement: true
            },
            bubbles: true,
            composed: true
        });
        if (dispatchEvent) {
            dispatchEvent(event);
        }
    };
    const dispatchOutDialEvent = (eventName, outDailNumber, index = -1) => {
        const outDailEvent = new CustomEvent(eventName, {
            detail: {
                value: { outDailNumber, index }
            },
            bubbles: true,
            composed: true
        });
        if (dispatchEvent) {
            dispatchEvent(outDailEvent);
        }
    };
    const initiateOutdailEdit = (outDailNumber, isActiveCall, index) => {
        if (isActiveCall) {
            dispatchOutDialConfirmModal();
        }
        else {
            dispatchOutDialEvent("ax-outdail-edit", outDailNumber, index);
        }
    };
    const initiateOutdailCall = (outDailNumber, isActiveCall) => {
        if (isActiveCall) {
            dispatchOutDialConfirmModal();
        }
        else {
            dispatchOutDialEvent("ax-outdail-call", outDailNumber);
            updateOutdailRequest(true);
        }
    };
    const getDisabled = () => {
        if (isWebRTCEnabled &&
            deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER &&
            (webRtcStatus === _constants__WEBPACK_IMPORTED_MODULE_6__.WEB_RTC_STATUS.WEB_RTC_REGISTERING || webRtcStatus === _constants__WEBPACK_IMPORTED_MODULE_6__.WEB_RTC_STATUS.WEB_RTC_DISCONNECTED)) {
            return true;
        }
        return false;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (agentHistoryItemList.current && isFocused) {
            agentHistoryItemList.current.focus();
        }
    }, [isFocused]);
    return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("li", Object.assign({ ref: agentHistoryItemList, className: `item item-${index} ${isFocused ? "focused-item" : ""}`, "aria-label": ariaLabelForContent, style: style }, (isFocused ? { tabIndex: 0 } : { tabIndex: -1 }), { onKeyDown: (event) => {
            if (event.key === "Tab" && !isAllowOutdialForCall) {
                resetFocusedItemIndex();
            }
        }, onClick: () => {
            resetFocusedItemIndex(index);
        }, key: `item-${contact.channelType}-${index}` }),
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("md-badge", Object.assign({ class: "contact-badge", circle: true }, { children: getMediaTypeIcon() })),
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", Object.assign({ className: "details" }, { children: [isAllowOutdialForCall ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("md-tooltip", Object.assign({ placement: "top", message: contactHistory.clickToCall }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("md-link", Object.assign({ type: "button", role: "button", class: `contact-link ${getDisabled() ? "disable-element" : ""}` }, (getDisabled() ? { disabled: true } : ""), (isFocused ? {} : { tabIndex: -1 }), { "aria-label": ariaLabelForTelephony, onClick: (e) => {
                            e.preventDefault();
                            initiateOutdailCall(headerLabel, isActiveCall);
                        } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("u", { children: headerLabel }) })) }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("md-tooltip", Object.assign({ placement: "top", message: headerLabel }, (!isHeaderLabelTruncated ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", Object.assign({ ref: headerLabelRef }, { children: headerLabel })) }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("md-tooltip", Object.assign({ placement: "top", message: (_b = contact.wrapUpCode) !== null && _b !== void 0 ? _b : "N/A" }, (((_c = contact.wrapUpCode) === null || _c === void 0 ? void 0 : _c.length) < limitWrapUpReasonLength || !contact.wrapUpCode ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", Object.assign({ className: "wrapup-reason-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "wrapup-reason" }, { children: (_d = contact.wrapUpCode) !== null && _d !== void 0 ? _d : "N/A" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "wrapup-separater" }, { children: "|" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("md-icon", { class: "recent-icon", "aria-hidden": "true", name: "recents-bold", iconSet: "momentumDesign", size: "12" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("time", Object.assign({ "aria-label": `${common.timerAriaLabel}, ${(0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_11__.getTimerLabel)(formattedDuration)}`, dateTime: formattedDuration }, { children: formattedDuration }))] })) }))] })),
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", Object.assign({ className: `${isAllowOutdialForCall ? "time-data" : "time-data with-margin"}` }, { children: [isAllowOutdialForCall && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("md-tooltip", Object.assign({ placement: "top", message: contactHistory.editBeforeCall }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("md-button", Object.assign({ onKeyDown: (event) => {
                            if (event.key === "Tab" && !event.shiftKey) {
                                resetFocusedItemIndex();
                            }
                        }, ref: agentHistoryItemButtonRef, class: getDisabled() ? "disable-element edit-button" : "edit-button" }, (isFocused ? {} : { tabIndex: -1 }), { ariaLabel: `${contactHistory.editBeforeCall} ${(0,_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_2__.makeAlphaNumericReadable)(headerLabel)}`, hasRemoveStyle: true }, (getDisabled() ? { disabled: true } : ""), { onClick: (e) => {
                            e.preventDefault();
                            initiateOutdailEdit(headerLabel, isActiveCall, index);
                        } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("md-icon", { "aria-hidden": "true", name: "edit-bold", class: "edit-icon", iconSet: "momentumDesign", size: "14" }) })) }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("time", Object.assign({ "aria-hidden": "true", dateTime: interactionStartTime }, { children: interactionStartTime }))] }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HistoryListItem);


/***/ }),

/***/ "./src/direflow-components/ContactHistory/HandledByAgent/components/index.tsx":
/*!************************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/HandledByAgent/components/index.tsx ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _css_common_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../css/common.css */ "./src/css/common.css");
/* harmony import */ var _css_common_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_css_common_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_InlineError__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Common/components/InlineError */ "./src/direflow-components/Common/components/InlineError.tsx");
/* harmony import */ var _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../ContactHistoryHelper */ "./src/direflow-components/ContactHistory/ContactHistoryHelper.ts");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../styles.scss */ "./src/direflow-components/ContactHistory/HandledByAgent/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../types */ "./src/direflow-components/ContactHistory/HandledByAgent/types.ts");
/* harmony import */ var _HistoryList__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./HistoryList */ "./src/direflow-components/ContactHistory/HandledByAgent/components/HistoryList.tsx");

/* eslint-disable no-nested-ternary */
/* eslint-disable radix */












const ContactHistoryHandledByAgent = ({ lastcompletedtask, chatcount, emailcount, voicecount, socialcount, agentId, tahoeEnabled, allowOutdial, isActiveCall, webRtcStatus, isWebRTCEnabled, isMaskSensitiveDataEnabled, deviceType, isDarkMode, orgId }) => {
    /**
     * @fires ax-outdail-edit
     * @fires ax-outdail-call
     * @fires ax-active-call-error
     */
    const localizedMessages = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_7__.getLocalizedMessages)().common;
    const [contacts, setContacts] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const [loadingError, setLoadingError] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(undefined);
    const [isError, setIsError] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [loadingTrackingId, setLoadingTrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(undefined);
    const channelDetails = new _types__WEBPACK_IMPORTED_MODULE_11__.ChannelDetails(voicecount, chatcount, emailcount, socialcount);
    const dragableElement = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const loadHistoryTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const resizer = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const defaultAgentHistoryHeight = "40vh";
    const agentHistoryStorageKey = "agent-history-height";
    const [agentHistoryHeight, setAgentHistoryHeight] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(defaultAgentHistoryHeight);
    const [resizeClass, setResizeClass] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [isHistoryLoading, setIsHistoryLoading] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [isAllowOutdial, setIsAllowOutdial] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(allowOutdial);
    const [isActiveCallExist, setIsActiveCallExist] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(isActiveCall);
    const [outdialRequested, setOutdialRequested] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [listContainerHeight, setListContainerHeight] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null);
    const [percentageHeightOfPanel, setPercentageHeight] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0);
    let isResizePressed;
    let retryCount = 0;
    const maxRetryCount = tahoeEnabled ? 3 : 5;
    const getLocalisedType = (type) => {
        return localizedMessages.historyChannelLabels[type];
    };
    const fetchAgentHistory = (delay = 1000) => {
        if (loadHistoryTimeoutIdRef.current) {
            window.clearTimeout(loadHistoryTimeoutIdRef.current);
        }
        setIsHistoryLoading(true);
        loadHistoryTimeoutIdRef.current = window.setTimeout(() => {
            loadHistoryByAgent();
        }, delay); // Timeout since elastic search on analyzer side takes 1 sec to update. refer CX-4449, CX-6476
    };
    const loadHistoryByAgent = () => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_HISTORY);
        const promise = (0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_9__.fetchHistoryByAgent)(agentId, tahoeEnabled, isMaskSensitiveDataEnabled);
        promise
            .then((data) => {
            var _a;
            if (tahoeEnabled) {
                const firstInteraction = data[0];
                if (firstInteraction &&
                    ((firstInteraction === null || firstInteraction === void 0 ? void 0 : firstInteraction.wrapUpCode) === "N/A" ||
                        firstInteraction.wrapUpCode === undefined ||
                        !firstInteraction.wrapUpCode ||
                        firstInteraction.wrapUpCode === "")) {
                    // retry to fetch history if wrapUpCode is not available upto 2 attempts, with interval of 2 seconds
                    if (retryCount < maxRetryCount) {
                        _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_9__.logger.info(`loadHistoryByAgent : Retrying to fetch agent history as wrapUpCode is not available, attempt : ${retryCount}`);
                        fetchAgentHistory(2000);
                        retryCount += 1;
                    }
                    else {
                        retryCount = 0;
                    }
                }
            }
            else {
                const firstInteraction = [...data].reverse();
                if (((_a = firstInteraction[0]) === null || _a === void 0 ? void 0 : _a.wrapUpCode) === "N/A" && retryCount < maxRetryCount) {
                    fetchAgentHistory();
                    retryCount += 1;
                }
                else {
                    retryCount = 0;
                }
            }
            setIsHistoryLoading(false);
            setLoadingError(undefined);
            setIsError(false);
            setListContainerHeight(parseInt(getComputedStyle(dragableElement === null || dragableElement === void 0 ? void 0 : dragableElement.current, "").height));
            setContacts(data);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_HISTORY, {
                InteractionsHandled: data === null || data === void 0 ? void 0 : data.length,
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
            });
        })
            .catch((error) => {
            setLoadingError(error.message);
            setIsError(true);
            setLoadingTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error));
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_HISTORY, {
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                Reason: error.message
            });
            _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_9__.logger.error(`event=loadHistoryByAgentError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error)}] [ContactHistory:loadContactHistory] Error while loading contact history by agent: ${error}`, error);
            setIsHistoryLoading(false);
            setContacts([]);
        });
        // }
    };
    /** fetch contact history on when interaction type is AgentWrappedUp  */
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if (lastcompletedtask && typeof lastcompletedtask === "string") {
            _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_9__.logger.info("fetchAgentHistory after 2s when call has been wrapped up");
            fetchAgentHistory(2000);
        }
        else {
            fetchAgentHistory();
        }
    }, [lastcompletedtask]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        return () => {
            window.clearTimeout(loadHistoryTimeoutIdRef.current);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        setIsAllowOutdial(allowOutdial);
    }, [allowOutdial]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        setIsActiveCallExist(isActiveCall);
        setOutdialRequested(false);
    }, [isActiveCall]);
    const saveAgentHistoryHeight = (value) => {
        sessionStorage.setItem(agentHistoryStorageKey, value);
        setListContainerHeight(parseInt(value, 10));
    };
    const retriveAgentHistoryHeight = () => {
        const height = sessionStorage.getItem(agentHistoryStorageKey) || defaultAgentHistoryHeight;
        setAgentHistoryHeight(height);
    };
    /**
     * This function handles the resizing of the panel when the ArrowUp or ArrowDown keys are pressed.
     * @param {KeyboardEvent} event - The keyboard event
     */
    const handleResizeKeyPress = (event) => {
        const panel = dragableElement === null || dragableElement === void 0 ? void 0 : dragableElement.current;
        const currentHeight = parseInt(getComputedStyle(panel, "").height);
        const increment = window.innerHeight * 0.1; // Change the size by 10%
        const maxHeight = window.innerHeight;
        const minHeight = 50;
        let newHeight;
        switch (event.key) {
            case "ArrowUp":
                newHeight = Math.min(currentHeight + increment, maxHeight);
                break;
            case "ArrowDown":
                newHeight = Math.max(currentHeight - increment, minHeight);
                break;
            default:
                return;
        }
        // Update the height of the panel and the percentageHeight state variable
        panel.style.height = `${newHeight}px`;
        saveAgentHistoryHeight(`${newHeight}px`);
        const percentageHeight = Math.round((newHeight / maxHeight) * 100);
        setPercentageHeight(percentageHeight);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        let mousePosition;
        retriveAgentHistoryHeight();
        const panel = dragableElement === null || dragableElement === void 0 ? void 0 : dragableElement.current;
        const resizerEle = resizer === null || resizer === void 0 ? void 0 : resizer.current;
        const setPanelHeight = (dx) => {
            const currentPanelHeight = parseInt(getComputedStyle(panel, "").height);
            const newHeight = `${currentPanelHeight + dx}px`;
            panel.style.height = newHeight;
            saveAgentHistoryHeight(newHeight);
        };
        const resize = (e) => {
            const dx = mousePosition - e.y;
            mousePosition = e.y;
            setPanelHeight(dx);
        };
        const touchResizeEvent = (e) => {
            const y = parseInt(e.touches[0].clientY);
            const dx = mousePosition - y;
            mousePosition = y;
            setPanelHeight(dx);
        };
        const mouseOnPressEvent = (e) => {
            mousePosition = e.y;
            document.addEventListener("mousemove", resize, false);
            setResizeClass("active");
            isResizePressed = true;
            panel.style.userSelect = "none";
        };
        const screenTouchEvent = (e) => {
            mousePosition = parseInt(e.touches[0].clientY);
            document.addEventListener("touchmove", touchResizeEvent);
            setResizeClass("active");
            isResizePressed = true;
            panel.style.userSelect = "none";
        };
        const mouseOnReleaseEvent = () => {
            document.removeEventListener("mousemove", resize, false);
            if (isResizePressed) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_HISTORY_RESIZE, {
                    [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.AGENT_HISTORY_RESIZE_HEIGHT]: sessionStorage.getItem(agentHistoryStorageKey) || defaultAgentHistoryHeight
                });
            }
            setResizeClass("");
            isResizePressed = false;
            panel.style.userSelect = "auto";
        };
        const screenTouchEndEvent = () => {
            document.removeEventListener("touchmove", touchResizeEvent);
            setResizeClass("");
            isResizePressed = false;
            panel.style.userSelect = "auto";
        };
        const handleOutDialFail = () => {
            setOutdialRequested(false);
        };
        if (resizerEle) {
            resizerEle.addEventListener("mousedown", mouseOnPressEvent);
            document.addEventListener("mouseup", mouseOnReleaseEvent);
            resizerEle.addEventListener("touchstart", screenTouchEvent);
            document.addEventListener("touchend", screenTouchEndEvent);
            document.addEventListener("outdail-call-failed", handleOutDialFail);
        }
        return () => {
            if (resizerEle) {
                resizerEle.removeEventListener("mousedown", mouseOnPressEvent);
                document.removeEventListener("mouseup", mouseOnReleaseEvent);
                resizerEle.removeEventListener("touchstart", screenTouchEvent);
                document.removeEventListener("touchend", screenTouchEndEvent);
                document.removeEventListener("outdail-call-failed", handleOutDialFail);
            }
        };
    }, []);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_7__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.Styled, Object.assign({ styles: [(_styles_scss__WEBPACK_IMPORTED_MODULE_10___default()), (_css_common_css__WEBPACK_IMPORTED_MODULE_6___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ ref: dragableElement }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isVisualRebrandEnabled
                ? { className: "agent-history new-momentum" }
                : { className: "agent-history" }), { style: { height: agentHistoryHeight }, id: "agent-history", role: "region", "aria-label": localizedMessages.agentHistoryLabel }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "hidden-overflow" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ ref: resizer, "data-testid": "agent-history-resizer", className: "history-resizer-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-grabber", { "disable-click-toggle": true, dragger: true, alignment: "bottom", className: "history-dragger", role: "slider", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": parseInt(agentHistoryHeight), "aria-label": localizedMessages.resizeHistoryDragger, "aria-valuetext": `${localizedMessages.resizeHistoryPanel}, ${percentageHeightOfPanel}%`, "aria-describedby": "resizerInstructions", onKeyDown: handleResizeKeyPress }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: `agent-history-resizer ${resizeClass}` })] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ id: "resizerInstructions", className: "sr-only" }, { children: localizedMessages.sliderResizerInstructions })), " ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-tabs", Object.assign({ "aria-label": localizedMessages.ariaLabelAgentHistoryWrapper, role: "tablist", justified: true, overflowLabel: localizedMessages.more }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isVisualRebrandEnabled
                            ? { newMomentum: true, variant: "primary", type: "rounded", "hug-tabs": true }
                            : {}), { children: [channelDetails.getChannels().map(({ type, count }) => {
                                    const tabIcon = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: `icon-${(0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_9__.getIconName)(type)}_14`, size: "16", iconSet: "preferMomentumDesign" }));
                                    return (count > 0 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab", Object.assign({ label: getLocalisedType(type), "aria-label": getLocalisedType(type), slot: "tab" }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isVisualRebrandEnabled
                                        ? { newMomentum: true, variant: "primary", type: "rounded" }
                                        : {}), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "top", message: getLocalisedType(type) }, { children: type === _types__WEBPACK_IMPORTED_MODULE_11__.ChannelTypes.All ? getLocalisedType(type) : tabIcon })) }), `tab_${type}`)));
                                }), channelDetails.getChannels().map(({ type, count }) => count > 0 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab-panel", Object.assign({ "focusable-panel": "false", slot: "panel" }, { children: isHistoryLoading ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "history-loader" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "60" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "loading-text" }, { children: localizedMessages.loadingMsg }))] }))) : isError ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "loading-error" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_InlineError__WEBPACK_IMPORTED_MODULE_8__["default"], { errorHeaderMsg: localizedMessages.errorMsg, errorSubMsg: loadingError, trackingId: loadingTrackingId, retry: loadHistoryByAgent }) }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HistoryList__WEBPACK_IMPORTED_MODULE_12__["default"], { contacts: (0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_9__.getContactsSorted)(contacts), channelType: type, allowOutdial: isAllowOutdial, isActiveCall: isActiveCallExist, updateOutdailRequest: setOutdialRequested, listContainerHeight: listContainerHeight, webRtcStatus: webRtcStatus, isWebRTCEnabled: isWebRTCEnabled, deviceType: deviceType, isDarkMode: isDarkMode })) }), `panel_${type}`)))] })), outdialRequested && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "spinner-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: 80 }) })))] })) })) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_4__.observer)(ContactHistoryHandledByAgent));


/***/ }),

/***/ "./src/direflow-components/ContactHistory/HandledByAgent/styles.scss":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/HandledByAgent/styles.scss ***!
  \***************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./styles.scss */ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/direflow-components/ContactHistory/HandledByAgent/styles.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/ContactHistory/HandledByAgent/types.ts":
/*!************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/HandledByAgent/types.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChannelDetails: () => (/* binding */ ChannelDetails),
/* harmony export */   ChannelTypes: () => (/* binding */ ChannelTypes),
/* harmony export */   SubChannelTypes: () => (/* binding */ SubChannelTypes)
/* harmony export */ });
var ChannelTypes;
(function (ChannelTypes) {
    ChannelTypes["All"] = "All";
    ChannelTypes["telephony"] = "telephony";
    ChannelTypes["chat"] = "chat";
    ChannelTypes["email"] = "email";
    ChannelTypes["social"] = "social";
})(ChannelTypes || (ChannelTypes = {}));
var SubChannelTypes;
(function (SubChannelTypes) {
    SubChannelTypes["sms"] = "sms";
    SubChannelTypes["facebook"] = "facebook";
    SubChannelTypes["whatsapp"] = "whatsapp";
    SubChannelTypes["appleBusinessChat"] = "appleMessages";
})(SubChannelTypes || (SubChannelTypes = {}));
class ChannelDetails {
    constructor(voiceCount, chatCount, emailCount, socialCount) {
        this.channels = [
            {
                type: ChannelTypes.All,
                count: voiceCount + chatCount + emailCount + socialCount
            },
            { type: ChannelTypes.telephony, count: voiceCount },
            { type: ChannelTypes.chat, count: chatCount },
            { type: ChannelTypes.social, count: socialCount },
            { type: ChannelTypes.email, count: emailCount }
        ];
    }
    getChannels() {
        return this.channels;
    }
}


/***/ }),

/***/ "./src/direflow-components/ContactHistory/components/InlineLoadingError.tsx":
/*!**********************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/components/InlineLoadingError.tsx ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");


const errorIconColor = "#D93829";
/**
 * Inline Loading error componenet.
 * @param props
 */
const InlineLoadingError = ({ errorMessageHeader, errorMessage, retry }) => {
    const { contactHistory: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.useI18nContext)();
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "inline-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-error-legacy_28", color: errorIconColor }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", { children: errorMessageHeader }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dd", { children: [i18n.errorID, ": ", errorMessage, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ariaLabel: i18n.tryAgain, variant: "primary", onClick: retry, size: "28" }, { children: i18n.tryAgain }))] })] })] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InlineLoadingError);


/***/ }),

/***/ "./src/direflow-components/ContactHistory/components/Timeline/TimelineItem.tsx":
/*!*************************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/components/Timeline/TimelineItem.tsx ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../ContactHistoryHelper */ "./src/direflow-components/ContactHistory/ContactHistoryHelper.ts");








const ENTER_KEY_CODE = 13;
/**
 * Functional component to display contact history detail
 * @param concat
 */
const TimelineItem = ({ contact, onTimeLineClick, disableTranscripts, isDarkMode, timeLineDate }) => {
    var _a, _b;
    const { contactHistory: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.useI18nContext)();
    let badgeBgColor = null;
    let iconName = "";
    let imgSrc = "";
    let iconColor = null;
    let badgeColor = null;
    const setIconDetails = (contact) => {
        const derivedMediaChannel = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.getDerivedMediaChannelForDirection)(contact.subChannelType, contact.callDirection);
        switch (derivedMediaChannel) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.SMS:
                iconName = "sms_16";
                badgeColor = "darkmint";
                iconColor = "#ffffff";
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.FACEBOOK:
                iconName = `messenger_16`;
                iconColor = "#ffffff";
                badgeBgColor = "#0078FF";
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.WHATSAPP:
                iconName = `whatsApp_16`;
                iconColor = "#ffffff";
                badgeBgColor = "#25D366";
                break;
        }
        if (derivedMediaChannel && _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]) {
            imgSrc = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.getImageCH)(contact.channelType, derivedMediaChannel, isDarkMode);
        }
    };
    const getMediaTypeBadge = () => {
        var _a;
        switch (contact.channelType) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.CHAT:
                iconName = "chat-active_16";
                badgeColor = "blue";
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.EMAIL:
                if ((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.isOutboundContact)(contact.callDirection)) {
                    setIconDetails(contact);
                }
                else {
                    iconName = "email-active_16";
                    badgeColor = "violet";
                }
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.VOICE:
                if (contact.isCallback || ((_a = contact === null || contact === void 0 ? void 0 : contact.outdialType) === null || _a === void 0 ? void 0 : _a.includes("CALLBACK"))) {
                    iconName = "icon-icon-callback_18";
                    badgeColor = "lime";
                }
                else if ((0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_7__.isOutdialTypeProgressive)(contact.outdialType)) {
                    iconName = "icon-icon-campaign_18";
                    badgeColor = "green";
                }
                else {
                    iconName = "handset-active_16";
                    badgeColor = "green";
                }
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.SOCIAL:
                setIconDetails(contact);
                break;
            default:
                break;
        }
    };
    getMediaTypeBadge();
    const handleKeyPress = (event) => {
        if (event.charCode === ENTER_KEY_CODE) {
            onTimeLineClick(contact);
        }
    };
    const transcriptAvaiable = contact.channelType === _Common_constants__WEBPACK_IMPORTED_MODULE_6__.MEDIA_TYPES.EMAIL && !disableTranscripts;
    const getIcon = () => {
        if (imgSrc) {
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { alt: imgSrc, src: imgSrc });
        }
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: iconName, color: iconColor, size: "16", iconSet: "preferMomentumDesign" });
    };
    // aria-label for with transcript and without transcript
    const timelineItemAriaLabel = `${i18n.contactHistoryList} ${i18n.wrapUpCode} ${contact.wrapUpCode}, ${i18n.agentName} ${contact.agentName}, ${i18n.entryPointName} ${contact.entrypointName}, ${i18n.acceptedTimeAndDate} ${luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(Number(contact.cstts)).toFormat(_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_7__.MERIDIEM_TIME_FORMAT)}, ${timeLineDate}, ${i18n.duration} ${(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.formatSelectedTime)((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.formatDuration)(luxon__WEBPACK_IMPORTED_MODULE_3__.Duration.fromMillis(contact.talkDuration)))}${transcriptAvaiable ? `, ${i18n.emailTranscript}, ${i18n.clickToViewEmailTranscript}` : ""}`;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", Object.assign({ className: "timeline-item--entry" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ circle: true, "aria-hidden": "true", color: badgeColor, bgColor: badgeBgColor }, { children: getIcon() })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ id: `item-${contact.cstts}` }, (transcriptAvaiable && { role: "button", tabIndex: 0, "aria-label": timelineItemAriaLabel }), { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("timeline-item", {
                    "transcript-available": transcriptAvaiable
                }), onClick: () => {
                    if (transcriptAvaiable) {
                        onTimeLineClick(contact);
                    }
                }, onKeyPress: (event) => {
                    if (transcriptAvaiable) {
                        handleKeyPress(event);
                    }
                } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "timeline-header" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "wrapup-code flex-1" }, { children: (_a = contact.wrapUpCode) !== null && _a !== void 0 ? _a : "N/A" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", Object.assign({ dateTime: luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(Number(contact.cstts)).toFormat(_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_7__.DATE_TIME_FORMAT), className: "accepting-time " }, { children: luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(Number(contact.cstts)).toFormat(_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_7__.MERIDIEM_TIME_FORMAT) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "timeline-body" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "agent-name entrypoint-name flex-1" }, { children: [(_b = contact.agentName) !== null && _b !== void 0 ? _b : "N/A", " \u2022 ", contact.entrypointName, transcriptAvaiable && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-link", Object.assign({ tabIndex: -1, tag: "span" }, { children: i18n.viewTranscript })))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "accepting-time" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { "aria-hidden": "true", name: "recents-bold", iconSet: "momentumDesign", size: "12" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "sr-only" }, { children: `${i18n.timeIcon} ${(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.formatSelectedTime)((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.formatDuration)(luxon__WEBPACK_IMPORTED_MODULE_3__.Duration.fromMillis(contact.talkDuration)))}` })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", Object.assign({ "aria-hidden": "true", dateTime: (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.formatDuration)(luxon__WEBPACK_IMPORTED_MODULE_3__.Duration.fromMillis(contact.talkDuration)) }, { children: (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.formatDuration)(luxon__WEBPACK_IMPORTED_MODULE_3__.Duration.fromMillis(contact.talkDuration)) }))] })] }))] }))] }))] }), contact.cstts));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TimelineItem);


/***/ }),

/***/ "./src/direflow-components/ContactHistory/components/Timeline/TimelineItems.tsx":
/*!**************************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/components/Timeline/TimelineItems.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_components_InlineError__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Common/components/InlineError */ "./src/direflow-components/Common/components/InlineError.tsx");
/* harmony import */ var _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../ContactHistoryHelper */ "./src/direflow-components/ContactHistory/ContactHistoryHelper.ts");
/* harmony import */ var _TimelineItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TimelineItem */ "./src/direflow-components/ContactHistory/components/Timeline/TimelineItem.tsx");









/**
 * Time list component is stateless component. renders time list
 * @param param
 */
const Timelines = ({ contacts, isLoading, isLoaded, errorMessage, loadingTrackingId, retry, onTimeLineClick, disableTranscripts, isError, isDarkMode }) => {
    const { contactHistory: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const groupedContacts = (0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_7__.groupContactsByStartDate)((0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_7__.getContactsSorted)(contacts));
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", Object.assign({ className: "timeline-main-container" }, { children: [isLoading && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "timeline-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: 80 }) }))), isError && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_InlineError__WEBPACK_IMPORTED_MODULE_6__["default"], { errorHeaderMsg: i18n.errorMsg, errorSubMsg: errorMessage || "", trackingId: loadingTrackingId, retry: retry, top: 1 })), isLoaded &&
                /* timeline elements */
                groupedContacts.length === 0 ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ role: "region", "aria-label": i18n.noRecordFound, className: "no-record-found" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_5__["default"], { illustrationType: "empty-state" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: i18n.noRecordFound })] }))) : (groupedContacts.map((group, index) => {
                const timeLineDate = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_4__.getDateCommonFormat)(new Date(group.contactStartDate).getTime());
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", Object.assign({ className: "timeline" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ outlined: true, bgColor: "var(--md-primary-bg-color)", color: "var(--md-secondary-text-color)" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", Object.assign({ dateTime: luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.fromMillis(Number(contacts[index].cstts)).toString() }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", { children: (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_4__.getDateForBrowserLang)(new Date(group.contactStartDate).getTime()) }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", Object.assign({ className: "timeline-sublist" }, { children: lodash__WEBPACK_IMPORTED_MODULE_1___default().orderBy(group.contacts, ["cstts"], ["desc"]).map((contact) => {
                                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TimelineItem__WEBPACK_IMPORTED_MODULE_8__["default"], { contact: contact, onTimeLineClick: onTimeLineClick, disableTranscripts: disableTranscripts, isDarkMode: isDarkMode, timeLineDate: timeLineDate }, `item-${contact.cstts}`));
                            }) }))] }), `timeline-${Date.now() + index}`));
            }))] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Timelines);


/***/ }),

/***/ "./src/direflow-components/ContactHistory/components/Transcripts/TranscriptComp.tsx":
/*!******************************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/components/Transcripts/TranscriptComp.tsx ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _TranscriptDetail__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TranscriptDetail */ "./src/direflow-components/ContactHistory/components/Transcripts/TranscriptDetail.tsx");
/* harmony import */ var _InlineLoadingError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../InlineLoadingError */ "./src/direflow-components/ContactHistory/components/InlineLoadingError.tsx");



const TranscriptComp = ({ errorMessageHeader, errorMessage, trackingId, retry, senderType, transcript, senderName, senderDate }) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [errorMessage !== "" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InlineLoadingError__WEBPACK_IMPORTED_MODULE_2__["default"], { errorMessageHeader: errorMessageHeader, errorMessage: errorMessage, trackingId: trackingId, retry: retry })), transcript !== "" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TranscriptDetail__WEBPACK_IMPORTED_MODULE_1__["default"], { senderName: senderName, senderDate: senderDate, senderType: senderType, transcript: transcript }))] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TranscriptComp);


/***/ }),

/***/ "./src/direflow-components/ContactHistory/components/Transcripts/TranscriptDetail.tsx":
/*!********************************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/components/Transcripts/TranscriptDetail.tsx ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dompurify */ "../../node_modules/dompurify/dist/purify.es.mjs");


const TranscriptDetail = ({ senderName, senderDate, senderType, transcript }) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "sender-detail", id: `transcript-detail-${senderType}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ id: `transcritp-sender-name-${senderType}` }, { children: [senderName, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ id: `transcript-sender-type-${senderType}`, className: "transcript-sender-type" }, { children: ["(", senderType, ")"] }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ id: `transcript-sender-date-${senderType}`, className: "transcript-sender-date" }, { children: senderDate }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", { id: `transcript-${senderType}`, dangerouslySetInnerHTML: {
                    __html: dompurify__WEBPACK_IMPORTED_MODULE_1__["default"].sanitize(transcript)
                } })] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TranscriptDetail);


/***/ }),

/***/ "./src/direflow-components/ContactHistory/components/Transcripts/TranscriptInfo.tsx":
/*!******************************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/components/Transcripts/TranscriptInfo.tsx ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../ContactHistoryHelper */ "./src/direflow-components/ContactHistory/ContactHistoryHelper.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");




const TranscirptInfo = ({ contact, subject }) => {
    const { contactTranscript: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.useI18nContext)();
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", Object.assign({ className: "transcript-info" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", { children: i18n.agent }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", { children: contact.agentName })] }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", { children: i18n.entryPoint }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", { children: contact.entrypointName })] }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", { children: i18n.date }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dd", { children: [(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_3__.getDateCommonFormat)(Number(contact.cstts)), " ", (0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_2__.convertToTime)(contact.cstts)] })] }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", { children: i18n.subject }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", { children: subject })] })] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TranscirptInfo);


/***/ }),

/***/ "./src/direflow-components/ContactHistory/components/Transcripts/index.tsx":
/*!*********************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/components/Transcripts/index.tsx ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_InlineError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Common/components/InlineError */ "./src/direflow-components/Common/components/InlineError.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../ContactHistoryHelper */ "./src/direflow-components/ContactHistory/ContactHistoryHelper.ts");
/* harmony import */ var _TranscriptComp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./TranscriptComp */ "./src/direflow-components/ContactHistory/components/Transcripts/TranscriptComp.tsx");
/* harmony import */ var _TranscriptInfo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TranscriptInfo */ "./src/direflow-components/ContactHistory/components/Transcripts/TranscriptInfo.tsx");

/* eslint-disable no-nested-ternary */








const Transcript = ({ contact, backToContactHistory, orgId }) => {
    /** Loading i18 */
    const { contactTranscript: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    /** Max of API calls available to fetch data */
    const maxTranscriptAPICalls = 2;
    /** Setting default values */
    const emailContent = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    const loadContactTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const [outboundTranscript, setOutboundTranscript] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        transcript: "",
        error: ""
    });
    const [inboundTranscript, setInboundTranscript] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        transcript: "",
        senderName: "",
        senderDate: "",
        senderSubject: "",
        error: ""
    });
    const [loaded, setLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        status: false,
        numberOfPromise: 0
    });
    const [loadingTrackingId, setLoadingTrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [outboundTrackingId, setOutboundTrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [inboundTrackingId, setInboundTrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const backBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    /**
         * @param metaInfo
         * Example : ""From:"Mohak Singh (mohaksin)" <mohaksin@cisco.com>
            Sent:Thursday, April 9, 2020 9:11 AM
            To:agentx2021@gmail.com
            Subject:Re: Customer help - Transcripts
            "
            senderName is extracted from the keyword "From" till next "<" is observed (as per implementation in ESR)
            senderDate is extracted from the keyword "Sent" till next "To" is observed.
         */
    const extractInboundDetails = (metaInfo) => {
        const senderDateTimStamp = new Date(metaInfo.substring(metaInfo.indexOf("Sent") + 5, metaInfo.indexOf("To") - 1).trim()).getTime();
        return {
            senderName: metaInfo
                .substring(metaInfo.indexOf("From") + 5, metaInfo.indexOf("Sent") - 1)
                .trim()
                .replace(/"/g, ""),
            senderDate: `${(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.getDateCommonFormat)(senderDateTimStamp)} ${(0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_6__.convertToTime)(senderDateTimStamp.toString())}`,
            senderSubject: metaInfo.substring(metaInfo.indexOf("Subject") + 8)
        };
    };
    /**
     *  API call for loading inbound transcript
     */
    const loadInboundTranscript = () => {
        var _a, _b, _c, _d, _e, _f;
        let inboundPromise;
        const url = ((_c = (_b = (_a = emailContent.current) === null || _a === void 0 ? void 0 : _a.interactionContext) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.inboundTranscript)
            ? (_d = emailContent.current) === null || _d === void 0 ? void 0 : _d.interactionContext.content.inboundTranscript
            : "";
        if (emailContent && ((_e = emailContent.current) === null || _e === void 0 ? void 0 : _e.storageName) === "emm") {
            inboundPromise = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.emm.fetchEmailContentFromEmm(url);
        }
        else if (emailContent && ((_f = emailContent.current) === null || _f === void 0 ? void 0 : _f.storageName) === "s3") {
            inboundPromise = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.mediaStorage.fetchStorageEmailContent(url);
        }
        if (inboundPromise) {
            inboundPromise
                .then((response) => {
                _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_6__.logger.info(`[Transcript:loadInboundTranscript]=> transcripts request for fetching inbound transcript  is successful }`);
                const { metaInfo, body } = response;
                const { senderName, senderDate, senderSubject } = extractInboundDetails(metaInfo);
                setInboundTranscript({
                    transcript: body,
                    senderName,
                    senderDate,
                    senderSubject,
                    error: ""
                });
            })
                .catch((error) => {
                _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_6__.logger.error(`event=loadInboundTranscriptError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error)}] [Transcript:loadInboundTranscript] => transcripts request for fetching inbound transcript failed}`);
                setInboundTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error));
                setInboundTranscript({
                    transcript: "",
                    senderName: "",
                    senderDate: "",
                    senderSubject: "",
                    error: error.id
                });
            });
        }
        return inboundPromise;
    };
    /**
     *  API call for loading outbound transcript
     */
    const loadOutboundTranscript = () => {
        var _a, _b, _c, _d, _e, _f;
        let outboundPromise;
        const url = ((_c = (_b = (_a = emailContent.current) === null || _a === void 0 ? void 0 : _a.interactionContext) === null || _b === void 0 ? void 0 : _b.outboundContent) === null || _c === void 0 ? void 0 : _c.outboundTranscript)
            ? (_d = emailContent.current) === null || _d === void 0 ? void 0 : _d.interactionContext.outboundContent.outboundTranscript
            : "";
        if (emailContent && ((_e = emailContent.current) === null || _e === void 0 ? void 0 : _e.storageName) === "emm") {
            outboundPromise = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.emm.fetchEmailContentFromEmm(url);
        }
        else if (emailContent && ((_f = emailContent.current) === null || _f === void 0 ? void 0 : _f.storageName) === "s3") {
            outboundPromise = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.mediaStorage.fetchStorageEmailContent(url);
        }
        outboundPromise
            .then((response) => {
            _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_6__.logger.info(`[Transcript:loadOutboundTranscript]=> transcripts request for fetching outbound transcript is successful }`);
            setOutboundTranscript({
                transcript: response,
                error: ""
            });
        })
            .catch((error) => {
            _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_6__.logger.error(`event=loadOutboundTranscriptError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error)}] [Transcript:loadOutboundTranscript] => transcripts request for fetching outbound transcript failed}`);
            setOutboundTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error));
            setOutboundTranscript({
                transcript: "",
                error: error.id
            });
        });
        return outboundPromise;
    };
    /**
     * Load contact transcripts
     * Inbound , Outbound or both
     */
    const loadContactTranscript = () => {
        var _a, _b, _c;
        const transcriptPromises = [];
        let inboundPromise;
        let outboundPromise;
        if (emailContent && ((_a = emailContent.current) === null || _a === void 0 ? void 0 : _a.interactionContext.content.inboundTranscript)) {
            inboundPromise = loadInboundTranscript();
            transcriptPromises.push(inboundPromise);
        }
        if (emailContent &&
            ((_b = emailContent.current) === null || _b === void 0 ? void 0 : _b.interactionContext.outboundContent) &&
            ((_c = emailContent.current) === null || _c === void 0 ? void 0 : _c.interactionContext.outboundContent.outboundTranscript)) {
            outboundPromise = loadOutboundTranscript();
            transcriptPromises.push(outboundPromise);
        }
        setLoaded({ status: false, numberOfPromise: transcriptPromises.length });
        /** If both API is success or any of fails, setting loaded status true along with promise
         * length, so that we can distinguish between Loading error and inline loading error.
         * Could have used Promise.allSettled but is in Implementation Progress.
         */
        Promise.all(transcriptPromises)
            .then(() => {
            _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_6__.logger.info(`[Transcript:loadContactTranscript]=> transcripts request for fetching transcripts is successful}`);
            setLoaded({ status: true, numberOfPromise: transcriptPromises.length });
        })
            .catch((err) => {
            _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_6__.logger.error(`event=loadContactTranscriptError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err)}] [Transcript:loadContactTranscript] => transcripts request for fetching transcript failed`);
            setLoadingTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err));
            setLoaded({ status: true, numberOfPromise: transcriptPromises.length });
        });
    };
    const getTranscriptUrls = () => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.emm
            .fetchContent({ orgId, taskId: contact.sid })
            .then((resp) => {
            emailContent.current = resp;
            if (loadContactTimeoutIdRef.current) {
                window.clearTimeout(loadContactTimeoutIdRef.current);
            }
            loadContactTimeoutIdRef.current = window.setTimeout(() => {
                loadContactTranscript();
            });
        })
            .catch((err) => {
            setLoadingTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err));
            setInboundTranscript({
                transcript: "",
                senderName: "",
                senderDate: "",
                senderSubject: "",
                error: err.id
            });
            setOutboundTranscript({
                transcript: "",
                error: err.id
            });
            setLoaded({ status: true, numberOfPromise: 0 });
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        getTranscriptUrls();
        if ((backBtnRef === null || backBtnRef === void 0 ? void 0 : backBtnRef.current) && backBtnRef.current.shadowRoot) {
            const button = backBtnRef.current.shadowRoot.querySelector("button");
            button.focus();
        }
        return () => {
            if (loadContactTimeoutIdRef.current) {
                window.clearTimeout(loadContactTimeoutIdRef.current);
            }
        };
    }, [contact]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ id: "backTranscipt", hasRemoveStyle: true, size: 36, ariaLabel: i18n.back, ref: backBtnRef, onClick: backToContactHistory, tabIndex: 0, class: "link-button" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: "icon-arrow-left_12", class: "icon-padding" }), i18n.back] })), !loaded.status ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "timeline-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: 80 }) }))) : (loaded.numberOfPromise === maxTranscriptAPICalls
                ? inboundTranscript.error !== "" && outboundTranscript.error !== ""
                : inboundTranscript.error !== "" || outboundTranscript.error !== "") ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_InlineError__WEBPACK_IMPORTED_MODULE_4__["default"], { errorHeaderMsg: i18n.errorTranscript, trackingId: loadingTrackingId, retry: getTranscriptUrls, top: 1 })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "transcript-content" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TranscriptInfo__WEBPACK_IMPORTED_MODULE_8__["default"], { contact: contact, subject: inboundTranscript.senderSubject }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "email-transcript-content" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TranscriptComp__WEBPACK_IMPORTED_MODULE_7__["default"], { errorMessage: outboundTranscript.error, errorMessageHeader: i18n.outboundErrorMessage, trackingId: outboundTrackingId, retry: loadOutboundTranscript, senderName: contact.agentName, senderDate: `${(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.getDateCommonFormat)(Number(contact.cstts))} ${(0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_6__.convertToTime)(contact.cstts)}`, senderType: i18n.agent, transcript: outboundTranscript.transcript }), (outboundTranscript.transcript !== "" || outboundTranscript.error !== "") && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TranscriptComp__WEBPACK_IMPORTED_MODULE_7__["default"], { errorMessageHeader: i18n.inboundErrorMessage, errorMessage: inboundTranscript.error, trackingId: inboundTrackingId, retry: loadInboundTranscript, senderName: inboundTranscript.senderName, senderDate: inboundTranscript.senderDate, senderType: i18n.customer, transcript: inboundTranscript.transcript })] }))] })))] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Transcript);


/***/ }),

/***/ "./src/direflow-components/ContactHistory/components/index.tsx":
/*!*********************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/components/index.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _css_common_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../css/common.css */ "./src/css/common.css");
/* harmony import */ var _css_common_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_css_common_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../ContactHistoryHelper */ "./src/direflow-components/ContactHistory/ContactHistoryHelper.ts");
/* harmony import */ var _styles_styles_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../styles/styles.css */ "./src/direflow-components/ContactHistory/styles/styles.css");
/* harmony import */ var _styles_styles_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_styles_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Timeline_TimelineItems__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Timeline/TimelineItems */ "./src/direflow-components/ContactHistory/components/Timeline/TimelineItems.tsx");
/* harmony import */ var _Transcripts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Transcripts */ "./src/direflow-components/ContactHistory/components/Transcripts/index.tsx");












/**
 * Contact History root component
 * @param details: FetchDetails
 * @param disableTranscripts: boolean
 */
const ContactHistory = ({ details, orgId, disableTranscripts, mockedContacts, isDarkMode }) => {
    const { contactHistory: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)();
    const [contactData, setContactData] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]);
    const [isLoading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true);
    const [isLoaded, setLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [errorMessage, setErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)();
    const [isError, setIsError] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [loadingTrackingId, setLoadingTrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(undefined);
    const [timelineSelected, setTimelineSelected] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)();
    const [slide, setSlide] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("slideIn");
    const [focussedContact, setFocussedContact] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)();
    const slideAnimationTime = 300;
    const contactHistoryRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const { agentId, interactionId, ani, dnis, contactDirection, tahoeEnabled } = details;
    const contactHistoryTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const loadContactHistory = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(() => {
        executeApiToLoadContactHistory(_Common_constants__WEBPACK_IMPORTED_MODULE_7__.retryAttemptContactHistory);
    }, [ani, contactDirection, dnis, i18n.missingAni, tahoeEnabled, agentId, interactionId, orgId]);
    const displayContactHistoryError = (error, customerPhoneNumber) => {
        _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_8__.logger.error(`event=loadContactHistoryByANIError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error)}] [ContactHistory:loadContactHistoryByANI] Error while loading contact history for ani:${customerPhoneNumber}`);
        setLoadingTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error));
        setContactData([]);
        setLoading(false);
        setLoaded(false);
        setIsError(true);
        setErrorMessage(error.message);
    };
    const executeApiToLoadContactHistory = (retryAttempt) => {
        if (!ani) {
            _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_8__.logger.error(`event=LoadContactHistoryError | [ContactHistory:loadContactHistory] Invalid/Missing ani ${ani}`);
            setIsError(true);
            setErrorMessage(i18n.missingAni);
            setLoaded(false);
            setLoading(false);
            return;
        }
        const customerPhoneNumber = contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.OUTBOUND ? dnis : ani;
        const promise = (0,_ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_8__.fetchHistoryByANI)(customerPhoneNumber, tahoeEnabled, agentId, interactionId);
        /** Resolve the promise */
        promise
            .then((contacts) => {
            setLoading(false);
            setLoaded(true);
            setContactData(contacts);
        })
            .catch((error) => {
            if (tahoeEnabled) {
                if (retryAttempt === _Common_constants__WEBPACK_IMPORTED_MODULE_7__.retryAttemptContactHistory) {
                    _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_3__.setTimeout(() => {
                        _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_8__.logger.info(`[ContactHistory:executeApiToLoadContactHistory] Retrying loading contact history for ani : ${ani}`);
                        executeApiToLoadContactHistory(0);
                    }, _Common_constants__WEBPACK_IMPORTED_MODULE_7__.TIMEOUT_THOUSAND_MS);
                }
                else {
                    displayContactHistoryError(error, customerPhoneNumber);
                }
            }
            else {
                displayContactHistoryError(error, customerPhoneNumber);
            }
        });
    };
    /**
     * Retry if loading of contact history fails
     */
    const retryLoadingContactHistory = () => {
        _ContactHistoryHelper__WEBPACK_IMPORTED_MODULE_8__.logger.info(`[ContactHistory:retryLoadingContactHistory] Retrying loading contact history for ani : ${ani}`);
        setIsError(false);
        setErrorMessage(null);
        setLoading(true);
        loadContactHistory();
    };
    /**
     * On Ani Change load the contact history data again
     */
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        setTimelineSelected(undefined);
        setLoading(true);
        setIsError(false);
        setErrorMessage(null);
        setContactData([]);
        loadContactHistory();
    }, [ani, loadContactHistory]);
    /**
     * If contactData updated due to ani changes, remove error if contactData found
     */
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        if (contactData && contactData.length > 0) {
            setErrorMessage(null);
            setIsError(false);
        }
    }, [contactData]);
    /** This is for testing with mock data */
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        if (mockedContacts && mockedContacts.length > 0) {
            setContactData(mockedContacts);
            setLoading(false);
            setLoaded(true);
        }
    }, [mockedContacts]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        return () => {
            if (contactHistoryTimeoutIdRef.current) {
                window.clearTimeout(contactHistoryTimeoutIdRef.current);
            }
        };
    }, []);
    /** setting state to show transcript for timeline selected */
    const onTimelineClick = (contact) => {
        setTimelineSelected(contact);
        setFocussedContact(contact);
        setSlide("slideIn");
    };
    /** removing the transcript element after timeout to show slide out animation */
    const backToContactHistory = () => {
        contactHistoryTimeoutIdRef.current = window.setTimeout(() => {
            setTimelineSelected(undefined);
            if (focussedContact) {
                contactHistoryRef.current.querySelector(`#item-${focussedContact.cstts}`).focus();
            }
        }, slideAnimationTime);
        setSlide("slideOut");
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: [(_styles_styles_css__WEBPACK_IMPORTED_MODULE_9___default()), (_css_common_css__WEBPACK_IMPORTED_MODULE_5___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "contact-history", ref: contactHistoryRef, role: "region", "aria-label": "Contact History" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Timeline_TimelineItems__WEBPACK_IMPORTED_MODULE_10__["default"], { contacts: contactData, isLoading: isLoading, isLoaded: isLoaded, errorMessage: errorMessage, loadingTrackingId: loadingTrackingId, retry: retryLoadingContactHistory, onTimeLineClick: onTimelineClick, disableTranscripts: disableTranscripts, isError: isError, isDarkMode: isDarkMode || false }), timelineSelected && (
                    /** Transcript component, rendered when timeline is selected */
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: `email-transcript ${slide}` }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Transcripts__WEBPACK_IMPORTED_MODULE_11__["default"], { contact: timelineSelected, orgId: orgId, backToContactHistory: backToContactHistory }) })))] })) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ContactHistory);


/***/ }),

/***/ "./src/direflow-components/ContactHistory/styles/styles.css":
/*!******************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/styles/styles.css ***!
  \******************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../node_modules/css-loader/dist/cjs.js!./styles.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/ContactHistory/styles/styles.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Dialer/Dialpad.tsx":
/*!****************************************************!*\
  !*** ./src/direflow-components/Dialer/Dialpad.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../constants */ "./src/constants.ts");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _style_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./style.css */ "./src/direflow-components/Dialer/style.css");
/* harmony import */ var _style_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_css__WEBPACK_IMPORTED_MODULE_5__);






const Dialpad = (props) => {
    const { dialNum, showCharButton, cursorPosition, ariaLabel } = props;
    const [inputCursorPos, setInputCursorPos] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    const dispatch = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.EventContext);
    const typeNumAtCursorPosition = (value, isEnterKeyPressed) => {
        const dn = typeof dialNum === "boolean" ? "" : dialNum.toString();
        const valBeforeCurPos = dn.substring(0, inputCursorPos);
        const valAfterCurPos = dn.substring(inputCursorPos, dn.length);
        const telNumber = valBeforeCurPos + value + valAfterCurPos;
        setInputCursorPos(inputCursorPos + 1);
        const event = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_3__.DIALER_BUTTON_CLICK_EVENT, {
            detail: {
                dnNumber: telNumber,
                singleDigitEntered: value,
                inputCursorPos,
                isEnterKeyPressed
            }
        });
        if (dispatch) {
            dispatch(event);
        }
    };
    const onDialNumClick = (value, enterKeyPressed) => {
        typeNumAtCursorPosition(value, enterKeyPressed);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        setInputCursorPos(cursorPosition + 1);
    }, [cursorPosition]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: (_style_css__WEBPACK_IMPORTED_MODULE_5___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ role: "group" }, (ariaLabel ? { "aria-label": ariaLabel } : {}), { className: "dialpad-buttons" }, { children: _constants__WEBPACK_IMPORTED_MODULE_3__.DIALPAD_BUTTONS_ARRAY.map((dialBtnObj) => {
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "dialpad-button" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ type: "button", size: 40, ariaLabel: `${dialBtnObj.val}`, onClick: (e) => {
                            e.preventDefault();
                            onDialNumClick(dialBtnObj.val, false);
                        }, onKeyDown: (e) => {
                            if (e.key === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.ENTER_KEY) {
                                e.preventDefault();
                                onDialNumClick(dialBtnObj.val, true);
                            }
                        }, circle: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "dialpad-button-text-wrapper" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: dialBtnObj.val }), showCharButton && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "dialpad-char-btn" }, { children: dialBtnObj.str }))] })) })) }), `dial-btn-${dialBtnObj.id}`));
            }) })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Dialpad);


/***/ }),

/***/ "./src/direflow-components/Dialer/style.css":
/*!**************************************************!*\
  !*** ./src/direflow-components/Dialer/style.css ***!
  \**************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../node_modules/css-loader/dist/cjs.js!./style.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Dialer/style.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/EmailComposer/Context/AppContext.tsx":
/*!**********************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/Context/AppContext.tsx ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmailProvider: () => (/* binding */ EmailProvider),
/* harmony export */   EmailReducer: () => (/* binding */ EmailReducer),
/* harmony export */   useEmailDispatchContext: () => (/* binding */ useEmailDispatchContext),
/* harmony export */   useEmailStateContext: () => (/* binding */ useEmailStateContext),
/* harmony export */   useEventContext: () => (/* binding */ useEventContext)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constants */ "./src/direflow-components/EmailComposer/constants.js");




/** Email state content to share state across  email component */
const EmailStateContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(undefined);
/** Email  dispatch content to dispatch action to update the email state */
const EmailDispatchContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(undefined);
/**
 * useEmailStateContext to get updated global state of the email component.
 */
const useEmailStateContext = () => {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(EmailStateContext);
    if (context === undefined) {
        throw new Error("useEmailStateContext must be used within a EmailProvider");
    }
    return context;
};
const useEventContext = () => {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.EventContext);
};
/**
 * useEmailDispatchContext to update global state of the email component.
 */
const useEmailDispatchContext = () => {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(EmailDispatchContext);
    if (context === undefined) {
        throw new Error("useEmailDispatchContext must be used within a EmailProvider");
    }
    return context;
};
/**
 * EmailReducer to update global state of the Email component
 * @param state
 * @param action
 */
const EmailReducer = (state, action) => {
    switch (action.type) {
        case _constants__WEBPACK_IMPORTED_MODULE_3__.SENDING_EMAIL:
        case _constants__WEBPACK_IMPORTED_MODULE_3__.VALID_STATUS:
        case _constants__WEBPACK_IMPORTED_MODULE_3__.INVALID_STATUS: {
            return Object.assign(Object.assign(Object.assign({}, state), action.payload), { status: action.type });
        }
        case _constants__WEBPACK_IMPORTED_MODULE_3__.REPLY_MODE_DRAFT: {
            return Object.assign(Object.assign(Object.assign({}, state), state.replyDraftMode), action.payload);
        }
        case _constants__WEBPACK_IMPORTED_MODULE_3__.READ_MODE_DRAFT: {
            return Object.assign(Object.assign(Object.assign({}, state), state.readDraftMode), action.payload);
        }
        case _constants__WEBPACK_IMPORTED_MODULE_3__.SAVE_TEMPLATE:
        case _constants__WEBPACK_IMPORTED_MODULE_3__.SAVE_REPLY_MESSAGE:
        case _constants__WEBPACK_IMPORTED_MODULE_3__.UNMOUNT_EMAIL:
        case _constants__WEBPACK_IMPORTED_MODULE_3__.SAVE_OUTBOUND_ATTACHMENT:
            return Object.assign(Object.assign({}, state), action.payload);
        default:
            return state;
    }
};
/**
 * Email context provider to share Email global state
 * @param param0
 */
const EmailProvider = ({ state, dispatch, children }) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmailStateContext.Provider, Object.assign({ value: state }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmailDispatchContext.Provider, Object.assign({ value: dispatch }, { children: children })) })));
};



/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/Attachment/AttachmentTag.tsx":
/*!***************************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/Attachment/AttachmentTag.tsx ***!
  \***************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* harmony import */ var _Context_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");





const iconBasedOnDocument = {
    "application/pdf": "icon-file-pdf_16",
    "image/png": "icon-file-image_16",
    "image/jpeg": "icon-file-image_16",
    "application/xls": "icon-file-excel_16",
    "application/doc": "icon-file-word_16",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "icon-file-word_16",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "icon-file-excel_16"
};
/**
 * Attachment
 * @param fileName   Attachment file Name
 * @param resourceUrl Attachment Resource url
 * @param contentType Attachment content type
 * @param handleDownload called upon when agent clicks on attachment in read mode
 * @param handleDelete called upon when agent clicks on delete attachment in reply mode
 */
const Attachment = ({ fileName, resourceUrl, contentType, handleDownload, showProgressBar: inProgress, handleDelete, shouldAllAttachmentsDisplayed }) => {
    const icon = iconBasedOnDocument[contentType];
    const state = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_4__.useEmailStateContext)();
    const { email } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.useI18nContext)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (inProgress === false && shouldAllAttachmentsDisplayed) {
            shouldAllAttachmentsDisplayed();
        }
        // eslint-disable-next-line
    }, [inProgress]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-chip", Object.assign({ role: "button", "aria-label": `${email.attachment} ${fileName}`, onClick: (e) => {
            e.preventDefault();
            if (state.mode === _constants__WEBPACK_IMPORTED_MODULE_3__.READ_EMAIL && handleDownload) {
                handleDownload(resourceUrl, contentType, fileName);
            }
        }, icon: icon || "icon-document_16", iconColor: "var(--md-alert-info-text-color)", bgColor: "var(--md-tertiary-bg-color)", value: fileName, class: "attachment-item attachment-name" }, (inProgress ? { indeterminateProgress: true } : ""), { children: state.mode !== _constants__WEBPACK_IMPORTED_MODULE_3__.READ_EMAIL && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "custom-right-content", name: "icon-cancel_12", id: "attachmentCancel", onClick: (e) => {
                e.preventDefault();
                if (handleDelete) {
                    handleDelete(resourceUrl, fileName);
                }
            } })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Attachment);


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/Attachment/index.tsx":
/*!*******************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/Attachment/index.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Common/components/ErrorModal */ "./src/direflow-components/Common/components/ErrorModal/index.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* harmony import */ var _Context_AppContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");
/* harmony import */ var _utils_Utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/Utils */ "./src/direflow-components/EmailComposer/utils/Utils.ts");
/* harmony import */ var _AttachmentTag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./AttachmentTag */ "./src/direflow-components/EmailComposer/components/Attachment/AttachmentTag.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};









/**
 * Attachments consists of Attachment components
 * @param attachments Attachments to display could be incoming or outgoing attachments
 * @updateAttachmentList Once attachment os successfully deleted , then update the attachment list
 */
const Attachments = ({ taskId, attachments = [], updateAttachmentList, getAttachmentsHeightCallback, storageName }) => {
    const { email, common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const hrefElement = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const attachmentContainerElm = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const [attachmentDetail, setAttachmentDetail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    const [downloading, setDownloading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [downloadFileName, setDownloadFileName] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [attachmentList, setAttachmentList] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(attachments);
    const [hasMoreAttachments, setHasMoreAttachments] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [errorModalState, setErrorModalState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [errorMessageState, setErrorMessageState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [errorTrackingId, setErrorTrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [showMoreAttachment, setShowMoreAttachment] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    /**
     *
     * @param data After successful rest api call to download attachment, open download browser window
     * @param contentType
     * @param fileName
     */
    const startDownloading = (data, contentType, fileName) => {
        const blob = new Blob(data, { type: contentType });
        setAttachmentDetail({ href: window.URL.createObjectURL(blob), fileName });
        if (hrefElement !== null && hrefElement.current !== null) {
            hrefElement.current.click();
        }
    };
    /**
     *
     * @param resourceUrl Make rest call to download attachment
     * @param contentType
     * @param fileName
     */
    const handleDownload = (resourceUrl, contentType, fileName) => __awaiter(void 0, void 0, void 0, function* () {
        setDownloadFileName(fileName);
        setDownloading(true);
        try {
            let data;
            if (storageName === "s3") {
                data = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.mediaStorage.downloadStorageAttachment(resourceUrl);
            }
            else {
                data = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.emm.downloadAttachment({ resourceUrl });
            }
            _utils_Utils__WEBPACK_IMPORTED_MODULE_7__.logger.info("File downloaded successfully :", fileName);
            startDownloading([data], contentType, fileName);
        }
        catch (err) {
            _utils_Utils__WEBPACK_IMPORTED_MODULE_7__.logger.error(`event=EMMFileDownloadError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err)}] Download file request fail for : fileName, ${fileName}`);
            setDownloading(false);
            setErrorMessageState(email.errordownloadattachment);
            setErrorModalState(true);
            setErrorTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err));
        }
    });
    /**
     *
     * @param resourceUrl Delete attachment
     * @param fileName
     */
    const handleDelete = (resourceUrl, fileName) => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.emm
            .deleteAttachment({ resourceUrl })
            .then(() => {
            _utils_Utils__WEBPACK_IMPORTED_MODULE_7__.logger.info("Attachment deleted successfully", fileName, resourceUrl);
            if (updateAttachmentList) {
                updateAttachmentList([...attachmentList].filter((attachment) => attachment.resourceUrl !== resourceUrl));
            }
        })
            .catch((err) => {
            _utils_Utils__WEBPACK_IMPORTED_MODULE_7__.logger.error(`event=AttachmentDeleteError |  [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err)}] Delete file request fail for :', fileName, ${err}`, err);
            setErrorMessageState(email.errordeleteattachment);
            setErrorModalState(true);
            setErrorTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err));
        });
    };
    const toggleAllAttachments = () => {
        if (attachmentContainerElm && attachmentContainerElm.current) {
            attachmentContainerElm.current.classList.toggle("showall-attachments");
            setShowMoreAttachment(!showMoreAttachment);
            if (getAttachmentsHeightCallback) {
                getAttachmentsHeightCallback(attachmentContainerElm);
            }
        }
    };
    /**
     * If all the attachments not displayed within scrollHeight then display show more icon
     */
    const shouldAllAttachmentsDisplayed = () => {
        const elm = attachmentContainerElm.current;
        if (elm) {
            setHasMoreAttachments(elm.scrollHeight > elm.clientHeight || elm.scrollWidth > elm.clientWidth);
            if (getAttachmentsHeightCallback) {
                getAttachmentsHeightCallback(attachmentContainerElm);
            }
        }
    };
    const updateDownloadingStatus = () => {
        setDownloading(false);
    };
    const state = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_6__.useEmailStateContext)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        shouldAllAttachmentsDisplayed();
        setAttachmentList(attachments);
        // eslint-disable-next-line
    }, [taskId, attachmentList, attachments]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        shouldAllAttachmentsDisplayed();
        let resizeTimer;
        window.addEventListener("resize", () => {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(() => {
                shouldAllAttachmentsDisplayed();
            }, 250);
        });
        // eslint-disable-next-line
    }, [downloading]);
    const errorModalCallback = () => {
        setErrorModalState(false);
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_4__["default"], { isOpen: errorModalState, message: errorMessageState, buttons: [
                    {
                        label: common.okButton,
                        onClick: errorModalCallback,
                        ariaLabel: common.okButton
                    }
                ], modalHeader: common.Error, trackingId: errorTrackingId, showCloseButton: false, noExitOnEsc: false, setErrorModal: setErrorModalState }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `attachment-section ${state.mode !== _constants__WEBPACK_IMPORTED_MODULE_5__.READ_EMAIL ? "editing" : ""}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "form-group" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", Object.assign({ className: "attachment-items", ref: attachmentContainerElm }, { children: attachmentList.map(({ fileName, resourceUrl, contentType, messageId, uploadInProgress }) => ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AttachmentTag__WEBPACK_IMPORTED_MODULE_8__["default"], { fileName: fileName, resourceUrl: resourceUrl, contentType: contentType, messageId: messageId, handleDownload: handleDownload, handleDelete: handleDelete, showProgressBar: (downloading && fileName === downloadFileName) || uploadInProgress, shouldAllAttachmentsDisplayed: shouldAllAttachmentsDisplayed }, fileName))) })) })), hasMoreAttachments && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: showMoreAttachment ? email.HideLabel : email.showMoreAttachment }, { children: showMoreAttachment ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ariaLabel: email.HideLabel, hasremovestyle: true, onClick: toggleAllAttachments, class: "link-button hide-attachments" }, { children: email.HideLabel }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ circle: true, class: "more-attachments", onClick: toggleAllAttachments, type: "button" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-more_28" }) }))) }))), downloading && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", { id: "anchorDownloadLink", ref: hrefElement, onClick: updateDownloadingStatus, href: attachmentDetail.href, target: "_self", download: attachmentDetail.fileName }))] }))] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Attachments);


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/Editor/AttachmentHook.tsx":
/*!************************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/Editor/AttachmentHook.tsx ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* harmony import */ var _Context_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");
/* harmony import */ var _utils_Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/Utils */ "./src/direflow-components/EmailComposer/utils/Utils.ts");
/* eslint-disable no-param-reassign */






/** Add Attachment hook */
const useAttachFile = (uploadInProgress, updateAttachmentList, outBoundAttachments, errorState, attachmentInfo) => {
    const { setErrorModalState, setErrorMessageState, setErrorModalHeaderState, setErrorTrackingId } = errorState;
    const inputFileRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { email, common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.useI18nContext)();
    const state = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_4__.useEmailStateContext)();
    const addAttachment = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (inputFileRef.current !== null) {
            inputFileRef.current.click();
        }
    };
    const currentMode = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(state.mode);
    currentMode.current = state.mode;
    const removeAttachment = (resourceUrl) => {
        const newOutBoundAttachments = [...outBoundAttachments].filter((attachment) => attachment.resourceUrl !== resourceUrl);
        updateAttachmentList(newOutBoundAttachments);
    };
    const updateAttachmentDetail = (newOutBoundAttachments, file, succResposne) => {
        newOutBoundAttachments.forEach((attachment) => {
            if (attachment.fileName === file.name && attachment.resourceUrl === "") {
                attachment.resourceUrl = succResposne.location;
                attachment.uploadInProgress = false;
            }
        });
        updateAttachmentList(newOutBoundAttachments);
        uploadInProgress(false);
    };
    const handleEmailAttachmentLimitFailure = (fileData) => {
        removeAttachment(fileData.resourceUrl);
        errorState.setErrorMessageState(email.erroraddlimitreached + attachmentInfo.maxAttachmentSizeInMB + email.errorlimit);
        errorState.setErrorModalState(true);
    };
    const handleEmailAttachmentPCIFailure = (fileData, errResponse) => {
        removeAttachment(fileData.resourceUrl);
        if (errResponse.details.axiosError.data.errorMessage.indexOf(_constants__WEBPACK_IMPORTED_MODULE_3__.FILE_TYPE) > -1) {
            setErrorMessageState(email.errorfiletype);
        }
        else if (errResponse.details.axiosError.data.errorMessage.indexOf(_constants__WEBPACK_IMPORTED_MODULE_3__.ATTACHED_FILE) > -1) {
            setErrorMessageState(email.errorcontainsimage);
        }
        else if (errResponse.details.axiosError.data.errorMessage.indexOf(_constants__WEBPACK_IMPORTED_MODULE_3__.CREDIT_CARD) > -1) {
            setErrorMessageState(email.errorcreditcard);
        }
        setErrorModalState(true);
        setErrorModalHeaderState(common.ErrorSecurityCompliance);
    };
    const handleEmailAttachmentOtherFailure = (fileData) => {
        setErrorModalHeaderState(common.Error);
        removeAttachment(fileData.resourceUrl);
        setErrorMessageState(email.erroraddattachemnt);
        setErrorModalState(true);
    };
    const handleUploadAttachmentFailure = (fileData, errResponse) => {
        if (errResponse.details.axiosError.status === _constants__WEBPACK_IMPORTED_MODULE_3__.HTTP_SUCCESS_413) {
            handleEmailAttachmentLimitFailure(fileData);
            return;
        }
        if (errResponse.details.axiosError.status === _constants__WEBPACK_IMPORTED_MODULE_3__.HTTP_SUCCESS_412) {
            handleEmailAttachmentPCIFailure(fileData, errResponse);
            return;
        }
        handleEmailAttachmentOtherFailure(fileData);
    };
    const fileInputHandler = (e) => {
        uploadInProgress(true);
        const file = e.target.files[0];
        if (file) {
            const attachmentFormData = new FormData();
            attachmentFormData.append("fileName", file);
            const fileData = {
                fileName: file.name,
                resourceUrl: "",
                contentType: file.type,
                uploadInProgress: true,
                size: file.size
            };
            const newOutBoundAttachments = [...outBoundAttachments];
            newOutBoundAttachments.push(fileData);
            updateAttachmentList(newOutBoundAttachments);
            let succResposne;
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.emm
                .addAttachment({
                orgId: state.orgId,
                taskId: state.taskId,
                data: attachmentFormData
            }, (x) => {
                succResposne = x.headers;
            })
                .then(() => {
                updateAttachmentDetail(newOutBoundAttachments, file, succResposne);
            })
                .catch((errResponse) => {
                var _a, _b, _c, _d, _e, _f;
                _utils_Utils__WEBPACK_IMPORTED_MODULE_5__.logger.error(`event=UploadAttachmentForEmailError | [Tracking ID: ${(_c = (_b = (_a = errResponse === null || errResponse === void 0 ? void 0 : errResponse.details) === null || _a === void 0 ? void 0 : _a.axiosError) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c.trackingid.split("_")[1]}] Email - attachment upload Failed: ${errResponse}`, errResponse);
                handleUploadAttachmentFailure(fileData, errResponse);
                uploadInProgress(false);
                setErrorTrackingId((_f = (_e = (_d = errResponse === null || errResponse === void 0 ? void 0 : errResponse.details) === null || _d === void 0 ? void 0 : _d.axiosError) === null || _e === void 0 ? void 0 : _e.headers) === null || _f === void 0 ? void 0 : _f.trackingid.split("_")[1]);
            });
        }
        else {
            uploadInProgress(false);
        }
    };
    const setInputFileRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((inputFileElm) => {
        inputFileRef.current = inputFileElm;
    }, []);
    return [setInputFileRef, addAttachment, fileInputHandler];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useAttachFile);


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/Editor/EditorToolbar.tsx":
/*!***********************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/Editor/EditorToolbar.tsx ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");



/**
 * EditorToolbar have the toolbar options in Editor
 * @param uploadInProgress   to disable attachfiles toobar button
 * @param isoutBoundAttachmentsLimitReached to disable attachfiles toobar button
 * @param attachmentInfo to show the info
 * @param outBoundAttachments to show/hode the info button
 */
const EditorToolbar = ({ uploadInProgress, isoutBoundAttachmentsLimitReached, attachmentInfo, outBoundAttachments, configs, pcisettings, addAttachment }) => {
    const { email } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.useI18nContext)();
    const isAttachmentDisable = uploadInProgress ||
        isoutBoundAttachmentsLimitReached ||
        (configs.isPCIComplianceEnabled && !pcisettings.isAttachmentEnabled);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ id: "toolbar" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "ql-formats" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ToolbarHeading }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", { className: "ql-header", value: 1, "aria-label": email.ToolbarHeading, type: "button" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ToolbarBold }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", { className: "ql-bold", "aria-label": email.ToolbarBold, type: "button" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ToolbarItalic }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", { className: "ql-italic", "aria-label": email.ToolbarItalic, type: "button" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ToolbarUnderLine }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", { className: "ql-underline", "aria-label": email.ToolbarUnderLine, type: "button" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ToolbarStrike }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", { className: "ql-strike", "aria-label": email.ToolbarStrike, type: "button" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ToolbarColor }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", { className: "ql-color", "aria-label": email.ToolbarColor }) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ql-formats" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "tb-separator" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "ql-formats" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ToolbarListOrder }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", { className: "ql-list", value: "ordered", "aria-label": email.ToolbarListOrder, type: "button" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ToolbarListBullet }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", { className: "ql-list", value: "bullet", "aria-label": email.ToolbarListBullet, type: "button" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ToolbarBlockQuote }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", { className: "ql-blockquote", "aria-label": email.ToolbarBlockQuote, type: "button" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ToolbarTable }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", Object.assign({ id: "table", defaultValue: "", className: "ql-tablemodule" }, { children: _constants__WEBPACK_IMPORTED_MODULE_2__.editorTableOps.map((ops) => {
                                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", Object.assign({ value: ops, "aria-label": email[ops] }, { children: email[ops] })));
                            }) })) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ql-formats" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "tb-separator" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ql-formats" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ToolbarLink }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", { className: "ql-link", "aria-label": email.link, type: "button" }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ql-formats" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "tb-separator" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "ql-formats" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.IndentRight }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", { className: "ql-indent", value: "+1", "aria-label": email.IndentRight, type: "button" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.IndentLeft }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", { className: "ql-indent", value: "-1", "aria-label": email.IndentLeft, type: "button" }) }))] })), configs.isCareAttachmentEnabled && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ql-formats" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "tb-separator" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "ql-formats" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.AttachFiles }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-link", Object.assign({ onClick: (e) => addAttachment && !isAttachmentDisable && addAttachment(e), class: "ql-attach", "aria-label": email.AttachFiles }, (isAttachmentDisable ? { disabled: true } : ""), { type: "button", role: "button" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-attachment_16", class: `ql-icon ${isAttachmentDisable ? "disable" : ""}` }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: `attachContent ${isAttachmentDisable ? "disable" : ""}` }, { children: email.AttachFiles }))] })) })), outBoundAttachments.length > 0 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ql-formats" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.AttachmentLimit +
                                        attachmentInfo.attachmentLimit +
                                        email.attachments +
                                        attachmentInfo.maxAttachmentSizeInMB +
                                        email.sizeLimit }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ hasRemoveStyle: true, class: "ql-info", ariaLabel: email.help, type: "button" }, { children: [" ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-info_12", class: "ql-icon" })] })) })) })))] }))] }))] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EditorToolbar);


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/Editor/QuilEditorHook.tsx":
/*!************************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/Editor/QuilEditorHook.tsx ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _agentx_quill__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/quill */ "../../node_modules/@agentx/quill/dist/quill.js");
/* harmony import */ var _agentx_quill__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_quill__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* eslint-disable no-param-reassign */



let table;
/** Quill Editor Hook */
const useQuillEditor = (taskId, mode, onChange) => {
    let quill;
    const refElm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const tableToolbar = (args) => {
        switch (args) {
            case "insertTable":
                table.insertTable(2, 2);
                break;
            case "insertRowAbove":
                table.insertRowAbove();
                break;
            case "insertRowBelow":
                table.insertRowBelow();
                break;
            case "insertColumnLeft":
                table.insertColumnLeft();
                break;
            case "insertColumnRight":
                table.insertColumnRight();
                break;
            case "deleteRow":
                table.deleteRow();
                break;
            case "deleteColumn":
                table.deleteColumn();
                break;
            case "deleteTable":
                table.deleteTable();
                break;
        }
    };
    const setRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((editorContainer) => {
        refElm.current = editorContainer;
        if (editorContainer && (mode === _constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_EMAIL || mode === _constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_ALL_EMAIL)) {
            quill = new (_agentx_quill__WEBPACK_IMPORTED_MODULE_0___default())(editorContainer, {
                modules: {
                    table: true,
                    toolbar: {
                        container: "#toolbar",
                        handlers: {
                            tablemodule: tableToolbar
                        }
                    },
                    keyboard: {
                        bindings: {
                            /** disabling tabbing inside editor so that focus should be moved to next element.
                              By default quill editor does not allow to come out of editor on tab press */
                            tab: {
                                key: 9,
                                handler() {
                                    return true;
                                }
                            }
                        }
                    }
                },
                theme: "snow"
            });
            quill.on("text-change", () => {
                onChange(quill.root.innerText && quill.root.innerText.trim() !== "" ? quill.root.innerHTML : "");
            });
            table = quill.getModule("table");
            if (quill.root) {
                quill.root.focus();
            }
        }
    }, [mode, taskId]);
    return [setRef, refElm];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useQuillEditor);


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/Editor/Utils.ts":
/*!**************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/Editor/Utils.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getAttachmentsHeight: () => (/* binding */ getAttachmentsHeight),
/* harmony export */   getDateTime: () => (/* binding */ getDateTime),
/* harmony export */   getOutBoundAttachmentLimit: () => (/* binding */ getOutBoundAttachmentLimit),
/* harmony export */   getReplyHeader: () => (/* binding */ getReplyHeader),
/* harmony export */   getTotalAttachedFileSize: () => (/* binding */ getTotalAttachedFileSize),
/* harmony export */   hasIncomingAttachment: () => (/* binding */ hasIncomingAttachment),
/* harmony export */   hasOutboundAttachment: () => (/* binding */ hasOutboundAttachment),
/* harmony export */   shouldShowMore: () => (/* binding */ shouldShowMore),
/* harmony export */   toggleButtonStyle: () => (/* binding */ toggleButtonStyle)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* harmony import */ var _utils_Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/Utils */ "./src/direflow-components/EmailComposer/utils/Utils.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");





const getTotalAttachedFileSize = (updatedList) => {
    let totalSize = 0;
    updatedList.forEach((attach) => {
        totalSize += attach && attach.size ? attach.size : 0;
    });
    totalSize /= _constants__WEBPACK_IMPORTED_MODULE_2__.ONE_KILO_BYTE_SIZE * _constants__WEBPACK_IMPORTED_MODULE_2__.ONE_KILO_BYTE_SIZE;
    return totalSize;
};
const getOutBoundAttachmentLimit = (attachmentInfo, updatedList) => {
    let MaxLimitInMB;
    let MaxLimit;
    const totalSize = updatedList.length > 0 ? getTotalAttachedFileSize(updatedList) : 0;
    if ((attachmentInfo === null || attachmentInfo === void 0 ? void 0 : attachmentInfo.maxAttachmentSizeInMB) && (attachmentInfo === null || attachmentInfo === void 0 ? void 0 : attachmentInfo.attachmentLimit)) {
        MaxLimitInMB = Number(attachmentInfo === null || attachmentInfo === void 0 ? void 0 : attachmentInfo.maxAttachmentSizeInMB);
        MaxLimit = Number(attachmentInfo === null || attachmentInfo === void 0 ? void 0 : attachmentInfo.attachmentLimit);
    }
    return !!(updatedList.length >= MaxLimit || totalSize >= MaxLimitInMB);
};
const getAttachmentsHeight = (ref) => {
    let height;
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
        height = `calc(100% - ${height + ref.current.clientHeight}px )`;
    }
    return height;
};
const getDateTime = (date) => {
    const dt = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromJSDate(date);
    return dt.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.DATETIME_MED_WITH_SECONDS);
};
const getReplyHeader = (state) => {
    if (state.mode !== _constants__WEBPACK_IMPORTED_MODULE_2__.READ_EMAIL) {
        return `<div>${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.getLocalizedMessages)().email.on} ${getDateTime(new Date(state.content.date))}, <span> ${state.content.from} &lt;${state.content.replyToAddress}&gt;</span> ${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.getLocalizedMessages)().email.wrote}:</div>`;
    }
    return ``;
};
const toggleButtonStyle = (state, showMore, outAttachments) => classnames__WEBPACK_IMPORTED_MODULE_0___default()("display-space-between", {
    "email-container-write-height": state.mode !== _constants__WEBPACK_IMPORTED_MODULE_2__.READ_EMAIL && !showMore && outAttachments.length === 0
}, {
    withAttachment: state.mode !== _constants__WEBPACK_IMPORTED_MODULE_2__.READ_EMAIL && !showMore && outAttachments.length > 0
});
const hasIncomingAttachment = (mode, incomingAttachments) => mode === _constants__WEBPACK_IMPORTED_MODULE_2__.READ_EMAIL && incomingAttachments.length > 0;
const hasOutboundAttachment = (mode, outAttachments) => (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_3__.isReplyMode)(mode) && outAttachments.length > 0;
const shouldShowMore = (mode, showMore) => mode === _constants__WEBPACK_IMPORTED_MODULE_2__.READ_EMAIL || mode === _constants__WEBPACK_IMPORTED_MODULE_2__.INIT_MAIL || showMore;


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/Editor/index.tsx":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/Editor/index.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dompurify */ "../../node_modules/dompurify/dist/purify.es.mjs");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Common/components/ErrorModal */ "./src/direflow-components/Common/components/ErrorModal/index.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* harmony import */ var _Context_AppContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");
/* harmony import */ var _utils_Utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/Utils */ "./src/direflow-components/EmailComposer/utils/Utils.ts");
/* harmony import */ var _Attachment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Attachment */ "./src/direflow-components/EmailComposer/components/Attachment/index.tsx");
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Footer */ "./src/direflow-components/EmailComposer/components/Footer/index.tsx");
/* harmony import */ var _AttachmentHook__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./AttachmentHook */ "./src/direflow-components/EmailComposer/components/Editor/AttachmentHook.tsx");
/* harmony import */ var _EditorToolbar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./EditorToolbar */ "./src/direflow-components/EmailComposer/components/Editor/EditorToolbar.tsx");
/* harmony import */ var _QuilEditorHook__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./QuilEditorHook */ "./src/direflow-components/EmailComposer/components/Editor/QuilEditorHook.tsx");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Utils */ "./src/direflow-components/EmailComposer/components/Editor/Utils.ts");















/**
 * EmailEditor consists of Editor, Attachments and Footer components
 * @param emailContent   Customer sent mail content
 * @param incomingAttachments Customer sent Attachments
 * @param outboundAttachments Agent uploaded Attachments
 */
const EmailEditor = ({ taskId, emailContent, incomingAttachments, outboundAttachments, draftEmailContent, configs, pcisettings, draftQuickReply, storageName, pciAllowedAttachmentTypes }) => {
    const { email, common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.useI18nContext)();
    const dispatch = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_7__.useEmailDispatchContext)();
    const state = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_7__.useEmailStateContext)();
    const [editorHtml, setEditorHtml] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(emailContent);
    const [showMore, setShowMore] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [outAttachments, setOutAttachments] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(outboundAttachments);
    const [uploadInProgress, setUploadInProgress] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [errorModalState, setErrorModalState] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [errorModalHeaderState, setErrorModalHeaderState] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [errorMessageState, setErrorMessageState] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [errorTrackingId, setErrorTrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [emailContainerHeight, setEmailContainerHeight] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [isoutBoundAttachmentsLimitReached, setIsoutBoundAttachmentsLimitReached] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const currentState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(state);
    currentState.current = state;
    const outBoundAttachmentLimit = (updatedList) => {
        setIsoutBoundAttachmentsLimitReached((0,_Utils__WEBPACK_IMPORTED_MODULE_14__.getOutBoundAttachmentLimit)(state.attachmentInfo, updatedList));
    };
    const updateAttachmentList = (updatedAttachmentList) => {
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_6__.SAVE_OUTBOUND_ATTACHMENT,
            payload: {
                outboundAttachments: updatedAttachmentList
            }
        });
        setOutAttachments(updatedAttachmentList);
        outBoundAttachmentLimit(updatedAttachmentList);
    };
    const errorState = {
        setErrorModalState,
        setErrorMessageState,
        setErrorModalHeaderState,
        setErrorTrackingId
    };
    const [setInputFileRef, addAttachment, fileInputHandler] = (0,_AttachmentHook__WEBPACK_IMPORTED_MODULE_11__["default"])(setUploadInProgress, updateAttachmentList, outAttachments, errorState, state.attachmentInfo);
    const setReplyMessage = (msg) => {
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_6__.SAVE_REPLY_MESSAGE,
            payload: {
                replyBody: msg
            }
        });
    };
    const [editorElm] = (0,_QuilEditorHook__WEBPACK_IMPORTED_MODULE_13__["default"])(taskId, state.mode, setReplyMessage);
    const isAttachmentUploadInProgress = () => {
        const inUploadProgressList = outAttachments === null || outAttachments === void 0 ? void 0 : outAttachments.filter((attachment) => attachment.uploadInProgress === true);
        if ((inUploadProgressList === null || inUploadProgressList === void 0 ? void 0 : inUploadProgressList.length) > 0) {
            return true;
        }
        return false;
    };
    const isSendButtonDisabled = () => {
        var _a;
        return (state.replyBody.length === 0 && ((_a = state.outboundAttachments) === null || _a === void 0 ? void 0 : _a.length) === 0) || isAttachmentUploadInProgress();
    };
    const sendHandler = (currState) => {
        if (!isSendButtonDisabled()) {
            const updState = currState || state;
            dispatch({
                type: _constants__WEBPACK_IMPORTED_MODULE_6__.SENDING_EMAIL,
                payload: {
                    replyEmail: {
                        subject: updState.content.subject,
                        fromAddress: updState.content.userEmailId,
                        toAddress: [updState.content.replyToAddress],
                        ccAddress: updState.replyCcAddress || [],
                        replyToAddress: updState.content.userEmailId,
                        contentType: "text/html",
                        body: updState.replyBody
                    }
                }
            });
        }
    };
    const showPreviousMail = (e) => {
        if (e.key !== "Tab") {
            e.preventDefault();
            setShowMore(!showMore);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        setEditorHtml(`${(0,_Utils__WEBPACK_IMPORTED_MODULE_14__.getReplyHeader)(state)}${emailContent}`);
    }, [taskId, state.mode, emailContent, state.content.date, state.content.from, state.content.replyToAddress]);
    const errorModalCallback = () => {
        setErrorModalState(false);
    };
    const getAttachmentsHeightCallback = (ref) => {
        setEmailContainerHeight((0,_Utils__WEBPACK_IMPORTED_MODULE_14__.getAttachmentsHeight)(ref));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        setOutAttachments(state.outboundAttachments);
        outBoundAttachmentLimit(state.outboundAttachments ? state.outboundAttachments : []);
    }, [taskId, state.mode]);
    const shouldSendEmail = (key) => {
        return (key.data &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.SEND_EMAIL_KEY &&
            (currentState.current.mode === _constants__WEBPACK_IMPORTED_MODULE_6__.REPLY_EMAIL || currentState.current.mode === _constants__WEBPACK_IMPORTED_MODULE_6__.REPLY_ALL_EMAIL) &&
            currentState.current.replyBody.length !== 0 &&
            currentState.current.status !== _constants__WEBPACK_IMPORTED_MODULE_6__.INVALID_STATUS);
    };
    const executeSendMailShortcut = (key) => {
        if (shouldSendEmail(key)) {
            sendHandler(currentState.current);
        }
    };
    const getCustomerDisplayName = () => {
        let customerDisplayName = "";
        if (state.content.from) {
            [customerDisplayName] = state.content.from.split("(");
        }
        else {
            const { defaultValues } = state.template;
            if (defaultValues.defaultTypeForCustomer) {
                customerDisplayName = defaultValues.defaultTypeCustomer;
            }
        }
        return customerDisplayName;
    };
    const getDefaultEmailContent = () => {
        let emailDefaultContent = "";
        if (draftEmailContent) {
            emailDefaultContent = draftEmailContent;
        }
        else if (state.template) {
            let { emailTemplate } = state.template;
            const { defaultValues } = state.template;
            const customer = getCustomerDisplayName();
            const agent = state.agentName || (defaultValues.defaultTypeForAgent ? defaultValues.defaultTypeAgent : "");
            emailTemplate = emailTemplate.replace(/\${CustomerName}/g, customer).replace(/\${AgentName}/g, agent);
            // replacing <th> element with <td>, <th> element is not supported by quill editor
            emailDefaultContent = emailTemplate.replace(/<th ([^>]*)>/g, "<td $1>").replace(/<\/th>/g, "</td>");
        }
        return emailDefaultContent;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((key) => executeSendMailShortcut(key));
        return () => {
            if (stopListen) {
                stopListen();
            }
        };
    }, []);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_5__["default"], { isOpen: errorModalState, message: errorMessageState, buttons: [
                    {
                        label: common.okButton,
                        onClick: errorModalCallback,
                        ariaLabel: common.okButton
                    }
                ], modalHeader: errorModalHeaderState, trackingId: errorTrackingId, showCloseButton: false, noExitOnEsc: false, setErrorModal: setErrorModalState }), (state.mode === _constants__WEBPACK_IMPORTED_MODULE_6__.REPLY_EMAIL || state.mode === _constants__WEBPACK_IMPORTED_MODULE_6__.REPLY_ALL_EMAIL) && state.attachmentInfo && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_EditorToolbar__WEBPACK_IMPORTED_MODULE_12__["default"], { uploadInProgress: uploadInProgress, outBoundAttachments: outAttachments, isoutBoundAttachmentsLimitReached: isoutBoundAttachmentsLimitReached, attachmentInfo: state.attachmentInfo, configs: configs, pcisettings: pcisettings, addAttachment: addAttachment })), (0,_Utils__WEBPACK_IMPORTED_MODULE_14__.hasIncomingAttachment)(state.mode, incomingAttachments) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Attachment__WEBPACK_IMPORTED_MODULE_9__["default"], { taskId: taskId, attachments: incomingAttachments, storageName: storageName })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `email-editor-container ${state.mode === _constants__WEBPACK_IMPORTED_MODULE_6__.READ_EMAIL ? "email-editor-height-read" : "email-editor-height-reply"}` }, { children: [(0,_Utils__WEBPACK_IMPORTED_MODULE_14__.hasOutboundAttachment)(state.mode, outAttachments) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Attachment__WEBPACK_IMPORTED_MODULE_9__["default"], { taskId: taskId, updateAttachmentList: updateAttachmentList, attachments: outAttachments, getAttachmentsHeightCallback: getAttachmentsHeightCallback })), (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_8__.isReplyMode)(state.mode) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: (0,_Utils__WEBPACK_IMPORTED_MODULE_14__.toggleButtonStyle)(state, showMore, outAttachments), style: !showMore && outAttachments.length > 0 ? { height: emailContainerHeight } : {} }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { ref: editorElm, className: "email-editor-container-editable", id: "editor", dangerouslySetInnerHTML: {
                                    __html: dompurify__WEBPACK_IMPORTED_MODULE_2__["default"].sanitize(getDefaultEmailContent())
                                } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: showMore ? email.HidePrevThread : email.ShowPrevThread }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", Object.assign({ id: "toggleThreadButton", "aria-label": showMore ? email.HidePrevThread : email.ShowPrevThread, onClick: showPreviousMail, onKeyDown: showPreviousMail, type: "button" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-more_16", color: "var(--md-primary-text-color)" }) })) }))] }))), (0,_Utils__WEBPACK_IMPORTED_MODULE_14__.shouldShowMore)(state.mode, showMore) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "show-more" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", { className: `email-editor-container-readonly-pre ${showMore && state.mode !== _constants__WEBPACK_IMPORTED_MODULE_6__.READ_EMAIL ? "email-editor-blockquote" : ""}`, dangerouslySetInnerHTML: {
                                __html: dompurify__WEBPACK_IMPORTED_MODULE_2__["default"].sanitize(editorHtml)
                            } }) })))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_10__["default"], { taskId: taskId, draftQuickReply: draftQuickReply, sendHandler: () => sendHandler(state), isSendButtonDisabled: isSendButtonDisabled() }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { id: "addFile", accept: pciAllowedAttachmentTypes, ref: setInputFileRef, onChange: fileInputHandler, type: "file", hidden: true, onClick: (e) => {
                    e.target.value = null;
                } })] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EmailEditor);


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/Footer/index.tsx":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/Footer/index.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* harmony import */ var _Context_AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");
/* harmony import */ var _QuickReply__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../QuickReply */ "./src/direflow-components/EmailComposer/components/QuickReply/index.tsx");





/**
 * Email footer component consists of QuickReply and Send email components
 * @param isSendButtonEnabled to disable send button
 * @param sendHandler send action handler
 */
const Footer = ({ isSendButtonDisabled, sendHandler, draftQuickReply, taskId }) => {
    const state = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_3__.useEmailStateContext)();
    const { email } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.useI18nContext)();
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: state.mode === _constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_EMAIL || state.mode === _constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_ALL_EMAIL ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "email-footer" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "reply-warning", role: "banner", tabIndex: 0, "aria-label": email.replywarning }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", { children: email.replywarning }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ onClick: sendHandler, ariaLabel: email.SendLabel, variant: "primary", id: "sendEmailBtn", size: 32, class: "send-button", part: "button" }, (state.status === _constants__WEBPACK_IMPORTED_MODULE_2__.INVALID_STATUS || isSendButtonDisabled ? { disabled: true } : ""), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-send_16", class: "send-icon" }), email.SendLabel] }))] }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QuickReply__WEBPACK_IMPORTED_MODULE_4__["default"], { taskId: taskId, draftQuickReply: draftQuickReply })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Footer);


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/Header/CcField.tsx":
/*!*****************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/Header/CcField.tsx ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* harmony import */ var _Context_AppContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");
/* harmony import */ var _utils_Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/Utils */ "./src/direflow-components/EmailComposer/utils/Utils.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Utils */ "./src/direflow-components/EmailComposer/components/Header/Utils.ts");








const CcField = ({ taskId, toAddress, userEmailId, ccAddress, draftCcAddress, ccFieldHeight, toggleCcField, isVisible }) => {
    const { email } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const state = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_5__.useEmailStateContext)();
    const dispatch = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_5__.useEmailDispatchContext)();
    const readonly = (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_6__.isReadMode)(state.mode);
    const ccAddressLength = (0,_Utils__WEBPACK_IMPORTED_MODULE_7__.isCCAddressEmpty)(ccAddress);
    const [ccAddresses, setCcAddresses] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const ccFieldRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const [ccBadges, setCcBadges] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const ccHeightRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        (0,_Utils__WEBPACK_IMPORTED_MODULE_7__.adjustCCFieldHeight)(ccHeightRef, ccFieldHeight);
    }, [ccAddresses, ccBadges]);
    const handleCcChange = (event) => {
        setCcAddresses(event.target.value);
        (0,_Utils__WEBPACK_IMPORTED_MODULE_7__.dispatchOnCCAddressChange)(event, dispatch, ccBadges);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        (0,_Utils__WEBPACK_IMPORTED_MODULE_7__.dispatchOnBadgesChange)((0,_utils_Utils__WEBPACK_IMPORTED_MODULE_6__.validateEmailIds)(ccBadges), ccBadges, dispatch);
    }, [ccBadges]);
    const handleDelete = (ccBadge) => {
        const updatedCcBadges = ccBadges.filter((i) => i !== ccBadge);
        setCcBadges(updatedCcBadges);
    };
    const handleEdit = (e, ccBadge) => {
        setCcAddresses(ccBadge);
        const updatedCcBadges = ccBadges.filter((i) => i !== ccBadge);
        setCcBadges(updatedCcBadges);
    };
    const handleKeyAction = (e, passedCcBadges) => {
        if (e.keyCode === 32 || e.keyCode === 186) {
            (0,_Utils__WEBPACK_IMPORTED_MODULE_7__.handleKeyDown)(e, passedCcBadges, setCcBadges, setCcAddresses);
        }
        const inputAction = e.target.tagName === "INPUT";
        const ccAddressAction = e.target.tagName === "MD-CHIP";
        switch (e.key) {
            case "Backspace":
                if (inputAction && e.target.value.length === 0) {
                    const previousCcAddress = e.target.previousElementSibling || null;
                    if (previousCcAddress) {
                        handleDelete(passedCcBadges[passedCcBadges.length - 1]);
                    }
                }
                if (ccAddressAction) {
                    handleDelete(passedCcBadges);
                }
                break;
            case "Enter":
                if (ccAddressAction) {
                    handleEdit(e, passedCcBadges);
                }
                break;
            default:
                break;
        }
    };
    /** this hook should be only invoked if mode  changes.
     * Do not add any other dependency, it will lead to re render header component
     */
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        setCcBadges((0,_Utils__WEBPACK_IMPORTED_MODULE_7__.getCCBadgesAddress)(state.mode, draftCcAddress, toAddress, userEmailId, ccAddress));
        if (state.mode === _constants__WEBPACK_IMPORTED_MODULE_4__.REPLY_ALL_EMAIL) {
            setTimeout(() => {
                if (ccFieldRef && ccFieldRef.current) {
                    ccFieldRef.current.blur();
                }
            });
        }
    }, [taskId, state.mode]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("email-row email-input-row cc-row-height", {
                "replyClass writeMailClass": state.mode !== _constants__WEBPACK_IMPORTED_MODULE_4__.READ_EMAIL,
                "hide-cc-field": !isVisible
            }), ref: ccHeightRef }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "subject-col1-cc label-width" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "email-label" }, { children: email.CcLabel })), readonly && ccAddressLength && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "email-value-cc", id: "ccAddressReadOnly" }, { children: (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_6__.addMailIdSeparator)(ccAddress) })))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "subject-col2-cc " }, { children: [ccBadges.map((ccBadge) => ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-chip", Object.assign({ class: classnames__WEBPACK_IMPORTED_MODULE_1___default()("badge-wrapper", {
                                "correctEmail-tag": (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_6__.validateEmailId)(ccBadge),
                                "wrongEmail-tag": !(0,_utils_Utils__WEBPACK_IMPORTED_MODULE_6__.validateEmailId)(ccBadge)
                            }), role: "button", id: "badgeWrapper", bgcolor: !(0,_utils_Utils__WEBPACK_IMPORTED_MODULE_6__.validateEmailId)(ccBadge) ? "var(--badge-red-bg-color)" : "var(--md-tertiary-bg-color)", onDoubleClick: (e) => handleEdit(e, ccBadge), value: ccBadge, color: !(0,_utils_Utils__WEBPACK_IMPORTED_MODULE_6__.validateEmailId)(ccBadge) && "red", onKeyDown: (e) => handleKeyAction(e, ccBadge) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "custom-right-content", name: "icon-cancel_12", class: "removeCcAddress", onClick: () => handleDelete(ccBadge) }) })))), !readonly && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { className: "email-value-cc-input", id: "ccAddress", type: "email", multiple: true, tabIndex: 0, "aria-label": "email cc input", ref: ccFieldRef, value: ccAddresses, onKeyDown: (e) => handleKeyAction(e, ccBadges), onChange: handleCcChange, onPaste: (e) => (0,_Utils__WEBPACK_IMPORTED_MODULE_7__.handlePaste)(e, ccBadges, setCcBadges), onBlur: (e) => (0,_Utils__WEBPACK_IMPORTED_MODULE_7__.handleOnBlur)(e, ccBadges, setCcBadges, setCcAddresses) }))] })), !readonly && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "subject-col3-cc" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ariaLabel: email.HideLabel, hasremovestyle: true, id: "hideCcBtn", onClick: toggleCcField, class: "link-button" }, { children: email.HideLabel })) })))] })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CcField);


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/Header/Utils.ts":
/*!**************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/Header/Utils.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   adjustCCFieldHeight: () => (/* binding */ adjustCCFieldHeight),
/* harmony export */   dispatchOnBadgesChange: () => (/* binding */ dispatchOnBadgesChange),
/* harmony export */   dispatchOnCCAddressChange: () => (/* binding */ dispatchOnCCAddressChange),
/* harmony export */   getCCBadgesAddress: () => (/* binding */ getCCBadgesAddress),
/* harmony export */   handleKeyDown: () => (/* binding */ handleKeyDown),
/* harmony export */   handleOnBlur: () => (/* binding */ handleOnBlur),
/* harmony export */   handlePaste: () => (/* binding */ handlePaste),
/* harmony export */   isCCAddressEmpty: () => (/* binding */ isCCAddressEmpty),
/* harmony export */   isCCFieldVisible: () => (/* binding */ isCCFieldVisible),
/* harmony export */   setCCFieldOnStateChange: () => (/* binding */ setCCFieldOnStateChange)
/* harmony export */ });
/* harmony import */ var _utils_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/Utils */ "./src/direflow-components/EmailComposer/utils/Utils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");


const dispatchOnCCAddressChange = (event, dispatch, ccBadges) => {
    if (event.target.value.trim() !== "") {
        dispatch({ type: _constants__WEBPACK_IMPORTED_MODULE_1__.INVALID_STATUS });
    }
    else {
        dispatch({ type: _constants__WEBPACK_IMPORTED_MODULE_1__.VALID_STATUS, payload: { replyCcAddress: ccBadges } });
    }
};
const dispatchOnBadgesChange = (areEmailIdsValid, ccBadges, dispatch) => {
    if (!areEmailIdsValid) {
        dispatch({ type: _constants__WEBPACK_IMPORTED_MODULE_1__.INVALID_STATUS, payload: { replyCcAddress: ccBadges } });
    }
    else {
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__.VALID_STATUS,
            payload: { replyCcAddress: ccBadges }
        });
    }
};
const handleOnBlur = (event, ccBadges, setCcBadges, setCcAddresses) => {
    event.preventDefault();
    const inputedEmail = event.target.value.trim();
    if (inputedEmail !== "") {
        const inCcBadges = ccBadges.includes(inputedEmail);
        if (!inCcBadges) {
            setCcBadges([...ccBadges, inputedEmail]);
            setCcAddresses("");
        }
    }
};
const handlePaste = (event, ccBadges, setCcBadges) => {
    event.preventDefault();
    const paste = event.clipboardData.getData("text");
    const emails = paste.split(";");
    if (emails) {
        const inputedEmails = emails.filter((email) => !ccBadges.includes(email));
        setCcBadges([...ccBadges, ...inputedEmails]);
    }
};
const handleKeyDown = (event, ccBadges, setCcBadges, setCcAddresses) => {
    const emailSeperator = [32, 186];
    if (emailSeperator.includes(event.keyCode)) {
        event.preventDefault();
        const inputedEmail = event.target.value.trim();
        if (inputedEmail !== "") {
            const inCcBadges = ccBadges.includes(inputedEmail);
            if (!inCcBadges) {
                setCcBadges([...ccBadges, inputedEmail]);
                setCcAddresses("");
            }
        }
    }
};
const isCCAddressEmpty = (ccAddress) => {
    return ccAddress && ccAddress.length > 0 && ccAddress[0] !== "";
};
const setCCFieldOnStateChange = (mode, draftCcAddress, ccAddress, updateCCFields) => {
    switch (mode) {
        case _constants__WEBPACK_IMPORTED_MODULE_1__.REPLY_EMAIL:
            updateCCFields(!!(draftCcAddress === null || draftCcAddress === void 0 ? void 0 : draftCcAddress.length));
            break;
        case _constants__WEBPACK_IMPORTED_MODULE_1__.REPLY_ALL_EMAIL:
            updateCCFields(true);
            break;
        case _constants__WEBPACK_IMPORTED_MODULE_1__.READ_EMAIL:
            if (isCCAddressEmpty(ccAddress)) {
                updateCCFields(true);
            }
            break;
        default:
            _utils_Utils__WEBPACK_IMPORTED_MODULE_0__.logger.info("Invalid State Mode");
    }
};
const isCCFieldVisible = (mode, isCCEmpty) => {
    return isCCEmpty || mode === _constants__WEBPACK_IMPORTED_MODULE_1__.REPLY_EMAIL || mode === _constants__WEBPACK_IMPORTED_MODULE_1__.REPLY_ALL_EMAIL;
};
const getCCBadgesAddress = (mode, draftCCAddress, toAddress, userEmailId, ccAddress) => {
    const draftCCArray = draftCCAddress || [];
    const formatCCAddress = ccAddress.filter((id) => id).map((id) => (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_0__.formatEmail)(id));
    const formatToAddress = toAddress.map((id) => (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_0__.formatEmail)(id)).filter((id) => (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_0__.formatEmail)(id) !== userEmailId);
    const defaultAddresses = draftCCArray.map((id) => id.trim()).filter((id) => !formatCCAddress.includes(id));
    switch (mode) {
        case _constants__WEBPACK_IMPORTED_MODULE_1__.REPLY_EMAIL:
            return draftCCArray;
        case _constants__WEBPACK_IMPORTED_MODULE_1__.REPLY_ALL_EMAIL:
            return draftCCArray.length !== 0
                ? draftCCArray
                : defaultAddresses.concat(formatToAddress).concat(formatCCAddress);
        case _constants__WEBPACK_IMPORTED_MODULE_1__.READ_EMAIL:
        default:
            return [];
    }
};
const adjustCCFieldHeight = (ccHeightRef, ccFieldHeight) => {
    if (ccHeightRef && ccHeightRef.current) {
        ccFieldHeight(ccHeightRef.current.clientHeight);
    }
};


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/Header/index.tsx":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/Header/index.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Context_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* harmony import */ var _utils_Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/Utils */ "./src/direflow-components/EmailComposer/utils/Utils.ts");
/* harmony import */ var _CcField__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CcField */ "./src/direflow-components/EmailComposer/components/Header/CcField.tsx");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Utils */ "./src/direflow-components/EmailComposer/components/Header/Utils.ts");

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */








const Header = ({ fromAddress, toAddress = [], ccAddress, userEmailId, subject, isCcFiledEnabled, draftCcAddress, ccFieldHeight, taskId }) => {
    const { email } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const state = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_4__.useEmailStateContext)();
    const dispatch = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_4__.useEmailDispatchContext)();
    const readonly = (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_6__.isReadMode)(state.mode);
    const [ccField, setCcField] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(readonly);
    const dispatchReply = (mode) => {
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_5__.REPLY_MODE_DRAFT,
            payload: {
                mode,
                readDraftMode: {
                    replyBody: state.replyBody,
                    content: state.content,
                    attachmentInfo: state.attachmentInfo,
                    status: state.status,
                    quickReplyBody: state.quickReplyBody
                }
            }
        });
    };
    const handleReplyAction = (e) => {
        e.preventDefault();
        dispatchReply(_constants__WEBPACK_IMPORTED_MODULE_5__.REPLY_EMAIL);
    };
    const handleReplyAllAction = (e) => {
        e.preventDefault();
        dispatchReply(_constants__WEBPACK_IMPORTED_MODULE_5__.REPLY_ALL_EMAIL);
    };
    const handleViewOrgMailAction = (e) => {
        e.preventDefault();
        const payloadData = {
            replyBody: state.replyBody,
            replyCcAddress: state.replyCcAddress,
            content: state.content,
            attachmentInfo: state.attachmentInfo,
            status: state.status,
            quickReplyMode: state.quickReplyBody,
            outboundAttachments: state.outboundAttachments
        };
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_5__.READ_MODE_DRAFT,
            payload: { mode: _constants__WEBPACK_IMPORTED_MODULE_5__.READ_EMAIL, replyDraftMode: payloadData }
        });
    };
    const updateCCFields = (isCcField) => {
        setCcField(isCcField);
        isCcFiledEnabled(isCcField);
    };
    const toggleCcField = () => {
        setCcField(!ccField);
        isCcFiledEnabled(!ccField);
    };
    /** this hook should be only invoked if mode  changes.
     * Do not add any other dependency, it will lead to re render header component
     */
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        (0,_Utils__WEBPACK_IMPORTED_MODULE_8__.setCCFieldOnStateChange)(state.mode, draftCcAddress, ccAddress, updateCCFields);
    }, [taskId, state.mode]);
    const executeEmailShortcuts = (key) => {
        if (key.data && key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_SHIFT) {
            if (key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.REPLY_EMAIL_KEY) {
                dispatchReply(_constants__WEBPACK_IMPORTED_MODULE_5__.REPLY_EMAIL);
            }
            else if (key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.REPLY_ALL_EMAIL_KEY) {
                dispatchReply(_constants__WEBPACK_IMPORTED_MODULE_5__.REPLY_ALL_EMAIL);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((key) => executeEmailShortcuts(key));
        return () => {
            if (stopListen) {
                stopListen();
            }
        };
    }, []);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `email-header ${state.mode === _constants__WEBPACK_IMPORTED_MODULE_5__.READ_EMAIL ? "readonly" : ""}` }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: `email-row email-input-row ${state.mode !== _constants__WEBPACK_IMPORTED_MODULE_5__.READ_EMAIL ? "writeMailClass" : ""}` }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "subject-col1" }, { children: [state.mode !== _constants__WEBPACK_IMPORTED_MODULE_5__.READ_EMAIL && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "email-label label-width" }, { children: email.SubjectLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ "aria-label": email.SubjectLabel, className: `email-value subject ${state.mode === _constants__WEBPACK_IMPORTED_MODULE_5__.READ_EMAIL ? "fontSizeReadMail" : ""}`, id: "subject" }, { children: subject })), state.mode === _constants__WEBPACK_IMPORTED_MODULE_5__.READ_EMAIL ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "bottom", message: email.ReplyLabel }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ id: "replyBtn", hasremoveStyle: true, part: "button", ariaLabel: email.ReplyLabel, role: "button", onClick: handleReplyAction, class: "link-button" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-phone-reply_16", class: "reply-icon" }), email.ReplyLabel] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "bottom", message: email.ReplyAllLabel }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ id: "replyAllBtn", hasremoveStyle: true, part: "button", ariaLabel: email.ReplyAllLabel, role: "button", onClick: handleReplyAllAction, class: "link-button" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-phone-reply-all_16", class: "reply-icon" }), email.ReplyAllLabel] })) }))] })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: email.ViewOriginalMail }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ hasremoveStyle: true, part: "button", id: "viewOrgBtn", ariaLabel: email.ViewOriginalMail, onClick: handleViewOrgMailAction, class: "link-button" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-back_16", class: "reply-icon" }), email.ViewOriginalMail] })) })))] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: `email-row email-input-row ${state.mode !== _constants__WEBPACK_IMPORTED_MODULE_5__.READ_EMAIL ? "replyClass writeMailClass" : ""} email-input-row` }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "subject-col1" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: `email-label ${state.mode !== _constants__WEBPACK_IMPORTED_MODULE_5__.READ_EMAIL ? "label-width" : ""} ` }, { children: email.ToLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "email-value", id: "fromAddress" }, { children: (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_6__.formatEmail)(fromAddress) })), !readonly && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: !ccField && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ hasremoveStyle: true, id: "toggleCcBtn", onClick: toggleCcField, class: "link-button", ariaLabel: email.CcLabel }, { children: email.CcLabel }))) }))] })) })), (0,_Utils__WEBPACK_IMPORTED_MODULE_8__.isCCFieldVisible)(state.mode, (0,_Utils__WEBPACK_IMPORTED_MODULE_8__.isCCAddressEmpty)(ccAddress)) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CcField__WEBPACK_IMPORTED_MODULE_7__["default"], { taskId: taskId, ccAddress: ccAddress, draftCcAddress: draftCcAddress, ccFieldHeight: ccFieldHeight, toAddress: toAddress, userEmailId: userEmailId, toggleCcField: toggleCcField, isVisible: ccField }))] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Header);


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/QuickReply/index.tsx":
/*!*******************************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/QuickReply/index.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* harmony import */ var _Context_AppContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");
/* harmony import */ var _utils_Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/Utils */ "./src/direflow-components/EmailComposer/utils/Utils.ts");







/**
 * QuickReply component to reply mail quickly without any formatting
 * @param defaultValue to display default value in the quick reply input field.
 */
const QuickReply = ({ draftQuickReply, taskId }) => {
    const { email } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const state = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_5__.useEmailStateContext)();
    const dispatch = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_5__.useEmailDispatchContext)();
    const quickReplyInput = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    const stateRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(state);
    stateRef.current = state;
    /**
     * sendHandler  is used to  dispatch SENDING_EMAIL  action to trigger send email rest api.
     */
    const sendHandler = (currentState) => {
        if (state.quickReplyBody.length !== 0) {
            const currState = currentState || state;
            dispatch({
                type: _constants__WEBPACK_IMPORTED_MODULE_4__.SENDING_EMAIL,
                payload: {
                    replyEmail: {
                        subject: currState.content.subject,
                        fromAddress: currState.content.userEmailId,
                        toAddress: [],
                        ccAddress: currState.content.ccAddress.map((id) => id && (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_6__.formatEmail)(id)),
                        replyToAddress: currState.content.userEmailId,
                        contentType: "text/html",
                        body: currState.quickReplyBody
                    }
                }
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (quickReplyInput && quickReplyInput.current && draftQuickReply) {
            quickReplyInput.current.innerHTML = draftQuickReply;
        }
        else {
            quickReplyInput.current.innerHTML = "";
        }
    }, [draftQuickReply, taskId]);
    const shouldSendEmailReply = (key) => {
        return (key.data &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.SEND_EMAIL_KEY &&
            state.mode === _constants__WEBPACK_IMPORTED_MODULE_4__.READ_EMAIL &&
            quickReplyInput.current &&
            quickReplyInput.current.innerHTML !== "");
    };
    const executeEmailShortcuts = (key) => {
        if (shouldSendEmailReply(key)) {
            sendHandler(stateRef.current);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((key) => executeEmailShortcuts(key));
        return () => {
            if (stopListen) {
                stopListen();
            }
        };
    }, []);
    /**
     * Quick reply input change listener to enable disable send button
     * @param event
     */
    const handleInputChange = (event) => {
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_4__.SAVE_REPLY_MESSAGE,
            payload: {
                quickReplyBody: event.target.value
            }
        });
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "quick-reply-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "text", "aria-label": email.QuickReplyInp, id: "quickReplyInp", name: "quickReplyInp", ref: quickReplyInput, value: state.quickReplyBody, onChange: handleInputChange, placeholder: email.QuickReplyInp, tabIndex: 0 }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "quick-reply-send" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "reply-warning", role: "banner", tabIndex: 0, "aria-label": email.replywarning }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", { children: email.replywarning }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ onClick: () => sendHandler(state), variant: "primary", ariaLabel: email.SendLabel, size: 32, part: "button", class: "send-button", id: "quickSendButton" }, (state.quickReplyBody.length === 0 ? { disabled: true } : ""), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-send_16", class: "send-icon" }), email.SendLabel] }))] }))] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuickReply);


/***/ }),

/***/ "./src/direflow-components/EmailComposer/components/index.tsx":
/*!********************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/components/index.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_quill_dist_quill_snow_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/quill/dist/quill.snow.css */ "../../node_modules/@agentx/quill/dist/quill.snow.css");
/* harmony import */ var _agentx_quill_dist_quill_snow_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_quill_dist_quill_snow_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Common/components/ErrorModal */ "./src/direflow-components/Common/components/ErrorModal/index.tsx");
/* harmony import */ var _Common_components_InlineError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Common/components/InlineError */ "./src/direflow-components/Common/components/InlineError.tsx");
/* harmony import */ var _Context_AppContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* harmony import */ var _styles_email_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../styles/email.css */ "./src/direflow-components/EmailComposer/styles/email.css");
/* harmony import */ var _styles_email_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_email_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_EmailReducer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../utils/EmailReducer */ "./src/direflow-components/EmailComposer/utils/EmailReducer.ts");
/* harmony import */ var _utils_EmailRequest__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../utils/EmailRequest */ "./src/direflow-components/EmailComposer/utils/EmailRequest.ts");
/* harmony import */ var _utils_Utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../utils/Utils */ "./src/direflow-components/EmailComposer/utils/Utils.ts");
/* harmony import */ var _Editor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Editor */ "./src/direflow-components/EmailComposer/components/Editor/index.tsx");
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Header */ "./src/direflow-components/EmailComposer/components/Header/index.tsx");
















/**
 * Email Container component which is the root component for email.
 * this component maintain the global state of the email component.
 * This component also handles all the external action e.g. rest api call and external stores.
 */
const EmailComposer = ({ emailprops, taskid: taskId, orgid: orgId, agentname: agentName }) => {
    var _a, _b, _c;
    const { template, pcisettings, cachedemail: cachedEmails, configs, pciAllowedAttachmentTypes } = emailprops;
    const defaultEmail = _utils_Utils__WEBPACK_IMPORTED_MODULE_13__.initialEmailState;
    const [state, dispatch] = (0,_utils_EmailReducer__WEBPACK_IMPORTED_MODULE_11__.InitReducer)(orgId, taskId, agentName, template, defaultEmail);
    const [isCcFiledEnabled, setIsCcFiledEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [errorPageState, setErrorPageState] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [errorCode, setErrorCode] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true);
    const [banner, setBanner] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({ state: false, message: "" });
    const [incomingAttachment, setincomingAttachments] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]);
    const [isTemplateFetchFailed, setIsTemplateFetchFailed] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const dispatchCustomEvent = (0,_Context_AppContext__WEBPACK_IMPORTED_MODULE_8__.useEventContext)();
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const [emailTemplateHeight, setEmailTemplateHeight] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const [ccFieldHeight, setccFieldHeight] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(_constants__WEBPACK_IMPORTED_MODULE_9__.email_ccField_height);
    const [errorModalProps, setErrorModalProps] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        errorModalState: false,
        errorMessageState: "",
        errorModalButtons: [],
        errorModalHeader: "",
        errorModalTrackingID: ""
    });
    const [storageName, setStorageName] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("emm");
    const stateRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(state);
    stateRef.current = state;
    const errorModalCallback = () => {
        setErrorModalProps({
            errorModalState: false,
            errorMessageState: "",
            errorModalButtons: [],
            errorModalHeader: "",
            errorModalTrackingID: ""
        });
    };
    const retryEmailDataFetch = () => {
        (0,_utils_EmailRequest__WEBPACK_IMPORTED_MODULE_12__.fetchEmailContent)(orgId, taskId, setErrorPageState, setErrorCode, setLoading, setStorageName);
        if (isTemplateFetchFailed) {
            (0,_utils_EmailRequest__WEBPACK_IMPORTED_MODULE_12__.fetchEmailTemplate)(orgId, dispatchCustomEvent, setIsTemplateFetchFailed);
        }
    };
    const onUnmoutOfEmail = () => {
        (0,_utils_EmailRequest__WEBPACK_IMPORTED_MODULE_12__.onUnmoutOfEmailComposer)(stateRef, dispatchCustomEvent, setLoading);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        setBanner({ state: false, message: "" });
    }, [state.mode]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        (0,_utils_EmailRequest__WEBPACK_IMPORTED_MODULE_12__.populateFromEmailCache)(cachedEmails, taskId, orgId, setErrorPageState, setErrorCode, setLoading, setStorageName);
    }, [cachedEmails]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        (0,_utils_EmailRequest__WEBPACK_IMPORTED_MODULE_12__.sendMailAndPCIcheck)(configs, orgId, taskId, errorModalCallback, setBanner, setErrorModalProps);
    }, [state.status, state.mode]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        (0,_utils_EmailRequest__WEBPACK_IMPORTED_MODULE_12__.setIncomingAttachment)(state, configs, setincomingAttachments, setBanner);
    }, [state.incomingAttachments]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        (0,_utils_EmailRequest__WEBPACK_IMPORTED_MODULE_12__.fetchAndSaveTemplate)(template, orgId, dispatchCustomEvent, setIsTemplateFetchFailed);
    }, [orgId, taskId]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const newHeight = (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_13__.calculateEmailTemplateHeight)(ref, state, banner.state, isCcFiledEnabled, ccFieldHeight);
        setEmailTemplateHeight(newHeight);
    }, [banner, isCcFiledEnabled, state.mode, ccFieldHeight]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        return onUnmoutOfEmail;
    }, [taskId]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Context_AppContext__WEBPACK_IMPORTED_MODULE_8__.EmailProvider, Object.assign({ dispatch: dispatch, state: state }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: [(_styles_email_css__WEBPACK_IMPORTED_MODULE_10___default()), (_agentx_quill_dist_quill_snow_css__WEBPACK_IMPORTED_MODULE_1___default())] }, { children: state.mode !== _constants__WEBPACK_IMPORTED_MODULE_9__.CANCEL_EMAIL && state.mode !== _constants__WEBPACK_IMPORTED_MODULE_9__.EMAIL_SENT && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "email-template" }, { children: loading && state.mode === _constants__WEBPACK_IMPORTED_MODULE_9__.INIT_MAIL ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "align-item-center" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: 80 }) }))) : (state.mode !== _constants__WEBPACK_IMPORTED_MODULE_9__.INIT_MAIL &&
                        (errorPageState ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_InlineError__WEBPACK_IMPORTED_MODULE_7__["default"], { errorHeaderMsg: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__.getLocalizedMessages)().email.errortext, errorSubMsg: errorCode, retry: retryEmailDataFetch })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ ref: ref }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-alert-banner", Object.assign({ class: "alertBanner" }, (banner.state ? { show: true } : ""), { closable: true, onHide: () => setBanner({ state: false, message: "" }), type: "warning", message: banner.message, "aria-label": banner.message, tabIndex: 0 })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ style: { height: emailTemplateHeight }, className: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
                                        "email-template-read": state.mode === _constants__WEBPACK_IMPORTED_MODULE_9__.READ_EMAIL
                                    }) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_6__["default"], { isOpen: errorModalProps.errorModalState, message: errorModalProps.errorMessageState, buttons: errorModalProps.errorModalButtons, modalHeader: errorModalProps.errorModalHeader, trackingId: errorModalProps.errorModalTrackingID, showCloseButton: false, noExitOnEsc: true }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_15__["default"], { taskId: taskId, fromAddress: state.content.replyToAddress, toAddress: state.content.toAddress, ccAddress: state.content.ccAddress, userEmailId: state.content.userEmailId, subject: state.content.subject, isCcFiledEnabled: setIsCcFiledEnabled, draftCcAddress: (_a = state.replyDraftMode) === null || _a === void 0 ? void 0 : _a.replyCcAddress, ccFieldHeight: setccFieldHeight }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Editor__WEBPACK_IMPORTED_MODULE_14__["default"], { taskId: taskId, emailContent: state.content.emailContent, incomingAttachments: incomingAttachment, outboundAttachments: (0,_utils_Utils__WEBPACK_IMPORTED_MODULE_13__.getOutboundAttachmentsFromCache)(state.replyDraftMode), draftQuickReply: (_b = state.readDraftMode) === null || _b === void 0 ? void 0 : _b.quickReplyBody, draftEmailContent: (_c = state.replyDraftMode) === null || _c === void 0 ? void 0 : _c.replyBody, configs: configs, pcisettings: pcisettings, storageName: storageName, pciAllowedAttachmentTypes: pciAllowedAttachmentTypes })] }))] })))) }))) })) }) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EmailComposer);


/***/ }),

/***/ "./src/direflow-components/EmailComposer/constants.js":
/*!************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/constants.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ATTACHED_FILE: () => (/* binding */ ATTACHED_FILE),
/* harmony export */   ATTACHMENT_FILE_TYPES: () => (/* binding */ ATTACHMENT_FILE_TYPES),
/* harmony export */   BUTTON_SIZE: () => (/* binding */ BUTTON_SIZE),
/* harmony export */   CANCEL_EMAIL: () => (/* binding */ CANCEL_EMAIL),
/* harmony export */   CREDIT_CARD: () => (/* binding */ CREDIT_CARD),
/* harmony export */   EMAIL_SENT: () => (/* binding */ EMAIL_SENT),
/* harmony export */   FILE_TYPE: () => (/* binding */ FILE_TYPE),
/* harmony export */   HTTP_NO_CONTENT_204: () => (/* binding */ HTTP_NO_CONTENT_204),
/* harmony export */   HTTP_SUCCESS_200: () => (/* binding */ HTTP_SUCCESS_200),
/* harmony export */   HTTP_SUCCESS_201: () => (/* binding */ HTTP_SUCCESS_201),
/* harmony export */   HTTP_SUCCESS_412: () => (/* binding */ HTTP_SUCCESS_412),
/* harmony export */   HTTP_SUCCESS_413: () => (/* binding */ HTTP_SUCCESS_413),
/* harmony export */   INIT_MAIL: () => (/* binding */ INIT_MAIL),
/* harmony export */   INVALID_STATUS: () => (/* binding */ INVALID_STATUS),
/* harmony export */   ONE_KILO_BYTE_SIZE: () => (/* binding */ ONE_KILO_BYTE_SIZE),
/* harmony export */   READ_EMAIL: () => (/* binding */ READ_EMAIL),
/* harmony export */   READ_MODE_DRAFT: () => (/* binding */ READ_MODE_DRAFT),
/* harmony export */   REPLY_ALL_EMAIL: () => (/* binding */ REPLY_ALL_EMAIL),
/* harmony export */   REPLY_EMAIL: () => (/* binding */ REPLY_EMAIL),
/* harmony export */   REPLY_MODE_DRAFT: () => (/* binding */ REPLY_MODE_DRAFT),
/* harmony export */   SAVE_OUTBOUND_ATTACHMENT: () => (/* binding */ SAVE_OUTBOUND_ATTACHMENT),
/* harmony export */   SAVE_REPLY_MESSAGE: () => (/* binding */ SAVE_REPLY_MESSAGE),
/* harmony export */   SAVE_TEMPLATE: () => (/* binding */ SAVE_TEMPLATE),
/* harmony export */   SENDING_EMAIL: () => (/* binding */ SENDING_EMAIL),
/* harmony export */   UNMOUNT_EMAIL: () => (/* binding */ UNMOUNT_EMAIL),
/* harmony export */   VALID_STATUS: () => (/* binding */ VALID_STATUS),
/* harmony export */   editorTableOps: () => (/* binding */ editorTableOps),
/* harmony export */   email_ccField_height: () => (/* binding */ email_ccField_height),
/* harmony export */   email_header_height: () => (/* binding */ email_header_height),
/* harmony export */   email_header_reply_all_height: () => (/* binding */ email_header_reply_all_height),
/* harmony export */   email_header_reply_height: () => (/* binding */ email_header_reply_height),
/* harmony export */   email_quick_reply_height: () => (/* binding */ email_quick_reply_height),
/* harmony export */   email_reply_height: () => (/* binding */ email_reply_height)
/* harmony export */ });
const INIT_MAIL = "INIT_MAIL";
const READ_EMAIL = "READ_EMAIL";
const SENDING_EMAIL = "SENDING_EMAIL";
const REPLY_EMAIL = "REPLY_EMAIL";
const REPLY_ALL_EMAIL = "REPLY_ALL_EMAIL";
const CANCEL_EMAIL = "CANCEL_EMAIL";
const VALID_STATUS = "VALID_STATUS";
const INVALID_STATUS = "INVALID_STATUS";
const EMAIL_SENT = "EMAIL_SENT";
const SAVE_TEMPLATE = "SAVE_TEMPLATE";
const SAVE_REPLY_MESSAGE = "SAVE_REPLY_MESSAGE";
const REPLY_MODE_DRAFT = "REPLY_MODE_DRAFT";
const READ_MODE_DRAFT = "READ_MODE_DRAFT";
const UNMOUNT_EMAIL = "UNMOUNT_EMAIL";
const SAVE_OUTBOUND_ATTACHMENT = "SAVE_OUTBOUND_ATTACHMENT";
const BUTTON_SIZE = 40;

/**
 * HTTP response codes
 */
const HTTP_SUCCESS_200 = 200;
const HTTP_SUCCESS_201 = 201;
const HTTP_NO_CONTENT_204 = 204;
const HTTP_SUCCESS_412 = 412;
const HTTP_SUCCESS_413 = 413;

const email_header_height = 81;
const email_header_reply_height = 145;
const email_header_reply_all_height = 192;
const email_quick_reply_height = 117;
const email_reply_height = 67;
const email_ccField_height = 47;

const ONE_KILO_BYTE_SIZE = 1024;

const FILE_TYPE = "File type";
const ATTACHED_FILE = "Attached file";
const CREDIT_CARD = "Credit Card";

const ATTACHMENT_FILE_TYPES = {
  DOCUMENT: ".html, .mhtml, .mht, .odt, .pdf, .pdfxml, .rtf, .shtml, .xps, .xml, .xhtml, .txt",
  EMAIL: ".eml, .msg",
  MICROSOFT:
    ".ods, .dot, .dothtml, .dotx, .dotm," +
    " .pot, .pothtml, .ppthtml, .pptmhtml, .pptxml, .potm, .potx, .pps, .ppam, .ppsm, .ppsx," +
    " .pptx, .pptm, .ppt, .pub, .pubhtml, .pubmhtml, .xls, .xlshtml, .xlthtml, .xlt, .xlsm, .xltx," +
    " .xltm, .xlam, .xlsb, .xlsx"
};

const editorTableOps = [
  "",
  "insertTable",
  "insertRowAbove",
  "insertRowBelow",
  "insertColumnLeft",
  "insertColumnRight",
  "deleteRow",
  "deleteColumn",
  "deleteTable"
];


/***/ }),

/***/ "./src/direflow-components/EmailComposer/styles/email.css":
/*!****************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/styles/email.css ***!
  \****************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../node_modules/css-loader/dist/cjs.js!./email.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/EmailComposer/styles/email.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/EmailComposer/utils/EmailReducer.ts":
/*!*********************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/utils/EmailReducer.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InitReducer: () => (/* binding */ InitReducer),
/* harmony export */   getReducer: () => (/* binding */ getReducer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _Context_AppContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");


let emailReducer;
const InitReducer = (orgId, taskId, agentName, template, defaultEmail) => {
    emailReducer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(_Context_AppContext__WEBPACK_IMPORTED_MODULE_1__.EmailReducer, Object.assign({ orgId,
        taskId,
        agentName,
        template }, defaultEmail));
    return emailReducer;
};
const getReducer = () => emailReducer;


/***/ }),

/***/ "./src/direflow-components/EmailComposer/utils/EmailRequest.ts":
/*!*********************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/utils/EmailRequest.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   dispatchEmailContentCache: () => (/* binding */ dispatchEmailContentCache),
/* harmony export */   fetchAndSaveTemplate: () => (/* binding */ fetchAndSaveTemplate),
/* harmony export */   fetchEmailContent: () => (/* binding */ fetchEmailContent),
/* harmony export */   fetchEmailTemplate: () => (/* binding */ fetchEmailTemplate),
/* harmony export */   onCancelClick: () => (/* binding */ onCancelClick),
/* harmony export */   onUnmoutOfEmailComposer: () => (/* binding */ onUnmoutOfEmailComposer),
/* harmony export */   pciCheck: () => (/* binding */ pciCheck),
/* harmony export */   populateFromEmailCache: () => (/* binding */ populateFromEmailCache),
/* harmony export */   sendEmail: () => (/* binding */ sendEmail),
/* harmony export */   sendMailAndPCIcheck: () => (/* binding */ sendMailAndPCIcheck),
/* harmony export */   setIncomingAttachment: () => (/* binding */ setIncomingAttachment)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../constants */ "./src/direflow-components/EmailComposer/constants.js");
/* harmony import */ var _EmailReducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./EmailReducer */ "./src/direflow-components/EmailComposer/utils/EmailReducer.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Utils */ "./src/direflow-components/EmailComposer/utils/Utils.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





const fetchEmailContent = (orgId, taskId, setErrorPageState, setErrorCode, setLoading, setStorageName) => __awaiter(void 0, void 0, void 0, function* () {
    const [, dispatch] = (0,_EmailReducer__WEBPACK_IMPORTED_MODULE_3__.getReducer)();
    _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.info(`Making email content request for orgId: ${orgId} taskId: ${taskId}`);
    try {
        const emailContent = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.emm.fetchContent({ orgId, taskId });
        setStorageName(emailContent.storageName || "emm");
        // TODO: pass emailContent instead of inboundTranscript
        const storageUrl = emailContent.interactionContext.content.inboundTranscript;
        if (emailContent.storageName === "emm") {
            yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.emm.fetchEmailContentFromEmm(storageUrl).then((data) => {
                emailContent.interactionContext.content.emailContent = data === null || data === void 0 ? void 0 : data.body;
            });
        }
        else if (emailContent.storageName === "s3") {
            yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.mediaStorage.fetchStorageEmailContent(storageUrl).then((data) => {
                emailContent.interactionContext.content.emailContent = data === null || data === void 0 ? void 0 : data.body;
            });
        }
        _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.info(`Email content request success`);
        const content = Object.assign(Object.assign({}, emailContent.interactionContext), { attachmentInfo: emailContent.attachmentInfo, storageName: emailContent.storageName });
        setErrorPageState(false);
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__.VALID_STATUS,
            payload: Object.assign(Object.assign({}, content), { taskId, mode: _constants__WEBPACK_IMPORTED_MODULE_2__.READ_EMAIL })
        });
        setLoading(false);
    }
    catch (error) {
        _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=EmailContentError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)}] Email content request failed: ${error}`, error);
        dispatch({ type: _constants__WEBPACK_IMPORTED_MODULE_2__.INVALID_STATUS, payload: { mode: _constants__WEBPACK_IMPORTED_MODULE_2__.READ_EMAIL } });
        setErrorCode(error.message);
        setLoading(false);
        setErrorPageState(true);
    }
});
const endContact = (taskId, errorModalCallback, setErrorModalProps) => {
    const [, dispatch] = (0,_EmailReducer__WEBPACK_IMPORTED_MODULE_3__.getReducer)();
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .endV2({ interactionId: taskId })
        .then(() => {
        _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.info(`Email task ended`, taskId);
    })
        .catch((err) => {
        _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=EmailEndTaskError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Email task end request failed: ${err}`, err);
        dispatch({ type: _constants__WEBPACK_IMPORTED_MODULE_2__.VALID_STATUS });
        const buttons = [
            {
                label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().common.Cancel,
                onClick: errorModalCallback,
                color: "default"
            },
            { label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().common.tryAgain, callBack: endContact }
        ];
        setErrorModalProps({
            errorModalState: true,
            errorMessageState: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().email.errorendcontact,
            errorModalButtons: buttons,
            errorModalHeader: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().common.Error
        });
    });
};
const sendEmail = (orgId, taskId, errorModalCallback, setErrorModalProps, responseDataContent) => {
    const [state, dispatch] = (0,_EmailReducer__WEBPACK_IMPORTED_MODULE_3__.getReducer)();
    if (responseDataContent) {
        const payload = state.mode === _constants__WEBPACK_IMPORTED_MODULE_2__.READ_EMAIL
            ? {
                quickReplyBody: responseDataContent,
                readDraftMode: Object.assign(Object.assign({}, state.readDraftMode), { quickReplyBody: responseDataContent }),
                status: _constants__WEBPACK_IMPORTED_MODULE_2__.VALID_STATUS
            }
            : {
                replyBody: responseDataContent,
                replyDraftMode: Object.assign(Object.assign({}, state.replyDraftMode), { replyBody: responseDataContent }),
                status: _constants__WEBPACK_IMPORTED_MODULE_2__.VALID_STATUS
            };
        dispatch({ type: _constants__WEBPACK_IMPORTED_MODULE_2__.SAVE_REPLY_MESSAGE, payload });
    }
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.emm
        .sendEmail({ orgId, taskId, data: state.replyEmail })
        .then(() => {
        _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.info(`Email send request success`);
        dispatch({ type: _constants__WEBPACK_IMPORTED_MODULE_2__.VALID_STATUS, payload: { mode: _constants__WEBPACK_IMPORTED_MODULE_2__.EMAIL_SENT } });
        endContact(taskId, errorModalCallback, setErrorModalProps);
    })
        .catch((error) => {
        _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=sendMailError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)}] Email send request failed:', ${error}`, error);
        dispatch({ type: _constants__WEBPACK_IMPORTED_MODULE_2__.INVALID_STATUS });
        setErrorModalProps({
            errorModalState: true,
            errorMessageState: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().email.errorsendemail,
            errorModalButtons: [
                {
                    label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().common.okButton,
                    onClick: errorModalCallback
                }
            ],
            errorModalHeader: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().common.Error,
            errorModalTrackingID: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)
        });
    });
};
const onCancelClick = (errorModalCallback) => {
    const [, dispatch] = (0,_EmailReducer__WEBPACK_IMPORTED_MODULE_3__.getReducer)();
    dispatch({ type: _constants__WEBPACK_IMPORTED_MODULE_2__.VALID_STATUS });
    errorModalCallback();
};
const pciCheck = (orgId, taskId, errorModalCallback, setBanner, setErrorModalProps) => {
    const [state, dispatch] = (0,_EmailReducer__WEBPACK_IMPORTED_MODULE_3__.getReducer)();
    let response;
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.pci
        .pciCheck({ data: { content: state.replyEmail.body } }, (x) => {
        response = { data: x.data, status: x.status };
    })
        .then(() => {
        _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.info(`PCI Content check Request Success`, response);
        if (response.status === 202) {
            const buttons = [
                {
                    label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().common.Cancel,
                    onClick: onCancelClick.bind({}, errorModalCallback),
                    color: "default"
                },
                {
                    label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().common.Yes,
                    onClick: sendEmail.bind({}, orgId, taskId, errorModalCallback, setErrorModalProps, response.data.content)
                }
            ];
            setBanner({
                state: true,
                message: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().email.pcibannerwarning
            });
            setErrorModalProps({
                errorModalState: true,
                errorMessageState: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().email.datamasked,
                errorModalButtons: buttons,
                errorModalHeader: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().common.ErrorSecurityCompliance
            });
        }
        else if (response.status === 200) {
            sendEmail(orgId, taskId, errorModalCallback, setErrorModalProps, response.data.content);
        }
    })
        .catch((err) => {
        _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=PCIContentCheckError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] PCI Content check request failed: ${err}`, err);
        dispatch({ type: _constants__WEBPACK_IMPORTED_MODULE_2__.VALID_STATUS });
        setErrorModalProps({
            errorModalState: true,
            errorMessageState: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().email.errorpcicheckemail,
            errorModalButtons: [
                {
                    label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().common.okButton,
                    onClick: errorModalCallback
                }
            ],
            errorModalHeader: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().common.Error,
            errorModalTrackingID: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)
        });
    });
};
const fetchEmailTemplate = (orgId, dispatchCustomEvent, setIsTemplateFetchFailed) => {
    const [, dispatch] = (0,_EmailReducer__WEBPACK_IMPORTED_MODULE_3__.getReducer)();
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.emm
        .fetchReplyTemplate({ orgId })
        .then((emailTemplateData) => {
        // dispatch Event to save template in context
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__.SAVE_TEMPLATE,
            payload: { template: emailTemplateData }
        });
        // dispatch Custom Event to save template in Agent-X Store
        const event = new CustomEvent("ax-email-template-fetched", {
            detail: { template: emailTemplateData },
            bubbles: true,
            composed: true
        });
        if (dispatchCustomEvent) {
            dispatchCustomEvent(event);
        }
        setIsTemplateFetchFailed(false);
    })
        .catch((error) => {
        setIsTemplateFetchFailed(true);
        _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=FetchEmailTemplateError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)}] Failed to fetch email template for orgID: ${orgId} message: ${error.message}`);
    });
};
const fetchAndSaveTemplate = (template, orgId, dispatchCustomEvent, setIsTemplateFetchFailed) => {
    const [, dispatch] = (0,_EmailReducer__WEBPACK_IMPORTED_MODULE_3__.getReducer)();
    if (!template.emailTemplate) {
        fetchEmailTemplate(orgId, dispatchCustomEvent, setIsTemplateFetchFailed);
    }
    else {
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__.SAVE_TEMPLATE,
            payload: { template }
        });
        setIsTemplateFetchFailed(false);
    }
};
const setIncomingAttachment = (state, configs, setincomingAttachments, setBanner) => {
    const attachments = state.incomingAttachments ? state.incomingAttachments : [];
    if (configs.isPCIComplianceEnabled) {
        const newAttachments = [];
        attachments.forEach((attachment) => {
            if (attachment.isCompliant) {
                newAttachments.push(attachment);
            }
        });
        if (attachments.length === newAttachments.length) {
            setincomingAttachments(attachments);
        }
        else {
            setincomingAttachments(newAttachments);
            setBanner({
                state: true,
                message: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().email.errorattachmentdrop
            });
        }
    }
    else {
        setincomingAttachments(attachments);
    }
};
const onUnmoutOfEmailComposer = (stateRef, dispatchCustomEvent, setLoading) => {
    const [state, dispatch] = (0,_EmailReducer__WEBPACK_IMPORTED_MODULE_3__.getReducer)();
    if ([_constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_EMAIL, _constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_ALL_EMAIL, _constants__WEBPACK_IMPORTED_MODULE_2__.READ_EMAIL].includes(state.mode)) {
        const payload = {
            taskId: state.taskId,
            replyBody: state.mode === _constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_EMAIL || state.mode === _constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_ALL_EMAIL ? state.replyBody : "",
            quickReplyBody: state.mode === _constants__WEBPACK_IMPORTED_MODULE_2__.READ_EMAIL ? state.quickReplyBody : "",
            mode: state.mode,
            replyCcAddress: state.mode === _constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_EMAIL || state.mode === _constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_ALL_EMAIL ? state.replyCcAddress : [],
            content: JSON.stringify(state.content),
            incomingAttachments: state.incomingAttachments,
            attachmentInfo: state.attachmentInfo,
            status: state.status,
            outboundAttachments: state.outboundAttachments
        };
        const cEvent = new CustomEvent("ax-email-draft-content", {
            detail: payload,
            bubbles: true,
            composed: true
        });
        if (dispatchCustomEvent) {
            dispatchCustomEvent(cEvent);
        }
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__.UNMOUNT_EMAIL,
            payload: Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_4__.initialEmailState), { readDraftMode: {}, replyDraftMode: {}, replyCcAddress: [] })
        });
        setLoading(true);
    }
};
const dispatchEmailContentCache = (cache) => {
    const [, dispatch] = (0,_EmailReducer__WEBPACK_IMPORTED_MODULE_3__.getReducer)();
    _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.info(`Updating email cache:`);
    const newObj = {
        readDraftMode: cache.mode === _constants__WEBPACK_IMPORTED_MODULE_2__.READ_EMAIL ? cache : {},
        replyDraftMode: cache.mode === _constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_EMAIL || cache.mode === _constants__WEBPACK_IMPORTED_MODULE_2__.REPLY_ALL_EMAIL ? cache : {}
    };
    dispatch({
        type: cache.status,
        payload: Object.assign(Object.assign({}, cache), newObj)
    });
};
const populateFromEmailCache = (cachedEmails, taskId, orgId, setErrorPageState, setErrorCode, setLoading, setStorageName) => {
    if (cachedEmails) {
        const cachedEmail = cachedEmails[taskId];
        if (cachedEmail) {
            _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.info("Email content loaded from cache");
            cachedEmail.content = cachedEmail.content ? JSON.parse(cachedEmail.content) : "";
            dispatchEmailContentCache(cachedEmail);
            setLoading(false);
        }
        else {
            fetchEmailContent(orgId, taskId, setErrorPageState, setErrorCode, setLoading, setStorageName);
        }
    }
};
const sendMailAndPCIcheck = (configs, orgId, taskId, errorModalCallback, setBanner, setErrorModalProps) => {
    const [state] = (0,_EmailReducer__WEBPACK_IMPORTED_MODULE_3__.getReducer)();
    if (state.status === _constants__WEBPACK_IMPORTED_MODULE_2__.SENDING_EMAIL) {
        _Utils__WEBPACK_IMPORTED_MODULE_4__.logger.info(`Making send email request for orgId: ${orgId} taskId: ${taskId}`);
        if (configs.isPCIComplianceEnabled) {
            pciCheck(orgId, taskId, errorModalCallback, setBanner, setErrorModalProps);
        }
        else {
            sendEmail(orgId, taskId, errorModalCallback, setErrorModalProps, null);
        }
    }
};


/***/ }),

/***/ "./src/direflow-components/EmailComposer/utils/Utils.ts":
/*!**************************************************************!*\
  !*** ./src/direflow-components/EmailComposer/utils/Utils.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addMailIdSeparator: () => (/* binding */ addMailIdSeparator),
/* harmony export */   calculateEmailTemplateHeight: () => (/* binding */ calculateEmailTemplateHeight),
/* harmony export */   formatEmail: () => (/* binding */ formatEmail),
/* harmony export */   getOutboundAttachmentsFromCache: () => (/* binding */ getOutboundAttachmentsFromCache),
/* harmony export */   initialEmailState: () => (/* binding */ initialEmailState),
/* harmony export */   initialTemplateState: () => (/* binding */ initialTemplateState),
/* harmony export */   isReadMode: () => (/* binding */ isReadMode),
/* harmony export */   isReplyMode: () => (/* binding */ isReplyMode),
/* harmony export */   logger: () => (/* binding */ logger),
/* harmony export */   updateEmailCache: () => (/* binding */ updateEmailCache),
/* harmony export */   validateEmailId: () => (/* binding */ validateEmailId),
/* harmony export */   validateEmailIds: () => (/* binding */ validateEmailIds)
/* harmony export */ });
/* harmony import */ var validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! validator/lib/isEmail */ "../../node_modules/validator/lib/isEmail.js");
/* harmony import */ var validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants */ "./src/direflow-components/EmailComposer/constants.js");



const logger = (0,_sdk__WEBPACK_IMPORTED_MODULE_0__.createLogger)("[EmailComposer]");
const initialEmailState = {
    status: _constants__WEBPACK_IMPORTED_MODULE_1__.VALID_STATUS,
    mode: _constants__WEBPACK_IMPORTED_MODULE_1__.INIT_MAIL,
    content: {
        emailContent: "",
        inboundTranscript: "",
        subject: "",
        toAddress: [],
        inReplyTo: "",
        ccAddress: [],
        userEmailId: "",
        references: "",
        contentType: "",
        date: "",
        replyToAddress: "",
        messageId: "",
        from: ""
    },
    replyEmail: {
        subject: "",
        fromAddress: "",
        replyToAddress: "",
        contentType: "",
        body: ""
    },
    incomingAttachments: [],
    outboundAttachments: [],
    attachmentInfo: undefined,
    replyBody: "",
    quickReplyBody: ""
};
const initialTemplateState = {
    defaultValues: {
        defaultTypeCustomer: "",
        defaultTypeForCustomer: false,
        defaultTypeAgent: "",
        defaultTypeForAgent: false
    },
    emailTemplate: ""
};
/**
 * validate if provided email is in correct format or not
 * @param emailId
 */
const validateEmailId = (emailId) => validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2___default()(emailId.trim());
/**
 * validate if email id has valid format
 * @param emailIds
 */
const validateEmailIds = (emailIds) => emailIds.every((id) => {
    return id.trim() !== "" ? validateEmailId(id) : true;
});
/**
 * Extract email id only from email addresses which as name concatenated in it.
 * eg. "John Doe <johnd@mail.com>". this regex will extract johnd@mail.com
 * @param emailId
 */
const formatEmail = (emailId) => {
    let emailFound = "";
    if (emailId) {
        const emailIdTrimmed = emailId.trim();
        // allow_display_name will allow the email to have user name.
        const emailMatch = validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2___default()(emailIdTrimmed, { allow_display_name: true });
        const indexleftArrow = emailIdTrimmed.indexOf("<");
        const indexRightArrow = emailIdTrimmed.indexOf(">");
        if (emailMatch && indexleftArrow > 0 && indexRightArrow > 0) {
            emailFound = emailIdTrimmed.substring(indexleftArrow + 1, indexRightArrow).trim();
        }
        else if (emailMatch) {
            emailFound = emailIdTrimmed;
        }
    }
    return emailFound;
};
/**
 * add semi colon as email id separator
 * @param emailIds
 */
const addMailIdSeparator = (emailIds) => {
    if (emailIds) {
        return emailIds.map((id) => formatEmail(id)).join("; ");
    }
    return "";
};
const updateEmailCache = (eventKey, payload, dispatchCustomEvent) => {
    const cEvent = new CustomEvent(eventKey, {
        detail: payload,
        bubbles: true,
        composed: true
    });
    if (dispatchCustomEvent) {
        dispatchCustomEvent(cEvent);
    }
};
const isReplyMode = (mode) => mode === _constants__WEBPACK_IMPORTED_MODULE_1__.REPLY_EMAIL || mode === _constants__WEBPACK_IMPORTED_MODULE_1__.REPLY_ALL_EMAIL;
const isReadMode = (mode) => mode === _constants__WEBPACK_IMPORTED_MODULE_1__.READ_EMAIL;
const calculateEmailTemplateHeight = (ref, state, banner, isCcFiledEnabled, ccFieldHeight) => {
    let newHeight = "100%";
    let bannerHeight;
    if (ref && ref.current) {
        bannerHeight = ref.current.clientHeight;
    }
    else {
        bannerHeight = 62; // just being more careful if anytime we don'y get banner height
    }
    if (state.mode === _constants__WEBPACK_IMPORTED_MODULE_1__.READ_EMAIL && banner && state.incomingAttachments && state.incomingAttachments.length > 0) {
        // case of READ EMAIL mode and incoming attachment and some PCI banner is present
        newHeight = `calc(100% - ${_constants__WEBPACK_IMPORTED_MODULE_1__.email_header_height + _constants__WEBPACK_IMPORTED_MODULE_1__.email_quick_reply_height + bannerHeight + 80}px )`;
    }
    else if (state.mode === _constants__WEBPACK_IMPORTED_MODULE_1__.READ_EMAIL && banner) {
        newHeight = `calc(100% - ${_constants__WEBPACK_IMPORTED_MODULE_1__.email_header_height + _constants__WEBPACK_IMPORTED_MODULE_1__.email_quick_reply_height + bannerHeight}px )`;
    }
    else if (state.mode === _constants__WEBPACK_IMPORTED_MODULE_1__.READ_EMAIL && state.incomingAttachments && state.incomingAttachments.length > 0) {
        // case of READ EMAIL mode and incoming attachment is present
        newHeight = `calc(100% - ${_constants__WEBPACK_IMPORTED_MODULE_1__.email_header_height + _constants__WEBPACK_IMPORTED_MODULE_1__.email_quick_reply_height + 80}px )`;
    }
    else if (state.mode === _constants__WEBPACK_IMPORTED_MODULE_1__.READ_EMAIL) {
        newHeight = `calc(100% - ${_constants__WEBPACK_IMPORTED_MODULE_1__.email_header_height + _constants__WEBPACK_IMPORTED_MODULE_1__.email_quick_reply_height}px )`;
    }
    else if (state.mode !== _constants__WEBPACK_IMPORTED_MODULE_1__.READ_EMAIL && banner && isCcFiledEnabled) {
        newHeight = `calc(100% - ${_constants__WEBPACK_IMPORTED_MODULE_1__.email_header_reply_height + ccFieldHeight + bannerHeight + _constants__WEBPACK_IMPORTED_MODULE_1__.email_reply_height}px )`;
    }
    else if (state.mode !== _constants__WEBPACK_IMPORTED_MODULE_1__.READ_EMAIL && banner && !isCcFiledEnabled) {
        newHeight = `calc(100% - ${_constants__WEBPACK_IMPORTED_MODULE_1__.email_header_reply_height + bannerHeight + _constants__WEBPACK_IMPORTED_MODULE_1__.email_reply_height}px )`;
    }
    else if (state.mode !== _constants__WEBPACK_IMPORTED_MODULE_1__.READ_EMAIL && isCcFiledEnabled) {
        newHeight = `calc(100% - ${_constants__WEBPACK_IMPORTED_MODULE_1__.email_header_reply_height + ccFieldHeight + _constants__WEBPACK_IMPORTED_MODULE_1__.email_reply_height}px )`;
    }
    else if (state.mode !== _constants__WEBPACK_IMPORTED_MODULE_1__.READ_EMAIL && !isCcFiledEnabled) {
        newHeight = `calc(100% - ${_constants__WEBPACK_IMPORTED_MODULE_1__.email_header_reply_height + _constants__WEBPACK_IMPORTED_MODULE_1__.email_reply_height}px )`;
    }
    return newHeight;
};
const getOutboundAttachmentsFromCache = (replyDraft) => {
    if (replyDraft && Object.keys(replyDraft).length > 0) {
        return replyDraft.outboundAttachments ? replyDraft.outboundAttachments : [];
    }
    return [];
};


/***/ }),

/***/ "./src/direflow-components/InteractionControl/AccordionHelper.tsx":
/*!************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/AccordionHelper.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   announceBadgeStatus: () => (/* binding */ announceBadgeStatus),
/* harmony export */   checkForFC: () => (/* binding */ checkForFC),
/* harmony export */   checkIsEditable: () => (/* binding */ checkIsEditable),
/* harmony export */   contentClassMap: () => (/* binding */ contentClassMap),
/* harmony export */   createCADMap: () => (/* binding */ createCADMap),
/* harmony export */   defineInteractionBadge: () => (/* binding */ defineInteractionBadge),
/* harmony export */   defineInteractionButton: () => (/* binding */ defineInteractionButton),
/* harmony export */   getInteractionControlShortcutKeys: () => (/* binding */ getInteractionControlShortcutKeys),
/* harmony export */   getOtherAgentTitleInTwoPartyConference: () => (/* binding */ getOtherAgentTitleInTwoPartyConference),
/* harmony export */   getRightSplitBadgeText: () => (/* binding */ getRightSplitBadgeText),
/* harmony export */   getTaskName: () => (/* binding */ getTaskName),
/* harmony export */   handleTimeOutForCallBack: () => (/* binding */ handleTimeOutForCallBack),
/* harmony export */   interactionControlTitleClassMap: () => (/* binding */ interactionControlTitleClassMap),
/* harmony export */   isContactTimer: () => (/* binding */ isContactTimer),
/* harmony export */   updateCadList: () => (/* binding */ updateCadList),
/* harmony export */   updateCadListFromCADIMIDigital: () => (/* binding */ updateCadListFromCADIMIDigital),
/* harmony export */   updateCadListFromConfig: () => (/* binding */ updateCadListFromConfig)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../AgentStateSelector/StateTimer */ "./src/direflow-components/AgentStateSelector/StateTimer.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../InteractionPopoverManager/Utils/InteractionPopoversUtils */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts");
/* harmony import */ var _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Utility/Utils/InteractionControlUtils */ "./src/direflow-components/Utility/Utils/InteractionControlUtils.ts");
/* harmony import */ var _components_InteractionButton_InteractionButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/InteractionButton/InteractionButton */ "./src/direflow-components/InteractionControl/components/InteractionButton/InteractionButton.tsx");
/* harmony import */ var _components_MidCallMonitoringSplitBadge__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/MidCallMonitoringSplitBadge */ "./src/direflow-components/InteractionControl/components/MidCallMonitoringSplitBadge.tsx");
/* harmony import */ var _components_ParticipantsBadge__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/ParticipantsBadge */ "./src/direflow-components/InteractionControl/components/ParticipantsBadge.tsx");
/* harmony import */ var _components_ParticipantsBadgeForConference__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components/ParticipantsBadgeForConference */ "./src/direflow-components/InteractionControl/components/ParticipantsBadgeForConference.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");

/* eslint-disable no-param-reassign */













const contentClassMap = (isExpanded) => {
    return classnames__WEBPACK_IMPORTED_MODULE_2___default()("interaction-control-content", {
        "interaction-control-display": isExpanded
    });
};
const interactionControlTitleClassMap = (isExpanded) => {
    return classnames__WEBPACK_IMPORTED_MODULE_2___default()("interaction-control-title", {
        "interaction-expanded": isExpanded
    });
};
const ONLY_ONE_EXTRA_PARTICIPANT = 2;
const WrapUp = "wrapUp";
const createCADMap = (displayName, name, agentEditable, agentViewable, value, type, isCopied, isShowCopy, isSecure, secureKeyId, secureKeyVersion
// eslint-disable-next-line max-params
) => {
    return {
        displayName,
        name,
        agentEditable,
        agentViewable,
        value,
        type,
        isCopied,
        isShowCopy,
        isSecure,
        secureKeyId,
        secureKeyVersion
    };
};
const updateCadObject = (cadList, contactInformation, item) => {
    if ((item === _constants__WEBPACK_IMPORTED_MODULE_12__.DEST_AGENT_NAME || item === _constants__WEBPACK_IMPORTED_MODULE_12__.DEST_AGENT_PHONE_NUMBER) && contactInformation[item]) {
        cadList[item] = createCADMap(item, item, false, true /* passing true since name and number are always agent viewable */, contactInformation[item], contactInformation[item].type, false, false, contactInformation[item].isSecure || false, contactInformation[item].secureKeyId || "", contactInformation[item].secureKeyVersion || 0);
    }
};
const getInteractionControlShortcutKeys = () => {
    return [
        {
            modifierKeys: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT,
            key: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.HOLD_RESUME_CALL_KEY,
            actionButtons: [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.HOLD_BUTTON, _Common_constants__WEBPACK_IMPORTED_MODULE_4__.RESUME_BUTTON]
        },
        {
            modifierKeys: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT,
            key: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.TRANSFER_KEY,
            actionButtons: [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.TRANSFER_BUTTON]
        },
        {
            modifierKeys: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT,
            key: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.CONSULT_KEY,
            actionButtons: [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT_BUTTON]
        },
        {
            modifierKeys: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT,
            key: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.END_KEY,
            actionButtons: [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.END_BUTTON]
        },
        {
            modifierKeys: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT,
            key: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.CONFERENCE_KEY,
            actionButtons: [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONFERENCE_BUTTON]
        },
        {
            modifierKeys: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_SHIFT,
            key: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.PAUSE_RESUME_RECORDING_KEY,
            actionButtons: [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.RECORDINGPAUSE_BUTTON, _Common_constants__WEBPACK_IMPORTED_MODULE_4__.RECORDINGRESUME_BUTTON]
        },
        {
            modifierKeys: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT,
            key: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_DTMF_KEYPAD,
            actionButtons: [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.KEYPAD_BUTTON]
        },
        {
            modifierKeys: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_SHIFT,
            key: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_STATE_SELECTOR_KEY,
            actionButtons: [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.MUTE_BUTTON, _Common_constants__WEBPACK_IMPORTED_MODULE_4__.UNMUTE_BUTTON]
        }
    ];
};
const notAddCustomerDetailsToCad = (mediaType) => {
    return mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.VOICE || mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.OUTBOUND_VOICE;
};
const updateMonitoringVariables = (contactInformation, cadVariables) => {
    cadVariables.forEach((variable) => {
        if (!contactInformation[variable]) {
            contactInformation[variable] = _Common_constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_COLUMN_VALUE;
        }
    });
};
const updateCadList = (cadList, contactInformation, agentId, isConsultView, cadVariables, isMPCEnabled) => {
    // set Monitoring variables to "-" in case of no value from rtd
    if (contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.MIDCALL_MONITORING) {
        updateMonitoringVariables(contactInformation, cadVariables);
    }
    if ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_7__.isAgentConsulting)(contactInformation, isMPCEnabled) &&
        (contactInformation.state === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULTING.toLowerCase() || contactInformation.state === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.STATE_POST_CALL) &&
        isConsultView) {
        /* update cad for consult-view pane. */
        Object.keys(contactInformation).forEach((item) => {
            updateCadObject(cadList, contactInformation, item);
        });
    }
    else {
        Object.keys(contactInformation).forEach((item) => {
            var _a, _b, _c, _d, _e, _f;
            if (!notAddCustomerDetailsToCad(contactInformation.mediaType) && cadVariables.includes(item)) {
                if (item === _constants__WEBPACK_IMPORTED_MODULE_12__.CUSTOMER_NAME &&
                    contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.SOCIAL &&
                    contactInformation.customerName) {
                    cadList[item] = createCADMap(item, item, false, true, contactInformation.customerName, "STRING", false, false, false, "", 0);
                }
                else if (contactInformation[item] && contactInformation[item] !== "") {
                    cadList[item] = createCADMap(item, item, false, true, contactInformation[item], contactInformation[item].type, false, false, ((_a = contactInformation[item]) === null || _a === void 0 ? void 0 : _a.isSecure) || false, ((_b = contactInformation[item]) === null || _b === void 0 ? void 0 : _b.secureKeyId) || "", ((_c = contactInformation[item]) === null || _c === void 0 ? void 0 : _c.secureKeyVersion) || 0);
                }
                else if (contactInformation.mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.EMAIL &&
                    contactInformation.mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.VOICE &&
                    contactInformation.mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.OUTBOUND_VOICE) {
                    cadList[item] = createCADMap(item, item, false, true, "N/A", "STRING", false, false, ((_d = contactInformation[item]) === null || _d === void 0 ? void 0 : _d.isSecure) || false, ((_e = contactInformation[item]) === null || _e === void 0 ? void 0 : _e.secureKeyId) || "", ((_f = contactInformation[item]) === null || _f === void 0 ? void 0 : _f.secureKeyVersion) || 0);
                }
            }
            /* adds destAgentDn and destAgentName to CAD variable as Agent DN and Agent Name. */
            if ((contactInformation.state === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONFERENCE.toLowerCase() || !contactInformation.isOwner) &&
                contactInformation.mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.MIDCALL_MONITORING &&
                (!isMPCEnabled || contactInformation.state !== _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONFERENCE.toLowerCase())) {
                updateCadObject(cadList, contactInformation, item);
            }
        });
    }
};
const checkIsEditable = (configCadVariables, name, isSecondaryEpDnAgent) => {
    const selectedItem = configCadVariables && configCadVariables.find((item) => item.name === name);
    if (selectedItem && selectedItem.agentEditable && !isSecondaryEpDnAgent) {
        return true;
    }
    return false;
};
const checkForFC = (isFcManaged, configCadVariables, callAssociatedData, name, isSecondaryEpDnAgent, mediaType) => {
    if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.MIDCALL_MONITORING) {
        return false;
    }
    if (isFcManaged === false) {
        return checkIsEditable(configCadVariables, name, isSecondaryEpDnAgent);
    }
    return callAssociatedData[name].agentEditable && !isSecondaryEpDnAgent;
};
const getCadListFormat = (item, callAssociatedDataTemp, configCadVariables, isFcManaged, isSecondaryEpDnAgent, mediaType) => {
    const cadItem = Object.assign({}, callAssociatedDataTemp[item]);
    return createCADMap(cadItem.displayName, cadItem.name, checkForFC(isFcManaged, configCadVariables, callAssociatedDataTemp, item, isSecondaryEpDnAgent, mediaType), cadItem.agentViewable, cadItem.value, cadItem.type, false, false, cadItem.isSecure || false, cadItem.secureKeyId || "", cadItem.secureKeyVersion || 0);
};
const updateCadListFromConfig = (cadList, cadSuppressedList, configCadVariables, callAssociatedData, isFcManaged, isGlobalVariablesEnabled, isSecondaryEpDnAgent, mediaType, fcDesktopViewCad) => {
    const callAssociatedDataTemp = Object.assign({}, callAssociatedData);
    /* filter cadSuppressedList from callAssociatedData */
    Object.keys(callAssociatedDataTemp).forEach((item) => {
        if (!isGlobalVariablesEnabled && cadSuppressedList && cadSuppressedList.includes(item.toLowerCase())) {
            delete callAssociatedDataTemp[item];
        }
        if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.MIDCALL_MONITORING && _constants__WEBPACK_IMPORTED_MODULE_12__.duplicateMCMVariables.includes(item)) {
            delete callAssociatedDataTemp[item];
        }
    });
    /* add only cadList from FC_DESKTOP_VIEW with sequence */
    const formatedFcDesktopViewCad = typeof fcDesktopViewCad === "string" ? JSON.parse(fcDesktopViewCad) : fcDesktopViewCad;
    if (formatedFcDesktopViewCad &&
        Object.keys(formatedFcDesktopViewCad).length > 0 &&
        formatedFcDesktopViewCad[_Common_constants__WEBPACK_IMPORTED_MODULE_4__.INTERACTION_PANEL].length > 0) {
        const sortedCadValue = formatedFcDesktopViewCad[_Common_constants__WEBPACK_IMPORTED_MODULE_4__.INTERACTION_PANEL].sort((a, b) => Number(a.variableSeq) - Number(b.variableSeq));
        sortedCadValue.forEach((varSeq) => {
            if (callAssociatedDataTemp[varSeq.name]) {
                cadList[varSeq.name] = getCadListFormat(varSeq.name, callAssociatedDataTemp, configCadVariables, isFcManaged, isSecondaryEpDnAgent, mediaType);
            }
        });
    }
    else {
        /* order cadList on base of voiceCustomerVariables */
        _constants__WEBPACK_IMPORTED_MODULE_12__.voiceCustomerVariables.forEach((item) => {
            if (callAssociatedDataTemp[item]) {
                if (item === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.RONA_TIMEOUT ||
                    (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.MIDCALL_MONITORING && _constants__WEBPACK_IMPORTED_MODULE_12__.duplicateMCMVariables.includes(item))) {
                    delete callAssociatedDataTemp[item]; // remove ronaTime from cadVariable.
                }
                else {
                    cadList[item] = getCadListFormat(item, callAssociatedDataTemp, configCadVariables, isFcManaged, isSecondaryEpDnAgent, mediaType);
                    delete callAssociatedDataTemp[item];
                }
            }
        });
        /* add remaining callAssociatedDataTemp to cadList. */
        Object.keys(callAssociatedDataTemp).forEach((item) => {
            cadList[item] = getCadListFormat(item, callAssociatedDataTemp, configCadVariables, isFcManaged, isSecondaryEpDnAgent, mediaType);
        });
    }
};
/*
 * Method which computes the cadList from CallAssociatedData associated with the interaction.
 * This method should be used only for IMI Digital channels where the interaction control shows the CAD.
 */
const updateCadListFromCADIMIDigital = (cadList, cadSuppressedList, callAssociatedData) => {
    const callAssociatedDataTemp = Object.assign({}, callAssociatedData);
    // Remove the variables which are part of CAD Suppressed List.
    Object.keys(callAssociatedDataTemp).forEach((item) => {
        if (cadSuppressedList && cadSuppressedList.includes(item.toLowerCase())) {
            delete callAssociatedDataTemp[item];
        }
    });
    // Position the customer variables to top of the list.
    _constants__WEBPACK_IMPORTED_MODULE_12__.imiDigitalCustomerVariables.forEach((item) => {
        if (callAssociatedDataTemp[item]) {
            cadList[item] = createCADMap(callAssociatedDataTemp[item].displayName, callAssociatedDataTemp[item].name, callAssociatedDataTemp[item].agentEditable, callAssociatedDataTemp[item].agentViewable, callAssociatedDataTemp[item].value, callAssociatedDataTemp[item].type, false, false, callAssociatedDataTemp[item].isSecure || false, callAssociatedDataTemp[item].secureKeyId || "", callAssociatedDataTemp[item].secureKeyVersion || 0);
            // delete customer details from cad
            delete callAssociatedDataTemp[item];
        }
    });
    // construct the UI CAD Map from CallAssociatedData
    Object.keys(callAssociatedDataTemp).forEach((item) => {
        cadList[item] = createCADMap(callAssociatedDataTemp[item].displayName, callAssociatedDataTemp[item].name, callAssociatedDataTemp[item].agentEditable, callAssociatedDataTemp[item].agentViewable, callAssociatedDataTemp[item].value, callAssociatedDataTemp[item].type, false, false, callAssociatedDataTemp[item].isSecure || false, callAssociatedDataTemp[item].secureKeyId || "", callAssociatedDataTemp[item].secureKeyVersion || 0);
    });
};
const isContactTimer = (contactInfo, isConsultView, isMPCEnabled, agentCallMonitoringState, isConferenceBadge = false) => {
    return (isConferenceBadge ||
        contactInfo.isConferencing ||
        contactInfo.isConsulted ||
        contactInfo.isWrapUp ||
        contactInfo.isHold ||
        (contactInfo.consultHold && isConsultView) ||
        (!(0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_7__.isAgentConsulting)(contactInfo, isMPCEnabled) && contactInfo.state === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULTING.toLowerCase()) ||
        contactInfo.state === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT.toLowerCase() ||
        contactInfo.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.MIDCALL_MONITORING ||
        (agentCallMonitoringState && (agentCallMonitoringState === null || agentCallMonitoringState === void 0 ? void 0 : agentCallMonitoringState.monitoringType) === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.BARGE_IN_MONITORING_STATE) ||
        contactInfo.isWrapUpAssist ||
        contactInfo.isInteractionInPostCall);
};
const getOtherAgentTitleInTwoPartyConference = (contactInformation, agentId) => {
    const participantsArray = Object.values(contactInformation.primaryMediaParticipants);
    const otherAgent = participantsArray.find((participant) => participant.agentId !== agentId);
    return otherAgent
        ? otherAgent.agentName || otherAgent.agentPhoneNumber || otherAgent.agentId
        : contactInformation.destAgentName || undefined;
};
const getTaskName = (contactInformation, isConsultView, agentId) => {
    const { mediaType, contactDirection } = contactInformation;
    if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.VOICE &&
        isConsultView &&
        contactInformation.destAgentId &&
        contactInformation.destAgentId !== agentId) {
        return contactInformation.destAgentName || contactInformation.destAgentPhoneNumber;
    }
    if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.VOICE) {
        return contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.INBOUND ? contactInformation.displayAni : contactInformation.dnis;
    }
    if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.SOCIAL) {
        if (contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.OUTBOUND) {
            return contactInformation.dnis;
        }
        return contactInformation.customerName ? contactInformation.customerName : contactInformation.appUser;
    }
    if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.EMAIL) {
        if (contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.OUTBOUND) {
            return contactInformation.dnis;
        }
        return contactInformation.customerName;
    }
    if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.MIDCALL_MONITORING) {
        return contactInformation.monitoringOwnerName || contactInformation.ownerName;
    }
    return contactInformation.customerName;
};
const defineInteractionButton = (interactionButtons = [], contactInformation, interactionControl, action, buttonProperties, dtmfValue, isPersistCallOrMPCEnabled, isInteractionBtnConfirmDialogEnabled, isConsultPanelVisualUpdateEnabled, webexCallingCallId) => {
    const { showLoaderButtonType, updateButtonProgressFlag, areCompactButtons, focusOnInteractionButton, setEmptyFocusOnInteractionButton } = buttonProperties;
    return interactionButtons.map((button, i) => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_InteractionButton_InteractionButton__WEBPACK_IMPORTED_MODULE_8__["default"], { button: button, buttonIndex: i, contactInformation: contactInformation, interactionControl: interactionControl, action: action, showLoaderButtonType: showLoaderButtonType, updateButtonProgressFlag: updateButtonProgressFlag, areCompactButtons: areCompactButtons, getAgentAction: _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_13__.getAgentAction, focusOnInteractionButton: focusOnInteractionButton, dtmfValue: dtmfValue, setEmptyFocusOnInteractionButton: setEmptyFocusOnInteractionButton, isPersistCallOrMPCEnabled: isPersistCallOrMPCEnabled, isInteractionBtnConfirmDialogEnabled: isInteractionBtnConfirmDialogEnabled, webexCallingCallId: webexCallingCallId, isConsultPanelVisualUpdateEnabled: isConsultPanelVisualUpdateEnabled }));
    });
};
const defineInteractionBadge = (contactInformation, chatInteractionStatus, localizedInteractionStatus, timeStamp, badgeAndIcon, isConsultView, channelNameLabels, interactionControlLocalized, isDarkMode, agentCallMonitoringState, isWxccMPCENabled, isPersistCallEnabled, isConsultVisualUpdateEnabled, agentId) => {
    var _a;
    const isPersistCallOrMPCEnabled = isWxccMPCENabled || isPersistCallEnabled;
    const { currentStateTimer, interactionTimer } = timeStamp;
    const { badgeColor, iconType, iconColor } = badgeAndIcon;
    let isConferenceBadge = false;
    if (isPersistCallOrMPCEnabled) {
        isConferenceBadge =
            (contactInformation.isConferencing &&
                !contactInformation.isWrapUpAssist &&
                !contactInformation.isInteractionInPostCall) ||
                ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_7__.isAgentConsulting)(contactInformation, isPersistCallOrMPCEnabled) &&
                    contactInformation.consultHold &&
                    contactInformation.isConferenceInProgress &&
                    !isConsultView);
    }
    else {
        isConferenceBadge = contactInformation.isConferencing && contactInformation.hasJoined;
    }
    let interactionIcon;
    let localBadgeColor;
    let isSplitBadge;
    let localIconColor;
    let isOnHold;
    const holdUI = () => {
        interactionIcon = "pause-bold";
        isSplitBadge = true;
        localBadgeColor = "#FFD98C";
        localIconColor = "#7D4705";
        isOnHold = true;
    };
    const consult = () => {
        interactionIcon = "headset-bold";
        isSplitBadge = true;
    };
    const conference = () => {
        interactionIcon = "webex-teams-bold";
        isSplitBadge = true;
    };
    const wrapup = () => {
        interactionIcon = "archive-bold";
        isSplitBadge = true;
    };
    const updateBadgeIconForPostCall = () => {
        interactionIcon = "webex-teams-bold";
        isSplitBadge = true;
    };
    const data = contactInformation;
    const isConsulting = ((_a = data === null || data === void 0 ? void 0 : data.state) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULTING;
    const postCallConsult = (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_7__.isPostCallConsultInProgress)(data);
    if (data.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.MIDCALL_MONITORING) {
        if (data.isMonitoringOnHold) {
            holdUI();
        }
        if (data.isBargedIn) {
            interactionIcon = "single-number-reach-bold";
        }
        isSplitBadge = true;
    }
    else if ((isConsulting || postCallConsult) && data.consultHold && isConsultView) {
        holdUI();
    }
    else if ((isConsulting || postCallConsult) && !data.consultHold && isConsultView) {
        consult();
    }
    else if ((isConsulting || (postCallConsult && data.isConferenceInProgress)) && !isConsultView) {
        updateBadgeIconForPostCall();
    }
    else if (data.state === _constants__WEBPACK_IMPORTED_MODULE_12__.CONSULTREQUESTED) {
        if (contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.CHAT || contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.SOCIAL) {
            conference();
        }
        else {
            if (isConsultVisualUpdateEnabled && !isConsultView) {
                holdUI();
            }
            else {
                consult();
            }
        }
    }
    else if (isConsultView && (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_7__.isPostCallConsultRequested)(data)) {
        consult();
    }
    else if (isConferenceBadge) {
        if (data.isHold && isWxccMPCENabled) {
            holdUI();
        }
        else {
            conference();
        }
    }
    else if (data.isWrapUp || data.isWrapUpAssist) {
        wrapup();
    }
    else if (data.isInteractionInPostCall) {
        updateBadgeIconForPostCall();
    }
    else if (data.isHold) {
        holdUI();
    }
    else if ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_7__.isBargedInteraction)(data.agentId, data.interactionId, agentCallMonitoringState)) {
        interactionIcon = "single-number-reach-bold";
        isSplitBadge = true;
    }
    else {
        isSplitBadge = false;
        interactionIcon = null;
        localBadgeColor = null;
        localIconColor = null;
        isOnHold = false;
    }
    const channelType = contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.SOCIAL
        ? contactInformation.mediaChannel
        : contactInformation.mediaType;
    const channelName = () => {
        const channel = channelType;
        switch (channel) {
            case "sms": {
                return channelNameLabels ? channelNameLabels.sms : "SMS";
            }
            case "telephony":
            case _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.MIDCALL_MONITORING: {
                return channelNameLabels ? channelNameLabels.telephony : "Call";
            }
            case "chat": {
                return channelNameLabels ? channelNameLabels.chat : "Chat";
            }
            case "email": {
                return channelNameLabels ? channelNameLabels.email : "Email";
            }
            case "facebook": {
                return channelNameLabels ? channelNameLabels.facebook : "Messenger";
            }
            case "whatsapp": {
                return channelNameLabels ? channelNameLabels.whatsapp : "Whatsapp";
            }
            case _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.APPLE_BUSINESS_CHAT: {
                return channelNameLabels ? channelNameLabels.appleBusinessChat : "Apple Business Chat";
            }
            case "googleMessages": {
                return channelNameLabels ? channelNameLabels.googleBusiness : `Google's Business Messages`;
            }
            default: {
                return channel;
            }
        }
    };
    const getBadgeIcon = () => {
        const derivedMediaChannel = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.getDerivedMediaChannelForDirection)(contactInformation.mediaChannel, contactInformation.contactDirection);
        if ((contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.SOCIAL || (0,_InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_6__.isMediaTypeDigitalOutbound)(derivedMediaChannel !== null && derivedMediaChannel !== void 0 ? derivedMediaChannel : "")) &&
            derivedMediaChannel &&
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]) {
            const imgSrc = isDarkMode
                ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel].communication.dark
                : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel].communication.light;
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { width: "22px", alt: `${imgSrc}`, src: `${imgSrc}` });
        }
        else {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", Object.assign({ name: `icon-${iconType}` }, (localIconColor || iconColor ? { color: localIconColor || iconColor } : ""), { size: "12", iconSet: "preferMomentumDesign" })));
        }
    };
    const firstSection = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({}, (isSplitBadge ? { slot: "split-left" } : ""), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: channelName(), placement: "bottom", "aria-hidden": "true" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ circle: true, small: true, style: { marginRight: ".375rem" }, color: `${localBadgeColor || !badgeColor.startsWith("#") ? localBadgeColor || badgeColor : ""}`, bgColor: `${localBadgeColor || badgeColor.startsWith("#") ? localBadgeColor || badgeColor : ""}`, "aria-label": channelType }, { children: getBadgeIcon() })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_3__["default"], { color: "none", timerTimeStamp: interactionTimer, timerLabel: `${channelName()} ${interactionControlLocalized.interactionDurationLabel}` })] })));
    const getBadgeText = () => {
        if (contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.CHAT || contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.SOCIAL) {
            return chatInteractionStatus;
        }
        if (isConferenceBadge) {
            if (contactInformation.isBargedIn) {
                return interactionControlLocalized.bargedIn;
            }
            if ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_7__.isAgentConsulting)(contactInformation, isWxccMPCENabled) && isConsultView && contactInformation.consultHold) {
                return interactionControlLocalized.consultCallOnHold;
            }
            if (contactInformation.isHold && isWxccMPCENabled) {
                return interactionControlLocalized.callOnHold;
            }
            if ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_7__.isPostCallConsultInProgress)(contactInformation) && !isConsultView) {
                return interactionControlLocalized.postCall;
            }
            if (isPersistCallOrMPCEnabled) {
                return getOtherAgentTitleInTwoPartyConference(contactInformation, agentId);
            }
            if (contactInformation.destAgentName) {
                return contactInformation.destAgentName;
            }
        }
        return localizedInteractionStatus;
    };
    const getAriaLabelForSubstateInteractionControl = () => {
        if (contactInformation.isConferencing && isPersistCallOrMPCEnabled) {
            const agentName = getOtherAgentTitleInTwoPartyConference(contactInformation, agentId);
            return interactionControlLocalized.badgeAriaLabel.replace("{participant}", agentName);
        }
        else if (contactInformation.isConferencing && contactInformation.destAgentName) {
            return interactionControlLocalized.badgeAriaLabel.replace("{participant}", contactInformation.destAgentName);
        }
        else if (contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.CHAT ||
            contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.SOCIAL) {
            return chatInteractionStatus;
        }
        else if (agentCallMonitoringState &&
            agentCallMonitoringState.monitoringType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.BARGE_IN_MONITORING_STATE &&
            data.interactionId === agentCallMonitoringState.interactionId) {
            return interactionControlLocalized.badgeAriaLabel.replace("{participant}", localizedInteractionStatus);
        }
        return localizedInteractionStatus;
    };
    const renderSplitBadge = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-badge", Object.assign({ ariaLabel: getAriaLabelForSubstateInteractionControl() }, (isOnHold ? { color: "hold" } : ""), { split: true }, { children: [firstSection, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ slot: "split-right" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { "aria-hidden": "true", class: "split-icon", name: interactionIcon, size: "14", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true" }, { children: getBadgeText() }))] }), isContactTimer(contactInformation, isConsultView, isWxccMPCENabled, agentCallMonitoringState, isConferenceBadge) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "timer-dash" }, { children: "-" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_3__["default"], { color: "none", timerTimeStamp: currentStateTimer, timerLabel: `${getBadgeText()} ${interactionControlLocalized.interactionDurationLabel}` })] }))] }))] }), "withSplit"));
    };
    const isAgentInConferenceAndBargedIN = () => {
        var _a;
        return (((_a = contactInformation.state) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONFERENCE &&
            contactInformation.isConferencing &&
            agentCallMonitoringState &&
            agentCallMonitoringState.monitoringType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.BARGE_IN_MONITORING_STATE &&
            data.interactionId === agentCallMonitoringState.interactionId);
    };
    const showMPCParticipants = () => {
        if (isConsultView && (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_7__.isPostCallConsultInProgress)(data)) {
            return false;
        }
        //function determines whether to show participants based the multi party conference flow
        const mediaParticipants = contactInformation.primaryMediaParticipants;
        const totalParticipants = (mediaParticipants && Object.keys(mediaParticipants).length) || 0;
        return (isPersistCallOrMPCEnabled &&
            (((data.isHold || data.state === WrapUp || data.isInteractionInPostCall) &&
                totalParticipants === ONLY_ONE_EXTRA_PARTICIPANT) ||
                totalParticipants > ONLY_ONE_EXTRA_PARTICIPANT) &&
            (!isConsultView || isConferenceBadge || data.state === WrapUp || data.isInteractionInPostCall));
    };
    if (isSplitBadge) {
        if (contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.MIDCALL_MONITORING) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MidCallMonitoringSplitBadge__WEBPACK_IMPORTED_MODULE_9__["default"], { data: data, firstSection: firstSection, contactInformation: contactInformation, isDarkMode: isDarkMode, interactionControlLocalized: interactionControlLocalized, getBadgeText: getBadgeText, interactionIcon: interactionIcon, isConsultView: isConsultView, agentCallMonitoringState: agentCallMonitoringState, currentStateTimer: currentStateTimer }));
        }
        else {
            if (showMPCParticipants()) {
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ParticipantsBadge__WEBPACK_IMPORTED_MODULE_10__["default"], { contactInformation: contactInformation, agentCallMonitoringState: agentCallMonitoringState, interactionTimer: interactionTimer, getBadgeText: getBadgeText, isConsultView: isConsultView, isConferenceBadge: isConferenceBadge, currentStateTimer: currentStateTimer, interactionIcon: interactionIcon }));
            }
            else {
                return isAgentInConferenceAndBargedIN() ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ParticipantsBadgeForConference__WEBPACK_IMPORTED_MODULE_11__["default"], { contactInformation: contactInformation, agentCallMonitoringState: agentCallMonitoringState, interactionTimer: interactionTimer, agentId: agentId, isMPCEnabled: isWxccMPCENabled })) : (renderSplitBadge());
            }
        }
    }
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ compact: true, "aria-label": contactInformation.mediaType }, { children: firstSection }), "withoutSplit"));
};
const handleTimeOutForCallBack = (callbackFunction, param, timeout) => {
    setTimeout(() => {
        callbackFunction(param);
    }, timeout);
};
// This function gets the text that is presant in the split-right of the badge.
const getRightSplitBadgeText = (infoSectionRef) => {
    var _a, _b;
    const badge = (_a = infoSectionRef === null || infoSectionRef === void 0 ? void 0 : infoSectionRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("md-badge");
    if (badge) {
        const badgeText = (_b = badge === null || badge === void 0 ? void 0 : badge.querySelector("span[slot='split-right']")) === null || _b === void 0 ? void 0 : _b.querySelector("span").innerText;
        if (badgeText) {
            return badgeText;
        }
    }
    return "";
};
// This function is to announce the badge status.
const announceBadgeStatus = (infoSectionRef) => {
    var _a, _b, _c, _d, _e;
    const badge = (_a = infoSectionRef === null || infoSectionRef === void 0 ? void 0 : infoSectionRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("md-badge");
    if (badge) {
        const callBadge = (_c = (_b = badge === null || badge === void 0 ? void 0 : badge.querySelector("span[slot='split-left']")) === null || _b === void 0 ? void 0 : _b.querySelector(".timer-label")) === null || _c === void 0 ? void 0 : _c.innerText;
        const splitRightBadge = (_e = (_d = badge === null || badge === void 0 ? void 0 : badge.querySelector("span[slot='split-right']")) === null || _d === void 0 ? void 0 : _d.querySelector(".timer-label")) === null || _e === void 0 ? void 0 : _e.innerText;
        if (callBadge && splitRightBadge) {
            (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.dispatchAnnouncement)(`${callBadge} ${splitRightBadge}`);
        }
    }
};


/***/ }),

/***/ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts":
/*!********************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/InteractionControlHelper.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   agentConference: () => (/* binding */ agentConference),
/* harmony export */   cancelCtqRequest: () => (/* binding */ cancelCtqRequest),
/* harmony export */   conferenceTransfer: () => (/* binding */ conferenceTransfer),
/* harmony export */   consultTransfer: () => (/* binding */ consultTransfer),
/* harmony export */   dispatchCustomInteractionEvent: () => (/* binding */ dispatchCustomInteractionEvent),
/* harmony export */   endMonitoring: () => (/* binding */ endMonitoring),
/* harmony export */   endingConference: () => (/* binding */ endingConference),
/* harmony export */   endingConsult: () => (/* binding */ endingConsult),
/* harmony export */   endingInteraction: () => (/* binding */ endingInteraction),
/* harmony export */   exitConference: () => (/* binding */ exitConference),
/* harmony export */   generateUUID: () => (/* binding */ generateUUID),
/* harmony export */   getAgentAction: () => (/* binding */ getAgentAction),
/* harmony export */   getChatInteractionStatus: () => (/* binding */ getChatInteractionStatus),
/* harmony export */   getErrorMsgForReasonCode: () => (/* binding */ getErrorMsgForReasonCode),
/* harmony export */   getLocalizedInteractionStatus: () => (/* binding */ getLocalizedInteractionStatus),
/* harmony export */   getStatusForChatInteraction: () => (/* binding */ getStatusForChatInteraction),
/* harmony export */   getTimeStampForStatus: () => (/* binding */ getTimeStampForStatus),
/* harmony export */   getTimestampForVoice: () => (/* binding */ getTimestampForVoice),
/* harmony export */   heldInteraction: () => (/* binding */ heldInteraction),
/* harmony export */   heldSilentMonitoring: () => (/* binding */ heldSilentMonitoring),
/* harmony export */   initialState: () => (/* binding */ initialState),
/* harmony export */   isAgentConferencing: () => (/* binding */ isAgentConferencing),
/* harmony export */   isPrimaryAgentInitiatedChatConsult: () => (/* binding */ isPrimaryAgentInitiatedChatConsult),
/* harmony export */   isQueueEnabled: () => (/* binding */ isQueueEnabled),
/* harmony export */   isVoice: () => (/* binding */ isVoice),
/* harmony export */   logger: () => (/* binding */ logger),
/* harmony export */   resumingInteraction: () => (/* binding */ resumingInteraction),
/* harmony export */   unHeldSilentMonitoring: () => (/* binding */ unHeldSilentMonitoring),
/* harmony export */   updateCadVariable: () => (/* binding */ updateCadVariable),
/* harmony export */   updateState: () => (/* binding */ updateState)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Utility/Utils/InteractionControlUtils */ "./src/direflow-components/Utility/Utils/InteractionControlUtils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./constants */ "./src/direflow-components/InteractionControl/constants.js");








const logger = (0,_sdk__WEBPACK_IMPORTED_MODULE_3__.createLogger)("[InteractionControl]");
/**
 * Returns event eg : 'END','CONFERENCE','TRANSFER','HOLD', 'RESUME'
 * @param type :string
 */
const getAgentAction = (type) => {
    return type.split("_")[0];
};
const isVoice = (interaction) => {
    return (interaction === null || interaction === void 0 ? void 0 : interaction.mediaType) === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.VOICE;
};
/**
 * Returns localized status of the interaction
 */
const getLocalizedInteractionStatus = (data, isConsultView, interactionControl, isConsultVisualUpdateEnabled, agentCallMonitoringState) => {
    var _a;
    if (data.isMonitoringOnHold) {
        return interactionControl.monitoringPaused;
    }
    if (data.isBargedIn) {
        return interactionControl.bargedIn;
    }
    const isSecondaryEpdnPostCallConsult = isConsultVisualUpdateEnabled && data.isSecondaryEpDnAgent && data.isInteractionInPostCall;
    if (((_a = data === null || data === void 0 ? void 0 : data.state) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULTING && data.consultHold && isConsultView) {
        return isSecondaryEpdnPostCallConsult ? interactionControl.postCallConsult : interactionControl.consultCallOnHold;
    }
    if (isConsultVisualUpdateEnabled && data.state === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT.toLowerCase() && !data.consultHold && isConsultView) {
        return interactionControl.consultRequested;
    }
    if (_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_6__.consultState.includes(data.state) && !data.consultHold && isConsultView) {
        return isSecondaryEpdnPostCallConsult ? interactionControl.postCallConsult : interactionControl.consulting;
    }
    if (data.state === _constants__WEBPACK_IMPORTED_MODULE_7__.CONSULTREQUESTED) {
        return isConsultVisualUpdateEnabled ? interactionControl.callOnHold : interactionControl.consultRequested;
    }
    if ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_6__.isPostCallConsultInProgress)(data)) {
        return isConsultView ? interactionControl.postCallConsult : interactionControl.postCall;
    }
    if ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_6__.isPostCallConsultRequested)(data) && isConsultView) {
        return interactionControl.consultRequested;
    }
    if (data.isWrapUp) {
        return interactionControl.wrapup;
    }
    if (data.isInteractionInPostCall) {
        return interactionControl === null || interactionControl === void 0 ? void 0 : interactionControl.postCall;
    }
    if (data.isWrapUpAssist) {
        return data.isOwner || data.isWrapUp ? interactionControl.wrapup : interactionControl.wrapupassist;
    }
    if (data.hasJoined && data.isConferencing) {
        return interactionControl.conference;
    }
    if (data.isHold) {
        return interactionControl.callOnHold;
    }
    if ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_6__.isBargedInteraction)(data.agentId, data.interactionId, agentCallMonitoringState)) {
        return agentCallMonitoringState === null || agentCallMonitoringState === void 0 ? void 0 : agentCallMonitoringState.supervisorName;
    }
    return interactionControl.connected;
};
const { interaction_control } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.getLocalizedMessages)();
const { errorCodes } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.getLocalizedMessages)();
/**
 *
 * @param data: Interaction
 */
const getChatInteractionStatus = (data, interactionControl) => {
    var _a, _b;
    if (data.isWrapUp) {
        return interactionControl.wrapup;
    }
    if (((_a = data.state) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONFERENCE) {
        return interactionControl.conference;
    }
    if (((_b = data.state) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT) {
        return interactionControl.conferenceRequested;
    }
    return interactionControl.connected;
};
/**
 * Util method to dispatch custom events
 */
const dispatchCustomInteractionEvent = (customEvt) => {
    const { thisEvent, response, eventName, dispatchCustomEvent } = customEvt;
    const eventDetail = response === "success" ? { thisEvent, response } : thisEvent;
    const customEvent = new CustomEvent(eventName, {
        detail: eventDetail,
        bubbles: true,
        composed: true
    });
    if (dispatchCustomEvent) {
        dispatchCustomEvent(customEvent);
    }
};
const getErrorMsgForReasonCode = (reasonCode) => {
    if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.featureflag.isDesktopReasonCodeEnabled() &&
        Object.prototype.hasOwnProperty.call(errorCodes, reasonCode)) {
        return errorCodes[reasonCode];
    }
    return null;
};
/**
 * Initial state of reducer
 */
const initialState = {
    interaction: {
        customerName: "",
        mediaType: "",
        mediaChannel: "",
        isWrapUp: false,
        consultHold: false,
        consultMediaResourceId: "",
        destAgentName: "",
        destAgentPhoneNumber: "",
        destAgentType: "",
        consultTimeStamp: 0,
        wrapUpTimestamp: 0,
        wrapUpAssistTimestamp: 0,
        holdTimestamp: 0,
        consultHoldTimestamp: 0,
        ownerName: "",
        ownerPhoneNumber: "",
        owner: "",
        agentId: "",
        queueId: "",
        ani: "",
        displayAni: "",
        orgId: "",
        interactionId: "",
        destAgentId: "",
        mediaResourceId: "",
        isConsulted: false,
        state: "",
        isFcManaged: false,
        isTerminated: false,
        timeStamp: 0,
        isHold: false,
        hasJoined: false,
        isOffered: false,
        isSecondaryEpDnAgent: false,
        ronaTimeout: "",
        ivrPath: "",
        phoneNumber: "",
        pathId: "",
        dnis: "",
        category: "",
        additionalDetails: "",
        isConferencing: false,
        contactDirection: "",
        outboundType: "",
        virtualTeamName: "",
        sourceNumber: "",
        sourcePage: "",
        appUser: "",
        ctqInProgress: false,
        customerNumber: "",
        isRecordingPaused: false,
        isOwner: false,
        EpDnConsultDestinationAgentJoined: false,
        reasonCode: "",
        primaryMediaParticipants: {},
        isWrapUpAssist: false,
        isSecondaryAgentCBT: false,
        postCallTimestamp: 0,
        isInteractionInPostCall: false,
        isAmdDetectedInCallback: false
    },
    buttons: [],
    isMPCEnabled: false,
    isDesktopConferenceRecordingEnabled: false
};
/* For Transfer Action:
 * For outboud calls outdialTransferToQueueEnabled will be true or false
 * For inbound calls outdialTransferToQueueEnabled will always be true
 * For Consult Action: queue eenabled for allowConsultToQueue is true
 */
const isQueueEnabled = (state, agentAction, allowConsultToQueue) => {
    if (state.interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.VOICE) {
        if (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.TRANSFER) {
            return (state.interaction.contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.INBOUND ||
                (state.interaction.contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.OUTBOUND && state.interaction.outdialTransferToQueueEnabled === true));
        }
        if (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT) {
            return allowConsultToQueue || false;
        }
    }
    return true;
};
/**
 * function to update I18N message and default list type used inside transfer modal
 */
const { transfer, conference, consult } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.getLocalizedMessages)();
const updateState = (agentAction, seti18nMessage) => {
    if (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.TRANSFER) {
        seti18nMessage(transfer);
    }
    else if (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONFERENCE) {
        seti18nMessage(conference);
    }
    else if (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT) {
        seti18nMessage(consult);
    }
};
/**
 * generate agent session id
 */
const generateUUID = () => {
    let d = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.utc().toMillis();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0; // eslint-disable-line no-bitwise
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16); // eslint-disable-line no-bitwise
    });
};
/**
 * Chat Interaction Action
 */
const getStatusForChatInteraction = (data) => {
    var _a;
    if (data.state === "consulting" || data.state === "consult" || data.state === "conference") {
        return (_a = data.state) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    }
    if (data.state === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT.toLowerCase()) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT_REQUESTED;
    }
    if (data.isWrapUp) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_4__.WRAP_UP;
    }
    return _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONNECTED;
};
const getEpOrDnConfDestinationType = (interaction) => {
    return (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_6__.isEPorEPDN)(interaction.destAgentType)
        ? (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.getDestAgentTypeForEporEPDN)()
        : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.DESTINATION_TYPE.DIAL_NUMBER;
};
/**
 * Request Conference
 */
const agentConference = (interaction, dispatchCustomEvent, eventName, agentId, detail, updateButtonProgressFlag, agentActionType) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const data = Object.assign(Object.assign({}, (agentActionType !== _Common_constants__WEBPACK_IMPORTED_MODULE_4__.DIAL_NUMBER && agentId && { agentId })), { to: interaction === null || interaction === void 0 ? void 0 : interaction.destAgentId, destinationType: agentActionType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.DIAL_NUMBER
            ? getEpOrDnConfDestinationType(interaction)
            : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.DESTINATION_TYPE.AGENT });
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONFERENCE_CLICKED, {
        Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
        [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_PROPS.INTERACTION_ID]: interaction.interactionId,
        [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_PROPS.MEDIA_TYPE]: interaction.mediaType
    }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONFERENCE_CLICKED, [
        (_f = (_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _e === void 0 ? void 0 : _e.SERVICE_PROVIDERS) === null || _f === void 0 ? void 0 : _f.webex_behavioral,
        (_h = (_g = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _g === void 0 ? void 0 : _g.SERVICE_PROVIDERS) === null || _h === void 0 ? void 0 : _h.prometheus
    ]);
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .consultConferenceV2({
        interactionId: interaction.interactionId,
        data
    })
        .then(() => {
        // do nothing
    })
        .catch((err) => {
        var _a, _b, _c, _d, _e, _f;
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: {
                type: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
                interactionId: "",
                trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err),
                message: getErrorMsgForReasonCode((_b = (_a = err === null || err === void 0 ? void 0 : err.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reasonCode) || interaction_control.conferenceFailed
            },
            eventName: "ax-interaction-conference-failed",
            dispatchCustomEvent
        });
        updateButtonProgressFlag("");
        logger.error(`event=ConsultConferenceError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to initiate Consult Conf: ${err}`, err);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONFERENCE_CLICKED, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            media_type: interaction.mediaType,
            Reason: "ConsultConferenceError",
            interactionId: interaction.interactionId
        }, [(_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus, (_f = (_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _e === void 0 ? void 0 : _e.SERVICE_PROVIDERS) === null || _f === void 0 ? void 0 : _f.webex_behavioral]);
    });
};
const isPrimaryAgentInitiatedChatConsult = (status, interaction) => {
    return (status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT &&
        (interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.CHAT || interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.SOCIAL) &&
        interaction.isOwner);
};
const isAgentConferencing = (interactionObj) => {
    var _a;
    return (((_a = interactionObj.state) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONFERENCE &&
        interactionObj.isConferencing &&
        (interactionObj.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.CHAT || interactionObj.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.SOCIAL));
};
/**
 * Ending the interaction
 */
const endingInteraction = (detail, dispatchCustomEvent, updateButtonProgressFlag, ani, mediaType, contactDirection, isEndingFromNonPrimary) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .endV2({ interactionId: detail.interactionId, isEndingFromNonPrimary })
        .then(() => {
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.SUCCESS,
            thisEvent: detail,
            eventName: "ax-interaction-end",
            dispatchCustomEvent
        });
        logger.info(`Interaction Event: `, detail);
    })
        .catch((err) => {
        var _a, _b;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackCallEndedEvent({
            eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_COMPLETED,
            interactionId: detail.interactionId,
            ani,
            mediaType,
            mediaChannel: detail.mediaChannel,
            contactDirection,
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            reasonForFailure: "EndInteractionError",
            reasonCode: err.reason
        });
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: {
                type: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
                interactionId: "",
                trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err),
                message: getErrorMsgForReasonCode((_b = (_a = err === null || err === void 0 ? void 0 : err.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reasonCode) || interaction_control.endCallFailed
            },
            eventName: "ax-interaction-end-failed",
            dispatchCustomEvent
        });
        updateButtonProgressFlag("");
        logger.error(`event=EndInteractionError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to End Interaction: ${err}`, err);
    });
};
/**
 * Ending Consult
 */
const endingConsult = (detail, dispatchCustomEvent, isConsult, isSecondaryEpDnAgent, updateButtonProgressFlag, updateCtqInProgress) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .consultEndV2({
        interactionId: detail.interactionId,
        isConsult,
        isSecondaryEpDnAgent
    })
        .then(() => {
        if (detail.type === _constants__WEBPACK_IMPORTED_MODULE_7__.EXIT) {
            dispatchCustomInteractionEvent({
                response: _constants__WEBPACK_IMPORTED_MODULE_7__.SUCCESS,
                thisEvent: {
                    type: detail.type,
                    interactionId: detail.interactionId,
                    message: interaction_control.consultExited
                },
                eventName: _constants__WEBPACK_IMPORTED_MODULE_7__.ANNOUNCEMENT_UPDATE,
                dispatchCustomEvent
            });
        }
    })
        .catch((err) => {
        var _a, _b;
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: {
                type: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
                interactionId: "",
                trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err),
                message: getErrorMsgForReasonCode((_b = (_a = err === null || err === void 0 ? void 0 : err.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reasonCode) || interaction_control.consultEndFailed
            },
            eventName: "ax-interaction-consult-end-failed",
            dispatchCustomEvent
        });
        updateCtqInProgress(false);
        updateButtonProgressFlag("");
        logger.error(`event=EndConsultError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to End Consult: ${err}`, err);
    });
};
const cancelCtqRequest = (detail, agentId, destinationQueueId, updateButtonProgressFlag, setCtqInProgress, setShowCtqErrorMessage, setEtrackingId) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .cancelCtq({
        interactionId: detail.interactionId,
        data: {
            agentId,
            queueId: destinationQueueId
        }
    })
        .then(() => {
        // do nothing
    })
        .catch((err) => {
        // inline error
        setShowCtqErrorMessage(true);
        setEtrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err));
        updateButtonProgressFlag("");
        setCtqInProgress(false);
        logger.error(`event=CancelCTQError |  [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to Cancel CTQ: ${err}`, err);
    });
};
/**
 * Hold Interaction
 */
const heldInteraction = (detail, isConsultView, dispatchCustomEvent, interaction, updateButtonProgressFlag, onHoldCompleteFunc) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .hold({
        interactionId: interaction.interactionId || detail.interactionId,
        data: {
            mediaResourceId: isConsultView ? interaction.consultMediaResourceId : interaction === null || interaction === void 0 ? void 0 : interaction.mediaResourceId
        }
    })
        .then(() => {
        if (onHoldCompleteFunc) {
            onHoldCompleteFunc();
        }
    })
        .catch((err) => {
        var _a, _b, _c, _d;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackHoldEvents({
            eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_HOLD_CLICKED,
            interactionId: detail.interactionId,
            mediaType: interaction.mediaType,
            ani: interaction.ani,
            contactDirection: interaction.contactDirection,
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            reasonForFailure: "InteractionHoldError",
            reasonCode: err.reason
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_HOLD_CLICKED, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            media_type: interaction.mediaType,
            Reason: "InteractionHoldError",
            interactionId: detail.interactionId
        }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus]);
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: {
                type: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
                interactionId: "",
                trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err),
                message: getErrorMsgForReasonCode((_d = (_c = err === null || err === void 0 ? void 0 : err.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || interaction_control.holdCallFailed
            },
            eventName: "ax-interaction-hold-failed",
            dispatchCustomEvent
        });
        updateButtonProgressFlag("");
        logger.error(`event=InteractionHoldError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to Hold Interaction: ${err}`, err);
    });
};
const heldSilentMonitoring = (dispatchCustomEvent, detail, interaction, updateButtonProgressFlag, agentconfig) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor
        .holdMonitoring({
        interactionId: interaction.interactionId
    })
        .then(() => {
        // do nothing
    })
        .catch((err) => {
        var _a, _b, _c, _d;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.PAUSE_MONITORING_CLICKED, {
            interactionId: detail.interactionId,
            SupervisorId: agentconfig.agentId,
            Role: agentconfig.role,
            reasonForFailure: "MonitoringHeldError",
            reasonCode: err.reason
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.PAUSE_MONITORING_CLICKED, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            media_type: interaction.mediaType,
            Reason: "MonitoringHeldError",
            interactionId: detail.interactionId
        }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus]);
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: {
                type: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
                interactionId: "",
                trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err),
                message: getErrorMsgForReasonCode((_d = (_c = err === null || err === void 0 ? void 0 : err.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || interaction_control.pauseMonitoringFailed
            },
            eventName: "ax-interaction-monitoring-hold-failed",
            dispatchCustomEvent
        });
        updateButtonProgressFlag("");
        logger.error(`event=MonitoringHeldError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to Hold Monitoring: ${err}`, err);
    });
};
const unHeldSilentMonitoring = (dispatchCustomEvent, detail, interaction, updateButtonProgressFlag, agentconfig) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor
        .unHoldMonitoring({
        interactionId: interaction.interactionId
    })
        .then(() => {
        // do nothing
    })
        .catch((err) => {
        var _a, _b, _c, _d;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.RESUME_MONITORING_CLICKED, {
            interactionId: detail.interactionId,
            SupervisorId: agentconfig.agentId,
            Role: agentconfig.role,
            reasonForFailure: "MonitoringResumeError",
            reasonCode: err.reason
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.RESUME_MONITORING_CLICKED, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            media_type: interaction.mediaType,
            Reason: "MonitoringResumeError",
            interactionId: detail.interactionId
        }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus]);
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: {
                type: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
                interactionId: "",
                trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err),
                message: getErrorMsgForReasonCode((_d = (_c = err === null || err === void 0 ? void 0 : err.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || interaction_control.resumeMonitoringFailed
            },
            eventName: "ax-interaction-monitoring-hold-failed",
            dispatchCustomEvent
        });
        updateButtonProgressFlag("");
        logger.error(`event=MonitoringResumeError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to Resume Monitoring: ${err}`, err);
    });
};
/**
 * Resume Interaction
 */
const resumingInteraction = (detail, isWxccMultiPartyConfEnabled, dispatchCustomEvent, interaction, updateButtonProgressFlag, onResumeCompleteFunc) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .unHold({
        interactionId: interaction.interactionId,
        data: {
            mediaResourceId: isWxccMultiPartyConfEnabled && (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_6__.isAgentConsulting)(interaction, isWxccMultiPartyConfEnabled)
                ? interaction.consultMediaResourceId
                : interaction === null || interaction === void 0 ? void 0 : interaction.mediaResourceId
        }
    })
        .then(() => {
        if (onResumeCompleteFunc) {
            onResumeCompleteFunc();
        }
    })
        .catch((err) => {
        var _a, _b, _c, _d;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackHoldEvents({
            eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_CLICKED,
            interactionId: detail.interactionId,
            mediaType: interaction.mediaType,
            contactDirection: interaction.contactDirection,
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            reasonForFailure: "ResumeInteractionError",
            reasonCode: err.reason
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_CLICKED, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            media_type: interaction.mediaType,
            Reason: "ResumeInteractionError",
            interactionId: detail.interactionId
        }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus]);
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: {
                type: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
                interactionId: "",
                trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err),
                message: getErrorMsgForReasonCode((_d = (_c = err === null || err === void 0 ? void 0 : err.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || interaction_control.resumeCallFailed
            },
            eventName: "ax-interaction-resume-failed",
            dispatchCustomEvent
        });
        updateButtonProgressFlag("");
        logger.error(`event=ResumeInteractionError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to Resume Interaction: ${err}`, err);
        if (interaction.mediaType === "telephony") {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_ACTIVATED, {
                InteractionId: interaction.interactionId,
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_PROPS.CALL_DIRECTION]: interaction.contactDirection,
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                Reason: "ResumeInteractionError"
            });
        }
    });
};
/**
 * Ending Consult Interaction
 */
const exitConference = (detail, dispatchCustomEvent, updateButtonProgressFlag) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .exitConference({ interactionId: detail.interactionId })
        .then(() => {
        logger.info("event=ExitConferenceSuccess | Exit Conference Interaction Success");
    })
        .catch((err) => {
        var _a, _b;
        const trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err);
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: {
                type: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
                interactionId: "",
                trackingId,
                message: getErrorMsgForReasonCode((_b = (_a = err === null || err === void 0 ? void 0 : err.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reasonCode) || interaction_control.conferenceExitFailed
            },
            eventName: "ax-interaction-conference-exit-failed",
            dispatchCustomEvent
        });
        updateButtonProgressFlag("");
        logger.error(`event=ExitConferenceError | [Tracking ID: ${trackingId}] Failed to Exit Conference Interaction: ${err}`, err);
    });
};
const endingConference = (detail, dispatchCustomEvent, isConsult, isSecondaryEpDnAgent, updateButtonProgressFlag, isPersistCallOrMPCEnabled) => {
    if (!isConsult && isPersistCallOrMPCEnabled) {
        exitConference(detail, dispatchCustomEvent, updateButtonProgressFlag);
        return;
    }
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .consultEndV2({
        interactionId: detail.interactionId,
        isConsult,
        isSecondaryEpDnAgent
    })
        .then(() => {
        // do nothing
    })
        .catch((err) => {
        var _a, _b;
        const trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err);
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: {
                type: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
                interactionId: "",
                trackingId,
                message: getErrorMsgForReasonCode((_b = (_a = err === null || err === void 0 ? void 0 : err.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reasonCode) || interaction_control.conferenceEndFailed
            },
            eventName: "ax-interaction-conference-end-failed",
            dispatchCustomEvent
        });
        updateButtonProgressFlag("");
        logger.error(`event=EndConferenceError | [Tracking ID: ${trackingId}] Failed to End Conference Interaction: ${err}`, err);
    });
};
/**
 * Request consult transfer
 */
const consultTransfer = (detail, payload, dispatchCustomEvent, updateButtonProgressFlag, isConsult) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .consultTransferV2({
        interactionId: detail.interactionId,
        data: payload
    })
        .then(() => {
        // do nothing
        logger.info(`consultTransfer successful`);
    })
        .catch((err) => {
        var _a, _b, _c, _d;
        updateButtonProgressFlag("");
        logger.error(`event=ConsultTransferError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Consult Transfer failed: ${err}`, err);
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: {
                type: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
                interactionId: "",
                trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err),
                message: isConsult
                    ? getErrorMsgForReasonCode((_b = (_a = err === null || err === void 0 ? void 0 : err.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reasonCode) || interaction_control.consultTransferFailed
                    : getErrorMsgForReasonCode((_d = (_c = err === null || err === void 0 ? void 0 : err.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || interaction_control.conferenceTransferFailed
            },
            eventName: "ax-interaction-consult-transfer-failed",
            dispatchCustomEvent
        });
    });
};
/**
 * Ending Conference Transfer
 */
const conferenceTransfer = (detail, dispatchCustomEvent, updateButtonProgressFlag) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .conferenceTransfer({ interactionId: detail.interactionId })
        .then(() => {
        logger.info("event=ConferenceTransferSuccess |  Conference TransferInteraction Success");
    })
        .catch((err) => {
        var _a, _b;
        const trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err);
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: {
                type: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
                interactionId: "",
                trackingId,
                message: getErrorMsgForReasonCode((_b = (_a = err === null || err === void 0 ? void 0 : err.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reasonCode) || interaction_control.conferenceTransferFailed
            },
            eventName: "ax-interaction-conference-transfer-failed",
            dispatchCustomEvent
        });
        updateButtonProgressFlag("");
        logger.error(`event=ConferenceTransferError | [Tracking ID: ${trackingId}] Failed to Conference Transfer Interaction: ${err}`, err);
    });
};
const endMonitoring = (taskId, dispatchCustom) => {
    (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.evt)(_Common_constants__WEBPACK_IMPORTED_MODULE_4__.AX_END_MONITORING, true, dispatchCustom);
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.MIDCALL_MONITORING_ENDED);
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor
        .endMonitoring({
        interactionId: taskId
    })
        .then((data) => {
        logger.info("event= MonitoringEnded:", data);
    })
        .catch((e) => {
        var _a, _b;
        logger.error("event= MonitoringEndFailed", e);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.END_MONITORING_CLICKED, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            Reason: "EndMonitoringFailed",
            interactionId: taskId
        }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus]);
    });
};
const getTimestampForVoice = (interaction, status, isConsultView, agentCallMonitoringState, isWxccMultiPartyConfEnabled = false, isWxccPersistConsultEnabled = false) => {
    var _a;
    if ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_6__.isBargedInteraction)(interaction.agentId, interaction.interactionId, agentCallMonitoringState)) {
        if (interaction.isHold && isWxccMultiPartyConfEnabled) {
            return luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.utc().toMillis();
        }
        return (_a = agentCallMonitoringState === null || agentCallMonitoringState === void 0 ? void 0 : agentCallMonitoringState.eventTime) !== null && _a !== void 0 ? _a : luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.utc().toMillis();
    }
    if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONFERENCE && interaction.isHold && isWxccMultiPartyConfEnabled) {
        //This condition will show "call on hold" in the badge
        return interaction.holdTimestamp || interaction.consultTimeStamp;
    }
    if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT_REQUESTED && !isConsultView && isWxccPersistConsultEnabled) {
        return interaction.holdTimestamp;
    }
    if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONFERENCE || status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT_REQUESTED) {
        return interaction.consultTimeStamp;
    }
    if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.WRAP_UP) {
        return interaction.wrapUpTimestamp;
    }
    if (interaction.isInteractionInPostCall) {
        return interaction.postCallTimestamp || luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.now().toMillis();
    }
    if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.WRAPUP_ASSIST) {
        return interaction.wrapUpAssistTimestamp;
    }
    if (isConsultView) {
        if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT_HOLD || status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULTED_AGENT_HELD) {
            return interaction.consultHoldTimestamp;
        }
        if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULTING || status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULTED_AGENT_UNHELD || status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT_UNHELD) {
            return interaction.consultTimeStamp;
        }
    }
    if (!isConsultView && (status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.HOLD || status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.EPDN_HOLD)) {
        return interaction.holdTimestamp;
    }
    return luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.utc().toMillis();
};
const getTimestampForNonVoice = (interaction, status) => {
    if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.WRAP_UP) {
        return interaction.wrapUpTimestamp;
    }
    if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT || status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULTING || status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONFERENCE || status === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT_REQUESTED) {
        if (interaction.owner === interaction.agentId) {
            return interaction.consultTimeStamp;
        }
        return interaction.timeStamp; // CX-4212-Fix: For secondary agent using agent joined time
    }
    return luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.utc().toMillis();
};
/**
 * ContactTimestamps hold|consultHold|consult|conference|wrapup
 */
const getTimeStampForStatus = (interaction, status, isConsultView, agentCallMonitoringState, isWxccMultiPartyConfEnabled = false, isWxccPersistConsultEnabled = false) => {
    if (interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.VOICE) {
        return getTimestampForVoice(interaction, status, isConsultView, agentCallMonitoringState, isWxccMultiPartyConfEnabled, isWxccPersistConsultEnabled);
    }
    if (interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.MIDCALL_MONITORING) {
        if (interaction.isMonitoringOnHold) {
            return interaction.monitoringHoldTimer || luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.now().toMillis();
        }
        if (interaction.isBargedIn) {
            return interaction.bargedInTimeStamp || luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.now().toMillis();
        }
        return interaction.monitoringStartTime || luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.now().toMillis();
    }
    return getTimestampForNonVoice(interaction, status);
};
const updateCadVariable = (detail, interactupdateCadPayLoad, dispatchCustomEvent, updateButtonProgressFlag, handleUpdateCallBack, secureCad, keyId, keyVersion
// eslint-disable-next-line max-params
) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.dialer
        .updateCadVariables({
        interactionId: detail.interactionId,
        data: interactupdateCadPayLoad,
        secureCad,
        keyId,
        keyVersion
    })
        .then(() => {
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.SUCCESS,
            thisEvent: detail,
            eventName: "ax-interaction-contact-updated",
            dispatchCustomEvent
        });
        handleUpdateCallBack("success", "");
        logger.info(`CAD Update Interaction Event: `);
    })
        .catch((err) => {
        // ContactUpdateFailed
        updateButtonProgressFlag("");
        dispatchCustomInteractionEvent({
            response: _constants__WEBPACK_IMPORTED_MODULE_7__.ERROR,
            thisEvent: detail,
            eventName: "ax-interaction-contact-update-failed",
            dispatchCustomEvent
        });
        if (err === "encryption error") {
            handleUpdateCallBack("encryption-error", (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err));
        }
        else {
            handleUpdateCallBack("error", (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err));
        }
        logger.error(`event=CADUpdateError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to initiate CAD Update : ${err}`, err);
    });
};


/***/ }),

/***/ "./src/direflow-components/InteractionControl/TransferHelper.ts":
/*!**********************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/TransferHelper.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   blindTransfer: () => (/* binding */ blindTransfer),
/* harmony export */   buddyErrorHandler: () => (/* binding */ buddyErrorHandler),
/* harmony export */   buddySuccessHandler: () => (/* binding */ buddySuccessHandler),
/* harmony export */   consultRequested: () => (/* binding */ consultRequested),
/* harmony export */   epErrorHandler: () => (/* binding */ epErrorHandler),
/* harmony export */   epSuccessHandler: () => (/* binding */ epSuccessHandler),
/* harmony export */   errorHandler: () => (/* binding */ errorHandler),
/* harmony export */   fetchEpDnList: () => (/* binding */ fetchEpDnList),
/* harmony export */   getAddressBook: () => (/* binding */ getAddressBook),
/* harmony export */   getBuddyAgentList: () => (/* binding */ getBuddyAgentList),
/* harmony export */   getBuddyAgentsListForInfiniteScrollModal: () => (/* binding */ getBuddyAgentsListForInfiniteScrollModal),
/* harmony export */   getEpDnList: () => (/* binding */ getEpDnList),
/* harmony export */   getVTeamList: () => (/* binding */ getVTeamList),
/* harmony export */   getVteamList: () => (/* binding */ getVteamList),
/* harmony export */   handleInputChange: () => (/* binding */ handleInputChange),
/* harmony export */   isNum: () => (/* binding */ isNum),
/* harmony export */   successHandler: () => (/* binding */ successHandler),
/* harmony export */   updateAddressBook: () => (/* binding */ updateAddressBook),
/* harmony export */   updateEpDnList: () => (/* binding */ updateEpDnList),
/* harmony export */   vTeamTransfer: () => (/* binding */ vTeamTransfer)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





const getPrometheusTrackingPayload = (interactionId, reason) => {
    return {
        Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
        interactionId,
        Reason: reason
    };
};
const fetchEpDnList = (orgId) => __awaiter(void 0, void 0, void 0, function* () {
    // Fetch EPDN List from agentx-backend.
    try {
        const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.abs.fetchEpDnMappings({ orgId });
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.info("Successfully fetched EP DN List:", response);
        return response;
    }
    catch (error) {
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=FetchEntryPointsMappedDialNumberError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)}] Failed to fetch Entry Points with Mapped Dialled numbers: ${error}`, error);
        throw error;
    }
});
const epDnListFetchSuccess = (data, dispatchCustomEvent) => {
    const event = new CustomEvent("ax-interaction-fetch-epdn-list-success", {
        detail: { data },
        bubbles: true,
        composed: true
    });
    if (dispatchCustomEvent) {
        dispatchCustomEvent(event);
    }
};
const epDnListFetchError = (error, dispatchCustomEvent) => {
    const event = new CustomEvent("ax-interaction-fetch-epdn-list-failure", {
        detail: { error },
        bubbles: true,
        composed: true
    });
    if (dispatchCustomEvent) {
        dispatchCustomEvent(event);
    }
};
const updateEpDnList = (orgId, dispatchCustomEvent) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetchEpDnList(orgId);
        epDnListFetchSuccess(response, dispatchCustomEvent);
        return response;
    }
    catch (error) {
        epDnListFetchError(error, dispatchCustomEvent);
        throw error;
    }
});
const getEpDnList = ({ epDnMapping, isDesktopConsultToEntryPointDnEnabled, channels, orgId, epDnFetchingStatus, dispatchCustomEvent }) => {
    if (isDesktopConsultToEntryPointDnEnabled && (channels === null || channels === void 0 ? void 0 : channels.voiceCount) > 0) {
        // Check data is already exists in STORE.
        if (!epDnMapping.initialFetchCompleted) {
            epDnFetchingStatus(true);
            updateEpDnList(orgId, dispatchCustomEvent)
                .then(() => epDnFetchingStatus(false))
                .catch(() => epDnFetchingStatus(false));
        }
        else {
            epDnFetchingStatus(false);
        }
    }
    else {
        epDnFetchingStatus(false);
    }
};
const getVTeamList = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.abs.fetchVteams({
        payload: Object.assign({}, payload),
        orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
        userId: ((_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.conf.profile) === null || _b === void 0 ? void 0 : _b.agentId) || ""
    });
});
const successHandler = (data, handleErrorMessageOnFetchSuccess) => {
    _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.info("Successfully fetched Queues :", data === null || data === void 0 ? void 0 : data.length);
    handleErrorMessageOnFetchSuccess();
};
const errorHandler = (error, setTrackingId, handleErrorMessageOnFetchFailure) => {
    setTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error));
    handleErrorMessageOnFetchFailure();
    _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=FetchVTeamListFailed | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)}] Failed to fetch VteamList : ${error}`, error);
};
const getVteamList = (payload, callback, setVteamList, setTrackingId, handleErrorMessageOnFetchSuccess, handleErrorMessageOnFetchFailure) => {
    var _a, _b;
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.abs
        .fetchVteams({
        payload: Object.assign({}, payload),
        orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
        userId: ((_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.conf.profile) === null || _b === void 0 ? void 0 : _b.agentId) || ""
    })
        .then((data) => {
        setVteamList(data);
        callback(data, _constants__WEBPACK_IMPORTED_MODULE_3__.NAME, _Common_constants__WEBPACK_IMPORTED_MODULE_1__.QUEUES);
        successHandler(data, handleErrorMessageOnFetchSuccess);
    })
        .catch((error) => {
        callback([], _constants__WEBPACK_IMPORTED_MODULE_3__.NAME, _Common_constants__WEBPACK_IMPORTED_MODULE_1__.QUEUES);
        errorHandler(error, setTrackingId, handleErrorMessageOnFetchFailure);
    });
};
const getBuddyAgentsListForInfiniteScrollModal = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.buddyAgentsV2({ data: payload });
});
const buddySuccessHandler = (data, handleErrorMessageOnFetchSuccess) => {
    handleErrorMessageOnFetchSuccess();
    _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.info("Successfully fetched BuddyAgents :", data.data.agentList);
};
const buddyErrorHandler = (error, setTrackingId, handleErrorMessageOnFetchFailure) => {
    handleErrorMessageOnFetchFailure();
    setTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error));
    _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=FetchBuddyAgentsError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)}] Failed to fetch BuddyAgents : ${error}`, error);
};
const epSuccessHandler = (data, handleErrorMessageOnFetchSuccess, agentAction) => {
    handleErrorMessageOnFetchSuccess();
    _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.info(`On ${agentAction} action, Successfully fetched EntryPoints : ${data}`);
};
const epErrorHandler = (error, setTrackingId, handleErrorMessageOnFetchFailure, agentAction) => {
    handleErrorMessageOnFetchFailure();
    setTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error));
    _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=FetchEntryPointError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)}] On ${agentAction} action, Failed to fetch Entry Points : ${error}`, error);
};
const getBuddyAgentList = (payload, callback, setbuddyList, setTrackingId, handleErrorMessageOnFetchSuccess, handleErrorMessageOnFetchFailure) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .buddyAgentsV2({ data: payload })
        .then((data) => {
        setbuddyList(data.data.agentList);
        buddySuccessHandler(data, handleErrorMessageOnFetchSuccess);
        callback(data.data.agentList, _constants__WEBPACK_IMPORTED_MODULE_3__.AGENT_NAME, _Common_constants__WEBPACK_IMPORTED_MODULE_1__.AGENTS);
    })
        .catch((error) => {
        callback([], _constants__WEBPACK_IMPORTED_MODULE_3__.AGENT_NAME, _Common_constants__WEBPACK_IMPORTED_MODULE_1__.AGENTS);
        buddyErrorHandler(error, setTrackingId, handleErrorMessageOnFetchFailure);
    });
};
const addressBookHandleSuccess = (data, dispatchCustomEvent) => {
    const event = new CustomEvent("ax-interaction-fetch-addressbook-list-success", {
        detail: { data },
        bubbles: true,
        composed: true
    });
    if (dispatchCustomEvent) {
        dispatchCustomEvent(event);
    }
};
const addressBookHandleError = (error, dispatchCustomEvent) => {
    const event = new CustomEvent("ax-interaction-fetch-addressbook-list-failure", {
        detail: { error },
        bubbles: true,
        composed: true
    });
    if (dispatchCustomEvent) {
        dispatchCustomEvent(event);
    }
};
const updateAddressBook = (dispatchCustomEvent, agentAction) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_2__.fetchAddressBookList)();
        addressBookHandleSuccess(response, dispatchCustomEvent);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.ADDRESS_BOOK, {
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_PROPS.ADDRESS_BOOK_LIST]: agentAction
        });
        return response;
    }
    catch (error) {
        addressBookHandleError(error, dispatchCustomEvent);
        throw error;
    }
});
const getAddressBook = ({ addressBook, addressBookFetchingStatus, dispatchCustomEvent, agentAction }) => {
    if (!addressBook.initialFetchCompleted) {
        updateAddressBook(dispatchCustomEvent, agentAction)
            .then(() => addressBookFetchingStatus(false))
            .catch(() => addressBookFetchingStatus(false));
    }
    else {
        addressBookFetchingStatus(false);
    }
};
const consultRequested = (interactionId, payload, handleCloseModal, setStateFunctions, url, ctqInProgress, setCtqInProgress) => {
    const { setShowErrorMessage, setTrackingId, setShouldDisableSubmitBtn, setShowFetchErrorMessage, setShowCtqErrorMessage, setShowCustomerLeftMessage, disableLoader } = setStateFunctions;
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .consultV2(payload)
        .then(() => {
        if (typeof setCtqInProgress === "function") {
            setCtqInProgress(false);
        }
        handleCloseModal(ctqInProgress);
    })
        .catch((err) => {
        var _a, _b, _c, _d;
        if (setShowErrorMessage) {
            setShowErrorMessage(true);
        }
        setShowFetchErrorMessage(false);
        setShowCtqErrorMessage(false);
        setShouldDisableSubmitBtn(false);
        setShowCustomerLeftMessage(false);
        disableLoader();
        setTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err));
        if (typeof setCtqInProgress === "function") {
            setCtqInProgress(false);
        }
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=InitiateConsultError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to initiate Consult request : ${err}`, err);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_CLICKED, Object.assign({}, getPrometheusTrackingPayload(interactionId, "InitiateConsultError")), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
    });
};
const blindTransfer = (interactionId, payload, detail, dispatchCustomEvent, handleCloseModal, setStateFunctions, eventEmitted) => {
    const { setShowErrorMessage, setTrackingId, setShouldDisableSubmitBtn, setShowFetchErrorMessage, disableLoader } = setStateFunctions;
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .blindTransferV2({
        interactionId,
        data: payload
    })
        .then(() => {
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.info(`blindTransfer: success for interactionId : ${interactionId}`);
    })
        .catch((err) => {
        var _a, _b, _c, _d;
        if (setShowErrorMessage) {
            setShowErrorMessage(true);
        }
        setShowFetchErrorMessage(false);
        setShouldDisableSubmitBtn(false);
        disableLoader();
        setTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err));
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=BlindTransferError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] blindTransfer to Agent failed: ${err}`, err);
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.dispatchCustomInteractionEvent)({
            response: _constants__WEBPACK_IMPORTED_MODULE_3__.SUCCESS,
            thisEvent: detail,
            eventName: eventEmitted,
            dispatchCustomEvent
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_TRANSFER_CLICKED, Object.assign({}, getPrometheusTrackingPayload(interactionId, "BlindTransferError")), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
    });
};
const vTeamTransfer = (interactionId, payload, handleCloseModal, setStateFunctions) => {
    const { setShowErrorMessage, setTrackingId, setShowFetchErrorMessage, setShouldDisableSubmitBtn, disableLoader } = setStateFunctions;
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .vteamTransferV2({ interactionId, data: payload })
        .then(() => {
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.info(`vteams blindTransfer : success for interactionId : ${interactionId}`);
    })
        .catch((err) => {
        var _a, _b, _c, _d;
        setShowFetchErrorMessage(false);
        if (setShowErrorMessage) {
            setShowErrorMessage(true);
        }
        setShouldDisableSubmitBtn(false);
        setTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err));
        disableLoader();
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=VTeamTransferError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] vteamTransfer failed: ${err}`, err);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_TRANSFER_CLICKED, Object.assign({}, getPrometheusTrackingPayload(interactionId, "VTeamTransferError")), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
    });
};
const isNum = (data) => {
    return /^\d+$/.test(data);
};
const handleInputChange = (input, defaultListType, selectedValue, setShowErrorDnVaildation, setSelectedValue, inputWithoutFormat) => {
    // on input value handle selectedValue and submit button
    if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_1__.DIAL_NUMBER) {
        // TODO: dn validation need to be confirmed.
        // eslint-disable-next-line
        const regexForDn = new RegExp("^[+1][0-9]{3,18}$|^[*#:][+1][0-9*#:]{3,18}$|^[0-9*#:]{3,18}$");
        if (!regexForDn.test(input)) {
            // if input entered is of less than 3 characters then we ask to input more characters and donot show this error message.
            inputWithoutFormat.length >= 3 ? setShowErrorDnVaildation(true) : setShowErrorDnVaildation(false);
            if (isNum(input)) {
                setSelectedValue(input);
            }
            else {
                setSelectedValue("");
            }
        }
        else {
            setShowErrorDnVaildation(false);
            setSelectedValue(input);
        }
    }
    else {
        setSelectedValue(input === selectedValue ? input : "");
    }
};


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/Accordion/Accordion.tsx":
/*!***************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/Accordion/Accordion.tsx ***!
  \***************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-mfe-wc-based */ "@agentx/agentx-mfe-wc-based");
/* harmony import */ var _agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! use-resize-observer/polyfilled */ "../../node_modules/use-resize-observer/polyfilled.js");
/* harmony import */ var use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../InteractionPopoverManager/Utils/InteractionPopoversUtils */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts");
/* harmony import */ var _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Utility/Utils/InteractionControlUtils */ "./src/direflow-components/Utility/Utils/InteractionControlUtils.ts");
/* harmony import */ var _WrapUp_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../WrapUp/components */ "./src/direflow-components/WrapUp/components/index.tsx");
/* harmony import */ var _AccordionHelper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../AccordionHelper */ "./src/direflow-components/InteractionControl/AccordionHelper.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");
/* harmony import */ var _reducer__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../reducer */ "./src/direflow-components/InteractionControl/reducer.ts");
/* harmony import */ var _AdditionalDetails_AdditionalDetails__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../AdditionalDetails/AdditionalDetails */ "./src/direflow-components/InteractionControl/components/AdditionalDetails/AdditionalDetails.tsx");
/* harmony import */ var _AccordionUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./AccordionUtils */ "./src/direflow-components/InteractionControl/components/Accordion/AccordionUtils.tsx");

/* eslint-disable no-lone-blocks */





















var RouteName;
(function (RouteName) {
    RouteName["TASK"] = "task";
    RouteName["TASKPANEL"] = "task-panel";
})(RouteName || (RouteName = {}));
const RoutePath = {
    [RouteName.TASK]: "/",
    [RouteName.TASKPANEL]: "/task/:taskId"
};
const Accordion = react__WEBPACK_IMPORTED_MODULE_8__.memo(({ interactionTimer, contactInformation, interactionButtons, currentStateTimer, action, wrapUpData, agentWrapUpCodeProps, agentId, interactionId, isOpen, isVoiceInteraction, isVoiceIntPaneUpdatedByUser, currentRoute, isInteractionCADContainersExpanded, isMainContainerCADExpanded, isConsultContainerCADExpanded, isConsultView, updateButtonProgressFlag, showLoaderButtonType, cadSuppressedList, configCadVariables, focusOnInteractionButton, decryptedState, retryDecryption, buttonDisableState, isSecureCADVariablesEnabled, isIMIGlobalVariablesEnabled, isGlobalVariablesEnabled, isSecondaryEpDnAgent, isDarkMode, isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled, dtmfValue, agentCallMonitoringState, isWxccMultiPartyConfEnabled, isPersistCallEnabled, setEmptyFocusOnInteractionButton, isDesktopAuxCodesInfiniteScrollEnabled, isInteractionBtnConfirmDialogEnabled, isConsultPanelVisualUpdateEnabled, webexCallingCallId }) => {
    var _a;
    const [isExpanded, setIsExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(isOpen);
    const { interaction_control, common, channelNameLabels } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_9__.useI18nContext)();
    const [iconType, setIconType] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)("");
    const [iconColor, setIconColor] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)("");
    const [badgeColor, setBadgeColor] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)("");
    const [cadVariables, setCADVariables] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([]);
    const [customerInfo, setCustomerInfo] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)({});
    const [nameOverflow, setNameOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false);
    const [recordingStatus, setRecordingStatus] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)("");
    const [cadUpdated, setCADUpdated] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)("");
    const [trackingId, setTrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)("");
    const [callAssociatedData, setCallAssociatedData] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(Object.assign({}, contactInformation.callAssociatedData));
    const [isDisabled, setIsDisabled] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(true);
    const [cadVariableFromConfig, setCadVariableFromConfig] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(configCadVariables);
    const [prevState, setPrevState] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(contactInformation.state);
    const [cadValidationError, setCadValidationError] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false);
    const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useReducer)(_reducer__WEBPACK_IMPORTED_MODULE_18__.CadVariablesUpdate, {});
    const [secureCad, setSecureCad] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([]);
    const dispatchEvent = (0,react__WEBPACK_IMPORTED_MODULE_8__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_4__.EventContext);
    const [editedCADVariables, setEditedCADVariables] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)({
        attributes: {}
    });
    const nameRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    const timerRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(-1);
    const [fullButtonContainerWidth, setFullButtonContainerWidth] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(0);
    const [areCompactButtons, setCompactButtons] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false);
    const [compactDetails, setCompactDetails] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false);
    const [keyId, setKeyId] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(null);
    const [keyVersion, setKeyVersion] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(null);
    const interactionControlRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    const infoSectionRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    const accordionRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    const buttonContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    const announceBadgeStatusTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    const restoreCopyTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    const contactInformationRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(contactInformation);
    contactInformationRef.current = contactInformation;
    const [accordionWidth, setAccordionWidth] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(0);
    const [infoSectionWidth, setInfoSectionWidth] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(0);
    const { height: interactionControlHeight } = use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_21___default()({
        ref: interactionControlRef
    });
    const updateNavEventName = "ax-update-navigation-warning";
    const compactDetailsScreen = 735;
    const consultInteractionGutter = 12;
    use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_21___default()({
        ref: buttonContainerRef,
        onResize: ({ width }) => {
            if (width && !areCompactButtons) {
                setFullButtonContainerWidth(width);
            }
        }
    });
    const updateCompactDetails = (value) => {
        setCompactDetails(value);
    };
    const updateCompactButtons = (value) => {
        setCompactButtons(value);
    };
    use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_21___default()({
        ref: accordionRef,
        onResize: ({ width }) => {
            if (width) {
                setAccordionWidth(width);
                (0,_AccordionUtils__WEBPACK_IMPORTED_MODULE_20__.handleAccordionRefChange)(width, accordionWidth, compactDetailsScreen, updateCompactDetails, infoSectionWidth, fullButtonContainerWidth, updateCompactButtons);
            }
        }
    });
    use_resize_observer_polyfilled__WEBPACK_IMPORTED_MODULE_21___default()({
        ref: infoSectionRef,
        onResize: ({ width }) => {
            if (width) {
                setInfoSectionWidth(width);
                (0,_AccordionUtils__WEBPACK_IMPORTED_MODULE_20__.infoSectionRefChange)(width, accordionWidth, fullButtonContainerWidth, updateCompactButtons);
            }
        }
    });
    const resetButtonsWidth = () => {
        setCompactButtons(false);
        setFullButtonContainerWidth(0);
    };
    // shouldAnnounceMonitoring will check if the contact information is monitoring or not.
    // Also, whenever the user presses the pause or resume monitoring button the announcement should also be made.
    const shouldAnnounceMonitoring = () => {
        const monitoringStatus = (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.getRightSplitBadgeText)(infoSectionRef);
        return (contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.MIDCALL_MONITORING &&
            (monitoringStatus === interaction_control.monitoringPaused ||
                monitoringStatus === interaction_control.monitoring ||
                monitoringStatus === interaction_control.bargedIn));
    };
    // This useEffect is used to announce the monitoring badge, when the supervisor enters monitoring.
    // Also called when the buttons get updated.
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        if (shouldAnnounceMonitoring()) {
            announceBadgeStatusTimeoutIdRef.current = window.setTimeout(() => (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.announceBadgeStatus)(infoSectionRef), 500);
        }
        return () => {
            if (announceBadgeStatusTimeoutIdRef.current) {
                window.clearTimeout(announceBadgeStatusTimeoutIdRef.current);
            }
        };
    }, [contactInformation.mediaType, (_a = buttonContainerRef === null || buttonContainerRef === void 0 ? void 0 : buttonContainerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("md-button")]);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        return () => {
            if (restoreCopyTimeoutIdRef.current) {
                window.clearTimeout(restoreCopyTimeoutIdRef.current);
            }
        };
    }, []);
    const getButtonProperties = () => {
        return {
            showLoaderButtonType,
            updateButtonProgressFlag,
            areCompactButtons,
            focusOnInteractionButton,
            setEmptyFocusOnInteractionButton
        };
    };
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        if (isSecureCADVariablesEnabled) {
            const secureCAD = [];
            let currentKeyId = null;
            let currentKeyVersion = null;
            Object.entries(state).forEach(([key, value]) => {
                if (value.isSecure) {
                    if (secureCAD.length === 0) {
                        currentKeyId = value.secureKeyId;
                        currentKeyVersion = value.secureKeyVersion;
                    }
                    secureCAD.push(key);
                }
            });
            setSecureCad(secureCAD);
            setKeyId(currentKeyId);
            setKeyVersion(currentKeyVersion);
        }
    }, [state, keyId, keyVersion, isSecureCADVariablesEnabled]);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        var _a, _b, _c;
        if (!isConsultView &&
            dispatchEvent &&
            (contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE ||
                contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.OUTBOUND_VOICE)) {
            dispatchEvent(new CustomEvent("ax-main-cad-section-dimension", {
                detail: {
                    height: (_a = interactionControlRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height
                }
            }));
        }
        else if (dispatchEvent &&
            (contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE ||
                contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.OUTBOUND_VOICE)) {
            if (!contactInformation.isOwner) {
                dispatchEvent(new CustomEvent("ax-main-cad-section-dimension", {
                    detail: {
                        height: (_b = interactionControlRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height
                    }
                }));
            }
            else {
                dispatchEvent(new CustomEvent("ax-consult-cad-section-dimension", {
                    detail: {
                        height: ((_c = interactionControlRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().height) + consultInteractionGutter
                    }
                }));
            }
        }
    }, [isExpanded, interactionControlHeight]);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        window.addEventListener("call-recording-started", resetButtonsWidth);
        return () => {
            window.removeEventListener("call-recording-started", resetButtonsWidth);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        resetButtonsWidth();
        dispatch({ type: "RESTORE", payload: { customerInfo: {} } });
        setCustomerInfo({});
    }, [interactionId]);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useLayoutEffect)(() => {
        /* Interaction Buttons Responsiveness */
        if (accordionWidth && infoSectionWidth && fullButtonContainerWidth !== 0) {
            const entireInfoSpace = infoSectionWidth + 35;
            const availableButtonSpace = accordionWidth - entireInfoSpace;
            if (fullButtonContainerWidth > availableButtonSpace) {
                setCompactButtons(true);
            }
            else {
                setCompactButtons(false);
            }
        }
    }, [fullButtonContainerWidth]);
    const interactionButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(interactionButtons);
    interactionButtonRef.current = interactionButtons;
    const isExpandedRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(isExpanded);
    isExpandedRef.current = isExpanded;
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        // Specific case for consult view to show exit button on second agent side only .
        setIconColor("");
        if (contactInformation.isOwner && isConsultView) {
            setIconType("handset-active_12");
            setBadgeColor("green");
            setCADVariables(_constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.CONSULT_VIEW);
            return;
        }
        const derivedMediaChannelType = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_11__.getDerivedMediaChannelForDirection)(contactInformation.mediaChannel, contactInformation.contactDirection);
        const channelType = contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.SOCIAL || (0,_InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__.isMediaTypeDigitalOutbound)(derivedMediaChannelType !== null && derivedMediaChannelType !== void 0 ? derivedMediaChannelType : "")
            ? derivedMediaChannelType
            : contactInformation.mediaType;
        switch (channelType) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.CHAT:
                setIconType("chat-active_14");
                setBadgeColor("blue");
                setCADVariables(isIMIGlobalVariablesEnabled ? _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.IMI_DIGITAL : _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.CHAT);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.EMAIL:
                setIconType("email-active_16");
                setBadgeColor("violet");
                setCADVariables(isIMIGlobalVariablesEnabled ? _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.IMI_DIGITAL : _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.EMAIL);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE:
                {
                    if (contactInformation.outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CALLBACK) {
                        setCADVariables(_constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.OUTDIAL_VOICE);
                        setIconType("icon-callback_12");
                        setBadgeColor("lime");
                        setIconColor("");
                    }
                    else if (contactInformation.contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.OUTBOUND &&
                        contactInformation.outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.COURTESY_CALLBACK) {
                        setIconType("icon-callback_12");
                        setBadgeColor("lime");
                    }
                    else if ((contactInformation.outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.PROGRESSIVE_CAMPAIGN && isProgressiveCampaignEnabled) ||
                        (isProgressiveCampaign1NEnabled &&
                            (contactInformation.outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CAMPAIGN_OUTDIAL_CUSTOMER ||
                                contactInformation.outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER ||
                                contactInformation.outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CAMPAIGN))) {
                        setIconType("icon-campaign_12");
                        setBadgeColor("green");
                    }
                    else {
                        setIconType("handset-active_12");
                        setBadgeColor("green");
                    }
                    if (contactInformation.contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.OUTBOUND) {
                        setCADVariables(_constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.OUTDIAL_VOICE);
                    }
                    else {
                        setCADVariables(_constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.VOICE);
                    }
                }
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.MIDCALL_MONITORING:
                {
                    setIconType("handset-active_12");
                    setBadgeColor("green");
                    const cadVariables = isWxccMultiPartyConfEnabled
                        ? _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.MONITORING_MULTI_PARTY
                        : _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.MONITORING;
                    setCADVariables(cadVariables);
                }
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.SMS:
                setIconType("sms_16");
                setBadgeColor("#16A693");
                setIconColor("#ffffff");
                setCADVariables(isIMIGlobalVariablesEnabled ? _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.IMI_DIGITAL : _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.SMS);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.FACEBOOK:
                setIconType("messenger_12");
                setBadgeColor("#0078FF");
                setIconColor("#ffffff");
                setCADVariables(isIMIGlobalVariablesEnabled ? _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.IMI_DIGITAL : _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.FACEBOOK);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.WHATSAPP:
                setIconType("whatsApp_12");
                setBadgeColor("#25D366");
                setIconColor("#ffffff");
                setCADVariables(isIMIGlobalVariablesEnabled ? _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.IMI_DIGITAL : _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.WHATSAPP);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.APPLE_BUSINESS_CHAT:
                setCADVariables(isIMIGlobalVariablesEnabled ? _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.IMI_DIGITAL : _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.APPLE_BUSINESS_CHAT);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.GOOGLE_BUSINESS_CHAT:
                setCADVariables(isIMIGlobalVariablesEnabled ? _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.IMI_DIGITAL : _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.GOOGLE_BUSINESS_CHAT);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_EMAIL:
                setCADVariables(isIMIGlobalVariablesEnabled ? _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.IMI_DIGITAL : _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.EMAIL);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_SMS:
                setCADVariables(isIMIGlobalVariablesEnabled ? _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.IMI_DIGITAL : _constants__WEBPACK_IMPORTED_MODULE_16__.cadVariablesMap.SMS);
                break;
            default:
                break;
        }
        if (nameRef.current) {
            if (nameRef.current.scrollWidth > nameRef.current.clientWidth) {
                setNameOverflow(true);
            }
            else {
                setNameOverflow(false);
            }
        }
    }, [interactionId]);
    const handleUpdateCallBack = (resopnse, trackingIdValue) => {
        if (resopnse === "success") {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CAD_VARIABLE_UPDATED, {
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.CALL_DIRECTION]: contactInformation.contactDirection,
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.INTERACTION_ID]: interactionId,
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
            });
            setEditedCADVariables({ attributes: {} });
            setIsDisabled(true);
            setCADUpdated("success");
            if (dispatchEvent) {
                dispatchEvent(new CustomEvent(updateNavEventName, {
                    detail: { key: "cadVariables", value: false }
                }));
            }
            (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.handleTimeOutForCallBack)(setCADUpdated, "", _constants__WEBPACK_IMPORTED_MODULE_16__.TIME_TO_REMOVE_MESSAGE); // remove success message after 10 sec
        }
        else if (resopnse === "encryption-error") {
            setCADUpdated("encryption-error");
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CAD_VARIABLE_UPDATED, {
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.CALL_DIRECTION]: contactInformation.contactDirection,
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.INTERACTION_ID]: interactionId,
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                Reason: "EncryptionError"
            });
        }
        else {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CAD_VARIABLE_UPDATED, {
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.CALL_DIRECTION]: contactInformation.contactDirection,
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.INTERACTION_ID]: interactionId,
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                Reason: "CADUpdateError"
            });
            setTrackingId(trackingIdValue);
            setCADUpdated("error");
        }
    };
    const submitCadValues = (submitType) => {
        if (submitType === "Save") {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CAD_VARIABLE_UPDATED);
            updateButtonProgressFlag("Save");
            const detail = { interactionId };
            (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_17__.updateCadVariable)(detail, editedCADVariables, dispatchEvent, updateButtonProgressFlag, handleUpdateCallBack, secureCad, keyId, keyVersion);
        }
        else {
            setCADVariables(Object.create(cadVariables));
            updateButtonProgressFlag("");
            setCADUpdated("");
            setCadValidationError(false);
            setEditedCADVariables({ attributes: {} });
            setIsDisabled(true);
            if (dispatchEvent) {
                dispatchEvent(new CustomEvent(updateNavEventName, {
                    detail: { key: "cadVariables", value: false }
                }));
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        //Update the isExpanded to computed value, while navigating to task page
        if (currentRoute === RouteName.TASKPANEL || currentRoute === RouteName.TASK) {
            if (isExpanded !== isOpen) {
                setIsExpanded(isOpen);
            }
        }
        else {
            setIsExpanded(false);
        }
    }, [currentRoute]);
    const updateUserVoiceIntPaneState = (isCollapsed) => {
        dispatchEvent(new CustomEvent("ax-update-uservoiceIntPaneState", {
            detail: isCollapsed,
            bubbles: true,
            composed: true
        }));
    };
    const updateUserClickVoicePaneState = (state) => {
        const isVoiceInteractionAndTaskPage = isVoiceInteraction && (currentRoute === RouteName.TASKPANEL || currentRoute === RouteName.TASK);
        const isVoiceInteractionAndNullRoute = currentRoute === null && isVoiceInteraction && window.location.href.indexOf(RouteName.TASK) > -1;
        if (isVoiceInteractionAndTaskPage || isVoiceInteractionAndNullRoute) {
            updateUserVoiceIntPaneState(state);
        }
    };
    const toogleActive = () => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.INTERACTION_CONTROL_PANE_TOGGLE);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.INTERACTION_CONTROL_PANE_TOGGLE, {
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.INTERACTION_CONTROL_STATE]: !isExpanded ? "Expanded" : "Minimized",
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
        });
        if (isExpanded === undefined) {
            setIsExpanded(!isExpandedRef.current);
            if (!isConsultView) {
                updateUserClickVoicePaneState(!isExpandedRef.current);
            }
        }
        else {
            setIsExpanded(!isExpanded);
            if (!isConsultView) {
                updateUserClickVoicePaneState(!isExpanded);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        setIsExpanded(!isInteractionCADContainersExpanded);
    }, [isInteractionCADContainersExpanded]);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        if ((contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE ||
            contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.OUTBOUND_VOICE) &&
            !isInteractionCADContainersExpanded) {
            if (!isConsultView && isMainContainerCADExpanded) {
                setIsExpanded(isMainContainerCADExpanded);
            }
            else if (isConsultView && isConsultContainerCADExpanded) {
                setIsExpanded(isConsultContainerCADExpanded);
            }
            else if (!isMainContainerCADExpanded && !isConsultContainerCADExpanded) {
                setIsExpanded(false);
            }
        }
    }, [isInteractionCADContainersExpanded, isMainContainerCADExpanded, isConsultContainerCADExpanded]);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        if (isVoiceIntPaneUpdatedByUser === null || !isConsultView) {
            setIsExpanded(isOpen);
        }
    }, [isOpen, interactionId]);
    const disableShortcutKeyForBtnsHavingConfirmDialog = (isConferencing, matchedButtonType) => {
        const BUTTONS_HAVING_CONFIRM_DIALOG = [_Common_constants__WEBPACK_IMPORTED_MODULE_10__.END_BUTTON, _Common_constants__WEBPACK_IMPORTED_MODULE_10__.EXIT_CONFERENCE];
        return (isInteractionBtnConfirmDialogEnabled &&
            BUTTONS_HAVING_CONFIRM_DIALOG.includes(matchedButtonType) &&
            isConferencing);
    };
    const executeAccordianShortcuts = (key) => {
        let matchedButton = [];
        if (interactionButtonRef.current && key.data) {
            const matchedKeys = (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.getInteractionControlShortcutKeys)().filter((data) => { var _a, _b; return data.key === ((_a = key.data) === null || _a === void 0 ? void 0 : _a.key) && data.modifierKeys === ((_b = key.data) === null || _b === void 0 ? void 0 : _b.modifierKeys); });
            if (matchedKeys && matchedKeys.length > 0) {
                matchedButton = interactionButtonRef.current.filter((button) => matchedKeys[0].actionButtons.includes(button.type) && button.visible && !button.disabled);
            }
            if (matchedButton && matchedButton.length > 0) {
                const contactInformation = Object.assign({}, contactInformationRef.current);
                if (disableShortcutKeyForBtnsHavingConfirmDialog(contactInformation.isConferencing, matchedButton[0].type)) {
                    return;
                }
                action({
                    type: matchedButton[0].type.split("_")[0],
                    interactionId: contactInformationRef.current.interactionId
                }, contactInformation);
                updateButtonProgressFlag(matchedButton[0].type);
                return;
            }
        }
        if (!isDisabled) {
            if (key.data &&
                key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.REGISTERED_KEYS.SAVE_EDITED_CAD_KEY &&
                key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
                submitCadValues("Save");
            }
            else if (key.data &&
                key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.REGISTERED_KEYS.REVERT_EDITED_CAD_KEY &&
                key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
                submitCadValues("Revert");
            }
        }
        if (key.data &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.REGISTERED_KEYS.EXPAND_COLLAPSE_INTERACTION_PANEL_KEY &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
            toogleActive();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.event.listenKeyPress((key) => executeAccordianShortcuts(key));
        return () => {
            if (stopListen) {
                stopListen();
            }
        };
    }, [isDisabled, isWxccMultiPartyConfEnabled, isPersistCallEnabled]);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        if (!lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(callAssociatedData, contactInformation.callAssociatedData)) {
            setCallAssociatedData(Object.assign({}, contactInformation.callAssociatedData));
            // update other agent side if he is also edited cad variables
            if (contactInformation.updatedBy &&
                contactInformation.updatedBy !== agentId &&
                Object.keys(editedCADVariables.attributes).length !== 0) {
                setEditedCADVariables({ attributes: {} });
                setIsDisabled(true);
                setCADUpdated("message");
                (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.handleTimeOutForCallBack)(setCADUpdated, "", _constants__WEBPACK_IMPORTED_MODULE_16__.TIME_TO_REMOVE_MESSAGE); // remove warning message after 10sec
            }
        }
        if (!lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(configCadVariables, cadVariableFromConfig)) {
            setCadVariableFromConfig(configCadVariables);
        }
        if (contactInformation.state !== prevState) {
            if (prevState !== contactInformation.state &&
                (contactInformation.state === "connected" || contactInformation.state === "conference")) {
                setCallAssociatedData(Object.assign({}, contactInformation.callAssociatedData));
            }
            setPrevState(contactInformation.state);
        }
    }, [contactInformation, contactInformation.callAssociatedData, configCadVariables, editedCADVariables]);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        // Set for CAD variables
        const cadList = {};
        if (contactInformation) {
            /*
             * This method updates the cadList based on the given cadVariables fixed map.
             * In case of,
             *  1. IMI Digital channels where global_variables_imi is disabled for the org,
             *  2. Native Digital channels,
             * the cadList is computed with fixed set of variables.
             *
             * In case of, IMI Digital channels where global_variables_imi is enabled for the org,
             *  then only variables related to consult/conference are added.
             *  Reading from CAD section is taken care in below method `updateCadListFromCADIMIDigital` call.
             */
            (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.updateCadList)(cadList, contactInformation, agentId, isConsultView, cadVariables, isWxccMultiPartyConfEnabled);
        }
        if ((contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE ||
            contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.MIDCALL_MONITORING ||
            contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.OUTBOUND_VOICE) &&
            (!isConsultView || !(0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_13__.isAgentConsulting)(contactInformation, isWxccMultiPartyConfEnabled))) {
            if (contactInformation.isFcManaged === false && contactInformation.callAssociatedData) {
                (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.updateCadListFromConfig)(cadList, cadSuppressedList, configCadVariables, contactInformation.callAssociatedData, contactInformation.isFcManaged, isGlobalVariablesEnabled, isSecondaryEpDnAgent, contactInformation.mediaType, contactInformation.fcDesktopViewCad);
            }
            else if (contactInformation.isFcManaged === true && contactInformation.callAssociatedData) {
                (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.updateCadListFromConfig)(cadList, cadSuppressedList, contactInformation.callAssociatedData, contactInformation.callAssociatedData, contactInformation.isFcManaged, isGlobalVariablesEnabled, isSecondaryEpDnAgent, contactInformation.mediaType, contactInformation.fcDesktopViewCad);
            }
            if (contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.MIDCALL_MONITORING) {
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_17__.logger.info("[App: Accordion] cad variables updated for MCM at time", performance.now());
            }
        }
        else if (isIMIGlobalVariablesEnabled) {
            /*
             * IMI Digital Channels:
             * Compute the CAD list from CAD Section of interation as
             * global_variables_imi FF is ON and mediaMgr is digitalmm
             */
            (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.updateCadListFromCADIMIDigital)(cadList, cadSuppressedList, contactInformation.callAssociatedData);
        }
        setCustomerInfo(Object.assign({}, cadList));
        dispatch({ type: "UPDATE", payload: { customerInfo: Object.assign({}, cadList) } });
    }, [
        interactionId,
        cadVariables,
        callAssociatedData,
        decryptedState,
        cadVariableFromConfig,
        contactInformation.destAgentId,
        contactInformation.destAgentName,
        contactInformation.contactStatus,
        contactInformation.state,
        contactInformation.activeParticipants,
        contactInformation.consultedParticipant,
        contactInformation.participants
    ]);
    const handleKeyPress = (event) => {
        if (event.key === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.ENTER_KEY || event.key === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.SPACE_KEY) {
            toogleActive();
        }
    };
    const restoreCopy = (data) => {
        customerInfo[data.name].isCopied = false;
        customerInfo[data.name].isShowCopy = false;
        dispatch({
            type: "UPDATE",
            payload: { customerInfo: Object.assign({}, customerInfo) }
        });
    };
    const copyText = (e, changeValue) => {
        var _a, _b, _c;
        const el = document.createElement("textarea");
        if (changeValue.value === undefined) {
            el.value = "";
        }
        else if (_Common_constants__WEBPACK_IMPORTED_MODULE_10__.TIMER_FIELDS.includes(changeValue.displayName.toLowerCase())) {
            const start = luxon__WEBPACK_IMPORTED_MODULE_7__.DateTime.fromMillis(Number(changeValue.value));
            const now = luxon__WEBPACK_IMPORTED_MODULE_7__.DateTime.utc();
            el.value = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_11__.formatDuration)(now.diff(start));
        }
        else {
            el.value = changeValue.value;
        }
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        customerInfo[changeValue.name].isCopied = true;
        customerInfo[changeValue.name].isShowCopy = false;
        dispatch({
            type: "UPDATED",
            payload: { customerInfo: Object.assign({}, customerInfo) }
        });
        setCustomerInfo(Object.assign({}, customerInfo));
        // keep the focus on the button after copy
        (_c = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button")) === null || _c === void 0 ? void 0 : _c.focus();
        if (restoreCopyTimeoutIdRef.current) {
            window.clearTimeout(restoreCopyTimeoutIdRef.current);
        }
        restoreCopyTimeoutIdRef.current = window.setTimeout(() => {
            restoreCopy(changeValue);
        }, 1000);
    };
    const enableCadButtons = (editableField, cadObject) => {
        if (editableField && editableField !== cadObject.value) {
            setIsDisabled(false);
        }
        else {
            setIsDisabled(showLoaderButtonType !== "" || Object.keys(editedCADVariables.attributes).length === 0);
        }
    };
    const setCadValidationResult = (isValid) => {
        setCadValidationError(isValid);
        setCADUpdated("");
    };
    const showDNISInCAD = !((contactInformation === null || contactInformation === void 0 ? void 0 : contactInformation.state) === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONFERENCE.toLowerCase() ||
        contactInformation.isWrapUpAssist ||
        contactInformation.isInteractionInPostCall) &&
        contactInformation.destAgentType === "EpDn" &&
        isConsultView;
    const getTimeStamp = () => {
        return { currentStateTimer, interactionTimer };
    };
    const getBadgeAndIcon = () => {
        return { badgeColor, iconType, iconColor };
    };
    function getEditedCADValues(editableField, cadObject) {
        if (Object.keys(editedCADVariables.attributes).includes(cadObject.name)) {
            if (cadObject.value === editableField &&
                contactInformation.callAssociatedData &&
                editableField === (contactInformation === null || contactInformation === void 0 ? void 0 : contactInformation.callAssociatedData[cadObject.name].value)) {
                delete editedCADVariables.attributes[cadObject.name];
                setEditedCADVariables(editedCADVariables);
            }
            else {
                editedCADVariables.attributes[cadObject.name] = editableField;
                setEditedCADVariables(editedCADVariables);
            }
        }
        else if (editableField !== cadObject.value) {
            editedCADVariables.attributes[cadObject.name] = editableField;
            setEditedCADVariables(editedCADVariables);
        }
        if (editableField !== cadObject.value) {
            const data = Object.assign({}, state);
            data[cadObject.name].value = editableField;
            dispatch({
                type: "UPDATED",
                payload: { value: Object.assign({}, data[cadObject.name]) }
            });
        }
        if (Object.keys(editedCADVariables.attributes).length > 0 && dispatchEvent) {
            dispatchEvent(new CustomEvent(updateNavEventName, {
                detail: { key: "cadVariables", value: true }
            }));
        }
        setIsDisabled(showLoaderButtonType !== "" || Object.keys(editedCADVariables.attributes).length === 0);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        setIsDisabled(showLoaderButtonType !== "" || Object.keys(editedCADVariables.attributes).length === 0);
    }, [showLoaderButtonType]);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.defineInteractionBadge)(contactInformation, (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_17__.getChatInteractionStatus)(contactInformation, interaction_control), (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_17__.getLocalizedInteractionStatus)(contactInformation, isConsultView, interaction_control, isConsultPanelVisualUpdateEnabled, agentCallMonitoringState), getTimeStamp(), getBadgeAndIcon(), isConsultView, channelNameLabels, interaction_control, isDarkMode, agentCallMonitoringState, isWxccMultiPartyConfEnabled, isPersistCallEnabled, isConsultPanelVisualUpdateEnabled, agentId);
    }, []);
    const renderAdditionalDetails = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AdditionalDetails_AdditionalDetails__WEBPACK_IMPORTED_MODULE_19__["default"], { customerInfo: Object.assign({}, state), isIMIGlobalVariablesEnabled: isIMIGlobalVariablesEnabled, isGlobalVariablesEnabled: isGlobalVariablesEnabled, isSecondaryEpDnAgent: isSecondaryEpDnAgent, getEditedCADValues: getEditedCADValues, copyText: copyText, enableCadButtons: enableCadButtons, mediaType: contactInformation.mediaType, setCadValidationResult: setCadValidationResult, decryptedState: decryptedState, isSecureCADVariablesEnabled: isSecureCADVariablesEnabled, showDNISInCAD: showDNISInCAD }));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        const data = contactInformation;
        if (data.isWrapUp || isConsultView) {
            setRecordingStatus("");
        }
        else if (data.isRecorded && data.isRecordingPaused && data.isPauseResumeEnabled) {
            setRecordingStatus(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDINGPAUSE);
        }
        else if (data.isRecorded && !data.isRecordingPaused && data.isPauseResumeEnabled) {
            setRecordingStatus(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDING);
        }
        else {
            setRecordingStatus("");
        }
        //Interaction control container overflow fix when the cad variable section expanded and consult state
        if (data.state === "consulting" && isExpanded && data.state !== prevState && window.innerHeight < 700) {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_17__.logger.info("[App: the connector view overflowed on consult view [isExpanded, contactInformation.state,prevState]", isExpanded, data.state, prevState);
            setIsExpanded(false);
        }
    }, [contactInformation, isConsultView]);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        const timerId = window.setTimeout(() => {
            const focusableElements = (0,_AccordionUtils__WEBPACK_IMPORTED_MODULE_20__.findFocusable)(accordionRef.current);
            if (focusableElements && contactInformation.isWrapUp === false) {
                focusableElements.focus();
            }
        }, 0);
        timerRef.current = timerId;
    }, [interactionButtons === null || interactionButtons === void 0 ? void 0 : interactionButtons.length, interactionId]);
    const checkMediaType = () => {
        return !!(contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE ||
            contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.OUTBOUND_VOICE);
    };
    const onRetry = () => {
        if (!buttonDisableState) {
            retryDecryption();
        }
    };
    const recordingIndicator = () => {
        if (recordingStatus === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDING) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "recording-indicator" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "record-filled", role: "img", "aria-label": interaction_control.recordingInProgess, iconSet: "momentumDesign", size: "16" }) })));
        }
        if (recordingStatus === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDINGPAUSE) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "recording-indicator recording-paused" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "record-filled", role: "img", "aria-label": interaction_control.recordingPaused, iconSet: "momentumDesign", size: "16" }) })));
        }
        return null;
    };
    const handleScroll = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
            containerRef.current.click();
        }
    };
    const getSRContent = () => {
        const taskName = interaction_control.taskName;
        const isConsultContent = isConsultView ? interaction_control.consultingTaskContext : "";
        return `${taskName}: ${isConsultContent}`;
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ id: "interaction-accordion" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `interaction-control ${iconType}`, ref: interactionControlRef }, { children: [recordingStatus && recordingIndicator(), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.interactionControlTitleClassMap)(isExpanded) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "inner-container", ref: accordionRef }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "interaction_detail_container interaction-control-avatar" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "interaction-section", ref: infoSectionRef }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "bottom", message: (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.getTaskName)(contactInformation, isConsultView, agentId) }, (!nameOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", Object.assign({ ref: nameRef, "aria-label": `${getSRContent()} ${(0,_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__.makeAlphaNumericReadable)((0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.getTaskName)(contactInformation, isConsultView, agentId))}`, className: "interaction-control-name" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "sr-only" }, { children: getSRContent() })), (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.getTaskName)(contactInformation, isConsultView, agentId)] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_5___default()("interaction-control-status", {
                                                updateStatusColor: (contactInformation.state !== "consult" && contactInformation.isHold && !isConsultView) ||
                                                    (contactInformation.consultHold && isConsultView)
                                            }) }, { children: (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.defineInteractionBadge)(contactInformation, (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_17__.getChatInteractionStatus)(contactInformation, interaction_control), (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_17__.getLocalizedInteractionStatus)(contactInformation, isConsultView, interaction_control, isConsultPanelVisualUpdateEnabled, agentCallMonitoringState), getTimeStamp(), getBadgeAndIcon(), isConsultView, channelNameLabels, interaction_control, isDarkMode, agentCallMonitoringState, isWxccMultiPartyConfEnabled, isPersistCallEnabled, isConsultPanelVisualUpdateEnabled, agentId) }))] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ ref: buttonContainerRef, className: "interaction-button-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "btn-group" }, { children: [!contactInformation.isWrapUp &&
                                                (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.defineInteractionButton)(interactionButtons, contactInformation, interaction_control, action, getButtonProperties(), dtmfValue, isWxccMultiPartyConfEnabled || isPersistCallEnabled, isInteractionBtnConfirmDialogEnabled, isConsultPanelVisualUpdateEnabled, webexCallingCallId), contactInformation.isWrapUp && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WrapUp_components__WEBPACK_IMPORTED_MODULE_14__["default"], { contactDirection: contactInformation.contactDirection, wrapUpProps: wrapUpData.wrapUpProps, agentWrapUpCodeProps: agentWrapUpCodeProps, interactionId: interactionId, wrapUpTimestamp: contactInformation.wrapUpTimestamp, isDesktopAuxCodesInfiniteScrollEnabled: isDesktopAuxCodesInfiniteScrollEnabled }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-grabber", Object.assign({ alignment: "top", "data-testid": "toggle-additional-info", class: `align-center-flex button-container ${checkMediaType() || isConsultView ? "higher-z-index" : ""} ${isExpanded ? "collapse-button" : "expand-button"}`, label: `${contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.SOCIAL
                                            ? contactInformation.mediaChannel
                                            : contactInformation.mediaType} details` }, (isExpanded ? { checked: true } : ""), (!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__.themeManager.isMomentumAvatarEnabled ? { shadow: true } : ""), { onClick: toogleActive, onKeyDown: handleKeyPress, ariaExpanded: !!isExpanded }))] }))] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_15__.contentClassMap)(isExpanded) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dl", Object.assign({ onScroll: (e) => {
                                handleScroll && handleScroll(e);
                            }, id: "additional-info", ref: containerRef, className: classnames__WEBPACK_IMPORTED_MODULE_5___default()("interaction-content align-center-flex", {
                                "single-column": compactDetails
                            }) }, { children: customerInfo && Object.keys(customerInfo).length > 0 && renderAdditionalDetails() })), (contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE || isIMIGlobalVariablesEnabled) &&
                            customerInfo &&
                            Object.keys(customerInfo).length > 0 &&
                            (!isConsultView || !(0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_13__.isAgentConsulting)(contactInformation, isWxccMultiPartyConfEnabled)) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ id: "cad-container-id", className: classnames__WEBPACK_IMPORTED_MODULE_5___default()("cad-container", {
                                "single-column": compactDetails
                            }) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_5___default()("cad-alert-container", {
                                        "single-column": compactDetails
                                    }) }, { children: [cadUpdated === "success" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ id: "agentAction-success-container-id", className: "agentAction-success-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-check-circle_12", class: "agentAction-success-icon" }), interaction_control.cadrequestuccess] }))), cadUpdated === "error" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ id: "agentAction-error-container-id", className: "agentAction-error-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-error_12", class: "agentAction-error-icon" }), interaction_control.cadrequestfailure, " ", common.trackingIdInputLabel, " ", trackingId] }))), cadUpdated === "message" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ id: "agentAction-message-container-id", className: "agentAction-warning-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-warning_12", class: "agentAction-warning-icon" }), interaction_control.cadupdatedmessage, " ", contactInformation.destAgentName, ". ", interaction_control.unsavedmessage] }))), cadValidationError && cadUpdated === "" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ id: "agentAction-error-container-id", className: "agentAction-error-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-error_12", class: "agentAction-error-icon" }), interaction_control.cadValidationError] }))), isSecureCADVariablesEnabled && cadUpdated === "encryption-error" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ id: "encrypt-error-container-id", className: "agentAction-error-container securecad-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-error_12", class: "agentAction-error-icon" }), interaction_control.secureCadSaveError] }))), isSecureCADVariablesEnabled && decryptedState === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.ApiResponseState.FAIL && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ id: "decrypt-error-container-id", "aria-label": `${interaction_control.secureDecryptionError} ${interaction_control.clickToTry}`, className: classnames__WEBPACK_IMPORTED_MODULE_5___default()("decrypt-error agentAction-error-container securecad-error", {
                                                "single-column": compactDetails
                                            }) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-error_12", class: "agentAction-error-icon" }), interaction_control.secureDecryptionError, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: `cad-retry ${buttonDisableState ? "cad-retry-disable" : ""}`, tabIndex: 0, onKeyPress: onRetry, role: "button", onClick: onRetry }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-activities_12" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "cad-retry-text" }, { children: interaction_control.clickToTry })), buttonDisableState && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "cad-retry-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "12" }) })))] }))] })))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "cad-button-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ class: "cad-buttons", ariaLabel: interaction_control.revert, size: "28", id: "revert", variant: "secondary" }, (showLoaderButtonType === "Revert" ? { loading: true } : ""), (isDisabled ? { disabled: true } : ""), { onClick: () => {
                                                if (!isDisabled) {
                                                    updateButtonProgressFlag("Revert");
                                                    submitCadValues("Revert");
                                                }
                                            } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ slot: "text" }, { children: interaction_control.revert })) }), "Revert"), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ class: "cad-buttons", ariaLabel: interaction_control.save, size: "28", id: "save", variant: "primary" }, (showLoaderButtonType === "Save" ? { loading: true } : ""), (isDisabled ? { disabled: true } : ""), { onClick: () => {
                                                if (!isDisabled) {
                                                    submitCadValues("Save");
                                                }
                                            } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ slot: "text" }, { children: interaction_control.save })) }), "Save")] }))] })))] }))] })) })));
}, (prevProps, nextProps) => {
    return (lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(prevProps.contactInformation, nextProps.contactInformation) &&
        prevProps.isOpen === nextProps.isOpen &&
        prevProps.isInteractionCADContainersExpanded === nextProps.isInteractionCADContainersExpanded &&
        prevProps.isMainContainerCADExpanded === nextProps.isMainContainerCADExpanded &&
        prevProps.isConsultContainerCADExpanded === nextProps.isConsultContainerCADExpanded &&
        lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(prevProps.interactionButtons, nextProps.interactionButtons) &&
        lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(prevProps.wrapUpData, nextProps.wrapUpData) &&
        lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(prevProps.showLoaderButtonType, nextProps.showLoaderButtonType) &&
        lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(prevProps.currentStateTimer, nextProps.currentStateTimer) &&
        lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(prevProps.decryptedState, nextProps.decryptedState) &&
        lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(prevProps.buttonDisableState, nextProps.buttonDisableState) &&
        lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(prevProps.isSecureCADVariablesEnabled, nextProps.isSecureCADVariablesEnabled) &&
        lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(prevProps.isDarkMode, nextProps.isDarkMode) &&
        lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(prevProps.agentCallMonitoringState, nextProps.agentCallMonitoringState) &&
        lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(prevProps.agentWrapUpCodeProps, nextProps.agentWrapUpCodeProps));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Accordion);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/Accordion/AccordionUtils.tsx":
/*!********************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/Accordion/AccordionUtils.tsx ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   findFocusable: () => (/* binding */ findFocusable),
/* harmony export */   handleAccordionRefChange: () => (/* binding */ handleAccordionRefChange),
/* harmony export */   infoSectionRefChange: () => (/* binding */ infoSectionRefChange)
/* harmony export */ });
const infoSectionRefChange = (width, accordionWidth, fullButtonContainerWidth, updateCompactButtons) => {
    if (accordionWidth && width && fullButtonContainerWidth !== 0) {
        const entireInfoSpace = width + 35;
        const availableButtonSpace = accordionWidth - entireInfoSpace;
        if (fullButtonContainerWidth > availableButtonSpace) {
            updateCompactButtons(true);
        }
        else {
            setTimeout(() => {
                updateCompactButtons(false);
            }, 0);
        }
    }
};
const handleAccordionRefChange = (width, accordionWidth, compactDetailsScreen, updateCompactDetails, infoSectionWidth, fullButtonContainerWidth, updateCompactButtons) => {
    if (accordionWidth !== width) {
        if (width && width < compactDetailsScreen) {
            setTimeout(() => {
                updateCompactDetails(true);
            }, 0);
        }
        else {
            setTimeout(() => {
                updateCompactDetails(false);
            }, 0);
        }
        if (width && infoSectionWidth && fullButtonContainerWidth !== 0) {
            const entireInfoSpace = infoSectionWidth + 35;
            const availableButtonSpace = width - entireInfoSpace;
            if (fullButtonContainerWidth > availableButtonSpace) {
                updateCompactButtons(true);
            }
            else {
                updateCompactButtons(false);
            }
        }
    }
};
function isHidden(element) {
    return (element.hasAttribute("hidden") ||
        (element.hasAttribute("aria-hidden") && element.getAttribute("aria-hidden") === "true") ||
        element.style.display === "none" ||
        element.style.opacity === "0" ||
        element.style.visibility === "hidden" ||
        element.style.visibility === "collapse");
}
function isInteractiveElement(element) {
    if (element instanceof HTMLButtonElement ||
        element instanceof HTMLDetailsElement ||
        element instanceof HTMLEmbedElement ||
        element instanceof HTMLIFrameElement ||
        element instanceof HTMLSelectElement ||
        element instanceof HTMLTextAreaElement) {
        return true;
    }
    if (element instanceof HTMLAnchorElement && element.hasAttribute("href")) {
        return true;
    }
    if (element instanceof HTMLInputElement && element.type !== "hidden") {
        return true;
    }
    if ((element instanceof HTMLAudioElement || element instanceof HTMLVideoElement) &&
        element.hasAttribute("controls")) {
        return true;
    }
    if ((element instanceof HTMLImageElement || element instanceof HTMLObjectElement) && element.hasAttribute("usemap")) {
        return true;
    }
    return element.hasAttribute("tabindex") && element.tabIndex > -1;
}
function isNotTabbable(element) {
    return element.getAttribute("tabindex") === "-1";
}
function isFocusable(element) {
    if (isHidden(element) || isNotTabbable(element)) {
        return false;
    }
    return isInteractiveElement(element);
}
function findFocusable(root) {
    const children = Array.from((root === null || root === void 0 ? void 0 : root.children) || []);
    let focusable = null;
    children.some((child) => {
        if (isHidden(child)) {
            return false;
        }
        if (isFocusable(child)) {
            focusable = child;
            return true;
        }
        if (child.shadowRoot) {
            focusable = findFocusable(child.shadowRoot);
            return focusable !== null;
        }
        if (child.tagName === "SLOT") {
            const childElements = child
                .assignedNodes()
                .filter((node) => node.nodeType === node.ELEMENT_NODE);
            if (childElements.length) {
                const parent = childElements[0].parentElement;
                if (parent) {
                    focusable = findFocusable(parent);
                    return focusable !== null;
                }
            }
        }
        focusable = findFocusable(child);
        return focusable !== null;
    });
    return focusable;
}


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/AdditionalDetails/AdditionalDetails.tsx":
/*!*******************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/AdditionalDetails/AdditionalDetails.tsx ***!
  \*******************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dompurify */ "../../node_modules/dompurify/dist/purify.es.mjs");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _DateTimeWrapper_DateTimeWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../DateTimeWrapper/DateTimeWrapper */ "./src/direflow-components/InteractionControl/components/DateTimeWrapper/DateTimeWrapper.tsx");
/* harmony import */ var _CADEditableTextField__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./CADEditableTextField */ "./src/direflow-components/InteractionControl/components/AdditionalDetails/CADEditableTextField.tsx");

/* eslint-disable no-plusplus */








const AdditionalDetails = ({ customerInfo, getEditedCADValues, copyText, enableCadButtons, mediaType, setCadValidationResult, decryptedState, isSecureCADVariablesEnabled, isSecondaryEpDnAgent, isIMIGlobalVariablesEnabled, isGlobalVariablesEnabled, showDNISInCAD }) => {
    const { interaction_control } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const [customerData, setCustomerData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(Object.assign({}, customerInfo));
    const [maskSecureCadValue, setMaskSecureCadValue] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
    const TIMEOUT_FIVE_MS = 5;
    const MASK_VALUE = "**********";
    const interactionKeyRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const setMaskSecureTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (isSecureCADVariablesEnabled && decryptedState === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.ApiResponseState.PASS) {
            setCustomerData(Object.assign({}, customerInfo));
            setMaskSecureTimeoutIdRef.current = window.setTimeout(() => {
                setMaskSecureCadValue(false);
            }, TIMEOUT_FIVE_MS); // timeout to avoid display of encrypted data
        }
        else {
            setCustomerData(Object.assign({}, customerInfo));
        }
        return () => {
            if (setMaskSecureTimeoutIdRef.current) {
                window.clearTimeout(setMaskSecureTimeoutIdRef.current);
            }
        };
    }, [customerInfo, decryptedState, isSecureCADVariablesEnabled]);
    // sonar.issue.ignore.block.start
    const dateRgx = "^((\\d{4})(-)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$";
    // sonar.issue.ignore.block.end
    const handleValueChange = (value, item) => {
        var _a;
        if (customerData[item].type === _constants__WEBPACK_IMPORTED_MODULE_6__.DATETIME) {
            if (!(value === null || value === void 0 ? void 0 : value.match(dateRgx))) {
                setCadValidationResult(true);
                return;
            }
            setCadValidationResult(false);
        }
        getEditedCADValues((_a = dompurify__WEBPACK_IMPORTED_MODULE_1__["default"].sanitize(value)) === null || _a === void 0 ? void 0 : _a.trim(), Object.assign({}, customerData[item]));
    };
    const getLabel = (item) => {
        var _a, _b;
        let label;
        const labelToLowercase = ((_a = customerData[item].displayName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || ((_b = customerData[item].name) === null || _b === void 0 ? void 0 : _b.toLowerCase());
        if (interaction_control[labelToLowercase]) {
            label = interaction_control[labelToLowercase];
            if (labelToLowercase === "ani") {
                if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.MEDIA_TYPES.VOICE || mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.MEDIA_TYPES.MIDCALL_MONITORING) {
                    // For voice, ani label should be the "Phone number"
                    label = interaction_control.ani;
                }
                else if (isIMIGlobalVariablesEnabled) {
                    // Digital IMI Channels, ani label should be the "Contact Origin"
                    label = interaction_control.contactorigin;
                }
                else {
                    // For Native chat and Email. ani label should be the "Customer Email"
                    label = interaction_control.email;
                }
            }
            if (labelToLowercase === "destagentphonenumber") {
                if (showDNISInCAD) {
                    label = interaction_control.dnis;
                }
            }
        }
        else {
            label = customerData[item].displayName || customerData[item].name;
        }
        return label;
    };
    const announceCopiedStatus = (message) => {
        window.dispatchEvent(new CustomEvent("ax-announcement-update", {
            detail: {
                thisEvent: {
                    message
                }
            }
        }));
    };
    const buttonLabel = (cadData, item) => {
        if (cadData.isCopied) {
            return "";
        }
        return `${interaction_control.copy} ${getLabel(item)}`;
    };
    const getCopyIcon = (item) => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "copy-button-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "top", message: customerData[item].isCopied ? interaction_control.copied : interaction_control.copy }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ class: "copy-tracking-id", type: "button", circle: true, size: "28", ariaLabel: buttonLabel(customerData[item], item), variant: customerData[item].isCopied ? "green" : "white", onClick: (event) => {
                        copyText(event, customerData[item]);
                        announceCopiedStatus(`${interaction_control.copied} ${getLabel(item)}`);
                    } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: customerData[item].isCopied ? "icon-check_12" : "icon-copy_12" }) })) })) })));
    };
    const getValue = (item) => {
        var _a, _b, _c, _d, _e, _f, _g;
        switch ((_a = customerData[item]) === null || _a === void 0 ? void 0 : _a.type) {
            case _constants__WEBPACK_IMPORTED_MODULE_6__.BOOLEAN:
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-toggle-switch", Object.assign({ class: "switch-container", label: getLabel(item), onClick: (e) => {
                        var _a;
                        if (customerData[item].agentEditable && !isSecondaryEpDnAgent) {
                            const value = e.target.checked === true ? "true" : "false";
                            getEditedCADValues((_a = dompurify__WEBPACK_IMPORTED_MODULE_1__["default"].sanitize(value)) === null || _a === void 0 ? void 0 : _a.trim(), Object.assign({}, customerData[item]));
                        }
                    } }, (!customerData[item].agentEditable || isSecondaryEpDnAgent ? { disabled: true } : ""), (((_b = customerData[item].value) === null || _b === void 0 ? void 0 : _b.toString()) === "true" ? { checked: true } : ""), { small: true })));
            case _constants__WEBPACK_IMPORTED_MODULE_6__.DATETIME:
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DateTimeWrapper_DateTimeWrapper__WEBPACK_IMPORTED_MODULE_7__["default"], { dateTimeString: (_d = (_c = customerData[item]) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.slice(), item: item, isDisabled: !((_e = customerData[item]) === null || _e === void 0 ? void 0 : _e.agentEditable) || isSecondaryEpDnAgent, handleValueChange: handleValueChange, label: getLabel(item) }), ((_f = customerData[item]) === null || _f === void 0 ? void 0 : _f.value) && getCopyIcon(item)] }));
            default:
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CADEditableTextField__WEBPACK_IMPORTED_MODULE_8__["default"], { customerDataItem: customerData[item], getEditedCADValues: getEditedCADValues, enableCadButtons: enableCadButtons, label: getLabel(item) }), ((_g = customerData[item]) === null || _g === void 0 ? void 0 : _g.value) && getCopyIcon(item)] }));
        }
    };
    const isCadViewable = (cadVar) => {
        return (cadVar.name &&
            cadVar.agentViewable !== false &&
            /* if agentViewable is undefined (for backward compatibility) we should treat it as true */
            cadVar.name !== _constants__WEBPACK_IMPORTED_MODULE_6__.FC_DESKTOP_VIEW);
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: customerData &&
            Object.keys(customerData).map((item) => {
                var _a;
                return (isCadViewable(customerData[item]) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "align-center-flex interaction-info-section" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", Object.assign({ className: "interaction-info-key", ref: interactionKeyRef }, { children: isSecureCADVariablesEnabled && customerData[item].isSecure ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ellipses interaction-label", title: getLabel(item) }, { children: getLabel(item) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "interaction-label interaction-secure-cad" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ tabIndex: 0, "aria-label": `${getLabel(item)} ${interaction_control.isSecureVariable}`, placement: "top", message: "Secure Variable" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-lock_12" }) })) }))] })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "top", message: getLabel(item) }, (!(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_4__.isTextOverflow)((_a = interactionKeyRef === null || interactionKeyRef === void 0 ? void 0 : interactionKeyRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth, getLabel(item))
                                ? { disabled: true }
                                : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "ellipses interaction-label", "data-title": getLabel(item) }, { children: getLabel(item) })) }))) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", Object.assign({ className: customerData[item].agentEditable && !isSecondaryEpDnAgent
                                ? "align-center-flex interaction-info-value"
                                : "align-center-flex interaction-info-value non-editable-field", id: customerData[item].name }, { children: isSecureCADVariablesEnabled && customerData[item].isSecure && maskSecureCadValue ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "interaction-mask-value" }, { children: [MASK_VALUE, " "] }))) : (getValue(item)) }))] }), customerData[item].name)));
            }) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AdditionalDetails);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/AdditionalDetails/CADEditableTextField.tsx":
/*!**********************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/AdditionalDetails/CADEditableTextField.tsx ***!
  \**********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dompurify */ "../../node_modules/dompurify/dist/purify.es.mjs");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../AgentStateSelector/StateTimer */ "./src/direflow-components/AgentStateSelector/StateTimer.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");








const CADEditableTextField = ({ customerDataItem, getEditedCADValues, enableCadButtons, label }) => {
    var _a;
    const [inputValue, setInputValue] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(customerDataItem === null || customerDataItem === void 0 ? void 0 : customerDataItem.value);
    const editableTextFieldRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const { interaction_control } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_7__.getLocalizedMessages)();
    const moveCursorToEnd = () => {
        var _a, _b;
        if (editableTextFieldRef === null || editableTextFieldRef === void 0 ? void 0 : editableTextFieldRef.current) {
            const range = document.createRange();
            const selection = window.getSelection();
            const divInsideEditableField = (_a = editableTextFieldRef.current.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("div");
            if (((_b = divInsideEditableField === null || divInsideEditableField === void 0 ? void 0 : divInsideEditableField.childNodes[0]) === null || _b === void 0 ? void 0 : _b.length) >= _Common_constants__WEBPACK_IMPORTED_MODULE_5__.CAD_VAR_MAX) {
                range.setStart(divInsideEditableField.childNodes[0], _Common_constants__WEBPACK_IMPORTED_MODULE_5__.CAD_VAR_MAX);
                range.collapse(true);
                selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
                selection === null || selection === void 0 ? void 0 : selection.addRange(range);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        moveCursorToEnd();
    }, [inputValue]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        var _a;
        setInputValue(((_a = customerDataItem === null || customerDataItem === void 0 ? void 0 : customerDataItem.value) === null || _a === void 0 ? void 0 : _a.includes(_constants__WEBPACK_IMPORTED_MODULE_3__.WEB_RTC_PREFIX)) ? _constants__WEBPACK_IMPORTED_MODULE_3__.DESKTOP : customerDataItem === null || customerDataItem === void 0 ? void 0 : customerDataItem.value);
    }, [customerDataItem === null || customerDataItem === void 0 ? void 0 : customerDataItem.value]);
    const showTooltip = () => {
        var _a, _b;
        let isTooltipVisible;
        if (editableTextFieldRef && editableTextFieldRef.current) {
            const divInsideEditableField = (_b = (_a = editableTextFieldRef === null || editableTextFieldRef === void 0 ? void 0 : editableTextFieldRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("div");
            isTooltipVisible = (divInsideEditableField === null || divInsideEditableField === void 0 ? void 0 : divInsideEditableField.offsetHeight) < (divInsideEditableField === null || divInsideEditableField === void 0 ? void 0 : divInsideEditableField.scrollHeight);
        }
        return isTooltipVisible;
    };
    const getEditableText = () => {
        var _a, _b, _c;
        return ((_c = (_b = (_a = editableTextFieldRef === null || editableTextFieldRef === void 0 ? void 0 : editableTextFieldRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("div")) === null || _c === void 0 ? void 0 : _c.textContent) || "";
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ class: "cad-value-width", message: customerDataItem.value ? customerDataItem.value : interaction_control.copy }, (!showTooltip() || customerDataItem.agentEditable ? { disabled: true } : ""), { children: _Common_constants__WEBPACK_IMPORTED_MODULE_5__.TIMER_FIELDS.includes(customerDataItem.displayName.toLowerCase()) ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "cad-timer" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_4__["default"], { color: "none", timerTimeStamp: Number(customerDataItem.value) }) }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-editable-field", Object.assign({ class: "cad-value-width", ref: editableTextFieldRef, ariaLabel: label, "max-lines": "2", hideMessage: true, content: inputValue }, (customerDataItem.type !== _constants__WEBPACK_IMPORTED_MODULE_6__.STRING ? { type: (_a = customerDataItem.type) === null || _a === void 0 ? void 0 : _a.toLowerCase() } : ""), (!customerDataItem.agentEditable ? { disabled: true } : ""), { onBlur: (e) => {
                    var _a;
                    e.persist();
                    if (customerDataItem.agentEditable) {
                        const value = getEditableText();
                        getEditedCADValues((_a = dompurify__WEBPACK_IMPORTED_MODULE_1__["default"].sanitize(value)) === null || _a === void 0 ? void 0 : _a.trim(), Object.assign({}, customerDataItem));
                    }
                }, onKeyPress: (e) => {
                    e.persist();
                    const textValueLength = getEditableText().length;
                    if (textValueLength >= _Common_constants__WEBPACK_IMPORTED_MODULE_5__.CAD_VAR_MAX) {
                        e.preventDefault();
                    }
                }, onKeyUp: (e) => {
                    var _a;
                    e.persist();
                    if (customerDataItem.agentEditable) {
                        const value = getEditableText();
                        enableCadButtons((_a = dompurify__WEBPACK_IMPORTED_MODULE_1__["default"].sanitize(value)) === null || _a === void 0 ? void 0 : _a.trim(), customerDataItem);
                    }
                }, onInput: (e) => {
                    e.persist();
                    let replacementText = "";
                    const textValue = getEditableText();
                    const eNativeEvent = e.nativeEvent;
                    if (textValue.length >= _Common_constants__WEBPACK_IMPORTED_MODULE_5__.CAD_VAR_MAX && eNativeEvent.inputType === "insertFromPaste") {
                        replacementText = textValue.substr(0, _Common_constants__WEBPACK_IMPORTED_MODULE_5__.CAD_VAR_MAX);
                        if (eNativeEvent.path) {
                            eNativeEvent.path[0].innerText = replacementText;
                        }
                        else if (eNativeEvent.originalTarget) {
                            eNativeEvent.originalTarget.innerText = replacementText;
                        }
                        setInputValue(replacementText);
                        moveCursorToEnd();
                    }
                } }))) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CADEditableTextField);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/ConfirmationDialog/ConfirmationDialogContent.tsx":
/*!****************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/ConfirmationDialog/ConfirmationDialogContent.tsx ***!
  \****************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");

const ConfirmationDialogContent = ({ dialogTitle, dialogMessage }) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", Object.assign({ className: "confirmation-dialog__title" }, { children: dialogTitle })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "confirmation-dialog__message", role: "alert" }, { children: dialogMessage }))] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ConfirmationDialogContent);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/ConfirmationDialog/ConfirmationDialogFooter.tsx":
/*!***************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/ConfirmationDialog/ConfirmationDialogFooter.tsx ***!
  \***************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");

const ConfirmationDialogFooter = ({ type, confirmButtonLabel, cancelButtonLabel, confirmButtonArialLabel, dialogConfirmHandler, dialogCancelHandler }) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "confirmation-dialog__buttons-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ariaLabel: confirmButtonArialLabel, "data-testid": `${type}_confirmButton`, class: "confirmation-dialog__button confirmation-dialog__button--confirm", variant: "primary", onClick: dialogConfirmHandler }, { children: confirmButtonLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ariaLabel: cancelButtonLabel, "data-testid": `${type}_cancelButton`, class: "confirmation-dialog__button confirmation-dialog__button--cancel", variant: "secondary", onClick: dialogCancelHandler }, { children: cancelButtonLabel }))] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ConfirmationDialogFooter);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/ConfirmationDialog/ConfirmationDialogUtils.tsx":
/*!**************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/ConfirmationDialog/ConfirmationDialogUtils.tsx ***!
  \**************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   openEndCallConfirmDialogWithShortcut: () => (/* binding */ openEndCallConfirmDialogWithShortcut)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);

const openEndCallConfirmDialogWithShortcut = (key, overlayRef, resetButtonStyles, type) => {
    if (key.data &&
        key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.shortcut.REGISTERED_KEYS.END_KEY &&
        key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
        setTimeout(() => {
            if (overlayRef) {
                overlayRef.current.isOpen = true;
                resetButtonStyles(type, true);
            }
        }, 100);
    }
};


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/ConfirmationDialog/index.tsx":
/*!********************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/ConfirmationDialog/index.tsx ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _ConfirmationDialogContent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ConfirmationDialogContent */ "./src/direflow-components/InteractionControl/components/ConfirmationDialog/ConfirmationDialogContent.tsx");
/* harmony import */ var _ConfirmationDialogFooter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ConfirmationDialogFooter */ "./src/direflow-components/InteractionControl/components/ConfirmationDialog/ConfirmationDialogFooter.tsx");
/* harmony import */ var _ConfirmationDialogUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./ConfirmationDialogUtils */ "./src/direflow-components/InteractionControl/components/ConfirmationDialog/ConfirmationDialogUtils.tsx");
/* harmony import */ var _style_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./style.css */ "./src/direflow-components/InteractionControl/components/ConfirmationDialog/style.css");
/* harmony import */ var _style_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_css__WEBPACK_IMPORTED_MODULE_8__);









const ConfirmationDialog = ({ isClickable, dialogTitle, dialogMessage, confirmButtonLabel, cancelButtonLabel, dialogConfirmHandler, resetButtonStyles, type, children }) => {
    const overlayRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const DIALOG_WIDTH = 368;
    const DIALOG_HEIGHT = 158;
    const OVERLAY_OPEN_EVENT = "menu-overlay-open";
    const OVERLAY_CLOSE_EVENT = "menu-overlay-close";
    const dialogOpenHandler = () => {
        resetButtonStyles(type, true);
    };
    const dialogCloseHandler = () => {
        setOverlayClose();
        resetButtonStyles(type, false);
    };
    const setOverlayClose = () => {
        overlayRef.current.isOpen = false;
    };
    const openEndCallConfirmDialogWithShortcutKey = (key) => {
        (0,_ConfirmationDialogUtils__WEBPACK_IMPORTED_MODULE_7__.openEndCallConfirmDialogWithShortcut)(key, overlayRef, resetButtonStyles, type);
    };
    //adding event listener to confirmation menu overlay
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if (!overlayRef) {
            return undefined;
        }
        const overlay = overlayRef === null || overlayRef === void 0 ? void 0 : overlayRef.current;
        overlay.addEventListener(OVERLAY_OPEN_EVENT, dialogOpenHandler);
        overlay.addEventListener(OVERLAY_CLOSE_EVENT, dialogCloseHandler);
        let stopListenShortcutEvent = () => { };
        if (type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.END_BUTTON) {
            const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress(openEndCallConfirmDialogWithShortcutKey);
            stopListenShortcutEvent = stopListen;
        }
        return () => {
            overlay.removeEventListener(OVERLAY_OPEN_EVENT, dialogOpenHandler);
            overlay.removeEventListener(OVERLAY_CLOSE_EVENT, dialogCloseHandler);
            stopListenShortcutEvent();
        };
    }, []);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ ref: overlayRef, "custom-width": `${DIALOG_WIDTH}px`, "max-height": `${DIALOG_HEIGHT}px` }, (!isClickable ? { disabled: true } : ""), { class: "overlay-confirmation-dialog" }, { children: [children, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: (_style_css__WEBPACK_IMPORTED_MODULE_8___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "confirmation-dialog" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ConfirmationDialogContent__WEBPACK_IMPORTED_MODULE_5__["default"], { dialogTitle: dialogTitle, dialogMessage: dialogMessage }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ConfirmationDialogFooter__WEBPACK_IMPORTED_MODULE_6__["default"], { type: type, dialogConfirmHandler: () => {
                                setOverlayClose();
                                dialogConfirmHandler();
                            }, dialogCancelHandler: () => {
                                setOverlayClose();
                            }, confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, confirmButtonArialLabel: dialogMessage })] })) }))] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ConfirmationDialog);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/ConfirmationDialog/style.css":
/*!********************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/ConfirmationDialog/style.css ***!
  \********************************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!./style.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/ConfirmationDialog/style.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/DateTimeWrapper/DateTimeWrapper.tsx":
/*!***************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/DateTimeWrapper/DateTimeWrapper.tsx ***!
  \***************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");



const DateTimeWrapper = ({ dateTimeString, item, handleValueChange, isDisabled, label }) => {
    var _a, _b;
    const dateTimeRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const dateTimeValue = dateTimeString === null || dateTimeString === void 0 ? void 0 : dateTimeString.split("[")[0];
    const handleDateTimeChangeEvent = (event) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.dateTimeString) === null || _b === void 0 ? void 0 : _b.split("T")[0]) === (dateTimeValue === null || dateTimeValue === void 0 ? void 0 : dateTimeValue.split("T")[0]) &&
            ((_e = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromISO((_d = (_c = event === null || event === void 0 ? void 0 : event.detail) === null || _c === void 0 ? void 0 : _c.dateTimeString) === null || _d === void 0 ? void 0 : _d.split("T")[1])) === null || _e === void 0 ? void 0 : _e.toFormat("TTZZ")) &&
            (((_f = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromISO(dateTimeValue === null || dateTimeValue === void 0 ? void 0 : dateTimeValue.split("T")[1])) === null || _f === void 0 ? void 0 : _f.toFormat("TTZZ")) || "00:00:00-08:00")) {
            // ignoring date-time-change event for revert case
        }
        else {
            handleValueChange((_h = (_g = event === null || event === void 0 ? void 0 : event.detail) === null || _g === void 0 ? void 0 : _g.dateTimeString) === null || _h === void 0 ? void 0 : _h.toString(), item);
        }
    };
    const handleCalenderOpen = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // to position date-time-picker absolute while calender pops up
        if (((_c = (_b = (_a = dateTimeRef === null || dateTimeRef === void 0 ? void 0 : dateTimeRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.style) === null || _c === void 0 ? void 0 : _c.position) !== "absolute") {
            const offsetValue = (_e = (_d = dateTimeRef.current) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect();
            dateTimeRef.current.parentElement.style.top = `${(offsetValue === null || offsetValue === void 0 ? void 0 : offsetValue.top) - ((_g = (_f = dateTimeRef.current) === null || _f === void 0 ? void 0 : _f.offsetParent) === null || _g === void 0 ? void 0 : _g.offsetTop)}px`;
            dateTimeRef.current.parentElement.style.left = `${(_h = dateTimeRef.current) === null || _h === void 0 ? void 0 : _h.offsetLeft}px`;
            dateTimeRef.current.parentElement.style.width = `${offsetValue === null || offsetValue === void 0 ? void 0 : offsetValue.width}px`;
            dateTimeRef.current.parentElement.style.position = "absolute";
            dateTimeRef.current.parentElement.style.float = "left";
        }
    };
    const handleCalenderClose = () => {
        if (dateTimeRef && dateTimeRef.current) {
            dateTimeRef.current.parentElement.style.width = "";
            dateTimeRef.current.parentElement.style.position = "inherit";
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        const element = dateTimeRef === null || dateTimeRef === void 0 ? void 0 : dateTimeRef.current;
        if (element) {
            element.addEventListener("date-time-change", handleDateTimeChangeEvent);
            element.addEventListener("menu-overlay-open", handleCalenderOpen);
            element.addEventListener("menu-overlay-close", handleCalenderClose);
        }
        return () => {
            if (element) {
                element.removeEventListener("date-time-change", handleDateTimeChangeEvent);
                element.removeEventListener("menu-overlay-open", handleCalenderOpen);
                element.removeEventListener("menu-overlay-close", handleCalenderClose);
            }
        };
    }, []);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-date-time-picker", Object.assign({ style: { height: "32px" }, ref: dateTimeRef, class: "cad-value-width", ariaLabel: label }, ((dateTimeValue === null || dateTimeValue === void 0 ? void 0 : dateTimeValue.split("T")[0]) ? { "date-value": dateTimeValue === null || dateTimeValue === void 0 ? void 0 : dateTimeValue.split("T")[0] } : ""), ((dateTimeValue === null || dateTimeValue === void 0 ? void 0 : dateTimeValue.split("T")[1]) && ((_a = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromISO(dateTimeValue === null || dateTimeValue === void 0 ? void 0 : dateTimeValue.split("T")[1])) === null || _a === void 0 ? void 0 : _a.toFormat("TTZZ"))
        ? {
            "time-value": (_b = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromISO(dateTimeValue === null || dateTimeValue === void 0 ? void 0 : dateTimeValue.split("T")[1])) === null || _b === void 0 ? void 0 : _b.toFormat("TTZZ")
        }
        : { "time-value": "00:00:00-08:00" }), (isDisabled ? { disabled: true } : ""))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DateTimeWrapper);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/InteractionButton/InteractionButton.tsx":
/*!*******************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/InteractionButton/InteractionButton.tsx ***!
  \*******************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _Keypad__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Keypad */ "./src/direflow-components/Keypad/index.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _ConfirmationDialog__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../ConfirmationDialog */ "./src/direflow-components/InteractionControl/components/ConfirmationDialog/index.tsx");
/* harmony import */ var _InteractionButtonUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./InteractionButtonUtils */ "./src/direflow-components/InteractionControl/components/InteractionButton/InteractionButtonUtils.tsx");











const InteractionButton = ({ button, buttonIndex, contactInformation, interactionControl, action, showLoaderButtonType, updateButtonProgressFlag, areCompactButtons, getAgentAction, focusOnInteractionButton, dtmfValue, setEmptyFocusOnInteractionButton, isPersistCallOrMPCEnabled, isInteractionBtnConfirmDialogEnabled, isConsultPanelVisualUpdateEnabled, webexCallingCallId }) => {
    var _a, _b;
    const [isTextOverflowing, setTextOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const buttonStates = {
        [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.HOLD_BUTTON]: "false",
        [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.RESUME_BUTTON]: "true",
        [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.RECORDINGPAUSE_BUTTON]: "false",
        [_Common_constants__WEBPACK_IMPORTED_MODULE_4__.RECORDINGRESUME_BUTTON]: "true"
    };
    const buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const menuElm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const interactionButtonFocusTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const announceLoadingStatusTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const keypadOpenTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { common, interaction_control } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const buttonLoaderStatus = showLoaderButtonType !== "";
    const isClickable = !button.disabled && !buttonLoaderStatus;
    const maxInteractionButtonWidth = 197;
    const interactionButtonSize = "28";
    const keypadOverlayWidth = 254;
    const keypadOverlayHeight = 465;
    const englishLabels = (_a = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getDefaultEnglishMessages)().interaction_control) === null || _a === void 0 ? void 0 : _a.confirmationDialog;
    const CONFIRM_DIALOG_CONFIG = (0,_InteractionButtonUtils__WEBPACK_IMPORTED_MODULE_9__.getConfirmDialogConfigs)(isInteractionBtnConfirmDialogEnabled, interaction_control, englishLabels);
    // focus on interaction button
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        interactionButtonFocusTimeoutIdRef.current = window.setTimeout(() => {
            var _a, _b;
            if (button.visible && !button.disabled && button.type === focusOnInteractionButton && (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current)) {
                const innerButton = (_b = (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button");
                if (innerButton) {
                    innerButton.focus();
                    setEmptyFocusOnInteractionButton();
                }
            }
        }, 10);
        return () => {
            if (interactionButtonFocusTimeoutIdRef.current) {
                window.clearTimeout(interactionButtonFocusTimeoutIdRef.current);
            }
        };
    }, [button, focusOnInteractionButton]);
    // text overflow
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (button.visible) {
            const additionalSpacing = 71;
            const maxAllowedTextSpace = maxInteractionButtonWidth - additionalSpacing;
            setTextOverflow((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_5__.isTextOverflow)(maxAllowedTextSpace, interactionControl[button.ariaLabel]));
        }
    }, [button.ariaLabel, button.visible, interactionControl]);
    // tooltip conditions
    const isTooltipAllowedButtons = () => {
        return (isPersistCallOrMPCEnabled &&
            contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.VOICE &&
            (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.END_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.EXIT_CONFERENCE));
    };
    const isCompactButton = () => {
        //In the future this will be updated to || button.type === END_BUTTON
        return areCompactButtons;
    };
    let isTooltipDisabled = !isCompactButton() && !isTextOverflowing && !isTooltipAllowedButtons();
    const getTooltipMessage = () => {
        switch (button.type) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_4__.BARGEIN_BUTTON:
                return getBargeInTooltipMessage();
            case _Common_constants__WEBPACK_IMPORTED_MODULE_4__.END_BUTTON:
            case _Common_constants__WEBPACK_IMPORTED_MODULE_4__.EXIT_CONFERENCE:
                return isPersistCallOrMPCEnabled && contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.VOICE
                    ? interactionControl[`${button.ariaLabel}Call`]
                    : interactionControl[button.ariaLabel];
            case _Common_constants__WEBPACK_IMPORTED_MODULE_4__.HOLD_BUTTON:
            case _Common_constants__WEBPACK_IMPORTED_MODULE_4__.RESUME_BUTTON:
                isTooltipDisabled = !isConsultPanelVisualUpdateEnabled && !contactInformation.isConsultInProgress;
                return button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.HOLD_BUTTON ? getHoldTooltipMessage() : getResumeTooltipMessage();
            default:
                return interactionControl[button.ariaLabel];
        }
    };
    const getBargeInTooltipMessage = () => {
        isTooltipDisabled = false;
        if (contactInformation.isMonitoringOnHold) {
            return interactionControl["bargeInTooltipDisabled"];
        }
        return !areCompactButtons
            ? interactionControl["bargeInTooltipText"]
            : interactionControl["bargeInCompactTooltipText"];
    };
    const getResumeTooltipMessage = () => {
        if (isConsultPanelVisualUpdateEnabled && contactInformation.isConsultInProgress) {
            return contactInformation.isConferenceInProgress
                ? interactionControl["switchConferenceTooltip"]
                : interactionControl["switchCallTooltip"];
        }
        else {
            return interactionControl[button.ariaLabel];
        }
    };
    const getHoldTooltipMessage = () => {
        return isConsultPanelVisualUpdateEnabled && contactInformation.isConsultInProgress
            ? interactionControl["switchConsultTooltip"]
            : interactionControl[button.ariaLabel];
    };
    // loader announcement
    const announceLoadingStatus = (message) => {
        window.dispatchEvent(new CustomEvent("ax-announcement-update", {
            detail: {
                thisEvent: {
                    message,
                    politeness: "assertive"
                }
            }
        }));
    };
    const isLoadingAnnouncementRequired = () => {
        return buttonLoaderStatus && button.type !== _Common_constants__WEBPACK_IMPORTED_MODULE_4__.TRANSFER_BUTTON && button.type !== _Common_constants__WEBPACK_IMPORTED_MODULE_4__.CONSULT_BUTTON;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        announceLoadingStatusTimeoutIdRef.current = window.setTimeout(() => {
            if (isLoadingAnnouncementRequired()) {
                announceLoadingStatus(common.loading);
            }
        }, 10);
        return () => {
            if (announceLoadingStatusTimeoutIdRef.current) {
                window.clearTimeout(announceLoadingStatusTimeoutIdRef.current);
            }
        };
    }, [buttonLoaderStatus]);
    const isNonToggleButton = (button) => {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_4__.nonToggleButtons.includes(button.type);
    };
    // confirmation dialog
    const isConfirmationDialogRequired = () => {
        //only remove FF during cleanup, rest condition should remain the same
        return (isInteractionBtnConfirmDialogEnabled &&
            Object.keys(CONFIRM_DIALOG_CONFIG).includes(button.type) &&
            contactInformation.isConferencing &&
            contactInformation.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.MEDIA_TYPES.VOICE);
    };
    // reset color of the end call and exit conference button on confirm dialog open and close
    const resetInteractionButtonStyles = (buttonType, isOpen) => {
        (0,_InteractionButtonUtils__WEBPACK_IMPORTED_MODULE_9__.resetButtonStyles)(buttonRef, buttonType, isOpen, setEmptyFocusOnInteractionButton, CONFIRM_DIALOG_CONFIG);
    };
    // interaction button click confirmed, also works as dialog confirm handler
    const buttonClickConfirmed = () => {
        updateButtonProgressFlag(button.type);
        action({
            type: getAgentAction(button.type),
            interactionId: contactInformation.interactionId,
            mediaType: contactInformation.mediaType
        }, contactInformation);
    };
    // interaction button click handler
    const interactionButtonClickHandler = () => {
        if (!isClickable) {
            return;
        }
        if (!isConfirmationDialogRequired()) {
            buttonClickConfirmed();
        }
    };
    //shortcut keys
    const executeOpenKeypad = (key) => {
        if (key.data &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_DTMF_KEYPAD &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
            if (keypadOpenTimeoutIdRef.current) {
                window.clearTimeout(keypadOpenTimeoutIdRef.current);
            }
            keypadOpenTimeoutIdRef.current = window.setTimeout(() => {
                if (menuElm.current) {
                    menuElm.current.isOpen = true;
                    updateButtonProgressFlag(_Common_constants__WEBPACK_IMPORTED_MODULE_4__.KEYPAD);
                    action({
                        type: getAgentAction(_Common_constants__WEBPACK_IMPORTED_MODULE_4__.KEYPAD),
                        interactionId: contactInformation.interactionId,
                        mediaType: contactInformation.mediaType
                    }, contactInformation);
                }
            }, _constants__WEBPACK_IMPORTED_MODULE_7__.TWO_HUNDRED_MS);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.event.listenKeyPress(executeOpenKeypad);
        return () => {
            if (stopListen) {
                stopListen();
            }
            if (keypadOpenTimeoutIdRef.current) {
                window.clearTimeout(keypadOpenTimeoutIdRef.current);
            }
        };
    }, []);
    const iconSet = (_b = button.iconSet) !== null && _b !== void 0 ? _b : "momentumDesign";
    // button content
    const getInteractionButtonContent = () => {
        let ariaPressed;
        if (isNonToggleButton(button) || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.KEYPAD_BUTTON) {
            ariaPressed = undefined;
        }
        else {
            ariaPressed = buttonStates[button.type] === "true" ? "true" : "false";
        }
        const buttonVariant = () => {
            if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.END_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.ENDMONITORING_BUTTON) {
                return "red";
            }
            if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.ENDCONSULT_BUTTON ||
                button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.EXIT_CONSULT ||
                button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.EXIT_CONFERENCE ||
                button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.END_CONFERENCE_BUTTON) {
                return "secondary-negative";
            }
            return "secondary";
        };
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ slot: button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.KEYPAD_BUTTON || isConfirmationDialogRequired() ? "menu-trigger" : "false", placement: "bottom", message: getTooltipMessage(), "data-testid": `${button.type}_TOOLTIP` }, (isTooltipDisabled ? { disabled: true } : ""), { children: (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)("md-button", Object.assign({ ref: buttonRef }, (isCompactButton() ? { circle: true } : ""), { ariaLabel: button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.BARGEIN_BUTTON
                    ? `${interactionControl[button.ariaLabel]}. ${getTooltipMessage()}`
                    : interactionControl[button.ariaLabel], ariaPressed: ariaPressed, key: button.type + buttonIndex.toString(), size: interactionButtonSize, maxWidth: `${maxInteractionButtonWidth}px`, variant: buttonVariant() }, (button.type === showLoaderButtonType ? { loading: true } : ""), (!isClickable ? { disabled: true } : ""), { onClick: interactionButtonClickHandler }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { ariaHidden: "true", slot: "icon", name: button.icon, iconSet: iconSet }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "interactionButtonText", slot: "text" }, { children: interactionControl[button.ariaLabel] }))) })));
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: button.visible && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "interactionButtonHolder" }, { children: button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_4__.KEYPAD_BUTTON ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ ref: menuElm, "custom-width": `${keypadOverlayWidth}px`, "max-height": `${keypadOverlayHeight}px`, placement: "bottom-start" }, (!isClickable ? { disabled: true } : ""), { class: "keypad-menu" }, { children: [getInteractionButtonContent(), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Keypad__WEBPACK_IMPORTED_MODULE_6__["default"], { defaultInpValue: dtmfValue, webexCallingCallId: webexCallingCallId })] }))) : isConfirmationDialogRequired() ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ConfirmationDialog__WEBPACK_IMPORTED_MODULE_8__["default"], Object.assign({ isClickable: isClickable, dialogTitle: CONFIRM_DIALOG_CONFIG[button.type].title, dialogMessage: CONFIRM_DIALOG_CONFIG[button.type].message, confirmButtonLabel: CONFIRM_DIALOG_CONFIG[button.type].confirmButtonLabel, cancelButtonLabel: CONFIRM_DIALOG_CONFIG[button.type].cancelButtonLabel, dialogConfirmHandler: buttonClickConfirmed, resetButtonStyles: resetInteractionButtonStyles, type: button.type }, { children: getInteractionButtonContent() }))) : (getInteractionButtonContent()) }), button.ariaLabel)) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InteractionButton);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/InteractionButton/InteractionButtonUtils.tsx":
/*!************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/InteractionButton/InteractionButtonUtils.tsx ***!
  \************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getButtonLabels: () => (/* binding */ getButtonLabels),
/* harmony export */   getConfirmDialogConfigs: () => (/* binding */ getConfirmDialogConfigs),
/* harmony export */   resetButtonStyles: () => (/* binding */ resetButtonStyles)
/* harmony export */ });
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");

const resetButtonStyles = (buttonRef, buttonType, isOpen, setEmptyFocusOnInteractionButton, CONFIRM_DIALOG_CONFIG) => {
    var _a;
    if (buttonRef.current) {
        const innerButton = (_a = buttonRef.current.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("button");
        if (innerButton) {
            const buttonConfig = CONFIRM_DIALOG_CONFIG[buttonType];
            const elmStyle = innerButton.style;
            if (isOpen) {
                elmStyle.backgroundColor = buttonConfig.colorOnDialogOpen;
            }
            else {
                elmStyle.backgroundColor = buttonConfig.colorOnDialogClose;
                innerButton.focus();
                setEmptyFocusOnInteractionButton();
            }
        }
    }
};
const getButtonLabels = (isInteractionBtnConfirmDialogEnabled, interactionControl, englishLabels) => {
    var _a, _b;
    return isInteractionBtnConfirmDialogEnabled
        ? {
            confirmButtonLabel: ((_a = interactionControl === null || interactionControl === void 0 ? void 0 : interactionControl.confirmationDialog) === null || _a === void 0 ? void 0 : _a.confirmButtonLabel) || (englishLabels === null || englishLabels === void 0 ? void 0 : englishLabels.confirmButtonLabel),
            cancelButtonLabel: ((_b = interactionControl === null || interactionControl === void 0 ? void 0 : interactionControl.confirmationDialog) === null || _b === void 0 ? void 0 : _b.cancelButtonLabel) || (englishLabels === null || englishLabels === void 0 ? void 0 : englishLabels.cancelButtonLabel)
        }
        : {};
};
const getConfirmDialogConfigs = (isInteractionBtnConfirmDialogEnabled, interactionControl, englishLabels) => {
    var _a, _b, _c, _d;
    const btnLabels = getButtonLabels(isInteractionBtnConfirmDialogEnabled, interactionControl, englishLabels);
    return isInteractionBtnConfirmDialogEnabled
        ? {
            [_Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON]: Object.assign({ title: ((_a = interactionControl === null || interactionControl === void 0 ? void 0 : interactionControl.confirmationDialog) === null || _a === void 0 ? void 0 : _a.endCallTitle) || (englishLabels === null || englishLabels === void 0 ? void 0 : englishLabels.endCallTitle), message: ((_b = interactionControl === null || interactionControl === void 0 ? void 0 : interactionControl.confirmationDialog) === null || _b === void 0 ? void 0 : _b.endCallMessage) || (englishLabels === null || englishLabels === void 0 ? void 0 : englishLabels.endCallMessage), colorOnDialogOpen: "var(--button-red-hover-bg-color)", colorOnDialogClose: "var(--button-red-bg-color)" }, btnLabels),
            [_Common_constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONFERENCE]: Object.assign({ title: ((_c = interactionControl === null || interactionControl === void 0 ? void 0 : interactionControl.confirmationDialog) === null || _c === void 0 ? void 0 : _c.exitConferenceTitle) || (englishLabels === null || englishLabels === void 0 ? void 0 : englishLabels.exitConferenceTitle), message: ((_d = interactionControl === null || interactionControl === void 0 ? void 0 : interactionControl.confirmationDialog) === null || _d === void 0 ? void 0 : _d.exitConferenceMessage) || (englishLabels === null || englishLabels === void 0 ? void 0 : englishLabels.exitConferenceMessage), colorOnDialogOpen: "var(--button-secondary-hover-bg-color)", colorOnDialogClose: "var(--button-secondary-bg-color)" }, btnLabels)
        }
        : {};
};


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/MidCallMonitoringSplitBadge.tsx":
/*!***********************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/MidCallMonitoringSplitBadge.tsx ***!
  \***********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../constants */ "./src/constants.ts");
/* harmony import */ var _AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../AgentStateSelector/StateTimer */ "./src/direflow-components/AgentStateSelector/StateTimer.tsx");
/* harmony import */ var _AccordionHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../AccordionHelper */ "./src/direflow-components/InteractionControl/AccordionHelper.tsx");




const MidCallMonitoringSplitBadge = ({ data, firstSection, contactInformation, isDarkMode, interactionControlLocalized, getBadgeText, interactionIcon, isConsultView, agentCallMonitoringState, currentStateTimer }) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-badge", Object.assign({ class: data.isMonitoringOnHold ? "monitoring-hold" : "", ariaLabel: !data.isMonitoringOnHold && !data.isBargedIn ? interactionControlLocalized.monitoring : getBadgeText() }, (data.isMonitoringOnHold ? { color: "hold" } : ""), { split: true }, { children: [firstSection, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ slot: "split-right" }, { children: [!data.isMonitoringOnHold && !data.isBargedIn ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "monitoring-split", "aria-hidden": "true" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { alt: "monitoring-icon", src: isDarkMode ? _constants__WEBPACK_IMPORTED_MODULE_1__.MONITORING_REGULAR_DARK : _constants__WEBPACK_IMPORTED_MODULE_1__.MONITORING_REGULAR_LIGHT }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: interactionControlLocalized.monitoring })] }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { "aria-hidden": "true", class: "split-icon", name: `icon-${interactionIcon}`, size: "12" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true" }, { children: getBadgeText() }))] })), (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_3__.isContactTimer)(contactInformation, isConsultView, agentCallMonitoringState) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "timer-dash" }, { children: "-" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_2__["default"], { color: "none", timerTimeStamp: currentStateTimer, timerLabel: `${!data.isMonitoringOnHold && !data.isBargedIn ? interactionControlLocalized.monitoring : getBadgeText()} ${interactionControlLocalized.interactionDurationLabel}` })] }))] }))] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MidCallMonitoringSplitBadge);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/ParticipantsBadge.tsx":
/*!*************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/ParticipantsBadge.tsx ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _i18n_messages_en__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../i18n/messages/en */ "./src/i18n/messages/en.js");
/* harmony import */ var _AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../AgentStateSelector/StateTimer */ "./src/direflow-components/AgentStateSelector/StateTimer.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _AccordionHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../AccordionHelper */ "./src/direflow-components/InteractionControl/AccordionHelper.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Utility/Utils/InteractionControlUtils */ "./src/direflow-components/Utility/Utils/InteractionControlUtils.ts");










const MENU_OVERLAY_OPEN = "menu-overlay-open";
const MENU_OVERLAY_CLOSE = "menu-overlay-close";
const GREEN = "green";
const ParticipantsBadge = ({ contactInformation, agentCallMonitoringState, interactionTimer, getBadgeText, isConsultView, currentStateTimer, interactionIcon, isConferenceBadge }) => {
    const menuElm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const menuTriggerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [filteredParticipantsList, setFilteredParticipantsList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const supervisorNameRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const agentNameRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const openMenu = () => {
        setIsOpen(true);
    };
    const closeMenu = () => {
        setIsOpen(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        const stateMenu = menuElm === null || menuElm === void 0 ? void 0 : menuElm.current;
        if (stateMenu) {
            stateMenu.addEventListener(MENU_OVERLAY_OPEN, openMenu);
            stateMenu.addEventListener(MENU_OVERLAY_CLOSE, closeMenu);
        }
        return () => {
            if (stateMenu) {
                stateMenu.removeEventListener(MENU_OVERLAY_OPEN, openMenu);
                stateMenu.removeEventListener(MENU_OVERLAY_CLOSE, closeMenu);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        const participantsDetails = contactInformation.primaryMediaParticipants;
        if (participantsDetails) {
            const filtered = Object.values(participantsDetails).filter((key) => key.agentId !== contactInformation.agentId);
            setFilteredParticipantsList(filtered);
        }
    }, [contactInformation.primaryMediaParticipants, contactInformation.agentId]);
    const getParticipantsList = () => {
        return filteredParticipantsList.map((participant) => {
            var _a, _b, _c;
            if (((_a = participant === null || participant === void 0 ? void 0 : participant.pType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== _constants__WEBPACK_IMPORTED_MODULE_2__.SUPERVISOR) {
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-list-item", Object.assign({ class: "md-list-item-conference", slot: "list-item" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "conferenceBargeIN-span" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "conference-span-icon" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { "aria-hidden": "true", class: "split-icon", name: "meet_12" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ class: "conference-span-name-tooltip", placement: "right" }, (!(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_6__.isTextOverflow)((_b = agentNameRef === null || agentNameRef === void 0 ? void 0 : agentNameRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth, (participant === null || participant === void 0 ? void 0 : participant.agentName) || (participant === null || participant === void 0 ? void 0 : participant.agentId))
                                ? { disabled: true }
                                : ""), { message: (participant === null || participant === void 0 ? void 0 : participant.agentName) || (participant === null || participant === void 0 ? void 0 : participant.agentId) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ ref: agentNameRef, className: "conferenceBargeIN-span-name wd-100" }, { children: (participant === null || participant === void 0 ? void 0 : participant.agentName) || (participant === null || participant === void 0 ? void 0 : participant.agentId) })) }))] })) })));
            }
            else if (agentCallMonitoringState) {
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-list-item", Object.assign({ class: "md-list-item-conference", slot: "list-item" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "conference-span-icon" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { "aria-hidden": "true", class: "split-icon", name: "single-number-reach_16" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ class: "conference-span-name-tooltip", placement: "right" }, (!(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_6__.isTextOverflow)((_c = supervisorNameRef === null || supervisorNameRef === void 0 ? void 0 : supervisorNameRef.current) === null || _c === void 0 ? void 0 : _c.offsetWidth, agentCallMonitoringState === null || agentCallMonitoringState === void 0 ? void 0 : agentCallMonitoringState.supervisorName)
                            ? { disabled: true }
                            : ""), { message: agentCallMonitoringState === null || agentCallMonitoringState === void 0 ? void 0 : agentCallMonitoringState.supervisorName }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ ref: supervisorNameRef, className: "conferenceBargeIN-span-name" }, { children: agentCallMonitoringState === null || agentCallMonitoringState === void 0 ? void 0 : agentCallMonitoringState.supervisorName })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "conference-timer" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_5__["default"], { color: "none", timerTimeStamp: agentCallMonitoringState === null || agentCallMonitoringState === void 0 ? void 0 : agentCallMonitoringState.eventTime }) }))] })));
            }
            return null;
        });
    };
    const getTotalParticpantCount = () => {
        return filteredParticipantsList === null || filteredParticipantsList === void 0 ? void 0 : filteredParticipantsList.length;
    };
    const getParticipantLabel = () => {
        return (contactInformation.primaryMediaParticipants &&
            `+${getTotalParticpantCount()}  ${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getLocalizedMessages)().interaction_control.participants}`);
    };
    const isPostCallConsult = () => {
        return (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_9__.isPostCallConsultInProgress)(contactInformation) || (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_9__.isPostCallConsultRequested)(contactInformation);
    };
    const isPostCallView = () => {
        return contactInformation.isInteractionInPostCall && !isConsultView;
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.I18nProvider, Object.assign({ value: Object.assign({}, _i18n_messages_en__WEBPACK_IMPORTED_MODULE_4__["default"]) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ placement: "bottom-end", ref: menuElm, size: "small", position: "bottom", id: "participants-badge-menu-overlay" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ ariaLabel: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.getLocalizedMessages)().interaction_control.bargeInConferenceAriaLabel, class: "md-button-conference", ref: menuTriggerRef, slot: "menu-trigger" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ circle: true, color: GREEN }, (contactInformation.state !== _constants__WEBPACK_IMPORTED_MODULE_8__.CONSULTREQUESTED && contactInformation.isHold && !isPostCallView
                            ? { bgcolor: "#FFD98C" }
                            : ""), { small: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", Object.assign({ name: "icon-handset-active_12", size: "12" }, (contactInformation.state !== _constants__WEBPACK_IMPORTED_MODULE_8__.CONSULTREQUESTED && contactInformation.isHold && !isPostCallView
                                ? { color: "#7D4705" }
                                : ""))) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_5__["default"], { color: "none", timerTimeStamp: interactionTimer }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ "aria-hidden": "true", className: "split-separator" }, { children: [" ", "|", " "] })), !isPostCallConsult() && isConferenceBadge && !contactInformation.isHold ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "split-right-participants" }, { children: getParticipantLabel() }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ "aria-hidden": "true", className: "split-right-participants" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { "aria-hidden": "true", class: "split-icon", name: interactionIcon, size: "14", iconSet: "momentumDesign" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true" }, { children: getBadgeText() }))] }), (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_7__.isContactTimer)(contactInformation, isConsultView, true, agentCallMonitoringState) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "timer-dash" }, { children: "-" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_5__["default"], { color: "none", timerTimeStamp: currentStateTimer })] }))] }))), isOpen ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "arrow-icon arrow-up", name: "icon-arrow-up-optical_8" })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "arrow-icon arrow-down", name: "icon-arrow-down-optical_8" }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-list", Object.assign({ class: "md-list-conference" }, { children: getParticipantsList() }))] })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ParticipantsBadge);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/ParticipantsBadgeForConference.tsx":
/*!**************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/ParticipantsBadgeForConference.tsx ***!
  \**************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _i18n_messages_en__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../i18n/messages/en */ "./src/i18n/messages/en.js");
/* harmony import */ var _AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../AgentStateSelector/StateTimer */ "./src/direflow-components/AgentStateSelector/StateTimer.tsx");
/* harmony import */ var _AccordionHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../AccordionHelper */ "./src/direflow-components/InteractionControl/AccordionHelper.tsx");






const ParticipantsBadgeForConference = ({ contactInformation, agentCallMonitoringState, interactionTimer, agentId, isMPCEnabled }) => {
    const menuElm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const menuTriggerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const openMenu = () => {
        setIsOpen(true);
    };
    const closeMenu = () => {
        setIsOpen(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        const stateMenu = menuElm === null || menuElm === void 0 ? void 0 : menuElm.current;
        if (stateMenu) {
            stateMenu.addEventListener("menu-overlay-open", openMenu);
            stateMenu.addEventListener("menu-overlay-close", closeMenu);
        }
        return () => {
            if (stateMenu) {
                stateMenu.removeEventListener("menu-overlay-open", openMenu);
                stateMenu.removeEventListener("menu-overlay-close", closeMenu);
            }
        };
    }, []);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.I18nProvider, Object.assign({ value: Object.assign({}, _i18n_messages_en__WEBPACK_IMPORTED_MODULE_3__["default"]) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ placement: "bottom-end", ref: menuElm, size: "small", position: "bottom", id: "menu-overlay", "max-height": "180px" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ ariaLabel: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.getLocalizedMessages)().interaction_control.bargeInConferenceAriaLabel, class: "md-button-conference", ref: menuTriggerRef, slot: "menu-trigger" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-badge", Object.assign({ circle: true, small: true, style: { marginRight: "var(--margin-375rem)" }, color: "green", bgColor: "" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "handset-filled", size: "12", iconSet: "momentumDesign" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_4__["default"], { color: "none", timerTimeStamp: interactionTimer }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ "aria-hidden": "true", className: "split-separator" }, { children: [" ", "|", " "] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ "aria-hidden": "true", className: "split-right-conference" }, { children: ["+2 ", (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.getLocalizedMessages)().interaction_control.participants] })), isOpen ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "arrow-icon arrow-up", name: "icon-arrow-up-optical_8" })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "arrow-icon arrow-down", name: "icon-arrow-down-optical_8" }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-list", Object.assign({ class: "md-list-conference" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-list-item", Object.assign({ class: "md-list-item-conference", slot: "list-item" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "conference-span-icon" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "split-icon", name: "meet_12" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "conferenceBargeIN-span-name" }, { children: isMPCEnabled
                                        ? (0,_AccordionHelper__WEBPACK_IMPORTED_MODULE_5__.getOtherAgentTitleInTwoPartyConference)(contactInformation, agentId)
                                        : (contactInformation === null || contactInformation === void 0 ? void 0 : contactInformation.destAgentName) || (contactInformation === null || contactInformation === void 0 ? void 0 : contactInformation.destAgentId) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "conference-timer" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_4__["default"], { color: "none", timerTimeStamp: contactInformation === null || contactInformation === void 0 ? void 0 : contactInformation.consultTimeStamp }) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-list-item", Object.assign({ class: "md-list-item-conference", slot: "list-item" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-hidden": "true", className: "conference-span-icon" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "split-icon", name: "single-number-reach_16" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "conferenceBargeIN-span-name" }, { children: agentCallMonitoringState === null || agentCallMonitoringState === void 0 ? void 0 : agentCallMonitoringState.supervisorName })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "conference-timer" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_4__["default"], { color: "none", timerTimeStamp: agentCallMonitoringState === null || agentCallMonitoringState === void 0 ? void 0 : agentCallMonitoringState.eventTime }) }))] }))] }))] })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ParticipantsBadgeForConference);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/Agent/BuddyAgentsList.tsx":
/*!*******************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/Agent/BuddyAgentsList.tsx ***!
  \*******************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_components_List__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../Common/components/List */ "./src/direflow-components/Common/components/List/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _TransferHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../TransferHelper */ "./src/direflow-components/InteractionControl/TransferHelper.ts");
/* harmony import */ var _common_ListItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../common/ListItem */ "./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.tsx");
/* harmony import */ var _common_SearchBar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../common/SearchBar */ "./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.tsx");
/* harmony import */ var _Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../Common/components/List/ListError */ "./src/direflow-components/Common/components/List/ListError/index.tsx");











const ItemHeight = 48;
const BuddyAgentsList = ({ selectedType, agentProfileID, mediaType, agentAction, setTrackingId, handleErrorMessageOnFetchSuccess, handleErrorMessageOnFetchFailure, onBuddyAgentSelect, listHeight, renderTransferModalError }) => {
    const [buddyAgentsList, setBuddyAgentsList] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [filteredAgentsList, setFilteredAgentsList] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
    const [searchQuery, setSearchQuery] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [isError, setIsError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const { transferModal, outdial } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const [loadingPageError, setLoadingPageError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const i18n = {
        tooltipMsg: transferModal.refreshTheList,
        refreshBtnAriaLabel: transferModal.refreshAgentList,
        emptyListInputPlaceholder: transferModal.AgentsEmpty,
        listInputPlaceholder: transferModal.infScrollAgent || transferModal.comboBoxAriaLabelAgent,
        noAdrFound: outdial.noAdrFound
    };
    const fetchBuddyAgentsList = () => {
        const buddyAgentPayLoad = {
            agentProfileId: agentProfileID,
            mediaType
        };
        if (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_6__.TRANSFER) {
            buddyAgentPayLoad.state = _Common_constants__WEBPACK_IMPORTED_MODULE_6__.AVAILABLE;
        }
        (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_7__.getBuddyAgentsListForInfiniteScrollModal)(buddyAgentPayLoad)
            .then((res) => {
            setBuddyAgentsList(res.data.agentList);
            setFilteredAgentsList(filterAgentsByName(res.data.agentList, searchQuery));
            setLoading(false);
            setIsError(false);
            (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_7__.buddySuccessHandler)(res, handleErrorMessageOnFetchSuccess);
            // this is needed for trap focus within Modal
            document.dispatchEvent(new CustomEvent("on-widget-update"));
        })
            .catch((err) => {
            setLoading(false);
            setIsError(true);
            setLoadingPageError(err);
            (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_7__.buddyErrorHandler)(err, setTrackingId, handleErrorMessageOnFetchFailure);
        });
    };
    const refreshBuddyAgentsList = () => {
        setIsError(false);
        setLoading(true);
        setBuddyAgentsList([]); // on refresh, clear the list
        onBuddyAgentSelect(""); // on refresh, clear the selected agent
        setFilteredAgentsList([]); // on refresh, clear the filtered list
        fetchBuddyAgentsList();
    };
    const filterAgentsByName = (buddyAgentsList, searchText) => {
        if (!searchText) {
            return buddyAgentsList;
        }
        return buddyAgentsList.filter((agent) => agent.agentName.toLowerCase().includes(searchText.toLowerCase()));
    };
    const searchHandler = (searchText) => {
        setSearchQuery(searchText);
    };
    const resetFilteredList = () => {
        refreshBuddyAgentsList();
        setSearchQuery("");
    };
    const handleSearchQuery = () => {
        if (searchQuery === "") {
            resetFilteredList();
        }
        else {
            setFilteredAgentsList(filterAgentsByName(buddyAgentsList, searchQuery));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (!loading) {
            handleSearchQuery();
        }
    }, [searchQuery]);
    // adding listener only for resetting the list to original list when selected radio button changes
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        setLoading(true);
        fetchBuddyAgentsList();
    }, [selectedType]);
    const onAgentSelectFromList = (selectData) => {
        onBuddyAgentSelect(selectData);
    };
    const getHeight = () => {
        return listHeight || 290;
    };
    const renderListError = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_10__["default"], { onRetry: () => refreshBuddyAgentsList(), trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(loadingPageError) }));
    };
    const renderBuddyAgentsList = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [renderTransferModalError && renderTransferModalError(), (filteredAgentsList === null || filteredAgentsList === void 0 ? void 0 : filteredAgentsList.length) > 0 ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_5__["default"], Object.assign({ innerElementType: "ul", data: filteredAgentsList, height: getHeight(), itemHeight: ItemHeight, onSelectValue: onAgentSelectFromList, infiniteScrollEnabled: false, ariaLabel: transferModal.comboBoxAriaLabelAgent }, { children: (props) => {
                        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_ListItem__WEBPACK_IMPORTED_MODULE_8__["default"], Object.assign({}, props, { avatarState: props.data.state, title: props.data.agentName, searchQuery: searchQuery })));
                    } }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "no-record", style: { height: getHeight() } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_4__["default"], { illustrationType: "empty-result" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-label": i18n.noAdrFound, className: "no-record-found" }, { children: i18n.noAdrFound }))] })))] }));
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "transfer-to-div" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_SearchBar__WEBPACK_IMPORTED_MODULE_9__["default"], { i18n: i18n, refreshListHandler: refreshBuddyAgentsList, searchHandler: searchHandler, loading: loading, isListEmpty: !loading && !isError && buddyAgentsList.length === 0 }), loading && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "infinite-scroll-spinner-modal", "data-testid": "list-loading-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "56" }) }))), isError && renderListError(), !loading && !isError && renderBuddyAgentsList()] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BuddyAgentsList);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/EPList/EPList.tsx":
/*!***********************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/EPList/EPList.tsx ***!
  \***********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_components_List__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../Common/components/List */ "./src/direflow-components/Common/components/List/index.tsx");
/* harmony import */ var _Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../Common/components/List/ListError */ "./src/direflow-components/Common/components/List/ListError/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");
/* harmony import */ var _TransferHelper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../TransferHelper */ "./src/direflow-components/InteractionControl/TransferHelper.ts");
/* harmony import */ var _common_ListItem__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../common/ListItem */ "./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.tsx");
/* harmony import */ var _common_SearchBar__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../common/SearchBar */ "./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.tsx");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../styles.css */ "./src/direflow-components/InteractionControl/components/TransferModal/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_14__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};















const ItemHeight = 48;
const EntryPointList = ({ agentAction, selectedType, setTrackingId, handleErrorMessageOnFetchSuccess, handleErrorMessageOnFetchFailure, onEPSelect, mediaType, listHeight, renderTransferModalError }) => {
    const [epList, setEPList] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [completeFetchedList, setCompleteFetchedList] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [searchQuery, setSearchQuery] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const { transferModal, outdial } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.useI18nContext)();
    // pagination
    const [hasNextPage, setHasNextPage] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [pageNum, setPageNum] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(-1);
    const [isAllPagesLoaded, setIsAllPagesLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    // loading
    const [isSearchBarLoading, setIsSearchBarLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [loadingFirstPage, setLoadingFirstPage] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true);
    const [isNextPageLoading, setIsNextPageLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    // errors
    const [searchMinCharError, setSearchMinCharError] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [loadingFirstPageError, setLoadingFirstPageError] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        error: false,
        trackingId: ""
    });
    const [pageFetchError, setPageFetchError] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        error: false,
        trackingId: ""
    });
    const i18n = {
        tooltipMsg: transferModal.refreshTheList,
        refreshBtnAriaLabel: transferModal.refreshEpList,
        emptyListInputPlaceholder: transferModal.EPEmpty,
        listInputPlaceholder: transferModal.infScrollEP || transferModal.comboBoxAriaLabelEp,
        noAdrFound: outdial.noAdrFound,
        noRecordFound: outdial.noAdrFound,
        searchMinCharError: transferModal.searchMinCharError
    };
    // to refresh the EP list
    const refreshEPList = () => {
        setIsSearchBarLoading(true);
        setLoadingFirstPage(true);
        onEPSelect("");
        setEPList([]);
        loadPage(_constants__WEBPACK_IMPORTED_MODULE_9__.FIRST_PAGE, searchQuery, true);
    };
    const getFilteredEPList = (list, searchText) => {
        const lowerSearchText = searchText.toLowerCase();
        return list.filter((item) => {
            const matchesName = item.name.toLowerCase().includes(lowerSearchText);
            const matchesDialedNumber = agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_8__.CONSULT && item.dialledNumber.toLowerCase().includes(lowerSearchText);
            return matchesName || matchesDialedNumber;
        });
    };
    const filterEPList = (searchText) => {
        const filteredList = getFilteredEPList(completeFetchedList, searchText);
        setEPList(filteredList);
        setSearchMinCharError(false);
    };
    const onSearchInputChange = (searchText) => {
        if (searchText === "") {
            if (isAllPagesLoaded) {
                if (completeFetchedList.length) {
                    setEPList(completeFetchedList);
                }
                setHasNextPage(false);
                setSearchMinCharError(false);
            }
            else {
                refreshEPList();
            }
        }
        else {
            if (searchText.length >= _Common_constants__WEBPACK_IMPORTED_MODULE_8__.MINIMUM_CHARACTERS_FOR_SEARCH) {
                if (isAllPagesLoaded) {
                    filterEPList(searchText);
                }
                else {
                    setIsSearchBarLoading(true);
                    setLoadingFirstPage(true);
                    loadPage(_constants__WEBPACK_IMPORTED_MODULE_9__.FIRST_PAGE, searchText, true);
                }
            }
            else {
                setSearchMinCharError(true);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if (!loadingFirstPage) {
            onSearchInputChange(searchQuery);
        }
    }, [searchQuery]);
    const searchHandler = (searchText) => {
        setSearchQuery(searchText);
    };
    // functions related to pagination
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        loadFirstPage();
    }, [selectedType]);
    const onEPSelectFromList = (selectData) => {
        onEPSelect(selectData);
    };
    const fetchEPDNList = (pageNumber, searchQuery) => {
        var _a;
        return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs
            .fetchPaginatedEpDnMappingList({
            payload: {
                pageSize: _Common_constants__WEBPACK_IMPORTED_MODULE_8__.PAGE_SIZE,
                pageNumber,
                channelType: mediaType,
                search: searchQuery
            },
            orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || ""
        })
            .then((res) => {
            return res;
        })
            .catch((e) => {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_10__.logger.error("event=fetchEPDNMappingFailed Error while fetching epdn mapping list", e);
            handleLoadPageError(e, pageNumber);
            return null;
        });
    };
    const fetchEPList = (pageNumber, searchQuery) => {
        var _a;
        return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs
            .fetchEpList({
            payload: {
                pageSize: _Common_constants__WEBPACK_IMPORTED_MODULE_8__.PAGE_SIZE,
                pageNumber,
                channelType: mediaType,
                search: searchQuery
            },
            orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || ""
        })
            .then((res) => {
            return res;
        })
            .catch((e) => {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_10__.logger.error("event=fetchEPListFailed Error while fetching ep list", e);
            handleLoadPageError(e, pageNumber);
            return null;
        });
    };
    const fetchList = (pageNumber, searchQuery) => __awaiter(void 0, void 0, void 0, function* () {
        let response = null;
        if (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_8__.CONSULT) {
            response = yield fetchEPDNList(pageNumber, searchQuery);
        }
        else if (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_8__.TRANSFER) {
            response = yield fetchEPList(pageNumber, searchQuery);
        }
        return Promise.resolve(response);
    });
    const loadPage = (pageNumber, searchQuery, reset = false) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield fetchList(pageNumber, searchQuery);
        if (res) {
            handleLoadPageSuccess(res, reset, searchQuery);
            // this is needed for trap focus within Modal
            document.dispatchEvent(new CustomEvent("on-widget-update"));
        }
        // to control the SearchBar behaviour
        setIsSearchBarLoading(false);
        setSearchMinCharError(false);
    });
    const loadFirstPage = () => {
        setEPList([]);
        setLoadingFirstPage(true);
        setLoadingFirstPageError({
            error: false,
            trackingId: ""
        });
        loadPage(_constants__WEBPACK_IMPORTED_MODULE_9__.FIRST_PAGE, searchQuery, true);
    };
    const loadNextPage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isNextPageLoading) {
            return;
        }
        setIsNextPageLoading(true);
        loadPage(pageNum + 1, searchQuery, false);
    });
    const handleLoadPageSuccess = (res, reset, searchQuery) => {
        const { page, totalPages } = res.meta || {};
        const currentEpList = res.data;
        const newEpList = reset ? currentEpList : [...epList, ...currentEpList];
        // TODO: [CX-18483]: below filtering logic for consult action will be removed after the API  supports the desktop profile filter as local filtering is not needed then.
        const filteredList = agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_8__.CONSULT ? getFilteredEPList(currentEpList, searchQuery) : newEpList;
        setEPList(filteredList);
        const isLastPage = page === totalPages - 1;
        const isFirstPage = page === _constants__WEBPACK_IMPORTED_MODULE_9__.FIRST_PAGE;
        if (!searchQuery) {
            setIsAllPagesLoaded(isLastPage);
            if (isLastPage) {
                setCompleteFetchedList(newEpList);
            }
        }
        else if (isFirstPage && agentAction !== _Common_constants__WEBPACK_IMPORTED_MODULE_8__.CONSULT) {
            setIsAllPagesLoaded(false);
            setCompleteFetchedList([]);
        }
        setPageFetchError({ error: false, trackingId: "" });
        setLoadingFirstPageError({ error: false, trackingId: "" });
        if (page !== undefined && totalPages !== undefined) {
            setHasNextPage(page < totalPages - 1);
        }
        else {
            setHasNextPage(false);
        }
        if (page === _constants__WEBPACK_IMPORTED_MODULE_9__.FIRST_PAGE || page === -1) {
            setLoadingFirstPage(false);
            onEPSelectFromList("");
        }
        setIsNextPageLoading(false);
        (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_11__.epSuccessHandler)(currentEpList, handleErrorMessageOnFetchSuccess, agentAction);
        setPageNum(page);
    };
    const handleLoadPageError = (err, pageNumber) => {
        const trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err);
        if (pageNumber === _constants__WEBPACK_IMPORTED_MODULE_9__.FIRST_PAGE || pageNumber === -1) {
            setLoadingFirstPage(false);
            setLoadingFirstPageError({ error: true, trackingId });
            onEPSelect("");
            (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_11__.epErrorHandler)(err, setTrackingId, handleErrorMessageOnFetchFailure, agentAction);
        }
        else {
            setPageFetchError({ error: true, trackingId });
            setHasNextPage(true);
            setIsNextPageLoading(false);
        }
    };
    // UI renders
    const getContentHeight = () => {
        return listHeight !== null && listHeight !== void 0 ? listHeight : 290;
    };
    const renderSearchBar = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_SearchBar__WEBPACK_IMPORTED_MODULE_13__["default"], { i18n: i18n, refreshListHandler: refreshEPList, searchHandler: searchHandler, loading: isSearchBarLoading, isListEmpty: isSearchBarLoading }));
    };
    const renderLoader = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "infinite-scroll-spinner-modal", "data-testid": "list-loading-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "56" }) })));
    };
    const getSubtitle = (props) => {
        return agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_8__.CONSULT ? props.data.dialledNumber : "";
    };
    const renderEPList = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_6__["default"], Object.assign({ innerElementType: "ul", data: epList, height: getContentHeight(), itemHeight: ItemHeight, onSelectValue: onEPSelectFromList, infiniteScrollEnabled: true, ariaLabel: transferModal.comboBoxAriaLabelEp, loadNextPage: loadNextPage, hasNextPage: hasNextPage, isNextPageLoading: isNextPageLoading, pageFetchError: pageFetchError }, { children: (props) => {
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_ListItem__WEBPACK_IMPORTED_MODULE_12__["default"], Object.assign({}, props, { title: props.data.name, searchQuery: searchQuery, subTitle: getSubtitle(props) })));
            } })));
    };
    const renderNoRecordFound = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "no-record modal-content-height" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_5__["default"], { illustrationType: "empty-result" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-label": i18n.noRecordFound, className: "no-record-found" }, { children: i18n.noRecordFound }))] })));
    };
    const renderListError = () => {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_7__["default"], { onRetry: () => loadFirstPage(), trackingId: loadingFirstPageError.trackingId });
    };
    const renderMinCharSearchError = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "search-block-error modal-content-height" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "search-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "info_16", class: "search-error-info" }), i18n.searchMinCharError] })) })));
    };
    const isShowLoader = () => {
        return loadingFirstPage && !loadingFirstPageError.error && !searchMinCharError;
    };
    const isLoaded = () => {
        return !loadingFirstPage && !loadingFirstPageError.error && !searchMinCharError;
    };
    const renderErrorMessage = () => {
        return isLoaded() ? renderNoRecordFound() : renderListError();
    };
    const renderError = () => {
        return searchMinCharError ? renderMinCharSearchError() : renderErrorMessage();
    };
    const isShowEPList = () => {
        return isLoaded() && epList.length > 0;
    };
    const renderEPSection = () => {
        return isShowEPList() ? renderEPList() : renderError();
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: (_styles_css__WEBPACK_IMPORTED_MODULE_14___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "transfer-to-div" }, { children: [renderSearchBar(), renderTransferModalError && renderTransferModalError(), isShowLoader() ? renderLoader() : renderEPSection()] })) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EntryPointList);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/TransferModalContent.tsx":
/*!******************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/TransferModalContent.tsx ***!
  \******************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _AddressBookIncreasedLimit_AddressBookIncreasedLimit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../AddressBookIncreasedLimit/AddressBookIncreasedLimit */ "./src/direflow-components/AddressBookIncreasedLimit/AddressBookIncreasedLimit.tsx");
/* harmony import */ var _Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Common/components/HighlightText */ "./src/direflow-components/Common/components/HighlightText/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");
/* harmony import */ var _TransferHelper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../TransferHelper */ "./src/direflow-components/InteractionControl/TransferHelper.ts");
/* harmony import */ var _Agent_BuddyAgentsList__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./Agent/BuddyAgentsList */ "./src/direflow-components/InteractionControl/components/TransferModal/Agent/BuddyAgentsList.tsx");
/* harmony import */ var _EPList_EPList__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./EPList/EPList */ "./src/direflow-components/InteractionControl/components/TransferModal/EPList/EPList.tsx");
/* harmony import */ var _integration_microsoft__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./integration/microsoft */ "./src/direflow-components/InteractionControl/components/TransferModal/integration/microsoft/index.tsx");
/* harmony import */ var _integration_microsoft_AuthError__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./integration/microsoft/AuthError */ "./src/direflow-components/InteractionControl/components/TransferModal/integration/microsoft/AuthError.tsx");
/* harmony import */ var _integration_webex_WebexOrganizationUserList__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./integration/webex/WebexOrganizationUserList */ "./src/direflow-components/InteractionControl/components/TransferModal/integration/webex/WebexOrganizationUserList.tsx");
/* harmony import */ var _queue_QueueList__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./queue/QueueList */ "./src/direflow-components/InteractionControl/components/TransferModal/queue/QueueList.tsx");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./styles.css */ "./src/direflow-components/InteractionControl/components/TransferModal/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_22__);

/* eslint-disable no-unused-expressions */






















const TransferModalContent = ({ orgId, modal, agentAction, agentActionType, handleCloseModal, interactionId, reasonCode, mediaType, config, enableSubmitForTesting, setDestinationQueue, cancelCtq, enableQueue, showCtqErrorMessage, isCtqInProgress, eTrackingId, contactDirection, ani, epDnMapping, addressBook, isDesktopConsultToEntryPointDnEnabled, isAddressBookInfiniteScrollEnabled, isWxccMultiPartyConfEnabled, isWxccPersistCallEnabled, primaryMediaParticipants, isDarkMode, isConsultTransferInfiniteScrollEnabled }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    let arr = [""];
    const accessBuddyTeam = (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.accessBuddyTeam) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    const accessQueue = (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _c === void 0 ? void 0 : _c.accessQueue) === null || _d === void 0 ? void 0 : _d.toLowerCase();
    const accessEntryPoint = (_f = (_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _e === void 0 ? void 0 : _e.accessEntryPoint) === null || _f === void 0 ? void 0 : _f.toLowerCase();
    const hideAgent = isAgentRadioButtonHidden();
    const hideQueue = isQueueRadioButtonHidden();
    const hideEP = isEPRadioButtonHidden();
    const hideDN = isDNRadioButtonHidden();
    const hideOrg = isOrganisationRadioButtonHidden();
    const { initialListType, listTypeSeqNo } = getInitialListTypeAndSeqNo();
    const [defaultListType, setDefaultListType] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(() => {
        return isConsultTransferInfiniteScrollEnabled ? initialListType : mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.EMAIL ? _Common_constants__WEBPACK_IMPORTED_MODULE_11__.QUEUES : _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS;
    });
    const [dropdownValue, setDropdownValue] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]);
    const [selectedValue, setSelectedValue] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""); // Variable for setting selected value from combo box
    const [inputValue, setInputValue] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const [orgSearchValue, setOrgSearchValue] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null);
    const [inputValueWithoutEscape, setinputValueWithoutEscape] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const [i18nMessage, seti18nMessage] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(_constants__WEBPACK_IMPORTED_MODULE_13__.i18nMessages);
    const [showErrorMessage, setShowErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [showCustomerLeftMessage, setShowCustomerLeftMessage] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [showFetchErrorMessage, setShowFetchErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [isShowCtqErrorMessage, setShowCtqErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [initiateDataFetch, setInitiateDataFetch] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0);
    const [initiateOrgDataFetch, setInitiateOrgDataFetch] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0);
    const [trackingId, setTrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const dispatchCustomEvent = (0,react__WEBPACK_IMPORTED_MODULE_6__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.EventContext);
    const [buddyList, setbuddyList] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]);
    const [vteamList, setVteamList] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]);
    const [dn, setDn] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]);
    const [isEpDnFetching, setEpDnFetching] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [ctqInProgress, setCtqInProgress] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(isCtqInProgress);
    const [shouldDisableSubmitBtn, setShouldDisableSubmitBtn] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const { transferModal, common, organization: i18nOrganization } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_8__.useI18nContext)();
    const [showErrorDnVaildation, setShowErrorDnVaildation] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [isChanged, setIsChanged] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false); // disable radio buttons while vteam/buddyagent/addressbook request is in progess.
    const [isLoadingListItem, setIsLoadingListItem] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [selectedEntryPointId, setSelectedEntryPointId] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const [selectedBuddyAgent, setSelectedBuddyAgent] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null);
    const [resetTab, setResetTab] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(-1);
    const [selectedQueue, setSelectedQueue] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null);
    const [selectedEntryPoint, setSelectedEntryPoint] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null);
    const selectedTab = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(0);
    const tabElm = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const modalRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const tabPanelElmOne = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const tabPanelElmTwo = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const radioGroupRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const comboBoxRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const submitButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const searchInputRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const orgSearchInputRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const orgContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const menuOverlayRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const hoveredListItemRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(-1);
    const resizeObserverRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const focusTrapUpdateTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const inputFieldFocusTimeIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const searchFieldFocusTimeIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const visibleTabTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const focusTimerIdRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const [isConnectorView, setIsConnectorView] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [connViewOrgListHeight, setConnViewOrgListHeight] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0);
    //MultiPartyConference
    const holdParticipantsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(true);
    const visibleOptions = 6;
    const blindTransferEventName = "ax-interaction-blind-transfer";
    const DEFAULT_AVATAR_SIZE = 36;
    const isAddressBookConfigured = !!((_g = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _g === void 0 ? void 0 : _g.addressBookId);
    const INPUT_CHANGE_EVENT = "input-change";
    const isAllRadioButtonsHidden = hideAgent && hideQueue && hideEP && hideDN && hideOrg;
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        var _a;
        const consultCreatedlistener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.contact.eAgentConsultCreated.listen((resp) => {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`successfully initiated consult request : ${resp}`);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.CONSULT_START_TIME, new Date().getTime());
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_util.trackConsultEvent({
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_ACTIVATED,
                mediaType,
                interactionId: resp.data.interactionId,
                contactDirection
            });
            (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.dispatchCustomInteractionEvent)({
                response: _constants__WEBPACK_IMPORTED_MODULE_13__.SUCCESS,
                thisEvent: { type: resp.type, interactionId: resp.data.interactionId },
                eventName: "ax-interaction-consult-created",
                dispatchCustomEvent
            });
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.contact.eAgentConsultFailed.listen(({ data }) => {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_util.trackConsultEvent({
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_ACTIVATED,
                mediaType,
                interactionId: data.interactionId,
                contactDirection,
                status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                timeEvent: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_END_ACTIVATED,
                reasonForFailure: "AgentConsultFailed",
                reasonCode: data.reason
            });
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.contact.eAgentContactEnded.listen((resp) => {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`event=customerDropDuringConsultRequest: ${resp}`);
            setShowCustomerLeftMessage(true);
        });
        const blindTransferlistener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.contact.eAgentblindTransferred.listen((resp) => {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_INTERACTION_TRANSFERRED, {
                status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
                mediaType,
                interactionId: resp.data.interactionId,
                contactDirection
            });
            (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.dispatchCustomInteractionEvent)({
                response: _constants__WEBPACK_IMPORTED_MODULE_13__.SUCCESS,
                thisEvent: { type: resp.type, interactionId: resp.data.interactionId },
                eventName: blindTransferEventName,
                dispatchCustomEvent
            });
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`blindTransfer: success for interactionId : ${resp.data.interactionId}`);
        });
        const vTeamTransferlistener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.contact.eAgentvteamTransfer.listen((resp) => {
            (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.dispatchCustomInteractionEvent)({
                response: _constants__WEBPACK_IMPORTED_MODULE_13__.SUCCESS,
                thisEvent: { type: resp.type, interactionId: resp.data.interactionId },
                eventName: blindTransferEventName,
                dispatchCustomEvent
            });
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`vTeam Transfer: success for interactionId : ${resp.data.interactionId}`);
        });
        setupConsultTypeTelemetry(defaultListType);
        // Load EpDn and AddressBook List on component mount and set on STORE.
        if (!addressBook.initialFetchCompleted && !isAddressBookInfiniteScrollEnabled) {
            // Load AddressBook List.
            (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.updateAddressBook)(dispatchCustomEvent, agentAction).catch((error) => {
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.error("Error on fetching address book", error);
            });
        }
        if (!epDnMapping.initialFetchCompleted &&
            isDesktopConsultToEntryPointDnEnabled &&
            ((_a = config === null || config === void 0 ? void 0 : config.channels) === null || _a === void 0 ? void 0 : _a.voiceCount) > 0 &&
            !isConsultTransferInfiniteScrollEnabled) {
            (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.updateEpDnList)(orgId, dispatchCustomEvent) // Load EpDn List.
                .then(() => updateEpDnFetchingStatus(false))
                .catch((error) => {
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.error("Error on fetching EPDN list", error);
                updateEpDnFetchingStatus(false);
            });
        }
        return () => {
            if (blindTransferlistener && vTeamTransferlistener && consultCreatedlistener) {
                blindTransferlistener.stopListen();
                vTeamTransferlistener.stopListen();
                consultCreatedlistener.stopListen();
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        // Updates i18n messages and defulistype on agentAction update
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.updateState)(agentAction, seti18nMessage);
        setTrackingId(eTrackingId);
        setShowCtqErrorMessage(showCtqErrorMessage);
        setCtqInProgress(isCtqInProgress);
    }, [agentAction, eTrackingId, showCtqErrorMessage, isCtqInProgress]);
    function getInitialListTypeAndSeqNo() {
        let initialListType = "";
        let listTypeSeqNo = -1;
        if (!hideAgent) {
            initialListType = _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS;
            listTypeSeqNo = 0;
        }
        else if (!hideQueue) {
            initialListType = _Common_constants__WEBPACK_IMPORTED_MODULE_11__.QUEUES;
            listTypeSeqNo = 1;
        }
        else if (!hideDN) {
            initialListType = _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER;
            listTypeSeqNo = 2;
        }
        // DN, EP and ORG will be shown in case of Voice only,
        // so in that case always DN will be initially selected
        // and it never be EP and ORG
        return { initialListType, listTypeSeqNo };
    }
    const dropdownValuesHandler = (data, iteration) => {
        arr = [];
        data.forEach((value) => {
            if (value["dn"] && value["desc"]) {
                arr.push({ dn: value["dn"], name: value["desc"] });
            }
            else {
                arr.push(value[iteration]);
            }
        });
        return arr;
    };
    const { epDnList, isErrorMessageForEpList } = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(() => {
        return {
            epDnList: epDnMapping.data,
            isErrorMessageForEpList: 
            // This FF check is added so that only one error message is shown at a time.
            // In case of FF : off -> this should display error message.
            // In case of FF : on -> only the inner(ListError) error message should show.
            !isConsultTransferInfiniteScrollEnabled &&
                epDnMapping.initialFetchCompleted &&
                Object.keys(epDnMapping.errorObj).length > 0
                ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(epDnMapping.errorObj)
                : ""
        };
    }, [epDnMapping]);
    const { addressBookList, addressBookErrorTrackingId } = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(() => {
        return {
            addressBookList: dropdownValuesHandler(addressBook.data, _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DN),
            addressBookErrorTrackingId: 
            // This FF check is added so that only one error message is shown at a time.
            // In case of FF : off -> this should display error message.
            // In case of FF : on -> only the inner(ListError) error message should show.
            !isConsultTransferInfiniteScrollEnabled &&
                addressBook.initialFetchCompleted &&
                Object.keys(addressBook.errorObj).length > 0
                ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(addressBook.errorObj)
                : ""
        };
    }, [addressBook]);
    /**
     * Handler for input focus event to show/hide the list of agents/queues
     */
    const initializeDropdownValue = (data, iteration, listType) => {
        // Active radio button check is required before update the dropdown values
        // If API is timeout and returning the responses after some time, meanwhile user is selected another radio button.
        if (defaultListType === listType) {
            const response = dropdownValuesHandler(data, iteration);
            setDropdownValue(response);
            setIsChanged(false);
            updateFocusableElements();
        }
    };
    const handleRadioChangeEvent = (event) => {
        var _a, _b;
        if (defaultListType !== ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.selected)) {
            setIsChanged(true);
            setShowErrorMessage(false);
            setShowCustomerLeftMessage(false);
            setShowFetchErrorMessage(false);
            if ((_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.selected) {
                setSelectedValue("");
                setDefaultListType(event.detail.selected);
                setupConsultTypeTelemetry(event.detail.selected);
            }
            setInputValue("");
            setinputValueWithoutEscape("");
            setShowCtqErrorMessage(false);
            setCtqInProgress(false);
            setShowErrorDnVaildation(false);
        }
    };
    const onQueueSelect = (data) => {
        setSelectedValue(data.name);
        setSelectedQueue(data);
    };
    const onBuddyAgentSelect = (data) => {
        setSelectedValue(data.agentName);
        setSelectedBuddyAgent(data);
    };
    const onEntryPointSelect = (data) => {
        setSelectedValue(data.name);
        setSelectedEntryPoint(data);
    };
    const updateSelectedValue = (e) => {
        // on select/Unselect handle selectedValue and submit button
        let selectedDn = "";
        if (e.detail.value && e.detail.value.value) {
            selectedDn = e.detail.value.value.dn ? e.detail.value.value.dn : e.detail.value.value;
        }
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.CHOSE_ADDRESS_BOOK_ENTRY, true);
        setSelectedValue(selectedDn);
        setShowErrorDnVaildation(false);
    };
    const setupConsultTypeTelemetry = (key) => {
        if (config.collaborationConfig.displayWebexUserDetails && key === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION) {
            key = _Common_constants__WEBPACK_IMPORTED_MODULE_11__.WEBEX_EXPERTS;
        }
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.CONSULT_TYPE, key);
    };
    const escapeSpecialCharactersOnDN = (input) => {
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER) {
            input = input.replace(/[^+*#:0-9]/g, "");
        }
        return input;
    };
    const updateOnInputChange = (e) => {
        const inputWithoutFormat = e.detail.value;
        const input = escapeSpecialCharactersOnDN(inputWithoutFormat);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.SEARCHED_ADDRESS_BOOK, (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.isNum)(input) ? "number" : "name");
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.CHOSE_ADDRESS_BOOK_ENTRY, false);
        setInputValue(input);
        (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.handleInputChange)(input, defaultListType, selectedValue, setShowErrorDnVaildation, setSelectedValue, inputWithoutFormat);
    };
    const updateComboBoxClear = () => {
        var _a;
        if (comboBoxRef.current) {
            updateFocusableElements();
            const element = (_a = comboBoxRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot.querySelector("input");
            element.dispatchEvent(new CustomEvent("focus-visible", {
                composed: true,
                bubbles: true
            }));
        }
    };
    const shouldStripSpecialChar = () => {
        // This method we were invoking only if desktop-addressbook-increased-limit FF is enabled.
        if (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER) {
            // If Transfer is selected, Strip the special characters for addressbook and entry points lists.
            return true;
        }
        else if (checkEpDnListVisibility(agentAction)) {
            // "wxcc_consult_to_entry_point_dn" FF is ON
            if (isAddressBookConfigured) {
                // Multi Tabs - Addressbook list and EPDN list are rendered
                if (selectedTab.current === 0) {
                    // Strip all the special character, When Addressbook Tab is selected.
                    return true;
                }
            }
            // Only Entry points Lists are rendered OR Entry Points Tab is selected.
            return false;
        }
        else if (isAddressBookConfigured) {
            // "wxcc_consult_to_entry_point_dn" FF is OFF. Address book tab only rendered (Single Tab).
            return true;
        }
        else {
            // No options selection are rendered.
            return false;
        }
    };
    const debouncedEPAddressInputUpdate = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_12__.debouncedFunc)((detailVal, targetVal, type) => onEPAddressBookInputUpdate(detailVal, targetVal, type));
    const orgSearchInputValueChangeHandler = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_12__.debouncedFunc)((e) => {
        var _a;
        const value = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.value;
        setOrgSearchValue(value);
        if (initiateOrgDataFetch === 0) {
            setInitiateOrgDataFetch(1);
        }
        // When entering new values, reset the selected value.
        setSelectedValue("");
        triggerWidgetUpdate();
        // MS graph api not have option to filter with business phone, So we have to make the fetchUsers API recrusively until get the first 50 data along with businessPhone
        // So debounce with 500 sec is required for avoiding the duplicate requests
    }, 500);
    const inputValueChangeHandler = (e) => {
        var _a, _b;
        const detailVal = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.value;
        const targetVal = (_b = e.target) === null || _b === void 0 ? void 0 : _b.value;
        const type = e.type;
        if (isAddressBookInfiniteScrollEnabled) {
            debouncedEPAddressInputUpdate(detailVal, targetVal, type);
        }
        else {
            onEPAddressBookInputUpdate(detailVal, targetVal, type);
        }
    };
    const isMenuOverlayOpen = () => {
        var _a;
        return (menuOverlayRef === null || menuOverlayRef === void 0 ? void 0 : menuOverlayRef.current) && !((_a = menuOverlayRef.current) === null || _a === void 0 ? void 0 : _a.isOpen);
    };
    const handleInitiateDataFetch = (type) => {
        if (type === _constants__WEBPACK_IMPORTED_MODULE_7__.LIST_CLICK) {
            setInitiateDataFetch(0);
        }
        else if (initiateDataFetch === 0) {
            setInitiateDataFetch(1);
        }
    };
    const onEPAddressBookInputUpdate = (detailVal, targetVal, type) => {
        let input = "";
        if (detailVal) {
            input = detailVal;
        }
        else if (targetVal) {
            input = targetVal;
        }
        const inputWithoutFormat = input;
        if (isMenuOverlayOpen()) {
            menuOverlayRef.current.isOpen = true;
        }
        if (isConsultTransferInfiniteScrollEnabled) {
            handleInitiateDataFetch(type);
        }
        if (!(type === "input" || type === INPUT_CHANGE_EVENT)) {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.CHOSE_ADDRESS_BOOK_ENTRY, true);
            setInputValue(input);
            setSelectedValue(input);
            setShowErrorDnVaildation(false);
        }
        else {
            if (shouldStripSpecialChar() || input === "") {
                // Remove special charcter when addressbook is selected
                setinputValueWithoutEscape(input);
                input = escapeSpecialCharactersOnDN(input);
            }
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.SEARCHED_ADDRESS_BOOK, (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.isNum)(input) ? "number" : "name");
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.CHOSE_ADDRESS_BOOK_ENTRY, false);
            setInputValue(input);
            (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.handleInputChange)(input, defaultListType, selectedValue, setShowErrorDnVaildation, setSelectedValue, inputWithoutFormat);
        }
        triggerWidgetUpdate();
        handleAddressSelectorFocus();
    };
    const triggerWidgetUpdate = () => {
        // Dispatch on-widget-update event to FocusTrapMixin to capture the new elements
        updateFocusableElements();
        if (focusTrapUpdateTimeoutIdRef.current) {
            window.clearTimeout(focusTrapUpdateTimeoutIdRef.current);
        }
        focusTrapUpdateTimeoutIdRef.current = window.setTimeout(() => {
            const inputElementIndex = getInputElementIndex();
            if (inputElementIndex >= 0) {
                if (menuOverlayRef.current) {
                    menuOverlayRef.current.focusTrapIndex = 0;
                }
                modalRef.current.focusTrapIndex = inputElementIndex;
                // prevent activeFocusTrap on menu overlay, because the overlay rendering inside the modal component.
                if (menuOverlayRef.current) {
                    menuOverlayRef.current.deactivateFocusTrap();
                }
            }
        }, 20);
    };
    const getInputElementIndex = () => {
        var _a, _b;
        return (_b = (_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _a === void 0 ? void 0 : _a.focusableElements) === null || _b === void 0 ? void 0 : _b.findIndex((element) => element.tagName && element.tagName.toLowerCase() === "input");
    };
    const handleClearInput = () => {
        var _a;
        triggerWidgetUpdate();
        if (((_a = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _a === void 0 ? void 0 : _a.value) === "" && inputValueWithoutEscape !== "") {
            setInputValue("");
            setinputValueWithoutEscape("");
        }
        handleAddressSelectorFocus();
        if (isMenuOverlayOpen()) {
            menuOverlayRef.current.isOpen = true;
        }
    };
    const handleErrorMessageOnFetchSuccess = () => {
        setShowFetchErrorMessage(false);
        setShowCtqErrorMessage(false);
        setShowCustomerLeftMessage(false);
        setShowErrorMessage(false);
        setTrackingId("");
        setIsLoadingListItem(false);
        setIsChanged(false);
    };
    const handleErrorMessageOnFetchFailure = () => {
        setIsLoadingListItem(false);
        setShowCtqErrorMessage(false);
        setShowCustomerLeftMessage(false);
        setShowErrorMessage(false);
        setShowFetchErrorMessage(true);
        setIsChanged(false);
    };
    const updateFetchingStatus = (status) => {
        setIsLoadingListItem(status);
        setIsChanged(status);
    };
    const getListValues = (retry = false) => {
        if (defaultListType !== _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION) {
            setIsLoadingListItem(true);
        }
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.QUEUES && !isConsultTransferInfiniteScrollEnabled) {
            const vteamPayload = {
                agentSessionId: (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.generateUUID)(),
                agentProfileId: config.agentProfileID,
                channelType: mediaType,
                type: mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE && agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER ? _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ALL : _Common_constants__WEBPACK_IMPORTED_MODULE_11__.INBOUNDQUEUE
            };
            (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.getVteamList)(vteamPayload, initializeDropdownValue, setVteamList, setTrackingId, handleErrorMessageOnFetchSuccess, handleErrorMessageOnFetchFailure);
        }
        else if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS) {
            const buddyAgentPayLoad = {
                agentProfileId: config.agentProfileID,
                mediaType
            };
            if (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER) {
                buddyAgentPayLoad.state = _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AVAILABLE;
            }
            (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.getBuddyAgentList)(buddyAgentPayLoad, initializeDropdownValue, setbuddyList, setTrackingId, handleErrorMessageOnFetchSuccess, handleErrorMessageOnFetchFailure);
        }
        else if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION) {
            if (config.microsoftAuthConfig.isAuthenticated) {
                setIsLoadingListItem(true);
                if (retry || initiateOrgDataFetch === 0) {
                    if (!retry) {
                        updateFetchingStatus(false);
                    }
                    else {
                        // While retry, Disable the consult/transfer button.
                        setSelectedValue("");
                    }
                    setInitiateOrgDataFetch((prevValue) => {
                        return prevValue + 1;
                    });
                }
                else {
                    updateFetchingStatus(false);
                }
            }
            else {
                setIsChanged(false);
            }
        }
        else if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ENTRY_POINT) {
            return;
        }
        else if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER) {
            (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_12__.evt)(_constants__WEBPACK_IMPORTED_MODULE_13__.ANNOUNCEMENT_UPDATE, { message: common.loading }, dispatchCustomEvent);
            if (!isAddressBookInfiniteScrollEnabled) {
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.getAddressBook)({
                    addressBook: retry ? Object.assign(Object.assign({}, addressBook), { initialFetchCompleted: false }) : addressBook,
                    addressBookFetchingStatus: updateFetchingStatus,
                    dispatchCustomEvent,
                    agentAction
                });
            }
            else {
                updateFetchingStatus(false);
                setInitiateDataFetch((prevValue) => {
                    return prevValue + 1;
                });
            }
            if (!isConsultTransferInfiniteScrollEnabled) {
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.getEpDnList)({
                    epDnMapping: retry ? Object.assign(Object.assign({}, epDnMapping), { initialFetchCompleted: false }) : epDnMapping,
                    isDesktopConsultToEntryPointDnEnabled,
                    channels: config === null || config === void 0 ? void 0 : config.channels,
                    orgId,
                    epDnFetchingStatus: updateEpDnFetchingStatus,
                    dispatchCustomEvent
                });
            }
        }
    };
    const updateEpDnFetchingStatus = (status) => {
        setEpDnFetching(status);
    };
    const keyDownOnTabChanged = (e) => {
        var _a, _b;
        const code = e.keyCode;
        const tabChanged = (_a = tabElm === null || tabElm === void 0 ? void 0 : tabElm.current) === null || _a === void 0 ? void 0 : _a.tabChanged;
        const selectedTabIndex = (_b = tabElm === null || tabElm === void 0 ? void 0 : tabElm.current) === null || _b === void 0 ? void 0 : _b.getAttribute("selected");
        let data;
        if (selectedTabIndex === 0) {
            data = addressBookList.map((a) => ({ dn: a.dn, desc: a.name }));
        }
        else if (selectedTabIndex === 1) {
            data = epDnList.map((a) => ({ dn: a.dialledNumber, desc: a.name }));
        }
        handleListNavigation(code, data);
        if (!tabChanged) {
            window.dispatchEvent(new CustomEvent("menu-overlay-keydown", {
                detail: {
                    keyCode: code,
                    listData: data,
                    hoveredListItemIndex: hoveredListItemRef.current
                },
                composed: true,
                bubbles: true
            }));
        }
        else {
            hoveredListItemRef.current = -1;
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        //TODO: in this implementation, we fetch the list value inside the component, getListValues code to be removed isConsultTransferInfiniteScrollEnabled FF will be removed
        if (!isConsultTransferInfiniteScrollEnabled || defaultListType !== _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS) {
            getListValues();
        }
        setSelectedValue("");
        setDropdownValue([]);
        setOrgSearchValue(null);
    }, [defaultListType]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        // If the defaultListType is Dial Number, then will update the success state based on store response.
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER && addressBook.initialFetchCompleted) {
            if (Object.keys(addressBook.errorObj).length === 0) {
                // Success on fetching the address book
                setDn(addressBook.data || []);
                handleErrorMessageOnFetchSuccess();
            }
            else {
                // Failure on fetching the address book
                setDn([]);
                handleErrorMessageOnFetchFailure();
                setTrackingId(addressBookErrorTrackingId);
            }
        }
    }, [defaultListType, addressBook, addressBookErrorTrackingId]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const radioGroup = radioGroupRef.current;
        if (radioGroupRef && radioGroupRef.current) {
            radioGroup.addEventListener("radio-change", handleRadioChangeEvent);
        }
        return () => {
            if (radioGroup) {
                radioGroup.removeEventListener("radio-change", handleRadioChangeEvent);
            }
        };
    }, [defaultListType]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        if (comboBoxRef && comboBoxRef.current) {
            comboBoxRef.current.rovingPreventFocus = true;
        }
        const comboBox = comboBoxRef.current;
        if (comboBoxRef && comboBoxRef.current) {
            comboBox.addEventListener("change-selected", updateSelectedValue);
            comboBox.addEventListener("combobox-input", updateOnInputChange);
            // While pressing the clear icon on md-combobox
            comboBox.addEventListener("remove-all-selected", updateComboBoxClear);
        }
        return () => {
            comboBox === null || comboBox === void 0 ? void 0 : comboBox.removeEventListener("change-selected", updateSelectedValue);
            comboBox === null || comboBox === void 0 ? void 0 : comboBox.removeEventListener("combobox-input", updateOnInputChange);
            // While pressing the clear icon on md-combobox
            comboBox === null || comboBox === void 0 ? void 0 : comboBox.removeEventListener("remove-all-selected", updateComboBoxClear);
        };
    }, [defaultListType]);
    const handleListNavigation = (keyCode, data) => {
        switch (keyCode) {
            // UP
            case 38: {
                if (hoveredListItemRef.current > 0) {
                    hoveredListItemRef.current = hoveredListItemRef.current - 1;
                }
                break;
            }
            // DOWN
            case 40: {
                if (data.length - 1 === hoveredListItemRef.current) {
                    hoveredListItemRef.current = 0;
                }
                else {
                    hoveredListItemRef.current = hoveredListItemRef.current + 1;
                }
                break;
            }
            default: {
                break;
            }
        }
    };
    const onMenuOverlayOpen = () => {
        // to set focus on the 'Address Book' tab on keyboard navigation when menu overlay opens
        // the tabs are formed after some delay
        if (visibleTabTimeoutIdRef.current) {
            window.clearTimeout(visibleTabTimeoutIdRef.current);
        }
        visibleTabTimeoutIdRef.current = window.setTimeout(function () {
            var _a, _b, _c, _d;
            const inputIsFocused = (_b = (_a = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.activeElement;
            if (!inputIsFocused) {
                const visibleTab = (_d = (_c = tabElm === null || tabElm === void 0 ? void 0 : tabElm.current) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelectorAll("div .visible-tabs-container md-tab");
                if (visibleTab && visibleTab[selectedTab.current]) {
                    visibleTab[selectedTab.current].focus();
                }
            }
        }, 20);
        updateFocusableElements();
    };
    const resetTabOnChange = (e) => {
        setResetTab(e.detail.value);
        selectedTab.current = e.detail.value;
    };
    const focusElementOnTabChange = (e) => {
        var _a;
        const element = selectedTab.current === 0 ? tabPanelElmOne : tabPanelElmTwo;
        if (e.detail.key === "Tab" && !e.detail.shiftKey) {
            (_a = element === null || element === void 0 ? void 0 : element.current) === null || _a === void 0 ? void 0 : _a.setAttribute("tabindex", "0");
            updateFocusableElements();
            if (focusTimerIdRef.current) {
                window.clearTimeout(focusTimerIdRef.current);
            }
            focusTimerIdRef.current = window.setTimeout(() => {
                var _a, _b;
                (_a = element === null || element === void 0 ? void 0 : element.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent("focus-visible", {
                    composed: true,
                    bubbles: true
                }));
                (_b = element === null || element === void 0 ? void 0 : element.current) === null || _b === void 0 ? void 0 : _b.focus();
            }, 50);
            e.stopPropagation();
        }
    };
    const menuOverlayKeydown = (e) => {
        if (e.keyCode === 27 && menuOverlayRef.current.isOpen === true) {
            e.stopPropagation();
            menuOverlayRef.current.isOpen = false;
        }
    };
    const tabKeyDown = (e) => {
        if (e.code === "Tab") {
            e.stopPropagation();
        }
    };
    const tabSelectChanged = (e) => {
        selectedTab.current = e.detail.value;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        document.addEventListener("selected-changed", resetTabOnChange);
        return () => {
            document.removeEventListener("selected-changed", resetTabOnChange);
        };
    }, [resetTab]);
    const getCheckBoxHeight = () => {
        return isCheckBoxVisible() ? _constants__WEBPACK_IMPORTED_MODULE_7__.CHECKBOX_HEIGHT : _constants__WEBPACK_IMPORTED_MODULE_7__.NO_CHECKBOX_HEIGHT;
    };
    const handleOrgListContainerHeight = (height) => {
        const orgInputContainer = orgSearchInputRef.current.getBoundingClientRect();
        const AllowCheckBoxSpace = getCheckBoxHeight();
        setConnViewOrgListHeight(height - (orgInputContainer.bottom + 110 + AllowCheckBoxSpace));
    };
    const resizeHandler = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_12__.debouncedFunc)((entries) => {
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION &&
            entries &&
            entries.length > 0 &&
            entries[0].target &&
            entries[0].target.clientWidth &&
            entries[0].target.clientWidth <= _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONNECTOR_VIEW_WIDTH) {
            setIsConnectorView(true);
            handleOrgListContainerHeight(entries[0].target.clientHeight);
        }
        else {
            setIsConnectorView(false);
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        var _a;
        (_a = tabElm === null || tabElm === void 0 ? void 0 : tabElm.current) === null || _a === void 0 ? void 0 : _a.addEventListener("keydown", keyDownOnTabChanged);
        return () => {
            if (focusTrapUpdateTimeoutIdRef.current) {
                window.clearTimeout(focusTrapUpdateTimeoutIdRef.current);
            }
            if (searchFieldFocusTimeIdRef.current) {
                window.clearTimeout(searchFieldFocusTimeIdRef.current);
            }
            if (visibleTabTimeoutIdRef.current) {
                window.clearTimeout(visibleTabTimeoutIdRef.current);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER) {
            selectedTab.current = 0;
            (_a = menuOverlayRef === null || menuOverlayRef === void 0 ? void 0 : menuOverlayRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener("menu-overlay-open", onMenuOverlayOpen);
            inputFieldFocusTimeIdRef.current = window.setTimeout(() => {
                var _a;
                // Set tabIndex=-1 on tabpabel for while opening the menuoverlay disable the auto focus to tabs and keep focus on the input field
                (_a = tabPanelElmOne === null || tabPanelElmOne === void 0 ? void 0 : tabPanelElmOne.current) === null || _a === void 0 ? void 0 : _a.setAttribute("tabindex", "-1");
            }, 20);
            // selected-changed
            (_b = tabElm === null || tabElm === void 0 ? void 0 : tabElm.current) === null || _b === void 0 ? void 0 : _b.addEventListener("selected-changed", tabSelectChanged);
            (_c = tabElm === null || tabElm === void 0 ? void 0 : tabElm.current) === null || _c === void 0 ? void 0 : _c.addEventListener("tab-keydown", focusElementOnTabChange);
            (_d = tabPanelElmOne === null || tabPanelElmOne === void 0 ? void 0 : tabPanelElmOne.current) === null || _d === void 0 ? void 0 : _d.addEventListener("keydown", tabKeyDown);
            (_e = tabPanelElmTwo === null || tabPanelElmTwo === void 0 ? void 0 : tabPanelElmTwo.current) === null || _e === void 0 ? void 0 : _e.addEventListener("keydown", tabKeyDown);
        }
        (_f = menuOverlayRef === null || menuOverlayRef === void 0 ? void 0 : menuOverlayRef.current) === null || _f === void 0 ? void 0 : _f.addEventListener("keydown", menuOverlayKeydown);
        // for UT to check input handler
        (_g = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _g === void 0 ? void 0 : _g.addEventListener("input-selected-changed", inputValueChangeHandler);
        (_h = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _h === void 0 ? void 0 : _h.addEventListener(INPUT_CHANGE_EVENT, inputValueChangeHandler);
        (_j = orgSearchInputRef === null || orgSearchInputRef === void 0 ? void 0 : orgSearchInputRef.current) === null || _j === void 0 ? void 0 : _j.addEventListener(INPUT_CHANGE_EVENT, orgSearchInputValueChangeHandler);
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION) {
            resizeObserverRef.current = new ResizeObserver(resizeHandler);
            resizeObserverRef.current.observe(document.body);
        }
        return () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (resizeObserverRef.current) {
                resizeObserverRef.current.disconnect();
            }
            (_a = menuOverlayRef === null || menuOverlayRef === void 0 ? void 0 : menuOverlayRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("menu-overlay-open", onMenuOverlayOpen);
            (_b = menuOverlayRef === null || menuOverlayRef === void 0 ? void 0 : menuOverlayRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener("menu-overlay-close", () => { });
            (_c = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener("input-selected-changed", inputValueChangeHandler);
            (_d = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _d === void 0 ? void 0 : _d.removeEventListener(INPUT_CHANGE_EVENT, inputValueChangeHandler);
            (_e = tabElm === null || tabElm === void 0 ? void 0 : tabElm.current) === null || _e === void 0 ? void 0 : _e.removeEventListener("selected-changed", tabSelectChanged);
            (_f = tabElm === null || tabElm === void 0 ? void 0 : tabElm.current) === null || _f === void 0 ? void 0 : _f.removeEventListener("tab-keydown", focusElementOnTabChange);
            (_g = menuOverlayRef === null || menuOverlayRef === void 0 ? void 0 : menuOverlayRef.current) === null || _g === void 0 ? void 0 : _g.removeEventListener("keydown", menuOverlayKeydown);
            (_h = tabPanelElmOne === null || tabPanelElmOne === void 0 ? void 0 : tabPanelElmOne.current) === null || _h === void 0 ? void 0 : _h.removeEventListener("keydown", tabKeyDown);
            (_j = tabPanelElmTwo === null || tabPanelElmTwo === void 0 ? void 0 : tabPanelElmTwo.current) === null || _j === void 0 ? void 0 : _j.removeEventListener("keydown", tabKeyDown);
            (_k = tabElm === null || tabElm === void 0 ? void 0 : tabElm.current) === null || _k === void 0 ? void 0 : _k.removeEventListener("keydown", keyDownOnTabChanged);
            if (debouncedEPAddressInputUpdate === null || debouncedEPAddressInputUpdate === void 0 ? void 0 : debouncedEPAddressInputUpdate.cancel) {
                debouncedEPAddressInputUpdate === null || debouncedEPAddressInputUpdate === void 0 ? void 0 : debouncedEPAddressInputUpdate.cancel();
            }
            if (inputFieldFocusTimeIdRef.current) {
                window.clearTimeout(inputFieldFocusTimeIdRef.current);
            }
            if (searchFieldFocusTimeIdRef.current) {
                window.clearTimeout(searchFieldFocusTimeIdRef.current);
            }
        };
    }, [defaultListType]);
    const checkAction = () => {
        return agentAction !== _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONFERENCE;
    };
    const getAgentStatus = (val) => {
        if ((defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS &&
            (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT || agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER) &&
            mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE) ||
            (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS &&
                (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONFERENCE || agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER) &&
                (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.CHAT || mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.SOCIAL))) {
            const curr = buddyList.find((item) => item.agentName === val);
            if ((curr === null || curr === void 0 ? void 0 : curr.state) === "Available") {
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "available align", name: "icon-unread-badge_12" });
            }
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "un-available align", name: "icon-unread-badge_12" });
        }
        return null;
    };
    const getAgentStatusString = (val) => {
        if (!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumAvatarEnabled) {
            return "";
        }
        if ((defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS &&
            (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT || agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER) &&
            mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE) ||
            (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS &&
                (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONFERENCE || agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER) &&
                (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.CHAT || mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.SOCIAL))) {
            const curr = buddyList.find((item) => item.agentName === val);
            if ((curr === null || curr === void 0 ? void 0 : curr.state) === "Available") {
                return "active";
            }
            return "idle";
        }
        return "";
    };
    const dropdownOptionTemplate = (item, index) => {
        return typeof item === "string" ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "queue-option string", slot: `${item}-${index}`, "aria-label": item, "display-value": item }, { children: [!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumAvatarEnabled && getAgentStatus(item), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-avatar", Object.assign({ alt: item, title: item, type: getAgentStatusString(item), size: DEFAULT_AVATAR_SIZE, hideDefaultTooltip: false }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumAvatarEnabled ? { newMomentum: true } : {}))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("slot", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "agentContactInfo", style: { paddingLeft: "4px" } }, { children: item })) })] }), `${item}-${index}`)) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "queue-option", slot: `${defaultListType}-${item.dn}-${index}`, "aria-label": `${item.name} ${item.dn}`, "display-value": item.dn }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "address-list-item", style: { display: "flex" } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-avatar", { size: "32", title: item.name, class: "address-list-item-avatar" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "address-list-item-detail", style: { paddingLeft: "12px" } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: item.name }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-name" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_10__["default"], { text: item.name, highlight: inputValue }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-dn" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_10__["default"], { text: item.dn, highlight: inputValue }) }))] }))] })) }), `${item}-${index}`));
    };
    const checkEpDnListVisibility = (agentAction) => {
        return isDesktopConsultToEntryPointDnEnabled && agentAction !== _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER;
    };
    const getBoxPlaceHolder = () => {
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION) {
            const placeholderKey = config.collaborationConfig.displayWebexUserDetails
                ? `Webex${defaultListType}`
                : defaultListType;
            return i18nMessage.placeholder[placeholderKey];
        }
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER) {
            if (isConsultTransferInfiniteScrollEnabled) {
                return i18nMessage.placeholder[_constants__WEBPACK_IMPORTED_MODULE_13__.dialNumberSearch];
            }
            if (checkEpDnListVisibility(agentAction)) {
                // EPDN FF is ON. Check the address book list as well as EPDN list
                if (addressBookList.length > 0 || epDnList.length > 0) {
                    return i18nMessage.placeholder[_constants__WEBPACK_IMPORTED_MODULE_13__.dialNumberOrEntryPoint];
                }
            }
            else if (addressBookList.length > 0) {
                // For address book list
                return i18nMessage.placeholder[_constants__WEBPACK_IMPORTED_MODULE_13__.dialNumber];
            }
        }
        else if (dropdownValue.length > 0) {
            // For Agent and Queue list
            return i18nMessage.placeholder[defaultListType];
        }
        // For the Agent, Queue, DN drop down list are empty.
        return transferModal[`${defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER ? _constants__WEBPACK_IMPORTED_MODULE_13__.dialNumber : defaultListType}Empty`];
    };
    const handleRefreshButtonLabel = () => {
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.QUEUES) {
            return transferModal.refreshQueueList;
        }
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS) {
            return transferModal.refreshAgentList;
        }
        return transferModal.refreshAddressBook;
    };
    /* This element render the Agent, Queue, DN (Address Book) list */
    const renderListElement = (dropDownList) => {
        return dropDownList.map((item, index) => dropdownOptionTemplate(item, index));
    };
    const getCustomOptions = () => {
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER) {
            if (checkEpDnListVisibility(agentAction)) {
                return [...addressBookList, ...epDnList];
            }
            return addressBookList;
        }
        return dropdownValue;
    };
    const handleListClick = (selectedValue) => {
        const { dn, id } = selectedValue;
        setSelectedEntryPointId(id);
        onEPAddressBookInputUpdate(undefined, dn, _constants__WEBPACK_IMPORTED_MODULE_7__.LIST_CLICK);
        if (menuOverlayRef === null || menuOverlayRef === void 0 ? void 0 : menuOverlayRef.current) {
            menuOverlayRef.current.isOpen = false;
        }
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.ADDRESS_BOOK, {
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.ADDRESS_BOOK_LIST_SEARCH]: agentAction
        });
    };
    // Gets Search Query Value based on the agentAction or addressbook tab selection.
    // When addressbook tab selected if inputvalue is empty, use inputValueWithoutEscape
    const getSearchQuery = () => {
        var _a, _b, _c;
        let searchQuery;
        if (((_a = tabElm === null || tabElm === void 0 ? void 0 : tabElm.current) === null || _a === void 0 ? void 0 : _a.getAttribute("selected")) === "0" ||
            ((_b = tabElm === null || tabElm === void 0 ? void 0 : tabElm.current) === null || _b === void 0 ? void 0 : _b.getAttribute("selected")) === "1" ||
            agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER) {
            if (inputValue === "") {
                searchQuery = inputValueWithoutEscape;
            }
            else {
                searchQuery = inputValue;
            }
        }
        else {
            searchQuery = ((_c = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _c === void 0 ? void 0 : _c.value) || "";
        }
        return searchQuery;
    };
    const updateFocusableElements = () => {
        document.dispatchEvent(new CustomEvent("on-widget-update"));
    };
    const renderEPDNList = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddressBookIncreasedLimit_AddressBookIncreasedLimit__WEBPACK_IMPORTED_MODULE_9__["default"], { data: epDnList.map((a) => ({ dn: a.dialledNumber, desc: a.name, id: a.id })), height: 290, loading: isLoadingListItem, searchQuery: getSearchQuery(), loadingError: Object.keys(epDnMapping.errorObj).length > 0, loadingTrackingId: addressBookErrorTrackingId, retryLoadingAddressBook: () => getListValues(true), handleListClick: handleListClick, resetTab: resetTab, isAddressBookInfiniteScrollEnabled: false, isConsultTransferInfiniteScrollEnabled: isConsultTransferInfiniteScrollEnabled }));
    };
    const renderAddressBook = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddressBookIncreasedLimit_AddressBookIncreasedLimit__WEBPACK_IMPORTED_MODULE_9__["default"], { data: addressBookList.map((a) => ({ dn: a.dn, desc: a.name })), height: 290, loading: isLoadingListItem, searchQuery: getSearchQuery(), loadingError: Object.keys(addressBook.errorObj).length > 0, loadingTrackingId: addressBookErrorTrackingId, retryLoadingAddressBook: () => getListValues(true), handleListClick: handleListClick, resetTab: resetTab, isAddressBookInfiniteScrollEnabled: isAddressBookInfiniteScrollEnabled, initiateDataFetch: initiateDataFetch, isConsultTransferInfiniteScrollEnabled: isConsultTransferInfiniteScrollEnabled }));
    };
    const renderMultiTabs = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-tabs", Object.assign({ justified: true, selected: selectedTab.current, ref: tabElm }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab", Object.assign({ slot: "tab", tabIndex: -1, "aria-label": transferModal.addressBookSectionLabel }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: transferModal.addressBookSectionLabel }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab-panel", Object.assign({ ref: tabPanelElmOne, slot: "panel", class: "address-panel" }, { children: renderAddressBook() })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab", Object.assign({ slot: "tab", tabIndex: -1, "aria-label": transferModal.entryPointSectionLabel }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: transferModal.entryPointSectionLabel }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab-panel", Object.assign({ ref: tabPanelElmTwo, slot: "panel" }, { children: renderEPDNList() }))] })));
    };
    const renderSingleTab = (tabLabel, listRenderer) => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [!isConsultTransferInfiniteScrollEnabled ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "entry-point-tab", slot: "header", "aria-label": tabLabel }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: tabLabel }) }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "entry-point-content" }, { children: listRenderer() }))] }));
    };
    const renderNoOptionsSection = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "no-options", slot: "header", "aria-label": common.noOptions }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: common.noOptions }) })));
    };
    const handleAddressSelectorFocus = () => {
        if (searchFieldFocusTimeIdRef.current) {
            window.clearTimeout(searchFieldFocusTimeIdRef.current);
        }
        searchFieldFocusTimeIdRef.current = window.setTimeout(() => {
            var _a, _b, _c;
            (_c = (_b = (_a = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("input")) === null || _c === void 0 ? void 0 : _c.focus();
        }, 10);
    };
    const renderDNOverlay = () => {
        if (isConsultTransferInfiniteScrollEnabled) {
            if (isAddressBookConfigured) {
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "entry-point-content" }, { children: renderAddressBook() }));
            }
            return renderNoOptionsSection();
        }
        else {
            // for consult
            if (checkEpDnListVisibility(agentAction)) {
                if (isAddressBookConfigured) {
                    return renderMultiTabs();
                }
                return renderSingleTab(transferModal.entryPointSectionLabel, renderEPDNList);
            }
            // for transfer
            if (isAddressBookConfigured) {
                return renderSingleTab(transferModal.addressBookSectionLabel, renderAddressBook);
            }
            return renderNoOptionsSection();
        }
    };
    const handleKeyDownOnSearchInput = (e) => {
        if ((e.key === _constants__WEBPACK_IMPORTED_MODULE_7__.Key.ArrowDown || e.key === _constants__WEBPACK_IMPORTED_MODULE_7__.Key.Enter) && !menuOverlayRef.current.isOpen) {
            menuOverlayRef.current.isOpen = true;
        }
        else if (e.keyCode === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ESCAPE_KEY_CODE && menuOverlayRef.current.isOpen === true) {
            e.stopPropagation();
        }
    };
    const getSearchInputComp = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-input", Object.assign({ ref: searchInputRef, placeholder: getBoxPlaceHolder(), slot: "menu-trigger", variant: "primary", value: inputValue, clear: true, onClick: (e) => handleClearInput(), onKeyDown: (e) => handleKeyDownOnSearchInput(e), autoFocus: true, clearAriaLabel: common.clear }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }))));
    };
    const renderRefreshButtonOrSpinner = () => {
        return isLoadingListItem || isEpDnFetching ? refreshSpinner() : refreshButton();
    };
    const renderTabModal = () => {
        return !isConsultTransferInfiniteScrollEnabled ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ ref: menuOverlayRef, class: "queueDropdown queueDropdown-tabbed", slot: "settings", size: "large" }, { children: [getSearchInputComp(), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "epdn-addressbook" }, { children: renderDNOverlay() }))] }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "search-row" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "epdn-addressbook-search" }, { children: getSearchInputComp() })), renderRefreshButtonOrSpinner()] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "epdn-addressbook addressbook-consult-transfer-infinite-scrolling" }, { children: [renderTransferModalError(), renderDNOverlay()] }))] }));
    };
    const renderComboBox = () => {
        // Combobox is render on when defaultListType is AGENT or QUEUE.
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-combobox", Object.assign({ class: `queueDropdown ${defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER && "dnDropdown"}`, id: "queueDropdown", placeholder: getBoxPlaceHolder(), ariaLabel: defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.QUEUES ? transferModal.comboBoxAriaLabelQueue : transferModal.comboBoxAriaLabelAgent, label: getBoxPlaceHolder(), "custom-options": JSON.stringify(getCustomOptions()), "with-custom-content": true, "input-value": inputValue, "visible-option": visibleOptions, ref: comboBoxRef, "no-options-i18n": common.noOptions ? common.noOptions : "No Options", "no-results-i18n": common.noResults ? common.noResults : "No Results", "allow-custom-value": defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER && (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.isNum)(selectedValue) ? true : undefined }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }), ((defaultListType !== _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER && dropdownValue.length === 0) ||
            isLoadingListItem === true ||
            isChanged ||
            (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER && isEpDnFetching)
            ? { disabled: true }
            : {}), { children: renderListElement(dropdownValue) })));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        if (isLoadingListItem) {
            (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_12__.evt)(_constants__WEBPACK_IMPORTED_MODULE_13__.ANNOUNCEMENT_UPDATE, { message: common.loading }, dispatchCustomEvent);
        }
    }, [isLoadingListItem]);
    const refreshSpinner = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "refresh-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "16" }) })));
    };
    const refreshButton = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ class: "refresh-list-tooltip", message: transferModal.refreshTheList }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ class: "refresh-list-button", type: "button", arialabel: handleRefreshButtonLabel(), circle: true, variant: "ghost", onClick: (e) => getListValues(true), onKeydown: (e) => getListValues(true) }, (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION && !config.microsoftAuthConfig.isAuthenticated && { disabled: true }), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: "icon-refresh_16" }) })) })));
    };
    const renderTransferModalError = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [showErrorDnVaildation && !displayErrorMessage() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ id: "agentAction-error-container-id", className: "actionMessage agentAction-error-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-error_12", class: "agentAction-error-icon" }) }), checkEpDnListVisibility(agentAction)
                            ? `${transferModal.DialNumbOrEntryPointInvalid}`
                            : transferModal.DialNumbInvalid] }))), displayErrorMessage() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ id: "agentAction-error-container-id", className: "actionMessage agentAction-error-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-error_12", class: "agentAction-error-icon" }) }), showErrorMessage && ((0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.getErrorMsgForReasonCode)(reasonCode) || i18nMessage.failureError), isShowCtqErrorMessage && i18nMessage.ctqFailureMsg, renderFailureMessage(isErrorMessageForEpList, showFetchErrorMessage, agentAction), "(", common.trackingIdInputLabel, renderTrackingId(isErrorMessageForEpList, trackingId, agentAction), ")"] }))), ctqInProgress && !(showErrorMessage || showFetchErrorMessage || isShowCtqErrorMessage) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ id: "cancelCtq-info-container-id", className: "cancelCtq-info-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "cancelCtq-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "12" }) })), i18nMessage.cancelCtqInfo] }))), showCustomerLeftMessage && agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ id: "agentAction-error-container-id", className: "actionMessage agentAction-error-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-error_12", class: "agentAction-error-icon" }) }), i18nMessage.customerLeftMsg] })))] }));
    };
    const renderElement = () => {
        switch (defaultListType) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION:
                return renderOrgSearchComp();
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER:
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [renderTabModal(), !isConsultTransferInfiniteScrollEnabled ? renderRefreshButtonOrSpinner() : null] }));
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ENTRY_POINT:
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_EPList_EPList__WEBPACK_IMPORTED_MODULE_17__["default"], { agentAction: agentAction, selectedType: defaultListType, setTrackingId: setTrackingId, handleErrorMessageOnFetchSuccess: handleErrorMessageOnFetchSuccess, handleErrorMessageOnFetchFailure: handleErrorMessageOnFetchFailure, onEPSelect: onEntryPointSelect, mediaType: mediaType, listHeight: 290, renderTransferModalError: renderTransferModalError }));
            default:
                if (isConsultTransferInfiniteScrollEnabled) {
                    if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS) {
                        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Agent_BuddyAgentsList__WEBPACK_IMPORTED_MODULE_16__["default"], { selectedType: defaultListType, agentProfileID: config.agentProfileID, mediaType: mediaType, agentAction: agentAction, setTrackingId: setTrackingId, handleErrorMessageOnFetchSuccess: handleErrorMessageOnFetchSuccess, handleErrorMessageOnFetchFailure: handleErrorMessageOnFetchFailure, onBuddyAgentSelect: onBuddyAgentSelect, listHeight: 290, renderTransferModalError: renderTransferModalError }));
                    }
                    else if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.QUEUES) {
                        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_queue_QueueList__WEBPACK_IMPORTED_MODULE_21__["default"], { selectedType: defaultListType, mediaType: mediaType, setTrackingId: setTrackingId, handleErrorMessageOnFetchSuccess: handleErrorMessageOnFetchSuccess, handleErrorMessageOnFetchFailure: handleErrorMessageOnFetchFailure, onQueueSelect: onQueueSelect, listHeight: 290, renderTransferModalError: renderTransferModalError }));
                    }
                }
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [renderComboBox(), renderTransferModalError(), isLoadingListItem ? refreshSpinner() : refreshButton()] }));
        }
    };
    const renderSearchComp = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: `${!isConsultTransferInfiniteScrollEnabled ? "transfer-modal-search-container" : ""} ${defaultListType.toLowerCase()}` }, { children: renderElement() })), !isConsultTransferInfiniteScrollEnabled && defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER ? renderTransferModalError() : null] }));
    };
    const handleOrgUserSelection = (selectedValue) => {
        if ((selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.businessPhones) && (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.businessPhones.length) > 0) {
            setInitiateOrgDataFetch(0);
            setSelectedValue(selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.businessPhones[0]);
            setShowErrorDnVaildation(false);
            orgSearchInputRef.current.value = selectedValue.businessPhones[0];
            setOrgSearchValue(selectedValue.businessPhones[0]);
        }
        else {
            setSelectedValue("");
        }
    };
    const handleOrgUsersSearch = () => {
        if (orgSearchValue) {
            return orgSearchValue;
        }
        return "";
    };
    const handleMsAuthenticationRetry = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)((event) => {
        event.preventDefault();
        (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_12__.evt)(_constants__WEBPACK_IMPORTED_MODULE_7__.INITIATE_MS_AUTH_LOGIN, true, dispatchCustomEvent);
    }, []);
    const isQueueAndOrganizationEnabled = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(() => {
        // This method will return true, when Queue and Organization both feature are enabled
        // This method helpful for defining the custom className and custom height based on multiple radio row conditions
        return enableQueue && config.collaborationConfig.displayUserDetails && mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE;
    }, [mediaType, enableQueue, config.collaborationConfig.displayUserDetails]);
    const numberOfAgentsInCall = (primaryMediaParticipants) => {
        return Object.values(primaryMediaParticipants).filter((participant) => participant.pType !== _constants__WEBPACK_IMPORTED_MODULE_7__.SUPERVISOR_ALT).length;
    };
    const isCheckBoxVisible = () => {
        return (isWxccMultiPartyConfEnabled &&
            agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT &&
            numberOfAgentsInCall(primaryMediaParticipants) >= _constants__WEBPACK_IMPORTED_MODULE_7__.MIN_NUMBER_OF_CONSULT_AGENTS_FOR_INTERACTING);
    };
    const orgContainerDefaultHeight = () => {
        const AllowCheckBoxSpace = getCheckBoxHeight();
        if (isConsultTransferInfiniteScrollEnabled) {
            return _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORG_CONTAINER_HEIGHT_INFINITE_SCROLL; // no need to handle the checkbox space for infinite scroll
        }
        return _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORG_CONTAINER_HEIGHT - AllowCheckBoxSpace;
    };
    const updateOrgFetchingStatus = (status) => {
        updateFetchingStatus(status);
        updateFocusableElements();
    };
    const renderOrgSearchComp = () => {
        let userListComponent;
        let enableRefresh = false;
        if (config.collaborationConfig.displayMicrosoftUserDetails) {
            enableRefresh = true;
            userListComponent = renderMicrosoftOrgSearchComp();
        }
        else if (config.collaborationConfig.displayWebexUserDetails) {
            userListComponent = renderWebexOrgSearchComp();
        }
        else {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.error(`displayUserDetails enabled but no MSFT or Webex user details enabled`);
        }
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "org-search-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-input", Object.assign({ class: "org-search-input", ref: orgSearchInputRef, placeholder: getBoxPlaceHolder(), variant: "primary", clear: true, autoFocus: true, clearAriaLabel: common.clear }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }))), enableRefresh && (isLoadingListItem ? refreshSpinner() : refreshButton())] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "organization-users-list", ref: orgContainerRef }, { children: userListComponent }))] }));
    };
    const renderWebexOrgSearchComp = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_integration_webex_WebexOrganizationUserList__WEBPACK_IMPORTED_MODULE_20__["default"], { searchQuery: handleOrgUsersSearch(), height: isConnectorView ? connViewOrgListHeight : orgContainerDefaultHeight(), isDarkMode: isDarkMode, onItemClicked: handleOrgUserSelection, renderTransferModalError: renderTransferModalError }));
    };
    const renderMicrosoftOrgSearchComp = () => {
        var _a;
        return ((_a = config.microsoftAuthConfig) === null || _a === void 0 ? void 0 : _a.isAuthenticated) ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_integration_microsoft__WEBPACK_IMPORTED_MODULE_18__["default"], { height: isConnectorView ? connViewOrgListHeight : orgContainerDefaultHeight(), searchQuery: handleOrgUsersSearch(), handleListClick: handleOrgUserSelection, initiateDataFetch: initiateOrgDataFetch, updateFetchingStatus: updateOrgFetchingStatus, renderTransferModalError: renderTransferModalError })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_integration_microsoft_AuthError__WEBPACK_IMPORTED_MODULE_19__["default"], { handleRetry: handleMsAuthenticationRetry, errorMessageLabel: i18nOrganization.authError, tryAgainLabel: common.tryAgain }));
    };
    const handleOrgSearchContainerDisabler = (disabled) => {
        orgSearchInputRef.current.disabled = disabled;
        if (disabled) {
            orgContainerRef.current.classList.add("disabled");
        }
        else {
            orgContainerRef.current.classList.remove("disabled");
        }
    };
    // eslint-disable-next-line consistent-return
    const getSelectedValue = (iteration, defaultListType) => {
        switch (iteration) {
            case _constants__WEBPACK_IMPORTED_MODULE_13__.AGENT_NAME: {
                return isConsultTransferInfiniteScrollEnabled
                    ? selectedBuddyAgent
                    : buddyList.find((item) => item.agentName === selectedValue);
            }
            case _constants__WEBPACK_IMPORTED_MODULE_13__.NAME:
                return isConsultTransferInfiniteScrollEnabled && defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ENTRY_POINT
                    ? selectedEntryPoint
                    : isConsultTransferInfiniteScrollEnabled
                        ? selectedQueue
                        : vteamList.find((item) => item.name === selectedValue);
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DN:
                return dn.find((item) => item.dn === selectedValue.toString());
            default:
                return [];
        }
    };
    //When there is separate radio button for entry point in consult modal
    const getEpConsultDestAgentId = () => {
        /* Payload having only EntryPointID will be considered as EPDN */
        if ((isWxccMultiPartyConfEnabled || isWxccPersistCallEnabled) && (selectedEntryPoint === null || selectedEntryPoint === void 0 ? void 0 : selectedEntryPoint.id)) {
            return selectedEntryPoint === null || selectedEntryPoint === void 0 ? void 0 : selectedEntryPoint.id;
        }
        return selectedEntryPoint === null || selectedEntryPoint === void 0 ? void 0 : selectedEntryPoint.dialledNumber;
    };
    const getEpOrDNConsultPayload = () => {
        /* Payload having only EntryPointID will be considered as EPDN */
        if ((isWxccMultiPartyConfEnabled || isWxccPersistCallEnabled) &&
            (selectedTab.current === 1 || !isAddressBookConfigured) &&
            selectedEntryPointId) {
            return {
                destAgentId: selectedEntryPointId,
                destinationType: _Common_constants__WEBPACK_IMPORTED_MODULE_11__.EPDN
            };
        }
        const item = getSelectedValue(_Common_constants__WEBPACK_IMPORTED_MODULE_11__.DN);
        return {
            destAgentId: (item === null || item === void 0 ? void 0 : item.dn) || selectedValue.toString().trim(),
            destinationType: _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DN
        };
    };
    const isHoldParticipantsPassed = () => {
        // By default on consult holdParticipant is true.
        // In case of MultiParty Conf enabled the holdParticipant is passed as false if the checkbox is checked
        // otherwise holdParticipant is not passed.
        return isWxccMultiPartyConfEnabled && !holdParticipantsRef.current;
    };
    const handleConsult = () => {
        let payload;
        const holdParticipants = holdParticipantsRef.current;
        const setStateFunctions = {
            setShowErrorMessage,
            setTrackingId,
            setShouldDisableSubmitBtn,
            setShowFetchErrorMessage,
            setShowCtqErrorMessage,
            setShowCustomerLeftMessage,
            disableLoader
        };
        switch (defaultListType) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS: {
                const item = getSelectedValue(_constants__WEBPACK_IMPORTED_MODULE_13__.AGENT_NAME);
                payload = {
                    interactionId,
                    data: Object.assign({ destinationType: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.DESTINATION_TYPE.AGENT, to: item === null || item === void 0 ? void 0 : item.agentId }, (isHoldParticipantsPassed() && { holdParticipants }))
                };
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.consultRequested)(interactionId, payload, handleCloseModal, setStateFunctions, _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT.toLowerCase());
                break;
            }
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.QUEUES: {
                const item = getSelectedValue(_constants__WEBPACK_IMPORTED_MODULE_13__.NAME);
                setCtqInProgress(true);
                setDestinationQueue(item === null || item === void 0 ? void 0 : item.id);
                payload = {
                    interactionId,
                    data: Object.assign({ destinationType: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.DESTINATION_TYPE.QUEUE, to: item === null || item === void 0 ? void 0 : item.id }, (isHoldParticipantsPassed() && { holdParticipants }))
                };
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.consultRequested)(interactionId, payload, handleCloseModal, setStateFunctions, "ctq", ctqInProgress, setCtqInProgress);
                break;
            }
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ENTRY_POINT: {
                payload = {
                    interactionId,
                    data: Object.assign({ destinationType: !(0,_Common_Utils__WEBPACK_IMPORTED_MODULE_12__.isMultipartyFeatureFlagOn)()
                            ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.DESTINATION_TYPE.DIAL_NUMBER
                            : (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_12__.getDestAgentTypeForEporEPDN)(), to: getEpConsultDestAgentId() }, (isHoldParticipantsPassed() && { holdParticipants }))
                };
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.consultRequested)(interactionId, payload, handleCloseModal, setStateFunctions, _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT.toLowerCase());
                break;
            }
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER: {
                const p = getEpOrDNConsultPayload();
                payload = {
                    interactionId,
                    data: Object.assign({ destinationType: p.destinationType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DN ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.DESTINATION_TYPE.DIAL_NUMBER : (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_12__.getDestAgentTypeForEporEPDN)(), to: p === null || p === void 0 ? void 0 : p.destAgentId }, (isHoldParticipantsPassed() && { holdParticipants }))
                };
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.consultRequested)(interactionId, payload, handleCloseModal, setStateFunctions, _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT.toLowerCase());
                break;
            }
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION: {
                handleOrgSearchContainerDisabler(true);
                payload = {
                    interactionId,
                    data: Object.assign({ to: (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_12__.escapeSpecialChars)(selectedValue.toString().trim()), destinationType: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.DESTINATION_TYPE.DIAL_NUMBER }, (isHoldParticipantsPassed() && { holdParticipants }))
                };
                delete setStateFunctions.setShowErrorMessage;
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.consultRequested)(interactionId, payload, handleCloseModal, setStateFunctions, _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT.toLowerCase());
                break;
            }
            default:
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`please select Agent / Queue / DN`);
        }
    };
    const disableLoader = () => {
        setIsLoadingListItem(false);
        setIsChanged(false);
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION) {
            handleOrgSearchContainerDisabler(false);
        }
    };
    const handleTransfer = (detail) => {
        var _a, _b;
        let payload;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_util.trackCallTransferEvent({
            eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_TRANSFER_CLICKED,
            interactionId: detail.interactionId,
            ani,
            mediaType,
            contactDirection,
            timeEvent: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_TRANSFER_ACTIVATED
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_TRANSFER_CLICKED, [
            (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus
        ]);
        const setStateFunctions = {
            setShowErrorMessage,
            setTrackingId,
            setShouldDisableSubmitBtn,
            setShowFetchErrorMessage,
            setShowCustomerLeftMessage,
            disableLoader
        };
        switch (defaultListType) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS: {
                const item = getSelectedValue(_constants__WEBPACK_IMPORTED_MODULE_13__.AGENT_NAME);
                payload = {
                    to: (item === null || item === void 0 ? void 0 : item.agentId) || "",
                    destinationType: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.DESTINATION_TYPE.AGENT
                };
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.blindTransfer)(interactionId, payload, detail, dispatchCustomEvent, handleCloseModal, setStateFunctions, blindTransferEventName);
                break;
            }
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.QUEUES: {
                const item = getSelectedValue(_constants__WEBPACK_IMPORTED_MODULE_13__.NAME);
                const data = {
                    to: (item === null || item === void 0 ? void 0 : item.analyzerId) || (item === null || item === void 0 ? void 0 : item.id),
                    destinationType: isConsultTransferInfiniteScrollEnabled || (item === null || item === void 0 ? void 0 : item.type) === "inboundqueue"
                        ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.DESTINATION_TYPE.QUEUE
                        : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.DESTINATION_TYPE.EPDN
                };
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.vTeamTransfer)(interactionId, data, handleCloseModal, setStateFunctions);
                break;
            }
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ENTRY_POINT: {
                const item = getSelectedValue(_constants__WEBPACK_IMPORTED_MODULE_13__.NAME, defaultListType);
                const data = {
                    to: (item === null || item === void 0 ? void 0 : item.analyzerId) || (item === null || item === void 0 ? void 0 : item.id),
                    destinationType: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.DESTINATION_TYPE.EPDN
                };
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.vTeamTransfer)(interactionId, data, handleCloseModal, setStateFunctions);
                break;
            }
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER: {
                const item = getSelectedValue(_Common_constants__WEBPACK_IMPORTED_MODULE_11__.DN);
                payload = {
                    to: (item === null || item === void 0 ? void 0 : item.dn) || selectedValue.toString().trim(),
                    destinationType: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.DESTINATION_TYPE.DIAL_NUMBER
                };
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.blindTransfer)(interactionId, payload, detail, dispatchCustomEvent, handleCloseModal, setStateFunctions, blindTransferEventName);
                break;
            }
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION: {
                handleOrgSearchContainerDisabler(true);
                payload = {
                    to: (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_12__.escapeSpecialChars)(selectedValue.toString().trim()),
                    destinationType: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.DESTINATION_TYPE.DIAL_NUMBER
                };
                delete setStateFunctions.setShowErrorMessage;
                (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_15__.blindTransfer)(interactionId, payload, detail, dispatchCustomEvent, handleCloseModal, setStateFunctions, blindTransferEventName);
                break;
            }
            default:
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`please select Agent / Queue / DN`);
        }
    };
    const trackAddressBookEvents = () => {
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER) {
            const choseAddressBook = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.getValueFromCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.CHOSE_ADDRESS_BOOK_ENTRY);
            const searchedAddressBookBy = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.getValueFromCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.SEARCHED_ADDRESS_BOOK);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_CONSULT_TRANSFER_SEARCH, {
                choseFromAddressBook: choseAddressBook,
                searchedVia: searchedAddressBookBy,
                action: agentAction
            });
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.removeValueFromCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.SEARCHED_ADDRESS_BOOK);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.removeValueFromCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.CHOSE_ADDRESS_BOOK_ENTRY);
            if (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.AGENT_INTERACTION_TRANSFERRED);
            }
        }
    };
    const requestAction = (detail) => {
        var _a, _b;
        trackAddressBookEvents();
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`${agentAction} initiated`);
        setShouldDisableSubmitBtn(true);
        switch (agentAction) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT:
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CONSULT_CALL_TRANSFER);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_util.trackConsultEvent(Object.assign({ eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_CLICKED, mediaType, interactionId: detail.interactionId, contactDirection, timeEvent: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_ACTIVATED }, (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER
                    ? { dialNumberType: selectedTab.current === 0 ? _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ADDRESS_BOOK : _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ENTRY_POINT }
                    : {})));
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_CLICKED, [
                    (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus
                ]);
                handleConsult();
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER:
                handleTransfer(detail);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONFERENCE:
                // Track Digital Interaction Conference Click.
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_CONFERENCE_CLICKED, {
                    Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
                    [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.MEDIA_TYPE]: mediaType
                });
                handleConsult(); // Needs to be taken care for conference in telephony.
                break;
            default:
                break;
        }
        agentActionType(defaultListType);
    };
    const modalTitle = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(() => {
        var _a, _b, _c, _d, _e;
        if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE) {
            // This block will execute, When Organization FF is enabled
            if (!enableQueue && !config.collaborationConfig.displayUserDetails) {
                // Queue option is disabled, organization option is disabled
                return (_a = i18nMessage === null || i18nMessage === void 0 ? void 0 : i18nMessage.header) === null || _a === void 0 ? void 0 : _a.noQueueOrganizationTelephony;
            }
            else if (!enableQueue) {
                // Queue option only disabled
                return (_b = i18nMessage === null || i18nMessage === void 0 ? void 0 : i18nMessage.header) === null || _b === void 0 ? void 0 : _b.noQueueTelephony;
            }
            else if (!config.collaborationConfig.displayUserDetails) {
                return (_c = i18nMessage === null || i18nMessage === void 0 ? void 0 : i18nMessage.header) === null || _c === void 0 ? void 0 : _c.noOrganizationTelephony;
            }
            else {
                // All the options like Agent, Queue, Dial Number, Organization options are enabled.
                return (_d = i18nMessage === null || i18nMessage === void 0 ? void 0 : i18nMessage.header) === null || _d === void 0 ? void 0 : _d.telephony;
            }
        }
        else {
            // This block will execute, When Organization FF is enabled
            // For Chat and Email
            return (_e = i18nMessage === null || i18nMessage === void 0 ? void 0 : i18nMessage.header) === null || _e === void 0 ? void 0 : _e[mediaType];
        }
    }, [i18nMessage, mediaType, enableQueue, config.collaborationConfig.displayUserDetails]);
    function isAgentRadioButtonHidden() {
        //Hide when FF is on and accessBuddyTeam is "none"
        return isConsultTransferInfiniteScrollEnabled && accessBuddyTeam === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.NONE;
    }
    function isQueueRadioButtonHidden() {
        const isQueueDisabled = !enableQueue || accessQueue === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.NONE;
        return isConsultTransferInfiniteScrollEnabled || agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT
            ? isQueueDisabled
            : accessEntryPoint === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.NONE && isQueueDisabled;
    }
    function isDNRadioButtonHidden() {
        // Hide when mediaType is not voice
        return mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE;
    }
    function isEPRadioButtonHidden() {
        // Hide when mediaType is not voice or agentAction is not consult or isConsultTransferInfiniteScrollEnabled is false
        // or accessEntryPoint is "none"
        return (mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE ||
            (agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT && !isDesktopConsultToEntryPointDnEnabled) ||
            !isConsultTransferInfiniteScrollEnabled ||
            accessEntryPoint === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.NONE);
    }
    function isOrganisationRadioButtonHidden() {
        // Hide when mediaType is not voice or config.collaborationConfig.displayUserDetails is false
        return mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE || !config.collaborationConfig.displayUserDetails;
    }
    const getRadioButtons = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-radiogroup", Object.assign({ checked: listTypeSeqNo, alignment: "horizontal", ref: radioGroupRef, "group-label": modalTitle }, (isChanged || (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER && isEpDnFetching) ? { disabled: true } : ""), { children: [!isAgentRadioButtonHidden() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-radio", Object.assign({ class: "radioClass", value: _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS, "aria-label": i18nMessage.agents, label: i18nMessage.agents, htmlId: "agentRadio", slot: "radio", autoFocus: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: i18nMessage.agents, placement: "top" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "radioLabel" }, { children: i18nMessage.agents })) })) }))), !isQueueRadioButtonHidden() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-radio", Object.assign({ class: "radioClass", value: _Common_constants__WEBPACK_IMPORTED_MODULE_11__.QUEUES, "aria-label": i18nMessage.queues, label: i18nMessage.queues, htmlId: "queueRadio", slot: "radio" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: i18nMessage.queues, placement: "top" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "radioLabel" }, { children: i18nMessage.queues })) })) }))), !isDNRadioButtonHidden() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-radio", Object.assign({ id: "dailNumberId", class: "radioClass", value: _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER, "aria-label": i18nMessage.dialNumber, label: i18nMessage.dialNumber, htmlId: "dailNumberRadio", slot: "radio" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: i18nMessage.dialNumber, placement: "top" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "radioLabel" }, { children: i18nMessage.dialNumber })) })) }))), !isEPRadioButtonHidden() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-radio", Object.assign({ id: "entryPointId", class: "radioClass", value: _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ENTRY_POINT, "aria-label": i18nMessage.entryPoint, label: i18nMessage.entryPoint, htmlId: "entryPointRadio", slot: "radio" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: i18nMessage.entryPoint, placement: "top" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "radioLabel" }, { children: i18nMessage.entryPoint })) })) }))), !isOrganisationRadioButtonHidden() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-radio", Object.assign({ id: "organizationUsers", class: "radioClass", value: _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION, "aria-label": i18nMessage.organization, label: i18nMessage.organization, htmlId: "organizationUsersRadio", slot: "radio" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: i18nMessage.organization, placement: "top" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "radioLabel" }, { children: i18nMessage.organization })) })) })))] })));
    };
    const renderFailureMessage = (isErrorMessageForEpList, showFetchErrorMessage, agentAction) => {
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER) {
            if (isErrorMessageForEpList !== "" && !showFetchErrorMessage && checkEpDnListVisibility(agentAction)) {
                return transferModal.EntryPoint;
            }
            else if (typeof isErrorMessageForEpList === "string" &&
                isErrorMessageForEpList !== "" &&
                showFetchErrorMessage &&
                checkEpDnListVisibility(agentAction)) {
                return transferModal.Common;
            }
            else if (showFetchErrorMessage) {
                return transferModal.DialNumber;
            }
        }
        else if (showFetchErrorMessage) {
            return transferModal[defaultListType.replace(/\s/g, "")];
        }
        return "";
    };
    const renderTrackingId = (isErrorMessageForEpList, trackingId, agentAction) => {
        if (defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER &&
            isErrorMessageForEpList !== "" &&
            typeof isErrorMessageForEpList === "string" &&
            checkEpDnListVisibility(agentAction)) {
            return isErrorMessageForEpList;
        }
        return trackingId;
    };
    const showEpDnError = () => {
        if (typeof isErrorMessageForEpList === "string" &&
            isErrorMessageForEpList !== "" &&
            defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER &&
            isDesktopConsultToEntryPointDnEnabled &&
            agentAction !== _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER) {
            return true;
        }
        return false;
    };
    const isDisabled = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(() => (!selectedValue && enableSubmitForTesting !== "true") || shouldDisableSubmitBtn || showErrorDnVaildation, [selectedValue, enableSubmitForTesting, shouldDisableSubmitBtn, showErrorDnVaildation]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
        const submitButton = submitButtonRef.current;
        if (submitButton && !isDisabled()) {
            /* Dispatch "focus-visible" event, because FocusTrapMixin need to add submit button to focusable queue */
            submitButton.dispatchEvent(new CustomEvent("focus-visible", {
                composed: true,
                bubbles: true
            }));
        }
    }, [submitButtonRef, isDisabled]);
    const totalRadioButtons = () => {
        return (+!isAgentRadioButtonHidden() +
            +!isQueueRadioButtonHidden() +
            +!isDNRadioButtonHidden() +
            +!isEPRadioButtonHidden() +
            +!isOrganisationRadioButtonHidden());
    };
    const customModalClassNames = () => {
        return {
            "list-organization": config.collaborationConfig.displayUserDetails && mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE,
            "list-queue": enableQueue,
            "list-dialnumber": mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE,
            "radio-two-row": isConsultTransferInfiniteScrollEnabled
                ? totalRadioButtons() === 4 || totalRadioButtons() === 2
                : isQueueAndOrganizationEnabled,
            //if the radio buttons are 4 and the infinite scroll is enabled, then the radio buttons should be in 2 rows and both rows contian 2 radio buttons
            "radio-three-column": isConsultTransferInfiniteScrollEnabled && totalRadioButtons() !== 4,
            "isConsultTransferInfiniteScrollEnabled-class": isConsultTransferInfiniteScrollEnabled
        };
    };
    const handleConsultCheckBoxChange = (e) => {
        holdParticipantsRef.current = !e.target.checked;
    };
    const multiPartyConsultCheckBox = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: `multiparty-consult-check-box ${isConsultTransferInfiniteScrollEnabled ? "consult-checkbox-connector" : ""}` }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-checkbox", Object.assign({ id: "multiPartyConsultCheckBox", slot: "checkbox", class: "multi-party-consult-checkbox", onClick: handleConsultCheckBoxChange }, { children: i18nMessage.checkBoxLabel })) })));
    };
    const handleCancelBtn = () => {
        if (ctqInProgress) {
            cancelCtq({
                type: agentAction,
                interactionId
            });
            setIsChanged(false);
            setIsLoadingListItem(false);
        }
        else {
            handleCloseModal(ctqInProgress);
        }
    };
    const handleSubmitBtn = () => {
        if (!isDisabled()) {
            requestAction({
                type: agentAction,
                interactionId
            });
            setIsChanged(true);
            setIsLoadingListItem(true);
        }
    };
    const modalFooter = () => {
        return isCheckBoxVisible() ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ slot: "footer", className: `transfer-modal-footer ${isLargeModalForInfListReq() ? "transfer-modal-footer-connector-view" : ""} direction-column` }, { children: [multiPartyConsultCheckBox(), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "transfer-modal-md-button" }, { children: defaultModalFooter() }))] }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ slot: "footer", className: `transfer-modal-footer ${isLargeModalForInfListReq() ? "transfer-modal-footer-connector-view" : ""} ` }, { children: defaultModalFooter() })));
    };
    const defaultModalFooter = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ onClick: handleCancelBtn, type: "button", ariaLabel: ctqInProgress ? i18nMessage.cancelCtqAction : i18nMessage.cancel, class: "transfer-modal-btn", variant: "secondary" }, { children: ctqInProgress ? i18nMessage.cancelCtqAction : i18nMessage.cancel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ id: "submitActionId", ref: submitButtonRef, onClick: handleSubmitBtn, type: "submit" }, (isDisabled() ? { disabled: true } : ""), { ariaLabel: i18nMessage.type, class: "transfer-modal-btn", variant: "primary" }, { children: i18nMessage.type }))] }));
    };
    const isLargeModalForInfListReq = () => {
        return isConsultTransferInfiniteScrollEnabled;
    };
    const displayErrorMessage = () => {
        return (showErrorMessage ||
            // Below FF is added so that only one type of error message is shown at a time.
            // In case of FF : off -> this should display error message.
            // In case of FF : on -> only the inner(ListError) error message should show.
            (!isConsultTransferInfiniteScrollEnabled && showFetchErrorMessage) ||
            isShowCtqErrorMessage ||
            showEpDnError());
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_22___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-modal", Object.assign({ ref: modalRef, headerLabel: i18nMessage.title, ariaLabel: i18nMessage.title, applicationId: "app", id: "actionModal", hideFooter: true, size: "small", noExitOnEsc: true, onHide: () => {
                    handleCloseModal(ctqInProgress);
                }, onKeyDown: (e) => {
                    if (e.keyCode === 27) {
                        handleCloseModal(ctqInProgress);
                    }
                }, class: `modal-container ${isLargeModalForInfListReq() ? "modal-container-large" : ""}` }, (modal ? { show: true } : ""), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("modal-body-class", customModalClassNames()) }, { children: [checkAction() && mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.EMAIL && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "my-radio-group" }, { children: getRadioButtons() }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `agentAction-container ${isConsultTransferInfiniteScrollEnabled && "modal-container-height"}`, role: "alert" }, { children: [defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.AGENTS && renderSearchComp(), defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.QUEUES && renderSearchComp(), defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.DIAL_NUMBER && renderSearchComp(), defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ENTRY_POINT && renderSearchComp(), defaultListType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.ORGANIZATION && renderSearchComp(), isConsultTransferInfiniteScrollEnabled && isAllRadioButtonsHidden ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ id: "all-radio-buttons-hidden", "data-testid": "all-radio-buttons-hidden", className: "all-radio-buttons-hidden" }, { children: [" ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "all-radio-buttons-hidden-text-wrapper" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "all-radio-buttons-hidden-icon", name: "info_16" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "all-radio-buttons-hidden-text" }, { children: agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSFER
                                                            ? `${transferModal.allRadioButtonHidedTextForTransfer}`
                                                            : agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONSULT
                                                                ? `${transferModal.allRadioButtonHidedTextForConsult}`
                                                                : agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CONFERENCE
                                                                    ? `${transferModal.allRadioButtonHidedTextForConference}`
                                                                    : "" }))] }))] }))) : null] }))] })), modalFooter()] })) }) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_5__.observer)(TransferModalContent));


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.css":
/*!*************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.css ***!
  \*************************************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../../node_modules/css-loader/dist/cjs.js!./ListItem.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.tsx":
/*!*************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.tsx ***!
  \*************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _assets_AgentStateIcons_available_16_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../../assets/AgentStateIcons/available_16.svg */ "./src/assets/AgentStateIcons/available_16.svg");
/* harmony import */ var _assets_AgentStateIcons_idle_16_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../../assets/AgentStateIcons/idle_16.svg */ "./src/assets/AgentStateIcons/idle_16.svg");
/* harmony import */ var _Common_components_AvatarStatus_AvatarStatus__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../Common/components/AvatarStatus/AvatarStatus */ "./src/direflow-components/Common/components/AvatarStatus/AvatarStatus.tsx");
/* harmony import */ var _Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../Common/components/HighlightText */ "./src/direflow-components/Common/components/HighlightText/index.tsx");
/* harmony import */ var _ListItem_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./ListItem.css */ "./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.css");
/* harmony import */ var _ListItem_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_ListItem_css__WEBPACK_IMPORTED_MODULE_9__);











const StatusTypeIcon = {
    Available: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_assets_AgentStateIcons_available_16_svg__WEBPACK_IMPORTED_MODULE_5__["default"], {}),
    Idle: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_assets_AgentStateIcons_idle_16_svg__WEBPACK_IMPORTED_MODULE_6__["default"], {})
};
const PresenceType = {
    Available: "active",
    Idle: "idle"
};
// function to provide the UI content of list item
const ListItem = ({ data, index, style, isFocused, isSelected, onSelectValue, searchQuery, avatarState, title, subTitle = "" }) => {
    const listItmElm = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (isFocused) {
            listItmElm.current.focus();
        }
    }, [isFocused]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.Styled, Object.assign({ styles: (_ListItem_css__WEBPACK_IMPORTED_MODULE_9___default()) }, { children: (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("li", Object.assign({ className: `infinite-menu-list ${isSelected ? "selected-list-item " : ""} ${isFocused ? "selected-list-item-focused" : ""}` }, (isFocused ? { tabIndex: 0 } : { tabIndex: -1 }), { ref: listItmElm, role: "option", "aria-selected": isSelected, key: `status-${title}`, style: style, onClick: () => onSelectValue(data, index) }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(`list-item type-${avatarState}`) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Common_components_AvatarStatus_AvatarStatus__WEBPACK_IMPORTED_MODULE_7__["default"], Object.assign({ alt: title, title: title, statusIcon: !_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumAvatarEnabled && avatarState ? StatusTypeIcon[avatarState] : null, avatarClass: "list-item-avatar" }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumAvatarEnabled
                        ? { presenceType: PresenceType[avatarState], newMomentum: true }
                        : {}))), subTitle ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", Object.assign({ className: "list-item-detail" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("md-tooltip", Object.assign({ message: title, disabled: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", Object.assign({ className: "list-item-name" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_8__["default"], { text: title, highlight: searchQuery }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", Object.assign({ className: "list-item-subtitle" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_8__["default"], { text: subTitle, highlight: searchQuery }) }))] }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("list-text", "ellipsis-text") }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_8__["default"], { text: title, highlight: searchQuery }) })))] }))) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ListItem);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.css":
/*!**************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.css ***!
  \**************************************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../../node_modules/css-loader/dist/cjs.js!./SearchBar.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.tsx":
/*!**************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.tsx ***!
  \**************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _SearchBar_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./SearchBar.css */ "./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.css");
/* harmony import */ var _SearchBar_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_SearchBar_css__WEBPACK_IMPORTED_MODULE_5__);






const SearchBar = (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(({ refreshListHandler, searchHandler, loading, i18n, isListEmpty }, ref) => {
    const [searchQuery, setSearchQuery] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [searchInputPlaceholder, setSearchInputPlaceholder] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(i18n.emptyListInputPlaceholder);
    const searchInpRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const debouncedInputChangeHandler = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_4__.debouncedFunc)((e) => {
        onSearchInputChange(e);
    }, 500);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        const searchInp = searchInpRef.current;
        searchInp && searchInp.addEventListener("input-change", debouncedInputChangeHandler);
        return () => {
            searchInp && searchInp.removeEventListener("input-change", debouncedInputChangeHandler);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        setSearchInputPlaceholder(loading
            ? i18n.emptyListInputPlaceholder
            : isListEmpty
                ? i18n.emptyListInputPlaceholder
                : i18n.listInputPlaceholder);
    }, [loading, isListEmpty]);
    const onSearchInputChange = (e) => {
        var _a, _b;
        const searchText = ((_b = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim()) || "";
        setSearchQuery(searchText);
        searchHandler(searchText);
    };
    const refreshSpinner = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "refresh-spinner", "data-testid": "refreshSpinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "16" }) })));
    };
    const refreshButton = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ class: "refresh-list-tooltip", message: i18n.tooltipMsg }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ class: "refresh-list-button", type: "button", arialabel: i18n.refreshBtnAriaLabel, circle: true, variant: "ghost", "data-testid": "refreshButton", onClick: (e) => refreshListHandler() }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { slot: "icon", name: "refresh-bold", iconSet: "momentumDesign" }) })) })));
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: (_SearchBar_css__WEBPACK_IMPORTED_MODULE_5___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "search" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "search-bar-input" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-input", Object.assign({ ref: searchInpRef, type: "search", placeholder: searchInputPlaceholder, containerSize: "medium-10", searchable: "true", clear: "true", "data-testid": "searchInput", value: searchQuery }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }), (loading || isListEmpty ? { disabled: true } : {}))) })), loading ? refreshSpinner() : refreshButton()] })) })));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SearchBar);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/integration/microsoft/AuthError.tsx":
/*!*****************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/integration/microsoft/AuthError.tsx ***!
  \*****************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");


const OrganizationAuthError = react__WEBPACK_IMPORTED_MODULE_1__.memo((props) => {
    const { handleRetry, errorMessageLabel, tryAgainLabel } = props;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "organization-auth-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-error_12" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "auth-error-message", "aria-label": errorMessageLabel }, { children: [errorMessageLabel, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-link", Object.assign({ inline: true, class: "ms-retry-auth-link", "data-testid": "retry-ms-auth", role: "link", "aria-label": tryAgainLabel, onClick: handleRetry }, { children: tryAgainLabel }))] }))] })));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrganizationAuthError);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/integration/microsoft/index.tsx":
/*!*************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/integration/microsoft/index.tsx ***!
  \*************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OrganizationUsersList: () => (/* binding */ OrganizationUsersList),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _AddressBookIncreasedLimit_components_OrgDetails_OrgDetails__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../../AddressBookIncreasedLimit/components/OrgDetails/OrgDetails */ "./src/direflow-components/AddressBookIncreasedLimit/components/OrgDetails/OrgDetails.tsx");
/* harmony import */ var _AddressBookIncreasedLimit_styles_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../../AddressBookIncreasedLimit/styles.css */ "./src/direflow-components/AddressBookIncreasedLimit/styles.css");
/* harmony import */ var _AddressBookIncreasedLimit_styles_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_AddressBookIncreasedLimit_styles_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../../Common/components/HighlightText */ "./src/direflow-components/Common/components/HighlightText/index.tsx");
/* harmony import */ var _Common_components_List__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../../Common/components/List */ "./src/direflow-components/Common/components/List/index.tsx");
/* harmony import */ var _Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../../Common/components/List/ListError */ "./src/direflow-components/Common/components/List/ListError/index.tsx");
/* harmony import */ var _Common_components_MSTAvatar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../../Common/components/MSTAvatar */ "./src/direflow-components/Common/components/MSTAvatar/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../../InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./utils */ "./src/direflow-components/InteractionControl/components/TransferModal/integration/microsoft/utils.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};















const OrganizationUsersList = ({ searchQuery, handleListClick, height, initiateDataFetch, updateFetchingStatus, resetFocus, renderTransferModalError }) => {
    const { orgDetailsLabels, organization: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.useI18nContext)();
    const nextLinkRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const totalPages = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(0);
    const page = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(-1);
    const [hasNextPage, setHasNextPage] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [isNextPageLoading, setIsNextPageLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [pageFetchError, setPageFetchError] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        error: false,
        trackingId: ""
    });
    const [usersList, setOrganizationUsers] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [loadingFirstPage, setLoadingFirstPage] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [loadingFirstPageError, setLoadingFirstPageError] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        error: false,
        trackingId: ""
    });
    const [searchError, setSearchError] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const loadFirstPage = () => {
        setOrganizationUsers([]);
        setLoadingFirstPage(true);
        loadPage(0, searchQuery, true);
    };
    react__WEBPACK_IMPORTED_MODULE_3__.useEffect(() => {
        if (initiateDataFetch !== 0 && searchQuery !== undefined) {
            if (searchQuery.length >= _Common_constants__WEBPACK_IMPORTED_MODULE_12__.MINIMUM_CHARACTERS_FOR_SEARCH || searchQuery === "") {
                setSearchError(false);
                loadFirstPage();
            }
            else {
                setSearchError(true);
            }
        }
    }, [initiateDataFetch, searchQuery]);
    const fetchUserPresence = (userIds) => __awaiter(void 0, void 0, void 0, function* () {
        (0,_utils__WEBPACK_IMPORTED_MODULE_14__.fetchUserPresences)(userIds).then((response) => {
            if (Array.isArray(response) && response.length > 0) {
                setOrganizationUsers((prevState) => {
                    const prevStateCopy = [...prevState];
                    response.forEach((presenceDataObj) => {
                        const index = prevStateCopy.findIndex((it) => it.id === presenceDataObj.id);
                        if (index >= 0) {
                            prevStateCopy[index].hasPresence = {};
                            const prevStateObj = prevStateCopy[index].hasPresence;
                            prevStateObj.availability = presenceDataObj.availability;
                            prevStateObj.activity = presenceDataObj.activity;
                            prevStateObj.statusMessage = presenceDataObj.statusMessage;
                        }
                    });
                    return prevStateCopy;
                });
            }
        });
    });
    const fetchProfilePhoto = (userIds) => __awaiter(void 0, void 0, void 0, function* () {
        (0,_utils__WEBPACK_IMPORTED_MODULE_14__.fetchUserAvatars)(userIds).then((response) => {
            if (Array.isArray(response) && response.length > 0) {
                setOrganizationUsers((prevState) => {
                    const prevStateCopy = [...prevState];
                    response.forEach((data) => {
                        const index = prevState.findIndex((it) => it.id === (data === null || data === void 0 ? void 0 : data.userId));
                        if (index >= 0) {
                            prevStateCopy[index].profileUrl = data === null || data === void 0 ? void 0 : data.base64Result;
                        }
                    });
                    return prevStateCopy;
                });
            }
        });
    });
    const setTotalPages = (totalUsers) => {
        totalPages.current = Math.ceil(totalUsers / _utils__WEBPACK_IMPORTED_MODULE_14__.TOTAL_RECORDS_PER_PAGE);
    };
    const setPage = (pageNumber) => {
        page.current = pageNumber;
    };
    const fetchMicrosoftUsers = (pageNumber, searchQuery, results = []) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const parameters = Object.assign({ count: _utils__WEBPACK_IMPORTED_MODULE_14__.TOTAL_RECORDS_PER_PAGE, skipToken: pageNumber !== 0 ? (0,_utils__WEBPACK_IMPORTED_MODULE_14__.extractSkipTokenFromNextLink)(nextLinkRef.current) : "" }, (searchQuery && searchQuery !== "" ? { searchQuery } : null));
        const apiResponse = yield ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.microsoft) === null || _a === void 0 ? void 0 : _a.fetchUsers(parameters));
        // filter the response with only entries have businessPhones number.
        const filteredRecords = (0,_utils__WEBPACK_IMPORTED_MODULE_14__.formatUsersResponse)(apiResponse.value);
        nextLinkRef.current = (_b = apiResponse["@odata.nextLink"]) !== null && _b !== void 0 ? _b : null;
        if (pageNumber === 0) {
            // On initial fetch update the total records counts
            // MS Graph API will return the totalRecords count on page 0 only, not for all pagination requests
            const totalUsers = apiResponse["@odata.count"];
            setTotalPages(Number(totalUsers));
        }
        results = results.concat(filteredRecords);
        setPage(pageNumber);
        if (results.length >= _utils__WEBPACK_IMPORTED_MODULE_14__.TOTAL_RECORDS_PER_PAGE) {
            return results;
        }
        else if (pageNumber < totalPages.current - 1) {
            // Call the same function recursively and get the results
            const response = yield fetchMicrosoftUsers(pageNumber + 1, searchQuery, results);
            return response;
        }
        return results;
    });
    const loadPage = (pageNumber, searchQuery, reset = false) => {
        fetchMicrosoftUsers(pageNumber, searchQuery)
            .then((response) => {
            setHasNextPage(page.current < totalPages.current - 1);
            if (Array.isArray(response) && response.length > 0) {
                const userIds = response.map((it) => it.id);
                fetchProfilePhoto(userIds);
                fetchUserPresence(userIds);
            }
            setPageFetchError({ error: false, trackingId: "" });
            setLoadingFirstPageError({ error: false, trackingId: "" });
            setOrganizationUsers((prevItems) => (reset ? response : [...prevItems, ...response]));
            if (pageNumber === 0) {
                setLoadingFirstPage(false);
                updateFetchingStatus(false);
            }
            setIsNextPageLoading(false);
        })
            .catch((error) => {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_13__.logger.error("[Organization]: Error on fetching users from microsoft graph api", error);
            // Tracking ID is not possible to get on ms api.
            if (pageNumber === 0) {
                setLoadingFirstPage(false);
                updateFetchingStatus(false);
                setLoadingFirstPageError({ error: true, trackingId: "" });
            }
            else {
                setPageFetchError({ error: true, trackingId: "" });
                // CHECK This logic is correct or not.
                setHasNextPage(true);
                setIsNextPageLoading(false);
            }
        });
    };
    const loadNextPage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isNextPageLoading) {
            return;
        }
        setIsNextPageLoading(true);
        loadPage(page.current + 1, searchQuery);
    });
    const isNoRecordFound = () => {
        return usersList.length === 0 && !loadingFirstPage;
    };
    const getLoadingError = () => {
        if (searchError) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "search-block-error", style: { height } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "search-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "info-badge-filled", iconSet: "momentumDesign", size: "16", class: "search-error-info" }), i18n.searchError] })) })));
        }
        if (!loadingFirstPage && loadingFirstPageError.error) {
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_10__["default"], { onRetry: () => loadFirstPage(), trackingId: loadingFirstPageError.trackingId });
        }
        else if (isNoRecordFound()) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "no-record", style: { height } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_7__["default"], { illustrationType: "empty-result" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-label": i18n.noMatchFound, className: "no-record-found" }, { children: i18n.noMatchFound }))] })));
        }
        return null;
    };
    const handleSelectedItem = (selectedData) => {
        const selectedUser = usersList.find((user) => user.id === selectedData.id);
        handleListClick(selectedUser);
    };
    const checkDetailValue = (detail) => {
        return !detail || detail === "" ? _Common_constants__WEBPACK_IMPORTED_MODULE_12__.EMPTY_DETAIL_VALUE : detail;
    };
    const buildOrgCardDetails = (value) => {
        return {
            role: {
                value: checkDetailValue(value.jobTitle),
                label: orgDetailsLabels.role
            },
            department: {
                value: checkDetailValue(value.department),
                label: orgDetailsLabels.department
            },
            email: {
                value: checkDetailValue(value.userPrincipalName),
                label: orgDetailsLabels.email
            },
            phone: {
                value: value.businessPhones ? checkDetailValue(value.businessPhones[0]) : _Common_constants__WEBPACK_IMPORTED_MODULE_12__.EMPTY_DETAIL_VALUE,
                label: orgDetailsLabels.businessPhone
            }
        };
    };
    const ListItemContent = ({ data, index, style, isSelected, isFocused, onSelectValue }) => {
        var _a, _b, _c, _d;
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `address-list-item address-book-increased-limit-list-item ${isSelected ? "selected" : ""} ${isFocused ? "hovered" : ""}`, style: style, "aria-label": data.userDetails, onClick: () => onSelectValue(data, index) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ placement: "right-start", "custom-width": "308px", "allow-hover-toggle": true }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ slot: "menu-trigger" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_MSTAvatar__WEBPACK_IMPORTED_MODULE_11__["default"], { alt: data.displayName || "", title: data.displayName, availability: (_a = data.hasPresence) === null || _a === void 0 ? void 0 : _a.availability, activity: (_b = data.hasPresence) === null || _b === void 0 ? void 0 : _b.activity, avatarClass: "address-list-item-avatar", src: data.profileUrl || "" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "org-detail-wrapper" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddressBookIncreasedLimit_components_OrgDetails_OrgDetails__WEBPACK_IMPORTED_MODULE_5__["default"], { name: data.displayName, details: buildOrgCardDetails(data), avatarImageURL: data.profileUrl || "", userAvailability: (_c = data.hasPresence) === null || _c === void 0 ? void 0 : _c.availability, userActivity: (_d = data.hasPresence) === null || _d === void 0 ? void 0 : _d.activity }) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "address-list-item-detail" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: data.displayName, disabled: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-name" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_8__["default"], { text: data.displayName, highlight: searchQuery }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-dn" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_8__["default"], { text: data.userDetails, highlight: searchQuery }) }))] }))] }), index));
    };
    const getOrgUsersListComponent = () => {
        if (isNoRecordFound() || searchError) {
            return null;
        }
        if (!loadingFirstPage && !loadingFirstPageError.error) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_9__["default"], Object.assign({ data: usersList, customClassName: "address-book-increased-limit-list", height: height, itemHeight: 48, onSelectValue: handleSelectedItem, hasNextPage: hasNextPage, isNextPageLoading: isNextPageLoading, loadNextPage: loadNextPage, pageFetchError: pageFetchError, resetFocusedAndSelected: resetFocus, infiniteScrollEnabled: true }, { children: (props) => {
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItemContent, Object.assign({}, props));
                } })));
        }
        return null;
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: (_AddressBookIncreasedLimit_styles_css__WEBPACK_IMPORTED_MODULE_6___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: `address-list address-book-increased-limit adr-list-ht-od-dis-outdial-ani ${(loadingFirstPageError === null || loadingFirstPageError === void 0 ? void 0 : loadingFirstPageError.error) ? "address-book-loading-error" : ""}` }, { children: [loadingFirstPage && !searchError && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-book-increased-limit__loading", style: { height } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "56" }) }))), renderTransferModalError && renderTransferModalError(), getOrgUsersListComponent(), getLoadingError()] })) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrganizationUsersList);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/integration/microsoft/utils.ts":
/*!************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/integration/microsoft/utils.ts ***!
  \************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TOTAL_RECORDS_PER_PAGE: () => (/* binding */ TOTAL_RECORDS_PER_PAGE),
/* harmony export */   extractSkipTokenFromNextLink: () => (/* binding */ extractSkipTokenFromNextLink),
/* harmony export */   fetchUserAvatars: () => (/* binding */ fetchUserAvatars),
/* harmony export */   fetchUserPresences: () => (/* binding */ fetchUserPresences),
/* harmony export */   formatUserDetails: () => (/* binding */ formatUserDetails),
/* harmony export */   formatUsersResponse: () => (/* binding */ formatUsersResponse)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


const TOTAL_RECORDS_PER_PAGE = 50;
const b64toBlob = (b64Data, contentType, sliceSize) => {
    const type = contentType || "image/png";
    const size = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += size) {
        const slice = byteCharacters.slice(offset, offset + size);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i += 1) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type });
};
const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.readAsDataURL(blob);
    });
};
const splitArrayIntoSets = (array, chunkSize) => {
    const sets = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        sets.push(array.slice(i, i + chunkSize));
    }
    return sets;
};
const fetchUserAvatars = (userIds) => __awaiter(void 0, void 0, void 0, function* () {
    const batchRequestSteps = userIds.map((userId) => {
        return {
            id: userId,
            method: "GET",
            url: `/users/${userId}/photo/$value`
        };
    });
    try {
        // Split Batch Requests into 20 set of arrays.
        const batchRequestSets = splitArrayIntoSets(batchRequestSteps, 20);
        const allBatchRequestSteps = batchRequestSets.map((userRequest) => {
            var _a;
            // Batch request maximum array size is 20.
            return (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.microsoft) === null || _a === void 0 ? void 0 : _a.batchRequest(userRequest);
        });
        const batchResponse = yield Promise.all(allBatchRequestSteps);
        const responses = batchRequestSets.map((batchRequest, index) => {
            return batchRequest.map((value) => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                const response = (_a = batchResponse[index]) === null || _a === void 0 ? void 0 : _a.getResponseById(value.id);
                if (response.ok) {
                    const data = yield response.text();
                    const binToBlob = b64toBlob(data, "img/jpg");
                    const base64Result = yield blobToBase64(binToBlob);
                    return {
                        userId: value.id,
                        base64Result
                    };
                }
                return null;
            }));
        });
        const responseList = [];
        responses.forEach((value) => {
            responseList.push(...value);
        });
        const avatarResponses = yield Promise.all(responseList);
        return avatarResponses.filter((response) => !!response);
    }
    catch (error) {
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Organization]: Error on fetching user avatar from microsoft graph api", error);
        throw error;
    }
});
const fetchUserPresences = (userIds) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const response = yield ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.microsoft) === null || _a === void 0 ? void 0 : _a.fetchUserPresence({
            requestData: { ids: userIds }
        }));
        return response.value.map((value) => {
            return {
                id: value.id,
                availability: value.availability,
                activity: value.activity,
                statusMessage: value.statusMessage
            };
        });
    }
    catch (error) {
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Organization]: Error on fetching user presences from microsoft graph api", error);
        throw error;
    }
});
const extractSkipTokenFromNextLink = (nextLinkRef) => {
    var _a;
    if (nextLinkRef) {
        const url = new URL(nextLinkRef);
        // Extract the skipToken query parameter
        const skipToken = (_a = url.searchParams.get("$skiptoken")) !== null && _a !== void 0 ? _a : url.searchParams.get("$skipToken");
        return skipToken !== null && skipToken !== void 0 ? skipToken : "";
    }
    return "";
};
const formatUserDetails = (value) => {
    let userDetails = "";
    if (value.jobTitle && value.jobTitle.trim() !== "") {
        userDetails = `${value.jobTitle}, `;
    }
    if (value.department && value.department.trim() !== "") {
        userDetails += `${value.department}, `;
    }
    if (value.businessPhones && Array.isArray(value.businessPhones) && value.businessPhones.length > 0) {
        userDetails += `${value.businessPhones[0]}`;
    }
    return userDetails;
};
const formatUsersResponse = (usersList) => {
    const response = [];
    usersList.forEach((value) => {
        // Use For Each to filter the business phones, if api is not supported.
        // Push only if fields having the valid businessPhone numbers
        if (Array.isArray(value.businessPhones) && value.businessPhones.length > 0) {
            response.push(Object.assign(Object.assign({}, value), { userDetails: formatUserDetails(value) }));
        }
    });
    return response;
};


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/integration/webex/WebexListItemContent.tsx":
/*!************************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/integration/webex/WebexListItemContent.tsx ***!
  \************************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WebexListItemContent: () => (/* binding */ WebexListItemContent)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _AddressBookIncreasedLimit_components_WebexContactCard_WebexContactCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../AddressBookIncreasedLimit/components/WebexContactCard/WebexContactCard */ "./src/direflow-components/AddressBookIncreasedLimit/components/WebexContactCard/WebexContactCard.tsx");
/* harmony import */ var _Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../Common/components/HighlightText */ "./src/direflow-components/Common/components/HighlightText/index.tsx");
/* harmony import */ var _Common_components_WebexAvatar_WebexAvatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../../Common/components/WebexAvatar/WebexAvatar */ "./src/direflow-components/Common/components/WebexAvatar/WebexAvatar.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../../Common/constants */ "./src/direflow-components/Common/constants.ts");







const WebexListItemContent = ({ data, searchQuery, index, style, isSelected, isFocused, onSelectValue, onVisible }) => {
    var _a, _b, _c, _d, _e;
    const { orgDetailsLabels } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.useI18nContext)();
    const rootRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const checkDetailValue = (detail) => {
        return !detail || detail === "" ? _Common_constants__WEBPACK_IMPORTED_MODULE_6__.EMPTY_DETAIL_VALUE : detail;
    };
    const buildOrgCardDetails = (value) => {
        return {
            role: {
                value: checkDetailValue(value.jobTitle),
                label: orgDetailsLabels.role
            },
            department: {
                value: checkDetailValue(value.department),
                label: orgDetailsLabels.department
            },
            email: {
                value: checkDetailValue(value.email),
                label: orgDetailsLabels.email
            },
            phone: {
                value: value.phoneNumber ? value.phoneNumber : _Common_constants__WEBPACK_IMPORTED_MODULE_6__.EMPTY_DETAIL_VALUE,
                label: orgDetailsLabels.workPhone
            }
        };
    };
    const getDetailsString = () => {
        let detailsString = "";
        if (data.jobTitle) {
            detailsString = detailsString.concat(data.department || data.phoneNumber ? data.jobTitle.concat(", ") : data.jobTitle);
        }
        if (data.department) {
            detailsString = detailsString.concat(data.phoneNumber ? data.department.concat(", ") : data.department);
        }
        if (data.phoneNumber) {
            detailsString = detailsString.concat(data.phoneNumber);
        }
        return detailsString;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        const observer = new IntersectionObserver(([entry]) => {
            onVisible(data, entry.isIntersecting);
        }, {
            root: null,
            rootMargin: "0px",
            threshold: 1
        });
        observer.observe(rootRef.current);
        return () => observer.unobserve(rootRef.current);
    }, []);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ ref: rootRef, className: `address-list-item address-book-increased-limit-list-item ${isSelected ? "selected" : ""} ${isFocused ? "hovered" : ""}`, style: style, "aria-label": data.displayName, onClick: () => onSelectValue(data, index) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ placement: "right-start", "custom-width": "308px", "allow-hover-toggle": true }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ slot: "menu-trigger" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_WebexAvatar_WebexAvatar__WEBPACK_IMPORTED_MODULE_5__["default"], { name: data.displayName, src: data.avatarUrl, presence: (_a = data.presence) === null || _a === void 0 ? void 0 : _a.status }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "org-detail-wrapper" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddressBookIncreasedLimit_components_WebexContactCard_WebexContactCard__WEBPACK_IMPORTED_MODULE_3__["default"], { name: data.displayName, details: buildOrgCardDetails(data), src: data.avatarUrl, presenceStatus: (_b = data.presence) === null || _b === void 0 ? void 0 : _b.status, lastActiveTime: (_c = data.presence) === null || _c === void 0 ? void 0 : _c.lastActiveTime, expiresTime: (_d = data.presence) === null || _d === void 0 ? void 0 : _d.expiresTime, customStatusMessage: (_e = data.presence) === null || _e === void 0 ? void 0 : _e.customStatus }) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "address-list-item-detail" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: data.displayName, disabled: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-name" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_4__["default"], { text: data.displayName, highlight: searchQuery }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-dn" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_4__["default"], { text: getDetailsString(), highlight: searchQuery }) }))] }))] }), index));
};


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/integration/webex/WebexOrganizationUserList.tsx":
/*!*****************************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/integration/webex/WebexOrganizationUserList.tsx ***!
  \*****************************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ WebexOrganizationUserList)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../styles.css */ "./src/direflow-components/InteractionControl/components/TransferModal/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _WebexUsersList__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./WebexUsersList */ "./src/direflow-components/InteractionControl/components/TransferModal/integration/webex/WebexUsersList.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};









const maxSearchResult = 100;
var SearchState;
(function (SearchState) {
    SearchState[SearchState["noError"] = 0] = "noError";
    SearchState[SearchState["empty"] = 1] = "empty";
    SearchState[SearchState["lessThanThreeChars"] = 2] = "lessThanThreeChars";
    SearchState[SearchState["noMatchFound"] = 3] = "noMatchFound";
    SearchState[SearchState["Searching"] = 4] = "Searching";
})(SearchState || (SearchState = {}));
function handleVisibleUsersChanged(visibleUsers, setUsers, cachedLookupUsers) {
    return __awaiter(this, void 0, void 0, function* () {
        const userIdsToLookup = visibleUsers.filter((user) => user.source !== "lookup").map(({ userId }) => userId);
        if (userIdsToLookup.length === 0) {
            return;
        }
        try {
            const visibleUsersWithRoleAndDept = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.webex.lookupUsers(userIdsToLookup);
            visibleUsersWithRoleAndDept.forEach((user) => (cachedLookupUsers.current[user.userId] = user));
            setUsers((users) => users.map((user) => {
                const visibleUser = visibleUsersWithRoleAndDept.find(({ userId }) => userId === user.userId);
                return visibleUser !== null && visibleUser !== void 0 ? visibleUser : user;
            }));
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.webex.subscribeForPresenceUpdates(userIdsToLookup);
            document.dispatchEvent(new CustomEvent("on-widget-update"));
        }
        catch (e) {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_6__.logger.error(`[Webex] lookup users failure ${e}`);
        }
    });
}
function WebexOrganizationUserList({ searchQuery, height, isDarkMode, onItemClicked, renderTransferModalError }) {
    const [users, setUsers] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const cachedLookupUsers = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)({});
    const { interaction_control, organization } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.useI18nContext)();
    const [searchState, setSearchState] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(SearchState.noError);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
        (function () {
            return __awaiter(this, void 0, void 0, function* () {
                if (searchQuery.length < 3) {
                    setUsers([]);
                    setSearchState(searchQuery.length === 0 ? SearchState.empty : SearchState.lessThanThreeChars);
                }
                else {
                    try {
                        setSearchState(SearchState.Searching);
                        const foundUsers = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.webex.searchUsers(searchQuery, maxSearchResult);
                        const foundUsersWithCache = foundUsers
                            .map((user) => { var _a; return (_a = cachedLookupUsers.current[user.userId]) !== null && _a !== void 0 ? _a : user; })
                            .filter((user) => user.phoneNumber);
                        setUsers(foundUsersWithCache);
                        if (users.length > 0) {
                            document.dispatchEvent(new CustomEvent("on-widget-update"));
                        }
                        setSearchState(users.length === 0 ? SearchState.noMatchFound : SearchState.noError);
                    }
                    catch (e) {
                        setSearchState(SearchState.noMatchFound);
                        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_6__.logger.error(`[Webex] search users failure ${e}`);
                    }
                }
            });
        })();
    }, [searchQuery]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.webex.onPresenceUpdateEvent.listen((presences) => {
            if (presences.length > 0) {
                setUsers((prevUsers) => {
                    const prevUsersCopy = [...prevUsers];
                    presences.forEach((presence) => {
                        var _a;
                        const foundUser = (_a = prevUsersCopy.find((it) => it.userId === presence.contactId)) !== null && _a !== void 0 ? _a : cachedLookupUsers.current[presence.contactId];
                        if (foundUser) {
                            foundUser.presence = presence;
                        }
                    });
                    return prevUsersCopy;
                });
            }
            document.dispatchEvent(new CustomEvent("on-widget-update"));
        });
    }, []);
    const getWebexUsersList = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WebexUsersList__WEBPACK_IMPORTED_MODULE_8__.WebexUsersList, { userList: users, height: height, searchQuery: searchQuery, handleListClick: (item) => {
                if (item === null || item === void 0 ? void 0 : item.phoneNumber) {
                    onItemClicked({ businessPhones: [item.phoneNumber] });
                }
            }, onVisibleItemsChanged: (users) => handleVisibleUsersChanged(users, setUsers, cachedLookupUsers) }));
    };
    const getPlaceholder = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "no-record", style: { height } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_5__["default"], { illustrationType: searchState === SearchState.noMatchFound ? "empty-result" : "empty-organization-search", theme: isDarkMode ? "dark" : "light" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-label": searchState === SearchState.noMatchFound ? organization.noMatchFound : interaction_control.searchPlaceholder, className: "no-record-found" }, { children: searchState === SearchState.noMatchFound ? organization.noMatchFound : interaction_control.searchPlaceholder }))] })));
    };
    const showSpinner = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "org-search-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "56" }) })));
    };
    const renderSearchError = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "org-search-block-error", style: { height } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "org-search-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "info-badge-filled", size: "16", iconSet: "momentumDesign", class: "search-error-info" }), organization.searchError] })) })));
    };
    const renderSearchResult = () => {
        return users.length === 0 ? getPlaceholder() : getWebexUsersList();
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: (_styles_css__WEBPACK_IMPORTED_MODULE_7___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [renderTransferModalError && renderTransferModalError(), searchState === SearchState.Searching
                        ? showSpinner()
                        : searchState === SearchState.lessThanThreeChars
                            ? renderSearchError()
                            : renderSearchResult()] }) })) }));
}


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/integration/webex/WebexUsersList.tsx":
/*!******************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/integration/webex/WebexUsersList.tsx ***!
  \******************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WebexUsersList: () => (/* binding */ WebexUsersList),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _Common_components_AvatarStatus_styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../Common/components/AvatarStatus/styles.scss */ "./src/direflow-components/Common/components/AvatarStatus/styles.scss");
/* harmony import */ var _Common_components_AvatarStatus_styles_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Common_components_AvatarStatus_styles_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Common_components_List__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../../Common/components/List */ "./src/direflow-components/Common/components/List/index.tsx");
/* harmony import */ var _WebexListItemContent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./WebexListItemContent */ "./src/direflow-components/InteractionControl/components/TransferModal/integration/webex/WebexListItemContent.tsx");







const WebexUsersList = ({ userList, searchQuery, handleListClick, height, onVisibleItemsChanged }) => {
    const visibleUsers = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)({});
    const handleSelectedItem = (selectedData) => {
        const selectedUser = userList.find((user) => user.userId === selectedData.userId);
        if (selectedUser) {
            handleListClick(selectedUser);
        }
    };
    const debounceVisibleItemsChanged = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(lodash__WEBPACK_IMPORTED_MODULE_2___default().debounce(function () {
        const users = Object.values(visibleUsers.current);
        if (users.length > 0) {
            onVisibleItemsChanged(users);
            visibleUsers.current = {};
        }
    }, 1000), []);
    const handleOnVisible = (user, isVisible) => {
        if (!isVisible) {
            delete visibleUsers.current[user.userId];
        }
        else {
            visibleUsers.current[user.userId] = user;
        }
        debounceVisibleItemsChanged();
    };
    const getOrgUsersListComponent = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_5__["default"], Object.assign({ data: userList, customClassName: "address-book-increased-limit-list", height: height, itemHeight: 48, onSelectValue: handleSelectedItem, infiniteScrollEnabled: false }, { children: (props) => {
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WebexListItemContent__WEBPACK_IMPORTED_MODULE_6__.WebexListItemContent, Object.assign({ searchQuery: searchQuery, onVisible: handleOnVisible }, props));
            } })));
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: (_Common_components_AvatarStatus_styles_scss__WEBPACK_IMPORTED_MODULE_4___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-list address-book-increased-limit adr-list-ht-od-dis-outdial-ani " }, { children: getOrgUsersListComponent() })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WebexUsersList);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/queue/QueueList.tsx":
/*!*************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/queue/QueueList.tsx ***!
  \*************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_components_List__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../Common/components/List */ "./src/direflow-components/Common/components/List/index.tsx");
/* harmony import */ var _Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../Common/components/List/ListError */ "./src/direflow-components/Common/components/List/ListError/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");
/* harmony import */ var _TransferHelper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../TransferHelper */ "./src/direflow-components/InteractionControl/TransferHelper.ts");
/* harmony import */ var _common_ListItem__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../common/ListItem */ "./src/direflow-components/InteractionControl/components/TransferModal/common/ListItem.tsx");
/* harmony import */ var _common_SearchBar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../common/SearchBar */ "./src/direflow-components/InteractionControl/components/TransferModal/common/SearchBar.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};












const ItemHeight = 48;
const QueueList = ({ selectedType, mediaType, setTrackingId, handleErrorMessageOnFetchSuccess, handleErrorMessageOnFetchFailure, onQueueSelect, listHeight, renderTransferModalError }) => {
    const [searchQuery, setSearchQuery] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [queueList, setQueueList] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [isSearchBarLoading, setIsSearchBarLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const { transferModal, outdial } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    const [hasNextPage, setHasNextPage] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [pageNum, setPageNum] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(-1);
    const [loadingFirstPage, setLoadingFirstPage] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
    const [isNextPageLoading, setIsNextPageLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [searchMinCharError, setSearchMinCharError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [loadingFirstPageError, setLoadingFirstPageError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        error: false,
        trackingId: ""
    });
    const [pageFetchError, setPageFetchError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        error: false,
        trackingId: ""
    });
    const i18n = {
        tooltipMsg: transferModal.refreshTheList,
        refreshBtnAriaLabel: transferModal.refreshQueueList,
        emptyListInputPlaceholder: transferModal.QueuesEmpty,
        listInputPlaceholder: transferModal.infScrollQueue || transferModal.comboBoxAriaLabelQueue,
        noRecordFound: outdial.noAdrFound,
        searchMinCharError: transferModal.searchMinCharError
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        loadFirstPage();
    }, [selectedType]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (!loadingFirstPage) {
            onSearchInputChange(searchQuery);
        }
    }, [searchQuery]);
    const loadFirstPage = () => {
        setQueueList([]);
        setLoadingFirstPage(true);
        setLoadingFirstPageError({ error: false, trackingId: "" });
        loadPage(0, searchQuery, true);
    };
    const refreshQueueList = () => {
        setIsSearchBarLoading(true);
        setLoadingFirstPage(true);
        onQueueSelect("");
        setQueueList([]);
        loadPage(0, searchQuery, true);
    };
    const loadNextPage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isNextPageLoading) {
            return;
        }
        setIsNextPageLoading(true);
        loadPage(pageNum + 1, searchQuery, false);
    });
    const handleLoadPageSuccess = (res, reset) => {
        const { page, totalPages } = res.meta || {};
        const currentQueueList = res.data;
        //update the previous list with new list or reset the list with new list.
        setQueueList((prevQueueList) => (reset ? currentQueueList : [...prevQueueList, ...currentQueueList]));
        setPageFetchError({ error: false, trackingId: "" });
        setLoadingFirstPageError({ error: false, trackingId: "" });
        if (page !== undefined && totalPages !== undefined) {
            setHasNextPage(page < totalPages - 1);
        }
        else {
            setHasNextPage(false);
        }
        if (page === 0 || page === -1) {
            setLoadingFirstPage(false);
            onQueueSelect("");
        }
        setIsNextPageLoading(false);
        (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_9__.successHandler)(currentQueueList, handleErrorMessageOnFetchSuccess);
        setPageNum(page);
    };
    const handleLoadPageError = (err, pageNumber) => {
        const trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err);
        if (pageNumber === 0 || pageNumber === -1) {
            setLoadingFirstPage(false);
            setLoadingFirstPageError({ error: true, trackingId });
            onQueueSelect("");
            (0,_TransferHelper__WEBPACK_IMPORTED_MODULE_9__.errorHandler)(err, setTrackingId, handleErrorMessageOnFetchFailure);
        }
        else {
            setPageFetchError({ error: true, trackingId });
            setHasNextPage(true);
            setIsNextPageLoading(false);
        }
    };
    const loadPage = (pageNumber, searchQuery, reset = false) => {
        var _a;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs
            .fetchQueueList({
            payload: {
                pageSize: _Common_constants__WEBPACK_IMPORTED_MODULE_7__.PAGE_SIZE,
                pageNumber,
                channelType: mediaType,
                search: searchQuery,
                desktopProfileFilter: true // this true for filter queues based on desktop profile.
            },
            orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || ""
        })
            .then((res) => {
            handleLoadPageSuccess(res, reset);
            // this is needed for trap focus within Modal
            document.dispatchEvent(new CustomEvent("on-widget-update"));
        })
            .catch((err) => {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_8__.logger.error("event=fetchQueuesFailed Error while fetching queue list", err);
            handleLoadPageError(err, pageNumber);
        })
            .finally(() => {
            setIsSearchBarLoading(false);
            setSearchMinCharError(false);
        });
    };
    const onQueueSelectFromList = (selectData) => {
        onQueueSelect(selectData);
    };
    const onSearchInputChange = (searchText) => {
        if (searchText === "") {
            refreshQueueList();
        }
        else {
            if (searchText.length >= _Common_constants__WEBPACK_IMPORTED_MODULE_7__.MINIMUM_CHARACTERS_FOR_SEARCH) {
                setIsSearchBarLoading(true);
                setLoadingFirstPage(true);
                loadPage(0, searchText, true);
            }
            else {
                setSearchMinCharError(true);
            }
        }
    };
    const searchHandler = (searchText) => {
        setSearchQuery(searchText);
    };
    const getContentHeight = () => {
        return listHeight !== null && listHeight !== void 0 ? listHeight : 290;
    };
    const renderSearchBar = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_SearchBar__WEBPACK_IMPORTED_MODULE_11__["default"], { i18n: i18n, refreshListHandler: refreshQueueList, searchHandler: searchHandler, loading: isSearchBarLoading, isListEmpty: isSearchBarLoading }));
    };
    const renderMinCharSearchError = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "search-block-error modal-content-height" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "search-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "info-badge-filled", iconSet: "momentumDesign", size: "16", class: "search-error-info" }), i18n.searchMinCharError] })) })));
    };
    const renderLoader = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "infinite-scroll-spinner-modal", "data-testid": "list-loading-spinner" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "56" }) })));
    };
    const renderNoRecordFound = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "no-record modal-content-height" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_4__["default"], { illustrationType: "empty-result" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-label": i18n.noRecordFound, className: "no-record-found" }, { children: i18n.noRecordFound }))] })));
    };
    const renderListError = () => {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_6__["default"], { onRetry: () => loadFirstPage(), trackingId: loadingFirstPageError.trackingId });
    };
    const renderQueueList = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_5__["default"], Object.assign({ innerElementType: "ul", data: queueList, height: getContentHeight(), itemHeight: ItemHeight, onSelectValue: onQueueSelectFromList, infiniteScrollEnabled: true, loadNextPage: loadNextPage, hasNextPage: hasNextPage, isNextPageLoading: isNextPageLoading, ariaLabel: transferModal.comboBoxAriaLabelQueue, pageFetchError: pageFetchError }, { children: (props) => {
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_ListItem__WEBPACK_IMPORTED_MODULE_10__["default"], Object.assign({}, props, { title: props.data.name, searchQuery: searchQuery }));
            } })));
    };
    const isShowLoader = () => {
        return loadingFirstPage && !loadingFirstPageError.error && !searchMinCharError;
    };
    const isLoaded = () => {
        return !loadingFirstPage && !loadingFirstPageError.error && !searchMinCharError;
    };
    const renderErrorMessage = () => {
        return isLoaded() ? renderNoRecordFound() : renderListError();
    };
    const renderError = () => {
        return searchMinCharError ? renderMinCharSearchError() : renderErrorMessage();
    };
    const isShowQueueList = () => {
        return isLoaded() && queueList.length > 0;
    };
    const renderQueueSection = () => {
        return isShowQueueList() ? renderQueueList() : renderError();
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "transfer-to-div" }, { children: [renderSearchBar(), renderTransferModalError && renderTransferModalError(), isShowLoader() ? renderLoader() : renderQueueSection()] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QueueList);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/TransferModal/styles.css":
/*!****************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/TransferModal/styles.css ***!
  \****************************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../../node_modules/css-loader/dist/cjs.js!./styles.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/components/TransferModal/styles.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/InteractionControl/components/index.tsx":
/*!*************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/components/index.tsx ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-mfe-wc-based */ "@agentx/agentx-mfe-wc-based");
/* harmony import */ var _agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _i18n_messages_en__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../i18n/messages/en */ "./src/i18n/messages/en.js");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Common/components/ErrorModal */ "./src/direflow-components/Common/components/ErrorModal/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _InteractionPopoverManager_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../InteractionPopoverManager/constants */ "./src/direflow-components/InteractionPopoverManager/constants.ts");
/* harmony import */ var _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Utility/Utils/InteractionControlUtils */ "./src/direflow-components/Utility/Utils/InteractionControlUtils.ts");
/* harmony import */ var _Utility_Utils_services_BargeIn__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Utility/Utils/services/BargeIn */ "./src/direflow-components/Utility/Utils/services/BargeIn.ts");
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _interactionHelpers_Recording__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../interactionHelpers/Recording */ "./src/direflow-components/InteractionControl/interactionHelpers/Recording.ts");
/* harmony import */ var _reducer__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../reducer */ "./src/direflow-components/InteractionControl/reducer.ts");
/* harmony import */ var _styles_Accordion_css__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../styles/Accordion.css */ "./src/direflow-components/InteractionControl/styles/Accordion.css");
/* harmony import */ var _styles_Accordion_css__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_styles_Accordion_css__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _css_common_css__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./../../../css/common.css */ "./src/css/common.css");
/* harmony import */ var _css_common_css__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_css_common_css__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _Accordion_Accordion__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./Accordion/Accordion */ "./src/direflow-components/InteractionControl/components/Accordion/Accordion.tsx");
/* harmony import */ var _TransferModal_TransferModalContent__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./TransferModal/TransferModalContent */ "./src/direflow-components/InteractionControl/components/TransferModal/TransferModalContent.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






















/**
 * @element agentx-react-interaction-control
 * @param interaction
 * @param buttons
 * @param agentConfig
 * @fires ax-interaction-end, ax-interaction-hold, ax-interaction-resume
 * @fires ax-interaction-modal-toggled
 */
const InteractionControl = ({ interaction, agentconfig, wrapUpData, agentWrapUpCodeProps, cadStatus, callpersistence, isVoiceInteraction, isVoiceIntPaneUpdatedByUser, currentRoute, isConsultView, enableSubmitForTesting, decryptedState, retryDecryption, buttonDisableState, isSecureCADVariablesEnabled, epDnMapping, addressBook, isDesktopConsultToEntryPointDnEnabled, isDarkMode, isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled, isAddressBookInfiniteScrollEnabled, isWxccMultiPartyConfEnabled, isDesktopConferenceRecordingEnabled, isCallMuted, isDesktopAuxCodesInfiniteScrollEnabled }) => {
    var _a, _b, _c, _d, _e, _f;
    /**
     * This needs to be set on first load itself when state is CONNECTED and
     * it should not change till wrap completes.
     */
    const [interactionTimer, setInteractionTimer] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)((interaction === null || interaction === void 0 ? void 0 : interaction.timeStamp) || luxon__WEBPACK_IMPORTED_MODULE_4__.DateTime.utc().toMillis());
    const [currentStateTimer, setCurrentStateTimer] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(luxon__WEBPACK_IMPORTED_MODULE_4__.DateTime.utc().toMillis());
    const { agentId } = agentconfig;
    /**
     * Transfer / Consult modal
     */
    const [showModal, setShowModal] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [agentAction, setAgentAction] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [destinationQueueId, setDestinationQueueId] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [isCtqInProgress, setCtqInProgress] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(interaction === null || interaction === void 0 ? void 0 : interaction.ctqInProgress);
    const [agentActionType, setAgentActionType] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(interaction.destAgentType === "DN" ? _Common_constants__WEBPACK_IMPORTED_MODULE_10__.DIAL_NUMBER : "");
    const [showCtqErrorMessage, setShowCtqErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [eTrackingId, setEtrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [errorModalState, setErrorModalState] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const autoResumeInterval = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(-1);
    const [focusOnInteractionButton, setFocusOnInteractionButton] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const openModalAfterRecordingResume = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)();
    const contactStatusRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)("-");
    const windowOpenPlaceholderRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const muteUnmuteTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const windowPlaceholderUpdateTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const dataSetsToUnsubscribe = [];
    /**
     * For dispatching event to Agentx.
     */
    const dispatchEvent = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.EventContext);
    const dispatchCustomEvent = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.EventContext);
    /**
     * define contactInformation
     */
    const [contactInformation] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(interaction);
    const [showLoaderButtonType, setShowLoaderButtonType] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const updateButtonProgressFlag = (buttonType) => {
        setShowLoaderButtonType(buttonType);
    };
    const updateContactDataInInteraction = (selectedContactData) => {
        var _a, _b, _c;
        if (selectedContactData) {
            const updateInteractionWithRTD = {};
            updateInteractionWithRTD.monitoringOwnerName = (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.getName)(selectedContactData);
            updateInteractionWithRTD.contactPhoneNumber = selectedContactData.contactDirection
                ? selectedContactData.contactDirection === _constants__WEBPACK_IMPORTED_MODULE_15__.INBOUND
                    ? selectedContactData.origin
                    : selectedContactData.destination
                : "-";
            updateInteractionWithRTD.contactQueue = selectedContactData.queueName ? selectedContactData.queueName : "-";
            if (agentconfig.isWxccMultiPartyConfEnabled) {
                updateInteractionWithRTD.participants = selectedContactData.eventName
                    ? (_a = (0,_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__.getParticipantsDetails)(selectedContactData, selectedContactData.eventName, agentconfig.isWxccMultiPartyConfEnabled, agentconfig.agentDBId)) === null || _a === void 0 ? void 0 : _a.participants
                    : "-";
            }
            else {
                updateInteractionWithRTD.activeParticipants = selectedContactData.eventName
                    ? (_b = (0,_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__.getParticipantsDetails)(selectedContactData, selectedContactData.eventName, agentconfig.isWxccMultiPartyConfEnabled, agentconfig.agentDBId)) === null || _b === void 0 ? void 0 : _b.activeParticipantsName
                    : "-";
                updateInteractionWithRTD.consultedParticipant = selectedContactData.eventName
                    ? (_c = (0,_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__.getParticipantsDetails)(selectedContactData, selectedContactData === null || selectedContactData === void 0 ? void 0 : selectedContactData.eventName, agentconfig.isWxccMultiPartyConfEnabled, agentconfig.agentDBId)) === null || _c === void 0 ? void 0 : _c.consultedParticipantName
                    : "-";
            }
            updateInteractionWithRTD.recording = selectedContactData.recording === "true" ? "On" : "Off";
            if (dispatchEvent) {
                dispatchEvent(new CustomEvent("monitor-interaction-owner", {
                    detail: updateInteractionWithRTD.monitoringOwnerName,
                    bubbles: true,
                    composed: true
                }));
            }
            dispatch({
                type: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.UPDATE_RTD_DATA,
                payload: {
                    interaction: updateInteractionWithRTD,
                    agentId
                }
            });
        }
    };
    const updateChannelDataInInteraction = (selectedChannelData) => {
        if (selectedChannelData) {
            const updateInteractionWithRTD = {};
            updateInteractionWithRTD.contactStatus = selectedChannelData.contactStatus
                ? selectedChannelData.contactStatus
                : "-";
            updateInteractionWithRTD.timeInContactStatus = selectedChannelData.contactStatusTimestamp
                ? selectedChannelData.contactStatusTimestamp.toString()
                : "-";
            updateInteractionWithRTD.totalContactDuration = selectedChannelData.contactIngestionTimestamp
                ? selectedChannelData.contactIngestionTimestamp.toString()
                : "-";
            updateInteractionWithRTD.agentInteractionTime = (0,_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__.getAgentInteractionTime)(selectedChannelData, updateInteractionWithRTD.contactStatus);
            dispatch({
                type: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.UPDATE_RTD_DATA,
                payload: {
                    interaction: updateInteractionWithRTD,
                    agentId
                }
            });
        }
    };
    const interactionButtonsPayload = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(() => {
        return {
            buttons: (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.getInteractionButtons)(interaction.mediaType, agentconfig, interaction.contactDirection, interaction.isBargedIn)
        };
    }, [_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.getInteractionButtons, interaction.mediaType, agentconfig, interaction.contactDirection, interaction.isBargedIn]);
    /**
     * will change whenever the buttons props updates
     */
    const interactionButtons = interactionButtonsPayload().buttons;
    const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useReducer)(_reducer__WEBPACK_IMPORTED_MODULE_17__.InteractionControlReducer, {
        interaction: contactInformation,
        buttons: interactionButtons,
        isMPCEnabled: (_a = agentconfig === null || agentconfig === void 0 ? void 0 : agentconfig.isWxccMultiPartyConfEnabled) !== null && _a !== void 0 ? _a : false,
        isPersistCallEnabled: (_b = agentconfig === null || agentconfig === void 0 ? void 0 : agentconfig.isWxccPersistCallEnabled) !== null && _b !== void 0 ? _b : false,
        isDesktopConferenceRecordingEnabled: isDesktopConferenceRecordingEnabled !== null && isDesktopConferenceRecordingEnabled !== void 0 ? isDesktopConferenceRecordingEnabled : false,
        isAllowConfTransferToEpDnEnabled: (_c = agentconfig === null || agentconfig === void 0 ? void 0 : agentconfig.isAllowConfTransferToEpDnEnabled) !== null && _c !== void 0 ? _c : false,
        isCallMuted: isCallMuted !== null && isCallMuted !== void 0 ? isCallMuted : false,
        isConferenceTransferEnabled: (_d = agentconfig === null || agentconfig === void 0 ? void 0 : agentconfig.isConferenceTransferEnabled) !== null && _d !== void 0 ? _d : false,
        isConsultPanelVisualUpdateEnabled: (_e = agentconfig === null || agentconfig === void 0 ? void 0 : agentconfig.isWxccPersistConsultEnabled) !== null && _e !== void 0 ? _e : false
    });
    const requestConference = (detail, interaction) => {
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.agentConference)(interaction, dispatchCustomEvent, "ax-interaction-conference", agentId, detail, updateButtonProgressFlag, (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.getAgentActionType)(interaction));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        const showModalToggleEvent = new CustomEvent("ax-interaction-modal-toggled", {
            detail: {
                isInteractionModelOpen: showModal,
                interactionId: interaction.interactionId
            },
            bubbles: true,
            composed: true
        });
        if (dispatchEvent) {
            dispatchEvent(showModalToggleEvent);
        }
    }, [showModal]);
    const getConsultButtonUpdate = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(() => {
        return (state.buttons &&
            state.buttons.map((button) => {
                if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONSULT_BUTTON && agentconfig.isWxccMultiPartyConfEnabled) {
                    button.disabled = !interaction.isConsultEnabledForMPC;
                }
                return button;
            }));
    }, [interaction.isConsultEnabledForMPC, agentconfig.isWxccMultiPartyConfEnabled]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if (agentconfig.isWxccMultiPartyConfEnabled && interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE) {
            //enabling consult button in case of MPC
            dispatch({
                type: _constants__WEBPACK_IMPORTED_MODULE_15__.UPDATE_MPC_FLAG,
                payload: { interaction, buttons: getConsultButtonUpdate() }
            });
        }
    }, [interaction.isConsultEnabledForMPC, agentconfig.isWxccMultiPartyConfEnabled]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        var _a, _b, _c;
        if (interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE) {
            dispatch({
                type: _constants__WEBPACK_IMPORTED_MODULE_15__.UPDATE_INTERACTION_BUTTONS,
                payload: Object.assign(Object.assign({}, interactionButtonsPayload()), { isMPCEnabled: (_a = agentconfig.isWxccMultiPartyConfEnabled) !== null && _a !== void 0 ? _a : false, isPersistCallEnabled: (_b = agentconfig.isWxccPersistCallEnabled) !== null && _b !== void 0 ? _b : false, isDesktopConferenceRecordingEnabled: isDesktopConferenceRecordingEnabled !== null && isDesktopConferenceRecordingEnabled !== void 0 ? isDesktopConferenceRecordingEnabled : false, isAllowConfTransferToEpDnEnabled: (_c = agentconfig === null || agentconfig === void 0 ? void 0 : agentconfig.isAllowConfTransferToEpDnEnabled) !== null && _c !== void 0 ? _c : false, isCallMuted: isCallMuted !== null && isCallMuted !== void 0 ? isCallMuted : false })
            });
        }
    }, [agentconfig.isendcallenabled, agentconfig.isEndConsultEnabled]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        var _a, _b, _c, _d, _e;
        // Required since props update is not synchronous .
        const status = interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.CHAT || interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.SOCIAL
            ? (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.getStatusForChatInteraction)(interaction)
            : (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.getStatusFromInteraction)(interaction, isConsultView, agentconfig.isWxccMultiPartyConfEnabled);
        if (((_a = state === null || state === void 0 ? void 0 : state.buttons) === null || _a === void 0 ? void 0 : _a.length) === 0 || state.interaction.mediaType !== interaction.mediaType) {
            dispatch({
                type: _constants__WEBPACK_IMPORTED_MODULE_15__.UPDATE_INTERACTION_BUTTONS,
                payload: Object.assign(Object.assign({}, interactionButtonsPayload()), { isMPCEnabled: (_b = agentconfig.isWxccMultiPartyConfEnabled) !== null && _b !== void 0 ? _b : false, isPersistCallEnabled: (_c = agentconfig.isWxccPersistCallEnabled) !== null && _c !== void 0 ? _c : false, isDesktopConferenceRecordingEnabled: isDesktopConferenceRecordingEnabled !== null && isDesktopConferenceRecordingEnabled !== void 0 ? isDesktopConferenceRecordingEnabled : false, isAllowConfTransferToEpDnEnabled: (_d = agentconfig === null || agentconfig === void 0 ? void 0 : agentconfig.isAllowConfTransferToEpDnEnabled) !== null && _d !== void 0 ? _d : false, isCallMuted: isCallMuted !== null && isCallMuted !== void 0 ? isCallMuted : false })
            });
        }
        if ((0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.isPrimaryAgentInitiatedChatConsult)(status, interaction)) {
            setShowModal(false);
        }
        updateButtonProgressFlag("");
        if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.SILENTMONITORING) {
            dispatch({
                type: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.SILENTMONITORING,
                payload: Object.assign({ interaction,
                    agentId }, interactionButtonsPayload())
            });
            setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.MONITORINGHELD_BUTTON);
        }
        else if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MONITORINGHELD) {
            dispatch({
                type: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MONITORINGHELD,
                payload: Object.assign({ interaction,
                    agentId }, interactionButtonsPayload())
            });
        }
        else if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MONITORINGUNHELD) {
            dispatch({
                type: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MONITORINGUNHELD,
                payload: Object.assign({ interaction,
                    agentId }, interactionButtonsPayload())
            });
        }
        else if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.BARGEIN) {
            dispatch({
                type: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.BARGEIN,
                payload: Object.assign(Object.assign({ interaction,
                    agentId }, interactionButtonsPayload()), { isWebRTCMonitoring: (_e = ((agentconfig === null || agentconfig === void 0 ? void 0 : agentconfig.isWebRTCEnabled) && (agentconfig === null || agentconfig === void 0 ? void 0 : agentconfig.deviceType) === _InteractionPopoverManager_constants__WEBPACK_IMPORTED_MODULE_11__.BROWSER)) !== null && _e !== void 0 ? _e : false })
            });
        }
        else {
            dispatch({
                type: status,
                payload: { interaction, agentId }
            });
        }
    }, [interaction, agentconfig.agentId, agentconfig.isendcallenabled, agentconfig.isBargeInEnabled]);
    const recordingEvent = (response, detail, type) => {
        const eventDetail = response === _constants__WEBPACK_IMPORTED_MODULE_15__.SUCCESS
            ? { type: detail.type.toLowerCase(), interactionId: detail.interactionId, response }
            : detail;
        const event = new CustomEvent(type, {
            detail: eventDetail,
            bubbles: true,
            composed: true
        });
        if (dispatchEvent) {
            dispatchEvent(event);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if (interaction.destAgentType) {
            setAgentActionType((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.getAgentActionType)(interaction));
        }
    }, [interaction.destAgentType]);
    const setEmptyFocusOnInteractionButton = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(() => {
        setFocusOnInteractionButton("");
    }, []);
    // unmounting of component
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        const dispatchCaller = function (resp, eventName) {
            (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.dispatchCustomInteractionEvent)({
                response: _constants__WEBPACK_IMPORTED_MODULE_15__.SUCCESS,
                thisEvent: { type: resp.type, interactionId: resp.data.interactionId },
                eventName,
                dispatchCustomEvent
            });
            updateCtqInProgress(false);
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`Interaction Event: `, resp);
        };
        const consultEndListener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentConsultEnded.listen((resp) => {
            dispatchCaller(resp, "ax-interaction-consult-end");
        });
        const consultConferenceEndListener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentConsultConferenceEnded.listen((resp) => {
            dispatchCaller(resp, "ax-interaction-consult-end");
        });
        const cancelctqlistener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentCtqCancelled.listen((resp) => {
            (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.dispatchCustomInteractionEvent)({
                response: _constants__WEBPACK_IMPORTED_MODULE_15__.SUCCESS,
                thisEvent: { type: resp.type, interactionId: resp.data.interactionId },
                eventName: "ax-interaction-cancel-ctq",
                dispatchCustomEvent
            });
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`Interaction Event: `, resp);
            handleCloseModal(false);
            setCtqInProgress(false);
        });
        const holdListener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentContactHeld.listen((resp) => {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`Interaction Event: `, resp);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_util.trackHoldEvents({
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_HOLD_ACTIVATED,
                interactionId: resp.data.interactionId,
                mediaType: resp.data.interaction.mediaType,
                ani: resp.data.interaction.callProcessingDetails.ani,
                contactDirection: resp.data.interaction.contactDirection.type,
                timeEvent: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_ACTIVATED
            });
            (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.dispatchCustomInteractionEvent)({
                response: _constants__WEBPACK_IMPORTED_MODULE_15__.SUCCESS,
                thisEvent: { type: resp.type, interactionId: resp.data.interactionId },
                eventName: "ax-interaction-hold",
                dispatchCustomEvent
            });
        });
        const unholdlistener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentContactUnHeld.listen((resp) => {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`Interaction Event: `, resp);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_util.trackHoldEvents({
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_ACTIVATED,
                interactionId: resp.data.interactionId,
                ani: resp.data.interaction.callProcessingDetails.ani,
                mediaType: state.interaction.mediaType,
                contactDirection: state.interaction.contactDirection
            });
            (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.dispatchCustomInteractionEvent)({
                response: _constants__WEBPACK_IMPORTED_MODULE_15__.SUCCESS,
                thisEvent: { type: resp.type, interactionId: resp.data.interactionId },
                eventName: "ax-interaction-resume",
                dispatchCustomEvent
            });
        });
        const resumelistener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eResumeRecording.listen((resp) => {
            if (openModalAfterRecordingResume &&
                openModalAfterRecordingResume.current &&
                openModalAfterRecordingResume.current.openModal) {
                openModalAfterRecordingResume.current.openModal();
                openModalAfterRecordingResume.current.openModal = null;
            }
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`Successfully resumed the recording: `, resp);
        });
        const pauselistener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.ePauseRecording.listen((resp) => {
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`Successfully paused the recording: `, resp);
            if (resp.data.interaction.callProcessingDetails.pauseResumeEnabled === "true" &&
                agentconfig.privacyShieldVisible === true &&
                resp.data.interaction.callProcessingDetails.pauseDuration &&
                resp.data.interaction.mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.MIDCALL_MONITORING) {
                const duration = parseInt(resp.data.interaction.callProcessingDetails.pauseDuration, 10);
                const autoResume = window.setTimeout(() => {
                    (0,_interactionHelpers_Recording__WEBPACK_IMPORTED_MODULE_16__.resumeRecording)({
                        type: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDINGRESUME.toLowerCase(),
                        interactionId: resp.data.interactionId,
                        mediaType: resp.data.interaction.mediaType
                    }, true, recordingEvent, updateButtonProgressFlag, resp.data.interaction.contactDirection.type, resp.data.interaction.callProcessingDetails.ani);
                }, duration * _constants__WEBPACK_IMPORTED_MODULE_15__.MILLISECONDS_IN_ONE_SECOND);
                autoResumeInterval.current = autoResume;
                setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDINGPAUSE_BUTTON);
            }
        });
        const consultTransferlistener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eConsultTransfer.listen((resp) => {
            (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.dispatchCustomInteractionEvent)({
                response: _constants__WEBPACK_IMPORTED_MODULE_15__.SUCCESS,
                thisEvent: { type: resp.type, interactionId: resp.data.interactionId },
                eventName: "ax-interaction-consult-transfer",
                dispatchCustomEvent
            });
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`consultTransfer: success for interactionId : ${resp.data.interactionId}`);
        });
        const ConsultConferencedListener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentConsultConferenced.listen((resp) => {
            if (resp.data.interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE) {
                (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.dispatchCustomInteractionEvent)({
                    response: _constants__WEBPACK_IMPORTED_MODULE_15__.SUCCESS,
                    thisEvent: { type: resp.type, interactionId: resp.data.interactionId },
                    eventName: "ax-interaction-conference",
                    dispatchCustomEvent
                });
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`Consult Interaction Event: `, resp);
            }
        });
        return () => {
            if (autoResumeInterval) {
                clearTimeout(autoResumeInterval.current);
            }
            if (resumelistener &&
                pauselistener &&
                consultTransferlistener &&
                ConsultConferencedListener &&
                unholdlistener &&
                consultConferenceEndListener &&
                cancelctqlistener &&
                holdListener &&
                consultEndListener &&
                consultConferenceEndListener) {
                resumelistener.stopListen();
                pauselistener.stopListen();
                consultTransferlistener.stopListen();
                ConsultConferencedListener.stopListen();
                unholdlistener.stopListen();
                holdListener.stopListen();
                cancelctqlistener.stopListen();
                consultEndListener.stopListen();
                consultConferenceEndListener.stopListen();
            }
        };
    }, []);
    const getMPCUpdateForMuteUnmute = () => {
        return agentconfig.isWxccMultiPartyConfEnabled
            ? (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.isAgentConsulting)(contactInformation, agentconfig.isWxccMultiPartyConfEnabled)
            : contactInformation.isOwner;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if (isConsultView && getMPCUpdateForMuteUnmute()) {
            return;
        }
        if (interaction.isCallMute !== undefined) {
            handleMuteUnmuteViewChanges(interaction.isCallMute ? _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MUTE : _Common_constants__WEBPACK_IMPORTED_MODULE_10__.UNMUTE);
        }
    }, [interaction.mediaType, interaction.isCallMute]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        return () => {
            if (muteUnmuteTimeoutIdRef.current) {
                window.clearTimeout(muteUnmuteTimeoutIdRef.current);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if (isConsultView) {
            return;
        }
        if (interaction.isRecorded && interaction.isRecordingPaused && interaction.isPauseResumeEnabled) {
            dispatch({
                type: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDINGRESUME
            });
        }
        if (interaction.isRecorded && !interaction.isRecordingPaused && interaction.isPauseResumeEnabled) {
            dispatch({
                type: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDINGPAUSE
            });
        }
        if (interaction.isRecordingPaused &&
            interaction.isPauseResumeEnabled &&
            agentconfig.privacyShieldVisible === true &&
            interaction.recordingPauseDuration &&
            autoResumeInterval.current === -1 &&
            interaction.mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.MIDCALL_MONITORING) {
            const duration = parseInt(interaction.recordingPauseDuration, 10);
            const autoResume = window.setTimeout(() => {
                clearRecordingInterval();
                (0,_interactionHelpers_Recording__WEBPACK_IMPORTED_MODULE_16__.resumeRecording)({
                    interactionId: interaction.interactionId,
                    type: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDINGRESUME.toLowerCase(),
                    mediaType: interaction.mediaType
                }, true, recordingEvent, updateButtonProgressFlag, interaction.contactDirection, interaction.ani);
            }, duration * _constants__WEBPACK_IMPORTED_MODULE_15__.MILLISECONDS_IN_ONE_SECOND);
            autoResumeInterval.current = autoResume;
        }
        if ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.getStatusFromInteraction)(interaction, isConsultView, agentconfig.isWxccMultiPartyConfEnabled) === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.WRAP_UP &&
            showModal) {
            setShowModal(false);
        }
    }, [interaction]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        const handleHoldResumeInteractionEvent = (event) => {
            const { callId, currentlyOnHold, isHeld } = event.detail;
            const detail = { interactionId: callId, type: isHeld ? "hold" : "resume" };
            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info("Processing hold/resume mercury event: currentlyOnHold-", currentlyOnHold, " isHeld-", isHeld);
            if (isHeld && !currentlyOnHold) {
                holdHandler(detail, interaction, agentconfig, false, setFocusOnInteractionButton);
            }
            else if (!isHeld && currentlyOnHold) {
                resumeHandler(detail, interaction, agentconfig, false, setFocusOnInteractionButton);
            }
        };
        window.addEventListener("holdResumeInteractionEvent", handleHoldResumeInteractionEvent);
        return () => {
            window.removeEventListener("holdResumeInteractionEvent", handleHoldResumeInteractionEvent);
        };
    }, [interaction]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if ((0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.isAgentConferencing)(interaction)) {
            //when agent is conferencing and not part of consult
            dispatch({
                type: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONFERENCE,
                payload: { interaction, buttons: interactionButtons, agentId: agentconfig.agentId }
            });
        }
    }, [interaction, agentconfig.agentId, interactionButtons]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        const status = interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE
            ? (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.getStatusFromInteraction)(interaction, isConsultView, agentconfig.isWxccMultiPartyConfEnabled)
            : (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.getStatusForChatInteraction)(interaction);
        const contactTimer = (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.getTimeStampForStatus)(interaction, status, isConsultView, agentconfig.agentCallMonitoringState, isWxccMultiPartyConfEnabled, agentconfig.isWxccPersistConsultEnabled) || luxon__WEBPACK_IMPORTED_MODULE_4__.DateTime.utc().toMillis();
        setCurrentStateTimer(contactTimer);
        setInteractionTimer((interaction === null || interaction === void 0 ? void 0 : interaction.timeStamp) || luxon__WEBPACK_IMPORTED_MODULE_4__.DateTime.utc().toMillis());
    }, [interaction, agentconfig.agentCallMonitoringState]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        const subscribeRTD = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            yield ((_a = window.wxcc) === null || _a === void 0 ? void 0 : _a.rtdwc.subscribe({
                datasetName: "wxcc.rtd.contactstats",
                update: (data) => {
                    if (data === null || data === void 0 ? void 0 : data.datasetValues) {
                        const telephonyData = data === null || data === void 0 ? void 0 : data.datasetValues.filter((contactData) => contactData.data.channelType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE &&
                            contactData.data.eventName !== _Common_constants__WEBPACK_IMPORTED_MODULE_10__.FLOW_ACTIVITY_EVENT);
                        const selectedInteraction = telephonyData.find((contactData) => contactData.data.interactionId === interaction.interactionId);
                        if (selectedInteraction === null || selectedInteraction === void 0 ? void 0 : selectedInteraction.data) {
                            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info("[App: InteractionControl] received selected contact data at time", performance.now());
                            const selectedInteractionData = Object.assign({}, selectedInteraction === null || selectedInteraction === void 0 ? void 0 : selectedInteraction.data);
                            updateContactDataInInteraction(selectedInteractionData);
                            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info("[App: InteractionControl] selected contact data", selectedInteractionData);
                        }
                    }
                },
                error: (err) => {
                    _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.error("[App: InteractionControl] Failed to load ContactStats Data ", err);
                }
            }).then((data) => {
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info("[App:TPW] subscribed ContactStats successfully", data);
                dataSetsToUnsubscribe.push(data);
            }).catch((err) => {
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.error("[App:TPW] Failed to subscribe ContactStats", err);
            }));
            yield ((_b = window.wxcc) === null || _b === void 0 ? void 0 : _b.rtdwc.subscribe({
                datasetName: "wxcc.rtd.agentchannelstatus",
                update: (data) => {
                    var _a;
                    if (data.datasetValues) {
                        const telephonyData = data.datasetValues.filter((channelData) => {
                            var _a, _b;
                            return channelData.data.channelType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE &&
                                ((_a = channelData.data) === null || _a === void 0 ? void 0 : _a.contactStatusTimestamp) &&
                                ((_b = channelData.data) === null || _b === void 0 ? void 0 : _b.contactStatusTimestamp) !== 0;
                        });
                        const selectedInteraction = telephonyData.find((channelData) => channelData.data.interactionId === interaction.interactionId);
                        if (selectedInteraction === null || selectedInteraction === void 0 ? void 0 : selectedInteraction.data) {
                            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info("[App: InteractionControl] received selected channel data at time", performance.now());
                            // creating new object only when interaction data is received to avoid unnecessary object creation
                            const selectedInteractionData = Object.assign({}, selectedInteraction === null || selectedInteraction === void 0 ? void 0 : selectedInteraction.data);
                            const contactStatus = (0,_agentx_agentx_mfe_wc_based__WEBPACK_IMPORTED_MODULE_1__.mapAgentContactStatus)(selectedInteractionData.contactStatus, (_a = contactStatusRef.current) !== null && _a !== void 0 ? _a : "");
                            selectedInteractionData.contactStatus = contactStatus;
                            updateChannelDataInInteraction(selectedInteractionData);
                            contactStatusRef.current = contactStatus !== null && contactStatus !== void 0 ? contactStatus : "";
                            _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info("[App: InteractionControl] selected channel data", selectedInteractionData);
                        }
                    }
                },
                error: (err) => {
                    _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.error("[App: InteractionControl] Failed to load AgentChannelStatus Data ", err);
                }
            }).then((data) => {
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info("[App: InteractionControl] subscribed AgentChannelStatus successfully", data);
                dataSetsToUnsubscribe.push(data);
            }).catch((err) => {
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.error("[App: InteractionControl] Failed to subscribe AgentChannelStatus", err);
            }));
        });
        if (interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.MIDCALL_MONITORING) {
            subscribeRTD();
        }
        return () => {
            dataSetsToUnsubscribe.forEach((dataSet) => {
                if (dataSet && dataSet.unsubscribe) {
                    dataSet.unsubscribe();
                }
            });
        };
    }, [interaction.mediaType]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if (showModal) {
            setShowModal(false);
        }
    }, [interaction.interactionId]);
    const endInteraction = (detail) => {
        var _a, _b, _c, _d, _e, _f;
        const isEndingFromNonPrimary = (agentconfig.isWxccMultiPartyConfEnabled || agentconfig.isWxccPersistCallEnabled) &&
            interaction.owner !== interaction.agentId;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_COMPLETED, [
            (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral,
            (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus,
            (_f = (_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _e === void 0 ? void 0 : _e.SERVICE_PROVIDERS) === null || _f === void 0 ? void 0 : _f.webex_business
        ]);
        clearRecordingInterval();
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.endingInteraction)(detail, dispatchCustomEvent, updateButtonProgressFlag, interaction.ani, interaction.mediaType, interaction.contactDirection, isEndingFromNonPrimary);
    };
    /**
     * Method to end the only consult.
     * @param detail
     */
    const endConsult = (detail, isConsult, isSecondaryEpDnAgent) => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_util.trackConsultEvent({
            eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_END_CLICKED,
            mediaType: state.interaction.mediaType,
            interactionId: state.interaction.interactionId,
            contactDirection: state.interaction.contactDirection,
            timeEvent: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_END_ACTIVATED
        });
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.endingConsult)(detail, dispatchCustomEvent, isConsult, isSecondaryEpDnAgent, updateButtonProgressFlag, updateCtqInProgress);
    };
    const updateCtqInProgress = (ctqFlag) => {
        setCtqInProgress(ctqFlag);
    };
    /**
     * Method to cancel consult to Queue initiated .
     * @param detail
     */
    const cancelCtq = (detail) => {
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.cancelCtqRequest)(detail, agentId, destinationQueueId, updateButtonProgressFlag, setCtqInProgress, setShowCtqErrorMessage, setEtrackingId);
        setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.TRANSFER_BUTTON);
    };
    const holdInteraction = (detail, interaction, onHoldCompleteFunc) => {
        var _a, _b;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_util.trackHoldEvents({
            eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_HOLD_CLICKED,
            interactionId: detail.interactionId,
            mediaType: interaction.mediaType,
            contactDirection: interaction.contactDirection,
            ani: interaction.ani,
            timeEvent: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_HOLD_ACTIVATED
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_HOLD_CLICKED, [
            (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus
        ]);
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.heldInteraction)(detail, isConsultView, dispatchCustomEvent, interaction, updateButtonProgressFlag, onHoldCompleteFunc);
    };
    const holdSilentMonitoring = (detail, interaction) => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.PAUSE_MONITORING_CLICKED, {
            interactionId: detail.interactionId,
            SupervisorId: agentconfig.agentId,
            Role: agentconfig.role
        });
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.heldSilentMonitoring)(dispatchCustomEvent, detail, interaction, updateButtonProgressFlag, agentconfig);
    };
    const startBargeIn = (detail, interaction) => {
        const telemetryData = {
            eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.BARGE_IN_CLICKED,
            interactionId: detail.interactionId,
            supervisorId: agentconfig.agentId,
            role: agentconfig.role,
            monitoringType: _Common_constants__WEBPACK_IMPORTED_MODULE_10__.BARGE_IN_MONITORING_STATE,
            agentId: interaction.owner
        };
        const bargeInParams = {
            detail,
            updateButtonProgressFlag,
            role: agentconfig.role,
            notificationTitle: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.bargeInFailedTitle,
            notificationData: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.bargeInFailedData,
            dispatchEvent
        };
        _Utility_Utils_services_BargeIn__WEBPACK_IMPORTED_MODULE_13__.bargeInService.track(telemetryData);
        _Utility_Utils_services_BargeIn__WEBPACK_IMPORTED_MODULE_13__.bargeInService.bargeIn(bargeInParams);
    };
    const unHoldSilentMonitoring = (detail, interaction) => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.RESUME_MONITORING_CLICKED, {
            interactionId: detail.interactionId,
            SupervisorId: agentconfig.agentId,
            Role: agentconfig.role
        });
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.unHeldSilentMonitoring)(dispatchCustomEvent, detail, state.interaction, updateButtonProgressFlag, agentconfig);
    };
    const resumeInteraction = (detail, interaction, onResumeCompleteFunc) => {
        var _a, _b;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_util.trackHoldEvents({
            eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_CLICKED,
            interactionId: detail.interactionId,
            mediaType: interaction.mediaType,
            ani: interaction.ani,
            contactDirection: interaction.contactDirection,
            timeEvent: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_ACTIVATED
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_CLICKED, [
            (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus
        ]);
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.resumingInteraction)(detail, isWxccMultiPartyConfEnabled, dispatchCustomEvent, interaction, updateButtonProgressFlag, onResumeCompleteFunc);
    };
    const endConsultInteraction = (detail, isConsult, isSecondaryEpDnAgent, isPersistCallOrMPCEnabled) => {
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.endingConference)(detail, dispatchCustomEvent, isConsult, isSecondaryEpDnAgent, updateButtonProgressFlag, isPersistCallOrMPCEnabled);
    };
    /**
     *  Consult/Conference Transfer
     */
    const requestConsultTransfer = (detail, interaction) => {
        const destinationTypeString = (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.getAgentActionType)(interaction) === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.DIAL_NUMBER ? ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.isEPorEPDN)(interaction === null || interaction === void 0 ? void 0 : interaction.destAgentType) ? _Common_constants__WEBPACK_IMPORTED_MODULE_10__.EP_DN : _Common_constants__WEBPACK_IMPORTED_MODULE_10__.DN) : "";
        const payload = {
            to: interaction.destAgentId || "",
            destinationType: destinationTypeString
                ? destinationTypeString === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.EP_DN
                    ? (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_8__.getDestAgentTypeForEporEPDN)()
                    : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.DESTINATION_TYPE.DIAL_NUMBER
                : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.DESTINATION_TYPE.AGENT
        };
        // This telemetry is to find the duration between the CONSULT button in the Consult Request modal to the TRANSFER button in the Interaction Control during a consulting stage
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CONSULT_CALL_TRANSFER, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.MEDIA_TYPE]: interaction.mediaType
        });
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.consultTransfer)(detail, payload, dispatchCustomEvent, updateButtonProgressFlag, interaction.state.toUpperCase() === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONSULTING);
    };
    const requestConferenceTransfer = (detail) => {
        (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.conferenceTransfer)(detail, dispatchCustomEvent, updateButtonProgressFlag);
    };
    const clearRecordingInterval = () => {
        if (interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE && interaction.isPauseResumeEnabled && autoResumeInterval) {
            clearTimeout(autoResumeInterval.current);
            autoResumeInterval.current = -1;
        }
    };
    /**
     * Method to close the modal and set some states while closing modal
     */
    const handleCloseModal = (ctqInProgressFlag) => {
        setShowModal(false);
        setCtqInProgress(ctqInProgressFlag);
        updateButtonProgressFlag("");
        setShowCtqErrorMessage(false);
        if (focusOnInteractionButton !== _Common_constants__WEBPACK_IMPORTED_MODULE_10__.ENDCONSULT_BUTTON) {
            setFocusOnInteractionButton(`${agentAction}_BUTTON`);
        }
    };
    const setDestinationQueue = (id) => {
        setDestinationQueueId(id);
    };
    const setModalForTransferAction = () => {
        // This telemetry is used to find create the event when the TRANSFER button in the Interaction Control is clicked
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.INTERACTION_TRANSFER_REQUEST_CLICKED, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.MEDIA_TYPE]: interaction.mediaType,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.MEDIA_CHANNEL]: interaction.mediaChannel
        });
        // This telemetry is used to find duration between TRANSFER Button Interaction Control to the TRANSFER Button in the Transfer Request modal
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_TRANSFER_CLICKED);
        clearRecordingInterval();
        setShowModal(true);
        setAgentAction(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.TRANSFER);
    };
    const setModalForConferenceAction = () => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.INTERACTION_CONFERENCE_REQUEST_CLICKED, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.MEDIA_TYPE]: interaction.mediaType,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.MEDIA_CHANNEL]: interaction.mediaChannel
        });
        setAgentAction(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONFERENCE);
    };
    const setModalForConsultAction = () => {
        // This telemetry is used to find create the event when the CONSULT button in the Interaction Control is clicked
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.INTERACTION_CONSULT_REQUEST_CLICKED, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.MEDIA_TYPE]: interaction.mediaType
        });
        // This telemetry is used to find the duration between CONSULT Button Interaction Control to the CONSULT Button in the Consult Request modal
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_CLICKED);
        clearRecordingInterval();
        setShowModal(true);
        setAgentAction(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONSULT);
    };
    const holdHandler = (detail, interaction, agentconfig, notifyWebex, setFocusOnInteractionButton) => {
        const onHoldCompleteFunc = () => {
            if (notifyWebex && agentconfig.webexCallingCallId && agentconfig.webexCallingCallId !== "") {
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info("Notifying Webex to hold call");
                window.dispatchEvent(new CustomEvent(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.AX_WEBEX_CALL_HOLD_RESUME, {
                    detail: { callId: agentconfig.webexCallingCallId, hold: true },
                    bubbles: true,
                    composed: true
                }));
            }
        };
        holdInteraction({
            type: detail.type.toLowerCase(),
            interactionId: detail.interactionId
        }, interaction, onHoldCompleteFunc);
        setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.RESUME_BUTTON);
    };
    const resumeHandler = (detail, interaction, agentconfig, notifyWebex, setFocusOnInteractionButton) => {
        const onResumeCompleteFunc = () => {
            if (notifyWebex && agentconfig.webexCallingCallId && agentconfig.webexCallingCallId !== "") {
                _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info("Notifying Webex to resume call");
                window.dispatchEvent(new CustomEvent(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.AX_WEBEX_CALL_HOLD_RESUME, {
                    detail: { callId: agentconfig.webexCallingCallId, hold: false },
                    bubbles: true,
                    composed: true
                }));
            }
        };
        resumeInteraction({
            type: detail.type.toLowerCase(),
            interactionId: detail.interactionId
        }, interaction, onResumeCompleteFunc);
        setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.HOLD_BUTTON);
    };
    const muteUnmuteHandler = () => {
        if (agentconfig.webexCallingCallId && agentconfig.webexCallingCallId !== "") {
            window.dispatchEvent(new CustomEvent(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.AX_WEBEX_CALL_MUTE_UNMUTE, {
                detail: { callId: agentconfig.webexCallingCallId },
                bubbles: true,
                composed: true
            }));
        }
        else {
            window.dispatchEvent(new CustomEvent(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.AX_WEB_CALL_MUTE_UNMUTE, {
                bubbles: true,
                composed: true
            }));
        }
    };
    const handleMuteUnmuteViewChanges = (type) => {
        updateButtonProgressFlag(type === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MUTE ? _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MUTE_BUTTON : _Common_constants__WEBPACK_IMPORTED_MODULE_10__.UNMUTE_BUTTON);
        setFocusOnInteractionButton(type === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MUTE ? _Common_constants__WEBPACK_IMPORTED_MODULE_10__.UNMUTE_BUTTON : _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MUTE_BUTTON);
        if (muteUnmuteTimeoutIdRef.current) {
            window.clearTimeout(muteUnmuteTimeoutIdRef.current);
        }
        muteUnmuteTimeoutIdRef.current = window.setTimeout(() => {
            updateButtonProgressFlag("");
            dispatch({
                type,
                payload: {
                    interaction,
                    buttons: state.buttons,
                    agentId: agentconfig.agentId,
                    isCallMuted
                }
            });
        }, _constants__WEBPACK_IMPORTED_MODULE_15__.TWO_HUNDRED_MS);
    };
    const getInteractionEvent = (detail, interaction) => {
        var _a, _b, _c, _d;
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`Emitted action ${detail.type}`);
        let action = (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.getAgentAction)(detail.type);
        if (isCtqInProgress) {
            action = "CANCELCTQ";
        }
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.logger.info(`${action} is clicked`);
        switch (action) {
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONSULT:
                if (interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE &&
                    interaction.isPauseResumeEnabled &&
                    interaction.isRecordingPaused) {
                    setAgentAction(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONSULT);
                    setErrorModalState(true);
                }
                else {
                    setModalForConsultAction();
                }
                setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.ENDCONSULT_BUTTON);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.ENDCONSULT:
            case _constants__WEBPACK_IMPORTED_MODULE_15__.EXIT: {
                const isPostCallConsult = (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.isPostCallConsultInProgress)(interaction) || (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.isPostCallConsultRequested)(interaction);
                endConsult({
                    type: detail.type,
                    interactionId: detail.interactionId
                }, interaction.state === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONSULT.toLowerCase() ||
                    interaction.state === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONSULTING.toLowerCase() ||
                    isPostCallConsult, interaction.isSecondaryEpDnAgent || false);
                setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONSULT_BUTTON);
                break;
            }
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CANCELCTQ:
                cancelCtq({
                    type: detail.type,
                    interactionId: detail.interactionId
                });
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.ENDMONITORING:
                (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.endMonitoring)(detail.interactionId, dispatchEvent);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.TRANSFER:
                if (interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE && interaction.state !== _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONNECTED.toLowerCase()) {
                    if (agentconfig.isConferenceTransferEnabled && (interaction === null || interaction === void 0 ? void 0 : interaction.isConferenceInProgress)) {
                        requestConferenceTransfer({
                            type: detail.type,
                            interactionId: detail.interactionId
                        });
                        return;
                    }
                    requestConsultTransfer(detail, interaction);
                }
                else if (interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE &&
                    interaction.isPauseResumeEnabled &&
                    interaction.isRecordingPaused) {
                    setAgentAction(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.TRANSFER);
                    setErrorModalState(true);
                }
                else {
                    setModalForTransferAction();
                }
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONFERENCE:
                if (interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MEDIA_TYPES.VOICE) {
                    requestConference(detail, interaction);
                }
                else {
                    setShowModal(true);
                    setModalForConferenceAction();
                }
                if (agentconfig.isWxccPersistCallEnabled || agentconfig.isWxccMultiPartyConfEnabled) {
                    setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.EXIT_CONFERENCE);
                }
                else {
                    setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.END_CONFERENCE_BUTTON);
                }
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.ENDCONFERENCE:
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.EXITCONFERENCE:
                endConsultInteraction({
                    type: detail.type,
                    interactionId: detail.interactionId
                }, interaction.state === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONSULT.toLowerCase(), interaction.isSecondaryEpDnAgent || false, agentconfig.isWxccPersistCallEnabled || agentconfig.isWxccMultiPartyConfEnabled);
                setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.CONFERENCE_BUTTON);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.END:
                endInteraction({
                    type: detail.type,
                    interactionId: detail.interactionId
                });
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDINGPAUSE:
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_util.trackCallRecordingEvent({
                    eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_PAUSE_RECORDING_CLICKED,
                    interactionId: detail.interactionId,
                    mediaType: interaction.mediaType,
                    contactDirection: interaction.contactDirection,
                    ani: interaction.ani,
                    timeEvent: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_PAUSE_RECORDING_ACTIVATED
                });
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_CACHE_KEYS.PAUSE_REC_START_TIME, new Date().getTime());
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_PAUSE_RECORDING_CLICKED, [
                    (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus
                ]);
                (0,_interactionHelpers_Recording__WEBPACK_IMPORTED_MODULE_16__.pauseRecording)({
                    type: detail.type.toLowerCase(),
                    interactionId: detail.interactionId,
                    mediaType: interaction.mediaType
                }, recordingEvent, updateButtonProgressFlag, interaction.contactDirection, interaction.ani);
                setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDINGRESUME_BUTTON);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDINGRESUME:
                if (autoResumeInterval) {
                    clearTimeout(autoResumeInterval.current);
                    autoResumeInterval.current = -1;
                }
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_util.trackCallRecordingEvent({
                    eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_RECORDING_CLICKED,
                    interactionId: detail.interactionId,
                    mediaType: interaction.mediaType,
                    contactDirection: interaction.contactDirection,
                    ani: interaction.ani,
                    timeEvent: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_RECORDING_ACTIVATED
                });
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_RECORDING_CLICKED, [
                    (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus
                ]);
                (0,_interactionHelpers_Recording__WEBPACK_IMPORTED_MODULE_16__.resumeRecording)({
                    type: detail.type.toLowerCase(),
                    interactionId: detail.interactionId,
                    mediaType: interaction.mediaType
                }, false, recordingEvent, updateButtonProgressFlag, interaction.contactDirection, interaction.ani);
                setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.RECORDINGPAUSE_BUTTON);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.HOLD:
                holdHandler(detail, interaction, agentconfig, true, setFocusOnInteractionButton);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.RESUME:
                resumeHandler(detail, interaction, agentconfig, true, setFocusOnInteractionButton);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MONITORINGHELD:
                holdSilentMonitoring({
                    type: detail.type.toLowerCase(),
                    interactionId: detail.interactionId
                }, interaction);
                setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.MONITORINGHELD_BUTTON);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MONITORINGUNHELD:
                unHoldSilentMonitoring({
                    type: detail.type.toLowerCase(),
                    interactionId: detail.interactionId
                }, interaction);
                setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.MONITORINGUNHELD_BUTTON);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.BARGEIN:
                startBargeIn({
                    type: detail.type.toLowerCase(),
                    interactionId: detail.interactionId
                }, interaction);
                setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.MONITORINGUNHELD_BUTTON);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.KEYPAD:
                updateButtonProgressFlag("");
                setFocusOnInteractionButton(_Common_constants__WEBPACK_IMPORTED_MODULE_10__.KEYPAD_BUTTON);
                break;
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.MUTE:
            case _Common_constants__WEBPACK_IMPORTED_MODULE_10__.UNMUTE:
                muteUnmuteHandler();
                break;
            default:
                break;
        }
    };
    const resumeRecordingCallback = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(() => {
        clearRecordingInterval();
        setErrorModalState(false);
        openModalAfterRecordingResume.current = {
            openModal: agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.TRANSFER ? setModalForTransferAction : setModalForConsultAction
        };
        (0,_interactionHelpers_Recording__WEBPACK_IMPORTED_MODULE_16__.resumeRecording)({
            type: "recordingresume",
            interactionId: state.interaction.interactionId,
            mediaType: state.interaction.mediaType
        }, false, recordingEvent, updateButtonProgressFlag, interaction.contactDirection, interaction.ani);
    }, [agentAction]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        windowPlaceholderUpdateTimeoutIdRef.current = window.setTimeout(() => {
            if (windowOpenPlaceholderRef.current) {
                windowOpenPlaceholderRef.current.innerHTML = `${state.interaction.mediaType} ${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.windowOpened}`;
            }
        }, 100);
        return () => {
            if (windowPlaceholderUpdateTimeoutIdRef.current) {
                window.clearTimeout(windowPlaceholderUpdateTimeoutIdRef.current);
            }
        };
    }, [state]);
    const errorModalCallback = () => {
        updateButtonProgressFlag("");
        setErrorModalState(false);
        setFocusOnInteractionButton(`${agentAction}_BUTTON`);
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.I18nProvider, Object.assign({ value: Object.assign({}, _i18n_messages_en__WEBPACK_IMPORTED_MODULE_7__["default"]) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.Styled, Object.assign({ styles: [(_styles_Accordion_css__WEBPACK_IMPORTED_MODULE_18___default()), (_css_common_css__WEBPACK_IMPORTED_MODULE_19___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ id: "interaction-control-id" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "interaction-control-wrapper" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "sr-only", ref: windowOpenPlaceholderRef, "aria-live": "polite", role: "alert" }), errorModalState && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_9__["default"], { showCloseButton: false, isOpen: errorModalState, noExitOnEsc: true, message: agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.TRANSFER
                                ? (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.errorOnPrvacyShieldForTransfer
                                : (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.errorOnPrvacyShieldForConsult, buttons: [
                                {
                                    label: agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.TRANSFER
                                        ? (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.cancelTransfer
                                        : (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.cancelConsult,
                                    color: "secondary",
                                    onClick: errorModalCallback,
                                    ariaLabel: agentAction === _Common_constants__WEBPACK_IMPORTED_MODULE_10__.TRANSFER
                                        ? (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.cancelTransfer
                                        : (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.cancelConsult
                                },
                                {
                                    label: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.resumerecording,
                                    onClick: resumeRecordingCallback,
                                    ariaLabel: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.resumerecording
                                }
                            ], modalHeader: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.privacyShield })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Accordion_Accordion__WEBPACK_IMPORTED_MODULE_20__["default"], Object.assign({ interactionTimer: interactionTimer, contactInformation: isConsultView ? interaction : state.interaction, isConsultView: isConsultView, currentStateTimer: currentStateTimer, interactionButtons: state === null || state === void 0 ? void 0 : state.buttons, cadSuppressedList: agentconfig.callVariablesSuppressed, configCadVariables: agentconfig.cadVariables, updateButtonProgressFlag: updateButtonProgressFlag, showLoaderButtonType: showLoaderButtonType, wrapUpData: wrapUpData, agentWrapUpCodeProps: agentWrapUpCodeProps, agentId: agentId, interactionId: state.interaction.interactionId, isSecondaryEpDnAgent: state.interaction.isSecondaryEpDnAgent, action: getInteractionEvent }, cadStatus, { isOpen: callpersistence.isOpen, isVoiceInteraction: isVoiceInteraction, isVoiceIntPaneUpdatedByUser: isVoiceIntPaneUpdatedByUser, currentRoute: currentRoute, focusOnInteractionButton: focusOnInteractionButton, decryptedState: decryptedState, retryDecryption: retryDecryption, buttonDisableState: buttonDisableState, isSecureCADVariablesEnabled: isSecureCADVariablesEnabled, isIMIGlobalVariablesEnabled: agentconfig.isIMIGlobalVariablesEnabled, isGlobalVariablesEnabled: agentconfig.isGlobalVariablesEnabled, isDarkMode: isDarkMode, isProgressiveCampaignEnabled: isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled: isProgressiveCampaign1NEnabled, dtmfValue: agentconfig.dtmfValue, agentCallMonitoringState: agentconfig.agentCallMonitoringState, isWxccMultiPartyConfEnabled: agentconfig.isWxccMultiPartyConfEnabled, isPersistCallEnabled: agentconfig.isWxccPersistCallEnabled, setEmptyFocusOnInteractionButton: setEmptyFocusOnInteractionButton, isDesktopAuxCodesInfiniteScrollEnabled: isDesktopAuxCodesInfiniteScrollEnabled, isInteractionBtnConfirmDialogEnabled: agentconfig.isInteractionBtnConfirmDialogEnabled, isConsultPanelVisualUpdateEnabled: agentconfig.isWxccPersistConsultEnabled, webexCallingCallId: agentconfig.webexCallingCallId })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ id: "interaction-control-transfer-modal" }, { children: showModal &&
                                (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_12__.getStatusFromInteraction)(interaction, isConsultView, agentconfig.isWxccMultiPartyConfEnabled) !==
                                    _Common_constants__WEBPACK_IMPORTED_MODULE_10__.WRAP_UP && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TransferModal_TransferModalContent__WEBPACK_IMPORTED_MODULE_21__["default"], { orgId: interaction.orgId, modal: showModal, agentAction: agentAction, agentActionType: setAgentActionType, handleCloseModal: handleCloseModal, mediaType: state.interaction.mediaType, interactionId: state.interaction.interactionId, reasonCode: state.interaction.reasonCode, config: agentconfig, enableQueue: (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_14__.isQueueEnabled)(state, agentAction, agentconfig.allowConsultToQueue), enableSubmitForTesting: enableSubmitForTesting, setDestinationQueue: setDestinationQueue, cancelCtq: cancelCtq, showCtqErrorMessage: showCtqErrorMessage, isCtqInProgress: isCtqInProgress, eTrackingId: eTrackingId, contactDirection: state.interaction.contactDirection, ani: state.interaction.ani, epDnMapping: epDnMapping, addressBook: addressBook, isDesktopConsultToEntryPointDnEnabled: isDesktopConsultToEntryPointDnEnabled, isAddressBookInfiniteScrollEnabled: isAddressBookInfiniteScrollEnabled, isWxccMultiPartyConfEnabled: agentconfig.isWxccMultiPartyConfEnabled, isWxccPersistCallEnabled: agentconfig.isWxccPersistCallEnabled, primaryMediaParticipants: (_f = interaction.primaryMediaParticipants) !== null && _f !== void 0 ? _f : {}, isDarkMode: isDarkMode, isConsultTransferInfiniteScrollEnabled: agentconfig.isConsultTransferInfiniteScrollEnabled })) }))] })) })) })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InteractionControl);


/***/ }),

/***/ "./src/direflow-components/InteractionControl/constants.js":
/*!*****************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/constants.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AGENT: () => (/* binding */ AGENT),
/* harmony export */   AGENT_DN: () => (/* binding */ AGENT_DN),
/* harmony export */   AGENT_NAME: () => (/* binding */ AGENT_NAME),
/* harmony export */   ANI: () => (/* binding */ ANI),
/* harmony export */   ANNOUNCEMENT_UPDATE: () => (/* binding */ ANNOUNCEMENT_UPDATE),
/* harmony export */   BOOLEAN: () => (/* binding */ BOOLEAN),
/* harmony export */   CONSULTREQUESTED: () => (/* binding */ CONSULTREQUESTED),
/* harmony export */   CONTACT_COMPLETED: () => (/* binding */ CONTACT_COMPLETED),
/* harmony export */   CUSTOMER_NAME: () => (/* binding */ CUSTOMER_NAME),
/* harmony export */   DATETIME: () => (/* binding */ DATETIME),
/* harmony export */   DECIMAL: () => (/* binding */ DECIMAL),
/* harmony export */   DEST_AGENT_NAME: () => (/* binding */ DEST_AGENT_NAME),
/* harmony export */   DEST_AGENT_PHONE_NUMBER: () => (/* binding */ DEST_AGENT_PHONE_NUMBER),
/* harmony export */   DN: () => (/* binding */ DN),
/* harmony export */   ERROR: () => (/* binding */ ERROR),
/* harmony export */   EXIT: () => (/* binding */ EXIT),
/* harmony export */   FC_DESKTOP_VIEW: () => (/* binding */ FC_DESKTOP_VIEW),
/* harmony export */   FIRST_PAGE: () => (/* binding */ FIRST_PAGE),
/* harmony export */   ICON: () => (/* binding */ ICON),
/* harmony export */   INBOUND: () => (/* binding */ INBOUND),
/* harmony export */   INTEGER: () => (/* binding */ INTEGER),
/* harmony export */   MILLISECONDS_IN_ONE_SECOND: () => (/* binding */ MILLISECONDS_IN_ONE_SECOND),
/* harmony export */   NAME: () => (/* binding */ NAME),
/* harmony export */   OWNER_NAME: () => (/* binding */ OWNER_NAME),
/* harmony export */   OWNER_PHONE_NUMBER: () => (/* binding */ OWNER_PHONE_NUMBER),
/* harmony export */   RONA_TIMEOUT: () => (/* binding */ RONA_TIMEOUT),
/* harmony export */   STRING: () => (/* binding */ STRING),
/* harmony export */   SUCCESS: () => (/* binding */ SUCCESS),
/* harmony export */   THREE_HUNDRED_MS: () => (/* binding */ THREE_HUNDRED_MS),
/* harmony export */   TIME_TO_REMOVE_MESSAGE: () => (/* binding */ TIME_TO_REMOVE_MESSAGE),
/* harmony export */   TWO_HUNDRED_MS: () => (/* binding */ TWO_HUNDRED_MS),
/* harmony export */   UPDATE_CONSULT_BUTTON: () => (/* binding */ UPDATE_CONSULT_BUTTON),
/* harmony export */   UPDATE_CONTACT_INFORMATION: () => (/* binding */ UPDATE_CONTACT_INFORMATION),
/* harmony export */   UPDATE_HELD_UNHELD: () => (/* binding */ UPDATE_HELD_UNHELD),
/* harmony export */   UPDATE_INTERACTION_BUTTONS: () => (/* binding */ UPDATE_INTERACTION_BUTTONS),
/* harmony export */   UPDATE_MPC_FLAG: () => (/* binding */ UPDATE_MPC_FLAG),
/* harmony export */   VIRTUAL_TEAM_NAME: () => (/* binding */ VIRTUAL_TEAM_NAME),
/* harmony export */   WRAPUP_COMPLETED: () => (/* binding */ WRAPUP_COMPLETED),
/* harmony export */   cadVariablesMap: () => (/* binding */ cadVariablesMap),
/* harmony export */   dialNumber: () => (/* binding */ dialNumber),
/* harmony export */   dialNumberOrEntryPoint: () => (/* binding */ dialNumberOrEntryPoint),
/* harmony export */   dialNumberSearch: () => (/* binding */ dialNumberSearch),
/* harmony export */   duplicateMCMVariables: () => (/* binding */ duplicateMCMVariables),
/* harmony export */   fcDesktopView: () => (/* binding */ fcDesktopView),
/* harmony export */   i18nMessages: () => (/* binding */ i18nMessages),
/* harmony export */   iconColor: () => (/* binding */ iconColor),
/* harmony export */   imiDigitalCustomerVariables: () => (/* binding */ imiDigitalCustomerVariables),
/* harmony export */   interactionControlButtons: () => (/* binding */ interactionControlButtons),
/* harmony export */   voiceCustomerVariables: () => (/* binding */ voiceCustomerVariables)
/* harmony export */ });
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");

/**
 * For internal state update on props change from parent container
 */
const UPDATE_CONTACT_INFORMATION = "UPDATE_CONTACT_INFORMATION";
const UPDATE_INTERACTION_BUTTONS = "UPDATE_INTERACTION_BUTTONS";
const UPDATE_MPC_FLAG = "UPDATE_MPC_FLAG";
const UPDATE_HELD_UNHELD = "UPDATE_HELD_UNHELD";
const UPDATE_CONSULT_BUTTON = "UPDATE_CONSULT_BUTTON";
const MILLISECONDS_IN_ONE_SECOND = 1000;
const TIME_TO_REMOVE_MESSAGE = 10000;
const SUCCESS = "success";
const ERROR = "error";

/**
 * Button icons
 */
const ICON = {
  ASSIGN_PRIVILEGE: "assign-privilege-bold",
  CANCEL: "cancel-bold",
  EXIT_ROOM: "exit-room-bold",
  DEVICE_IN_ROOM: "icon-device-in-room_16", //will be updated to webex-teams-bold
  DEVICE_IN_ROOM_END: "icon-device-in-room-end_16", // currently no equivalent
  DIALPAD: "dialpad-bold",
  MICROPHONE: "microphone-bold",
  MICROPHONE_MUTED: "microphone-muted-bold",
  PAUSE: "pause-bold",
  PLAY: "play-bold",
  HEADSET: "headset-bold",
  HEADSET_MUTED: "headset-muted-bold",
  RECORDING_PAUSED: "record-paused-bold",
  PLAY_CIRCLE: "play-circle-bold",
  ACTIVE_SPEAKER: "active-speaker-bold",
  SINGLE_NUMBER_REACH: "single-number-reach-bold"
};

const LEGACY_ICON_SET = "momentumUI";

/**
 * Buttons for different media types
 */
const interactionControlButtons = {
  chatControls: [
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON,
      icon: ICON.ASSIGN_PRIVILEGE,
      ariaLabel: "transfer"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON,
      icon: ICON.DEVICE_IN_ROOM,
      ariaLabel: "conference",
      iconSet: LEGACY_ICON_SET
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_CONFERENCE_BUTTON,
      icon: ICON.DEVICE_IN_ROOM_END,
      ariaLabel: "endconference",
      iconSet: LEGACY_ICON_SET
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON,
      icon: ICON.CANCEL,
      ariaLabel: "end"
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONFERENCE,
      icon: ICON.EXIT_ROOM,
      ariaLabel: "exitconference"
    }
  ],
  emailControls: [
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON,
      icon: ICON.ASSIGN_PRIVILEGE,
      ariaLabel: "transfer"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON,
      icon: ICON.CANCEL,
      ariaLabel: "end"
    }
  ],
  callControls: [
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.KEYPAD_BUTTON,
      icon: ICON.DIALPAD,
      ariaLabel: "keypad"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON,
      icon: ICON.MICROPHONE,
      ariaLabel: "mute"
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON,
      icon: ICON.MICROPHONE_MUTED,
      ariaLabel: "unmute"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON,
      icon: ICON.PAUSE,
      ariaLabel: "hold"
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON,
      icon: ICON.PLAY,
      ariaLabel: "resume"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON,
      icon: ICON.HEADSET,
      ariaLabel: "consult"
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON,
      icon: ICON.HEADSET_MUTED,
      ariaLabel: "endconsult"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON,
      icon: ICON.ASSIGN_PRIVILEGE,
      ariaLabel: "transfer"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON,
      icon: ICON.DEVICE_IN_ROOM,
      ariaLabel: "conference",
      iconSet: LEGACY_ICON_SET
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_CONFERENCE_BUTTON,
      icon: ICON.DEVICE_IN_ROOM_END,
      ariaLabel: "endconference",
      iconSet: LEGACY_ICON_SET
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONSULT,
      icon: ICON.EXIT_ROOM,
      ariaLabel: "exitconsult"
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONFERENCE,
      icon: ICON.EXIT_ROOM,
      ariaLabel: "exitconference"
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON,
      icon: ICON.RECORDING_PAUSED,
      ariaLabel: "pauserecording"
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGRESUME_BUTTON,
      icon: ICON.PLAY_CIRCLE,
      ariaLabel: "resumerecording"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON,
      icon: ICON.CANCEL,
      ariaLabel: "end"
    }
  ],
  monitoringControls: [
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MONITORINGHELD_BUTTON,
      icon: ICON.PAUSE,
      ariaLabel: "pauseMonitoring"
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MONITORINGUNHELD_BUTTON,
      icon: ICON.PLAY,
      ariaLabel: "resumeMonitoring"
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.WHISPER_COACH_BUTTON,
      icon: ICON.ACTIVE_SPEAKER,
      ariaLabel: "whisperCoach"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.BARGEIN_BUTTON,
      icon: ICON.SINGLE_NUMBER_REACH,
      ariaLabel: "bargeIn"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDMONITORING_BUTTON,
      icon: ICON.CANCEL,
      ariaLabel: "endMonitoring"
    }
  ],
  bargedInControls: [
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON,
      icon: ICON.MICROPHONE,
      ariaLabel: "mute"
    },
    {
      disabled: false,
      visible: false,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON,
      icon: ICON.MICROPHONE_MUTED,
      ariaLabel: "unmute"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDMONITORING_BUTTON,
      icon: ICON.CANCEL,
      ariaLabel: "endMonitoring"
    }
  ],
  digitalOutboundControls: [
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON,
      icon: ICON.ASSIGN_PRIVILEGE,
      ariaLabel: "transfer"
    },
    {
      disabled: false,
      visible: true,
      type: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON,
      icon: ICON.CANCEL,
      ariaLabel: "end"
    }
  ]
};

const i18nMessages = {
  title: "",
  heading: {
    chat: "",
    email: "",
    telephony: ""
  },
  queues: "",
  agents: "",
  placeholder: "",
  type: "",
  cancel: "",
  closeModal: ""
};

const cadVariablesMap = {
  CHAT: ["customerName", "ani", "virtualTeamName", "category", "additionalDetails"],
  EMAIL: ["customerName", "ani", "virtualTeamName"],
  VOICE: [],
  OUTDIAL_VOICE: [],
  SMS: ["virtualTeamName", "customerNumber", "sourceNumber"],
  FACEBOOK: ["customerName", "virtualTeamName", "sourcePage"],
  APPLE_BUSINESS_CHAT: ["customerName", "virtualTeamName"],
  GOOGLE_BUSINESS_CHAT: ["customerName", "virtualTeamName"],
  WHATSAPP: ["customerName", "virtualTeamName", "customerNumber", "sourceNumber"],
  CONSULT_VIEW: ["agent", "agentDnis"],
  // IMI Digital Channels will use CAD for interaction details. No fixed list as above.
  IMI_DIGITAL: [],
  MONITORING: [
    "contactPhoneNumber",
    "contactQueue",
    "activeParticipants",
    "consultedParticipant",
    "contactStatus",
    "timeInContactStatus",
    "agentInteractionTime",
    "totalContactDuration",
    "recording"
  ],
  MONITORING_MULTI_PARTY: [
    "contactPhoneNumber",
    "contactQueue",
    "participants",
    "contactStatus",
    "timeInContactStatus",
    "agentInteractionTime",
    "totalContactDuration",
    "recording"
  ]
};

// used to sort customer details from cadVariables for voice.
const voiceCustomerVariables = ["ani", "dn", "virtualTeamName", "ronaTimeout"];

const duplicateMCMVariables = ["ani", "virtualTeamName"];
// used to sort customer details from cadVariables for imi digital channels.
const imiDigitalCustomerVariables = ["customerName", "ani", "dn", "virtualTeamName", "ronaTimeout"];

const AGENT_NAME = "agentName";
const NAME = "name";
const dialNumber = "DialNumber";
const dialNumberSearch = "DialNumberSearch";
const dialNumberOrEntryPoint = "DialNumberOrEntryPoint";
const EXIT = "EXIT";
const DN = "dn";
const ANI = "ani";
const VIRTUAL_TEAM_NAME = "virtualTeamName";
const OWNER_NAME = "ownerName";
const AGENT = "Agent";
const OWNER_PHONE_NUMBER = "ownerPhoneNumber";
const AGENT_DN = "Agent DN";
const DEST_AGENT_NAME = "destAgentName";
const DEST_AGENT_PHONE_NUMBER = "destAgentPhoneNumber";
const CUSTOMER_NAME = "customerName";
const CONSULTREQUESTED = "consult";
const BOOLEAN = "BOOLEAN";
const STRING = "STRING";
const INTEGER = "INTEGER";
const DECIMAL = "DECIMAL";
const DATETIME = "DATETIME";
const RONA_TIMEOUT = "ronaTimeout";
const FC_DESKTOP_VIEW = "FC-DESKTOP-VIEW";
const fcDesktopView = "fcDesktopView";
const INBOUND = "inbound";
const CONTACT_COMPLETED = "contact-completed";
const WRAPUP_COMPLETED = "wrapup-completed";

const iconColor = {
  white: "white",
  gray_40: "gray-40",
  red: "red"
};

const TWO_HUNDRED_MS = 200;
const THREE_HUNDRED_MS = 300;

const ANNOUNCEMENT_UPDATE = "ax-announcement-update";

const FIRST_PAGE = 0;


/***/ }),

/***/ "./src/direflow-components/InteractionControl/interactionHelpers/Recording.ts":
/*!************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/interactionHelpers/Recording.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   pauseRecording: () => (/* binding */ pauseRecording),
/* harmony export */   resumeRecording: () => (/* binding */ resumeRecording)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");





const resumeRecording = (detail, autoResumedVal, recordingEvent, updateButtonProgressFlag, contactDirection, ani) => {
    const { interaction_control } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)();
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .resumeRecordingV2({
        interactionId: detail.interactionId,
        data: { autoResumed: autoResumedVal }
    })
        .then(() => {
        // do nothing
    })
        .catch((err) => {
        var _a, _b, _c, _d;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackCallRecordingEvent({
            eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_RECORDING_CLICKED,
            interactionId: detail.interactionId,
            mediaType: _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE,
            contactDirection,
            ani,
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            reasonForFailure: "ResumeRecordingError",
            reasonCode: err.reason
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_RECORDING_CLICKED, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            interactionId: detail.interactionId,
            media_type: _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE,
            Reason: "ResumeRecordingError"
        }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus]);
        recordingEvent(_constants__WEBPACK_IMPORTED_MODULE_3__.ERROR, {
            type: detail.type.toLowerCase(),
            interactionId: detail.interactionId,
            trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err),
            message: (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.getErrorMsgForReasonCode)((_d = (_c = err === null || err === void 0 ? void 0 : err.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || interaction_control.resumeRecordingFailed
        }, "ax-interaction-recording-resume-failed");
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=ResumeRecordingError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to Resume Recording: ${err}`, err);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackCallRecordingEvent({
            eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_RECORDING_ACTIVATED,
            interactionId: detail.interactionId,
            mediaType: _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE,
            contactDirection,
            ani,
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            reasonForFailure: "ResumeRecordingError",
            reasonCode: err.reason
        });
        updateButtonProgressFlag("");
    });
};
const pauseRecording = (detail, recordingEvent, updateButtonProgressFlag, contactDirection, ani) => {
    const { interaction_control } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)();
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .pauseRecordingV2({ interactionId: detail.interactionId })
        .then(() => {
        // do nothing
    })
        .catch((err) => {
        var _a, _b, _c, _d;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackCallRecordingEvent({
            eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_PAUSE_RECORDING_CLICKED,
            interactionId: detail.interactionId,
            mediaType: _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE,
            contactDirection,
            ani,
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            reasonForFailure: "PauseRecordingError",
            reasonCode: err.reason
        });
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_PAUSE_RECORDING_CLICKED, {
            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
            interactionId: detail.interactionId,
            media_type: _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE,
            Reason: "PauseRecordingError"
        }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus]);
        recordingEvent(_constants__WEBPACK_IMPORTED_MODULE_3__.ERROR, {
            type: detail.type.toLowerCase(),
            interactionId: detail.interactionId,
            trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err),
            message: (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.getErrorMsgForReasonCode)((_d = (_c = err === null || err === void 0 ? void 0 : err.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || interaction_control.pauseRecordingFailed
        }, "ax-interaction-recording-pause-failed");
        updateButtonProgressFlag("");
        _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_4__.logger.error(`event=PauseRecordingError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to Pause Recording: ${err}`, err);
    });
};


/***/ }),

/***/ "./src/direflow-components/InteractionControl/reducer.ts":
/*!***************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/reducer.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CadVariablesUpdate: () => (/* binding */ CadVariablesUpdate),
/* harmony export */   InteractionControlReducer: () => (/* binding */ InteractionControlReducer),
/* harmony export */   getBargeInButtons: () => (/* binding */ getBargeInButtons),
/* harmony export */   getButtonUpdateForWrapupAssistAndPostCall: () => (/* binding */ getButtonUpdateForWrapupAssistAndPostCall),
/* harmony export */   getConferenceButtonForEpDnHoldResume: () => (/* binding */ getConferenceButtonForEpDnHoldResume),
/* harmony export */   getConnectedButtonUpdate: () => (/* binding */ getConnectedButtonUpdate),
/* harmony export */   getConsultPanelButtonUpdate: () => (/* binding */ getConsultPanelButtonUpdate),
/* harmony export */   getConsultRequestedButtonUpdate: () => (/* binding */ getConsultRequestedButtonUpdate),
/* harmony export */   getConsultUnheldAndHoldButtonUpdate: () => (/* binding */ getConsultUnheldAndHoldButtonUpdate),
/* harmony export */   getConsultingButtonForNonPrimaryAgent: () => (/* binding */ getConsultingButtonForNonPrimaryAgent),
/* harmony export */   getConsultingButtonUpdate: () => (/* binding */ getConsultingButtonUpdate),
/* harmony export */   getEpDnConsultPanelButtonUpdate: () => (/* binding */ getEpDnConsultPanelButtonUpdate),
/* harmony export */   getEpDnConsultingButtonUpdate: () => (/* binding */ getEpDnConsultingButtonUpdate),
/* harmony export */   getEpDnHoldButtonUpdate: () => (/* binding */ getEpDnHoldButtonUpdate),
/* harmony export */   getHoldButtonUpdate: () => (/* binding */ getHoldButtonUpdate),
/* harmony export */   getTransferButtonForEpDnHoldResume: () => (/* binding */ getTransferButtonForEpDnHoldResume),
/* harmony export */   initialState: () => (/* reexport safe */ _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_2__.initialState),
/* harmony export */   persistCallOrMPCCheck: () => (/* binding */ persistCallOrMPCCheck)
/* harmony export */ });
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Utility/Utils/InteractionControlUtils */ "./src/direflow-components/Utility/Utils/InteractionControlUtils.ts");
/* harmony import */ var _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./constants */ "./src/direflow-components/InteractionControl/constants.js");




const ICON_SET = "momentumDesign";
const HOLD_ICON = "pause-bold";
const HOLD_LABEL = "hold";
const isButtonDisabledForChat = (action) => {
    var _a, _b, _c, _d, _e, _f;
    if (((_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction) === null || _b === void 0 ? void 0 : _b.mediaType) === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.CHAT ||
        ((_d = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.interaction) === null || _d === void 0 ? void 0 : _d.mediaType) === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.SOCIAL ||
        (((_f = (_e = action.payload) === null || _e === void 0 ? void 0 : _e.interaction) === null || _f === void 0 ? void 0 : _f.outboundType) === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.OUTDIAL &&
            action.payload.interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.EMAIL)) {
        return action.payload.interaction.hasCustomerLeft || action.payload.interaction.isConvNotFound;
    }
    return false;
};
const isAmdDetectedInCallback = (interaction) => {
    return (interaction === null || interaction === void 0 ? void 0 : interaction.isAmdDetectedInCallback) === true;
};
const getVisualUpdateButton = (button, isVisible, buttonDisabled, iconString, ariaLabel) => {
    return Object.assign(Object.assign({}, button), { disabled: buttonDisabled, visible: isVisible, icon: iconString !== undefined ? iconString : button.icon, ariaLabel: ariaLabel !== undefined ? ariaLabel : button.ariaLabel });
};
const getConnectedButtonUpdate = (action, status, buttons, isConsultPanelVisualUpdateEnabled) => {
    var _a;
    const interaction = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction;
    const isMainCallOnHold = interaction === null || interaction === void 0 ? void 0 : interaction.isHold;
    const amdDetectedInCallback = isAmdDetectedInCallback(interaction);
    return buttons.map((button) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON ||
            (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON && status === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED.toLowerCase()) ||
            (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON && status !== _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED.toLowerCase()) ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.KEYPAD_BUTTON) {
            const endConsultUpdate = button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON && isConsultPanelVisualUpdateEnabled;
            buttonStatus = getVisualUpdateButton(button, !(button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON && isConsultPanelVisualUpdateEnabled), endConsultUpdate ? button.disabled : button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON ? amdDetectedInCallback : false);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: isButtonDisabledForChat(action) || amdDetectedInCallback, visible: true });
        }
        else if ((button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON && status !== _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED.toLowerCase()) ||
            (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON &&
                (((_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction) === null || _b === void 0 ? void 0 : _b.mediaType) === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.CHAT ||
                    ((_d = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.interaction) === null || _d === void 0 ? void 0 : _d.mediaType) === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.SOCIAL))) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true, disabled: isButtonDisabledForChat(action) });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON && isMainCallOnHold) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON && !isMainCallOnHold) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true, icon: HOLD_ICON, ariaLabel: HOLD_LABEL });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON && status === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED.toLowerCase()) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign({}, button);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONFERENCE &&
            ((_f = (_e = action.payload) === null || _e === void 0 ? void 0 : _e.interaction) === null || _f === void 0 ? void 0 : _f.isConferenceInProgress) &&
            !((_h = (_g = action.payload) === null || _g === void 0 ? void 0 : _g.interaction) === null || _h === void 0 ? void 0 : _h.isOwner)) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true });
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const persistCallOrMPCCheck = (button, isPersistCallOrMPCEnabled, isResumeEnabledOnConsultCompleted, interaction) => {
    if (isPersistCallOrMPCEnabled && (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_2__.isVoice)(interaction)) {
        return Object.assign(Object.assign({}, button), { disabled: isResumeEnabledOnConsultCompleted });
    }
    return Object.assign(Object.assign({}, button), { disabled: true });
};
const recordingButtonCheck = (button, isDesktopConferenceRecordingEnabled) => {
    return Object.assign(Object.assign({}, button), { disabled: !isDesktopConferenceRecordingEnabled });
};
const getConferenceButtonsForOwner = (interaction, buttons, isPersistCallOrMPCEnabled, isConsultEnabledForMPC, isDesktopConferenceRecordingEnabled, isResumeEnabledOnConsultCompleted) => {
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON && isConsultEnabledForMPC) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: isAmdDetectedInCallback(interaction), visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON) {
            buttonStatus = isResumeEnabledOnConsultCompleted
                ? Object.assign(Object.assign({}, button), { visible: false }) : Object.assign(Object.assign({}, button), { disabled: true, visible: true, icon: HOLD_ICON, ariaLabel: HOLD_LABEL });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON && isResumeEnabledOnConsultCompleted) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true, disabled: false });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.KEYPAD_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON) {
            buttonStatus = persistCallOrMPCCheck(button, isPersistCallOrMPCEnabled, isResumeEnabledOnConsultCompleted, interaction);
        }
        else if ((interaction === null || interaction === void 0 ? void 0 : interaction.mediaType) !== _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.VOICE && button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_CONFERENCE_BUTTON && (interaction === null || interaction === void 0 ? void 0 : interaction.mediaType) !== _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.VOICE) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
        }
        else if ((button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON && (interaction === null || interaction === void 0 ? void 0 : interaction.mediaType) === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.VOICE && !isPersistCallOrMPCEnabled) ||
            (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_CONFERENCE_BUTTON && !isPersistCallOrMPCEnabled)) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON ? isAmdDetectedInCallback(interaction) : false, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON) {
            buttonStatus = recordingButtonCheck(button, isDesktopConferenceRecordingEnabled);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign({}, button);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONFERENCE && isPersistCallOrMPCEnabled && (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_2__.isVoice)(interaction)) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: isResumeEnabledOnConsultCompleted, visible: true });
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getConferenceButtonupdate = (action, buttons, isMPCEnabled, isPersistCallEnabled, isDesktopConferenceRecordingEnabled, isCallMuted) => {
    var _a, _b, _c;
    // either only conference going on or conference + consult going(MPC case) on but consult not initiate by this agent
    const isPersistCallOrMPCEnabled = isMPCEnabled || isPersistCallEnabled;
    const interaction = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction;
    const isConsultEnabledForMPC = (_b = (isMPCEnabled && (interaction === null || interaction === void 0 ? void 0 : interaction.isConsultEnabledForMPC))) !== null && _b !== void 0 ? _b : false;
    const isRecordingVisible = (interaction === null || interaction === void 0 ? void 0 : interaction.isPauseResumeEnabled) && (interaction === null || interaction === void 0 ? void 0 : interaction.isRecorded);
    const isResumeEnabledOnConsultCompleted = (interaction === null || interaction === void 0 ? void 0 : interaction.state) === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_COMPLETED && isMPCEnabled && (interaction === null || interaction === void 0 ? void 0 : interaction.isHold);
    if (((_c = action.payload) === null || _c === void 0 ? void 0 : _c.agentId) && (interaction === null || interaction === void 0 ? void 0 : interaction.isOwner)) {
        return getConferenceButtonsForOwner(interaction, buttons, isPersistCallOrMPCEnabled, isConsultEnabledForMPC, isDesktopConferenceRecordingEnabled, isResumeEnabledOnConsultCompleted);
    }
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON && isPersistCallOrMPCEnabled) {
            if (isMPCEnabled) {
                buttonStatus = isConsultEnabledForMPC
                    ? Object.assign(Object.assign({}, button), { disabled: isAmdDetectedInCallback(interaction), visible: true }) : Object.assign(Object.assign({}, button), { disabled: true, visible: true });
            }
            else if (isPersistCallEnabled) {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: true });
            }
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON && isResumeEnabledOnConsultCompleted) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true, disabled: false });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON) {
            buttonStatus =
                isResumeEnabledOnConsultCompleted || !isPersistCallOrMPCEnabled
                    ? Object.assign(Object.assign({}, button), { visible: false }) : Object.assign(Object.assign({}, button), { visible: true, disabled: true, icon: HOLD_ICON, ariaLabel: HOLD_LABEL });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONFERENCE ||
            (isPersistCallOrMPCEnabled && button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON && (0,_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_2__.isVoice)(interaction))) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: isResumeEnabledOnConsultCompleted, visible: true });
        }
        else if (isPersistCallOrMPCEnabled && button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: !isDesktopConferenceRecordingEnabled, visible: isRecordingVisible });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON && isCallMuted) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true, disabled: false });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON && !isCallMuted) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true, disabled: false });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.KEYPAD_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getHoldButtonUpdate = (action, status, buttons, isPersistCallOrMPCEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled) => {
    var _a;
    const interaction = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction;
    const isPersistCallMPCOnHold = isPersistCallOrMPCEnabled && (interaction === null || interaction === void 0 ? void 0 : interaction.isHold);
    const isPersistCallMPCNotOnHold = isPersistCallOrMPCEnabled && !(interaction === null || interaction === void 0 ? void 0 : interaction.isHold);
    return buttons.map((button) => {
        var _a, _b;
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON) {
            const buttonIsVisible = _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.consultState.includes(status) && !isConsultPanelVisualUpdateEnabled;
            buttonStatus = getVisualUpdateButton(button, buttonIsVisible, buttonIsVisible ? button.disabled : false);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON) {
            if (isConsultPanelVisualUpdateEnabled) {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: true });
            }
            else if (isPersistCallOrMPCEnabled && status === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE.toLowerCase()) {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: false });
            }
            else {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: true });
            }
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON && _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.consultState.includes(status)) {
            buttonStatus = getVisualUpdateButton(button, true, isConsultPanelVisualUpdateEnabled && _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.consultState.includes(status));
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON) {
            const buttonDisabled = isConsultPanelVisualUpdateEnabled
                ? button.disabled
                : isPersistCallMPCOnHold && status === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE.toLowerCase();
            buttonStatus = getVisualUpdateButton(button, !(isConsultPanelVisualUpdateEnabled && _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.consultState.includes(status)), buttonDisabled);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON && isPersistCallMPCNotOnHold && status === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE.toLowerCase()) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: true });
        }
        else if ((button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON && !_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.consultState.includes(status)) || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.KEYPAD_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON ? isAmdDetectedInCallback(interaction) : false, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON) {
            buttonStatus =
                isPersistCallOrMPCEnabled &&
                    ((_b = (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.interaction) === null || _b === void 0 ? void 0 : _b.isConferenceInProgress) &&
                    !isConferenceTransferEnabled
                    ? Object.assign(Object.assign({}, button), { disabled: true, visible: false }) : Object.assign(Object.assign({}, button), { disabled: (isConsultPanelVisualUpdateEnabled && _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.consultState.includes(status)) ||
                        isAmdDetectedInCallback(interaction), visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON) {
            if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED.toLowerCase()) {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: false });
            }
            else if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING.toLowerCase()) {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: true });
            }
            else {
                buttonStatus = Object.assign({}, button);
            }
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign({}, button);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONFERENCE && status === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE.toLowerCase() && isPersistCallOrMPCEnabled) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getTransferButtonForEpDnHoldResume = (action, button, isMPCEnabled, isAllowConfTransferToEpDnEnabled, isConferenceTransferEnabled, EpDnConsultDestinationAgentJoined = false) => {
    var _a;
    const interaction = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction;
    if (isMPCEnabled && (interaction === null || interaction === void 0 ? void 0 : interaction.isConferenceInProgress) && !isConferenceTransferEnabled) {
        return Object.assign(Object.assign({}, button), { disabled: true, visible: false });
    }
    return Object.assign(Object.assign({}, button), { disabled: (!isAllowConfTransferToEpDnEnabled && !EpDnConsultDestinationAgentJoined) || isAmdDetectedInCallback(interaction), visible: true });
};
const getConferenceButtonForEpDnHoldResume = (button, isAllowConfTransferToEpDnEnabled, EpDnConsultDestinationAgentJoined = false) => {
    return Object.assign(Object.assign({}, button), { disabled: !isAllowConfTransferToEpDnEnabled && !EpDnConsultDestinationAgentJoined, visible: isAllowConfTransferToEpDnEnabled || EpDnConsultDestinationAgentJoined });
};
const getEpDnHoldButtonUpdate = (action, status, buttons, isMPCEnabled, isAllowConfTransferToEpDnEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled) => {
    var _a;
    const interaction = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction;
    const EpDnConsultDestinationAgentJoined = interaction === null || interaction === void 0 ? void 0 : interaction.EpDnConsultDestinationAgentJoined;
    return buttons.map((button) => {
        let buttonStatus;
        const consultPanelUpdate = isConsultPanelVisualUpdateEnabled && _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.consultState.includes(status);
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON) {
            const conferenceButton = getConferenceButtonForEpDnHoldResume(button, isAllowConfTransferToEpDnEnabled, EpDnConsultDestinationAgentJoined);
            buttonStatus = Object.assign(Object.assign({}, conferenceButton), { disabled: consultPanelUpdate ? true : conferenceButton.disabled });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON) {
            const transferButton = getTransferButtonForEpDnHoldResume(action, button, isMPCEnabled, isAllowConfTransferToEpDnEnabled, isConferenceTransferEnabled, EpDnConsultDestinationAgentJoined);
            buttonStatus = Object.assign(Object.assign({}, transferButton), { disabled: consultPanelUpdate ? true : transferButton.disabled });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON ||
            (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON && status === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED.toLowerCase()) ||
            (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON && status !== _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED.toLowerCase()) ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.KEYPAD_BUTTON) {
            if ((button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON) && consultPanelUpdate) {
                buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
            }
            else {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON ? isAmdDetectedInCallback(interaction) : false, visible: true });
            }
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON) {
            if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED.toLowerCase()) {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: false });
            }
            else if (status === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING.toLowerCase()) {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: true });
            }
            else {
                buttonStatus = Object.assign({}, button);
            }
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign({}, button);
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getRecordingPauseButtonUpdate = (buttons) => {
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGRESUME_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        else {
            buttonStatus = Object.assign({}, button);
        }
        return buttonStatus;
    });
};
const getRecordingResumeButtonUpdate = (buttons) => {
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGRESUME_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        else {
            buttonStatus = Object.assign({}, button);
        }
        return buttonStatus;
    });
};
const getConsultRequestedButtonUpdate = (action, buttons, isMPCEnabled, isConsultPanelVisualUpdateEnabled) => {
    return buttons.map((button) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON) {
            if ((_b = (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.interaction) === null || _b === void 0 ? void 0 : _b.isHold) {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: false });
            }
            else {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
            }
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON) {
            if (isConsultPanelVisualUpdateEnabled) {
                buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
            }
            else if (((_d = (_c = action === null || action === void 0 ? void 0 : action.payload) === null || _c === void 0 ? void 0 : _c.interaction) === null || _d === void 0 ? void 0 : _d.isHold) && ((_f = (_e = action === null || action === void 0 ? void 0 : action.payload) === null || _e === void 0 ? void 0 : _e.interaction) === null || _f === void 0 ? void 0 : _f.destAgentType) === "EpDn") {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
            }
            else if ((_h = (_g = action === null || action === void 0 ? void 0 : action.payload) === null || _g === void 0 ? void 0 : _g.interaction) === null || _h === void 0 ? void 0 : _h.isHold) {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: true });
            }
            else {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: false });
            }
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON && isConsultPanelVisualUpdateEnabled) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON) {
            buttonStatus =
                isMPCEnabled && ((_k = (_j = action === null || action === void 0 ? void 0 : action.payload) === null || _j === void 0 ? void 0 : _j.interaction) === null || _k === void 0 ? void 0 : _k.isConferenceInProgress)
                    ? Object.assign(Object.assign({}, button), { visible: false }) : Object.assign(Object.assign({}, button), { disabled: true, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.KEYPAD_BUTTON) {
            buttonStatus = getVisualUpdateButton(button, !(button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON && isConsultPanelVisualUpdateEnabled), false);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: false });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign({}, button);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONFERENCE &&
            isMPCEnabled &&
            ((_m = (_l = action === null || action === void 0 ? void 0 : action.payload) === null || _l === void 0 ? void 0 : _l.interaction) === null || _m === void 0 ? void 0 : _m.isConferenceInProgress)) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true, disabled: true });
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getEpDnConsultPanelButtonUpdate = (buttons, action, isAllowConfTransferToEpDnEnabled, isConferenceTransferEnabled) => {
    var _a, _b, _c;
    const EpDnConsultDestinationAgentJoined = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction) === null || _b === void 0 ? void 0 : _b.EpDnConsultDestinationAgentJoined;
    const interaction = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.interaction;
    const postCallConsult = interaction && ((0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.isPostCallConsultInProgress)(interaction) || (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.isPostCallConsultRequested)(interaction));
    const consultOnHold = (interaction === null || interaction === void 0 ? void 0 : interaction.consultHold) === true;
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON) {
            buttonStatus = getVisualUpdateButton(button, !consultOnHold, consultOnHold, _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.icon, _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.ariaLabel);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON) {
            const transferButton = getTransferButtonForEpDnHoldResume(action, button, true, isAllowConfTransferToEpDnEnabled, isConferenceTransferEnabled, EpDnConsultDestinationAgentJoined);
            buttonStatus = Object.assign(Object.assign({}, transferButton), { disabled: postCallConsult || consultOnHold ? true : transferButton.disabled });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON) {
            const conferenceButton = getConferenceButtonForEpDnHoldResume(button, isAllowConfTransferToEpDnEnabled, EpDnConsultDestinationAgentJoined);
            buttonStatus = Object.assign(Object.assign({}, conferenceButton), { disabled: postCallConsult || consultOnHold ? true : conferenceButton.disabled, icon: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MERGE_BUTTON.icon, ariaLabel: _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MERGE_BUTTON.ariaLabel, iconSet: ICON_SET });
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getConsultPanelButtonUpdate = (action, buttons, isAllowConfTransferToEpDnEnabled = false, isConferenceTransferEnabledFF = false) => {
    var _a;
    const interaction = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction;
    const epDnAgent = (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.isEPorEPDN)(interaction === null || interaction === void 0 ? void 0 : interaction.destAgentType);
    if (epDnAgent) {
        return getEpDnConsultPanelButtonUpdate(buttons, action, isAllowConfTransferToEpDnEnabled, isConferenceTransferEnabledFF);
    }
    const postCallConsultInProgress = interaction && (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.isPostCallConsultInProgress)(interaction);
    const postCallConsultRequested = interaction && (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.isPostCallConsultRequested)(interaction);
    const isConferenceInProgress = interaction === null || interaction === void 0 ? void 0 : interaction.isConferenceInProgress;
    const isConferenceTransferEnabled = isConferenceTransferEnabledFF;
    const isConsultPending = (interaction === null || interaction === void 0 ? void 0 : interaction.state) === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT.toLowerCase() ||
        ((interaction === null || interaction === void 0 ? void 0 : interaction.state) === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING.toLowerCase() && interaction.consultHold) ||
        postCallConsultRequested;
    const getButtonIcon = (button) => {
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON) {
            return _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.icon;
        }
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON) {
            return _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MERGE_BUTTON.icon;
        }
        return button.icon;
    };
    const getButtonAriaLabel = (button) => {
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON) {
            return _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.ariaLabel;
        }
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON) {
            return _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MERGE_BUTTON.ariaLabel;
        }
        return button.ariaLabel;
    };
    const getButtonIsVisible = (button) => {
        let buttonIsVisible = true;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON && (interaction === null || interaction === void 0 ? void 0 : interaction.consultHold)) {
            buttonIsVisible = false;
        }
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON && !isConferenceInProgress && !(interaction === null || interaction === void 0 ? void 0 : interaction.isOwner)) {
            buttonIsVisible = false;
        }
        return buttonIsVisible;
    };
    const getButtonDisabled = (button) => {
        if (isConsultPending) {
            return true;
        }
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON) {
            return postCallConsultInProgress && (interaction === null || interaction === void 0 ? void 0 : interaction.isConferenceInProgress) === false;
        }
        if (postCallConsultInProgress) {
            return true;
        }
        if (!isConferenceInProgress) {
            return isButtonDisabledForChat(action) || isAmdDetectedInCallback(interaction);
        }
        return false;
    };
    const updateButton = (button) => {
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON) {
            return Object.assign(Object.assign({}, button), { disabled: false, visible: true });
        }
        if (isConferenceInProgress && (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON)) {
            return Object.assign(Object.assign(Object.assign({}, button), { disabled: getButtonDisabled(button), visible: getButtonIsVisible(button), icon: getButtonIcon(button), ariaLabel: getButtonAriaLabel(button) }), (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON && { iconSet: ICON_SET }));
        }
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON ||
            (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON && (!isConferenceInProgress || isConferenceTransferEnabled)) ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON) {
            return Object.assign(Object.assign(Object.assign({}, button), { disabled: getButtonDisabled(button), visible: getButtonIsVisible(button), icon: getButtonIcon(button), ariaLabel: getButtonAriaLabel(button) }), (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON && { iconSet: ICON_SET }));
        }
        return Object.assign(Object.assign({}, button), { visible: false });
    };
    return buttons.map(updateButton);
};
const getConsultUnheldAndHoldButtonUpdate = (action, buttons, isMPCEnabled, isAllowConfTransferToEpDnEnabled, isConsultPanelVisualUpdateEnabled = false, isConferenceTransferEnabledFF = false) => {
    if (isConsultPanelVisualUpdateEnabled) {
        return getConsultPanelButtonUpdate(action, buttons, isAllowConfTransferToEpDnEnabled, isConferenceTransferEnabledFF);
    }
    return buttons.map((button) => {
        return Object.assign(Object.assign({}, button), { visible: false });
    });
};
const getConsultedAgentHoldButtonUpdate = (buttons) => {
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONSULT) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign({}, button);
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getConsultingButtonForNonPrimaryAgent = (buttons, isMPCOnHold, isMPCNotOnHold, isMPCEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled) => {
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: !(isConsultPanelVisualUpdateEnabled && button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON) });
        }
        else if ((button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON && isMPCOnHold) || (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON && isMPCNotOnHold)) {
            if (isConsultPanelVisualUpdateEnabled) {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON && isMPCNotOnHold, icon: button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON ? _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.icon : button.icon, ariaLabel: button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON ? _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.ariaLabel : button.ariaLabel });
            }
            else {
                buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
            }
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign({}, button);
        }
        else if (isMPCEnabled && button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON && isMPCEnabled && isConferenceTransferEnabled) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getConsultingButtonUpdate = (buttons, action, isMPCEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled) => {
    var _a;
    const interaction = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction;
    const isConferenceInProgress = interaction === null || interaction === void 0 ? void 0 : interaction.isConferenceInProgress;
    const isMPCOnHold = isMPCEnabled && (interaction === null || interaction === void 0 ? void 0 : interaction.isHold);
    const isMPCNotOnHold = isMPCEnabled && !(interaction === null || interaction === void 0 ? void 0 : interaction.isHold);
    if (isMPCEnabled && !(interaction === null || interaction === void 0 ? void 0 : interaction.isOwner)) {
        return getConsultingButtonForNonPrimaryAgent(buttons, isMPCOnHold, isMPCNotOnHold, isMPCEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled);
    }
    return buttons.map((button) => {
        let buttonStatus;
        const buttonIsVisible = !(isConsultPanelVisualUpdateEnabled &&
            (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON || (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON && (interaction === null || interaction === void 0 ? void 0 : interaction.isHold))));
        const buttonUpdate = button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON && isConsultPanelVisualUpdateEnabled;
        const buttonIcon = buttonUpdate ? _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.icon : undefined;
        const buttonLabel = buttonUpdate ? _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.ariaLabel : undefined;
        if (isConferenceInProgress &&
            (interaction === null || interaction === void 0 ? void 0 : interaction.mediaType) === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.VOICE &&
            (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON)) {
            buttonStatus = getVisualUpdateButton(button, buttonIsVisible, false, buttonIcon, buttonLabel);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON && (isConferenceInProgress || isConsultPanelVisualUpdateEnabled)) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON ||
            (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON && (!isConferenceInProgress || isConferenceTransferEnabled)) ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.KEYPAD_BUTTON) {
            const buttonIsDisabled = isButtonDisabledForChat(action) || isAmdDetectedInCallback(interaction);
            buttonStatus = getVisualUpdateButton(button, buttonIsVisible, buttonIsDisabled, buttonIcon, buttonLabel);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign({}, button);
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getEpDnConsultingButtonUpdate = (buttons, action, isMPCEnabled, isAllowConfTransferToEpDnEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled) => {
    var _a, _b;
    const EpDnConsultDestinationAgentJoined = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction) === null || _b === void 0 ? void 0 : _b.EpDnConsultDestinationAgentJoined;
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.KEYPAD_BUTTON) {
            const holdButtonIcon = isConsultPanelVisualUpdateEnabled ? _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.icon : HOLD_ICON;
            const holdButtonLabel = isConsultPanelVisualUpdateEnabled ? _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.ariaLabel : HOLD_LABEL;
            const buttonIsVisible = isConsultPanelVisualUpdateEnabled ? button.type !== _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON : true;
            buttonStatus = getVisualUpdateButton(button, buttonIsVisible, button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDCONSULT_BUTTON && isConsultPanelVisualUpdateEnabled ? button.disabled : false, button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON ? holdButtonIcon : undefined, button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON ? holdButtonLabel : undefined);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_BUTTON) {
            buttonStatus = getTransferButtonForEpDnHoldResume(action, button, isMPCEnabled, isAllowConfTransferToEpDnEnabled, isConferenceTransferEnabled, EpDnConsultDestinationAgentJoined);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_BUTTON) {
            buttonStatus = getConferenceButtonForEpDnHoldResume(button, isAllowConfTransferToEpDnEnabled, EpDnConsultDestinationAgentJoined);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign({}, button);
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getMonitoringHoldButtons = (buttons) => {
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDMONITORING_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MONITORINGUNHELD_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.BARGEIN_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true, disabled: true });
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getMonitoringUnHoldButtons = (buttons) => {
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MONITORINGHELD_BUTTON ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDMONITORING_BUTTON ||
            button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.BARGEIN_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true, disabled: false });
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const getBargeInButtons = (buttons, isWebCallMuted) => {
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.ENDMONITORING_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: isWebCallMuted, disabled: !isWebCallMuted });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: !isWebCallMuted, disabled: isWebCallMuted });
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false, disabled: true });
        }
        return buttonStatus;
    });
};
const getMuteButtonUpdate = (buttons) => {
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true, disabled: false });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false, disabled: true });
        }
        else {
            buttonStatus = Object.assign({}, button);
        }
        return buttonStatus;
    });
};
const getUnmuteButtonUpdate = (buttons) => {
    return buttons.map((button) => {
        let buttonStatus;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true, disabled: false });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false, disabled: true });
        }
        else {
            buttonStatus = Object.assign({}, button);
        }
        return buttonStatus;
    });
};
const getButtonUpdateForWrapupAssistAndPostCall = (buttons, action, isAllowConfTransferToEpDnEnabled) => {
    return buttons.map((button) => {
        var _a, _b, _c, _d, _e;
        let buttonStatus;
        const interaction = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction;
        const postCallConsultInProgress = interaction && (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.isPostCallConsultInProgress)(interaction);
        const postCallConsult = postCallConsultInProgress || (interaction && (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.isPostCallConsultRequested)(interaction));
        const postCallConsultCompleted = interaction && (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.isPostCallConsultCompleted)(interaction);
        const conferenceInProgress = (_b = interaction === null || interaction === void 0 ? void 0 : interaction.isConferenceInProgress) !== null && _b !== void 0 ? _b : false;
        const consultOnHold = (_c = interaction === null || interaction === void 0 ? void 0 : interaction.consultHold) !== null && _c !== void 0 ? _c : false;
        const isConsultCompleted = ((_e = (_d = action === null || action === void 0 ? void 0 : action.payload) === null || _d === void 0 ? void 0 : _d.interaction) === null || _e === void 0 ? void 0 : _e.state) === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_COMPLETED;
        const consultCompleted = isConsultCompleted || postCallConsultCompleted;
        if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RESUME_BUTTON && consultCompleted) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: false, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON && consultCompleted) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: postCallConsultInProgress ? !consultOnHold : true, visible: postCallConsultInProgress ? consultOnHold : true, icon: postCallConsult ? _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.icon : HOLD_ICON, ariaLabel: postCallConsult ? _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SWITCH_BUTTON.ariaLabel : HOLD_LABEL });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true, visible: !postCallConsult });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONFERENCE) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: postCallConsult || consultCompleted, visible: postCallConsult && !conferenceInProgress ? false : true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.END_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { disabled: postCallConsult ? true : postCallConsultCompleted ? false : isConsultCompleted, visible: true });
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE_BUTTON || button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE_BUTTON) {
            buttonStatus = Object.assign({}, button);
        }
        else if (button.type === _Common_constants__WEBPACK_IMPORTED_MODULE_0__.KEYPAD_BUTTON) {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: true, disabled: !isAllowConfTransferToEpDnEnabled });
        }
        else {
            buttonStatus = Object.assign(Object.assign({}, button), { visible: false });
        }
        return buttonStatus;
    });
};
const updateButtonStatus = (action, status, 
// eslint-disable-next-line
isCallMuted = false, featureFlagsForButtonUpdates, ...buttons) => {
    var _a;
    const { isMPCEnabled, isPersistCallEnabled, isDesktopConferenceRecordingEnabled, isAllowConfTransferToEpDnEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled } = featureFlagsForButtonUpdates;
    switch (action.type) {
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED:
            return getConnectedButtonUpdate(action, status, buttons, isConsultPanelVisualUpdateEnabled);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE:
            return getConferenceButtonupdate(action, buttons, isMPCEnabled, isPersistCallEnabled, isDesktopConferenceRecordingEnabled, isCallMuted);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD:
            return getHoldButtonUpdate(action, status, buttons, isMPCEnabled || isPersistCallEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EPDN_HOLD:
            return getEpDnHoldButtonUpdate(action, status, buttons, isMPCEnabled, isAllowConfTransferToEpDnEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE:
            return getRecordingPauseButtonUpdate(buttons);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGRESUME:
            return getRecordingResumeButtonUpdate(buttons);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_REQUESTED: {
            const interaction = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction;
            if (isConsultPanelVisualUpdateEnabled && interaction && (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_1__.isPostCallConsultRequested)(interaction)) {
                return getConsultPanelButtonUpdate(action, buttons, false, isConferenceTransferEnabled);
            }
            return getConsultRequestedButtonUpdate(action, buttons, isMPCEnabled, isConsultPanelVisualUpdateEnabled);
        }
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_UNHELD:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_HOLD:
            return getConsultUnheldAndHoldButtonUpdate(action, buttons, isMPCEnabled, isAllowConfTransferToEpDnEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTED_AGENT_HELD:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTED_AGENT_UNHELD:
            return getConsultedAgentHoldButtonUpdate(buttons);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING:
            return getConsultingButtonUpdate(buttons, action, isMPCEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EPDN_CONSULTING:
            return getEpDnConsultingButtonUpdate(buttons, action, isMPCEnabled, isAllowConfTransferToEpDnEnabled, isConsultPanelVisualUpdateEnabled, isConferenceTransferEnabled);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MONITORINGHELD:
            return getMonitoringHoldButtons(buttons);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MONITORINGUNHELD:
            return getMonitoringUnHoldButtons(buttons);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.BARGEIN:
            return getBargeInButtons(buttons, isCallMuted);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE:
            return getMuteButtonUpdate(buttons);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE:
            return getUnmuteButtonUpdate(buttons);
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.WRAPUP_ASSIST:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL:
            return getButtonUpdateForWrapupAssistAndPostCall(buttons, action, isAllowConfTransferToEpDnEnabled);
        default:
            return buttons;
    }
};
const InteractionControlReducer = (state = _InteractionControlHelper__WEBPACK_IMPORTED_MODULE_2__.initialState, action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    const featureFlagsForButtonUpdates = {
        isMPCEnabled: state.isMPCEnabled,
        isPersistCallEnabled: state.isPersistCallEnabled,
        isDesktopConferenceRecordingEnabled: state.isDesktopConferenceRecordingEnabled,
        isAllowConfTransferToEpDnEnabled: state.isAllowConfTransferToEpDnEnabled,
        isConsultPanelVisualUpdateEnabled: state.isConsultPanelVisualUpdateEnabled,
        isConferenceTransferEnabled: state.isConferenceTransferEnabled
    };
    switch (action.type) {
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.HOLD:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EPDN_HOLD:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_UNHELD:
            return Object.assign(Object.assign({}, state), { interaction: Object.assign(Object.assign({}, state.interaction), (_a = action.payload) === null || _a === void 0 ? void 0 : _a.interaction), buttons: updateButtonStatus(action, (_c = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.interaction) === null || _c === void 0 ? void 0 : _c.state, state.isCallMuted, featureFlagsForButtonUpdates, ...((_d = state.buttons) !== null && _d !== void 0 ? _d : [])) });
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGRESUME:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.RECORDINGPAUSE:
            return Object.assign(Object.assign({}, state), { buttons: updateButtonStatus(action, undefined, state.isCallMuted, featureFlagsForButtonUpdates, ...((_e = state.buttons) !== null && _e !== void 0 ? _e : [])) });
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MUTE:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UNMUTE:
            return Object.assign(Object.assign({}, state), { buttons: updateButtonStatus(action, undefined, (_f = action.payload) === null || _f === void 0 ? void 0 : _f.isCallMuted, featureFlagsForButtonUpdates, ...((_g = state.buttons) !== null && _g !== void 0 ? _g : [])), isCallMuted: (_h = action.payload) === null || _h === void 0 ? void 0 : _h.isCallMuted });
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_REQUESTED:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.EPDN_CONSULTING:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_HOLD:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTED_AGENT_HELD:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTED_AGENT_UNHELD:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MONITORINGHELD:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.MONITORINGUNHELD:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.WRAPUP_ASSIST:
            return Object.assign(Object.assign({}, state), { interaction: Object.assign(Object.assign({}, state.interaction), (_j = action.payload) === null || _j === void 0 ? void 0 : _j.interaction), buttons: updateButtonStatus(action, state.isConsultPanelVisualUpdateEnabled ? (_k = state.interaction) === null || _k === void 0 ? void 0 : _k.state : undefined, state.isCallMuted, featureFlagsForButtonUpdates, ...((_l = state.buttons) !== null && _l !== void 0 ? _l : [])) });
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.BARGEIN:
            return Object.assign(Object.assign({}, state), { interaction: Object.assign(Object.assign({}, state.interaction), (_m = action.payload) === null || _m === void 0 ? void 0 : _m.interaction), buttons: updateButtonStatus(action, undefined, state.isCallMuted, featureFlagsForButtonUpdates, ...((_q = (((_o = action.payload) === null || _o === void 0 ? void 0 : _o.isWebRTCMonitoring) ? (_p = action.payload) === null || _p === void 0 ? void 0 : _p.buttons : state.buttons)) !== null && _q !== void 0 ? _q : [])) });
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP:
        case _constants__WEBPACK_IMPORTED_MODULE_3__.UPDATE_CONTACT_INFORMATION:
            return Object.assign(Object.assign({}, state), { interaction: Object.assign(Object.assign({}, state.interaction), (_r = action.payload) === null || _r === void 0 ? void 0 : _r.interaction) });
        case _constants__WEBPACK_IMPORTED_MODULE_3__.UPDATE_INTERACTION_BUTTONS:
            return Object.assign(Object.assign({}, state), { interaction: Object.assign(Object.assign({}, state.interaction), (_s = action.payload) === null || _s === void 0 ? void 0 : _s.interaction), buttons: [...((_u = (_t = action.payload) === null || _t === void 0 ? void 0 : _t.buttons) !== null && _u !== void 0 ? _u : [])], isMPCEnabled: (_v = action.payload) === null || _v === void 0 ? void 0 : _v.isMPCEnabled, isPersistCallEnabled: (_w = action.payload) === null || _w === void 0 ? void 0 : _w.isPersistCallEnabled, isDesktopConferenceRecordingEnabled: (_x = action.payload) === null || _x === void 0 ? void 0 : _x.isDesktopConferenceRecordingEnabled, isAllowConfTransferToEpDnEnabled: (_y = action.payload) === null || _y === void 0 ? void 0 : _y.isAllowConfTransferToEpDnEnabled, isCallMuted: (_z = action.payload) === null || _z === void 0 ? void 0 : _z.isCallMuted });
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.SILENTMONITORING:
            return Object.assign(Object.assign({}, state), { interaction: Object.assign(Object.assign({}, state.interaction), (_0 = action.payload) === null || _0 === void 0 ? void 0 : _0.interaction), buttons: [...((_2 = (_1 = action.payload) === null || _1 === void 0 ? void 0 : _1.buttons) !== null && _2 !== void 0 ? _2 : [])] });
        case _Common_constants__WEBPACK_IMPORTED_MODULE_0__.UPDATE_RTD_DATA:
            return Object.assign(Object.assign({}, state), { interaction: Object.assign(Object.assign({}, state.interaction), (_3 = action.payload) === null || _3 === void 0 ? void 0 : _3.interaction), buttons: [...((_4 = state.buttons) !== null && _4 !== void 0 ? _4 : [])] });
        case _constants__WEBPACK_IMPORTED_MODULE_3__.UPDATE_MPC_FLAG:
            return Object.assign(Object.assign({}, state), { interaction: Object.assign(Object.assign({}, state.interaction), (_5 = action.payload) === null || _5 === void 0 ? void 0 : _5.interaction), buttons: ((_6 = action.payload) === null || _6 === void 0 ? void 0 : _6.buttons) !== undefined ? [...action.payload.buttons] : [...((_7 = state.buttons) !== null && _7 !== void 0 ? _7 : [])] });
        default:
            return state;
    }
};
const CadVariablesUpdate = (state = {}, action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    switch (action.type) {
        case "UPDATED":
            if ((_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.name) {
                return Object.assign(Object.assign({}, state), { [(_d = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.name]: Object.assign(Object.assign(Object.assign({}, state[(_f = (_e = action.payload) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.name]), action.payload.value), { isShowCopy: true, isCopied: false }) });
            }
            return Object.assign({}, state);
        case "UPDATE":
            return Object.assign({}, (_g = action.payload) === null || _g === void 0 ? void 0 : _g.customerInfo);
        case "RESTORE":
            return {};
        default:
            return Object.assign(Object.assign({}, state), (_h = action.payload) === null || _h === void 0 ? void 0 : _h.customerInfo);
    }
};



/***/ }),

/***/ "./src/direflow-components/InteractionControl/styles/Accordion.css":
/*!*************************************************************************!*\
  !*** ./src/direflow-components/InteractionControl/styles/Accordion.css ***!
  \*************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../node_modules/css-loader/dist/cjs.js!./Accordion.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionControl/styles/Accordion.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/InteractionControlWrapper/components/SecureCadUtility.ts":
/*!******************************************************************************************!*\
  !*** ./src/direflow-components/InteractionControlWrapper/components/SecureCadUtility.ts ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   decryptCAD: () => (/* binding */ decryptCAD)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Common/constants */ "./src/direflow-components/Common/constants.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const decryptCAD = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const cad = data.callAssociatedData;
    let decryptedState = _Common_constants__WEBPACK_IMPORTED_MODULE_2__.NONE;
    if (cad) {
        // find all isSecure=true values and decrypt them
        const valueArray = {};
        let keyId;
        let keyVersion;
        Object.entries(cad).forEach(([key, value]) => {
            if (value.isSecure) {
                if (Object.keys(valueArray).length === 0) {
                    keyId = value.secureKeyId;
                    keyVersion = value.secureKeyVersion;
                }
                valueArray[key] = value.value;
            }
        });
        if (Object.keys(valueArray).length !== 0) {
            const secureData = {
                data: valueArray,
                action: "decrypt",
                keyId,
                keyVersion
            };
            try {
                const decryptedData = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.abs.secureCADVariables(secureData);
                const decryp = decryptedData.data;
                decryptedState = _Common_constants__WEBPACK_IMPORTED_MODULE_2__.ApiResponseState.PASS;
                // find the value and assign the decrypted value returned from the api
                Object.entries(decryp).forEach(([key, value]) => {
                    if (key in cad) {
                        cad[key] = Object.assign(Object.assign({}, cad[key]), { value });
                    }
                });
            }
            catch (err) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Error decrypting", err.message);
                decryptedState = _Common_constants__WEBPACK_IMPORTED_MODULE_2__.ApiResponseState.FAIL;
            }
        }
    }
    return { data, decryptedState };
});


/***/ }),

/***/ "./src/direflow-components/InteractionControlWrapper/components/index.tsx":
/*!********************************************************************************!*\
  !*** ./src/direflow-components/InteractionControlWrapper/components/index.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _InteractionControl_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../InteractionControl/components */ "./src/direflow-components/InteractionControl/components/index.tsx");
/* harmony import */ var _Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Utility/Utils/InteractionControlUtils */ "./src/direflow-components/Utility/Utils/InteractionControlUtils.ts");
/* harmony import */ var _SecureCadUtility__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./SecureCadUtility */ "./src/direflow-components/InteractionControlWrapper/components/SecureCadUtility.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






const InteractionControlWrapper = ({ interaction, buttons, agentconfig, cadStatus, wrapUpData, agentWrapUpCodeProps, callpersistence, isVoiceInteraction, isVoiceIntPaneUpdatedByUser, currentRoute, epDnMapping, addressBook, isDesktopConsultToEntryPointDnEnabled, isDarkMode, isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled, isAddressBookInfiniteScrollEnabled, isDesktopConferenceRecordingEnabled, isCallMuted, isDesktopAuxCodesInfiniteScrollEnabled }) => {
    const [decryptedData, setDecryptedData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(interaction);
    const [decryptionState, setDecryptionState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_Common_constants__WEBPACK_IMPORTED_MODULE_2__.NONE);
    const [buttonDisableState, setButtonDisableState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const retryDecryptData = () => __awaiter(void 0, void 0, void 0, function* () {
        setButtonDisableState(true);
        const { data, decryptedState } = yield (0,_SecureCadUtility__WEBPACK_IMPORTED_MODULE_5__.decryptCAD)(interaction);
        setDecryptedData(data);
        setDecryptionState(decryptedState);
        setButtonDisableState(false);
    });
    const decryptData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (agentconfig.isSecureCADVariablesEnabled) {
            const { data, decryptedState } = yield (0,_SecureCadUtility__WEBPACK_IMPORTED_MODULE_5__.decryptCAD)(interaction);
            setDecryptionState(decryptedState);
            setDecryptedData(data);
        }
        else {
            setDecryptedData(interaction);
        }
    }), [interaction]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        decryptData();
    }, [interaction, decryptData]);
    function showConsultView() {
        const postCallConsultRequested = (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_4__.isPostCallConsultRequested)(interaction);
        const postCallConsultInProgress = (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_4__.isPostCallConsultInProgress)(interaction);
        const postCallConsult = postCallConsultRequested || postCallConsultInProgress;
        if (interaction.mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE) {
            return false;
        }
        if ((interaction.state === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULTING.toLowerCase() ||
            (agentconfig.isWxccPersistConsultEnabled && interaction.state === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULT.toLowerCase()) ||
            postCallConsult) &&
            interaction.consultMediaResourceId &&
            !interaction.isWrapUp) {
            return true;
        }
        if (!agentconfig.isWxccMultiPartyConfEnabled &&
            (interaction.state === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONFERENCE.toLowerCase() || interaction.isWrapUpAssist) &&
            !interaction.isOwner) {
            return true;
        }
        if (isDesktopConsultToEntryPointDnEnabled &&
            interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE &&
            !interaction.isOwner &&
            (interaction.state === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULTING.toLowerCase() ||
                (agentconfig.isWxccPersistConsultEnabled && interaction.state === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULT.toLowerCase()) ||
                postCallConsult)) {
            return true;
        }
        return false;
    }
    function showCallView() {
        if (interaction.mediaType !== _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE) {
            return true;
        }
        //If multiparty is not enabled we show all the agents call view
        const isConsultedPostCall = !(0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_4__.isAgentConsulting)(interaction, agentconfig.isWxccMultiPartyConfEnabled) &&
            (0,_Utility_Utils_InteractionControlUtils__WEBPACK_IMPORTED_MODULE_4__.isPostCallConsultInProgress)(interaction);
        if (agentconfig.isWxccMultiPartyConfEnabled &&
            !interaction.isConsulted &&
            (!interaction.parentInteractionId || interaction.parentInteractionId === interaction.interactionId) &&
            !isConsultedPostCall) {
            return true;
        }
        if (interaction.isOwner || interaction.isWrapUp) {
            return true;
        }
        return false;
    }
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [showCallView() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InteractionControl_components__WEBPACK_IMPORTED_MODULE_3__["default"], { interaction: decryptedData, buttons: buttons, cadStatus: cadStatus, agentconfig: agentconfig, wrapUpData: wrapUpData, agentWrapUpCodeProps: agentWrapUpCodeProps, isConsultView: false, isVoiceInteraction: isVoiceInteraction, isVoiceIntPaneUpdatedByUser: isVoiceIntPaneUpdatedByUser, currentRoute: currentRoute, callpersistence: callpersistence, decryptedState: decryptionState, retryDecryption: retryDecryptData, buttonDisableState: buttonDisableState, isSecureCADVariablesEnabled: agentconfig.isSecureCADVariablesEnabled, epDnMapping: epDnMapping, addressBook: addressBook, isDesktopConsultToEntryPointDnEnabled: isDesktopConsultToEntryPointDnEnabled, isDarkMode: isDarkMode, isProgressiveCampaignEnabled: isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled: isProgressiveCampaign1NEnabled, isAddressBookInfiniteScrollEnabled: isAddressBookInfiniteScrollEnabled, isWxccMultiPartyConfEnabled: agentconfig.isWxccMultiPartyConfEnabled, isDesktopConferenceRecordingEnabled: isDesktopConferenceRecordingEnabled, isCallMuted: isCallMuted, isDesktopAuxCodesInfiniteScrollEnabled: isDesktopAuxCodesInfiniteScrollEnabled })), showConsultView() && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InteractionControl_components__WEBPACK_IMPORTED_MODULE_3__["default"], { interaction: decryptedData, buttons: buttons, cadStatus: cadStatus, agentconfig: agentconfig, wrapUpData: wrapUpData, agentWrapUpCodeProps: agentWrapUpCodeProps, isConsultView: true, callpersistence: callpersistence, isVoiceInteraction: isVoiceInteraction, isVoiceIntPaneUpdatedByUser: isVoiceIntPaneUpdatedByUser, currentRoute: currentRoute, decryptedState: decryptionState, retryDecryption: retryDecryptData, buttonDisableState: buttonDisableState, isSecureCADVariablesEnabled: agentconfig.isSecureCADVariablesEnabled, epDnMapping: epDnMapping, addressBook: addressBook, isDesktopConsultToEntryPointDnEnabled: isDesktopConsultToEntryPointDnEnabled, isDarkMode: isDarkMode, isProgressiveCampaignEnabled: isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled: isProgressiveCampaign1NEnabled, isAddressBookInfiniteScrollEnabled: isAddressBookInfiniteScrollEnabled, isWxccMultiPartyConfEnabled: agentconfig.isWxccMultiPartyConfEnabled, isDesktopConferenceRecordingEnabled: isDesktopConferenceRecordingEnabled, isCallMuted: isCallMuted, isDesktopAuxCodesInfiniteScrollEnabled: isDesktopAuxCodesInfiniteScrollEnabled }))] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InteractionControlWrapper);
function isInteractionBarged(agentStateMonitoring) {
    throw new Error("Function not implemented.");
}


/***/ }),

/***/ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionListenerAndRequests.ts":
/*!***************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionPopoverManager/Utils/InteractionListenerAndRequests.ts ***!
  \***************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   acceptInteractionRequest: () => (/* binding */ acceptInteractionRequest),
/* harmony export */   answerCallRequest: () => (/* binding */ answerCallRequest),
/* harmony export */   declineCallRequest: () => (/* binding */ declineCallRequest),
/* harmony export */   endInteractionRequest: () => (/* binding */ endInteractionRequest),
/* harmony export */   processInteractionUpdates: () => (/* binding */ processInteractionUpdates)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constants */ "./src/direflow-components/InteractionPopoverManager/constants.ts");
/* harmony import */ var _InteractionPopoverConverter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./InteractionPopoverConverter */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoverConverter.ts");
/* harmony import */ var _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./InteractionPopoversUtils */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts");






/**
 * Listens to multiple interaction events and call's show popover and remove popover
 * as per event
 * @param showPopover
 * @param updatePopover
 * @param removePopover
 * @param agentContactRonaEvent
 * @param contactAssignedEvent
 * @param endOutboundCallContactEvent
 */
const processInteractionUpdates = (agentId, showPopover, updatePopover, removePopover, taskMap, popovers, { isDesktopConsultToEntryPointDnEnabled, isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled, isDesktopCpdViewEnabled, isProgressive11SpecialModeEnabled }) => {
    Object.keys(taskMap).forEach((task) => {
        const taskObj = taskMap[task];
        const popExist = popovers.find((pop) => pop.config.id === taskObj.interactionId);
        const isValidPopoverForInteraction = popExist && popExist.config.isInvitationPopover && taskObj.type !== _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.AGENT_CONTACT_RESERVED;
        if (!popExist || isValidPopoverForInteraction) {
            if (taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.AGENT_CONTACT_RESERVED ||
                (taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.AGENT_CONTACT &&
                    (taskObj.interaction.state === "new" || taskObj.interaction.state === "consult") &&
                    !taskObj.interaction.participants[taskObj.agentId].isOffered)) {
                _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.info(`${taskObj.type} received inside invitation popover for showing, interaction ID:`, taskObj.interactionId);
                const popoverData = (0,_InteractionPopoverConverter__WEBPACK_IMPORTED_MODULE_4__.convertEventToInvitationPopoverData)(taskObj, agentId, isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled);
                if (popoverData) {
                    showPopover(popoverData);
                }
            }
            else if (taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.AGENT_OFFER_CONTACT ||
                taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.AGENT_OFFER_CONSULT ||
                taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.AGENT_CONTACT ||
                taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.MONITORING_OFFERED ||
                taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.AGENT_OFFER_CAMPAIGN_RESERVED ||
                taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.AGENT_ADD_CAMPAIGN_RESERVED) {
                _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.info(`${taskObj.type} received inside interaction popover for showing, interaction ID:`, taskObj.interactionId);
                const popoverData = (0,_InteractionPopoverConverter__WEBPACK_IMPORTED_MODULE_4__.convertEventToInteractionPopoverData)(taskObj, isDesktopConsultToEntryPointDnEnabled, agentId, isDesktopCpdViewEnabled);
                if (popoverData) {
                    showPopover(popoverData);
                }
            }
        }
        else if (taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.AGENT_CONSULTING ||
            taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.AGENT_CONTACT_ASSIGNED ||
            taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EVENT_TYPES.MONITORING_STARTED) {
            _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.info(`${taskObj.type} received inside popover for removing, interaction ID:`, taskObj.interactionId);
            const popoverData = (0,_InteractionPopoverConverter__WEBPACK_IMPORTED_MODULE_4__.convertEventToInteractionPopoverData)(taskObj, isDesktopConsultToEntryPointDnEnabled, agentId, isDesktopCpdViewEnabled);
            if (popoverData) {
                removePopover(popoverData);
            }
        }
        else if (isProgressive11SpecialModeEnabled) {
            //This feature flag check shouldn't be needed, only feature flagging here to play safe for CarShield issue: https://jira-eng-sjc12.cisco.com/jira/browse/CX-16728
            const popoverData = (0,_InteractionPopoverConverter__WEBPACK_IMPORTED_MODULE_4__.convertEventToInteractionPopoverData)(taskObj, isDesktopConsultToEntryPointDnEnabled, agentId, isDesktopCpdViewEnabled);
            if (popoverData) {
                updatePopover(popoverData);
            }
        }
    });
};
/**
 * Request to accept interaction and performing respective update.
 * @param data
 * @param removePopover
 * @param addError
 */
const acceptInteractionRequest = (data, removePopover, addError, contactAssignedEvent) => {
    var _a, _b;
    if (((_a = data.header.button) === null || _a === void 0 ? void 0 : _a.id.startsWith("accept")) || (0,_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.isMediaTypeDigitalOutbound)(data.header.mediaType)) {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
            .acceptV2({ interactionId: data.id })
            .then((res) => {
            _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.info("Contact assigned Success ", res);
            contactAssignedEvent("success");
        })
            .catch((error) => {
            _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.error(`event=ContactAssignedError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)}] Contact Assigned Error :', ${error}`, error);
            contactAssignedEvent("error");
            addError(data, error);
        });
    }
    else if ((_b = data.header.button) === null || _b === void 0 ? void 0 : _b.id.startsWith("consult-accept")) {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
            .consultAccept({ interactionId: data.id })
            .then((res) => {
            _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.info("Consult accept Success ", res);
            contactAssignedEvent("success");
        })
            .catch((error) => {
            _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.error(`event=AcceptConsultError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)}] Consult accept Error :', ${error}`, error);
            contactAssignedEvent("error");
            addError(data, error);
        });
    }
};
const endInteractionRequest = (data, removePopover, addError, endOutboundCallContactEvent) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
        .cancelTaskV2({ interactionId: data.id })
        .then((res) => {
        _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.info(`Contact Ended Success mediaType:${data.type} InteractionId:${data.id}`, JSON.stringify(res));
        endOutboundCallContactEvent("success");
    })
        .catch((error) => {
        _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.error(`event=EndContactError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error)}] Contact Ended Error mediaType:${data.type} InteractionId:${data.id} ${error}`);
        addError(data, error);
        endOutboundCallContactEvent("error");
    });
};
/**
 * Request to accept/answer call and performing respective update.
 * @param data
 * @param removePopover
 * @param addError
 */
const answerCallRequest = (data, removePopover, addError) => {
    const deviceDetails = data.callingDeviceDetails;
    if (deviceDetails) {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.webexCalling
            .answerCall({ callId: deviceDetails.deviceCallId, deviceId: deviceDetails.deviceId })
            .then((_res) => {
            _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.info(`[answerCallRequest] | Answer call success, call ID: ${deviceDetails.deviceCallId}`);
            window.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_3__.WEBEX_CALL_ANSWERED, {
                detail: { value: data.id },
                bubbles: true,
                composed: true
            }));
            const isOutbound = data.header.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_VOICE;
            _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.info(`[answerCallRequest] | isOutbound: ${isOutbound}`);
            if (!isOutbound) {
                removePopover(data);
            }
        })
            .catch((error) => {
            var _a;
            _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.error(`[answerCallRequest] | Error: ${error}, tracking ID: ${(_a = error.details) === null || _a === void 0 ? void 0 : _a.trackingId}`);
            error.message = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().interactionPopover.unableToAnswer;
            addError(data, error);
        });
    }
};
/**
 * Request to accept/answer call and performing respective update.
 * @param data
 * @param removePopover
 * @param addError
 */
const declineCallRequest = (data, removePopover, addError) => {
    const deviceDetails = data.callingDeviceDetails;
    if (deviceDetails) {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.webexCalling
            .rejectCall({ callId: deviceDetails.deviceCallId })
            .then((_res) => {
            _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.info(`[declineCallRequest] | Decline call success, call ID: ${deviceDetails.deviceCallId}`);
            removePopover(data);
        })
            .catch((error) => {
            var _a;
            _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_5__.logger.error(`[declineCallRequest] | Error: ${error}, tracking ID: ${(_a = error.details) === null || _a === void 0 ? void 0 : _a.trackingId}`);
            error.message = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().interactionPopover.unableToDecline;
            addError(data, error);
        });
    }
};


/***/ }),

/***/ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoverConverter.ts":
/*!************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoverConverter.ts ***!
  \************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   convertEventToInteractionPopoverData: () => (/* binding */ convertEventToInteractionPopoverData),
/* harmony export */   convertEventToInvitationPopoverData: () => (/* binding */ convertEventToInvitationPopoverData),
/* harmony export */   getAgentVariables: () => (/* binding */ getAgentVariables),
/* harmony export */   getChosenCadVariables: () => (/* binding */ getChosenCadVariables),
/* harmony export */   getContactTitle: () => (/* binding */ getContactTitle),
/* harmony export */   getCustomerDetails: () => (/* binding */ getCustomerDetails),
/* harmony export */   getInteractionPopoverTitle: () => (/* binding */ getInteractionPopoverTitle),
/* harmony export */   getInvitationPopoverTitle: () => (/* binding */ getInvitationPopoverTitle),
/* harmony export */   getInvitationTitle: () => (/* binding */ getInvitationTitle),
/* harmony export */   getMediaTypes: () => (/* binding */ getMediaTypes),
/* harmony export */   isSecondaryAgent: () => (/* binding */ isSecondaryAgent),
/* harmony export */   isSecondaryEpDnAgent: () => (/* binding */ isSecondaryEpDnAgent)
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../InteractionControl/constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./InteractionPopoversUtils */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts");





const { interactionPopover: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)();
const getCustomerDetails = (mediaType, data) => {
    switch (mediaType) {
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_VOICE:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.MIDCALL_MONITORING: {
            return [
                {
                    label: i18n.phoneNumber,
                    value: data.displayAni
                },
                { label: i18n.dni, value: data.dnis },
                { label: i18n.queueName, value: data.virtualTeamName }
            ];
        }
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_EMAIL:
            return [
                { label: i18n.email, value: data.dnis },
                { label: i18n.queueName, value: data.virtualTeamName }
            ];
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.CHAT:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.EMAIL:
            return [
                {
                    label: i18n.customerName,
                    value: data.customerName
                },
                { label: i18n.email, value: data.displayAni },
                { label: i18n.queueName, value: data.virtualTeamName }
            ];
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.FACEBOOK:
            return [
                { label: i18n.queueName, value: data.virtualTeamName },
                { label: i18n.sourcePage, value: data.sourcePage }
            ];
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_SMS:
            return [
                { label: i18n.phoneNumber, value: data.dnis },
                { label: i18n.sourceNumber, value: data.sourceNumber },
                { label: i18n.queueName, value: data.virtualTeamName }
            ];
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.SMS:
            return [
                { label: i18n.queueName, value: data.virtualTeamName },
                { label: i18n.phoneNumber, value: data.customerNumber },
                { label: i18n.sourceNumber, value: data.sourceNumber }
            ];
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.APPLE_BUSINESS_CHAT:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.GOOGLE_BUSINESS_CHAT:
            return [
                { label: i18n.customerName, value: data.customerName },
                { label: i18n.queueName, value: data.virtualTeamName }
            ];
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.WHATSAPP:
            return [
                { label: i18n.customerName, value: data.customerName },
                { label: i18n.phoneNumber, value: data.customerNumber },
                { label: i18n.sourceNumber, value: data.sourceNumber },
                { label: i18n.queueName, value: data.virtualTeamName }
            ];
        default:
            return [];
    }
};
const findTheLocalizationLabel = (cadValue) => {
    // This method is used to map the existing i18n localization key for the name label
    // localize the ani, dn, rona timeout, virtualTeamName keys only
    switch (cadValue.name) {
        case _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.VIRTUAL_TEAM_NAME:
            return i18n.queueName;
        case _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.RONA_TIMEOUT:
            return i18n.rona;
        case _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.ANI:
            return i18n.phoneNumber;
        case _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.DN:
            return i18n.dni;
        default:
            return cadValue.displayName;
    }
};
const getChosenCadVariables = (data, fcDesktopViewCad) => {
    const newObj = [];
    if (fcDesktopViewCad && data) {
        const popoverValues = typeof fcDesktopViewCad == "string" ? JSON.parse(fcDesktopViewCad) : fcDesktopViewCad;
        const sortedCadValue = popoverValues["pop-over"].sort((a, b) => Number(a.variableSeq) - Number(b.variableSeq));
        sortedCadValue.forEach((item) => {
            const cadValue = data[item.name];
            if (!(cadValue === null || cadValue === void 0 ? void 0 : cadValue.isSecure) && (cadValue === null || cadValue === void 0 ? void 0 : cadValue.agentViewable)) {
                // Get the valid popover labels for specific keys like ani, dn, virtualTeamName, ronaTimeout
                const labelName = findTheLocalizationLabel(cadValue);
                newObj.push({ label: labelName, value: cadValue.value });
            }
        });
    }
    return newObj;
};
const getAgentVariables = (data) => {
    return [
        { label: i18n.agentDn, value: data.dn },
        { label: i18n.agentName, value: data.name },
        { label: i18n.agentTeam, value: data.teamName }
    ];
};
const getMediaTypes = (data, isOwner, agentId) => {
    var _a, _b, _c, _d, _e;
    switch (data.mediaType) {
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.EMAIL:
            if ((0,_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__.isContactOutdialOutbound)(data.contactDirection.type, (_a = data.outboundType) !== null && _a !== void 0 ? _a : "")) {
                return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_EMAIL;
            }
            return data.mediaType;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.SOCIAL:
            if (data.mediaChannel === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.SMS &&
                (0,_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__.isContactOutdialOutbound)(data.contactDirection.type, (_b = data.outboundType) !== null && _b !== void 0 ? _b : "")) {
                return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_SMS;
            }
            return data.mediaChannel;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE:
            // check if incoming call is a monitoring call or a consult call which is being monitored
            if (((_c = data.callProcessingDetails) === null || _c === void 0 ? void 0 : _c.monitorType) === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MONITORING_TYPE.MIDCALL &&
                !isOwner &&
                ((_e = (_d = data.participants[agentId]) === null || _d === void 0 ? void 0 : _d.pType) === null || _e === void 0 ? void 0 : _e.toLowerCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.SUPERVISOR) {
                return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.MIDCALL_MONITORING;
            }
            if (data.contactDirection.type === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.OUTBOUND) {
                return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_VOICE;
            }
            return data.mediaType;
        default:
            return data.mediaType;
    }
};
/**
 * For agent initiated digital contacts, a different popover value is needed.
 * This function works on the derived media type and returns the invitation popover title.
 * @param derivedMediaType - The media type derived based on media type and channel.
 */
const getInvitationPopoverTitle = (derivedMediaType) => {
    switch (derivedMediaType) {
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_EMAIL:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_SMS:
            return (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().initiating;
        default:
            return (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().connecting;
    }
};
/**
 * For agent initiated digital contacts, a different popover value is needed.
 * This function works on the derived media type and returns the interaction popover title.
 * @param derivedMediaType - The media type derived based on media type and channel.
 * @param virtualTeamName - The default interaction popover title.
 */
const getInteractionPopoverTitle = (derivedMediaType, virtualTeamName) => {
    switch (derivedMediaType) {
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_EMAIL:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_SMS:
            return (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().outbound;
        default:
            return virtualTeamName;
    }
};
const getContactTitle = (mediaType, mediaChannel, data, contactDirection, outboundType) => {
    switch (mediaType) {
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE:
            return contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.OUTBOUND ? data.dnis : data.displayAni;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.CHAT:
            return data.customerName;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.EMAIL:
            if ((0,_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__.isContactOutdialOutbound)(contactDirection, outboundType)) {
                return data.dnis;
            }
            return data.fromAddress || data.customerName;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.SOCIAL:
            if (mediaChannel === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.SMS && (0,_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__.isContactOutdialOutbound)(contactDirection, outboundType)) {
                return data.dnis;
            }
            return data.customerName || data.appUser;
        default:
            return "";
    }
};
const isSecondaryAgent = (data) => {
    return (data.interaction.callProcessingDetails.relationshipType === "consult" &&
        data.interaction.callProcessingDetails.parentInteractionId &&
        data.interaction.callProcessingDetails.parentInteractionId !== data.interaction.interactionId);
};
const isSecondaryEpDnAgent = (data, isDesktopConsultToEntryPointDnEnabled) => {
    return (isDesktopConsultToEntryPointDnEnabled && data.interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE && isSecondaryAgent(data));
};
const getParentAgentDetails = (data, isDesktopConsultToEntryPointDnEnabled) => {
    var _a, _b, _c;
    if (isSecondaryEpDnAgent(data, isDesktopConsultToEntryPointDnEnabled) === true) {
        return {
            dn: (_a = data.interaction.callProcessingDetails) === null || _a === void 0 ? void 0 : _a.parent_Agent_DN,
            name: (_b = data.interaction.callProcessingDetails) === null || _b === void 0 ? void 0 : _b.parent_Agent_Name,
            teamName: (_c = data.interaction.callProcessingDetails) === null || _c === void 0 ? void 0 : _c.parent_Agent_TeamName
        }; // get parent agent Dn, parent agent name, parent agent team in case of EP-DN.
    }
    return {};
};
const getAgentDetails = (data, isDesktopConsultToEntryPointDnEnabled) => {
    if (data.consultingAgentId) {
        return getAgentVariables(data.interaction.participants[data.consultingAgentId]);
    }
    if (isDesktopConsultToEntryPointDnEnabled) {
        const parentAgentDetails = getParentAgentDetails(data, isDesktopConsultToEntryPointDnEnabled);
        return getAgentVariables(parentAgentDetails);
    }
    return [];
};
const getInvitationTitle = (mediaChannel, mediaType, contactDirection, outboundType, isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled, data) => {
    if ((mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.OUTBOUND_VOICE || mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE) && contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.OUTBOUND) {
        if (outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.COURTESY_CALLBACK) {
            return (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().popoverTitle.courtesyCallback;
        }
        if ((outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.PROGRESSIVE_CAMPAIGN && isProgressiveCampaignEnabled) ||
            (outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.OUTDIAL_RESERVATION && isProgressiveCampaign1NEnabled)) {
            return (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().popoverTitle.progressiveCampaign;
        }
        if (outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CALLBACK) {
            return (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().popoverTitle.callback;
        }
        return (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().popoverTitle.outboundCall;
    }
    if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE && contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.INBOUND) {
        return (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().popoverTitle.incomingCall;
    }
    if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.EMAIL) {
        if ((0,_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__.isContactOutdialOutbound)(contactDirection, outboundType)) {
            return data.dnis;
        }
        return `${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().popoverTitle.incoming} ${mediaType}`;
    }
    if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.SOCIAL) {
        if (mediaChannel === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.SMS && (0,_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__.isContactOutdialOutbound)(contactDirection, outboundType)) {
            return data.dnis;
        }
        return `${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().popoverTitle.incoming} ${mediaChannel}`;
    }
    if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.CHAT) {
        return (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().popoverTitle.chat;
    }
    return `${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.getLocalizedMessages)().popoverTitle.incoming} ${mediaType}`;
};
const getAgentName = (owner, participants) => {
    var _a;
    return (_a = participants[owner]) === null || _a === void 0 ? void 0 : _a.name;
};
const getCustomerPhoneNumber = (callProcessingDetails) => {
    return callProcessingDetails.displayAni;
};
const getCallingDeviceDetails = (agentId, participants) => {
    // get the "webex" deviceId and deviceCallId for the current agent participant, if it is defined for this agent
    const agentParticipants = Object.values(participants).filter((participant) => participant &&
        (participant === null || participant === void 0 ? void 0 : participant.id) === agentId &&
        (participant === null || participant === void 0 ? void 0 : participant.deviceId) &&
        (participant === null || participant === void 0 ? void 0 : participant.deviceCallId) &&
        (participant === null || participant === void 0 ? void 0 : participant.deviceCallId.trim()) !== "" &&
        (participant === null || participant === void 0 ? void 0 : participant.deviceId.trim()) !== "");
    if (agentParticipants.length > 0) {
        const participant = agentParticipants[0];
        const deviceType = participant.deviceType ? participant.deviceType : "";
        const deviceId = participant.deviceId;
        const deviceCallId = participant.deviceCallId;
        _InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__.logger.info(`[getCallingDeviceDetails] | deviceType: ${deviceType}, deviceId: ${deviceId}, deviceCallId: ${deviceCallId}`);
        return { deviceType, deviceId, deviceCallId };
    }
    return undefined;
};
/**
 * Converter for all type of interaction object
 * @param data
 */
const convertEventToInteractionPopoverData = (data, isDesktopConsultToEntryPointDnEnabled, agentId, isDesktopCpdViewEnabled) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let fcDesktopViewCad;
    if (isDesktopCpdViewEnabled) {
        fcDesktopViewCad = data.interaction.callProcessingDetails.fcDesktopView;
    }
    else if (data.interaction.callAssociatedData) {
        fcDesktopViewCad = (_a = data.interaction.callAssociatedData[_Common_constants__WEBPACK_IMPORTED_MODULE_2__.FC_DESKTOP_VIEW]) === null || _a === void 0 ? void 0 : _a.value;
    }
    const chosenCadVariables = getChosenCadVariables(data.interaction.callAssociatedData, fcDesktopViewCad);
    const isOwner = data.interaction.owner === data.agentId;
    const contactTitle = getContactTitle(data.interaction.mediaType, data.interaction.mediaChannel, data.interaction.callProcessingDetails, data.interaction.contactDirection.type, (_b = data.interaction.outboundType) !== null && _b !== void 0 ? _b : "");
    return {
        id: data.interactionId,
        header: {
            mediaType: getMediaTypes(data.interaction, isOwner, agentId),
            mediaChannel: data.interaction.mediaChannel,
            popoverTitle: getInteractionPopoverTitle(getMediaTypes(data.interaction, isOwner, agentId), data.interaction.callProcessingDetails.virtualTeamName),
            contactTitle,
            button: {
                id: data.type === "AgentOfferConsult" || data.interaction.state === "consult"
                    ? `consult-accept-${getMediaTypes(data.interaction, isOwner, agentId)}-${data.interactionId}`
                    : `accept-${getMediaTypes(data.interaction, isOwner, agentId)}-${data.interactionId}`,
                label: data.interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE ? i18n.ringing : i18n.accept,
                acceptAriaLabel: data.interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE ? i18n.ringing : i18n.acceptAriaLabel,
                contactTitle: contactTitle.replace(/"/g, "")
            }
        },
        contactDirection: data.interaction.contactDirection.type,
        outboundType: data.interaction.outboundType,
        details: getCustomerDetails(getMediaTypes(data.interaction, isOwner, agentId), data.interaction.callProcessingDetails),
        time: ((_c = data.interaction.participants[data.agentId]) === null || _c === void 0 ? void 0 : _c.lastUpdated) || luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.utc().toMillis(),
        type: data.interaction.mediaType,
        ronatimeout: parseInt((_e = (_d = data.interaction) === null || _d === void 0 ? void 0 : _d.callProcessingDetails) === null || _e === void 0 ? void 0 : _e.ronaTimeout, 10),
        isOwner: isSecondaryEpDnAgent(data, isDesktopConsultToEntryPointDnEnabled) === true
            ? false
            : data.interaction.owner === data.agentId,
        chosenCadVaiables: (chosenCadVariables.length && chosenCadVariables) ||
            getCustomerDetails(getMediaTypes(data.interaction, isOwner, agentId), data.interaction.callProcessingDetails),
        agentVariables: getAgentDetails(data, isDesktopConsultToEntryPointDnEnabled),
        eventType: data.type,
        agentName: getAgentName(data.interaction.owner, (_f = data.interaction) === null || _f === void 0 ? void 0 : _f.participants),
        customerPhoneNumber: getCustomerPhoneNumber(data.interaction.callProcessingDetails),
        autoAnswerEnabled: (_g = data.interaction.participants[data.agentId]) === null || _g === void 0 ? void 0 : _g.autoAnswerEnabled,
        callingDeviceDetails: getCallingDeviceDetails(data.agentId, (_h = data.interaction) === null || _h === void 0 ? void 0 : _h.participants)
    };
};
/**
 * Converter for Invitation object
 *
 */
const convertEventToInvitationPopoverData = (data, agentId, isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled) => {
    var _a, _b, _c, _d;
    const isOwner = data.interaction.owner === data.agentId;
    return {
        id: data.interactionId,
        header: {
            mediaType: getMediaTypes(data.interaction, isOwner, agentId),
            mediaChannel: data.interaction.mediaChannel,
            popoverTitle: getInvitationPopoverTitle(getMediaTypes(data.interaction, isOwner, agentId)),
            contactTitle: getInvitationTitle(data.interaction.mediaChannel, data.interaction.mediaType, data.interaction.contactDirection.type, (_a = data.interaction.outboundType) !== null && _a !== void 0 ? _a : "", isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled, data.interaction.callProcessingDetails)
        },
        contactDirection: data.interaction.contactDirection.type,
        outboundType: data.interaction.outboundType,
        details: getCustomerDetails(getMediaTypes(data.interaction, isOwner, agentId), data.interaction.callProcessingDetails),
        time: ((_b = data.interaction.participants[data.agentId]) === null || _b === void 0 ? void 0 : _b.lastUpdated) || luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.utc().toMillis(),
        type: data.interaction.mediaType,
        ronatimeout: parseInt((_d = (_c = data.interaction) === null || _c === void 0 ? void 0 : _c.callProcessingDetails) === null || _d === void 0 ? void 0 : _d.ronaTimeout, 10),
        isOwner: data.interaction.owner === data.agentId,
        isInvitationPopover: true,
        autoAnswerEnabled: data.interaction.participants[data.agentId].autoAnswerEnabled
    };
};


/***/ }),

/***/ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts":
/*!*********************************************************************************************!*\
  !*** ./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts ***!
  \*********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   dispatchCustomEvent: () => (/* binding */ dispatchCustomEvent),
/* harmony export */   filterPopoverPerMediaTypes: () => (/* binding */ filterPopoverPerMediaTypes),
/* harmony export */   focusPopover: () => (/* binding */ focusPopover),
/* harmony export */   getCallLenght: () => (/* binding */ getCallLenght),
/* harmony export */   getLimitingDetails: () => (/* binding */ getLimitingDetails),
/* harmony export */   getPopoverIconBadge: () => (/* binding */ getPopoverIconBadge),
/* harmony export */   getPopoversPaginated: () => (/* binding */ getPopoversPaginated),
/* harmony export */   getPreviousAllPopovers: () => (/* binding */ getPreviousAllPopovers),
/* harmony export */   isAgentContactInOfferConsultState: () => (/* binding */ isAgentContactInOfferConsultState),
/* harmony export */   isAgentContactInRingingState: () => (/* binding */ isAgentContactInRingingState),
/* harmony export */   isContactOutdialOutbound: () => (/* binding */ isContactOutdialOutbound),
/* harmony export */   isMediaTypeDigitalOutbound: () => (/* binding */ isMediaTypeDigitalOutbound),
/* harmony export */   isNonTerminatedTask: () => (/* binding */ isNonTerminatedTask),
/* harmony export */   logger: () => (/* binding */ logger),
/* harmony export */   mergePopoverViaPriority: () => (/* binding */ mergePopoverViaPriority),
/* harmony export */   playSound: () => (/* binding */ playSound),
/* harmony export */   populatePopoverPerMediaTypes: () => (/* binding */ populatePopoverPerMediaTypes),
/* harmony export */   setIsSeenPopoverPerMediaType: () => (/* binding */ setIsSeenPopoverPerMediaType),
/* harmony export */   updatePopoverCampainCallState: () => (/* binding */ updatePopoverCampainCallState),
/* harmony export */   updatePopoverCollapseState: () => (/* binding */ updatePopoverCollapseState),
/* harmony export */   updatePopoverErrorState: () => (/* binding */ updatePopoverErrorState),
/* harmony export */   updatePopoverExpandState: () => (/* binding */ updatePopoverExpandState),
/* harmony export */   updatePopoverRemoveState: () => (/* binding */ updatePopoverRemoveState),
/* harmony export */   updatePopoverSeenState: () => (/* binding */ updatePopoverSeenState)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../constants */ "./src/direflow-components/InteractionPopoverManager/constants.ts");



const logger = (0,_sdk__WEBPACK_IMPORTED_MODULE_0__.createLogger)("[InteractionPopoverManager]");
/**
 * Returns updated pool data as per updateType
 * @param popoverPool
 * @param popoverId
 * @param updateType
 * @param errorMessage
 * @param popoverTrackingId
 */
const updatePopoverExpandState = (popovers, popoverId) => {
    return popovers.map((popover) => {
        return Object.assign(Object.assign({}, popover), { config: Object.assign(Object.assign({}, popover.config), { expandedState: popover.config.id === popoverId }) });
    });
};
const updatePopoverCollapseState = (popovers, popoverId) => {
    return popovers.map((popover) => {
        if (popover.config.id === popoverId) {
            return Object.assign(Object.assign({}, popover), { config: Object.assign(Object.assign({}, popover.config), { expandedState: false }) });
        }
        return popover;
    });
};
const updatePopoverSeenState = (popovers, popoverId) => {
    return popovers.map((popover) => {
        return Object.assign(Object.assign({}, popover), { isSeen: popover.config.id !== popoverId });
    });
};
const updatePopoverRemoveState = (popovers, popoverId) => {
    return popovers.map((popover) => {
        if (popover.config.id === popoverId) {
            return Object.assign(Object.assign({}, popover), { isBeingRemoved: true });
        }
        return Object.assign({}, popover);
    });
};
const updatePopoverCampainCallState = (popovers, popoverId) => {
    return popovers.map((popover) => {
        if (popover.config.id === popoverId) {
            return Object.assign(Object.assign({}, popover), { isCampaignCalling: true });
        }
        return Object.assign({}, popover);
    });
};
const updatePopoverErrorState = (popovers, popoverId, errorMsg, trackingId) => {
    return popovers.map((popover) => {
        return Object.assign(Object.assign({}, popover), { errorMessage: popover.config.id === popoverId ? errorMsg : popover.errorMessage, popoverTrackingId: popover.config.id === popoverId ? trackingId : popover.popoverTrackingId });
    });
};
const isAgentContactInRingingState = (data) => {
    if (data.interaction.state === _constants__WEBPACK_IMPORTED_MODULE_2__.NEW_INTERACTION || data.interaction.state === _constants__WEBPACK_IMPORTED_MODULE_2__.CONNECTED_INTERACTION) {
        return (!data.interaction.participants[data.agentId].isWrapUp && !data.interaction.participants[data.agentId].hasJoined);
    }
    return false;
};
const isAgentContactInOfferConsultState = (data) => {
    if (data.interaction.state === _constants__WEBPACK_IMPORTED_MODULE_2__.CONSULT_INTERACTION) {
        return (!data.interaction.participants[data.agentId].isWrapUp &&
            !data.interaction.participants[data.agentId].hasJoined &&
            data.interaction.participants[data.agentId].isConsulted);
    }
    return false;
};
const populatePopoverPerMediaTypes = (pool, popover) => {
    switch (popover.config.type) {
        case _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.VOICE:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.OUTBOUND_VOICE:
            pool.call.push(popover);
            break;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.CHAT:
            pool.chat.push(popover);
            break;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.EMAIL:
            pool.email.push(popover);
            break;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.SOCIAL:
            pool.social.push(popover);
            break;
        default:
            return pool;
    }
    return pool;
};
const setIsSeen = (pool, popover, mediaType) => {
    const perPool = Object.assign({}, pool);
    const index = pool[mediaType].findIndex((po) => po.config.id === popover.config.id);
    const poolPerMedia = [...pool[mediaType]];
    poolPerMedia[index].isSeen = true;
    poolPerMedia[mediaType] = perPool;
    return poolPerMedia;
};
const setIsSeenPopoverPerMediaType = (pool, popover) => {
    const poolCopy = Object.assign({}, pool);
    switch (popover.config.type) {
        case _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.VOICE:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.OUTBOUND_VOICE:
            poolCopy.call = setIsSeen(pool, popover, "call");
            break;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.CHAT:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.EMAIL:
        case _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.SOCIAL:
            poolCopy[popover.config.type] = setIsSeen(pool, popover, popover.config.type);
            break;
        default:
            return poolCopy;
    }
    return poolCopy;
};
const filterPopoverPerMediaTypes = (popoversPerMediaTypeRef, popover) => {
    return {
        call: popover.type === _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.VOICE
            ? popoversPerMediaTypeRef.call.filter((pop) => pop.config.id !== popover.id)
            : popoversPerMediaTypeRef.call,
        chat: popover.type === _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.CHAT
            ? popoversPerMediaTypeRef.chat.filter((pop) => pop.config.id !== popover.id)
            : popoversPerMediaTypeRef.chat,
        email: popover.type === _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.EMAIL
            ? popoversPerMediaTypeRef.email.filter((pop) => pop.config.id !== popover.id)
            : popoversPerMediaTypeRef.email,
        social: popover.type === _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.SOCIAL
            ? popoversPerMediaTypeRef.social.filter((pop) => pop.config.id !== popover.id)
            : popoversPerMediaTypeRef.social
    };
};
const focusPopover = (activePopoverRef, isExpanded = false, isWebCall = false) => {
    setTimeout(() => {
        if (isExpanded &&
            activePopoverRef.current &&
            activePopoverRef.current.shadowRoot &&
            activePopoverRef.current.shadowRoot.querySelector("button")) {
            activePopoverRef.current.shadowRoot.querySelector("button").focus();
            if (isWebCall) {
                logger.info("event= WebRtcActionButtonsRendered : [WebRtc]: Webcall Accept and Cancel buttons rendered, agentId :", sessionStorage.getItem("agentId"));
            }
        }
    }, 0);
};
const getLimitingDetails = (details) => {
    return details && details.slice(0, _constants__WEBPACK_IMPORTED_MODULE_2__.MAX_ROWS_ALLOWED);
};
const getPopoverIconBadge = (isPopoverOfCall) => {
    return isPopoverOfCall ? "icon-badge-call" : "icon-badge";
};
/**
 * returning popover array as per priority
 */
const mergePopoverViaPriority = (popoversPerMediaType, isTaskList) => {
    if (isTaskList) {
        return popoversPerMediaType.call
            .concat(popoversPerMediaType.chat)
            .concat(popoversPerMediaType.social)
            .concat(popoversPerMediaType.email);
    }
    return popoversPerMediaType.email
        .concat(popoversPerMediaType.social)
        .concat(popoversPerMediaType.chat)
        .concat(popoversPerMediaType.call);
};
const isNonTerminatedTask = (taskObj) => {
    return taskObj && taskObj.interaction && !taskObj.interaction.isTerminated;
};
const dispatchCustomEvent = (eventName, dataToBeSend, dispatchCustom) => {
    const event = new CustomEvent(eventName, {
        detail: dataToBeSend,
        bubbles: true,
        composed: true
    });
    if (dispatchCustom) {
        dispatchCustom(event);
    }
};
const playSound = () => {
    let notificationSettings = localStorage.getItem(_Common_constants__WEBPACK_IMPORTED_MODULE_1__.DESKTOP_NOTIFICATION_SOUND_SETTINGS) || _Common_constants__WEBPACK_IMPORTED_MODULE_1__.SOUND_DEFAULT_SETTINGS;
    notificationSettings = JSON.parse(notificationSettings);
    const newPopoverAudio = new Audio("/sounds/new_contact_sound.mp3");
    newPopoverAudio.load();
    const agentId = sessionStorage.getItem("agentId") || "default";
    const notification = notificationSettings[agentId] || JSON.parse(_Common_constants__WEBPACK_IMPORTED_MODULE_1__.SOUND_DEFAULT_SETTINGS).default;
    newPopoverAudio.volume = notification.volume;
    newPopoverAudio.muted = notification.mute || !notification.sound;
    newPopoverAudio.pause();
    newPopoverAudio.currentTime = 0;
    newPopoverAudio.play().catch((error) => {
        logger.error("event=SoundPlayError | Error while playing sound :", error);
    });
};
/**
 * Split popover pool map into pagination array pool
 * @param popoverPoolMap
 */
const getPopoversPaginated = (conactedPoolOtherChannel, callPool, perPage = 5) => {
    const paginatedPoolOther = [];
    const paginatedPopovers = [];
    while (conactedPoolOtherChannel.length) {
        if (conactedPoolOtherChannel.length < perPage - callPool.length) {
            const split = conactedPoolOtherChannel.splice(0, perPage - callPool.length);
            paginatedPoolOther.push(split);
        }
        else {
            const split = conactedPoolOtherChannel.splice(conactedPoolOtherChannel.length - (perPage - callPool.length));
            paginatedPoolOther.push(split);
        }
    }
    if (paginatedPoolOther && paginatedPoolOther.length > 0) {
        paginatedPoolOther.forEach((split, index) => {
            paginatedPopovers[index] = split.concat(callPool);
        });
    }
    else {
        paginatedPopovers[0] = callPool;
    }
    return paginatedPopovers;
};
/**
 *  Returns call length in pool
 * @param splitPop
 */
const getCallLenght = (paginatedPool) => {
    if (paginatedPool.length > 1) {
        let callCount = 0;
        paginatedPool[0].forEach((x) => {
            if (x.config.type === "telephony") {
                // eslint-disable-next-line no-plusplus
                callCount++;
            }
        });
        return callCount;
    }
    return 0;
};
/**
 * Return length of popovers in previos index exluding call from 1nd index forward
 * @param index
 * @param paginatedPopovers
 */
const getPreviousAllPopovers = (index, paginatedPopovers) => {
    let cuurentIndex = index;
    let len = 0;
    while (cuurentIndex >= 0 && paginatedPopovers[cuurentIndex]) {
        if (cuurentIndex === 0) {
            len += paginatedPopovers[cuurentIndex].length;
        }
        else {
            len += paginatedPopovers[cuurentIndex].length - getCallLenght(paginatedPopovers);
        }
        cuurentIndex -= 1;
    }
    return len;
};
/**
 * Returns if a derived media type is digital outbound or not.
 * @param derivedMediaType - Media type derived based on actual media type, channel and direction of interaction.
 * Returns a Boolean depicting if media type is a digital outbound or not.
 */
const isMediaTypeDigitalOutbound = (derivedMediaType) => {
    return (derivedMediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_EMAIL ||
        derivedMediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_1__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_SMS);
};
/**
 * Returns if a contact is of OUTBOUND direction and OUTDIAL type.
 * @param contactDirection - Direction of the contact
 * @param outboundType - Type of outbound
 */
const isContactOutdialOutbound = (contactDirection, outboundType) => {
    return contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_1__.OUTBOUND && outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_1__.OUT_DIAL;
};


/***/ }),

/***/ "./src/direflow-components/InteractionPopoverManager/components/InteractionPopover/InteractionPopover.tsx":
/*!****************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionPopoverManager/components/InteractionPopover/InteractionPopover.tsx ***!
  \****************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionPopover: () => (/* binding */ InteractionPopover)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var timers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! timers */ "../../node_modules/timers-browserify/main.js");
/* harmony import */ var timers__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(timers__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../AgentStateSelector/StateTimer */ "./src/direflow-components/AgentStateSelector/StateTimer.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _Common_components_TooltipEllipsis__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Common/components/TooltipEllipsis */ "./src/direflow-components/Common/components/TooltipEllipsis/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Utils/InteractionPopoversUtils */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/InteractionPopoverManager/constants.ts");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../index.css */ "./src/direflow-components/InteractionPopoverManager/components/index.css");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _css_common_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./../../../../css/common.css */ "./src/css/common.css");
/* harmony import */ var _css_common_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_css_common_css__WEBPACK_IMPORTED_MODULE_15__);
















const DEFAULT_RONA_TIMEOUT_VOICE = 18;
const DEFAULT_RONA_TIMEOUT_DIGITAL = 32;
const FLASHING_TIMEOUT = 5;
const POPOVER_BUTTON_MAX_WIDTH_WITHOUT_PADDING = 53; // ButtonMaxWidth - padding => 85-32
const RONA_TIMEOUT_CHECK = 8;
const ICON_SRC = "icon src";
/**
 * Interaction Popover component, renders all info along with action for popover
 */
const InteractionPopover = ({ isDarkMode, config, acceptTask, endTask, answerCall, declineCall, popoverExpanded, errorMessage, popoverTrackingId, isSeen, isBeingRemoved, isEndCallEnabled, isTaskList, isProgressiveCampaignEnabled, isProgressiveCampaign1NEnabled, isSuppressWebexCallingNotificationEnabled, deviceType, isCampaignCalling, isAgentHandlingTask, agentId, popoverIndex, isActivePopover }) => {
    var _a, _b, _c;
    const { id, header, details, expandedState, contactDirection, ronatimeout, outboundType, isOwner, chosenCadVaiables, agentVariables, eventType, isInvitationPopover, agentName, customerPhoneNumber, autoAnswerEnabled } = config;
    const { contactTitle, popoverTitle, mediaType, mediaChannel, button } = header;
    const [isFlashing, setIsFlashing] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [showDetails, setShowDetails] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(expandedState);
    const [isButtonTextOverflow, setIsButtonTextOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [isRequestInProgress, setIsRequestInProgress] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [outdialLoading, setOutdialLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [isAnswerTextOverflow, setIsAnswerTextOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [isCancelTextOverflow, setIsCancelTextOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [isAnswerReqInProgress, setIsAnswerReqInProgress] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [isWebexAnswerOutdialReqInProgress, setIsWebexAnswerOutdialReqInProgress] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [isCancelReqInProgress, setIsCancelReqInProgress] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [isWCEstablished, setIsWCEstablished] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const popover = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const activeFocus = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const toggleFocus = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const callAnswerBtn = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const callCancelBtn = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const loadingPlaceholderRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const flashTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const focusTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const loadPlaceholderTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const popoverFocusTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const isPopoverOfCall = config.type === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE;
    const dispatchCustom = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.EventContext);
    const popoverTitleLocalized = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().popoverTitle;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if (isPopoverOfCall) {
            popoverFocusTimeoutIdRef.current = window.setTimeout(() => {
                var _a, _b, _c;
                (_c = (_b = (_a = popover.current) === null || _a === void 0 ? void 0 : _a.querySelector("md-task-item")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(".md-taskitem").focus();
            }, _Common_constants__WEBPACK_IMPORTED_MODULE_11__.TIMEOUT_TEN_MS);
        }
        return () => {
            if (popoverFocusTimeoutIdRef.current) {
                window.clearTimeout(popoverFocusTimeoutIdRef.current);
            }
        };
    }, []);
    const showChosenVariables = () => {
        if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE ||
            mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.OUTBOUND_VOICE ||
            mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.MIDCALL_MONITORING) {
            if (eventType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.EVENT_TYPES.AGENT_OFFER_CONSULT ||
                (!isOwner && eventType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.EVENT_TYPES.AGENT_OFFER_CONTACT)) {
                return agentVariables === null || agentVariables === void 0 ? void 0 : agentVariables.concat((0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__.getLimitingDetails)(chosenCadVaiables));
            }
            return (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__.getLimitingDetails)(chosenCadVaiables);
        }
        return (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__.getLimitingDetails)(details !== null && details !== void 0 ? details : []);
    };
    const limitingDetails = showChosenVariables();
    const refTrackingId = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const refTrackingIdCpyBtn = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const DEFAULT_RONA_TIMEOUT = mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE ? DEFAULT_RONA_TIMEOUT_VOICE : DEFAULT_RONA_TIMEOUT_DIGITAL;
    const showDetailsRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(showDetails);
    showDetailsRef.current = showDetails;
    const copyTrackingID = () => {
        if (refTrackingId.current) {
            refTrackingId.current.select();
        }
        document.execCommand("copy");
        if (refTrackingIdCpyBtn.current) {
            refTrackingIdCpyBtn.current.focus();
        }
    };
    /**
     * Toggle show details on click of maximize / minimize button
     * and update the parent about it.
     */
    const toggleShowDetails = () => {
        setShowDetails(!showDetails);
        if (!showDetails) {
            popoverExpanded(config);
        }
    };
    const isProgressive1NCampaignCall = () => {
        return outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.OUTDIAL_RESERVATION && isProgressiveCampaign1NEnabled;
    };
    const isPreviewCampaignCall = () => {
        return outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CAMPAIGN && isProgressiveCampaign1NEnabled;
    };
    const showCallingButtonFor1NCampaignCall = () => {
        return isCampaignCalling ? (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interactionPopover.calling : "";
    };
    const getPopOverTitle = () => {
        if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.OUTBOUND_VOICE && contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.OUTBOUND) {
            if (outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.COURTESY_CALLBACK) {
                return popoverTitleLocalized.courtesyCallback;
            }
            if (outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CALLBACK) {
                return popoverTitleLocalized.callback;
            }
            if ((outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.PROGRESSIVE_CAMPAIGN && isProgressiveCampaignEnabled) || isProgressive1NCampaignCall()) {
                return popoverTitleLocalized.progressiveCampaign;
            }
            return popoverTitleLocalized.outboundCall;
        }
        if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.VOICE && contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.INBOUND) {
            return popoverTitleLocalized.incomingCall;
        }
        if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.MIDCALL_MONITORING) {
            return popoverTitleLocalized.monitoringCall;
        }
        return "";
    };
    const getMediaType = () => {
        if (outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.COURTESY_CALLBACK || outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.CALLBACK) {
            return "callback";
        }
        if ((outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.PROGRESSIVE_CAMPAIGN && isProgressiveCampaignEnabled) ||
            isProgressive1NCampaignCall() ||
            isPreviewCampaignCall()) {
            return _Common_constants__WEBPACK_IMPORTED_MODULE_11__.PROGRESSIVE_CAMPAIGN_ICON;
        }
        if ((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_9__.isIconSrc)(mediaType, mediaChannel)) {
            return ICON_SRC;
        }
        return mediaType;
    };
    const focusOnButton = (event) => {
        if (!showDetails) {
            popoverExpanded(config);
            event.stopPropagation();
        }
    };
    const isIncomingWebexCallWithKnownDeviceDetails = () => {
        return isSuppressWebexCallingNotificationEnabled && config.callingDeviceDetails !== undefined;
    };
    const isWebCall = () => {
        return deviceType === _constants__WEBPACK_IMPORTED_MODULE_13__.BROWSER && isPopoverOfCall;
    };
    const popoverHasAnswerDeclineButtons = () => {
        return isWebCall() || isIncomingWebexCallWithKnownDeviceDetails();
    };
    const handleBtnFocus = (reactRef) => {
        var _a, _b, _c;
        // eslint-disable-next-line no-unused-expressions
        (_c = (_b = (_a = reactRef === null || reactRef === void 0 ? void 0 : reactRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(_constants__WEBPACK_IMPORTED_MODULE_13__.BUTTON)) === null || _c === void 0 ? void 0 : _c.focus();
    };
    const handleHeaderFocus = () => {
        var _a, _b, _c, _d, _e;
        // eslint-disable-next-line no-unused-expressions
        (_e = (_d = (_c = (_b = (_a = popover === null || popover === void 0 ? void 0 : popover.current) === null || _a === void 0 ? void 0 : _a.previousSibling) === null || _b === void 0 ? void 0 : _b.querySelector(".header md-button")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector(_constants__WEBPACK_IMPORTED_MODULE_13__.BUTTON)) === null || _e === void 0 ? void 0 : _e.focus();
    };
    const isTargetHasClass = (e, className) => {
        var _a, _b;
        return (_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.contains(className);
    };
    /**
     * Handle Key press event on maximize / minimize button
     * @param event
     */
    const handleKeyPressToggle = (event) => {
        event.persist();
        if (event.charCode === _constants__WEBPACK_IMPORTED_MODULE_13__.TAB_KEY_CODE && event.shiftKey) {
            if (popoverHasAnswerDeclineButtons()) {
                handleBtnFocus(callCancelBtn);
            }
            else {
                handleBtnFocus(activeFocus);
            }
        }
    };
    const handleCallAnswer = (event) => {
        event.stopPropagation();
        if (isAcceptCallDisabled()) {
            return;
        }
        if (isIncomingWebexCallWithKnownDeviceDetails()) {
            if (!isWebexAnswerOutdialReqInProgress && answerCall) {
                setIsAnswerReqInProgress(true);
                setIsRequestInProgress(true);
                if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.OUTBOUND_VOICE) {
                    // outbound, e.g. Outdial call
                    setIsWebexAnswerOutdialReqInProgress(true);
                }
                answerCall(config);
            }
            return;
        }
        _sdk__WEBPACK_IMPORTED_MODULE_7__.logger.info("event= WebRtcAcceptCall : [WebRtc]: Webcall accept clicked, agentId:", agentId);
        setIsAnswerReqInProgress(true);
        setIsRequestInProgress(true);
        (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__.dispatchCustomEvent)(_constants__WEBPACK_IMPORTED_MODULE_13__.WEB_CALL_ANSWER, {}, dispatchCustom);
    };
    const handleCallCancel = (event) => {
        event.stopPropagation();
        if (isIncomingWebexCallWithKnownDeviceDetails()) {
            if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.OUTBOUND_VOICE) {
                if (endTask) {
                    setIsCancelReqInProgress(true);
                    setIsRequestInProgress(true);
                    endTask(config);
                }
            }
            else {
                if (declineCall) {
                    setIsCancelReqInProgress(true);
                    setIsRequestInProgress(true);
                    declineCall(config);
                }
            }
            return;
        }
        if (isCancelCallDisabled()) {
            return;
        }
        _sdk__WEBPACK_IMPORTED_MODULE_7__.logger.info("event= WebRtcCancelCall : [WebRtc]: Webcall cancel clicked, agentId:", agentId);
        setIsCancelReqInProgress(true);
        setIsRequestInProgress(true);
        (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__.dispatchCustomEvent)(_constants__WEBPACK_IMPORTED_MODULE_13__.WEB_CALL_CANCEL, {}, dispatchCustom);
    };
    const handleCallButtons = () => {
        setIsCancelReqInProgress(false);
        setIsAnswerReqInProgress(false);
        setIsRequestInProgress(false);
    };
    const handleWebexCallButtons = (event) => {
        if (event.detail.value === config.id) {
            handleCallButtons();
        }
    };
    const handleCallEstablised = () => {
        handleCallButtons();
        setIsWCEstablished(true);
    };
    const handleAccept = () => {
        if (isPopoverOfCall) {
            /* voice offer cant be accepted from desktop, voice popover is only indicative. */
            return;
        }
        setIsRequestInProgress(true);
        if (acceptTask) {
            acceptTask(config);
        }
    };
    const handleDigitalOutboundAutoAnswer = (event) => {
        event.stopPropagation();
        if (isActivePopover) {
            handleAccept();
        }
    };
    const handleKeyPress = (event) => {
        var _a, _b, _c, _d;
        event.persist();
        if (event.keyCode === _constants__WEBPACK_IMPORTED_MODULE_13__.ENTER_KEY_CODE && acceptTask !== undefined) {
            handleAccept();
        }
        else if (event.keyCode === _constants__WEBPACK_IMPORTED_MODULE_13__.TAB_KEY_CODE && event.shiftKey) {
            const isPreviousButton = (_d = (_c = (_b = (_a = popover === null || popover === void 0 ? void 0 : popover.current) === null || _a === void 0 ? void 0 : _a.previousSibling) === null || _b === void 0 ? void 0 : _b.querySelector(".header md-button")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector(_constants__WEBPACK_IMPORTED_MODULE_13__.BUTTON);
            if (isPreviousButton) {
                event.preventDefault();
                handleHeaderFocus();
            }
        }
    };
    const handleEnterKeyPress = (e) => {
        if (isTargetHasClass(e, _constants__WEBPACK_IMPORTED_MODULE_13__.WC_ANSWER_BTN)) {
            handleCallAnswer(e);
        }
        else {
            handleCallCancel(e);
        }
    };
    const handleCallButtonKeyPress = (event) => {
        event.stopPropagation();
        if (event.keyCode === _constants__WEBPACK_IMPORTED_MODULE_13__.ENTER_KEY_CODE) {
            handleEnterKeyPress(event);
        }
        else if (event.key === _constants__WEBPACK_IMPORTED_MODULE_13__.TAB_KEY &&
            event.shiftKey &&
            isTargetHasClass(event, _constants__WEBPACK_IMPORTED_MODULE_13__.WC_ANSWER_BTN)) {
            handleHeaderFocus();
        }
    };
    const getContactTitle = () => {
        if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.MIDCALL_MONITORING) {
            return agentName;
        }
        return contactTitle;
    };
    const getChannelTitle = () => {
        if (mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.MIDCALL_MONITORING) {
            return customerPhoneNumber;
        }
        return popoverTitle;
    };
    const showOutdialCancel = () => {
        return (!(isProgressiveCampaign1NEnabled && outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.OUTDIAL_RESERVATION) &&
            isEndCallEnabled &&
            contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.OUTBOUND &&
            outboundType !== _Common_constants__WEBPACK_IMPORTED_MODULE_11__.COURTESY_CALLBACK &&
            isOwner);
    };
    const handleInitialFocus = (event) => {
        var _a;
        event.stopPropagation();
        if (isAgentHandlingTask) {
            return; // no need to focus for agent already handling a task.
        }
        if (popoverHasAnswerDeclineButtons()) {
            if (((_a = event.target) === null || _a === void 0 ? void 0 : _a.id) === "taskItemId") {
                handleBtnFocus(callAnswerBtn);
            }
        }
        else {
            handleBtnFocus(activeFocus);
        }
    };
    const isAcceptCallDisabled = () => {
        return isRequestInProgress || isWCEstablished;
    };
    const isCancelCallDisabled = () => {
        return isRequestInProgress;
    };
    const hideCancelForProgresssive = () => {
        return !isCampaignCalling && outboundType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.OUTDIAL_RESERVATION && isProgressiveCampaign1NEnabled;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if ((ronatimeout || DEFAULT_RONA_TIMEOUT) >= RONA_TIMEOUT_CHECK) {
            flashTimeoutIdRef.current = window.setTimeout(() => {
                setIsFlashing(true);
            }, ((ronatimeout || DEFAULT_RONA_TIMEOUT) - FLASHING_TIMEOUT) * 1000);
        }
        const text = isEndCallEnabled && contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.OUTBOUND ? (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().common.Cancel : button === null || button === void 0 ? void 0 : button.label;
        setIsButtonTextOverflow((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_9__.isTextOverflow)(POPOVER_BUTTON_MAX_WIDTH_WITHOUT_PADDING, text));
        return () => {
            if (flashTimeoutIdRef.current) {
                window.clearTimeout(flashTimeoutIdRef.current);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        setIsAnswerTextOverflow((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_9__.isTextOverflow)(POPOVER_BUTTON_MAX_WIDTH_WITHOUT_PADDING, (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().common.Answer));
        setIsCancelTextOverflow((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_9__.isTextOverflow)(POPOVER_BUTTON_MAX_WIDTH_WITHOUT_PADDING, (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().common.Cancel));
        if (!isWebCall()) {
            return () => { };
        }
        window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.WC_DISCONNECTED, handleCallButtons);
        window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.WC_NOT_FOUND, handleCallButtons);
        window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.WC_ESTABLISHED, handleCallEstablised);
        window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.WEB_CALL_AUTO_ANSWER, handleCallAnswer);
        return () => {
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.WC_DISCONNECTED, handleCallButtons);
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.WC_NOT_FOUND, handleCallButtons);
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.WC_ESTABLISHED, handleCallEstablised);
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.WEB_CALL_AUTO_ANSWER, handleCallAnswer);
        };
    }, [deviceType]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if (!isIncomingWebexCallWithKnownDeviceDetails()) {
            return () => { };
        }
        window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.WEBEX_CALL_ANSWERED, handleWebexCallButtons);
        return () => {
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.WEBEX_CALL_ANSWERED, handleWebexCallButtons);
        };
    }, [config.callingDeviceDetails]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if (!(0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__.isMediaTypeDigitalOutbound)(mediaType)) {
            return () => { };
        }
        window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.DIGITAL_OUTBOUND_AUTO_ANSWER, handleDigitalOutboundAutoAnswer);
        return () => {
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__.DIGITAL_OUTBOUND_AUTO_ANSWER, handleDigitalOutboundAutoAnswer);
        };
    }, [mediaType]);
    const phoneNumber = (_c = (_b = (_a = limitingDetails === null || limitingDetails === void 0 ? void 0 : limitingDetails[0]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.split("").join(" ")) !== null && _c !== void 0 ? _c : "";
    /**
     * Handle focus whenever the popover is expanded
     * Making the popover expand on focus on accept and showing popover details.
     */
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        focusTimeoutIdRef.current = window.setTimeout(() => {
            var _a;
            if (!((_a = activeFocus.current) === null || _a === void 0 ? void 0 : _a.hasAttribute("disabled")) && showDetailsRef.current && !isAgentHandlingTask) {
                if (popoverHasAnswerDeclineButtons()) {
                    (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__.focusPopover)(callAnswerBtn, showDetailsRef.current, true);
                }
                else {
                    (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__.focusPopover)(activeFocus, showDetailsRef.current);
                }
            }
        }, 100);
        announceRingingLabel();
        return () => {
            if (focusTimeoutIdRef.current) {
                window.clearTimeout(focusTimeoutIdRef.current);
            }
        };
    }, [showDetails, isInvitationPopover]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if (expandedState !== showDetails) {
            setShowDetails(expandedState);
        }
    }, [expandedState]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        handleCallButtons();
        setIsWebexAnswerOutdialReqInProgress(false);
    }, [errorMessage]);
    const announceRingingLabel = () => {
        if (!isInvitationPopover && !popoverHasAnswerDeclineButtons() && isPopoverOfCall) {
            window.dispatchEvent(new CustomEvent(_Common_constants__WEBPACK_IMPORTED_MODULE_11__.AX_ANNOUNCEMENT_UPDATE, {
                detail: {
                    thisEvent: {
                        message: `${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interactionPopover.incomingCallFrom} ${phoneNumber}`
                    }
                }
            }));
        }
    };
    const getAnswerDeclineCallButtons = (popoverIndex) => {
        const { Answer: AnswerText, Decline: DeclineText, Cancel: CancelText, AnswerAriaLabel } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().common;
        const cancelBtnText = mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.OUTBOUND_VOICE ? CancelText : DeclineText;
        const isOutboundWebexCallAgentLegEst = isWebexAnswerOutdialReqInProgress && !isAnswerReqInProgress;
        const answerBtnText = isCampaignCalling || isOutboundWebexCallAgentLegEst
            ? (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interactionPopover.calling
            : AnswerText;
        const answerAriaLabel = isCampaignCalling ? (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interactionPopover.calling : AnswerAriaLabel;
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "bottom", message: answerBtnText, class: "web-call-answer-button" }, (isAcceptCallDisabled() || !isAnswerTextOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ id: `answerInteraction-${config.id}`, ref: callAnswerBtn }, (isAcceptCallDisabled() && !isCampaignCalling ? { disabled: true } : ""), { onFocus: focusOnButton, onClick: answerBtnText === AnswerText ? handleCallAnswer : "", onKeyDown: handleCallButtonKeyPress, width: "85px", ariaLabel: `${answerAriaLabel} ${popoverIndex + 1}`, variant: _constants__WEBPACK_IMPORTED_MODULE_13__.GREEN, class: `interaction-btn answer-btn ${isCampaignCalling || isOutboundWebexCallAgentLegEst ? "accept-btn-call" : ""}` }, { children: [!isAnswerReqInProgress && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ slot: "text" }, { children: [" ", answerBtnText, " "] })), isAnswerReqInProgress && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ slot: "text", className: "cancelling-text-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "16" }), " ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "cancelling-text" }, { children: answerBtnText }))] })))] })) })), hideCancelForProgresssive() ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "bottom", message: cancelBtnText }, (!isCancelTextOverflow || isCancelCallDisabled() ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ id: `endInteraction-${config.id}` }, (isCancelCallDisabled() ? { disabled: true } : ""), { ref: callCancelBtn, onFocus: focusOnButton, onClick: handleCallCancel, onKeyDown: handleCallButtonKeyPress, width: "85px", ariaLabel: cancelBtnText, variant: "secondary", class: "interaction-btn cancel-btn" }, { children: [!isCancelReqInProgress && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ slot: "text" }, { children: [" ", cancelBtnText, " "] })), isCancelReqInProgress && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ slot: "text", className: "cancelling-text-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "16" }), " ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "cancelling-text" }, { children: cancelBtnText }))] })))] })) })))] }));
    };
    const getCancelOutdialButton = () => {
        const { Cancel: CancelText, Canceling: CancelingText } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().common;
        const onClick = () => {
            if (endTask) {
                endTask(config);
            }
            setOutdialLoading(true);
        };
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "bottom", message: CancelText }, (!isButtonTextOverflow || outdialLoading ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-button", Object.assign({ id: `endInteraction-${config.id}`, ref: activeFocus }, (outdialLoading ? { disabled: true } : ""), { onFocus: focusOnButton, onClick: onClick, onKeyDown: handleKeyPress, maxWidth: "85px", variant: "secondary", ariaLabel: outdialLoading ? CancelingText : CancelText, class: "interaction-btn" }, { children: [!outdialLoading && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ slot: "text" }, { children: [" ", CancelText, " "] })), outdialLoading && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ slot: "text", className: "cancelling-text-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "16" }), " ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "cancelling-text" }, { children: CancelingText }))] })))] })) })));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        loadPlaceholderTimeoutIdRef.current = (0,timers__WEBPACK_IMPORTED_MODULE_4__.setTimeout)(() => {
            if (isRequestInProgress && loadingPlaceholderRef.current) {
                loadingPlaceholderRef.current.innerHTML = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().common.loading;
            }
        }, 100);
        return () => {
            if (loadPlaceholderTimeoutIdRef.current) {
                clearTimeout(loadPlaceholderTimeoutIdRef.current);
            }
        };
    }, [isRequestInProgress]);
    const getActionButtons = (buttonLocalized, idx) => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-tooltip", Object.assign({ placement: "bottom", message: showCallingButtonFor1NCampaignCall() || (buttonLocalized === null || buttonLocalized === void 0 ? void 0 : buttonLocalized.label) }, (!isButtonTextOverflow ? { disabled: true } : ""), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "sr-only", ref: loadingPlaceholderRef, "aria-live": "polite", role: "alert" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ id: `acceptInteraction-${config.id}`, ref: activeFocus, onFocus: focusOnButton, onClick: handleAccept, onKeyDown: handleKeyPress, maxWidth: "85px", variant: _constants__WEBPACK_IMPORTED_MODULE_13__.GREEN, ariaLabel: `${getAcceptAriaLabel(buttonLocalized === null || buttonLocalized === void 0 ? void 0 : buttonLocalized.acceptAriaLabel, buttonLocalized === null || buttonLocalized === void 0 ? void 0 : buttonLocalized.contactTitle, idx)}` }, (isRequestInProgress
                    ? {
                        loading: isRequestInProgress,
                        disabled: true
                    }
                    : null), (isPopoverOfCall ? { "aria-disabled": true, disabled: true } : ""), { class: classnames__WEBPACK_IMPORTED_MODULE_2___default()("interaction-btn", {
                        "accept-btn-call": isPopoverOfCall,
                        glowing: isFlashing
                    }) }, { children: isRequestInProgress ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { slot: "icon" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ slot: "text" }, { children: showCallingButtonFor1NCampaignCall() || (buttonLocalized === null || buttonLocalized === void 0 ? void 0 : buttonLocalized.label) }))] })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ slot: "text" }, { children: [" ", showCallingButtonFor1NCampaignCall() || (buttonLocalized === null || buttonLocalized === void 0 ? void 0 : buttonLocalized.label)] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "interaction-btn--glow" }, { children: [" ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "text-ellipsis popover-button" })] }))] })) }))] })));
    };
    const renderActionButtons = (buttonLocalized, popoverIndex) => {
        if (popoverHasAnswerDeclineButtons()) {
            return getAnswerDeclineCallButtons(popoverIndex);
        }
        // Remove the cancel button and only show the Ringing button when agent is offered call for 1:N progressive campaign
        return showOutdialCancel() ? getCancelOutdialButton() : getActionButtons(buttonLocalized, popoverIndex);
    };
    const isButtonEnabledForOutdial = () => {
        return showOutdialCancel() && !outdialLoading && !isWebCall();
    };
    const isButtonEnabledForEmailChat = () => {
        return !isPopoverOfCall && !isRequestInProgress;
    };
    const callAnswerBtnEnabled = () => {
        return isWebCall() && (!isAcceptCallDisabled() || !!isCampaignCalling);
    };
    /**
     * Bug: CX-10529
     * Checks if the interaction button is enabled and accordingly will set the tabIndex for the md-taskitem containers tabindex.
     *
     * This function checks if the interaction button is enabled based on several conditions:
     * - If it's an email or chat interaction and the request is not in progress.
     * - If the interaction is an outdial call and and not in the the loading state.
     * - If it's a web call and the accept button is not disabled.
     *
     * @returns {boolean} Returns true if any of the above conditions are met, otherwise returns false.
     */
    const isInteractionButtonEnabled = () => {
        return isButtonEnabledForEmailChat() || isButtonEnabledForOutdial() || callAnswerBtnEnabled();
    };
    const getAcceptAriaLabel = (acceptAriaLabel, contactTitle, idx) => {
        return (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.replacePlaceholders)(acceptAriaLabel, {
            taskType: mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.SOCIAL ? mediaChannel : mediaType,
            from: contactTitle,
            taskNumber: idx + 1
        });
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_css_common_css__WEBPACK_IMPORTED_MODULE_15___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ id: id, ref: popover, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("popover", {
                    "popover-light": !isDarkMode,
                    "popover-slide-in": !isSeen && !isBeingRemoved && !isTaskList,
                    "popover-slide-out": isBeingRemoved && !isTaskList,
                    "popover-telephony": isPopoverOfCall,
                    "popover-task-list": isTaskList,
                    "popover-expanded": showDetails,
                    "popover-dark": isDarkMode,
                    collapsed: isTaskList && !(limitingDetails && showDetails) && !isInvitationPopover
                }) }, { children: isInvitationPopover ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("header", { "popover-call-green": isPopoverOfCall }, { "header-error": errorMessage }) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-task-item", Object.assign({ selected: true, mediaType: getMediaType(), status: "", "item-title": contactTitle, iconSrc: (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_9__.getImageSrcGeneric)(mediaType, mediaChannel, isDarkMode || false) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ slot: "queue" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "connecting-loader" }, { children: [popoverTitle, " ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-loading", { class: "loader" })] })) })) })) }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("header", { "popover-call-green": isPopoverOfCall }, { "header-error": errorMessage }) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-task-item", Object.assign({ id: "taskItemId", onFocus: handleInitialFocus }, (outdialLoading
                                    ? {
                                        customAriaLabel: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interaction_control.callCancelledInProgress
                                    }
                                    : ""), { selected: true, tabIndexForContainer: isInteractionButtonEnabled() ? "-1" : "0", popovertitle: getPopOverTitle(), mediaType: getMediaType(), status: "", "item-title": getContactTitle(), iconSrc: (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_9__.getImageSrcGeneric)(mediaType, mediaChannel, isDarkMode || false, showDetails || false) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ slot: "queue" }, { children: [mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.MIDCALL_MONITORING ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { class: "channel-icon", name: "handset-active_10" })) : null, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "queue-name" }, { children: [getChannelTitle(), !(0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__.isMediaTypeDigitalOutbound)(mediaType) ? " - " : ""] })), config.time && !(0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_12__.isMediaTypeDigitalOutbound)(mediaType) ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "popover-timer" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AgentStateSelector_StateTimer__WEBPACK_IMPORTED_MODULE_8__["default"], { color: _constants__WEBPACK_IMPORTED_MODULE_13__.NONE, timerTimeStamp: config.time }) }))) : null] })), button && renderActionButtons(button, popoverIndex)] })), errorMessage && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "popover-error text-ellipsis" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-error_12", class: "popover-error-icon" }), isIncomingWebexCallWithKnownDeviceDetails()
                                            ? errorMessage
                                            : contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.INBOUND
                                                ? (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interactionPopover.unableToAccept
                                                : (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interactionPopover.unableToEnd, " ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("details", Object.assign({ className: "error-details" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("summary", Object.assign({ className: "trackingId-summary" }, { children: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().common.errorDetails })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "popover-trackingId" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "popover-trackingId-number" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "trackingId-label" }, { children: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().common.trackingIdInputLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("trackingid-input", {
                                                                        "trackingid-input-call-green": isPopoverOfCall
                                                                    }), type: "text", ref: refTrackingId, value: popoverTrackingId, readOnly: true })] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "popover-trackingId-copyBtn" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ class: "copy-trackingId-btn", onClick: copyTrackingID, ref: refTrackingIdCpyBtn, color: _constants__WEBPACK_IMPORTED_MODULE_13__.WHITE, circle: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "icon-copy_12" }) })) }))] }))] }))] }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "popover-toggle-button" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ref: toggleFocus, onClick: toggleShowDetails, onKeyPress: handleKeyPressToggle, class: "details-toggle-btn", color: _constants__WEBPACK_IMPORTED_MODULE_13__.WHITE, hasRemoveStyle: true, size: _constants__WEBPACK_IMPORTED_MODULE_13__.POPOVER_BUTTON_SIZE, ariaExpanded: showDetails, ariaLabel: `${mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_11__.MEDIA_TYPES.SOCIAL ? mediaChannel : mediaType} ${(0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().interactionPopover.requestDetails}` }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: showDetails ? _constants__WEBPACK_IMPORTED_MODULE_13__.ICON_ARROW_UP : _constants__WEBPACK_IMPORTED_MODULE_13__.ICON_ARROW_DOWN }) })) }))] })), limitingDetails && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dl", Object.assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("popover-details", {
                                "popover-details-light": !isDarkMode,
                                "popover-details-dark": isDarkMode,
                                "popover-call-green": isPopoverOfCall,
                                "popover-details-show": showDetails
                            }) }, { children: limitingDetails.map((row) => {
                                var _a;
                                return row.value && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "popover-details-row" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_TooltipEllipsis__WEBPACK_IMPORTED_MODULE_10__["default"], Object.assign({ value: `${row.label}`, placement: "top" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "popover-details-row-label text-ellipsis" }, { children: row.label })) })) }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_TooltipEllipsis__WEBPACK_IMPORTED_MODULE_10__["default"], Object.assign({ value: `${row.value}`, placement: "top" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "popover-details-row-value text-ellipsis" }, { children: `${((_a = row === null || row === void 0 ? void 0 : row.value) === null || _a === void 0 ? void 0 : _a.includes(_constants__WEBPACK_IMPORTED_MODULE_5__.WEB_RTC_PREFIX)) ? _constants__WEBPACK_IMPORTED_MODULE_5__.DESKTOP : row.value}` })) })) })] }), row.label));
                            }) })))] })) })) })) }));
};


/***/ }),

/***/ "./src/direflow-components/InteractionPopoverManager/components/InteractionPopoverPagination/index.tsx":
/*!*************************************************************************************************************!*\
  !*** ./src/direflow-components/InteractionPopoverManager/components/InteractionPopoverPagination/index.tsx ***!
  \*************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionPopoverPagination: () => (/* binding */ InteractionPopoverPagination)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");



/**
 * Interaction Popover component, renders all info along with action for popover
 */
const InteractionPopoverPagination = ({ showPrevious, showNext, paginationInfo, currentIndexOfPool, numberOfAccept, numberOfPages, acceptAll }) => {
    /** Loading i18 */
    const { interactionPopover: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.useI18nContext)();
    const PAGINATION_ACCEPT_BUTTON_WIDTH = "160px";
    /** Return the paignation ellipses  */
    const getPaginatonEllipses = () => {
        const paginationEllip = [];
        for (let indexOfPool = 0; indexOfPool < numberOfPages; indexOfPool += 1) {
            paginationEllip.push((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("popover-dot", {
                    "popover-dot-selected": currentIndexOfPool === indexOfPool
                }) }, indexOfPool));
        }
        return paginationEllip;
    };
    const getTextWithNumberOfAccept = () => {
        return i18n.acceptMultipleRequest.replace("{requestCount}", numberOfAccept);
    };
    const getPaginationDetails = () => {
        const localisedStringMapObj = {
            "{indexStart}": paginationInfo.indexStart,
            "{indexEnd}": paginationInfo.indexEnd,
            "{totalPopoverpoolLength}": paginationInfo.totalPopoverpoolLength
        };
        const regex = new RegExp(Object.keys(localisedStringMapObj).join("|"), "gi");
        return i18n.paginationDetail.replace(regex, (matched) => {
            return localisedStringMapObj[matched];
        });
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "popover-pagination" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "pagination-info" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ id: "showPrevious", class: "pagination-button", hasRemoveStyle: true, ariaLabel: i18n.back, onClick: showPrevious }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "arrow-left_16" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "pagination-detail" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ id: "pagination-count-details" }, { children: getPaginationDetails() })) }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "ellipses-popover" }, { children: getPaginatonEllipses() }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ id: "showNext", hasRemoveStyle: true, class: "pagination-button", ariaLabel: i18n.next, onClick: showNext }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "arrow-right-bold", size: "16", iconSet: "momentumDesign" }) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "pagination-accept-all" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: getTextWithNumberOfAccept() }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ id: "acceptAll", maxWidth: PAGINATION_ACCEPT_BUTTON_WIDTH, color: "blue", outline: true, ariaLabel: getTextWithNumberOfAccept(), onClick: acceptAll }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ slot: "text" }, { children: getTextWithNumberOfAccept() })) })) })) }))] })) }));
};


/***/ }),

/***/ "./src/direflow-components/InteractionPopoverManager/components/index.css":
/*!********************************************************************************!*\
  !*** ./src/direflow-components/InteractionPopoverManager/components/index.css ***!
  \********************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../../node_modules/css-loader/dist/cjs.js!./index.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/InteractionPopoverManager/components/index.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/InteractionPopoverManager/components/index.tsx":
/*!********************************************************************************!*\
  !*** ./src/direflow-components/InteractionPopoverManager/components/index.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../constants */ "./src/direflow-components/InteractionPopoverManager/constants.ts");
/* harmony import */ var _Utils_InteractionListenerAndRequests__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Utils/InteractionListenerAndRequests */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionListenerAndRequests.ts");
/* harmony import */ var _Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Utils/InteractionPopoversUtils */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./index.css */ "./src/direflow-components/InteractionPopoverManager/components/index.css");
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _InteractionPopover_InteractionPopover__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./InteractionPopover/InteractionPopover */ "./src/direflow-components/InteractionPopoverManager/components/InteractionPopover/InteractionPopover.tsx");
/* harmony import */ var _InteractionPopoverPagination__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./InteractionPopoverPagination */ "./src/direflow-components/InteractionPopoverManager/components/InteractionPopoverPagination/index.tsx");












/**
 * Stack for interaction popover
 */
const InteractionPopoverManager = ({ agentconfig, taskMap, popoverConfig, agentId }) => {
    const [popoverArr, setPopoverArr] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [popoversPerMediaType, setPopoversPerMediaType] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        call: [],
        chat: [],
        social: [],
        email: []
    });
    const [lastExpandedPopover, setLastExpandedPopover] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)();
    const [lastExpandedPaginatedPopover, setLastExpandedPaginatedPopover] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)();
    const [currentIndexOfPool, setCurrentIndexOfPool] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const [paginatedPopoverPool, setPaginatedPopoverPool] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [poolIndex, setPoolIndex] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        indexStart: 1,
        indexEnd: paginatedPopoverPool[0] ? paginatedPopoverPool[0].length : 0,
        totalPopoverpoolLength: paginatedPopoverPool.length
    });
    const isTaskListProp = !!(popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isTaskList);
    const isDarkMode = popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isDarkMode;
    const popoverconfigRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(popoverConfig);
    popoverconfigRef.current = popoverConfig;
    const dispatchCustom = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.EventContext);
    /**
     * Git issue, getting current state in callback
     * https://github.com/facebook/react/issues/16154
     */
    const removePopoverTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const popoversUpdatedRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(popoverArr);
    popoversUpdatedRef.current = popoverArr;
    const popoversPerMediaTypeRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(popoversPerMediaType);
    popoversPerMediaTypeRef.current = popoversPerMediaType;
    const paginatedPoolUpdatedRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(paginatedPopoverPool);
    paginatedPoolUpdatedRef.current = paginatedPopoverPool;
    const currentIndexOfPoolRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(currentIndexOfPool);
    currentIndexOfPoolRef.current = currentIndexOfPool;
    const lastExpandedPopoverRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(lastExpandedPopover);
    lastExpandedPopoverRef.current = lastExpandedPopover;
    const lastExpandedPaginatedPopoverRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(lastExpandedPaginatedPopover);
    lastExpandedPaginatedPopoverRef.current = lastExpandedPaginatedPopover;
    /** Add error to popover */
    const addError = (data, error) => {
        // clear previous error
        clearError(data);
        if (isTaskListProp) {
            const updatedPopovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverErrorState)(popoversUpdatedRef.current, data.id, error.message, (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error));
            setPopoverArr(updatedPopovers);
        }
        else {
            const processedPopovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverErrorState)(paginatedPoolUpdatedRef.current[currentIndexOfPoolRef.current], data.id, error.message, (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error));
            const paginatedCopy = [...paginatedPoolUpdatedRef.current];
            paginatedCopy[currentIndexOfPoolRef.current] = processedPopovers;
            setPaginatedPopoverPool(paginatedCopy);
        }
    };
    const clearError = (data) => {
        if (isTaskListProp) {
            const updatedPopovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverErrorState)(popoversUpdatedRef.current, data.id, "", "");
            setPopoverArr(updatedPopovers);
        }
        else {
            const processedPopovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverErrorState)(paginatedPoolUpdatedRef.current[currentIndexOfPoolRef.current], data.id, "", "");
            const paginatedCopy = [...paginatedPoolUpdatedRef.current];
            paginatedCopy[currentIndexOfPoolRef.current] = processedPopovers;
            setPaginatedPopoverPool(paginatedCopy);
        }
    };
    const setPopoverPoolIndex = () => {
        let curr = currentIndexOfPool;
        if (curr === paginatedPoolUpdatedRef.current.length && curr !== 0) {
            setCurrentIndexOfPool(curr - 1);
            curr -= 1;
        }
        setPoolIndex({
            indexStart: curr === 0 ? 1 : (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.getPreviousAllPopovers)(curr - 1, paginatedPoolUpdatedRef.current) + 1,
            indexEnd: paginatedPoolUpdatedRef.current[curr]
                ? (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.getPreviousAllPopovers)(curr, paginatedPoolUpdatedRef.current)
                : 0,
            totalPopoverpoolLength: popoversPerMediaTypeRef.current.call.length +
                popoversPerMediaTypeRef.current.chat.length +
                popoversPerMediaTypeRef.current.email.length +
                popoversPerMediaTypeRef.current.social.length
        });
    };
    const paginatedPoolMap = (paginPool) => paginPool.map((pool) => {
        if (pool.length > 0) {
            return (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverExpandState)(pool, pool[pool.length - 1].config.id);
        }
        return pool;
    });
    const updatePaginatedPool = (popoversPerMedia) => {
        const paginatedPool = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.getPopoversPaginated)(popoversPerMedia.email.concat(popoversPerMedia.social).concat(popoversPerMedia.chat), popoversPerMedia.call);
        const newPaginatedPool = paginatedPoolMap(paginatedPool);
        paginatedPoolUpdatedRef.current = newPaginatedPool;
        setPaginatedPopoverPool(newPaginatedPool);
        setPopoverPoolIndex();
    };
    const removePopoverHelper = (popover) => {
        const updatedPopover = popoversUpdatedRef.current.filter((pop) => pop.config.id !== popover.id);
        if (updatedPopover.length > 0) {
            const updatedPopoversExp = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverExpandState)(updatedPopover, updatedPopover[updatedPopover.length - 1].config.id);
            setPopoverArr(updatedPopoversExp);
        }
        else {
            setPopoverArr(updatedPopover);
        }
    };
    /** Removes popover after slide animation */
    const removePopover = (popover) => {
        popoversPerMediaTypeRef.current = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.filterPopoverPerMediaTypes)(popoversPerMediaTypeRef.current, popover);
        setPopoversPerMediaType(popoversPerMediaTypeRef.current);
        updatePaginatedPool(popoversPerMediaTypeRef.current);
        const updatedPopovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverRemoveState)(popoversUpdatedRef.current, popover.id);
        setPopoverArr(updatedPopovers);
        if (isTaskListProp || popover.isInvitationPopover) {
            removePopoverHelper(popover);
        }
        else {
            if (removePopoverTimeoutIdRef.current) {
                window.clearTimeout(removePopoverTimeoutIdRef.current);
            }
            removePopoverTimeoutIdRef.current = window.setTimeout(() => {
                removePopoverHelper(popover);
            }, _constants__WEBPACK_IMPORTED_MODULE_6__.SLIDE_ANIMATION_TIME);
        }
    };
    const isWebCall = (popover) => {
        var _a;
        return ((_a = popoverconfigRef.current) === null || _a === void 0 ? void 0 : _a.deviceType) === _constants__WEBPACK_IMPORTED_MODULE_6__.BROWSER && popover.type === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.MEDIA_TYPES.VOICE;
    };
    /** Emit custom event for Contact Assigned Event */
    const contactAssignedEvent = (res) => {
        (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.dispatchCustomEvent)("ax-aqm-contact-assigned-event", { assigned: res }, dispatchCustom);
    };
    /** Emit custom event for showing incoming Popover */
    const fireNotification = (popover) => {
        (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.dispatchCustomEvent)("ax-fire-notification", popover, dispatchCustom);
    };
    /** Emit custom event for Unread Interaction Popover Count Event */
    const newPopoverCountEvent = (popoverCount) => {
        (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.dispatchCustomEvent)("ax-new-popover-count", popoverCount, dispatchCustom);
    };
    /** Emit custom event for Outdial End contact Event */
    const endOutboundCallContactEvent = (res) => {
        (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.dispatchCustomEvent)("ax-aqm-end-outbound-contact-event", { ended: res }, dispatchCustom);
    };
    /** Accepting the task from popover for web call in case of shortcut-key-press */
    const handleWCAccept = () => {
        (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.dispatchCustomEvent)(_constants__WEBPACK_IMPORTED_MODULE_6__.WEB_CALL_ANSWER, {}, dispatchCustom);
    };
    /** Accepting the task from popover */
    const acceptTask = (selectedPopover) => {
        if (isWebCall(selectedPopover)) {
            handleWCAccept();
            return;
        }
        (0,_Utils_InteractionListenerAndRequests__WEBPACK_IMPORTED_MODULE_7__.acceptInteractionRequest)(selectedPopover, removePopover, addError, contactAssignedEvent);
    };
    /** End the task from popover */
    const endTask = (selectedPopover) => {
        (0,_Utils_InteractionListenerAndRequests__WEBPACK_IMPORTED_MODULE_7__.endInteractionRequest)(selectedPopover, removePopover, addError, endOutboundCallContactEvent);
    };
    const answerCall = (selectedPopover) => {
        (0,_Utils_InteractionListenerAndRequests__WEBPACK_IMPORTED_MODULE_7__.answerCallRequest)(selectedPopover, removePopover, addError);
    };
    const declineCall = (selectedPopover) => {
        (0,_Utils_InteractionListenerAndRequests__WEBPACK_IMPORTED_MODULE_7__.declineCallRequest)(selectedPopover, removePopover, addError);
    };
    /** Show Popover after updating new contact to Array */
    const showPopover = (popover) => {
        const newPopover = {
            config: popover,
            acceptTask: popover.type !== _Common_constants__WEBPACK_IMPORTED_MODULE_5__.MEDIA_TYPES.VOICE || isWebCall(popover)
                ? (selectedPopover) => acceptTask(selectedPopover)
                : undefined,
            endTask: popover.type === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.MEDIA_TYPES.VOICE && popover.contactDirection === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.OUTBOUND
                ? (selectedPopover) => endTask(selectedPopover)
                : undefined,
            answerCall: popover.callingDeviceDetails
                ? (selectedPopover) => answerCall(selectedPopover)
                : undefined,
            declineCall: popover.callingDeviceDetails
                ? (selectedPopover) => declineCall(selectedPopover)
                : undefined
        };
        const popoverArrCopy = [...popoversUpdatedRef.current];
        // To  check if a popover with same interactionid exists, do not create the new popover
        // Only in case of consult accept
        const isPopoverExists = popoverArrCopy.find((thisPopover) => {
            var _a;
            const newPopoverButtonId = (_a = newPopover.config.header.button) === null || _a === void 0 ? void 0 : _a.id;
            return (!thisPopover.config.isInvitationPopover &&
                thisPopover.config.id === newPopover.config.id &&
                (newPopoverButtonId === null || newPopoverButtonId === void 0 ? void 0 : newPopoverButtonId.startsWith("consult-accept")));
        });
        if (!isPopoverExists) {
            popoversPerMediaTypeRef.current = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.populatePopoverPerMediaTypes)(popoversPerMediaTypeRef.current, newPopover);
            setPopoversPerMediaType(popoversPerMediaTypeRef.current);
            /** Putting in array as per priority, with call at bottom with highest and email with least */
            updatePaginatedPool(popoversPerMediaTypeRef.current);
            const popovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.mergePopoverViaPriority)(popoversPerMediaTypeRef.current, isTaskListProp);
            if (popovers.length > 0) {
                /** Putting the highest priority one to be expanded always */
                let updatedPopoverConfigs;
                if (isTaskListProp) {
                    updatedPopoverConfigs = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverExpandState)(popovers, popovers[0].config.id);
                }
                else {
                    updatedPopoverConfigs = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverExpandState)(popovers, popovers[popovers.length - 1].config.id);
                }
                const newconfigs = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverSeenState)(updatedPopoverConfigs, popover.id);
                setPopoverArr(newconfigs);
                !newPopover.config.isInvitationPopover && fireNotification(newPopover.config); // audio is played in ax-fire-notification event
            }
        }
    };
    const updatePopover = (updatedPopover) => {
        const updatePopoverArray = (popoverArray) => {
            return popoverArray.map((thisPopover) => {
                if (thisPopover.config.id === updatedPopover.id) {
                    return Object.assign(Object.assign({}, thisPopover), { config: Object.assign(Object.assign({}, thisPopover.config), updatedPopover) });
                }
                return thisPopover;
            });
        };
        // updates the dataset being used in the task list
        const updatedPopoverArr = updatePopoverArray(popoversUpdatedRef.current);
        setPopoverArr(updatedPopoverArr);
        popoversUpdatedRef.current = updatedPopoverArr;
        // updates the dataset being used for the paginated popovers when the task list is minimized
        const updatedPaginatedPopovers = paginatedPoolUpdatedRef.current.map(updatePopoverArray);
        setPaginatedPopoverPool(updatedPaginatedPopovers);
        paginatedPoolUpdatedRef.current = updatedPaginatedPopovers;
    };
    const switchBetweenPopover = () => {
        var _a;
        if ((_a = popoverconfigRef.current) === null || _a === void 0 ? void 0 : _a.isTaskList) {
            const popovers = popoversUpdatedRef.current;
            if (popovers.length > 0) {
                const currentExpandedPopover = popovers.findIndex((pop) => pop.config.expandedState);
                let nextExpandedIndex = 0;
                if (currentExpandedPopover - 1 > 0) {
                    nextExpandedIndex = currentExpandedPopover - 1;
                }
                else if (currentExpandedPopover === 0) {
                    nextExpandedIndex = popovers.length - 1;
                }
                const processedPopovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverExpandState)(popovers, popovers[nextExpandedIndex].config.id);
                setPopoverArr(processedPopovers);
            }
        }
        else {
            const popovers = paginatedPoolUpdatedRef.current[currentIndexOfPoolRef.current];
            if (popovers.length > 0) {
                const currentExpandedPopover = popovers.findIndex((pop) => pop.config.expandedState);
                let nextExpandedIndex = 0;
                if (currentExpandedPopover - 1 > 0) {
                    nextExpandedIndex = currentExpandedPopover - 1;
                }
                else if (currentExpandedPopover === 0) {
                    nextExpandedIndex = popovers.length - 1;
                }
                const processedPopovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverExpandState)(popovers, popovers[nextExpandedIndex].config.id);
                const paginPool = [...paginatedPoolUpdatedRef.current];
                paginPool[currentIndexOfPoolRef.current] = processedPopovers;
                setPaginatedPopoverPool(paginPool);
            }
        }
    };
    const executeAcceptShortcut = () => {
        var _a;
        if ((_a = popoverconfigRef.current) === null || _a === void 0 ? void 0 : _a.isTaskList) {
            const popovers = popoversUpdatedRef.current;
            const currentExpandedPopover = popovers.find((pop) => pop.config.expandedState && pop.acceptTask);
            if (currentExpandedPopover) {
                acceptTask(currentExpandedPopover === null || currentExpandedPopover === void 0 ? void 0 : currentExpandedPopover.config);
            }
        }
        else {
            const popovers = paginatedPoolUpdatedRef.current[currentIndexOfPoolRef.current];
            const currentExpandedPopover = popovers.find((pop) => pop.config.expandedState && pop.acceptTask);
            if (currentExpandedPopover) {
                acceptTask(currentExpandedPopover === null || currentExpandedPopover === void 0 ? void 0 : currentExpandedPopover.config);
            }
        }
    };
    const expandCollapseShortcut = () => {
        var _a, _b, _c, _d, _e;
        if ((_a = popoverconfigRef.current) === null || _a === void 0 ? void 0 : _a.isTaskList) {
            const popovers = popoversUpdatedRef.current;
            const currentExpandedPopover = popovers.find((pop) => pop.config.expandedState);
            if (currentExpandedPopover) {
                lastExpandedPopoverRef.current = currentExpandedPopover;
                setLastExpandedPopover(currentExpandedPopover);
                setPopoverArr((0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverCollapseState)(popovers, currentExpandedPopover === null || currentExpandedPopover === void 0 ? void 0 : currentExpandedPopover.config.id));
            }
            else if ((_b = lastExpandedPopoverRef.current) === null || _b === void 0 ? void 0 : _b.config.id) {
                setPopoverArr((0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverExpandState)(popovers, (_c = lastExpandedPopoverRef.current) === null || _c === void 0 ? void 0 : _c.config.id));
            }
        }
        else {
            const paginatedPool = paginatedPoolUpdatedRef.current[currentIndexOfPoolRef.current];
            const currentExpandedPopover1 = paginatedPool.findIndex((pop) => pop.config.expandedState);
            let processedPopovers1;
            if (currentExpandedPopover1 >= 0) {
                lastExpandedPaginatedPopoverRef.current = paginatedPool[currentExpandedPopover1];
                setLastExpandedPaginatedPopover(paginatedPool[currentExpandedPopover1]);
                processedPopovers1 = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverCollapseState)(paginatedPool, paginatedPool[currentExpandedPopover1].config.id);
            }
            else if ((_d = lastExpandedPaginatedPopoverRef.current) === null || _d === void 0 ? void 0 : _d.config.id) {
                processedPopovers1 = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverExpandState)(paginatedPool, (_e = lastExpandedPaginatedPopoverRef.current) === null || _e === void 0 ? void 0 : _e.config.id);
            }
            const paginCopy = [...paginatedPoolUpdatedRef.current];
            paginCopy[currentIndexOfPoolRef.current] = processedPopovers1;
            setPaginatedPopoverPool(paginCopy);
        }
    };
    const acceptAll = () => {
        paginatedPoolUpdatedRef.current[currentIndexOfPoolRef.current].forEach((popOver) => {
            if (popOver.acceptTask) {
                popOver.acceptTask(popOver.config);
            }
        });
    };
    const acceptAllInTaskList = () => {
        popoverArr.forEach((pop) => {
            if (pop.acceptTask) {
                pop.acceptTask(pop.config);
            }
        });
    };
    const executeShortcut = (key) => {
        if (key.data &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.ACCEPT_TASK_KEY) {
            executeAcceptShortcut();
        }
        else if (key.data &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.SWITCH_POPOVER_KEY) {
            switchBetweenPopover();
        }
        else if (key.data &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_SHIFT &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.EXPAND_COLLAPSE_POPOVER_KEY) {
            expandCollapseShortcut();
        }
        else if (key.data &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_SHIFT &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.ACCEPT_ALL_TASK_KEY &&
            paginatedPoolUpdatedRef.current.length > 1) {
            acceptAll();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((key) => executeShortcut(key));
        return () => {
            if (stopListen) {
                stopListen();
            }
            if (removePopoverTimeoutIdRef.current) {
                window.clearTimeout(removePopoverTimeoutIdRef.current);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        newPopoverCountEvent(popoverArr.length);
    }, [popoverArr.length]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f;
        const popoverToRemove = popoverArr.filter((pop) => !Object.keys(taskMap).includes(pop.config.id) ||
            (Object.keys(taskMap).includes(pop.config.id) &&
                pop.config.isInvitationPopover &&
                (taskMap[pop.config.id].type === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.EVENT_TYPES.AGENT_OFFER_CONTACT ||
                    taskMap[pop.config.id].type === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.EVENT_TYPES.AGENT_OFFER_CONSULT ||
                    taskMap[pop.config.id].type === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.EVENT_TYPES.AGENT_OFFER_CAMPAIGN_RESERVED ||
                    taskMap[pop.config.id].type === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.EVENT_TYPES.AGENT_ADD_CAMPAIGN_RESERVED)));
        popoverToRemove.forEach((pop) => {
            removePopover(pop.config);
        });
        (0,_Utils_InteractionListenerAndRequests__WEBPACK_IMPORTED_MODULE_7__.processInteractionUpdates)(agentId, showPopover, updatePopover, removePopover, taskMap, popoversUpdatedRef.current, {
            isDesktopConsultToEntryPointDnEnabled: (_a = popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isDesktopConsultToEntryPointDnEnabled) !== null && _a !== void 0 ? _a : false,
            isProgressiveCampaignEnabled: (_b = popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isProgressiveCampaignEnabled) !== null && _b !== void 0 ? _b : false,
            isProgressiveCampaign1NEnabled: (_c = popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isProgressiveCampaign1NEnabled) !== null && _c !== void 0 ? _c : false,
            isDesktopCpdViewEnabled: (_d = popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isDesktopCpdViewEnabled) !== null && _d !== void 0 ? _d : false,
            isProgressive11SpecialModeEnabled: (_e = agentconfig === null || agentconfig === void 0 ? void 0 : agentconfig.isProgressive11SpecialModeEnabled) !== null && _e !== void 0 ? _e : false
        });
        setCallingForCampaignCalls(taskMap, (_f = popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isProgressiveCampaign1NEnabled) !== null && _f !== void 0 ? _f : false);
    }, [taskMap]);
    const checkIfAgentAddedToCampaign = (taskObj) => {
        var _a, _b;
        return ((taskObj.type === _Common_constants__WEBPACK_IMPORTED_MODULE_5__.EVENT_TYPES.AGENT_ADD_CAMPAIGN_RESERVED || taskObj.reservedAgentChannelId) &&
            ((_a = taskObj.interaction.participants[taskObj.agentId]) === null || _a === void 0 ? void 0 : _a.hasJoined) &&
            !((_b = taskObj.interaction.participants[agentId]) === null || _b === void 0 ? void 0 : _b.isWrapUp));
    };
    const checkForUpdatedPopover = (taskMap) => {
        let popExist;
        Object.keys(taskMap).forEach((task) => {
            const taskObj = taskMap[task];
            popExist = popoversUpdatedRef.current.find((pop) => pop.config.id === taskObj.interactionId && checkIfAgentAddedToCampaign(taskObj));
        });
        return popExist;
    };
    const setCallingForCampaignCalls = (taskMap, isProgressiveCampaign1NEnabled) => {
        let popExist;
        if (isTaskListProp) {
            popExist = checkForUpdatedPopover(taskMap);
            if (popExist) {
                const updatedPopovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverCampainCallState)(popoversUpdatedRef.current, popExist.config.id);
                setPopoverArr(updatedPopovers);
            }
        }
        else {
            const popover = paginatedPoolUpdatedRef.current[currentIndexOfPoolRef.current];
            popExist = checkForUpdatedPopover(taskMap);
            if (popExist) {
                const updatedPopovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverCampainCallState)(popover, popExist.config.id);
                const paginatedCopy = [...paginatedPoolUpdatedRef.current];
                paginatedCopy[currentIndexOfPoolRef.current] = updatedPopovers;
                setPaginatedPopoverPool(paginatedCopy);
            }
        }
    };
    /** Callback when popover is expanded  */
    const popoverExpanded = (config) => {
        if (isTaskListProp) {
            const processedPopovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverExpandState)(popoverArr, config.id);
            setPopoverArr(processedPopovers);
        }
        else {
            const processedPopovers = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.updatePopoverExpandState)(paginatedPoolUpdatedRef.current[currentIndexOfPool], config.id);
            const paginatedPoolCopy = [...paginatedPoolUpdatedRef.current];
            paginatedPoolCopy[currentIndexOfPool] = processedPopovers;
            setPaginatedPopoverPool(paginatedPoolCopy);
        }
    };
    const setSeenForAllStack = () => {
        const newPool = paginatedPopoverPool[currentIndexOfPool].map((pop) => {
            (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.setIsSeenPopoverPerMediaType)(popoversPerMediaTypeRef.current, pop);
            return Object.assign(Object.assign({}, pop), { isSeen: true });
        });
        const paginCopy = [...paginatedPopoverPool];
        paginCopy[currentIndexOfPool] = newPool;
        setPaginatedPopoverPool(paginCopy);
    };
    const showPrevious = () => {
        if (currentIndexOfPoolRef.current > 0) {
            setSeenForAllStack();
            setCurrentIndexOfPool(currentIndexOfPool - 1);
        }
    };
    const showNext = () => {
        if (currentIndexOfPoolRef.current < paginatedPoolUpdatedRef.current.length - 1) {
            setSeenForAllStack();
            setCurrentIndexOfPool(currentIndexOfPool + 1);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        const paginPool = (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.getPopoversPaginated)(popoversPerMediaTypeRef.current.email
            .concat(popoversPerMediaTypeRef.current.social)
            .concat(popoversPerMediaTypeRef.current.chat), popoversPerMediaTypeRef.current.call);
        const paginatedPool = paginatedPoolMap(paginPool);
        setPopoverPoolIndex();
        setPaginatedPopoverPool(paginatedPool);
    }, [popoverArr.length]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        setPopoverPoolIndex();
    }, [currentIndexOfPool]);
    const acceptAllTasks = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ id: "acceptAllTask", className: "acceptAll", onClick: () => acceptAllInTaskList() }, { children: (popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isTaskList) && popoverArr.length > 5 ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ class: "accept-all-btn", color: "blue", outline: true }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ slot: "text" }, { children: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.getLocalizedMessages)().interactionPopover.acceptAll })) }))) : ("") })));
    };
    const popoverTemplate = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: popoverArr.map((popover, index) => ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InteractionPopover_InteractionPopover__WEBPACK_IMPORTED_MODULE_10__.InteractionPopover, { isDarkMode: isDarkMode, agentId: agentId, config: popover.config, acceptTask: popover.acceptTask, endTask: popover.endTask, answerCall: popover.answerCall, declineCall: popover.declineCall, popoverExpanded: popoverExpanded, errorMessage: popover.errorMessage, popoverTrackingId: popover.popoverTrackingId, isSeen: popover.isSeen, isBeingRemoved: popover.isBeingRemoved, isEndCallEnabled: agentconfig.isendcallenabled, isTaskList: isTaskListProp, isProgressiveCampaignEnabled: (popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isProgressiveCampaignEnabled) || false, isProgressiveCampaign1NEnabled: (popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isProgressiveCampaign1NEnabled) || false, isSuppressWebexCallingNotificationEnabled: (popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isSuppressWebexCallingNotificationEnabled) || false, deviceType: (popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.deviceType) || null, isCampaignCalling: popover.isCampaignCalling, isAgentHandlingTask: agentconfig.isAgentHandlingTask, popoverIndex: index, isActivePopover: (popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isActivePopover) || false }, popover.config.id))) }));
    };
    const popoverPaginationTemplate = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [paginatedPopoverPool[currentIndexOfPool] &&
                    paginatedPopoverPool[currentIndexOfPool].map((popoverPagin, index) => ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InteractionPopover_InteractionPopover__WEBPACK_IMPORTED_MODULE_10__.InteractionPopover, { isDarkMode: isDarkMode, agentId: agentId, config: popoverPagin.config, acceptTask: popoverPagin.acceptTask, endTask: popoverPagin.endTask, answerCall: popoverPagin.answerCall, declineCall: popoverPagin.declineCall, popoverExpanded: popoverExpanded, errorMessage: popoverPagin.errorMessage, popoverTrackingId: popoverPagin.popoverTrackingId, isSeen: popoverPagin.isSeen, isBeingRemoved: popoverPagin.isBeingRemoved, isEndCallEnabled: agentconfig.isendcallenabled, isTaskList: isTaskListProp, isProgressiveCampaignEnabled: (popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isProgressiveCampaignEnabled) || false, isProgressiveCampaign1NEnabled: (popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isProgressiveCampaign1NEnabled) || false, isSuppressWebexCallingNotificationEnabled: (popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isSuppressWebexCallingNotificationEnabled) || false, deviceType: (popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.deviceType) || null, isCampaignCalling: popoverPagin.isCampaignCalling, isAgentHandlingTask: agentconfig.isAgentHandlingTask, popoverIndex: index, isActivePopover: (popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.isActivePopover) || false }, popoverPagin.config.id))), paginatedPopoverPool.length > 1 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InteractionPopoverPagination__WEBPACK_IMPORTED_MODULE_11__.InteractionPopoverPagination, { showPrevious: showPrevious, showNext: showNext, acceptAll: acceptAll, paginationInfo: poolIndex, currentIndexOfPool: currentIndexOfPool, numberOfAccept: paginatedPopoverPool[currentIndexOfPool].length - (0,_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_8__.getCallLenght)(paginatedPopoverPool), numberOfPages: paginatedPopoverPool.length }))] }));
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: (_index_css__WEBPACK_IMPORTED_MODULE_9___default()) }, { children: !isTaskListProp ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "popover_container" }, { children: popoverPaginationTemplate() }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "popover-task-list-parent" }, { children: [popoverTemplate(), acceptAllTasks()] }))) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InteractionPopoverManager);


/***/ }),

/***/ "./src/direflow-components/InteractionPopoverManager/constants.ts":
/*!************************************************************************!*\
  !*** ./src/direflow-components/InteractionPopoverManager/constants.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BLACK: () => (/* binding */ BLACK),
/* harmony export */   BROWSER: () => (/* binding */ BROWSER),
/* harmony export */   BUTTON: () => (/* binding */ BUTTON),
/* harmony export */   CHANNEL_ICON_SIZE: () => (/* binding */ CHANNEL_ICON_SIZE),
/* harmony export */   CONNECTED_INTERACTION: () => (/* binding */ CONNECTED_INTERACTION),
/* harmony export */   CONSULT_INTERACTION: () => (/* binding */ CONSULT_INTERACTION),
/* harmony export */   DIGITAL_OUTBOUND_AUTO_ANSWER: () => (/* binding */ DIGITAL_OUTBOUND_AUTO_ANSWER),
/* harmony export */   ENTER_KEY_CODE: () => (/* binding */ ENTER_KEY_CODE),
/* harmony export */   GREEN: () => (/* binding */ GREEN),
/* harmony export */   HANDLE_ERROR: () => (/* binding */ HANDLE_ERROR),
/* harmony export */   HANDLE_EXPAND: () => (/* binding */ HANDLE_EXPAND),
/* harmony export */   ICON_ARROW_DOWN: () => (/* binding */ ICON_ARROW_DOWN),
/* harmony export */   ICON_ARROW_UP: () => (/* binding */ ICON_ARROW_UP),
/* harmony export */   MAX_ROWS_ALLOWED: () => (/* binding */ MAX_ROWS_ALLOWED),
/* harmony export */   NEW_INTERACTION: () => (/* binding */ NEW_INTERACTION),
/* harmony export */   NONE: () => (/* binding */ NONE),
/* harmony export */   POPOVER_BUTTON_SIZE: () => (/* binding */ POPOVER_BUTTON_SIZE),
/* harmony export */   SLIDE_ANIMATION_TIME: () => (/* binding */ SLIDE_ANIMATION_TIME),
/* harmony export */   SPACE_KEY_CODE: () => (/* binding */ SPACE_KEY_CODE),
/* harmony export */   TAB_KEY: () => (/* binding */ TAB_KEY),
/* harmony export */   TAB_KEY_CODE: () => (/* binding */ TAB_KEY_CODE),
/* harmony export */   WC_ANSWER_BTN: () => (/* binding */ WC_ANSWER_BTN),
/* harmony export */   WC_CANCEL_BTN: () => (/* binding */ WC_CANCEL_BTN),
/* harmony export */   WC_DISCONNECTED: () => (/* binding */ WC_DISCONNECTED),
/* harmony export */   WC_ESTABLISHED: () => (/* binding */ WC_ESTABLISHED),
/* harmony export */   WC_NOT_FOUND: () => (/* binding */ WC_NOT_FOUND),
/* harmony export */   WEBEX_CALL_ANSWERED: () => (/* binding */ WEBEX_CALL_ANSWERED),
/* harmony export */   WEB_CALL_ANSWER: () => (/* binding */ WEB_CALL_ANSWER),
/* harmony export */   WEB_CALL_AUTO_ANSWER: () => (/* binding */ WEB_CALL_AUTO_ANSWER),
/* harmony export */   WEB_CALL_CANCEL: () => (/* binding */ WEB_CALL_CANCEL),
/* harmony export */   WHITE: () => (/* binding */ WHITE)
/* harmony export */ });
const ICON_ARROW_UP = "arrow-up_8";
const ICON_ARROW_DOWN = "arrow-down_8";
const MAX_ROWS_ALLOWED = 6;
const POPOVER_BUTTON_SIZE = 36;
const ENTER_KEY_CODE = 13;
const TAB_KEY_CODE = 9;
const TAB_KEY = "Tab";
const SPACE_KEY_CODE = 32;
const GREEN = "green";
const WHITE = "white-100";
const BLACK = "black-100";
const NONE = "none";
const CHANNEL_ICON_SIZE = 20;
const HANDLE_ERROR = "HANDLE_ERROR";
const HANDLE_EXPAND = "HANDLE_EXPAND";
const SLIDE_ANIMATION_TIME = 200;
const NEW_INTERACTION = "new";
const CONNECTED_INTERACTION = "connected";
const CONSULT_INTERACTION = "consult";
const BUTTON = "button";
const WC_ANSWER_BTN = "answer-btn";
const WC_CANCEL_BTN = "cancel-btn";
const WEB_CALL_ANSWER = "ax-web-call-answer";
const WEB_CALL_CANCEL = "ax-web-call-decline";
const WC_ESTABLISHED = "ax-web-call-established";
const WC_DISCONNECTED = "ax-web-call-disconnected";
const WEB_CALL_AUTO_ANSWER = "ax-web-call-auto-answer";
const DIGITAL_OUTBOUND_AUTO_ANSWER = "ax-digital-outbound-auto-answer";
const WC_NOT_FOUND = "ax-web-call-not-found";
const BROWSER = "BROWSER";
const WEBEX_CALL_ANSWERED = "ax-webex-call-answered";


/***/ }),

/***/ "./src/direflow-components/Keypad/index.tsx":
/*!**************************************************!*\
  !*** ./src/direflow-components/Keypad/index.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../constants */ "./src/constants.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../InteractionControl/constants */ "./src/direflow-components/InteractionControl/constants.js");
/* harmony import */ var _style_css__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./style.css */ "./src/direflow-components/Keypad/style.css");
/* harmony import */ var _style_css__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_style_css__WEBPACK_IMPORTED_MODULE_12__);













const Keypad = ({ defaultInpValue, webexCallingCallId }) => {
    const [dialNumber, setDialNumber] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [showSpinner, setShowSpinner] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const dialerRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const enterKeyFocusTimeOutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const setSpinnerTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const regexForDn = new RegExp("^[0-9*#]+$");
    const [inputCursorPos, setInputCursorPos] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0);
    const dispatch = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.EventContext);
    const dispatchCustomEvent = (eventName, detail) => {
        window.dispatchEvent(new CustomEvent(eventName, {
            detail,
            bubbles: true,
            composed: true
        }));
    };
    const hideSpinner = () => {
        if (setSpinnerTimeoutIdRef.current) {
            window.clearTimeout(setSpinnerTimeoutIdRef.current);
        }
        setSpinnerTimeoutIdRef.current = window.setTimeout(() => {
            setShowSpinner(false);
        }, _constants__WEBPACK_IMPORTED_MODULE_7__.LOADER_DISPLAY_DURATION);
    };
    /**
     * Debounced function to update the dtmf value to store
     * so as to handle the case of multiple interactions and switching in between
     */
    const updateDtmfValue = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_10__.debouncedFunc)((dtmfVal) => {
        const event = new CustomEvent("ax-update-dtmf-value", {
            detail: {
                value: dtmfVal
            }
        });
        if (dispatch) {
            dispatch(event);
        }
    }, _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_11__.THREE_HUNDRED_MS);
    const setDialNumberAndMakeAPIcall = (data) => {
        try {
            if (data.dnNumber) {
                setDialNumber(data.dnNumber);
                updateDtmfValue(data.dnNumber);
            }
            if (data.singleDigitEntered) {
                setShowSpinner(true);
                if (webexCallingCallId && webexCallingCallId !== "") {
                    _sdk__WEBPACK_IMPORTED_MODULE_8__.logger.info(`[Webex] : Sending DTMF for callId : ${webexCallingCallId}`);
                    dispatchCustomEvent(_Common_constants__WEBPACK_IMPORTED_MODULE_9__.AX_WEBEX_CALL_SEND_DTMF, { callId: webexCallingCallId, dtmf: data.singleDigitEntered });
                }
                else {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.webCalling.sendDTMF(data.singleDigitEntered);
                }
                hideSpinner();
            }
        }
        catch (e) {
            hideSpinner();
            _sdk__WEBPACK_IMPORTED_MODULE_8__.logger.error(`[WebRtc] : Error in making DTMF call : ${e}`);
        }
    };
    const inputChangeHandler = (e) => {
        const inputText = e.target.value || "";
        if (inputText) {
            if (!regexForDn.test(inputText)) {
                e.target.value = inputText.replace(/[^0-9*#.]/g, "").replace(/(\..*)\./g, "$1");
            }
            else {
                setDialNumber(e.target.value);
                setInputCursorPos(inputCursorPos + 1);
                updateDtmfValue(e.target.value);
            }
        }
        else if (inputText === "") {
            setDialNumber("");
        }
    };
    const handleDialerButtonPress = (e) => {
        if (e.detail) {
            // using timeout for setting focus on input
            if (enterKeyFocusTimeOutIdRef.current) {
                window.clearTimeout(enterKeyFocusTimeOutIdRef.current);
            }
            enterKeyFocusTimeOutIdRef.current = window.setTimeout(() => {
                var _a, _b;
                // When enter key is pressed the focus should remain on the dialer button
                // and will not come to input box
                if (!e.detail.isEnterKeyPressed) {
                    // set focus on input field whenever dial button is pressed
                    if ((_b = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("input")) {
                        inputRef.current.shadowRoot.querySelector("input").focus();
                    }
                    // to keep the cursor at end position resetting the input value
                    setDialNumber("");
                }
                setDialNumberAndMakeAPIcall(e.detail);
                setInputCursorPos(e.detail.inputCursorPos);
            }, _constants__WEBPACK_IMPORTED_MODULE_7__.DURATION_DIALER_BUTTON_PRESS);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if (defaultInpValue) {
            setDialNumber(defaultInpValue);
        }
        const dialerComp = dialerRef === null || dialerRef === void 0 ? void 0 : dialerRef.current;
        if (dialerComp) {
            dialerComp.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_7__.DIALER_BUTTON_CLICK_EVENT, handleDialerButtonPress);
        }
        return () => {
            if (dialerComp) {
                dialerComp.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_7__.DIALER_BUTTON_CLICK_EVENT, handleDialerButtonPress);
            }
            if (setSpinnerTimeoutIdRef.current) {
                window.clearTimeout(setSpinnerTimeoutIdRef.current);
            }
            if (enterKeyFocusTimeOutIdRef.current) {
                window.clearTimeout(enterKeyFocusTimeOutIdRef.current);
            }
        };
    }, []);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.Styled, Object.assign({ styles: (_style_css__WEBPACK_IMPORTED_MODULE_12___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "keypad-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-input", Object.assign({ ref: inputRef, autofocus: true, htmlId: "pillSearchInput", name: "pillSearchInput", "data-testid": "keypad-search", ariaLabel: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().keypad.keyPadSearch, placeholder: (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.getLocalizedMessages)().keypad.keyPadSearch, onInput: inputChangeHandler, class: "search-input", value: dialNumber }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }), { onKeyDown: (e) => {
                            // When Backspace or Delete key is pressed do not make an API call
                            if (e.keyCode === _constants__WEBPACK_IMPORTED_MODULE_7__.keyCode.backspace || e.keyCode === _constants__WEBPACK_IMPORTED_MODULE_7__.keyCode.delete) {
                                return;
                            }
                            if (regexForDn.test(e.key)) {
                                setDialNumberAndMakeAPIcall({ singleDigitEntered: e.key });
                            }
                        } }, { children: showSpinner && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { slot: "input-section-right", size: "20" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("agentx-react-dialer", { ref: dialerRef, dialNum: dialNumber, cursorPosition: inputCursorPos, showCharButton: true })] })) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_4__.observer)(Keypad));


/***/ }),

/***/ "./src/direflow-components/Keypad/style.css":
/*!**************************************************!*\
  !*** ./src/direflow-components/Keypad/style.css ***!
  \**************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../node_modules/css-loader/dist/cjs.js!./style.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Keypad/style.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/MultiLogin/component/index.tsx":
/*!****************************************************************!*\
  !*** ./src/direflow-components/MultiLogin/component/index.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Common/components/ErrorModal */ "./src/direflow-components/Common/components/ErrorModal/index.tsx");




const MultiLogin = () => {
    const { multiLogin: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.getLocalizedMessages)();
    const windowReloadTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const modalCallback = () => {
        windowReloadTimeoutIdRef.current = window.setTimeout(() => {
            window.location.reload();
        }, 2000); // Delaying Continue, as other agent registering.
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        return () => {
            if (windowReloadTimeoutIdRef.current) {
                window.clearTimeout(windowReloadTimeoutIdRef.current);
            }
        };
    }, []);
    const buttons = [{ label: i18n.continue, onClick: modalCallback, ariaLabel: i18n.continue }];
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_3__["default"], { message: i18n.message, modalHeader: i18n.header, isOpen: true, buttons: buttons, showCloseButton: false, noExitOnEsc: true }) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MultiLogin);


/***/ }),

/***/ "./src/direflow-components/Outdial/AddressBook/components/index.tsx":
/*!**************************************************************************!*\
  !*** ./src/direflow-components/Outdial/AddressBook/components/index.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _AddressBookIncreasedLimit_AddressBookIncreasedLimit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../AddressBookIncreasedLimit/AddressBookIncreasedLimit */ "./src/direflow-components/AddressBookIncreasedLimit/AddressBookIncreasedLimit.tsx");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _OutDialAni__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../OutDialAni */ "./src/direflow-components/Outdial/OutDialAni/index.tsx");
/* harmony import */ var _OutDialAniInfiniteScroll__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../OutDialAniInfiniteScroll */ "./src/direflow-components/Outdial/OutDialAniInfiniteScroll/index.tsx");












const AddressBook = ({ addressList, loadingError, loadingTrackingId, retryLoadingAddressBook, defaultSearchQuery, initiateOutboundCall, isAdhocDialingEnabled, closePopover, outdialAniList, resetFocusableElements, isDarkModeEnable, isAddressBookLoading, selectedANI, isAddressBookInfiniteScrollEnabled, initiateDataFetch, aniOverlayWidth, isOutdialAniInfiniteScrollEnabled, orgId }) => {
    const [filteredAddress, setFilteredAddress] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(addressList);
    const [searchQuery, setSearchQuery] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const { outdial: i18n, common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.useI18nContext)();
    const searchInputRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const addressListRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const inputSearchTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const [selectedAddress, setSelectedAddress] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const filterAddress = (value) => {
        const searchText = defaultSearchQuery || value;
        setSearchQuery(searchText);
        const filteredList = addressList.filter((address) => address.desc.concat(address.dn).toLowerCase().includes(searchText.toLowerCase()));
        setFilteredAddress(filteredList);
        handleAddressSelectorFocus();
    };
    const outdialDebouncedFunc = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_9__.debouncedFunc)((value) => filterAddress(value));
    const inputValueChangeHandler = (e) => {
        // clear the selection when user types in the search box
        setSelectedAddress("");
        if (isAddressBookInfiniteScrollEnabled) {
            outdialDebouncedFunc(e.target.value);
        }
        else {
            filterAddress(e.target.value);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        setFilteredAddress(addressList);
    }, [addressList]);
    const handleAddressSelectorFocus = () => {
        var _a, _b;
        if ((_b = (_a = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("input")) {
            if (inputSearchTimeoutIdRef.current) {
                window.clearTimeout(inputSearchTimeoutIdRef.current);
            }
            inputSearchTimeoutIdRef.current = window.setTimeout(() => {
                searchInputRef.current.shadowRoot.querySelector("input").focus();
            }, 20);
        }
    };
    const inputKeydownHandler = (event) => {
        const { srcEvent } = event.detail;
        if (addressListRef && addressListRef.current) {
            if (srcEvent.code === "Tab") {
                addressListRef.current.rovingPreventFocus = false;
            }
            else {
                addressListRef.current.rovingPreventFocus = true;
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        if (selectedAddress !== "") {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.ADDRESS_BOOK, {
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.ADDRESS_BOOK_LIST_SEARCH]: _constants__WEBPACK_IMPORTED_MODULE_5__.OUTDIAL
            });
            resetFocusableElements();
        }
    }, [selectedAddress]);
    const resetFilteredList = (e) => {
        var _a;
        if (((_a = e.detail) === null || _a === void 0 ? void 0 : _a.value) === "") {
            setFilteredAddress(addressList);
            setSearchQuery("");
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        if (addressListRef && addressListRef.current) {
            addressListRef.current.rovingPreventFocus = true;
        }
        const input = searchInputRef.current;
        if (searchInputRef && searchInputRef.current) {
            input.addEventListener("input-keydown", inputKeydownHandler);
        }
        return () => {
            input === null || input === void 0 ? void 0 : input.removeEventListener("input-keydown", inputKeydownHandler);
            outdialDebouncedFunc === null || outdialDebouncedFunc === void 0 ? void 0 : outdialDebouncedFunc.cancel();
            if (inputSearchTimeoutIdRef.current) {
                window.clearTimeout(inputSearchTimeoutIdRef.current);
            }
        };
    }, []);
    const handleClick = (selectedValue) => {
        const { dn } = selectedValue;
        setSelectedAddress(dn);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const input = searchInputRef.current;
        if (searchInputRef && searchInputRef.current) {
            input.addEventListener("input-change", resetFilteredList);
        }
        return () => {
            input === null || input === void 0 ? void 0 : input.removeEventListener("input-change", resetFilteredList);
        };
    }, [addressList]);
    const getAddressBook = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddressBookIncreasedLimit_AddressBookIncreasedLimit__WEBPACK_IMPORTED_MODULE_7__["default"], { height: 216, width: 250, loading: isAddressBookLoading, isAdhocDialingEnabled: isAdhocDialingEnabled, loadingError: Object.keys(loadingError || []).length > 0, loadingTrackingId: loadingTrackingId, retryLoadingAddressBook: retryLoadingAddressBook, data: addressList, searchQuery: searchQuery, handleListClick: handleClick, isAddressBookInfiniteScrollEnabled: isAddressBookInfiniteScrollEnabled, initiateDataFetch: initiateDataFetch }));
    };
    const getNoContacts = () => {
        if (addressList && addressList.length === 0 && Object.keys(loadingError || []).length === 0) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "no-contacts" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_8__["default"], { illustrationType: "empty-state" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "no-contacts-found" }, { children: i18n.noContacts }))] })));
        }
        return null;
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "address-book address-book-height-with-ani" }, { children: [((addressList && addressList.length > 0) || isAddressBookInfiniteScrollEnabled) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "address-search" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-input", Object.assign({ ref: searchInputRef, clear: true, htmlId: "pillSearchInput", name: "pillSearchInput", ariaLabel: i18n.addressSearch, placeholder: i18n.addressSearch, onInput: inputValueChangeHandler, class: "search-input", value: searchQuery, autoFocus: true, searchable: true, clearAriaLabel: common.clear }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }))) })), getAddressBook()] })), ((addressList && addressList.length > 0) || isAddressBookInfiniteScrollEnabled) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [isOutdialAniInfiniteScrollEnabled ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutDialAniInfiniteScroll__WEBPACK_IMPORTED_MODULE_11__["default"], { selectedOutdialAni: selectedANI, overlayWidth: aniOverlayWidth, orgId: orgId })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutDialAni__WEBPACK_IMPORTED_MODULE_10__["default"], { outdialAniList: outdialAniList, isDarkModeEnable: isDarkModeEnable, selectedOutdialAni: selectedANI, resetFocusableElements: resetFocusableElements, overlayWidth: aniOverlayWidth })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "outdial-button" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ type: "submit", size: "40", ariaLabel: i18n.call, circle: true, variant: "green", role: "button", onClick: (e) => {
                                if (selectedAddress !== "") {
                                    initiateOutboundCall(e, selectedAddress, selectedANI.id, _constants__WEBPACK_IMPORTED_MODULE_5__.OUTDIAL_TYPE.ADDRESS_BOOK);
                                    closePopover();
                                }
                            } }, (selectedAddress === "" ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "handset-bold", size: "16", iconSet: "momentumDesign" }) })) }))] })), !isAddressBookLoading && !isAddressBookInfiniteScrollEnabled && getNoContacts()] })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__.observer)(AddressBook));


/***/ }),

/***/ "./src/direflow-components/Outdial/Dialpad/components/index.tsx":
/*!**********************************************************************!*\
  !*** ./src/direflow-components/Outdial/Dialpad/components/index.tsx ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ValidationMessage: () => (/* binding */ ValidationMessage),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _OutDialAni__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../OutDialAni */ "./src/direflow-components/Outdial/OutDialAni/index.tsx");
/* harmony import */ var _OutDialAniInfiniteScroll__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../OutDialAniInfiniteScroll */ "./src/direflow-components/Outdial/OutDialAniInfiniteScroll/index.tsx");









const Dialpad = ({ addressList, initiateOutboundCall, closePopover, outdialAniList, resetFocusableElements, isDarkModeEnable, selectedANI, aniOverlayWidth, isOutdialAniInfiniteScrollEnabled, orgId }) => {
    const [dialNumber, setDialNumber] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const { outdial: i18n, common, keypad } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__.useI18nContext)();
    const [isDialNumberValid, setIsDialNumberValid] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true);
    const comboboxEl = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const dialNumbers = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => addressList.map((address, index) => {
        return {
            id: `${index}`,
            dn: address.dn
        };
    }), [addressList]);
    const dialerRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const [inputCursorPos, setInputCursorPos] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    //eslint-disable-next-line sonarjs/concise-regex
    const regExForDnSpecialChars = new RegExp("^[+1][0-9]{3,18}$|^[*#:][+1][0-9*#:]{3,18}$|^[0-9*#:]{3,18}$"); // new Regex allowing special chars '*, #, :'
    const validateDialNumber = (phoneNumber) => {
        // const regex = new RegExp(phoneValidateRegex);
        // TODO: this will be later replaced by Dial Plan Regex.
        const regexForDn = regExForDnSpecialChars;
        if (regexForDn.test(phoneNumber)) {
            setIsDialNumberValid(true);
            return true;
        }
        setIsDialNumberValid(false);
        return false;
    };
    const onComboboxInputChange = (e) => {
        var _a, _b;
        if (!e.detail) {
            return;
        }
        let dialNum;
        if (e.type === _constants__WEBPACK_IMPORTED_MODULE_4__.AX_OUTDIAL_EDIT) {
            dialNum = e.detail.value.outDailNumber;
        }
        else {
            dialNum = e.detail.value;
        }
        const specialCharsPattern = /[^+*#:0-9]/g;
        dialNum = dialNum.replace(specialCharsPattern, "");
        if (dialNum !== "") {
            validateDialNumber(dialNum);
            setDialNumber(dialNum);
            setInputCursorPos(inputCursorPos + 1);
            const inputEl = (_b = (_a = comboboxEl === null || comboboxEl === void 0 ? void 0 : comboboxEl.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("input");
            if (inputEl) {
                inputEl.value = dialNum;
            }
        }
        else {
            const isEditType = e.type === _constants__WEBPACK_IMPORTED_MODULE_4__.AX_OUTDIAL_EDIT;
            const isOriginalValue = isEditType ? dialNum === e.detail.value.outDailNumber : dialNum === e.detail.value;
            setDialNumber("");
            setIsDialNumberValid(isOriginalValue);
        }
    };
    const onComboboxListSelectHandler = (e) => {
        if (e.detail.value) {
            const selectedVal = e.detail.value.dn;
            validateDialNumber(selectedVal);
            setDialNumber(`${selectedVal}`);
            setInputCursorPos(inputCursorPos + 1);
        }
    };
    const onComboboxInputClear = () => {
        setDialNumber("");
        setIsDialNumberValid(true);
    };
    const initiateOutboundCallOnEnter = (e) => {
        var _a, _b, _c;
        if (e.which === _Common_constants__WEBPACK_IMPORTED_MODULE_6__.ENTER_KEY_CODE) {
            const dialNum = ((_c = (_b = (_a = comboboxEl.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("input")) === null || _c === void 0 ? void 0 : _c.value) || dialNumber;
            if (dialNum.trim() !== "" && validateDialNumber(dialNum)) {
                initiateOutboundCall(e, dialNum, selectedANI.id, _constants__WEBPACK_IMPORTED_MODULE_4__.OUTDIAL_TYPE.CUSTOM);
                closePopover();
            }
        }
    };
    const numberIsDialable = () => {
        return !isDialNumberValid || dialNumber.trim() === "";
    };
    const handleDialerButtonPress = (e) => {
        if (e.detail) {
            setDialNumber(e.detail.dnNumber);
            validateDialNumber(e.detail.dnNumber);
            setInputCursorPos(e.detail.inputCursorPos);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        const element = comboboxEl.current;
        const dialerComp = dialerRef === null || dialerRef === void 0 ? void 0 : dialerRef.current;
        if (element) {
            element.addEventListener("remove-all-selected", onComboboxInputClear);
            element.addEventListener("change-selected", onComboboxListSelectHandler);
            element.addEventListener("combobox-input", onComboboxInputChange);
            document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_4__.AX_OUTDIAL_EDIT, onComboboxInputChange);
        }
        if (dialerComp) {
            dialerComp.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_4__.DIALER_BUTTON_CLICK_EVENT, handleDialerButtonPress);
        }
        return () => {
            if (element) {
                element.removeEventListener("remove-all-selected", onComboboxInputClear);
                element.removeEventListener("change-selected", onComboboxListSelectHandler);
                element.removeEventListener("combobox-input", onComboboxInputChange);
                document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_4__.AX_OUTDIAL_EDIT, onComboboxInputChange);
            }
            if (dialerComp) {
                dialerComp.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_4__.DIALER_BUTTON_CLICK_EVENT, handleDialerButtonPress);
            }
        };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if (!numberIsDialable()) {
            resetFocusableElements();
        }
    }, [isDialNumberValid, dialNumber]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "dialpad-main" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", Object.assign({ target: "#" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "dialpad-search" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-combobox", Object.assign({ class: "dialpad-dropdown", options: JSON.stringify(dialNumbers), placeholder: i18n.dialpadSearch, "input-value": dialNumber, "option-id": "id", "option-value": "dn", onKeyPress: initiateOutboundCallOnEnter, ref: comboboxEl, ariaLabel: i18n.dialpadSearch, "visible-option": "6", "no-options-i18n": common.noOptions ? common.noOptions : "No Options", "no-results-i18n": common.noResults ? common.noResults : "No Results", "use-virtual-scroll": true, "arrow-aria-label": i18n.upArrowLabel, "clear-aria-label": i18n.clear }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ValidationMessage, { valid: isDialNumberValid, message: i18n.errorDialPadValidationMessage })] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "dialer" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("agentx-react-dialer", { ariaLabel: keypad.dialPad, ref: dialerRef, dialNum: dialNumber, cursorPosition: inputCursorPos }) })), isOutdialAniInfiniteScrollEnabled ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutDialAniInfiniteScroll__WEBPACK_IMPORTED_MODULE_8__["default"], { selectedOutdialAni: selectedANI, overlayWidth: aniOverlayWidth, orgId: orgId })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutDialAni__WEBPACK_IMPORTED_MODULE_7__["default"], { outdialAniList: outdialAniList, isDarkModeEnable: isDarkModeEnable, selectedOutdialAni: selectedANI, resetFocusableElements: resetFocusableElements, overlayWidth: aniOverlayWidth })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "outdial-button" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ type: "submit", size: "40", ariaLabel: i18n.call, circle: true, variant: "green", onClick: (e) => {
                            if (!numberIsDialable()) {
                                initiateOutboundCall(e, dialNumber, selectedANI.id, _constants__WEBPACK_IMPORTED_MODULE_4__.OUTDIAL_TYPE.CUSTOM);
                                setDialNumber("");
                                closePopover();
                            }
                        } }, (numberIsDialable() ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "handset-bold", size: "16", iconSet: "momentumDesign" }) })) }))] })) })));
};
const ValidationMessage = ({ valid, message }) => {
    if (!valid) {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "validation-msg", role: "alert", "aria-atomic": "true" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "error-legacy-badge-filled", iconSet: "momentumDesign", size: "14", color: "var(--md-alert-error-text-color)" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", { children: message })] })));
    }
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_2__.observer)(Dialpad));


/***/ }),

/***/ "./src/direflow-components/Outdial/EnterpriseSearch/components/OutDialEnterpriseSearch.tsx":
/*!*************************************************************************************************!*\
  !*** ./src/direflow-components/Outdial/EnterpriseSearch/components/OutDialEnterpriseSearch.tsx ***!
  \*************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_EnterpriseSearch_EnterpriseSearch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Common/components/EnterpriseSearch/EnterpriseSearch */ "./src/direflow-components/Common/components/EnterpriseSearch/EnterpriseSearch.tsx");
/* harmony import */ var _OutDialAni__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../OutDialAni */ "./src/direflow-components/Outdial/OutDialAni/index.tsx");
/* harmony import */ var _OutDialAniInfiniteScroll__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../OutDialAniInfiniteScroll */ "./src/direflow-components/Outdial/OutDialAniInfiniteScroll/index.tsx");







const OutDialEnterpriseSearch = ({ displayMicrosoftUserDetails, displayWebexUserDetails, microsoftAuthenticated, initiateOutboundCall, closePopover, outdialAniList, resetFocusableElements, isDarkMode, selectedANI, resetTab, isOutdialAniInfiniteScrollEnabled, orgId }) => {
    const [selectedNumber, setSelectedNumber] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [outdialType, setOutdialType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { outdial: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (selectedNumber.trim() !== "") {
            resetFocusableElements();
        }
    }, [selectedNumber]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (displayWebexUserDetails) {
            setOutdialType(_constants__WEBPACK_IMPORTED_MODULE_2__.OUTDIAL_TYPE.WEBEX_SEARCH);
        }
        else if (displayMicrosoftUserDetails) {
            setOutdialType(_constants__WEBPACK_IMPORTED_MODULE_2__.OUTDIAL_TYPE.MICROSOFT_SEARCH);
        }
    }, [displayWebexUserDetails, displayMicrosoftUserDetails]);
    const isDisabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => selectedNumber === "", [selectedNumber]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "enterprise-search" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", Object.assign({ target: "#" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EnterpriseSearch_EnterpriseSearch__WEBPACK_IMPORTED_MODULE_4__["default"], { displayMicrosoftUserDetails: displayMicrosoftUserDetails, displayWebexUserDetails: displayWebexUserDetails, height: 220, isDarkMode: isDarkMode, microsoftAuthenticated: microsoftAuthenticated, handleSelectedNumber: setSelectedNumber, resetTab: resetTab }), isOutdialAniInfiniteScrollEnabled ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutDialAniInfiniteScroll__WEBPACK_IMPORTED_MODULE_6__["default"], { selectedOutdialAni: selectedANI, overlayWidth: "350px", orgId: orgId })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutDialAni__WEBPACK_IMPORTED_MODULE_5__["default"], { outdialAniList: outdialAniList, isDarkModeEnable: isDarkMode, selectedOutdialAni: selectedANI, resetFocusableElements: resetFocusableElements, overlayWidth: "350px" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "outdial-button" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ type: "submit", size: "40", ariaLabel: i18n.call, circle: true, variant: "green", onClick: (e) => {
                            initiateOutboundCall(e, selectedNumber, selectedANI.id, outdialType);
                            setSelectedNumber("");
                        } }, (isDisabled() ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "handset-bold", size: "16", iconSet: "momentumDesign" }) })) }))] })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OutDialEnterpriseSearch);


/***/ }),

/***/ "./src/direflow-components/Outdial/OutDialAni/OutdialAniItem.tsx":
/*!***********************************************************************!*\
  !*** ./src/direflow-components/Outdial/OutDialAni/OutdialAniItem.tsx ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const OutdialAniItem = ({ outdialAniOption, handleOutdialAniChange, selectedOutdialAni, setIsOpen, menuIsOpen }) => {
    const [isTextOverflow, setTextOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const outdialTextRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        const textContainer = outdialTextRef.current;
        let isTextOverflowing;
        if (textContainer && menuIsOpen) {
            isTextOverflowing = textContainer.offsetWidth < textContainer.scrollWidth;
        }
        setTextOverflow(isTextOverflowing);
    }, [menuIsOpen]);
    const handleSelection = () => {
        if (selectedOutdialAni !== outdialAniOption.name) {
            handleOutdialAniChange(outdialAniOption, new Date());
        }
        setIsOpen(false);
    };
    const handleClick = () => {
        handleSelection();
    };
    const handleKeyDown = (e) => {
        e.preventDefault();
        if (e.key === "Enter" || e.key === " ") {
            handleSelection();
        }
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-list-item", Object.assign({ slot: "list-item", class: "status-menu-item", id: `id-${outdialAniOption.name}`, "aria-label": outdialAniOption.name, onClick: handleClick, onKeyDown: handleKeyDown }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ message: outdialAniOption.name }, (!isTextOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ ref: outdialTextRef, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("agent-status-option-text", "ellipsis-text") }, { children: outdialAniOption.name })) })) }), `status-${outdialAniOption.name}`));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OutdialAniItem);


/***/ }),

/***/ "./src/direflow-components/Outdial/OutDialAni/index.tsx":
/*!**************************************************************!*\
  !*** ./src/direflow-components/Outdial/OutDialAni/index.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _EmailComposer_Context_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../EmailComposer/Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");
/* harmony import */ var _OutdialAniItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./OutdialAniItem */ "./src/direflow-components/Outdial/OutDialAni/OutdialAniItem.tsx");
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_7__);








const OutDialAni = ({ outdialAniList, isDarkModeEnable, selectedOutdialAni, resetFocusableElements, overlayWidth }) => {
    const { outdial: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.useI18nContext)();
    const outdialAniElm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const outdialAniTriggerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const resetFocusableTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [outdialAniArray, setOutdialAniArray] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const dispatchCustomEvent = (0,_EmailComposer_Context_AppContext__WEBPACK_IMPORTED_MODULE_4__.useEventContext)();
    const selectedIndex = outdialAniArray.findIndex((i) => i.name === (selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (outdialAniElm === null || outdialAniElm === void 0 ? void 0 : outdialAniElm.current) {
            outdialAniElm.current.isOpen = isOpen;
        }
    }, [isOpen]);
    const closeMenu = () => {
        var _a, _b;
        setIsOpen(false);
        const button = (_b = (_a = outdialAniTriggerRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button");
        if (button) {
            button.focus();
        }
    };
    const handleOutdialAniSelectInterceptor = (outdialAniOption) => {
        outdialAniElm.current.isOpen = false;
        setIsOpen(false);
        let updatedData;
        if (outdialAniOption.id === "") {
            updatedData = {
                id: "",
                name: ""
            };
        }
        else {
            updatedData = Object.assign({}, outdialAniOption);
        }
        const event = new CustomEvent("ax-outdial-ani", {
            detail: { data: updatedData },
            bubbles: true,
            composed: true
        });
        if (dispatchCustomEvent) {
            dispatchCustomEvent(event);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        const outdialAniOption = outdialAniElm === null || outdialAniElm === void 0 ? void 0 : outdialAniElm.current;
        if (outdialAniOption) {
            outdialAniOption.addEventListener("menu-overlay-close", closeMenu);
        }
        return () => {
            if (outdialAniOption) {
                outdialAniOption.removeEventListener("menu-overlay-close", closeMenu);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        const sortedList = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_3__.orderBy)(outdialAniList, "name");
        const defaultOption = [{ id: "", name: i18n.outdialAniPlaceholder }];
        setOutdialAniArray([...defaultOption, ...sortedList]);
        if (resetFocusableElements && outdialAniList.length > 0) {
            resetFocusableTimeoutIdRef.current = window.setTimeout(() => resetFocusableElements(), 0);
        }
        return () => {
            if (resetFocusableTimeoutIdRef.current) {
                window.clearTimeout(resetFocusableTimeoutIdRef.current);
            }
        };
    }, [outdialAniList]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "outdial-ani-label" }, { children: i18n.outdialAniLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ ref: outdialAniElm, "custom-width": overlayWidth !== null && overlayWidth !== void 0 ? overlayWidth : "200px", position: "bottom", id: "outdial-overlay", "max-height": "327px" }, (outdialAniList && outdialAniList.length === 0 ? { disabled: true } : ""), { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-tooltip", Object.assign({ placement: "bottom", class: "outdial-ani-tooltip", slot: "menu-trigger" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ slot: "tooltip-content" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "status-tooltip-text" }, { children: (selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name) === "" ? i18n.outdialAniPlaceholder : selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ class: "outdial-ani-btn", ref: outdialAniTriggerRef, ariaExpanded: isOpen, size: "32", variant: "dropdown" }, (outdialAniList && outdialAniList.length === 0 ? { disabled: true } : ""), (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_7__.themeManager.isMomentumV2Enabled ? { rounded: true } : { outline: true }), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "button-internal-element" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "sr-only", id: "dropdown-label" }, { children: i18n.outdialAniLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-labelledby": `${(selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name) ? selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.id : ""}`, className: "ellipsis-text", id: selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.id }, { children: (selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name) === "" ? i18n.outdialAniPlaceholder : selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name })), isOpen ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { "aria-hidden": "true", class: "arrow-icon arrow-up", name: "arrow-up-bold", iconSet: "momentumDesign", size: "16" })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { "aria-hidden": "true", class: "arrow-icon arrow-up", name: "arrow-down-bold", iconSet: "momentumDesign", size: "16" }))] })) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-list", Object.assign({ class: "menu-list", role: "list", activated: selectedIndex > 0 ? selectedIndex : 0 }, { children: outdialAniArray &&
                            outdialAniArray.length > 0 &&
                            outdialAniArray.map((option) => {
                                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutdialAniItem__WEBPACK_IMPORTED_MODULE_5__["default"], { outdialAniOption: option, handleOutdialAniChange: handleOutdialAniSelectInterceptor, selectedOutdialAni: selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name, setIsOpen: setIsOpen, menuIsOpen: isOpen }, option.id));
                            }) }))] }))] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_6__.observer)(OutDialAni));
OutDialAni.defaultProps = {
    resetFocusableElements: () => { }
};


/***/ }),

/***/ "./src/direflow-components/Outdial/OutDialAniInfiniteScroll/OutdialAniItem.tsx":
/*!*************************************************************************************!*\
  !*** ./src/direflow-components/Outdial/OutDialAniInfiniteScroll/OutdialAniItem.tsx ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Common/components/HighlightText */ "./src/direflow-components/Common/components/HighlightText/index.tsx");



const OutdialAniItem = ({ data, index, style = {}, isFocused, onSelectValue, customData }) => {
    const listItmElm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { selectedOutdialAni, searchQuery, totalRecords } = customData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (isFocused) {
            listItmElm.current.focus();
        }
    }, [isFocused]);
    const getIsSelected = () => {
        return ((data.id === selectedOutdialAni.id && selectedOutdialAni.name === data.name) ||
            (data.id === "" && selectedOutdialAni.id === ""));
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", Object.assign({ className: `infinite-menu-list-item ${getIsSelected() ? "selected-list-item " : ""} ${isFocused ? "selected-list-item-focused" : ""}` }, (isFocused ? { tabIndex: 0 } : { tabIndex: -1 }), { ref: listItmElm, "aria-selected": getIsSelected(), style: style, onClick: () => onSelectValue(data, index), "aria-posinset": index + 1, "aria-setsize": totalRecords }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_HighlightText__WEBPACK_IMPORTED_MODULE_2__["default"], { text: data.name, highlight: searchQuery }) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OutdialAniItem);


/***/ }),

/***/ "./src/direflow-components/Outdial/OutDialAniInfiniteScroll/OutdialAniList.tsx":
/*!*************************************************************************************!*\
  !*** ./src/direflow-components/Outdial/OutDialAniInfiniteScroll/OutdialAniList.tsx ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_components_List__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Common/components/List */ "./src/direflow-components/Common/components/List/index.tsx");
/* harmony import */ var _Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Common/components/List/ListError */ "./src/direflow-components/Common/components/List/ListError/index.tsx");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils */ "./src/direflow-components/Outdial/utils.ts");
/* harmony import */ var _OutdialAniItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./OutdialAniItem */ "./src/direflow-components/Outdial/OutDialAniInfiniteScroll/OutdialAniItem.tsx");







const OutDialAniList = ({ outdialAnis, loadingFirstPage, loadingFirstPageError, searchError, hasNextPage, isNextPageLoading, loadNextPage, pageFetchError, customData, onSelectValue, loadFirstPage }) => {
    const { common, outdial: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_1__.useI18nContext)();
    const isNoRecordFound = () => {
        return (outdialAnis === null || outdialAnis === void 0 ? void 0 : outdialAnis.length) === 0 && !loadingFirstPage;
    };
    const getNoRecordFound = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "no-record" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_2__["default"], { illustrationType: "empty-result" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-label": common.nomatchfound, className: "no-record-found" }, { children: common.nomatchfound }))] })));
    };
    const isApiError = () => {
        return !loadingFirstPage && (loadingFirstPageError === null || loadingFirstPageError === void 0 ? void 0 : loadingFirstPageError.error);
    };
    const getApiError = () => {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_4__["default"], { onRetry: () => loadFirstPage(), trackingId: loadingFirstPageError.trackingId });
    };
    const getSearchError = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "search-block-error" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "search-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "info-badge-filled", iconSet: "momentumDesign", size: "16", class: "search-error-info" }), i18n.searchError] })) })));
    };
    const getLoadingError = () => {
        if (searchError) {
            return getSearchError();
        }
        else if (isApiError()) {
            return getApiError();
        }
        else if (isNoRecordFound()) {
            return getNoRecordFound();
        }
        else {
            return null;
        }
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [getLoadingError(), loadingFirstPage && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "outdial-list__loading " }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "48" }) }))), !loadingFirstPage && !loadingFirstPageError.error && !searchError && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "wrap-up-virtual-list-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_3__["default"], Object.assign({ data: outdialAnis, height: outdialAnis.length > 8 ? _utils__WEBPACK_IMPORTED_MODULE_5__.ItemHeight * 8 : _utils__WEBPACK_IMPORTED_MODULE_5__.ItemHeight * outdialAnis.length, onSelectValue: onSelectValue, itemHeight: _utils__WEBPACK_IMPORTED_MODULE_5__.ItemHeight, innerElementType: "ul", infiniteScrollEnabled: true, hasNextPage: hasNextPage, isNextPageLoading: isNextPageLoading, loadNextPage: loadNextPage, pageFetchError: pageFetchError, customData: customData }, { children: (props) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutdialAniItem__WEBPACK_IMPORTED_MODULE_6__["default"], Object.assign({}, props)) })) })))] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OutDialAniList);


/***/ }),

/***/ "./src/direflow-components/Outdial/OutDialAniInfiniteScroll/OutdialAniMenu.tsx":
/*!*************************************************************************************!*\
  !*** ./src/direflow-components/Outdial/OutDialAniInfiniteScroll/OutdialAniMenu.tsx ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");




const OutdialAniMenu = (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((props, ref) => {
    const { overlayWidth, isOpen, selectedOutdialAni, triggerRef, children } = props;
    const { outdial: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_3__.useI18nContext)();
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ ref: ref, "custom-width": overlayWidth !== null && overlayWidth !== void 0 ? overlayWidth : "223px", position: "bottom", id: "outdial-overlay", "max-height": "327px", class: "outdial-ani-menu" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-tooltip", Object.assign({ placement: "bottom", class: "outdial-ani-tooltip", slot: "menu-trigger" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ slot: "tooltip-content" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "status-tooltip-text" }, { children: (selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name) === "" ? i18n.outdialAniPlaceholder : selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ class: "outdial-ani-btn", ref: triggerRef, ariaExpanded: isOpen, size: "32", variant: "dropdown" }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__.themeManager.isMomentumV2Enabled ? { rounded: true } : { outline: true }), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "button-internal-element" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "sr-only", id: "dropdown-label" }, { children: i18n.outdialAniLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-labelledby": `${(selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name) ? selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.id : ""}`, className: "ellipsis-text", id: selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.id }, { children: (selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name) === "" ? i18n.outdialAniPlaceholder : selectedOutdialAni === null || selectedOutdialAni === void 0 ? void 0 : selectedOutdialAni.name })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { "aria-hidden": "true", class: "arrow-icon arrow-up", name: isOpen ? "arrow-up-bold" : "arrow-down-bold", iconSet: "momentumDesign", size: "16" })] })) }))] })), children] })));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OutdialAniMenu);


/***/ }),

/***/ "./src/direflow-components/Outdial/OutDialAniInfiniteScroll/index.tsx":
/*!****************************************************************************!*\
  !*** ./src/direflow-components/Outdial/OutDialAniInfiniteScroll/index.tsx ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_SearchBar_SearchBar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Common/components/SearchBar/SearchBar */ "./src/direflow-components/Common/components/SearchBar/SearchBar.tsx");
/* harmony import */ var _EmailComposer_Context_AppContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../EmailComposer/Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils */ "./src/direflow-components/Outdial/utils.ts");
/* harmony import */ var _OutdialAniList__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./OutdialAniList */ "./src/direflow-components/Outdial/OutDialAniInfiniteScroll/OutdialAniList.tsx");
/* harmony import */ var _OutdialAniMenu__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./OutdialAniMenu */ "./src/direflow-components/Outdial/OutDialAniInfiniteScroll/OutdialAniMenu.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const OutDialAni = ({ selectedOutdialAni, overlayWidth, orgId }) => {
    const { outdial: i18n } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.useI18nContext)();
    const dispatchCustomEvent = (0,_EmailComposer_Context_AppContext__WEBPACK_IMPORTED_MODULE_6__.useEventContext)();
    const outdialAniElm = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const outdialAniTriggerRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [outdialAnis, setOutdialAnis] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [currentPage, setCurrentPage] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const [totalRecords, setTotalRecords] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const [searchQuery, setSearchQuery] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [hasNextPage, setHasNextPage] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [isNextPageLoading, setIsNextPageLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [pageFetchError, setPageFetchError] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        error: false,
        trackingId: ""
    });
    const [loadingFirstPage, setLoadingFirstPage] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [loadingFirstPageError, setLoadingFirstPageError] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(_utils__WEBPACK_IMPORTED_MODULE_7__.DEFAULT_ERROR_OBJECT);
    const [searchError, setSearchError] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const loadFirstPage = () => {
        setOutdialAnis([]);
        setLoadingFirstPage(true);
        loadPage(0, searchQuery, true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if (outdialAniElm === null || outdialAniElm === void 0 ? void 0 : outdialAniElm.current) {
            outdialAniElm.current.isOpen = isOpen;
        }
    }, [isOpen]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        if (isOpen && (searchQuery.length >= _utils__WEBPACK_IMPORTED_MODULE_7__.MINIMUM_CHARACTERS_FOR_SEARCH || searchQuery === "")) {
            setSearchError(false);
            loadFirstPage();
        }
        else if (searchQuery.length < _utils__WEBPACK_IMPORTED_MODULE_7__.MINIMUM_CHARACTERS_FOR_SEARCH && searchQuery !== "") {
            setSearchError(true);
        }
    }, [isOpen, searchQuery]);
    const closeMenu = () => {
        setIsOpen(false);
        setSearchQuery("");
    };
    const openMenu = () => {
        setIsOpen(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        const outdialAniOption = outdialAniElm === null || outdialAniElm === void 0 ? void 0 : outdialAniElm.current;
        if (outdialAniOption) {
            outdialAniOption.addEventListener("menu-overlay-close", closeMenu);
            outdialAniOption.addEventListener("menu-overlay-open", openMenu);
        }
        return () => {
            if (outdialAniOption) {
                outdialAniOption.removeEventListener("menu-overlay-close", closeMenu);
                outdialAniOption.removeEventListener("menu-overlay-open", openMenu);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
        document.dispatchEvent(new CustomEvent("on-widget-update"));
    }, [outdialAnis]);
    const handleFirstPageData = (data, searchQuery) => {
        const defaultOption = [{ id: "", name: i18n.outdialAniPlaceholder }];
        if ((searchQuery.length >= _utils__WEBPACK_IMPORTED_MODULE_7__.MINIMUM_CHARACTERS_FOR_SEARCH &&
            i18n.outdialAniPlaceholder.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase())) ||
            searchQuery === "") {
            setOutdialAnis([...defaultOption, ...data]);
        }
        else {
            setOutdialAnis(data);
        }
    };
    const handleFetchSuccess = (response, page, searchQuery, reset) => {
        const { data, meta } = response;
        const { page: responsePage, totalPages, totalRecords } = meta;
        setTotalRecords(totalRecords);
        setLoadingFirstPageError({ error: false, trackingId: "" });
        if (page === 0) {
            handleFirstPageData(data, searchQuery);
        }
        else {
            setOutdialAnis((prevItems) => (reset ? data : [...prevItems, ...data]));
        }
        if (responsePage !== undefined && totalPages !== undefined) {
            setHasNextPage(responsePage < totalPages - 1);
            setCurrentPage(responsePage);
        }
        else {
            setHasNextPage(false);
        }
        setIsNextPageLoading(false);
        if (page === 0) {
            setLoadingFirstPage(false);
        }
    };
    const handleFetchError = (error, page) => {
        const trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error);
        if (page === 0) {
            setLoadingFirstPage(false);
            setLoadingFirstPageError({ error: true, trackingId });
        }
        else {
            setPageFetchError({ error: true, trackingId });
            setHasNextPage(true);
            setIsNextPageLoading(false);
        }
    };
    const loadPage = (page, searchQuery, reset = false) => {
        (0,_utils__WEBPACK_IMPORTED_MODULE_7__.fetchOutdialANIs)(orgId, page, searchQuery)
            .then((response) => handleFetchSuccess(response, page, searchQuery, reset))
            .catch((error) => handleFetchError(error, page));
    };
    const loadNextPage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isNextPageLoading) {
            return;
        }
        setIsNextPageLoading(true);
        setPageFetchError(_utils__WEBPACK_IMPORTED_MODULE_7__.DEFAULT_ERROR_OBJECT);
        loadPage((currentPage !== null && currentPage !== void 0 ? currentPage : 0) + 1, searchQuery);
    });
    const handleOutdialAniSelectInterceptor = (outdialAniOption) => {
        outdialAniElm.current.isOpen = false;
        setIsOpen(false);
        let updatedData;
        if (outdialAniOption.id === "") {
            updatedData = {
                id: "",
                name: ""
            };
        }
        else {
            updatedData = Object.assign({}, outdialAniOption);
        }
        const event = new CustomEvent("ax-outdial-ani", {
            detail: { data: updatedData },
            bubbles: true,
            composed: true
        });
        if (dispatchCustomEvent) {
            dispatchCustomEvent(event);
        }
    };
    const customData = {
        selectedOutdialAni,
        searchQuery,
        totalRecords
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "outdial-ani-label" }, { children: i18n.outdialAniLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OutdialAniMenu__WEBPACK_IMPORTED_MODULE_9__["default"], Object.assign({ ref: outdialAniElm, overlayWidth: overlayWidth, isOpen: isOpen, selectedOutdialAni: selectedOutdialAni, triggerRef: outdialAniTriggerRef }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_SearchBar_SearchBar__WEBPACK_IMPORTED_MODULE_5__["default"], { searchQuery: searchQuery, setSearchQuery: setSearchQuery, placeHolderText: i18n.outdialAniPlaceHolder }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutdialAniList__WEBPACK_IMPORTED_MODULE_8__["default"], { outdialAnis: outdialAnis, loadingFirstPage: loadingFirstPage, loadingFirstPageError: loadingFirstPageError, searchError: searchError, hasNextPage: hasNextPage, isNextPageLoading: isNextPageLoading, loadNextPage: loadNextPage, pageFetchError: pageFetchError, customData: customData, onSelectValue: handleOutdialAniSelectInterceptor, loadFirstPage: loadFirstPage })] }))] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_2__.observer)(OutDialAni));


/***/ }),

/***/ "./src/direflow-components/Outdial/components/OutdialPopover.tsx":
/*!***********************************************************************!*\
  !*** ./src/direflow-components/Outdial/components/OutdialPopover.tsx ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Common/components/ErrorModal */ "./src/direflow-components/Common/components/ErrorModal/index.tsx");
/* harmony import */ var _AddressBook_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../AddressBook/components */ "./src/direflow-components/Outdial/AddressBook/components/index.tsx");
/* harmony import */ var _Dialpad_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Dialpad/components */ "./src/direflow-components/Outdial/Dialpad/components/index.tsx");
/* harmony import */ var _EnterpriseSearch_components_OutDialEnterpriseSearch__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../EnterpriseSearch/components/OutDialEnterpriseSearch */ "./src/direflow-components/Outdial/EnterpriseSearch/components/OutDialEnterpriseSearch.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










var OrgSearchEnabledOutDialTab;
(function (OrgSearchEnabledOutDialTab) {
    OrgSearchEnabledOutDialTab[OrgSearchEnabledOutDialTab["AddressBook"] = 0] = "AddressBook";
    OrgSearchEnabledOutDialTab[OrgSearchEnabledOutDialTab["OrgSearch"] = 1] = "OrgSearch";
    OrgSearchEnabledOutDialTab[OrgSearchEnabledOutDialTab["DialPad"] = 2] = "DialPad";
})(OrgSearchEnabledOutDialTab || (OrgSearchEnabledOutDialTab = {}));
var OutDialTab;
(function (OutDialTab) {
    OutDialTab[OutDialTab["AddressBook"] = 0] = "AddressBook";
    OutDialTab[OutDialTab["DialPad"] = 1] = "DialPad";
})(OutDialTab || (OutDialTab = {}));
const logger = (0,_sdk__WEBPACK_IMPORTED_MODULE_5__.createLogger)("[Outdial]");
const OutdialPopover = ({ addressList, showPopover, loadingError, loadingTrackingId, retryLoadingAddressBook, onMenuOverlayInitialOpen, isOutDialEnabledAgent, shouldDisableOutdialForExclusive, isAdhocDialingEnabled, phoneValidateRegex, outdialAniList, agentDn, selectedANI, outdialEntryPointId, isCallInProgress, isDarkModeEnable, isAddressBookLoading, webRtcStatus, isWebRTCEnabled, deviceType, isAddressBookInfiniteScrollEnabled, isOutdialOrgSearchEnabled, displayMicrosoftUserDetails, displayWebexUserDetails, microsoftAuthenticated, isOutdialAniInfiniteScrollEnabled, orgId }) => {
    const { outdial: i18n, common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_4__.useI18nContext)();
    const tabElm = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const popoverElm = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const inputFocusTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const outDailMenuCloseTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const popoverElmTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const setFocusTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const popoverTabTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const [initialOpen, setInitialOpenStatus] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [errorModalState, setErrorModalState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [errorTrackingId, setErrorTrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [isOutdialModalOpen, setIsOutdialModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [axOutdailEditIndex, setAxOutdailEditIndex] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(-1);
    const [selectedTab, setSelectedTab] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(-1);
    const [showSearchTab, setShowSearchTab] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const shouldNotExecuteShortcut = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(true);
    shouldNotExecuteShortcut.current = true;
    const setFocusOnSearchField = (e) => {
        var _a, _b, _c, _d;
        if (tabElm && tabElm.current) {
            setSelectedTab((_a = e.detail) === null || _a === void 0 ? void 0 : _a.value);
            let searchInp = null;
            if (isOutdialOrgSearchEnabled && ((_b = e.detail) === null || _b === void 0 ? void 0 : _b.value) === OrgSearchEnabledOutDialTab.OrgSearch) {
                //enterprise search tab
                searchInp = tabElm.current && tabElm.current.querySelector(".org-search-input");
            }
            else if ((isOutdialOrgSearchEnabled && ((_c = e.detail) === null || _c === void 0 ? void 0 : _c.value) === OrgSearchEnabledOutDialTab.DialPad) ||
                (!isOutdialOrgSearchEnabled && ((_d = e.detail) === null || _d === void 0 ? void 0 : _d.value) === OutDialTab.DialPad)) {
                //dial pad tab
                searchInp = tabElm.current && tabElm.current.querySelector("md-combobox");
            }
            else {
                searchInp = tabElm.current && tabElm.current.querySelector(".search-input");
            }
            if (searchInp && searchInp.shadowRoot) {
                inputFocusTimeoutIdRef.current = window.setTimeout(() => {
                    searchInp.shadowRoot.querySelector("input").focus();
                }, 10);
            }
        }
    };
    const resetFocusableElements = () => {
        var _a;
        if ((_a = popoverElm === null || popoverElm === void 0 ? void 0 : popoverElm.current) === null || _a === void 0 ? void 0 : _a.setFocusableElements) {
            popoverElm.current.setFocusableElements();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        const element = tabElm.current;
        if (element) {
            element.addEventListener("selected-changed", setFocusOnSearchField);
        }
        return () => {
            if (element) {
                element.removeEventListener("selected-changed", setFocusOnSearchField);
            }
            if (inputFocusTimeoutIdRef.current) {
                window.clearTimeout(inputFocusTimeoutIdRef.current);
            }
            if (outDailMenuCloseTimeoutIdRef.current) {
                window.clearTimeout(outDailMenuCloseTimeoutIdRef.current);
            }
            if (popoverElmTimeoutIdRef.current) {
                window.clearTimeout(popoverElmTimeoutIdRef.current);
            }
            if (popoverTabTimeoutIdRef.current) {
                window.clearTimeout(popoverTabTimeoutIdRef.current);
            }
        };
    }, []);
    const checkWebRtcStatus = () => {
        if (isWebRTCEnabled && deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
            if (webRtcStatus === _constants__WEBPACK_IMPORTED_MODULE_3__.WEB_RTC_STATUS.WEB_RTC_REGISTERING || webRtcStatus === _constants__WEBPACK_IMPORTED_MODULE_3__.WEB_RTC_STATUS.WEB_RTC_DISCONNECTED) {
                return true;
            }
        }
        return false;
    };
    const toHidePopover = () => {
        shouldNotExecuteShortcut.current =
            !isOutDialEnabledAgent ||
                isCallInProgress ||
                !showPopover ||
                shouldDisableOutdialForExclusive ||
                checkWebRtcStatus();
        if (shouldNotExecuteShortcut.current) {
            closePopover(); // fix: #CX-7814 md-overlay pop-up not closes with disable.
        }
        return shouldNotExecuteShortcut.current;
    };
    const onOutdialMenuClose = (event) => {
        if ((popoverElm === null || popoverElm === void 0 ? void 0 : popoverElm.current) === event.target) {
            setIsOutdialModalOpen(false);
            if (outDailMenuCloseTimeoutIdRef.current) {
                window.clearTimeout(outDailMenuCloseTimeoutIdRef.current);
            }
            outDailMenuCloseTimeoutIdRef.current = window.setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                const closeEvent = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_3__.OUTDIAL_MENU_CLOSE, {
                    detail: {
                        value: axOutdailEditIndex
                    }
                });
                document.dispatchEvent(closeEvent);
                setAxOutdailEditIndex(-1);
            }), 50);
        }
    };
    const onOutdialMenuOpen = () => {
        setIsOutdialModalOpen(true);
    };
    const executeOpenOutdial = (key) => {
        if (!shouldNotExecuteShortcut.current &&
            key.data &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_OUTDIAL_KEY &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
            if (popoverElmTimeoutIdRef.current) {
                window.clearTimeout(popoverElmTimeoutIdRef.current);
            }
            popoverElmTimeoutIdRef.current = window.setTimeout(() => {
                if (popoverElm.current) {
                    popoverElm.current.isOpen = true;
                }
            }, 200);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (isOutdialModalOpen) {
            setFocusTimeoutIdRef.current = window.setTimeout(() => {
                var _a, _b;
                setFocusOnSearchField({
                    detail: { value: (_b = (_a = tabElm.current) === null || _a === void 0 ? void 0 : _a.selected) !== null && _b !== void 0 ? _b : 0 }
                });
            }, 0);
        }
        return () => {
            if (setFocusTimeoutIdRef.current) {
                window.clearTimeout(setFocusTimeoutIdRef.current);
            }
        };
    }, [isOutdialModalOpen]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (!initialOpen && isOutdialModalOpen) {
            setInitialOpenStatus(true);
            onMenuOverlayInitialOpen();
        }
    }, [initialOpen, isOutdialModalOpen]);
    const executeOutDailEdit = (e) => {
        if (popoverTabTimeoutIdRef.current) {
            window.clearTimeout(popoverTabTimeoutIdRef.current);
        }
        popoverTabTimeoutIdRef.current = window.setTimeout(() => {
            if (popoverElm.current && tabElm.current) {
                setAxOutdailEditIndex(e.detail.value.index);
                popoverElm.current.isOpen = true;
                // work around for md-tabs selection
                const tabIndex = isOutdialOrgSearchEnabled ? OrgSearchEnabledOutDialTab.DialPad : OutDialTab.DialPad;
                const { id } = tabElm.current.querySelectorAll("md-tab")[tabIndex];
                const event = new CustomEvent("tab-click", {
                    detail: { id },
                    bubbles: true,
                    cancelable: true,
                    composed: false
                });
                tabElm.current.dispatchEvent(event);
            }
        }, 200);
    };
    const executeOutDail = (e) => {
        var _a, _b, _c;
        if ((_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.value) {
            let outDailNumber = "";
            if (typeof e.detail.value === "object" && e.detail.value !== null && "outDailNumber" in e.detail.value) {
                outDailNumber = (_b = e === null || e === void 0 ? void 0 : e.detail) === null || _b === void 0 ? void 0 : _b.value.outDailNumber;
            }
            else {
                outDailNumber = (_c = e === null || e === void 0 ? void 0 : e.detail) === null || _c === void 0 ? void 0 : _c.value;
            }
            initiateOutboundCall(e, outDailNumber, "", "");
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((key) => executeOpenOutdial(key));
        return () => {
            if (stopListen) {
                stopListen();
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        const outdialMenu = popoverElm === null || popoverElm === void 0 ? void 0 : popoverElm.current;
        if (outdialMenu) {
            outdialMenu.addEventListener("menu-overlay-open", onOutdialMenuOpen);
            outdialMenu.addEventListener("menu-overlay-close", onOutdialMenuClose);
            document.addEventListener("ax-outdail-call", executeOutDail);
            document.addEventListener("ax-outdail-edit", executeOutDailEdit);
        }
        return () => {
            if (outdialMenu) {
                outdialMenu.removeEventListener("menu-overlay-open", onOutdialMenuOpen);
                outdialMenu.removeEventListener("menu-overlay-close", onOutdialMenuClose);
                document.removeEventListener("ax-outdail-call", executeOutDail);
                document.removeEventListener("ax-outdail-edit", executeOutDailEdit);
            }
        };
    }, [axOutdailEditIndex]);
    const errorModalCallback = () => {
        setErrorModalState(false);
    };
    const initiateOutboundCall = (e, customerDn, outdialAni, outdialType) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const requestData = {
            entryPointId: outdialEntryPointId,
            destination: customerDn,
            direction: "OUTBOUND",
            attributes: {},
            mediaType: "telephony",
            outboundType: "OUTDIAL"
        };
        if (outdialAni !== "") {
            requestData.origin = outdialAni;
        }
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_CACHE_KEYS.OUTDIAL_TYPE, outdialType);
        const oudialResponse = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.dialer.startOutdial({
            data: requestData
        });
        setSelectedTab(-1);
        oudialResponse
            .then(() => {
            logger.info("outdial success -  got the offer contact");
        })
            .catch((err) => {
            if (err.id === "Service.aqm.reqs.Timeout" || err.id === "Service.reqs.generic.failure") {
                logger.error(`event=OutdialFailed | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err)}] Outdial Failed:', ${err}`, err);
                setErrorModalState(true);
                setErrorTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err));
                const event = new CustomEvent("outdail-call-failed", {
                    bubbles: true,
                    composed: true
                });
                document.dispatchEvent(event);
            }
            else if (err.id === "Service.aqm.dialer.startOutdial") {
                logger.error(`event=OutdialFailed | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err)}] Outdial Failed:', ${err}`, err);
            }
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_util.trackInitialCallEvents({
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_INITIATED,
                interactionId: err.interactionId,
                contactDirection: requestData.direction,
                customerDn,
                mediaType: requestData.mediaType,
                status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                reasonCode: "TIME_OUT"
            });
        });
    };
    const closePopover = () => {
        if (popoverElm && popoverElm.current) {
            popoverElm.current.isOpen = false;
        }
    };
    const shouldShowSearchTab = () => {
        return isOutdialOrgSearchEnabled && (displayMicrosoftUserDetails || displayWebexUserDetails);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (shouldShowSearchTab() !== showSearchTab) {
            setShowSearchTab(shouldShowSearchTab());
        }
    }, [isOutdialOrgSearchEnabled, displayMicrosoftUserDetails, displayWebexUserDetails]);
    const aniOverlayWidth = showSearchTab ? "350px" : "223px";
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_ErrorModal__WEBPACK_IMPORTED_MODULE_6__["default"], { isOpen: errorModalState, message: i18n.errorOutdialFailed, buttons: [
                    {
                        label: common.okButton,
                        onClick: errorModalCallback,
                        ariaLabel: common.okButton
                    }
                ], modalHeader: common.Error, trackingId: errorTrackingId, showCloseButton: false, noExitOnEsc: false, setErrorModal: setErrorModalState }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({}, (toHidePopover() ? { disabled: true } : ""), { ref: popoverElm, ariaRole: "dialog", "data-testid": "outdial-popover-md-menu-overlay", ariaLabel: i18n.mainIconTooltip, "aria-describedby": isAdhocDialingEnabled ? "outdial-dialog-details" : undefined, "custom-width": showSearchTab ? "384px" : "245px", "max-height": "465px", class: "outdial-menu" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ slot: "menu-trigger", placement: "bottom", message: isOutDialEnabledAgent ? i18n.mainIconTooltip : i18n.errorOutdialDisabled }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ ariaLabel: isOutDialEnabledAgent ? i18n.mainIconTooltip : i18n.errorOutdialDisabled, ariaExpanded: !!isOutdialModalOpen, size: "32", variant: "ghost", class: "outdial-opener", circle: true }, (toHidePopover() ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "handset-bold", size: "20", iconSet: "momentumDesign" }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ id: "outdial-dialog-details", className: "sr-only" }, { children: i18n.outdialDialogDescription })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "outdial-main height-with-ani" }, { children: isAdhocDialingEnabled || showSearchTab ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-tabs", Object.assign({ role: "tablist", justified: true, selected: isAdhocDialingEnabled && showSearchTab ? "2" : "1", ref: tabElm }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab", Object.assign({ slot: "tab", role: "tab", "aria-label": i18n.addressTab }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "bottom", message: i18n.addressTabTooltip }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "contact-card-bold", size: "16", iconSet: "momentumDesign" }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab-panel", Object.assign({ slot: "panel", class: "address-panel", "focusable-panel": "false" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddressBook_components__WEBPACK_IMPORTED_MODULE_7__["default"], { addressList: addressList, loadingError: loadingError, loadingTrackingId: loadingTrackingId, retryLoadingAddressBook: retryLoadingAddressBook, isAdhocDialingEnabled: isAdhocDialingEnabled, initiateOutboundCall: initiateOutboundCall, closePopover: closePopover, outdialAniList: outdialAniList, resetFocusableElements: resetFocusableElements, isDarkModeEnable: isDarkModeEnable, isAddressBookLoading: isAddressBookLoading, selectedANI: selectedANI, isAddressBookInfiniteScrollEnabled: isAddressBookInfiniteScrollEnabled, initiateDataFetch: isOutdialModalOpen ? 1 : 0, aniOverlayWidth: aniOverlayWidth, isOutdialAniInfiniteScrollEnabled: isOutdialAniInfiniteScrollEnabled, orgId: orgId }) })), showSearchTab && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab", Object.assign({ slot: "tab", role: "tab", "aria-label": i18n.searchTab }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "bottom", message: i18n.searchTabTooltip }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "queue-contact-bold", size: "16", iconSet: "momentumDesign" }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab-panel", Object.assign({ slot: "panel", "focusable-panel": "false" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_EnterpriseSearch_components_OutDialEnterpriseSearch__WEBPACK_IMPORTED_MODULE_9__["default"], { displayMicrosoftUserDetails: displayMicrosoftUserDetails, displayWebexUserDetails: displayWebexUserDetails, microsoftAuthenticated: microsoftAuthenticated, initiateOutboundCall: initiateOutboundCall, closePopover: closePopover, outdialAniList: outdialAniList, resetFocusableElements: resetFocusableElements, isDarkMode: isDarkModeEnable, selectedANI: selectedANI, resetTab: selectedTab, isOutdialAniInfiniteScrollEnabled: isOutdialAniInfiniteScrollEnabled, orgId: orgId }) }))] })), isAdhocDialingEnabled && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab", Object.assign({ slot: "tab", role: "tab", "aria-label": i18n.dialpadTab }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "bottom", message: i18n.dialpadTooltip }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "dialpad-bold", size: "16", iconSet: "momentumDesign" }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tab-panel", Object.assign({ slot: "panel" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Dialpad_components__WEBPACK_IMPORTED_MODULE_8__["default"], { addressList: addressList, outdialAniList: outdialAniList, phoneValidateRegex: phoneValidateRegex, initiateOutboundCall: initiateOutboundCall, closePopover: closePopover, resetFocusableElements: resetFocusableElements, isDarkModeEnable: isDarkModeEnable, selectedANI: selectedANI, aniOverlayWidth: aniOverlayWidth, isOutdialAniInfiniteScrollEnabled: isOutdialAniInfiniteScrollEnabled, orgId: orgId }) }))] }))] }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddressBook_components__WEBPACK_IMPORTED_MODULE_7__["default"], { addressList: addressList, loadingError: loadingError, loadingTrackingId: loadingTrackingId, retryLoadingAddressBook: retryLoadingAddressBook, isAdhocDialingEnabled: isAdhocDialingEnabled, initiateOutboundCall: initiateOutboundCall, closePopover: closePopover, outdialAniList: outdialAniList, resetFocusableElements: resetFocusableElements, isDarkModeEnable: isDarkModeEnable, isAddressBookLoading: isAddressBookLoading, selectedANI: selectedANI, isAddressBookInfiniteScrollEnabled: isAddressBookInfiniteScrollEnabled, initiateDataFetch: isOutdialModalOpen ? 1 : 0, aniOverlayWidth: aniOverlayWidth, isOutdialAniInfiniteScrollEnabled: isOutdialAniInfiniteScrollEnabled, orgId: orgId })) }))] }))] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OutdialPopover);


/***/ }),

/***/ "./src/direflow-components/Outdial/components/index.tsx":
/*!**************************************************************!*\
  !*** ./src/direflow-components/Outdial/components/index.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../constants */ "./src/constants.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _EmailComposer_Context_AppContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../EmailComposer/Context/AppContext */ "./src/direflow-components/EmailComposer/Context/AppContext.tsx");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../styles.css */ "./src/direflow-components/Outdial/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _OutdialPopover__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./OutdialPopover */ "./src/direflow-components/Outdial/components/OutdialPopover.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











const OutdialComponent = ({ showPopover, outDialAni, addressBook, orgId, selectedANI, isDarkModeEnable, shouldDisableOutdialForExclusive, isOutDialEnabledTenant, isOutDialEnabledAgent, isAdhocDialingEnabled, phoneValidateRegex, outdialEntryPointId, agentDn, isCallInProgress, webRtcStatus, isWebRTCEnabled, deviceType, isAddressBookInfiniteScrollEnabled, isOutdialOrgSearchEnabled, displayMicrosoftUserDetails, displayWebexUserDetails, microsoftAuthenticated, isOutdialAniInfiniteScrollEnabled }) => {
    const [selectedTab, setSelectedTab] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(1);
    const [isAddressBookLoading, setIsAddressBookLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const logger = (0,_sdk__WEBPACK_IMPORTED_MODULE_6__.createLogger)("[Outdial]");
    const onTabSelect = (selectedTabIndex) => {
        setSelectedTab(selectedTabIndex);
    };
    const dispatchCustomEvent = (0,_EmailComposer_Context_AppContext__WEBPACK_IMPORTED_MODULE_8__.useEventContext)();
    const retryLoadingAddressBook = () => {
        fetchAddressBook();
    };
    const fetchOutdialANI = () => {
        var _a;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs
            .fetchOutdialANICMS({
            orgId,
            outdialANIId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.outdialANIId) || ""
        })
            .then((resp) => {
            const event = new CustomEvent("ax-outdial-update-ani-list", {
                detail: { data: resp },
                bubbles: true,
                composed: true
            });
            if (dispatchCustomEvent) {
                dispatchCustomEvent(event);
            }
        })
            .catch((err) => {
            handleOutdialANIFailure(err);
            logger.error(`event=fetchOutdialANIError | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err)}] Fetch Outdial ANI Error :', ${JSON.stringify(err)}`, err);
        });
    };
    const { loadingError, loadingTrackingId } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
        var _a, _b, _c;
        if (addressBook.initialFetchCompleted && addressBook.errorObj) {
            return {
                loadingError: addressBook.errorObj.message || ((_c = (_b = (_a = addressBook.errorObj) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.msg) === null || _c === void 0 ? void 0 : _c.message) || addressBook.errorObj,
                loadingTrackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(addressBook.errorObj)
            };
        }
        return { loadingError: "", loadingTrackingId: undefined };
    }, [addressBook]);
    const handleOutdialANIFailure = (error) => {
        const event = new CustomEvent("ax-outdial-update-ani-list-failed", {
            detail: { error },
            bubbles: true,
            composed: true
        });
        if (dispatchCustomEvent) {
            dispatchCustomEvent(event);
        }
    };
    const fetchAddressBookSuccess = (data) => {
        const event = new CustomEvent("ax-outdial-fetch-addressbook-list-success", {
            detail: { data },
            bubbles: true,
            composed: true
        });
        if (dispatchCustomEvent) {
            dispatchCustomEvent(event);
        }
    };
    const fetchAddressBookFailure = (error) => {
        const event = new CustomEvent("ax-outdial-fetch-addressbook-list-failure", {
            detail: { error },
            bubbles: true,
            composed: true
        });
        if (dispatchCustomEvent) {
            dispatchCustomEvent(event);
        }
    };
    const fetchAddressBook = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsAddressBookLoading(true);
            const response = yield (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_7__.fetchAddressBookList)();
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.ADDRESS_BOOK, {
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_PROPS.ADDRESS_BOOK_LIST]: _constants__WEBPACK_IMPORTED_MODULE_4__.OUTDIAL
            });
            fetchAddressBookSuccess(response);
        }
        catch (error) {
            fetchAddressBookFailure(error);
        }
        finally {
            setIsAddressBookLoading(false);
        }
    });
    const fetchData = () => {
        if (!addressBook.initialFetchCompleted && !isAddressBookInfiniteScrollEnabled) {
            fetchAddressBook();
        }
        if (!outDialAni.initialFetchCompleted && !isOutdialAniInfiniteScrollEnabled) {
            fetchOutdialANI();
        }
    };
    const onMenuOverlayInitialOpen = () => {
        fetchData();
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.Styled, Object.assign({ styles: (_styles_css__WEBPACK_IMPORTED_MODULE_9___default()) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: isOutDialEnabledTenant && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutdialPopover__WEBPACK_IMPORTED_MODULE_10__["default"], { onMenuOverlayInitialOpen: onMenuOverlayInitialOpen, shouldDisableOutdialForExclusive: shouldDisableOutdialForExclusive, addressList: addressBook.data, onTabSelect: onTabSelect, selectedTab: selectedTab, outdialAniList: outDialAni.data, showPopover: showPopover, loadingError: loadingError, loadingTrackingId: loadingTrackingId, retryLoadingAddressBook: retryLoadingAddressBook, isOutDialEnabledAgent: isOutDialEnabledAgent, isAdhocDialingEnabled: isAdhocDialingEnabled, phoneValidateRegex: phoneValidateRegex, outdialEntryPointId: outdialEntryPointId, agentDn: agentDn, selectedANI: selectedANI, isCallInProgress: isCallInProgress, isDarkModeEnable: isDarkModeEnable, isAddressBookLoading: isAddressBookLoading, webRtcStatus: webRtcStatus, isWebRTCEnabled: isWebRTCEnabled, deviceType: deviceType, isAddressBookInfiniteScrollEnabled: isAddressBookInfiniteScrollEnabled, isOutdialOrgSearchEnabled: isOutdialOrgSearchEnabled, displayMicrosoftUserDetails: displayMicrosoftUserDetails, displayWebexUserDetails: displayWebexUserDetails, microsoftAuthenticated: microsoftAuthenticated, isOutdialAniInfiniteScrollEnabled: isOutdialAniInfiniteScrollEnabled, orgId: orgId })) }) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OutdialComponent);


/***/ }),

/***/ "./src/direflow-components/Outdial/styles.css":
/*!****************************************************!*\
  !*** ./src/direflow-components/Outdial/styles.css ***!
  \****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../node_modules/css-loader/dist/cjs.js!./styles.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/Outdial/styles.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/direflow-components/Outdial/utils.ts":
/*!**************************************************!*\
  !*** ./src/direflow-components/Outdial/utils.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DEFAULT_ERROR_OBJECT: () => (/* binding */ DEFAULT_ERROR_OBJECT),
/* harmony export */   ItemHeight: () => (/* binding */ ItemHeight),
/* harmony export */   MINIMUM_CHARACTERS_FOR_SEARCH: () => (/* binding */ MINIMUM_CHARACTERS_FOR_SEARCH),
/* harmony export */   PAGE_SIZE: () => (/* binding */ PAGE_SIZE),
/* harmony export */   fetchOutdialANIs: () => (/* binding */ fetchOutdialANIs)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../sdk */ "./src/sdk.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


const PAGE_SIZE = 100;
const DEFAULT_ERROR_OBJECT = {
    error: false,
    trackingId: ""
};
const ItemHeight = 36;
const MINIMUM_CHARACTERS_FOR_SEARCH = 3;
const fetchOutdialANIs = (orgId, page, searchQuery) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const params = {
            orgId,
            page,
            pageSize: PAGE_SIZE,
            search: searchQuery,
            outdialANIId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.outdialANIId) || ""
        };
        const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.abs.fetchPaginatedOutdialANI(params);
        return {
            data: response.data.data.outdialAniList,
            meta: response.meta
        };
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`event=fetchOutdialAnis | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error) : ""} | Fetching fetchOutdialAnis failed : ${error}`, error);
        throw error;
    }
});


/***/ }),

/***/ "./src/direflow-components/Utility/Utils/ImiChatInitializer.ts":
/*!*********************************************************************!*\
  !*** ./src/direflow-components/Utility/Utils/ImiChatInitializer.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IMI_EVENTS: () => (/* binding */ IMI_EVENTS),
/* harmony export */   attachImiEventListener: () => (/* binding */ attachImiEventListener),
/* harmony export */   dispatchCustomEvent: () => (/* binding */ dispatchCustomEvent),
/* harmony export */   initializeImiChat: () => (/* binding */ initializeImiChat)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../sdk */ "./src/sdk.ts");

const IMI_MESSAGE_RECEIVED = "imi-message-received";
const IMI_CONVERSATION_LOADED = "imi-conversation-loaded";
const IMI_CONVERSATION_LOADED_ERROR = "imi-conversation-loaded-error";
const LIVECHAT_CHAT_CLOSED = "imi-livechat-closed";
const IMI_SERVICES_INITIALIZED = "imi-services-initialized";
const IMI_EVENTS = {
    CONV_LOADED: "onConversationLoaded",
    CONV_LOAD_ERROR: "onConversationLoadedError",
    MESSAGE_RECEIVED: "onMessageReceived",
    LIVECHAT_CHAT_CLOSED: "LIVECHAT_CHAT_CLOSED",
    IMI_SERVICES_INITIALIZED: "IMI_SERVICES_INITIALIZED"
};
const logger = (0,_sdk__WEBPACK_IMPORTED_MODULE_0__.createLogger)("[ImiWidgetInitializer]");
const dispatchCustomEvent = (eventName, dataToBeSend, dispatchCustom) => {
    const event = new CustomEvent(eventName, {
        detail: dataToBeSend,
        bubbles: true,
        composed: true
    });
    dispatchCustom(event);
};
const attachImiEventListener = (name, data, dispatchCustom) => {
    switch (name) {
        case IMI_EVENTS.MESSAGE_RECEIVED:
            dispatchCustomEvent(IMI_MESSAGE_RECEIVED, data, dispatchCustom);
            break;
        case IMI_EVENTS.CONV_LOADED:
            logger.info("Conversation Loaded event", data);
            dispatchCustomEvent(IMI_CONVERSATION_LOADED, data, dispatchCustom);
            break;
        case IMI_EVENTS.CONV_LOAD_ERROR:
            logger.info("Conversation Loaded Error event", data);
            dispatchCustomEvent(IMI_CONVERSATION_LOADED_ERROR, data, dispatchCustom);
            break;
        case IMI_EVENTS.LIVECHAT_CHAT_CLOSED:
            logger.info("Conversation Closed event", data);
            dispatchCustomEvent(LIVECHAT_CHAT_CLOSED, data, dispatchCustom);
            break;
        case IMI_EVENTS.IMI_SERVICES_INITIALIZED:
            logger.info("IMI Services initialized event", data);
            dispatchCustomEvent(IMI_SERVICES_INITIALIZED, data, dispatchCustom);
            break;
        default:
            break;
    }
};
const initializeImiChat = (accessToken, dispatchCustom) => {
    const config = {
        cb: (name, data) => attachImiEventListener(name, data, dispatchCustom),
        logger: _sdk__WEBPACK_IMPORTED_MODULE_0__.loggerForImi
    };
    try {
        const imiEngage = new window.ImiEngageWC(config);
        imiEngage.setParam("data", { jwt: accessToken, lang: "en-US" });
        logger.info("IMI chat widget initialized successfully", imiEngage);
    }
    catch (error) {
        logger.error("Error in initializing IMI chat widget", error);
    }
};


/***/ }),

/***/ "./src/direflow-components/Utility/Utils/InteractionControlUtils.ts":
/*!**************************************************************************!*\
  !*** ./src/direflow-components/Utility/Utils/InteractionControlUtils.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   consultState: () => (/* binding */ consultState),
/* harmony export */   getAgentActionType: () => (/* binding */ getAgentActionType),
/* harmony export */   getButtonIndex: () => (/* binding */ getButtonIndex),
/* harmony export */   getInteractionButtons: () => (/* binding */ getInteractionButtons),
/* harmony export */   getName: () => (/* binding */ getName),
/* harmony export */   getStatusFromInteraction: () => (/* binding */ getStatusFromInteraction),
/* harmony export */   isAgentConsulting: () => (/* binding */ isAgentConsulting),
/* harmony export */   isBargedInteraction: () => (/* binding */ isBargedInteraction),
/* harmony export */   isEPorEPDN: () => (/* binding */ isEPorEPDN),
/* harmony export */   isPostCallConsultCompleted: () => (/* binding */ isPostCallConsultCompleted),
/* harmony export */   isPostCallConsultInProgress: () => (/* binding */ isPostCallConsultInProgress),
/* harmony export */   isPostCallConsultRequested: () => (/* binding */ isPostCallConsultRequested)
/* harmony export */ });
/* harmony import */ var _AgentProfile_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../AgentProfile/constants */ "./src/direflow-components/AgentProfile/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../InteractionControl/constants */ "./src/direflow-components/InteractionControl/constants.js");




const consultState = ["consult", "consulting"];
const getName = (selectedContactData) => {
    if ((selectedContactData === null || selectedContactData === void 0 ? void 0 : selectedContactData.eventName) === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.TRANSFER_COMPLETED &&
        (selectedContactData === null || selectedContactData === void 0 ? void 0 : selectedContactData.destinationAgentDNIS) &&
        !(selectedContactData === null || selectedContactData === void 0 ? void 0 : selectedContactData.destinationAgentName)) {
        return selectedContactData === null || selectedContactData === void 0 ? void 0 : selectedContactData.destinationAgentDNIS;
    }
    return selectedContactData === null || selectedContactData === void 0 ? void 0 : selectedContactData.agentName;
};
const getButtonIndex = (newCallbuttons, buttonType) => {
    return newCallbuttons
        .map((e) => {
        return e.type;
    })
        .indexOf(buttonType);
};
const isPostCallConsultRequested = (interaction) => {
    if (interaction.isInteractionInPostCall) {
        return interaction.consultState === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.POST_CALL_CONSULT_TYPE.INITIATED;
    }
    return false;
};
const isPostCallConsultInProgress = (interaction) => {
    if (interaction.isInteractionInPostCall) {
        return interaction.consultState === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.POST_CALL_CONSULT_TYPE.ACTIVE;
    }
    return false;
};
const isPostCallConsultCompleted = (interaction) => {
    if (interaction.isInteractionInPostCall) {
        return interaction.consultState === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.POST_CALL_CONSULT_TYPE.COMPLETED;
    }
    return false;
};
const isAgentConsulting = (data, isMPCEnabled) => {
    const isConsultState = consultState.includes(data.state) || isPostCallConsultInProgress(data);
    return isMPCEnabled
        ? isConsultState &&
            !!data.primaryMediaParticipants &&
            Object.keys(data.primaryMediaParticipants).includes(data.agentId) &&
            !data.isSecondaryEpDnAgent // EPDN check for consult view
        : data.isOwner && isConsultState;
};
const isEPorEPDN = (destAgentType) => {
    return destAgentType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EPDN || destAgentType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.ENTRYPOINT;
};
const getAgentActionType = (data) => {
    return data.destAgentType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.DN || isEPorEPDN(data.destAgentType) || data.isSecondaryAgentCBT ? _Common_constants__WEBPACK_IMPORTED_MODULE_2__.DIAL_NUMBER : "";
};
const getConsultingViewStatus = (data, isMPCEnabled) => {
    var _a;
    const postCallConsultInProgress = isPostCallConsultInProgress(data);
    const agentConsulting = isAgentConsulting(data, isMPCEnabled);
    if ((((_a = data === null || data === void 0 ? void 0 : data.state) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULTING || postCallConsultInProgress) && !agentConsulting) {
        return data.consultHold ? _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULTED_AGENT_HELD : _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULTED_AGENT_UNHELD;
    }
    if (consultState.includes(data.state) || postCallConsultInProgress) {
        return data.consultHold ? _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULT_HOLD : _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULT_UNHELD;
    }
    if (data.isConferencing) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONFERENCE;
    }
    return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONNECTED;
};
const getStatusFromInteraction = (data, isConsultView, isMPCEnabled) => {
    var _a, _b, _c, _d;
    if (data.isBargedIn) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.BARGEIN;
    }
    if (data.isMonitoringOnHold) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MONITORINGHELD;
    }
    if (data.type === "MonitoringUnHeld") {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MONITORINGUNHELD;
    }
    if (data.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.MIDCALL_MONITORING) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.SILENTMONITORING;
    }
    if (isPostCallConsultRequested(data) && isConsultView) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULT_REQUESTED;
    }
    if (isConsultView) {
        return getConsultingViewStatus(data, isMPCEnabled);
    }
    if (((_a = data === null || data === void 0 ? void 0 : data.state) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULTING && isEPorEPDN(data.destAgentType) && !isConsultView && !data.isHold) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EPDN_CONSULTING;
    }
    if (((_b = data === null || data === void 0 ? void 0 : data.state) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULTING && isEPorEPDN(data.destAgentType) && !isConsultView && data.isHold) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EPDN_HOLD;
    }
    if (((_c = data === null || data === void 0 ? void 0 : data.state) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULTING && !isConsultView && !data.isHold) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULTING;
    }
    if (((_d = data === null || data === void 0 ? void 0 : data.state) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULTING && !isConsultView && data.isHold) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.HOLD;
    }
    if (data.state === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULT.toLowerCase() && !isConsultView) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONSULT_REQUESTED;
    }
    if (data.isWrapUp) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.WRAP_UP;
    }
    if (data.isInteractionInPostCall && !isConsultView) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.POST_CALL;
    }
    if (data.isWrapUpAssist) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.WRAPUP_ASSIST;
    }
    if (data.isConferencing) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONFERENCE;
    }
    if (data.hasJoined && !data.isHold) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONNECTED;
    }
    if (data.isHold) {
        return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.HOLD;
    }
    return _Common_constants__WEBPACK_IMPORTED_MODULE_2__.CONNECTED;
};
function getInteractionButtons(mediaType, agentconfig, contactDirection = "", isBargedIn = false) {
    const newCallbuttons = _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.interactionControlButtons.callControls.map((a) => (Object.assign({}, a)));
    const monitoringControlButtons = [..._InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.interactionControlButtons.monitoringControls];
    const bargedInControlButtons = [..._InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.interactionControlButtons.bargedInControls];
    const shouldShowCallControlsForWebexCall = agentconfig.webexCallingCallId && agentconfig.webexCallingCallId !== "";
    switch (mediaType) {
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.CHAT:
            return _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.interactionControlButtons.chatControls;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.SOCIAL:
            if ((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_1__.isOutboundContact)(contactDirection)) {
                return _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.interactionControlButtons.digitalOutboundControls;
            }
            return _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.interactionControlButtons.chatControls;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.EMAIL:
            if ((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_1__.isOutboundContact)(contactDirection)) {
                return _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.interactionControlButtons.digitalOutboundControls;
            }
            return _InteractionControl_constants__WEBPACK_IMPORTED_MODULE_3__.interactionControlButtons.emailControls;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.VOICE:
            if (agentconfig.deviceType !== _AgentProfile_constants__WEBPACK_IMPORTED_MODULE_0__.BROWSER && !shouldShowCallControlsForWebexCall) {
                // removing Keypad and mute/unmute Button from Interaction Buttons.
                const keypadIndex = getButtonIndex(newCallbuttons, _Common_constants__WEBPACK_IMPORTED_MODULE_2__.KEYPAD_BUTTON);
                newCallbuttons.splice(keypadIndex, 1);
                const muteIndex = getButtonIndex(newCallbuttons, _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MUTE_BUTTON);
                newCallbuttons.splice(muteIndex, 1);
                const unmuteIndex = getButtonIndex(newCallbuttons, _Common_constants__WEBPACK_IMPORTED_MODULE_2__.UNMUTE_BUTTON);
                newCallbuttons.splice(unmuteIndex, 1);
            }
            if (!agentconfig.isendcallenabled || !agentconfig.isEndConsultEnabled) {
                if (!agentconfig.isendcallenabled &&
                    (agentconfig.deviceType !== _AgentProfile_constants__WEBPACK_IMPORTED_MODULE_0__.BROWSER || !agentconfig.isWebrtcEndCallEnabled)) {
                    const index = getButtonIndex(newCallbuttons, _Common_constants__WEBPACK_IMPORTED_MODULE_2__.END_BUTTON);
                    // removing End Button from Interaction Buttons.
                    newCallbuttons.splice(index, 1);
                }
                if (!agentconfig.isEndConsultEnabled) {
                    let index = getButtonIndex(newCallbuttons, _Common_constants__WEBPACK_IMPORTED_MODULE_2__.ENDCONSULT_BUTTON);
                    // removing End Consult Button from Interaction Buttons.
                    newCallbuttons.splice(index, 1);
                    index = getButtonIndex(newCallbuttons, _Common_constants__WEBPACK_IMPORTED_MODULE_2__.EXIT_CONSULT);
                    // removing Exit consult  Button from Interaction Buttons.
                    newCallbuttons.splice(index, 1);
                }
            }
            if (agentconfig.isWxccPersistConsultEnabled) {
                const endConsultIndex = getButtonIndex(newCallbuttons, _Common_constants__WEBPACK_IMPORTED_MODULE_2__.ENDCONSULT_BUTTON);
                if (endConsultIndex !== -1) {
                    const [endConsultButton] = newCallbuttons.splice(endConsultIndex, 1);
                    newCallbuttons.push(endConsultButton);
                }
            }
            return newCallbuttons;
        case _Common_constants__WEBPACK_IMPORTED_MODULE_2__.MEDIA_TYPES.MIDCALL_MONITORING:
            if (!agentconfig.isBargeInEnabled) {
                const bargeInButtonIndex = getButtonIndex(monitoringControlButtons, _Common_constants__WEBPACK_IMPORTED_MODULE_2__.BARGEIN_BUTTON);
                monitoringControlButtons.splice(bargeInButtonIndex, 1);
            }
            //If we are barged in with webrtc, display the new controls
            if (agentconfig.isWebRTCEnabled && agentconfig.deviceType === _AgentProfile_constants__WEBPACK_IMPORTED_MODULE_0__.BROWSER && isBargedIn) {
                return bargedInControlButtons;
            }
            return monitoringControlButtons;
        default:
            return [];
    }
}
function isBargedInteraction(agentId, interactionId, agentCallMonitoringState) {
    return (agentCallMonitoringState &&
        agentCallMonitoringState.monitoringType === _Common_constants__WEBPACK_IMPORTED_MODULE_2__.BARGE_IN_MONITORING_STATE &&
        agentId === agentCallMonitoringState.agentId &&
        interactionId === agentCallMonitoringState.interactionId);
}


/***/ }),

/***/ "./src/direflow-components/Utility/Utils/MSFTavatarUtils.ts":
/*!******************************************************************!*\
  !*** ./src/direflow-components/Utility/Utils/MSFTavatarUtils.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SynchStatus: () => (/* binding */ SynchStatus),
/* harmony export */   getAvatarStatus: () => (/* binding */ getAvatarStatus),
/* harmony export */   getUserSynchStatus: () => (/* binding */ getUserSynchStatus)
/* harmony export */ });
const AvailabilityConst = {
    Available: "Available",
    AvailableIdle: "AvailableIdle",
    Away: "Away",
    BeRightBack: "BeRightBack",
    Busy: "Busy",
    BusyIdle: "BusyIdle",
    DoNotDisturb: "DoNotDisturb",
    Offline: "Offline"
};
const ActivityConst = {
    Available: "Available",
    Away: "Away",
    BeRightBack: "BeRightBack",
    Busy: "Busy",
    DoNotDisturb: "DoNotDisturb",
    InACall: "InACall",
    InAConferenceCall: "InAConferenceCall",
    Inactive: "Inactive",
    InAMeeting: "InAMeeting",
    Offline: "Offline",
    OffWork: "OffWork",
    OutOfOffice: "OutOfOffice",
    PresenceUnknown: "PresenceUnknown",
    Presenting: "Presenting",
    UrgentInterruptionsOnly: "UrgentInterruptionsOnly"
};
const getAvatarStatus = (availability, activity, StatusType) => {
    const status = {
        [`${AvailabilityConst.Available}-${ActivityConst.Available}`]: StatusType.Available,
        [`${AvailabilityConst.Available}-${ActivityConst.OutOfOffice}`]: StatusType.Available,
        [`${AvailabilityConst.Busy}-${ActivityConst.Busy}`]: StatusType.Busy,
        [`${AvailabilityConst.Busy}-${ActivityConst.InACall}`]: StatusType.OnCall,
        [`${AvailabilityConst.Busy}-${ActivityConst.InAMeeting}`]: StatusType.Meeting,
        [`${AvailabilityConst.Busy}-${ActivityConst.OutOfOffice}`]: StatusType.Busy,
        [`${AvailabilityConst.DoNotDisturb}-${ActivityConst.DoNotDisturb}`]: StatusType.DnD,
        [`${AvailabilityConst.DoNotDisturb}-${ActivityConst.Presenting}`]: StatusType.Presenting,
        [`${AvailabilityConst.DoNotDisturb}-${ActivityConst.UrgentInterruptionsOnly}`]: StatusType.Busy,
        [`${AvailabilityConst.Away}-${ActivityConst.Away}`]: StatusType.Occupied,
        [`${AvailabilityConst.BeRightBack}-${ActivityConst.BeRightBack}`]: StatusType.Occupied,
        [`${AvailabilityConst.Offline}-${ActivityConst.Offline}`]: StatusType.Occupied,
        [`${AvailabilityConst.Offline}-${ActivityConst.OffWork}`]: StatusType.Occupied,
        [`${AvailabilityConst.Offline}-${ActivityConst.PresenceUnknown}`]: StatusType.UnKnown,
        [`${AvailabilityConst.Offline}-${ActivityConst.OutOfOffice}`]: StatusType.OutOfOffice
    };
    return status[`${availability}-${activity}`] || null;
};
const SynchStatus = {
    Available: "Available",
    AvailableOutOfOffice: "Available, Out of Office",
    Away: "Away",
    BeRightBack: "Be Right Back",
    Busy: "Busy",
    DoNotDisturb: "Do Not Disturb",
    Meeting: "In a Meeting",
    Offline: "Offline",
    OnCall: "On a Call",
    OutOfOffice: "Out Of Office",
    Presenting: "Presenting",
    Unknown: "Status Unknown"
};
const getUserSynchStatus = (availability, activity) => {
    const status = {
        [`${AvailabilityConst.Available}-${ActivityConst.Available}`]: SynchStatus.Available,
        [`${AvailabilityConst.Available}-${ActivityConst.OutOfOffice}`]: SynchStatus.AvailableOutOfOffice,
        [`${AvailabilityConst.Busy}-${ActivityConst.Busy}`]: SynchStatus.Busy,
        [`${AvailabilityConst.Busy}-${ActivityConst.InACall}`]: SynchStatus.OnCall,
        [`${AvailabilityConst.Busy}-${ActivityConst.InAMeeting}`]: SynchStatus.Meeting,
        [`${AvailabilityConst.Busy}-${ActivityConst.OutOfOffice}`]: SynchStatus.Busy,
        [`${AvailabilityConst.DoNotDisturb}-${ActivityConst.DoNotDisturb}`]: SynchStatus.DoNotDisturb,
        [`${AvailabilityConst.DoNotDisturb}-${ActivityConst.Presenting}`]: SynchStatus.Presenting,
        [`${AvailabilityConst.DoNotDisturb}-${ActivityConst.UrgentInterruptionsOnly}`]: SynchStatus.Busy,
        [`${AvailabilityConst.Away}-${ActivityConst.Away}`]: SynchStatus.Away,
        [`${AvailabilityConst.BeRightBack}-${ActivityConst.BeRightBack}`]: SynchStatus.BeRightBack,
        [`${AvailabilityConst.Offline}-${ActivityConst.Offline}`]: SynchStatus.Offline,
        [`${AvailabilityConst.Offline}-${ActivityConst.OffWork}`]: SynchStatus.Offline,
        [`${AvailabilityConst.Offline}-${ActivityConst.PresenceUnknown}`]: SynchStatus.Unknown,
        [`${AvailabilityConst.Offline}-${ActivityConst.OutOfOffice}`]: SynchStatus.OutOfOffice
    };
    return status[`${availability}-${activity}`] || SynchStatus.Unknown;
};


/***/ }),

/***/ "./src/direflow-components/Utility/Utils/TaskListeners.ts":
/*!****************************************************************!*\
  !*** ./src/direflow-components/Utility/Utils/TaskListeners.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TaskListeners: () => (/* binding */ TaskListeners),
/* harmony export */   attachTaskListeners: () => (/* binding */ attachTaskListeners),
/* harmony export */   conferenceTaskEvents: () => (/* binding */ conferenceTaskEvents),
/* harmony export */   consultTaskEvents: () => (/* binding */ consultTaskEvents),
/* harmony export */   ctqTaskEvents: () => (/* binding */ ctqTaskEvents),
/* harmony export */   dispatchListenerEvent: () => (/* binding */ dispatchListenerEvent),
/* harmony export */   endTaskEvent: () => (/* binding */ endTaskEvent),
/* harmony export */   monitoringEventListeners: () => (/* binding */ monitoringEventListeners),
/* harmony export */   offerTaskEvent: () => (/* binding */ offerTaskEvent),
/* harmony export */   outBoundTaskEvents: () => (/* binding */ outBoundTaskEvents),
/* harmony export */   sendCallTypeTelemetry: () => (/* binding */ sendCallTypeTelemetry),
/* harmony export */   stopAllListeners: () => (/* binding */ stopAllListeners)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _AgentProfile_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../AgentProfile/constants */ "./src/direflow-components/AgentProfile/constants.ts");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../InteractionPopoverManager/Utils/InteractionPopoversUtils */ "./src/direflow-components/InteractionPopoverManager/Utils/InteractionPopoversUtils.ts");





const logger = (0,_sdk__WEBPACK_IMPORTED_MODULE_1__.createLogger)("[TaskListener]");
const AGENT_CONTACT_ENDED = "agent-contact-ended";
const AGENT_CONTACT_ASSIGN_FAILED = "agent-contact-assigned-failed";
const getTrackingPayload = (name, data, deviceType) => {
    return {
        eventName: name,
        interactionId: data.interactionId,
        ani: data.interaction.callProcessingDetails.ani,
        mediaType: data.interaction.mediaType,
        mediaChannel: data.interaction.mediaChannel,
        contactDirection: data.interaction.contactDirection.type,
        outboundType: data.interaction.outboundType,
        deviceType
    };
};
const getPrometheusTrackingPayload = (data, reason) => {
    return {
        interactionId: data.interactionId,
        media_type: data.interaction.mediaType,
        Reason: reason || data.reasonCode
    };
};
let listenersAggregator = [];
const dispatchListenerEvent = (eventName, dataToBeSend, dispatchCustom) => {
    const event = new CustomEvent(eventName, {
        detail: dataToBeSend,
        bubbles: true,
        composed: true
    });
    if (dispatchCustom) {
        dispatchCustom(event);
    }
};
const sendCallTypeTelemetry = (data) => {
    if (data && data.agentId) {
        const participant = data.interaction.participants[data.agentId];
        const hideWebexCallingSetting = localStorage.getItem(_AgentProfile_constants__WEBPACK_IMPORTED_MODULE_2__.DESKTOP_HIDE_WEBEX_CALLING_NOTIFICATIONS_SETTING);
        participant.deviceCallId && participant.deviceId && hideWebexCallingSetting === "true"
            ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_CACHE_KEYS.CALL_TYPE, "Webex_routed_to_WxCC")
            : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_CACHE_KEYS.CALL_TYPE, "Webex_call");
    }
};
const offerTaskEvent = (dispatchCustom, deviceType) => {
    listenersAggregator = listenersAggregator.concat([
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentContactReserved.listen(({ data }) => {
            logger.info("event= AgentContactReserved:", data);
            dispatchListenerEvent("agent-contact-reserved", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentOfferContact.listen(({ data }) => {
            logger.info("event= AgentOfferContact:", data);
            dispatchListenerEvent("agent-offer-contact", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackInitialCallEvents({
                interactionId: data.interactionId,
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_INITIATED,
                contactDirection: data.interaction.contactDirection.type,
                ani: data.interaction.callProcessingDetails.ani,
                mediaType: data.interaction.mediaType,
                outboundType: data.interaction.outboundType,
                deviceType
            });
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentOfferConsult.listen(({ data }) => {
            logger.info("event= AgentOfferConsult:", data);
            dispatchListenerEvent("agent-offer-consult", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentContact.listen(({ data }) => {
            logger.info("event= AgentContact event:", data);
            dispatchListenerEvent("agent-contact", data, dispatchCustom);
        })
    ]);
};
const endTaskEvent = (dispatchCustom, deviceType) => {
    listenersAggregator = listenersAggregator.concat([
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentContactEnded.listen(({ data }) => {
            logger.info("event= AgentContactEnded:", data);
            dispatchListenerEvent(AGENT_CONTACT_ENDED, data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackCallEndedEvent(getTrackingPayload(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_COMPLETED, data, deviceType));
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.clearCache();
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentContactAssignFailed.listen(({ data }) => {
            var _a;
            if (data.interaction.mediaType === "telephony") {
                logger.info("event= AgentContactAssignFailed:", data);
                dispatchListenerEvent(AGENT_CONTACT_ENDED, data, dispatchCustom);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackInitialCallEvents({
                    eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_ANSWERED,
                    interactionId: data.interactionId,
                    contactDirection: data.interaction.contactDirection.type,
                    outboundType: data.interaction.outboundType,
                    ani: data.interaction.callProcessingDetails.ani,
                    mediaType: data.interaction.mediaType,
                    mediaChannel: data.interaction.mediaChannel,
                    status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                    reasonForFailure: "AgentContactAssignFailed",
                    reasonCode: data.reasonCode,
                    deviceType
                });
            }
            else if ((0,_InteractionPopoverManager_Utils_InteractionPopoversUtils__WEBPACK_IMPORTED_MODULE_4__.isContactOutdialOutbound)(data.interaction.contactDirection.type, (_a = data.interaction.outboundType) !== null && _a !== void 0 ? _a : "") &&
                (data.interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_3__.MEDIA_TYPES.EMAIL || data.interaction.mediaType === _Common_constants__WEBPACK_IMPORTED_MODULE_3__.MEDIA_TYPES.SOCIAL)) {
                dispatchListenerEvent(AGENT_CONTACT_ASSIGN_FAILED, data, dispatchCustom);
                dispatchListenerEvent(AGENT_CONTACT_ENDED, data, dispatchCustom);
            }
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentContactWrappedUp.listen(({ data }) => {
            logger.info("event= AgentContactWrappedUp event:", data);
            dispatchListenerEvent("agent-contact-wrappedup", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackWrapUpAppliedEvent(getTrackingPayload(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_WRAP_UP_APPLIED, data));
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentOfferContactRona.listen(({ data }) => {
            logger.info("event= AgentRonaContact:", data);
            dispatchListenerEvent("agent-contact-rona", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackInitialCallEvents({
                interactionId: data.interactionId,
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.AGENT_RONA,
                contactDirection: data.interaction.contactDirection.type,
                outboundType: data.interaction.outboundType,
                ani: data.interaction.callProcessingDetails.ani,
                mediaType: data.interaction.mediaType,
                reasonCode: data.reason
            });
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentInviteFailed.listen(({ data }) => {
            logger.info("event= AgentInviteFailed:", data);
            dispatchListenerEvent("agent-invite-failed", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackInitialCallEvents({
                interactionId: data.interactionId,
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.AGENT_INVITE_FAILED,
                contactDirection: data.interaction.contactDirection.type,
                ani: data.interaction.callProcessingDetails.ani,
                mediaType: data.interaction.mediaType
            });
            logger.info("event= RONA Device Failure:", data);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackInitialCallEvents({
                interactionId: data.interactionId,
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.AGENT_RONA,
                contactDirection: data.interaction.contactDirection.type,
                outboundType: data.interaction.outboundType,
                ani: data.interaction.callProcessingDetails.ani,
                mediaType: data.interaction.mediaType,
                reasonCode: "RONA Device Failure"
            });
        })
    ]);
};
const consultTaskEvents = (dispatchCustom) => {
    listenersAggregator = listenersAggregator.concat([
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentConsulting.listen(({ data }) => {
            logger.info("event= AgentConsulting:", data);
            dispatchListenerEvent("agent-consulting", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentConsultEnded.listen(({ data }) => {
            var _a, _b, _c, _d;
            logger.info("event= AgentConsultEnded event:", data);
            dispatchListenerEvent("agent-consult-ended", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackConsultEvent({
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_END_ACTIVATED,
                mediaType: data.interaction.mediaType,
                interactionId: data.interactionId,
                contactDirection: data.interaction.contactDirection.type,
                outboundType: data.interaction.outboundType
            });
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_CLICKED, Object.assign({ Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS }, getPrometheusTrackingPayload(data, "AgentConsultEnded")), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentConsultCreated.listen(({ data }) => {
            logger.info("event= AgentConsultCreated event:", data);
            dispatchListenerEvent("agent-consult-created", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentConsultFailed.listen(({ data }) => {
            var _a, _b, _c, _d;
            logger.info("event= AgentConsultFailed event:", data);
            dispatchListenerEvent("agent-consult-failed", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackConsultEvent({
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_END_ACTIVATED,
                mediaType: data.interaction.mediaType,
                interactionId: data.interactionId,
                contactDirection: data.interaction.contactDirection.type,
                outboundType: data.interaction.outboundType,
                status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                reasonForFailure: "AgentConsultFailed",
                reasonCode: data.reason
            });
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_CLICKED, Object.assign({ Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED }, getPrometheusTrackingPayload(data, "AgentConsultFailed")), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eContactMerged.listen(({ data }) => {
            logger.info("event= Agent ContactMerged event:", data);
            dispatchListenerEvent("agent-contact-merged", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentConsultTransferFailed.listen(({ data }) => {
            logger.info("event= Agent ConsultTransfer Failed event:", data);
            dispatchListenerEvent("agent-consult-transfer-failed", data, dispatchCustom);
        })
    ]);
};
const conferenceTaskEvents = (dispatchCustom) => {
    listenersAggregator = listenersAggregator.concat([
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentConsultConferenced.listen(({ data }) => {
            logger.info("event= AgentConsultConferenced event:", data);
            dispatchListenerEvent("agent-consult-conferenced", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackConsultEvent({
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONFERENCE_ACTIVATED,
                mediaType: data.interaction.mediaType,
                interactionId: data.interactionId,
                contactDirection: data.interaction.contactDirection.type,
                outboundType: data.interaction.outboundType
            });
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentConsultConferenceEnded.listen(({ data }) => {
            var _a, _b, _c, _d;
            logger.info("event= AgentConsultConferenceEnded event:", data);
            dispatchListenerEvent("agent-consult-conference-ended", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONFERENCE_ENDED, Object.assign({ Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS }, getPrometheusTrackingPayload(data, "AgentConsultConferencedEnded")), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus]);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eContactOwnerChanged.listen(({ data }) => {
            logger.info("event= ContactOwnerChanged event:", data);
            dispatchListenerEvent("contact-owner-changed", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eParticipantJoinedConference.listen(({ data }) => {
            logger.info("event= ParticipantJoinedConference event:", data);
            dispatchListenerEvent("agent-conference-participantJoined", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eParticipantLeftConference.listen(({ data }) => {
            logger.info("event= ParticipantLeftConference event:", data);
            dispatchListenerEvent("agent-conference-participantLeft", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentConferenceTransferred.listen(({ data }) => {
            logger.info("event= AgentConferenceTransferred event:", data);
            dispatchListenerEvent("agent-conference-transferred", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eParticipantPostCallActivity.listen(({ data }) => {
            logger.info("event= eParticipantPostCallActivity event:", data.interactionId, data);
            dispatchListenerEvent("participant-post-call-activity", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentConsultConferencing.listen(({ data }) => {
            logger.info("event= AgentConsultConferencing event:", data);
            dispatchListenerEvent("agent-consult-conferencing", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentConsultTransferring.listen(({ data }) => {
            //we are not performing any function during this event
            logger.info("event= AgentConsultTransferring event:", data);
        })
    ]);
};
const outBoundTaskEvents = (dispatchCustom, deviceType) => {
    listenersAggregator = listenersAggregator.concat([
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.dialer.eOutdialFailed.listen(({ data }) => {
            logger.info("event= AgentOutboundFailed event:", data);
            dispatchListenerEvent("agent-outbound-failed", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackInitialCallEvents({
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_INITIATED,
                interactionId: data.interactionId,
                contactDirection: data.interaction.contactDirection.type,
                outboundType: data.interaction.outboundType,
                customerDn: data.interaction.callProcessingDetails.dnis,
                mediaType: data.interaction.mediaType,
                status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                reasonForFailure: "AgentOutboundFailed",
                reasonCode: data.reason || "CUSTOMER_UNAVAILABLE",
                deviceType
            });
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.agent.eMockOutdialAniList.listen((data) => {
            logger.info("event= Outdial ANI List event:", data);
            dispatchListenerEvent("agent-outidal-ani-list", data, dispatchCustom);
        })
    ]);
};
const ctqTaskEvents = (dispatchCustom) => {
    listenersAggregator = listenersAggregator.concat([
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentCtqCancelFailed.listen(({ data }) => {
            logger.info("event= AgentCtqCancelFailed event:", data);
            dispatchListenerEvent("agent-ctq-cancel-failed", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentCtqCancelled.listen(({ data }) => {
            logger.info("event= AgentCtqCancelled event:", data);
            dispatchListenerEvent("agent-ctq-cancelled", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentCtqFailed.listen(({ data }) => {
            var _a, _b, _c, _d;
            logger.info("event= AgentCtqFailed event:", data);
            dispatchListenerEvent("agent-ctq-failed", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONSULT_CLICKED, Object.assign({ Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED }, getPrometheusTrackingPayload(data, "AgentCtqFailed")), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
        })
    ]);
};
const monitoringEventListeners = (dispatchCustom) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    listenersAggregator = listenersAggregator.concat([
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor.eAgentMonitorStateChanged.listen(({ data }) => {
            logger.info("event= AgentMonitorStateChanged event:", data);
            dispatchListenerEvent("agent-monitor-state-changed", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor.eAgentMonitorStateChangeFailed.listen(({ data }) => {
            logger.info("event= AgentMonitorStateChanged event:", data);
            dispatchListenerEvent("agent-monitor-state-change-failed", data, dispatchCustom);
        })
    ]);
    listenersAggregator = listenersAggregator.concat([
        (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor) === null || _a === void 0 ? void 0 : _a.eMonitoringOffered.listen((response) => {
            const { data } = response;
            logger.info("event= MonitoringOffered:", data);
            const updatedData = Object.assign(Object.assign({}, data), { interaction: data.task, interactionId: data.taskId });
            dispatchListenerEvent("monitoring-offered", updatedData, dispatchCustom);
        }),
        (_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor) === null || _b === void 0 ? void 0 : _b.eMonitoringStarted.listen((response) => {
            const { data } = response;
            logger.info("event= MonitoringStarted:", data);
            const updatedData = Object.assign(Object.assign({}, data), { interaction: data.task, interactionId: data.taskId });
            dispatchListenerEvent("monitoring-started", updatedData, dispatchCustom);
        }),
        (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor) === null || _c === void 0 ? void 0 : _c.eMonitoringEnded.listen((response) => {
            const { data } = response;
            logger.info("event= MonitoringEnded:", data);
            const updatedData = Object.assign(Object.assign({}, data), { interactionId: data.taskId });
            dispatchListenerEvent("monitoring-ended", updatedData, dispatchCustom);
        }),
        (_d = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor) === null || _d === void 0 ? void 0 : _d.eMonitoringEndFailed.listen((error) => {
            const { data } = error;
            logger.info("event= MonitoringEndFailed:", data);
            dispatchListenerEvent("monitoring-end-failed", data, dispatchCustom);
        }),
        (_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor) === null || _e === void 0 ? void 0 : _e.eMonitoringRequestCreateFailed.listen((error) => {
            const { data } = error;
            logger.info("event= MonitoringRequestCreateFailed:", data);
            dispatchListenerEvent("monitoring-create-failed", data, dispatchCustom);
        }),
        (_f = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor) === null || _f === void 0 ? void 0 : _f.eMonitoringFailed.listen((error) => {
            const { data } = error;
            logger.info("event= MonitoringFailed:", data);
            const updatedData = Object.assign(Object.assign({}, data), { interactionId: data.taskId });
            dispatchListenerEvent("monitoring-failed", updatedData, dispatchCustom);
        }),
        (_g = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor) === null || _g === void 0 ? void 0 : _g.eMonitoringHeld.listen((response) => {
            const { data } = response;
            logger.info("event= MonitoringHeld:", data);
            const updatedData = Object.assign(Object.assign({}, data), { interactionId: data.taskId });
            dispatchListenerEvent("monitoring-held", updatedData, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor.eAgentMonitoringEnded.listen(({ data }) => {
            logger.info("event= eAgentMonitoringEnded event:", data);
            dispatchListenerEvent("agent-monitor-end", data, dispatchCustom);
        }),
        (_h = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor) === null || _h === void 0 ? void 0 : _h.eMonitoringHoldFailed.listen((response) => {
            const { data } = response;
            logger.info("event= MonitoringHoldFailed:", data);
            dispatchListenerEvent("monitoring-held-failed", data, dispatchCustom);
        }),
        (_j = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor) === null || _j === void 0 ? void 0 : _j.eMonitoringUnHeld.listen((response) => {
            const { data } = response;
            logger.info("event= MonitoringUnHeld:", data);
            const updatedData = Object.assign(Object.assign({}, data), { interactionId: data.taskId });
            dispatchListenerEvent("monitoring-unheld", updatedData, dispatchCustom);
        }),
        (_k = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor) === null || _k === void 0 ? void 0 : _k.eMonitoringUnHoldFailed.listen((response) => {
            const { data } = response;
            logger.info("event= MonitoringUnHoldFailed:", data);
            dispatchListenerEvent("monitoring-unheld-failed", data, dispatchCustom);
        })
    ]);
};
const attachTaskListeners = (dispatchCustom, deviceType) => {
    const loginOption = deviceType;
    offerTaskEvent(dispatchCustom, loginOption);
    outBoundTaskEvents(dispatchCustom, loginOption);
    endTaskEvent(dispatchCustom, loginOption);
    consultTaskEvents(dispatchCustom);
    conferenceTaskEvents(dispatchCustom);
    ctqTaskEvents(dispatchCustom);
    monitoringEventListeners(dispatchCustom);
    listenersAggregator = listenersAggregator.concat([
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentContactAssigned.listen(({ data }) => {
            logger.info("event= AgentContactAssigned:", data);
            dispatchListenerEvent("agent-contact-assigned", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackInitialCallEvents({
                interactionId: data.interactionId,
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_ANSWERED,
                contactDirection: data.interaction.contactDirection.type,
                outboundType: data.interaction.outboundType,
                ani: data.interaction.callProcessingDetails.ani,
                mediaType: data.interaction.mediaType,
                deviceType: loginOption,
                mediaChannel: data.interaction.mediaChannel
            });
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.setValueInCache(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_CACHE_KEYS.CONTACT_ASSIGNED_TIME, new Date().getTime());
            sendCallTypeTelemetry(data);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentContactHeld.listen(({ data }) => {
            var _a, _b;
            logger.info("event= AgentContactHeld event:", data);
            dispatchListenerEvent("contact-held", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_HOLD_CLICKED, Object.assign({ Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS }, getPrometheusTrackingPayload(data)), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus]);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentContactUnHeld.listen(({ data }) => {
            var _a, _b;
            logger.info("event= AgentContactUnHeld event:", data);
            dispatchListenerEvent("contact-unheld", data, dispatchCustom);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_CLICKED, Object.assign({ Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS }, getPrometheusTrackingPayload(data)), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus]);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentWrapup.listen(({ data }) => {
            logger.info("event= AgentWrapup event:", data);
            dispatchListenerEvent("agent-wrapup", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eCallRecordingStarted.listen(({ data }) => {
            logger.info("event= CallRecordingStarted event:", data);
            dispatchListenerEvent("call-recording-started", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.dialer.eContactUpdated.listen(({ data }) => {
            logger.info("event= ContactUpdated:", data);
            dispatchListenerEvent("agent-contact-updated", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eResumeRecording.listen(({ data }) => {
            var _a, _b;
            dispatchListenerEvent("ax-interaction-recording-resumed", data, dispatchCustom);
            logger.info(`event= Successfully resumed the recording: `, data);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackCallRecordingEvent(Object.assign(Object.assign({}, getTrackingPayload(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_RECORDING_ACTIVATED, data)), { autoResumed: data.autoResumed }));
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_RESUME_RECORDING_CLICKED, Object.assign({ Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS }, getPrometheusTrackingPayload(data)), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus]);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.ePauseRecording.listen(({ data }) => {
            var _a, _b;
            dispatchListenerEvent("ax-interaction-recording-paused", data, dispatchCustom);
            logger.info(`event= Successfully paused the recording: `, data);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackCallRecordingEvent(getTrackingPayload(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_PAUSE_RECORDING_ACTIVATED, data));
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_PAUSE_RECORDING_CLICKED, Object.assign({ Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS }, getPrometheusTrackingPayload(data)), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus]);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentvteamTransfer.listen(({ data }) => {
            var _a, _b, _c, _d;
            logger.info(`event= Successfully contact got transferred to queue: `, data);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackCallTransferEvent(getTrackingPayload(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_TRANSFER_ACTIVATED, data));
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_TRANSFER_CLICKED, Object.assign({ Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS }, getPrometheusTrackingPayload(data, data.type)), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentblindTransferred.listen(({ data }) => {
            var _a, _b, _c, _d;
            logger.info(`event= Successfully contact got transferred to agent: `, data);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_util.trackCallTransferEvent(getTrackingPayload(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_TRANSFER_ACTIVATED, data));
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_TRANSFER_CLICKED, Object.assign({ Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS }, getPrometheusTrackingPayload(data, data.type)), [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentContactCleanup.listen(({ data }) => {
            logger.info("event= ContactCleanup:", data);
            dispatchListenerEvent("agent-contact-cleanup", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eContactCallbackFailed.listen(({ data }) => {
            logger.info("event= ContactCallbackFailed:", data);
            dispatchListenerEvent("contact-callback-failed", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentOfferCampaignReserved.listen((data) => {
            logger.info("event= AgentOfferCampaignReservation event:", data);
            dispatchListenerEvent("agent-offer-campaign-reserved", data, dispatchCustom);
        }),
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact.eAgentAddCampaignReserved.listen((data) => {
            logger.info("event= AgentAddCampaignReservation event:", data);
            dispatchListenerEvent("agent-add-campaign-reserved", data, dispatchCustom);
        })
    ]);
};
const stopAllListeners = () => {
    listenersAggregator.forEach((s) => s.stopListen());
    listenersAggregator.length = 0;
};
const TaskListeners = {
    stopAllListeners,
    dispatchListenerEvent
};


/***/ }),

/***/ "./src/direflow-components/Utility/Utils/WebexAvatarUtils.ts":
/*!*******************************************************************!*\
  !*** ./src/direflow-components/Utility/Utils/WebexAvatarUtils.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WebexStatus: () => (/* binding */ WebexStatus)
/* harmony export */ });
const WebexStatus = {
    Unknown: "unknown",
    Pending: "pending",
    Active: "active",
    Inactive: "inactive",
    Dnd: "dnd",
    Quiet: "quiet",
    Busy: "busy",
    OOO: "ooo",
    Call: "call",
    Meeting: "meeting",
    Presenting: "presenting",
    CalendarItem: "calendaritem"
};


/***/ }),

/***/ "./src/direflow-components/Utility/Utils/services/BargeIn.ts":
/*!*******************************************************************!*\
  !*** ./src/direflow-components/Utility/Utils/services/BargeIn.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   bargeInService: () => (/* binding */ bargeInService)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _InteractionControl_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../InteractionControl/InteractionControlHelper */ "./src/direflow-components/InteractionControl/InteractionControlHelper.ts");




class BargeInService {
    track(telemetryData) {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(telemetryData.eventName, Object.assign({}, telemetryData));
    }
    bargeIn(bargeInParams) {
        const { detail, updateButtonProgressFlag, role, notificationTitle, notificationData, dispatchEvent } = bargeInParams;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.supervisor
            .bargeIn({
            interactionId: detail.interactionId
        })
            .catch((err) => {
            var _a, _b, _c, _d;
            const telemetryData = {
                eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.BARGE_IN_ACTIVATED,
                interactionId: detail.interactionId,
                role,
                reasonForFailure: (_b = (_a = err === null || err === void 0 ? void 0 : err.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reason,
                reasonCode: (_d = (_c = err === null || err === void 0 ? void 0 : err.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode,
                status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED
            };
            this.track(telemetryData);
            updateButtonProgressFlag("");
            this.dispatchCustomEvent(dispatchEvent, notificationTitle, notificationData);
            _InteractionControl_InteractionControlHelper__WEBPACK_IMPORTED_MODULE_3__.logger.error(`event= BargeInfailed | [Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(err)}] Failed to Barge In: ${err}`, err);
        });
    }
    dispatchCustomEvent(dispatchEvent, notificationTitle, notificationData) {
        const notification = {
            type: _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.Notifications.ItemMeta.Type.Warn,
            mode: _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.Notifications.ItemMeta.Mode.AutoDismiss,
            title: notificationTitle,
            data: notificationData
        };
        (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_2__.evt)("ax-fire-notification", notification, dispatchEvent);
    }
}
const bargeInService = new BargeInService();


/***/ }),

/***/ "./src/direflow-components/Utility/components/index.tsx":
/*!**************************************************************!*\
  !*** ./src/direflow-components/Utility/components/index.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Utils_ImiChatInitializer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Utils/ImiChatInitializer */ "./src/direflow-components/Utility/Utils/ImiChatInitializer.ts");
/* harmony import */ var _Utils_TaskListeners__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Utils/TaskListeners */ "./src/direflow-components/Utility/Utils/TaskListeners.ts");
/* React Based MFE global utilities
 * The purpose of this component is to hold common logic which is required on loading of the AgentX application
 * before loading any MFEs without rendering any HTML element.
 * Example:
 * - Attaching task event listeners at the start of the application
 */






const logger = (0,_sdk__WEBPACK_IMPORTED_MODULE_3__.createLogger)("[Utility]");
const Utility = ({ agentConfigs, configs, imiconfigs, accessToken }) => {
    const dispatchCustom = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.EventContext);
    const requestChatConference = (data) => {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.aqm.contact
            .consultConferenceV2({
            interactionId: data.interactionId,
            data: {
                agentId: data.agentId,
                to: data === null || data === void 0 ? void 0 : data.destAgentId,
                destinationType: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.DESTINATION_TYPE.AGENT
            }
        })
            .then(() => { })
            .catch((err) => {
            var _a, _b, _c, _d;
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.CALL_CONFERENCE_CLICKED, {
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_PROPS.MEDIA_TYPE]: data.mediaType,
                Reason: "ConsultConferenceError",
                interactionId: data.interactionId
            }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
            (0,_Utils_TaskListeners__WEBPACK_IMPORTED_MODULE_5__.dispatchListenerEvent)("agent-conference-failed", err, dispatchCustom);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        (0,_Utils_TaskListeners__WEBPACK_IMPORTED_MODULE_5__.attachTaskListeners)(dispatchCustom, agentConfigs.deviceType);
        return () => {
            _Utils_TaskListeners__WEBPACK_IMPORTED_MODULE_5__.TaskListeners.stopAllListeners();
        };
    }, [agentConfigs.deviceType]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (agentConfigs.areDigitalChannelsEnabled &&
            imiconfigs.imiWidgetEnabled &&
            accessToken &&
            imiconfigs.imiScriptLoaded &&
            imiconfigs.isStationLoginSuccess) {
            (0,_Utils_ImiChatInitializer__WEBPACK_IMPORTED_MODULE_4__.initializeImiChat)(accessToken, dispatchCustom);
        }
    }, [
        agentConfigs.areDigitalChannelsEnabled,
        imiconfigs.imiWidgetEnabled,
        accessToken,
        imiconfigs.imiScriptLoaded,
        imiconfigs.isStationLoginSuccess
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (configs.initiateConferenceChat) {
            requestChatConference(configs);
        }
    }, [configs]);
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Utility);


/***/ }),

/***/ "./src/direflow-components/WrapUp/DefaultWrapUpProperties.ts":
/*!*******************************************************************!*\
  !*** ./src/direflow-components/WrapUp/DefaultWrapUpProperties.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const wrapUpProperties = {
    wrapUpProps: {
        wrapUpReasonList: [
            { isSystem: false, name: "Billing Reason", id: 1645, isDefault: false },
            {
                isSystem: false,
                name: "Credit Card Information",
                id: 1646,
                isDefault: false
            },
            { isSystem: false, name: "Debit Card", id: 1647, isDefault: false },
            {
                isSystem: false,
                name: "Return And Refund",
                id: 1648,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Product Enquiry About Food insecurity issues and weight gain",
                id: 1688,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Return And Refund 0",
                id: 1649,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Return And Refund 1",
                id: 1650,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Return And Refund 2",
                id: 1651,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Return And Refund 3",
                id: 1652,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Return And Refund 4",
                id: 1653,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Return And Refund 5",
                id: 1654,
                isDefault: true
            },
            {
                isSystem: false,
                name: "Return And Refund 6",
                id: 1655,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Return And Refund 7",
                id: 1656,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Return And Refund 8",
                id: 1657,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Return And Refund 9",
                id: 1658,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Return And Refund 10",
                id: 1659,
                isDefault: false
            },
            {
                isSystem: false,
                name: "Return And Refund 11",
                id: 1660,
                isDefault: false
            }
        ],
        autoWrapup: true,
        autoWrapupInterval: 30000,
        lastAgentRoute: true,
        allowCancelAutoWrapup: true
    },
    contactDirection: "",
    interactionId: "cc27b8df-97a3-11ea-9082-71f9453e8292",
    wrapUpTimestamp: new Date().getTime(),
    isDesktopAuxCodesInfiniteScrollEnabled: false,
    agentWrapUpCodeProps: {
        agentWrapUpCodes: {
            data: [],
            meta: {
                links: { first: "", last: "", next: "", self: " " },
                orgid: "xyz",
                page: 0,
                pageSize: 100,
                totalPages: 1,
                totalRecords: 10
            }
        },
        agentDefaultWrapupCode: {
            id: "1645",
            name: "Billing Reason"
        }
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (wrapUpProperties);


/***/ }),

/***/ "./src/direflow-components/WrapUp/WrapUpHelper.ts":
/*!********************************************************!*\
  !*** ./src/direflow-components/WrapUp/WrapUpHelper.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   fetchWrapUpCodes: () => (/* binding */ fetchWrapUpCodes),
/* harmony export */   removeCanceledAutoWrapupInterationIdFromSS: () => (/* binding */ removeCanceledAutoWrapupInterationIdFromSS),
/* harmony export */   removeInteractionId: () => (/* binding */ removeInteractionId),
/* harmony export */   sessionStorageInteractionList: () => (/* binding */ sessionStorageInteractionList),
/* harmony export */   updateSSWithCanceledAutoWrapupInterationId: () => (/* binding */ updateSSWithCanceledAutoWrapupInterationId)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../sdk */ "./src/sdk.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./constants */ "./src/direflow-components/WrapUp/constants.js");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



// using sessionstorage since we dont have an API to track if the auto wrap  up was cleared for any interaction.
const sessionStorageInteractionList = (interactionId) => {
    var _a;
    return ((_a = sessionStorage.getItem("autoWrapUpInteraction")) === null || _a === void 0 ? void 0 : _a.split(",").includes(interactionId)) || false;
};
const removeInteractionId = (interactionId) => {
    var _a;
    const list = (_a = sessionStorage.getItem("autoWrapUpInteraction")) === null || _a === void 0 ? void 0 : _a.split(",");
    if (list && list.includes(interactionId)) {
        list.splice(list.indexOf(interactionId), 1);
        sessionStorage.setItem("autoWrapUpInteraction", JSON.parse(JSON.stringify(list)));
    }
};
const removeCanceledAutoWrapupInterationIdFromSS = (interactionId) => {
    var _a;
    const list = (_a = sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__.CANCELED_AUTOWRAPUP_INTERACTION)) === null || _a === void 0 ? void 0 : _a.split(",");
    const index = list === null || list === void 0 ? void 0 : list.indexOf(interactionId);
    if (list && index !== -1 && index !== undefined) {
        list.splice(index, 1);
        sessionStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_2__.CANCELED_AUTOWRAPUP_INTERACTION, list.join(","));
    }
};
const updateSSWithCanceledAutoWrapupInterationId = (interactionId) => {
    const existingData = sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__.CANCELED_AUTOWRAPUP_INTERACTION);
    const existingDataArr = existingData ? existingData.split(",") : [];
    existingDataArr.push(interactionId);
    sessionStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_2__.CANCELED_AUTOWRAPUP_INTERACTION, existingDataArr.join(","));
};
const fetchWrapUpCodes = (orgId, page, searchQuery) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = {
            orgId,
            page,
            pageSize: _constants__WEBPACK_IMPORTED_MODULE_2__.PAGE_SIZE,
            search: searchQuery
        };
        const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.abs.fetchPaginatedWrapUpCodes(params);
        return response ? response : {};
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`event=fetchWrapupCodes | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error) : ""} | Fetching wrapup codes from aux code is failed : ${error}`, error);
        throw error;
    }
});


/***/ }),

/***/ "./src/direflow-components/WrapUp/components/AutoWrapUpTimer/index.tsx":
/*!*****************************************************************************!*\
  !*** ./src/direflow-components/WrapUp/components/AutoWrapUpTimer/index.tsx ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/src/luxon.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/WrapUp/constants.js");






const AutoWrapUpTimer = ({ autoWrapUpInterval, submitHandler, addColorFont, wrapUpTimestamp }) => {
    const wrapStamp = wrapUpTimestamp || luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().millisecond;
    const autoWrapUpTimer = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(wrapStamp).plus({
        seconds: autoWrapUpInterval / 1000
    });
    const [displayTimer, setDisplayTimer] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(autoWrapUpTimer);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const localTimeStamp = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local();
        const intervalId = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.setInterval(function () {
            setDisplayTimer(autoWrapUpTimer);
        }, _constants__WEBPACK_IMPORTED_MODULE_5__.AUTO_WRAPUP_TIMEOUT_INTERVAL);
        if (parseInt(displayTimer.diff(localTimeStamp).as("seconds").toString()) <= 0) {
            submitHandler(true);
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.clearInterval(intervalId);
        }
        return () => _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.clearInterval(intervalId);
    }, [autoWrapUpTimer, autoWrapUpInterval, displayTimer, submitHandler, wrapUpTimestamp]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", Object.assign({ id: "auto-wrapup-timer", className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
            "font-blue": addColorFont && autoWrapUpTimer.diff(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local()).milliseconds > _constants__WEBPACK_IMPORTED_MODULE_5__.AUTO_WRAPUP_WARNING_TIME_MILLISECONDS,
            "font-red": addColorFont && autoWrapUpTimer.diff(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local()).milliseconds <= 10000
        }) }, { children: displayTimer.diff(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local(), ["minutes", "seconds"]).toFormat("mm:ss") })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AutoWrapUpTimer);


/***/ }),

/***/ "./src/direflow-components/WrapUp/components/WrapUpContent/index.tsx":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/WrapUp/components/WrapUpContent/index.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "../../node_modules/classnames/index.js");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _WrapUpHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../WrapUpHelper */ "./src/direflow-components/WrapUp/WrapUpHelper.ts");
/* harmony import */ var _AutoWrapUpTimer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../AutoWrapUpTimer */ "./src/direflow-components/WrapUp/components/AutoWrapUpTimer/index.tsx");
/* harmony import */ var _WrapUpPopover__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../WrapUpPopover */ "./src/direflow-components/WrapUp/components/WrapUpPopover/index.tsx");










const wrapUpButtomMaxWidth = 140;
const WrapUpContent = (props) => {
    var _a, _b;
    const menuElm = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const [isMenuOpen, setMenuOpen] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true);
    const [isAutoWrapUp, setIsAutoWrapUp] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)((_a = props === null || props === void 0 ? void 0 : props.wrapUpProps) === null || _a === void 0 ? void 0 : _a.autoWrapup);
    const { wrapup } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_5__.useI18nContext)();
    const dispatchEvent = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_2__.EventContext);
    const [isWrapUpOverflow, setIsWrapUpOverflow] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const cancelAutoTimer = (interactionId) => {
        const event = new CustomEvent("ax-auto-wrap-up", {
            detail: {
                type: "updateInteractionId",
                interactionId: interactionId || props.interactionId
            },
            bubbles: true,
            composed: true
        });
        setIsAutoWrapUp(false);
        if (dispatchEvent) {
            dispatchEvent(event);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        if (menuElm === null || menuElm === void 0 ? void 0 : menuElm.current) {
            menuElm.current.isOpen = isMenuOpen;
        }
    }, [isMenuOpen]);
    const openMenu = () => {
        setMenuOpen(true);
    };
    const closeMenu = () => {
        setMenuOpen(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const wrapupMenu = menuElm === null || menuElm === void 0 ? void 0 : menuElm.current;
        if (wrapupMenu) {
            menuElm.current.isOpen = true;
            wrapupMenu.addEventListener("menu-overlay-open", openMenu);
            wrapupMenu.addEventListener("menu-overlay-close", closeMenu);
        }
        setIsWrapUpOverflow((0,_Common_Utils__WEBPACK_IMPORTED_MODULE_6__.isTextOverflow)(wrapUpButtomMaxWidth, wrapup.wrapupreason));
        return () => {
            if (wrapupMenu) {
                wrapupMenu.removeEventListener("menu-overlay-open", openMenu);
                wrapupMenu.removeEventListener("menu-overlay-close", closeMenu);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        var _a;
        setIsAutoWrapUp((_a = props === null || props === void 0 ? void 0 : props.wrapUpProps) === null || _a === void 0 ? void 0 : _a.autoWrapup);
    }, [props]);
    const executeWrapUpShortcut = (key) => {
        if (key.data &&
            key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_WRAP_UP_KEY &&
            key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
            openMenu();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
        const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((key) => executeWrapUpShortcut(key));
        return () => {
            if (stopListen) {
                stopListen();
            }
        };
    }, []);
    const handleCloseMenuFromInside = () => {
        closeMenu();
    };
    const handleFocusableItemChange = () => {
        if (menuElm && menuElm.current && menuElm.current.setFocusableElements) {
            menuElm.current.setFocusableElements();
        }
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-tooltip", Object.assign({ placement: "bottom", message: wrapup.wrapupreason }, (isMenuOpen || !isWrapUpOverflow ? { disabled: true } : ""), { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("md-menu-overlay", Object.assign({ id: "wrap-up-menu-overlay", ariaRole: "dialog", ariaLabel: wrapup.wrapupreason, ref: menuElm, placement: "bottom-end" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ slot: "menu-trigger", id: "wrapup-button-id", class: "wrapup-button", "data-testid": "wrapup-button-id", variant: "secondary", size: "32", width: "260px", "max-width": "260px", ariaLabel: wrapup.wrapupreason, ariaExpanded: isMenuOpen, type: "button" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "wrapup-button__children" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: "auto-wrapup-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: isAutoWrapUp && (0,_WrapUpHelper__WEBPACK_IMPORTED_MODULE_7__.sessionStorageInteractionList)(props === null || props === void 0 ? void 0 : props.interactionId) && !isMenuOpen
                                            ? "wrapup-text"
                                            : "wrapup-text wrapup-text-notimer" }, { children: wrapup.wrapupreason })), isAutoWrapUp && (0,_WrapUpHelper__WEBPACK_IMPORTED_MODULE_7__.sessionStorageInteractionList)(props === null || props === void 0 ? void 0 : props.interactionId) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", Object.assign({ className: isMenuOpen ? "hide-content" : "" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ className: "timer-dash" }, { children: " - " })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AutoWrapUpTimer__WEBPACK_IMPORTED_MODULE_8__["default"], { autoWrapUpInterval: (_b = props === null || props === void 0 ? void 0 : props.wrapUpProps) === null || _b === void 0 ? void 0 : _b.autoWrapupInterval, wrapUpTimestamp: props === null || props === void 0 ? void 0 : props.wrapUpTimestamp, submitHandler: () => { }, addColorFont: true })] })))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
                                    "arrow-up_16": isMenuOpen,
                                    "arrow-down_16": !isMenuOpen
                                }), size: "14", className: "pull-right wrap-up-toggle-icon" })] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "wrap-up-popover-wrapper" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WrapUpPopover__WEBPACK_IMPORTED_MODULE_9__["default"], { wrapUpPopOver: props, cancelAutoTimer: cancelAutoTimer, handleCloseMenu: handleCloseMenuFromInside, focusableItemChange: handleFocusableItemChange, overlayOpen: isMenuOpen }) }))] })) })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WrapUpContent);


/***/ }),

/***/ "./src/direflow-components/WrapUp/components/WrapUpListContainer/RadioItems.tsx":
/*!**************************************************************************************!*\
  !*** ./src/direflow-components/WrapUp/components/WrapUpListContainer/RadioItems.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");


const RadioItems = ({ data, index, style = {}, isSelected, isFocused, overlayOpen, totalRecords, onSelectValue, resetFocusedItemIndex, submitWrapUpOnEnter, selectedReason }) => {
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const focusRadioInput = () => {
        inputRef.current.focus();
    };
    const checkRadioInput = () => {
        inputRef.current.tabIndex = 0;
        inputRef.current.checked = true;
    };
    const resetRadioInput = () => {
        inputRef.current.tabIndex = -1;
        inputRef.current.checked = false;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (isFocused && inputRef.current) {
            checkRadioInput();
            focusRadioInput();
        }
        else {
            resetRadioInput();
        }
    }, [isFocused]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (isSelected && inputRef.current) {
            checkRadioInput();
        }
        else {
            resetRadioInput();
        }
    }, [isSelected, overlayOpen]);
    const handleClickOnRadio = () => {
        resetFocusedItemIndex(index);
        checkRadioInput();
        focusRadioInput();
    };
    const isMatching = () => {
        return (selectedReason === null || selectedReason === void 0 ? void 0 : selectedReason.name) === data.name && (selectedReason === null || selectedReason === void 0 ? void 0 : selectedReason.id) === data.id;
    };
    const setPrevSelectedIfMatch = () => {
        if (isMatching()) {
            inputRef.current.checked = true;
        }
    };
    // to mark check the selected item on updating the list
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        setPrevSelectedIfMatch();
    }, [data.id]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "radio-wrapper", style: Object.assign(Object.assign({}, style), { left: "2px" }) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-radio", Object.assign({ ref: inputRef, slot: "radio", class: "wrap-up-radio-option", title: data.name, label: `${data.name}, ${index + 1} of ${totalRecords}`, value: data.name, ariaLabel: data.name, onKeyPress: submitWrapUpOnEnter, onClick: handleClickOnRadio }, { children: data.name }), data.id) }), data.id));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RadioItems);


/***/ }),

/***/ "./src/direflow-components/WrapUp/components/WrapUpListContainer/RadioItemsContainer.tsx":
/*!***********************************************************************************************!*\
  !*** ./src/direflow-components/WrapUp/components/WrapUpListContainer/RadioItemsContainer.tsx ***!
  \***********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _RadioItems__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./RadioItems */ "./src/direflow-components/WrapUp/components/WrapUpListContainer/RadioItems.tsx");


const RadioContainer = ({ data, index, style = {}, isSelected, isFocused, onSelectValue, resetFocusedItemIndex, customData }) => {
    const { overlayOpen, totalRecords, submitWrapUpOnEnter, selectedReason } = customData;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RadioItems__WEBPACK_IMPORTED_MODULE_1__["default"], { data: data, index: index, style: style, isSelected: isSelected, isFocused: isFocused, overlayOpen: overlayOpen, totalRecords: totalRecords, onSelectValue: onSelectValue, resetFocusedItemIndex: resetFocusedItemIndex, submitWrapUpOnEnter: submitWrapUpOnEnter, selectedReason: selectedReason }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RadioContainer);


/***/ }),

/***/ "./src/direflow-components/WrapUp/components/WrapUpListContainer/index.tsx":
/*!*********************************************************************************!*\
  !*** ./src/direflow-components/WrapUp/components/WrapUpListContainer/index.tsx ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_components_List__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Common/components/List */ "./src/direflow-components/Common/components/List/index.tsx");
/* harmony import */ var _Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Common/components/List/ListError */ "./src/direflow-components/Common/components/List/ListError/index.tsx");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/WrapUp/constants.js");
/* harmony import */ var _WrapUpHelper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../WrapUpHelper */ "./src/direflow-components/WrapUp/WrapUpHelper.ts");
/* harmony import */ var _RadioItemsContainer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./RadioItemsContainer */ "./src/direflow-components/WrapUp/components/WrapUpListContainer/RadioItemsContainer.tsx");
/* harmony import */ var _usePagination__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./usePagination */ "./src/direflow-components/WrapUp/components/WrapUpListContainer/usePagination.tsx");











const WrapUpListContainer = ({ searchTerm, searchResults, reasonList, overlayOpen, isSearchMode, agentWrapUpCodes, containerLabel, submitWrapUpOnEnter, processUpdatesForSelectedWrapUp, selectedReason }) => {
    var _a, _b;
    const [wrapUpList, setWrapUpList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(reasonList);
    const [resetFocus, setResetFocus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [resetFocusedAndSelected, setResetFocusedAndSelected] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [searchError, setSearchError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [loadingFirstPage, setLoadingFirstPage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [loadingFirstPageError, setLoadingFirstPageError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        error: false,
        trackingId: ""
    });
    const [isRetryLoad, setIsRetryLoad] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { common, wrapup } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.useI18nContext)();
    const itemHeight = 36;
    const maxItems = 8;
    const totoalHeight = maxItems * itemHeight;
    // to update the first loading page status from usePaginator
    const updateLoadingFirstPage = (state) => {
        setLoadingFirstPage(state);
    };
    // to update the first loading page error status from usePaginator
    const updateLoadingFirstPageError = (state) => {
        setLoadingFirstPageError(state);
    };
    // to update the retry state from usePaginator
    const updateIsRetryLoad = (state) => {
        setIsRetryLoad(state);
    };
    // to update the wrapUpListfrom paginator in case of search
    const updateWrapUpList = (newWrapUpList, pageUpdate = false, reset = false) => {
        setWrapUpList((prevItems) => {
            if (!pageUpdate) {
                return newWrapUpList;
            }
            else {
                return reset ? [...newWrapUpList] : [...prevItems, ...newWrapUpList];
            }
        });
    };
    const updateFunctions = {
        updateWrapUpList,
        updateLoadingFirstPage,
        updateLoadingFirstPageError,
        updateIsRetryLoad
    };
    const searchParameters = {
        searchTerm,
        searchResults,
        isRetryLoad
    };
    const { hasNextPage, isNextPageLoading, pageFetchError, loadNextPage } = (0,_usePagination__WEBPACK_IMPORTED_MODULE_10__["default"])((_a = agentWrapUpCodes === null || agentWrapUpCodes === void 0 ? void 0 : agentWrapUpCodes.meta) === null || _a === void 0 ? void 0 : _a.page, reasonList, agentWrapUpCodes, _constants__WEBPACK_IMPORTED_MODULE_7__.AX_WRAPUP_CODE_UPDATE, _WrapUpHelper__WEBPACK_IMPORTED_MODULE_8__.fetchWrapUpCodes, searchParameters, updateFunctions);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (isSearchMode) {
            if (searchTerm.length >= _Common_constants__WEBPACK_IMPORTED_MODULE_6__.MINIMUM_CHARACTERS_FOR_SEARCH || searchTerm === "") {
                setSearchError(false);
            }
            else {
                setSearchError(true);
            }
        }
        else {
            updateWrapUpList(reasonList);
        }
    }, [reasonList, isSearchMode, searchTerm]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        setResetFocusedAndSelected(!resetFocusedAndSelected);
    }, [searchResults, isSearchMode]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        //remove selection outline when menu is closed
        if (!overlayOpen) {
            setResetFocus(!resetFocus);
        }
    }, [overlayOpen]);
    const handleWrapUpReasonChange = (selected) => {
        const selectedId = selected.id;
        const selectName = selected.name;
        processUpdatesForSelectedWrapUp(selectName, selectedId);
    };
    const customData = {
        overlayOpen,
        totalRecords: (_b = agentWrapUpCodes === null || agentWrapUpCodes === void 0 ? void 0 : agentWrapUpCodes.meta) === null || _b === void 0 ? void 0 : _b.totalRecords,
        submitWrapUpOnEnter,
        selectedReason // to mark check the selected item on updating the list
    };
    // condition if there is no record found after search
    const isNoRecordFound = () => {
        return (wrapUpList === null || wrapUpList === void 0 ? void 0 : wrapUpList.length) === 0 && !loadingFirstPage;
    };
    const getNoRecordFound = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "no-record" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_3__["default"], { illustrationType: "empty-result" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", Object.assign({ "aria-label": common.nomatchfound, className: "no-record-found" }, { children: common.nomatchfound }))] })));
    };
    // condition for api failure for search
    const isApiError = () => {
        return !loadingFirstPage && (loadingFirstPageError === null || loadingFirstPageError === void 0 ? void 0 : loadingFirstPageError.error);
    };
    const getApiError = () => {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List_ListError__WEBPACK_IMPORTED_MODULE_5__["default"], { onRetry: () => setIsRetryLoad(true), trackingId: loadingFirstPageError.trackingId });
    };
    // enter min character limit for search error
    const getSearchError = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "search-block-error" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "search-error" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "info-badge-filled", iconSet: "momentumDesign", size: "16", class: "search-error-info" }), wrapup.searchError] })) })));
    };
    const getLoadingError = () => {
        if (searchError) {
            return getSearchError();
        }
        else if (isApiError()) {
            return getApiError();
        }
        else if (isNoRecordFound()) {
            return getNoRecordFound();
        }
        else {
            return null;
        }
    };
    const getSpinner = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: loadingFirstPage && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "wrapup-list__loading" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-spinner", { size: "48" }) }))) }));
    };
    const getWrapUpList = () => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "wrap-up-virtual-list-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_List__WEBPACK_IMPORTED_MODULE_4__["default"], Object.assign({ data: wrapUpList, height: totoalHeight, onSelectValue: (selected) => {
                    handleWrapUpReasonChange(selected);
                }, customClassName: "radio-list-container", ariaLabel: containerLabel, itemHeight: itemHeight, innerElementType: "div", infiniteScrollEnabled: true, retainLastFocusedItem: true, resetFocus: resetFocus ? 1 : 0, resetFocusedAndSelected: resetFocusedAndSelected ? 1 : 0, hasNextPage: hasNextPage, isNextPageLoading: isNextPageLoading, loadNextPage: loadNextPage, pageFetchError: pageFetchError, customData: customData }, { children: (props) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RadioItemsContainer__WEBPACK_IMPORTED_MODULE_9__["default"], Object.assign({}, props)) })) })));
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [getSpinner(), isSearchMode && getLoadingError(), !searchError && !isNoRecordFound() && !loadingFirstPage && !loadingFirstPageError.error && getWrapUpList()] }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WrapUpListContainer);


/***/ }),

/***/ "./src/direflow-components/WrapUp/components/WrapUpListContainer/usePagination.tsx":
/*!*****************************************************************************************!*\
  !*** ./src/direflow-components/WrapUp/components/WrapUpListContainer/usePagination.tsx ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _Common_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Common/constants */ "./src/direflow-components/Common/constants.ts");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../constants */ "./src/direflow-components/WrapUp/constants.js");
/* harmony import */ var _WrapUpPopover__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../WrapUpPopover */ "./src/direflow-components/WrapUp/components/WrapUpPopover/index.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







const usePagination = (initialPage, reasonList, agentWrapUpCodes, eventDispatchType, fetchDataCB, searchParameters, updateFunctions) => {
    const dispatchEvent = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.EventContext);
    const [hasNextPage, setHasNextPage] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isNextPageLoading, setIsNextPageLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const wrapUpCodeMeta = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)({ totalPages: 0 });
    const [pageFetchError, setPageFetchError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_constants__WEBPACK_IMPORTED_MODULE_5__.DEFAULT_ERROR_OBJECT);
    const [currentPage, setCurrentPage] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialPage);
    const isPageValid = (page, totalPages) => {
        return page !== undefined && !!totalPages;
    };
    const { searchTerm, searchResults, isRetryLoad } = searchParameters;
    const { updateWrapUpList, updateLoadingFirstPage, updateLoadingFirstPageError, updateIsRetryLoad } = updateFunctions;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        var _a;
        const filteredTotalPages = wrapUpCodeMeta.current.totalPages;
        const totalPages = filteredTotalPages || ((_a = agentWrapUpCodes === null || agentWrapUpCodes === void 0 ? void 0 : agentWrapUpCodes.meta) === null || _a === void 0 ? void 0 : _a.totalPages);
        if (isPageValid(currentPage, totalPages)) {
            setHasNextPage(currentPage < totalPages - 1);
        }
        else {
            setHasNextPage(false);
        }
    }, []);
    // this useEffect is to retry the load when the api error occurs
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (isRetryLoad) {
            loadPage(0, searchTerm);
            updateIsRetryLoad(false);
        }
    }, [isRetryLoad]);
    const handleError = (error, page) => {
        const trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(error);
        _WrapUpPopover__WEBPACK_IMPORTED_MODULE_6__.logger.error(`[WrapUp:Pagination][Tracking ID: ${trackingId}] WrapupFailed: PageLoadFailed: ', ${error}`, error);
        if (page === 0) {
            updateLoadingFirstPage(false);
            updateLoadingFirstPageError({ error: true, trackingId });
        }
        else {
            setHasNextPage(true);
            setPageFetchError({ error: true, trackingId });
            setIsNextPageLoading(false);
        }
    };
    const handlePageUpdate = (nextPageWrapUpCodes, reset) => {
        setPageFetchError(_constants__WEBPACK_IMPORTED_MODULE_5__.DEFAULT_ERROR_OBJECT);
        updateLoadingFirstPageError({ error: false, trackingId: "" });
        // eslint-disable-next-line no-unsafe-optional-chaining -- Tech debt/Potential bug.
        const { page, totalPages } = nextPageWrapUpCodes === null || nextPageWrapUpCodes === void 0 ? void 0 : nextPageWrapUpCodes.meta;
        if (isPageValid(page, totalPages)) {
            setHasNextPage(page < totalPages - 1);
            setCurrentPage(page);
            wrapUpCodeMeta.current = nextPageWrapUpCodes.meta;
            updateWrapUpList(nextPageWrapUpCodes.data, true, reset);
        }
        else {
            setHasNextPage(false);
        }
        setIsNextPageLoading(false);
        if (page === 0) {
            updateLoadingFirstPage(false);
        }
    };
    const dispatchWrapUpCodesUpdate = (nextPageWrapUpCodes) => {
        const updatedIdleCodes = {
            meta: nextPageWrapUpCodes.meta,
            data: [...reasonList, ...nextPageWrapUpCodes.data]
        };
        (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_4__.evt)(eventDispatchType, updatedIdleCodes, dispatchEvent);
    };
    // condition to check if all the pages are fetched
    const isFullyFetched = () => {
        var _a;
        return agentWrapUpCodes && currentPage === ((_a = agentWrapUpCodes === null || agentWrapUpCodes === void 0 ? void 0 : agentWrapUpCodes.meta) === null || _a === void 0 ? void 0 : _a.totalPages) - 1;
    };
    const isSearchable = () => {
        return searchTerm.length >= _Common_constants__WEBPACK_IMPORTED_MODULE_3__.MINIMUM_CHARACTERS_FOR_SEARCH;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (isSearchable()) {
            handleSearch();
        }
        // this is to resume from the last page when the search term is empty
        if (searchTerm === "") {
            setCurrentPage(agentWrapUpCodes.meta.page);
            setHasNextPage(agentWrapUpCodes.meta.page < agentWrapUpCodes.meta.totalPages - 1);
        }
    }, [searchResults]);
    const handleSearch = () => {
        if (isFullyFetched()) {
            // to search loacally as all wrapup codes are fetched
            updateWrapUpList(searchResults);
        }
        else {
            // to search via api call.
            loadFirstPageForSearch();
        }
    };
    // to load first page for search
    const loadFirstPageForSearch = () => {
        updateWrapUpList([]);
        updateLoadingFirstPage(true);
        loadPage(0, searchTerm, true);
    };
    const loadPage = (currentPage, searchQuery, reset = false) => {
        var _a;
        const orgId = (_a = agentWrapUpCodes === null || agentWrapUpCodes === void 0 ? void 0 : agentWrapUpCodes.meta) === null || _a === void 0 ? void 0 : _a.orgid;
        fetchDataCB(orgId, currentPage, searchQuery)
            .then((response) => {
            const nextPageWrapUpCodes = response;
            if (searchQuery === "") {
                // updating the wrapup codes should only occur when the search query is empty
                dispatchWrapUpCodesUpdate(nextPageWrapUpCodes);
            }
            handlePageUpdate(nextPageWrapUpCodes, reset);
        })
            .catch((error) => {
            handleError(error, currentPage);
        });
    };
    const loadNextPage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isNextPageLoading) {
            return;
        }
        setIsNextPageLoading(true);
        setPageFetchError(_constants__WEBPACK_IMPORTED_MODULE_5__.DEFAULT_ERROR_OBJECT);
        loadPage((currentPage !== null && currentPage !== void 0 ? currentPage : 0) + 1, searchTerm);
    });
    return {
        hasNextPage,
        isNextPageLoading,
        pageFetchError,
        loadNextPage
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (usePagination);


/***/ }),

/***/ "./src/direflow-components/WrapUp/components/WrapUpPopover/index.tsx":
/*!***************************************************************************!*\
  !*** ./src/direflow-components/WrapUp/components/WrapUpPopover/index.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PAGE_SIZE: () => (/* binding */ PAGE_SIZE),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   logger: () => (/* binding */ logger)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! mobx-react-lite */ "../../node_modules/mobx-react-lite/es/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../sdk */ "./src/sdk.ts");
/* harmony import */ var _Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Common/components/EmptyStateWrapper */ "./src/direflow-components/Common/components/EmptyStateWrapper/index.tsx");
/* harmony import */ var _Common_components_InlineError__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Common/components/InlineError */ "./src/direflow-components/Common/components/InlineError.tsx");
/* harmony import */ var _Common_Utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Common/Utils */ "./src/direflow-components/Common/Utils.ts");
/* harmony import */ var _WrapUpHelper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../WrapUpHelper */ "./src/direflow-components/WrapUp/WrapUpHelper.ts");
/* harmony import */ var _AutoWrapUpTimer_index__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../AutoWrapUpTimer/index */ "./src/direflow-components/WrapUp/components/AutoWrapUpTimer/index.tsx");
/* harmony import */ var _WrapUpListContainer_index__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../WrapUpListContainer/index */ "./src/direflow-components/WrapUp/components/WrapUpListContainer/index.tsx");














const PAGE_SIZE = 50;
const logger = (0,_sdk__WEBPACK_IMPORTED_MODULE_7__.createLogger)("WrapUpPopover");
const WrapUpPopover = ({ wrapUpPopOver, cancelAutoTimer, handleCloseMenu, focusableItemChange, overlayOpen }) => {
    var _a, _b, _c, _d, _e, _f;
    const { wrapup, common } = (0,_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_6__.useI18nContext)();
    const [reasonList, setReasonList] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(wrapUpPopOver.isDesktopAuxCodesInfiniteScrollEnabled
        ? (_b = (_a = wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.agentWrapUpCodeProps) === null || _a === void 0 ? void 0 : _a.agentWrapUpCodes) === null || _b === void 0 ? void 0 : _b.data
        : (_c = wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.wrapUpProps) === null || _c === void 0 ? void 0 : _c.wrapUpReasonList);
    const [isAutoWrapUp, setHideAutoWrapUp] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)((_d = wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.wrapUpProps) === null || _d === void 0 ? void 0 : _d.autoWrapup);
    const allowCancelAutoWrapup = (_e = wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.wrapUpProps) === null || _e === void 0 ? void 0 : _e.allowCancelAutoWrapup;
    const [interactionIdValue, setInteractionId] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.interactionId);
    const [searchTerm, setSearchTerm] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [searchResults, setSearchResults] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const [selectedReason, setSelectedReason] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({ id: "", name: "" });
    const [enableSubmit, setEnableSubmit] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [showErrorMessage, setShowErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [trackingId, setTrackingId] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [countMessage, setCountMessage] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [isSearchMode, setSearchMode] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const isLastAgentRoute = false; // wrapUpPopOver?.wrapUpProps?.lastAgentRoute; => enable logic once CORE implements
    const dispatchEvent = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_3__.EventContext);
    const searchInputRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const radioGroupRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const wrapUpButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const resetWarnOnTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const wrapperSearchMessageTimeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const getDefaultWrapUpReason = (reasonList) => {
        var _a;
        if (wrapUpPopOver.isDesktopAuxCodesInfiniteScrollEnabled) {
            return (_a = wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.agentWrapUpCodeProps) === null || _a === void 0 ? void 0 : _a.agentDefaultWrapupCode;
        }
        return reasonList === null || reasonList === void 0 ? void 0 : reasonList.find(({ isDefault }) => isDefault === true);
    };
    const cancelAutoWrapUp = (interactionId) => {
        setHideAutoWrapUp(false);
        cancelAutoTimer(interactionId);
    };
    const cancelAutoWrapUpBtnHandler = () => {
        cancelAutoWrapUp();
        // set in session to track canceled auto wrapup
        (0,_WrapUpHelper__WEBPACK_IMPORTED_MODULE_11__.updateSSWithCanceledAutoWrapupInterationId)(wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.interactionId);
    };
    const searchTermDebouncedFunc = (0,_Common_Utils__WEBPACK_IMPORTED_MODULE_10__.debouncedFunc)((value) => {
        setSearchTerm(value);
        updateSearchResults(value);
        if (value.length === 1) {
            document.dispatchEvent(new CustomEvent("on-widget-update"));
        }
    });
    const updateSelectedWrapUp = (id = "", name = "") => {
        setSelectedReason({ id, name });
    };
    const searchHandler = (event) => {
        setSearchMode(true);
        updateSelectedWrapUp();
        searchTermDebouncedFunc(event.target.value.toLowerCase());
    };
    const inputKeydownHandler = (event) => {
        const { srcEvent } = event.detail;
        if (radioGroupRef && radioGroupRef.current) {
            if (srcEvent.code === "Tab") {
                radioGroupRef.current.rovingPreventFocus = false;
            }
            else {
                radioGroupRef.current.rovingPreventFocus = true;
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if (searchInputRef && searchInputRef.current) {
            const input = searchInputRef.current;
            input.addEventListener("input-change", searchHandler);
            input.addEventListener("input-keydown", inputKeydownHandler);
            return () => {
                input.removeEventListener("input-change", searchHandler);
                input.removeEventListener("input-keydown", inputKeydownHandler);
            };
        }
        return () => { };
    }, [reasonList]);
    const handleRadioChangeEvent = (event) => {
        var _a;
        if (event === null || event === void 0 ? void 0 : event.detail) {
            const { selected } = event.detail;
            const selectedId = (_a = reasonList === null || reasonList === void 0 ? void 0 : reasonList.find((reason) => reason.name === selected)) === null || _a === void 0 ? void 0 : _a.id;
            processUpdatesForSelectedWrapUp(selected, selectedId);
        }
    };
    const processUpdatesForSelectedWrapUp = (selected, selectedId) => {
        if (selectedId && selected) {
            setSelectedReason({ id: selectedId.toString(), name: selected });
        }
        if (!(0,_WrapUpHelper__WEBPACK_IMPORTED_MODULE_11__.sessionStorageInteractionList)(wrapUpPopOver.interactionId)) {
            dispatchEvent(new CustomEvent("ax-update-navigation-warning", {
                detail: { key: "wrapUpReason", value: true }
            }));
        }
        setEnableSubmit(selected !== undefined || selected !== "");
        document.dispatchEvent(new CustomEvent("on-widget-update"));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        const radioGroup = radioGroupRef === null || radioGroupRef === void 0 ? void 0 : radioGroupRef.current;
        if (radioGroup) {
            radioGroup.rovingPreventFocus = true;
            radioGroup.addEventListener("radio-change", handleRadioChangeEvent);
        }
        return () => {
            if (radioGroup) {
                radioGroup.removeEventListener("radio-change", handleRadioChangeEvent);
            }
        };
    }, [reasonList]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if (searchTerm === "") {
            setSearchMode(false);
        }
    }, [searchTerm]);
    const updateSearchResults = (searchQuery) => {
        const filterReasonList = reasonList === null || reasonList === void 0 ? void 0 : reasonList.filter((reason) => reason.name.toLowerCase().includes(searchQuery));
        const isSelectedReasonPresent = filterReasonList === null || filterReasonList === void 0 ? void 0 : filterReasonList.filter((reason) => selectedReason.name === reason.name);
        if ((isSelectedReasonPresent === null || isSelectedReasonPresent === void 0 ? void 0 : isSelectedReasonPresent.length) < 1) {
            updateSelectedWrapUp();
        }
        setEnableSubmit((filterReasonList === null || filterReasonList === void 0 ? void 0 : filterReasonList.length) > 0 && selectedReason.id !== "");
        setSearchResults(filterReasonList);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        updateSearchResults(searchTerm);
    }, [reasonList]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        var _a, _b, _c, _d;
        if (wrapUpPopOver.isDesktopAuxCodesInfiniteScrollEnabled) {
            setReasonList((_b = (_a = wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.agentWrapUpCodeProps) === null || _a === void 0 ? void 0 : _a.agentWrapUpCodes) === null || _b === void 0 ? void 0 : _b.data);
        }
        else {
            setReasonList((_c = wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.wrapUpProps) === null || _c === void 0 ? void 0 : _c.wrapUpReasonList);
        }
        setHideAutoWrapUp((_d = wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.wrapUpProps) === null || _d === void 0 ? void 0 : _d.autoWrapup);
        setInteractionId(wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.interactionId);
    }, [wrapUpPopOver]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        var _a, _b, _c, _d;
        if (selectedReason.name && selectedReason.name !== "") {
            dispatchEvent(new CustomEvent("ax-update-navigation-warning", {
                detail: { key: "wrapUpReason", value: true }
            }));
        }
        if ((_b = (_a = wrapUpButtonRef === null || wrapUpButtonRef === void 0 ? void 0 : wrapUpButtonRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button")) {
            wrapUpButtonRef.current.shadowRoot.querySelector("button").autofocus = true;
        }
        else if ((_d = (_c = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("input")) {
            searchInputRef.current.shadowRoot.querySelector("input").focus();
        }
    }, [isAutoWrapUp]);
    function wrapUpEvent(interactionIdParam) {
        const event = new CustomEvent("ax-interaction-wrapup", {
            detail: {
                type: "wrapup",
                interactionIdParam,
                contactDirection: wrapUpPopOver.contactDirection
            },
            bubbles: true,
            composed: true
        });
        if (dispatchEvent) {
            dispatchEvent(event);
        }
    }
    const isSubmitWrapupDisabled = !enableSubmit || selectedReason.id === "";
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        if (enableSubmit && selectedReason.id !== "") {
            /** Submit Button is now enabled */
            focusableItemChange();
        }
    }, [selectedReason.id]);
    const submitHandler = (isAutoWrapping) => {
        var _a, _b, _c, _d, _e, _f;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_WRAP_UP_APPLIED, [
            (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral,
            (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus,
            (_f = (_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _e === void 0 ? void 0 : _e.SERVICE_PROVIDERS) === null || _f === void 0 ? void 0 : _f.webex_business
        ]);
        if ((!isAutoWrapping && isSubmitWrapupDisabled) ||
            (isAutoWrapping && !(0,_WrapUpHelper__WEBPACK_IMPORTED_MODULE_11__.sessionStorageInteractionList)(wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.interactionId))) {
            return;
        }
        (0,_WrapUpHelper__WEBPACK_IMPORTED_MODULE_11__.removeInteractionId)(interactionIdValue);
        const defaultReason = getDefaultWrapUpReason(reasonList);
        const wrapUpReq = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.contact.wrapupV2({
            interactionId: interactionIdValue,
            data: {
                auxCodeId: selectedReason.id || (defaultReason === null || defaultReason === void 0 ? void 0 : defaultReason.id.toString()) || "",
                wrapUpReason: selectedReason.name || (defaultReason === null || defaultReason === void 0 ? void 0 : defaultReason.name) || ""
            }
        });
        wrapUpReq
            .then(() => {
            (0,_WrapUpHelper__WEBPACK_IMPORTED_MODULE_11__.removeCanceledAutoWrapupInterationIdFromSS)(wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.interactionId);
        })
            .catch((err) => {
            var _a, _b, _c, _d, _e, _f;
            if ((err === null || err === void 0 ? void 0 : err.id) === "Service.aqm.reqs.Pending") {
                // #CX-4335 fix
                return;
            }
            setShowErrorMessage(true);
            cancelAutoWrapUp();
            setTrackingId((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err));
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_WRAP_UP_APPLIED, {
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                Reason: err === null || err === void 0 ? void 0 : err.id
            }, [
                (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus,
                (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral,
                (_f = (_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _e === void 0 ? void 0 : _e.SERVICE_PROVIDERS) === null || _f === void 0 ? void 0 : _f.webex_business
            ]);
            logger.error(`[Tracking ID: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(err)}] WrapupFailed Event: ', ${err}`, err);
        });
    };
    const submitWrapUpOnEnter = (event) => {
        if (event.key === "Enter") {
            submitHandler(false);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        const listener = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.contact.eAgentContactWrappedUp.listen((resp) => {
            var _a, _b, _c, _d, _e, _f;
            if (resp.data.interactionId !== (wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.interactionId)) {
                return;
            }
            handleCloseMenu();
            setShowErrorMessage(false);
            cancelAutoTimer(resp.data.interactionId);
            wrapUpEvent(resp.data.interactionId);
            logger.info("Wrappedup Event: interactionId:", resp.data.interactionId);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.CALL_WRAP_UP_APPLIED, {
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
                media_channel: resp.data.interaction.mediaChannel,
                media_type: resp.data.interaction.mediaType
            }, [
                (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.prometheus,
                (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral,
                (_f = (_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry) === null || _e === void 0 ? void 0 : _e.SERVICE_PROVIDERS) === null || _f === void 0 ? void 0 : _f.webex_business
            ]);
        });
        return () => {
            if (listener) {
                listener.stopListen();
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
        wrapperSearchMessageTimeoutIdRef.current = window.setTimeout(() => {
            if (searchResults.length > 0) {
                setCountMessage(`${searchResults.length} ${wrapup.searchResult}`);
            }
            else {
                setCountMessage(`${wrapup.noResultFound}`);
            }
        }, 1000);
        return () => window.clearTimeout(wrapperSearchMessageTimeoutIdRef.current);
    }, [searchResults]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: !(wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.wrapUpProps) ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "wrapup-container common-error-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_InlineError__WEBPACK_IMPORTED_MODULE_9__["default"], { errorHeaderMsg: common.errorMsg, errorSubMsg: common.errorID, retry: () => { } }) }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "wrapup-container" }, { children: [isAutoWrapUp && (0,_WrapUpHelper__WEBPACK_IMPORTED_MODULE_11__.sessionStorageInteractionList)(wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.interactionId) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "auto-wrapup-wrapper" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "auto-wrapup-label" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AutoWrapUpTimer_index__WEBPACK_IMPORTED_MODULE_12__["default"], { autoWrapUpInterval: wrapUpPopOver.wrapUpProps.autoWrapupInterval, submitHandler: submitHandler, wrapUpTimestamp: wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.wrapUpTimestamp, addColorFont: false }), " ", wrapup.untilautowrapup] })), allowCancelAutoWrapup && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ id: "auto-wrapup-button-id", "data-testid": "auto-wrapup-button-id", ref: wrapUpButtonRef, class: "auto-wrapup-button", size: "32", ariaLabel: wrapup.cancelautowrapup, type: "button", variant: "primary", onClick: cancelAutoWrapUpBtnHandler }, { children: wrapup.cancelautowrapup })))] }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", Object.assign({ className: "wrap-up-reason-header" }, { children: wrapup === null || wrapup === void 0 ? void 0 : wrapup.wrapupreason })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "wrap-up-input-wrapper" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-input", Object.assign({ ref: searchInputRef, id: "pillSearchInput", searchable: true, placeholder: common.search, clear: true, containerSize: "medium-10", htmlId: "pillSearchInput", name: "pillSearchInput", value: searchTerm, type: "text", autoFocus: true, ariaLabel: wrapup.wrapupsearch, clearAriaLabel: common.clear }, (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled ? { newMomentum: true } : { shape: "pill" }))) })), wrapUpPopOver.isDesktopAuxCodesInfiniteScrollEnabled ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WrapUpListContainer_index__WEBPACK_IMPORTED_MODULE_13__["default"], { searchTerm: searchTerm, searchResults: searchResults, reasonList: reasonList, overlayOpen: overlayOpen, isSearchMode: isSearchMode, agentWrapUpCodes: (_f = wrapUpPopOver === null || wrapUpPopOver === void 0 ? void 0 : wrapUpPopOver.agentWrapUpCodeProps) === null || _f === void 0 ? void 0 : _f.agentWrapUpCodes, containerLabel: wrapup === null || wrapup === void 0 ? void 0 : wrapup.listContainerLabel, submitWrapUpOnEnter: submitWrapUpOnEnter, processUpdatesForSelectedWrapUp: processUpdatesForSelectedWrapUp, selectedReason: { id: selectedReason.id, name: selectedReason.name } })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "wrap-up-list-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ "data-testid": "count-message-for-wrapup", className: "sr-only", "aria-live": "polite" }, { children: countMessage })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-radiogroup", Object.assign({ "group-label": wrapup === null || wrapup === void 0 ? void 0 : wrapup.wrapupreason, ref: radioGroupRef, id: "wrap-up-list-id" }, { children: searchResults && searchResults.length > 0
                                ? searchResults.map((option) => ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-radio", Object.assign({ slot: "radio", class: "wrap-up-radio-option", title: option.name, label: option.name, value: option.name, onKeyPress: submitWrapUpOnEnter, ariaLabel: option.name }, { children: option.name }), option.id)))
                                : null })), !searchResults || searchResults.length === 0 ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_components_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_8__["default"], { illustrationType: "empty-result" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", Object.assign({ className: "wrap-up-no-match" }, { children: common.nomatchfound }))] })) : null] }))), isLastAgentRoute ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "wrap-up-setting" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", Object.assign({ className: "wrap-up-reason-header follow-up" }, { children: wrapup.followupsetting })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "wrap-up-followup-checkbox-wrapper" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-checkboxgroup", Object.assign({ name: "lastAgentRoute" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-checkbox", Object.assign({ slot: "checkbox", value: "lastAgentRoute", htmlId: "lastAgentRoute", onChange: () => { }, class: "last-agent-route" }, { children: wrapup.lastagentroute })) })) }))] }))) : null, showErrorMessage && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ id: "wrapup-error-container-id", className: "wrapup-error-container" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "wrapup-error-icon-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-icon", { name: "error-legacy-badge-filled", iconSet: "momentumDesign", size: "12" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", Object.assign({ className: "wrapup-error-message" }, { children: [wrapup.invalidationError, " (", common.trackingIdInputLabel, " ", trackingId, ")"] }))] }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "wrap-up-submit-button" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("md-button", Object.assign({ id: "wrapup-submit-button-id", size: "32", ariaLabel: wrapup.submitwrapup, type: "button", variant: "primary" }, (isSubmitWrapupDisabled ? { disabled: true } : ""), { onClick: () => submitHandler(false), "data-testid": "wrapup-submit-testId" }, { children: wrapup.submitwrapup })) }))] }))) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_4__.observer)(WrapUpPopover));


/***/ }),

/***/ "./src/direflow-components/WrapUp/components/index.tsx":
/*!*************************************************************!*\
  !*** ./src/direflow-components/WrapUp/components/index.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../i18n/I18nProvider */ "./src/i18n/I18nProvider.tsx");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../styles.css */ "./src/direflow-components/WrapUp/styles.css");
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _WrapUpContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./WrapUpContent */ "./src/direflow-components/WrapUp/components/WrapUpContent/index.tsx");





/**
 * App WrapUp MFE
 * A Micro Front End component for rendering WrapUp Reasons Menu used in Call Controller MFE
 *
 * @param props
 */
const WrapUp = (props) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_I18nProvider__WEBPACK_IMPORTED_MODULE_2__.I18nProvider, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_wc_utilities__WEBPACK_IMPORTED_MODULE_1__.Styled, Object.assign({ styles: [(_styles_css__WEBPACK_IMPORTED_MODULE_3___default())] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", Object.assign({ className: "wrap-up-menu-selector" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WrapUpContent__WEBPACK_IMPORTED_MODULE_4__["default"], Object.assign({}, props)) })) })) }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WrapUp);


/***/ }),

/***/ "./src/direflow-components/WrapUp/constants.js":
/*!*****************************************************!*\
  !*** ./src/direflow-components/WrapUp/constants.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AUTO_WRAPUP_TIMEOUT_INTERVAL: () => (/* binding */ AUTO_WRAPUP_TIMEOUT_INTERVAL),
/* harmony export */   AUTO_WRAPUP_WARNING_TIME_MILLISECONDS: () => (/* binding */ AUTO_WRAPUP_WARNING_TIME_MILLISECONDS),
/* harmony export */   AX_WRAPUP_CODE_UPDATE: () => (/* binding */ AX_WRAPUP_CODE_UPDATE),
/* harmony export */   CANCELED_AUTOWRAPUP_INTERACTION: () => (/* binding */ CANCELED_AUTOWRAPUP_INTERACTION),
/* harmony export */   DEFAULT_ERROR_OBJECT: () => (/* binding */ DEFAULT_ERROR_OBJECT),
/* harmony export */   PAGE_SIZE: () => (/* binding */ PAGE_SIZE)
/* harmony export */ });
const AUTO_WRAPUP_TIMEOUT_INTERVAL = 1000; // milliseconds
const AUTO_WRAPUP_WARNING_TIME_MILLISECONDS = 10000; // milliseconds
const CANCELED_AUTOWRAPUP_INTERACTION = "canceledAutoWrapUpInteraction"; // milliseconds
const AX_WRAPUP_CODE_UPDATE = "ax-wrapup-codes-update";
const PAGE_SIZE = 100;
const DEFAULT_ERROR_OBJECT = {
  error: false,
  trackingId: ""
};


/***/ }),

/***/ "./src/direflow-components/WrapUp/styles.css":
/*!***************************************************!*\
  !*** ./src/direflow-components/WrapUp/styles.css ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


        var result = __webpack_require__(/*! !!../../../../../node_modules/css-loader/dist/cjs.js!./styles.css */ "../../node_modules/css-loader/dist/cjs.js!./src/direflow-components/WrapUp/styles.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/i18n/I18nProvider.tsx":
/*!***********************************!*\
  !*** ./src/i18n/I18nProvider.tsx ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I18nProvider: () => (/* binding */ I18nProvider),
/* harmony export */   getBrowserLanguage: () => (/* binding */ getBrowserLanguage),
/* harmony export */   getDefaultEnglishMessages: () => (/* binding */ getDefaultEnglishMessages),
/* harmony export */   getLanguageFromCode: () => (/* binding */ getLanguageFromCode),
/* harmony export */   getLocalizedMessages: () => (/* binding */ getLocalizedMessages),
/* harmony export */   replacePlaceholders: () => (/* binding */ replacePlaceholders),
/* harmony export */   useI18nContext: () => (/* binding */ useI18nContext)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var iso_639_1__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! iso-639-1 */ "../../node_modules/iso-639-1/src/index.js");
/* harmony import */ var iso_639_1__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(iso_639_1__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./constants */ "./src/i18n/constants.js");
/* harmony import */ var _messages_bg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./messages/bg */ "./src/i18n/messages/bg.js");
/* harmony import */ var _messages_ca__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./messages/ca */ "./src/i18n/messages/ca.js");
/* harmony import */ var _messages_cs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./messages/cs */ "./src/i18n/messages/cs.js");
/* harmony import */ var _messages_da__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./messages/da */ "./src/i18n/messages/da.js");
/* harmony import */ var _messages_de__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./messages/de */ "./src/i18n/messages/de.js");
/* harmony import */ var _messages_en__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./messages/en */ "./src/i18n/messages/en.js");
/* harmony import */ var _messages_es__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./messages/es */ "./src/i18n/messages/es.js");
/* harmony import */ var _messages_fi__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./messages/fi */ "./src/i18n/messages/fi.js");
/* harmony import */ var _messages_fr__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./messages/fr */ "./src/i18n/messages/fr.js");
/* harmony import */ var _messages_hr__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./messages/hr */ "./src/i18n/messages/hr.js");
/* harmony import */ var _messages_hu__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./messages/hu */ "./src/i18n/messages/hu.js");
/* harmony import */ var _messages_it__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./messages/it */ "./src/i18n/messages/it.js");
/* harmony import */ var _messages_ja__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./messages/ja */ "./src/i18n/messages/ja.js");
/* harmony import */ var _messages_ko__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./messages/ko */ "./src/i18n/messages/ko.js");
/* harmony import */ var _messages_nb__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./messages/nb */ "./src/i18n/messages/nb.js");
/* harmony import */ var _messages_nl__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./messages/nl */ "./src/i18n/messages/nl.js");
/* harmony import */ var _messages_pl__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./messages/pl */ "./src/i18n/messages/pl.js");
/* harmony import */ var _messages_pt__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./messages/pt */ "./src/i18n/messages/pt.js");
/* harmony import */ var _messages_ro__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./messages/ro */ "./src/i18n/messages/ro.js");
/* harmony import */ var _messages_ru__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./messages/ru */ "./src/i18n/messages/ru.js");
/* harmony import */ var _messages_sk__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./messages/sk */ "./src/i18n/messages/sk.js");
/* harmony import */ var _messages_sl__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./messages/sl */ "./src/i18n/messages/sl.js");
/* harmony import */ var _messages_sr__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./messages/sr */ "./src/i18n/messages/sr.js");
/* harmony import */ var _messages_sv__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./messages/sv */ "./src/i18n/messages/sv.js");
/* harmony import */ var _messages_tr__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./messages/tr */ "./src/i18n/messages/tr.js");
/* harmony import */ var _messages_uk__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./messages/uk */ "./src/i18n/messages/uk.js");
/* harmony import */ var _messages_zh_CN__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./messages/zh_CN */ "./src/i18n/messages/zh_CN.js");
/* harmony import */ var _messages_zh_TW__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./messages/zh_TW */ "./src/i18n/messages/zh_TW.js");
































const supportedLanguage = [
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_BG,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_CA,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_CS,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_DA,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_DE,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_EN,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_ES,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_FI,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_FR,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_HR,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_HU,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_IT,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_JA,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_KO,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_NB,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_NL,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_PL,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_PT,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_RO,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_RU,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_SK,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_SL,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_SR,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_SV,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_TR,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_UK,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_ZH_CN,
    _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_ZH_TW
];
const messages = {
    bg: _messages_bg__WEBPACK_IMPORTED_MODULE_4__["default"],
    ca: _messages_ca__WEBPACK_IMPORTED_MODULE_5__["default"],
    cs: _messages_cs__WEBPACK_IMPORTED_MODULE_6__["default"],
    da: _messages_da__WEBPACK_IMPORTED_MODULE_7__["default"],
    de: _messages_de__WEBPACK_IMPORTED_MODULE_8__["default"],
    en: _messages_en__WEBPACK_IMPORTED_MODULE_9__["default"],
    es: _messages_es__WEBPACK_IMPORTED_MODULE_10__["default"],
    fi: _messages_fi__WEBPACK_IMPORTED_MODULE_11__["default"],
    fr: _messages_fr__WEBPACK_IMPORTED_MODULE_12__["default"],
    hr: _messages_hr__WEBPACK_IMPORTED_MODULE_13__["default"],
    hu: _messages_hu__WEBPACK_IMPORTED_MODULE_14__["default"],
    it: _messages_it__WEBPACK_IMPORTED_MODULE_15__["default"],
    ja: _messages_ja__WEBPACK_IMPORTED_MODULE_16__["default"],
    ko: _messages_ko__WEBPACK_IMPORTED_MODULE_17__["default"],
    nb: _messages_nb__WEBPACK_IMPORTED_MODULE_18__["default"],
    nl: _messages_nl__WEBPACK_IMPORTED_MODULE_19__["default"],
    pl: _messages_pl__WEBPACK_IMPORTED_MODULE_20__["default"],
    pt: _messages_pt__WEBPACK_IMPORTED_MODULE_21__["default"],
    ro: _messages_ro__WEBPACK_IMPORTED_MODULE_22__["default"],
    ru: _messages_ru__WEBPACK_IMPORTED_MODULE_23__["default"],
    sk: _messages_sk__WEBPACK_IMPORTED_MODULE_24__["default"],
    sl: _messages_sl__WEBPACK_IMPORTED_MODULE_25__["default"],
    sr: _messages_sr__WEBPACK_IMPORTED_MODULE_26__["default"],
    sv: _messages_sv__WEBPACK_IMPORTED_MODULE_27__["default"],
    tr: _messages_tr__WEBPACK_IMPORTED_MODULE_28__["default"],
    uk: _messages_uk__WEBPACK_IMPORTED_MODULE_29__["default"],
    "zh-CN": _messages_zh_CN__WEBPACK_IMPORTED_MODULE_30__["default"],
    "zh-TW": _messages_zh_TW__WEBPACK_IMPORTED_MODULE_31__["default"]
};
/** I18nContext to share localized message across components */
const I18nContext = react__WEBPACK_IMPORTED_MODULE_2__.createContext(undefined);
/** useI18nContext to use I18nContext */
const useI18nContext = () => {
    const context = react__WEBPACK_IMPORTED_MODULE_2__.useContext(I18nContext);
    if (context === undefined) {
        throw new Error("useI18nContext must be used within a I18nProvider");
    }
    return context;
};
const getBrowserLanguage = () => {
    let browserLanguage = window.navigator.languages ? window.navigator.languages[0] : null;
    const browserLanguageStr = "browserLanguage";
    const userLanguage = "userLanguage";
    browserLanguage =
        browserLanguage ||
            window.navigator.language ||
            window.navigator[browserLanguageStr] ||
            window.navigator[userLanguage];
    let shortLang = browserLanguage;
    if (shortLang && shortLang.includes("-")) {
        shortLang = messages[shortLang] ? shortLang : shortLang.split("-")[0];
    }
    if (!shortLang) {
        shortLang = _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_EN_CODE;
    }
    return shortLang;
};
const getMessagesForSelectedLocale = () => {
    const selectedLang = getBrowserLanguage();
    // check if browser language is not supported then return english
    return messages[selectedLang] ? messages[selectedLang] : messages.en;
};
/**
 * Get localized messages.
 */
const getLocalizedMessages = () => {
    return getMessagesForSelectedLocale();
};
const getDefaultEnglishMessages = () => {
    return messages.en;
};
/** I18nProvider to share i18n localized messages */
const I18nProvider = (props) => {
    const messagesBasedOnLang = getMessagesForSelectedLocale();
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(I18nContext.Provider, Object.assign({ value: messagesBasedOnLang }, { children: props.children }));
};
function getLanguageFromCode() {
    const shortLang = getBrowserLanguage();
    const language = iso_639_1__WEBPACK_IMPORTED_MODULE_1___default().getName(shortLang);
    return supportedLanguage.includes(language) ? language : _constants__WEBPACK_IMPORTED_MODULE_3__.LANG_EN;
}
/**
 * Replaces placeholders in a string with the provided replacements.
 * @param str - String with placeholders to be replaced
 * @param replacements - Object containing the key-value pairs of placeholders and their replacements
 * Returns the string with placeholders replaced with the provided values.
 * Example: replacePlaceholders('Hello {name}', { name: 'John' }) => 'Hello John'
 */
const replacePlaceholders = (str, replacements) => {
    return str.replace(/{(\w+)}/g, (match, key) => {
        return replacements[key] !== undefined ? replacements[key] : match;
    });
};



/***/ }),

/***/ "./src/i18n/constants.js":
/*!*******************************!*\
  !*** ./src/i18n/constants.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LANG_BG: () => (/* binding */ LANG_BG),
/* harmony export */   LANG_CA: () => (/* binding */ LANG_CA),
/* harmony export */   LANG_CS: () => (/* binding */ LANG_CS),
/* harmony export */   LANG_DA: () => (/* binding */ LANG_DA),
/* harmony export */   LANG_DE: () => (/* binding */ LANG_DE),
/* harmony export */   LANG_EN: () => (/* binding */ LANG_EN),
/* harmony export */   LANG_EN_CODE: () => (/* binding */ LANG_EN_CODE),
/* harmony export */   LANG_ES: () => (/* binding */ LANG_ES),
/* harmony export */   LANG_FI: () => (/* binding */ LANG_FI),
/* harmony export */   LANG_FR: () => (/* binding */ LANG_FR),
/* harmony export */   LANG_HR: () => (/* binding */ LANG_HR),
/* harmony export */   LANG_HU: () => (/* binding */ LANG_HU),
/* harmony export */   LANG_IT: () => (/* binding */ LANG_IT),
/* harmony export */   LANG_JA: () => (/* binding */ LANG_JA),
/* harmony export */   LANG_KO: () => (/* binding */ LANG_KO),
/* harmony export */   LANG_NB: () => (/* binding */ LANG_NB),
/* harmony export */   LANG_NL: () => (/* binding */ LANG_NL),
/* harmony export */   LANG_PL: () => (/* binding */ LANG_PL),
/* harmony export */   LANG_PT: () => (/* binding */ LANG_PT),
/* harmony export */   LANG_RO: () => (/* binding */ LANG_RO),
/* harmony export */   LANG_RU: () => (/* binding */ LANG_RU),
/* harmony export */   LANG_SK: () => (/* binding */ LANG_SK),
/* harmony export */   LANG_SL: () => (/* binding */ LANG_SL),
/* harmony export */   LANG_SR: () => (/* binding */ LANG_SR),
/* harmony export */   LANG_SV: () => (/* binding */ LANG_SV),
/* harmony export */   LANG_TR: () => (/* binding */ LANG_TR),
/* harmony export */   LANG_UK: () => (/* binding */ LANG_UK),
/* harmony export */   LANG_ZH_CN: () => (/* binding */ LANG_ZH_CN),
/* harmony export */   LANG_ZH_TW: () => (/* binding */ LANG_ZH_TW)
/* harmony export */ });
const LANG_BG = "Bulgarian";
const LANG_CA = "Catalan";
const LANG_CS = "Czech";
const LANG_DA = "Danish";
const LANG_DE = "German";
const LANG_EN = "English";
const LANG_ES = "Spanish";
const LANG_FI = "Finnish";
const LANG_FR = "French";
const LANG_HR = "Croatian";
const LANG_HU = "Hungarian";
const LANG_IT = "Italian";
const LANG_JA = "Japanese";
const LANG_KO = "Korean";
const LANG_NB = "Norwegian Bokmål";
const LANG_NL = "Dutch";
const LANG_PL = "Polish";
const LANG_PT = "Portuguese";
const LANG_RO = "Romanian";
const LANG_RU = "Russian";
const LANG_SK = "Slovak";
const LANG_SL = "Slovenian";
const LANG_SR = "Serbian";
const LANG_SV = "Swedish";
const LANG_TR = "Turkish";
const LANG_UK = "Ukrainian";
const LANG_ZH_CN = "Chinese China";
const LANG_ZH_TW = "Chinese Taiwan";
const LANG_EN_CODE = "en";


/***/ }),

/***/ "./src/i18n/messages/bg.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/bg.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Неуспешно зареждане на данни',
    errorID: 'ИД на грешка',
    tryAgain: 'Нов опит',
    Error: 'Грешка',
    okButton: 'OK',
    Yes: 'Да',
    Cancel: 'Отказ',
    Confirm: 'Потвърждаване',
    Continue: 'Продълж.',
    Canceling: 'Отменяне',
    CiscoAiAssistant: 'Cisco AI асистент',
    Answer: 'Отговаряне',
    AnswerAriaLabel: 'Отговор на задача от работния плот',
    Decline: 'Отхвърляне',
    ErrorSecurityCompliance: 'Съответствие на защитата',
    errorDetails: 'Подробности за грешката',
    learnMore: 'Научете повече',
    showLess: 'Показване на по-малко',
    trackingIdDescription:
      'Споделете ИД за проследяване с администратора на сайта или екипа по поддръжката, за да разследвате ситуацията.',
    trackingIdInputLabel: 'ИД за проследяване: ',
    submitForm: 'Подаване на формуляр',
    unnamedStatus: 'Статус без име',
    errorChatMsg: 'Неуспешно зареждане на данни от чат',
    noOptions: 'Без опции',
    noResults: 'Няма резултат',
    more: 'Повече',
    nomatchfound: 'Няма намерени съвпадения',
    collaborationTool: 'Инструмент за сътрудничество',
    timerAriaLabel: 'Прекарано време',
    historyItemTime: 'Случи се в',
    loading: 'Зарежда се',
    months: [
      'Януари',
      'Февруари',
      'Март',
      'Април',
      'Май',
      'Юни',
      'Юли',
      'Август',
      'Септември',
      'Октомври',
      'Ноември',
      'Декември'
    ],
    loadingMsg: 'Зарежда се..',
    search: 'Търсене',
    historyChannelLabels: {
      All: 'Всички',
      telephony: 'Глас',
      chat: 'Чат',
      email: 'Имейл',
      social: 'Социални'
    },
    homePageLabel: 'Начална страница',
    resizeHistoryDragger: 'Плъзгач за преоразмеряване на хронологията',
    agentHistoryLabel: 'хронология на агент',
    clear: 'Изчистване на въведеното',
    ariaLabelAgentHistoryWrapper:
      'Хронологията на взаимодействие с агента показва скорошните ви комуникации с клиенти по различни канали от последните 24 часа',
    sliderResizerInstructions:
      'В момента използвате плъзгач. За да преоразмерите използвайте бутоните със стрелки',
    resizeHistoryPanel: 'Преоразмеряване на панела за хронологията, плъзгача,',
    time: {
      hours: 'час',
      minutes: 'мин',
      seconds: 'сек.'
    }
  },
  email: {
    ToLabel: 'До',
    FromLabel: 'От',
    CcLabel: 'Як',
    BccLabel: 'Ск',
    SubjectLabel: 'Тема',
    HideLabel: 'Скрий',
    SendLabel: 'Изпращане',
    ShowPrevThread: 'Показване на предишната нишка',
    HidePrevThread: 'Скриване на предишната нишка',
    ReplyLabel: 'Отговор',
    ReplyAllLabel: 'Отговор до всички',
    ViewOriginalMail: 'Преглед на оригиналния имейл',
    QuickReplyInp: 'Бърз отговор тук...',
    AttachFiles: 'Прикачване на файлове',
    ToolbarHeading: 'Заглавие 1',
    ToolbarBold: 'Удебелен',
    ToolbarItalic: 'Курсив',
    ToolbarUnderLine: 'Подчертаване',
    ToolbarBlockQuote: 'Блок с цитати',
    ToolbarCode: 'Блок с код',
    ToolbarListOrder: 'Изброяване по подредба',
    ToolbarListBullet: 'Показване по водещи символи',
    ToolbarLink: 'Връзка',
    ToolbarStrike: 'Пробив',
    ToolbarColor: 'Цвят на текста',
    ToolbarTable: 'Таблица',
    insertTable: 'Вмъкване на таблица',
    insertRowAbove: 'Вмъкване на ред отгоре',
    insertRowBelow: 'Вмъкване на ред отдолу',
    insertColumnLeft: 'Вмъкване на колона отляво',
    insertColumnRight: 'Вмъкване на колона отдясно',
    deleteRow: 'Изтриване на ред',
    deleteColumn: 'Изтриване на колона',
    deleteTable: 'Изтриване на таблица;',
    link: 'Връзка',
    IndentRight: 'Отстъп отдясно',
    IndentLeft: 'Отстъп отляво',
    showMoreAttachment: 'Показване на още прикачени файлове',
    AttachmentLimit: 'Прикачване до ',
    attachments: ' прикачени файлове ',
    sizeLimit: ' Максимална стойност на MB',
    attachment: 'Прикачен файл',
    errordeleteattachment: 'Невъзможно изтриване на файлове. Опитайте отново.',
    errordownloadattachment: 'Неуспешно изтегляне на файлове. Опитайте отново.',
    erroraddattachemnt: 'Невъзможно качване на файлове. Опитайте отново.',
    errorendcontact: 'Невъзможност за приключване на взаимодействието. Опитайте отново.',
    erroraddlimitreached:
      'Файлът не може да бъде прикачен, защото надвишава максималния размер. ',
    errorattachmentdrop:
      'Приставките, които са пуснати като съдържание, съдържат данни, които нарушават политиката за защита на данните в компанията.',
    errorfiletype: 'Типът на файла не се поддържа. Опитайте отново.',
    errorcreditcard:
      'Неуспешно качване на прикачените файлове, тъй като съдържа данни, нарушаващи политиката за защита на компанията.',
    errorcontainsimage:
      'Неуспешно качване на прикачените файлове, тъй като съдържа изображение, което не се поддържа в съответствие с политиката за защита на компанията.',
    errorlimit: ' Ограничение за МВ.',
    errorsendemail: 'Изпращането на имейла е невъзможно. Опитайте отново.',
    errorpcicheckemail: 'Неуспешно извличане на PCI данни. Опитайте отново.',
    errortext: 'Неуспешно зареждане на данни',
    tryAgain: 'Нов опит',
    replywarning:
      'Не споделяйте финансова или здравна информация или информация за идентифициране на лице в това съобщение или прикачените файлове.',
    datamasked:
      'Темата или тялото на имейла са редактирани според политиката за защита на компанията. Сигурни ли сте, че искате да изпратите този имейл?',
    pcibannerwarning:
      'Темата или тялото на имейла e редактирано според политиката за защита на компанията.',
    on: 'Вкл.',
    wrote: 'написа'
  },
  interaction_control: {
    windowOpened: 'Отворен прозорец',
    connected: 'Свързано',
    consultRequested: 'Искане за консултация',
    consulting: 'Консултиране',
    consultCallOnHold: 'Консултация в задържане',
    callOnHold: 'Повикване в задържане',
    consult: 'Консултативен разговор',
    endconsult: 'Край на консултация',
    hold: 'ЗадРаз',
    transfer: 'Прехвърляне',
    conference: 'Конференция',
    endconference: 'Край на конференцията',
    conferenceRequested: 'Заявка за конференция',
    switchCall: 'Превключване',
    mergeCall: 'Обединяване',
    wrapup: 'Приключване',
    end: 'Край',
    customername: 'Име на клиента',
    dn: 'DNIS',
    ivrpath: 'Път на IVR',
    email: 'Имейл на клиент',
    ani: 'Телефонен номер',
    queueid: 'Име на опашката',
    ronatimeout: 'Време за RONA',
    pathid: 'ИД на път на IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'DN на агента',
    destagentname: 'Име на агент',
    virtualteamname: 'Опашка',
    category: 'Категория',
    additionaldetails: 'Допълнителни подробности',
    sourcenumber: 'Номер на източника',
    sourcepage: 'Страница на източника',
    appuser: 'ИД на потребител на приложение',
    customernumber: 'Телефонен номер',
    exitconference: 'Излизане от конференцията',
    resume: 'Възобн',
    pauserecording: 'Пауза в записа',
    resumerecording: 'Възобновяване на записа',
    exitconsult: 'Излизане от консултацията',
    pauseRecordingFailed: 'Неуспешно поставяне на записването на пауза. Опитайте отново.',
    resumeRecordingFailed: 'Неуспешно възобновяване на записването. Опитайте отново.',
    holdCallFailed: 'Разговорът не може да бъде задържан. Опитайте отново.',
    resumeCallFailed: 'Неуспешно възобновяване на разговора. Опитайте отново.',
    endCallFailed: 'Невъзможност за приключване на взаимодействието. Опитайте отново.',
    consultTransferFailed:
      'Неуспешно прехвърляне на повикването за консултация. Опитайте отново.',
    conferenceTransferFailed:
      'Прехвърлянето на конферентното повикване е невъзможно. Опитайте отново.',
    conferenceFailed:
      'Заявката за конференция не може да се свърже. Опитайте отново.',
    consultEndFailed: 'Неуспешно завършване на искане за консултация. Опитайте отново.',
    conferenceExitFailed:
      'Неуспешен изход от искане за консултация. Опитайте отново.',
    conferenceEndFailed:
      'Неуспешно завършване на искане за консултация. Опитайте отново.',
    cancelCtqFailed:
      'Невъзможно прекратяване на консултативно повикване с връщане към опашката. Опитайте отново.',
    privacyShield: 'Защита на поверителността',
    errorOnPrvacyShieldForConsult:
      'Записването в момента е на пауза. Възобновете записването, за да започне консултативно повикване.',
    errorOnPrvacyShieldForTransfer:
      'Записването в момента е на пауза. Възобновете записването, за да започне прехвърляне на повикване.',
    cancelConsult: 'Прекратяване на консултация',
    cancelTransfer: 'Прекратяване на прехвърляне',
    copy: 'Копиране',
    copied: 'Копирано',
    cadrequestuccess: 'Успешно записване на информацията за клиента.',
    cadrequestfailure: 'Неуспешно записване на информацията за клиента. Опитайте по-късно.',
    cadupdatedmessage: 'Информацията за клиента е актуализирана от',
    unsavedmessage: 'Незаписаните ви промени са презаписани.',
    save: 'Запаметяване',
    revert: 'Възстан.',
    expandDetails: 'Разгъване на подробни данни',
    collapseDetails: 'Свиване на подробните данни',
    cadValidationError:
      'Невалиден формат. Използвайте международния стандарт за дата и час.',
    secureCadSaveError:
      'Информацията за клиента не е записана. Щракнете върху „Запиши“, за да опитате отново.',
    secureDecryptionError: 'Защитените променливи не могат да се покажат.',
    clickToTry: 'Щракнете, за да опитате отново',
    isSecureVariable: 'е защитена променлива',
    contactorigin: 'Произход на контакта',
    resumeMonitoring: 'Възобновяване на наблюдението',
    pauseMonitoring: 'Пауза на наблюдението',
    whisperCoach: 'Напътствие с шепот',
    bargeIn: 'Включване в разговор',
    endMonitoring: 'Край на наблюдението',
    contactphonenumber: 'Тел. номер на контакта',
    contactqueue: 'Опашка с контакти',
    activeparticipants: 'Активни участници',
    consultedparticipant: 'Консултиран участник',
    contactstatus: 'Състояние на контакта',
    timeincontactstatus: 'Време в състояние на контакт',
    totalcontactduration: 'Обща продължителност на контакта',
    agentinteractiontime: 'Продължителност на взаимодействието',
    recording: 'Записване',
    monitoring: 'Наблюдение',
    monitoringPaused: 'Наблюдението е на пауза',
    pauseMonitoringFailed: 'Наблюдението не може да се постави на пауза. Опитайте отново.',
    resumeMonitoringFailed: 'Наблюдението не може да се възобнови. Опитайте отново.',
    callCancelledInProgress: 'Повикването се отменя',
    bargedIn: 'Намеса',
    keypad: 'Клавиатура',
    mute: 'Без звук',
    unmute: 'Отмяна на заглушаването',
    bargeInTooltipText:
      'Микрофонът ще се включи и ще се присъедините към това взаимодействие с клиента',
    bargeInCompactTooltipText:
      'Микрофонът ще се включи и ще се присъедините към това взаимодействие с клиента',
    bargeInTooltipDisabled: 'Моля, възобновете наблюдението, за да активирате възможността за намеса',
    bargeInFailedTitle: 'Намесата не успя',
    bargeInFailedData:
      'Възникна грешка, докато се опитвахте да се намесите. Опитайте отново след известно време.',
    supervisorBargedIn: 'се намеси в повикването ви.',
    leftInteraction: 'Напусна взаимодействието.',
    conferenceEnded: 'Конферентният разговор приключи.',
    participants: 'Участници',
    badgeAriaLabel: '{participant} е в повикването',
    bargeInConferenceAriaLabel: 'Има двама участници във взаимодействието',
    taskName: 'Име на задача за управление на взаимодействие',
    interactionDurationLabel: 'Времетраене',
    wrapupassist: 'Помощ при приключване',
    consultingTaskContext: 'Консултантско обаждане от',
    consultExited: 'Консултативното повикване приключи',
    endCall: 'Край на повикването.',
    exitconferenceCall:
      'Излезте от повикването и конферентният разговор продължава с активните участници.',
    recordingInProgess: 'Записът е в ход',
    recordingPaused: 'Записът е на пауза',
    searchPlaceholder: 'Търсене на контакти',
    postCall: "Повикване",
    switchCallTooltip: "Превключване към повикване",
    switchConsultTooltip: "Превключване към консултативно повикване",
    switchConferenceTooltip: "Превключване към конферентно повикване",
    confirmationDialog: {
      endCallTitle: 'Искате ли да прекратите сесията на повикването?',
      endCallMessage: 'Кликнете върху Потвърждаване, за да прекратите повикването за всички участници.',
      exitConferenceTitle: 'Искате ли да излезете от конферентния разговор?',
      exitConferenceMessage:
        'Щракнете върху Потвърждаване, за да излезете от конферентния разговор и да позволите на другите участници да продължат.',
      confirmButtonLabel: "Потвърждаване",
      cancelButtonLabel: "Отказ",  
    },
    postCallOnHold: "Последващо повикване в задържане",
    postCallConsult: "Консултация след повикване",
    postCallConsultOnHold: "Консултация след повикване в задържане",
  },
  agentProfile: {
    teamName: 'Екип',
    dialNumber: 'Номер за набиране',
    phoneNumber: 'Телефонен номер',
    settings: 'Промяна на настройките',
    signOut: 'Изход',
    webRTCDisconnected: 'Предупреждение за прекъсната настолна телефония ',
    msAuthFailed: 'Неуспешно удостоверяване от Microsoft',
    stateSyncFailed: 'Неуспешно синхронизиране на състоянието',
    userProfileLabel: 'Потребителски профил',
    ariaAgentprofile: 'Профил на агент',
    ChannelCapacity: 'Капацитет на канала',
    voice: 'Глас',
    chat: 'Чат',
    email: 'Имейл',
    social: 'Социални',
    channelCapacityTooltip: 'Щракнете, за да видите повече',
    blendedRouting: 'Смесване',
    exclusiveRouting: 'Ексклузивно маршрутизиране',
    realtimeRouting: 'Смесване на маршрутизиране в реално време',
    blendedRoutingTooltip: 'Обработвайте много контакти в каналите.',
    exclusiveRoutingTooltip: 'В даден момент обработвайте само един контакт.',
    realtimeRoutingTooltip: 'Обработвайте задължително един канал в реално време.',
    errorActiveContacts:
      'Не можете да излезете сега, тъй като имате активни разговори. Завършете ги и опитайте отново.',
    searchTeams: 'Търсене на екипи',
    changeTeamsConfirmHeader: 'Потвърждение за смяна на екипа',
    changeTeamsConfirmMessage: 'Сигурни ли сте, че искате да смените екипа си?',
    changeTeamLabel: 'Смяна на екипа',
    errorChangeTeams:
      'Не можете да смените екипа сега, тъй като имате активни заявки. Завършете ги и опитайте отново.',
    saveTeamSelection: 'Избор на запис на екип',
    userSettings: 'Потребителски настройки',
    resetLayout: 'Нулиране на оформлението на Desktop',
    resetConfirmHeader: 'Нулиране на потвърдените за оформление',
    resetConfirmMessage:
      'Сигурни ли сте, че искате да нулирате цялото оформление на „Работен плот“?<br/>„Работен плот“ ще се върне към оформлението по подразбиране.',
    downloadLogs: 'Изтегляне на отчета за грешки',
    help: 'Помощ',
    signoutConfirm: 'Наистина ли искате да излезете?',
    signoutConfirmHeader: 'Потвърждение за излизане',
    darkTheme: 'Превключване към тъмен режим',
    newLook: 'Превключване към нов облик',
    keyboardShortcuts: 'Клавишни комбинации',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Настройки за уведомявания',
    silentNotification: 'Тихи уведомявания',
    enableNotificationSettings: 'Активиране на уведомявания',
    enableSilentNotificationSettings: 'Активиране на тихи уведомявания',
    suppressWebexCallingNotificationSettings: 'Скриване на известията за Webex Calling',
    notificationSettingDescription:
      'Предлага уведомявания, като нови съобщения, предупреждения и промени в Статусто.',
    silentNotificationDescription:
      'Изключва екранните предупреждения. Можете да прегледате уведомяванията в центъра за уведомявания.',
    suppressWebexCallingNotificationDescription: 
    'Не показвайте изскачащи известия за входящи повиквания на Webex и им отговаряйте чрез Webex Contact Center.',
    arrowLabel: 'Назад',
    managedTeams: 'Управлявани екипи',
    managedTeamsError: 'Неуспешно зареждане на екипи.',
    viewAll: 'Преглед на всички',
    profileSettings: 'Настройки на профила',
    userRole: 'Роля',
    saveSelection: 'Записване на селекцията',
    extension: 'Вътрешен номер',
    changeProfileConfirmHeader: 'Потвърждаване на промените в настройките на профила',
    changeProfileConfirmMessage:
      'Наистина ли искате да запишете промените в потребителския си профил?',
    confirm: 'Потвърждаване',
    errorProfileUpdate:
      'Не можете да смените настройките на профила сега, тъй като имате активни заявки. Завършете ги и опитайте отново.',
    roleAgentSupervisor: 'Надзорник и агент',
    roleSupervisor: 'Надзорник',
    noTeam: 'Няма отбор',
    testYourNetwork: 'Тествайте мрежата си',
    speakerAndMic: 'Високоговорител и микрофон',
    speaker: 'Високоговорител',
    mic: 'Микрофон',
    speakerDescription:
      'Изберете и тествайте изходното устройство, за да сте сигурни, че чувате повикващия.',
    micDescription:
      'Изберете и тествайте входното устройство, за да сте сигурни, че повикващият ще ви чуе.',
    micError:
      'Достъпът до микрофона е отказан. Разрешете достъпа чрез настройките на браузъра или се обърнете към вашия администратор.',
    speakerError:
      'В момента високоговорителят не е наличен, тъй като достъпът до микрофона е отказан.',
    telephony: 'Телефония',
    desktop: 'Работен плот',
    onSpeakerPlay:
      'Ако не можете да™чуете тестовия звук, проверете устройството на високоговорителя.',
    onMicPlay:
      'Ако не можете да чуете тестовия звук, проверете както високоговорителя, така и микрофона.',
    onMicRecord: 'Запишете съобщение за възпроизвеждане.',
    test: 'Тест',
    recording: 'Записване',
    playing: 'Възпроизвеждане',
    reconnecting: 'Повторно свързване',
    disconnectMessage:
      'Връзката с настолната телефония е прекъсната. Опитайте друга опция за телефония.',
    singleTelephonyDisconnectMessage:
      'Връзката с настолната телефония е прекъсната. Обърнете се към вашия администратор.',
    clear: 'Изчистване на въведеното',
    rememberMeCheckBoxMessage: "Не показвай това повече",
    saveLabel: 'Запаметяване',
    browserUnsupportedError: "Неуспешно влизане, защото използвате неподдържан браузър.",
    microphoneAccessDeniedError: "Достъпът до микрофона е отказан. Разрешете достъпа чрез настройките на браузъра или се обърнете към вашия администратор.",
  },
  contactHistory: {
    mainHeader: 'Хронология на контакта',
    handledBy: 'Обработено от',
    noRecordFound: 'Не е намерена хронология на контакта!',
    tryAgain: 'Нов опит',
    errorMsg: 'Невъзможно извличане на хронологията на контакта. Опитайте отново.',
    errorID: 'ИД на грешка',
    missingAni: 'Липсва ANI',
    timeIcon: 'Продължителност',
    taskHandled: 'Обработена задача',
    noHistoryNew: 'Няма хронология',
    noHistory: 'Няма хронология',
    viewTranscript: 'Преглед на имейл съобщение',
    transcriptFor: 'Преписи за',
    editBeforeCall: 'Редактиране преди повикване',
    clickToCall: 'Повикване с щракване',
    onAnActiveCallErrorMessage:
      'Не можете да инициирате ново повикване, тъй като вече сте в активно повикване.',
    receivedFrom: 'Контакт, получен от',
    initiatedTo: 'Контакт, иницииран от',
    wrapUpReason: 'Причина за приключване',
    startCallTelephony:
      'Щракнете върху връзката за телефонния номер, за да стартирате изходящо повикване.',
    contactHistoryList: 'Списък с хронология на контакта,',
    wrapUpCode: 'Код за приключване',
    agentName: 'Име на агента',
    entryPointName: 'Входна точка',
    acceptedTimeAndDate: 'Приети час и дата',
    duration: 'Времетраене',
    emailTranscript: 'Изпращане на преписа по имейл',
    clickToViewEmailTranscript: 'Щракнете, за да видите препис по имейл',
    listContainer: 'Списък с полета'
  },
  contactTranscript: {
    agent: 'Агент',
    entryPoint: 'Входна точка',
    date: 'Дата',
    subject: 'Тема',
    from: 'От',
    sent: 'Изпратен',
    to: 'До',
    back: 'Назад',
    errorTranscript: 'Възникна грешка при извличане на копия.',
    customer: 'Клиент',
    inboundErrorMessage: 'Неуспешно зареждане на имейл на клиент.',
    outboundErrorMessage: 'Неуспешно качване на отговора на агент'
  },
  popoverTitle: {
    callback: 'Назад повикване',
    outboundCall: 'Изходящо повикване',
    incomingCall: 'Предупредително повикване',
    progressiveCampaign: 'Повикване от кампания',
    courtesyCallback: 'Назад повикване за учтивост',
    chat: 'Входящ чат',
    incoming: 'Входящи',
    monitoringCall: 'Повикване за наблюдение'
  },
  connecting: 'Свързва се',
  initiating: 'Инициализиране',
  outbound: 'Изходящи',
  transfer: {
    title: 'Заявка за прехвърляне',
    heading: {
      chat: 'Изберете агента или опашката, към които искате да осъществите прехвърляне.',
      email: 'Изберете агента или опашката, към които искате да осъществите прехвърляне.',
      telephony:
        'Изберете агента или опашката, към които искате да осъществите прехвърляне.',
      noQueueTelephony:
        'Изберете агента или опашката, към които искате да осъществите прехвърляне.'
    },
    header: {
      chat: 'Изберете агента или опашката за прехвърляне на този контакт.',
      email: 'Изберете опашката за прехвърляне на този контакт.',
      telephony:
        'Изберете агента, опашката, номера за набиране или организацията за прехвърляне на този контакт.',
      noQueueTelephony:
        'Изберете агента, номер за набиране или организация за прехвърляне на този контакт.',
      noOrganizationTelephony:
        'Изберете агента, опашката или номера за набиране за прехвърляне на този контакт.',
      noQueueOrganizationTelephony:
        'Изберете агента или номер за набиране за прехвърляне на този контакт.'
    },
    queues: 'Опашка',
    agents: 'Агент',
    dialNumber: 'Номер за набиране',
    organization: 'Организация',
    placeholder: {
      Queues: 'Изберете от списъка с опашки',
      Agents: 'Изберете от списъка с агенти',
      DialNumber: 'Избор по име или номер',
      DialNumberOrEntryPoint: 'Избор по име/номер/входна точка',
      ChooseByNameOrNumber: 'Избор по име/номер',
      Organization: 'Търсене по име/роля/отдел/служебен телефон',
      WebexOrganization: 'Търсене по име или имейл адрес',
      DialNumberSearch: 'Търсене по име или номер'
    },
    type: 'Прехвърляне',
    cancel: 'Отказ',
    closeModal: 'Затваряне на модалния диалог',
    failureError: 'Неуспешно стартиране на заявката за прехвърляне. Опитайте отново.',
    entryPoint: 'Входна точка'
  },
  consult: {
    title: 'Заявка за консултация',
    heading: {
      chat: 'Изберете агента или опашката, към които искате да осъществите прехвърляне.',
      email: 'Изберете агента или опашката, към които искате да осъществите прехвърляне.',
      telephony:
        'Изберете агента или опашката, с които искате да се консултирате.',
      noQueueTelephony:
        'Изберете агента или опашката, с които искате да се консултирате.'
    },
    header: {
      chat: 'Изберете агента или опашката за прехвърляне на този контакт.',
      email: 'Изберете опашката за прехвърляне на този контакт.',
      telephony:
        'Изберете агента, опашката, номера за набиране или организацията, с които искате да се консултирате.',
      noQueueTelephony:
        'Изберете агента, номер за набиране или организация, с която искате да се консултирате.',
      noOrganizationTelephony:
        'Изберете агента, опашката или номера за набиране, с които искате да се консултирате.',
      noQueueOrganizationTelephony:
        'Изберете агента или номер за набиране, с които искате да се консултирате.'
    },
    queues: 'Опашка',
    agents: 'Агент',
    dialNumber: 'Номер за набиране',
    organization: 'Организация',
    placeholder: {
      Queues: 'Изберете от списъка с опашки',
      Agents: 'Изберете от списъка с агенти',
      DialNumber: 'Избор по име или номер',
      DialNumberOrEntryPoint: 'Избор по име/номер/входна точка',
      ChooseByNameOrNumber: 'Избор по име/номер',
      Organization: 'Търсене по име/роля/отдел/служебен телефон',
      WebexOrganization: 'Търсене по име или имейл адрес',
      DialNumberSearch: 'Търсене по име или номер'
    },
    type: 'Консултативен разговор',
    checkBoxLabel: 'Позволете на участниците да продължат да си взаимодействат.',
    cancel: 'Отказ',
    closeModal: 'Затваряне на модалния диалог',
    failureError: 'Не може да се свърже искането за консултация. Опитайте отново.',
    customerLeftMsg: 'Клиентът е прекъснат. Консултацията вече не е необходима.',
    ctqFailureMsg:
      'Невъзможно прекратяване на консултативно повикване с връщане към опашката. Опитайте отново.',
    cancelCtqInfo:
      'Търсене на достъпен агент в избраната опашка. Изчакайте или прекратете заявката за консултация.',
    cancelCtqAction: 'Прекратяване на консултация',
    entryPoint: 'Входна точка'
  },
  conference: {
    title: 'Заявка за конференция',
    heading: {
      chat: 'Изберете определен агент за конферентен разговор'
    },
    queues: 'Опашка',
    agents: 'Агент',
    dialNumber: 'Номер за набиране',
    organization: 'Организация',
    placeholder: {
      Queues: 'Изберете от списъка с опашки',
      Agents: 'Изберете от списъка с агенти',
      DialNumber: 'Избор по име или номер'
    },
    type: 'Конференция',
    cancel: 'Отказ',
    closeModal: 'Затваряне на модалния диалог',
    failureError: 'Неуспешно стартиране на тази заявка за конференция. Опитайте отново.'
  },
  transferModal: {
    Agents: 'Извличането на списъка на агентите е невъзможно. Опреснете списъка.',
    AgentsEmpty: 'Няма достъпен агент',
    Queues: 'Извличането на списъка от опашки е невъзможно. Опреснете списъка.',
    QueuesEmpty: 'Няма достъпна опашка',
    EPEmpty: 'Няма достъпна входна точка',
    DialNumber:
      'Извличането на списъка от набрани номера от адресната книга е невъзможно. Опреснете списъка.',
    EntryPoint:
      'Списъкът с номера на входни точки не може да се извлече. Опреснете списъка.',
    Common: 'Списъкът не може да се извлече. Опреснете списъка.',
    DialNumberEmpty: 'Няма достъпен номер за набиране',
    DialNumbInvalid:
      'Номерът за набиране е невалиден. Свържете се с администратора.',
    DialNumbOrEntryPointInvalid:
      'Невалиден номер за набиране/входна точка. Свържете се с администратора.',
    refreshQueueList: 'Опресняване на списъка с опашки',
    refreshAgentList: 'Опресняване на списъка с агенти',
    refreshEpList: 'Опресняване на входните точки',
    refreshAddressBook: 'Опресняване на адресната книга',
    refreshTheList: 'Опресняване на списъка',
    entryPointSectionLabel: 'Входна точка',
    addressBookSectionLabel: 'Адресна книга',
    organization: 'Организация',
    comboBoxAriaLabelAgent: 'Изберете от списъка с агенти',
    comboBoxAriaLabelQueue: 'Изберете от списъка с опашки',
    comboBoxAriaLabelEp: 'Изберете от списъка с входни точки',
    infScrollAgent: 'Търсене на агенти',
    infScrollQueue: 'Опашки за търсене',
    infScrollEP: 'Търсене на входни точки',
    allRadioButtonHidedTextForConsult: 'Нямате назначени обекти, които да се консултират с това взаимодействие. Свържете се с администратора.',
    allRadioButtonHidedTextForTransfer: 'Нямате назначени входни точки, които да се прехвърлят с това взаимодействие. Свържете се с администратора.',
    allRadioButtonHidedTextForConference: 'Нямате назначени входни точки към конференции с това взаимодействие. Свържете се с администратора.',
    searchMinCharError: 'Въведете минимум три букви, за да търсите',
  },
  wrapup: {
    cancelautowrapup: 'Прекратяване на автоматичното приключване',
    wrapupreason: 'Причини за приключване',
    untilautowrapup: 'до автоматично приключване',
    followupsetting: 'Настройки за последващи действия',
    lastagentroute: 'Маршрутизиране към последния агент',
    submitwrapup: 'Подаване на приключване',
    wrapupsearch: 'Търсене на причина за приключване',
    invalidationError: 'Неуспешно изпращане на приключване',
    searchResult: 'Налични резултати от търсенето',
    noResultFound: 'Няма намерени резултати от търсене',
    listContainerLabel: 'Списък с обобщени контейнери',
    searchError: 'Въведете минимум три знака, за да потърсите причини за завършване.',
  },

  outdial: {
    call: 'Обади се',
    dialpadSearch: 'Въведете номер',
    addressSearch: 'Търсене по име/номер',
    addressTab: 'Адрес',
    addressTabTooltip: 'Търсене в адресната книга',
    dialpadTab: 'Клавиатура за набиране',
    dialpadTooltip: 'Набиране на номер',
    searchTab: 'Търсене',
    searchTabTooltip:'Търсене на хора в моята организация',
    noAdrFound: 'Няма намерени съвпадения',
    noContacts: 'Няма контакти',
    mainIconTooltip: 'Изходящи повиквания',
    errorOutdialFailed:
      'Неуспешно изходящо повикване. Работният плот не успя да свърже повикването или повикването не е получило отговор.',
    errorOutdialDisabled: 'Изходящите повиквания са деактивирани',
    errorDialPadValidationMessage: 'Неправилен формат',
    outdialReqInProgress: 'В ход е изходящо повикване',
    outdialAniPlaceholder: 'Изберете ANI за външно набиране',
    outdialAniLabel: 'ANI за набиране на външни номера',
    outdialAniPlaceHolder: 'Търсене на ANI за външно набиране',
    errorDcCallsLimitExceeded:
      'Центърът за данни е достигнал максималния лимит за изходящи повиквания. Не може да се извършват още изходящи повиквания',
    errorOrgCallsLimitExceeded:
      'Организацията е достигнала максималния лимит за повиквания към външни номера. Не може да се извършват още повиквания към външни номера.',
    errorOutDialNoAnswerFromCustomer:
      'Клиентът не отговори на повикването ви. Опитайте да се обадите по-късно.',
    errorOutDialCustomerUnavailable:
      'Клиентът в момента не е на разположение. Опитайте да се обадите по-късно.',
    errorOutDialAgentEnds: 'Приключихте разговора си с клиента.',
    errorOutDialCustomerBusy: 'Клиентът в момента е зает. Опитайте да се обадите по-късно.',
    searchError: 'Въведете минимум три знака, за да търсите в контактите.',
    upArrowLabel: 'Разгъване',
    clear: 'Изчистване на въведеното',
    outdialDialogDescription: 'В момента сте отворили диалога с разделите.'
  },

  organization: {
    noMatchFound: 'Няма намерени съвпадения',
    searchError: 'Въведете минимум три знака, за да търсите в контактите.',
    authError: 'Няма контакти за показване. Неуспешно удостоверяване от Microsoft.'
  },

  interactionPopover: {
    of: 'от',
    accept: 'Приеми',
    acceptAriaLabel: 'Приемане на задача {taskNumber} – {taskType} от {from}',
    requests: 'Заявки',
    back: 'назад',
    next: 'напред',
    acceptMultipleRequest: 'Приемане на заявки {requestCount}',
    paginationDetail: '{indexStart}-{indexEnd} от {totalPopoverpoolLength}',
    hidePopoverDetails: 'Скриване на подробности на изскачащ прозорец',
    showPopoverDetails: 'Показване на подробностите за изскачащ прозорец',
    customerName: 'Име на клиента',
    email: 'Имейл',
    queueName: 'Име на опашката',
    failedToAccept: 'Неуспешно приемане.',
    unableToAccept: 'Приемането на контакта е невъзможно.',
    failedToEnd: 'Неуспешно изпращане.',
    unableToEnd: 'Прекратяването на контакта е невъзможно. ',
    ringing: 'Звънене',
    calling: 'Повикване',
    phoneNumber: 'Телефонен номер',
    dni: 'DNIS',
    ivrPathId: 'ИД на път на IVR',
    pathId: 'ИД на път',
    rona: 'RONA',
    sourcePage: 'Страница на източника',
    sourceNumber: 'Номер на източника',
    appUserId: 'ИД на потребител на приложение',
    acceptAll: 'Приемане на всички задачи',
    agentDn: 'DN на агента',
    agentName: 'Име на служителя',
    agentTeam: 'Екип от агенти',
    requestDetails: 'Подробности за заявката',
    incomingCallFrom: 'Входящо повикване от',
    unableToAnswer: 'Неуспешно отговаряне на повикването. Опитайте отново.',
    unableToDecline: 'Неуспешно отказване на повикването. Опитайте отново.'
  },

  multiLogin: {
    header: 'Сигнал за няколко влизания',
    message:
      'Влезли сте в работен плот в множество екземпляри на приложението. Щракнете върху „Продължение“, за да продължите с този екземпляр на приложението. В противен случай затворете прозореца.',
    continue: 'Продълж.'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Прехвърлянето към входна точка/опашка е неуспешно поради грешка в конфигурацията.',
    1010: "Консултацията е невъзможна, тъй като агентът не може да разпределен навреме. ",
    1042: "Контактът не е намерен.",
    1043: 'Местоназначението е невалидно.',
    1045: 'Взаимодействието не се възлага на агента.',
    1046: 'Консултирането с агент е неуспешно, тъй като в системата не е намерен канал за съвпадение на агент.',
    1038: "Не е намерен агент",
    1037: 'Неуспешно влизане поради вътрешна грешка.',

    // Media Events
    138: 'Действието е неуспешно поради неизвестни причини.',
    136: 'Потребителят не е намерен',

    // AgentConsultFailed
    1050: 'Не може да се направи справка поради неподдържана конфигурация или активност в потока. ',
    1005: "Консултацията е невъзможна, тъй като агентът не отговори на заявката навреме.",
    1051: 'Не може да се извърши консултация или прехвърляне поради невалидна входна точка или номер за набиране.',

    // AgentInviteFailed
    1053: 'Взаимодействието не може да се представи поради чакаща задача за пренареждане на работен поток.',
    1054: 'Не може да се осъществи изходящо повикване поради проблеми с мултимедията с това искане. ',

    // AgentContactAssignFailed
    1011: 'Не може да се отговори или приеме повикването поради липсващи агенти в текущото взаимодействие. ',

    // ContactCallbackFailed
    1034: 'Неуспешно обратно повикване на контакта, тъй като за заявката е извечен ContactParkTimeout.',

    // ContactUpdateFailed
    1020: "Не може да се актуализират променливите, тъй като една от стойностите надвишава ограничението за знаци от 256. Намалете знаците и опитайте отново.",

    // AgentInviteFailed
    1031: 'Агентът е поканил клиента, след като е поискано обратното повикване.',

    // AgentBlindTransferFailedEvent
    1044: 'Неуспешно сляпо прехвърляне на агента, тъй като местоназначението на агента е присвоено на друго взаимодействие.',

    // AgentCtqCancelFailed
    1047: "Контактът не е намерен..",

    // AgentCtqFailed
    1048: "Групата за разпространение на повикванията не е конфигурирана.",
    1049: 'Максималното време за изчакване в опашката е надвишено.',
    // StationLoginFailed
    127: 'Неуспешна DN регистрация на агент с изключение за дублиране на влизането.'
  },

  stateSelector: {
    Available: 'Достъпен',
    errorstatechange: 'Неуспешно записване на промени. Опитайте отново.',
    errorStateChangeInPendingLogout: 'Неуспешна промяна на състоянието на агента поради изчакване на излизане.',
    label: 'Статус на достъпност',
    agentStateSelector: 'Инструмент за избор на състоянието на агента',
    Engaged: 'Ангажиран',
    engagedAvailableInfo:
      'В момента сте ангажиран(а) с взаимодействие и сте в Статус „Достъпен“.',
    engagedIdleInfo:
      'В момента сте ангажиран(а) с взаимодействие и сте в Статус „Свободен“',
    engagedInfo: 'В момента участвате във взаимодействие.',
    engagedSupervisorStateChange: 'промени състоянието ви на',
    axAgentStateChanged: 'Вашето състояние се промени на',
    axAgentSync: 'поради синхронизиране на състоянието с вашия инструмент за сътрудничество.',
    engagedPresenceInfo:
      'В момента участвате в това взаимодействие и състоянието ви е',
    engagedPresenceSync: 'поради синхронизиране на състоянието с вашия инструмент за сътрудничество.',
    clear: 'Изчистване на въведеното',
    searchState: 'въвеждане',
    agentStatusLabel: 'Състояние на агента',
    agentStateLabel: 'Агентът е в състояние на {selectedState} пред последния {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Агентът е в състояние {selectedState} поне за последните 0 секунди',
    agentStateChangeSuccessful:'Промяната в състоянието на {selectedState} е успешна.',
    agentStateChangeFail:'Промяната в състоянието на {selectedState} е неуспешна.',
    searchError: 'Въведете минимум три знака, за да потърсите състояние.'
  },

  warningMessage: {
    header: 'Незаписани промени',
    message:
      'Имате незаписани промени на тази страница. Сигурни ли сте, че искате да напуснете страницата? ',
    cancelButton: 'Оставам',
    saveButton: 'Напускам'
  },

  notificationLables: {
    muteVolume: 'Заглушаване на звука при уведомяване',
    unmuteVolume: 'Отмяна на заглушаването на звука при уведомяване',
    notificationVolume: 'Сила на звука при уведомяване',
    playSound: 'Възпроизвеждане на звук при уведомяване',
    enableSoundNotificationSettings: 'Активиране на звукови уведомявания',
    enableSoundNotificationSettingsDescription:
      'Издава звукови уведомявания за постъпващи заявки. Можете да регулирате силата на звука по-долу.',
    volumeTitle: 'Сила на звука'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Повикване',
    chat: 'Чат',
    email: 'Имейл',
    facebook: 'Messenger',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Бизнес съобщения на Google"
  },
  orgDetailsLabels: {
    role: 'Роля',
    department: 'Отдел',
    email: 'Имейл',
    businessPhone: 'Служебен телефон',
    workPhone: 'Служебен',
  },
  addressListError: {
    title: 'Неуспешно зареждане на данни',
    errorId: 'ИД на грешка:'
  },
  keypad: {
    keyPadSearch: 'Въведете номера за пренасочване',
    dialPad: 'Клавиатура за набиране'
  },
  collabTool: {
    userAuthenticated: 'Удостоверяване на потребител:',
    successful: 'Успешно',
    failed: 'Неуспешно.',
    tryAgain: 'Нов опит',
    stateSync: 'Синхронизиране на състоянието:',
    mercuryFailedInfo: ' Свържете се с вашия администратор.',
    retrying: 'Извършва се повторен опит...',
    trackingIdLabel: 'ИД за проследяване: '
  },
  webex: {
    webex: 'Webex',
    info: 'Интеграцията ви позволява да синхронизирате състоянията между работния плот и Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'С тази интеграция можете да се консултирате или да прехвърляте повиквания към потребителите на Microsoft Teams.',
    authenticationFailedInfo:
      'Ако вече е отворен прозорец за удостоверяване, опитайте отново удостоверяването там.',
    ListItemContactDetails:
      'Името на контакта е {name}, присъствието му е {presence}, отделът е {department}, длъжността е {jobTitle} и телефонният номер е {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Уведомяване на службите за спешна помощ',
    readNotification: 'Прочетох уведомяването.'
  },
  webexPresenceStatus: {
    active: 'Активно',
    lastActiveFewMinutesAgo: 'Активен през последните няколко минути',
    lastActiveMinutesAgo: 'Активен преди {min} минути',
    lastActive1HourAgo: 'Последна активност преди 1 час',
    lastActiveHoursAgo: 'Активен преди {hour} часа',
    lastActiveYesterday: 'Активен вчера',
    lastActiveOnDate: 'Активност на {date}',
    busy: 'Заето',
    busyUntil: 'Зает до {date}',
    dnd: 'НеМеБезпокой',
    dndUntil: 'Не ме безпокойте до {date}',
    quiet: 'Не е на разположение',
    quietUntil: 'Не е на разположение до {date}',
    ooo: 'Извън офиса',
    outOfOfficeUntil: 'Извън офиса до {date}',
    call: 'В момента разговаря',
    meeting: 'В среща',
    calendarItem: 'В планирана среща',
    presenting: 'Представяне',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Търсене по име или подробности за профила',
    webexPlaceholder: 'Търсене по име или имейл адрес',
    refreshTheList: 'Опресняване на списъка',
    refreshAddressBook: 'Опресняване на адресната книга',
    microsoftAuthError: 'Няма контакти за показване. Неуспешно удостоверяване от Microsoft.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/ca.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/ca.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'No s\'han pogut carregar les dades',
    errorID: 'ID d\'error',
    tryAgain: 'Torneu-ho a provar',
    Error: 'Error',
    okButton: 'D\'acord',
    Yes: 'SÍ',
    Cancel: 'Cancel·lar',
    Confirm: 'Confirmar',
    Continue: 'Contin.',
    Canceling: 'S\'està cancel·lant',
    CiscoAiAssistant: 'Assistent d\'IA de Cisco',
    Answer: 'Respondre',
    AnswerAriaLabel: 'Contestar la tasca d\'escriptori',
    Decline: 'Rebutjar',
    ErrorSecurityCompliance: 'Compliment de seguretat',
    errorDetails: 'Detalls de l\'error',
    learnMore: 'Més informació',
    showLess: 'Mostrar-ne menys',
    trackingIdDescription:
      'Compartiu l\'ID de seguiment amb l\'administrador del lloc o l\'equip de suport per investigar la situació.',
    trackingIdInputLabel: 'ID de seguiment: ',
    submitForm: 'Enviar formulari',
    unnamedStatus: 'Estat sense nom',
    errorChatMsg: 'No s\'han pogut carregar les dades del xat',
    noOptions: 'No hi ha opcions',
    noResults: 'Cap resultat',
    more: 'Més',
    nomatchfound: 'No s\'han trobat coincidències',
    collaborationTool: 'Eina de col·laboració',
    timerAriaLabel: 'Temps dedicat',
    historyItemTime: 'Es va produir a les',
    loading: 'S&apos;està carregant',
    months: [
      'Gener',
      'Febrer',
      'Març',
      'Abril',
      'Maig',
      'Juny',
      'Juliol',
      'Agost',
      'Setembre',
      'Octubre',
      'Novembre',
      'Desembre'
    ],
    loadingMsg: 'S\'està carregant...',
    search: 'Cercar',
    historyChannelLabels: {
      All: 'Tot',
      telephony: 'Veu',
      chat: 'Xat',
      email: 'Correu electrònic',
      social: 'Social'
    },
    homePageLabel: 'Pàgina d\'inici',
    resizeHistoryDragger: 'Canviar mida de l\'arrossegament de l\'historial',
    agentHistoryLabel: 'historial d\'agents',
    clear: 'Esborrar entrada',
    ariaLabelAgentHistoryWrapper:
      'L\'historial d\'interacció de l\'agent mostra les comunicacions dels clients recents a diferents canals de les últimes 24 hores',
    sliderResizerInstructions:
      'Esteu en un control lliscant. Per canviar la mida, utilitzeu les tecles de fletxa',
    resizeHistoryPanel: 'Canviar mida del tauler d\'historial, control lliscant,',
    time: {
      hours: 'hora',
      minutes: 'min',
      seconds: 's'
    }
  },
  email: {
    ToLabel: 'A',
    FromLabel: 'Des de',
    CcLabel: 'A/c',
    BccLabel: 'C/o:',
    SubjectLabel: 'Tema',
    HideLabel: 'Amagar',
    SendLabel: 'Enviar',
    ShowPrevThread: 'Mostrar el fil anterior',
    HidePrevThread: 'Amagar el fil anterior',
    ReplyLabel: 'Respondre',
    ReplyAllLabel: 'Respondre a tot',
    ViewOriginalMail: 'Veure el correu electrònic original',
    QuickReplyInp: 'Resposta ràpida aquí...',
    AttachFiles: 'Adjuntar fitxers',
    ToolbarHeading: 'Encapçalament1',
    ToolbarBold: 'Negreta',
    ToolbarItalic: 'Cursiva',
    ToolbarUnderLine: 'Subratllat',
    ToolbarBlockQuote: 'Bloquejar pressupost',
    ToolbarCode: 'Bloc del codi',
    ToolbarListOrder: 'Llista per ordre',
    ToolbarListBullet: 'Llista per vinyeta',
    ToolbarLink: 'Enllaç',
    ToolbarStrike: 'Ratllat',
    ToolbarColor: 'Color de text',
    ToolbarTable: 'Taula',
    insertTable: 'Inserir taula',
    insertRowAbove: 'Inserir fila a sobre',
    insertRowBelow: 'Inserir fila a sota',
    insertColumnLeft: 'Inserir columna esquerra',
    insertColumnRight: 'Inserir columna dreta',
    deleteRow: 'Eliminar fila',
    deleteColumn: 'Eliminar columna',
    deleteTable: 'Eliminar taula',
    link: 'Enllaç',
    IndentRight: 'Sagnia a la dreta',
    IndentLeft: 'Sagnia a l\'esquerra',
    showMoreAttachment: 'Mostrar més fitxers adjunts',
    AttachmentLimit: 'Adjuntar fins a ',
    attachments: ' fitxers adjunts, ',
    sizeLimit: ' Màxim de MB',
    attachment: 'Fitxer adjunt',
    errordeleteattachment: 'No s\'ha(n) pogut eliminar el(s) fitxer(s). Torneu-ho a provar.',
    errordownloadattachment: 'No s\'ha pogut baixar el(s) fitxer(s). Torneu-ho a provar.',
    erroraddattachemnt: 'No s\'ha(n) pogut carregar el(s) fitxer(s). Torneu-ho a provar.',
    errorendcontact: 'No s\'ha pogut finalitzar la interacció. Torneu-ho a provar.',
    erroraddlimitreached:
      'No s\'ha pogut adjuntar el fitxer perquè supera el màxim ',
    errorattachmentdrop:
      'El(s) fitxer(s) adjunt(s) s\'ha(n) eliminat d\'acord amb la política de seguretat de l\'empresa.',
    errorfiletype: 'No s\'admet el tipus de fitxer. Torneu-ho a provar.',
    errorcreditcard:
      'No s\'ha(n) pogut carregar el(s) fitxer(s) adjunt(s) d\'acord amb la política de seguretat de l\'empresa.',
    errorcontainsimage:
      'No s\'ha(n) pogut carregar el(s) fitxer(s) adjunt(s). Les imatges no s\'admeten, d\'acord amb la política de seguretat de l\'empresa.',
    errorlimit: ' Límit de MB.',
    errorsendemail: 'No s\'ha pogut enviar el correu electrònic. Torneu-ho a provar.',
    errorpcicheckemail: 'No es poden recuperar les dades de PCI. Torneu-ho a provar.',
    errortext: 'No s\'han pogut carregar les dades',
    tryAgain: 'Torneu-ho a provar',
    replywarning:
      'No compartiu informació financera, de salut o informació identificable personalment (PII) en aquest missatge o als fitxers adjunts.',
    datamasked:
      'El tema o el cos del correu electrònic s\'ha redactat d\'acord amb la política de seguretat de l\'empresa. Segur que voleu enviar el correu electrònic?',
    pcibannerwarning:
      'El tema o el cos del correu electrònic s\'ha redactat d\'acord amb la política de seguretat de l\'empresa.',
    on: 'Activat',
    wrote: 'va escriure'
  },
  interaction_control: {
    windowOpened: 'Finestra oberta',
    connected: 'Connectat',
    consultRequested: 'Consulta sol·licitada',
    consulting: 'S\'està consultant',
    consultCallOnHold: 'Consulta en espera',
    callOnHold: 'Trucada en espera',
    consult: 'Consultar',
    endconsult: 'Finalitzar consulta',
    hold: 'Espera',
    transfer: 'Transferir',
    conference: 'Conferència',
    endconference: 'Finalitzar la conferència',
    conferenceRequested: 'Conferència sol·licitada',
    switchCall: 'Canviar',
    mergeCall: 'Combinar',
    wrapup: 'Tancament',
    end: 'Finalitzar',
    customername: 'Nom del client',
    dn: 'DNIS',
    ivrpath: 'Ruta d\'IVR',
    email: 'Correu electrònic de client',
    ani: 'Número de telèfon',
    queueid: 'Nom de la cua',
    ronatimeout: 'Temps de RONA',
    pathid: 'ID de la ruta d\'IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'DN de l\'agent',
    destagentname: 'Nom de l\'agent',
    virtualteamname: 'Cua',
    category: 'Categoria',
    additionaldetails: 'Detalls addicionals',
    sourcenumber: 'Número d\'origen',
    sourcepage: 'Pàgina d\'origen',
    appuser: 'ID d\'usuari de l\'aplicació',
    customernumber: 'Número de telèfon',
    exitconference: 'Sortir de la conferència',
    resume: 'Continuar',
    pauserecording: 'Pausa de l\'enregistrament',
    resumerecording: 'Represa de l\'enregistrament',
    exitconsult: 'Sortit de la consulta',
    pauseRecordingFailed: 'No es pot posar l\'enregistrament en pausa. Torneu-ho a provar.',
    resumeRecordingFailed: 'No es pot reprendre l\'enregistrament. Torneu-ho a provar.',
    holdCallFailed: 'No es pot retenir la trucada. Torneu-ho a provar.',
    resumeCallFailed: 'No es pot reprendre la trucada. Torneu-ho a provar.',
    endCallFailed: 'No s\'ha pogut finalitzar la interacció. Torneu-ho a provar.',
    consultTransferFailed:
      'No es pot transferir la trucada de consulta. Torneu-ho a provar.',
    conferenceTransferFailed:
      'No es pot transferir la trucada de conferència. Torneu-ho a provar.',
    conferenceFailed:
      'No es pot connectar la sol·licitud de conferència. Torneu-ho a provar.',
    consultEndFailed: 'No es pot finalitzar la sol·licitud de consulta. Torneu-ho a provar.',
    conferenceExitFailed:
      'No es pot sortir de la sol·licitud de conferència. Torneu-ho a provar.',
    conferenceEndFailed:
      'No es pot finalitzar la sol·licitud de conferència. Torneu-ho a provar.',
    cancelCtqFailed:
      'No es pot cancel·lar la trucada de consulta a la cua. Torneu-ho a provar.',
    privacyShield: 'Escut de privadesa',
    errorOnPrvacyShieldForConsult:
      'L\'enregistrament està actualment en pausa. Repreneu l\'enregistrament per iniciar una trucada de consulta.',
    errorOnPrvacyShieldForTransfer:
      'L\'enregistrament està actualment en pausa. Repreneu l\'enregistrament per iniciar una trucada de transferència.',
    cancelConsult: 'Cancel·lar consulta',
    cancelTransfer: 'Cancel·lar transferència',
    copy: 'Copiar',
    copied: 'Copiat',
    cadrequestuccess: 'La informació del client s\'ha desat correctament.',
    cadrequestfailure: 'No s\'ha pogut desar la informació del client. Proveu-ho més tard.',
    cadupdatedmessage: 'La informació del client ha estat actualitzada correctament per',
    unsavedmessage: 'Els canvis sense desar se sobreescriuen.',
    save: 'Desar',
    revert: 'Revertir',
    expandDetails: 'Ampliar detalls',
    collapseDetails: 'Reduir detalls',
    cadValidationError:
      'El format no és vàlid. Utilitzeu l\'estàndard internacional per a la data i l\'hora.',
    secureCadSaveError:
      'No s\'ha desat la informació del client. Feu clic a Desar per tornar-ho a provar.',
    secureDecryptionError: 'No es poden mostrar variables segures.',
    clickToTry: 'Feu clic per tornar-ho a intentar',
    isSecureVariable: 'és una variable segura',
    contactorigin: 'Origen de contacte',
    resumeMonitoring: 'Reprendre la supervisió',
    pauseMonitoring: 'Pausar supervisió',
    whisperCoach: 'Orientació de xiuxiueig',
    bargeIn: 'Intervenir',
    endMonitoring: 'Finalitzar supervisió',
    contactphonenumber: 'Número de telèfon de contacte',
    contactqueue: 'Cua de contacte',
    activeparticipants: 'Participants actius',
    consultedparticipant: 'Participant consultat',
    contactstatus: 'Estat del contacte',
    timeincontactstatus: 'Temps en l\'estat del contacte',
    totalcontactduration: 'Durada total del contacte',
    agentinteractiontime: 'Durada de la interacció',
    recording: 'Enregistrament',
    monitoring: 'Supervisió',
    monitoringPaused: 'Supervisió en pausa',
    pauseMonitoringFailed: 'No es pot posar la supervisió en pausa. Torneu-ho a provar.',
    resumeMonitoringFailed: 'No es pot reprendre la supervisió. Torneu-ho a provar.',
    callCancelledInProgress: 'Cancel·lació de trucada en curs',
    bargedIn: 'Intervenció',
    keypad: 'Utilitzar el teclat',
    mute: 'Silenci',
    unmute: 'Activar so',
    bargeInTooltipText:
      'El micròfon s\'activarà i us unireu a la interacció amb aquest client.',
    bargeInCompactTooltipText:
      'Intervenció. El micròfon s\'activarà i us unireu a la interacció amb aquest client.',
    bargeInTooltipDisabled: 'Repreneu la supervisió per habilitar la intervenció',
    bargeInFailedTitle: 'Error en la intervenció',
    bargeInFailedData:
      'S\'ha produït un error en intentar fer una intervenció. Torneu-ho a provar més tard.',
    supervisorBargedIn: 's\'ha incorporat a la trucada.',
    leftInteraction: 'ha abandonat la interacció.',
    conferenceEnded: 'La trucada de conferència ha finalitzat.',
    participants: 'Participants',
    badgeAriaLabel: '{participant} és a la trucada',
    bargeInConferenceAriaLabel: 'Hi ha dos participants en la interacció',
    taskName: 'Nom de tasca de control d\'interacció',
    interactionDurationLabel: 'Durada',
    wrapupassist: 'Assistència de conclusió',
    consultingTaskContext: 'Trucada de consulta des de',
    consultExited: 'S\'ha sortit de la trucada de consulta',
    endCall: 'Finalitzeu la trucada.',
    exitconferenceCall:
      'Sortiu de la trucada i la conferència continuarà amb els participants actius.',
    recordingInProgess: 'Enregistrament en curs',
    recordingPaused: 'Enregistrament en pausa',
    searchPlaceholder: 'Cercar contactes',
    postCall: "Després de la trucada",
    switchCallTooltip: "Canviar a la trucada",
    switchConsultTooltip: "Canviar a la trucada de consulta",
    switchConferenceTooltip: "Canviar a la trucada de conferència",
    confirmationDialog: {
      endCallTitle: 'Voleu finalitzar la trucada?',
      endCallMessage: 'Feu clic a Confirmar per finalitzar la trucada de tots els participants.',
      exitConferenceTitle: 'Voleu sortir de la trucada de conferència?',
      exitConferenceMessage:
        'Feu clic a Confirmar per sortir de la trucada de conferència i permetre que continuïn els altres participants.',
      confirmButtonLabel: "Confirmar",
      cancelButtonLabel: "Cancel·lar",  
    },
    postCallOnHold: "Posterior a la trucada en espera",
    postCallConsult: "Consulta posterior a la trucada",
    postCallConsultOnHold: "Consulta posterior a la trucada en espera",
  },
  agentProfile: {
    teamName: 'Equip',
    dialNumber: 'Número',
    phoneNumber: 'Número de telèfon',
    settings: 'Canviar la configuració',
    signOut: 'Tancar sessió',
    webRTCDisconnected: 'Advertiment de telefonia d\'escriptori desconnectada ',
    msAuthFailed: 'Error d\'autenticació de Microsoft',
    stateSyncFailed: 'La sincronització de l\'estat ha fallat',
    userProfileLabel: 'Perfil d\'usuari',
    ariaAgentprofile: 'Perfil de l\'agent',
    ChannelCapacity: 'Capacitat de canal',
    voice: 'Veu',
    chat: 'Xat',
    email: 'Correu electrònic',
    social: 'Social',
    channelCapacityTooltip: 'Feu clic per veure més',
    blendedRouting: 'Barreja',
    exclusiveRouting: 'Encaminament exclusiu',
    realtimeRouting: 'Encaminament barrejat en temps real',
    blendedRoutingTooltip: 'Gestionar diversos contactes als canals.',
    exclusiveRoutingTooltip: 'Gestionar només un contacte a la vegada.',
    realtimeRoutingTooltip: 'Gestionar un canal en temps real obligatori.',
    errorActiveContacts:
      'No podeu tancar la sessió perquè teniu converses actives. Completeu-les i torneu-ho a provar.',
    searchTeams: 'Cercar equips',
    changeTeamsConfirmHeader: 'Confirmació de canvi d\'equip',
    changeTeamsConfirmMessage: 'Segur que voleu canviar d\'equip?',
    changeTeamLabel: 'Canviar d\'equip',
    errorChangeTeams:
      'No podeu canviar l\'equip ara perquè tenis sol·licituds actives. Completeu-les i torneu-ho a provar.',
    saveTeamSelection: 'Desar la selecció d\'equip',
    userSettings: 'Configuració d\'usuari',
    resetLayout: 'Restablir tot el disseny de l\'escriptori',
    resetConfirmHeader: 'Confirmació de restabliment del disseny',
    resetConfirmMessage:
      'Segur que voleu restablir tot el disseny de l\'escriptori? <br/> L\'escriptori tornarà al disseny predeterminat.',
    downloadLogs: 'Baixar informe d\'errors',
    help: 'Ajuda',
    signoutConfirm: 'Segur que voleu tancar la sessió?',
    signoutConfirmHeader: 'Confirmació de tancament de la sessió',
    darkTheme: 'Canviar al mode fosc',
    newLook: 'Canviar a un aspecte nou',
    keyboardShortcuts: 'Dreceres de teclat',
    keyboardShortcutCombination: 'Control+Alt+F',
    errorReportCombination: 'Control+Maj+2',
    notificationSettings: 'Configuració de notificació',
    silentNotification: 'Notificació silenciosa',
    enableNotificationSettings: 'Activar notificacions',
    enableSilentNotificationSettings: 'Activar notificacions silencioses',
    suppressWebexCallingNotificationSettings: 'Amagar notificacions de Webex Calling',
    notificationSettingDescription:
      'Lliura notificacions, com ara missatges, avisos i canvis d\'estat.',
    silentNotificationDescription:
      'Apaga les alertes en pantalla. Podeu veure les notificacions al centre de notificacions.',
    suppressWebexCallingNotificationDescription: 
    'No mostrar notificacions de finestres emergents per a les trucades Webex entrants i contestar-les a través del centre de contacte de Webex.',
    arrowLabel: 'Tornar',
    managedTeams: 'Equips gestionats',
    managedTeamsError: 'No s\'han pogut carregar els equips.',
    viewAll: 'Veure-ho tot',
    profileSettings: 'Configuració del perfil',
    userRole: 'Funció',
    saveSelection: 'Desar la selecció',
    extension: 'Extensió',
    changeProfileConfirmHeader: 'Confirmar els canvis de configuració del perfil',
    changeProfileConfirmMessage:
      'Esteu segur que voleu desar els canvis del perfil?',
    confirm: 'Confirmar',
    errorProfileUpdate:
      'No podeu canviar la configuració del perfil ara perquè teniu sol·licituds actives. Completeu-les i torneu-ho a provar.',
    roleAgentSupervisor: 'Supervisor i agent',
    roleSupervisor: 'Supervisor',
    noTeam: 'Sense equip',
    testYourNetwork: 'Comprovar la xarxa',
    speakerAndMic: 'Altaveu i micròfon',
    speaker: 'Altaveu',
    mic: 'Micròfon',
    speakerDescription:
      'Escolliu i proveu el dispositiu de sortida per assegurar-vos que escolteu l\'autor de la trucada.',
    micDescription:
      'Escolliu i proveu el dispositiu d\'entrada per assegurar-vos que l\'autor de la trucada us escolta.',
    micError:
      'S\'ha denegat l\'accés al micròfon. Activeu l\'accés a través de la configuració del navegador o contacteu amb el vostre administrador.',
    speakerError:
      'L\'altaveu no està disponible actualment perquè s\'ha denegat l\'accés al micròfon.',
    telephony: 'Telefonia',
    desktop: 'Escriptori',
    onSpeakerPlay:
      'Si no podeu escoltar el so de la prova, comproveu el dispositiu de l\'altaveu.',
    onMicPlay:
      'Si no podeu escoltar el so de la prova, comproveu tant l\'altaveu com el micròfon.',
    onMicRecord: 'Enregistreu un missatge per reproduir-lo.',
    test: 'Prova',
    recording: 'Enregistrament',
    playing: 'Reproduint',
    reconnecting: 'S\'està tornant a connectar',
    disconnectMessage:
      'Telefonia d\'escriptori desconnectada. Proveu amb una altra opció de telefonia.',
    singleTelephonyDisconnectMessage:
      'Telefonia d\'escriptori desconnectada. Poseu-vos en contacte amb l\'administrador.',
    clear: 'Esborrar entrada',
    rememberMeCheckBoxMessage: "No tornar-m\'ho a mostrar",
    saveLabel: 'Desar',
    browserUnsupportedError: "L\'inici de sessió ha fallat perquè esteu utilitzant un navegador no compatible.",
    microphoneAccessDeniedError: "S\'ha denegat l\'accés al micròfon. Activeu l\'accés a través de la configuració del navegador o contacteu amb el vostre administrador.",
  },
  contactHistory: {
    mainHeader: 'Historial de contactes',
    handledBy: 'Gestionat per',
    noRecordFound: 'No s\'ha trobat cap historial de contactes.',
    tryAgain: 'Torneu-ho a provar',
    errorMsg: 'No es pot carregar l\'historial de contactes. Torneu-ho a provar.',
    errorID: 'ID d\'error',
    missingAni: 'Falta ANI',
    timeIcon: 'Durada',
    taskHandled: 'Tasca gestionada',
    noHistoryNew: 'Sense historial',
    noHistory: 'Sense historial',
    viewTranscript: 'Veure missatge de correu electrònic',
    transcriptFor: 'Transcripcions per a',
    editBeforeCall: 'Editar abans de trucar',
    clickToCall: 'Fer clic per trucar',
    onAnActiveCallErrorMessage:
      'No podeu iniciar una trucada nova perquè ja esteu en una trucada activa.',
    receivedFrom: 'Contacte rebut de',
    initiatedTo: 'Contacte iniciat a les',
    wrapUpReason: 'Motiu de tancament',
    startCallTelephony:
      'Feu clic a l\'enllaç del número de telèfon per iniciar una trucada sortint.',
    contactHistoryList: 'Llista d\'historial de contactes',
    wrapUpCode: 'Codi de tancament',
    agentName: 'Nom de l\'agent',
    entryPointName: 'Punt d\'entrada',
    acceptedTimeAndDate: 'Data i hora d\'acceptació',
    duration: 'Durada',
    emailTranscript: 'Enviar la transcripció per correu electrònic',
    clickToViewEmailTranscript: 'Feu clic aquí per veure la transcripció de correu electrònic',
    listContainer: 'Contenidor de llistes'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Punt d\'entrada',
    date: 'Data',
    subject: 'Tema',
    from: 'Des de',
    sent: 'Enviat',
    to: 'A',
    back: 'Enrere',
    errorTranscript: 'S\'ha produït un error en recuperar les transcripcions',
    customer: 'Client',
    inboundErrorMessage: 'No s\'ha pogut carregar el correu electrònic del client',
    outboundErrorMessage: 'No s\'ha pogut carregar la resposta de l\'agent'
  },
  popoverTitle: {
    callback: 'Devolució de trucada',
    outboundCall: 'Trucada sortint',
    incomingCall: 'Trucada entrant',
    progressiveCampaign: 'Trucada de campanya',
    courtesyCallback: 'Dev. truc. cortesia',
    chat: 'Xat entrant',
    incoming: 'Entrant',
    monitoringCall: 'Trucada de supervisió'
  },
  connecting: 'Connectant',
  initiating: 'S\'està iniciant',
  outbound: 'Sortint',
  transfer: {
    title: 'Sol·licitud de transferència',
    heading: {
      chat: 'Seleccioneu l\'agent o la cua a la qual voleu transferir.',
      email: 'Seleccioneu la cua a la qual voleu transferir.',
      telephony:
        'Seleccioneu l\'agent, la cua o el número de marcatge al qual voleu transferir.',
      noQueueTelephony:
        'Seleccioneu l\'agent o el número de marcatge al qual voleu transferir.'
    },
    header: {
      chat: 'Seleccioneu l\'agent o una cua per transferir aquest contacte.',
      email: 'Seleccioneu la cua per transferir aquest contacte.',
      telephony:
        'Seleccioneu l\'agent, la cua, el número de marcatge o l\'organització per transferir aquest contacte.',
      noQueueTelephony:
        'Seleccioneu l\'agent, el número de marcatge o l\'organització per transferir aquest contacte.',
      noOrganizationTelephony:
        'Seleccioneu l\'agent, la cua o el número de marcatge per transferir aquest contacte.',
      noQueueOrganizationTelephony:
        'Seleccioneu l\'agent o el número de marcatge per transferir aquest contacte.'
    },
    queues: 'Cua',
    agents: 'Agent',
    dialNumber: 'Número',
    organization: 'Organització',
    placeholder: {
      Queues: 'Triar d\'una llista de cues',
      Agents: 'Triar d\'una llista d\'agents',
      DialNumber: 'Triar per nom o número',
      DialNumberOrEntryPoint: 'Triar per nom/número/punt d\'entrada',
      ChooseByNameOrNumber: 'Triar per nom/número',
      Organization: 'Cercar per nom/funció/departament/telèfon d\'empresa',
      WebexOrganization: 'Cercar per nom o correu electrònic',
      DialNumberSearch: 'Cercar per nom o número'
    },
    type: 'Transferir',
    cancel: 'Cancel·lar',
    closeModal: 'Tancar el mòdul',
    failureError: 'No s\'ha pogut iniciar la sol·licitud de transferència. Torneu-ho a provar.',
    entryPoint: 'Punt d\'entrada'
  },
  consult: {
    title: 'Sol·licitud de consulta',
    heading: {
      chat: 'Seleccioneu l\'agent o la cua a la qual voleu transferir.',
      email: 'Seleccioneu la cua a la qual voleu transferir.',
      telephony:
        'Seleccioneu l\'agent, la cua o el número de marcatge amb el qual voleu consultar.',
      noQueueTelephony:
        'Seleccioneu l\'agent o el número de marcatge amb el qual voleu consultar.'
    },
    header: {
      chat: 'Seleccioneu l\'agent o una cua per transferir aquest contacte.',
      email: 'Seleccioneu la cua per transferir aquest contacte.',
      telephony:
        'Seleccioneu l\'agent, la cua, el número de marcatge o l\'organització amb el qual voleu consultar.',
      noQueueTelephony:
        'Seleccioneu l\'agent, el número de marcatge o l\'organització amb el qual voleu consultar.',
      noOrganizationTelephony:
        'Seleccioneu l\'agent, la cua o el número de marcatge amb el qual voleu consultar.',
      noQueueOrganizationTelephony:
        'Seleccioneu l\'agent o el número de marcatge amb el qual voleu consultar.'
    },
    queues: 'Cua',
    agents: 'Agent',
    dialNumber: 'Número',
    organization: 'Organització',
    placeholder: {
      Queues: 'Triar d\'una llista de cues',
      Agents: 'Triar d\'una llista d\'agents',
      DialNumber: 'Triar per nom o número',
      DialNumberOrEntryPoint: 'Triar per nom/número/punt d\'entrada',
      ChooseByNameOrNumber: 'Triar per nom/número',
      Organization: 'Cercar per nom/funció/departament/telèfon d\'empresa',
      WebexOrganization: 'Cercar per nom o correu electrònic',
      DialNumberSearch: 'Cercar per nom o número'
    },
    type: 'Consultar',
    checkBoxLabel: 'Permeteu que els participants continuïn interactuant.',
    cancel: 'Cancel·lar',
    closeModal: 'Tancar el mòdul',
    failureError: 'No es pot connectar la sol·licitud de consulta. Torneu-ho a provar.',
    customerLeftMsg: 'Client desconnectat. La consulta ja no és necessària.',
    ctqFailureMsg:
      'No es pot cancel·lar la trucada de consulta a la cua. Torneu-ho a provar.',
    cancelCtqInfo:
      'S\'està cercant un agent disponible a la cua seleccionada. Espereu o cancel·leu aquesta sol·licitud de consulta.',
    cancelCtqAction: 'Cancel·lar consulta.',
    entryPoint: 'Punt d\'entrada'
  },
  conference: {
    title: 'Sol·licitud de conferència',
    heading: {
      chat: 'Seleccioneu un agent específic per al xat de conferència'
    },
    queues: 'Cua',
    agents: 'Agent',
    dialNumber: 'Número',
    organization: 'Organització',
    placeholder: {
      Queues: 'Triar d\'una llista de cues',
      Agents: 'Triar d\'una llista d\'agents',
      DialNumber: 'Triar per nom o número'
    },
    type: 'Conferència',
    cancel: 'Cancel·lar',
    closeModal: 'Tancar el mòdul',
    failureError: 'No es pot iniciar la sol·licitud de conferència. Torneu-ho a provar.'
  },
  transferModal: {
    Agents: 'No es pot recuperar la llista d\'agents. Actualitzeu la llista.',
    AgentsEmpty: 'No hi ha cap agent disponible',
    Queues: 'No es pot recuperar la llista de cues. Actualitzeu la llista.',
    QueuesEmpty: 'No hi ha cap cua disponible',
    EPEmpty: 'No hi ha cap punt d\'entrada disponible',
    DialNumber:
      'No es pot recuperar la llista de números de marcatge de la llibreta d\'adreces. Actualitzeu la llista.',
    EntryPoint:
      'No es pot recuperar la llista de números de punt d\'entrada. Actualitzeu la llista.',
    Common: 'No es pot recuperar la llista. Actualitzeu la llista.',
    DialNumberEmpty: 'No hi ha cap número de marcatge disponible',
    DialNumbInvalid:
      'El número de marcatge no és vàlid. Poseu-vos en contacte amb l\'administrador.',
    DialNumbOrEntryPointInvalid:
      'El número de marcatge/punt d\'entrada no és vàlid. Poseu-vos en contacte amb l\'administrador.',
    refreshQueueList: 'Actualitzar la llista de cues',
    refreshAgentList: 'Actualitzar la llista d\'agents',
    refreshEpList: 'Actualitzar els punts d\'entrada',
    refreshAddressBook: 'Actualitzar la llibreta d\'adreces',
    refreshTheList: 'Actualitzar la llista',
    entryPointSectionLabel: 'Punt d\'entrada',
    addressBookSectionLabel: 'Llibreta d\'adreces',
    organization: 'Organització',
    comboBoxAriaLabelAgent: 'Triar d\'una llista d\'agents',
    comboBoxAriaLabelQueue: 'Triar d\'una llista de cues',
    comboBoxAriaLabelEp: 'Escollir des d\'una llista de punts d\'entrada',
    infScrollAgent: 'Cercar agents',
    infScrollQueue: 'Cercar cues',
    infScrollEP: 'Cercar punts d\'entrada',
    allRadioButtonHidedTextForConsult: 'No teniu cap entitat assignada per consultar aquesta interacció. Poseu-vos en contacte amb l\'administrador.',
    allRadioButtonHidedTextForTransfer: 'No teniu cap entitat assignada per transferir aquesta interacció. Poseu-vos en contacte amb l\'administrador.',
    allRadioButtonHidedTextForConference: 'No teniu cap entitat assignada per fer una conferència d\'aquesta interacció. Poseu-vos en contacte amb l\'administrador.',
    searchMinCharError: 'Introduïu un mínim de tres caràcters per cercar.',
  },
  wrapup: {
    cancelautowrapup: 'Cancel·lar tancament automàtic',
    wrapupreason: 'Motius de tancament',
    untilautowrapup: 'fins al tancament automàtic',
    followupsetting: 'Configuració de seguiment',
    lastagentroute: 'Encaminament de l\'últim agent',
    submitwrapup: 'Enviar tancament',
    wrapupsearch: 'Cercar motiu de tancament',
    invalidationError: 'No s\'ha pogut enviar el tancament',
    searchResult: 'Resultats de la cerca disponibles',
    noResultFound: 'No s\'han trobat resultats de cerca',
    listContainerLabel: 'Contenidor de llista de tancament',
    searchError: 'Introduïu un mínim de tres caràcters per cercar motius de tancament.',
  },

  outdial: {
    call: 'Trucada',
    dialpadSearch: 'Intro. un núm. per marcar',
    addressSearch: 'Cercar per nom/número',
    addressTab: 'Adreça',
    addressTabTooltip: 'Cercar a la llibreta d\'adreces',
    dialpadTab: 'Teclat de marcatge',
    dialpadTooltip: 'Marcar un número',
    searchTab: 'Cerca',
    searchTabTooltip:'Cercar persones de la meva organització',
    noAdrFound: 'No s\'han trobat coincidències',
    noContacts: 'Cap contacte',
    mainIconTooltip: 'Trucada sortint',
    errorOutdialFailed:
      'Error de la trucada sortint. L\'escriptori no ha pogut connectar la trucada o la trucada no s\'ha respost.',
    errorOutdialDisabled: 'Les trucades sortints estan inhabilitades',
    errorDialPadValidationMessage: 'Format incorrecte',
    outdialReqInProgress: 'La trucada sortint està en curs',
    outdialAniPlaceholder: 'Seleccionar ANI de trucada sortint',
    outdialAniLabel: 'ANI de trucada sortint',
    outdialAniPlaceHolder: 'Cercar ANI de trucada sortint',
    errorDcCallsLimitExceeded:
      'El centre de dades ha assolit el límit màxim per a les trucades sortints. No es poden fer més trucades sortints',
    errorOrgCallsLimitExceeded:
      'L\'organització ha arribat al límit màxim per a les trucades sortints. No s\'han pogut fer més trucades sortints.',
    errorOutDialNoAnswerFromCustomer:
      'El client no ha respost a la vostra trucada. Proveu de trucar més tard.',
    errorOutDialCustomerUnavailable:
      'El client no està disponible en aquest moment. Proveu de trucar més tard.',
    errorOutDialAgentEnds: 'Heu acabat la trucada amb el client.',
    errorOutDialCustomerBusy: 'El client està ocupat en aquest moment. Proveu de trucar més tard.',
    searchError: 'Introduïu un mínim de tres caràcters per cercar els contactes.',
    upArrowLabel: 'Ampliar',
    clear: 'Esborrar entrada',
    outdialDialogDescription: 'Actualment esteu en el diàleg amb fitxes.'
  },

  organization: {
    noMatchFound: 'No s\'han trobat coincidències',
    searchError: 'Introduïu un mínim de tres caràcters per cercar els contactes.',
    authError: 'No hi ha contactes per mostrar. L\'autenticació de Microsoft ha fallat.'
  },

  interactionPopover: {
    of: 'de',
    accept: 'Accep.',
    acceptAriaLabel: 'Acceptar tasca {taskNumber} - {taskType} de {from}',
    requests: 'Sol·licitud(s)',
    back: 'enrere',
    next: 'següent',
    acceptMultipleRequest: 'Acceptar {requestCount} sol·licituds',
    paginationDetail: '{indexStart}-{indexEnd} de {totalPopoverpoolLength}',
    hidePopoverDetails: 'Amagar detalls emergents',
    showPopoverDetails: 'Mostrar detalls emergents',
    customerName: 'Nom del client',
    email: 'Correu electrònic',
    queueName: 'Nom de la cua',
    failedToAccept: 'No s\'ha pogut acceptar.',
    unableToAccept: 'No es pot acceptar el contacte.',
    failedToEnd: 'No s\'ha pogut finalitzar.',
    unableToEnd: 'No es pot finalitzar el contacte. ',
    ringing: 'Està sonant',
    calling: 'Trucant',
    phoneNumber: 'Número de telèfon',
    dni: 'DNIS',
    ivrPathId: 'ID de la ruta d\'IVR',
    pathId: 'ID de la ruta',
    rona: 'RONA (trucada sense resposta)',
    sourcePage: 'Pàgina d\'origen',
    sourceNumber: 'Número d\'origen',
    appUserId: 'ID d\'usuari de l\'aplicació',
    acceptAll: 'Acceptar totes les tasques',
    agentDn: 'DN de l\'agent',
    agentName: 'Nom de l\'agent',
    agentTeam: 'Equip de l\'agent',
    requestDetails: 'Detalls de la sol·licitud',
    incomingCallFrom: 'Trucada entrant de',
    unableToAnswer: 'No es pot respondre la trucada. Torneu-ho a provar.',
    unableToDecline: 'No es pot rebutjar la trucada. Torneu-ho a provar.'
  },

  multiLogin: {
    header: 'Alerta d\'inici de sessió múltiple',
    message:
      'Heu iniciat sessió a diverses finestres instàncies de l\'aplicació. Feu clic a Continuar per passar a l\'escriptori d\'aquesta instància de l\'aplicació. Sinó, tanqueu aquesta finestra.',
    continue: 'Contin.'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'No s\'ha pogut realitzar la transferència a un punt d\'entrada/una cua a causa d\'un error de configuració.',
    1010: "No s\'ha pogut consultar perquè l\'agent no s\'ha pogut assignar a temps. ",
    1042: "No es troba el contacte",
    1043: 'La destinació no és vàlida.',
    1045: 'La interacció no està assignada a l\'agent.',
    1046: 'La consulta de l\'agent ha fallat, perquè no s\'ha trobat cap canal d\'agent coincident al sistema.',
    1038: "No s\'ha trobat l\'agent",
    1037: 'L\'inici de sessió ha fallat a causa d\'un error intern.',

    // Media Events
    138: 'L\'acció ha fallat per causes desconegudes.',
    136: 'No es troba l\'usuari',

    // AgentConsultFailed
    1050: 'No es pot consultar a causa d\'una configuració o activitat no admesa al flux. ',
    1005: "No es pot consultar perquè l\'agent no ha respost la sol·licitud a temps.",
    1051: 'No es pot consultar o transferir perquè un punt d\'entrada o un número de marcació no són vàlids.',

    // AgentInviteFailed
    1053: 'No s\'ha pogut presentar la interacció a causa d\'una tasca pendent de tornar a posar en cua el flux de treball.',
    1054: 'No s\'ha pogut realitzar la trucada sortint a causa de problemes de mitjans amb aquesta sol·licitud. ',

    // AgentContactAssignFailed
    1011: 'No es pot respondre o acceptar la trucada perquè falten agents en la interacció en curs. ',

    // ContactCallbackFailed
    1034: 'La devolució de la trucada del contacte ha fallat perquè s\'ha rebut ContactParkTimeout per a la sol·licitud.',

    // ContactUpdateFailed
    1020: "No es poden actualitzar les variables perquè un dels valors excedeix el límit de 256 caràcters. Reduïu els caràcters i torneu-ho a intentar.",

    // AgentInviteFailed
    1031: 'L\'agent ha convidat al client després de la sol·licitud de la devolució de trucada.',

    // AgentBlindTransferFailedEvent
    1044: 'La transferència cega de l\'agent ha fallat perquè l\'agent de destinació està assignat a una altra interacció.',

    // AgentCtqCancelFailed
    1047: "No es troba el contacte.",

    // AgentCtqFailed
    1048: "El grup de distribució de trucades no està configurat.",
    1049: 'S\'ha excedit el temps d\'espera màxim en la cua.',
    // StationLoginFailed
    127: 'El registre de DN de l\'agent ha fallat amb l\'excepció d\'inici de sessió duplicat.'
  },

  stateSelector: {
    Available: 'Disponible',
    errorstatechange: 'El canvi d\'estat no ha estat correcte. Torneu-ho a provar.',
    errorStateChangeInPendingLogout: 'Error en canviar l\'estat d\'agent a causa d\'un tancament de sessió pendent.',
    label: 'Estat de disponibilitat',
    agentStateSelector: 'Selector d\'estat de l\'agent',
    Engaged: 'Compromès',
    engagedAvailableInfo:
      'Actualment esteu participant en una interacció i en l\'estat Disponible.',
    engagedIdleInfo:
      'Actualment esteu participant en una interacció i en l\'estat Inactiu.',
    engagedInfo: 'Esteu participant en una interacció.',
    engagedSupervisorStateChange: 'ha canviat el vostre estat a',
    axAgentStateChanged: 'El vostre estat ha canviat a',
    axAgentSync: 'a causa de la sincronització de l\'estat amb la vostra eina de col·laboració.',
    engagedPresenceInfo:
      'Actualment esteu participant en una interacció i el vostre estat és',
    engagedPresenceSync: 'a causa de la sincronització de l\'estat amb la vostra eina de col·laboració.',
    clear: 'Esborrar entrada',
    searchState: 'entrada',
    agentStatusLabel: 'Estat de l\'agent',
    agentStateLabel: 'L\'agent està en l\'estat {selectedState} per a l\'últim {selectedTimeValue}',
    agentStateLabelOnStateChange: 'L\'agent està en l\'estat {selectedState} per als últims 0 segons',
    agentStateChangeSuccessful:'Canvi d\'estat a {selectedState} correcte.',
    agentStateChangeFail:'Error de canvi d\'estat a {selectedState}.',
    searchError: 'Introduïu un mínim de tres caràcters per cercar estats.'
  },

  warningMessage: {
    header: 'Canvis sense desar',
    message:
      'Teniu canvis sense desar en aquesta pàgina. Segur que voleu sortir d\'aquesta pàgina? ',
    cancelButton: 'Quedar-s\'hi',
    saveButton: 'Sortir'
  },

  notificationLables: {
    muteVolume: 'Silenciar el volum de la notificació',
    unmuteVolume: 'Activar so del volum de la notificació',
    notificationVolume: 'Volum de la notificació',
    playSound: 'Reproduir el so de la notificació',
    enableSoundNotificationSettings: 'Activar sons de notificació',
    enableSoundNotificationSettingsDescription:
      'Proporciona notificacions de so per a sol·licituds entrants. Podeu ajustar el volum a continuació.',
    volumeTitle: 'Volum del so'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Trucada',
    chat: 'Xat',
    email: 'Correu electrònic',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google\'s Business Messages"
  },
  orgDetailsLabels: {
    role: 'Funció',
    department: 'Departament',
    email: 'Correu electrònic',
    businessPhone: 'Telèfon d\'empresa',
    workPhone: 'Treball',
  },
  addressListError: {
    title: 'No s\'han pogut carregar les dades',
    errorId: 'ID d\'error:'
  },
  keypad: {
    keyPadSearch: 'Introduïu el número',
    dialPad: 'Teclat de marcatge'
  },
  collabTool: {
    userAuthenticated: 'Autenticació d\'usuari:',
    successful: 'Correcte',
    failed: 'Error.',
    tryAgain: 'Torneu-ho a provar',
    stateSync: 'Sincronització d\'estat:',
    mercuryFailedInfo: ' Poseu-vos en contacte amb l\'administrador.',
    retrying: 'S\'està tornant a intentar...',
    trackingIdLabel: 'ID de seguiment: '
  },
  webex: {
    webex: 'Webex',
    info: 'La integració us permet sincronitzar estats entre escriptori i Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Amb aquesta integració podeu consultar o transferir trucades als usuaris de Microsoft Teams.',
    authenticationFailedInfo:
      'Si ja hi ha una finestra d\'autenticació oberta, torneu-ho a provar.',
    ListItemContactDetails:
      'El nom del contacte és: {name}, la seva presència és: {presence}, el departament és: {department}, el càrrec és: {jobTitle} i el número de telèfon és: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Notificació del servei d\'emergència',
    readNotification: 'He llegit la notificació.'
  },
  webexPresenceStatus: {
    active: 'Actiu',
    lastActiveFewMinutesAgo: 'Actiu en els últims minuts',
    lastActiveMinutesAgo: 'Actiu fa {min} minuts',
    lastActive1HourAgo: 'Última activitat fa 1 hora',
    lastActiveHoursAgo: 'Actiu fa {hour} hores',
    lastActiveYesterday: 'Actiu ahir',
    lastActiveOnDate: 'Actiu el {date}',
    busy: 'Ocupat',
    busyUntil: 'Ocupat fins al {date}',
    dnd: 'No molestar',
    dndUntil: 'No molesteu fins al {date}',
    quiet: 'Silenci',
    quietUntil: 'Silenci fins al {date}',
    ooo: 'Fora de l\'oficina',
    outOfOfficeUntil: 'Fora de l\'oficina fins el {date}',
    call: 'Al telèfon',
    meeting: 'En una reunió',
    calendarItem: 'En una reunió de calendari',
    presenting: 'Presentant',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Cercar per nom o detalls del perfil',
    webexPlaceholder: 'Cercar per nom o correu electrònic',
    refreshTheList: 'Actualitzar la llista',
    refreshAddressBook: 'Actualitzar la llibreta d\'adreces',
    microsoftAuthError: 'No hi ha contactes per mostrar. L\'autenticació de Microsoft ha fallat.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/cs.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/cs.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Nepodařilo se načíst data',
    errorID: 'ID chyby',
    tryAgain: 'Zkusit znovu',
    Error: 'Chyba',
    okButton: 'OK',
    Yes: 'Ano',
    Cancel: 'Zrušit',
    Confirm: 'Potvrdit',
    Continue: 'Pokračovat',
    Canceling: 'Rušení',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: 'Přijmout',
    AnswerAriaLabel: 'Přijmout úkol na ploše',
    Decline: 'Zamítnout',
    ErrorSecurityCompliance: 'Dodržování zabezpečení',
    errorDetails: 'Podrobnosti o chybě',
    learnMore: 'Další informace',
    showLess: 'Zobrazit méně',
    trackingIdDescription:
      'Toto ID sledování sdělte správci pracoviště nebo týmu podpory, který celou věc vyšetří.',
    trackingIdInputLabel: 'ID sledování: ',
    submitForm: 'Odeslat formulář',
    unnamedStatus: 'Stav bez jména',
    errorChatMsg: 'Nepodařilo se načíst data konverzace',
    noOptions: 'Žádné možnosti',
    noResults: 'Žádné výsledky',
    more: 'Více',
    nomatchfound: 'Nenalezeny žádné shody',
    collaborationTool: 'Nástroj pro spolupráci',
    timerAriaLabel: 'Strávená doba',
    historyItemTime: 'Stalo se v',
    loading: 'Načítání',
    months: [
      'Leden',
      'Únor',
      'Březen',
      'Duben',
      'Kvě',
      'Červen',
      'Červenec',
      'Srpen',
      'Září',
      'Říjen',
      'Listopad',
      'Prosinec'
    ],
    loadingMsg: 'Načítaní...',
    search: 'Hledat',
    historyChannelLabels: {
      All: 'Vše',
      telephony: 'Hlas',
      chat: 'Konverzace',
      email: 'E-mail',
      social: 'Sociální sítě'
    },
    homePageLabel: 'Domovská stránka',
    resizeHistoryDragger: 'Změna velikosti posuvníku historie',
    agentHistoryLabel: 'historie agenta',
    clear: 'Vymazat vstup',
    ariaLabelAgentHistoryWrapper:
      'Historie interakcí agenta zobrazuje vaši nedávnou komunikaci se zákazníky napříč různými kanály za posledních 24 hodin',
    sliderResizerInstructions:
      'Aktuálně jste na posuvníku. Změnu velikosti provedete pomocí kláves se šipkami.',
    resizeHistoryPanel: 'Změnit velikost panelu historie, posuvník,',
    time: {
      hours: 'hod.',
      minutes: 'min.',
      seconds: 's'
    }
  },
  email: {
    ToLabel: 'Do',
    FromLabel: 'Od',
    CcLabel: 'Kopie',
    BccLabel: 'Skrytá kopie',
    SubjectLabel: 'Předmět',
    HideLabel: 'Skrýt',
    SendLabel: 'Odeslat',
    ShowPrevThread: 'Zobrazit předchozí vlákno',
    HidePrevThread: 'Skrýt předchozí vlákno',
    ReplyLabel: 'Odpovědět',
    ReplyAllLabel: 'Odpovědět všem',
    ViewOriginalMail: 'Zobrazit originální e-mail',
    QuickReplyInp: 'Zde zadejte rychlou odpověď...',
    AttachFiles: 'Připojit soubory',
    ToolbarHeading: 'Nadpis1',
    ToolbarBold: 'Tučně',
    ToolbarItalic: 'Kurzíva',
    ToolbarUnderLine: 'Podtržení',
    ToolbarBlockQuote: 'Bloková citace',
    ToolbarCode: 'Blok kódu',
    ToolbarListOrder: 'Seznam – pořadí',
    ToolbarListBullet: 'Seznam – odrážky',
    ToolbarLink: 'Odkaz',
    ToolbarStrike: 'Přeškrtnutí',
    ToolbarColor: 'Barva textu',
    ToolbarTable: 'Tabulka',
    insertTable: 'Vložit tabulku',
    insertRowAbove: 'Vložit řádek nad',
    insertRowBelow: 'Vložit řádek pod',
    insertColumnLeft: 'Vložit sloupec vlevo',
    insertColumnRight: 'Vložit sloupec vpravo',
    deleteRow: 'Odstranit řádek',
    deleteColumn: 'Odstranit sloupec',
    deleteTable: 'Odstranit tabulku',
    link: 'Odkaz',
    IndentRight: 'Zarovnat vpravo',
    IndentLeft: 'Zarovnat vlevo',
    showMoreAttachment: 'Zobrazit další přílohy',
    AttachmentLimit: 'Připojte až ',
    attachments: ' příloh(y) ',
    sizeLimit: ' max. MB',
    attachment: 'Příloha',
    errordeleteattachment: 'Soubory se nepodařilo odstranit. Zkuste to znovu.',
    errordownloadattachment: 'Soubory se nepodařilo stáhnout. Zkuste to znovu.',
    erroraddattachemnt: 'Soubory se nepodařilo odeslat. Zkuste to znovu.',
    errorendcontact: 'Interakci se nepodařilo ukončit. Zkuste to znovu.',
    erroraddlimitreached:
      'Soubor nebylo možné přidat jako přílohu, protože překračuje max. ',
    errorattachmentdrop:
      'Přílohy byly zrušeny, protože porušují zásady zabezpečení společnosti.',
    errorfiletype: 'Tento typ souboru není podporován. Zkuste to znovu.',
    errorcreditcard:
      'Nepodařilo se nahrát přílohu, protože porušuje zásady zabezpečení společnosti.',
    errorcontainsimage:
      'Nepodařilo se nahrát přílohu. Obrázek v příloze není podporován kvůli porušení zásad zabezpečení společnosti.',
    errorlimit: ' max. MB.',
    errorsendemail: 'E-mail se nepodařilo odeslat. Zkuste to znovu.',
    errorpcicheckemail: 'Nepodařilo se načíst data PCI. Zkuste to znovu.',
    errortext: 'Nepodařilo se načíst data',
    tryAgain: 'Zkusit znovu',
    replywarning:
      'V této zprávě ani přílohách nesdílejte finanční, zdravotní nebo jiné informace umožňující zjištění totožnosti (PII).',
    datamasked:
      'Předmět nebo hlavní text e-mailu je skrytý na základě zásad zabezpečení společnosti. Opravdu chcete e-mail odeslat?',
    pcibannerwarning:
      'Předmět nebo hlavní text e-mailu je skrytý na základě zásad zabezpečení společnosti.',
    on: 'Zapnuto',
    wrote: 'napsal(a)'
  },
  interaction_control: {
    windowOpened: 'Okno otevřeno',
    connected: 'Připojeno',
    consultRequested: 'Požadována konzultace',
    consulting: 'Probíhá konzultace',
    consultCallOnHold: 'Konzultace pozastavena',
    callOnHold: 'Hovor pozastaven',
    consult: 'Konzultace',
    endconsult: 'Ukončit konzultaci',
    hold: 'Přidržet',
    transfer: 'Přepojit',
    conference: 'Konference',
    endconference: 'Ukončit konferenci',
    conferenceRequested: 'Zažádáno o konferenci',
    switchCall: 'Přepínač',
    mergeCall: 'Sloučit',
    wrapup: 'Shrnutí',
    end: 'Ukončit',
    customername: 'Jméno zákazníka',
    dn: 'DNIS',
    ivrpath: 'Cesta IVR',
    email: 'E-mail zákazníka',
    ani: 'Telefonní číslo',
    queueid: 'Název fronty',
    ronatimeout: 'Čas RONA',
    pathid: 'ID cesty IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'Číslo agenta v adresáři',
    destagentname: 'Jméno agenta',
    virtualteamname: 'Fronta',
    category: 'Kategorie',
    additionaldetails: 'Další podrobnosti',
    sourcenumber: 'Číslo zdroje',
    sourcepage: 'Stránka zdroje',
    appuser: 'ID uživatele aplikace',
    customernumber: 'Telefonní číslo',
    exitconference: 'Ukončit konferenci',
    resume: 'Pokračovat',
    pauserecording: 'Pozastavit záznam',
    resumerecording: 'Obnovit záznam',
    exitconsult: 'Ukončit konzultaci',
    pauseRecordingFailed: 'Nepodařilo se záznam pozastavit. Zkuste to znovu.',
    resumeRecordingFailed: 'Nepodařilo se záznam obnovit. Zkuste to znovu.',
    holdCallFailed: 'Volání se nepodařilo přidržet. Zkuste to znovu.',
    resumeCallFailed: 'Volání se nepodařilo obnovit. Zkuste to znovu.',
    endCallFailed: 'Interakci se nepodařilo ukončit. Zkuste to znovu.',
    consultTransferFailed:
      'Nelze přepojit konzultační volání. Zkuste to znovu.',
    conferenceTransferFailed:
      'Nepodařilo se přenést konferenční hovor. Zkuste to znovu.',
    conferenceFailed:
      'Žádost o konferenci nelze spojit. Zkuste to znovu.',
    consultEndFailed: 'Nelze ukončit žádost o konzultaci. Zkuste to znovu.',
    conferenceExitFailed:
      'Nelze ukončit žádost o konferenci. Zkuste to znovu.',
    conferenceEndFailed:
      'Nelze ukončit žádost o konferenci. Zkuste to znovu.',
    cancelCtqFailed:
      'Nepodařilo se zrušit konzultační hovor ve frontě. Zkuste to znovu.',
    privacyShield: 'Štít pro ochranu soukromí',
    errorOnPrvacyShieldForConsult:
      'Nahrávání je pozastaveno. Pro zahájení konzultačního hovoru pokračujte v nahrávání.',
    errorOnPrvacyShieldForTransfer:
      'Nahrávání je pozastaveno. Chcete-li zahájit přepojování hovoru, pokračujte v nahrávání.',
    cancelConsult: 'Zrušit konzultaci',
    cancelTransfer: 'Zrušení přenosu',
    copy: 'Kopírovat',
    copied: 'Zkopírováno',
    cadrequestuccess: 'Informace o zákazníkovi byly úspěšně uloženy.',
    cadrequestfailure: 'Informace o zákazníkovi se nepodařilo uložit. Zkuste to prosím později.',
    cadupdatedmessage: 'Informace o zákazníkovi byly před nedávnem aktualizovány uživatelem',
    unsavedmessage: 'Neuložené změny byly přepsány.',
    save: 'Uložit',
    revert: 'Návrat',
    expandDetails: 'Rozbalit podrobnosti',
    collapseDetails: 'Sbalit podrobnosti',
    cadValidationError:
      'Neplatný formát. Použijte mezinárodní standard pro datum a čas.',
    secureCadSaveError:
      'Informace o zákazníkovi nejsou uloženy. Kliknutím na Uložit opakujte akci.',
    secureDecryptionError: 'Zabezpečené proměnné nelze zobrazit.',
    clickToTry: 'Kliknutím akci opakujte',
    isSecureVariable: 'je zabezpečená proměnná',
    contactorigin: 'Původ kontaktu',
    resumeMonitoring: 'Pokračovat ve sledování',
    pauseMonitoring: 'Pozastavit sledování',
    whisperCoach: 'Stínový instruktor',
    bargeIn: 'Vynucený vstup',
    endMonitoring: 'Ukončit sledování',
    contactphonenumber: 'Telefonní číslo kontaktu',
    contactqueue: 'Fronta kontaktů',
    activeparticipants: 'Aktivní účastníci',
    consultedparticipant: 'Účastník, se kterým probíhala konzultace',
    contactstatus: 'Stav kontaktu',
    timeincontactstatus: 'Doba ve stavu kontaktu',
    totalcontactduration: 'Celková doba trvání kontaktu',
    agentinteractiontime: 'Doba trvání interakce',
    recording: 'Nahrávání',
    monitoring: 'Sledování',
    monitoringPaused: 'Sledování pozastaveno',
    pauseMonitoringFailed: 'Sledování nelze pozastavit. Zkuste to znovu',
    resumeMonitoringFailed: 'Nelze pokračovat ve sledování. Zkuste to znovu',
    callCancelledInProgress: 'Probíhá zrušení hovoru',
    bargedIn: 'Vstoupil/a',
    keypad: 'Číselník',
    mute: 'Ztlumit',
    unmute: 'Zrušit ztlumení',
    bargeInTooltipText:
      'Zapne se mikrofon a vy se připojíte k interakci se zákazníkem.',
    bargeInCompactTooltipText:
      'Vstoupit. Zapne se mikrofon a vy se připojíte k interakci se zákazníkem.',
    bargeInTooltipDisabled: 'Pokračujte ve sledování, abyste mohli vstoupit',
    bargeInFailedTitle: 'Vstup selhal',
    bargeInFailedData:
      'Při pokusu o vstup došlo k chybě. Zkuste to po nějaké době znovu.',
    supervisorBargedIn: 'vstoupil/a do vašeho hovoru.',
    leftInteraction: 'opustil/a interakci.',
    conferenceEnded: 'Konferenční hovor byl ukončen.',
    participants: 'Účastníci',
    badgeAriaLabel: '{participant} má hovor',
    bargeInConferenceAriaLabel: 'V interakci jsou dva účastníci',
    taskName: 'Název úlohy nastavení interakce',
    interactionDurationLabel: 'Doba trvání',
    wrapupassist: 'Asistence pro činnosti po hovoru',
    consultingTaskContext: 'Konzultační hovor od:',
    consultExited: 'Konzultační hovor byl ukončen',
    endCall: 'Ukončete hovor.',
    exitconferenceCall:
      'Opusťte hovor a konferenční hovor pokračuje za účasti aktivních účastníků.',
    recordingInProgess: 'Nahrávání probíhá',
    recordingPaused: 'Nahrávání pozastaveno',
    searchPlaceholder: 'Hledat kontakty',
    postCall: "Po skončení hovoru",
    switchCallTooltip: "Přepnout na hovor",
    switchConsultTooltip: "Přepnout na konzultační hovor",
    switchConferenceTooltip: "Přepnout na konferenční hovor",
    confirmationDialog: {
      endCallTitle: 'Chcete ukončit volání?',
      endCallMessage: 'Kliknutím na tlačítko Potvrdit ukončíte volání u všech účastníků.',
      exitConferenceTitle: 'Chcete ukončit konferenční hovor?',
      exitConferenceMessage:
        'Kliknutím na tlačítko Potvrdit ukončíte konferenční hovor a umožníte ostatním účastníkům pokračovat.',
      confirmButtonLabel: "Potvrdit",
      cancelButtonLabel: "Zrušit",  
    },
    postCallOnHold: "Činnost po hovoru, hovor přidržen",
    postCallConsult: "Konzultace po hovoru",
    postCallConsultOnHold: "Konzultace po hovoru, hovor přidržen",
  },
  agentProfile: {
    teamName: 'Tým',
    dialNumber: 'Vytáčené číslo',
    phoneNumber: 'Telefonní číslo',
    settings: 'Změnit nastavení',
    signOut: 'Odhlásit',
    webRTCDisconnected: 'Varování: Plocha telefonie byla odpojena ',
    msAuthFailed: 'Ověření společností Microsoft selhalo',
    stateSyncFailed: 'Synchronizace stavu se nezdařila',
    userProfileLabel: 'Profil uživatele',
    ariaAgentprofile: 'Profil agenta',
    ChannelCapacity: 'Kapacita kanálu',
    voice: 'Hlas',
    chat: 'Konverzace',
    email: 'E-mail',
    social: 'Sociální sítě',
    channelCapacityTooltip: 'Kliknutím zobrazíte více',
    blendedRouting: 'Kombinováno',
    exclusiveRouting: 'Exkluzivní směrování',
    realtimeRouting: 'Kombinované směrování v reálném čase',
    blendedRoutingTooltip: 'Zpracování několika kontaktů současně na všech kanálech.',
    exclusiveRoutingTooltip: 'Zpracování vždy pouze jednoho kontaktu.',
    realtimeRoutingTooltip: 'Zpracování jednoho vyžadovaného kanálu v reálném čase.',
    errorActiveContacts:
      'Není možné se odhlásit, protože máte aktivní konverzace. Dokončete je a zkuste to znovu.',
    searchTeams: 'Hledat týmy',
    changeTeamsConfirmHeader: 'Změnit potvrzení týmu',
    changeTeamsConfirmMessage: 'Opravdu chcete změnit váš tým?',
    changeTeamLabel: 'Změnit tým',
    errorChangeTeams:
      'Nemůžete teď změnit tým, protože máte aktivní žádost(i). Dokončete je prosím a pak to zkuste znovu.',
    saveTeamSelection: 'Uložit výběr týmu',
    userSettings: 'Uživatelská nastavení',
    resetLayout: 'Obnovit celé rozvržení plochy',
    resetConfirmHeader: 'Potvrzení obnovení rozvržení',
    resetConfirmMessage:
      'Opravdu chcete obnovit celé rozvržení plochy? <br/> Plocha bude navrácena do výchozího rozvržení.',
    downloadLogs: 'Stáhnout sestavu chyb',
    help: 'Nápověda',
    signoutConfirm: 'Opravdu se chcete odhlásit?',
    signoutConfirmHeader: 'Potvrzení odhlášení',
    darkTheme: 'Přepnout do tmavého režimu',
    newLook: 'Přepnout na Nový vzhled',
    keyboardShortcuts: 'Klávesové zkratky',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Nastavení oznámení',
    silentNotification: 'Tiché oznámení',
    enableNotificationSettings: 'Povolit oznámení',
    enableSilentNotificationSettings: 'Povolit tichá oznámení',
    suppressWebexCallingNotificationSettings: 'Skrýt oznámení služby Webex Calling',
    notificationSettingDescription:
      'Doručí oznámení například pro nové zprávy, výstrahy a změny stavu.',
    silentNotificationDescription:
      'Vypne výstrahy na obrazovce. Oznámení můžete zobrazit v centru oznámení.',
    suppressWebexCallingNotificationDescription: 
    'Nezobrazovat vyskakovací oznámení o příchozích voláních Webex a přijímat je prostřednictvím systému Webex Contact Center.',
    arrowLabel: 'Vrátit se zpět',
    managedTeams: 'Spravované týmy',
    managedTeamsError: 'Nepodařilo se načíst týmy.',
    viewAll: 'Zobrazit vše',
    profileSettings: 'Nastavení profilu',
    userRole: 'Role',
    saveSelection: 'Uložit výběr',
    extension: 'Linka',
    changeProfileConfirmHeader: 'Potvrďte změny nastavení profilu',
    changeProfileConfirmMessage:
      'Opravdu chcete uložit změny v profilu?',
    confirm: 'Potvrdit',
    errorProfileUpdate:
      'Teď nemůžete změnit nastavení profilu, protože máte aktivní žádost(i). Dokončete je prosím a pak to zkuste znovu.',
    roleAgentSupervisor: 'Supervizor a agent',
    roleSupervisor: 'Supervizor',
    noTeam: 'Žádný tým',
    testYourNetwork: 'Testování sítě',
    speakerAndMic: 'Reproduktor a mikrofon',
    speaker: 'Reproduktor',
    mic: 'Mikrofon',
    speakerDescription:
      'Vyberte a otestujte výstupní zařízení, abyste se ujistili, že volajícího slyšíte.',
    micDescription:
      'Vyberte a otestujte vstupní zařízení, abyste se ujistili, že vás volající slyší.',
    micError:
      'Přístup k mikrofonu je odepřen. Povolte přístup prostřednictvím nastavení prohlížeče nebo kontaktujte správce.',
    speakerError:
      'Reproduktor není momentálně dostupný, protože je odepřen přístup k mikrofonu.',
    telephony: 'Telefonie',
    desktop: 'Plocha',
    onSpeakerPlay:
      'Pokud neslyšíte testovací zvuk, zkontrolujte zařízení reproduktoru.',
    onMicPlay:
      'Pokud neslyšíte testovací zvuk, zkontrolujte reproduktor i mikrofon.',
    onMicRecord: 'Nahrajte zprávu pro přehrávání.',
    test: 'Test',
    recording: 'Nahrávání',
    playing: 'Přehrává se',
    reconnecting: 'Obnovování připojení',
    disconnectMessage:
      'Telefonie na ploše byla odpojena. Použijte jinou možnost telefonie.',
    singleTelephonyDisconnectMessage:
      'Telefonie na ploše byla odpojena. Obraťte se na správce.',
    clear: 'Vymazat vstup',
    rememberMeCheckBoxMessage: "Toto již nezobrazovat",
    saveLabel: 'Uložit',
    browserUnsupportedError: "Přihlášení se nezdařilo, protože používáte nepodporovaný prohlížeč.",
    microphoneAccessDeniedError: "Přístup k mikrofonu je odepřen. Povolte přístup prostřednictvím nastavení prohlížeče nebo kontaktujte správce.",
  },
  contactHistory: {
    mainHeader: 'Historie kontaktu',
    handledBy: 'Vyřízeno pomocí',
    noRecordFound: 'Nenalezena žádná historie kontaktu!',
    tryAgain: 'Zkusit znovu',
    errorMsg: 'Nepodařilo se načíst historii kontaktu. Zkuste to znovu.',
    errorID: 'ID chyby',
    missingAni: 'ANI chybí',
    timeIcon: 'Trvání',
    taskHandled: 'Úloha vyřízena',
    noHistoryNew: 'Žádná historie',
    noHistory: 'Žádná historie',
    viewTranscript: 'Zobrazit e-mailovou zprávu',
    transcriptFor: 'Přepisy pro',
    editBeforeCall: 'Upravit před hovorem',
    clickToCall: 'Zavolat kliknutím',
    onAnActiveCallErrorMessage:
      'Nemůžete zahájit nový hovor, protože jste již v aktivním hovoru.',
    receivedFrom: 'Kontakt přijat od',
    initiatedTo: 'Kontakt zahájen s',
    wrapUpReason: 'Důvod shrnutí',
    startCallTelephony:
      'Kliknutím na odkaz s telefonním číslem zahájíte odchozí volání.',
    contactHistoryList: 'Seznam historie kontaktu,',
    wrapUpCode: 'Kód shrnutí',
    agentName: 'Jméno agenta',
    entryPointName: 'Vstupní bod',
    acceptedTimeAndDate: 'Datum a čas přijetí',
    duration: 'Doba trvání',
    emailTranscript: 'Přepis e-mailu',
    clickToViewEmailTranscript: 'Kliknutím zobrazíte přepis e-mailu',
    listContainer: 'Kontejner seznamu'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Vstupní bod',
    date: 'Datum',
    subject: 'Předmět',
    from: 'Od',
    sent: 'Odesláno',
    to: 'Do',
    back: 'Zpět',
    errorTranscript: 'Při pokusu o načtení přepisů došlo k chybě',
    customer: 'Zákazník',
    inboundErrorMessage: 'Nepodařilo se načíst e-mail zákazníka',
    outboundErrorMessage: 'Nepodařilo se načíst odpověď agenta'
  },
  popoverTitle: {
    callback: 'Zavolat zpět',
    outboundCall: 'Odchozí volání',
    incomingCall: 'Příchozí hovor',
    progressiveCampaign: 'Hovor v rámci kampaně',
    courtesyCallback: 'Funkce Courtesy Callback',
    chat: 'Příchozí konverzace',
    incoming: 'Příchozí',
    monitoringCall: 'Sledovaný hovor'
  },
  connecting: 'Připojování',
  initiating: 'Zahajování',
  outbound: 'Odchozí',
  transfer: {
    title: 'Žádost o přepojení',
    heading: {
      chat: 'Vyberte agenta nebo frontu, na které chcete přepojit.',
      email: 'Vyberte frontu, na kterou chcete přepojit.',
      telephony:
        'Vyberte agenta, frontu nebo vytočte číslo, na které chcete přepojit.',
      noQueueTelephony:
        'Vyberte agenta nebo vytočte číslo, na které chcete přepojit.'
    },
    header: {
      chat: 'Vyberte agenta nebo frontu pro přepojení tohoto kontaktu.',
      email: 'Vyberte frontu pro přepojení tohoto kontaktu.',
      telephony:
        'Vyberte frontu, agenta, vytáčené číslo nebo organizaci pro přepojení tohoto kontaktu.',
      noQueueTelephony:
        'Vyberte agenta, vytáčené číslo nebo organizaci pro přepojení tohoto kontaktu.',
      noOrganizationTelephony:
        'Vyberte frontu, agenta nebo vytáčené číslo pro přepojení tohoto kontaktu.',
      noQueueOrganizationTelephony:
        'Vyberte agenta nebo vytáčené číslo pro přepojení tohoto kontaktu.'
    },
    queues: 'Fronta',
    agents: 'Agent',
    dialNumber: 'Vytáčené číslo',
    organization: 'Organizace',
    placeholder: {
      Queues: 'Vybrat ze seznamu front',
      Agents: 'Vybrat ze seznamu agentů',
      DialNumber: 'Zvolit podle jména nebo čísla',
      DialNumberOrEntryPoint: 'Výběr podle jména/čísla/vstupního bodu',
      ChooseByNameOrNumber: 'Zvolit podle jména/čísla',
      Organization: 'Vyhledávání podle jména/role/oddělení/pracovního telefonu',
      WebexOrganization: 'Vyhledávání podle jména nebo e-mailu',
      DialNumberSearch: 'Vyhledávání podle jména nebo čísla'
    },
    type: 'Přepojit',
    cancel: 'Zrušit',
    closeModal: 'Zavřít modul',
    failureError: 'Převedení tohoto požadavku se nezdařilo. Zkuste to znovu.',
    entryPoint: 'Vstupní bod'
  },
  consult: {
    title: 'Žádost o konzultaci',
    heading: {
      chat: 'Vyberte agenta nebo frontu, na které chcete přepojit.',
      email: 'Vyberte frontu, na kterou chcete přepojit.',
      telephony:
        'Vyberte agenta, frontu nebo vytočte číslo, které chcete použít ke konzultaci.',
      noQueueTelephony:
        'Vyberte agenta nebo vytočte číslo, které chcete použít ke konzultaci.'
    },
    header: {
      chat: 'Vyberte agenta nebo frontu pro přepojení tohoto kontaktu.',
      email: 'Vyberte frontu pro přepojení tohoto kontaktu.',
      telephony:
        'Vyberte agenta, frontu, vytáčené číslo nebo organizaci, se kterou chcete konzultovat.',
      noQueueTelephony:
        'Vyberte agenta, vytáčené číslo nebo organizaci, se kterou chcete konzultovat.',
      noOrganizationTelephony:
        'Vyberte agenta, frontu nebo vytáčené číslo, se kterým chcete konzultovat.',
      noQueueOrganizationTelephony:
        'Vyberte agenta nebo vytáčené číslo, se kterým chcete konzultovat.'
    },
    queues: 'Fronta',
    agents: 'Agent',
    dialNumber: 'Vytáčené číslo',
    organization: 'Organizace',
    placeholder: {
      Queues: 'Vybrat ze seznamu front',
      Agents: 'Vybrat ze seznamu agentů',
      DialNumber: 'Zvolit podle jména nebo čísla',
      DialNumberOrEntryPoint: 'Výběr podle jména/čísla/vstupního bodu',
      ChooseByNameOrNumber: 'Zvolit podle jména/čísla',
      Organization: 'Vyhledávání podle jména/role/oddělení/pracovního telefonu',
      WebexOrganization: 'Vyhledávání podle jména nebo e-mailu',
      DialNumberSearch: 'Vyhledávání podle jména nebo čísla'
    },
    type: 'Konzultace',
    checkBoxLabel: 'Umožněte účastníkům pokračovat v interakci.',
    cancel: 'Zrušit',
    closeModal: 'Zavřít modul',
    failureError: 'Žádost o konzultaci nelze spojit. Zkuste to znovu.',
    customerLeftMsg: 'Zákazník byl odpojen. konzultace již není zapotřebí.',
    ctqFailureMsg:
      'Nepodařilo se zrušit konzultační hovor ve frontě. Zkuste to znovu.',
    cancelCtqInfo:
      'Probíhá hledání dostupného agenta ve vybrané frontě. Čekejte nebo zrušte žádost o konzultaci.',
    cancelCtqAction: 'Zrušit konzultaci',
    entryPoint: 'Vstupní bod'
  },
  conference: {
    title: 'Žádost o konferenci',
    heading: {
      chat: 'Vyberte konkrétního agenta pro konferenční konverzaci'
    },
    queues: 'Fronta',
    agents: 'Agent',
    dialNumber: 'Vytáčené číslo',
    organization: 'Organizace',
    placeholder: {
      Queues: 'Vybrat ze seznamu front',
      Agents: 'Vybrat ze seznamu agentů',
      DialNumber: 'Zvolit podle jména nebo čísla'
    },
    type: 'Konference',
    cancel: 'Zrušit',
    closeModal: 'Zavřít modul',
    failureError: 'Nepodařilo se iniciovat tuto žádost o konferenci. Zkuste to znovu.'
  },
  transferModal: {
    Agents: 'Seznam agentů nelze načíst. Aktualizujte seznam.',
    AgentsEmpty: 'Žádný dostupný agent',
    Queues: 'Seznam front nelze načíst. Aktualizujte seznam.',
    QueuesEmpty: 'Žádná dostupná fronta',
    EPEmpty: 'Není k dispozici žádný vstupní bod',
    DialNumber:
      'Seznam vytáčených čísel z adresáře nelze načíst. Aktualizujte seznam.',
    EntryPoint:
      'Seznam čísel vstupních bodů nelze načíst. Obnovte seznam.',
    Common: 'Seznam nelze načíst. Obnovte seznam.',
    DialNumberEmpty: 'Žádné dostupné volací číslo',
    DialNumbInvalid:
      'Vytáčené číslo není platné. Obraťte se na správce.',
    DialNumbOrEntryPointInvalid:
      'Číslo vytáčení/vstupní bod je neplatný. Obraťte se na správce.',
    refreshQueueList: 'Aktualizovat seznam front',
    refreshAgentList: 'Aktualizovat seznam agentů',
    refreshEpList: 'Obnovit vstupní body',
    refreshAddressBook: 'Aktualizovat adresář',
    refreshTheList: 'Aktualizovat seznam',
    entryPointSectionLabel: 'Vstupní bod',
    addressBookSectionLabel: 'Adresář',
    organization: 'Organizace',
    comboBoxAriaLabelAgent: 'Vybrat ze seznamu agentů',
    comboBoxAriaLabelQueue: 'Vybrat ze seznamu front',
    comboBoxAriaLabelEp: 'K výběru použijte seznam vstupních bodů',
    infScrollAgent: 'Hledat agenty',
    infScrollQueue: 'Hledat fronty',
    infScrollEP: 'Hledat vstupní body',
    allRadioButtonHidedTextForConsult: 'Nemáte přiřazené žádné entity, které by tuto interakci konzultovaly. Obraťte se na správce.',
    allRadioButtonHidedTextForTransfer: 'Nemáte přiřazené žádné entity, které by tuto interakci přepojily. Obraťte se na správce.',
    allRadioButtonHidedTextForConference: 'Nemáte přiřazené žádné entity, které by tuto interakci přidaly do konference. Obraťte se na správce.',
    searchMinCharError: 'Pro vyhledávání zadejte minimálně tři znaky.',
  },
  wrapup: {
    cancelautowrapup: 'Zrušit automatické shrnutí',
    wrapupreason: 'Důvody shrnutí',
    untilautowrapup: 'do automatického shrnutí',
    followupsetting: 'Nastavení reakce',
    lastagentroute: 'Směrování na posledního agenta',
    submitwrapup: 'Odeslat shrnutí',
    wrapupsearch: 'Hledat důvod shrnutí',
    invalidationError: 'Shrnutí se nepodařilo odeslat',
    searchResult: 'Dostupné výsledky hledání',
    noResultFound: 'Nebyly nalezeny žádné výsledky hledání',
    listContainerLabel: 'Kontejner seznamu shrnutí',
    searchError: 'Př hledání důvodů pro shrnutí zadejte nejméně tři znaky.',
  },

  outdial: {
    call: 'Volat',
    dialpadSearch: 'Zadat číslo pro vytočení',
    addressSearch: 'Vyhledávání podle jména/čísla',
    addressTab: 'Adresa',
    addressTabTooltip: 'Hledat v adresáři',
    dialpadTab: 'Číselník',
    dialpadTooltip: 'Vytočit číslo',
    searchTab: 'Hledat',
    searchTabTooltip:'Hledat osoby v mé organizaci',
    noAdrFound: 'Nenalezeny žádné shody',
    noContacts: 'Žádné kontakty',
    mainIconTooltip: 'Vnější volání',
    errorOutdialFailed:
      'Vnější volání selhalo. Plocha nemohla hovor spojit nebo hovor nebyl přijat.',
    errorOutdialDisabled: 'Vnější volání jsou zakázaná',
    errorDialPadValidationMessage: 'Nesprávný formát',
    outdialReqInProgress: 'Probíhá vnější volání',
    outdialAniPlaceholder: 'Zvolte vnější volání ANI.',
    outdialAniLabel: 'ANI vnějšího volání',
    outdialAniPlaceHolder: 'Vyhledat ANI vnějšího volání',
    errorDcCallsLimitExceeded:
      'Datové centrum dosáhlo maximálního limitu pro vnější volání. Nelze uskutečnit další vnější volání',
    errorOrgCallsLimitExceeded:
      'Organizace dosáhla maximálního limitu pro vnější volání. Nelze provést žádné další vnější volání.',
    errorOutDialNoAnswerFromCustomer:
      'Zákazník váš hovor nepřijal. Zkuste zavolat později.',
    errorOutDialCustomerUnavailable:
      'Zákazník momentálně není dostupný. Zkuste zavolat později.',
    errorOutDialAgentEnds: 'Ukončili jste hovor se zákazníkem.',
    errorOutDialCustomerBusy: 'Zákazník je momentálně zaneprázdněn. Zkuste zavolat později.',
    searchError: 'Pro vyhledávání kontaktů zadejte minimálně tři znaky.',
    upArrowLabel: 'Rozbalit',
    clear: 'Vymazat vstup',
    outdialDialogDescription: 'Aktuálně jste v dialogovém okně s kartami.'
  },

  organization: {
    noMatchFound: 'Nenalezeny žádné shody',
    searchError: 'Pro vyhledávání kontaktů zadejte minimálně tři znaky.',
    authError: 'Žádné kontakty k zobrazení. Ověření Microsoftu se nezdařilo.'
  },

  interactionPopover: {
    of: 'z',
    accept: 'Přijmout',
    acceptAriaLabel: 'Přijmout úkol {taskNumber} – {taskType} od: {from}',
    requests: 'Požadavky',
    back: 'zpět',
    next: 'další',
    acceptMultipleRequest: 'Přijmout {requestCount} žádostí',
    paginationDetail: '{indexStart}-{indexEnd} z celkem {totalPopoverpoolLength}',
    hidePopoverDetails: 'Skrýt podrobnosti v místním okně',
    showPopoverDetails: 'Zobrazit podrobnosti v místním okně',
    customerName: 'Jméno zákazníka',
    email: 'E-mail',
    queueName: 'Název fronty',
    failedToAccept: 'Přijetí se nepodařilo.',
    unableToAccept: 'Kontakt nelze přijmout.',
    failedToEnd: 'Ukončení se nepodařilo.',
    unableToEnd: 'Kontakt nelze ukončit. ',
    ringing: 'Zvoní',
    calling: 'Volání',
    phoneNumber: 'Telefonní číslo',
    dni: 'DNIS',
    ivrPathId: 'ID cesty IVR',
    pathId: 'ID cesty',
    rona: 'RONA',
    sourcePage: 'Stránka zdroje',
    sourceNumber: 'Číslo zdroje',
    appUserId: 'ID uživatele aplikace',
    acceptAll: 'Přijmout všechny úkoly',
    agentDn: 'Číslo agenta v adresáři',
    agentName: 'Agent – Jméno',
    agentTeam: 'Tým agenta',
    requestDetails: 'Podrobnosti žádosti',
    incomingCallFrom: 'Příchozí hovor od',
    unableToAnswer: 'Volání nelze přijmout. Zkuste to znovu.',
    unableToDecline: 'Volání nelze odmítnout. Zkuste to znovu.'
  },

  multiLogin: {
    header: 'Upozornění na několikanásobné přihlášení',
    message:
      'K ploše jste přihlášeni z více instancí aplikace. Kliknutím na tlačítko Pokračovat budete pokračovat s plochou v této instanci aplikace. V opačném případě toto okno zavřete.',
    continue: 'Pokračovat'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Přenos do vstupního bodu/fronty selhal kvůli chybě konfigurace.',
    1010: "Nelze konzultovat, protože agent nemohl být přidělen včas. ",
    1042: "Kontakt nebyl nalezen",
    1043: 'Cíl je neplatný.',
    1045: 'Interakce není přiřazena agentovi.',
    1046: 'Konzultace agenta selhala, protože v systému nebyl nalezen žádný odpovídající kanál agenta.',
    1038: "Agent nebyl nalezen",
    1037: 'Přihlášení selhalo kvůli interní chybě.',

    // Media Events
    138: 'Akce selhala z neznámých důvodů.',
    136: 'Uživatel nebyl nalezen',

    // AgentConsultFailed
    1050: 'Nelze konzultovat z důvodu nepodporované konfigurace nebo aktivity v toku. ',
    1005: "Nelze konzultovat, protože agent neodpověděl na požadavek včas.",
    1051: 'Nelze konzultovat ani přepojit z důvodu neplatného vstupního bodu nebo vytáčeného čísla.',

    // AgentInviteFailed
    1053: 'Interakci nelze zobrazit z důvodu nevyřízené úlohy opětovného zařazení pracovního postupu do fronty.',
    1054: 'Nelze uskutečnit vnější volání z důvodu problémů s médii u tohoto požadavku. ',

    // AgentContactAssignFailed
    1011: 'Nelze přijmout hovor z důvodu chybějících agentů v probíhající interakci. ',

    // ContactCallbackFailed
    1034: 'Zpětné volání kontaktu selhalo, protože pro požadavek byla přijata odpověď ContactParkTimeout.',

    // ContactUpdateFailed
    1020: "Nelze aktualizovat proměnné, protože jedna z hodnot překročila limit 256 znaků. Zkraťte počet znaků a zkuste to znovu.",

    // AgentInviteFailed
    1031: 'Agent pozval zákazníka po vyžádání zpětného volání.',

    // AgentBlindTransferFailedEvent
    1044: 'Přepojení agenta naslepo selhalo, protože cílový agent je přiřazen k jiné interakci.',

    // AgentCtqCancelFailed
    1047: "Kontakt nebyl nalezen.",

    // AgentCtqFailed
    1048: "Skupina pro distribuci volání není nakonfigurována.",
    1049: 'Je překročena maximální doba čekání ve frontě.',
    // StationLoginFailed
    127: 'Registrace čísla v adresáři agenta selhala na základě výjimky duplicitního přihlášení.'
  },

  stateSelector: {
    Available: 'K dispozici',
    errorstatechange: 'Změna stavu nebyla úspěšná. Zkuste to znovu.',
    errorStateChangeInPendingLogout: 'Změna stavu agenta se nezdařila z důvodu čekajícího odhlášení.',
    label: 'Stav dostupnosti',
    agentStateSelector: 'Výběr stavu agenta',
    Engaged: 'Zapojený',
    engagedAvailableInfo:
      'V současné době jste zapojeni do interakce a nacházíte se ve stavu Dostupný.',
    engagedIdleInfo:
      'V současné době jste zapojeni do interakce a nacházíte se ve stavu Nečinný.',
    engagedInfo: 'Právě se účastníte interakce.',
    engagedSupervisorStateChange: 'změnil/a váš stav na',
    axAgentStateChanged: 'Váš stav se změnil na',
    axAgentSync: 'z důvodu synchronizace stavu s nástrojem pro spolupráci.',
    engagedPresenceInfo:
      'V současné době jste zapojeni do interakce a nacházíte se ve stavu',
    engagedPresenceSync: 'z důvodu synchronizace stavu s nástrojem pro spolupráci.',
    clear: 'Vymazat vstup',
    searchState: 'vstup',
    agentStatusLabel: 'Stav agenta',
    agentStateLabel: 'Agent je ve stavu {selectedState} po dobu: {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Agent je za posledních 0 sekund ve stavu {selectedState}',
    agentStateChangeSuccessful:'Změna stavu na {selectedState} proběhla úspěšně.',
    agentStateChangeFail:'Změna stavu na {selectedState} se nezdařila.',
    searchError: 'Pro vyhledávání stavů zadejte minimálně tři znaky.'
  },

  warningMessage: {
    header: 'Neuložené změny',
    message:
      'Na této stránce jsou neuložené změny. Opravdu chcete tuto stránku opustit? ',
    cancelButton: 'Zůstat',
    saveButton: 'Opustit'
  },

  notificationLables: {
    muteVolume: 'Ztlumení oznámení',
    unmuteVolume: 'Zrušit ztlumení oznámení',
    notificationVolume: 'Hlasitost oznámení',
    playSound: 'Přehrát zvuk oznámení',
    enableSoundNotificationSettings: 'Povolit zvuková oznámení',
    enableSoundNotificationSettingsDescription:
      'Přehraje zvuk při příchozím oznámení. Hlasitost můžete nastavit níže.',
    volumeTitle: 'Hlasitost zvuku'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Volat',
    chat: 'Konverzace',
    email: 'E-mail',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google Business Messages"
  },
  orgDetailsLabels: {
    role: 'Role',
    department: 'Oddělení',
    email: 'E-mail',
    businessPhone: 'Pracovní telefon',
    workPhone: 'Práce',
  },
  addressListError: {
    title: 'Nepodařilo se načíst data',
    errorId: 'ID chyby:'
  },
  keypad: {
    keyPadSearch: 'Zadejte číslo',
    dialPad: 'Číselník'
  },
  collabTool: {
    userAuthenticated: 'Ověření uživatele:',
    successful: 'Operace proběhla úspěšně',
    failed: 'Selhání.',
    tryAgain: 'Zkusit znovu',
    stateSync: 'Synchronizace stavu:',
    mercuryFailedInfo: ' Obraťte se na správce.',
    retrying: 'Probíhá další pokus...',
    trackingIdLabel: 'ID sledování: '
  },
  webex: {
    webex: 'Webex',
    info: 'Integrace umožňuje synchronizovat stavy mezi plochou a službou Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Pomocí této integrace můžete konzultovat nebo přepojovat hovory s uživateli Microsoft Teams.',
    authenticationFailedInfo:
      'Pokud je okno ověření již otevřeno, zkuste ověření provést znovu v tomto okně.',
    ListItemContactDetails:
      'Jméno kontaktu je: {name}, jeho přítomnost je: {presence}, oddělení je: {department}, název pracovní pozice je: {jobTitle} a telefonní číslo je: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Oznámení tísňové služby',
    readNotification: 'Oznámení jsem si přečetl/a.'
  },
  webexPresenceStatus: {
    active: 'Aktivní',
    lastActiveFewMinutesAgo: 'Aktivní během posledních několika minut',
    lastActiveMinutesAgo: 'Aktivní před {min} min.',
    lastActive1HourAgo: 'Poslední aktivita před 1 hod.',
    lastActiveHoursAgo: 'Aktivní před {hour} hod.',
    lastActiveYesterday: 'Aktivní včera',
    lastActiveOnDate: 'Aktivní {date}',
    busy: 'Zaneprázdněný',
    busyUntil: 'Zaneprázdněný do {date}',
    dnd: 'Nerušit',
    dndUntil: 'Nerušit do {date}',
    quiet: 'Tichý',
    quietUntil: 'Tichý do {date}',
    ooo: 'Mimo kancelář',
    outOfOfficeUntil: 'Mimo kancelář do {date}',
    call: 'Volá',
    meeting: 'Na schůzce',
    calendarItem: 'Na kalendářní schůzce',
    presenting: 'Prezentuje',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Hledat podle jména nebo podrobností profilu',
    webexPlaceholder: 'Vyhledávání podle jména nebo e-mailu',
    refreshTheList: 'Aktualizovat seznam',
    refreshAddressBook: 'Aktualizovat adresář',
    microsoftAuthError: 'Žádné kontakty k zobrazení. Ověření Microsoftu se nezdařilo.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/da.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/da.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Kunne ikke indlæse data',
    errorID: 'Fejl-id',
    tryAgain: 'Prøv igen',
    Error: 'Fejl',
    okButton: 'OK',
    Yes: 'Ja',
    Cancel: 'Annuller',
    Confirm: 'Bekræft',
    Continue: 'Fortsæt',
    Canceling: 'Annullerer',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: 'Svar',
    AnswerAriaLabel: 'Besvar desktop-opgave',
    Decline: 'Afvis',
    ErrorSecurityCompliance: 'Overholdelse af regler og standarder for sikkerhed',
    errorDetails: 'Fejloplysninger',
    learnMore: 'Få mere at vide',
    showLess: 'Vis mindre',
    trackingIdDescription:
      'Del sporings-id\'et med webstedsadministratoren eller supportteamet for at undersøge situationen.',
    trackingIdInputLabel: 'Sporings-id: ',
    submitForm: 'Send formular',
    unnamedStatus: 'Ikke-navngiven status',
    errorChatMsg: 'Kunne ikke indlæse chatdata',
    noOptions: 'Ingen indstillinger',
    noResults: 'Ingen resultater',
    more: 'Mere',
    nomatchfound: 'Ingen resultater blev fundet',
    collaborationTool: 'Samarbejdsværktøj',
    timerAriaLabel: 'Brugt tid',
    historyItemTime: 'Fandt sted i',
    loading: 'Indlæser',
    months: [
      'Januar',
      'Februar',
      'Marts',
      'April',
      'Maj',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'December'
    ],
    loadingMsg: 'Indlæser ..',
    search: 'Søg',
    historyChannelLabels: {
      All: 'Alle',
      telephony: 'Tale',
      chat: 'Chat',
      email: 'E-mail',
      social: 'Sociale medier'
    },
    homePageLabel: 'Startside',
    resizeHistoryDragger: 'Tilpas størrelse på historik-trækfunktion',
    agentHistoryLabel: 'agenthistorik',
    clear: 'Ryd input',
    ariaLabelAgentHistoryWrapper:
      'Agentinteraktionshistorik: Viser din seneste kundekommunikation på tværs af forskellige kanaler fra de seneste 24 timer',
    sliderResizerInstructions:
      'Du er i øjeblikket på en skyder. Brug piletasterne til at ændre størrelsen',
    resizeHistoryPanel: 'Panel til tilpasning af størrelsen på historik, skyder,',
    time: {
      hours: 'time',
      minutes: 'min.',
      seconds: 'sek.'
    }
  },
  email: {
    ToLabel: 'Til',
    FromLabel: 'Fra',
    CcLabel: 'Cc',
    BccLabel: 'Bcc',
    SubjectLabel: 'Emne',
    HideLabel: 'Skjul',
    SendLabel: 'Send',
    ShowPrevThread: 'Vis tidligere tråd',
    HidePrevThread: 'Skjul tidligere tråd',
    ReplyLabel: 'Svar',
    ReplyAllLabel: 'Svar alle',
    ViewOriginalMail: 'Vis oprindelig e-mail',
    QuickReplyInp: 'Hurtigt svar her....',
    AttachFiles: 'Vedhæft filer',
    ToolbarHeading: 'Overskrift1',
    ToolbarBold: 'Fed',
    ToolbarItalic: 'Kursiv',
    ToolbarUnderLine: 'Understreget',
    ToolbarBlockQuote: 'Blokcitat',
    ToolbarCode: 'Kodeblok',
    ToolbarListOrder: 'Vis sorteret',
    ToolbarListBullet: 'Vis efter punkttegn',
    ToolbarLink: 'Link',
    ToolbarStrike: 'Gennemstregning',
    ToolbarColor: 'Tekstfarve',
    ToolbarTable: 'Tabel',
    insertTable: 'Indsæt tabel',
    insertRowAbove: 'Indsæt række over',
    insertRowBelow: 'Indsæt række under',
    insertColumnLeft: 'Indsæt kolonne til venstre',
    insertColumnRight: 'Indsæt kolonne til højre',
    deleteRow: 'Slet række',
    deleteColumn: 'Slet kolonne',
    deleteTable: 'Slet tabel',
    link: 'Link',
    IndentRight: 'Indryk højre',
    IndentLeft: 'Indryk venstre',
    showMoreAttachment: 'Vis flere vedhæftede filer',
    AttachmentLimit: 'Vedhæft op til ',
    attachments: ' vedhæftede filer, ',
    sizeLimit: ' MB maks.',
    attachment: 'Vedhæftet fil',
    errordeleteattachment: 'Kunne ikke slette fil(er). Prøv igen.',
    errordownloadattachment: 'Kunne ikke downloade fil(er). Prøv igen.',
    erroraddattachemnt: 'Kunne ikke uploade fil(er). Prøv igen.',
    errorendcontact: 'Kunne ikke afslutte interaktionen. Prøv igen.',
    erroraddlimitreached:
      'Fil kunne ikke vedhæftes, fordi den overstiger maksimum ',
    errorattachmentdrop:
      'En eller flere vedhæftede filer blev droppet ifølge virksomhedens sikkerhedspolitik.',
    errorfiletype: 'Filtypen understøttes ikke. Prøv igen.',
    errorcreditcard:
      'Kunne ikke uploade den eller de vedhæftede filer, da den indeholder data, der overtræder virksomhedens sikkerhedspolitik.',
    errorcontainsimage:
      'Kunne ikke uploade den eller de vedhæftede filer, fordi de indeholder billeder, der ikke understøttes på grund af virksomhedens sikkerhedspolitik.',
    errorlimit: ' MB grænse.',
    errorsendemail: 'Kunne ikke sende e-mailen. Prøv igen.',
    errorpcicheckemail: 'Kunne ikke hente PCI-data. Prøv igen.',
    errortext: 'Kunne ikke indlæse data',
    tryAgain: 'Prøv igen',
    replywarning:
      'Del ikke økonomiske, sundhedsmæssige eller personligt identificerbare oplysninger (PII – Personally Identifiable Information) i denne meddelelse eller i vedhæftede filer.',
    datamasked:
      'E-mailens emne eller brødtekst redigeres ifølge virksomhedens sikkerhedspolitik. Er du sikker på, at du vil sende e-mailen?',
    pcibannerwarning:
      'E-mailens emne eller brødtekst redigeres ifølge virksomhedens sikkerhedspolitik.',
    on: 'Til',
    wrote: 'skrev'
  },
  interaction_control: {
    windowOpened: 'Vindue åbnet',
    connected: 'Forbundet',
    consultRequested: 'Rådgivning anmodet',
    consulting: 'Rådgivning',
    consultCallOnHold: 'Rådgivning i venteposition',
    callOnHold: 'Opkald i venteposition',
    consult: 'Konsulter',
    endconsult: 'Afslut rådgivning',
    hold: 'Park',
    transfer: 'Overfør',
    conference: 'Konference',
    endconference: 'Afslut konference',
    conferenceRequested: 'Konference anmodet',
    switchCall: 'Skift',
    mergeCall: 'Flet',
    wrapup: 'Afslut',
    end: 'Slut',
    customername: 'Kundenavn',
    dn: 'DNIS',
    ivrpath: 'IVR-sti',
    email: 'Kunde-e-mail',
    ani: 'Telefonnummer',
    queueid: 'Kønavn',
    ronatimeout: 'Rona-tid',
    pathid: 'IVR-sti-id',
    dnis: 'DNIS',
    destagentphonenumber: 'Agent-DN',
    destagentname: 'Agentnavn',
    virtualteamname: 'Kø',
    category: 'Kategori',
    additionaldetails: 'Yderligere detaljer',
    sourcenumber: 'Kildenummer',
    sourcepage: 'Kildeside',
    appuser: 'App-bruger-id',
    customernumber: 'Telefonnummer',
    exitconference: 'Afslut konference',
    resume: 'Genoptag',
    pauserecording: 'Sæt optagelse på pause',
    resumerecording: 'Fortsæt optagelse',
    exitconsult: 'Afslut rådgivning',
    pauseRecordingFailed: 'Kunne ikke sætte optagelse på pause. Prøv igen.',
    resumeRecordingFailed: 'Kunne ikke fortsætte optagelse på pause. Prøv igen.',
    holdCallFailed: 'Kunne ikke sætte opkald i venteposition. Prøv igen.',
    resumeCallFailed: 'Kunne ikke fortsætte opkaldet. Prøv igen.',
    endCallFailed: 'Kunne ikke afslutte interaktionen. Prøv igen.',
    consultTransferFailed:
      'Kunne ikke omstille rådgivningsopkaldet. Prøv igen.',
    conferenceTransferFailed:
      'Kunne ikke overføre konferenceopkaldet. Prøv igen.',
    conferenceFailed:
      'Kunne ikke oprette forbindelse til konferenceanmodningen. Prøv igen.',
    consultEndFailed: 'Kunne ikke afslutte rådgivningsanmodningen. Prøv igen.',
    conferenceExitFailed:
      'Kunne ikke afslutte konferenceanmodningen. Prøv igen.',
    conferenceEndFailed:
      'Kunne ikke afslutte konferenceanmodningen. Prøv igen.',
    cancelCtqFailed:
      'Kunne ikke annullere rådgivningsopkald til køen. Prøv igen.',
    privacyShield: 'Beskyttelsesfunktion',
    errorOnPrvacyShieldForConsult:
      'Optagelse er i øjeblikket sat på pause. Genoptag optagelse for at starte et rådgivningsopkald.',
    errorOnPrvacyShieldForTransfer:
      'Optagelse er i øjeblikket sat på pause. Genoptag optagelse for at starte et overførselsopkald.',
    cancelConsult: 'Annuller rådgivning',
    cancelTransfer: 'Annuller overførsel',
    copy: 'Kopier',
    copied: 'Kopieret',
    cadrequestuccess: 'Kundeoplysninger er blevet gemt.',
    cadrequestfailure: 'Kunne ikke gemme kundeoplysninger. Prøv igen senere.',
    cadupdatedmessage: 'Kundeoplysninger er blevet opdateret for nylig',
    unsavedmessage: 'Dine ugemte ændringer er blevet overskrevet.',
    save: 'Gem',
    revert: 'Returner',
    expandDetails: 'Udvid detaljer',
    collapseDetails: 'Skjul detaljer',
    cadValidationError:
      'Ugyldigt format. Brug den internationale standard for dato og tid.',
    secureCadSaveError:
      'Kundeoplysninger gemmes ikke. Klik på Gem for at prøve igen.',
    secureDecryptionError: 'Sikre variabler kan ikke vises.',
    clickToTry: 'Klik for at prøve igen',
    isSecureVariable: 'er en sikker variabel',
    contactorigin: 'Kontaktoprindelse',
    resumeMonitoring: 'Genoptag overvågning',
    pauseMonitoring: 'Sæt overvågning på pause',
    whisperCoach: 'Hviskecoach',
    bargeIn: 'Bryd ind',
    endMonitoring: 'Afslut overvågning',
    contactphonenumber: 'Kontakts telefonnummer',
    contactqueue: 'Kontaktkø',
    activeparticipants: 'Aktive deltagere',
    consultedparticipant: 'Rådgivende deltager',
    contactstatus: 'Kontaktstatus',
    timeincontactstatus: 'Tid i kontaktstatus',
    totalcontactduration: 'Samlet kontaktvar.',
    agentinteractiontime: 'Varighed af interaktion',
    recording: 'Optager',
    monitoring: 'Overvågning',
    monitoringPaused: 'Overvågning sat på pause',
    pauseMonitoringFailed: 'Kan ikke sætte overvågningen på pause. Prøv igen.',
    resumeMonitoringFailed: 'Kan ikke genoptage overvågningen. Prøv igen.',
    callCancelledInProgress: 'Annullering af opkald i gang',
    bargedIn: 'Brudt ind i',
    keypad: 'Tastatur',
    mute: 'Slå lyd fra',
    unmute: 'Slå lyd til',
    bargeInTooltipText:
      'Mikrofonen tændes, og du deltager i denne kundeinteraktion',
    bargeInCompactTooltipText:
      'Bryd ind. Mikrofonen tændes, og du deltager i denne kundeinteraktion',
    bargeInTooltipDisabled: 'Genoptag overvågning for at aktivere Bryd ind',
    bargeInFailedTitle: 'Bryd ind mislykkedes',
    bargeInFailedData:
      'Der opstod en fejl under forsøget på at bryde ind. Prøv igen efter et stykke tid.',
    supervisorBargedIn: 'er brudt ind i dit opkald.',
    leftInteraction: 'har forladt interaktionen.',
    conferenceEnded: 'Konferenceopkald er afsluttet.',
    participants: 'Deltagere',
    badgeAriaLabel: '{participant} er i gang med opkaldet',
    bargeInConferenceAriaLabel: 'Der er to deltagere i interaktionen',
    taskName: 'Opgavenavn for interaktionskontrol',
    interactionDurationLabel: 'Varighed',
    wrapupassist: 'Afslutningsassistance',
    consultingTaskContext: 'Konsulentopkald fra',
    consultExited: 'Konsultationsopkald afsluttet',
    endCall: 'Afslut opkaldet.',
    exitconferenceCall:
      'Afslut opkaldet, hvorefter konferencen fortsætter med de aktive deltagere.',
    recordingInProgess: 'Optagelse i gang',
    recordingPaused: 'Optagelse sat på pause',
    searchPlaceholder: 'Søg kontakter',
    postCall: "Efter opkald",
    switchCallTooltip: "Skift til opkald",
    switchConsultTooltip: "Skift til rådgivningsopkald",
    switchConferenceTooltip: "Skift til konferenceopkald",
    confirmationDialog: {
      endCallTitle: 'Vil du afslutte opkaldet?',
      endCallMessage: 'Klik på Bekræft for at afslutte opkaldet for alle deltagere.',
      exitConferenceTitle: 'Vil du afslutte konferenceopkaldet?',
      exitConferenceMessage:
        'Klik på Bekræft for at afslutte konferenceopkaldet og tillade de andre deltagere at fortsætte.',
      confirmButtonLabel: "Bekræft",
      cancelButtonLabel: "Annuller",  
    },
    postCallOnHold: "Aktiviteter efter opkald i venteposition",
    postCallConsult: "Konsultation efter opkald",
    postCallConsultOnHold: "Rådgivning efter opkald i venteposition",
  },
  agentProfile: {
    teamName: 'Team',
    dialNumber: 'Opkaldsnummer',
    phoneNumber: 'Telefonnummer',
    settings: 'Skift indstillinger',
    signOut: 'Log ud',
    webRTCDisconnected: 'Advarsel om, at Desktop-telefoni er afbrudt ',
    msAuthFailed: 'Microsoft-godkendelse mislykkedes',
    stateSyncFailed: 'Tilstandssynkronisering mislykkedes',
    userProfileLabel: 'Brugerprofil',
    ariaAgentprofile: 'Agentprofil',
    ChannelCapacity: 'Kanalkapacitet',
    voice: 'Tale',
    chat: 'Chat',
    email: 'E-mail',
    social: 'Sociale medier',
    channelCapacityTooltip: 'Klik for at se mere',
    blendedRouting: 'Blandet',
    exclusiveRouting: 'Eksklusiv distribution',
    realtimeRouting: 'Blandet distribution – realtid',
    blendedRoutingTooltip: 'Håndter flere kontakter på tværs af kanaler.',
    exclusiveRoutingTooltip: 'Håndter kun én kontakt ad gangen.',
    realtimeRoutingTooltip: 'Håndtér en obligatorisk realtidskanal.',
    errorActiveContacts:
      'Du kan ikke logge ud nu, fordi du har aktive samtaler. Afslut dem, og prøv igen.',
    searchTeams: 'Søg efter teams',
    changeTeamsConfirmHeader: 'Skift teambekræftelse',
    changeTeamsConfirmMessage: 'Er du sikker på, at du vil ændre dit team?',
    changeTeamLabel: 'Skift team',
    errorChangeTeams:
      'Du kan ikke ændre teamet nu, fordi du har en eller flere aktive anmodninger. Fuldfør dem, og prøv igen.',
    saveTeamSelection: 'Gem teamvalg',
    userSettings: 'Brugerindstillinger',
    resetLayout: 'Nulstil hele Desktop-layout',
    resetConfirmHeader: 'Bekræftelse af nulstilling af layout',
    resetConfirmMessage:
      'Er du sikker på at du vil nulstille hele Desktop-layoutet? <br/> Desktop går tilbage til standardlayoutet.',
    downloadLogs: 'Download fejlrapport',
    help: 'Hjælp',
    signoutConfirm: 'Er du sikker på, at du vil logge ud?',
    signoutConfirmHeader: 'Bekræftelse af udlogning',
    darkTheme: 'Skift til mørk tilstand',
    newLook: 'Skift til nyt udseende',
    keyboardShortcuts: 'Tastaturgenveje',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Skift+2',
    notificationSettings: 'Meddelelsesindstillinger',
    silentNotification: 'Lydløs meddelelse',
    enableNotificationSettings: 'Aktivér meddelelser',
    enableSilentNotificationSettings: 'Aktivér lydløse meddelelser',
    suppressWebexCallingNotificationSettings: 'Skjul Webex-opkaldsmeddelelser',
    notificationSettingDescription:
      'Leverer meddelelser såsom nye meddelelser, beskeder og statusændringer.',
    silentNotificationDescription:
      'Slår påmindelser på skærmen fra. Du kan få vist meddelelserne i meddelelsescentret.',
    suppressWebexCallingNotificationDescription: 
    'Vis ikke pop op-meddelelser for indgående Webex-opkald, og besvar dem gennem Webex Contact Center.',
    arrowLabel: 'Gå tilbage',
    managedTeams: 'Administrerede teams',
    managedTeamsError: 'Kunne ikke indlæse teams.',
    viewAll: 'Se alt',
    profileSettings: 'Profilindstillinger',
    userRole: 'Stilling',
    saveSelection: 'Gem valg',
    extension: 'Lokalnr.',
    changeProfileConfirmHeader: 'Bekræft ændringer af profilindstillinger',
    changeProfileConfirmMessage:
      'Er du sikker på, at du vil gemme dine profilændringer?',
    confirm: 'Bekræft',
    errorProfileUpdate:
      'Du kan ikke ændre profilindstillingerne nu, fordi du har flere aktive anmodninger. Fuldfør dem, og prøv igen.',
    roleAgentSupervisor: 'Supervisor og agent',
    roleSupervisor: 'Supervisor',
    noTeam: 'Intet team',
    testYourNetwork: 'Test dit netværk',
    speakerAndMic: 'Højttaler og mikrofon',
    speaker: 'Højttaler',
    mic: 'Mikrofon',
    speakerDescription:
      'Vælg og test udgangsenheden for at sikre, at du hører den person, der ringer op.',
    micDescription:
      'Vælg og test indgangsenheden for at sikre, at den person, der ringer op, hører dig.',
    micError:
      'Adgang til mikrofon er nægtet. Aktivér adgang via browserindstillinger, eller kontakt administratoren.',
    speakerError:
      'Højttaler er i øjeblikket ikke tilgængelig, da adgang til mikrofonen nægtes.',
    telephony: 'Telefoni',
    desktop: 'Desktop',
    onSpeakerPlay:
      'Hvis du ikke kan høre testlyden, skal du kontrollere højttalerenheden.',
    onMicPlay:
      'Hvis du ikke kan høre testlyden, skal du kontrollere både højttaleren og mikrofonen.',
    onMicRecord: 'Optag en meddelelse til afspilning.',
    test: 'Test',
    recording: 'Optager',
    playing: 'Afspiller',
    reconnecting: 'Opretter forbindelse igen',
    disconnectMessage:
      'Desktoptelefoni er afbrudt. Prøv en anden telefoniindstilling.',
    singleTelephonyDisconnectMessage:
      'Desktoptelefoni er afbrudt. Kontakt administratoren.',
    clear: 'Ryd input',
    rememberMeCheckBoxMessage: "Vis ikke dette igen",
    saveLabel: 'Gem',
    browserUnsupportedError: "Logon mislykkedes, fordi du bruger en browser, der ikke understøttes.",
    microphoneAccessDeniedError: "Adgang til mikrofon er nægtet. Aktivér adgang via browserindstillinger, eller kontakt administratoren.",
  },
  contactHistory: {
    mainHeader: 'Kontakthistorik',
    handledBy: 'Håndteret af',
    noRecordFound: 'Der blev ikke fundet nogen kontakthistorik!',
    tryAgain: 'Prøv igen',
    errorMsg: 'Kunne ikke indlæse kontakthistorikken. Prøv igen.',
    errorID: 'Fejl-id',
    missingAni: 'ANI mangler',
    timeIcon: 'Varighed',
    taskHandled: 'Opgave håndteret',
    noHistoryNew: 'Ingen historik',
    noHistory: 'Ingen historik',
    viewTranscript: 'Vis e-mailmeddelelse',
    transcriptFor: 'Udskrifter for',
    editBeforeCall: 'Rediger før opkald',
    clickToCall: 'Klik for at ringe op',
    onAnActiveCallErrorMessage:
      'Du kan ikke starte et nyt opkald, da du allerede er i gang med et aktivt opkald.',
    receivedFrom: 'Kontakt modtaget fra',
    initiatedTo: 'Kontakt startet til',
    wrapUpReason: 'Afslutningsårsag',
    startCallTelephony:
      'Klik på telefonnummerlinket for at starte et udgående opkald.',
    contactHistoryList: 'Kontakthistorikliste,',
    wrapUpCode: 'Kode for afslutning',
    agentName: 'Agentnavn',
    entryPointName: 'Indgangspunkt',
    acceptedTimeAndDate: 'Accepteret klokkeslæt og dato',
    duration: 'Varighed',
    emailTranscript: 'E-mailafskrift',
    clickToViewEmailTranscript: 'Klik for at se transskription af e-mail',
    listContainer: 'Anfør Container'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Indgangspunkt',
    date: 'Dato',
    subject: 'Emne',
    from: 'Fra',
    sent: 'Sendt',
    to: 'Til',
    back: 'Tilbage',
    errorTranscript: 'Der opstod en fejl under hentning af udskrifter',
    customer: 'Kunde',
    inboundErrorMessage: 'Kunne ikke indlæse kunde-e-mailen',
    outboundErrorMessage: 'Kunne ikke indlæse agentsvaret'
  },
  popoverTitle: {
    callback: 'Tilbagekald',
    outboundCall: 'Udgående opkald',
    incomingCall: 'Indgående opkald',
    progressiveCampaign: 'Kampagneopkald',
    courtesyCallback: 'Tilbagekald',
    chat: 'Indgående chat',
    incoming: 'Indgående',
    monitoringCall: 'Overvågningsopkald'
  },
  connecting: 'Opretter forbindelse',
  initiating: 'Starter',
  outbound: 'Udgående',
  transfer: {
    title: 'Overførselsanmodning',
    heading: {
      chat: 'Vælg den agent eller kø, du vil overføre til.',
      email: 'Vælg den kø, du vil overføre til.',
      telephony:
        'Vælg den agent, den kø eller det opkaldsnummer, du vil overføre til.',
      noQueueTelephony:
        'Vælg den agent eller det opkaldsnummer, du vil overføre til.'
    },
    header: {
      chat: 'Vælg agenten eller køen for at omstille denne kontakt.',
      email: 'Vælg køen for omstilling af denne kontakt.',
      telephony:
        'Vælg agenten, køen, opkaldsnummeret eller organisationen for omstilling af denne kontakt.',
      noQueueTelephony:
        'Vælg agenten, opkaldsnummeret eller organisationen for omstilling af denne kontakt.',
      noOrganizationTelephony:
        'Vælg agenten, køen eller opkaldsnummeret for omstilling af denne kontakt.',
      noQueueOrganizationTelephony:
        'Vælg agenten eller opkaldsnummeret for overførsel af denne kontakt.'
    },
    queues: 'Kø',
    agents: 'Agent',
    dialNumber: 'Opkaldsnummer',
    organization: 'Organisation',
    placeholder: {
      Queues: 'Vælg på en køliste',
      Agents: 'Vælg på en agentliste',
      DialNumber: 'Vælg efter navn eller nummer',
      DialNumberOrEntryPoint: 'Vælg efter navn/nummer/indgangspunkt',
      ChooseByNameOrNumber: 'Vælg efter navn/nummer',
      Organization: 'Søg efter navn/stilling/afdeling/arbejdstelefon',
      WebexOrganization: 'Søg efter navn eller e-mailadresse',
      DialNumberSearch: 'Søg efter navn eller nummer'
    },
    type: 'Overfør',
    cancel: 'Annuller',
    closeModal: 'Luk modal',
    failureError: 'Kunne ikke starte anmodningen. Prøv igen.',
    entryPoint: 'Indgangspunkt'
  },
  consult: {
    title: 'Rådgivningsanmodning',
    heading: {
      chat: 'Vælg den agent eller kø, du vil overføre til.',
      email: 'Vælg den kø, du vil overføre til.',
      telephony:
        'Vælg den agent, den kø eller det opkaldsnummer, du vil rådføre dig med.',
      noQueueTelephony:
        'Vælg den agent eller det opkaldsnummer, du vil rådføre dig med.'
    },
    header: {
      chat: 'Vælg agenten eller køen for at omstille denne kontakt.',
      email: 'Vælg køen for omstilling af denne kontakt.',
      telephony:
        'Vælg agenten, køen, opkaldsnummeret eller organisationen, du vil rådføre dig med.',
      noQueueTelephony:
        'Vælg agenten, opkaldsnummeret eller organisationen, du vil rådføre dig med.',
      noOrganizationTelephony:
        'Vælg agenten, køen eller opkaldsnummeret, du vil rådføre dig med.',
      noQueueOrganizationTelephony:
        'Vælg agenten eller opkaldsnummeret, du vil rådføre dig med.'
    },
    queues: 'Kø',
    agents: 'Agent',
    dialNumber: 'Opkaldsnummer',
    organization: 'Organisation',
    placeholder: {
      Queues: 'Vælg på en køliste',
      Agents: 'Vælg på en agentliste',
      DialNumber: 'Vælg efter navn eller nummer',
      DialNumberOrEntryPoint: 'Vælg efter navn/nummer/indgangspunkt',
      ChooseByNameOrNumber: 'Vælg efter navn/nummer',
      Organization: 'Søg efter navn/stilling/afdeling/arbejdstelefon',
      WebexOrganization: 'Søg efter navn eller e-mailadresse',
      DialNumberSearch: 'Søg efter navn eller nummer'
    },
    type: 'Konsulter',
    checkBoxLabel: 'Tillad, at deltagerne fortsætter med at interagere.',
    cancel: 'Annuller',
    closeModal: 'Luk modal',
    failureError: 'Kunne ikke oprette forbindelse til rådgivningsanmodningen. Prøv igen.',
    customerLeftMsg: 'Kunden har mistet forbindelsen. Konsultation er ikke længere nødvendig.',
    ctqFailureMsg:
      'Kunne ikke annullere rådgivningsopkald til køen. Prøv igen.',
    cancelCtqInfo:
      'Søger efter en tilgængelig agent i den valgte kø. Vent, eller annuller rådgivningsanmodningen.',
    cancelCtqAction: 'Annuller rådgivning.',
    entryPoint: 'Indgangspunkt'
  },
  conference: {
    title: 'Konferenceanmodning',
    heading: {
      chat: 'Vælg en bestem agent til konferencechat'
    },
    queues: 'Kø',
    agents: 'Agent',
    dialNumber: 'Opkaldsnummer',
    organization: 'Organisation',
    placeholder: {
      Queues: 'Vælg på en køliste',
      Agents: 'Vælg på en agentliste',
      DialNumber: 'Vælg efter navn eller nummer'
    },
    type: 'Konference',
    cancel: 'Annuller',
    closeModal: 'Luk modal',
    failureError: 'Kunne ikke starte denne konferenceanmodning. Prøv igen.'
  },
  transferModal: {
    Agents: 'Kunne ikke hente listen over agenter. Opdater listen.',
    AgentsEmpty: 'Ingen tilgængelig agent',
    Queues: 'Kunne ikke hente listen over køer. Opdater listen.',
    QueuesEmpty: 'Ingen tilgængelig kø',
    EPEmpty: 'Intet adgangspunkt tilgængeligt',
    DialNumber:
      'Kunne ikke hente listen over opkaldsnumre i adressebogen. Opdater listen.',
    EntryPoint:
      'Kan ikke hente liste over indgangspunktnumre. Opdater listen.',
    Common: 'Kan ikke hente listen. Opdater listen.',
    DialNumberEmpty: 'Intet tilgængeligt opkaldsnummer',
    DialNumbInvalid:
      'Opkaldsnummeret er ugyldigt. Kontakt administratoren.',
    DialNumbOrEntryPointInvalid:
      'Opkaldsnummer/indgangspunkt er ugyldigt. Kontakt din administrator.',
    refreshQueueList: 'Opdater listen over køer',
    refreshAgentList: 'Opdater listen over agenter',
    refreshEpList: 'Opdater indgangspunkterne',
    refreshAddressBook: 'Opdater adressebogen',
    refreshTheList: 'Opdater listen',
    entryPointSectionLabel: 'Indgangspunkt',
    addressBookSectionLabel: 'Adressebog',
    organization: 'Organisation',
    comboBoxAriaLabelAgent: 'Vælg på en agentliste',
    comboBoxAriaLabelQueue: 'Vælg på en køliste',
    comboBoxAriaLabelEp: 'Vælg fra en liste over indgangspunkter',
    infScrollAgent: 'Søg agenter',
    infScrollQueue: 'Søg i køer',
    infScrollEP: 'Søg Indgangspunkter',
    allRadioButtonHidedTextForConsult: 'Du har ingen tildelte enheder til at konsultere denne interaktion. Kontakt din Administrator.',
    allRadioButtonHidedTextForTransfer: 'Du har ingen tildelte enheder til at overføre denne interaktion. Kontakt din Administrator.',
    allRadioButtonHidedTextForConference: 'Du har ingen tildelte enheder til at lave en konference af denne interaktion. Kontakt din Administrator.',
    searchMinCharError: 'Indtast mindst tre tegn for at søge.',
  },
  wrapup: {
    cancelautowrapup: 'Annuller automatisk afslutning',
    wrapupreason: 'Afslutningsårsager',
    untilautowrapup: 'indtil automatisk afslutning',
    followupsetting: 'Indstilling for opfølgning',
    lastagentroute: 'Seneste agentdistribution',
    submitwrapup: 'Send afslutning',
    wrapupsearch: 'Søg efter afslutningsårsag',
    invalidationError: 'Kunne ikke sende afslutning',
    searchResult: 'Tilgængelige søgeresultater',
    noResultFound: 'Ingen søgeresultater blev fundet',
    listContainerLabel: 'Afslutningscontainerliste',
    searchError: 'Indtast mindst tre tegn for at søge efter afslutningsårsager.',
  },

  outdial: {
    call: 'Opkald',
    dialpadSearch: 'Angiv nummer, der skal ringes op',
    addressSearch: 'Søg efter navn/nummer',
    addressTab: 'Adresse',
    addressTabTooltip: 'Søg i adressebog',
    dialpadTab: 'Numerisk tastatur',
    dialpadTooltip: 'Ring til et nummer',
    searchTab: 'Søg',
    searchTabTooltip:'Søg efter personer i min organisation',
    noAdrFound: 'Ingen resultater blev fundet',
    noContacts: 'Ingen kontakter',
    mainIconTooltip: 'Udgående opkald',
    errorOutdialFailed:
      'Udgående opkald mislykkedes. Desktop kunne ikke oprette forbindelse til opkaldet, eller opkaldet blev ikke besvaret.',
    errorOutdialDisabled: 'Udgående opkald er deaktiveret',
    errorDialPadValidationMessage: 'Forkert format',
    outdialReqInProgress: 'Udgående opkald er i gang',
    outdialAniPlaceholder: 'Vælg Udgående opkald (ANI)',
    outdialAniLabel: 'ANI for udgående opkald',
    outdialAniPlaceHolder: 'Søg efter udgående ANI',
    errorDcCallsLimitExceeded:
      'Datacentret har nået maksimumgrænsen for udgående opkald. Der kan ikke foretages flere udgående opkald',
    errorOrgCallsLimitExceeded:
      'Organisationen har nået maksimumgrænsen for udgående opkald. Der kan ikke foretages flere udgående opkald.',
    errorOutDialNoAnswerFromCustomer:
      'Kunden besvarede ikke opkaldet. Prøv at ringe op senere.',
    errorOutDialCustomerUnavailable:
      'Kunden er ikke tilgængelig nu. Prøv at ringe op senere.',
    errorOutDialAgentEnds: 'Du afsluttede kundeopkaldet.',
    errorOutDialCustomerBusy: 'Kunden er optaget nu. Prøv at ringe op senere.',
    searchError: 'Indtast mindst tre tegn for at søge i kontakterne.',
    upArrowLabel: 'Udvid',
    clear: 'Ryd input',
    outdialDialogDescription: 'Du er i øjeblikket i dialogen med faner.'
  },

  organization: {
    noMatchFound: 'Ingen resultater blev fundet',
    searchError: 'Indtast mindst tre tegn for at søge i kontakterne.',
    authError: 'Ingen kontakter at vise. Microsoft-godkendelse mislykkedes.'
  },

  interactionPopover: {
    of: 'af',
    accept: 'Acpt.',
    acceptAriaLabel: 'Accepter opgave {taskNumber} - {taskType} fra {from}',
    requests: 'Anmodning(er)',
    back: 'tilbage',
    next: 'næste',
    acceptMultipleRequest: 'Accepter {requestCount} anmodninger',
    paginationDetail: '{indexStart}-{indexEnd} af {totalPopoverpoolLength}',
    hidePopoverDetails: 'Skjul popover-detaljer',
    showPopoverDetails: 'Vis popover-detaljer',
    customerName: 'Kundenavn',
    email: 'E-mail',
    queueName: 'Kønavn',
    failedToAccept: 'Kunne ikke acceptere.',
    unableToAccept: 'Kunne ikke acceptere kontakten.',
    failedToEnd: 'Kunne ikke afslutte.',
    unableToEnd: 'Kunne ikke afslutte kontakten. ',
    ringing: 'Ringning',
    calling: 'Ringer til',
    phoneNumber: 'Telefonnummer',
    dni: 'DNIS',
    ivrPathId: 'IVR-sti-id',
    pathId: 'Sti-id',
    rona: 'RONA',
    sourcePage: 'Kildeside',
    sourceNumber: 'Kildenummer',
    appUserId: 'App-bruger-id',
    acceptAll: 'Acceptér alle opgaver',
    agentDn: 'Agent-DN',
    agentName: 'Agentnavn',
    agentTeam: 'Agentteam',
    requestDetails: 'Anmodningsdetaljer',
    incomingCallFrom: 'Indgående opkald fra',
    unableToAnswer: 'Kan ikke besvare opkaldet. Prøv venligst igen.',
    unableToDecline: 'Opkaldet kunne ikke afvises. Prøv venligst igen.'
  },

  multiLogin: {
    header: 'Besked om flere logins',
    message:
      'Du er logget ind på Desktop i flere applikationsforekomster. Klik på Fortsæt for at gå videre med Desktop i denne applikationsforekomst. Ellers skal du lukke vinduet.',
    continue: 'Fortsæt'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Overførsel til indgangspunkt/kø mislykkedes på grund af en konfigurationsfejl.',
    1010: "Rådgivning ikke mulig, da agenten ikke kan tildeles i tide. ",
    1042: "Kontakten blev ikke fundet",
    1043: 'Destinationen er ugyldig.',
    1045: 'Interaktionen er ikke tildelt til agenten.',
    1046: 'Agentrådgivning mislykkedes, da der ikke blev fundet en tilsvarende agentkanal i systemet.',
    1038: "Agenten blev ikke fundet",
    1037: 'Logon mislykkedes på grund af en intern fejl.',

    // Media Events
    138: 'Handling mislykkedes på grund af ukendte årsager.',
    136: 'Brugeren blev ikke fundet',

    // AgentConsultFailed
    1050: 'Rådgivning er ikke mulig pga. ikke-understøttet konfiguration eller aktivitet i flowet. ',
    1005: "Rådgivning er ikke mulig, da agenten ikke besvarede anmodningen til tiden.",
    1051: 'Rådgivning eller overførsel er ikke mulig pga. ugyldigt indgangspunkt eller opkaldsnummer.',

    // AgentInviteFailed
    1053: 'Interaktion kan ikke vises pga. en arbejdsgang, hvor opgave venter på at blive sat i kø igen.',
    1054: 'Foretagelse af udgående opkald er ikke mulig pga. medieproblemer med denne anmodning. ',

    // AgentContactAssignFailed
    1011: 'Besvarelse eller accept af opkaldet er ikke mulig pga. manglende agenter i den igangværende interaktion. ',

    // ContactCallbackFailed
    1034: 'Tilbagekald til kontakten mislykkedes, da KontaktParkérTimeout blev modtaget for anmodningen.',

    // ContactUpdateFailed
    1020: "Variablerne kan ikke opdateres, da en af værdierne overstiger tegngrænsen på 256. Reducer antal tegn, og prøv igen.",

    // AgentInviteFailed
    1031: 'Agenten har inviteret kunden, efter at der er anmodet om tilbagekald.',

    // AgentBlindTransferFailedEvent
    1044: 'Blind overførsel af agent mislykkedes, da destinationsagenten er tildelt en anden interaktion.',

    // AgentCtqCancelFailed
    1047: "Kontakten blev ikke fundet.",

    // AgentCtqFailed
    1048: "Opkaldsdistributionsgruppen er ikke konfigureret.",
    1049: 'Den maksimale ventetid i køen er overskredet.',
    // StationLoginFailed
    127: 'Tilmelding af agent-DN mislykkedes med undtagelse pga. på dobbeltlogon.'
  },

  stateSelector: {
    Available: 'Tilgængelig',
    errorstatechange: 'Tilstandsændringer lykkedes ikke. Prøv igen.',
    errorStateChangeInPendingLogout: 'Kunne ikke ændre agenttilstand pga. afventende logout.',
    label: 'Tilgængelighedstilstand',
    agentStateSelector: 'Valg af agenttilstand',
    Engaged: 'Optaget',
    engagedAvailableInfo:
      'Du er i øjeblikket optaget med en interaktion og i tilstanden tilgængelig.',
    engagedIdleInfo:
      'Du er i øjeblikket optaget med en interaktion og i tilstanden inaktiv',
    engagedInfo: 'Du er i øjeblikket i gang med en interaktion.',
    engagedSupervisorStateChange: 'har ændret tilstanden til',
    axAgentStateChanged: 'Din tilstand er ændret til',
    axAgentSync: 'på grund af tilstandssynkronisering med dit samarbejdsværktøj.',
    engagedPresenceInfo:
      'Du er i øjeblikket optaget med en interaktion og din tilstand er',
    engagedPresenceSync: 'på grund af tilstandssynkronisering med dit samarbejdsværktøj.',
    clear: 'Ryd input',
    searchState: 'indgang',
    agentStatusLabel: 'Agentstatus',
    agentStateLabel: 'Agent er i {selectedState}-tilstand i de sidste {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Agent er i tilstanden {selectedState} i de sidste 0 sek',
    agentStateChangeSuccessful:'Statusændring til {selectedState} lykkedes.',
    agentStateChangeFail:'Statusændring til {selectedState} mislykkedes.',
    searchError: 'Indtast mindst tre tegn for at søge efter tilstande.'
  },

  warningMessage: {
    header: 'Ugemte ændringer',
    message:
      'Du har ugemte ændringer på denne side. Er du sikker på, at du vil forlade siden? ',
    cancelButton: 'Bliv',
    saveButton: 'Forlad'
  },

  notificationLables: {
    muteVolume: 'Slå lydstyrke for meddelelse fra',
    unmuteVolume: 'Slå lydstyrke for meddelelse til',
    notificationVolume: 'Lydstyrke for meddelelse',
    playSound: 'Afspil meddelelseslyd',
    enableSoundNotificationSettings: 'Aktivér lydmeddelelser',
    enableSoundNotificationSettingsDescription:
      'Giver lydmeddelelser ved indgående anmodninger. Du kan justere lydstyrken herunder.',
    volumeTitle: 'Lydstyrke'
  },

  channelNameLabels: {
    sms: 'Sms',
    telephony: 'Opkald',
    chat: 'Chat',
    email: 'E-mail',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business chat',
    googleBusiness: "Googles Business Messages"
  },
  orgDetailsLabels: {
    role: 'Stilling',
    department: 'Afdeling',
    email: 'E-mail',
    businessPhone: 'Arbejdstelefon',
    workPhone: 'Arbejde',
  },
  addressListError: {
    title: 'Kunne ikke indlæse data',
    errorId: 'Fejl-id:'
  },
  keypad: {
    keyPadSearch: 'Indtast nummeret',
    dialPad: 'Numerisk tastatur'
  },
  collabTool: {
    userAuthenticated: 'Brugergodkendelse:',
    successful: 'Lykkedes',
    failed: 'Mislykkedes.',
    tryAgain: 'Prøv igen',
    stateSync: 'Tilstandssynkronisering:',
    mercuryFailedInfo: ' Kontakt administratoren.',
    retrying: 'Prøver igen ...',
    trackingIdLabel: 'Sporings-id: '
  },
  webex: {
    webex: 'Webex',
    info: 'Integration giver dig mulighed for at synkronisere tilstande mellem desktop og Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Med denne integration kan du få rådgivning eller omstille opkald til brugerne af Microsoft Teams.',
    authenticationFailedInfo:
      'Hvis et godkendelsesvindue allerede er åbent, skal du prøve at godkende igen der.',
    ListItemContactDetails:
      'Kontaktens navn er: {name}, dennes tilstedeværelse er: {presence}, afdeling er: {department}, jobtitel er: {jobTitle}, og telefonnummer er: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Besked om nødservice',
    readNotification: 'Jeg har læst beskeden.'
  },
  webexPresenceStatus: {
    active: 'Aktiv',
    lastActiveFewMinutesAgo: 'Aktiv i de sidste par minutter',
    lastActiveMinutesAgo: 'Aktiv {min} minutter siden',
    lastActive1HourAgo: 'Seneste aktivitet for 1 time siden',
    lastActiveHoursAgo: 'Aktiv {hour} minutter siden',
    lastActiveYesterday: 'Aktiv i går',
    lastActiveOnDate: 'Aktiv på {date}',
    busy: 'Optaget',
    busyUntil: 'Optaget indtil {date}',
    dnd: 'Forstyr ikke',
    dndUntil: 'Forstyr ikke indtil {date}',
    quiet: 'Dæmpet',
    quietUntil: 'Dæmpet indtil {date}',
    ooo: 'Ikke på kontoret',
    outOfOfficeUntil: 'Ikke på kontoret indtil {date}',
    call: 'I et opkald',
    meeting: 'In a meeting',
    calendarItem: 'I et møde',
    presenting: 'Præsenterer',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Søg efter navn eller profiloplysninger',
    webexPlaceholder: 'Søg efter navn eller e-mailadresse',
    refreshTheList: 'Opdater listen',
    refreshAddressBook: 'Opdater adressebogen',
    microsoftAuthError: 'Ingen kontakter at vise. Microsoft-godkendelse mislykkedes.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/de.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/de.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Daten konnten nicht geladen werden',
    errorID: 'Fehler-ID',
    tryAgain: 'Erneut versuchen',
    Error: 'Fehler',
    okButton: 'OK',
    Yes: 'Ja',
    Cancel: 'Abbrechen',
    Confirm: 'Bestätigen',
    Continue: 'Fortfahren',
    Canceling: 'Vorgang wird abgebrochen',
    CiscoAiAssistant: 'Cisco-KI-Assistent',
    Answer: 'Entgegennehmen',
    AnswerAriaLabel: 'Desktop-Aufgabe beantworten',
    Decline: 'Abweisen',
    ErrorSecurityCompliance: 'Einhaltung von Sicherheitsregeln',
    errorDetails: 'Fehlerdetails',
    learnMore: 'Weitere Infos',
    showLess: 'Weniger anzeigen',
    trackingIdDescription:
      'Teilen Sie dem Website-Administrator oder dem Support-Team die Nachverfolgungs-ID zur Untersuchung der Situation mit.',
    trackingIdInputLabel: 'Nachverfolgungs-ID: ',
    submitForm: 'Formular senden',
    unnamedStatus: 'Unbenannter Status',
    errorChatMsg: 'Chatdaten konnten nicht geladen werden',
    noOptions: 'Keine Optionen',
    noResults: 'Keine Ergebnisse',
    more: 'Mehr',
    nomatchfound: 'Keine Ergebnisse gefunden',
    collaborationTool: 'Collaboration-Tool',
    timerAriaLabel: 'Verwendete Zeit',
    historyItemTime: 'Aufgetreten um',
    loading: 'Laden',
    months: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember'
    ],
    loadingMsg: 'Wird geladen...',
    search: 'Suche',
    historyChannelLabels: {
      All: 'Alle',
      telephony: 'Sprache',
      chat: 'Chat',
      email: 'E-Mail',
      social: 'Sozial'
    },
    homePageLabel: 'Startseite',
    resizeHistoryDragger: 'Größe des Verlaufs-Draggers ändern',
    agentHistoryLabel: 'Agent-Verlauf',
    clear: 'Eingabe löschen',
    ariaLabelAgentHistoryWrapper:
      'Der Agenten-Interaktionsverlauf zeigt die aktuellen Kundenkommunikationen der letzten 24 Stunden in verschiedenen Kanälen an.',
    sliderResizerInstructions:
      'Sie verwenden derzeit einen Schieberegler. Um die Größe zu ändern, verwenden Sie die Pfeiltasten.',
    resizeHistoryPanel: 'Größe des Verlaufsfensters ändern, Schieberegler,',
    time: {
      hours: 'Stunde',
      minutes: 'min.',
      seconds: 'Sek.'
    }
  },
  email: {
    ToLabel: 'An',
    FromLabel: 'Von',
    CcLabel: 'Cc',
    BccLabel: 'Bcc',
    SubjectLabel: 'Betrifft',
    HideLabel: 'Ausblenden',
    SendLabel: 'Senden',
    ShowPrevThread: 'Vorherigen Thread anzeigen',
    HidePrevThread: 'Vorherigen Thread ausblenden',
    ReplyLabel: 'Antworten',
    ReplyAllLabel: 'Allen antworten',
    ViewOriginalMail: 'Ursprüngliche E-Mail anzeigen',
    QuickReplyInp: 'Hier Kurzantwort...',
    AttachFiles: 'Dateien anfügen',
    ToolbarHeading: 'Überschrift 1',
    ToolbarBold: 'Fett',
    ToolbarItalic: 'Kursiv',
    ToolbarUnderLine: 'Unterstrichen',
    ToolbarBlockQuote: 'Blockzitat',
    ToolbarCode: 'Codeblock',
    ToolbarListOrder: 'Nach Sortierung auflisten',
    ToolbarListBullet: 'Nach Aufzählungspunkt auflisten',
    ToolbarLink: 'Link',
    ToolbarStrike: 'Durchgestrichen',
    ToolbarColor: 'Textfarbe',
    ToolbarTable: 'Tabelle',
    insertTable: 'Tabelle einfügen',
    insertRowAbove: 'Zeile darüber einfügen',
    insertRowBelow: 'Zeile darunter einfügen',
    insertColumnLeft: 'Spalte links einfügen',
    insertColumnRight: 'Spalte rechts einfügen',
    deleteRow: 'Zeile löschen',
    deleteColumn: 'Spalte löschen',
    deleteTable: 'Tabelle löschen',
    link: 'Link',
    IndentRight: 'Rechts einrücken',
    IndentLeft: 'Links einrücken',
    showMoreAttachment: 'Mehr Anhänge anzeigen',
    AttachmentLimit: 'Bis zu ',
    attachments: ' Anhänge, ',
    sizeLimit: ' MB maximal',
    attachment: 'Anhang',
    errordeleteattachment: 'Datei(en) konnte(n) nicht gelöscht werden. Bitte versuchen Sie es erneut.',
    errordownloadattachment: 'Datei(en) konnte(n) nicht heruntergeladen werden. Bitte versuchen Sie es erneut.',
    erroraddattachemnt: 'Datei(en) konnte(n) nicht hochgeladen werden. Bitte versuchen Sie es erneut.',
    errorendcontact: 'Die Interaktion konnte nicht beendet werden. Bitte versuchen Sie es erneut.',
    erroraddlimitreached:
      'Datei konnte nicht angehängt werden, da sie das folgende Limit überschreitet: ',
    errorattachmentdrop:
      'Anhänge gemäß Sicherheitsrichtlinie des Unternehmens gelöscht.',
    errorfiletype: 'Der Dateityp wird nicht unterstützt. Versuchen Sie es erneut.',
    errorcreditcard:
      'Anhänge konnten nicht hochgeladen werden, da sie gegen die Sicherheitsrichtlinie des Unternehmens verstoßen.',
    errorcontainsimage:
      'Anhänge konnten nicht hochgeladen werden. Die Bilder in den Anhängen werden nicht von der Sicherheitsrichtlinie des Unternehmens unterstützt.',
    errorlimit: ' MB.',
    errorsendemail: 'Die E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    errorpcicheckemail: 'PCI-Daten können nicht abgerufen werden. Bitte versuchen Sie es erneut.',
    errortext: 'Daten konnten nicht geladen werden',
    tryAgain: 'Erneut versuchen',
    replywarning:
      'Teilen Sie keine finanziellen, gesundheitsbezogenen oder personenbezogenen Daten in dieser Nachricht oder den Anhängen.',
    datamasked:
      'Der E-Mail-Betreff oder -Text wurde gemäß Sicherheitsrichtlinie des Unternehmens geändert. Möchten Sie die E-Mail wirklich senden?',
    pcibannerwarning:
      'Der E-Mail-Betreff oder -Text wurde gemäß Sicherheitsrichtlinie des Unternehmens geändert.',
    on: 'Am',
    wrote: 'schrieb'
  },
  interaction_control: {
    windowOpened: 'Fenster geöffnet',
    connected: 'Verbunden',
    consultRequested: 'Rücksprache angefragt',
    consulting: 'Rücksprache halten',
    consultCallOnHold: 'Rücksprache gehalten',
    callOnHold: 'Anruf wird gehalten',
    consult: 'Rücksprache',
    endconsult: 'Rücksprache beenden',
    hold: 'Halten',
    transfer: 'Übergabe',
    conference: 'Konferenz',
    endconference: 'Konferenz beenden',
    conferenceRequested: 'Konferenz angefragt',
    switchCall: 'Wechseln',
    mergeCall: 'Zusammenfüh.',
    wrapup: 'Nachbearbeitung',
    end: 'Beenden',
    customername: 'Kundenname',
    dn: 'DNIS',
    ivrpath: 'IVR-Pfad',
    email: 'Kunden-E-Mail',
    ani: 'Telefonnummer',
    queueid: 'Name d. Wartes.',
    ronatimeout: 'RONA-Zeit',
    pathid: 'IVR-Pfad-ID',
    dnis: 'DNIS',
    destagentphonenumber: 'Agenten-Verzeichnisnummer',
    destagentname: 'Agentenname',
    virtualteamname: 'Warteschlange',
    category: 'Kategorie',
    additionaldetails: 'Zusätzliche Details',
    sourcenumber: 'Quellnummer',
    sourcepage: 'Quellseite',
    appuser: 'App-Benutzer-ID',
    customernumber: 'Telefonnummer',
    exitconference: 'Konferenz beenden',
    resume: 'Fortsetzen',
    pauserecording: 'Aufzeichnung anhalten',
    resumerecording: 'Aufzeichnung fortsetzen',
    exitconsult: 'Rücksprache beenden',
    pauseRecordingFailed: 'Aufzeichnung konnte nicht angehalten werden. Bitte versuchen Sie es erneut.',
    resumeRecordingFailed: 'Aufzeichnung konnte nicht fortgesetzt werden. Bitte versuchen Sie es erneut.',
    holdCallFailed: 'Anruf kann nicht gehalten werden. Bitte versuchen Sie es erneut.',
    resumeCallFailed: 'Anruf kann nicht fortgesetzt werden. Bitte versuchen Sie es erneut.',
    endCallFailed: 'Die Interaktion konnte nicht beendet werden. Bitte versuchen Sie es erneut.',
    consultTransferFailed:
      'Beratungsanruf kann nicht übergeben werden. Bitte versuchen Sie es erneut.',
    conferenceTransferFailed:
      'Konferenzgespräch kann nicht übergeben werden. Bitte versuchen Sie es erneut.',
    conferenceFailed:
      'Die Konferenzanfrage kann nicht verbunden werden. Bitte versuchen Sie es erneut.',
    consultEndFailed: 'Die Rückspracheanfrage kann nicht beendet werden. Bitte versuchen Sie es erneut.',
    conferenceExitFailed:
      'Die Konferenzanfrage kann nicht beendet werden. Bitte versuchen Sie es erneut.',
    conferenceEndFailed:
      'Die Konferenzanfrage kann nicht beendet werden. Bitte versuchen Sie es erneut.',
    cancelCtqFailed:
      'Rücksprachenanruf konnte nicht in Warteschlange abgebrochen werden. Bitte versuchen Sie es erneut.',
    privacyShield: 'Datenschutzschild',
    errorOnPrvacyShieldForConsult:
      'Aufzeichnung ist derzeit angehalten. Setzen Sie die Aufzeichnung fort, um einen Rücksprachenanruf zu starten.',
    errorOnPrvacyShieldForTransfer:
      'Aufzeichnung ist derzeit angehalten. Setzen Sie die Aufzeichnung fort, um eine Anrufübergabe zu starten.',
    cancelConsult: 'Rücksprache abbrechen',
    cancelTransfer: 'Übergabe abbrechen',
    copy: 'Kopieren',
    copied: 'Kopiert',
    cadrequestuccess: 'Kundendaten wurden erfolgreich gespeichert.',
    cadrequestfailure: 'Fehler beim Speichern der Kundendaten. Versuchen Sie es später erneut.',
    cadupdatedmessage: 'Kundendaten wurden kürzlich aktualisiert von',
    unsavedmessage: 'Ihre nicht gespeicherten Änderungen werden überschrieben.',
    save: 'Speichern',
    revert: 'Zurücksetzen',
    expandDetails: 'Details erweitern',
    collapseDetails: 'Details reduzieren',
    cadValidationError:
      'Ungültiges Format. Verwenden Sie den internationalen Standard für Datum und Uhrzeit.',
    secureCadSaveError:
      'Kundendaten nicht gespeichert. Auf "Speichern" klicken, um es erneut zu versuchen.',
    secureDecryptionError: 'Sichere Variablen können nicht angezeigt werden.',
    clickToTry: 'Zum Wiederholen klicken',
    isSecureVariable: 'ist eine sichere Variable',
    contactorigin: 'Kontaktursprung',
    resumeMonitoring: 'Überwachung fortsetzen',
    pauseMonitoring: 'Überwachung anhalten',
    whisperCoach: 'Whisper-Coach',
    bargeIn: 'Eingreifen',
    endMonitoring: 'Überwachung beenden',
    contactphonenumber: 'Telefonnummer des Kontakts',
    contactqueue: 'Kontakt-Warteschlange',
    activeparticipants: 'Aktive Teilnehmer',
    consultedparticipant: 'Rücksprache bei Teilnehmer',
    contactstatus: 'Kontakt-Status',
    timeincontactstatus: 'Zeit in Kontakt-Status',
    totalcontactduration: 'Kontakt-Dauer gesamt',
    agentinteractiontime: 'Interaktionsdauer',
    recording: 'Aufzeichnung',
    monitoring: 'Überwachung',
    monitoringPaused: 'Überwachung angehalten',
    pauseMonitoringFailed: 'Überwachung konnte nicht angehalten werden. Bitte versuchen Sie es erneut.',
    resumeMonitoringFailed: 'Überwachung konnte nicht fortgesetzt werden. Bitte versuchen Sie es erneut.',
    callCancelledInProgress: 'Aktiver Anruf wird abgebrochen',
    bargedIn: 'Eingegriffen',
    keypad: 'Tastenfeld',
    mute: 'Stummschalten',
    unmute: 'Stummschalten aufheben',
    bargeInTooltipText:
      'Das Mikrofon schaltet sich ein und Sie treten dieser Kundeninteraktion bei.',
    bargeInCompactTooltipText:
      'Eingreifen. Das Mikrofon schaltet sich ein und Sie treten dieser Kundeninteraktion bei.',
    bargeInTooltipDisabled: 'Setzen Sie die Überwachung fort, um das Eingreifen zu aktivieren',
    bargeInFailedTitle: 'Eingreifen fehlgeschlagen',
    bargeInFailedData:
      'Beim Eingreifen ist ein Fehler aufgetreten. Versuchen Sie es nach einiger Zeit erneut.',
    supervisorBargedIn: 'Hat in Ihren Anruf eingegriffen.',
    leftInteraction: 'hat die Interaktion verlassen.',
    conferenceEnded: 'Konferenzgespräch ist beendet.',
    participants: 'Teilnehmer',
    badgeAriaLabel: '{participant} ist im Gespräch',
    bargeInConferenceAriaLabel: 'Es sind zwei Teilnehmer an der Interaktion beteiligt',
    taskName: 'Name der Interaktionssteuerungsaufgabe',
    interactionDurationLabel: 'Zeitdauer',
    wrapupassist: 'Unterstützung zur Nachbearbeitung',
    consultingTaskContext: 'Beratungsanruf von',
    consultExited: 'Rücksprachenanruf beendet',
    endCall: 'Anruf beenden.',
    exitconferenceCall:
      'Beenden Sie den Anruf und die Konferenz wird mit den aktiven Teilnehmern fortgesetzt.',
    recordingInProgess: 'Wird aufgezeichnet',
    recordingPaused: 'Aufzeichnung pausiert',
    searchPlaceholder: 'Kontakte suchen',
    postCall: "Nach Anruf",
    switchCallTooltip: "Zu Anruf wechseln",
    switchConsultTooltip: "Zu Rücksprache-Anruf wechseln",
    switchConferenceTooltip: "Zu Konferenzgespräch wechseln",
    confirmationDialog: {
      endCallTitle: 'Möchten Sie den Anruf beenden?',
      endCallMessage: 'Klicken Sie auf „Bestätigen“, um den Anruf für alle Teilnehmer zu beenden.',
      exitConferenceTitle: 'Möchten Sie das Konferenzgespräch beenden?',
      exitConferenceMessage:
        'Klicken Sie auf „Bestätigen“, um das Konferenzgespräch zu beenden und den anderen Teilnehmern zu erlauben, fortzufahren.',
      confirmButtonLabel: "Bestätigen",
      cancelButtonLabel: "Abbrechen",  
    },
    postCallOnHold: "Nach Anruf gehalten",
    postCallConsult: "Rücksprache nach Anruf",
    postCallConsultOnHold: "Rücksprache nach Anruf gehalten",
  },
  agentProfile: {
    teamName: 'Team',
    dialNumber: 'Rufnummer',
    phoneNumber: 'Telefonnummer',
    settings: 'Einstellungen ändern',
    signOut: 'Abmelden',
    webRTCDisconnected: 'Warnhinweis: Desktop-Telefonie getrennt ',
    msAuthFailed: 'Microsoft-Authentifizierung fehlgeschlagen',
    stateSyncFailed: 'Statussynchronisierung fehlgeschlagen',
    userProfileLabel: 'Benutzerprofil',
    ariaAgentprofile: 'Agent-Profil',
    ChannelCapacity: 'Kanalkapazität',
    voice: 'Sprache',
    chat: 'Chat',
    email: 'E-Mail',
    social: 'Sozial',
    channelCapacityTooltip: 'Klicken, um mehr anzuzeigen',
    blendedRouting: 'Gemischt',
    exclusiveRouting: 'Exklusives Routing',
    realtimeRouting: 'Gemischte Weiterleitung – Echtzeit',
    blendedRoutingTooltip: 'Mehrere Kontakte über Kanäle hinweg bearbeiten.',
    exclusiveRoutingTooltip: 'Nur einen Kontakt gleichzeitig bearbeiten.',
    realtimeRoutingTooltip: 'Einen obligatorischen Echtzeit-Kanal bearbeiten.',
    errorActiveContacts:
      'Sie können sich jetzt nicht abmelden, da Sie an aktiven Konversationen beteiligt sind. Schließen Sie diese ab, und versuchen Sie es erneut.',
    searchTeams: 'Teams suchen',
    changeTeamsConfirmHeader: 'Team-Bestätigung ändern',
    changeTeamsConfirmMessage: 'Möchten Sie Ihr Team wirklich ändern?',
    changeTeamLabel: 'Team ändern',
    errorChangeTeams:
      'Sie können das Team derzeit nicht ändern, da Sie aktive Anfragen haben. Bitte schließen Sie diese ab, und versuchen Sie es erneut.',
    saveTeamSelection: 'Team-Auswahl speichern',
    userSettings: 'Benutzereinstellungen',
    resetLayout: 'Gesamtes Desktop-Layout zurücksetzen',
    resetConfirmHeader: 'Bestätigung der Layoutzurücksetzung',
    resetConfirmMessage:
      'Möchten Sie das gesamte Desktop-Layout wirklich zurücksetzen? <br/> Der Desktop wird auf das Standard-Layout zurückgesetzt.',
    downloadLogs: 'Fehlerbericht herunterladen',
    help: 'Hilfe',
    signoutConfirm: 'Möchten Sie sich wirklich abmelden?',
    signoutConfirmHeader: 'Abmeldebestätigung',
    darkTheme: 'Zum dunklen Modus wechseln',
    newLook: 'Zum neuen Look wechseln',
    keyboardShortcuts: 'Tastenkombinationen',
    keyboardShortcutCombination: 'Strg+Alt+F',
    errorReportCombination: 'Strg+Umschalt+2',
    notificationSettings: 'Benachrichtigungseinstellungen',
    silentNotification: 'Stille Benachrichtigung',
    enableNotificationSettings: 'Benachrichtigungen aktivieren',
    enableSilentNotificationSettings: 'Stille Benachrichtigungen aktivieren',
    suppressWebexCallingNotificationSettings: 'Webex Calling-Benachrichtigungen ausblenden',
    notificationSettingDescription:
      'Liefert Benachrichtigungen bei neuen Nachrichten, Alarmen und Statusänderungen.',
    silentNotificationDescription:
      'Deaktiviert die Alarme auf dem Bildschirm. Sie können die Benachrichtigungen im Benachrichtigungscenter anzeigen.',
    suppressWebexCallingNotificationDescription: 
    'Keine Popupbenachrichtigungen für eingehende Webex-Anrufe anzeigen und diese über Webex Contact Center annehmen.',
    arrowLabel: 'Zurück',
    managedTeams: 'Verwaltete Teams',
    managedTeamsError: 'Teams konnten nicht geladen werden.',
    viewAll: 'Alle anzeigen',
    profileSettings: 'Profileinstellungen',
    userRole: 'Rolle',
    saveSelection: 'Auswahl speichern',
    extension: 'Erweiterung',
    changeProfileConfirmHeader: 'Änderungen an den Profileinstellungen bestätigen',
    changeProfileConfirmMessage:
      'Möchten Sie die Profiländerungen wirklich speichern?',
    confirm: 'Bestätigen',
    errorProfileUpdate:
      'Sie können die Profileinstellungen derzeit nicht ändern, da Sie aktive Anfragen haben. Bitte schließen Sie diese ab, und versuchen Sie es erneut.',
    roleAgentSupervisor: 'Supervisor und Agent',
    roleSupervisor: 'Supervisor',
    noTeam: 'Kein Team',
    testYourNetwork: 'Testen Sie Ihr Netzwerk',
    speakerAndMic: 'Lautsprecher und Mikrofon',
    speaker: 'Lautsprecher',
    mic: 'Mikrofon',
    speakerDescription:
      'Wählen und testen Sie das Ausgabegerät, um sicherzustellen, dass Sie den Anrufer hören.',
    micDescription:
      'Wählen und testen Sie das Eingabegerät, um sicherzustellen, dass der Anrufer Sie hört.',
    micError:
      'Der Zugriff auf das Mikrofon wurde verweigert. Aktivieren Sie den Zugriff über die Browsereinstellungen oder wenden Sie sich an den Administrator.',
    speakerError:
      'Lautsprecher ist derzeit nicht verfügbar, da der Zugriff auf das Mikrofon verweigert wird.',
    telephony: 'Telefonie',
    desktop: 'Desktop',
    onSpeakerPlay:
      'Wenn Sie den Testton nicht hören, überprüfen Sie das Lautsprechergerät.',
    onMicPlay:
      'Wenn Sie den Testton nicht hören, überprüfen Sie den Lautsprecher und das Mikrofon.',
    onMicRecord: 'Eine Nachricht zur Wiedergabe aufzeichnen.',
    test: 'Test',
    recording: 'Aufzeichnung',
    playing: 'Wiedergabe',
    reconnecting: 'Erneute Verbindungsherstellung',
    disconnectMessage:
      'Desktop-Telefonie getrennt. Versuchen Sie es mit einer anderen Telefonie-Option.',
    singleTelephonyDisconnectMessage:
      'Desktop-Telefonie getrennt. Wenden Sie sich an den Administrator.',
    clear: 'Eingabe löschen',
    rememberMeCheckBoxMessage: "Nicht erneut anzeigen",
    saveLabel: 'Speichern',
    browserUnsupportedError: "Die Anmeldung ist fehlgeschlagen, da Sie einen nicht unterstützten Browser verwenden.",
    microphoneAccessDeniedError: "Der Zugriff auf das Mikrofon wurde verweigert. Aktivieren Sie den Zugriff über die Browsereinstellungen oder wenden Sie sich an den Administrator.",
  },
  contactHistory: {
    mainHeader: 'Kontaktverlauf',
    handledBy: 'Bearbeitet von',
    noRecordFound: 'Kein Kontaktverlauf gefunden.',
    tryAgain: 'Erneut versuchen',
    errorMsg: 'Der Kontaktverlauf konnte nicht abgerufen werden. Bitte versuchen Sie es erneut.',
    errorID: 'Fehler-ID',
    missingAni: 'ANI fehlt',
    timeIcon: 'Dauer',
    taskHandled: 'Aufgabe bearbeitet',
    noHistoryNew: 'Kein Verlauf',
    noHistory: 'Kein Verlauf',
    viewTranscript: 'E-Mail-Nachricht anzeigen',
    transcriptFor: 'Abschriften für',
    editBeforeCall: 'Vor Anruf bearbeiten',
    clickToCall: 'Klicken zum Anrufen',
    onAnActiveCallErrorMessage:
      'Sie können keinen neuen Anruf initiieren, da Sie sich bereits in einem aktiven Anruf befinden.',
    receivedFrom: 'Kontakt erhalten von',
    initiatedTo: 'Kontakt initiiert an',
    wrapUpReason: 'Grund für Nachbereitung',
    startCallTelephony:
      'Klicken Sie auf den Link zur Telefonnummer, um einen ausgehenden Anruf zu starten.',
    contactHistoryList: 'Kontaktverlaufsliste',
    wrapUpCode: 'Nachbearbeitungscode',
    agentName: 'Agentenname',
    entryPointName: 'Einstiegspunkt',
    acceptedTimeAndDate: 'Akzeptierte Uhrzeit und Datum',
    duration: 'Dauer',
    emailTranscript: 'E-Mail-Protokoll',
    clickToViewEmailTranscript: 'Zum Anzeigen des E-Mail-Transkripts klicken',
    listContainer: 'Container auflisten'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Einstiegspunkt',
    date: 'Datum',
    subject: 'Betrifft',
    from: 'Von',
    sent: 'Gesendet',
    to: 'An',
    back: 'Zurück',
    errorTranscript: 'Beim Abrufen der Abschriften ist ein Fehler aufgetreten',
    customer: 'Kunde',
    inboundErrorMessage: 'Kunden-E-Mail konnte nicht geladen werden',
    outboundErrorMessage: 'Agentenantwort konnte nicht geladen werden'
  },
  popoverTitle: {
    callback: 'Rückruf',
    outboundCall: 'Ausgehender Anruf',
    incomingCall: 'Eingehender Anruf',
    progressiveCampaign: 'Kampagnenanruf',
    courtesyCallback: 'Automatischer Rückrufwunsch',
    chat: 'Eingehender Chat',
    incoming: 'Eingehend',
    monitoringCall: 'Überwachter Anruf'
  },
  connecting: 'Verbindung wird hergestellt',
  initiating: 'Initiieren',
  outbound: 'Ausgehend',
  transfer: {
    title: 'Übergabeanfrage',
    heading: {
      chat: 'Wählen Sie den Agenten oder die Warteschlange aus, an den bzw. die Sie übergeben möchten.',
      email: 'Wählen Sie die Warteschlange aus, an die Sie übergeben möchten.',
      telephony:
        'Wählen Sie den Agenten, die Warteschlange oder die Rufnummer aus, an den bzw. die Sie übergeben möchten.',
      noQueueTelephony:
        'Wählen Sie den Agenten oder die Rufnummer aus, an den bzw. die Sie übergeben möchten.'
    },
    header: {
      chat: 'Wählen Sie den Agenten oder die Warteschlange für die Übergabe dieses Kontakts aus.',
      email: 'Wählen Sie die Warteschlange für die Übergabe dieses Kontakts aus.',
      telephony:
        'Wählen Sie den Agenten, die Warteschlange, die Rufnummer oder die Organisation für die Übergabe dieses Kontakts aus.',
      noQueueTelephony:
        'Wählen Sie den Agenten, die Rufnummer oder die Organisation für die Übergabe dieses Kontakts aus.',
      noOrganizationTelephony:
        'Wählen Sie den Agenten, die Warteschlange oder die Rufnummer für die Übergabe dieses Kontakts aus.',
      noQueueOrganizationTelephony:
        'Wählen Sie den Agenten oder die Rufnummer für die Übergabe dieses Kontakts aus.'
    },
    queues: 'Warteschlange',
    agents: 'Agent',
    dialNumber: 'Rufnummer',
    organization: 'Organisation',
    placeholder: {
      Queues: 'Aus Liste mit Warteschlangen auswählen',
      Agents: 'Aus Liste mit Agenten auswählen',
      DialNumber: 'Name oder Nummer auswählen',
      DialNumberOrEntryPoint: 'Name/Nummer/Einstiegspunkt auswählen',
      ChooseByNameOrNumber: 'Name/Nummer auswählen',
      Organization: 'Nach Name/Rolle/Abteilung/Geschäftstelefon suchen',
      WebexOrganization: 'Suchen nach Name oder E-Mail',
      DialNumberSearch: 'Suchen nach Name oder Nummer'
    },
    type: 'Übergabe',
    cancel: 'Abbrechen',
    closeModal: 'Modal schließen',
    failureError: 'Die Anfrage konnte nicht übergeben werden. Bitte versuchen Sie erneut.',
    entryPoint: 'Einstiegspunkt'
  },
  consult: {
    title: 'Anfrage für Rücksprache',
    heading: {
      chat: 'Wählen Sie den Agenten oder die Warteschlange aus, an den bzw. die Sie übergeben möchten.',
      email: 'Wählen Sie die Warteschlange aus, an die Sie übergeben möchten.',
      telephony:
        'Wählen Sie den Agenten, die Warteschlange oder die Rufnummer aus, mit dem bzw. der Sie Rücksprache halten möchten.',
      noQueueTelephony:
        'Wählen Sie den Agenten oder die Rufnummer aus, mit dem bzw. der Sie Rücksprache halten möchten.'
    },
    header: {
      chat: 'Wählen Sie den Agenten oder die Warteschlange für die Übergabe dieses Kontakts aus.',
      email: 'Wählen Sie die Warteschlange für die Übergabe dieses Kontakts aus.',
      telephony:
        'Wählen Sie den Agenten, die Warteschlange, die Rufnummer oder die Organisation aus, mit dem bzw. der Sie Rücksprache halten möchten.',
      noQueueTelephony:
        'Wählen Sie den Agenten, die Rufnummer oder die Organisation aus, mit dem bzw. der Sie Rücksprache halten möchten.',
      noOrganizationTelephony:
        'Wählen Sie den Agenten, die Warteschlange oder die Rufnummer aus, mit dem bzw. der Sie Rücksprache halten möchten.',
      noQueueOrganizationTelephony:
        'Wählen Sie den Agenten oder die Rufnummer aus, mit dem bzw. der Sie Rücksprache halten möchten.'
    },
    queues: 'Warteschlange',
    agents: 'Agent',
    dialNumber: 'Rufnummer',
    organization: 'Organisation',
    placeholder: {
      Queues: 'Aus Liste mit Warteschlangen auswählen',
      Agents: 'Aus Liste mit Agenten auswählen',
      DialNumber: 'Name oder Nummer auswählen',
      DialNumberOrEntryPoint: 'Name/Nummer/Einstiegspunkt auswählen',
      ChooseByNameOrNumber: 'Name/Nummer auswählen',
      Organization: 'Nach Name/Rolle/Abteilung/Geschäftstelefon suchen',
      WebexOrganization: 'Suchen nach Name oder E-Mail',
      DialNumberSearch: 'Suchen nach Name oder Nummer'
    },
    type: 'Rücksprache',
    checkBoxLabel: 'Teilnehmern erlauben, weiter zu interagieren.',
    cancel: 'Abbrechen',
    closeModal: 'Modal schließen',
    failureError: 'Die Rückspracheanfrage kann nicht verbunden werden. Bitte versuchen Sie es erneut.',
    customerLeftMsg: 'Verbindung mit Kunde getrennt. Keine Rücksprache mehr erforderlich.',
    ctqFailureMsg:
      'Rücksprachenanruf konnte nicht in Warteschlange abgebrochen werden. Bitte versuchen Sie es erneut.',
    cancelCtqInfo:
      'Es wird nach einem verfügbaren Agenten in der gewählten Warteschlange gesucht. Warten Sie, oder brechen Sie die Rücksprachenanfrage ab.',
    cancelCtqAction: 'Rücksprache abbrechen',
    entryPoint: 'Einstiegspunkt'
  },
  conference: {
    title: 'Konferenzanfrage',
    heading: {
      chat: 'Speziellen Agenten für Konferenz-Chat auswählen'
    },
    queues: 'Warteschlange',
    agents: 'Agent',
    dialNumber: 'Rufnummer',
    organization: 'Organisation',
    placeholder: {
      Queues: 'Aus Liste mit Warteschlangen auswählen',
      Agents: 'Aus Liste mit Agenten auswählen',
      DialNumber: 'Name oder Nummer auswählen'
    },
    type: 'Konferenz',
    cancel: 'Abbrechen',
    closeModal: 'Modal schließen',
    failureError: 'Die Konferenzanfrage konnte nicht initiiert werden. Bitte versuchen Sie es erneut.'
  },
  transferModal: {
    Agents: 'Die Agentenliste kann nicht abgerufen werden. Aktualisieren Sie die Liste.',
    AgentsEmpty: 'Kein verfügbarer Agent',
    Queues: 'Die Warteschleifenliste kann nicht abgerufen werden. Aktualisieren Sie die Liste.',
    QueuesEmpty: 'Keine Warteschlange verfügbar',
    EPEmpty: 'Kein Einstiegspunkt verfügbar',
    DialNumber:
      'Die Liste der Rufnummern kann nicht aus dem Adressbuch abgerufen werden. Aktualisieren Sie die Liste.',
    EntryPoint:
      'Die Liste der Einstiegspunkt-Nummern kann nicht aus dem Adressbuch abgerufen werden. Aktualisieren Sie die Liste.',
    Common: 'Die Liste kann nicht abgerufen werden. Aktualisieren Sie die Liste.',
    DialNumberEmpty: 'Keine Rufnummer verfügbar',
    DialNumbInvalid:
      'Die Rufnummer ist ungültig. Wenden Sie sich an den Administrator.',
    DialNumbOrEntryPointInvalid:
      'Rufnummer/Einstiegspunkt ist ungültig. Wenden Sie sich an den Administrator.',
    refreshQueueList: 'Liste der Warteschleifen aktualisieren',
    refreshAgentList: 'Agentenliste aktualisieren',
    refreshEpList: 'Einstiegspunkte aktualisieren',
    refreshAddressBook: 'Adressbuch aktualisieren',
    refreshTheList: 'Liste aktualisieren',
    entryPointSectionLabel: 'Einstiegspunkt',
    addressBookSectionLabel: 'Adressbuch',
    organization: 'Organisation',
    comboBoxAriaLabelAgent: 'Aus Liste mit Agenten auswählen',
    comboBoxAriaLabelQueue: 'Aus Liste mit Warteschlangen auswählen',
    comboBoxAriaLabelEp: 'Aus einer Liste von Einstiegspunkten wählen',
    infScrollAgent: 'Agenten durchsuchen',
    infScrollQueue: 'Warteschlangen durchsuchen',
    infScrollEP: 'Einstiegspunkte durchsuchen',
    allRadioButtonHidedTextForConsult: 'Ihnen sind keine Entitäten zugewiesen, um diese Interaktion zu konsultieren. Wenden Sie sich an den Administrator.',
    allRadioButtonHidedTextForTransfer: 'Ihnen sind keine Entitäten zugewiesen, um diese Interaktion zu übergeben. Wenden Sie sich an den Administrator.',
    allRadioButtonHidedTextForConference: 'Ihnen sind keine Entitäten zugewiesen, um diese Interaktion als Konferenz abzuhalten. Wenden Sie sich an den Administrator.',
    searchMinCharError: 'Geben Sie für die Suche mindestens drei Zeichen ein.',
  },
  wrapup: {
    cancelautowrapup: 'Automatische Nachbearbeitung abbrechen',
    wrapupreason: 'Nachbearb.-gründe',
    untilautowrapup: 'bis automatische Nachbearbeitung',
    followupsetting: 'Nachbearbeitungseinstellung',
    lastagentroute: 'Weiterleitung letzter Agent',
    submitwrapup: 'Nachbearbeitung senden',
    wrapupsearch: 'Nachbearbeitungsgrund suchen',
    invalidationError: 'Nachbearbeitung konnte nicht gesendet werden',
    searchResult: 'Suchergebnisse verfügbar',
    noResultFound: 'Keine Suchergebnisse gefunden',
    listContainerLabel: 'Listen-Container der Nacharbeitsdaten',
    searchError: 'Geben Sie mindestens drei Zeichen ein, um nach Nachbereitungsgründen zu suchen.',
  },

  outdial: {
    call: 'Anruf',
    dialpadSearch: 'Nummer anwählen',
    addressSearch: 'Nach Name/Nummer suchen',
    addressTab: 'Adresse',
    addressTabTooltip: 'Im Adressbuch suchen',
    dialpadTab: 'Wähltastatur',
    dialpadTooltip: 'Nummer wählen',
    searchTab: 'Suche',
    searchTabTooltip:'Nach Personen in meiner Organisation suchen',
    noAdrFound: 'Keine Ergebnisse gefunden',
    noContacts: 'Keine Kontakte',
    mainIconTooltip: 'Externer Anruf',
    errorOutdialFailed:
      'Externer Anruf fehlgeschlagen. Desktop konnte den Anruf nicht verbinden, oder der Anruf wurde nicht angenommen.',
    errorOutdialDisabled: 'Externe Anrufe sind deaktiviert',
    errorDialPadValidationMessage: 'Falsches Format',
    outdialReqInProgress: 'Laufender externer Anruf',
    outdialAniPlaceholder: 'ANI für ausgehende Anrufe auswählen',
    outdialAniLabel: 'Outdial-ANI',
    outdialAniPlaceHolder: 'ANI für ausgehende Anrufe suchen',
    errorDcCallsLimitExceeded:
      'Das Rechenzentrum hat die maximale Anzahl an ausgehenden Anrufen erreicht. Keine weiteren ausgehenden Anrufe möglich',
    errorOrgCallsLimitExceeded:
      'Die Organisation hat die maximale Anzahl an ausgehenden Anrufen erreicht. Keine weiteren ausgehenden Anrufe möglich.',
    errorOutDialNoAnswerFromCustomer:
      'Der Kunde hat den Anruf nicht angenommen, bitte später anrufen.',
    errorOutDialCustomerUnavailable:
      'Der Kunde ist derzeit nicht verfügbar, bitte später anrufen.',
    errorOutDialAgentEnds: 'Sie haben den Anruf mit dem Kunden beendet.',
    errorOutDialCustomerBusy: 'Beim Kunden ist derzeit besetzt, bitte später anrufen.',
    searchError: 'Geben Sie mindestens drei Zeichen ein, um die Kontakte zu durchsuchen.',
    upArrowLabel: 'Erweitern',
    clear: 'Eingabe löschen',
    outdialDialogDescription: 'Sie befinden sich gerade in einem Dialog mit Registerkarten.'
  },

  organization: {
    noMatchFound: 'Keine Ergebnisse gefunden',
    searchError: 'Geben Sie mindestens drei Zeichen ein, um die Kontakte zu durchsuchen.',
    authError: 'Keine Kontakte zum Anzeigen vorhanden. Microsoft-Authentifizierung fehlgeschlagen.'
  },

  interactionPopover: {
    of: 'von',
    accept: 'Anneh.',
    acceptAriaLabel: 'Aufgabe {taskNumber} – {taskType} annehmen von {from}',
    requests: 'Anfrage(n)',
    back: 'Zurück',
    next: 'Weiter',
    acceptMultipleRequest: '{requestCount} Anforderungen akzeptieren',
    paginationDetail: '{indexStart}–{indexEnd} von {totalPopoverpoolLength}',
    hidePopoverDetails: 'Popover-Details ausblenden',
    showPopoverDetails: 'Popover-Details anzeigen',
    customerName: 'Kundenname',
    email: 'E-Mail',
    queueName: 'Name d. Wartes.',
    failedToAccept: 'Akzeptieren fehlgeschlagen.',
    unableToAccept: 'Der Kontakt kann nicht angenommen werden.',
    failedToEnd: 'Beenden fehlgeschlagen.',
    unableToEnd: 'Der Kontakt kann nicht beendet werden. ',
    ringing: 'Klingeln',
    calling: 'Anrufen',
    phoneNumber: 'Telefonnummer',
    dni: 'DNIS',
    ivrPathId: 'IVR-Pfad-ID',
    pathId: 'Pfad-ID',
    rona: 'RONA',
    sourcePage: 'Quellseite',
    sourceNumber: 'Quellnummer',
    appUserId: 'App-Benutzer-ID',
    acceptAll: 'Alle Aufgaben akzeptieren',
    agentDn: 'Agenten-Verzeichnisnummer',
    agentName: 'Agentname',
    agentTeam: 'Agententeam',
    requestDetails: 'Details anfragen',
    incomingCallFrom: 'Eingehender Anruf von',
    unableToAnswer: 'Anruf kann nicht angenommen werden. Bitte versuchen Sie es erneut.',
    unableToDecline: 'Anruf kann nicht umgeleitet werden. Bitte versuchen Sie es erneut.'
  },

  multiLogin: {
    header: 'Warnung zu mehrfacher Anmeldung',
    message:
      'Sie sind auf dem Desktop in mehreren Anwendungsinstanzen angemeldet. Klicken Sie auf „Weiter“, um mit dem Desktop in dieser Anwendungsinstanz fortzufahren, oder schließen Sie dieses Fenster.',
    continue: 'Fortfahren'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Übergabe an Einstiegspunkt/Warteschlange aufgrund eines Konfigurationsfehlers fehlgeschlagen.',
    1010: "Rücksprache ist nicht möglich, da der Agent nicht rechtzeitig zugewiesen werden konnte. ",
    1042: "Der Kontakt wurde nicht gefunden.",
    1043: 'Das Ziel ist ungültig.',
    1045: 'Die Interaktion ist dem Agenten nicht zugewiesen.',
    1046: 'Rücksprache mit dem Agenten ist fehlgeschlagen, da kein übereinstimmender Agentenkanal im System gefunden wurde.',
    1038: "Der Agent wurde nicht gefunden.",
    1037: 'Die Anmeldung ist aufgrund eines internen Fehlers fehlgeschlagen.',

    // Media Events
    138: 'Die Aktion aus unbekannten Gründen fehlgeschlagen.',
    136: 'Der Benutzer wurde nicht gefunden.',

    // AgentConsultFailed
    1050: 'Eine Rücksprache ist aufgrund einer nicht unterstützter Konfiguration oder Aktivität im Flow nicht möglich. ',
    1005: "Rücksprache nicht möglich, da der Agent die Anforderung nicht rechtzeitig beantwortet hat.",
    1051: 'Rücksprache oder Übertragung aufgrund eines ungültigen Einstiegspunkts oder einer ungültigen Rufnummer nicht möglich.',

    // AgentInviteFailed
    1053: 'Die Interaktion kann aufgrund einer ausstehenden Workflow-Aufgabe zur erneuten Warteschlangeneinreihung nicht angezeigt werden.',
    1054: 'Externer Anruf kann aufgrund von Medienproblemen mit dieser Anforderung nicht getätigt werden. ',

    // AgentContactAssignFailed
    1011: 'Der Anruf kann aufgrund fehlender Agenten in der laufenden Interaktion nicht beantwortet oder angenommen werden. ',

    // ContactCallbackFailed
    1034: 'Der Rückruf des Kontakts ist fehlgeschlagen, da ContactParkTimeout für die Anforderung eingegangen ist.',

    // ContactUpdateFailed
    1020: "Die Variablen können nicht aktualisiert werden, da einer der Werte die Zeichenbeschränkung von 256 überschreitet. Verringern Sie die Zeichenanzahl, und versuchen Sie es erneut.",

    // AgentInviteFailed
    1031: 'Der Agent hat den Kunden eingeladen, nachdem der Rückruf angefordert wurde.',

    // AgentBlindTransferFailedEvent
    1044: 'Die Übergabe ohne Rückfrage des Agenten ist fehlgeschlagen, da der Ziel-Agent einer anderen Interaktion zugewiesen ist.',

    // AgentCtqCancelFailed
    1047: "Der Kontakt wurde nicht gefunden.",

    // AgentCtqFailed
    1048: "Die Anrufverteilungsgruppe ist nicht konfiguriert.",
    1049: 'Die maximale Wartezeit in der Warteschlange wurde überschritten.',
    // StationLoginFailed
    127: 'Agenten-DN-Registrierung mit doppelter Anmelde-Ausnahme fehlgeschlagen.'
  },

  stateSelector: {
    Available: 'Verfügbar',
    errorstatechange: 'Die Statusänderung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
    errorStateChangeInPendingLogout: 'Agentenstatus konnte aufgrund ausstehender Abmeldung nicht geändert werden.',
    label: 'Verfügbarkeitsstatus',
    agentStateSelector: 'Agentenstatus-Selektor',
    Engaged: 'Beschäftigt',
    engagedAvailableInfo:
      'Sie befinden sich derzeit in einer Interaktion und haben den Status „Verfügbar“.',
    engagedIdleInfo:
      'Sie befinden sich derzeit in einer Interaktion und haben den Status „Frei“.',
    engagedInfo: 'Sie befinden sich derzeit in einer Interaktion.',
    engagedSupervisorStateChange: 'Status geändert in',
    axAgentStateChanged: 'Ihr Status wurde geändert in',
    axAgentSync: 'aufgrund der Statussynchronisierung mit Ihrem Collaboration-Tool.',
    engagedPresenceInfo:
      'Sie befinden sich derzeit in einer Interaktion und Ihr Status ist',
    engagedPresenceSync: 'aufgrund der Statussynchronisierung mit Ihrem Collaboration-Tool.',
    clear: 'Eingabe löschen',
    searchState: 'Eingabe',
    agentStatusLabel: 'Agentenstatus',
    agentStateLabel: 'Agent befindet sich seit {selectedTimeValue}im Status {selectedState}.',
    agentStateLabelOnStateChange: 'Agent befindet sich seit den letzten 0 Sekunden im Status {selectedState}.',
    agentStateChangeSuccessful:'Status erfolgreich in {selectedState} geändert.',
    agentStateChangeFail:'Status konnte nicht in {selectedState} geändert werden.',
    searchError: 'Geben Sie mindestens drei Zeichen ein, um nach Status zu suchen.'
  },

  warningMessage: {
    header: 'Nicht gespeicherte Änderungen',
    message:
      'Sie haben nicht gespeicherte Änderungen auf dieser Seite. Möchten Sie diese Seite wirklich verlassen? ',
    cancelButton: 'Bleiben',
    saveButton: 'Verlassen'
  },

  notificationLables: {
    muteVolume: 'Benachrichtigungston stummschalten',
    unmuteVolume: 'Benachrichtigungston freischalten',
    notificationVolume: 'Benachrichtigungslautstärke',
    playSound: 'Benachrichtigungston abspielen',
    enableSoundNotificationSettings: 'Benachrichtigungstöne aktivieren',
    enableSoundNotificationSettingsDescription:
      'Spielt Benachrichtigungstöne bei eingehenden Anfragen ab. Sie können nachfolgend die Lautstärke anpassen.',
    volumeTitle: 'Tonlautstärke'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Anruf',
    chat: 'Chat',
    email: 'E-Mail',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Business Messages von Google"
  },
  orgDetailsLabels: {
    role: 'Rolle',
    department: 'Abteilung',
    email: 'E-Mail',
    businessPhone: 'Geschäftstelefon',
    workPhone: 'Geschäftlich',
  },
  addressListError: {
    title: 'Daten konnten nicht geladen werden',
    errorId: 'Fehler-ID:'
  },
  keypad: {
    keyPadSearch: 'Nummer eingeben',
    dialPad: 'Wähltastatur'
  },
  collabTool: {
    userAuthenticated: 'Benutzerauthentifizierung:',
    successful: 'Erfolgreich',
    failed: 'Fehlgeschlagen.',
    tryAgain: 'Erneut versuchen',
    stateSync: 'Statussynchronisierung:',
    mercuryFailedInfo: ' Wenden Sie sich an den Administrator.',
    retrying: 'Neuer Versuch...',
    trackingIdLabel: 'Nachverfolgungs-ID: '
  },
  webex: {
    webex: 'Webex',
    info: 'Die Integration ermöglicht die Synchronisierung des Status zwischen Desktop und Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Mit dieser Integration können Sie Rücksprachen zu Anrufen halten oder diese an die Benutzer von Microsoft Teams übergeben.',
    authenticationFailedInfo:
      'Wenn bereits ein Authentifizierungsfenster geöffnet ist, wiederholen Sie die Authentifizierung dort.',
    ListItemContactDetails:
      'Der Name des Kontakts ist: {name}, seine Präsenz ist: {presence}, die Abteilung ist: {department}, der jobTitle ist: {jobTitle} und die Telefonnummer ist: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Notfalldienstbenachrichtigung',
    readNotification: 'Ich habe die Benachrichtigung gelesen.'
  },
  webexPresenceStatus: {
    active: 'Aktiv',
    lastActiveFewMinutesAgo: 'In den letzten Minuten aktiv',
    lastActiveMinutesAgo: 'Vor {min} Minuten aktiv',
    lastActive1HourAgo: 'Letzte Aktivität vor 1 Stunde',
    lastActiveHoursAgo: 'Vor {hour} Stunden aktiv',
    lastActiveYesterday: 'Gestern aktiv',
    lastActiveOnDate: 'Am {date} aktiv',
    busy: 'Belegt',
    busyUntil: 'Belegt bis {date}',
    dnd: 'Nicht stören',
    dndUntil: 'Bitte nicht stören bis {date}',
    quiet: 'Ruhe',
    quietUntil: 'Ruhe bis {date}',
    ooo: 'Abwesend',
    outOfOfficeUntil: 'Abwesend bis {date}',
    call: 'Am Telefon',
    meeting: 'In einem Meeting',
    calendarItem: 'In einem Kalender-Meeting',
    presenting: 'Präsentation',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Nach Name oder Profildetails suchen',
    webexPlaceholder: 'Suchen nach Name oder E-Mail',
    refreshTheList: 'Liste aktualisieren',
    refreshAddressBook: 'Adressbuch aktualisieren',
    microsoftAuthError: 'Keine Kontakte zum Anzeigen vorhanden. Microsoft-Authentifizierung fehlgeschlagen.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/en.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/en.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Failed to load data',
    errorID: 'Error ID',
    tryAgain: 'Try Again',
    Error: 'Error',
    okButton: 'OK',
    Yes: 'Yes',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    Continue: 'Continue',
    Canceling: 'Canceling',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: 'Answer',
    AnswerAriaLabel: 'Answer desktop task',
    Decline: 'Decline',
    ErrorSecurityCompliance: 'Security Compliance',
    errorDetails: 'Error Details',
    learnMore: 'Learn More',
    showLess: 'Show Less',
    trackingIdDescription:
      'Please share the Tracking ID with site administrator or the support team to investigate the situation.',
    trackingIdInputLabel: 'Tracking ID: ',
    submitForm: 'Submit Form',
    unnamedStatus: 'Unnamed Status',
    errorChatMsg: 'Failed to load chat data',
    noOptions: 'No Options',
    noResults: 'No Results',
    more: 'More',
    nomatchfound: 'No matches found',
    collaborationTool: 'Collaboration tool',
    timerAriaLabel: 'Time Spent',
    historyItemTime: 'Happened at',
    loading: 'Loading',
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    loadingMsg: 'Loading..',
    search: 'Search',
    historyChannelLabels: {
      All: 'All',
      telephony: 'Voice',
      chat: 'Chat',
      email: 'Email',
      social: 'Social'
    },
    homePageLabel: 'Home Page',
    resizeHistoryDragger: 'Resize history dragger',
    agentHistoryLabel: 'agent history',
    clear: 'Clear Input',
    ariaLabelAgentHistoryWrapper:
      'Agent Interaction History Displays your recent customer communications across different channels from the past 24 hours',
    sliderResizerInstructions:
      'You are currently on a slider. To resize use Arrow Keys',
    resizeHistoryPanel: 'Resize history panel, slider,',
    time: {
      hours: 'hour',
      minutes: 'min',
      seconds: 'sec'
    }
  },
  email: {
    ToLabel: 'To',
    FromLabel: 'From',
    CcLabel: 'Cc',
    BccLabel: 'Bcc',
    SubjectLabel: 'Subject',
    HideLabel: 'Hide',
    SendLabel: 'Send',
    ShowPrevThread: 'Show Previous Thread',
    HidePrevThread: 'Hide Previous Thread',
    ReplyLabel: 'Reply',
    ReplyAllLabel: 'Reply All',
    ViewOriginalMail: 'View Original Email',
    QuickReplyInp: 'Quick reply here...',
    AttachFiles: 'Attach Files',
    ToolbarHeading: 'Heading1',
    ToolbarBold: 'Bold',
    ToolbarItalic: 'Italic',
    ToolbarUnderLine: 'Underline',
    ToolbarBlockQuote: 'Blockquote',
    ToolbarCode: 'Code Block',
    ToolbarListOrder: 'List By Ordered',
    ToolbarListBullet: 'List By bullet',
    ToolbarLink: 'Link',
    ToolbarStrike: 'Strikethrough',
    ToolbarColor: 'Text Color',
    ToolbarTable: 'Table',
    insertTable: 'Insert Table',
    insertRowAbove: 'Insert Row Above',
    insertRowBelow: 'Insert Row Below',
    insertColumnLeft: 'Insert Column Left',
    insertColumnRight: 'Insert Column Right',
    deleteRow: 'Delete Row',
    deleteColumn: 'Delete Column',
    deleteTable: 'Delete Table',
    link: 'Link',
    IndentRight: 'Indent Right',
    IndentLeft: 'Indent Left',
    showMoreAttachment: 'Show more attachments',
    AttachmentLimit: 'Attach up to ',
    attachments: ' attachments, ',
    sizeLimit: ' MB maximum',
    attachment: 'Attachment',
    errordeleteattachment: 'Unable to delete file(s). Please try again.',
    errordownloadattachment: 'Unable to download file(s). Please try again.',
    erroraddattachemnt: 'Unable to upload file(s). Please try again.',
    errorendcontact: 'Unable to end the interaction. Please try again.',
    erroraddlimitreached:
      'File could not be attached because it exceeds the maximum ',
    errorattachmentdrop:
      'Attachment(s) dropped as per the company’s security policy.',
    errorfiletype: 'The file type is not supported. Please try again.',
    errorcreditcard:
      'Unable to upload attachment(s) as per the company’s security policy.',
    errorcontainsimage:
      'Unable to upload attachment(s). Images in attachments are not supported by the company’s security policy.',
    errorlimit: ' MB limit.',
    errorsendemail: 'Unable to send the email. Please try again.',
    errorpcicheckemail: 'Unable to retrieve PCI data. Please try again.',
    errortext: 'Failed to load data',
    tryAgain: 'Try Again',
    replywarning:
      'Do not share Financial, Health, or any Personally Identifiable Information (PII) in this message or attachments.',
    datamasked:
      'The email subject or body is redacted as per the company’s security policy. Are you sure you want to send the email?',
    pcibannerwarning:
      'The email subject or body is redacted as per the company’s security policy.',
    on: 'On',
    wrote: 'wrote'
  },
  interaction_control: {
    windowOpened: 'Window Opened',
    connected: 'Connected',
    consultRequested: 'Consult Requested',
    consulting: 'Consulting',
    consultCallOnHold: 'Consult on Hold',
    callOnHold: 'Call on Hold',
    consult: 'Consult',
    endconsult: 'End Consult',
    hold: 'Hold',
    transfer: 'Transfer',
    conference: 'Conference',
    endconference: 'End Conference',
    conferenceRequested: 'Conference Requested',
    switchCall: 'Switch',
    mergeCall: 'Merge',
    wrapup: 'Wrap Up',
    end: 'End',
    customername: 'Customer Name',
    dn: 'DNIS',
    ivrpath: 'IVR Path',
    email: 'Customer Email',
    ani: 'Phone Number',
    queueid: 'Queue Name',
    ronatimeout: 'Rona Time',
    pathid: 'IVR Path ID',
    dnis: 'DNIS',
    destagentphonenumber: 'Agent DN',
    destagentname: 'Agent Name',
    virtualteamname: 'Queue',
    category: 'Category',
    additionaldetails: 'Additional Details',
    sourcenumber: 'Source Number',
    sourcepage: 'Source Page',
    appuser: 'App User ID',
    customernumber: 'Phone Number',
    exitconference: 'Exit Conference',
    resume: 'Resume',
    pauserecording: 'Pause Recording',
    resumerecording: 'Resume Recording',
    exitconsult: 'Exit Consult',
    pauseRecordingFailed: 'Unable to pause recording. Please try again.',
    resumeRecordingFailed: 'Unable to resume recording. Please try again.',
    holdCallFailed: 'Unable to hold the call. Please try again.',
    resumeCallFailed: 'Unable to resume the call. Please try again.',
    endCallFailed: 'Unable to end the interaction. Please try again.',
    consultTransferFailed:
      'Unable to transfer the consult call. Please try again.',
    conferenceTransferFailed:
      'Unable to transfer the conference call. Please try again.',
    conferenceFailed:
      'Unable to connect the conference request. Please try again.',
    consultEndFailed: 'Unable to end the consult request. Please try again.',
    conferenceExitFailed:
      'Unable to exit the conference request. Please try again.',
    conferenceEndFailed:
      'Unable to end the conference request. Please try again.',
    cancelCtqFailed:
      'Unable to cancel the consult call to the queue. Please try again.',
    privacyShield: 'Privacy Shield',
    errorOnPrvacyShieldForConsult:
      'Recording is currently paused. Please resume recording to start a consult call.',
    errorOnPrvacyShieldForTransfer:
      'Recording is currently paused. Please resume recording to start a Transfer call.',
    cancelConsult: 'Cancel Consult',
    cancelTransfer: 'Cancel Transfer',
    copy: 'Copy',
    copied: 'Copied',
    cadrequestuccess: 'Customer Information has been saved successfully.',
    cadrequestfailure: 'Failed to save customer information. Please try later.',
    cadupdatedmessage: 'Customer information was recently updated by',
    unsavedmessage: 'Your unsaved changes are overwritten.',
    save: 'Save',
    revert: 'Revert',
    expandDetails: 'Expand Details',
    collapseDetails: 'Collapse Details',
    cadValidationError:
      'Invalid format. Use the international standard for date and time.',
    secureCadSaveError:
      'Customer information is not saved. Click Save to try again.',
    secureDecryptionError: 'Secure variables cannot be displayed.',
    clickToTry: 'Click to retry',
    isSecureVariable: 'is a secure variable',
    contactorigin: 'Contact Origin',
    resumeMonitoring: 'Resume Monitoring',
    pauseMonitoring: 'Pause Monitoring',
    whisperCoach: 'Whisper Coach',
    bargeIn: 'Barge In',
    endMonitoring: 'End Monitoring',
    contactphonenumber: 'Contact Phone Number',
    contactqueue: 'Contact Queue',
    activeparticipants: 'Active Participants',
    consultedparticipant: 'Consulted Participant',
    contactstatus: 'Contact Status',
    timeincontactstatus: 'Time In Contact Status',
    totalcontactduration: 'Total Contact Duration',
    agentinteractiontime: 'Interaction Duration',
    recording: 'Recording',
    monitoring: 'Monitoring',
    monitoringPaused: 'Monitoring Paused',
    pauseMonitoringFailed: 'Unable to pause the monitoring. Please try again',
    resumeMonitoringFailed: 'Unable to resume the monitoring. Please try again',
    callCancelledInProgress: 'Call cancel in progress',
    bargedIn: 'Barged In',
    keypad: 'Keypad',
    mute: 'Mute',
    unmute: 'Unmute',
    bargeInTooltipText:
      'The mic will turn on and you will join this customer interaction',
    bargeInCompactTooltipText:
      'Barge In. The mic will turn on and you will join this customer interaction',
    bargeInTooltipDisabled: 'Please resume monitoring to enable barge in',
    bargeInFailedTitle: 'Barge In Failed',
    bargeInFailedData:
      'There was an error while you tried to barge in. Please try again after sometime.',
    supervisorBargedIn: 'has barged into your call.',
    leftInteraction: 'has left the interaction.',
    conferenceEnded: 'Conference call has ended.',
    participants: 'Participants',
    badgeAriaLabel: '{participant} is in the call',
    bargeInConferenceAriaLabel: 'There are two Participants in the interaction',
    taskName: 'Interaction Control Task Name',
    interactionDurationLabel: 'Duration time',
    wrapupassist: 'Wrap Up Assistance',
    consultingTaskContext: 'Consulting call from',
    consultExited: 'Consult call exited',
    endCall: 'End the call.',
    exitconferenceCall:
      'Exit the call and the conference continues with active participants.',
    recordingInProgess: 'Recording in Progress',
    recordingPaused: 'Recording paused',
    searchPlaceholder: 'Search contacts',
    postCall: "Post Call",
    switchCallTooltip: "Switch to call",
    switchConsultTooltip: "Switch to consult call",
    switchConferenceTooltip: "Switch to conference call",
    confirmationDialog: {
      endCallTitle: 'Do you want to end the call?',
      endCallMessage: 'Click Confirm to end the call for all participants.',
      exitConferenceTitle: 'Do you want to exit the conference call?',
      exitConferenceMessage:
        'Click Confirm to exit the conference call and allow the other participants to continue.',
      confirmButtonLabel: "Confirm",
      cancelButtonLabel: "Cancel",  
    },
    postCallConsult: "Post Call Consult",
  },
  agentProfile: {
    teamName: 'Team',
    dialNumber: 'Dial Number',
    phoneNumber: 'Phone Number',
    settings: 'Change Settings',
    signOut: 'Sign Out',
    webRTCDisconnected: 'Warning Desktop Telephony disconnected ',
    msAuthFailed: 'Microsoft authentication failed',
    stateSyncFailed: 'State synchronization failed',
    userProfileLabel: 'User Profile',
    ariaAgentprofile: 'Agent Profile',
    ChannelCapacity: 'Channel Capacity',
    voice: 'Voice',
    chat: 'Chat',
    email: 'Email',
    social: 'Social',
    channelCapacityTooltip: 'Click to see more',
    blendedRouting: 'Blended',
    exclusiveRouting: 'Exclusive Routing',
    realtimeRouting: 'Blended Routing Real-time',
    blendedRoutingTooltip: 'Handle multiple contacts across channels.',
    exclusiveRoutingTooltip: 'Handle only one contact at a time.',
    realtimeRoutingTooltip: 'Handle one mandatory real-time channel.',
    errorActiveContacts:
      'You cannot sign out now because you have active conversations. Complete them and try again.',
    searchTeams: 'Search Teams',
    changeTeamsConfirmHeader: 'Change Team Confirmation',
    changeTeamsConfirmMessage: 'Are you sure you want to change your team?',
    changeTeamLabel: 'Change Team',
    errorChangeTeams:
      'You cannot change the team now because you have active request(s). Please complete them and try again.',
    saveTeamSelection: 'Save Team Selection',
    userSettings: 'User Settings',
    resetLayout: 'Reset Entire Desktop Layout',
    resetConfirmHeader: 'Reset Layout Confirmation',
    resetConfirmMessage:
      'Are you sure you want to reset the entire Desktop layout? <br/> The Desktop will return to the default layout.',
    downloadLogs: 'Download Error Report',
    help: 'Help',
    signoutConfirm: 'Are you sure you want to sign out?',
    signoutConfirmHeader: 'Sign Out Confirmation',
    darkTheme: 'Switch to Dark Mode',
    newLook: 'Switch to New Look',
    keyboardShortcuts: 'Keyboard Shortcuts',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Notification Settings',
    silentNotification: 'Silent Notification',
    enableNotificationSettings: 'Enable Notifications',
    enableSilentNotificationSettings: 'Enable Silent Notifications',
    suppressWebexCallingNotificationSettings: 'Hide Webex Calling Notifications',
    notificationSettingDescription:
      'Delivers notifications such as new messages, alerts and status changes.',
    silentNotificationDescription:
      'Turns off the on-screen alerts. You can view the notifications in the Notification Center.',
    suppressWebexCallingNotificationDescription: 
    'Don\'t show pop-up notifications for incoming Webex calls and answer them through Webex Contact Center.',
    personalGreetings: 'Personal greetings',
    arrowLabel: 'Go back',
    managedTeams: 'Managed Teams',
    managedTeamsError: 'Failed to load teams.',
    viewAll: 'View All',
    profileSettings: 'Profile Settings',
    userRole: 'Role',
    saveSelection: 'Save Selection',
    extension: 'Extension',
    changeProfileConfirmHeader: 'Confirm Profile Settings Changes',
    changeProfileConfirmMessage:
      'Are you sure you want to save your profile changes?',
    confirm: 'Confirm',
    errorProfileUpdate:
      'You cannot change the Profile Settings now because you have active requests. Please complete them and try again.',
    roleAgentSupervisor: 'Supervisor and Agent',
    roleSupervisor: 'Supervisor',
    noTeam: 'No Team',
    testYourNetwork: 'Test Your Network',
    speakerAndMic: 'Speaker and Microphone',
    speaker: 'Speaker',
    mic: 'Microphone',
    speakerDescription:
      'Choose and test the output device to ensure that you hear the caller.',
    micDescription:
      'Choose and test the input device to ensure that the caller hears you.',
    micError:
      'Access to microphone is denied. Enable access through browser settings or contact your administrator.',
    speakerError:
      'Speaker is currently not available as access to microphone is denied.',
    telephony: 'Telephony',
    desktop: 'Desktop',
    onSpeakerPlay:
      'If you can’t hear the test sound, check the speaker device.',
    onMicPlay:
      'If you can’t hear the test sound, check both speaker and microphone.',
    onMicRecord: 'Record a message for playback.',
    test: 'Test',
    recording: 'Recording',
    playing: 'Playing',
    reconnecting: 'Reconnecting',
    disconnectMessage:
      'Desktop telephony disconnected. Try a different telephony option.',
    singleTelephonyDisconnectMessage:
      'Desktop telephony disconnected. Contact your administrator.',
    clear: 'Clear Input',
    rememberMeCheckBoxMessage: "Don't show this again",
    saveLabel: 'Save',
    browserUnsupportedError: "Sign in failed because you are using an unsupported browser.",
    microphoneAccessDeniedError: "Access to microphone is denied. Enable access through browser settings or contact your administrator.",
  },
  contactHistory: {
    mainHeader: 'Contact History',
    handledBy: 'Handled by',
    noRecordFound: 'No contact history found!',
    tryAgain: 'Try Again',
    errorMsg: 'Unable to retrieve the contact history. Please try again.',
    errorID: 'Error ID',
    missingAni: 'ANI is missing',
    timeIcon: 'Duration',
    taskHandled: 'Task handled',
    noHistoryNew: 'No history',
    noHistory: 'No History',
    viewTranscript: 'View email message',
    transcriptFor: 'Transcripts for',
    editBeforeCall: 'Edit before Call',
    clickToCall: 'Click to Call',
    onAnActiveCallErrorMessage:
      'You cannot initiate a new call as you are already on an active call.',
    receivedFrom: 'Contact received from',
    initiatedTo: 'Contact initiated to',
    wrapUpReason: 'Wrap up reason',
    startCallTelephony:
      'Click the phone number link to start an outbound call.',
    contactHistoryList: 'Contact History List,',
    wrapUpCode: 'Wrap up code',
    agentName: 'Agent name',
    entryPointName: 'Entry point',
    acceptedTimeAndDate: 'Accepted time and date',
    duration: 'Duration',
    emailTranscript: 'Email transcript',
    clickToViewEmailTranscript: 'Click to view email transcript',
    listContainer: 'List Container'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Entry Point',
    date: 'Date',
    subject: 'Subject',
    from: 'From',
    sent: 'Sent',
    to: 'To',
    back: 'Back',
    errorTranscript: 'Error occurred while fetching transcripts',
    customer: 'Customer',
    inboundErrorMessage: 'Failed to load the customer email',
    outboundErrorMessage: 'Failed to load the agent response'
  },
  popoverTitle: {
    callback: 'Callback',
    outboundCall: 'Outbound Call',
    incomingCall: 'Incoming Call',
    progressiveCampaign: 'Campaign Call',
    courtesyCallback: 'Courtesy Callback',
    chat: 'Incoming Chat',
    incoming: 'Incoming',
    monitoringCall: 'Monitoring Call'
  },
  connecting: 'Connecting',
  initiating: 'Initiating',
  outbound: 'Outbound',
  transfer: {
    title: 'Transfer Request',
    heading: {
      chat: 'Select the agent or queue that you want to transfer to.',
      email: 'Select the queue that you want to transfer to.',
      telephony:
        'Select the agent, queue or dial number that you want to transfer to.',
      noQueueTelephony:
        'Select the agent or dial number that you want to transfer to.'
    },
    header: {
      chat: 'Select the agent or queue for transferring this contact.',
      email: 'Select the queue for transferring this contact.',
      telephony:
        'Select the agent, queue, dial number or organization for transferring this contact.',
      noQueueTelephony:
        'Select the agent, dial number or organization for transferring this contact.',
      noOrganizationTelephony:
        'Select the agent, queue or dial number for transferring this contact.',
      noQueueOrganizationTelephony:
        'Select the agent or dial number for transferring this contact.'
    },
    queues: 'Queue',
    agents: 'Agent',
    dialNumber: 'Dial Number',
    organization: 'Organization',
    placeholder: {
      Queues: 'Choose from a list of queues',
      Agents: 'Choose from a list of agents',
      DialNumber: 'Choose By Name or Number',
      DialNumberOrEntryPoint: 'Choose By Name/Number/Entry Point',
      ChooseByNameOrNumber: 'Choose by Name/Number',
      Organization: 'Search by Name/Role/Department/Business Phone',
      WebexOrganization: 'Search by name or email',
      DialNumberSearch: 'Search by Name or Number'
    },
    type: 'Transfer',
    cancel: 'Cancel',
    closeModal: 'Close Modal',
    failureError: 'Unable to transfer the request. Please try again.',
    entryPoint: 'Entry Point'
  },
  consult: {
    title: 'Consult Request',
    heading: {
      chat: 'Select the agent or queue that you want to transfer to.',
      email: 'Select the queue that you want to transfer to.',
      telephony:
        'Select the agent, queue or dial number that you want to consult with.',
      noQueueTelephony:
        'Select the agent or dial number that you want to consult with.'
    },
    header: {
      chat: 'Select the agent or queue for transferring this contact.',
      email: 'Select the queue for transferring this contact.',
      telephony:
        'Select the agent, queue, dial number or organization with which you want to consult.',
      noQueueTelephony:
        'Select the agent, dial number or organization with which you want to consult.',
      noOrganizationTelephony:
        'Select the agent, queue or dial number with which you want to consult.',
      noQueueOrganizationTelephony:
        'Select the agent or dial number with which you want to consult.'
    },
    queues: 'Queue',
    agents: 'Agent',
    dialNumber: 'Dial Number',
    organization: 'Organization',
    placeholder: {
      Queues: 'Choose from a list of queues',
      Agents: 'Choose from a list of agents',
      DialNumber: 'Choose By Name or Number',
      DialNumberOrEntryPoint: 'Choose By Name/Number/Entry Point',
      ChooseByNameOrNumber: 'Choose by Name/Number',
      Organization: 'Search by Name/Role/Department/Business Phone',
      WebexOrganization: 'Search by name or email',
      DialNumberSearch: 'Search by Name or Number'
    },
    type: 'Consult',
    checkBoxLabel: 'Allow participants to continue interacting.',
    cancel: 'Cancel',
    closeModal: 'Close Modal',
    failureError: 'Unable to connect the consult request. Please try again.',
    customerLeftMsg: 'Customer disconnected. Consult no longer needed.',
    ctqFailureMsg:
      'Unable to cancel the consult call to the queue. Please try again.',
    cancelCtqInfo:
      'Searching for an available agent in the selected queue. Please wait or cancel the consult request.',
    cancelCtqAction: 'Cancel Consult',
    entryPoint: 'Entry Point'
  },
  conference: {
    title: 'Conference Request',
    heading: {
      chat: 'Select a specific agent for conference chat'
    },
    queues: 'Queue',
    agents: 'Agent',
    dialNumber: 'Dial Number',
    organization: 'Organization',
    placeholder: {
      Queues: 'Choose from a list of queues',
      Agents: 'Choose from a list of agents',
      DialNumber: 'Choose By Name or Number'
    },
    type: 'Conference',
    cancel: 'Cancel',
    closeModal: 'Close Modal',
    failureError: 'Unable to initiate the conference request. Please try again.'
  },
  transferModal: {
    Agents: 'Unable to retrieve the list of agents. Please refresh the list.',
    AgentsEmpty: 'No agent available',
    Queues: 'Unable to retrieve the list of queues. Please refresh the list.',
    QueuesEmpty: 'No queue available',
    EPEmpty: 'No entry point available',
    DialNumber:
      'Unable to retrieve the list of dial numbers from the address book. Please refresh the list.',
    EntryPoint:
      'Unable to retrieve the list of entry point numbers. Please refresh the list.',
    Common: 'Unable to retrieve the list. Please refresh the list.',
    DialNumberEmpty: 'No Dial Number Available',
    DialNumbInvalid:
      'Dial number is invalid. Please contact your administrator.',
    DialNumbOrEntryPointInvalid:
      'Dial number/Entry Point is invalid. Please contact your administrator.',
    refreshQueueList: 'Refresh the List of Queues',
    refreshAgentList: 'Refresh the List of Agents',
    refreshEpList: 'Refresh the Entry Points',
    refreshAddressBook: 'Refresh the Address Book',
    refreshTheList: 'Refresh the List',
    entryPointSectionLabel: 'Entry Point',
    addressBookSectionLabel: 'Address Book',
    organization: 'Organization',
    comboBoxAriaLabelAgent: 'Choose from a list of agents',
    comboBoxAriaLabelQueue: 'Choose from a list of queues',
    comboBoxAriaLabelEp: 'Choose from a list of entry points',
    infScrollAgent: 'Search agents',
    infScrollQueue: 'Search queues',
    infScrollEP: 'Search Entry Points',
    allRadioButtonHidedTextForConsult: 'You have no assigned entities to consult this interaction. Contact your Administrator.',
    allRadioButtonHidedTextForTransfer: 'You have no assigned entities to transfer this interaction. Contact your Administrator.',
    allRadioButtonHidedTextForConference: 'You have no assigned entities to conference this interaction. Contact your Administrator.',
    searchMinCharError: 'Enter minimum of three characters to search.',
  },
  wrapup: {
    cancelautowrapup: 'Cancel Auto Wrap Up',
    wrapupreason: 'Wrap Up Reasons',
    untilautowrapup: 'until auto wrap up',
    followupsetting: 'Follow Up Setting',
    lastagentroute: 'Last Agent Routing',
    submitwrapup: 'Submit Wrap Up',
    wrapupsearch: 'Search Wrapup Reason',
    invalidationError: 'Failed to submit wrap up',
    searchResult: 'Search results available',
    noResultFound: 'No search results found',
    listContainerLabel: 'Wrap Up List Container',
    searchError: 'Enter a minimum of three characters to search for wrap-up reasons.',
  },

  outdial: {
    call: 'Call',
    dialpadSearch: 'Enter number to dial',
    addressSearch: 'Search by Name/Number',
    addressTab: 'Address',
    addressTabTooltip: 'Search address book',
    dialpadTab: 'Dialpad',
    dialpadTooltip: 'Dial a number',
    searchTab: 'Search',
    searchTabTooltip:'Search for people in my organization',
    noAdrFound: 'No matches found',
    noContacts: 'No contacts',
    mainIconTooltip: 'Outdial Call',
    errorOutdialFailed:
      'Outdial call failed. Desktop was not able to connect the call, or the call was not answered.',
    errorOutdialDisabled: 'Outdial calls are disabled',
    errorDialPadValidationMessage: 'Incorrect Format',
    outdialReqInProgress: 'Outdial call is in progress',
    outdialAniPlaceholder: 'Select Outdial ANI',
    outdialAniLabel: 'Outdial ANI',
    outdialAniPlaceHolder: 'Search for outdial ANI',
    errorDcCallsLimitExceeded:
      'The data center has reached the maximum limit for outdial calls. Unable to make any more outdial calls',
    errorOrgCallsLimitExceeded:
      'The organization has reached the maximum limit for outdial calls. Unable to make any more outdial calls.',
    errorOutDialNoAnswerFromCustomer:
      'The customer did not answer your call. Try calling later.',
    errorOutDialCustomerUnavailable:
      'The customer is not available now. Try calling later.',
    errorOutDialAgentEnds: 'You ended your call with the customer.',
    errorOutDialCustomerBusy: 'The customer is busy now. Try calling later.',
    searchError: 'Enter minimum of three characters to search the contacts.',
    upArrowLabel: 'Expand',
    clear: 'Clear Input',
    outdialDialogDescription: 'You are currently on the dialogue with tabs.'
  },

  organization: {
    noMatchFound: 'No matches found',
    searchError: 'Enter minimum of three characters to search the contacts.',
    authError: 'No contacts to display. Microsoft authentication failed.'
  },

  interactionPopover: {
    of: 'of',
    accept: 'Accept',
    acceptAriaLabel: 'Accept task {taskNumber} - {taskType} from {from}',
    requests: 'Request(s)',
    back: 'back',
    next: 'next',
    acceptMultipleRequest: 'Accept {requestCount} Requests',
    paginationDetail: '{indexStart}-{indexEnd} of {totalPopoverpoolLength}',
    hidePopoverDetails: 'Hide Popover Details',
    showPopoverDetails: 'Show Popover Details',
    customerName: 'Customer Name',
    email: 'Email',
    queueName: 'Queue Name',
    failedToAccept: 'Failed to accept.',
    unableToAccept: 'Unable to accept the contact.',
    failedToEnd: 'Failed to end.',
    unableToEnd: 'Unable to end the contact. ',
    ringing: 'Ringing',
    calling: 'Calling',
    phoneNumber: 'Phone Number',
    dni: 'DNIS',
    ivrPathId: 'IVR Path ID',
    pathId: 'Path ID',
    rona: 'RONA',
    sourcePage: 'Source Page',
    sourceNumber: 'Source Number',
    appUserId: 'App User ID',
    acceptAll: 'Accept All Tasks',
    agentDn: 'Agent DN',
    agentName: 'Agent Name',
    agentTeam: 'Agent Team',
    requestDetails: 'Request Details',
    incomingCallFrom: 'Incoming Call from',
    unableToAnswer: 'Unable to answer the call. Please try again.',
    unableToDecline: 'Unable to decline the call. Please try again.'
  },

  multiLogin: {
    header: 'Multiple Sign In Alert',
    message:
      'You are signed in to the Desktop in multiple application instances. Click Continue to proceed with the Desktop in this application instance. Else, close this window.',
    continue: 'Continue'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Transfer to entry point/queue failed due to a configuration error.',
    1010: "Unable to consult as the agent couldn't be allocated in time. ",
    1042: "The contact isn't found",
    1043: 'The destination is invalid.',
    1045: 'The interaction is not assigned to the agent.',
    1046: 'Agent consult failed, as no matching agent channel is found in the system.',
    1038: "The agent isn't found",
    1037: 'Sign in failed due to Internal error.',

    // Media Events
    138: 'Action failed due to unknown reasons.',
    136: 'The user is not found',

    // AgentConsultFailed
    1050: 'Unable to consult due to unsupported configuration or activity in the flow. ',
    1005: "Unable to consult as the agent didn't answer the request on time.",
    1051: 'Unable to consult or transfer due to an invalid entry point or dial number.',

    // AgentInviteFailed
    1053: 'Unable to present the interaction due to a pending workflow requeue task.',
    1054: 'Unable to place outdial call due to media issues with this request. ',

    // AgentContactAssignFailed
    1011: 'Unable to answer or accept the call because of missing agents in the ongoing interaction. ',

    // ContactCallbackFailed
    1034: 'Calling back the contact failed as ContactParkTimeout is received for the request.',

    // ContactUpdateFailed
    1020: "Can't update the variables as one of the values exceeds the character limit of 256. Reduce the characters and try again.",

    // AgentInviteFailed
    1031: 'The agent has invited  the customer after the callback has been requested.',

    // AgentBlindTransferFailedEvent
    1044: 'Blind transfer of the agent failed, as the destination agent is assigned to another interaction.',

    // AgentCtqCancelFailed
    1047: "The contact isn't found.",

    // AgentCtqFailed
    1048: "The call distribution group isn't configured.",
    1049: 'The maximum wait time in the queue is exceeded.',
    // StationLoginFailed
    127: 'Agent DN Register failed with duplicate login exception.'
  },

  stateSelector: {
    Available: 'Available',
    errorstatechange: 'State change was not successful. Please try again.',
    errorStateChangeInPendingLogout: 'Failed to change agent state due to pending logout.',
    label: 'Availability State',
    agentStateSelector: 'Agent State Selector',
    Engaged: 'Engaged',
    engagedAvailableInfo:
      'You are currently engaged in an interaction and in the Available state.',
    engagedIdleInfo:
      'You are currently engaged in an interaction and in the Idle state',
    engagedInfo: 'You are currently engaged in an interaction.',
    engagedSupervisorStateChange: 'changed your state to',
    axAgentStateChanged: 'Your state changed to',
    axAgentSync: 'due to state sync with your collaboration tool.',
    engagedPresenceInfo:
      'You are currently engaged in an interaction and your state is',
    engagedPresenceSync: 'due to state sync with your collaboration tool.',
    clear: 'Clear Input',
    searchState: 'input',
    agentStatusLabel: 'Agent Status',
    agentStateLabel: 'Agent is in {selectedState} state for the last {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Agent is in {selectedState} state for the last 0 sec',
    agentStateChangeSuccessful:'State change to {selectedState} successful.',
    agentStateChangeFail:'State change to {selectedState} failed.',
    searchError: 'Enter a minimum of three characters to search for states.',
    stateChangeDisabled: 'Still establishing connection. Wait a moment before changing.'
  },

  idleCodeErrors: {
    errorHeader: "State changed to Idle",
    cancelButton: "Cancel",
    setAvailableButton: "Set as Available",
    invalidNumber: "You missed a call because your dial number is invalid. Your availability is now Idle. Update your dial number in your profile menu and set yourself as Available.",
    unreachable: "You missed a call because your dial number isn’t associated with a device. Your availability is now set to Idle. Do you want to switch back to Available?",
    declined: "You declined an interaction. Your availability is now set to Idle. Do you want to switch back to Available?",
    busy: "You missed a call because your device is in use. Your availability is now set to Idle. Do you want to switch back to Available?",
    channelFailure: "Something unexpected happened. Your availability is now set to Idle. Do you want to switch back to Available?",
    rona: "You missed an interaction. Your availability is now set to Idle. Do you want to switch back to Available?"
  },

  warningMessage: {
    header: 'Unsaved Changes',
    message:
      'You have unsaved changes on this page. Are you sure you want to leave this page? ',
    cancelButton: 'Stay',
    saveButton: 'Leave'
  },

  notificationLables: {
    muteVolume: 'Mute notification volume',
    unmuteVolume: 'Unmute notification volume',
    notificationVolume: 'Notification volume',
    playSound: 'Play notification sound',
    enableSoundNotificationSettings: 'Enable Sound Notifications',
    enableSoundNotificationSettingsDescription:
      'Delivers sound notifications for incoming requests. You can adjust the volume below.',
    volumeTitle: 'Sound Volume'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Call',
    chat: 'Chat',
    email: 'Email',
    facebook: 'Messenger',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: `Google's Business Messages`
  },
  orgDetailsLabels: {
    role: 'Role',
    department: 'Department',
    email: 'Email',
    businessPhone: 'Business Phone',
    workPhone: 'Work',
  },
  addressListError: {
    title: 'Failed to load data',
    errorId: 'Error ID:'
  },
  keypad: {
    keyPadSearch: 'Enter the number',
    dialPad: 'Dial Pad'
  },
  collabTool: {
    userAuthenticated: 'User authentication:',
    successful: 'Successful',
    failed: 'Failed.',
    tryAgain: 'Try Again',
    stateSync: 'State synchronization:',
    mercuryFailedInfo: ' Contact your administrator.',
    retrying: 'Retrying...',
    trackingIdLabel: 'Tracking ID: '
  },
  webex: {
    webex: 'Webex',
    info: 'Integration allows you to sync states between Desktop and Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'With this integration you can consult or transfer calls to the users of Microsoft Teams.',
    authenticationFailedInfo:
      'If an authentication window is already open, retry the authentication there.',
    ListItemContactDetails:
      'Name of the contact is: {name}, its presence is: {presence}, department is: {department}, jobTitle is: {jobTitle} and the phone number is: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Emergency Service Notification',
    readNotification: 'I have read the notification.'
  },
  webexPresenceStatus: {
    active: 'Active',
    lastActiveFewMinutesAgo: 'Active in the past few minutes',
    lastActiveMinutesAgo: 'Active {min} minutes ago',
    lastActive1HourAgo: 'Latest activity 1 hour ago',
    lastActiveHoursAgo: 'Active {hour} hours ago',
    lastActiveYesterday: 'Active yesterday',
    lastActiveOnDate: 'Active on {date}',
    busy: 'Busy',
    busyUntil: 'Busy until {date}',
    dnd: 'Do not disturb',
    dndUntil: 'Do not disturb until {date}',
    quiet: 'Quiet',
    quietUntil: 'Quiet until {date}',
    ooo: 'Out of office',
    outOfOfficeUntil: 'Out of office until {date}',
    call: 'On a call',
    meeting: 'In a meeting',
    calendarItem: 'In a calendar meeting',
    presenting: 'Presenting',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Search by name or profile details',
    webexPlaceholder: 'Search by name or email',
    refreshTheList: 'Refresh the List',
    refreshAddressBook: 'Refresh the Address Book',
    microsoftAuthError: 'No contacts to display. Microsoft authentication failed.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/es.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/es.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Error al cargar datos',
    errorID: 'ID de error',
    tryAgain: 'Inténtelo de nuevo',
    Error: 'Error',
    okButton: 'Aceptar',
    Yes: 'Sí',
    Cancel: 'Cancelar',
    Confirm: 'Confirmar',
    Continue: 'Continuar',
    Canceling: 'Cancelando',
    CiscoAiAssistant: 'Asistente de IA de Cisco',
    Answer: 'Responder',
    AnswerAriaLabel: 'Contestar tarea de escritorio',
    Decline: 'Rechazar',
    ErrorSecurityCompliance: 'Cumplimiento de seguridad',
    errorDetails: 'Detalles del error',
    learnMore: 'Más información',
    showLess: 'Mostrar menos',
    trackingIdDescription:
      'Comparta el ID de seguimiento con el administrador del sitio o el equipo de soporte para investigar la situación.',
    trackingIdInputLabel: 'ID de seguimiento: ',
    submitForm: 'Enviar formulario',
    unnamedStatus: 'Estado sin nombre',
    errorChatMsg: 'Error al cargar datos de chat',
    noOptions: 'No hay opciones',
    noResults: 'Sin resultados',
    more: 'Más',
    nomatchfound: 'No se han encontrado coincidencias',
    collaborationTool: 'Herramienta de colaboración',
    timerAriaLabel: 'Tiempo invertido',
    historyItemTime: 'Ocurrió en',
    loading: 'Carga',
    months: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre'
    ],
    loadingMsg: 'Cargando...',
    search: 'Buscar',
    historyChannelLabels: {
      All: 'Todo',
      telephony: 'Voz',
      chat: 'Chat',
      email: 'Correo electrónico',
      social: 'Social'
    },
    homePageLabel: 'Página de inicio',
    resizeHistoryDragger: 'Cambiar el tamaño del arrastrador del historial',
    agentHistoryLabel: 'historial del agente',
    clear: 'Borrar entrada',
    ariaLabelAgentHistoryWrapper:
      'El historial de interacciones con agentes muestra las comunicaciones recientes con sus clientes a través de diferentes canales en las últimas 24 horas.',
    sliderResizerInstructions:
      'Actualmente está en un control deslizante. Para cambiar el tamaño, utilice las teclas de flecha',
    resizeHistoryPanel: 'Cambiar tamaño del panel de historial, control deslizante,',
    time: {
      hours: 'hora',
      minutes: 'minuto',
      seconds: 's'
    }
  },
  email: {
    ToLabel: 'Para',
    FromLabel: 'De',
    CcLabel: 'CC',
    BccLabel: 'CCO',
    SubjectLabel: 'Asunto',
    HideLabel: 'Ocultar',
    SendLabel: 'Enviar',
    ShowPrevThread: 'Mostrar hilo anterior',
    HidePrevThread: 'Ocultar hilo anterior',
    ReplyLabel: 'Responder',
    ReplyAllLabel: 'Responder a todos',
    ViewOriginalMail: 'Ver correo electrónico original',
    QuickReplyInp: 'Respuesta rápida aquí....',
    AttachFiles: 'Adjuntar archivos',
    ToolbarHeading: 'Encabezado1',
    ToolbarBold: 'Negrita',
    ToolbarItalic: 'Cursiva',
    ToolbarUnderLine: 'Subrayar',
    ToolbarBlockQuote: 'Bloquear presupuesto',
    ToolbarCode: 'Bloque de código',
    ToolbarListOrder: 'Lista por orden',
    ToolbarListBullet: 'Lista por viñeta',
    ToolbarLink: 'Enlace',
    ToolbarStrike: 'Tachar',
    ToolbarColor: 'Color del texto',
    ToolbarTable: 'Tabla',
    insertTable: 'Insertar tabla',
    insertRowAbove: 'Insertar fila encima',
    insertRowBelow: 'Insertar fila debajo',
    insertColumnLeft: 'Insertar columna a la izquierda',
    insertColumnRight: 'Insertar columna a la derecha',
    deleteRow: 'Eliminar fila',
    deleteColumn: 'Eliminar columna',
    deleteTable: 'Eliminar tabla',
    link: 'Enlace',
    IndentRight: 'Sangría derecha',
    IndentLeft: 'Sangría izquierda',
    showMoreAttachment: 'Mostrar más archivos adjuntos',
    AttachmentLimit: 'Adjuntar hasta ',
    attachments: ' archivos adjuntos, ',
    sizeLimit: ' Máximo de MB',
    attachment: 'Archivo adjunto',
    errordeleteattachment: 'No se puede eliminar el/los archivo(s). Inténtelo de nuevo.',
    errordownloadattachment: 'No se puede descargar el/los archivo(s). Inténtelo de nuevo.',
    erroraddattachemnt: 'No se puede cargar el/los archivo(s). Inténtelo de nuevo.',
    errorendcontact: 'No se puede finalizar la interacción. Inténtelo de nuevo.',
    erroraddlimitreached:
      'No se pudo adjuntar el archivo porque excede el máximo ',
    errorattachmentdrop:
      'Se han eliminado los datos adjuntos de acuerdo con la norma de seguridad de la empresa.',
    errorfiletype: 'No se admite el tipo de archivo. Inténtelo de nuevo.',
    errorcreditcard:
      'No se pudieron cargar los archivos adjuntos de acuerdo con la normas de seguridad de la empresa.',
    errorcontainsimage:
      'No se pudieron cargar los archivos adjuntos. Las imágenes adjuntas no se admiten de acuerdo con la norma de seguridad de la empresa.',
    errorlimit: ' Límite de MB.',
    errorsendemail: 'No se puede enviar el correo electrónico. Inténtelo de nuevo.',
    errorpcicheckemail: 'No se puede recuperar los datos de PCI. Inténtelo de nuevo.',
    errortext: 'Error al cargar datos',
    tryAgain: 'Inténtelo de nuevo',
    replywarning:
      'No comparta información financiera, de salud o información identificable personalmente (PII) en este mensaje o en archivos adjuntos.',
    datamasked:
      'El asunto o el cuerpo del correo electrónico se ha redactado de acuerdo con la norma de seguridad de la empresa. ¿Seguro que desea enviar el correo electrónico?',
    pcibannerwarning:
      'El asunto o el cuerpo del correo electrónico se ha redactado de acuerdo con la norma de seguridad de la empresa.',
    on: 'El',
    wrote: 'escribió'
  },
  interaction_control: {
    windowOpened: 'Ventana abierta',
    connected: 'Conectados',
    consultRequested: 'Consulta solicitada',
    consulting: 'Consulta',
    consultCallOnHold: 'Consulta en espera',
    callOnHold: 'Llamada en espera',
    consult: 'Consultar',
    endconsult: 'Finalizar consulta',
    hold: 'Poner en espera',
    transfer: 'Transferir',
    conference: 'Conferencia',
    endconference: 'Finalizar conferencia',
    conferenceRequested: 'Conferencia solicitada',
    switchCall: 'Cambiar',
    mergeCall: 'Combinar',
    wrapup: 'Cierre',
    end: 'Fin',
    customername: 'Nombre de cliente',
    dn: 'DNIS',
    ivrpath: 'Ruta de IVR',
    email: 'Correo electrónico de cliente',
    ani: 'Número de teléfono',
    queueid: 'Nombre de cola',
    ronatimeout: 'Tiempo RONA',
    pathid: 'ID de ruta de IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'DN del agente',
    destagentname: 'Nombre del agente',
    virtualteamname: 'Cola',
    category: 'Categoría',
    additionaldetails: 'Detalles adicionales',
    sourcenumber: 'Número de origen',
    sourcepage: 'Página de origen',
    appuser: 'ID de usuario de la aplicación',
    customernumber: 'Número de teléfono',
    exitconference: 'Salir de la conferencia',
    resume: 'Reanudar',
    pauserecording: 'Pausar grabación',
    resumerecording: 'Reanudar grabación',
    exitconsult: 'Salir de la consulta',
    pauseRecordingFailed: 'No se puede pausar la grabación. Vuelva a intentarlo.',
    resumeRecordingFailed: 'No se puede reanudar la grabación. Vuelva a intentarlo.',
    holdCallFailed: 'No se puede poner en espera la llamada. Vuelva a intentarlo.',
    resumeCallFailed: 'No se puede reanudar la llamada. Vuelva a intentarlo.',
    endCallFailed: 'No se puede finalizar la interacción. Inténtelo de nuevo.',
    consultTransferFailed:
      'No se puede transferir la llamada de consulta. Vuelva a intentarlo.',
    conferenceTransferFailed:
      'No se puede transferir la llamada de conferencia. Inténtelo de nuevo.',
    conferenceFailed:
      'No se puede conectar la solicitud de conferencia. Vuelva a intentarlo.',
    consultEndFailed: 'No se puede finalizar la solicitud de consulta. Vuelva a intentarlo.',
    conferenceExitFailed:
      'No se puede salir de la solicitud de conferencia. Vuelva a intentarlo.',
    conferenceEndFailed:
      'No se puede finalizar la solicitud de conferencia. Vuelva a intentarlo.',
    cancelCtqFailed:
      'No se puede cancelar la llamada de consulta a la cola. Inténtelo de nuevo.',
    privacyShield: 'Escudo de privacidad',
    errorOnPrvacyShieldForConsult:
      'La grabación está en pausa actualmente. Reanude la grabación para iniciar una llamada de consulta.',
    errorOnPrvacyShieldForTransfer:
      'La grabación está en pausa actualmente. Reanude la grabación para iniciar una llamada de transferencia.',
    cancelConsult: 'Cancelar consulta',
    cancelTransfer: 'Cancelar transferencia',
    copy: 'Copiar',
    copied: 'Copiado',
    cadrequestuccess: 'La información del cliente se ha guardado correctamente.',
    cadrequestfailure: 'No se pudo guardar la información del cliente. Inténtelo de nuevo más tarde.',
    cadupdatedmessage: 'La información del cliente ha sido actualizada recientemente por',
    unsavedmessage: 'Se sobrescriben los cambios sin guardar.',
    save: 'Guardar',
    revert: 'Revertir',
    expandDetails: 'Expandir detalles',
    collapseDetails: 'Contraer detalles',
    cadValidationError:
      'Formato no válido. Utilice el estándar internacional para la fecha y la hora.',
    secureCadSaveError:
      'La información del cliente no se ha guardado. Haga clic en Guardar para volver a intentarlo.',
    secureDecryptionError: 'No se pueden mostrar las variables seguras.',
    clickToTry: 'Haga clic para volver a intentarlo.',
    isSecureVariable: 'es una variable segura',
    contactorigin: 'Origen de contacto',
    resumeMonitoring: 'Reanudar supervisión',
    pauseMonitoring: 'Pausar supervisión',
    whisperCoach: 'Entrenamiento susurrado',
    bargeIn: 'Incorporarse',
    endMonitoring: 'Finalizar supervisión',
    contactphonenumber: 'Número de teléfono de contacto',
    contactqueue: 'Cola de contactos',
    activeparticipants: 'Participantes activos',
    consultedparticipant: 'Participante consultado',
    contactstatus: 'Estado de contacto',
    timeincontactstatus: 'Tiempo en estado de contacto',
    totalcontactduration: 'Duración total de contacto',
    agentinteractiontime: 'Duración de la interacción',
    recording: 'Registrando',
    monitoring: 'Supervisión',
    monitoringPaused: 'Supervisión en pausa',
    pauseMonitoringFailed: 'No se puede pausar la supervisión. Vuelva a intentarlo.',
    resumeMonitoringFailed: 'No se puede reanudar la supervisión. Vuelva a intentarlo.',
    callCancelledInProgress: 'Cancelación de llamada en curso',
    bargedIn: 'Incorporado',
    keypad: 'Teclado',
    mute: 'Silenciar',
    unmute: 'Anular silencio',
    bargeInTooltipText:
      'El micrófono se activará y se unirá a esta interacción con el cliente.',
    bargeInCompactTooltipText:
      'Incorporación. El micrófono se activará y se unirá a esta interacción con el cliente.',
    bargeInTooltipDisabled: 'Reanude la supervisión para activar la incorporación',
    bargeInFailedTitle: 'Error de incorporación',
    bargeInFailedData:
      'Se ha producido un error mientras intentaba la incorporación. Vuelva a intentarlo transcurridos unos instantes.',
    supervisorBargedIn: 'se ha incorporado a su llamada.',
    leftInteraction: 'ha abandonado la interacción.',
    conferenceEnded: 'La llamada de conferencia ha finalizado.',
    participants: 'Participantes',
    badgeAriaLabel: '{participant} está en la llamada',
    bargeInConferenceAriaLabel: 'Hay dos participantes en la interacción',
    taskName: 'Nombre de la tarea de control de interacción',
    interactionDurationLabel: 'Duración',
    wrapupassist: 'Asistencia de cierre',
    consultingTaskContext: 'Llamada de consultoría desde',
    consultExited: 'Consultar llamada cerrada',
    endCall: 'Finalice la llamada.',
    exitconferenceCall:
      'Salga de la llamada y la conferencia continuará con los participantes activos.',
    recordingInProgess: 'Grabación en curso',
    recordingPaused: 'Grabación en pausa',
    searchPlaceholder: 'Buscar contactos',
    postCall: "Después de la llamada",
    switchCallTooltip: "Cambiar a llamada",
    switchConsultTooltip: "Cambiar a llamada de consulta",
    switchConferenceTooltip: "Cambiar a llamada de conferencia",
    confirmationDialog: {
      endCallTitle: '¿Desea finalizar la llamada?',
      endCallMessage: 'Haga clic en Confirmar para finalizar la llamada de todos los participantes.',
      exitConferenceTitle: '¿Desea salir de la llamada de conferencia?',
      exitConferenceMessage:
        'Haga clic en Confirmar para salir de la llamada de conferencia y permitir que los demás participantes continúen.',
      confirmButtonLabel: "Confirmar",
      cancelButtonLabel: "Cancelar",  
    },
    postCallOnHold: "Posterior a la llamada en espera",
    postCallConsult: "Consulta posterior a la llamada",
    postCallConsultOnHold: "Llamada posterior a la consulta en espera",
  },
  agentProfile: {
    teamName: 'Equipo',
    dialNumber: 'Número de marcación',
    phoneNumber: 'Número de teléfono',
    settings: 'Cambiar configuración',
    signOut: 'Cerrar sesión',
    webRTCDisconnected: 'Advertencia de telefonía de escritorio desconectada ',
    msAuthFailed: 'Error de autenticación de Microsoft',
    stateSyncFailed: 'Error de sincronización de estado',
    userProfileLabel: 'Perfil de usuario',
    ariaAgentprofile: 'Perfil de agente',
    ChannelCapacity: 'Capacidad del canal',
    voice: 'Voz',
    chat: 'Chat',
    email: 'Correo electrónico',
    social: 'Social',
    channelCapacityTooltip: 'Haga clic para ver más',
    blendedRouting: 'Mezclado',
    exclusiveRouting: 'Direccionamiento exclusivo',
    realtimeRouting: 'Direccionamiento mezclado en tiempo real',
    blendedRoutingTooltip: 'Gestione varios contactos a través de los canales.',
    exclusiveRoutingTooltip: 'Gestione solo un contacto a la vez.',
    realtimeRoutingTooltip: 'Gestione un canal en tiempo real obligatorio.',
    errorActiveContacts:
      'No puede cerrar sesión ahora porque tiene conversaciones activas. Complételas e inténtelo de nuevo.',
    searchTeams: 'Buscar equipos',
    changeTeamsConfirmHeader: 'Confirmación de cambio de equipo',
    changeTeamsConfirmMessage: '¿Seguro que desea cambiar de equipo?',
    changeTeamLabel: 'Cambiar equipo',
    errorChangeTeams:
      'No puede cambiar de equipo ahora porque tiene solicitudes activas. Complételas e inténtelo de nuevo.',
    saveTeamSelection: 'Guardar selección de equipo',
    userSettings: 'Configuración del usuario',
    resetLayout: 'Restablecer todo el diseño del escritorio',
    resetConfirmHeader: 'Restablecer confirmación de diseño',
    resetConfirmMessage:
      '¿Seguro que desea restablecer todo el diseño del escritorio? <br/> El escritorio volverá al diseño predeterminado.',
    downloadLogs: 'Descargar informe de errores',
    help: 'Ayuda',
    signoutConfirm: '¿Seguro que desea cerrar la sesión?',
    signoutConfirmHeader: 'Confirmación de cierre de sesión',
    darkTheme: 'Cambiar al modo oscuro',
    newLook: 'Cambiar a un nuevo aspecto',
    keyboardShortcuts: 'Métodos abreviados de teclado',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Mayús+2',
    notificationSettings: 'Configuración de notificación',
    silentNotification: 'Silenciar notificación',
    enableNotificationSettings: 'Activar notificaciones',
    enableSilentNotificationSettings: 'Activar notificaciones silenciosas',
    suppressWebexCallingNotificationSettings: 'Ocultar notificaciones de Webex Calling',
    notificationSettingDescription:
      'Entrega notificaciones tales como nuevos mensajes, alertas y cambios de estado.',
    silentNotificationDescription:
      'Desactiva alertas en pantalla. Puede ver las notificaciones en el centro de notificaciones.',
    suppressWebexCallingNotificationDescription: 
    'No muestre notificaciones emergentes para las llamadas entrantes de Webex y contéstelas a través Webex Contact Center.',
    arrowLabel: 'Volver atrás',
    managedTeams: 'Equipos gestionados',
    managedTeamsError: 'Error al cargar los equipos.',
    viewAll: 'Ver todo',
    profileSettings: 'Configuración del perfil',
    userRole: 'Rol',
    saveSelection: 'Guardar selección',
    extension: 'Extensión',
    changeProfileConfirmHeader: 'Confirmar cambios de configuración del perfil',
    changeProfileConfirmMessage:
      '¿Está seguro de que desea guardar los cambios realizados en el perfil?',
    confirm: 'Confirmar',
    errorProfileUpdate:
      'No puede cambiar la configuración del perfil ahora porque tiene solicitudes activas. Complételas e inténtelo de nuevo.',
    roleAgentSupervisor: 'Supervisor y agente',
    roleSupervisor: 'Supervisor',
    noTeam: 'Sin equipo',
    testYourNetwork: 'Probar la red',
    speakerAndMic: 'Altavoz y micrófono',
    speaker: 'Altavoz',
    mic: 'Micrófono',
    speakerDescription:
      'Elija y pruebe el dispositivo de salida para asegurarse de que escucha a la persona que llama.',
    micDescription:
      'Elija y pruebe el dispositivo de entrada para asegurarse de que la persona que llama le escucha.',
    micError:
      'Se ha denegado el acceso al micrófono. Habilite el acceso a través de la configuración del explorador o póngase en contacto con el administrador.',
    speakerError:
      'El altavoz no está disponible actualmente porque se ha denegado el acceso al micrófono.',
    telephony: 'Telefonía',
    desktop: 'Escritorio',
    onSpeakerPlay:
      'Si no puede escuchar el sonido de prueba, verifique el dispositivo de altavoz.',
    onMicPlay:
      'Si no puede escuchar el sonido de prueba, verifique el altavoz y el micrófono.',
    onMicRecord: 'Grabe un mensaje para reproducirlo.',
    test: 'Probar',
    recording: 'Grabando',
    playing: 'Reproduciendo',
    reconnecting: 'Reconectando',
    disconnectMessage:
      'La telefonía de escritorio se ha desconectado. Pruebe con una opción de telefonía distinta.',
    singleTelephonyDisconnectMessage:
      'La telefonía de escritorio se ha desconectado. Póngase en contacto con el administrador.',
    clear: 'Borrar entrada',
    rememberMeCheckBoxMessage: "No volver a mostrar este mensaje",
    saveLabel: 'Guardar',
    browserUnsupportedError: "Error al iniciar sesión porque está utilizando un explorador no compatible.",
    microphoneAccessDeniedError: "Se ha denegado el acceso al micrófono. Habilite el acceso a través de la configuración del explorador o póngase en contacto con el administrador.",
  },
  contactHistory: {
    mainHeader: 'Historial de contacto',
    handledBy: 'Gestionado por',
    noRecordFound: 'No se he encontrado ningún historial de contactos.',
    tryAgain: 'Inténtelo de nuevo',
    errorMsg: 'No se puede recuperar el historial de contactos. Inténtelo de nuevo.',
    errorID: 'ID de error',
    missingAni: 'Falta ANI',
    timeIcon: 'Duración',
    taskHandled: 'Tarea gestionada',
    noHistoryNew: 'No hay historial',
    noHistory: 'No hay historial',
    viewTranscript: 'Ver mensaje de correo electrónico',
    transcriptFor: 'Transcripciones para',
    editBeforeCall: 'Editar antes de la llamada',
    clickToCall: 'Clic para llamar',
    onAnActiveCallErrorMessage:
      'No puede iniciar una nueva llamada porque ya se encuentra en una llamada activa.',
    receivedFrom: 'Contacto recibido de',
    initiatedTo: 'Contacto iniciado para',
    wrapUpReason: 'Motivo de cierre',
    startCallTelephony:
      'Haga clic en el enlace del número de teléfono para iniciar una llamada saliente.',
    contactHistoryList: 'Lista del historial de contactos,',
    wrapUpCode: 'Código de cierre',
    agentName: 'Nombre del agente',
    entryPointName: 'Punto de entrada',
    acceptedTimeAndDate: 'Fecha y hora aceptadas',
    duration: 'Duración',
    emailTranscript: 'Enviar transcripción por correo electrónico',
    clickToViewEmailTranscript: 'Haga clic para ver la transcripción del correo electrónico',
    listContainer: 'Contenedor de listas'
  },
  contactTranscript: {
    agent: 'Agente',
    entryPoint: 'Punto de entrada',
    date: 'Fecha',
    subject: 'Asunto',
    from: 'De',
    sent: 'Enviado',
    to: 'Para',
    back: 'Atrás',
    errorTranscript: 'Ha habido un error al buscar transcripciones',
    customer: 'Cliente',
    inboundErrorMessage: 'Error al cargar el correo electrónico del cliente',
    outboundErrorMessage: 'Error al cargar la respuesta del agente'
  },
  popoverTitle: {
    callback: 'Devolución de llamada',
    outboundCall: 'Llamada saliente',
    incomingCall: 'Llamada entrante',
    progressiveCampaign: 'Llamada de campaña',
    courtesyCallback: 'Devolución de llamada de cortesía',
    chat: 'Chat entrante',
    incoming: 'Entrante',
    monitoringCall: 'Llamada de supervisión'
  },
  connecting: 'Conectando',
  initiating: 'Iniciando',
  outbound: 'Saliente',
  transfer: {
    title: 'Solicitud de transferencia',
    heading: {
      chat: 'Seleccione el agente o la cola a la que desea transferir.',
      email: 'Seleccione la cola a la que desea transferir.',
      telephony:
        'Seleccione el agente, la cola o el número de marcado al que desea transferir.',
      noQueueTelephony:
        'Seleccione el agente o el número de marcado al que desea transferir.'
    },
    header: {
      chat: 'Seleccione el agente o la cola para transferir este contacto.',
      email: 'Seleccione la cola para transferir este contacto.',
      telephony:
        'Seleccione el agente, la cola, el número de marcado o la organización para transferir este contacto.',
      noQueueTelephony:
        'Seleccione el agente, el número de marcado o la organización para transferir este contacto.',
      noOrganizationTelephony:
        'Seleccione el agente, la cola, o el número marcado para transferir este contacto.',
      noQueueOrganizationTelephony:
        'Seleccione el agente o un número de marcado para transferir este contacto.'
    },
    queues: 'Cola',
    agents: 'Agente',
    dialNumber: 'Número de marcación',
    organization: 'Organización',
    placeholder: {
      Queues: 'Elegir de una lista de colas',
      Agents: 'Elegir de una lista de agentes',
      DialNumber: 'Elegir por nombre/número',
      DialNumberOrEntryPoint: 'Elegir por nombre/número/punto de entrada',
      ChooseByNameOrNumber: 'Elegir por nombre/número',
      Organization: 'Buscar por nombre/rol/departamento/teléfono de empresa',
      WebexOrganization: 'Buscar por nombre o correo electrónico',
      DialNumberSearch: 'Buscar por nombre o número'
    },
    type: 'Transferir',
    cancel: 'Cancelar',
    closeModal: 'Cerrar modal',
    failureError: 'No se puede transferir la solicitud. Inténtelo de nuevo.',
    entryPoint: 'Punto de entrada'
  },
  consult: {
    title: 'Solicitud de consulta',
    heading: {
      chat: 'Seleccione el agente o la cola a la que desea transferir.',
      email: 'Seleccione la cola a la que desea transferir.',
      telephony:
        'Seleccione el agente, la cola o el número de marcado con el que desea consultar.',
      noQueueTelephony:
        'Seleccione el agente o el número de marcado con el que desea consultar.'
    },
    header: {
      chat: 'Seleccione el agente o la cola para transferir este contacto.',
      email: 'Seleccione la cola para transferir este contacto.',
      telephony:
        'Seleccione el agente, la cola, el número de marcado o la organización que desea consultar.',
      noQueueTelephony:
        'Seleccione el agente, el número de marcado o la organización que desea consultar.',
      noOrganizationTelephony:
        'Seleccione el agente, la cola o el número de marcado con el que desea consultar.',
      noQueueOrganizationTelephony:
        'Seleccione el agente o el número de marcado con el que desea consultar.'
    },
    queues: 'Cola',
    agents: 'Agente',
    dialNumber: 'Número de marcación',
    organization: 'Organización',
    placeholder: {
      Queues: 'Elegir de una lista de colas',
      Agents: 'Elegir de una lista de agentes',
      DialNumber: 'Elegir por nombre/número',
      DialNumberOrEntryPoint: 'Elegir por nombre/número/punto de entrada',
      ChooseByNameOrNumber: 'Elegir por nombre/número',
      Organization: 'Buscar por nombre/rol/departamento/teléfono de empresa',
      WebexOrganization: 'Buscar por nombre o correo electrónico',
      DialNumberSearch: 'Buscar por nombre o número'
    },
    type: 'Consultar',
    checkBoxLabel: 'Permitir que los participantes continúen interactuando.',
    cancel: 'Cancelar',
    closeModal: 'Cerrar modal',
    failureError: 'No se puede conectar la solicitud de consulta. Vuelva a intentarlo.',
    customerLeftMsg: 'Cliente desconectado. La consulta ya no es necesaria.',
    ctqFailureMsg:
      'No se puede cancelar la llamada de consulta a la cola. Inténtelo de nuevo.',
    cancelCtqInfo:
      'Buscando un agente disponible en la cola seleccionada. Espere o cancele la solicitud de consulta.',
    cancelCtqAction: 'Cancelar consulta',
    entryPoint: 'Punto de entrada'
  },
  conference: {
    title: 'Solicitud de conferencia',
    heading: {
      chat: 'Seleccione un agente específico para el chat de conferencia'
    },
    queues: 'Cola',
    agents: 'Agente',
    dialNumber: 'Número de marcación',
    organization: 'Organización',
    placeholder: {
      Queues: 'Elegir de una lista de colas',
      Agents: 'Elegir de una lista de agentes',
      DialNumber: 'Elegir por nombre/número'
    },
    type: 'Conferencia',
    cancel: 'Cancelar',
    closeModal: 'Cerrar modal',
    failureError: 'No se puede iniciar la solicitud de conferencia. Inténtelo de nuevo.'
  },
  transferModal: {
    Agents: 'No se puede recuperar la lista de agentes. Actualice la lista.',
    AgentsEmpty: 'No hay ningún agente disponible',
    Queues: 'No se puede recuperar la lista de colas. Actualice la lista.',
    QueuesEmpty: 'No hay ninguna cola disponible',
    EPEmpty: 'No hay un punto de entrada disponible',
    DialNumber:
      'No se puede recuperar la lista de números de marcación de la libreta de direcciones. Actualice la lista.',
    EntryPoint:
      'No se puede recuperar la lista de números de puntos de entrada. Actualice la lista.',
    Common: 'No se puede recuperar la lista. Actualice la lista.',
    DialNumberEmpty: 'No hay ningún número de marcado disponible',
    DialNumbInvalid:
      'El número de marcado no es válido. Póngase en contacto con el administrador.',
    DialNumbOrEntryPointInvalid:
      'El número de marcación/punto de entrada no es válido. Contacte con su administrador.',
    refreshQueueList: 'Actualizar la lista de colas',
    refreshAgentList: 'Actualizar la lista de agentes',
    refreshEpList: 'Actualizar los puntos de entrada',
    refreshAddressBook: 'Actualizar la libreta de direcciones',
    refreshTheList: 'Actualizar la lista',
    entryPointSectionLabel: 'Punto de entrada',
    addressBookSectionLabel: 'Libreta de direcciones',
    organization: 'Organización',
    comboBoxAriaLabelAgent: 'Elegir de una lista de agentes',
    comboBoxAriaLabelQueue: 'Elegir de una lista de colas',
    comboBoxAriaLabelEp: 'Elija de una lista de puntos de entrada',
    infScrollAgent: 'Buscar agentes',
    infScrollQueue: 'Buscar colas',
    infScrollEP: 'Buscar puntos de entrada',
    allRadioButtonHidedTextForConsult: 'No tiene entidades asignadas para consultar esta interacción. Póngase en contacto con el administrador.',
    allRadioButtonHidedTextForTransfer: 'No tiene entidades asignadas para transferir esta interacción. Póngase en contacto con el administrador.',
    allRadioButtonHidedTextForConference: 'No tiene entidades asignadas para realizar una conferencia sobre esta interacción. Póngase en contacto con el administrador.',
    searchMinCharError: 'Introduzca un mínimo de tres caracteres para buscar.',
  },
  wrapup: {
    cancelautowrapup: 'Cancelar cierre automático',
    wrapupreason: 'Motivos de cierre',
    untilautowrapup: 'hasta cierre auto.',
    followupsetting: 'Configuración de seguimiento',
    lastagentroute: 'Último enrutamiento de agente',
    submitwrapup: 'Enviar cierre',
    wrapupsearch: 'Buscar motivo de cierre',
    invalidationError: 'Error al enviar el cierre',
    searchResult: 'Resultados de búsqueda disponibles',
    noResultFound: 'No se encontraron resultados de búsqueda',
    listContainerLabel: 'Contenedor de lista de cierre',
    searchError: 'Introduzca un mínimo de tres caracteres para buscar motivos de cierre.',
  },

  outdial: {
    call: 'Llamada',
    dialpadSearch: 'Introd. número a llamar',
    addressSearch: 'Buscar por nombre/número',
    addressTab: 'Dirección',
    addressTabTooltip: 'Buscar en libreta de direcciones',
    dialpadTab: 'Teclado de marcación',
    dialpadTooltip: 'Marcar un número',
    searchTab: 'Buscar',
    searchTabTooltip:'Buscar personas en mi organización',
    noAdrFound: 'No se han encontrado coincidencias',
    noContacts: 'No hay contactos',
    mainIconTooltip: 'Llamada saliente',
    errorOutdialFailed:
      'Error de llamada saliente. El escritorio no ha podido conectar la llamada o no se ha respondido la llamada.',
    errorOutdialDisabled: 'Las llamadas salientes están desactivadas',
    errorDialPadValidationMessage: 'Formato incorrecto',
    outdialReqInProgress: 'Llamada saliente en curso',
    outdialAniPlaceholder: 'Seleccionar ANI de llamada saliente',
    outdialAniLabel: 'ANI de llamada saliente',
    outdialAniPlaceHolder: 'Buscar ANI de llamada externa',
    errorDcCallsLimitExceeded:
      'El centro de datos ha alcanzado el límite máximo para las llamadas salientes. No se pueden realizar más llamadas salientes',
    errorOrgCallsLimitExceeded:
      'La organización ha alcanzado el límite máximo para las llamadas salientes. No se pueden realizar más llamadas salientes.',
    errorOutDialNoAnswerFromCustomer:
      'El cliente no ha respondido a su llamada. Intente llamar más tarde.',
    errorOutDialCustomerUnavailable:
      'El cliente no está disponible ahora. Intente llamar más tarde.',
    errorOutDialAgentEnds: 'Ha finalizado la llamada con el cliente.',
    errorOutDialCustomerBusy: 'El cliente está ocupado ahora. Intente llamar más tarde.',
    searchError: 'Introduzca un mínimo de tres caracteres para buscar los contactos.',
    upArrowLabel: 'Expandir',
    clear: 'Borrar entrada',
    outdialDialogDescription: 'Actualmente está en el diálogo con las fichas.'
  },

  organization: {
    noMatchFound: 'No se han encontrado coincidencias',
    searchError: 'Introduzca un mínimo de tres caracteres para buscar los contactos.',
    authError: 'No hay contactos para mostrar. Error de la autenticación de Microsoft.'
  },

  interactionPopover: {
    of: 'de',
    accept: 'Aceptar',
    acceptAriaLabel: 'Aceptar tarea {taskNumber} - {taskType} desde {from}',
    requests: 'Solicitud(es)',
    back: 'atrás',
    next: 'siguiente',
    acceptMultipleRequest: 'Aceptar {requestCount} solicitudes',
    paginationDetail: '{indexStart}-{indexEnd} de {totalPopoverpoolLength}',
    hidePopoverDetails: 'Ocultar detalles emergentes',
    showPopoverDetails: 'Mostrar detalles emergentes',
    customerName: 'Nombre de cliente',
    email: 'Correo electrónico',
    queueName: 'Nombre de cola',
    failedToAccept: 'No se pudo aceptar.',
    unableToAccept: 'No se puede aceptar el contacto.',
    failedToEnd: 'No se pudo finalizar.',
    unableToEnd: 'No se puede finalizar el contacto. ',
    ringing: 'Sonando',
    calling: 'Llamando',
    phoneNumber: 'Número de teléfono',
    dni: 'DNIS',
    ivrPathId: 'ID de ruta de IVR',
    pathId: 'ID de ruta',
    rona: 'RONA',
    sourcePage: 'Página de origen',
    sourceNumber: 'Número de origen',
    appUserId: 'ID de usuario de la aplicación',
    acceptAll: 'Aceptar todas las tareas',
    agentDn: 'DN del agente',
    agentName: 'Nombre del agente',
    agentTeam: 'Equipos de agentes',
    requestDetails: 'Detalles de la solicitud',
    incomingCallFrom: 'Llamada entrante de',
    unableToAnswer: 'No se puede responder la llamada. Vuelva a intentarlo.',
    unableToDecline: 'No se puede rechazar la llamada. Vuelva a intentarlo.'
  },

  multiLogin: {
    header: 'Alerta de inicio de sesión múltiple',
    message:
      'Ha iniciado sesión en el escritorio en varias instancias de la aplicación. Haga clic en Continuar para seguir en el escritorio en esta instancia de la aplicación. De lo contrario, cierre esta ventana.',
    continue: 'Continuar'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'No se ha podido realizar la transferencia a la cola o al punto de entrada debido a un error de configuración.',
    1010: "No se puede consultar porque el agente no se ha podido asignar a tiempo. ",
    1042: "No se encuentra el contacto",
    1043: 'El tipo de destino no es válido.',
    1045: 'La interacción no está asignada al agente.',
    1046: 'Error en la consulta del agente, ya que no se encuentra ningún canal de agente coincidente en el sistema.',
    1038: "No se encuentra el agente",
    1037: 'No se ha podido iniciar sesión a causa de un error interno.',

    // Media Events
    138: 'Error de la acción por razones desconocidas.',
    136: 'No se encuentra el usuario',

    // AgentConsultFailed
    1050: 'No se puede consultar debido a una configuración o una actividad no admitida en el flujo. ',
    1005: "No se puede consultar porque el agente no respondió la solicitud a tiempo.",
    1051: 'No se puede consultar o transferir debido a un punto de entrada o número de marcación no válido.',

    // AgentInviteFailed
    1053: 'No se puede presentar la interacción porque hay una tarea para volver a poner en cola del flujo de trabajo pendiente.',
    1054: 'No se puede realizar una llamada externa debido a problemas de medios con esta solicitud. ',

    // AgentContactAssignFailed
    1011: 'No se puede contestar o aceptar la llamada porque faltan agentes en la interacción en curso. ',

    // ContactCallbackFailed
    1034: 'La devolución de llamada al contacto ha fallado porque se ha recibido ContactParkTimeout para la solicitud.',

    // ContactUpdateFailed
    1020: "No se pueden actualizar las variables porque uno de los valores excede el límite de 256 caracteres. Reduzca los caracteres e inténtelo de nuevo.",

    // AgentInviteFailed
    1031: 'El agente ha invitado al cliente después de la solicitud de la devolución de llamada.',

    // AgentBlindTransferFailedEvent
    1044: 'Se ha producido un error en la transferencia oculta del agente, ya que el agente de destino está asignado a otra interacción.',

    // AgentCtqCancelFailed
    1047: "No se encuentra el contacto.",

    // AgentCtqFailed
    1048: "El grupo de distribución de llamadas no está configurado.",
    1049: 'Se ha excedido el tiempo de espera máximo en la cola.',
    // StationLoginFailed
    127: 'Error de registro de DN de agente con excepción de inicio de sesión duplicada.'
  },

  stateSelector: {
    Available: 'Disponible',
    errorstatechange: 'Cambio de estado no satisfactorio. Inténtelo de nuevo.',
    errorStateChangeInPendingLogout: 'Error al cambiar el estado del agente debido a un cierre de sesión pendiente.',
    label: 'Estado de disponibilidad',
    agentStateSelector: 'Selector de estado de agente',
    Engaged: 'Ocupado',
    engagedAvailableInfo:
      'Está participando en una interacción y en el estado Disponible en estos momentos.',
    engagedIdleInfo:
      'Actualmente está participando en una interacción y en el estado Inactivo',
    engagedInfo: 'Actualmente está participando en una interacción.',
    engagedSupervisorStateChange: 'ha cambiado el estado a',
    axAgentStateChanged: 'Su estado ha cambiado a',
    axAgentSync: 'debido a la sincronización del estado con su herramienta de colaboración.',
    engagedPresenceInfo:
      'Actualmente está participando en una interacción y su estado es',
    engagedPresenceSync: 'debido a la sincronización del estado con su herramienta de colaboración.',
    clear: 'Borrar entrada',
    searchState: 'entrada',
    agentStatusLabel: 'Estado de agentes',
    agentStateLabel: 'El agente está en el estado {selectedState} durante el último {selectedTimeValue}',
    agentStateLabelOnStateChange: 'El agente está en el estado {selectedState} durante los últimos 0 segundos',
    agentStateChangeSuccessful:'Cambio de estado a {selectedState} correcto.',
    agentStateChangeFail:'No se ha podido cambiar el estado a {selectedState}.',
    searchError: 'Introduzca un mínimo de tres caracteres para buscar estados.'
  },

  warningMessage: {
    header: 'Cambios sin guardar',
    message:
      'Tiene cambios sin guardar en esta página. ¿Seguro que desea salir de esta página? ',
    cancelButton: 'Permanecer',
    saveButton: 'Salir'
  },

  notificationLables: {
    muteVolume: 'Silenciar volumen de notificaciones',
    unmuteVolume: 'Cancelar silencio de volumen de notificaciones',
    notificationVolume: 'Volumen de notificaciones',
    playSound: 'Reproducir sonido de notificación',
    enableSoundNotificationSettings: 'Activar notificaciones de sonido',
    enableSoundNotificationSettingsDescription:
      'Entrega notificaciones de sonido para solicitudes entrantes. Puede ajustar el volumen a continuación.',
    volumeTitle: 'Volumen del sonido'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Llamada',
    chat: 'Chat',
    email: 'Correo electrónico',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Chat empresarial de Apple',
    googleBusiness: "Google\'s Business Messages"
  },
  orgDetailsLabels: {
    role: 'Rol',
    department: 'Departamento',
    email: 'Correo electrónico',
    businessPhone: 'Teléfono de empresa',
    workPhone: 'Trabajo',
  },
  addressListError: {
    title: 'Error al cargar datos',
    errorId: 'ID de error:'
  },
  keypad: {
    keyPadSearch: 'Introduzca el número',
    dialPad: 'Teclado numérico'
  },
  collabTool: {
    userAuthenticated: 'Autenticación de usuario:',
    successful: 'Correcto',
    failed: 'Error.',
    tryAgain: 'Inténtelo de nuevo',
    stateSync: 'Sincronización de estado:',
    mercuryFailedInfo: ' Póngase en contacto con el administrador.',
    retrying: 'Nuevo intento...',
    trackingIdLabel: 'ID de seguimiento: '
  },
  webex: {
    webex: 'Webex',
    info: 'La integración permite sincronizar estados entre el escritorio y Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Con esta integración podrá consultar o transferir llamadas a los usuarios de Microsoft Teams.',
    authenticationFailedInfo:
      'Si ya hay una ventana de autenticación abierta, vuelva a intentar la autenticación allí.',
    ListItemContactDetails:
      'El nombre del contacto es: {name}, su presencia es: {presence}, el departamento es: {department}, el cargo es: {jobTitle} y el número de teléfono es: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Notificación de servicio de emergencia',
    readNotification: 'He leído la notificación.'
  },
  webexPresenceStatus: {
    active: 'Activo',
    lastActiveFewMinutesAgo: 'Activo en los últimos minutos',
    lastActiveMinutesAgo: 'Activo hace {min} minutos',
    lastActive1HourAgo: 'Última actividad hace 1 hora',
    lastActiveHoursAgo: 'Activo hace {hour} horas',
    lastActiveYesterday: 'Activo ayer',
    lastActiveOnDate: 'Activo el {date}',
    busy: 'Ocupado',
    busyUntil: 'Ocupado hasta el {date}',
    dnd: 'No molestar',
    dndUntil: 'No molestar hasta el {date}',
    quiet: 'Silencio',
    quietUntil: 'Silencio hasta el {date}',
    ooo: 'Fuera de la oficina',
    outOfOfficeUntil: 'Fuera de la oficina hasta el {date}',
    call: 'Al teléfono',
    meeting: 'En una reunión',
    calendarItem: 'En una reunión de calendario',
    presenting: 'Presentando',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Buscar por nombre o detalles del perfil',
    webexPlaceholder: 'Buscar por nombre o correo electrónico',
    refreshTheList: 'Actualizar la lista',
    refreshAddressBook: 'Actualizar la libreta de direcciones',
    microsoftAuthError: 'No hay contactos para mostrar. Error de la autenticación de Microsoft.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/fi.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/fi.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Tietojen lataus epäonnistui',
    errorID: 'Virheen tunnus',
    tryAgain: 'Yritä uudelleen',
    Error: 'Virhe',
    okButton: 'OK',
    Yes: 'Kyllä',
    Cancel: 'Peruuta',
    Confirm: 'Vahvista',
    Continue: 'Jatka',
    Canceling: 'Peruutetaan',
    CiscoAiAssistant: 'Cisco tekoälyavustaja',
    Answer: 'Vastaa',
    AnswerAriaLabel: 'Vastaa työpöytätehtävään',
    Decline: 'Hylkää',
    ErrorSecurityCompliance: 'Tietoturvan noudattaminen',
    errorDetails: 'Virhetiedot',
    learnMore: 'Lisätietoja',
    showLess: 'Näytä vähemmän',
    trackingIdDescription:
      'Aloita ongelman tutkinta jakamalla seurantatunnus toimintapaikan pääkäyttäjälle tai tukitiimille.',
    trackingIdInputLabel: 'Seurantatunnus: ',
    submitForm: 'Lähetä lomake',
    unnamedStatus: 'Nimeämätön tila',
    errorChatMsg: 'Keskustelutietojen lataus epäonnistui',
    noOptions: 'Ei asetuksia',
    noResults: 'Ei tuloksia',
    more: 'Enemmän',
    nomatchfound: 'Vastineita ei löytynyt',
    collaborationTool: 'Yhteistyötyökalu',
    timerAriaLabel: 'Käytetty aika',
    historyItemTime: 'Tapahtui',
    loading: 'Ladataan...',
    months: [
      'Tammikuu',
      'Helmikuu',
      'Maaliskuu',
      'Huhtikuu',
      'Toukokuu',
      'Kesäkuu',
      'Heinäkuu',
      'Elokuu',
      'Syyskuu',
      'Lokakuu',
      'Marraskuu',
      'Joulukuu'
    ],
    loadingMsg: 'Ladataan..',
    search: 'Hae',
    historyChannelLabels: {
      All: 'Kaikki',
      telephony: 'Puhe',
      chat: 'Keskustele',
      email: 'Sähköposti',
      social: 'Some'
    },
    homePageLabel: 'Aloitussivu',
    resizeHistoryDragger: 'Muuta historian vetäjän kokoa',
    agentHistoryLabel: 'edustajan historia',
    clear: 'Tyhjennä syöte',
    ariaLabelAgentHistoryWrapper:
      'Edustajan viestintähistoriassa näkyvät viimeaikaiset asiakasviestinnät eri kanavilla 24 viime tunnin ajalta',
    sliderResizerInstructions:
      'Valinta on liukusäätimessä. Voit muuttaa kokoa nuolinäppäimillä',
    resizeHistoryPanel: 'Muuta historiapaneelin kokoa, liukusäädin,',
    time: {
      hours: 'tunti',
      minutes: 'min',
      seconds: 's'
    }
  },
  email: {
    ToLabel: 'Mihin',
    FromLabel: 'Mistä',
    CcLabel: 'Kopio',
    BccLabel: 'Piilokopio',
    SubjectLabel: 'Aihe',
    HideLabel: 'Piilota',
    SendLabel: 'Lähetä',
    ShowPrevThread: 'Näytä edellinen ketju',
    HidePrevThread: 'Piilota edellinen ketju',
    ReplyLabel: 'Vastaa',
    ReplyAllLabel: 'Vastaa kaikille',
    ViewOriginalMail: 'Näytä alkuperäinen sähköposti',
    QuickReplyInp: 'Pikavastaus tähän...',
    AttachFiles: 'Liitä tiedostoja',
    ToolbarHeading: 'Otsikko1',
    ToolbarBold: 'Lihavointi',
    ToolbarItalic: 'Kursivoitu',
    ToolbarUnderLine: 'Alleviivattu',
    ToolbarBlockQuote: 'Estä tarjous',
    ToolbarCode: 'Koodin esto',
    ToolbarListOrder: 'Luettelo järjestettynä',
    ToolbarListBullet: 'Luettelo luettelomerkein',
    ToolbarLink: 'Linkki',
    ToolbarStrike: 'Yliviivaus',
    ToolbarColor: 'Tekstin väri',
    ToolbarTable: 'Taulukko',
    insertTable: 'Lisää taulukko',
    insertRowAbove: 'Lisää rivi yläpuolelle',
    insertRowBelow: 'Lisää rivi alapuolelle',
    insertColumnLeft: 'Lisää sarake vasemmalle',
    insertColumnRight: 'Lisää sarake oikealle',
    deleteRow: 'Poista rivi',
    deleteColumn: 'Poista sarake',
    deleteTable: 'Poista taulukko',
    link: 'Linkki',
    IndentRight: 'Sisennä oikealle',
    IndentLeft: 'Sisennä vasemmalle',
    showMoreAttachment: 'Näytä enemmän liitteitä',
    AttachmentLimit: 'Voit liittää enintään ',
    attachments: ' liitettä, ',
    sizeLimit: ' enintään Mt',
    attachment: 'Liite',
    errordeleteattachment: 'Tiedostoja ei voida poistaa. Yritä uudelleen.',
    errordownloadattachment: 'Tiedostoja ei voida ladata. Yritä uudelleen.',
    erroraddattachemnt: 'Tiedostoja ei voida ladata palvelimeen. Yritä uudelleen.',
    errorendcontact: 'Vuorovaikutusta ei voida päättää. Yritä uudelleen.',
    erroraddlimitreached:
      'Tiedostoa ei voitu liittää, koska sen koko ylittää enimmäisrajoituksen ',
    errorattachmentdrop:
      'Liitteet on hylätty yrityksen suojauskäytännön mukaisesti.',
    errorfiletype: 'Tiedostotyyppiä ei tueta. Yritä uudelleen.',
    errorcreditcard:
      'Liitteitä ei voida ladata yrityksen suojauskäytännön mukaan.',
    errorcontainsimage:
      'Liitteitä ei voida ladata. Liitteissä olevia kuvia ei tueta yrityksen suojauskäytännön mukaan.',
    errorlimit: ' Mt:n rajoitus.',
    errorsendemail: 'Sähköpostia ei voida lähettää. Yritä uudelleen.',
    errorpcicheckemail: 'PCI-tietoja ei voida noutaa. Yritä uudelleen.',
    errortext: 'Tietojen lataus epäonnistui',
    tryAgain: 'Yritä uudelleen',
    replywarning:
      'Älä jaa talous- tai terveystietoja tai muita henkilöön yhdistettävissä olevia tietoja tässä viestissä tai liitteissä.',
    datamasked:
      'Sähköpostin aihe tai tekstiosa on vedetty pois yrityksen suojauskäytännön mukaisesti. Haluatko varmasti lähettää sähköpostin?',
    pcibannerwarning:
      'Sähköpostin aihe tai tekstiosa on vedetty pois yrityksen suojauskäytännön mukaisesti.',
    on: 'Milloin',
    wrote: 'kirjoitti'
  },
  interaction_control: {
    windowOpened: 'Ikkuna avattu',
    connected: 'Yhdistetty',
    consultRequested: 'Konsultointia pyydetty',
    consulting: 'Konsultointi',
    consultCallOnHold: 'Konsultointi pidossa',
    callOnHold: 'Puhelu pidossa',
    consult: 'Konsultoi',
    endconsult: 'Lopeta konsultointi',
    hold: 'Pito',
    transfer: 'Siirrä',
    conference: 'Neuvottelu',
    endconference: 'Lopeta neuvottelu',
    conferenceRequested: 'Neuvottelua pyydetty',
    switchCall: 'Vaihda',
    mergeCall: 'Yhdistä',
    wrapup: 'Päättäminen',
    end: 'Lopeta',
    customername: 'Asiakkaan nimi',
    dn: 'DNIS',
    ivrpath: 'IVR-polku',
    email: 'Asiakkaan sähköposti',
    ani: 'Puhelinnumero',
    queueid: 'Jonon nimi',
    ronatimeout: 'Rona-aika',
    pathid: 'IVR-polun tunnus',
    dnis: 'DNIS',
    destagentphonenumber: 'Edustajan DN',
    destagentname: 'Edustajan nimi',
    virtualteamname: 'Jonossa',
    category: 'Luokka',
    additionaldetails: 'Lisätiedot',
    sourcenumber: 'Lähdenumero',
    sourcepage: 'Lähdesivu',
    appuser: 'Sovelluskäyttäjän tunnus',
    customernumber: 'Puhelinnumero',
    exitconference: 'Lopeta neuvottelu',
    resume: 'Jatka',
    pauserecording: 'Keskeytä tallennus',
    resumerecording: 'Jatka tallennusta',
    exitconsult: 'Lopeta konsultointi',
    pauseRecordingFailed: 'Tallennusta ei voida keskeyttää. Yritä uudelleen.',
    resumeRecordingFailed: 'Tallennusta ei voida jatkaa. Yritä uudelleen.',
    holdCallFailed: 'Puhelua ei voida asettaa pitoon. Yritä uudelleen.',
    resumeCallFailed: 'Puhelua ei voida jatkaa. Yritä uudelleen.',
    endCallFailed: 'Vuorovaikutusta ei voida päättää. Yritä uudelleen.',
    consultTransferFailed:
      'Konsultointipuhelua ei voida siirtää. Yritä uudelleen.',
    conferenceTransferFailed:
      'Neuvottelupuhelua ei voida siirtää. Yritä uudelleen.',
    conferenceFailed:
      'Neuvottelupyyntöä ei voida yhdistää. Yritä uudelleen.',
    consultEndFailed: 'Konsultointipyyntöä ei voida lopettaa. Yritä uudelleen.',
    conferenceExitFailed:
      'Neuvottelupyyntöä ei voida lopettaa. Yritä uudelleen.',
    conferenceEndFailed:
      'Neuvottelupyyntöä ei voida lopettaa. Yritä uudelleen.',
    cancelCtqFailed:
      'Konsultointipuhelun siirtoa jonoon ei voida peruuttaa. Yritä uudelleen.',
    privacyShield: 'Privacy Shield -järjestely',
    errorOnPrvacyShieldForConsult:
      'Tallennus on keskeytetty tällä hetkellä. Aloita konsultointipuhelu jatkamalla tallennusta.',
    errorOnPrvacyShieldForTransfer:
      'Tallennus on keskeytetty tällä hetkellä. Aloita puhelun siirto jatkamalla tallennusta.',
    cancelConsult: 'Peruuta konsultointi',
    cancelTransfer: 'Peruuta siirto',
    copy: 'Kopioi',
    copied: 'Kopioitu',
    cadrequestuccess: 'Asiakastietojen tallennus onnistui.',
    cadrequestfailure: 'Asiakastietojen tallennus onnistui. Yritä myöhemmin uudelleen.',
    cadupdatedmessage: 'Asiakastietoja on päivitetty äskettäin:',
    unsavedmessage: 'Tallentamattomat muutokset korvataan.',
    save: 'Tallenna',
    revert: 'Palaa',
    expandDetails: 'Laajenna tiedot',
    collapseDetails: 'Kutista tiedot',
    cadValidationError:
      'Virheellinen muoto. Käytä päivämäärän ja kellonajan kansainvälistä standardia.',
    secureCadSaveError:
      'Asiakastietoja ei ole tallennettu. Yritä uudelleen valitsemalla Tallenna.',
    secureDecryptionError: 'Suojattuja muuttujia ei voi näyttää.',
    clickToTry: 'Yritä uudelleen napsauttamalla',
    isSecureVariable: 'on suojattu muuttuja',
    contactorigin: 'Yhteyshenkilön alkuperä',
    resumeMonitoring: 'Jatka seurantaa',
    pauseMonitoring: 'Keskeytä seuranta',
    whisperCoach: 'Kuiskausvalmennus',
    bargeIn: 'Liity',
    endMonitoring: 'Lopeta seuranta',
    contactphonenumber: 'Yhteyshenkilön puhelinnumero',
    contactqueue: 'Yhteydenottojono',
    activeparticipants: 'Aktiiviset osallistujat',
    consultedparticipant: 'Konsultoitu osallistuja',
    contactstatus: 'Yhteydenottotila',
    timeincontactstatus: 'Aika yhteydenottotilassa',
    totalcontactduration: 'Yhteydenoton kesto yhteensä',
    agentinteractiontime: 'Vuorovaikutuksen kesto',
    recording: 'Nauhoitus',
    monitoring: 'Seuranta',
    monitoringPaused: 'Seuranta keskeytetty',
    pauseMonitoringFailed: 'Seurantaa ei voida keskeyttää. Yritä uudelleen',
    resumeMonitoringFailed: 'Seurantaa ei voida jatkaa. Yritä uudelleen',
    callCancelledInProgress: 'Puhelun peruutus käynnissä',
    bargedIn: 'Liitytty',
    keypad: 'Näppäimistö',
    mute: 'Mykistä',
    unmute: 'Poista mykistys',
    bargeInTooltipText:
      'Mikrofoni menee päälle, ja voit liittyä tähän asiakasvuorovaikutukseen',
    bargeInCompactTooltipText:
      'Liity. Mikrofoni menee päälle, ja voit liittyä tähän asiakasvuorovaikutukseen',
    bargeInTooltipDisabled: 'Ota liittyminen käyttöön jatkamalla seurantaa',
    bargeInFailedTitle: 'Liittyminen epäonnistui',
    bargeInFailedData:
      'Liittymisen aikana tapahtui virhe. Yritä jonkin ajan kuluttua uudelleen.',
    supervisorBargedIn: 'on liittynyt puheluusi.',
    leftInteraction: 'on poistunut vuorovaikutuksesta.',
    conferenceEnded: 'Neuvottelupuhelu on päättynyt.',
    participants: 'Osallistujat',
    badgeAriaLabel: '{participant} on puhelussa',
    bargeInConferenceAriaLabel: 'Vuorovaikutuksessa on kaksi osallistujaa',
    taskName: 'Vuorovaikutuksen ohjaustehtävän nimi',
    interactionDurationLabel: 'Kestoaika',
    wrapupassist: 'Päättämisapu',
    consultingTaskContext: 'Konsultointipuhelu kohteesta',
    consultExited: 'Konsultointipuhelu lopetettu',
    endCall: 'Lopeta puhelu.',
    exitconferenceCall:
      'Lopeta puhelu, niin neuvottelu jatkuu aktiivisten osallistujien kanssa.',
    recordingInProgess: 'Tallennus käynnissä',
    recordingPaused: 'Tallennus keskeytetty',
    searchPlaceholder: 'Hae yhteystietoja',
    postCall: "Puhelun jälkeinen",
    switchCallTooltip: "Vaihda puheluun",
    switchConsultTooltip: "Vaihda konsultointipuheluun",
    switchConferenceTooltip: "Vaihda neuvottelupuheluun",
    confirmationDialog: {
      endCallTitle: 'Haluatko lopettaa puhelun?',
      endCallMessage: 'Lopeta puhelu kaikilta osallistujilta valitsemalla Vahvista.',
      exitConferenceTitle: 'Haluatko poistua neuvottelupuhelusta?',
      exitConferenceMessage:
        'Poistu neuvottelupuhelusta ja anna muiden osallistujien jatkaa valitsemalla Vahvista.',
      confirmButtonLabel: "Vahvista",
      cancelButtonLabel: "Peruuta",  
    },
    postCallOnHold: "Puhelun jälkeinen pidossa",
    postCallConsult: "Puhelun jälkeinen konsultointi",
    postCallConsultOnHold: "Puhelun jälkeinen konsultointi pidossa",
  },
  agentProfile: {
    teamName: 'Tiimi',
    dialNumber: 'Valintanumero',
    phoneNumber: 'Puhelinnumero',
    settings: 'Muuta asetuksia',
    signOut: 'Kirjaudu ulos.',
    webRTCDisconnected: 'Varoitus: työpöydän puhelinliikenneyhteys katkaistu ',
    msAuthFailed: 'Microsoftin todennus epäonnistui',
    stateSyncFailed: 'Tilan synkronointi epäonnistui',
    userProfileLabel: 'Käyttäjäprofiili',
    ariaAgentprofile: 'Edustajan profiili',
    ChannelCapacity: 'Kanavan kapasiteetti',
    voice: 'Puhe',
    chat: 'Keskustele',
    email: 'Sähköposti',
    social: 'Some',
    channelCapacityTooltip: 'Saat lisätietoja napsauttamalla',
    blendedRouting: 'Sekoitettu',
    exclusiveRouting: 'Rajaava reititys',
    realtimeRouting: 'Sekoitettu, reaaliaikainen reititys',
    blendedRoutingTooltip: 'Käsittele useita yhteydenottoja eri kanavilla.',
    exclusiveRoutingTooltip: 'Käsittele vain yhtä yhteydenottoa kerrallaan.',
    realtimeRoutingTooltip: 'Käsittele yhtä pakollista reaaliaikaista kanavaa.',
    errorActiveContacts:
      'Et voi kirjautua ulos nyt, koska keskusteluja on aktiivisena. Viimeistele ne ja yritä uudelleen.',
    searchTeams: 'Etsi tiimejä',
    changeTeamsConfirmHeader: 'Vaihda tiimiä -varmistus',
    changeTeamsConfirmMessage: 'Haluatko varmasti vaihtaa tiimiäsi?',
    changeTeamLabel: 'Vaihda tiimi',
    errorChangeTeams:
      'Et voi vaihtaa tiimiä nyt, sillä sinulla on yksi tai useampi aktiivinen pyyntö. Suorita aiemmat pyynnöt loppuun ja yritä uudelleen.',
    saveTeamSelection: 'Tallenna tiimikokoelma',
    userSettings: 'Käyttäjän asetukset',
    resetLayout: 'Palauta koko työpöydän asettelu',
    resetConfirmHeader: 'Asettelun palautuksen vahvistus',
    resetConfirmMessage:
      'Haluatko varmasti palauttaa koko työpöydän asettelun? <br/> Työpöytä palautetaan oletusasetteluun.',
    downloadLogs: 'Lataa virheraportti',
    help: 'Ohje',
    signoutConfirm: 'Haluatko varmasti kirjautua ulos?',
    signoutConfirmHeader: 'Uloskirjautumisen vahvistus',
    darkTheme: 'Vaihda tummaan tilaan',
    newLook: 'Vaihda uuteen ulkoasuun',
    keyboardShortcuts: 'Pikanäppäimet',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Vaihto+2',
    notificationSettings: 'Ilmoitusasetukset',
    silentNotification: 'Äänetön ilmoitus',
    enableNotificationSettings: 'Ota ilmoitukset käyttöön',
    enableSilentNotificationSettings: 'Ota äänettömät ilmoitukset käyttöön',
    suppressWebexCallingNotificationSettings: 'Piilota Webex Callingin ilmoitukset',
    notificationSettingDescription:
      'Toimittaa ilmoitukset, kuten uudet viestit, hälytykset ja tilamuutokset.',
    silentNotificationDescription:
      'Poistaa näyttöön tulevat hälytykset käytöstä. Voit tarkastella ilmoituksia ilmoituskeskuksessa.',
    suppressWebexCallingNotificationDescription: 
    'Älä näytä saapuvien Webex-puhelujen ponnahdusilmoituksia, ja vastaa niihin Webex Contact Centerin kautta.',
    arrowLabel: 'Palaa takaisin',
    managedTeams: 'Hallinnoidut tiimit',
    managedTeamsError: 'Tiimien lataus epäonnistui.',
    viewAll: 'Näytä kaikki',
    profileSettings: 'Profiiliasetukset',
    userRole: 'Rooli',
    saveSelection: 'Tallenna valinta',
    extension: 'Alanumero',
    changeProfileConfirmHeader: 'Vahvista profiiliasetusten muutokset',
    changeProfileConfirmMessage:
      'Haluatko varmasti tallentaa profiilin muutokset?',
    confirm: 'Vahvista',
    errorProfileUpdate:
      'Et voi muuttaa profiiliasetuksia nyt, sillä sinulla on aktiivisia pyyntöjä. Tee aiemmat pyynnöt loppuun ja yritä uudelleen.',
    roleAgentSupervisor: 'Esimies ja edustaja',
    roleSupervisor: 'Esimies',
    noTeam: 'Ei tiimiä',
    testYourNetwork: 'Testaa verkkosi',
    speakerAndMic: 'Kaiutin ja mikrofoni',
    speaker: 'Kaiutin',
    mic: 'Mikrofoni',
    speakerDescription:
      'Varmista, että kuulet soittajan äänen, valitsemalla kaiutin ja testaamalla sitä.',
    micDescription:
      'Varmista, että soittaja kuulee äänesi, valitsemalla mikrofoni ja testaamalla sitä.',
    micError:
      'Mikrofonin käyttö on estetty. Ota mikrofoni käyttöön selaimen asetuksissa tai ota yhteys järjestelmänvalvojaan.',
    speakerError:
      'Kaiutin ei ole tällä hetkellä käytettävissä, koska mikrofonin käyttö on estetty.',
    telephony: 'Puhelinliikenne',
    desktop: 'Työpöytä',
    onSpeakerPlay:
      'Jos et kuule testiääntä, tarkista kaiutin.',
    onMicPlay:
      'Jos et kuule testiääntä, tarkista sekä kaiutin että mikrofoni.',
    onMicRecord: 'Nauhoita viesti toistoa varten.',
    test: 'Testaa',
    recording: 'Tallennus',
    playing: 'Toistetaan',
    reconnecting: 'Yhdistetään uudelleen',
    disconnectMessage:
      'Työpöydän puhelinliikenneyhteys katkaistu. Kokeile toista puhelinliikennevaihtoehtoa.',
    singleTelephonyDisconnectMessage:
      'Työpöydän puhelinliikenneyhteys katkaistu. Ota yhteyttä järjestelmänvalvojaan.',
    clear: 'Tyhjennä syöte',
    rememberMeCheckBoxMessage: "Älä näytä uudelleen",
    saveLabel: 'Tallenna',
    browserUnsupportedError: "Kirjautuminen epäonnistui, koska käytössä on selain, jota ei tueta.",
    microphoneAccessDeniedError: "Mikrofonin käyttö on estetty. Ota mikrofoni käyttöön selaimen asetuksissa tai ota yhteys järjestelmänvalvojaan.",
  },
  contactHistory: {
    mainHeader: 'Yhteydenottohistoria',
    handledBy: 'Käsittelijä',
    noRecordFound: 'Yhteydenottohistoriaa ei löytynyt!',
    tryAgain: 'Yritä uudelleen',
    errorMsg: 'Yhteydenottohistoriaa ei voida noutaa. Yritä uudelleen.',
    errorID: 'Virheen tunnus',
    missingAni: 'ANI puuttuu',
    timeIcon: 'Kesto',
    taskHandled: 'Tehtävä käsitelty',
    noHistoryNew: 'Ei historiaa',
    noHistory: 'Ei historiaa',
    viewTranscript: 'Näytä sähköpostiviesti',
    transcriptFor: 'Tallenteet:',
    editBeforeCall: 'Muokkaa ennen puhelua',
    clickToCall: 'Soita napsauttamalla',
    onAnActiveCallErrorMessage:
      'Et voi aloittaa uutta puhelua, koska olet jo mukana aktiivisessa puhelussa.',
    receivedFrom: 'Yhteydenotto saatu kohteesta',
    initiatedTo: 'Yhteydenotto aloitettu kohteeseen',
    wrapUpReason: 'Päättämisen syy',
    startCallTelephony:
      'Aloita lähtevä puhelu napsauttamalla puhelinnumerolinkkiä.',
    contactHistoryList: 'Yhteydenottohistorialuettelo',
    wrapUpCode: 'Päättämiskoodi',
    agentName: 'Edustajan nimi',
    entryPointName: 'Aloituskohta',
    acceptedTimeAndDate: 'Hyväksytty päivämäärä ja aika',
    duration: 'Kesto',
    emailTranscript: 'Sähköpostitallenne',
    clickToViewEmailTranscript: 'Näytä sähköpostitallenne napsauttamalla',
    listContainer: 'Luettelosäilö'
  },
  contactTranscript: {
    agent: 'Edustaja',
    entryPoint: 'Aloituskohta',
    date: 'Päivämäärä',
    subject: 'Aihe',
    from: 'Mistä',
    sent: 'Lähetetty',
    to: 'Mihin',
    back: 'Takaisin',
    errorTranscript: 'Virhe tallenteita noudettaessa',
    customer: 'Asiakas',
    inboundErrorMessage: 'Asiakkaan sähköpostin lataus epäonnistui',
    outboundErrorMessage: 'Edustajan vastauksen lataus epäonnistui'
  },
  popoverTitle: {
    callback: 'Takaisinsoitto',
    outboundCall: 'Lähtevä puhelu',
    incomingCall: 'Saapuva puhelu',
    progressiveCampaign: 'Kampanjapuhelu',
    courtesyCallback: 'Huomaavaisuustakaisinsoitto',
    chat: 'Saapuva keskustelu',
    incoming: 'Saapuvat',
    monitoringCall: 'Seurantapuhelu'
  },
  connecting: 'Yhdistetään',
  initiating: 'Alustetaan',
  outbound: 'Lähtevä',
  transfer: {
    title: 'Siirtopyyntö',
    heading: {
      chat: 'Valitse edustaja tai jono, johon haluat siirtää.',
      email: 'Valitse jono, johon haluat siirtää.',
      telephony:
        'Valitse edustaja, jono tai valintanumero, johon haluat siirtää.',
      noQueueTelephony:
        'Valitse edustaja tai valintanumero, johon haluat siirtää.'
    },
    header: {
      chat: 'Valitse edustaja tai jono tämän yhteydenoton siirtämiseen.',
      email: 'Valitse jono tämän yhteystiedon siirtämiseen.',
      telephony:
        'Valitse edustaja, jono, valintanumero tai organisaatio tämän yhteydenoton siirtämiseen.',
      noQueueTelephony:
        'Valitse edustaja, valintanumero tai organisaatio tämän yhteydenoton siirtämiseen.',
      noOrganizationTelephony:
        'Valitse edustaja, jono tai valintanumero tämän yhteydenoton siirtämiseen.',
      noQueueOrganizationTelephony:
        'Valitse edustaja tai valintanumero tämän yhteydenoton siirtämiseen.'
    },
    queues: 'Jonossa',
    agents: 'Edustaja',
    dialNumber: 'Valintanumero',
    organization: 'Organisaatio',
    placeholder: {
      Queues: 'Valitse jonoluettelosta',
      Agents: 'Valitse edustajaluettelosta',
      DialNumber: 'Valitse nimen tai numeron mukaan',
      DialNumberOrEntryPoint: 'Valitse nimen/numeron/aloituskohdan mukaan',
      ChooseByNameOrNumber: 'Valitse nimen/numeron mukaan',
      Organization: 'Hae nimen/roolin/osaston/työpuhelimen mukaan',
      WebexOrganization: 'Hae nimen tai sähköpostin mukaan',
      DialNumberSearch: 'Hae nimen tai numeron mukaan'
    },
    type: 'Siirrä',
    cancel: 'Peruuta',
    closeModal: 'Sulje modaali',
    failureError: 'Pyyntöä ei voida siirtää. Yritä uudelleen.',
    entryPoint: 'Aloituskohta'
  },
  consult: {
    title: 'Konsultointipyyntö',
    heading: {
      chat: 'Valitse edustaja tai jono, johon haluat siirtää.',
      email: 'Valitse jono, johon haluat siirtää.',
      telephony:
        'Valitse edustaja, jono tai valintanumero, jonka kanssa haluat konsultoida.',
      noQueueTelephony:
        'Valitse edustaja tai valintanumero, jonka kanssa haluat konsultoida.'
    },
    header: {
      chat: 'Valitse edustaja tai jono tämän yhteydenoton siirtämiseen.',
      email: 'Valitse jono tämän yhteystiedon siirtämiseen.',
      telephony:
        'Valitse edustaja, jono, valintanumero tai organisaatio, jonka kanssa haluat konsultoida.',
      noQueueTelephony:
        'Valitse edustaja, valintanumero tai organisaatio, jonka kanssa haluat konsultoida.',
      noOrganizationTelephony:
        'Valitse edustaja, jono tai valintanumero, jonka kanssa haluat konsultoida.',
      noQueueOrganizationTelephony:
        'Valitse edustaja tai valintanumero, jonka kanssa haluat konsultoida.'
    },
    queues: 'Jonossa',
    agents: 'Edustaja',
    dialNumber: 'Valintanumero',
    organization: 'Organisaatio',
    placeholder: {
      Queues: 'Valitse jonoluettelosta',
      Agents: 'Valitse edustajaluettelosta',
      DialNumber: 'Valitse nimen tai numeron mukaan',
      DialNumberOrEntryPoint: 'Valitse nimen/numeron/aloituskohdan mukaan',
      ChooseByNameOrNumber: 'Valitse nimen/numeron mukaan',
      Organization: 'Hae nimen/roolin/osaston/työpuhelimen mukaan',
      WebexOrganization: 'Hae nimen tai sähköpostin mukaan',
      DialNumberSearch: 'Hae nimen tai numeron mukaan'
    },
    type: 'Konsultoi',
    checkBoxLabel: 'Salli osallistujien jatkaa vuorovaikutusta.',
    cancel: 'Peruuta',
    closeModal: 'Sulje modaali',
    failureError: 'Konsultointipyyntöä ei voida yhdistää. Yritä uudelleen.',
    customerLeftMsg: 'Asiakasyhteys katkaistu. Konsultointia ei enää tarvita.',
    ctqFailureMsg:
      'Konsultointipuhelun siirtoa jonoon ei voida peruuttaa. Yritä uudelleen.',
    cancelCtqInfo:
      'Haetaan saatavilla olevaa edustajaa valitusta jonosta. Odota tai peruuta konsultointipyyntö.',
    cancelCtqAction: 'Peruuta konsultointi',
    entryPoint: 'Aloituskohta'
  },
  conference: {
    title: 'Neuvottelupyyntö',
    heading: {
      chat: 'Valitse tietty edustaja chat-neuvotteluun'
    },
    queues: 'Jonossa',
    agents: 'Edustaja',
    dialNumber: 'Valintanumero',
    organization: 'Organisaatio',
    placeholder: {
      Queues: 'Valitse jonoluettelosta',
      Agents: 'Valitse edustajaluettelosta',
      DialNumber: 'Valitse nimen tai numeron mukaan'
    },
    type: 'Neuvottelu',
    cancel: 'Peruuta',
    closeModal: 'Sulje modaali',
    failureError: 'Neuvottelupyyntöä ei voida alustaa. Yritä uudelleen.'
  },
  transferModal: {
    Agents: 'Edustajien luetteloa ei voi noutaa. Päivitä luettelo.',
    AgentsEmpty: 'Ei edustajaa saatavilla',
    Queues: 'Jonojen luetteloa ei voi noutaa. Päivitä luettelo.',
    QueuesEmpty: 'Ei jonoa saatavilla',
    EPEmpty: 'Aloituskohtaa ei ole käytettävissä',
    DialNumber:
      'Valintanumeroiden luetteloa ei voi noutaa osoitekirjasta. Päivitä luettelo.',
    EntryPoint:
      'Aloituskohtanumeroiden luetteloa ei voi noutaa. Päivitä luettelo.',
    Common: 'Luetteloa ei voi noutaa. Päivitä luettelo.',
    DialNumberEmpty: 'Ei valintanumeroa saatavilla',
    DialNumbInvalid:
      'Valintanumero on virheellinen. Ota yhteyttä järjestelmänvalvojaan.',
    DialNumbOrEntryPointInvalid:
      'Valintanumero/aloituskohta on virheellinen. Ota yhteyttä järjestelmänvalvojaan.',
    refreshQueueList: 'Päivitä jonoluettelo',
    refreshAgentList: 'Päivitä edustajaluettelo',
    refreshEpList: 'Päivitä aloituskohdat',
    refreshAddressBook: 'Päivitä osoitekirja',
    refreshTheList: 'Päivitä luettelo',
    entryPointSectionLabel: 'Aloituskohta',
    addressBookSectionLabel: 'Osoitekirja',
    organization: 'Organisaatio',
    comboBoxAriaLabelAgent: 'Valitse edustajaluettelosta',
    comboBoxAriaLabelQueue: 'Valitse jonoluettelosta',
    comboBoxAriaLabelEp: 'Valitse aloituskohtien luettelosta',
    infScrollAgent: 'Hae edustajista',
    infScrollQueue: 'Hae jonoista',
    infScrollEP: 'Hae aloituskohdista',
    allRadioButtonHidedTextForConsult: 'Sinulla ei ole määritettyjä tahoja, joiden kanssa voisit konsultoida tästä vuorovaikutuksesta. Ota yhteyttä järjestelmänvalvojaan.',
    allRadioButtonHidedTextForTransfer: 'Sinulla ei ole määritettyjä tahoja, joille voisit siirtää tämän vuorovaikutuksen. Ota yhteyttä järjestelmänvalvojaan.',
    allRadioButtonHidedTextForConference: 'Sinulla ei ole määritettyjä tahoja, joiden kanssa voisit neuvotella tästä vuorovaikutuksesta. Ota yhteyttä järjestelmänvalvojaan.',
    searchMinCharError: 'Anna vähintään kolme merkkiä hakua varten.',
  },
  wrapup: {
    cancelautowrapup: 'Peruuta automaattinen päättäminen',
    wrapupreason: 'Päättämissyyt',
    untilautowrapup: 'automaattiseen päättämiseen',
    followupsetting: 'Jatkotoimiasetus',
    lastagentroute: 'Edellinen edustajan reititys',
    submitwrapup: 'Lähetä päättäminen',
    wrapupsearch: 'Hae päättämisen syy',
    invalidationError: 'Päättämisen lähetys epäonnistui',
    searchResult: 'Hakutuloksia saatavilla',
    noResultFound: 'Hakutuloksia ei löytynyt',
    listContainerLabel: 'Päättämisen luettelosäilö',
    searchError: 'Syötä vähintään kolme merkkiä, jos haluat hakea päättämissyitä.',
  },

  outdial: {
    call: 'Soita',
    dialpadSearch: 'Anna numero, johon soitetaan',
    addressSearch: 'Hae nimellä/numerolla',
    addressTab: 'Osoite',
    addressTabTooltip: 'Hae osoitekirjaa',
    dialpadTab: 'Valintanäppäimistö',
    dialpadTooltip: 'Soita numeroon',
    searchTab: 'Haku',
    searchTabTooltip:'Hae henkilöitä organisaatiosta',
    noAdrFound: 'Vastineita ei löytynyt',
    noContacts: 'Ei yhteyshenkilöitä',
    mainIconTooltip: 'Lähtevä puhelu',
    errorOutdialFailed:
      'Lähtevä puhelu epäonnistui. Työpöytä ei voinut yhdistää puhelua tai puheluun ei vastattu.',
    errorOutdialDisabled: 'Lähtevät puhelut on poistettu käytöstä',
    errorDialPadValidationMessage: 'Virheellinen muoto',
    outdialReqInProgress: 'Lähtevä puhelu on käynnissä',
    outdialAniPlaceholder: 'Valitse lähtevä ANI',
    outdialAniLabel: 'Lähtevä ANI',
    outdialAniPlaceHolder: 'Hae lähtevää ANIa',
    errorDcCallsLimitExceeded:
      'Datakeskus on saavuttanut lähtevien puheluiden enimmäismäärän. Lähteviä puheluita ei voi soittaa enempää',
    errorOrgCallsLimitExceeded:
      'Organisaatio on saavuttanut lähtevien puheluiden enimmäismäärän. Lähteviä puheluita ei voi soittaa enempää.',
    errorOutDialNoAnswerFromCustomer:
      'Asiakas ei vastannut puheluun. Yritä soittaa myöhemmin uudelleen.',
    errorOutDialCustomerUnavailable:
      'Asiakas ei ole nyt tavoitettavissa. Yritä soittaa myöhemmin uudelleen.',
    errorOutDialAgentEnds: 'Olet lopettanut puhelun asiakkaan kanssa.',
    errorOutDialCustomerBusy: 'Asiakas puhuu parhaillaan toista puhelua. Yritä soittaa myöhemmin uudelleen.',
    searchError: 'Anna vähintään kolme merkkiä yhteystietojen hakua varten.',
    upArrowLabel: 'Laajenna',
    clear: 'Tyhjennä syöte',
    outdialDialogDescription: 'Olet tällä hetkellä valintaikkunassa, jossa on välilehtiä.'
  },

  organization: {
    noMatchFound: 'Vastineita ei löytynyt',
    searchError: 'Anna vähintään kolme merkkiä yhteystietojen hakua varten.',
    authError: 'Ei näytettäviä yhteystietoja. Microsoftin todennus epäonnistui.'
  },

  interactionPopover: {
    of: '/',
    accept: 'Salli',
    acceptAriaLabel: 'Hyväksy tehtävä {taskNumber} – {taskType} kohteesta {from}',
    requests: 'Pyynnöt',
    back: 'takaisin',
    next: 'seuraava',
    acceptMultipleRequest: 'Hyväksy {requestCount} pyyntöä',
    paginationDetail: '{indexStart}-{indexEnd} / {totalPopoverpoolLength}',
    hidePopoverDetails: 'Piilota ponnahdusikkunan tiedot',
    showPopoverDetails: 'Näytä ponnahdusikkunan tiedot',
    customerName: 'Asiakkaan nimi',
    email: 'Sähköposti',
    queueName: 'Jonon nimi',
    failedToAccept: 'Hyväksyntä epäonnistui.',
    unableToAccept: 'Yhteydenottoa ei voida hyväksyä.',
    failedToEnd: 'Lopettaminen epäonnistui.',
    unableToEnd: 'Yhteydenottoa ei voida lopettaa. ',
    ringing: 'Soi',
    calling: 'Soitetaan',
    phoneNumber: 'Puhelinnumero',
    dni: 'DNIS',
    ivrPathId: 'IVR-polun tunnus',
    pathId: 'Polun tunnus',
    rona: 'RONA',
    sourcePage: 'Lähdesivu',
    sourceNumber: 'Lähdenumero',
    appUserId: 'Sovelluskäyttäjän tunnus',
    acceptAll: 'Hyväksy kaikki tehtävät',
    agentDn: 'Edustajan DN',
    agentName: 'Asiakaspalvelijan nimi',
    agentTeam: 'Edustajan tiimi',
    requestDetails: 'Pyynnön tiedot',
    incomingCallFrom: 'Saapuva puhelu:',
    unableToAnswer: 'Puheluun ei voi vastata. Yritä uudelleen.',
    unableToDecline: 'Puhelua ei voi hylätä. Yritä uudelleen.'
  },

  multiLogin: {
    header: 'Hälytys useista kirjautumisista',
    message:
      'Olet kirjautunut Desktopiin useassa sovellusesiintymässä. Valitse Jatka, jos haluat käyttää Desktopia tässä sovellusesiintymässä. Muussa tapauksessa sulje tämä ikkuna.',
    continue: 'Jatka'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Siirto aloituskohtaan/jonoon epäonnistui määritysvirheen vuoksi.',
    1010: "Konsultointi ei onnistu, koska edustajaa ei voitu määrittää ajoissa. ",
    1042: "Yhteyshenkilöä ei löydy",
    1043: 'Kohde on virheellinen.',
    1045: 'Vuorovaikutusta ei ole määritetty edustajalle.',
    1046: 'Edustajan konsultointi epäonnistui, koska järjestelmästä ei löytynyt vastaavaa edustajan kanavaa.',
    1038: "Edustajaa ei löydy",
    1037: 'Kirjautuminen epäonnistui sisäisen virheen vuoksi.',

    // Media Events
    138: 'Toiminto epäonnistui tuntemattomasta syystä.',
    136: 'Käyttäjää ei löydy',

    // AgentConsultFailed
    1050: 'Konsultointi ei onnistu, koska määritystä tai toimintoa kulussa ei tueta. ',
    1005: "Konsultointi ei onnistu, koska edustaja ei vastannut pyyntöön ajoissa.",
    1051: 'Konsultointi tai siirto ei onnistu virheellisen aloituskohdan tai valintanumeron vuoksi.',

    // AgentInviteFailed
    1053: 'Vuorovaikutusta ei voi esittää odottavan työnkulun uudelleen jonoon asettamistehtävän vuoksi.',
    1054: 'Lähtevää puhelua ei voi soittaa tähän pyyntöön liittyvien mediaongelmien vuoksi. ',

    // AgentContactAssignFailed
    1011: 'Puheluun ei voi vastata tai sitä ei voi hyväksyä, koska meneillään olevasta vuorovaikutuksesta puuttuu edustajia. ',

    // ContactCallbackFailed
    1034: 'Soittaminen takaisin yhteyshenkilölle epäonnistui, koska pyynnölle vastaanotettiin ContactParkTimeout.',

    // ContactUpdateFailed
    1020: "Muuttujia ei voi päivittää, koska jokin arvoista ylittää 256 merkin rajan. Vähennä merkkejä ja yritä uudelleen.",

    // AgentInviteFailed
    1031: 'Edustaja on kutsunut asiakkaan takaisinsoiton pyytämisen jälkeen.',

    // AgentBlindTransferFailedEvent
    1044: 'Edustajan valvomaton siirto epäonnistui, koska kohde-edustaja on määritetty toiseen vuorovaikutukseen.',

    // AgentCtqCancelFailed
    1047: "Yhteyshenkilöä ei löydy.",

    // AgentCtqFailed
    1048: "Puhelujakeluryhmää ei ole määritetty.",
    1049: 'Jonon enimmäisodotusaika on ylittynyt.',
    // StationLoginFailed
    127: 'Edustajan DN-rekisteröinti epäonnistui, ja tapahtui päällekkäisen kirjautumisen poikkeus.'
  },

  stateSelector: {
    Available: 'Käytettävissä',
    errorstatechange: 'Tilan vaihto ei onnistunut. Yritä uudelleen.',
    errorStateChangeInPendingLogout: 'Edustajan tilan vaihtaminen epäonnistui odottavan uloskirjautumisen vuoksi.',
    label: 'Tavoitettavuustila',
    agentStateSelector: 'Edustajan tilan valitsin',
    Engaged: 'Varattu',
    engagedAvailableInfo:
      'Olet parhaillaan varattuna vuorovaikutuksessa ja Tavoitettavissa-tilassa.',
    engagedIdleInfo:
      'Olet parhaillaan varattuna vuorovaikutuksessa ja Vapaa-tilassa',
    engagedInfo: 'Olet parhaillaan mukana vuorovaikutuksessa.',
    engagedSupervisorStateChange: 'muutti tilaksesi',
    axAgentStateChanged: 'Tilaksi on muuttunut',
    axAgentSync: 'tilan yhteistyötyökalun kanssa synkronoinnin takia.',
    engagedPresenceInfo:
      'Olet parhaillaan mukana vuorovaikutuksessa, ja tilanasi on',
    engagedPresenceSync: 'tilan yhteistyötyökalun kanssa synkronoinnin takia.',
    clear: 'Tyhjennä syöte',
    searchState: 'syöte',
    agentStatusLabel: 'Edustajan tila',
    agentStateLabel: 'Edustajan tilana on ollut {selectedState} edelliset {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Edustajan tilana on ollut {selectedState} edelliset 0 sekuntia',
    agentStateChangeSuccessful:'Tilan vaihtaminen tilaksi {selectedState} onnistui.',
    agentStateChangeFail:'Tilan vaihtaminen tilaksi {selectedState} epäonnistui.',
    searchError: 'Syötä vähintään kolme merkkiä, jotta voit hakea tiloja.'
  },

  warningMessage: {
    header: 'Tallentamattomia muutoksia',
    message:
      'Tällä sivulla on tallentamattomia muutoksia. Haluatko varmasti poistua tältä sivulta? ',
    cancelButton: 'Pysy',
    saveButton: 'Poistu'
  },

  notificationLables: {
    muteVolume: 'Mykistä ilmoitusääni',
    unmuteVolume: 'Poista ilmoitusäänen mykistys',
    notificationVolume: 'Ilmoituksen äänenvoimakkuus',
    playSound: 'Toista ilmoitusääni',
    enableSoundNotificationSettings: 'Ota ääni-ilmoitukset käyttöön',
    enableSoundNotificationSettingsDescription:
      'Toistaa ääni-ilmoitukset saapuville pyynnöille. Voit säätää äänenvoimakkuutta alla.',
    volumeTitle: 'Äänenvoimakkuus'
  },

  channelNameLabels: {
    sms: 'Tekstiviesti',
    telephony: 'Soita',
    chat: 'Keskustele',
    email: 'Sähköposti',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Googlen Business Messages"
  },
  orgDetailsLabels: {
    role: 'Rooli',
    department: 'Osasto',
    email: 'Sähköposti',
    businessPhone: 'Työpuhelin',
    workPhone: 'Työ',
  },
  addressListError: {
    title: 'Tietojen lataus epäonnistui',
    errorId: 'Virheen tunnus:'
  },
  keypad: {
    keyPadSearch: 'Anna numero',
    dialPad: 'Valintapaneeli'
  },
  collabTool: {
    userAuthenticated: 'Käyttäjän todennus:',
    successful: 'Onnistui',
    failed: 'Epäonnistui.',
    tryAgain: 'Yritä uudelleen',
    stateSync: 'Tilan synkronointi:',
    mercuryFailedInfo: ' Ota yhteyttä järjestelmänvalvojaan.',
    retrying: 'Yritetään uudelleen...',
    trackingIdLabel: 'Seurantatunnus: '
  },
  webex: {
    webex: 'Webex',
    info: 'Integroinnin ansiosta voit synkronoida tiloja työpöydän ja Webexin välillä.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Tämän integraation avulla voit konsultoida tai siirtää puhelut Microsoft Teamsin käyttäjille.',
    authenticationFailedInfo:
      'Jos todennusikkuna on jo auki, yritä suorittaa todennus siinä.',
    ListItemContactDetails:
      'Yhteyshenkilön nimi on {name}, sen läsnäolo on {presence}, osasto on {department}, työnimike on {jobTitle} ja puhelinnumero on {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Hätäpalveluilmoitus',
    readNotification: 'Olen lukenut ilmoituksen.'
  },
  webexPresenceStatus: {
    active: 'Käytössä',
    lastActiveFewMinutesAgo: 'Aktiivinen viime minuutteina',
    lastActiveMinutesAgo: 'Aktiivinen {min} minuuttia sitten',
    lastActive1HourAgo: 'Viimeisin toiminta 1 tunti sitten',
    lastActiveHoursAgo: 'Aktiivinen {hour} tuntia sitten',
    lastActiveYesterday: 'Aktiivinen eilen',
    lastActiveOnDate: 'Aktiivinen {date}',
    busy: 'Varattu',
    busyUntil: 'Varattu {date} asti',
    dnd: 'ESH',
    dndUntil: 'Ei saa häiritä ennen {date}',
    quiet: 'Hiljainen',
    quietUntil: 'Hiljainen {date} asti',
    ooo: 'Vapaalla',
    outOfOfficeUntil: 'Vapaalla {date} asti',
    call: 'Puhelimessa',
    meeting: 'Kokouksessa',
    calendarItem: 'Kalenterikokouksessa',
    presenting: 'Esitystä pitämässä',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Hae nimen tai profiilin tietojen mukaan',
    webexPlaceholder: 'Hae nimen tai sähköpostin mukaan',
    refreshTheList: 'Päivitä luettelo',
    refreshAddressBook: 'Päivitä osoitekirja',
    microsoftAuthError: 'Ei näytettäviä yhteystietoja. Microsoftin todennus epäonnistui.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/fr.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/fr.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Échec du chargement des données',
    errorID: 'ID d\'erreur',
    tryAgain: 'Veuillez réessayer',
    Error: 'Erreur',
    okButton: 'OK',
    Yes: 'Oui',
    Cancel: 'Annuler',
    Confirm: 'Confirmer',
    Continue: 'Continuer',
    Canceling: 'Annulation',
    CiscoAiAssistant: 'Assistant Cisco AI',
    Answer: 'Répondre',
    AnswerAriaLabel: 'Répondre à la tâche de bureau',
    Decline: 'Refuser',
    ErrorSecurityCompliance: 'Conformité de la sécurité',
    errorDetails: 'Détails de l\'erreur',
    learnMore: 'En savoir plus',
    showLess: 'Afficher moins',
    trackingIdDescription:
      'Veuillez communiquer l\'identifiant de suivi à l\'administrateur du site ou à l\'équipe d\'assistance pour qu\'ils puissent enquêter sur la situation.',
    trackingIdInputLabel: 'ID de suivi : ',
    submitForm: 'Envoyer le formulaire',
    unnamedStatus: 'État sans nom',
    errorChatMsg: 'Échec du chargement des données de conversation',
    noOptions: 'Aucune option',
    noResults: 'Aucun résultat',
    more: 'Plus',
    nomatchfound: 'Aucun résultat trouvé',
    collaborationTool: 'Outil de collaboration',
    timerAriaLabel: 'Temps passé',
    historyItemTime: 'Survenu à',
    loading: 'Chargement en cours...',
    months: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre'
    ],
    loadingMsg: 'Chargement en cours...',
    search: 'Rechercher',
    historyChannelLabels: {
      All: 'Tous',
      telephony: 'Voix',
      chat: 'Chat',
      email: 'E-mail',
      social: 'Social'
    },
    homePageLabel: 'Page d\'accueil',
    resizeHistoryDragger: 'Redimensionner le curseur de l\'historique',
    agentHistoryLabel: 'historique de l\'agent',
    clear: 'Effacer la saisie',
    ariaLabelAgentHistoryWrapper:
      'Historique des interactions avec l\'agent Affiche les communications récentes avec vos clients sur différents canaux au cours des dernières 24 heures.',
    sliderResizerInstructions:
      'Vous êtes actuellement sur un curseur. Pour redimensionner, utilisez les touches fléchées',
    resizeHistoryPanel: 'Panneau Historique de redimensionnement, curseur,',
    time: {
      hours: 'heure',
      minutes: 'mn',
      seconds: 'sec'
    }
  },
  email: {
    ToLabel: 'À',
    FromLabel: 'De',
    CcLabel: 'Cc',
    BccLabel: 'Cci',
    SubjectLabel: 'Sujet',
    HideLabel: 'Masquer',
    SendLabel: 'Envoyer',
    ShowPrevThread: 'Afficher le fil de discussion précédent',
    HidePrevThread: 'Masquer le fil précédent',
    ReplyLabel: 'Répondre',
    ReplyAllLabel: 'Répondre à tous',
    ViewOriginalMail: 'Afficher le courrier électronique original',
    QuickReplyInp: 'Réponse rapide ici...',
    AttachFiles: 'Joindre des fichiers',
    ToolbarHeading: 'Entête1',
    ToolbarBold: 'Gras',
    ToolbarItalic: 'Italique',
    ToolbarUnderLine: 'Souligné',
    ToolbarBlockQuote: 'Bloquer le devis',
    ToolbarCode: 'Bloc de code',
    ToolbarListOrder: 'Lister par Commandé',
    ToolbarListBullet: 'Lister par point',
    ToolbarLink: 'Lien',
    ToolbarStrike: 'Barré',
    ToolbarColor: 'Couleur du texte',
    ToolbarTable: 'Tableau',
    insertTable: 'Insérer un tableau',
    insertRowAbove: 'Insérer la ligne au-dessus',
    insertRowBelow: 'Insérer la ligne au-dessous',
    insertColumnLeft: 'Insérer la colonne à gauche',
    insertColumnRight: 'Insérer la colonne à droite',
    deleteRow: 'Supprimer la ligne',
    deleteColumn: 'Supprimer la colonne',
    deleteTable: 'Supprimer le tableau',
    link: 'Lien',
    IndentRight: 'Indenter à droite',
    IndentLeft: 'Indenter à gauche',
    showMoreAttachment: 'Afficher plus de pièces jointes',
    AttachmentLimit: 'Joindre jusqu\'à ',
    attachments: ' pièces jointes, ',
    sizeLimit: ' Mo maximum',
    attachment: 'Pièce jointe',
    errordeleteattachment: 'Échec de la suppression du/des fichier(s). Veuillez réessayer.',
    errordownloadattachment: 'Échec du téléchargement du/des fichier(s). Veuillez réessayer.',
    erroraddattachemnt: 'Impossible de télécharger le(s) fichier(s). Veuillez réessayer.',
    errorendcontact: 'Échec de la cessation de l\'interaction. Veuillez réessayer.',
    erroraddlimitreached:
      'Le fichier n\'a pas pu être joint car il dépasse le maximum autorisé ',
    errorattachmentdrop:
      'Pièce(s) jointe(s) supprimée(s) en raison de la politique de sécurité de l\'entreprise.',
    errorfiletype: 'Le type de fichier n\'est pas pris en charge. Veuillez réessayer.',
    errorcreditcard:
      'Impossible de télécharger la ou les pièces jointes conformément à la politique de sécurité de l\'entreprise.',
    errorcontainsimage:
      'Impossible de télécharger une ou plusieurs pièces jointes. Les images contenues dans les pièces jointes ne sont pas conformes à la politique de sécurité de l\'entreprise.',
    errorlimit: ' Limite de Mo.',
    errorsendemail: 'Impossible d\'envoyer le courrier électronique. Veuillez réessayer.',
    errorpcicheckemail: 'Impossible de récupérer les données PCI. Veuillez réessayer.',
    errortext: 'Échec du chargement des données',
    tryAgain: 'Veuillez réessayer',
    replywarning:
      'Ne partagez pas d\'informations financières, de santé ou toute autre information personnellement identifiable (IIP) dans ce message ou dans les pièces jointes.',
    datamasked:
      'L\'objet ou le corps du courrier électronique contient des données qui enfreignent la politique de sécurité de l\'entreprise. Êtes-vous sûr de vouloir envoyer le courrier électronique ?',
    pcibannerwarning:
      'L\'objet ou le corps du courrier électronique contient des données qui enfreignent la politique de sécurité de l\'entreprise.',
    on: 'Activé',
    wrote: 'écrire'
  },
  interaction_control: {
    windowOpened: 'Fenêtre ouverte',
    connected: 'Connecté',
    consultRequested: 'Consultation demandée',
    consulting: 'Consultation',
    consultCallOnHold: 'Consultation en attente',
    callOnHold: 'Appel en attente',
    consult: 'Consulter',
    endconsult: 'Fin de consultation',
    hold: 'Mettre en attente',
    transfer: 'Transférer',
    conference: 'Conférence',
    endconference: 'Terminer la conférence',
    conferenceRequested: 'Conférence demandée',
    switchCall: 'Changer',
    mergeCall: 'Fusionner',
    wrapup: 'Traitement post-appel',
    end: 'Fin',
    customername: 'Nom du client',
    dn: 'DNIS',
    ivrpath: 'Chemin IVR',
    email: 'E-mail client',
    ani: 'Numéro de téléphone',
    queueid: 'Nom de la file d\'attente',
    ronatimeout: 'Durée de sonnerie sans réponse (RONA)',
    pathid: 'ID du chemin IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'DN d\'agent',
    destagentname: 'Nom de l\'agent',
    virtualteamname: 'File d’attente',
    category: 'Catégorie',
    additionaldetails: 'Détails supplémentaires',
    sourcenumber: 'Numéro de la source',
    sourcepage: 'Page source',
    appuser: 'ID utilisateur de l\'application',
    customernumber: 'Numéro de téléphone',
    exitconference: 'Quitter la conférence',
    resume: 'Reprendre',
    pauserecording: 'Suspendre l\'enregistrement',
    resumerecording: 'Reprendre l\'enregistrement',
    exitconsult: 'Quitter la consultation',
    pauseRecordingFailed: 'Impossible de mettre l\'enregistrement en pause. Veuillez réessayer.',
    resumeRecordingFailed: 'Impossible de reprendre l\'enregistrement. Veuillez réessayer.',
    holdCallFailed: 'Impossible de mettre l\'appel en attente. Veuillez réessayer.',
    resumeCallFailed: 'Impossible de reprendre l\'appel. Veuillez réessayer.',
    endCallFailed: 'Échec de la cessation de l\'interaction. Veuillez réessayer.',
    consultTransferFailed:
      'Impossible de transférer l\'appel de consultation. Veuillez réessayer.',
    conferenceTransferFailed:
      'Impossible de transférer la conférence téléphonique. Veuillez réessayer.',
    conferenceFailed:
      'Impossible de se connecter à la demande de conférence téléphonique. Veuillez réessayer.',
    consultEndFailed: 'Impossible de mettre fin à la demande de consultation. Veuillez réessayer.',
    conferenceExitFailed:
      'Impossible de quitter la demande de conférence. Veuillez réessayer.',
    conferenceEndFailed:
      'Impossible de mettre fin à la demande de conférence. Veuillez réessayer.',
    cancelCtqFailed:
      'Impossible d\'annuler l\'appel de consultation à la file d\'attente. Veuillez réessayer.',
    privacyShield: 'Bouclier de la vie privée',
    errorOnPrvacyShieldForConsult:
      'L\'enregistrement est actuellement en pause. Veuillez reprendre l\'enregistrement pour commencer une consultation.',
    errorOnPrvacyShieldForTransfer:
      'L\'enregistrement est actuellement en pause. Veuillez reprendre l\'enregistrement pour commencer un transfert d\'appel.',
    cancelConsult: 'Annuler la consultation',
    cancelTransfer: 'Annuler le transfert',
    copy: 'Copier',
    copied: 'Copié',
    cadrequestuccess: 'Les informations sur les clients ont été sauvegardées avec succès.',
    cadrequestfailure: 'Impossible de sauvegarder les informations sur les clients. Veuillez réessayer ultérieurement.',
    cadupdatedmessage: 'Les informations sur les clients ont été récemment mises à jour par',
    unsavedmessage: 'Vos modifications non sauvegardées sont écrasées.',
    save: 'Enregistrer',
    revert: 'Revenir',
    expandDetails: 'Développer les informations détaillées',
    collapseDetails: 'Réduire les informations détaillées',
    cadValidationError:
      'Format non valide. Utilisez la norme internationale pour la date et l\'heure.',
    secureCadSaveError:
      'Les informations sur le client ne sont pas enregistrées. Cliquez sur Enregistrer pour réessayer.',
    secureDecryptionError: 'Impossible d\'afficher les variables sécurisées.',
    clickToTry: 'Cliquez pour réessayer',
    isSecureVariable: 'Est une variable sécurisée',
    contactorigin: 'Origine du contact',
    resumeMonitoring: 'Reprendre la surveillance',
    pauseMonitoring: 'Suspendre la surveillance',
    whisperCoach: 'Fonction de coaching en mode chuchotement',
    bargeIn: 'Rejoindre la conversation',
    endMonitoring: 'Mettre fin à la surveillance',
    contactphonenumber: 'Numéro de téléphone du contact',
    contactqueue: 'File d\'attente des contacts',
    activeparticipants: 'Participants actifs',
    consultedparticipant: 'Participant consulté',
    contactstatus: 'État du contact',
    timeincontactstatus: 'Durée dans État du contact',
    totalcontactduration: 'Durée totale du contact',
    agentinteractiontime: 'Durée de l\'interaction',
    recording: 'Enregistrement',
    monitoring: 'Surveillance',
    monitoringPaused: 'Surveillance mise en pause',
    pauseMonitoringFailed: 'Impossible de mettre la surveillance en pause. Veuillez réessayer.',
    resumeMonitoringFailed: 'Impossible de reprendre la surveillance. Veuillez réessayer.',
    callCancelledInProgress: 'Annulation de l\'appel en cours',
    bargedIn: 'Interrompu',
    keypad: 'Clavier',
    mute: 'Couper le son',
    unmute: 'Rétablir le son',
    bargeInTooltipText:
      'Le micro se mettra en marche et vous participerez à cette interaction avec le client',
    bargeInCompactTooltipText:
      'Interrompre. Le micro se mettra en marche et vous participerez à cette interaction avec le client',
    bargeInTooltipDisabled: 'Pour permettre l\'interruption, veuillez reprendre le suivi',
    bargeInFailedTitle: 'Interruption échouée',
    bargeInFailedData:
      'Une erreur s\'est produite lors de votre tentative d\'interruption. Veuillez réessayer ultérieurement.',
    supervisorBargedIn: 'est intervenu(e) dans votre appel.',
    leftInteraction: 'a quitté l\'interaction.',
    conferenceEnded: 'La téléconférence est terminée.',
    participants: 'Participants',
    badgeAriaLabel: '{participant} prend part à l\'appel',
    bargeInConferenceAriaLabel: 'Il y a deux participants à l\'interaction',
    taskName: 'Interaction Contrôle Nom de la tâche',
    interactionDurationLabel: 'Durée',
    wrapupassist: 'Assistance post-appel',
    consultingTaskContext: 'Appel de consultation de',
    consultExited: 'Fin de la consultation',
    endCall: 'Termine l\'appel.',
    exitconferenceCall:
      'Quitte l\'appel et la conférence se poursuit avec les participants actifs.',
    recordingInProgess: 'Enregistrement en cours',
    recordingPaused: 'Enregistrement en pause',
    searchPlaceholder: 'Rechercher dans les contacts',
    postCall: "Après l’appel",
    switchCallTooltip: "Basculer sur l\'appel",
    switchConsultTooltip: "Basculer sur l\'appel de consultation",
    switchConferenceTooltip: "Basculer sur la téléconférence",
    confirmationDialog: {
      endCallTitle: 'Voulez-vous mettre fin à l\'appel ?',
      endCallMessage: 'Cliquez sur Confirmer pour mettre fin à l\'appel pour tous les participants.',
      exitConferenceTitle: 'Voulez-vous quitter la conférence téléphonique ?',
      exitConferenceMessage:
        'Cliquez sur Confirmer pour quitter la conférence téléphonique et permettre aux autres participants de continuer.',
      confirmButtonLabel: "Confirmer",
      cancelButtonLabel: "Annuler",  
    },
    postCallOnHold: "Mise en attente du post-appel",
    postCallConsult: "Consultation post-appel",
    postCallConsultOnHold: "Consultation post appel en attente",
  },
  agentProfile: {
    teamName: 'Équipe',
    dialNumber: 'Numéro composé',
    phoneNumber: 'Numéro de téléphone',
    settings: 'Modifier les paramètres',
    signOut: 'Se déconnecter',
    webRTCDisconnected: 'Avertissement : Téléphonie de bureau déconnectée ',
    msAuthFailed: 'Échec de l\'authentification Microsoft',
    stateSyncFailed: 'Échec de la synchronisation des états',
    userProfileLabel: 'Profil utilisateur',
    ariaAgentprofile: 'Profil de l’agent',
    ChannelCapacity: 'Capacité du canal',
    voice: 'Voix',
    chat: 'Chat',
    email: 'E-mail',
    social: 'Social',
    channelCapacityTooltip: 'Cliquez pour en savoir plus',
    blendedRouting: 'Fusionné',
    exclusiveRouting: 'Routage exclusif',
    realtimeRouting: 'Routage mixte en temps réel',
    blendedRoutingTooltip: 'Traiter plusieurs contacts  sur tous les canaux.',
    exclusiveRoutingTooltip: 'Ne traiter qu\'un seul contact à la fois.',
    realtimeRoutingTooltip: 'Traiter un canal en temps réel obligatoire.',
    errorActiveContacts:
      'Vous ne pouvez pas vous déconnecter maintenant parce que vous avez des conversations actives. Terminez-les et essayez à nouveau.',
    searchTeams: 'Recherche d\'équipes',
    changeTeamsConfirmHeader: 'Confirmation du changement d\'équipe',
    changeTeamsConfirmMessage: 'Êtes-vous sûr de vouloir changer d\'équipe ?',
    changeTeamLabel: 'Changer d\'équipe',
    errorChangeTeams:
      'Vous ne pouvez pas changer d\'équipe maintenant car vous avez une ou plusieurs demandes actives. Veuillez les effectuer et réessayer.',
    saveTeamSelection: 'Enregistrer la sélection de l\'équipe',
    userSettings: 'Paramètres de l\'utilisateur',
    resetLayout: 'Rétablir l\'ensemble de la mise en page du bureau',
    resetConfirmHeader: 'Réinitialiser la confirmation de la mise en page',
    resetConfirmMessage:
      'Êtes-vous sûr de vouloir réinitialiser l\'ensemble de la mise en page du bureau ? <br/> Le bureau reviendra à la présentation par défaut.',
    downloadLogs: 'Télécharger le rapport d\'erreur',
    help: 'Aide',
    signoutConfirm: 'Êtes-vous sûr de vouloir vous déconnecter ?',
    signoutConfirmHeader: 'Confirmation de déconnexion',
    darkTheme: 'Passer en mode sombre',
    newLook: 'Passer à la nouvelle apparence',
    keyboardShortcuts: 'Raccourcis clavier',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Maj+2',
    notificationSettings: 'Paramètres de notification',
    silentNotification: 'Notification silencieuse',
    enableNotificationSettings: 'Activer les notifications',
    enableSilentNotificationSettings: 'Activer les notifications silencieuses',
    suppressWebexCallingNotificationSettings: 'Masquer les notifications d\'appel Webex',
    notificationSettingDescription:
      'Envoyer des notifications telles que les nouveaux messages, les alertes et les changements de statut.',
    silentNotificationDescription:
      'Désactiver les alertes à l\'écran. Vous pouvez consulter les notifications dans le Centre de notification.',
    suppressWebexCallingNotificationDescription: 
    'N\'affichez pas de notifications pop-up pour les appels Webex entrants et répondez-y par l\'intermédiaire du Webex Contact Center.',
    arrowLabel: 'Précédent',
    managedTeams: 'Équipes gérées',
    managedTeamsError: 'Échec lors du chargement des équipes.',
    viewAll: 'Afficher Tout',
    profileSettings: 'Paramètres du profil',
    userRole: 'Rôle',
    saveSelection: 'Enregistrer la sélection',
    extension: 'Numéro de poste',
    changeProfileConfirmHeader: 'Confirmer les modifications des paramètres du profil',
    changeProfileConfirmMessage:
      'Voulez-vous vraiment enregistrer les modifications apportées au profil ?',
    confirm: 'Confirmer',
    errorProfileUpdate:
      'Vous ne pouvez pas modifier les paramètres du profil maintenant car vous avez des demandes actives. Veuillez les effectuer et réessayer.',
    roleAgentSupervisor: 'Superviseur et agent',
    roleSupervisor: 'Superviseur',
    noTeam: 'Aucune équipe',
    testYourNetwork: 'Tester votre réseau',
    speakerAndMic: 'Haut-parleur et microphone',
    speaker: 'Haut-parleur',
    mic: 'Microphone',
    speakerDescription:
      'Choisissez et testez le périphérique de sortie pour vous assurer que vous entendez l\'appelant.',
    micDescription:
      'Choisissez et testez le périphérique d\'entrée pour vous assurer que l\'appelant vus entend.',
    micError:
      'L\'accès au microphone est refusé. Activez l\'accès à l\'aide des paramètres du navigateur ou contactez votre administrateur.',
    speakerError:
      'Le haut-parleur n\'est pas disponible actuellement car l\'accès au microphone est refusé.',
    telephony: 'Téléphonie',
    desktop: 'Bureau',
    onSpeakerPlay:
      'Si vous n\'entendez pas le son du test, vérifiez le haut-parleur.',
    onMicPlay:
      'Si vous n\'entendez pas le son du test, vérifiez le haut-parleur et le microphone.',
    onMicRecord: 'Enregistrez un message pour le lire.',
    test: 'Test',
    recording: 'Enregistrement',
    playing: 'Lecture en cours',
    reconnecting: 'En cours de reconnexion...',
    disconnectMessage:
      'La téléphonie de bureau est déconnectée. Essayez une autre option de téléphonie.',
    singleTelephonyDisconnectMessage:
      'Téléphonie de bureau déconnectée. Contactez votre administrateur.',
    clear: 'Effacer la saisie',
    rememberMeCheckBoxMessage: "Ne plus montrer ceci",
    saveLabel: 'Enregistrer',
    browserUnsupportedError: "L\'ouverture de session a échoué car vous utilisez un navigateur non pris en charge.",
    microphoneAccessDeniedError: "L\'accès au microphone est refusé. Activez l\'accès à l\'aide des paramètres du navigateur ou contactez votre administrateur.",
  },
  contactHistory: {
    mainHeader: 'Historique de contacts',
    handledBy: 'Traité par',
    noRecordFound: 'Aucun historique de contact trouvé !',
    tryAgain: 'Veuillez réessayer',
    errorMsg: 'Impossible de récupérer l\'historique des contacts. Veuillez réessayer.',
    errorID: 'ID d\'erreur',
    missingAni: 'Absence d\'ANI',
    timeIcon: 'Durée',
    taskHandled: 'Tâches traitées',
    noHistoryNew: 'Aucun historique',
    noHistory: 'Aucun historique',
    viewTranscript: 'Afficher un message électronique',
    transcriptFor: 'Transcriptions pour',
    editBeforeCall: 'Modifier avant l\'appel',
    clickToCall: 'Cliquer pour appeler',
    onAnActiveCallErrorMessage:
      'Vous ne pouvez pas passer un nouvel appel car vous avez déjà un appel actif.',
    receivedFrom: 'Contact reçu de',
    initiatedTo: 'Contact initié à',
    wrapUpReason: 'Raisons du post-appel',
    startCallTelephony:
      'Cliquez sur le lien du numéro de téléphone pour lancer un appel sortant.',
    contactHistoryList: 'Liste de l\'historique des contacts,',
    wrapUpCode: 'Code de traitement post-appel',
    agentName: 'Nom de l\'agent',
    entryPointName: 'Point d’entrée',
    acceptedTimeAndDate: 'Date et heure acceptées',
    duration: 'Durée',
    emailTranscript: 'Envoyer la transcription par courrier électronique',
    clickToViewEmailTranscript: 'Cliquez pour afficher la transcription de l\'email',
    listContainer: 'Répertorier le conteneur'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Point d’entrée',
    date: 'Date',
    subject: 'Sujet',
    from: 'De',
    sent: 'Envoyé',
    to: 'À',
    back: 'Retour',
    errorTranscript: 'Une erreur s\'est produite lors de la récupération des transcriptions',
    customer: 'Client',
    inboundErrorMessage: 'Échec du chargement du message électronique du client',
    outboundErrorMessage: 'Échec du chargement de la réponse de l\'agent'
  },
  popoverTitle: {
    callback: 'Rappel',
    outboundCall: 'Appel sortant',
    incomingCall: 'Appel entrant',
    progressiveCampaign: 'Appel de campagne',
    courtesyCallback: 'Rappel de courtoisie',
    chat: 'Conversation entrante',
    incoming: 'Entrant',
    monitoringCall: 'Supervision d\'appel'
  },
  connecting: 'Connexion en cours',
  initiating: 'Initialisation en cours',
  outbound: 'Sortant',
  transfer: {
    title: 'Demande de transfert',
    heading: {
      chat: 'Sélectionnez l\'agent ou la file d\'attente vers lequel ou laquelle vous souhaitez effectuer le transfert.',
      email: 'Sélectionnez la file d\'attente vers laquelle vous souhaitez effectuer le transfert.',
      telephony:
        'Sélectionnez l\'agent, la file d\'attente ou le numéro composé vers lequel ou laquelle vous souhaitez effectuer le transfert.',
      noQueueTelephony:
        'Sélectionnez l\'agent ou le numéro composé vers lequel vous souhaitez effectuer le transfert.'
    },
    header: {
      chat: 'Sélectionner l\'agent ou la file d\'attente pour le transfert de ce contact.',
      email: 'Sélectionner la file d\'attente pour le transfert de ce contact.',
      telephony:
        'Sélectionner l\'agent, la file d\'attente, le numéro d\'appel ou l\'organisation pour le transfert de ce contact.',
      noQueueTelephony:
        'Sélectionner l\'agent, le numéro d\'appel ou l\'organisation pour le transfert de ce contact.',
      noOrganizationTelephony:
        'Sélectionner l\'agent, la file d\'attente ou le numéro d\'appel pour le transfert de ce contact.',
      noQueueOrganizationTelephony:
        'Sélectionner l\'agent ou le numéro d\'appel pour le transfert de ce contact.'
    },
    queues: 'File d’attente',
    agents: 'Agent',
    dialNumber: 'Numéro composé',
    organization: 'Entreprise',
    placeholder: {
      Queues: 'Choisir parmi une liste de files d\'attente',
      Agents: 'Choisir parmi une liste d\'agents',
      DialNumber: 'Choisir par nom ou par numéro',
      DialNumberOrEntryPoint: 'Choisir par nom/numéro/point d\'entrée',
      ChooseByNameOrNumber: 'Choisir par nom ou par numéro',
      Organization: 'Recherche par nom, rôle, service ou numéro de téléphone professionnel',
      WebexOrganization: 'Recherche par nom ou email',
      DialNumberSearch: 'Recherche par nom ou numéro'
    },
    type: 'Transférer',
    cancel: 'Annuler',
    closeModal: 'Fermer le modal',
    failureError: 'Impossible de transférer la demande. Veuillez réessayer.',
    entryPoint: 'Point d’entrée'
  },
  consult: {
    title: 'Demande de consultation',
    heading: {
      chat: 'Sélectionnez l\'agent ou la file d\'attente vers lequel ou laquelle vous souhaitez effectuer le transfert.',
      email: 'Sélectionnez la file d\'attente vers laquelle vous souhaitez effectuer le transfert.',
      telephony:
        'Sélectionnez l\'agent, la file d\'attente ou le numéro composé avec lequel ou laquelle vous souhaitez effectuer une consultation.',
      noQueueTelephony:
        'Sélectionnez l\'agent ou le numéro composé avec lequel vous souhaitez effectuer une consultation.'
    },
    header: {
      chat: 'Sélectionner l\'agent ou la file d\'attente pour le transfert de ce contact.',
      email: 'Sélectionner la file d\'attente pour le transfert de ce contact.',
      telephony:
        'Sélectionner l\'agent, la file d\'attente, le numéro d\'appel ou l\'organisation avec lequel ou laquelle vous souhaitez effectuer une consultation.',
      noQueueTelephony:
        'Sélectionner l\'agent, le numéro d\'appel ou l\'organisation avec lequel ou laquelle vous souhaitez effectuer une consultation.',
      noOrganizationTelephony:
        'Sélectionner l\'agent, la file d\'attente ou le numéro d\'appel avec lequel ou laquelle vous souhaitez effectuer une consultation.',
      noQueueOrganizationTelephony:
        'Sélectionner l\'agent ou le numéro d\'appel avec lequel vous souhaitez effectuer une consultation.'
    },
    queues: 'File d’attente',
    agents: 'Agent',
    dialNumber: 'Numéro composé',
    organization: 'Entreprise',
    placeholder: {
      Queues: 'Choisir parmi une liste de files d\'attente',
      Agents: 'Choisir parmi une liste d\'agents',
      DialNumber: 'Choisir par nom ou par numéro',
      DialNumberOrEntryPoint: 'Choisir par nom/numéro/point d\'entrée',
      ChooseByNameOrNumber: 'Choisir par nom ou par numéro',
      Organization: 'Recherche par nom, rôle, service ou numéro de téléphone professionnel',
      WebexOrganization: 'Recherche par nom ou email',
      DialNumberSearch: 'Recherche par nom ou numéro'
    },
    type: 'Consulter',
    checkBoxLabel: 'Permettez aux participants de continuer à interagir.',
    cancel: 'Annuler',
    closeModal: 'Fermer le modal',
    failureError: 'Impossible de se connecter à la demande de consultation. Veuillez réessayer.',
    customerLeftMsg: 'Client déconnecté. La consultation n\'est plus nécessaire.',
    ctqFailureMsg:
      'Impossible d\'annuler l\'appel de consultation à la file d\'attente. Veuillez réessayer.',
    cancelCtqInfo:
      'Recherche d\'un agent disponible dans la file d\'attente sélectionnée. Veuillez attendre ou annuler la demande de consultation.',
    cancelCtqAction: 'Annuler la consultation',
    entryPoint: 'Point d’entrée'
  },
  conference: {
    title: 'Demande de conférence',
    heading: {
      chat: 'Sélectionner un agent spécifique pour la conversation de conférence'
    },
    queues: 'File d’attente',
    agents: 'Agent',
    dialNumber: 'Numéro composé',
    organization: 'Entreprise',
    placeholder: {
      Queues: 'Choisir parmi une liste de files d\'attente',
      Agents: 'Choisir parmi une liste d\'agents',
      DialNumber: 'Choisir par nom ou par numéro'
    },
    type: 'Conférence',
    cancel: 'Annuler',
    closeModal: 'Fermer le modal',
    failureError: 'Impossible d\'initier la demande de conférence. Veuillez réessayer.'
  },
  transferModal: {
    Agents: 'Impossible de récupérer la liste des agents. Veuillez actualiser la liste.',
    AgentsEmpty: 'Aucun agent disponible',
    Queues: 'Impossible de récupérer la liste des files d\'attente. Veuillez actualiser la liste.',
    QueuesEmpty: 'Aucune file d\'attente disponible',
    EPEmpty: 'Aucun point d\'entrée disponible',
    DialNumber:
      'Impossible de récupérer la liste des numéros composés dans le carnet d\'adresses. Veuillez actualiser la liste.',
    EntryPoint:
      'Impossible de récupérer la liste des numéros de points d\'entrée. Veuillez actualiser la liste.',
    Common: 'Impossible de récupérer la liste. Veuillez actualiser la liste.',
    DialNumberEmpty: 'Aucun n° de téléphone disponible',
    DialNumbInvalid:
      'Le numéro de téléphone n\'est pas valable. Veuillez contacter votre administrateur.',
    DialNumbOrEntryPointInvalid:
      'Le numéro de téléphone/point d\'entrée n\'est pas valide. Veuillez contacter votre administrateur.',
    refreshQueueList: 'Actualiser la liste des files d\'attente',
    refreshAgentList: 'Actualiser la liste des agents',
    refreshEpList: 'Actualiser les points d\'entrée',
    refreshAddressBook: 'Actualiser le carnet d\'adresses',
    refreshTheList: 'Actualiser la liste',
    entryPointSectionLabel: 'Point d’entrée',
    addressBookSectionLabel: 'Carnet d’adresses',
    organization: 'Entreprise',
    comboBoxAriaLabelAgent: 'Choisir parmi une liste d\'agents',
    comboBoxAriaLabelQueue: 'Choisir parmi une liste de files d\'attente',
    comboBoxAriaLabelEp: 'Choisissez dans une liste de points d\'entrée',
    infScrollAgent: 'Recherche d\'agents',
    infScrollQueue: 'Recherche dans les files d\'attente',
    infScrollEP: 'Rechercher des points d\'entrée',
    allRadioButtonHidedTextForConsult: 'Vous n\'avez pas d\'entités assignées pour consulter cette interaction. Contactez votre administrateur.',
    allRadioButtonHidedTextForTransfer: 'Vous n\'avez pas d\'entités assignées pour transférer cette interaction. Contactez votre administrateur.',
    allRadioButtonHidedTextForConference: 'Vous n\'avez pas d\'entités assignées pour la conférence de cette interaction. Contactez votre administrateur.',
    searchMinCharError: 'Saisissez un minimum de trois caractères pour effectuer la recherche.',
  },
  wrapup: {
    cancelautowrapup: 'Annuler le traitement post-appel auto',
    wrapupreason: 'Motifs post-appel',
    untilautowrapup: 'jusqu\'au travail post-appel automatique',
    followupsetting: 'Paramétrage du suivi',
    lastagentroute: 'Routage du dernier agent',
    submitwrapup: 'Envoyer le travail post-appel',
    wrapupsearch: 'Rechercher le motif du travail post-appel',
    invalidationError: 'Échec d\'envoi du travail post-appel',
    searchResult: 'Résultats de la recherche disponibles',
    noResultFound: 'Aucun résultat de recherche trouvé',
    listContainerLabel: 'Container de la liste de post-appel',
    searchError: 'Saisissez un minimum de trois caractères pour rechercher les motifs post-appel.',
  },

  outdial: {
    call: 'Appel',
    dialpadSearch: 'Saisir numéro à composer',
    addressSearch: 'Rechercher par Nom/Numéro',
    addressTab: 'Adresse',
    addressTabTooltip: 'Recherche dans le carnet d\'adresses',
    dialpadTab: 'Pavé de numérotation',
    dialpadTooltip: 'Composer un numéro',
    searchTab: 'Rechercher',
    searchTabTooltip:'Rechercher des personnes dans mon organisation',
    noAdrFound: 'Aucun résultat trouvé',
    noContacts: 'Pas de contact',
    mainIconTooltip: 'Appel externe',
    errorOutdialFailed:
      'L\'appel externe a échoué. Le poste de travail n\'a pas pu établir la connexion ou l\'appel n\'a pas reçu de réponse.',
    errorOutdialDisabled: 'Les appels externes sont désactivés',
    errorDialPadValidationMessage: 'Format incorrect',
    outdialReqInProgress: 'Appel externe en cours',
    outdialAniPlaceholder: 'Sélectionner un ANI de numéro d\'appel externe',
    outdialAniLabel: 'ANI d’appel externe',
    outdialAniPlaceHolder: 'Recherche un ANI d\'appels externes',
    errorDcCallsLimitExceeded:
      'Le data center a atteint la limite maximale d\'appels externes. Impossible de passer d\'autres appels externes',
    errorOrgCallsLimitExceeded:
      'L\'organisation a atteint la limite maximale d\'appels externes. Impossible de passer d\'autres appels externes.',
    errorOutDialNoAnswerFromCustomer:
      'Le client n\'a pas répondu à votre appel. Essayez d\'appeler ultérieurement.',
    errorOutDialCustomerUnavailable:
      'Le client n\'est pas disponible pour le moment. Essayez d\'appeler ultérieurement.',
    errorOutDialAgentEnds: 'Vous avez mis fin à votre appel avec le client.',
    errorOutDialCustomerBusy: 'Le client est occupé pour le moment. Essayez d\'appeler ultérieurement.',
    searchError: 'Saisissez un minimum de trois caractères pour rechercher les contacts.',
    upArrowLabel: 'Agrandir',
    clear: 'Effacer la saisie',
    outdialDialogDescription: 'Vous êtes actuellement dans le dialogue avec les onglets.'
  },

  organization: {
    noMatchFound: 'Aucun résultat trouvé',
    searchError: 'Saisissez un minimum de trois caractères pour rechercher les contacts.',
    authError: 'Aucun contact à afficher. L\'authentification Microsoft a échoué.'
  },

  interactionPopover: {
    of: 'de',
    accept: 'Accepter',
    acceptAriaLabel: 'Accepter la tâche {taskNumber} - {taskType} de {from}',
    requests: 'demande(s)',
    back: 'retour',
    next: 'suivante',
    acceptMultipleRequest: 'Accepter {requestCount} demandes',
    paginationDetail: '{indexStart}-{indexEnd} de {totalPopoverpoolLength}',
    hidePopoverDetails: 'Masquer les détails des fenêtres contextuelles',
    showPopoverDetails: 'Afficher les détails de la fenêtre contextuelle',
    customerName: 'Nom du client',
    email: 'E-mail',
    queueName: 'Nom de la file d\'attente',
    failedToAccept: 'Échec de l\'acceptation.',
    unableToAccept: 'Impossible d\'accepter le contact.',
    failedToEnd: 'Échec de la terminaison.',
    unableToEnd: 'Impossible de mettre fin au contact. ',
    ringing: 'Sonnerie',
    calling: 'Appel en cours',
    phoneNumber: 'Numéro de téléphone',
    dni: 'DNIS',
    ivrPathId: 'ID du chemin IVR',
    pathId: 'ID de chemin d\'accès',
    rona: 'RONA',
    sourcePage: 'Page source',
    sourceNumber: 'Numéro de la source',
    appUserId: 'ID utilisateur de l\'application',
    acceptAll: 'Accepter toutes les tâches',
    agentDn: 'DN d\'agent',
    agentName: 'Nom agent',
    agentTeam: 'Équipe d\'agents',
    requestDetails: 'Demande d\'informations',
    incomingCallFrom: 'Appel entrant de',
    unableToAnswer: 'Impossible de répondre à l\'appel. Veuillez réessayer.',
    unableToDecline: 'Impossible de refuser l\'appel. Veuillez réessayer.'
  },

  multiLogin: {
    header: 'Alerte de connexion multiple',
    message:
      'Vous êtes connecté au Bureau dans plusieurs instances applicatives. Cliquez sur Continuer pour continuer à utiliser le Bureau dans cette instance applicative. Sinon, fermez cette fenêtre.',
    continue: 'Continuer'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Le transfert vers le point d\'entrée/la file d\'attente a échoué en raison d\'une erreur de configuration.',
    1010: "Consultation impossible, car l\'agent n\'a pas pu être affecté à temps. ",
    1042: "Le contact est introuvable",
    1043: 'La destination est non valide.',
    1045: 'L\'interaction n\'est pas attribuée à l\'agent.',
    1046: 'La consultation de l\'agent a échoué, car aucun canal d\'agent correspondant n\'a été trouvé dans le système.',
    1038: "Agent introuvable",
    1037: 'La connexion a échoué en raison d\'une erreur interne.',

    // Media Events
    138: 'L\'action a échoué pour des raisons inconnues.',
    136: 'Utilisateur introuvable',

    // AgentConsultFailed
    1050: 'Consultation impossible en raison d\'une configuration ou d\'une activité non prise en charge dans le flux. ',
    1005: "Consultation impossible, car l\'agent n\'a pas répondu à la demande dans les délais.",
    1051: 'Consultation ou transfert impossible en raison d\'un point d\'entrée ou d\'un numéro non valide.',

    // AgentInviteFailed
    1053: 'Impossible de présenter l\'interaction en raison d\'une tâche de replacement en file d\'attente du flow en cours.',
    1054: 'Impossible de passer un appel vers l\'extérieur en raison de problèmes de médias liés à cette demande. ',

    // AgentContactAssignFailed
    1011: 'Impossible de répondre ou d\'accepter l\'appel, car il manque des agents dans l\'interaction en cours. ',

    // ContactCallbackFailed
    1034: 'Le rappel du contact a échoué, car la valeur ContactParkTimeout a été reçue pour la demande.',

    // ContactUpdateFailed
    1020: "Impossible de mettre à jour les variables, car l\'une des valeurs dépasse la limite de 256 caractères. Réduisez le nombre de caractères et réessayez.",

    // AgentInviteFailed
    1031: 'L\'agent a invité le client après avoir demandé le rappel.',

    // AgentBlindTransferFailedEvent
    1044: 'Le transfert sans suivi de l\'agent a échoué, car l\'agent destinataire est affecté à une autre interaction.',

    // AgentCtqCancelFailed
    1047: "Le contact est introuvable.",

    // AgentCtqFailed
    1048: "Le groupe de distribution des appels n\'est pas configuré.",
    1049: 'Le temps d\'attente maximum dans la file d\'attente est dépassé.',
    // StationLoginFailed
    127: 'L\'enregistrement du DN de l\'agent a échoué en raison d\'une exception de duplication de connexion.'
  },

  stateSelector: {
    Available: 'Disponible',
    errorstatechange: 'Le changement d\'état a échoué. Réessayez.',
    errorStateChangeInPendingLogout: 'Échec du changement d\'état de l\'agent en raison d\'une déconnexion en cours.',
    label: 'État de disponibilité',
    agentStateSelector: 'Sélecteur d\'état de l\'agent',
    Engaged: 'Engagé',
    engagedAvailableInfo:
      'Vous êtes actuellement engagé dans une interaction et vous êtes dans l\'état Disponible.',
    engagedIdleInfo:
      'Vous êtes actuellement engagé dans une interaction et vous êtes dans l\'état Inactif.',
    engagedInfo: 'Vous êtes actuellement engagé dans une interaction.',
    engagedSupervisorStateChange: 'a changé votre état en',
    axAgentStateChanged: 'Votre état a changé en',
    axAgentSync: 'en raison de l\'état de synchronisation avec votre outil de collaboration.',
    engagedPresenceInfo:
      'Vous êtes actuellement engagé dans une interaction et votre état est',
    engagedPresenceSync: 'en raison de l\'état de synchronisation avec votre outil de collaboration.',
    clear: 'Effacer la saisie',
    searchState: 'entrée',
    agentStatusLabel: 'Statut de l\'agent',
    agentStateLabel: 'L\'agent est dans l\'état {selectedState} depuis le dernier {selectedTimeValue}',
    agentStateLabelOnStateChange: 'L\'agent est dans l\'état {selectedState} depuis la dernière 0 sec',
    agentStateChangeSuccessful:'Changement d\'état vers {selectedState} réussi.',
    agentStateChangeFail:'Le changement d\'état vers {selectedState} a échoué.',
    searchError: 'Saisissez un minimum de trois caractères pour rechercher des états.'
  },

  warningMessage: {
    header: 'Modifications non enregistrées',
    message:
      'Vous avez des modifications non sauvegardées sur cette page. Êtes-vous sûr de vouloir quitter cette page ? ',
    cancelButton: 'Demeurer',
    saveButton: 'Quitter'
  },

  notificationLables: {
    muteVolume: 'Couper le son du volume des notifications',
    unmuteVolume: 'Rétablir le son du volume de notification',
    notificationVolume: 'Volume des notifications',
    playSound: 'Jouer le son de la notification',
    enableSoundNotificationSettings: 'Activer les notifications sonores',
    enableSoundNotificationSettingsDescription:
      'Émettre des notifications sonores pour les demandes entrantes. Vous pouvez régler le volume ci-dessous.',
    volumeTitle: 'Volume sonore'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Appel',
    chat: 'Chat',
    email: 'E-mail',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Messages commerciaux de Google"
  },
  orgDetailsLabels: {
    role: 'Rôle',
    department: 'Département',
    email: 'E-Mail',
    businessPhone: 'Téléphone professionnel',
    workPhone: 'Travail',
  },
  addressListError: {
    title: 'Échec du chargement des données',
    errorId: 'ID d\'erreur :'
  },
  keypad: {
    keyPadSearch: 'Saisir le numéro',
    dialPad: 'Clavier de numérotation'
  },
  collabTool: {
    userAuthenticated: 'Authentification de l\'utilisateur :',
    successful: 'Réussite',
    failed: 'Échec.',
    tryAgain: 'Veuillez réessayer',
    stateSync: 'État de la synchronisation :',
    mercuryFailedInfo: ' Contactez votre administrateur.',
    retrying: 'Tentative en cours...',
    trackingIdLabel: 'ID de suivi : '
  },
  webex: {
    webex: 'Webex',
    info: 'L\'intégration vous permet de synchroniser les états entre Desktop et Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Cette intégration vous permet de consulter ou de transférer des appels aux utilisateurs de Microsoft Teams.',
    authenticationFailedInfo:
      'Si une fenêtre d\'authentification est déjà ouverte, tentez à nouveau l\'authentification à cet endroit.',
    ListItemContactDetails:
      'Le nom du contact est : {name}, sa présence est : {presence}, le département est : {department}, le titre du poste est : {jobTitle} et le numéro de téléphone est : {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Notification des services d\'urgence',
    readNotification: 'J\'ai lu la notification.'
  },
  webexPresenceStatus: {
    active: 'Actif',
    lastActiveFewMinutesAgo: 'Actif au cours des dernières minutes',
    lastActiveMinutesAgo: 'Actif il y a {min} minutes',
    lastActive1HourAgo: 'Dernière activité il y a 1 heure',
    lastActiveHoursAgo: 'Actif il y a {hour} heures',
    lastActiveYesterday: 'Actif hier',
    lastActiveOnDate: 'Actif le {date}',
    busy: 'Occupé',
    busyUntil: 'Occupé jusqu\'à {date}',
    dnd: 'Pas déranger',
    dndUntil: 'Ne pas déranger jusqu\'à {date}',
    quiet: 'Silence',
    quietUntil: 'Silence jusqu\'à {date}',
    ooo: 'Absent du bureau',
    outOfOfficeUntil: 'Absent du bureau jusqu\'au {date}',
    call: 'Au téléphone',
    meeting: 'En réunion',
    calendarItem: 'En réunion de calendrier',
    presenting: 'En présentation',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Recherche par nom ou détails du profil',
    webexPlaceholder: 'Recherche par nom ou email',
    refreshTheList: 'Actualiser la liste',
    refreshAddressBook: 'Actualiser le carnet d\'adresses',
    microsoftAuthError: 'Aucun contact à afficher. L\'authentification Microsoft a échoué.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/hr.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/hr.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Učitavanje podataka nije uspjelo',
    errorID: 'ID pogreške',
    tryAgain: 'Pokušajte ponovno',
    Error: 'Pogreška',
    okButton: 'U REDU',
    Yes: 'Da',
    Cancel: 'Poništi',
    Confirm: 'Potvrdi',
    Continue: 'Nastavi',
    Canceling: 'Odustajanje',
    CiscoAiAssistant: 'Cisco AI pomoćnik',
    Answer: 'Odgovori',
    AnswerAriaLabel: 'Odgovor na zadatak radne površine',
    Decline: 'Odbij',
    ErrorSecurityCompliance: 'Sigurnosna sukladnost',
    errorDetails: 'Pojedinosti o pogreški',
    learnMore: 'Saznajte više',
    showLess: 'Prikazuj manje',
    trackingIdDescription:
      'Podijelite ID praćenja sa administratorom stranice ili timom podrške kako biste istražili situaciju.',
    trackingIdInputLabel: 'ID za praćenje: ',
    submitForm: 'Pošaljite obrazac',
    unnamedStatus: 'Neimenovani status',
    errorChatMsg: 'Učitavanje podataka razgovora nije uspjelo',
    noOptions: 'Nema opcija',
    noResults: 'Nema rezultata',
    more: 'Više',
    nomatchfound: 'Nema podudarnih rezultata',
    collaborationTool: 'Alat za suradnju',
    timerAriaLabel: 'Utrošeno vrijeme',
    historyItemTime: 'Dogodilo se na',
    loading: 'Učitavanje',
    months: [
      'Siječanj',
      'Veljača',
      'Ožujak',
      'Travanj',
      'svibanj',
      'Lipanj',
      'Srpanj',
      'Kolovoz',
      'Rujan',
      'Listopad',
      'Studeni',
      'Prosinac'
    ],
    loadingMsg: 'Učitavanje...',
    search: 'Pretraži',
    historyChannelLabels: {
      All: 'Svi',
      telephony: 'Glasovni',
      chat: 'Razgovor',
      email: 'E-pošta',
      social: 'Društveno'
    },
    homePageLabel: 'Početna stranica',
    resizeHistoryDragger: 'Promjena veličine alata za povlačenje povijesti',
    agentHistoryLabel: 'povijest agenta',
    clear: 'Brisanje unosa',
    ariaLabelAgentHistoryWrapper:
      'Povijest interakcije s agentom prikazuje vašu nedavnu komunikaciju s klijentima na različitim kanalima u protekla 24 sata',
    sliderResizerInstructions:
      'Trenutno ste na klizaču. Za promjenu veličine koristite tipke sa strelicama',
    resizeHistoryPanel: 'Promjena veličine odjeljka povijesti, klizača,',
    time: {
      hours: 'sat',
      minutes: 'minuta',
      seconds: 's'
    }
  },
  email: {
    ToLabel: 'Za',
    FromLabel: 'Od',
    CcLabel: 'Kopija',
    BccLabel: 'Skrivena kopija',
    SubjectLabel: 'Tema',
    HideLabel: 'Sakrij',
    SendLabel: 'Pošalji',
    ShowPrevThread: 'Prikaži prethodnu nit',
    HidePrevThread: 'Sakrij prethodnu nit',
    ReplyLabel: 'Odgovor',
    ReplyAllLabel: 'Odgovori svima',
    ViewOriginalMail: 'Prikaz izvorne e-pošte',
    QuickReplyInp: 'Brzi odgovor ovdje...',
    AttachFiles: 'Priloži datoteke',
    ToolbarHeading: 'Zaglavlje1',
    ToolbarBold: 'Podebljano',
    ToolbarItalic: 'Kurziv',
    ToolbarUnderLine: 'Podcrtano',
    ToolbarBlockQuote: 'Blokiranje navoda',
    ToolbarCode: 'Blokiranje koda',
    ToolbarListOrder: 'Izlistaj prema narudžbi',
    ToolbarListBullet: 'Izlistaj u natuknicama',
    ToolbarLink: 'Veza',
    ToolbarStrike: 'Prekriženo',
    ToolbarColor: 'Boja teksta',
    ToolbarTable: 'Tablica',
    insertTable: 'Unesi tablicu',
    insertRowAbove: 'Umetanje retka iznad',
    insertRowBelow: 'Umetanje retka ispod',
    insertColumnLeft: 'Umetanje stupca lijevo',
    insertColumnRight: 'Umetanje stupca desno',
    deleteRow: 'Brisanje retka',
    deleteColumn: 'Brisanje stupca',
    deleteTable: 'Brisanje tablice',
    link: 'Veza',
    IndentRight: 'Uvuci desno',
    IndentLeft: 'Uvuci lijevo',
    showMoreAttachment: 'Prikaži više privitaka',
    AttachmentLimit: 'Priloži najviše ',
    attachments: ' privitaka, ',
    sizeLimit: ' najviše MB',
    attachment: 'Privitak',
    errordeleteattachment: 'Datoteke nije moguće izbrisati. Pokušajte ponovno.',
    errordownloadattachment: 'Datoteke nije moguće preuzeti. Pokušajte ponovno.',
    erroraddattachemnt: 'Slanje datoteke nije uspjelo. Pokušajte ponovno.',
    errorendcontact: 'Prekidanje interakcije nije uspjelo. Pokušajte ponovno.',
    erroraddlimitreached:
      'Datoteku nismo mogli dodati kao privitak jer prelazi maksimum ',
    errorattachmentdrop:
      'Privitci su ispušteni zbog sigurnosnih pravila tvrtke.',
    errorfiletype: 'Vrsta datoteke nije podržana. Pokušajte ponovno.',
    errorcreditcard:
      'Privitak nije poslan zbog sigurnosnih pravila tvrtke.',
    errorcontainsimage:
      'Privici se ne mogu poslati. Slike u privitku nisu podržane zbog sigurnosnih pravila tvrtke.',
    errorlimit: ' MB ograničenje.',
    errorsendemail: 'Nije moguće poslati poruku e-pošte. Pokušajte ponovno.',
    errorpcicheckemail: 'Ne možemo povratiti PCI podatke. Pokušajte ponovno.',
    errortext: 'Učitavanje podataka nije uspjelo',
    tryAgain: 'Pokušajte ponovno',
    replywarning:
      'Ne dijelite financijske, zdravstvene ili osobne informacije u ovoj poruci ili privitcima.',
    datamasked:
      'Ovaj predmet ili sadržaj e-pošte sadrži prekrivene dijelove zbog sigurnosnih pravila tvrtke. Jeste li sigurni da ga želite poslati?',
    pcibannerwarning:
      'Ovaj predmet e-pošte sadrži prekrivene dijelove zbog sigurnosnih pravila tvrtke.',
    on: 'Uključi',
    wrote: 'napisano'
  },
  interaction_control: {
    windowOpened: 'Prozor je otvoren',
    connected: 'Povezano',
    consultRequested: 'Zahtjev za konzultiranje',
    consulting: 'Konzultiranje',
    consultCallOnHold: 'Konzultacija na čekanju',
    callOnHold: 'Poziv na čekanju',
    consult: 'Konzultiraj',
    endconsult: 'Završi konzultaciju',
    hold: 'Na čekanju',
    transfer: 'Prenesi',
    conference: 'Konferencija',
    endconference: 'kraj konferencije',
    conferenceRequested: 'Zahtjev za konferenciju',
    switchCall: 'Prebaci',
    mergeCall: 'Spoji',
    wrapup: 'Rekapitulacija',
    end: 'Kraj',
    customername: 'Ime klijenta',
    dn: 'DNIS',
    ivrpath: 'IVR niz',
    email: 'E-pošta kupca',
    ani: 'Telefonski broj',
    queueid: 'Naziv reda čekanja',
    ronatimeout: 'Rona vrijeme',
    pathid: 'ID IVR niza',
    dnis: 'DNIS',
    destagentphonenumber: 'DN agenta',
    destagentname: 'Ime agenta',
    virtualteamname: 'Red čekanja',
    category: 'Kategorija',
    additionaldetails: 'Dodatne pojedinosti',
    sourcenumber: 'Broj izvora',
    sourcepage: 'Izvorna stranica',
    appuser: 'Korisnički ID aplikacije',
    customernumber: 'Telefonski broj',
    exitconference: 'Izlaz iz konferencije',
    resume: 'Nastavi',
    pauserecording: 'Pauziraj snimanje',
    resumerecording: 'Nastavi snimanje',
    exitconsult: 'Izlaz iz konzultacije',
    pauseRecordingFailed: 'Ne možemo pauzirati snimanje. Pokušajte ponovno.',
    resumeRecordingFailed: 'Ne možemo nastaviti snimanje. Pokušajte ponovno.',
    holdCallFailed: 'Ne možemo staviti poziv na čekanje. Pokušajte ponovno.',
    resumeCallFailed: 'Ne možemo nastaviti poziv. Pokušajte ponovno.',
    endCallFailed: 'Prekidanje interakcije nije uspjelo. Pokušajte ponovno.',
    consultTransferFailed:
      'Ne možemo prenijeti poziv za konzultaciju. Pokušajte ponovno.',
    conferenceTransferFailed:
      'Ne možemo prenijeti konferencijski poziv. Pokušajte ponovno.',
    conferenceFailed:
      'Ne možemo spojiti zahtjev za konferenciju. Pokušajte ponovno.',
    consultEndFailed: 'Ne možemo završiti zahtjev za konzultaciju. Pokušajte ponovno.',
    conferenceExitFailed:
      'Nije moguće izići iz zahtjeva za konferenciju. Pokušajte ponovno.',
    conferenceEndFailed:
      'Ne možemo završiti zahtjev za konferenciju. Pokušajte ponovno.',
    cancelCtqFailed:
      'Ne možemo otkazati poziv za konzultaciju iz reda čekanja. Pokušajte ponovno.',
    privacyShield: 'Zaštita privatnosti',
    errorOnPrvacyShieldForConsult:
      'Snimanje je trenutno pauzirano. Nastavite snimanje za početak konzultacije.',
    errorOnPrvacyShieldForTransfer:
      'Snimanje je trenutno pauzirano. Nastavite snimanje za početak prijenosa poziva.',
    cancelConsult: 'Otkaži konzultaciju',
    cancelTransfer: 'Otkaži prijenos',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    cadrequestuccess: 'Korisničke informacije uspješno su spremljene.',
    cadrequestfailure: 'Korisničke informacije nisu spremljene. Pokušajte kasnije.',
    cadupdatedmessage: 'Korisničke informacije nedavno su ažurirane',
    unsavedmessage: 'Nesačuvane promjene su prepisane.',
    save: 'Spremi',
    revert: 'Povrat',
    expandDetails: 'Proširi pojedinosti',
    collapseDetails: 'Sažmi pojedinosti',
    cadValidationError:
      'Format nije valjan. Upotrebljavajte međunarodni standard za datum i vrijeme.',
    secureCadSaveError:
      'Podaci o kupcu nisu spremljeni. Kliknite Spremi kako biste pokušali ponovno.',
    secureDecryptionError: 'Sigurne varijable ne mogu se prikazati.',
    clickToTry: 'Kliknite za ponovni pokušaj',
    isSecureVariable: 'je sigurna varijabla',
    contactorigin: 'Izvor kontakta',
    resumeMonitoring: 'Nastavi nadzor',
    pauseMonitoring: 'Pauziraj nadzor',
    whisperCoach: 'Trener-šaptač',
    bargeIn: 'Upadanje',
    endMonitoring: 'Završi nadzor',
    contactphonenumber: 'Telefonski broj kontakta',
    contactqueue: 'Red čekanja za kontakt',
    activeparticipants: 'Aktivni sudionici',
    consultedparticipant: 'Konzultirani sudionik',
    contactstatus: 'Status kontakta',
    timeincontactstatus: 'Vrijeme u statusu kontakta',
    totalcontactduration: 'Ukupno trajanje kontakta',
    agentinteractiontime: 'Trajanje interakcije',
    recording: 'Snimanje',
    monitoring: 'Nadzor',
    monitoringPaused: 'Nadzor pauziran',
    pauseMonitoringFailed: 'Nadzor nije moguće pauzirati. Pokušajte ponovno.',
    resumeMonitoringFailed: 'Nadzor nije moguće nastaviti. Pokušajte ponovno.',
    callCancelledInProgress: 'U tijeku je odustajanje od poziva',
    bargedIn: 'Upadanje',
    keypad: 'Tipkovnica',
    mute: 'Isključi zvuk',
    unmute: 'Uključi zvuk',
    bargeInTooltipText:
      'Mikrofon će se uključiti i pridružit ćete se ovoj interakciji s kupcem',
    bargeInCompactTooltipText:
      'Upad. Mikrofon će se uključiti i pridružit ćete se ovoj interakciji s kupcem',
    bargeInTooltipDisabled: 'Nastavite praćenje kako bi se omogućio upad',
    bargeInFailedTitle: 'Upad nije uspio',
    bargeInFailedData:
      'Došlo je do pogreške dok ste pokušavali upasti. Pokušajte ponovno nakon nekog vremena.',
    supervisorBargedIn: 'upao/la je u vaš poziv.',
    leftInteraction: 'napustio/la je interakciju.',
    conferenceEnded: 'Konferencijski poziv je završio.',
    participants: 'Sudionik',
    badgeAriaLabel: '{participant} je u pozivu',
    bargeInConferenceAriaLabel: 'Postoje dva sudionika u interakciji',
    taskName: 'Naziv zadatka kontrole interakcije',
    interactionDurationLabel: 'Vremensko trajanje',
    wrapupassist: 'Pomoć pri rekapitulaciji',
    consultingTaskContext: 'Konzultantski poziv od',
    consultExited: 'Konzultantski poziv je napušten',
    endCall: 'Završite poziv.',
    exitconferenceCall:
      'Izađite iz poziva i konferencija se nastavlja s aktivnim sudionicima.',
    recordingInProgess: 'Snimanje je u tijeku',
    recordingPaused: 'Snimanje je pauzirano',
    searchPlaceholder: 'Pretraživanje kontakata',
    postCall: "Poslije poziva",
    switchCallTooltip: "Prebacivanje na poziv",
    switchConsultTooltip: "Prebacivanje na konzultacijski poziv",
    switchConferenceTooltip: "Prebacivanje na konferencijski poziv",
    confirmationDialog: {
      endCallTitle: 'Želite li prekinuti poziv?',
      endCallMessage: 'Kliknite Potvrdi da biste prekinuli poziv za sve sudionike.',
      exitConferenceTitle: 'Želite li izići iz konferencijskog poziva?',
      exitConferenceMessage:
        'Kliknite Potvrdi da biste izašli iz konferencijskog poziva i dopustili ostalim sudionicima da nastave.',
      confirmButtonLabel: "Potvrdi",
      cancelButtonLabel: "Poništi",  
    },
    postCallOnHold: "Poslije poziva na čekanju",
    postCallConsult: "Poslije konzultacijskog poziva",
    postCallConsultOnHold: "Poslije konzultacijskog poziva na čekanju",
  },
  agentProfile: {
    teamName: 'Tim',
    dialNumber: 'Broj za biranje',
    phoneNumber: 'Telefonski broj',
    settings: 'Promjena postavki',
    signOut: 'Odjava',
    webRTCDisconnected: 'Upozorenje – računalna telefonija je prekinuta ',
    msAuthFailed: 'Microsoftova provjera autentičnosti nije uspjela',
    stateSyncFailed: 'Sinkronizacija stanja nije uspjela',
    userProfileLabel: 'Korisnički profil',
    ariaAgentprofile: 'Profil agenta',
    ChannelCapacity: 'Kapacitet kanala',
    voice: 'Glasovni',
    chat: 'Razgovor',
    email: 'E-pošta',
    social: 'Društveno',
    channelCapacityTooltip: 'Klikni za više',
    blendedRouting: 'Stopljeno',
    exclusiveRouting: 'Ekskluzivno usmjeravanje',
    realtimeRouting: 'Stopljeno stvarno vrijeme usmjeravanja',
    blendedRoutingTooltip: 'Upravljajte višestrukim kontaktima na svim kanalima.',
    exclusiveRoutingTooltip: 'U jednom trenutku možete premjestiti samo jedan kontakt.',
    realtimeRoutingTooltip: 'Upravljajte jednim obaveznim kanalom u stvarnom vremenu.',
    errorActiveContacts:
      'Ne možete se odjaviti jer imate aktivne razgovore. Završite ih i pokušajte ponovno.',
    searchTeams: 'Pretraživanje timova',
    changeTeamsConfirmHeader: 'Potvrda promjene tima',
    changeTeamsConfirmMessage: 'Jeste li sigurni da želite promijeniti tim?',
    changeTeamLabel: 'Promjena tima',
    errorChangeTeams:
      'Trenutno ne možete promijeniti tim jer imate aktivne zahtjeve. Dovršite ih i pokušajte ponovno.',
    saveTeamSelection: 'Sačuvajte izbor tima',
    userSettings: 'Postavke korisnika',
    resetLayout: 'Resetirajte prikaz cijele radne površine',
    resetConfirmHeader: 'Resetiranje potvrde prikaza',
    resetConfirmMessage:
      'Jeste li sigurni da želite resetirati izgled cijele radne površine? <br/> Radna površina vratit će se na zadani prikaz.',
    downloadLogs: 'Preuzmi izvješće o pogreški',
    help: 'Pomoć',
    signoutConfirm: 'Jeste li sigurni da se želite odjaviti?',
    signoutConfirmHeader: 'Potvrda odjave',
    darkTheme: 'Prebacivanje na tamni način',
    newLook: 'Promijeni na novi izgled',
    keyboardShortcuts: 'Prečice tipkovnice',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Postavke obavijesti',
    silentNotification: 'Tiha obavijest',
    enableNotificationSettings: 'Omogući obavijesti',
    enableSilentNotificationSettings: 'Omogućavanje tihih obavijesti',
    suppressWebexCallingNotificationSettings: 'Sakrij obavijesti za Webex Calling',
    notificationSettingDescription:
      'Dostavlja obavijesti kao što su nove poruke, upozorenja i promjene statusa.',
    silentNotificationDescription:
      'Isključuje upozorenja na zaslonu. Obavijesti možete pregledavati u centru za obavijesti.',
    suppressWebexCallingNotificationDescription: 
    'Ne prikazuj skočne obavijesti za dolazne Webex pozive i odgovori na njih putem centra Webex Contact Center.',
    arrowLabel: 'Vrati se natrag',
    managedTeams: 'Upravljani timovi',
    managedTeamsError: 'Učitavanje timova nije uspjelo.',
    viewAll: 'Prikaži sve',
    profileSettings: 'Postavke profila',
    userRole: 'Uloga',
    saveSelection: 'Sačuvajte izbor',
    extension: 'Kućni broj',
    changeProfileConfirmHeader: 'Potvrdite promjene postavki profila',
    changeProfileConfirmMessage:
      'Jeste li sigurni da želite spremiti promjene na profilu?',
    confirm: 'Potvrdi',
    errorProfileUpdate:
      'Trenutno ne možete promijeniti postavke profila jer imate aktivne zahtjeve. Dovršite ih i pokušajte ponovno.',
    roleAgentSupervisor: 'Nadzornik i agent',
    roleSupervisor: 'Nadzornik',
    noTeam: 'Nema tima',
    testYourNetwork: 'Testirajte svoju mrežu',
    speakerAndMic: 'Zvučnik i mikrofon',
    speaker: 'Zvučnik',
    mic: 'Mikrofon',
    speakerDescription:
      'Odaberite i testirajte izlazni uređaj kako biste bili sigurni da ćete čuti pozivatelja.',
    micDescription:
      'Odaberite i testirajte ulazni uređaj kako biste bili sigurni da će vas pozivatelj čuti.',
    micError:
      'Pristup mikrofonu je odbijen. Omogućite pristup putem postavki preglednika ili se obratite administratoru.',
    speakerError:
      'Zvučnik trenutačno nije dostupan jer je pristup mikrofonu odbijen.',
    telephony: 'Telefonija',
    desktop: 'Radna površina',
    onSpeakerPlay:
      'Ako ne možete čuti testni zvuk, provjerite zvučnik uređaja.',
    onMicPlay:
      'Ako ne možete čuti testni zvuk, provjerite oba zvučnika i mikrofon.',
    onMicRecord: 'Snimite poruku za reprodukciju.',
    test: 'Test',
    recording: 'Snimanje',
    playing: 'Reproduciranje',
    reconnecting: 'Ponovna uspostava veze',
    disconnectMessage:
      'Računalna telefonija je prekinuta. Isprobajte drugu mogućnost telefonije.',
    singleTelephonyDisconnectMessage:
      'Računalna telefonija je prekinuta. Obratite se svom administratoru.',
    clear: 'Brisanje unosa',
    rememberMeCheckBoxMessage: "Ne prikazuj ovo ponovo",
    saveLabel: 'Spremi',
    browserUnsupportedError: "Prijava nije uspjela jer upotrebljavate nepodržan preglednik.",
    microphoneAccessDeniedError: "Pristup mikrofonu je odbijen. Omogućite pristup putem postavki preglednika ili se obratite administratoru.",
  },
  contactHistory: {
    mainHeader: 'Povijest kontakta',
    handledBy: 'Upravljao',
    noRecordFound: 'Povijest kontakta nije pronađena!',
    tryAgain: 'Pokušajte ponovno',
    errorMsg: 'Neuspješno učitavanje podataka o povijesti kontakta. Pokušajte ponovno.',
    errorID: 'ID pogreške',
    missingAni: 'ANI nedostaje',
    timeIcon: 'Trajanje',
    taskHandled: 'Upravljani zadatak',
    noHistoryNew: 'Nema povijesti',
    noHistory: 'Nema povijesti',
    viewTranscript: 'Pogledaj poruku e-pošte',
    transcriptFor: 'Prijepisi za',
    editBeforeCall: 'Uređivanje prije poziva',
    clickToCall: 'Kliknite za pozivanje',
    onAnActiveCallErrorMessage:
      'Ne možete pokrenuti novi poziv jer ste već na aktivnom pozivu.',
    receivedFrom: 'Kontakt primljen od',
    initiatedTo: 'Kontakt pokrenut do',
    wrapUpReason: 'Razlog za rekapitulaciju',
    startCallTelephony:
      'Da biste pokrenuli odlazni poziv, kliknite vezu na broj telefona.',
    contactHistoryList: 'Popis povijesti kontakta,',
    wrapUpCode: 'Kod rekapitulacije',
    agentName: 'Naziv agenta',
    entryPointName: 'Ulazna točka',
    acceptedTimeAndDate: 'Prihvaćeno vrijeme i datum',
    duration: 'Trajanje',
    emailTranscript: 'Transkript e-pošte',
    clickToViewEmailTranscript: 'Kliknite da biste pogledali prijepis e-pošte',
    listContainer: 'Spremnik popisa'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Ulazna točka',
    date: 'Datum',
    subject: 'Tema',
    from: 'Od',
    sent: 'Poslano',
    to: 'Za',
    back: 'Natrag',
    errorTranscript: 'Prilikom dohvaćanja prijepisa došlo je do pogreške',
    customer: 'Klijent',
    inboundErrorMessage: 'Učitavanje e-pošte korisnika nije uspjelo',
    outboundErrorMessage: 'Učitavanje agentova odgovora nije uspjelo'
  },
  popoverTitle: {
    callback: 'Povratni poziv',
    outboundCall: 'Odlazni poziv',
    incomingCall: 'Dolazni poziv',
    progressiveCampaign: 'Poziv kampanje',
    courtesyCallback: 'Uslužni povratni poziv',
    chat: 'Dolazni chat',
    incoming: 'Dolazno',
    monitoringCall: 'Poziv nadzora'
  },
  connecting: 'Povezivanje',
  initiating: 'Pokretanje',
  outbound: 'Izlazni',
  transfer: {
    title: 'Zahtjev za prijenos',
    heading: {
      chat: 'Odaberite agenta ili red u koji se želite prenijeti.',
      email: 'Odaberite red u koji se želite prenijeti.',
      telephony:
        'Odaberite agenta, red ili broj za biranje na koji se želite prenijeti.',
      noQueueTelephony:
        'Odaberite agenta ili broj za biranje na koji se želite prenijeti.'
    },
    header: {
      chat: 'Odaberite agenta ili određeni red čekanja za prijenos ovog kontakta.',
      email: 'Odaberite red čekanja za prijenos ovog kontakta.',
      telephony:
        'Odaberite agenta, određeni red čekanja, broj za biranje ili organizaciju za prijenos ovog kontakta.',
      noQueueTelephony:
        'Odaberite agenta, broj za biranje ili organizaciju za prijenos ovog kontakta.',
      noOrganizationTelephony:
        'Odaberite agenta, određeni red čekanja ili broj za biranje za prijenos ovog kontakta.',
      noQueueOrganizationTelephony:
        'Odaberite agenta ili broj za biranje za prijenos ovog kontakta.'
    },
    queues: 'Red čekanja',
    agents: 'Agent',
    dialNumber: 'Broj za biranje',
    organization: 'Organizacija',
    placeholder: {
      Queues: 'Odaberite s popisa redova čekanja',
      Agents: 'Odaberite s popisa agenata',
      DialNumber: 'Odabir prema imenu ili broju',
      DialNumberOrEntryPoint: 'Odabir prema imenu/broju / ulaznoj točki',
      ChooseByNameOrNumber: 'Odabir prema imenu/broju',
      Organization: 'Pretraživanje po imenu/ulozi/odjelu/poslovnom telefonu',
      WebexOrganization: 'Pretraživanje po imenu ili e-pošti',
      DialNumberSearch: 'Pretraživanje po imenu ili broju'
    },
    type: 'Prenesi',
    cancel: 'Poništi',
    closeModal: 'Zatvaranje modula',
    failureError: 'Pokretanje zahtjeva za prijenos nije uspjelo. Pokušajte ponovno.',
    entryPoint: 'Ulazna točka'
  },
  consult: {
    title: 'Zahtjev za konzultiranje',
    heading: {
      chat: 'Odaberite agenta ili red u koji se želite prenijeti.',
      email: 'Odaberite red u koji se želite prenijeti.',
      telephony:
        'Odaberite agenta, red ili broj za biranje s kojim se želite konzultirati.',
      noQueueTelephony:
        'Odaberite agenta ili broj za biranje s kojim se želite konzultirati.'
    },
    header: {
      chat: 'Odaberite agenta ili određeni red čekanja za prijenos ovog kontakta.',
      email: 'Odaberite red čekanja za prijenos ovog kontakta.',
      telephony:
        'Odaberite agenta, red čekanja ili broj za biranje ili organizaciju s kojom se želite konzultirati.',
      noQueueTelephony:
        'Odaberite agenta, red čekanja ili organizaciju s kojom se želite konzultirati.',
      noOrganizationTelephony:
        'Odaberite agenta, red čekanja ili broj za biranje s kojim se želite konzultirati.',
      noQueueOrganizationTelephony:
        'Odaberite agenta ili broj za biranje s kojim se želite konzultirati.'
    },
    queues: 'Red čekanja',
    agents: 'Agent',
    dialNumber: 'Broj za biranje',
    organization: 'Organizacija',
    placeholder: {
      Queues: 'Odaberite s popisa redova čekanja',
      Agents: 'Odaberite s popisa agenata',
      DialNumber: 'Odabir prema imenu ili broju',
      DialNumberOrEntryPoint: 'Odabir prema imenu/broju / ulaznoj točki',
      ChooseByNameOrNumber: 'Odabir prema imenu/broju',
      Organization: 'Pretraživanje po imenu/ulozi/odjelu/poslovnom telefonu',
      WebexOrganization: 'Pretraživanje po imenu ili e-pošti',
      DialNumberSearch: 'Pretraživanje po imenu ili broju'
    },
    type: 'Konzultiraj',
    checkBoxLabel: 'Dopustite sudionicima nastavak interakcije.',
    cancel: 'Poništi',
    closeModal: 'Zatvaranje modula',
    failureError: 'Ne možemo spojiti zahtjev za konzultaciju. Pokušajte ponovno.',
    customerLeftMsg: 'Klijent je prekinuo vezu. Konzultacije više nisu potrebne.',
    ctqFailureMsg:
      'Ne možemo otkazati poziv za konzultaciju iz reda čekanja. Pokušajte ponovno.',
    cancelCtqInfo:
      'Tražimo dostupnog agenta u odabranom redu čekanja. Pričekajte ili otkažite zahtjev za konzultaciju.',
    cancelCtqAction: 'Otkaži konzultaciju',
    entryPoint: 'Ulazna točka'
  },
  conference: {
    title: 'Zahtjev za konferenciju',
    heading: {
      chat: 'Odaberite određenog agenta za konferencijski razgovor'
    },
    queues: 'Red čekanja',
    agents: 'Agent',
    dialNumber: 'Broj za biranje',
    organization: 'Organizacija',
    placeholder: {
      Queues: 'Odaberite s popisa redova čekanja',
      Agents: 'Odaberite s popisa agenata',
      DialNumber: 'Odabir prema imenu ili broju'
    },
    type: 'Konferencija',
    cancel: 'Poništi',
    closeModal: 'Zatvaranje modula',
    failureError: 'Pokretanje zahtjeva za konferenciju nije moguće. Pokušajte ponovno.'
  },
  transferModal: {
    Agents: 'Neuspješno učitavanje popisa agenata. Osvježite popis.',
    AgentsEmpty: 'Nema dostupnih agenata',
    Queues: 'Neuspješno učitavanje popisa redova. Osvježite popis.',
    QueuesEmpty: 'Nema dostupnih redova čekanja',
    EPEmpty: 'Nema dostupne ulazne točke',
    DialNumber:
      'Neuspješno učitavanje popisa brojeva za biranje iz adresara. Osvježite popis.',
    EntryPoint:
      'Neuspješno učitavanje popisa brojeva ulaznih točaka. Osvježite popis.',
    Common: 'Neuspješno učitavanje popisa. Osvježite popis.',
    DialNumberEmpty: 'Nema dostupnih brojeva za biranje',
    DialNumbInvalid:
      'Pozivni broj nije valjan. Obratite se administratoru.',
    DialNumbOrEntryPointInvalid:
      'Broj za biranje / ulazna točka nije valjan/a. Obratite se administratoru.',
    refreshQueueList: 'Osvježite popis redova',
    refreshAgentList: 'Osvježite popis agenata',
    refreshEpList: 'Osvježi ulazne točke',
    refreshAddressBook: 'Osvježite adresar',
    refreshTheList: 'Osvježite popis',
    entryPointSectionLabel: 'Ulazna točka',
    addressBookSectionLabel: 'Adresar',
    organization: 'Organizacija',
    comboBoxAriaLabelAgent: 'Odaberite s popisa agenata',
    comboBoxAriaLabelQueue: 'Odaberite s popisa redova čekanja',
    comboBoxAriaLabelEp: 'Odaberi s popisa ulaznih točaka',
    infScrollAgent: 'Pretraživanje agenata',
    infScrollQueue: 'Pretraživanje redova čekanja',
    infScrollEP: 'Pretraživanje ulaznih točaka',
    allRadioButtonHidedTextForConsult: 'Nemate dodijeljenih entiteta za pregled ove interakcije. Obratite se administratoru.',
    allRadioButtonHidedTextForTransfer: 'Nemate dodijeljenih entiteta za prijenos ove interakcije. Obratite se administratoru.',
    allRadioButtonHidedTextForConference: 'Nemate dodijeljenih entiteta za konferenciju ove interakcije. Obratite se administratoru.',
    searchMinCharError: 'Unesite minimalno tri znaka za pretraživanje.',
  },
  wrapup: {
    cancelautowrapup: 'Otkaži auto. rekapitulaciju',
    wrapupreason: 'Razl. za rekap.',
    untilautowrapup: 'do automatske rekapitulacije',
    followupsetting: 'Postavljanje daljnjeg praćenja',
    lastagentroute: 'Posljednje usmjeravanje agenta',
    submitwrapup: 'Slanje rekapitulacije',
    wrapupsearch: 'Pretraživanje razloga rekapitulacije',
    invalidationError: 'Slanje rekapitulacije nije uspjelo',
    searchResult: 'Dostupni rezultati pretraživanja',
    noResultFound: 'Nema pronađenih rezultata pretraživanja',
    listContainerLabel: 'Spremnik zaključnog popisa',
    searchError: 'Unesite najmanje tri znaka za traženje razloga završavanja.',
  },

  outdial: {
    call: 'Pozovi',
    dialpadSearch: 'Unesite br. za bir.',
    addressSearch: 'Pretraživanje po imenu/broju',
    addressTab: 'Adresa',
    addressTabTooltip: 'Pretraživanje adresara',
    dialpadTab: 'Brojčanik',
    dialpadTooltip: 'Birajte broj',
    searchTab: 'Traži',
    searchTabTooltip:'Traži osobe u mojoj tvrtki ili ustanovi',
    noAdrFound: 'Nema podudarnih rezultata',
    noContacts: 'Nema kontakata',
    mainIconTooltip: 'Poziv sustava koji poziva broj',
    errorOutdialFailed:
      'Sustav koji poziva broj nije uspio. Radna površina nije se mogla povezati na poziv ili poziv nije odgovoren.',
    errorOutdialDisabled: 'Pozivi sustava koji poziva broj su onemogućeni',
    errorDialPadValidationMessage: 'Netočan format',
    outdialReqInProgress: 'Pozivi sustava koji poziva broj je u tijeku',
    outdialAniPlaceholder: 'Odaberite ANI sustava koji poziva broj',
    outdialAniLabel: 'ANI sustava koji poziva broj',
    outdialAniPlaceHolder: 'Traži ANI za sustav koji poziva broj',
    errorDcCallsLimitExceeded:
      'Podatkovni centar dosegao je maksimalno ograničenje sustava koji poziva broj. Nije moguće pozivanje broja',
    errorOrgCallsLimitExceeded:
      'Organizacija je dosegla maksimalno ograničenje sustava koji poziva broj. Nije moguće pozivanje broja.',
    errorOutDialNoAnswerFromCustomer:
      'Korisnik nije odgovorio na vaš poziv. Pokušajte zvati kasnije.',
    errorOutDialCustomerUnavailable:
      'Korisnik trenutačno nije dostupan. Pokušajte zvati kasnije.',
    errorOutDialAgentEnds: 'Završili ste poziv s korisnikom.',
    errorOutDialCustomerBusy: 'Kupac je trenutačno zauzet. Pokušajte zvati kasnije.',
    searchError: 'Za pretraživanje kontakata unesite minimalno tri znaka.',
    upArrowLabel: 'Proširi',
    clear: 'Brisanje unosa',
    outdialDialogDescription: 'Trenutačno ste u dijalogu s karticama.'
  },

  organization: {
    noMatchFound: 'Nema podudarnih rezultata',
    searchError: 'Za pretraživanje kontakata unesite minimalno tri znaka.',
    authError: 'Nema kontakata za prikaz. Microsoftova provjera autentičnosti nije uspjela.'
  },

  interactionPopover: {
    of: 'od',
    accept: 'Prihvati',
    acceptAriaLabel: 'Prihvati zadatak {taskNumber} – {taskType} od {from}',
    requests: 'Zahtjevi',
    back: 'natrag',
    next: 'sljedeće',
    acceptMultipleRequest: 'Prihvati ovoliko zahtjeva: {requestCount}',
    paginationDetail: '{indexStart} – {indexEnd} od {totalPopoverpoolLength}',
    hidePopoverDetails: 'sakrij iskočne pojedinosti',
    showPopoverDetails: 'prikaži iskočne pojedinosti',
    customerName: 'Ime klijenta',
    email: 'E-pošta',
    queueName: 'Naziv reda čekanja',
    failedToAccept: 'Prihvaćanje nije uspjelo.',
    unableToAccept: 'Prihvaćanje kontakta nije moguće.',
    failedToEnd: 'Završavanje nije uspjelo.',
    unableToEnd: 'Završavanje kontakta nije moguće. ',
    ringing: 'Zvoni',
    calling: 'Pozivanje',
    phoneNumber: 'Telefonski broj',
    dni: 'DNIS',
    ivrPathId: 'ID IVR niza',
    pathId: 'ID puta',
    rona: 'RONA',
    sourcePage: 'Izvorna stranica',
    sourceNumber: 'Broj izvora',
    appUserId: 'Korisnički ID aplikacije',
    acceptAll: 'Prihvati sve zadatke',
    agentDn: 'DN agenta',
    agentName: 'Naziv agenta',
    agentTeam: 'Tim agenta',
    requestDetails: 'Detalji zahtjeva',
    incomingCallFrom: 'Dolazni poziv od',
    unableToAnswer: 'Ne možemo odgovoriti na poziv. Pokušajte ponovno.',
    unableToDecline: 'Ne možemo odbiti poziv. Pokušajte ponovno.'
  },

  multiLogin: {
    header: 'Upozorenje za višestruku prijavu',
    message:
      'Prijavljeni ste u aplikaciju Desktop u više instanca aplikacije. Kliknite „Upotrebljavaj ovdje“ da biste je upotrebljavali u ovoj instanci aplikacije. U suprotnom, zatvorite prozor.',
    continue: 'Nastavi'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Prijenos na ulaznu točku / red čekanja nije uspio zbog pogreške u konfiguraciji.',
    1010: "Nije moguće obaviti konzultaciju jer agent nije mogao biti dodijeljen na vrijeme. ",
    1042: "Kontakt nije pronađen",
    1043: 'Odredište nije valjano.',
    1045: 'Interakcija nije dodijeljena agentu.',
    1046: 'Konzultacija s agentom nije uspjela jer u sustavu nije pronađen nijedan odgovarajući kanal za agenta.',
    1038: "Agent nije pronađen",
    1037: 'Prijava nije uspjela zbog interne pogreške.',

    // Media Events
    138: 'Radnja nije uspjela zbog nepoznatih razloga.',
    136: 'Korisnik nije pronađen',

    // AgentConsultFailed
    1050: 'Konzultacija nije moguća zbog nepodržane konfiguracije ili aktivnosti u tijeku. ',
    1005: "Konzultacija nije moguća jer agent nije odgovorio na zahtjev na vrijeme.",
    1051: 'Konzultacija ili prijenos nisu mogući zbog nevaljane ulazne točke ili broja za biranje.',

    // AgentInviteFailed
    1053: 'Nije moguće predstaviti interakciju zbog neriješenog zadatka iz reda čekanja u tijeku rada.',
    1054: 'Nije moguće postaviti da sustav poziva broj zbog problema koje s ovim zahtjevom imaju mediji. ',

    // AgentContactAssignFailed
    1011: 'Nije moguće odgovoriti ili prihvatiti poziv zbog nedostatka agenata u trenutačnoj interakciji. ',

    // ContactCallbackFailed
    1034: 'Povratni poziv kontaktu nije uspio jer je za zahtjev primljen ContactParkTimeout.',

    // ContactUpdateFailed
    1020: "Varijable se ne mogu ažurirati jer jedna od vrijednosti premašuje ograničenje od 256 znakova. Smanjite broj znakova i pokušajte ponovno.",

    // AgentInviteFailed
    1031: 'Agent je pozvao klijenta nakon što je zatražen povratni poziv.',

    // AgentBlindTransferFailedEvent
    1044: 'Slijepi prijenos agenta nije uspio jer je odredišni agent dodijeljen drugoj interakciji.',

    // AgentCtqCancelFailed
    1047: "Kontakt nije pronađen.",

    // AgentCtqFailed
    1048: "Skupina za raspodjelu poziva nije postavljena.",
    1049: 'Premašeno je maksimalno vrijeme čekanja u redu čekanja.',
    // StationLoginFailed
    127: 'Registracija DN-a agenta nije uspjela s dupliciranim izuzetkom prijave.'
  },

  stateSelector: {
    Available: 'Dostupno',
    errorstatechange: 'Promjena stanja nije uspjela. Pokušajte ponovno.',
    errorStateChangeInPendingLogout: 'Promjena stanja agenta nije uspjela zbog odjave na čekanju.',
    label: 'Stanje dostupnosti',
    agentStateSelector: 'Birač stanja agenta',
    Engaged: 'Zauzet',
    engagedAvailableInfo:
      'Trenutno ste zauzeti interakcijom i u dostupnom stanju.',
    engagedIdleInfo:
      'Trenutno ste uključeni u interakciju i u stanju mirovanja',
    engagedInfo: 'Trenutačno sudjelujete u interakciji.',
    engagedSupervisorStateChange: 'vaše stanje promijenjeno u',
    axAgentStateChanged: 'Vaše stanje promijenjeno je u',
    axAgentSync: 'zbog sinkronizacije stanja s vašim alatom za suradnju.',
    engagedPresenceInfo:
      'Trenutačno ste uključeni u interakciju i vaš je status',
    engagedPresenceSync: 'zbog sinkronizacije stanja s vašim alatom za suradnju.',
    clear: 'Brisanje unosa',
    searchState: 'unos',
    agentStatusLabel: 'Stanje agenta',
    agentStateLabel: 'Agent je u stanju {selectedState} za posljednji {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Agent je u stanju {selectedState} za posljednjih 0 s',
    agentStateChangeSuccessful:'Promjena stanja u {selectedState} je uspjela.',
    agentStateChangeFail:'Promjena statusa u {selectedState} nije uspjela.',
    searchError: 'Za pretraživanje država unesite minimalno tri znaka.'
  },

  warningMessage: {
    header: 'Nespremljene promjene',
    message:
      'Imate nespremljene promjene na ovoj stranici. Jeste li sigurni da je želite napustiti? ',
    cancelButton: 'Ostani',
    saveButton: 'Napusti'
  },

  notificationLables: {
    muteVolume: 'Stavi glasnoću obavijesti na nečujno',
    unmuteVolume: 'Uključi glasnoću obavijesti',
    notificationVolume: 'Glasnoća obavijesti',
    playSound: 'Reproduciraj zvuk obavijesti',
    enableSoundNotificationSettings: 'Omogući zvučne obavijesti',
    enableSoundNotificationSettingsDescription:
      'Dostavlja zvučne obavijesti za dolazne zahtjeve. Prilagodite glasnoću dolje.',
    volumeTitle: 'Glasnoća zvuka'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Pozovi',
    chat: 'Razgovor',
    email: 'E-pošta',
    facebook: 'Messenger',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Googleove poslovne poruke"
  },
  orgDetailsLabels: {
    role: 'Uloga',
    department: 'Odjel',
    email: 'E-pošta',
    businessPhone: 'Poslovni mobitel',
    workPhone: 'Posao',
  },
  addressListError: {
    title: 'Učitavanje podataka nije uspjelo',
    errorId: 'ID pogreške:'
  },
  keypad: {
    keyPadSearch: 'Unesite broj',
    dialPad: 'Brojčanik'
  },
  collabTool: {
    userAuthenticated: 'Provjera autentičnosti korisnika:',
    successful: 'Uspješno',
    failed: 'Nije uspjelo.',
    tryAgain: 'Pokušajte ponovno',
    stateSync: 'Sinkronizacija stanja:',
    mercuryFailedInfo: ' Obratite se administratoru.',
    retrying: 'Ponovno pokušavanje...',
    trackingIdLabel: 'ID za praćenje: '
  },
  webex: {
    webex: 'Webex',
    info: 'Integracija omogućuje sinkronizaciju stanja između radne površine i aplikacije Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'S ovom integracijom možete se konzultirati ili prenijeti pozive korisnicima sustava Microsoft Teams.',
    authenticationFailedInfo:
      'Ako je prozor provjere autentičnosti već otvoren, ponovo pokušajte s provjerom autentičnosti.',
    ListItemContactDetails:
      'Ime kontakta je: {name}, njegova prisutnost je: {presence}, odjel je: {department}, naziv posla je: {jobTitle} i broj telefona je: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Obavijest hitne službe',
    readNotification: 'Pročitao/la sam obavijest.'
  },
  webexPresenceStatus: {
    active: 'Aktivan',
    lastActiveFewMinutesAgo: 'Aktivan u posljednjih nekoliko minuta',
    lastActiveMinutesAgo: 'Aktivan prije broja minuta: {min}',
    lastActive1HourAgo: 'Najnovija aktivnost prije 1 sat',
    lastActiveHoursAgo: 'Aktivan prije broja sati: {hour}',
    lastActiveYesterday: 'Jučer aktivan',
    lastActiveOnDate: 'Aktivan dana {date}',
    busy: 'Zauzet',
    busyUntil: 'Zauzet do {date}',
    dnd: 'Ne ometaj',
    dndUntil: 'Ne ometaj do {date}',
    quiet: 'Tih',
    quietUntil: 'Tiho do {date}',
    ooo: 'Izvan ureda',
    outOfOfficeUntil: 'Izvan ureda do {date}',
    call: 'Poziv u tijeku',
    meeting: 'Na sastanku',
    calendarItem: 'Na sastanku u kalendaru',
    presenting: 'Predstavljanje',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Pretraživanje po nazivu ili detaljima profila',
    webexPlaceholder: 'Pretraživanje po imenu ili e-pošti',
    refreshTheList: 'Osvježite popis',
    refreshAddressBook: 'Osvježite adresar',
    microsoftAuthError: 'Nema kontakata za prikaz. Microsoftova provjera autentičnosti nije uspjela.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/hu.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/hu.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Nem sikerült betölteni az adatokat',
    errorID: 'Hibaazonosító',
    tryAgain: 'Próbálkozzon újra',
    Error: 'Hiba',
    okButton: 'OK',
    Yes: 'Igen',
    Cancel: 'Mégse',
    Confirm: 'Megerősítés',
    Continue: 'Folytatás',
    Canceling: 'Megszakítás',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: 'Válasz',
    AnswerAriaLabel: 'Válasz asztali feladatra',
    Decline: 'Elutasít',
    ErrorSecurityCompliance: 'Biztonsági megfelelés',
    errorDetails: 'Hiba részletei',
    learnMore: 'Bővebben',
    showLess: 'Kevesebb mutatása',
    trackingIdDescription:
      'Ossza meg a Tracking ID azonosítót az oldal adminisztrátorával vagy a támogatási csapattal a helyzet kivizsgálása érdekében.',
    trackingIdInputLabel: 'Követési azonosító: ',
    submitForm: 'Űrlap beküldése',
    unnamedStatus: 'Név nélküli állapot',
    errorChatMsg: 'Nem sikerült betölteni a csevegési adatokat',
    noOptions: 'Nincsenek beállítások',
    noResults: 'Nincs eredmény',
    more: 'Továbbiak',
    nomatchfound: 'Nem található egyezés',
    collaborationTool: 'Együttműködési eszköz',
    timerAriaLabel: 'Eltöltött idő',
    historyItemTime: 'Megtörténés ideje:',
    loading: 'Betöltés',
    months: [
      'Január',
      'Február',
      'Március',
      'Április',
      'Máj',
      'Június',
      'Július',
      'Augusztus',
      'Szeptember',
      'Október',
      'November',
      'December'
    ],
    loadingMsg: 'Betöltés..',
    search: 'Keresés',
    historyChannelLabels: {
      All: 'Összes',
      telephony: 'Hang',
      chat: 'Csevegés',
      email: 'E-mail',
      social: 'Közösségi'
    },
    homePageLabel: 'Kezdőoldal',
    resizeHistoryDragger: 'Előzmények méretezésének fogantyúja',
    agentHistoryLabel: 'ügynökelőzmények',
    clear: 'Bevitel törlése',
    ariaLabelAgentHistoryWrapper:
      'Az Ügynöki interakciós előzmények funkció megjeleníti az elmúlt 24 órában a különböző csatornákon történt legutóbbi ügyfélkommunikációt',
    sliderResizerInstructions:
      'Jelenleg egy csúszkán áll. A méretezéshez használja a nyílbillentyűket',
    resizeHistoryPanel: 'Előzménypanel átméretezése, csúszka,',
    time: {
      hours: 'órával',
      minutes: 'perc',
      seconds: 'másodperc'
    }
  },
  email: {
    ToLabel: 'Záró',
    FromLabel: 'Kezdő',
    CcLabel: 'Másolat',
    BccLabel: 'Titkos másolat',
    SubjectLabel: 'Tárgy',
    HideLabel: 'Elrejtés',
    SendLabel: 'Küldés',
    ShowPrevThread: 'Előző szál megjelenítése',
    HidePrevThread: 'Előző szál elrejtése',
    ReplyLabel: 'Válasz',
    ReplyAllLabel: 'Válasz mindenkinek',
    ViewOriginalMail: 'Eredeti email megtekintése',
    QuickReplyInp: 'Gyors válasz itt....',
    AttachFiles: 'Fájlok csatolása',
    ToolbarHeading: '1Fejléc',
    ToolbarBold: 'Félkövér',
    ToolbarItalic: 'Dőlt',
    ToolbarUnderLine: 'Aláhúzott',
    ToolbarBlockQuote: 'Nagybetű',
    ToolbarCode: 'Kódblokk',
    ToolbarListOrder: 'Listázás rendezés szerint',
    ToolbarListBullet: 'Listázás pontok szerint',
    ToolbarLink: 'Hivatkozás',
    ToolbarStrike: 'Áthúzott',
    ToolbarColor: 'Szövegszín',
    ToolbarTable: 'Táblázat',
    insertTable: 'Táblázat beszúrása',
    insertRowAbove: 'Sor beszúrása fölé',
    insertRowBelow: 'Sor beszúrása alá',
    insertColumnLeft: 'Oszlop beszúrása balra',
    insertColumnRight: 'Oszlop beszúrása jobbra',
    deleteRow: 'Sor törlése',
    deleteColumn: 'Oszlop törlése',
    deleteTable: 'Táblázat törlése',
    link: 'Hivatkozás',
    IndentRight: 'Jobb oldali behúzás',
    IndentLeft: 'Bal oldali behúzás',
    showMoreAttachment: 'További csatolmányok megjelenítése',
    AttachmentLimit: 'Legfeljebb ennyit csatolhat ',
    attachments: ' melléklet, ',
    sizeLimit: ' MB maximum',
    attachment: 'Melléklet',
    errordeleteattachment: 'Nem lehet törölni a fájlt vagy fájlokat. Próbálkozzon ismét.',
    errordownloadattachment: 'Nem sikerült letölteni a fájlt vagy fájlokat. Próbálkozzon ismét.',
    erroraddattachemnt: 'Nem lehet feltölteni a fájlt vagy fájlokat. Próbálkozzon ismét.',
    errorendcontact: 'Nem sikerült lezárni ezt az interakciót. Próbálkozzon ismét.',
    erroraddlimitreached:
      'A fájl nem használható mellékletként, mert túllépi a maximális ',
    errorattachmentdrop:
      'A melléklet(ek)et töröltük, mivel olyan adatokat tartalmaz(nak), amelyeket nem enged meg a vállalat biztonsági szabályrendszere.',
    errorfiletype: 'A fájltípus nem támogatott. Próbálkozzon ismét.',
    errorcreditcard:
      'A vállalat biztonsági szabályrendszere nem engedi feltölteni a melléklet(ek)et.',
    errorcontainsimage:
      'Nem sikerült feltölteni a melléklet(ek)et. Olyan képeket tartalmaz(nak), amelyeket nem támogat a vállalat biztonsági szabályrendszere.',
    errorlimit: ' MB korlátot.',
    errorsendemail: 'Nem sikerült elküldeni az emailt. Próbálkozzon ismét.',
    errorpcicheckemail: 'Nem sikerült lekérni a PCI-adatokat. Próbálja újra.',
    errortext: 'Nem sikerült betölteni az adatokat',
    tryAgain: 'Próbálkozzon újra',
    replywarning:
      'Ne osszon meg pénzügyi, egészségügyi vagy személyes azonosításra alkalmas információt (PII) ebben az üzenetben vagy mellékleteiben.',
    datamasked:
      'Az e-mail tárgya vagy szövegtörzse a vállalat biztonsági szabályrendszerének megfelelően kitakarásokat tartalmaz. Biztosan elküldi az e-mailt?',
    pcibannerwarning:
      'Az e-mail tárgya vagy szövegtörzse a vállalat biztonsági szabályrendszerének megfelelően kitakarásokat tartalmaz.',
    on: 'Be',
    wrote: 'írta'
  },
  interaction_control: {
    windowOpened: 'Ablak megnyitva',
    connected: 'Kapcsolt',
    consultRequested: 'Tanácsadás kérése',
    consulting: 'Tanácsadás',
    consultCallOnHold: 'Konzultáció fenntartva',
    callOnHold: 'Hívásvisszatartás',
    consult: 'Tanácskérés',
    endconsult: 'Tanácsadás befejezése',
    hold: 'Tartás',
    transfer: 'Átirányítás',
    conference: 'Konferencia',
    endconference: 'Konferencia vége',
    conferenceRequested: 'Konferencia kérve',
    switchCall: 'Kapcsolás',
    mergeCall: 'Belépés',
    wrapup: 'Befejezés',
    end: 'Befejezés',
    customername: 'Ügyfélnév',
    dn: 'DNIS',
    ivrpath: 'IVR-útvonal',
    email: 'Ügyfél email',
    ani: 'Telefonszám',
    queueid: 'Várólista neve',
    ronatimeout: 'Rona idő',
    pathid: 'IVR útvonal azonosító',
    dnis: 'DNIS',
    destagentphonenumber: 'DN ügynök',
    destagentname: 'Ügynök neve',
    virtualteamname: 'Sor',
    category: 'Kategória',
    additionaldetails: 'További adatok',
    sourcenumber: 'Forrásszám',
    sourcepage: 'Forrásoldal',
    appuser: 'Alkalmazás felhasználói azonosító',
    customernumber: 'Telefonszám',
    exitconference: 'Kilépés a konferenciából',
    resume: 'Folytatás',
    pauserecording: 'Felvétel szüneteltetése',
    resumerecording: 'Felvétel folytatása',
    exitconsult: 'Tanácsadás befejezése',
    pauseRecordingFailed: 'Nem lehet szüneteltetni a felvételt. Próbálkozzon újra.',
    resumeRecordingFailed: 'Nem lehet folytatni a felvételt. Próbálkozzon újra.',
    holdCallFailed: 'Nem lehet a hívást tartásba helyezni. Próbálkozzon újra.',
    resumeCallFailed: 'Nem lehet folytatni a hívást. Próbálkozzon újra.',
    endCallFailed: 'Nem sikerült lezárni ezt az interakciót. Próbálkozzon ismét.',
    consultTransferFailed:
      'Nem lehet átirányítani a tanácsadási hívást. Próbálkozzon újra.',
    conferenceTransferFailed:
      'Nem lehet átirányítani a konferenciahívást. Próbálkozzon újra.',
    conferenceFailed:
      'Nem lehet csatlakozni a konferencia kéréshez. Próbálkozzon újra.',
    consultEndFailed: 'Nem lehet lezárni a tanácsadási kérést. Próbálkozzon újra.',
    conferenceExitFailed:
      'Nem lehet kilépni a konferenciakérésből. Próbálkozzon újra.',
    conferenceEndFailed:
      'Nem lehet lezárni a konferencia kérést. Próbálkozzon újra.',
    cancelCtqFailed:
      'Nem lehet visszavonni a várakozási listára helyezett konzultációs hívást. Kérjük, próbálja ismét.',
    privacyShield: 'Adatvédelmi Pajzs',
    errorOnPrvacyShieldForConsult:
      'A rögzítés jelenleg szünetel. Folytassa a rögzítést a konzultációs hívás indításához.',
    errorOnPrvacyShieldForTransfer:
      'A rögzítés jelenleg szünetel. Folytassa a rögzítést a hívásátirányítás indításához.',
    cancelConsult: 'Konzultáció törlése',
    cancelTransfer: 'Átvitel visszavonása',
    copy: 'Másolás',
    copied: 'Másolva',
    cadrequestuccess: 'Az ügyfélinformációkat sikeresen mentettük.',
    cadrequestfailure: 'Nem sikerült elmenteni az ügyfélinformációkat. Próbálkozzon később.',
    cadupdatedmessage: 'Az ügyfélinformációt a közelmúltban frissítette:',
    unsavedmessage: 'Nem mentett módosításait felülírtuk.',
    save: 'Mentés',
    revert: 'Visszavonás törlése',
    expandDetails: 'Részletek kibontása',
    collapseDetails: 'Részletek összecsukása',
    cadValidationError:
      'Érvénytelen formátum. Használja a nemzetközi szabványt a dátumhoz és az időhöz.',
    secureCadSaveError:
      'Az ügyfél-információ mentése nem sikerült. Az ismételt próbálkozáshoz kattintson a Mentés gombra.',
    secureDecryptionError: 'A biztonságos változók nem jeleníthetők meg.',
    clickToTry: 'Kattintson ide az ismételt próbálkozáshoz',
    isSecureVariable: 'egy biztonságos változó',
    contactorigin: 'Kapcsolat eredete',
    resumeMonitoring: 'Figyelés folytatása',
    pauseMonitoring: 'Figyelés szüneteltetése',
    whisperCoach: 'Suttogó oktató',
    bargeIn: 'Berontás',
    endMonitoring: 'Figyelés befejezése',
    contactphonenumber: 'Kapcsolattartó telefonszáma',
    contactqueue: 'Kapcsolatsor',
    activeparticipants: 'Aktív résztvevők',
    consultedparticipant: 'Konzultált résztvevő',
    contactstatus: 'Kapcsolatállapot',
    timeincontactstatus: 'Kapcsolatállapotban töltött idő',
    totalcontactduration: 'Kapcsolat teljes időtartama',
    agentinteractiontime: 'Interakció időtartama',
    recording: 'Rögzítés',
    monitoring: 'Felügyelet',
    monitoringPaused: 'Figyelés szüneteltetve',
    pauseMonitoringFailed: 'Nem lehet szüneteltetni a figyelést. Próbálkozzon újra.',
    resumeMonitoringFailed: 'Nem lehet folytatni a figyelést. Próbálkozzon újra.',
    callCancelledInProgress: 'Hívás megszakítása folyamatban',
    bargedIn: 'Belépett',
    keypad: 'Billentyűzet',
    mute: 'Némítás',
    unmute: 'Némítás kikapcsolása',
    bargeInTooltipText:
      'A mikrofon bekapcsol, és Ön csatlakozik az ügyfél-interakcióhoz',
    bargeInCompactTooltipText:
      'Lépjen be. A mikrofon bekapcsol, és Ön csatlakozik az ügyfél-interakcióhoz',
    bargeInTooltipDisabled: 'A belépés engedélyezéséhez folytassa a figyelést',
    bargeInFailedTitle: 'Sikertelen belépés',
    bargeInFailedData:
      'Hiba történt a belépési kísérlet közben. Egy kis idő múlva próbálja újra.',
    supervisorBargedIn: 'belépett a hívásodba.',
    leftInteraction: 'kilépett az interakcióból.',
    conferenceEnded: 'A konferenciahívás véget ért.',
    participants: 'Résztvevők',
    badgeAriaLabel: '{participant} a hívásban van',
    bargeInConferenceAriaLabel: 'Az interakciónak két résztvevője van',
    taskName: 'Interakcióvezérlési feladat neve',
    interactionDurationLabel: 'Időtartam',
    wrapupassist: 'Segítség a befejezéshez',
    consultingTaskContext: 'Konzultációs hívás innen:',
    consultExited: 'Kilépett a konzultációs hívásból',
    endCall: 'Hívás befejezése.',
    exitconferenceCall:
      'Ha kilép a hívásból, a konferencia az aktív résztvevőkkel folytatódik.',
    recordingInProgess: 'Felvétel folyamatban',
    recordingPaused: 'A felvétel szünetel',
    searchPlaceholder: 'Névjegyek keresése',
    postCall: "Hívás utáni tevékenységek",
    switchCallTooltip: "Váltás hívásra",
    switchConsultTooltip: "Váltás tanácsadási hívásra",
    switchConferenceTooltip: "Váltás konferenciahívásra",
    confirmationDialog: {
      endCallTitle: 'Befejezi a hívást?',
      endCallMessage: 'Kattintson a Megerősítés gombra a hívás befejezéséhez az összes résztvevő számára.',
      exitConferenceTitle: 'Kilép a konferenciahívásból?',
      exitConferenceMessage:
        'Kattintson a Megerősítés gombra a konferenciahívásból való kilépéshez, és ahhoz, hogy engedélyezze a többi résztvevő számára a folytatást.',
      confirmButtonLabel: "Megerősítés",
      cancelButtonLabel: "Mégse",  
    },
    postCallOnHold: "Hívás utáni tartás",
    postCallConsult: "Hívás utáni tanácsadás",
    postCallConsultOnHold: "Hívás utáni tanácsadás, tartásban",
  },
  agentProfile: {
    teamName: 'Csapat',
    dialNumber: 'Tárcsázandó szám',
    phoneNumber: 'Telefonszám',
    settings: 'Beállítások módosítása',
    signOut: 'Kijelentkezés',
    webRTCDisconnected: 'Figyelmeztetés: Asztali telefonszolgáltatás leválasztva ',
    msAuthFailed: 'Sikertelen Microsoftos hitelesítés',
    stateSyncFailed: 'Az állapot szinkronizálása sikertelen volt',
    userProfileLabel: 'Felhasználói profil',
    ariaAgentprofile: 'Ügynökprofil',
    ChannelCapacity: 'Csatorna kapacitás',
    voice: 'Hang',
    chat: 'Csevegés',
    email: 'E-mail',
    social: 'Közösségi',
    channelCapacityTooltip: 'Kattintson, ha többet szeretne megtudni',
    blendedRouting: 'Kevert',
    exclusiveRouting: 'Kizáró átirányítás',
    realtimeRouting: 'Kevert átirányítás valós idejű',
    blendedRoutingTooltip: 'Több kapcsolat párhuzamos kezelése az összes csatornán.',
    exclusiveRoutingTooltip: 'Egyszerre csak egy kapcsolat kezelése.',
    realtimeRoutingTooltip: 'Egy kötelező valós idejű csatorna kezelése.',
    errorActiveContacts:
      'Nem tud kijelentkezni most, mert aktív beszélgetései vannak még. Fejezze be ezeket, és próbálkozzon újra.',
    searchTeams: 'Csapat keresése',
    changeTeamsConfirmHeader: 'Csapatváltás megerősítése',
    changeTeamsConfirmMessage: 'Valóban csapatot szeretne váltani?',
    changeTeamLabel: 'Csapat váltása',
    errorChangeTeams:
      'Nem tud csapatot váltani most, mert aktív kérése(i) van(nak) még. Fejezze be ezeket, és próbálkozzon újra.',
    saveTeamSelection: 'Csapatválasztás mentése',
    userSettings: 'Felhasználói beállítások',
    resetLayout: 'A teljes Asztali elrendezés visszaállítása',
    resetConfirmHeader: 'Elrendezés visszaállítás megerősítés',
    resetConfirmMessage:
      'Valóban vissza szeretné állítani a teljes Asztali elrendezést? <br/> Az Asztal visszatér az alapértelmezett elrendezéshez.',
    downloadLogs: 'Letöltési hiba jelentés',
    help: 'Súgó',
    signoutConfirm: 'Valóban szeretne kijelentkezni?',
    signoutConfirmHeader: 'Kijelentkezés megerősítése',
    darkTheme: 'Váltás Sötét módra',
    newLook: 'Váltás új megjelenésre',
    keyboardShortcuts: 'Gyorsgomb kombinációk',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Értesítési beállítások',
    silentNotification: 'Néma értesítés',
    enableNotificationSettings: 'Értesítések engedélyezése',
    enableSilentNotificationSettings: 'Néma értesítések engedélyezése',
    suppressWebexCallingNotificationSettings: 'Webex Calling-értesítések elrejtése',
    notificationSettingDescription:
      'Kézbesítési értesítések, például új üzenetek, riasztások és állapotváltozások.',
    silentNotificationDescription:
      'Bekapcsolja a képernyőn megjelenő riasztásokat. Az értesítéseket az Értesítési Központban tekintheti meg.',
    suppressWebexCallingNotificationDescription: 
    'Ne jelenítsen meg felugró értesítéseket a bejövő Webex-hívásokról, és ne fogadja őket Webex Contact Centeren keresztül.',
    arrowLabel: 'Vissza',
    managedTeams: 'Kezelt csapatok',
    managedTeamsError: 'Nem sikerült betölteni a csapatokat.',
    viewAll: 'Összes megtekintése',
    profileSettings: 'Profilbeállítások',
    userRole: 'Szerep',
    saveSelection: 'Kiválasztás mentése',
    extension: 'Mellék',
    changeProfileConfirmHeader: 'Profilbeállítás módosítások megerősítése',
    changeProfileConfirmMessage:
      'Valóban szeretné elmenteni a profil módosításait?',
    confirm: 'Megerősítés',
    errorProfileUpdate:
      'Most nem lehet módosítani a Profilbeállításokat, mert van folyamatban lévő aktív kérelem. Töltse ki ezeket, és próbálkozzon később.',
    roleAgentSupervisor: 'Felettes és ügynök',
    roleSupervisor: 'Felettes',
    noTeam: 'Nincs csapat',
    testYourNetwork: 'Hálózat tesztelése',
    speakerAndMic: 'Hangszóró és mikrofon',
    speaker: 'Hangszóró',
    mic: 'Mikrofon',
    speakerDescription:
      'Válassza ki és tesztelje a kimeneti eszközt, és győződjön meg arról, hogy hallja a hívó felet.',
    micDescription:
      'Válassza ki és tesztelje a bemeneti eszközt, és győződjön meg arról, hogy a hívó fél hallja Önt.',
    micError:
      'A mikrofonhoz való hozzáférés megtagadva. Engedélyezze a hozzáférést a böngésző beállításai között, vagy forduljon a rendszergazdához.',
    speakerError:
      'A hangszóró jelenleg nem érhető el, mivel a mikrofonhoz való hozzáférés meg van tagadva.',
    telephony: 'Telefon',
    desktop: 'Asztal',
    onSpeakerPlay:
      'Ha nem hallja a teszthangot, ellenőrizze a hangszórót.',
    onMicPlay:
      'Ha nem hallja a teszthangot, ellenőrizze a hangszórót és a mikrofont.',
    onMicRecord: 'Rögzítsen egy üzenetet a visszajátszáshoz.',
    test: 'Teszt',
    recording: 'Rögzítés',
    playing: 'Lejátszás',
    reconnecting: 'Újrakapcsolódás',
    disconnectMessage:
      'Az asztali telefonszolgáltatás megszakadt. Próbáljon ki egy másik telefonálási lehetőséget.',
    singleTelephonyDisconnectMessage:
      'Az asztali telefonszolgáltatás megszakadt. Lépjen kapcsolatba a rendszergazdával.',
    clear: 'Bevitel törlése',
    rememberMeCheckBoxMessage: "Ne jelenjen meg újra",
    saveLabel: 'Mentés',
    browserUnsupportedError: "A bejelentkezés sikertelen volt, mert nem támogatott böngészőt használ.",
    microphoneAccessDeniedError: "A mikrofonhoz való hozzáférés megtagadva. Engedélyezze a hozzáférést a böngésző beállításai között, vagy forduljon a rendszergazdához.",
  },
  contactHistory: {
    mainHeader: 'Kapcsolat előzményei',
    handledBy: 'Kezelő',
    noRecordFound: 'Nem található kapcsolati előzmény!',
    tryAgain: 'Próbálkozzon újra',
    errorMsg: 'Nem lehet lehívni a névjegy-előzményeket. Próbálkozzon ismét.',
    errorID: 'Hibaazonosító',
    missingAni: 'Hiányzó ANI',
    timeIcon: 'Időtartam',
    taskHandled: 'Kezelt feladat',
    noHistoryNew: 'Nincsenek előzmények',
    noHistory: 'Nincsenek előzmények',
    viewTranscript: 'E-mail üzenet megtekintése',
    transcriptFor: 'Leiratok ennek:',
    editBeforeCall: 'Szerkesztés a hívás előtt',
    clickToCall: 'Kattintás a híváshoz',
    onAnActiveCallErrorMessage:
      'Nem lehet új hívást indítani, mert már aktív hívásban van.',
    receivedFrom: 'Kapcsolatfelvétel érkezett:',
    initiatedTo: 'Kapcsolatfelvétel kezdeményezve:',
    wrapUpReason: 'Befejezési ok',
    startCallTelephony:
      'Kimenő hívás indításához kattintson a telefonszám hivatkozásra.',
    contactHistoryList: 'Kapcsolat előzményei lista,',
    wrapUpCode: 'Felgöngyölítési kód',
    agentName: 'Ügynök neve',
    entryPointName: 'Belépési pont',
    acceptedTimeAndDate: 'Elfogadott dátum és idő',
    duration: 'Időtartam',
    emailTranscript: 'E-mail átirat',
    clickToViewEmailTranscript: 'Kattintson ide az e-mail átiratának megtekintéséhez',
    listContainer: 'Listatároló'
  },
  contactTranscript: {
    agent: 'Ügynök',
    entryPoint: 'Belépési pont',
    date: 'Dátum',
    subject: 'Tárgy',
    from: 'Kezdő',
    sent: 'Elküldve',
    to: 'Záró',
    back: 'Vissza',
    errorTranscript: 'Hiba történt a leiratok beszerzése közben',
    customer: 'Ügyfél',
    inboundErrorMessage: 'Nem lehet betölteni az ügyfél e-mailt',
    outboundErrorMessage: 'Nem lehet betölteni az ügynök válaszát'
  },
  popoverTitle: {
    callback: 'Visszahívás',
    outboundCall: 'Kimenő hívás',
    incomingCall: 'Bejövő hívás',
    progressiveCampaign: 'Kampányhívás',
    courtesyCallback: 'Ingyenes visszahívás',
    chat: 'Bejövő csevegés',
    incoming: 'Bejövő',
    monitoringCall: 'Ellenőrzőhívás'
  },
  connecting: 'Csatlakozás',
  initiating: 'Kezdeményezés',
  outbound: 'Kimenő',
  transfer: {
    title: 'Átirányítási kérelem',
    heading: {
      chat: 'Válassza ki azt az ügynököt vagy várólistát, amelyre át szeretne irányítani.',
      email: 'Válassza ki azt a várólistát, amelyre át szeretne irányítani.',
      telephony:
        'Válassza ki azt az ügynököt, várólistát vagy tárcsázási számot, amelyre át szeretne irányítani.',
      noQueueTelephony:
        'Válassza ki azt az ügynököt vagy tárcsázási számot, amelyre át szeretne irányítani.'
    },
    header: {
      chat: 'Válasszon ki egy ügynököt vagy sort, ahová át szeretné irányítani ezt a kapcsolatot.',
      email: 'Válasszon ki egy sort, ahová át szeretné irányítani ezt a kapcsolatot.',
      telephony:
        'Válasszon ki egy ügynököt, sort, tárcsázandó számot vagy szervezetet, ahová át szeretné irányítani ezt a kapcsolatot.',
      noQueueTelephony:
        'Válasszon ki egy ügynököt, tárcsázandó számot vagy szervezetet, ahová át szeretné irányítani ezt a kapcsolatot.',
      noOrganizationTelephony:
        'Válasszon ki egy ügynököt, sort vagy tárcsázandó számot, ahová át szeretné irányítani ezt a kapcsolatot.',
      noQueueOrganizationTelephony:
        'Válassza ki az ügynököt vagy a tárcsázandó számot, ahová át szeretné irányítani ezt a kapcsolatot.'
    },
    queues: 'Sor',
    agents: 'Ügynök',
    dialNumber: 'Tárcsázandó szám',
    organization: 'Szervezet',
    placeholder: {
      Queues: 'Válasszon a várólisták listájából',
      Agents: 'Válasszon az ügynökök listájából',
      DialNumber: 'Keresés név vagy szám szerint',
      DialNumberOrEntryPoint: 'Keresés név/szám/belépési pont szerint',
      ChooseByNameOrNumber: 'Kiválasztás név/szám szerint',
      Organization: 'Keresés név/szerep/részleg/céges telefonszám alapján',
      WebexOrganization: 'Keresés név vagy e-mail-cím szerint',
      DialNumberSearch: 'Keresés név vagy szám szerint'
    },
    type: 'Átirányítás',
    cancel: 'Mégse',
    closeModal: 'Modul bezárása',
    failureError: 'Nem sikerült átirányítani ezt a kérést. Próbálkozzon ismét.',
    entryPoint: 'Belépési pont'
  },
  consult: {
    title: 'Tanácsadás kérése',
    heading: {
      chat: 'Válassza ki azt az ügynököt vagy várólistát, amelyre át szeretne irányítani.',
      email: 'Válassza ki azt a várólistát, amelyre át szeretne irányítani.',
      telephony:
        'Válassza ki azt az ügynököt, várólistát vagy tárcsázási számot, amellyel konzultálni szeretne.',
      noQueueTelephony:
        'Válassza ki azt az ügynököt vagy tárcsázási számot, amellyel konzultálni szeretne.'
    },
    header: {
      chat: 'Válasszon ki egy ügynököt vagy sort, ahová át szeretné irányítani ezt a kapcsolatot.',
      email: 'Válasszon ki egy sort, ahová át szeretné irányítani ezt a kapcsolatot.',
      telephony:
        'Válassza ki az ügynököt, sort, tárcsázási számot vagy szervezetet, amellyel konzultálni szeretne.',
      noQueueTelephony:
        'Válassza ki az ügynököt, tárcsázási számot vagy szervezetet, amellyel konzultálni szeretne.',
      noOrganizationTelephony:
        'Válassza ki az ügynököt, sort vagy tárcsázási számot, amellyel konzultálni szeretne.',
      noQueueOrganizationTelephony:
        'Válassza ki az ügynököt vagy tárcsázási számot, amellyel konzultálni szeretne.'
    },
    queues: 'Sor',
    agents: 'Ügynök',
    dialNumber: 'Tárcsázandó szám',
    organization: 'Szervezet',
    placeholder: {
      Queues: 'Válasszon a várólisták listájából',
      Agents: 'Válasszon az ügynökök listájából',
      DialNumber: 'Keresés név vagy szám szerint',
      DialNumberOrEntryPoint: 'Keresés név/szám/belépési pont szerint',
      ChooseByNameOrNumber: 'Kiválasztás név/szám szerint',
      Organization: 'Keresés név/szerep/részleg/céges telefonszám alapján',
      WebexOrganization: 'Keresés név vagy e-mail-cím szerint',
      DialNumberSearch: 'Keresés név vagy szám szerint'
    },
    type: 'Tanácskérés',
    checkBoxLabel: 'Az interakció folytatásnak engedélyezése a résztvevők számára.',
    cancel: 'Mégse',
    closeModal: 'Modul bezárása',
    failureError: 'Nem lehet csatlakozni a tanácsadó kéréshez. Próbálkozzon újra.',
    customerLeftMsg: 'Ügyfél szétkapcsolva. Nincs szükség további tanácsadásra.',
    ctqFailureMsg:
      'Nem lehet visszavonni a várakozási listára helyezett konzultációs hívást. Kérjük, próbálja ismét.',
    cancelCtqInfo:
      'Rendelkezésre álló ügynök keresése a kiválasztott sorban. Várjon, vagy törölje a tanácsadási kérést.',
    cancelCtqAction: 'Konzultáció törlése.',
    entryPoint: 'Belépési pont'
  },
  conference: {
    title: 'Konferenciakérés',
    heading: {
      chat: 'Válasszon ügynököt a konferencia-csevegéshez'
    },
    queues: 'Sor',
    agents: 'Ügynök',
    dialNumber: 'Tárcsázandó szám',
    organization: 'Szervezet',
    placeholder: {
      Queues: 'Válasszon a várólisták listájából',
      Agents: 'Válasszon az ügynökök listájából',
      DialNumber: 'Keresés név vagy szám szerint'
    },
    type: 'Konferencia',
    cancel: 'Mégse',
    closeModal: 'Modul bezárása',
    failureError: 'Nem sikerült elindítani ezt a konferenciakérést. Próbálkozzon ismét.'
  },
  transferModal: {
    Agents: 'Nem sikerült lekérni az ügynökök listáját. Frissítse a listát.',
    AgentsEmpty: 'Nincs rendelkezésre álló ügynök',
    Queues: 'Nem sikerült lekérni a sorok listáját. Frissítse a listát.',
    QueuesEmpty: 'Nincs rendelkezésre álló várólista',
    EPEmpty: 'Nincs elérhető belépési pont',
    DialNumber:
      'Nem sikerült lekérni a telefonszámok listáját a címjegyzékből. Frissítse a listát.',
    EntryPoint:
      'Nem sikerült lekérni a belépési pontok listáját. Frissítse a listát.',
    Common: 'Nem sikerült lekérni a listát. Frissítse a listát.',
    DialNumberEmpty: 'Nem áll rendelkezésre tárcsázási szám',
    DialNumbInvalid:
      'A tárcsázási szám érvénytelen. Forduljon a rendszergazdához.',
    DialNumbOrEntryPointInvalid:
      'Tárcsázási szám/belépési pont érvénytelen. Forduljon a rendszergazdához.',
    refreshQueueList: 'A várólisták listájának frissítése',
    refreshAgentList: 'Az ügynökök listájának frissítése',
    refreshEpList: 'A belépési pontok frissítése',
    refreshAddressBook: 'A címjegyzék frissítése',
    refreshTheList: 'A lista frissítése',
    entryPointSectionLabel: 'Belépési pont',
    addressBookSectionLabel: 'Címjegyzék',
    organization: 'Szervezet',
    comboBoxAriaLabelAgent: 'Válasszon az ügynökök listájából',
    comboBoxAriaLabelQueue: 'Válasszon a várólisták listájából',
    comboBoxAriaLabelEp: 'Válasszon a belépési pontok listájából',
    infScrollAgent: 'Keresés az ügynökök között',
    infScrollQueue: 'Keresés a sorok között',
    infScrollEP: 'Keresés a belépési pontok között',
    allRadioButtonHidedTextForConsult: 'Nincs hozzárendelt entitása az interakcióval kapcsolatos tanácsadáshoz. Forduljon a rendszergazdához.',
    allRadioButtonHidedTextForTransfer: 'Nincs hozzárendelt entitása az interakció átadásához. Forduljon a rendszergazdához.',
    allRadioButtonHidedTextForConference: 'Nincs hozzárendelt entitása az interakcióval kapcsolatos konferenciához. Forduljon a rendszergazdához.',
    searchMinCharError: 'A kereséséhez legalább három karaktert adjon meg.',
  },
  wrapup: {
    cancelautowrapup: 'Automatikus felgöngyölítés törlése',
    wrapupreason: 'Befejezési okok',
    untilautowrapup: 'automatikus felgöngyölítésig',
    followupsetting: 'Utánkövetési beállítás',
    lastagentroute: 'Utolsó ügynök útirányítás',
    submitwrapup: 'Felgöngyölítés beküldése',
    wrapupsearch: 'Felgöngyölítési ok keresése',
    invalidationError: 'Nem sikerült beküldeni felgöngyölítést',
    searchResult: 'Van elérhető keresési eredmény',
    noResultFound: 'Nincs elérhető keresési eredmény',
    listContainerLabel: 'Összefoglalási lista tárolója',
    searchError: 'A befejezési okok közötti kereséséhez legalább három karaktert adjon meg.',
  },

  outdial: {
    call: 'Hívás',
    dialpadSearch: 'Adjon meg tárcsázandó számot',
    addressSearch: 'Keresés név/szám szerint',
    addressTab: 'Cím',
    addressTabTooltip: 'Keresés a címjegyzékben',
    dialpadTab: 'Tárcsázó',
    dialpadTooltip: 'Szám tárcsázása',
    searchTab: 'Keres',
    searchTabTooltip:'Személyek keresése a szervezetemben',
    noAdrFound: 'Nem található egyezés',
    noContacts: 'Nincsenek kapcsolatok',
    mainIconTooltip: 'Tárcsázásos hívás',
    errorOutdialFailed:
      'A tárcsázásos hívás sikertelen. A Desktop nem tudott csatlakozni a híváshoz, vagy a hívást nem fogadták.',
    errorOutdialDisabled: 'A tárcsázásos hívások le vannak tiltva',
    errorDialPadValidationMessage: 'Nem megfelelő formátum',
    outdialReqInProgress: 'Tárcsázásos hívás folyamatban',
    outdialAniPlaceholder: 'Külső tárcsázási ANI választása',
    outdialAniLabel: 'Külső tárcsázási ANI',
    outdialAniPlaceHolder: 'Tárcsázási ANI keresése',
    errorDcCallsLimitExceeded:
      'Az adatközpont elérte a tárcsázásos hívások maximális számra vonatkozó korlátot. Több tárcsázásos hívás nem kezdeményezhető',
    errorOrgCallsLimitExceeded:
      'A szervezet elérte a tárcsázásos hívások maximális számára vonatkozó korlátot. Több tárcsázásos hívás nem kezdeményezhető.',
    errorOutDialNoAnswerFromCustomer:
      'Az ügyfél nem fogadta a hívását. Próbálja meg hívni később.',
    errorOutDialCustomerUnavailable:
      'Az ügyfél jelenleg nem elérhető. Próbálja meg hívni később.',
    errorOutDialAgentEnds: 'Ön befejezte a telefonbeszélgetést az ügyféllel.',
    errorOutDialCustomerBusy: 'Az ügyfél jelenleg foglalt. Próbálja meg hívni később.',
    searchError: 'A kapcsolatok körében történő kereséséhez legalább három karaktert adjon meg.',
    upArrowLabel: 'Kinyitás',
    clear: 'Bevitel törlése',
    outdialDialogDescription: 'Jelenleg a lapokat tartalmazó párbeszéden van.'
  },

  organization: {
    noMatchFound: 'Nem található egyezés',
    searchError: 'A kapcsolatok körében történő kereséséhez legalább három karaktert adjon meg.',
    authError: 'Nincsenek megjeleníthető kapcsolatok. Sikertelen Microsoftos hitelesítés.'
  },

  interactionPopover: {
    of: 'per',
    accept: 'Elfogad',
    acceptAriaLabel: 'Feladat elfogadása - szám: {taskNumber}, típus: {taskType}, forrás: {from}',
    requests: 'Kérés(ek)',
    back: 'vissza',
    next: 'tovább',
    acceptMultipleRequest: '{requestCount} kérelem fogadása',
    paginationDetail: '{indexStart}–{indexEnd} / {totalPopoverpoolLength}',
    hidePopoverDetails: 'Felugró részletek elrejtése',
    showPopoverDetails: 'Felugró részletek megjelenítése',
    customerName: 'Ügyfél neve',
    email: 'E-mail',
    queueName: 'Várólista neve',
    failedToAccept: 'Nem sikerült elfogadni.',
    unableToAccept: 'Nem lehet elfogadni a névjegyet.',
    failedToEnd: 'Befejezés sikertelen.',
    unableToEnd: 'Nem sikerült lezárni a névjegyet. ',
    ringing: 'Kicsengés',
    calling: 'Hívás',
    phoneNumber: 'Telefonszám',
    dni: 'DNIS',
    ivrPathId: 'IVR útvonal azonosító',
    pathId: 'Útvonal azonosító',
    rona: 'RONA',
    sourcePage: 'Forrásoldal',
    sourceNumber: 'Forrásszám',
    appUserId: 'Alkalmazás felhasználói azonosító',
    acceptAll: 'Minden feladat elfogadása',
    agentDn: 'DN ügynök',
    agentName: 'Ügynöknév',
    agentTeam: 'Ügynök csapata',
    requestDetails: 'Részletek kérése',
    incomingCallFrom: 'Bejövő hívás innen:',
    unableToAnswer: 'Nem lehet fogadni a hívást. Próbálkozzon újra.',
    unableToDecline: 'Nem lehet elutasítani a hívást. Próbálkozzon újra.'
  },

  multiLogin: {
    header: 'Többszörös bejelentkezési figyelmeztetés',
    message:
      'Már be van jelentkezve a Desktopba több alkalmazáspéldányban is. Kattintson a Folytatás gombra, ha a Desktopot ebben az alkalmazáspéldányban szeretné tovább használni. Ellenkező esetben zárja be ezt az ablakot.',
    continue: 'Folytatás'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Konfigurációs hiba miatt nem sikerült az átadás a belépési pontnak/várólistának.',
    1010: "A tanácsadás nem sikerült, mert az ügynök hozzárendelése nem volt időben megoldható. ",
    1042: "A kapcsolat nem található",
    1043: 'A cél érvénytelen.',
    1045: 'Az interakció nincs hozzárendelve az ügynökhöz.',
    1046: 'Az ügynöki tanácsadás sikertelen volt, mert a rendszerben nem található egyező ügynöki csatorna.',
    1038: "Az ügynök nem található",
    1037: 'Belső hiba miatt a bejelentkezés nem sikerült.',

    // Media Events
    138: 'Ismeretlen okok miatt a művelet nem sikerült.',
    136: 'A felhasználó nem található',

    // AgentConsultFailed
    1050: 'Az adatfolyamban szereplő nem támogatott konfiguráció vagy tevékenység miatt a tanácsadás nem valósítható meg. ',
    1005: "Nem lehet egyeztetni, mivel az ügynök nem válaszolt a kérésre időben.",
    1051: 'Érvénytelen belépési pont vagy tárcsázási szám miatt nem lehetséges a konzultáció vagy az átvitel.',

    // AgentInviteFailed
    1053: 'Nem lehet bemutatni az interakciót egy munkafolyamat függőben lévő várólista-visszahelyezési feladata miatt.',
    1054: 'A kéréssel kapcsolatos médiaproblémák miatt nem lehet tárcsázásos hívást kezdeményezni. ',

    // AgentContactAssignFailed
    1011: 'Nem lehet fogadni a hívást, mivel a folyamatban lévő interakcióból ügynökök hiányoznak. ',

    // ContactCallbackFailed
    1034: 'A kapcsolat visszahívása sikertelen volt, mivel a rendszer ContactParkTimeout üzenetet fogadott.',

    // ContactUpdateFailed
    1020: "A változókat nem lehet frissíteni, mint az egyik érték meghaladja a 256 karakteres korlátot. Csökkentse a karakterek számát, és próbálja újra.",

    // AgentInviteFailed
    1031: 'Az ügynök a visszahívási kérés után hívta meg a vevőt.',

    // AgentBlindTransferFailedEvent
    1044: 'Az ügynök azonnali hívásátadása sikertelen volt, mivel a célügynök egy másik interakcióhoz van rendelve.',

    // AgentCtqCancelFailed
    1047: "A kapcsolat nem található.",

    // AgentCtqFailed
    1048: "Nincs beállítva a hívásátirányítási csoport.",
    1049: 'A várólista maximális várakozási ideje túllépve.',
    // StationLoginFailed
    127: 'Dupla bejelentkezésből adódó hiba miatt nem sikerült az ügynök DN-regisztrálása.'
  },

  stateSelector: {
    Available: 'Elérhető',
    errorstatechange: 'Állapotváltozás nem sikerült. Próbálja újra.',
    errorStateChangeInPendingLogout: 'Nem sikerült megváltoztatni az ügynökállapotot függőben lévő kijelentkezés miatt.',
    label: 'Elérhetőségi állapot',
    agentStateSelector: 'Ügynökállapot-választó',
    Engaged: 'Foglalt',
    engagedAvailableInfo:
      'Ön jelenleg interakciót folytat és a elérhető állapotban van.',
    engagedIdleInfo:
      'Ön jelenleg interakciót folytat és az inaktív állapotban van.',
    engagedInfo: 'Ön jelenleg interakciót folytat.',
    engagedSupervisorStateChange: 'módosította az Ön állapotát erre:',
    axAgentStateChanged: 'Az Ön állapota megváltozott erre:',
    axAgentSync: 'az együttműködési eszközzel való állapotszinkronizálás miatt.',
    engagedPresenceInfo:
      'Ön jelenleg interakciót folytat, és az Ön állapota',
    engagedPresenceSync: 'az együttműködési eszközzel való állapotszinkronizálás miatt.',
    clear: 'Bevitel törlése',
    searchState: 'bevitel',
    agentStatusLabel: 'Ügynökállapot',
    agentStateLabel: 'Az ügynök állapota {selectedState} az elmúlt {selectedTimeValue} során',
    agentStateLabelOnStateChange: 'Az ügynök állapota {selectedState} az elmúlt 0 másodperc során',
    agentStateChangeSuccessful:'Az állapot módosítása „{selectedState} sikeres” értékre.',
    agentStateChangeFail:'Az állapot módosítása „{selectedState} sikertelen” értékre.',
    searchError: 'Az állapotok közötti kereséséhez legalább három karaktert adjon meg.'
  },

  warningMessage: {
    header: 'Nem mentett módosítások',
    message:
      'Nem mentett módosításai vannak ezen az oldalon. Valóban el szeretné hagyni ezt az oldalt? ',
    cancelButton: 'Marad',
    saveButton: 'Kilépés'
  },

  notificationLables: {
    muteVolume: 'Értesítési hangerő némítása',
    unmuteVolume: 'Értesítési hangerő némításának feloldása',
    notificationVolume: 'Értesítési hangerő',
    playSound: 'Értesítési hang lejátszása',
    enableSoundNotificationSettings: 'Hangos értesítések engedélyezése',
    enableSoundNotificationSettingsDescription:
      'Hang értesítések lejátszása a bejövő kérésekhez. A hangerőt lent állíthatja be.',
    volumeTitle: 'Hangerő'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Hívás',
    chat: 'Csevegés',
    email: 'E-mail',
    facebook: 'Messenger',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Apple Business chat',
    googleBusiness: "A Google üzleti üzenetei"
  },
  orgDetailsLabels: {
    role: 'Szerep',
    department: 'Részleg',
    email: 'E-mail',
    businessPhone: 'Céges telefon',
    workPhone: 'Munkahelyi',
  },
  addressListError: {
    title: 'Nem sikerült betölteni az adatokat',
    errorId: 'Hibaazonosító:'
  },
  keypad: {
    keyPadSearch: 'Írja be a számot',
    dialPad: 'Tárcsázó'
  },
  collabTool: {
    userAuthenticated: 'Felhasználóhitelesítés:',
    successful: 'Sikeres',
    failed: 'Nem sikerült.',
    tryAgain: 'Próbálkozzon újra',
    stateSync: 'Állapot-szinkronizálás:',
    mercuryFailedInfo: ' Forduljon a rendszergazdához.',
    retrying: 'Újrapróbálkozás...',
    trackingIdLabel: 'Követési azonosító: '
  },
  webex: {
    webex: 'Webex',
    info: 'Az integráció lehetővé teszi az állapotok szinkronizálását az Asztal és a Webex között.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Ezzel az integrációval tanácsadást folytathat a Microsoft Teams felhasználóival, vagy hívásokat adhat át nekik.',
    authenticationFailedInfo:
      'Ha már meg van nyitva egy hitelesítési ablak, próbálkozzon ott a hitelesítéssel.',
    ListItemContactDetails:
      'A kapcsolat neve: {name}, jelenléte: {presence}, osztálya: {department}, beosztása: {jobTitle}, telefonszáma: {phoneno}.'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Sürgősségi segélyszolgálati értesítés',
    readNotification: 'Elolvastam az értesítést.'
  },
  webexPresenceStatus: {
    active: 'Aktív',
    lastActiveFewMinutesAgo: 'Aktív az elmúlt percekben',
    lastActiveMinutesAgo: 'Aktív {min} perccel ezelőtt',
    lastActive1HourAgo: 'Utolsó tevékenység 1 órája',
    lastActiveHoursAgo: 'Aktív {hour} órával ezelőtt',
    lastActiveYesterday: 'Aktív tegnap',
    lastActiveOnDate: 'Aktív ekkor: {date}',
    busy: 'Foglalt',
    busyUntil: 'Foglalt eddig: {date}',
    dnd: 'Ne zavarj',
    dndUntil: 'Ne zavarjanak eddig: {date}',
    quiet: 'Halk',
    quietUntil: 'Halk eddig: {date}',
    ooo: 'Házon kívül',
    outOfOfficeUntil: 'Házon kívül eddig: {date}',
    call: 'Hívásban',
    meeting: 'Értekezleten',
    calendarItem: 'Naptári értekezleten',
    presenting: 'Előad',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Keresés név vagy profiladatok alapján',
    webexPlaceholder: 'Keresés név vagy e-mail-cím szerint',
    refreshTheList: 'A lista frissítése',
    refreshAddressBook: 'A címjegyzék frissítése',
    microsoftAuthError: 'Nincsenek megjeleníthető kapcsolatok. Sikertelen Microsoftos hitelesítés.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/it.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/it.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Impossibile caricare i dati',
    errorID: 'ID errore',
    tryAgain: 'Riprova',
    Error: 'Errore',
    okButton: 'OK',
    Yes: 'Sì',
    Cancel: 'Annulla',
    Confirm: 'Conferma',
    Continue: 'Continua',
    Canceling: 'Annullamento',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: 'Rispondi',
    AnswerAriaLabel: 'Rispondi ad attività desktop',
    Decline: 'Rifiuta',
    ErrorSecurityCompliance: 'Conformità alle norme di sicurezza',
    errorDetails: 'Dettagli errore',
    learnMore: 'Ulteriori informazioni',
    showLess: 'Mostra meno',
    trackingIdDescription:
      'Per indagare sulla situazione, condividere l\'ID monitoraggio con l\'amministratore del sito o con il team dell\'assistenza.',
    trackingIdInputLabel: 'ID monitoraggio: ',
    submitForm: 'Invia modulo',
    unnamedStatus: 'Stato senza nome',
    errorChatMsg: 'Non è stato possibile caricare i dati della chat',
    noOptions: 'Nessuna opzione',
    noResults: 'Nessun risultato',
    more: 'Altro',
    nomatchfound: 'Nessuna corrispondenza trovata',
    collaborationTool: 'Strumento di collaborazione',
    timerAriaLabel: 'Tempo trascorso',
    historyItemTime: 'Data',
    loading: 'Caricamento in corso',
    months: [
      'Gennaio',
      'Febbraio',
      'Marzo',
      'Aprile',
      'Maggio',
      'Giugno',
      'Luglio',
      'Agosto',
      'Settembre',
      'Ottobre',
      'Novembre',
      'Dicembre'
    ],
    loadingMsg: 'Caricamento in corso...',
    search: 'Cerca',
    historyChannelLabels: {
      All: 'Tutto',
      telephony: 'Voce',
      chat: 'Chat',
      email: 'E-mail',
      social: 'Social'
    },
    homePageLabel: 'Pagina iniziale',
    resizeHistoryDragger: 'Ridimensiona trascinatore cronologia',
    agentHistoryLabel: 'cronologia agente',
    clear: 'Cancella input',
    ariaLabelAgentHistoryWrapper:
      'Cronologia interazioni agente Mostra le comunicazioni recenti con i clienti su diversi canali nelle ultime 24 ore',
    sliderResizerInstructions:
      'Attualmente è in uso un indicatore di scorrimento. Per ridimensionare utilizzare i tasti freccia',
    resizeHistoryPanel: 'Ridimensiona pannello cronologia, indicatore di scorrimento,',
    time: {
      hours: 'ora',
      minutes: 'min.',
      seconds: 'Sec'
    }
  },
  email: {
    ToLabel: 'A',
    FromLabel: 'Da',
    CcLabel: 'Cc',
    BccLabel: 'Ccn',
    SubjectLabel: 'Oggetto',
    HideLabel: 'Nascondi',
    SendLabel: 'Invia',
    ShowPrevThread: 'Mostra thread precedente',
    HidePrevThread: 'Nascondi thread precedente',
    ReplyLabel: 'Rispondi',
    ReplyAllLabel: 'Rispondi a tutti',
    ViewOriginalMail: 'Visualizza e-mail originale',
    QuickReplyInp: 'Risposta rapida qui...',
    AttachFiles: 'Allegati',
    ToolbarHeading: 'Intestazione1',
    ToolbarBold: 'Grassetto',
    ToolbarItalic: 'Corsivo',
    ToolbarUnderLine: 'Sottolineato',
    ToolbarBlockQuote: 'Blocco citazione',
    ToolbarCode: 'Blocco codice',
    ToolbarListOrder: 'Elenco numerato',
    ToolbarListBullet: 'Elenco puntato',
    ToolbarLink: 'Collegamento',
    ToolbarStrike: 'Barrato',
    ToolbarColor: 'Colore testo',
    ToolbarTable: 'Tabella',
    insertTable: 'Inserisci tabella',
    insertRowAbove: 'Inserisci riga sopra',
    insertRowBelow: 'Inserisci riga sotto',
    insertColumnLeft: 'Inserisci colonna a sinistra',
    insertColumnRight: 'Inserisci colonna a destra',
    deleteRow: 'Elimina riga',
    deleteColumn: 'Elimina colonna',
    deleteTable: 'Elimina tabella',
    link: 'Collegamento',
    IndentRight: 'Rientro a destra',
    IndentLeft: 'Rientro a sinistra',
    showMoreAttachment: 'Mostra altri allegati',
    AttachmentLimit: 'Allega fino a ',
    attachments: ' allegati, ',
    sizeLimit: ' MB massimo',
    attachment: 'Allegato',
    errordeleteattachment: 'Impossibile eliminare i file. Riprovare.',
    errordownloadattachment: 'Impossibile scaricare i file. Riprovare.',
    erroraddattachemnt: 'Impossibile caricare i file. Riprovare.',
    errorendcontact: 'Impossibile terminare l\'interazione. Riprovare.',
    erroraddlimitreached:
      'Impossibile allegare il file perché supera il massimo ',
    errorattachmentdrop:
      'Allegati rimossi conformemente alle norme sulla sicurezza dei dati dell\'azienda.',
    errorfiletype: 'Il tipo di file non è supportato. Riprovare.',
    errorcreditcard:
      'Impossibile caricare gli allegati conformemente alle norme sulla sicurezza dell\'azienda.',
    errorcontainsimage:
      'Impossibile caricare gli allegati. Le immagini negli allegati non sono supportate dalle norme sulla sicurezza dell\'azienda.',
    errorlimit: ' limite in MB.',
    errorsendemail: 'Impossibile inviare l\'e-mail. Riprovare.',
    errorpcicheckemail: 'Impossibile recuperare i dati PCI. Riprovare.',
    errortext: 'Impossibile caricare i dati',
    tryAgain: 'Riprova',
    replywarning:
      'Non condividere informazioni finanziare, sulla salute o qualsiasi informazione personale in questo messaggio o negli allegati.',
    datamasked:
      'L\'oggetto o il corpo dell\'e-mail è redatto conformemente alle norme sulla sicurezza dei dati dell\'azienda. Inviare l\'e-mail?',
    pcibannerwarning:
      'L\'oggetto o il corpo dell\'e-mail è redatto conformemente alle norme sulla sicurezza dei dati dell\'azienda.',
    on: 'Attivato',
    wrote: 'scrisse'
  },
  interaction_control: {
    windowOpened: 'Finestra aperta',
    connected: 'Connesso',
    consultRequested: 'Consulenza richiesta',
    consulting: 'In consultazione',
    consultCallOnHold: 'Consulenza in attesa',
    callOnHold: 'Chiamata in attesa',
    consult: 'Consulta',
    endconsult: 'Termina consulenza',
    hold: 'In attesa',
    transfer: 'Trasferisci',
    conference: 'Conferenza',
    endconference: 'Termina conferenza',
    conferenceRequested: 'Conferenza richiesta',
    switchCall: 'Cambia',
    mergeCall: 'Unisci',
    wrapup: 'Riepilogo',
    end: 'Termina',
    customername: 'Nome cliente',
    dn: 'DNIS',
    ivrpath: 'Percorso IVR',
    email: 'E-mail cliente',
    ani: 'Numero di telefono',
    queueid: 'Nome coda',
    ronatimeout: 'Tempo RONA',
    pathid: 'ID percorso IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'DN agente',
    destagentname: 'Nome dell\'agente',
    virtualteamname: 'Coda',
    category: 'Categoria',
    additionaldetails: 'Dettagli Aggiuntivi',
    sourcenumber: 'Numero di origine',
    sourcepage: 'Pagina di origine',
    appuser: 'ID utente app',
    customernumber: 'Numero di telefono',
    exitconference: 'Esci da conferenza',
    resume: 'Riprendi',
    pauserecording: 'Metti in pausa registrazione',
    resumerecording: 'Riprendi registrazione',
    exitconsult: 'Esci da consulenza',
    pauseRecordingFailed: 'Impossibile sospendere la registrazione. Riprovare.',
    resumeRecordingFailed: 'Impossibile riprendere la registrazione. Riprovare.',
    holdCallFailed: 'Impossibile mettere in attesa la chiamata. Riprovare.',
    resumeCallFailed: 'Impossibile riprendere la chiamata. Riprovare.',
    endCallFailed: 'Impossibile terminare l\'interazione. Riprovare.',
    consultTransferFailed:
      'Impossibile trasferire la chiamata di consulenza. Riprovare.',
    conferenceTransferFailed:
      'Impossibile trasferire la chiamata in conferenza. Riprovare.',
    conferenceFailed:
      'Impossibile connettere la richiesta di conferenza. Riprovare.',
    consultEndFailed: 'Impossibile terminare la richiesta di consulenza. Riprovare.',
    conferenceExitFailed:
      'Impossibile uscire dalla richiesta di conferenza. Riprovare.',
    conferenceEndFailed:
      'Impossibile terminare la richiesta di conferenza. Riprovare.',
    cancelCtqFailed:
      'Impossibile annullare la chiamata di consulenza nella coda. Riprovare.',
    privacyShield: 'Privacy Shield',
    errorOnPrvacyShieldForConsult:
      'Al momento la registrazione è in pausa. Per avviare una chiamata di consulenza, riprendere la registrazione.',
    errorOnPrvacyShieldForTransfer:
      'Al momento la registrazione è in pausa. Per avviare un trasferimento di chiamata, riprendere la registrazione.',
    cancelConsult: 'Annulla consulenza',
    cancelTransfer: 'Annulla trasferimento',
    copy: 'Copia',
    copied: 'Copiato',
    cadrequestuccess: 'Le informazioni del cliente sono state salvate.',
    cadrequestfailure: 'Non è stato possibile salvare le informazioni del cliente. Provare più tardi.',
    cadupdatedmessage: 'Le informazioni del cliente sono state aggiornate di recente da',
    unsavedmessage: 'Le modifiche non salvate sono state sovrascritte.',
    save: 'Salva',
    revert: 'Ripristina',
    expandDetails: 'Espandi dettagli',
    collapseDetails: 'Riduci dettagli',
    cadValidationError:
      'Formato non valido. Utilizzare lo standard internazionale per la data e l\'ora.',
    secureCadSaveError:
      'Le informazioni sul cliente non sono state salvate. Fare clic su Salva per riprovare.',
    secureDecryptionError: 'Non è possibile visualizzare le variabili protette.',
    clickToTry: 'Fare clic per riprovare',
    isSecureVariable: 'è una variabile protetta',
    contactorigin: 'Origine contatto',
    resumeMonitoring: 'Riprendi monitoraggio',
    pauseMonitoring: 'Sospendi monitoraggio',
    whisperCoach: 'Suggerimenti riservati',
    bargeIn: 'Includi',
    endMonitoring: 'Termina monitoraggio',
    contactphonenumber: 'Numero di telefono del contatto',
    contactqueue: 'Coda contatto',
    activeparticipants: 'Partecipanti attivi',
    consultedparticipant: 'Partecipante consultato',
    contactstatus: 'Stato contatto',
    timeincontactstatus: 'Stato tempo di connessione',
    totalcontactduration: 'Durata totale contatto',
    agentinteractiontime: 'Durata interazione',
    recording: 'Registrazione',
    monitoring: 'Monitoraggio',
    monitoringPaused: 'Monitoraggio sospeso',
    pauseMonitoringFailed: 'Impossibile sospendere il monitoraggio. Riprovare.',
    resumeMonitoringFailed: 'Impossibile riprendere il monitoraggio. Riprovare.',
    callCancelledInProgress: 'Annullamento chiamata in corso',
    bargedIn: 'Entrato',
    keypad: 'Tastiera',
    mute: 'Disattiva microfono',
    unmute: 'Attiva microfono',
    bargeInTooltipText:
      'Il microfono si attiverà per consentire la partecipazione a questa interazione con il cliente',
    bargeInCompactTooltipText:
      'Inclusione. Il microfono si attiverà per consentire la partecipazione a questa interazione con il cliente',
    bargeInTooltipDisabled: 'Riprendi il monitoraggio per abilitare l\'inclusione',
    bargeInFailedTitle: 'Errore di inclusione',
    bargeInFailedData:
      'Si è verificato un errore durante il tentativo di inclusione. Riprovare più tardi.',
    supervisorBargedIn: 'ha fatto irruzione nella chiamata.',
    leftInteraction: 'ha abbandonato l\'interazione.',
    conferenceEnded: 'La chiamata in conferenza è terminata.',
    participants: 'Partecipanti',
    badgeAriaLabel: '{participant} è nella chiamata',
    bargeInConferenceAriaLabel: 'Due partecipanti nell\'interazione',
    taskName: 'Nome attività controllo interazione',
    interactionDurationLabel: 'Durata',
    wrapupassist: 'Riepilogo assistenza',
    consultingTaskContext: 'Chiamata di consultazione da',
    consultExited: 'Uscita dalla chiamata di consultazione',
    endCall: 'Terminare la chiamata.',
    exitconferenceCall:
      'Uscire dalla chiamata. La conferenza continuerà con i partecipanti attivi.',
    recordingInProgess: 'Registrazione in corso',
    recordingPaused: 'Registrazione sospesa',
    searchPlaceholder: 'Cerca contatti',
    postCall: "Chiamata successiva",
    switchCallTooltip: "Passa alla chiamata",
    switchConsultTooltip: "Passa alla chiamata di consulenza",
    switchConferenceTooltip: "Passa alla chiamata in conferenza",
    confirmationDialog: {
      endCallTitle: 'Terminare la chiamata?',
      endCallMessage: 'Fare clic su Conferma per terminare la chiamata per tutti i partecipanti.',
      exitConferenceTitle: 'Uscire dalla chiamata in conferenza?',
      exitConferenceMessage:
        'Fare clic su Conferma per uscire dalla chiamata in conferenza e consentire agli altri partecipanti di continuare.',
      confirmButtonLabel: "Conferma",
      cancelButtonLabel: "Annulla",  
    },
    postCallOnHold: "Chiamata successiva in attesa",
    postCallConsult: "Consulenza post chiamata",
    postCallConsultOnHold: "Consulenza post chiamata in attesa",
  },
  agentProfile: {
    teamName: 'Team',
    dialNumber: 'Componi numero',
    phoneNumber: 'Numero di telefono',
    settings: 'Modifica impostazioni',
    signOut: 'Disconnetti',
    webRTCDisconnected: 'Avvertenza Telefonia desktop disconnessa ',
    msAuthFailed: 'Autenticazione Microsoft non riuscita',
    stateSyncFailed: 'Sincronizzazione dello stato non riuscita',
    userProfileLabel: 'Profilo utente',
    ariaAgentprofile: 'Profilo agente',
    ChannelCapacity: 'Capacità canale',
    voice: 'Voce',
    chat: 'Chat',
    email: 'E-mail',
    social: 'Social',
    channelCapacityTooltip: 'Fare clic per visualizzare altro',
    blendedRouting: 'Mista',
    exclusiveRouting: 'Indirizzamento esclusivo',
    realtimeRouting: 'Indirizzamento misto in tempo reale',
    blendedRoutingTooltip: 'Gestire più contatti in tutti i canali.',
    exclusiveRoutingTooltip: 'Gestire un solo contatto alla volta.',
    realtimeRoutingTooltip: 'Gestire un canale obbligatorio in tempo reale.',
    errorActiveContacts:
      'Impossibile disconnettersi adesso perché l\'utente ha conversazioni attive. Completarle e riprovare.',
    searchTeams: 'Cerca team',
    changeTeamsConfirmHeader: 'Conferma Cambia team',
    changeTeamsConfirmMessage: 'Cambiare team?',
    changeTeamLabel: 'Cambia team',
    errorChangeTeams:
      'Impossibile cambiare team adesso perché l\'utente ha richieste attive. Completarle e riprovare.',
    saveTeamSelection: 'Salva selezione team',
    userSettings: 'Impostazioni utente',
    resetLayout: 'Ripristina interno layout Desktop',
    resetConfirmHeader: 'Conferma ripristina layout',
    resetConfirmMessage:
      'Ripristinare l\'intero layout Desktop? <br/> Desktop tornerà nel suo layout predefinito.',
    downloadLogs: 'Scarica report errori',
    help: 'Guida',
    signoutConfirm: 'Disconnettersi?',
    signoutConfirmHeader: 'Conferma disconnessione',
    darkTheme: 'Passa a modalità scura',
    newLook: 'Passa a nuovo aspetto',
    keyboardShortcuts: 'Tasti di scelta rapida',
    keyboardShortcutCombination: 'CTRL+Alt+F',
    errorReportCombination: 'CTRL+MAIUSC+2',
    notificationSettings: 'Impostazioni notifiche',
    silentNotification: 'Notifica silenziosa',
    enableNotificationSettings: 'Abilita notifiche',
    enableSilentNotificationSettings: 'Abilita notifiche silenziose',
    suppressWebexCallingNotificationSettings: 'Nascondi notifiche Webex Calling',
    notificationSettingDescription:
      'Invia notifiche quali nuovi messaggi, avvisi e modifiche di stato.',
    silentNotificationDescription:
      'Disattiva gli avvisi su schermo. È possibile visualizzare le notifiche nel Centro notifiche.',
    suppressWebexCallingNotificationDescription: 
    'Evita di mostrare le notifiche popup per le chiamate Webex in ingresso e consente di rispondere tramite Webex Contact Center.',
    arrowLabel: 'Torna indietro',
    managedTeams: 'Team gestiti',
    managedTeamsError: 'Impossibile caricare i team.',
    viewAll: 'Visualizza tutto',
    profileSettings: 'Impostazioni profilo',
    userRole: 'Ruolo',
    saveSelection: 'Salva selezione',
    extension: 'Interno',
    changeProfileConfirmHeader: 'Conferma modifiche impostazioni profilo',
    changeProfileConfirmMessage:
      'Salvare le modifiche al profilo?',
    confirm: 'Conferma',
    errorProfileUpdate:
      'Impossibile modificare le impostazioni del profilo adesso perché l\'utente ha richieste attive. Completarle e riprovare.',
    roleAgentSupervisor: 'Supervisore e agente',
    roleSupervisor: 'Supervisore',
    noTeam: 'Nessun team',
    testYourNetwork: 'Verifica la rete',
    speakerAndMic: 'Altoparlante e microfono',
    speaker: 'Altoparlante',
    mic: 'Microfono',
    speakerDescription:
      'Selezionare e testare il dispositivo di output per accertarsi di sentire il chiamante.',
    micDescription:
      'Selezionare e testare il dispositivo di input per accertarsi che il chiamante senta il chiamato.',
    micError:
      'Accesso al microfono negato. Abilitare l\'accesso tramite le impostazioni del browser o contattare l\'amministratore.',
    speakerError:
      'Al momento l\'altoparlante non è disponibile perché l\'accesso al microfono è negato.',
    telephony: 'Telefonia',
    desktop: 'Desktop',
    onSpeakerPlay:
      'Se il suono di prova non si sente, controllare il dispositivo dell\'altoparlante.',
    onMicPlay:
      'Se il suono di prova non si sente, controllare sia l\'altoparlante che il microfono.',
    onMicRecord: 'Registrare un messaggio per la riproduzione.',
    test: 'Test',
    recording: 'Registrazione',
    playing: 'Riproduzione in corso',
    reconnecting: 'Riconnessione',
    disconnectMessage:
      'Telefonia desktop disconnessa. Provare a utilizzare un\'opzione di telefonia diversa.',
    singleTelephonyDisconnectMessage:
      'Telefonia desktop disconnessa. Contattare l\'amministratore.',
    clear: 'Cancella input',
    rememberMeCheckBoxMessage: "Non visualizzare nuovamente questo messaggio",
    saveLabel: 'Salva',
    browserUnsupportedError: "Accesso non riuscito perché il browser in uso non è supportato.",
    microphoneAccessDeniedError: "Accesso al microfono negato. Abilitare l\'accesso tramite le impostazioni del browser o contattare l\'amministratore.",
  },
  contactHistory: {
    mainHeader: 'Cronologia contatto',
    handledBy: 'Gestito da',
    noRecordFound: 'Nessuna cronologia contatti trovata.',
    tryAgain: 'Riprova',
    errorMsg: 'Impossibile recuperare la cronologia dei contatti. Riprovare.',
    errorID: 'ID errore',
    missingAni: 'ANI mancante',
    timeIcon: 'Durata',
    taskHandled: 'Attività gestita',
    noHistoryNew: 'Nessuna cronologia',
    noHistory: 'Nessuna cronologia',
    viewTranscript: 'Visualizza messaggio e-mail',
    transcriptFor: 'Trascrizioni per',
    editBeforeCall: 'Modifica prima di chiamare',
    clickToCall: 'Fai clic per chiamare',
    onAnActiveCallErrorMessage:
      'Non è possibile avviare una nuova chiamata mentre si è già impegnati in una chiamata attiva.',
    receivedFrom: 'Contatto ricevuto da',
    initiatedTo: 'Contatto avviato con',
    wrapUpReason: 'Motivo riepilogo',
    startCallTelephony:
      'Fare clic sul collegamento del numero di telefono per avviare una chiamata in uscita.',
    contactHistoryList: 'Elenco cronologia contatti',
    wrapUpCode: 'Codice di wrapup',
    agentName: 'Nome dell\'agente',
    entryPointName: 'Punto di accesso',
    acceptedTimeAndDate: 'Date e ora accettazione',
    duration: 'Durata',
    emailTranscript: 'Invia trascrizione via e-mail',
    clickToViewEmailTranscript: 'Fare clic per visualizzare la trascrizione dell\'e-mail',
    listContainer: 'Container elenco'
  },
  contactTranscript: {
    agent: 'Agente',
    entryPoint: 'Punto di accesso',
    date: 'Data',
    subject: 'Oggetto',
    from: 'Da',
    sent: 'Inviato',
    to: 'A',
    back: 'Indietro',
    errorTranscript: 'Si è verificato un errore durante il recupero delle trascrizioni',
    customer: 'Cliente',
    inboundErrorMessage: 'Impossibile caricare l\'e-mail del cliente',
    outboundErrorMessage: 'Impossibile caricare la risposta dell\'agente'
  },
  popoverTitle: {
    callback: 'Richiamata',
    outboundCall: 'Chiamata in uscita',
    incomingCall: 'Chiamata in arrivo',
    progressiveCampaign: 'Chiamata campagna',
    courtesyCallback: 'Richiamata di cortesia',
    chat: 'Chat in entrata',
    incoming: 'In arrivo',
    monitoringCall: 'Monitoraggio delle chiamate'
  },
  connecting: 'Connessione in corso',
  initiating: 'Avvio in corso',
  outbound: 'In uscita',
  transfer: {
    title: 'Richiesta di trasferimento',
    heading: {
      chat: 'Selezionare l\'agente o la coda per il trasferimento.',
      email: 'Selezionare la coda per il trasferimento.',
      telephony:
        'Selezionare l\'agente, la coda o il numero da chiamare per il trasferimento.',
      noQueueTelephony:
        'Selezionare l\'agente o il numero da chiamare per il trasferimento.'
    },
    header: {
      chat: 'Selezionare l\'agente o la coda per il trasferimento di questo contatto.',
      email: 'Selezionare la coda per il trasferimento di questo contatto.',
      telephony:
        'Selezionare l\'agente, la coda, il numero da chiamare o l\'organizzazione per trasferire questo contatto.',
      noQueueTelephony:
        'Selezionare l\'agente, il numero da chiamare o l\'organizzazione per trasferire questo contatto.',
      noOrganizationTelephony:
        'Selezionare l\'agente, la coda o il numero da chiamare per trasferire questo contatto.',
      noQueueOrganizationTelephony:
        'Selezionare l\'agente o il numero da chiamare per trasferire questo contatto.'
    },
    queues: 'Coda',
    agents: 'Agente',
    dialNumber: 'Componi numero',
    organization: 'Organizzazione',
    placeholder: {
      Queues: 'Scegli da un elenco di code',
      Agents: 'Scegli da un elenco di agenti',
      DialNumber: 'Scegli per nome o numero',
      DialNumberOrEntryPoint: 'Scegli per nome/numero/punto di accesso',
      ChooseByNameOrNumber: 'Scegli per nome/numero',
      Organization: 'Cerca per nome/ruolo/reparto/telefono aziendale',
      WebexOrganization: 'Cerca per nome o e-mail',
      DialNumberSearch: 'Cerca per nome o numero'
    },
    type: 'Trasferisci',
    cancel: 'Annulla',
    closeModal: 'Chiudi finestra modale',
    failureError: 'Non è stato possibile trasferire la richiesta. Riprovare.',
    entryPoint: 'Punto di accesso'
  },
  consult: {
    title: 'Richiesta consulenza',
    heading: {
      chat: 'Selezionare l\'agente o la coda per il trasferimento.',
      email: 'Selezionare la coda per il trasferimento.',
      telephony:
        'Selezionare l\'agente, la coda o il numero da chiamare per la consulenza.',
      noQueueTelephony:
        'Selezionare l\'agente o il numero da chiamare per la consulenza.'
    },
    header: {
      chat: 'Selezionare l\'agente o la coda per il trasferimento di questo contatto.',
      email: 'Selezionare la coda per il trasferimento di questo contatto.',
      telephony:
        'Selezionare l\'agente, la coda, il numero da chiamare o l\'organizzazione per la consulenza.',
      noQueueTelephony:
        'Selezionare l\'agente, il numero da chiamare o l\'organizzazione per la consulenza.',
      noOrganizationTelephony:
        'Selezionare l\'agente, la coda o il numero da chiamare per la consulenza.',
      noQueueOrganizationTelephony:
        'Selezionare l\'agente o il numero da chiamare per la consulenza.'
    },
    queues: 'Coda',
    agents: 'Agente',
    dialNumber: 'Componi numero',
    organization: 'Organizzazione',
    placeholder: {
      Queues: 'Scegli da un elenco di code',
      Agents: 'Scegli da un elenco di agenti',
      DialNumber: 'Scegli per nome o numero',
      DialNumberOrEntryPoint: 'Scegli per nome/numero/punto di accesso',
      ChooseByNameOrNumber: 'Scegli per nome/numero',
      Organization: 'Cerca per nome/ruolo/reparto/telefono aziendale',
      WebexOrganization: 'Cerca per nome o e-mail',
      DialNumberSearch: 'Cerca per nome o numero'
    },
    type: 'Consulta',
    checkBoxLabel: 'Consentire ai partecipanti di continuare a interagire.',
    cancel: 'Annulla',
    closeModal: 'Chiudi finestra modale',
    failureError: 'Impossibile connettere la richiesta di consulenza. Riprovare.',
    customerLeftMsg: 'Cliente disconnesso. La consulenza non è più necessaria.',
    ctqFailureMsg:
      'Impossibile annullare la chiamata di consulenza nella coda. Riprovare.',
    cancelCtqInfo:
      'Ricerca di un agente disponibile nella coda selezionata. Attendere o annullare la richiesta di consulenza.',
    cancelCtqAction: 'Annulla consulenza.',
    entryPoint: 'Punto di accesso'
  },
  conference: {
    title: 'Richiesta di conferenza',
    heading: {
      chat: 'Selezionare un agente specifico per chat in conferenza'
    },
    queues: 'Coda',
    agents: 'Agente',
    dialNumber: 'Componi numero',
    organization: 'Organizzazione',
    placeholder: {
      Queues: 'Scegli da un elenco di code',
      Agents: 'Scegli da un elenco di agenti',
      DialNumber: 'Scegli per nome o numero'
    },
    type: 'Conferenza',
    cancel: 'Annulla',
    closeModal: 'Chiudi finestra modale',
    failureError: 'Impossibile avviare la richiesta di conferenza. Riprovare.'
  },
  transferModal: {
    Agents: 'Impossibile recuperare l\'elenco degli agenti. Aggiornare l\'elenco.',
    AgentsEmpty: 'Nessun agente disponibile',
    Queues: 'Impossibile recuperare l\'elenco delle code. Aggiornare l\'elenco.',
    QueuesEmpty: 'Nessuna coda disponibile',
    EPEmpty: 'Nessun punto di accesso disponibile',
    DialNumber:
      'Impossibile recuperare l\'elenco dei numeri da chiamare dalla rubrica. Aggiornare l\'elenco.',
    EntryPoint:
      'Impossibile recuperare l\'elenco dei numeri dei punti di accesso. Aggiornare l\'elenco.',
    Common: 'Impossibile recuperare l\'elenco. Aggiornare l\'elenco.',
    DialNumberEmpty: 'Nessun numero da chiamare disponibile',
    DialNumbInvalid:
      'Il numero da chiamare non è valido. Contattare l\'amministratore.',
    DialNumbOrEntryPointInvalid:
      'Numero da chiamare/Punto di accesso non valido. Contattare l\'amministratore.',
    refreshQueueList: 'Aggiorna l\'elenco delle code',
    refreshAgentList: 'Aggiorna l\'elenco degli agenti',
    refreshEpList: 'Aggiorna i punti di accesso',
    refreshAddressBook: 'Aggiornare la rubrica',
    refreshTheList: 'Aggiorna l\'elenco',
    entryPointSectionLabel: 'Punto di accesso',
    addressBookSectionLabel: 'Rubrica',
    organization: 'Organizzazione',
    comboBoxAriaLabelAgent: 'Scegli da un elenco di agenti',
    comboBoxAriaLabelQueue: 'Scegli da un elenco di code',
    comboBoxAriaLabelEp: 'Scegli da un elenco di punti di accesso',
    infScrollAgent: 'Cerca agenti',
    infScrollQueue: 'Cerca code',
    infScrollEP: 'Cerca punti di accesso',
    allRadioButtonHidedTextForConsult: 'Non ci sono entità assegnate per la consulenza in questa interazione. Contattare l\'amministratore.',
    allRadioButtonHidedTextForTransfer: 'Non ci sono entità assegnate per il trasferimento in questa interazione. Contattare l\'amministratore.',
    allRadioButtonHidedTextForConference: 'Non ci sono entità assegnate per la conferenza in questa interazione. Contattare l\'amministratore.',
    searchMinCharError: 'Immettere almeno tre caratteri per effettuare la ricerca.',
  },
  wrapup: {
    cancelautowrapup: 'Annulla wrapup automatico',
    wrapupreason: 'Motivi riepilogo',
    untilautowrapup: 'fino al riepilogo automatico',
    followupsetting: 'Impostazione follow up',
    lastagentroute: 'Ultimo smistamento agente',
    submitwrapup: 'Invia riepilogo',
    wrapupsearch: 'Cerca motivo riepilogo',
    invalidationError: 'Impossibile avviare il riepilogo',
    searchResult: 'Risultati della ricerca disponibili',
    noResultFound: 'Nessun risultato della ricerca trovato',
    listContainerLabel: 'Container elenco dati di riepilogo',
    searchError: 'Inserire un minimo di tre caratteri per cercare i motivi riepilogo.',
  },

  outdial: {
    call: 'Chiama',
    dialpadSearch: 'Componi numero',
    addressSearch: 'Cerca nome/numero',
    addressTab: 'Indirizzo',
    addressTabTooltip: 'Cerca in rubrica',
    dialpadTab: 'Tastiera',
    dialpadTooltip: 'Chiama un numero',
    searchTab: 'Cerca',
    searchTabTooltip:'Cerca persone nella mia organizzazione',
    noAdrFound: 'Nessuna corrispondenza trovata',
    noContacts: 'Nessun contatto',
    mainIconTooltip: 'Chiamata in uscita',
    errorOutdialFailed:
      'Chiamata in uscita non riuscita. Desktop non è stato in grado di connettere la chiamata o la chiamata non ha ricevuto risposta.',
    errorOutdialDisabled: 'Le chiamate in uscita sono disabilitate',
    errorDialPadValidationMessage: 'Formato non corretto',
    outdialReqInProgress: 'Chiamata in uscita in corso',
    outdialAniPlaceholder: 'Seleziona chiamata in uscita (ANI)',
    outdialAniLabel: 'Chiamate in uscita ANI',
    outdialAniPlaceHolder: 'Cerca ANI chiamate in composizione esterna',
    errorDcCallsLimitExceeded:
      'Il centro dati ha raggiunto il limite massimo per le chiamate in uscita. Impossibile effettuare altre chiamate in uscita',
    errorOrgCallsLimitExceeded:
      'L\'organizzazione ha raggiunto il limite massimo per le chiamate in uscita. Impossibile effettuare altre chiamate in uscita.',
    errorOutDialNoAnswerFromCustomer:
      'Il cliente non ha risposto alla chiamata. Provare a chiamare più tardi.',
    errorOutDialCustomerUnavailable:
      'Il cliente non è disponibile al momento. Provare a chiamare più tardi.',
    errorOutDialAgentEnds: 'La chiamata con il cliente è terminata.',
    errorOutDialCustomerBusy: 'Il cliente è occupato. Provare a chiamare più tardi.',
    searchError: 'Immettere almeno tre caratteri per cercare i contatti.',
    upArrowLabel: 'Espandi',
    clear: 'Cancella input',
    outdialDialogDescription: 'Attualmente è visualizzata la finestra di dialogo con le schede.'
  },

  organization: {
    noMatchFound: 'Nessuna corrispondenza trovata',
    searchError: 'Immettere almeno tre caratteri per cercare i contatti.',
    authError: 'Nessun contatto da visualizzare. Autenticazione Microsoft non riuscita.'
  },

  interactionPopover: {
    of: 'di',
    accept: 'Accetta',
    acceptAriaLabel: 'Accetta attività {taskNumber} - {taskType} da {from}',
    requests: 'Richiesta/e',
    back: 'indietro',
    next: 'avanti',
    acceptMultipleRequest: 'Accetta {requestCount} richieste',
    paginationDetail: '{indexStart}-{indexEnd} di {totalPopoverpoolLength}',
    hidePopoverDetails: 'Nascondi dettagli popover',
    showPopoverDetails: 'Mostra dettagli popover',
    customerName: 'Nome cliente',
    email: 'E-mail',
    queueName: 'Nome coda',
    failedToAccept: 'Impossibile accettare.',
    unableToAccept: 'Impossibile accettare il contatto.',
    failedToEnd: 'Impossibile terminare.',
    unableToEnd: 'Impossibile terminare il contatto. ',
    ringing: 'Squillo',
    calling: 'Chiamata in corso',
    phoneNumber: 'Numero di telefono',
    dni: 'DNIS',
    ivrPathId: 'ID percorso IVR',
    pathId: 'ID percorso',
    rona: 'RONA',
    sourcePage: 'Pagina di origine',
    sourceNumber: 'Numero di origine',
    appUserId: 'ID utente app',
    acceptAll: 'Accetta tutte le attività',
    agentDn: 'DN agente',
    agentName: 'Nome operatore',
    agentTeam: 'Team di agenti',
    requestDetails: 'Dettagli richiesta',
    incomingCallFrom: 'Chiamata in arrivo da',
    unableToAnswer: 'Impossibile rispondere alla chiamata. Riprovare.',
    unableToDecline: 'Impossibile rifiutare la chiamata. Riprovare.'
  },

  multiLogin: {
    header: 'Avviso accesso multiplo',
    message:
      'È stato eseguito l\'accesso al desktop in più istanze dell\'applicazione. Fare clic su Continua per procedere con il desktop in questa istanza dell\'applicazione. Altrimenti, chiudere la finestra.',
    continue: 'Continua'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Il trasferimento al punto di ingresso/alla coda non è riuscito a causa di un errore di configurazione.',
    1010: "Impossibile eseguire la consulenza in quanto non è stato possibile assegnare l\'agente in tempo. ",
    1042: "Il contatto non è stato trovato",
    1043: 'La destinazione non è valida.',
    1045: 'L\'interazione non è assegnata all\'agente.',
    1046: 'Consulenza con l\'agente non riuscita: non è stato trovato nessun canale agente corrispondente nel sistema.',
    1038: "L\'agente non è stato trovato",
    1037: 'Accesso non riuscito a causa di un errore interno.',

    // Media Events
    138: 'Azione non riuscita per motivi sconosciuti.',
    136: 'L\'utente non è stato trovato',

    // AgentConsultFailed
    1050: 'Impossibile eseguire la consulenza a causa di una configurazione o attività non supportata nel flusso. ',
    1005: "Impossibile eseguire la consulenza in quanto l\'agente non ha risposto in tempo alla richiesta.",
    1051: 'Impossibile eseguire la consulenza o il trasferimento a causa di un punto di accesso o numero da chiamare non valido.',

    // AgentInviteFailed
    1053: 'Impossibile presentare l\'interazione a causa di un\'attività di riaccodamento del flusso di lavoro in sospeso.',
    1054: 'Impossibile effettuare una chiamata in composizione esterna a causa di problemi del supporto con questa richiesta. ',

    // AgentContactAssignFailed
    1011: 'Impossibile rispondere o accettare la chiamata a causa di agenti mancanti nell\'interazione in corso. ',

    // ContactCallbackFailed
    1034: 'La richiamata del contatto non è riuscita perché per la richiesta è stato ricevuto ContactParkTimeout.',

    // ContactUpdateFailed
    1020: "Impossibile aggiornare le variabili in quanto uno dei valori supera il limite di 256 caratteri. Ridurre il numero di caratteri e riprovare.",

    // AgentInviteFailed
    1031: 'L\'agente ha invitato il cliente dopo che la richiamata è stata richiesta.',

    // AgentBlindTransferFailedEvent
    1044: 'Il trasferimento cieco dell\'agente non è riuscito in quanto l\'agente di destinazione è assegnato a un\'altra interazione.',

    // AgentCtqCancelFailed
    1047: "Il contatto non è stato trovato.",

    // AgentCtqFailed
    1048: "Il gruppo di distribuzione della chiamata non è configurato.",
    1049: 'È stato superato il tempo massimo di attesa in coda.',
    // StationLoginFailed
    127: 'Errore di registrazione del DN agente con eccezione per accesso duplicato.'
  },

  stateSelector: {
    Available: 'Disponibile',
    errorstatechange: 'Modifica dello stato non riuscita. Riprovare.',
    errorStateChangeInPendingLogout: 'Impossibile modificare lo stato dell\'agente a causa del logout in sospeso.',
    label: 'Stato disponibilità',
    agentStateSelector: 'Selettore stato dell\'agente',
    Engaged: 'Impegnati',
    engagedAvailableInfo:
      'Al momento si è impegnati in un\'interazione e in stato Disponibile.',
    engagedIdleInfo:
      'Al momento si è impegnati in un\'interazione e in stato Inattivo',
    engagedInfo: 'Al momento si è impegnati in un\'interazione.',
    engagedSupervisorStateChange: 'ha modificato lo stato in',
    axAgentStateChanged: 'Lo stato è stato modificato in',
    axAgentSync: 'a causa della sincronizzazione dello stato con lo strumento di collaborazione.',
    engagedPresenceInfo:
      'Al momento si è impegnati in un\'interazione e il proprio stato è',
    engagedPresenceSync: 'a causa della sincronizzazione dello stato con lo strumento di collaborazione.',
    clear: 'Cancella input',
    searchState: 'input',
    agentStatusLabel: 'Stato agente',
    agentStateLabel: 'Agente in stato {selectedState} per gli ultimi/le ultime {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Agente in stato {selectedState} per gli ultimi 0 sec',
    agentStateChangeSuccessful:'Modifica dello stato in {selectedState} riuscito.',
    agentStateChangeFail:'Modifica dello stato in {selectedState} non riuscito.',
    searchError: 'Inserire almeno tre caratteri per cercare gli stati.'
  },

  warningMessage: {
    header: 'Modifiche non salvate',
    message:
      'Alcune modifiche non sono state salvate. Abbandonare dalla pagina? ',
    cancelButton: 'Rimani',
    saveButton: 'Abbandona'
  },

  notificationLables: {
    muteVolume: 'Disattiva l\'audio della notifica',
    unmuteVolume: 'Attiva l\'audio della notifica',
    notificationVolume: 'Volume notifica',
    playSound: 'Riproduci audio notifica',
    enableSoundNotificationSettings: 'Abilita notifiche audio',
    enableSoundNotificationSettingsDescription:
      'Invia notifiche audio perle richieste in arrivo. È possibile regolare il volume qui sotto.',
    volumeTitle: 'Volume audio'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Chiamata',
    chat: 'Chat',
    email: 'E-mail',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Messaggi aziendali di Google"
  },
  orgDetailsLabels: {
    role: 'Ruolo',
    department: 'Reparto',
    email: 'E-mail',
    businessPhone: 'Telefono aziendale',
    workPhone: 'Ufficio',
  },
  addressListError: {
    title: 'Impossibile caricare i dati',
    errorId: 'ID errore:'
  },
  keypad: {
    keyPadSearch: 'Immettere il numero',
    dialPad: 'Tastierino numerico'
  },
  collabTool: {
    userAuthenticated: 'Autenticazione utente',
    successful: 'Operazione riuscita',
    failed: 'Non riuscito.',
    tryAgain: 'Riprova',
    stateSync: 'Stato sincronizzazione:',
    mercuryFailedInfo: ' Contattare l\'amministratore.',
    retrying: 'Nuovo tentativo...',
    trackingIdLabel: 'ID monitoraggio: '
  },
  webex: {
    webex: 'Webex',
    info: 'L\'integrazione consente di sincronizzare gli stati tra Desktop e Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Con questa integrazione è possibile consultare o trasferire chiamate agli utenti di Microsoft Teams.',
    authenticationFailedInfo:
      'Se è già aperta una finestra di autenticazione, riprovare a eseguire l\'autenticazione.',
    ListItemContactDetails:
      'Il nome del contatto è: {name}, la sua presenza è: {presence}, il reparto è: {department}, la qualifica è: {jobTitle} e il numero di telefono è: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Notifica servizio di emergenza',
    readNotification: 'Ho letto la notifica.'
  },
  webexPresenceStatus: {
    active: 'Attivo',
    lastActiveFewMinutesAgo: 'Attivo negli ultimi minuti',
    lastActiveMinutesAgo: 'Attivo {min} minuti fa',
    lastActive1HourAgo: 'Ultima attività 1 ora fa',
    lastActiveHoursAgo: 'Attivo {hour} ore fa',
    lastActiveYesterday: 'Attivo ieri',
    lastActiveOnDate: 'Attivo in data {date}',
    busy: 'Occupato',
    busyUntil: 'Occupato fino alla data {date}',
    dnd: 'Non dist.',
    dndUntil: 'Non disturbare fino alla data {date}',
    quiet: 'Silenzioso',
    quietUntil: 'Silenzioso fino alla data {date}',
    ooo: 'Fuori sede',
    outOfOfficeUntil: 'Fuori sede fino alla data {date}',
    call: 'In chiamata',
    meeting: 'In riunione',
    calendarItem: 'In una riunione di calendario',
    presenting: 'Presentazione',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Ricerca per nome o dettagli del profilo',
    webexPlaceholder: 'Cerca per nome o e-mail',
    refreshTheList: 'Aggiorna l\'elenco',
    refreshAddressBook: 'Aggiornare la rubrica',
    microsoftAuthError: 'Nessun contatto da visualizzare. Autenticazione Microsoft non riuscita.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/ja.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/ja.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'データのロードに失敗しました',
    errorID: 'エラー ID',
    tryAgain: 'もう一度やり直してください',
    Error: 'エラー',
    okButton: 'OK',
    Yes: 'はい',
    Cancel: 'キャンセル',
    Confirm: '確認',
    Continue: '続行',
    Canceling: 'キャンセルしています',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: '応答',
    AnswerAriaLabel: 'デスクトップタスクに応答する',
    Decline: '拒否',
    ErrorSecurityCompliance: 'セキュリティのコンプライアンス',
    errorDetails: 'エラーの詳細',
    learnMore: '詳細',
    showLess: '表示を減らす',
    trackingIdDescription:
      '追跡 ID を管理者またはサポートチームと共有して、状況を調査してください。',
    trackingIdInputLabel: 'トラッキング ID: ',
    submitForm: '送信者:',
    unnamedStatus: '名前のない状態',
    errorChatMsg: 'データのロードに失敗しました',
    noOptions: 'オプションなし',
    noResults: '検索結果がありません',
    more: '詳細の表示',
    nomatchfound: '一致するものが見つかりませんでした',
    collaborationTool: 'コラボレーションツール',
    timerAriaLabel: '費やした時間',
    historyItemTime: '発生日時',
    loading: 'ロード中',
    months: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月'
    ],
    loadingMsg: '読み込み中...',
    search: '検索',
    historyChannelLabels: {
      All: '全て',
      telephony: '音声',
      chat: 'チャット',
      email: 'Eメール',
      social: 'ソーシャル'
    },
    homePageLabel: 'ホームページ',
    resizeHistoryDragger: 'サイズ変更履歴ドラッガー',
    agentHistoryLabel: 'エージェントの履歴',
    clear: '入力をクリア',
    ariaLabelAgentHistoryWrapper:
      'エージェントの対話履歴は、過去 24 時間における、さまざまなチャネル全体での最近の顧客コミュニケーションを表示します。',
    sliderResizerInstructions:
      '現在スライダを使って移動しています。サイズを変更するに矢印キーを使ってください',
    resizeHistoryPanel: '履歴パネル、スライダのサイズを変更する',
    time: {
      hours: '時間',
      minutes: '最小値',
      seconds: '秒'
    }
  },
  email: {
    ToLabel: '送信先',
    FromLabel: '差出人',
    CcLabel: 'Cc',
    BccLabel: 'Bcc',
    SubjectLabel: '件名',
    HideLabel: '隠す',
    SendLabel: '送信',
    ShowPrevThread: '前のスレッドを表示',
    HidePrevThread: '前のスレッドを非表示',
    ReplyLabel: '返信',
    ReplyAllLabel: '全員に返信',
    ViewOriginalMail: '元のメールを表示',
    QuickReplyInp: 'クイック返信はここに入力…',
    AttachFiles: 'ファイルを添付',
    ToolbarHeading: '見出し 1',
    ToolbarBold: '太字',
    ToolbarItalic: 'イタリック',
    ToolbarUnderLine: '下線',
    ToolbarBlockQuote: 'ブロッククォート',
    ToolbarCode: 'コードのブロック',
    ToolbarListOrder: '注文リスト',
    ToolbarListBullet: '箇条書きリスト',
    ToolbarLink: 'リンク',
    ToolbarStrike: '取り消し線',
    ToolbarColor: 'テキストの色',
    ToolbarTable: '表',
    insertTable: '表の挿入',
    insertRowAbove: '上に行を挿入',
    insertRowBelow: '下に行を挿入',
    insertColumnLeft: '左に列を挿入',
    insertColumnRight: '右に列を挿入',
    deleteRow: '行の削除',
    deleteColumn: '列の削除',
    deleteTable: '表の削除',
    link: 'リンク',
    IndentRight: '右インデント',
    IndentLeft: '左インデント',
    showMoreAttachment: 'その他の添付ファイルを表示',
    AttachmentLimit: '添付制限 ',
    attachments: ' 添付ファイル、 ',
    sizeLimit: ' 最大 MB',
    attachment: '添付ファイル',
    errordeleteattachment: 'ファイルを削除できません。もう一度やり直してください。',
    errordownloadattachment: 'ファイルをダウンロードできません。もう一度やり直してください。',
    erroraddattachemnt: 'ファイルをアップロードできません。もう一度やり直してください。',
    errorendcontact: 'インタラクションを終了できません。もう一度やり直してください。',
    erroraddlimitreached:
      '最大値を超えているため、ファイルを添付できませんでした ',
    errorattachmentdrop:
      '会社のセキュリティポリシーにより、添付ファイルが削除されました。',
    errorfiletype: 'サポートされていないファイルの種類です。もう一度やり直してください。',
    errorcreditcard:
      '会社のセキュリティポリシーにより、添付ファイルをアップロードできませんでした。',
    errorcontainsimage:
      '添付ファイルをアップロードできません。添付ファイルの画像は、会社のセキュリティーポリシーではサポートされていません。',
    errorlimit: ' MB 制限。',
    errorsendemail: 'メールを送信できません。もう一度やり直してください。',
    errorpcicheckemail: 'PCI データを取得できません。もう一度やり直してください。',
    errortext: 'データのロードに失敗しました',
    tryAgain: 'もう一度やり直してください',
    replywarning:
      '健康や財産、個人を特定できる情報(Pll)をこのメッセージまたは添付ファイルで共有しないでください。',
    datamasked:
      'メールの件名または本文は、会社のセキュリティポリシーにより編集されます。メールを送信してもよろしいですか?',
    pcibannerwarning:
      'メールの件名または本文は、会社のセキュリティポリシーにより編集されます。',
    on: 'オン',
    wrote: '書き込み済み'
  },
  interaction_control: {
    windowOpened: 'ウィンドウが開きました',
    connected: '接続済み',
    consultRequested: 'リクエストされたコンサルト',
    consulting: 'コンサル',
    consultCallOnHold: 'コンサルト保留中',
    callOnHold: '通話保留中',
    consult: 'コンサルト',
    endconsult: 'コンサルトの終了',
    hold: '保留',
    transfer: '転送',
    conference: '会議',
    endconference: '電話会議の終了',
    conferenceRequested: 'リクエストされた電話会議',
    switchCall: 'スイッチ',
    mergeCall: 'マージ',
    wrapup: 'ラップアップ',
    end: '終了',
    customername: '顧客名',
    dn: 'DNIS',
    ivrpath: 'IVR パス',
    email: '顧客のメール',
    ani: '電話番号',
    queueid: 'キュー名',
    ronatimeout: 'ロナタイム',
    pathid: 'IVR パス ID',
    dnis: 'DNIS',
    destagentphonenumber: 'エージェント DN',
    destagentname: 'エージェント名',
    virtualteamname: 'キュー',
    category: '分類',
    additionaldetails: '追加詳細',
    sourcenumber: 'ソース番号',
    sourcepage: 'ソースページ',
    appuser: 'アプリユーザ ID',
    customernumber: '電話番号',
    exitconference: '電話会議の終了',
    resume: '再開',
    pauserecording: '録音の一時停止',
    resumerecording: '録音の再開',
    exitconsult: 'コンサルトの終了',
    pauseRecordingFailed: '録音を一時停止できません。もう一度やり直してください。',
    resumeRecordingFailed: '録音を再開できません。もう一度やり直してください。',
    holdCallFailed: '通話を保留できません。もう一度やり直してください。',
    resumeCallFailed: '通話を再開できません。もう一度やり直してください。',
    endCallFailed: 'インタラクションを終了できません。もう一度やり直してください。',
    consultTransferFailed:
      'コンサルトコールを転送できません。もう一度やり直してください。',
    conferenceTransferFailed:
      '電話会議を転送できません。もう一度やり直してください。',
    conferenceFailed:
      '会議のリクエストに接続できません。もう一度やり直してください。',
    consultEndFailed: 'コンサルトのリクエストを終了できません。もう一度やり直してください。',
    conferenceExitFailed:
      '会議のリクエストを終了できません。もう一度やり直してください。',
    conferenceEndFailed:
      '会議のリクエストを終了できません。もう一度やり直してください。',
    cancelCtqFailed:
      'キューへのコンサルトをキャンセルできません。もう一度やり直してください。',
    privacyShield: 'プライバシーシールド',
    errorOnPrvacyShieldForConsult:
      '現在、録音は一時停止しています。録音を再開して、コンサルトコールを開始してください。',
    errorOnPrvacyShieldForTransfer:
      '現在、録音は一時停止しています。録音を再開して、コールの転送を開始してください。',
    cancelConsult: 'コンサルトのキャンセル',
    cancelTransfer: '転送のキャンセル',
    copy: 'コピー',
    copied: 'コピー済み',
    cadrequestuccess: '顧客情報が正常に保存されました。',
    cadrequestfailure: '顧客情報の保存に失敗しました。後でお試しください。',
    cadupdatedmessage: '顧客情報は最近、以下によりアップデートされました。',
    unsavedmessage: '保存されていない変更は上書きされます。',
    save: '保存',
    revert: '元に戻す',
    expandDetails: '詳細を開く',
    collapseDetails: '詳細を閉じる',
    cadValidationError:
      '無効な形式。日付と時刻には国際標準を使用します。',
    secureCadSaveError:
      '顧客情報は保存されていません。[保存] をクリックして再試行してください。',
    secureDecryptionError: '安全な変数は表示できません。',
    clickToTry: 'クリックして再試行',
    isSecureVariable: 'は安全な変数です',
    contactorigin: 'コンタクト元',
    resumeMonitoring: 'モニタリングの再開',
    pauseMonitoring: 'モニタリングの一時停止',
    whisperCoach: 'ウィスパーコーチ',
    bargeIn: '割り込み',
    endMonitoring: 'モニタリングの終了',
    contactphonenumber: 'コンタクト電話番号',
    contactqueue: '連絡先キュー',
    activeparticipants: 'アクティブな参加者',
    consultedparticipant: 'コンサルトされた参加者',
    contactstatus: '連絡先状況',
    timeincontactstatus: '連絡先状況の時間',
    totalcontactduration: '連絡先継続時間の合計',
    agentinteractiontime: '対話時間',
    recording: '録音',
    monitoring: 'モニタリング中',
    monitoringPaused: '一時停止済みモニタリング',
    pauseMonitoringFailed: 'モニタリングを一時停止できません。もう一度やり直してください。',
    resumeMonitoringFailed: 'モニタリングを再開できません。もう一度やり直してください。',
    callCancelledInProgress: 'コールのキャンセルが進行中です',
    bargedIn: '割り込み',
    keypad: 'キーパッド',
    mute: 'ミュート',
    unmute: 'ミュート解除',
    bargeInTooltipText:
      'マイクがオンになり、この顧客との対話に参加します',
    bargeInCompactTooltipText:
      '割り込みました。マイクがオンになり、この顧客とのインタラクションに参加します',
    bargeInTooltipDisabled: 'モニタリングを再開して割り込みを有効にしてください',
    bargeInFailedTitle: '割り込みに失敗しました',
    bargeInFailedData:
      '割り込み中にエラーが発生しました。しばらくしてからもう一度やり直してください。',
    supervisorBargedIn: 'あなたの通話に割り込みました。',
    leftInteraction: '対話終了しました。',
    conferenceEnded: '電話会議が終了しました。',
    participants: '参加者',
    badgeAriaLabel: '{participant} が通話に参加しています',
    bargeInConferenceAriaLabel: 'インタラクションには 2 人の参加者がいます',
    taskName: 'インタラクション コントロール タスク名',
    interactionDurationLabel: '継続時間',
    wrapupassist: 'ラップアップヘルプ',
    consultingTaskContext: 'コンサルティングコール元',
    consultExited: 'コンサルトコールが終了しました',
    endCall: '通話を終了します。',
    exitconferenceCall:
      '通話を終了すると、電話会議はアクティブな参加者と継続します。',
    recordingInProgess: '録音中',
    recordingPaused: '録音中断',
    searchPlaceholder: '連絡先の検索',
    postCall: "通話後",
    switchCallTooltip: "発信に切り替える",
    switchConsultTooltip: "コンサルトコールに切り替える",
    switchConferenceTooltip: "会議電話に切り替える",
    confirmationDialog: {
      endCallTitle: '通話を終了しますか?',
      endCallMessage: '[確認] をクリックして、すべての参加者の通話を終了します。',
      exitConferenceTitle: '会議電話を終了しますか?',
      exitConferenceMessage:
        '[確認] をクリックして会議電話を終了し、他の参加者が続行できるようにします。',
      confirmButtonLabel: "確認",
      cancelButtonLabel: "キャンセル",  
    },
    postCallOnHold: "ポストコールの保留",
    postCallConsult: "ポストコールのコンサルト",
    postCallConsultOnHold: "ポストコールのコンサルト保留中",
  },
  agentProfile: {
    teamName: 'チーム',
    dialNumber: 'ダイヤル番号',
    phoneNumber: '電話番号',
    settings: '設定の変更',
    signOut: 'ログアウト',
    webRTCDisconnected: '警告デスクトップ電話が切断されました ',
    msAuthFailed: 'Microsoft 認証に失敗しました',
    stateSyncFailed: '状態の同期が失敗しました',
    userProfileLabel: 'ユーザープロファイル',
    ariaAgentprofile: 'エージェントプロファイル',
    ChannelCapacity: 'チャネル容量',
    voice: '音声',
    chat: 'チャット',
    email: 'Eメール',
    social: 'ソーシャル',
    channelCapacityTooltip: 'クリックしてもっと表示',
    blendedRouting: '混合',
    exclusiveRouting: '排他的ルーティング',
    realtimeRouting: '混合ルーティングリアルタイム',
    blendedRoutingTooltip: '複数のチャンネルにわたって複数の連絡先を処理します。',
    exclusiveRoutingTooltip: '一度に処理するコンタクトは 1 件のみです。',
    realtimeRoutingTooltip: '1 つの必須のリアルタイム・チャネルを処理します。',
    errorActiveContacts:
      'アクティブの会話があるため、サインアウトできません。それらを完了してからやり直してください。',
    searchTeams: 'チームの検索',
    changeTeamsConfirmHeader: 'チーム変更の確認',
    changeTeamsConfirmMessage: 'チームの変更をしてもよろしいですか?',
    changeTeamLabel: 'チームの変更',
    errorChangeTeams:
      'アクティブなリクエストがあるため、現在チームを変更することはできません。それらを完了して、もう一度やり直してください。',
    saveTeamSelection: 'チーム選択の保存',
    userSettings: 'ユーザ設定',
    resetLayout: 'デスクトップレイアウト全体のリセット',
    resetConfirmHeader: 'レイアウト確認のリセット',
    resetConfirmMessage:
      'デスクトップレイアウト全体をリセットしてもよろしいですか? <br/> デスクトプはデフォルトのレイアウトに戻ります。',
    downloadLogs: 'エラーレポートをダウンロード',
    help: 'ヘルプ',
    signoutConfirm: 'ログアウトしてもよろしいですか？',
    signoutConfirmHeader: 'ログアウトの確認',
    darkTheme: 'ダークモードに切り替え',
    newLook: '新しい見た目に切り替える',
    keyboardShortcuts: 'キーボードのショートカット',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: '通知設定',
    silentNotification: 'サイレント通知',
    enableNotificationSettings: '通知を有効にする',
    enableSilentNotificationSettings: 'サイレント通知を有効にする',
    suppressWebexCallingNotificationSettings: 'Webex Calling の通知を非表示にする',
    notificationSettingDescription:
      '新しいメッセージ、アラート、ステータス変更などの通知をお知らせします。',
    silentNotificationDescription:
      '画面上のアラートをオフにします。通知は通知センターで確認できます。',
    suppressWebexCallingNotificationDescription: 
    '着信 Webex 通話に対してポップアップ通知を表示せず、Webex Contact Center を通じて応答します。',
    arrowLabel: '戻る',
    managedTeams: '監視対象チーム',
    managedTeamsError: 'チームのロードに失敗しました。',
    viewAll: 'すべて表示',
    profileSettings: 'プロファイルの設定',
    userRole: 'ロール',
    saveSelection: '選択の保存',
    extension: '内線',
    changeProfileConfirmHeader: 'プロファイルの設定変更の確認',
    changeProfileConfirmMessage:
      'プロファイルの変更を保存しますか?',
    confirm: '確認',
    errorProfileUpdate:
      'アクティブなリクエストがあるため、現在プロファイルの設定を変更することはできません。それらを完了して、もう一度やり直してください。',
    roleAgentSupervisor: 'スーパーバイザとエージェント',
    roleSupervisor: 'スーパーバイザ',
    noTeam: 'チームなし',
    testYourNetwork: 'ネットワークのテスト',
    speakerAndMic: 'スピーカーとマイク',
    speaker: 'スピーカー',
    mic: 'マイクロフォン',
    speakerDescription:
      '出力デバイスを選択してテストし、発信者の声が聞こえることを確認します。',
    micDescription:
      '入力デバイスを選択してテストし、発信者に自分の声が聞こえることを確認します。',
    micError:
      'マイクへのアクセスが拒否されています。ブラウザの設定でアクセスを有効にするか、管理者に問い合わせてください。',
    speakerError:
      'マイクへのアクセスが拒否されているため、スピーカーは現在使用できません。',
    telephony: '電話',
    desktop: 'デスクトップ',
    onSpeakerPlay:
      'テスト音が聞こえない場合は、スピーカーデバイスを確認します。',
    onMicPlay:
      'テスト音が聞こえない場合は、スピーカーとマイクの両方を確認します。',
    onMicRecord: '再生するメッセージを録音します。',
    test: 'テスト',
    recording: '録音',
    playing: '再生中',
    reconnecting: '再接続中',
    disconnectMessage:
      'デスクトップ電話が切断されました。別の電話オプションを試してください。',
    singleTelephonyDisconnectMessage:
      'デスクトップ電話が切断されました。管理者に問い合わせてください。',
    clear: '入力をクリア',
    rememberMeCheckBoxMessage: "次回から表示しない",
    saveLabel: '保存',
    browserUnsupportedError: "サポートされていないブラウザを使用しているためログインに失敗しました.",
    microphoneAccessDeniedError: "マイクへのアクセスが拒否されています。ブラウザの設定でアクセスを有効にするか、管理者に問い合わせてください.",
  },
  contactHistory: {
    mainHeader: 'コンタクト履歴',
    handledBy: '処理者',
    noRecordFound: 'コンタクト履歴が見つかりません!',
    tryAgain: 'もう一度やり直してください',
    errorMsg: '連絡履歴を取得できません。もう一度やり直してください。',
    errorID: 'エラー ID',
    missingAni: 'ANI がありません',
    timeIcon: '期間',
    taskHandled: '処理済みのタスク',
    noHistoryNew: '履歴なし',
    noHistory: '履歴なし',
    viewTranscript: '電子メールメッセージの表示',
    transcriptFor: '文字変換対象',
    editBeforeCall: '通話前に編集',
    clickToCall: 'クリックして発信',
    onAnActiveCallErrorMessage:
      'すでにコールがアクティブな状態で、新しいコールを開始することはできません。',
    receivedFrom: 'コンタクトの送信元',
    initiatedTo: 'コンタクトの開始先',
    wrapUpReason: 'ラップアップの理由',
    startCallTelephony:
      '電話番号のリンクをクリックして、発信コールを開始します。',
    contactHistoryList: 'コンタクト履歴リスト',
    wrapUpCode: 'ラップアップコード',
    agentName: 'エージェント名',
    entryPointName: 'エントリポイント',
    acceptedTimeAndDate: '受諾日時',
    duration: '期間',
    emailTranscript: 'メールの記録',
    clickToViewEmailTranscript: 'クリックしてメールの記録を表示',
    listContainer: 'コンテナの一覧表示'
  },
  contactTranscript: {
    agent: 'エージェント',
    entryPoint: 'エントリポイント',
    date: '日付',
    subject: '件名',
    from: '差出人',
    sent: '送信しました',
    to: '送信先',
    back: '戻る',
    errorTranscript: '文字起こし中にエラーが発生しました',
    customer: '顧客',
    inboundErrorMessage: '顧客のメールを読み込めませんでした',
    outboundErrorMessage: 'エージェントの返信を読み込めませんでした'
  },
  popoverTitle: {
    callback: 'コールバック',
    outboundCall: 'アウトバウンドコール',
    incomingCall: '着信',
    progressiveCampaign: 'キャンペーンコール',
    courtesyCallback: 'サービスコールバック',
    chat: '着信チャット',
    incoming: '着信',
    monitoringCall: 'モニタリングコール'
  },
  connecting: '接続中',
  initiating: '初期化中',
  outbound: 'アウトバウンド',
  transfer: {
    title: '転送リクエスト',
    heading: {
      chat: '転送するエージェントまたはキューを選択します。',
      email: '転送するキューを選択します。',
      telephony:
        '転送するエージェント、キューまたはダイヤル番号を選択します。',
      noQueueTelephony:
        '転送するエージェントまたはダイヤル番号を選択します。'
    },
    header: {
      chat: 'この連絡先を転送するためのエージェントまたはキューを選択します。',
      email: 'このコンタクトを転送するキューを選択します。',
      telephony:
        'この連絡先を転送するエージェント、キュー、ダイヤル番号、または組織を選択します。',
      noQueueTelephony:
        'この連絡先を転送するエージェント、ダイヤル番号、または組織を選択します。',
      noOrganizationTelephony:
        'この連絡先を転送するエージェント、キュー、またはダイヤル番号を選択します。',
      noQueueOrganizationTelephony:
        'この連絡先を転送するエージェントまたはダイヤル番号を選択します。'
    },
    queues: 'キュー',
    agents: 'エージェント',
    dialNumber: 'ダイヤル番号',
    organization: '組織',
    placeholder: {
      Queues: 'キューのリストから選択',
      Agents: 'エージェントの一覧から選択',
      DialNumber: '名前または番号で選択',
      DialNumberOrEntryPoint: '名前/番号/エントリポイントで選択',
      ChooseByNameOrNumber: '名前または番号で選択',
      Organization: '名前/ロール/部門/勤務先電話番号で検索',
      WebexOrganization: '名前またはメールで検索',
      DialNumberSearch: '名前または番号で検索'
    },
    type: '転送',
    cancel: 'キャンセル',
    closeModal: 'モーダルを閉じる',
    failureError: 'リクエストを転送できませんでした。もう一度やり直してください。',
    entryPoint: 'エントリポイント'
  },
  consult: {
    title: 'コンサルトリクエスト',
    heading: {
      chat: '転送するエージェントまたはキューを選択します。',
      email: '転送するキューを選択します。',
      telephony:
        '対応するエージェント、キューまたはダイヤル番号を選択します。',
      noQueueTelephony:
        '対応するエージェントまたはダイヤル番号を選択します。'
    },
    header: {
      chat: 'この連絡先を転送するためのエージェントまたはキューを選択します。',
      email: 'このコンタクトを転送するキューを選択します。',
      telephony:
        'コンサルトするエージェント、キュー、ダイヤル番号、または組織を選択します。',
      noQueueTelephony:
        'コンサルトするエージェント、ダイヤル番号、または組織を選択します。',
      noOrganizationTelephony:
        'コンサルトするエージェント、キュー、またはダイヤル番号を選択します。',
      noQueueOrganizationTelephony:
        'コンサルトするエージェントまたはダイヤル番号を選択します。'
    },
    queues: 'キュー',
    agents: 'エージェント',
    dialNumber: 'ダイヤル番号',
    organization: '組織',
    placeholder: {
      Queues: 'キューのリストから選択',
      Agents: 'エージェントの一覧から選択',
      DialNumber: '名前または番号で選択',
      DialNumberOrEntryPoint: '名前/番号/エントリポイントで選択',
      ChooseByNameOrNumber: '名前または番号で選択',
      Organization: '名前/ロール/部門/勤務先電話番号で検索',
      WebexOrganization: '名前またはメールで検索',
      DialNumberSearch: '名前または番号で検索'
    },
    type: 'コンサルト',
    checkBoxLabel: '参加者が対話を続けることを許可します。',
    cancel: 'キャンセル',
    closeModal: 'モーダルを閉じる',
    failureError: 'コンサルトのリクエストに接続できません。もう一度やり直してください。',
    customerLeftMsg: '顧客が切断されました。コンサルトはもう必要ありません。',
    ctqFailureMsg:
      'キューへのコンサルトをキャンセルできません。もう一度やり直してください。',
    cancelCtqInfo:
      '選択したキューで使用可能なエージェントを検索しています。お待ちいただくか、コンサルトリクエストをキャンセルしてください。',
    cancelCtqAction: 'コンサルトのキャンセル',
    entryPoint: 'エントリポイント'
  },
  conference: {
    title: '電話会議のリクエスト',
    heading: {
      chat: '電話会議チャットの特定のエージェントを選択'
    },
    queues: 'キュー',
    agents: 'エージェント',
    dialNumber: 'ダイヤル番号',
    organization: '組織',
    placeholder: {
      Queues: 'キューのリストから選択',
      Agents: 'エージェントの一覧から選択',
      DialNumber: '名前または番号で選択'
    },
    type: '会議',
    cancel: 'キャンセル',
    closeModal: 'モーダルを閉じる',
    failureError: '電話会議リクエストを開始できません。もう一度やり直してください。'
  },
  transferModal: {
    Agents: 'エージェントのリストを取得できません。リストを更新してください。',
    AgentsEmpty: '対応可能なエージェントなし',
    Queues: 'キューのリストを取得できません。リストを更新してください。',
    QueuesEmpty: '使用可能なキューなし',
    EPEmpty: '利用できるエントリポイントがありません',
    DialNumber:
      'アドレス帳からダイヤル番号のリストを取得できません。リストを更新してください。',
    EntryPoint:
      'エントリポイント番号のリストを取得できません。リストを更新してください。',
    Common: 'リストを取得できません。リストを更新してください。',
    DialNumberEmpty: '使用可能なダイヤル番号なし',
    DialNumbInvalid:
      'ダイヤル番号が無効です。管理者に連絡してください。',
    DialNumbOrEntryPointInvalid:
      'ダイヤル番号/エントリポイントが無効です。管理者に連絡してください。',
    refreshQueueList: 'キューのリストの更新',
    refreshAgentList: 'エージェントのリストの更新',
    refreshEpList: 'エントリポイントを更新する',
    refreshAddressBook: 'アドレス帳の更新',
    refreshTheList: 'リストの更新',
    entryPointSectionLabel: 'エントリポイント',
    addressBookSectionLabel: 'アドレス帳',
    organization: '組織',
    comboBoxAriaLabelAgent: 'エージェントの一覧から選択',
    comboBoxAriaLabelQueue: 'キューのリストから選択',
    comboBoxAriaLabelEp: 'エントリポイントのリストから選択する',
    infScrollAgent: 'エージェントの検索',
    infScrollQueue: 'キューの検索',
    infScrollEP: 'エントリポイントの検索',
    allRadioButtonHidedTextForConsult: 'このインタラクションをコンサルトするために指定されたエンティティがありません。管理者にお問い合わせください。',
    allRadioButtonHidedTextForTransfer: 'このインタラクションを転送するために指定されたエンティティがありません。管理者にお問い合わせください。',
    allRadioButtonHidedTextForConference: 'このインタラクションを電話会議するために指定されたエンティティがありません。管理者にお問い合わせください。',
    searchMinCharError: '検索するには 3 文字以上入力してください。',
  },
  wrapup: {
    cancelautowrapup: '自動ラップアップをキャンセル',
    wrapupreason: 'ラップアップの理由',
    untilautowrapup: '自動ラップアップまで',
    followupsetting: 'フォローアップ設定',
    lastagentroute: '前回のエージェントのルーティング',
    submitwrapup: 'ラップアップを送信',
    wrapupsearch: '検索ラップアップの理由',
    invalidationError: 'ラップアップが送信できませんでした',
    searchResult: '検索結果が使用可能です',
    noResultFound: '検索結果が見つかりません',
    listContainerLabel: 'ラップアップリストコンテナ',
    searchError: 'ラップアップの理由を検索するには、3 文字以上入力してください。',
  },

  outdial: {
    call: '通話',
    dialpadSearch: 'ダイヤル番号を入力',
    addressSearch: '名前/番号で検索',
    addressTab: 'アドレス',
    addressTabTooltip: 'アドレス帳の検索',
    dialpadTab: 'ダイアルパッド',
    dialpadTooltip: '番号をダイヤルする',
    searchTab: '検索',
    searchTabTooltip:'組織内のユーザーを検索する',
    noAdrFound: '一致するものが見つかりませんでした',
    noContacts: 'コンタクトなし',
    mainIconTooltip: 'アウトダイヤルコール',
    errorOutdialFailed:
      'アウトダイヤルコールが失敗しました。デスクトップが通話に接続できなかったか、通話に応答がありませんでした。',
    errorOutdialDisabled: 'アウトダイヤルコールが無効になっている',
    errorDialPadValidationMessage: 'ファイル形式が正しくありません',
    outdialReqInProgress: 'アウトダイヤルコール中です',
    outdialAniPlaceholder: 'アウトダイヤル ANI を選択',
    outdialAniLabel: 'アウトダイヤル ANI',
    outdialAniPlaceHolder: 'アウトダイヤル ANI の検索',
    errorDcCallsLimitExceeded:
      'データセンターは、アウトダイヤルコールの上限に達しています。アウトダイヤルコールをこれ以上実行できません',
    errorOrgCallsLimitExceeded:
      '組織は、アウトダイヤルコールの上限に達しています。アウトダイヤルコールをこれ以上実行できません。',
    errorOutDialNoAnswerFromCustomer:
      '顧客は通話に応答しませんでした。後でかけ直してください。',
    errorOutDialCustomerUnavailable:
      '顧客は現在、応答できません。後でかけ直してください。',
    errorOutDialAgentEnds: '顧客との通話を終了しました。',
    errorOutDialCustomerBusy: '顧客は現在、取り込み中です。後でかけ直してください。',
    searchError: 'コンタクトを検索するには 3 文字以上入力してください。',
    upArrowLabel: '展開',
    clear: '入力をクリア',
    outdialDialogDescription: 'タブ付きのダイアログを表示しています。'
  },

  organization: {
    noMatchFound: '一致するものが見つかりませんでした',
    searchError: 'コンタクトを検索するには 3 文字以上入力してください。',
    authError: '連絡先が表示されません。Microsoft 認証に失敗しました。'
  },

  interactionPopover: {
    of: '/',
    accept: '応答',
    acceptAriaLabel: 'タスク {taskNumber} を承諾 - {taskType}（依頼元 {from}）',
    requests: 'リクエスト',
    back: '戻る',
    next: '次へ',
    acceptMultipleRequest: '{requestCount} 件のリクエストを承諾する',
    paginationDetail: '{indexStart}-{totalPopoverpoolLength} の {indexEnd}',
    hidePopoverDetails: 'ポップオーバーの詳細を非表示',
    showPopoverDetails: 'ポップオーバーの詳細を表示',
    customerName: '顧客名',
    email: 'Eメール',
    queueName: 'キュー名',
    failedToAccept: '応答できませんでした。',
    unableToAccept: '連絡先を承諾できません。',
    failedToEnd: '終了できませんでした。',
    unableToEnd: '連絡を終了できません。 ',
    ringing: '呼び出し中',
    calling: '発信中',
    phoneNumber: '電話番号',
    dni: 'DNIS',
    ivrPathId: 'IVR パス ID',
    pathId: 'パス ID',
    rona: 'RONA',
    sourcePage: 'ソースページ',
    sourceNumber: 'ソース番号',
    appUserId: 'アプリユーザ ID',
    acceptAll: 'すべてのタスクを承諾する',
    agentDn: 'エージェント DN',
    agentName: 'エージェント名',
    agentTeam: 'エージェントチーム',
    requestDetails: 'リクエスト詳細',
    incomingCallFrom: '以下からの着信',
    unableToAnswer: '通話を応答できません。もう一度やり直してください。',
    unableToDecline: '通話を拒否できません。もう一度やり直してください。'
  },

  multiLogin: {
    header: '複数サインインの警告',
    message:
      '複数のアプリケーションインスタンスでデスクトップにサインしています。[続行する] をクリックして、このアプリケーションインスタンスのデスクトップに進んでください。それ以外の場合は、このウィンドウを閉じます。',
    continue: '続行'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: '設定エラーにより、エントリポイント/キューへの転送に失敗しました。',
    1010: "エージェントへの時間の割り当てに失敗したため、コンサルトを使用できません。 ",
    1042: "コンタクトが見つかりません。",
    1043: '送信先が無効です。',
    1045: 'このインタラクションはエージェントに割り当てられていません。',
    1046: 'エージェントによるコンサルトが失敗しました。一致するエージェントチャネルがシステムに見つかりません。',
    1038: "エージェントが見つかりません",
    1037: '内部エラーによりサインインに失敗しました。',

    // Media Events
    138: '不明な理由によりアクションが失敗しました。',
    136: 'ユーザが見つかりません',

    // AgentConsultFailed
    1050: 'フローの設定またはアクティビティがサポート対象外のため、コンサルトを使用できません。 ',
    1005: "リクエストへのエージェントの応答が時間内になかったため、コンサルトを使用できません。",
    1051: 'エントリポイントまたはダイヤル番号が無効です。コンサルトまたは転送を使用できません。',

    // AgentInviteFailed
    1053: 'ワークフローの再キューイングタスクが保留中です。インタラクションを使用できません。',
    1054: 'この要求のメディアに問題が発生したため、発信通話を行うことができません。 ',

    // AgentContactAssignFailed
    1011: '進行中のインタラクションにエージェントが見つからないため、通話を応答または承認できません。 ',

    // ContactCallbackFailed
    1034: '要求で ContactParkTimeout を受信したため、連絡先へのコールバックに失敗しました。',

    // ContactUpdateFailed
    1020: "いずれかの値が文字数制限である 256 文字を超えているため、変数を更新できません。文字を減らしてやり直してください。",

    // AgentInviteFailed
    1031: 'コールバックの要求後に、エージェントにより顧客が招待されました。',

    // AgentBlindTransferFailedEvent
    1044: 'エージェントのブラインド転送が失敗しました。転送先のエージェントが別のインタラクションに割り当てられています。',

    // AgentCtqCancelFailed
    1047: "コンタクトが見つかりません。",

    // AgentCtqFailed
    1048: "通話の分配先グループが設定されていません。",
    1049: 'キューの待機時間が制限を超えました。',
    // StationLoginFailed
    127: '重複するログイン例外でエージェント DN 登録が失敗しました。'
  },

  stateSelector: {
    Available: '応答可能',
    errorstatechange: '状態の変更に失敗しました。もう一度やり直してください。',
    errorStateChangeInPendingLogout: 'ログアウト保留中のため、エージェントの状態変更に失敗しました。',
    label: '応答可否',
    agentStateSelector: 'エージェントの状態セレクタ',
    Engaged: '対応中',
    engagedAvailableInfo:
      '現在の状態は、対応中であり応答可能状態です。',
    engagedIdleInfo:
      '現在、対話中で [アイドル（Idle）] 状態です',
    engagedInfo: '現在、対話を実行しています。',
    engagedSupervisorStateChange: '次の状態に変更',
    axAgentStateChanged: '次の状態に変更',
    axAgentSync: 'コラボレーションツールとの状態同期のため。',
    engagedPresenceInfo:
      '現在対話中で、状態は',
    engagedPresenceSync: 'コラボレーションツールとの状態同期のため。',
    clear: '入力をクリア',
    searchState: '入力',
    agentStatusLabel: 'エージェントの状況',
    agentStateLabel: 'エージェントは最後の {selectedTimeValue} の {selectedState} の状態です',
    agentStateLabelOnStateChange: 'エージェントは最後の 0 秒間は {selectedState} の状態です',
    agentStateChangeSuccessful:'{selectedState} への状態の変更が成功しました。',
    agentStateChangeFail:'{selectedState} への状態の変更に失敗しました。',
    searchError: '状態を検索するには 3 文字以上入力してください。'
  },

  warningMessage: {
    header: '保存されていない変更',
    message:
      'このページには保存されてない変更があります。このページを離れてもよろしいですか? ',
    cancelButton: '残る',
    saveButton: '離れる'
  },

  notificationLables: {
    muteVolume: '通知ボリュームをミュートする',
    unmuteVolume: '通知ボリュームのミュートを解除する',
    notificationVolume: '通知ボリューム',
    playSound: '通知音を鳴らす',
    enableSoundNotificationSettings: '音声通知を有効にする',
    enableSoundNotificationSettingsDescription:
      '着信リクエストを音声通知にてお知らせします。以下で音量を調節できます。',
    volumeTitle: '音量'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: '通話',
    chat: 'チャット',
    email: 'Eメール',
    facebook: 'メッセンジャー',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google のビジネスメッセージ"
  },
  orgDetailsLabels: {
    role: 'ロール',
    department: '部門',
    email: 'メール',
    businessPhone: '勤務先電話番号',
    workPhone: '勤務先',
  },
  addressListError: {
    title: 'データのロードに失敗しました',
    errorId: 'エラー ID:'
  },
  keypad: {
    keyPadSearch: '番号を入力',
    dialPad: 'ダイヤルパッド'
  },
  collabTool: {
    userAuthenticated: 'ユーザー認証：',
    successful: '成功',
    failed: '失敗しました。',
    tryAgain: 'もう一度やり直してください',
    stateSync: '状態の同期:',
    mercuryFailedInfo: ' 管理者にお問い合わせください。',
    retrying: '再試行中...',
    trackingIdLabel: 'トラッキング ID: '
  },
  webex: {
    webex: 'Webex',
    info: 'インテグレーションにより、デスクトップと Webex の間で状態を同期できます。'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'このインテグレーションを使用すると、Microsoft Teams のユーザーに相談したり、通話を転送したりできます。',
    authenticationFailedInfo:
      '認証ウィンドウがすでに開いている場合は、そこで認証を再試行します。',
    ListItemContactDetails:
      'コンタクトの名前：{name}、プレゼンス：{presence}、部門：{department}、役職名：{jobTitle}、電話番号：{phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: '緊急サービス通知',
    readNotification: '通知を読みました。'
  },
  webexPresenceStatus: {
    active: 'アクティブ',
    lastActiveFewMinutesAgo: '数分前にアクティブ',
    lastActiveMinutesAgo: '{min} 分前にアクティブ',
    lastActive1HourAgo: '1 時間前の最新アクティビティ',
    lastActiveHoursAgo: '{hour} 時間前にアクティブ',
    lastActiveYesterday: '昨日アクティブ',
    lastActiveOnDate: '{date} にアクティブ',
    busy: '通話中',
    busyUntil: '{date} まで取り込み中',
    dnd: 'サイレント',
    dndUntil: '{date} まで着信拒否',
    quiet: '無表示',
    quietUntil: '{date} まで無表示',
    ooo: '外出中',
    outOfOfficeUntil: '{date} まで外出中',
    call: '通話中',
    meeting: 'ミーティング中',
    calendarItem: 'カレンダーミーティング中',
    presenting: '発表中',
  },
  enterpriseSearch: {
    orgPlaceholder: '名前またはプロファイルの詳細で検索する',
    webexPlaceholder: '名前またはメールで検索',
    refreshTheList: 'リストの更新',
    refreshAddressBook: 'アドレス帳の更新',
    microsoftAuthError: '連絡先が表示されません。Microsoft 認証に失敗しました。'
  }
});


/***/ }),

/***/ "./src/i18n/messages/ko.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/ko.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: '데이터 로드 실패',
    errorID: '오류 ID',
    tryAgain: '다시 시도',
    Error: '오류',
    okButton: '확인',
    Yes: '예',
    Cancel: '취소',
    Confirm: '확인',
    Continue: '계속',
    Canceling: '취소 중',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: '전화받기',
    AnswerAriaLabel: '데스크팁 작업 응답',
    Decline: '거부',
    ErrorSecurityCompliance: '보안 준수',
    errorDetails: '오류 세부 정보',
    learnMore: '자세히 알아보기',
    showLess: '표시 항목 줄이기',
    trackingIdDescription:
      '추적 ID를 사이트 관리자 또는 지원 팀과 공유하여 상황을 조사하십시오.',
    trackingIdInputLabel: '추적 ID: ',
    submitForm: '양식 제출',
    unnamedStatus: '이름없는 상태',
    errorChatMsg: '채팅 데이터 로드 실패',
    noOptions: '옵션 없음',
    noResults: '결과가 없습니다',
    more: '자세히',
    nomatchfound: '일치하는 항목이 없음',
    collaborationTool: '협업 도구',
    timerAriaLabel: '소요된 시간',
    historyItemTime: '발생 시간:',
    loading: '로드 중',
    months: [
      '1월',
      '2월',
      '3월',
      '4월',
      '5월',
      '6월',
      '7월',
      '8월',
      '9월',
      '10월',
      '11월',
      '12월'
    ],
    loadingMsg: '로드 중..',
    search: '검색',
    historyChannelLabels: {
      All: '모두',
      telephony: '음성',
      chat: '채팅',
      email: '이메일',
      social: '소셜'
    },
    homePageLabel: '홈페이지',
    resizeHistoryDragger: '기록 드래거 크기 조정',
    agentHistoryLabel: '상담사 기록',
    clear: '입력 지우기',
    ariaLabelAgentHistoryWrapper:
      '상담사 상호 작용 기록: 지난 24시간 동안 다양한 채널에서의 최근 고객 커뮤니케이션을 표시합니다.',
    sliderResizerInstructions:
      '현재 슬라이더에 있습니다. 크기를 조정하려면 화살표 키를 사용하십시오',
    resizeHistoryPanel: '내역 패널 크기 조정, 슬라이더,',
    time: {
      hours: '시간',
      minutes: '분',
      seconds: '초'
    }
  },
  email: {
    ToLabel: '종료',
    FromLabel: '시작',
    CcLabel: '참조',
    BccLabel: '숨은 참조',
    SubjectLabel: '제목',
    HideLabel: '숨기기',
    SendLabel: '보내기',
    ShowPrevThread: '이전 스레드 표시',
    HidePrevThread: '이전 스레드 숨기기',
    ReplyLabel: '응답',
    ReplyAllLabel: '모두 회신',
    ViewOriginalMail: '원래 전자 메일 보기',
    QuickReplyInp: '이곳에서 빠른 답신...',
    AttachFiles: '첨부파일',
    ToolbarHeading: '머리글1',
    ToolbarBold: '굵게',
    ToolbarItalic: '기울임꼴',
    ToolbarUnderLine: '밑줄',
    ToolbarBlockQuote: '쿼트 차단',
    ToolbarCode: '코드 차단',
    ToolbarListOrder: '순서대로 나열',
    ToolbarListBullet: '글머리표 순으로 나열',
    ToolbarLink: '링크',
    ToolbarStrike: '취소선',
    ToolbarColor: '텍스트 색',
    ToolbarTable: '테이블',
    insertTable: '테이블 삽입',
    insertRowAbove: '위에 행 삽입',
    insertRowBelow: '아래에 행 삽입',
    insertColumnLeft: '왼쪽에 열 삽입',
    insertColumnRight: '오른쪽에 열 삽입',
    deleteRow: '행 삭제',
    deleteColumn: '열 삭제',
    deleteTable: '테이블 삭제',
    link: '링크',
    IndentRight: '오른쪽 들여쓰기',
    IndentLeft: '왼쪽 들여쓰기',
    showMoreAttachment: '추가 첨부 파일 표시',
    AttachmentLimit: '최대 ',
    attachments: ' 개 첨부 파일 첨부, ',
    sizeLimit: ' MB 최대',
    attachment: '첨부 파일',
    errordeleteattachment: '파일을 삭제하지 못했습니다. 다시 시도하십시오.',
    errordownloadattachment: '파일을 다운로드하지 못했습니다. 다시 시도하십시오.',
    erroraddattachemnt: '파일을 업로드하지 못했습니다. 다시 시도하십시오.',
    errorendcontact: '상호작용을 종료하지 못했습니다. 다시 시도하십시오.',
    erroraddlimitreached:
      '최대값을 초과하여 파일을 첨부할 수 없습니다. ',
    errorattachmentdrop:
      '회사의 보안 정책 때문에 첨부 파일이 삭제되었습니다.',
    errorfiletype: '파일 유형이 지원되지 않습니다. 다시 시도하십시오.',
    errorcreditcard:
      '회사의 보안 정책 때문에 첨부 파일을 업로드하지 못했습니다.',
    errorcontainsimage:
      '첨부 파일을 업로드하지 못했습니다. 첨부 파일에 있는 이미지가 회사의 보안 정책에서 지원하지 않는 이미지입니다.',
    errorlimit: ' MB 제한.',
    errorsendemail: '이메일을 전송할 수 없습니다. 다시 시도하십시오.',
    errorpcicheckemail: 'PCI 데이터를 가져올 수 없습니다. 다시 시도하십시오.',
    errortext: '데이터 로드 실패',
    tryAgain: '다시 시도',
    replywarning:
      '이 메시지 또는 첨부 파일에서 금융, 건강 또는 개인 식별 정보(PII)를 공유하지 마십시오.',
    datamasked:
      '회사의 보안 정책에 따라 이메일 제목이나 본문이 수정되었습니다. 이메일을 보내시겠습니까?',
    pcibannerwarning:
      '회사의 보안 정책에 따라 이메일 제목이나 본문이 수정되었습니다.',
    on: '설정',
    wrote: '작성함'
  },
  interaction_control: {
    windowOpened: '창이 열렸음',
    connected: '연결됨',
    consultRequested: '참조 요청됨',
    consulting: '상담 중',
    consultCallOnHold: '상담 대기',
    callOnHold: '통화 대기',
    consult: '상담',
    endconsult: '상담 종료',
    hold: '보류',
    transfer: '호전환',
    conference: '전화회의',
    endconference: '전화회의 종료',
    conferenceRequested: '전화회의 요청됨',
    switchCall: '전환',
    mergeCall: '병합',
    wrapup: '후속 작업',
    end: '종료',
    customername: '고객 이름',
    dn: 'DNIS',
    ivrpath: 'IVR 경로',
    email: '고객 전자 메일',
    ani: '전화 번호',
    queueid: '대기열 이름',
    ronatimeout: 'Rona 시간',
    pathid: 'IVR 경로 ID',
    dnis: 'DNIS',
    destagentphonenumber: '상담사 DN',
    destagentname: '상담사 이름',
    virtualteamname: '서비스 대기열',
    category: '범주',
    additionaldetails: '추가 상세 정보',
    sourcenumber: '소스 번호',
    sourcepage: '소스 페이지',
    appuser: '앱 사용자 ID',
    customernumber: '전화 번호',
    exitconference: '전화회의 끝내기',
    resume: '보류 해제',
    pauserecording: '레코딩 종료',
    resumerecording: '레코딩 다시 시작',
    exitconsult: '참조 종료',
    pauseRecordingFailed: '녹화를 일시 중지할 수 없습니다. 다시 시도하십시오.',
    resumeRecordingFailed: '녹화를 다시 시작할 수 없습니다. 다시 시도하십시오.',
    holdCallFailed: '통화를 보류할 수 없습니다. 다시 시도하십시오.',
    resumeCallFailed: '통화를 다시 시작할 수 없습니다. 다시 시도하십시오.',
    endCallFailed: '상호작용을 종료하지 못했습니다. 다시 시도하십시오.',
    consultTransferFailed:
      '상담 통화를 호 전환할 수 없습니다. 다시 시도하십시오.',
    conferenceTransferFailed:
      '전화회의를 호 전환할 수 없습니다. 다시 시도하십시오.',
    conferenceFailed:
      '전화회의 요청을 연결할 수 없습니다. 다시 시도하십시오.',
    consultEndFailed: '상담 요청을 종료할 수 없습니다. 다시 시도하십시오.',
    conferenceExitFailed:
      '전화회의 요청을 종료할 수 없습니다. 다시 시도하십시오.',
    conferenceEndFailed:
      '전화회의 요청을 종료할 수 없습니다. 다시 시도하십시오.',
    cancelCtqFailed:
      '상담 통화를 취소하여 대기열로 보낼 수 없습니다. 다시 시도해주십시오.',
    privacyShield: '개인 정보 보호',
    errorOnPrvacyShieldForConsult:
      '기록이 일시 중지되었습니다. 상담 통화를 시작하려면 기록을 재개해주십시오.',
    errorOnPrvacyShieldForTransfer:
      '기록이 일시 중지되었습니다. 통화 호 전환을 시작하려면 기록을 재개해주십시오.',
    cancelConsult: '상담 취소',
    cancelTransfer: '호 전환 취소',
    copy: '복사',
    copied: '복사됨',
    cadrequestuccess: '고객 정보가 저장되었습니다.',
    cadrequestfailure: '고객 정보를 저장하지 못했습니다. 나중에 다시 시도해주십시오.',
    cadupdatedmessage: '고객 정보가 최근에 다음 사람에 의해 업데이트되었습니다.',
    unsavedmessage: '저장하지 않은 변경사항을 덮어씁니다.',
    save: '저장',
    revert: '되돌리기',
    expandDetails: '세부 정보 확장',
    collapseDetails: '세부 정보 축소',
    cadValidationError:
      '형식이 잘못되었습니다. 날짜 및 시간에 대한 국제 표준을 사용하십시오.',
    secureCadSaveError:
      '고객 정보가 저장되지 않습니다. 저장을 클릭하여 다시 시도하십시오.',
    secureDecryptionError: '보안 변수를 표시할 수 없습니다.',
    clickToTry: '다시 시도하려면 클릭',
    isSecureVariable: '보안 변수임',
    contactorigin: '연락처 원본',
    resumeMonitoring: '모니터링 재개',
    pauseMonitoring: '모니터링 일시 중지',
    whisperCoach: '위스퍼 코치',
    bargeIn: '대화참여',
    endMonitoring: '모니터링 종료',
    contactphonenumber: '연락처 전화 번호',
    contactqueue: '연락처 대기열',
    activeparticipants: '활성 참가자',
    consultedparticipant: '상담이 요청된 참가자',
    contactstatus: '연락처 상태',
    timeincontactstatus: '연락처 상태 경과 시간',
    totalcontactduration: '총 연락처 지속 시간',
    agentinteractiontime: '상호 작용 지속 시간',
    recording: '녹음 중',
    monitoring: '모니터링',
    monitoringPaused: '모니터링 일시 중지됨',
    pauseMonitoringFailed: '모니터링을 일시 중지할 수 없습니다. 다시 시도하십시오.',
    resumeMonitoringFailed: '모니터링을 재개할 수 없습니다. 다시 시도하십시오.',
    callCancelledInProgress: '진행 중인 통화 취소',
    bargedIn: '대화에 참여했음',
    keypad: '키패드',
    mute: '음소거',
    unmute: '음소거 해제',
    bargeInTooltipText:
      '마이크가 켜지고 이 고객 상호 작용에 참가하게 됩니다',
    bargeInCompactTooltipText:
      '대화 참여. 마이크가 켜지고 이 고객 상호 작용에 참가하게 됩니다',
    bargeInTooltipDisabled: '대화 참여를 활성화하려면 모니터링을 다시 시작하십시오.',
    bargeInFailedTitle: '대화 참여 실패',
    bargeInFailedData:
      '대화에 참여하는 동안 오류가 발생했습니다. 잠시 후 다시 시도하십시오.',
    supervisorBargedIn: '님이 통화에 끼어들었습니다.',
    leftInteraction: '님이 상호작용을 떠났습니다.',
    conferenceEnded: '컨퍼런스콜이 종료되었습니다.',
    participants: '참가자',
    badgeAriaLabel: '{participant} 님이 통화 중입니다',
    bargeInConferenceAriaLabel: '상호 작용에 두 명의 참가자가 있습니다',
    taskName: '상호 작용 제어 작업 이름',
    interactionDurationLabel: '지속 시간',
    wrapupassist: '후속 작업 지원',
    consultingTaskContext: '상담 전화',
    consultExited: '상담 통화 종료됨',
    endCall: '통화를 종료합니다.',
    exitconferenceCall:
      '통화를 종료하고 활성 참가자와 함께 전화회의를 계속합니다.',
    recordingInProgess: '녹화 진행 중',
    recordingPaused: '녹화 일시 중지됨',
    searchPlaceholder: '연락처 검색',
    postCall: "통화 후",
    switchCallTooltip: "통화로 전환",
    switchConsultTooltip: "상담 통화로 전환",
    switchConferenceTooltip: "전화회의 통화로 전환",
    confirmationDialog: {
      endCallTitle: '통화를 종료하시겠습니까?',
      endCallMessage: '모든 참가자에 대한 통화를 종료하려면 확인을 클릭합니다.',
      exitConferenceTitle: '전화회의 통화를 종료하시겠습니까?',
      exitConferenceMessage:
        '확인을 클릭하여 전화회의 통화를 종료하고 다른 참가자들이 통화를 계속할 수 있도록 합니다.',
      confirmButtonLabel: "확인",
      cancelButtonLabel: "취소",  
    },
    postCallOnHold: "통화 후 보류 중",
    postCallConsult: "통화 후 상담",
    postCallConsultOnHold: "통화 후 상담 보류 중",
  },
  agentProfile: {
    teamName: '팀',
    dialNumber: '다이얼 번호',
    phoneNumber: '전화 번호',
    settings: '설정 변경',
    signOut: '로그아웃',
    webRTCDisconnected: '경고 데스크톱 전화 통신 끊김 ',
    msAuthFailed: 'Microsoft 인증 실패',
    stateSyncFailed: '상태 동기화에 실패했습니다.',
    userProfileLabel: '사용자 프로필',
    ariaAgentprofile: '상담사 프로필',
    ChannelCapacity: '채널 용량',
    voice: '음성',
    chat: '채팅',
    email: '이메일',
    social: '소셜',
    channelCapacityTooltip: '자세히 보려면 클릭',
    blendedRouting: '혼합됨',
    exclusiveRouting: '독점 라우팅',
    realtimeRouting: '혼합된 실시간 라우팅',
    blendedRoutingTooltip: '여러 채널의 여러 연락처를 처리합니다.',
    exclusiveRoutingTooltip: '한 번에 하나의 연락처만 처리합니다.',
    realtimeRoutingTooltip: '필수 실시간 채널 하나를 처리합니다.',
    errorActiveContacts:
      '활성인 대화가 있기 때문에 지금 로그아웃할 수 없습니다. 대화를 완료한 후 다시 시도하십시오.',
    searchTeams: '팀 검색',
    changeTeamsConfirmHeader: '팀 변경 확인',
    changeTeamsConfirmMessage: '팀을 변경하시겠습니까?',
    changeTeamLabel: '팀 변경',
    errorChangeTeams:
      '현재 활성 요청이 있으므로 팀을 변경할 수 없습니다. 이 요청을 완료하고 다시 시도하십시오.',
    saveTeamSelection: '팀 선택 저장',
    userSettings: '사용자 설정',
    resetLayout: '전체 데스크탑 레이아웃 재설정',
    resetConfirmHeader: '레이아웃 재설정 확인',
    resetConfirmMessage:
      '전체 데스크탑 레이아웃을 재설정하시겠습니까? <br/> 데스크탑이 기본 레이아웃으로 돌아갑니다.',
    downloadLogs: '오류 보고서 다운로드',
    help: '도움말',
    signoutConfirm: '로그아웃하시겠습니까?',
    signoutConfirmHeader: '로그아웃 확인',
    darkTheme: '다크 모드로 전환',
    newLook: '새 모양으로 전환',
    keyboardShortcuts: '키보드 바로 가기',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: '알림 설정',
    silentNotification: '무음 알림',
    enableNotificationSettings: '알림 활성화',
    enableSilentNotificationSettings: '무음 알림 활성화',
    suppressWebexCallingNotificationSettings: 'Webex Calling 알림 숨기기',
    notificationSettingDescription:
      '새로운 메시지, 경고, 상태 변화 같은 알림을 전달합니다.',
    silentNotificationDescription:
      '경고 표시를 끕니다. 알림 센터에서 알림을 확인할 수 있습니다.',
    suppressWebexCallingNotificationDescription: 
    '수신 Webex 전화에 대한 팝업 알림을 표시하지 않고 Webex Contact Center를 통해 응답합니다.',
    arrowLabel: '돌아가기',
    managedTeams: '관리되는 팀',
    managedTeamsError: '팀을 로드하지 못했습니다.',
    viewAll: '모두 보기',
    profileSettings: '프로파일 설정',
    userRole: '역할',
    saveSelection: '선택 항목 저장',
    extension: '내선 번호',
    changeProfileConfirmHeader: '프로필 설정 변경 사항 확인',
    changeProfileConfirmMessage:
      '프로필 변경 사항을 저장하시겠습니까?',
    confirm: '확인',
    errorProfileUpdate:
      '현재 활성 요청이 있으므로 프로필 설정을 변경할 수 없습니다. 이 요청을 완료하고 다시 시도하십시오.',
    roleAgentSupervisor: '감독자 및 상담사',
    roleSupervisor: '감독자',
    noTeam: '팀 없음',
    testYourNetwork: '네트워크 테스트',
    speakerAndMic: '스피커 및 마이크',
    speaker: '스피커',
    mic: '마이크',
    speakerDescription:
      '출력 장치를 선택하고 테스트하여 발신자의 소리가 들리는지 확인합니다.',
    micDescription:
      '입력 장치를 선택하고 테스트하여 발신자에게 소리가 들리는지 확인합니다.',
    micError:
      '마이크에 대한 액세스가 거부되었습니다. 브라우저 설정을 통해 액세스를 활성화하거나 관리자에게 문의하십시오.',
    speakerError:
      '마이크에 대한 액세스가 거부 되었으므로 현재 스피커를 사용할 수 없습니다.',
    telephony: '전화 통신',
    desktop: '데스크탑',
    onSpeakerPlay:
      '테스트 사운드가 들리지 않으면 스피커 장치를 확인합니다.',
    onMicPlay:
      '테스트 사운드가 들리지 않으면 스피커와 마이크를 모두 확인합니다.',
    onMicRecord: '재생할 메시지를 녹음합니다.',
    test: '텍스트',
    recording: '녹음 중',
    playing: '재생 중',
    reconnecting: '다시 연결 중',
    disconnectMessage:
      '데스크톱 전화 연결 끊김. 다른 전화 옵션을 시도 합니다.',
    singleTelephonyDisconnectMessage:
      '데스크톱 전화 연결 끊김. 관리자에게 문의 하십시오.',
    clear: '입력 지우기',
    rememberMeCheckBoxMessage: "다시 표시 안 함",
    saveLabel: '저장',
    browserUnsupportedError: "지원되지 않는 브라우저를 사용하고 있기 때문에 로그인에 실패했습니다.",
    microphoneAccessDeniedError: "마이크에 대한 액세스가 거부되었습니다. 브라우저 설정을 통해 액세스를 활성화하거나 관리자에게 문의하십시오.",
  },
  contactHistory: {
    mainHeader: '연락처 기록',
    handledBy: '처리자',
    noRecordFound: '연락처 기록을 찾을 수 없습니다!',
    tryAgain: '다시 시도',
    errorMsg: '연락처 기록을 가져올 수 없습니다. 나중에 다시 시도하십시오.',
    errorID: '오류 ID',
    missingAni: 'ANI가 없습니다',
    timeIcon: '재생 시간',
    taskHandled: '처리된 작업',
    noHistoryNew: '이력 없음',
    noHistory: '이력 없음',
    viewTranscript: '이메일 메시지 보기',
    transcriptFor: '대화 내용:',
    editBeforeCall: '통화하기 전에 편집',
    clickToCall: '클릭투콜',
    onAnActiveCallErrorMessage:
      '이미 활성 통화 중이므로 새 통화를 시작할 수 없습니다.',
    receivedFrom: '받은 연락처:',
    initiatedTo: '시작한 연락처:',
    wrapUpReason: '후속 작업 사유',
    startCallTelephony:
      '전화 번호 링크를 클릭하여 발신 전화를 시작합니다.',
    contactHistoryList: '연락처 기록 목록,',
    wrapUpCode: '후속 작업 코드',
    agentName: '상담사 이름',
    entryPointName: '엔트리 포인트',
    acceptedTimeAndDate: '수락된 시간 및 날짜',
    duration: '재생 시간',
    emailTranscript: '이메일 스크립트',
    clickToViewEmailTranscript: '이메일 스크립트를 보려면 클릭하십시오',
    listContainer: '목록 컨테이너'
  },
  contactTranscript: {
    agent: '상담사',
    entryPoint: '엔트리 포인트',
    date: '날짜',
    subject: '제목',
    from: '시작',
    sent: '보냄',
    to: '종료',
    back: '뒤로',
    errorTranscript: '대화 내용을 가져오는 중 오류 발생',
    customer: '고객',
    inboundErrorMessage: '고객 전자 메일을 로드하지 못했습니다',
    outboundErrorMessage: '상담사 응답을 로드하지 못했습니다'
  },
  popoverTitle: {
    callback: '회신',
    outboundCall: '아웃바운드 통화',
    incomingCall: '착신 통화',
    progressiveCampaign: '캠페인 통화',
    courtesyCallback: '무료 콜백',
    chat: '수신 채팅',
    incoming: '수신',
    monitoringCall: '통화 모니터링'
  },
  connecting: '연결 중',
  initiating: '시작',
  outbound: '아웃바운드',
  transfer: {
    title: '호 전환 요청',
    heading: {
      chat: '전송할 상담사 또는 대기열을 선택합니다.',
      email: '전송할 대기열을 선택합니다.',
      telephony:
        '전송할 상담사, 대기열 또는 다이얼 번호를 선택합니다.',
      noQueueTelephony:
        '전송할 상담사 또는 다이얼 번호를 선택합니다.'
    },
    header: {
      chat: '이 연락처를 전송하기 위한 상담원 또는 대기열을 선택합니다.',
      email: '이 연락처를 전송하기 위한 대기열을 선택합니다.',
      telephony:
        '이 연락처를 전송하기 위한 상담사, 다이얼 번호 또는 조직을 선택합니다.',
      noQueueTelephony:
        '이 연락처를 전송하기 위한 상담사, 다이얼 번호 또는 조직을 선택합니다.',
      noOrganizationTelephony:
        '이 연락처를 전송하기 위한 상담사, 대기열 또는 다이얼 번호를 선택합니다.',
      noQueueOrganizationTelephony:
        '이 연락처를 전송하기 위한 상담사 또는 다이얼 번호를 선택합니다.'
    },
    queues: '서비스 대기열',
    agents: '상담사',
    dialNumber: '다이얼 번호',
    organization: '조직',
    placeholder: {
      Queues: '대기열 목록에서 선택',
      Agents: '상담사 목록에서 선택',
      DialNumber: '이름 또는 번호로 선택',
      DialNumberOrEntryPoint: '이름/번호/엔트리 포인트별로 선택',
      ChooseByNameOrNumber: '이름/번호로 선택',
      Organization: '이름/직무/부서/회사 전화번호로 검색',
      WebexOrganization: '이름 또는 이메일로 검색',
      DialNumberSearch: '이름 또는 번호로 검색'
    },
    type: '호전환',
    cancel: '취소',
    closeModal: '모달 닫기',
    failureError: '요청을 시작하지 못했습니다. 나중에 다시 시도해주십시오.',
    entryPoint: '엔트리 포인트'
  },
  consult: {
    title: '참조 요청',
    heading: {
      chat: '전송할 상담사 또는 대기열을 선택합니다.',
      email: '전송할 대기열을 선택합니다.',
      telephony:
        '상담할 상담사, 대기열 또는 다이얼 번호를 선택합니다.',
      noQueueTelephony:
        '상담할 상담사 또는 다이얼 번호를 선택합니다.'
    },
    header: {
      chat: '이 연락처를 전송하기 위한 상담원 또는 대기열을 선택합니다.',
      email: '이 연락처를 전송하기 위한 대기열을 선택합니다.',
      telephony:
        '상담할 상담사, 대기열, 다이얼 번호 또는 조직을 선택합니다.',
      noQueueTelephony:
        '상담할 상담사, 다이얼 번호 또는 조직을 선택합니다.',
      noOrganizationTelephony:
        '상담할 상담사, 대기열 또는 다이얼 번호를 선택합니다.',
      noQueueOrganizationTelephony:
        '상담할 상담사 또는 다이얼 번호를 선택합니다.'
    },
    queues: '서비스 대기열',
    agents: '상담사',
    dialNumber: '다이얼 번호',
    organization: '조직',
    placeholder: {
      Queues: '대기열 목록에서 선택',
      Agents: '상담사 목록에서 선택',
      DialNumber: '이름 또는 번호로 선택',
      DialNumberOrEntryPoint: '이름/번호/엔트리 포인트별로 선택',
      ChooseByNameOrNumber: '이름/번호로 선택',
      Organization: '이름/직무/부서/회사 전화번호로 검색',
      WebexOrganization: '이름 또는 이메일로 검색',
      DialNumberSearch: '이름 또는 번호로 검색'
    },
    type: '상담',
    checkBoxLabel: '참가자가 계속 상호 작용할 수 있습니다.',
    cancel: '취소',
    closeModal: '모달 닫기',
    failureError: '상담 요청을 연결할 수 없습니다. 다시 시도하십시오.',
    customerLeftMsg: '고객 연결이 끊어졌습니다. 더 이상 상담이 필요하지 않습니다.',
    ctqFailureMsg:
      '상담 통화를 취소하여 대기열로 보낼 수 없습니다. 다시 시도해주십시오.',
    cancelCtqInfo:
      '선택한 대기열에서 사용 가능한 상담사를 검색하는 중입니다. 검색될 때까지 기다리거나 상담 요청을 취소하십시오.',
    cancelCtqAction: '상담 취소',
    entryPoint: '엔트리 포인트'
  },
  conference: {
    title: '회의 요청',
    heading: {
      chat: '전화회의 채팅을 위한 특정 상담사 선택'
    },
    queues: '서비스 대기열',
    agents: '상담사',
    dialNumber: '다이얼 번호',
    organization: '조직',
    placeholder: {
      Queues: '대기열 목록에서 선택',
      Agents: '상담사 목록에서 선택',
      DialNumber: '이름 또는 번호로 선택'
    },
    type: '전화회의',
    cancel: '취소',
    closeModal: '모달 닫기',
    failureError: '전화회의 요청을 시작하지 못했습니다. 나중에 다시 시도해주십시오.'
  },
  transferModal: {
    Agents: '상담사 목록을 검색할 수 없습니다. 목록을 새로 고치십시오.',
    AgentsEmpty: '사용 가능 상담사 없음',
    Queues: '대기열 목록을 검색할 수 없습니다. 목록을 새로 고치십시오.',
    QueuesEmpty: '사용 가능 대기열 없음',
    EPEmpty: '사용할 수 있는 진입점 없음',
    DialNumber:
      '주소록에서 전화 번호 목록을 검색할 수 없습니다. 목록을 새로 고치십시오.',
    EntryPoint:
      '엔트리 포인트 번호 목록을 검색할 수 없습니다. 목록을 새로 고치십시오.',
    Common: '목록을 검색할 수 없습니다. 목록을 새로 고치십시오.',
    DialNumberEmpty: '사용 가능 다이얼 번호 없음',
    DialNumbInvalid:
      '다이얼 번호가 올바르지 않습니다. 관리자에게 문의하십시오.',
    DialNumbOrEntryPointInvalid:
      '다이얼 번호/엔트리 포인트가 잘못되었습니다. 관리자에게 문의하십시오.',
    refreshQueueList: '대기열 목록 새로 고침',
    refreshAgentList: '상담사 목록 새로 고침',
    refreshEpList: '진입점 새로 고침',
    refreshAddressBook: '주소록 새로 고침',
    refreshTheList: '목록 새로 고침',
    entryPointSectionLabel: '엔트리 포인트',
    addressBookSectionLabel: '주소록',
    organization: '조직',
    comboBoxAriaLabelAgent: '상담사 목록에서 선택',
    comboBoxAriaLabelQueue: '대기열 목록에서 선택',
    comboBoxAriaLabelEp: '진입점 목록에서 선택',
    infScrollAgent: '상담사 검색',
    infScrollQueue: '대기열 검색',
    infScrollEP: '진입점 검색',
    allRadioButtonHidedTextForConsult: '이 상호 작용을 참조하도록 할당된 엔터티가 없습니다. 관리자에게 문의하십시오.',
    allRadioButtonHidedTextForTransfer: '이 상호 작용을 전송하도록 할당된 엔터티가 없습니다. 관리자에게 문의하십시오.',
    allRadioButtonHidedTextForConference: '이 상호 작용을 전화회의하도록 할당된 엔터티가 없습니다. 관리자에게 문의하십시오.',
    searchMinCharError: '검색하려면 최소 세 자를 입력하십시오.',
  },
  wrapup: {
    cancelautowrapup: '자동 후속 작업 취소',
    wrapupreason: '후속 작업 사유',
    untilautowrapup: '자동 후속 작업 때까지',
    followupsetting: '후속 조치 설정',
    lastagentroute: '최종 상담사 라우팅',
    submitwrapup: '후속 작업 제출',
    wrapupsearch: '후속 작업 사유 검색',
    invalidationError: '후속 작업을 제출하지 못했습니다',
    searchResult: '검색 결과 사용 가능',
    noResultFound: '검색 결과를 찾을 수 없음',
    listContainerLabel: '후속 작업 목록 컨테이너',
    searchError: '최소 3자를 입력하여 후속 작업 이유를 검색합니다.',
  },

  outdial: {
    call: '통화',
    dialpadSearch: '다이얼할 번호 입력',
    addressSearch: '이름/번호로 검색',
    addressTab: '주소',
    addressTabTooltip: '주소록 검색',
    dialpadTab: '다이얼패드',
    dialpadTooltip: '번호로 전화 걸기',
    searchTab: '검색',
    searchTabTooltip:'내 조직의 사용자 검색',
    noAdrFound: '일치하는 항목이 없음',
    noContacts: '연락처가 없음',
    mainIconTooltip: '아웃다이얼 통화',
    errorOutdialFailed:
      '아웃다이얼 통화에 실패했습니다. 데스크탑이 통화를 연결할 수 없거나 응답받지 못했습니다.',
    errorOutdialDisabled: '아웃다이얼 통화가 비활성화되었습니다',
    errorDialPadValidationMessage: '잘못된 형식',
    outdialReqInProgress: '아웃다이얼 통화가 진행 중입니다',
    outdialAniPlaceholder: '아웃다이얼 ANI 선택',
    outdialAniLabel: '아웃다이얼 ANI',
    outdialAniPlaceHolder: '아웃다이얼 ANI 검색',
    errorDcCallsLimitExceeded:
      '데이터 센터는 아웃다이얼 통화의 최대 한도에 도달했습니다. 더 이상 아웃다이얼 통화를 할 수 없습니다.',
    errorOrgCallsLimitExceeded:
      '조직은 아웃다이얼 통화의 최대 한도에 도달했습니다. 더 이상 아웃다이얼 통화를 할 수 없습니다.',
    errorOutDialNoAnswerFromCustomer:
      '고객이 통화에 응답하지 않았습니다. 나중에 전화를 걸어 보십시오.',
    errorOutDialCustomerUnavailable:
      '고객에게 현재 연결할 수 없습니다. 나중에 전화를 걸어 보십시오.',
    errorOutDialAgentEnds: '고객과의 통화가 종료되었습니다.',
    errorOutDialCustomerBusy: '고객이 현재 통화 중입니다. 나중에 전화를 걸어 보십시오.',
    searchError: '연락처를 검색하려면 최소 세 자를 입력하십시오.',
    upArrowLabel: '확장',
    clear: '입력 지우기',
    outdialDialogDescription: '현재 탭이 있는 대화 상자에 있습니다.'
  },

  organization: {
    noMatchFound: '일치하는 항목이 없음',
    searchError: '연락처를 검색하려면 최소 세 자를 입력하십시오.',
    authError: '표시할 연락처가 없습니다. Microsoft 인증에 실패했습니다.'
  },

  interactionPopover: {
    of: '/',
    accept: '승인',
    acceptAriaLabel: '{from}의 작업 {taskNumber} - {taskType} 승인',
    requests: '요청',
    back: '뒤로',
    next: '다음',
    acceptMultipleRequest: '{requestCount} 요청 수락',
    paginationDetail: '{indexStart}-{indexEnd} / {totalPopoverpoolLength}',
    hidePopoverDetails: '팝오버 세부 정보 숨기기',
    showPopoverDetails: '팝오버 세부 정보 표시',
    customerName: '고객 이름',
    email: '이메일',
    queueName: '대기열 이름',
    failedToAccept: '수락하지 못했습니다.',
    unableToAccept: '연락처를 수락하지 못했습니다.',
    failedToEnd: '종료하지 못했습니다.',
    unableToEnd: '연락처를 종료하지 못했습니다. ',
    ringing: '전화 거는 중',
    calling: '전화 거는 중',
    phoneNumber: '전화 번호',
    dni: 'DNIS',
    ivrPathId: 'IVR 경로 ID',
    pathId: '경로 ID',
    rona: 'RONA',
    sourcePage: '소스 페이지',
    sourceNumber: '소스 번호',
    appUserId: '앱 사용자 ID',
    acceptAll: '모든 작업 수락',
    agentDn: '상담사 DN',
    agentName: '상담원 이름',
    agentTeam: '상담사 팀',
    requestDetails: '요청 세부 정보',
    incomingCallFrom: '다음에서 온 수신 통화',
    unableToAnswer: '통화에 응답할 수 없습니다. 다시 시도하십시오.',
    unableToDecline: '통화를 거부할 수 없습니다. 다시 시도하십시오.'
  },

  multiLogin: {
    header: '여러 로그인 알림',
    message:
      '여러 애플리케이션 인스턴스에서 데스크탑에 로그인했습니다. 이 애플리케이션 인스턴스에서 데스크탑으로 계속 진행하려면 계속을 클릭하십시오. 그렇지 않으면 이 창을 닫으십시오.',
    continue: '계속'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: '구성 오류로 인해 진입점/대기열로 전송에 실패했습니다.',
    1010: "상담사를 시간 내에 할당할 수 없으므로 상담할 수 없습니다. ",
    1042: "연락처를 찾을 수 없습니다.",
    1043: '대상이 잘못되었습니다.',
    1045: '상호 작용이 상담사에게 할당되지 않았습니다.',
    1046: '시스템에서 일치하는 상담사 채널을 찾을 수 없어 상담사 상담에 실패했습니다.',
    1038: "상담사를 찾을 수 없음",
    1037: '내부 오류로 인해 로그인에 실패했습니다.',

    // Media Events
    138: '알 수 없는 이유로 작업이 실패했습니다.',
    136: '사용자를 찾을 수 없음',

    // AgentConsultFailed
    1050: '흐름에서 지원되지 않는 구성 또는 활동으로 인해 상담할 수 없습니다. ',
    1005: "상담사가 요청에 제때 응답하지 않아 상담할 수 없습니다.",
    1051: '잘못된 진입점 또는 다이얼 번호로 인해 상담 또는 호전환할 수 없습니다.',

    // AgentInviteFailed
    1053: '보류 중인 워크플로우 대기열 작업으로 인해 상호 작용을 제공할 수 없습니다.',
    1054: '이 요청과 관련된 미디어 문제로 인해 아웃다이얼 전화를 걸 수 없습니다. ',

    // AgentContactAssignFailed
    1011: '진행 중인 상호 작용에서 상담사 누락으로 인해 통화에 응답하거나 수락할 수 없습니다. ',

    // ContactCallbackFailed
    1034: '요청에 대한 ContactParkTimeout이 수신되었으므로 연락처에 콜백하지 못했습니다.',

    // ContactUpdateFailed
    1020: "값 중 하나가 256자 문자 제한을 초과하므로 변수를 업데이트할 수 없습니다. 문자 수를 줄인 후 다시 시도하십시오.",

    // AgentInviteFailed
    1031: '콜백이 요청된 후 상담사가 고객을 초대했습니다.',

    // AgentBlindTransferFailedEvent
    1044: '대상 상담사가 다른 상호 작용에 할당되었으므로 상담사의 비공개 전환이 실패했습니다.',

    // AgentCtqCancelFailed
    1047: "연락처를 찾을 수 없습니다.",

    // AgentCtqFailed
    1048: "통화 분배 그룹이 구성되지 않았습니다.",
    1049: '대기열의 최대 대기 시간을 초과했습니다.',
    // StationLoginFailed
    127: '중복 로그인 예외로 인해 상담사 DN 등록이 실패했습니다.'
  },

  stateSelector: {
    Available: '사용 가능',
    errorstatechange: '상태 변경에 실패했습니다. 다시 시도해 주십시오.',
    errorStateChangeInPendingLogout: '보류 중인 로그아웃으로 인해 상담사 상태를 변경하지 못했습니다.',
    label: '사용 가능성 상태',
    agentStateSelector: '상담사 상태 선택기',
    Engaged: '참여함',
    engagedAvailableInfo:
      '현재 상호 작용에 참여 중이며 사용 가능 상태입니다.',
    engagedIdleInfo:
      '현재 상호 작용에 참여 중이며 유휴 상태입니다',
    engagedInfo: '현재 상호 작용에 참여하고 있습니다.',
    engagedSupervisorStateChange: '상태가 다음으로 변경되었음',
    axAgentStateChanged: '상태가 다음으로 변경되었음',
    axAgentSync: '협업 도구와의 상태 동기화로 인한 것입니다.',
    engagedPresenceInfo:
      '현재 상호 작용에 참여 중이며 상태는',
    engagedPresenceSync: '협업 도구와의 상태 동기화로 인한 것입니다.',
    clear: '입력 지우기',
    searchState: '입력',
    agentStatusLabel: '상담사 상태',
    agentStateLabel: '상담사가 마지막 {selectedTimeValue}의 {selectedState} 상태입니다.',
    agentStateLabelOnStateChange: '에이전트가 마지막 0초 동안 {selectedState} 상태입니다',
    agentStateChangeSuccessful:'상태가 {selectedState}(으)로 변경되었습니다.',
    agentStateChangeFail:'{selectedState}(으)로 상태 변경에 실패했습니다.',
    searchError: '상태를 검색하려면 최소 세 자를 입력하십시오.'
  },

  warningMessage: {
    header: '저장하지 않은 변경 사항',
    message:
      '이 페이지에 저장하지 않은 변경 사항이 있습니다. 페이지에서 나가시겠습니까? ',
    cancelButton: '나가지 않기',
    saveButton: '나가기'
  },

  notificationLables: {
    muteVolume: '알림 음소거',
    unmuteVolume: '알림 볼륨 음소거 해제',
    notificationVolume: '알림 볼륨',
    playSound: '알림음 재생',
    enableSoundNotificationSettings: '소리 알림 활성화',
    enableSoundNotificationSettingsDescription:
      '요청이 들어오면 소리 알림을 보냅니다. 아래에서 소리 크기를 조절할 수 있습니다.',
    volumeTitle: '소리 크기'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: '통화',
    chat: '채팅',
    email: '이메일',
    facebook: '메신저',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google의 비즈니스 메시지"
  },
  orgDetailsLabels: {
    role: '역할',
    department: '부서',
    email: '이메일',
    businessPhone: '회사 전화번호',
    workPhone: '직장',
  },
  addressListError: {
    title: '데이터 로드 실패',
    errorId: '오류 ID:'
  },
  keypad: {
    keyPadSearch: '번호 입력',
    dialPad: '다이얼 패드'
  },
  collabTool: {
    userAuthenticated: '사용자 인증:',
    successful: '성공',
    failed: '실패.',
    tryAgain: '다시 시도',
    stateSync: '상태 동기화:',
    mercuryFailedInfo: ' 관리자에게 문의하십시오.',
    retrying: '재시도 중...',
    trackingIdLabel: '추적 ID: '
  },
  webex: {
    webex: 'Webex',
    info: '통합을 사용하면 데스크탑과 Webex 간에 상태를 동기화할 수 있습니다.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: '이 통합을 통해 Microsoft Teams의 사용자에게 상담하거나 전화를 이전할 수 있습니다.',
    authenticationFailedInfo:
      '인증 창이 이미 열려 있으면 거기서 인증을 다시 시도하십시오.',
    ListItemContactDetails:
      '연락처 이름: {name}, 연락처의 현재 위치: {presence}, 부서: {department}, 직위: {jobTitle} 및 전화 번호: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: '응급 서비스 알림',
    readNotification: '알림을 읽었습니다.'
  },
  webexPresenceStatus: {
    active: '활성',
    lastActiveFewMinutesAgo: '지난 몇 분 동안 활동',
    lastActiveMinutesAgo: '{min}분 전에 활동',
    lastActive1HourAgo: '1시간 전에 마지막 활동',
    lastActiveHoursAgo: '{hour}시간 전에 활동',
    lastActiveYesterday: '어제 활동',
    lastActiveOnDate: '{date}에 활동',
    busy: '통화 중',
    busyUntil: '{date}까지 통화 중',
    dnd: '방해사절',
    dndUntil: '{date}까지 방해 금지',
    quiet: '무음',
    quietUntil: '{date}까지 무음',
    ooo: '부재 중',
    outOfOfficeUntil: '{date}까지 부재 중',
    call: '통화 중',
    meeting: '미팅 중',
    calendarItem: '캘린더 미팅 중',
    presenting: '발표 중',
  },
  enterpriseSearch: {
    orgPlaceholder: '이름 또는 프로필 세부 정보로 검색',
    webexPlaceholder: '이름 또는 이메일로 검색',
    refreshTheList: '목록 새로 고침',
    refreshAddressBook: '주소록 새로 고침',
    microsoftAuthError: '표시할 연락처가 없습니다. Microsoft 인증에 실패했습니다.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/nb.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/nb.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Kan ikke laste data',
    errorID: 'Feil-ID',
    tryAgain: 'Prøv på nytt',
    Error: 'Feil',
    okButton: 'OK',
    Yes: 'Ja',
    Cancel: 'Avbryt',
    Confirm: 'Bekreft',
    Continue: 'Fortsett',
    Canceling: 'Avbryter',
    CiscoAiAssistant: 'Cisco KI-assistent',
    Answer: 'Svar',
    AnswerAriaLabel: 'Svare på skrivebordsoppgave',
    Decline: 'Avslå',
    ErrorSecurityCompliance: 'Samsvar knyttet til sikkerhet',
    errorDetails: 'Feildetaljer',
    learnMore: 'Finn ut mer',
    showLess: 'Vis mindre',
    trackingIdDescription:
      'Del sporings-ID-en med nettstedsadministratoren eller støtteteamet for å undersøke forholdet.',
    trackingIdInputLabel: 'Sporings-ID: ',
    submitForm: 'Send skjema',
    unnamedStatus: 'Status uten navn',
    errorChatMsg: 'Kan ikke laste chattedata',
    noOptions: 'Ingen alternativer',
    noResults: 'Ingen resultater',
    more: 'Mer',
    nomatchfound: 'Ingen treff ble funnet',
    collaborationTool: 'Samarbeidsverktøy',
    timerAriaLabel: 'Tid brukt',
    historyItemTime: 'Skjedde på',
    loading: 'Laster',
    months: [
      'Januar',
      'Februar',
      'Mars',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Desember'
    ],
    loadingMsg: 'Laster …',
    search: 'Søk',
    historyChannelLabels: {
      All: 'Alle',
      telephony: 'Stemme',
      chat: 'Chat',
      email: 'E-post',
      social: 'Sosiale kanaler'
    },
    homePageLabel: 'Hjemmeside',
    resizeHistoryDragger: 'Endre størrelse på logg',
    agentHistoryLabel: 'agentlogg',
    clear: 'Fjern inndata',
    ariaLabelAgentHistoryWrapper:
      'Agentsamhandlingslogg viser nylig kundekommunikasjon på tvers av ulike kanaler fra de siste 24 timene',
    sliderResizerInstructions:
      'Du er på en glidebryter. Hvis du vil endre størrelse, bruker du piltastene',
    resizeHistoryPanel: 'Endre størrelse på historikkpanelet, glidebryteren,',
    time: {
      hours: 'time',
      minutes: 'minutt(er)',
      seconds: 'sek'
    }
  },
  email: {
    ToLabel: 'Til',
    FromLabel: 'Fra',
    CcLabel: 'Kopi:',
    BccLabel: 'Blindkopi:',
    SubjectLabel: 'Emne',
    HideLabel: 'Skjul',
    SendLabel: 'Send',
    ShowPrevThread: 'Vis tidligere tråd',
    HidePrevThread: 'Skjul tidligere tråd',
    ReplyLabel: 'Svar',
    ReplyAllLabel: 'Svar alle',
    ViewOriginalMail: 'Vis opprinnelig e-post',
    QuickReplyInp: 'Hurtigsvar her ...',
    AttachFiles: 'Legg til filer',
    ToolbarHeading: 'Overskrift1',
    ToolbarBold: 'Uthevet',
    ToolbarItalic: 'Kursiv',
    ToolbarUnderLine: 'Understreket',
    ToolbarBlockQuote: 'Blokksitat',
    ToolbarCode: 'Kodeblokk',
    ToolbarListOrder: 'Sorter etter Bestilt',
    ToolbarListBullet: 'Sorter etter punkt',
    ToolbarLink: 'Kobling',
    ToolbarStrike: 'Gjennomstreking',
    ToolbarColor: 'Tekstfarge',
    ToolbarTable: 'Tabell',
    insertTable: 'Sett inn tabell',
    insertRowAbove: 'Sett in rad over',
    insertRowBelow: 'Sett inn rad under',
    insertColumnLeft: 'Sett inn kolonne til venstre',
    insertColumnRight: 'Sett inn kolonne til høyre',
    deleteRow: 'Slett rad',
    deleteColumn: 'Slett kolonne',
    deleteTable: 'Slett tabell',
    link: 'Kobling',
    IndentRight: 'Høyre innrykk',
    IndentLeft: 'Venstre innrykk',
    showMoreAttachment: 'Vis flere vedlegg',
    AttachmentLimit: 'Legg ved opptil ',
    attachments: ' vedlegg, ',
    sizeLimit: ' MB maksimalt',
    attachment: 'Vedlegg',
    errordeleteattachment: 'Kan ikke slette filer. Prøv på nytt.',
    errordownloadattachment: 'Kan ikke laste ned filer. Prøv på nytt.',
    erroraddattachemnt: 'Kan ikke laste opp filer. Prøv på nytt.',
    errorendcontact: 'Kan ikke avslutte samhandlingen. Prøv på nytt.',
    erroraddlimitreached:
      'Kan ikke legge til filen fordi den er for stor ',
    errorattachmentdrop:
      'Vedlegg har blitt forkastet i henhold til selskapets retningslinjer for sikkerhet.',
    errorfiletype: 'Filtypen støttes ikke. Prøv på nytt.',
    errorcreditcard:
      'Kan ikke laste opp vedlegg, i henhold til selskapets retningslinjer for sikkerhet.',
    errorcontainsimage:
      'Kan ikke laste opp vedlegg. Bilder i vedleggene støttes ikke av selskapets retningslinjer for sikkerhet.',
    errorlimit: ' MB-grense.',
    errorsendemail: 'Kan ikke sende e-posten. Prøv på nytt.',
    errorpcicheckemail: 'Kan ikke hente PCI-data. Prøv på nytt.',
    errortext: 'Kan ikke laste data',
    tryAgain: 'Prøv på nytt',
    replywarning:
      'Meldingen eller vedleggene må ikke inneholde økonomiske opplysninger, helseopplysninger eller personopplysninger.',
    datamasked:
      'Emnet eller innholdet i e-posten har blitt dekket til i henhold til selskapets retningslinjer for sikkerhet. Er du sikker på at du vil sende e-posten?',
    pcibannerwarning:
      'Emnet eller innholdet i e-posten har blitt dekket til i henhold til selskapets retningslinjer for sikkerhet.',
    on: 'På',
    wrote: 'skrev'
  },
  interaction_control: {
    windowOpened: 'Vinduet åpnet',
    connected: 'Tilkoblet',
    consultRequested: 'Konsultasjon forespurt',
    consulting: 'Konsultasjon pågår',
    consultCallOnHold: 'Konsultasjon på vent',
    callOnHold: 'Samtale på vent',
    consult: 'Konsultasjon',
    endconsult: 'Avslutt konsultasjon',
    hold: 'Vent',
    transfer: 'Overfør',
    conference: 'Konferanse',
    endconference: 'Avslutt konferanse',
    conferenceRequested: 'Konferanse forespurt',
    switchCall: 'Bytt',
    mergeCall: 'Slå sammen',
    wrapup: 'Avslutning',
    end: 'Avslutt',
    customername: 'Kundenavn',
    dn: 'DNIS',
    ivrpath: 'IVR-bane',
    email: 'Kunde-e-post',
    ani: 'Telefonnummer',
    queueid: 'Kønavn',
    ronatimeout: 'Rona-tid',
    pathid: 'IVR-bane-ID',
    dnis: 'DNIS',
    destagentphonenumber: 'Agent-DN',
    destagentname: 'Agentnavn',
    virtualteamname: 'Kø',
    category: 'Kategori',
    additionaldetails: 'Ytterligere opplysninger',
    sourcenumber: 'Kildenummer',
    sourcepage: 'Kildeside',
    appuser: 'Appbruker-ID',
    customernumber: 'Telefonnummer',
    exitconference: 'Avslutt konferanse',
    resume: 'Gjenoppta',
    pauserecording: 'Paus opptak',
    resumerecording: 'Gjenoppta opptak',
    exitconsult: 'Avslutt konsultasjon',
    pauseRecordingFailed: 'Kan ikke pause opptak. Prøv på nytt.',
    resumeRecordingFailed: 'Kan ikke gjenoppta opptak. Prøv på nytt.',
    holdCallFailed: 'Kan ikke sette samtalen på vent. Prøv på nytt.',
    resumeCallFailed: 'Kan ikke gjenoppta samtalen. Prøv på nytt.',
    endCallFailed: 'Kan ikke avslutte samhandlingen. Prøv på nytt.',
    consultTransferFailed:
      'Kan ikke overføre konsultasjonssamtalen. Prøv på nytt.',
    conferenceTransferFailed:
      'Kan ikke overføre konferansesamtalen. Prøv på nytt.',
    conferenceFailed:
      'Kan ikke koble til konferanseforespørselen. Prøv på nytt.',
    consultEndFailed: 'Kan ikke avslutte konsultasjonsforespørselen. Prøv på nytt.',
    conferenceExitFailed:
      'Kan ikke gå ut av konferanseforespørselen. Prøv på nytt.',
    conferenceEndFailed:
      'Kan ikke avslutte konferanseforespørselen. Prøv på nytt.',
    cancelCtqFailed:
      'Kan ikke avbryte konsultasjonssamtalen til køen. Prøv på nytt.',
    privacyShield: 'Personvern',
    errorOnPrvacyShieldForConsult:
      'Opptak er for øyeblikket satt på pause. Gjenoppta opptaket for å starte en konsultasjonssamtale.',
    errorOnPrvacyShieldForTransfer:
      'Opptak er for øyeblikket satt på pause. Gjenoppta opptaket for å starte en overføringssamtale.',
    cancelConsult: 'Avbryt konsultasjon',
    cancelTransfer: 'Avbryt overføring',
    copy: 'Kopier',
    copied: 'Kopiert',
    cadrequestuccess: 'Kundeinformasjon har blitt lagret.',
    cadrequestfailure: 'Kunne ikke lagre kundeinformasjon. Prøv på nytt senere.',
    cadupdatedmessage: 'Kundeinformasjon ble nylig oppdatert av',
    unsavedmessage: 'De ulagrede endringene dine har blitt overskrevet.',
    save: 'Lagre',
    revert: 'Tilbakestill',
    expandDetails: 'Utvid detaljer',
    collapseDetails: 'Skjul detaljer',
    cadValidationError:
      'Ugyldig format. Bruk den internasjonale standarden for dato og klokkeslett.',
    secureCadSaveError:
      'Kundeinformasjon er ikke lagret. Klikk på Lagre for å prøve på nytt.',
    secureDecryptionError: 'Kan ikke vise sikre variabler.',
    clickToTry: 'Klikk for å prøve på nytt',
    isSecureVariable: 'er en sikker variabel',
    contactorigin: 'Kontakt opprinnelse',
    resumeMonitoring: 'Gjenoppta overvåking',
    pauseMonitoring: 'Stans overvåking midlertidig',
    whisperCoach: 'Hviskende veileder',
    bargeIn: 'Bryt inn',
    endMonitoring: 'Avslutt overvåking',
    contactphonenumber: 'Kontaktens telefonnummer',
    contactqueue: 'Kontaktkø',
    activeparticipants: 'Aktive deltakere',
    consultedparticipant: 'Konsultert deltaker',
    contactstatus: 'Kontaktstatus',
    timeincontactstatus: 'Tid i kontaktstatus',
    totalcontactduration: 'Total kontaktvarighet',
    agentinteractiontime: 'Varighet av interaksjon',
    recording: 'Innspilling',
    monitoring: 'Overvåking',
    monitoringPaused: 'Overvåking midlertidig stanset',
    pauseMonitoringFailed: 'Kan ikke midlertidig stanse overvåkingen. Prøv på nytt.',
    resumeMonitoringFailed: 'Kan ikke gjenoppta overvåkingen. Prøv på nytt.',
    callCancelledInProgress: 'Samtaleavbryting pågår',
    bargedIn: 'Brutt inn',
    keypad: 'Tastatur',
    mute: 'Demp',
    unmute: 'Slå av demping',
    bargeInTooltipText:
      'Mikrofonen vil slås på, og du kommer til å bli med i denne kundesamhandlingen',
    bargeInCompactTooltipText:
      'Bryt inn. Mikrofonen vil slås på, og du kommer til å bli med i denne kundesamhandlingen',
    bargeInTooltipDisabled: 'Gjenoppta overvåking for å aktivere Bryt inn',
    bargeInFailedTitle: 'Bryt inn mislyktes',
    bargeInFailedData:
      'Det oppstod en feil da du prøvde å bryte inn i. Prøv på nytt etter en stund.',
    supervisorBargedIn: 'har kommet inn i anrop din.',
    leftInteraction: 'har forlatt samhandlingen.',
    conferenceEnded: 'Konferansesamtalen er avsluttet.',
    participants: 'Deltakere',
    badgeAriaLabel: '{participant} er i samtalen',
    bargeInConferenceAriaLabel: 'Det er to deltakere i samhandlingen',
    taskName: 'Navn på samhandlingskontrolloppgave',
    interactionDurationLabel: 'Varighet',
    wrapupassist: 'Avslutningsassistanse',
    consultingTaskContext: 'Konsulentsamtale fra',
    consultExited: 'Rådfør deg med avsluttet samtale',
    endCall: 'Avslutt samtalen.',
    exitconferenceCall:
      'Avslutt samtalen og konferansen fortsetter med aktive deltakere.',
    recordingInProgess: 'Innspilling pågår',
    recordingPaused: 'Opptaket er satt på pause',
    searchPlaceholder: 'Søk etter kontakter',
    postCall: "Etter anrop",
    switchCallTooltip: "Bytt til anrop",
    switchConsultTooltip: "Bytt til konsultasjonsanrop",
    switchConferenceTooltip: "Bytt til konferansesamtale",
    confirmationDialog: {
      endCallTitle: 'Vil du avslutte samtalen?',
      endCallMessage: 'Klikk på Bekreft for å avslutte samtalen for alle deltakerne.',
      exitConferenceTitle: 'Vil du avslutte konferansesamtalen?',
      exitConferenceMessage:
        'Klikk på Bekreft for å avslutte konferansesamtalen og la de andre deltakerne fortsette.',
      confirmButtonLabel: "Bekreft",
      cancelButtonLabel: "Avbryt",  
    },
    postCallOnHold: "På vent etter anrop",
    postCallConsult: "Konsultasjon etter anrop",
    postCallConsultOnHold: "Konsultasjon etter anrop på vent",
  },
  agentProfile: {
    teamName: 'Team',
    dialNumber: 'Oppringingsnummer',
    phoneNumber: 'Telefonnummer',
    settings: 'Endre innstillinger',
    signOut: 'Logg av',
    webRTCDisconnected: 'Advarsel: Stasjonær PC-telefoni er frakoblet ',
    msAuthFailed: 'Microsoft-godkjenning mislyktes',
    stateSyncFailed: 'Tilstandssynkronisering mislyktes',
    userProfileLabel: 'Brukerprofil',
    ariaAgentprofile: 'Agentprofil',
    ChannelCapacity: 'Kanalkapasitet',
    voice: 'Stemme',
    chat: 'Chat',
    email: 'E-post',
    social: 'Sosiale kanaler',
    channelCapacityTooltip: 'Klikk for å se mer',
    blendedRouting: 'Blandet',
    exclusiveRouting: 'Eksklusiv distribusjon',
    realtimeRouting: 'Blandet distribusjon i sanntid',
    blendedRoutingTooltip: 'Behandle flere kontakter samtidig på tvers av kanaler.',
    exclusiveRoutingTooltip: 'Behandle bare én kontakt om gangen.',
    realtimeRoutingTooltip: 'Behandle én obligatorisk sanntidskanal.',
    errorActiveContacts:
      'Du kan ikke logge av nå fordi du har aktive samtaler. Fullfør dem og prøv på nytt.',
    searchTeams: 'Søk etter Team',
    changeTeamsConfirmHeader: 'Bekreftelse for endring av team',
    changeTeamsConfirmMessage: 'Er du sikker på at du vil endre teamet ditt?',
    changeTeamLabel: 'Endre team',
    errorChangeTeams:
      'Du kan ikke endre teamet for øyeblikket fordi du har aktive forespørsel(er). Vennligst fullfør de og prøv igjen.',
    saveTeamSelection: 'Lagre teamvalg',
    userSettings: 'Brukerinnstillinger',
    resetLayout: 'Tilbakestill hele skrivebordsoppsettet',
    resetConfirmHeader: 'Bekreftelse for tilbakestilling av oppsett',
    resetConfirmMessage:
      'Er du sikker på at du vil tilbakestille hele skrivebordsoppsettet? <br/> Skrivebordet blir tilbakestilt til standardoppsettet.',
    downloadLogs: 'Last ned feilrapport',
    help: 'Hjelp',
    signoutConfirm: 'Er du sikker på at du vil logge av?',
    signoutConfirmHeader: 'Bekreftelse for avlogging',
    darkTheme: 'Bytt til nattmodus',
    newLook: 'Bytt til nytt utseende',
    keyboardShortcuts: 'Tastatursnarveier',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Varslingsinnstillinger',
    silentNotification: 'Lydløst varsel',
    enableNotificationSettings: 'Aktiver varsler',
    enableSilentNotificationSettings: 'Aktiver lydløse varsler',
    suppressWebexCallingNotificationSettings: 'Skjul Webex Calling-varsler',
    notificationSettingDescription:
      'Leverer varsler som nye meldinger, varsler og statusendringer.',
    silentNotificationDescription:
      'Slår av varsler på skjermen. Du kan se varslene i varslingssenteret.',
    suppressWebexCallingNotificationDescription: 
    'Ikke vis popup-varsler for innkommende Webex-anrop, og svar på dem via Webex Contact Center.',
    arrowLabel: 'Gå tilbake',
    managedTeams: 'Administrere team',
    managedTeamsError: 'Kunne ikke laste grupper.',
    viewAll: 'Vis alle',
    profileSettings: 'Profilinnstillinger',
    userRole: 'Rolle',
    saveSelection: 'Lagre merket område',
    extension: 'Internnummer',
    changeProfileConfirmHeader: 'Bekreft endringer i profilinnstillinger',
    changeProfileConfirmMessage:
      'Er du sikker på at du vil lagre profilendringene?',
    confirm: 'Bekreft',
    errorProfileUpdate:
      'Du kan ikke endre profilinnstillingene for øyeblikket fordi du har aktive forespørsler. Vennligst fullfør dem og prøv igjen.',
    roleAgentSupervisor: 'Leder og agent',
    roleSupervisor: 'Tilsynsperson',
    noTeam: 'Ingen gruppe',
    testYourNetwork: 'Test nettverket',
    speakerAndMic: 'Høyttaler og mikrofon',
    speaker: 'Høyttaler',
    mic: 'Mikrofon',
    speakerDescription:
      'Velg og test enhetens utdataenhet for å sikre at du hører anroperen.',
    micDescription:
      'Velg og test enhetens inndataenhet for å sikre at anroperen hører deg.',
    micError:
      'Ingen tilgang til mikrofon. Aktiver tilgang ved hjelp av nettleserinnstillinger, eller kontakt administrator.',
    speakerError:
      'Taler er ikke tilgjengelig fordi tilgang til mikrofon er avslått.',
    telephony: 'Telefoni',
    desktop: 'Skrivebord',
    onSpeakerPlay:
      'Hvis du ikke kan høre testlyden, må du kontrollere høyttalerenheten.',
    onMicPlay:
      'Hvis du ikke kan høre testlyden, må du kontrollere både høyttaleren og mikrofonen.',
    onMicRecord: 'Spill inn en melding for avspilling.',
    test: 'Test',
    recording: 'Opptak',
    playing: 'Spiller av',
    reconnecting: 'Kobler til på nytt',
    disconnectMessage:
      'Skrivebordstelefoni er frakoblet. Prøv et annet alternativ for telefoni.',
    singleTelephonyDisconnectMessage:
      'Skrivebordstelefoni er frakoblet. Kontakt administrator.',
    clear: 'Fjern inndata',
    rememberMeCheckBoxMessage: "Ikke vis dette igjen",
    saveLabel: 'Lagre',
    browserUnsupportedError: "Påloggingen mislyktes fordi du bruker en nettleser som ikke støttes.",
    microphoneAccessDeniedError: "Ingen tilgang til mikrofon. Aktiver tilgang ved hjelp av nettleserinnstillinger, eller kontakt administrator.",
  },
  contactHistory: {
    mainHeader: 'Kontakthistorikk',
    handledBy: 'Behandlet av',
    noRecordFound: 'Finner ingen kontaktlogg!',
    tryAgain: 'Prøv på nytt',
    errorMsg: 'Kan ikke hente kontakthistorikk. Prøv på nytt.',
    errorID: 'Feil-ID',
    missingAni: 'ANI mangler',
    timeIcon: 'Varighet',
    taskHandled: 'Oppgave behandlet',
    noHistoryNew: 'Ingen logg',
    noHistory: 'Ingen logg',
    viewTranscript: 'Vis e-postmeldinger',
    transcriptFor: 'Utskrifter for',
    editBeforeCall: 'Rediger før samtale',
    clickToCall: 'Klikk for å ringe',
    onAnActiveCallErrorMessage:
      'Du kan ikke starte en ny samtale ettersom du allerede er i en aktiv samtale.',
    receivedFrom: 'Kontakt mottatt fra',
    initiatedTo: 'Kontakt initiert til',
    wrapUpReason: 'Årsak til avslutning',
    startCallTelephony:
      'Klikk på telefonnummerkoblingen for å starte et utgående anrop.',
    contactHistoryList: 'Kontakthistorikkliste,',
    wrapUpCode: 'Avslutningskode',
    agentName: 'Agentnavn',
    entryPointName: 'Inngangspunkt',
    acceptedTimeAndDate: 'Klokkeslett og dato for godkjennelse',
    duration: 'Varighet',
    emailTranscript: 'E-postutskrift',
    clickToViewEmailTranscript: 'Klikk for å se e-postutskrift',
    listContainer: 'Liste beholder'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Inngangspunkt',
    date: 'Dato',
    subject: 'Emne',
    from: 'Fra',
    sent: 'Sendt',
    to: 'Til',
    back: 'Tilbake',
    errorTranscript: 'Det oppstod en feil under henting av utskrifter',
    customer: 'Kunde',
    inboundErrorMessage: 'Kan ikke laste kunde-e-posten',
    outboundErrorMessage: 'Kan ikke laste agentsvaret'
  },
  popoverTitle: {
    callback: 'Tilbakeringing',
    outboundCall: 'Utgående anrop',
    incomingCall: 'Innkommende anrop',
    progressiveCampaign: 'Kampanjesamtale',
    courtesyCallback: 'Høflig tilbakeringing',
    chat: 'Innkommende chat',
    incoming: 'Innkommende',
    monitoringCall: 'Overvåkingssamtale'
  },
  connecting: 'Kobler til',
  initiating: 'Initierer',
  outbound: 'Utgående',
  transfer: {
    title: 'Overføringsforespørsel',
    heading: {
      chat: 'Velg agenten eller køen du vil overføre til.',
      email: 'Velg køen du vil overføre til.',
      telephony:
        'Velg agenten, køen eller telefonnummeret du vil overføre til.',
      noQueueTelephony:
        'Velg agenten eller telefonnummeret du vil overføre til.'
    },
    header: {
      chat: 'Velg agenten eller køen for å overføre denne kontakten.',
      email: 'Velg køen for å overføre denne kontakten.',
      telephony:
        'Velg agenten, køen, oppringningsnummeret eller organisasjonen for å overføre denne kontakten.',
      noQueueTelephony:
        'Velg agenten, oppringningsnummeret eller organisasjonen for å overføre denne kontakten.',
      noOrganizationTelephony:
        'Velg agenten, køen eller oppringningsnummeret for å overføre denne kontakten.',
      noQueueOrganizationTelephony:
        'Velg agenten eller oppringningsnummeret for å overføre denne kontakten.'
    },
    queues: 'Kø',
    agents: 'Agent',
    dialNumber: 'Oppringingsnummer',
    organization: 'Organisasjon',
    placeholder: {
      Queues: 'Velg fra en liste over køer',
      Agents: 'Velg fra en liste over agenter',
      DialNumber: 'Velg med navn eller nummer',
      DialNumberOrEntryPoint: 'Velg etter navn/nummer/inngangspunkt',
      ChooseByNameOrNumber: 'Velg med navn/nummer',
      Organization: 'Søk etter navn/rolle/avdeling/arbeidstelefon',
      WebexOrganization: 'Søk med navn eller e-post',
      DialNumberSearch: 'Søk med navn eller nummer'
    },
    type: 'Overfør',
    cancel: 'Avbryt',
    closeModal: 'Lukk modal',
    failureError: 'Kan ikke overføre forespørselen. Prøv på nytt.',
    entryPoint: 'Inngangspunkt'
  },
  consult: {
    title: 'Konsultasjonsforespørsel',
    heading: {
      chat: 'Velg agenten eller køen du vil overføre til.',
      email: 'Velg køen du vil overføre til.',
      telephony:
        'Velg agenten, køen eller telefonnummeret du vil rådføre deg med.',
      noQueueTelephony:
        'Velg agenten eller telefonnummeret du vil rådføre deg med.'
    },
    header: {
      chat: 'Velg agenten eller køen for å overføre denne kontakten.',
      email: 'Velg køen for å overføre denne kontakten.',
      telephony:
        'Velg agenten, køen, oppringingsnummeret eller organisasjonen du ønsker å konsultere med.',
      noQueueTelephony:
        'Velg agenten, oppringingsnummeret eller organisasjonen du vil konsultere med.',
      noOrganizationTelephony:
        'Velg agenten, køen eller oppringingsnummeret du vil konsultere med.',
      noQueueOrganizationTelephony:
        'Velg agenten eller ringenummeret du vil konsultere med.'
    },
    queues: 'Kø',
    agents: 'Agent',
    dialNumber: 'Oppringingsnummer',
    organization: 'Organisasjon',
    placeholder: {
      Queues: 'Velg fra en liste over køer',
      Agents: 'Velg fra en liste over agenter',
      DialNumber: 'Velg med navn eller nummer',
      DialNumberOrEntryPoint: 'Velg etter navn/nummer/inngangspunkt',
      ChooseByNameOrNumber: 'Velg med navn/nummer',
      Organization: 'Søk etter navn/rolle/avdeling/arbeidstelefon',
      WebexOrganization: 'Søk med navn eller e-post',
      DialNumberSearch: 'Søk med navn eller nummer'
    },
    type: 'Konsultasjon',
    checkBoxLabel: 'La deltakerne fortsette å samhandle.',
    cancel: 'Avbryt',
    closeModal: 'Lukk modal',
    failureError: 'Kan ikke koble til konsultasjonsforespørselen. Prøv på nytt.',
    customerLeftMsg: 'Kunden ble koblet fra. Konsultasjon er ikke lenger nødvendig.',
    ctqFailureMsg:
      'Kan ikke avbryte konsultasjonssamtalen til køen. Prøv på nytt.',
    cancelCtqInfo:
      'Søker etter en tilgjengelig agent i den valgte køen. Vent litt, eller avbryt konsultasjonsforespørselen.',
    cancelCtqAction: 'Avbryt konsultasjon.',
    entryPoint: 'Inngangspunkt'
  },
  conference: {
    title: 'Konferanseforespørsel',
    heading: {
      chat: 'Velg en bestemt agent for en konferansechat'
    },
    queues: 'Kø',
    agents: 'Agent',
    dialNumber: 'Oppringingsnummer',
    organization: 'Organisasjon',
    placeholder: {
      Queues: 'Velg fra en liste over køer',
      Agents: 'Velg fra en liste over agenter',
      DialNumber: 'Velg med navn eller nummer'
    },
    type: 'Konferanse',
    cancel: 'Avbryt',
    closeModal: 'Lukk modal',
    failureError: 'Kan ikke starte denne konferanseforespørselen. Prøv på nytt.'
  },
  transferModal: {
    Agents: 'Kan ikke hente listen over agenter. Oppdater listen.',
    AgentsEmpty: 'Ingen agent tilgjengelig',
    Queues: 'Kan ikke hente listen over køer. Oppdater listen.',
    QueuesEmpty: 'Ingen køer tilgjengelig',
    EPEmpty: 'Ingen inngangspunkt tilgjengelig',
    DialNumber:
      'Kan ikke hente listen over oppringingsnumre fra adresseboken. Oppdater listen.',
    EntryPoint:
      'Kan ikke hente listen med inngangspunktnumre. Last listen på nytt.',
    Common: 'Kan ikke hente listen. Last listen på nytt.',
    DialNumberEmpty: 'Ingen ringenumre tilgjengelige',
    DialNumbInvalid:
      'Oppringingsnummeret er ugyldig. Kontakt administrator.',
    DialNumbOrEntryPointInvalid:
      'Oppringingsnummer/inngangspunkt er ugyldig. Kontakt administrator.',
    refreshQueueList: 'Oppdater listen over køer',
    refreshAgentList: 'Oppdater listen over agenter',
    refreshEpList: 'Oppdatere inngangspunktene',
    refreshAddressBook: 'Oppdater adresseboken',
    refreshTheList: 'Oppdater listen',
    entryPointSectionLabel: 'Inngangspunkt',
    addressBookSectionLabel: 'Adressebok',
    organization: 'Organisasjon',
    comboBoxAriaLabelAgent: 'Velg fra en liste over agenter',
    comboBoxAriaLabelQueue: 'Velg fra en liste over køer',
    comboBoxAriaLabelEp: 'Velge fra en liste over inngangspunkter',
    infScrollAgent: 'Søke agenter',
    infScrollQueue: 'Søk i køer',
    infScrollEP: 'Søk i inngangspunkter',
    allRadioButtonHidedTextForConsult: 'Du har ingen tilordnede enheter til å konsultere denne samhandlingen. Kontakt administratoren.',
    allRadioButtonHidedTextForTransfer: 'Du har ingen tilordnede enheter til å overføre denne samhandlingen. Kontakt administratoren.',
    allRadioButtonHidedTextForConference: 'Du har ingen tilordnede enheter til å konferere denne samhandlingen. Kontakt administratoren.',
    searchMinCharError: 'Skriv inn minst tre tegn for å søke.',
  },
  wrapup: {
    cancelautowrapup: 'Avbryt automatisk avslutning',
    wrapupreason: 'Avslutningsårsaker',
    untilautowrapup: 'inntil automatisk avslutning',
    followupsetting: 'Innstilling for oppfølging',
    lastagentroute: 'Siste agent-ruting',
    submitwrapup: 'Send avslutning',
    wrapupsearch: 'Søk etter avslutningsårsak',
    invalidationError: 'Kan ikke sende avslutning',
    searchResult: 'Tilgjengelige søkeresultater',
    noResultFound: 'Fant ingen søkeresultater',
    listContainerLabel: 'Ferdigstillingsdataliste beholder',
    searchError: 'Skriv inn minst tre tegn for å søke etter avslutningsgrunner.',
  },

  outdial: {
    call: 'Samtale',
    dialpadSearch: 'Angi nr. som skal ringes',
    addressSearch: 'Søk med navn/nummer',
    addressTab: 'Adresse',
    addressTabTooltip: 'Søk i adressebok',
    dialpadTab: 'Tastatur',
    dialpadTooltip: 'Slå et nummer',
    searchTab: 'Søk',
    searchTabTooltip:'Søke etter personer i organisasjonen',
    noAdrFound: 'Ingen treff ble funnet',
    noContacts: 'Ingen kontakter',
    mainIconTooltip: 'Utgående anrop',
    errorOutdialFailed:
      'Utgående anrop feilet. Skrivebordet kunne ikke koble til anropet, eller anropet ble ikke besvart.',
    errorOutdialDisabled: 'Utgående anrop er deaktivert',
    errorDialPadValidationMessage: 'Uriktig format',
    outdialReqInProgress: 'Utgående anrop pågår',
    outdialAniPlaceholder: 'Velg utgående ANI',
    outdialAniLabel: 'Utgående ANI',
    outdialAniPlaceHolder: 'Søk etter oppringings-ANI',
    errorDcCallsLimitExceeded:
      'Datasenteret har nådd maksimumsgrensen for utgående anrop. Kan ikke foreta flere utgående anrop',
    errorOrgCallsLimitExceeded:
      'Organisasjonen har nådd maksimumsgrensen for utgående anrop. Kan ikke foreta noen flere utgående anrop.',
    errorOutDialNoAnswerFromCustomer:
      'Kunden besvarte ikke anropet ditt. Prøv å ringe senere.',
    errorOutDialCustomerUnavailable:
      'Kunden er ikke tilgjengelig nå. Prøv å ringe senere.',
    errorOutDialAgentEnds: 'Du har avsluttet samtalen med kunden.',
    errorOutDialCustomerBusy: 'Kunden er opptatt nå. Prøv å ringe senere.',
    searchError: 'Skriv inn minst tre tegn for å søke i kontaktene.',
    upArrowLabel: 'Utvid',
    clear: 'Fjern inndata',
    outdialDialogDescription: 'Du er for øyeblikket i dialogen med faner.'
  },

  organization: {
    noMatchFound: 'Ingen treff ble funnet',
    searchError: 'Skriv inn minst tre tegn for å søke i kontaktene.',
    authError: 'Ingen kontakter å vise. Microsoft-godkjenning mislyktes.'
  },

  interactionPopover: {
    of: 'av',
    accept: 'Godta',
    acceptAriaLabel: 'Godta oppgave {taskNumber} – {taskType} fra {from}',
    requests: 'Forespørsel/forespørsler',
    back: 'tilbake',
    next: 'neste',
    acceptMultipleRequest: 'Godta {requestCount} forespørsler',
    paginationDetail: '{indexStart}-{indexEnd} av {totalPopoverpoolLength}',
    hidePopoverDetails: 'Skjul detaljer i popup-melding',
    showPopoverDetails: 'Vis detaljer i popup-melding',
    customerName: 'Kundenavn',
    email: 'E-post',
    queueName: 'Kønavn',
    failedToAccept: 'Kan ikke godta.',
    unableToAccept: 'Kan ikke godta kontakten.',
    failedToEnd: 'Kan ikke avslutte.',
    unableToEnd: 'Kan ikke avslutte kontakten. ',
    ringing: 'Ringing',
    calling: 'Ringer',
    phoneNumber: 'Telefonnummer',
    dni: 'DNIS',
    ivrPathId: 'IVR-bane-ID',
    pathId: 'Bane-ID',
    rona: 'RONA',
    sourcePage: 'Kildeside',
    sourceNumber: 'Kildenummer',
    appUserId: 'Appbruker-ID',
    acceptAll: 'Godta alle oppgaver',
    agentDn: 'Agent-DN',
    agentName: 'Agentens navn',
    agentTeam: 'Agentgruppe',
    requestDetails: 'Forespørselsdetaljer',
    incomingCallFrom: 'Innkommende anrop fra',
    unableToAnswer: 'Kan ikke svare på samtalen. Prøv på nytt.',
    unableToDecline: 'Kan ikke avvise samtalen. Prøv på nytt.'
  },

  multiLogin: {
    header: 'Varsel om flere pålogginger',
    message:
      'Du er logget på Skrivebordet i flere programmer. Klikk på Fortsett hvis du vil fortsette med Skrivebordet i dette programmet. Lukk vinduet hvis ikke.',
    continue: 'Fortsett'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Overføring til inngangspunkt/kø mislyktes på grunn av en konfigurasjonsfeil.',
    1010: "Kan ikke konsultere siden agenten ikke kunne tildeles i tide. ",
    1042: "Kontakten ble ikke funnet",
    1043: 'Destinasjonen er ugyldig.',
    1045: 'Samhandlingen er ikke tilordnet til agenten.',
    1046: 'Agentkonsultasjon mislykket siden det ikke ble funnet noen samsvarende agentkanal i systemet.',
    1038: "Agenten ble ikke funnet",
    1037: 'Påloggingen mislyktes på grunn av en intern feil.',

    // Media Events
    138: 'Handlingen mislyktes på grunn av ukjente årsaker.',
    136: 'Brukeren ble ikke funnet',

    // AgentConsultFailed
    1050: 'Kan ikke konsultere grunnet ustøttet konfigurasjon eller aktivitet i flyten. ',
    1005: "Kan ikke konsultere fordi agenten ikke besvarte forespørselen i tide.",
    1051: 'Kan ikke konsultere eller overføre på grunn av et ugyldig inngangspunkt eller inntastet nummer.',

    // AgentInviteFailed
    1053: 'Kan ikke vise samhandlingen grunnet en ventende oppgave for ny kø for arbeidsflyt.',
    1054: 'Kan ikke foreta en oppringing grunnet medieproblemer med denne forespørselen. ',

    // AgentContactAssignFailed
    1011: 'Kan ikke svare på eller godta samtalen på grunn av manglende agenter i den pågående interaksjonen. ',

    // ContactCallbackFailed
    1034: 'Ring tilbake til kontakten mislyktes fordi KontaktParkingTimeout er mottatt for forespørselen.',

    // ContactUpdateFailed
    1020: "Kan ikke oppdatere variablene fordi én av verdiene overskrider tegngrensen på 256. Reduser tegnene og prøv på nytt.",

    // AgentInviteFailed
    1031: 'Agenten har invitert kunden etter at det har blitt bedt om tilbakeringing.',

    // AgentBlindTransferFailedEvent
    1044: 'Agentens blindoverføring mislyktes ettersom destinasjonsagenten er tilordnet til en annen samhandling.',

    // AgentCtqCancelFailed
    1047: "Kontakten ble ikke funnet.",

    // AgentCtqFailed
    1048: "Anropsdistribusjonsgruppen er ikke konfigurert.",
    1049: 'Den maksimale ventetiden i køen er overskredet.',
    // StationLoginFailed
    127: 'Registrering for agentens DN mislyktes pga. dobbeltpålogging.'
  },

  stateSelector: {
    Available: 'Tilgjengelig',
    errorstatechange: 'Tilstandsendringen ble ikke fullført. Prøv på nytt.',
    errorStateChangeInPendingLogout: 'Kan ikke endre agent status på grunn av ventende avlogging.',
    label: 'Tilgjengelighetsstatus',
    agentStateSelector: 'Agenttilstandsselektor',
    Engaged: 'Innkoblet',
    engagedAvailableInfo:
      'Du er innkoblet i en samhandling og i tilgjengelig status.',
    engagedIdleInfo:
      'Du er innkoblet i en samhandling og i inaktiv status.',
    engagedInfo: 'Du er for øyeblikket opptatt i en samhandling.',
    engagedSupervisorStateChange: 'har endret tilstanden til',
    axAgentStateChanged: 'Din tilstand endret til',
    axAgentSync: 'på grunn av tilstandssynkronisering med samarbeidsverktøyet ditt.',
    engagedPresenceInfo:
      'Du er for øyeblikket opptatt i en samhandling og statusen din er',
    engagedPresenceSync: 'på grunn av tilstandssynkronisering med samarbeidsverktøyet ditt.',
    clear: 'Fjern inndata',
    searchState: 'inndata',
    agentStatusLabel: 'Agentstatus',
    agentStateLabel: 'Agenten har vært i {selectedState} tilstand de siste {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Agent har vært i tilstand {selectedState} de siste 0 sek.',
    agentStateChangeSuccessful:'Tilstandsendring til {selectedState} vellykket.',
    agentStateChangeFail:'Statusendring til {selectedState} mislykket.',
    searchError: 'Skriv inn minst tre tegn for å søke etter status.'
  },

  warningMessage: {
    header: 'Ulagrede endringer',
    message:
      'Du har ulagrede endringer på denne siden. Er du sikker på at du vil forlate siden? ',
    cancelButton: 'Bli værende',
    saveButton: 'Forlat'
  },

  notificationLables: {
    muteVolume: 'Demp varslingsvolumet',
    unmuteVolume: 'Slå på varslingsvolumet',
    notificationVolume: 'Varslingsvolum',
    playSound: 'Spill av varslingslyd',
    enableSoundNotificationSettings: 'Aktiver lydvarsler',
    enableSoundNotificationSettingsDescription:
      'Lever lydvarsler for innkommende forespørsler. Du kan justere volumet nedenfor.',
    volumeTitle: 'Lydvolum'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Samtale',
    chat: 'Chat',
    email: 'E-post',
    facebook: 'Meldingsservice',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Apple Business chat',
    googleBusiness: "Googles forretningsmeldinger"
  },
  orgDetailsLabels: {
    role: 'Rolle',
    department: 'Avdeling',
    email: 'E-post',
    businessPhone: 'Arbeidstelefon',
    workPhone: 'Arbeid',
  },
  addressListError: {
    title: 'Kan ikke laste data',
    errorId: 'Feil-ID:'
  },
  keypad: {
    keyPadSearch: 'Angi nummeret',
    dialPad: 'Nummertastatur'
  },
  collabTool: {
    userAuthenticated: 'Brukergodkjenning:',
    successful: 'Vellykket',
    failed: 'Mislyktes.',
    tryAgain: 'Prøv på nytt',
    stateSync: 'Tilstandssynkronisering:',
    mercuryFailedInfo: ' Kontakt administratoren din.',
    retrying: 'Prøver på nytt ...',
    trackingIdLabel: 'Sporings-ID: '
  },
  webex: {
    webex: 'Webex',
    info: 'Integrering lar deg synkronisere tilstander mellom skrivebord og Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Med denne integrasjonen kan du konsultere eller overføre anrop til brukere av Microsoft Teams.',
    authenticationFailedInfo:
      'Hvis et godkjenningsvindu allerede er åpent, prøv å godkjenne på nytt der.',
    ListItemContactDetails:
      'Navnet på kontakten er: {name}, dens tilstedeværelse er: {presence}, avdeling er: {department}, jobbtittel er: {jobTitle} og telefonnummeret er: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Nødtjenestevarsling',
    readNotification: 'Jeg har lest meldingen.'
  },
  webexPresenceStatus: {
    active: 'Aktiv',
    lastActiveFewMinutesAgo: 'Aktiv de siste minuttene',
    lastActiveMinutesAgo: 'Aktiv for {min} minutter siden',
    lastActive1HourAgo: 'Siste aktivitet 1 time siden',
    lastActiveHoursAgo: 'Aktiv for {hour} timer siden',
    lastActiveYesterday: 'Aktiv i går',
    lastActiveOnDate: 'Sist aktiv {date}',
    busy: 'Opptatt',
    busyUntil: 'Opptatt til {date}',
    dnd: 'Ikke forstr.',
    dndUntil: 'Ikke forstyrr før {date}',
    quiet: 'Stille',
    quietUntil: 'Stille til {date}',
    ooo: 'Fraværende',
    outOfOfficeUntil: 'Fraværende til {date}',
    call: 'I en samtale',
    meeting: 'I et møte',
    calendarItem: 'I et kalendermøte',
    presenting: 'Presenterer',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Søk etter navn eller profildetaljer',
    webexPlaceholder: 'Søk med navn eller e-post',
    refreshTheList: 'Oppdater listen',
    refreshAddressBook: 'Oppdater adresseboken',
    microsoftAuthError: 'Ingen kontakter å vise. Microsoft-godkjenning mislyktes.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/nl.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/nl.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Kan gegevens niet laden',
    errorID: 'Fout-ID',
    tryAgain: 'Probeer het opnieuw',
    Error: 'Fout',
    okButton: 'OK',
    Yes: 'Ja',
    Cancel: 'Annuleren',
    Confirm: 'Bevestigen',
    Continue: 'Doorgaan',
    Canceling: 'Annuleren',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: 'Beantwoorden',
    AnswerAriaLabel: 'Desktoptaak beantwoorden',
    Decline: 'Afwijzen',
    ErrorSecurityCompliance: 'Naleving van beveiliging',
    errorDetails: 'Foutdetails',
    learnMore: 'Meer informatie',
    showLess: 'Minder tonen',
    trackingIdDescription:
      'Deel de Tracking-ID met de sitebeheerder of met het supportteam om de toestand te onderzoeken.',
    trackingIdInputLabel: 'Tracking-ID: ',
    submitForm: 'Formulier verzenden',
    unnamedStatus: 'Onbenoemde status',
    errorChatMsg: 'Chatgegevens kunnen niet worden geladen',
    noOptions: 'Geen opties',
    noResults: 'Geen resultaten',
    more: 'Meer',
    nomatchfound: 'Geen overeenkomsten gevonden',
    collaborationTool: 'Samenwerkingstool',
    timerAriaLabel: 'Tijd besteed',
    historyItemTime: 'Gebeurde in',
    loading: 'Laden',
    months: [
      'Januari',
      'Februari',
      'Maart',
      'April',
      'Mei',
      'Juni',
      'Juli',
      'Augustus',
      'September',
      'Oktober',
      'November',
      'December'
    ],
    loadingMsg: 'Bezig met laden..',
    search: 'Zoeken',
    historyChannelLabels: {
      All: 'Alles',
      telephony: 'Spraak',
      chat: 'Chat',
      email: 'E-mail',
      social: 'Sociaal'
    },
    homePageLabel: 'Startpagina',
    resizeHistoryDragger: 'Formaat sleeptool geschiedenis wijzigen',
    agentHistoryLabel: 'agentgeschiedenis',
    clear: 'Invoer wissen',
    ariaLabelAgentHistoryWrapper:
      'Interactiegeschiedenis agent toont uw recente communicatie met klanten via verschillende kanalen van de afgelopen 24 uur.',
    sliderResizerInstructions:
      'U gebruikt momenteel een schuifbalk. Gebruik de pijltoetsen om het formaat aan te passen',
    resizeHistoryPanel: 'Formaat van Geschiedenisvenster wijzigen, schuifbalk,',
    time: {
      hours: 'uur',
      minutes: 'min',
      seconds: 'sec'
    }
  },
  email: {
    ToLabel: 'Tot',
    FromLabel: 'Van',
    CcLabel: 'Cc',
    BccLabel: 'Bcc',
    SubjectLabel: 'Onderw.',
    HideLabel: 'Verberg.',
    SendLabel: 'Verzenden',
    ShowPrevThread: 'Vorige thread weergeven',
    HidePrevThread: 'Vorige thread verbergen',
    ReplyLabel: 'Antwoorden',
    ReplyAllLabel: 'Allen beantwoorden',
    ViewOriginalMail: 'Originele e-mail weergeven',
    QuickReplyInp: 'Hier snel beantwoorden...',
    AttachFiles: 'Bestanden bijvoegen',
    ToolbarHeading: 'Titel1',
    ToolbarBold: 'Vet',
    ToolbarItalic: 'Cursief',
    ToolbarUnderLine: 'Onderstrepen',
    ToolbarBlockQuote: 'Blokquota',
    ToolbarCode: 'Codeblok',
    ToolbarListOrder: 'Sorteren op besteld',
    ToolbarListBullet: 'Sorteren volgens teken',
    ToolbarLink: 'Koppeling',
    ToolbarStrike: 'Doorstrepen',
    ToolbarColor: 'Tekstkleur',
    ToolbarTable: 'Tabel',
    insertTable: 'Tabel invoegen',
    insertRowAbove: 'Rij boven invoegen',
    insertRowBelow: 'Rij onder invoegen',
    insertColumnLeft: 'Kolom links invoegen',
    insertColumnRight: 'Kolom rechts invoegen',
    deleteRow: 'Rij verwijderen',
    deleteColumn: 'Kolom verwijderen',
    deleteTable: 'Tabel verwijderen',
    link: 'Koppeling',
    IndentRight: 'Indent rechts',
    IndentLeft: 'Indent links',
    showMoreAttachment: 'Meer bijlagen weergeven',
    AttachmentLimit: 'Voeg max. ',
    attachments: ' bijlagen bij, ',
    sizeLimit: ' MB maximum',
    attachment: 'Bijlage',
    errordeleteattachment: 'Kan het/de bestand(en) niet verwijderen. Probeer het opnieuw.',
    errordownloadattachment: 'Kan het/de bestand(en) niet downloaden. Probeer het opnieuw.',
    erroraddattachemnt: 'Kan het/de bestand(en) niet uploaden. Probeer het opnieuw.',
    errorendcontact: 'Kan de interactie niet beëindigen. Probeer het opnieuw.',
    erroraddlimitreached:
      'Het bestand kon niet worden bijgevoegd aangezien het ',
    errorattachmentdrop:
      'Bijlage(n) verwijderd overeenkomstig het beveiligingsbeleid van het bedrijf.',
    errorfiletype: 'Het bestandstype wordt niet ondersteund. Probeer het opnieuw.',
    errorcreditcard:
      'Kan de bijlage(n) niet uploaden overeenkomstig het beveiligingsbeleid van het bedrijf.',
    errorcontainsimage:
      'Kan de bijlage(n) niet uploaden. Afbeeldingen in bijlagen worden niet ondersteund door het beveiligingsbeleid van het bedrijf.',
    errorlimit: ' de limiet van MB overschrijdt.',
    errorsendemail: 'Kan de e-mail niet verzenden. Probeer het opnieuw.',
    errorpcicheckemail: 'Kan PCI-gegevens niet ophalen. Probeer het opnieuw.',
    errortext: 'Kan gegevens niet laden',
    tryAgain: 'Probeer het opnieuw',
    replywarning:
      'Deel geen financiële, gezondheids- of andere persoonlijk identificeerbare informatie in dit bericht of deze bijlagen.',
    datamasked:
      'Het onderwerp of de tekst van de e-mail is bewerkt overeenkomstig het beveiligingsbeleid van het bedrijf. Wilt u de e-mail toch verzenden?',
    pcibannerwarning:
      'Het onderwerp of de tekst van de e-mail is bewerkt overeenkomstig het beveiligingsbeleid van het bedrijf.',
    on: 'Op',
    wrote: 'schreef'
  },
  interaction_control: {
    windowOpened: 'Venster geopend',
    connected: 'Verbonden',
    consultRequested: 'Ruggespraak verzocht',
    consulting: 'Ruggespraak bezig',
    consultCallOnHold: 'Consultatie on Hold',
    callOnHold: 'Gesprek in wachtstand',
    consult: 'Ruggespraak',
    endconsult: 'Ruggespraak beëindigen',
    hold: 'In wacht',
    transfer: 'Doorverbinden',
    conference: 'Conferentie',
    endconference: 'Conferentie beëindigen',
    conferenceRequested: 'Conferentie verzocht',
    switchCall: 'Overschakelen',
    mergeCall: 'Samenvoegen',
    wrapup: 'Afronden',
    end: 'Beëindigen',
    customername: 'Naam klant',
    dn: 'DNIS',
    ivrpath: 'IVR-pad',
    email: 'Klante-mail',
    ani: 'Telefoonnummer',
    queueid: 'Naam wachtrij',
    ronatimeout: 'Rona tijd',
    pathid: 'IVR-pad-ID',
    dnis: 'DNIS',
    destagentphonenumber: 'Agent DN',
    destagentname: 'Naam agent',
    virtualteamname: 'Wachtrij',
    category: 'Categorie',
    additionaldetails: 'Aanvullende details',
    sourcenumber: 'Bronnummer',
    sourcepage: 'Bronpagina',
    appuser: 'ID app-gebruiker',
    customernumber: 'Telefoonnummer',
    exitconference: 'Conferentie afsluiten',
    resume: 'Hervatten',
    pauserecording: 'Opnemen pauzeren',
    resumerecording: 'Opname hervatten',
    exitconsult: 'Ruggespraak afsluiten',
    pauseRecordingFailed: 'Kan opname niet onderbreken. Probeer het opnieuw.',
    resumeRecordingFailed: 'Kan opname niet hervatten. Probeer het opnieuw.',
    holdCallFailed: 'Kan het gesprek niet in de wachtstand zetten. Probeer het opnieuw.',
    resumeCallFailed: 'Kan het gesprek niet hervatten. Probeer het opnieuw.',
    endCallFailed: 'Kan de interactie niet beëindigen. Probeer het opnieuw.',
    consultTransferFailed:
      'Kan het gesprek voor ruggespraak niet doorverbinden. Probeer het opnieuw.',
    conferenceTransferFailed:
      'Kan conferentiegesprek niet doorverbinden. Probeer het opnieuw.',
    conferenceFailed:
      'Kan het conferentieverzoek niet verbinden. Probeer het opnieuw.',
    consultEndFailed: 'Kan het verzoek voor ruggespraak niet beëindigen. Probeer het opnieuw.',
    conferenceExitFailed:
      'Kan het conferentieverzoek niet afsluiten. Probeer het opnieuw.',
    conferenceEndFailed:
      'Kan het conferentieverzoek niet beëindigen. Probeer het opnieuw.',
    cancelCtqFailed:
      'Kon het consultatiegesprek in de wachtrij niet annuleren. Probeer het opnieuw.',
    privacyShield: 'Privacy afschermen',
    errorOnPrvacyShieldForConsult:
      'Opname is momenteel gepauzeerd. Hervat de opname om een consultatiegesprek te starten.',
    errorOnPrvacyShieldForTransfer:
      'Opname is momenteel gepauzeerd. Hervat de opname om een doorverbonden gesprek te starten.',
    cancelConsult: 'Consultatie annuleren',
    cancelTransfer: 'Doorverbinding annuleren',
    copy: 'Kopiëren',
    copied: 'Gekopieerd',
    cadrequestuccess: 'Klantinformatie is opgeslagen.',
    cadrequestfailure: 'Klantinformatie opslaan mislukt. Probeer het later opnieuw.',
    cadupdatedmessage: 'Klantinformatie werd onlangs bijgewerkt door',
    unsavedmessage: 'Uw niet-opgeslagen wijzigingen zijn overschreven.',
    save: 'Opslaan',
    revert: 'Terugdraaien',
    expandDetails: 'Details uitvouwen',
    collapseDetails: 'Details samenvouwen',
    cadValidationError:
      'Ongeldige indeling. Gebruik de internationale standaard voor datum en tijd.',
    secureCadSaveError:
      'Klantgegevens zijn niet opgeslagen. Klik op Opslaan om het opnieuw te proberen.',
    secureDecryptionError: 'Er kunnen geen veilige variabelen worden weer gegeven.',
    clickToTry: 'Klik om het opnieuw te proberen',
    isSecureVariable: 'Is een veilige variabele',
    contactorigin: 'Contact bron',
    resumeMonitoring: 'Controle hervatten',
    pauseMonitoring: 'Controle onderbreken',
    whisperCoach: 'Fluistercoach',
    bargeIn: 'Inbreken',
    endMonitoring: 'Controle beëindigen',
    contactphonenumber: 'Tel. nr. contactpers.',
    contactqueue: 'Contactwachtrij',
    activeparticipants: 'Actieve deelnemers',
    consultedparticipant: 'Deeln. geraadplgd',
    contactstatus: 'Contactstatus',
    timeincontactstatus: 'Tijd in contactstatus',
    totalcontactduration: 'Totale duur contact',
    agentinteractiontime: 'Duur interactie',
    recording: 'Bezig met opnemen',
    monitoring: 'Controleren',
    monitoringPaused: 'Controle onderbroken',
    pauseMonitoringFailed: 'Kan de controle niet onderbreken. Probeer het opnieuw',
    resumeMonitoringFailed: 'Kan de controle niet hervatten. Probeer het opnieuw',
    callCancelledInProgress: 'Bezig met oproep annuleren',
    bargedIn: 'Ingebroken',
    keypad: 'Toetsenbord',
    mute: 'Dempen',
    unmute: 'Dempen opheffen',
    bargeInTooltipText:
      'De microfoon wordt ingeschakeld en u neemt deel aan deze klantinteractie',
    bargeInCompactTooltipText:
      'Inbreken. De microfoon wordt ingeschakeld en u neemt deel aan deze klantinteractie',
    bargeInTooltipDisabled: 'Hervat controleren om inbreken mogelijk te maken',
    bargeInFailedTitle: 'Inbreken mislukt',
    bargeInFailedData:
      'Er is een fout opgetreden tijdens het inbreken. Probeer het later nog een keer.',
    supervisorBargedIn: 'is ingebroken in uw gesprek.',
    leftInteraction: 'heeft het gesprek verlaten.',
    conferenceEnded: 'Het conferentiegesprek is beëindigd.',
    participants: 'Deelnemers',
    badgeAriaLabel: '{participant} is in het gesprek',
    bargeInConferenceAriaLabel: 'Twee deelnemers doen mee met de interactie',
    taskName: 'Taaknaam interactiebeheer',
    interactionDurationLabel: 'Tijdsduur',
    wrapupassist: 'Ondersteuning bij afronding',
    consultingTaskContext: 'Ruggespraakgesprek van',
    consultExited: 'Ruggespraak afgesloten',
    endCall: 'Beëindig het gesprek.',
    exitconferenceCall:
      'Sluit het gesprek af. Het conferentiegesprek gaat verder met actieve deelnemers.',
    recordingInProgess: 'Opname bezig',
    recordingPaused: 'Opname onderbroken',
    searchPlaceholder: 'Contactpersonen zoeken',
    postCall: "Enquête na gesprek",
    switchCallTooltip: "Naar gesprek schakelen",
    switchConsultTooltip: "Naar ruggespraakgesprek schakelen",
    switchConferenceTooltip: "Naar conferentiegesprek schakelen",
    confirmationDialog: {
      endCallTitle: 'Wilt u het gesprek beëindigen?',
      endCallMessage: 'Klik op Bevestigen om het gesprek voor alle deelnemers te beëindigen.',
      exitConferenceTitle: 'Wilt u het conferentiegesprek afsluiten?',
      exitConferenceMessage:
        'Klik op Bevestigen om het conferentiegesprek af te sluiten en de andere deelnemers toe te staan verder te gaan.',
      confirmButtonLabel: "Bevestigen",
      cancelButtonLabel: "Annuleren",  
    },
    postCallOnHold: "In de wacht na gesprek",
    postCallConsult: "Consultatie na het gesprek",
    postCallConsultOnHold: "Consultatie na gesprek in de wacht",
  },
  agentProfile: {
    teamName: 'Team',
    dialNumber: 'Nummer',
    phoneNumber: 'Telefoonnummer',
    settings: 'Instellingen wijzigen',
    signOut: 'Afmelden',
    webRTCDisconnected: 'Waarschuwing: verbinding met Desktop-telefonie verbroken ',
    msAuthFailed: 'Microsoft-verificatie mislukt',
    stateSyncFailed: 'Statussynchronisatie is mislukt',
    userProfileLabel: 'Gebruikersprofiel',
    ariaAgentprofile: 'Agentprofiel',
    ChannelCapacity: 'Capaciteit van kanaal',
    voice: 'Spraak',
    chat: 'Chat',
    email: 'E-mail',
    social: 'Sociaal',
    channelCapacityTooltip: 'Klik om meer weer te geven',
    blendedRouting: 'Gemengd',
    exclusiveRouting: 'Exclusieve routering',
    realtimeRouting: 'Gemengde routering in realtime',
    blendedRoutingTooltip: 'Handel meerdere contacten onder kanalen af.',
    exclusiveRoutingTooltip: 'Handel slechts één contact tegelijk af.',
    realtimeRoutingTooltip: 'Handel één verplicht real-time kanaal af.',
    errorActiveContacts:
      'Afmelden is momenteel niet mogelijk aangezien u actieve gesprekken hebt. Rond ze af en probeer het opnieuw.',
    searchTeams: 'Teams zoeken',
    changeTeamsConfirmHeader: 'Wijzig teambevestiging',
    changeTeamsConfirmMessage: 'Weet u zeker dat u uw team wilt veranderen?',
    changeTeamLabel: 'Van team wisselen',
    errorChangeTeams:
      'U kunt het team nu niet wijzigen omdat u actieve aanvragen heeft. Voltooi ze en probeer het opnieuw.',
    saveTeamSelection: 'Sla teamselectie op',
    userSettings: 'Gebruikersinstellingen',
    resetLayout: 'Volledige desktopindeling resetten',
    resetConfirmHeader: 'Lay-outbevestiging resetten',
    resetConfirmMessage:
      'Weet u zeker dat u de volledige desktopindeling wilt resetten? <br/> De desktop zal terugkeren naar de standaardindeling.',
    downloadLogs: 'Foutrapport downloaden',
    help: 'Help',
    signoutConfirm: 'Weet u zeker dat u wilt afmelden?',
    signoutConfirmHeader: 'Bevestiging afmelding',
    darkTheme: 'Overschakelen naar Donkere modus',
    newLook: 'Overschakelen naar nieuwe look',
    keyboardShortcuts: 'Toetsenbordsneltoetsen',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Meldingsinstellingen',
    silentNotification: 'Stille melding',
    enableNotificationSettings: 'Meldingen inschakelen',
    enableSilentNotificationSettings: 'Stille meldingen inschakelen',
    suppressWebexCallingNotificationSettings: 'Meldingen Webex Calling verbergen',
    notificationSettingDescription:
      'Levert meldingen zoals berichten, waarschuwingen en statuswijzigingen.',
    silentNotificationDescription:
      'Schakelt de waarschuwingen op het scherm uit. U kunt de meldingen bekijken in het Meldingencentrum.',
    suppressWebexCallingNotificationDescription: 
    'Geen pop-upmeldingen weergeven voor binnenkomende Webex-gesprekken en deze via Webex Contactcenter beantwoorden.',
    arrowLabel: 'Teruggaan',
    managedTeams: 'Beheerde Teams',
    managedTeamsError: 'Teams kan niet worden geladen.',
    viewAll: 'Alles weergeven',
    profileSettings: 'Profielinstellingen',
    userRole: 'Rol',
    saveSelection: 'Selectie opslaan',
    extension: 'Toestel',
    changeProfileConfirmHeader: 'Wijzigingen in profielinstellingen bevestigen',
    changeProfileConfirmMessage:
      'Weet u zeker dat u uw profielwijzigingen wilt opslaan?',
    confirm: 'Bevestigen',
    errorProfileUpdate:
      'U kunt de profielinstellingen nu niet wijzigen omdat u actieve aanvragen heeft. Voltooi ze en probeer het opnieuw.',
    roleAgentSupervisor: 'Supervisor en agent',
    roleSupervisor: 'Supervisor',
    noTeam: 'Geen team',
    testYourNetwork: 'Uw netwerk testen',
    speakerAndMic: 'Luidspreker en microfoon',
    speaker: 'Luidspreker',
    mic: 'Microfoon',
    speakerDescription:
      'Kies en test het uitvoerapparaat om te controleren of u de beller hoort.',
    micDescription:
      'Kies en test het invoerapparaat om te controleren of de beller u hoort.',
    micError:
      'Toegang tot de microfoon is geweigerd. Schakel toegang via browserinstellingen in of neem contact op met de beheerder.',
    speakerError:
      'De luidspreker is momenteel niet beschikbaar omdat de toegang tot de microfoon wordt geweigerd.',
    telephony: 'Telefonie',
    desktop: 'Bureaublad',
    onSpeakerPlay:
      'Als u het testgeluid niet kunt horen, controleer dan de luidspreker.',
    onMicPlay:
      'Als u het testgeluid niet kunt horen, controleer dan de luidspreker en de microfoon.',
    onMicRecord: 'Neem een bericht op om af te spelen.',
    test: 'Test',
    recording: 'Bezig met opnemen',
    playing: 'Wordt afgespeeld',
    reconnecting: 'Opnieuw verbinding maken',
    disconnectMessage:
      'Verbinding met desktoptelefonie is verbroken. Probeer een andere telefonieoptie.',
    singleTelephonyDisconnectMessage:
      'Verbinding met desktoptelefonie is verbroken. Neem contact op met uw beheerder.',
    clear: 'Invoer wissen',
    rememberMeCheckBoxMessage: "Dit niet meer laten zien",
    saveLabel: 'Opslaan',
    browserUnsupportedError: "Aanmelden is mislukt omdat u een niet-ondersteunde browser gebruikt.",
    microphoneAccessDeniedError: "Toegang tot de microfoon is geweigerd. Schakel toegang via browserinstellingen in of neem contact op met de beheerder.",
  },
  contactHistory: {
    mainHeader: 'Contactgeschiedenis',
    handledBy: 'Afgehandeld door',
    noRecordFound: 'Geen contactgeschiedenis gevonden!',
    tryAgain: 'Probeer het opnieuw',
    errorMsg: 'Kan contactgeschiedenis niet ophalen. Probeer het opnieuw.',
    errorID: 'Fout-ID',
    missingAni: 'ANI ontbreekt',
    timeIcon: 'Duur',
    taskHandled: 'Taak afgehandeld',
    noHistoryNew: 'Geen geschiedenis',
    noHistory: 'Geen geschiedenis',
    viewTranscript: 'E-mailbericht weergeven',
    transcriptFor: 'Transcripties voor',
    editBeforeCall: 'Bewerken vóór gesprek',
    clickToCall: 'Klikken om te bellen',
    onAnActiveCallErrorMessage:
      'U kunt geen nieuw gesprek starten omdat u al een actieve oproep hebt.',
    receivedFrom: 'Contact ontvangen van',
    initiatedTo: 'Contact gestart bij',
    wrapUpReason: 'Afrondingsredenen',
    startCallTelephony:
      'Klik op de koppeling van het telefoonnummer om een uitgaand gesprek te starten.',
    contactHistoryList: 'Lijst met contactgeschiedenis,',
    wrapUpCode: 'Code voor afronden',
    agentName: 'Naam agent',
    entryPointName: 'Invoerpunt',
    acceptedTimeAndDate: 'Geaccepteerde tijd en datum',
    duration: 'Duur',
    emailTranscript: 'E-mailtranscriptie',
    clickToViewEmailTranscript: 'Klik om e-mailtranscript weer te geven',
    listContainer: 'Lijstcontainer'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Invoerpunt',
    date: 'Datum',
    subject: 'Onderw.',
    from: 'Van',
    sent: 'Verzenden',
    to: 'Tot',
    back: 'Vorige',
    errorTranscript: 'Bij het ophalen van de transcripts is een fout opgetreden',
    customer: 'Klant',
    inboundErrorMessage: 'Kon de e-mail van de klant niet laden',
    outboundErrorMessage: 'Kon het antwoord van de agent niet laden'
  },
  popoverTitle: {
    callback: 'Terugbellen',
    outboundCall: 'Uitgaand gesprek',
    incomingCall: 'Inkomend gesprek',
    progressiveCampaign: 'Campagnegesprek',
    courtesyCallback: 'Belfth.terugbl.gspr.',
    chat: 'Inkomende chat',
    incoming: 'Inkomend',
    monitoringCall: 'Gesprek controleren'
  },
  connecting: 'Verbinden',
  initiating: 'Initiëren',
  outbound: 'Uitgaand',
  transfer: {
    title: 'Verzoek voor doorverbinden',
    heading: {
      chat: 'Selecteer de agent of wachtrij waarnaar u wilt doorverbinden.',
      email: 'Selecteer de wachtrij waarnaar u wilt doorverbinden.',
      telephony:
        'Selecteer de agent, de wachtrij of het kiesnummer waarnaar u wilt doorverbinden.',
      noQueueTelephony:
        'Selecteer de agent of het kiesnummer waarnaar u wilt doorverbinden.'
    },
    header: {
      chat: 'Selecteer de agent of wachtrij voor het doorverbinden van dit contact.',
      email: 'Selecteer de wachtrij voor het doorverbinden van dit contact.',
      telephony:
        'Selecteer de agent, wachtrij, kiesnummer of organisatie voor het doorverbinden van dit contact.',
      noQueueTelephony:
        'Selecteer de agent, het belnummer of de organisatie voor het doorverbinden van dit contact.',
      noOrganizationTelephony:
        'Selecteer de agent, wachtrij of kiesnummer voor het doorverbinden van dit contact.',
      noQueueOrganizationTelephony:
        'Selecteer de agent of het belnummer voor het doorverbinden van dit contact.'
    },
    queues: 'Wachtrij',
    agents: 'Agent',
    dialNumber: 'Nummer',
    organization: 'Organisatie',
    placeholder: {
      Queues: 'Kies uit een lijst met wachtrijen',
      Agents: 'Kies uit een lijst met agenten',
      DialNumber: 'Kiezen op naam of nummer',
      DialNumberOrEntryPoint: 'Kiezen op naam/nummer/invoerpunt',
      ChooseByNameOrNumber: 'Kies op naam/nummer',
      Organization: 'Zoeken op naam/rol/afdeling/bedrijfstelefoon',
      WebexOrganization: 'Zoeken op naam of e-mail',
      DialNumberSearch: 'Zoeken op naam of nummer'
    },
    type: 'Doorverbinden',
    cancel: 'Annuleren',
    closeModal: 'Module sluiten',
    failureError: 'Kan het verzoek niet doorverbinden. Probeer het opnieuw.',
    entryPoint: 'Invoerpunt'
  },
  consult: {
    title: 'Verzoek ruggespraak',
    heading: {
      chat: 'Selecteer de agent of wachtrij waarnaar u wilt doorverbinden.',
      email: 'Selecteer de wachtrij waarnaar u wilt doorverbinden.',
      telephony:
        'Selecteer de agent, de wachtrij of het kiesnummer waarmee u wilt overleggen.',
      noQueueTelephony:
        'Selecteer de agent of het kiesnummer waarmee u wilt overleggen.'
    },
    header: {
      chat: 'Selecteer de agent of wachtrij voor het doorverbinden van dit contact.',
      email: 'Selecteer de wachtrij voor het doorverbinden van dit contact.',
      telephony:
        'Selecteer de agent, wachtrij, belnummer of organisatie waarmee u wilt overleggen.',
      noQueueTelephony:
        'Selecteer de agent, het belnummer of de organisatie waarmee u wilt overleggen.',
      noOrganizationTelephony:
        'Selecteer de agent, wachtrij of belnummer waarmee u wilt overleggen.',
      noQueueOrganizationTelephony:
        'Selecteer de agent of het belnummer waarmee u wilt overleggen.'
    },
    queues: 'Wachtrij',
    agents: 'Agent',
    dialNumber: 'Nummer',
    organization: 'Organisatie',
    placeholder: {
      Queues: 'Kies uit een lijst met wachtrijen',
      Agents: 'Kies uit een lijst met agenten',
      DialNumber: 'Kiezen op naam of nummer',
      DialNumberOrEntryPoint: 'Kiezen op naam/nummer/invoerpunt',
      ChooseByNameOrNumber: 'Kies op naam/nummer',
      Organization: 'Zoeken op naam/rol/afdeling/bedrijfstelefoon',
      WebexOrganization: 'Zoeken op naam of e-mail',
      DialNumberSearch: 'Zoeken op naam of nummer'
    },
    type: 'Ruggespraak',
    checkBoxLabel: 'Deelnemers toestaan om te blijven communiceren.',
    cancel: 'Annuleren',
    closeModal: 'Module sluiten',
    failureError: 'Kan het verzoek voor ruggespraak niet verbinden. Probeer het opnieuw.',
    customerLeftMsg: 'Verbinding klant verbroken. Consult is niet meer nodig.',
    ctqFailureMsg:
      'Kon het consultatiegesprek in de wachtrij niet annuleren. Probeer het opnieuw.',
    cancelCtqInfo:
      'Een beschikbare agent in de geselecteerde wachtrij zoeken. Wacht even of annuleer het consultatieverzoek.',
    cancelCtqAction: 'Consultatie annuleren',
    entryPoint: 'Invoerpunt'
  },
  conference: {
    title: 'Conferentieverzoek',
    heading: {
      chat: 'Selecteer een specifieke agent voor de conferentiechat'
    },
    queues: 'Wachtrij',
    agents: 'Agent',
    dialNumber: 'Nummer',
    organization: 'Organisatie',
    placeholder: {
      Queues: 'Kies uit een lijst met wachtrijen',
      Agents: 'Kies uit een lijst met agenten',
      DialNumber: 'Kiezen op naam of nummer'
    },
    type: 'Conferentie',
    cancel: 'Annuleren',
    closeModal: 'Module sluiten',
    failureError: 'Kan dit conferentieverzoek niet starten. Probeer het opnieuw.'
  },
  transferModal: {
    Agents: 'Kan de lijst agenten niet ophalen. Vernieuw de lijst.',
    AgentsEmpty: 'Geen agent beschikbaar',
    Queues: 'Kan de lijst wachtrijen niet ophalen. Vernieuw de lijst.',
    QueuesEmpty: 'Geen wachtrij beschikbaar',
    EPEmpty: 'Geen invoerpunt beschikbaar',
    DialNumber:
      'Kan de lijst met gekozen nummers niet ophalen uit het adresboek. Vernieuw de lijst.',
    EntryPoint:
      'Kan de lijst met invoerpuntnummers niet ophalen. Vernieuw de lijst.',
    Common: 'Kan de lijst niet ophalen. Vernieuw de lijst.',
    DialNumberEmpty: 'Geen nummer beschikbaar',
    DialNumbInvalid:
      'Nummer is ongeldig. Neem contact op met uw beheerder.',
    DialNumbOrEntryPointInvalid:
      'Kiesnummer/invoerpunt is ongeldig. Neem contact op met uw beheerder.',
    refreshQueueList: 'De lijst met wachtrijen vernieuwen',
    refreshAgentList: 'De lijst met agenten vernieuwen',
    refreshEpList: 'De invoerpunten vernieuwen',
    refreshAddressBook: 'Het adresboek vernieuwen',
    refreshTheList: 'De lijst vernieuwen',
    entryPointSectionLabel: 'Invoerpunt',
    addressBookSectionLabel: 'Adresboek',
    organization: 'Organisatie',
    comboBoxAriaLabelAgent: 'Kies uit een lijst met agenten',
    comboBoxAriaLabelQueue: 'Kies uit een lijst met wachtrijen',
    comboBoxAriaLabelEp: 'Kies uit de lijst met invoerpunten',
    infScrollAgent: 'Agenten zoeken',
    infScrollQueue: 'Wachtrijen zoeken',
    infScrollEP: 'Invoerpunten zoeken',
    allRadioButtonHidedTextForConsult: 'U hebt geen toegewezen entiteiten om deze interactie te raadplegen. Neem contact op met uw beheerder.',
    allRadioButtonHidedTextForTransfer: 'U hebt geen toegewezen entiteiten om deze interactie over te dragen. Neem contact op met uw beheerder.',
    allRadioButtonHidedTextForConference: 'U hebt geen toegewezen entiteiten om deze interactie voor de conferentie te gebruiken. Neem contact op met uw beheerder.',
    searchMinCharError: 'Voer minimaal drie tekens in om te zoeken.',
  },
  wrapup: {
    cancelautowrapup: 'Automatisch afronden annuleren',
    wrapupreason: 'Redenen voor afronden',
    untilautowrapup: 'tot automatische afronding',
    followupsetting: 'Opvolgingsinstelling',
    lastagentroute: 'Laatste agentroutering',
    submitwrapup: 'Afronding verzenden',
    wrapupsearch: 'Reden van afronding zoeken',
    invalidationError: 'Kon de afronding niet verzenden',
    searchResult: 'Zoekresultaten beschikbaar',
    noResultFound: 'Geen zoekresultaten gevonden',
    listContainerLabel: 'Container voor afrondingslijst',
    searchError: 'Voer minimaal drie tekens in om naar afrondingsredenen te zoeken.',
  },

  outdial: {
    call: 'Gesprek',
    dialpadSearch: 'Voer een nummer in om te kiezen',
    addressSearch: 'Zoeken op naam/nummer',
    addressTab: 'Adres',
    addressTabTooltip: 'Zoeken in adresboek',
    dialpadTab: 'Toetsenblok',
    dialpadTooltip: 'Een nummer kiezen',
    searchTab: 'Zoeken',
    searchTabTooltip:'Zoeken naar mensen in mijn organisatie',
    noAdrFound: 'Geen overeenkomsten gevonden',
    noContacts: 'Geen contacten',
    mainIconTooltip: 'Uitbelgesprek',
    errorOutdialFailed:
      'Uitbelgesprek mislukt. Desktop kon het gesprek niet verbinden of er kwam geen antwoord.',
    errorOutdialDisabled: 'Uitbelgesprekken zijn uitgeschakeld',
    errorDialPadValidationMessage: 'Foutieve indeling',
    outdialReqInProgress: 'Uitbelgesprek is bezig',
    outdialAniPlaceholder: 'Selecteer Uitbel-ANI',
    outdialAniLabel: 'ANI voor uitgaand kiezen',
    outdialAniPlaceHolder: 'ANI voor uitgaand kiezen zoeken',
    errorDcCallsLimitExceeded:
      'Het datacenter heeft de maximumlimiet bereikt voor uitbelgesprekken. Kan geen uitbelgesprekken meer beginnen',
    errorOrgCallsLimitExceeded:
      'De organisatie heeft de maximumlimiet bereikt voor uitbelgesprekken. Kan geen uitbelgesprekken meer beginnen.',
    errorOutDialNoAnswerFromCustomer:
      'De klant heeft uw gesprek niet beantwoord. Probeer later opnieuw te bellen.',
    errorOutDialCustomerUnavailable:
      'De klant is nu niet beschikbaar. Probeer later opnieuw te bellen.',
    errorOutDialAgentEnds: 'U hebt uw gesprek met de klant beëindigd.',
    errorOutDialCustomerBusy: 'De klant is nu niet beschikbaar. Probeer later opnieuw te bellen.',
    searchError: 'Voer minimaal drie tekens in om de contactpersonen te doorzoeken.',
    upArrowLabel: 'Uitvouwen',
    clear: 'Invoer wissen',
    outdialDialogDescription: 'U bent momenteel in het gesprekvenster met tabbladen.'
  },

  organization: {
    noMatchFound: 'Geen overeenkomsten gevonden',
    searchError: 'Voer minimaal drie tekens in om de contactpersonen te doorzoeken.',
    authError: 'Geen contacten om weer te geven. Microsoft-verificatie mislukt.'
  },

  interactionPopover: {
    of: 'van',
    accept: 'Accept.',
    acceptAriaLabel: 'Taak {taskNumber} - {taskType} van {from} accepteren',
    requests: 'Verzoek(en)',
    back: 'terug',
    next: 'volgende',
    acceptMultipleRequest: '{requestCount} verzoeken accepteren',
    paginationDetail: '{indexStart}-{indexEnd} van {totalPopoverpoolLength}',
    hidePopoverDetails: 'Pop-updetails verbergen',
    showPopoverDetails: 'Pop-updetails weergeven',
    customerName: 'Naam klant',
    email: 'E-mail',
    queueName: 'Naam wachtrij',
    failedToAccept: 'Kon niet worden aanvaard.',
    unableToAccept: 'Kan het contact niet accepteren.',
    failedToEnd: 'Kon niet worden beëindigd.',
    unableToEnd: 'Kan het contact niet beëindigen. ',
    ringing: 'Gaat over',
    calling: 'Bellen',
    phoneNumber: 'Telefoonnummer',
    dni: 'DNIS',
    ivrPathId: 'IVR-pad-ID',
    pathId: 'Pad-ID',
    rona: 'OBGA',
    sourcePage: 'Bronpagina',
    sourceNumber: 'Bronnummer',
    appUserId: 'ID app-gebruiker',
    acceptAll: 'Alle taken accepteren',
    agentDn: 'Agent DN',
    agentName: 'Agentnaam',
    agentTeam: 'Agentteam',
    requestDetails: 'Details van aanvraag',
    incomingCallFrom: 'Inkomend gesprek van',
    unableToAnswer: 'Kan het gesprek niet beantwoorden. Probeer het opnieuw.',
    unableToDecline: 'Kan het gesprek niet weigeren. Probeer het opnieuw.'
  },

  multiLogin: {
    header: 'Waarschuwing meervoudige aanmelding',
    message:
      'U ben via meerdere toepassingsinstanties geregistreerd in de Desktop. Klik op Doorgaan om verder te gaan met de Desktop in deze toepassingsinstantie of sluit dit venster.',
    continue: 'Doorgaan'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Doorverbinden naar invoerpunt/wachtrij is mislukt vanwege een configuratiefout.',
    1010: "Consultatie is niet mogelijk omdat de agent niet op tijd kon worden toegewezen. ",
    1042: "De contactpersoon is niet gevonden",
    1043: 'Het doel is ongeldig.',
    1045: 'De interactie is niet toegewezen aan de agent.',
    1046: 'Agentconsultatie is mislukt omdat er geen overeenkomend agentkanaal is gevonden in het systeem.',
    1038: "De agent is niet gevonden",
    1037: 'Aanmelden is mislukt vanwege een interne fout.',

    // Media Events
    138: 'De actie is mislukt wegens onbekende redenen.',
    136: 'De gebruiker is niet gevonden',

    // AgentConsultFailed
    1050: 'Consultatie is niet mogelijk vanwege niet-ondersteunde configuratie of activiteit in de stroom. ',
    1005: "Consultatie is niet mogelijk omdat de agent de aanvraag niet op tijd heeft beantwoord.",
    1051: 'Consultatie of doorverbinden is niet mogelijk vanwege een ongeldig invoerpunt of kiesnummer.',

    // AgentInviteFailed
    1053: 'Kan de interactie niet presenteren omdat een werkstroomtaak voor het opnieuw in de wachtrij plaatsen in behandeling is.',
    1054: 'Kan uitbelgesprek niet plaatsen vanwege mediaproblemen met deze aanvraag. ',

    // AgentContactAssignFailed
    1011: 'Kan het gesprek niet beantwoorden of accepteren vanwege ontbrekende agenten in de lopende interactie. ',

    // ContactCallbackFailed
    1034: 'Terugbellen van contactpersoon is mislukt omdat voor de aanvraag ContactParkTimeout is ontvangen.',

    // ContactUpdateFailed
    1020: "De variabelen kunnen niet worden bijgewerkt omdat een van de waarden de tekenlimiet van 256 overschrijdt. Verminder het aantal tekens en probeer het opnieuw.",

    // AgentInviteFailed
    1031: 'De agent heeft de klant uitgenodigd nadat het terugbellen is aangevraagd.',

    // AgentBlindTransferFailedEvent
    1044: 'Onaangekondigd doorverbinden van de agent is mislukt omdat de bestemmingsagent aan een andere interactie is toegewezen.',

    // AgentCtqCancelFailed
    1047: "De contactpersoon is niet gevonden.",

    // AgentCtqFailed
    1048: "De gespreksdistributiegroep is niet geconfigureerd.",
    1049: 'De maximale wachttijd in de wachtrij is overschreden.',
    // StationLoginFailed
    127: 'Agent DN-register is mislukt met dubbele aanmeldingsuitzondering.'
  },

  stateSelector: {
    Available: 'Beschikbaar',
    errorstatechange: 'Statuswijziging is niet gelukt. Probeer het opnieuw.',
    errorStateChangeInPendingLogout: 'Kan agentstatus niet wijzigen vanwege afmelden in behandeling.',
    label: 'Beschikbaarheidsstatus',
    agentStateSelector: 'Selectie agentstatus',
    Engaged: 'Betrokken',
    engagedAvailableInfo:
      'U bent momenteel betrokken bij een interactie en in de status Beschikbaar.',
    engagedIdleInfo:
      'U bent momenteel betrokken bij een interactie en in de status Inactief.',
    engagedInfo: 'U bent momenteel betrokken bij een interactie.',
    engagedSupervisorStateChange: 'heeft uw status gewijzigd in',
    axAgentStateChanged: 'Uw status is gewijzigd in',
    axAgentSync: 'vanwege statussynchronisatie met uw samenwerkingstool.',
    engagedPresenceInfo:
      'U bent momenteel betrokken bij een interactie en uw status is',
    engagedPresenceSync: 'vanwege statussynchronisatie met uw samenwerkingstool.',
    clear: 'Invoer wissen',
    searchState: 'invoer',
    agentStatusLabel: 'Agentstatus',
    agentStateLabel: 'Agent heeft sinds {selectedTimeValue} de status {selectedState}',
    agentStateLabelOnStateChange: 'Agent heeft sinds 0 Sec de status {selectedState}',
    agentStateChangeSuccessful:'Statuswijziging in {selectedState} is voltooid.',
    agentStateChangeFail:'Statuswijziging in {selectedState} is mislukt.',
    searchError: 'Voer minimaal drie tekens in om de statussen te doorzoeken.'
  },

  warningMessage: {
    header: 'Niet-opgeslagen wijzigingen',
    message:
      'U hebt niet-opgeslagen wijzigingen op deze pagina. Weet u zeker dat u deze pagina wilt verlaten? ',
    cancelButton: 'Blijven',
    saveButton: 'Verlaten'
  },

  notificationLables: {
    muteVolume: 'Meldingsvolume dempen',
    unmuteVolume: 'Dempen van meldingsvolume opheffen',
    notificationVolume: 'Meldingsvolume',
    playSound: 'Meldingsgeluid afspelen',
    enableSoundNotificationSettings: 'Geluidsmeldingen inschakelen',
    enableSoundNotificationSettingsDescription:
      'Levert geluidsmeldingen voor inkomende verzoeken. U kunt het volume hieronder aanpassen.',
    volumeTitle: 'Geluidsvolume'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Gesprek',
    chat: 'Chat',
    email: 'E-mail',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Berichten van Google Business"
  },
  orgDetailsLabels: {
    role: 'Rol',
    department: 'Afdeling',
    email: 'E-mail',
    businessPhone: 'Bedrijfstelefoon',
    workPhone: 'Werk',
  },
  addressListError: {
    title: 'Kan gegevens niet laden',
    errorId: 'Fout-ID:'
  },
  keypad: {
    keyPadSearch: 'Voer een nummer in',
    dialPad: 'Nummerkeuze'
  },
  collabTool: {
    userAuthenticated: 'Verificatie gebruiker:',
    successful: 'Gelukt',
    failed: 'Mislukt.',
    tryAgain: 'Probeer het opnieuw',
    stateSync: 'Statussynchronisatie:',
    mercuryFailedInfo: ' Neem contact op met uw beheerder.',
    retrying: 'Bezig met opnieuw proberen...',
    trackingIdLabel: 'Tracking-ID: '
  },
  webex: {
    webex: 'Webex',
    info: 'Met integratie kunt u de statussen synchroniseren tussen Desktop en Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Met deze integratie kunt u consultatiegesprekken voeren of gesprekken doorverbinden naar Microsoft Teams-gebruikers.',
    authenticationFailedInfo:
      'Als er al een verificatievenster is geopend, probeert u de verificatie daar opnieuw.',
    ListItemContactDetails:
      'Naam van de contactpersoon is: {name}, de aanwezigheid is: {presence}, de afdeling is: {department}, de functie is: {jobTitle} en het telefoonnummer is: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Melding van nooddienst',
    readNotification: 'Ik heb de melding gelezen.'
  },
  webexPresenceStatus: {
    active: 'Actief',
    lastActiveFewMinutesAgo: 'In de afgelopen minuten actief',
    lastActiveMinutesAgo: '{min} minuten geleden actief',
    lastActive1HourAgo: 'Laatste activiteit 1 uur geleden',
    lastActiveHoursAgo: '{hour} uur geleden actief',
    lastActiveYesterday: 'Gisteren actief',
    lastActiveOnDate: 'Actief op {date}',
    busy: 'Bezet',
    busyUntil: 'Bezet tot {date}',
    dnd: 'Niet storen',
    dndUntil: 'Niet storen tot {date}',
    quiet: 'Stil',
    quietUntil: 'Stil tot {date}',
    ooo: 'Niet op kantoor',
    outOfOfficeUntil: 'Niet op kantoor tot {date}',
    call: 'In gesprek',
    meeting: 'In vergadering',
    calendarItem: 'In een agendavergadering',
    presenting: 'Presenteren',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Zoeken op naam of profieldetails',
    webexPlaceholder: 'Zoeken op naam of e-mail',
    refreshTheList: 'De lijst vernieuwen',
    refreshAddressBook: 'Het adresboek vernieuwen',
    microsoftAuthError: 'Geen contacten om weer te geven. Microsoft-verificatie mislukt.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/pl.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/pl.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Nie udało się załadować danych',
    errorID: 'Identyfikator błędu',
    tryAgain: 'Spróbuj ponownie',
    Error: 'Błąd',
    okButton: 'OK',
    Yes: 'Tak',
    Cancel: 'Anuluj',
    Confirm: 'Potwierdź',
    Continue: 'Kontynuuj',
    Canceling: 'Anulowanie',
    CiscoAiAssistant: 'Asystent AI Cisco',
    Answer: 'Odbierz',
    AnswerAriaLabel: 'Odbierz zadanie pulpitu',
    Decline: 'Odrzuć',
    ErrorSecurityCompliance: 'Zgodność z zasadami',
    errorDetails: 'Szczegóły błędu',
    learnMore: 'Dowiedz się więcej',
    showLess: 'Pokaż mniej',
    trackingIdDescription:
      'Przekaż Tracking ID administratorowi strony lub zespołowi pomocy technicznej, aby rozwiązać tę sytuację.',
    trackingIdInputLabel: 'Identyfikator śledzenia: ',
    submitForm: 'Prześlij formularz',
    unnamedStatus: 'Nienazwany stan',
    errorChatMsg: 'Nie udało się załadować danych czatu',
    noOptions: 'Brak opcji',
    noResults: 'Brak wyników',
    more: 'Więcej',
    nomatchfound: 'Nie odnaleziono wyników',
    collaborationTool: 'Narzędzie do współpracy',
    timerAriaLabel: 'Czas spędzony',
    historyItemTime: 'Zdarzyło się o godzinie',
    loading: 'Ładowanie',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień'
    ],
    loadingMsg: 'Ładowanie...',
    search: 'Szukaj',
    historyChannelLabels: {
      All: 'Wszystkie',
      telephony: 'Głos',
      chat: 'Czat',
      email: 'E-mail',
      social: 'Społecznościowe'
    },
    homePageLabel: 'Strona domowa',
    resizeHistoryDragger: 'Zmień rozmiar narzędzia do przeciągania historii',
    agentHistoryLabel: 'historia agenta',
    clear: 'Wyczyść dane',
    ariaLabelAgentHistoryWrapper:
      'Historia interakcji z agentem Wyświetla ostatnią komunikację z klientami w różnych kanałach z ostatnich 24 godzin',
    sliderResizerInstructions:
      'Korzystasz obecnie z suwaka. Aby zmienić rozmiar, użyj strzałek',
    resizeHistoryPanel: 'Zmień rozmiar panelu historii, suwak,',
    time: {
      hours: 'godz.',
      minutes: 'min',
      seconds: 's'
    }
  },
  email: {
    ToLabel: 'Do',
    FromLabel: 'Od',
    CcLabel: 'DW',
    BccLabel: 'UDW',
    SubjectLabel: 'Temat',
    HideLabel: 'Ukryj',
    SendLabel: 'Wyślij',
    ShowPrevThread: 'Pokaż poprzedni wątek',
    HidePrevThread: 'Ukryj poprzedni wątek',
    ReplyLabel: 'Odpowiedz',
    ReplyAllLabel: 'Odpowiedz wszystkim',
    ViewOriginalMail: 'Otwórz oryginalny e-mail',
    QuickReplyInp: 'Wpisz tutaj szybką odpowiedź...',
    AttachFiles: 'Dołącz pliki',
    ToolbarHeading: 'Nagłówek 1',
    ToolbarBold: 'Pogrubienie',
    ToolbarItalic: 'Kursywa',
    ToolbarUnderLine: 'Podkreślenie',
    ToolbarBlockQuote: 'Kwota zablokowanych',
    ToolbarCode: 'Kod zablokowania',
    ToolbarListOrder: 'Sortuj wg zorganizowanych',
    ToolbarListBullet: 'Sortuj wg lista punktorów',
    ToolbarLink: 'Łącze',
    ToolbarStrike: 'Przekreślenie',
    ToolbarColor: 'Kolor tekstu',
    ToolbarTable: 'Tabela',
    insertTable: 'Wstaw tabelę',
    insertRowAbove: 'Wstaw rząd powyżej',
    insertRowBelow: 'Wstaw rząd poniżej',
    insertColumnLeft: 'Wstaw kolumnę po lewej',
    insertColumnRight: 'Wstaw kolumnę po prawej',
    deleteRow: 'Usuń rząd',
    deleteColumn: 'Usuń kolumnę',
    deleteTable: 'Usuń tabelę',
    link: 'Łącze',
    IndentRight: 'Wcięcie w prawo',
    IndentLeft: 'Wcięcie w lewo',
    showMoreAttachment: 'Pokaż więcej załączników',
    AttachmentLimit: 'Załącz do ',
    attachments: ' załączników, ',
    sizeLimit: ' Maks. MB',
    attachment: 'Załącznik',
    errordeleteattachment: 'Nie udało się usunąć plików. Spróbuj ponownie.',
    errordownloadattachment: 'Nie udało się pobrać plików. Spróbuj ponownie.',
    erroraddattachemnt: 'Nie udało się wgrać pliku. Spróbuj ponownie.',
    errorendcontact: 'Nie udało się zakończyć interakcji. Spróbuj ponownie.',
    erroraddlimitreached:
      'Nie udało się załączyć pliku gdyż przekracza on maks. ',
    errorattachmentdrop:
      'Załączniki zostały odrzucone gdyż zawierały dane niezgodne z zasadami bezpieczeństwa firmy.',
    errorfiletype: 'Ten typ pliku nie jest obsługiwany, spróbuj ponownie.',
    errorcreditcard:
      'Nie udało się wgrać załącznika, gdyż zawiera on dane, które nie przestrzegają zasad bezpieczeństwa firmy.',
    errorcontainsimage:
      'Nie udało się wgrać załącznika, gdyż zawiera on obraz, który nie jest obsługiwany z powodu łamania zasad bezpieczeństwa firmy.',
    errorlimit: ' MB limitu.',
    errorsendemail: 'Nie udało się przesłać wiadomości e-mail. Spróbuj ponownie.',
    errorpcicheckemail: 'Nie udało się pobrać danych PCI. Spróbuj ponownie.',
    errortext: 'Nie udało się załadować danych',
    tryAgain: 'Spróbuj ponownie',
    replywarning:
      'Nie udostępniaj danych natury finansowej, zdrowotnej lub danych umożliwiających identyfikację osoby (PII).',
    datamasked:
      'Tytuł lub treść wiadomości e-mail został ukryty, gdyż zawiera treści niezgodne z zasadami bezpieczeństwa firmy. Czy na pewno chcesz wysłać tę wiadomość?',
    pcibannerwarning:
      'Tytuł wiadomości e-mail lub jej treść zawiera dane ukryte, jako że treść zawiera dane niezgodne z zasadami bezpieczeństwa firmy.',
    on: 'Dnia',
    wrote: 'napisał/-a'
  },
  interaction_control: {
    windowOpened: 'Okno otwarte',
    connected: 'Połączono',
    consultRequested: 'Żądanie konsultacji',
    consulting: 'Konsultacja',
    consultCallOnHold: 'Konsultacja wstrzymana',
    callOnHold: 'Połączenie wstrzymane',
    consult: 'Skonsultuj',
    endconsult: 'Zakończ konsultacje',
    hold: 'Wstrzym.',
    transfer: 'Przekieruj',
    conference: 'Konferencja',
    endconference: 'Zakończ konferencję',
    conferenceRequested: 'Żądanie konferencji',
    switchCall: 'Przełącz',
    mergeCall: 'Scal',
    wrapup: 'Podsumowanie',
    end: 'Zakończ',
    customername: 'Nazwa klienta',
    dn: 'DNIS',
    ivrpath: 'Ścieżka IVR',
    email: 'E-mail klienta',
    ani: 'Numer telefonu',
    queueid: 'Nazwa kolejki',
    ronatimeout: 'Czas Rona',
    pathid: 'Identyfikator ścieżki IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'Agent DN',
    destagentname: 'Imię i nazwisko agenta',
    virtualteamname: 'Kolejka',
    category: 'Kategoria',
    additionaldetails: 'Dodatkowe szczegóły',
    sourcenumber: 'Numer źródłowy',
    sourcepage: 'Strona źródłowa',
    appuser: 'Identyfikator użytkownika aplikacji',
    customernumber: 'Numer telefonu',
    exitconference: 'Wyjdź z konferencji',
    resume: 'Wznów',
    pauserecording: 'Wstrzymaj monitorowanie',
    resumerecording: 'Wznów nagrywanie',
    exitconsult: 'Wyjdź z konsultacji',
    pauseRecordingFailed: 'Nie udało się zatrzymać nagrywania. Spróbuj ponownie.',
    resumeRecordingFailed: 'Nie udało się wznowić nagrywania. Spróbuj ponownie.',
    holdCallFailed: 'Nie udało się zatrzymać połączenia. Spróbuj ponownie.',
    resumeCallFailed: 'Nie udało się wznowić połączenia. Spróbuj ponownie.',
    endCallFailed: 'Nie udało się zakończyć interakcji. Spróbuj ponownie.',
    consultTransferFailed:
      'Nie udało się przekazać połączenia z konsultacją. Spróbuj ponownie.',
    conferenceTransferFailed:
      'Nie udało się przekazać połączenia konferencji. Spróbuj ponownie później.',
    conferenceFailed:
      'Nie można połączyć prośby o konferencję. Spróbuj ponownie.',
    consultEndFailed: 'Nie można zakończyć prośby o konsultację. Spróbuj ponownie.',
    conferenceExitFailed:
      'Nie można wyjść z prośby o konferencję. Spróbuj ponownie.',
    conferenceEndFailed:
      'Nie można zakończyć prośby o konferencję. Spróbuj ponownie.',
    cancelCtqFailed:
      'Nie udało się anulować połączenia konsultacji w kolejce. Spróbuj ponownie później.',
    privacyShield: 'Tarcza prywatności',
    errorOnPrvacyShieldForConsult:
      'Nagrywanie jest w tej chwili wstrzymane. Wznów nagrywanie lub rozpocznij połączenie konsultacji.',
    errorOnPrvacyShieldForTransfer:
      'Nagrywanie jest w tej chwili wstrzymane. Wznów nagrywanie lub rozpocznij połączenie przekierowanie.',
    cancelConsult: 'Anuluj konsultacje',
    cancelTransfer: 'Anuluj przekierowanie',
    copy: 'Kopiuj',
    copied: 'Skopiowane',
    cadrequestuccess: 'Informacje o kliencie zostały zapisane pomyślnie.',
    cadrequestfailure: 'Nie udało się zapisać informacji klienta. Spróbuj ponownie później.',
    cadupdatedmessage: 'Dane o kliencie zostały zaktualizowane przez:',
    unsavedmessage: 'Niezapisane zmiany zostały nadpisane.',
    save: 'Zapisz',
    revert: 'Przywróć',
    expandDetails: 'Rozwiń szczegóły',
    collapseDetails: 'Zwiń szczegóły',
    cadValidationError:
      'Nieprawidłowy format. Użyj międzynarodowego standardu daty i godziny.',
    secureCadSaveError:
      'Informacje o kliencie nie zostały zapisane. Kliknij przycisk Zapisz, aby spróbować ponownie.',
    secureDecryptionError: 'Nie można wyświetlić zabezpieczonych zmiennych.',
    clickToTry: 'Kliknij, aby ponowić próbę',
    isSecureVariable: 'to zabezpieczona zmienna',
    contactorigin: 'Początek kontaktu',
    resumeMonitoring: 'Wznów monitorowanie',
    pauseMonitoring: 'Wstrzymaj monitorowanie',
    whisperCoach: 'Instruktaż szeptany',
    bargeIn: 'Przyłącz się',
    endMonitoring: 'Zakończ monitorowanie',
    contactphonenumber: 'Numer telefonu kontaktowego',
    contactqueue: 'Kolejka kontaktów',
    activeparticipants: 'Aktywni uczestnicy',
    consultedparticipant: 'Konsultacja z uczestnikiem',
    contactstatus: 'Stan kontaktu',
    timeincontactstatus: 'Czas w stanie kontaktu',
    totalcontactduration: 'Całkowity czas trwania kontaktu',
    agentinteractiontime: 'Czas trwania interakcji',
    recording: 'Nagrywanie',
    monitoring: 'Monitorowanie',
    monitoringPaused: 'Wstrzymane monitorowanie',
    pauseMonitoringFailed: 'Nie udało się wstrzymać monitorowania. Spróbuj ponownie',
    resumeMonitoringFailed: 'Nie udało się wznowić monitorowania. Spróbuj ponownie',
    callCancelledInProgress: 'Trwa anulowanie połączenia',
    bargedIn: 'Wtrącenie',
    keypad: 'Klawiatura',
    mute: 'Wycisz',
    unmute: 'Wyłącz wyciszenie',
    bargeInTooltipText:
      'Włączy się mikrofon i dołączysz do interakcji z klientem',
    bargeInCompactTooltipText:
      'Wtrącenie: Włączy się mikrofon i dołączysz do interakcji z klientem',
    bargeInTooltipDisabled: 'Wznów monitorowanie, aby umożliwić wtrącenie',
    bargeInFailedTitle: 'Wtrącenie nie powiodło się',
    bargeInFailedData:
      'Wystąpił błąd podczas próby wtrącenia. Spróbuj ponownie za jakiś czas.',
    supervisorBargedIn: '– wtrącił się do Twojego połączenia.',
    leftInteraction: 'opuścił(a) interakcję.',
    conferenceEnded: 'Połączenie konferencyjne zostało zakończone.',
    participants: 'Uczestnicy',
    badgeAriaLabel: '{participant} jest w trakcie połączenia',
    bargeInConferenceAriaLabel: 'W interakcji bierze udział dwóch uczestników',
    taskName: 'Nazwa zadania Kontroli interakcji',
    interactionDurationLabel: 'Czas trwania',
    wrapupassist: 'Pomoc w podsumowaniu',
    consultingTaskContext: 'Połączenie konsultacyjne od',
    consultExited: 'Połączenie konsultacyjne zakończone',
    endCall: 'Zakończ połączenie.',
    exitconferenceCall:
      'Zakończ połączenie, a konferencja będzie kontynuowana z aktywnymi uczestnikami.',
    recordingInProgess: 'Trwa nagrywanie',
    recordingPaused: 'Nagrywanie wstrzymane',
    searchPlaceholder: 'Wyszukaj kontakty',
    postCall: "Opublikuj połączenie",
    switchCallTooltip: "Przełącz na połączenie",
    switchConsultTooltip: "Przełącz na połączenie konsultacyjne",
    switchConferenceTooltip: "Przełącz na połączenie konferencyjne",
    confirmationDialog: {
      endCallTitle: 'Czy chcesz zakończyć połączenie?',
      endCallMessage: 'Kliknij przycisk Potwierdź, aby zakończyć połączenie dla wszystkich uczestników.',
      exitConferenceTitle: 'Czy chcesz zakończyć połączenie konferencyjne?',
      exitConferenceMessage:
        'Kliknij przycisk Potwierdź, aby zakończyć połączenie konferencyjne i umożliwić innym uczestnikom jego kontynuowanie.',
      confirmButtonLabel: "Potwierdź",
      cancelButtonLabel: "Anuluj",  
    },
    postCallOnHold: "Wstrzymanie opublikowanie połączenia",
    postCallConsult: "Opublikowanie połączenia konsultacyjnego",
    postCallConsultOnHold: "Wstrzymanie opublikowanie połączenia konsultacyjnego",
  },
  agentProfile: {
    teamName: 'Zespół',
    dialNumber: 'Wybierany numer',
    phoneNumber: 'Numer telefonu',
    settings: 'Zmień ustawienia',
    signOut: 'Wyloguj',
    webRTCDisconnected: 'Ostrzeżenie: Telefonia stacjonarna rozłączona ',
    msAuthFailed: 'Uwierzytelnianie firmy Microsoft nie powiodło się',
    stateSyncFailed: 'Synchronizacja stanu nie powiodła się',
    userProfileLabel: 'Profil użytkownika',
    ariaAgentprofile: 'Profil agenta',
    ChannelCapacity: 'Pojemność kanału',
    voice: 'Głos',
    chat: 'Czat',
    email: 'E-mail',
    social: 'Społecznościowe',
    channelCapacityTooltip: 'Kliknij, aby zobaczyć więcej',
    blendedRouting: 'Mieszane',
    exclusiveRouting: 'Routing na wyłączność',
    realtimeRouting: 'Routing mieszany w czasie rzeczywistym',
    blendedRoutingTooltip: 'Obsługa wielu kontaktów w różnych kanałach.',
    exclusiveRoutingTooltip: 'Obsługiwać w danym momencie tylko jednego kontaktu.',
    realtimeRoutingTooltip: 'Obsługa jednego obowiązkowego kanału czasu rzeczywistego.',
    errorActiveContacts:
      'Nie możesz się teraz wylogować, gdyż bierzesz udział w aktywnych konwersacjach. Zakończ je i spróbuj ponownie.',
    searchTeams: 'Wyszukaj zespół',
    changeTeamsConfirmHeader: 'Potwierdzenie zmiany zespołu',
    changeTeamsConfirmMessage: 'Czy na pewno chcesz zmienić zespół?',
    changeTeamLabel: 'Zmiana zespołu',
    errorChangeTeams:
      'Nie możesz zmienić w tym momencie zespołu, ponieważ masz aktywne żądania. Należy je najpierw obsłużyć, a potem spróbować ponownie.',
    saveTeamSelection: 'Zapisz wybór zespołu',
    userSettings: 'Ustawienia użytkownika',
    resetLayout: 'Zresetuj cały układ pulpitu',
    resetConfirmHeader: 'Potwierdzenie zresetowania układu pulpitu',
    resetConfirmMessage:
      'Czy na pewno chcesz zresetować cały układ pulpitu?<br/> Pulpit powróci do domyślnego układu.',
    downloadLogs: 'Pobierz raport o błędach',
    help: 'Pomoc',
    signoutConfirm: 'Czy na pewno chcesz się wylogować?',
    signoutConfirmHeader: 'Potwierdzenie wylogowania',
    darkTheme: 'Przełącz na ciemny motyw',
    newLook: 'Przełącz na nowy wygląd',
    keyboardShortcuts: 'Skróty klawiszowe',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Ustawienia powiadomień',
    silentNotification: 'Ciche powiadomienia',
    enableNotificationSettings: 'Włącz powiadomienia',
    enableSilentNotificationSettings: 'Włącz ciche powiadomienia',
    suppressWebexCallingNotificationSettings: 'Ukryj powiadomienia Webex Calling',
    notificationSettingDescription:
      'Dostarcza powiadomienia, takie jak nowe wiadomości, alerty i zmiany statusu.',
    silentNotificationDescription:
      'Wyłącza alerty na ekranie. Możesz wyświetlać powiadomienia w Centrum powiadomień.',
    suppressWebexCallingNotificationDescription: 
    'Nie wyświetlaj wyskakujących powiadomień o przychodzących połączeniach Webex i odbieraj je za pośrednictwem Webex Contact Center.',
    arrowLabel: 'Wróć',
    managedTeams: 'Zespoły zarządzane',
    managedTeamsError: 'Nie udało się załadować zespołów.',
    viewAll: 'Wyświetl wszystko',
    profileSettings: 'Ustawienia profilu',
    userRole: 'Rola',
    saveSelection: 'Zapisz zaznaczenie',
    extension: 'Nr wewnętrzny',
    changeProfileConfirmHeader: 'Potwierdź zmiany w ustawieniach profilowych',
    changeProfileConfirmMessage:
      'Czy na pewno chcesz zapisać zmiany w profilu?',
    confirm: 'Potwierdź',
    errorProfileUpdate:
      'Nie możesz zmienić w tym ustawień profilu, ponieważ masz aktywne żądania. Należy je najpierw obsłużyć, a potem spróbować ponownie.',
    roleAgentSupervisor: 'Przełożony i agent',
    roleSupervisor: 'Przełożony',
    noTeam: 'Brak zespołu',
    testYourNetwork: 'Przetestuj swoją sieć',
    speakerAndMic: 'Głośnik i mikrofon',
    speaker: 'Głośnik',
    mic: 'Mikrofon',
    speakerDescription:
      'Wybierz i przetestuj urządzenie wyjściowe, aby upewnić się, że słyszysz rozmówcę.',
    micDescription:
      'Wybierz i przetestuj urządzenie wejściowe, aby upewnić się, że rozmówca Cię usłyszy.',
    micError:
      'Dostęp do mikrofonu jest zablokowany. Włącz dostęp poprzez ustawienia przeglądarki lub skontaktuj się z administratorem.',
    speakerError:
      'Głośnik jest obecnie niedostępny, ponieważ odmówiono dostępu do mikrofonu.',
    telephony: 'Telefonia',
    desktop: 'Pulpit',
    onSpeakerPlay:
      'Jeśli nie słychać dźwięku testowego, sprawdź głośnik.',
    onMicPlay:
      'Jeśli nie słychać dźwięku testowego, sprawdź głośnik i mikrofon.',
    onMicRecord: 'Nagraj wiadomość do odtworzenia.',
    test: 'Test',
    recording: 'Nagrywanie',
    playing: 'Odtwarzanie',
    reconnecting: 'Ponowne łączenie',
    disconnectMessage:
      'Telefonia stacjonarna rozłączona. Spróbuj innej opcji.',
    singleTelephonyDisconnectMessage:
      'Telefon stacjonarny rozłączony. Skontaktuj się z administratorem.',
    clear: 'Wyczyść dane',
    rememberMeCheckBoxMessage: "Nie pokazuj tego ponownie",
    saveLabel: 'Zapisz',
    browserUnsupportedError: "Logowanie nie powiodło się, ponieważ używana przeglądarka jest nieobsługiwana.",
    microphoneAccessDeniedError: "Dostęp do mikrofonu jest zablokowany. Włącz dostęp poprzez ustawienia przeglądarki lub skontaktuj się z administratorem.",
  },
  contactHistory: {
    mainHeader: 'Historia kontaktów',
    handledBy: 'Realizowane przez',
    noRecordFound: 'Nie odnaleziono historii kontaktów.',
    tryAgain: 'Spróbuj ponownie',
    errorMsg: 'Nie udało się pobrać historii kontaktów. Spróbuj ponownie.',
    errorID: 'Identyfikator błędu',
    missingAni: 'Brak ANI',
    timeIcon: 'Czas trwania',
    taskHandled: 'Zadanie obsłużone',
    noHistoryNew: 'Brak historii',
    noHistory: 'Brak historii',
    viewTranscript: 'Wyświetl wiadomość e-mail',
    transcriptFor: 'Transkrypcje',
    editBeforeCall: 'Edycja przed nawiązaniem połączenia',
    clickToCall: 'Kliknij, aby połączyć',
    onAnActiveCallErrorMessage:
      'Nie można zainicjować nowego połączenia, ponieważ użytkownik ma w tym momencie otwarte połączenie.',
    receivedFrom: 'Kontakt otrzymany od',
    initiatedTo: 'Kontakt zainicjowany do',
    wrapUpReason: 'Powód zakończenia',
    startCallTelephony:
      'Kliknij łącze z numerem telefonu, aby rozpocząć połączenie wychodzące.',
    contactHistoryList: 'Lista historii kontaktów,',
    wrapUpCode: 'Kod podsumowania',
    agentName: 'Imię i nazwisko agenta',
    entryPointName: 'Punkt wejścia',
    acceptedTimeAndDate: 'Przyjęta data i godzina',
    duration: 'Czas trwania',
    emailTranscript: 'Transkrypcja e-mail',
    clickToViewEmailTranscript: 'Kliknij, aby wyświetlić transkrypcję e-maila',
    listContainer: 'Kontener listy'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Punkt wejścia',
    date: 'Data',
    subject: 'Temat',
    from: 'Od',
    sent: 'Wysłane',
    to: 'Do',
    back: 'Wstecz',
    errorTranscript: 'Wystąpił błąd podczas pobierania transkryptów',
    customer: 'Klient',
    inboundErrorMessage: 'Nie udało się załadować e-maila klienta',
    outboundErrorMessage: 'Nie udało się załadować odpowiedzi agenta'
  },
  popoverTitle: {
    callback: 'Oddzwanianie',
    outboundCall: 'Poł. wychodzące',
    incomingCall: 'Połączenie przychodzące',
    progressiveCampaign: 'Połączenie kampanii',
    courtesyCallback: 'Opcja oddzwaniania',
    chat: 'Czat przychodzący',
    incoming: 'Przychodzące',
    monitoringCall: 'Monitorowanie połączenia'
  },
  connecting: 'Łączenie',
  initiating: 'Inicjowanie',
  outbound: 'Wychodzące',
  transfer: {
    title: 'Żądanie przekierowania',
    heading: {
      chat: 'Zaznacz agenta lub kolejkę, do której chcesz przekazać połączenie.',
      email: 'Zaznacz kolejkę, do której chcesz przekazać połączenie.',
      telephony:
        'Zaznacz agenta, kolejkę lub numer wybierania, pod który chcesz przekazać połączenie.',
      noQueueTelephony:
        'Zaznacz agenta lub numer wybierania, pod który chcesz przekazać połączenie.'
    },
    header: {
      chat: 'Wybierz agenta lub kolejkę, aby przekazać kontakt.',
      email: 'Wybierz kolejkę do przekazania tego kontaktu.',
      telephony:
        'Wybierz agenta, kolejkę, numer wybierania lub organizację do przeniesienia tego kontaktu.',
      noQueueTelephony:
        'Wybierz agenta, numer wybierania lub organizację do przeniesienia tego kontaktu.',
      noOrganizationTelephony:
        'Wybierz agenta, kolejkę lub numer wybierania do przeniesienia tego kontaktu.',
      noQueueOrganizationTelephony:
        'Wybierz konkretną kolejkę, agenta lub numer, aby przenieść ten kontakt.'
    },
    queues: 'Kolejka',
    agents: 'Agent',
    dialNumber: 'Wybierany numer',
    organization: 'Organizacja',
    placeholder: {
      Queues: 'Wybierz z listy kolejek',
      Agents: 'Wybierz z listy agentów',
      DialNumber: 'Wybierz według nazwy bądź numeru',
      DialNumberOrEntryPoint: 'Wybierz według nazwy/numeru/punktu wejścia',
      ChooseByNameOrNumber: 'Wybierz według nazwy bądź numeru',
      Organization: 'Wyszukiwanie według nazwiska/funkcji/działu/telefonu służbowego',
      WebexOrganization: 'Wyszukiwanie według nazwy lub adresu e-mail',
      DialNumberSearch: 'Wyszukiwanie według nazwy lub numeru'
    },
    type: 'Przekieruj',
    cancel: 'Anuluj',
    closeModal: 'Zamknij moduł',
    failureError: 'Nie udało się przekazać żądania. Spróbuj ponownie.',
    entryPoint: 'Punkt wejścia'
  },
  consult: {
    title: 'Żądanie konsultacji',
    heading: {
      chat: 'Zaznacz agenta lub kolejkę, do której chcesz przekazać połączenie.',
      email: 'Zaznacz kolejkę, do której chcesz przekazać połączenie.',
      telephony:
        'Zaznacz agenta, kolejkę lub numer wybierania, z którym chcesz przeprowadzić konsultację.',
      noQueueTelephony:
        'Zaznacz agenta lub numer wybierania, z którym chcesz przeprowadzić konsultację.'
    },
    header: {
      chat: 'Wybierz agenta lub kolejkę, aby przekazać kontakt.',
      email: 'Wybierz kolejkę do przekazania tego kontaktu.',
      telephony:
        'Wybierz agenta, kolejkę, numer wybierania lub organizację, z którą chcesz się skonsultować.',
      noQueueTelephony:
        'Wybierz agenta, numer wybierania lub organizację, z którą chcesz się skonsultować.',
      noOrganizationTelephony:
        'Zaznacz agenta, kolejkę lub numer wybierania, z którym chcesz przeprowadzić konsultację.',
      noQueueOrganizationTelephony:
        'Zaznacz agenta lub numer wybierania, z którym chcesz przeprowadzić konsultację.'
    },
    queues: 'Kolejka',
    agents: 'Agent',
    dialNumber: 'Wybierany numer',
    organization: 'Organizacja',
    placeholder: {
      Queues: 'Wybierz z listy kolejek',
      Agents: 'Wybierz z listy agentów',
      DialNumber: 'Wybierz według nazwy bądź numeru',
      DialNumberOrEntryPoint: 'Wybierz według nazwy/numeru/punktu wejścia',
      ChooseByNameOrNumber: 'Wybierz według nazwy bądź numeru',
      Organization: 'Wyszukiwanie według nazwiska/funkcji/działu/telefonu służbowego',
      WebexOrganization: 'Wyszukiwanie według nazwy lub adresu e-mail',
      DialNumberSearch: 'Wyszukiwanie według nazwy lub numeru'
    },
    type: 'Skonsultuj',
    checkBoxLabel: 'Zezwól uczestnikom na dalszą interakcję.',
    cancel: 'Anuluj',
    closeModal: 'Zamknij moduł',
    failureError: 'Nie można połączyć prośby o konsultację. Spróbuj ponownie.',
    customerLeftMsg: 'Klient rozłączony. Konsultacja nie jest już potrzebna.',
    ctqFailureMsg:
      'Nie udało się anulować połączenia konsultacji w kolejce. Spróbuj ponownie później.',
    cancelCtqInfo:
      'Trwa wyszukiwanie odpowiedniego agenta w kolejce. Poczekaj albo anuluj żądanie konsultacji.',
    cancelCtqAction: 'Anuluj konsultacje',
    entryPoint: 'Punkt wejścia'
  },
  conference: {
    title: 'Żądanie konferencji',
    heading: {
      chat: 'Wybierz konkretnego agenta lub czat konferencyjny'
    },
    queues: 'Kolejka',
    agents: 'Agent',
    dialNumber: 'Wybierany numer',
    organization: 'Organizacja',
    placeholder: {
      Queues: 'Wybierz z listy kolejek',
      Agents: 'Wybierz z listy agentów',
      DialNumber: 'Wybierz według nazwy bądź numeru'
    },
    type: 'Konferencja',
    cancel: 'Anuluj',
    closeModal: 'Zamknij moduł',
    failureError: 'Nie udało się zainicjować żądania konferencji. Spróbuj ponownie.'
  },
  transferModal: {
    Agents: 'Nie udało się pobrać listy agentów. Odśwież listę.',
    AgentsEmpty: 'Brak dostępnych agentów',
    Queues: 'Nie udało się pobrać listy kolejek. Odśwież listę.',
    QueuesEmpty: 'Brak dostępnej kolejki',
    EPEmpty: 'Brak dostępnego punktu wejścia',
    DialNumber:
      'Nie udało się pobrać listy numerów wybierania z książki adresowej. Odśwież listę.',
    EntryPoint:
      'Nie można pobrać listy numerów punktów wejścia. Proszę odświeżyć listę.',
    Common: 'Nie można pobrać listy. Proszę odświeżyć listę.',
    DialNumberEmpty: 'Brak dostępnego numeru wybierania',
    DialNumbInvalid:
      'Wybrany numer jest niepoprawny. Skontaktuj się z administratorem.',
    DialNumbOrEntryPointInvalid:
      'Numer wybierania/punkt wejścia jest nieprawidłowy. Skontaktuj się z administratorem.',
    refreshQueueList: 'Odśwież listę kolejek',
    refreshAgentList: 'Odśwież listę agentów',
    refreshEpList: 'Odśwież punkty wejścia',
    refreshAddressBook: 'Odśwież książkę adresową',
    refreshTheList: 'Odśwież listę',
    entryPointSectionLabel: 'Punkt wejścia',
    addressBookSectionLabel: 'Książka adresowa',
    organization: 'Organizacja',
    comboBoxAriaLabelAgent: 'Wybierz z listy agentów',
    comboBoxAriaLabelQueue: 'Wybierz z listy kolejek',
    comboBoxAriaLabelEp: 'Wybierz z listy punkty wejścia',
    infScrollAgent: 'Wyszukaj agentów',
    infScrollQueue: 'Kolejki wyszukiwania',
    infScrollEP: 'Wyszukaj punkty wejścia',
    allRadioButtonHidedTextForConsult: 'Nie masz przypisanych podmiotów do konsultowania tej interakcji. Skontaktuj się z administratorem.',
    allRadioButtonHidedTextForTransfer: 'Nie masz przypisanych podmiotów do przeniesienia tej interakcji. Skontaktuj się z administratorem.',
    allRadioButtonHidedTextForConference: 'Nie masz przypisanych podmiotów do konferencji tej interakcji. Skontaktuj się z administratorem.',
    searchMinCharError: 'Wprowadź co najmniej trzy znaki, aby wyszukać.',
  },
  wrapup: {
    cancelautowrapup: 'Anuluj automatyczne kończenie',
    wrapupreason: 'Powody zakończenia',
    untilautowrapup: 'do automatycznego zakończenia',
    followupsetting: 'Ustawienia dalszych działań',
    lastagentroute: 'Ostatnie trasowanie agenta',
    submitwrapup: 'Prześlij zakończenie',
    wrapupsearch: 'Przeszukaj powody zakończenia',
    invalidationError: 'Nie udało się przesłać zakończenia',
    searchResult: 'Dostępne wyniki wyszukiwania',
    noResultFound: 'Nie znaleziono wyników wyszukiwania',
    listContainerLabel: 'Kontener listy zestawienia',
    searchError: 'Wprowadź co najmniej trzy znaki, aby wyszukać powody podsumowania.',
  },

  outdial: {
    call: 'Połącz',
    dialpadSearch: 'Wprowadź numer',
    addressSearch: 'Wprowadź nazwę/numer',
    addressTab: 'Adres',
    addressTabTooltip: 'Szukaj w książce adresowej',
    dialpadTab: 'Klawiatura numeryczna',
    dialpadTooltip: 'Wybieranie numeru',
    searchTab: 'Szukaj',
    searchTabTooltip:'Wyszukiwanie osób w organizacji',
    noAdrFound: 'Nie odnaleziono wyników',
    noContacts: 'Brak kontaktów',
    mainIconTooltip: 'Połączenie wychodzące',
    errorOutdialFailed:
      'Połączenie wychodzące nie powiodło się. Pulpit nie był w stanie nawiązać połączenia lub połączenie nie zostało odebrane.',
    errorOutdialDisabled: 'Połączenia wychodzące są wyłączone',
    errorDialPadValidationMessage: 'Nieprawidłowy format',
    outdialReqInProgress: 'Połączenie wychodzące jest w toku',
    outdialAniPlaceholder: 'Wybierz poł. wychodzące ANI',
    outdialAniLabel: 'ANI połączeń wychodzących',
    outdialAniPlaceHolder: 'Wyszukiwanie numeru ANI wybierania wychodzącego',
    errorDcCallsLimitExceeded:
      'Centrum danych osiągnęło maksymalny limit połączeń wychodzących. Nie można wykonać więcej połączeń wychodzących',
    errorOrgCallsLimitExceeded:
      'Organizacja osiągnęła maksymalny limit połączeń wychodzących. Nie można wykonać więcej połączeń wychodzących.',
    errorOutDialNoAnswerFromCustomer:
      'Klient nie odebrał Twojego połączenia. Spróbuj zadzwonić później.',
    errorOutDialCustomerUnavailable:
      'Klient jest obecnie niedostępny. Spróbuj zadzwonić później.',
    errorOutDialAgentEnds: 'Twoje połączenie z klientem zostało zakończone.',
    errorOutDialCustomerBusy: 'Klient jest obecnie zajęty. Spróbuj zadzwonić później.',
    searchError: 'Wprowadź co najmniej trzy znaki, aby wyszukać kontakty.',
    upArrowLabel: 'Rozwiń',
    clear: 'Wyczyść dane',
    outdialDialogDescription: 'Obecnie znajdujesz się w oknie z zakładkami.'
  },

  organization: {
    noMatchFound: 'Nie odnaleziono wyników',
    searchError: 'Wprowadź co najmniej trzy znaki, aby wyszukać kontakty.',
    authError: 'Brak kontaktów do wyświetlenia. Uwierzytelnianie Microsoft nie powiodło się.'
  },

  interactionPopover: {
    of: 'spośród',
    accept: 'Odbierz',
    acceptAriaLabel: 'Zaakceptuj zadanie {taskNumber} - {taskType} od {from}',
    requests: 'Żądań',
    back: 'wstecz',
    next: 'dalej',
    acceptMultipleRequest: 'Zaakceptuj żądania: {requestCount}',
    paginationDetail: '{indexStart}-{indexEnd} z {totalPopoverpoolLength}',
    hidePopoverDetails: 'Ukryj szczegóły wiadomości',
    showPopoverDetails: 'Pokaż szczegóły wiadomości',
    customerName: 'Nazwa klienta',
    email: 'E-mail',
    queueName: 'Nazwa kolejki',
    failedToAccept: 'Nie udało się zaakceptować.',
    unableToAccept: 'Nie można odebrać kontaktu.',
    failedToEnd: 'Nie można zakończyć.',
    unableToEnd: 'Nie można zakończyć kontaktu. ',
    ringing: 'Dzwoni',
    calling: 'Łączenie',
    phoneNumber: 'Numer telefonu',
    dni: 'DNIS',
    ivrPathId: 'Identyfikator ścieżki IVR',
    pathId: 'Identyfikator ścieżki',
    rona: 'Przekier. bez odp.',
    sourcePage: 'Strona źródłowa',
    sourceNumber: 'Numer źródłowy',
    appUserId: 'Identyfikator użytkownika aplikacji',
    acceptAll: 'Akceptuj wszystkie zadania',
    agentDn: 'Agent DN',
    agentName: 'Nazwa agenta',
    agentTeam: 'Agent Team (Zespół agentów)',
    requestDetails: 'Poproś o szczegóły',
    incomingCallFrom: 'Połączenie przychodzące od:',
    unableToAnswer: 'Nie można odebrać połączenia. Spróbuj ponownie.',
    unableToDecline: 'Nie można odrzucić połączenia. Spróbuj ponownie.'
  },

  multiLogin: {
    header: 'Alert o wielokrotnym logowaniu',
    message:
      'Pulpit jest otwarty w kilku instancjach aplikacji. Naciśnij przycisk „Kontynuuj”, aby otworzyć go w tej instancji. W innym wypadku zamknij to okno.',
    continue: 'Kontynuuj'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Przekierowanie do punktu wejścia/kolejki nie powiodło się z powodu błędu konfiguracji.',
    1010: "Nie udało się przeprowadzić konsultacji, ponieważ nie udało się przydzielić agenta na czas. ",
    1042: "Nie udało się znaleźć kontaktu",
    1043: 'Nieprawidłowy cel.',
    1045: 'Interakcja nie jest przypisana do agenta.',
    1046: 'Konsultacja z agentem nie powiodła się, ponieważ w systemie nie znaleziono pasującego kanału agenta.',
    1038: "Nie udało się znaleźć agenta",
    1037: 'Logowanie nie powiodło się z powodu błędu wewnętrznego.',

    // Media Events
    138: 'Akcja nie powiodła się z nieznanych przyczyn.',
    136: 'Nie znaleziono użytkownika',

    // AgentConsultFailed
    1050: 'Nie można sprawdzić z powodu nieobsługiwanej konfiguracji lub aktywności w przepływie. ',
    1005: "Nie udało się przeprowadzić konsultacji, ponieważ agent nie odpowiedział na prośbę na czas.",
    1051: 'Nie można uzyskać połączenia lub transferu z powodu nieprawidłowego punktu wejścia lub numeru wybierania.',

    // AgentInviteFailed
    1053: 'Nie można zaprezentować interakcji z powodu oczekującego żądania przepływu pracy.',
    1054: 'Nie można nawiązać połączenia wychodzącego z powodu problemów z mediami dla tego żądania. ',

    // AgentContactAssignFailed
    1011: 'Brak możliwości odebrania lub przyjęcia połączenia z powodu braku agentów w trwającej interakcji. ',

    // ContactCallbackFailed
    1034: 'Oddzwonienie do kontaktu nie powiodło się, ponieważ dla żądania odebrano ContactParkTimeout.',

    // ContactUpdateFailed
    1020: "Nie można zaktualizować zmiennych, ponieważ jedna z wartości przekracza limit 256 znaków. Zmniejsz liczbę znaków i spróbuj ponownie.",

    // AgentInviteFailed
    1031: 'Agent zaprosił klienta po zażądaniu oddzwonienia.',

    // AgentBlindTransferFailedEvent
    1044: 'Przekierowanie bez konsultacji zakończone niepowodzeniem, ponieważ agent docelowy jest przypisany do innej interakcji.',

    // AgentCtqCancelFailed
    1047: "Nie udało się znaleźć kontaktu.",

    // AgentCtqFailed
    1048: "Grupa dystrybucji połączeń nie jest skonfigurowana.",
    1049: 'Przekroczono maksymalny czas oczekiwania w kolejce.',
    // StationLoginFailed
    127: 'Rejestr DN agenta nie powiódł się z wyjątkiem zduplikowanego logowania.'
  },

  stateSelector: {
    Available: 'Dostępny',
    errorstatechange: 'Zmiana stanu nie powiodła się. Spróbuj ponownie.',
    errorStateChangeInPendingLogout: 'Nie udało się zmienić stanu agenta z powodu oczekującego wylogowania.',
    label: 'Stan dostępności',
    agentStateSelector: 'Selektor stanu agenta',
    Engaged: 'Zaangażowany',
    engagedAvailableInfo:
      'Jesteś obecnie zaangażowany w interakcję i znajdujesz się w stanie Dostępny.',
    engagedIdleInfo:
      'Jesteś obecnie zaangażowany w interakcję i znajdujesz się w stanie Bezczynny.',
    engagedInfo: 'Jesteś obecnie zaangażowany w interakcję.',
    engagedSupervisorStateChange: 'zmienił Twój stan na:',
    axAgentStateChanged: 'Twój stan zmienił się na:',
    axAgentSync: 'z powodu synchronizacji stanu z narzędziem do współpracy.',
    engagedPresenceInfo:
      'Jesteś obecnie zaangażowany w interakcję i znajdujesz się w stanie:',
    engagedPresenceSync: 'z powodu synchronizacji stanu z narzędziem do współpracy.',
    clear: 'Wyczyść dane',
    searchState: 'dane',
    agentStatusLabel: 'Stan agenta',
    agentStateLabel: 'Agent jest w stanie {selectedState} przez ostatnie {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Agent jest w stanie {selectedState} przez ostatnie 0 sek',
    agentStateChangeSuccessful:'Zmiana stanu na {selectedState} zakończyła się sukcesem.',
    agentStateChangeFail:'Zmiana stanu na {selectedState} nie powiodła się',
    searchError: 'Wprowadź co najmniej trzy znaki, aby wyszukać stany.'
  },

  warningMessage: {
    header: 'Niezapisane zmiany',
    message:
      'Nie udało się zapisać zmian na tej stronie. Czy na pewno chcesz ją opuścić? ',
    cancelButton: 'Pozostań',
    saveButton: 'Opuść'
  },

  notificationLables: {
    muteVolume: 'Wycisz dźwięk powiadomienia',
    unmuteVolume: 'Anuluj wyciszenie dźwięku powiadomienia',
    notificationVolume: 'Dźwięk powiadomienia',
    playSound: 'Odtwórz dźwięk powiadomienia',
    enableSoundNotificationSettings: 'Włącz dźwięk powiadomienia',
    enableSoundNotificationSettingsDescription:
      'Odtwarza dźwięki powiadomień dla przychodzących żądań. Głośność można zmienić poniżej.',
    volumeTitle: 'Dźwięk powiadomienia'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Połącz',
    chat: 'Czat',
    email: 'E-mail',
    facebook: 'Messenger',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Czat Apple Business',
    googleBusiness: "Komunikaty biznesowe Google"
  },
  orgDetailsLabels: {
    role: 'Rola',
    department: 'Dział',
    email: 'Adres e-mail',
    businessPhone: 'Telefon służbowy',
    workPhone: 'Praca',
  },
  addressListError: {
    title: 'Nie udało się załadować danych',
    errorId: 'Identyfikator błędu:'
  },
  keypad: {
    keyPadSearch: 'Wprowadź numer',
    dialPad: 'Klawiatura numeryczna'
  },
  collabTool: {
    userAuthenticated: 'Użyj funkcji uwierzytelniania:',
    successful: 'Pomyślne',
    failed: 'Niepowodzenie.',
    tryAgain: 'Spróbuj ponownie',
    stateSync: 'Synchronizacja stanu:',
    mercuryFailedInfo: ' Skontaktuj się z administratorem.',
    retrying: 'Ponowna próba...',
    trackingIdLabel: 'Identyfikator śledzenia: '
  },
  webex: {
    webex: 'Webex',
    info: 'Integracja umożliwia synchronizację stanów między Desktop a Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Dzięki tej integracji możesz konsultować lub przekazywać połączenia do użytkowników Microsoft Teams.',
    authenticationFailedInfo:
      'Jeśli okno uwierzytelniania jest już otwarte, należy ponowić próbę uwierzytelnienia.',
    ListItemContactDetails:
      'Nazwa kontaktu to: {name}, jego obecność to: {presence}, dział to {department}, stanowisko to: {jobTitle}, a numer telefonu to: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Powiadomienie służb ratunkowych',
    readNotification: 'Przeczytałem powiadomienie.'
  },
  webexPresenceStatus: {
    active: 'Aktywne',
    lastActiveFewMinutesAgo: 'Aktywny w ciągu ostatnich kilku minut',
    lastActiveMinutesAgo: 'Aktywny {min} min temu',
    lastActive1HourAgo: 'Ostatnia aktywność 1 godzinę temu',
    lastActiveHoursAgo: 'Aktywny {hour} godz. temu',
    lastActiveYesterday: 'Aktywny wczoraj',
    lastActiveOnDate: 'Aktywny: {date}',
    busy: 'Numer zajęty',
    busyUntil: 'Zajęty do {date}',
    dnd: 'Nie przeszk.',
    dndUntil: 'Nie przeszkadzać do {date}',
    quiet: 'Wyciszony',
    quietUntil: 'Wyciszony do {date}',
    ooo: 'Poza biurem',
    outOfOfficeUntil: 'Poza biurem do {date}',
    call: 'W trakcie rozmowy',
    meeting: 'Na spotkaniu',
    calendarItem: 'Na spotkaniu dot. kalendarza',
    presenting: 'Trwa prezentacja',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Wyszukiwanie według nazwy lub szczegółów profilu',
    webexPlaceholder: 'Wyszukiwanie według nazwy lub adresu e-mail',
    refreshTheList: 'Odśwież listę',
    refreshAddressBook: 'Odśwież książkę adresową',
    microsoftAuthError: 'Brak kontaktów do wyświetlenia. Uwierzytelnianie Microsoft nie powiodło się.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/pt.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/pt.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Falha ao carregar dados',
    errorID: 'ID do erro',
    tryAgain: 'Tentar novamente',
    Error: 'Erro',
    okButton: 'OK',
    Yes: 'Sim',
    Cancel: 'Cancelar',
    Confirm: 'Confirmar',
    Continue: 'Continuar',
    Canceling: 'Cancelando',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: 'Atender',
    AnswerAriaLabel: 'Tarefa de área de trabalho Atender',
    Decline: 'Recusar',
    ErrorSecurityCompliance: 'Conformidade com segurança',
    errorDetails: 'Detalhes do erro',
    learnMore: 'Saber mais',
    showLess: 'Mostrar menos',
    trackingIdDescription:
      'Compartilhe a ID de rastreamento com o administrador do site ou com a equipe de suporte para investigar a situação.',
    trackingIdInputLabel: 'ID de rastreamento: ',
    submitForm: 'Enviar formulário',
    unnamedStatus: 'Status sem nome',
    errorChatMsg: 'Falha ao carregar dados de bate-papo',
    noOptions: 'Nenhuma opção',
    noResults: 'Nenhum resultado',
    more: 'Mais',
    nomatchfound: 'Nenhuma equivalência encontrada',
    collaborationTool: 'Ferramenta de colaboração',
    timerAriaLabel: 'Tempo gasto',
    historyItemTime: 'Aconteceu em',
    loading: 'Carregando',
    months: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro'
    ],
    loadingMsg: 'Carregando...',
    search: 'Pesquisar',
    historyChannelLabels: {
      All: 'Todos',
      telephony: 'Voz',
      chat: 'Bate-papo',
      email: 'E-mail',
      social: 'Social'
    },
    homePageLabel: 'Página inicial',
    resizeHistoryDragger: 'Redimensionar arrastador de histórico',
    agentHistoryLabel: 'histórico do agente',
    clear: 'Limpar entrada',
    ariaLabelAgentHistoryWrapper:
      'O histórico de interação do agente exibe as comunicações recentes do cliente em diferentes canais das últimas 24 horas',
    sliderResizerInstructions:
      'Você está em um controle deslizante no momento. Para redimensionar, use as teclas de seta',
    resizeHistoryPanel: 'Redimensionar painel de histórico, controle deslizante,',
    time: {
      hours: 'hora',
      minutes: 'min',
      seconds: 's'
    }
  },
  email: {
    ToLabel: 'Até',
    FromLabel: 'De',
    CcLabel: 'Cc',
    BccLabel: 'Cco',
    SubjectLabel: 'Assunto',
    HideLabel: 'Ocultar',
    SendLabel: 'Enviar',
    ShowPrevThread: 'Mostrar thread anterior',
    HidePrevThread: 'Ocultar thread anterior',
    ReplyLabel: 'Responder',
    ReplyAllLabel: 'Responder a todos',
    ViewOriginalMail: 'Visualizar e-mail original',
    QuickReplyInp: 'Resposta rápida aqui...',
    AttachFiles: 'Anexar arquivos',
    ToolbarHeading: 'Cabeçalho1',
    ToolbarBold: 'Negrito',
    ToolbarItalic: 'Itálico',
    ToolbarUnderLine: 'Sublinhado',
    ToolbarBlockQuote: 'Bloquear cotação',
    ToolbarCode: 'Bloqueio de código',
    ToolbarListOrder: 'Listar por pedidos',
    ToolbarListBullet: 'Listar por marcador',
    ToolbarLink: 'Link',
    ToolbarStrike: 'Riscar',
    ToolbarColor: 'Cor do Texto',
    ToolbarTable: 'Tabela',
    insertTable: 'Inserir tabela',
    insertRowAbove: 'Inserir linha acima',
    insertRowBelow: 'Inserir linha abaixo',
    insertColumnLeft: 'Inserir coluna esquerda',
    insertColumnRight: 'Inserir coluna direita',
    deleteRow: 'Excluir linha',
    deleteColumn: 'Excluir coluna',
    deleteTable: 'Excluir tabela',
    link: 'Link',
    IndentRight: 'Recuar à direita',
    IndentLeft: 'Recuar à esquerda',
    showMoreAttachment: 'Mostrar mais anexos',
    AttachmentLimit: 'Anexar até ',
    attachments: ' anexos, ',
    sizeLimit: ' MB máximo',
    attachment: 'Anexo',
    errordeleteattachment: 'Impossível excluir arquivo(s). Tente novamente.',
    errordownloadattachment: 'Impossível baixar arquivo(s). Tente novamente.',
    erroraddattachemnt: 'Impossível fazer upload do(s) arquivo(s). Tente novamente.',
    errorendcontact: 'Impossível encerrar a interação. Tente novamente.',
    erroraddlimitreached:
      'O arquivo não pôde ser anexado porque excede o máximo ',
    errorattachmentdrop:
      'Anexo(s) ignorado(s) de acordo com a política de segurança da empresa.',
    errorfiletype: 'O tipo de arquivo não é compatível. Tente novamente.',
    errorcreditcard:
      'Impossível fazer upload do(s) anexo(s) de acordo com a política de segurança da empresa.',
    errorcontainsimage:
      'Impossível carregar o(s) anexo(s). As imagens contidas nos anexos não são suportadas pela política de segurança da empresa.',
    errorlimit: ' MB de limite.',
    errorsendemail: 'Impossível enviar o e-mail. Tente novamente.',
    errorpcicheckemail: 'Impossível recuperar dados PCI. Tente novamente.',
    errortext: 'Falha ao carregar dados',
    tryAgain: 'Tentar novamente',
    replywarning:
      'Não compartilhe informações financeiras, de saúde ou quaisquer informações de identificação pessoal (PII) nesta mensagem ou anexos.',
    datamasked:
      'O assunto ou corpo do e-mail é editado conforme a política de segurança da empresa. Tem certeza de que deseja enviar o e-mail?',
    pcibannerwarning:
      'O assunto ou corpo do e-mail é editado conforme a política de segurança da empresa.',
    on: 'Ligado',
    wrote: 'escreveu'
  },
  interaction_control: {
    windowOpened: 'Janela aberta',
    connected: 'Conectado',
    consultRequested: 'Consulta solicitada',
    consulting: 'Consultando',
    consultCallOnHold: 'Consulta em espera',
    callOnHold: 'Chamada em espera',
    consult: 'Consultar',
    endconsult: 'Finalizar consulta',
    hold: 'Em Espera',
    transfer: 'Transferir',
    conference: 'Conferência',
    endconference: 'Encerrar conferência',
    conferenceRequested: 'Conferência solicitada',
    switchCall: 'Alternar',
    mergeCall: 'Mesclar',
    wrapup: 'Conclusão',
    end: 'Encerrar',
    customername: 'Nome do cliente',
    dn: 'DNIS',
    ivrpath: 'Caminho IVR',
    email: 'E-mail do cliente',
    ani: 'Número de telefone',
    queueid: 'Nome da fila',
    ronatimeout: 'Tempo Rona',
    pathid: 'ID do caminho IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'DN do agente',
    destagentname: 'Nome do agente',
    virtualteamname: 'Fila',
    category: 'Categoria',
    additionaldetails: 'Detalhes adicionais',
    sourcenumber: 'Número da origem',
    sourcepage: 'Página de origem',
    appuser: 'ID de usuário de aplicativo',
    customernumber: 'Número de telefone',
    exitconference: 'Sair da conferência',
    resume: 'Continuar',
    pauserecording: 'Pausar gravação',
    resumerecording: 'Retomar gravação',
    exitconsult: 'Sair da consulta',
    pauseRecordingFailed: 'Impossível pausar a gravação. Tente novamente.',
    resumeRecordingFailed: 'Impossível retomar a gravação. Tente novamente.',
    holdCallFailed: 'Impossível manter a chamada. Tente novamente.',
    resumeCallFailed: 'Impossível retomar a chamada. Tente novamente.',
    endCallFailed: 'Impossível encerrar a interação. Tente novamente.',
    consultTransferFailed:
      'Impossível transferir a chamada de consulta. Tente novamente.',
    conferenceTransferFailed:
      'Impossível transferir a chamada de conferência. Tente novamente.',
    conferenceFailed:
      'Impossível conectar a solicitação de conferência. Tente novamente.',
    consultEndFailed: 'Impossível terminar a solicitação de consulta. Tente novamente.',
    conferenceExitFailed:
      'Impossível sair da solicitação de conferência. Tente novamente.',
    conferenceEndFailed:
      'Impossível terminar a solicitação de conferência. Tente novamente.',
    cancelCtqFailed:
      'Não foi possível cancelar a chamada de consulta para a fila. Tente novamente.',
    privacyShield: 'Privacy Shield',
    errorOnPrvacyShieldForConsult:
      'As gravações estão em pausa no momento. Retome as gravações para iniciar uma chamada de consulta.',
    errorOnPrvacyShieldForTransfer:
      'As gravações estão em pausa no momento. Retome as gravações para iniciar uma transferência de chamadas.',
    cancelConsult: 'Cancelar consulta',
    cancelTransfer: 'Cancelar transferência',
    copy: 'Copiar',
    copied: 'Copiado',
    cadrequestuccess: 'As informações do cliente foram salvas com sucesso.',
    cadrequestfailure: 'Falha ao salvar as informações do cliente. Tente mais tarde.',
    cadupdatedmessage: 'As informações do cliente foram atualizadas recentemente por',
    unsavedmessage: 'Suas alterações não salvas foram sobrescritas.',
    save: 'Salvar',
    revert: 'Reverter',
    expandDetails: 'Expandir detalhes',
    collapseDetails: 'Recolher detalhes',
    cadValidationError:
      'Formato inválido. Use o padrão internacional de data e hora.',
    secureCadSaveError:
      'As informações do cliente não foram salvas. Clique em Salvar para tentar novamente.',
    secureDecryptionError: 'Variáveis seguras não podem ser exibidas.',
    clickToTry: 'Clique para repetir',
    isSecureVariable: 'é uma variável segura',
    contactorigin: 'Origem do contato',
    resumeMonitoring: 'Continuar monitoramento',
    pauseMonitoring: 'Pausar monitoramento',
    whisperCoach: 'Coach supervisor',
    bargeIn: 'Participar sem aviso',
    endMonitoring: 'Finalizar monitoramento',
    contactphonenumber: 'Número de telefone de contato',
    contactqueue: 'Fila de contatos',
    activeparticipants: 'Participantes ativos',
    consultedparticipant: 'Participante consultado',
    contactstatus: 'Status do contato',
    timeincontactstatus: 'Tempo no status do contato',
    totalcontactduration: 'Duração total do contato',
    agentinteractiontime: 'Duração da interação',
    recording: 'Gravação',
    monitoring: 'Monitoramento',
    monitoringPaused: 'Monitoramento pausado',
    pauseMonitoringFailed: 'Impossível pausar o monitoramento. Tente novamente',
    resumeMonitoringFailed: 'Impossível continuar o monitoramento. Tente novamente',
    callCancelledInProgress: 'Cancelamento de chamada em andamento',
    bargedIn: 'Interrompido',
    keypad: 'Teclado',
    mute: 'Silenciar',
    unmute: 'Ativar som',
    bargeInTooltipText:
      'O microfone será ativado e você entrará em uma interação com o cliente',
    bargeInCompactTooltipText:
      'Interrompido. O microfone será ativado e você entrará em uma interação com o cliente',
    bargeInTooltipDisabled: 'Por favor, retome o monitoramento para ativar a interrupção',
    bargeInFailedTitle: 'Falha de interrupção',
    bargeInFailedData:
      'Ocorreu um erro enquanto você tentava interromper. Tente novamente depois de algum tempo.',
    supervisorBargedIn: 'interrompeu sua chamada.',
    leftInteraction: 'saiu da interação.',
    conferenceEnded: 'A chamada de conferência terminou.',
    participants: 'Participantes',
    badgeAriaLabel: '{participant} está na chamada',
    bargeInConferenceAriaLabel: 'Existem dois participantes na interação',
    taskName: 'Nome da tarefa de controle de interação',
    interactionDurationLabel: 'Tempo de duração',
    wrapupassist: 'Assistência pós-atendimento',
    consultingTaskContext: 'Consultando chamada de',
    consultExited: 'Chamada de consulta encerrada',
    endCall: 'Finalize a ligação.',
    exitconferenceCall:
      'Saia da chamada e a conferência continua com os participantes ativos.',
    recordingInProgess: 'Gravação em andamento',
    recordingPaused: 'Gravação pausada',
    searchPlaceholder: 'Pesquisar contatos',
    postCall: "Pós-chamada",
    switchCallTooltip: "Alternar para chamada",
    switchConsultTooltip: "Alternar para chamada de consulta",
    switchConferenceTooltip: "Alternar para chamada de conferência",
    confirmationDialog: {
      endCallTitle: 'Você deseja finalizar a chamada?',
      endCallMessage: 'Clique em Confirmar para encerrar a chamada para todos os participantes.',
      exitConferenceTitle: 'Você deseja sair da chamada de conferência?',
      exitConferenceMessage:
        'Clique em Confirmar para sair da chamada de conferência e permitir que outros participantes continuem.',
      confirmButtonLabel: "Confirmar",
      cancelButtonLabel: "Cancelar",  
    },
    postCallOnHold: "Pós-chamada em espera",
    postCallConsult: "Pós-chamada de consulta",
    postCallConsultOnHold: "Pós-chamada de consulta em espera",
  },
  agentProfile: {
    teamName: 'Equipe',
    dialNumber: 'Número de discagem',
    phoneNumber: 'Número de telefone',
    settings: 'Mudar configurações',
    signOut: 'Finalizar sessão',
    webRTCDisconnected: 'Aviso de telefonia de desktop desconectada ',
    msAuthFailed: 'Falha na autenticação da Microsoft',
    stateSyncFailed: 'Falha na sincronização do estado',
    userProfileLabel: 'Perfil de usuário',
    ariaAgentprofile: 'Perfil de agente',
    ChannelCapacity: 'Capacidade do canal',
    voice: 'Voz',
    chat: 'Bate-papo',
    email: 'E-mail',
    social: 'Social',
    channelCapacityTooltip: 'Clique para ver mais',
    blendedRouting: 'Misto',
    exclusiveRouting: 'Roteamento exclusivo',
    realtimeRouting: 'Roteamento misto em tempo real',
    blendedRoutingTooltip: 'Tratar vários contatos entre os canais.',
    exclusiveRoutingTooltip: 'Lide apenas com um contato por vez.',
    realtimeRoutingTooltip: 'Tratar um canal obrigatório em tempo real.',
    errorActiveContacts:
      'Você não pode finalizar a sessão agora porque tem conversas ativas. Conclua-as e tente novamente.',
    searchTeams: 'Procurar equipes',
    changeTeamsConfirmHeader: 'Confirmação de mudança de equipe',
    changeTeamsConfirmMessage: 'Você tem certeza de que quer mudar sua equipe?',
    changeTeamLabel: 'Mudar equipe',
    errorChangeTeams:
      'Você não pode mudar de equipe agora porque tem solicitação(ões) ativa(s). Por favor, complete-as e tente novamente.',
    saveTeamSelection: 'Salvar seleção de equipe',
    userSettings: 'Configurações do usuário',
    resetLayout: 'Redefinir layout inteiro do Desktop',
    resetConfirmHeader: 'Redefinir confirmação de layout',
    resetConfirmMessage:
      'Tem certeza de que deseja redefinir todo o layout do Desktop?<br/>O Desktop retornará ao layout padrão.',
    downloadLogs: 'Download do relatório de erros',
    help: 'Ajuda',
    signoutConfirm: 'Você tem certeza de que deseja finalizar sessão?',
    signoutConfirmHeader: 'Confirmação de finalizar sessão',
    darkTheme: 'Alternar p/ modo escuro',
    newLook: 'Alternar para novo visual',
    keyboardShortcuts: 'Atalhos de teclado',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Configurações de notificação',
    silentNotification: 'Notificação silenciosa',
    enableNotificationSettings: 'Ativar notificações',
    enableSilentNotificationSettings: 'Ativar notificações silenciosas',
    suppressWebexCallingNotificationSettings: 'Ocultar notificações de Webex Calling',
    notificationSettingDescription:
      'Entrega notificações como novas mensagens, alertas e alterações de status.',
    silentNotificationDescription:
      'Desativa os alertas na tela. Você pode visualizar as notificações na Central de Notificações.',
    suppressWebexCallingNotificationDescription: 
    'Não mostra notificações pop-up para chamadas de Webex recebidas e as atende por meio da Webex Contact Center.',
    arrowLabel: 'Voltar',
    managedTeams: 'Equipes gerenciadas',
    managedTeamsError: 'Falha ao carregar equipes.',
    viewAll: 'Visualizar tudo',
    profileSettings: 'Configurações de perfil',
    userRole: 'Função',
    saveSelection: 'Salvar seleção',
    extension: 'Ramal',
    changeProfileConfirmHeader: 'Confirmar alterações nas configurações de perfil',
    changeProfileConfirmMessage:
      'Tem certeza de que deseja salvar as alterações em seu perfil?',
    confirm: 'Confirmar',
    errorProfileUpdate:
      'Você não pode alterar as configurações de perfil agora porque tem solicitações ativas. Conclua essas solicitações e tente novamente.',
    roleAgentSupervisor: 'Supervisor e agente',
    roleSupervisor: 'Supervisor',
    noTeam: 'Nenhuma equipe',
    testYourNetwork: 'Testar sua rede',
    speakerAndMic: 'Alto-falante e microfone',
    speaker: 'Alto-falante',
    mic: 'Microfone',
    speakerDescription:
      'Escolha e teste o dispositivo de saída para garantir que você ouça o autor da chamada.',
    micDescription:
      'Escolha e teste o dispositivo de entrada para garantir que o autor da chamada ouça você.',
    micError:
      'O acesso ao microfone foi negado. Ative o acesso nas configurações do navegador ou entre em contato com o administrador.',
    speakerError:
      'O alto-falante não está disponível no momento, pois o acesso ao microfone foi negado.',
    telephony: 'Telefonia',
    desktop: 'Desktop',
    onSpeakerPlay:
      'Se não conseguir ouvir o som de teste, verifique o dispositivo do alto-falante.',
    onMicPlay:
      'Se não conseguir ouvir o som de teste, verifique o alto-falante e o microfone.',
    onMicRecord: 'Grave uma mensagem para reprodução.',
    test: 'Testar',
    recording: 'Gravação',
    playing: 'Reproduzindo',
    reconnecting: 'Reconectando',
    disconnectMessage:
      'Telefonia de área de trabalho desconectada. Tente uma opção de telefonia diferente.',
    singleTelephonyDisconnectMessage:
      'Telefonia de área de trabalho desconectada. Entre em contato com o administrador.',
    clear: 'Limpar entrada',
    rememberMeCheckBoxMessage: "Não exibir isto novamente",
    saveLabel: 'Salvar',
    browserUnsupportedError: "Falha ao iniciar sessão porque você está usando um navegador incompatível.",
    microphoneAccessDeniedError: "O acesso ao microfone foi negado. Ative o acesso nas configurações do navegador ou entre em contato com o administrador.",
  },
  contactHistory: {
    mainHeader: 'Histórico do contato',
    handledBy: 'Tratado por',
    noRecordFound: 'Nenhum histórico de contato encontrado!',
    tryAgain: 'Tentar novamente',
    errorMsg: 'Impossível recuperar o histórico de contatos. Tente novamente.',
    errorID: 'ID do erro',
    missingAni: 'ANI ausente',
    timeIcon: 'Duração',
    taskHandled: 'Tarefa tratada',
    noHistoryNew: 'Nenhum histórico',
    noHistory: 'Nenhum histórico',
    viewTranscript: 'Exibir mensagem de e-mail',
    transcriptFor: 'Transcrições de',
    editBeforeCall: 'Editar antes de chamar',
    clickToCall: 'Clicar para ligar',
    onAnActiveCallErrorMessage:
      'Não é possível iniciar uma nova chamada, pois você já está em uma chamada ativa.',
    receivedFrom: 'Contato recebido de',
    initiatedTo: 'Contato iniciado em',
    wrapUpReason: 'Motivo de conclusão',
    startCallTelephony:
      'Clique no link do número do telefone para iniciar uma chamada de saída.',
    contactHistoryList: 'Lista de histórico do contato,',
    wrapUpCode: 'Código de conclusão',
    agentName: 'Nome do agente',
    entryPointName: 'Ponto de entrada',
    acceptedTimeAndDate: 'Data e hora aceitas',
    duration: 'Duração',
    emailTranscript: 'Transcrição por email',
    clickToViewEmailTranscript: 'Clique para ver a transcrição do e-mail',
    listContainer: 'Contêiner da lista'
  },
  contactTranscript: {
    agent: 'Agente',
    entryPoint: 'Ponto de entrada',
    date: 'Data',
    subject: 'Assunto',
    from: 'De',
    sent: 'Enviado',
    to: 'Até',
    back: 'Voltar',
    errorTranscript: 'Ocorreu um erro ao buscar as transcrições',
    customer: 'Cliente',
    inboundErrorMessage: 'Falha ao carregar o e-mail do cliente',
    outboundErrorMessage: 'Falha ao carregar a resposta do agente'
  },
  popoverTitle: {
    callback: 'Retorno de chamada',
    outboundCall: 'Chamada de saída',
    incomingCall: 'Chamada recebida',
    progressiveCampaign: 'Chamada da campanha',
    courtesyCallback: 'Retorno de chamada de cortesia',
    chat: 'Bate-papo recebido',
    incoming: 'Entrada',
    monitoringCall: 'Monitorando chamada'
  },
  connecting: 'Conectando',
  initiating: 'Iniciando',
  outbound: 'Saída',
  transfer: {
    title: 'Solicitação de transferência',
    heading: {
      chat: 'Selecione o agente ou a fila para a qual deseja transferir.',
      email: 'Selecione a fila para a qual deseja transferir.',
      telephony:
        'Selecione o agente, fila ou número de discagem para o qual deseja transferir.',
      noQueueTelephony:
        'Selecione o agente ou o número de discagem para o qual deseja transferir.'
    },
    header: {
      chat: 'Selecione o agente ou a fila para transferir este contato.',
      email: 'Selecione a fila para transferir este contato.',
      telephony:
        'Selecione o agente, a fila, o número de discagem ou a organização para transferir este contato.',
      noQueueTelephony:
        'Selecione o agente, o número de discagem ou a organização para transferir este contato.',
      noOrganizationTelephony:
        'Selecione o agente, a fila ou o número de discagem para transferir este contato.',
      noQueueOrganizationTelephony:
        'Selecione o agente ou o número de discagem para transferir este contato.'
    },
    queues: 'Fila',
    agents: 'Agente',
    dialNumber: 'Número de discagem',
    organization: 'Organização',
    placeholder: {
      Queues: 'Escolher em uma lista de filas',
      Agents: 'Escolher em uma lista de agentes',
      DialNumber: 'Escolher por nome ou número',
      DialNumberOrEntryPoint: 'Escolher por nome/número/ponto de entrada',
      ChooseByNameOrNumber: 'Escolher por nome/número',
      Organization: 'Pesquisar por nome/função/departamento/telefone comercial',
      WebexOrganization: 'Pesquisar por nome ou e-mail',
      DialNumberSearch: 'Pesquisar por nome ou número'
    },
    type: 'Transferir',
    cancel: 'Cancelar',
    closeModal: 'Fechar modal',
    failureError: 'Impossível transferir a solicitação. Tente novamente.',
    entryPoint: 'Ponto de entrada'
  },
  consult: {
    title: 'Solicitação de consulta',
    heading: {
      chat: 'Selecione o agente ou a fila para a qual deseja transferir.',
      email: 'Selecione a fila para a qual deseja transferir.',
      telephony:
        'Selecione o agente, fila ou número de discagem a ser consultado.',
      noQueueTelephony:
        'Selecione o agente ou o número de discagem a ser consultado.'
    },
    header: {
      chat: 'Selecione o agente ou a fila para transferir este contato.',
      email: 'Selecione a fila para transferir este contato.',
      telephony:
        'Selecione o agente, a fila, o número de discagem ou a organização com o qual você quer consultar.',
      noQueueTelephony:
        'Selecione o agente, o número de discagem ou a organização com o qual você quer consultar.',
      noOrganizationTelephony:
        'Selecione o agente, a fila ou o número de discagem com o qual você quer consultar.',
      noQueueOrganizationTelephony:
        'Selecione o agente ou o número de discagem com o qual você quer consultar.'
    },
    queues: 'Fila',
    agents: 'Agente',
    dialNumber: 'Número de discagem',
    organization: 'Organização',
    placeholder: {
      Queues: 'Escolher em uma lista de filas',
      Agents: 'Escolher em uma lista de agentes',
      DialNumber: 'Escolher por nome ou número',
      DialNumberOrEntryPoint: 'Escolher por nome/número/ponto de entrada',
      ChooseByNameOrNumber: 'Escolher por nome/número',
      Organization: 'Pesquisar por nome/função/departamento/telefone comercial',
      WebexOrganization: 'Pesquisar por nome ou e-mail',
      DialNumberSearch: 'Pesquisar por nome ou número'
    },
    type: 'Consultar',
    checkBoxLabel: 'Permite que participantes continuem interagindo.',
    cancel: 'Cancelar',
    closeModal: 'Fechar modal',
    failureError: 'Impossível conectar a solicitação de consulta. Tente novamente.',
    customerLeftMsg: 'Cliente desconectado. A consulta não é mais necessária.',
    ctqFailureMsg:
      'Não foi possível cancelar a chamada de consulta para a fila. Tente novamente.',
    cancelCtqInfo:
      'Procurando um agente disponível na fila selecionada. Aguarde ou cancele a solicitação de consulta.',
    cancelCtqAction: 'Cancelar consulta',
    entryPoint: 'Ponto de entrada'
  },
  conference: {
    title: 'Solicitação de conferência',
    heading: {
      chat: 'Selecione um agente específico para bate-papo de conferência'
    },
    queues: 'Fila',
    agents: 'Agente',
    dialNumber: 'Número de discagem',
    organization: 'Organização',
    placeholder: {
      Queues: 'Escolher em uma lista de filas',
      Agents: 'Escolher em uma lista de agentes',
      DialNumber: 'Escolher por nome ou número'
    },
    type: 'Conferência',
    cancel: 'Cancelar',
    closeModal: 'Fechar modal',
    failureError: 'Impossível iniciar a solicitação de conferência. Tente novamente.'
  },
  transferModal: {
    Agents: 'Não é possível recuperar a lista de agentes. Atualize a lista.',
    AgentsEmpty: 'Nenhum agente disponível',
    Queues: 'Não é possível recuperar a lista de filas. Atualize a lista.',
    QueuesEmpty: 'Nenhuma fila disponível',
    EPEmpty: 'Não há nenhum ponto de entrada disponível',
    DialNumber:
      'Não é possível recuperar a lista de números de discagem no catálogo de endereços. Atualize a lista.',
    EntryPoint:
      'Não é possível recuperar a lista de números de ponto de entrada. Atualize a lista.',
    Common: 'Não é possível recuperar a lista. Atualize a lista.',
    DialNumberEmpty: 'Nenhum número de discagem disponível',
    DialNumbInvalid:
      'Número de discagem inválido. Entre em contato com o administrador.',
    DialNumbOrEntryPointInvalid:
      'Número de discagem/ponto de entrada inválido. Entre em contato com o administrador.',
    refreshQueueList: 'Atualizar a lista de filas',
    refreshAgentList: 'Atualizar a lista de agentes',
    refreshEpList: 'Atualizar os pontos de entrada',
    refreshAddressBook: 'Atualizar o catálogo de endereços',
    refreshTheList: 'Atualizar a lista',
    entryPointSectionLabel: 'Ponto de entrada',
    addressBookSectionLabel: 'Catálogo de endereços',
    organization: 'Organização',
    comboBoxAriaLabelAgent: 'Escolher em uma lista de agentes',
    comboBoxAriaLabelQueue: 'Escolher em uma lista de filas',
    comboBoxAriaLabelEp: 'Escolher a partir de uma lista de pontos de entrada',
    infScrollAgent: 'Pesquisar agentes',
    infScrollQueue: 'Pesquisar filas',
    infScrollEP: 'Pesquisar pontos de entrada',
    allRadioButtonHidedTextForConsult: 'Você não tem entidades atribuídas para consultar esta interação. Entre em contato com o administrador.',
    allRadioButtonHidedTextForTransfer: 'Você não tem entidades atribuídas para transferir esta interação. Entre em contato com o administrador.',
    allRadioButtonHidedTextForConference: 'Você não tem entidades atribuídas para conferência desta interação. Entre em contato com o administrador.',
    searchMinCharError: 'Insira no mínimo três caracteres para procurar.',
  },
  wrapup: {
    cancelautowrapup: 'Cancelar conclusão automática',
    wrapupreason: 'Motivos de conclusão',
    untilautowrapup: 'até a conclusão automática',
    followupsetting: 'Configuração de acompanhamento',
    lastagentroute: 'Último roteamento do agente',
    submitwrapup: 'Enviar conclusão',
    wrapupsearch: 'Pesquisar motivo de conclusão',
    invalidationError: 'Falha ao enviar conclusão',
    searchResult: 'Resultados de pesquisa disponíveis',
    noResultFound: 'Nenhum resultado de pesquisa encontrado',
    listContainerLabel: 'Contêiner da lista de pós-atendimento',
    searchError: 'Insira, no mínimo, três caracteres para procurar motivos de finalização.',
  },

  outdial: {
    call: 'Chamada',
    dialpadSearch: 'Digite o número para discar',
    addressSearch: 'Pesquisar por nome/número',
    addressTab: 'Endereço',
    addressTabTooltip: 'Lista de endereços de pesquisa',
    dialpadTab: 'Teclado de discagem',
    dialpadTooltip: 'Discar um número',
    searchTab: 'Buscar',
    searchTabTooltip:'Procurar pessoas em minha organização',
    noAdrFound: 'Nenhuma equivalência encontrada',
    noContacts: 'Nenhum contato',
    mainIconTooltip: 'Chamada de saída',
    errorOutdialFailed:
      'A chamada de saída falhou. O Desktop não conseguiu conectar a chamada ou a chamada não foi atendida.',
    errorOutdialDisabled: 'As chamadas de saída estão desativadas',
    errorDialPadValidationMessage: 'Formato incorreto',
    outdialReqInProgress: 'A chamada de saída está em andamento',
    outdialAniPlaceholder: 'Selecionar ANI de discagem externa',
    outdialAniLabel: 'ANI de saída',
    outdialAniPlaceHolder: 'Procurar ANI de saída',
    errorDcCallsLimitExceeded:
      'O data center atingiu o limite máximo de chamadas de discagem externa. Não é possível efetuar mais chamadas de discagem externa',
    errorOrgCallsLimitExceeded:
      'A organização atingiu o limite máximo de chamadas de discagem externa. Não é possível efetuar mais nenhuma chamada de discagem externa.',
    errorOutDialNoAnswerFromCustomer:
      'O cliente não atendeu a sua chamada. Tente ligar mais tarde.',
    errorOutDialCustomerUnavailable:
      'O cliente não está disponível agora. Tente ligar mais tarde.',
    errorOutDialAgentEnds: 'Você encerrou a sua chamada com o cliente.',
    errorOutDialCustomerBusy: 'O cliente está ocupado agora. Tente ligar mais tarde.',
    searchError: 'Insira no mínimo três caracteres para procurar os contatos.',
    upArrowLabel: 'Expandir',
    clear: 'Limpar entrada',
    outdialDialogDescription: 'Você está atualmente em diálogo com as abas.'
  },

  organization: {
    noMatchFound: 'Nenhuma equivalência encontrada',
    searchError: 'Insira no mínimo três caracteres para procurar os contatos.',
    authError: 'Nenhum contato para exibir. A autenticação da Microsoft falhou.'
  },

  interactionPopover: {
    of: 'de',
    accept: 'Aceitar',
    acceptAriaLabel: 'Aceitar tarefa {taskNumber} - {taskType} de {from}',
    requests: 'Solicitação(ões)',
    back: 'voltar',
    next: 'próxima',
    acceptMultipleRequest: 'Aceitar {requestCount} solicitações',
    paginationDetail: '{indexStart}-{indexEnd} de {totalPopoverpoolLength}',
    hidePopoverDetails: 'Ocultar detalhes do popover',
    showPopoverDetails: 'Exibir detalhes do popover',
    customerName: 'Nome do cliente',
    email: 'E-mail',
    queueName: 'Nome da fila',
    failedToAccept: 'Falha ao aceitar.',
    unableToAccept: 'Impossível aceitar o contato.',
    failedToEnd: 'Falha ao terminar.',
    unableToEnd: 'Impossível fechar o contato. ',
    ringing: 'Tocando',
    calling: 'Chamando',
    phoneNumber: 'Número de telefone',
    dni: 'DNIS',
    ivrPathId: 'ID do caminho IVR',
    pathId: 'ID do caminho',
    rona: 'RONA',
    sourcePage: 'Página de origem',
    sourceNumber: 'Número da origem',
    appUserId: 'ID de usuário de aplicativo',
    acceptAll: 'Aceitar todas as tarefas',
    agentDn: 'DN do agente',
    agentName: 'Nome do Agente',
    agentTeam: 'Equipe de Agentes',
    requestDetails: 'Detalhes da solicitação',
    incomingCallFrom: 'Chamada recebida de',
    unableToAnswer: 'Impossível atender à chamada. Tente novamente.',
    unableToDecline: 'Impossível recusar a chamada. Tente novamente.'
  },

  multiLogin: {
    header: 'Alerta de login múltiplo',
    message:
      'Você está conectado ao Desktop em várias instâncias de aplicativo. Clique em Continuar para continuar com o Desktop nessa instância de aplicativo. Caso contrário, feche esta janela.',
    continue: 'Continuar'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Falha ao transferir para ponto de entrada/fila devido a um erro de configuração.',
    1010: "Não é possível consultar porque não foi possível alocar o agente a tempo. ",
    1042: "O contato não foi encontrado",
    1043: 'O destino é inválido.',
    1045: 'A interação não é atribuída ao agente.',
    1046: 'Falha na consulta do agente porque nenhum canal de agente correspondente foi encontrado no sistema.',
    1038: "O agente não foi encontrado",
    1037: 'Falha ao iniciar sessão devido a um erro interno.',

    // Media Events
    138: 'Falha na ação por motivos desconhecidos.',
    136: 'O usuário não foi encontrado',

    // AgentConsultFailed
    1050: 'Não é possível consultar devido a configuração ou atividade sem suporte no fluxo. ',
    1005: "Não é possível consultar porque o agente não atendeu a solicitação a tempo.",
    1051: 'Não é possível consultar ou transferir devido a um ponto de entrada ou número de discagem inválido.',

    // AgentInviteFailed
    1053: 'Não é possível apresentar a interação devido a uma tarefa de recolocação do fluxo de trabalho pendente.',
    1054: 'Não é possível efetuar a chamada de discagem externa devido a problemas de mídia com esta solicitação. ',

    // AgentContactAssignFailed
    1011: 'Não é possível atender ou aceitar a chamada devido à falta de agentes na interação contínua. ',

    // ContactCallbackFailed
    1034: 'Falha ao chamar novamente o contato porque ContactParkTimeout foi recebido para a solicitação.',

    // ContactUpdateFailed
    1020: "Não é possível atualizar as variáveis porque um dos valores excede o limite de 256 caracteres. Reduza os caracteres e tente novamente.",

    // AgentInviteFailed
    1031: 'O agente convidou o cliente após o retorno de chamada ter sido solicitado.',

    // AgentBlindTransferFailedEvent
    1044: 'Falha de transferência cega do agente porque o agente de destino foi atribuído a outra interação.',

    // AgentCtqCancelFailed
    1047: "O contato não foi encontrado.",

    // AgentCtqFailed
    1048: "O grupo de distribuição de chamadas não está configurado.",
    1049: 'O tempo máximo de espera na fila foi excedido.',
    // StationLoginFailed
    127: 'Falha no registro DN do agente com exceção de login duplicado.'
  },

  stateSelector: {
    Available: 'Disponível',
    errorstatechange: 'Falha de alteração de estado. Tente novamente.',
    errorStateChangeInPendingLogout: 'Falha ao alterar o estado do agente devido ao logoff pendente.',
    label: 'Estado de disponibilidade',
    agentStateSelector: 'Seletor de estado do agente',
    Engaged: 'Envolvido',
    engagedAvailableInfo:
      'Você está atualmente envolvido em uma interação e no estado Disponível.',
    engagedIdleInfo:
      'Você está atualmente envolvido em uma interação e no estado Ocioso',
    engagedInfo: 'Você está atualmente envolvido em uma interação.',
    engagedSupervisorStateChange: 'alterou seu estado para',
    axAgentStateChanged: 'Seu estado foi alterado para',
    axAgentSync: 'devido à sincronização de estado com sua ferramenta de colaboração.',
    engagedPresenceInfo:
      'Você está atualmente envolvido em uma interação e no estado',
    engagedPresenceSync: 'devido à sincronização de estado com sua ferramenta de colaboração.',
    clear: 'Limpar entrada',
    searchState: 'entrada',
    agentStatusLabel: 'Status do agente',
    agentStateLabel: 'O agente está no estado {selectedState} pelos últimos {selectedTimeValue}',
    agentStateLabelOnStateChange: 'O agente está no estado {selectedState} pelos últimos 0 s',
    agentStateChangeSuccessful:'Mudança de estado para {selectedState} bem-sucedida.',
    agentStateChangeFail:'Falha ao alterar estado para {selectedState}.',
    searchError: 'Insira, no mínimo, três caracteres para procurar estados.'
  },

  warningMessage: {
    header: 'Alterações não salvas',
    message:
      'Você tem alterações não salvas nesta página. Tem certeza de que deseja sair desta página? ',
    cancelButton: 'Ficar',
    saveButton: 'Sair'
  },

  notificationLables: {
    muteVolume: 'Desativar o som da notificação',
    unmuteVolume: 'Ativar o som da notificação',
    notificationVolume: 'Volume de notificação',
    playSound: 'Reproduzir som de notificação',
    enableSoundNotificationSettings: 'Ativar notificação de som',
    enableSoundNotificationSettingsDescription:
      'Entrega notificações de som para solicitações recebidas. Você pode ajustar o volume abaixo.',
    volumeTitle: 'Volume do som'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Chamada',
    chat: 'Bate-papo',
    email: 'E-mail',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Mensagens comerciais do Google"
  },
  orgDetailsLabels: {
    role: 'Função',
    department: 'Departamento',
    email: 'E-mail',
    businessPhone: 'Telefone comercial',
    workPhone: 'Trabalho',
  },
  addressListError: {
    title: 'Falha ao carregar dados',
    errorId: 'ID do erro:'
  },
  keypad: {
    keyPadSearch: 'Insira o número',
    dialPad: 'Teclado de discagem'
  },
  collabTool: {
    userAuthenticated: 'Autenticação do usuário:',
    successful: 'Operação bem-sucedida',
    failed: 'Falhou.',
    tryAgain: 'Tentar novamente',
    stateSync: 'Sincronização de estado:',
    mercuryFailedInfo: ' Entrar em contato com seu administrador.',
    retrying: 'Repetindo...',
    trackingIdLabel: 'ID de rastreamento: '
  },
  webex: {
    webex: 'Webex',
    info: 'A integração permite sincronizar estados entre Desktop e Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Com essa integração, você pode consultar ou transferir chamadas para os usuários do Microsoft Teams.',
    authenticationFailedInfo:
      'Se uma janela de autenticação já estiver aberta, repita nela o processo de autenticação.',
    ListItemContactDetails:
      'O nome do contato é: {name}, sua presença é: {presence}, o departamento é: {department}, o cargo é: {jobTitle} e o número de telefone é: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Notificação de serviço de emergência',
    readNotification: 'Eu li a notificação.'
  },
  webexPresenceStatus: {
    active: 'Ativo',
    lastActiveFewMinutesAgo: 'Ativo nos últimos minutos',
    lastActiveMinutesAgo: 'Ativo {min} minutos atrás',
    lastActive1HourAgo: 'Última atividade 1 hora atrás',
    lastActiveHoursAgo: 'Ativo {hour} horas atrás',
    lastActiveYesterday: 'Ativo ontem',
    lastActiveOnDate: 'Ativo em {date}',
    busy: 'Ocupado',
    busyUntil: 'Ocupado até {date}',
    dnd: 'Não perturb.',
    dndUntil: 'Não interromper até {date}',
    quiet: 'Silenciar',
    quietUntil: 'Silenciar até {date}',
    ooo: 'Ausência temporária',
    outOfOfficeUntil: 'Ausência temporária até {date}',
    call: 'Em uma chamada',
    meeting: 'Em reunião',
    calendarItem: 'Em reunião do calendário',
    presenting: 'Apresentando',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Pesquisar por nome ou detalhes do perfil',
    webexPlaceholder: 'Pesquisar por nome ou e-mail',
    refreshTheList: 'Atualizar a lista',
    refreshAddressBook: 'Atualizar o catálogo de endereços',
    microsoftAuthError: 'Nenhum contato para exibir. A autenticação da Microsoft falhou.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/ro.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/ro.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Eşec la încărcarea datelor',
    errorID: 'ID eroare',
    tryAgain: 'Încercaţi din nou',
    Error: 'Eroare',
    okButton: 'OK',
    Yes: 'Da',
    Cancel: 'Anulare',
    Confirm: 'Confirmare',
    Continue: 'Continuare',
    Canceling: 'Se anulează',
    CiscoAiAssistant: 'Asistent AI Cisco',
    Answer: 'Răspuns',
    AnswerAriaLabel: 'Răspundeți la activitatea desktop',
    Decline: 'Refuz',
    ErrorSecurityCompliance: 'Conformitate securitate',
    errorDetails: 'Detalii eroare',
    learnMore: 'Aflaţi mai multe',
    showLess: 'Afișare mai puține',
    trackingIdDescription:
      'Partajaţi ID-ul de urmărire cu administratorul site-ului sau cu echipa de suport pentru investigarea situaţiei.',
    trackingIdInputLabel: 'ID urmărire: ',
    submitForm: 'Remitere formular',
    unnamedStatus: 'Stare fără nume',
    errorChatMsg: 'Eşec la încărcarea datelor chatului',
    noOptions: 'Nicio opțiune',
    noResults: 'Niciun rezultat',
    more: 'Mai multe',
    nomatchfound: 'Nu a fost găsită nicio corespondenţă',
    collaborationTool: 'Instrument de colaborare',
    timerAriaLabel: 'Timp petrecut',
    historyItemTime: 'S-a întâmplat la',
    loading: 'Se încarcă',
    months: [
      'Ianuarie',
      'Februarie',
      'Martie',
      'Aprilie',
      'Mai',
      'Iunie',
      'Iulie',
      'August',
      'Septembrie',
      'Octombrie',
      'Noiembrie',
      'Decembrie'
    ],
    loadingMsg: 'Se încarcă...',
    search: 'Căutare',
    historyChannelLabels: {
      All: 'Toţi',
      telephony: 'Voce',
      chat: 'Chat',
      email: 'E-mail',
      social: 'Social media'
    },
    homePageLabel: 'Pagina de pornire',
    resizeHistoryDragger: 'Redimensionare glisor istoric',
    agentHistoryLabel: 'istoric agent',
    clear: 'Eliminare intrare',
    ariaLabelAgentHistoryWrapper:
      'Istoricul interacțiunilor cu agenții afișează comunicările recente cu clienții pe diferite canale din ultimele 24 de ore',
    sliderResizerInstructions:
      'În prezent vă aflați pe un glisor. Pentru a redimensiona, utilizați tastele săgeată',
    resizeHistoryPanel: 'Redimensionare panou istoric, glisor,',
    time: {
      hours: 'oră',
      minutes: 'min.',
      seconds: 'sec.'
    }
  },
  email: {
    ToLabel: 'Către',
    FromLabel: 'De la',
    CcLabel: 'CC',
    BccLabel: 'BCC',
    SubjectLabel: 'Subiect',
    HideLabel: 'Ascund.',
    SendLabel: 'Trimitere',
    ShowPrevThread: 'Afişare fir anterior',
    HidePrevThread: 'Ascundere fir anterior',
    ReplyLabel: 'Răspuns',
    ReplyAllLabel: 'Răspuns tuturor',
    ViewOriginalMail: 'Vizualizare e-mail original',
    QuickReplyInp: 'Răspuns rapid aici...',
    AttachFiles: 'Ataşare fişiere',
    ToolbarHeading: 'Titlu1',
    ToolbarBold: 'Aldin',
    ToolbarItalic: 'Cursiv',
    ToolbarUnderLine: 'Subliniere',
    ToolbarBlockQuote: 'Citat',
    ToolbarCode: 'Bloc de cod',
    ToolbarListOrder: 'Ordonare listă',
    ToolbarListBullet: 'Marcator listă',
    ToolbarLink: 'Link',
    ToolbarStrike: 'Tăiere text cu o linie',
    ToolbarColor: 'Culoare text',
    ToolbarTable: 'Tabel',
    insertTable: 'Inserare tabel',
    insertRowAbove: 'Inserare rând deasupra',
    insertRowBelow: 'Inserare rând dedesubt',
    insertColumnLeft: 'Inserare coloană la stânga',
    insertColumnRight: 'Inserare coloană la dreapta',
    deleteRow: 'Ştergere rând',
    deleteColumn: 'Ştergere coloană',
    deleteTable: 'Ştergere tabel',
    link: 'Link',
    IndentRight: 'Indentare la dreapta',
    IndentLeft: 'Indentare la stânga',
    showMoreAttachment: 'Afişare mai multe ataşamente',
    AttachmentLimit: 'Ataşare maximum ',
    attachments: ' ataşamente, ',
    sizeLimit: ' MB maximum',
    attachment: 'Ataşament',
    errordeleteattachment: 'Eşec la ştergerea fişierelor. Încercaţi din nou.',
    errordownloadattachment: 'Eşec la descărcarea fişierelor. Încercaţi din nou.',
    erroraddattachemnt: 'Eşec la încărcarea fişierelor. Încercaţi din nou.',
    errorendcontact: 'Eşec la finalizarea interacțiunii. Încercaţi din nou.',
    erroraddlimitreached:
      'Fişierul nu a putut fi ataşat, deoarece depăşeşte valoarea maximă ',
    errorattachmentdrop:
      'Ataşamentele au fost eliminate conform politicii de securitate a companiei.',
    errorfiletype: 'Tipul de fişier nu este acceptat. Încercaţi din nu.',
    errorcreditcard:
      'Nu se pot încărca ataşamente, conform politicii de securitate a companiei.',
    errorcontainsimage:
      'Nu se pot încărca ataşamente. Imaginile din atașamente nu sunt acceptate conform politicii de securitate a companiei.',
    errorlimit: ' MB limită.',
    errorsendemail: 'Nu se poate trimite e-mailul. Încercaţi din nou.',
    errorpcicheckemail: 'Nu se pot regăsi datele PCI. Încercaţi din nou.',
    errortext: 'Eşec la încărcarea datelor',
    tryAgain: 'Încercaţi din nou',
    replywarning:
      'Nu partajaţi informaţii financiare, de sănătate sau care vă pot identifica personal (PII) în acest mesaj sau în ataşamente.',
    datamasked:
      'Subiectul sau corpul e-mailului este mascat, conform politicii de securitate a companiei. Sigur trimiteţi e-mailul?',
    pcibannerwarning:
      'Subiectul sau corpul e-mailului este mascat, conform politicii de securitate a companiei.',
    on: 'Activat',
    wrote: 'a scris'
  },
  interaction_control: {
    windowOpened: 'Fereastră deschisă',
    connected: 'Conectați',
    consultRequested: 'Consultare solicitată',
    consulting: 'Consultare',
    consultCallOnHold: 'Consultare în aşteptare',
    callOnHold: 'Apel în aşteptare',
    consult: 'Consultare',
    endconsult: 'Finalizare consultare',
    hold: 'În aşteptare',
    transfer: 'Transfer',
    conference: 'Conferinţă',
    endconference: 'Finalizare conferinţă',
    conferenceRequested: 'Conferinţă solicitată',
    switchCall: 'Comutare',
    mergeCall: 'Îmbinare',
    wrapup: 'Concluzionare',
    end: 'Încheiere',
    customername: 'Nume client',
    dn: 'DNIS',
    ivrpath: 'Cale IVR',
    email: 'E-mail client',
    ani: 'Număr de telefon',
    queueid: 'Nume coadă',
    ronatimeout: 'Durată fără răspuns',
    pathid: 'ID cale IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'DN agent',
    destagentname: 'Nume agent',
    virtualteamname: 'Coadă',
    category: 'Categorie',
    additionaldetails: 'Detalii suplimentare',
    sourcenumber: 'Număr sursă',
    sourcepage: 'Pagină sursă',
    appuser: 'ID utilizator aplicaţie',
    customernumber: 'Număr de telefon',
    exitconference: 'Ieşire din conferinţă',
    resume: 'Reluare',
    pauserecording: 'Pauză înregistrare',
    resumerecording: 'Reluare înregistrare',
    exitconsult: 'Ieşire din consultare',
    pauseRecordingFailed: 'Înregistrarea nu a putut fi întreruptă. Vă rugăm să încercaţi din nou.',
    resumeRecordingFailed: 'Înregistrarea nu a putut fi reluată. Vă rugăm să încercaţi din nou.',
    holdCallFailed: 'Apelul nu a putut fi pus în aşteptare. Vă rugăm să încercaţi din nou.',
    resumeCallFailed: 'Apelul nu a putut fi reluat. Vă rugăm să încercaţi din nou.',
    endCallFailed: 'Eşec la finalizarea interacțiunii. Încercaţi din nou.',
    consultTransferFailed:
      'Apelul de consultare nu a putut fi transferat. Încercaţi din nou.',
    conferenceTransferFailed:
      'Nu se poate transfera apelul de conferință. Încercaţi din nou.',
    conferenceFailed:
      'Solicitarea de conferinţă nu a putut fi conectată. Încercaţi din nou.',
    consultEndFailed: 'Solicitarea de consultare nu a putut fi încheiată. Încercaţi din nou.',
    conferenceExitFailed:
      'Solicitarea de conferință nu a putut fi părăsită. Încercați din nou.',
    conferenceEndFailed:
      'Solicitarea de conferinţă nu a putut fi încheiată. Încercaţi din nou.',
    cancelCtqFailed:
      'Nu se poate anula apelul de consultare pentru coadă. Încercați din nou.',
    privacyShield: 'Protecție de confidențialitate',
    errorOnPrvacyShieldForConsult:
      'Înregistrarea este momentan în pauză. Reluați înregistrarea pentru a începe un apel de consultare.',
    errorOnPrvacyShieldForTransfer:
      'Înregistrarea este momentan în pauză. Reluați înregistrarea pentru a începe un apel de transfer.',
    cancelConsult: 'Anulare consultare',
    cancelTransfer: 'Anulare transfer',
    copy: 'Copiere',
    copied: 'Copiat',
    cadrequestuccess: 'Informațiile clientului au fost salvate cu succes.',
    cadrequestfailure: 'Eșec la salvarea informațiilor clientului. Încercați mai târziu.',
    cadupdatedmessage: 'Informațiile clientului au fost actualizate recent de',
    unsavedmessage: 'Modificările dvs. nesalvate sunt suprascrise.',
    save: 'Salvare',
    revert: 'Revenire',
    expandDetails: 'Extindere detalii',
    collapseDetails: 'Restrângere detalii',
    cadValidationError:
      'Format nevalid. Utilizați standardul internațional pentru dată și oră.',
    secureCadSaveError:
      'Informațiile despre clienți nu sunt salvate. Faceți clic pe Salvare pentru a încerca din nou.',
    secureDecryptionError: 'Variabilele securizate nu se pot afișa.',
    clickToTry: 'Faceți clic pentru a reîncerca',
    isSecureVariable: 'este o variabilă securizată',
    contactorigin: 'Origine contact',
    resumeMonitoring: 'Reluare monitorizare',
    pauseMonitoring: 'Pauză monitorizare',
    whisperCoach: 'Sufleor',
    bargeIn: 'S-a intervenit în apel',
    endMonitoring: 'Finalizare monitorizare',
    contactphonenumber: 'Număr de telefon de contact',
    contactqueue: 'Coadă de contacte',
    activeparticipants: 'Participanţi activi',
    consultedparticipant: 'Participant consultat',
    contactstatus: 'Stare contact',
    timeincontactstatus: 'Durată în starea contactului',
    totalcontactduration: 'Durată totală contact',
    agentinteractiontime: 'Durata interacțiunii',
    recording: 'Înregistrare',
    monitoring: 'Monitorizare',
    monitoringPaused: 'Monitorizare în pauză',
    pauseMonitoringFailed: 'Nu s-a putut întrerupe monitorizarea. Încercaţi din nou.',
    resumeMonitoringFailed: 'Nu s-a putut relua monitorizarea. Încercaţi din nou.',
    callCancelledInProgress: 'Anulare apel în curs',
    bargedIn: 'S-a intervenit în apel',
    keypad: 'Tastatură',
    mute: 'Dezactivare sunet',
    unmute: 'Activare sunet',
    bargeInTooltipText:
      'Microfonul se va activa și veți putea intra în această interacțiune cu clientul',
    bargeInCompactTooltipText:
      'S-a intervenit în apel. Microfonul se va activa și veți putea intra în această interacțiune cu clientul',
    bargeInTooltipDisabled: 'Reluați monitorizarea pentru a activa intervenția în apel',
    bargeInFailedTitle: 'S-a intervenit în apel a eșuat',
    bargeInFailedData:
      'A survenit o eroare la încercarea de intervenție în apel. Încercați din nou după un timp.',
    supervisorBargedIn: 'a intrat în apel.',
    leftInteraction: 'a părăsit interacțiunea.',
    conferenceEnded: 'Apelul de conferință s-a încheiat.',
    participants: 'Participanţi',
    badgeAriaLabel: '{participant} este în apel',
    bargeInConferenceAriaLabel: 'Există doi participanți la interacțiune',
    taskName: 'Nume sarcină control interacțiune',
    interactionDurationLabel: 'Durată de timp',
    wrapupassist: 'Asistență la concluzionare',
    consultingTaskContext: 'Apel de consultanță de la',
    consultExited: 'S-a ieșit din apelul de consultare',
    endCall: 'Finalizați apelul.',
    exitconferenceCall:
      'Ieșiți din apel și conferința va continua cu participanții activi.',
    recordingInProgess: 'Înregistrare în curs',
    recordingPaused: 'Înregistrarea a fost întreruptă',
    searchPlaceholder: 'Căutare contacte',
    postCall: "Apel ulterior",
    switchCallTooltip: "Comutați la apel",
    switchConsultTooltip: "Comutați la apelul de consultare",
    switchConferenceTooltip: "Comutați la apelul de conferință",
    confirmationDialog: {
      endCallTitle: 'Finalizați apelul?',
      endCallMessage: 'Faceți clic pe Confirmare pentru a finaliza apelul pentru toți participanții.',
      exitConferenceTitle: 'Ieșiți din apelul de conferință?',
      exitConferenceMessage:
        'Faceți clic pe Confirmare pentru a ieși din apelul de conferință și a permite celorlalți participanți să continue.',
      confirmButtonLabel: "Confirmare",
      cancelButtonLabel: "Anulare",  
    },
    postCallOnHold: "Apel ulterior în aşteptare",
    postCallConsult: "Consultare apel ulterior",
    postCallConsultOnHold: "Consultare în aşteptare apel ulterior",
  },
  agentProfile: {
    teamName: 'Echipă',
    dialNumber: 'Număr de format',
    phoneNumber: 'Număr de telefon',
    settings: 'Modificare setări',
    signOut: 'Deconectare',
    webRTCDisconnected: 'Avertizare Telefonie Desktop deconectată ',
    msAuthFailed: 'Autentificarea Microsoft a eșuat',
    stateSyncFailed: 'Sincronizarea stării a eșuat',
    userProfileLabel: 'Profil utilizator',
    ariaAgentprofile: 'Profil agent',
    ChannelCapacity: 'Capacitatea canalului',
    voice: 'Voce',
    chat: 'Chat',
    email: 'E-mail',
    social: 'Social media',
    channelCapacityTooltip: 'Faceţi clic pentru a vedea mai multe',
    blendedRouting: 'Mixt',
    exclusiveRouting: 'Dirijare exclusivă',
    realtimeRouting: 'Dirijare mixtă în timp real',
    blendedRoutingTooltip: 'Tratați mai multe contacte pe toate canalele.',
    exclusiveRoutingTooltip: 'Administraţi contactele pe rând.',
    realtimeRoutingTooltip: 'Tratați un canal obligatoriu în timp real.',
    errorActiveContacts:
      'Nu vă puteţi deconecta acum, deoarece aveţi conversaţii active. Finalizaţi-le şi încercaţi din nou.',
    searchTeams: 'Căutare echipe',
    changeTeamsConfirmHeader: 'Confirmare modificare echipă',
    changeTeamsConfirmMessage: 'Sigur doriți să vă modificați echipa?',
    changeTeamLabel: 'Modificare echipă',
    errorChangeTeams:
      'Nu vă puteţi modifica echipa acum, deoarece aveţi solicitări active. Finalizaţi-le şi încercaţi din nou.',
    saveTeamSelection: 'Salvare selecție echipă',
    userSettings: 'Setări utilizator',
    resetLayout: 'Resetare întregul aspect Desktop',
    resetConfirmHeader: 'Confirmare de resetare aspect',
    resetConfirmMessage:
      'Sigur resetați întregul aspect Desktop? <br/> Aplicația Desktop va reveni la aspectul prestabilit.',
    downloadLogs: 'Descărcare raport de erori',
    help: 'Ajutor',
    signoutConfirm: 'Sigur vă deconectați?',
    signoutConfirmHeader: 'Confirmare deconectare',
    darkTheme: 'Comutare la modul Întunecat',
    newLook: 'Comutare la aspect nou',
    keyboardShortcuts: 'Scurtături din taste',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Setări notificări',
    silentNotification: 'Notificare silențioasă',
    enableNotificationSettings: 'Activare notificări',
    enableSilentNotificationSettings: 'Activare notificări silențioase',
    suppressWebexCallingNotificationSettings: 'Ascundere notificări Webex Calling',
    notificationSettingDescription:
      'Livrează notificări precum mesaje noi, alerte și modificări de stări.',
    silentNotificationDescription:
      'Dezactivează alertele pe ecran. Puteți vizualiza notificările în Centrul de notificări.',
    suppressWebexCallingNotificationDescription: 
    'Nu afișați notificări pop-up pentru apelurile Webex primite și răspundeți la acestea prin Webex Contact Center.',
    arrowLabel: 'Revenire',
    managedTeams: 'Echipe administrate',
    managedTeamsError: 'Eșec la încărcarea echipelor.',
    viewAll: 'Vizualizează tot',
    profileSettings: 'Setări profil',
    userRole: 'Rol',
    saveSelection: 'Salvare selecție',
    extension: 'Extensie',
    changeProfileConfirmHeader: 'Confirmați modificările setărilor de profil',
    changeProfileConfirmMessage:
      'Sigur doriți să salvați modificările de profil?',
    confirm: 'Confirmare',
    errorProfileUpdate:
      'Nu puteți modifica setările de profil acum, deoarece aveți solicitări active. Finalizați-le și încercați din nou.',
    roleAgentSupervisor: 'Supervizor și agent',
    roleSupervisor: 'Supervizor',
    noTeam: 'Nicio echipă',
    testYourNetwork: 'Testați-vă rețeaua',
    speakerAndMic: 'Difuzor și microfon',
    speaker: 'Difuzor',
    mic: 'Microfon',
    speakerDescription:
      'Selectați și testați dispozitivul de ieșire pentru a vă asigura că auziți apelantul.',
    micDescription:
      'Selectați și testați dispozitivul de intrare pentru a vă asigura că apelantul vă aude.',
    micError:
      'Accesul la microfon este interzis. Permiteți accesul prin intermediul setărilor browserului sau contactați administratorul.',
    speakerError:
      'Difuzorul nu este disponibil momentan, deoarece accesul la microfon este refuzat.',
    telephony: 'Telefonie',
    desktop: 'Desktop',
    onSpeakerPlay:
      'Dacă nu puteți auzi sunetul de test, verificați difuzorul.',
    onMicPlay:
      'Dacă nu puteți auzi sunetul de test, verificați atât difuzorul, cât și microfonul.',
    onMicRecord: 'Înregistrați un mesaj pentru redare.',
    test: 'Test',
    recording: 'Înregistrare',
    playing: 'Se redă',
    reconnecting: 'Se reconectează',
    disconnectMessage:
      'Telefonia desktop a fost deconectată. Încercați altă opțiune de telefonie.',
    singleTelephonyDisconnectMessage:
      'Telefonia desktop a fost deconectată. Contactați administratorul.',
    clear: 'Eliminare intrare',
    rememberMeCheckBoxMessage: "Nu doresc să se afișeze din nou",
    saveLabel: 'Salvare',
    browserUnsupportedError: "Conectarea nu a reușit, deoarece utilizați un browser neacceptat.",
    microphoneAccessDeniedError: "Accesul la microfon este interzis. Permiteți accesul prin intermediul setărilor browserului sau contactați administratorul.",
  },
  contactHistory: {
    mainHeader: 'Istoric contacte',
    handledBy: 'Tratată de',
    noRecordFound: 'Nu a fost găsit niciun istoric de contacte!',
    tryAgain: 'Încercaţi din nou',
    errorMsg: 'Nu se poate regăsi istoricul contactelor. Încercați din nou.',
    errorID: 'ID eroare',
    missingAni: 'Lipseşte ANI',
    timeIcon: 'Durată',
    taskHandled: 'Sarcină gestionată',
    noHistoryNew: 'Nu există istoric',
    noHistory: 'Nu există istoric',
    viewTranscript: 'Vizualizare mesaj e-mail',
    transcriptFor: 'Transcrieri pentru',
    editBeforeCall: 'Editare înainte de apelare',
    clickToCall: 'Faceţi clic pentru a apela',
    onAnActiveCallErrorMessage:
      'Nu puteți iniția un apel nou, deoarece sunteți deja într-un apel activ.',
    receivedFrom: 'Contact primit de la',
    initiatedTo: 'Contact inițiat către',
    wrapUpReason: 'Motiv concluzionare',
    startCallTelephony:
      'Dați clic pe linkul numărului de telefon pentru a iniția un apel de ieșire.',
    contactHistoryList: 'Listă istoric contacte,',
    wrapUpCode: 'Cod concluzionare',
    agentName: 'Nume agent',
    entryPointName: 'Punct de intrare',
    acceptedTimeAndDate: 'Oră și dată acceptare',
    duration: 'Durată',
    emailTranscript: 'Transcriere chat pe e-mail',
    clickToViewEmailTranscript: 'Faceți clic pentru a vizualiza transcrierea e-mailului',
    listContainer: 'Container listă'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Punct de intrare',
    date: 'Data',
    subject: 'Subiect',
    from: 'De la',
    sent: 'Trimis',
    to: 'Către',
    back: 'Înapoi',
    errorTranscript: 'A survenit o eroare la preluarea transcrierilor',
    customer: 'Client',
    inboundErrorMessage: 'Eşec la încărcarea e-mailului clientului',
    outboundErrorMessage: 'Eşec la încărcarea răspunsului agentului'
  },
  popoverTitle: {
    callback: 'Reapelare',
    outboundCall: 'Apel de ieșire',
    incomingCall: 'Apel de alertare',
    progressiveCampaign: 'Apel campanie',
    courtesyCallback: 'Reapelare de curtoazie',
    chat: 'Chat de intrare',
    incoming: 'De intrare',
    monitoringCall: 'Apel de monitorizare'
  },
  connecting: 'Se conectează',
  initiating: 'Inițierea',
  outbound: 'De ieșire',
  transfer: {
    title: 'Solicitare de transfer',
    heading: {
      chat: 'Selectați agentul sau coada către care doriți să transferați.',
      email: 'Selectați coada către care doriți să transferați.',
      telephony:
        'Selectați agentul, coada sau numărul de apelare către care doriți să transferați.',
      noQueueTelephony:
        'Selectați agentul sau numărul de apelare către care doriți să transferați.'
    },
    header: {
      chat: 'Selectaţi agentul sau coada pentru transferarea acestui contact.',
      email: 'Selectaţi coada pentru transferarea acestui contact.',
      telephony:
        'Selectați agentul, coada, numărul de format sau organizația pentru transferarea acestui contact.',
      noQueueTelephony:
        'Selectați agentul, numărul de format sau organizația pentru transferarea acestui contact.',
      noOrganizationTelephony:
        'Selectați agentul, coada sau numărul de format pentru transferarea acestui contact.',
      noQueueOrganizationTelephony:
        'Selectați agentul sau numărul de format pentru transferarea acestui contact.'
    },
    queues: 'Coadă',
    agents: 'Agent',
    dialNumber: 'Număr de format',
    organization: 'Organizaţie',
    placeholder: {
      Queues: 'Selectaţi dintr-o listă de cozi',
      Agents: 'Selectaţi dintr-o listă de agenţi',
      DialNumber: 'Alegere după nume sau număr',
      DialNumberOrEntryPoint: 'Selectare după nume/număr/punct de intrare',
      ChooseByNameOrNumber: 'Selectați după nume/număr',
      Organization: 'Căutați după nume/rol/departament/telefon de serviciu',
      WebexOrganization: 'Căutare după nume/e-mail',
      DialNumberSearch: 'Căutare după nume/număr'
    },
    type: 'Transfer',
    cancel: 'Anulare',
    closeModal: 'Închidere fereastră modală',
    failureError: 'Nu se poate transfera solicitarea. Încercați din nou.',
    entryPoint: 'Punct de intrare'
  },
  consult: {
    title: 'Solicitare de consultare',
    heading: {
      chat: 'Selectați agentul sau coada către care doriți să transferați.',
      email: 'Selectați coada către care doriți să transferați.',
      telephony:
        'Selectați agentul, coada sau numărul de apelare cu care doriți să vă consultați.',
      noQueueTelephony:
        'Selectați agentul sau numărul de apelare cu care doriți să vă consultați.'
    },
    header: {
      chat: 'Selectaţi agentul sau coada pentru transferarea acestui contact.',
      email: 'Selectaţi coada pentru transferarea acestui contact.',
      telephony:
        'Selectați agentul, coada, numărul de format sau organizația cu care doriți să vă consultați.',
      noQueueTelephony:
        'Selectați agentul, numărul de format sau organizația cu care doriți să vă consultați.',
      noOrganizationTelephony:
        'Selectați agentul, coada sau numărul de format cu care doriți să vă consultați.',
      noQueueOrganizationTelephony:
        'Selectați agentul sau numărul de format cu care doriți să vă consultați.'
    },
    queues: 'Coadă',
    agents: 'Agent',
    dialNumber: 'Număr de format',
    organization: 'Organizaţie',
    placeholder: {
      Queues: 'Selectaţi dintr-o listă de cozi',
      Agents: 'Selectaţi dintr-o listă de agenţi',
      DialNumber: 'Alegere după nume sau număr',
      DialNumberOrEntryPoint: 'Selectare după nume/număr/punct de intrare',
      ChooseByNameOrNumber: 'Selectați după nume/număr',
      Organization: 'Căutați după nume/rol/departament/telefon de serviciu',
      WebexOrganization: 'Căutare după nume/e-mail',
      DialNumberSearch: 'Căutare după nume/număr'
    },
    type: 'Consultare',
    checkBoxLabel: 'Permiteți participanților să continue să interacționeze.',
    cancel: 'Anulare',
    closeModal: 'Închidere fereastră modală',
    failureError: 'Solicitarea de consultare nu a putut fi conectată. Încercaţi din nou.',
    customerLeftMsg: 'Client deconectat. Consultarea nu mai este necesară.',
    ctqFailureMsg:
      'Nu se poate anula apelul de consultare pentru coadă. Încercați din nou.',
    cancelCtqInfo:
      'Se caută un agent disponibil în coada selectată. Aşteptaţi sau anulaţi solicitarea de consultare.',
    cancelCtqAction: 'Anulare consultare',
    entryPoint: 'Punct de intrare'
  },
  conference: {
    title: 'Solicitare conferinţă',
    heading: {
      chat: 'Selectaţi un anumit agent pentru chat în conferinţă'
    },
    queues: 'Coadă',
    agents: 'Agent',
    dialNumber: 'Număr de format',
    organization: 'Organizaţie',
    placeholder: {
      Queues: 'Selectaţi dintr-o listă de cozi',
      Agents: 'Selectaţi dintr-o listă de agenţi',
      DialNumber: 'Alegere după nume sau număr'
    },
    type: 'Conferinţă',
    cancel: 'Anulare',
    closeModal: 'Închidere fereastră modală',
    failureError: 'Nu se poate iniţia solicitarea de conferinţă. Încercați din nou.'
  },
  transferModal: {
    Agents: 'Nu se poate prelua lista de agenți. Reîmprospătați lista.',
    AgentsEmpty: 'Niciun agent disponibil',
    Queues: 'Nu se poate prelua lista de cozi. Reîmprospătați lista.',
    QueuesEmpty: 'Nicio coadă disponibilă',
    EPEmpty: 'Nu există niciun punct de intrare disponibil',
    DialNumber:
      'Nu se poate prelua lista de numere de apelare din agendă. Reîmprospătați lista.',
    EntryPoint:
      'Nu s-a putut obține lista cu numerele punctelor de intrare. Reîmprospătați lista.',
    Common: 'Nu s-a putut obține lista. Reîmprospătați lista.',
    DialNumberEmpty: 'Niciun număr de format disponibil',
    DialNumbInvalid:
      'Numărul de format este nevalid. Contactaţi administratorul.',
    DialNumbOrEntryPointInvalid:
      'Numărul format/punctul de intrare nu este valid. Contactați administratorul.',
    refreshQueueList: 'Reîmprospătați lista de cozi',
    refreshAgentList: 'Reîmprospătați lista de agenți',
    refreshEpList: 'Reîmprospătați punctele de intrare',
    refreshAddressBook: 'Reîmprospătați agenda',
    refreshTheList: 'Reîmprospătați lista',
    entryPointSectionLabel: 'Punct de intrare',
    addressBookSectionLabel: 'Agendă',
    organization: 'Organizaţie',
    comboBoxAriaLabelAgent: 'Selectaţi dintr-o listă de agenţi',
    comboBoxAriaLabelQueue: 'Selectaţi dintr-o listă de cozi',
    comboBoxAriaLabelEp: 'Alegeți dintr-o listă de puncte de intrare',
    infScrollAgent: 'Căutare agenți',
    infScrollQueue: 'Căutare cozi',
    infScrollEP: 'Căutare puncte de intrare',
    allRadioButtonHidedTextForConsult: 'Nu aveți entități atribuite pentru a furniza consultație în această interacțiune. Contactați administratorul.',
    allRadioButtonHidedTextForTransfer: 'Nu aveți entități atribuite pentru a transfera această interacțiune. Contactați administratorul.',
    allRadioButtonHidedTextForConference: 'Nu aveți entități atribuite pentru a intra în conferință în această interacțiune. Contactați administratorul.',
    searchMinCharError: 'Introduceți cel puțin trei caractere pentru căutare.',
  },
  wrapup: {
    cancelautowrapup: 'Anulare concluzionare automată',
    wrapupreason: 'Motive concluzionare',
    untilautowrapup: 'până la concluzionare automată',
    followupsetting: 'Setare de urmărire',
    lastagentroute: 'Dirijare ultimul agent',
    submitwrapup: 'Trimitere concluzionare',
    wrapupsearch: 'Căutare motiv concluzionare',
    invalidationError: 'Eşec la trimiterea concluzionării',
    searchResult: 'Rezultate de căutare disponibile',
    noResultFound: 'Nu a fost găsit niciun rezultat al căutării',
    listContainerLabel: 'Depozit listă de date de concluzionare',
    searchError: 'Introduceți minimum trei caractere pentru a căuta motive de concluzionare.',
  },

  outdial: {
    call: 'Apel',
    dialpadSearch: 'Introduceți nr. de format',
    addressSearch: 'Căutare după nume/număr',
    addressTab: 'Adresă',
    addressTabTooltip: 'Căutare în agendă',
    dialpadTab: 'Tastatură de formare',
    dialpadTooltip: 'Formare număr',
    searchTab: 'Căutare',
    searchTabTooltip:'Căutare persoane din organizația mea',
    noAdrFound: 'Nu a fost găsită nicio corespondenţă',
    noContacts: 'Niciun contact',
    mainIconTooltip: 'Apel de apelare',
    errorOutdialFailed:
      'Apelul de apelare a eșuat. Aplicația Desktop nu a putut conecta apelul sau nu s-a răspuns la apel.',
    errorOutdialDisabled: 'Apelurile de apelare sunt dezactivate',
    errorDialPadValidationMessage: 'Format incorect',
    outdialReqInProgress: 'Apelul de apelare este în curs',
    outdialAniPlaceholder: 'Selectare ANI apelare',
    outdialAniLabel: 'ANI de apelare',
    outdialAniPlaceHolder: 'Căutați ANI de apelare',
    errorDcCallsLimitExceeded:
      'Centrul de date a atins limita maximă pentru apeluri efectuate. Nu se mai pot efectua apeluri',
    errorOrgCallsLimitExceeded:
      'Organizația a atins limita maximă pentru apeluri efectuate. Nu se mai pot efectua apeluri.',
    errorOutDialNoAnswerFromCustomer:
      'Clientul nu a răspuns la apelul dvs. Încercați să sunați mai târziu.',
    errorOutDialCustomerUnavailable:
      'Clientul nu este disponibil acum. Încercați să apelați mai târziu.',
    errorOutDialAgentEnds: 'Ați încheiat apelul cu clientul.',
    errorOutDialCustomerBusy: 'Clientul este ocupat acum. Încercați să apelați mai târziu.',
    searchError: 'Introduceți cel puțin trei caractere pentru o căutare în contacte.',
    upArrowLabel: 'Extindere',
    clear: 'Eliminare intrare',
    outdialDialogDescription: 'În prezent, sunteți în caseta de dialog cu file.'
  },

  organization: {
    noMatchFound: 'Nu a fost găsită nicio corespondenţă',
    searchError: 'Introduceți cel puțin trei caractere pentru o căutare în contacte.',
    authError: 'Nu există persoane de contact de afișat. Autentificarea Microsoft a eșuat.'
  },

  interactionPopover: {
    of: 'din',
    accept: 'Accept.',
    acceptAriaLabel: 'Acceptați activitatea {taskNumber} - {taskType} de la {from}',
    requests: 'Solicitări',
    back: 'înapoi',
    next: 'înainte',
    acceptMultipleRequest: 'Acceptare {requestCount} solicitări',
    paginationDetail: '{indexStart}-{indexEnd} din {totalPopoverpoolLength}',
    hidePopoverDetails: 'Ascundere detalii fereastră popover',
    showPopoverDetails: 'Afişare detalii fereastră popover',
    customerName: 'Nume client',
    email: 'E-mail',
    queueName: 'Nume coadă',
    failedToAccept: 'Eşec la acceptare.',
    unableToAccept: 'Nu s-a putut accepta contactul.',
    failedToEnd: 'Eşec la finalizare.',
    unableToEnd: 'Nu s-a putut încheia contactul. ',
    ringing: 'Sună',
    calling: 'Se apelează',
    phoneNumber: 'Număr de telefon',
    dni: 'DNIS',
    ivrPathId: 'ID cale IVR',
    pathId: 'ID cale',
    rona: 'RONA',
    sourcePage: 'Pagină sursă',
    sourceNumber: 'Număr sursă',
    appUserId: 'ID utilizator aplicaţie',
    acceptAll: 'Acceptare toate sarcinile',
    agentDn: 'DN agent',
    agentName: 'Nume agent',
    agentTeam: 'Echipă agent',
    requestDetails: 'Solicitare detalii',
    incomingCallFrom: 'Apel de intrare de la',
    unableToAnswer: 'Nu s-a putut răspunde la apel. Încercaţi din nou.',
    unableToDecline: 'Nu s-a putut respinge apelul. Încercaţi din nou.'
  },

  multiLogin: {
    header: 'Alertă de conectări multiple',
    message:
      'Sunteţi conectat la Desktop în mai multe instanțe ale aplicației. Faceţi clic pe Continuare pentru a continua cu Desktop în această instanță a aplicației. În caz contrar, închideţi această fereastră.',
    continue: 'Continuare'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Transferul către punctul de intrare/coadă a eșuat din cauza unei erori de configurare.',
    1010: "Nu s-a putut consulta, deoarece agentul nu a putut fi alocat la timp. ",
    1042: "Contactul nu a fost găsit",
    1043: 'Destinația este nevalidă.',
    1045: 'Interacțiunea nu este atribuită agentului.',
    1046: 'Consultarea cu agent e eșuat, deoarece niciun canal de agenți corespunzător nu a fost găsit în sistem.',
    1038: "Agentul nu a fost găsit",
    1037: 'Conectarea a eșuat din cauza erorii interne.',

    // Media Events
    138: 'Acțiunea a eșuat din motive necunoscute.',
    136: 'Utilizatorul nu a fost găsit',

    // AgentConsultFailed
    1050: 'Nu s-a putut consulta din cauza configurației sau activității neacceptate din flux. ',
    1005: "Nu s-a putut consulta, deoarece agentul nu a răspuns la solicitare la timp.",
    1051: 'Nu s-a putut consulta sau transfera din cauza unui punct de intrare sau a unui număr de format nevalid.',

    // AgentInviteFailed
    1053: 'Nu s-a putut prezenta interacțiunea, din cauza unei sarcini în așteptare pentru replasarea în coada din fluxul de lucru.',
    1054: 'Nu s-a putut plasa apelul de apelare, din cauza problemelor media cu această solicitare. ',

    // AgentContactAssignFailed
    1011: 'Nu s-a putut răspunde sau accepta apelul din cauza agenților lipsă în interacțiunea în curs. ',

    // ContactCallbackFailed
    1034: 'Apelarea inversă a contactului a eșuat, deoarece s-a primit ContactParkTimeout pentru solicitare.',

    // ContactUpdateFailed
    1020: "Nu s-au putut actualiza variabilele, deoarece una dintre valori depășește limita numărului de caractere, de 256. Reduceți numărul de caractere și încercați din nou.",

    // AgentInviteFailed
    1031: 'Agentul a invitat clientul după ce a fost solicitată apelarea inversă.',

    // AgentBlindTransferFailedEvent
    1044: 'Transferul orb al agentului a eșuat, deoarece agentul destinație este atribuit altei interacțiuni.',

    // AgentCtqCancelFailed
    1047: "Contactul nu a fost găsit.",

    // AgentCtqFailed
    1048: "Grupul de distribuire a apelurilor nu a fost configurat.",
    1049: 'Timpul maxim de așteptare în coadă a fost depășit.',
    // StationLoginFailed
    127: 'Înregistrarea DN a agentului a eșuat cu o excepție de conectare duplicată.'
  },

  stateSelector: {
    Available: 'Disponibili',
    errorstatechange: 'Modificarea stării nu a reuşit. Încercaţi din nou.',
    errorStateChangeInPendingLogout: 'Nu s-a putut modifica starea agentului din cauza deconectării în așteptare.',
    label: 'Stare de disponibilitate',
    agentStateSelector: 'Selector stare agent',
    Engaged: 'Ocupat',
    engagedAvailableInfo:
      'Momentan sunteți ocupat cu o interacțiune și în starea Disponibil.',
    engagedIdleInfo:
      'Momentan sunteți ocupat cu o interacțiune și în starea Inactiv',
    engagedInfo: 'În prezent sunteți angajat într-o interacțiune.',
    engagedSupervisorStateChange: 'starea dvs. a fost schimbată în',
    axAgentStateChanged: 'Starea dvs. s-a modificat în',
    axAgentSync: 'datorită sincronizării stării cu instrumentul dvs. de colaborare.',
    engagedPresenceInfo:
      'Momentan sunteți angajat într-o interacțiune, iar starea dvs. este',
    engagedPresenceSync: 'datorită sincronizării stării cu instrumentul dvs. de colaborare.',
    clear: 'Eliminare intrare',
    searchState: 'intrare',
    agentStatusLabel: 'Stare agent',
    agentStateLabel: 'Agentul a fost în starea {selectedState} în ultimele {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Agentul este în starea {selectedState} în ultima 0 sec.',
    agentStateChangeSuccessful:'Modificarea stării la {selectedState} a reușit.',
    agentStateChangeFail:'Modificarea stării la {selectedState} a eșuat.',
    searchError: 'Introduceți cel puțin trei caractere pentru a căuta stări.'
  },

  warningMessage: {
    header: 'Modificări nesalvate',
    message:
      'Aveți modificări nesalvate pe această pagină. Sigur părăsiți această pagină? ',
    cancelButton: 'Rămâneți',
    saveButton: 'Ieșiți'
  },

  notificationLables: {
    muteVolume: 'Dezactivare sunet notificare volum',
    unmuteVolume: 'Activare sunet notificare volum',
    notificationVolume: 'Volum notificare',
    playSound: 'Redare sunet notificare',
    enableSoundNotificationSettings: 'Activare notificări sonore',
    enableSoundNotificationSettingsDescription:
      'Livrează notificări sonore pentru solicitările de intrare. Puteți ajusta volumul mai jos.',
    volumeTitle: 'Volum sunet'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Apel',
    chat: 'Chat',
    email: 'E-mail',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google Business Messages"
  },
  orgDetailsLabels: {
    role: 'Rol',
    department: 'Departament',
    email: 'E-mail',
    businessPhone: 'Telefon de serviciu',
    workPhone: 'Serviciu',
  },
  addressListError: {
    title: 'Eşec la încărcarea datelor',
    errorId: 'ID eroare:'
  },
  keypad: {
    keyPadSearch: 'Introduceți numărul',
    dialPad: 'Tastatură de formare'
  },
  collabTool: {
    userAuthenticated: 'Autentificare utilizator:',
    successful: 'Reuşită',
    failed: 'Eșec.',
    tryAgain: 'Încercaţi din nou',
    stateSync: 'Sincronizare stare:',
    mercuryFailedInfo: ' Contactaţi administratorul.',
    retrying: 'Se reîncearcă...',
    trackingIdLabel: 'ID urmărire: '
  },
  webex: {
    webex: 'Webex',
    info: 'Integrarea vă permite să sincronizați stările între Desktop și Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Cu această integrare puteți consulta sau transfera apeluri către utilizatorii Microsoft Teams.',
    authenticationFailedInfo:
      'Dacă o fereastră de autentificare este deja deschisă, reîncercați autentificarea acolo.',
    ListItemContactDetails:
      'Numele contactului este: {name}, prezența sa este: {presence}, departamentul este: {department}, denumirea postului este: {jobTitle}, iar numărul de telefon este: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Notificare serviciu de urgență',
    readNotification: 'Am citit notificarea.'
  },
  webexPresenceStatus: {
    active: 'Activ',
    lastActiveFewMinutesAgo: 'Activ în ultimele câteva minute',
    lastActiveMinutesAgo: 'Activ acum {min} minute',
    lastActive1HourAgo: 'Ultima activitate acum 1 oră',
    lastActiveHoursAgo: 'Activ acum {hour} ore',
    lastActiveYesterday: 'Activ ieri',
    lastActiveOnDate: 'Activ în {date}',
    busy: 'Ocupat',
    busyUntil: 'Ocupat până în {date}',
    dnd: 'Nu deranjaţi',
    dndUntil: 'Nu deranjați până în {date}',
    quiet: 'Silențios',
    quietUntil: 'Silențios până în {date}',
    ooo: 'Plecat de la birou',
    outOfOfficeUntil: 'Plecat de la birou până în {date}',
    call: 'Într-un apel',
    meeting: 'Într-o întâlnire',
    calendarItem: 'Într-o întâlnire din calendar',
    presenting: 'Prezintă',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Căutare după nume sau detalii de profil',
    webexPlaceholder: 'Căutare după nume/e-mail',
    refreshTheList: 'Reîmprospătați lista',
    refreshAddressBook: 'Reîmprospătați agenda',
    microsoftAuthError: 'Nu există persoane de contact de afișat. Autentificarea Microsoft a eșuat.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/ru.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/ru.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Не удалось загрузить данные',
    errorID: 'Идентификатор ошибки',
    tryAgain: 'Повторите попытку',
    Error: 'Ошибка',
    okButton: 'ОК',
    Yes: 'Да',
    Cancel: 'Отмена',
    Confirm: 'Подтвердить',
    Continue: 'Продолжить',
    Canceling: 'Отмена',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: 'Ответ',
    AnswerAriaLabel: 'Ответить на настольную задачу',
    Decline: 'Отклонить',
    ErrorSecurityCompliance: 'Соответствие требованиям безопасности',
    errorDetails: 'Сведения об ошибке',
    learnMore: 'Подробнее',
    showLess: 'Меньше',
    trackingIdDescription:
      'Поделитесь идентификатором отслеживания с администратором сайта или группой поддержки, чтобы изучить ситуацию.',
    trackingIdInputLabel: 'Идентификатор отслеживания: ',
    submitForm: 'Отправить форму',
    unnamedStatus: 'Безымянное состояние',
    errorChatMsg: 'Не удалось загрузить данные чата',
    noOptions: 'Нет вариантов',
    noResults: 'Нет результатов',
    more: 'Больше',
    nomatchfound: 'Совпадений не найдено',
    collaborationTool: 'Инструмент для совместной работы',
    timerAriaLabel: 'Затраченное время',
    historyItemTime: 'Когда произошло:',
    loading: 'Загрузка',
    months: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь'
    ],
    loadingMsg: 'Загрузка...',
    search: 'Поиск',
    historyChannelLabels: {
      All: 'Все',
      telephony: 'Голос',
      chat: 'Чат',
      email: 'Эл. почта',
      social: 'Социальн. сети'
    },
    homePageLabel: 'Главная страница',
    resizeHistoryDragger: 'Изменение размера истории перетаскиванием',
    agentHistoryLabel: 'история оператора',
    clear: 'Очистить ввод',
    ariaLabelAgentHistoryWrapper:
      'В истории диалога с оператором отображается информация о недавнем общении с клиентами по различным каналам за последние 24 часа',
    sliderResizerInstructions:
      'Вы на ползунке. Чтобы изменить размер, используйте клавиши со стрелками',
    resizeHistoryPanel: 'изменить размер панели истории, ползунок,',
    time: {
      hours: 'ч',
      minutes: 'мин',
      seconds: 'с'
    }
  },
  email: {
    ToLabel: 'По',
    FromLabel: 'От',
    CcLabel: 'Копия',
    BccLabel: 'СК',
    SubjectLabel: 'Тема',
    HideLabel: 'Скрыть',
    SendLabel: 'Отправить',
    ShowPrevThread: 'Показать предыдущую цепочку',
    HidePrevThread: 'Скрыть предыдущую цепочку',
    ReplyLabel: 'Ответить',
    ReplyAllLabel: 'Ответить всем',
    ViewOriginalMail: 'Просмотреть исходное эл. письмо',
    QuickReplyInp: 'Введите быстрый ответ здесь...',
    AttachFiles: 'Вложить файлы',
    ToolbarHeading: 'Заголовок1',
    ToolbarBold: 'Полужирный',
    ToolbarItalic: 'Курсив',
    ToolbarUnderLine: 'Подчеркнутый',
    ToolbarBlockQuote: 'Блок цитирования',
    ToolbarCode: 'Блок кода',
    ToolbarListOrder: 'Упорядоченный список',
    ToolbarListBullet: 'Маркированный список',
    ToolbarLink: 'Ссылка',
    ToolbarStrike: 'Зачеркнутый',
    ToolbarColor: 'Цвет текста',
    ToolbarTable: 'Таблица',
    insertTable: 'Вставить таблицу',
    insertRowAbove: 'Вставить строку сверху',
    insertRowBelow: 'Вставить строку снизу',
    insertColumnLeft: 'Вставить столбец слева',
    insertColumnRight: 'Вставить столбец справа',
    deleteRow: 'Удалить строку',
    deleteColumn: 'Удалить столбец',
    deleteTable: 'Удалить таблицу',
    link: 'Ссылка',
    IndentRight: 'Отступ справа',
    IndentLeft: 'Отступ слева',
    showMoreAttachment: 'Показать другие вложения',
    AttachmentLimit: 'Прикрепите до ',
    attachments: ' вложений, ',
    sizeLimit: ' МБ максимум',
    attachment: 'Вложение',
    errordeleteattachment: 'Не удалось удалить файлы. Повторите попытку.',
    errordownloadattachment: 'Не удалось загрузить файлы. Повторите попытку.',
    erroraddattachemnt: 'Не удалось передать файл. Повторите попытку.',
    errorendcontact: 'Не удалось завершить взаимодействие. Повторите попытку.',
    erroraddlimitreached:
      'Не удалось вложить файл, поскольку его размер превышает максимальное ограничение в ',
    errorattachmentdrop:
      'Вложения отклонены в соответствии с политикой безопасности компании.',
    errorfiletype: 'Тип файла не поддерживается. Повторите попытку.',
    errorcreditcard:
      'Не удалось передать вложения в соответствии с политикой безопасности компании.',
    errorcontainsimage:
      'Не удалось передать вложение, поскольку в нем содержатся изображения, не поддерживаемые политикой безопасности компании.',
    errorlimit: ' МБ.',
    errorsendemail: 'Не удалось отправить эл. письмо. Повторите попытку.',
    errorpcicheckemail: 'Не удается получить данные PCI. Повторите попытку.',
    errortext: 'Не удалось загрузить данные',
    tryAgain: 'Повторите попытку',
    replywarning:
      'Не указывайте в этом сообщении или вложениях финансовую информацию, сведения о здоровье или информацию, позволяющую установить личность.',
    datamasked:
      'Тема или текст эл. письма отредактированы в соответствии с политикой безопасности компании. Отправить это письмо?',
    pcibannerwarning:
      'Тема или текст эл. письма отредактированы в соответствии с политикой безопасности компании.',
    on: 'Вкл',
    wrote: 'написал(а)'
  },
  interaction_control: {
    windowOpened: 'Окно открыто',
    connected: 'Подключено',
    consultRequested: 'Запрошена консультация',
    consulting: 'Консультация',
    consultCallOnHold: 'Консультация на удержании',
    callOnHold: 'Вызов на удержании',
    consult: 'Консультация',
    endconsult: 'Завершить консультацию',
    hold: 'Удержание',
    transfer: 'Перевод',
    conference: 'Конференция',
    endconference: 'Завершить конференцию',
    conferenceRequested: 'Запрошена конференция',
    switchCall: 'Переключить',
    mergeCall: 'Объединить',
    wrapup: 'Поствызов',
    end: 'Конец',
    customername: 'Имя клиента',
    dn: 'DNIS',
    ivrpath: 'Путь к IVR',
    email: 'Эл. почта клиента',
    ani: 'Номер телефона',
    queueid: 'Имя очереди',
    ronatimeout: 'Время RONA',
    pathid: 'Идентификатор пути к IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'Абонентский номер оператора',
    destagentname: 'Имя оператора',
    virtualteamname: 'Очередь',
    category: 'Категория',
    additionaldetails: 'Дополнит. сведения',
    sourcenumber: 'Исходный номер',
    sourcepage: 'Исходная страница',
    appuser: 'Идентификатор пользователя приложения',
    customernumber: 'Номер телефона',
    exitconference: 'Выйти из конференции',
    resume: 'Возобновить',
    pauserecording: 'Приостановить запись',
    resumerecording: 'Возобновить запись',
    exitconsult: 'Выйти из консультации',
    pauseRecordingFailed: 'Невозможно приостановить запись. Повторите попытку.',
    resumeRecordingFailed: 'Невозможно возобновить запись. Повторите попытку.',
    holdCallFailed: 'Невозможно поставить вызов на удержание. Повторите попытку.',
    resumeCallFailed: 'Невозможно возобновить вызов. Повторите попытку.',
    endCallFailed: 'Не удалось завершить взаимодействие. Повторите попытку.',
    consultTransferFailed:
      'Невозможно перевести консультационный вызов. Повторите попытку.',
    conferenceTransferFailed:
      'Невозможно перевести конференц-вызов. Повторите попытку.',
    conferenceFailed:
      'Не удается связать запрос конференции. Повторите попытку.',
    consultEndFailed: 'Невозможно завершить запрос консультации. Повторите попытку.',
    conferenceExitFailed:
      'Невозможно выйти из запроса на конференцию. Повторите попытку.',
    conferenceEndFailed:
      'Невозможно завершить запрос конференции. Повторите попытку.',
    cancelCtqFailed:
      'Не удается отменить консультативный вызов в очереди. Повторите попытку.',
    privacyShield: 'Privacy Shield',
    errorOnPrvacyShieldForConsult:
      'Запись приостановлена. Возобновите запись, чтобы начать консультативный вызов.',
    errorOnPrvacyShieldForTransfer:
      'Запись приостановлена. Возобновите запись, чтобы начать переданный вызов.',
    cancelConsult: 'Отменить консультацию',
    cancelTransfer: 'Отменить передачу',
    copy: 'Копировать',
    copied: 'Скопировано',
    cadrequestuccess: 'Сведения о клиенте успешно сохранены.',
    cadrequestfailure: 'Не удалось сохранить сведения о клиенте. Повторите попытку позднее.',
    cadupdatedmessage: 'Сведения о клиенте недавно были обновлены пользователем',
    unsavedmessage: 'Несохраненные изменения заменены.',
    save: 'Сохранить',
    revert: 'Возврат',
    expandDetails: 'Развернуть сведения',
    collapseDetails: 'Свернуть сведения',
    cadValidationError:
      'Неправильный формат. Используйте международный стандарт даты и времени.',
    secureCadSaveError:
      'Данные по клиенту не сохранены. Нажмите «Сохранить», чтобы повторить попытку.',
    secureDecryptionError: 'Не удается отобразить защищенные переменные.',
    clickToTry: 'Нажмите, чтобы повторить попытку',
    isSecureVariable: '— защищенная переменная',
    contactorigin: 'Происхождение контакта',
    resumeMonitoring: 'Возобновление мониторинга',
    pauseMonitoring: 'Приостановка мониторинга',
    whisperCoach: 'Скрытый инструктаж',
    bargeIn: 'Вмешательство',
    endMonitoring: 'Завершение мониторинга',
    contactphonenumber: 'Номер телефона контакта',
    contactqueue: 'Очередь контакта',
    activeparticipants: 'Активные участники',
    consultedparticipant: 'Проконсультированный участник',
    contactstatus: 'Статус контакта',
    timeincontactstatus: 'Время контакта в этом статусе',
    totalcontactduration: 'Общая длительность контакта',
    agentinteractiontime: 'Продолжительность взаимодействия',
    recording: 'Запись',
    monitoring: 'Мониторинг',
    monitoringPaused: 'Мониторинг приостановлен',
    pauseMonitoringFailed: 'Невозможно приостановить мониторинг. Повторите попытку',
    resumeMonitoringFailed: 'Невозможно возобновить мониторинг. Повторите попытку',
    callCancelledInProgress: 'Выполняется отмена вызова',
    bargedIn: 'Вмешательство',
    keypad: 'Цифровая клавиатура',
    mute: 'Выключить микрофон',
    unmute: 'Включить микрофон',
    bargeInTooltipText:
      'Микрофон будет включен, и вы присоединитесь к этому взаимодействию с пользователем',
    bargeInCompactTooltipText:
      'Вмешаться. Микрофон будет включен, и вы присоединитесь к этому взаимодействию с пользователем',
    bargeInTooltipDisabled: 'Возобновите мониторинг, чтобы разрешить вмешательство',
    bargeInFailedTitle: 'Не удалось вмешаться',
    bargeInFailedData:
      'При попытке вмешаться произошла ошибка. Повторите попытку позже.',
    supervisorBargedIn: 'вмешивается в ваш вызов.',
    leftInteraction: 'покидает взаимодействие.',
    conferenceEnded: 'Конференц-вызов завершен.',
    participants: 'Участники',
    badgeAriaLabel: '{participant} на вызове',
    bargeInConferenceAriaLabel: 'Два участника взаимодействия',
    taskName: 'Имя задачи по управлению взаимодействием',
    interactionDurationLabel: 'Продолжительность',
    wrapupassist: 'Помощь c поствызовом',
    consultingTaskContext: 'Консультационный вызов от',
    consultExited: 'Консультативный вызов прерван',
    endCall: 'Завершить вызов.',
    exitconferenceCall:
      'Выйти из вызова. Конференция продолжится с активными участниками.',
    recordingInProgess: 'Выполняется запись',
    recordingPaused: 'Запись приостановлена',
    searchPlaceholder: 'Поиск контактов',
    postCall: "Публикация вызова",
    switchCallTooltip: "Переключиться на вызов",
    switchConsultTooltip: "Переключиться на консультативный вызов",
    switchConferenceTooltip: "Переключиться на конференц-вызов",
    confirmationDialog: {
      endCallTitle: 'Завершить вызов?',
      endCallMessage: 'Нажмите "Подтвердить", чтобы завершить вызов для всех участников.',
      exitConferenceTitle: 'Выйти из конференц-вызова?',
      exitConferenceMessage:
        'Нажмите "Подтвердить", чтобы выйти из конференц-вызова и разрешить остальным участникам продолжить.',
      confirmButtonLabel: "Подтвердить",
      cancelButtonLabel: "Отмена",  
    },
    postCallOnHold: "Опрос после вызова на удержании",
    postCallConsult: "Консультация после вызова",
    postCallConsultOnHold: "Консультация после вызова на удержании",
  },
  agentProfile: {
    teamName: 'Группа',
    dialNumber: 'Набираемый номер',
    phoneNumber: 'Номер телефона',
    settings: 'Изменить настройки',
    signOut: 'Выйти',
    webRTCDisconnected: 'Предупреждение об отключении телефонии рабочего стола ',
    msAuthFailed: 'Аутентификация Microsoft не пройдена',
    stateSyncFailed: 'Не удалось синхронизировать состояние',
    userProfileLabel: 'Профиль пользователя',
    ariaAgentprofile: 'Профиль оператора',
    ChannelCapacity: 'Емкость канала',
    voice: 'Голос',
    chat: 'Чат',
    email: 'Эл. почта',
    social: 'Социальн. сети',
    channelCapacityTooltip: 'Щелкните, чтобы открыть дополнительные сведения',
    blendedRouting: 'Смешанный',
    exclusiveRouting: 'Эксклюзивная маршрутизация',
    realtimeRouting: 'Смешанная маршрутизация в реальном времени',
    blendedRoutingTooltip: 'Обработка нескольких контактов на разных каналах.',
    exclusiveRoutingTooltip: 'Единовременная обработка только одного контакта.',
    realtimeRoutingTooltip: 'Обработка одного обязательного канала в реальном времени.',
    errorActiveContacts:
      'Вы не можете выйти из системы сейчас, поскольку у вас есть активные разговоры. Завершите их и повторите попытку.',
    searchTeams: 'Поиск команд',
    changeTeamsConfirmHeader: 'Подтверждение смены команды',
    changeTeamsConfirmMessage: 'Действительно сменить команду?',
    changeTeamLabel: 'Сменить команду',
    errorChangeTeams:
      'Нельзя сменить команду сейчас, потому что у вас есть активные запросы. Пожалуйста, завершите их и попробуйте еще раз.',
    saveTeamSelection: 'Сохранить выбор команды',
    userSettings: 'Настройки пользователя',
    resetLayout: 'Сброс всего оформления Desktop',
    resetConfirmHeader: 'Подтверждение сброса оформления',
    resetConfirmMessage:
      'Действительно сбросить все оформление Desktop? <br/> В Desktop будет использоваться оформление по умолчанию.',
    downloadLogs: 'Загрузить отчет об ошибках',
    help: 'Справка',
    signoutConfirm: 'Действительно выйти?',
    signoutConfirmHeader: 'Подтверждение выхода',
    darkTheme: 'Переключиться на темный режим',
    newLook: 'Переключиться на новый внешний вид',
    keyboardShortcuts: 'Сочетания клавиш',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Настройки уведомлений',
    silentNotification: 'Беззвучное уведомление',
    enableNotificationSettings: 'Включить уведомления',
    enableSilentNotificationSettings: 'Включить беззвучные уведомления',
    suppressWebexCallingNotificationSettings: 'Скрыть уведомления от Webex Calling',
    notificationSettingDescription:
      'Доставляет уведомления, такие как новые сообщения, оповещения и изменения состояния.',
    silentNotificationDescription:
      'Выключает экранные оповещения. Вы можете просмотреть уведомления в центре уведомлений.',
    suppressWebexCallingNotificationDescription: 
    'Всплывающие уведомления о входящих вызовах Webex не отображаются, ответы на них через осуществляются через Webex Contact Center.',
    arrowLabel: 'Вернуться',
    managedTeams: 'Управляемые группы',
    managedTeamsError: 'Не удалось загрузить группы.',
    viewAll: 'Просмотреть все',
    profileSettings: 'Параметры профиля',
    userRole: 'Роль',
    saveSelection: 'Сохранить выбор',
    extension: 'Добавочный номер',
    changeProfileConfirmHeader: 'Подтверждение изменения параметров профиля',
    changeProfileConfirmMessage:
      'Сохранить изменения профиля?',
    confirm: 'Подтвердить',
    errorProfileUpdate:
      'Нельзя изменить параметры профиля, потому что у вас есть активные запросы. Пожалуйста, завершите их и попробуйте еще раз.',
    roleAgentSupervisor: 'Руководитель и оператор',
    roleSupervisor: 'Руководитель',
    noTeam: 'Без группы',
    testYourNetwork: 'Проверка вашей сети',
    speakerAndMic: 'Динамик и микрофон',
    speaker: 'Динамик',
    mic: 'Микрофон',
    speakerDescription:
      'Выберите и проверьте устройство вывода, чтобы убедиться, что вы услышите вызывающего абонента.',
    micDescription:
      'Выберите и проверьте устройство ввода, чтобы убедиться, что вызывающий абонент вас услышит.',
    micError:
      'Доступ к микрофону запрещен. Включите доступ с помощью настроек браузера или обратитесь к администратору.',
    speakerError:
      'В настоящее время динамик недоступен, так как запрещен доступ к микрофону.',
    telephony: 'Телефония',
    desktop: 'Рабочий стол',
    onSpeakerPlay:
      'Если вы не слышите тестовый сигнал, проверьте динамик.',
    onMicPlay:
      'Если вы не слышите тестовый сигнал, проверьте динамик и микрофон.',
    onMicRecord: 'Запишите сообщение для воспроизведения.',
    test: 'Проверка',
    recording: 'Запись',
    playing: 'Воспроизведение',
    reconnecting: 'Восстановление подключения',
    disconnectMessage:
      'Телефония рабочего стола отключена. Выберите другой параметр телефонии.',
    singleTelephonyDisconnectMessage:
      'Телефония рабочего стола отключена. Обратитесь к администратору.',
    clear: 'Очистить ввод',
    rememberMeCheckBoxMessage: "Больше не показывать",
    saveLabel: 'Сохранить',
    browserUnsupportedError: "Не удалось выполнить вход, так как вы используете неподдерживаемый браузер.",
    microphoneAccessDeniedError: "Доступ к микрофону запрещен. Включите доступ с помощью настроек браузера или обратитесь к администратору.",
  },
  contactHistory: {
    mainHeader: 'История контактов',
    handledBy: 'Обработано',
    noRecordFound: 'История контактов не найдена!',
    tryAgain: 'Повторите попытку',
    errorMsg: 'Не удалось получить историю контактов. Повторите попытку.',
    errorID: 'Идентификатор ошибки',
    missingAni: 'Отсутствует ANI',
    timeIcon: 'Продолж.',
    taskHandled: 'Обращение обработано',
    noHistoryNew: 'Нет истории',
    noHistory: 'Нет истории',
    viewTranscript: 'Просмотреть сообщение электронной почты',
    transcriptFor: 'Расшифровка для',
    editBeforeCall: 'Изменить до вызова',
    clickToCall: 'Нажмите, чтобы позвонить',
    onAnActiveCallErrorMessage:
      'Невозможно инициировать новый вызов, так как вы уже находитесь в состоянии активного вызова.',
    receivedFrom: 'От кого получен контакт:',
    initiatedTo: 'Кому инициирован контакт:',
    wrapUpReason: 'Причина поствызова',
    startCallTelephony:
      'Щелкните ссылку на номер телефона, чтобы начать исходящий вызов.',
    contactHistoryList: 'Список истории контактов,',
    wrapUpCode: 'Код завершения',
    agentName: 'Имя оператора',
    entryPointName: 'Точка входа',
    acceptedTimeAndDate: 'Дата и время принятия',
    duration: 'Продолжительность',
    emailTranscript: 'Расшифровка сообщений электронной почты',
    clickToViewEmailTranscript: 'Щелкните, чтобы просмотреть расшифровку сообщений электронной почты',
    listContainer: 'Контейнер списка'
  },
  contactTranscript: {
    agent: 'Оператор',
    entryPoint: 'Точка входа',
    date: 'Дата',
    subject: 'Тема',
    from: 'От',
    sent: 'Отправить',
    to: 'По',
    back: 'Назад',
    errorTranscript: 'При извлечении расшифровки произошла ошибка',
    customer: 'Клиент',
    inboundErrorMessage: 'Не удалось загрузить эл. почту клиента',
    outboundErrorMessage: 'Не удалось загрузить ответ оператора'
  },
  popoverTitle: {
    callback: 'Обратный вызов',
    outboundCall: 'Исходящий вызов',
    incomingCall: 'Входящий вызов',
    progressiveCampaign: 'Вызов в кампании',
    courtesyCallback: 'Обратный вызов вежливости',
    chat: 'Входящее сообщение чата',
    incoming: 'Входящие',
    monitoringCall: 'Вызов на мониторинге'
  },
  connecting: 'Установка соединения',
  initiating: 'Инициация',
  outbound: 'Исходящие',
  transfer: {
    title: 'Запрос перевода',
    heading: {
      chat: 'Выберите оператора или очередь, к которым требуется перейти.',
      email: 'Выберите очередь, в которую требуется перейти.',
      telephony:
        'Выберите оператора, очередь или набираемый номер, к которым требуется перейти.',
      noQueueTelephony:
        'Выберите оператора или набираемый номер, к которым требуется перейти.'
    },
    header: {
      chat: 'Выберите оператора или очередь для перевода этого контакта.',
      email: 'Выберите очередь для перевода этого контакта.',
      telephony:
        'Выберите оператора, очередь, набираемый номер или организацию для перевода этого контакта.',
      noQueueTelephony:
        'Выберите оператора, набираемый номер или организацию для перевода этого контакта.',
      noOrganizationTelephony:
        'Выберите оператора, очередь или набираемый номер для перевода этого контакта.',
      noQueueOrganizationTelephony:
        'Выберите оператора или набираемый номер для перевода этого контакта.'
    },
    queues: 'Очередь',
    agents: 'Оператор',
    dialNumber: 'Набираемый номер',
    organization: 'Организация',
    placeholder: {
      Queues: 'Выбрать из списка очередей',
      Agents: 'Выбрать из списка операторов',
      DialNumber: 'Выбрать по имени или номеру',
      DialNumberOrEntryPoint: 'Выбрать имя / номер / точку входа',
      ChooseByNameOrNumber: 'Выбрать по имени/номеру',
      Organization: 'Поиск по имени/должности/отделу/рабочему телефону',
      WebexOrganization: 'Поиск по имени или эл. почте',
      DialNumberSearch: 'Поиск по имени или номеру'
    },
    type: 'Перевод',
    cancel: 'Отмена',
    closeModal: 'Закрыть модальное окно',
    failureError: 'Не удалось передать запрос. Повторите попытку.',
    entryPoint: 'Точка входа'
  },
  consult: {
    title: 'Запрос консультации',
    heading: {
      chat: 'Выберите оператора или очередь, к которым требуется перейти.',
      email: 'Выберите очередь, в которую требуется перейти.',
      telephony:
        'Выберите оператора, очередь или набираемый номер, в отношении которых требуется консультация.',
      noQueueTelephony:
        'Выберите оператора или набираемый номер, в отношении которых требуется консультация.'
    },
    header: {
      chat: 'Выберите оператора или очередь для перевода этого контакта.',
      email: 'Выберите очередь для перевода этого контакта.',
      telephony:
        'Выберите оператора, очередь, набираемый номер или организацию для консультации.',
      noQueueTelephony:
        'Выберите оператора, набираемый номер или организацию для консультации.',
      noOrganizationTelephony:
        'Выберите оператора, очередь или набираемый номер для консультации.',
      noQueueOrganizationTelephony:
        'Выберите оператора или набираемый номер для консультации.'
    },
    queues: 'Очередь',
    agents: 'Оператор',
    dialNumber: 'Набираемый номер',
    organization: 'Организация',
    placeholder: {
      Queues: 'Выбрать из списка очередей',
      Agents: 'Выбрать из списка операторов',
      DialNumber: 'Выбрать по имени или номеру',
      DialNumberOrEntryPoint: 'Выбрать имя / номер / точку входа',
      ChooseByNameOrNumber: 'Выбрать по имени/номеру',
      Organization: 'Поиск по имени/должности/отделу/рабочему телефону',
      WebexOrganization: 'Поиск по имени или эл. почте',
      DialNumberSearch: 'Поиск по имени или номеру'
    },
    type: 'Консультация',
    checkBoxLabel: 'Позволить участникам продолжить взаимодействие.',
    cancel: 'Отмена',
    closeModal: 'Закрыть модальное окно',
    failureError: 'Не удается связать запрос консультации. Повторите попытку.',
    customerLeftMsg: 'Клиент отсоединился. Консультация больше не требуется.',
    ctqFailureMsg:
      'Не удается отменить консультативный вызов в очереди. Повторите попытку.',
    cancelCtqInfo:
      'Выполняется поиск доступного оператора в выбранной очереди. Подождите или отмените запрос консультации.',
    cancelCtqAction: 'Отменить консультацию.',
    entryPoint: 'Точка входа'
  },
  conference: {
    title: 'Запрос конференции',
    heading: {
      chat: 'Выберите определенного оператора для конференц-чата'
    },
    queues: 'Очередь',
    agents: 'Оператор',
    dialNumber: 'Набираемый номер',
    organization: 'Организация',
    placeholder: {
      Queues: 'Выбрать из списка очередей',
      Agents: 'Выбрать из списка операторов',
      DialNumber: 'Выбрать по имени или номеру'
    },
    type: 'Конференция',
    cancel: 'Отмена',
    closeModal: 'Закрыть модальное окно',
    failureError: 'Не удалось инициировать запрос конференции. Повторите попытку.'
  },
  transferModal: {
    Agents: 'Не удалось найти список операторов. Обновите список.',
    AgentsEmpty: 'Нет доступных операторов',
    Queues: 'Не удалось найти список очередей. Обновите список.',
    QueuesEmpty: 'Нет доступных очередей',
    EPEmpty: 'Нет доступной точки входа',
    DialNumber:
      'Не удалось найти список набираемых номеров из адресной книги. Обновите список.',
    EntryPoint:
      'Невозможно извлечь список номеров точки входа. Обновите список.',
    Common: 'Невозможно извлечь список. Обновите список.',
    DialNumberEmpty: 'Нет доступных набираемых номеров',
    DialNumbInvalid:
      'Недопустимый номер набора. Свяжитесь со своим администратором.',
    DialNumbOrEntryPointInvalid:
      'Неверный номер набора / точка входа. Обратитесь к администратору.',
    refreshQueueList: 'Обновить список очередей',
    refreshAgentList: 'Обновить список операторов',
    refreshEpList: 'Обновить точки входа',
    refreshAddressBook: 'Обновить адресную книгу',
    refreshTheList: 'Обновить список',
    entryPointSectionLabel: 'Точка входа',
    addressBookSectionLabel: 'Адресная книга',
    organization: 'Организация',
    comboBoxAriaLabelAgent: 'Выбрать из списка операторов',
    comboBoxAriaLabelQueue: 'Выбрать из списка очередей',
    comboBoxAriaLabelEp: 'Выбрать из списка точек входа',
    infScrollAgent: 'Искать операторов',
    infScrollQueue: 'Искать очереди',
    infScrollEP: 'Искать точки входа',
    allRadioButtonHidedTextForConsult: 'Вам не назначены объекты для консультации при этом взаимодействии. Обратитесь к администратору.',
    allRadioButtonHidedTextForTransfer: 'Вам не назначены объекты для передачи этого взаимодействия. Обратитесь к администратору.',
    allRadioButtonHidedTextForConference: 'Вам не назначены объекты для конференции при этом взаимодействии. Обратитесь к администратору.',
    searchMinCharError: 'Введите минимум три символа для поиска.',
  },
  wrapup: {
    cancelautowrapup: 'Отменить автоматическое завершение',
    wrapupreason: 'Причины поствызова',
    untilautowrapup: 'до автоматического поствызова',
    followupsetting: 'Настройка дальнейших действий',
    lastagentroute: 'Маршрутизация последнему оператору',
    submitwrapup: 'Оправить поствызов',
    wrapupsearch: 'Поиск причины поствызова',
    invalidationError: 'Не удалось отправить поствызов',
    searchResult: 'Доступны результаты поиска',
    noResultFound: 'Поиск не дал результатов',
    listContainerLabel: 'Контейнер списков для подготовки сводки',
    searchError: 'Введите не менее трех символов для поиска причин поствызова.',
  },

  outdial: {
    call: 'Вызов',
    dialpadSearch: 'Введите номер',
    addressSearch: 'Поиск по имени/номеру',
    addressTab: 'Адрес',
    addressTabTooltip: 'Поиск в адресной книге',
    dialpadTab: 'Панель набора',
    dialpadTooltip: 'Набрать номер',
    searchTab: 'Поиск',
    searchTabTooltip:'Поиск пользователей в моей организации',
    noAdrFound: 'Совпадений не найдено',
    noContacts: 'Контакты отсутствуют',
    mainIconTooltip: 'Исходящий вызов',
    errorOutdialFailed:
      'Ошибка исходящего вызова. Рабочему столу не удалось подключиться к вызову или ответа на вызов не было.',
    errorOutdialDisabled: 'Исходящие вызовы отключены',
    errorDialPadValidationMessage: 'Неверный формат',
    outdialReqInProgress: 'Выполняется исходящий вызов',
    outdialAniPlaceholder: 'Выбрать ANI исходящих',
    outdialAniLabel: 'ANI исходящих',
    outdialAniPlaceHolder: 'Поиск ANI исходящих',
    errorDcCallsLimitExceeded:
      'Центр обработки данных достиг максимального предела для исходящих вызовов. Больше невозможно совершить исходящие вызовы',
    errorOrgCallsLimitExceeded:
      'Организация достигла максимального предела для исходящих вызовов. Больше невозможно совершить исходящие вызовы.',
    errorOutDialNoAnswerFromCustomer:
      'Клиент не ответил на вызов. Повторите вызов позже.',
    errorOutDialCustomerUnavailable:
      'Клиент сейчас недоступен. Повторите вызов позже.',
    errorOutDialAgentEnds: 'Вы завершили вызов с клиентом.',
    errorOutDialCustomerBusy: 'Клиент сейчас занят. Повторите вызов позже.',
    searchError: 'Введите минимум три символа для поиска контактов.',
    upArrowLabel: 'Развернуть',
    clear: 'Очистить ввод',
    outdialDialogDescription: 'Вы находитесь в диалоговом окне с вкладками.'
  },

  organization: {
    noMatchFound: 'Совпадений не найдено',
    searchError: 'Введите минимум три символа для поиска контактов.',
    authError: 'Нет контактов для отображения. Аутентификация Microsoft не пройдена.'
  },

  interactionPopover: {
    of: 'из',
    accept: 'Принять',
    acceptAriaLabel: 'Принять задачу {taskNumber} — {taskType} от пользователя {from}',
    requests: 'Запросы',
    back: 'назад',
    next: 'далее',
    acceptMultipleRequest: 'Принять запросов: {requestCount}',
    paginationDetail: '{indexStart}–{indexEnd} из {totalPopoverpoolLength}',
    hidePopoverDetails: 'Скрыть всплывающее окно со сведениями',
    showPopoverDetails: 'Показать всплывающее окно со сведениями',
    customerName: 'Имя клиента',
    email: 'Электронная почта',
    queueName: 'Имя очереди',
    failedToAccept: 'Не удалось принять.',
    unableToAccept: 'Не удалось принять контакт.',
    failedToEnd: 'Не удалось завершить.',
    unableToEnd: 'Не удалось завершить контакт. ',
    ringing: 'Звонок',
    calling: 'Вызов',
    phoneNumber: 'Номер телефона',
    dni: 'DNIS',
    ivrPathId: 'Идентификатор пути к IVR',
    pathId: 'Идентификатор пути',
    rona: 'RONA',
    sourcePage: 'Исходная страница',
    sourceNumber: 'Исходный номер',
    appUserId: 'Идентификатор пользователя приложения',
    acceptAll: 'Принять все задачи',
    agentDn: 'Абонентский номер оператора',
    agentName: 'Имя оператора',
    agentTeam: 'Группа операторов',
    requestDetails: 'Сведения о запросе',
    incomingCallFrom: 'Входящий вызов от',
    unableToAnswer: 'Невозможно ответить на вызов. Повторите попытку.',
    unableToDecline: 'Невозможно отклонить вызов. Повторите попытку.'
  },

  multiLogin: {
    header: 'Предупреждение о нескольких попытках входа',
    message:
      'Вы вошли в Desktop в нескольких экземплярах приложения. Нажмите «Продолжить», чтобы продолжить работу с Desktop в этом экземпляре приложения. В противном случае закройте это окно.',
    continue: 'Продолжить'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Не удалось выполнить передачу в точку входа/очередь из-за ошибки конфигурации.',
    1010: "Невозможно выполнить консультацию, поскольку не удалось выделить оператора вовремя. ",
    1042: "Контакт не найден",
    1043: 'Недопустимое назначение.',
    1045: 'Взаимодействие не назначено оператору.',
    1046: 'Не удалось выполнить консультацию с оператором, поскольку в системе не найден соответствующий канал операторов.',
    1038: "Оператор не найден",
    1037: 'Не удалось выполнить вход из-за внутренней ошибки.',

    // Media Events
    138: 'Не удалось выполнить действие из-за неизвестных причин.',
    136: 'Пользователь не найден',

    // AgentConsultFailed
    1050: 'Не удалось выполнить консультацию из-за неподдерживаемой конфигурации или действия в потоке. ',
    1005: "Не удалось выполнить консультацию, поскольку оператор не ответил на запрос вовремя.",
    1051: 'Не удалось выполнить консультацию или передачу из-за недопустимой точки входа или набираемого номера.',

    // AgentInviteFailed
    1053: 'Не удалось представить взаимодействие из-за ожидающей задачи возврата рабочего процесса в очередь.',
    1054: 'Не удалось выполнить исходящий вызов из-за проблем со средой передачи данного запроса. ',

    // AgentContactAssignFailed
    1011: 'Не удалось ответить на вызов или принять его из-за отсутствия операторов в текущем взаимодействии. ',

    // ContactCallbackFailed
    1034: 'Не удалось выполнить обратный вызов контакта, поскольку запрос получил статус ContactParkTimeout.',

    // ContactUpdateFailed
    1020: "Не удалось обновить переменные, поскольку одно из значений превышает допустимое количество символов (256). Сократите количество символов и повторите попытку.",

    // AgentInviteFailed
    1031: 'Оператор пригласил клиента после запроса обратного вызова.',

    // AgentBlindTransferFailedEvent
    1044: 'Не удалось передать оператора вслепую, поскольку целевой оператор назначен другому взаимодействию.',

    // AgentCtqCancelFailed
    1047: "Контакт не найден.",

    // AgentCtqFailed
    1048: "Группа распределения вызовов не настроена.",
    1049: 'Превышено максимальное время ожидания в очереди.',
    // StationLoginFailed
    127: 'Регистрация абонентского номера оператора завершилась с ошибкой дублирования входа.'
  },

  stateSelector: {
    Available: 'Доступные',
    errorstatechange: 'Изменение состояния не выполнено. Повторите попытку.',
    errorStateChangeInPendingLogout: 'Не удалось изменить состояние оператора из-за ожидающего выхода из системы.',
    label: 'Состояние доступности',
    agentStateSelector: 'Селектор состояния оператора',
    Engaged: 'Приглашенный',
    engagedAvailableInfo:
      'В настоящий момент вы приглашены к взаимодействию и находитесь в состоянии "Доступен".',
    engagedIdleInfo:
      'В настоящий момент вы приглашены к взаимодействию и находитесь в состоянии ожидания.',
    engagedInfo: 'В данный момент вы приглашены к взаимодействию.',
    engagedSupervisorStateChange: 'изменяет ваше свое состояние на',
    axAgentStateChanged: 'Ваше состояние изменено на',
    axAgentSync: 'из-за синхронизации состояния с вашим инструментом для совместной работы.',
    engagedPresenceInfo:
      'Вы участвуете во взаимодействии и находитесь в состоянии',
    engagedPresenceSync: 'из-за синхронизации состояния с вашим инструментом для совместной работы.',
    clear: 'Очистить ввод',
    searchState: 'ввод',
    agentStatusLabel: 'Статус оператора',
    agentStateLabel: 'Оператор находится в состоянии {selectedState} последние {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Оператор находится в состоянии {selectedState} последние 0 сек.',
    agentStateChangeSuccessful:'Состояние успешно изменено на "{selectedState}".',
    agentStateChangeFail:'Не удалось изменить состояние на "{selectedState}".',
    searchError: 'Введите минимум три символа для поиска состояний.'
  },

  warningMessage: {
    header: 'Несохраненные изменения',
    message:
      'На этой странице есть несохраненные изменения. Действительно выйти с этой страницы? ',
    cancelButton: 'Остаться',
    saveButton: 'Покинуть'
  },

  notificationLables: {
    muteVolume: 'Отключить звук уведомления',
    unmuteVolume: 'Включить звук уведомления',
    notificationVolume: 'Громкость уведомления',
    playSound: 'Воспроизводить звук уведомления',
    enableSoundNotificationSettings: 'Включить звуковые уведомления',
    enableSoundNotificationSettingsDescription:
      'Воспроизводит звуковые уведомления для входящих запросов. Вы можете изменить громкость ниже.',
    volumeTitle: 'Громкость звука'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Вызов',
    chat: 'Чат',
    email: 'Эл. почта',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google\'s Business Messages"
  },
  orgDetailsLabels: {
    role: 'Роль',
    department: 'Отдел',
    email: 'Адрес эл. почты',
    businessPhone: 'Рабочий телефон',
    workPhone: 'Рабочий',
  },
  addressListError: {
    title: 'Не удалось загрузить данные',
    errorId: 'Идентификатор ошибки:'
  },
  keypad: {
    keyPadSearch: 'Введите номер',
    dialPad: 'Номеронабиратель'
  },
  collabTool: {
    userAuthenticated: 'Аутентификация пользователя:',
    successful: 'Успешно',
    failed: 'Не пройдена.',
    tryAgain: 'Повторите попытку',
    stateSync: 'Синхронизация состояния:',
    mercuryFailedInfo: ' Обратитесь к администратору.',
    retrying: 'Повторная попытка...',
    trackingIdLabel: 'Идентификатор отслеживания: '
  },
  webex: {
    webex: 'Webex',
    info: 'Интеграция позволяет синхронизировать состояния между настольной системой и Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Благодаря этой интеграции вы сможете консультироваться с пользователями Microsoft Teams или передавать им вызовы.',
    authenticationFailedInfo:
      'Если окно аутентификации уже открыто, повторите попытку аутентификации там.',
    ListItemContactDetails:
      'Имя контакта: {name}; присутствие: {presence}; отдел: {department}; должность: {jobTitle}; номер телефона: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Уведомление относительно экстренных служб',
    readNotification: 'Я прочитал(-а) уведомление.'
  },
  webexPresenceStatus: {
    active: 'Разговор',
    lastActiveFewMinutesAgo: 'Активен за последние несколько минут',
    lastActiveMinutesAgo: 'Активен {min} мин назад',
    lastActive1HourAgo: 'Последняя активность 1 час назад',
    lastActiveHoursAgo: 'Активен {hour} ч назад',
    lastActiveYesterday: 'Активен вчера',
    lastActiveOnDate: 'Активен {date}',
    busy: 'Занято',
    busyUntil: 'Занят до {date}',
    dnd: 'Не беспок.',
    dndUntil: 'Не беспокоить до {date}',
    quiet: 'Тихо',
    quietUntil: 'Тихо до {date}',
    ooo: 'Нет на месте',
    outOfOfficeUntil: 'Нет на месте до {date}',
    call: 'Говорит по телефону',
    meeting: 'На совещании',
    calendarItem: 'На календарном совещании',
    presenting: 'Представление',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Поиск по имени или сведениям о профиле',
    webexPlaceholder: 'Поиск по имени или эл. почте',
    refreshTheList: 'Обновить список',
    refreshAddressBook: 'Обновить адресную книгу',
    microsoftAuthError: 'Нет контактов для отображения. Аутентификация Microsoft не пройдена.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/sk.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/sk.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Nepodarilo sa načítať údaje',
    errorID: 'ID chyby',
    tryAgain: 'Skúste to znova',
    Error: 'Chyba',
    okButton: 'OK',
    Yes: 'Áno',
    Cancel: 'Zrušiť',
    Confirm: 'Potvrdiť',
    Continue: 'Pokračovať',
    Canceling: 'Ruší sa',
    CiscoAiAssistant: 'Cisco AI asistent',
    Answer: 'Prijať',
    AnswerAriaLabel: 'Prijať úlohu plochy',
    Decline: 'Odmietnuť',
    ErrorSecurityCompliance: 'Dodržiavanie pravidiel zabezpečenia',
    errorDetails: 'Podrobnosti chyby',
    learnMore: 'Ďalšie informácie',
    showLess: 'Zobraziť menej',
    trackingIdDescription:
      'Zdieľajte ID sledovania so správcom alebo s tímom podpory, ktorí situáciu prešetria.',
    trackingIdInputLabel: 'ID sledovania: ',
    submitForm: 'Odoslať formulár',
    unnamedStatus: 'Stav bez názvu',
    errorChatMsg: 'Nepodarilo sa načítať údaje konverzácie',
    noOptions: 'Žiadne možnosti',
    noResults: 'Žiadne výsledky',
    more: 'Viac',
    nomatchfound: 'Nenašli sa žiadne zhody',
    collaborationTool: 'Nástroj na spoluprácu',
    timerAriaLabel: 'Strávený čas',
    historyItemTime: 'Stalo sa na',
    loading: 'Prebieha načítanie',
    months: [
      'Január',
      'Február',
      'Marec',
      'Apríl',
      'Máj',
      'Jún',
      'Júl',
      'August',
      'September',
      'Október',
      'November',
      'December'
    ],
    loadingMsg: 'Načítava sa..',
    search: 'Vyhľadať',
    historyChannelLabels: {
      All: 'Všetky',
      telephony: 'Hlas',
      chat: 'Konverzácia',
      email: 'E-mail',
      social: 'Sociálne médium'
    },
    homePageLabel: 'Domovská stránka',
    resizeHistoryDragger: 'Posuvník na zmenu veľkosti histórie',
    agentHistoryLabel: 'história agenta',
    clear: 'Vyčistiť vstup',
    ariaLabelAgentHistoryWrapper:
      'História interakcií s agentmi zobrazuje vašu nedávnu komunikáciu so zákazníkmi cez rôzne kanály za posledných 24 hodín.',
    sliderResizerInstructions:
      'Momentálne ste na posúvači. Ak chcete zmeniť veľkosť, použite klávesy so šípkami',
    resizeHistoryPanel: 'Panel histórie zmien veľkosti, posúvač,',
    time: {
      hours: 'h',
      minutes: 'min',
      seconds: 's'
    }
  },
  email: {
    ToLabel: 'Do',
    FromLabel: 'Od',
    CcLabel: 'Kópia',
    BccLabel: 'Skrytá kópia',
    SubjectLabel: 'Predmet',
    HideLabel: 'Skryť',
    SendLabel: 'Odoslať',
    ShowPrevThread: 'Zobraziť predchádzajúce vlákno',
    HidePrevThread: 'Skryť predchádzajúce vlákno',
    ReplyLabel: 'Odpovedať',
    ReplyAllLabel: 'Odpovedať všetkým',
    ViewOriginalMail: 'Zobraziť pôvodný e-mail',
    QuickReplyInp: 'Sem zadajte rýchlu odpoveď...',
    AttachFiles: 'Priložiť súbory',
    ToolbarHeading: 'Nadpis1',
    ToolbarBold: 'Tučné',
    ToolbarItalic: 'Kurzívou',
    ToolbarUnderLine: 'Podčiarknuté',
    ToolbarBlockQuote: 'Citácia',
    ToolbarCode: 'Blok kódu',
    ToolbarListOrder: 'Zobraziť podľa – zoradené',
    ToolbarListBullet: 'Zobraziť podľa – odrážka',
    ToolbarLink: 'Prepojenie',
    ToolbarStrike: 'Prečiarknuté',
    ToolbarColor: 'Farba textu',
    ToolbarTable: 'Tabuľka',
    insertTable: 'Vložiť tabuľku',
    insertRowAbove: 'Vložiť riadok nad',
    insertRowBelow: 'Vložiť riadok pod',
    insertColumnLeft: 'Vložiť stĺpec vľavo',
    insertColumnRight: 'Vložiť stĺpec vpravo',
    deleteRow: 'Odstrániť riadok',
    deleteColumn: 'Odstrániť stĺpec',
    deleteTable: 'Odstrániť tabuľku',
    link: 'Prepojenie',
    IndentRight: 'Zarážka vpravo',
    IndentLeft: 'Zarážka vľavo',
    showMoreAttachment: 'Zobraziť viac príloh',
    AttachmentLimit: 'Môžete pripojiť najviac ',
    attachments: ' príloh, maximálne ',
    sizeLimit: ' MB',
    attachment: 'Príloha',
    errordeleteattachment: 'Súbory sa nepodarilo vymazať. Skúste to znova.',
    errordownloadattachment: 'Súbory sa nepodarilo stiahnuť. Skúste to znova.',
    erroraddattachemnt: 'Nepodarilo sa načítať súbory. Skúste to znova.',
    errorendcontact: 'Nepodarilo sa ukončiť interakciu. Skúste to znova.',
    erroraddlimitreached:
      'Súbor sa nepodarilo pripojiť, pretože presahuje limit maximálnej veľkosti ',
    errorattachmentdrop:
      'Prílohy sa zrušili, pretože obsahom boli údaje, ktoré boli v rozpore s pravidlami zabezpečenia údajov spoločnosti.',
    errorfiletype: 'Typ súboru nie je podporovaný. Skúste to znova.',
    errorcreditcard:
      'Prílohu sa nepodarilo nahrať, pretože obsahuje údaje, ktoré sú v rozpore s politikami spoločnosti týkajúcimi sa zabezpečenia údajov.',
    errorcontainsimage:
      'Prílohu sa nepodarilo nahrať. Obsahuje obraz, ktorý nie je podporovaný pre požiadavky zabezpečenia, ktoré sa vzťahujú na spoločnosť.',
    errorlimit: ' MB.',
    errorsendemail: 'E-mail sa nepodarilo odoslať. Skúste to znova.',
    errorpcicheckemail: 'Nepodarilo sa načítať údaje PCI. Skúste to znova.',
    errortext: 'Nepodarilo sa načítať údaje',
    tryAgain: 'Skúste to znova',
    replywarning:
      'V tejto správe ani jej prílohách neuvádzajte žiadne finančné, zdravotné ani osobné údaje.',
    datamasked:
      'Predmet e-mailu alebo text je cenzurovaný podľa pravidiel zabezpečenia spoločnosti. Naozaj si želáte poslať e-mail?',
    pcibannerwarning:
      'Predmet alebo text e-mailu je cenzurovaný podľa pravidiel zabezpečenia spoločnosti.',
    on: 'Zapnuté',
    wrote: 'napísal(-a)'
  },
  interaction_control: {
    windowOpened: 'Okno otvorené',
    connected: 'Pripojené',
    consultRequested: 'Žiadosť o konzultáciu',
    consulting: 'Konzultácia',
    consultCallOnHold: 'Konzultácia podržaná',
    callOnHold: 'Hovor podržaný',
    consult: 'Konzultovať',
    endconsult: 'Ukončiť konzultáciu',
    hold: 'Podržať',
    transfer: 'Prenos',
    conference: 'Konferencia',
    endconference: 'Ukončiť konferenciu',
    conferenceRequested: 'Žiadosť o konferenciu',
    switchCall: 'Prepnúť',
    mergeCall: 'Zlúčiť',
    wrapup: 'Kompletizácia',
    end: 'Ukončiť',
    customername: 'Meno zákazníka',
    dn: 'DNIS',
    ivrpath: 'Cesta IVR',
    email: 'E-mail zákazníka',
    ani: 'Telefónne číslo',
    queueid: 'Názov frontu',
    ronatimeout: 'Čas Rona',
    pathid: 'ID cesty IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'Agent DN',
    destagentname: 'Meno agenta',
    virtualteamname: 'Front',
    category: 'Kategória',
    additionaldetails: 'Ďalšie podrobnosti',
    sourcenumber: 'Zdrojové číslo',
    sourcepage: 'Zdrojová stránka',
    appuser: 'ID používateľa aplikácie',
    customernumber: 'Telefónne číslo',
    exitconference: 'Opustiť konferenciu',
    resume: 'Obnoviť',
    pauserecording: 'Pozastaviť nahrávanie',
    resumerecording: 'Pokračovať v nahrávaní',
    exitconsult: 'Odísť z konzultácie',
    pauseRecordingFailed: 'Pozastavenie nahrávania nie je možné. Skúste to znova.',
    resumeRecordingFailed: 'Opätovné spustenie nahrávania nie je možné. Skúste to znova.',
    holdCallFailed: 'Hovor sa nedá podržať. Skúste to znova.',
    resumeCallFailed: 'V hovore nemožno pokračovať. Skúste to znova.',
    endCallFailed: 'Nepodarilo sa ukončiť interakciu. Skúste to znova.',
    consultTransferFailed:
      'Nie je možné preniesť konzultačný hovor. Skúste to znova.',
    conferenceTransferFailed:
      'Nepodarilo sa preniesť konferenčný hovor. Skúste to znova.',
    conferenceFailed:
      'Žiadosť o konferenciu sa nedá prepojiť. Skúste to znova.',
    consultEndFailed: 'Nemožno ukončiť žiadosť o konzultáciu. Skúste to znova.',
    conferenceExitFailed:
      'Nemožno ukončiť žiadosť o konferenciu. Skúste to znova.',
    conferenceEndFailed:
      'Nemožno ukončiť žiadosť o konferenciu. Skúste to znova.',
    cancelCtqFailed:
      'Nepodarilo sa zrušiť konzultačný hovor do frontu. Skúste to znova.',
    privacyShield: 'Privacy Shield',
    errorOnPrvacyShieldForConsult:
      'Nahrávanie je momentálne pozastavené. Na spustenie konzultačného hovoru pokračujte v nahrávaní.',
    errorOnPrvacyShieldForTransfer:
      'Nahrávanie je momentálne pozastavené. Na spustenie preneseného hovoru pokračujte v nahrávaní.',
    cancelConsult: 'Zrušiť konzultáciu',
    cancelTransfer: 'Zrušiť prenos',
    copy: 'Kopírovať',
    copied: 'Skopírované',
    cadrequestuccess: 'Informácie o zákazníkovi sa úspešne uložili.',
    cadrequestfailure: 'Nepodarilo sa uložiť informácie o zákazníkovi. Skúste to znova.',
    cadupdatedmessage: 'Informácie o zákazníkovi sa nedávno aktualizovali',
    unsavedmessage: 'Vaše neuložené zmeny sa prepísali.',
    save: 'Uložiť',
    revert: 'Návrat',
    expandDetails: 'Rozbaliť podrobnosti',
    collapseDetails: 'Zbaliť podrobnosti',
    cadValidationError:
      'Neplatný formát. Použite medzinárodný štandard pre dátum a čas.',
    secureCadSaveError:
      'Informácie o zákazníkovi sa neukladajú. Kliknete na možnosť Uložiť, alebo ak to chcete skúsiť znova.',
    secureDecryptionError: 'Zabezpečené premenné nemožno zobraziť.',
    clickToTry: 'Kliknutím sem zopakujte',
    isSecureVariable: 'je zabezpečená premenná',
    contactorigin: 'Pôvod kontaktu',
    resumeMonitoring: 'Pokračovať v monitorovaní',
    pauseMonitoring: 'Pozastaviť monitorovanie',
    whisperCoach: 'Šepkajúci tréner',
    bargeIn: 'Pridať sa',
    endMonitoring: 'Ukončiť monitorovanie',
    contactphonenumber: 'Telefónne číslo kontaktu',
    contactqueue: 'Front kontaktov',
    activeparticipants: 'Aktívni účastníci',
    consultedparticipant: 'Konzultovaný účastník',
    contactstatus: 'Stav kontaktu',
    timeincontactstatus: 'Čas v stave kontaktu',
    totalcontactduration: 'Celkové trvanie kontaktu',
    agentinteractiontime: 'Trvanie interakcie',
    recording: 'Nahrávanie',
    monitoring: 'Monitorovanie',
    monitoringPaused: 'Monitorovanie pozastavené',
    pauseMonitoringFailed: 'Pozastavenie monitorovania nie je možné. Skúste to znova.',
    resumeMonitoringFailed: 'Pokračovanie v monitorovaní nie je možné. Skúste to znova.',
    callCancelledInProgress: 'Prebieha rušenie hovoru',
    bargedIn: 'Pristupované',
    keypad: 'Klávesnica',
    mute: 'Stlmiť',
    unmute: 'Zapnúť zvuk',
    bargeInTooltipText:
      'Mikrofón sa zapne a vy sa pripojíte k tejto interakcii zákazníka',
    bargeInCompactTooltipText:
      'Prístup: Mikrofón sa zapne a vy sa pripojíte k tejto interakcii zákazníka',
    bargeInTooltipDisabled: 'Pokračujte v monitorovaní, čím povolíte prístup',
    bargeInFailedTitle: 'Prístup neúspešný',
    bargeInFailedData:
      'Počas pokusu o prístup sa vyskytla chyba. Skúste to znova neskôr.',
    supervisorBargedIn: 'sa zapojil(-a) do vášho hovoru.',
    leftInteraction: 'opustil(-a) interakciu.',
    conferenceEnded: 'Konferenčný hovor sa skončil.',
    participants: 'Účastníci',
    badgeAriaLabel: '{participant} je na linke',
    bargeInConferenceAriaLabel: 'V interakcii sú dvaja účastníci',
    taskName: 'Názov úlohy riadenia interakcie',
    interactionDurationLabel: 'Čas trvania',
    wrapupassist: 'Pomoc pri kompletizácii',
    consultingTaskContext: 'Konzultačný hovor od',
    consultExited: 'Konzultovať ukončený hovor',
    endCall: 'Ukončite hovor.',
    exitconferenceCall:
      'Ukončite hovor a konferencia bude pokračovať s aktívnymi účastníkmi.',
    recordingInProgess: 'Prebieha záznam',
    recordingPaused: 'Záznam pozastavený',
    searchPlaceholder: 'Vyhľadať kontakty',
    postCall: "Po skončení hovoru",
    switchCallTooltip: "Prepnúť na hovor",
    switchConsultTooltip: "Prepnúť na konzultačný hovor",
    switchConferenceTooltip: "Prepnúť na konferenčný hovor",
    confirmationDialog: {
      endCallTitle: 'Želáte si ukončiť volanie?',
      endCallMessage: 'Kliknutím na tlačidlo Potvrdiť ukončíte volanie pre všetkých účastníkov.',
      exitConferenceTitle: 'Želáte si ukončiť konferenčný hovor?',
      exitConferenceMessage:
        'Kliknutím na tlačidlo Potvrdiť ukončíte konferenčný hovor a umožníte ostatným účastníkom pokračovať.',
      confirmButtonLabel: "Potvrdiť",
      cancelButtonLabel: "Zrušiť",  
    },
    postCallOnHold: "Hovor je podržaný",
    postCallConsult: "Konzultácia po hovore",
    postCallConsultOnHold: "Konzultácia po hovore je pozdržaná",
  },
  agentProfile: {
    teamName: 'Tím',
    dialNumber: 'Telefónne číslo',
    phoneNumber: 'Telefónne číslo',
    settings: 'Zmeniť nastavenia',
    signOut: 'Odhlásiť sa',
    webRTCDisconnected: 'Varovanie: Telefonovanie na ploche je odpojené ',
    msAuthFailed: 'Overenie spoločnosti Microsoft zlyhalo',
    stateSyncFailed: 'Synchronizácia stavu zlyhala',
    userProfileLabel: 'Používateľský profil',
    ariaAgentprofile: 'Profil agenta',
    ChannelCapacity: 'Kapacita kanála',
    voice: 'Hlas',
    chat: 'Konverzácia',
    email: 'E-mail',
    social: 'Sociálne médium',
    channelCapacityTooltip: 'Kliknutím zobrazíte viac',
    blendedRouting: 'Zmiešané',
    exclusiveRouting: 'Exkluzívne smerovanie',
    realtimeRouting: 'Zmiešané smerovanie v reálnom čase',
    blendedRoutingTooltip: 'Spracúvajte viaceré kontakty naprieč kanálmi.',
    exclusiveRoutingTooltip: 'Naraz spracovávajte iba jeden kontakt.',
    realtimeRoutingTooltip: 'Spracúvajte jeden povinný kanál v reálnom čase.',
    errorActiveContacts:
      'Teraz sa nemôžete odhlásiť, pretože máte aktívne konverzácie. Dokončite ich a potom to skúste znova.',
    searchTeams: 'Vyhľadať tímy',
    changeTeamsConfirmHeader: 'Potvrdenie zmeny tímu',
    changeTeamsConfirmMessage: 'Naozaj si želáte zmeniť svoj tím?',
    changeTeamLabel: 'Zmeniť tím',
    errorChangeTeams:
      'Teraz nemožno zmeniť tím, pretože máte aktívne požiadavky. Dokončite ich a skúste to znova.',
    saveTeamSelection: 'Uložiť výber tímu',
    userSettings: 'Používateľské nastavenia',
    resetLayout: 'Obnoviť celé rozloženie plochy',
    resetConfirmHeader: 'Obnoviť potvrdenie rozloženia',
    resetConfirmMessage:
      'Želáte si obnoviť celé rozloženie plochy? <br/> Plocha sa vráti do predvoleného rozloženia.',
    downloadLogs: 'Správa chýb sťahovania',
    help: 'Pomocník',
    signoutConfirm: 'Naozaj sa chcete odhlásiť?',
    signoutConfirmHeader: 'Potvrdenie odhlásenia',
    darkTheme: 'Prepnúť na tmavý režim',
    newLook: 'Prepnutie na nový vzhľad',
    keyboardShortcuts: 'Klávesové skratky',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Nastavenia oznámenia',
    silentNotification: 'Tiché oznámenie',
    enableNotificationSettings: 'E-mailové oznámenia',
    enableSilentNotificationSettings: 'Aktivovať tiché oznámenia',
    suppressWebexCallingNotificationSettings: 'Skryť oznámenia Webex Calling',
    notificationSettingDescription:
      'Dodáva oznámenia, akými sú nové správy, výstrahy a zmeny stavu.',
    silentNotificationDescription:
      'Vypne upozornenia na obrazovke. Môžete si zobraziť oznámenia v centre oznámení.',
    suppressWebexCallingNotificationDescription: 
    'Nezobrazovať kontextové oznámenia na prichádzajúce hovory Webex a odpovedať na ne prostredníctvom kontaktného centra Webex.',
    arrowLabel: 'Prejsť späť',
    managedTeams: 'Spravované tímy',
    managedTeamsError: 'Nepodarilo sa načítať tímy.',
    viewAll: 'Zobraziť Všetko',
    profileSettings: 'Nastavenia profilu',
    userRole: 'Rola',
    saveSelection: 'Uložiť výber',
    extension: 'Klapka',
    changeProfileConfirmHeader: 'Potvrdiť zmeny nastavení profilu',
    changeProfileConfirmMessage:
      'Naozaj chcete uložiť zmeny profilu?',
    confirm: 'Potvrdiť',
    errorProfileUpdate:
      'Teraz nemožno zmeniť nastavenia profilu, pretože máte aktívne požiadavky. Dokončite ich a skúste to znova.',
    roleAgentSupervisor: 'Nadriadený a agent',
    roleSupervisor: 'Nadriadený',
    noTeam: 'Žiadny tím',
    testYourNetwork: 'Otestujte sieť',
    speakerAndMic: 'Reproduktor a mikrofón',
    speaker: 'Reproduktor',
    mic: 'Mikrofón',
    speakerDescription:
      'Vyberte a otestujte výstupné zariadenie, aby ste sa uistili, že počujete volajúceho.',
    micDescription:
      'Vyberte a otestujte vstupné zariadenie, aby ste sa uistili, že vás volajúci bude počuť.',
    micError:
      'Prístup k mikrofónu je odmietnutý. Umožnite prístup prostredníctvom nastavení prehľadávača alebo sa obráťte na správcu.',
    speakerError:
      'Reproduktor je momentálne nedostupný, pretože prístup k mikrofónu je odmietnutý.',
    telephony: 'Telefonovanie',
    desktop: 'Pracovná plocha',
    onSpeakerPlay:
      'Ak testovací zvuk nepočujete, skontrolujte reproduktor.',
    onMicPlay:
      'Ak testovací zvuk nepočujete, skontrolujte reproduktor aj mikrofón.',
    onMicRecord: 'Nahrajte správu pre prehrávanie.',
    test: 'Test',
    recording: 'Nahrávanie',
    playing: 'Prehráva sa',
    reconnecting: 'Obnovuje sa pripojenie.',
    disconnectMessage:
      'Telefonovanie na ploche je odpojené. Vyskúšajte inú možnosť telefonovania.',
    singleTelephonyDisconnectMessage:
      'Telefonovanie na ploche je odpojené. Obráťte sa na správcu.',
    clear: 'Vyčistiť vstup',
    rememberMeCheckBoxMessage: "Znova nezobrazovať",
    saveLabel: 'Uložiť',
    browserUnsupportedError: "Prihlásenie zlyhalo, pretože používate nepodporovaný prehliadač.",
    microphoneAccessDeniedError: "Prístup k mikrofónu je odmietnutý. Umožnite prístup prostredníctvom nastavení prehľadávača alebo sa obráťte na správcu.",
  },
  contactHistory: {
    mainHeader: 'História kontaktu',
    handledBy: 'Spracoval',
    noRecordFound: 'Nenašla sa žiadna história kontaktu.',
    tryAgain: 'Skúste to znova',
    errorMsg: 'Nepodarilo sa načítať históriu kontaktov. Skúste to znova.',
    errorID: 'ID chyby',
    missingAni: 'Chýba ANI',
    timeIcon: 'Trvanie',
    taskHandled: 'Úloha bola vybavená',
    noHistoryNew: 'Žiadna história',
    noHistory: 'Žiadna História',
    viewTranscript: 'Zobraziť e-mailovú správu',
    transcriptFor: 'Prepisy pre',
    editBeforeCall: 'Upraviť pred hovorom',
    clickToCall: 'Zavolajte kliknutím',
    onAnActiveCallErrorMessage:
      'Nový hovor nemôžete iniciovať, keďže už máte aktívny hovor.',
    receivedFrom: 'Kontakt prijatý od',
    initiatedTo: 'Kontakt iniciovaný na',
    wrapUpReason: 'Dôvod kompletizácie',
    startCallTelephony:
      'Kliknutím na odkaz na telefónne číslo spustíte výstupný hovor.',
    contactHistoryList: 'Zoznam histórie kontaktov,',
    wrapUpCode: 'Kód kompletizácie',
    agentName: 'Meno agenta',
    entryPointName: 'Vstupný bod',
    acceptedTimeAndDate: 'Prijatý čas a dátum',
    duration: 'Trvanie',
    emailTranscript: 'Odoslať prepis emailom',
    clickToViewEmailTranscript: 'Kliknutím zobrazíte prepis e-mailu',
    listContainer: 'Kontajner zoznamu'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Vstupný bod',
    date: 'Dátum',
    subject: 'Predmet',
    from: 'Od',
    sent: 'Odoslané',
    to: 'Do',
    back: 'Späť',
    errorTranscript: 'Vyskytla sa chyba pri získavaní prepisov',
    customer: 'Zákazník',
    inboundErrorMessage: 'E-mail zákazníka sa nepodarilo načítať',
    outboundErrorMessage: 'Odpoveď agenta sa nepodarilo načítať'
  },
  popoverTitle: {
    callback: 'Spätné volanie',
    outboundCall: 'Výstupný hovor',
    incomingCall: 'Výstražný hovor',
    progressiveCampaign: 'Hovor kampane',
    courtesyCallback: 'Zdvorilostný spätný hovor',
    chat: 'Prichádzajúca konverzácia',
    incoming: 'Prichádzajúce',
    monitoringCall: 'Monitorovanie hovoru'
  },
  connecting: 'Prebieha pripájanie',
  initiating: 'Spúšťa sa',
  outbound: 'Odchádzajúce',
  transfer: {
    title: 'Žiadosť o prenos',
    heading: {
      chat: 'Vyberte agenta alebo front, do ktorého sa má vykonať prenos.',
      email: 'Vyberte front, do ktorého sa má vykonať prenos.',
      telephony:
        'Vyberte agenta, front alebo číslo na vytočenie, do ktorého sa má vykonať prenos.',
      noQueueTelephony:
        'Vyberte agenta alebo číslo na vytočenie, do ktorého sa má vykonať prenos.'
    },
    header: {
      chat: 'Vyberte si agenta alebo front na prepojenie tohto kontaktu.',
      email: 'Vyberte front na prepojenie kontaktu.',
      telephony:
        'Vyberte agenta, front, číslo na vytočenie alebo organizáciu na prepojenie tohto kontaktu.',
      noQueueTelephony:
        'Vyberte agenta, číslo na vytočenie alebo organizáciu na prepojenie tohto kontaktu.',
      noOrganizationTelephony:
        'Vyberte agenta, front alebo číslo na vytočenie na prepojenie tohto kontaktu.',
      noQueueOrganizationTelephony:
        'Vyberte agenta alebo číslo na vytočenie na prepojenie tohto kontaktu.'
    },
    queues: 'Front',
    agents: 'Agent',
    dialNumber: 'Telefónne číslo',
    organization: 'Organizácia',
    placeholder: {
      Queues: 'Vybrať zo zoznamu frontov',
      Agents: 'Vybrať zo zoznamu agentov',
      DialNumber: 'Vyberte podľa mena alebo čísla',
      DialNumberOrEntryPoint: 'Vybrať podľa mena/čísla/vstupného bodu',
      ChooseByNameOrNumber: 'Vybrať podľa mena/čísla',
      Organization: 'Vyhľadávanie podľa mena/roly/oddelenia/služobného telefónu',
      WebexOrganization: 'Hľadať podľa mena alebo e-mailu',
      DialNumberSearch: 'Hľadať podľa mena alebo čísla'
    },
    type: 'Prenos',
    cancel: 'Zrušiť',
    closeModal: 'Zavrieť modálne okno',
    failureError: 'Nepodarilo sa preniesť požiadavku. Skúste to znova.',
    entryPoint: 'Vstupný bod'
  },
  consult: {
    title: 'Žiadosť o konzultáciu',
    heading: {
      chat: 'Vyberte agenta alebo front, do ktorého sa má vykonať prenos.',
      email: 'Vyberte front, do ktorého sa má vykonať prenos.',
      telephony:
        'Vyberte agenta, front alebo číslo na vytočenie, s ktorými chcete vykonať konzultáciu.',
      noQueueTelephony:
        'Vyberte agenta alebo číslo na vytočenie, s ktorými chcete vykonať konzultáciu.'
    },
    header: {
      chat: 'Vyberte si agenta alebo front na prepojenie tohto kontaktu.',
      email: 'Vyberte front na prepojenie kontaktu.',
      telephony:
        'Vyberte agenta, front, číslo na vytočenie alebo organizáciu, s ktorými chcete vykonať konzultáciu.',
      noQueueTelephony:
        'Vyberte agenta, číslo na vytočenie alebo organizáciu, s ktorými chcete vykonať konzultáciu.',
      noOrganizationTelephony:
        'Vyberte agenta, front alebo číslo na vytočenie, s ktorými chcete vykonať konzultáciu.',
      noQueueOrganizationTelephony:
        'Vyberte agenta alebo číslo na vytočenie, s ktorými chcete vykonať konzultáciu.'
    },
    queues: 'Front',
    agents: 'Agent',
    dialNumber: 'Telefónne číslo',
    organization: 'Organizácia',
    placeholder: {
      Queues: 'Vybrať zo zoznamu frontov',
      Agents: 'Vybrať zo zoznamu agentov',
      DialNumber: 'Vyberte podľa mena alebo čísla',
      DialNumberOrEntryPoint: 'Vybrať podľa mena/čísla/vstupného bodu',
      ChooseByNameOrNumber: 'Vybrať podľa mena/čísla',
      Organization: 'Vyhľadávanie podľa mena/roly/oddelenia/služobného telefónu',
      WebexOrganization: 'Hľadať podľa mena alebo e-mailu',
      DialNumberSearch: 'Hľadať podľa mena alebo čísla'
    },
    type: 'Konzultovať',
    checkBoxLabel: 'Umožnite účastníkom pokračovať v interakcii.',
    cancel: 'Zrušiť',
    closeModal: 'Zavrieť modálne okno',
    failureError: 'Žiadosť o konzultáciu sa nedá prepojiť. Skúste to znova.',
    customerLeftMsg: 'Zákazník je odpojený. Konzultácia už nie je potrebná.',
    ctqFailureMsg:
      'Nepodarilo sa zrušiť konzultačný hovor do frontu. Skúste to znova.',
    cancelCtqInfo:
      'Vyhľadávanie dostupného agenta vo vybratom fronte. Počkajte alebo zrušte požiadavku na konzultáciu.',
    cancelCtqAction: 'Zrušiť konzultáciu.',
    entryPoint: 'Vstupný bod'
  },
  conference: {
    title: 'Žiadosť o konferenciu',
    heading: {
      chat: 'Vyberte konkrétneho agenta pre konferenčnú konverzáciu'
    },
    queues: 'Front',
    agents: 'Agent',
    dialNumber: 'Telefónne číslo',
    organization: 'Organizácia',
    placeholder: {
      Queues: 'Vybrať zo zoznamu frontov',
      Agents: 'Vybrať zo zoznamu agentov',
      DialNumber: 'Vyberte podľa mena alebo čísla'
    },
    type: 'Konferencia',
    cancel: 'Zrušiť',
    closeModal: 'Zavrieť modálne okno',
    failureError: 'Nepodarilo spustiť požiadavku na konferenciu. Skúste to znova.'
  },
  transferModal: {
    Agents: 'Nemožno načítať zoznam agentov. Obnovte zoznam.',
    AgentsEmpty: 'Nie je dostupný žiadny agent',
    Queues: 'Nemožno načítať zoznam frontov. Obnovte zoznam.',
    QueuesEmpty: 'Nie je dostupný žiadny front',
    EPEmpty: 'Nie je k dispozícii žiadny vstupný bod',
    DialNumber:
      'Nemožno načítať zoznam čísel vytáčania z adresára. Obnovte zoznam.',
    EntryPoint:
      'Nepodarilo sa načítať zoznam čísel vstupných bodov. Obnovte zoznam.',
    Common: 'Nepodarilo sa načítať zoznam. Obnovte zoznam.',
    DialNumberEmpty: 'Nie je dostupné žiadne číslo na vytočenie',
    DialNumbInvalid:
      'Vytočené číslo nie je platné. Kontaktujte správcu.',
    DialNumbOrEntryPointInvalid:
      'Neplatné volané číslo/vstupný bod. Obráťte sa na správcu.',
    refreshQueueList: 'Obnovenie zoznamu frontov',
    refreshAgentList: 'Obnovenie zoznamu agentov',
    refreshEpList: 'Obnovenie vstupných bodov',
    refreshAddressBook: 'Obnovenie adresára',
    refreshTheList: 'Obnovenie zoznamu',
    entryPointSectionLabel: 'Vstupný bod',
    addressBookSectionLabel: 'Adresár',
    organization: 'Organizácia',
    comboBoxAriaLabelAgent: 'Vybrať zo zoznamu agentov',
    comboBoxAriaLabelQueue: 'Vybrať zo zoznamu frontov',
    comboBoxAriaLabelEp: 'Vyberte si zo zoznamu vstupných bodov',
    infScrollAgent: 'Hľadať agentov',
    infScrollQueue: 'Fronty hľadania',
    infScrollEP: 'Hľadať vstupné body',
    allRadioButtonHidedTextForConsult: 'Nemáte priradené žiadne entity, ktoré by konzultovali túto interakciu. Obráťte sa na správcu.',
    allRadioButtonHidedTextForTransfer: 'Nemáte priradené žiadne entity, ktoré by prepájali túto interakciu. Obráťte sa na správcu.',
    allRadioButtonHidedTextForConference: 'Nemáte priradené žiadne entity, ktoré by zabezpečili konferenčné spojenie tejto interakcie. Obráťte sa na správcu.',
    searchMinCharError: 'Na vyhľadávanie zadajte minimálne tri znaky.',
  },
  wrapup: {
    cancelautowrapup: 'Zrušiť automatickú kompletizáciu',
    wrapupreason: 'Dôvod kompletizácie',
    untilautowrapup: 'do automatickej kompletizácie',
    followupsetting: 'Nastavenie následnej činnosti',
    lastagentroute: 'Posledné smerovanie agenta',
    submitwrapup: 'Odoslať kompletizáciu',
    wrapupsearch: 'Vyhľadať dôvod kompletizácie',
    invalidationError: 'Kompletizáciu sa nepodarilo odoslať',
    searchResult: 'Dostupné výsledky vyhľadávania',
    noResultFound: 'Nenašli sa žiadne výsledky vyhľadávania',
    listContainerLabel: 'Kontajner so súhrnným zoznamom',
    searchError: 'Na vyhľadávanie dôvodov skončenia zadajte minimálne tri znaky.',
  },

  outdial: {
    call: 'Volať',
    dialpadSearch: 'Zadajte číslo na vytočenie',
    addressSearch: 'Vyhľadať podľa mena/čísla',
    addressTab: 'Adresa',
    addressTabTooltip: 'Hľadať v knihe adries',
    dialpadTab: 'Klávesnica na vytáčanie',
    dialpadTooltip: 'Vytočte číslo',
    searchTab: 'Hľadať',
    searchTabTooltip:'Vyhľadávanie ľudí v mojej organizácii',
    noAdrFound: 'Nenašli sa žiadne zhody',
    noContacts: 'Žiadne kontakty',
    mainIconTooltip: 'Hovor s vytáčaním',
    errorOutdialFailed:
      'Vytočený hovor zlyhal. Ploche sa nepodarilo prepojiť hovor, prípadne hovor príjemca nezdvihol.',
    errorOutdialDisabled: 'Vytáčanie hovorov je vypnuté',
    errorDialPadValidationMessage: 'Nesprávny formát',
    outdialReqInProgress: 'Prebieha vytáčaný hovor',
    outdialAniPlaceholder: 'Vybrať vytáčanie ANI',
    outdialAniLabel: 'ANI vytáčania',
    outdialAniPlaceHolder: 'Vyhľadať vytáčanie ANI',
    errorDcCallsLimitExceeded:
      'Údajové centrum dosiahlo maximálny limit pre vytáčané hovory. Nie je možné realizovať žiadne ďalšie vytáčané hovory',
    errorOrgCallsLimitExceeded:
      'Organizácia dosiahla maximálny limit pre vytáčané hovory. Nie je možné realizovať žiadne ďalšie vytáčané hovory.',
    errorOutDialNoAnswerFromCustomer:
      'Zákazník neprijal váš hovor. Skúste zavolať neskôr.',
    errorOutDialCustomerUnavailable:
      'Zákazník nie je momentálne dostupný. Skúste zavolať neskôr.',
    errorOutDialAgentEnds: 'Ukončili ste hovor so zákazníkom.',
    errorOutDialCustomerBusy: 'Zákazník je momentálne zaneprázdnený. Skúste zavolať neskôr.',
    searchError: 'Ak chcete prehľadávať kontakty, zadajte minimálne tri znaky.',
    upArrowLabel: 'Rozbaliť',
    clear: 'Vyčistiť vstup',
    outdialDialogDescription: 'Momentálne ste v dialógovom okne s kartami.'
  },

  organization: {
    noMatchFound: 'Nenašli sa žiadne zhody',
    searchError: 'Ak chcete prehľadávať kontakty, zadajte minimálne tri znaky.',
    authError: 'Žiadne kontakty na zobrazenie. Overenie Microsoftu zlyhalo.'
  },

  interactionPopover: {
    of: 'z',
    accept: 'Prijať',
    acceptAriaLabel: 'Prijať úlohu {taskNumber} – {taskType} od {from}',
    requests: 'Žiadosti',
    back: 'späť',
    next: 'ďalej',
    acceptMultipleRequest: 'Prijať žiadosti ({requestCount})',
    paginationDetail: '{indexStart}-{indexEnd} z {totalPopoverpoolLength}',
    hidePopoverDetails: 'Skryť podrobnosti vo vyskakovacom okne',
    showPopoverDetails: 'Zobraziť podrobnosti vo vyskakovacom okne',
    customerName: 'Meno zákazníka',
    email: 'E-mail',
    queueName: 'Názov frontu',
    failedToAccept: 'Nepodarilo sa prijať.',
    unableToAccept: 'Nemožno prijať kontakt.',
    failedToEnd: 'Nepodarilo sa ukončiť.',
    unableToEnd: 'Nemožno ukončiť kontakt. ',
    ringing: 'Zvonenie',
    calling: 'Prebieha hovor',
    phoneNumber: 'Telefónne číslo',
    dni: 'DNIS',
    ivrPathId: 'ID cesty IVR',
    pathId: 'ID cesty',
    rona: 'Vyzváňa bez odpovede',
    sourcePage: 'Zdrojová stránka',
    sourceNumber: 'Zdrojové číslo',
    appUserId: 'ID používateľa aplikácie',
    acceptAll: 'Prijať všetky úlohy',
    agentDn: 'Agent DN',
    agentName: 'Meno agenta',
    agentTeam: 'Tím agentov',
    requestDetails: 'Podrobnosti o žiadosti',
    incomingCallFrom: 'Prichádzajúci hovor od',
    unableToAnswer: 'Hovor nemožno prijať. Skúste to znova.',
    unableToDecline: 'Hovor nemožno odmietnuť. Skúste to znova.'
  },

  multiLogin: {
    header: 'Výstraha na viacero prihlásení',
    message:
      'K ploche ste sa prihlásili vo viacerých inštanciách aplikácie. Kliknutím na možnosť Pokračovať prejdite na plochu v tejto inštancii aplikácie. V opačnom prípade toto okno zatvorte.',
    continue: 'Pokračovať'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Prenos do vstupného bodu/frontu zlyhal v dôsledku chyby konfigurácie.',
    1010: "Nie je možné konzultovať, pretože agent nemohol byť pridelený včas. ",
    1042: "Kontakt sa nenašiel",
    1043: 'Cieľové umiestnenie je neplatné.',
    1045: 'Interakcia nie je priradená agentovi.',
    1046: 'Konzultácia agenta zlyhala, pretože v systéme nebol nájdený žiadny zodpovedajúci kanál agenta.',
    1038: "Agent sa nenašiel",
    1037: 'Prihlásenie zlyhalo v dôsledku internej chyby.',

    // Media Events
    138: 'Akcia zlyhala v dôsledku neznámych príčin.',
    136: 'Používateľ sa nenašiel',

    // AgentConsultFailed
    1050: 'Nie je možné konzultovať z dôvodu nepodporovanej konfigurácie alebo aktivity v toku. ',
    1005: "Nie je možné konzultovať, pretože agent neodpovedal na požiadavku včas.",
    1051: 'Nie je možné konzultovať ani preniesť v dôsledku neplatného vstupného bodu alebo vytáčaného čísla.',

    // AgentInviteFailed
    1053: 'Interakciu nemožno zobraziť z dôvodu nevybavenej úlohy opätovného zaradenia pracovného postupu do frontu.',
    1054: 'Nie je možné uskutočniť vonkajšie volanie z dôvodu problémov s médiami pri tejto požiadavke. ',

    // AgentContactAssignFailed
    1011: 'Nie je možné prijať hovor z dôvodu chýbajúcich agentov v prebiehajúcej interakcii. ',

    // ContactCallbackFailed
    1034: 'Spätné volanie kontaktu zlyhalo, pretože pre požiadavku bola prijatá odpoveď ContactParkTimeout.',

    // ContactUpdateFailed
    1020: "Nie je možné aktualizovať premenné, pretože jedna z hodnôt prekročila limit 256 znakov. Znížte počet znakov a skúste to znova.",

    // AgentInviteFailed
    1031: 'Agent pozval zákazníka po vyžiadaní spätného volania.',

    // AgentBlindTransferFailedEvent
    1044: 'Prepojenie agenta naslepo zlyhalo, pretože cieľový agent je priradený k inej interakcii.',

    // AgentCtqCancelFailed
    1047: "Kontakt sa nenašiel.",

    // AgentCtqFailed
    1048: "Skupina na distribúciu volaní nie je nakonfigurovaná.",
    1049: 'Prekročil sa maximálny čas čakania vo fronte.',
    // StationLoginFailed
    127: 'Registrácia DN agenta zlyhala na základe výnimky duplicitného prihlásenia.'
  },

  stateSelector: {
    Available: 'Dostupné',
    errorstatechange: 'Zmena stavu nebola úspešná. Skúste to znova.',
    errorStateChangeInPendingLogout: 'Zmena stavu agenta zlyhala z dôvodu čakajúceho odhlásenia.',
    label: 'Stav dostupnosti',
    agentStateSelector: 'Výber stavu agenta',
    Engaged: 'Obsadené',
    engagedAvailableInfo:
      'Práve komunikujete a ste v stave Dostupný.',
    engagedIdleInfo:
      'Práve komunikujete a ste v stave Nečinný',
    engagedInfo: 'Aktuálne sa zúčastňujete interakcie.',
    engagedSupervisorStateChange: 'vám zmenil(-a) stav na',
    axAgentStateChanged: 'Váš stav sa zmenil na',
    axAgentSync: 'v dôsledku synchronizácie stavu s vaším nástrojom na spoluprácu.',
    engagedPresenceInfo:
      'Momentálne ste zapojení do interakcie a váš stav je',
    engagedPresenceSync: 'v dôsledku synchronizácie stavu s vaším nástrojom na spoluprácu.',
    clear: 'Vyčistiť vstup',
    searchState: 'vstup',
    agentStatusLabel: 'Stav agenta',
    agentStateLabel: 'Agent je v stave {selectedState} poslednom čase: {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Agent bol posledných 0 sekúnd v stave {selectedState}',
    agentStateChangeSuccessful:'Zmena stavu na úspešný {selectedState}.',
    agentStateChangeFail:'Zmena stavu na {selectedState} sa nepodarila.',
    searchError: 'Na vyhľadanie stavov zadajte minimálne tri znaky.'
  },

  warningMessage: {
    header: 'Neuložené zmeny',
    message:
      'Na tejto stránke máte neuložené zmeny. Želáte si opustiť túto stránku? ',
    cancelButton: 'Zostať',
    saveButton: 'Odísť'
  },

  notificationLables: {
    muteVolume: 'Stlmiť hlasitosť oznámení',
    unmuteVolume: 'Zrušiť stlmenie hlasitosti oznámení',
    notificationVolume: 'Hlasitosť oznámení',
    playSound: 'Prehrať zvuk oznámenia',
    enableSoundNotificationSettings: 'Aktivovať zvukové oznámenia',
    enableSoundNotificationSettingsDescription:
      'Ponúka zvukové oznámenia pre prichádzajúce požiadavky. Nižšie môžete upraviť hlasitosť.',
    volumeTitle: 'Hlasitosť zvuku'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Volať',
    chat: 'Konverzácia',
    email: 'E-mail',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Obchodné správy Google"
  },
  orgDetailsLabels: {
    role: 'Rola',
    department: 'Oddelenie',
    email: 'Email',
    businessPhone: 'Služobný telefón',
    workPhone: 'Práca',
  },
  addressListError: {
    title: 'Nepodarilo sa načítať údaje',
    errorId: 'ID chyby:'
  },
  keypad: {
    keyPadSearch: 'Zadajte číslo.',
    dialPad: 'Číselník'
  },
  collabTool: {
    userAuthenticated: 'Overenie používateľa:',
    successful: 'Úspešné',
    failed: 'Neúspešné.',
    tryAgain: 'Skúste to znova',
    stateSync: 'Synchronizácia stavu:',
    mercuryFailedInfo: ' Obráťte sa na správcu.',
    retrying: 'Prebieha opätovný pokus...',
    trackingIdLabel: 'ID sledovania: '
  },
  webex: {
    webex: 'Webex',
    info: 'Integrácia umožňuje synchronizovať stavy medzi plochou a Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Pomocou tejto integrácie môžete konzultovať alebo prepájať hovory na používateľov Microsoft Teams.',
    authenticationFailedInfo:
      'Ak je okno overenia už otvorené, skúste overenie vykonať znova v tomto okne.',
    ListItemContactDetails:
      'Meno kontaktu je: {name}, jeho prítomnosť je: {presence}, oddelenie je: {department}, pracovná pozícia je: {jobTitle} a telefónne číslo je: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Oznámenie núdzovej služby',
    readNotification: 'Prečítal/-a som si oznámenie.'
  },
  webexPresenceStatus: {
    active: 'Aktívny',
    lastActiveFewMinutesAgo: 'Aktívne v posledných minútach',
    lastActiveMinutesAgo: 'Aktívny pred {min} min.',
    lastActive1HourAgo: 'Posledná aktivita pred 1 hodinou',
    lastActiveHoursAgo: 'Aktívny pred {hour} hod.',
    lastActiveYesterday: 'Aktívny včera',
    lastActiveOnDate: 'Aktívny {date}',
    busy: 'Zaneprázdnený',
    busyUntil: 'Zaneprázdnený až {date}',
    dnd: 'Nerušiť',
    dndUntil: 'Nerušiť do {date}',
    quiet: 'Tichý',
    quietUntil: 'Tichý až do {date}',
    ooo: 'Mimo kancelárie',
    outOfOfficeUntil: 'Mimo kancelárie do {date}',
    call: 'Má hovor',
    meeting: 'Na schôdzi',
    calendarItem: 'Na kalendárnej schôdzi',
    presenting: 'Prezentuje',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Vyhľadávanie podľa mena alebo podrobností profilu',
    webexPlaceholder: 'Hľadať podľa mena alebo e-mailu',
    refreshTheList: 'Obnovenie zoznamu',
    refreshAddressBook: 'Obnovenie adresára',
    microsoftAuthError: 'Žiadne kontakty na zobrazenie. Overenie Microsoftu zlyhalo.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/sl.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/sl.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Podatkov ni bilo mogoče naložiti',
    errorID: 'ID napake',
    tryAgain: 'Poskusite znova',
    Error: 'Napaka',
    okButton: 'V redu',
    Yes: 'Da',
    Cancel: 'Prekliči',
    Confirm: 'Potrdi',
    Continue: 'Nadaljuj',
    Canceling: 'Preklic',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: 'Odgovori',
    AnswerAriaLabel: 'Opravilo namizja za odgovore',
    Decline: 'Zavrni',
    ErrorSecurityCompliance: 'Varnostna skladnost',
    errorDetails: 'Podrobnosti o napaki',
    learnMore: 'Več informacij',
    showLess: 'Pokaži manj',
    trackingIdDescription:
      'ID sledenja posredujte skrbniku spletnega mesta ali ekipi za podporo, ki bo raziskala situacijo.',
    trackingIdInputLabel: 'ID za sledenje: ',
    submitForm: 'Pošlji obrazec',
    unnamedStatus: 'Neimenovano stanje',
    errorChatMsg: 'Podatkov klepeta ni mogoče naložiti',
    noOptions: 'Ni možnosti',
    noResults: 'Ni rezultatov',
    more: 'Več',
    nomatchfound: 'Ni najdenih ujemanj',
    collaborationTool: 'Orodje za sodelovanje',
    timerAriaLabel: 'Porabljen čas',
    historyItemTime: 'Zgodilo se je ob',
    loading: 'Nalaganje',
    months: [
      'januar',
      'februar',
      'marec',
      'april',
      'maj',
      'junij',
      'julij',
      'avgust',
      'september',
      'oktober',
      'november',
      'december'
    ],
    loadingMsg: 'Nalaganje ...',
    search: 'Iskanje',
    historyChannelLabels: {
      All: 'Vse',
      telephony: 'Glasovno',
      chat: 'Klepet',
      email: 'E-pošta',
      social: 'Družbeno'
    },
    homePageLabel: 'Domača stran',
    resizeHistoryDragger: 'Spreminjanje velikosti orodja za vlečenje zgodovine',
    agentHistoryLabel: 'zgodovina posrednika',
    clear: 'Počisti vnos',
    ariaLabelAgentHistoryWrapper:
      'Zgodovina interakcij s posredniki prikazuje vašo nedavno komunikacijo s strankami v različnih kanalih v zadnjih 24 urah.',
    sliderResizerInstructions:
      'Trenutno ste na drsniku. Za spreminjanje velikosti uporabite puščične tipke',
    resizeHistoryPanel: 'Spreminjanje velikosti plošče z zgodovino, drsnik',
    time: {
      hours: 'uro',
      minutes: 'min',
      seconds: 's'
    }
  },
  email: {
    ToLabel: 'Za',
    FromLabel: 'Od',
    CcLabel: 'Kp',
    BccLabel: 'Skp',
    SubjectLabel: 'Zadeva',
    HideLabel: 'Skrij',
    SendLabel: 'Pošlji',
    ShowPrevThread: 'Prikaži prejšnjo nit',
    HidePrevThread: 'Skrij prejšnjo nit',
    ReplyLabel: 'Odgovori',
    ReplyAllLabel: 'Odgovori vsem',
    ViewOriginalMail: 'Ogled izvirnega e-poštnega sporočila',
    QuickReplyInp: 'Hitro odgovorite tukaj ...',
    AttachFiles: 'Priložite datoteke',
    ToolbarHeading: 'Glava1',
    ToolbarBold: 'Krepko',
    ToolbarItalic: 'Ležeče',
    ToolbarUnderLine: 'Podčrtano',
    ToolbarBlockQuote: 'Blockquote',
    ToolbarCode: 'Blok kode',
    ToolbarListOrder: 'Prikaži seznam glede na naročeno',
    ToolbarListBullet: 'Prikaži seznam glede na alinejo',
    ToolbarLink: 'Povezava',
    ToolbarStrike: 'Prečrtano',
    ToolbarColor: 'Barva besedila',
    ToolbarTable: 'Tabela',
    insertTable: 'Vstavi tabelo',
    insertRowAbove: 'Vstavi vrstico nad',
    insertRowBelow: 'Vstavi vrstico pod',
    insertColumnLeft: 'Vstavi stolpec levo',
    insertColumnRight: 'Vstavi stolpec desno',
    deleteRow: 'Izbriši vrstico',
    deleteColumn: 'Izbriši stolpec',
    deleteTable: 'Izbriši tabelo',
    link: 'Povezava',
    IndentRight: 'Zamik desno',
    IndentLeft: 'Zamik levo',
    showMoreAttachment: 'Pokaži več prilog',
    AttachmentLimit: 'Priloži do ',
    attachments: ' priloge, ',
    sizeLimit: ' MB največ',
    attachment: 'Priloga',
    errordeleteattachment: 'Datotek ni bilo mogoče izbrisati. Poskusite znova.',
    errordownloadattachment: 'Datotek ni bilo mogoče prenesti. Poskusite znova.',
    erroraddattachemnt: 'Datotek ni bilo mogoče naložiti. Poskusite znova.',
    errorendcontact: 'Interakcije ni mogoče končati. Poskusite znova.',
    erroraddlimitreached:
      'Datoteke ni bilo mogoče priložiti, ker presega največjo velikost ',
    errorattachmentdrop:
      'Priloge so izpuščene v skladu z varnostnim pravilnikom podjetja.',
    errorfiletype: 'Vrsta datoteke ni podprta. Poskusite znova.',
    errorcreditcard:
      'Prilog ni bilo mogoče naložiti v skladu z varnostnim pravilnikom podjetja.',
    errorcontainsimage:
      'Prilog ni bilo mogoče naložiti. Varnostni pravilnik podjetja ne podpira slik v prilogah.',
    errorlimit: ' MB omejitev.',
    errorsendemail: 'E-pošte ni mogoče poslati. Poskusite znova.',
    errorpcicheckemail: 'Podatkov PCI ni mogoče dobiti. Poskusite znova.',
    errortext: 'Podatkov ni bilo mogoče naložiti',
    tryAgain: 'Poskusite znova',
    replywarning:
      'Z drugimi ne delite nobenih finančnih, zdravstvenih ali drugih osebnih podatkov v tem sporočilu ali prilogah.',
    datamasked:
      'Zadeva ali telo e-poštnega sporočila sta maskirana v skladu z varnostnim pravilnikom podjetja. Ali ste prepričani, da ga želite poslati?',
    pcibannerwarning:
      'Zadeva ali telo e-poštnega sporočila sta maskirana v skladu z varnostnim pravilnikom podjetja.',
    on: 'Vklop',
    wrote: 'je napisal(-a)'
  },
  interaction_control: {
    windowOpened: 'Okno je odprto',
    connected: 'Povezano',
    consultRequested: 'Posvetovanje zahtevano',
    consulting: 'Posvetovanje',
    consultCallOnHold: 'Posvetovalni klic na čakanju',
    callOnHold: 'Klic na čakanju',
    consult: 'Posvetovanje',
    endconsult: 'Končaj posvetovanje',
    hold: 'Zadrži',
    transfer: 'Prenesi',
    conference: 'Konferenčni klic',
    endconference: 'Konec konference',
    conferenceRequested: 'Zahtevana je konferenca',
    switchCall: 'Preklopi',
    mergeCall: 'Združi',
    wrapup: 'Zaključek',
    end: 'Končaj',
    customername: 'Ime stranke',
    dn: 'DNS',
    ivrpath: 'Pot za IVR',
    email: 'Strankina e-pošta',
    ani: 'Telefonska številka',
    queueid: 'Ime čakalne vrste',
    ronatimeout: 'Čas Rona',
    pathid: 'ID poti za IVR',
    dnis: 'DNS',
    destagentphonenumber: 'DN zastopnika',
    destagentname: 'Ime zastopnika',
    virtualteamname: 'Čakalna vrsta',
    category: 'Kategorija:',
    additionaldetails: 'Dodatne podrobnosti',
    sourcenumber: 'Izvorna številka',
    sourcepage: 'Izvorna stran',
    appuser: 'ID uporabnika za aplikacijo',
    customernumber: 'Telefonska številka',
    exitconference: 'Izhod iz konference',
    resume: 'Nadaljuj',
    pauserecording: 'Ustavi snemanje',
    resumerecording: 'Nadaljuj snemanje',
    exitconsult: 'Končaj posvetovanje',
    pauseRecordingFailed: 'Snemanja ni mogoče začasno ustaviti. Poskusite znova.',
    resumeRecordingFailed: 'Snemanja ni mogoče nadaljevati. Poskusite znova.',
    holdCallFailed: 'Klica ni mogoče zadržati. Poskusite znova.',
    resumeCallFailed: 'Klica ni mogoče nadaljevati. Poskusite znova.',
    endCallFailed: 'Interakcije ni mogoče končati. Poskusite znova.',
    consultTransferFailed:
      'Posvetovalnega klica ni mogoče prenesti. Poskusite znova.',
    conferenceTransferFailed:
      'Konferenčnega klica ni mogoče prenesti. Poskusite znova.',
    conferenceFailed:
      'Zahteve za konferenco ni mogoče povezati. Poskusite znova.',
    consultEndFailed: 'Zahteve za posvetovanje ni mogoče končati. Poskusite znova.',
    conferenceExitFailed:
      'Zahteve za konferenco ni mogoče zapreti. Poskušajte znova.',
    conferenceEndFailed:
      'Zahteve za konferenco ni mogoče končati. Poskusite znova.',
    cancelCtqFailed:
      'Posvetovalnega klica v čakalno vrsto ni mogoče preklicati. Poskusite znova.',
    privacyShield: 'Zasebnostni ščit',
    errorOnPrvacyShieldForConsult:
      'Snemanje je začasno ustavljeno. Nadaljujte ga, če želite začeti posvetovalni klic.',
    errorOnPrvacyShieldForTransfer:
      'Snemanje je začasno ustavljeno. Nadaljujte ga, če želite začeti prenos klica.',
    cancelConsult: 'Preklic posvetovanja',
    cancelTransfer: 'Preklic prenosa',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    cadrequestuccess: 'Podatki o stranki so uspešno shranjeni.',
    cadrequestfailure: 'Podatkov o stranki ni bilo mogoče shraniti. Poskusite znova pozneje.',
    cadupdatedmessage: 'Podatke o stranki je pred nedavnim posodobil(-a)',
    unsavedmessage: 'Neshranjene spremembe so prepisane.',
    save: 'Shrani',
    revert: 'Povrni',
    expandDetails: 'Razširi podrobnosti',
    collapseDetails: 'Strni podrobnosti',
    cadValidationError:
      'Neveljavna oblika zapisa. Uporabite mednarodni standard za datum in uro.',
    secureCadSaveError:
      'Podatki o stranki niso shranjeni. Kliknite »Shrani«, da poskusite znova.',
    secureDecryptionError: 'Varnih spremenljivk ni mogoče prikazati.',
    clickToTry: 'Kliknite za vnovični poskus',
    isSecureVariable: 'je varna spremenljivka',
    contactorigin: 'Izvor stika',
    resumeMonitoring: 'Nadaljuj nadzorovanje',
    pauseMonitoring: 'Zaustavi nadzorovanje',
    whisperCoach: 'Usposabljanje s šepetanjem',
    bargeIn: 'Vskoči',
    endMonitoring: 'Zaključi nadzorovanje',
    contactphonenumber: 'Telefonska številka za stik',
    contactqueue: 'Čakalna vrsta stika',
    activeparticipants: 'Akitvni sodelujoči',
    consultedparticipant: 'Klicani sodelujoči',
    contactstatus: 'Stanje stika',
    timeincontactstatus: 'Čas v stanju stika',
    totalcontactduration: 'Skupno trajanje stika',
    agentinteractiontime: 'Trajanje interakcije',
    recording: 'Snemanje',
    monitoring: 'Nadzorovanje',
    monitoringPaused: 'Spremljanje zaust.',
    pauseMonitoringFailed: 'Spremljanja ni mogoče začasno ustaviti. Poskusite znova.',
    resumeMonitoringFailed: 'Spremljanja ni mogoče nadaljevati. Poskusite znova.',
    callCancelledInProgress: 'Preklic klica v teku',
    bargedIn: 'Vskočil(-a)',
    keypad: 'Tipkovnica',
    mute: 'IzkZv',
    unmute: 'Vklop zvoka',
    bargeInTooltipText:
      'Mikrofon se bo vklopil in pridružili se boste tej interakciji s strankami.',
    bargeInCompactTooltipText:
      'Vskok: mikrofon se bo vklopil in pridružili se boste tej interakciji s strankami.',
    bargeInTooltipDisabled: 'Nadaljujte spremljanje, da omogočite vskok',
    bargeInFailedTitle: 'Vskok ni uspel',
    bargeInFailedData:
      'Med poskusom vskoka je prišlo do napake. Poskusite znova čez nekaj časa.',
    supervisorBargedIn: 'je vskočil(-a) v vaš klic.',
    leftInteraction: 'je zapustil(-a) interakcijo.',
    conferenceEnded: 'Konferenčni klic je končan.',
    participants: 'Sodelujoči',
    badgeAriaLabel: '{participant} je v klicu',
    bargeInConferenceAriaLabel: 'V interakciji sta dva udeleženca',
    taskName: 'Ime opravila kontrolnika interakcije',
    interactionDurationLabel: 'Trajanje',
    wrapupassist: 'Pomoč pri zaključevanju',
    consultingTaskContext: 'Posvetovalni klic od',
    consultExited: 'Izhod iz posvetovalnega klica',
    endCall: 'Končajte klic.',
    exitconferenceCall:
      'Zapustite klic in konferenca se nadaljuje z aktivnimi udeleženci.',
    recordingInProgess: 'Snemanje poteka',
    recordingPaused: 'Snemanje zač. ustavljeno',
    searchPlaceholder: 'Iskanje stikov',
    postCall: "Po klicu",
    switchCallTooltip: "Preklopi na klic",
    switchConsultTooltip: "Preklopi na posvetovalni klic",
    switchConferenceTooltip: "Preklopi na konferenčni klic",
    confirmationDialog: {
      endCallTitle: 'Ali želite končati klic?',
      endCallMessage: 'Kliknite »Potrdi«, da končate klic za vse udeležence.',
      exitConferenceTitle: 'Ali želite izstopiti iz konferenčnega klica?',
      exitConferenceMessage:
        'Kliknite »Potrdi«, če želite izstopiti iz konferenčnega klica in drugim udeležencem dovoliti, da nadaljujejo.',
      confirmButtonLabel: "Potrdi",
      cancelButtonLabel: "Prekliči",  
    },
    postCallOnHold: "Na čakanju po klicu",
    postCallConsult: "Svetovanje po klicu",
    postCallConsultOnHold: "Svetovanje po klicu na čakanju",
  },
  agentProfile: {
    teamName: 'Ekipa',
    dialNumber: 'Klicna številka',
    phoneNumber: 'Telefonska številka',
    settings: 'Sprememba nastavitev',
    signOut: 'Izpis',
    webRTCDisconnected: 'Opozorilo: povezava namizne telefonije je prekinjena ',
    msAuthFailed: 'Microsoftovo preverjanje pristnosti ni uspelo',
    stateSyncFailed: 'Sinhronizacija stanja ni uspela',
    userProfileLabel: 'Uporabniški profil',
    ariaAgentprofile: 'Profil zastopnika',
    ChannelCapacity: 'Zmogljivost kanala',
    voice: 'Glasovno',
    chat: 'Klepet',
    email: 'E-pošta',
    social: 'Družbeno',
    channelCapacityTooltip: 'Kliknite, če želite videti več',
    blendedRouting: 'Kombinirano',
    exclusiveRouting: 'Ekskluzivno usmerjanje',
    realtimeRouting: 'Sprotno kombinirano usmerjanje',
    blendedRoutingTooltip: 'Obravnavajte več stikov prek vseh kanalov.',
    exclusiveRoutingTooltip: 'Obdelajte samo en stik hkrati.',
    realtimeRoutingTooltip: 'Obravnavajte en obvezen sprotni kanal.',
    errorActiveContacts:
      'Zdaj se ne morete izpisati, ker imate aktivne pogovore. Končajte jih in poskusite znova.',
    searchTeams: 'Iskanje ekip',
    changeTeamsConfirmHeader: 'Spreminjanje potrditve kipe',
    changeTeamsConfirmMessage: 'Ali ste prepričani, da želite spremeniti ekipo?',
    changeTeamLabel: 'Sprememba ekipa',
    errorChangeTeams:
      'Ekipe zdaj ne morete spremeniti, ker imate aktivne zahteve. Zaključite jih in nato poskusite znova.',
    saveTeamSelection: 'Shrani izbiro ekipe',
    userSettings: 'Nastavitve uporabnika',
    resetLayout: 'Ponastavitev celotne postavitve namizja',
    resetConfirmHeader: 'Potrditev ponastavitve postavitve',
    resetConfirmMessage:
      'Ali ste prepričani, da želite ponastaviti celotno namizno postavitev? <br/> Namizje se bo vrnilo na privzeto postavitev.',
    downloadLogs: 'Prenesite poročilo o napaki',
    help: 'Pomoč',
    signoutConfirm: 'Ali ste prepričani, da se želite izpisati?',
    signoutConfirmHeader: 'Potrditev izpisa',
    darkTheme: 'Preklop na temni način',
    newLook: 'Preklop na nov videz',
    keyboardShortcuts: 'Bližnjice na tipkovnici',
    keyboardShortcutCombination: 'Ctrl + Alt + F',
    errorReportCombination: 'Ctrl + Shift + 2',
    notificationSettings: 'Nastavitve obvestil',
    silentNotification: 'Tiho obvestilo',
    enableNotificationSettings: 'Omogoči obvestila',
    enableSilentNotificationSettings: 'Omogoči tiha obvestila',
    suppressWebexCallingNotificationSettings: 'Skrij obvestila za Webex Calling',
    notificationSettingDescription:
      'Prenese obvestila, kot so nova sporočila, opozorila in spremembe stanja.',
    silentNotificationDescription:
      'Izklopi zaslonska opozorila. Obvestila si lahko ogledate v središču za obvestila.',
    suppressWebexCallingNotificationDescription: 
    'Ne prikazujte pojavnih obvestil za dohodne klice Webex in nanje odgovarjajte prek središča Webex Contact Center.',
    arrowLabel: 'Nazaj',
    managedTeams: 'Upravljane ekipe',
    managedTeamsError: 'Ekip ni bilo mogoče naložiti.',
    viewAll: 'Prikaži vse',
    profileSettings: 'Nastavitve profila',
    userRole: 'Vloga',
    saveSelection: 'Shrani izbor',
    extension: 'Interna številka',
    changeProfileConfirmHeader: 'Potrditev sprememb nastavitev profila',
    changeProfileConfirmMessage:
      'Ali ste prepričani, da želite shraniti spremembe profila?',
    confirm: 'Potrdi',
    errorProfileUpdate:
      'Nastavitev profila zdaj ne morete spremeniti, ker imate aktivne zahteve. Zaključite jih in nato poskusite znova.',
    roleAgentSupervisor: 'Nadzornik in zastopnik',
    roleSupervisor: 'Nadzornik',
    noTeam: 'Ni ekipe',
    testYourNetwork: 'Preskusite svoje omrežje',
    speakerAndMic: 'Zvočnik in mikrofon',
    speaker: 'Zvočnik',
    mic: 'Mikrofon',
    speakerDescription:
      'Izberite in preskusite izhodno napravo, da poskrbite, da boste slišali klicatelja.',
    micDescription:
      'Izberite in preskusite vhodno napravo, da poskrbite, da vas bo klicatelj slišal.',
    micError:
      'Dostop do mikrofona je zavrnjen. Omogočite dostop prek nastavitev brskalnika ali pa se obrnite na skrbnika.',
    speakerError:
      'Zvočnik trenutno ni na voljo, ker je dostop do mikrofona zavrnjen.',
    telephony: 'Telefonija',
    desktop: 'Namizje',
    onSpeakerPlay:
      'Če ne slišite preskusnega zvoka, preverite zvočnik.',
    onMicPlay:
      'Če ne slišite preskusnega zvoka, preverite zvočnik in mikrofon.',
    onMicRecord: 'Posnemite sporočilo za predvajanje.',
    test: 'Preskus',
    recording: 'Snemanje',
    playing: 'Predvajanje',
    reconnecting: 'Ponovno vzpostavljanje povezave',
    disconnectMessage:
      'Povezava z namizno telefonijo je prekinjena. Poskusite z drugo možnostjo telefonije.',
    singleTelephonyDisconnectMessage:
      'Povezava z namizno telefonijo je prekinjena. Obrnite se na skrbnika.',
    clear: 'Počisti vnos',
    rememberMeCheckBoxMessage: "Tega ne kaži več",
    saveLabel: 'Shrani',
    browserUnsupportedError: "Vpis ni uspel, ker uporabljate nepodprt brskalnik.",
    microphoneAccessDeniedError: "Dostop do mikrofona je zavrnjen. Omogočite dostop prek nastavitev brskalnika ali pa se obrnite na skrbnika.",
  },
  contactHistory: {
    mainHeader: 'Zgodovina stika',
    handledBy: 'Obravnava:',
    noRecordFound: 'Zgodovina stikov ni na voljo.',
    tryAgain: 'Poskusite znova',
    errorMsg: 'Zgodovine stikov ni mogoče dobiti. Poskusite znova.',
    errorID: 'ID napake',
    missingAni: 'ANI manjka',
    timeIcon: 'Trajanje',
    taskHandled: 'Naloga obravnavana',
    noHistoryNew: 'Ni zgodovine',
    noHistory: 'Ni zgodovine',
    viewTranscript: 'Ogled e-poštnega sporočila',
    transcriptFor: 'Prepisi za',
    editBeforeCall: 'Uredi pred klicem',
    clickToCall: 'Kliknite za klic',
    onAnActiveCallErrorMessage:
      'Novega klica ne morete začeti, saj že sodelujete pri aktivnem klicu.',
    receivedFrom: 'Stik je prejet od',
    initiatedTo: 'Stik je bil vzpostavljen s/z',
    wrapUpReason: 'Razlog za zaključevanje',
    startCallTelephony:
      'Kliknite povezavo do telefonske številke, da začnete odhodni klic.',
    contactHistoryList: 'Seznam zgodovine stikov',
    wrapUpCode: 'Koda za zaključevanje',
    agentName: 'Ime zastopnika',
    entryPointName: 'Vstopna točka',
    acceptedTimeAndDate: 'Datum in ura sprejema',
    duration: 'Trajanje',
    emailTranscript: 'Pošlji prepis po e-pošti',
    clickToViewEmailTranscript: 'Kliknite za ogled prepisa e-pošte',
    listContainer: 'Vsebnik seznama'
  },
  contactTranscript: {
    agent: 'Zastopnik',
    entryPoint: 'Vstopna točka',
    date: 'Datum',
    subject: 'Zadeva',
    from: 'Od',
    sent: 'Poslano',
    to: 'Za',
    back: 'Nazaj',
    errorTranscript: 'Prišlo je do napake pri prenosu prepisov',
    customer: 'Stranka',
    inboundErrorMessage: 'Strankinega e-poštnega sporočila ni bilo mogoče naložiti',
    outboundErrorMessage: 'Zastopnikovega odgovora ni bilo mogoče naložiti'
  },
  popoverTitle: {
    callback: 'Povratni klic',
    outboundCall: 'Odhodni klic',
    incomingCall: 'Dohodni klic',
    progressiveCampaign: 'Klic akcije',
    courtesyCallback: 'Vljudnostni pov. klic',
    chat: 'Dohodni klepet',
    incoming: 'Dohodno',
    monitoringCall: 'Nadzor klicev'
  },
  connecting: 'Vzpostavljanje povezave',
  initiating: 'Začetek',
  outbound: 'Odhodno',
  transfer: {
    title: 'Zahteva za prenos',
    heading: {
      chat: 'Izberite zastopnika ali čakalno vrsto, na katero želite prenesti.',
      email: 'Izberite čakalno vrsto, na katero želite prenesti.',
      telephony:
        'Izberite zastopnika, čakalno vrsto ali klicno številko, na katero želite prenesti.',
      noQueueTelephony:
        'Izberite zastopnika ali klicno številko, na katero želite prenesti.'
    },
    header: {
      chat: 'Izberite posrednika ali čakalno vrsto za preusmeritev tega stika.',
      email: 'Izberite čakalno vrsto za preusmeritev tega stika.',
      telephony:
        'Izberite posrednika, čakalno vrsto, klicno številko ali organizacijo za preusmeritev tega stika.',
      noQueueTelephony:
        'Izberite posrednika, klicno številko ali organizacijo za preusmeritev tega stika.',
      noOrganizationTelephony:
        'Izberite posrednika, čakalno vrsto ali klicno številko za preusmeritev tega stika.',
      noQueueOrganizationTelephony:
        'Izberite posrednika ali klicno številko za preusmeritev tega stika.'
    },
    queues: 'Čakalna vrsta',
    agents: 'Zastopnik',
    dialNumber: 'Klicna številka',
    organization: 'Organizacija',
    placeholder: {
      Queues: 'Izberite na seznamu čakalnih vrst',
      Agents: 'Izberite na seznamu zastopnikov',
      DialNumber: 'Izberite po imenu ali številki',
      DialNumberOrEntryPoint: 'Izberite glede na ime/število/vstopno točko',
      ChooseByNameOrNumber: 'Izberite po imenu/številki',
      Organization: 'Iskanje po imenu/vlogi/oddelku/službenem telefonu',
      WebexOrganization: 'Iskanje po imenu ali e-poštnem naslovu',
      DialNumberSearch: 'Iskanje po imenu ali številki'
    },
    type: 'Prenesi',
    cancel: 'Prekliči',
    closeModal: 'Zapri modalno okno',
    failureError: 'Zahteve ni mogoče prenesti. Poskusite znova.',
    entryPoint: 'Vstopna točka'
  },
  consult: {
    title: 'Posvetovanje – zahteva',
    heading: {
      chat: 'Izberite zastopnika ali čakalno vrsto, na katero želite prenesti.',
      email: 'Izberite čakalno vrsto, na katero želite prenesti.',
      telephony:
        'Izberite zastopnika, čakalno vrsto ali klicno številko, s katero se želite posvetovati.',
      noQueueTelephony:
        'Izberite zastopnika ali klicno številko, s katero se želite posvetovati.'
    },
    header: {
      chat: 'Izberite posrednika ali čakalno vrsto za preusmeritev tega stika.',
      email: 'Izberite čakalno vrsto za preusmeritev tega stika.',
      telephony:
        'Izberite posrednika, čakalno vrsto, klicno številko ali organizacijo, s katero se želite posvetovati.',
      noQueueTelephony:
        'Izberite posrednika, klicno številko ali organizacijo, s katero se želite posvetovati.',
      noOrganizationTelephony:
        'Izberite zastopnika, čakalno vrsto ali klicno številko, s katero se želite posvetovati.',
      noQueueOrganizationTelephony:
        'Izberite zastopnika ali klicno številko, s katero se želite posvetovati.'
    },
    queues: 'Čakalna vrsta',
    agents: 'Zastopnik',
    dialNumber: 'Klicna številka',
    organization: 'Organizacija',
    placeholder: {
      Queues: 'Izberite na seznamu čakalnih vrst',
      Agents: 'Izberite na seznamu zastopnikov',
      DialNumber: 'Izberite po imenu ali številki',
      DialNumberOrEntryPoint: 'Izberite glede na ime/število/vstopno točko',
      ChooseByNameOrNumber: 'Izberite po imenu/številki',
      Organization: 'Iskanje po imenu/vlogi/oddelku/službenem telefonu',
      WebexOrganization: 'Iskanje po imenu ali e-poštnem naslovu',
      DialNumberSearch: 'Iskanje po imenu ali številki'
    },
    type: 'Posvetovanje',
    checkBoxLabel: 'Udeležencem omogočite nadaljevanje interakcije.',
    cancel: 'Prekliči',
    closeModal: 'Zapri modalno okno',
    failureError: 'Zahteve za posvetovanje ni mogoče povezati. Poskusite znova.',
    customerLeftMsg: 'Stranka je prekinila povezavo. Posvetovanje ni več potrebno.',
    ctqFailureMsg:
      'Posvetovalnega klica v čakalno vrsto ni mogoče preklicati. Poskusite znova.',
    cancelCtqInfo:
      'Iskanje razpoložljivega zastopnika v izbrani čakalni vrsti. Počakajte ali prekličite zahtevo za posvetovanje.',
    cancelCtqAction: 'Preklic posvetovanja',
    entryPoint: 'Vstopna točka'
  },
  conference: {
    title: 'Zahteva za konferenco',
    heading: {
      chat: 'Izberite določenega zastopnika za konferenčni klepet'
    },
    queues: 'Čakalna vrsta',
    agents: 'Zastopnik',
    dialNumber: 'Klicna številka',
    organization: 'Organizacija',
    placeholder: {
      Queues: 'Izberite na seznamu čakalnih vrst',
      Agents: 'Izberite na seznamu zastopnikov',
      DialNumber: 'Izberite po imenu ali številki'
    },
    type: 'Konferenčni klic',
    cancel: 'Prekliči',
    closeModal: 'Zapri modalno okno',
    failureError: 'Zahteve za konferenco ni mogoče sprožiti. Poskusite znova.'
  },
  transferModal: {
    Agents: 'Seznama zastopnikov ni mogoče dobiti. Osvežite seznam.',
    AgentsEmpty: 'Ni razpoložljivega zastopnika',
    Queues: 'Seznama čakalnih vrst ni mogoče dobiti. Osvežite seznam.',
    QueuesEmpty: 'Ni razpoložljive čakalne vrste',
    EPEmpty: 'Na voljo ni nobena vstopna točka',
    DialNumber:
      'Seznama klicnih številk ni mogoče dobiti iz imenika. Osvežite seznam.',
    EntryPoint:
      'Seznama številk vstopnih toč ni mogoče pridobiti. Osvežite seznam.',
    Common: 'Seznama ni mogoče pridobiti. Osvežite seznam.',
    DialNumberEmpty: 'Ni razpoložljive klicne številke',
    DialNumbInvalid:
      'Klicna številka ni veljavna. Obrnite se na skrbnika.',
    DialNumbOrEntryPointInvalid:
      'Klicna številka/vstopna točka je neveljavna. Obrnite se na skrbnika.',
    refreshQueueList: 'Osveževanje seznama čakalnih vrst',
    refreshAgentList: 'Osveževanje seznama zastopnikov',
    refreshEpList: 'Osveži vstopne točke',
    refreshAddressBook: 'Osveževanje imenika',
    refreshTheList: 'Osveževanje seznama',
    entryPointSectionLabel: 'Vstopna točka',
    addressBookSectionLabel: 'Imenik',
    organization: 'Organizacija',
    comboBoxAriaLabelAgent: 'Izberite na seznamu zastopnikov',
    comboBoxAriaLabelQueue: 'Izberite na seznamu čakalnih vrst',
    comboBoxAriaLabelEp: 'Izberite na seznamu vstopnih točk',
    infScrollAgent: 'Iskanje posrednikov',
    infScrollQueue: 'Iskanje čakalnih vrst',
    infScrollEP: 'Iskanje vstopnih točk',
    allRadioButtonHidedTextForConsult: 'Nimate dodeljenih entitet za posvetovanje za to interakcijo. Obrnite se na skrbnika.',
    allRadioButtonHidedTextForTransfer: 'Nimate dodeljenih entitet za prenos za to interakcijo. Obrnite se na skrbnika.',
    allRadioButtonHidedTextForConference: 'Nimate dodeljenih entitet za konferenčni klic za to interakcijo. Obrnite se na skrbnika.',
    searchMinCharError: 'Vnesite vsaj tri znake za iskanje.',
  },
  wrapup: {
    cancelautowrapup: 'Prekliči samodejno zaključevanje',
    wrapupreason: 'Razlogi za zaključevanje',
    untilautowrapup: 'do samodejnega zaključevanja',
    followupsetting: 'Nastavitev za nadaljnje delo',
    lastagentroute: 'Zadnje usmerjanje zastopnika',
    submitwrapup: 'Pošlji zaključevanje',
    wrapupsearch: 'Iskanje razloga za zaključevanje',
    invalidationError: 'Zaključevanja ni bilo mogoče poslati',
    searchResult: 'Rezultati iskanja so na voljo',
    noResultFound: 'Ni rezultatov iskanja',
    listContainerLabel: 'Vsebnik seznama zaključevanj',
    searchError: 'Vnesite vsaj tri znake za iskanje razlogov za zaključevanje.',
  },

  outdial: {
    call: 'Pokliči',
    dialpadSearch: 'Vnesite številko za klic',
    addressSearch: 'Iskanje po imenu/številki',
    addressTab: 'Naslov',
    addressTabTooltip: 'Iskanje po imeniku',
    dialpadTab: 'Številčnica',
    dialpadTooltip: 'Klicanje številke',
    searchTab: 'Iskati',
    searchTabTooltip:'Iskanje posameznikov v moji organizaciji',
    noAdrFound: 'Ni najdenih ujemanj',
    noContacts: 'Ni stikov',
    mainIconTooltip: 'Odhodni klic',
    errorOutdialFailed:
      'Odhodni klic ni uspel. Namizje ni moglo vzpostaviti klica ali pa je bil ta neodgovorjen.',
    errorOutdialDisabled: 'Odhodni klici so onemogočeni',
    errorDialPadValidationMessage: 'Napačna oblika',
    outdialReqInProgress: 'Poteka odhodni klic',
    outdialAniPlaceholder: 'Izberite ANI za odhodni klic',
    outdialAniLabel: 'ANI za odhodni klic',
    outdialAniPlaceHolder: 'Išči ANI za odhodni klic',
    errorDcCallsLimitExceeded:
      'Podatkovno središče je doseglo največje dovoljeno število odhodnih klicev. Več odhodnih klicev ni mogoče izvesti.',
    errorOrgCallsLimitExceeded:
      'Organizacija je dosegla največje dovoljeno število odhodnih klicev. Več odhodnih klicev ni mogoče izvesti.',
    errorOutDialNoAnswerFromCustomer:
      'Stranka ni odgovorila na vaš klic. Poskusite jo poklicati pozneje.',
    errorOutDialCustomerUnavailable:
      'Stranka trenutno ni na voljo. Poskusite jo poklicati pozneje.',
    errorOutDialAgentEnds: 'Končali klic ste klic s stranko.',
    errorOutDialCustomerBusy: 'Stranka je trenutno zasedena. Poskusite jo poklicati pozneje.',
    searchError: 'Vnesite vsaj tri znake za iskanje stikov.',
    upArrowLabel: 'Razširi',
    clear: 'Počisti vnos',
    outdialDialogDescription: 'Trenutno ste v pogovornem oknu z zavihki.'
  },

  organization: {
    noMatchFound: 'Ni najdenih ujemanj',
    searchError: 'Vnesite vsaj tri znake za iskanje stikov.',
    authError: 'Ni stikov za prikaz. Microsoftovo preverjanje pristnosti ni uspelo.'
  },

  interactionPopover: {
    of: 'od',
    accept: 'Sprejmi',
    acceptAriaLabel: 'Sprejem opravila {taskNumber} {taskType} od: {from}',
    requests: 'Zahteve',
    back: 'nazaj',
    next: 'naprej',
    acceptMultipleRequest: 'Sprejmi zahteve ({requestCount})',
    paginationDetail: '{indexStart}-{indexEnd} od {totalPopoverpoolLength}',
    hidePopoverDetails: 'Skrij podrobnosti pojavnega okna',
    showPopoverDetails: 'Pokaži podrobnosti pojavnega okna',
    customerName: 'Ime stranke',
    email: 'E-pošta',
    queueName: 'Ime čakalne vrste',
    failedToAccept: 'Ni bilo sprejeto.',
    unableToAccept: 'Stika ni mogoče sprejeti.',
    failedToEnd: 'Končevanje ni uspelo.',
    unableToEnd: 'Stika ni mogoče končati. ',
    ringing: 'Zvonjenje',
    calling: 'Klicanje',
    phoneNumber: 'Telefonska številka',
    dni: 'DNS',
    ivrPathId: 'ID poti za IVR',
    pathId: 'ID poti',
    rona: 'RONA',
    sourcePage: 'Izvorna stran',
    sourceNumber: 'Izvorna številka',
    appUserId: 'ID uporabnika za aplikacijo',
    acceptAll: 'Sprejmi vsa opravila',
    agentDn: 'DN zastopnika',
    agentName: 'Ime telefonista',
    agentTeam: 'Ekipa zastopnika',
    requestDetails: 'Podrobnosti zahteve',
    incomingCallFrom: 'Dohodni klic od',
    unableToAnswer: 'Na klic ni mogoče odgovoriti. Poskusite znova.',
    unableToDecline: 'Klica ni mogoče zavrniti. Poskusite znova.'
  },

  multiLogin: {
    header: 'Opozorilo o večkratnem vpisu',
    message:
      'V namizje ste vpisani v več primerkih aplikacije. Kliknite Nadaljuj, če želite nadaljevati uporabo namizja v tem primerku aplikacije, sicer zaprite to okno.',
    continue: 'Nadaljuj'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Prenos na vstopno točko/čakalno vrsto ni uspel zaradi konfiguracijske napake.',
    1010: "Posvetovanje ni mogoče, ker posrednika ni bil mogoče pravočasno dodeliti. ",
    1042: "Stika ni mogoče najti",
    1043: 'Cilj je neveljaven.',
    1045: 'Interakcija ni dodeljena posredniku.',
    1046: 'Posvetovanje s posrednikom ni uspelo, ker v sistemu ni mogoče najti ujemajočega kanala posrednika.',
    1038: "Posrednika ni mogoče najti",
    1037: 'Vpis ni uspel zaradi notranje napake.',

    // Media Events
    138: 'Dejanje ni uspelo zaradi neznanih razlogov.',
    136: 'Uporabnika ni mogoče najti',

    // AgentConsultFailed
    1050: 'Posvetovanje ni mogoče zaradi nepodprte konfiguracije ali dejavnosti v toku. ',
    1005: "Posvetovanje ni mogoče zaradi, ker se posrednik ni pravočasno odzval na zahtevo.",
    1051: 'Posvetovanje ali prenos ni mogoč zaradi neveljavne vstopne točke ali klicane številke.',

    // AgentInviteFailed
    1053: 'Interakcije ni mogoče prikazati zaradi čakajočega opravila vnovičnega uvrščanja poteka dela v čakalno vrsto.',
    1054: 'Odhodnega klica ni mogoče vzpostaviti zaradi predstavnostnih težav s to zahtevo. ',

    // AgentContactAssignFailed
    1011: 'Na klic ni mogoče odgovoriti ali ga sprejeti, ker v tekoči interakciji manjkajo posredniki. ',

    // ContactCallbackFailed
    1034: 'Povratni klic ni uspel, ker je za zahtevo prejet ContactParkTimeout.',

    // ContactUpdateFailed
    1020: "Spremenljivk ni mogoče posodobiti, ker ena od vrednosti presega omejitev števila znakov (256). Zmanjšajte število znakov in poskusite znova.",

    // AgentInviteFailed
    1031: 'Posrednik je povabil stranko, potem ko je bil zahtevan povratni klic.',

    // AgentBlindTransferFailedEvent
    1044: 'Takojšnja preusmeritev posrednika ni uspela, ker je ciljni posrednik dodeljen drugi interakciji.',

    // AgentCtqCancelFailed
    1047: "Stika ni mogoče najti.",

    // AgentCtqFailed
    1048: "Skupina za distribucijo klicev ni konfigurirana.",
    1049: 'Najdaljši čas čakanja v čakalni vrsti je presežen.',
    // StationLoginFailed
    127: 'Registracija DN za posrednika ni uspela zaradi izjeme podvojene prijave.'
  },

  stateSelector: {
    Available: 'Na voljo',
    errorstatechange: 'Sprememba stanja ni bila uspešna. Poskusite znova.',
    errorStateChangeInPendingLogout: 'Sprememba stanja posrednika ni uspela zaradi čakajoče odjave.',
    label: 'Stanje razpoložljivosti',
    agentStateSelector: 'Izbirnik stanja posrednika',
    Engaged: 'Zaseden',
    engagedAvailableInfo:
      'Trenutno ste zasedeni s komunikacijo in ste v stanju razpoložljivosti.',
    engagedIdleInfo:
      'Trenutno ste zasedeni s komunikacijo in ste v stanju nedejavnosti',
    engagedInfo: 'Trenutno ste udeleženi v interakciji.',
    engagedSupervisorStateChange: 'je spremenil/-a vaše stanje v',
    axAgentStateChanged: 'Vaše stanje je spremenjeno v',
    axAgentSync: 'zaradi sinhronizacije stanja z vašim orodjem za sodelovanje.',
    engagedPresenceInfo:
      'Trenutno imate interakcijo in ste v stanju',
    engagedPresenceSync: 'zaradi sinhronizacije stanja z vašim orodjem za sodelovanje.',
    clear: 'Počisti vnos',
    searchState: 'vnos',
    agentStatusLabel: 'Stanje telefonista',
    agentStateLabel: 'Posrednik je zadnjih {selectedTimeValue} v stanju {selectedState}',
    agentStateLabelOnStateChange: 'Posrednik je zadnjih 0 sek. v stanju {selectedState}',
    agentStateChangeSuccessful:'Sprememba stanja v {selectedState} je uspela.',
    agentStateChangeFail:'Sprememba stanja v {selectedState} ni uspela.',
    searchError: 'Vnesite vsaj tri znake za iskanje zveznih držav.'
  },

  warningMessage: {
    header: 'Neshranjene spremembe',
    message:
      'Na tej strani imate neshranjene spremembe. Ali jo želite zares zapustiti? ',
    cancelButton: 'ostani',
    saveButton: 'Zapusti'
  },

  notificationLables: {
    muteVolume: 'Izklop glasnosti obvestil',
    unmuteVolume: 'Vnovični vklop zvoka obvestil',
    notificationVolume: 'Glasnost obvestil',
    playSound: 'Predvajaj zvok obvestila',
    enableSoundNotificationSettings: 'Omogoči zvočna obvestila',
    enableSoundNotificationSettingsDescription:
      'Prenese zvočna obvestila za dohodne zahteve. Glasnost lahko nastavite spodaj.',
    volumeTitle: 'Glasnost zvoka'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Pokliči',
    chat: 'Klepet',
    email: 'E-pošta',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google\'s Business Messages"
  },
  orgDetailsLabels: {
    role: 'Vloga',
    department: 'Oddelek',
    email: 'E-pošta',
    businessPhone: 'Službeni telefon',
    workPhone: 'Delo',
  },
  addressListError: {
    title: 'Podatkov ni bilo mogoče naložiti',
    errorId: 'ID napake:'
  },
  keypad: {
    keyPadSearch: 'Vnesite številko',
    dialPad: 'Številčnica'
  },
  collabTool: {
    userAuthenticated: 'Preverjanje pristnosti uporabnikov:',
    successful: 'Uspešno',
    failed: 'Neuspešno.',
    tryAgain: 'Poskusite znova',
    stateSync: 'Sinhronizacija stanja:',
    mercuryFailedInfo: ' Obrnite se na skrbnika.',
    retrying: 'Vnovični poskus ...',
    trackingIdLabel: 'ID za sledenje: '
  },
  webex: {
    webex: 'Webex',
    info: 'Integracija omogoča sinhronizacijo stanj med namizjem in storitvijo Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'S to integracijo lahko klice posredujete v posvetovanje ali jih prenesete uporabnikom storitve Microsoft Teams.',
    authenticationFailedInfo:
      'Če je okno za preverjanje pristnosti že odprto, poskušajte znova preveriti pristnost v njem.',
    ListItemContactDetails:
      'Ime stika: {name}. Njegova prisotnost: {presence}. Oddelek: {department}. Delovno mesto: {jobTitle}. Telefonska številka: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Obvestilo storitve za nujne primere',
    readNotification: 'Prebral(-a) sem obvestilo.'
  },
  webexPresenceStatus: {
    active: 'Dejavni',
    lastActiveFewMinutesAgo: 'Aktiven v zadnjih nekaj minutah',
    lastActiveMinutesAgo: 'Aktiven pred {min} min',
    lastActive1HourAgo: 'Zadnja aktivnost pred 1 uro',
    lastActiveHoursAgo: 'Aktiven pred {hour} h',
    lastActiveYesterday: 'Aktiven včeraj',
    lastActiveOnDate: 'Aktiven: {date}',
    busy: 'Zasedeno',
    busyUntil: 'Zaseden(-a) do: {date}',
    dnd: 'Ne moti',
    dndUntil: 'Ne moti do: {date}',
    quiet: 'Tiho',
    quietUntil: 'Tiho do: {date}',
    ooo: 'Odsotnost',
    outOfOfficeUntil: 'Odsotnost do: {date}',
    call: 'Sodeluje v klicu',
    meeting: 'Na sestanku',
    calendarItem: 'Na koledarskem sestanku',
    presenting: 'Trenutno predstavlja',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Iskanje po imenu ali podrobnostih profila',
    webexPlaceholder: 'Iskanje po imenu ali e-poštnem naslovu',
    refreshTheList: 'Osveževanje seznama',
    refreshAddressBook: 'Osveževanje imenika',
    microsoftAuthError: 'Ni stikov za prikaz. Microsoftovo preverjanje pristnosti ni uspelo.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/sr.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/sr.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Neuspešno učitavanje podataka',
    errorID: 'ID greške',
    tryAgain: 'Pokušajte ponovo',
    Error: 'Greška',
    okButton: 'U redu',
    Yes: 'Da',
    Cancel: 'Otkaži',
    Confirm: 'Potvrdi',
    Continue: 'Nastavi',
    Canceling: 'Otkazivanje',
    CiscoAiAssistant: 'Cisco AI pomoćnik',
    Answer: 'Odgovori',
    AnswerAriaLabel: 'Odgovor na zadatak na radnoj površini',
    Decline: 'Odbij',
    ErrorSecurityCompliance: 'Usklađenost za bezbednost',
    errorDetails: 'Detalji greške',
    learnMore: 'Saznajte više',
    showLess: 'Prikaži manje',
    trackingIdDescription:
      'Podelite ID za praćenje sa administratorom lokacije ili timom za podršku da biste ispitali situaciju.',
    trackingIdInputLabel: 'ID za praćenje: ',
    submitForm: 'Pošalji formular',
    unnamedStatus: 'Neimenovani status',
    errorChatMsg: 'Neuspešno učitavanje podataka ćaskanja',
    noOptions: 'Nema opcija',
    noResults: 'Nema rezultata',
    more: 'Dodatno',
    nomatchfound: 'Nisu pronađena poklapanja',
    collaborationTool: 'Alat za saradnju',
    timerAriaLabel: 'Potrošeno vreme',
    historyItemTime: 'Dogodilo se u',
    loading: 'Učitavanje',
    months: [
      'Januar',
      'Februar',
      'Mart',
      'April',
      'Maj',
      'Jun',
      'Jul',
      'Avgust',
      'Septembar',
      'Oktobar',
      'Novembar',
      'Decembar'
    ],
    loadingMsg: 'Učitavanje..',
    search: 'Pretraži',
    historyChannelLabels: {
      All: 'Sve',
      telephony: 'Glas',
      chat: 'Ćaskanje',
      email: 'E-adresa',
      social: 'Društveni'
    },
    homePageLabel: 'Početna stranica',
    resizeHistoryDragger: 'Promenite veličinu klizača za istoriju',
    agentHistoryLabel: 'istorija agenta',
    clear: 'Ukloni unos',
    ariaLabelAgentHistoryWrapper:
      'Istorija za interakciju agenta prikazuje komunikacije vašeg skorašnjeg klijenta na različitim kanalima u proteklih 24 sata',
    sliderResizerInstructions:
      'Trenutno ste na klizaču. Upotrebite tastere strelica za promenu veličine',
    resizeHistoryPanel: 'Promenite veličinu okna za istoriju, klizač.',
    time: {
      hours: 'sat',
      minutes: 'min.',
      seconds: 'sek.'
    }
  },
  email: {
    ToLabel: 'Za',
    FromLabel: 'Od',
    CcLabel: 'Cc',
    BccLabel: 'Bcc',
    SubjectLabel: 'Tema',
    HideLabel: 'Sakrij',
    SendLabel: 'Pošalji',
    ShowPrevThread: 'Prikaži prethodni niz',
    HidePrevThread: 'Sakrij prethodni niz',
    ReplyLabel: 'Odgovori',
    ReplyAllLabel: 'Odgovori svima',
    ViewOriginalMail: 'Pogledaj originalnu e-poštu',
    QuickReplyInp: 'Brzo odgovorite ovde...',
    AttachFiles: 'Priloži datoteke',
    ToolbarHeading: 'Naslov1',
    ToolbarBold: 'Podebljano',
    ToolbarItalic: 'Kurziv',
    ToolbarUnderLine: 'Podvučeno',
    ToolbarBlockQuote: 'Blokiranje navoda',
    ToolbarCode: 'Kod za blokiranje',
    ToolbarListOrder: 'Izlistaj po nalogu',
    ToolbarListBullet: 'Izlistaj po stavkama',
    ToolbarLink: 'Veza',
    ToolbarStrike: 'Precrtaj',
    ToolbarColor: 'Boja teksta',
    ToolbarTable: 'Tabela',
    insertTable: 'Ubaci tabelu',
    insertRowAbove: 'Ubaci red iznad',
    insertRowBelow: 'Ubaci red ispod',
    insertColumnLeft: 'Ubaci kolonu levo',
    insertColumnRight: 'Ubaci kolonu desno',
    deleteRow: 'Obriši red',
    deleteColumn: 'Obriši kolonu',
    deleteTable: 'Obriši tabelu',
    link: 'Veza',
    IndentRight: 'Razmak desno',
    IndentLeft: 'Razmak levo',
    showMoreAttachment: 'Prikaži još priloga',
    AttachmentLimit: 'Priloži do ',
    attachments: ' prilozi, ',
    sizeLimit: ' MB maksimum',
    attachment: 'Prilog',
    errordeleteattachment: 'Neuspešno brisanje datoteke(a). Pokušajte ponovo.',
    errordownloadattachment: 'Neuspešno preuzimanje datoteke(a). Pokušajte ponovo.',
    erroraddattachemnt: 'Neuspešno otpremanje datoteke(a). Pokušajte ponovo.',
    errorendcontact: 'Neuspešan prekid interakcije. Pokušajte ponovo.',
    erroraddlimitreached:
      'Datoteka nije mogla biti priložena jer prekoračuje maksimum ',
    errorattachmentdrop:
      'Prilog(zi) odbačen u skladu sa pravilnikom za bezbednost podataka kompanije.',
    errorfiletype: 'Tip datoteke nije podržan. Pokušajte ponovo.',
    errorcreditcard:
      'Neuspešno otpremanje priloga u skladu sa pravilnikom kompanije za bezbednost podataka.',
    errorcontainsimage:
      'Neuspešno otpremanje priloga. Slike u prilogu nisu podržani od strane bezbednosnog pravilnika kompanije.',
    errorlimit: ' MB ograničenje.',
    errorsendemail: 'Neuspešno slanje e-pošte. Pokušajte ponovo.',
    errorpcicheckemail: 'Nije moguće vratiti PCI podatke. Pokušajte ponovo.',
    errortext: 'Neuspešno učitavanje podataka',
    tryAgain: 'Pokušajte ponovo',
    replywarning:
      'Nemojte deliti finansijske, zdravstvene niti bilo koje lične identifikacione informacije (PII) u ovoj poruci ili prilozima.',
    datamasked:
      'Tema ili tekst poruke e-pošte sadrže podatke koji su redirigovani u skladu sa bezbednosnim pravilnikom kompanije. Da li ste sigurni d želite da pošaljete ovu poruku e-pošte?',
    pcibannerwarning:
      'Tema ili tekst e-pošte je redirigovan u skladu sa pravilnikom za bezbednost kompanije.',
    on: 'Na',
    wrote: 'upisao'
  },
  interaction_control: {
    windowOpened: 'Prozor je otvoren',
    connected: 'Povezano',
    consultRequested: 'Zatražena konsultacija',
    consulting: 'Konsultacija',
    consultCallOnHold: 'Konsultacija na čekanju',
    callOnHold: 'Poziv na čekanju',
    consult: 'Pokreni konsultaciju',
    endconsult: 'Završi konsultaciju',
    hold: 'Čekanje',
    transfer: 'Prenesi',
    conference: 'Konferencija',
    endconference: 'Završi konferenciju',
    conferenceRequested: 'Zahtev za konferenciju',
    switchCall: 'Prelazak',
    mergeCall: 'Objedini',
    wrapup: 'Završetak',
    end: 'Kraj',
    customername: 'Ime klijenta',
    dn: 'DNIS',
    ivrpath: 'IVR-putanja',
    email: 'E-adresa korisnika',
    ani: 'Broj telefona',
    queueid: 'Naziv reda za čekanje',
    ronatimeout: 'Rona vreme',
    pathid: 'IVR putanja ID',
    dnis: 'DNIS',
    destagentphonenumber: 'Agent DN',
    destagentname: 'Ime agenta',
    virtualteamname: 'Red za čekanje',
    category: 'Kategorija',
    additionaldetails: 'Dodatne informacije',
    sourcenumber: 'Izvorni broj',
    sourcepage: 'Izvorna stranica',
    appuser: 'ID korisnika aplikacije',
    customernumber: 'Broj telefona',
    exitconference: 'Izađi iz konferencije',
    resume: 'Nastavi',
    pauserecording: 'Pauziranje snimanja',
    resumerecording: 'Nastavak snimanja',
    exitconsult: 'Napusti konsultaciju',
    pauseRecordingFailed: 'Nije moguće pauzirati snimanje. Pokušajte ponovo.',
    resumeRecordingFailed: 'Nije moguće nastaviti snimanje. Pokušajte ponovo.',
    holdCallFailed: 'Nije moguće staviti poziv na čekanje. Pokušajte ponovo.',
    resumeCallFailed: 'Nije moguće nastaviti poziv. Pokušajte ponovo.',
    endCallFailed: 'Neuspešan prekid interakcije. Pokušajte ponovo.',
    consultTransferFailed:
      'Nije moguće preneti poziv za konsultaciju. Pokušajte ponovo.',
    conferenceTransferFailed:
      'Nije moguće preneti konferencijski poziv. Pokušajte ponovo.',
    conferenceFailed:
      'Nije moguće povezati zahtev za konferenciju. Pokušajte ponovo.',
    consultEndFailed: 'Nije moguće završiti zahtev za konsultaciju. Pokušajte ponovo.',
    conferenceExitFailed:
      'Nije moguće napustiti zahtev za konferenciju. Pokušajte ponovo.',
    conferenceEndFailed:
      'Nije moguće završiti zahtev za konferenciju. Pokušajte ponovo.',
    cancelCtqFailed:
      'Nije moguće otkazati poziv za konsultaciju u redu za čekanje. Pokušajte ponovo.',
    privacyShield: 'Zaštitnik privatnosti',
    errorOnPrvacyShieldForConsult:
      'Snimanje je trenutno pauzirano. Nastavite snimanje da biste pokrenuli poziv za konsultaciju.',
    errorOnPrvacyShieldForTransfer:
      'Snimanje je trenutno pauzirano. Nastavite snimanje da biste pokrenuli prenos poziva.',
    cancelConsult: 'Otkaži konsultaciju',
    cancelTransfer: 'Otkazivanje prenosa',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    cadrequestuccess: 'Informacije o korisniku su uspešno sačuvane.',
    cadrequestfailure: 'Neuspešno čuvanje informacija korisnika. Pokušajte ponovo kasnije.',
    cadupdatedmessage: 'Informacije o korisniku su skoro ažurirane od strane',
    unsavedmessage: 'Vaše nesačuvane poruke su prebrisane.',
    save: 'Sačuvaj',
    revert: 'Vrati',
    expandDetails: 'Proširi informacije',
    collapseDetails: 'Sklopi informacije',
    cadValidationError:
      'Pogrešan format. Upotrebite internacionalni standard za datum i vreme.',
    secureCadSaveError:
      'Informacije o klijentima nisu sačuvane. Kliknite na dugme "Sačuvaj" da biste pokušali ponovo.',
    secureDecryptionError: 'Nije moguće prikazati bezbedne promenljive.',
    clickToTry: 'Kliknite da biste pokušali ponovo',
    isSecureVariable: 'je bezbedna promenljiva',
    contactorigin: 'Poreklo kontakta',
    resumeMonitoring: 'Nastavi nadzor',
    pauseMonitoring: 'Pauziraj nadzor',
    whisperCoach: 'Šaputanje trenera',
    bargeIn: 'Upadni',
    endMonitoring: 'Završi nadzor',
    contactphonenumber: 'Broj telefona za kontakt',
    contactqueue: 'Red za čekanje za kontakt',
    activeparticipants: 'Aktivni učesnici',
    consultedparticipant: 'Konsultovani učesnik',
    contactstatus: 'Status kontakta',
    timeincontactstatus: 'Vreme u statusu kontakta',
    totalcontactduration: 'Ukupno trajanje kontakta',
    agentinteractiontime: 'Trajanje interakcije',
    recording: 'Snimanje',
    monitoring: 'Nadzor',
    monitoringPaused: 'Nadzor pauziran',
    pauseMonitoringFailed: 'Nije moguće pauzirati nadzor. Pokušajte ponovo',
    resumeMonitoringFailed: 'Nije moguće nastaviti nadzor. Pokušajte ponovo',
    callCancelledInProgress: 'Otkazivanje poziva u toku',
    bargedIn: 'Odbačeno u',
    keypad: 'Tastatura',
    mute: 'Priguši',
    unmute: 'Uklj ton',
    bargeInTooltipText:
      'Mikrofon će se uključiti i vi ćete se priključiti ovoj interakciji sa klijentom',
    bargeInCompactTooltipText:
      'Odbačeni dolazni. Mikrofon će se uključiti i vi ćete se priključiti ovoj interakciji sa klijentom',
    bargeInTooltipDisabled: 'Nastavite nadzor da biste omogućili odbacivanje dolaznih',
    bargeInFailedTitle: 'Odbacivanje dolaznih nije uspelo',
    bargeInFailedData:
      'Došlo je do greške dok ste pokušali odbacivanje dolaznih. Pokušajte ponovo kasnije.',
    supervisorBargedIn: 'je odbacio vaš poziv.',
    leftInteraction: 'je napustio interakciju.',
    conferenceEnded: 'Konferencijski razgovor je završen.',
    participants: 'Učesnici',
    badgeAriaLabel: '{participant} je u pozivu',
    bargeInConferenceAriaLabel: 'Postoje dva učesnika u interakciji',
    taskName: 'Interakcija za naziv za kontrolni zadatak',
    interactionDurationLabel: 'Vremensko trajanje',
    wrapupassist: 'Pomoć za zaključenje',
    consultingTaskContext: 'Konsultantski poziv od',
    consultExited: 'Konsultantski poziv je napušten',
    endCall: 'Prekini poziv.',
    exitconferenceCall:
      'Napusti poziv dok se konferencija nastavlja sa aktivnim učesnicima.',
    recordingInProgess: 'Snimanje je u toku',
    recordingPaused: 'Snimanje pauzirano',
    searchPlaceholder: 'Pretraga kontakata',
    postCall: "Nakon poziva",
    switchCallTooltip: "Prebacite se na poziv",
    switchConsultTooltip: "Prebacite se na poziv za konsultaciju",
    switchConferenceTooltip: "Prebacite se na konferencijski razgovor",
    confirmationDialog: {
      endCallTitle: 'Želite li da prekinete poziv?',
      endCallMessage: 'Kliknite na dugme Potvrdi da biste prekinuli poziv za sve učesnike.',
      exitConferenceTitle: 'Želite li da napustite konferencijski poziv?',
      exitConferenceMessage:
        'Kliknite na dugme Potvrdi da biste napustili konferencijski poziv i omogućili ostalim učesnicima da nastave.',
      confirmButtonLabel: "Potvrdi",
      cancelButtonLabel: "Otkaži",  
    },
    postCallOnHold: "Postavi poziv na čekanje",
    postCallConsult: "Postavi poziv na konsultacije",
    postCallConsultOnHold: "Postavi poziv za konsultacije na čekanje",
  },
  agentProfile: {
    teamName: 'Tim',
    dialNumber: 'Birani broj',
    phoneNumber: 'Broj telefona',
    settings: 'Promena podešavanja',
    signOut: 'Odjava',
    webRTCDisconnected: 'Upozorenje Desktop Telephony prekinut ',
    msAuthFailed: 'Microsoft autentifikacija nije uspela',
    stateSyncFailed: 'Sinhronizacija statusa nije uspela',
    userProfileLabel: 'Korisnički profil',
    ariaAgentprofile: 'Profil agenta',
    ChannelCapacity: 'Kapacitet kanala',
    voice: 'Glas',
    chat: 'Ćaskanje',
    email: 'E-adresa',
    social: 'Društveni',
    channelCapacityTooltip: 'Kliknite da vidite više',
    blendedRouting: 'Blendirano',
    exclusiveRouting: 'Ekskluzivno rutiranje',
    realtimeRouting: 'Izmešano rutiranje u realnom vremenu',
    blendedRoutingTooltip: 'Rukovanje višestrukim kontaktima širom svih kanala.',
    exclusiveRoutingTooltip: 'Rukujte samo jednim kontaktom istovremeno.',
    realtimeRoutingTooltip: 'Rukujte obaveznim kanalom u realnom vremenu.',
    errorActiveContacts:
      'Ne možete da se odjavite sada jer imate aktivne razgovore. Završite ih i pokušajte ponovo.',
    searchTeams: 'Pretraga timova',
    changeTeamsConfirmHeader: 'Promena potvrde tima',
    changeTeamsConfirmMessage: 'Da li ste sigurni da želite da promenite svoj tim?',
    changeTeamLabel: 'Promena tima',
    errorChangeTeams:
      'Ne možete da promenite tim sada jer imate aktivni zahtev(e). Obavite ih i pokušajte ponovo.',
    saveTeamSelection: 'Čuvanje izbora tima',
    userSettings: 'Postavke korisnika',
    resetLayout: 'Resetujte ceo raspored radne površine',
    resetConfirmHeader: 'Potvrda resetovanja sloja',
    resetConfirmMessage:
      'Da li ste sigurni da želite da resetujete ceo raspored radne površine? <br/> Radna površina će se vratiti na podrazumevani raspored.',
    downloadLogs: 'Preuzmi izveštaj o grešci',
    help: 'Pomoć',
    signoutConfirm: 'Da li ste sigurni da želite da se odjavite?',
    signoutConfirmHeader: 'Potvrda odjave',
    darkTheme: 'Prebacivanje u tamni režim',
    newLook: 'Prebacite se na novi izgled',
    keyboardShortcuts: 'Prečice na tastaturi',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Postavke obaveštenja',
    silentNotification: 'Tiha obaveštenja',
    enableNotificationSettings: 'Omogući obaveštenja',
    enableSilentNotificationSettings: 'Omogući tiha obaveštenja',
    suppressWebexCallingNotificationSettings: 'Sakrij obaveštenja za Webex Calling',
    notificationSettingDescription:
      'Dostavlja obaveštenja kao što su nove poruke, upozorenja i promene statusa.',
    silentNotificationDescription:
      'Isključuje upozorenja na ekranu. Možete da pogledate obaveštenja u centru za obaveštenja.',
    suppressWebexCallingNotificationDescription: 
    'Ne prikazujte iskačuća obaveštenja za dolazne Webex pozive i odgovorite na njih putem usluge Webex Contact Center.',
    arrowLabel: 'Vrati se nazad',
    managedTeams: 'Upravljani timovi',
    managedTeamsError: 'Neuspešno učitavanje timova.',
    viewAll: 'Pregledaj sve',
    profileSettings: 'Postavke profila',
    userRole: 'Uloga',
    saveSelection: 'Sačuvaj izbor',
    extension: 'Lokal',
    changeProfileConfirmHeader: 'Potvrda promene Postavke profila',
    changeProfileConfirmMessage:
      'Da li ste sigurni da želite sačuvate promene profila?',
    confirm: 'Potvrdi',
    errorProfileUpdate:
      'Ne možete da promenite postavke profila sada jer imate aktivne zahteve. Obavite ih i pokušajte ponovo.',
    roleAgentSupervisor: 'Nadzornik i agent',
    roleSupervisor: 'Nadzornik',
    noTeam: 'Nema tima',
    testYourNetwork: 'Testirajte svoju mrežu',
    speakerAndMic: 'Zvučnik i mikrofon',
    speaker: 'Zvučnik',
    mic: 'Mikrofon',
    speakerDescription:
      'Odaberite i testirajte izlazni uređaj da biste se uverili da čujete pozivaoca.',
    micDescription:
      'Odaberite i testirajte ulazni uređaj da biste se uverili da vas pozivalac čuje.',
    micError:
      'Pristup mikrofonu je odbijen. Omogućite pristup kroz postavke pregledača ili se obratite administratoru.',
    speakerError:
      'Zvučnik trenutno nije dostupan jer je pristup za mikrofon odbijen.',
    telephony: 'Telefonija',
    desktop: 'Radna površina',
    onSpeakerPlay:
      'Ako ne možete da čujete probni zvuk, proverite zvučnik.',
    onMicPlay:
      'Ako ne možete da čujete probni zvuk, proverite zvučnik i mikrofon.',
    onMicRecord: 'Snimite poruku za reprodukciju.',
    test: 'Test',
    recording: 'Snimanje',
    playing: 'Reprodukcija',
    reconnecting: 'Ponovno povezivanje',
    disconnectMessage:
      'Desktop telefon je isključen. Pokušajte drugu opciju za telefon.',
    singleTelephonyDisconnectMessage:
      'Desktop telefon je isključen. Kontaktirajte svog administratora.',
    clear: 'Ukloni unos',
    rememberMeCheckBoxMessage: "Ne prikazuj ovo ponovo",
    saveLabel: 'Sačuvaj',
    browserUnsupportedError: "Prijavljivanje nije uspelo jer koristite pregledač koji nije podržan.",
    microphoneAccessDeniedError: "Pristup mikrofonu je odbijen. Omogućite pristup kroz postavke pregledača ili se obratite administratoru.",
  },
  contactHistory: {
    mainHeader: 'Istorija kontakata',
    handledBy: 'Obrađeno od strane',
    noRecordFound: 'Nije pronađena istorija kontakata!',
    tryAgain: 'Pokušajte ponovo',
    errorMsg: 'Neuspešno pronalaženje istorije kontakta. Pokušajte ponovo.',
    errorID: 'ID greške',
    missingAni: 'ANI nedostaje',
    timeIcon: 'Trajanje',
    taskHandled: 'Obrađeni zadaci',
    noHistoryNew: 'Nema istorije',
    noHistory: 'Nema istorije',
    viewTranscript: 'Pregled poruke e-pošte',
    transcriptFor: 'Transkripti za',
    editBeforeCall: 'Uredi pre poziva',
    clickToCall: 'Kliknite za poziv',
    onAnActiveCallErrorMessage:
      'Ne možete da pokrenete novi poziv jer ste već na aktivnom pozivu.',
    receivedFrom: 'Kontakt dobijen od',
    initiatedTo: 'Kontakt pokrenut za',
    wrapUpReason: 'Razlog zaključenja',
    startCallTelephony:
      'Kliknite na vezu za broj telefona da biste pokrenuli odlazni poziv.',
    contactHistoryList: 'Lista istorije kontakata',
    wrapUpCode: 'Kod za zaključenje',
    agentName: 'Naziv agenta',
    entryPointName: 'Ulazna tačka',
    acceptedTimeAndDate: 'Prihvaćeno vreme i datum',
    duration: 'Trajanje',
    emailTranscript: 'Transkript e-pošte',
    clickToViewEmailTranscript: 'Kliknite za pregled transkripta e-pošte',
    listContainer: 'Kontejner liste'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Ulazna tačka',
    date: 'Datum',
    subject: 'Tema',
    from: 'Od',
    sent: 'Poslato',
    to: 'Za',
    back: 'Nazad',
    errorTranscript: 'Došlo je do greške prilikom preuzimanja transkripata',
    customer: 'Klijent',
    inboundErrorMessage: 'Neuspešno učitavanje e-pošte korisnika',
    outboundErrorMessage: 'Neuspešno učitavanje odgovora agenta'
  },
  popoverTitle: {
    callback: 'Povratni poziv',
    outboundCall: 'Odlazni poziv',
    incomingCall: 'Dolazni poziv',
    progressiveCampaign: 'Poziv za  kampanju',
    courtesyCallback: 'Povr. poz. iz ljubaz.',
    chat: 'Dolazno ćaskanje',
    incoming: 'Dolazni',
    monitoringCall: 'Nadzorni poziv'
  },
  connecting: 'Povezivanje',
  initiating: 'Pokretanje',
  outbound: 'Odlazni',
  transfer: {
    title: 'Zahtev za prenos',
    heading: {
      chat: 'Izaberite agenta ili red za čekanje na koji želite da obavite prebacivanje.',
      email: 'Izaberite red za čekanje na koji želite da obavite prebacivanje.',
      telephony:
        'Izaberite agenta, red za čekanje ili broj za pozivanje na koji želite da obavite prebacivanje.',
      noQueueTelephony:
        'Izaberite agenta ili broj za pozivanje na koji želite da obavite prebacivanje.'
    },
    header: {
      chat: 'Izaberite agenta ili red za čekanje za prenos kontakta.',
      email: 'Izaberite red za čekanje za prenos ovog kontakta.',
      telephony:
        'Izaberite agenta, red za čekanje, broj za pozivanje ili organizaciju za prenos kontakta.',
      noQueueTelephony:
        'Izaberite agenta, broj za pozivanje ili organizaciju za prenos kontakta.',
      noOrganizationTelephony:
        'Izaberite agenta, red za čekanje ili broj za pozivanje za prenos kontakta.',
      noQueueOrganizationTelephony:
        'Izaberite agenta ili broj za pozivanje za prenos kontakta.'
    },
    queues: 'Red za čekanje',
    agents: 'Agent',
    dialNumber: 'Birani broj',
    organization: 'Organizacija',
    placeholder: {
      Queues: 'Izaberite sa liste redova za čekanje',
      Agents: 'Izaberite sa liste agenata',
      DialNumber: 'Izaberite po imenu ili broju',
      DialNumberOrEntryPoint: 'Izaberite po imenu/Broju/Ulaznoj tački',
      ChooseByNameOrNumber: 'Izbor po imenu/broju',
      Organization: 'Pretraga po imenu/Ulozi/Odeljenju/Poslovnom telefonu',
      WebexOrganization: 'Pretraga po imenu ili e-adresi',
      DialNumberSearch: 'Pretraga po imenu ili br.'
    },
    type: 'Prenesi',
    cancel: 'Otkaži',
    closeModal: 'Zatvori modalni',
    failureError: 'Neuspešno pokretanje ovog zahteva za transfer. Pokušajte ponovo.',
    entryPoint: 'Ulazna tačka'
  },
  consult: {
    title: 'Zahtev za konsultaciju',
    heading: {
      chat: 'Izaberite agenta ili red za čekanje na koji želite da obavite prebacivanje.',
      email: 'Izaberite red za čekanje na koji želite da obavite prebacivanje.',
      telephony:
        'Izaberite agenta, red za čekanje ili broj za pozivanje sa kojim želite da se konsultujete.',
      noQueueTelephony:
        'Izaberite agenta ili broj za pozivanje sa kojim želite da se konsultujete.'
    },
    header: {
      chat: 'Izaberite agenta ili red za čekanje za prenos kontakta.',
      email: 'Izaberite red za čekanje za prenos ovog kontakta.',
      telephony:
        'Izaberite agenta, red za čekanje, broj za pozivanje ili organizaciju sa kojom želite da se konsultujete.',
      noQueueTelephony:
        'Izaberite agenta, broj za pozivanje ili organizaciju sa kojom želite da se konsultujete.',
      noOrganizationTelephony:
        'Izaberite agenta, red za čekanje ili broj za pozivanje sa kojim želite da se konsultujete.',
      noQueueOrganizationTelephony:
        'Izaberite agenta ili broj za pozivanje sa kojim želite da se konsultujete.'
    },
    queues: 'Red za čekanje',
    agents: 'Agent',
    dialNumber: 'Birani broj',
    organization: 'Organizacija',
    placeholder: {
      Queues: 'Izaberite sa liste redova za čekanje',
      Agents: 'Izaberite sa liste agenata',
      DialNumber: 'Izaberite po imenu ili broju',
      DialNumberOrEntryPoint: 'Izaberite po imenu/Broju/Ulaznoj tački',
      ChooseByNameOrNumber: 'Izbor po imenu/broju',
      Organization: 'Pretraga po imenu/Ulozi/Odeljenju/Poslovnom telefonu',
      WebexOrganization: 'Pretraga po imenu ili e-adresi',
      DialNumberSearch: 'Pretraga po imenu ili br.'
    },
    type: 'Pokreni konsultaciju',
    checkBoxLabel: 'Dozvoli učesnicima da nastave interakciju.',
    cancel: 'Otkaži',
    closeModal: 'Zatvori modalni',
    failureError: 'Nije moguće povezati zahtev za konsultaciju. Pokušajte ponovo.',
    customerLeftMsg: 'Klijent je prekinuo vezu. Konsultacije više nisu potrebne.',
    ctqFailureMsg:
      'Nije moguće otkazati poziv za konsultaciju u redu za čekanje. Pokušajte ponovo.',
    cancelCtqInfo:
      'Pretraga za dostupnog agenta u izabranom redu za čekanje. Sačekajte ili otkažite zahtev za konsultaciju.',
    cancelCtqAction: 'Otkaži konsultaciju.',
    entryPoint: 'Ulazna tačka'
  },
  conference: {
    title: 'Zahtev za konferenciju',
    heading: {
      chat: 'Izaberite određenog agenta za konferencijsko ćaskanje'
    },
    queues: 'Red za čekanje',
    agents: 'Agent',
    dialNumber: 'Birani broj',
    organization: 'Organizacija',
    placeholder: {
      Queues: 'Izaberite sa liste redova za čekanje',
      Agents: 'Izaberite sa liste agenata',
      DialNumber: 'Izaberite po imenu ili broju'
    },
    type: 'Konferencija',
    cancel: 'Otkaži',
    closeModal: 'Zatvori modalni',
    failureError: 'Neuspešno pokretanje zahteva za ovu konferenciju. Pokušajte ponovo.'
  },
  transferModal: {
    Agents: 'Nije moguće nabaviti listu agenata. Osvežite listu.',
    AgentsEmpty: 'Nema dostupnog agenta.',
    Queues: 'Nije moguće nabaviti listu reda za čekanje. Osvežite listu.',
    QueuesEmpty: 'Nema dostupnog reda za čekanje',
    EPEmpty: 'Nije dostupna ulazna tačka',
    DialNumber:
      'Nije moguće nabaviti listu pozvanih brojeva iz imenika. Osvežite listu.',
    EntryPoint:
      'Nije moguće pronaći listu unosa za brojeve tačke. Osvežite listu.',
    Common: 'Nije moguće pronaći listu. Osvežite listu.',
    DialNumberEmpty: 'Nema dostupnog broja za povezivanje',
    DialNumbInvalid:
      'Pozvani broj je pogrešan. Kontaktirajte svog administratora.',
    DialNumbOrEntryPointInvalid:
      'Broj za pozivanje/Ulazna tačka je nevažeća/i. Kontaktirajte svog administratora.',
    refreshQueueList: 'Osveži liste redova za čekanje',
    refreshAgentList: 'Osveži listu agenata',
    refreshEpList: 'Osveži ulazne tačke',
    refreshAddressBook: 'Osveži adresar',
    refreshTheList: 'Osveži listu',
    entryPointSectionLabel: 'Ulazna tačka',
    addressBookSectionLabel: 'Adresar',
    organization: 'Organizacija',
    comboBoxAriaLabelAgent: 'Izaberite sa liste agenata',
    comboBoxAriaLabelQueue: 'Izaberite sa liste redova za čekanje',
    comboBoxAriaLabelEp: 'Izaberite sa liste ulaznih tačaka',
    infScrollAgent: 'Pretraga agenata',
    infScrollQueue: 'Pretraga redova za čekanje',
    infScrollEP: 'Pretraga ulaznih tačaka',
    allRadioButtonHidedTextForConsult: 'Nemate dodeljene entitete za konsultaciju ove interakcije. Obratite se svom administratoru.',
    allRadioButtonHidedTextForTransfer: 'Nemate dodeljene entitete za prenos ove interakcije. Obratite se svom administratoru.',
    allRadioButtonHidedTextForConference: 'Nemate dodeljene entitete za konferenciju ove interakcije. Obratite se svom administratoru.',
    searchMinCharError: 'Unesite minimalno tri karaktera da biste pokrenuli pretragu.',
  },
  wrapup: {
    cancelautowrapup: 'Otkaži automatsko zaključenje',
    wrapupreason: 'Razlozi zaključenja',
    untilautowrapup: 'do automatskog zaključenja',
    followupsetting: 'Podešavanje kontrole',
    lastagentroute: 'Poslednje rutiranje agenta',
    submitwrapup: 'Pošalji zaključenje',
    wrapupsearch: 'Pretraga razloga za zaključenje',
    invalidationError: 'Neuspešno slanje zaključenja',
    searchResult: 'Dostupni rezultati za pretragu',
    noResultFound: 'Nisu pronađeni rezultati pretrage',
    listContainerLabel: 'Kontejner liste za zaključenje',
    searchError: 'Unesite najmanje tri znaka da biste pretražili razloge za prekid.',
  },

  outdial: {
    call: 'Poziv',
    dialpadSearch: 'Unesite broj za pozivanje',
    addressSearch: 'Pretraga po imenu/broju',
    addressTab: 'Adresa',
    addressTabTooltip: 'Pretraga adresara',
    dialpadTab: 'Brojčanik za biranje',
    dialpadTooltip: 'Pozovite broj',
    searchTab: 'Pretraži',
    searchTabTooltip:'Pretraga ljudi u mojoj organizaciji',
    noAdrFound: 'Nisu pronađena poklapanja',
    noContacts: 'Nema kontakata',
    mainIconTooltip: 'Odlazni poziv',
    errorOutdialFailed:
      'Odlazni poziv nije uspeo. Radna površina nije uspela da se poveže na poziv, ili nije odgovoreno na poziv.',
    errorOutdialDisabled: 'Odlazni pozivi su isključeni',
    errorDialPadValidationMessage: 'Netačan format',
    outdialReqInProgress: 'Odlazni poziv je u toku',
    outdialAniPlaceholder: 'Izaberite odlazni ANI',
    outdialAniLabel: 'Odlazni ANI',
    outdialAniPlaceHolder: 'Pretraži ANI za odlazno biranje',
    errorDcCallsLimitExceeded:
      'Centar za podatke je dostigao maksimalno ograničenje za odlazne pozive. Nije moguće obaviti još odlaznih poziva',
    errorOrgCallsLimitExceeded:
      'Organizacija je dostigla maksimalno ograničenje za odlazne pozive. Nije moguće obaviti još odlaznih poziva.',
    errorOutDialNoAnswerFromCustomer:
      'Klijent nije odgovorio na vaš poziv. Pokušajte da pozovete kasnije.',
    errorOutDialCustomerUnavailable:
      'Klijent sada nije dostupan. Pokušajte da pozovete kasnije.',
    errorOutDialAgentEnds: 'Završili ste poziv sa klijentom.',
    errorOutDialCustomerBusy: 'Klijent je sada zauzet. Pokušajte da pozovete kasnije.',
    searchError: 'Unesite minimalno tri karaktera da biste pretražili kontakte.',
    upArrowLabel: 'Prošireno',
    clear: 'Ukloni unos',
    outdialDialogDescription: 'Trenutno ste na dijalogu sa karticama.'
  },

  organization: {
    noMatchFound: 'Nisu pronađena poklapanja',
    searchError: 'Unesite minimalno tri karaktera da biste pretražili kontakte.',
    authError: 'Nema kontakata za prikaz. Microsoft autentifikacija nije uspela.'
  },

  interactionPopover: {
    of: 'od',
    accept: 'Prihvati',
    acceptAriaLabel: 'Prihvatanje zadatka {taskNumber} – {taskType} od {from}',
    requests: 'Zahtev(i)',
    back: 'nazad',
    next: 'sledeći',
    acceptMultipleRequest: 'Prihvati {requestCount} zahteva',
    paginationDetail: '{indexStart}-{indexEnd} od {totalPopoverpoolLength}',
    hidePopoverDetails: 'Sakrij detalje iskačućeg prozora',
    showPopoverDetails: 'Prikaži detalje iskačućeg prozora',
    customerName: 'Ime klijenta',
    email: 'E-adresa',
    queueName: 'Naziv reda za čekanje',
    failedToAccept: 'Neuspešno prihvatanje.',
    unableToAccept: 'Nije moguće prihvatiti kontakt.',
    failedToEnd: 'Završetak nije uspeo.',
    unableToEnd: 'Nije moguće završiti kontakt. ',
    ringing: 'Zvono',
    calling: 'Pozivanje',
    phoneNumber: 'Broj telefona',
    dni: 'DNIS',
    ivrPathId: 'IVR putanja ID',
    pathId: 'ID putanje',
    rona: 'RONA',
    sourcePage: 'Izvorna stranica',
    sourceNumber: 'Izvorni broj',
    appUserId: 'ID korisnika aplikacije',
    acceptAll: 'Prihvati sve zadatke',
    agentDn: 'Agent DN',
    agentName: 'Ime agenta',
    agentTeam: 'Tim agenta',
    requestDetails: 'Zahtev za detalje',
    incomingCallFrom: 'Dolazni poziv od',
    unableToAnswer: 'Nije moguće prihvatiti poziv. Pokušajte ponovo.',
    unableToDecline: 'Nije moguće odbiti poziv. Pokušajte ponovo.'
  },

  multiLogin: {
    header: 'Upozorenje za višestruke prijave',
    message:
      'Prijavljeni ste na radnu površinu u slučajevima višestrukih aplikacija. Kliknite na Nastavi sa radnom površinom u ovom slučaju aplikacije. Ili, zatvorite ovaj prozor.',
    continue: 'Nastavi'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Prenos na ulaznu tačku/red za čekanje nije uspeo zbog greške u konfiguraciji.',
    1010: "Nije moguće obaviti konsultaciju jer agent nije mogao biti dodeljen na vreme. ",
    1042: "Kontakt nije pronađen",
    1043: 'Destinacija je pogrešna.',
    1045: 'Interakcija nije dodeljena za agenta.',
    1046: 'Konsultacija agenta nije uspela, jer nije pronađen odgovarajući kanal za agenta u sistemu.',
    1038: "Agent nije pronađen",
    1037: 'Prijava nije uspela zbog interne greške.',

    // Media Events
    138: 'Radnja nije uspela iz nepoznatih razloga.',
    136: 'Korisnik nije pronađen',

    // AgentConsultFailed
    1050: 'Konsultacija nije moguća zbog nepodržane konfiguracije ili aktivnosti u toku. ',
    1005: "Nije moguće obaviti konsultaciju jer agent nije odgovorio na zahtev na vreme.",
    1051: 'Nije moguće obaviti konsultaciju ili prenos zbog pogrešne ulazne tačke ili broja za pozivanje.',

    // AgentInviteFailed
    1053: 'Nije moguće predstaviti interakciju zbog radnog toka zadatka na čekanju u redu po atributima.',
    1054: 'Nije moguće obaviti odlazni poziv zbog problema sa medijem iz ovog zahteva. ',

    // AgentContactAssignFailed
    1011: 'Nije moguće odgovoriti niti prihvatiti poziv zbog agenta koji nedostaje u tekućoj interakciji. ',

    // ContactCallbackFailed
    1034: 'Povratni poziv za kontakt nije uspeo jer je ContactParkTimeout dobijen za zahtev.',

    // ContactUpdateFailed
    1020: "Nije moguće ažurirati promenljive jer jedna od vrednosti prekoračuje ograničenje za broj karaktera od 256. Smanjite broj karaktera i pokušajte ponovo.",

    // AgentInviteFailed
    1031: 'Agent je pozvao klijenta nakon što je zatražen povratni poziv.',

    // AgentBlindTransferFailedEvent
    1044: 'Slepi prenos agenta nije uspeo jer je agent na destinaciji dodeljen za drugu interakciju.',

    // AgentCtqCancelFailed
    1047: "Kontakt nije pronađen.",

    // AgentCtqFailed
    1048: "Grupa za distribuciju poziva nije podešena.",
    1049: 'Maksimalno vreme čekanja u redu za čekanje je prekoračeno.',
    // StationLoginFailed
    127: 'Registracija Agenta DN nije uspela uz izuzetak za duplu prijavu.'
  },

  stateSelector: {
    Available: 'Dostupno',
    errorstatechange: 'Promena statusa nije bila uspešna. Pokušajte ponovo.',
    errorStateChangeInPendingLogout: 'Promena stanja agenta nije uspela zbog odjavljivanja na čekanju.',
    label: 'Status dostupnosti',
    agentStateSelector: 'Selektor statusa agenta',
    Engaged: 'Angažovano',
    engagedAvailableInfo:
      'Trenutno ste angažovani u interakciji i u statusu Dostupan.',
    engagedIdleInfo:
      'Trenutno ste angažovani u interakciji i u statusu U mirovanju',
    engagedInfo: 'Trenutno ste angažovani u interakciji.',
    engagedSupervisorStateChange: 'promenio je vaš status u',
    axAgentStateChanged: 'Vaš status se promenio u',
    axAgentSync: 'zbog sinhronizacije statusa sa vašim alatom za saradnju.',
    engagedPresenceInfo:
      'Trenutno ste angažovani u interakciji i vaš status je',
    engagedPresenceSync: 'zbog sinhronizacije statusa sa vašim alatom za saradnju.',
    clear: 'Ukloni unos',
    searchState: 'unos',
    agentStatusLabel: 'Status agenta',
    agentStateLabel: 'Agent je u statusu {selectedState} tokom poslednjih {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Agent je u statusu {selectedState} tokom poslednjih 0 sek.',
    agentStateChangeSuccessful:'Promena države u {selectedState} je uspela.',
    agentStateChangeFail:'Promena statusa u {selectedState} nije uspela.',
    searchError: 'Unesite najmanje tri znaka da biste pretražili statuse.'
  },

  warningMessage: {
    header: 'Nesačuvane promene',
    message:
      'Imate nesačuvane promene na ovoj stranici. Da li ste sigurni da želite da napustite stranicu? ',
    cancelButton: 'Ostani',
    saveButton: 'Napusti'
  },

  notificationLables: {
    muteVolume: 'Priguši jačinu zvuka obaveštenja',
    unmuteVolume: 'Otkaži prigušivanje jačine zvuka obaveštenja',
    notificationVolume: 'Jačina zvuka obaveštenja',
    playSound: 'Reprodukuj zvuk obaveštenja',
    enableSoundNotificationSettings: 'Omogući zvučna obaveštenja',
    enableSoundNotificationSettingsDescription:
      'Dostavlja zvučna obaveštenja za dolazne zahteve. Možete da podesite jačinu zvuka ispod.',
    volumeTitle: 'Jačina zvuka'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Poziv',
    chat: 'Ćaskanje',
    email: 'E-adresa',
    facebook: 'Messenger',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google poslovni menadžeri"
  },
  orgDetailsLabels: {
    role: 'Uloga',
    department: 'Odeljenje',
    email: 'E-adresa',
    businessPhone: 'Poslovni telefon',
    workPhone: 'Radni',
  },
  addressListError: {
    title: 'Neuspešno učitavanje podataka',
    errorId: 'ID greške:'
  },
  keypad: {
    keyPadSearch: 'Unesite broj',
    dialPad: 'Brojčanik za biranje'
  },
  collabTool: {
    userAuthenticated: 'Autentifikacija korisnika:',
    successful: 'Uspešno',
    failed: 'Neuspešno.',
    tryAgain: 'Pokušajte ponovo',
    stateSync: 'Sinhronizacija statusa:',
    mercuryFailedInfo: ' Kontaktirajte svog administratora.',
    retrying: 'Ponovni pokušaj...',
    trackingIdLabel: 'ID za praćenje: '
  },
  webex: {
    webex: 'Webex',
    info: 'Integracija vam dozvoljava sinhronizaciju statusa između Desktop i Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Uz ovu integraciju možete da obavite konsultaciju ili prenos poziva na korisnika Microsoft Teams.',
    authenticationFailedInfo:
      'Ako je prozor za autentifikaciju već otvoren, pokušajte autentifikaciju ponovo tamo.',
    ListItemContactDetails:
      'Ime kontakta je: {name}, njegovo prisustvo je: {presence}, odeljenje je: {department}, naslov posla je: {jobTitle} i broj telefona je: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Obaveštenje za hitnu službu',
    readNotification: 'Pročitao sam obaveštenje.'
  },
  webexPresenceStatus: {
    active: 'Aktivno',
    lastActiveFewMinutesAgo: 'Aktivan u poslednjih nekoliko minuta',
    lastActiveMinutesAgo: 'Aktivno {min} minuta ranije',
    lastActive1HourAgo: 'Poslednja aktivnost pre 1 sat',
    lastActiveHoursAgo: 'Aktivno {hour} sati ranije',
    lastActiveYesterday: 'Aktivno juče',
    lastActiveOnDate: 'Aktivno na dan {date}',
    busy: 'Zauzeto',
    busyUntil: 'Zauzet do {date}',
    dnd: 'Ne uznemir.',
    dndUntil: 'Ne uznemiravaj do {date}',
    quiet: 'Tiho',
    quietUntil: 'Tiho do {date}',
    ooo: 'Van kancelarije',
    outOfOfficeUntil: 'Van kancelarije do {date}',
    call: 'Na pozivu',
    meeting: 'Na sastanku',
    calendarItem: 'Na sastanku iz kalendara',
    presenting: 'Držim prezentaciju',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Pretraga po imenu ili detaljima profila',
    webexPlaceholder: 'Pretraga po imenu ili e-adresi',
    refreshTheList: 'Osveži listu',
    refreshAddressBook: 'Osveži adresar',
    microsoftAuthError: 'Nema kontakata za prikaz. Microsoft autentifikacija nije uspela.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/sv.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/sv.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Det gick inte att läsa in data',
    errorID: 'Fel-ID',
    tryAgain: 'Försök igen',
    Error: 'Fel',
    okButton: 'OK',
    Yes: 'Ja',
    Cancel: 'Avbryt',
    Confirm: 'Bekräfta',
    Continue: 'Fortsätt',
    Canceling: 'Avbryter',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: 'Svara',
    AnswerAriaLabel: 'Svara på skrivbordsuppgift',
    Decline: 'Avböj',
    ErrorSecurityCompliance: 'Säkerhetsöverensstämmelse',
    errorDetails: 'Feldetaljer',
    learnMore: 'Läs mer',
    showLess: 'Visa Mindre',
    trackingIdDescription:
      'Dela spårnings-ID med webbplatsadministratören eller supportteamet för att utreda situationen.',
    trackingIdInputLabel: 'Spårnings-ID: ',
    submitForm: 'Utskicksformulär',
    unnamedStatus: 'Namnlös status',
    errorChatMsg: 'Kunde inte ladda chattdata',
    noOptions: 'Inga alternativ',
    noResults: 'Inga resultat',
    more: 'Mer',
    nomatchfound: 'Inga matchningar hittades',
    collaborationTool: 'Samarbetsverktyg',
    timerAriaLabel: 'Tid som spenderats',
    historyItemTime: 'Hände vid',
    loading: 'Inläsning',
    months: [
      'Januari',
      'Februari',
      'Mars',
      'April',
      'Maj',
      'Juni',
      'Juli',
      'Augusti',
      'September',
      'Oktober',
      'November',
      'December'
    ],
    loadingMsg: 'Läser in ...',
    search: 'Sök',
    historyChannelLabels: {
      All: 'Alla',
      telephony: 'Röst',
      chat: 'Chatt',
      email: 'E-post',
      social: 'Sociala'
    },
    homePageLabel: 'Startsida',
    resizeHistoryDragger: 'Dragelement för att ändra storlek på historiken',
    agentHistoryLabel: 'agenthistorik',
    clear: 'Tydlig inmatning',
    ariaLabelAgentHistoryWrapper:
      'Agentinteraktionshistorik Visar din senaste kundkommunikation över olika kanaler från de senaste 24 timmarna',
    sliderResizerInstructions:
      'Du befinner dig för närvarande på ett skjutreglage. Om du vill ändra storlek använder du piltangenterna.',
    resizeHistoryPanel: 'Ändra storlek på historikpanelen, skjutreglaget,',
    time: {
      hours: 'timme',
      minutes: 'min',
      seconds: 'sek'
    }
  },
  email: {
    ToLabel: 'Till',
    FromLabel: 'Från och med',
    CcLabel: 'Kopia',
    BccLabel: 'Hemlig kopia',
    SubjectLabel: 'Ämne',
    HideLabel: 'Dölj',
    SendLabel: 'Skicka',
    ShowPrevThread: 'Visa föregående tråd',
    HidePrevThread: 'Dölj föregående tråd',
    ReplyLabel: 'Svara',
    ReplyAllLabel: 'Svara alla',
    ViewOriginalMail: 'Visa original-e-post',
    QuickReplyInp: 'Snabbsvar här …',
    AttachFiles: 'Bifoga Filer',
    ToolbarHeading: 'Rubrik 1',
    ToolbarBold: 'Fetstil',
    ToolbarItalic: 'Kursivt',
    ToolbarUnderLine: 'Understruket',
    ToolbarBlockQuote: 'Blockera offert',
    ToolbarCode: 'Kodblock',
    ToolbarListOrder: 'Lista i ordning',
    ToolbarListBullet: 'Lista i punkter',
    ToolbarLink: 'Länk',
    ToolbarStrike: 'Genomstruken',
    ToolbarColor: 'Textfärg',
    ToolbarTable: 'Tabell',
    insertTable: 'Infoga tabell',
    insertRowAbove: 'Infoga rad ovanför',
    insertRowBelow: 'Infoga rad under',
    insertColumnLeft: 'Infoga kolumn till vänster',
    insertColumnRight: 'Infoga kolumn till höger',
    deleteRow: 'Radera rad',
    deleteColumn: 'Radera kolumn',
    deleteTable: 'Radera tabell',
    link: 'Länk',
    IndentRight: 'Indrag till höger',
    IndentLeft: 'Indrag till vänster',
    showMoreAttachment: 'Visa fler bilagor',
    AttachmentLimit: 'Bifoga upp till ',
    attachments: ' bilagor, ',
    sizeLimit: ' MB max',
    attachment: 'Bilaga',
    errordeleteattachment: 'Kunde inte ta bort fil(er). Försök igen.',
    errordownloadattachment: 'Kunde inte hämta fil(er). Försök igen.',
    erroraddattachemnt: 'Kunde inte överföra fil(er). Försök igen.',
    errorendcontact: 'Kunde inte avsluta kontakten. Försök igen.',
    erroraddlimitreached:
      'Filen kunde inte bifogas eftersom den överskrider max ',
    errorattachmentdrop:
      'Bilaga/bilagor togs bort i enlighet med företagets säkerhetspolicy.',
    errorfiletype: 'Filtypen stöds inte. Försök igen.',
    errorcreditcard:
      'Det går inte att överföra bilaga/bilagor i enlighet med företagets säkerhetspolicy.',
    errorcontainsimage:
      'Det går inte att överföra bilaga/bilagor. Företagets säkerhetspolicy stöder inte bilder i bilagor.',
    errorlimit: ' MB-gräns.',
    errorsendemail: 'Kunde inte skicka e-posten. Försök igen.',
    errorpcicheckemail: 'Kan inte hämta PCI-data. Försök igen.',
    errortext: 'Det gick inte att läsa in data',
    tryAgain: 'Försök igen',
    replywarning:
      'Dela inte ekonomisk, hälsorelaterad eller annan personligt identifierbar information (PII) i meddelandet eller bilagorna.',
    datamasked:
      'E-postmeddelandets ämnesrad eller brödtext har dolts i enlighet med företagets säkerhetspolicy. Är du säker på att du vill skicka meddelandet?',
    pcibannerwarning:
      'E-postmeddelandets ämnesrad eller brödtext har dolts i enlighet med företagets säkerhetspolicy.',
    on: 'På',
    wrote: 'skrev'
  },
  interaction_control: {
    windowOpened: 'Fönster öppnat',
    connected: 'Ansluten',
    consultRequested: 'Begäran om rådfrågning',
    consulting: 'Rådfrågar',
    consultCallOnHold: 'Konsult i vänteläge',
    callOnHold: 'Parkerade samtal',
    consult: 'Rådfråga',
    endconsult: 'Avsluta rådfråga',
    hold: 'Väntar',
    transfer: 'Överför',
    conference: 'Konferens',
    endconference: 'Avsluta konferens',
    conferenceRequested: 'Konferensbegäran',
    switchCall: 'Byt',
    mergeCall: 'Koppla ihop',
    wrapup: 'Avslutning',
    end: 'Avsluta',
    customername: 'Kundnamn',
    dn: 'DNIS',
    ivrpath: 'IVR-sökväg',
    email: 'Kundens e-post',
    ani: 'Telefonnummer',
    queueid: 'Könamn',
    ronatimeout: 'Ronatid',
    pathid: 'IVR-sökvägs-ID',
    dnis: 'DNIS',
    destagentphonenumber: 'Agent-katalognummer',
    destagentname: 'Agentnamn',
    virtualteamname: 'Kö',
    category: 'Kategori',
    additionaldetails: 'Övriga uppgifter',
    sourcenumber: 'Källnummer',
    sourcepage: 'Källsida',
    appuser: 'Appanvändar-ID',
    customernumber: 'Telefonnummer',
    exitconference: 'Avsluta konferens',
    resume: 'Fortsätt',
    pauserecording: 'Pausa inspelning',
    resumerecording: 'Återuppta inspelning',
    exitconsult: 'Avsluta rådfrågning',
    pauseRecordingFailed: 'Kan inte pausa inspelning. Försök igen.',
    resumeRecordingFailed: 'Kan inte fortsätta inspelning. Försök igen.',
    holdCallFailed: 'Kan inte parkera samtalet. Försök igen.',
    resumeCallFailed: 'Kan inte återuppta samtalet. Försök igen.',
    endCallFailed: 'Kunde inte avsluta kontakten. Försök igen.',
    consultTransferFailed:
      'Kan inte överföra konsultsamtalet. Försök igen.',
    conferenceTransferFailed:
      'Kan inte överföra konferenssamtalet. Försök igen.',
    conferenceFailed:
      'Kan inte ansluta konferensbegäran. Försök igen.',
    consultEndFailed: 'Kan inte avsluta begäran om rådgivning. Försök igen.',
    conferenceExitFailed:
      'Kan inte avsluta konferensbegäran. Försök igen.',
    conferenceEndFailed:
      'Kan inte avsluta konferensbegäran. Försök igen.',
    cancelCtqFailed:
      'Det går inte att avbryta konsultsamtalet i kön. Försök igen.',
    privacyShield: 'Sekretesskydd',
    errorOnPrvacyShieldForConsult:
      'Inspelningen är för närvarande pausad. Återuppta inspelningen för att starta ett konsultsamtal.',
    errorOnPrvacyShieldForTransfer:
      'Inspelningen är för närvarande pausad. Återuppta inspelningen för att starta en samtalsöverföring.',
    cancelConsult: 'Avsluta konsult',
    cancelTransfer: 'Avbryt samtalsöverföring',
    copy: 'Kopiera',
    copied: 'Kopierad',
    cadrequestuccess: 'Kundinformation har sparats.',
    cadrequestfailure: 'Kundinformation kunde inte sparas. Försök senare.',
    cadupdatedmessage: 'Kundinformation uppdaterades nyligen av',
    unsavedmessage: 'Dina osparade ändringar skrivs över.',
    save: 'Spara',
    revert: 'Ångra',
    expandDetails: 'Expandera detaljer',
    collapseDetails: 'Komprimera detaljer',
    cadValidationError:
      'Ogiltigt format. Använd den internationella standarden för datum och tid.',
    secureCadSaveError:
      'Kundinformation sparades inte. Klicka på Spara för att försöka igen.',
    secureDecryptionError: 'Det går inte att visa säkra variabler.',
    clickToTry: 'Klicka för att försöka igen',
    isSecureVariable: 'är en säker variabel',
    contactorigin: 'Kontaktens ursprung',
    resumeMonitoring: 'Återuppta övervakning',
    pauseMonitoring: 'Pausa övervakning',
    whisperCoach: 'Viskningscoach',
    bargeIn: 'Bröt in',
    endMonitoring: 'Avsluta övervakning',
    contactphonenumber: 'Kontakttelefonnummer',
    contactqueue: 'Kontaktkö',
    activeparticipants: 'Aktiva deltagare',
    consultedparticipant: 'Konsulterad mötesdelt.',
    contactstatus: 'Kontaktstatus',
    timeincontactstatus: 'Tid i kontaktstatus',
    totalcontactduration: 'Total varakt. för kontakt',
    agentinteractiontime: 'Interaktionens varaktighet',
    recording: 'Inspelning',
    monitoring: 'Övervakning',
    monitoringPaused: 'Övervakning pausad',
    pauseMonitoringFailed: 'Kan inte pausa övervakningen. Försök igen.',
    resumeMonitoringFailed: 'Kan inte återuppta övervakningen. Försök igen.',
    callCancelledInProgress: 'Samtalet avbryts',
    bargedIn: 'Bröt in',
    keypad: 'Knappsats',
    mute: 'Ljud av',
    unmute: 'Ljud på',
    bargeInTooltipText:
      'Mikrofonen aktiveras och du kommer att delta i den här kundinteraktionen',
    bargeInCompactTooltipText:
      'Bröt in. Mikrofonen aktiveras och du kommer att delta i den här kundinteraktionen',
    bargeInTooltipDisabled: 'Du måste återuppta övervakningen för att aktivera Bryt in',
    bargeInFailedTitle: 'Bröt in i misslyckades',
    bargeInFailedData:
      'Ett fel uppstod när du försökte bryta in. Försök igen om en stund.',
    supervisorBargedIn: 'har brutit in i ditt samtal.',
    leftInteraction: 'har lämnat interaktionen.',
    conferenceEnded: 'Konferenssamtalet har avslutats.',
    participants: 'Deltagare',
    badgeAriaLabel: '{participant} är i samtalet',
    bargeInConferenceAriaLabel: 'Det finns två mötesdeltagare i interaktionen',
    taskName: 'Namn på aktivitet för interaktionskontroll',
    interactionDurationLabel: 'Varaktighet',
    wrapupassist: 'Avslutshjälp',
    consultingTaskContext: 'Konsultsamtal från',
    consultExited: 'Konsultsamtal avslutat',
    endCall: 'Avsluta samtalet.',
    exitconferenceCall:
      'Avsluta samtalet och konferensen fortsätter med aktiva mötesdeltagare.',
    recordingInProgess: 'Inspelning pågår',
    recordingPaused: 'Inspelning pausad',
    searchPlaceholder: 'Sök efter kontakter',
    postCall: "Efter samtal",
    switchCallTooltip: "Växla till samtal",
    switchConsultTooltip: "Växla till konsultsamtal",
    switchConferenceTooltip: "Växla till konferenssamtal",
    confirmationDialog: {
      endCallTitle: 'Vill du avsluta samtalet?',
      endCallMessage: 'Klicka på Bekräfta om du vill avsluta samtalet för alla mötesdeltagare.',
      exitConferenceTitle: 'Vill du avsluta konferenssamtalet?',
      exitConferenceMessage:
        'Klicka på Bekräfta om du vill avsluta konferenssamtalet och låta de andra mötesdeltagarna fortsätta.',
      confirmButtonLabel: "Bekräfta",
      cancelButtonLabel: "Avbryt",  
    },
    postCallOnHold: "Efterföljande samtal i vänteläge",
    postCallConsult: "Konsultera efter samtal",
    postCallConsultOnHold: "Efterföljande konsultsamtal i vänteläge",
  },
  agentProfile: {
    teamName: 'Team',
    dialNumber: 'Uppringningsnummer',
    phoneNumber: 'Telefonnummer',
    settings: 'Ändra inställningar',
    signOut: 'Logga ut',
    webRTCDisconnected: 'Varning om frånkopplad skrivbordstelefoni ',
    msAuthFailed: 'Microsoft-autentisering misslyckades',
    stateSyncFailed: 'Det gick inte att statussynkronisera',
    userProfileLabel: 'Användarprofil',
    ariaAgentprofile: 'Agentprofil',
    ChannelCapacity: 'Kanalkapacitet',
    voice: 'Röst',
    chat: 'Chatt',
    email: 'E-post',
    social: 'Sociala',
    channelCapacityTooltip: 'Klicka om du vill se mer',
    blendedRouting: 'Blandad',
    exclusiveRouting: 'Exklusiv routing',
    realtimeRouting: 'Blandad realtidsroutning',
    blendedRoutingTooltip: 'Hantera flera kontakter samtidigt i flera kanaler.',
    exclusiveRoutingTooltip: 'Hantera bara en kontakt åt gången.',
    realtimeRoutingTooltip: 'Hantera en obligatorisk realtidskanal.',
    errorActiveContacts:
      'Du kan inte logga ut nu eftersom du har aktiva konversationer. Slutför dem och försök igen.',
    searchTeams: 'Sök i Teams',
    changeTeamsConfirmHeader: 'Ändra bekräftelse för Team',
    changeTeamsConfirmMessage: 'Är du säker på att du vill ändra ditt team?',
    changeTeamLabel: 'Ändra Team',
    errorChangeTeams:
      'Du kan inte byta team nu eftersom du har aktiva förfrågningar. Slutför dem och försök igen.',
    saveTeamSelection: 'Spara Team-urval',
    userSettings: 'Användarinställningar',
    resetLayout: 'Återställ hela skrivbordslayouten',
    resetConfirmHeader: 'Bekräftelse om återställd layout',
    resetConfirmMessage:
      'Är du säker att du vill radera hela skrivbordslayouten? <br/> Skrivbordet kommer att återställas till standardlayouten.',
    downloadLogs: 'Hämta felrapport',
    help: 'Hjälp',
    signoutConfirm: 'Är du säker att du vill logga ut?',
    signoutConfirmHeader: 'Bekräftelse om utloggning',
    darkTheme: 'Växla till mörkt läge',
    newLook: 'Växla till Nytt utseende',
    keyboardShortcuts: 'Kortkommandon',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Aviseringsinställningar',
    silentNotification: 'Tyst avisering',
    enableNotificationSettings: 'Aktivera aviseringar',
    enableSilentNotificationSettings: 'Aktivera tysta aviseringar',
    suppressWebexCallingNotificationSettings: 'Dölj Webex Calling‑aviseringar',
    notificationSettingDescription:
      'Levererar aviseringar om nya meddelanden, varningar och statusändringar.',
    silentNotificationDescription:
      'Stänger av varningar på skärmen. Du kan se aviseringarna i Aviseringscentret.',
    suppressWebexCallingNotificationDescription: 
    'Visa inte popup-aviseringar för inkommande Webex‑samtal och besvara dem via Webex Contact Center.',
    arrowLabel: 'Gå tillbaka',
    managedTeams: 'Hanterade team',
    managedTeamsError: 'Det gick inte att läsa in team.',
    viewAll: 'Visa alla',
    profileSettings: 'Profilinställningar',
    userRole: 'Roll',
    saveSelection: 'Spara urval',
    extension: 'Anknytning',
    changeProfileConfirmHeader: 'Bekräfta ändrade profilinställningar',
    changeProfileConfirmMessage:
      'Vill du verkligen spara dina profiländringar?',
    confirm: 'Bekräfta',
    errorProfileUpdate:
      'Du kan inte ändra profilinställningarna nu eftersom du har aktiva förfrågningar. Slutför dem och försök igen.',
    roleAgentSupervisor: 'Arbetsledare och agent',
    roleSupervisor: 'Arbetsledare',
    noTeam: 'Inget team',
    testYourNetwork: 'Testa ditt nätverk',
    speakerAndMic: 'Högtalare och mikrofon',
    speaker: 'Högtalare',
    mic: 'Mikrofon',
    speakerDescription:
      'Välj och testa ljudenheten för att se till att du hör uppringaren.',
    micDescription:
      'Välj och testa inmatningsenheten för att se till att uppringaren hör dig.',
    micError:
      'Åtkomst till mikrofon nekas. Aktivera åtkomst via webbläsarens inställningar eller kontakta administratören.',
    speakerError:
      'Högtalaren är för närvarande inte tillgänglig eftersom åtkomst till mikrofon nekas.',
    telephony: 'Telefoni',
    desktop: 'Skrivbord',
    onSpeakerPlay:
      'Om du inte hör testljudet, kontrollera högtalarenheten.',
    onMicPlay:
      'Om du inte hör testljudet, kontrollera både högtalaren och mikrofonen.',
    onMicRecord: 'Spela in ett meddelande för uppspelning.',
    test: 'Testa',
    recording: 'Inspelning',
    playing: 'Spelar upp',
    reconnecting: 'Återansluter',
    disconnectMessage:
      'Skrivbordstelefoni är frånkopplat. Försök med ett annat telefonialternativ.',
    singleTelephonyDisconnectMessage:
      'Skrivbordstelefoni är frånkopplat. Kontakta administratören.',
    clear: 'Tydlig inmatning',
    rememberMeCheckBoxMessage: "Visa inte igen",
    saveLabel: 'Spara',
    browserUnsupportedError: "Inloggningen misslyckades eftersom du använder en webbläsare som inte stöds.",
    microphoneAccessDeniedError: "Åtkomst till mikrofon nekas. Aktivera åtkomst via webbläsarens inställningar eller kontakta administratören.",
  },
  contactHistory: {
    mainHeader: 'Kontakthistorik',
    handledBy: 'Hanterades av',
    noRecordFound: 'Ingen kontakthistorik hittades!',
    tryAgain: 'Försök igen',
    errorMsg: 'Kunde inte hämta kontakthistorik. Försök igen.',
    errorID: 'Fel-ID',
    missingAni: 'ANI saknas',
    timeIcon: 'Varaktighet',
    taskHandled: 'Uppgiften har hanterats',
    noHistoryNew: 'Ingen historik',
    noHistory: 'Ingen historik',
    viewTranscript: 'Visa e-postmeddelande',
    transcriptFor: 'Avskrifter för',
    editBeforeCall: 'Redigera före samtal',
    clickToCall: 'Klicka om du vill ringa',
    onAnActiveCallErrorMessage:
      'Du kan inte ringa ett nytt samtal eftersom du redan är i ett aktivt samtal.',
    receivedFrom: 'Kontakt mottagen från',
    initiatedTo: 'Kontakt initierad till',
    wrapUpReason: 'Orsak till avslut',
    startCallTelephony:
      'Klicka på telefonnumnerlänken för att starta ett utgående samtal.',
    contactHistoryList: 'Lista över kontakthistorik',
    wrapUpCode: 'Avslutskod',
    agentName: 'Agentnamn',
    entryPointName: 'Startadress',
    acceptedTimeAndDate: 'Godkänd tid och datum',
    duration: 'Varaktighet',
    emailTranscript: 'Skicka avskrift via e-post',
    clickToViewEmailTranscript: 'Klicka för att visa avskrift av e-post',
    listContainer: 'Listbehållare'
  },
  contactTranscript: {
    agent: 'Agent',
    entryPoint: 'Startadress',
    date: 'Datum',
    subject: 'Ämne',
    from: 'Från och med',
    sent: 'Skickat',
    to: 'Till',
    back: 'Bakåt',
    errorTranscript: 'Ett fel uppstod vid hämtning av avskrifter',
    customer: 'Kund',
    inboundErrorMessage: 'Kunde inte läsa in kundens e-post',
    outboundErrorMessage: 'Kunde inte läsa in agentens svar'
  },
  popoverTitle: {
    callback: 'Återuppringning',
    outboundCall: 'Utgående samtal',
    incomingCall: 'Inkommande samtal',
    progressiveCampaign: 'Kampanjsamtal',
    courtesyCallback: 'Återuppringning',
    chat: 'Inkommande chatt',
    incoming: 'Inkommande',
    monitoringCall: 'Övervakningssamtal'
  },
  connecting: 'Ansluter',
  initiating: 'Initierar',
  outbound: 'Utgående',
  transfer: {
    title: 'Överföringsbegäran',
    heading: {
      chat: 'Välj den agent eller kö du vill överföra till.',
      email: 'Välj den kö du vill överföra till.',
      telephony:
        'Välj den agent, kö eller det uppringningsnummer du vill överföra till.',
      noQueueTelephony:
        'Välj den agent eller det uppringningsnummer du vill överföra till.'
    },
    header: {
      chat: 'Välj agent eller en specifik kö för att överföra denna kontakt.',
      email: 'Välj kö för att överföra denna kontakt.',
      telephony:
        'Välj agent, kö, uppringningsnummer eller organisation för att överföra denna kontakt.',
      noQueueTelephony:
        'Välj agent, uppringningsnummer eller organisation för att överföra denna kontakt.',
      noOrganizationTelephony:
        'Välj agent, kö eller uppringningsnummer för att överföra denna kontakt.',
      noQueueOrganizationTelephony:
        'Välj agent eller ett uppringningsnummer för att överföra denna kontakt.'
    },
    queues: 'Kö',
    agents: 'Agent',
    dialNumber: 'Uppringningsnummer',
    organization: 'Organisation',
    placeholder: {
      Queues: 'Välj i en kölista',
      Agents: 'Välj i en lista med agenter',
      DialNumber: 'Välj baserat på namn eller nummer',
      DialNumberOrEntryPoint: 'Välj baserat på namn/nummer/startadress',
      ChooseByNameOrNumber: 'Välj baserat på namn/nummer',
      Organization: 'Sök på namn/roll/avdelning/företagstelefon',
      WebexOrganization: 'Sök efter namn eller e‑post',
      DialNumberSearch: 'Sök efter Namn eller Nummer'
    },
    type: 'Överför',
    cancel: 'Avbryt',
    closeModal: 'Stäng läge',
    failureError: 'Kunde inte överföra begäran. Försök igen.',
    entryPoint: 'Startadress'
  },
  consult: {
    title: 'Rådfråga begäran',
    heading: {
      chat: 'Välj den agent eller kö du vill överföra till.',
      email: 'Välj den kö du vill överföra till.',
      telephony:
        'Välj den agent, kö eller det uppringningsnummer du vill konsultera.',
      noQueueTelephony:
        'Välj den agent eller det uppringningsnummer du vill konsultera.'
    },
    header: {
      chat: 'Välj agent eller en specifik kö för att överföra denna kontakt.',
      email: 'Välj kö för att överföra denna kontakt.',
      telephony:
        'Välj agent, kö, uppringningsnummer eller organisation att konsultera.',
      noQueueTelephony:
        'Välj agent, uppringningsnummer eller organisation att konsultera.',
      noOrganizationTelephony:
        'Välj agent, kö eller det uppringningsnummer att konsultera.',
      noQueueOrganizationTelephony:
        'Välj agent eller uppringningsnummer att konsultera.'
    },
    queues: 'Kö',
    agents: 'Agent',
    dialNumber: 'Uppringningsnummer',
    organization: 'Organisation',
    placeholder: {
      Queues: 'Välj i en kölista',
      Agents: 'Välj i en lista med agenter',
      DialNumber: 'Välj baserat på namn eller nummer',
      DialNumberOrEntryPoint: 'Välj baserat på namn/nummer/startadress',
      ChooseByNameOrNumber: 'Välj baserat på namn/nummer',
      Organization: 'Sök på namn/roll/avdelning/företagstelefon',
      WebexOrganization: 'Sök efter namn eller e‑post',
      DialNumberSearch: 'Sök efter Namn eller Nummer'
    },
    type: 'Rådfråga',
    checkBoxLabel: 'Tillåt mötesdeltagarna fortsätta interagera.',
    cancel: 'Avbryt',
    closeModal: 'Stäng läge',
    failureError: 'Kan inte ansluta begäran om rådgivning. Försök igen.',
    customerLeftMsg: 'Kunden kopplades från. Konsultation behövs inte längre.',
    ctqFailureMsg:
      'Det går inte att avbryta konsultsamtalet i kön. Försök igen.',
    cancelCtqInfo:
      'Söker efter en tillgänglig agent i den valda kön. Vänta eller avbryt begäran om rådfrågning.',
    cancelCtqAction: 'Avsluta konsult',
    entryPoint: 'Startadress'
  },
  conference: {
    title: 'Konferensbegäran',
    heading: {
      chat: 'Välj en specifik agent för konferenschatt'
    },
    queues: 'Kö',
    agents: 'Agent',
    dialNumber: 'Uppringningsnummer',
    organization: 'Organisation',
    placeholder: {
      Queues: 'Välj i en kölista',
      Agents: 'Välj i en lista med agenter',
      DialNumber: 'Välj baserat på namn eller nummer'
    },
    type: 'Konferens',
    cancel: 'Avbryt',
    closeModal: 'Stäng läge',
    failureError: 'Kunde inte initiera konferensbegäran. Försök igen.'
  },
  transferModal: {
    Agents: 'Det gick inte att hämta listan med agenter. Uppdatera listan.',
    AgentsEmpty: 'Ingen tillgänglig agent',
    Queues: 'Det gick inte att hämta listan med köer Uppdatera listan.',
    QueuesEmpty: 'Ingen tillgänglig kö',
    EPEmpty: 'Ingen startadress tillgänglig',
    DialNumber:
      'Det gick inte att hämta listan med uppringningsnummer från adressboken. Uppdatera listan.',
    EntryPoint:
      'Det gick inte att hämta listan med startadressnummer. Uppdatera listan.',
    Common: 'Det gick inte att hämta listan. Uppdatera listan.',
    DialNumberEmpty: 'Inget uppringningsnummer tillgängligt',
    DialNumbInvalid:
      'Uppringningsnumret är ogiltigt. Kontakta administratören.',
    DialNumbOrEntryPointInvalid:
      'Uppringningsnumret/startadressen är ogiltig. Kontakta administratören.',
    refreshQueueList: 'Uppdatera listan med köer',
    refreshAgentList: 'Uppdatera listan med agenter',
    refreshEpList: 'Uppdatera startadresserna',
    refreshAddressBook: 'Uppdatera adressboken',
    refreshTheList: 'Uppdatera listan',
    entryPointSectionLabel: 'Startadress',
    addressBookSectionLabel: 'Adressbok',
    organization: 'Organisation',
    comboBoxAriaLabelAgent: 'Välj i en lista med agenter',
    comboBoxAriaLabelQueue: 'Välj i en kölista',
    comboBoxAriaLabelEp: 'Välj från en lista över startadresser',
    infScrollAgent: 'Sök agenter',
    infScrollQueue: 'Sökköer',
    infScrollEP: 'Sök startadresser',
    allRadioButtonHidedTextForConsult: 'Du har inga tilldelade entiteter som kan konsultera den här interaktionen. Kontakta administratören.',
    allRadioButtonHidedTextForTransfer: 'Du har inga tilldelade entiteter som kan överföra den här interaktionen. Kontakta administratören.',
    allRadioButtonHidedTextForConference: 'Du har inga tilldelade entiteter som kan konferera med den här interaktionen. Kontakta administratören.',
    searchMinCharError: 'Ange minst tre tecken för att söka.',
  },
  wrapup: {
    cancelautowrapup: 'Avbryt autoavslut',
    wrapupreason: 'Orsaker till avslut',
    untilautowrapup: 'tills autoavslut',
    followupsetting: 'Uppföljningsinställning',
    lastagentroute: 'Senaste agent-routning',
    submitwrapup: 'Skicka avslut',
    wrapupsearch: 'Sök orsak till avslut',
    invalidationError: 'Kunde inte skicka avslut',
    searchResult: 'Tillgängliga sökresultat',
    noResultFound: 'Inga sökresultat hittades',
    listContainerLabel: 'Listbehållare för lista med avslutningsdata',
    searchError: 'Ange minst tre tecken att söka efter avslutningsskäl.',
  },

  outdial: {
    call: 'Samtal',
    dialpadSearch: 'Ange nummer att ringa',
    addressSearch: 'Sök på namn/nummer',
    addressTab: 'Adress',
    addressTabTooltip: 'Sök i adressbok',
    dialpadTab: 'Knappsats',
    dialpadTooltip: 'Ring ett nummer',
    searchTab: 'Sök',
    searchTabTooltip:'Sök efter personer i min organisation',
    noAdrFound: 'Inga matchningar hittades',
    noContacts: 'Inga kontakter',
    mainIconTooltip: 'Utgående samtal',
    errorOutdialFailed:
      'Utgående samtal misslyckades. Desktop kunde inte ansluta samtalet eller så besvarades inte samtalet.',
    errorOutdialDisabled: 'Utgående samtal är inaktiverade',
    errorDialPadValidationMessage: 'Fel format',
    outdialReqInProgress: 'Utgående samtal pågår',
    outdialAniPlaceholder: 'Välj samtal ut-ANI',
    outdialAniLabel: 'Samtal ut-ANI',
    outdialAniPlaceHolder: 'Sök efter utgående ANI',
    errorDcCallsLimitExceeded:
      'Datacentret har uppnått maxgränsen för antalet externa samtal. Det går inte att ringa fler externa samtal',
    errorOrgCallsLimitExceeded:
      'Organisationen har uppnått maxgränsen för antalet externa samtal. Det går inte att ringa fler externa samtal.',
    errorOutDialNoAnswerFromCustomer:
      'Kunden svarade inte. Försök ringa senare.',
    errorOutDialCustomerUnavailable:
      'Kunden är inte tillgänglig nu. Försök ringa senare.',
    errorOutDialAgentEnds: 'Du avslutade samtalet med kunden.',
    errorOutDialCustomerBusy: 'Kunden är upptagen nu. Försök ringa senare.',
    searchError: 'Ange minst tre tecken för att söka bland kontakterna.',
    upArrowLabel: 'Expandera',
    clear: 'Tydlig inmatning',
    outdialDialogDescription: 'Du är för närvarande i dialog med flikar.'
  },

  organization: {
    noMatchFound: 'Inga matchningar hittades',
    searchError: 'Ange minst tre tecken för att söka bland kontakterna.',
    authError: 'Inga kontakter att visa. Microsoft-autentisering misslyckades.'
  },

  interactionPopover: {
    of: 'av',
    accept: 'Accep.',
    acceptAriaLabel: 'Godkänn uppgift {taskNumber} – {taskType} från {from}',
    requests: 'Begäran/begäranden',
    back: 'bakåt',
    next: 'nästa',
    acceptMultipleRequest: 'Acceptera {requestCount} förfrågningar',
    paginationDetail: '{indexStart}-{indexEnd} av {totalPopoverpoolLength}',
    hidePopoverDetails: 'Dölj popupdetaljer',
    showPopoverDetails: 'Visa popupdetaljer',
    customerName: 'Kundnamn',
    email: 'E-post',
    queueName: 'Könamn',
    failedToAccept: 'Kunde inte acceptera.',
    unableToAccept: 'Det går inte att acceptera kontakten.',
    failedToEnd: 'Kunde inte avsluta.',
    unableToEnd: 'Det går inte att avsluta kontakten. ',
    ringing: 'Ringer',
    calling: 'Ringer',
    phoneNumber: 'Telefonnummer',
    dni: 'DNIS',
    ivrPathId: 'IVR-sökvägs-ID',
    pathId: 'Sökvägs-ID',
    rona: 'OVIS',
    sourcePage: 'Källsida',
    sourceNumber: 'Källnummer',
    appUserId: 'Appanvändar-ID',
    acceptAll: 'Acceptera alla uppgifter',
    agentDn: 'Agent-katalognummer',
    agentName: 'Agentnamn',
    agentTeam: 'Agentteam',
    requestDetails: 'Detaljer om förfrågan',
    incomingCallFrom: 'Inkommande samtal från',
    unableToAnswer: 'Kan inte besvara samtalet. Försök igen.',
    unableToDecline: 'Kan inte avvisa samtalet. Försök igen.'
  },

  multiLogin: {
    header: 'Varning om flera inloggningar',
    message:
      'Du är inloggad på Desktop i flera programinstanser. Klicka på Fortsätt för att fortsätta med Desktop i den här programinstansen. Stäng annars det här fönstret.',
    continue: 'Fortsätt'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Överföring till startadress/kö misslyckades på grund av ett konfigurationsfel.',
    1010: "Det går inte att rådfråga eftersom agenten inte kunde bli tilldelad i tid. ",
    1042: "Kontakten hittades inte",
    1043: 'Destinationen är ogiltig.',
    1045: 'Interaktionen är inte tilldelad agenten.',
    1046: 'Det gick inte att rådfråga en agent eftersom ingen matchande agentkanal hittades i systemet.',
    1038: "Agenten hittades inte",
    1037: 'Det gick inte att logga in på grund av ett internt fel.',

    // Media Events
    138: 'Åtgärden misslyckades på grund av okända orsaker.',
    136: 'Användaren hittades inte',

    // AgentConsultFailed
    1050: 'Det går inte att rådfråga på grund av att konfigurationen eller aktiviteten inte stöds i flödet. ',
    1005: "Det går inte att rådfråga eftersom agenten inte besvarade förfrågan i tid.",
    1051: 'Det går inte att konsultera eller överföra på grund av ogiltig startadress eller ogiltigt uppringningsnummer.',

    // AgentInviteFailed
    1053: 'Det går inte att presentera interaktionen på grund av en väntande arbetsflödesuppgift för omplacering i kö.',
    1054: 'Det går inte att ringa ut ett samtal på grund av medieproblem med denna förfrågan. ',

    // AgentContactAssignFailed
    1011: 'Det går inte att besvara eller godkänna samtalet på grund av att det saknas agenter i den pågående interaktionen. ',

    // ContactCallbackFailed
    1034: 'Det gick inte att ringa tillbaka till kontakten eftersom ContactParkTimeout har tagits emot för förfrågan.',

    // ContactUpdateFailed
    1020: "Det går inte att uppdatera variablerna eftersom ett av värdena överstiger gränsen på 256 tecken. Minska antalet tecken och försök igen.",

    // AgentInviteFailed
    1031: 'Agenten har bjudit in kunden efter att återuppringning har begärts.',

    // AgentBlindTransferFailedEvent
    1044: 'Direkt överföring av agenten misslyckades eftersom destinationsagenten är tilldelad en annan interaktion.',

    // AgentCtqCancelFailed
    1047: "Kontakten hittades inte.",

    // AgentCtqFailed
    1048: "Samtalsdistributionsgruppen har inte konfigurerats.",
    1049: 'Den maximala väntetiden i kön har överstigits.',
    // StationLoginFailed
    127: 'Registrering av agent-DN misslyckades med ett undantag för dubbel inloggning.'
  },

  stateSelector: {
    Available: 'Tillgänglig',
    errorstatechange: 'Tillståndsändring misslyckades. Försök igen.',
    errorStateChangeInPendingLogout: 'Det gick inte att ändra agentstatus på grund av väntande utloggning.',
    label: 'Tillgänglighetsstatus',
    agentStateSelector: 'Väljare för agentstatus',
    Engaged: 'Deltar',
    engagedAvailableInfo:
      'Du deltar för närvarande i en interaktion och har statusen Tillgänglig.',
    engagedIdleInfo:
      'Du deltar för närvarande i en interaktion och har statusen Passiv.',
    engagedInfo: 'Du arbetar för närvarande i en interaktion.',
    engagedSupervisorStateChange: 'ändrade din status till',
    axAgentStateChanged: 'Din status ändades till',
    axAgentSync: 'på grund av statussynkronisering med ditt mötesverktyg.',
    engagedPresenceInfo:
      'Du deltar för närvarande i en interaktion och din status är',
    engagedPresenceSync: 'på grund av statussynkronisering med ditt mötesverktyg.',
    clear: 'Tydlig inmatning',
    searchState: 'ingång',
    agentStatusLabel: 'Agentstatus',
    agentStateLabel: 'Agenten har status {selectedState} för det senaste {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Agenten har {selectedState} status under de senaste 0 sekunderna',
    agentStateChangeSuccessful:'Status ändrad till {selectedState}.',
    agentStateChangeFail:'Statusändring till {selectedState} misslyckades.',
    searchError: 'Ange minst tre tecken för att söka bland tillstånd.'
  },

  warningMessage: {
    header: 'Osparade ändringar',
    message:
      'Du har osparade ändringar på sidan. Är du säker på att du vill lämna sidan? ',
    cancelButton: 'Stanna',
    saveButton: 'Lämna'
  },

  notificationLables: {
    muteVolume: 'Stäng av aviseringsvolymen',
    unmuteVolume: 'Slå på aviseringsvolymen',
    notificationVolume: 'Aviseringsvolym',
    playSound: 'Spela upp aviseringsljud',
    enableSoundNotificationSettings: 'Aktivera ljudaviseringar',
    enableSoundNotificationSettingsDescription:
      'Levererar ljudaviseringar för inkommande begäranden. Du kan justera volymen nedan.',
    volumeTitle: 'Ljudvolym'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Samtal',
    chat: 'Chatt',
    email: 'E-post',
    facebook: 'Messenger',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Googles företagsmeddelanden"
  },
  orgDetailsLabels: {
    role: 'Roll',
    department: 'Avdelning',
    email: 'E-post',
    businessPhone: 'Företagstelefon',
    workPhone: 'Arbete',
  },
  addressListError: {
    title: 'Det gick inte att läsa in data',
    errorId: 'Fel-ID:'
  },
  keypad: {
    keyPadSearch: 'Ange numret',
    dialPad: 'Knappsats'
  },
  collabTool: {
    userAuthenticated: 'Användarautentisering:',
    successful: 'Lyckades',
    failed: 'Misslyckades.',
    tryAgain: 'Försök igen',
    stateSync: 'Statussynkronisering:',
    mercuryFailedInfo: ' Kontakta systemadministratören.',
    retrying: 'Försöker igen ...',
    trackingIdLabel: 'Spårnings-ID: '
  },
  webex: {
    webex: 'Webex',
    info: 'Med integrering kan du synkronisera status mellan skrivbordet och Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Med denna integrering kan du konsultera eller överföra samtal till Microsoft Teams-användare.',
    authenticationFailedInfo:
      'Om ett autentiseringsfönster redan är öppet kan du göra ett nytt autentiseringsförsök där.',
    ListItemContactDetails:
      'Kontaktens namn är: {name}, kontaktens närvaro är: {presence}, avdelning är: {department}, befattning är: {jobTitle} och telefonnummer är: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Meddelande om räddningstjänst',
    readNotification: 'Jag har läst meddelandet.'
  },
  webexPresenceStatus: {
    active: 'Aktiv',
    lastActiveFewMinutesAgo: 'Aktiv under de senaste minuterna',
    lastActiveMinutesAgo: 'Aktiv för {min} minuter sedan',
    lastActive1HourAgo: 'Senaste aktivitet för 1 timme sedan',
    lastActiveHoursAgo: 'Aktiv för {hour} timmar sedan',
    lastActiveYesterday: 'Aktiv i går',
    lastActiveOnDate: 'Aktiv den {date}',
    busy: 'Upptaget',
    busyUntil: 'Upptagen till {date}',
    dnd: 'Stör ej',
    dndUntil: 'Stör ej förrän {date}',
    quiet: 'Tyst',
    quietUntil: 'Tyst tills {date}',
    ooo: 'Ej tillgänglig',
    outOfOfficeUntil: 'Frånvarande till {date}',
    call: 'Upptagen i samtal',
    meeting: 'Sitter i möte',
    calendarItem: 'Sitter i kalendermöte',
    presenting: 'Presenterar',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Sök efter namn eller profilinformation',
    webexPlaceholder: 'Sök efter namn eller e‑post',
    refreshTheList: 'Uppdatera listan',
    refreshAddressBook: 'Uppdatera adressboken',
    microsoftAuthError: 'Inga kontakter att visa. Microsoft-autentisering misslyckades.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/tr.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/tr.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Veriler yüklenemedi',
    errorID: 'Hata Kimliği',
    tryAgain: 'Tekrar Deneyin',
    Error: 'Hata',
    okButton: 'Tamam',
    Yes: 'Evet',
    Cancel: 'İptal',
    Confirm: 'Onayla',
    Continue: 'Devam',
    Canceling: 'İptal ediliyor',
    CiscoAiAssistant: 'Cisco Yapay Zeka Yardımcısı',
    Answer: 'Yanıtla',
    AnswerAriaLabel: 'Masaüstü görevini yanıtla',
    Decline: 'Reddet',
    ErrorSecurityCompliance: 'Güvenlik Uyumluluğu',
    errorDetails: 'Hata Ayrıntıları',
    learnMore: 'Daha Fazla Bilgi',
    showLess: 'Daha Az Göster',
    trackingIdDescription:
      'Durumun araştırılabilmesi için, Takip Kimliğini lütfen site yöneticisiyle veya destek ekibiyle paylaşın.',
    trackingIdInputLabel: 'Takip Kimliği: ',
    submitForm: 'Formu Gönder',
    unnamedStatus: 'Adsız Durum',
    errorChatMsg: 'Sohbet verileri yüklenemedi',
    noOptions: 'Seçenek Yok',
    noResults: 'Sonuç Yok',
    more: 'Daha Fazla',
    nomatchfound: 'Eşleşme bulunamadı',
    collaborationTool: 'İş birliği aracı',
    timerAriaLabel: 'Harcanan Süre',
    historyItemTime: 'Gerçekleşme saati:',
    loading: 'Yükleniyor',
    months: [
      'Ocak',
      'Şubat',
      'Mart',
      'Nisan',
      'Mayıs',
      'Haziran',
      'Temmuz',
      'Ağustos',
      'Eylül',
      'Ekim',
      'Kasım',
      'Aralık'
    ],
    loadingMsg: 'Yükleniyor..',
    search: 'Ara',
    historyChannelLabels: {
      All: 'Tümü',
      telephony: 'Ses',
      chat: 'Sohbet',
      email: 'E-posta',
      social: 'Sosyal'
    },
    homePageLabel: 'Giriş Sayfası',
    resizeHistoryDragger: 'Geçmiş sürükleyicisini yeniden boyutlandır',
    agentHistoryLabel: 'temsilci geçmişi',
    clear: 'Girişi Temizle',
    ariaLabelAgentHistoryWrapper:
      'Temsilci Etkileşim Geçmişi, son 24 saat içinde farklı kanallarda gerçekleştirdiğiniz en son müşteri iletişimlerinizi görüntüler',
    sliderResizerInstructions:
      'Şu anda bir ayarlayıcıdasınız. Yeniden boyutlandırmak için ok tuşlarını kullanın',
    resizeHistoryPanel: 'Geçmiş panelini, ayarlayıcıyı yeniden boyutlandırın,',
    time: {
      hours: 'saat',
      minutes: 'dk',
      seconds: 'sn.'
    }
  },
  email: {
    ToLabel: 'Bitiş',
    FromLabel: 'Başlangıç',
    CcLabel: 'Bilgi',
    BccLabel: 'Gizli',
    SubjectLabel: 'Konu',
    HideLabel: 'Gizle',
    SendLabel: 'Gönder',
    ShowPrevThread: 'Önceki Başlığı Göster',
    HidePrevThread: 'Önceki Başlığı Gizle',
    ReplyLabel: 'Yanıtla',
    ReplyAllLabel: 'Tümünü Yanıtla',
    ViewOriginalMail: 'Orijinal E-postayı Görüntüle',
    QuickReplyInp: 'Burada hızlı yanıtla...',
    AttachFiles: 'Dosya Ekle',
    ToolbarHeading: 'Başlık1',
    ToolbarBold: 'Kalın',
    ToolbarItalic: 'İtalik',
    ToolbarUnderLine: 'Altı Çizili',
    ToolbarBlockQuote: 'Hazır Metin',
    ToolbarCode: 'Kod Bloğu',
    ToolbarListOrder: 'Sıraya Göre Listele',
    ToolbarListBullet: 'Madde işaretine göre listele',
    ToolbarLink: 'Bağlantı',
    ToolbarStrike: 'Üstü Çizili',
    ToolbarColor: 'Metin Rengi',
    ToolbarTable: 'Tablo',
    insertTable: 'Tablo Ekle',
    insertRowAbove: 'Üste Satır Ekle',
    insertRowBelow: 'Alta Satır Ekle',
    insertColumnLeft: 'Sola Sütun Ekle',
    insertColumnRight: 'Sağa Sütun Ekle',
    deleteRow: 'Satırı Sil',
    deleteColumn: 'Sütunu Sil',
    deleteTable: 'Tabloyu Sil',
    link: 'Bağlantı',
    IndentRight: 'Sağa Girinti',
    IndentLeft: 'Sola Girinti',
    showMoreAttachment: 'Daha fazla ek göster',
    AttachmentLimit: 'En fazla ek adedi: ',
    attachments: ' ek, ',
    sizeLimit: ' maksimum MB',
    attachment: 'Ek',
    errordeleteattachment: 'Dosyalar silinemiyor. Lütfen tekrar deneyin.',
    errordownloadattachment: 'Dosyalar indirilemiyor. Lütfen tekrar deneyin.',
    erroraddattachemnt: 'Dosyalar yüklenemiyor. Lütfen tekrar deneyin.',
    errorendcontact: 'Etkileşim sonlandırılamıyor. Lütfen tekrar deneyin.',
    erroraddlimitreached:
      'Dosya, maksimum sınırı aştığı için eklenemedi ',
    errorattachmentdrop:
      'Şirketin güvenlik politikası nedeniyle, ekler bırakıldı.',
    errorfiletype: 'Dosya türü desteklenmiyor. Lütfen tekrar deneyin.',
    errorcreditcard:
      'Şirketin güvenlik politikası nedeniyle, ekler yüklenemiyor.',
    errorcontainsimage:
      'Ekler yüklenemiyor. Eklerin içerdiği resimler, şirketin güvenlik politikası tarafından desteklenmiyor.',
    errorlimit: ' MB sınırı.',
    errorsendemail: 'E-posta gönderilemiyor. Lütfen tekrar deneyin.',
    errorpcicheckemail: 'PCI verileri alınamıyor. Lütfen tekrar deneyin.',
    errortext: 'Veriler yüklenemedi',
    tryAgain: 'Tekrar Deneyin',
    replywarning:
      'Bu mesajda veya eklerde Finansal, Tıbbi veya Kişisel Olarak Tanımlayıcı Bilgiler (PII) paylaşmayın.',
    datamasked:
      'E-posta konusu veya gövdesi, şirketin güvenlik politikasına göre düzenlendi. E-postayı göndermek istediğinizden emin misiniz?',
    pcibannerwarning:
      'E-posta konusu veya gövdesi, şirketin güvenlik politikasına göre düzenlendi.',
    on: 'Açık',
    wrote: 'yazdı'
  },
  interaction_control: {
    windowOpened: 'Pencere Açıldı',
    connected: 'Bağlandı',
    consultRequested: 'Danışma İstendi',
    consulting: 'Danışma',
    consultCallOnHold: 'Danışma Beklemede',
    callOnHold: 'Çağrı Beklemede',
    consult: 'Danış',
    endconsult: 'Danışmayı Bitir',
    hold: 'Bekletme',
    transfer: 'Aktar',
    conference: 'Konferans',
    endconference: 'Konferansı Sonlandır',
    conferenceRequested: 'Konferans İstendi',
    switchCall: 'Geçiş Yap',
    mergeCall: 'Birleştir',
    wrapup: 'Toparlama',
    end: 'Bitir',
    customername: 'Müşteri Adı',
    dn: 'DNIS',
    ivrpath: 'IVR Yolu',
    email: 'Müşteri E-postası',
    ani: 'Telefon Numarası',
    queueid: 'Sıra Adı',
    ronatimeout: 'Rona Saati',
    pathid: 'IVR Yolu Kimliği',
    dnis: 'DNIS',
    destagentphonenumber: 'Temsilci DN\'si',
    destagentname: 'Temsilci Adı',
    virtualteamname: 'Sıra',
    category: 'Kategori',
    additionaldetails: 'Ek Ayrıntılar',
    sourcenumber: 'Kaynak Numarası',
    sourcepage: 'Kaynak Sayfası',
    appuser: 'Uygulama Kullanıcı Kimliği',
    customernumber: 'Telefon Numarası',
    exitconference: 'Konferanstan Çık',
    resume: 'Sürdür',
    pauserecording: 'Kaydı Duraklat',
    resumerecording: 'Kaydı Sürdür',
    exitconsult: 'Danışmadan Çık',
    pauseRecordingFailed: 'Kayıt duraklatılamıyor. Lütfen tekrar deneyin.',
    resumeRecordingFailed: 'Kayıt sürdürülemiyor. Lütfen tekrar deneyin.',
    holdCallFailed: 'Çağrı bekletilemiyor. Lütfen tekrar deneyin.',
    resumeCallFailed: 'Çağrı sürdürülemiyor. Lütfen tekrar deneyin.',
    endCallFailed: 'Etkileşim sonlandırılamıyor. Lütfen tekrar deneyin.',
    consultTransferFailed:
      'Danışma çağrısı aktarılamıyor. Lütfen tekrar deneyin.',
    conferenceTransferFailed:
      'Konferans çağrısı aktarılamıyor. Lütfen tekrar deneyin.',
    conferenceFailed:
      'Konferans isteğine bağlanılamıyor. Lütfen tekrar deneyin.',
    consultEndFailed: 'Danışma isteği sonlandırılamıyor. Lütfen tekrar deneyin.',
    conferenceExitFailed:
      'Konferans isteğinden çıkılamıyor. Lütfen tekrar deneyin.',
    conferenceEndFailed:
      'Konferans isteği sonlandırılamıyor. Lütfen tekrar deneyin.',
    cancelCtqFailed:
      'Sıraya yapılan danışma çağrısı iptal edilemiyor. Lütfen tekrar deneyin.',
    privacyShield: 'Gizlilik Kalkanı',
    errorOnPrvacyShieldForConsult:
      'Kayıt işlemi duraklatılmış durumda. Danışma çağrısı başlatmak için lütfen kayıt işlemini sürdürün.',
    errorOnPrvacyShieldForTransfer:
      'Kayıt işlemi duraklatılmış durumda. Aktarma çağrısı başlatmak için lütfen kayıt işlemini sürdürün.',
    cancelConsult: 'Danışmayı İptal Et',
    cancelTransfer: 'Aktarmayı İptal Et',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    cadrequestuccess: 'Müşteri Bilgileri başarıyla kaydedildi.',
    cadrequestfailure: 'Müşteri bilgileri kaydedilemedi. Lütfen daha sonra deneyin.',
    cadupdatedmessage: 'Müşteri bilgileri, yakın zamanda şu kişi tarafından güncellendi:',
    unsavedmessage: 'Kaydedilmeyen değişikliklerinizin üzerine yazıldı.',
    save: 'Kaydet',
    revert: 'Geri Al',
    expandDetails: 'Ayrıntıları Genişlet',
    collapseDetails: 'Ayrıntıları Daralt',
    cadValidationError:
      'Geçersiz biçim. Tarih ve saat için uluslararası standardı kullanın.',
    secureCadSaveError:
      'Müşteri bilgileri kaydedilmedi. Kaydet\'e tıklayarak tekrar deneyin.',
    secureDecryptionError: 'Güvenli değişkenler görüntülenemiyor.',
    clickToTry: 'Tekrar denemek için tıklayın',
    isSecureVariable: 'güvenli bir değişkendir',
    contactorigin: 'Kişi Kaynağı',
    resumeMonitoring: 'İzlemeyi Sürdür',
    pauseMonitoring: 'İzlemeyi Duraklat',
    whisperCoach: 'Fısıltı Koçu',
    bargeIn: 'Katıl',
    endMonitoring: 'İzlemeyi Sonlandır',
    contactphonenumber: 'İletişim Telefon Numarası',
    contactqueue: 'İletişim Sırası',
    activeparticipants: 'Etkin Katılımcılar',
    consultedparticipant: 'Danışılan Katılımcı',
    contactstatus: 'İletişim Durumu',
    timeincontactstatus: 'İletişim Durumunda Geçen Süre',
    totalcontactduration: 'Toplam İletişim Süresi',
    agentinteractiontime: 'Etkileşim Süresi',
    recording: 'Kayıt',
    monitoring: 'İzleme',
    monitoringPaused: 'İzleme Duraklatıldı',
    pauseMonitoringFailed: 'İzleme duraklatılamıyor. Lütfen tekrar deneyin',
    resumeMonitoringFailed: 'İzleme sürdürülemiyor. Lütfen tekrar deneyin',
    callCancelledInProgress: 'Çağrı iptali devam ediyor',
    bargedIn: 'Katıldı',
    keypad: 'Tuş Takımı',
    mute: 'Sessize Al',
    unmute: 'Sesi Aç',
    bargeInTooltipText:
      'Mikrofon açılacak ve bu müşteri etkileşimine katılacaksınız',
    bargeInCompactTooltipText:
      'Katıl. Mikrofon açılacak ve bu müşteri etkileşimine katılacaksınız',
    bargeInTooltipDisabled: 'Katılmayı etkinleştirmek için lütfen izlemeyi sürdürün',
    bargeInFailedTitle: 'Katılma Başarısız',
    bargeInFailedData:
      'Katılmaya çalışırken bir hata oluştu. Lütfen bir süre sonra tekrar deneyin.',
    supervisorBargedIn: 'çağrınıza katıldı.',
    leftInteraction: 'etkileşimden ayrıldı.',
    conferenceEnded: 'Konferans çağrısı sona erdi.',
    participants: 'Katılımcılar',
    badgeAriaLabel: '{participant} çağrıda',
    bargeInConferenceAriaLabel: 'Etkileşimde iki Katılımcı vardır',
    taskName: 'Etkileşim Kontrolü Görev Adı',
    interactionDurationLabel: 'Süre',
    wrapupassist: 'Toparlama Yardımı',
    consultingTaskContext: 'Şu kişiden danışma çağrısı',
    consultExited: 'Danışma çağrısından çıkıldı',
    endCall: 'Çağrıyı sonlandır.',
    exitconferenceCall:
      'Çağrıdan çıktığınızda konferans aktif katılımcılarla devam eder.',
    recordingInProgess: 'Kayıt Sürüyor',
    recordingPaused: 'Kayıt duraklatıldı',
    searchPlaceholder: 'Kişileri ara',
    postCall: "Çağrı Sonrası",
    switchCallTooltip: "Çağrıya geçiş yap",
    switchConsultTooltip: "Danışma çağrısına geçiş yap",
    switchConferenceTooltip: "Konferans çağrısına geçiş yap",
    confirmationDialog: {
      endCallTitle: 'Çağrıyı sonlandırmak istiyor musunuz?',
      endCallMessage: 'Tüm katılımcılar için çağrıyı sonlandırmak üzere Onayla\'ya tıklayın.',
      exitConferenceTitle: 'Konferans çağrısından çıkmak istiyor musunuz?',
      exitConferenceMessage:
        'Konferans çağrısından çıkmak ve diğer katılımcıların çağrıyı sürdürmesine izin vermek için Onayla\'ya tıklayın.',
      confirmButtonLabel: "Onayla",
      cancelButtonLabel: "İptal",  
    },
    postCallOnHold: "Çağrı Sonrası Beklemede",
    postCallConsult: "Çağrı Sonrası Danışma",
    postCallConsultOnHold: "Çağrı Sonrası Danışma Beklemede",
  },
  agentProfile: {
    teamName: 'Ekip',
    dialNumber: 'Çevirme Numarası',
    phoneNumber: 'Telefon Numarası',
    settings: 'Ayarları Değiştir',
    signOut: 'Oturumu Kapat',
    webRTCDisconnected: 'Uyarı Masaüstü Telefon bağlantısı kesildi ',
    msAuthFailed: 'Microsoft kimlik doğrulaması başarısız oldu',
    stateSyncFailed: 'Durum senkronizasyonu yapılamadı',
    userProfileLabel: 'Kullanıcı Profili',
    ariaAgentprofile: 'Temsilci Profili',
    ChannelCapacity: 'Kanal Kapasitesi',
    voice: 'Ses',
    chat: 'Sohbet',
    email: 'E-posta',
    social: 'Sosyal',
    channelCapacityTooltip: 'Daha fazlasını görmek için tıklayın',
    blendedRouting: 'Karışık',
    exclusiveRouting: 'Özel Yönlendirme',
    realtimeRouting: 'Karışık Gerçek Zamanlı Yönlendirme',
    blendedRoutingTooltip: 'Kanallar arasında birden fazla kişiyi işleyin.',
    exclusiveRoutingTooltip: 'Bir seferde yalnızca bir kişiyi işleyin.',
    realtimeRoutingTooltip: 'Yalnızca bir zorunlu gerçek zamanlı kanalı işleyin.',
    errorActiveContacts:
      'Etkin sohbetleriniz bulunduğu için oturumunuzu şu anda kapatamazsınız. Bunları tamamlayın ve tekrar deneyin.',
    searchTeams: 'Ekip Ara',
    changeTeamsConfirmHeader: 'Ekibi Değiştirme Onayı',
    changeTeamsConfirmMessage: 'Ekibinizi değiştirmek istediğinizden emin misiniz?',
    changeTeamLabel: 'Ekibi Değiştir',
    errorChangeTeams:
      'Etkin istekleriniz bulunduğu için ekibi şu anda değiştiremezsiniz. Lütfen bunları tamamlayın ve tekrar deneyin.',
    saveTeamSelection: 'Ekip Seçimini Kaydet',
    userSettings: 'Kullanıcı Ayarları',
    resetLayout: 'Masaüstü Düzeninin Tamamını Sıfırla',
    resetConfirmHeader: 'Düzen Onayını Sıfırla',
    resetConfirmMessage:
      'Masaüstü düzeninin tamamını sıfırlamak istediğinizden emin misiniz? <br/> Masaüstü, varsayılan düzene döndürülecektir.',
    downloadLogs: 'Hata Raporu İndir',
    help: 'Yardım',
    signoutConfirm: 'Oturumu kapatmak istediğinizden emin misiniz?',
    signoutConfirmHeader: 'Oturumu Kapatma Onayı',
    darkTheme: 'Karanlık Moda Geç',
    newLook: 'Yeni Görünüme Geçiş Yap',
    keyboardShortcuts: 'Klavye Kısayolları',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Bildirim Ayarları',
    silentNotification: 'Sessiz Bildirim',
    enableNotificationSettings: 'Bildirimleri Etkinleştir',
    enableSilentNotificationSettings: 'Sessiz Bildirimleri Etkinleştir',
    suppressWebexCallingNotificationSettings: 'Webex Calling Bildirimlerini Gizle',
    notificationSettingDescription:
      'Yeni mesajlar, uyarılar ve durum değişiklikleri gibi bildirimleri iletir.',
    silentNotificationDescription:
      'Ekran uyarılarını kapatır. Bildirimleri, Bildirim Merkezinden görüntüleyebilirsiniz.',
    suppressWebexCallingNotificationDescription: 
    'Gelen Webex aramaları için açılan bildirimleri gösterme ve bu aramaları Webex Contact Center aracılığıyla yanıtla.',
    arrowLabel: 'Geri git',
    managedTeams: 'Yönetilen Ekipler',
    managedTeamsError: 'Ekipler yüklenemedi.',
    viewAll: 'Tümünü Görüntüle',
    profileSettings: 'Profil Ayarları',
    userRole: 'Rol',
    saveSelection: 'Seçimi Kaydet',
    extension: 'Dahili Hat',
    changeProfileConfirmHeader: 'Profil Ayarları Değişikliklerini Onayla',
    changeProfileConfirmMessage:
      'Profil değişikliklerinizi kaydetmek istediğinizden emin misiniz?',
    confirm: 'Onayla',
    errorProfileUpdate:
      'Etkin istekleriniz bulunduğu için Profil Ayarlarını şu anda değiştiremezsiniz. Lütfen bunları tamamlayın ve tekrar deneyin.',
    roleAgentSupervisor: 'Gözetmen ve Temsilci',
    roleSupervisor: 'Gözetmen',
    noTeam: 'Ekip Yok',
    testYourNetwork: 'Ağınızı Test Edin',
    speakerAndMic: 'Hoparlör ve Mikrofon',
    speaker: 'Hoparlör',
    mic: 'Mikrofon',
    speakerDescription:
      'Arayanı duyduğunuzdan emin olmak için çıkış cihazını seçin ve test edin.',
    micDescription:
      'Arayanın sizi duyduğunuzdan emin olmak için giriş cihazını seçin ve test edin.',
    micError:
      'Mikrofona erişim engellendi. Tarayıcı ayarları aracılığıyla erişimi etkinleştirin veya yöneticinize başvurun.',
    speakerError:
      'Mikrofona erişim engellendiği için şu anda hoparlör kullanılamıyor.',
    telephony: 'Telefon',
    desktop: 'Masaüstü',
    onSpeakerPlay:
      'Test sesini duyamıyorsanız hoparlör cihazını kontrol edin.',
    onMicPlay:
      'Test sesini duyamıyorsanız hem hoparlörü hem de mikrofonu kontrol edin.',
    onMicRecord: 'Kayıttan dinlemek için bir mesaj kaydedin.',
    test: 'Test',
    recording: 'Kayıt',
    playing: 'Oynatılıyor',
    reconnecting: 'Yeniden bağlanıyor',
    disconnectMessage:
      'Masaüstü telefonunun bağlantısı kesildi. Farklı bir telefon seçeneğini deneyin.',
    singleTelephonyDisconnectMessage:
      'Masaüstü telefonunun bağlantısı kesildi. Yöneticinizle iletişime geçin.',
    clear: 'Girişi Temizle',
    rememberMeCheckBoxMessage: "Bunu tekrar gösterme",
    saveLabel: 'Kaydet',
    browserUnsupportedError: "Desteklenmeyen bir tarayıcı kullandığınız için oturum açılamadı.",
    microphoneAccessDeniedError: "Mikrofona erişim engellendi. Tarayıcı ayarları aracılığıyla erişimi etkinleştirin veya yöneticinize başvurun.",
  },
  contactHistory: {
    mainHeader: 'Kişi Geçmişi',
    handledBy: 'İşleyen',
    noRecordFound: 'Kişi geçmişi bulunamadı!',
    tryAgain: 'Tekrar Deneyin',
    errorMsg: 'Kişi geçmişi alınamıyor. Lütfen tekrar deneyin.',
    errorID: 'Hata Kimliği',
    missingAni: 'ANI eksik',
    timeIcon: 'Süre',
    taskHandled: 'Görev işlendi',
    noHistoryNew: 'Geçmiş yok',
    noHistory: 'Geçmiş Yok',
    viewTranscript: 'E-posta mesajını görüntüle',
    transcriptFor: 'Aşağıdakiler için dökümler:',
    editBeforeCall: 'Çağrıdan önce düzenle',
    clickToCall: 'Çağrı yapmak için tıkla',
    onAnActiveCallErrorMessage:
      'Zaten aktif bir çağrıda olduğunuz için yeni bir çağrı başlatamazsınız.',
    receivedFrom: 'İletişim isteğinin alındığı kaynak:',
    initiatedTo: 'İletişim isteğinin gönderildiği kaynak:',
    wrapUpReason: 'Toparlama nedeni',
    startCallTelephony:
      'Giden çağrı başlatmak için telefon numarası bağlantısına tıklayın.',
    contactHistoryList: 'Kişi Geçmişi Listesi,',
    wrapUpCode: 'Toparlama kodu',
    agentName: 'Temsilci adı',
    entryPointName: 'Giriş noktası',
    acceptedTimeAndDate: 'Kabul edildiği saat ve tarih',
    duration: 'Süre',
    emailTranscript: 'E-posta dökümü',
    clickToViewEmailTranscript: 'E-posta dökümünü görüntülemek için tıklayın',
    listContainer: 'Liste Kapsayıcısı'
  },
  contactTranscript: {
    agent: 'Temsilci',
    entryPoint: 'Giriş Noktası',
    date: 'Tarih',
    subject: 'Konu',
    from: 'Başlangıç',
    sent: 'Gönderildi',
    to: 'Bitiş',
    back: 'Geri',
    errorTranscript: 'Dökümler alınırken hata oluştu',
    customer: 'Müşteri',
    inboundErrorMessage: 'Müşteri e-postası yüklenemedi',
    outboundErrorMessage: 'Temsilci yanıtı yüklenemedi'
  },
  popoverTitle: {
    callback: 'Geri Ara',
    outboundCall: 'Giden Çağrı',
    incomingCall: 'Gelen Çağrı',
    progressiveCampaign: 'Kampanya Çağrısı',
    courtesyCallback: 'Nezaketen Geri Arama',
    chat: 'Gelen Sohbet',
    incoming: 'Gelen',
    monitoringCall: 'İzleme Çağrısı'
  },
  connecting: 'Bağlanıyor',
  initiating: 'Başlatılıyor',
  outbound: 'Giden',
  transfer: {
    title: 'Aktarma İsteği',
    heading: {
      chat: 'Aktarmak istediğiniz temsilciyi veya sırayı seçin.',
      email: 'Aktarmak istediğiniz sırayı seçin.',
      telephony:
        'Aktarmak istediğiniz temsilciyi, sırayı veya çevirme numarasını seçin.',
      noQueueTelephony:
        'Aktarmak istediğiniz temsilciyi veya çevirme numarasını seçin.'
    },
    header: {
      chat: 'Bu kişiyi aktarmak için bir temsilci veya sıra seçin.',
      email: 'Bu kişiyi aktarmak için bir sıra seçin.',
      telephony:
        'Bu kişiyi aktarmak için temsilci, sıra, çevirme numarası veya kuruluş seçin.',
      noQueueTelephony:
        'Bu kişiyi aktarmak için temsilci, çevirme numarası veya kuruluş seçin.',
      noOrganizationTelephony:
        'Bu kişiyi aktarmak için temsilci, sıra veya çevirme numarası seçin.',
      noQueueOrganizationTelephony:
        'Bu kişiyi aktarmak için bir temsilci veya çevirme numarası seçin.'
    },
    queues: 'Sıra',
    agents: 'Temsilci',
    dialNumber: 'Çevirme Numarası',
    organization: 'Kuruluş',
    placeholder: {
      Queues: 'Sıra listesinden seçin',
      Agents: 'Temsilci listesinden seçin',
      DialNumber: 'Ada veya Numaraya Göre Seçin',
      DialNumberOrEntryPoint: 'Ada/Numaraya/Giriş Noktasına Göre Seçme',
      ChooseByNameOrNumber: 'Ada/Numaraya göre seçin',
      Organization: 'Ada/Role/Departmana/İş Telefonuna göre arama yapın',
      WebexOrganization: 'Ada veya e-postaya göre ara',
      DialNumberSearch: 'Ada veya Numaraya göre ara'
    },
    type: 'Aktar',
    cancel: 'İptal',
    closeModal: 'Kalıcı Kutuyu Kapat',
    failureError: 'İstek aktarılamıyor. Lütfen tekrar deneyin.',
    entryPoint: 'Giriş Noktası'
  },
  consult: {
    title: 'Danışma İsteği',
    heading: {
      chat: 'Aktarmak istediğiniz temsilciyi veya sırayı seçin.',
      email: 'Aktarmak istediğiniz sırayı seçin.',
      telephony:
        'Danışmak istediğiniz temsilciyi, sırayı veya çevirme numarasını seçin.',
      noQueueTelephony:
        'Danışmak istediğiniz temsilciyi veya çevirme numarasını seçin.'
    },
    header: {
      chat: 'Bu kişiyi aktarmak için bir temsilci veya sıra seçin.',
      email: 'Bu kişiyi aktarmak için bir sıra seçin.',
      telephony:
        'Danışmak istediğiniz temsilciyi, sırayı, çevirme numarasını veya kuruluşu seçin.',
      noQueueTelephony:
        'Danışmak istediğiniz temsilciyi, çevirme numarasını veya kuruluşu seçin.',
      noOrganizationTelephony:
        'Danışmak istediğiniz temsilciyi, sırayı veya çevirme numarasını seçin.',
      noQueueOrganizationTelephony:
        'Danışmak istediğiniz temsilciyi veya çevirme numarasını seçin.'
    },
    queues: 'Sıra',
    agents: 'Temsilci',
    dialNumber: 'Çevirme Numarası',
    organization: 'Kuruluş',
    placeholder: {
      Queues: 'Sıra listesinden seçin',
      Agents: 'Temsilci listesinden seçin',
      DialNumber: 'Ada veya Numaraya Göre Seçin',
      DialNumberOrEntryPoint: 'Ada/Numaraya/Giriş Noktasına Göre Seçme',
      ChooseByNameOrNumber: 'Ada/Numaraya göre seçin',
      Organization: 'Ada/Role/Departmana/İş Telefonuna göre arama yapın',
      WebexOrganization: 'Ada veya e-postaya göre ara',
      DialNumberSearch: 'Ada veya Numaraya göre ara'
    },
    type: 'Danış',
    checkBoxLabel: 'Katılımcıların etkileşime devam etmelerine izin verin.',
    cancel: 'İptal',
    closeModal: 'Kalıcı Kutuyu Kapat',
    failureError: 'Danışma isteğine bağlanılamıyor. Lütfen tekrar deneyin.',
    customerLeftMsg: 'Müşterinin bağlantısı kesildi. Danışmaya artık gerek kalmadı.',
    ctqFailureMsg:
      'Sıraya yapılan danışma çağrısı iptal edilemiyor. Lütfen tekrar deneyin.',
    cancelCtqInfo:
      'Seçilen sırada uygun bir temsilci aranıyor. Lütfen bekleyin veya danışma isteğini iptal edin.',
    cancelCtqAction: 'Danışmayı İptal Et',
    entryPoint: 'Giriş Noktası'
  },
  conference: {
    title: 'Konferans İsteği',
    heading: {
      chat: 'Konferans sohbeti için belirli bir temsilci seçin'
    },
    queues: 'Sıra',
    agents: 'Temsilci',
    dialNumber: 'Çevirme Numarası',
    organization: 'Kuruluş',
    placeholder: {
      Queues: 'Sıra listesinden seçin',
      Agents: 'Temsilci listesinden seçin',
      DialNumber: 'Ada veya Numaraya Göre Seçin'
    },
    type: 'Konferans',
    cancel: 'İptal',
    closeModal: 'Kalıcı Kutuyu Kapat',
    failureError: 'Konferans isteği başlatılamıyor. Lütfen tekrar deneyin.'
  },
  transferModal: {
    Agents: 'Temsilci listesi alınamıyor. Lütfen listeyi yenileyin.',
    AgentsEmpty: 'Uygun temsilci yok',
    Queues: 'Sıra listesi alınamıyor. Lütfen listeyi yenileyin.',
    QueuesEmpty: 'Uygun sıra yok',
    EPEmpty: 'Kullanılabilir giriş noktası yok',
    DialNumber:
      'Adres defterinden çevirme numarası listesi alınamıyor. Lütfen listeyi yenileyin.',
    EntryPoint:
      'Giriş noktası numaraları listesi alınamıyor. Lütfen listeyi yenileyin.',
    Common: 'Liste alınamıyor. Lütfen listeyi yenileyin.',
    DialNumberEmpty: 'Uygun çevirme numarası yok',
    DialNumbInvalid:
      'Çevirme numarası geçersiz. Lütfen yöneticinize başvurun.',
    DialNumbOrEntryPointInvalid:
      'Çevirme numarası/Giriş Noktası geçersiz. Lütfen yöneticinizle iletişime geçin.',
    refreshQueueList: 'Sıra Listesini Yenile',
    refreshAgentList: 'Temsilci Listesini Yenile',
    refreshEpList: 'Giriş Noktalarını Yenile',
    refreshAddressBook: 'Adres Defterini Yenile',
    refreshTheList: 'Listeyi Yenile',
    entryPointSectionLabel: 'Giriş Noktası',
    addressBookSectionLabel: 'Adres Defteri',
    organization: 'Kuruluş',
    comboBoxAriaLabelAgent: 'Temsilci listesinden seçin',
    comboBoxAriaLabelQueue: 'Sıra listesinden seçin',
    comboBoxAriaLabelEp: 'Giriş noktaları listesinden seçin',
    infScrollAgent: 'Temsilci ara',
    infScrollQueue: 'Sıra ara',
    infScrollEP: 'Giriş noktası ara',
    allRadioButtonHidedTextForConsult: 'Bu etkileşime danışmak için atanmış varlığınız yok. Yöneticinize başvurun.',
    allRadioButtonHidedTextForTransfer: 'Bu etkileşimi aktarmak için atanmış varlığınız yok. Yöneticinize başvurun.',
    allRadioButtonHidedTextForConference: 'Bu etkileşimle konferans kurmak için atanmış varlığınız yok. Yöneticinize başvurun.',
    searchMinCharError: 'Aramak için en az üç karakter girin.',
  },
  wrapup: {
    cancelautowrapup: 'Otomatik Toparlamayı İptal Et',
    wrapupreason: 'Toparlama Nedenleri',
    untilautowrapup: 'otomatik toparlamaya kadar',
    followupsetting: 'Takip Öğesi Ayarı',
    lastagentroute: 'Son Temsilci Yönlendirmesi',
    submitwrapup: 'Toparlamayı Gönder',
    wrapupsearch: 'Toparlama Nedeni Ara',
    invalidationError: 'Toparlama gönderilemedi',
    searchResult: 'Uygun arama sonuçları',
    noResultFound: 'Arama sonucu bulunamadı',
    listContainerLabel: 'Toparlama Listesi Kapsayıcısı',
    searchError: 'Toparlama nedenlerini aramak için en az üç karakter girin.',
  },

  outdial: {
    call: 'Çağrı',
    dialpadSearch: 'Çevrilecek numarayı girin',
    addressSearch: 'Ada/Numaraya göre ara',
    addressTab: 'Adres',
    addressTabTooltip: 'Adres defterini ara',
    dialpadTab: 'Tuş Takımı',
    dialpadTooltip: 'Bir numara çevirin',
    searchTab: 'Ara',
    searchTabTooltip:'Kuruluşumdaki kişileri arama',
    noAdrFound: 'Eşleşme bulunamadı',
    noContacts: 'Kişi yok',
    mainIconTooltip: 'Dış Arama Çağrısı',
    errorOutdialFailed:
      'Dış arama çağrısı başarısız oldu. Masaüstü çağrıyı bağlayamadı veya çağrıya yanıt verilmedi.',
    errorOutdialDisabled: 'Dış arama çağrıları devre dışı bırakıldı',
    errorDialPadValidationMessage: 'Yanlış Biçim',
    outdialReqInProgress: 'Dış arama çağrısı devam ediyor',
    outdialAniPlaceholder: 'Dış Arama ANI\'si Seçin',
    outdialAniLabel: 'Dış Arama ANI\'si',
    outdialAniPlaceHolder: 'Dış Arama ANI\'si için ara',
    errorDcCallsLimitExceeded:
      'Veri merkezi, dış arama çağrıları için maksimum sınıra ulaştı. Daha fazla dış arama çağrısı yapılamıyor',
    errorOrgCallsLimitExceeded:
      'Kuruluş, dış arama çağrıları için maksimum sınıra ulaştı. Daha fazla dış arama çağrısı yapılamıyor.',
    errorOutDialNoAnswerFromCustomer:
      'Müşteri çağrınızı yanıtlamadı. Daha sonra aramayı deneyin.',
    errorOutDialCustomerUnavailable:
      'Müşteri şu an da müsait değil. Daha sonra aramayı deneyin.',
    errorOutDialAgentEnds: 'Müşteriyle olan aramanızı sonlandırdınız.',
    errorOutDialCustomerBusy: 'Müşteri şu anda meşgul. Daha sonra aramayı deneyin.',
    searchError: 'Kişileri aramak için en az üç karakter girin.',
    upArrowLabel: 'Genişlet',
    clear: 'Girişi Temizle',
    outdialDialogDescription: 'Şu anda sekmeli iletişim kutusundasınız.'
  },

  organization: {
    noMatchFound: 'Eşleşme bulunamadı',
    searchError: 'Kişileri aramak için en az üç karakter girin.',
    authError: 'Görüntülenecek kişi yok. Microsoft kimlik doğrulaması yapılamadı.'
  },

  interactionPopover: {
    of: '/',
    accept: 'Onayla',
    acceptAriaLabel: '{taskNumber} görevini kabul et - {from} kişisinden {taskType}',
    requests: 'İstekler',
    back: 'geri',
    next: 'sonraki',
    acceptMultipleRequest: '{requestCount} İsteği kabul et',
    paginationDetail: '{indexStart}-{indexEnd} / {totalPopoverpoolLength}',
    hidePopoverDetails: 'Açılır Pencere Ayrıntılarını Gizle',
    showPopoverDetails: 'Açılır Pencere Ayrıntılarını Göster',
    customerName: 'Müşteri Adı',
    email: 'E-posta',
    queueName: 'Sıra Adı',
    failedToAccept: 'Kabul edilemedi.',
    unableToAccept: 'İletişim kabul edilemiyor.',
    failedToEnd: 'Sonlandırılamadı.',
    unableToEnd: 'İletişim sonlandırılamıyor. ',
    ringing: 'Çalıyor',
    calling: 'Aranıyor',
    phoneNumber: 'Telefon Numarası',
    dni: 'DNIS',
    ivrPathId: 'IVR Yolu Kimliği',
    pathId: 'Yol Kimliği',
    rona: 'RONA',
    sourcePage: 'Kaynak Sayfası',
    sourceNumber: 'Kaynak Numarası',
    appUserId: 'Uygulama Kullanıcı Kimliği',
    acceptAll: 'Tüm Görevleri kabul et',
    agentDn: 'Temsilci DN\'si',
    agentName: 'Temsilci Adı',
    agentTeam: 'Temsilci Ekibi',
    requestDetails: 'İstek Detayları',
    incomingCallFrom: 'Şu kişiden Gelen Çağrı:',
    unableToAnswer: 'Çağrı yanıtlanamıyor. Lütfen tekrar deneyin.',
    unableToDecline: 'Çağrı reddedilemiyor. Lütfen tekrar deneyin.'
  },

  multiLogin: {
    header: 'Birden Fazla Oturum Açma Uyarısı',
    message:
      'Birden fazla uygulama örneği üzerinde Desktop oturumu açtınız. Desktop\'u bu uygulama örneğinde açmak için Devam\'a tıklayın. Aksi takdirde, bu pencereyi kapatın.',
    continue: 'Devam'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Giriş noktasına/sıraya aktarım işlemi, bir yapılandırma hatası nedeniyle başarısız oldu.',
    1010: "Temsilci zamanında ayrılamadığı için danışma gerçekleştirilemiyor. ",
    1042: "Kişi bulunamadı",
    1043: 'Hedef geçersiz.',
    1045: 'Etkileşim temsilciye atanmadı.',
    1046: 'Sistemde eşleşen bir temsilci kanalı bulunamadığı için temsilciye danışma işlemi başarısız oldu.',
    1038: "Temsilci bulunamadı",
    1037: 'Dahili hata nedeniyle oturum açılamadı.',

    // Media Events
    138: 'Eylem, bilinmeyen nedenlerden ötürü başarısız oldu.',
    136: 'Kullanıcı bulunamadı',

    // AgentConsultFailed
    1050: 'Desteklenmeyen yapılandırma veya akıştaki etkinlik nedeniyle danışma işlemi gerçekleştirilemiyor. ',
    1005: "Temsilci talebe zamanında yanıt vermediği için danışma gerçekleştirilemiyor.",
    1051: 'Geçersiz giriş noktası ya da çevirme numarası nedeniyle danışma veya aktarım gerçekleştirilemiyor.',

    // AgentInviteFailed
    1053: 'Bekleyen bir iş akışı yeniden sıraya alma görevi nedeniyle etkileşim sunulamıyor.',
    1054: 'Bu taleple ilgili medya sorunları nedeniyle dış arama yapılamıyor. ',

    // AgentContactAssignFailed
    1011: 'Devam etmekte olan etkileşimdeki temsilcilerin eksik olması nedeniyle çağrı yanıtlanamıyor ya da kabul edilemiyor. ',

    // ContactCallbackFailed
    1034: 'Talep için ContactParkTimeout hatası alındığından kişiyi geri arama işlemi başarısız oldu.',

    // ContactUpdateFailed
    1020: "Değerlerden biri 256 karakter sınırını aştığından değişkenler güncellenemiyor. Karakterleri azaltıp tekrar deneyin.",

    // AgentInviteFailed
    1031: 'Temsilci, geri arama talep edildikten sonra müşteriyi davet etti.',

    // AgentBlindTransferFailedEvent
    1044: 'Hedef müşteri temsilcisi başka bir etkileşime atandığı için müşteri temsilcisinin gizli aktarması yapılamadı.',

    // AgentCtqCancelFailed
    1047: "Kişi bulunamadı.",

    // AgentCtqFailed
    1048: "Çağrı dağıtım grubu yapılandırılmadı.",
    1049: 'Sırada maksimum bekleme süresi aşıldı.',
    // StationLoginFailed
    127: 'Temsilci DN Kaydı yinelenen oturum açma istisnasıyla başarısız oldu.'
  },

  stateSelector: {
    Available: 'Uygun',
    errorstatechange: 'Durum değişikliği yapılamadı. Lütfen tekrar deneyin.',
    errorStateChangeInPendingLogout: 'Bekleyen oturum kapatma nedeniyle temsilci durumu değiştirilemedi.',
    label: 'Uygunluk Durumu',
    agentStateSelector: 'Temsilci Durumu Seçici',
    Engaged: 'Bağlı',
    engagedAvailableInfo:
      'Şu anda bir etkileşime bağlısınız ve Uygun durumundasınız.',
    engagedIdleInfo:
      'Şu anda bir etkileşime bağlısınız ve Boşta durumundasınız',
    engagedInfo: 'Şu anda bir etkileşime bağlısınız.',
    engagedSupervisorStateChange: 'durumunuzu şu olarak değiştirdi:',
    axAgentStateChanged: 'İşbirliği aracınızla durum senkronizasyonu nedeniyle durumunuz',
    axAgentSync: 'olarak değişti.',
    engagedPresenceInfo:
      'Şu anda bir etkileşime bağlısınız ve işbirliği aracınızla durum senkronizasyonu nedeniyle durumunuz',
    engagedPresenceSync: 'olarak ayarlı.',
    clear: 'Girişi Temizle',
    searchState: 'giriş',
    agentStatusLabel: 'Temsilci Durumu',
    agentStateLabel: 'Temsilci son {selectedTimeValue} için {selectedState} durumunda',
    agentStateLabelOnStateChange: 'Aracı son 0 sn. için {selectedState} durumunda',
    agentStateChangeSuccessful:'{selectedState} durumuna geçiş başarılı.',
    agentStateChangeFail:'{selectedState} durumuna geçiş başarısız oldu.',
    searchError: 'Durumları aramak için en az üç karakter girin.'
  },

  warningMessage: {
    header: 'Kaydedilmeyen Değişiklikler',
    message:
      'Sayfada kaydedilmemiş olan değişiklikleriniz var. Bu sayfadan çıkmak istediğinizden emin misiniz? ',
    cancelButton: 'Kal',
    saveButton: 'Çık'
  },

  notificationLables: {
    muteVolume: 'Bildirim sesini kapat',
    unmuteVolume: 'Bildirim sesini aç',
    notificationVolume: 'Bildirim sesi',
    playSound: 'Bildirim sesini çal',
    enableSoundNotificationSettings: 'Sesli Bildirimleri Etkinleştir',
    enableSoundNotificationSettingsDescription:
      'Gelen istekler için sesli bildirimleri iletir. Ses düzeyini aşağıdan ayarlayabilirsiniz.',
    volumeTitle: 'Ses Düzeyi'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Çağrı',
    chat: 'Sohbet',
    email: 'E-posta',
    facebook: 'Messenger',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google\'s Business Messages"
  },
  orgDetailsLabels: {
    role: 'Rol',
    department: 'Departman',
    email: 'E-posta',
    businessPhone: 'İş Telefonu',
    workPhone: 'İş',
  },
  addressListError: {
    title: 'Veriler yüklenemedi',
    errorId: 'Hata Kimliği:'
  },
  keypad: {
    keyPadSearch: 'Numarayı girin',
    dialPad: 'Arama Tuşları'
  },
  collabTool: {
    userAuthenticated: 'Kullanıcı kimlik doğrulaması:',
    successful: 'Başarılı',
    failed: 'Başarısız oldu.',
    tryAgain: 'Tekrar Deneyin',
    stateSync: 'Durum senkronizasyonu:',
    mercuryFailedInfo: ' Yöneticinizle görüşün.',
    retrying: 'Yeniden deneniyor...',
    trackingIdLabel: 'Takip Kimliği: '
  },
  webex: {
    webex: 'Webex',
    info: 'Entegrasyon, Desktop ile Webex arasında durumları senkronize etmenize olanak sağlar.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Bu entegrasyon sayesinde Microsoft Teams kullanıcılarına danışabilir veya çağrı aktarabilirsiniz.',
    authenticationFailedInfo:
      'Bir kimlik doğrulama penceresi zaten açıksa kimlik doğrulamayı bu pencerede yeniden deneyin.',
    ListItemContactDetails:
      'Kişinin adı: {name}, durumu: {presence}, departmanı: {department}, iş ünvanı: {jobTitle} ve telefon numarası: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Acil Servis Bildirimi',
    readNotification: 'Bildirimi okudum.'
  },
  webexPresenceStatus: {
    active: 'Etkin',
    lastActiveFewMinutesAgo: 'Son birkaç dakika içinde aktifti',
    lastActiveMinutesAgo: '{min} dakika önce aktifti',
    lastActive1HourAgo: 'Son etkinlik 1 saat önce',
    lastActiveHoursAgo: '{hour} saat önce aktifti',
    lastActiveYesterday: 'Dün aktifti',
    lastActiveOnDate: '{date} tarihinde aktifti',
    busy: 'Meşgul',
    busyUntil: '{date} tarihine kadar meşgul',
    dnd: 'RahatsızEtme',
    dndUntil: '{date} tarihine kadar rahatsız etmeyin',
    quiet: 'Sessiz',
    quietUntil: '{date} tarihine kadar sessiz',
    ooo: 'Ofis dışında',
    outOfOfficeUntil: '{date} tarihine kadar ofis dışında',
    call: 'Çağrıda',
    meeting: 'Toplantıda',
    calendarItem: 'Takvim toplantısında',
    presenting: 'Sunum yapıyor',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Ada veya profil ayrıntılarına göre ara',
    webexPlaceholder: 'Ada veya e-postaya göre ara',
    refreshTheList: 'Listeyi Yenile',
    refreshAddressBook: 'Adres Defterini Yenile',
    microsoftAuthError: 'Görüntülenecek kişi yok. Microsoft kimlik doğrulaması yapılamadı.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/uk.js":
/*!*********************************!*\
  !*** ./src/i18n/messages/uk.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: 'Не вдалося завантажити дані',
    errorID: 'Ідентифікатор помилки',
    tryAgain: 'Спробуйте ще раз',
    Error: 'Помилка',
    okButton: 'ОК',
    Yes: 'Так',
    Cancel: 'Скасувати',
    Confirm: 'Підтвердити',
    Continue: 'Продовжити',
    Canceling: 'Скасування',
    CiscoAiAssistant: 'Cisco AI Assistant',
    Answer: 'Відповісти',
    AnswerAriaLabel: 'Відповісти на настільне завдання',
    Decline: 'Відхилити',
    ErrorSecurityCompliance: 'Відповідність вимогам безпеки',
    errorDetails: 'Деталі помилки',
    learnMore: 'Детальніше',
    showLess: 'Показати менше',
    trackingIdDescription:
      'Поділіться ідентифікатором відстеження з адміністратором сайту або службою підтримки, щоб розібратися в ситуації.',
    trackingIdInputLabel: 'Ідентифікатор відстеження: ',
    submitForm: 'Надіслати форму',
    unnamedStatus: 'Безіменний стан',
    errorChatMsg: 'Не вдалося завантажити дані чата',
    noOptions: 'Немає параметрів',
    noResults: 'Немає результатів',
    more: 'Більше',
    nomatchfound: 'Не знайдено збігів',
    collaborationTool: 'Інструмент для співпраці',
    timerAriaLabel: 'Витрачений час',
    historyItemTime: 'Коли сталося:',
    loading: 'Завантаження',
    months: [
      'Січень',
      'Лютий',
      'Березень',
      'Квітень',
      'Травень',
      'Червень',
      'Липень',
      'Серпень',
      'Вересень',
      'Жовтень',
      'Листопад',
      'Грудень'
    ],
    loadingMsg: 'Завантаження…',
    search: 'Пошук',
    historyChannelLabels: {
      All: 'Усі',
      telephony: 'Голос',
      chat: 'Чат',
      email: 'Електронна пошта',
      social: 'Соціальні мережі'
    },
    homePageLabel: 'Головна сторінка',
    resizeHistoryDragger: 'Перетягувач для зміни розміру історії',
    agentHistoryLabel: 'історія оператора',
    clear: 'Очистити вхідні дані',
    ariaLabelAgentHistoryWrapper:
      'В історії взаємодії з оператором відображаються останні комунікації з клієнтами по різних каналах за останні 24 години',
    sliderResizerInstructions:
      'Зараз ви на повзунку. Щоб змінити розмір, використовуйте клавіші зі стрілками',
    resizeHistoryPanel: 'Змінити розмір панелі історії, повзунок,',
    time: {
      hours: 'год.',
      minutes: 'хв',
      seconds: 'с'
    }
  },
  email: {
    ToLabel: 'Кому',
    FromLabel: 'Від',
    CcLabel: 'Копія',
    BccLabel: 'Прихована копія',
    SubjectLabel: 'Тема',
    HideLabel: 'Приховати',
    SendLabel: 'Надіслати',
    ShowPrevThread: 'Показати попередній ланцюжок',
    HidePrevThread: 'Сховати попередній ланцюжок',
    ReplyLabel: 'Відповісти',
    ReplyAllLabel: 'Відповісти всім',
    ViewOriginalMail: 'Переглянути оригінальний електронний лист',
    QuickReplyInp: 'Уведіть швидку відповідь тут…',
    AttachFiles: 'Вкласти файли',
    ToolbarHeading: 'Заголовок1',
    ToolbarBold: 'Жирний',
    ToolbarItalic: 'Курсив',
    ToolbarUnderLine: 'Підкреслений',
    ToolbarBlockQuote: 'Блок-цитата',
    ToolbarCode: 'Кодовий блок',
    ToolbarListOrder: 'Відобразити впорядкованим списком',
    ToolbarListBullet: 'Відобразити маркірованим списком',
    ToolbarLink: 'Посилання',
    ToolbarStrike: 'Закреслений',
    ToolbarColor: 'Колір тексту',
    ToolbarTable: 'Таблиця',
    insertTable: 'Вставити таблицю',
    insertRowAbove: 'Вставити рядок вище',
    insertRowBelow: 'Вставте рядок нижче',
    insertColumnLeft: 'Вставити стовпець зліва',
    insertColumnRight: 'Вставити стовпець справа',
    deleteRow: 'Видалити рядок',
    deleteColumn: 'Видалити стовпець',
    deleteTable: 'Видалити таблицю',
    link: 'Посилання',
    IndentRight: 'Правий відступ',
    IndentLeft: 'Лівий відступ',
    showMoreAttachment: 'Показати більше вкладених файлів',
    AttachmentLimit: 'Вкласти до ',
    attachments: ' файлів, ',
    sizeLimit: ' МБ максимально',
    attachment: 'Вкладений файл',
    errordeleteattachment: 'Неможливо видалити файли. Спробуйте ще раз.',
    errordownloadattachment: 'Неможливо завантажити файли. Спробуйте ще раз.',
    erroraddattachemnt: 'Неможливо завантажити файли. Спробуйте ще раз.',
    errorendcontact: 'Неможливо завершити взаємодію. Спробуйте ще раз.',
    erroraddlimitreached:
      'Не вдалося прикріпити файл, оскільки він перевищує максимальний ліміт ',
    errorattachmentdrop:
      'Вкладення видалено відповідно до політики безпеки компаніїâ€™.',
    errorfiletype: 'Тип файлу не підтримується. Спробуйте ще раз.',
    errorcreditcard:
      'Не вдається завантажити вкладені файли відповідно до політики безпеки компаніїâ€™.',
    errorcontainsimage:
      'Не вдається завантажити вкладені файли. Зображення у вкладених файлах не підтримуються політикою безпеки компаніїâ€™.',
    errorlimit: ' МБ – обмеження.',
    errorsendemail: 'Неможливо надіслати електронний лист. Спробуйте ще раз.',
    errorpcicheckemail: 'Неможливо отримати дані PCI. Спробуйте ще раз.',
    errortext: 'Не вдалося завантажити дані',
    tryAgain: 'Спробуйте ще раз',
    replywarning:
      'Не надавайте інформацію про фінанси, здоров’я чи будь-яку персональну інформацію (PII) у цьому повідомленні або вкладених файлах.',
    datamasked:
      'Тема або текст електронного листа відредаговано відповідно до політики безпеки компаніїâ€™. Ви точно хочете надіслати електронний лист?',
    pcibannerwarning:
      'Тема або текст електронного листа відредаговано відповідно до політики безпеки компаніїâ€™.',
    on: 'Увімк.',
    wrote: 'написав'
  },
  interaction_control: {
    windowOpened: 'Вікно відкрито',
    connected: 'Підключено',
    consultRequested: 'Запит на консультацію надіслано',
    consulting: 'Консультація',
    consultCallOnHold: 'Консультація на утриманні',
    callOnHold: 'Виклик на утриманні',
    consult: 'Проконсультуватися',
    endconsult: 'Завершити консультацію',
    hold: 'Утримувати',
    transfer: 'Передати',
    conference: 'Конференція',
    endconference: 'Завершити конференцію',
    conferenceRequested: 'Запит на конференцію надіслано',
    switchCall: 'Перемкнути',
    mergeCall: 'Об’єднати',
    wrapup: 'Завершення',
    end: 'Завершити',
    customername: 'Ім’я клієнта',
    dn: 'DNIS',
    ivrpath: 'Шлях IVR',
    email: 'Електронна пошта клієнта',
    ani: 'Номер телефону',
    queueid: 'Назва черги',
    ronatimeout: 'час RONA',
    pathid: 'Ідентифікатор шляху IVR',
    dnis: 'DNIS',
    destagentphonenumber: 'DN оператора',
    destagentname: 'Ім’я оператора',
    virtualteamname: 'Черга',
    category: 'Категорія',
    additionaldetails: 'Додаткова інформація',
    sourcenumber: 'Номер джерела',
    sourcepage: 'Сторінка джерела',
    appuser: 'Ідентифікатор користувача додатка',
    customernumber: 'Номер телефону',
    exitconference: 'Вийти з конференції',
    resume: 'Відновити',
    pauserecording: 'Призупинити запис',
    resumerecording: 'Відновити запис',
    exitconsult: 'Вийти з консультації',
    pauseRecordingFailed: 'Не вдається призупинити запис. Спробуйте ще раз.',
    resumeRecordingFailed: 'Не вдається відновити запис. Спробуйте ще раз.',
    holdCallFailed: 'Неможливо поставити виклик на утримання. Спробуйте ще раз.',
    resumeCallFailed: 'Не вдається відновити виклик. Спробуйте ще раз.',
    endCallFailed: 'Неможливо завершити взаємодію. Спробуйте ще раз.',
    consultTransferFailed:
      'Не вдається передати консультаційний виклик. Спробуйте ще раз.',
    conferenceTransferFailed:
      'Не вдається передати конференц-виклик. Спробуйте ще раз.',
    conferenceFailed:
      'Не вдається підключитися до запиту на конференц-виклик. Спробуйте ще раз.',
    consultEndFailed: 'Не вдалося завершити запит на консультацію. Спробуйте ще раз.',
    conferenceExitFailed:
      'Не вдалося вийти із запиту на конференц-виклик. Спробуйте ще раз.',
    conferenceEndFailed:
      'Не вдалося завершити запит на конференц-виклик. Спробуйте ще раз.',
    cancelCtqFailed:
      'Неможливо скасувати консультаційний виклик і поставити його до черги. Спробуйте ще раз.',
    privacyShield: 'Щит конфіденційності',
    errorOnPrvacyShieldForConsult:
      'Наразі запис призупинено. Відновіть запис, щоб почати консультаційний виклик.',
    errorOnPrvacyShieldForTransfer:
      'Наразі запис призупинено. Відновіть запис, щоб почати передачу виклику.',
    cancelConsult: 'Скасувати консультацію',
    cancelTransfer: 'Скасувати передачу',
    copy: 'Копіювати',
    copied: 'Скопійовано',
    cadrequestuccess: 'Інформація про клієнта була успішно збережена.',
    cadrequestfailure: 'Не вдалося зберегти інформацію про клієнта. Спробуйте пізніше.',
    cadupdatedmessage: 'Інформація про клієнта нещодавно оновлена',
    unsavedmessage: 'Ваші незбережені зміни буде перезаписано.',
    save: 'Зберегти',
    revert: 'Повернути',
    expandDetails: 'Розгорнути інформацію',
    collapseDetails: 'Сховати інформацію',
    cadValidationError:
      'Неприпустимий формат. Використовуйте міжнародний стандарт дати та часу.',
    secureCadSaveError:
      'Інформацію про клієнта не збережено. Клацніть Зберегти, щоб повторити спробу.',
    secureDecryptionError: 'Захищені змінні не можуть бути відображені.',
    clickToTry: 'Клацніть, щоб повторити спробу',
    isSecureVariable: 'є захищеною змінною',
    contactorigin: 'Зв’яжіться з Origin',
    resumeMonitoring: 'Продовжити моніторинг',
    pauseMonitoring: 'Призупинити моніторинг',
    whisperCoach: 'Симулятор шепоту',
    bargeIn: 'Втрутитися',
    endMonitoring: 'Завершити моніторинг',
    contactphonenumber: 'Контактний номер телефону',
    contactqueue: 'Черга контактів',
    activeparticipants: 'Активні учасники',
    consultedparticipant: 'Проконсультований учасник',
    contactstatus: 'Стан контакту',
    timeincontactstatus: 'Час у стані контакту',
    totalcontactduration: 'Загальна тривалість контактів',
    agentinteractiontime: 'Тривалість взаємодії',
    recording: 'Запис',
    monitoring: 'Моніторинг',
    monitoringPaused: 'Моніторинг призупинено',
    pauseMonitoringFailed: 'Не вдалося призупинити моніторинг. Спробуйте ще раз',
    resumeMonitoringFailed: 'Не вдалося продовжити моніторинг. Спробуйте ще раз',
    callCancelledInProgress: 'Триває скасування виклику',
    bargedIn: 'Втручання',
    keypad: 'Клавіатура',
    mute: 'Вимкнути звук',
    unmute: 'Увімкнути звук',
    bargeInTooltipText:
      'Мікрофон увімкнеться, і ви приєднаєтеся до цієї взаємодії з клієнтом',
    bargeInCompactTooltipText:
      'Втрутитися. Мікрофон увімкнеться, і ви приєднаєтеся до цієї взаємодії з клієнтом',
    bargeInTooltipDisabled: 'Відновіть моніторинг, щоб дозволити втручання',
    bargeInFailedTitle: 'Не вдалося втрутитися',
    bargeInFailedData:
      'Під час спроби втрутитися сталася помилка. Повторіть спробу пізніше.',
    supervisorBargedIn: 'втручається у ваш дзвінок.',
    leftInteraction: 'залишає взаємодію.',
    conferenceEnded: 'Конференц-виклик завершено.',
    participants: 'Учасники',
    badgeAriaLabel: '{participant} має виклик',
    bargeInConferenceAriaLabel: 'Два учасники взаємодії',
    taskName: 'Ім’я завдання керування взаємодією',
    interactionDurationLabel: 'Тривалість',
    wrapupassist: 'Допомога із завершенням',
    consultingTaskContext: 'Консультаційний виклик від',
    consultExited: 'Консультаційний виклик перервано',
    endCall: 'Завершити виклик.',
    exitconferenceCall:
      'Вийти з виклику. Конференція продовжиться з активними учасниками.',
    recordingInProgess: 'Триває запис',
    recordingPaused: 'Запис призупинено',
    searchPlaceholder: 'Пошук контактів',
    postCall: "Після виклику",
    switchCallTooltip: "Переключитися на виклик",
    switchConsultTooltip: "Переключитися на консультаційний виклик",
    switchConferenceTooltip: "Переключитися на конференц-виклик",
    confirmationDialog: {
      endCallTitle: 'Бажаєте завершити виклик?',
      endCallMessage: 'Натисніть "Підтвердити", щоб завершити виклик для всіх учасників.',
      exitConferenceTitle: 'Дійсно вийти з конференц-виклику?',
      exitConferenceMessage:
        'Натисніть "Підтвердити", щоб вийти з конференц-виклику — він продовжиться з рештою учасників.',
      confirmButtonLabel: "Підтвердити",
      cancelButtonLabel: "Скасувати",  
    },
    postCallOnHold: "Опитування після виклику на утриманні",
    postCallConsult: "Консультація після виклику",
    postCallConsultOnHold: "Консультація після виклику на утриманні",
  },
  agentProfile: {
    teamName: 'Команда',
    dialNumber: 'Набрати номер',
    phoneNumber: 'Номер телефону',
    settings: 'Змінити параметри',
    signOut: 'Вийти',
    webRTCDisconnected: 'Попередження: телефонію через ПК відключено ',
    msAuthFailed: 'Помилка автентифікації Microsoft',
    stateSyncFailed: 'Не вдалося синхронізувати стан',
    userProfileLabel: 'Профіль користувача',
    ariaAgentprofile: 'Профіль оператора',
    ChannelCapacity: 'Спроможність каналу',
    voice: 'Голос',
    chat: 'Чат',
    email: 'Електронна пошта',
    social: 'Соціальні мережі',
    channelCapacityTooltip: 'Натисніть, щоб переглянути деталі',
    blendedRouting: 'Змішаний',
    exclusiveRouting: 'Ексклюзивна маршрутизація',
    realtimeRouting: 'Змішана маршрутизація в режимі реального часу',
    blendedRoutingTooltip: 'Обробляйте кілька контактів у різних каналах.',
    exclusiveRoutingTooltip: 'Обробляйте лише один контакт за раз.',
    realtimeRoutingTooltip: 'Обробляйте один обов’язковий канал у режимі реального часу.',
    errorActiveContacts:
      'Ви не можете вийти зараз, оскільки ви маєте активні розмови. Завершіть їх і спробуйте ще раз.',
    searchTeams: 'Шукати команди',
    changeTeamsConfirmHeader: 'Змінити підтвердження команди',
    changeTeamsConfirmMessage: 'Ви точно хочете змінити команду?',
    changeTeamLabel: 'Змінити команду',
    errorChangeTeams:
      'Зараз ви не можете змінити команду, оскільки у вас є активні запити. Заповніть їх і повторіть спробу.',
    saveTeamSelection: 'Зберегти вибір команди',
    userSettings: 'Налаштування користувача',
    resetLayout: 'Скинути весь макет робочого столу',
    resetConfirmHeader: 'Скинути підтвердження макета',
    resetConfirmMessage:
      'Ви впевнені, що хочете скинути весь макет робочого столу? <br/> Буде відновлено стандартний макет робочого столу.',
    downloadLogs: 'Завантажити звіт про помилку',
    help: 'Довідка',
    signoutConfirm: 'Ви точно хочете вийти?',
    signoutConfirmHeader: 'Підтвердження виходу',
    darkTheme: 'Переключитись у темний режим',
    newLook: 'Переключитись на новий вигляд',
    keyboardShortcuts: 'Сполучення клавіш',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: 'Налаштування сповіщень',
    silentNotification: 'Беззвучне сповіщення',
    enableNotificationSettings: 'Увімкнути сповіщення',
    enableSilentNotificationSettings: 'Увімкнути беззвучні сповіщення',
    suppressWebexCallingNotificationSettings: 'Приховати сповіщення Webex Calling',
    notificationSettingDescription:
      'Надсилає сповіщення, як-от нові повідомлення, сповіщення та зміни стану.',
    silentNotificationDescription:
      'Вимикає сповіщення на екрані. Ви можете переглянути сповіщення в Центрі сповіщень.',
    suppressWebexCallingNotificationDescription: 
    'Не показувати спливаючі сповіщення про вхідні виклики Webex і відповідати на них з контактного центру Webex.',
    arrowLabel: 'Повернутися',
    managedTeams: 'Керовані команди',
    managedTeamsError: 'Не вдалося завантажити дані щодо команд.',
    viewAll: 'Переглянути всі',
    profileSettings: 'Налаштування профілю',
    userRole: 'Роль',
    saveSelection: 'Зберегти виділення',
    extension: 'Внутрішній номер',
    changeProfileConfirmHeader: 'Підтвердьте зміни налаштувань профілю',
    changeProfileConfirmMessage:
      'Ви точно хочете зберегти зміни свого профілю?',
    confirm: 'Підтвердити',
    errorProfileUpdate:
      'Зараз ви не можете змінити налаштування профілю, оскільки у вас є активні запити. Заповніть їх і повторіть спробу.',
    roleAgentSupervisor: 'Керівник і оператор',
    roleSupervisor: 'Керівник',
    noTeam: 'Немає команди',
    testYourNetwork: 'Перевірити мережу',
    speakerAndMic: 'Динамік і мікрофон',
    speaker: 'Динамік',
    mic: 'Мікрофон',
    speakerDescription:
      'Виберіть і протестуйте пристрій виводу, щоб переконатися, що ви чуєте абонента.',
    micDescription:
      'Виберіть і протестуйте пристрій вводу, щоб переконатися, що абонент чує вас.',
    micError:
      'Доступ до мікрофона заборонений. Увімкніть доступ через налаштування браузера або зверніться до адміністратора.',
    speakerError:
      'Динамік наразі недоступний, оскільки доступ до мікрофона заборонений.',
    telephony: 'Телефонія',
    desktop: 'Робочий стіл',
    onSpeakerPlay:
      'Якщо ви не чуєте тестовий звук, перевірте динамік.',
    onMicPlay:
      'Якщо ви не чуєте тестовий звук, перевірте динамік і мікрофон.',
    onMicRecord: 'Запишіть повідомлення для відтворення.',
    test: 'Тест',
    recording: 'Запис',
    playing: 'Відтворюється',
    reconnecting: 'Повторне підключення',
    disconnectMessage:
      'Телефонію через ПК відключено. Спробуйте інший варіант телефонії.',
    singleTelephonyDisconnectMessage:
      'Телефонію через ПК відключено. Зверніться до адміністратора.',
    clear: 'Очистити вхідні дані',
    rememberMeCheckBoxMessage: "Більше не показувати",
    saveLabel: 'Зберегти',
    browserUnsupportedError: "Не вдалося ввійти, оскільки ваш браузер не підтримується.",
    microphoneAccessDeniedError: "Доступ до мікрофона заборонений. Увімкніть доступ через налаштування браузера або зверніться до адміністратора.",
  },
  contactHistory: {
    mainHeader: 'Історія контактів',
    handledBy: 'Оброблено',
    noRecordFound: 'Історію контактів не знайдено!',
    tryAgain: 'Спробуйте ще раз',
    errorMsg: 'Не вдається отримати історію контактів. Спробуйте ще раз.',
    errorID: 'Ідентифікатор помилки',
    missingAni: 'ANI відсутній',
    timeIcon: 'Тривалість',
    taskHandled: 'Завдання виконано',
    noHistoryNew: 'Немає історії',
    noHistory: 'Немає історії',
    viewTranscript: 'Переглянути повідомлення електронної пошти',
    transcriptFor: 'Стенограми для',
    editBeforeCall: 'Змінити перед викликом',
    clickToCall: 'Клацніть, щоб здійснити виклик',
    onAnActiveCallErrorMessage:
      'Ви не можете розпочати новий виклик, оскільки у вас уже триває активний виклик.',
    receivedFrom: 'Контакт отримано від',
    initiatedTo: 'Контакт ініційовано до',
    wrapUpReason: 'Причина завершення',
    startCallTelephony:
      'Натисніть посилання на номер телефону, щоб розпочати вихідний виклик.',
    contactHistoryList: 'Список історії контактів,',
    wrapUpCode: 'Код завершення',
    agentName: 'Ім’я оператора',
    entryPointName: 'Точка входу',
    acceptedTimeAndDate: 'Дата й час прийняття',
    duration: 'Тривалість',
    emailTranscript: 'Надіслати стенограму електронною поштою',
    clickToViewEmailTranscript: 'Натисніть, щоб переглянути стенограму електронною поштою',
    listContainer: 'Контейнер списків'
  },
  contactTranscript: {
    agent: 'Оператор',
    entryPoint: 'Точка входу',
    date: 'Дата',
    subject: 'Тема',
    from: 'Від',
    sent: 'Надіслано',
    to: 'Кому',
    back: 'Назад',
    errorTranscript: 'Під час отримання стенограм сталася помилка',
    customer: 'Клієнт',
    inboundErrorMessage: 'Не вдалося завантажити електронну пошту клієнта',
    outboundErrorMessage: 'Не вдалося завантажити відповідь оператора'
  },
  popoverTitle: {
    callback: 'Перетелефонувати',
    outboundCall: 'Вихідний виклик',
    incomingCall: 'Вхідний виклик',
    progressiveCampaign: 'Виклик кампанії',
    courtesyCallback: 'Зворотний виклик ввічливості',
    chat: 'Вхідне повідомлення в чаті',
    incoming: 'Вхідні',
    monitoringCall: 'Виклик із моніторингом'
  },
  connecting: 'Підключення',
  initiating: 'Ініціювання',
  outbound: 'Вихідні',
  transfer: {
    title: 'Запит на передачу',
    heading: {
      chat: 'Виберіть оператора або чергу, куди ви хочете передати виклик.',
      email: 'Виберіть чергу, куди ви хочете передати виклик.',
      telephony:
        'Виберіть оператора, чергу або номер набору, куди ви хочете передати виклик.',
      noQueueTelephony:
        'Виберіть оператора або номер набору, куди ви хочете передати виклик.'
    },
    header: {
      chat: 'Виберіть оператора або чергу для передачі цього контакту.',
      email: 'Виберіть чергу для передачі цього контакту.',
      telephony:
        'Виберіть оператора, чергу, номер набору або організацію для передачі цього контакту.',
      noQueueTelephony:
        'Виберіть оператора, номер набору або організацію для передачі цього контакту.',
      noOrganizationTelephony:
        'Виберіть оператора, чергу або номер набору для передачі цього контакту.',
      noQueueOrganizationTelephony:
        'Виберіть оператора або номер набору для передачі цього контакту.'
    },
    queues: 'Черга',
    agents: 'Оператор',
    dialNumber: 'Набрати номер',
    organization: 'Організація',
    placeholder: {
      Queues: 'Виберіть зі списку черг',
      Agents: 'Виберіть зі списку операторів',
      DialNumber: 'Виберіть за іменем або номером',
      DialNumberOrEntryPoint: 'Виберіть за іменем, номером або точкою входу',
      ChooseByNameOrNumber: 'Виберіть за іменем/номером',
      Organization: 'Пошук за назвою/посадою/відділом/робочим телефоном',
      WebexOrganization: 'Пошук за ім’ям або ел. поштою',
      DialNumberSearch: 'Пошук за ім’ям або номером'
    },
    type: 'Передати',
    cancel: 'Скасувати',
    closeModal: 'Закрити Modal',
    failureError: 'Не вдалося передати запит. Спробуйте ще раз.',
    entryPoint: 'Точка входу'
  },
  consult: {
    title: 'Запит на консультацію',
    heading: {
      chat: 'Виберіть оператора або чергу, куди ви хочете передати виклик.',
      email: 'Виберіть чергу, куди ви хочете передати виклик.',
      telephony:
        'Виберіть оператора, чергу або номер набору, з якими хочете провести консультацію.',
      noQueueTelephony:
        'Виберіть оператора або номер набору, з якими хочете провести консультацію.'
    },
    header: {
      chat: 'Виберіть оператора або чергу для передачі цього контакту.',
      email: 'Виберіть чергу для передачі цього контакту.',
      telephony:
        'Виберіть оператора, чергу, номер набору або організацію, з якими хочете провести консультацію.',
      noQueueTelephony:
        'Виберіть оператора, номер набору або організацію, з якими хочете провести консультацію.',
      noOrganizationTelephony:
        'Виберіть оператора, чергу або номер набору, з якими хочете провести консультацію.',
      noQueueOrganizationTelephony:
        'Виберіть оператора або номер набору, з якими хочете провести консультацію.'
    },
    queues: 'Черга',
    agents: 'Оператор',
    dialNumber: 'Набрати номер',
    organization: 'Організація',
    placeholder: {
      Queues: 'Виберіть зі списку черг',
      Agents: 'Виберіть зі списку операторів',
      DialNumber: 'Виберіть за іменем або номером',
      DialNumberOrEntryPoint: 'Виберіть за іменем, номером або точкою входу',
      ChooseByNameOrNumber: 'Виберіть за іменем/номером',
      Organization: 'Пошук за назвою/посадою/відділом/робочим телефоном',
      WebexOrganization: 'Пошук за ім’ям або ел. поштою',
      DialNumberSearch: 'Пошук за ім’ям або номером'
    },
    type: 'Проконсультуватися',
    checkBoxLabel: 'Дозволити учасникам продовжити взаємодію.',
    cancel: 'Скасувати',
    closeModal: 'Закрити Modal',
    failureError: 'Не вдається підключитися до запиту на консультацію. Спробуйте ще раз.',
    customerLeftMsg: 'Клієнт від’єднався. Консультація більше не потрібна.',
    ctqFailureMsg:
      'Неможливо скасувати консультаційний виклик і поставити його до черги. Спробуйте ще раз.',
    cancelCtqInfo:
      'Пошук доступного оператора у вибраній черзі. Зачекайте або скасуйте запит на консультацію.',
    cancelCtqAction: 'Скасувати консультацію',
    entryPoint: 'Точка входу'
  },
  conference: {
    title: 'Запит на конференцію',
    heading: {
      chat: 'Виберіть конкретного оператора для конференц-чата'
    },
    queues: 'Черга',
    agents: 'Оператор',
    dialNumber: 'Набрати номер',
    organization: 'Організація',
    placeholder: {
      Queues: 'Виберіть зі списку черг',
      Agents: 'Виберіть зі списку операторів',
      DialNumber: 'Виберіть за іменем або номером'
    },
    type: 'Конференція',
    cancel: 'Скасувати',
    closeModal: 'Закрити Modal',
    failureError: 'Не вдається розпочати запит на конференц-виклик. Спробуйте ще раз.'
  },
  transferModal: {
    Agents: 'Не вдається отримати список операторів, оновіть його.',
    AgentsEmpty: 'Немає доступних операторів',
    Queues: 'Не вдається отримати список черг, оновіть його.',
    QueuesEmpty: 'Немає доступної черги',
    EPEmpty: 'Немає доступної точки входу',
    DialNumber:
      'Не вдається отримати список номерів набору з адресної книги. Оновіть список.',
    EntryPoint:
      'Не вдається отримати список номерів точок входу. Оновіть список.',
    Common: 'Не вдається отримати список. Оновіть список.',
    DialNumberEmpty: 'Немає доступного номера для набору',
    DialNumbInvalid:
      'Номер набору неприпустимий. Зверніться до адміністратора.',
    DialNumbOrEntryPointInvalid:
      'Номер набору або точка входу неприпустимі. Зверніться до адміністратора.',
    refreshQueueList: 'Оновити список черг',
    refreshAgentList: 'Оновити список операторів',
    refreshEpList: 'Оновити точки входу',
    refreshAddressBook: 'Оновити адресну книгу',
    refreshTheList: 'Оновити список',
    entryPointSectionLabel: 'Точка входу',
    addressBookSectionLabel: 'Адресна книга',
    organization: 'Організація',
    comboBoxAriaLabelAgent: 'Виберіть зі списку операторів',
    comboBoxAriaLabelQueue: 'Виберіть зі списку черг',
    comboBoxAriaLabelEp: 'Виберіть зі списку точок входу',
    infScrollAgent: 'Пошук операторів',
    infScrollQueue: 'Пошук черг',
    infScrollEP: 'Пошук точок входу',
    allRadioButtonHidedTextForConsult: 'У вас немає призначених об\'єктів для консультації в цій взаємодії. Зверніться до адміністратора.',
    allRadioButtonHidedTextForTransfer: 'У вас немає призначених об\'єктів для передачі цієї взаємодії. Зверніться до адміністратора.',
    allRadioButtonHidedTextForConference: 'У вас немає призначених об\'єктів для конференції в цій взаємодії. Зверніться до адміністратора.',
    searchMinCharError: 'Введіть принаймні три символи для пошуку.',
  },
  wrapup: {
    cancelautowrapup: 'Скасувати автоматичне завершення',
    wrapupreason: 'Причини завершення',
    untilautowrapup: 'до автоматичного завершення',
    followupsetting: 'Наступне налаштування',
    lastagentroute: 'Маршрутизація останнього оператора',
    submitwrapup: 'Надіслати запит на завершення',
    wrapupsearch: 'Шукати причини завершення',
    invalidationError: 'Не вдалося надіслати запит на завершення',
    searchResult: 'Доступні результати пошуку',
    noResultFound: 'Не знайдено результатів пошуку',
    listContainerLabel: 'Контейнер списків для завершення',
    searchError: 'Введіть принаймні три символи для пошуку серед причин завершення.',
  },

  outdial: {
    call: 'Виклик',
    dialpadSearch: 'Уведіть номер для набору',
    addressSearch: 'Пошук за іменем/номером',
    addressTab: 'Адреса',
    addressTabTooltip: 'Пошук в адресній книзі',
    dialpadTab: 'Циферблат',
    dialpadTooltip: 'Набрати номер',
    searchTab: 'Пошук',
    searchTabTooltip:'Пошук людей у моїй організації',
    noAdrFound: 'Не знайдено збігів',
    noContacts: 'Немає контактів',
    mainIconTooltip: 'Набраний виклик',
    errorOutdialFailed:
      'Помилка набраного виклику. Робочому столу не вдалося підключитися до виклику, або на виклик не відповіли.',
    errorOutdialDisabled: 'Набрані виклики вимкнено',
    errorDialPadValidationMessage: 'Неправильний формат',
    outdialReqInProgress: 'Триває набраний виклик',
    outdialAniPlaceholder: 'Вибрати набрані ANI',
    outdialAniLabel: 'Набрані ANI',
    outdialAniPlaceHolder: 'Пошук набраного ANI',
    errorDcCallsLimitExceeded:
      'Досягнуто максимального обмеження набраних викликів для центру обробки даних. Неможливо більше здійснювати набір.',
    errorOrgCallsLimitExceeded:
      'Досягнуто максимального обмеження набраних викликів для організації. Неможливо більше здійснювати набір.',
    errorOutDialNoAnswerFromCustomer:
      'Клієнт не відповів на ваш виклик. Спробуйте здійснити виклик пізніше.',
    errorOutDialCustomerUnavailable:
      'Клієнт зараз недоступний. Спробуйте здійснити виклик пізніше.',
    errorOutDialAgentEnds: 'Ви завершили виклик із клієнтом.',
    errorOutDialCustomerBusy: 'Клієнт зараз зайнятий. Спробуйте здійснити виклик пізніше.',
    searchError: 'Введіть принаймні три символи для пошуку контактів.',
    upArrowLabel: 'Розгорнути',
    clear: 'Очистити вхідні дані',
    outdialDialogDescription: 'Зараз ви в діалоговому вікні з вкладками.'
  },

  organization: {
    noMatchFound: 'Не знайдено збігів',
    searchError: 'Введіть принаймні три символи для пошуку контактів.',
    authError: 'Немає контактів для відображення. Помилка автентифікації Microsoft.'
  },

  interactionPopover: {
    of: 'з',
    accept: 'Прийняти',
    acceptAriaLabel: 'Прийняти завдання {taskNumber} — {taskType} від користувача {from}',
    requests: 'Запит(и)',
    back: 'назад',
    next: 'далі',
    acceptMultipleRequest: 'Прийняти {requestCount} запитів',
    paginationDetail: '{indexStart}-{indexEnd} з {totalPopoverpoolLength}',
    hidePopoverDetails: 'Приховати деталі спливаючого вікна',
    showPopoverDetails: 'Показати деталі спливаючого вікна',
    customerName: 'Ім’я клієнта',
    email: 'Електронна пошта',
    queueName: 'Назва черги',
    failedToAccept: 'Не вдалося прийняти.',
    unableToAccept: 'Неможливо прийняти контакт.',
    failedToEnd: 'Не вдалося завершити.',
    unableToEnd: 'Неможливо завершити контакт. ',
    ringing: 'Дзвінок',
    calling: 'Виклик',
    phoneNumber: 'Номер телефону',
    dni: 'DNIS',
    ivrPathId: 'Ідентифікатор шляху IVR',
    pathId: 'Ідентифікатор шляху',
    rona: 'RONA',
    sourcePage: 'Сторінка джерела',
    sourceNumber: 'Номер джерела',
    appUserId: 'Ідентифікатор користувача додатка',
    acceptAll: 'Прийняти всі завдання',
    agentDn: 'DN оператора',
    agentName: 'Ім’я оператора',
    agentTeam: 'Група операторів',
    requestDetails: 'Деталі запиту',
    incomingCallFrom: 'Вхідний виклик від',
    unableToAnswer: 'Не вдається відповісти на виклик. Спробуйте ще раз.',
    unableToDecline: 'Не вдається відхилити виклик. Спробуйте ще раз.'
  },

  multiLogin: {
    header: 'Сповіщення про багаторазовий вхід',
    message:
      'Ви виконали вхід до робочого столу в кількох екземплярах програми. Натисніть "Продовжити", щоб продовжити роботу з робочим столом у цьому екземплярі програми. В іншому випадку закрийте це вікно.',
    continue: 'Продовжити'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: 'Не вдалося перенести дані до точки входу/черги через помилку конфігурації.',
    1010: "Не вдалося провести консультацію, оскільки агента неможливо було призначити вчасно. ",
    1042: "Контакт не знайдено",
    1043: 'Неприпустимий пункт призначення.',
    1045: 'Взаємодія не призначена агенту.',
    1046: 'Консультація з агентом не проведена, оскільки в системі не знайдено канал відповідного агента.',
    1038: "Агента не знайдено",
    1037: 'Не вдалося виконати вхід через внутрішню помилку.',

    // Media Events
    138: 'Не вдалося виконати дію з невідомих причин.',
    136: 'Користувача не знайдено',

    // AgentConsultFailed
    1050: 'Не вдалося провести консультацію через непідтримувану конфігурацію або активність у потоці. ',
    1005: "Не вдалося провести консультацію, оскільки агент не відповів на запит вчасно.",
    1051: 'Не вдалося проконсультувати або передати через недійсну точку входу або номер набору.',

    // AgentInviteFailed
    1053: 'Не вдалося представити взаємодію, оскільки є очікуване завдання черги робочого процесу.',
    1054: 'Не вдалося здійснити виклик із набором номера через проблеми з носієм, пов’язані із цим запитом. ',

    // AgentContactAssignFailed
    1011: 'Не вдалося відповісти або прийняти виклик через відсутність агентів у поточній взаємодії. ',

    // ContactCallbackFailed
    1034: 'Не вдалося передзвонити контакту, оскільки для запиту отримано ContactParkTimeout.',

    // ContactUpdateFailed
    1020: "Не вдалося оновити змінні, оскільки одне зі значень перевищує обмеження у 256 символів. Зменште кількість символів і повторіть спробу.",

    // AgentInviteFailed
    1031: 'Агент запросив клієнта після запиту зворотного виклику.',

    // AgentBlindTransferFailedEvent
    1044: 'Не вдалося виконати передавання всліпу агента, оскільки агентові в пункті призначення доручено іншу взаємодію.',

    // AgentCtqCancelFailed
    1047: "Контакт не знайдено.",

    // AgentCtqFailed
    1048: "Групу розсилки викликів не налаштовано.",
    1049: 'Перевищено максимальний час очікування в черзі.',
    // StationLoginFailed
    127: 'Не вдалося використати реєстр DN оператора з виключенням дублікатів входу.'
  },

  stateSelector: {
    Available: 'Доступний',
    errorstatechange: 'Зміна стану не відбулася, спробуйте ще раз.',
    errorStateChangeInPendingLogout: 'Не вдалося змінити стан оператора через очікуваний вихід.',
    label: 'Стан доступності',
    agentStateSelector: 'Селектор стану оператора',
    Engaged: 'Залучено',
    engagedAvailableInfo:
      'Наразі вас залучено до взаємодії, і ви перебуваєте в стані доступності.',
    engagedIdleInfo:
      'Наразі вас залучено до взаємодії, і ви перебуваєте в стані очікування.',
    engagedInfo: 'Наразі вас залучено до взаємодії.',
    engagedSupervisorStateChange: 'змінює ваш стан на',
    axAgentStateChanged: 'Ваш стан змінено на',
    axAgentSync: 'через синхронізацію стану з вашим інструментом для співпраці.',
    engagedPresenceInfo:
      'Наразі вас залучено до взаємодії, і ви перебуваєте в стані',
    engagedPresenceSync: 'через синхронізацію стану з вашим інструментом для співпраці.',
    clear: 'Очистити вхідні дані',
    searchState: 'вхідні дані',
    agentStatusLabel: 'Стан оператора',
    agentStateLabel: 'Оператор перебуває в стані {selectedState} останні {selectedTimeValue}',
    agentStateLabelOnStateChange: 'Оператор перебуває в стані {selectedState} останні 0 с.',
    agentStateChangeSuccessful:'Успішно змінено стан на "{selectedState}".',
    agentStateChangeFail:'Не вдалося змінити стан на "{selectedState}".',
    searchError: 'Введіть принаймні три символи для пошуку станів.'
  },

  warningMessage: {
    header: 'Незбережені зміни',
    message:
      'У вас є незбережені зміни на цій сторінці. Ви впевнені, що хочете покинути цю сторінку? ',
    cancelButton: 'Залишитися',
    saveButton: 'Покинути'
  },

  notificationLables: {
    muteVolume: 'Вимкнути гучність сповіщень',
    unmuteVolume: 'Увімкнути гучність сповіщень',
    notificationVolume: 'Гучність сповіщень',
    playSound: 'Відтворити звук сповіщень',
    enableSoundNotificationSettings: 'Увімкнути звукові сповіщення',
    enableSoundNotificationSettingsDescription:
      'Надсилання звукових сповіщень про вхідні запити. Ви можете налаштувати гучність нижче.',
    volumeTitle: 'Гучність звуку'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: 'Виклик',
    chat: 'Чат',
    email: 'Електронна пошта',
    facebook: 'Месенджер',
    whatsapp: 'WhatsApp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google\'s Business Messages"
  },
  orgDetailsLabels: {
    role: 'Роль',
    department: 'Відділ',
    email: 'Електронна пошта',
    businessPhone: 'Робочий телефон',
    workPhone: 'Робочий',
  },
  addressListError: {
    title: 'Не вдалося завантажити дані',
    errorId: 'Ідентифікатор помилки:'
  },
  keypad: {
    keyPadSearch: 'Уведіть номер',
    dialPad: 'Номеронабирач'
  },
  collabTool: {
    userAuthenticated: 'Автентифікація користувача:',
    successful: 'Успішно',
    failed: 'Не виконано.',
    tryAgain: 'Спробуйте ще раз',
    stateSync: 'Синхронізація стану:',
    mercuryFailedInfo: ' Зверніться до адміністратора.',
    retrying: 'Повторна спроба...',
    trackingIdLabel: 'Ідентифікатор відстеження: '
  },
  webex: {
    webex: 'Webex',
    info: 'Інтеграція дає змогу синхронізувати стани між настільною системою й Webex.'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: 'Завдяки цій інтеграції можна надавати консультації або передавати виклики користувачам Microsoft Teams.',
    authenticationFailedInfo:
      'Якщо вікно автентифікації вже відкрито, спробуйте ще раз автентифікуватися в ньому.',
    ListItemContactDetails:
      'Ім’я контакту: {name}, стан присутності: {presence}, відділ: {department}, посада: {jobTitle} і номер телефону: {phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: 'Сповіщення щодо екстрених служб',
    readNotification: 'Я прочитав(-ла) сповіщення.'
  },
  webexPresenceStatus: {
    active: 'Активні',
    lastActiveFewMinutesAgo: 'Активний протягом останніх кількох хвилин',
    lastActiveMinutesAgo: 'Активний {min} хв. тому',
    lastActive1HourAgo: 'Остання активність 1 год. тому',
    lastActiveHoursAgo: 'Активний {hour} год. тому',
    lastActiveYesterday: 'Активний вчора',
    lastActiveOnDate: 'Активний {date}',
    busy: 'Зайнято',
    busyUntil: 'Зайнято до {date}',
    dnd: 'Не турбувати',
    dndUntil: 'Не турбувати до {date}',
    quiet: 'Тихі',
    quietUntil: 'Тихі до {date}',
    ooo: 'Не на роботі',
    outOfOfficeUntil: 'Не на роботі до {date}',
    call: 'На виклику',
    meeting: 'На зустрічі',
    calendarItem: 'На календарній зустрічі',
    presenting: 'Проводить презентацію',
  },
  enterpriseSearch: {
    orgPlaceholder: 'Пошук за ім’ям або відомостями профілю',
    webexPlaceholder: 'Пошук за ім’ям або ел. поштою',
    refreshTheList: 'Оновити список',
    refreshAddressBook: 'Оновити адресну книгу',
    microsoftAuthError: 'Немає контактів для відображення. Помилка автентифікації Microsoft.'
  }
});


/***/ }),

/***/ "./src/i18n/messages/zh_CN.js":
/*!************************************!*\
  !*** ./src/i18n/messages/zh_CN.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: '无法加载数据',
    errorID: '错误 ID',
    tryAgain: '重试',
    Error: '错误',
    okButton: '确定',
    Yes: '是',
    Cancel: '取消',
    Confirm: '确认',
    Continue: '继续',
    Canceling: '正在取消',
    CiscoAiAssistant: 'Cisco AI 助理',
    Answer: '应答',
    AnswerAriaLabel: '应答桌面任务',
    Decline: '拒接',
    ErrorSecurityCompliance: '安全符合性',
    errorDetails: '错误详细信息',
    learnMore: '了解更多',
    showLess: '显示更少',
    trackingIdDescription:
      '请与站点管理员或支持团队共享追踪 ID 以调查情况。',
    trackingIdInputLabel: '追踪 ID： ',
    submitForm: '提交表单',
    unnamedStatus: '未命名状态',
    errorChatMsg: '无法加载聊天数据',
    noOptions: '无选项',
    noResults: '无结果',
    more: '更多',
    nomatchfound: '未找到匹配项',
    collaborationTool: '协作工具',
    timerAriaLabel: '花费的时间',
    historyItemTime: '发生于',
    loading: '正在加载',
    months: [
      '一月',
      '二月',
      '三月',
      '四月',
      '五月',
      '六月',
      '七月',
      '八月',
      '九月',
      '十月',
      '十一月',
      '十二月'
    ],
    loadingMsg: '正在加载...',
    search: '搜索',
    historyChannelLabels: {
      All: '全部',
      telephony: '语音',
      chat: '聊天',
      email: '电子邮件',
      social: '社交媒体'
    },
    homePageLabel: '主页',
    resizeHistoryDragger: '调整历史拖动器的大小',
    agentHistoryLabel: '座席历史记录',
    clear: '清除输入',
    ariaLabelAgentHistoryWrapper:
      '座席交互历史记录会显示过去 24 小时内您通过不同渠道与客户的最新通信情况',
    sliderResizerInstructions:
      '您当前在滑块上。要调整大小，请使用箭头键',
    resizeHistoryPanel: '调整历史记录面板、滑块的大小，',
    time: {
      hours: '小时',
      minutes: '分钟',
      seconds: '秒'
    }
  },
  email: {
    ToLabel: '到',
    FromLabel: '自',
    CcLabel: '抄送',
    BccLabel: '密送',
    SubjectLabel: '主题',
    HideLabel: '隐藏',
    SendLabel: '发送',
    ShowPrevThread: '显示上一个线程',
    HidePrevThread: '隐藏上一个线程',
    ReplyLabel: '回复',
    ReplyAllLabel: '回复全部',
    ViewOriginalMail: '查看原始电子邮件',
    QuickReplyInp: '在此快速回复...',
    AttachFiles: '附加文件',
    ToolbarHeading: '标题 1',
    ToolbarBold: '加粗',
    ToolbarItalic: '倾斜',
    ToolbarUnderLine: '下划线',
    ToolbarBlockQuote: '块引用',
    ToolbarCode: '代码块',
    ToolbarListOrder: '按确定的顺序列示',
    ToolbarListBullet: '按项目符号列示',
    ToolbarLink: '链接',
    ToolbarStrike: '删除线',
    ToolbarColor: '文本颜色',
    ToolbarTable: '表格',
    insertTable: '插入表格',
    insertRowAbove: '在上方插入行',
    insertRowBelow: '在下方插入行',
    insertColumnLeft: '在左侧插入列',
    insertColumnRight: '在右侧插入列',
    deleteRow: '删除行',
    deleteColumn: '删除列',
    deleteTable: '删除表格',
    link: '链接',
    IndentRight: '右缩进',
    IndentLeft: '左缩进',
    showMoreAttachment: '显示更多附件',
    AttachmentLimit: '最多附加 ',
    attachments: ' 个附件， ',
    sizeLimit: ' MB (大小上限)',
    attachment: '附件',
    errordeleteattachment: '无法删除文件。请重试。',
    errordownloadattachment: '无法下载文件。请重试。',
    erroraddattachemnt: '无法上传文件。请重试。',
    errorendcontact: '无法结束互动。请重试。',
    erroraddlimitreached:
      '无法附加文件，因其超出上限 ',
    errorattachmentdrop:
      '因违反公司安全策略，附件已删除。',
    errorfiletype: '文件类型不受支持。请再试一次。',
    errorcreditcard:
      '因违反公司安全策略，无法上传附件。',
    errorcontainsimage:
      '无法上传附件。附件中包含公司安全策略禁止的图像。',
    errorlimit: ' MB 限制。',
    errorsendemail: '无法发送电子邮件。请重试。',
    errorpcicheckemail: '无法检索 PCI 数据。请重试。',
    errortext: '无法加载数据',
    tryAgain: '重试',
    replywarning:
      '请勿在此消息或附件中共享财务、健康或任何个人身份信息 (PII)。',
    datamasked:
      '根据公司安全策略编辑了电子邮件的主题或正文。是否确定要发送该电子邮件？',
    pcibannerwarning:
      '根据公司安全策略编辑了电子邮件的主题或正文。',
    on: '开',
    wrote: '已写'
  },
  interaction_control: {
    windowOpened: '窗口已打开',
    connected: '已连接',
    consultRequested: '已请求咨询',
    consulting: '咨询',
    consultCallOnHold: '咨询保持',
    callOnHold: '呼叫保持',
    consult: '咨询',
    endconsult: '结束咨询',
    hold: '保持',
    transfer: '转接',
    conference: '会议',
    endconference: '结束会议',
    conferenceRequested: '已请求会议',
    switchCall: '切换',
    mergeCall: '合并',
    wrapup: '话后处理',
    end: '结束',
    customername: '客户名称',
    dn: 'DNIS',
    ivrpath: 'IVR 路径',
    email: '客户电子邮件',
    ani: '电话号码',
    queueid: '队列名称',
    ronatimeout: 'RONA 时间',
    pathid: 'IVR 路径 ID',
    dnis: 'DNIS',
    destagentphonenumber: '座席 DN',
    destagentname: '座席名称',
    virtualteamname: '队列',
    category: '类别',
    additionaldetails: '其他详细信息',
    sourcenumber: '源数值',
    sourcepage: '源页面',
    appuser: '应用程序用户 ID',
    customernumber: '电话号码',
    exitconference: '退出会议',
    resume: '恢复',
    pauserecording: '暂停录音',
    resumerecording: '恢复录音',
    exitconsult: '退出咨询',
    pauseRecordingFailed: '无法暂停录音。请重试。',
    resumeRecordingFailed: '无法恢复录音。请重试。',
    holdCallFailed: '无法保留呼叫。请重试。',
    resumeCallFailed: '无法恢复呼叫。请重试。',
    endCallFailed: '无法结束互动。请重试。',
    consultTransferFailed:
      '无法转接咨询呼叫。请重试。',
    conferenceTransferFailed:
      '无法转接会议呼叫。请重试。',
    conferenceFailed:
      '无法连接会议请求。请重试。',
    consultEndFailed: '无法结束咨询请求。请重试。',
    conferenceExitFailed:
      '无法退出会议请求。请重试。',
    conferenceEndFailed:
      '无法结束会议请求。请重试。',
    cancelCtqFailed:
      '无法取消对队列的咨询呼叫。请重试。',
    privacyShield: '隐私盾',
    errorOnPrvacyShieldForConsult:
      '当前已暂停录音。请恢复录制以开始咨询呼叫。',
    errorOnPrvacyShieldForTransfer:
      '当前已暂停录音。请恢复录制以开始转接呼叫。',
    cancelConsult: '取消咨询',
    cancelTransfer: '取消转接',
    copy: '复制',
    copied: '已复制',
    cadrequestuccess: '已成功保存客户信息。',
    cadrequestfailure: '无法保存客户信息。请稍后重试。',
    cadupdatedmessage: '客户信息最近已由以下方更新：',
    unsavedmessage: '您未保存的更改已被覆盖。',
    save: '保存',
    revert: '复原',
    expandDetails: '展开详细信息',
    collapseDetails: '折叠详细信息',
    cadValidationError:
      '格式无效。请使用国际标准日期和时间。',
    secureCadSaveError:
      '客户未保存。单击“保存”重试。',
    secureDecryptionError: '无法显示安全变量。',
    clickToTry: '单击以重试',
    isSecureVariable: '是一个安全变量',
    contactorigin: '联系人来源',
    resumeMonitoring: '恢复监听',
    pauseMonitoring: '暂停监听',
    whisperCoach: '密谈指导',
    bargeIn: '插入',
    endMonitoring: '结束监听',
    contactphonenumber: '联系人电话号码',
    contactqueue: '联系人队列',
    activeparticipants: '活动参与者',
    consultedparticipant: '已咨询参加者',
    contactstatus: '联系人状态',
    timeincontactstatus: '处于联系人状态的时间',
    totalcontactduration: '总计联系人持续时间',
    agentinteractiontime: '交互持续时间',
    recording: '正在录音',
    monitoring: '监听',
    monitoringPaused: '已暂停监听',
    pauseMonitoringFailed: '无法暂停监听。请重试',
    resumeMonitoringFailed: '无法恢复监听。请重试',
    callCancelledInProgress: '进行中的呼叫取消',
    bargedIn: '已插入',
    keypad: '键盘',
    mute: '静音',
    unmute: '取消静音',
    bargeInTooltipText:
      '麦克风将开启，并且您将加入此客户互动',
    bargeInCompactTooltipText:
      '插入。麦克风将开启，并且您将加入此客户互动',
    bargeInTooltipDisabled: '请恢复监听以启用插入',
    bargeInFailedTitle: '插入失败',
    bargeInFailedData:
      '尝试插入时出错。请在一段时间后重试。',
    supervisorBargedIn: '已插入您的呼叫。',
    leftInteraction: '已退出互动。',
    conferenceEnded: '会议呼叫已结束。',
    participants: '参与者',
    badgeAriaLabel: '{participant} 正在通话中',
    bargeInConferenceAriaLabel: '互动中有两个参加者',
    taskName: '互动控制任务名称',
    interactionDurationLabel: '持续时间',
    wrapupassist: '话后工作帮助',
    consultingTaskContext: '咨询呼叫来自',
    consultExited: '咨询呼叫已退出',
    endCall: '结束呼叫。',
    exitconferenceCall:
      '退出通话，继续与活动参加者进行会议。',
    recordingInProgess: '正在录制',
    recordingPaused: '录制暂停',
    searchPlaceholder: '搜索联系人',
    postCall: "话后",
    switchCallTooltip: "切换到呼叫",
    switchConsultTooltip: "切换到咨询呼叫",
    switchConferenceTooltip: "切换到会议呼叫",
    confirmationDialog: {
      endCallTitle: '是否要结束呼叫？',
      endCallMessage: '单击“确认”以结束所有参加者的呼叫。',
      exitConferenceTitle: '是否要退出会议呼叫？',
      exitConferenceMessage:
        '单击“确认”以退出会议呼叫并允许其他参加者继续。',
      confirmButtonLabel: "确认",
      cancelButtonLabel: "取消",  
    },
    postCallOnHold: "话后保持",
    postCallConsult: "话后咨询",
    postCallConsultOnHold: "话后咨询保持",
  },
  agentProfile: {
    teamName: '小组',
    dialNumber: '拔号',
    phoneNumber: '电话号码',
    settings: '更改设置',
    signOut: '注销',
    webRTCDisconnected: '警告桌面电话已断开连接 ',
    msAuthFailed: 'Microsoft 身份验证失败',
    stateSyncFailed: '状态同步失败',
    userProfileLabel: '用户配置文件',
    ariaAgentprofile: '座席配置文件',
    ChannelCapacity: '通道容量',
    voice: '语音',
    chat: '聊天',
    email: '电子邮件',
    social: '社交媒体',
    channelCapacityTooltip: '单击查看更多信息',
    blendedRouting: '混合',
    exclusiveRouting: '排除路由',
    realtimeRouting: '实时混合路由',
    blendedRoutingTooltip: '处理来自不同通道的多个联系人。',
    exclusiveRoutingTooltip: '一次仅处理一个联络。',
    realtimeRoutingTooltip: '处理一个强制性实时通道。',
    errorActiveContacts:
      '因为有正在进行的对话，所以您目前无法注销。请完成对话后重试。',
    searchTeams: '搜索小组',
    changeTeamsConfirmHeader: '变更小组确认',
    changeTeamsConfirmMessage: '是否确定要变更小组？',
    changeTeamLabel: '变更小组',
    errorChangeTeams:
      '您现在无法变更小组，因为您有正在处理中的请求。请完成这些请求并重试。',
    saveTeamSelection: '保存小组选择',
    userSettings: '用户设置',
    resetLayout: '重置整个 Desktop 布局',
    resetConfirmHeader: '重置布局确认',
    resetConfirmMessage:
      '是否确定要重置整个 Desktop 布局？ <br/>Desktop 将恢复为默认布局。',
    downloadLogs: '下载错误报告',
    help: '帮助',
    signoutConfirm: '是否确定要注销？',
    signoutConfirmHeader: '注销确认',
    darkTheme: '切换到暗模式',
    newLook: '切换到新外观',
    keyboardShortcuts: '键盘快捷键',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: '通知设置',
    silentNotification: '静音通知',
    enableNotificationSettings: '启用通知',
    enableSilentNotificationSettings: '启用静音通知',
    suppressWebexCallingNotificationSettings: '隐藏 Webex Calling 通知',
    notificationSettingDescription:
      '发出通知，例如新消息、警报和状态更改。',
    silentNotificationDescription:
      '关闭屏幕警报。您可以在通知中心查看通知。',
    suppressWebexCallingNotificationDescription: 
    '不显示传入 Webex 呼叫的弹出通知，并通过 Webex Contact Center 应答呼叫。',
    arrowLabel: '返回',
    managedTeams: '受托管小组',
    managedTeamsError: '无法加载小组。',
    viewAll: '查看所有',
    profileSettings: '配置文件设置',
    userRole: '角色',
    saveSelection: '保存所选项',
    extension: '分机',
    changeProfileConfirmHeader: '确认配置文件设置更改',
    changeProfileConfirmMessage:
      '是否确定要保存您的配置文件更改？',
    confirm: '确认',
    errorProfileUpdate:
      '您现在无法变更配置文件设置，因为您有正在处理中的请求。请完成这些请求并重试。',
    roleAgentSupervisor: '主管和坐席',
    roleSupervisor: '主管',
    noTeam: '无小组',
    testYourNetwork: '测试您的网络',
    speakerAndMic: '扬声器和麦克风',
    speaker: '扬声器',
    mic: '麦克风',
    speakerDescription:
      '选择并测试输出设备，以确保您听到主叫方的声音。',
    micDescription:
      '选择并测试输入设备，以确保主叫方听到您的声音。',
    micError:
      '拒绝访问麦克风。通过浏览器设置启用访问权限或与管理员联系。',
    speakerError:
      '扬声器当前不可用，因为拒绝接入麦克风。',
    telephony: '电话',
    desktop: '桌面',
    onSpeakerPlay:
      '如果您听不到测试音，请检查扬声器设备。',
    onMicPlay:
      '如果您听不到测试音，请检查扬声器和麦克风。',
    onMicRecord: '录制留言以进行播放。',
    test: '测试',
    recording: '正在录音',
    playing: '正在播放',
    reconnecting: '正在重新连接',
    disconnectMessage:
      '桌面电话已断开连接。尝试其他电话选项。',
    singleTelephonyDisconnectMessage:
      '桌面电话已断开连接。请与管理员联系。',
    clear: '清除输入',
    rememberMeCheckBoxMessage: "不再显示此内容",
    saveLabel: '保存',
    browserUnsupportedError: "登录失败，因为您使用的浏览器不受支持.",
    microphoneAccessDeniedError: "拒绝访问麦克风。通过浏览器设置启用访问权限或与管理员联系.",
  },
  contactHistory: {
    mainHeader: '联系历史记录',
    handledBy: '处理人',
    noRecordFound: '未找到联系历史记录！',
    tryAgain: '重试',
    errorMsg: '无法检索联系历史记录。请重试。',
    errorID: '错误 ID',
    missingAni: '缺少 ANI',
    timeIcon: '时长',
    taskHandled: '已处理任务',
    noHistoryNew: '无历史记录',
    noHistory: '无历史记录',
    viewTranscript: '查看电子邮件消息',
    transcriptFor: '以下项的副本：',
    editBeforeCall: '呼叫前编辑',
    clickToCall: '点击以呼叫',
    onAnActiveCallErrorMessage:
      '无法发起新呼叫，因为您已在通话中。',
    receivedFrom: '联系接收自',
    initiatedTo: '联系发起至',
    wrapUpReason: '话后处理原因',
    startCallTelephony:
      '单击电话号码链接以开始出站呼叫。',
    contactHistoryList: '联系历史记录列表，',
    wrapUpCode: '话后处理代码',
    agentName: '座席名称',
    entryPointName: '入口点',
    acceptedTimeAndDate: '接受的时间和日期',
    duration: '时长',
    emailTranscript: '电子邮件记录',
    clickToViewEmailTranscript: '单击以查看电子邮件记录',
    listContainer: '列表容器'
  },
  contactTranscript: {
    agent: '座席',
    entryPoint: '入口点',
    date: '日期',
    subject: '主题',
    from: '自',
    sent: '已发送',
    to: '到',
    back: '返回',
    errorTranscript: '获取副本时出错',
    customer: '客户',
    inboundErrorMessage: '无法加载客户电子邮件',
    outboundErrorMessage: '无法加载座席响应'
  },
  popoverTitle: {
    callback: '回呼',
    outboundCall: '出站呼叫',
    incomingCall: '传入呼叫',
    progressiveCampaign: '活动呼叫',
    courtesyCallback: '礼貌回叫',
    chat: '传入聊天',
    incoming: '传入',
    monitoringCall: '监控呼叫'
  },
  connecting: '正在连接',
  initiating: '正在启动',
  outbound: '出站',
  transfer: {
    title: '转接请求',
    heading: {
      chat: '选择要转接到的座席或队列。',
      email: '选择要转接到的队列。',
      telephony:
        '选择要转接到的座席、队列或拨号。',
      noQueueTelephony:
        '选择要转接到的座席或拨号。'
    },
    header: {
      chat: '选择座席或队列来转接此联系人。',
      email: '选择一个队列来转接此联系人。',
      telephony:
        '选择座席、队列、拨号或组织来转接此联系人。',
      noQueueTelephony:
        '选择座席、拨号或组织来转接此联系人。',
      noOrganizationTelephony:
        '选择座席、队列或拨号来转接此联系人。',
      noQueueOrganizationTelephony:
        '选择座席或拨号来转接此联系人。'
    },
    queues: '队列',
    agents: '座席',
    dialNumber: '拔号',
    organization: '组织',
    placeholder: {
      Queues: '从队列列表中选择',
      Agents: '从座席列表中选择',
      DialNumber: '按姓名或号码搜索',
      DialNumberOrEntryPoint: '按名称/号码/入口点进行选择',
      ChooseByNameOrNumber: '按姓名/号码搜索',
      Organization: '按姓名/角色/部门/工作电话搜索',
      WebexOrganization: '按姓名或电子邮件搜索',
      DialNumberSearch: '按姓名或号码搜索'
    },
    type: '转接',
    cancel: '取消',
    closeModal: '关闭模块',
    failureError: '无法转接此请求。请重试。',
    entryPoint: '入口点'
  },
  consult: {
    title: '咨询请求',
    heading: {
      chat: '选择要转接到的座席或队列。',
      email: '选择要转接到的队列。',
      telephony:
        '选择要咨询的座席、队列或拨号。',
      noQueueTelephony:
        '选择要咨询的座席或拨号。'
    },
    header: {
      chat: '选择座席或队列来转接此联系人。',
      email: '选择一个队列来转接此联系人。',
      telephony:
        '选择要咨询的座席、队列、拨号或组织。',
      noQueueTelephony:
        '选择要咨询的座席、拨号或组织。',
      noOrganizationTelephony:
        '选择要咨询的座席、队列或拨号。',
      noQueueOrganizationTelephony:
        '选择要咨询的座席或拨号。'
    },
    queues: '队列',
    agents: '座席',
    dialNumber: '拔号',
    organization: '组织',
    placeholder: {
      Queues: '从队列列表中选择',
      Agents: '从座席列表中选择',
      DialNumber: '按姓名或号码搜索',
      DialNumberOrEntryPoint: '按名称/号码/入口点进行选择',
      ChooseByNameOrNumber: '按姓名/号码搜索',
      Organization: '按姓名/角色/部门/工作电话搜索',
      WebexOrganization: '按姓名或电子邮件搜索',
      DialNumberSearch: '按姓名或号码搜索'
    },
    type: '咨询',
    checkBoxLabel: '允许参加者继续互动。',
    cancel: '取消',
    closeModal: '关闭模块',
    failureError: '无法连接咨询请求。请重试。',
    customerLeftMsg: '客户已断开连接。不再需要咨询。',
    ctqFailureMsg:
      '无法取消对队列的咨询呼叫。请重试。',
    cancelCtqInfo:
      '正在所选队列中搜索有空的座席。请稍候或取消咨询请求。',
    cancelCtqAction: '取消咨询',
    entryPoint: '入口点'
  },
  conference: {
    title: '会议请求',
    heading: {
      chat: '选择特定座席进行会议聊天'
    },
    queues: '队列',
    agents: '座席',
    dialNumber: '拔号',
    organization: '组织',
    placeholder: {
      Queues: '从队列列表中选择',
      Agents: '从座席列表中选择',
      DialNumber: '按姓名或号码搜索'
    },
    type: '会议',
    cancel: '取消',
    closeModal: '关闭模块',
    failureError: '无法发起会议请求。请重试。'
  },
  transferModal: {
    Agents: '无法检索座席列表。请刷新列表。',
    AgentsEmpty: '无可用座席',
    Queues: '无法检索队列列表。请刷新列表。',
    QueuesEmpty: '无可用队列',
    EPEmpty: '没有可用入口点',
    DialNumber:
      '无法从通讯簿检索拨号号码列表。请刷新列表。',
    EntryPoint:
      '无法检索到入口点号码的列表。请刷新列表。',
    Common: '无法检索到列表。请刷新列表。',
    DialNumberEmpty: '无可用拨号',
    DialNumbInvalid:
      '拨号无效。请与您的管理员联系。',
    DialNumbOrEntryPointInvalid:
      '拨号号码/入口点无效。请联系您的管理员。',
    refreshQueueList: '刷新队列列表',
    refreshAgentList: '刷新座席列表',
    refreshEpList: '刷新入口点',
    refreshAddressBook: '刷新通讯簿',
    refreshTheList: '刷新列表',
    entryPointSectionLabel: '入口点',
    addressBookSectionLabel: '通讯簿',
    organization: '组织',
    comboBoxAriaLabelAgent: '从座席列表中选择',
    comboBoxAriaLabelQueue: '从队列列表中选择',
    comboBoxAriaLabelEp: '从入口点列表中选择',
    infScrollAgent: '搜索座席',
    infScrollQueue: '搜索队列',
    infScrollEP: '搜索入口点',
    allRadioButtonHidedTextForConsult: '您没有分配的实体来咨询此交互。请联系您的管理员。',
    allRadioButtonHidedTextForTransfer: '您没有分配的实体来转接此交互。请联系您的管理员。',
    allRadioButtonHidedTextForConference: '您没有分配的实体来商讨此交互。请联系您的管理员。',
    searchMinCharError: '至少输入三个字符以进行搜索。',
  },
  wrapup: {
    cancelautowrapup: '取消自动话后处理',
    wrapupreason: '话后处理原因',
    untilautowrapup: '直至自动话后处理',
    followupsetting: '跟进设置',
    lastagentroute: '上一个座席路由',
    submitwrapup: '提交话后处理',
    wrapupsearch: '搜索话后处理原因',
    invalidationError: '无法提交话后处理',
    searchResult: '个搜索结果可用',
    noResultFound: '没有找到搜索结果',
    listContainerLabel: '事后处理列表容器',
    searchError: '至少输入三个字符以搜索话后处理原因。',
  },

  outdial: {
    call: '呼叫',
    dialpadSearch: '输入拨号号码',
    addressSearch: '按姓名/号码搜索',
    addressTab: '地址',
    addressTabTooltip: '搜索通讯簿',
    dialpadTab: '拨号盘',
    dialpadTooltip: '拨打号码',
    searchTab: '搜索',
    searchTabTooltip:'搜索我的组织中的人员',
    noAdrFound: '未找到匹配项',
    noContacts: '没有联系人',
    mainIconTooltip: '外拨呼叫',
    errorOutdialFailed:
      '外拨呼叫失败。Desktop 无法连接呼叫，或者呼叫未被应答。',
    errorOutdialDisabled: '外拨呼叫已禁用',
    errorDialPadValidationMessage: '格式不正确',
    outdialReqInProgress: '外拨呼叫正在进行中',
    outdialAniPlaceholder: '选择外拨 ANI',
    outdialAniLabel: '外拨 ANI',
    outdialAniPlaceHolder: '搜索外拨 ANI',
    errorDcCallsLimitExceeded:
      '数据中心已达到外拨呼叫的最大数限制。无法更拨打任何外拨呼叫',
    errorOrgCallsLimitExceeded:
      '组织已达到外拨呼叫的最大数限制。无法再拨打任何外拨呼叫。',
    errorOutDialNoAnswerFromCustomer:
      '客户未应答您的呼叫。请稍后尝试呼叫。',
    errorOutDialCustomerUnavailable:
      '客户现在没空。请稍后尝试呼叫。',
    errorOutDialAgentEnds: '您已结束与客户的呼叫。',
    errorOutDialCustomerBusy: '客户现在忙碌。请稍后尝试呼叫。',
    searchError: '至少输入三个字符以搜索联系人。',
    upArrowLabel: '展开',
    clear: '清除输入',
    outdialDialogDescription: '您当前正在带有选项卡的对话框中。'
  },

  organization: {
    noMatchFound: '未找到匹配项',
    searchError: '至少输入三个字符以搜索联系人。',
    authError: '没有要显示的联系人。Microsoft 身份验证失败。'
  },

  interactionPopover: {
    of: '/',
    accept: '接受',
    acceptAriaLabel: '从 {from} 接受任务 {taskNumber} - {taskType}',
    requests: '请求',
    back: '返回',
    next: '下一个',
    acceptMultipleRequest: '接受 {requestCount} 个请求',
    paginationDetail: '{indexStart}-{indexEnd}，总计 {totalPopoverpoolLength}',
    hidePopoverDetails: '隐藏弹出框详情',
    showPopoverDetails: '显示弹出框详情',
    customerName: '客户名称',
    email: '电子邮件',
    queueName: '队列名称',
    failedToAccept: '无法接受。',
    unableToAccept: '无法接受联系。',
    failedToEnd: '无法结束。',
    unableToEnd: '无法结束联系。 ',
    ringing: '正在振铃',
    calling: '正在呼叫',
    phoneNumber: '电话号码',
    dni: 'DNIS',
    ivrPathId: 'IVR 路径 ID',
    pathId: '路径 ID',
    rona: 'RONA',
    sourcePage: '源页面',
    sourceNumber: '源数值',
    appUserId: '应用程序用户 ID',
    acceptAll: '接受所有任务',
    agentDn: '座席 DN',
    agentName: '座席姓名',
    agentTeam: '座席小组',
    requestDetails: '请求详细信息',
    incomingCallFrom: '传入呼叫来自',
    unableToAnswer: '无法应答呼叫。请重试。',
    unableToDecline: '无法拒绝呼叫。请重试。'
  },

  multiLogin: {
    header: '多次登录警报',
    message:
      '您在多个浏览器窗口中登录了 Desktop。单击 [继续] 以在此应用程序实例中继续使用 Desktop。否则，请关闭此窗口。',
    continue: '继续'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: '由于配置错误，转接至入口点/队列失败。',
    1010: "无法咨询，因为无法及时分配座席。 ",
    1042: "未找到该联系人",
    1043: '目标无效。',
    1045: '互动未分配给座席。',
    1046: '座席咨询失败，因为系统中找不到匹配的座席通道。',
    1038: "未找到座席",
    1037: '由于内部错误，登录失败。',

    // Media Events
    138: '由于未知原因，操作失败。',
    136: '未找到用户',

    // AgentConsultFailed
    1050: '由于流程中不受支持的配置或活动，无法咨询。 ',
    1005: "由于座席未及时应答请求，无法咨询。",
    1051: '由于入口点或拨号号码无效，无法咨询或转接。',

    // AgentInviteFailed
    1053: '由于工作流程重新排队任务待批准，无法显示交互。',
    1054: '由于此请求的媒体问题，无法发出外拨呼叫。 ',

    // AgentContactAssignFailed
    1011: '由于正在进行的交互缺少座席，无法应答或接受呼叫。 ',

    // ContactCallbackFailed
    1034: '由于收到请求的 ContactParkTimeout，回呼联系人失败。',

    // ContactUpdateFailed
    1020: "由于其中一个变量值超过 256 的字符限制，无法更新变量。请减少字符，然后重试。",

    // AgentInviteFailed
    1031: '在请求回呼后，该座席已邀请客户。',

    // AgentBlindTransferFailedEvent
    1044: '由于目标座席分配到另一个交互，因此座席自动转接失败。',

    // AgentCtqCancelFailed
    1047: "未找到该联系人。",

    // AgentCtqFailed
    1048: "未配置呼叫分发组。",
    1049: '超出队列中的最长等待时间。',
    // StationLoginFailed
    127: '代理目录号码注册失败，出现重复登录异常。'
  },

  stateSelector: {
    Available: '有空',
    errorstatechange: '状态更改不成功。请重试。',
    errorStateChangeInPendingLogout: '由于注销未完成，无法更改座席状态。',
    label: '可用性状态',
    agentStateSelector: '座席状态选择器',
    Engaged: '接洽中',
    engagedAvailableInfo:
      '您当前正在进行交互，并处于“可用”状态。',
    engagedIdleInfo:
      '您当前正在进行交互，并处于“空闲”状态。',
    engagedInfo: '您当前正在进行互动。',
    engagedSupervisorStateChange: '已将您的状态更改为',
    axAgentStateChanged: '您的状态变更为',
    axAgentSync: '由于状态与协作工具同步。',
    engagedPresenceInfo:
      '您当前正在进行交互，您的状态是',
    engagedPresenceSync: '由于状态与协作工具同步。',
    clear: '清除输入',
    searchState: '输入',
    agentStatusLabel: '座席状态',
    agentStateLabel: '座席最后 {selectedTimeValue} 处于 {selectedState} 状态',
    agentStateLabelOnStateChange: '座席最后 0 秒处于 {selectedState} 状态',
    agentStateChangeSuccessful:'状态更改为 {selectedState} 成功。',
    agentStateChangeFail:'状态更改为 {selectedState} 失败。',
    searchError: '至少输入三个字符以搜索状态。'
  },

  warningMessage: {
    header: '未保存的更改',
    message:
      '您在此页面上有尚未保持的更改。是否确定要离开此页面？ ',
    cancelButton: '留下',
    saveButton: '离开'
  },

  notificationLables: {
    muteVolume: '将通知音量静音',
    unmuteVolume: '取消通知音量静音',
    notificationVolume: '通知音量',
    playSound: '播放通知提示音',
    enableSoundNotificationSettings: '启用有声通知',
    enableSoundNotificationSettingsDescription:
      '发送传入请求的有声通知。您可以在下方调节音量。',
    volumeTitle: '声音音量'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: '呼叫',
    chat: '聊天',
    email: '电子邮件',
    facebook: 'Messenger',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google\'s Business Messages"
  },
  orgDetailsLabels: {
    role: '角色',
    department: '部门',
    email: '电子邮件',
    businessPhone: '工作电话',
    workPhone: '工作',
  },
  addressListError: {
    title: '无法加载数据',
    errorId: '错误 ID：'
  },
  keypad: {
    keyPadSearch: '输入号码',
    dialPad: '拨号盘'
  },
  collabTool: {
    userAuthenticated: '用户身份验证：',
    successful: '成功',
    failed: '失败。',
    tryAgain: '重试',
    stateSync: '状态同步：',
    mercuryFailedInfo: ' 请与管理员联系。',
    retrying: '正在重试...',
    trackingIdLabel: '追踪 ID： '
  },
  webex: {
    webex: 'Webex',
    info: '集成允许您在桌面和 Webex 之间同步状态。'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: '通过该集成，您可以向 Microsoft Teams 用户咨询或转接呼叫。',
    authenticationFailedInfo:
      '如果身份验证窗口已打开，请在该窗口中重试身份验证。',
    ListItemContactDetails:
      '联系人姓名是：{name}，其在线状态是：{presence}，部门是：{department}，职位头衔是：{jobTitle}并且电话号码是：{phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: '紧急服务通知',
    readNotification: '我已阅读通知。'
  },
  webexPresenceStatus: {
    active: '活动',
    lastActiveFewMinutesAgo: '在过去几分钟内处于活动状态',
    lastActiveMinutesAgo: '{min} 分钟前处于活动状态',
    lastActive1HourAgo: '1 小时前的最新活动',
    lastActiveHoursAgo: '在 {hour} 小时前处于活动状态',
    lastActiveYesterday: '昨天处于活动状态',
    lastActiveOnDate: '在 {date} 处于活动状态',
    busy: '忙碌',
    busyUntil: '{date} 之前忙碌',
    dnd: '免打扰',
    dndUntil: '{date} 之前请勿打扰',
    quiet: '安静',
    quietUntil: '{date} 之前保持安静',
    ooo: '不在办公室',
    outOfOfficeUntil: '{date} 之前不在办公室',
    call: '通话中',
    meeting: '正在开会',
    calendarItem: '在日历会议中',
    presenting: '演示中',
  },
  enterpriseSearch: {
    orgPlaceholder: '按姓名或个人资料详细信息搜索',
    webexPlaceholder: '按姓名或电子邮件搜索',
    refreshTheList: '刷新列表',
    refreshAddressBook: '刷新通讯簿',
    microsoftAuthError: '没有要显示的联系人。Microsoft 身份验证失败。'
  }
});


/***/ }),

/***/ "./src/i18n/messages/zh_TW.js":
/*!************************************!*\
  !*** ./src/i18n/messages/zh_TW.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  common: {
    errorMsg: '無法載入數據',
    errorID: '錯誤 ID',
    tryAgain: '再試一次',
    Error: '錯誤',
    okButton: '確定',
    Yes: '是',
    Cancel: '取消',
    Confirm: '確認',
    Continue: '繼續',
    Canceling: '取消中',
    CiscoAiAssistant: 'Cisco AI 助手',
    Answer: '接聽',
    AnswerAriaLabel: '接聽桌面工作',
    Decline: '拒絕',
    ErrorSecurityCompliance: '安全合規',
    errorDetails: '錯誤詳情',
    learnMore: '了解更多',
    showLess: '顯示較少',
    trackingIdDescription:
      '請與網站管理員或支援團隊分享追蹤 ID，以調查情況。',
    trackingIdInputLabel: '追蹤 ID： ',
    submitForm: '提交表格',
    unnamedStatus: '未命名狀態',
    errorChatMsg: '無法載入聊天數據',
    noOptions: '沒有選項',
    noResults: '沒有搜尋結果',
    more: '更多',
    nomatchfound: '找不到相符項目',
    collaborationTool: '協作工具',
    timerAriaLabel: '所用的時間',
    historyItemTime: '發生於',
    loading: '載入中',
    months: [
      '一月',
      '二月',
      '三月',
      '四月',
      '五月',
      '六月',
      '七月',
      '八月',
      '九月',
      '十月',
      '十一月',
      '十二月'
    ],
    loadingMsg: '正在載入…',
    search: '搜尋',
    historyChannelLabels: {
      All: '全部',
      telephony: '語音',
      chat: '聊天',
      email: '電子郵件',
      social: '社交媒體'
    },
    homePageLabel: '主頁',
    resizeHistoryDragger: '調整記錄拖動器的大小',
    agentHistoryLabel: '代理歷程記錄',
    clear: '清除輸入',
    ariaLabelAgentHistoryWrapper:
      '代理互動記錄顯示過去 24 小時內您透過不同管道與客戶的最近通訊',
    sliderResizerInstructions:
      '您目前位於滑桿位置。如要調整大小，請使用箭頭鍵',
    resizeHistoryPanel: '調整以下項目的大小：記錄面板、滑桿、',
    time: {
      hours: '小時',
      minutes: '分鐘',
      seconds: '秒'
    }
  },
  email: {
    ToLabel: '到',
    FromLabel: '從',
    CcLabel: '傳送副本：',
    BccLabel: '傳送隱藏副本：',
    SubjectLabel: '主旨',
    HideLabel: '隱藏',
    SendLabel: '傳送',
    ShowPrevThread: '顯示上一個對話串',
    HidePrevThread: '隱藏上一個對話串',
    ReplyLabel: '回覆',
    ReplyAllLabel: '全部回覆',
    ViewOriginalMail: '檢視原本的電子郵件',
    QuickReplyInp: '在這裡快速回覆…',
    AttachFiles: '附加檔案',
    ToolbarHeading: '標題 1',
    ToolbarBold: '粗體',
    ToolbarItalic: '斜體',
    ToolbarUnderLine: '底線',
    ToolbarBlockQuote: '封鎖引用',
    ToolbarCode: '代號封鎖',
    ToolbarListOrder: '按順序列出',
    ToolbarListBullet: '按項目符號列出',
    ToolbarLink: '連結',
    ToolbarStrike: '刪除線',
    ToolbarColor: '文字色彩',
    ToolbarTable: '表格',
    insertTable: '插入表格',
    insertRowAbove: '在上方插入行',
    insertRowBelow: '在下方插入行',
    insertColumnLeft: '向左插入列',
    insertColumnRight: '向右插入列',
    deleteRow: '刪除行',
    deleteColumn: '刪除列',
    deleteTable: '刪除表格',
    link: '連結',
    IndentRight: '向右縮進',
    IndentLeft: '向左縮進',
    showMoreAttachment: '顯示更多附件',
    AttachmentLimit: '附件上限 ',
    attachments: ' 附件， ',
    sizeLimit: ' MB 上限',
    attachment: '附件',
    errordeleteattachment: '無法刪除檔案。請再試一次。',
    errordownloadattachment: '無法下載檔案。請再試一次。',
    erroraddattachemnt: '無法上載檔案。請再試一次。',
    errorendcontact: '無法結束互動。請再試一次。',
    erroraddlimitreached:
      '無法附加檔案，因為檔案已超出上限 ',
    errorattachmentdrop:
      '已根據公司數據安全政策放棄附件。',
    errorfiletype: '檔案類型不支援。請再試一次。',
    errorcreditcard:
      '由於公司的安全政策所以無法上載附件。',
    errorcontainsimage:
      '無法上載附件。公司的安全政策不支援附件中的圖像。',
    errorlimit: ' MB 限制。',
    errorsendemail: '無法發送電子郵件。請再試一次。',
    errorpcicheckemail: '無法擷取 PCI 數據。請再試一次。',
    errortext: '無法載入數據',
    tryAgain: '再試一次',
    replywarning:
      '切勿在此訊息或附件中分享財務、健康或任何個人身份資訊 (PII)。',
    datamasked:
      '已根據公司的安全政策編輯郵件主題或正文。您確定要傳送電子郵件嗎？',
    pcibannerwarning:
      '已根據公司的安全政策編輯郵件主題或正文。',
    on: '開',
    wrote: '撰寫'
  },
  interaction_control: {
    windowOpened: '視窗已開啟',
    connected: '已連線',
    consultRequested: '已請求諮詢',
    consulting: '正在諮詢',
    consultCallOnHold: '保留的諮詢通話',
    callOnHold: '保留通話',
    consult: '商議',
    endconsult: '結束諮詢',
    hold: '保留',
    transfer: '轉接',
    conference: '會議',
    endconference: '結束會議',
    conferenceRequested: '已請求會議',
    switchCall: '切換',
    mergeCall: '合併',
    wrapup: '整理',
    end: '結束',
    customername: '客戶名稱',
    dn: 'DNIS',
    ivrpath: 'IVR 路徑',
    email: '客戶電子郵件',
    ani: '電話號碼',
    queueid: '佇列名稱',
    ronatimeout: 'Rona 時間',
    pathid: 'IVR 路徑 ID',
    dnis: 'DNIS',
    destagentphonenumber: '代理 DN',
    destagentname: '代理姓名',
    virtualteamname: '佇列',
    category: '分類',
    additionaldetails: '其他詳細資料',
    sourcenumber: '資源編號',
    sourcepage: '資源頁面',
    appuser: '應用程式使用者 ID',
    customernumber: '電話號碼',
    exitconference: '離開會議',
    resume: '恢復',
    pauserecording: '暫停錄音',
    resumerecording: '繼續錄音',
    exitconsult: '離開諮詢',
    pauseRecordingFailed: '無法暫停錄音。請再試一次。',
    resumeRecordingFailed: '無法恢復錄音。請再試一次。',
    holdCallFailed: '無法保留通話。請再試一次。',
    resumeCallFailed: '無法恢復通話。請再試一次。',
    endCallFailed: '無法結束互動。請再試一次。',
    consultTransferFailed:
      '無法轉接諮詢電話。請再試一次。',
    conferenceTransferFailed:
      '無法轉接會議電話。請再試一次。',
    conferenceFailed:
      '無法連接會議請求。請再試一次。',
    consultEndFailed: '無法結束諮詢請求。請再試一次。',
    conferenceExitFailed:
      '無法退出會議請求。請再試一次。',
    conferenceEndFailed:
      '無法結束會議請求。請再試一次。',
    cancelCtqFailed:
      '無法取消諮詢通話並退回佇列。請再試一次.',
    privacyShield: '隱私盾',
    errorOnPrvacyShieldForConsult:
      '錄製目前已暫停。請恢復錄製以開始諮詢通話。',
    errorOnPrvacyShieldForTransfer:
      '錄製目前已暫停。請恢復錄製以開始轉接通話。',
    cancelConsult: '取消諮詢',
    cancelTransfer: '取消轉接',
    copy: '複製',
    copied: '已複製',
    cadrequestuccess: '客戶資料已成功儲存。',
    cadrequestfailure: '無法儲存客戶資料。請稍後再試。',
    cadupdatedmessage: '客戶資料最近已更新，更新者：',
    unsavedmessage: '未儲存的變更已被覆寫。',
    save: '儲存',
    revert: '回復',
    expandDetails: '展開詳細資料',
    collapseDetails: '收合詳細資料',
    cadValidationError:
      '無效的格式。使用國際標準作為日期和時間。',
    secureCadSaveError:
      '未儲存客戶資料。按一下儲存以重試。',
    secureDecryptionError: '安全變數無法顯示。',
    clickToTry: '按一下以重試',
    isSecureVariable: '是一個安全變數',
    contactorigin: '聯絡人地點',
    resumeMonitoring: '繼續監控',
    pauseMonitoring: '暫停監控',
    whisperCoach: '耳語指導',
    bargeIn: '插話',
    endMonitoring: '結束監控',
    contactphonenumber: '聯絡電話號碼',
    contactqueue: '聯絡人佇列',
    activeparticipants: '作用中參與者',
    consultedparticipant: '被諮詢的參加者',
    contactstatus: '聯絡人狀態',
    timeincontactstatus: '聯絡狀態中時間',
    totalcontactduration: '總計聯絡人持續時間',
    agentinteractiontime: '互動持續時間',
    recording: '錄音中',
    monitoring: '監控',
    monitoringPaused: '監控已暫停',
    pauseMonitoringFailed: '無法暫停監控，請再嘗試一次',
    resumeMonitoringFailed: '無法繼續監控，請再嘗試一次',
    callCancelledInProgress: '通話在進行期間取消',
    bargedIn: '已插話',
    keypad: '鍵台',
    mute: '靜音',
    unmute: '取消靜音',
    bargeInTooltipText:
      '麥克風將會開啟，且您將會加入此客戶的互動',
    bargeInCompactTooltipText:
      '已插話。麥克風將會開啟，且您將會加入此客戶的互動',
    bargeInTooltipDisabled: '請繼續監控，以便啟用插話',
    bargeInFailedTitle: '無法插話',
    bargeInFailedData:
      '您嘗試插話時，系統發生錯誤。請稍後重試。',
    supervisorBargedIn: '已插入您的通話。',
    leftInteraction: '已離開互動。',
    conferenceEnded: '會議通話已結束。',
    participants: '參與者',
    badgeAriaLabel: '{participant} 通話中',
    bargeInConferenceAriaLabel: '互動中有兩個參加者',
    taskName: '互動控制工作名稱',
    interactionDurationLabel: '持續時間',
    wrapupassist: '整理協助',
    consultingTaskContext: '諮詢電話來自',
    consultExited: '已結束諮詢通話',
    endCall: '結束通話。',
    exitconferenceCall:
      '結束通話，會與作用中的參與者繼續會議。',
    recordingInProgess: '正在錄製',
    recordingPaused: '已暫停錄製',
    searchPlaceholder: '搜尋聯絡人',
    postCall: "通話後",
    switchCallTooltip: "切換至通話",
    switchConsultTooltip: "切換至諮詢通話",
    switchConferenceTooltip: "切換至會議通話",
    confirmationDialog: {
      endCallTitle: '您要結束通話嗎？',
      endCallMessage: '按一下「確認」以結束所有參加者的通話。',
      exitConferenceTitle: '您要離開會議通話嗎？',
      exitConferenceMessage:
        '按一下「確認」結束會議通話，並允許其他參加者繼續。',
      confirmButtonLabel: "確認",
      cancelButtonLabel: "取消",  
    },
    postCallOnHold: "通話後保留",
    postCallConsult: "通話後諮詢",
    postCallConsultOnHold: "通話後諮詢保留",
  },
  agentProfile: {
    teamName: '小組',
    dialNumber: '電話號碼',
    phoneNumber: '電話號碼',
    settings: '變更設定',
    signOut: '登出',
    webRTCDisconnected: '警告：桌面電話已中斷連接 ',
    msAuthFailed: 'Microsoft 驗證失敗',
    stateSyncFailed: '狀態同步失敗。',
    userProfileLabel: '使用者設定檔',
    ariaAgentprofile: '代理設定檔',
    ChannelCapacity: '頻道容量',
    voice: '語音',
    chat: '聊天',
    email: '電子郵件',
    social: '社交媒體',
    channelCapacityTooltip: '點擊以查看更多',
    blendedRouting: '混合',
    exclusiveRouting: '專屬路由',
    realtimeRouting: '混合路由即時',
    blendedRoutingTooltip: '橫跨頻道處理多個聯絡人。',
    exclusiveRoutingTooltip: '一次只處理一個聯絡人。',
    realtimeRoutingTooltip: '處理一個強制性即時頻道。',
    errorActiveContacts:
      '您目前無法登出，因為您有進行中的通話。請先完成通話，然後再試一次。',
    searchTeams: '搜尋團隊',
    changeTeamsConfirmHeader: '確認更改團隊',
    changeTeamsConfirmMessage: '您確定要更改團隊嗎？',
    changeTeamLabel: '更改團隊',
    errorChangeTeams:
      '您現在無法更改團隊，因為您有處理中的請求。請完成相關請求後再試一次。',
    saveTeamSelection: '儲存團隊選擇',
    userSettings: '使用者設定',
    resetLayout: '重設整個桌面佈局',
    resetConfirmHeader: '重設佈局確認',
    resetConfirmMessage:
      '您確定要重設整個桌面佈局嗎？<br/>桌面將返回預設佈局。',
    downloadLogs: '下載錯誤報告',
    help: '說明',
    signoutConfirm: '您確定要登出嗎？',
    signoutConfirmHeader: '登出確認',
    darkTheme: '切換到深色模式',
    newLook: '切換至新外觀',
    keyboardShortcuts: '鍵盤快速鍵',
    keyboardShortcutCombination: 'Ctrl+Alt+F',
    errorReportCombination: 'Ctrl+Shift+2',
    notificationSettings: '通知設定',
    silentNotification: '靜音通知',
    enableNotificationSettings: '啟用通知',
    enableSilentNotificationSettings: '啟用靜音通知',
    suppressWebexCallingNotificationSettings: '隱藏 Webex Calling 通知',
    notificationSettingDescription:
      '提供新訊息、提示和狀態變更等通知。',
    silentNotificationDescription:
      '關閉螢幕提示。您可在通知中心查看通知。',
    suppressWebexCallingNotificationDescription: 
    '不要顯示 Webex 來電的快顯通知，而是透過 Webex Contact Center 接聽來電。',
    arrowLabel: '返回',
    managedTeams: '受管理小組',
    managedTeamsError: '無法載入團隊。',
    viewAll: '檢視所有',
    profileSettings: '設定檔設定',
    userRole: '角色',
    saveSelection: '儲存選擇',
    extension: '分機',
    changeProfileConfirmHeader: '確認設定檔設定變更',
    changeProfileConfirmMessage:
      '您確定要儲存自己的設定檔變更嗎？',
    confirm: '確認',
    errorProfileUpdate:
      '您現在無法更改設定檔設定，因為您有處理中的請求。請完成相關請求後再試一次。',
    roleAgentSupervisor: '監督員和代理',
    roleSupervisor: '監督員',
    noTeam: '沒有團隊',
    testYourNetwork: '測試您的網路',
    speakerAndMic: '喇叭和麥克風',
    speaker: '喇叭',
    mic: '麥克風',
    speakerDescription:
      '選擇並測試輸出裝置，以確保您可以聽到來電者的聲音。',
    micDescription:
      '選擇並測試輸入裝置，以確保來電者可以聽到您的聲音。',
    micError:
      '已拒絕麥克風的存取權。請透過瀏覽器設定啟用存取權，或與管理員聯絡。',
    speakerError:
      '揚聲器目前無法使用，因為拒絕存取麥克風。',
    telephony: '電話',
    desktop: '桌面',
    onSpeakerPlay:
      '如果您聽不到測試音，請檢查喇叭裝置。',
    onMicPlay:
      '如果您聽不到測試音，請檢查喇叭和麥克風。',
    onMicRecord: '錄製留言以進行播放。',
    test: '測試',
    recording: '錄音中',
    playing: '正在播放',
    reconnecting: '正在重新連接',
    disconnectMessage:
      '桌面電話已中斷連接。請嘗試其他電話選項。',
    singleTelephonyDisconnectMessage:
      '桌面電話已中斷連接。請與管理員聯絡。',
    clear: '清除輸入',
    rememberMeCheckBoxMessage: "不再顯示此內容",
    saveLabel: '儲存',
    browserUnsupportedError: "無法登入，因為您使用了不受支援的瀏覽器.",
    microphoneAccessDeniedError: "已拒絕麥克風的存取權。請透過瀏覽器設定啟用存取權，或與管理員聯絡.",
  },
  contactHistory: {
    mainHeader: '聯絡人記錄',
    handledBy: '處理者',
    noRecordFound: '找不到聯絡活動記錄！',
    tryAgain: '再試一次',
    errorMsg: '無法擷取聯絡記錄。請再試一次。',
    errorID: '錯誤 ID',
    missingAni: '缺少了 ANI',
    timeIcon: '持續時間',
    taskHandled: '已處理的工作任務',
    noHistoryNew: '沒有記錄',
    noHistory: '沒有記錄',
    viewTranscript: '檢視電子郵件訊息',
    transcriptFor: '轉錄文字',
    editBeforeCall: '通話前編輯',
    clickToCall: '按一下以通話',
    onAnActiveCallErrorMessage:
      '您無法發起新通新，因為您正在進行通話。',
    receivedFrom: '聯絡人接收自',
    initiatedTo: '聯絡人發起至',
    wrapUpReason: '整理原因',
    startCallTelephony:
      '按一下電話號碼連結以開始輸出通話。',
    contactHistoryList: '聯絡人記錄列表',
    wrapUpCode: '整理代碼',
    agentName: '代理名稱',
    entryPointName: '進入點',
    acceptedTimeAndDate: '已接受的時間和日期',
    duration: '持續時間',
    emailTranscript: '電子郵件記錄',
    clickToViewEmailTranscript: '按一下以檢視電子郵件記錄',
    listContainer: '清單容器'
  },
  contactTranscript: {
    agent: '代理',
    entryPoint: '進入點',
    date: '日期',
    subject: '主旨',
    from: '從',
    sent: '已傳送',
    to: '到',
    back: '上一步',
    errorTranscript: '擷取轉錄文字時發生錯誤',
    customer: '客戶',
    inboundErrorMessage: '無法載入客戶電子郵件',
    outboundErrorMessage: '無法載入代理回應'
  },
  popoverTitle: {
    callback: '回撥',
    outboundCall: '撥出通話',
    incomingCall: '來電',
    progressiveCampaign: '推廣電話',
    courtesyCallback: '禮貌回撥',
    chat: '傳入聊天',
    incoming: '傳入',
    monitoringCall: '監控呼叫'
  },
  connecting: '連線中',
  initiating: '正在起始',
  outbound: '外撥',
  transfer: {
    title: '轉接請求',
    heading: {
      chat: '選擇您要轉移到哪個代理或佇列。',
      email: '選擇您要轉移到哪個佇列。',
      telephony:
        '選擇您要轉移到哪個代理、佇列或撥號號碼。',
      noQueueTelephony:
        '選擇您要轉移到哪個代理或撥號號碼。'
    },
    header: {
      chat: '選擇用於轉接此聯絡人的代理或佇列。',
      email: '選擇用於轉接此聯絡人的佇列。',
      telephony:
        '選擇用於轉接此聯絡人的代理、佇列、撥號號碼或組織。',
      noQueueTelephony:
        '選擇用於轉接此聯絡人的代理、撥號號碼或組織。',
      noOrganizationTelephony:
        '選擇用於轉接此聯絡人的代理、佇列或撥號號碼。',
      noQueueOrganizationTelephony:
        '選擇用於轉移此聯絡人的代理或撥號號碼。'
    },
    queues: '佇列',
    agents: '代理',
    dialNumber: '電話號碼',
    organization: '組織',
    placeholder: {
      Queues: '從佇列列表中選擇',
      Agents: '從代理列表中選擇',
      DialNumber: '按名稱或號碼選擇',
      DialNumberOrEntryPoint: '按名稱/號碼/進入點選擇',
      ChooseByNameOrNumber: '按名稱/號碼選擇',
      Organization: '按名稱/職務/部門/商務電話搜尋',
      WebexOrganization: '按名稱或電子郵件搜尋',
      DialNumberSearch: '按名稱或號碼搜尋'
    },
    type: '轉接',
    cancel: '取消',
    closeModal: '關閉模組',
    failureError: '無法轉接請求。請再試一次。',
    entryPoint: '進入點'
  },
  consult: {
    title: '諮詢請求',
    heading: {
      chat: '選擇您要轉移到哪個代理或佇列。',
      email: '選擇您要轉移到哪個佇列。',
      telephony:
        '選擇您要諮詢哪個代理、佇列或撥號號碼。',
      noQueueTelephony:
        '選擇您要諮詢哪個代理或撥號號碼。'
    },
    header: {
      chat: '選擇用於轉接此聯絡人的代理或佇列。',
      email: '選擇用於轉接此聯絡人的佇列。',
      telephony:
        '選擇您要諮詢哪個代理、佇列、撥號號碼或機構。',
      noQueueTelephony:
        '選擇您要諮詢哪個代理、撥號號碼或機構。',
      noOrganizationTelephony:
        '選擇您要諮詢哪個代理、佇列或撥號號碼。',
      noQueueOrganizationTelephony:
        '選擇您要諮詢哪個代理或撥號號碼。'
    },
    queues: '佇列',
    agents: '代理',
    dialNumber: '電話號碼',
    organization: '組織',
    placeholder: {
      Queues: '從佇列列表中選擇',
      Agents: '從代理列表中選擇',
      DialNumber: '按名稱或號碼選擇',
      DialNumberOrEntryPoint: '按名稱/號碼/進入點選擇',
      ChooseByNameOrNumber: '按名稱/號碼選擇',
      Organization: '按名稱/職務/部門/商務電話搜尋',
      WebexOrganization: '按名稱或電子郵件搜尋',
      DialNumberSearch: '按名稱或號碼搜尋'
    },
    type: '商議',
    checkBoxLabel: '允許參加者繼續互動。',
    cancel: '取消',
    closeModal: '關閉模組',
    failureError: '無法連接諮詢請求。請再試一次。',
    customerLeftMsg: '客戶已中斷連線。不再需要諮詢。',
    ctqFailureMsg:
      '無法取消諮詢通話並退回佇列。請再試一次.',
    cancelCtqInfo:
      '在所選佇列中搜尋可用的代理。請稍等或取消諮詢請求。',
    cancelCtqAction: '取消諮詢',
    entryPoint: '進入點'
  },
  conference: {
    title: '會議要求',
    heading: {
      chat: '選擇用於會議聊天的特定代理'
    },
    queues: '佇列',
    agents: '代理',
    dialNumber: '電話號碼',
    organization: '組織',
    placeholder: {
      Queues: '從佇列列表中選擇',
      Agents: '從代理列表中選擇',
      DialNumber: '按名稱或號碼選擇'
    },
    type: '會議',
    cancel: '取消',
    closeModal: '關閉模組',
    failureError: '無法啟用會議請求。請再試一次。'
  },
  transferModal: {
    Agents: '無法擷取代理清單。請重新整理清單。',
    AgentsEmpty: '沒有可提供服務的代理',
    Queues: '無法擷取佇列清單。請重新整理清單。',
    QueuesEmpty: '沒有可用的佇列',
    EPEmpty: '並無可用的進入點',
    DialNumber:
      '無法擷取通訊錄的撥號號碼。請重新整理清單。',
    EntryPoint:
      '無法擷取進入點號碼清單。請重新整理清單。',
    Common: '無法擷取清單。請重新整理清單。',
    DialNumberEmpty: '沒有可用的撥號號碼',
    DialNumbInvalid:
      '撥號號碼無效。請與您的管理員聯絡。',
    DialNumbOrEntryPointInvalid:
      '撥號號碼/進入點無效。請與您的管理員聯絡。',
    refreshQueueList: '重新整理佇列清單',
    refreshAgentList: '重新整理代理清單',
    refreshEpList: '重新整理進入點',
    refreshAddressBook: '重新整理通訊錄',
    refreshTheList: '重新整理清單',
    entryPointSectionLabel: '進入點',
    addressBookSectionLabel: '通訊錄',
    organization: '組織',
    comboBoxAriaLabelAgent: '從代理列表中選擇',
    comboBoxAriaLabelQueue: '從佇列列表中選擇',
    comboBoxAriaLabelEp: '從進入點清單選擇',
    infScrollAgent: '搜尋代理',
    infScrollQueue: '搜尋佇列',
    infScrollEP: '搜尋進入點',
    allRadioButtonHidedTextForConsult: '您並無獲分配的實體以諮詢本互動。請聯絡管理員。',
    allRadioButtonHidedTextForTransfer: '您並無獲分配的實體以轉接本互動。請聯絡管理員。',
    allRadioButtonHidedTextForConference: '您並無獲分配的實體以召開本互動。請聯絡管理員。',
    searchMinCharError: '至少輸入三個字元以搜尋。',
  },
  wrapup: {
    cancelautowrapup: '取消自動結束',
    wrapupreason: '整理原因',
    untilautowrapup: '直至自動整理',
    followupsetting: '跟進設定',
    lastagentroute: '最後一次代理路由',
    submitwrapup: '提交整理',
    wrapupsearch: '搜尋整理原因',
    invalidationError: '無法提交整理',
    searchResult: '可用的搜尋結果',
    noResultFound: '未找到搜尋結果',
    listContainerLabel: '整理清單容器',
    searchError: '輸入至少三個字元，搜尋整理原因。',
  },

  outdial: {
    call: '通話',
    dialpadSearch: '輸入號碼以撥號',
    addressSearch: '按名稱或號碼搜尋',
    addressTab: '地址',
    addressTabTooltip: '搜尋通訊錄',
    dialpadTab: '撥號盤',
    dialpadTooltip: '撥打號碼',
    searchTab: '搜尋',
    searchTabTooltip:'搜尋我機構中的人員',
    noAdrFound: '找不到相符項目',
    noContacts: '並無聯絡人',
    mainIconTooltip: '撥出通話',
    errorOutdialFailed:
      '撥出通話失敗。桌面無法連接通話，或通話沒有人接聽。',
    errorOutdialDisabled: '撥出通話已停用',
    errorDialPadValidationMessage: '錯誤格式',
    outdialReqInProgress: '撥出通話處理中',
    outdialAniPlaceholder: '選擇撥出 ANI',
    outdialAniLabel: '撥出 ANI',
    outdialAniPlaceHolder: '搜尋撥出 ANI',
    errorDcCallsLimitExceeded:
      '資料中心已達撥出通話上限。無法撥打更多撥出通話',
    errorOrgCallsLimitExceeded:
      '機構已達撥出通話上限。無法撥打更多撥出通話。',
    errorOutDialNoAnswerFromCustomer:
      '客戶沒有接聽您的電話。試著稍後再撥。',
    errorOutDialCustomerUnavailable:
      '客戶目前連絡不上。試著稍後再撥。',
    errorOutDialAgentEnds: '您已結束與客戶的通話。',
    errorOutDialCustomerBusy: '客戶現在忙碌中。試著稍後再撥。',
    searchError: '至少輸入三個字元，以搜尋聯絡人。',
    upArrowLabel: '展開',
    clear: '清除輸入',
    outdialDialogDescription: '您目前正處於附標籤的對話之位置。'
  },

  organization: {
    noMatchFound: '找不到相符項目',
    searchError: '至少輸入三個字元，以搜尋聯絡人。',
    authError: '並無可顯示的聯絡人。Microsoft 驗證失敗。'
  },

  interactionPopover: {
    of: '屬於',
    accept: '接受',
    acceptAriaLabel: '接受來自 {from} 的工作 (編號為：{taskNumber}，類型為：{taskType})',
    requests: '請求',
    back: '上一步',
    next: '下一步',
    acceptMultipleRequest: '接受 {requestCount} 個要求',
    paginationDetail: '{indexStart} - {indexEnd}，共 {totalPopoverpoolLength}',
    hidePopoverDetails: '隱藏彈出式視窗詳細資訊',
    showPopoverDetails: '顯示彈出式視窗詳細資訊',
    customerName: '客戶名稱',
    email: '電子郵件',
    queueName: '佇列名稱',
    failedToAccept: '無法接受。',
    unableToAccept: '無法接受聯絡人。',
    failedToEnd: '無法結束。',
    unableToEnd: '無法結束聯繫。 ',
    ringing: '響鈴',
    calling: '致電',
    phoneNumber: '電話號碼',
    dni: 'DNIS',
    ivrPathId: 'IVR 路徑 ID',
    pathId: '路徑 ID',
    rona: 'RONA',
    sourcePage: '資源頁面',
    sourceNumber: '資源編號',
    appUserId: '應用程式使用者 ID',
    acceptAll: '接受所有任務',
    agentDn: '代理 DN',
    agentName: '代理名稱',
    agentTeam: '代理小組',
    requestDetails: '請求詳細資訊',
    incomingCallFrom: '來電來自：',
    unableToAnswer: '無法接聽通話。請再試一次。',
    unableToDecline: '無法拒絕通話。請再試一次。'
  },

  multiLogin: {
    header: '多重登入警示',
    message:
      '您已在多個應用程式執行個體中登入桌面。按一下 [繼續] 以在此應用程式執行個體繼續使用桌面。否則，請關閉此視窗。',
    continue: '繼續'
  },

  errorCodes: {
    // Generic Reason Codes
    1002: '因發生組態問題，因此無法傳輸至進入點/佇列。',
    1010: "由於無法及時分配代理，因此無法進行諮詢。 ",
    1042: "找不到聯絡人",
    1043: '目的地無效。',
    1045: '未有分配互動給代理。',
    1046: '由於在系統找不到相符的代理頻道，因此無法進行代理咨詢。',
    1038: "找不到代理",
    1037: '由於發生內部錯誤，因此無法登入。',

    // Media Events
    138: '因不明原因而無法操作。',
    136: '找不到使用者',

    // AgentConsultFailed
    1050: '由於流程中組態或活動不受支援，因此無法進行諮詢。 ',
    1005: "由於代理未能及時接聽要求，因此無法進行諮詢。",
    1051: '因進入點或撥號無效，因此無法諮詢或傳送。',

    // AgentInviteFailed
    1053: '由於工作流程重新排序任務已擱置，因此無法顯示互動。',
    1054: '由於要求有媒體問題，因此無法撥出通話。 ',

    // AgentContactAssignFailed
    1011: '由於正在進行的互動缺少代理，因此無法接聽或接受通話。 ',

    // ContactCallbackFailed
    1034: '由於收到此要求的 ContactParkTimeout，因此無法回電聯絡人。',

    // ContactUpdateFailed
    1020: "由於其中一個值超過 256 的字元限制，因此無法更新變數。請減少字元，然後重試。",

    // AgentInviteFailed
    1031: '在要求回電之後，該代理已邀請客戶。',

    // AgentBlindTransferFailedEvent
    1044: '由於目的地的代理已分配到另一個互動，因此代理無法進行秘密轉接。',

    // AgentCtqCancelFailed
    1047: "找不到聯絡人。",

    // AgentCtqFailed
    1048: "未設定通話分佈群組。",
    1049: '已超出佇列中的最長等待時間。',
    // StationLoginFailed
    127: '代理 DN 註冊失敗，出現重複登入異常。'
  },

  stateSelector: {
    Available: '有空',
    errorstatechange: '狀態更改不成功。請再試一次。',
    errorStateChangeInPendingLogout: '由於登出擱置，因此無法變更值機員狀態。',
    label: '可用性狀態',
    agentStateSelector: '代理狀態選擇器',
    Engaged: '已在互動',
    engagedAvailableInfo:
      '您目前正在互動且為在線狀態。',
    engagedIdleInfo:
      '您目前正在互動且為閒置狀態',
    engagedInfo: '您目前正在互動。',
    engagedSupervisorStateChange: '已將狀態更改為',
    axAgentStateChanged: '您的狀態已更改為',
    axAgentSync: '因使用協作工具同步狀態。',
    engagedPresenceInfo:
      '您目前正在互動且您的狀態為',
    engagedPresenceSync: '因使用協作工具同步狀態。',
    clear: '清除輸入',
    searchState: '輸入',
    agentStatusLabel: '代理狀態',
    agentStateLabel: '代理最近 {selectedTimeValue} 處於{selectedState}狀態',
    agentStateLabelOnStateChange: '代理最後 0 秒處於 {selectedState} 狀態',
    agentStateChangeSuccessful:'已成功將狀態變更為 {selectedState}。',
    agentStateChangeFail:'無法將狀態變更為 {selectedState}。',
    searchError: '輸入至少三個字元，搜尋狀態。'
  },

  warningMessage: {
    header: '未儲存的變更',
    message:
      '此頁面上尚未儲存的變更。您確定要離開此頁面嗎？ ',
    cancelButton: '停留',
    saveButton: '離開'
  },

  notificationLables: {
    muteVolume: '靜音通知音量',
    unmuteVolume: '取消靜音通知音量',
    notificationVolume: '通知音量',
    playSound: '播放通知音效',
    enableSoundNotificationSettings: '啟用音效通知',
    enableSoundNotificationSettingsDescription:
      '提供來電請求的音效通知。您可在下方調節音量。',
    volumeTitle: '音量'
  },

  channelNameLabels: {
    sms: 'SMS',
    telephony: '通話',
    chat: '聊天',
    email: '電子郵件',
    facebook: 'Messenger',
    whatsapp: 'Whatsapp',
    appleBusinessChat: 'Apple Business Chat',
    googleBusiness: "Google 商業訊息"
  },
  orgDetailsLabels: {
    role: '角色',
    department: '部門',
    email: '電子郵件',
    businessPhone: '商務電話',
    workPhone: '作業',
  },
  addressListError: {
    title: '無法載入數據',
    errorId: '錯誤 ID：'
  },
  keypad: {
    keyPadSearch: '輸入號碼',
    dialPad: '撥號鍵盤'
  },
  collabTool: {
    userAuthenticated: '使用者驗證：',
    successful: '成功',
    failed: '失敗。',
    tryAgain: '再試一次',
    stateSync: '同步狀態',
    mercuryFailedInfo: ' 請聯絡管理員。',
    retrying: '重試中...',
    trackingIdLabel: '追蹤 ID： '
  },
  webex: {
    webex: 'Webex',
    info: '整合可讓您在桌面和 Webex 之間同步狀態。'
  },
  microsoft: {
    teams: 'Microsoft Teams',
    info: '您可以透過此整合程序向 Microsoft Teams 的使用者咨詢或轉接通話。',
    authenticationFailedInfo:
      '如驗證視窗已開啟，請在此處重試驗證。',
    ListItemContactDetails:
      '聯結人名稱為：{name}，其狀態為：{presence}，部門為：{department}，職稱為：{jobTitle}，而電話號碼為：{phoneno}'
  },
  emergencyServiceNotification: {
    emergencyServiceNotification: '緊急服務通知',
    readNotification: '我已閱讀通知。'
  },
  webexPresenceStatus: {
    active: '進行中',
    lastActiveFewMinutesAgo: '過去幾分鐘處於啟用狀態',
    lastActiveMinutesAgo: '在 {min} 分鐘前處於啟用狀態',
    lastActive1HourAgo: '最新活動 1 小時前',
    lastActiveHoursAgo: '在 {hour} 小時前處於啟用狀態',
    lastActiveYesterday: '在昨天處於啟用狀態',
    lastActiveOnDate: '在 {date} 處於啟用狀態',
    busy: '忙線',
    busyUntil: '忙線直到 {date}',
    dnd: '勿打擾',
    dndUntil: '{date} 前切勿打擾',
    quiet: '靜音',
    quietUntil: '靜音直到 {date}',
    ooo: '外出',
    outOfOfficeUntil: '外出直到 {date}',
    call: '通話中',
    meeting: '會議中',
    calendarItem: '行事曆會議中',
    presenting: '簡報中',
  },
  enterpriseSearch: {
    orgPlaceholder: '依姓名或設定檔詳細資料搜尋',
    webexPlaceholder: '按名稱或電子郵件搜尋',
    refreshTheList: '重新整理清單',
    refreshAddressBook: '重新整理通訊錄',
    microsoftAuthError: '並無可顯示的聯絡人。Microsoft 驗證失敗。'
  }
});


/***/ }),

/***/ "./src/react-wc-utilities/event-context/EventContext.tsx":
/*!***************************************************************!*\
  !*** ./src/react-wc-utilities/event-context/EventContext.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EventContext: () => (/* binding */ EventContext),
/* harmony export */   EventProvider: () => (/* binding */ EventProvider)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");

const EventContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(() => {
    /* Initially return nothing */
});
const EventProvider = EventContext.Provider;



/***/ }),

/***/ "./src/react-wc-utilities/index.ts":
/*!*****************************************!*\
  !*** ./src/react-wc-utilities/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EventContext: () => (/* reexport safe */ _event_context_EventContext__WEBPACK_IMPORTED_MODULE_0__.EventContext),
/* harmony export */   EventProvider: () => (/* reexport safe */ _event_context_EventContext__WEBPACK_IMPORTED_MODULE_0__.EventProvider),
/* harmony export */   Styled: () => (/* reexport safe */ _scoped_style_Styled__WEBPACK_IMPORTED_MODULE_3__.Styled),
/* harmony export */   createReactWebComponent: () => (/* reexport safe */ _react_wc_wrapper_LegacyComponentProxy__WEBPACK_IMPORTED_MODULE_1__.createReactWebComponent),
/* harmony export */   defineReactWebComponent: () => (/* reexport safe */ _react_wc_wrapper_ReactWebComponentFactory__WEBPACK_IMPORTED_MODULE_2__.defineReactWebComponent)
/* harmony export */ });
/* harmony import */ var _event_context_EventContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./event-context/EventContext */ "./src/react-wc-utilities/event-context/EventContext.tsx");
/* harmony import */ var _react_wc_wrapper_LegacyComponentProxy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./react-wc-wrapper/LegacyComponentProxy */ "./src/react-wc-utilities/react-wc-wrapper/LegacyComponentProxy.tsx");
/* harmony import */ var _react_wc_wrapper_ReactWebComponentFactory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./react-wc-wrapper/ReactWebComponentFactory */ "./src/react-wc-utilities/react-wc-wrapper/ReactWebComponentFactory.tsx");
/* harmony import */ var _scoped_style_Styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scoped-style/Styled */ "./src/react-wc-utilities/scoped-style/Styled.tsx");







/***/ }),

/***/ "./src/react-wc-utilities/react-wc-wrapper/LegacyComponentProxy.tsx":
/*!**************************************************************************!*\
  !*** ./src/react-wc-utilities/react-wc-wrapper/LegacyComponentProxy.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createReactWebComponent: () => (/* binding */ createReactWebComponent)
/* harmony export */ });
/* harmony import */ var _ReactWebComponentFactory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ReactWebComponentFactory */ "./src/react-wc-utilities/react-wc-wrapper/ReactWebComponentFactory.tsx");

function getLitType(value) {
    if (Array.isArray(value)) {
        return Array;
    }
    else if (typeof value === "boolean") {
        return Boolean;
    }
    else if (typeof value === "number") {
        return Number;
    }
    else if (value !== null && typeof value === "object") {
        return Object;
    }
    return String;
}
function mapReactPropsToLitProps(reactProps) {
    return Object.entries(reactProps).reduce((acc, [key, value]) => {
        acc[key] = { type: getLitType(value) };
        return acc;
    }, {});
}
//@deprecated use defineReactWebComponent instead
function createReactWebComponent(params) {
    let litProperties;
    if (params.properties) {
        litProperties = mapReactPropsToLitProps(params.properties);
    }
    (0,_ReactWebComponentFactory__WEBPACK_IMPORTED_MODULE_0__.createWebComponentClass)(params.configuration.tagname, params.component, litProperties !== null && litProperties !== void 0 ? litProperties : {}, params.properties);
}


/***/ }),

/***/ "./src/react-wc-utilities/react-wc-wrapper/ReactWebComponent.tsx":
/*!***********************************************************************!*\
  !*** ./src/react-wc-utilities/react-wc-wrapper/ReactWebComponent.tsx ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CustomAttributeConverter: () => (/* binding */ CustomAttributeConverter),
/* harmony export */   ReactWebComponent: () => (/* binding */ ReactWebComponent)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-dom */ "../../node_modules/react-dom/index.js");
/* harmony import */ var _event_context_EventContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../event-context/EventContext */ "./src/react-wc-utilities/event-context/EventContext.tsx");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "../../node_modules/lit-element/lit-element.js");





class ReactWebComponent extends lit_element__WEBPACK_IMPORTED_MODULE_4__.UpdatingElement {
    constructor(reactComponent, reactProps) {
        var _a;
        super();
        this.eventDispatcher = (event) => {
            this.dispatchEvent(event);
        };
        this.reactComponent = reactComponent;
        this.attachShadow({ mode: "open" });
        if (!reactComponent) {
            const error = document.createElement("div");
            error.innerText = "No React component provided";
            error.style.color = "red";
            error.style.fontWeight = "bold";
            (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.appendChild(error);
        }
        if (reactProps) {
            this.initializeReactProps(reactProps);
        }
    }
    initializeReactProps(reactProps) {
        for (const [key, value] of Object.entries(reactProps)) {
            Reflect.set(this, key, value);
        }
    }
    createReactProps() {
        const ctor = this.constructor;
        if (!ctor.properties) {
            return {};
        }
        return Object.fromEntries(Object.keys(ctor.properties).map((key) => [key, Reflect.get(this, key)]));
    }
    mountReactComponent() {
        if (!this.reactComponent || !this.shadowRoot) {
            return;
        }
        const reactElement = react__WEBPACK_IMPORTED_MODULE_1__.createElement(this.reactComponent, this.createReactProps());
        const eventProviderElement = (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_event_context_EventContext__WEBPACK_IMPORTED_MODULE_3__.EventProvider, Object.assign({ value: this.eventDispatcher }, { children: reactElement }));
        react_dom__WEBPACK_IMPORTED_MODULE_2__.render(eventProviderElement, this.shadowRoot);
    }
    updated(_changedProperties) {
        this.mountReactComponent();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.shadowRoot) {
            react_dom__WEBPACK_IMPORTED_MODULE_2__.unmountComponentAtNode(this.shadowRoot);
        }
    }
}
const CustomAttributeConverter = {
    toAttribute: lit_element__WEBPACK_IMPORTED_MODULE_4__.defaultConverter.toAttribute,
    fromAttribute(value, type) {
        switch (type) {
            case Boolean:
                // Handle boolean attributes from legacy Direflow components
                return value !== null && (value === "" || value.trim().toLowerCase() === "true");
            case Number:
                return value === null ? null : Number(value);
            case Object:
            case Array:
                return JSON.parse(value);
        }
        return value;
    }
};


/***/ }),

/***/ "./src/react-wc-utilities/react-wc-wrapper/ReactWebComponentFactory.tsx":
/*!******************************************************************************!*\
  !*** ./src/react-wc-utilities/react-wc-wrapper/ReactWebComponentFactory.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createWebComponentClass: () => (/* binding */ createWebComponentClass),
/* harmony export */   defineReactWebComponent: () => (/* binding */ defineReactWebComponent)
/* harmony export */ });
/* harmony import */ var _ReactWebComponent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ReactWebComponent */ "./src/react-wc-utilities/react-wc-wrapper/ReactWebComponent.tsx");

function createWebComponentClass(tagName, reactComponent, reactPropertyDeclarations, defaultReactProps) {
    class ReactWebComponentWithProps extends _ReactWebComponent__WEBPACK_IMPORTED_MODULE_0__.ReactWebComponent {
        constructor() {
            super(reactComponent, defaultReactProps);
        }
        static get properties() {
            return reactPropertyDeclarations;
        }
        static createProperty(name, options) {
            //CustomAttributeConverter is needed to handle boolean attributes from legacy Direflow components
            options = Object.assign(options, { converter: _ReactWebComponent__WEBPACK_IMPORTED_MODULE_0__.CustomAttributeConverter });
            super.createProperty(name, options);
        }
    }
    window.customElements.define(tagName, ReactWebComponentWithProps);
    return ReactWebComponentWithProps;
}
function defineReactWebComponent(tagName, reactComponent, reactPropertyDeclarations) {
    return createWebComponentClass(tagName, reactComponent, reactPropertyDeclarations !== null && reactPropertyDeclarations !== void 0 ? reactPropertyDeclarations : {});
}


/***/ }),

/***/ "./src/react-wc-utilities/scoped-style/Styled.tsx":
/*!********************************************************!*\
  !*** ./src/react-wc-utilities/scoped-style/Styled.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Styled: () => (/* binding */ Styled)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var _styleInjector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./styleInjector */ "./src/react-wc-utilities/scoped-style/styleInjector.tsx");


const Styled = (props) => {
    let styles;
    if (typeof props.styles === "string") {
        styles = props.styles.toString();
    }
    else {
        styles = props.styles.reduce((acc, current) => `${acc} ${current}`);
    }
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styleInjector__WEBPACK_IMPORTED_MODULE_1__["default"], Object.assign({ scoped: props.scoped }, { children: [styles, props.children] })));
};



/***/ }),

/***/ "./src/react-wc-utilities/scoped-style/styleInjector.tsx":
/*!***************************************************************!*\
  !*** ./src/react-wc-utilities/scoped-style/styleInjector.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var react_lib_adler32__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-lib-adler32 */ "../../node_modules/react-lib-adler32/adler32.js");
/* harmony import */ var react_lib_adler32__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lib_adler32__WEBPACK_IMPORTED_MODULE_2__);

/****************************************************************************
The MIT License (MIT)

Copyright (c) 2020 Silind Ltd

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*****************************************************************************/
/* eslint-disable sonarjs/slow-regex */


const isDevEnv = "development" !== "production";
class Style extends react__WEBPACK_IMPORTED_MODULE_1__.Component {
    constructor() {
        super(...arguments);
        this.scopeClassNameCache = {};
        this.scopedCSSTextCache = {};
        this.scoped = this.props.scoped !== undefined ? this.props.scoped : true;
        this.pepper = "";
        this.getStyleString = () => {
            if (this.props.children instanceof Array) {
                const styleString = this.props.children.filter((child) => !(0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child) && typeof child === "string");
                if (styleString.length > 1) {
                    throw new Error(`Multiple style objects as direct descendants of a
        Style component are not supported (${styleString.length} style objects detected):

        ${styleString[0]}
        `);
                }
                return styleString[0];
            }
            if (typeof this.props.children === "string" && !(0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(this.props.children)) {
                return this.props.children;
            }
            return null;
        };
        this.getRootElement = () => {
            if (this.props.children instanceof Array) {
                const rootElement = this.props.children.filter((child) => (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child));
                if (isDevEnv) {
                    if (rootElement.length > 1) {
                        throw new Error(`Adjacent JSX elements must be wrapped in an enclosing tag 
          (${rootElement.length} root elements detected)`);
                    }
                    if (typeof rootElement[0] !== "undefined" && this.isVoidElement(rootElement[0].type)) {
                        throw new Error(`Self-closing void elements like ${rootElement.type} must be 
          wrapped in an enclosing tag. Reactive Style must be able to nest a style element inside of the 
          root element and void element content models never 
          allow it to have contents under any circumstances.`);
                    }
                }
                return rootElement[0];
            }
            if ((0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(this.props.children)) {
                return this.props.children;
            }
            return null;
        };
        this.getRootSelectors = (rootElement) => {
            const rootSelectors = [];
            if (rootElement.props.id) {
                rootSelectors.push(`#${rootElement.props.id}`);
            }
            if (rootElement.props.className) {
                rootElement.props.className
                    .trim()
                    .split(/\s+/g)
                    .forEach((className) => rootSelectors.push(className));
            }
            if (!rootSelectors.length && typeof rootElement.type === "string") {
                rootSelectors.push(rootElement.type);
            }
            return rootSelectors;
        };
        this.processCSSText = (styleString, scopeClassName, rootSelectors) => {
            return styleString
                .replace(/\s*\/\/(?![^(]*\)).*|\s*\/\*.*\*\//g, "")
                .replace(/\s\s+/g, " ")
                .split("}")
                .map((fragment) => {
                const isDeclarationBodyPattern = /.*:.*;/g;
                const isLastItemDeclarationBodyPattern = /.*:.*(;|$|\s+)/g;
                // eslint-disable-next-line sonarjs/anchor-precedence -- legacy direflow code
                const isAtRulePattern = /\s*@/g;
                // eslint-disable-next-line sonarjs/anchor-precedence, sonarjs/concise-regex -- legacy direflow code
                const isKeyframeOffsetPattern = /\s*(([0-9][0-9]?|100)\s*%)|\s*(to|from)\s*$/g;
                return fragment
                    .split("{")
                    .map((statement, i, arr) => {
                    if (!statement.trim().length) {
                        return "";
                    }
                    const isDeclarationBodyItemWithOptionalSemicolon = arr.length - 1 === i && statement.match(isLastItemDeclarationBodyPattern);
                    if (statement.match(isDeclarationBodyPattern) || isDeclarationBodyItemWithOptionalSemicolon) {
                        return this.escapeTextContentForBrowser(statement);
                    }
                    const selector = statement;
                    if (scopeClassName && !/:target/gi.test(selector)) {
                        if (!selector.match(isAtRulePattern) && !selector.match(isKeyframeOffsetPattern)) {
                            return this.scopeSelector(scopeClassName, selector, rootSelectors);
                        }
                        return selector;
                    }
                    return selector;
                })
                    .join("{\n");
            })
                .join("}\n");
        };
        this.escaper = (match) => {
            const ESCAPE_LOOKUP = {
                ">": "&gt;",
                "<": "&lt;"
            };
            return ESCAPE_LOOKUP[match];
        };
        this.escapeTextContentForBrowser = (text) => {
            const ESCAPE_REGEX = /[><]/g;
            return `${text}`.replace(ESCAPE_REGEX, this.escaper);
        };
        this.scopeSelector = (scopeClassName, selector, rootSelectors) => {
            const scopedSelector = [];
            const groupOfSelectorsPattern = /,(?![^(|[]*\)|\])/g;
            const selectors = selector.split(groupOfSelectorsPattern);
            selectors.forEach((selectorElement) => {
                let containsSelector;
                let unionSelector;
                if ((rootSelectors === null || rootSelectors === void 0 ? void 0 : rootSelectors.length) && rootSelectors.some((rootSelector) => selectorElement.match(rootSelector))) {
                    unionSelector = selectorElement;
                    const escapedRootSelectors = rootSelectors === null || rootSelectors === void 0 ? void 0 : rootSelectors.map((rootSelector) => rootSelector.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"));
                    unionSelector = unionSelector.replace(new RegExp(`(${escapedRootSelectors === null || escapedRootSelectors === void 0 ? void 0 : escapedRootSelectors.join("|")})`), `$1${scopeClassName}`);
                    containsSelector = this.scoped ? `${scopeClassName} ${selectorElement}` : selectorElement;
                    scopedSelector.push(unionSelector, containsSelector);
                }
                else {
                    containsSelector = this.scoped ? `${scopeClassName} ${selectorElement}` : selectorElement;
                    scopedSelector.push(containsSelector);
                }
            });
            if (!this.scoped && scopedSelector.length > 1) {
                return scopedSelector[1];
            }
            return scopedSelector.join(", ");
        };
        this.getScopeClassName = (styleString, rootElement) => {
            let hash = styleString;
            if (rootElement) {
                this.pepper = "";
                this.traverseObjectToGeneratePepper(rootElement);
                hash += this.pepper;
            }
            return (isDevEnv ? "scope-" : "s") + react_lib_adler32__WEBPACK_IMPORTED_MODULE_2___default()(hash);
        };
        this.traverseObjectToGeneratePepper = (obj, depth = 0) => {
            if (depth > 32 || this.pepper.length > 10000) {
                return;
            }
            Object.keys(obj).forEach((prop) => {
                const isPropReactInternal = /^[_$]|type|ref|^value$/.test(prop);
                if (!!obj[prop] && typeof obj[prop] === "object" && !isPropReactInternal) {
                    this.traverseObjectToGeneratePepper(obj[prop], depth + 1);
                }
                else if (!!obj[prop] && !isPropReactInternal && typeof obj[prop] !== "function") {
                    this.pepper += obj[prop];
                }
            });
        };
        this.isVoidElement = (type) => [
            "area",
            "base",
            "br",
            "col",
            "command",
            "embed",
            "hr",
            "img",
            "input",
            "keygen",
            "link",
            "meta",
            "param",
            "source",
            "track",
            "wbr"
        ].some((voidType) => type === voidType);
        this.createStyleElement = (cssText, scopeClassName) => {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", { id: "react_scoped_styles", type: "text/css", dangerouslySetInnerHTML: { __html: cssText || "" } }, scopeClassName));
        };
        this.getNewChildrenForCloneElement = (cssText, rootElement, scopeClassName) => {
            return [this.createStyleElement(cssText, scopeClassName)].concat(rootElement.props.children);
        };
    }
    render() {
        const styleString = this.getStyleString();
        const rootElement = this.getRootElement();
        if (!styleString && rootElement) {
            return rootElement.props.children;
        }
        if (styleString && !rootElement) {
            return this.createStyleElement(this.processCSSText(styleString), this.getScopeClassName(styleString, rootElement));
        }
        const rootElementId = rootElement.props.id ? rootElement.props.id : "";
        const rootElementClassNames = rootElement.props.className ? `${rootElement.props.className} ` : "";
        let scopeClassName;
        let scopedCSSText;
        const scopeClassNameAddress = rootElementClassNames + rootElementId + styleString;
        if (this.scopeClassNameCache[scopeClassNameAddress]) {
            scopeClassName = this.scopeClassNameCache[scopeClassNameAddress];
            scopedCSSText = this.scopedCSSTextCache[scopeClassName];
        }
        else {
            scopeClassName = this.getScopeClassName(styleString, rootElement);
            scopedCSSText = this.processCSSText(styleString, `.${scopeClassName}`, this.getRootSelectors(rootElement));
            this.scopeClassNameCache[scopeClassNameAddress] = scopeClassName;
            this.scopedCSSTextCache[scopeClassName] = scopedCSSText;
        }
        const className = this.scoped ? `${rootElementClassNames}${scopeClassName}` : rootElementClassNames;
        return (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(rootElement, Object.assign(Object.assign({}, rootElement.props), { className: className.trim() }), this.getNewChildrenForCloneElement(scopedCSSText, rootElement, scopeClassName));
    }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Style);


/***/ }),

/***/ "./src/sdk.ts":
/*!********************!*\
  !*** ./src/sdk.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createLogger: () => (/* binding */ createLogger),
/* harmony export */   logger: () => (/* binding */ logger),
/* harmony export */   loggerForImi: () => (/* binding */ loggerForImi),
/* harmony export */   loggerPool: () => (/* binding */ loggerPool)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);

const objKeysToBeMasked = {
    ani: true,
    dn: true,
    agent_ani: true,
    dnis: true,
    email: true,
    callAssociatedData: true,
    title: true,
    text: true,
    agentName: true,
    agentMailId: true,
    userName: true,
    emails: true,
    sipAddresses: true
};
const logger = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createLogger)("agentx-mfe-react-based", objKeysToBeMasked);
const loggerForImi = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createLogger)("imi-engage", objKeysToBeMasked);
const loggerPool = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Logger.POOL;
const createLogger = (prefix) => {
    class LoggerWrapper {
        constructor(pfx) {
            this.prefix = pfx;
        }
        error(...msg) {
            logger.error(this.prefix, ...msg);
        }
        info(...msg) {
            logger.info(this.prefix, ...msg);
        }
        warn(...msg) {
            logger.warn(this.prefix, ...msg);
        }
    }
    return new LoggerWrapper(prefix);
};


/***/ }),

/***/ "@agentx/agentx-mfe-wc-based":
/*!**********************************************!*\
  !*** external "@agentx/agentx-mfe-wc-based" ***!
  \**********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@agentx/agentx-mfe-wc-based");

/***/ }),

/***/ "@agentx/agentx-services":
/*!******************************************!*\
  !*** external "@agentx/agentx-services" ***!
  \******************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@agentx/agentx-services");

/***/ }),

/***/ "@momentum-ui/web-components":
/*!**********************************************!*\
  !*** external "@momentum-ui/web-components" ***!
  \**********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@momentum-ui/web-components");

/***/ }),

/***/ "@uuip/unified-ui-platform-sdk":
/*!************************************************!*\
  !*** external "@uuip/unified-ui-platform-sdk" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@uuip/unified-ui-platform-sdk");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!********************************************************************!*\
  !*** ./src/direflow-components/AddressBookIncreasedLimit/index.ts ***!
  \********************************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _AddressBookIncreasedLimit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AddressBookIncreasedLimit */ "./src/direflow-components/AddressBookIncreasedLimit/AddressBookIncreasedLimit.tsx");


(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _AddressBookIncreasedLimit__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-address-book-increased-limit",
        useShadow: true
    },
    properties: {}
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!*******************************************************!*\
  !*** ./src/direflow-components/AgentProfile/index.ts ***!
  \*******************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _DefaultAgentProfileProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DefaultAgentProfileProps */ "./src/direflow-components/AgentProfile/DefaultAgentProfileProps.ts");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components */ "./src/direflow-components/AgentProfile/components/index.tsx");



(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _components__WEBPACK_IMPORTED_MODULE_2__["default"],
    configuration: {
        tagname: "agentx-react-agent-profile",
        useShadow: true
    },
    properties: _DefaultAgentProfileProps__WEBPACK_IMPORTED_MODULE_1__["default"]
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!*************************************************************!*\
  !*** ./src/direflow-components/AgentStateSelector/index.ts ***!
  \*************************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _AgentStateSelector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AgentStateSelector */ "./src/direflow-components/AgentStateSelector/AgentStateSelector.tsx");
/* harmony import */ var _DefaultStateSelectorProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DefaultStateSelectorProps */ "./src/direflow-components/AgentStateSelector/DefaultStateSelectorProps.ts");
// Add these polyfills for ie 11



(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _AgentStateSelector__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-state-selector",
        useShadow: true
    },
    properties: _DefaultStateSelectorProps__WEBPACK_IMPORTED_MODULE_2__["default"]
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!***************************************************!*\
  !*** ./src/direflow-components/AppTitle/index.ts ***!
  \***************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _AppTitle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AppTitle */ "./src/direflow-components/AppTitle/AppTitle.tsx");
/* harmony import */ var _mocks_DefaultApplicationTitleProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./__mocks__/DefaultApplicationTitleProps */ "./src/direflow-components/AppTitle/__mocks__/DefaultApplicationTitleProps.js");



(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _AppTitle__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-app-title",
        useShadow: true
    },
    properties: _mocks_DefaultApplicationTitleProps__WEBPACK_IMPORTED_MODULE_2__["default"]
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**********************************************************!*\
  !*** ./src/direflow-components/ContactHistory/index.tsx ***!
  \**********************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components */ "./src/direflow-components/ContactHistory/components/index.tsx");


(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _components__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-contact-history",
        useShadow: true
    },
    properties: {
        details: {
            agentId: "",
            interactionId: "",
            ani: "",
            dnis: "",
            contactDirection: "",
            tahoeEnabled: false
        },
        orgId: "",
        mockedContacts: {},
        disableTranscripts: false,
        isDarkMode: false,
        isProgressiveCampaign1NEnabled: false
    }
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!*************************************************************************!*\
  !*** ./src/direflow-components/ContactHistory/HandledByAgent/index.tsx ***!
  \*************************************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components */ "./src/direflow-components/ContactHistory/HandledByAgent/components/index.tsx");


(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _components__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-contact-handled-by-agent",
        useShadow: true
    },
    properties: {
        lastcompletedtask: "",
        chatcount: 0,
        emailcount: 0,
        voicecount: 0,
        socialcount: 0,
        agentId: "",
        tahoeEnabled: false,
        allowOutdial: false,
        isActiveCall: false,
        webRtcStatus: "webRtcRegistering",
        isWebRTCEnabled: false,
        isMaskSensitiveDataEnabled: false,
        deviceType: "AGENT_DN",
        isDarkMode: false,
        orgId: ""
    }
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************************************!*\
  !*** ./src/direflow-components/Dialer/index.tsx ***!
  \**************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _Dialpad__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Dialpad */ "./src/direflow-components/Dialer/Dialpad.tsx");


(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _Dialpad__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-dialer",
        useShadow: true
    },
    properties: {
        dialNum: "",
        showCharButton: false,
        cursorPosition: 0,
        ariaLabel: ""
    }
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!*********************************************************!*\
  !*** ./src/direflow-components/EmailComposer/index.tsx ***!
  \*********************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components */ "./src/direflow-components/EmailComposer/components/index.tsx");
/* harmony import */ var _utils_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils/Utils */ "./src/direflow-components/EmailComposer/utils/Utils.ts");



(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _components__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-email-composer",
        useShadow: true
    },
    properties: {
        taskid: "",
        orgid: "",
        agentname: "",
        emailprops: {
            configs: {
                isCareAttachmentEnabled: true,
                isPCIComplianceEnabled: true
            },
            pcisettings: {
                action: "drop",
                isAttachmentEnabled: false
            },
            template: _utils_Utils__WEBPACK_IMPORTED_MODULE_2__.initialTemplateState,
            pciAllowedAttachmentTypes: ""
        }
    }
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!*********************************************************************!*\
  !*** ./src/direflow-components/InteractionControlWrapper/index.tsx ***!
  \*********************************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components */ "./src/direflow-components/InteractionControlWrapper/components/index.tsx");


(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _components__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-interaction-control-wrapper",
        useShadow: true
    },
    properties: {
        interaction: {},
        buttons: [],
        agentconfig: {},
        cadStatus: {},
        wrapUpData: {},
        agentWrapUpCodeProps: {
            agentWrapUpCodes: {
                data: [],
                meta: {}
            },
            agentDefaultWrapupCode: {}
        },
        callpersistence: {},
        isVoiceInteraction: true,
        isVoiceIntPaneUpdatedByUser: null,
        currentRoute: null,
        epDnMapping: {},
        addressBook: {},
        isDesktopConsultToEntryPointDnEnabled: false,
        isDarkMode: false,
        isProgressiveCampaignEnabled: false,
        isProgressiveCampaign1NEnabled: false,
        isAddressBookInfiniteScrollEnabled: false,
        isDesktopConferenceRecordingEnabled: false,
        isCallMuted: false,
        isDesktopAuxCodesInfiniteScrollEnabled: false
    }
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!*********************************************************************!*\
  !*** ./src/direflow-components/InteractionPopoverManager/index.tsx ***!
  \*********************************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components */ "./src/direflow-components/InteractionPopoverManager/components/index.tsx");


(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _components__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-interaction-popover",
        useShadow: true
    },
    properties: {
        agentconfig: { isendcallenabled: true, isProgressive11SpecialModeEnabled: false },
        taskMap: {},
        agentId: "",
        popoverConfig: {}
    }
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!******************************************************!*\
  !*** ./src/direflow-components/MultiLogin/index.tsx ***!
  \******************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./component */ "./src/direflow-components/MultiLogin/component/index.tsx");


(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _component__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-multi-login-modal",
        useShadow: true
    }
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!***************************************************!*\
  !*** ./src/direflow-components/Outdial/index.tsx ***!
  \***************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components */ "./src/direflow-components/Outdial/components/index.tsx");


(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _components__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-out-dial",
        useShadow: true
    },
    properties: {
        outDialAni: {
            initialFetchCompleted: false,
            data: []
        },
        addressBook: {
            initialFetchCompleted: false,
            data: [],
            errorObj: {}
        },
        shouldDisableOutdialForExclusive: false,
        isOutDialEnabledTenant: false,
        isOutDialEnabledAgent: false,
        phoneValidateRegex: "",
        agentDn: "",
        outdialEntryPointId: "",
        isAdhocDialingEnabled: false,
        isCallInProgress: false,
        showPopover: true,
        orgId: "",
        selectedANI: { id: "", name: "" },
        isDarkModeEnable: false,
        webRtcStatus: "webRtcRegistering",
        isWebRTCEnabled: false,
        deviceType: "AGENT_DN",
        isAddressBookInfiniteScrollEnabled: false,
        isOutdialOrgSearchEnabled: false,
        displayMicrosoftUserDetails: false,
        displayWebexUserDetails: false,
        microsoftAuthenticated: false,
        isOutdialAniInfiniteScrollEnabled: false
    }
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!***************************************************!*\
  !*** ./src/direflow-components/Utility/index.tsx ***!
  \***************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components */ "./src/direflow-components/Utility/components/index.tsx");


(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _components__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-utility",
        useShadow: true
    },
    properties: {
        agentConfigs: {
            areDigitalChannelsEnabled: false,
            deviceType: ""
        },
        configs: {
            interactionId: "",
            agentId: "",
            destAgentId: "",
            initiateConferenceChat: false
        },
        imiconfigs: {},
        accessToken: ""
    }
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!*************************************************!*\
  !*** ./src/direflow-components/WrapUp/index.ts ***!
  \*************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @react-wc-utilities */ "./src/react-wc-utilities/index.ts");
/* harmony import */ var _components_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/index */ "./src/direflow-components/WrapUp/components/index.tsx");
/* harmony import */ var _DefaultWrapUpProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DefaultWrapUpProperties */ "./src/direflow-components/WrapUp/DefaultWrapUpProperties.ts");



(0,_react_wc_utilities__WEBPACK_IMPORTED_MODULE_0__.createReactWebComponent)({
    component: _components_index__WEBPACK_IMPORTED_MODULE_1__["default"],
    configuration: {
        tagname: "agentx-react-app-wrapup",
        useShadow: true
    },
    properties: _DefaultWrapUpProperties__WEBPACK_IMPORTED_MODULE_2__["default"]
});

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=agentx-mfe-react-based.js.map